(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root.BeachBall = factory(typeof BeachBall === 'undefined' ? {} : BeachBall);
}(this, function (_) {
  'use strict';
  _no_name_provided__3.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__3.prototype.constructor = _no_name_provided__3;
  SequenceBuilderIterator.prototype = Object.create(SequenceScope.prototype);
  SequenceBuilderIterator.prototype.constructor = SequenceBuilderIterator;
  CoroutineSingletons.prototype = Object.create(Enum.prototype);
  CoroutineSingletons.prototype.constructor = CoroutineSingletons;
  Default.prototype = Object.create(Random.prototype);
  Default.prototype.constructor = Default;
  XorWowRandom.prototype = Object.create(Random.prototype);
  XorWowRandom.prototype.constructor = XorWowRandom;
  LazyThreadSafetyMode.prototype = Object.create(Enum.prototype);
  LazyThreadSafetyMode.prototype.constructor = LazyThreadSafetyMode;
  Error_0.prototype = Object.create(Error.prototype);
  Error_0.prototype.constructor = Error_0;
  NotImplementedError.prototype = Object.create(Error_0.prototype);
  NotImplementedError.prototype.constructor = NotImplementedError;
  Iterator.prototype = Object.create(UByteIterator.prototype);
  Iterator.prototype.constructor = Iterator;
  Iterator_0.prototype = Object.create(UIntIterator.prototype);
  Iterator_0.prototype.constructor = Iterator_0;
  Iterator_1.prototype = Object.create(ULongIterator.prototype);
  Iterator_1.prototype.constructor = Iterator_1;
  Iterator_2.prototype = Object.create(UShortIterator.prototype);
  Iterator_2.prototype.constructor = Iterator_2;
  IntProgressionIterator.prototype = Object.create(IntIterator.prototype);
  IntProgressionIterator.prototype.constructor = IntProgressionIterator;
  LongProgressionIterator.prototype = Object.create(LongIterator.prototype);
  LongProgressionIterator.prototype.constructor = LongProgressionIterator;
  CharProgressionIterator.prototype = Object.create(CharIterator.prototype);
  CharProgressionIterator.prototype.constructor = CharProgressionIterator;
  IntRange.prototype = Object.create(IntProgression.prototype);
  IntRange.prototype.constructor = IntRange;
  LongRange.prototype = Object.create(LongProgression.prototype);
  LongRange.prototype.constructor = LongRange;
  CharRange.prototype = Object.create(CharProgression.prototype);
  CharRange.prototype.constructor = CharRange;
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  ListIteratorImpl.prototype = Object.create(IteratorImpl.prototype);
  ListIteratorImpl.prototype.constructor = ListIteratorImpl;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  AbstractMutableSet.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableSet.prototype.constructor = AbstractMutableSet;
  AbstractEntrySet.prototype = Object.create(AbstractMutableSet.prototype);
  AbstractEntrySet.prototype.constructor = AbstractEntrySet;
  _no_name_provided__16.prototype = Object.create(AbstractMutableSet.prototype);
  _no_name_provided__16.prototype.constructor = _no_name_provided__16;
  _no_name_provided__17.prototype = Object.create(AbstractMutableCollection.prototype);
  _no_name_provided__17.prototype.constructor = _no_name_provided__17;
  AbstractMutableMap.prototype = Object.create(AbstractMap.prototype);
  AbstractMutableMap.prototype.constructor = AbstractMutableMap;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  EntrySet.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet.prototype.constructor = EntrySet;
  HashMap.prototype = Object.create(AbstractMutableMap.prototype);
  HashMap.prototype.constructor = HashMap;
  HashSet.prototype = Object.create(AbstractMutableSet.prototype);
  HashSet.prototype.constructor = HashSet;
  ChainEntry.prototype = Object.create(SimpleEntry.prototype);
  ChainEntry.prototype.constructor = ChainEntry;
  EntrySet_0.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet_0.prototype.constructor = EntrySet_0;
  LinkedHashMap.prototype = Object.create(HashMap.prototype);
  LinkedHashMap.prototype.constructor = LinkedHashMap;
  LinkedHashSet.prototype = Object.create(HashSet.prototype);
  LinkedHashSet.prototype.constructor = LinkedHashSet;
  NodeJsOutput_0.prototype = Object.create(BaseOutput.prototype);
  NodeJsOutput_0.prototype.constructor = NodeJsOutput_0;
  BufferedOutput_0.prototype = Object.create(BaseOutput.prototype);
  BufferedOutput_0.prototype.constructor = BufferedOutput_0;
  BufferedOutputToConsoleLog_0.prototype = Object.create(BufferedOutput_0.prototype);
  BufferedOutputToConsoleLog_0.prototype.constructor = BufferedOutputToConsoleLog_0;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  IllegalStateException.prototype = Object.create(RuntimeException.prototype);
  IllegalStateException.prototype.constructor = IllegalStateException;
  CancellationException.prototype = Object.create(IllegalStateException.prototype);
  CancellationException.prototype.constructor = CancellationException;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  RegexOption.prototype = Object.create(Enum.prototype);
  RegexOption.prototype.constructor = RegexOption;
  _no_name_provided__46.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__46.prototype.constructor = _no_name_provided__46;
  _no_name_provided__49.prototype = Object.create(IntIterator.prototype);
  _no_name_provided__49.prototype.constructor = _no_name_provided__49;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  _no_name_provided__1_3.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__1_3.prototype.constructor = _no_name_provided__1_3;
  _no_name_provided__1_4.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__1_4.prototype.constructor = _no_name_provided__1_4;
  IllegalArgumentException.prototype = Object.create(RuntimeException.prototype);
  IllegalArgumentException.prototype.constructor = IllegalArgumentException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  NumberFormatException.prototype = Object.create(IllegalArgumentException.prototype);
  NumberFormatException.prototype.constructor = NumberFormatException;
  ArithmeticException.prototype = Object.create(RuntimeException.prototype);
  ArithmeticException.prototype.constructor = ArithmeticException;
  AssertionError.prototype = Object.create(Error_0.prototype);
  AssertionError.prototype.constructor = AssertionError;
  NullPointerException.prototype = Object.create(RuntimeException.prototype);
  NullPointerException.prototype.constructor = NullPointerException;
  NoWhenBranchMatchedException.prototype = Object.create(RuntimeException.prototype);
  NoWhenBranchMatchedException.prototype.constructor = NoWhenBranchMatchedException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  UninitializedPropertyAccessException.prototype = Object.create(RuntimeException.prototype);
  UninitializedPropertyAccessException.prototype.constructor = UninitializedPropertyAccessException;
  RingBuffer.prototype = Object.create(ByteRingBuffer.prototype);
  RingBuffer.prototype.constructor = RingBuffer;
  FastArrayList.prototype = Object.create(AbstractMutableList.prototype);
  FastArrayList.prototype.constructor = FastArrayList;
  Type.prototype = Object.create(Enum.prototype);
  Type.prototype.constructor = Type;
  MajorOrder.prototype = Object.create(Enum.prototype);
  MajorOrder.prototype.constructor = MajorOrder;
  Empty.prototype = Object.create(Shape2d.prototype);
  Empty.prototype.constructor = Empty;
  BaseEllipse.prototype = Object.create(Shape2d.prototype);
  BaseEllipse.prototype.constructor = BaseEllipse;
  Ellipse.prototype = Object.create(BaseEllipse.prototype);
  Ellipse.prototype.constructor = Ellipse;
  Circle.prototype = Object.create(BaseEllipse.prototype);
  Circle.prototype.constructor = Circle;
  Rectangle_0.prototype = Object.create(Shape2d.prototype);
  Rectangle_0.prototype.constructor = Rectangle_0;
  Path.prototype = Object.create(Shape2d.prototype);
  Path.prototype.constructor = Path;
  Polygon.prototype = Object.create(Shape2d.prototype);
  Polygon.prototype.constructor = Polygon;
  Polyline.prototype = Object.create(Shape2d.prototype);
  Polyline.prototype.constructor = Polyline;
  Complex.prototype = Object.create(Shape2d.prototype);
  Complex.prototype.constructor = Complex;
  LineCap.prototype = Object.create(Enum.prototype);
  LineCap.prototype.constructor = LineCap;
  LineJoin.prototype = Object.create(Enum.prototype);
  LineJoin.prototype.constructor = LineJoin;
  IntArrayListSort.prototype = Object.create(SortOps.prototype);
  IntArrayListSort.prototype.constructor = IntArrayListSort;
  PolygonScanline.prototype = Object.create(RastScale.prototype);
  PolygonScanline.prototype.constructor = PolygonScanline;
  EdgePoint.prototype = Object.create(Enum.prototype);
  EdgePoint.prototype.constructor = EdgePoint;
  Winding.prototype = Object.create(Enum.prototype);
  Winding.prototype.constructor = Winding;
  Easings.prototype = Object.create(Enum.prototype);
  Easings.prototype.constructor = Easings;
  SMOOTH.prototype = Object.create(Easings.prototype);
  SMOOTH.prototype.constructor = SMOOTH;
  EASE_IN_ELASTIC.prototype = Object.create(Easings.prototype);
  EASE_IN_ELASTIC.prototype.constructor = EASE_IN_ELASTIC;
  EASE_OUT_ELASTIC.prototype = Object.create(Easings.prototype);
  EASE_OUT_ELASTIC.prototype.constructor = EASE_OUT_ELASTIC;
  EASE_OUT_BOUNCE.prototype = Object.create(Easings.prototype);
  EASE_OUT_BOUNCE.prototype.constructor = EASE_OUT_BOUNCE;
  LINEAR.prototype = Object.create(Easings.prototype);
  LINEAR.prototype.constructor = LINEAR;
  EASE_IN.prototype = Object.create(Easings.prototype);
  EASE_IN.prototype.constructor = EASE_IN;
  EASE_OUT.prototype = Object.create(Easings.prototype);
  EASE_OUT.prototype.constructor = EASE_OUT;
  EASE_IN_OUT.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT.prototype.constructor = EASE_IN_OUT;
  EASE_OUT_IN.prototype = Object.create(Easings.prototype);
  EASE_OUT_IN.prototype.constructor = EASE_OUT_IN;
  EASE_IN_BACK.prototype = Object.create(Easings.prototype);
  EASE_IN_BACK.prototype.constructor = EASE_IN_BACK;
  EASE_OUT_BACK.prototype = Object.create(Easings.prototype);
  EASE_OUT_BACK.prototype.constructor = EASE_OUT_BACK;
  EASE_IN_OUT_BACK.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT_BACK.prototype.constructor = EASE_IN_OUT_BACK;
  EASE_OUT_IN_BACK.prototype = Object.create(Easings.prototype);
  EASE_OUT_IN_BACK.prototype.constructor = EASE_OUT_IN_BACK;
  EASE_IN_OUT_ELASTIC.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT_ELASTIC.prototype.constructor = EASE_IN_OUT_ELASTIC;
  EASE_OUT_IN_ELASTIC.prototype = Object.create(Easings.prototype);
  EASE_OUT_IN_ELASTIC.prototype.constructor = EASE_OUT_IN_ELASTIC;
  EASE_IN_BOUNCE.prototype = Object.create(Easings.prototype);
  EASE_IN_BOUNCE.prototype.constructor = EASE_IN_BOUNCE;
  EASE_IN_OUT_BOUNCE.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT_BOUNCE.prototype.constructor = EASE_IN_OUT_BOUNCE;
  EASE_OUT_IN_BOUNCE.prototype = Object.create(Easings.prototype);
  EASE_OUT_IN_BOUNCE.prototype.constructor = EASE_OUT_IN_BOUNCE;
  EASE_IN_QUAD.prototype = Object.create(Easings.prototype);
  EASE_IN_QUAD.prototype.constructor = EASE_IN_QUAD;
  EASE_OUT_QUAD.prototype = Object.create(Easings.prototype);
  EASE_OUT_QUAD.prototype.constructor = EASE_OUT_QUAD;
  EASE_IN_OUT_QUAD.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT_QUAD.prototype.constructor = EASE_IN_OUT_QUAD;
  EASE_SINE.prototype = Object.create(Easings.prototype);
  EASE_SINE.prototype.constructor = EASE_SINE;
  EASE_CLAMP_START.prototype = Object.create(Easings.prototype);
  EASE_CLAMP_START.prototype.constructor = EASE_CLAMP_START;
  EASE_CLAMP_END.prototype = Object.create(Easings.prototype);
  EASE_CLAMP_END.prototype.constructor = EASE_CLAMP_END;
  EASE_CLAMP_MIDDLE.prototype = Object.create(Easings.prototype);
  EASE_CLAMP_MIDDLE.prototype.constructor = EASE_CLAMP_MIDDLE;
  Type_0.prototype = Object.create(Enum.prototype);
  Type_0.prototype.constructor = Type_0;
  Type_1.prototype = Object.create(Enum.prototype);
  Type_1.prototype.constructor = Type_1;
  ManifoldType.prototype = Object.create(Enum.prototype);
  ManifoldType.prototype.constructor = ManifoldType;
  TOIOutputState.prototype = Object.create(Enum.prototype);
  TOIOutputState.prototype.constructor = TOIOutputState;
  Type_2.prototype = Object.create(Enum.prototype);
  Type_2.prototype.constructor = Type_2;
  ChainShape.prototype = Object.create(Shape.prototype);
  ChainShape.prototype.constructor = ChainShape;
  CircleShape.prototype = Object.create(Shape.prototype);
  CircleShape.prototype.constructor = CircleShape;
  EdgeShape.prototype = Object.create(Shape.prototype);
  EdgeShape.prototype.constructor = EdgeShape;
  PolygonShape.prototype = Object.create(Shape.prototype);
  PolygonShape.prototype.constructor = PolygonShape;
  ShapeType.prototype = Object.create(Enum.prototype);
  ShapeType.prototype.constructor = ShapeType;
  BodyType.prototype = Object.create(Enum.prototype);
  BodyType.prototype.constructor = BodyType;
  ChainAndCircleContact.prototype = Object.create(Contact.prototype);
  ChainAndCircleContact.prototype.constructor = ChainAndCircleContact;
  ChainAndPolygonContact.prototype = Object.create(Contact.prototype);
  ChainAndPolygonContact.prototype.constructor = ChainAndPolygonContact;
  CircleContact.prototype = Object.create(Contact.prototype);
  CircleContact.prototype.constructor = CircleContact;
  EdgeAndCircleContact.prototype = Object.create(Contact.prototype);
  EdgeAndCircleContact.prototype.constructor = EdgeAndCircleContact;
  EdgeAndPolygonContact.prototype = Object.create(Contact.prototype);
  EdgeAndPolygonContact.prototype.constructor = EdgeAndPolygonContact;
  PolygonAndCircleContact.prototype = Object.create(Contact.prototype);
  PolygonAndCircleContact.prototype.constructor = PolygonAndCircleContact;
  PolygonContact.prototype = Object.create(Contact.prototype);
  PolygonContact.prototype.constructor = PolygonContact;
  LambdaOrderedStack.prototype = Object.create(OrderedStack.prototype);
  LambdaOrderedStack.prototype.constructor = LambdaOrderedStack;
  ContactMutableStack.prototype = Object.create(MutableStack.prototype);
  ContactMutableStack.prototype.constructor = ContactMutableStack;
  DatePart.prototype = Object.create(Enum.prototype);
  DatePart.prototype.constructor = DatePart;
  DayOfWeek.prototype = Object.create(Enum.prototype);
  DayOfWeek.prototype.constructor = DayOfWeek;
  English.prototype = Object.create(KlockLocale.prototype);
  English.prototype.constructor = English;
  Companion_86.prototype = Object.create(English.prototype);
  Companion_86.prototype.constructor = Companion_86;
  KlockLocaleGender.prototype = Object.create(Enum.prototype);
  KlockLocaleGender.prototype.constructor = KlockLocaleGender;
  Month.prototype = Object.create(Enum.prototype);
  Month.prototype.constructor = Month;
  Fast32BufferF.prototype = Object.create(Fast32Buffer.prototype);
  Fast32BufferF.prototype.constructor = Fast32BufferF;
  _no_name_provided__110.prototype = Object.create(KmemGCImpl.prototype);
  _no_name_provided__110.prototype.constructor = _no_name_provided__110;
  Kind.prototype = Object.create(Enum.prototype);
  Kind.prototype.constructor = Kind;
  Color.prototype = Object.create(Enum.prototype);
  Color.prototype.constructor = Color;
  Level.prototype = Object.create(Enum.prototype);
  Level.prototype.constructor = Level;
  Console_0.prototype = Object.create(BaseConsole.prototype);
  Console_0.prototype.constructor = Console_0;
  None.prototype = Object.create(TraceBase.prototype);
  None.prototype.constructor = None;
  AbstractCoroutine.prototype = Object.create(JobSupport.prototype);
  AbstractCoroutine.prototype.constructor = AbstractCoroutine;
  $joinAllCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $joinAllCOROUTINE$0.prototype.constructor = $joinAllCOROUTINE$0;
  StandaloneCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  StandaloneCoroutine.prototype.constructor = StandaloneCoroutine;
  LazyStandaloneCoroutine.prototype = Object.create(StandaloneCoroutine.prototype);
  LazyStandaloneCoroutine.prototype.constructor = LazyStandaloneCoroutine;
  $awaitCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitCOROUTINE$1.prototype.constructor = $awaitCOROUTINE$1;
  DeferredCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  DeferredCoroutine.prototype.constructor = DeferredCoroutine;
  LazyDeferredCoroutine.prototype = Object.create(DeferredCoroutine.prototype);
  LazyDeferredCoroutine.prototype.constructor = LazyDeferredCoroutine;
  CancelHandler.prototype = Object.create(CancelHandlerBase.prototype);
  CancelHandler.prototype.constructor = CancelHandler;
  DisposeOnCancel.prototype = Object.create(CancelHandler.prototype);
  DisposeOnCancel.prototype.constructor = DisposeOnCancel;
  BeforeResumeCancelHandler.prototype = Object.create(CancelHandler.prototype);
  BeforeResumeCancelHandler.prototype.constructor = BeforeResumeCancelHandler;
  RemoveOnCancel.prototype = Object.create(BeforeResumeCancelHandler.prototype);
  RemoveOnCancel.prototype.constructor = RemoveOnCancel;
  DispatchedTask.prototype = Object.create(SchedulerTask.prototype);
  DispatchedTask.prototype.constructor = DispatchedTask;
  CancellableContinuationImpl.prototype = Object.create(DispatchedTask.prototype);
  CancellableContinuationImpl.prototype.constructor = CancellableContinuationImpl;
  InvokeOnCancel.prototype = Object.create(CancelHandler.prototype);
  InvokeOnCancel.prototype.constructor = InvokeOnCancel;
  $awaitCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitCOROUTINE$2.prototype.constructor = $awaitCOROUTINE$2;
  CompletableDeferredImpl.prototype = Object.create(JobSupport.prototype);
  CompletableDeferredImpl.prototype.constructor = CompletableDeferredImpl;
  CancelledContinuation.prototype = Object.create(CompletedExceptionally.prototype);
  CancelledContinuation.prototype.constructor = CancelledContinuation;
  Key_2.prototype = Object.create(AbstractCoroutineContextKey.prototype);
  Key_2.prototype.constructor = Key_2;
  CoroutineDispatcher.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  CoroutineDispatcher.prototype.constructor = CoroutineDispatcher;
  CoroutineStart.prototype = Object.create(Enum.prototype);
  CoroutineStart.prototype.constructor = CoroutineStart;
  EventLoop.prototype = Object.create(CoroutineDispatcher.prototype);
  EventLoop.prototype.constructor = EventLoop;
  CompletionHandlerException.prototype = Object.create(RuntimeException.prototype);
  CompletionHandlerException.prototype.constructor = CompletionHandlerException;
  CoroutinesInternalError.prototype = Object.create(Error_0.prototype);
  CoroutinesInternalError.prototype.constructor = CoroutinesInternalError;
  LinkedListHead.prototype = Object.create(LinkedListNode.prototype);
  LinkedListHead.prototype.constructor = LinkedListHead;
  NodeList_0.prototype = Object.create(LinkedListHead.prototype);
  NodeList_0.prototype.constructor = NodeList_0;
  CompletionHandlerBase.prototype = Object.create(LinkedListNode.prototype);
  CompletionHandlerBase.prototype.constructor = CompletionHandlerBase;
  JobNode.prototype = Object.create(CompletionHandlerBase.prototype);
  JobNode.prototype.constructor = JobNode;
  ChildCompletion.prototype = Object.create(JobNode.prototype);
  ChildCompletion.prototype.constructor = ChildCompletion;
  AwaitContinuation.prototype = Object.create(CancellableContinuationImpl.prototype);
  AwaitContinuation.prototype.constructor = AwaitContinuation;
  _no_name_provided__113.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__113.prototype.constructor = _no_name_provided__113;
  JobCancellingNode.prototype = Object.create(JobNode.prototype);
  JobCancellingNode.prototype.constructor = JobCancellingNode;
  ChildHandleNode.prototype = Object.create(JobCancellingNode.prototype);
  ChildHandleNode.prototype.constructor = ChildHandleNode;
  InvokeOnCancelling.prototype = Object.create(JobCancellingNode.prototype);
  InvokeOnCancelling.prototype.constructor = InvokeOnCancelling;
  InvokeOnCompletion.prototype = Object.create(JobNode.prototype);
  InvokeOnCompletion.prototype.constructor = InvokeOnCompletion;
  ResumeOnCompletion.prototype = Object.create(JobNode.prototype);
  ResumeOnCompletion.prototype.constructor = ResumeOnCompletion;
  ResumeAwaitOnCompletion.prototype = Object.create(JobNode.prototype);
  ResumeAwaitOnCompletion.prototype.constructor = ResumeAwaitOnCompletion;
  ChildContinuation.prototype = Object.create(JobCancellingNode.prototype);
  ChildContinuation.prototype.constructor = ChildContinuation;
  JobImpl.prototype = Object.create(JobSupport.prototype);
  JobImpl.prototype.constructor = JobImpl;
  DisposeOnCompletion.prototype = Object.create(JobNode.prototype);
  DisposeOnCompletion.prototype.constructor = DisposeOnCompletion;
  MainCoroutineDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  MainCoroutineDispatcher.prototype.constructor = MainCoroutineDispatcher;
  SupervisorJobImpl.prototype = Object.create(JobImpl.prototype);
  SupervisorJobImpl.prototype.constructor = SupervisorJobImpl;
  TimeoutCancellationException.prototype = Object.create(CancellationException.prototype);
  TimeoutCancellationException.prototype.constructor = TimeoutCancellationException;
  ScopeCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  ScopeCoroutine.prototype.constructor = ScopeCoroutine;
  TimeoutCoroutine.prototype = Object.create(ScopeCoroutine.prototype);
  TimeoutCoroutine.prototype.constructor = TimeoutCoroutine;
  Unconfined.prototype = Object.create(CoroutineDispatcher.prototype);
  Unconfined.prototype.constructor = Unconfined;
  RemoveReceiveOnCancel.prototype = Object.create(BeforeResumeCancelHandler.prototype);
  RemoveReceiveOnCancel.prototype.constructor = RemoveReceiveOnCancel;
  Receive.prototype = Object.create(LinkedListNode.prototype);
  Receive.prototype.constructor = Receive;
  ReceiveElement.prototype = Object.create(Receive.prototype);
  ReceiveElement.prototype.constructor = ReceiveElement;
  ReceiveElementWithUndeliveredHandler.prototype = Object.create(ReceiveElement.prototype);
  ReceiveElementWithUndeliveredHandler.prototype.constructor = ReceiveElementWithUndeliveredHandler;
  AbstractChannel.prototype = Object.create(AbstractSendChannel.prototype);
  AbstractChannel.prototype.constructor = AbstractChannel;
  Send.prototype = Object.create(LinkedListNode.prototype);
  Send.prototype.constructor = Send;
  SendBuffered.prototype = Object.create(Send.prototype);
  SendBuffered.prototype.constructor = SendBuffered;
  Closed.prototype = Object.create(Send.prototype);
  Closed.prototype.constructor = Closed;
  SendElement.prototype = Object.create(Send.prototype);
  SendElement.prototype.constructor = SendElement;
  SendElementWithUndeliveredHandler.prototype = Object.create(SendElement.prototype);
  SendElementWithUndeliveredHandler.prototype.constructor = SendElementWithUndeliveredHandler;
  ArrayChannel.prototype = Object.create(AbstractChannel.prototype);
  ArrayChannel.prototype.constructor = ArrayChannel;
  BufferOverflow.prototype = Object.create(Enum.prototype);
  BufferOverflow.prototype.constructor = BufferOverflow;
  Closed_0.prototype = Object.create(Failed.prototype);
  Closed_0.prototype.constructor = Closed_0;
  ClosedReceiveChannelException.prototype = Object.create(NoSuchElementException.prototype);
  ClosedReceiveChannelException.prototype.constructor = ClosedReceiveChannelException;
  ClosedSendChannelException.prototype = Object.create(IllegalStateException.prototype);
  ClosedSendChannelException.prototype.constructor = ClosedSendChannelException;
  ChannelCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  ChannelCoroutine.prototype.constructor = ChannelCoroutine;
  ConflatedChannel.prototype = Object.create(AbstractChannel.prototype);
  ConflatedChannel.prototype.constructor = ConflatedChannel;
  LinkedListChannel.prototype = Object.create(AbstractChannel.prototype);
  LinkedListChannel.prototype.constructor = LinkedListChannel;
  ProducerCoroutine.prototype = Object.create(ChannelCoroutine.prototype);
  ProducerCoroutine.prototype.constructor = ProducerCoroutine;
  RendezvousChannel.prototype = Object.create(AbstractChannel.prototype);
  RendezvousChannel.prototype.constructor = RendezvousChannel;
  SafeFlow.prototype = Object.create(AbstractFlow.prototype);
  SafeFlow.prototype.constructor = SafeFlow;
  $collect_2COROUTINE$5.prototype = Object.create(CoroutineImpl_0.prototype);
  $collect_2COROUTINE$5.prototype.constructor = $collect_2COROUTINE$5;
  $emitAllImplCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $emitAllImplCOROUTINE$6.prototype.constructor = $emitAllImplCOROUTINE$6;
  $collectCOROUTINE$7.prototype = Object.create(CoroutineImpl_0.prototype);
  $collectCOROUTINE$7.prototype.constructor = $collectCOROUTINE$7;
  $toCollectionCOROUTINE$13.prototype = Object.create(CoroutineImpl_0.prototype);
  $toCollectionCOROUTINE$13.prototype.constructor = $toCollectionCOROUTINE$13;
  $firstOrNullCOROUTINE$14.prototype = Object.create(CoroutineImpl_0.prototype);
  $firstOrNullCOROUTINE$14.prototype.constructor = $firstOrNullCOROUTINE$14;
  DispatchedContinuation.prototype = Object.create(DispatchedTask.prototype);
  DispatchedContinuation.prototype.constructor = DispatchedContinuation;
  UndeliveredElementException.prototype = Object.create(RuntimeException.prototype);
  UndeliveredElementException.prototype.constructor = UndeliveredElementException;
  JsMainDispatcher.prototype = Object.create(MainCoroutineDispatcher.prototype);
  JsMainDispatcher.prototype.constructor = JsMainDispatcher;
  UnconfinedEventLoop.prototype = Object.create(EventLoop.prototype);
  UnconfinedEventLoop.prototype.constructor = UnconfinedEventLoop;
  JobCancellationException.prototype = Object.create(CancellationException.prototype);
  JobCancellationException.prototype.constructor = JobCancellationException;
  SetTimeoutBasedDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  SetTimeoutBasedDispatcher.prototype.constructor = SetTimeoutBasedDispatcher;
  NodeDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  NodeDispatcher.prototype.constructor = NodeDispatcher;
  SetTimeoutDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  SetTimeoutDispatcher.prototype.constructor = SetTimeoutDispatcher;
  MessageQueue.prototype = Object.create(ArrayQueue.prototype);
  MessageQueue.prototype.constructor = MessageQueue;
  ScheduledMessageQueue.prototype = Object.create(MessageQueue.prototype);
  ScheduledMessageQueue.prototype.constructor = ScheduledMessageQueue;
  ClearTimeout.prototype = Object.create(CancelHandler.prototype);
  ClearTimeout.prototype.constructor = ClearTimeout;
  WindowDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  WindowDispatcher.prototype.constructor = WindowDispatcher;
  WindowMessageQueue.prototype = Object.create(MessageQueue.prototype);
  WindowMessageQueue.prototype.constructor = WindowMessageQueue;
  AbortFlowException.prototype = Object.create(CancellationException.prototype);
  AbortFlowException.prototype.constructor = AbortFlowException;
  $writeCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$0.prototype.constructor = $writeCOROUTINE$0;
  $readCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$1.prototype.constructor = $readCOROUTINE$1;
  _no_name_provided__125.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__125.prototype.constructor = _no_name_provided__125;
  _no_name_provided__126.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__126.prototype.constructor = _no_name_provided__126;
  _no_name_provided__129.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__129.prototype.constructor = _no_name_provided__129;
  $invokeCOROUTINE$4.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$4.prototype.constructor = $invokeCOROUTINE$4;
  _no_name_provided__130.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__130.prototype.constructor = _no_name_provided__130;
  $withTimeoutCOROUTINE$7.prototype = Object.create(CoroutineImpl_0.prototype);
  $withTimeoutCOROUTINE$7.prototype.constructor = $withTimeoutCOROUTINE$7;
  Signal.prototype = Object.create(BaseSignal.prototype);
  Signal.prototype.constructor = Signal;
  $invokeCOROUTINE$8.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$8.prototype.constructor = $invokeCOROUTINE$8;
  AsyncSignal.prototype = Object.create(BaseSignal.prototype);
  AsyncSignal.prototype.constructor = AsyncSignal;
  _no_name_provided__133.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  _no_name_provided__133.prototype.constructor = _no_name_provided__133;
  _no_name_provided__135.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__135.prototype.constructor = _no_name_provided__135;
  _no_name_provided__136.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__136.prototype.constructor = _no_name_provided__136;
  _no_name_provided__137.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__137.prototype.constructor = _no_name_provided__137;
  $uncompressCOROUTINE$11.prototype = Object.create(CoroutineImpl_0.prototype);
  $uncompressCOROUTINE$11.prototype.constructor = $uncompressCOROUTINE$11;
  $compressCOROUTINE$12.prototype = Object.create(CoroutineImpl_0.prototype);
  $compressCOROUTINE$12.prototype.constructor = $compressCOROUTINE$12;
  Companion_102.prototype = Object.create(DeflatePortable.prototype);
  Companion_102.prototype.constructor = Companion_102;
  $compressCOROUTINE$13.prototype = Object.create(CoroutineImpl_0.prototype);
  $compressCOROUTINE$13.prototype.constructor = $compressCOROUTINE$13;
  $uncompressCOROUTINE$14.prototype = Object.create(CoroutineImpl_0.prototype);
  $uncompressCOROUTINE$14.prototype.constructor = $uncompressCOROUTINE$14;
  GZIP.prototype = Object.create(GZIPBase.prototype);
  GZIP.prototype.constructor = GZIP;
  Companion_103.prototype = Object.create(GZIP.prototype);
  Companion_103.prototype.constructor = Companion_103;
  $writeCOROUTINE$19.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$19.prototype.constructor = $writeCOROUTINE$19;
  $readCOROUTINE$20.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$20.prototype.constructor = $readCOROUTINE$20;
  $uncompressCOROUTINE$17.prototype = Object.create(CoroutineImpl_0.prototype);
  $uncompressCOROUTINE$17.prototype.constructor = $uncompressCOROUTINE$17;
  $compressCOROUTINE$18.prototype = Object.create(CoroutineImpl_0.prototype);
  $compressCOROUTINE$18.prototype.constructor = $compressCOROUTINE$18;
  $writeCOROUTINE$23.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$23.prototype.constructor = $writeCOROUTINE$23;
  $readCOROUTINE$24.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$24.prototype.constructor = $readCOROUTINE$24;
  Companion_104.prototype = Object.create(ZLib.prototype);
  Companion_104.prototype.constructor = Companion_104;
  $uncompressCOROUTINE$21.prototype = Object.create(CoroutineImpl_0.prototype);
  $uncompressCOROUTINE$21.prototype.constructor = $uncompressCOROUTINE$21;
  $compressCOROUTINE$22.prototype = Object.create(CoroutineImpl_0.prototype);
  $compressCOROUTINE$22.prototype.constructor = $compressCOROUTINE$22;
  $forInputCOROUTINE$25.prototype = Object.create(CoroutineImpl_0.prototype);
  $forInputCOROUTINE$25.prototype.constructor = $forInputCOROUTINE$25;
  $prepareBytesUpToCOROUTINE$27.prototype = Object.create(CoroutineImpl_0.prototype);
  $prepareBytesUpToCOROUTINE$27.prototype.constructor = $prepareBytesUpToCOROUTINE$27;
  $abytesCOROUTINE$28.prototype = Object.create(CoroutineImpl_0.prototype);
  $abytesCOROUTINE$28.prototype.constructor = $abytesCOROUTINE$28;
  $readCOROUTINE$29.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$29.prototype.constructor = $readCOROUTINE$29;
  $strzCOROUTINE$30.prototype = Object.create(CoroutineImpl_0.prototype);
  $strzCOROUTINE$30.prototype.constructor = $strzCOROUTINE$30;
  $getLengthCOROUTINE$32.prototype = Object.create(CoroutineImpl_0.prototype);
  $getLengthCOROUTINE$32.prototype.constructor = $getLengthCOROUTINE$32;
  $invokeCOROUTINE$33.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$33.prototype.constructor = $invokeCOROUTINE$33;
  $readCOROUTINE$34.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$34.prototype.constructor = $readCOROUTINE$34;
  Companion_109.prototype = Object.create(KDynamic.prototype);
  Companion_109.prototype.constructor = Companion_109;
  TypeContext.prototype = Object.create(KDynamic.prototype);
  TypeContext.prototype.constructor = TypeContext;
  $emit_2COROUTINE$60.prototype = Object.create(CoroutineImpl_0.prototype);
  $emit_2COROUTINE$60.prototype.constructor = $emit_2COROUTINE$60;
  _no_name_provided__157.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__157.prototype.constructor = _no_name_provided__157;
  $getUnderlyingUnscapedFileCOROUTINE$45.prototype = Object.create(CoroutineImpl_0.prototype);
  $getUnderlyingUnscapedFileCOROUTINE$45.prototype.constructor = $getUnderlyingUnscapedFileCOROUTINE$45;
  $initOnceCOROUTINE$46.prototype = Object.create(CoroutineImpl_0.prototype);
  $initOnceCOROUTINE$46.prototype.constructor = $initOnceCOROUTINE$46;
  $openCOROUTINE$48.prototype = Object.create(CoroutineImpl_0.prototype);
  $openCOROUTINE$48.prototype.constructor = $openCOROUTINE$48;
  $readRangeCOROUTINE$49.prototype = Object.create(CoroutineImpl_0.prototype);
  $readRangeCOROUTINE$49.prototype.constructor = $readRangeCOROUTINE$49;
  $statCOROUTINE$52.prototype = Object.create(CoroutineImpl_0.prototype);
  $statCOROUTINE$52.prototype.constructor = $statCOROUTINE$52;
  $listSimpleCOROUTINE$53.prototype = Object.create(CoroutineImpl_0.prototype);
  $listSimpleCOROUTINE$53.prototype.constructor = $listSimpleCOROUTINE$53;
  Kind_0.prototype = Object.create(Enum.prototype);
  Kind_0.prototype.constructor = Kind_0;
  Proxy.prototype = Object.create(Vfs.prototype);
  Proxy.prototype.constructor = Proxy;
  _no_name_provided__158.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__158.prototype.constructor = _no_name_provided__158;
  $readRangeCOROUTINE$38.prototype = Object.create(CoroutineImpl_0.prototype);
  $readRangeCOROUTINE$38.prototype.constructor = $readRangeCOROUTINE$38;
  $listSimpleCOROUTINE$43.prototype = Object.create(CoroutineImpl_0.prototype);
  $listSimpleCOROUTINE$43.prototype.constructor = $listSimpleCOROUTINE$43;
  VfsOpenMode.prototype = Object.create(Enum.prototype);
  VfsOpenMode.prototype.constructor = VfsOpenMode;
  VfsV2.prototype = Object.create(Vfs.prototype);
  VfsV2.prototype.constructor = VfsV2;
  $emit_2COROUTINE$81.prototype = Object.create(CoroutineImpl_0.prototype);
  $emit_2COROUTINE$81.prototype.constructor = $emit_2COROUTINE$81;
  _no_name_provided__160.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__160.prototype.constructor = _no_name_provided__160;
  $readStringCOROUTINE$67.prototype = Object.create(CoroutineImpl_0.prototype);
  $readStringCOROUTINE$67.prototype.constructor = $readStringCOROUTINE$67;
  VfsFile.prototype = Object.create(VfsNamed.prototype);
  VfsFile.prototype.constructor = VfsFile;
  _no_name_provided__161.prototype = Object.create(Proxy.prototype);
  _no_name_provided__161.prototype.constructor = _no_name_provided__161;
  LocalVfs.prototype = Object.create(Vfs.prototype);
  LocalVfs.prototype.constructor = LocalVfs;
  $updateInfoCOROUTINE$89.prototype = Object.create(CoroutineImpl_0.prototype);
  $updateInfoCOROUTINE$89.prototype.constructor = $updateInfoCOROUTINE$89;
  $writeCOROUTINE$90.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$90.prototype.constructor = $writeCOROUTINE$90;
  _no_name_provided__163.prototype = Object.create(AsyncStreamBase.prototype);
  _no_name_provided__163.prototype.constructor = _no_name_provided__163;
  $initOnceCOROUTINE$83.prototype = Object.create(CoroutineImpl_0.prototype);
  $initOnceCOROUTINE$83.prototype.constructor = $initOnceCOROUTINE$83;
  $statCOROUTINE$84.prototype = Object.create(CoroutineImpl_0.prototype);
  $statCOROUTINE$84.prototype.constructor = $statCOROUTINE$84;
  $ensureParentDirectoryCOROUTINE$85.prototype = Object.create(CoroutineImpl_0.prototype);
  $ensureParentDirectoryCOROUTINE$85.prototype.constructor = $ensureParentDirectoryCOROUTINE$85;
  $listFlowCOROUTINE$87.prototype = Object.create(CoroutineImpl_0.prototype);
  $listFlowCOROUTINE$87.prototype.constructor = $listFlowCOROUTINE$87;
  $openCOROUTINE$88.prototype = Object.create(CoroutineImpl_0.prototype);
  $openCOROUTINE$88.prototype.constructor = $openCOROUTINE$88;
  MapLikeStorageVfs.prototype = Object.create(VfsV2.prototype);
  MapLikeStorageVfs.prototype.constructor = MapLikeStorageVfs;
  $setEntryInfoCOROUTINE$91.prototype = Object.create(CoroutineImpl_0.prototype);
  $setEntryInfoCOROUTINE$91.prototype.constructor = $setEntryInfoCOROUTINE$91;
  $hasEntryInfoCOROUTINE$92.prototype = Object.create(CoroutineImpl_0.prototype);
  $hasEntryInfoCOROUTINE$92.prototype.constructor = $hasEntryInfoCOROUTINE$92;
  $getEntryInfoCOROUTINE$93.prototype = Object.create(CoroutineImpl_0.prototype);
  $getEntryInfoCOROUTINE$93.prototype.constructor = $getEntryInfoCOROUTINE$93;
  $setFileChunkCOROUTINE$96.prototype = Object.create(CoroutineImpl_0.prototype);
  $setFileChunkCOROUTINE$96.prototype.constructor = $setFileChunkCOROUTINE$96;
  $getFileChunkCOROUTINE$97.prototype = Object.create(CoroutineImpl_0.prototype);
  $getFileChunkCOROUTINE$97.prototype.constructor = $getFileChunkCOROUTINE$97;
  $writeDataCOROUTINE$98.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeDataCOROUTINE$98.prototype.constructor = $writeDataCOROUTINE$98;
  $readDataCOROUTINE$99.prototype = Object.create(CoroutineImpl_0.prototype);
  $readDataCOROUTINE$99.prototype.constructor = $readDataCOROUTINE$99;
  $closeCOROUTINE$101.prototype = Object.create(CoroutineImpl_0.prototype);
  $closeCOROUTINE$101.prototype.constructor = $closeCOROUTINE$101;
  MountableVfs_0.prototype = Object.create(Proxy.prototype);
  MountableVfs_0.prototype.constructor = MountableVfs_0;
  $MountableVfsCOROUTINE$100.prototype = Object.create(CoroutineImpl_0.prototype);
  $MountableVfsCOROUTINE$100.prototype.constructor = $MountableVfsCOROUTINE$100;
  _no_name_provided__167.prototype = Object.create(AsyncStreamBase.prototype);
  _no_name_provided__167.prototype.constructor = _no_name_provided__167;
  _no_name_provided__168.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__168.prototype.constructor = _no_name_provided__168;
  $statCOROUTINE$102.prototype = Object.create(CoroutineImpl_0.prototype);
  $statCOROUTINE$102.prototype.constructor = $statCOROUTINE$102;
  NodeVfs.prototype = Object.create(VfsV2.prototype);
  NodeVfs.prototype.constructor = NodeVfs;
  $readCOROUTINE$109.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$109.prototype.constructor = $readCOROUTINE$109;
  $getLengthCOROUTINE$110.prototype = Object.create(CoroutineImpl_0.prototype);
  $getLengthCOROUTINE$110.prototype.constructor = $getLengthCOROUTINE$110;
  _no_name_provided__172.prototype = Object.create(AsyncStreamBase.prototype);
  _no_name_provided__172.prototype.constructor = _no_name_provided__172;
  $openCOROUTINE$103.prototype = Object.create(CoroutineImpl_0.prototype);
  $openCOROUTINE$103.prototype.constructor = $openCOROUTINE$103;
  $_readRangeBaseCOROUTINE$105.prototype = Object.create(CoroutineImpl_0.prototype);
  $_readRangeBaseCOROUTINE$105.prototype.constructor = $_readRangeBaseCOROUTINE$105;
  $readRangeCOROUTINE$106.prototype = Object.create(CoroutineImpl_0.prototype);
  $readRangeCOROUTINE$106.prototype.constructor = $readRangeCOROUTINE$106;
  $statCOROUTINE$108.prototype = Object.create(CoroutineImpl_0.prototype);
  $statCOROUTINE$108.prototype.constructor = $statCOROUTINE$108;
  UrlVfs_0.prototype = Object.create(Vfs.prototype);
  UrlVfs_0.prototype.constructor = UrlVfs_0;
  _no_name_provided__173.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__173.prototype.constructor = _no_name_provided__173;
  $closeCOROUTINE$114.prototype = Object.create(CoroutineImpl_0.prototype);
  $closeCOROUTINE$114.prototype.constructor = $closeCOROUTINE$114;
  $openCOROUTINE$115.prototype = Object.create(CoroutineImpl_0.prototype);
  $openCOROUTINE$115.prototype.constructor = $openCOROUTINE$115;
  Impl.prototype = Object.create(VfsV2.prototype);
  Impl.prototype.constructor = Impl;
  $openAsZipCOROUTINE$111.prototype = Object.create(CoroutineImpl_0.prototype);
  $openAsZipCOROUTINE$111.prototype.constructor = $openAsZipCOROUTINE$111;
  $openAsZipCOROUTINE$112.prototype = Object.create(CoroutineImpl_0.prototype);
  $openAsZipCOROUTINE$112.prototype.constructor = $openAsZipCOROUTINE$112;
  $ZipVfsCOROUTINE$113.prototype = Object.create(CoroutineImpl_0.prototype);
  $ZipVfsCOROUTINE$113.prototype.constructor = $ZipVfsCOROUTINE$113;
  BaseSingleByteCharset.prototype = Object.create(Charset.prototype);
  BaseSingleByteCharset.prototype.constructor = BaseSingleByteCharset;
  SingleByteCharset.prototype = Object.create(BaseSingleByteCharset.prototype);
  SingleByteCharset.prototype.constructor = SingleByteCharset;
  ISO_8859_1.prototype = Object.create(SingleByteCharset.prototype);
  ISO_8859_1.prototype.constructor = ISO_8859_1;
  UTF16Charset.prototype = Object.create(Charset.prototype);
  UTF16Charset.prototype.constructor = UTF16Charset;
  UTC8CharsetBase.prototype = Object.create(Charset.prototype);
  UTC8CharsetBase.prototype.constructor = UTC8CharsetBase;
  ASCII.prototype = Object.create(BaseSingleByteCharset.prototype);
  ASCII.prototype.constructor = ASCII;
  InvalidOperationException.prototype = Object.create(Exception.prototype);
  InvalidOperationException.prototype.constructor = InvalidOperationException;
  _no_name_provided__180.prototype = Object.create(NativeThreadLocal.prototype);
  _no_name_provided__180.prototype.constructor = _no_name_provided__180;
  Methods.prototype = Object.create(Enum.prototype);
  Methods.prototype.constructor = Methods;
  IOException.prototype = Object.create(Exception.prototype);
  IOException.prototype.constructor = IOException;
  HttpException.prototype = Object.create(IOException.prototype);
  HttpException.prototype.constructor = HttpException;
  $readAllBytesCOROUTINE$119.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAllBytesCOROUTINE$119.prototype.constructor = $readAllBytesCOROUTINE$119;
  $readAllStringCOROUTINE$120.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAllStringCOROUTINE$120.prototype.constructor = $readAllStringCOROUTINE$120;
  $checkErrorsCOROUTINE$121.prototype = Object.create(CoroutineImpl_0.prototype);
  $checkErrorsCOROUTINE$121.prototype.constructor = $checkErrorsCOROUTINE$121;
  $requestCOROUTINE$122.prototype = Object.create(CoroutineImpl_0.prototype);
  $requestCOROUTINE$122.prototype.constructor = $requestCOROUTINE$122;
  $requestAsBytesCOROUTINE$124.prototype = Object.create(CoroutineImpl_0.prototype);
  $requestAsBytesCOROUTINE$124.prototype.constructor = $requestAsBytesCOROUTINE$124;
  $readBytesCOROUTINE$125.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesCOROUTINE$125.prototype.constructor = $readBytesCOROUTINE$125;
  ProcessingInstructionTag.prototype = Object.create(Element_1.prototype);
  ProcessingInstructionTag.prototype.constructor = ProcessingInstructionTag;
  OpenCloseTag.prototype = Object.create(Element_1.prototype);
  OpenCloseTag.prototype.constructor = OpenCloseTag;
  OpenTag.prototype = Object.create(Element_1.prototype);
  OpenTag.prototype.constructor = OpenTag;
  CommentTag.prototype = Object.create(Element_1.prototype);
  CommentTag.prototype.constructor = CommentTag;
  CloseTag.prototype = Object.create(Element_1.prototype);
  CloseTag.prototype.constructor = CloseTag;
  Text_0.prototype = Object.create(Element_1.prototype);
  Text_0.prototype.constructor = Text_0;
  _no_name_provided__188.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__188.prototype.constructor = _no_name_provided__188;
  Type_3.prototype = Object.create(Enum.prototype);
  Type_3.prototype.constructor = Type_3;
  $readXmlCOROUTINE$141.prototype = Object.create(CoroutineImpl_0.prototype);
  $readXmlCOROUTINE$141.prototype.constructor = $readXmlCOROUTINE$141;
  _no_name_provided__192.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__192.prototype.constructor = _no_name_provided__192;
  _no_name_provided__193.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__193.prototype.constructor = _no_name_provided__193;
  $readCOROUTINE$142.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$142.prototype.constructor = $readCOROUTINE$142;
  $writeCOROUTINE$143.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$143.prototype.constructor = $writeCOROUTINE$143;
  $readInternalCOROUTINE$144.prototype = Object.create(CoroutineImpl_0.prototype);
  $readInternalCOROUTINE$144.prototype.constructor = $readInternalCOROUTINE$144;
  $writeInternalCOROUTINE$145.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeInternalCOROUTINE$145.prototype.constructor = $writeInternalCOROUTINE$145;
  $getAvailableCOROUTINE$146.prototype = Object.create(CoroutineImpl_0.prototype);
  $getAvailableCOROUTINE$146.prototype.constructor = $getAvailableCOROUTINE$146;
  $eofCOROUTINE$147.prototype = Object.create(CoroutineImpl_0.prototype);
  $eofCOROUTINE$147.prototype.constructor = $eofCOROUTINE$147;
  $readCOROUTINE$148.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$148.prototype.constructor = $readCOROUTINE$148;
  $writeCOROUTINE$150.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$150.prototype.constructor = $writeCOROUTINE$150;
  $_readCOROUTINE$154.prototype = Object.create(CoroutineImpl_0.prototype);
  $_readCOROUTINE$154.prototype.constructor = $_readCOROUTINE$154;
  BufferedStreamBase.prototype = Object.create(AsyncStreamBase.prototype);
  BufferedStreamBase.prototype.constructor = BufferedStreamBase;
  $hasLengthCOROUTINE$155.prototype = Object.create(CoroutineImpl_0.prototype);
  $hasLengthCOROUTINE$155.prototype.constructor = $hasLengthCOROUTINE$155;
  MemoryAsyncStreamBase.prototype = Object.create(AsyncStreamBase.prototype);
  MemoryAsyncStreamBase.prototype.constructor = MemoryAsyncStreamBase;
  SyncAsyncStreamBase.prototype = Object.create(AsyncStreamBase.prototype);
  SyncAsyncStreamBase.prototype.constructor = SyncAsyncStreamBase;
  $closeCOROUTINE$180.prototype = Object.create(CoroutineImpl_0.prototype);
  $closeCOROUTINE$180.prototype.constructor = $closeCOROUTINE$180;
  SliceAsyncStreamBase.prototype = Object.create(AsyncStreamBase.prototype);
  SliceAsyncStreamBase.prototype.constructor = SliceAsyncStreamBase;
  SeekNotSupportedException.prototype = Object.create(UnsupportedOperationException.prototype);
  SeekNotSupportedException.prototype.constructor = SeekNotSupportedException;
  _no_name_provided__195.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__195.prototype.constructor = _no_name_provided__195;
  $getPositionCOROUTINE$183.prototype = Object.create(CoroutineImpl_0.prototype);
  $getPositionCOROUTINE$183.prototype.constructor = $getPositionCOROUTINE$183;
  $getLengthCOROUTINE$184.prototype = Object.create(CoroutineImpl_0.prototype);
  $getLengthCOROUTINE$184.prototype.constructor = $getLengthCOROUTINE$184;
  $readCOROUTINE$185.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$185.prototype.constructor = $readCOROUTINE$185;
  $writeCOROUTINE$186.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$186.prototype.constructor = $writeCOROUTINE$186;
  $getLengthCOROUTINE$188.prototype = Object.create(CoroutineImpl_0.prototype);
  $getLengthCOROUTINE$188.prototype.constructor = $getLengthCOROUTINE$188;
  _no_name_provided__200.prototype = Object.create(AsyncStreamBase.prototype);
  _no_name_provided__200.prototype.constructor = _no_name_provided__200;
  $readCOROUTINE$189.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$189.prototype.constructor = $readCOROUTINE$189;
  $readAllCOROUTINE$149.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAllCOROUTINE$149.prototype.constructor = $readAllCOROUTINE$149;
  $readS32BECOROUTINE$152.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS32BECOROUTINE$152.prototype.constructor = $readS32BECOROUTINE$152;
  $readBytesExactCOROUTINE$153.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesExactCOROUTINE$153.prototype.constructor = $readBytesExactCOROUTINE$153;
  $readExactCOROUTINE$157.prototype = Object.create(CoroutineImpl_0.prototype);
  $readExactCOROUTINE$157.prototype.constructor = $readExactCOROUTINE$157;
  $readBytesCOROUTINE$158.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesCOROUTINE$158.prototype.constructor = $readBytesCOROUTINE$158;
  $readBytesUpToCOROUTINE$160.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesUpToCOROUTINE$160.prototype.constructor = $readBytesUpToCOROUTINE$160;
  $write32LECOROUTINE$161.prototype = Object.create(CoroutineImpl_0.prototype);
  $write32LECOROUTINE$161.prototype.constructor = $write32LECOROUTINE$161;
  $readBytesUpToCopyCOROUTINE$163.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesUpToCopyCOROUTINE$163.prototype.constructor = $readBytesUpToCopyCOROUTINE$163;
  $getAvailableCOROUTINE$164.prototype = Object.create(CoroutineImpl_0.prototype);
  $getAvailableCOROUTINE$164.prototype.constructor = $getAvailableCOROUTINE$164;
  $readBytesUpToCOROUTINE$165.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesUpToCOROUTINE$165.prototype.constructor = $readBytesUpToCOROUTINE$165;
  $getAvailableCOROUTINE$166.prototype = Object.create(CoroutineImpl_0.prototype);
  $getAvailableCOROUTINE$166.prototype.constructor = $getAvailableCOROUTINE$166;
  $write16LECOROUTINE$167.prototype = Object.create(CoroutineImpl_0.prototype);
  $write16LECOROUTINE$167.prototype.constructor = $write16LECOROUTINE$167;
  $hasAvailableCOROUTINE$168.prototype = Object.create(CoroutineImpl_0.prototype);
  $hasAvailableCOROUTINE$168.prototype.constructor = $hasAvailableCOROUTINE$168;
  $readStringCOROUTINE$170.prototype = Object.create(CoroutineImpl_0.prototype);
  $readStringCOROUTINE$170.prototype.constructor = $readStringCOROUTINE$170;
  $readS8COROUTINE$171.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS8COROUTINE$171.prototype.constructor = $readS8COROUTINE$171;
  $readS64LECOROUTINE$172.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS64LECOROUTINE$172.prototype.constructor = $readS64LECOROUTINE$172;
  $readS32LECOROUTINE$173.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS32LECOROUTINE$173.prototype.constructor = $readS32LECOROUTINE$173;
  $readS16LECOROUTINE$174.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS16LECOROUTINE$174.prototype.constructor = $readS16LECOROUTINE$174;
  $readU32LECOROUTINE$175.prototype = Object.create(CoroutineImpl_0.prototype);
  $readU32LECOROUTINE$175.prototype.constructor = $readU32LECOROUTINE$175;
  $write32BECOROUTINE$176.prototype = Object.create(CoroutineImpl_0.prototype);
  $write32BECOROUTINE$176.prototype.constructor = $write32BECOROUTINE$176;
  $readSliceCOROUTINE$177.prototype = Object.create(CoroutineImpl_0.prototype);
  $readSliceCOROUTINE$177.prototype.constructor = $readSliceCOROUTINE$177;
  $writeTempBytesCOROUTINE$178.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeTempBytesCOROUTINE$178.prototype.constructor = $writeTempBytesCOROUTINE$178;
  $sliceWithBoundsCOROUTINE$179.prototype = Object.create(CoroutineImpl_0.prototype);
  $sliceWithBoundsCOROUTINE$179.prototype.constructor = $sliceWithBoundsCOROUTINE$179;
  $sliceStartCOROUTINE$181.prototype = Object.create(CoroutineImpl_0.prototype);
  $sliceStartCOROUTINE$181.prototype.constructor = $sliceStartCOROUTINE$181;
  $readU16LECOROUTINE$182.prototype = Object.create(CoroutineImpl_0.prototype);
  $readU16LECOROUTINE$182.prototype.constructor = $readU16LECOROUTINE$182;
  MemorySyncStreamBase.prototype = Object.create(SyncStreamBase.prototype);
  MemorySyncStreamBase.prototype.constructor = MemorySyncStreamBase;
  ReadonlySyncStreamBase.prototype = Object.create(SyncStreamBase.prototype);
  ReadonlySyncStreamBase.prototype.constructor = ReadonlySyncStreamBase;
  SliceSyncStreamBase.prototype = Object.create(SyncStreamBase.prototype);
  SliceSyncStreamBase.prototype.constructor = SliceSyncStreamBase;
  _no_name_provided__212.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__212.prototype.constructor = _no_name_provided__212;
  Language.prototype = Object.create(Enum.prototype);
  Language.prototype.constructor = Language;
  BlobAsyncBaseStream.prototype = Object.create(AsyncStreamBase.prototype);
  BlobAsyncBaseStream.prototype.constructor = BlobAsyncBaseStream;
  _no_name_provided__224.prototype = Object.create(Vfs.prototype);
  _no_name_provided__224.prototype.constructor = _no_name_provided__224;
  FileNotFoundException.prototype = Object.create(IOException.prototype);
  FileNotFoundException.prototype.constructor = FileNotFoundException;
  EOFException.prototype = Object.create(IOException.prototype);
  EOFException.prototype.constructor = EOFException;
  _no_name_provided__235.prototype = Object.create(UTC8CharsetBase.prototype);
  _no_name_provided__235.prototype.constructor = _no_name_provided__235;
  _no_name_provided__236.prototype = Object.create(AsyncSocketFactory.prototype);
  _no_name_provided__236.prototype.constructor = _no_name_provided__236;
  $requestInternalCOROUTINE$190.prototype = Object.create(CoroutineImpl_0.prototype);
  $requestInternalCOROUTINE$190.prototype.constructor = $requestInternalCOROUTINE$190;
  HttpClientBrowserJs.prototype = Object.create(HttpClient.prototype);
  HttpClientBrowserJs.prototype.constructor = HttpClientBrowserJs;
  GrowMethod.prototype = Object.create(Enum.prototype);
  GrowMethod.prototype.constructor = GrowMethod;
  Bitmap32.prototype = Object.create(Bitmap.prototype);
  Bitmap32.prototype.constructor = Bitmap32;
  BitmapIndexed.prototype = Object.create(Bitmap.prototype);
  BitmapIndexed.prototype.constructor = BitmapIndexed;
  Bitmap8.prototype = Object.create(BitmapIndexed.prototype);
  Bitmap8.prototype.constructor = Bitmap8;
  BitmapChannel.prototype = Object.create(Enum.prototype);
  BitmapChannel.prototype.constructor = BitmapChannel;
  BitmapSlice.prototype = Object.create(BmpSlice.prototype);
  BitmapSlice.prototype.constructor = BitmapSlice;
  FloatBitmap32.prototype = Object.create(Bitmap.prototype);
  FloatBitmap32.prototype.constructor = FloatBitmap32;
  NativeImage.prototype = Object.create(Bitmap.prototype);
  NativeImage.prototype.constructor = NativeImage;
  $readNinePatchCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $readNinePatchCOROUTINE$0.prototype.constructor = $readNinePatchCOROUTINE$0;
  RGB.prototype = Object.create(ColorFormat24.prototype);
  RGB.prototype.constructor = RGB;
  Companion_135.prototype = Object.create(RGB.prototype);
  Companion_135.prototype.constructor = Companion_135;
  BGR.prototype = Object.create(RGB.prototype);
  BGR.prototype.constructor = BGR;
  Companion_137.prototype = Object.create(ColorFormat32.prototype);
  Companion_137.prototype.constructor = Companion_137;
  $readBitmapFontCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapFontCOROUTINE$1.prototype.constructor = $readBitmapFontCOROUTINE$1;
  $readBitmapFontXmlCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapFontXmlCOROUTINE$2.prototype.constructor = $readBitmapFontXmlCOROUTINE$2;
  $readBitmapFontTxtCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapFontTxtCOROUTINE$3.prototype.constructor = $readBitmapFontTxtCOROUTINE$3;
  _no_name_provided__260.prototype = Object.create(TextRendererActions.prototype);
  _no_name_provided__260.prototype.constructor = _no_name_provided__260;
  $emit_2_8_4_4COROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $emit_2_8_4_4COROUTINE$6.prototype.constructor = $emit_2_8_4_4COROUTINE$6;
  $collect_2_2_2COROUTINE$5.prototype = Object.create(CoroutineImpl_0.prototype);
  $collect_2_2_2COROUTINE$5.prototype.constructor = $collect_2_2_2COROUTINE$5;
  _no_name_provided__262.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__262.prototype.constructor = _no_name_provided__262;
  $readFontCOROUTINE$4.prototype = Object.create(CoroutineImpl_0.prototype);
  $readFontCOROUTINE$4.prototype.constructor = $readFontCOROUTINE$4;
  SystemFontRegistry.prototype = Object.create(DefaultFontRegistry.prototype);
  SystemFontRegistry.prototype.constructor = SystemFontRegistry;
  TtfNativeSystemFontProvider.prototype = Object.create(NativeSystemFontProvider.prototype);
  TtfNativeSystemFontProvider.prototype.constructor = TtfNativeSystemFontProvider;
  FallbackNativeSystemFontProvider.prototype = Object.create(TtfNativeSystemFontProvider.prototype);
  FallbackNativeSystemFontProvider.prototype.constructor = FallbackNativeSystemFontProvider;
  NameId.prototype = Object.create(Enum.prototype);
  NameId.prototype.constructor = NameId;
  GraphicsPath.prototype = Object.create(VectorPath.prototype);
  GraphicsPath.prototype.constructor = GraphicsPath;
  GlyphGraphicsPath.prototype = Object.create(GraphicsPath.prototype);
  GlyphGraphicsPath.prototype.constructor = GlyphGraphicsPath;
  CompositeGlyph.prototype = Object.create(Glyph_0.prototype);
  CompositeGlyph.prototype.constructor = CompositeGlyph;
  SimpleGlyph.prototype = Object.create(Glyph_0.prototype);
  SimpleGlyph.prototype.constructor = SimpleGlyph;
  $readTtfFontCOROUTINE$9.prototype = Object.create(CoroutineImpl_0.prototype);
  $readTtfFontCOROUTINE$9.prototype.constructor = $readTtfFontCOROUTINE$9;
  BmImageInfo.prototype = Object.create(ImageInfo.prototype);
  BmImageInfo.prototype.constructor = BmImageInfo;
  BMP.prototype = Object.create(ImageFormat.prototype);
  BMP.prototype.constructor = BMP;
  Direction.prototype = Object.create(Enum.prototype);
  Direction.prototype.constructor = Direction;
  ImageFormats.prototype = Object.create(ImageFormat.prototype);
  ImageFormats.prototype.constructor = ImageFormats;
  $readBitmapOptimizedCOROUTINE$13.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapOptimizedCOROUTINE$13.prototype.constructor = $readBitmapOptimizedCOROUTINE$13;
  $readBitmapSliceCOROUTINE$14.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapSliceCOROUTINE$14.prototype.constructor = $readBitmapSliceCOROUTINE$14;
  $readBitmapCOROUTINE$15.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapCOROUTINE$15.prototype.constructor = $readBitmapCOROUTINE$15;
  $decodeCOROUTINE$16.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$16.prototype.constructor = $decodeCOROUTINE$16;
  $decodeCOROUTINE$17.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$17.prototype.constructor = $decodeCOROUTINE$17;
  $decodeCOROUTINE$18.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$18.prototype.constructor = $decodeCOROUTINE$18;
  BaseNativeImageFormatProvider.prototype = Object.create(NativeImageFormatProvider.prototype);
  BaseNativeImageFormatProvider.prototype.constructor = BaseNativeImageFormatProvider;
  BitmapNativeImage.prototype = Object.create(NativeImage.prototype);
  BitmapNativeImage.prototype.constructor = BitmapNativeImage;
  Colorspace.prototype = Object.create(Enum.prototype);
  Colorspace.prototype.constructor = Colorspace;
  PNG.prototype = Object.create(ImageFormat.prototype);
  PNG.prototype.constructor = PNG;
  RegisteredImageFormats.prototype = Object.create(ImageFormat.prototype);
  RegisteredImageFormats.prototype.constructor = RegisteredImageFormats;
  TGA.prototype = Object.create(ImageFormat.prototype);
  TGA.prototype.constructor = TGA;
  ColorFiller.prototype = Object.create(BaseFiller.prototype);
  ColorFiller.prototype.constructor = ColorFiller;
  GradientFiller.prototype = Object.create(BaseFiller.prototype);
  GradientFiller.prototype.constructor = GradientFiller;
  BitmapFiller.prototype = Object.create(BaseFiller.prototype);
  BitmapFiller.prototype.constructor = BitmapFiller;
  NoneFiller.prototype = Object.create(BaseFiller.prototype);
  NoneFiller.prototype.constructor = NoneFiller;
  GradientKind.prototype = Object.create(Enum.prototype);
  GradientKind.prototype.constructor = GradientKind;
  GradientInterpolationMethod.prototype = Object.create(Enum.prototype);
  GradientInterpolationMethod.prototype.constructor = GradientInterpolationMethod;
  GradientUnits.prototype = Object.create(Enum.prototype);
  GradientUnits.prototype.constructor = GradientUnits;
  BoundBuilderTextRendererActions.prototype = Object.create(TextRendererActions.prototype);
  BoundBuilderTextRendererActions.prototype.constructor = BoundBuilderTextRendererActions;
  Text2TextRendererActions.prototype = Object.create(TextRendererActions.prototype);
  Text2TextRendererActions.prototype.constructor = Text2TextRendererActions;
  Bitmap32Context2d.prototype = Object.create(Renderer.prototype);
  Bitmap32Context2d.prototype.constructor = Bitmap32Context2d;
  BitmapVector.prototype = Object.create(Bitmap.prototype);
  BitmapVector.prototype.constructor = BitmapVector;
  CompositeMode.prototype = Object.create(Enum.prototype);
  CompositeMode.prototype.constructor = CompositeMode;
  BlendMode.prototype = Object.create(Enum.prototype);
  BlendMode.prototype.constructor = BlendMode;
  CycleMethod.prototype = Object.create(Enum.prototype);
  CycleMethod.prototype.constructor = CycleMethod;
  LineScaleMode.prototype = Object.create(Enum.prototype);
  LineScaleMode.prototype.constructor = LineScaleMode;
  ShapeBuilder.prototype = Object.create(Context2d.prototype);
  ShapeBuilder.prototype.constructor = ShapeBuilder;
  $readSVGCOROUTINE$19.prototype = Object.create(CoroutineImpl_0.prototype);
  $readSVGCOROUTINE$19.prototype.constructor = $readSVGCOROUTINE$19;
  Rasterizer.prototype = Object.create(RastScale.prototype);
  Rasterizer.prototype.constructor = Rasterizer;
  DummyRenderer.prototype = Object.create(Renderer.prototype);
  DummyRenderer.prototype.constructor = DummyRenderer;
  Companion_162.prototype = Object.create(DummyRenderer.prototype);
  Companion_162.prototype.constructor = Companion_162;
  NodeJsNativeImageFormatProvider.prototype = Object.create(BaseNativeImageFormatProvider.prototype);
  NodeJsNativeImageFormatProvider.prototype.constructor = NodeJsNativeImageFormatProvider;
  $decodeCOROUTINE$20.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$20.prototype.constructor = $decodeCOROUTINE$20;
  $decodeCOROUTINE$21.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$21.prototype.constructor = $decodeCOROUTINE$21;
  HtmlNativeImageFormatProvider.prototype = Object.create(NativeImageFormatProvider.prototype);
  HtmlNativeImageFormatProvider.prototype.constructor = HtmlNativeImageFormatProvider;
  HtmlNativeImage.prototype = Object.create(NativeImage.prototype);
  HtmlNativeImage.prototype.constructor = HtmlNativeImage;
  $decodeToCanvasCOROUTINE$22.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeToCanvasCOROUTINE$22.prototype.constructor = $decodeToCanvasCOROUTINE$22;
  $loadCanvasCOROUTINE$23.prototype = Object.create(CoroutineImpl_0.prototype);
  $loadCanvasCOROUTINE$23.prototype.constructor = $loadCanvasCOROUTINE$23;
  CanvasContext2dRenderer.prototype = Object.create(Renderer.prototype);
  CanvasContext2dRenderer.prototype.constructor = CanvasContext2dRenderer;
  KmlGlWithExtensions.prototype = Object.create(KmlGl.prototype);
  KmlGlWithExtensions.prototype.constructor = KmlGlWithExtensions;
  _no_name_provided__295.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__295.prototype.constructor = _no_name_provided__295;
  Kind_1.prototype = Object.create(Enum.prototype);
  Kind_1.prototype.constructor = Kind_1;
  BlendEquation.prototype = Object.create(Enum.prototype);
  BlendEquation.prototype.constructor = BlendEquation;
  BlendFactor.prototype = Object.create(Enum.prototype);
  BlendFactor.prototype.constructor = BlendFactor;
  DrawType.prototype = Object.create(Enum.prototype);
  DrawType.prototype.constructor = DrawType;
  IndexType.prototype = Object.create(Enum.prototype);
  IndexType.prototype.constructor = IndexType;
  StencilOp.prototype = Object.create(Enum.prototype);
  StencilOp.prototype.constructor = StencilOp;
  TriangleFace.prototype = Object.create(Enum.prototype);
  TriangleFace.prototype.constructor = TriangleFace;
  CompareMode.prototype = Object.create(Enum.prototype);
  CompareMode.prototype.constructor = CompareMode;
  FrontFace.prototype = Object.create(Enum.prototype);
  FrontFace.prototype.constructor = FrontFace;
  RenderBuffer.prototype = Object.create(BaseRenderBufferImpl.prototype);
  RenderBuffer.prototype.constructor = RenderBuffer;
  ShaderException.prototype = Object.create(RuntimeException.prototype);
  ShaderException.prototype.constructor = ShaderException;
  GlRenderBuffer.prototype = Object.create(RenderBuffer.prototype);
  GlRenderBuffer.prototype.constructor = GlRenderBuffer;
  GlBuffer.prototype = Object.create(Buffer.prototype);
  GlBuffer.prototype.constructor = GlBuffer;
  GlTexture.prototype = Object.create(Texture.prototype);
  GlTexture.prototype.constructor = GlTexture;
  _no_name_provided__313.prototype = Object.create(BaseRenderBufferImpl.prototype);
  _no_name_provided__313.prototype.constructor = _no_name_provided__313;
  AGOpengl.prototype = Object.create(AG.prototype);
  AGOpengl.prototype.constructor = AGOpengl;
  DummyAG.prototype = Object.create(AG.prototype);
  DummyAG.prototype.constructor = DummyAG;
  LogBaseAG.prototype = Object.create(DummyAG.prototype);
  LogBaseAG.prototype.constructor = LogBaseAG;
  PrintAG.prototype = Object.create(LogBaseAG.prototype);
  PrintAG.prototype.constructor = PrintAG;
  LogAG.prototype = Object.create(LogBaseAG.prototype);
  LogAG.prototype.constructor = LogAG;
  LogTexture.prototype = Object.create(Texture.prototype);
  LogTexture.prototype.constructor = LogTexture;
  LogBuffer.prototype = Object.create(Buffer.prototype);
  LogBuffer.prototype.constructor = LogBuffer;
  LogRenderBuffer.prototype = Object.create(RenderBuffer.prototype);
  LogRenderBuffer.prototype.constructor = LogRenderBuffer;
  GlslGenerator.prototype = Object.create(Visitor.prototype);
  GlslGenerator.prototype.constructor = GlslGenerator;
  Stms.prototype = Object.create(Stm.prototype);
  Stms.prototype.constructor = Stms;
  Set_0.prototype = Object.create(Stm.prototype);
  Set_0.prototype.constructor = Set_0;
  Discard.prototype = Object.create(Stm.prototype);
  Discard.prototype.constructor = Discard;
  If.prototype = Object.create(Stm.prototype);
  If.prototype.constructor = If;
  Binop.prototype = Object.create(Operand.prototype);
  Binop.prototype.constructor = Binop;
  IntLiteral.prototype = Object.create(Operand.prototype);
  IntLiteral.prototype.constructor = IntLiteral;
  FloatLiteral.prototype = Object.create(Operand.prototype);
  FloatLiteral.prototype.constructor = FloatLiteral;
  BoolLiteral.prototype = Object.create(Operand.prototype);
  BoolLiteral.prototype.constructor = BoolLiteral;
  Vector.prototype = Object.create(Operand.prototype);
  Vector.prototype.constructor = Vector;
  Swizzle.prototype = Object.create(Operand.prototype);
  Swizzle.prototype.constructor = Swizzle;
  ArrayAccess.prototype = Object.create(Operand.prototype);
  ArrayAccess.prototype.constructor = ArrayAccess;
  Func.prototype = Object.create(Operand.prototype);
  Func.prototype.constructor = Func;
  Variable.prototype = Object.create(Operand.prototype);
  Variable.prototype.constructor = Variable;
  Uniform.prototype = Object.create(Variable.prototype);
  Uniform.prototype.constructor = Uniform;
  Attribute.prototype = Object.create(Variable.prototype);
  Attribute.prototype.constructor = Attribute;
  VarType.prototype = Object.create(Enum.prototype);
  VarType.prototype.constructor = VarType;
  Varying.prototype = Object.create(Variable.prototype);
  Varying.prototype.constructor = Varying;
  Precision.prototype = Object.create(Enum.prototype);
  Precision.prototype.constructor = Precision;
  VertexShader.prototype = Object.create(Shader.prototype);
  VertexShader.prototype.constructor = VertexShader;
  Output_0.prototype = Object.create(Variable.prototype);
  Output_0.prototype.constructor = Output_0;
  FragmentShader.prototype = Object.create(Shader.prototype);
  FragmentShader.prototype.constructor = FragmentShader;
  ShaderType.prototype = Object.create(Enum.prototype);
  ShaderType.prototype.constructor = ShaderType;
  _no_name_provided__326.prototype = Object.create(Visitor.prototype);
  _no_name_provided__326.prototype.constructor = _no_name_provided__326;
  _no_name_provided__327.prototype = Object.create(Visitor.prototype);
  _no_name_provided__327.prototype.constructor = _no_name_provided__327;
  Temp_0.prototype = Object.create(Variable.prototype);
  Temp_0.prototype.constructor = Temp_0;
  VarKind.prototype = Object.create(Enum.prototype);
  VarKind.prototype.constructor = VarKind;
  PreventDefaultException.prototype = Object.create(Exception.prototype);
  PreventDefaultException.prototype.constructor = PreventDefaultException;
  Type_4.prototype = Object.create(Enum.prototype);
  Type_4.prototype.constructor = Type_4;
  ScrollDeltaMode.prototype = Object.create(Enum.prototype);
  ScrollDeltaMode.prototype.constructor = ScrollDeltaMode;
  MouseEvent_0.prototype = Object.create(Event_0.prototype);
  MouseEvent_0.prototype.constructor = MouseEvent_0;
  ReshapeEvent.prototype = Object.create(Event_0.prototype);
  ReshapeEvent.prototype.constructor = ReshapeEvent;
  Type_5.prototype = Object.create(Enum.prototype);
  Type_5.prototype.constructor = Type_5;
  KeyEvent.prototype = Object.create(Event_0.prototype);
  KeyEvent.prototype.constructor = KeyEvent;
  GamePadUpdateEvent.prototype = Object.create(Event_0.prototype);
  GamePadUpdateEvent.prototype.constructor = GamePadUpdateEvent;
  GamePadStickEvent.prototype = Object.create(Event_0.prototype);
  GamePadStickEvent.prototype.constructor = GamePadStickEvent;
  Type_6.prototype = Object.create(Enum.prototype);
  Type_6.prototype.constructor = Type_6;
  GamePadButtonEvent.prototype = Object.create(Event_0.prototype);
  GamePadButtonEvent.prototype.constructor = GamePadButtonEvent;
  Type_7.prototype = Object.create(Enum.prototype);
  Type_7.prototype.constructor = Type_7;
  GamePadConnectionEvent.prototype = Object.create(Event_0.prototype);
  GamePadConnectionEvent.prototype.constructor = GamePadConnectionEvent;
  Type_8.prototype = Object.create(Enum.prototype);
  Type_8.prototype.constructor = Type_8;
  TouchEvent_0.prototype = Object.create(Event_0.prototype);
  TouchEvent_0.prototype.constructor = TouchEvent_0;
  Status.prototype = Object.create(Enum.prototype);
  Status.prototype.constructor = Status;
  Kind_2.prototype = Object.create(Enum.prototype);
  Kind_2.prototype.constructor = Kind_2;
  ResumeEvent.prototype = Object.create(Event_0.prototype);
  ResumeEvent.prototype.constructor = ResumeEvent;
  PauseEvent.prototype = Object.create(Event_0.prototype);
  PauseEvent.prototype.constructor = PauseEvent;
  StopEvent.prototype = Object.create(Event_0.prototype);
  StopEvent.prototype.constructor = StopEvent;
  DestroyEvent.prototype = Object.create(Event_0.prototype);
  DestroyEvent.prototype.constructor = DestroyEvent;
  RenderEvent.prototype = Object.create(Event_0.prototype);
  RenderEvent.prototype.constructor = RenderEvent;
  InitEvent.prototype = Object.create(Event_0.prototype);
  InitEvent.prototype.constructor = InitEvent;
  DisposeEvent.prototype = Object.create(Event_0.prototype);
  DisposeEvent.prototype.constructor = DisposeEvent;
  FullScreenEvent.prototype = Object.create(Event_0.prototype);
  FullScreenEvent.prototype.constructor = FullScreenEvent;
  Mode.prototype = Object.create(Enum.prototype);
  Mode.prototype.constructor = Mode;
  Type_9.prototype = Object.create(Enum.prototype);
  Type_9.prototype.constructor = Type_9;
  DropFileEvent.prototype = Object.create(Event_0.prototype);
  DropFileEvent.prototype.constructor = DropFileEvent;
  StandardGamepadMapping.prototype = Object.create(GamepadMapping.prototype);
  StandardGamepadMapping.prototype.constructor = StandardGamepadMapping;
  Companion_172.prototype = Object.create(StandardGamepadMapping.prototype);
  Companion_172.prototype.constructor = Companion_172;
  GameButton.prototype = Object.create(Enum.prototype);
  GameButton.prototype.constructor = GameButton;
  MouseButton.prototype = Object.create(Enum.prototype);
  MouseButton.prototype.constructor = MouseButton;
  Key_6.prototype = Object.create(Enum.prototype);
  Key_6.prototype.constructor = Key_6;
  GameStick.prototype = Object.create(Enum.prototype);
  GameStick.prototype.constructor = GameStick;
  Cursor.prototype = Object.create(Enum.prototype);
  Cursor.prototype.constructor = Cursor;
  Quality.prototype = Object.create(Enum.prototype);
  Quality.prototype.constructor = Quality;
  _no_name_provided__334.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__334.prototype.constructor = _no_name_provided__334;
  $waitCloseCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $waitCloseCOROUTINE$0.prototype.constructor = $waitCloseCOROUTINE$0;
  $loopCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $loopCOROUTINE$1.prototype.constructor = $loopCOROUTINE$1;
  GameWindow.prototype = Object.create(Mixin_2.prototype);
  GameWindow.prototype.constructor = GameWindow;
  GameWindowCoroutineDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  GameWindowCoroutineDispatcher.prototype.constructor = GameWindowCoroutineDispatcher;
  Fixed.prototype = Object.create(Length.prototype);
  Fixed.prototype.constructor = Fixed;
  PT.prototype = Object.create(Fixed.prototype);
  PT.prototype.constructor = PT;
  KmlGlJsCanvas.prototype = Object.create(KmlGlWithExtensions.prototype);
  KmlGlJsCanvas.prototype.constructor = KmlGlJsCanvas;
  AGWebgl.prototype = Object.create(AGOpengl.prototype);
  AGWebgl.prototype.constructor = AGWebgl;
  Nimbus_111_1420_Safari_GamepadMapping.prototype = Object.create(GamepadMapping.prototype);
  Nimbus_111_1420_Safari_GamepadMapping.prototype.constructor = Nimbus_111_1420_Safari_GamepadMapping;
  NodeJsGameWindow.prototype = Object.create(GameWindow.prototype);
  NodeJsGameWindow.prototype.constructor = NodeJsGameWindow;
  _no_name_provided__351.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__351.prototype.constructor = _no_name_provided__351;
  _no_name_provided__352.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__352.prototype.constructor = _no_name_provided__352;
  $loopCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $loopCOROUTINE$2.prototype.constructor = $loopCOROUTINE$2;
  BrowserGameWindow.prototype = Object.create(GameWindow.prototype);
  BrowserGameWindow.prototype.constructor = BrowserGameWindow;
  $tryReadInfoCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $tryReadInfoCOROUTINE$0.prototype.constructor = $tryReadInfoCOROUTINE$0;
  $decodeStreamCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeStreamCOROUTINE$1.prototype.constructor = $decodeStreamCOROUTINE$1;
  $decodeStreamOrErrorCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeStreamOrErrorCOROUTINE$2.prototype.constructor = $decodeStreamOrErrorCOROUTINE$2;
  AudioFormats.prototype = Object.create(AudioFormat.prototype);
  AudioFormats.prototype.constructor = AudioFormats;
  $encodeToByteArrayCOROUTINE$5.prototype = Object.create(CoroutineImpl_0.prototype);
  $encodeToByteArrayCOROUTINE$5.prototype.constructor = $encodeToByteArrayCOROUTINE$5;
  InvalidAudioFormatException.prototype = Object.create(RuntimeException.prototype);
  InvalidAudioFormatException.prototype.constructor = InvalidAudioFormatException;
  MP3Base.prototype = Object.create(AudioFormat.prototype);
  MP3Base.prototype.constructor = MP3Base;
  MP3.prototype = Object.create(MP3Base.prototype);
  MP3.prototype.constructor = MP3;
  Companion_183.prototype = Object.create(MP3.prototype);
  Companion_183.prototype.constructor = Companion_183;
  ChannelMode.prototype = Object.create(Enum.prototype);
  ChannelMode.prototype.constructor = ChannelMode;
  $_getDurationCOROUTINE$8.prototype = Object.create(CoroutineImpl_0.prototype);
  $_getDurationCOROUTINE$8.prototype.constructor = $_getDurationCOROUTINE$8;
  $skipID3v2TagCOROUTINE$9.prototype = Object.create(CoroutineImpl_0.prototype);
  $skipID3v2TagCOROUTINE$9.prototype.constructor = $skipID3v2TagCOROUTINE$9;
  $tryReadInfoCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $tryReadInfoCOROUTINE$6.prototype.constructor = $tryReadInfoCOROUTINE$6;
  OggBase.prototype = Object.create(AudioFormat.prototype);
  OggBase.prototype.constructor = OggBase;
  OGG.prototype = Object.create(OggBase.prototype);
  OGG.prototype.constructor = OGG;
  Companion_186.prototype = Object.create(OGG.prototype);
  Companion_186.prototype.constructor = Companion_186;
  $tryReadInfoCOROUTINE$11.prototype = Object.create(CoroutineImpl_0.prototype);
  $tryReadInfoCOROUTINE$11.prototype.constructor = $tryReadInfoCOROUTINE$11;
  $parseCOROUTINE$12.prototype = Object.create(CoroutineImpl_0.prototype);
  $parseCOROUTINE$12.prototype.constructor = $parseCOROUTINE$12;
  $readCOROUTINE$15.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$15.prototype.constructor = $readCOROUTINE$15;
  $cloneCOROUTINE$16.prototype = Object.create(CoroutineImpl_0.prototype);
  $cloneCOROUTINE$16.prototype.constructor = $cloneCOROUTINE$16;
  WAV.prototype = Object.create(AudioFormat.prototype);
  WAV.prototype.constructor = WAV;
  Companion_187.prototype = Object.create(WAV.prototype);
  Companion_187.prototype.constructor = Companion_187;
  WavAudioStream.prototype = Object.create(AudioStream.prototype);
  WavAudioStream.prototype.constructor = WavAudioStream;
  _no_name_provided__382.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__382.prototype.constructor = _no_name_provided__382;
  $tryReadInfoCOROUTINE$13.prototype = Object.create(CoroutineImpl_0.prototype);
  $tryReadInfoCOROUTINE$13.prototype.constructor = $tryReadInfoCOROUTINE$13;
  $decodeStreamCOROUTINE$14.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeStreamCOROUTINE$14.prototype.constructor = $decodeStreamCOROUTINE$14;
  $encodeCOROUTINE$17.prototype = Object.create(CoroutineImpl_0.prototype);
  $encodeCOROUTINE$17.prototype.constructor = $encodeCOROUTINE$17;
  $parseCOROUTINE$18.prototype = Object.create(CoroutineImpl_0.prototype);
  $parseCOROUTINE$18.prototype.constructor = $parseCOROUTINE$18;
  $riffCOROUTINE$19.prototype = Object.create(CoroutineImpl_0.prototype);
  $riffCOROUTINE$19.prototype.constructor = $riffCOROUTINE$19;
  AudioDataStream.prototype = Object.create(AudioStream.prototype);
  AudioDataStream.prototype.constructor = AudioDataStream;
  $toDataCOROUTINE$21.prototype = Object.create(CoroutineImpl_0.prototype);
  $toDataCOROUTINE$21.prototype.constructor = $toDataCOROUTINE$21;
  $waitCOROUTINE$22.prototype = Object.create(CoroutineImpl_0.prototype);
  $waitCOROUTINE$22.prototype.constructor = $waitCOROUTINE$22;
  _no_name_provided__385.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__385.prototype.constructor = _no_name_provided__385;
  $createSoundCOROUTINE$23.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$23.prototype.constructor = $createSoundCOROUTINE$23;
  $createSoundCOROUTINE$24.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$24.prototype.constructor = $createSoundCOROUTINE$24;
  $createSoundCOROUTINE$25.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$25.prototype.constructor = $createSoundCOROUTINE$25;
  $createSoundCOROUTINE$26.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$26.prototype.constructor = $createSoundCOROUTINE$26;
  _no_name_provided__386.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__386.prototype.constructor = _no_name_provided__386;
  _no_name_provided__387.prototype = Object.create(SoundChannel.prototype);
  _no_name_provided__387.prototype.constructor = _no_name_provided__387;
  SoundAudioStream.prototype = Object.create(Sound.prototype);
  SoundAudioStream.prototype.constructor = SoundAudioStream;
  $createSoundCOROUTINE$32.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$32.prototype.constructor = $createSoundCOROUTINE$32;
  $createSoundCOROUTINE$33.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$33.prototype.constructor = $createSoundCOROUTINE$33;
  HtmlNativeSoundProvider.prototype = Object.create(NativeSoundProvider.prototype);
  HtmlNativeSoundProvider.prototype.constructor = HtmlNativeSoundProvider;
  _no_name_provided__389.prototype = Object.create(SoundChannel.prototype);
  _no_name_provided__389.prototype.constructor = _no_name_provided__389;
  AudioBufferSound.prototype = Object.create(Sound.prototype);
  AudioBufferSound.prototype.constructor = AudioBufferSound;
  _no_name_provided__394.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__394.prototype.constructor = _no_name_provided__394;
  $loadSoundCOROUTINE$36.prototype = Object.create(CoroutineImpl_0.prototype);
  $loadSoundCOROUTINE$36.prototype.constructor = $loadSoundCOROUTINE$36;
  $loadSoundCOROUTINE$37.prototype = Object.create(CoroutineImpl_0.prototype);
  $loadSoundCOROUTINE$37.prototype.constructor = $loadSoundCOROUTINE$37;
  $addCOROUTINE$38.prototype = Object.create(CoroutineImpl_0.prototype);
  $addCOROUTINE$38.prototype.constructor = $addCOROUTINE$38;
  JsPlatformAudioOutput.prototype = Object.create(PlatformAudioOutput.prototype);
  JsPlatformAudioOutput.prototype.constructor = JsPlatformAudioOutput;
  NotMappedException.prototype = Object.create(RuntimeException.prototype);
  NotMappedException.prototype.constructor = NotMappedException;
  _no_name_provided__406.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__406.prototype.constructor = _no_name_provided__406;
  $getProviderOrNullCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $getProviderOrNullCOROUTINE$0.prototype.constructor = $getProviderOrNullCOROUTINE$0;
  $getProviderCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $getProviderCOROUTINE$1.prototype.constructor = $getProviderCOROUTINE$1;
  $getCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $getCOROUTINE$3.prototype.constructor = $getCOROUTINE$3;
  $createdCOROUTINE$5.prototype = Object.create(CoroutineImpl_0.prototype);
  $createdCOROUTINE$5.prototype.constructor = $createdCOROUTINE$5;
  $deinitCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $deinitCOROUTINE$6.prototype.constructor = $deinitCOROUTINE$6;
  $deinitCOROUTINE$7.prototype = Object.create(CoroutineImpl_0.prototype);
  $deinitCOROUTINE$7.prototype.constructor = $deinitCOROUTINE$7;
  $getCOROUTINE$9.prototype = Object.create(CoroutineImpl_0.prototype);
  $getCOROUTINE$9.prototype.constructor = $getCOROUTINE$9;
  $deinitCOROUTINE$10.prototype = Object.create(CoroutineImpl_0.prototype);
  $deinitCOROUTINE$10.prototype.constructor = $deinitCOROUTINE$10;
  $getCOROUTINE$11.prototype = Object.create(CoroutineImpl_0.prototype);
  $getCOROUTINE$11.prototype.constructor = $getCOROUTINE$11;
  JsObjectMapper2.prototype = Object.create(ObjectMapper2.prototype);
  JsObjectMapper2.prototype.constructor = JsObjectMapper2;
  _no_name_provided__412.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__412.prototype.constructor = _no_name_provided__412;
  _no_name_provided__413.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__413.prototype.constructor = _no_name_provided__413;
  _no_name_provided__414.prototype = Object.create(Module.prototype);
  _no_name_provided__414.prototype.constructor = _no_name_provided__414;
  _no_name_provided__415.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__415.prototype.constructor = _no_name_provided__415;
  _no_name_provided__416.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__416.prototype.constructor = _no_name_provided__416;
  _no_name_provided__417.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__417.prototype.constructor = _no_name_provided__417;
  _no_name_provided__418.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__418.prototype.constructor = _no_name_provided__418;
  _no_name_provided__419.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__419.prototype.constructor = _no_name_provided__419;
  _no_name_provided__420.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__420.prototype.constructor = _no_name_provided__420;
  $invokeCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$0.prototype.constructor = $invokeCOROUTINE$0;
  $invokeCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$1.prototype.constructor = $invokeCOROUTINE$1;
  $prepareViewsCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $prepareViewsCOROUTINE$3.prototype.constructor = $prepareViewsCOROUTINE$3;
  View.prototype = Object.create(BaseView.prototype);
  View.prototype.constructor = View;
  AnBaseShape.prototype = Object.create(View.prototype);
  AnBaseShape.prototype.constructor = AnBaseShape;
  AnShape.prototype = Object.create(AnBaseShape.prototype);
  AnShape.prototype.constructor = AnShape;
  Container.prototype = Object.create(View.prototype);
  Container.prototype.constructor = Container;
  AnMovieClip.prototype = Object.create(Container.prototype);
  AnMovieClip.prototype.constructor = AnMovieClip;
  DummyView.prototype = Object.create(View.prototype);
  DummyView.prototype.constructor = DummyView;
  AnEmptyView.prototype = Object.create(DummyView.prototype);
  AnEmptyView.prototype.constructor = AnEmptyView;
  AnTextField.prototype = Object.create(Container.prototype);
  AnTextField.prototype.constructor = AnTextField;
  AnMorphShape.prototype = Object.create(AnBaseShape.prototype);
  AnMorphShape.prototype.constructor = AnMorphShape;
  _no_name_provided__433.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__433.prototype.constructor = _no_name_provided__433;
  AnSymbolEmpty.prototype = Object.create(AnSymbol.prototype);
  AnSymbolEmpty.prototype.constructor = AnSymbolEmpty;
  _no_name_provided__434.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__434.prototype.constructor = _no_name_provided__434;
  AnSymbolSound.prototype = Object.create(AnSymbol.prototype);
  AnSymbolSound.prototype.constructor = AnSymbolSound;
  AnTextFieldSymbol.prototype = Object.create(AnSymbol.prototype);
  AnTextFieldSymbol.prototype.constructor = AnTextFieldSymbol;
  AnSymbolBaseShape.prototype = Object.create(AnSymbol.prototype);
  AnSymbolBaseShape.prototype.constructor = AnSymbolBaseShape;
  AnSymbolShape.prototype = Object.create(AnSymbolBaseShape.prototype);
  AnSymbolShape.prototype.constructor = AnSymbolShape;
  AnSymbolMorphShape.prototype = Object.create(AnSymbolBaseShape.prototype);
  AnSymbolMorphShape.prototype.constructor = AnSymbolMorphShape;
  AnSymbolBitmap.prototype = Object.create(AnSymbol.prototype);
  AnSymbolBitmap.prototype.constructor = AnSymbolBitmap;
  AnSymbolMovieClip.prototype = Object.create(AnSymbol.prototype);
  AnSymbolMovieClip.prototype.constructor = AnSymbolMovieClip;
  AnDepthTimeline.prototype = Object.create(Timed.prototype);
  AnDepthTimeline.prototype.constructor = AnDepthTimeline;
  _no_name_provided__435.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__435.prototype.constructor = _no_name_provided__435;
  _no_name_provided__436.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__436.prototype.constructor = _no_name_provided__436;
  $executeCOROUTINE$8.prototype = Object.create(CoroutineImpl_0.prototype);
  $executeCOROUTINE$8.prototype.constructor = $executeCOROUTINE$8;
  NodeKind.prototype = Object.create(Enum.prototype);
  NodeKind.prototype.constructor = NodeKind;
  _no_name_provided__441.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__441.prototype.constructor = _no_name_provided__441;
  _no_name_provided__442.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__442.prototype.constructor = _no_name_provided__442;
  $executeCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $executeCOROUTINE$6.prototype.constructor = $executeCOROUTINE$6;
  AnimateCancellationException.prototype = Object.create(CancellationException.prototype);
  AnimateCancellationException.prototype.constructor = AnimateCancellationException;
  $animateCOROUTINE$9.prototype = Object.create(CoroutineImpl_0.prototype);
  $animateCOROUTINE$9.prototype.constructor = $animateCOROUTINE$9;
  $readLibraryCOROUTINE$11.prototype = Object.create(CoroutineImpl_0.prototype);
  $readLibraryCOROUTINE$11.prototype.constructor = $readLibraryCOROUTINE$11;
  _no_name_provided__444.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__444.prototype.constructor = _no_name_provided__444;
  _no_name_provided__445.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__445.prototype.constructor = _no_name_provided__445;
  $readAniCOROUTINE$10.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAniCOROUTINE$10.prototype.constructor = $readAniCOROUTINE$10;
  $readAnimationCOROUTINE$12.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAnimationCOROUTINE$12.prototype.constructor = $readAnimationCOROUTINE$12;
  _no_name_provided__456.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__456.prototype.constructor = _no_name_provided__456;
  _no_name_provided__457.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__457.prototype.constructor = _no_name_provided__457;
  _no_name_provided__458.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__458.prototype.constructor = _no_name_provided__458;
  $configureLoggerFromPropertiesCOROUTINE$13.prototype = Object.create(CoroutineImpl_0.prototype);
  $configureLoggerFromPropertiesCOROUTINE$13.prototype.constructor = $configureLoggerFromPropertiesCOROUTINE$13;
  Type_10.prototype = Object.create(Enum.prototype);
  Type_10.prototype.constructor = Type_10;
  $readParticleEmitterCOROUTINE$14.prototype = Object.create(CoroutineImpl_0.prototype);
  $readParticleEmitterCOROUTINE$14.prototype.constructor = $readParticleEmitterCOROUTINE$14;
  _no_name_provided__474.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__474.prototype.constructor = _no_name_provided__474;
  $forceLoadTextureCOROUTINE$16.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadTextureCOROUTINE$16.prototype.constructor = $forceLoadTextureCOROUTINE$16;
  $forceLoadSourceFileCOROUTINE$17.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadSourceFileCOROUTINE$17.prototype.constructor = $forceLoadSourceFileCOROUTINE$17;
  ParticleEmitterView.prototype = Object.create(View.prototype);
  ParticleEmitterView.prototype.constructor = ParticleEmitterView;
  _no_name_provided__495.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__495.prototype.constructor = _no_name_provided__495;
  $initCOROUTINE$18.prototype = Object.create(CoroutineImpl_0.prototype);
  $initCOROUTINE$18.prototype.constructor = $initCOROUTINE$18;
  $initCOROUTINE$21.prototype = Object.create(CoroutineImpl_0.prototype);
  $initCOROUTINE$21.prototype.constructor = $initCOROUTINE$21;
  $sceneAfterDestroyInternalCOROUTINE$22.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneAfterDestroyInternalCOROUTINE$22.prototype.constructor = $sceneAfterDestroyInternalCOROUTINE$22;
  EmptyScene.prototype = Object.create(Scene.prototype);
  EmptyScene.prototype.constructor = EmptyScene;
  _no_name_provided__499.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__499.prototype.constructor = _no_name_provided__499;
  _no_name_provided__500.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__500.prototype.constructor = _no_name_provided__500;
  _no_name_provided__501.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__501.prototype.constructor = _no_name_provided__501;
  _no_name_provided__503.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__503.prototype.constructor = _no_name_provided__503;
  _no_name_provided__504.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__504.prototype.constructor = _no_name_provided__504;
  _no_name_provided__505.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__505.prototype.constructor = _no_name_provided__505;
  $_changeToCOROUTINE$24.prototype = Object.create(CoroutineImpl_0.prototype);
  $_changeToCOROUTINE$24.prototype.constructor = $_changeToCOROUTINE$24;
  SceneContainer.prototype = Object.create(Container.prototype);
  SceneContainer.prototype.constructor = SceneContainer;
  TransitionView.prototype = Object.create(Container.prototype);
  TransitionView.prototype.constructor = TransitionView;
  Orientation.prototype = Object.create(Enum.prototype);
  Orientation.prototype.constructor = Orientation;
  Rectangle_1.prototype = Object.create(Shape_1.prototype);
  Rectangle_1.prototype.constructor = Rectangle_1;
  Ellipse_0.prototype = Object.create(Shape_1.prototype);
  Ellipse_0.prototype.constructor = Ellipse_0;
  PPoint.prototype = Object.create(Shape_1.prototype);
  PPoint.prototype.constructor = PPoint;
  Polygon_0.prototype = Object.create(Shape_1.prototype);
  Polygon_0.prototype.constructor = Polygon_0;
  Polyline_0.prototype = Object.create(Shape_1.prototype);
  Polyline_0.prototype.constructor = Polyline_0;
  Text_2.prototype = Object.create(Shape_1.prototype);
  Text_2.prototype.constructor = Text_2;
  DrawOrder.prototype = Object.create(Enum.prototype);
  DrawOrder.prototype.constructor = DrawOrder;
  Embedded.prototype = Object.create(Image_0.prototype);
  Embedded.prototype.constructor = Embedded;
  External_0.prototype = Object.create(Image_0.prototype);
  External_0.prototype.constructor = External_0;
  StringT.prototype = Object.create(Property_0.prototype);
  StringT.prototype.constructor = StringT;
  IntT.prototype = Object.create(Property_0.prototype);
  IntT.prototype.constructor = IntT;
  FloatT.prototype = Object.create(Property_0.prototype);
  FloatT.prototype.constructor = FloatT;
  BoolT.prototype = Object.create(Property_0.prototype);
  BoolT.prototype.constructor = BoolT;
  ColorT.prototype = Object.create(Property_0.prototype);
  ColorT.prototype.constructor = ColorT;
  FileT.prototype = Object.create(Property_0.prototype);
  FileT.prototype.constructor = FileT;
  ObjectT.prototype = Object.create(Property_0.prototype);
  ObjectT.prototype.constructor = ObjectT;
  Tiles.prototype = Object.create(Layer.prototype);
  Tiles.prototype.constructor = Tiles;
  Objects.prototype = Object.create(Layer.prototype);
  Objects.prototype.constructor = Objects;
  Image.prototype = Object.create(Layer.prototype);
  Image.prototype.constructor = Image;
  Group.prototype = Object.create(Layer.prototype);
  Group.prototype.constructor = Group;
  Orientation_0.prototype = Object.create(Enum.prototype);
  Orientation_0.prototype.constructor = Orientation_0;
  RenderOrder.prototype = Object.create(Enum.prototype);
  RenderOrder.prototype.constructor = RenderOrder;
  StaggerAxis.prototype = Object.create(Enum.prototype);
  StaggerAxis.prototype.constructor = StaggerAxis;
  StaggerIndex.prototype = Object.create(Enum.prototype);
  StaggerIndex.prototype.constructor = StaggerIndex;
  ObjectAlignment.prototype = Object.create(Enum.prototype);
  ObjectAlignment.prototype.constructor = ObjectAlignment;
  TextHAlignment.prototype = Object.create(Enum.prototype);
  TextHAlignment.prototype.constructor = TextHAlignment;
  TextVAlignment.prototype = Object.create(Enum.prototype);
  TextVAlignment.prototype.constructor = TextVAlignment;
  Encoding.prototype = Object.create(Enum.prototype);
  Encoding.prototype.constructor = Encoding;
  Compression.prototype = Object.create(Enum.prototype);
  Compression.prototype.constructor = Compression;
  $readTiledMapCOROUTINE$25.prototype = Object.create(CoroutineImpl_0.prototype);
  $readTiledMapCOROUTINE$25.prototype.constructor = $readTiledMapCOROUTINE$25;
  $readTiledMapDataCOROUTINE$26.prototype = Object.create(CoroutineImpl_0.prototype);
  $readTiledMapDataCOROUTINE$26.prototype.constructor = $readTiledMapDataCOROUTINE$26;
  $toTiledSetCOROUTINE$27.prototype = Object.create(CoroutineImpl_0.prototype);
  $toTiledSetCOROUTINE$27.prototype.constructor = $toTiledSetCOROUTINE$27;
  TiledMapView.prototype = Object.create(Container.prototype);
  TiledMapView.prototype.constructor = TiledMapView;
  $forceLoadSourceFileCOROUTINE$28.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadSourceFileCOROUTINE$28.prototype.constructor = $forceLoadSourceFileCOROUTINE$28;
  TiledMapViewRef.prototype = Object.create(Container.prototype);
  TiledMapViewRef.prototype.constructor = TiledMapViewRef;
  _no_name_provided__524.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__524.prototype.constructor = _no_name_provided__524;
  $tweenCOROUTINE$30.prototype = Object.create(CoroutineImpl_0.prototype);
  $tweenCOROUTINE$30.prototype.constructor = $tweenCOROUTINE$30;
  _no_name_provided__530.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__530.prototype.constructor = _no_name_provided__530;
  _no_name_provided__531.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__531.prototype.constructor = _no_name_provided__531;
  Serializer.prototype = Object.create(KTreeSerializerExt.prototype);
  Serializer.prototype.constructor = Serializer;
  _no_name_provided__533.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__533.prototype.constructor = _no_name_provided__533;
  _no_name_provided__535.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__535.prototype.constructor = _no_name_provided__535;
  FixedSizeContainer.prototype = Object.create(Container.prototype);
  FixedSizeContainer.prototype.constructor = FixedSizeContainer;
  UIView.prototype = Object.create(FixedSizeContainer.prototype);
  UIView.prototype.constructor = UIView;
  UIButton.prototype = Object.create(UIView.prototype);
  UIButton.prototype.constructor = UIButton;
  Serializer_0.prototype = Object.create(KTreeSerializerExt.prototype);
  Serializer_0.prototype.constructor = Serializer_0;
  UIBaseCheckBox.prototype = Object.create(UIView.prototype);
  UIBaseCheckBox.prototype.constructor = UIBaseCheckBox;
  UICheckBox.prototype = Object.create(UIBaseCheckBox.prototype);
  UICheckBox.prototype.constructor = UICheckBox;
  _no_name_provided__539.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__539.prototype.constructor = _no_name_provided__539;
  _no_name_provided__540.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__540.prototype.constructor = _no_name_provided__540;
  _no_name_provided__541.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__541.prototype.constructor = _no_name_provided__541;
  _no_name_provided__542.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__542.prototype.constructor = _no_name_provided__542;
  _no_name_provided__543.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__543.prototype.constructor = _no_name_provided__543;
  _no_name_provided__546.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__546.prototype.constructor = _no_name_provided__546;
  _no_name_provided__548.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__548.prototype.constructor = _no_name_provided__548;
  _no_name_provided__550.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__550.prototype.constructor = _no_name_provided__550;
  _no_name_provided__552.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__552.prototype.constructor = _no_name_provided__552;
  _no_name_provided__554.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__554.prototype.constructor = _no_name_provided__554;
  Serializer_1.prototype = Object.create(KTreeSerializerExt.prototype);
  Serializer_1.prototype.constructor = Serializer_1;
  UIProgressBar.prototype = Object.create(UIView.prototype);
  UIProgressBar.prototype.constructor = UIProgressBar;
  UiSkinKind.prototype = Object.create(Enum.prototype);
  UiSkinKind.prototype.constructor = UiSkinKind;
  $forceLoadSourceFileCOROUTINE$31.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadSourceFileCOROUTINE$31.prototype.constructor = $forceLoadSourceFileCOROUTINE$31;
  AnimationViewRef.prototype = Object.create(Container.prototype);
  AnimationViewRef.prototype.constructor = AnimationViewRef;
  RectBase.prototype = Object.create(View.prototype);
  RectBase.prototype.constructor = RectBase;
  BaseImage.prototype = Object.create(RectBase.prototype);
  BaseImage.prototype.constructor = BaseImage;
  BaseGraphics.prototype = Object.create(BaseImage.prototype);
  BaseGraphics.prototype.constructor = BaseGraphics;
  BlendMode_0.prototype = Object.create(Enum.prototype);
  BlendMode_0.prototype.constructor = BlendMode_0;
  Graphics.prototype = Object.create(BaseGraphics.prototype);
  Graphics.prototype.constructor = Graphics;
  ShapeView.prototype = Object.create(Graphics.prototype);
  ShapeView.prototype.constructor = ShapeView;
  Ellipse_1.prototype = Object.create(ShapeView.prototype);
  Ellipse_1.prototype.constructor = Ellipse_1;
  HitTestDirection.prototype = Object.create(Enum.prototype);
  HitTestDirection.prototype.constructor = HitTestDirection;
  $forceLoadSourceFileCOROUTINE$32.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadSourceFileCOROUTINE$32.prototype.constructor = $forceLoadSourceFileCOROUTINE$32;
  Image_1.prototype = Object.create(BaseImage.prototype);
  Image_1.prototype.constructor = Image_1;
  $forceLoadSourceFileCOROUTINE$33.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadSourceFileCOROUTINE$33.prototype.constructor = $forceLoadSourceFileCOROUTINE$33;
  NinePatchEx.prototype = Object.create(View.prototype);
  NinePatchEx.prototype.constructor = NinePatchEx;
  SolidRect.prototype = Object.create(RectBase.prototype);
  SolidRect.prototype.constructor = SolidRect;
  Sprite.prototype = Object.create(BaseImage.prototype);
  Sprite.prototype.constructor = Sprite;
  Stage.prototype = Object.create(Container.prototype);
  Stage.prototype.constructor = Stage;
  $ktreeToViewTreeCOROUTINE$34.prototype = Object.create(CoroutineImpl_0.prototype);
  $ktreeToViewTreeCOROUTINE$34.prototype.constructor = $ktreeToViewTreeCOROUTINE$34;
  Serializer_2.prototype = Object.create(KTreeSerializerExt.prototype);
  Serializer_2.prototype.constructor = Serializer_2;
  _no_name_provided__612.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__612.prototype.constructor = _no_name_provided__612;
  $forceLoadFontSourceCOROUTINE$35.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadFontSourceCOROUTINE$35.prototype.constructor = $forceLoadFontSourceCOROUTINE$35;
  Text_3.prototype = Object.create(Container.prototype);
  Text_3.prototype.constructor = Text_3;
  TextOld.prototype = Object.create(View.prototype);
  TextOld.prototype.constructor = TextOld;
  $forceLoadSourceFileCOROUTINE$36.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadSourceFileCOROUTINE$36.prototype.constructor = $forceLoadSourceFileCOROUTINE$36;
  TreeViewRef.prototype = Object.create(Container.prototype);
  TreeViewRef.prototype.constructor = TreeViewRef;
  $forceLoadSourceFileCOROUTINE$37.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadSourceFileCOROUTINE$37.prototype.constructor = $forceLoadSourceFileCOROUTINE$37;
  VectorImage.prototype = Object.create(BaseGraphics.prototype);
  VectorImage.prototype.constructor = VectorImage;
  CollisionKind.prototype = Object.create(Enum.prototype);
  CollisionKind.prototype.constructor = CollisionKind;
  _no_name_provided__622.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__622.prototype.constructor = _no_name_provided__622;
  _no_name_provided__625.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__625.prototype.constructor = _no_name_provided__625;
  $closeSuspendCOROUTINE$38.prototype = Object.create(CoroutineImpl_0.prototype);
  $closeSuspendCOROUTINE$38.prototype.constructor = $closeSuspendCOROUTINE$38;
  $viewsCOROUTINE$39.prototype = Object.create(CoroutineImpl_0.prototype);
  $viewsCOROUTINE$39.prototype.constructor = $viewsCOROUTINE$39;
  TransitionFilter.prototype = Object.create(ShaderFilter.prototype);
  TransitionFilter.prototype.constructor = TransitionFilter;
  WaveFilter.prototype = Object.create(ShaderFilter.prototype);
  WaveFilter.prototype.constructor = WaveFilter;
  $ktreeToViewTreeCOROUTINE$40.prototype = Object.create(CoroutineImpl_0.prototype);
  $ktreeToViewTreeCOROUTINE$40.prototype.constructor = $ktreeToViewTreeCOROUTINE$40;
  $ktreeToViewTreeInternalCOROUTINE$41.prototype = Object.create(CoroutineImpl_0.prototype);
  $ktreeToViewTreeInternalCOROUTINE$41.prototype.constructor = $ktreeToViewTreeInternalCOROUTINE$41;
  KTreeRoot.prototype = Object.create(FixedSizeContainer.prototype);
  KTreeRoot.prototype.constructor = KTreeRoot;
  $readKTreeCOROUTINE$42.prototype = Object.create(CoroutineImpl_0.prototype);
  $readKTreeCOROUTINE$42.prototype.constructor = $readKTreeCOROUTINE$42;
  $readKTreeCOROUTINE$43.prototype = Object.create(CoroutineImpl_0.prototype);
  $readKTreeCOROUTINE$43.prototype.constructor = $readKTreeCOROUTINE$43;
  Repeat.prototype = Object.create(Enum.prototype);
  Repeat.prototype.constructor = Repeat;
  TileMap.prototype = Object.create(View.prototype);
  TileMap.prototype.constructor = TileMap;
  Key_7.prototype = Object.create(Key_1.prototype);
  Key_7.prototype.constructor = Key_7;
  Box2dWorldComponent.prototype = Object.create(FixedUpdateComponent.prototype);
  Box2dWorldComponent.prototype.constructor = Box2dWorldComponent;
  $loadCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $loadCOROUTINE$0.prototype.constructor = $loadCOROUTINE$0;
  _no_name_provided__655.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__655.prototype.constructor = _no_name_provided__655;
  _no_name_provided__656.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__656.prototype.constructor = _no_name_provided__656;
  _no_name_provided__657.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__657.prototype.constructor = _no_name_provided__657;
  _no_name_provided__658.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__658.prototype.constructor = _no_name_provided__658;
  _no_name_provided__659.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__659.prototype.constructor = _no_name_provided__659;
  $configureCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $configureCOROUTINE$1.prototype.constructor = $configureCOROUTINE$1;
  GameModule.prototype = Object.create(Module.prototype);
  GameModule.prototype.constructor = GameModule;
  BaseEntity.prototype = Object.create(Sprite.prototype);
  BaseEntity.prototype.constructor = BaseEntity;
  BeachBall.prototype = Object.create(Sprite.prototype);
  BeachBall.prototype.constructor = BeachBall;
  Debris.prototype = Object.create(BaseEntity.prototype);
  Debris.prototype.constructor = Debris;
  Breakable.prototype = Object.create(BaseEntity.prototype);
  Breakable.prototype.constructor = Breakable;
  Brick.prototype = Object.create(BaseEntity.prototype);
  Brick.prototype.constructor = Brick;
  Bumper.prototype = Object.create(BaseEntity.prototype);
  Bumper.prototype.constructor = Bumper;
  Coin.prototype = Object.create(BaseEntity.prototype);
  Coin.prototype.constructor = Coin;
  BlockedExit.prototype = Object.create(BaseEntity.prototype);
  BlockedExit.prototype.constructor = BlockedExit;
  LeftFlipper.prototype = Object.create(Sprite.prototype);
  LeftFlipper.prototype.constructor = LeftFlipper;
  RightFlipper.prototype = Object.create(Sprite.prototype);
  RightFlipper.prototype.constructor = RightFlipper;
  Spring.prototype = Object.create(BaseEntity.prototype);
  Spring.prototype.constructor = Spring;
  Teleport.prototype = Object.create(BaseEntity.prototype);
  Teleport.prototype.constructor = Teleport;
  TeleportDestination.prototype = Object.create(BaseEntity.prototype);
  TeleportDestination.prototype.constructor = TeleportDestination;
  TextEntity.prototype = Object.create(Text_3.prototype);
  TextEntity.prototype.constructor = TextEntity;
  Tunnel.prototype = Object.create(Sprite.prototype);
  Tunnel.prototype.constructor = Tunnel;
  Vehicle.prototype = Object.create(BaseEntity.prototype);
  Vehicle.prototype.constructor = Vehicle;
  _no_name_provided__675.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__675.prototype.constructor = _no_name_provided__675;
  Water.prototype = Object.create(BaseEntity.prototype);
  Water.prototype.constructor = Water;
  _no_name_provided__676.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__676.prototype.constructor = _no_name_provided__676;
  _no_name_provided__677.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__677.prototype.constructor = _no_name_provided__677;
  $sceneInitCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneInitCOROUTINE$2.prototype.constructor = $sceneInitCOROUTINE$2;
  EndScene.prototype = Object.create(Scene.prototype);
  EndScene.prototype.constructor = EndScene;
  _no_name_provided__679.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__679.prototype.constructor = _no_name_provided__679;
  _no_name_provided__680.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__680.prototype.constructor = _no_name_provided__680;
  $sceneInitCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneInitCOROUTINE$3.prototype.constructor = $sceneInitCOROUTINE$3;
  IntroScene.prototype = Object.create(Scene.prototype);
  IntroScene.prototype.constructor = IntroScene;
  $sceneInitCOROUTINE$4.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneInitCOROUTINE$4.prototype.constructor = $sceneInitCOROUTINE$4;
  LoadScene.prototype = Object.create(Scene.prototype);
  LoadScene.prototype.constructor = LoadScene;
  _no_name_provided__682.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__682.prototype.constructor = _no_name_provided__682;
  $sceneInitCOROUTINE$5.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneInitCOROUTINE$5.prototype.constructor = $sceneInitCOROUTINE$5;
  PlayScene.prototype = Object.create(Scene.prototype);
  PlayScene.prototype.constructor = PlayScene;
  _no_name_provided__684.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__684.prototype.constructor = _no_name_provided__684;
  _no_name_provided__685.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__685.prototype.constructor = _no_name_provided__685;
  $sceneInitCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneInitCOROUTINE$6.prototype.constructor = $sceneInitCOROUTINE$6;
  TitleScene.prototype = Object.create(Scene.prototype);
  TitleScene.prototype.constructor = TitleScene;
  Hud.prototype = Object.create(Container.prototype);
  Hud.prototype.constructor = Hud;
  PlayField.prototype = Object.create(Container.prototype);
  PlayField.prototype.constructor = PlayField;
  function indexOf(_this_, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last_1 = _this_.length - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[index_0] == null) {
            return index_0;
          }}
         while (inductionVariable <= last_1);
    } else {
      var inductionVariable_0 = 0;
      var last_2 = _this_.length - 1 | 0;
      if (inductionVariable_0 <= last_2)
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals_1(element, _this_[index_1])) {
            return index_1;
          }}
         while (inductionVariable_0 <= last_2);
    }
    return -1;
  }
  function toList(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList(_this_);
    }
  }
  function toCollection(_this_, destination) {
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      destination.add_2bq_k$(item);
      Unit_getInstance();
    }
    return destination;
  }
  function joinToString(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function contains(_this_, element) {
    return indexOf_0(_this_, element) >= 0;
  }
  function indexOf_0(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this_[index_0]) {
          return index_0;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function getOrNull(_this_, index_0) {
    return (index_0 >= 0 ? index_0 <= _get_lastIndex_(_this_) : false) ? _this_[index_0] : null;
  }
  function lastOrNull(_this_) {
    var tmp;
    if (_this_.length === 0) {
      tmp = null;
    } else {
      {
        tmp = _this_[_this_.length - 1 | 0];
      }
    }
    return tmp;
  }
  function getOrNull_0(_this_, index_0) {
    return (index_0 >= 0 ? index_0 <= _get_lastIndex__1(_this_) : false) ? _this_[index_0] : null;
  }
  function contains_0(_this_, element) {
    return indexOf(_this_, element) >= 0;
  }
  function toSet(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_[0]);
      default:return toCollection(_this_, LinkedHashSet_init_$Create$_1(mapCapacity(_this_.length)));
    }
  }
  function toMutableList(_this_) {
    return ArrayList_init_$Create$_1(asCollection(_this_));
  }
  function joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_v1o70a_k$(prefix);
    Unit_getInstance();
    var count_0 = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    $l$break: while (inductionVariable < last_1) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count_0 = count_0 + 1 | 0;
      if (count_0 > 1) {
        buffer.append_v1o70a_k$(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count_0 <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count_0 > limit : false) {
      buffer.append_v1o70a_k$(truncated);
      Unit_getInstance();
    }buffer.append_v1o70a_k$(postfix);
    Unit_getInstance();
    return buffer;
  }
  function joinTo$default(_this_, buffer, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      separator = ', ';
    if (!(($mask0 & 4) === 0))
      prefix = '';
    if (!(($mask0 & 8) === 0))
      postfix = '';
    if (!(($mask0 & 16) === 0))
      limit = -1;
    if (!(($mask0 & 32) === 0))
      truncated = '...';
    if (!(($mask0 & 64) === 0))
      transform = null;
    return joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform);
  }
  function _get_lastIndex_(_this_) {
    return _this_.length - 1 | 0;
  }
  function _get_lastIndex__0(_this_) {
    return _this_.length - 1 | 0;
  }
  function _get_lastIndex__1(_this_) {
    return _this_.length - 1 | 0;
  }
  function _get_lastIndex__2(_this_) {
    return _this_.length - 1 | 0;
  }
  function contains_1(_this_, element) {
    return indexOf_1(_this_, element) >= 0;
  }
  function single(_this_) {
    var tmp0_subject = _this_.length;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('Array is empty.');
      case 1:
        tmp = _this_[0];
        break;
      default:throw IllegalArgumentException_init_$Create$('Array has more than one element.');
    }
    return tmp;
  }
  function contains_2(_this_, element) {
    return indexOf_2(_this_, element) >= 0;
  }
  function indexOf_1(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element.equals(_this_[index_0])) {
          return index_0;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function indexOf_2(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this_[index_0]) {
          return index_0;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function _get_indices_(_this_) {
    return new IntRange(0, _get_lastIndex__3(_this_));
  }
  function _get_lastIndex__3(_this_) {
    return _this_.length - 1 | 0;
  }
  function contains_3(_this_, element) {
    return indexOf_3(_this_, element) >= 0;
  }
  function contains_4(_this_, element) {
    return indexOf_4(_this_, element) >= 0;
  }
  function indexOf_3(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this_[index_0]) {
          return index_0;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function indexOf_4(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element.equals(_this_[index_0])) {
          return index_0;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function take(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }if (n === 0)
      return emptyList();
    if (n >= _this_.length)
      return toList_2(_this_);
    if (n === 1)
      return listOf_0(_this_[0]);
    var count_0 = 0;
    var list = ArrayList_init_$Create$_0(n);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    $l$break: while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_2bq_k$(item);
      Unit_getInstance();
      count_0 = count_0 + 1 | 0;
      if (count_0 === n)
        break $l$break;
      else {
      }
    }
    return list;
  }
  function take_0(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }if (n === 0)
      return emptyList();
    if (n >= _this_.length)
      return toList_0(_this_);
    if (n === 1)
      return listOf_0(_this_[0]);
    var count_0 = 0;
    var list = ArrayList_init_$Create$_0(n);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    $l$break: while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_2bq_k$(item);
      Unit_getInstance();
      count_0 = count_0 + 1 | 0;
      if (count_0 === n)
        break $l$break;
      else {
      }
    }
    return list;
  }
  function sortedArray(_this_) {
    if (_this_.length === 0)
      return _this_;
    else {
    }
    var tmp0_apply_0 = _this_.slice();
    sort_0(tmp0_apply_0);
    return tmp0_apply_0;
  }
  function sortedArray_0(_this_) {
    if (_this_.length === 0)
      return _this_;
    else {
    }
    var tmp0_apply_0 = copyOf_3(_this_);
    sort_1(tmp0_apply_0);
    return tmp0_apply_0;
  }
  function sum(_this_) {
    var sum_2 = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      sum_2 = sum_2 + element | 0;
    }
    return sum_2;
  }
  function toList_0(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList_0(_this_);
    }
  }
  function toList_1(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList_1(_this_);
    }
  }
  function toList_2(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList_2(_this_);
    }
  }
  function toMutableList_0(_this_) {
    var list = ArrayList_init_$Create$_0(_this_.length);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_2bq_k$(item);
      Unit_getInstance();
    }
    return list;
  }
  function toMutableList_1(_this_) {
    var list = ArrayList_init_$Create$_0(_this_.length);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_2bq_k$(item);
      Unit_getInstance();
    }
    return list;
  }
  function toMutableList_2(_this_) {
    var list = ArrayList_init_$Create$_0(_this_.length);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_2bq_k$(item);
      Unit_getInstance();
    }
    return list;
  }
  function sliceArray(_this_, indices) {
    if (indices.isEmpty_0_k$())
      return new Int8Array(0);
    return copyOfRange_2(_this_, indices._get_start__0_k$(), indices._get_endInclusive__0_k$() + 1 | 0);
  }
  function toList_3(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__0_k$();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyList();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_ha5a7z_k$(0);
          } else {
            {
              tmp_0 = _this_.iterator_0_k$().next_0_k$();
            }
          }

          tmp = listOf_0(tmp_0);
          break;
        default:tmp = toMutableList_3(_this_);
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyList(toMutableList_4(_this_));
  }
  function joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo_0(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default_0(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function zip(_this_, other) {
    var first_1_0 = _this_.iterator_0_k$();
    var second_2 = other.iterator_0_k$();
    var tmp0_minOf_0 = collectionSizeOrDefault(_this_, 10);
    var tmp1_minOf_0 = collectionSizeOrDefault(other, 10);
    var list_3 = ArrayList_init_$Create$_0(Math.min(tmp0_minOf_0, tmp1_minOf_0));
    while (first_1_0.hasNext_0_k$() ? second_2.hasNext_0_k$() : false) {
      var tmp2__anonymous__4 = first_1_0.next_0_k$();
      var tmp3__anonymous__4 = second_2.next_0_k$();
      list_3.add_2bq_k$(to(tmp2__anonymous__4, tmp3__anonymous__4));
      Unit_getInstance();
    }
    return list_3;
  }
  function reversed(_this_) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__0_k$() <= 1;
    } else {
      {
        tmp = false;
      }
    }
    if (tmp)
      return toList_3(_this_);
    else {
    }
    var list = toMutableList_4(_this_);
    reverse(list);
    return list;
  }
  function toSet_0(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__0_k$();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptySet();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_ha5a7z_k$(0);
          } else {
            {
              tmp_0 = _this_.iterator_0_k$().next_0_k$();
            }
          }

          tmp = setOf_0(tmp_0);
          break;
        default:tmp = toCollection_0(_this_, LinkedHashSet_init_$Create$_1(mapCapacity(_this_._get_size__0_k$())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlySet(toCollection_0(_this_, LinkedHashSet_init_$Create$()));
  }
  function toMutableList_3(_this_) {
    return ArrayList_init_$Create$_1(_this_);
  }
  function first(_this_) {
    if (_this_.isEmpty_0_k$())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_ha5a7z_k$(0);
  }
  function plus(_this_, elements) {
    if (isInterface(elements, Collection)) {
      var result = ArrayList_init_$Create$_0(_this_._get_size__0_k$() + elements._get_size__0_k$() | 0);
      result.addAll_dxd4eo_k$(_this_);
      Unit_getInstance();
      result.addAll_dxd4eo_k$(elements);
      Unit_getInstance();
      return result;
    } else {
      {
        var result_0 = ArrayList_init_$Create$_1(_this_);
        addAll(result_0, elements);
        Unit_getInstance();
        return result_0;
      }
    }
  }
  function contains_5(_this_, element) {
    if (isInterface(_this_, Collection))
      return _this_.contains_2bq_k$(element);
    else {
    }
    return indexOf_5(_this_, element) >= 0;
  }
  function filterNotNull(_this_) {
    return filterNotNullTo(_this_, ArrayList_init_$Create$());
  }
  function distinct(_this_) {
    return toList_3(toMutableSet(_this_));
  }
  function sorted(_this_) {
    if (isInterface(_this_, Collection)) {
      if (_this_._get_size__0_k$() <= 1)
        return toList_3(_this_);
      var tmp0_toTypedArray_0 = _this_;
      var tmp = copyToArray_0(tmp0_toTypedArray_0);
      var tmp1_apply_0 = isArray(tmp) ? tmp : THROW_CCE();
      sort_0(tmp1_apply_0);
      return asList(tmp1_apply_0);
    } else {
    }
    var tmp2_apply_0 = toMutableList_4(_this_);
    sort(tmp2_apply_0);
    return tmp2_apply_0;
  }
  function firstOrNull(_this_) {
    return _this_.isEmpty_0_k$() ? null : _this_.get_ha5a7z_k$(0);
  }
  function plus_0(_this_, element) {
    var result = ArrayList_init_$Create$_0(_this_._get_size__0_k$() + 1 | 0);
    result.addAll_dxd4eo_k$(_this_);
    Unit_getInstance();
    result.add_2bq_k$(element);
    Unit_getInstance();
    return result;
  }
  function toIntArray(_this_) {
    var result = new Int32Array(_this_._get_size__0_k$());
    var index_0 = 0;
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      var tmp1 = index_0;
      index_0 = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function last(_this_) {
    if (_this_.isEmpty_0_k$())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_ha5a7z_k$(_get_lastIndex__4(_this_));
  }
  function first_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return first(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_0_k$();
        if (!iterator_0.hasNext_0_k$())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        return iterator_0.next_0_k$();
      }
    }
  }
  function last_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return last(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_0_k$();
        if (!iterator_0.hasNext_0_k$())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var last_1 = iterator_0.next_0_k$();
        while (iterator_0.hasNext_0_k$())
          last_1 = iterator_0.next_0_k$();
        return last_1;
      }
    }
  }
  function maxOrNull(_this_) {
    var iterator_0 = _this_.iterator_0_k$();
    if (!iterator_0.hasNext_0_k$())
      return null;
    var max = iterator_0.next_0_k$();
    while (iterator_0.hasNext_0_k$()) {
      var e = iterator_0.next_0_k$();
      if (compareTo(max, e) < 0)
        max = e;
    }
    return max;
  }
  function count(_this_) {
    if (isInterface(_this_, Collection))
      return _this_._get_size__0_k$();
    else {
    }
    var count_0 = 0;
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      count_0 = count_0 + 1 | 0;
      checkCountOverflow(count_0);
      Unit_getInstance();
    }
    return count_0;
  }
  function maxOrNull_0(_this_) {
    var iterator_0 = _this_.iterator_0_k$();
    if (!iterator_0.hasNext_0_k$())
      return null;
    var max = iterator_0.next_0_k$();
    while (iterator_0.hasNext_0_k$()) {
      var e = iterator_0.next_0_k$();
      var tmp0_maxOf_0 = max;
      max = Math.max(tmp0_maxOf_0, e);
    }
    return max;
  }
  function toMutableList_4(_this_) {
    if (isInterface(_this_, Collection))
      return toMutableList_3(_this_);
    else {
    }
    return toCollection_0(_this_, ArrayList_init_$Create$());
  }
  function joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_v1o70a_k$(prefix);
    Unit_getInstance();
    var count_0 = 0;
    var tmp0_iterator = _this_.iterator_0_k$();
    $l$break: while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      count_0 = count_0 + 1 | 0;
      if (count_0 > 1) {
        buffer.append_v1o70a_k$(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count_0 <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count_0 > limit : false) {
      buffer.append_v1o70a_k$(truncated);
      Unit_getInstance();
    }buffer.append_v1o70a_k$(postfix);
    Unit_getInstance();
    return buffer;
  }
  function toCollection_0(_this_, destination) {
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var item = tmp0_iterator.next_0_k$();
      destination.add_2bq_k$(item);
      Unit_getInstance();
    }
    return destination;
  }
  function sortedWith(_this_, comparator) {
    if (isInterface(_this_, Collection)) {
      if (_this_._get_size__0_k$() <= 1)
        return toList_3(_this_);
      var tmp0_toTypedArray_0 = _this_;
      var tmp = copyToArray_0(tmp0_toTypedArray_0);
      var tmp1_apply_0 = isArray(tmp) ? tmp : THROW_CCE();
      sortWith_0(tmp1_apply_0, comparator);
      return asList(tmp1_apply_0);
    } else {
    }
    var tmp2_apply_0 = toMutableList_4(_this_);
    sortWith(tmp2_apply_0, comparator);
    return tmp2_apply_0;
  }
  function indexOf_5(_this_, element) {
    if (isInterface(_this_, List))
      return _this_.indexOf_2bq_k$(element);
    else {
    }
    var index_0 = 0;
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var item = tmp0_iterator.next_0_k$();
      checkIndexOverflow(index_0);
      Unit_getInstance();
      if (equals_1(element, item))
        return index_0;
      var tmp1 = index_0;
      index_0 = tmp1 + 1 | 0;
      Unit_getInstance();
    }
    return -1;
  }
  function filterNotNullTo(_this_, destination) {
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      if (!(element == null)) {
        destination.add_2bq_k$(element);
        Unit_getInstance();
      }}
    return destination;
  }
  function toMutableSet(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (isInterface(tmp0_subject, Collection)) {
      tmp = LinkedHashSet_init_$Create$_0(_this_);
    } else {
      {
        tmp = toCollection_0(_this_, LinkedHashSet_init_$Create$());
      }
    }
    return tmp;
  }
  function single_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return single_1(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_0_k$();
        if (!iterator_0.hasNext_0_k$())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var single_2 = iterator_0.next_0_k$();
        if (iterator_0.hasNext_0_k$())
          throw IllegalArgumentException_init_$Create$('Collection has more than one element.');
        return single_2;
      }
    }
  }
  function asSequence(_this_) {
    return new _no_name_provided__1(_this_);
  }
  function single_1(_this_) {
    var tmp0_subject = _this_._get_size__0_k$();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('List is empty.');
      case 1:
        tmp = _this_.get_ha5a7z_k$(0);
        break;
      default:throw IllegalArgumentException_init_$Create$('List has more than one element.');
    }
    return tmp;
  }
  function firstOrNull_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List)) {
      if (_this_.isEmpty_0_k$())
        return null;
      else
        return _this_.get_ha5a7z_k$(0);
    } else {
      {
        var iterator_0 = _this_.iterator_0_k$();
        if (!iterator_0.hasNext_0_k$())
          return null;
        return iterator_0.next_0_k$();
      }
    }
  }
  function sum_0(_this_) {
    var sum_2 = 0.0;
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      sum_2 = sum_2 + element;
    }
    return sum_2;
  }
  function sum_1(_this_) {
    var sum_2 = 0;
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      sum_2 = sum_2 + element | 0;
    }
    return sum_2;
  }
  function minus(_this_, elements) {
    var other = convertToSetForSetOperationWith(elements, _this_);
    if (other.isEmpty_0_k$())
      return toList_3(_this_);
    var tmp0_filterNotTo_0 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = _this_.iterator_0_k$();
    while (tmp0_iterator_1.hasNext_0_k$()) {
      var element_2 = tmp0_iterator_1.next_0_k$();
      if (!other.contains_2bq_k$(element_2)) {
        tmp0_filterNotTo_0.add_2bq_k$(element_2);
        Unit_getInstance();
      } else {
      }
    }
    return tmp0_filterNotTo_0;
  }
  function toHashSet(_this_) {
    return toCollection_0(_this_, HashSet_init_$Create$(mapCapacity(collectionSizeOrDefault(_this_, 12))));
  }
  function _no_name_provided__1($this_asSequence) {
    this._$this_asSequence = $this_asSequence;
  }
  _no_name_provided__1.prototype.iterator_2_0_k$ = function () {
    return this._$this_asSequence.iterator_0_k$();
  };
  _no_name_provided__1.prototype.iterator_0_k$ = function () {
    return this.iterator_2_0_k$();
  };
  _no_name_provided__1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function toList_4(_this_) {
    if (_this_._get_size__0_k$() === 0)
      return emptyList();
    var iterator_0 = _this_._get_entries__0_k$().iterator_0_k$();
    if (!iterator_0.hasNext_0_k$())
      return emptyList();
    var first_2 = iterator_0.next_0_k$();
    if (!iterator_0.hasNext_0_k$()) {
      return listOf_0(new Pair(first_2._get_key__0_k$(), first_2._get_value__0_k$()));
    }var result = ArrayList_init_$Create$_0(_this_._get_size__0_k$());
    result.add_2bq_k$(new Pair(first_2._get_key__0_k$(), first_2._get_value__0_k$()));
    Unit_getInstance();
    do {
      var tmp0_toPair_0 = iterator_0.next_0_k$();
      result.add_2bq_k$(new Pair(tmp0_toPair_0._get_key__0_k$(), tmp0_toPair_0._get_value__0_k$()));
      Unit_getInstance();
    }
     while (iterator_0.hasNext_0_k$());
    return result;
  }
  function until(_this_, to_0) {
    if (to_0 <= IntCompanionObject_getInstance()._MIN_VALUE_5)
      return Companion_getInstance_11()._EMPTY;
    return numberRangeToNumber(_this_, to_0 - 1 | 0);
  }
  function coerceAtMost(_this_, maximumValue) {
    return _this_ > maximumValue ? maximumValue : _this_;
  }
  function until_0(_this_, to_0) {
    Companion_getInstance_17();
    if (to_0.compareTo_wiekkq_k$(new Long(0, -2147483648)) <= 0)
      return Companion_getInstance_12()._EMPTY_0;
    else {
    }
    return _this_.rangeTo_wiekkq_k$(to_0.minus_wiekkq_k$(new Long(1, 0)).toLong_0_k$());
  }
  function step(_this_, step_0) {
    checkStepIsPositive(step_0 > 0, step_0);
    return Companion_getInstance_8().fromClosedRange_fcwjfj_k$(_this_._first_0, _this_._last, _this_._step_2 > 0 ? step_0 : -step_0 | 0);
  }
  function downTo(_this_, to_0) {
    return Companion_getInstance_8().fromClosedRange_fcwjfj_k$(_this_, to_0, -1);
  }
  function coerceIn(_this_, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_ < minimumValue)
      return minimumValue;
    if (_this_ > maximumValue)
      return maximumValue;
    return _this_;
  }
  function coerceAtLeast(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function coerceAtLeast_0(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function coerceAtLeast_1(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function reversed_0(_this_) {
    return Companion_getInstance_8().fromClosedRange_fcwjfj_k$(_this_._last, _this_._first_0, -_this_._step_2 | 0);
  }
  function coerceIn_0(_this_, minimumValue, maximumValue) {
    if (minimumValue.compareTo_wiekkq_k$(maximumValue) > 0)
      throw IllegalArgumentException_init_$Create$('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_.compareTo_wiekkq_k$(minimumValue) < 0)
      return minimumValue;
    if (_this_.compareTo_wiekkq_k$(maximumValue) > 0)
      return maximumValue;
    return _this_;
  }
  function asIterable(_this_) {
    return new _no_name_provided__1_0(_this_);
  }
  function map(_this_, transform) {
    return new TransformingSequence(_this_, transform);
  }
  function take_1(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp;
    if (n === 0) {
      tmp = emptySequence();
    } else {
      if (isInterface(_this_, DropTakeSequence)) {
        tmp = _this_.take_ha5a7z_k$(n);
      } else {
        {
          tmp = new TakeSequence(_this_, n);
        }
      }
    }
    return tmp;
  }
  function toList_5(_this_) {
    return optimizeReadOnlyList(toMutableList_5(_this_));
  }
  function toMutableList_5(_this_) {
    return toCollection_1(_this_, ArrayList_init_$Create$());
  }
  function toCollection_1(_this_, destination) {
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var item = tmp0_iterator.next_0_k$();
      destination.add_2bq_k$(item);
      Unit_getInstance();
    }
    return destination;
  }
  function _no_name_provided__1_0($this_asIterable) {
    this._$this_asIterable = $this_asIterable;
  }
  _no_name_provided__1_0.prototype.iterator_2_0_k$ = function () {
    return this._$this_asIterable.iterator_0_k$();
  };
  _no_name_provided__1_0.prototype.iterator_0_k$ = function () {
    return this.iterator_2_0_k$();
  };
  _no_name_provided__1_0.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Iterable]
  };
  function plus_1(_this_, elements) {
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(_this_._get_size__0_k$() + elements.length | 0));
    result.addAll_dxd4eo_k$(_this_);
    Unit_getInstance();
    addAll_0(result, elements);
    Unit_getInstance();
    return result;
  }
  function plus_2(_this_, elements) {
    var tmp0_safe_receiver = collectionSizeOrNull(elements);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = _this_._get_size__0_k$() + tmp0_safe_receiver | 0;
    }
    var tmp1_elvis_lhs = tmp;
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(tmp1_elvis_lhs == null ? imul(_this_._get_size__0_k$(), 2) : tmp1_elvis_lhs));
    result.addAll_dxd4eo_k$(_this_);
    Unit_getInstance();
    addAll(result, elements);
    Unit_getInstance();
    return result;
  }
  function minus_0(_this_, elements) {
    var other = convertToSetForSetOperationWith(elements, _this_);
    if (other.isEmpty_0_k$())
      return toSet_0(_this_);
    if (isInterface(other, Set)) {
      var tmp0_filterNotTo_0 = LinkedHashSet_init_$Create$();
      var tmp0_iterator_1 = _this_.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!other.contains_2bq_k$(element_2)) {
          tmp0_filterNotTo_0.add_2bq_k$(element_2);
          Unit_getInstance();
        } else {
        }
      }
      return tmp0_filterNotTo_0;
    } else {
    }
    var result = LinkedHashSet_init_$Create$_0(_this_);
    result.removeAll_dxd4eo_k$(other);
    Unit_getInstance();
    return result;
  }
  function first_1(_this_) {
    if (charSequenceLength(_this_) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    else {
    }
    return charSequenceGet(_this_, 0);
  }
  function take_2(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_substring_0 = coerceAtMost(n, _this_.length);
    return _this_.substring(0, tmp1_substring_0);
  }
  function dropLast(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return take_2(_this_, coerceAtLeast(_this_.length - n | 0, 0));
  }
  function contentHashCode(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new UByteArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UByteArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentHashCode_5(tmp);
  }
  function contentHashCode_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new UShortArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UShortArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentHashCode_6(tmp);
  }
  function contentHashCode_1(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new UIntArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UIntArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentHashCode_4(tmp);
  }
  function contentHashCode_2(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new ULongArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _ULongArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentHashCode_7(tmp);
  }
  function contentEquals(_this_, other) {
    var tmp1_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new UByteArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UByteArray___get_storage__impl_(tmp1_safe_receiver);
      }
    }
    var tmp_1 = tmp;
    var tmp0_safe_receiver = other;
    var tmp_2;
    var tmp_3 = tmp0_safe_receiver;
    if ((tmp_3 == null ? null : new UByteArray(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      {
        tmp_2 = _UByteArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentEquals_5(tmp_1, tmp_2);
  }
  function contentEquals_0(_this_, other) {
    var tmp1_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new UShortArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UShortArray___get_storage__impl_(tmp1_safe_receiver);
      }
    }
    var tmp_1 = tmp;
    var tmp0_safe_receiver = other;
    var tmp_2;
    var tmp_3 = tmp0_safe_receiver;
    if ((tmp_3 == null ? null : new UShortArray(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      {
        tmp_2 = _UShortArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentEquals_6(tmp_1, tmp_2);
  }
  function contentEquals_1(_this_, other) {
    var tmp1_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new UIntArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UIntArray___get_storage__impl_(tmp1_safe_receiver);
      }
    }
    var tmp_1 = tmp;
    var tmp0_safe_receiver = other;
    var tmp_2;
    var tmp_3 = tmp0_safe_receiver;
    if ((tmp_3 == null ? null : new UIntArray(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      {
        tmp_2 = _UIntArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentEquals_4(tmp_1, tmp_2);
  }
  function contentEquals_2(_this_, other) {
    var tmp1_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new ULongArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _ULongArray___get_storage__impl_(tmp1_safe_receiver);
      }
    }
    var tmp_1 = tmp;
    var tmp0_safe_receiver = other;
    var tmp_2;
    var tmp_3 = tmp0_safe_receiver;
    if ((tmp_3 == null ? null : new ULongArray(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      {
        tmp_2 = _ULongArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentEquals_7(tmp_1, tmp_2);
  }
  function _no_name_provided_(this$0) {
    this._this$0 = this$0;
  }
  _no_name_provided_.prototype.invoke_2bq_k$ = function (it) {
    return it === this._this$0 ? '(this Collection)' : toString_0(it);
  };
  _no_name_provided_.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_2bq_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractCollection() {
  }
  AbstractCollection.prototype.contains_2bq_k$ = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = this.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (equals_1(element_2, element)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.containsAll_dxd4eo_k$ = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!this.contains_2bq_k$(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, _no_name_provided_$factory(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl_0(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _no_name_provided_$factory(this$0) {
    var i = new _no_name_provided_(this$0);
    return function (p1) {
      return i.invoke_2bq_k$(p1);
    };
  }
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.prototype.checkElementIndex_rvwcgf_k$ = function (index_0, size_2) {
    if (index_0 < 0 ? true : index_0 >= size_2) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index_0 + ', size: ' + size_2);
    }};
  Companion_0.prototype.checkPositionIndex_rvwcgf_k$ = function (index_0, size_2) {
    if (index_0 < 0 ? true : index_0 > size_2) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index_0 + ', size: ' + size_2);
    }};
  Companion_0.prototype.checkRangeIndexes_zd700_k$ = function (fromIndex, toIndex, size_2) {
    if (fromIndex < 0 ? true : toIndex > size_2) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size_2);
    }if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$('' + 'fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }};
  Companion_0.prototype.checkBoundsIndexes_zd700_k$ = function (startIndex, endIndex, size_2) {
    if (startIndex < 0 ? true : endIndex > size_2) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size_2);
    }if (startIndex > endIndex) {
      throw IllegalArgumentException_init_$Create$('' + 'startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
    }};
  Companion_0.prototype.orderedHashCode_dxd51x_k$ = function (c) {
    var hashCode_1 = 1;
    var tmp0_iterator = c.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var e = tmp0_iterator.next_0_k$();
      var tmp = imul(31, hashCode_1);
      var tmp1_safe_receiver = e;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_0.prototype.orderedEquals_tuq55s_k$ = function (c, other) {
    if (!(c._get_size__0_k$() === other._get_size__0_k$()))
      return false;
    var otherIterator = other.iterator_0_k$();
    var tmp0_iterator = c.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var elem = tmp0_iterator.next_0_k$();
      var elemOther = otherIterator.next_0_k$();
      if (!equals_1(elem, elemOther)) {
        return false;
      }}
    return true;
  };
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function _no_name_provided__0($entryIterator) {
    this._$entryIterator = $entryIterator;
  }
  _no_name_provided__0.prototype.hasNext_0_k$ = function () {
    return this._$entryIterator.hasNext_0_k$();
  };
  _no_name_provided__0.prototype.next_0_k$ = function () {
    return this._$entryIterator.next_0_k$()._get_value__0_k$();
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function toString($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = $this._get_entries__0_k$();
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (equals_1(element_2._get_key__0_k$(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function Companion_1() {
    Companion_instance_0 = this;
  }
  Companion_1.prototype.entryHashCode_4vm2wp_k$ = function (e) {
    var tmp2_safe_receiver_4 = e._get_key__0_k$();
    var tmp3_elvis_lhs_3 = tmp2_safe_receiver_4 == null ? null : hashCode(tmp2_safe_receiver_4);
    var tmp = tmp3_elvis_lhs_3 == null ? 0 : tmp3_elvis_lhs_3;
    var tmp0_safe_receiver_6 = e._get_value__0_k$();
    var tmp1_elvis_lhs_5 = tmp0_safe_receiver_6 == null ? null : hashCode(tmp0_safe_receiver_6);
    return tmp ^ (tmp1_elvis_lhs_5 == null ? 0 : tmp1_elvis_lhs_5);
  };
  Companion_1.prototype.entryToString_4vm2wp_k$ = function (e) {
    return '' + e._get_key__0_k$() + '=' + e._get_value__0_k$();
  };
  Companion_1.prototype.entryEquals_caydzc_k$ = function (e, other) {
    if (!(!(other == null) ? isInterface(other, Entry) : false))
      return false;
    else {
    }
    return equals_1(e._get_key__0_k$(), other._get_key__0_k$()) ? equals_1(e._get_value__0_k$(), other._get_value__0_k$()) : false;
  };
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function _no_name_provided__2(this$0) {
    this._this$0_0 = this$0;
  }
  _no_name_provided__2.prototype.invoke_4v0zae_k$ = function (it) {
    return this._this$0_0.toString_4v0zae_k$(it);
  };
  _no_name_provided__2.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_4v0zae_k$((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3(this$0) {
    this._this$0_1 = this$0;
    AbstractCollection.call(this);
  }
  _no_name_provided__3.prototype.contains_2c7_k$ = function (element) {
    return this._this$0_1.containsValue_2c7_k$(element);
  };
  _no_name_provided__3.prototype.contains_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_2c7_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__3.prototype.iterator_0_k$ = function () {
    var entryIterator = this._this$0_1._get_entries__0_k$().iterator_0_k$();
    return new _no_name_provided__0(entryIterator);
  };
  _no_name_provided__3.prototype._get_size__0_k$ = function () {
    return this._this$0_1._get_size__0_k$();
  };
  _no_name_provided__3.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMap() {
    Companion_getInstance_0();
    this.__keys = null;
    this.__values = null;
  }
  AbstractMap.prototype.containsKey_2bw_k$ = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  AbstractMap.prototype.containsValue_2c7_k$ = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._get_entries__0_k$();
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (equals_1(element_2._get_value__0_k$(), value)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.containsEntry_7gsh9e_k$ = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    else {
    }
    var key = entry._get_key__0_k$();
    var value = entry._get_value__0_k$();
    var ourValue = (isInterface(this, Map_0) ? this : THROW_CCE()).get_2bw_k$(key);
    if (!equals_1(value, ourValue)) {
      return false;
    }var tmp;
    if (ourValue == null) {
      tmp = !(isInterface(this, Map_0) ? this : THROW_CCE()).containsKey_2bw_k$(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
    }
    return true;
  };
  AbstractMap.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Map_0) : false))
      return false;
    else {
    }
    if (!(this._get_size__0_k$() === other._get_size__0_k$()))
      return false;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = other._get_entries__0_k$();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!this.containsEntry_7gsh9e_k$(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.get_2bw_k$ = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__0_k$();
  };
  AbstractMap.prototype.hashCode = function () {
    return hashCode(this._get_entries__0_k$());
  };
  AbstractMap.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  AbstractMap.prototype._get_size__0_k$ = function () {
    return this._get_entries__0_k$()._get_size__0_k$();
  };
  AbstractMap.prototype.toString = function () {
    var tmp = this._get_entries__0_k$();
    return joinToString$default_0(tmp, ', ', '{', '}', 0, null, _no_name_provided_$factory_0(this), 24, null);
  };
  AbstractMap.prototype.toString_4v0zae_k$ = function (entry) {
    return toString(this, entry._get_key__0_k$()) + '=' + toString(this, entry._get_value__0_k$());
  };
  AbstractMap.prototype._get_values__0_k$ = function () {
    if (this.__values == null) {
      var tmp = this;
      tmp.__values = new _no_name_provided__3(this);
    }return ensureNotNull(this.__values);
  };
  AbstractMap.$metadata$ = {
    simpleName: 'AbstractMap',
    kind: 'class',
    interfaces: [Map_0]
  };
  function _no_name_provided_$factory_0(this$0) {
    var i = new _no_name_provided__2(this$0);
    return function (p1) {
      return i.invoke_4v0zae_k$(p1);
    };
  }
  function Companion_2() {
    Companion_instance_1 = this;
  }
  Companion_2.prototype.unorderedHashCode_dxd51x_k$ = function (c) {
    var hashCode_1 = 0;
    var tmp0_iterator = c.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      var tmp = hashCode_1;
      var tmp1_safe_receiver = element;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_2.prototype.setEquals_qlktm2_k$ = function (c, other) {
    if (!(c._get_size__0_k$() === other._get_size__0_k$()))
      return false;
    return c.containsAll_dxd4eo_k$(other);
  };
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function contentDeepEqualsImpl_0(_this_, other) {
    if (_this_ === other)
      return true;
    if ((_this_ == null ? true : other == null) ? true : !(_this_.length === other.length))
      return false;
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v1 = _this_[i];
        var v2 = other[i];
        if (v1 === v2) {
          continue;
        } else if (v1 == null ? true : v2 == null) {
          return false;
        }var tmp;
        if (!(v1 == null) ? isArray(v1) : false) {
          tmp = !(v2 == null) ? isArray(v2) : false;
        } else {
          {
            tmp = false;
          }
        }
        if (tmp) {
          if (!contentDeepEquals(v1, v2))
            return false;
        } else {
          var tmp_0;
          if (!(v1 == null) ? isByteArray(v1) : false) {
            tmp_0 = !(v2 == null) ? isByteArray(v2) : false;
          } else {
            {
              tmp_0 = false;
            }
          }
          if (tmp_0) {
            if (!contentEquals_5(v1, v2))
              return false;
          } else {
            var tmp_1;
            if (!(v1 == null) ? isShortArray(v1) : false) {
              tmp_1 = !(v2 == null) ? isShortArray(v2) : false;
            } else {
              {
                tmp_1 = false;
              }
            }
            if (tmp_1) {
              if (!contentEquals_6(v1, v2))
                return false;
            } else {
              var tmp_2;
              if (!(v1 == null) ? isIntArray(v1) : false) {
                tmp_2 = !(v2 == null) ? isIntArray(v2) : false;
              } else {
                {
                  tmp_2 = false;
                }
              }
              if (tmp_2) {
                if (!contentEquals_4(v1, v2))
                  return false;
              } else {
                var tmp_3;
                if (!(v1 == null) ? isLongArray(v1) : false) {
                  tmp_3 = !(v2 == null) ? isLongArray(v2) : false;
                } else {
                  {
                    tmp_3 = false;
                  }
                }
                if (tmp_3) {
                  if (!contentEquals_7(v1, v2))
                    return false;
                } else {
                  var tmp_4;
                  if (!(v1 == null) ? isFloatArray(v1) : false) {
                    tmp_4 = !(v2 == null) ? isFloatArray(v2) : false;
                  } else {
                    {
                      tmp_4 = false;
                    }
                  }
                  if (tmp_4) {
                    if (!contentEquals_3(v1, v2))
                      return false;
                  } else {
                    var tmp_5;
                    if (!(v1 == null) ? isDoubleArray(v1) : false) {
                      tmp_5 = !(v2 == null) ? isDoubleArray(v2) : false;
                    } else {
                      {
                        tmp_5 = false;
                      }
                    }
                    if (tmp_5) {
                      if (!contentEquals_8(v1, v2))
                        return false;
                    } else {
                      var tmp_6;
                      if (!(v1 == null) ? isCharArray(v1) : false) {
                        tmp_6 = !(v2 == null) ? isCharArray(v2) : false;
                      } else {
                        {
                          tmp_6 = false;
                        }
                      }
                      if (tmp_6) {
                        if (!contentEquals_9(v1, v2))
                          return false;
                      } else {
                        var tmp_7;
                        if (!(v1 == null) ? isBooleanArray(v1) : false) {
                          tmp_7 = !(v2 == null) ? isBooleanArray(v2) : false;
                        } else {
                          {
                            tmp_7 = false;
                          }
                        }
                        if (tmp_7) {
                          if (!contentEquals_10(v1, v2))
                            return false;
                        } else {
                          var tmp_8;
                          if (v1 instanceof UByteArray) {
                            tmp_8 = v2 instanceof UByteArray;
                          } else {
                            {
                              tmp_8 = false;
                            }
                          }
                          if (tmp_8) {
                            var tmp_9 = v1;
                            var tmp_10 = tmp_9 == null ? null : tmp_9._storage;
                            var tmp_11 = v2;
                            if (!contentEquals(tmp_10, tmp_11 == null ? null : tmp_11._storage))
                              return false;
                            else {
                            }
                          } else {
                            var tmp_12;
                            if (v1 instanceof UShortArray) {
                              tmp_12 = v2 instanceof UShortArray;
                            } else {
                              {
                                tmp_12 = false;
                              }
                            }
                            if (tmp_12) {
                              var tmp_13 = v1;
                              var tmp_14 = tmp_13 == null ? null : tmp_13._storage_2;
                              var tmp_15 = v2;
                              if (!contentEquals_0(tmp_14, tmp_15 == null ? null : tmp_15._storage_2))
                                return false;
                              else {
                              }
                            } else {
                              var tmp_16;
                              if (v1 instanceof UIntArray) {
                                tmp_16 = v2 instanceof UIntArray;
                              } else {
                                {
                                  tmp_16 = false;
                                }
                              }
                              if (tmp_16) {
                                var tmp_17 = v1;
                                var tmp_18 = tmp_17 == null ? null : tmp_17._storage_0;
                                var tmp_19 = v2;
                                if (!contentEquals_1(tmp_18, tmp_19 == null ? null : tmp_19._storage_0))
                                  return false;
                                else {
                                }
                              } else {
                                var tmp_20;
                                if (v1 instanceof ULongArray) {
                                  tmp_20 = v2 instanceof ULongArray;
                                } else {
                                  {
                                    tmp_20 = false;
                                  }
                                }
                                if (tmp_20) {
                                  var tmp_21 = v1;
                                  var tmp_22 = tmp_21 == null ? null : tmp_21._storage_1;
                                  var tmp_23 = v2;
                                  if (!contentEquals_2(tmp_22, tmp_23 == null ? null : tmp_23._storage_1))
                                    return false;
                                  else {
                                  }
                                } else {
                                  if (!equals_1(v1, v2))
                                    return false;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
       while (inductionVariable <= last_1);
    return true;
  }
  function listOf(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function optimizeReadOnlyList(_this_) {
    var tmp0_subject = _this_._get_size__0_k$();
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_.get_ha5a7z_k$(0));
      default:return _this_;
    }
  }
  function _get_lastIndex__4(_this_) {
    return _this_._get_size__0_k$() - 1 | 0;
  }
  function asCollection(_this_) {
    return new ArrayAsCollection(_this_, false);
  }
  function ArrayAsCollection(values_21, isVarargs) {
    this._values = values_21;
    this._isVarargs = isVarargs;
  }
  ArrayAsCollection.prototype._get_size__0_k$ = function () {
    return this._values.length;
  };
  ArrayAsCollection.prototype.isEmpty_0_k$ = function () {
    var tmp0_isEmpty_0 = this._values;
    return tmp0_isEmpty_0.length === 0;
  };
  ArrayAsCollection.prototype.contains_2c5_k$ = function (element) {
    return contains_0(this._values, element);
  };
  ArrayAsCollection.prototype.contains_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_2c5_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ArrayAsCollection.prototype.containsAll_dxd41r_k$ = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!this.contains_2c5_k$(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ArrayAsCollection.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_dxd41r_k$(elements);
  };
  ArrayAsCollection.prototype.iterator_0_k$ = function () {
    return arrayIterator(this._values);
  };
  ArrayAsCollection.$metadata$ = {
    simpleName: 'ArrayAsCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function EmptyList() {
    EmptyList_instance = this;
    this._serialVersionUID = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, List) : false) {
      tmp = other.isEmpty_0_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyList.prototype.hashCode = function () {
    return 1;
  };
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype._get_size__0_k$ = function () {
    return 0;
  };
  EmptyList.prototype.isEmpty_0_k$ = function () {
    return true;
  };
  EmptyList.prototype.contains_5jd3j5_k$ = function (element) {
    return false;
  };
  EmptyList.prototype.contains_2bq_k$ = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_5jd3j5_k$(tmp);
  };
  EmptyList.prototype.containsAll_lwol4p_k$ = function (elements) {
    return elements.isEmpty_0_k$();
  };
  EmptyList.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_lwol4p_k$(elements);
  };
  EmptyList.prototype.get_ha5a7z_k$ = function (index_0) {
    throw IndexOutOfBoundsException_init_$Create$_0('' + "Empty list doesn't contain element at index " + index_0 + '.');
  };
  EmptyList.prototype.indexOf_5jd3j5_k$ = function (element) {
    return -1;
  };
  EmptyList.prototype.indexOf_2bq_k$ = function (element) {
    if (!false)
      return -1;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.indexOf_5jd3j5_k$(tmp);
  };
  EmptyList.prototype.iterator_0_k$ = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.prototype.listIterator_ha5a7z_k$ = function (index_0) {
    if (!(index_0 === 0))
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'Index: ' + index_0);
    return EmptyIterator_getInstance();
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_0_k$ = function () {
    return false;
  };
  EmptyIterator.prototype.next_0_k$ = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function _get_indices__0(_this_) {
    return numberRangeToNumber(0, _this_._get_size__0_k$() - 1 | 0);
  }
  function throwCountOverflow() {
    throw ArithmeticException_init_$Create$('Count overflow has happened.');
  }
  function throwIndexOverflow() {
    throw ArithmeticException_init_$Create$('Index overflow has happened.');
  }
  function mutableListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function collectionSizeOrDefault(_this_, default_0) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__0_k$();
    } else {
      {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function collectionSizeOrNull(_this_) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__0_k$();
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function convertToSetForSetOperationWith(_this_, source) {
    var tmp0_subject = _this_;
    var tmp;
    if (isInterface(tmp0_subject, Set)) {
      tmp = _this_;
    } else {
      if (isInterface(tmp0_subject, Collection)) {
        var tmp_0;
        var tmp_1;
        if (isInterface(source, Collection)) {
          tmp_1 = source._get_size__0_k$() < 2;
        } else {
          {
            tmp_1 = false;
          }
        }
        if (tmp_1) {
          tmp_0 = _this_;
        } else {
          {
            tmp_0 = safeToConvertToSet(_this_) ? toHashSet(_this_) : _this_;
          }
        }
        tmp = tmp_0;
      } else {
        {
          tmp = toHashSet(_this_);
        }
      }
    }
    return tmp;
  }
  function safeToConvertToSet(_this_) {
    var tmp;
    if (_this_._get_size__0_k$() > 2) {
      tmp = _this_ instanceof ArrayList;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function toMap(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyMap();
      case 1:
        return mapOf_0(_this_[0]);
      default:return toMap_1(_this_, LinkedHashMap_init_$Create$_1(mapCapacity(_this_.length)));
    }
  }
  function plus_3(_this_, map_0) {
    var tmp0_apply_0 = LinkedHashMap_init_$Create$_2(_this_);
    tmp0_apply_0.putAll_nn707j_k$(map_0);
    return tmp0_apply_0;
  }
  function toMap_0(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__0_k$();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyMap();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_ha5a7z_k$(0);
          } else {
            {
              tmp_0 = _this_.iterator_0_k$().next_0_k$();
            }
          }

          tmp = mapOf_0(tmp_0);
          break;
        default:tmp = toMap_2(_this_, LinkedHashMap_init_$Create$_1(mapCapacity(_this_._get_size__0_k$())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyMap(toMap_2(_this_, LinkedHashMap_init_$Create$()));
  }
  function linkedMapOf(pairs) {
    return toMap_1(pairs, LinkedHashMap_init_$Create$_1(mapCapacity(pairs.length)));
  }
  function mapOf(pairs) {
    return pairs.length > 0 ? toMap_1(pairs, LinkedHashMap_init_$Create$_1(mapCapacity(pairs.length))) : emptyMap();
  }
  function hashMapOf(pairs) {
    var tmp0_apply_0 = HashMap_init_$Create$_1(mapCapacity(pairs.length));
    putAll(tmp0_apply_0, pairs);
    return tmp0_apply_0;
  }
  function toMutableMap(_this_) {
    return LinkedHashMap_init_$Create$_2(_this_);
  }
  function emptyMap() {
    var tmp = EmptyMap_getInstance();
    return isInterface(tmp, Map_0) ? tmp : THROW_CCE();
  }
  function toMap_1(_this_, destination) {
    putAll(destination, _this_);
    return destination;
  }
  function toMap_2(_this_, destination) {
    putAll_0(destination, _this_);
    return destination;
  }
  function optimizeReadOnlyMap(_this_) {
    var tmp0_subject = _this_._get_size__0_k$();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        tmp = _this_;
        break;
      default:tmp = _this_;
        break;
    }
    return tmp;
  }
  function putAll(_this_, pairs) {
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var tmp1_loop_parameter = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = tmp1_loop_parameter.component1_0_k$();
      var value = tmp1_loop_parameter.component2_0_k$();
      _this_.put_1q9pf_k$(key, value);
      Unit_getInstance();
    }
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    this._serialVersionUID_0 = new Long(-888910638, 1920087921);
  }
  EmptyMap.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Map_0) : false) {
      tmp = other.isEmpty_0_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyMap.prototype.hashCode = function () {
    return 0;
  };
  EmptyMap.prototype.toString = function () {
    return '{}';
  };
  EmptyMap.prototype._get_size__0_k$ = function () {
    return 0;
  };
  EmptyMap.prototype.isEmpty_0_k$ = function () {
    return true;
  };
  EmptyMap.prototype.containsKey_wi7j7l_k$ = function (key) {
    return false;
  };
  EmptyMap.prototype.containsKey_2bw_k$ = function (key) {
    if (!(key == null ? true : isObject(key)))
      return false;
    else {
    }
    return this.containsKey_wi7j7l_k$((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype.get_wi7j7l_k$ = function (key) {
    return null;
  };
  EmptyMap.prototype.get_2bw_k$ = function (key) {
    if (!(key == null ? true : isObject(key)))
      return null;
    else {
    }
    return this.get_wi7j7l_k$((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype._get_entries__0_k$ = function () {
    return EmptySet_getInstance();
  };
  EmptyMap.prototype._get_values__0_k$ = function () {
    return EmptyList_getInstance();
  };
  EmptyMap.$metadata$ = {
    simpleName: 'EmptyMap',
    kind: 'object',
    interfaces: [Map_0, Serializable]
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function putAll_0(_this_, pairs) {
    var tmp0_iterator = pairs.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var tmp1_loop_parameter = tmp0_iterator.next_0_k$();
      var key = tmp1_loop_parameter.component1_0_k$();
      var value = tmp1_loop_parameter.component2_0_k$();
      _this_.put_1q9pf_k$(key, value);
      Unit_getInstance();
    }
  }
  function minus_1(_this_, key) {
    var tmp0_apply_0 = toMutableMap(_this_);
    tmp0_apply_0.remove_2bw_k$(key);
    Unit_getInstance();
    return optimizeReadOnlyMap(tmp0_apply_0);
  }
  function removeAll(_this_, predicate) {
    return filterInPlace(_this_, predicate, true);
  }
  function removeLast(_this_) {
    var tmp;
    if (_this_.isEmpty_0_k$()) {
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    } else {
      tmp = _this_.removeAt_ha5a7z_k$(_get_lastIndex__4(_this_));
    }
    return tmp;
  }
  function addAll(_this_, elements) {
    var tmp0_subject = elements;
    if (isInterface(tmp0_subject, Collection))
      return _this_.addAll_dxd4eo_k$(elements);
    else {
      {
        var result = false;
        var tmp1_iterator = elements.iterator_0_k$();
        while (tmp1_iterator.hasNext_0_k$()) {
          var item = tmp1_iterator.next_0_k$();
          if (_this_.add_2bq_k$(item))
            result = true;
        }
        return result;
      }
    }
  }
  function filterInPlace(_this_, predicate, predicateResultToRemove) {
    if (!isInterface(_this_, RandomAccess)) {
      return filterInPlace_0(isInterface(_this_, MutableIterable) ? _this_ : THROW_CCE(), predicate, predicateResultToRemove);
    } else {
    }
    var writeIndex = 0;
    var inductionVariable = 0;
    var last_1 = _get_lastIndex__4(_this_);
    if (inductionVariable <= last_1)
      do {
        var readIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = _this_.get_ha5a7z_k$(readIndex);
        if (predicate(element) === predicateResultToRemove)
          continue;
        if (!(writeIndex === readIndex)) {
          _this_.set_ddb1qf_k$(writeIndex, element);
          Unit_getInstance();
        }var tmp1 = writeIndex;
        writeIndex = tmp1 + 1 | 0;
        Unit_getInstance();
      }
       while (!(readIndex === last_1));
    if (writeIndex < _this_._get_size__0_k$()) {
      var inductionVariable_0 = _get_lastIndex__4(_this_);
      if (writeIndex <= inductionVariable_0)
        do {
          var removeIndex = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          _this_.removeAt_ha5a7z_k$(removeIndex);
          Unit_getInstance();
        }
         while (!(removeIndex === writeIndex));
      return true;
    } else {
      return false;
    }
  }
  function addAll_0(_this_, elements) {
    return _this_.addAll_dxd4eo_k$(asList(elements));
  }
  function filterInPlace_0(_this_, predicate, predicateResultToRemove) {
    var result = false;
    var tmp0_with_0 = _this_.iterator_0_k$();
    while (tmp0_with_0.hasNext_0_k$())
      if (predicate(tmp0_with_0.next_0_k$()) === predicateResultToRemove) {
        tmp0_with_0.remove_sv8swh_k$();
        result = true;
      }return result;
  }
  function removeAll_0(_this_, predicate) {
    return filterInPlace_0(_this_, predicate, true);
  }
  function Sequence() {
  }
  Sequence.$metadata$ = {
    simpleName: 'Sequence',
    kind: 'interface',
    interfaces: []
  };
  function sequence(block) {
    return new _no_name_provided__1_1(block);
  }
  function SequenceScope() {
  }
  SequenceScope.$metadata$ = {
    simpleName: 'SequenceScope',
    kind: 'class',
    interfaces: []
  };
  function iterator(block) {
    var iterator_0 = new SequenceBuilderIterator();
    iterator_0._nextStep = createCoroutineUnintercepted(block, iterator_0, iterator_0);
    return iterator_0;
  }
  function nextNotReady($this) {
    if (!$this.hasNext_0_k$())
      throw NoSuchElementException_init_$Create$();
    else
      return $this.next_0_k$();
  }
  function exceptionalState($this) {
    var tmp0_subject = $this._state;
    switch (tmp0_subject) {
      case 4:
        return NoSuchElementException_init_$Create$();
      case 5:
        return IllegalStateException_init_$Create$_0('Iterator has failed.');
      default:return IllegalStateException_init_$Create$_0('' + 'Unexpected state of the iterator: ' + $this._state);
    }
  }
  function SequenceBuilderIterator() {
    SequenceScope.call(this);
    this._state = 0;
    this._nextValue = null;
    this._nextIterator = null;
    this._nextStep = null;
  }
  SequenceBuilderIterator.prototype.hasNext_0_k$ = function () {
    while (true) {
      var tmp0_subject = this._state;
      switch (tmp0_subject) {
        case 0:
          break;
        case 1:
          if (ensureNotNull(this._nextIterator).hasNext_0_k$()) {
            this._state = 2;
            return true;
          } else {
            this._nextIterator = null;
          }

          break;
        case 4:
          return false;
        case 3:
        case 2:
          return true;
        default:throw exceptionalState(this);
      }
      this._state = 5;
      var step_0 = ensureNotNull(this._nextStep);
      this._nextStep = null;
      var tmp0_success_0 = Companion_getInstance_3();
      step_0.resumeWith_bnunh2_k$(_Result___init__impl_(Unit_getInstance()));
    }
  };
  SequenceBuilderIterator.prototype.next_0_k$ = function () {
    var tmp0_subject = this._state;
    switch (tmp0_subject) {
      case 0:
      case 1:
        return nextNotReady(this);
      case 2:
        this._state = 1;
        return ensureNotNull(this._nextIterator).next_0_k$();
      case 3:
        this._state = 0;
        var tmp = this._nextValue;
        var result = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
        this._nextValue = null;
        return result;
      default:throw exceptionalState(this);
    }
  };
  SequenceBuilderIterator.prototype.yield_iav7o_k$ = function (value, $cont) {
    this._nextValue = value;
    this._state = 3;
    var tmp0__anonymous__1 = $cont;
    this._nextStep = tmp0__anonymous__1;
    return _get_COROUTINE_SUSPENDED_();
  };
  SequenceBuilderIterator.prototype.resumeWith_6zvzl9_k$ = function (result) {
    throwOnFailure(result);
    var tmp = _Result___get_value__impl_(result);
    if (tmp == null ? true : isObject(tmp))
      tmp;
    else
      THROW_CCE();
    this._state = 4;
  };
  SequenceBuilderIterator.prototype.resumeWith_bnunh2_k$ = function (result) {
    return this.resumeWith_6zvzl9_k$(result);
  };
  SequenceBuilderIterator.prototype._get_context__0_k$ = function () {
    return EmptyCoroutineContext_getInstance();
  };
  SequenceBuilderIterator.$metadata$ = {
    simpleName: 'SequenceBuilderIterator',
    kind: 'class',
    interfaces: [Iterator_3, Continuation]
  };
  function _no_name_provided__1_1($block) {
    this._$block = $block;
  }
  _no_name_provided__1_1.prototype.iterator_2_0_k$ = function () {
    return iterator(this._$block);
  };
  _no_name_provided__1_1.prototype.iterator_0_k$ = function () {
    return this.iterator_2_0_k$();
  };
  _no_name_provided__1_1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function generateSequence(seedFunction, nextFunction) {
    return new GeneratorSequence(seedFunction, nextFunction);
  }
  function _no_name_provided__4(this$0) {
    this._this$0_2 = this$0;
    this._iterator = this._this$0_2._sequence.iterator_0_k$();
  }
  _no_name_provided__4.prototype.next_0_k$ = function () {
    return this._this$0_2._transformer(this._iterator.next_0_k$());
  };
  _no_name_provided__4.prototype.hasNext_0_k$ = function () {
    return this._iterator.hasNext_0_k$();
  };
  _no_name_provided__4.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function TransformingSequence(sequence_0, transformer) {
    this._sequence = sequence_0;
    this._transformer = transformer;
  }
  TransformingSequence.prototype.iterator_0_k$ = function () {
    return new _no_name_provided__4(this);
  };
  TransformingSequence.$metadata$ = {
    simpleName: 'TransformingSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function emptySequence() {
    return EmptySequence_getInstance();
  }
  function DropTakeSequence() {
  }
  DropTakeSequence.$metadata$ = {
    simpleName: 'DropTakeSequence',
    kind: 'interface',
    interfaces: [Sequence]
  };
  function _no_name_provided__5(this$0) {
    this._this$0_3 = this$0;
    this._left = this._this$0_3._count;
    this._iterator_0 = this._this$0_3._sequence_0.iterator_0_k$();
  }
  _no_name_provided__5.prototype.next_0_k$ = function () {
    if (this._left === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    var tmp1 = tmp0_this._left;
    tmp0_this._left = tmp1 - 1 | 0;
    Unit_getInstance();
    return this._iterator_0.next_0_k$();
  };
  _no_name_provided__5.prototype.hasNext_0_k$ = function () {
    return this._left > 0 ? this._iterator_0.hasNext_0_k$() : false;
  };
  _no_name_provided__5.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function TakeSequence(sequence_0, count_0) {
    this._sequence_0 = sequence_0;
    this._count = count_0;
    var tmp0_require_0 = this._count >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'count must be non-negative, but was ' + this._count + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }}
  TakeSequence.prototype.take_ha5a7z_k$ = function (n) {
    return n >= this._count ? this : new TakeSequence(this._sequence_0, n);
  };
  TakeSequence.prototype.iterator_0_k$ = function () {
    return new _no_name_provided__5(this);
  };
  TakeSequence.$metadata$ = {
    simpleName: 'TakeSequence',
    kind: 'class',
    interfaces: [Sequence, DropTakeSequence]
  };
  function calcNext($this) {
    $this._nextItem = $this._nextState === -2 ? $this._this$0_4._getInitialValue() : $this._this$0_4._getNextValue(ensureNotNull($this._nextItem));
    $this._nextState = $this._nextItem == null ? 0 : 1;
  }
  function _no_name_provided__6(this$0) {
    this._this$0_4 = this$0;
    this._nextItem = null;
    this._nextState = -2;
  }
  _no_name_provided__6.prototype.next_0_k$ = function () {
    if (this._nextState < 0)
      calcNext(this);
    if (this._nextState === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem;
    var result = isObject(tmp) ? tmp : THROW_CCE();
    this._nextState = -1;
    return result;
  };
  _no_name_provided__6.prototype.hasNext_0_k$ = function () {
    if (this._nextState < 0)
      calcNext(this);
    return this._nextState === 1;
  };
  _no_name_provided__6.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function GeneratorSequence(getInitialValue, getNextValue) {
    this._getInitialValue = getInitialValue;
    this._getNextValue = getNextValue;
  }
  GeneratorSequence.prototype.iterator_0_k$ = function () {
    return new _no_name_provided__6(this);
  };
  GeneratorSequence.$metadata$ = {
    simpleName: 'GeneratorSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function EmptySequence() {
    EmptySequence_instance = this;
  }
  EmptySequence.prototype.iterator_0_k$ = function () {
    return EmptyIterator_getInstance();
  };
  EmptySequence.prototype.take_ha5a7z_k$ = function (n) {
    return EmptySequence_getInstance();
  };
  EmptySequence.$metadata$ = {
    simpleName: 'EmptySequence',
    kind: 'object',
    interfaces: [Sequence, DropTakeSequence]
  };
  var EmptySequence_instance;
  function EmptySequence_getInstance() {
    if (EmptySequence_instance == null)
      new EmptySequence();
    return EmptySequence_instance;
  }
  function setOf(elements) {
    return elements.length > 0 ? toSet(elements) : emptySet();
  }
  function emptySet() {
    return EmptySet_getInstance();
  }
  function optimizeReadOnlySet(_this_) {
    var tmp0_subject = _this_._get_size__0_k$();
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_.iterator_0_k$().next_0_k$());
      default:return _this_;
    }
  }
  function EmptySet() {
    EmptySet_instance = this;
    this._serialVersionUID_1 = new Long(1993859828, 793161749);
  }
  EmptySet.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Set) : false) {
      tmp = other.isEmpty_0_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptySet.prototype.hashCode = function () {
    return 0;
  };
  EmptySet.prototype.toString = function () {
    return '[]';
  };
  EmptySet.prototype._get_size__0_k$ = function () {
    return 0;
  };
  EmptySet.prototype.isEmpty_0_k$ = function () {
    return true;
  };
  EmptySet.prototype.contains_5jd3j5_k$ = function (element) {
    return false;
  };
  EmptySet.prototype.contains_2bq_k$ = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_5jd3j5_k$(tmp);
  };
  EmptySet.prototype.containsAll_lwol4p_k$ = function (elements) {
    return elements.isEmpty_0_k$();
  };
  EmptySet.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_lwol4p_k$(elements);
  };
  EmptySet.prototype.iterator_0_k$ = function () {
    return EmptyIterator_getInstance();
  };
  EmptySet.$metadata$ = {
    simpleName: 'EmptySet',
    kind: 'object',
    interfaces: [Set, Serializable]
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function hashSetOf(elements) {
    return toCollection(elements, HashSet_init_$Create$(mapCapacity(elements.length)));
  }
  function naturalOrder() {
    var tmp = NaturalOrderComparator_getInstance();
    return isInterface(tmp, Comparator) ? tmp : THROW_CCE();
  }
  function NaturalOrderComparator() {
    NaturalOrderComparator_instance = this;
  }
  NaturalOrderComparator.prototype.compare_wgxnai_k$ = function (a, b) {
    return compareTo(a, b);
  };
  NaturalOrderComparator.prototype.compare = function (a, b) {
    var tmp = (!(a == null) ? isComparable(a) : false) ? a : THROW_CCE();
    return this.compare_wgxnai_k$(tmp, (!(b == null) ? isComparable(b) : false) ? b : THROW_CCE());
  };
  NaturalOrderComparator.$metadata$ = {
    simpleName: 'NaturalOrderComparator',
    kind: 'object',
    interfaces: [Comparator]
  };
  var NaturalOrderComparator_instance;
  function NaturalOrderComparator_getInstance() {
    if (NaturalOrderComparator_instance == null)
      new NaturalOrderComparator();
    return NaturalOrderComparator_instance;
  }
  function compareValues(a, b) {
    if (a === b)
      return 0;
    if (a == null)
      return -1;
    if (b == null)
      return 1;
    return compareTo((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
  }
  function ReverseOrderComparator() {
    ReverseOrderComparator_instance = this;
  }
  ReverseOrderComparator.prototype.compare_wgxnai_k$ = function (a, b) {
    return compareTo(b, a);
  };
  ReverseOrderComparator.prototype.compare = function (a, b) {
    var tmp = (!(a == null) ? isComparable(a) : false) ? a : THROW_CCE();
    return this.compare_wgxnai_k$(tmp, (!(b == null) ? isComparable(b) : false) ? b : THROW_CCE());
  };
  ReverseOrderComparator.$metadata$ = {
    simpleName: 'ReverseOrderComparator',
    kind: 'object',
    interfaces: [Comparator]
  };
  var ReverseOrderComparator_instance;
  function ReverseOrderComparator_getInstance() {
    if (ReverseOrderComparator_instance == null)
      new ReverseOrderComparator();
    return ReverseOrderComparator_instance;
  }
  function reversed_1(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof ReversedComparator) {
      tmp = _this_._comparator;
    } else {
      if (equals_1(tmp0_subject, NaturalOrderComparator_getInstance())) {
        var tmp_0 = ReverseOrderComparator_getInstance();
        tmp = isInterface(tmp_0, Comparator) ? tmp_0 : THROW_CCE();
      } else {
        if (equals_1(tmp0_subject, ReverseOrderComparator_getInstance())) {
          var tmp_1 = NaturalOrderComparator_getInstance();
          tmp = isInterface(tmp_1, Comparator) ? tmp_1 : THROW_CCE();
        } else {
          {
            tmp = new ReversedComparator(_this_);
          }
        }
      }
    }
    return tmp;
  }
  function ReversedComparator(comparator) {
    this._comparator = comparator;
  }
  ReversedComparator.prototype.compare_1qgdm_k$ = function (a, b) {
    return this._comparator.compare(b, a);
  };
  ReversedComparator.prototype.compare = function (a, b) {
    var tmp = (a == null ? true : isObject(a)) ? a : THROW_CCE();
    return this.compare_1qgdm_k$(tmp, (b == null ? true : isObject(b)) ? b : THROW_CCE());
  };
  ReversedComparator.$metadata$ = {
    simpleName: 'ReversedComparator',
    kind: 'class',
    interfaces: [Comparator]
  };
  function Continuation() {
  }
  Continuation.$metadata$ = {
    simpleName: 'Continuation',
    kind: 'interface',
    interfaces: []
  };
  function startCoroutine(_this_, completion) {
    var tmp0_resume_0 = intercepted(createCoroutineUnintercepted_0(_this_, completion));
    var tmp0_success_0_1 = Companion_getInstance_3();
    tmp0_resume_0.resumeWith_bnunh2_k$(_Result___init__impl_(Unit_getInstance()));
  }
  function startCoroutine_0(_this_, receiver, completion) {
    var tmp0_resume_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
    var tmp0_success_0_1 = Companion_getInstance_3();
    tmp0_resume_0.resumeWith_bnunh2_k$(_Result___init__impl_(Unit_getInstance()));
  }
  function Key() {
    Key_instance = this;
  }
  Key.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance;
  function Key_getInstance() {
    if (Key_instance == null)
      new Key();
    return Key_instance;
  }
  function ContinuationInterceptor() {
  }
  ContinuationInterceptor.prototype.releaseInterceptedContinuation_h7c6yl_k$ = function (continuation) {
  };
  ContinuationInterceptor.prototype.get_9uvjra_k$ = function (key) {
    if (key instanceof AbstractCoroutineContextKey) {
      var tmp;
      if (key.isSubKey_djuxjq_k$(this._get_key__0_k$())) {
        var tmp_0 = key.tryCast_k332zt_k$(this);
        tmp = (!(tmp_0 == null) ? isInterface(tmp_0, Element_0) : false) ? tmp_0 : null;
      } else {
        tmp = null;
      }
      return tmp;
    } else {
    }
    var tmp_1;
    if (Key_getInstance() === key) {
      tmp_1 = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  ContinuationInterceptor.prototype.minusKey_djuxjq_k$ = function (key) {
    if (key instanceof AbstractCoroutineContextKey) {
      return (key.isSubKey_djuxjq_k$(this._get_key__0_k$()) ? !(key.tryCast_k332zt_k$(this) == null) : false) ? EmptyCoroutineContext_getInstance() : this;
    } else {
    }
    return Key_getInstance() === key ? EmptyCoroutineContext_getInstance() : this;
  };
  ContinuationInterceptor.$metadata$ = {
    simpleName: 'ContinuationInterceptor',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function Key_0() {
  }
  Key_0.$metadata$ = {
    simpleName: 'Key',
    kind: 'interface',
    interfaces: []
  };
  function Element_0() {
  }
  Element_0.prototype.get_9uvjra_k$ = function (key) {
    var tmp;
    if (equals_1(this._get_key__0_k$(), key)) {
      tmp = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  };
  Element_0.prototype.fold_cq605b_k$ = function (initial, operation) {
    return operation(initial, this);
  };
  Element_0.prototype.minusKey_djuxjq_k$ = function (key) {
    return equals_1(this._get_key__0_k$(), key) ? EmptyCoroutineContext_getInstance() : this;
  };
  Element_0.$metadata$ = {
    simpleName: 'Element',
    kind: 'interface',
    interfaces: [CoroutineContext]
  };
  function _no_name_provided__7() {
  }
  _no_name_provided__7.prototype.invoke_2v6pkd_k$ = function (acc, element) {
    var removed = acc.minusKey_djuxjq_k$(element._get_key__0_k$());
    var tmp;
    if (removed === EmptyCoroutineContext_getInstance()) {
      tmp = element;
    } else {
      var interceptor = removed.get_9uvjra_k$(Key_getInstance());
      var tmp_0;
      if (interceptor == null) {
        tmp_0 = new CombinedContext(removed, element);
      } else {
        var left = removed.minusKey_djuxjq_k$(Key_getInstance());
        tmp_0 = left === EmptyCoroutineContext_getInstance() ? new CombinedContext(element, interceptor) : new CombinedContext(new CombinedContext(left, element), interceptor);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  _no_name_provided__7.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineContext) : false) ? p1 : THROW_CCE();
    return this.invoke_2v6pkd_k$(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__7.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CoroutineContext() {
  }
  CoroutineContext.prototype.plus_d7pszg_k$ = function (context) {
    var tmp;
    if (context === EmptyCoroutineContext_getInstance()) {
      tmp = this;
    } else {
      tmp = context.fold_cq605b_k$(this, _no_name_provided_$factory_1());
    }
    return tmp;
  };
  CoroutineContext.$metadata$ = {
    simpleName: 'CoroutineContext',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_1() {
    var i = new _no_name_provided__7();
    return function (p1, p2) {
      return i.invoke_2v6pkd_k$(p1, p2);
    };
  }
  function EmptyCoroutineContext() {
    EmptyCoroutineContext_instance = this;
    this._serialVersionUID_2 = new Long(0, 0);
  }
  EmptyCoroutineContext.prototype.get_9uvjra_k$ = function (key) {
    return null;
  };
  EmptyCoroutineContext.prototype.fold_cq605b_k$ = function (initial, operation) {
    return initial;
  };
  EmptyCoroutineContext.prototype.plus_d7pszg_k$ = function (context) {
    return context;
  };
  EmptyCoroutineContext.prototype.minusKey_djuxjq_k$ = function (key) {
    return this;
  };
  EmptyCoroutineContext.prototype.hashCode = function () {
    return 0;
  };
  EmptyCoroutineContext.prototype.toString = function () {
    return 'EmptyCoroutineContext';
  };
  EmptyCoroutineContext.$metadata$ = {
    simpleName: 'EmptyCoroutineContext',
    kind: 'object',
    interfaces: [CoroutineContext, Serializable]
  };
  var EmptyCoroutineContext_instance;
  function EmptyCoroutineContext_getInstance() {
    if (EmptyCoroutineContext_instance == null)
      new EmptyCoroutineContext();
    return EmptyCoroutineContext_instance;
  }
  function size($this) {
    var cur = $this;
    var size_2 = 2;
    while (true) {
      var tmp = cur._left_0;
      var tmp0_elvis_lhs = tmp instanceof CombinedContext ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return size_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      cur = tmp_0;
      var tmp1 = size_2;
      size_2 = tmp1 + 1 | 0;
      Unit_getInstance();
    }
  }
  function contains_6($this, element) {
    return equals_1($this.get_9uvjra_k$(element._get_key__0_k$()), element);
  }
  function containsAll($this, context) {
    var cur = context;
    while (true) {
      if (!contains_6($this, cur._element))
        return false;
      var next_0 = cur._left_0;
      if (next_0 instanceof CombinedContext) {
        cur = next_0;
      } else {
        {
          return contains_6($this, isInterface(next_0, Element_0) ? next_0 : THROW_CCE());
        }
      }
    }
  }
  function _no_name_provided__8() {
  }
  _no_name_provided__8.prototype.invoke_mz4o2y_k$ = function (acc, element) {
    var tmp;
    if (charSequenceLength(acc) === 0) {
      tmp = toString_1(element);
    } else {
      {
        tmp = '' + acc + ', ' + element;
      }
    }
    return tmp;
  };
  _no_name_provided__8.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    return this.invoke_mz4o2y_k$(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__8.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CombinedContext(left, element) {
    this._left_0 = left;
    this._element = element;
  }
  CombinedContext.prototype.get_9uvjra_k$ = function (key) {
    var cur = this;
    while (true) {
      var tmp0_safe_receiver = cur._element.get_9uvjra_k$(key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        return tmp0_safe_receiver;
      }
      Unit_getInstance();
      var next_0 = cur._left_0;
      if (next_0 instanceof CombinedContext) {
        cur = next_0;
      } else {
        {
          return next_0.get_9uvjra_k$(key);
        }
      }
    }
  };
  CombinedContext.prototype.fold_cq605b_k$ = function (initial, operation) {
    return operation(this._left_0.fold_cq605b_k$(initial, operation), this._element);
  };
  CombinedContext.prototype.minusKey_djuxjq_k$ = function (key) {
    var tmp0_safe_receiver = this._element.get_9uvjra_k$(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      return this._left_0;
    }
    Unit_getInstance();
    var newLeft = this._left_0.minusKey_djuxjq_k$(key);
    return newLeft === this._left_0 ? this : newLeft === EmptyCoroutineContext_getInstance() ? this._element : new CombinedContext(newLeft, this._element);
  };
  CombinedContext.prototype.equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof CombinedContext) {
        tmp_1 = size(other) === size(this);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = containsAll(other, this);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CombinedContext.prototype.hashCode = function () {
    return hashCode(this._left_0) + hashCode(this._element) | 0;
  };
  CombinedContext.prototype.toString = function () {
    return '[' + this.fold_cq605b_k$('', _no_name_provided_$factory_2()) + ']';
  };
  CombinedContext.$metadata$ = {
    simpleName: 'CombinedContext',
    kind: 'class',
    interfaces: [CoroutineContext, Serializable]
  };
  function AbstractCoroutineContextKey(baseKey, safeCast) {
    this._safeCast = safeCast;
    var tmp = this;
    var tmp_0;
    if (baseKey instanceof AbstractCoroutineContextKey) {
      tmp_0 = baseKey._topmostKey;
    } else {
      {
        tmp_0 = baseKey;
      }
    }
    tmp._topmostKey = tmp_0;
  }
  AbstractCoroutineContextKey.prototype.tryCast_k332zt_k$ = function (element) {
    return this._safeCast(element);
  };
  AbstractCoroutineContextKey.prototype.isSubKey_djuxjq_k$ = function (key) {
    return key === this ? true : this._topmostKey === key;
  };
  AbstractCoroutineContextKey.$metadata$ = {
    simpleName: 'AbstractCoroutineContextKey',
    kind: 'class',
    interfaces: [Key_0]
  };
  function AbstractCoroutineContextElement(key) {
    this._key = key;
  }
  AbstractCoroutineContextElement.prototype._get_key__0_k$ = function () {
    return this._key;
  };
  AbstractCoroutineContextElement.$metadata$ = {
    simpleName: 'AbstractCoroutineContextElement',
    kind: 'class',
    interfaces: [Element_0]
  };
  function _no_name_provided_$factory_2() {
    var i = new _no_name_provided__8();
    return function (p1, p2) {
      return i.invoke_mz4o2y_k$(p1, p2);
    };
  }
  function _get_COROUTINE_SUSPENDED_() {
    return CoroutineSingletons_COROUTINE_SUSPENDED_getInstance();
  }
  var CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  var CoroutineSingletons_UNDECIDED_instance;
  var CoroutineSingletons_RESUMED_instance;
  var CoroutineSingletons_entriesInitialized;
  function CoroutineSingletons_initEntries() {
    if (CoroutineSingletons_entriesInitialized)
      return Unit_getInstance();
    CoroutineSingletons_entriesInitialized = true;
    CoroutineSingletons_COROUTINE_SUSPENDED_instance = new CoroutineSingletons('COROUTINE_SUSPENDED', 0);
    CoroutineSingletons_UNDECIDED_instance = new CoroutineSingletons('UNDECIDED', 1);
    CoroutineSingletons_RESUMED_instance = new CoroutineSingletons('RESUMED', 2);
  }
  function CoroutineSingletons(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineSingletons.$metadata$ = {
    simpleName: 'CoroutineSingletons',
    kind: 'class',
    interfaces: []
  };
  function CoroutineSingletons_COROUTINE_SUSPENDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  }
  function CoroutineSingletons_UNDECIDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_UNDECIDED_instance;
  }
  function CoroutineSingletons_RESUMED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_RESUMED_instance;
  }
  function Default() {
    Default_instance = this;
    Random.call(this);
    this._defaultRandom = defaultPlatformRandom();
  }
  Default.prototype.nextBits_ha5a7z_k$ = function (bitCount) {
    return this._defaultRandom.nextBits_ha5a7z_k$(bitCount);
  };
  Default.prototype.nextInt_0_k$ = function () {
    return this._defaultRandom.nextInt_0_k$();
  };
  Default.prototype.nextInt_27zxwg_k$ = function (from, until_1) {
    return this._defaultRandom.nextInt_27zxwg_k$(from, until_1);
  };
  Default.prototype.nextLong_0_k$ = function () {
    return this._defaultRandom.nextLong_0_k$();
  };
  Default.prototype.nextDouble_0_k$ = function () {
    return this._defaultRandom.nextDouble_0_k$();
  };
  Default.prototype.nextDouble_e2tf9d_k$ = function (until_1) {
    return this._defaultRandom.nextDouble_e2tf9d_k$(until_1);
  };
  Default.prototype.nextDouble_ngl742_k$ = function (from, until_1) {
    return this._defaultRandom.nextDouble_ngl742_k$(from, until_1);
  };
  Default.prototype.nextFloat_0_k$ = function () {
    return this._defaultRandom.nextFloat_0_k$();
  };
  Default.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: [Serializable]
  };
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Random() {
    Default_getInstance();
  }
  Random.prototype.nextInt_0_k$ = function () {
    return this.nextBits_ha5a7z_k$(32);
  };
  Random.prototype.nextInt_27zxwg_k$ = function (from, until_1) {
    checkRangeBounds(from, until_1);
    var n = until_1 - from | 0;
    if (n > 0 ? true : n === IntCompanionObject_getInstance()._MIN_VALUE_5) {
      var tmp;
      if ((n & (-n | 0)) === n) {
        var bitCount = fastLog2(n);
        tmp = this.nextBits_ha5a7z_k$(bitCount);
      } else {
        var v;
        do {
          var bits = this.nextInt_0_k$() >>> 1;
          v = bits % n;
        }
         while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
        tmp = v;
      }
      var rnd = tmp;
      return from + rnd | 0;
    } else {
      while (true) {
        var rnd_0 = this.nextInt_0_k$();
        if (from <= rnd_0 ? rnd_0 < until_1 : false)
          return rnd_0;
      }
    }
  };
  Random.prototype.nextLong_0_k$ = function () {
    var tmp0_plus_0 = toLong(this.nextInt_0_k$()).shl_ha5a7z_k$(32);
    var tmp1_plus_0 = this.nextInt_0_k$();
    return tmp0_plus_0.plus_wiekkq_k$(toLong(tmp1_plus_0));
  };
  Random.prototype.nextDouble_0_k$ = function () {
    return doubleFromParts(this.nextBits_ha5a7z_k$(26), this.nextBits_ha5a7z_k$(27));
  };
  Random.prototype.nextDouble_e2tf9d_k$ = function (until_1) {
    return this.nextDouble_ngl742_k$(0.0, until_1);
  };
  Random.prototype.nextDouble_ngl742_k$ = function (from, until_1) {
    checkRangeBounds_0(from, until_1);
    var size_2 = until_1 - from;
    var tmp;
    if ((isInfinite_0(size_2) ? isFinite(from) : false) ? isFinite(until_1) : false) {
      var r1 = this.nextDouble_0_k$() * (until_1 / 2 - from / 2);
      tmp = from + r1 + r1;
    } else {
      tmp = from + this.nextDouble_0_k$() * size_2;
    }
    var r = tmp;
    return r >= until_1 ? nextDown(until_1) : r;
  };
  Random.prototype.nextFloat_0_k$ = function () {
    return this.nextBits_ha5a7z_k$(24) / 16777216;
  };
  Random.$metadata$ = {
    simpleName: 'Random',
    kind: 'class',
    interfaces: []
  };
  function Random_0(seed) {
    return XorWowRandom_init_$Create$(seed.toInt_0_k$(), seed.shr_ha5a7z_k$(32).toInt_0_k$());
  }
  function checkRangeBounds(from, until_1) {
    var tmp0_require_0 = until_1 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_1);
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return tmp;
  }
  function fastLog2(value) {
    return 31 - Math.clz32(value) | 0;
  }
  function checkRangeBounds_0(from, until_1) {
    var tmp0_require_0 = until_1 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_1);
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return tmp;
  }
  function boundsErrorMessage(from, until_1) {
    return '' + 'Random range is empty: [' + from + ', ' + until_1 + ').';
  }
  function Random_1(seed) {
    return XorWowRandom_init_$Create$(seed, seed >> 31);
  }
  function takeUpperBits(_this_, bitCount) {
    return _this_ >>> (32 - bitCount | 0) & (-bitCount | 0) >> 31;
  }
  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ seed2 >>> 4);
    return $this;
  }
  function XorWowRandom_init_$Create$(seed1, seed2) {
    return XorWowRandom_init_$Init$(seed1, seed2, Object.create(XorWowRandom.prototype));
  }
  function Companion_3() {
    Companion_instance_2 = this;
    this._serialVersionUID_3 = new Long(0, 0);
  }
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function XorWowRandom(x, y, z, w, v, addend) {
    Companion_getInstance_2();
    Random.call(this);
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
    this._v = v;
    this._addend = addend;
    var tmp0_require_0 = !((this._x | this._y | this._z | this._w | this._v) === 0);
    if (!tmp0_require_0) {
      var message_2 = 'Initial state must have at least one non-zero element.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var inductionVariable = 0;
    if (inductionVariable < 64)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.nextInt_0_k$();
        Unit_getInstance();
      }
       while (inductionVariable < 64);
  }
  XorWowRandom.prototype.nextInt_0_k$ = function () {
    var t = this._x;
    t = t ^ t >>> 2;
    this._x = this._y;
    this._y = this._z;
    this._z = this._w;
    var v0 = this._v;
    this._w = v0;
    t = t ^ t << 1 ^ v0 ^ v0 << 4;
    this._v = t;
    var tmp0_this = this;
    tmp0_this._addend = tmp0_this._addend + 362437 | 0;
    return t + this._addend | 0;
  };
  XorWowRandom.prototype.nextBits_ha5a7z_k$ = function (bitCount) {
    return takeUpperBits(this.nextInt_0_k$(), bitCount);
  };
  XorWowRandom.$metadata$ = {
    simpleName: 'XorWowRandom',
    kind: 'class',
    interfaces: [Serializable]
  };
  function checkStepIsPositive(isPositive, step_0) {
    if (!isPositive)
      throw IllegalArgumentException_init_$Create$('' + 'Step must be positive, was: ' + step_0 + '.');
  }
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function appendElement(_this_, element, transform) {
    if (!(transform == null)) {
      _this_.append_v1o70a_k$(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_v1o70a_k$(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_wi8o78_k$(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_v1o70a_k$(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function equals(_this_, other, ignoreCase) {
    if (_this_.equals(other))
      return true;
    if (!ignoreCase)
      return false;
    var thisUpper = uppercaseChar(_this_);
    var otherUpper = uppercaseChar(other);
    var tmp;
    if (thisUpper.equals(otherUpper)) {
      tmp = true;
    } else {
      var tmp0_asDynamic_0 = thisUpper.toString();
      var tmp1_unsafeCast_0 = tmp0_asDynamic_0.toLowerCase();
      var tmp_0 = charSequenceGet(tmp1_unsafeCast_0, 0);
      var tmp2_asDynamic_0 = otherUpper.toString();
      var tmp3_unsafeCast_0 = tmp2_asDynamic_0.toLowerCase();
      tmp = tmp_0.equals(charSequenceGet(tmp3_unsafeCast_0, 0));
    }
    return tmp;
  }
  function toIntOrNull(_this_) {
    return toIntOrNull_0(_this_, 10);
  }
  function toLongOrNull(_this_) {
    return toLongOrNull_0(_this_, 10);
  }
  function toIntOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_wi8o78_k$(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        limit = IntCompanionObject_getInstance()._MIN_VALUE_5;
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        limit = -IntCompanionObject_getInstance()._MAX_VALUE_5 | 0;
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      limit = -IntCompanionObject_getInstance()._MAX_VALUE_5 | 0;
    }
    var limitForMaxRadix = (-IntCompanionObject_getInstance()._MAX_VALUE_5 | 0) / 36 | 0;
    var limitBeforeMul = limitForMaxRadix;
    var result = 0;
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result < limitBeforeMul) {
          if (limitBeforeMul === limitForMaxRadix) {
            limitBeforeMul = limit / radix | 0;
            if (result < limitBeforeMul) {
              return null;
            }} else {
            return null;
          }
        }result = imul(result, radix);
        if (result < (limit + digit | 0))
          return null;
        result = result - digit | 0;
      }
       while (inductionVariable < length);
    return isNegative_0 ? result : -result | 0;
  }
  function toLongOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_wi8o78_k$(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        Companion_getInstance_17();
        limit = new Long(0, -2147483648);
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        Companion_getInstance_17();
        limit = (new Long(-1, 2147483647)).unaryMinus_0_k$();
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      Companion_getInstance_17();
      limit = (new Long(-1, 2147483647)).unaryMinus_0_k$();
    }
    Companion_getInstance_17();
    var tmp0_div_0 = (new Long(-1, 2147483647)).unaryMinus_0_k$();
    var limitForMaxRadix = tmp0_div_0.div_wiekkq_k$(new Long(36, 0));
    var limitBeforeMul = limitForMaxRadix;
    var result = new Long(0, 0);
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result.compareTo_wiekkq_k$(limitBeforeMul) < 0) {
          if (limitBeforeMul.equals(limitForMaxRadix)) {
            limitBeforeMul = limit.div_wiekkq_k$(toLong(radix));
            if (result.compareTo_wiekkq_k$(limitBeforeMul) < 0) {
              return null;
            }} else {
            return null;
          }
        }var tmp1_times_0 = result;
        result = tmp1_times_0.times_wiekkq_k$(toLong(radix));
        var tmp = result;
        if (tmp.compareTo_wiekkq_k$(limit.plus_wiekkq_k$(toLong(digit))) < 0)
          return null;
        else {
        }
        var tmp2_minus_0 = result;
        result = tmp2_minus_0.minus_wiekkq_k$(toLong(digit));
      }
       while (inductionVariable < length);
    return isNegative_0 ? result : result.unaryMinus_0_k$();
  }
  function numberFormatError(input) {
    throw NumberFormatException_init_$Create$('' + "Invalid number format: '" + input + "'");
  }
  function startsWith(_this_, char, ignoreCase) {
    return charSequenceLength(_this_) > 0 ? equals(charSequenceGet(_this_, 0), char, ignoreCase) : false;
  }
  function startsWith$default(_this_, char, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith(_this_, char, ignoreCase);
  }
  function substringBefore(_this_, delimiter, missingDelimiterValue) {
    var index_0 = indexOf$default(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index_0 === -1) {
      tmp = missingDelimiterValue;
    } else {
      tmp = _this_.substring(0, index_0);
    }
    return tmp;
  }
  function substringBefore$default(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringBefore(_this_, delimiter, missingDelimiterValue);
  }
  function substringAfter(_this_, delimiter, missingDelimiterValue) {
    var index_0 = indexOf$default(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index_0 === -1) {
      tmp = missingDelimiterValue;
    } else {
      var tmp0_substring_0 = index_0 + 1 | 0;
      var tmp1_substring_0 = _this_.length;
      tmp = _this_.substring(tmp0_substring_0, tmp1_substring_0);
    }
    return tmp;
  }
  function substringAfter$default(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringAfter(_this_, delimiter, missingDelimiterValue);
  }
  function padStart(_this_, length, padChar) {
    return toString_1(padStart_0(isCharSequence(_this_) ? _this_ : THROW_CCE(), length, padChar));
  }
  function removeSuffix(_this_, suffix) {
    if (endsWith$default_0(_this_, suffix, false, 2, null)) {
      var tmp0_substring_0 = _this_.length - charSequenceLength(suffix) | 0;
      return _this_.substring(0, tmp0_substring_0);
    } else {
    }
    return _this_;
  }
  function trim(_this_, chars) {
    var tmp0_trim_0 = isCharSequence(_this_) ? _this_ : THROW_CCE();
    var startIndex_1 = 0;
    var endIndex_2 = charSequenceLength(tmp0_trim_0) - 1 | 0;
    var startFound_3 = false;
    $l$break: while (startIndex_1 <= endIndex_2) {
      var index_4 = !startFound_3 ? startIndex_1 : endIndex_2;
      var tmp1__anonymous__1 = charSequenceGet(tmp0_trim_0, index_4);
      var match_5 = contains_1(chars, tmp1__anonymous__1);
      if (!startFound_3) {
        if (!match_5)
          startFound_3 = true;
        else
          startIndex_1 = startIndex_1 + 1 | 0;
      } else {
        if (!match_5)
          break $l$break;
        else
          endIndex_2 = endIndex_2 - 1 | 0;
      }
    }
    return toString_1(charSequenceSubSequence(tmp0_trim_0, startIndex_1, endIndex_2 + 1 | 0));
  }
  function trimStart(_this_, chars) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_trimStart_0 = isCharSequence(_this_) ? _this_ : THROW_CCE();
      var inductionVariable = 0;
      var last_1 = charSequenceLength(tmp0_trimStart_0) - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1__anonymous__1 = charSequenceGet(tmp0_trimStart_0, index_2);
          if (!contains_1(chars, tmp1__anonymous__1)) {
            tmp$ret$0 = charSequenceSubSequence(tmp0_trimStart_0, index_2, charSequenceLength(tmp0_trimStart_0));
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable <= last_1);
      tmp$ret$0 = '';
    }
     while (false);
    return toString_1(tmp$ret$0);
  }
  function substringBeforeLast(_this_, delimiter, missingDelimiterValue) {
    var index_0 = lastIndexOf$default(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index_0 === -1) {
      tmp = missingDelimiterValue;
    } else {
      tmp = _this_.substring(0, index_0);
    }
    return tmp;
  }
  function substringBeforeLast$default(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringBeforeLast(_this_, delimiter, missingDelimiterValue);
  }
  function split(_this_, delimiters, ignoreCase, limit) {
    if (delimiters.length === 1) {
      return split_1(_this_, delimiters[0].toString(), ignoreCase, limit);
    }var tmp0_map_0 = asIterable(rangesDelimitedBy$default(_this_, delimiters, 0, ignoreCase, limit, 2, null));
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(substring(_this_, item_2_3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  }
  function split$default(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return split(_this_, delimiters, ignoreCase, limit);
  }
  function split_0(_this_, delimiters, ignoreCase, limit) {
    if (delimiters.length === 1) {
      var delimiter = delimiters[0];
      if (!(charSequenceLength(delimiter) === 0)) {
        return split_1(_this_, delimiter, ignoreCase, limit);
      } else {
      }
    }var tmp0_map_0 = asIterable(rangesDelimitedBy$default_0(_this_, delimiters, 0, ignoreCase, limit, 2, null));
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(substring(_this_, item_2_3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  }
  function split$default_0(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return split_0(_this_, delimiters, ignoreCase, limit);
  }
  function indexOf_6(_this_, char, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      tmp = indexOfAny(_this_, charArrayOf([char]), startIndex, ignoreCase);
    } else {
      {
        var tmp1_nativeIndexOf_0 = _this_;
        var tmp0_nativeIndexOf_0 = char.toString();
        tmp = tmp1_nativeIndexOf_0.indexOf(tmp0_nativeIndexOf_0, startIndex);
      }
    }
    return tmp;
  }
  function indexOf$default(_this_, char, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOf_6(_this_, char, startIndex, ignoreCase);
  }
  function indexOf_7(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp_1 = charSequenceLength(_this_);
      tmp = indexOf$default_1(_this_, string, startIndex, tmp_1, ignoreCase, false, 16, null);
    } else {
      {
        var tmp0_nativeIndexOf_0 = _this_;
        tmp = tmp0_nativeIndexOf_0.indexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function indexOf$default_0(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOf_7(_this_, string, startIndex, ignoreCase);
  }
  function contains_7(_this_, char, ignoreCase) {
    return indexOf$default(_this_, char, 0, ignoreCase, 2, null) >= 0;
  }
  function contains$default(_this_, char, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return contains_7(_this_, char, ignoreCase);
  }
  function lineSequence(_this_) {
    return splitToSequence$default(_this_, ['\r\n', '\n', '\r'], false, 0, 6, null);
  }
  function trimEnd(_this_, chars) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_trimEnd_0 = isCharSequence(_this_) ? _this_ : THROW_CCE();
      var inductionVariable = charSequenceLength(tmp0_trimEnd_0) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp1__anonymous__1 = charSequenceGet(tmp0_trimEnd_0, index_2);
          if (!contains_1(chars, tmp1__anonymous__1)) {
            tmp$ret$0 = charSequenceSubSequence(tmp0_trimEnd_0, 0, index_2 + 1 | 0);
            break l$ret$1;
          } else {
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$0 = '';
    }
     while (false);
    return toString_1(tmp$ret$0);
  }
  function substringAfterLast(_this_, delimiter, missingDelimiterValue) {
    var index_0 = lastIndexOf$default(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index_0 === -1) {
      tmp = missingDelimiterValue;
    } else {
      var tmp0_substring_0 = index_0 + 1 | 0;
      var tmp1_substring_0 = _this_.length;
      tmp = _this_.substring(tmp0_substring_0, tmp1_substring_0);
    }
    return tmp;
  }
  function substringAfterLast$default(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringAfterLast(_this_, delimiter, missingDelimiterValue);
  }
  function _get_lastIndex__5(_this_) {
    return charSequenceLength(_this_) - 1 | 0;
  }
  function lastIndexOf(_this_, char, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      tmp = lastIndexOfAny(_this_, charArrayOf([char]), startIndex, ignoreCase);
    } else {
      {
        var tmp1_nativeLastIndexOf_0 = _this_;
        var tmp0_nativeLastIndexOf_0 = char.toString();
        tmp = tmp1_nativeLastIndexOf_0.lastIndexOf(tmp0_nativeLastIndexOf_0, startIndex);
      }
    }
    return tmp;
  }
  function lastIndexOf$default(_this_, char, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__5(_this_);
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return lastIndexOf(_this_, char, startIndex, ignoreCase);
  }
  function contains_8(_this_, other, ignoreCase) {
    var tmp;
    if (typeof other === 'string') {
      tmp = indexOf$default_0(_this_, other, 0, ignoreCase, 2, null) >= 0;
    } else {
      {
        var tmp_0 = charSequenceLength(_this_);
        tmp = indexOf$default_1(_this_, other, 0, tmp_0, ignoreCase, false, 16, null) >= 0;
      }
    }
    return tmp;
  }
  function contains$default_0(_this_, other, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return contains_8(_this_, other, ignoreCase);
  }
  function removePrefix(_this_, prefix) {
    if (startsWith$default_0(_this_, prefix, false, 2, null)) {
      var tmp0_substring_0 = charSequenceLength(prefix);
      return _this_.substring(tmp0_substring_0);
    } else {
    }
    return _this_;
  }
  function endsWith(_this_, char, ignoreCase) {
    return charSequenceLength(_this_) > 0 ? equals(charSequenceGet(_this_, _get_lastIndex__5(_this_)), char, ignoreCase) : false;
  }
  function endsWith$default(_this_, char, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith(_this_, char, ignoreCase);
  }
  function padStart_0(_this_, length, padChar) {
    if (length < 0)
      throw IllegalArgumentException_init_$Create$('' + 'Desired length ' + length + ' is less than zero.');
    if (length <= charSequenceLength(_this_))
      return charSequenceSubSequence(_this_, 0, charSequenceLength(_this_));
    var sb = StringBuilder_init_$Create$(length);
    var inductionVariable = 1;
    var last_1 = length - charSequenceLength(_this_) | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.append_wi8o78_k$(padChar);
        Unit_getInstance();
      }
       while (!(i === last_1));
    sb.append_v1o70a_k$(_this_);
    Unit_getInstance();
    return sb;
  }
  function endsWith_0(_this_, suffix, ignoreCase) {
    var tmp;
    var tmp_0;
    if (!ignoreCase) {
      tmp_0 = typeof _this_ === 'string';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = typeof suffix === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      return endsWith$default_1(_this_, suffix, false, 2, null);
    } else {
      return regionMatchesImpl(_this_, charSequenceLength(_this_) - charSequenceLength(suffix) | 0, suffix, 0, charSequenceLength(suffix), ignoreCase);
    }
  }
  function endsWith$default_0(_this_, suffix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith_0(_this_, suffix, ignoreCase);
  }
  function trim_0(_this_) {
    var startIndex_1 = 0;
    var endIndex_2 = charSequenceLength(_this_) - 1 | 0;
    var startFound_3 = false;
    $l$break: while (startIndex_1 <= endIndex_2) {
      var index_4 = !startFound_3 ? startIndex_1 : endIndex_2;
      var match_5 = isWhitespace(charSequenceGet(_this_, index_4));
      if (!startFound_3) {
        if (!match_5)
          startFound_3 = true;
        else
          startIndex_1 = startIndex_1 + 1 | 0;
      } else {
        if (!match_5)
          break $l$break;
        else
          endIndex_2 = endIndex_2 - 1 | 0;
      }
    }
    return charSequenceSubSequence(_this_, startIndex_1, endIndex_2 + 1 | 0);
  }
  function split_1(_this_, delimiter, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var currentOffset = 0;
    var nextIndex = indexOf_7(_this_, delimiter, currentOffset, ignoreCase);
    if (nextIndex === -1 ? true : limit === 1) {
      return listOf_0(toString_1(_this_));
    }var isLimited = limit > 0;
    var result = ArrayList_init_$Create$_0(isLimited ? coerceAtMost(limit, 10) : 10);
    $l$break: do {
      var tmp1_substring_0 = currentOffset;
      var tmp2_substring_0 = nextIndex;
      result.add_2bq_k$(toString_1(charSequenceSubSequence(_this_, tmp1_substring_0, tmp2_substring_0)));
      Unit_getInstance();
      currentOffset = nextIndex + delimiter.length | 0;
      if (isLimited ? result._get_size__0_k$() === (limit - 1 | 0) : false)
        break $l$break;
      nextIndex = indexOf_7(_this_, delimiter, currentOffset, ignoreCase);
    }
     while (!(nextIndex === -1));
    var tmp3_substring_0 = currentOffset;
    var tmp4_substring_0 = charSequenceLength(_this_);
    result.add_2bq_k$(toString_1(charSequenceSubSequence(_this_, tmp3_substring_0, tmp4_substring_0)));
    Unit_getInstance();
    return result;
  }
  function substring(_this_, range) {
    return toString_1(charSequenceSubSequence(_this_, range._get_start__0_k$(), range._get_endInclusive__0_k$() + 1 | 0));
  }
  function rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return new DelimitedRangesSequence(_this_, startIndex, limit, _no_name_provided_$factory_3(delimiters, ignoreCase));
  }
  function rangesDelimitedBy$default(_this_, delimiters, startIndex, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    if (!(($mask0 & 8) === 0))
      limit = 0;
    return rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit);
  }
  function rangesDelimitedBy_0(_this_, delimiters, startIndex, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var delimitersList = asList(delimiters);
    return new DelimitedRangesSequence(_this_, startIndex, limit, _no_name_provided_$factory_4(delimitersList, ignoreCase));
  }
  function rangesDelimitedBy$default_0(_this_, delimiters, startIndex, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    if (!(($mask0 & 8) === 0))
      limit = 0;
    return rangesDelimitedBy_0(_this_, delimiters, startIndex, ignoreCase, limit);
  }
  function indexOfAny(_this_, chars, startIndex, ignoreCase) {
    var tmp;
    if (!ignoreCase ? chars.length === 1 : false) {
      tmp = typeof _this_ === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      var tmp1_nativeIndexOf_0 = _this_;
      var tmp0_nativeIndexOf_0 = char.toString();
      return tmp1_nativeIndexOf_0.indexOf(tmp0_nativeIndexOf_0, startIndex);
    } else {
    }
    var inductionVariable = coerceAtLeast(startIndex, 0);
    var last_1 = _get_lastIndex__5(_this_);
    if (inductionVariable <= last_1)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var charAtIndex = charSequenceGet(_this_, index_0);
        var tmp$ret$0;
        l$ret$1: do {
          var indexedObject = chars;
          var inductionVariable_0 = 0;
          var last_2 = indexedObject.length;
          while (inductionVariable_0 < last_2) {
            var element_2 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (equals(element_2, charAtIndex, ignoreCase)) {
              tmp$ret$0 = true;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = false;
        }
         while (false);
        if (tmp$ret$0)
          return index_0;
        else {
        }
      }
       while (!(index_0 === last_1));
    return -1;
  }
  function indexOf_8(_this_, other, startIndex, endIndex, ignoreCase, last_1) {
    var indices = !last_1 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this_))) : downTo(coerceAtMost(startIndex, _get_lastIndex__5(_this_)), coerceAtLeast(endIndex, 0));
    var tmp;
    if (typeof _this_ === 'string') {
      tmp = typeof other === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var inductionVariable = indices._first_0;
      var last_2 = indices._last;
      var step_0 = indices._step_2;
      if ((step_0 > 0 ? inductionVariable <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable : false)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          if (regionMatches(other, 0, _this_, index_0, charSequenceLength(other), ignoreCase))
            return index_0;
        }
         while (!(index_0 === last_2));
    } else {
      {
        var inductionVariable_0 = indices._first_0;
        var last_3 = indices._last;
        var step_1 = indices._step_2;
        if ((step_1 > 0 ? inductionVariable_0 <= last_3 : false) ? true : step_1 < 0 ? last_3 <= inductionVariable_0 : false)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            if (regionMatchesImpl(other, 0, _this_, index_1, charSequenceLength(other), ignoreCase))
              return index_1;
          }
           while (!(index_1 === last_3));
      }
    }
    return -1;
  }
  function indexOf$default_1(_this_, other, startIndex, endIndex, ignoreCase, last_1, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      last_1 = false;
    return indexOf_8(_this_, other, startIndex, endIndex, ignoreCase, last_1);
  }
  function splitToSequence(_this_, delimiters, ignoreCase, limit) {
    var tmp = rangesDelimitedBy$default_0(_this_, delimiters, 0, ignoreCase, limit, 2, null);
    return map(tmp, _no_name_provided_$factory_5(_this_));
  }
  function splitToSequence$default(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return splitToSequence(_this_, delimiters, ignoreCase, limit);
  }
  function lastIndexOfAny(_this_, chars, startIndex, ignoreCase) {
    var tmp;
    if (!ignoreCase ? chars.length === 1 : false) {
      tmp = typeof _this_ === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      var tmp1_nativeLastIndexOf_0 = _this_;
      var tmp0_nativeLastIndexOf_0 = char.toString();
      return tmp1_nativeLastIndexOf_0.lastIndexOf(tmp0_nativeLastIndexOf_0, startIndex);
    } else {
    }
    var inductionVariable = coerceAtMost(startIndex, _get_lastIndex__5(_this_));
    if (0 <= inductionVariable)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var charAtIndex = charSequenceGet(_this_, index_0);
        var tmp$ret$0;
        l$ret$1: do {
          var indexedObject = chars;
          var inductionVariable_0 = 0;
          var last_1 = indexedObject.length;
          while (inductionVariable_0 < last_1) {
            var element_2 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (equals(element_2, charAtIndex, ignoreCase)) {
              tmp$ret$0 = true;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = false;
        }
         while (false);
        if (tmp$ret$0)
          return index_0;
        else {
        }
      }
       while (0 <= inductionVariable);
    return -1;
  }
  function startsWith_0(_this_, prefix, ignoreCase) {
    var tmp;
    var tmp_0;
    if (!ignoreCase) {
      tmp_0 = typeof _this_ === 'string';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = typeof prefix === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      return startsWith$default_1(_this_, prefix, false, 2, null);
    } else {
      return regionMatchesImpl(_this_, 0, prefix, 0, charSequenceLength(prefix), ignoreCase);
    }
  }
  function startsWith$default_0(_this_, prefix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith_0(_this_, prefix, ignoreCase);
  }
  function trimEnd_0(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = charSequenceLength(_this_) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (!isWhitespace(charSequenceGet(_this_, index_2))) {
            tmp$ret$0 = charSequenceSubSequence(_this_, 0, index_2 + 1 | 0);
            break l$ret$1;
          }}
         while (0 <= inductionVariable);
      tmp$ret$0 = '';
    }
     while (false);
    return tmp$ret$0;
  }
  function regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    if (((otherOffset < 0 ? true : thisOffset < 0) ? true : thisOffset > (charSequenceLength(_this_) - length | 0)) ? true : otherOffset > (charSequenceLength(other) - length | 0)) {
      return false;
    }var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(charSequenceGet(_this_, thisOffset + index_0 | 0), charSequenceGet(other, otherOffset + index_0 | 0), ignoreCase))
          return false;
      }
       while (inductionVariable < length);
    return true;
  }
  function calcNext_0($this) {
    if ($this._nextSearchIndex < 0) {
      $this._nextState_0 = 0;
      $this._nextItem_0 = null;
    } else {
      var tmp;
      var tmp_0;
      if ($this._this$0_5._limit > 0) {
        var tmp0_this = $this;
        tmp0_this._counter = tmp0_this._counter + 1 | 0;
        tmp_0 = tmp0_this._counter >= $this._this$0_5._limit;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        {
          tmp = $this._nextSearchIndex > charSequenceLength($this._this$0_5._input);
        }
      }
      if (tmp) {
        $this._nextItem_0 = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__5($this._this$0_5._input));
        $this._nextSearchIndex = -1;
      } else {
        {
          var match = $this._this$0_5._getNextMatch($this._this$0_5._input, $this._nextSearchIndex);
          if (match == null) {
            $this._nextItem_0 = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__5($this._this$0_5._input));
            $this._nextSearchIndex = -1;
          } else {
            var tmp1_container = match;
            var index_0 = tmp1_container.component1_0_k$();
            var length = tmp1_container.component2_0_k$();
            $this._nextItem_0 = until($this._currentStartIndex, index_0);
            $this._currentStartIndex = index_0 + length | 0;
            $this._nextSearchIndex = $this._currentStartIndex + (length === 0 ? 1 : 0) | 0;
          }
        }
      }
      $this._nextState_0 = 1;
    }
  }
  function _no_name_provided__9(this$0) {
    this._this$0_5 = this$0;
    this._nextState_0 = -1;
    this._currentStartIndex = coerceIn(this._this$0_5._startIndex, 0, charSequenceLength(this._this$0_5._input));
    this._nextSearchIndex = this._currentStartIndex;
    this._nextItem_0 = null;
    this._counter = 0;
  }
  _no_name_provided__9.prototype.next_0_k$ = function () {
    if (this._nextState_0 === -1)
      calcNext_0(this);
    if (this._nextState_0 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem_0;
    var result = tmp instanceof IntRange ? tmp : THROW_CCE();
    this._nextItem_0 = null;
    this._nextState_0 = -1;
    return result;
  };
  _no_name_provided__9.prototype.hasNext_0_k$ = function () {
    if (this._nextState_0 === -1)
      calcNext_0(this);
    return this._nextState_0 === 1;
  };
  _no_name_provided__9.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
    this._input = input;
    this._startIndex = startIndex;
    this._limit = limit;
    this._getNextMatch = getNextMatch;
  }
  DelimitedRangesSequence.prototype.iterator_0_k$ = function () {
    return new _no_name_provided__9(this);
  };
  DelimitedRangesSequence.$metadata$ = {
    simpleName: 'DelimitedRangesSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function findAnyOf(_this_, strings, startIndex, ignoreCase, last_1) {
    if (!ignoreCase ? strings._get_size__0_k$() === 1 : false) {
      var string = single_0(strings);
      var tmp;
      if (!last_1) {
        tmp = indexOf$default_0(_this_, string, startIndex, false, 4, null);
      } else {
        tmp = lastIndexOf$default_0(_this_, string, startIndex, false, 4, null);
      }
      var index_0 = tmp;
      return index_0 < 0 ? null : to(index_0, string);
    }var indices = !last_1 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this_)) : downTo(coerceAtMost(startIndex, _get_lastIndex__5(_this_)), 0);
    if (typeof _this_ === 'string') {
      var inductionVariable = indices._first_0;
      var last_2 = indices._last;
      var step_0 = indices._step_2;
      if ((step_0 > 0 ? inductionVariable <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable : false)
        do {
          var index_1 = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var tmp$ret$0;
          l$ret$1: do {
            var tmp0_iterator_1 = strings.iterator_0_k$();
            while (tmp0_iterator_1.hasNext_0_k$()) {
              var element_2 = tmp0_iterator_1.next_0_k$();
              if (regionMatches(element_2, 0, _this_, index_1, element_2.length, ignoreCase)) {
                tmp$ret$0 = element_2;
                break l$ret$1;
              } else {
              }
            }
            tmp$ret$0 = null;
          }
           while (false);
          var matchingString = tmp$ret$0;
          if (!(matchingString == null))
            return to(index_1, matchingString);
        }
         while (!(index_1 === last_2));
    } else {
      {
        var inductionVariable_0 = indices._first_0;
        var last_3 = indices._last;
        var step_1 = indices._step_2;
        if ((step_1 > 0 ? inductionVariable_0 <= last_3 : false) ? true : step_1 < 0 ? last_3 <= inductionVariable_0 : false)
          do {
            var index_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            var tmp$ret$2;
            l$ret$3: do {
              var tmp0_iterator_1_0 = strings.iterator_0_k$();
              while (tmp0_iterator_1_0.hasNext_0_k$()) {
                var element_2_0 = tmp0_iterator_1_0.next_0_k$();
                if (regionMatchesImpl(element_2_0, 0, _this_, index_2, element_2_0.length, ignoreCase)) {
                  tmp$ret$2 = element_2_0;
                  break l$ret$3;
                } else {
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var matchingString_0 = tmp$ret$2;
            if (!(matchingString_0 == null))
              return to(index_2, matchingString_0);
          }
           while (!(index_2 === last_3));
      }
    }
    return null;
  }
  function lastIndexOf_0(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_8(_this_, string, startIndex, 0, ignoreCase, true);
    } else {
      {
        var tmp0_nativeLastIndexOf_0 = _this_;
        tmp = tmp0_nativeLastIndexOf_0.lastIndexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function lastIndexOf$default_0(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__5(_this_);
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return lastIndexOf_0(_this_, string, startIndex, ignoreCase);
  }
  function lines(_this_) {
    return toList_5(lineSequence(_this_));
  }
  function _no_name_provided__10($delimiters, $ignoreCase) {
    this._$delimiters = $delimiters;
    this._$ignoreCase = $ignoreCase;
  }
  _no_name_provided__10.prototype.invoke_w2qdfo_k$ = function ($this$$receiver, currentIndex) {
    var tmp0_let_0 = indexOfAny($this$$receiver, this._$delimiters, currentIndex, this._$ignoreCase);
    return tmp0_let_0 < 0 ? null : to(tmp0_let_0, 1);
  };
  _no_name_provided__10.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_w2qdfo_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__10.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__11($delimitersList, $ignoreCase) {
    this._$delimitersList = $delimitersList;
    this._$ignoreCase_0 = $ignoreCase;
  }
  _no_name_provided__11.prototype.invoke_w2qdfo_k$ = function ($this$$receiver, currentIndex) {
    var tmp0_safe_receiver = findAnyOf($this$$receiver, this._$delimitersList, currentIndex, this._$ignoreCase_0, false);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = to(tmp0_safe_receiver._first, tmp0_safe_receiver._second.length);
    }
    return tmp;
  };
  _no_name_provided__11.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_w2qdfo_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__11.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__12($this_splitToSequence) {
    this._$this_splitToSequence = $this_splitToSequence;
  }
  _no_name_provided__12.prototype.invoke_em8bnc_k$ = function (it) {
    return substring(this._$this_splitToSequence, it);
  };
  _no_name_provided__12.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_em8bnc_k$(p1 instanceof IntRange ? p1 : THROW_CCE());
  };
  _no_name_provided__12.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_3($delimiters, $ignoreCase) {
    var i = new _no_name_provided__10($delimiters, $ignoreCase);
    return function (p1, p2) {
      return i.invoke_w2qdfo_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_4($delimitersList, $ignoreCase) {
    var i = new _no_name_provided__11($delimitersList, $ignoreCase);
    return function (p1, p2) {
      return i.invoke_w2qdfo_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_5($this_splitToSequence) {
    var i = new _no_name_provided__12($this_splitToSequence);
    return function (p1) {
      return i.invoke_em8bnc_k$(p1);
    };
  }
  function MatchResult() {
  }
  MatchResult.$metadata$ = {
    simpleName: 'MatchResult',
    kind: 'interface',
    interfaces: []
  };
  function MatchGroupCollection() {
  }
  MatchGroupCollection.$metadata$ = {
    simpleName: 'MatchGroupCollection',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Lazy() {
  }
  Lazy.$metadata$ = {
    simpleName: 'Lazy',
    kind: 'interface',
    interfaces: []
  };
  function UnsafeLazyImpl(initializer) {
    this._initializer = initializer;
    this.__value = UNINITIALIZED_VALUE_getInstance();
  }
  UnsafeLazyImpl.prototype._get_value__0_k$ = function () {
    if (this.__value === UNINITIALIZED_VALUE_getInstance()) {
      this.__value = ensureNotNull(this._initializer)();
      this._initializer = null;
    }var tmp = this.__value;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  UnsafeLazyImpl.prototype.isInitialized_0_k$ = function () {
    return !(this.__value === UNINITIALIZED_VALUE_getInstance());
  };
  UnsafeLazyImpl.prototype.toString = function () {
    return this.isInitialized_0_k$() ? toString_0(this._get_value__0_k$()) : 'Lazy value not initialized yet.';
  };
  UnsafeLazyImpl.$metadata$ = {
    simpleName: 'UnsafeLazyImpl',
    kind: 'class',
    interfaces: [Lazy, Serializable]
  };
  function UNINITIALIZED_VALUE() {
    UNINITIALIZED_VALUE_instance = this;
  }
  UNINITIALIZED_VALUE.$metadata$ = {
    simpleName: 'UNINITIALIZED_VALUE',
    kind: 'object',
    interfaces: []
  };
  var UNINITIALIZED_VALUE_instance;
  function UNINITIALIZED_VALUE_getInstance() {
    if (UNINITIALIZED_VALUE_instance == null)
      new UNINITIALIZED_VALUE();
    return UNINITIALIZED_VALUE_instance;
  }
  var LazyThreadSafetyMode_SYNCHRONIZED_instance;
  var LazyThreadSafetyMode_PUBLICATION_instance;
  var LazyThreadSafetyMode_NONE_instance;
  var LazyThreadSafetyMode_entriesInitialized;
  function LazyThreadSafetyMode_initEntries() {
    if (LazyThreadSafetyMode_entriesInitialized)
      return Unit_getInstance();
    LazyThreadSafetyMode_entriesInitialized = true;
    LazyThreadSafetyMode_SYNCHRONIZED_instance = new LazyThreadSafetyMode('SYNCHRONIZED', 0);
    LazyThreadSafetyMode_PUBLICATION_instance = new LazyThreadSafetyMode('PUBLICATION', 1);
    LazyThreadSafetyMode_NONE_instance = new LazyThreadSafetyMode('NONE', 2);
  }
  function LazyThreadSafetyMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LazyThreadSafetyMode.$metadata$ = {
    simpleName: 'LazyThreadSafetyMode',
    kind: 'class',
    interfaces: []
  };
  function LazyThreadSafetyMode_PUBLICATION_getInstance() {
    LazyThreadSafetyMode_initEntries();
    return LazyThreadSafetyMode_PUBLICATION_instance;
  }
  function _Result___init__impl_(value) {
    return value;
  }
  function _Result___get_value__impl_(this_0) {
    return this_0;
  }
  function _Result___get_isFailure__impl_(this_0) {
    var tmp = _Result___get_value__impl_(this_0);
    return tmp instanceof Failure;
  }
  function Result__exceptionOrNull_impl(this_0) {
    var tmp0_subject = _Result___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject instanceof Failure) {
      tmp = _Result___get_value__impl_(this_0)._exception;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function Companion_4() {
    Companion_instance_3 = this;
  }
  Companion_4.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_4();
    return Companion_instance_3;
  }
  function Failure(exception) {
    this._exception = exception;
  }
  Failure.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Failure) {
      tmp = equals_1(this._exception, other._exception);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Failure.prototype.hashCode = function () {
    return hashCode(this._exception);
  };
  Failure.prototype.toString = function () {
    return '' + 'Failure(' + this._exception + ')';
  };
  Failure.$metadata$ = {
    simpleName: 'Failure',
    kind: 'class',
    interfaces: [Serializable]
  };
  function createFailure(exception) {
    return new Failure(exception);
  }
  function throwOnFailure(_this_) {
    var tmp = _Result___get_value__impl_(_this_);
    if (tmp instanceof Failure)
      throw _Result___get_value__impl_(_this_)._exception;
    else {
    }
  }
  function NotImplementedError_init_$Init$(message, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      message = 'An operation is not implemented.';
    NotImplementedError.call($this, message);
    return $this;
  }
  function NotImplementedError_init_$Create$(message, $mask0, $marker) {
    var tmp = NotImplementedError_init_$Init$(message, $mask0, $marker, Object.create(NotImplementedError.prototype));
    captureStack(tmp, NotImplementedError_init_$Create$);
    return tmp;
  }
  function NotImplementedError(message) {
    Error_init_$Init$_0(message, this);
    captureStack(this, NotImplementedError);
  }
  NotImplementedError.$metadata$ = {
    simpleName: 'NotImplementedError',
    kind: 'class',
    interfaces: []
  };
  function Pair(first_2, second) {
    this._first = first_2;
    this._second = second;
  }
  Pair.prototype.toString = function () {
    return '' + '(' + this._first + ', ' + this._second + ')';
  };
  Pair.prototype.component1_0_k$ = function () {
    return this._first;
  };
  Pair.prototype.component2_0_k$ = function () {
    return this._second;
  };
  Pair.prototype.hashCode = function () {
    var result = this._first == null ? 0 : hashCode(this._first);
    result = imul(result, 31) + (this._second == null ? 0 : hashCode(this._second)) | 0;
    return result;
  };
  Pair.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals_1(this._first, tmp0_other_with_cast._first))
      return false;
    if (!equals_1(this._second, tmp0_other_with_cast._second))
      return false;
    return true;
  };
  Pair.$metadata$ = {
    simpleName: 'Pair',
    kind: 'class',
    interfaces: [Serializable]
  };
  function to(_this_, that) {
    return new Pair(_this_, that);
  }
  function _UByte___init__impl_(data) {
    return data;
  }
  function _UByte___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_5() {
    Companion_instance_4 = this;
    this._MIN_VALUE = _UByte___init__impl_(0);
    this._MAX_VALUE = _UByte___init__impl_(-1);
    this._SIZE_BYTES = 1;
    this._SIZE_BITS = 8;
  }
  Companion_5.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_5();
    return Companion_instance_4;
  }
  function UByte__compareTo_impl(this_0, other) {
    var tmp = _UByte___get_data__impl_(this_0) & 255;
    return compareTo(tmp, _UByte___get_data__impl_(other) & 255);
  }
  function UByte__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data;
    return UByte__compareTo_impl(tmp, other instanceof UByte ? other._data : THROW_CCE());
  }
  function UByte__toString_impl(this_0) {
    return (_UByte___get_data__impl_(this_0) & 255).toString();
  }
  function UByte__hashCode_impl(this_0) {
    return this_0;
  }
  function UByte__equals_impl(this_0, other) {
    if (!(other instanceof UByte))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UByte ? other._data : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UByte(data) {
    Companion_getInstance_4();
    this._data = data;
  }
  UByte.prototype.compareTo_dj4lnz_k$ = function (other) {
    return UByte__compareTo_impl(this._data, other);
  };
  UByte.prototype.compareTo_2c5_k$ = function (other) {
    return UByte__compareTo_impl_0(this, other);
  };
  UByte.prototype.toString = function () {
    return UByte__toString_impl(this._data);
  };
  UByte.prototype.hashCode = function () {
    return UByte__hashCode_impl(this._data);
  };
  UByte.prototype.equals = function (other) {
    return UByte__equals_impl(this._data, other);
  };
  UByte.$metadata$ = {
    simpleName: 'UByte',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _UByteArray___get_storage__impl_(this_0) {
    return this_0;
  }
  function _UByteArray___get_size__impl_(this_0) {
    return _UByteArray___get_storage__impl_(this_0).length;
  }
  function UByteArray__iterator_impl(this_0) {
    return new Iterator(_UByteArray___get_storage__impl_(this_0));
  }
  function Iterator(array) {
    UByteIterator.call(this);
    this._array = array;
    this._index = 0;
  }
  Iterator.prototype.hasNext_0_k$ = function () {
    return this._index < this._array.length;
  };
  Iterator.prototype.nextUByte_sh428i_k$ = function () {
    var tmp;
    if (this._index < this._array.length) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index;
      tmp0_this._index = tmp1 + 1 | 0;
      var tmp0_toUByte_0 = this._array[tmp1];
      tmp = _UByte___init__impl_(tmp0_toUByte_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this._index.toString());
    }
    return tmp;
  };
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function UByteArray__contains_impl(this_0, element) {
    var tmp = isObject(new UByte(element)) ? new UByte(element) : THROW_CCE();
    if (!(tmp instanceof UByte))
      return false;
    else {
    }
    var tmp_0 = _UByteArray___get_storage__impl_(this_0);
    return contains_2(tmp_0, _UByte___get_data__impl_(element));
  }
  function UByteArray__contains_impl_0(this_0, element) {
    if (!(element instanceof UByte))
      return false;
    else {
    }
    var tmp = this_0._storage;
    return UByteArray__contains_impl(tmp, element instanceof UByte ? element._data : THROW_CCE());
  }
  function UByteArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        var tmp_0;
        if (element_2 instanceof UByte) {
          var tmp_1 = _UByteArray___get_storage__impl_(this_0);
          var tmp0_toByte_0_4 = element_2._data;
          tmp_0 = contains_2(tmp_1, _UByte___get_data__impl_(tmp0_toByte_0_4));
        } else {
          {
            tmp_0 = false;
          }
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function UByteArray__containsAll_impl_0(this_0, elements) {
    return UByteArray__containsAll_impl(this_0._storage, elements);
  }
  function UByteArray__isEmpty_impl(this_0) {
    return _UByteArray___get_storage__impl_(this_0).length === 0;
  }
  function UByteArray__toString_impl(this_0) {
    return '' + 'UByteArray(storage=' + toString_1(this_0) + ')';
  }
  function UByteArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function UByteArray__equals_impl(this_0, other) {
    if (!(other instanceof UByteArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UByteArray ? other._storage : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UByteArray(storage) {
    this._storage = storage;
  }
  UByteArray.prototype._get_size__0_k$ = function () {
    return _UByteArray___get_size__impl_(this._storage);
  };
  UByteArray.prototype.iterator_0_k$ = function () {
    return UByteArray__iterator_impl(this._storage);
  };
  UByteArray.prototype.contains_dj4lnz_k$ = function (element) {
    return UByteArray__contains_impl(this._storage, element);
  };
  UByteArray.prototype.contains_2bq_k$ = function (element) {
    return UByteArray__contains_impl_0(this, element);
  };
  UByteArray.prototype.containsAll_wji8mv_k$ = function (elements) {
    return UByteArray__containsAll_impl(this._storage, elements);
  };
  UByteArray.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return UByteArray__containsAll_impl_0(this, elements);
  };
  UByteArray.prototype.isEmpty_0_k$ = function () {
    return UByteArray__isEmpty_impl(this._storage);
  };
  UByteArray.prototype.toString = function () {
    return UByteArray__toString_impl(this._storage);
  };
  UByteArray.prototype.hashCode = function () {
    return UByteArray__hashCode_impl(this._storage);
  };
  UByteArray.prototype.equals = function (other) {
    return UByteArray__equals_impl(this._storage, other);
  };
  UByteArray.$metadata$ = {
    simpleName: 'UByteArray',
    kind: 'class',
    interfaces: [Collection]
  };
  function _UInt___init__impl_(data) {
    return data;
  }
  function _UInt___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_6() {
    Companion_instance_5 = this;
    this._MIN_VALUE_0 = _UInt___init__impl_(0);
    this._MAX_VALUE_0 = _UInt___init__impl_(-1);
    this._SIZE_BYTES_0 = 4;
    this._SIZE_BITS_0 = 32;
  }
  Companion_6.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_6();
    return Companion_instance_5;
  }
  function UInt__compareTo_impl(this_0, other) {
    return uintCompare(_UInt___get_data__impl_(this_0), _UInt___get_data__impl_(other));
  }
  function UInt__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data_0;
    return UInt__compareTo_impl(tmp, other instanceof UInt ? other._data_0 : THROW_CCE());
  }
  function UInt__toString_impl(this_0) {
    return toLong(_UInt___get_data__impl_(this_0)).and_wiekkq_k$(new Long(-1, 0)).toString();
  }
  function UInt__hashCode_impl(this_0) {
    return this_0;
  }
  function UInt__equals_impl(this_0, other) {
    if (!(other instanceof UInt))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UInt ? other._data_0 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UInt(data) {
    Companion_getInstance_5();
    this._data_0 = data;
  }
  UInt.prototype.compareTo_wijjag_k$ = function (other) {
    return UInt__compareTo_impl(this._data_0, other);
  };
  UInt.prototype.compareTo_2c5_k$ = function (other) {
    return UInt__compareTo_impl_0(this, other);
  };
  UInt.prototype.toString = function () {
    return UInt__toString_impl(this._data_0);
  };
  UInt.prototype.hashCode = function () {
    return UInt__hashCode_impl(this._data_0);
  };
  UInt.prototype.equals = function (other) {
    return UInt__equals_impl(this._data_0, other);
  };
  UInt.$metadata$ = {
    simpleName: 'UInt',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _UIntArray___get_storage__impl_(this_0) {
    return this_0;
  }
  function _UIntArray___get_size__impl_(this_0) {
    return _UIntArray___get_storage__impl_(this_0).length;
  }
  function UIntArray__iterator_impl(this_0) {
    return new Iterator_0(_UIntArray___get_storage__impl_(this_0));
  }
  function Iterator_0(array) {
    UIntIterator.call(this);
    this._array_0 = array;
    this._index_0 = 0;
  }
  Iterator_0.prototype.hasNext_0_k$ = function () {
    return this._index_0 < this._array_0.length;
  };
  Iterator_0.prototype.nextUInt_sv9k7v_k$ = function () {
    var tmp;
    if (this._index_0 < this._array_0.length) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_0;
      tmp0_this._index_0 = tmp1 + 1 | 0;
      var tmp0_toUInt_0 = this._array_0[tmp1];
      tmp = _UInt___init__impl_(tmp0_toUInt_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this._index_0.toString());
    }
    return tmp;
  };
  Iterator_0.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function UIntArray__contains_impl(this_0, element) {
    var tmp = isObject(new UInt(element)) ? new UInt(element) : THROW_CCE();
    if (!(tmp instanceof UInt))
      return false;
    else {
    }
    var tmp_0 = _UIntArray___get_storage__impl_(this_0);
    return contains(tmp_0, _UInt___get_data__impl_(element));
  }
  function UIntArray__contains_impl_0(this_0, element) {
    if (!(element instanceof UInt))
      return false;
    else {
    }
    var tmp = this_0._storage_0;
    return UIntArray__contains_impl(tmp, element instanceof UInt ? element._data_0 : THROW_CCE());
  }
  function UIntArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        var tmp_0;
        if (element_2 instanceof UInt) {
          var tmp_1 = _UIntArray___get_storage__impl_(this_0);
          var tmp0_toInt_0_4 = element_2._data_0;
          tmp_0 = contains(tmp_1, _UInt___get_data__impl_(tmp0_toInt_0_4));
        } else {
          {
            tmp_0 = false;
          }
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function UIntArray__containsAll_impl_0(this_0, elements) {
    return UIntArray__containsAll_impl(this_0._storage_0, elements);
  }
  function UIntArray__isEmpty_impl(this_0) {
    return _UIntArray___get_storage__impl_(this_0).length === 0;
  }
  function UIntArray__toString_impl(this_0) {
    return '' + 'UIntArray(storage=' + toString_1(this_0) + ')';
  }
  function UIntArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function UIntArray__equals_impl(this_0, other) {
    if (!(other instanceof UIntArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UIntArray ? other._storage_0 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UIntArray(storage) {
    this._storage_0 = storage;
  }
  UIntArray.prototype._get_size__0_k$ = function () {
    return _UIntArray___get_size__impl_(this._storage_0);
  };
  UIntArray.prototype.iterator_0_k$ = function () {
    return UIntArray__iterator_impl(this._storage_0);
  };
  UIntArray.prototype.contains_wijjag_k$ = function (element) {
    return UIntArray__contains_impl(this._storage_0, element);
  };
  UIntArray.prototype.contains_2bq_k$ = function (element) {
    return UIntArray__contains_impl_0(this, element);
  };
  UIntArray.prototype.containsAll_sjraxa_k$ = function (elements) {
    return UIntArray__containsAll_impl(this._storage_0, elements);
  };
  UIntArray.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return UIntArray__containsAll_impl_0(this, elements);
  };
  UIntArray.prototype.isEmpty_0_k$ = function () {
    return UIntArray__isEmpty_impl(this._storage_0);
  };
  UIntArray.prototype.toString = function () {
    return UIntArray__toString_impl(this._storage_0);
  };
  UIntArray.prototype.hashCode = function () {
    return UIntArray__hashCode_impl(this._storage_0);
  };
  UIntArray.prototype.equals = function (other) {
    return UIntArray__equals_impl(this._storage_0, other);
  };
  UIntArray.$metadata$ = {
    simpleName: 'UIntArray',
    kind: 'class',
    interfaces: [Collection]
  };
  function UIntIterator() {
  }
  UIntIterator.prototype.next_sv9k7v_k$ = function () {
    return this.nextUInt_sv9k7v_k$();
  };
  UIntIterator.prototype.next_0_k$ = function () {
    return new UInt(this.next_sv9k7v_k$());
  };
  UIntIterator.$metadata$ = {
    simpleName: 'UIntIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function ULongIterator() {
  }
  ULongIterator.prototype.next_sha8jq_k$ = function () {
    return this.nextULong_sha8jq_k$();
  };
  ULongIterator.prototype.next_0_k$ = function () {
    return new ULong(this.next_sha8jq_k$());
  };
  ULongIterator.$metadata$ = {
    simpleName: 'ULongIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function UByteIterator() {
  }
  UByteIterator.prototype.next_sh428i_k$ = function () {
    return this.nextUByte_sh428i_k$();
  };
  UByteIterator.prototype.next_0_k$ = function () {
    return new UByte(this.next_sh428i_k$());
  };
  UByteIterator.$metadata$ = {
    simpleName: 'UByteIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function UShortIterator() {
  }
  UShortIterator.prototype.next_um6tma_k$ = function () {
    return this.nextUShort_um6tma_k$();
  };
  UShortIterator.prototype.next_0_k$ = function () {
    return new UShort(this.next_um6tma_k$());
  };
  UShortIterator.$metadata$ = {
    simpleName: 'UShortIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function _ULong___init__impl_(data) {
    return data;
  }
  function _ULong___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_7() {
    Companion_instance_6 = this;
    this._MIN_VALUE_1 = _ULong___init__impl_(new Long(0, 0));
    this._MAX_VALUE_1 = _ULong___init__impl_(new Long(-1, -1));
    this._SIZE_BYTES_1 = 8;
    this._SIZE_BITS_1 = 64;
  }
  Companion_7.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_7();
    return Companion_instance_6;
  }
  function ULong__compareTo_impl(this_0, other) {
    return ulongCompare(_ULong___get_data__impl_(this_0), _ULong___get_data__impl_(other));
  }
  function ULong__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data_1;
    return ULong__compareTo_impl(tmp, other instanceof ULong ? other._data_1 : THROW_CCE());
  }
  function ULong__toString_impl(this_0) {
    return ulongToString(_ULong___get_data__impl_(this_0));
  }
  function ULong__hashCode_impl(this_0) {
    return this_0.hashCode();
  }
  function ULong__equals_impl(this_0, other) {
    if (!(other instanceof ULong))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ULong ? other._data_1 : THROW_CCE();
    if (!this_0.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function ULong(data) {
    Companion_getInstance_6();
    this._data_1 = data;
  }
  ULong.prototype.compareTo_djarz7_k$ = function (other) {
    return ULong__compareTo_impl(this._data_1, other);
  };
  ULong.prototype.compareTo_2c5_k$ = function (other) {
    return ULong__compareTo_impl_0(this, other);
  };
  ULong.prototype.toString = function () {
    return ULong__toString_impl(this._data_1);
  };
  ULong.prototype.hashCode = function () {
    return ULong__hashCode_impl(this._data_1);
  };
  ULong.prototype.equals = function (other) {
    return ULong__equals_impl(this._data_1, other);
  };
  ULong.$metadata$ = {
    simpleName: 'ULong',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _ULongArray___get_storage__impl_(this_0) {
    return this_0;
  }
  function _ULongArray___get_size__impl_(this_0) {
    return _ULongArray___get_storage__impl_(this_0).length;
  }
  function ULongArray__iterator_impl(this_0) {
    return new Iterator_1(_ULongArray___get_storage__impl_(this_0));
  }
  function Iterator_1(array) {
    ULongIterator.call(this);
    this._array_1 = array;
    this._index_1 = 0;
  }
  Iterator_1.prototype.hasNext_0_k$ = function () {
    return this._index_1 < this._array_1.length;
  };
  Iterator_1.prototype.nextULong_sha8jq_k$ = function () {
    var tmp;
    if (this._index_1 < this._array_1.length) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_1;
      tmp0_this._index_1 = tmp1 + 1 | 0;
      var tmp0_toULong_0 = this._array_1[tmp1];
      tmp = _ULong___init__impl_(tmp0_toULong_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this._index_1.toString());
    }
    return tmp;
  };
  Iterator_1.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function ULongArray__contains_impl(this_0, element) {
    var tmp = isObject(new ULong(element)) ? new ULong(element) : THROW_CCE();
    if (!(tmp instanceof ULong))
      return false;
    else {
    }
    var tmp_0 = _ULongArray___get_storage__impl_(this_0);
    return contains_4(tmp_0, _ULong___get_data__impl_(element));
  }
  function ULongArray__contains_impl_0(this_0, element) {
    if (!(element instanceof ULong))
      return false;
    else {
    }
    var tmp = this_0._storage_1;
    return ULongArray__contains_impl(tmp, element instanceof ULong ? element._data_1 : THROW_CCE());
  }
  function ULongArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        var tmp_0;
        if (element_2 instanceof ULong) {
          var tmp_1 = _ULongArray___get_storage__impl_(this_0);
          var tmp0_toLong_0_4 = element_2._data_1;
          tmp_0 = contains_4(tmp_1, _ULong___get_data__impl_(tmp0_toLong_0_4));
        } else {
          {
            tmp_0 = false;
          }
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function ULongArray__containsAll_impl_0(this_0, elements) {
    return ULongArray__containsAll_impl(this_0._storage_1, elements);
  }
  function ULongArray__isEmpty_impl(this_0) {
    return _ULongArray___get_storage__impl_(this_0).length === 0;
  }
  function ULongArray__toString_impl(this_0) {
    return '' + 'ULongArray(storage=' + toString_1(this_0) + ')';
  }
  function ULongArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function ULongArray__equals_impl(this_0, other) {
    if (!(other instanceof ULongArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ULongArray ? other._storage_1 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ULongArray(storage) {
    this._storage_1 = storage;
  }
  ULongArray.prototype._get_size__0_k$ = function () {
    return _ULongArray___get_size__impl_(this._storage_1);
  };
  ULongArray.prototype.iterator_0_k$ = function () {
    return ULongArray__iterator_impl(this._storage_1);
  };
  ULongArray.prototype.contains_djarz7_k$ = function (element) {
    return ULongArray__contains_impl(this._storage_1, element);
  };
  ULongArray.prototype.contains_2bq_k$ = function (element) {
    return ULongArray__contains_impl_0(this, element);
  };
  ULongArray.prototype.containsAll_wotoar_k$ = function (elements) {
    return ULongArray__containsAll_impl(this._storage_1, elements);
  };
  ULongArray.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return ULongArray__containsAll_impl_0(this, elements);
  };
  ULongArray.prototype.isEmpty_0_k$ = function () {
    return ULongArray__isEmpty_impl(this._storage_1);
  };
  ULongArray.prototype.toString = function () {
    return ULongArray__toString_impl(this._storage_1);
  };
  ULongArray.prototype.hashCode = function () {
    return ULongArray__hashCode_impl(this._storage_1);
  };
  ULongArray.prototype.equals = function (other) {
    return ULongArray__equals_impl(this._storage_1, other);
  };
  ULongArray.$metadata$ = {
    simpleName: 'ULongArray',
    kind: 'class',
    interfaces: [Collection]
  };
  function _UShort___init__impl_(data) {
    return data;
  }
  function _UShort___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_8() {
    Companion_instance_7 = this;
    this._MIN_VALUE_2 = _UShort___init__impl_(0);
    this._MAX_VALUE_2 = _UShort___init__impl_(-1);
    this._SIZE_BYTES_2 = 2;
    this._SIZE_BITS_2 = 16;
  }
  Companion_8.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_8();
    return Companion_instance_7;
  }
  function UShort__compareTo_impl(this_0, other) {
    var tmp = _UShort___get_data__impl_(this_0) & 65535;
    return compareTo(tmp, _UShort___get_data__impl_(other) & 65535);
  }
  function UShort__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data_2;
    return UShort__compareTo_impl(tmp, other instanceof UShort ? other._data_2 : THROW_CCE());
  }
  function UShort__toString_impl(this_0) {
    return (_UShort___get_data__impl_(this_0) & 65535).toString();
  }
  function UShort__hashCode_impl(this_0) {
    return this_0;
  }
  function UShort__equals_impl(this_0, other) {
    if (!(other instanceof UShort))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UShort ? other._data_2 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UShort(data) {
    Companion_getInstance_7();
    this._data_2 = data;
  }
  UShort.prototype.compareTo_6go47f_k$ = function (other) {
    return UShort__compareTo_impl(this._data_2, other);
  };
  UShort.prototype.compareTo_2c5_k$ = function (other) {
    return UShort__compareTo_impl_0(this, other);
  };
  UShort.prototype.toString = function () {
    return UShort__toString_impl(this._data_2);
  };
  UShort.prototype.hashCode = function () {
    return UShort__hashCode_impl(this._data_2);
  };
  UShort.prototype.equals = function (other) {
    return UShort__equals_impl(this._data_2, other);
  };
  UShort.$metadata$ = {
    simpleName: 'UShort',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _UShortArray___get_storage__impl_(this_0) {
    return this_0;
  }
  function _UShortArray___get_size__impl_(this_0) {
    return _UShortArray___get_storage__impl_(this_0).length;
  }
  function UShortArray__iterator_impl(this_0) {
    return new Iterator_2(_UShortArray___get_storage__impl_(this_0));
  }
  function Iterator_2(array) {
    UShortIterator.call(this);
    this._array_2 = array;
    this._index_2 = 0;
  }
  Iterator_2.prototype.hasNext_0_k$ = function () {
    return this._index_2 < this._array_2.length;
  };
  Iterator_2.prototype.nextUShort_um6tma_k$ = function () {
    var tmp;
    if (this._index_2 < this._array_2.length) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_2;
      tmp0_this._index_2 = tmp1 + 1 | 0;
      var tmp0_toUShort_0 = this._array_2[tmp1];
      tmp = _UShort___init__impl_(tmp0_toUShort_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this._index_2.toString());
    }
    return tmp;
  };
  Iterator_2.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function UShortArray__contains_impl(this_0, element) {
    var tmp = isObject(new UShort(element)) ? new UShort(element) : THROW_CCE();
    if (!(tmp instanceof UShort))
      return false;
    else {
    }
    var tmp_0 = _UShortArray___get_storage__impl_(this_0);
    return contains_3(tmp_0, _UShort___get_data__impl_(element));
  }
  function UShortArray__contains_impl_0(this_0, element) {
    if (!(element instanceof UShort))
      return false;
    else {
    }
    var tmp = this_0._storage_2;
    return UShortArray__contains_impl(tmp, element instanceof UShort ? element._data_2 : THROW_CCE());
  }
  function UShortArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        var tmp_0;
        if (element_2 instanceof UShort) {
          var tmp_1 = _UShortArray___get_storage__impl_(this_0);
          var tmp0_toShort_0_4 = element_2._data_2;
          tmp_0 = contains_3(tmp_1, _UShort___get_data__impl_(tmp0_toShort_0_4));
        } else {
          {
            tmp_0 = false;
          }
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function UShortArray__containsAll_impl_0(this_0, elements) {
    return UShortArray__containsAll_impl(this_0._storage_2, elements);
  }
  function UShortArray__isEmpty_impl(this_0) {
    return _UShortArray___get_storage__impl_(this_0).length === 0;
  }
  function UShortArray__toString_impl(this_0) {
    return '' + 'UShortArray(storage=' + toString_1(this_0) + ')';
  }
  function UShortArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function UShortArray__equals_impl(this_0, other) {
    if (!(other instanceof UShortArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UShortArray ? other._storage_2 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UShortArray(storage) {
    this._storage_2 = storage;
  }
  UShortArray.prototype._get_size__0_k$ = function () {
    return _UShortArray___get_size__impl_(this._storage_2);
  };
  UShortArray.prototype.iterator_0_k$ = function () {
    return UShortArray__iterator_impl(this._storage_2);
  };
  UShortArray.prototype.contains_6go47f_k$ = function (element) {
    return UShortArray__contains_impl(this._storage_2, element);
  };
  UShortArray.prototype.contains_2bq_k$ = function (element) {
    return UShortArray__contains_impl_0(this, element);
  };
  UShortArray.prototype.containsAll_m5guox_k$ = function (elements) {
    return UShortArray__containsAll_impl(this._storage_2, elements);
  };
  UShortArray.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return UShortArray__containsAll_impl_0(this, elements);
  };
  UShortArray.prototype.isEmpty_0_k$ = function () {
    return UShortArray__isEmpty_impl(this._storage_2);
  };
  UShortArray.prototype.toString = function () {
    return UShortArray__toString_impl(this._storage_2);
  };
  UShortArray.prototype.hashCode = function () {
    return UShortArray__hashCode_impl(this._storage_2);
  };
  UShortArray.prototype.equals = function (other) {
    return UShortArray__equals_impl(this._storage_2, other);
  };
  UShortArray.$metadata$ = {
    simpleName: 'UShortArray',
    kind: 'class',
    interfaces: [Collection]
  };
  function uintCompare(v1, v2) {
    return compareTo(v1 ^ IntCompanionObject_getInstance()._MIN_VALUE_5, v2 ^ IntCompanionObject_getInstance()._MIN_VALUE_5);
  }
  function ulongCompare(v1, v2) {
    Companion_getInstance_17();
    var tmp = v1.xor_wiekkq_k$(new Long(0, -2147483648));
    Companion_getInstance_17();
    return tmp.compareTo_wiekkq_k$(v2.xor_wiekkq_k$(new Long(0, -2147483648)));
  }
  function ulongToString(v) {
    return ulongToString_0(v, 10);
  }
  function ulongToString_0(v, base) {
    if (v.compareTo_wiekkq_k$(new Long(0, 0)) >= 0)
      return toString_2(v, base);
    var tmp0_div_0 = v.ushr_ha5a7z_k$(1);
    var quotient = tmp0_div_0.div_wiekkq_k$(toLong(base)).shl_ha5a7z_k$(1);
    var tmp1_times_0 = quotient;
    var rem = v.minus_wiekkq_k$(tmp1_times_0.times_wiekkq_k$(toLong(base)));
    if (rem.compareTo_wiekkq_k$(toLong(base)) >= 0) {
      var tmp2_minus_0 = rem;
      rem = tmp2_minus_0.minus_wiekkq_k$(toLong(base));
      var tmp3_plus_0 = quotient;
      quotient = tmp3_plus_0.plus_wiekkq_k$(new Long(1, 0));
    }return toString_2(quotient, base) + toString_2(rem, base);
  }
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator_3() {
  }
  Iterator_3.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator_3]
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator_3]
  };
  function MutableListIterator() {
  }
  MutableListIterator.$metadata$ = {
    simpleName: 'MutableListIterator',
    kind: 'interface',
    interfaces: [ListIterator, MutableIterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function IntIterator() {
  }
  IntIterator.prototype.next_0_k$ = function () {
    return this.nextInt_0_k$();
  };
  IntIterator.$metadata$ = {
    simpleName: 'IntIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function LongIterator() {
  }
  LongIterator.prototype.next_0_k$ = function () {
    return this.nextLong_0_k$();
  };
  LongIterator.$metadata$ = {
    simpleName: 'LongIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function CharIterator() {
  }
  CharIterator.prototype.next_0_k$ = function () {
    return this.nextChar_0_k$();
  };
  CharIterator.$metadata$ = {
    simpleName: 'CharIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function IntProgressionIterator(first_2, last_1, step_0) {
    IntIterator.call(this);
    this._step = step_0;
    this._finalElement = last_1;
    this._hasNext = this._step > 0 ? first_2 <= last_1 : first_2 >= last_1;
    this._next_0 = this._hasNext ? first_2 : this._finalElement;
  }
  IntProgressionIterator.prototype.hasNext_0_k$ = function () {
    return this._hasNext;
  };
  IntProgressionIterator.prototype.nextInt_0_k$ = function () {
    var value = this._next_0;
    if (value === this._finalElement) {
      if (!this._hasNext)
        throw NoSuchElementException_init_$Create$();
      this._hasNext = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_0 = tmp0_this._next_0 + this._step | 0;
    }
    return value;
  };
  IntProgressionIterator.$metadata$ = {
    simpleName: 'IntProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function LongProgressionIterator(first_2, last_1, step_0) {
    LongIterator.call(this);
    this._step_0 = step_0;
    this._finalElement_0 = last_1;
    this._hasNext_0 = this._step_0.compareTo_wiekkq_k$(new Long(0, 0)) > 0 ? first_2.compareTo_wiekkq_k$(last_1) <= 0 : first_2.compareTo_wiekkq_k$(last_1) >= 0;
    this._next_1 = this._hasNext_0 ? first_2 : this._finalElement_0;
  }
  LongProgressionIterator.prototype.hasNext_0_k$ = function () {
    return this._hasNext_0;
  };
  LongProgressionIterator.prototype.nextLong_0_k$ = function () {
    var value = this._next_1;
    if (value.equals(this._finalElement_0)) {
      if (!this._hasNext_0)
        throw NoSuchElementException_init_$Create$();
      this._hasNext_0 = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_1 = tmp0_this._next_1.plus_wiekkq_k$(this._step_0);
    }
    return value;
  };
  LongProgressionIterator.$metadata$ = {
    simpleName: 'LongProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function CharProgressionIterator(first_2, last_1, step_0) {
    CharIterator.call(this);
    this._step_1 = step_0;
    var tmp = this;
    tmp._finalElement_1 = last_1.toInt_0_k$();
    this._hasNext_1 = this._step_1 > 0 ? first_2.compareTo_wi8o78_k$(last_1) <= 0 : first_2.compareTo_wi8o78_k$(last_1) >= 0;
    var tmp_0 = this;
    var tmp_1;
    if (this._hasNext_1) {
      tmp_1 = first_2.toInt_0_k$();
    } else {
      tmp_1 = this._finalElement_1;
    }
    tmp_0._next_2 = tmp_1;
  }
  CharProgressionIterator.prototype.hasNext_0_k$ = function () {
    return this._hasNext_1;
  };
  CharProgressionIterator.prototype.nextChar_0_k$ = function () {
    var value = this._next_2;
    if (value === this._finalElement_1) {
      if (!this._hasNext_1)
        throw NoSuchElementException_init_$Create$();
      this._hasNext_1 = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_2 = tmp0_this._next_2 + this._step_1 | 0;
    }
    return numberToChar(value);
  };
  CharProgressionIterator.$metadata$ = {
    simpleName: 'CharProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function Companion_9() {
    Companion_instance_8 = this;
  }
  Companion_9.prototype.fromClosedRange_fcwjfj_k$ = function (rangeStart, rangeEnd, step_0) {
    return new IntProgression(rangeStart, rangeEnd, step_0);
  };
  Companion_9.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_9();
    return Companion_instance_8;
  }
  function IntProgression(start, endInclusive, step_0) {
    Companion_getInstance_8();
    if (step_0 === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step_0 === IntCompanionObject_getInstance()._MIN_VALUE_5)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_0 = start;
    this._last = getProgressionLastElement(start, endInclusive, step_0);
    this._step_2 = step_0;
  }
  IntProgression.prototype._get_first__0_k$ = function () {
    return this._first_0;
  };
  IntProgression.prototype._get_last__0_k$ = function () {
    return this._last;
  };
  IntProgression.prototype.iterator_0_k$ = function () {
    return new IntProgressionIterator(this._first_0, this._last, this._step_2);
  };
  IntProgression.prototype.isEmpty_0_k$ = function () {
    return this._step_2 > 0 ? this._first_0 > this._last : this._first_0 < this._last;
  };
  IntProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = (this.isEmpty_0_k$() ? other.isEmpty_0_k$() : false) ? true : (this._first_0 === other._first_0 ? this._last === other._last : false) ? this._step_2 === other._step_2 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntProgression.prototype.hashCode = function () {
    return this.isEmpty_0_k$() ? -1 : imul(31, imul(31, this._first_0) + this._last | 0) + this._step_2 | 0;
  };
  IntProgression.prototype.toString = function () {
    return this._step_2 > 0 ? '' + this._first_0 + '..' + this._last + ' step ' + this._step_2 : '' + this._first_0 + ' downTo ' + this._last + ' step ' + (-this._step_2 | 0);
  };
  IntProgression.$metadata$ = {
    simpleName: 'IntProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function Companion_10() {
    Companion_instance_9 = this;
  }
  Companion_10.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_10();
    return Companion_instance_9;
  }
  function LongProgression(start, endInclusive, step_0) {
    Companion_getInstance_9();
    if (step_0.equals(new Long(0, 0)))
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    Companion_getInstance_17();
    if (step_0.equals(new Long(0, -2147483648)))
      throw IllegalArgumentException_init_$Create$('Step must be greater than Long.MIN_VALUE to avoid overflow on negation.');
    else {
    }
    this._first_1 = start;
    this._last_0 = getProgressionLastElement_0(start, endInclusive, step_0);
    this._step_3 = step_0;
  }
  LongProgression.prototype._get_first__0_k$ = function () {
    return this._first_1;
  };
  LongProgression.prototype._get_last__0_k$ = function () {
    return this._last_0;
  };
  LongProgression.prototype.iterator_0_k$ = function () {
    return new LongProgressionIterator(this._first_1, this._last_0, this._step_3);
  };
  LongProgression.prototype.isEmpty_0_k$ = function () {
    return this._step_3.compareTo_wiekkq_k$(new Long(0, 0)) > 0 ? this._first_1.compareTo_wiekkq_k$(this._last_0) > 0 : this._first_1.compareTo_wiekkq_k$(this._last_0) < 0;
  };
  LongProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof LongProgression) {
      tmp = (this.isEmpty_0_k$() ? other.isEmpty_0_k$() : false) ? true : (this._first_1.equals(other._first_1) ? this._last_0.equals(other._last_0) : false) ? this._step_3.equals(other._step_3) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  LongProgression.prototype.hashCode = function () {
    return this.isEmpty_0_k$() ? -1 : numberToLong(31).times_wiekkq_k$(numberToLong(31).times_wiekkq_k$(this._first_1.xor_wiekkq_k$(this._first_1.ushr_ha5a7z_k$(32))).plus_wiekkq_k$(this._last_0.xor_wiekkq_k$(this._last_0.ushr_ha5a7z_k$(32)))).plus_wiekkq_k$(this._step_3.xor_wiekkq_k$(this._step_3.ushr_ha5a7z_k$(32))).toInt_0_k$();
  };
  LongProgression.prototype.toString = function () {
    return this._step_3.compareTo_wiekkq_k$(new Long(0, 0)) > 0 ? '' + this._first_1 + '..' + this._last_0 + ' step ' + this._step_3 : '' + this._first_1 + ' downTo ' + this._last_0 + ' step ' + this._step_3.unaryMinus_0_k$();
  };
  LongProgression.$metadata$ = {
    simpleName: 'LongProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function Companion_11() {
    Companion_instance_10 = this;
  }
  Companion_11.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_11();
    return Companion_instance_10;
  }
  function CharProgression(start, endInclusive, step_0) {
    Companion_getInstance_10();
    if (step_0 === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step_0 === IntCompanionObject_getInstance()._MIN_VALUE_5)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_2 = start;
    var tmp = this;
    var tmp_0 = start.toInt_0_k$();
    tmp._last_1 = numberToChar(getProgressionLastElement(tmp_0, endInclusive.toInt_0_k$(), step_0));
    this._step_4 = step_0;
  }
  CharProgression.prototype._get_first__0_k$ = function () {
    return this._first_2;
  };
  CharProgression.prototype._get_last__0_k$ = function () {
    return this._last_1;
  };
  CharProgression.prototype.iterator_0_k$ = function () {
    return new CharProgressionIterator(this._first_2, this._last_1, this._step_4);
  };
  CharProgression.prototype.isEmpty_0_k$ = function () {
    return this._step_4 > 0 ? this._first_2.compareTo_wi8o78_k$(this._last_1) > 0 : this._first_2.compareTo_wi8o78_k$(this._last_1) < 0;
  };
  CharProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof CharProgression) {
      tmp = (this.isEmpty_0_k$() ? other.isEmpty_0_k$() : false) ? true : (this._first_2.equals(other._first_2) ? this._last_1.equals(other._last_1) : false) ? this._step_4 === other._step_4 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  CharProgression.prototype.hashCode = function () {
    var tmp;
    if (this.isEmpty_0_k$()) {
      tmp = -1;
    } else {
      var tmp0__get_code__0 = this._first_2;
      var tmp_0 = imul(31, tmp0__get_code__0.toInt_0_k$());
      var tmp1__get_code__0 = this._last_1;
      tmp = imul(31, tmp_0 + tmp1__get_code__0.toInt_0_k$() | 0) + this._step_4 | 0;
    }
    return tmp;
  };
  CharProgression.prototype.toString = function () {
    return this._step_4 > 0 ? '' + this._first_2 + '..' + this._last_1 + ' step ' + this._step_4 : '' + this._first_2 + ' downTo ' + this._last_1 + ' step ' + (-this._step_4 | 0);
  };
  CharProgression.$metadata$ = {
    simpleName: 'CharProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function ClosedRange() {
  }
  ClosedRange.$metadata$ = {
    simpleName: 'ClosedRange',
    kind: 'interface',
    interfaces: []
  };
  function Companion_12() {
    Companion_instance_11 = this;
    this._EMPTY = new IntRange(1, 0);
  }
  Companion_12.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_12();
    return Companion_instance_11;
  }
  function IntRange(start, endInclusive) {
    Companion_getInstance_11();
    IntProgression.call(this, start, endInclusive, 1);
  }
  IntRange.prototype._get_start__0_k$ = function () {
    return this._get_first__0_k$();
  };
  IntRange.prototype._get_endInclusive__0_k$ = function () {
    return this._get_last__0_k$();
  };
  IntRange.prototype.isEmpty_0_k$ = function () {
    return this._get_first__0_k$() > this._get_last__0_k$();
  };
  IntRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = (this.isEmpty_0_k$() ? other.isEmpty_0_k$() : false) ? true : this._get_first__0_k$() === other._get_first__0_k$() ? this._get_last__0_k$() === other._get_last__0_k$() : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntRange.prototype.hashCode = function () {
    return this.isEmpty_0_k$() ? -1 : imul(31, this._get_first__0_k$()) + this._get_last__0_k$() | 0;
  };
  IntRange.prototype.toString = function () {
    return '' + this._get_first__0_k$() + '..' + this._get_last__0_k$();
  };
  IntRange.$metadata$ = {
    simpleName: 'IntRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Companion_13() {
    Companion_instance_12 = this;
    this._EMPTY_0 = new LongRange(new Long(1, 0), new Long(0, 0));
  }
  Companion_13.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_13();
    return Companion_instance_12;
  }
  function LongRange(start, endInclusive) {
    Companion_getInstance_12();
    LongProgression.call(this, start, endInclusive, new Long(1, 0));
  }
  LongRange.prototype._get_start__0_k$ = function () {
    return this._get_first__0_k$();
  };
  LongRange.prototype._get_endInclusive__0_k$ = function () {
    return this._get_last__0_k$();
  };
  LongRange.prototype.isEmpty_0_k$ = function () {
    return this._get_first__0_k$().compareTo_wiekkq_k$(this._get_last__0_k$()) > 0;
  };
  LongRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof LongRange) {
      tmp = (this.isEmpty_0_k$() ? other.isEmpty_0_k$() : false) ? true : this._get_first__0_k$().equals(other._get_first__0_k$()) ? this._get_last__0_k$().equals(other._get_last__0_k$()) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  LongRange.prototype.hashCode = function () {
    return this.isEmpty_0_k$() ? -1 : numberToLong(31).times_wiekkq_k$(this._get_first__0_k$().xor_wiekkq_k$(this._get_first__0_k$().ushr_ha5a7z_k$(32))).plus_wiekkq_k$(this._get_last__0_k$().xor_wiekkq_k$(this._get_last__0_k$().ushr_ha5a7z_k$(32))).toInt_0_k$();
  };
  LongRange.prototype.toString = function () {
    return '' + this._get_first__0_k$() + '..' + this._get_last__0_k$();
  };
  LongRange.$metadata$ = {
    simpleName: 'LongRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Companion_14() {
    Companion_instance_13 = this;
    this._EMPTY_1 = new CharRange(new Char(1), new Char(0));
  }
  Companion_14.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_14();
    return Companion_instance_13;
  }
  function CharRange(start, endInclusive) {
    Companion_getInstance_13();
    CharProgression.call(this, start, endInclusive, 1);
  }
  CharRange.prototype.isEmpty_0_k$ = function () {
    return this._get_first__0_k$().compareTo_wi8o78_k$(this._get_last__0_k$()) > 0;
  };
  CharRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof CharRange) {
      tmp = (this.isEmpty_0_k$() ? other.isEmpty_0_k$() : false) ? true : this._get_first__0_k$().equals(other._get_first__0_k$()) ? this._get_last__0_k$().equals(other._get_last__0_k$()) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  CharRange.prototype.hashCode = function () {
    var tmp;
    if (this.isEmpty_0_k$()) {
      tmp = -1;
    } else {
      var tmp0__get_code__0 = this._get_first__0_k$();
      var tmp_0 = imul(31, tmp0__get_code__0.toInt_0_k$());
      var tmp1__get_code__0 = this._get_last__0_k$();
      tmp = tmp_0 + tmp1__get_code__0.toInt_0_k$() | 0;
    }
    return tmp;
  };
  CharRange.prototype.toString = function () {
    return '' + this._get_first__0_k$() + '..' + this._get_last__0_k$();
  };
  CharRange.$metadata$ = {
    simpleName: 'CharRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function getProgressionLastElement(start, end, step_0) {
    var tmp;
    if (step_0 > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step_0) | 0;
    } else if (step_0 < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step_0 | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function getProgressionLastElement_0(start, end, step_0) {
    var tmp;
    if (step_0.compareTo_wiekkq_k$(new Long(0, 0)) > 0) {
      tmp = start.compareTo_wiekkq_k$(end) >= 0 ? end : end.minus_wiekkq_k$(differenceModulo_0(end, start, step_0));
    } else if (step_0.compareTo_wiekkq_k$(new Long(0, 0)) < 0) {
      tmp = start.compareTo_wiekkq_k$(end) <= 0 ? end : end.plus_wiekkq_k$(differenceModulo_0(start, end, step_0.unaryMinus_0_k$()));
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function differenceModulo_0(a, b, c) {
    return mod_0(mod_0(a, c).minus_wiekkq_k$(mod_0(b, c)), c);
  }
  function mod(a, b) {
    var mod_1 = a % b;
    return mod_1 >= 0 ? mod_1 : mod_1 + b | 0;
  }
  function mod_0(a, b) {
    var mod_1 = a.rem_wiekkq_k$(b);
    return mod_1.compareTo_wiekkq_k$(new Long(0, 0)) >= 0 ? mod_1 : mod_1.plus_wiekkq_k$(b);
  }
  function ByteCompanionObject_0() {
    ByteCompanionObject_instance = this;
    this._MIN_VALUE_3 = -128;
    this._MAX_VALUE_3 = 127;
    this._SIZE_BYTES_3 = 1;
    this._SIZE_BITS_3 = 8;
  }
  ByteCompanionObject_0.prototype._get_MIN_VALUE__0_k$ = function () {
    return this._MIN_VALUE_3;
  };
  ByteCompanionObject_0.prototype._get_MAX_VALUE__0_k$ = function () {
    return this._MAX_VALUE_3;
  };
  ByteCompanionObject_0.prototype._get_SIZE_BYTES__0_k$ = function () {
    return this._SIZE_BYTES_3;
  };
  ByteCompanionObject_0.prototype._get_SIZE_BITS__0_k$ = function () {
    return this._SIZE_BITS_3;
  };
  ByteCompanionObject_0.$metadata$ = {
    simpleName: 'ByteCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(ByteCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_MIN_VALUE__0_k$
  });
  Object.defineProperty(ByteCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_MAX_VALUE__0_k$
  });
  Object.defineProperty(ByteCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_SIZE_BYTES__0_k$
  });
  Object.defineProperty(ByteCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_SIZE_BITS__0_k$
  });
  var ByteCompanionObject_instance;
  function ByteCompanionObject_getInstance() {
    if (ByteCompanionObject_instance == null)
      new ByteCompanionObject_0();
    return ByteCompanionObject_instance;
  }
  function ShortCompanionObject_0() {
    ShortCompanionObject_instance = this;
    this._MIN_VALUE_4 = -32768;
    this._MAX_VALUE_4 = 32767;
    this._SIZE_BYTES_4 = 2;
    this._SIZE_BITS_4 = 16;
  }
  ShortCompanionObject_0.prototype._get_MIN_VALUE__0_k$ = function () {
    return this._MIN_VALUE_4;
  };
  ShortCompanionObject_0.prototype._get_MAX_VALUE__0_k$ = function () {
    return this._MAX_VALUE_4;
  };
  ShortCompanionObject_0.prototype._get_SIZE_BYTES__0_k$ = function () {
    return this._SIZE_BYTES_4;
  };
  ShortCompanionObject_0.prototype._get_SIZE_BITS__0_k$ = function () {
    return this._SIZE_BITS_4;
  };
  ShortCompanionObject_0.$metadata$ = {
    simpleName: 'ShortCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(ShortCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_MIN_VALUE__0_k$
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_MAX_VALUE__0_k$
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_SIZE_BYTES__0_k$
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_SIZE_BITS__0_k$
  });
  var ShortCompanionObject_instance;
  function ShortCompanionObject_getInstance() {
    if (ShortCompanionObject_instance == null)
      new ShortCompanionObject_0();
    return ShortCompanionObject_instance;
  }
  function IntCompanionObject_0() {
    IntCompanionObject_instance = this;
    this._MIN_VALUE_5 = -2147483648;
    this._MAX_VALUE_5 = 2147483647;
    this._SIZE_BYTES_5 = 4;
    this._SIZE_BITS_5 = 32;
  }
  IntCompanionObject_0.prototype._get_MIN_VALUE__0_k$ = function () {
    return this._MIN_VALUE_5;
  };
  IntCompanionObject_0.prototype._get_MAX_VALUE__0_k$ = function () {
    return this._MAX_VALUE_5;
  };
  IntCompanionObject_0.prototype._get_SIZE_BYTES__0_k$ = function () {
    return this._SIZE_BYTES_5;
  };
  IntCompanionObject_0.prototype._get_SIZE_BITS__0_k$ = function () {
    return this._SIZE_BITS_5;
  };
  IntCompanionObject_0.$metadata$ = {
    simpleName: 'IntCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(IntCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MIN_VALUE__0_k$
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MAX_VALUE__0_k$
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BYTES__0_k$
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BITS__0_k$
  });
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    if (IntCompanionObject_instance == null)
      new IntCompanionObject_0();
    return IntCompanionObject_instance;
  }
  function FloatCompanionObject_0() {
    FloatCompanionObject_instance = this;
    this._MIN_VALUE_6 = 1.4E-45;
    this._MAX_VALUE_6 = 3.4028235E38;
    this._POSITIVE_INFINITY = Infinity;
    this._NEGATIVE_INFINITY = -Infinity;
    this._NaN = NaN;
    this._SIZE_BYTES_6 = 4;
    this._SIZE_BITS_6 = 32;
  }
  FloatCompanionObject_0.prototype._get_MIN_VALUE__0_k$ = function () {
    return this._MIN_VALUE_6;
  };
  FloatCompanionObject_0.prototype._get_MAX_VALUE__0_k$ = function () {
    return this._MAX_VALUE_6;
  };
  FloatCompanionObject_0.prototype._get_POSITIVE_INFINITY__0_k$ = function () {
    return this._POSITIVE_INFINITY;
  };
  FloatCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0_k$ = function () {
    return this._NEGATIVE_INFINITY;
  };
  FloatCompanionObject_0.prototype._get_NaN__0_k$ = function () {
    return this._NaN;
  };
  FloatCompanionObject_0.prototype._get_SIZE_BYTES__0_k$ = function () {
    return this._SIZE_BYTES_6;
  };
  FloatCompanionObject_0.prototype._get_SIZE_BITS__0_k$ = function () {
    return this._SIZE_BITS_6;
  };
  FloatCompanionObject_0.$metadata$ = {
    simpleName: 'FloatCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(FloatCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_MIN_VALUE__0_k$
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_MAX_VALUE__0_k$
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_POSITIVE_INFINITY__0_k$
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0_k$
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_NaN__0_k$
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_SIZE_BYTES__0_k$
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_SIZE_BITS__0_k$
  });
  var FloatCompanionObject_instance;
  function FloatCompanionObject_getInstance() {
    if (FloatCompanionObject_instance == null)
      new FloatCompanionObject_0();
    return FloatCompanionObject_instance;
  }
  function DoubleCompanionObject_0() {
    DoubleCompanionObject_instance = this;
    this._MIN_VALUE_7 = 4.9E-324;
    this._MAX_VALUE_7 = 1.7976931348623157E308;
    this._POSITIVE_INFINITY_0 = Infinity;
    this._NEGATIVE_INFINITY_0 = -Infinity;
    this._NaN_0 = NaN;
    this._SIZE_BYTES_7 = 8;
    this._SIZE_BITS_7 = 64;
  }
  DoubleCompanionObject_0.prototype._get_MIN_VALUE__0_k$ = function () {
    return this._MIN_VALUE_7;
  };
  DoubleCompanionObject_0.prototype._get_MAX_VALUE__0_k$ = function () {
    return this._MAX_VALUE_7;
  };
  DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY__0_k$ = function () {
    return this._POSITIVE_INFINITY_0;
  };
  DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0_k$ = function () {
    return this._NEGATIVE_INFINITY_0;
  };
  DoubleCompanionObject_0.prototype._get_NaN__0_k$ = function () {
    return this._NaN_0;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BYTES__0_k$ = function () {
    return this._SIZE_BYTES_7;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BITS__0_k$ = function () {
    return this._SIZE_BITS_7;
  };
  DoubleCompanionObject_0.$metadata$ = {
    simpleName: 'DoubleCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MIN_VALUE__0_k$
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MAX_VALUE__0_k$
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY__0_k$
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0_k$
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NaN__0_k$
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BYTES__0_k$
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BITS__0_k$
  });
  var DoubleCompanionObject_instance;
  function DoubleCompanionObject_getInstance() {
    if (DoubleCompanionObject_instance == null)
      new DoubleCompanionObject_0();
    return DoubleCompanionObject_instance;
  }
  function Comparator() {
  }
  Comparator.$metadata$ = {
    simpleName: 'Comparator',
    kind: 'interface',
    interfaces: []
  };
  function listOf_0(element) {
    return arrayListOf([element]);
  }
  function mapOf_0(pair) {
    return hashMapOf([pair]);
  }
  function setOf_0(element) {
    return hashSetOf([element]);
  }
  function sortWith(_this_, comparator) {
    collectionsSort(_this_, comparator);
  }
  function arrayCopy_0(source, destination, destinationOffset, startIndex, endIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(startIndex, endIndex, source.length);
    var rangeSize = endIndex - startIndex | 0;
    Companion_getInstance().checkRangeIndexes_zd700_k$(destinationOffset, destinationOffset + rangeSize | 0, destination.length);
    if (ArrayBuffer.isView(destination) && ArrayBuffer.isView(source)) {
      var subrange = source.subarray(startIndex, endIndex);
      destination.set(subrange, destinationOffset);
    } else {
      if (!(source === destination) ? true : destinationOffset <= startIndex) {
        var inductionVariable = 0;
        if (inductionVariable < rangeSize)
          do {
            var index_0 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination[destinationOffset + index_0 | 0] = source[startIndex + index_0 | 0];
          }
           while (inductionVariable < rangeSize);
      } else {
        var inductionVariable_0 = rangeSize - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            destination[destinationOffset + index_1 | 0] = source[startIndex + index_1 | 0];
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  function mapCapacity(expectedSize) {
    return expectedSize;
  }
  function sort(_this_) {
    collectionsSort(_this_, naturalOrder());
  }
  function checkCountOverflow(count_0) {
    if (count_0 < 0) {
      throwCountOverflow();
    }return count_0;
  }
  function checkIndexOverflow(index_0) {
    if (index_0 < 0) {
      throwIndexOverflow();
    }return index_0;
  }
  function copyToArray_0(collection) {
    var tmp;
    if (collection.toArray !== undefined) {
      var tmp0_unsafeCast_0 = collection.toArray();
      tmp = tmp0_unsafeCast_0;
    } else {
      {
        var tmp1_unsafeCast_0 = copyToArrayImpl_0(collection);
        tmp = tmp1_unsafeCast_0;
      }
    }
    return tmp;
  }
  function collectionsSort(list, comparator) {
    if (list._get_size__0_k$() <= 1)
      return Unit_getInstance();
    var array = copyToArray_0(list);
    sortArrayWith(array, comparator);
    var inductionVariable = 0;
    var last_1 = array.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.set_ddb1qf_k$(i, array[i]);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
  }
  function copyToArrayImpl_0(collection) {
    var array = [];
    var iterator_0 = collection.iterator_0_k$();
    while (iterator_0.hasNext_0_k$()) {
      array.push(iterator_0.next_0_k$());
    }
    return array;
  }
  function _no_name_provided__13($elements) {
    this._$elements = $elements;
  }
  _no_name_provided__13.prototype.invoke_2bq_k$ = function (it) {
    return this._$elements.contains_2bq_k$(it);
  };
  _no_name_provided__13.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_2bq_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__13.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.remove_2bq_k$ = function (element) {
    this.checkIsMutable_sv8swh_k$();
    var iterator_0 = this.iterator_0_k$();
    while (iterator_0.hasNext_0_k$()) {
      if (equals_1(iterator_0.next_0_k$(), element)) {
        iterator_0.remove_sv8swh_k$();
        return true;
      }}
    return false;
  };
  AbstractMutableCollection.prototype.addAll_dxd4eo_k$ = function (elements) {
    this.checkIsMutable_sv8swh_k$();
    var modified = false;
    var tmp0_iterator = elements.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      if (this.add_2bq_k$(element))
        modified = true;
    }
    return modified;
  };
  AbstractMutableCollection.prototype.removeAll_dxd4eo_k$ = function (elements) {
    this.checkIsMutable_sv8swh_k$();
    var tmp = isInterface(this, MutableIterable) ? this : THROW_CCE();
    return removeAll_0(tmp, _no_name_provided_$factory_6(elements));
  };
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.prototype.checkIsMutable_sv8swh_k$ = function () {
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function _no_name_provided_$factory_6($elements) {
    var i = new _no_name_provided__13($elements);
    return function (p1) {
      return i.invoke_2bq_k$(p1);
    };
  }
  function IteratorImpl($outer) {
    this._$this = $outer;
    this._index_3 = 0;
    this._last_2 = -1;
  }
  IteratorImpl.prototype._set_index__majfzk_k$ = function (_set___) {
    this._index_3 = _set___;
  };
  IteratorImpl.prototype.hasNext_0_k$ = function () {
    return this._index_3 < this._$this._get_size__0_k$();
  };
  IteratorImpl.prototype.next_0_k$ = function () {
    if (!this.hasNext_0_k$())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_3;
    tmp0_this._index_3 = tmp1 + 1 | 0;
    tmp._last_2 = tmp1;
    return this._$this.get_ha5a7z_k$(this._last_2);
  };
  IteratorImpl.prototype.remove_sv8swh_k$ = function () {
    var tmp0_check_0 = !(this._last_2 === -1);
    if (!tmp0_check_0) {
      var message_1 = 'Call next() or previous() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }this._$this.removeAt_ha5a7z_k$(this._last_2);
    Unit_getInstance();
    this._index_3 = this._last_2;
    this._last_2 = -1;
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ListIteratorImpl($outer, index_0) {
    this._$this_0 = $outer;
    IteratorImpl.call(this, $outer);
    Companion_getInstance().checkPositionIndex_rvwcgf_k$(index_0, this._$this_0._get_size__0_k$());
    this._set_index__majfzk_k$(index_0);
  }
  ListIteratorImpl.$metadata$ = {
    simpleName: 'ListIteratorImpl',
    kind: 'class',
    interfaces: [MutableListIterator]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this._modCount = 0;
  }
  AbstractMutableList.prototype._set_modCount__majfzk_k$ = function (_set___) {
    this._modCount = _set___;
  };
  AbstractMutableList.prototype._get_modCount__0_k$ = function () {
    return this._modCount;
  };
  AbstractMutableList.prototype.add_2bq_k$ = function (element) {
    this.checkIsMutable_sv8swh_k$();
    this.add_vz2mgm_k$(this._get_size__0_k$(), element);
    return true;
  };
  AbstractMutableList.prototype.iterator_0_k$ = function () {
    return new IteratorImpl(this);
  };
  AbstractMutableList.prototype.contains_2bq_k$ = function (element) {
    return this.indexOf_2bq_k$(element) >= 0;
  };
  AbstractMutableList.prototype.indexOf_2bq_k$ = function (element) {
    var inductionVariable = 0;
    var last_1 = _get_lastIndex__4(this);
    if (inductionVariable <= last_1)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this.get_ha5a7z_k$(index_0), element)) {
          return index_0;
        }}
       while (!(index_0 === last_1));
    return -1;
  };
  AbstractMutableList.prototype.listIterator_ha5a7z_k$ = function (index_0) {
    return new ListIteratorImpl(this, index_0);
  };
  AbstractMutableList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals_tuq55s_k$(this, other);
  };
  AbstractMutableList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode_dxd51x_k$(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function _no_name_provided__14($entryIterator) {
    this._$entryIterator_0 = $entryIterator;
  }
  _no_name_provided__14.prototype.hasNext_0_k$ = function () {
    return this._$entryIterator_0.hasNext_0_k$();
  };
  _no_name_provided__14.prototype.next_0_k$ = function () {
    return this._$entryIterator_0.next_0_k$()._get_key__0_k$();
  };
  _no_name_provided__14.prototype.remove_sv8swh_k$ = function () {
    return this._$entryIterator_0.remove_sv8swh_k$();
  };
  _no_name_provided__14.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function _no_name_provided__15($entryIterator) {
    this._$entryIterator_1 = $entryIterator;
  }
  _no_name_provided__15.prototype.hasNext_0_k$ = function () {
    return this._$entryIterator_1.hasNext_0_k$();
  };
  _no_name_provided__15.prototype.next_0_k$ = function () {
    return this._$entryIterator_1.next_0_k$()._get_value__0_k$();
  };
  _no_name_provided__15.prototype.remove_sv8swh_k$ = function () {
    return this._$entryIterator_1.remove_sv8swh_k$();
  };
  _no_name_provided__15.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function SimpleEntry(key, value) {
    this._key_0 = key;
    this.__value_0 = value;
  }
  SimpleEntry.prototype._get_key__0_k$ = function () {
    return this._key_0;
  };
  SimpleEntry.prototype._get_value__0_k$ = function () {
    return this.__value_0;
  };
  SimpleEntry.prototype.setValue_2c7_k$ = function (newValue) {
    var oldValue = this.__value_0;
    this.__value_0 = newValue;
    return oldValue;
  };
  SimpleEntry.prototype.hashCode = function () {
    return Companion_getInstance_0().entryHashCode_4vm2wp_k$(this);
  };
  SimpleEntry.prototype.toString = function () {
    return Companion_getInstance_0().entryToString_4vm2wp_k$(this);
  };
  SimpleEntry.prototype.equals = function (other) {
    return Companion_getInstance_0().entryEquals_caydzc_k$(this, other);
  };
  SimpleEntry.$metadata$ = {
    simpleName: 'SimpleEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function AbstractEntrySet() {
    AbstractMutableSet.call(this);
  }
  AbstractEntrySet.prototype.contains_2bq_k$ = function (element) {
    return this.containsEntry_4v0zae_k$(element);
  };
  AbstractEntrySet.prototype.remove_2bq_k$ = function (element) {
    return this.removeEntry_4v0zae_k$(element);
  };
  AbstractEntrySet.$metadata$ = {
    simpleName: 'AbstractEntrySet',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__16(this$0) {
    this._this$0_6 = this$0;
    AbstractMutableSet.call(this);
  }
  _no_name_provided__16.prototype.add_2bw_k$ = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  _no_name_provided__16.prototype.add_2bq_k$ = function (element) {
    return this.add_2bw_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__16.prototype.contains_2bw_k$ = function (element) {
    return this._this$0_6.containsKey_2bw_k$(element);
  };
  _no_name_provided__16.prototype.contains_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_2bw_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__16.prototype.iterator_0_k$ = function () {
    var entryIterator = this._this$0_6._get_entries__0_k$().iterator_0_k$();
    return new _no_name_provided__14(entryIterator);
  };
  _no_name_provided__16.prototype.remove_2bw_k$ = function (element) {
    this.checkIsMutable_sv8swh_k$();
    if (this._this$0_6.containsKey_2bw_k$(element)) {
      this._this$0_6.remove_2bw_k$(element);
      Unit_getInstance();
      return true;
    }return false;
  };
  _no_name_provided__16.prototype.remove_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_2bw_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__16.prototype._get_size__0_k$ = function () {
    return this._this$0_6._get_size__0_k$();
  };
  _no_name_provided__16.prototype.checkIsMutable_sv8swh_k$ = function () {
    return this._this$0_6.checkIsMutable_sv8swh_k$();
  };
  _no_name_provided__16.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__17(this$0) {
    this._this$0_7 = this$0;
    AbstractMutableCollection.call(this);
  }
  _no_name_provided__17.prototype.add_2c7_k$ = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on values');
  };
  _no_name_provided__17.prototype.add_2bq_k$ = function (element) {
    return this.add_2c7_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__17.prototype.contains_2c7_k$ = function (element) {
    return this._this$0_7.containsValue_2c7_k$(element);
  };
  _no_name_provided__17.prototype.contains_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_2c7_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__17.prototype.iterator_0_k$ = function () {
    var entryIterator = this._this$0_7._get_entries__0_k$().iterator_0_k$();
    return new _no_name_provided__15(entryIterator);
  };
  _no_name_provided__17.prototype._get_size__0_k$ = function () {
    return this._this$0_7._get_size__0_k$();
  };
  _no_name_provided__17.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, Collection) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals_tuq55s_k$(this, other);
  };
  _no_name_provided__17.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode_dxd51x_k$(this);
  };
  _no_name_provided__17.prototype.checkIsMutable_sv8swh_k$ = function () {
    return this._this$0_7.checkIsMutable_sv8swh_k$();
  };
  _no_name_provided__17.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.__keys_0 = null;
    this.__values_0 = null;
  }
  AbstractMutableMap.prototype._get_keys__0_k$ = function () {
    if (this.__keys_0 == null) {
      var tmp = this;
      tmp.__keys_0 = new _no_name_provided__16(this);
    }return ensureNotNull(this.__keys_0);
  };
  AbstractMutableMap.prototype.putAll_nn707j_k$ = function (from) {
    this.checkIsMutable_sv8swh_k$();
    var tmp0_iterator = from._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var tmp1_loop_parameter = tmp0_iterator.next_0_k$();
      var key = tmp1_loop_parameter._get_key__0_k$();
      var value = tmp1_loop_parameter._get_value__0_k$();
      this.put_1q9pf_k$(key, value);
      Unit_getInstance();
    }
  };
  AbstractMutableMap.prototype._get_values__0_k$ = function () {
    if (this.__values_0 == null) {
      var tmp = this;
      tmp.__values_0 = new _no_name_provided__17(this);
    }return ensureNotNull(this.__values_0);
  };
  AbstractMutableMap.prototype.remove_2bw_k$ = function (key) {
    this.checkIsMutable_sv8swh_k$();
    var iter = this._get_entries__0_k$().iterator_0_k$();
    while (iter.hasNext_0_k$()) {
      var entry = iter.next_0_k$();
      var k = entry._get_key__0_k$();
      if (equals_1(key, k)) {
        var value = entry._get_value__0_k$();
        iter.remove_sv8swh_k$();
        return value;
      }}
    return null;
  };
  AbstractMutableMap.prototype.checkIsMutable_sv8swh_k$ = function () {
  };
  AbstractMutableMap.$metadata$ = {
    simpleName: 'AbstractMutableMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  AbstractMutableSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals_qlktm2_k$(this, other);
  };
  AbstractMutableSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode_dxd51x_k$(this);
  };
  AbstractMutableSet.$metadata$ = {
    simpleName: 'AbstractMutableSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function ArrayList_init_$Init$($this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    ArrayList.call($this, copyToArray_0(elements));
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, Object.create(ArrayList.prototype));
  }
  function rangeCheck($this, index_0) {
    Companion_getInstance().checkElementIndex_rvwcgf_k$(index_0, $this._get_size__0_k$());
    return index_0;
  }
  function insertionRangeCheck($this, index_0) {
    Companion_getInstance().checkPositionIndex_rvwcgf_k$(index_0, $this._get_size__0_k$());
    return index_0;
  }
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this._array_3 = array;
    this._isReadOnly = false;
  }
  ArrayList.prototype._get_size__0_k$ = function () {
    return this._array_3.length;
  };
  ArrayList.prototype.get_ha5a7z_k$ = function (index_0) {
    var tmp = this._array_3[rangeCheck(this, index_0)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.set_ddb1qf_k$ = function (index_0, element) {
    this.checkIsMutable_sv8swh_k$();
    rangeCheck(this, index_0);
    Unit_getInstance();
    var tmp0_apply_0 = this._array_3[index_0];
    this._array_3[index_0] = element;
    var tmp = tmp0_apply_0;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.add_2bq_k$ = function (element) {
    this.checkIsMutable_sv8swh_k$();
    var tmp0_asDynamic_0 = this._array_3;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0_k$();
    tmp0_this._set_modCount__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.add_vz2mgm_k$ = function (index_0, element) {
    this.checkIsMutable_sv8swh_k$();
    var tmp0_asDynamic_0 = this._array_3;
    tmp0_asDynamic_0.splice(insertionRangeCheck(this, index_0), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0_k$();
    tmp0_this._set_modCount__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.addAll_dxd4eo_k$ = function (elements) {
    this.checkIsMutable_sv8swh_k$();
    if (elements.isEmpty_0_k$())
      return false;
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._array_3;
    var tmp1_plus_0 = copyToArray_0(elements);
    tmp._array_3 = tmp0_plus_0.concat(tmp1_plus_0);
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_modCount__0_k$();
    tmp1_this._set_modCount__majfzk_k$(tmp2 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.removeAt_ha5a7z_k$ = function (index_0) {
    this.checkIsMutable_sv8swh_k$();
    rangeCheck(this, index_0);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0_k$();
    tmp0_this._set_modCount__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp;
    if (index_0 === _get_lastIndex__4(this)) {
      var tmp0_asDynamic_0 = this._array_3;
      tmp = tmp0_asDynamic_0.pop();
    } else {
      var tmp1_asDynamic_0 = this._array_3;
      tmp = tmp1_asDynamic_0.splice(index_0, 1)[0];
    }
    return tmp;
  };
  ArrayList.prototype.remove_2bq_k$ = function (element) {
    this.checkIsMutable_sv8swh_k$();
    var inductionVariable = 0;
    var last_1 = this._array_3.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this._array_3[index_0], element)) {
          var tmp0_asDynamic_0 = this._array_3;
          tmp0_asDynamic_0.splice(index_0, 1);
          var tmp1_this = this;
          var tmp2 = tmp1_this._get_modCount__0_k$();
          tmp1_this._set_modCount__majfzk_k$(tmp2 + 1 | 0);
          Unit_getInstance();
          return true;
        }}
       while (inductionVariable <= last_1);
    return false;
  };
  ArrayList.prototype.clear_sv8swh_k$ = function () {
    this.checkIsMutable_sv8swh_k$();
    var tmp = this;
    tmp._array_3 = [];
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0_k$();
    tmp0_this._set_modCount__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.indexOf_2bq_k$ = function (element) {
    return indexOf(this._array_3, element);
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this._array_3);
  };
  ArrayList.prototype.toArray_0_k$ = function () {
    return [].slice.call(this._array_3);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_0_k$();
  };
  ArrayList.prototype.checkIsMutable_sv8swh_k$ = function () {
    if (this._isReadOnly)
      throw UnsupportedOperationException_init_$Create$();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  var _stableSortingIsSupported;
  function sortArrayWith(array, comparator) {
    if (getStableSortingIsSupported()) {
      var comparison = _no_name_provided_$factory_7(comparator);
      array.sort(comparison);
    } else {
      mergeSort(array, 0, _get_lastIndex__1(array), comparator);
    }
  }
  function sortArray(array) {
    if (getStableSortingIsSupported()) {
      var comparison = _no_name_provided_$factory_8();
      array.sort(comparison);
    } else {
      mergeSort(array, 0, _get_lastIndex__1(array), naturalOrder());
    }
  }
  function getStableSortingIsSupported() {
    var tmp0_safe_receiver = _stableSortingIsSupported;
    if (tmp0_safe_receiver == null)
      null;
    else {
      return tmp0_safe_receiver;
    }
    Unit_getInstance();
    _stableSortingIsSupported = false;
    var tmp0_unsafeCast_0 = [];
    var array = tmp0_unsafeCast_0;
    var inductionVariable = 0;
    if (inductionVariable < 600)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array.push(index_0);
      }
       while (inductionVariable < 600);
    var comparison = _no_name_provided_$factory_9();
    array.sort(comparison);
    var inductionVariable_0 = 1;
    var last_1 = array.length;
    if (inductionVariable_0 < last_1)
      do {
        var index_1 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var a = array[index_1 - 1 | 0];
        var b = array[index_1];
        if ((a & 3) === (b & 3) ? a >= b : false)
          return false;
      }
       while (inductionVariable_0 < last_1);
    _stableSortingIsSupported = true;
    return true;
  }
  function mergeSort(array, start, endInclusive, comparator) {
    var tmp0_arrayOfNulls_0 = array.length;
    var tmp1_unsafeCast_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var buffer = tmp1_unsafeCast_0;
    var result = mergeSort_0(array, buffer, start, endInclusive, comparator);
    if (!(result === array)) {
      var inductionVariable = start;
      if (inductionVariable <= endInclusive)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          array[i] = result[i];
        }
         while (!(i === endInclusive));
    }}
  function mergeSort_0(array, buffer, start, end, comparator) {
    if (start === end) {
      return array;
    }var median = (start + end | 0) / 2 | 0;
    var left = mergeSort_0(array, buffer, start, median, comparator);
    var right = mergeSort_0(array, buffer, median + 1 | 0, end, comparator);
    var target = left === buffer ? array : buffer;
    var leftIndex = start;
    var rightIndex = median + 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (leftIndex <= median ? rightIndex <= end : false) {
          var leftValue = left[leftIndex];
          var rightValue = right[rightIndex];
          if (comparator.compare(leftValue, rightValue) <= 0) {
            target[i] = leftValue;
            var tmp1 = leftIndex;
            leftIndex = tmp1 + 1 | 0;
            Unit_getInstance();
          } else {
            target[i] = rightValue;
            var tmp2 = rightIndex;
            rightIndex = tmp2 + 1 | 0;
            Unit_getInstance();
          }
        } else if (leftIndex <= median) {
          target[i] = left[leftIndex];
          var tmp3 = leftIndex;
          leftIndex = tmp3 + 1 | 0;
          Unit_getInstance();
        } else {
          target[i] = right[rightIndex];
          var tmp4 = rightIndex;
          rightIndex = tmp4 + 1 | 0;
          Unit_getInstance();
          Unit_getInstance();
        }
      }
       while (!(i === end));
    return target;
  }
  function _no_name_provided__18($comparator) {
    this._$comparator = $comparator;
  }
  _no_name_provided__18.prototype.invoke_1qgdm_k$ = function (a, b) {
    return this._$comparator.compare(a, b);
  };
  _no_name_provided__18.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE();
    return this.invoke_1qgdm_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__18.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__19() {
  }
  _no_name_provided__19.prototype.invoke_1qgdm_k$ = function (a, b) {
    return compareTo(a, b);
  };
  _no_name_provided__19.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isComparable(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_1qgdm_k$(tmp, (!(p2 == null) ? isComparable(p2) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__19.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__20() {
  }
  _no_name_provided__20.prototype.invoke_27zxwg_k$ = function (a, b) {
    return (a & 3) - (b & 3) | 0;
  };
  _no_name_provided__20.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_27zxwg_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__20.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_7($comparator) {
    var i = new _no_name_provided__18($comparator);
    return function (p1, p2) {
      return i.invoke_1qgdm_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_8() {
    var i = new _no_name_provided__19();
    return function (p1, p2) {
      return i.invoke_1qgdm_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_9() {
    var i = new _no_name_provided__20();
    return function (p1, p2) {
      return i.invoke_27zxwg_k$(p1, p2);
    };
  }
  function HashCode() {
    HashCode_instance = this;
  }
  HashCode.prototype.equals_rvz98i_k$ = function (value1, value2) {
    return equals_1(value1, value2);
  };
  HashCode.prototype.getHashCode_wi7j7l_k$ = function (value) {
    var tmp0_safe_receiver = value;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  HashCode.$metadata$ = {
    simpleName: 'HashCode',
    kind: 'object',
    interfaces: [EqualityComparator]
  };
  var HashCode_instance;
  function HashCode_getInstance() {
    if (HashCode_instance == null)
      new HashCode();
    return HashCode_instance;
  }
  function EqualityComparator() {
  }
  EqualityComparator.$metadata$ = {
    simpleName: 'EqualityComparator',
    kind: 'interface',
    interfaces: []
  };
  function EntrySet($outer) {
    this._$this_1 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet.prototype.add_qbahou_k$ = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet.prototype.add_2bq_k$ = function (element) {
    return this.add_qbahou_k$((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.containsEntry_4v0zae_k$ = function (element) {
    return this._$this_1.containsEntry_7gsh9e_k$(element);
  };
  EntrySet.prototype.iterator_0_k$ = function () {
    return this._$this_1._internalMap.iterator_0_k$();
  };
  EntrySet.prototype.removeEntry_4v0zae_k$ = function (element) {
    if (contains_5(this, element)) {
      this._$this_1.remove_2bw_k$(element._get_key__0_k$());
      Unit_getInstance();
      return true;
    }return false;
  };
  EntrySet.prototype._get_size__0_k$ = function () {
    return this._$this_1._get_size__0_k$();
  };
  EntrySet.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this._internalMap = internalMap;
    $this._equality = internalMap._get_equality__0_k$();
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(new InternalHashCodeMap(HashCode_getInstance()), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_0($this);
    var tmp0_require_0 = initialCapacity >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_require_0 = loadFactor >= 0;
    if (!tmp1_require_0) {
      var message_1_0 = '' + 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
    }return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return HashMap_init_$Init$_1(initialCapacity, loadFactor, Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_2(initialCapacity, $this) {
    HashMap_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashMap_init_$Create$_1(initialCapacity) {
    return HashMap_init_$Init$_2(initialCapacity, Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_3(original, $this) {
    HashMap_init_$Init$_0($this);
    $this.putAll_nn707j_k$(original);
    return $this;
  }
  function HashMap_init_$Create$_2(original) {
    return HashMap_init_$Init$_3(original, Object.create(HashMap.prototype));
  }
  HashMap.prototype.clear_sv8swh_k$ = function () {
    this._internalMap.clear_sv8swh_k$();
  };
  HashMap.prototype.containsKey_2bw_k$ = function (key) {
    return this._internalMap.contains_2bw_k$(key);
  };
  HashMap.prototype.containsValue_2c7_k$ = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._internalMap;
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (this._equality.equals_rvz98i_k$(element_2._get_value__0_k$(), value)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  HashMap.prototype._get_entries__0_k$ = function () {
    if (this.__entries == null) {
      this.__entries = this.createEntrySet_0_k$();
    }return ensureNotNull(this.__entries);
  };
  HashMap.prototype.createEntrySet_0_k$ = function () {
    return new EntrySet(this);
  };
  HashMap.prototype.get_2bw_k$ = function (key) {
    return this._internalMap.get_2bw_k$(key);
  };
  HashMap.prototype.put_1q9pf_k$ = function (key, value) {
    return this._internalMap.put_1q9pf_k$(key, value);
  };
  HashMap.prototype.remove_2bw_k$ = function (key) {
    return this._internalMap.remove_2bw_k$(key);
  };
  HashMap.prototype._get_size__0_k$ = function () {
    return this._internalMap._get_size__0_k$();
  };
  function HashMap() {
    this.__entries = null;
  }
  HashMap.$metadata$ = {
    simpleName: 'HashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function HashSet_init_$Init$(initialCapacity, loadFactor, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$_0(initialCapacity, loadFactor);
    return $this;
  }
  function HashSet_init_$Init$_0(initialCapacity, $this) {
    HashSet_init_$Init$(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashSet_init_$Create$(initialCapacity) {
    return HashSet_init_$Init$_0(initialCapacity, Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_1(map_0, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = map_0;
    return $this;
  }
  HashSet.prototype._get_map__0_k$ = function () {
    return this._map;
  };
  HashSet.prototype.add_2bq_k$ = function (element) {
    var old = this._map.put_1q9pf_k$(element, this);
    return old == null;
  };
  HashSet.prototype.clear_sv8swh_k$ = function () {
    this._map.clear_sv8swh_k$();
  };
  HashSet.prototype.contains_2bq_k$ = function (element) {
    return this._map.containsKey_2bw_k$(element);
  };
  HashSet.prototype.isEmpty_0_k$ = function () {
    return this._map.isEmpty_0_k$();
  };
  HashSet.prototype.iterator_0_k$ = function () {
    return this._map._get_keys__0_k$().iterator_0_k$();
  };
  HashSet.prototype.remove_2bq_k$ = function (element) {
    return !(this._map.remove_2bw_k$(element) == null);
  };
  HashSet.prototype._get_size__0_k$ = function () {
    return this._map._get_size__0_k$();
  };
  function HashSet() {
  }
  HashSet.$metadata$ = {
    simpleName: 'HashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function computeNext($this) {
    if ($this._chainOrEntry != null ? $this._isChain : false) {
      var tmp0_unsafeCast_0 = $this._chainOrEntry;
      var chainSize = tmp0_unsafeCast_0.length;
      var tmp0_this = $this;
      tmp0_this._itemIndex = tmp0_this._itemIndex + 1 | 0;
      if (tmp0_this._itemIndex < chainSize)
        return 0;
      else {
      }
    }var tmp1_this = $this;
    tmp1_this._keyIndex = tmp1_this._keyIndex + 1 | 0;
    if (tmp1_this._keyIndex < $this._keys.length) {
      $this._chainOrEntry = $this._this$0_8._backingMap[$this._keys[$this._keyIndex]];
      var tmp = $this;
      var tmp_0 = $this._chainOrEntry;
      tmp._isChain = !(tmp_0 == null) ? isArray(tmp_0) : false;
      $this._itemIndex = 0;
      return 0;
    } else {
      {
        $this._chainOrEntry = null;
        return 1;
      }
    }
  }
  function getEntry($this, key) {
    var tmp0_elvis_lhs = getChainOrEntryOrNull($this, $this._equality_0.getHashCode_wi7j7l_k$(key));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if ($this._equality_0.equals_rvz98i_k$(entry._get_key__0_k$(), key)) {
        return entry;
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        return findEntryInChain(chain, $this, key);
      }
    }
  }
  function findEntryInChain(_this_, $this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = _this_;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if ($this._equality_0.equals_rvz98i_k$(element_2._get_key__0_k$(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function getChainOrEntryOrNull($this, hashCode_1) {
    var chainOrEntry = $this._backingMap[hashCode_1];
    return chainOrEntry === undefined ? null : chainOrEntry;
  }
  function _no_name_provided__21(this$0) {
    this._this$0_8 = this$0;
    this._state_0 = -1;
    this._keys = Object.keys(this._this$0_8._backingMap);
    this._keyIndex = -1;
    this._chainOrEntry = null;
    this._isChain = false;
    this._itemIndex = -1;
    this._lastEntry = null;
  }
  _no_name_provided__21.prototype.hasNext_0_k$ = function () {
    if (this._state_0 === -1)
      this._state_0 = computeNext(this);
    return this._state_0 === 0;
  };
  _no_name_provided__21.prototype.next_0_k$ = function () {
    if (!this.hasNext_0_k$())
      throw NoSuchElementException_init_$Create$();
    var tmp;
    if (this._isChain) {
      var tmp0_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp0_unsafeCast_0[this._itemIndex];
    } else {
      var tmp1_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp1_unsafeCast_0;
    }
    var lastEntry = tmp;
    this._lastEntry = lastEntry;
    this._state_0 = -1;
    return lastEntry;
  };
  _no_name_provided__21.prototype.remove_sv8swh_k$ = function () {
    var tmp0_checkNotNull_0 = this._lastEntry;
    var tmp$ret$0;
    l$ret$1: do {
      if (tmp0_checkNotNull_0 == null) {
        var message_2_1 = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
      } else {
        tmp$ret$0 = tmp0_checkNotNull_0;
        break l$ret$1;
      }
    }
     while (false);
    Unit_getInstance();
    this._this$0_8.remove_2bw_k$(ensureNotNull(this._lastEntry)._get_key__0_k$());
    Unit_getInstance();
    this._lastEntry = null;
    var tmp0_this = this;
    var tmp1 = tmp0_this._itemIndex;
    tmp0_this._itemIndex = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  _no_name_provided__21.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function InternalHashCodeMap(equality) {
    this._equality_0 = equality;
    this._backingMap = this.createJsMap_0_k$();
    this._size = 0;
  }
  InternalHashCodeMap.prototype._get_equality__0_k$ = function () {
    return this._equality_0;
  };
  InternalHashCodeMap.prototype._get_size__0_k$ = function () {
    return this._size;
  };
  InternalHashCodeMap.prototype.put_1q9pf_k$ = function (key, value) {
    var hashCode_1 = this._equality_0.getHashCode_wi7j7l_k$(key);
    var chainOrEntry = getChainOrEntryOrNull(this, hashCode_1);
    if (chainOrEntry == null) {
      this._backingMap[hashCode_1] = new SimpleEntry(key, value);
    } else {
      if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
        var entry = chainOrEntry;
        if (this._equality_0.equals_rvz98i_k$(entry._get_key__0_k$(), key)) {
          return entry.setValue_2c7_k$(value);
        } else {
          var tmp0_arrayOf_0 = [entry, new SimpleEntry(key, value)];
          this._backingMap[hashCode_1] = tmp0_arrayOf_0;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size;
          tmp0_this._size = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }
      } else {
        {
          var chain = chainOrEntry;
          var entry_0 = findEntryInChain(chain, this, key);
          if (!(entry_0 == null)) {
            return entry_0.setValue_2c7_k$(value);
          }chain.push(new SimpleEntry(key, value));
        }
      }
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this._size;
    tmp2_this._size = tmp3 + 1 | 0;
    Unit_getInstance();
    return null;
  };
  InternalHashCodeMap.prototype.remove_2bw_k$ = function (key) {
    var hashCode_1 = this._equality_0.getHashCode_wi7j7l_k$(key);
    var tmp0_elvis_lhs = getChainOrEntryOrNull(this, hashCode_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if (this._equality_0.equals_rvz98i_k$(entry._get_key__0_k$(), key)) {
        jsDeleteProperty(this._backingMap, hashCode_1);
        var tmp1_this = this;
        var tmp2 = tmp1_this._size;
        tmp1_this._size = tmp2 - 1 | 0;
        Unit_getInstance();
        return entry._get_value__0_k$();
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        var inductionVariable = 0;
        var last_1 = chain.length - 1 | 0;
        if (inductionVariable <= last_1)
          do {
            var index_0 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var entry_0 = chain[index_0];
            if (this._equality_0.equals_rvz98i_k$(key, entry_0._get_key__0_k$())) {
              if (chain.length === 1) {
                chain.length = 0;
                jsDeleteProperty(this._backingMap, hashCode_1);
              } else {
                chain.splice(index_0, 1);
              }
              var tmp4_this = this;
              var tmp5 = tmp4_this._size;
              tmp4_this._size = tmp5 - 1 | 0;
              Unit_getInstance();
              return entry_0._get_value__0_k$();
            }}
           while (inductionVariable <= last_1);
      }
    }
    return null;
  };
  InternalHashCodeMap.prototype.clear_sv8swh_k$ = function () {
    this._backingMap = this.createJsMap_0_k$();
    this._size = 0;
  };
  InternalHashCodeMap.prototype.contains_2bw_k$ = function (key) {
    return !(getEntry(this, key) == null);
  };
  InternalHashCodeMap.prototype.get_2bw_k$ = function (key) {
    var tmp0_safe_receiver = getEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__0_k$();
  };
  InternalHashCodeMap.prototype.iterator_0_k$ = function () {
    return new _no_name_provided__21(this);
  };
  InternalHashCodeMap.$metadata$ = {
    simpleName: 'InternalHashCodeMap',
    kind: 'class',
    interfaces: [InternalMap]
  };
  function InternalMap() {
  }
  InternalMap.prototype.createJsMap_0_k$ = function () {
    var result = Object.create(null);
    result['foo'] = 1;
    jsDeleteProperty(result, 'foo');
    return result;
  };
  InternalMap.$metadata$ = {
    simpleName: 'InternalMap',
    kind: 'interface',
    interfaces: [MutableIterable]
  };
  function EntryIterator($outer) {
    this._$this_2 = $outer;
    this._last_3 = null;
    this._next_3 = null;
    this._next_3 = this._$this_2._$this_4._head;
  }
  EntryIterator.prototype.hasNext_0_k$ = function () {
    return !(this._next_3 === null);
  };
  EntryIterator.prototype.next_0_k$ = function () {
    if (!this.hasNext_0_k$())
      throw NoSuchElementException_init_$Create$();
    var current = ensureNotNull(this._next_3);
    this._last_3 = current;
    var tmp = this;
    var tmp0_takeIf_0 = current._next_4;
    var tmp_0;
    if (!(tmp0_takeIf_0 === this._$this_2._$this_4._head)) {
      tmp_0 = tmp0_takeIf_0;
    } else {
      {
        tmp_0 = null;
      }
    }
    tmp._next_3 = tmp_0;
    return current;
  };
  EntryIterator.prototype.remove_sv8swh_k$ = function () {
    var tmp0_check_0 = !(this._last_3 == null);
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }this._$this_2.checkIsMutable_sv8swh_k$();
    remove(ensureNotNull(this._last_3), this._$this_2._$this_4);
    this._$this_2._$this_4._map_0.remove_2bw_k$(ensureNotNull(this._last_3)._get_key__0_k$());
    Unit_getInstance();
    this._last_3 = null;
  };
  EntryIterator.$metadata$ = {
    simpleName: 'EntryIterator',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ChainEntry($outer, key, value) {
    this._$this_3 = $outer;
    SimpleEntry.call(this, key, value);
    this._next_4 = null;
    this._prev = null;
  }
  ChainEntry.prototype.setValue_2c7_k$ = function (newValue) {
    this._$this_3.checkIsMutable_sv8swh_k$();
    return SimpleEntry.prototype.setValue_2c7_k$.call(this, newValue);
  };
  ChainEntry.$metadata$ = {
    simpleName: 'ChainEntry',
    kind: 'class',
    interfaces: []
  };
  function EntrySet_0($outer) {
    this._$this_4 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet_0.prototype.add_qbahou_k$ = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet_0.prototype.add_2bq_k$ = function (element) {
    return this.add_qbahou_k$((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype.containsEntry_4v0zae_k$ = function (element) {
    return this._$this_4.containsEntry_7gsh9e_k$(element);
  };
  EntrySet_0.prototype.iterator_0_k$ = function () {
    return new EntryIterator(this);
  };
  EntrySet_0.prototype.removeEntry_4v0zae_k$ = function (element) {
    this.checkIsMutable_sv8swh_k$();
    if (contains_5(this, element)) {
      this._$this_4.remove_2bw_k$(element._get_key__0_k$());
      Unit_getInstance();
      return true;
    }return false;
  };
  EntrySet_0.prototype._get_size__0_k$ = function () {
    return this._$this_4._get_size__0_k$();
  };
  EntrySet_0.prototype.checkIsMutable_sv8swh_k$ = function () {
    return this._$this_4.checkIsMutable_sv8swh_k$();
  };
  EntrySet_0.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function addToEnd(_this_, $this) {
    var tmp0_check_0 = _this_._next_4 == null ? _this_._prev == null : false;
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var _head = $this._head;
    if (_head == null) {
      $this._head = _this_;
      _this_._next_4 = _this_;
      _this_._prev = _this_;
    } else {
      var tmp1_checkNotNull_0 = _head._prev;
      var tmp$ret$0;
      l$ret$1: do {
        if (tmp1_checkNotNull_0 == null) {
          var message_2_1_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
        } else {
          tmp$ret$0 = tmp1_checkNotNull_0;
          break l$ret$1;
        }
      }
       while (false);
      var _tail = tmp$ret$0;
      _this_._prev = _tail;
      _this_._next_4 = _head;
      _head._prev = _this_;
      _tail._next_4 = _this_;
    }
  }
  function remove(_this_, $this) {
    if (_this_._next_4 === _this_) {
      $this._head = null;
    } else {
      if ($this._head === _this_) {
        $this._head = _this_._next_4;
      }ensureNotNull(_this_._next_4)._prev = _this_._prev;
      ensureNotNull(_this_._prev)._next_4 = _this_._next_4;
    }
    _this_._next_4 = null;
    _this_._prev = null;
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_1(initialCapacity, loadFactor, $this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_1(initialCapacity, $this) {
    LinkedHashMap_init_$Init$_0(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_1(initialCapacity) {
    return LinkedHashMap_init_$Init$_1(initialCapacity, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_2(original, $this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    $this.putAll_nn707j_k$(original);
    return $this;
  }
  function LinkedHashMap_init_$Create$_2(original) {
    return LinkedHashMap_init_$Init$_2(original, Object.create(LinkedHashMap.prototype));
  }
  LinkedHashMap.prototype.clear_sv8swh_k$ = function () {
    this.checkIsMutable_sv8swh_k$();
    this._map_0.clear_sv8swh_k$();
    this._head = null;
  };
  LinkedHashMap.prototype.containsKey_2bw_k$ = function (key) {
    return this._map_0.containsKey_2bw_k$(key);
  };
  LinkedHashMap.prototype.containsValue_2c7_k$ = function (value) {
    var tmp0_elvis_lhs = this._head;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    do {
      if (equals_1(node._get_value__0_k$(), value)) {
        return true;
      }node = ensureNotNull(node._next_4);
    }
     while (!(node === this._head));
    return false;
  };
  LinkedHashMap.prototype.createEntrySet_0_k$ = function () {
    return new EntrySet_0(this);
  };
  LinkedHashMap.prototype.get_2bw_k$ = function (key) {
    var tmp0_safe_receiver = this._map_0.get_2bw_k$(key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__0_k$();
  };
  LinkedHashMap.prototype.put_1q9pf_k$ = function (key, value) {
    this.checkIsMutable_sv8swh_k$();
    var old = this._map_0.get_2bw_k$(key);
    if (old == null) {
      var newEntry = new ChainEntry(this, key, value);
      this._map_0.put_1q9pf_k$(key, newEntry);
      Unit_getInstance();
      addToEnd(newEntry, this);
      return null;
    } else {
      return old.setValue_2c7_k$(value);
    }
  };
  LinkedHashMap.prototype.remove_2bw_k$ = function (key) {
    this.checkIsMutable_sv8swh_k$();
    var entry = this._map_0.remove_2bw_k$(key);
    if (!(entry == null)) {
      remove(entry, this);
      return entry._get_value__0_k$();
    }return null;
  };
  LinkedHashMap.prototype._get_size__0_k$ = function () {
    return this._map_0._get_size__0_k$();
  };
  LinkedHashMap.prototype.checkIsMutable_sv8swh_k$ = function () {
    if (this._isReadOnly_0)
      throw UnsupportedOperationException_init_$Create$();
  };
  function LinkedHashMap() {
    this._head = null;
    this._isReadOnly_0 = false;
  }
  LinkedHashMap.$metadata$ = {
    simpleName: 'LinkedHashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function LinkedHashSet_init_$Init$($this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$() {
    return LinkedHashSet_init_$Init$(Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_0(elements, $this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    $this.addAll_dxd4eo_k$(elements);
    Unit_getInstance();
    return $this;
  }
  function LinkedHashSet_init_$Create$_0(elements) {
    return LinkedHashSet_init_$Init$_0(elements, Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Init$_2(initialCapacity, $this) {
    LinkedHashSet_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_1(initialCapacity) {
    return LinkedHashSet_init_$Init$_2(initialCapacity, Object.create(LinkedHashSet.prototype));
  }
  LinkedHashSet.prototype.checkIsMutable_sv8swh_k$ = function () {
    return this._get_map__0_k$().checkIsMutable_sv8swh_k$();
  };
  function LinkedHashSet() {
  }
  LinkedHashSet.$metadata$ = {
    simpleName: 'LinkedHashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  var output;
  function BaseOutput() {
  }
  BaseOutput.prototype.println_sv8swh_k$ = function () {
    this.print_qi8yb4_k$('\n');
  };
  BaseOutput.prototype.println_qi8yb4_k$ = function (message) {
    this.print_qi8yb4_k$(message);
    this.println_sv8swh_k$();
  };
  BaseOutput.$metadata$ = {
    simpleName: 'BaseOutput',
    kind: 'class',
    interfaces: []
  };
  function NodeJsOutput_0(outputStream) {
    BaseOutput.call(this);
    this._outputStream = outputStream;
  }
  NodeJsOutput_0.prototype.print_qi8yb4_k$ = function (message) {
    var messageString = String(message);
    this._outputStream.write(messageString);
  };
  NodeJsOutput_0.$metadata$ = {
    simpleName: 'NodeJsOutput',
    kind: 'class',
    interfaces: []
  };
  function BufferedOutputToConsoleLog_0() {
    BufferedOutput_0.call(this);
  }
  BufferedOutputToConsoleLog_0.prototype.print_qi8yb4_k$ = function (message) {
    var s = String(message);
    var tmp0_nativeLastIndexOf_0 = s;
    var i = tmp0_nativeLastIndexOf_0.lastIndexOf('\n', 0);
    if (i >= 0) {
      var tmp0_this = this;
      var tmp = tmp0_this._get_buffer__0_k$();
      var tmp1_substring_0 = s;
      tmp0_this._set_buffer__a4enbm_k$(tmp + tmp1_substring_0.substring(0, i));
      this.flush_sv8swh_k$();
      var tmp2_substring_0 = s;
      var tmp3_substring_0 = i + 1 | 0;
      s = tmp2_substring_0.substring(tmp3_substring_0);
    }var tmp1_this = this;
    tmp1_this._set_buffer__a4enbm_k$(tmp1_this._get_buffer__0_k$() + s);
  };
  BufferedOutputToConsoleLog_0.prototype.flush_sv8swh_k$ = function () {
    console.log(this._get_buffer__0_k$());
    this._set_buffer__a4enbm_k$('');
  };
  BufferedOutputToConsoleLog_0.$metadata$ = {
    simpleName: 'BufferedOutputToConsoleLog',
    kind: 'class',
    interfaces: []
  };
  function BufferedOutput_0() {
    BaseOutput.call(this);
    this._buffer = '';
  }
  BufferedOutput_0.prototype._set_buffer__a4enbm_k$ = function (_set___) {
    this._buffer = _set___;
  };
  BufferedOutput_0.prototype._get_buffer__0_k$ = function () {
    return this._buffer;
  };
  BufferedOutput_0.prototype.print_qi8yb4_k$ = function (message) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._buffer;
    tmp._buffer = tmp_0 + String(message);
  };
  BufferedOutput_0.$metadata$ = {
    simpleName: 'BufferedOutput',
    kind: 'class',
    interfaces: []
  };
  function println(message) {
    output.println_qi8yb4_k$(message);
  }
  function output$init$() {
    var isNode_2 = typeof process !== 'undefined' && process.versions && !!process.versions.node;
    return isNode_2 ? new NodeJsOutput_0(process.stdout) : new BufferedOutputToConsoleLog_0();
  }
  function SafeContinuation_init_$Init$(delegate, $this) {
    SafeContinuation.call($this, delegate, CoroutineSingletons_UNDECIDED_getInstance());
    return $this;
  }
  function SafeContinuation_init_$Create$(delegate) {
    return SafeContinuation_init_$Init$(delegate, Object.create(SafeContinuation.prototype));
  }
  function SafeContinuation(delegate, initialResult) {
    this._delegate = delegate;
    this._result = initialResult;
  }
  SafeContinuation.prototype._get_context__0_k$ = function () {
    return this._delegate._get_context__0_k$();
  };
  SafeContinuation.prototype.resumeWith_bnunh2_k$ = function (result) {
    var cur = this._result;
    if (cur === CoroutineSingletons_UNDECIDED_getInstance()) {
      this._result = _Result___get_value__impl_(result);
    } else if (cur === _get_COROUTINE_SUSPENDED_()) {
      this._result = CoroutineSingletons_RESUMED_getInstance();
      this._delegate.resumeWith_bnunh2_k$(result);
    } else
      throw IllegalStateException_init_$Create$_0('Already resumed');
  };
  SafeContinuation.prototype.getOrThrow_0_k$ = function () {
    if (this._result === CoroutineSingletons_UNDECIDED_getInstance()) {
      this._result = _get_COROUTINE_SUSPENDED_();
      return _get_COROUTINE_SUSPENDED_();
    }var result = this._result;
    var tmp;
    if (result === CoroutineSingletons_RESUMED_getInstance()) {
      tmp = _get_COROUTINE_SUSPENDED_();
    } else {
      if (result instanceof Failure) {
        throw result._exception;
      } else {
        {
          tmp = result;
        }
      }
    }
    return tmp;
  };
  SafeContinuation.$metadata$ = {
    simpleName: 'SafeContinuation',
    kind: 'class',
    interfaces: [Continuation]
  };
  function CancellationException_init_$Init$(message, $this) {
    IllegalStateException_init_$Init$_0(message, $this);
    CancellationException.call($this);
    return $this;
  }
  function CancellationException_init_$Create$(message) {
    var tmp = CancellationException_init_$Init$(message, Object.create(CancellationException.prototype));
    captureStack(tmp, CancellationException_init_$Create$);
    return tmp;
  }
  function CancellationException_init_$Init$_0(message, cause, $this) {
    IllegalStateException_init_$Init$_1(message, cause, $this);
    CancellationException.call($this);
    return $this;
  }
  function CancellationException_init_$Create$_0(message, cause) {
    var tmp = CancellationException_init_$Init$_0(message, cause, Object.create(CancellationException.prototype));
    captureStack(tmp, CancellationException_init_$Create$_0);
    return tmp;
  }
  function CancellationException() {
    captureStack(this, CancellationException);
  }
  CancellationException.$metadata$ = {
    simpleName: 'CancellationException',
    kind: 'class',
    interfaces: []
  };
  function _get_EmptyContinuation_() {
    return EmptyContinuation;
  }
  var EmptyContinuation;
  function _no_name_provided__1_2($tmp0_Continuation_0) {
    this._$tmp0_Continuation_0 = $tmp0_Continuation_0;
  }
  _no_name_provided__1_2.prototype._get_context__2_0_k$ = function () {
    return this._$tmp0_Continuation_0;
  };
  _no_name_provided__1_2.prototype._get_context__0_k$ = function () {
    return this._get_context__2_0_k$();
  };
  _no_name_provided__1_2.prototype.resumeWith_3_jccoe6_k$ = function (result) {
    throwOnFailure(result);
    var tmp = _Result___get_value__impl_(result);
    if (tmp == null ? true : isObject(tmp))
      tmp;
    else
      THROW_CCE();
    return Unit_getInstance();
  };
  _no_name_provided__1_2.prototype.resumeWith_bnunh2_k$ = function (result) {
    return this.resumeWith_3_jccoe6_k$(result);
  };
  _no_name_provided__1_2.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Continuation]
  };
  function EmptyContinuation$init$() {
    var tmp0_Continuation_0 = EmptyCoroutineContext_getInstance();
    return new _no_name_provided__1_2(tmp0_Continuation_0);
  }
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function round(x) {
    if (!(x % 0.5 === 0.0)) {
      return Math.round(x);
    }var floor = Math.floor(x);
    var tmp;
    if (floor % 2 === 0.0) {
      tmp = floor;
    } else {
      tmp = Math.ceil(x);
    }
    return tmp;
  }
  function abs(n) {
    return n < 0 ? -n | 0 | 0 : n;
  }
  function roundToInt(_this_) {
    var tmp;
    if (isNaN_0(_this_)) {
      throw IllegalArgumentException_init_$Create$('Cannot round NaN value.');
    } else if (_this_ > IntCompanionObject_getInstance()._MAX_VALUE_5) {
      tmp = IntCompanionObject_getInstance()._MAX_VALUE_5;
    } else if (_this_ < IntCompanionObject_getInstance()._MIN_VALUE_5) {
      tmp = IntCompanionObject_getInstance()._MIN_VALUE_5;
    } else {
      tmp = numberToInt(Math.round(_this_));
    }
    return tmp;
  }
  function nextDown(_this_) {
    var tmp;
    var tmp_0;
    if (isNaN_0(_this_)) {
      tmp_0 = true;
    } else {
      DoubleCompanionObject_getInstance();
      tmp_0 = _this_ === -Infinity;
    }
    if (tmp_0) {
      tmp = _this_;
    } else {
      if (_this_ === 0.0) {
        DoubleCompanionObject_getInstance();
        tmp = -4.9E-324;
      } else {
        {
          var tmp2_fromBits_0 = DoubleCompanionObject_getInstance();
          var tmp0_plus_0 = toRawBits(_this_);
          var tmp1_plus_0 = _this_ > 0.0 ? -1 : 1;
          var tmp3_fromBits_0 = tmp0_plus_0.plus_wiekkq_k$(toLong(tmp1_plus_0));
          tmp = doubleFromBits(tmp3_fromBits_0);
        }
      }
    }
    return tmp;
  }
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function isNaN_1(_this_) {
    return !(_this_ === _this_);
  }
  function isInfinite(_this_) {
    var tmp;
    FloatCompanionObject_getInstance();
    if (_this_ === Infinity) {
      tmp = true;
    } else {
      {
        FloatCompanionObject_getInstance();
        tmp = _this_ === -Infinity;
      }
    }
    return tmp;
  }
  function isInfinite_0(_this_) {
    var tmp;
    DoubleCompanionObject_getInstance();
    if (_this_ === Infinity) {
      tmp = true;
    } else {
      {
        DoubleCompanionObject_getInstance();
        tmp = _this_ === -Infinity;
      }
    }
    return tmp;
  }
  function isFinite(_this_) {
    return !isInfinite_0(_this_) ? !isNaN_0(_this_) : false;
  }
  var INV_2_26;
  var INV_2_53;
  function doubleFromParts(hi26, low27) {
    return hi26 * INV_2_26 + low27 * INV_2_53;
  }
  function defaultPlatformRandom() {
    var tmp0_unsafeCast_0 = Math.random() * Math.pow(2, 32) | 0;
    return Random_1(tmp0_unsafeCast_0);
  }
  function INV_2_26$init$() {
    return Math.pow(2.0, -26.0);
  }
  function INV_2_53$init$() {
    return Math.pow(2.0, -53.0);
  }
  function _get_js_(_this_) {
    return (_this_ instanceof KClassImpl ? _this_ : THROW_CCE())._get_jClass__0_k$();
  }
  function KCallable() {
  }
  KCallable.$metadata$ = {
    simpleName: 'KCallable',
    kind: 'interface',
    interfaces: []
  };
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this._jClass = jClass;
  }
  KClassImpl.prototype._get_jClass__0_k$ = function () {
    return this._jClass;
  };
  KClassImpl.prototype.equals = function (other) {
    var tmp;
    if (other instanceof KClassImpl) {
      tmp = equals_1(this._get_jClass__0_k$(), other._get_jClass__0_k$());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KClassImpl.prototype.hashCode = function () {
    var tmp0_safe_receiver = this._get_simpleName__0_k$();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  KClassImpl.prototype.toString = function () {
    return '' + 'class ' + this._get_simpleName__0_k$();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this._givenSimpleName = givenSimpleName;
    this._isInstanceFunction = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype.equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    else {
    }
    return KClassImpl.prototype.equals.call(this, other) ? this._givenSimpleName === other._givenSimpleName : false;
  };
  PrimitiveKClassImpl.prototype._get_simpleName__0_k$ = function () {
    return this._givenSimpleName;
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this._simpleName = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__0_k$ = function () {
    return this._simpleName;
  };
  NothingKClassImpl.prototype._get_jClass__0_k$ = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.prototype.equals = function (other) {
    return other === this;
  };
  NothingKClassImpl.prototype.hashCode = function () {
    return 0;
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.prototype._get_simpleName__0_k$ = function () {
    throw IllegalStateException_init_$Create$_0('Unknown simpleName for ErrorKClass');
  };
  ErrorKClass.prototype.equals = function (other) {
    return other === this;
  };
  ErrorKClass.prototype.hashCode = function () {
    return 0;
  };
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp0_safe_receiver = jClass.$metadata$;
    var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    tmp._simpleName_0 = tmp0_unsafeCast_0;
  }
  SimpleKClassImpl.prototype._get_simpleName__0_k$ = function () {
    return this._simpleName_0;
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function KFunction() {
  }
  KFunction.$metadata$ = {
    simpleName: 'KFunction',
    kind: 'interface',
    interfaces: [KCallable]
  };
  function KProperty1() {
  }
  KProperty1.$metadata$ = {
    simpleName: 'KProperty1',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KProperty0() {
  }
  KProperty0.$metadata$ = {
    simpleName: 'KProperty0',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KProperty() {
  }
  KProperty.$metadata$ = {
    simpleName: 'KProperty',
    kind: 'interface',
    interfaces: [KCallable]
  };
  function KMutableProperty1() {
  }
  KMutableProperty1.$metadata$ = {
    simpleName: 'KMutableProperty1',
    kind: 'interface',
    interfaces: [KProperty1, KMutableProperty]
  };
  function KMutableProperty0() {
  }
  KMutableProperty0.$metadata$ = {
    simpleName: 'KMutableProperty0',
    kind: 'interface',
    interfaces: [KProperty0, KMutableProperty]
  };
  function KMutableProperty2() {
  }
  KMutableProperty2.$metadata$ = {
    simpleName: 'KMutableProperty2',
    kind: 'interface',
    interfaces: [KProperty2, KMutableProperty]
  };
  function KMutableProperty() {
  }
  KMutableProperty.$metadata$ = {
    simpleName: 'KMutableProperty',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KProperty2() {
  }
  KProperty2.$metadata$ = {
    simpleName: 'KProperty2',
    kind: 'interface',
    interfaces: [KProperty]
  };
  var functionClasses;
  function _no_name_provided__22() {
  }
  _no_name_provided__22.prototype.invoke_wi7j7l_k$ = function (it) {
    return isObject(it);
  };
  _no_name_provided__22.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__22.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__23() {
  }
  _no_name_provided__23.prototype.invoke_wi7j7l_k$ = function (it) {
    return isNumber(it);
  };
  _no_name_provided__23.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__23.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__24() {
  }
  _no_name_provided__24.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  };
  _no_name_provided__24.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__24.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__25() {
  }
  _no_name_provided__25.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__25.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__25.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__26() {
  }
  _no_name_provided__26.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__26.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__26.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__27() {
  }
  _no_name_provided__27.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__27.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__27.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__28() {
  }
  _no_name_provided__28.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__28.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__28.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__29() {
  }
  _no_name_provided__29.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__29.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__29.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__30() {
  }
  _no_name_provided__30.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? isArray(it) : false;
  };
  _no_name_provided__30.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__30.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__31() {
  }
  _no_name_provided__31.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? typeof it === 'string' : false;
  };
  _no_name_provided__31.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__31.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__32() {
  }
  _no_name_provided__32.prototype.invoke_wi7j7l_k$ = function (it) {
    return it instanceof Error;
  };
  _no_name_provided__32.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__32.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__33() {
  }
  _no_name_provided__33.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? isBooleanArray(it) : false;
  };
  _no_name_provided__33.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__33.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__34() {
  }
  _no_name_provided__34.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? isCharArray(it) : false;
  };
  _no_name_provided__34.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__34.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__35() {
  }
  _no_name_provided__35.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? isByteArray(it) : false;
  };
  _no_name_provided__35.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__35.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__36() {
  }
  _no_name_provided__36.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? isShortArray(it) : false;
  };
  _no_name_provided__36.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__36.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__37() {
  }
  _no_name_provided__37.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? isIntArray(it) : false;
  };
  _no_name_provided__37.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__37.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__38() {
  }
  _no_name_provided__38.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? isLongArray(it) : false;
  };
  _no_name_provided__38.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__38.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__39() {
  }
  _no_name_provided__39.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? isFloatArray(it) : false;
  };
  _no_name_provided__39.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__39.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__40() {
  }
  _no_name_provided__40.prototype.invoke_wi7j7l_k$ = function (it) {
    return !(it == null) ? isDoubleArray(it) : false;
  };
  _no_name_provided__40.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__40.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__41($arity) {
    this._$arity = $arity;
  }
  _no_name_provided__41.prototype.invoke_wi7j7l_k$ = function (it) {
    var tmp;
    if (typeof it === 'function') {
      tmp = it.length === this._$arity;
    } else {
      tmp = false;
    }
    return tmp;
  };
  _no_name_provided__41.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__41.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PrimitiveClasses_0() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp0_unsafeCast_0 = Object;
    tmp._anyClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0, 'Any', _no_name_provided_$factory_10());
    var tmp_0 = this;
    var tmp0_unsafeCast_0_0 = Number;
    tmp_0._numberClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_0, 'Number', _no_name_provided_$factory_11());
    this._nothingClass = NothingKClassImpl_getInstance();
    var tmp_1 = this;
    var tmp0_unsafeCast_0_1 = Boolean;
    tmp_1._booleanClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_1, 'Boolean', _no_name_provided_$factory_12());
    var tmp_2 = this;
    var tmp0_unsafeCast_0_2 = Number;
    tmp_2._byteClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_2, 'Byte', _no_name_provided_$factory_13());
    var tmp_3 = this;
    var tmp0_unsafeCast_0_3 = Number;
    tmp_3._shortClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_3, 'Short', _no_name_provided_$factory_14());
    var tmp_4 = this;
    var tmp0_unsafeCast_0_4 = Number;
    tmp_4._intClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_4, 'Int', _no_name_provided_$factory_15());
    var tmp_5 = this;
    var tmp0_unsafeCast_0_5 = Number;
    tmp_5._floatClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_5, 'Float', _no_name_provided_$factory_16());
    var tmp_6 = this;
    var tmp0_unsafeCast_0_6 = Number;
    tmp_6._doubleClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_6, 'Double', _no_name_provided_$factory_17());
    var tmp_7 = this;
    var tmp0_unsafeCast_0_7 = Array;
    tmp_7._arrayClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_7, 'Array', _no_name_provided_$factory_18());
    var tmp_8 = this;
    var tmp0_unsafeCast_0_8 = String;
    tmp_8._stringClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_8, 'String', _no_name_provided_$factory_19());
    var tmp_9 = this;
    var tmp0_unsafeCast_0_9 = Error;
    tmp_9._throwableClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_9, 'Throwable', _no_name_provided_$factory_20());
    var tmp_10 = this;
    var tmp0_unsafeCast_0_10 = Array;
    tmp_10._booleanArrayClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_10, 'BooleanArray', _no_name_provided_$factory_21());
    var tmp_11 = this;
    var tmp0_unsafeCast_0_11 = Uint16Array;
    tmp_11._charArrayClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_11, 'CharArray', _no_name_provided_$factory_22());
    var tmp_12 = this;
    var tmp0_unsafeCast_0_12 = Int8Array;
    tmp_12._byteArrayClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_12, 'ByteArray', _no_name_provided_$factory_23());
    var tmp_13 = this;
    var tmp0_unsafeCast_0_13 = Int16Array;
    tmp_13._shortArrayClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_13, 'ShortArray', _no_name_provided_$factory_24());
    var tmp_14 = this;
    var tmp0_unsafeCast_0_14 = Int32Array;
    tmp_14._intArrayClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_14, 'IntArray', _no_name_provided_$factory_25());
    var tmp_15 = this;
    var tmp0_unsafeCast_0_15 = Array;
    tmp_15._longArrayClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_15, 'LongArray', _no_name_provided_$factory_26());
    var tmp_16 = this;
    var tmp0_unsafeCast_0_16 = Float32Array;
    tmp_16._floatArrayClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_16, 'FloatArray', _no_name_provided_$factory_27());
    var tmp_17 = this;
    var tmp0_unsafeCast_0_17 = Float64Array;
    tmp_17._doubleArrayClass = new PrimitiveKClassImpl(tmp0_unsafeCast_0_17, 'DoubleArray', _no_name_provided_$factory_28());
  }
  PrimitiveClasses_0.prototype._get_anyClass__0_k$ = function () {
    return this._anyClass;
  };
  PrimitiveClasses_0.prototype._get_numberClass__0_k$ = function () {
    return this._numberClass;
  };
  PrimitiveClasses_0.prototype._get_nothingClass__0_k$ = function () {
    return this._nothingClass;
  };
  PrimitiveClasses_0.prototype._get_booleanClass__0_k$ = function () {
    return this._booleanClass;
  };
  PrimitiveClasses_0.prototype._get_byteClass__0_k$ = function () {
    return this._byteClass;
  };
  PrimitiveClasses_0.prototype._get_shortClass__0_k$ = function () {
    return this._shortClass;
  };
  PrimitiveClasses_0.prototype._get_intClass__0_k$ = function () {
    return this._intClass;
  };
  PrimitiveClasses_0.prototype._get_floatClass__0_k$ = function () {
    return this._floatClass;
  };
  PrimitiveClasses_0.prototype._get_doubleClass__0_k$ = function () {
    return this._doubleClass;
  };
  PrimitiveClasses_0.prototype._get_arrayClass__0_k$ = function () {
    return this._arrayClass;
  };
  PrimitiveClasses_0.prototype._get_stringClass__0_k$ = function () {
    return this._stringClass;
  };
  PrimitiveClasses_0.prototype._get_throwableClass__0_k$ = function () {
    return this._throwableClass;
  };
  PrimitiveClasses_0.prototype._get_booleanArrayClass__0_k$ = function () {
    return this._booleanArrayClass;
  };
  PrimitiveClasses_0.prototype._get_charArrayClass__0_k$ = function () {
    return this._charArrayClass;
  };
  PrimitiveClasses_0.prototype._get_byteArrayClass__0_k$ = function () {
    return this._byteArrayClass;
  };
  PrimitiveClasses_0.prototype._get_shortArrayClass__0_k$ = function () {
    return this._shortArrayClass;
  };
  PrimitiveClasses_0.prototype._get_intArrayClass__0_k$ = function () {
    return this._intArrayClass;
  };
  PrimitiveClasses_0.prototype._get_longArrayClass__0_k$ = function () {
    return this._longArrayClass;
  };
  PrimitiveClasses_0.prototype._get_floatArrayClass__0_k$ = function () {
    return this._floatArrayClass;
  };
  PrimitiveClasses_0.prototype._get_doubleArrayClass__0_k$ = function () {
    return this._doubleArrayClass;
  };
  PrimitiveClasses_0.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = functionClasses[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_unsafeCast_0_3 = Function;
      var tmp_0 = '' + 'Function' + arity;
      var result_2 = new PrimitiveKClassImpl(tmp0_unsafeCast_0_3, tmp_0, _no_name_provided_$factory_29(arity));
      var tmp1_asDynamic_0_5 = functionClasses;
      tmp1_asDynamic_0_5[arity] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses_0.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses_0.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_anyClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_numberClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_nothingClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_arrayClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_stringClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_throwableClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanArrayClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_charArrayClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteArrayClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortArrayClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intArrayClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_longArrayClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatArrayClass__0_k$
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleArrayClass__0_k$
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses_0();
    return PrimitiveClasses_instance;
  }
  function _no_name_provided_$factory_10() {
    var i = new _no_name_provided__22();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_11() {
    var i = new _no_name_provided__23();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_12() {
    var i = new _no_name_provided__24();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_13() {
    var i = new _no_name_provided__25();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_14() {
    var i = new _no_name_provided__26();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_15() {
    var i = new _no_name_provided__27();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_16() {
    var i = new _no_name_provided__28();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_17() {
    var i = new _no_name_provided__29();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_18() {
    var i = new _no_name_provided__30();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_19() {
    var i = new _no_name_provided__31();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_20() {
    var i = new _no_name_provided__32();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_21() {
    var i = new _no_name_provided__33();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_22() {
    var i = new _no_name_provided__34();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_23() {
    var i = new _no_name_provided__35();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_24() {
    var i = new _no_name_provided__36();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_25() {
    var i = new _no_name_provided__37();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_26() {
    var i = new _no_name_provided__38();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_27() {
    var i = new _no_name_provided__39();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_28() {
    var i = new _no_name_provided__40();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function _no_name_provided_$factory_29($arity) {
    var i = new _no_name_provided__41($arity);
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function functionClasses$init$() {
    return fillArrayVal(Array(0), null);
  }
  function getKClass_0(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      tmp = getKClassM_0(jClass);
    } else {
      tmp = getKClass1_0(jClass);
    }
    return tmp;
  }
  function getKClassM_0(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1_0(jClasses[0]);
        break;
      case 0:
        var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
        tmp = tmp0_unsafeCast_0;
        break;
      default:var tmp1_unsafeCast_0 = new ErrorKClass();
        tmp = tmp1_unsafeCast_0;
        break;
    }
    return tmp;
  }
  function getKClass1_0(jClass) {
    if (jClass === String) {
      var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._stringClass;
      return tmp0_unsafeCast_0;
    }var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function getKClassFromExpression_0(e) {
    var tmp0_subject = typeof e;
    var tmp;
    switch (tmp0_subject) {
      case 'string':
        tmp = PrimitiveClasses_getInstance()._stringClass;
        break;
      case 'number':
        var tmp_0;
        var tmp0_asDynamic_0 = jsBitwiseOr(e, 0);
        if (tmp0_asDynamic_0 === e) {
          tmp_0 = PrimitiveClasses_getInstance()._intClass;
        } else {
          {
            tmp_0 = PrimitiveClasses_getInstance()._doubleClass;
          }
        }

        tmp = tmp_0;
        break;
      case 'boolean':
        tmp = PrimitiveClasses_getInstance()._booleanClass;
        break;
      case 'function':
        var tmp_1 = PrimitiveClasses_getInstance();
        tmp = tmp_1.functionClass(e.length);
        break;
      default:var tmp_2;
        if (isBooleanArray(e)) {
          tmp_2 = PrimitiveClasses_getInstance()._booleanArrayClass;
        } else {
          if (isCharArray(e)) {
            tmp_2 = PrimitiveClasses_getInstance()._charArrayClass;
          } else {
            if (isByteArray(e)) {
              tmp_2 = PrimitiveClasses_getInstance()._byteArrayClass;
            } else {
              if (isShortArray(e)) {
                tmp_2 = PrimitiveClasses_getInstance()._shortArrayClass;
              } else {
                if (isIntArray(e)) {
                  tmp_2 = PrimitiveClasses_getInstance()._intArrayClass;
                } else {
                  if (isLongArray(e)) {
                    tmp_2 = PrimitiveClasses_getInstance()._longArrayClass;
                  } else {
                    if (isFloatArray(e)) {
                      tmp_2 = PrimitiveClasses_getInstance()._floatArrayClass;
                    } else {
                      if (isDoubleArray(e)) {
                        tmp_2 = PrimitiveClasses_getInstance()._doubleArrayClass;
                      } else {
                        if (isInterface(e, KClass)) {
                          tmp_2 = getKClass_0(KClass);
                        } else {
                          if (isArray(e)) {
                            tmp_2 = PrimitiveClasses_getInstance()._arrayClass;
                          } else {
                            {
                              var constructor = Object.getPrototypeOf(e).constructor;
                              var tmp_3;
                              if (constructor === Object) {
                                tmp_3 = PrimitiveClasses_getInstance()._anyClass;
                              } else if (constructor === Error) {
                                tmp_3 = PrimitiveClasses_getInstance()._throwableClass;
                              } else {
                                var jsClass_0 = constructor;
                                tmp_3 = getKClass1_0(jsClass_0);
                              }
                              tmp_2 = tmp_3;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        tmp = tmp_2;
        break;
    }
    var tmp1_unsafeCast_0 = tmp;
    return tmp1_unsafeCast_0;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function StringBuilder_init_$Init$(capacity, $this) {
    StringBuilder_init_$Init$_0($this);
    return $this;
  }
  function StringBuilder_init_$Create$(capacity) {
    return StringBuilder_init_$Init$(capacity, Object.create(StringBuilder.prototype));
  }
  function StringBuilder_init_$Init$_0($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$_0() {
    return StringBuilder_init_$Init$_0(Object.create(StringBuilder.prototype));
  }
  function StringBuilder(content) {
    this._string = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype._get_length__0_k$ = function () {
    var tmp0_asDynamic_0 = this._string;
    return tmp0_asDynamic_0.length;
  };
  StringBuilder.prototype.get_ha5a7z_k$ = function (index_0) {
    var tmp0_getOrElse_0 = this._string;
    var tmp;
    if (index_0 >= 0 ? index_0 <= _get_lastIndex__5(tmp0_getOrElse_0) : false) {
      tmp = charSequenceGet(tmp0_getOrElse_0, index_0);
    } else {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index_0 + ', length: ' + this._get_length__0_k$() + '}');
    }
    return tmp;
  };
  StringBuilder.prototype.subSequence_27zxwg_k$ = function (startIndex, endIndex) {
    var tmp0_substring_0 = this._string;
    return tmp0_substring_0.substring(startIndex, endIndex);
  };
  StringBuilder.prototype.append_wi8o78_k$ = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value;
    return this;
  };
  StringBuilder.prototype.append_v1o70a_k$ = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_wi7j7l_k$ = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_uch40_k$ = function (value) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._string;
    var tmp1_elvis_lhs = value;
    tmp._string = tmp_0 + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this._string;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function isWhitespace(_this_) {
    return isWhitespaceImpl(_this_);
  }
  function uppercaseChar(_this_) {
    var tmp0_asDynamic_0 = _this_.toString();
    var tmp1_unsafeCast_0 = tmp0_asDynamic_0.toUpperCase();
    var uppercase = tmp1_unsafeCast_0;
    return uppercase.length > 1 ? _this_ : charSequenceGet(uppercase, 0);
  }
  function checkRadix(radix) {
    if (!(2 <= radix ? radix <= 36 : false)) {
      throw IllegalArgumentException_init_$Create$('' + 'radix ' + radix + ' was not in valid range 2..36');
    }return radix;
  }
  function toInt(_this_) {
    var tmp0_elvis_lhs = toIntOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toDouble(_this_) {
    var tmp0_unsafeCast_0 = +_this_;
    var tmp1_also_0 = tmp0_unsafeCast_0;
    if ((isNaN_0(tmp1_also_0) ? !isNaN_2(_this_) : false) ? true : tmp1_also_0 === 0.0 ? isBlank(_this_) : false) {
      numberFormatError(_this_);
    }return tmp1_also_0;
  }
  function toDoubleOrNull(_this_) {
    var tmp0_unsafeCast_0 = +_this_;
    var tmp1_takeIf_0 = tmp0_unsafeCast_0;
    var tmp;
    if (!((isNaN_0(tmp1_takeIf_0) ? !isNaN_2(_this_) : false) ? true : tmp1_takeIf_0 === 0.0 ? isBlank(_this_) : false)) {
      tmp = tmp1_takeIf_0;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function toInt_0(_this_, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this_, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function isNaN_2(_this_) {
    var tmp0_subject = _this_.toLowerCase();
    switch (tmp0_subject) {
      case 'nan':
      case '+nan':
      case '-nan':
        return true;
      default:return false;
    }
  }
  function digitOf(char, radix) {
    var tmp0_let_0 = (char.compareTo_wi8o78_k$(new Char(48)) >= 0 ? char.compareTo_wi8o78_k$(new Char(57)) <= 0 : false) ? char.minus_wi8o78_k$(new Char(48)) : (char.compareTo_wi8o78_k$(new Char(65)) >= 0 ? char.compareTo_wi8o78_k$(new Char(90)) <= 0 : false) ? char.minus_wi8o78_k$(new Char(65)) + 10 | 0 : (char.compareTo_wi8o78_k$(new Char(97)) >= 0 ? char.compareTo_wi8o78_k$(new Char(122)) <= 0 : false) ? char.minus_wi8o78_k$(new Char(97)) + 10 | 0 : char.compareTo_wi8o78_k$(new Char(128)) < 0 ? -1 : (char.compareTo_wi8o78_k$(new Char(65313)) >= 0 ? char.compareTo_wi8o78_k$(new Char(65338)) <= 0 : false) ? char.minus_wi8o78_k$(new Char(65313)) + 10 | 0 : (char.compareTo_wi8o78_k$(new Char(65345)) >= 0 ? char.compareTo_wi8o78_k$(new Char(65370)) <= 0 : false) ? char.minus_wi8o78_k$(new Char(65345)) + 10 | 0 : digitToIntImpl(char);
    return tmp0_let_0 >= radix ? -1 : tmp0_let_0;
  }
  function Regex_init_$Init$(pattern, $this) {
    Regex.call($this, pattern, emptySet());
    return $this;
  }
  function Regex_init_$Create$(pattern) {
    return Regex_init_$Init$(pattern, Object.create(Regex.prototype));
  }
  function Companion_15() {
    Companion_instance_14 = this;
    this._patternEscape = new RegExp('[\\\\^$*+?.()|[\\]{}]', 'g');
    this._replacementEscape = new RegExp('\\$', 'g');
  }
  Companion_15.prototype.escape_6wfw3l_k$ = function (literal) {
    var tmp0_nativeReplace_0 = this._patternEscape;
    return literal.replace(tmp0_nativeReplace_0, '\\$&');
  };
  Companion_15.prototype.escapeReplacement_6wfw3l_k$ = function (literal) {
    var tmp0_nativeReplace_0 = this._replacementEscape;
    return literal.replace(tmp0_nativeReplace_0, '$$$$');
  };
  Companion_15.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_14;
  function Companion_getInstance_14() {
    if (Companion_instance_14 == null)
      new Companion_15();
    return Companion_instance_14;
  }
  function _no_name_provided__42() {
  }
  _no_name_provided__42.prototype.invoke_ot21mf_k$ = function (it) {
    return it._value_0;
  };
  _no_name_provided__42.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ot21mf_k$(p1 instanceof RegexOption ? p1 : THROW_CCE());
  };
  _no_name_provided__42.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__43(this$0, $input, $startIndex) {
    this._this$0_9 = this$0;
    this._$input = $input;
    this._$startIndex = $startIndex;
  }
  _no_name_provided__43.prototype.invoke_0_k$ = function () {
    return this._this$0_9.find_w2qdfo_k$(this._$input, this._$startIndex);
  };
  _no_name_provided__43.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__44() {
  }
  _no_name_provided__44.prototype.invoke_p75qlr_k$ = function (match) {
    return match.next_0_k$();
  };
  _no_name_provided__44.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_p75qlr_k$((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__44.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Regex(pattern, options) {
    Companion_getInstance_14();
    this._pattern = pattern;
    this._options = toSet_0(options);
    var tmp = this;
    tmp._nativePattern = new RegExp(pattern, joinToString$default_0(options, '', 'gu', null, 0, null, _no_name_provided_$factory_30(), 28, null));
  }
  Regex.prototype.find_w2qdfo_k$ = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }return findNext(this._nativePattern, toString_1(input), startIndex);
  };
  Regex.prototype.find$default_5nuume_k$ = function (input, startIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    return this.find_w2qdfo_k$(input, startIndex);
  };
  Regex.prototype.findAll_w2qdfo_k$ = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }var tmp = _no_name_provided_$factory_31(this, input, startIndex);
    return generateSequence(tmp, _no_name_provided_$factory_32());
  };
  Regex.prototype.findAll$default_5nuume_k$ = function (input, startIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    return this.findAll_w2qdfo_k$(input, startIndex);
  };
  Regex.prototype.replace_abi4bo_k$ = function (input, replacement) {
    var tmp0_nativeReplace_0 = toString_1(input);
    var tmp1_nativeReplace_0 = this._nativePattern;
    return tmp0_nativeReplace_0.replace(tmp1_nativeReplace_0, replacement);
  };
  Regex.prototype.split_w2qdfo_k$ = function (input, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Limit must be non-negative, but was ' + limit;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_let_0 = this.findAll$default_5nuume_k$(input, 0, 2, null);
    var matches_0 = limit === 0 ? tmp1_let_0 : take_1(tmp1_let_0, limit - 1 | 0);
    var result = ArrayList_init_$Create$();
    var lastStart = 0;
    var tmp0_iterator = matches_0.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var match = tmp0_iterator.next_0_k$();
      result.add_2bq_k$(toString_1(charSequenceSubSequence(input, lastStart, match._get_range__0_k$()._get_start__0_k$())));
      Unit_getInstance();
      lastStart = match._get_range__0_k$()._get_endInclusive__0_k$() + 1 | 0;
    }
    result.add_2bq_k$(toString_1(charSequenceSubSequence(input, lastStart, charSequenceLength(input))));
    Unit_getInstance();
    return result;
  };
  Regex.prototype.toString = function () {
    return this._nativePattern.toString();
  };
  Regex.$metadata$ = {
    simpleName: 'Regex',
    kind: 'class',
    interfaces: []
  };
  function MatchGroup(value) {
    this._value = value;
  }
  MatchGroup.prototype.toString = function () {
    return '' + 'MatchGroup(value=' + this._value + ')';
  };
  MatchGroup.prototype.hashCode = function () {
    return getStringHashCode(this._value);
  };
  MatchGroup.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MatchGroup))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MatchGroup ? other : THROW_CCE();
    if (!(this._value === tmp0_other_with_cast._value))
      return false;
    return true;
  };
  MatchGroup.$metadata$ = {
    simpleName: 'MatchGroup',
    kind: 'class',
    interfaces: []
  };
  function RegexOption() {
  }
  RegexOption.$metadata$ = {
    simpleName: 'RegexOption',
    kind: 'class',
    interfaces: []
  };
  function findNext(_this_, input, from) {
    _this_.lastIndex = from;
    var match = _this_.exec(input);
    if (match == null)
      return null;
    var range = numberRangeToNumber(match.index, _this_.lastIndex - 1 | 0);
    return new _no_name_provided__47(range, match, _this_, input);
  }
  function _no_name_provided__45(this$0) {
    this._this$0_10 = this$0;
  }
  _no_name_provided__45.prototype.invoke_ha5a7z_k$ = function (it) {
    return this._this$0_10.get_ha5a7z_k$(it);
  };
  _no_name_provided__45.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__45.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__46($match) {
    this._$match = $match;
    AbstractCollection.call(this);
  }
  _no_name_provided__46.prototype._get_size__0_k$ = function () {
    return this._$match.length;
  };
  _no_name_provided__46.prototype.iterator_0_k$ = function () {
    var tmp = asSequence(_get_indices__0(this));
    return map(tmp, _no_name_provided_$factory_33(this)).iterator_0_k$();
  };
  _no_name_provided__46.prototype.get_ha5a7z_k$ = function (index_0) {
    var tmp0_safe_receiver = this._$match[index_0];
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = new MatchGroup(tmp0_safe_receiver);
    }
    return tmp;
  };
  _no_name_provided__46.$metadata$ = {
    kind: 'class',
    interfaces: [MatchGroupCollection]
  };
  function _no_name_provided__47($range, $match, $this_findNext, $input) {
    this._$range = $range;
    this._$match_0 = $match;
    this._$this_findNext = $this_findNext;
    this._$input_0 = $input;
    this._range = this._$range;
    var tmp = this;
    tmp._groups = new _no_name_provided__46(this._$match_0);
    this._groupValues_ = null;
  }
  _no_name_provided__47.prototype._get_range__0_k$ = function () {
    return this._range;
  };
  _no_name_provided__47.prototype._get_groups__0_k$ = function () {
    return this._groups;
  };
  _no_name_provided__47.prototype.next_0_k$ = function () {
    return findNext(this._$this_findNext, this._$input_0, this._$range.isEmpty_0_k$() ? this._$range._get_start__0_k$() + 1 | 0 : this._$range._get_endInclusive__0_k$() + 1 | 0);
  };
  _no_name_provided__47.$metadata$ = {
    kind: 'class',
    interfaces: [MatchResult]
  };
  function _no_name_provided_$factory_30() {
    var i = new _no_name_provided__42();
    return function (p1) {
      return i.invoke_ot21mf_k$(p1);
    };
  }
  function _no_name_provided_$factory_31(this$0, $input, $startIndex) {
    var i = new _no_name_provided__43(this$0, $input, $startIndex);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_32() {
    var i = new _no_name_provided__44();
    return function (p1) {
      return i.invoke_p75qlr_k$(p1);
    };
  }
  function _no_name_provided_$factory_33(this$0) {
    var i = new _no_name_provided__45(this$0);
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function concatToString(_this_, startIndex, endIndex) {
    Companion_getInstance().checkBoundsIndexes_zd700_k$(startIndex, endIndex, _this_.length);
    var result = '';
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + _this_[index_0];
      }
       while (inductionVariable < endIndex);
    return result;
  }
  function startsWith_1(_this_, prefix, ignoreCase) {
    if (!ignoreCase) {
      return _this_.startsWith(prefix, 0);
    } else
      return regionMatches(_this_, 0, prefix, 0, prefix.length, ignoreCase);
  }
  function startsWith$default_1(_this_, prefix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith_1(_this_, prefix, ignoreCase);
  }
  function replace(_this_, oldChar, newChar, ignoreCase) {
    var tmp0_nativeReplace_0 = new RegExp(Companion_getInstance_14().escape_6wfw3l_k$(oldChar.toString()), ignoreCase ? 'gui' : 'gu');
    var tmp1_nativeReplace_0 = newChar.toString();
    return _this_.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  }
  function replace$default(_this_, oldChar, newChar, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return replace(_this_, oldChar, newChar, ignoreCase);
  }
  function replace_0(_this_, oldValue, newValue, ignoreCase) {
    var tmp0_nativeReplace_0 = new RegExp(Companion_getInstance_14().escape_6wfw3l_k$(oldValue), ignoreCase ? 'gui' : 'gu');
    var tmp1_nativeReplace_0 = Companion_getInstance_14().escapeReplacement_6wfw3l_k$(newValue);
    return _this_.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  }
  function replace$default_0(_this_, oldValue, newValue, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return replace_0(_this_, oldValue, newValue, ignoreCase);
  }
  function equals_0(_this_, other, ignoreCase) {
    var tmp;
    if (_this_ == null) {
      tmp = other == null;
    } else if (!ignoreCase) {
      tmp = _this_ == other;
    } else if (other == null) {
      tmp = false;
    } else {
      var thisLower = _this_.toLowerCase();
      var otherLower = other.toLowerCase();
      var tmp_0;
      if (thisLower === otherLower) {
        tmp_0 = true;
      } else {
        var tmp_1 = thisLower.toUpperCase();
        tmp_0 = tmp_1 === otherLower.toUpperCase();
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function endsWith_1(_this_, suffix, ignoreCase) {
    if (!ignoreCase) {
      return _this_.endsWith(suffix);
    } else
      return regionMatches(_this_, _this_.length - suffix.length | 0, suffix, 0, suffix.length, ignoreCase);
  }
  function endsWith$default_1(_this_, suffix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith_1(_this_, suffix, ignoreCase);
  }
  function repeat(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + "Count 'n' must be non-negative, but was " + n + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp0_subject = n;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = '';
        break;
      case 1:
        tmp = toString_1(_this_);
        break;
      default:var result = '';
        if (!(charSequenceLength(_this_) === 0)) {
          var s = toString_1(_this_);
          var count_0 = n;
          $l$break: while (true) {
            if ((count_0 & 1) === 1) {
              result = result + s;
            }count_0 = count_0 >>> 1;
            if (count_0 === 0) {
              break $l$break;
            }s = s + s;
          }
        } else {
        }

        return result;
    }
    return tmp;
  }
  function isBlank(_this_) {
    var tmp;
    if (charSequenceLength(_this_) === 0) {
      tmp = true;
    } else {
      var tmp_0;
      if (typeof _this_ === 'string') {
        tmp_0 = _this_;
      } else {
        {
          tmp_0 = toString_1(_this_);
        }
      }
      tmp = matches(tmp_0, '^[\\s\\xA0]+$');
    }
    return tmp;
  }
  function regionMatches(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    return regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase);
  }
  function matches(_this_, regex) {
    var result = _this_.match(regex);
    return !(result == null) ? !(result.length === 0) : false;
  }
  function printStackTrace(_this_) {
    console.error(stackTraceToString(_this_));
  }
  function stackTraceToString(_this_) {
    return (new ExceptionTraceBuilder()).buildFor_onfaoi_k$(_this_);
  }
  function hasSeen($this, exception) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = $this._visited;
      var indexedObject = tmp0_any_0;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_2 === exception) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  }
  function dumpFullTrace(_this_, $this, indent, qualifier) {
    if (dumpSelfTrace(_this_, $this, indent, qualifier))
      true;
    else
      return Unit_getInstance();
    Unit_getInstance();
    var cause = _this_.cause;
    while (!(cause == null)) {
      if (dumpSelfTrace(cause, $this, indent, 'Caused by: '))
        true;
      else
        return Unit_getInstance();
      Unit_getInstance();
      cause = cause.cause;
    }
  }
  function dumpSelfTrace(_this_, $this, indent, qualifier) {
    $this._target.append_uch40_k$(indent).append_uch40_k$(qualifier);
    Unit_getInstance();
    var shortInfo = _this_.toString();
    if (hasSeen($this, _this_)) {
      $this._target.append_uch40_k$('[CIRCULAR REFERENCE, SEE ABOVE: ').append_uch40_k$(shortInfo).append_uch40_k$(']\n');
      Unit_getInstance();
      return false;
    }var tmp0_asDynamic_0 = $this._visited;
    tmp0_asDynamic_0.push(_this_);
    var tmp = _this_.stack;
    var stack = (tmp == null ? true : typeof tmp === 'string') ? tmp : THROW_CCE();
    if (!(stack == null)) {
      var tmp_0 = stack;
      var tmp1_let_0 = indexOf$default_0(tmp_0, shortInfo, 0, false, 6, null);
      var stackStart = tmp1_let_0 < 0 ? 0 : tmp1_let_0 + shortInfo.length | 0;
      if (stackStart === 0) {
        $this._target.append_uch40_k$(shortInfo).append_uch40_k$('\n');
        Unit_getInstance();
      }var tmp2_isEmpty_0 = $this._topStack;
      if (charSequenceLength(tmp2_isEmpty_0) === 0) {
        $this._topStack = stack;
        $this._topStackStart = stackStart;
      } else {
        {
          stack = dropCommonFrames($this, stack, stackStart);
        }
      }
      if (charSequenceLength(indent) > 0) {
        var tmp_1;
        if (stackStart === 0) {
          tmp_1 = 0;
        } else {
          var count_1 = 0;
          var indexedObject = shortInfo;
          var inductionVariable = 0;
          var last_1 = indexedObject.length;
          while (inductionVariable < last_1) {
            var element_3 = charSequenceGet(indexedObject, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            if (element_3.equals(new Char(10))) {
              count_1 = count_1 + 1 | 0;
              Unit_getInstance();
            } else {
            }
          }
          tmp_1 = 1 + count_1 | 0;
        }
        var messageLines = tmp_1;
        var tmp3_forEachIndexed_0 = lineSequence(stack);
        var index_1 = 0;
        var tmp0_iterator_2 = tmp3_forEachIndexed_0.iterator_0_k$();
        while (tmp0_iterator_2.hasNext_0_k$()) {
          var item_3 = tmp0_iterator_2.next_0_k$();
          var tmp1_4 = index_1;
          index_1 = tmp1_4 + 1 | 0;
          var tmp4__anonymous__5 = checkIndexOverflow(tmp1_4);
          if (tmp4__anonymous__5 >= messageLines) {
            $this._target.append_uch40_k$(indent);
            Unit_getInstance();
          }$this._target.append_uch40_k$(item_3).append_uch40_k$('\n');
          Unit_getInstance();
        }
      } else {
        {
          $this._target.append_uch40_k$(stack).append_uch40_k$('\n');
          Unit_getInstance();
        }
      }
    } else {
      $this._target.append_uch40_k$(shortInfo).append_uch40_k$('\n');
      Unit_getInstance();
    }
    var suppressed = _get_suppressedExceptions_(_this_);
    if (!suppressed.isEmpty_0_k$()) {
      var suppressedIndent = indent + '    ';
      var tmp0_iterator = suppressed.iterator_0_k$();
      while (tmp0_iterator.hasNext_0_k$()) {
        var s = tmp0_iterator.next_0_k$();
        dumpFullTrace(s, $this, suppressedIndent, 'Suppressed: ');
      }
    } else {
    }
    return true;
  }
  function dropCommonFrames($this, stack, stackStart) {
    var commonFrames = 0;
    var lastBreak = 0;
    var preLastBreak = 0;
    var inductionVariable = 0;
    var tmp0_minOf_0 = $this._topStack.length - $this._topStackStart | 0;
    var tmp1_minOf_0 = stack.length - stackStart | 0;
    var last_1 = Math.min(tmp0_minOf_0, tmp1_minOf_0);
    if (inductionVariable < last_1)
      $l$break: do {
        var pos = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(stack, _get_lastIndex__5(stack) - pos | 0);
        if (!c.equals(charSequenceGet($this._topStack, _get_lastIndex__5($this._topStack) - pos | 0)))
          break $l$break;
        if (c.equals(new Char(10))) {
          commonFrames = commonFrames + 1 | 0;
          preLastBreak = lastBreak;
          lastBreak = pos;
        }}
       while (inductionVariable < last_1);
    if (commonFrames <= 1)
      return stack;
    while (preLastBreak > 0 ? charSequenceGet(stack, _get_lastIndex__5(stack) - (preLastBreak - 1 | 0) | 0).equals(new Char(32)) : false)
      preLastBreak = preLastBreak - 1 | 0;
    return dropLast(stack, preLastBreak) + ('' + '... and ' + (commonFrames - 1 | 0) + ' more common stack frames skipped');
  }
  function ExceptionTraceBuilder() {
    this._target = StringBuilder_init_$Create$_0();
    var tmp = this;
    tmp._visited = [];
    this._topStack = '';
    this._topStackStart = 0;
  }
  ExceptionTraceBuilder.prototype.buildFor_onfaoi_k$ = function (exception) {
    dumpFullTrace(exception, this, '', '');
    return this._target.toString();
  };
  ExceptionTraceBuilder.$metadata$ = {
    simpleName: 'ExceptionTraceBuilder',
    kind: 'class',
    interfaces: []
  };
  function _get_suppressedExceptions_(_this_) {
    var tmp0_safe_receiver = _this_._suppressed;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function addSuppressed(_this_, exception) {
    if (!(_this_ === exception)) {
      var tmp0_unsafeCast_0 = _this_._suppressed;
      var suppressed = tmp0_unsafeCast_0;
      if (suppressed == null) {
        _this_._suppressed = mutableListOf([exception]);
      } else {
        suppressed.add_2bq_k$(exception);
        Unit_getInstance();
      }
    }}
  function Companion_16() {
    Companion_instance_15 = this;
    this._MIN_VALUE_8 = new Char(0);
    this._MAX_VALUE_8 = new Char(65535);
    this._MIN_HIGH_SURROGATE = new Char(55296);
    this._MAX_HIGH_SURROGATE = new Char(56319);
    this._MIN_LOW_SURROGATE = new Char(56320);
    this._MAX_LOW_SURROGATE = new Char(57343);
    this._MIN_SURROGATE = new Char(55296);
    this._MAX_SURROGATE = new Char(57343);
    this._SIZE_BYTES_8 = 2;
    this._SIZE_BITS_8 = 16;
  }
  Companion_16.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_15;
  function Companion_getInstance_15() {
    if (Companion_instance_15 == null)
      new Companion_16();
    return Companion_instance_15;
  }
  function Char(code) {
    Companion_getInstance_15();
    var tmp = this;
    tmp._value_1 = _UShort___get_data__impl_(code) & 65535;
  }
  Char.prototype.compareTo_wi8o78_k$ = function (other) {
    return this._value_1 - other._value_1 | 0;
  };
  Char.prototype.compareTo_2c5_k$ = function (other) {
    return this.compareTo_wi8o78_k$(other instanceof Char ? other : THROW_CCE());
  };
  Char.prototype.minus_wi8o78_k$ = function (other) {
    return this._value_1 - other._value_1 | 0;
  };
  Char.prototype.rangeTo_wi8o78_k$ = function (other) {
    return new CharRange(this, other);
  };
  Char.prototype.toByte_0_k$ = function () {
    return toByte(this._value_1);
  };
  Char.prototype.toInt_0_k$ = function () {
    return this._value_1;
  };
  Char.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Char))
      return false;
    else {
    }
    return this._value_1 === other._value_1;
  };
  Char.prototype.hashCode = function () {
    return this._value_1;
  };
  Char.prototype.toString = function () {
    var tmp0_unsafeCast_0 = String.fromCharCode(this._value_1);
    return tmp0_unsafeCast_0;
  };
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Entry() {
  }
  Entry.$metadata$ = {
    simpleName: 'Entry',
    kind: 'interface',
    interfaces: []
  };
  function Map_0() {
  }
  Map_0.$metadata$ = {
    simpleName: 'Map',
    kind: 'interface',
    interfaces: []
  };
  function MutableEntry() {
  }
  MutableEntry.$metadata$ = {
    simpleName: 'MutableEntry',
    kind: 'interface',
    interfaces: [Entry]
  };
  function MutableMap() {
  }
  MutableMap.$metadata$ = {
    simpleName: 'MutableMap',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function MutableSet() {
  }
  MutableSet.$metadata$ = {
    simpleName: 'MutableSet',
    kind: 'interface',
    interfaces: [Set, MutableCollection]
  };
  function Set() {
  }
  Set.$metadata$ = {
    simpleName: 'Set',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function Companion_17() {
    Companion_instance_16 = this;
  }
  Companion_17.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_17();
    return Companion_instance_16;
  }
  function Enum(name, ordinal) {
    Companion_getInstance_16();
    this._name = name;
    this._ordinal = ordinal;
  }
  Enum.prototype._get_name__0_k$ = function () {
    return this._name;
  };
  Enum.prototype._get_ordinal__0_k$ = function () {
    return this._ordinal;
  };
  Enum.prototype.compareTo_2bq_k$ = function (other) {
    return compareTo(this._ordinal, other._ordinal);
  };
  Enum.prototype.compareTo_2c5_k$ = function (other) {
    return this.compareTo_2bq_k$(other instanceof Enum ? other : THROW_CCE());
  };
  Enum.prototype.equals = function (other) {
    return this === other;
  };
  Enum.prototype.hashCode = function () {
    return identityHashCode(this);
  };
  Enum.prototype.toString = function () {
    return this._name;
  };
  Enum.$metadata$ = {
    simpleName: 'Enum',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toString_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last_1 = array.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last_1));
    return array;
  }
  function arrayIterator(array) {
    return new _no_name_provided__48(array);
  }
  function intArrayIterator(array) {
    return new _no_name_provided__49(array);
  }
  function booleanArray(size_2) {
    var tmp0_withType_0 = fillArrayVal(Array(size_2), false);
    tmp0_withType_0.$type$ = 'BooleanArray';
    var tmp1_unsafeCast_0 = tmp0_withType_0;
    return tmp1_unsafeCast_0;
  }
  function charArray(size_2) {
    var tmp = Array(size_2);
    var tmp_0;
    Companion_getInstance_15();
    var tmp0__get_code__0_1 = new Char(0);
    if (0 < tmp0__get_code__0_1.toInt_0_k$()) {
      tmp_0 = true;
    } else {
      {
        Companion_getInstance_15();
        var tmp1__get_code__0_2 = new Char(65535);
        tmp_0 = 0 > tmp1__get_code__0_2.toInt_0_k$();
      }
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$('Invalid Char code: 0');
    } else {
    }
    var tmp0_withType_0 = fillArrayVal(tmp, new Char(0));
    tmp0_withType_0.$type$ = 'CharArray';
    var tmp1_unsafeCast_0 = tmp0_withType_0;
    return tmp1_unsafeCast_0;
  }
  function longArray(size_2) {
    var tmp0_withType_0 = fillArrayVal(Array(size_2), new Long(0, 0));
    tmp0_withType_0.$type$ = 'LongArray';
    var tmp1_unsafeCast_0 = tmp0_withType_0;
    return tmp1_unsafeCast_0;
  }
  function charArrayOf(arr) {
    var tmp0_withType_0 = arr.slice();
    tmp0_withType_0.$type$ = 'CharArray';
    var tmp1_unsafeCast_0 = tmp0_withType_0;
    return tmp1_unsafeCast_0;
  }
  function _no_name_provided__48($array) {
    this._$array = $array;
    this._index_4 = 0;
  }
  _no_name_provided__48.prototype.hasNext_0_k$ = function () {
    return !(this._index_4 === this._$array.length);
  };
  _no_name_provided__48.prototype.next_0_k$ = function () {
    var tmp;
    if (!(this._index_4 === this._$array.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_4;
      tmp0_this._index_4 = tmp1 + 1 | 0;
      tmp = this._$array[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_4);
    }
    return tmp;
  };
  _no_name_provided__48.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function _no_name_provided__49($array) {
    this._$array_0 = $array;
    IntIterator.call(this);
    this._index_5 = 0;
  }
  _no_name_provided__49.prototype.hasNext_0_k$ = function () {
    return !(this._index_5 === this._$array_0.length);
  };
  _no_name_provided__49.prototype.nextInt_0_k$ = function () {
    var tmp;
    if (!(this._index_5 === this._$array_0.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_5;
      tmp0_this._index_5 = tmp1 + 1 | 0;
      tmp = this._$array_0[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_5);
    }
    return tmp;
  };
  _no_name_provided__49.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var buf;
  var bufFloat64;
  var bufFloat32;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function floatToRawBits(value) {
    bufFloat32[0] = value;
    return bufInt32[0];
  }
  function floatFromBits(value) {
    bufInt32[0] = value;
    return bufFloat32[0];
  }
  function getNumberHashCode(obj) {
    var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
    if (tmp0_unsafeCast_0 === obj) {
      return numberToInt(obj);
    } else {
    }
    bufFloat64[0] = obj;
    return imul(bufInt32[highIndex], 31) + bufInt32[lowIndex] | 0;
  }
  function doubleFromBits(value) {
    bufInt32[lowIndex] = value._low;
    bufInt32[highIndex] = value._high;
    return bufFloat64[0];
  }
  function doubleToRawBits(value) {
    bufFloat64[0] = value;
    return new Long(bufInt32[lowIndex], bufInt32[highIndex]);
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufFloat32$init$() {
    var tmp0_unsafeCast_0 = new Float32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function charSequenceGet(a, index_0) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.charCodeAt(index_0);
      var tmp1_Char_0 = tmp0_unsafeCast_0;
      var tmp_0;
      Companion_getInstance_15();
      var tmp0__get_code__0_1 = new Char(0);
      if (tmp1_Char_0 < tmp0__get_code__0_1.toInt_0_k$()) {
        tmp_0 = true;
      } else {
        {
          Companion_getInstance_15();
          var tmp1__get_code__0_2 = new Char(65535);
          tmp_0 = tmp1_Char_0 > tmp1__get_code__0_2.toInt_0_k$();
        }
      }
      if (tmp_0) {
        throw IllegalArgumentException_init_$Create$('' + 'Invalid Char code: ' + tmp1_Char_0);
      } else {
      }
      tmp = numberToChar(tmp1_Char_0);
    } else {
      tmp = a.get_ha5a7z_k$(index_0);
    }
    return tmp;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.length;
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a._get_length__0_k$();
    }
    return tmp;
  }
  function charSequenceSubSequence(a, startIndex, endIndex) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.substring(startIndex, endIndex);
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a.subSequence_27zxwg_k$(startIndex, endIndex);
    }
    return tmp;
  }
  function contentEqualsInternal(_this_, other) {
    var a = _this_;
    var b = other;
    if (a === b)
      return true;
    if (((a == null ? true : b == null) ? true : !isArrayish(b)) ? true : a.length != b.length)
      return false;
    var inductionVariable = 0;
    var last_1 = a.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals_1(a[i], b[i])) {
          return false;
        }}
       while (inductionVariable < last_1);
    return true;
  }
  function contentHashCodeInternal(_this_) {
    var a = _this_;
    if (a == null)
      return 0;
    var result = 1;
    var inductionVariable = 0;
    var last_1 = a.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = imul(result, 31) + hashCode(a[i]) | 0;
      }
       while (inductionVariable < last_1);
    return result;
  }
  function contentDeepHashCodeInternal(_this_) {
    if (_this_ == null)
      return 0;
    var result = 1;
    var tmp0_iterator = arrayIterator(_this_);
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      var tmp;
      if (element == null) {
        tmp = 0;
      } else {
        if (isArrayish(element)) {
          tmp = contentDeepHashCodeInternal(element);
        } else {
          if (element instanceof UByteArray) {
            var tmp_0 = element;
            tmp = contentHashCode(tmp_0 == null ? null : tmp_0._storage);
          } else {
            if (element instanceof UShortArray) {
              var tmp_1 = element;
              tmp = contentHashCode_0(tmp_1 == null ? null : tmp_1._storage_2);
            } else {
              if (element instanceof UIntArray) {
                var tmp_2 = element;
                tmp = contentHashCode_1(tmp_2 == null ? null : tmp_2._storage_0);
              } else {
                if (element instanceof ULongArray) {
                  var tmp_3 = element;
                  tmp = contentHashCode_2(tmp_3 == null ? null : tmp_3._storage_1);
                } else {
                  {
                    tmp = hashCode(element);
                  }
                }
              }
            }
          }
        }
      }
      var elementHash = tmp;
      result = imul(31, result) + elementHash | 0;
    }
    return result;
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, _no_name_provided_$factory_34(), 24, null);
  }
  function _no_name_provided__50() {
  }
  _no_name_provided__50.prototype.invoke_wi7j7l_k$ = function (it) {
    return toString_1(it);
  };
  _no_name_provided__50.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_wi7j7l_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__50.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_34() {
    var i = new _no_name_provided__50();
    return function (p1) {
      return i.invoke_wi7j7l_k$(p1);
    };
  }
  function compareTo(a, b) {
    var tmp0_subject = typeof a;
    var tmp;
    switch (tmp0_subject) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.toDouble_0_k$());
          } else {
            {
              tmp_0 = primitiveCompareTo(a, b);
            }
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        var ia = 1 / a;
        var tmp_1;
        if (ia === 1 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            {
              tmp_1 = 1;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.compareTo_2c5_k$(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    if (!jsIn('kotlinHashCodeValue$', obj)) {
      var hash = jsBitwiseOr(Math.random() * 4.294967296E9, 0);
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }var tmp0_unsafeCast_0 = obj['kotlinHashCodeValue$'];
    return tmp0_unsafeCast_0;
  }
  function equals_1(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }if (obj2 == null) {
      return false;
    }if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }if (obj1 !== obj1) {
      return obj2 !== obj2;
    }if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp_1 = 1 / obj1;
          tmp_0 = tmp_1 === 1 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }return obj1 === obj2;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var tmp0_subject = typeof obj;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        var tmp_0;
        if (obj) {
          tmp_0 = 1;
        } else {
          {
            tmp_0 = 0;
          }
        }

        tmp = tmp_0;
        break;
      default:tmp = getStringHashCode(String(obj));
        break;
    }
    return tmp;
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last_1 = length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last_1));
    return hash;
  }
  function anyToString(o) {
    return Object.prototype.toString.call(o);
  }
  function boxIntrinsic(x) {
    throw IllegalStateException_init_$Create$_0('Should be lowered');
  }
  function unboxIntrinsic(x) {
    throw IllegalStateException_init_$Create$_0('Should be lowered');
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function newThrowable(message, cause) {
    var throwable = new Error();
    var tmp;
    if (isUndefined(message)) {
      var tmp_0;
      if (isUndefined(cause)) {
        tmp_0 = message;
      } else {
        var tmp0_safe_receiver = cause;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
        tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      var tmp2_elvis_lhs = message;
      tmp = tmp2_elvis_lhs == null ? undefined : tmp2_elvis_lhs;
    }
    throwable.message = tmp;
    throwable.cause = cause;
    throwable.name = 'Throwable';
    return throwable;
  }
  function isUndefined(value) {
    return value === undefined;
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function getContinuation() {
    throw Exception_init_$Create$('Implemented as intrinsic');
  }
  function returnIfSuspended(argument, $cont) {
    throw Exception_init_$Create$('Implemented as intrinsic');
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function noWhenBranchMatchedException() {
    throw NoWhenBranchMatchedException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$('' + 'lateinit property ' + name + ' has not been initialized');
  }
  function THROW_ISE() {
    throw IllegalStateException_init_$Create$();
  }
  function lazy(initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function fillFrom(src, dst) {
    var srcLen = src.length;
    var dstLen = dst.length;
    var index_0 = 0;
    var arr = dst;
    while (index_0 < srcLen ? index_0 < dstLen : false) {
      var tmp = index_0;
      var tmp0 = index_0;
      index_0 = tmp0 + 1 | 0;
      arr[tmp] = src[tmp0];
    }
    return dst;
  }
  function arrayPlusCollection(array, collection) {
    var tmp0_unsafeCast_0 = array.slice();
    var result = tmp0_unsafeCast_0;
    result.length = result.length + collection._get_size__0_k$() | 0;
    if (array.$type$ !== undefined) {
      result.$type$ = array.$type$;
    }var index_0 = array.length;
    var tmp0_iterator = collection.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      var tmp1 = index_0;
      index_0 = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function arrayCopyResize(source, newSize, defaultValue) {
    var tmp0_unsafeCast_0 = source.slice(0, newSize);
    var result = tmp0_unsafeCast_0;
    if (source.$type$ !== undefined) {
      result.$type$ = source.$type$;
    }var index_0 = source.length;
    if (newSize > index_0) {
      result.length = newSize;
      while (index_0 < newSize) {
        var tmp0 = index_0;
        index_0 = tmp0 + 1 | 0;
        result[tmp0] = defaultValue;
      }
    }return result;
  }
  function lazy_0(mode, initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function Companion_18() {
    Companion_instance_17 = this;
    this._MIN_VALUE_9 = new Long(0, -2147483648);
    this._MAX_VALUE_9 = new Long(-1, 2147483647);
    this._SIZE_BYTES_9 = 8;
    this._SIZE_BITS_9 = 64;
  }
  Companion_18.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_17;
  function Companion_getInstance_17() {
    if (Companion_instance_17 == null)
      new Companion_18();
    return Companion_instance_17;
  }
  function Long(low, high) {
    Companion_getInstance_17();
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.compareTo_wiekkq_k$ = function (other) {
    return compare(this, other);
  };
  Long.prototype.compareTo_2c5_k$ = function (other) {
    return this.compareTo_wiekkq_k$(other instanceof Long ? other : THROW_CCE());
  };
  Long.prototype.plus_wiekkq_k$ = function (other) {
    return add(this, other);
  };
  Long.prototype.minus_wiekkq_k$ = function (other) {
    return subtract(this, other);
  };
  Long.prototype.times_wiekkq_k$ = function (other) {
    return multiply(this, other);
  };
  Long.prototype.div_wiekkq_k$ = function (other) {
    return divide(this, other);
  };
  Long.prototype.rem_wiekkq_k$ = function (other) {
    return modulo(this, other);
  };
  Long.prototype.inc_0_k$ = function () {
    return this.plus_wiekkq_k$(new Long(1, 0));
  };
  Long.prototype.dec_0_k$ = function () {
    return this.minus_wiekkq_k$(new Long(1, 0));
  };
  Long.prototype.unaryMinus_0_k$ = function () {
    return this.inv_0_k$().plus_wiekkq_k$(new Long(1, 0));
  };
  Long.prototype.rangeTo_wiekkq_k$ = function (other) {
    return new LongRange(this, other);
  };
  Long.prototype.shl_ha5a7z_k$ = function (bitCount) {
    return shiftLeft(this, bitCount);
  };
  Long.prototype.shr_ha5a7z_k$ = function (bitCount) {
    return shiftRight(this, bitCount);
  };
  Long.prototype.ushr_ha5a7z_k$ = function (bitCount) {
    return shiftRightUnsigned(this, bitCount);
  };
  Long.prototype.and_wiekkq_k$ = function (other) {
    return new Long(this._low & other._low, this._high & other._high);
  };
  Long.prototype.or_wiekkq_k$ = function (other) {
    return new Long(this._low | other._low, this._high | other._high);
  };
  Long.prototype.xor_wiekkq_k$ = function (other) {
    return new Long(this._low ^ other._low, this._high ^ other._high);
  };
  Long.prototype.inv_0_k$ = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_0_k$ = function () {
    return this._low;
  };
  Long.prototype.toLong_0_k$ = function () {
    return this;
  };
  Long.prototype.toFloat_0_k$ = function () {
    return this.toDouble_0_k$();
  };
  Long.prototype.toDouble_0_k$ = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_0_k$();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode_0(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_0_k$());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_wiekkq_k$(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem = subtract(_this_, multiply(other, approx));
          return add(approx, rem.div_wiekkq_k$(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_wiekkq_k$(negate(other));
      } else {
        tmp = negate(negate(_this_).div_wiekkq_k$(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_wiekkq_k$(negate(other)));
    }var res = ZERO;
    var rem_0 = _this_;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta_0 = log2 <= 48.0 ? 1.0 : Math.pow(2.0, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta_0;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function modulo(_this_, other) {
    return subtract(_this_, multiply(_this_.div_wiekkq_k$(other), other));
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function shiftRightUnsigned(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >>> numBits_0);
      } else {
        var tmp;
        if (numBits_0 === 32) {
          tmp = new Long(_this_._high, 0);
        } else {
          tmp = new Long(_this_._high >>> (numBits_0 - 32 | 0), 0);
        }
        return tmp;
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function hashCode_0(l) {
    return l._low ^ l._high;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div_3 = _this_.div_wiekkq_k$(radixLong);
        var rem = subtract(multiply(div_3, radixLong), _this_).toInt_0_k$();
        var tmp = toStringImpl(div_3, radix);
        var tmp0_unsafeCast_0 = rem.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_wiekkq_k$(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_0_k$();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits = tmp1_unsafeCast_0;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_0_k$();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value) {
    if (isNaN_0(value)) {
      return ZERO;
    } else if (value <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function primitiveArrayConcat(args) {
    var size_local = 0;
    var inductionVariable = 0;
    var last_1 = args.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = size_local;
        var tmp0_unsafeCast_0 = args[i];
        size_local = tmp + tmp0_unsafeCast_0.length | 0;
      }
       while (!(i === last_1));
    var a = args[0];
    var tmp1_unsafeCast_0 = primitiveArrayConcat$outlinedJsCode$(a, size_local);
    var result = tmp1_unsafeCast_0;
    if (a.$type$ != null) {
      var tmp2_withType_0 = a.$type$;
      result.$type$ = tmp2_withType_0;
    } else {
    }
    size_local = 0;
    var inductionVariable_0 = 0;
    var last_2 = args.length - 1 | 0;
    if (inductionVariable_0 <= last_2)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp3_unsafeCast_0 = args[i_0];
        var arr = tmp3_unsafeCast_0;
        var inductionVariable_1 = 0;
        var last_3 = arr.length - 1 | 0;
        if (inductionVariable_1 <= last_3)
          do {
            var j = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp3 = size_local;
            size_local = tmp3 + 1 | 0;
            result[tmp3] = arr[j];
          }
           while (!(j === last_3));
      }
       while (!(i_0 === last_2));
    return result;
  }
  function arrayConcat(args) {
    var len = args.length;
    var tmp0_unsafeCast_0 = arrayConcat$outlinedJsCode$_0(len);
    var typed = tmp0_unsafeCast_0;
    var inductionVariable = 0;
    var last_1 = len - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var arr = args[i];
        if (!(!(arr == null) ? isArray(arr) : false)) {
          typed[i] = [].slice.call(arr);
        } else {
          {
            typed[i] = arr;
          }
        }
      }
       while (!(i === last_1));
    return [].concat.apply([], typed);
  }
  function primitiveArrayConcat$outlinedJsCode$(a, size_local) {
    return new a.constructor(size_local);
  }
  function arrayConcat$outlinedJsCode$_0(len) {
    return Array(len);
  }
  function numberToByte(a) {
    return toByte(numberToInt(a));
  }
  function toByte(a) {
    var tmp0_unsafeCast_0 = toByte$outlinedJsCode$(a);
    return tmp0_unsafeCast_0;
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_0_k$();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function numberToDouble(a) {
    var tmp0_unsafeCast_0 = numberToDouble$outlinedJsCode$_0(a);
    return tmp0_unsafeCast_0;
  }
  function numberToShort(a) {
    return toShort(numberToInt(a));
  }
  function toShort(a) {
    var tmp0_unsafeCast_0 = toShort$outlinedJsCode$_1(a);
    return tmp0_unsafeCast_0;
  }
  function numberToLong(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a;
    } else {
      {
        tmp = fromNumber(a);
      }
    }
    return tmp;
  }
  function numberToChar(a) {
    var tmp0_toUShort_0 = numberToInt(a);
    return new Char(_UShort___init__impl_(toShort(tmp0_toUShort_0)));
  }
  function toLong(a) {
    return fromInt(a);
  }
  function toByte$outlinedJsCode$(a) {
    return a << 24 >> 24;
  }
  function numberToDouble$outlinedJsCode$_0(a) {
    return +a;
  }
  function toShort$outlinedJsCode$_1(a) {
    return a << 16 >> 16;
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  var propertyRefClassMetadataCache;
  function getPropertyCallableRef(name, paramCount, type, getter, setter) {
    getter.get = getter;
    getter.set = setter;
    getter.callableName = name;
    var tmp0_unsafeCast_0 = getPropertyRefClass(getter, getKPropMetadata(paramCount, setter, type));
    return tmp0_unsafeCast_0;
  }
  function getPropertyRefClass(obj, metadata) {
    obj.$metadata$ = metadata;
    obj.constructor = obj;
    return obj;
  }
  function getKPropMetadata(paramCount, setter, type) {
    var mdata = propertyRefClassMetadataCache[paramCount][setter == null ? 0 : 1];
    if (mdata.interfaces.length == 0) {
      mdata.interfaces.push(type);
    }return mdata;
  }
  function propertyRefClassMetadataCache$init$() {
    var tmp = {kind: 'class', interfaces: []};
    var tmp0_arrayOf_0 = [tmp, {kind: 'class', interfaces: []}];
    var tmp_0 = {kind: 'class', interfaces: []};
    var tmp1_arrayOf_0 = [tmp_0, {kind: 'class', interfaces: []}];
    var tmp_1 = {kind: 'class', interfaces: []};
    var tmp2_arrayOf_0 = [tmp_1, {kind: 'class', interfaces: []}];
    var tmp3_arrayOf_0 = [tmp0_arrayOf_0, tmp1_arrayOf_0, tmp2_arrayOf_0];
    return tmp3_arrayOf_0;
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }}
    }var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isComparable(value) {
    var type = typeof value;
    return ((type === 'string' ? true : type === 'boolean') ? true : isNumber(value)) ? true : isInterface(value, _get_js_(getKClass_0(Comparable)));
  }
  function isCharSequence(value) {
    return typeof value === 'string' ? true : isInterface(value, _get_js_(getKClass_0(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return isJsArray(a) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function contentEquals_3(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentHashCode_3(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function copyOf(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Int8Array(newSize));
  }
  function asList(_this_) {
    return new ArrayList(_this_);
  }
  function copyOfRange(_this_, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(fromIndex, toIndex, _this_.length);
    return _this_.slice(fromIndex, toIndex);
  }
  function contentEquals_4(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentHashCode_4(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function fill(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function fill_0(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function contentDeepHashCode(_this_) {
    return contentDeepHashCodeInternal(_this_);
  }
  function contentDeepEquals(_this_, other) {
    return contentDeepEqualsImpl_0(_this_, other);
  }
  function plus_4(_this_, elements) {
    return arrayPlusCollection(_this_, elements);
  }
  function sort_0(_this_) {
    if (_this_.length > 1)
      sortArray(_this_);
  }
  function sortWith_0(_this_, comparator) {
    if (_this_.length > 1)
      sortArrayWith(_this_, comparator);
  }
  function copyOfRange_0(_this_, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(fromIndex, toIndex, _this_.length);
    return _this_.slice(fromIndex, toIndex);
  }
  function contentEquals_5(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_6(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_7(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_8(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_9(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_10(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function copyOf_0(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return arrayCopyResize(_this_, newSize, null);
  }
  function fill_1(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function fill$default(_this_, element, fromIndex, toIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      fromIndex = 0;
    if (!(($mask0 & 4) === 0))
      toIndex = _this_.length;
    return fill_1(_this_, element, fromIndex, toIndex);
  }
  function contentHashCode_5(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function contentHashCode_6(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function contentHashCode_7(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function copyOf_1(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Int32Array(newSize));
  }
  function copyOf_2(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Float64Array(newSize));
  }
  function copyOfRange_1(_this_, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(fromIndex, toIndex, _this_.length);
    var tmp0_withType_0 = _this_.slice(fromIndex, toIndex);
    tmp0_withType_0.$type$ = 'LongArray';
    return tmp0_withType_0;
  }
  function fill_2(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function fill_3(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function copyOfRange_2(_this_, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes_zd700_k$(fromIndex, toIndex, _this_.length);
    return _this_.slice(fromIndex, toIndex);
  }
  function contentEquals_11(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentHashCode_8(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function sort_1(_this_) {
    if (_this_.length > 1) {
      var tmp0_sort_0 = _no_name_provided_$factory_35();
      _this_.sort(tmp0_sort_0);
    }}
  function copyOf_3(_this_) {
    var tmp0_withType_0 = _this_.slice();
    tmp0_withType_0.$type$ = 'LongArray';
    return tmp0_withType_0;
  }
  function _no_name_provided__51() {
  }
  _no_name_provided__51.prototype.invoke_40e5o_k$ = function (a, b) {
    return a.compareTo_wiekkq_k$(b);
  };
  _no_name_provided__51.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_40e5o_k$(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__51.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_35() {
    var i = new _no_name_provided__51();
    return function (p1, p2) {
      return i.invoke_40e5o_k$(p1, p2);
    };
  }
  function reverse(_this_) {
    var midPoint = (_this_._get_size__0_k$() / 2 | 0) - 1 | 0;
    if (midPoint < 0)
      return Unit_getInstance();
    var reverseIndex = _get_lastIndex__4(_this_);
    var inductionVariable = 0;
    if (inductionVariable <= midPoint)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = _this_.get_ha5a7z_k$(index_0);
        _this_.set_ddb1qf_k$(index_0, _this_.get_ha5a7z_k$(reverseIndex));
        Unit_getInstance();
        _this_.set_ddb1qf_k$(reverseIndex, tmp);
        Unit_getInstance();
        var tmp1 = reverseIndex;
        reverseIndex = tmp1 - 1 | 0;
        Unit_getInstance();
      }
       while (!(index_0 === midPoint));
  }
  function digitToIntImpl(_this_) {
    var ch = _this_.toInt_0_k$();
    var index_0 = binarySearchRange(Digit_getInstance()._rangeStart, ch);
    var diff = ch - Digit_getInstance()._rangeStart[index_0] | 0;
    return diff < 10 ? diff : -1;
  }
  function binarySearchRange(array, needle) {
    var bottom = 0;
    var top = array.length - 1 | 0;
    var middle = -1;
    var value = 0;
    while (bottom <= top) {
      middle = (bottom + top | 0) / 2 | 0;
      value = array[middle];
      if (needle > value)
        bottom = middle + 1 | 0;
      else if (needle === value)
        return middle;
      else
        top = middle - 1 | 0;
    }
    return middle - (needle < value ? 1 : 0) | 0;
  }
  function Digit() {
    Digit_instance = this;
    var tmp = this;
    tmp._rangeStart = new Int32Array([48, 1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3558, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43504, 43600, 44016, 65296]);
  }
  Digit.$metadata$ = {
    simpleName: 'Digit',
    kind: 'object',
    interfaces: []
  };
  var Digit_instance;
  function Digit_getInstance() {
    if (Digit_instance == null)
      new Digit();
    return Digit_instance;
  }
  function isWhitespaceImpl(_this_) {
    var ch = _this_.toInt_0_k$();
    return (((9 <= ch ? ch <= 13 : false) ? true : 28 <= ch ? ch <= 32 : false) ? true : ch === 160) ? true : ch > 4096 ? (((((ch === 5760 ? true : 8192 <= ch ? ch <= 8202 : false) ? true : ch === 8232) ? true : ch === 8233) ? true : ch === 8239) ? true : ch === 8287) ? true : ch === 12288 : false;
  }
  function releaseIntercepted($this) {
    var intercepted_0 = $this._intercepted_;
    if (!(intercepted_0 == null) ? !(intercepted_0 === $this) : false) {
      ensureNotNull($this._get_context__0_k$().get_9uvjra_k$(Key_getInstance())).releaseInterceptedContinuation_h7c6yl_k$(intercepted_0);
    }$this._intercepted_ = CompletedContinuation_getInstance();
  }
  function CoroutineImpl_0(resultContinuation) {
    this._resultContinuation = resultContinuation;
    this._state_1 = 0;
    this._exceptionState = 0;
    this._result_0 = null;
    this._exception_0 = null;
    this._finallyPath = null;
    var tmp = this;
    var tmp0_safe_receiver = this._resultContinuation;
    tmp.__context = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_context__0_k$();
    this._intercepted_ = null;
  }
  CoroutineImpl_0.prototype._get_exception__0_k$ = function () {
    return this._exception_0;
  };
  CoroutineImpl_0.prototype._get_context__0_k$ = function () {
    return ensureNotNull(this.__context);
  };
  CoroutineImpl_0.prototype.intercepted_0_k$ = function () {
    var tmp2_elvis_lhs = this._intercepted_;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp0_safe_receiver = this._get_context__0_k$().get_9uvjra_k$(Key_getInstance());
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.interceptContinuation_x4ijla_k$(this);
      var tmp0_also_0 = tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
      this._intercepted_ = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    return tmp;
  };
  CoroutineImpl_0.prototype.resumeWith_jccoe6_k$ = function (result) {
    var current = this;
    var tmp;
    if (_Result___get_isFailure__impl_(result)) {
      tmp = null;
    } else {
      var tmp_0 = _Result___get_value__impl_(result);
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    }
    var currentResult = tmp;
    var currentException = Result__exceptionOrNull_impl(result);
    while (true) {
      var tmp0_with_0 = current;
      if (currentException == null) {
        tmp0_with_0._result_0 = currentResult;
      } else {
        tmp0_with_0._state_1 = tmp0_with_0._exceptionState;
        tmp0_with_0._exception_0 = currentException;
      }
      try {
        var outcome_2 = tmp0_with_0.doResume_0_k$();
        if (outcome_2 === _get_COROUTINE_SUSPENDED_())
          return Unit_getInstance();
        currentResult = outcome_2;
        currentException = null;
      } catch ($p) {
        currentResult = null;
        currentException = $p;
      }
      releaseIntercepted(tmp0_with_0);
      var completion_4 = ensureNotNull(tmp0_with_0._resultContinuation);
      if (completion_4 instanceof CoroutineImpl_0) {
        current = completion_4;
      } else {
        {
          if (!(currentException == null)) {
            var tmp0_resumeWithException_0_5 = ensureNotNull(currentException);
            var tmp0_failure_0_1_6 = Companion_getInstance_3();
            completion_4.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(tmp0_resumeWithException_0_5)));
          } else {
            var tmp1_resume_0_7 = currentResult;
            var tmp0_success_0_1_8 = Companion_getInstance_3();
            completion_4.resumeWith_bnunh2_k$(_Result___init__impl_(tmp1_resume_0_7));
          }
          return Unit_getInstance();
        }
      }
    }
  };
  CoroutineImpl_0.prototype.resumeWith_bnunh2_k$ = function (result) {
    return this.resumeWith_jccoe6_k$(result);
  };
  CoroutineImpl_0.$metadata$ = {
    simpleName: 'CoroutineImpl',
    kind: 'class',
    interfaces: [Continuation]
  };
  function CompletedContinuation() {
    CompletedContinuation_instance = this;
  }
  CompletedContinuation.prototype._get_context__0_k$ = function () {
    throw IllegalStateException_init_$Create$_0('This continuation is already complete');
  };
  CompletedContinuation.prototype.resumeWith_jccoe6_k$ = function (result) {
    throw IllegalStateException_init_$Create$_0('This continuation is already complete');
  };
  CompletedContinuation.prototype.resumeWith_bnunh2_k$ = function (result) {
    return this.resumeWith_jccoe6_k$(result);
  };
  CompletedContinuation.prototype.toString = function () {
    return 'This continuation is already complete';
  };
  CompletedContinuation.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'object',
    interfaces: [Continuation]
  };
  var CompletedContinuation_instance;
  function CompletedContinuation_getInstance() {
    if (CompletedContinuation_instance == null)
      new CompletedContinuation();
    return CompletedContinuation_instance;
  }
  function intercepted(_this_) {
    var tmp0_safe_receiver = _this_ instanceof CoroutineImpl_0 ? _this_ : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.intercepted_0_k$();
    return tmp1_elvis_lhs == null ? _this_ : tmp1_elvis_lhs;
  }
  function createCoroutineUnintercepted(_this_, receiver, completion) {
    return new _no_name_provided__1_3(_this_, receiver, completion);
  }
  function createCoroutineUnintercepted_0(_this_, completion) {
    return new _no_name_provided__1_4(_this_, completion);
  }
  function _no_name_provided__1_3($this_createCoroutineUnintercepted, $receiver, $completion) {
    this._$this_createCoroutineUnintercepted = $this_createCoroutineUnintercepted;
    this._$receiver = $receiver;
    this._$completion = $completion;
    CoroutineImpl_0.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  _no_name_provided__1_3.prototype.doResume_2_0_k$ = function () {
    if (this._get_exception__0_k$() != null)
      throw this._get_exception__0_k$();
    return this._$this_createCoroutineUnintercepted(this._$receiver, this._$completion);
  };
  _no_name_provided__1_3.prototype.doResume_0_k$ = function () {
    return this.doResume_2_0_k$();
  };
  _no_name_provided__1_3.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_4($this_createCoroutineUnintercepted, $completion) {
    this._$this_createCoroutineUnintercepted_0 = $this_createCoroutineUnintercepted;
    this._$completion_0 = $completion;
    CoroutineImpl_0.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  _no_name_provided__1_4.prototype.doResume_2_0_k$ = function () {
    if (this._get_exception__0_k$() != null)
      throw this._get_exception__0_k$();
    return this._$this_createCoroutineUnintercepted_0(this._$completion_0);
  };
  _no_name_provided__1_4.prototype.doResume_0_k$ = function () {
    return this.doResume_2_0_k$();
  };
  _no_name_provided__1_4.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: []
  };
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Exception.call($this);
    return $this;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function Error_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Error_0.call($this);
    return $this;
  }
  function Error_0() {
    captureStack(this, Error_0);
  }
  Error_0.$metadata$ = {
    simpleName: 'Error',
    kind: 'class',
    interfaces: []
  };
  function IllegalArgumentException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$(message) {
    var tmp = IllegalArgumentException_init_$Init$(message, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  IllegalArgumentException.$metadata$ = {
    simpleName: 'IllegalArgumentException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$(message) {
    var tmp = RuntimeException_init_$Init$_0(message, Object.create(RuntimeException.prototype));
    captureStack(tmp, RuntimeException_init_$Create$);
    return tmp;
  }
  function RuntimeException_init_$Init$_1(message, cause, $this) {
    Exception_init_$Init$_1(message, cause, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_0(message, cause) {
    var tmp = RuntimeException_init_$Init$_1(message, cause, Object.create(RuntimeException.prototype));
    captureStack(tmp, RuntimeException_init_$Create$_0);
    return tmp;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function IllegalStateException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$() {
    var tmp = IllegalStateException_init_$Init$(Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message) {
    var tmp = IllegalStateException_init_$Init$_0(message, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_1(message, cause) {
    var tmp = IllegalStateException_init_$Init$_1(message, cause, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$_1);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  IllegalStateException.$metadata$ = {
    simpleName: 'IllegalStateException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$() {
    var tmp = IndexOutOfBoundsException_init_$Init$(Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$_0(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$_0(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$_0);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function NumberFormatException_init_$Init$(message, $this) {
    IllegalArgumentException_init_$Init$(message, $this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$(message) {
    var tmp = NumberFormatException_init_$Init$(message, Object.create(NumberFormatException.prototype));
    captureStack(tmp, NumberFormatException_init_$Create$);
    return tmp;
  }
  function NumberFormatException() {
    captureStack(this, NumberFormatException);
  }
  NumberFormatException.$metadata$ = {
    simpleName: 'NumberFormatException',
    kind: 'class',
    interfaces: []
  };
  function ArithmeticException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$(message) {
    var tmp = ArithmeticException_init_$Init$(message, Object.create(ArithmeticException.prototype));
    captureStack(tmp, ArithmeticException_init_$Create$);
    return tmp;
  }
  function ArithmeticException() {
    captureStack(this, ArithmeticException);
  }
  ArithmeticException.$metadata$ = {
    simpleName: 'ArithmeticException',
    kind: 'class',
    interfaces: []
  };
  function AssertionError_init_$Init$($this) {
    Error_init_$Init$($this);
    AssertionError.call($this);
    return $this;
  }
  function AssertionError_init_$Create$() {
    var tmp = AssertionError_init_$Init$(Object.create(AssertionError.prototype));
    captureStack(tmp, AssertionError_init_$Create$);
    return tmp;
  }
  function AssertionError() {
    captureStack(this, AssertionError);
  }
  AssertionError.$metadata$ = {
    simpleName: 'AssertionError',
    kind: 'class',
    interfaces: []
  };
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(Object.create(NullPointerException.prototype));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  NullPointerException.$metadata$ = {
    simpleName: 'NullPointerException',
    kind: 'class',
    interfaces: []
  };
  function NoWhenBranchMatchedException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoWhenBranchMatchedException.call($this);
    return $this;
  }
  function NoWhenBranchMatchedException_init_$Create$() {
    var tmp = NoWhenBranchMatchedException_init_$Init$(Object.create(NoWhenBranchMatchedException.prototype));
    captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
    return tmp;
  }
  function NoWhenBranchMatchedException() {
    captureStack(this, NoWhenBranchMatchedException);
  }
  NoWhenBranchMatchedException.$metadata$ = {
    simpleName: 'NoWhenBranchMatchedException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function UninitializedPropertyAccessException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$(message, Object.create(UninitializedPropertyAccessException.prototype));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  UninitializedPropertyAccessException.$metadata$ = {
    simpleName: 'UninitializedPropertyAccessException',
    kind: 'class',
    interfaces: []
  };
  function jsIn(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = jsIn$outlinedJsCode$(lhs_hack, rhs_hack);
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = jsBitwiseOr$outlinedJsCode$_0(lhs_hack, rhs_hack);
    return tmp0_unsafeCast_0;
  }
  function jsTypeOf(value_hack) {
    var tmp0_unsafeCast_0 = jsTypeOf$outlinedJsCode$_1(value_hack);
    return tmp0_unsafeCast_0;
  }
  function jsDeleteProperty(obj_hack, property_hack) {
    jsDeleteProperty$outlinedJsCode$_2(obj_hack, property_hack);
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp0_unsafeCast_0 = jsInstanceOf$outlinedJsCode$_3(obj_hack, jsClass_hack);
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = jsBitwiseAnd$outlinedJsCode$_4(lhs_hack, rhs_hack);
    return tmp0_unsafeCast_0;
  }
  function jsIn$outlinedJsCode$(lhs_hack, rhs_hack) {
    return lhs_hack in rhs_hack;
  }
  function jsBitwiseOr$outlinedJsCode$_0(lhs_hack, rhs_hack) {
    return lhs_hack | rhs_hack;
  }
  function jsTypeOf$outlinedJsCode$_1(value_hack) {
    return typeof value_hack;
  }
  function jsDeleteProperty$outlinedJsCode$_2(obj_hack, property_hack) {
    return delete obj_hack[property_hack];
  }
  function jsInstanceOf$outlinedJsCode$_3(obj_hack, jsClass_hack) {
    return obj_hack instanceof jsClass_hack;
  }
  function jsBitwiseAnd$outlinedJsCode$_4(lhs_hack, rhs_hack) {
    return lhs_hack & rhs_hack;
  }
  function toRawBits(_this_) {
    return doubleToRawBits(_this_);
  }
  function toBits(_this_) {
    var tmp;
    if (isNaN_1(_this_)) {
      FloatCompanionObject_getInstance();
      tmp = NaN;
    } else {
      tmp = _this_;
    }
    return floatToRawBits(tmp);
  }
  function toString_2(_this_, radix) {
    return toStringImpl(_this_, checkRadix(radix));
  }
  function Companion_19() {
    Companion_instance_18 = this;
  }
  Companion_19.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_18;
  function Companion_getInstance_18() {
    if (Companion_instance_18 == null)
      new Companion_19();
    return Companion_instance_18;
  }
  function index($this, x, y) {
    if (!(0 <= x ? x < $this._width : false) ? true : !(0 <= y ? y < $this._height : false))
      throw IndexOutOfBoundsException_init_$Create$();
    return imul(y, $this._width) + x | 0;
  }
  function IntArray2(width, height, data) {
    Companion_getInstance_18();
    this._width = width;
    this._height = height;
    this._data_3 = data;
  }
  IntArray2.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this._width === other._width;
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._height === other._height;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = contentEquals_4(this._data_3, other._data_3);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntArray2.prototype.hashCode = function () {
    return (this._width + this._height | 0) + contentHashCode_4(this._data_3) | 0;
  };
  IntArray2.prototype.get_27zxwg_k$ = function (x, y) {
    return this._data_3[index(this, x, y)];
  };
  IntArray2.prototype.inside_27zxwg_k$ = function (x, y) {
    return ((x >= 0 ? y >= 0 : false) ? x < this._width : false) ? y < this._height : false;
  };
  IntArray2.prototype.iterator_0_k$ = function () {
    return intArrayIterator(this._data_3);
  };
  IntArray2.prototype.toString = function () {
    var tmp0_map_0 = until(0, this._height);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var inductionVariable = tmp0_map_0._get_first__0_k$();
    var last_1 = tmp0_map_0._get_last__0_k$();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_map_0_5 = until(0, this._width);
        var tmp0_mapTo_0_1_6 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_5, 10));
        var inductionVariable_0 = tmp0_map_0_5._get_first__0_k$();
        var last_2 = tmp0_map_0_5._get_last__0_k$();
        if (inductionVariable_0 <= last_2)
          do {
            var item_2_3_8 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            tmp0_mapTo_0_1_6.add_2bq_k$(this.get_27zxwg_k$(item_2_3_8, item_2_3));
            Unit_getInstance();
          }
           while (!(item_2_3_8 === last_2));
        tmp0_mapTo_0_1.add_2bq_k$(joinToString$default_0(tmp0_mapTo_0_1_6, ', ', null, null, 0, null, null, 62, null));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    return joinToString$default_0(tmp0_mapTo_0_1, '\n', null, null, 0, null, null, 62, null);
  };
  IntArray2.$metadata$ = {
    simpleName: 'IntArray2',
    kind: 'class',
    interfaces: [Iterable]
  };
  function ByteArrayDeque_init_$Init$(initialBits, allowGrow, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialBits = 10;
    if (!(($mask0 & 2) === 0))
      allowGrow = true;
    ByteArrayDeque.call($this, initialBits, allowGrow);
    return $this;
  }
  function ByteArrayDeque_init_$Create$(initialBits, allowGrow, $mask0, $marker) {
    return ByteArrayDeque_init_$Init$(initialBits, allowGrow, $mask0, $marker, Object.create(ByteArrayDeque.prototype));
  }
  function ensureWrite($this, count_0) {
    if (count_0 > $this._ring._get_availableWrite__0_k$()) {
      if (!$this._allowGrow) {
        var message = '' + "Can't grow ByteArrayDeque. Need to write " + count_0 + ', but only ' + $this._ring._get_availableWrite__0_k$() + ' is available';
        println('' + 'ERROR: ' + message);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }var minNewSize = $this._ring._get_availableRead__0_k$() + count_0 | 0;
      var newBits = ilog2(minNewSize) + 2 | 0;
      var newRing = new RingBuffer(newBits);
      while ($this._ring._get_availableRead__0_k$() > 0) {
        var read_0 = $this._ring.read_irqg4d_k$($this._tempBuffer, 0, $this._tempBuffer.length);
        newRing.write_irqg4d_k$($this._tempBuffer, 0, read_0);
        Unit_getInstance();
      }
      $this._ring = newRing;
    }return $this;
  }
  function ByteArrayDeque(initialBits, allowGrow) {
    this._initialBits = initialBits;
    this._allowGrow = allowGrow;
    this._ring = new RingBuffer(this._initialBits);
    this._tempBuffer = new Int8Array(1024);
    this._written = new Long(0, 0);
    this._read = new Long(0, 0);
  }
  ByteArrayDeque.prototype._get_availableRead__0_k$ = function () {
    return this._ring._get_availableRead__0_k$();
  };
  ByteArrayDeque.prototype.write_irqg4d_k$ = function (buffer, offset_0, size_2) {
    var out = ensureWrite(this, size_2)._ring.write_irqg4d_k$(buffer, offset_0, size_2);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._written;
      tmp._written = tmp0_plus_0.plus_wiekkq_k$(toLong(out));
    }return out;
  };
  ByteArrayDeque.prototype.read_irqg4d_k$ = function (buffer, offset_0, size_2) {
    var out = this._ring.read_irqg4d_k$(buffer, offset_0, size_2);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._read;
      tmp._read = tmp0_plus_0.plus_wiekkq_k$(toLong(out));
    }return out;
  };
  ByteArrayDeque.prototype.hashCode = function () {
    return this._ring.contentHashCode_0_k$();
  };
  ByteArrayDeque.prototype.equals = function (other) {
    var tmp;
    if (other instanceof ByteArrayDeque) {
      tmp = this._ring.equals(other._ring);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ByteArrayDeque.$metadata$ = {
    simpleName: 'ByteArrayDeque',
    kind: 'class',
    interfaces: []
  };
  function ShortArrayDeque_init_$Init$(initialBits, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialBits = 10;
    ShortArrayDeque.call($this, initialBits);
    return $this;
  }
  function ShortArrayDeque_init_$Create$(initialBits, $mask0, $marker) {
    return ShortArrayDeque_init_$Init$(initialBits, $mask0, $marker, Object.create(ShortArrayDeque.prototype));
  }
  function ensureWrite_0($this, count_0) {
    if (count_0 > $this._ring_0._availableWrite_0) {
      var minNewSize = $this._ring_0._availableRead_0 + count_0 | 0;
      var newBits = ilog2(minNewSize) + 2 | 0;
      var newRing = new ShortRingBuffer(newBits);
      while ($this._ring_0._availableRead_0 > 0) {
        var read_0 = $this._ring_0.read_br01yt_k$($this._tempBuffer_0, 0, $this._tempBuffer_0.length);
        newRing.write_br01yt_k$($this._tempBuffer_0, 0, read_0);
        Unit_getInstance();
      }
      $this._ring_0 = newRing;
    }return $this;
  }
  function ShortArrayDeque(initialBits) {
    this._initialBits_0 = initialBits;
    this._ring_0 = new ShortRingBuffer(this._initialBits_0);
    this._tempBuffer_0 = new Int16Array(1024);
    this._written_0 = new Long(0, 0);
    this._read_0 = new Long(0, 0);
  }
  ShortArrayDeque.prototype._get_availableRead__0_k$ = function () {
    return this._ring_0._availableRead_0;
  };
  ShortArrayDeque.prototype.write_br01yt_k$ = function (buffer, offset_0, size_2) {
    var out = ensureWrite_0(this, size_2)._ring_0.write_br01yt_k$(buffer, offset_0, size_2);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._written_0;
      tmp._written_0 = tmp0_plus_0.plus_wiekkq_k$(toLong(out));
    }return out;
  };
  ShortArrayDeque.prototype.read_br01yt_k$ = function (buffer, offset_0, size_2) {
    var out = this._ring_0.read_br01yt_k$(buffer, offset_0, size_2);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._read_0;
      tmp._read_0 = tmp0_plus_0.plus_wiekkq_k$(toLong(out));
    }return out;
  };
  ShortArrayDeque.prototype.hashCode = function () {
    return this._ring_0.contentHashCode_0_k$();
  };
  ShortArrayDeque.prototype.equals = function (other) {
    var tmp;
    if (other instanceof ShortArrayDeque) {
      tmp = this._ring_0.equals(other._ring_0);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ShortArrayDeque.$metadata$ = {
    simpleName: 'ShortArrayDeque',
    kind: 'class',
    interfaces: []
  };
  function FloatArrayDeque_init_$Init$(initialBits, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialBits = 10;
    FloatArrayDeque.call($this, initialBits);
    return $this;
  }
  function FloatArrayDeque_init_$Create$(initialBits, $mask0, $marker) {
    return FloatArrayDeque_init_$Init$(initialBits, $mask0, $marker, Object.create(FloatArrayDeque.prototype));
  }
  function ensureWrite_1($this, count_0) {
    if (count_0 > $this._ring_1._availableWrite_1) {
      var minNewSize = $this._ring_1._availableRead_1 + count_0 | 0;
      var newBits = ilog2(minNewSize) + 2 | 0;
      var newRing = new FloatRingBuffer(newBits);
      while ($this._ring_1._availableRead_1 > 0) {
        var read_0 = $this._ring_1.read_zd834l_k$($this._tempBuffer_1, 0, $this._tempBuffer_1.length);
        newRing.write_zd834l_k$($this._tempBuffer_1, 0, read_0);
        Unit_getInstance();
      }
      $this._ring_1 = newRing;
    }return $this;
  }
  function FloatArrayDeque(initialBits) {
    this._initialBits_1 = initialBits;
    this._ring_1 = new FloatRingBuffer(this._initialBits_1);
    this._tempBuffer_1 = new Float32Array(1024);
    this._written_1 = new Long(0, 0);
    this._read_1 = new Long(0, 0);
  }
  FloatArrayDeque.prototype._get_availableRead__0_k$ = function () {
    return this._ring_1._availableRead_1;
  };
  FloatArrayDeque.prototype.write_zd834l_k$ = function (buffer, offset_0, size_2) {
    var out = ensureWrite_1(this, size_2)._ring_1.write_zd834l_k$(buffer, offset_0, size_2);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._written_1;
      tmp._written_1 = tmp0_plus_0.plus_wiekkq_k$(toLong(out));
    }return out;
  };
  FloatArrayDeque.prototype.read_zd834l_k$ = function (buffer, offset_0, size_2) {
    var out = this._ring_1.read_zd834l_k$(buffer, offset_0, size_2);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._read_1;
      tmp._read_1 = tmp0_plus_0.plus_wiekkq_k$(toLong(out));
    }return out;
  };
  FloatArrayDeque.prototype.read$default_l2dr7t_k$ = function (buffer, offset_0, size_2, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset_0 = 0;
    if (!(($mask0 & 4) === 0))
      size_2 = buffer.length - offset_0 | 0;
    return this.read_zd834l_k$(buffer, offset_0, size_2);
  };
  FloatArrayDeque.prototype.hashCode = function () {
    return this._ring_1.contentHashCode_0_k$();
  };
  FloatArrayDeque.prototype.equals = function (other) {
    var tmp;
    if (other instanceof FloatArrayDeque) {
      tmp = this._ring_1.equals(other._ring_1);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  FloatArrayDeque.$metadata$ = {
    simpleName: 'FloatArrayDeque',
    kind: 'class',
    interfaces: []
  };
  function DoubleArrayList_init_$Init$(capacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      capacity = 7;
    DoubleArrayList.call($this, capacity);
    return $this;
  }
  function DoubleArrayList_init_$Create$(capacity, $mask0, $marker) {
    return DoubleArrayList_init_$Init$(capacity, $mask0, $marker, Object.create(DoubleArrayList.prototype));
  }
  function Companion_20() {
    Companion_instance_19 = this;
  }
  Companion_20.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_19;
  function Companion_getInstance_19() {
    if (Companion_instance_19 == null)
      new Companion_20();
    return Companion_instance_19;
  }
  function DoubleArrayList_init_$Init$_0(other, $this) {
    DoubleArrayList_init_$Init$(0, 1, null, $this);
    $this.add_pd4ws6_k$(other);
    return $this;
  }
  function DoubleArrayList_init_$Create$_0(other) {
    return DoubleArrayList_init_$Init$_0(other, Object.create(DoubleArrayList.prototype));
  }
  function DoubleArrayList_init_$Init$_1(other, $this) {
    DoubleArrayList_init_$Init$(0, 1, null, $this);
    $this.add$default_unnwnd_k$(other, 0, 0, 6, null);
    return $this;
  }
  function DoubleArrayList_init_$Create$_1(other) {
    return DoubleArrayList_init_$Init$_1(other, Object.create(DoubleArrayList.prototype));
  }
  function ensure($this, count_0) {
    if (($this._length + count_0 | 0) > $this._data_4.length) {
      var tmp = $this;
      var tmp_0 = $this._data_4;
      var tmp0_max_0 = $this._length + count_0 | 0;
      var tmp1_max_0 = imul($this._data_4.length, 3);
      var tmp_1 = copyOf_2(tmp_0, Math.max(tmp0_max_0, tmp1_max_0));
      tmp._data_4 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
    }}
  function DoubleArrayList(capacity) {
    Companion_getInstance_19();
    var tmp = this;
    var tmp_0 = new Float64Array(capacity);
    tmp._data_4 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    this._length = 0;
  }
  DoubleArrayList.prototype._set_size__majfzk_k$ = function (value) {
    ensure(this, value);
    this._length = value;
  };
  DoubleArrayList.prototype._get_size__0_k$ = function () {
    return this._length;
  };
  DoubleArrayList.prototype.clear_sv8swh_k$ = function () {
    this._length = 0;
    return Unit_getInstance();
  };
  DoubleArrayList.prototype.add_okcceq_k$ = function (v0) {
    ensure(this, 1);
    var tmp = this._data_4;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
  };
  DoubleArrayList.prototype.add_ul66c3_k$ = function (v0, v1) {
    ensure(this, 2);
    var tmp = this._data_4;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this._data_4;
    var tmp2_this = this;
    var tmp3 = tmp2_this._length;
    tmp2_this._length = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
  };
  DoubleArrayList.prototype.add_lf7oid_k$ = function (v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this._data_4;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this._data_4;
    var tmp2_this = this;
    var tmp3 = tmp2_this._length;
    tmp2_this._length = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
    var tmp_1 = this._data_4;
    var tmp4_this = this;
    var tmp5 = tmp4_this._length;
    tmp4_this._length = tmp5 + 1 | 0;
    tmp_1[tmp5] = v2;
    var tmp_2 = this._data_4;
    var tmp6_this = this;
    var tmp7 = tmp6_this._length;
    tmp6_this._length = tmp7 + 1 | 0;
    tmp_2[tmp7] = v3;
  };
  DoubleArrayList.prototype.add_iylh49_k$ = function (v0, v1, v2, v3, v4, v5) {
    ensure(this, 6);
    var tmp = this._data_4;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this._data_4;
    var tmp2_this = this;
    var tmp3 = tmp2_this._length;
    tmp2_this._length = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
    var tmp_1 = this._data_4;
    var tmp4_this = this;
    var tmp5 = tmp4_this._length;
    tmp4_this._length = tmp5 + 1 | 0;
    tmp_1[tmp5] = v2;
    var tmp_2 = this._data_4;
    var tmp6_this = this;
    var tmp7 = tmp6_this._length;
    tmp6_this._length = tmp7 + 1 | 0;
    tmp_2[tmp7] = v3;
    var tmp_3 = this._data_4;
    var tmp8_this = this;
    var tmp9 = tmp8_this._length;
    tmp8_this._length = tmp9 + 1 | 0;
    tmp_3[tmp9] = v4;
    var tmp_4 = this._data_4;
    var tmp10_this = this;
    var tmp11 = tmp10_this._length;
    tmp10_this._length = tmp11 + 1 | 0;
    tmp_4[tmp11] = v5;
  };
  DoubleArrayList.prototype.plusAssign_okcceq_k$ = function (value) {
    return this.add_okcceq_k$(value);
  };
  DoubleArrayList.prototype.plusAssign_pd4ws6_k$ = function (value) {
    return this.add_pd4ws6_k$(value);
  };
  DoubleArrayList.prototype.add_naenjd_k$ = function (values_21, offset_0, length) {
    ensure(this, length);
    arraycopy(isDoubleArray(values_21) ? values_21 : THROW_CCE(), offset_0, this._data_4, this._get_size__0_k$(), length);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._set_size__majfzk_k$(tmp0_this._get_size__0_k$() + length | 0);
  };
  DoubleArrayList.prototype.add$default_unnwnd_k$ = function (values_21, offset_0, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset_0 = 0;
    if (!(($mask0 & 4) === 0))
      length = values_21.length;
    return this.add_naenjd_k$(values_21, offset_0, length);
  };
  DoubleArrayList.prototype.add_pd4ws6_k$ = function (values_21) {
    return this.add_naenjd_k$(values_21._data_4, 0, values_21._get_size__0_k$());
  };
  DoubleArrayList.prototype.get_ha5a7z_k$ = function (index_0) {
    return this._data_4[index_0];
  };
  DoubleArrayList.prototype.getAt_ha5a7z_k$ = function (index_0) {
    return this._data_4[index_0];
  };
  DoubleArrayList.prototype.set_xewlg1_k$ = function (index_0, value) {
    if (index_0 >= this._length) {
      ensure(this, index_0 + 1 | 0);
      this._length = index_0 + 1 | 0;
    }return this._data_4[index_0] = value;
  };
  DoubleArrayList.prototype.iterator_0_k$ = function () {
    return this.listIterator_ha5a7z_k$(0);
  };
  DoubleArrayList.prototype.contains_e2tf9d_k$ = function (element) {
    var inductionVariable = 0;
    var last_1 = this._length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this._data_4[n] === element)
          return true;
      }
       while (inductionVariable < last_1);
    return false;
  };
  DoubleArrayList.prototype.contains_2bq_k$ = function (element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    else {
    }
    return this.contains_e2tf9d_k$((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  DoubleArrayList.prototype.containsAll_tri21_k$ = function (elements) {
    var tmp0_iterator = elements.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var e = tmp0_iterator.next_0_k$();
      if (!this.contains_e2tf9d_k$(e))
        return false;
    }
    return true;
  };
  DoubleArrayList.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_tri21_k$(elements);
  };
  DoubleArrayList.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  DoubleArrayList.prototype.listIterator_ha5a7z_k$ = function (index_0) {
    return take(this._data_4, this._length).listIterator_ha5a7z_k$(index_0);
  };
  DoubleArrayList.prototype.hashCode = function () {
    return contentHashCode_9(this._data_4, 0, this._get_size__0_k$());
  };
  DoubleArrayList.prototype.equals = function (other) {
    if (other instanceof DoubleArrayList)
      return this._get_size__0_k$() === other._get_size__0_k$() ? contentEquals_12(this._data_4, other._data_4, 0, this._get_size__0_k$()) : false;
    else {
    }
    if (!(other == null) ? isInterface(other, List) : false)
      return equals_1(other, this);
    else {
    }
    return false;
  };
  DoubleArrayList.prototype.toString = function () {
    var tmp0_also_0 = StringBuilder_init_$Create$(2 + imul(5, this._get_size__0_k$()) | 0);
    tmp0_also_0.append_wi8o78_k$(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n_3 === 0)) {
          tmp0_also_0.append_uch40_k$(', ');
          Unit_getInstance();
        }tmp0_also_0.append_wi7j7l_k$(this.getAt_ha5a7z_k$(n_3));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp0_also_0.append_wi8o78_k$(new Char(93));
    Unit_getInstance();
    return tmp0_also_0.toString();
  };
  DoubleArrayList.$metadata$ = {
    simpleName: 'DoubleArrayList',
    kind: 'class',
    interfaces: [Collection]
  };
  function IntArrayList_init_$Init$(capacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      capacity = 7;
    IntArrayList.call($this, capacity);
    return $this;
  }
  function IntArrayList_init_$Create$(capacity, $mask0, $marker) {
    return IntArrayList_init_$Init$(capacity, $mask0, $marker, Object.create(IntArrayList.prototype));
  }
  function Companion_21() {
    Companion_instance_20 = this;
  }
  Companion_21.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_21();
    return Companion_instance_20;
  }
  function IntArrayList_init_$Init$_0(other, $this) {
    IntArrayList_init_$Init$(0, 1, null, $this);
    $this.add_i58uhq_k$(other);
    return $this;
  }
  function IntArrayList_init_$Create$_0(other) {
    return IntArrayList_init_$Init$_0(other, Object.create(IntArrayList.prototype));
  }
  function IntArrayList_init_$Init$_1(other, $this) {
    IntArrayList_init_$Init$(0, 1, null, $this);
    $this.add$default_fc0b9j_k$(other, 0, 0, 6, null);
    return $this;
  }
  function IntArrayList_init_$Create$_1(other) {
    return IntArrayList_init_$Init$_1(other, Object.create(IntArrayList.prototype));
  }
  function IntArrayList(capacity) {
    Companion_getInstance_20();
    var tmp = this;
    var tmp_0 = new Int32Array(capacity);
    tmp._data_5 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    this._length_0 = 0;
  }
  IntArrayList.prototype._set_size__majfzk_k$ = function (value) {
    this.ensure_majfzk_k$(value);
    this._length_0 = value;
  };
  IntArrayList.prototype._get_size__0_k$ = function () {
    return this._length_0;
  };
  IntArrayList.prototype.ensure_majfzk_k$ = function (count_0) {
    if ((this._length_0 + count_0 | 0) > this._data_5.length) {
      var tmp = this;
      var tmp_0 = this._data_5;
      var tmp0_max_0 = this._length_0 + count_0 | 0;
      var tmp1_max_0 = imul(this._data_5.length, 3);
      var tmp_1 = copyOf_1(tmp_0, Math.max(tmp0_max_0, tmp1_max_0));
      tmp._data_5 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }};
  IntArrayList.prototype.clear_sv8swh_k$ = function () {
    this._length_0 = 0;
    return Unit_getInstance();
  };
  IntArrayList.prototype.add_majfzk_k$ = function (v0) {
    this.ensure_majfzk_k$(1);
    var tmp = this._data_5;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length_0;
    tmp0_this._length_0 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
  };
  IntArrayList.prototype.plusAssign_majfzk_k$ = function (value) {
    return this.add_majfzk_k$(value);
  };
  IntArrayList.prototype.plusAssign_i58uhq_k$ = function (value) {
    return this.add_i58uhq_k$(value);
  };
  IntArrayList.prototype.add_6gxn8n_k$ = function (values_21, offset_0, length) {
    this.ensure_majfzk_k$(length);
    arraycopy_0(isIntArray(values_21) ? values_21 : THROW_CCE(), offset_0, this._data_5, this._get_size__0_k$(), length);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._set_size__majfzk_k$(tmp0_this._get_size__0_k$() + length | 0);
  };
  IntArrayList.prototype.add$default_fc0b9j_k$ = function (values_21, offset_0, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset_0 = 0;
    if (!(($mask0 & 4) === 0))
      length = values_21.length;
    return this.add_6gxn8n_k$(values_21, offset_0, length);
  };
  IntArrayList.prototype.add_i58uhq_k$ = function (values_21) {
    return this.add_6gxn8n_k$(values_21._data_5, 0, values_21._get_size__0_k$());
  };
  IntArrayList.prototype.get_ha5a7z_k$ = function (index_0) {
    return this._data_5[index_0];
  };
  IntArrayList.prototype.getAt_ha5a7z_k$ = function (index_0) {
    return this._data_5[index_0];
  };
  IntArrayList.prototype.set_rvwcgf_k$ = function (index_0, value) {
    if (index_0 >= this._length_0) {
      this.ensure_majfzk_k$(index_0 + 1 | 0);
      this._length_0 = index_0 + 1 | 0;
    }return this._data_5[index_0] = value;
  };
  IntArrayList.prototype.iterator_0_k$ = function () {
    return this.listIterator_ha5a7z_k$(0);
  };
  IntArrayList.prototype.contains_ha5a7z_k$ = function (element) {
    var inductionVariable = 0;
    var last_1 = this._length_0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this._data_5[n] === element)
          return true;
      }
       while (inductionVariable < last_1);
    return false;
  };
  IntArrayList.prototype.contains_2bq_k$ = function (element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    else {
    }
    return this.contains_ha5a7z_k$((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  IntArrayList.prototype.containsAll_envxgl_k$ = function (elements) {
    var tmp0_iterator = elements.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var e = tmp0_iterator.next_0_k$();
      if (!this.contains_ha5a7z_k$(e))
        return false;
    }
    return true;
  };
  IntArrayList.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_envxgl_k$(elements);
  };
  IntArrayList.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  IntArrayList.prototype.insertAt_27zxwg_k$ = function (index_0, value) {
    this.ensure_majfzk_k$(1);
    if (!this.isEmpty_0_k$()) {
      arraycopy_0(this._data_5, index_0, this._data_5, index_0 + 1 | 0, this._length_0 - index_0 | 0);
      Unit_getInstance();
    } else {
    }
    this._data_5[index_0] = value;
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2._length_0;
    tmp0_this_2._length_0 = tmp1_3 + 1 | 0;
    Unit_getInstance();
    return this;
  };
  IntArrayList.prototype.swap_rvwcgf_k$ = function (indexA, indexB) {
    var l = this.getAt_ha5a7z_k$(indexA);
    var r = this.getAt_ha5a7z_k$(indexB);
    this.set_rvwcgf_k$(indexA, r);
    this.set_rvwcgf_k$(indexB, l);
  };
  IntArrayList.prototype.removeAt_27zxwg_k$ = function (index_0, count_0) {
    if ((index_0 < 0 ? true : index_0 >= this._length_0) ? true : (index_0 + count_0 | 0) > this._length_0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this._data_5[index_0];
    if (count_0 > 0) {
      if (index_0 < (this._length_0 - count_0 | 0)) {
        arraycopy_0(this._data_5, index_0 + count_0 | 0, this._data_5, index_0, (this._length_0 - index_0 | 0) - count_0 | 0);
        Unit_getInstance();
      }var tmp0_this = this;
      tmp0_this._length_0 = tmp0_this._length_0 - count_0 | 0;
    }return out;
  };
  IntArrayList.prototype.toIntArray_0_k$ = function () {
    return copyOf_1(this._data_5, this._length_0);
  };
  IntArrayList.prototype.listIterator_ha5a7z_k$ = function (index_0) {
    return take_0(this._data_5, this._length_0).listIterator_ha5a7z_k$(index_0);
  };
  IntArrayList.prototype.hashCode = function () {
    return contentHashCode_10(this._data_5, 0, this._get_size__0_k$());
  };
  IntArrayList.prototype.equals = function (other) {
    if (other instanceof IntArrayList)
      return this._get_size__0_k$() === other._get_size__0_k$() ? contentEquals_13(this._data_5, other._data_5, 0, this._get_size__0_k$()) : false;
    else {
    }
    if (!(other == null) ? isInterface(other, List) : false)
      return equals_1(other, this);
    else {
    }
    return false;
  };
  IntArrayList.prototype.toString = function () {
    var tmp0_also_0 = StringBuilder_init_$Create$(2 + imul(5, this._get_size__0_k$()) | 0);
    tmp0_also_0.append_wi8o78_k$(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n_3 === 0)) {
          tmp0_also_0.append_uch40_k$(', ');
          Unit_getInstance();
        }tmp0_also_0.append_wi7j7l_k$(this.getAt_ha5a7z_k$(n_3));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp0_also_0.append_wi8o78_k$(new Char(93));
    Unit_getInstance();
    return tmp0_also_0.toString();
  };
  IntArrayList.$metadata$ = {
    simpleName: 'IntArrayList',
    kind: 'class',
    interfaces: [Collection]
  };
  function intArrayListOf(values_21) {
    return IntArrayList_init_$Create$_1(values_21.slice());
  }
  function doubleArrayListOf(values_21) {
    return DoubleArrayList_init_$Create$_1(values_21.slice());
  }
  function toIntArrayList(_this_) {
    return IntArrayList_init_$Create$_1(_this_.slice());
  }
  function toCaseInsensitiveMap(_this_) {
    var tmp0_also_0 = CaseInsensitiveStringMap_init_$Create$();
    tmp0_also_0.putAll_cox34w_k$(_this_);
    return tmp0_also_0;
  }
  function CaseInsensitiveStringMap_init_$Init$($this) {
    CaseInsensitiveStringMap.call($this, LinkedHashMap_init_$Create$(), LinkedHashMap_init_$Create$(), LinkedHashMap_init_$Create$());
    return $this;
  }
  function CaseInsensitiveStringMap_init_$Create$() {
    return CaseInsensitiveStringMap_init_$Init$(Object.create(CaseInsensitiveStringMap.prototype));
  }
  function CaseInsensitiveStringMap(mapOrig, lcToOrig, mapLC) {
    this._mapOrig = mapOrig;
    this._lcToOrig = lcToOrig;
    this._mapLC = mapLC;
  }
  CaseInsensitiveStringMap.prototype.isEmpty_0_k$ = function () {
    return this._mapOrig.isEmpty_0_k$();
  };
  CaseInsensitiveStringMap.prototype._get_entries__0_k$ = function () {
    return this._mapOrig._get_entries__0_k$();
  };
  CaseInsensitiveStringMap.prototype._get_size__0_k$ = function () {
    return this._mapOrig._get_size__0_k$();
  };
  CaseInsensitiveStringMap.prototype._get_values__0_k$ = function () {
    return this._mapOrig._get_values__0_k$();
  };
  CaseInsensitiveStringMap.prototype.containsKey_6wfw3l_k$ = function (key) {
    return this._mapLC.containsKey_2bw_k$(key.toLowerCase());
  };
  CaseInsensitiveStringMap.prototype.containsKey_2bw_k$ = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_6wfw3l_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  CaseInsensitiveStringMap.prototype.get_6wfw3l_k$ = function (key) {
    return this._mapLC.get_2bw_k$(key.toLowerCase());
  };
  CaseInsensitiveStringMap.prototype.get_2bw_k$ = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_6wfw3l_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  CaseInsensitiveStringMap.prototype.put_q4qpm4_k$ = function (key, value) {
    this.remove_6wfw3l_k$(key);
    Unit_getInstance();
    var tmp0_set_0 = this._mapOrig;
    tmp0_set_0.put_1q9pf_k$(key, value);
    Unit_getInstance();
    var tmp1_set_0 = this._lcToOrig;
    var tmp2_set_0 = key.toLowerCase();
    tmp1_set_0.put_1q9pf_k$(tmp2_set_0, key);
    Unit_getInstance();
    return this._mapLC.put_1q9pf_k$(key.toLowerCase(), value);
  };
  CaseInsensitiveStringMap.prototype.put_1q9pf_k$ = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.put_q4qpm4_k$(tmp, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  CaseInsensitiveStringMap.prototype.putAll_cox34w_k$ = function (from) {
    var tmp0_iterator = from._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var v = tmp0_iterator.next_0_k$();
      this.put_q4qpm4_k$(v._get_key__0_k$(), v._get_value__0_k$());
      Unit_getInstance();
    }
  };
  CaseInsensitiveStringMap.prototype.putAll_nn707j_k$ = function (from) {
    return this.putAll_cox34w_k$(from);
  };
  CaseInsensitiveStringMap.prototype.remove_6wfw3l_k$ = function (key) {
    var lkey = key.toLowerCase();
    var okey = this._lcToOrig.get_2bw_k$(lkey);
    var tmp0_remove_0 = this._mapOrig;
    (isInterface(tmp0_remove_0, MutableMap) ? tmp0_remove_0 : THROW_CCE()).remove_2bw_k$(okey);
    Unit_getInstance();
    var res = this._mapLC.remove_2bw_k$(lkey);
    this._lcToOrig.remove_2bw_k$(lkey);
    Unit_getInstance();
    return res;
  };
  CaseInsensitiveStringMap.prototype.remove_2bw_k$ = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.remove_6wfw3l_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  CaseInsensitiveStringMap.prototype.equals = function (other) {
    var tmp;
    if (other instanceof CaseInsensitiveStringMap) {
      tmp = equals_1(this._mapLC, other._mapLC);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  CaseInsensitiveStringMap.prototype.hashCode = function () {
    return hashCode(this._mapLC);
  };
  CaseInsensitiveStringMap.$metadata$ = {
    simpleName: 'CaseInsensitiveStringMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function CopyOnWriteFrozenMap() {
    var tmp = this;
    tmp._map_1 = new KdsAtomicRef(emptyMap());
  }
  CopyOnWriteFrozenMap.prototype._get_size__0_k$ = function () {
    return this._map_1._value_3._get_size__0_k$();
  };
  CopyOnWriteFrozenMap.prototype.containsKey_2bw_k$ = function (key) {
    return this._map_1._value_3.containsKey_2bw_k$(key);
  };
  CopyOnWriteFrozenMap.prototype.get_2bw_k$ = function (key) {
    return this._map_1._value_3.get_2bw_k$(key);
  };
  CopyOnWriteFrozenMap.prototype.isEmpty_0_k$ = function () {
    return this._map_1._value_3.isEmpty_0_k$();
  };
  CopyOnWriteFrozenMap.prototype._get_entries__0_k$ = function () {
    return asFakeMutable(this._map_1._value_3._get_entries__0_k$());
  };
  CopyOnWriteFrozenMap.prototype._get_values__0_k$ = function () {
    return asFakeMutable_0(this._map_1._value_3._get_values__0_k$());
  };
  CopyOnWriteFrozenMap.prototype.put_1q9pf_k$ = function (key, value) {
    var tmp0_also_0 = this._map_1._value_3.get_2bw_k$(key);
    this._map_1._value_3 = plus_3(this._map_1._value_3, mapOf_0(to(key, value)));
    return tmp0_also_0;
  };
  CopyOnWriteFrozenMap.prototype.putAll_nn707j_k$ = function (from) {
    this._map_1._value_3 = plus_3(this._map_1._value_3, from);
    return Unit_getInstance();
  };
  CopyOnWriteFrozenMap.prototype.remove_2bw_k$ = function (key) {
    var tmp0_also_0 = this._map_1._value_3.get_2bw_k$(key);
    this._map_1._value_3 = minus_1(this._map_1._value_3, key);
    return tmp0_also_0;
  };
  CopyOnWriteFrozenMap.$metadata$ = {
    simpleName: 'CopyOnWriteFrozenMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function _get_capacity_($this) {
    return $this._data_6.length;
  }
  function resizeIfRequiredFor($this, count_0) {
    if (($this._get_size__0_k$() + count_0 | 0) > _get_capacity_($this)) {
      var i = $this._data_6;
      var istart = $this.__start;
      var tmp = new Int32Array(imul($this._data_6.length, 2));
      var o = isIntArray(tmp) ? tmp : THROW_CCE();
      copyCyclic($this, i, istart, o, $this.__size);
      $this._data_6 = o;
      $this.__start = 0;
    }}
  function copyCyclic($this, i, istart, o, count_0) {
    var tmp0_min_0 = i.length - istart | 0;
    var size1 = Math.min(tmp0_min_0, count_0);
    var size2 = count_0 - size1 | 0;
    arraycopy_0(i, istart, o, 0, size1);
    Unit_getInstance();
    if (size2 > 0) {
      arraycopy_0(i, 0, o, size1, size2);
      Unit_getInstance();
    }}
  function internalIndex($this, index_0) {
    return umod($this.__start + index_0 | 0, _get_capacity_($this));
  }
  function _no_name_provided__52($that, this$0) {
    this._$that = $that;
    this._this$0_11 = this$0;
    this._index_6 = 0;
  }
  _no_name_provided__52.prototype.next_0_k$ = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_6;
    tmp0_this._index_6 = tmp1 + 1 | 0;
    return this._$that.get_ha5a7z_k$(tmp1);
  };
  _no_name_provided__52.prototype.hasNext_0_k$ = function () {
    return this._index_6 < this._this$0_11._get_size__0_k$();
  };
  _no_name_provided__52.prototype.remove_sv8swh_k$ = function () {
    var tmp0_this_2 = this;
    tmp0_this_2._index_6 = tmp0_this_2._index_6 - 1 | 0;
    this._this$0_11.removeAt_ha5a7z_k$(tmp0_this_2._index_6);
    return Unit_getInstance();
  };
  _no_name_provided__52.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function IntDeque(initialCapacity) {
    this.__start = 0;
    this.__size = 0;
    var tmp = this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp._data_6 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
  IntDeque.prototype._get_size__0_k$ = function () {
    return this.__size;
  };
  IntDeque.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  IntDeque.prototype.addAll_fe038o_k$ = function (items) {
    resizeIfRequiredFor(this, count(items));
    var tmp0_iterator_2 = items.iterator_0_k$();
    while (tmp0_iterator_2.hasNext_0_k$()) {
      var i_3 = tmp0_iterator_2.next_0_k$();
      this.addLast_majfzk_k$(i_3);
    }
    return Unit_getInstance();
  };
  IntDeque.prototype.addLast_majfzk_k$ = function (item) {
    resizeIfRequiredFor(this, 1);
    this._data_6[umod(this.__start + this._get_size__0_k$() | 0, _get_capacity_(this))] = item;
    var tmp0_this = this;
    var tmp1 = tmp0_this.__size;
    tmp0_this.__size = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  IntDeque.prototype.removeFirst_0_k$ = function () {
    if (this.__size <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var tmp0_apply_0 = this._get_first__0_k$();
    this.__start = umod(this.__start + 1 | 0, _get_capacity_(this));
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2.__size;
    tmp0_this_2.__size = tmp1_3 - 1 | 0;
    Unit_getInstance();
    return tmp0_apply_0;
  };
  IntDeque.prototype.removeLast_0_k$ = function () {
    if (this.__size <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var tmp0_apply_0 = this._get_last__0_k$();
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2.__size;
    tmp0_this_2.__size = tmp1_3 - 1 | 0;
    Unit_getInstance();
    return tmp0_apply_0;
  };
  IntDeque.prototype.removeAt_ha5a7z_k$ = function (index_0) {
    if (index_0 < 0 ? true : index_0 >= this._get_size__0_k$())
      throw IndexOutOfBoundsException_init_$Create$();
    if (index_0 === 0)
      return this.removeFirst_0_k$();
    if (index_0 === (this._get_size__0_k$() - 1 | 0))
      return this.removeLast_0_k$();
    var old = this.get_ha5a7z_k$(index_0);
    if (index_0 < (this._get_size__0_k$() / 2 | 0)) {
      var inductionVariable = index_0;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.set_rvwcgf_k$(n, this.get_ha5a7z_k$(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.__start = umod(this.__start + 1 | 0, _get_capacity_(this));
    } else {
      var inductionVariable_0 = index_0;
      var last_1 = this._get_size__0_k$() - 1 | 0;
      if (inductionVariable_0 < last_1)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.set_rvwcgf_k$(n_0, this.get_ha5a7z_k$(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last_1);
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this.__size;
    tmp2_this.__size = tmp3 - 1 | 0;
    Unit_getInstance();
    return old;
  };
  IntDeque.prototype.add_ha5a7z_k$ = function (element) {
    this.addLast_majfzk_k$(element);
    return true;
  };
  IntDeque.prototype.add_2bq_k$ = function (element) {
    return this.add_ha5a7z_k$((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  IntDeque.prototype.addAll_envxgl_k$ = function (elements) {
    this.addAll_fe038o_k$(isInterface(elements, Iterable) ? elements : THROW_CCE());
    return true;
  };
  IntDeque.prototype.addAll_dxd4eo_k$ = function (elements) {
    return this.addAll_envxgl_k$(elements);
  };
  IntDeque.prototype.remove_ha5a7z_k$ = function (element) {
    var index_0 = this.indexOf_ha5a7z_k$(element);
    if (index_0 >= 0) {
      this.removeAt_ha5a7z_k$(index_0);
      Unit_getInstance();
    }return index_0 >= 0;
  };
  IntDeque.prototype.remove_2bq_k$ = function (element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    else {
    }
    return this.remove_ha5a7z_k$((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  IntDeque.prototype._get_first__0_k$ = function () {
    return this._data_6[this.__start];
  };
  IntDeque.prototype._get_last__0_k$ = function () {
    return this._data_6[internalIndex(this, this._get_size__0_k$() - 1 | 0)];
  };
  IntDeque.prototype.set_rvwcgf_k$ = function (index_0, value) {
    return this._data_6[internalIndex(this, index_0)] = value;
  };
  IntDeque.prototype.get_ha5a7z_k$ = function (index_0) {
    return this._data_6[internalIndex(this, index_0)];
  };
  IntDeque.prototype.contains_ha5a7z_k$ = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = until(0, this._get_size__0_k$());
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var inductionVariable = tmp0_any_0._get_first__0_k$();
      var last_1 = tmp0_any_0._get_last__0_k$();
      if (inductionVariable <= last_1)
        do {
          var element_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.get_ha5a7z_k$(element_2) === element) {
            tmp$ret$0 = true;
            break l$ret$1;
          } else {
          }
        }
         while (!(element_2 === last_1));
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  IntDeque.prototype.contains_2bq_k$ = function (element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    else {
    }
    return this.contains_ha5a7z_k$((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  IntDeque.prototype.indexOf_ha5a7z_k$ = function (element) {
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.get_ha5a7z_k$(n) === element)
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  };
  IntDeque.prototype.containsAll_envxgl_k$ = function (elements) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator_1_2 = elements.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(to(item_2_3, 0));
      Unit_getInstance();
    }
    var emap = toLinkedMap(tmp0_mapTo_0_1);
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.get_ha5a7z_k$(it);
        if ((isInterface(emap, Map_0) ? emap : THROW_CCE()).containsKey_2bw_k$(e)) {
          emap.put_1q9pf_k$(e, 1);
          Unit_getInstance();
        } else {
        }
      }
       while (inductionVariable < last_1);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = emap._get_values__0_k$();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!(element_2 === 1)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  IntDeque.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_envxgl_k$(elements);
  };
  IntDeque.prototype.iterator_0_k$ = function () {
    var that = this;
    return new _no_name_provided__52(that, this);
  };
  IntDeque.prototype.hashCode = function () {
    var tmp1_contentHashCode_0 = this._get_size__0_k$();
    var result_1 = 1;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_contentHashCode_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result_1);
        var tmp0_hashCode_0 = this.get_ha5a7z_k$(n_3);
        var tmp0_safe_receiver_2 = tmp0_hashCode_0;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
        result_1 = tmp + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
      }
       while (inductionVariable < tmp1_contentHashCode_0);
    return result_1;
  };
  IntDeque.prototype.equals = function (other) {
    if (!(other instanceof IntDeque))
      return false;
    else {
    }
    if (!(other._get_size__0_k$() === this._get_size__0_k$()))
      return false;
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.get_ha5a7z_k$(n) === other.get_ha5a7z_k$(n)))
          return false;
      }
       while (inductionVariable < last_1);
    return true;
  };
  IntDeque.prototype.toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.append_wi8o78_k$(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.append_wi7j7l_k$(this.get_ha5a7z_k$(n));
        Unit_getInstance();
        if (!(n === (this._get_size__0_k$() - 1 | 0))) {
          sb.append_uch40_k$(', ');
          Unit_getInstance();
        }}
       while (inductionVariable < last_1);
    sb.append_wi8o78_k$(new Char(93));
    Unit_getInstance();
    return sb.toString();
  };
  IntDeque.$metadata$ = {
    simpleName: 'IntDeque',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function _get_capacity__0($this) {
    return $this._data_7.length;
  }
  function TGenDeque_init_$Init$($this) {
    TGenDeque.call($this, 16);
    return $this;
  }
  function TGenDeque_init_$Create$() {
    return TGenDeque_init_$Init$(Object.create(TGenDeque.prototype));
  }
  function resizeIfRequiredFor_0($this, count_0) {
    if (($this._get_size__0_k$() + count_0 | 0) > _get_capacity__0($this)) {
      var i = $this._data_7;
      var istart = $this.__start_0;
      var tmp0_arrayOfNulls_0 = imul($this._data_7.length, 2);
      var tmp = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
      var o = isArray(tmp) ? tmp : THROW_CCE();
      copyCyclic_0($this, i, istart, o, $this.__size_0);
      $this._data_7 = o;
      $this.__start_0 = 0;
    }}
  function copyCyclic_0($this, i, istart, o, count_0) {
    var tmp0_min_0 = i.length - istart | 0;
    var size1 = Math.min(tmp0_min_0, count_0);
    var size2 = count_0 - size1 | 0;
    arraycopy_1(i, istart, o, 0, size1);
    Unit_getInstance();
    if (size2 > 0) {
      arraycopy_1(i, 0, o, size1, size2);
      Unit_getInstance();
    }}
  function internalIndex_0($this, index_0) {
    return umod($this.__start_0 + index_0 | 0, _get_capacity__0($this));
  }
  function _no_name_provided__53($that, this$0) {
    this._$that_0 = $that;
    this._this$0_12 = this$0;
    this._index_7 = 0;
  }
  _no_name_provided__53.prototype.next_0_k$ = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_7;
    tmp0_this._index_7 = tmp1 + 1 | 0;
    return this._$that_0.get_ha5a7z_k$(tmp1);
  };
  _no_name_provided__53.prototype.hasNext_0_k$ = function () {
    return this._index_7 < this._this$0_12._get_size__0_k$();
  };
  _no_name_provided__53.prototype.remove_sv8swh_k$ = function () {
    var tmp0_this_2 = this;
    tmp0_this_2._index_7 = tmp0_this_2._index_7 - 1 | 0;
    this._this$0_12.removeAt_ha5a7z_k$(tmp0_this_2._index_7);
    return Unit_getInstance();
  };
  _no_name_provided__53.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function TGenDeque(initialCapacity) {
    this.__start_0 = 0;
    this.__size_0 = 0;
    var tmp = this;
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp._data_7 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
  TGenDeque.prototype._get_size__0_k$ = function () {
    return this.__size_0;
  };
  TGenDeque.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  TGenDeque.prototype.addAll_8gvnu6_k$ = function (items) {
    resizeIfRequiredFor_0(this, count(items));
    var tmp0_iterator_2 = items.iterator_0_k$();
    while (tmp0_iterator_2.hasNext_0_k$()) {
      var i_3 = tmp0_iterator_2.next_0_k$();
      this.addLast_xoeh3q_k$(i_3);
    }
    return Unit_getInstance();
  };
  TGenDeque.prototype.addLast_xoeh3q_k$ = function (item) {
    resizeIfRequiredFor_0(this, 1);
    this._data_7[umod(this.__start_0 + this._get_size__0_k$() | 0, _get_capacity__0(this))] = item;
    var tmp0_this = this;
    var tmp1 = tmp0_this.__size_0;
    tmp0_this.__size_0 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  TGenDeque.prototype.removeFirst_0_k$ = function () {
    if (this.__size_0 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var tmp0_apply_0 = this._get_first__0_k$();
    this.__start_0 = umod(this.__start_0 + 1 | 0, _get_capacity__0(this));
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2.__size_0;
    tmp0_this_2.__size_0 = tmp1_3 - 1 | 0;
    Unit_getInstance();
    return tmp0_apply_0;
  };
  TGenDeque.prototype.removeLast_0_k$ = function () {
    if (this.__size_0 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var tmp0_apply_0 = this._get_last__0_k$();
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2.__size_0;
    tmp0_this_2.__size_0 = tmp1_3 - 1 | 0;
    Unit_getInstance();
    return tmp0_apply_0;
  };
  TGenDeque.prototype.removeAt_ha5a7z_k$ = function (index_0) {
    if (index_0 < 0 ? true : index_0 >= this._get_size__0_k$())
      throw IndexOutOfBoundsException_init_$Create$();
    if (index_0 === 0)
      return this.removeFirst_0_k$();
    if (index_0 === (this._get_size__0_k$() - 1 | 0))
      return this.removeLast_0_k$();
    var old = this.get_ha5a7z_k$(index_0);
    if (index_0 < (this._get_size__0_k$() / 2 | 0)) {
      var inductionVariable = index_0;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.set_bkxjm1_k$(n, this.get_ha5a7z_k$(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.__start_0 = umod(this.__start_0 + 1 | 0, _get_capacity__0(this));
    } else {
      var inductionVariable_0 = index_0;
      var last_1 = this._get_size__0_k$() - 1 | 0;
      if (inductionVariable_0 < last_1)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.set_bkxjm1_k$(n_0, this.get_ha5a7z_k$(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last_1);
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this.__size_0;
    tmp2_this.__size_0 = tmp3 - 1 | 0;
    Unit_getInstance();
    return old;
  };
  TGenDeque.prototype.add_1hrmez_k$ = function (element) {
    this.addLast_xoeh3q_k$(element);
    return true;
  };
  TGenDeque.prototype.add_2bq_k$ = function (element) {
    return this.add_1hrmez_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenDeque.prototype.addAll_1asxxx_k$ = function (elements) {
    this.addAll_8gvnu6_k$(isInterface(elements, Iterable) ? elements : THROW_CCE());
    return true;
  };
  TGenDeque.prototype.addAll_dxd4eo_k$ = function (elements) {
    return this.addAll_1asxxx_k$(elements);
  };
  TGenDeque.prototype.remove_1hrmez_k$ = function (element) {
    var index_0 = this.indexOf_1hrmez_k$(element);
    if (index_0 >= 0) {
      this.removeAt_ha5a7z_k$(index_0);
      Unit_getInstance();
    }return index_0 >= 0;
  };
  TGenDeque.prototype.remove_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_1hrmez_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenDeque.prototype._get_first__0_k$ = function () {
    return this._data_7[this.__start_0];
  };
  TGenDeque.prototype._get_last__0_k$ = function () {
    return this._data_7[internalIndex_0(this, this._get_size__0_k$() - 1 | 0)];
  };
  TGenDeque.prototype.set_bkxjm1_k$ = function (index_0, value) {
    return this._data_7[internalIndex_0(this, index_0)] = value;
  };
  TGenDeque.prototype.get_ha5a7z_k$ = function (index_0) {
    return this._data_7[internalIndex_0(this, index_0)];
  };
  TGenDeque.prototype.contains_1hrmez_k$ = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = until(0, this._get_size__0_k$());
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var inductionVariable = tmp0_any_0._get_first__0_k$();
      var last_1 = tmp0_any_0._get_last__0_k$();
      if (inductionVariable <= last_1)
        do {
          var element_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals_1(this.get_ha5a7z_k$(element_2), element)) {
            tmp$ret$0 = true;
            break l$ret$1;
          } else {
          }
        }
         while (!(element_2 === last_1));
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  TGenDeque.prototype.contains_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_1hrmez_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenDeque.prototype.indexOf_1hrmez_k$ = function (element) {
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this.get_ha5a7z_k$(n), element))
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  };
  TGenDeque.prototype.containsAll_1asxxx_k$ = function (elements) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator_1_2 = elements.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(to(item_2_3, 0));
      Unit_getInstance();
    }
    var emap = toLinkedMap(tmp0_mapTo_0_1);
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.get_ha5a7z_k$(it);
        if ((isInterface(emap, Map_0) ? emap : THROW_CCE()).containsKey_2bw_k$(e)) {
          emap.put_1q9pf_k$(e, 1);
          Unit_getInstance();
        } else {
        }
      }
       while (inductionVariable < last_1);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = emap._get_values__0_k$();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!(element_2 === 1)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  TGenDeque.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_1asxxx_k$(elements);
  };
  TGenDeque.prototype.iterator_0_k$ = function () {
    var that = this;
    return new _no_name_provided__53(that, this);
  };
  TGenDeque.prototype.hashCode = function () {
    var tmp1_contentHashCode_0 = this._get_size__0_k$();
    var result_1 = 1;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_contentHashCode_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result_1);
        var tmp0_hashCode_0 = this.get_ha5a7z_k$(n_3);
        var tmp0_safe_receiver_2 = tmp0_hashCode_0;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
        result_1 = tmp + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
      }
       while (inductionVariable < tmp1_contentHashCode_0);
    return result_1;
  };
  TGenDeque.prototype.equals = function (other) {
    if (!(other instanceof TGenDeque))
      return false;
    else {
    }
    if (!(other._get_size__0_k$() === this._get_size__0_k$()))
      return false;
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals_1(this.get_ha5a7z_k$(n), other.get_ha5a7z_k$(n)))
          return false;
      }
       while (inductionVariable < last_1);
    return true;
  };
  TGenDeque.prototype.toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.append_wi8o78_k$(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.append_wi7j7l_k$(this.get_ha5a7z_k$(n));
        Unit_getInstance();
        if (!(n === (this._get_size__0_k$() - 1 | 0))) {
          sb.append_uch40_k$(', ');
          Unit_getInstance();
        }}
       while (inductionVariable < last_1);
    sb.append_wi8o78_k$(new Char(93));
    Unit_getInstance();
    return sb.toString();
  };
  TGenDeque.$metadata$ = {
    simpleName: 'TGenDeque',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function fastArrayListOf(values_21) {
    var tmp0_also_0 = FastArrayList_init_$Create$_0(values_21.length);
    addAll_0(tmp0_also_0, values_21);
    Unit_getInstance();
    return tmp0_also_0;
  }
  function toFastList(_this_) {
    var tmp0_also_0 = FastArrayList_init_$Create$_0(_this_._get_size__0_k$());
    var n_1_2 = 0;
    while (n_1_2 < _this_._get_size__0_k$()) {
      var tmp0_2_4 = n_1_2;
      n_1_2 = tmp0_2_4 + 1 | 0;
      var tmp0__anonymous__3_3 = _this_.get_ha5a7z_k$(tmp0_2_4);
      tmp0_also_0.add_2bq_k$(tmp0__anonymous__3_3);
      Unit_getInstance();
    }
    return tmp0_also_0;
  }
  function toFastList_0(_this_) {
    var tmp0_also_0 = FastArrayList_init_$Create$_0(_this_.length);
    var n_1_2 = 0;
    while (n_1_2 < _this_.length) {
      var tmp0_2_4 = n_1_2;
      n_1_2 = tmp0_2_4 + 1 | 0;
      var tmp0__anonymous__3_3 = _this_[tmp0_2_4];
      tmp0_also_0.add_2bq_k$(tmp0__anonymous__3_3);
      Unit_getInstance();
    }
    return tmp0_also_0;
  }
  function getAndRemove(_this_, key) {
    var tmp0_also_0 = get(_this_, key);
    remove_0(_this_, key);
    return tmp0_also_0;
  }
  function GenericListIterator(list, iindex) {
    this._list = list;
    this._iindex = iindex;
    var containsUpper = this._list._get_size__0_k$();
    var containsArg = this._iindex;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException_init_$Create$_0('' + this._iindex);
    else {
    }
    this._index_8 = this._iindex;
  }
  GenericListIterator.prototype.hasNext_0_k$ = function () {
    return this._index_8 < this._list._get_size__0_k$();
  };
  GenericListIterator.prototype.next_0_k$ = function () {
    if (!this.hasNext_0_k$())
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_8;
    tmp0_this._index_8 = tmp1 + 1 | 0;
    return this._list.get_ha5a7z_k$(tmp1);
  };
  GenericListIterator.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals_1(this._list, other._list);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._index_8 === other._index_8;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  GenericListIterator.prototype.hashCode = function () {
    return hashCode(this._list) + this._index_8 | 0;
  };
  GenericListIterator.$metadata$ = {
    simpleName: 'GenericListIterator',
    kind: 'class',
    interfaces: [ListIterator]
  };
  function IntIntMap_init_$Init$(initialCapacity, loadFactor, $this) {
    var tmp0_max_0 = ilog2Ceil(initialCapacity);
    IntIntMap.call($this, Math.max(4, tmp0_max_0), loadFactor, true);
    return $this;
  }
  function IntIntMap_init_$Init$_0(initialCapacity, loadFactor, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialCapacity = 16;
    if (!(($mask0 & 2) === 0))
      loadFactor = 0.75;
    IntIntMap_init_$Init$(initialCapacity, loadFactor, $this);
    return $this;
  }
  function IntIntMap_init_$Create$(initialCapacity, loadFactor, $mask0, $marker) {
    return IntIntMap_init_$Init$_0(initialCapacity, loadFactor, $mask0, $marker, Object.create(IntIntMap.prototype));
  }
  function Companion_22() {
    Companion_instance_21 = this;
    this._EOF = 2147483646;
    this._ZERO_INDEX = 2147483647;
    this._EMPTY_2 = 0;
  }
  Companion_22.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_22();
    return Companion_instance_21;
  }
  function _get_stashStart_($this) {
    return $this.__keys_1.length - $this._stashSize | 0;
  }
  function grow($this) {
    var inc = $this._nbits < 20 ? 3 : 1;
    var newnbits = $this._nbits + inc | 0;
    var new_0 = new IntIntMap(newnbits, $this._loadFactor, true);
    var inductionVariable = 0;
    var last_1 = $this.__keys_1.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = $this.__keys_1[n];
        Companion_getInstance_21();
        if (!(k === 0)) {
          new_0.set_27zxwg_k$(k, $this.__values_1[n]);
          Unit_getInstance();
        } else {
        }
      }
       while (inductionVariable <= last_1);
    $this._nbits = new_0._nbits;
    $this._capacity = new_0._capacity;
    $this._mask = new_0._mask;
    $this._stashSize = new_0._stashSize;
    $this.__keys_1 = new_0.__keys_1;
    $this.__values_1 = new_0.__values_1;
    $this._growSize = new_0._growSize;
  }
  function growStash($this) {
    $this._stashSize = imul($this._stashSize, 2);
    $this.__keys_1 = copyOf_1($this.__keys_1, $this._get_backSize__0_k$());
    $this.__values_1 = copyOf_1($this.__values_1, $this._get_backSize__0_k$());
  }
  function _getKeyIndex($this, key) {
    if (key === 0) {
      var tmp;
      if ($this._hasZero) {
        Companion_getInstance_21();
        tmp = 2147483647;
      } else {
        tmp = -1;
      }
      return tmp;
    }var index1 = hash1($this, key);
    if ($this.__keys_1[index1] === key)
      return index1;
    var index2 = hash2($this, key);
    if ($this.__keys_1[index2] === key)
      return index2;
    var index3 = hash3($this, key);
    if ($this.__keys_1[index3] === key)
      return index3;
    var inductionVariable = _get_stashStart_($this);
    var last_1 = $this.__keys_1.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ($this.__keys_1[n] === key)
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  }
  function setEmptySlot($this, index_0, key, value) {
    var tmp = $this.__keys_1[index_0];
    Companion_getInstance_21();
    if (!(tmp === 0))
      throw IllegalStateException_init_$Create$();
    else {
    }
    $this.__keys_1[index_0] = key;
    $this.__values_1[index_0] = value;
    var tmp0_this = $this;
    var tmp1 = tmp0_this._size_0;
    tmp0_this._size_0 = tmp1 + 1 | 0;
    Unit_getInstance();
    return 0;
  }
  function hash1($this, key) {
    return _hash1(key, $this._mask);
  }
  function hash2($this, key) {
    return _hash2(key, $this._mask);
  }
  function hash3($this, key) {
    return _hash3(key, $this._mask);
  }
  function IntIntMap(nbits, loadFactor, dummy) {
    Companion_getInstance_21();
    this._nbits = nbits;
    this._loadFactor = loadFactor;
    this._capacity = 1 << this._nbits;
    this._hasZero = false;
    this._zeroValue = 0;
    this._mask = this._capacity - 1 | 0;
    this._stashSize = 1 + imul(this._nbits, this._nbits) | 0;
    this.__keys_1 = new Int32Array(this._get_backSize__0_k$());
    this.__values_1 = new Int32Array(this._get_backSize__0_k$());
    this._growSize = numberToInt(this._capacity * this._loadFactor);
    this._size_0 = 0;
  }
  IntIntMap.prototype._get_backSize__0_k$ = function () {
    return this._capacity + this._stashSize | 0;
  };
  IntIntMap.prototype.contains_ha5a7z_k$ = function (key) {
    return _getKeyIndex(this, key) >= 0;
  };
  IntIntMap.prototype.get_ha5a7z_k$ = function (key) {
    var index_0 = _getKeyIndex(this, key);
    if (index_0 < 0)
      return 0;
    Companion_getInstance_21();
    if (index_0 === 2147483647)
      return this._zeroValue;
    else {
    }
    return this.__values_1[index_0];
  };
  IntIntMap.prototype.set_27zxwg_k$ = function (key, value) {
    retry: while (true) {
      var index_0 = _getKeyIndex(this, key);
      if (index_0 < 0) {
        if (key === 0) {
          this._hasZero = true;
          this._zeroValue = value;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size_0;
          tmp0_this._size_0 = tmp1 + 1 | 0;
          Unit_getInstance();
          return 0;
        }if (this._size_0 >= this._growSize)
          grow(this);
        var index1 = hash1(this, key);
        var tmp = this.__keys_1[index1];
        Companion_getInstance_21();
        if (tmp === 0)
          return setEmptySlot(this, index1, key, value);
        else {
        }
        var index2 = hash2(this, key);
        var tmp_0 = this.__keys_1[index2];
        Companion_getInstance_21();
        if (tmp_0 === 0)
          return setEmptySlot(this, index2, key, value);
        else {
        }
        var index3 = hash3(this, key);
        var tmp_1 = this.__keys_1[index3];
        Companion_getInstance_21();
        if (tmp_1 === 0)
          return setEmptySlot(this, index3, key, value);
        else {
        }
        var inductionVariable = _get_stashStart_(this);
        var last_1 = this.__keys_1.length;
        if (inductionVariable < last_1)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_2 = this.__keys_1[n];
            Companion_getInstance_21();
            if (tmp_2 === 0)
              return setEmptySlot(this, n, key, value);
            else {
            }
          }
           while (inductionVariable < last_1);
        if (this._stashSize > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else {
        Companion_getInstance_21();
        if (index_0 === 2147483647) {
          var tmp0_apply_0 = this._zeroValue;
          this._zeroValue = value;
          return tmp0_apply_0;
        } else {
          {
            var tmp1_apply_0 = this.__values_1[index_0];
            this.__values_1[index_0] = value;
            return tmp1_apply_0;
          }
        }
      }
    }
  };
  IntIntMap.prototype.nextNonEmptyIndex_pb76ll_k$ = function (keys, offset_0) {
    var inductionVariable = offset_0;
    var last_1 = keys.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = keys[n];
        Companion_getInstance_21();
        if (!(tmp === 0))
          return n;
        else {
        }
      }
       while (inductionVariable < last_1);
    Companion_getInstance_21();
    return 2147483646;
  };
  IntIntMap.prototype.equals = function (other) {
    if (!(other instanceof IntMap))
      return false;
    else {
    }
    var tmp;
    if (this._hasZero) {
      Companion_getInstance_22();
      tmp = 2147483647;
    } else {
      tmp = this.nextNonEmptyIndex_pb76ll_k$(this.__keys_1, 0);
    }
    var index_1_1 = tmp;
    $l$break: while (true) {
      var tmp_0 = index_1_1;
      Companion_getInstance_22();
      if (!!(tmp_0 === 2147483646)) {
        break $l$break;
      }var tmp0_subject_2_3 = index_1_1;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_22();
      if (tmp0_subject_2_3 === 2147483647) {
        tmp_2 = true;
      } else {
        {
          Companion_getInstance_22();
          tmp_2 = tmp0_subject_2_3 === 2147483646;
        }
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        {
          tmp_1 = this.__keys_1[index_1_1];
        }
      }
      var tmp0__anonymous__3_2 = tmp_1;
      var tmp0__anonymous__4 = this.get_ha5a7z_k$(tmp0__anonymous__3_2);
      if (!equals_1(other.get_ha5a7z_k$(tmp0__anonymous__3_2), tmp0__anonymous__4))
        return false;
      var tmp_3 = this.__keys_1;
      var tmp_4;
      var tmp_5 = index_1_1;
      Companion_getInstance_22();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        {
          tmp_4 = index_1_1 + 1 | 0;
        }
      }
      index_1_1 = this.nextNonEmptyIndex_pb76ll_k$(tmp_3, tmp_4);
    }
    return true;
  };
  IntIntMap.prototype.hashCode = function () {
    var out = 0;
    var tmp;
    if (this._hasZero) {
      Companion_getInstance_22();
      tmp = 2147483647;
    } else {
      tmp = this.nextNonEmptyIndex_pb76ll_k$(this.__keys_1, 0);
    }
    var index_1_1 = tmp;
    $l$break: while (true) {
      var tmp_0 = index_1_1;
      Companion_getInstance_22();
      if (!!(tmp_0 === 2147483646)) {
        break $l$break;
      }var tmp0_subject_2_3 = index_1_1;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_22();
      if (tmp0_subject_2_3 === 2147483647) {
        tmp_2 = true;
      } else {
        {
          Companion_getInstance_22();
          tmp_2 = tmp0_subject_2_3 === 2147483646;
        }
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        {
          tmp_1 = this.__keys_1[index_1_1];
        }
      }
      var tmp0__anonymous__3_2 = tmp_1;
      var tmp0__anonymous__4 = this.get_ha5a7z_k$(tmp0__anonymous__3_2);
      out = out + (tmp0__anonymous__3_2 + tmp0__anonymous__4 | 0) | 0;
      var tmp_3 = this.__keys_1;
      var tmp_4;
      var tmp_5 = index_1_1;
      Companion_getInstance_22();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        {
          tmp_4 = index_1_1 + 1 | 0;
        }
      }
      index_1_1 = this.nextNonEmptyIndex_pb76ll_k$(tmp_3, tmp_4);
    }
    return out;
  };
  IntIntMap.$metadata$ = {
    simpleName: 'IntIntMap',
    kind: 'class',
    interfaces: []
  };
  function currentKey($this) {
    var tmp0_subject = $this._index_9;
    var tmp;
    var tmp_0;
    Companion_getInstance_22();
    if (tmp0_subject === 2147483647) {
      tmp_0 = true;
    } else {
      {
        Companion_getInstance_22();
        tmp_0 = tmp0_subject === 2147483646;
      }
    }
    if (tmp_0) {
      tmp = 0;
    } else {
      {
        tmp = $this._map_2.__keys_2[$this._index_9];
      }
    }
    return tmp;
  }
  function currentValue($this) {
    var tmp0_subject = $this._index_9;
    var tmp;
    Companion_getInstance_22();
    if (tmp0_subject === 2147483647) {
      tmp = $this._map_2._zeroValue_0;
    } else {
      Companion_getInstance_22();
      if (tmp0_subject === 2147483646) {
        tmp = null;
      } else {
        {
          tmp = $this._map_2.__values_2[$this._index_9];
        }
      }
    }
    return tmp;
  }
  function nextNonEmptyIndex($this, keys, offset_0) {
    var inductionVariable = offset_0;
    var last_1 = keys.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = keys[n];
        Companion_getInstance_22();
        if (!(tmp === 0))
          return n;
        else {
        }
      }
       while (inductionVariable < last_1);
    Companion_getInstance_22();
    return 2147483646;
  }
  function next($this) {
    var tmp = $this._index_9;
    Companion_getInstance_22();
    if (!(tmp === 2147483646)) {
      var tmp_0 = $this;
      var tmp_1 = $this._map_2.__keys_2;
      var tmp_2;
      var tmp_3 = $this._index_9;
      Companion_getInstance_22();
      if (tmp_3 === 2147483647) {
        tmp_2 = 0;
      } else {
        {
          tmp_2 = $this._index_9 + 1 | 0;
        }
      }
      tmp_0._index_9 = nextNonEmptyIndex($this, tmp_1, tmp_2);
    } else {
    }
  }
  function _no_name_provided__54($tmp0_let_0_7) {
    this._$tmp0_let_0_7 = $tmp0_let_0_7;
  }
  _no_name_provided__54.prototype.invoke_0_k$ = function () {
    return this._$tmp0_let_0_7.hasNext_0_k$();
  };
  _no_name_provided__54.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__55($tmp0_let_0_7) {
    this._$tmp0_let_0_7_0 = $tmp0_let_0_7;
  }
  _no_name_provided__55.prototype.invoke_0_k$ = function () {
    return this._$tmp0_let_0_7_0.nextKey_0_k$();
  };
  _no_name_provided__55.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__56($tmp0_let_0_7) {
    this._$tmp0_let_0_7_1 = $tmp0_let_0_7;
  }
  _no_name_provided__56.prototype.invoke_0_k$ = function () {
    return this._$tmp0_let_0_7_1.hasNext_0_k$();
  };
  _no_name_provided__56.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__57($tmp0_let_0_7) {
    this._$tmp0_let_0_7_2 = $tmp0_let_0_7;
  }
  _no_name_provided__57.prototype.invoke_0_k$ = function () {
    return this._$tmp0_let_0_7_2.nextValue_0_k$();
  };
  _no_name_provided__57.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function IntMap_init_$Init$(initialCapacity, loadFactor, $this) {
    var tmp0_max_0 = ilog2Ceil(initialCapacity);
    IntMap.call($this, Math.max(4, tmp0_max_0), loadFactor, true);
    return $this;
  }
  function IntMap_init_$Init$_0(initialCapacity, loadFactor, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialCapacity = 16;
    if (!(($mask0 & 2) === 0))
      loadFactor = 0.75;
    IntMap_init_$Init$(initialCapacity, loadFactor, $this);
    return $this;
  }
  function IntMap_init_$Create$(initialCapacity, loadFactor, $mask0, $marker) {
    return IntMap_init_$Init$_0(initialCapacity, loadFactor, $mask0, $marker, Object.create(IntMap.prototype));
  }
  function Companion_23() {
    Companion_instance_22 = this;
    this._EOF_0 = 2147483646;
    this._ZERO_INDEX_0 = 2147483647;
    this._EMPTY_3 = 0;
  }
  Companion_23.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_23();
    return Companion_instance_22;
  }
  function _get_stashStart__0($this) {
    return $this.__keys_2.length - $this._stashSize_0 | 0;
  }
  function grow_0($this) {
    var inc = $this._nbits_0 < 20 ? 3 : 1;
    var newnbits = $this._nbits_0 + inc | 0;
    var new_0 = new IntMap(newnbits, $this._loadFactor_0, true);
    var inductionVariable = 0;
    var last_1 = $this.__keys_2.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = $this.__keys_2[n];
        Companion_getInstance_22();
        if (!(k === 0)) {
          new_0.set_bq5tp3_k$(k, $this.__values_2[n]);
          Unit_getInstance();
        } else {
        }
      }
       while (inductionVariable <= last_1);
    $this._nbits_0 = new_0._nbits_0;
    $this._capacity_0 = new_0._capacity_0;
    $this._mask_0 = new_0._mask_0;
    $this._stashSize_0 = new_0._stashSize_0;
    $this.__keys_2 = new_0.__keys_2;
    $this.__values_2 = new_0.__values_2;
    $this._growSize_0 = new_0._growSize_0;
  }
  function growStash_0($this) {
    $this._stashSize_0 = imul($this._stashSize_0, 2);
    $this.__keys_2 = copyOf_1($this.__keys_2, $this._get_backSize__0_k$());
    $this.__values_2 = copyOf_0($this.__values_2, $this._get_backSize__0_k$());
  }
  function _getKeyIndex_0($this, key) {
    if (key === 0) {
      var tmp;
      if ($this._hasZero_0) {
        Companion_getInstance_22();
        tmp = 2147483647;
      } else {
        tmp = -1;
      }
      return tmp;
    }var index1 = hash1_0($this, key);
    if ($this.__keys_2[index1] === key)
      return index1;
    var index2 = hash2_0($this, key);
    if ($this.__keys_2[index2] === key)
      return index2;
    var index3 = hash3_0($this, key);
    if ($this.__keys_2[index3] === key)
      return index3;
    var inductionVariable = _get_stashStart__0($this);
    var last_1 = $this.__keys_2.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ($this.__keys_2[n] === key)
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  }
  function setEmptySlot_0($this, index_0, key, value) {
    var tmp = $this.__keys_2[index_0];
    Companion_getInstance_22();
    if (!(tmp === 0))
      throw IllegalStateException_init_$Create$();
    else {
    }
    $this.__keys_2[index_0] = key;
    $this.__values_2[index_0] = value;
    var tmp0_this = $this;
    var tmp1 = tmp0_this._size_1;
    tmp0_this._size_1 = tmp1 + 1 | 0;
    Unit_getInstance();
    return null;
  }
  function hash1_0($this, key) {
    return _hash1(key, $this._mask_0);
  }
  function hash2_0($this, key) {
    return _hash2(key, $this._mask_0);
  }
  function hash3_0($this, key) {
    return _hash3(key, $this._mask_0);
  }
  function Entry_0(key, value) {
    this._key_1 = key;
    this._value_2 = value;
  }
  Entry_0.prototype.toString = function () {
    return '' + 'Entry(key=' + this._key_1 + ', value=' + this._value_2 + ')';
  };
  Entry_0.prototype.hashCode = function () {
    var result = this._key_1;
    result = imul(result, 31) + (this._value_2 == null ? 0 : hashCode(this._value_2)) | 0;
    return result;
  };
  Entry_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!(this._key_1 === tmp0_other_with_cast._key_1))
      return false;
    if (!equals_1(this._value_2, tmp0_other_with_cast._value_2))
      return false;
    return true;
  };
  Entry_0.$metadata$ = {
    simpleName: 'Entry',
    kind: 'class',
    interfaces: []
  };
  function Iterator_4(map_0) {
    this._map_2 = map_0;
    var tmp = this;
    var tmp_0;
    if (this._map_2._hasZero_0) {
      Companion_getInstance_22();
      tmp_0 = 2147483647;
    } else {
      tmp_0 = nextNonEmptyIndex(this, this._map_2.__keys_2, 0);
    }
    tmp._index_9 = tmp_0;
    this._entry = new Entry_0(0, null);
  }
  Iterator_4.prototype.hasNext_0_k$ = function () {
    var tmp = this._index_9;
    Companion_getInstance_22();
    return !(tmp === 2147483646);
  };
  Iterator_4.prototype.nextKey_0_k$ = function () {
    var tmp0_apply_0 = currentKey(this);
    next(this);
    return tmp0_apply_0;
  };
  Iterator_4.prototype.nextValue_0_k$ = function () {
    var tmp0_apply_0 = currentValue(this);
    next(this);
    return tmp0_apply_0;
  };
  Iterator_4.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_5(this$0) {
    this._this$0_13 = this$0;
  }
  _no_name_provided__1_5.prototype.iterator_2_0_k$ = function () {
    var tmp0_let_0_7 = new Iterator_4(this._this$0_13);
    var tmp = _no_name_provided_$factory_36(tmp0_let_0_7);
    return Iterator_5(tmp, _no_name_provided_$factory_37(tmp0_let_0_7));
  };
  _no_name_provided__1_5.prototype.iterator_0_k$ = function () {
    return this.iterator_2_0_k$();
  };
  _no_name_provided__1_5.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Iterable]
  };
  function _no_name_provided__1_6(this$0) {
    this._this$0_14 = this$0;
  }
  _no_name_provided__1_6.prototype.iterator_2_0_k$ = function () {
    var tmp0_let_0_7 = new Iterator_4(this._this$0_14);
    var tmp = _no_name_provided_$factory_38(tmp0_let_0_7);
    return Iterator_5(tmp, _no_name_provided_$factory_39(tmp0_let_0_7));
  };
  _no_name_provided__1_6.prototype.iterator_0_k$ = function () {
    return this.iterator_2_0_k$();
  };
  _no_name_provided__1_6.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Iterable]
  };
  function IntMap(nbits, loadFactor, dummy) {
    Companion_getInstance_22();
    this._nbits_0 = nbits;
    this._loadFactor_0 = loadFactor;
    this._capacity_0 = 1 << this._nbits_0;
    this._hasZero_0 = false;
    this._zeroValue_0 = null;
    this._mask_0 = this._capacity_0 - 1 | 0;
    this._stashSize_0 = 1 + imul(this._nbits_0, this._nbits_0) | 0;
    this.__keys_2 = new Int32Array(this._get_backSize__0_k$());
    var tmp = this;
    var tmp0_arrayOfNulls_0 = this._get_backSize__0_k$();
    var tmp_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    tmp.__values_2 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    this._growSize_0 = numberToInt(this._capacity_0 * this._loadFactor_0);
    this._size_1 = 0;
  }
  IntMap.prototype._get_backSize__0_k$ = function () {
    return this._capacity_0 + this._stashSize_0 | 0;
  };
  IntMap.prototype.get_ha5a7z_k$ = function (key) {
    var index_0 = _getKeyIndex_0(this, key);
    if (index_0 < 0)
      return null;
    Companion_getInstance_22();
    if (index_0 === 2147483647)
      return this._zeroValue_0;
    else {
    }
    return this.__values_2[index_0];
  };
  IntMap.prototype.set_bq5tp3_k$ = function (key, value) {
    retry: while (true) {
      var index_0 = _getKeyIndex_0(this, key);
      if (index_0 < 0) {
        if (key === 0) {
          this._hasZero_0 = true;
          this._zeroValue_0 = value;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size_1;
          tmp0_this._size_1 = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }if (this._size_1 >= this._growSize_0)
          grow_0(this);
        var index1 = hash1_0(this, key);
        var tmp = this.__keys_2[index1];
        Companion_getInstance_22();
        if (tmp === 0)
          return setEmptySlot_0(this, index1, key, value);
        else {
        }
        var index2 = hash2_0(this, key);
        var tmp_0 = this.__keys_2[index2];
        Companion_getInstance_22();
        if (tmp_0 === 0)
          return setEmptySlot_0(this, index2, key, value);
        else {
        }
        var index3 = hash3_0(this, key);
        var tmp_1 = this.__keys_2[index3];
        Companion_getInstance_22();
        if (tmp_1 === 0)
          return setEmptySlot_0(this, index3, key, value);
        else {
        }
        var inductionVariable = _get_stashStart__0(this);
        var last_1 = this.__keys_2.length;
        if (inductionVariable < last_1)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_2 = this.__keys_2[n];
            Companion_getInstance_22();
            if (tmp_2 === 0)
              return setEmptySlot_0(this, n, key, value);
            else {
            }
          }
           while (inductionVariable < last_1);
        if (this._stashSize_0 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else {
        Companion_getInstance_22();
        if (index_0 === 2147483647) {
          var tmp0_apply_0 = this._zeroValue_0;
          this._zeroValue_0 = value;
          return tmp0_apply_0;
        } else {
          {
            var tmp1_apply_0 = this.__values_2[index_0];
            this.__values_2[index_0] = value;
            return tmp1_apply_0;
          }
        }
      }
    }
  };
  IntMap.prototype._get_keys__0_k$ = function () {
    return new _no_name_provided__1_5(this);
  };
  IntMap.prototype._get_values__0_k$ = function () {
    return new _no_name_provided__1_6(this);
  };
  IntMap.prototype.nextNonEmptyIndex_pb76ll_k$ = function (keys, offset_0) {
    var inductionVariable = offset_0;
    var last_1 = keys.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = keys[n];
        Companion_getInstance_22();
        if (!(tmp === 0))
          return n;
        else {
        }
      }
       while (inductionVariable < last_1);
    Companion_getInstance_22();
    return 2147483646;
  };
  IntMap.prototype.equals = function (other) {
    if (!(other instanceof IntMap))
      return false;
    else {
    }
    var tmp;
    if (this._hasZero_0) {
      Companion_getInstance_22();
      tmp = 2147483647;
    } else {
      tmp = this.nextNonEmptyIndex_pb76ll_k$(this.__keys_2, 0);
    }
    var index_1_1 = tmp;
    $l$break: while (true) {
      var tmp_0 = index_1_1;
      Companion_getInstance_22();
      if (!!(tmp_0 === 2147483646)) {
        break $l$break;
      }var tmp0_subject_2_3 = index_1_1;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_22();
      if (tmp0_subject_2_3 === 2147483647) {
        tmp_2 = true;
      } else {
        {
          Companion_getInstance_22();
          tmp_2 = tmp0_subject_2_3 === 2147483646;
        }
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        {
          tmp_1 = this.__keys_2[index_1_1];
        }
      }
      var tmp0__anonymous__3_2 = tmp_1;
      var tmp0__anonymous__4 = this.get_ha5a7z_k$(tmp0__anonymous__3_2);
      if (!equals_1(other.get_ha5a7z_k$(tmp0__anonymous__3_2), tmp0__anonymous__4))
        return false;
      var tmp_3 = this.__keys_2;
      var tmp_4;
      var tmp_5 = index_1_1;
      Companion_getInstance_22();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        {
          tmp_4 = index_1_1 + 1 | 0;
        }
      }
      index_1_1 = this.nextNonEmptyIndex_pb76ll_k$(tmp_3, tmp_4);
    }
    return true;
  };
  IntMap.prototype.hashCode = function () {
    var out = 0;
    var tmp;
    if (this._hasZero_0) {
      Companion_getInstance_22();
      tmp = 2147483647;
    } else {
      tmp = this.nextNonEmptyIndex_pb76ll_k$(this.__keys_2, 0);
    }
    var index_1_1 = tmp;
    $l$break: while (true) {
      var tmp_0 = index_1_1;
      Companion_getInstance_22();
      if (!!(tmp_0 === 2147483646)) {
        break $l$break;
      }var tmp0_subject_2_3 = index_1_1;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_22();
      if (tmp0_subject_2_3 === 2147483647) {
        tmp_2 = true;
      } else {
        {
          Companion_getInstance_22();
          tmp_2 = tmp0_subject_2_3 === 2147483646;
        }
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        {
          tmp_1 = this.__keys_2[index_1_1];
        }
      }
      var tmp0__anonymous__3_2 = tmp_1;
      var tmp0__anonymous__4 = this.get_ha5a7z_k$(tmp0__anonymous__3_2);
      var tmp_3 = out;
      var tmp_4 = tmp0__anonymous__3_2;
      var tmp0_safe_receiver_2_6 = tmp0__anonymous__4;
      var tmp1_elvis_lhs_1_5 = tmp0_safe_receiver_2_6 == null ? null : hashCode(tmp0_safe_receiver_2_6);
      out = tmp_3 + (tmp_4 + (tmp1_elvis_lhs_1_5 == null ? 0 : tmp1_elvis_lhs_1_5) | 0) | 0;
      var tmp_5 = this.__keys_2;
      var tmp_6;
      var tmp_7 = index_1_1;
      Companion_getInstance_22();
      if (tmp_7 === 2147483647) {
        tmp_6 = 0;
      } else {
        {
          tmp_6 = index_1_1 + 1 | 0;
        }
      }
      index_1_1 = this.nextNonEmptyIndex_pb76ll_k$(tmp_5, tmp_6);
    }
    return out;
  };
  IntMap.prototype.firstValue_0_k$ = function () {
    var tmp;
    if (this._hasZero_0) {
      Companion_getInstance_22();
      tmp = 2147483647;
    } else {
      tmp = this.nextNonEmptyIndex_pb76ll_k$(this.__keys_2, 0);
    }
    var index_1_1 = tmp;
    $l$break: while (true) {
      var tmp_0 = index_1_1;
      Companion_getInstance_22();
      if (!!(tmp_0 === 2147483646)) {
        break $l$break;
      }var tmp0_subject_2_3 = index_1_1;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_22();
      if (tmp0_subject_2_3 === 2147483647) {
        tmp_2 = true;
      } else {
        {
          Companion_getInstance_22();
          tmp_2 = tmp0_subject_2_3 === 2147483646;
        }
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        {
          tmp_1 = this.__keys_2[index_1_1];
        }
      }
      var tmp0__anonymous__3_2 = tmp_1;
      var tmp0__anonymous__4 = ensureNotNull(this.get_ha5a7z_k$(tmp0__anonymous__3_2));
      return tmp0__anonymous__4;
    }
    throw IllegalStateException_init_$Create$_0('firstValue on empty IntMap');
  };
  IntMap.$metadata$ = {
    simpleName: 'IntMap',
    kind: 'class',
    interfaces: []
  };
  function toIntMap(_this_) {
    var tmp = numberToInt(_this_._get_size__0_k$() * 1.25);
    var out = IntMap_init_$Create$(tmp, 0.0, 2, null);
    var tmp0_iterator = _this_._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var tmp1_loop_parameter = tmp0_iterator.next_0_k$();
      var k = tmp1_loop_parameter._get_key__0_k$();
      var v = tmp1_loop_parameter._get_value__0_k$();
      out.set_bq5tp3_k$(k, v);
      Unit_getInstance();
    }
    return out;
  }
  function associateByInt(_this_, block) {
    var n = 0;
    var out = IntMap_init_$Create$(0, 0.0, 3, null);
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var it = tmp0_iterator.next_0_k$();
      var tmp1 = n;
      n = tmp1 + 1 | 0;
      out.set_bq5tp3_k$(block(tmp1, it), it);
      Unit_getInstance();
    }
    return out;
  }
  function _hash1(key, mask_0) {
    return _mask(key, mask_0);
  }
  function _hash2(key, mask_0) {
    return _mask(imul(key, 1294968109), mask_0);
  }
  function _hash3(key, mask_0) {
    return _mask(imul(key, 294969449), mask_0);
  }
  function _mask(value, mask_0) {
    return (((value + (value >>> 8 & 255) | 0) + (value >>> 16 & 255) | 0) + (value >> 24 & 255) | 0) & mask_0;
  }
  function _no_name_provided_$factory_36($tmp0_let_0_7) {
    var i = new _no_name_provided__54($tmp0_let_0_7);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_37($tmp0_let_0_7) {
    var i = new _no_name_provided__55($tmp0_let_0_7);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_38($tmp0_let_0_7) {
    var i = new _no_name_provided__56($tmp0_let_0_7);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_39($tmp0_let_0_7) {
    var i = new _no_name_provided__57($tmp0_let_0_7);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function Iterator_5(hasNext, next_0) {
    return new _no_name_provided__58(hasNext, next_0);
  }
  function _no_name_provided__58($hasNext, $next) {
    this._$hasNext = $hasNext;
    this._$next = $next;
  }
  _no_name_provided__58.prototype.hasNext_0_k$ = function () {
    return this._$hasNext();
  };
  _no_name_provided__58.prototype.next_0_k$ = function () {
    return this._$next();
  };
  _no_name_provided__58.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function ListReader(list) {
    this._list_0 = list;
    this._position = 0;
  }
  ListReader.prototype._get_hasMore__0_k$ = function () {
    return this._position < this._list_0._get_size__0_k$();
  };
  ListReader.prototype.peek_0_k$ = function () {
    return this._list_0.get_ha5a7z_k$(this._position);
  };
  ListReader.prototype.skip_ha5a7z_k$ = function (count_0) {
    var tmp0_this_2 = this;
    tmp0_this_2._position = tmp0_this_2._position + count_0 | 0;
    return this;
  };
  ListReader.prototype.read_0_k$ = function () {
    var tmp0_apply_0 = this.peek_0_k$();
    this.skip_ha5a7z_k$(1);
    Unit_getInstance();
    return tmp0_apply_0;
  };
  ListReader.prototype.toString = function () {
    return '' + 'ListReader(' + this._list_0 + ')';
  };
  ListReader.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ListReader) {
      tmp_0 = equals_1(this._list_0, other._list_0);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._position === other._position;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ListReader.prototype.hashCode = function () {
    return hashCode(this._list_0);
  };
  ListReader.$metadata$ = {
    simpleName: 'ListReader',
    kind: 'class',
    interfaces: []
  };
  function Pool_init_$Init$(reset, preallocate, gen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      reset = _no_name_provided_$factory_40();
    }if (!(($mask0 & 2) === 0))
      preallocate = 0;
    Pool.call($this, reset, preallocate, gen);
    return $this;
  }
  function Pool_init_$Create$(reset, preallocate, gen, $mask0, $marker) {
    return Pool_init_$Init$(reset, preallocate, gen, $mask0, $marker, Object.create(Pool.prototype));
  }
  function Companion_24() {
    Companion_instance_23 = this;
  }
  Companion_24.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_24();
    return Companion_instance_23;
  }
  function Pool_init_$Init$_0(preallocate, gen, $this) {
    Pool.call($this, _no_name_provided_$factory_41(), preallocate, gen);
    return $this;
  }
  function Pool_init_$Create$_0(preallocate, gen) {
    return Pool_init_$Init$_0(preallocate, gen, Object.create(Pool.prototype));
  }
  function Pool_init_$Init$_1(preallocate, gen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      preallocate = 0;
    Pool_init_$Init$_0(preallocate, gen, $this);
    return $this;
  }
  function Pool_init_$Create$_1(preallocate, gen, $mask0, $marker) {
    return Pool_init_$Init$_1(preallocate, gen, $mask0, $marker, Object.create(Pool.prototype));
  }
  function _no_name_provided__59() {
  }
  _no_name_provided__59.prototype.invoke_iav7o_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__59.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_iav7o_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__59.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__60() {
  }
  _no_name_provided__60.prototype.invoke_iav7o_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__60.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_iav7o_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__60.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Pool(reset, preallocate, gen) {
    Companion_getInstance_23();
    this._reset = reset;
    this._gen = gen;
    this._items = new TGenStack();
    this._lastId = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_this = this;
        var tmp2 = tmp1_this._lastId;
        tmp1_this._lastId = tmp2 + 1 | 0;
        this._items.push_xoeh3q_k$(this._gen(tmp2));
      }
       while (inductionVariable < preallocate);
  }
  Pool.prototype._get_itemsInPool__0_k$ = function () {
    return this._items._get_size__0_k$();
  };
  Pool.prototype.alloc_0_k$ = function () {
    var tmp;
    var tmp0_isNotEmpty_0 = this._items;
    if (!tmp0_isNotEmpty_0.isEmpty_0_k$()) {
      tmp = this._items.pop_0_k$();
    } else {
      {
        var tmp0_this = this;
        var tmp1 = tmp0_this._lastId;
        tmp0_this._lastId = tmp1 + 1 | 0;
        tmp = this._gen(tmp1);
      }
    }
    return tmp;
  };
  Pool.prototype.free_iav7o_k$ = function (element) {
    this._reset(element);
    this._items.push_xoeh3q_k$(element);
  };
  Pool.prototype.free_vgcrvo_k$ = function (elements) {
    var tmp0_iterator = elements.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var element = tmp0_iterator.next_0_k$();
      this.free_iav7o_k$(element);
    }
  };
  Pool.prototype.hashCode = function () {
    return this._items.hashCode();
  };
  Pool.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = this._items.equals(other._items);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._get_itemsInPool__0_k$() === other._get_itemsInPool__0_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Pool.$metadata$ = {
    simpleName: 'Pool',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_40() {
    var i = new _no_name_provided__59();
    return function (p1) {
      i.invoke_iav7o_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_41() {
    var i = new _no_name_provided__60();
    return function (p1) {
      i.invoke_iav7o_k$(p1);
      return Unit_getInstance();
    };
  }
  function Companion_25() {
    Companion_instance_24 = this;
  }
  Companion_25.prototype.invoke_qtlxb0_k$ = function (comparator, reversed_2) {
    var tmp = fillArrayVal(Array(16), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_2 ? reversed_1(comparator) : comparator);
  };
  Companion_25.prototype.invoke_jo4d1e_k$ = function (reversed_2, comparator) {
    return Companion_getInstance_24().invoke_qtlxb0_k$(new sam$kotlin_Comparator$0(comparator), reversed_2);
  };
  Companion_25.prototype.invoke$default_ebmhms_k$ = function (reversed_2, comparator, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      reversed_2 = false;
    return this.invoke_jo4d1e_k$(reversed_2, comparator);
  };
  Companion_25.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_24;
  function Companion_getInstance_24() {
    if (Companion_instance_24 == null)
      new Companion_25();
    return Companion_instance_24;
  }
  function _set_value_(_this_, $this, value) {
    return $this._data_8[_this_] = value;
  }
  function _get_value_(_this_, $this) {
    return $this._data_8[_this_];
  }
  function _get_isRoot_(_this_, $this) {
    return _this_ === 0;
  }
  function _get_parent_(_this_, $this) {
    return (_this_ - 1 | 0) / 2 | 0;
  }
  function _get_left_(_this_, $this) {
    return imul(2, _this_) + 1 | 0;
  }
  function _get_right_(_this_, $this) {
    return imul(2, _this_) + 2 | 0;
  }
  function gt($this, a, b) {
    return $this._comparator_0.compare(a, b) > 0;
  }
  function lt($this, a, b) {
    return $this._comparator_0.compare(a, b) < 0;
  }
  function _get_capacity__1($this) {
    return $this._data_8.length;
  }
  function ensure_0($this, index_0) {
    if (index_0 >= _get_capacity__1($this)) {
      var tmp = $this;
      var tmp_0 = copyOf_0($this._data_8, 2 + imul(_get_capacity__1($this), 2) | 0);
      tmp._data_8 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    }}
  function minHeapify($this, index_0) {
    var i = index_0;
    $l$break: while (true) {
      var left = _get_left_(i, $this);
      var right = _get_right_(i, $this);
      var smallest = i;
      if (left < $this._size_2 ? lt($this, _get_value_(left, $this), _get_value_(i, $this)) : false)
        smallest = left;
      if (right < $this._size_2 ? lt($this, _get_value_(right, $this), _get_value_(smallest, $this)) : false)
        smallest = right;
      if (!(smallest === i)) {
        swap($this, i, smallest);
        i = smallest;
      } else {
        break $l$break;
      }
    }
  }
  function swap($this, l, r) {
    var temp_0 = _get_value_(r, $this);
    _set_value_(r, $this, _get_value_(l, $this));
    _set_value_(l, $this, temp_0);
  }
  function sam$kotlin_Comparator$0(function_0) {
    this._function = function_0;
  }
  sam$kotlin_Comparator$0.prototype.compare_1qgdm_k$ = function (a, b) {
    return this._function(a, b);
  };
  sam$kotlin_Comparator$0.prototype.compare = function (a, b) {
    return this.compare_1qgdm_k$(a, b);
  };
  sam$kotlin_Comparator$0.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__61($index, this$0) {
    this._$index = $index;
    this._this$0_15 = this$0;
  }
  _no_name_provided__61.prototype.hasNext_0_k$ = function () {
    return this._$index._v < this._this$0_15._size_2;
  };
  _no_name_provided__61.prototype.next_0_k$ = function () {
    var tmp0 = this._$index._v;
    this._$index._v = tmp0 + 1 | 0;
    return _get_value_(tmp0, this._this$0_15);
  };
  _no_name_provided__61.prototype.remove_0_k$ = function () {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  _no_name_provided__61.prototype.remove_sv8swh_k$ = function () {
    return this.remove_0_k$();
  };
  _no_name_provided__61.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function TGenPriorityQueue(data, comparator) {
    Companion_getInstance_24();
    this._data_8 = data;
    this._comparator_0 = comparator;
    this._size_2 = 0;
  }
  TGenPriorityQueue.prototype._get_size__0_k$ = function () {
    return this._size_2;
  };
  TGenPriorityQueue.prototype._get_head__0_k$ = function () {
    if (this._size_2 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    return this._data_8[0];
  };
  TGenPriorityQueue.prototype.add_1hrmez_k$ = function (element) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._size_2;
    tmp0_this._size_2 = tmp1 + 1 | 0;
    Unit_getInstance();
    ensure_0(this, this._size_2);
    var i = this._size_2 - 1 | 0;
    _set_value_(i, this, element);
    while (!_get_isRoot_(i, this) ? gt(this, _get_value_(_get_parent_(i, this), this), _get_value_(i, this)) : false) {
      swap(this, i, _get_parent_(i, this));
      i = _get_parent_(i, this);
    }
    return true;
  };
  TGenPriorityQueue.prototype.add_2bq_k$ = function (element) {
    return this.add_1hrmez_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenPriorityQueue.prototype.removeHead_0_k$ = function () {
    if (this._size_2 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    if (this._size_2 === 1) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._size_2;
      tmp0_this._size_2 = tmp1 - 1 | 0;
      Unit_getInstance();
      return _get_value_(0, this);
    }var root = _get_value_(0, this);
    _set_value_(0, this, _get_value_(this._size_2 - 1 | 0, this));
    var tmp2_this = this;
    var tmp3 = tmp2_this._size_2;
    tmp2_this._size_2 = tmp3 - 1 | 0;
    Unit_getInstance();
    minHeapify(this, 0);
    return root;
  };
  TGenPriorityQueue.prototype.indexOf_1hrmez_k$ = function (element) {
    var inductionVariable = 0;
    var last_1 = this._size_2;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this._data_8[n], element))
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  };
  TGenPriorityQueue.prototype.remove_1hrmez_k$ = function (element) {
    var index_0 = this.indexOf_1hrmez_k$(element);
    if (index_0 >= 0)
      this.removeAt_majfzk_k$(index_0);
    return index_0 >= 0;
  };
  TGenPriorityQueue.prototype.remove_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_1hrmez_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenPriorityQueue.prototype.removeAt_majfzk_k$ = function (index_0) {
    var i = index_0;
    while (!(i === 0)) {
      swap(this, i, _get_parent_(i, this));
      i = _get_parent_(i, this);
    }
    this.removeHead_0_k$();
    Unit_getInstance();
  };
  TGenPriorityQueue.prototype.contains_1hrmez_k$ = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = until(0, this._size_2);
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var inductionVariable = tmp0_any_0._get_first__0_k$();
      var last_1 = tmp0_any_0._get_last__0_k$();
      if (inductionVariable <= last_1)
        do {
          var element_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals_1(_get_value_(element_2, this), element)) {
            tmp$ret$0 = true;
            break l$ret$1;
          } else {
          }
        }
         while (!(element_2 === last_1));
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  TGenPriorityQueue.prototype.contains_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_1hrmez_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenPriorityQueue.prototype.containsAll_1asxxx_k$ = function (elements) {
    var thisSet = toSet_0(this);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!thisSet.contains_2bq_k$(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  TGenPriorityQueue.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_1asxxx_k$(elements);
  };
  TGenPriorityQueue.prototype.isEmpty_0_k$ = function () {
    return this._size_2 === 0;
  };
  TGenPriorityQueue.prototype.addAll_1asxxx_k$ = function (elements) {
    var tmp0_iterator_2 = elements.iterator_0_k$();
    while (tmp0_iterator_2.hasNext_0_k$()) {
      var e_3 = tmp0_iterator_2.next_0_k$();
      this.add_1hrmez_k$(e_3);
      Unit_getInstance();
    }
    return !elements.isEmpty_0_k$();
  };
  TGenPriorityQueue.prototype.addAll_dxd4eo_k$ = function (elements) {
    return this.addAll_1asxxx_k$(elements);
  };
  TGenPriorityQueue.prototype.iterator_0_k$ = function () {
    var index_0 = {_v: 0};
    return new _no_name_provided__61(index_0, this);
  };
  TGenPriorityQueue.prototype.toString = function () {
    return toString_1(toList_3(this));
  };
  TGenPriorityQueue.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_11(this._data_8, other._data_8);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = equals_1(this._comparator_0, other._comparator_0);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  TGenPriorityQueue.prototype.hashCode = function () {
    return contentHashCode_8(this._data_8);
  };
  TGenPriorityQueue.$metadata$ = {
    simpleName: 'TGenPriorityQueue',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function TGenQueue() {
    this._items_0 = TGenDeque_init_$Create$();
  }
  TGenQueue.prototype._get_size__0_k$ = function () {
    return this._items_0._get_size__0_k$();
  };
  TGenQueue.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  TGenQueue.prototype.enqueue_xoeh3q_k$ = function (v) {
    return this._items_0.addLast_xoeh3q_k$(v);
  };
  TGenQueue.prototype.dequeue_0_k$ = function () {
    return this._items_0.removeFirst_0_k$();
  };
  TGenQueue.prototype.contains_1hrmez_k$ = function (element) {
    return this._items_0.contains_1hrmez_k$(element);
  };
  TGenQueue.prototype.contains_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_1hrmez_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenQueue.prototype.containsAll_1asxxx_k$ = function (elements) {
    return this._items_0.containsAll_1asxxx_k$(elements);
  };
  TGenQueue.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_1asxxx_k$(elements);
  };
  TGenQueue.prototype.iterator_0_k$ = function () {
    return this._items_0.iterator_0_k$();
  };
  TGenQueue.prototype.hashCode = function () {
    return this._items_0.hashCode();
  };
  TGenQueue.prototype.equals = function (other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this._items_0.equals(other._items_0);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  TGenQueue.$metadata$ = {
    simpleName: 'TGenQueue',
    kind: 'class',
    interfaces: [Collection]
  };
  function RingBuffer(bits) {
    ByteRingBuffer.call(this, bits);
  }
  RingBuffer.$metadata$ = {
    simpleName: 'RingBuffer',
    kind: 'class',
    interfaces: []
  };
  function ByteRingBuffer(bits) {
    this._bits = bits;
    this._totalSize = 1 << this._bits;
    this._mask_1 = this._totalSize - 1 | 0;
    this._buffer_0 = new Int8Array(this._totalSize);
    this._readPos = 0;
    this._writePos = 0;
    this._availableWrite = this._totalSize;
    this._availableRead = 0;
  }
  ByteRingBuffer.prototype._get_availableWrite__0_k$ = function () {
    return this._availableWrite;
  };
  ByteRingBuffer.prototype._get_availableRead__0_k$ = function () {
    return this._availableRead;
  };
  ByteRingBuffer.prototype.write_irqg4d_k$ = function (data, offset_0, size_2) {
    var tmp0_min_0 = this._availableWrite;
    var toWrite = Math.min(tmp0_min_0, size_2);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._buffer_0[this._writePos] = data[offset_0 + n | 0];
        this._writePos = (this._writePos + 1 | 0) & this._mask_1;
      }
       while (inductionVariable < toWrite);
    var tmp1_this = this;
    tmp1_this._availableRead = tmp1_this._availableRead + toWrite | 0;
    var tmp2_this = this;
    tmp2_this._availableWrite = tmp2_this._availableWrite - toWrite | 0;
    return toWrite;
  };
  ByteRingBuffer.prototype.read_irqg4d_k$ = function (data, offset_0, size_2) {
    var tmp0_min_0 = this._availableRead;
    var toRead = Math.min(tmp0_min_0, size_2);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset_0 + n | 0] = this._buffer_0[this._readPos];
        this._readPos = (this._readPos + 1 | 0) & this._mask_1;
      }
       while (inductionVariable < toRead);
    var tmp1_this = this;
    tmp1_this._availableWrite = tmp1_this._availableWrite + toRead | 0;
    var tmp2_this = this;
    tmp2_this._availableRead = tmp2_this._availableRead - toRead | 0;
    return toRead;
  };
  ByteRingBuffer.prototype.readByte_0_k$ = function () {
    if (this._availableRead <= 0)
      return -1;
    var out = this._buffer_0[this._readPos] & 255;
    this._readPos = (this._readPos + 1 | 0) & this._mask_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this._availableRead;
    tmp0_this._availableRead = tmp1 - 1 | 0;
    Unit_getInstance();
    var tmp2_this = this;
    var tmp3 = tmp2_this._availableWrite;
    tmp2_this._availableWrite = tmp3 + 1 | 0;
    Unit_getInstance();
    return out;
  };
  ByteRingBuffer.prototype.peek_ha5a7z_k$ = function (offset_0) {
    return this._buffer_0[(this._readPos + offset_0 | 0) & this._mask_1];
  };
  ByteRingBuffer.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ByteRingBuffer) {
      tmp_0 = this._availableRead === other._availableRead;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_equaler_0 = this._availableRead;
        var inductionVariable = 0;
        if (inductionVariable < tmp0_equaler_0)
          do {
            var n_2 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(this.peek_ha5a7z_k$(n_2) === other.peek_ha5a7z_k$(n_2))) {
              tmp$ret$0 = false;
              break l$ret$1;
            } else {
            }
          }
           while (inductionVariable < tmp0_equaler_0);
        tmp$ret$0 = true;
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ByteRingBuffer.prototype.hashCode = function () {
    return this.contentHashCode_0_k$();
  };
  ByteRingBuffer.prototype.contentHashCode_0_k$ = function () {
    var tmp0_hashCoder_0 = this._availableRead;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + this.peek_ha5a7z_k$(n_3) | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  };
  ByteRingBuffer.$metadata$ = {
    simpleName: 'ByteRingBuffer',
    kind: 'class',
    interfaces: []
  };
  function ShortRingBuffer(bits) {
    this._bits_0 = bits;
    this._totalSize_0 = 1 << this._bits_0;
    this._mask_2 = this._totalSize_0 - 1 | 0;
    this._buffer_1 = new Int16Array(this._totalSize_0);
    this._readPos_0 = 0;
    this._writePos_0 = 0;
    this._availableWrite_0 = this._totalSize_0;
    this._availableRead_0 = 0;
    this._temp = new Int16Array(1);
  }
  ShortRingBuffer.prototype.write_br01yt_k$ = function (data, offset_0, size_2) {
    var tmp0_min_0 = this._availableWrite_0;
    var toWrite = Math.min(tmp0_min_0, size_2);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._buffer_1[this._writePos_0] = data[offset_0 + n | 0];
        this._writePos_0 = (this._writePos_0 + 1 | 0) & this._mask_2;
      }
       while (inductionVariable < toWrite);
    var tmp1_this = this;
    tmp1_this._availableRead_0 = tmp1_this._availableRead_0 + toWrite | 0;
    var tmp2_this = this;
    tmp2_this._availableWrite_0 = tmp2_this._availableWrite_0 - toWrite | 0;
    return toWrite;
  };
  ShortRingBuffer.prototype.read_br01yt_k$ = function (data, offset_0, size_2) {
    var tmp0_min_0 = this._availableRead_0;
    var toRead = Math.min(tmp0_min_0, size_2);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset_0 + n | 0] = this._buffer_1[this._readPos_0];
        this._readPos_0 = (this._readPos_0 + 1 | 0) & this._mask_2;
      }
       while (inductionVariable < toRead);
    var tmp1_this = this;
    tmp1_this._availableWrite_0 = tmp1_this._availableWrite_0 + toRead | 0;
    var tmp2_this = this;
    tmp2_this._availableRead_0 = tmp2_this._availableRead_0 - toRead | 0;
    return toRead;
  };
  ShortRingBuffer.prototype.peek_ha5a7z_k$ = function (offset_0) {
    return this._buffer_1[(this._readPos_0 + offset_0 | 0) & this._mask_2];
  };
  ShortRingBuffer.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ShortRingBuffer) {
      tmp_0 = this._availableRead_0 === other._availableRead_0;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_equaler_0 = this._availableRead_0;
        var inductionVariable = 0;
        if (inductionVariable < tmp0_equaler_0)
          do {
            var n_2 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(this.peek_ha5a7z_k$(n_2) === other.peek_ha5a7z_k$(n_2))) {
              tmp$ret$0 = false;
              break l$ret$1;
            } else {
            }
          }
           while (inductionVariable < tmp0_equaler_0);
        tmp$ret$0 = true;
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ShortRingBuffer.prototype.hashCode = function () {
    return this.contentHashCode_0_k$();
  };
  ShortRingBuffer.prototype.contentHashCode_0_k$ = function () {
    var tmp0_hashCoder_0 = this._availableRead_0;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + this.peek_ha5a7z_k$(n_3) | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  };
  ShortRingBuffer.$metadata$ = {
    simpleName: 'ShortRingBuffer',
    kind: 'class',
    interfaces: []
  };
  function FloatRingBuffer(bits) {
    this._bits_1 = bits;
    this._totalSize_1 = 1 << this._bits_1;
    this._mask_3 = this._totalSize_1 - 1 | 0;
    this._buffer_2 = new Float32Array(this._totalSize_1);
    this._readPos_1 = 0;
    this._writePos_1 = 0;
    this._availableWrite_1 = this._totalSize_1;
    this._availableRead_1 = 0;
  }
  FloatRingBuffer.prototype.write_zd834l_k$ = function (data, offset_0, size_2) {
    var tmp0_min_0 = this._availableWrite_1;
    var toWrite = Math.min(tmp0_min_0, size_2);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._buffer_2[this._writePos_1] = data[offset_0 + n | 0];
        this._writePos_1 = (this._writePos_1 + 1 | 0) & this._mask_3;
      }
       while (inductionVariable < toWrite);
    var tmp1_this = this;
    tmp1_this._availableRead_1 = tmp1_this._availableRead_1 + toWrite | 0;
    var tmp2_this = this;
    tmp2_this._availableWrite_1 = tmp2_this._availableWrite_1 - toWrite | 0;
    return toWrite;
  };
  FloatRingBuffer.prototype.read_zd834l_k$ = function (data, offset_0, size_2) {
    var tmp0_min_0 = this._availableRead_1;
    var toRead = Math.min(tmp0_min_0, size_2);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset_0 + n | 0] = this._buffer_2[this._readPos_1];
        this._readPos_1 = (this._readPos_1 + 1 | 0) & this._mask_3;
      }
       while (inductionVariable < toRead);
    var tmp1_this = this;
    tmp1_this._availableWrite_1 = tmp1_this._availableWrite_1 + toRead | 0;
    var tmp2_this = this;
    tmp2_this._availableRead_1 = tmp2_this._availableRead_1 - toRead | 0;
    return toRead;
  };
  FloatRingBuffer.prototype.peek_ha5a7z_k$ = function (offset_0) {
    return this._buffer_2[(this._readPos_1 + offset_0 | 0) & this._mask_3];
  };
  FloatRingBuffer.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof FloatRingBuffer) {
      tmp_0 = this._availableRead_1 === other._availableRead_1;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_equaler_0 = this._availableRead_1;
        var inductionVariable = 0;
        if (inductionVariable < tmp0_equaler_0)
          do {
            var n_2 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(this.peek_ha5a7z_k$(n_2) === other.peek_ha5a7z_k$(n_2))) {
              tmp$ret$0 = false;
              break l$ret$1;
            } else {
            }
          }
           while (inductionVariable < tmp0_equaler_0);
        tmp$ret$0 = true;
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  FloatRingBuffer.prototype.hashCode = function () {
    return this.contentHashCode_0_k$();
  };
  FloatRingBuffer.prototype.contentHashCode_0_k$ = function () {
    var tmp0_hashCoder_0 = this._availableRead_1;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + toBits(this.peek_ha5a7z_k$(n_3)) | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  };
  FloatRingBuffer.$metadata$ = {
    simpleName: 'FloatRingBuffer',
    kind: 'class',
    interfaces: []
  };
  function TGenStack() {
    this._items_1 = FastArrayList_init_$Create$();
  }
  TGenStack.prototype._get_size__0_k$ = function () {
    return this._items_1._get_size__0_k$();
  };
  TGenStack.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  TGenStack.prototype.push_xoeh3q_k$ = function (v) {
    this._items_1.add_2bq_k$(v);
    Unit_getInstance();
  };
  TGenStack.prototype.pop_0_k$ = function () {
    return this._items_1.removeAt_ha5a7z_k$(this._items_1._get_size__0_k$() - 1 | 0);
  };
  TGenStack.prototype.contains_1hrmez_k$ = function (element) {
    return this._items_1.contains_2bq_k$(element);
  };
  TGenStack.prototype.contains_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_1hrmez_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenStack.prototype.containsAll_1asxxx_k$ = function (elements) {
    return this._items_1.containsAll_dxd4eo_k$(elements);
  };
  TGenStack.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_1asxxx_k$(elements);
  };
  TGenStack.prototype.iterator_0_k$ = function () {
    return this._items_1.iterator_0_k$();
  };
  TGenStack.prototype.hashCode = function () {
    return this._items_1.hashCode();
  };
  TGenStack.prototype.equals = function (other) {
    var tmp;
    if (other instanceof TGenStack) {
      tmp = this._items_1.equals(other._items_1);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  TGenStack.$metadata$ = {
    simpleName: 'TGenStack',
    kind: 'class',
    interfaces: [Collection]
  };
  function Mixin_init_$Init$(extra, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      extra = null;
    Mixin.call($this, extra);
    return $this;
  }
  function Mixin_init_$Create$(extra, $mask0, $marker) {
    return Mixin_init_$Init$(extra, $mask0, $marker, Object.create(Mixin.prototype));
  }
  function Property_init_$Init$(name, defaultGen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      name = null;
    Property.call($this, name, defaultGen);
    return $this;
  }
  function Property_init_$Create$(name, defaultGen, $mask0, $marker) {
    return Property_init_$Init$(name, defaultGen, $mask0, $marker, Object.create(Property.prototype));
  }
  function PropertyThis_init_$Init$(name, defaultGen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      name = null;
    PropertyThis.call($this, name, defaultGen);
    return $this;
  }
  function PropertyThis_init_$Create$(name, defaultGen, $mask0, $marker) {
    return PropertyThis_init_$Init$(name, defaultGen, $mask0, $marker, Object.create(PropertyThis.prototype));
  }
  function Mixin(extra) {
    this._extra = extra;
  }
  Mixin.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._extra = _set___;
  };
  Mixin.prototype._get_extra__0_k$ = function () {
    return this._extra;
  };
  Mixin.$metadata$ = {
    simpleName: 'Mixin',
    kind: 'class',
    interfaces: [Extra]
  };
  function Property(name, defaultGen) {
    this._name_0 = name;
    this._defaultGen = defaultGen;
  }
  Property.$metadata$ = {
    simpleName: 'Property',
    kind: 'class',
    interfaces: []
  };
  function PropertyThis(name, defaultGen) {
    this._name_1 = name;
    this._defaultGen_0 = defaultGen;
  }
  PropertyThis.$metadata$ = {
    simpleName: 'PropertyThis',
    kind: 'class',
    interfaces: []
  };
  function Extra() {
  }
  Extra.$metadata$ = {
    simpleName: 'Extra',
    kind: 'interface',
    interfaces: []
  };
  function WithParent() {
  }
  WithParent.$metadata$ = {
    simpleName: 'WithParent',
    kind: 'interface',
    interfaces: []
  };
  function Computed(prop, default_0) {
    this._prop = prop;
    this._default = default_0;
  }
  Computed.prototype.getValue_z85e3i_k$ = function (thisRef, p) {
    var current = thisRef;
    while (!(current == null)) {
      var result = this._prop.get(current);
      if (!(result == null))
        return result;
      current = current._get_parent__0_k$();
    }
    return this._default();
  };
  Computed.$metadata$ = {
    simpleName: 'Computed',
    kind: 'class',
    interfaces: []
  };
  function getExtra(_this_, name) {
    var tmp0_safe_receiver = _this_._get_extra__0_k$();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.get(name);
    }
    return tmp;
  }
  function setExtra(_this_, name, value) {
    if (_this_._get_extra__0_k$() == null) {
      if (value == null)
        return Unit_getInstance();
      _this_._set_extra__n1onou_k$(ExtraTypeCreate());
    }var tmp0_safe_receiver = _this_._get_extra__0_k$();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.set(name, value);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function ExtraTypeCreate() {
    return FastStringMap();
  }
  function toLinkedMap(_this_) {
    var tmp0_also_0 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_2 = _this_.iterator_0_k$();
    while (tmp0_iterator_2.hasNext_0_k$()) {
      var tmp1_loop_parameter_3 = tmp0_iterator_2.next_0_k$();
      var key_4 = tmp1_loop_parameter_3.component1_0_k$();
      var value_5 = tmp1_loop_parameter_3.component2_0_k$();
      tmp0_also_0.put_1q9pf_k$(key_4, value_5);
      Unit_getInstance();
    }
    return tmp0_also_0;
  }
  function linkedHashMapOf(pairs) {
    var tmp0_also_0 = LinkedHashMap_init_$Create$();
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var tmp1_loop_parameter_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key_4 = tmp1_loop_parameter_3.component1_0_k$();
      var value_5 = tmp1_loop_parameter_3.component2_0_k$();
      tmp0_also_0.put_1q9pf_k$(key_4, value_5);
      Unit_getInstance();
    }
    return tmp0_also_0;
  }
  function getCyclic(_this_, index_0) {
    return _this_.get_ha5a7z_k$(umod(index_0, _this_._get_size__0_k$()));
  }
  function getCyclic_0(_this_, index_0) {
    return _this_[umod(index_0, _this_.length)];
  }
  function _BSearchResult___init__impl_(raw) {
    return raw;
  }
  function _BSearchResult___get_raw__impl_(this_0) {
    return this_0;
  }
  function _BSearchResult___get_found__impl_(this_0) {
    return _BSearchResult___get_raw__impl_(this_0) >= 0;
  }
  function binarySearch(_this_, v, fromIndex, toIndex) {
    var tmp$ret$0;
    l$ret$1: do {
      var low_2 = fromIndex;
      var high_3 = toIndex - 1 | 0;
      while (low_2 <= high_3) {
        var mid_4 = (low_2 + high_3 | 0) / 2 | 0;
        var mval_5 = compareTo(_this_.getAt_ha5a7z_k$(mid_4), v);
        if (mval_5 < 0)
          low_2 = mid_4 + 1 | 0;
        else if (mval_5 > 0)
          high_3 = mid_4 - 1 | 0;
        else {
          tmp$ret$0 = mid_4;
          break l$ret$1;
        }
      }
      var tmp0__anonymous__1_6 = low_2;
      var tmp1__anonymous__1_6 = high_3;
      tmp$ret$0 = (-tmp0__anonymous__1_6 | 0) - 1 | 0;
    }
     while (false);
    return _BSearchResult___init__impl_(tmp$ret$0);
  }
  function binarySearch$default(_this_, v, fromIndex, toIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      fromIndex = 0;
    if (!(($mask0 & 4) === 0))
      toIndex = _this_._get_size__0_k$();
    return binarySearch(_this_, v, fromIndex, toIndex);
  }
  function flip(_this_) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(_this_._get_size__0_k$());
    var tmp0_iterator_1_2 = _this_._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(new Pair(item_2_3._get_value__0_k$(), item_2_3._get_key__0_k$()));
      Unit_getInstance();
    }
    return toMap_0(tmp0_mapTo_0_1);
  }
  function genericSort(subject, left, right, ops) {
    return genericSort_0(subject, left, right, ops, false);
  }
  function SortOps() {
  }
  SortOps.prototype.shiftLeft_n1r3z0_k$ = function (subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last_1 = indexL + 1 | 0;
    if (last_1 <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.swap_n1r3z0_k$(subject, n - 1 | 0, n);
      }
       while (!(n === last_1));
  };
  SortOps.$metadata$ = {
    simpleName: 'SortOps',
    kind: 'class',
    interfaces: []
  };
  function genericSort_0(subject, left, right, ops, reversed_2) {
    timSort$default(subject, left, right, ops, reversed_2, 0, 32, null);
    return subject;
  }
  function timSort(arr, l, r, ops, reversed_2, RUN) {
    var n = (r - l | 0) + 1 | 0;
    var progression = step(until(0, n), RUN);
    var inductionVariable = progression._first_0;
    var last_1 = progression._last;
    var step_0 = progression._step_2;
    if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var tmp = l + i | 0;
        var tmp0_min_0 = (i + RUN | 0) - 1 | 0;
        var tmp1_min_0 = n - 1 | 0;
        insertionSort(arr, tmp, l + Math.min(tmp0_min_0, tmp1_min_0) | 0, ops, reversed_2);
      }
       while (!(i === last_1));
    var size_2 = RUN;
    while (size_2 < n) {
      var progression_0 = step(until(0, n), imul(2, size_2));
      var inductionVariable_0 = progression_0._first_0;
      var last_2 = progression_0._last;
      var step_1 = progression_0._step_2;
      if ((step_1 > 0 ? inductionVariable_0 <= last_2 : false) ? true : step_1 < 0 ? last_2 <= inductionVariable_0 : false)
        do {
          var left = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_1 | 0;
          var tmp2_min_0 = size_2;
          var tmp3_min_0 = (n - left | 0) - 1 | 0;
          var rize = Math.min(tmp2_min_0, tmp3_min_0);
          var mid = (left + rize | 0) - 1 | 0;
          var tmp4_min_0 = (left + imul(2, rize) | 0) - 1 | 0;
          var tmp5_min_0 = n - 1 | 0;
          var right = Math.min(tmp4_min_0, tmp5_min_0);
          merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed_2);
        }
         while (!(left === last_2));
      size_2 = imul(size_2, 2);
    }
  }
  function timSort$default(arr, l, r, ops, reversed_2, RUN, $mask0, $handler) {
    if (!(($mask0 & 32) === 0))
      RUN = 32;
    return timSort(arr, l, r, ops, reversed_2, RUN);
  }
  function insertionSort(arr, left, right, ops, reversed_2) {
    var inductionVariable = left + 1 | 0;
    if (inductionVariable <= right)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var m = n - 1 | 0;
        $l$break: while (m >= left) {
          if (negateIf(ops.compare_7j2snf_k$(arr, m, n), reversed_2) <= 0)
            break $l$break;
          var tmp1 = m;
          m = tmp1 - 1 | 0;
          Unit_getInstance();
        }
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        Unit_getInstance();
        if (!(m === n))
          ops.shiftLeft_n1r3z0_k$(arr, m, n);
      }
       while (!(n === right));
  }
  function merge(arr, start, mid, end, ops, reversed_2) {
    var s = start;
    var m = mid;
    var s2 = m + 1 | 0;
    if (negateIf(ops.compare_7j2snf_k$(arr, m, s2), reversed_2) <= 0)
      return Unit_getInstance();
    while (s <= m ? s2 <= end : false) {
      if (negateIf(ops.compare_7j2snf_k$(arr, s, s2), reversed_2) <= 0) {
        var tmp0 = s;
        s = tmp0 + 1 | 0;
        Unit_getInstance();
      } else {
        ops.shiftLeft_n1r3z0_k$(arr, s, s2);
        var tmp1 = s;
        s = tmp1 + 1 | 0;
        Unit_getInstance();
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        Unit_getInstance();
        var tmp3 = s2;
        s2 = tmp3 + 1 | 0;
        Unit_getInstance();
      }
    }
  }
  function negateIf(_this_, doNegate) {
    return doNegate ? -_this_ | 0 : _this_;
  }
  function asFakeMutable(_this_) {
    return new FakeMutableSetMapEntry(_this_);
  }
  function FakeMutableCollection(collection) {
    this._collection = collection;
  }
  FakeMutableCollection.prototype.contains_2bw_k$ = function (element) {
    return this._collection.contains_2bq_k$(element);
  };
  FakeMutableCollection.prototype.contains_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_2bw_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  FakeMutableCollection.prototype.containsAll_dxd49i_k$ = function (elements) {
    return this._collection.containsAll_dxd4eo_k$(elements);
  };
  FakeMutableCollection.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_dxd49i_k$(elements);
  };
  FakeMutableCollection.prototype.isEmpty_0_k$ = function () {
    return this._collection.isEmpty_0_k$();
  };
  FakeMutableCollection.prototype._get_size__0_k$ = function () {
    return this._collection._get_size__0_k$();
  };
  FakeMutableCollection.prototype.add_2bw_k$ = function (element) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableCollection.prototype.add_2bq_k$ = function (element) {
    return this.add_2bw_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  FakeMutableCollection.prototype.addAll_dxd49i_k$ = function (elements) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableCollection.prototype.addAll_dxd4eo_k$ = function (elements) {
    return this.addAll_dxd49i_k$(elements);
  };
  FakeMutableCollection.prototype.remove_2bw_k$ = function (element) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableCollection.prototype.remove_2bq_k$ = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_2bw_k$((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  FakeMutableCollection.prototype.iterator_0_k$ = function () {
    return asFakeMutable_1(this._collection.iterator_0_k$());
  };
  FakeMutableCollection.$metadata$ = {
    simpleName: 'FakeMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection, Collection]
  };
  function asFakeMutable_0(_this_) {
    return new FakeMutableCollection(_this_);
  }
  function FakeMutableSetMapEntry(set_0) {
    this._set = set_0;
  }
  FakeMutableSetMapEntry.prototype.add_qbahou_k$ = function (element) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableSetMapEntry.prototype.add_2bq_k$ = function (element) {
    return this.add_qbahou_k$((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  FakeMutableSetMapEntry.prototype.addAll_wd5xv0_k$ = function (elements) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableSetMapEntry.prototype.addAll_dxd4eo_k$ = function (elements) {
    return this.addAll_wd5xv0_k$(elements);
  };
  FakeMutableSetMapEntry.prototype.iterator_0_k$ = function () {
    var tmp0_map_0 = this._set;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(new FakeMutableMapEntry(item_2_3));
      Unit_getInstance();
    }
    return asFakeMutable_1(tmp0_mapTo_0_1.iterator_0_k$());
  };
  FakeMutableSetMapEntry.prototype.remove_qbahou_k$ = function (element) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableSetMapEntry.prototype.remove_2bq_k$ = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.remove_qbahou_k$((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  FakeMutableSetMapEntry.prototype._get_size__0_k$ = function () {
    return this._set._get_size__0_k$();
  };
  FakeMutableSetMapEntry.prototype.contains_qbahou_k$ = function (element) {
    return this._set.contains_2bq_k$(element);
  };
  FakeMutableSetMapEntry.prototype.contains_2bq_k$ = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.contains_qbahou_k$((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  FakeMutableSetMapEntry.prototype.containsAll_wd5xv0_k$ = function (elements) {
    return this._set.containsAll_dxd4eo_k$(elements);
  };
  FakeMutableSetMapEntry.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return this.containsAll_wd5xv0_k$(elements);
  };
  FakeMutableSetMapEntry.prototype.isEmpty_0_k$ = function () {
    return this._set.isEmpty_0_k$();
  };
  FakeMutableSetMapEntry.$metadata$ = {
    simpleName: 'FakeMutableSetMapEntry',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function FakeMutableIterator(iterator_0) {
    this._iterator_1 = iterator_0;
  }
  FakeMutableIterator.prototype.hasNext_0_k$ = function () {
    return this._iterator_1.hasNext_0_k$();
  };
  FakeMutableIterator.prototype.next_0_k$ = function () {
    return this._iterator_1.next_0_k$();
  };
  FakeMutableIterator.prototype.remove_0_k$ = function () {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableIterator.prototype.remove_sv8swh_k$ = function () {
    return this.remove_0_k$();
  };
  FakeMutableIterator.$metadata$ = {
    simpleName: 'FakeMutableIterator',
    kind: 'class',
    interfaces: [MutableIterator, Iterator_3]
  };
  function asFakeMutable_1(_this_) {
    return new FakeMutableIterator(_this_);
  }
  function FakeMutableMapEntry(entry) {
    this._entry_0 = entry;
  }
  FakeMutableMapEntry.prototype._get_key__0_k$ = function () {
    return this._entry_0._get_key__0_k$();
  };
  FakeMutableMapEntry.prototype._get_value__0_k$ = function () {
    return this._entry_0._get_value__0_k$();
  };
  FakeMutableMapEntry.prototype.setValue_2c7_k$ = function (newValue) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableMapEntry.$metadata$ = {
    simpleName: 'FakeMutableMapEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function umod(_this_, other) {
    var remainder = _this_ % other;
    return remainder < 0 ? remainder + other | 0 : remainder;
  }
  function ilog2Ceil(v) {
    var tmp0_log2_0 = v;
    var tmp1_ceil_0 = Math.log2(tmp0_log2_0);
    return numberToInt(Math.ceil(tmp1_ceil_0));
  }
  function arraycopy(src, srcPos, dst, dstPos, size_2) {
    var tmp0_copyInto_0 = srcPos + size_2 | 0;
    arrayCopy_0(src, dst, dstPos, srcPos, tmp0_copyInto_0);
    return dst;
  }
  function contentHashCode_9(_this_, src, dst) {
    var tmp0_hashCoder_0 = dst - src | 0;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + numberToInt(_this_[src + n_3 | 0]) | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  }
  function contentEquals_12(_this_, that, src, dst) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_equaler_0 = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_equaler_0)
        do {
          var n_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(_this_[src + n_2 | 0] === that[src + n_2 | 0])) {
            tmp$ret$0 = false;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable < tmp0_equaler_0);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function arraycopy_0(src, srcPos, dst, dstPos, size_2) {
    var tmp0_copyInto_0 = srcPos + size_2 | 0;
    arrayCopy_0(src, dst, dstPos, srcPos, tmp0_copyInto_0);
    return dst;
  }
  function contentHashCode_10(_this_, src, dst) {
    var tmp0_hashCoder_0 = dst - src | 0;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + _this_[src + n_3 | 0] | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  }
  function contentEquals_13(_this_, that, src, dst) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_equaler_0 = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_equaler_0)
        do {
          var n_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(_this_[src + n_2 | 0] === that[src + n_2 | 0])) {
            tmp$ret$0 = false;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable < tmp0_equaler_0);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function ilog2(v) {
    var tmp0_log2_0 = v;
    return numberToInt(Math.log2(tmp0_log2_0));
  }
  function arraycopy_1(src, srcPos, dst, dstPos, size_2) {
    var tmp0_copyInto_0 = srcPos + size_2 | 0;
    arrayCopy_0(src, dst, dstPos, srcPos, tmp0_copyInto_0);
    return dst;
  }
  function FastArrayList_init_$Init$($this) {
    FastArrayList.call($this, []);
    return $this;
  }
  function FastArrayList_init_$Create$() {
    return FastArrayList_init_$Init$(Object.create(FastArrayList.prototype));
  }
  function FastArrayList_init_$Init$_0(initialCapacity, $this) {
    FastArrayList.call($this, []);
    return $this;
  }
  function FastArrayList_init_$Create$_0(initialCapacity) {
    return FastArrayList_init_$Init$_0(initialCapacity, Object.create(FastArrayList.prototype));
  }
  function rangeCheck_0($this, index_0) {
    if (index_0 < 0 ? true : index_0 >= $this._get_size__0_k$()) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index_0 + ', size: ' + $this._get_size__0_k$());
    }return index_0;
  }
  function insertionRangeCheck_0($this, index_0) {
    if (index_0 < 0 ? true : index_0 > $this._get_size__0_k$()) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index_0 + ', size: ' + $this._get_size__0_k$());
    }return index_0;
  }
  function FastArrayList(array) {
    AbstractMutableList.call(this);
    this._array_4 = array;
    this._isReadOnly_1 = false;
  }
  FastArrayList.prototype._get_size__0_k$ = function () {
    return this._array_4.length;
  };
  FastArrayList.prototype.get_ha5a7z_k$ = function (index_0) {
    var tmp0_asDynamic_0 = this._array_4[rangeCheck_0(this, index_0)];
    return tmp0_asDynamic_0;
  };
  FastArrayList.prototype.set_ddb1qf_k$ = function (index_0, element) {
    rangeCheck_0(this, index_0);
    Unit_getInstance();
    var tmp0_apply_0 = this._array_4[index_0];
    this._array_4[index_0] = element;
    var tmp1_asDynamic_0 = tmp0_apply_0;
    return tmp1_asDynamic_0;
  };
  FastArrayList.prototype.add_2bq_k$ = function (element) {
    var tmp0_asDynamic_0 = this._array_4;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0_k$();
    tmp0_this._set_modCount__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  FastArrayList.prototype.add_vz2mgm_k$ = function (index_0, element) {
    var tmp0_asDynamic_0 = this._array_4;
    tmp0_asDynamic_0.splice(insertionRangeCheck_0(this, index_0), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0_k$();
    tmp0_this._set_modCount__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  FastArrayList.prototype.addAll_dxd4eo_k$ = function (elements) {
    if (elements.isEmpty_0_k$())
      return false;
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._array_4;
    var tmp1_plus_0 = copyToArray_0(elements);
    tmp._array_4 = tmp0_plus_0.concat(tmp1_plus_0);
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_modCount__0_k$();
    tmp1_this._set_modCount__majfzk_k$(tmp2 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  FastArrayList.prototype.removeAt_ha5a7z_k$ = function (index_0) {
    rangeCheck_0(this, index_0);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0_k$();
    tmp0_this._set_modCount__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp;
    if (index_0 === _get_lastIndex__4(this)) {
      var tmp0_asDynamic_0 = this._array_4;
      tmp = tmp0_asDynamic_0.pop();
    } else {
      var tmp1_asDynamic_0 = this._array_4;
      tmp = tmp1_asDynamic_0.splice(index_0, 1)[0];
    }
    return tmp;
  };
  FastArrayList.prototype.remove_2bq_k$ = function (element) {
    var inductionVariable = 0;
    var last_1 = this._array_4.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this._array_4[index_0], element)) {
          var tmp0_asDynamic_0 = this._array_4;
          tmp0_asDynamic_0.splice(index_0, 1);
          var tmp1_this = this;
          var tmp2 = tmp1_this._get_modCount__0_k$();
          tmp1_this._set_modCount__majfzk_k$(tmp2 + 1 | 0);
          Unit_getInstance();
          return true;
        }}
       while (inductionVariable <= last_1);
    return false;
  };
  FastArrayList.prototype.clear_sv8swh_k$ = function () {
    var tmp = this;
    tmp._array_4 = [];
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0_k$();
    tmp0_this._set_modCount__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  FastArrayList.prototype.indexOf_2bq_k$ = function (element) {
    return indexOf(this._array_4, element);
  };
  FastArrayList.prototype.toString = function () {
    var tmp = this._array_4;
    return '[' + joinToString$default(tmp, ', ', null, null, 0, null, null, 62, null) + ']';
  };
  FastArrayList.prototype.toArray_0_k$ = function () {
    return [].slice.call(this._array_4);
  };
  FastArrayList.prototype.toArray = function () {
    return this.toArray_0_k$();
  };
  FastArrayList.$metadata$ = {
    simpleName: 'FastArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  function FastIdentityMap() {
    var tmp0_asDynamic_0 = new Map();
    return tmp0_asDynamic_0;
  }
  function clear(_this_) {
    return _this_.clear();
  }
  function FastStringMap() {
    var tmp0_asDynamic_0 = new Map();
    return tmp0_asDynamic_0;
  }
  function FastIntMap() {
    var tmp0_asDynamic_0 = new Map();
    return tmp0_asDynamic_0;
  }
  function get(_this_, key) {
    return _this_.get(key);
  }
  function set(_this_, key, value) {
    return _this_.set(key, value);
  }
  function remove_0(_this_, key) {
    return _this_.delete(key);
  }
  function _get_size_(_this_) {
    return _this_.size;
  }
  function KdsAtomicRef(initial) {
    this._value_3 = initial;
  }
  KdsAtomicRef.$metadata$ = {
    simpleName: 'KdsAtomicRef',
    kind: 'class',
    interfaces: []
  };
  var CONCURRENCY_COUNT;
  function Companion_26() {
    Companion_instance_25 = this;
    this._TOP_LEFT = new Anchor(0.0, 0.0);
    this._TOP_CENTER = new Anchor(0.5, 0.0);
    this._TOP_RIGHT = new Anchor(1.0, 0.0);
    this._MIDDLE_LEFT = new Anchor(0.0, 0.5);
    this._MIDDLE_CENTER = new Anchor(0.5, 0.5);
    this._MIDDLE_RIGHT = new Anchor(1.0, 0.5);
    this._BOTTOM_LEFT = new Anchor(0.0, 1.0);
    this._BOTTOM_CENTER = new Anchor(0.5, 1.0);
    this._BOTTOM_RIGHT = new Anchor(1.0, 1.0);
  }
  Companion_26.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_25;
  function Companion_getInstance_25() {
    if (Companion_instance_25 == null)
      new Companion_26();
    return Companion_instance_25;
  }
  function Anchor(sx, sy) {
    Companion_getInstance_25();
    this._sx = sx;
    this._sy = sy;
  }
  Anchor.prototype.toString = function () {
    return '' + 'Anchor(sx=' + this._sx + ', sy=' + this._sy + ')';
  };
  Anchor.prototype.hashCode = function () {
    var result = getNumberHashCode(this._sx);
    result = imul(result, 31) + getNumberHashCode(this._sy) | 0;
    return result;
  };
  Anchor.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Anchor ? other : THROW_CCE();
    if (!equals_1(this._sx, tmp0_other_with_cast._sx))
      return false;
    if (!equals_1(this._sy, tmp0_other_with_cast._sy))
      return false;
    return true;
  };
  Anchor.$metadata$ = {
    simpleName: 'Anchor',
    kind: 'class',
    interfaces: [Interpolable]
  };
  function _Angle___init__impl_(radians) {
    return radians;
  }
  function _Angle___get_radians__impl_(this_0) {
    return this_0;
  }
  function Angle__toString_impl(this_0) {
    return '' + _get_degrees_(this_0) + '.degrees';
  }
  function Companion_27() {
    Companion_instance_26 = this;
  }
  Companion_27.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_27();
    return Companion_instance_26;
  }
  function Angle__compareTo_impl(this_0, other) {
    var left = _Angle___get_radians__impl_(this_0);
    var right = _Angle___get_radians__impl_(other);
    if (left < right)
      return -1;
    if (left > right)
      return 1;
    return 0;
  }
  function Angle__compareTo_impl_0(this_0, other) {
    var tmp = this_0._radians;
    return Angle__compareTo_impl(tmp, other instanceof Angle ? other._radians : THROW_CCE());
  }
  function Angle__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function Angle__equals_impl(this_0, other) {
    if (!(other instanceof Angle))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Angle ? other._radians : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function Angle(radians) {
    Companion_getInstance_26();
    this._radians = radians;
  }
  Angle.prototype.toString = function () {
    return Angle__toString_impl(this._radians);
  };
  Angle.prototype.compareTo_ubek5g_k$ = function (other) {
    return Angle__compareTo_impl(this._radians, other);
  };
  Angle.prototype.compareTo_2c5_k$ = function (other) {
    return Angle__compareTo_impl_0(this, other);
  };
  Angle.prototype.hashCode = function () {
    return Angle__hashCode_impl(this._radians);
  };
  Angle.prototype.equals = function (other) {
    return Angle__equals_impl(this._radians, other);
  };
  Angle.$metadata$ = {
    simpleName: 'Angle',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _get_radians_(_this_) {
    var tmp0_fromRadians_0 = Companion_getInstance_26();
    return _Angle___init__impl_(_this_);
  }
  function _get_degrees_(_this_) {
    var tmp0_radiansToDegrees_0 = Companion_getInstance_26();
    var tmp1_radiansToDegrees_0 = _Angle___get_radians__impl_(_this_);
    return tmp1_radiansToDegrees_0 * 57.29577951308232;
  }
  function Angle_between(x0, y0, x1, y1) {
    var tmp0_atan2_0 = y1 - y0;
    var tmp1_atan2_0 = x1 - x0;
    var angle = Math.atan2(tmp0_atan2_0, tmp1_atan2_0);
    return angle < 0.0 ? _Angle___init__impl_(angle + 6.283185307179586) : _Angle___init__impl_(angle);
  }
  function _get_radians__0(_this_) {
    var tmp0_fromRadians_0 = Companion_getInstance_26();
    var tmp0_fromRadians_0_1 = _this_;
    return _Angle___init__impl_(tmp0_fromRadians_0_1);
  }
  function plus_5(_this_, other) {
    return _Angle___init__impl_(_Angle___get_radians__impl_(_this_) + _Angle___get_radians__impl_(other));
  }
  function _get_degrees__0(_this_) {
    var tmp0_fromDegrees_0 = Companion_getInstance_26();
    var tmp0_fromDegrees_0_1 = _this_;
    return _Angle___init__impl_(tmp0_fromDegrees_0_1 * 0.017453292519943295);
  }
  function times(_this_, scale_1) {
    return _Angle___init__impl_(_Angle___get_radians__impl_(_this_) * scale_1);
  }
  function _get_cosine_(_this_) {
    var tmp0_cos_0_1 = _Angle___get_radians__impl_(_this_);
    return Math.cos(tmp0_cos_0_1);
  }
  function _get_sine_(_this_) {
    var tmp0_sin_0_1 = _Angle___get_radians__impl_(_this_);
    return Math.sin(tmp0_sin_0_1);
  }
  function unaryMinus(_this_) {
    return _Angle___init__impl_(-_Angle___get_radians__impl_(_this_));
  }
  function minus_2(_this_, other) {
    return _Angle___init__impl_(_Angle___get_radians__impl_(_this_) - _Angle___get_radians__impl_(other));
  }
  function _get_degrees__1(_this_) {
    var tmp0_fromDegrees_0 = Companion_getInstance_26();
    return _Angle___init__impl_(_this_ * 0.017453292519943295);
  }
  function div(_this_, other) {
    return _Angle___get_radians__impl_(_this_) / _Angle___get_radians__impl_(other);
  }
  function _get_absoluteValue_(_this_) {
    var tmp1_fromRadians_0 = Companion_getInstance_26();
    var tmp0__get_absoluteValue__0 = _Angle___get_radians__impl_(_this_);
    var tmp2_fromRadians_0 = Math.abs(tmp0__get_absoluteValue__0);
    return _Angle___init__impl_(tmp2_fromRadians_0);
  }
  function div_0(_this_, scale_1) {
    return div_1(_this_, scale_1);
  }
  function times_0(_this_, scale_1) {
    return times(_this_, scale_1);
  }
  function _get_radians__1(_this_) {
    var tmp0_fromRadians_0 = Companion_getInstance_26();
    var tmp0_fromRadians_0_1 = _this_;
    return _Angle___init__impl_(tmp0_fromRadians_0_1);
  }
  function div_1(_this_, scale_1) {
    return _Angle___init__impl_(_Angle___get_radians__impl_(_this_) / scale_1);
  }
  function unaryPlus(_this_) {
    return _Angle___init__impl_(+_Angle___get_radians__impl_(_this_));
  }
  function times_1(_this_, scale_1) {
    return times(_this_, scale_1);
  }
  function Companion_28() {
    Companion_instance_27 = this;
    this._MIN = -Infinity;
    this._MAX = Infinity;
  }
  Companion_28.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_27;
  function Companion_getInstance_27() {
    if (Companion_instance_27 == null)
      new Companion_28();
    return Companion_instance_27;
  }
  function BoundsBuilder() {
    Companion_getInstance_27();
    this._tempRect = Companion_getInstance_35().invoke_0_k$();
    this._npoints = 0;
    this._xmin = Companion_getInstance_27()._MAX;
    this._xmax = Companion_getInstance_27()._MIN;
    this._ymin = Companion_getInstance_27()._MAX;
    this._ymax = Companion_getInstance_27()._MIN;
  }
  BoundsBuilder.prototype.reset_sv8swh_k$ = function () {
    this._xmin = Companion_getInstance_27()._MAX;
    this._xmax = Companion_getInstance_27()._MIN;
    this._ymin = Companion_getInstance_27()._MAX;
    this._ymax = Companion_getInstance_27()._MIN;
    this._npoints = 0;
  };
  BoundsBuilder.prototype.add_ngl742_k$ = function (x, y) {
    if (x < this._xmin)
      this._xmin = x;
    if (x > this._xmax)
      this._xmax = x;
    if (y < this._ymin)
      this._ymin = y;
    if (y > this._ymax)
      this._ymax = y;
    var tmp0_this = this;
    var tmp1 = tmp0_this._npoints;
    tmp0_this._npoints = tmp1 + 1 | 0;
    Unit_getInstance();
    return this;
  };
  BoundsBuilder.prototype.add_27zxwg_k$ = function (x, y) {
    return this.add_ngl742_k$(x, y);
  };
  BoundsBuilder.prototype.add_n7xxde_k$ = function (x, y, transform) {
    return this.add_ngl742_k$(transform.transformX_ngl742_k$(x, y), transform.transformY_ngl742_k$(x, y));
  };
  BoundsBuilder.prototype.add_uebyw0_k$ = function (rect_3) {
    if (rect_3._get_isNotEmpty__0_k$()) {
      this.add_ngl742_k$(rect_3._get_left__0_k$(), rect_3._get_top__0_k$());
      Unit_getInstance();
      this.add_ngl742_k$(rect_3._get_right__0_k$(), rect_3._get_bottom__0_k$());
      Unit_getInstance();
    }return this;
  };
  BoundsBuilder.prototype.add_st3qfk_k$ = function (rect_3, transform) {
    if (rect_3._get_isNotEmpty__0_k$()) {
      this.add_n7xxde_k$(rect_3._get_left__0_k$(), rect_3._get_top__0_k$(), transform);
      Unit_getInstance();
      this.add_n7xxde_k$(rect_3._get_right__0_k$(), rect_3._get_bottom__0_k$(), transform);
      Unit_getInstance();
    }return this;
  };
  BoundsBuilder.prototype.getBoundsOrNull_uebyw0_k$ = function (out) {
    return this._npoints === 0 ? null : out.setBounds_i6u10_k$(this._xmin, this._ymin, this._xmax, this._ymax);
  };
  BoundsBuilder.prototype.getBounds_uebyw0_k$ = function (out) {
    if (this.getBoundsOrNull_uebyw0_k$(out) == null) {
      out.setBounds_w0xdj4_k$(0, 0, 0, 0);
      Unit_getInstance();
    }return out;
  };
  BoundsBuilder.prototype.getBounds$default_3nifib_k$ = function (out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      out = Companion_getInstance_35().invoke_0_k$();
    return this.getBounds_uebyw0_k$(out);
  };
  BoundsBuilder.$metadata$ = {
    simpleName: 'BoundsBuilder',
    kind: 'class',
    interfaces: []
  };
  function Companion_29() {
    Companion_instance_28 = this;
  }
  Companion_29.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_28;
  function Companion_getInstance_28() {
    if (Companion_instance_28 == null)
      new Companion_29();
    return Companion_instance_28;
  }
  var Type_IDENTITY_instance;
  var Type_TRANSLATE_instance;
  var Type_SCALE_instance;
  var Type_SCALE_TRANSLATE_instance;
  var Type_COMPLEX_instance;
  var Type_entriesInitialized;
  function Type_initEntries() {
    if (Type_entriesInitialized)
      return Unit_getInstance();
    Type_entriesInitialized = true;
    Type_IDENTITY_instance = new Type('IDENTITY', 0, 1, false, false, false);
    Type_TRANSLATE_instance = new Type('TRANSLATE', 1, 2, false, false, true);
    Type_SCALE_instance = new Type('SCALE', 2, 3, false, true, false);
    Type_SCALE_TRANSLATE_instance = new Type('SCALE_TRANSLATE', 3, 4, false, true, true);
    Type_COMPLEX_instance = new Type('COMPLEX', 4, 5, true, true, true);
  }
  function Transform_init_$Init$(x, y, scaleX, scaleY, skewX, skewY, rotation_0, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0.0;
    if (!(($mask0 & 2) === 0))
      y = 0.0;
    if (!(($mask0 & 4) === 0))
      scaleX = 1.0;
    if (!(($mask0 & 8) === 0))
      scaleY = 1.0;
    if (!(($mask0 & 16) === 0))
      skewX = _get_radians__0(0);
    if (!(($mask0 & 32) === 0))
      skewY = _get_radians__0(0);
    if (!(($mask0 & 64) === 0))
      rotation_0 = _get_radians__0(0);
    Transform.call($this, x, y, scaleX, scaleY, skewX, skewY, rotation_0);
    return $this;
  }
  function Transform_init_$Create$(x, y, scaleX, scaleY, skewX, skewY, rotation_0, $mask0, $marker) {
    return Transform_init_$Init$(x, y, scaleX, scaleY, skewX, skewY, rotation_0, $mask0, $marker, Object.create(Transform.prototype));
  }
  function Matrix_init_$Init$(a, b, c, d, tx_0, ty_0, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      a = 1.0;
    if (!(($mask0 & 2) === 0))
      b = 0.0;
    if (!(($mask0 & 4) === 0))
      c = 0.0;
    if (!(($mask0 & 8) === 0))
      d = 1.0;
    if (!(($mask0 & 16) === 0))
      tx_0 = 0.0;
    if (!(($mask0 & 32) === 0))
      ty_0 = 0.0;
    Matrix.call($this, a, b, c, d, tx_0, ty_0);
    return $this;
  }
  function Matrix_init_$Create$(a, b, c, d, tx_0, ty_0, $mask0, $marker) {
    return Matrix_init_$Init$(a, b, c, d, tx_0, ty_0, $mask0, $marker, Object.create(Matrix.prototype));
  }
  function Companion_30() {
    Companion_instance_29 = this;
  }
  Companion_30.prototype.transformXf_ktgjr4_k$ = function (a, b, c, d, tx_0, ty_0, px, py) {
    return a * px + c * py + tx_0;
  };
  Companion_30.prototype.transformYf_ktgjr4_k$ = function (a, b, c, d, tx_0, ty_0, px, py) {
    return d * py + b * px + ty_0;
  };
  Companion_30.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_29;
  function Companion_getInstance_29() {
    if (Companion_instance_29 == null)
      new Companion_30();
    return Companion_instance_29;
  }
  function Type(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    Enum.call(this, name, ordinal);
    this._id = id;
    this._hasRotation = hasRotation;
    this._hasScale = hasScale;
    this._hasTranslation = hasTranslation;
  }
  Type.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Transform(x, y, scaleX, scaleY, skewX, skewY, rotation_0) {
    this._x_0 = x;
    this._y_0 = y;
    this._scaleX = scaleX;
    this._scaleY = scaleY;
    this._skewX = skewX;
    this._skewY = skewY;
    this._rotation = rotation_0;
  }
  Transform.prototype._get_x__0_k$ = function () {
    return this._x_0;
  };
  Transform.prototype._get_y__0_k$ = function () {
    return this._y_0;
  };
  Transform.prototype._get_scaleAvg__0_k$ = function () {
    return (this._scaleX + this._scaleY) * 0.5;
  };
  Transform.prototype.setMatrixNoReturn_skjkkf_k$ = function (matrix) {
    var PI_4 = 0.7853981633974483;
    this._x_0 = matrix._tx;
    this._y_0 = matrix._ty;
    var tmp = this;
    var tmp0_atan_0 = -matrix._c / matrix._d;
    tmp._skewX = _get_radians_(Math.atan(tmp0_atan_0));
    var tmp_0 = this;
    var tmp1_atan_0 = matrix._b / matrix._a;
    tmp_0._skewY = _get_radians_(Math.atan(tmp1_atan_0));
    if (!equals_1(new Angle(this._skewX), new Angle(this._skewX)))
      this._skewX = _get_radians_(0.0);
    if (!equals_1(new Angle(this._skewY), new Angle(this._skewY)))
      this._skewY = _get_radians_(0.0);
    var tmp_1 = this;
    var tmp_2;
    if (Angle__compareTo_impl(this._skewX, unaryMinus(_get_radians_(PI_4))) > 0 ? Angle__compareTo_impl(this._skewX, _get_radians_(PI_4)) < 0 : false) {
      var tmp_3 = matrix._d;
      var tmp2_cos_0 = this._skewX;
      var tmp0_cos_0_1 = _Angle___get_radians__impl_(tmp2_cos_0);
      tmp_2 = tmp_3 / Math.cos(tmp0_cos_0_1);
    } else {
      var tmp_4 = -matrix._c;
      var tmp3_sin_0 = this._skewX;
      var tmp0_sin_0_1 = _Angle___get_radians__impl_(tmp3_sin_0);
      tmp_2 = tmp_4 / Math.sin(tmp0_sin_0_1);
    }
    tmp_1._scaleY = tmp_2;
    var tmp_5 = this;
    var tmp_6;
    if (Angle__compareTo_impl(this._skewY, unaryMinus(_get_radians_(PI_4))) > 0 ? Angle__compareTo_impl(this._skewY, _get_radians_(PI_4)) < 0 : false) {
      var tmp_7 = matrix._a;
      var tmp4_cos_0 = this._skewY;
      var tmp0_cos_0_1_0 = _Angle___get_radians__impl_(tmp4_cos_0);
      tmp_6 = tmp_7 / Math.cos(tmp0_cos_0_1_0);
    } else {
      var tmp_8 = matrix._b;
      var tmp5_sin_0 = this._skewY;
      var tmp0_sin_0_1_0 = _Angle___get_radians__impl_(tmp5_sin_0);
      tmp_6 = tmp_8 / Math.sin(tmp0_sin_0_1_0);
    }
    tmp_5._scaleX = tmp_6;
    var tmp6_abs_0 = minus_2(this._skewX, this._skewY);
    var tmp1_fromRadians_0_1 = Companion_getInstance_26();
    var tmp0__get_absoluteValue__0_3 = _Angle___get_radians__impl_(tmp6_abs_0);
    var tmp2_fromRadians_0_2 = Math.abs(tmp0__get_absoluteValue__0_3);
    if (_Angle___get_radians__impl_(_Angle___init__impl_(tmp2_fromRadians_0_2)) < 1.0E-4) {
      this._rotation = this._skewX;
      this._skewX = _get_radians_(0.0);
      this._skewY = _get_radians_(0.0);
    } else {
      {
        this._rotation = _get_radians__0(0);
      }
    }
  };
  Transform.prototype.toString = function () {
    return '' + 'Transform(x=' + this._x_0 + ', y=' + this._y_0 + ', scaleX=' + this._scaleX + ', scaleY=' + this._scaleY + ', skewX=' + new Angle(this._skewX) + ', skewY=' + new Angle(this._skewY) + ', rotation=' + new Angle(this._rotation) + ')';
  };
  Transform.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_0);
    result = imul(result, 31) + getNumberHashCode(this._y_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scaleX) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scaleY) | 0;
    result = imul(result, 31) + Angle__hashCode_impl(this._skewX) | 0;
    result = imul(result, 31) + Angle__hashCode_impl(this._skewY) | 0;
    result = imul(result, 31) + Angle__hashCode_impl(this._rotation) | 0;
    return result;
  };
  Transform.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Transform))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Transform ? other : THROW_CCE();
    if (!equals_1(this._x_0, tmp0_other_with_cast._x_0))
      return false;
    if (!equals_1(this._y_0, tmp0_other_with_cast._y_0))
      return false;
    if (!equals_1(this._scaleX, tmp0_other_with_cast._scaleX))
      return false;
    if (!equals_1(this._scaleY, tmp0_other_with_cast._scaleY))
      return false;
    if (!equals_1(new Angle(this._skewX), new Angle(tmp0_other_with_cast._skewX)))
      return false;
    if (!equals_1(new Angle(this._skewY), new Angle(tmp0_other_with_cast._skewY)))
      return false;
    if (!equals_1(new Angle(this._rotation), new Angle(tmp0_other_with_cast._rotation)))
      return false;
    return true;
  };
  Transform.$metadata$ = {
    simpleName: 'Transform',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable, XY, XYf]
  };
  function Type_IDENTITY_getInstance() {
    Type_initEntries();
    return Type_IDENTITY_instance;
  }
  function Type_TRANSLATE_getInstance() {
    Type_initEntries();
    return Type_TRANSLATE_instance;
  }
  function Type_SCALE_getInstance() {
    Type_initEntries();
    return Type_SCALE_instance;
  }
  function Type_SCALE_TRANSLATE_getInstance() {
    Type_initEntries();
    return Type_SCALE_TRANSLATE_instance;
  }
  function Type_COMPLEX_getInstance() {
    Type_initEntries();
    return Type_COMPLEX_instance;
  }
  function Matrix(a, b, c, d, tx_0, ty_0) {
    Companion_getInstance_29();
    this._a = a;
    this._b = b;
    this._c = c;
    this._d = d;
    this._tx = tx_0;
    this._ty = ty_0;
  }
  Matrix.prototype._get_af__0_k$ = function () {
    return this._a;
  };
  Matrix.prototype._get_bf__0_k$ = function () {
    return this._b;
  };
  Matrix.prototype._get_cf__0_k$ = function () {
    return this._c;
  };
  Matrix.prototype._get_df__0_k$ = function () {
    return this._d;
  };
  Matrix.prototype._get_txf__0_k$ = function () {
    return this._tx;
  };
  Matrix.prototype._get_tyf__0_k$ = function () {
    return this._ty;
  };
  Matrix.prototype.getType_0_k$ = function () {
    var hasRotation = !(this._b === 0.0) ? true : !(this._c === 0.0);
    var hasScale = !(this._a === 1.0) ? true : !(this._d === 1.0);
    var hasTranslation = !(this._tx === 0.0) ? true : !(this._ty === 0.0);
    return hasRotation ? Type_COMPLEX_getInstance() : (hasScale ? hasTranslation : false) ? Type_SCALE_TRANSLATE_getInstance() : hasScale ? Type_SCALE_getInstance() : hasTranslation ? Type_TRANSLATE_getInstance() : Type_IDENTITY_getInstance();
  };
  Matrix.prototype.setTo_hmhsjq_k$ = function (a, b, c, d, tx_0, ty_0) {
    this._a = a;
    this._b = b;
    this._c = c;
    this._d = d;
    this._tx = tx_0;
    this._ty = ty_0;
    return this;
  };
  Matrix.prototype.copyFrom_v5f3e9_k$ = function (that) {
    if (!(that == null)) {
      this.setTo_hmhsjq_k$(that._a, that._b, that._c, that._d, that._tx, that._ty);
      Unit_getInstance();
    } else {
      this.identity_0_k$();
      Unit_getInstance();
    }
    return this;
  };
  Matrix.prototype.rotate_ubek5g_k$ = function (angle) {
    var theta_2 = _Angle___get_radians__impl_(angle);
    var cos_3 = Math.cos(theta_2);
    var sin_4 = Math.sin(theta_2);
    var a1_5 = this._a * cos_3 - this._b * sin_4;
    this._b = this._a * sin_4 + this._b * cos_3;
    this._a = a1_5;
    var c1_6 = this._c * cos_3 - this._d * sin_4;
    this._d = this._c * sin_4 + this._d * cos_3;
    this._c = c1_6;
    var tx1_7 = this._tx * cos_3 - this._ty * sin_4;
    this._ty = this._tx * sin_4 + this._ty * cos_3;
    this._tx = tx1_7;
    return this;
  };
  Matrix.prototype.skew_spjw94_k$ = function (skewX, skewY) {
    var tmp0_sin_0_1 = _Angle___get_radians__impl_(skewX);
    var sinX = Math.sin(tmp0_sin_0_1);
    var tmp0_cos_0_1 = _Angle___get_radians__impl_(skewX);
    var cosX = Math.cos(tmp0_cos_0_1);
    var tmp0_sin_0_1_0 = _Angle___get_radians__impl_(skewY);
    var sinY = Math.sin(tmp0_sin_0_1_0);
    var tmp0_cos_0_1_0 = _Angle___get_radians__impl_(skewY);
    var cosY = Math.cos(tmp0_cos_0_1_0);
    return this.setTo_hmhsjq_k$(this._a * cosY - this._b * sinX, this._a * sinY + this._b * cosX, this._c * cosY - this._d * sinX, this._c * sinY + this._d * cosX, this._tx * cosY - this._ty * sinX, this._tx * sinY + this._ty * cosX);
  };
  Matrix.prototype.scale_ngl742_k$ = function (sx, sy) {
    return this.setTo_hmhsjq_k$(this._a * sx, this._b * sx, this._c * sy, this._d * sy, this._tx * sx, this._ty * sy);
  };
  Matrix.prototype.scale_rybm4g_k$ = function (sx, sy) {
    return this.scale_ngl742_k$(sx, sy);
  };
  Matrix.prototype.prescale_ngl742_k$ = function (sx, sy) {
    return this.setTo_hmhsjq_k$(this._a * sx, this._b * sx, this._c * sy, this._d * sy, this._tx, this._ty);
  };
  Matrix.prototype.translate_ngl742_k$ = function (dx, dy) {
    var tmp0_this_2 = this;
    tmp0_this_2._tx = tmp0_this_2._tx + dx;
    var tmp1_this_3 = this;
    tmp1_this_3._ty = tmp1_this_3._ty + dy;
    return this;
  };
  Matrix.prototype.translate_27zxwg_k$ = function (dx, dy) {
    return this.translate_ngl742_k$(dx, dy);
  };
  Matrix.prototype.pretranslate_ngl742_k$ = function (dx, dy) {
    var tmp0_this_2 = this;
    tmp0_this_2._tx = tmp0_this_2._tx + (this._a * dx + this._c * dy);
    var tmp1_this_3 = this;
    tmp1_this_3._ty = tmp1_this_3._ty + (this._b * dx + this._d * dy);
    return this;
  };
  Matrix.prototype.prerotate_ubek5g_k$ = function (angle) {
    var m_2 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    m_2.rotate_ubek5g_k$(angle);
    Unit_getInstance();
    this.premultiply_lwp7hs_k$(m_2);
    Unit_getInstance();
    return this;
  };
  Matrix.prototype.premultiply_lwp7hs_k$ = function (m) {
    return this.premultiply_hmhsjq_k$(m._a, m._b, m._c, m._d, m._tx, m._ty);
  };
  Matrix.prototype.postmultiply_lwp7hs_k$ = function (m) {
    return this.multiply_yv84xs_k$(this, m);
  };
  Matrix.prototype.premultiply_hmhsjq_k$ = function (la, lb, lc, ld, ltx, lty) {
    return this.setTo_hmhsjq_k$(la * this._a + lb * this._c, la * this._b + lb * this._d, lc * this._a + ld * this._c, lc * this._b + ld * this._d, ltx * this._a + lty * this._c + this._tx, ltx * this._b + lty * this._d + this._ty);
  };
  Matrix.prototype.multiply_yv84xs_k$ = function (l, r) {
    return this.setTo_hmhsjq_k$(l._a * r._a + l._b * r._c, l._a * r._b + l._b * r._d, l._c * r._a + l._d * r._c, l._c * r._b + l._d * r._d, l._tx * r._a + l._ty * r._c + r._tx, l._tx * r._b + l._ty * r._d + r._ty);
  };
  Matrix.prototype.deltaTransformX_ngl742_k$ = function (x, y) {
    return x * this._a + y * this._c;
  };
  Matrix.prototype.identity_0_k$ = function () {
    return this.setTo_hmhsjq_k$(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
  };
  Matrix.prototype.setToNan_0_k$ = function () {
    DoubleCompanionObject_getInstance();
    DoubleCompanionObject_getInstance();
    DoubleCompanionObject_getInstance();
    DoubleCompanionObject_getInstance();
    DoubleCompanionObject_getInstance();
    DoubleCompanionObject_getInstance();
    return this.setTo_hmhsjq_k$(NaN, NaN, NaN, NaN, NaN, NaN);
  };
  Matrix.prototype.isIdentity_0_k$ = function () {
    return this.getType_0_k$().equals(Type_IDENTITY_getInstance());
  };
  Matrix.prototype.invert_lwp7hs_k$ = function (matrixToInvert) {
    var src = matrixToInvert;
    var dst = this;
    var norm = src._a * src._d - src._b * src._c;
    if (norm === 0.0) {
      dst.setTo_hmhsjq_k$(0.0, 0.0, 0.0, 0.0, -src._tx, -src._ty);
      Unit_getInstance();
    } else {
      var inorm = 1.0 / norm;
      var d = src._a * inorm;
      var a = src._d * inorm;
      var b = src._b * -inorm;
      var c = src._c * -inorm;
      dst.setTo_hmhsjq_k$(a, b, c, d, -a * src._tx - c * src._ty, -b * src._tx - d * src._ty);
      Unit_getInstance();
    }
    return this;
  };
  Matrix.prototype.inverted_lwp7hs_k$ = function (out) {
    return out.invert_lwp7hs_k$(this);
  };
  Matrix.prototype.inverted$default_3vhimr_k$ = function (out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      out = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }return this.inverted_lwp7hs_k$(out);
  };
  Matrix.prototype.setTransform_hbf2g_k$ = function (x, y, scaleX, scaleY, rotation_0, skewX, skewY) {
    if (equals_1(new Angle(skewX), new Angle(_get_radians_(0.0))) ? equals_1(new Angle(skewY), new Angle(_get_radians_(0.0))) : false) {
      if (equals_1(new Angle(rotation_0), new Angle(_get_radians__0(0)))) {
        this.setTo_hmhsjq_k$(scaleX, 0.0, 0.0, scaleY, x, y);
        Unit_getInstance();
      } else {
        var tmp0_cos_0_1 = _Angle___get_radians__impl_(rotation_0);
        var cos = Math.cos(tmp0_cos_0_1);
        var tmp0_sin_0_1 = _Angle___get_radians__impl_(rotation_0);
        var sin = Math.sin(tmp0_sin_0_1);
        this.setTo_hmhsjq_k$(cos * scaleX, sin * scaleY, -sin * scaleX, cos * scaleY, x, y);
        Unit_getInstance();
      }
    } else {
      this.identity_0_k$();
      Unit_getInstance();
      this.scale_ngl742_k$(scaleX, scaleY);
      Unit_getInstance();
      this.skew_spjw94_k$(skewX, skewY);
      Unit_getInstance();
      this.rotate_ubek5g_k$(rotation_0);
      Unit_getInstance();
      this.translate_ngl742_k$(x, y);
      Unit_getInstance();
    }
    return this;
  };
  Matrix.prototype.clone_0_k$ = function () {
    return new Matrix(this._a, this._b, this._c, this._d, this._tx, this._ty);
  };
  Matrix.prototype.toTransform_vj70ir_k$ = function (out) {
    out.setMatrixNoReturn_skjkkf_k$(this);
    return out;
  };
  Matrix.prototype.toTransform$default_888p34_k$ = function (out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      out = Transform_init_$Create$(0.0, 0.0, 0.0, 0.0, null, null, null, 127, null);
    }return this.toTransform_vj70ir_k$(out);
  };
  Matrix.prototype.transform_hj1jb5_k$ = function (px, py, out) {
    return out.setTo_ngl742_k$(this.transformX_ngl742_k$(px, py), this.transformY_ngl742_k$(px, py));
  };
  Matrix.prototype.transformX_ngl742_k$ = function (px, py) {
    return this._a * px + this._c * py + this._tx;
  };
  Matrix.prototype.transformY_ngl742_k$ = function (px, py) {
    return this._d * py + this._b * px + this._ty;
  };
  Matrix.prototype.transformXf_rybm4g_k$ = function (px, py) {
    return this.transformX_ngl742_k$(px, py);
  };
  Matrix.prototype.transformYf_rybm4g_k$ = function (px, py) {
    return this.transformY_ngl742_k$(px, py);
  };
  Matrix.prototype.setToInterpolated_1dhpa9_k$ = function (ratio, l, r) {
    return this.setTo_hmhsjq_k$(interpolate(ratio, l._a, r._a), interpolate(ratio, l._b, r._b), interpolate(ratio, l._c, r._c), interpolate(ratio, l._d, r._d), interpolate(ratio, l._tx, r._tx), interpolate(ratio, l._ty, r._ty));
  };
  Matrix.prototype.toString = function () {
    return '' + 'Matrix(a=' + this._a + ', b=' + this._b + ', c=' + this._c + ', d=' + this._d + ', tx=' + this._tx + ', ty=' + this._ty + ')';
  };
  Matrix.prototype.copy_hmhsjq_k$ = function (a, b, c, d, tx_0, ty_0) {
    return new Matrix(a, b, c, d, tx_0, ty_0);
  };
  Matrix.prototype.copy$default_oiwydk_k$ = function (a, b, c, d, tx_0, ty_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      a = this._a;
    if (!(($mask0 & 2) === 0))
      b = this._b;
    if (!(($mask0 & 4) === 0))
      c = this._c;
    if (!(($mask0 & 8) === 0))
      d = this._d;
    if (!(($mask0 & 16) === 0))
      tx_0 = this._tx;
    if (!(($mask0 & 32) === 0))
      ty_0 = this._ty;
    return this.copy_hmhsjq_k$(a, b, c, d, tx_0, ty_0);
  };
  Matrix.prototype.hashCode = function () {
    var result = getNumberHashCode(this._a);
    result = imul(result, 31) + getNumberHashCode(this._b) | 0;
    result = imul(result, 31) + getNumberHashCode(this._c) | 0;
    result = imul(result, 31) + getNumberHashCode(this._d) | 0;
    result = imul(result, 31) + getNumberHashCode(this._tx) | 0;
    result = imul(result, 31) + getNumberHashCode(this._ty) | 0;
    return result;
  };
  Matrix.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals_1(this._a, tmp0_other_with_cast._a))
      return false;
    if (!equals_1(this._b, tmp0_other_with_cast._b))
      return false;
    if (!equals_1(this._c, tmp0_other_with_cast._c))
      return false;
    if (!equals_1(this._d, tmp0_other_with_cast._d))
      return false;
    if (!equals_1(this._tx, tmp0_other_with_cast._tx))
      return false;
    if (!equals_1(this._ty, tmp0_other_with_cast._ty))
      return false;
    return true;
  };
  Matrix.$metadata$ = {
    simpleName: 'Matrix',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable]
  };
  var tempMat3D;
  var tempVec1;
  var tempVec2;
  var tempVec3;
  var tempMat1;
  function Companion_31() {
    Companion_instance_30 = this;
    this._M00 = 0;
    this._M10 = 1;
    this._M20 = 2;
    this._M30 = 3;
    this._M01 = 4;
    this._M11 = 5;
    this._M21 = 6;
    this._M31 = 7;
    this._M02 = 8;
    this._M12 = 9;
    this._M22 = 10;
    this._M32 = 11;
    this._M03 = 12;
    this._M13 = 13;
    this._M23 = 14;
    this._M33 = 15;
  }
  Companion_31.prototype.rowMajorIndex_27zxwg_k$ = function (row, column) {
    return imul(row, 4) + column | 0;
  };
  Companion_31.prototype.columnMajorIndex_27zxwg_k$ = function (row, column) {
    return imul(column, 4) + row | 0;
  };
  Companion_31.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_30;
  function Companion_getInstance_30() {
    if (Companion_instance_30 == null)
      new Companion_31();
    return Companion_instance_30;
  }
  function Matrix3D() {
    Companion_getInstance_30();
    var tmp = this;
    tmp._data_9 = new Float32Array([1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0]);
  }
  Matrix3D.prototype.get_27zxwg_k$ = function (row, column) {
    return this._data_9[Companion_getInstance_30().columnMajorIndex_27zxwg_k$(row, column)];
  };
  Matrix3D.prototype.setRows_7avoxs_k$ = function (a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, a30, a31, a32, a33) {
    Companion_getInstance_30();
    this._data_9[0] = a00;
    Companion_getInstance_30();
    this._data_9[4] = a01;
    Companion_getInstance_30();
    this._data_9[8] = a02;
    Companion_getInstance_30();
    this._data_9[12] = a03;
    Companion_getInstance_30();
    this._data_9[1] = a10;
    Companion_getInstance_30();
    this._data_9[5] = a11;
    Companion_getInstance_30();
    this._data_9[9] = a12;
    Companion_getInstance_30();
    this._data_9[13] = a13;
    Companion_getInstance_30();
    this._data_9[2] = a20;
    Companion_getInstance_30();
    this._data_9[6] = a21;
    Companion_getInstance_30();
    this._data_9[10] = a22;
    Companion_getInstance_30();
    this._data_9[14] = a23;
    Companion_getInstance_30();
    this._data_9[3] = a30;
    Companion_getInstance_30();
    this._data_9[7] = a31;
    Companion_getInstance_30();
    this._data_9[11] = a32;
    Companion_getInstance_30();
    this._data_9[15] = a33;
    return this;
  };
  Matrix3D.prototype.setColumns_7avoxs_k$ = function (a00, a10, a20, a30, a01, a11, a21, a31, a02, a12, a22, a32, a03, a13, a23, a33) {
    Companion_getInstance_30();
    this._data_9[0] = a00;
    Companion_getInstance_30();
    this._data_9[4] = a01;
    Companion_getInstance_30();
    this._data_9[8] = a02;
    Companion_getInstance_30();
    this._data_9[12] = a03;
    Companion_getInstance_30();
    this._data_9[1] = a10;
    Companion_getInstance_30();
    this._data_9[5] = a11;
    Companion_getInstance_30();
    this._data_9[9] = a12;
    Companion_getInstance_30();
    this._data_9[13] = a13;
    Companion_getInstance_30();
    this._data_9[2] = a20;
    Companion_getInstance_30();
    this._data_9[6] = a21;
    Companion_getInstance_30();
    this._data_9[10] = a22;
    Companion_getInstance_30();
    this._data_9[14] = a23;
    Companion_getInstance_30();
    this._data_9[3] = a30;
    Companion_getInstance_30();
    this._data_9[7] = a31;
    Companion_getInstance_30();
    this._data_9[11] = a32;
    Companion_getInstance_30();
    this._data_9[15] = a33;
    return this;
  };
  Matrix3D.prototype.identity_0_k$ = function () {
    return this.setColumns_7avoxs_k$(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  };
  Matrix3D.prototype.copyFrom_srku5d_k$ = function (that) {
    var inductionVariable = 0;
    if (inductionVariable < 16)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._data_9[n] = that._data_9[n];
      }
       while (inductionVariable < 16);
    return this;
  };
  Matrix3D.prototype.setToOrtho_qor328_k$ = function (left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx_0 = -(right + left) / (right - left);
    var ty_0 = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return this.setRows_7avoxs_k$(sx, 0.0, 0.0, tx_0, 0.0, sy, 0.0, ty_0, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  };
  Matrix3D.prototype.setToOrtho_tgr0io_k$ = function (rect_3, near, far) {
    return this.setToOrtho_hmhsjq_k$(rect_3._get_left__0_k$(), rect_3._get_right__0_k$(), rect_3._get_bottom__0_k$(), rect_3._get_top__0_k$(), near, far);
  };
  Matrix3D.prototype.setToOrtho_hmhsjq_k$ = function (left, right, bottom, top, near, far) {
    return this.setToOrtho_qor328_k$(left, right, bottom, top, near, far);
  };
  Matrix3D.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Matrix3D) {
      tmp = contentEquals_3(this._data_9, other._data_9);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Matrix3D.prototype.hashCode = function () {
    return contentHashCode_3(this._data_9);
  };
  Matrix3D.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_uch40_k$('Matrix3D(\n');
    Unit_getInstance();
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0_1.append_uch40_k$('  [ ');
        Unit_getInstance();
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col_6 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col_6 === 0)) {
              tmp0_apply_0_1.append_uch40_k$(', ');
              Unit_getInstance();
            }var v_7 = this.get_27zxwg_k$(row_4, col_6);
            if (Math.floor(v_7) === v_7) {
              tmp0_apply_0_1.append_wi7j7l_k$(numberToInt(v_7));
              Unit_getInstance();
            } else {
              {
                tmp0_apply_0_1.append_wi7j7l_k$(v_7);
                Unit_getInstance();
              }
            }
          }
           while (inductionVariable_0 < 4);
        tmp0_apply_0_1.append_uch40_k$(' ],\n');
        Unit_getInstance();
      }
       while (inductionVariable < 4);
    tmp0_apply_0_1.append_uch40_k$(')');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  Matrix3D.$metadata$ = {
    simpleName: 'Matrix3D',
    kind: 'class',
    interfaces: []
  };
  var MajorOrder_ROW_instance;
  var MajorOrder_COLUMN_instance;
  var MajorOrder_entriesInitialized;
  function MajorOrder_initEntries() {
    if (MajorOrder_entriesInitialized)
      return Unit_getInstance();
    MajorOrder_entriesInitialized = true;
    MajorOrder_ROW_instance = new MajorOrder('ROW', 0);
    MajorOrder_COLUMN_instance = new MajorOrder('COLUMN', 1);
  }
  function MajorOrder(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  MajorOrder.$metadata$ = {
    simpleName: 'MajorOrder',
    kind: 'class',
    interfaces: []
  };
  function setRows(_this_, a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, a30, a31, a32, a33) {
    return _this_.setRows_7avoxs_k$(a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, a30, a31, a32, a33);
  }
  function copyToFloatWxH(_this_, out, rows, columns, order, offset_0) {
    var n = offset_0;
    if (order.equals(MajorOrder_ROW_getInstance())) {
      var inductionVariable = 0;
      if (inductionVariable < columns)
        do {
          var column = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < rows)
            do {
              var row = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp2 = n;
              n = tmp2 + 1 | 0;
              out[tmp2] = _this_._data_9[Companion_getInstance_30().rowMajorIndex_27zxwg_k$(row, column)];
            }
             while (inductionVariable_0 < rows);
        }
         while (inductionVariable < columns);
    } else {
      var inductionVariable_1 = 0;
      if (inductionVariable_1 < columns)
        do {
          var column_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < rows)
            do {
              var row_0 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var tmp5 = n;
              n = tmp5 + 1 | 0;
              out[tmp5] = _this_._data_9[Companion_getInstance_30().columnMajorIndex_27zxwg_k$(row_0, column_0)];
            }
             while (inductionVariable_2 < rows);
        }
         while (inductionVariable_1 < columns);
    }
  }
  function MajorOrder_ROW_getInstance() {
    MajorOrder_initEntries();
    return MajorOrder_ROW_instance;
  }
  function MajorOrder_COLUMN_getInstance() {
    MajorOrder_initEntries();
    return MajorOrder_COLUMN_instance;
  }
  function copyFrom(_this_, that) {
    return toMatrix3D(that, _this_);
  }
  function toMatrix3D(_this_, out) {
    return setRows(out, _this_._a, _this_._c, 0.0, _this_._tx, _this_._b, _this_._d, 0.0, _this_._ty, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  function Companion_32() {
    Companion_instance_31 = this;
  }
  Companion_32.prototype.invoke_0_k$ = function () {
    return new Point(0.0, 0.0);
  };
  Companion_32.prototype.invoke_ngl742_k$ = function (x, y) {
    return new Point(x, y);
  };
  Companion_32.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_31;
  function Companion_getInstance_31() {
    if (Companion_instance_31 == null)
      new Companion_32();
    return Companion_instance_31;
  }
  function IPoint() {
  }
  IPoint.$metadata$ = {
    simpleName: 'IPoint',
    kind: 'interface',
    interfaces: []
  };
  function Point_init_$Init$(x, y, $this) {
    Point.call($this, x, y);
    return $this;
  }
  function Point_init_$Create$(x, y) {
    return Point_init_$Init$(x, y, Object.create(Point.prototype));
  }
  function Point_init_$Init$_0(x, y, $this) {
    Point.call($this, x, y);
    return $this;
  }
  function Point_init_$Create$_0(x, y) {
    return Point_init_$Init$_0(x, y, Object.create(Point.prototype));
  }
  function Companion_33() {
    Companion_instance_32 = this;
    this._Zero = Companion_getInstance_31().invoke_ngl742_k$(0.0, 0.0);
    this._One = Companion_getInstance_31().invoke_ngl742_k$(1.0, 1.0);
    this._Up = Companion_getInstance_31().invoke_ngl742_k$(0.0, 1.0);
    this._Down = Companion_getInstance_31().invoke_ngl742_k$(0.0, -1.0);
    this._Left = Companion_getInstance_31().invoke_ngl742_k$(-1.0, 0.0);
    this._Right = Companion_getInstance_31().invoke_ngl742_k$(1.0, 0.0);
  }
  Companion_33.prototype.invoke_0_k$ = function () {
    return new Point(0.0, 0.0);
  };
  Companion_33.prototype.angleArc_ghsg5b_k$ = function (a, b) {
    var tmp1_fromRadians_0 = Companion_getInstance_26();
    var tmp0_acos_0 = dot(a, b) / (_get_length_(a) * _get_length_(b));
    var tmp2_fromRadians_0 = Math.acos(tmp0_acos_0);
    return _Angle___init__impl_(tmp2_fromRadians_0);
  };
  Companion_33.prototype.angle_2vxr7h_k$ = function (ax, ay, bx, by) {
    var tmp0_between_0 = Companion_getInstance_26();
    return Angle_between(ax, ay, bx, by);
  };
  Companion_33.prototype.compare_i6u10_k$ = function (lx, ly, rx, ry) {
    var ret = compareTo(ly, ry);
    return ret === 0 ? compareTo(lx, rx) : ret;
  };
  Companion_33.prototype.distance_i6u10_k$ = function (x1, y1, x2, y2) {
    var tmp0_hypot_0 = x1 - x2;
    var tmp1_hypot_0 = y1 - y2;
    return Math.hypot(tmp0_hypot_0, tmp1_hypot_0);
  };
  Companion_33.prototype.distance_w0xdj4_k$ = function (x1, y1, x2, y2) {
    return this.distance_i6u10_k$(x1, y1, x2, y2);
  };
  Companion_33.prototype.distance_6xxxj2_k$ = function (a, b) {
    return this.distance_i6u10_k$(a._x_1, a._y_1, b._x_1, b._y_1);
  };
  Companion_33.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_32;
  function Companion_getInstance_32() {
    if (Companion_instance_32 == null)
      new Companion_33();
    return Companion_instance_32;
  }
  function Point(x, y) {
    Companion_getInstance_32();
    this._x_1 = x;
    this._y_1 = y;
  }
  Point.prototype._get_x__0_k$ = function () {
    return this._x_1;
  };
  Point.prototype._get_y__0_k$ = function () {
    return this._y_1;
  };
  Point.prototype._set_xf__cpozfn_k$ = function (value) {
    this._x_1 = value;
  };
  Point.prototype._get_xf__0_k$ = function () {
    return this._x_1;
  };
  Point.prototype._set_yf__cpozfn_k$ = function (value) {
    this._y_1 = value;
  };
  Point.prototype._get_yf__0_k$ = function () {
    return this._y_1;
  };
  Point.prototype.compareTo_jr2uc6_k$ = function (other) {
    return Companion_getInstance_32().compare_i6u10_k$(this._x_1, this._y_1, other._get_x__0_k$(), other._get_y__0_k$());
  };
  Point.prototype.compareTo_2c5_k$ = function (other) {
    return this.compareTo_jr2uc6_k$((!(other == null) ? isInterface(other, IPoint) : false) ? other : THROW_CCE());
  };
  Point.prototype.setTo_27zxwg_k$ = function (x, y) {
    return this.setTo_ngl742_k$(x, y);
  };
  Point.prototype.setTo_ngl742_k$ = function (x, y) {
    this._x_1 = x;
    this._y_1 = y;
    return this;
  };
  Point.prototype.setTo_rybm4g_k$ = function (x, y) {
    this._set_xf__cpozfn_k$(x);
    this._set_yf__cpozfn_k$(y);
    return this;
  };
  Point.prototype.copyFrom_ujo5kx_k$ = function (that) {
    return this.setTo_ngl742_k$(that._x_1, that._y_1);
  };
  Point.prototype.setToTransform_12ll73_k$ = function (mat, p) {
    return this.setToTransform_fy9432_k$(mat, p._x_1, p._y_1);
  };
  Point.prototype.setToTransform_fy9432_k$ = function (mat, x, y) {
    return this.setTo_ngl742_k$(mat.transformX_ngl742_k$(x, y), mat.transformY_ngl742_k$(x, y));
  };
  Point.prototype.setToAdd_6xxxj2_k$ = function (a, b) {
    return this.setTo_ngl742_k$(a._x_1 + b._x_1, a._y_1 + b._y_1);
  };
  Point.prototype.setToSub_6xxxj2_k$ = function (a, b) {
    return this.setTo_ngl742_k$(a._x_1 - b._x_1, a._y_1 - b._y_1);
  };
  Point.prototype.setToMul_e1b7r4_k$ = function (a, s) {
    return this.setTo_ngl742_k$(a._x_1 * s, a._y_1 * s);
  };
  Point.prototype.distanceTo_ngl742_k$ = function (x, y) {
    var tmp0_hypot_0 = x - this._x_1;
    var tmp1_hypot_0 = y - this._y_1;
    return Math.hypot(tmp0_hypot_0, tmp1_hypot_0);
  };
  Point.prototype.distanceTo_ujo5kx_k$ = function (that) {
    return this.distanceTo_ngl742_k$(that._x_1, that._y_1);
  };
  Point.prototype.angleTo_sw9sci_k$ = function (other) {
    var tmp0_between_0 = Companion_getInstance_26();
    var tmp1_between_0 = this._x_1;
    var tmp2_between_0 = this._y_1;
    var tmp3_between_0 = other._x_1;
    var tmp4_between_0 = other._y_1;
    return Angle_between(tmp1_between_0, tmp2_between_0, tmp3_between_0, tmp4_between_0);
  };
  Point.prototype.interpolateWith_10r4jk_k$ = function (ratio, other) {
    return Companion_getInstance_32().invoke_0_k$().setToInterpolated_mq48lb_k$(ratio, this, other);
  };
  Point.prototype.setToInterpolated_mq48lb_k$ = function (ratio, l, r) {
    return this.setToInterpolated_gad539_k$(ratio, l._x_1, l._y_1, r._x_1, r._y_1);
  };
  Point.prototype.setToInterpolated_gad539_k$ = function (ratio, lx, ly, rx, ry) {
    return this.setTo_ngl742_k$(interpolate(ratio, lx, rx), interpolate(ratio, ly, ry));
  };
  Point.prototype.toString = function () {
    return '' + '(' + _get_niceStr_(this._x_1) + ', ' + _get_niceStr_(this._y_1) + ')';
  };
  Point.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_1);
    result = imul(result, 31) + getNumberHashCode(this._y_1) | 0;
    return result;
  };
  Point.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Point))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Point ? other : THROW_CCE();
    if (!equals_1(this._x_1, tmp0_other_with_cast._x_1))
      return false;
    if (!equals_1(this._y_1, tmp0_other_with_cast._y_1))
      return false;
    return true;
  };
  Point.$metadata$ = {
    simpleName: 'Point',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable, Comparable, IPoint, XY, XYf]
  };
  function XY() {
  }
  XY.$metadata$ = {
    simpleName: 'XY',
    kind: 'interface',
    interfaces: [IPoint]
  };
  function XYf() {
  }
  XYf.$metadata$ = {
    simpleName: 'XYf',
    kind: 'interface',
    interfaces: []
  };
  function _get_length_(_this_) {
    var tmp0_hypot_0 = _this_._get_x__0_k$();
    var tmp1_hypot_0 = _this_._get_y__0_k$();
    return Math.hypot(tmp0_hypot_0, tmp1_hypot_0);
  }
  function dot(_this_, that) {
    return _this_._get_x__0_k$() * that._get_x__0_k$() + _this_._get_y__0_k$() * that._get_y__0_k$();
  }
  function minus_3(_this_, that) {
    return Companion_getInstance_31().invoke_ngl742_k$(_this_._get_x__0_k$() - that._get_x__0_k$(), _this_._get_y__0_k$() - that._get_y__0_k$());
  }
  function plus_6(_this_, that) {
    return Companion_getInstance_31().invoke_ngl742_k$(_this_._get_x__0_k$() + that._get_x__0_k$(), _this_._get_y__0_k$() + that._get_y__0_k$());
  }
  function times_2(_this_, scale_1) {
    return Companion_getInstance_31().invoke_ngl742_k$(_this_._get_x__0_k$() * scale_1, _this_._get_y__0_k$() * scale_1);
  }
  function _get_unit_(_this_) {
    return div_2(_this_, _get_length_(_this_));
  }
  function div_2(_this_, scale_1) {
    return Companion_getInstance_31().invoke_ngl742_k$(_this_._get_x__0_k$() / scale_1, _this_._get_y__0_k$() / scale_1);
  }
  function IPointArrayList() {
  }
  IPointArrayList.$metadata$ = {
    simpleName: 'IPointArrayList',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided__62($points) {
    this._$points = $points;
  }
  _no_name_provided__62.prototype.invoke_xoz56j_k$ = function ($this$invoke) {
    var inductionVariable = 0;
    var last_1 = this._$points._get_size__0_k$() - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this$invoke.add_ngl742_k$(this._$points.get_ha5a7z_k$(n)._get_x__0_k$(), this._$points.get_ha5a7z_k$(n)._get_y__0_k$());
        Unit_getInstance();
      }
       while (inductionVariable <= last_1);
  };
  _no_name_provided__62.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xoz56j_k$(p1 instanceof PointArrayList ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__62.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PointArrayList_init_$Init$(capacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      capacity = 7;
    PointArrayList.call($this, capacity);
    return $this;
  }
  function PointArrayList_init_$Create$(capacity, $mask0, $marker) {
    return PointArrayList_init_$Init$(capacity, $mask0, $marker, Object.create(PointArrayList.prototype));
  }
  function Companion_34() {
    Companion_instance_33 = this;
  }
  Companion_34.prototype.invoke_h6a0xc_k$ = function (capacity, callback) {
    var tmp0_apply_0 = new PointArrayList(capacity);
    callback(tmp0_apply_0);
    return tmp0_apply_0;
  };
  Companion_34.prototype.invoke_99nbow_k$ = function (points) {
    var tmp = Companion_getInstance_33();
    var tmp_0 = points._get_size__0_k$();
    return tmp.invoke_h6a0xc_k$(tmp_0, _no_name_provided_$factory_42(points));
  };
  Companion_34.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_33;
  function Companion_getInstance_33() {
    if (Companion_instance_33 == null)
      new Companion_34();
    return Companion_instance_33;
  }
  function PointArrayList(capacity) {
    Companion_getInstance_33();
    this._xList = new DoubleArrayList(capacity);
    this._yList = new DoubleArrayList(capacity);
  }
  PointArrayList.prototype._get_size__0_k$ = function () {
    return this._xList._get_size__0_k$();
  };
  PointArrayList.prototype.isNotEmpty_0_k$ = function () {
    return !(this._get_size__0_k$() === 0);
  };
  PointArrayList.prototype.clear_0_k$ = function () {
    this._xList.clear_sv8swh_k$();
    this._yList.clear_sv8swh_k$();
    return this;
  };
  PointArrayList.prototype.add_ngl742_k$ = function (x, y) {
    var tmp0_this_2 = this;
    tmp0_this_2._xList.plusAssign_okcceq_k$(x);
    var tmp1_this_3 = this;
    tmp1_this_3._yList.plusAssign_okcceq_k$(y);
    return this;
  };
  PointArrayList.prototype.toList_0_k$ = function () {
    var out = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__anonymous__3 = this.getX_ha5a7z_k$(n_2);
        var tmp1__anonymous__3 = this.getY_ha5a7z_k$(n_2);
        out.add_2bq_k$(new Point(tmp0__anonymous__3, tmp1__anonymous__3));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    return out;
  };
  PointArrayList.prototype.getX_ha5a7z_k$ = function (index_0) {
    return this._xList.getAt_ha5a7z_k$(index_0);
  };
  PointArrayList.prototype.getY_ha5a7z_k$ = function (index_0) {
    return this._yList.getAt_ha5a7z_k$(index_0);
  };
  PointArrayList.prototype.toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.append_wi8o78_k$(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.getX_ha5a7z_k$(n);
        var y = this.getY_ha5a7z_k$(n);
        if (!(n === 0)) {
          sb.append_uch40_k$(', ');
          Unit_getInstance();
        }sb.append_wi8o78_k$(new Char(40));
        Unit_getInstance();
        if (x === round(x)) {
          sb.append_wi7j7l_k$(numberToInt(x));
          Unit_getInstance();
        } else {
          sb.append_wi7j7l_k$(x);
          Unit_getInstance();
        }
        sb.append_uch40_k$(', ');
        Unit_getInstance();
        if (y === round(y)) {
          sb.append_wi7j7l_k$(numberToInt(y));
          Unit_getInstance();
        } else {
          sb.append_wi7j7l_k$(y);
          Unit_getInstance();
        }
        sb.append_wi8o78_k$(new Char(41));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    sb.append_wi8o78_k$(new Char(93));
    Unit_getInstance();
    return sb.toString();
  };
  PointArrayList.$metadata$ = {
    simpleName: 'PointArrayList',
    kind: 'class',
    interfaces: [IPointArrayList]
  };
  function Companion_35() {
    Companion_instance_34 = this;
  }
  Companion_35.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_34;
  function Companion_getInstance_34() {
    if (Companion_instance_34 == null)
      new Companion_35();
    return Companion_instance_34;
  }
  function PointIntArrayList(capacity) {
    Companion_getInstance_34();
    var tmp = this;
    tmp._$$delegate_0 = Mixin_init_$Create$(null, 1, null);
    this._xList_0 = new IntArrayList(capacity);
    this._yList_0 = new IntArrayList(capacity);
  }
  PointIntArrayList.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0._set_extra__n1onou_k$(_set___);
  };
  PointIntArrayList.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0._get_extra__0_k$();
  };
  PointIntArrayList.prototype._get_size__0_k$ = function () {
    return this._xList_0._get_size__0_k$();
  };
  PointIntArrayList.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  PointIntArrayList.prototype.clear_sv8swh_k$ = function () {
    this._xList_0.clear_sv8swh_k$();
    this._yList_0.clear_sv8swh_k$();
  };
  PointIntArrayList.prototype.add_27zxwg_k$ = function (x, y) {
    var tmp0_this_2 = this;
    tmp0_this_2._xList_0.plusAssign_majfzk_k$(x);
    var tmp1_this_3 = this;
    tmp1_this_3._yList_0.plusAssign_majfzk_k$(y);
    return this;
  };
  PointIntArrayList.prototype.getX_ha5a7z_k$ = function (index_0) {
    return this._xList_0.getAt_ha5a7z_k$(index_0);
  };
  PointIntArrayList.prototype.getY_ha5a7z_k$ = function (index_0) {
    return this._yList_0.getAt_ha5a7z_k$(index_0);
  };
  PointIntArrayList.prototype.toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.append_wi8o78_k$(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.getX_ha5a7z_k$(n);
        var y = this.getY_ha5a7z_k$(n);
        if (!(n === 0)) {
          sb.append_uch40_k$(', ');
          Unit_getInstance();
        }sb.append_wi8o78_k$(new Char(40));
        Unit_getInstance();
        sb.append_wi7j7l_k$(x);
        Unit_getInstance();
        sb.append_uch40_k$(', ');
        Unit_getInstance();
        sb.append_wi7j7l_k$(y);
        Unit_getInstance();
        sb.append_wi8o78_k$(new Char(41));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    sb.append_wi8o78_k$(new Char(93));
    Unit_getInstance();
    return sb.toString();
  };
  PointIntArrayList.$metadata$ = {
    simpleName: 'PointIntArrayList',
    kind: 'class',
    interfaces: [IPointIntArrayList, Extra]
  };
  function IPointIntArrayList() {
  }
  IPointIntArrayList.$metadata$ = {
    simpleName: 'IPointIntArrayList',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_42($points) {
    var i = new _no_name_provided__62($points);
    return function (p1) {
      i.invoke_xoz56j_k$(p1);
      return Unit_getInstance();
    };
  }
  function Companion_36() {
    Companion_instance_35 = this;
  }
  Companion_36.prototype.invoke_0_k$ = function () {
    return new Rectangle(0.0, 0.0, 0.0, 0.0);
  };
  Companion_36.prototype.invoke_w0xdj4_k$ = function (x, y, width, height) {
    return new Rectangle(x, y, width, height);
  };
  Companion_36.prototype.fromBounds_i6u10_k$ = function (left, top, right, bottom) {
    return Companion_getInstance_35().invoke_0_k$().setBounds_i6u10_k$(left, top, right, bottom);
  };
  Companion_36.prototype.isContainedIn_x1ktds_k$ = function (a, b) {
    return ((a._x_2 >= b._x_2 ? a._y_2 >= b._y_2 : false) ? a._x_2 + a._width_0 <= b._x_2 + b._width_0 : false) ? a._y_2 + a._height_0 <= b._y_2 + b._height_0 : false;
  };
  Companion_36.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_35;
  function Companion_getInstance_35() {
    if (Companion_instance_35 == null)
      new Companion_36();
    return Companion_instance_35;
  }
  function Rectangle(x, y, width, height) {
    Companion_getInstance_35();
    this._x_2 = x;
    this._y_2 = y;
    this._width_0 = width;
    this._height_0 = height;
  }
  Rectangle.prototype._get_x__0_k$ = function () {
    return this._x_2;
  };
  Rectangle.prototype._get_y__0_k$ = function () {
    return this._y_2;
  };
  Rectangle.prototype._get_width__0_k$ = function () {
    return this._width_0;
  };
  Rectangle.prototype._get_height__0_k$ = function () {
    return this._height_0;
  };
  Rectangle.prototype._get_isNotEmpty__0_k$ = function () {
    return !(this._get_area__0_k$() === 0.0);
  };
  Rectangle.prototype._get_area__0_k$ = function () {
    return this._width_0 * this._height_0;
  };
  Rectangle.prototype._get_left__0_k$ = function () {
    return this._x_2;
  };
  Rectangle.prototype._set_top__okcceq_k$ = function (value) {
    this._y_2 = value;
    return Unit_getInstance();
  };
  Rectangle.prototype._get_top__0_k$ = function () {
    return this._y_2;
  };
  Rectangle.prototype._get_right__0_k$ = function () {
    return this._x_2 + this._width_0;
  };
  Rectangle.prototype._get_bottom__0_k$ = function () {
    return this._y_2 + this._height_0;
  };
  Rectangle.prototype._get_size__qyi6qb_k$ = function () {
    return Companion_getInstance_38().invoke_9i800l_k$(this._width_0, this._height_0);
  };
  Rectangle.prototype.setTo_i6u10_k$ = function (x, y, width, height) {
    this._x_2 = x;
    this._y_2 = y;
    this._width_0 = width;
    this._height_0 = height;
    return this;
  };
  Rectangle.prototype.setTo_bha9a8_k$ = function (x, y, width, height) {
    return this.setTo_i6u10_k$(x, y, width, height);
  };
  Rectangle.prototype.copyFrom_uebyw0_k$ = function (that) {
    return this.setTo_i6u10_k$(that._x_2, that._y_2, that._width_0, that._height_0);
  };
  Rectangle.prototype.setBounds_i6u10_k$ = function (left, top, right, bottom) {
    return this.setTo_i6u10_k$(left, top, right - left, bottom - top);
  };
  Rectangle.prototype.setBounds_w0xdj4_k$ = function (left, top, right, bottom) {
    return this.setBounds_i6u10_k$(left, top, right, bottom);
  };
  Rectangle.prototype.intersects_uebyw0_k$ = function (that) {
    return this.intersectsX_uebyw0_k$(that) ? this.intersectsY_uebyw0_k$(that) : false;
  };
  Rectangle.prototype.intersectsX_uebyw0_k$ = function (that) {
    return that._get_left__0_k$() <= this._get_right__0_k$() ? that._get_right__0_k$() >= this._get_left__0_k$() : false;
  };
  Rectangle.prototype.intersectsY_uebyw0_k$ = function (that) {
    return that._get_top__0_k$() <= this._get_bottom__0_k$() ? that._get_bottom__0_k$() >= this._get_top__0_k$() : false;
  };
  Rectangle.prototype.setToIntersection_x1ktds_k$ = function (a, b) {
    return !(a.intersection_x1ktds_k$(b, this) == null) ? this : null;
  };
  Rectangle.prototype.intersection_x1ktds_k$ = function (that, target) {
    var tmp;
    if (this.intersects_uebyw0_k$(that)) {
      var tmp0_max_0 = this._get_left__0_k$();
      var tmp1_max_0 = that._get_left__0_k$();
      var tmp_0 = Math.max(tmp0_max_0, tmp1_max_0);
      var tmp2_max_0 = this._get_top__0_k$();
      var tmp3_max_0 = that._get_top__0_k$();
      var tmp_1 = Math.max(tmp2_max_0, tmp3_max_0);
      var tmp4_min_0 = this._get_right__0_k$();
      var tmp5_min_0 = that._get_right__0_k$();
      var tmp_2 = Math.min(tmp4_min_0, tmp5_min_0);
      var tmp6_min_0 = this._get_bottom__0_k$();
      var tmp7_min_0 = that._get_bottom__0_k$();
      tmp = target.setBounds_i6u10_k$(tmp_0, tmp_1, tmp_2, Math.min(tmp6_min_0, tmp7_min_0));
    } else {
      tmp = null;
    }
    return tmp;
  };
  Rectangle.prototype.displace_ngl742_k$ = function (dx, dy) {
    return this.setTo_i6u10_k$(this._x_2 + dx, this._y_2 + dy, this._width_0, this._height_0);
  };
  Rectangle.prototype.inflate_i6u10_k$ = function (left, top, right, bottom) {
    return this.setBounds_i6u10_k$(this._get_left__0_k$() - left, this._get_top__0_k$() - top, this._get_right__0_k$() + right, this._get_bottom__0_k$() + bottom);
  };
  Rectangle.prototype.inflate$default_n82wze_k$ = function (left, top, right, bottom, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      top = left;
    if (!(($mask0 & 4) === 0))
      right = left;
    if (!(($mask0 & 8) === 0))
      bottom = top;
    return this.inflate_i6u10_k$(left, top, right, bottom);
  };
  Rectangle.prototype.clear_0_k$ = function () {
    return this.setTo_i6u10_k$(0.0, 0.0, 0.0, 0.0);
  };
  Rectangle.prototype.clone_0_k$ = function () {
    return new Rectangle(this._x_2, this._y_2, this._width_0, this._height_0);
  };
  Rectangle.prototype.setToAnchoredRectangle_s80lk4_k$ = function (item, anchor_2, container) {
    return this.setToAnchoredRectangle_amjtkc_k$(item._get_size__qyi6qb_k$(), anchor_2, container);
  };
  Rectangle.prototype.setToAnchoredRectangle_amjtkc_k$ = function (item, anchor_2, container) {
    return this.setTo_i6u10_k$(container._x_2 + anchor_2._sx * (container._width_0 - _Size___get_width__impl_(item)), container._y_2 + anchor_2._sy * (container._height_0 - _Size___get_height__impl_(item)), _Size___get_width__impl_(item), _Size___get_height__impl_(item));
  };
  Rectangle.prototype.toString = function () {
    return '' + 'Rectangle(x=' + _get_niceStr_(this._x_2) + ', y=' + _get_niceStr_(this._y_2) + ', width=' + _get_niceStr_(this._width_0) + ', height=' + _get_niceStr_(this._height_0) + ')';
  };
  Rectangle.prototype.toInt_t4v1qq_k$ = function () {
    return Companion_getInstance_36().invoke_x6iaui_k$(this._x_2, this._y_2, this._width_0, this._height_0);
  };
  Rectangle.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_2);
    result = imul(result, 31) + getNumberHashCode(this._y_2) | 0;
    result = imul(result, 31) + getNumberHashCode(this._width_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._height_0) | 0;
    return result;
  };
  Rectangle.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals_1(this._x_2, tmp0_other_with_cast._x_2))
      return false;
    if (!equals_1(this._y_2, tmp0_other_with_cast._y_2))
      return false;
    if (!equals_1(this._width_0, tmp0_other_with_cast._width_0))
      return false;
    if (!equals_1(this._height_0, tmp0_other_with_cast._height_0))
      return false;
    return true;
  };
  Rectangle.$metadata$ = {
    simpleName: 'Rectangle',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable, IRectangle, Sizeable]
  };
  function IRectangle() {
  }
  IRectangle.$metadata$ = {
    simpleName: 'IRectangle',
    kind: 'interface',
    interfaces: []
  };
  function _RectangleInt___init__impl_(rect_3) {
    return rect_3;
  }
  function _RectangleInt___get_rect__impl_(this_0) {
    return this_0;
  }
  function _RectangleInt___set_x__impl_(this_0, value) {
    _RectangleInt___get_rect__impl_(this_0)._x_2 = value;
    return Unit_getInstance();
  }
  function _RectangleInt___get_x__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._x_2);
  }
  function _RectangleInt___set_y__impl_(this_0, value) {
    _RectangleInt___get_rect__impl_(this_0)._y_2 = value;
    return Unit_getInstance();
  }
  function _RectangleInt___get_y__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._y_2);
  }
  function _RectangleInt___set_width__impl_(this_0, value) {
    _RectangleInt___get_rect__impl_(this_0)._width_0 = value;
    return Unit_getInstance();
  }
  function _RectangleInt___get_width__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._width_0);
  }
  function _RectangleInt___set_height__impl_(this_0, value) {
    _RectangleInt___get_rect__impl_(this_0)._height_0 = value;
    return Unit_getInstance();
  }
  function _RectangleInt___get_height__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._height_0);
  }
  function _RectangleInt___get_left__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._get_left__0_k$());
  }
  function _RectangleInt___get_top__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._get_top__0_k$());
  }
  function _RectangleInt___get_right__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._get_right__0_k$());
  }
  function _RectangleInt___get_bottom__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._get_bottom__0_k$());
  }
  function Companion_37() {
    Companion_instance_36 = this;
  }
  Companion_37.prototype.invoke_t4v1qq_k$ = function () {
    return _RectangleInt___init__impl_(Companion_getInstance_35().invoke_0_k$());
  };
  Companion_37.prototype.invoke_ihmn6a_k$ = function (x, y, width, height) {
    return _RectangleInt___init__impl_(Companion_getInstance_35().invoke_w0xdj4_k$(x, y, width, height));
  };
  Companion_37.prototype.invoke_x6iaui_k$ = function (x, y, width, height) {
    return _RectangleInt___init__impl_(new Rectangle(x, y, width, height));
  };
  Companion_37.prototype.fromBounds_ihmn6a_k$ = function (left, top, right, bottom) {
    return Companion_getInstance_36().invoke_ihmn6a_k$(left, top, right - left | 0, bottom - top | 0);
  };
  Companion_37.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_36;
  function Companion_getInstance_36() {
    if (Companion_instance_36 == null)
      new Companion_37();
    return Companion_instance_36;
  }
  function RectangleInt__toString_impl(this_0) {
    return '' + 'Rectangle(x=' + _RectangleInt___get_x__impl_(this_0) + ', y=' + _RectangleInt___get_y__impl_(this_0) + ', width=' + _RectangleInt___get_width__impl_(this_0) + ', height=' + _RectangleInt___get_height__impl_(this_0) + ')';
  }
  function RectangleInt__hashCode_impl(this_0) {
    return this_0.hashCode();
  }
  function RectangleInt__equals_impl(this_0, other) {
    if (!(other instanceof RectangleInt))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RectangleInt ? other._rect : THROW_CCE();
    if (!this_0.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function RectangleInt(rect_3) {
    Companion_getInstance_36();
    this._rect = rect_3;
  }
  RectangleInt.prototype._get_x__0_k$ = function () {
    return _RectangleInt___get_x__impl_(this._rect);
  };
  RectangleInt.prototype._get_y__0_k$ = function () {
    return _RectangleInt___get_y__impl_(this._rect);
  };
  RectangleInt.prototype._get_width__0_k$ = function () {
    return _RectangleInt___get_width__impl_(this._rect);
  };
  RectangleInt.prototype._get_height__0_k$ = function () {
    return _RectangleInt___get_height__impl_(this._rect);
  };
  RectangleInt.prototype.toString = function () {
    return RectangleInt__toString_impl(this._rect);
  };
  RectangleInt.prototype.hashCode = function () {
    return RectangleInt__hashCode_impl(this._rect);
  };
  RectangleInt.prototype.equals = function (other) {
    return RectangleInt__equals_impl(this._rect, other);
  };
  RectangleInt.$metadata$ = {
    simpleName: 'RectangleInt',
    kind: 'class',
    interfaces: [IRectangleInt]
  };
  function IRectangleInt() {
  }
  IRectangleInt.$metadata$ = {
    simpleName: 'IRectangleInt',
    kind: 'interface',
    interfaces: []
  };
  function contains_9(_this_, x, y) {
    return (x >= _get_left__0(_this_) ? x < _get_right__0(_this_) : false) ? y >= _get_top_(_this_) ? y < _get_bottom_(_this_) : false : false;
  }
  function _get_float_(_this_) {
    return Companion_getInstance_35().invoke_w0xdj4_k$(_this_._get_x__0_k$(), _this_._get_y__0_k$(), _this_._get_width__0_k$(), _this_._get_height__0_k$());
  }
  function bounds(_this_, target) {
    var first_2 = true;
    var left = 0.0;
    var right = 0.0;
    var top = 0.0;
    var bottom = 0.0;
    var tmp0_iterator = _this_.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var r = tmp0_iterator.next_0_k$();
      if (first_2) {
        left = _get_left__0(r);
        right = _get_right__0(r);
        top = _get_top_(r);
        bottom = _get_bottom_(r);
        first_2 = false;
      } else {
        var tmp0_min_0 = left;
        var tmp1_min_0 = _get_left__0(r);
        left = Math.min(tmp0_min_0, tmp1_min_0);
        var tmp2_max_0 = right;
        var tmp3_max_0 = _get_right__0(r);
        right = Math.max(tmp2_max_0, tmp3_max_0);
        var tmp4_min_0 = top;
        var tmp5_min_0 = _get_top_(r);
        top = Math.min(tmp4_min_0, tmp5_min_0);
        var tmp6_max_0 = bottom;
        var tmp7_max_0 = _get_bottom_(r);
        bottom = Math.max(tmp6_max_0, tmp7_max_0);
      }
    }
    return target.setBounds_i6u10_k$(left, top, right, bottom);
  }
  function _get_topLeft_(_this_) {
    return new Point(_get_left__0(_this_), _get_top_(_this_));
  }
  function _get_topRight_(_this_) {
    return new Point(_get_right__0(_this_), _get_top_(_this_));
  }
  function _get_bottomRight_(_this_) {
    return new Point(_get_right__0(_this_), _get_bottom_(_this_));
  }
  function _get_bottomLeft_(_this_) {
    return new Point(_get_left__0(_this_), _get_bottom_(_this_));
  }
  function applyTransform(_this_, m) {
    var l = m.transformX_ngl742_k$(_this_._get_left__0_k$(), _this_._get_top__0_k$());
    var t = m.transformY_ngl742_k$(_this_._get_left__0_k$(), _this_._get_top__0_k$());
    var r = m.transformX_ngl742_k$(_this_._get_right__0_k$(), _this_._get_bottom__0_k$());
    var b = m.transformY_ngl742_k$(_this_._get_right__0_k$(), _this_._get_bottom__0_k$());
    return _this_.setTo_i6u10_k$(l, t, r - l, b - t);
  }
  function setTo(_this_, x, y, width, height) {
    _RectangleInt___set_x__impl_(_this_, x);
    _RectangleInt___set_y__impl_(_this_, y);
    _RectangleInt___set_width__impl_(_this_, width);
    _RectangleInt___set_height__impl_(_this_, height);
    return _this_;
  }
  function _get_left__0(_this_) {
    return _this_._get_x__0_k$();
  }
  function _get_right__0(_this_) {
    return _this_._get_x__0_k$() + _this_._get_width__0_k$();
  }
  function _get_top_(_this_) {
    return _this_._get_y__0_k$();
  }
  function _get_bottom_(_this_) {
    return _this_._get_y__0_k$() + _this_._get_height__0_k$();
  }
  function _get_left__1(_this_) {
    return _this_._get_x__0_k$();
  }
  function _get_top__0(_this_) {
    return _this_._get_y__0_k$();
  }
  function _get_right__1(_this_) {
    return _this_._get_x__0_k$() + _this_._get_width__0_k$() | 0;
  }
  function _get_bottom__0(_this_) {
    return _this_._get_y__0_k$() + _this_._get_height__0_k$() | 0;
  }
  function _no_name_provided__63() {
  }
  _no_name_provided__63.prototype.invoke_9zgql_k$ = function (c, iw, ih, cw, ch) {
    var s0 = cw / iw;
    var s1 = ch / ih;
    var s = Math.max(s0, s1);
    return c === 0 ? iw * s : ih * s;
  };
  _no_name_provided__63.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    return this.invoke_9zgql_k$(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
  };
  _no_name_provided__63.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__64() {
  }
  _no_name_provided__64.prototype.invoke_9zgql_k$ = function (c, iw, ih, cw, ch) {
    var s0 = cw / iw;
    var s1 = ch / ih;
    var s = Math.min(s0, s1);
    return c === 0 ? iw * s : ih * s;
  };
  _no_name_provided__64.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    return this.invoke_9zgql_k$(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
  };
  _no_name_provided__64.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__65() {
  }
  _no_name_provided__65.prototype.invoke_9zgql_k$ = function (c, iw, ih, cw, ch) {
    return c === 0 ? cw : ch;
  };
  _no_name_provided__65.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    return this.invoke_9zgql_k$(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
  };
  _no_name_provided__65.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__66() {
  }
  _no_name_provided__66.prototype.invoke_9zgql_k$ = function (c, iw, ih, cw, ch) {
    return c === 0 ? iw : ih;
  };
  _no_name_provided__66.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    return this.invoke_9zgql_k$(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
  };
  _no_name_provided__66.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_38() {
    Companion_instance_37 = this;
    var tmp = this;
    tmp._COVER = new ScaleMode(_no_name_provided_$factory_43());
    var tmp_0 = this;
    tmp_0._SHOW_ALL = new ScaleMode(_no_name_provided_$factory_44());
    var tmp_1 = this;
    tmp_1._EXACT = new ScaleMode(_no_name_provided_$factory_45());
    var tmp_2 = this;
    tmp_2._NO_SCALE = new ScaleMode(_no_name_provided_$factory_46());
  }
  Companion_38.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_37;
  function Companion_getInstance_37() {
    if (Companion_instance_37 == null)
      new Companion_38();
    return Companion_instance_37;
  }
  function ScaleMode(transform) {
    Companion_getInstance_37();
    this._transform = transform;
  }
  ScaleMode.prototype.transformW_i6u10_k$ = function (iw, ih, cw, ch) {
    return this._transform(0, iw, ih, cw, ch);
  };
  ScaleMode.prototype.transformH_i6u10_k$ = function (iw, ih, cw, ch) {
    return this._transform(1, iw, ih, cw, ch);
  };
  ScaleMode.prototype.invoke_2hy4zr_k$ = function (item, container, target) {
    return setTo_0(target, numberToInt(this.transformW_i6u10_k$(_SizeInt___get_width__impl_(item), _SizeInt___get_height__impl_(item), _SizeInt___get_width__impl_(container), _SizeInt___get_height__impl_(container))), numberToInt(this.transformH_i6u10_k$(_SizeInt___get_width__impl_(item), _SizeInt___get_height__impl_(item), _SizeInt___get_width__impl_(container), _SizeInt___get_height__impl_(container))));
  };
  ScaleMode.$metadata$ = {
    simpleName: 'ScaleMode',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_43() {
    var i = new _no_name_provided__63();
    return function (p1, p2, p3, p4, p5) {
      return i.invoke_9zgql_k$(p1, p2, p3, p4, p5);
    };
  }
  function _no_name_provided_$factory_44() {
    var i = new _no_name_provided__64();
    return function (p1, p2, p3, p4, p5) {
      return i.invoke_9zgql_k$(p1, p2, p3, p4, p5);
    };
  }
  function _no_name_provided_$factory_45() {
    var i = new _no_name_provided__65();
    return function (p1, p2, p3, p4, p5) {
      return i.invoke_9zgql_k$(p1, p2, p3, p4, p5);
    };
  }
  function _no_name_provided_$factory_46() {
    var i = new _no_name_provided__66();
    return function (p1, p2, p3, p4, p5) {
      return i.invoke_9zgql_k$(p1, p2, p3, p4, p5);
    };
  }
  function Sizeable() {
  }
  Sizeable.$metadata$ = {
    simpleName: 'Sizeable',
    kind: 'interface',
    interfaces: []
  };
  function ISize() {
  }
  ISize.$metadata$ = {
    simpleName: 'ISize',
    kind: 'interface',
    interfaces: []
  };
  function _Size___init__impl_(p) {
    return p;
  }
  function _Size___get_p__impl_(this_0) {
    return this_0;
  }
  function Companion_39() {
    Companion_instance_38 = this;
  }
  Companion_39.prototype.invoke_9i800l_k$ = function (width, height) {
    return _Size___init__impl_(new Point(width, height));
  };
  Companion_39.prototype.invoke_5hnyrx_k$ = function (width, height) {
    return _Size___init__impl_(Point_init_$Create$_0(width, height));
  };
  Companion_39.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_38;
  function Companion_getInstance_38() {
    if (Companion_instance_38 == null)
      new Companion_39();
    return Companion_instance_38;
  }
  function _Size___set_width__impl_(this_0, value) {
    _Size___get_p__impl_(this_0)._x_1 = value;
    return Unit_getInstance();
  }
  function _Size___get_width__impl_(this_0) {
    return _Size___get_p__impl_(this_0)._x_1;
  }
  function _Size___set_height__impl_(this_0, value) {
    _Size___get_p__impl_(this_0)._y_1 = value;
    return Unit_getInstance();
  }
  function _Size___get_height__impl_(this_0) {
    return _Size___get_p__impl_(this_0)._y_1;
  }
  function Size__toString_impl(this_0) {
    return '' + 'Size(width=' + _get_niceStr_(_Size___get_width__impl_(this_0)) + ', height=' + _get_niceStr_(_Size___get_height__impl_(this_0)) + ')';
  }
  function Size__hashCode_impl(this_0) {
    return this_0.hashCode();
  }
  function Size__equals_impl(this_0, other) {
    if (!(other instanceof Size))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Size ? other._p : THROW_CCE();
    if (!this_0.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function Size(p) {
    Companion_getInstance_38();
    this._p = p;
  }
  Size.prototype.toString = function () {
    return Size__toString_impl(this._p);
  };
  Size.prototype.hashCode = function () {
    return Size__hashCode_impl(this._p);
  };
  Size.prototype.equals = function (other) {
    return Size__equals_impl(this._p, other);
  };
  Size.$metadata$ = {
    simpleName: 'Size',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable, ISize, Sizeable]
  };
  function _SizeInt___init__impl_(size_2) {
    new Size(size_2);
    return size_2;
  }
  function _SizeInt___get_size__impl_(this_0) {
    return this_0;
  }
  function Companion_40() {
    Companion_instance_39 = this;
  }
  Companion_40.prototype.invoke_qgazdw_k$ = function () {
    return _SizeInt___init__impl_(Companion_getInstance_38().invoke_5hnyrx_k$(0, 0));
  };
  Companion_40.prototype.invoke_aaxa64_k$ = function (x, y) {
    return _SizeInt___init__impl_(Companion_getInstance_38().invoke_5hnyrx_k$(x, y));
  };
  Companion_40.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_39;
  function Companion_getInstance_39() {
    if (Companion_instance_39 == null)
      new Companion_40();
    return Companion_instance_39;
  }
  function _SizeInt___set_width__impl_(this_0, value) {
    return _Size___set_width__impl_(_SizeInt___get_size__impl_(this_0), value);
  }
  function _SizeInt___get_width__impl_(this_0) {
    return numberToInt(_Size___get_width__impl_(_SizeInt___get_size__impl_(this_0)));
  }
  function _SizeInt___set_height__impl_(this_0, value) {
    return _Size___set_height__impl_(_SizeInt___get_size__impl_(this_0), value);
  }
  function _SizeInt___get_height__impl_(this_0) {
    return numberToInt(_Size___get_height__impl_(_SizeInt___get_size__impl_(this_0)));
  }
  function SizeInt__toString_impl(this_0) {
    return '' + 'SizeInt(width=' + _SizeInt___get_width__impl_(this_0) + ', height=' + _SizeInt___get_height__impl_(this_0) + ')';
  }
  function SizeInt__hashCode_impl(this_0) {
    return Size__hashCode_impl(this_0);
  }
  function SizeInt__equals_impl(this_0, other) {
    if (!(other instanceof SizeInt))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SizeInt ? other._size_3 : THROW_CCE();
    if (!equals_1(new Size(this_0), new Size(tmp0_other_with_cast)))
      return false;
    return true;
  }
  function SizeInt(size_2) {
    Companion_getInstance_39();
    this._size_3 = size_2;
  }
  SizeInt.prototype.toString = function () {
    return SizeInt__toString_impl(this._size_3);
  };
  SizeInt.prototype.hashCode = function () {
    return SizeInt__hashCode_impl(this._size_3);
  };
  SizeInt.prototype.equals = function (other) {
    return SizeInt__equals_impl(this._size_3, other);
  };
  SizeInt.$metadata$ = {
    simpleName: 'SizeInt',
    kind: 'class',
    interfaces: [ISizeInt]
  };
  function setTo_0(_this_, width, height) {
    _SizeInt___set_width__impl_(_this_, width);
    _SizeInt___set_height__impl_(_this_, height);
    return _this_;
  }
  function ISizeInt() {
  }
  ISizeInt.$metadata$ = {
    simpleName: 'ISizeInt',
    kind: 'interface',
    interfaces: []
  };
  function IVector3() {
  }
  IVector3.$metadata$ = {
    simpleName: 'IVector3',
    kind: 'interface',
    interfaces: []
  };
  function MVector3() {
  }
  MVector3.$metadata$ = {
    simpleName: 'MVector3',
    kind: 'interface',
    interfaces: [IVector3]
  };
  function Companion_41() {
    Companion_instance_40 = this;
  }
  Companion_41.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_40;
  function Companion_getInstance_40() {
    if (Companion_instance_40 == null)
      new Companion_41();
    return Companion_instance_40;
  }
  function Vector3D() {
    Companion_getInstance_40();
    var tmp = this;
    tmp._data_10 = new Float32Array([0.0, 0.0, 0.0, 1.0]);
  }
  Vector3D.prototype._get_x__0_k$ = function () {
    return this._data_10[0];
  };
  Vector3D.prototype._get_y__0_k$ = function () {
    return this._data_10[1];
  };
  Vector3D.prototype._get_z__0_k$ = function () {
    return this._data_10[2];
  };
  Vector3D.prototype._get_w__0_k$ = function () {
    return this._data_10[3];
  };
  Vector3D.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Vector3D) {
      tmp_2 = almostEquals(this._get_x__0_k$(), other._get_x__0_k$());
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = almostEquals(this._get_y__0_k$(), other._get_y__0_k$());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = almostEquals(this._get_z__0_k$(), other._get_z__0_k$());
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = almostEquals(this._get_w__0_k$(), other._get_w__0_k$());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Vector3D.prototype.hashCode = function () {
    return contentHashCode_3(this._data_10);
  };
  Vector3D.prototype.toString = function () {
    return this._get_w__0_k$() === 1.0 ? '' + '(' + _get_niceStr__0(this._get_x__0_k$()) + ', ' + _get_niceStr__0(this._get_y__0_k$()) + ', ' + _get_niceStr__0(this._get_z__0_k$()) + ')' : '' + '(' + _get_niceStr__0(this._get_x__0_k$()) + ', ' + _get_niceStr__0(this._get_y__0_k$()) + ', ' + _get_niceStr__0(this._get_z__0_k$()) + ', ' + _get_niceStr__0(this._get_w__0_k$()) + ')';
  };
  Vector3D.$metadata$ = {
    simpleName: 'Vector3D',
    kind: 'class',
    interfaces: [MVector3]
  };
  function Temp() {
    this._tvalues = new Float64Array(6);
    this._xvalues = new Float64Array(8);
    this._yvalues = new Float64Array(8);
    this._tpoint0 = Companion_getInstance_32().invoke_0_k$();
    this._tpoint1 = Companion_getInstance_32().invoke_0_k$();
    this._tpoint2 = Companion_getInstance_32().invoke_0_k$();
    this._tpoint3 = Companion_getInstance_32().invoke_0_k$();
  }
  Temp.$metadata$ = {
    simpleName: 'Temp',
    kind: 'class',
    interfaces: []
  };
  function Companion_42() {
    Companion_instance_41 = this;
  }
  Companion_42.prototype.quadToCubic1_g03kql_k$ = function (v0, v1, v2) {
    return v0 + (v1 - v0) * 0.6666666666666666;
  };
  Companion_42.prototype.quadToCubic2_g03kql_k$ = function (v0, v1, v2) {
    return v2 + (v1 - v2) * 0.6666666666666666;
  };
  Companion_42.prototype.quadBounds_ryuqya_k$ = function (x0, y0, xc, yc, x1, y1, target, temp_0) {
    return this.cubicBounds_iom630_k$(x0, y0, this.quadToCubic1_g03kql_k$(x0, xc, x1), this.quadToCubic1_g03kql_k$(y0, yc, y1), this.quadToCubic2_g03kql_k$(x0, xc, x1), this.quadToCubic2_g03kql_k$(y0, yc, y1), x1, y1, target, temp_0);
  };
  Companion_42.prototype.quadBounds$default_oascqk_k$ = function (x0, y0, xc, yc, x1, y1, target, temp_0, $mask0, $handler) {
    if (!(($mask0 & 64) === 0))
      target = Companion_getInstance_35().invoke_0_k$();
    if (!(($mask0 & 128) === 0))
      temp_0 = new Temp();
    return this.quadBounds_ryuqya_k$(x0, y0, xc, yc, x1, y1, target, temp_0);
  };
  Companion_42.prototype.quadCalc_5bkw6y_k$ = function (x0, y0, xc, yc, x1, y1, t, target) {
    var t1_1 = 1 - t;
    var a_2 = t1_1 * t1_1;
    var c_3 = t * t;
    var b_4 = 2 * t1_1 * t;
    var tmp0__anonymous__5 = a_2 * x0 + b_4 * xc + c_3 * x1;
    var tmp1__anonymous__5 = a_2 * y0 + b_4 * yc + c_3 * y1;
    return target.setTo_ngl742_k$(tmp0__anonymous__5, tmp1__anonymous__5);
  };
  Companion_42.prototype.cubicBounds_iom630_k$ = function (x0, y0, x1, y1, x2, y2, x3, y3, target, temp_0) {
    var j = 0;
    var a;
    var b;
    var c;
    var b2ac;
    var sqrtb2ac;
    var inductionVariable = 0;
    if (inductionVariable < 2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (i === 0) {
          b = 6 * x0 - 12 * x1 + 6 * x2;
          a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
          c = 3 * x1 - 3 * x0;
        } else {
          b = 6 * y0 - 12 * y1 + 6 * y2;
          a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
          c = 3 * y1 - 3 * y0;
        }
        var tmp0_abs_0 = a;
        if (Math.abs(tmp0_abs_0) < 1.0E-12) {
          var tmp1_abs_0 = b;
          if (Math.abs(tmp1_abs_0) >= 1.0E-12) {
            var t = -c / b;
            if (0.0 < t ? t < 1.0 : false) {
              var tmp1 = j;
              j = tmp1 + 1 | 0;
              temp_0._tvalues[tmp1] = t;
            }} else {
          }
        } else {
          {
            b2ac = b * b - 4 * c * a;
            if (b2ac < 0.0)
              continue;
            var tmp2_sqrt_0 = b2ac;
            sqrtb2ac = Math.sqrt(tmp2_sqrt_0);
            var t1 = (-b + sqrtb2ac) / (2.0 * a);
            if (0.0 < t1 ? t1 < 1.0 : false) {
              var tmp2 = j;
              j = tmp2 + 1 | 0;
              temp_0._tvalues[tmp2] = t1;
            }var t2 = (-b - sqrtb2ac) / (2.0 * a);
            if (0.0 < t2 ? t2 < 1.0 : false) {
              var tmp3 = j;
              j = tmp3 + 1 | 0;
              temp_0._tvalues[tmp3] = t2;
            }}
        }
      }
       while (inductionVariable < 2);
    $l$break: while (true) {
      var tmp4 = j;
      j = tmp4 - 1 | 0;
      if (!(tmp4 > 0)) {
        break $l$break;
      }var t_0 = temp_0._tvalues[j];
      var mt = 1 - t_0;
      temp_0._xvalues[j] = mt * mt * mt * x0 + 3 * mt * mt * t_0 * x1 + 3 * mt * t_0 * t_0 * x2 + t_0 * t_0 * t_0 * x3;
      temp_0._yvalues[j] = mt * mt * mt * y0 + 3 * mt * mt * t_0 * y1 + 3 * mt * t_0 * t_0 * y2 + t_0 * t_0 * t_0 * y3;
    }
    temp_0._xvalues[temp_0._tvalues.length + 0 | 0] = x0;
    temp_0._xvalues[temp_0._tvalues.length + 1 | 0] = x3;
    temp_0._yvalues[temp_0._tvalues.length + 0 | 0] = y0;
    temp_0._yvalues[temp_0._tvalues.length + 1 | 0] = y3;
    return target.setBounds_i6u10_k$(minOrElse(temp_0._xvalues, 0.0), minOrElse(temp_0._yvalues, 0.0), maxOrElse(temp_0._xvalues, 0.0), maxOrElse(temp_0._yvalues, 0.0));
  };
  Companion_42.prototype.cubicCalc_pzeyfc_k$ = function (x0, y0, x1, y1, x2, y2, x3, y3, t, target) {
    var cx_1 = 3.0 * (x1 - x0);
    var bx_2 = 3.0 * (x2 - x1) - cx_1;
    var ax_3 = x3 - x0 - cx_1 - bx_2;
    var cy_4 = 3.0 * (y1 - y0);
    var by_5 = 3.0 * (y2 - y1) - cy_4;
    var ay_6 = y3 - y0 - cy_4 - by_5;
    var tSquared_7 = t * t;
    var tCubed_8 = tSquared_7 * t;
    var tmp0__anonymous__9 = ax_3 * tCubed_8 + bx_2 * tSquared_7 + cx_1 * t + x0;
    var tmp1__anonymous__9 = ay_6 * tCubed_8 + by_5 * tSquared_7 + cy_4 * t + y0;
    return target.setTo_ngl742_k$(tmp0__anonymous__9, tmp1__anonymous__9);
  };
  Companion_42.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_41;
  function Companion_getInstance_41() {
    if (Companion_instance_41 == null)
      new Companion_42();
    return Companion_instance_41;
  }
  function Algo() {
  }
  Algo.$metadata$ = {
    simpleName: 'Algo',
    kind: 'interface',
    interfaces: []
  };
  function Companion_43() {
    Companion_instance_42 = this;
  }
  Companion_43.prototype.invoke_xwg7kg_k$ = function (width, height, algo) {
    return new BinPacker(width, height, algo);
  };
  Companion_43.prototype.invoke$default_zcmln7_k$ = function (width, height, algo, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      algo = new MaxRects(width, height);
    return this.invoke_xwg7kg_k$(width, height, algo);
  };
  Companion_43.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_42;
  function Companion_getInstance_42() {
    if (Companion_instance_42 == null)
      new Companion_43();
    return Companion_instance_42;
  }
  function BinPacker(width, height, algo) {
    Companion_getInstance_42();
    this._width_1 = width;
    this._height_1 = height;
    this._algo = algo;
    this._allocated = FastArrayList_init_$Create$();
  }
  BinPacker.prototype.add_ngl742_k$ = function (width, height) {
    var tmp0_elvis_lhs = this.addOrNull_ngl742_k$(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('' + "Size '" + this._width_1 + 'x' + this._height_1 + "' doesn't fit in '" + this._width_1 + 'x' + this._height_1 + "'");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  BinPacker.prototype.addOrNull_ngl742_k$ = function (width, height) {
    var tmp0_elvis_lhs = this._algo.add_ngl742_k$(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rect_3 = tmp;
    var tmp1_this = this;
    var tmp0_plusAssign_0 = tmp1_this._allocated;
    tmp0_plusAssign_0.add_2bq_k$(rect_3);
    Unit_getInstance();
    return rect_3;
  };
  BinPacker.$metadata$ = {
    simpleName: 'BinPacker',
    kind: 'class',
    interfaces: []
  };
  function quickFindPositionForNewNodeBestAreaFit($this, width, height) {
    DoubleCompanionObject_getInstance();
    var score = 1.7976931348623157E308;
    var areaFit;
    var bestNode = Companion_getInstance_35().invoke_0_k$();
    var tmp0_iterator = $this._freeRectangles.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var r = tmp0_iterator.next_0_k$();
      if (r._width_0 >= width ? r._height_0 >= height : false) {
        areaFit = r._width_0 * r._height_0 - width * height;
        if (areaFit < score) {
          bestNode._x_2 = r._x_2;
          bestNode._y_2 = r._y_2;
          bestNode._width_0 = width;
          bestNode._height_0 = height;
          score = areaFit;
        }}}
    return bestNode;
  }
  function splitFreeNode($this, freeNode_0, usedNode) {
    var newNode;
    if (((usedNode._get_left__0_k$() >= freeNode_0._get_right__0_k$() ? true : usedNode._get_right__0_k$() <= freeNode_0._x_2) ? true : usedNode._get_top__0_k$() >= freeNode_0._get_bottom__0_k$()) ? true : usedNode._get_bottom__0_k$() <= freeNode_0._get_top__0_k$()) {
      return false;
    }if (usedNode._x_2 < freeNode_0._get_right__0_k$() ? usedNode._get_right__0_k$() > freeNode_0._x_2 : false) {
      if (usedNode._y_2 > freeNode_0._y_2 ? usedNode._y_2 < freeNode_0._get_bottom__0_k$() : false) {
        newNode = freeNode_0.clone_0_k$();
        newNode._height_0 = usedNode._y_2 - newNode._y_2;
        $this._freeRectangles.add_2bq_k$(newNode);
        Unit_getInstance();
      }if (usedNode._get_bottom__0_k$() < freeNode_0._get_bottom__0_k$()) {
        newNode = freeNode_0.clone_0_k$();
        newNode._set_top__okcceq_k$(usedNode._get_bottom__0_k$());
        newNode._height_0 = freeNode_0._get_bottom__0_k$() - usedNode._get_bottom__0_k$();
        $this._freeRectangles.add_2bq_k$(newNode);
        Unit_getInstance();
      }}if (usedNode._y_2 < freeNode_0._get_bottom__0_k$() ? usedNode._get_bottom__0_k$() > freeNode_0._y_2 : false) {
      if (usedNode._x_2 > freeNode_0._x_2 ? usedNode._x_2 < freeNode_0._get_right__0_k$() : false) {
        newNode = freeNode_0.clone_0_k$();
        newNode._width_0 = usedNode._x_2 - newNode._x_2;
        $this._freeRectangles.add_2bq_k$(newNode);
        Unit_getInstance();
      }if (usedNode._get_right__0_k$() < freeNode_0._get_right__0_k$()) {
        newNode = freeNode_0.clone_0_k$();
        newNode._x_2 = usedNode._get_right__0_k$();
        newNode._width_0 = freeNode_0._get_right__0_k$() - usedNode._get_right__0_k$();
        $this._freeRectangles.add_2bq_k$(newNode);
        Unit_getInstance();
      }}return true;
  }
  function pruneFreeList($this) {
    var len = $this._freeRectangles._get_size__0_k$();
    var i = 0;
    while (i < len) {
      var j = i + 1 | 0;
      var tmpRect = $this._freeRectangles.get_ha5a7z_k$(i);
      $l$break: while (j < len) {
        var tmpRect2 = $this._freeRectangles.get_ha5a7z_k$(j);
        if (Companion_getInstance_35().isContainedIn_x1ktds_k$(tmpRect, tmpRect2)) {
          $this._freeRectangles.removeAt_ha5a7z_k$(i);
          Unit_getInstance();
          i = i - 1 | 0;
          Unit_getInstance();
          len = len - 1 | 0;
          Unit_getInstance();
          break $l$break;
        }if (Companion_getInstance_35().isContainedIn_x1ktds_k$(tmpRect2, tmpRect)) {
          $this._freeRectangles.removeAt_ha5a7z_k$(j);
          Unit_getInstance();
          len = len - 1 | 0;
          Unit_getInstance();
          j = j - 1 | 0;
          Unit_getInstance();
        }var tmp0 = j;
        j = tmp0 + 1 | 0;
        Unit_getInstance();
      }
      var tmp1 = i;
      i = tmp1 + 1 | 0;
      Unit_getInstance();
    }
  }
  function MaxRects(maxWidth, maxHeight) {
    this._freeRectangles = fastArrayListOf([new Rectangle(0.0, 0.0, maxWidth, maxHeight)]);
  }
  MaxRects.prototype.add_ngl742_k$ = function (width, height) {
    return this.quickInsert_ngl742_k$(width, height);
  };
  MaxRects.prototype.quickInsert_ngl742_k$ = function (width, height) {
    if (width <= 0.0 ? height <= 0.0 : false)
      return Companion_getInstance_35().invoke_w0xdj4_k$(0, 0, 0, 0);
    var newNode = quickFindPositionForNewNodeBestAreaFit(this, width, height);
    if (newNode._height_0 === 0.0)
      return null;
    var numRectanglesToProcess = this._freeRectangles._get_size__0_k$();
    var i = 0;
    while (i < numRectanglesToProcess) {
      if (splitFreeNode(this, this._freeRectangles.get_ha5a7z_k$(i), newNode)) {
        this._freeRectangles.removeAt_ha5a7z_k$(i);
        Unit_getInstance();
        numRectanglesToProcess = numRectanglesToProcess - 1 | 0;
        Unit_getInstance();
        i = i - 1 | 0;
        Unit_getInstance();
      }var tmp0 = i;
      i = tmp0 + 1 | 0;
      Unit_getInstance();
    }
    pruneFreeList(this);
    return newNode;
  };
  MaxRects.$metadata$ = {
    simpleName: 'MaxRects',
    kind: 'class',
    interfaces: [Algo]
  };
  function toPathList(_this_) {
    var paths = ArrayList_init_$Create$();
    var path_0 = PointArrayList_init_$Create$(0, 1, null);
    var lx_1 = 0.0;
    var ly_2 = 0.0;
    if (path_0.isNotEmpty_0_k$()) {
      var tmp0_plusAssign_0_23 = path_0;
      paths.add_2bq_k$(tmp0_plusAssign_0_23);
      Unit_getInstance();
      path_0 = PointArrayList_init_$Create$(0, 1, null);
    }var n_1 = 0;
    var tmp0_fastForEach_0 = _this_._commands;
    var n_1_0 = 0;
    while (n_1_0 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1_0;
      n_1_0 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__2_3 = tmp0_fastForEach_0.getAt_ha5a7z_k$(tmp0_2);
      var tmp0_subject_3_4 = tmp1__anonymous__2_3;
      Command_getInstance();
      if (tmp0_subject_3_4 === 0) {
        var tmp1_4_5 = n_1;
        n_1 = tmp1_4_5 + 1 | 0;
        var tmp2__anonymous__3_18 = _this_._data_11.get_ha5a7z_k$(tmp1_4_5);
        var tmp2_5_6 = n_1;
        n_1 = tmp2_5_6 + 1 | 0;
        var tmp3__anonymous__3_18 = _this_._data_11.get_ha5a7z_k$(tmp2_5_6);
        path_0.add_ngl742_k$(tmp2__anonymous__3_18, tmp3__anonymous__3_18);
        var tmp0_also_0_20 = Unit_getInstance();
        lx_1 = tmp2__anonymous__3_18;
        var tmp1_also_0_19 = tmp0_also_0_20;
        ly_2 = tmp3__anonymous__3_18;
      } else {
        Command_getInstance();
        if (tmp0_subject_3_4 === 1) {
          var tmp3_6_7 = n_1;
          n_1 = tmp3_6_7 + 1 | 0;
          var tmp4__anonymous__6_21 = _this_._data_11.get_ha5a7z_k$(tmp3_6_7);
          var tmp4_7_8 = n_1;
          n_1 = tmp4_7_8 + 1 | 0;
          var tmp5__anonymous__6_21 = _this_._data_11.get_ha5a7z_k$(tmp4_7_8);
          path_0.add_ngl742_k$(tmp4__anonymous__6_21, tmp5__anonymous__6_21);
          var tmp0_also_0_23 = Unit_getInstance();
          lx_1 = tmp4__anonymous__6_21;
          var tmp1_also_0_22 = tmp0_also_0_23;
          ly_2 = tmp5__anonymous__6_21;
        } else {
          Command_getInstance();
          if (tmp0_subject_3_4 === 2) {
            var tmp5_8_9 = n_1;
            n_1 = tmp5_8_9 + 1 | 0;
            var tmp6__anonymous__9_24 = _this_._data_11.get_ha5a7z_k$(tmp5_8_9);
            var tmp6_9_10 = n_1;
            n_1 = tmp6_9_10 + 1 | 0;
            var tmp7__anonymous__9_24 = _this_._data_11.get_ha5a7z_k$(tmp6_9_10);
            var tmp7_10_11 = n_1;
            n_1 = tmp7_10_11 + 1 | 0;
            var tmp8__anonymous__9_24 = _this_._data_11.get_ha5a7z_k$(tmp7_10_11);
            var tmp8_11_12 = n_1;
            n_1 = tmp8_11_12 + 1 | 0;
            var tmp9__anonymous__9_24 = _this_._data_11.get_ha5a7z_k$(tmp8_11_12);
            var dt_10_25 = 0.05;
            var inductionVariable = 1;
            if (inductionVariable < 20)
              do {
                var n_12_27 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp0_quadCalc_0_28 = Companion_getInstance_41();
                var tmp1_quadCalc_0_29 = lx_1;
                var tmp2_quadCalc_0_30 = ly_2;
                var tmp3_quadCalc_0_31 = n_12_27 * dt_10_25;
                var t1_1_32 = 1 - tmp3_quadCalc_0_31;
                var a_2_33 = t1_1_32 * t1_1_32;
                var c_3_34 = tmp3_quadCalc_0_31 * tmp3_quadCalc_0_31;
                var b_4_35 = 2 * t1_1_32 * tmp3_quadCalc_0_31;
                var tmp16__anonymous__24 = a_2_33 * tmp1_quadCalc_0_29 + b_4_35 * tmp6__anonymous__9_24 + c_3_34 * tmp8__anonymous__9_24;
                var tmp17__anonymous__24 = a_2_33 * tmp2_quadCalc_0_30 + b_4_35 * tmp7__anonymous__9_24 + c_3_34 * tmp9__anonymous__9_24;
                path_0.add_ngl742_k$(tmp16__anonymous__24, tmp17__anonymous__24);
                Unit_getInstance();
              }
               while (inductionVariable < 20);
            lx_1 = tmp8__anonymous__9_24;
            var tmp4_also_0_36 = Unit_getInstance();
            ly_2 = tmp9__anonymous__9_24;
          } else {
            Command_getInstance();
            if (tmp0_subject_3_4 === 3) {
              var tmp9_12_13 = n_1;
              n_1 = tmp9_12_13 + 1 | 0;
              var tmp10__anonymous__15_37 = _this_._data_11.get_ha5a7z_k$(tmp9_12_13);
              var tmp10_13_14 = n_1;
              n_1 = tmp10_13_14 + 1 | 0;
              var tmp11__anonymous__15_37 = _this_._data_11.get_ha5a7z_k$(tmp10_13_14);
              var tmp11_14_15 = n_1;
              n_1 = tmp11_14_15 + 1 | 0;
              var tmp12__anonymous__15_37 = _this_._data_11.get_ha5a7z_k$(tmp11_14_15);
              var tmp12_15_16 = n_1;
              n_1 = tmp12_15_16 + 1 | 0;
              var tmp13__anonymous__15_37 = _this_._data_11.get_ha5a7z_k$(tmp12_15_16);
              var tmp13_16_17 = n_1;
              n_1 = tmp13_16_17 + 1 | 0;
              var tmp14__anonymous__15_37 = _this_._data_11.get_ha5a7z_k$(tmp13_16_17);
              var tmp14_17_18 = n_1;
              n_1 = tmp14_17_18 + 1 | 0;
              var tmp15__anonymous__15_37 = _this_._data_11.get_ha5a7z_k$(tmp14_17_18);
              var dt_16_38 = 0.05;
              var inductionVariable_0 = 1;
              if (inductionVariable_0 < 20)
                do {
                  var n_18_40 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var tmp0_cubicCalc_0_41 = Companion_getInstance_41();
                  var tmp1_cubicCalc_0_42 = lx_1;
                  var tmp2_cubicCalc_0_43 = ly_2;
                  var tmp3_cubicCalc_0_44 = n_18_40 * dt_16_38;
                  var cx_1_45 = 3.0 * (tmp10__anonymous__15_37 - tmp1_cubicCalc_0_42);
                  var bx_2_46 = 3.0 * (tmp12__anonymous__15_37 - tmp10__anonymous__15_37) - cx_1_45;
                  var ax_3_47 = tmp14__anonymous__15_37 - tmp1_cubicCalc_0_42 - cx_1_45 - bx_2_46;
                  var cy_4_48 = 3.0 * (tmp11__anonymous__15_37 - tmp2_cubicCalc_0_43);
                  var by_5_49 = 3.0 * (tmp13__anonymous__15_37 - tmp11__anonymous__15_37) - cy_4_48;
                  var ay_6_50 = tmp15__anonymous__15_37 - tmp2_cubicCalc_0_43 - cy_4_48 - by_5_49;
                  var tSquared_7_51 = tmp3_cubicCalc_0_44 * tmp3_cubicCalc_0_44;
                  var tCubed_8_52 = tSquared_7_51 * tmp3_cubicCalc_0_44;
                  var tmp18__anonymous__24 = ax_3_47 * tCubed_8_52 + bx_2_46 * tSquared_7_51 + cx_1_45 * tmp3_cubicCalc_0_44 + tmp1_cubicCalc_0_42;
                  var tmp19__anonymous__24 = ay_6_50 * tCubed_8_52 + by_5_49 * tSquared_7_51 + cy_4_48 * tmp3_cubicCalc_0_44 + tmp2_cubicCalc_0_43;
                  path_0.add_ngl742_k$(tmp18__anonymous__24, tmp19__anonymous__24);
                  Unit_getInstance();
                }
                 while (inductionVariable_0 < 20);
              lx_1 = tmp14__anonymous__15_37;
              var tmp4_also_0_53 = Unit_getInstance();
              ly_2 = tmp15__anonymous__15_37;
            } else {
              Command_getInstance();
              if (tmp0_subject_3_4 === 4) {
                if (path_0.isNotEmpty_0_k$()) {
                  var tmp0_plusAssign_0_23_0 = path_0;
                  paths.add_2bq_k$(tmp0_plusAssign_0_23_0);
                  Unit_getInstance();
                  path_0 = PointArrayList_init_$Create$(0, 1, null);
                }} else {
              }
            }
          }
        }
      }
    }
    if (path_0.isNotEmpty_0_k$()) {
      var tmp0_plusAssign_0_23_1 = path_0;
      paths.add_2bq_k$(tmp0_plusAssign_0_23_1);
      Unit_getInstance();
      path_0 = PointArrayList_init_$Create$(0, 1, null);
    }return paths;
  }
  function WithHitShape2d() {
  }
  WithHitShape2d.$metadata$ = {
    simpleName: 'WithHitShape2d',
    kind: 'interface',
    interfaces: []
  };
  function _intersectsStep0($this, l, ml, r, mr, tempMatrix_0) {
    if (!(tempMatrix_0 == null) ? !(ml == null) ? true : !(mr == null) : false) {
      if (!(mr == null)) {
        tempMatrix_0.invert_lwp7hs_k$(mr);
        Unit_getInstance();
      } else {
        tempMatrix_0.identity_0_k$();
        Unit_getInstance();
      }
      if (!(ml == null)) {
        tempMatrix_0.premultiply_lwp7hs_k$(ml);
        Unit_getInstance();
      }var tmp0_fastForEach_0 = l._get_paths__0_k$();
      var n_1 = 0;
      while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
        var inductionVariable = 0;
        var last_1 = tmp1__anonymous__3._get_size__0_k$();
        if (inductionVariable < last_1)
          do {
            var n_2_5 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0__anonymous__3_6 = tmp1__anonymous__3.getX_ha5a7z_k$(n_2_5);
            var tmp1__anonymous__3_7 = tmp1__anonymous__3.getY_ha5a7z_k$(n_2_5);
            var tx_4_8 = tempMatrix_0.transformX_ngl742_k$(tmp0__anonymous__3_6, tmp1__anonymous__3_7);
            var ty_5_9 = tempMatrix_0.transformY_ngl742_k$(tmp0__anonymous__3_6, tmp1__anonymous__3_7);
            if (r.containsPoint_ngl742_k$(tx_4_8, ty_5_9))
              return true;
          }
           while (inductionVariable < last_1);
      }
    } else {
      var tmp2_fastForEach_0 = l._get_paths__0_k$();
      var n_1_0 = 0;
      while (n_1_0 < tmp2_fastForEach_0._get_size__0_k$()) {
        var tmp0_2_0 = n_1_0;
        n_1_0 = tmp0_2_0 + 1 | 0;
        var tmp3__anonymous__3 = tmp2_fastForEach_0.get_ha5a7z_k$(tmp0_2_0);
        var inductionVariable_0 = 0;
        var last_2 = tmp3__anonymous__3._get_size__0_k$();
        if (inductionVariable_0 < last_2)
          do {
            var n_2_5_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp0__anonymous__3_6_0 = tmp3__anonymous__3.getX_ha5a7z_k$(n_2_5_0);
            var tmp1__anonymous__3_7_0 = tmp3__anonymous__3.getY_ha5a7z_k$(n_2_5_0);
            if (r.containsPoint_ngl742_k$(tmp0__anonymous__3_6_0, tmp1__anonymous__3_7_0))
              return true;
          }
           while (inductionVariable_0 < last_2);
      }
    }
    return false;
  }
  function Companion_44() {
    Companion_instance_43 = this;
    this._TYPE = -2;
  }
  Companion_44.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_43;
  function Companion_getInstance_43() {
    if (Companion_instance_43 == null)
      new Companion_44();
    return Companion_instance_43;
  }
  function _no_name_provided__67(this$0) {
    this._this$0_16 = this$0;
  }
  _no_name_provided__67.prototype.invoke_0_k$ = function () {
    var tmp0_buildPath_0 = VectorPath_init_$Create$(null, null, null, 7, null);
    ellipse(tmp0_buildPath_0, 0.0, 0.0, this._this$0_16._ellipseRadiusX, this._this$0_16._ellipseRadiusY);
    return applyTransform_0(tmp0_buildPath_0, Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null).pretranslate_ngl742_k$(this._this$0_16._ellipseX, this._this$0_16._ellipseY).prerotate_ubek5g_k$(this._this$0_16._ellipseAngle));
  };
  _no_name_provided__67.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__68(this$0) {
    this._this$0_17 = this$0;
  }
  _no_name_provided__68.prototype.invoke_xoz56j_k$ = function ($this$invoke) {
    var inductionVariable = 0;
    var last_1 = this._this$0_17._ellipseTotalPoints;
    if (inductionVariable < last_1)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_cos01_0 = Companion_getInstance_26();
        var tmp1_cos01_0 = it / this._this$0_17._ellipseTotalPoints;
        var tmp0_cos_0_1 = 6.283185307179586 * tmp1_cos01_0;
        var tmp = this._this$0_17._ellipseX + Math.cos(tmp0_cos_0_1) * this._this$0_17._ellipseRadiusX;
        var tmp2_sin01_0 = Companion_getInstance_26();
        var tmp3_sin01_0 = it / this._this$0_17._ellipseTotalPoints;
        var tmp0_sin_0_1 = 6.283185307179586 * tmp3_sin01_0;
        $this$invoke.add_ngl742_k$(tmp, this._this$0_17._ellipseY + Math.sin(tmp0_sin_0_1) * this._this$0_17._ellipseRadiusY);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
  };
  _no_name_provided__68.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xoz56j_k$(p1 instanceof PointArrayList ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__68.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_45() {
    Companion_instance_44 = this;
  }
  Companion_45.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_44;
  function Companion_getInstance_44() {
    if (Companion_instance_44 == null)
      new Companion_45();
    return Companion_instance_44;
  }
  function Circle_init_$Init$(x, y, radius, totalPoints, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      totalPoints = 32;
    Circle.call($this, x, y, radius, totalPoints);
    return $this;
  }
  function Circle_init_$Create$(x, y, radius, totalPoints, $mask0, $marker) {
    return Circle_init_$Init$(x, y, radius, totalPoints, $mask0, $marker, Object.create(Circle.prototype));
  }
  function Companion_46() {
    Companion_instance_45 = this;
  }
  Companion_46.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_45;
  function Companion_getInstance_45() {
    if (Companion_instance_45 == null)
      new Companion_46();
    return Companion_instance_45;
  }
  function Companion_47() {
    Companion_instance_46 = this;
    this._TYPE_0 = 3;
  }
  Companion_47.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_46;
  function Companion_getInstance_46() {
    if (Companion_instance_46 == null)
      new Companion_47();
    return Companion_instance_46;
  }
  function _no_name_provided__69(this$0) {
    this._this$0_18 = this$0;
  }
  _no_name_provided__69.prototype.invoke_xoz56j_k$ = function ($this$invoke) {
    $this$invoke.add_ngl742_k$(this._this$0_18._get_x__0_k$(), this._this$0_18._get_y__0_k$()).add_ngl742_k$(this._this$0_18._get_x__0_k$() + this._this$0_18._get_width__0_k$(), this._this$0_18._get_y__0_k$()).add_ngl742_k$(this._this$0_18._get_x__0_k$() + this._this$0_18._get_width__0_k$(), this._this$0_18._get_y__0_k$() + this._this$0_18._get_height__0_k$()).add_ngl742_k$(this._this$0_18._get_x__0_k$(), this._this$0_18._get_y__0_k$() + this._this$0_18._get_height__0_k$());
    Unit_getInstance();
  };
  _no_name_provided__69.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xoz56j_k$(p1 instanceof PointArrayList ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__69.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_48() {
    Companion_instance_47 = this;
    this._TYPE_1 = 4;
  }
  Companion_48.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_47;
  function Companion_getInstance_47() {
    if (Companion_instance_47 == null)
      new Companion_48();
    return Companion_instance_47;
  }
  function Companion_49() {
    Companion_instance_48 = this;
    this._TYPE_2 = 5;
  }
  Companion_49.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_48;
  function Companion_getInstance_48() {
    if (Companion_instance_48 == null)
      new Companion_49();
    return Companion_instance_48;
  }
  function _no_name_provided__70(this$0) {
    this._this$0_19 = this$0;
  }
  _no_name_provided__70.prototype.invoke_0_k$ = function () {
    var tmp0_buildPath_0 = VectorPath_init_$Create$(null, null, null, 7, null);
    polygon$default_0(tmp0_buildPath_0, this._this$0_19._points, false, 2, null);
    return tmp0_buildPath_0;
  };
  _no_name_provided__70.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_50() {
    Companion_instance_49 = this;
    this._TYPE_3 = 6;
  }
  Companion_50.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_49;
  function Companion_getInstance_49() {
    if (Companion_instance_49 == null)
      new Companion_50();
    return Companion_instance_49;
  }
  function Companion_51() {
    Companion_instance_50 = this;
    this._TYPE_4 = 7;
  }
  Companion_51.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_50;
  function Companion_getInstance_50() {
    if (Companion_instance_50 == null)
      new Companion_51();
    return Companion_instance_50;
  }
  function _no_name_provided__71(this$0) {
    this._this$0_20 = this$0;
  }
  _no_name_provided__71.prototype.invoke_0_k$ = function () {
    var tmp0_flatMap_0 = this._this$0_20._items_2;
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_flatMap_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      var list_3_4 = element_2_3._get_paths__0_k$();
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    return tmp0_flatMapTo_0_1;
  };
  _no_name_provided__71.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_52() {
    Companion_instance_51 = this;
  }
  Companion_52.prototype.intersects_r62lph_k$ = function (l, ml, r, mr, tempMatrix_0) {
    if (l._get_type__0_k$() === r._get_type__0_k$()) {
      var tmp0_subject = l._get_type__0_k$();
      Companion_getInstance_43();
      if (tmp0_subject === -2) {
        var tmp;
        if (l instanceof Circle) {
          tmp = r instanceof Circle;
        } else {
          {
            tmp = false;
          }
        }
        if (tmp) {
          return optimizedIntersect(l, ml, r, mr);
        } else {
        }
      } else {
      }
    }return _intersectsStep0(this, l, ml, r, mr, tempMatrix_0) ? true : _intersectsStep0(this, r, mr, l, ml, tempMatrix_0);
  };
  Companion_52.prototype.EllipseOrCircle_sdkgzl_k$ = function (x, y, radiusX, radiusY, angle, totalPoints) {
    return radiusX === radiusY ? new Circle(x, y, radiusX, totalPoints) : new Ellipse(x, y, radiusX, radiusY, angle, totalPoints);
  };
  Companion_52.prototype.EllipseOrCircle$default_nyqti8_k$ = function (x, y, radiusX, radiusY, angle, totalPoints, $mask0, $handler) {
    if (!(($mask0 & 16) === 0)) {
      var tmp0__get_ZERO__0 = Companion_getInstance_26();
      angle = _Angle___init__impl_(0.0);
    }if (!(($mask0 & 32) === 0))
      totalPoints = 32;
    return this.EllipseOrCircle_sdkgzl_k$(x, y, radiusX, radiusY, angle, totalPoints);
  };
  Companion_52.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_51;
  function Companion_getInstance_51() {
    if (Companion_instance_51 == null)
      new Companion_52();
    return Companion_instance_51;
  }
  function WithArea() {
  }
  WithArea.$metadata$ = {
    simpleName: 'WithArea',
    kind: 'interface',
    interfaces: []
  };
  function Empty() {
    Empty_instance = this;
    Shape2d.call(this);
    this._TYPE_5 = 0;
    this._type = 0;
    this._paths = listOf_0(new PointArrayList(0));
    this._closed = false;
    this._area = 0.0;
  }
  Empty.prototype._get_type__0_k$ = function () {
    return this._type;
  };
  Empty.prototype._get_paths__0_k$ = function () {
    return this._paths;
  };
  Empty.prototype.containsPoint_ngl742_k$ = function (x, y) {
    return false;
  };
  Empty.$metadata$ = {
    simpleName: 'Empty',
    kind: 'object',
    interfaces: [WithArea]
  };
  var Empty_instance;
  function Empty_getInstance() {
    if (Empty_instance == null)
      new Empty();
    return Empty_instance;
  }
  function BaseEllipse(ellipseX, ellipseY, ellipseRadiusX, ellipseRadiusY, ellipseAngle, ellipseTotalPoints) {
    Companion_getInstance_43();
    Shape2d.call(this);
    this._ellipseX = ellipseX;
    this._ellipseY = ellipseY;
    this._ellipseRadiusX = ellipseRadiusX;
    this._ellipseRadiusY = ellipseRadiusY;
    this._ellipseAngle = ellipseAngle;
    this._ellipseTotalPoints = ellipseTotalPoints;
    var tmp = this;
    tmp._vectorPath$delegate = lazy(_no_name_provided_$factory_47(this));
    var tmp_0 = this;
    var tmp_1;
    if (this._get_isCircle__0_k$()) {
      var tmp_2 = Companion_getInstance_33();
      tmp_1 = listOf_0(tmp_2.invoke_h6a0xc_k$(this._ellipseTotalPoints, _no_name_provided_$factory_48(this)));
    } else {
      var tmp_3 = this._get_vectorPath__0_k$();
      tmp_1 = listOf_0(getPoints2$default(tmp_3, null, 1, null));
    }
    tmp_0._paths_0 = tmp_1;
  }
  BaseEllipse.prototype._get_type__0_k$ = function () {
    Companion_getInstance_43();
    return -2;
  };
  BaseEllipse.prototype._get_isCircle__0_k$ = function () {
    return this._ellipseRadiusX === this._ellipseRadiusY;
  };
  BaseEllipse.prototype._get_vectorPath__0_k$ = function () {
    var tmp0_getValue_0 = vectorPath$factory();
    return this._vectorPath$delegate._get_value__0_k$();
  };
  BaseEllipse.prototype._get_paths__0_k$ = function () {
    return this._paths_0;
  };
  BaseEllipse.prototype.containsPoint_ngl742_k$ = function (x, y) {
    if (this._get_isCircle__0_k$()) {
      var tmp0_hypot_0 = this._ellipseX - x;
      var tmp1_hypot_0 = this._ellipseY - y;
      return Math.hypot(tmp0_hypot_0, tmp1_hypot_0) < this._ellipseRadiusX;
    }return this._get_vectorPath__0_k$().containsPoint_ngl742_k$(x, y);
  };
  BaseEllipse.$metadata$ = {
    simpleName: 'BaseEllipse',
    kind: 'class',
    interfaces: [WithArea]
  };
  function Ellipse(x, y, radiusX, radiusY, angle, totalPoints) {
    Companion_getInstance_44();
    BaseEllipse.call(this, x, y, radiusX, radiusY, angle, totalPoints);
    this._x_3 = x;
    this._y_3 = y;
    this._radiusX = radiusX;
    this._radiusY = radiusY;
    this._angle = angle;
    this._totalPoints = totalPoints;
  }
  Ellipse.prototype.toString = function () {
    return '' + 'Ellipse(x=' + this._x_3 + ', y=' + this._y_3 + ', radiusX=' + this._radiusX + ', radiusY=' + this._radiusY + ', angle=' + new Angle(this._angle) + ', totalPoints=' + this._totalPoints + ')';
  };
  Ellipse.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_3);
    result = imul(result, 31) + getNumberHashCode(this._y_3) | 0;
    result = imul(result, 31) + getNumberHashCode(this._radiusX) | 0;
    result = imul(result, 31) + getNumberHashCode(this._radiusY) | 0;
    result = imul(result, 31) + Angle__hashCode_impl(this._angle) | 0;
    result = imul(result, 31) + this._totalPoints | 0;
    return result;
  };
  Ellipse.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ellipse))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Ellipse ? other : THROW_CCE();
    if (!equals_1(this._x_3, tmp0_other_with_cast._x_3))
      return false;
    if (!equals_1(this._y_3, tmp0_other_with_cast._y_3))
      return false;
    if (!equals_1(this._radiusX, tmp0_other_with_cast._radiusX))
      return false;
    if (!equals_1(this._radiusY, tmp0_other_with_cast._radiusY))
      return false;
    if (!equals_1(new Angle(this._angle), new Angle(tmp0_other_with_cast._angle)))
      return false;
    if (!(this._totalPoints === tmp0_other_with_cast._totalPoints))
      return false;
    return true;
  };
  Ellipse.$metadata$ = {
    simpleName: 'Ellipse',
    kind: 'class',
    interfaces: []
  };
  function Circle(x, y, radius, totalPoints) {
    Companion_getInstance_45();
    var tmp0__get_ZERO__0 = Companion_getInstance_26();
    BaseEllipse.call(this, x, y, radius, radius, _Angle___init__impl_(0.0), totalPoints);
    this._x_4 = x;
    this._y_4 = y;
    this._radius = radius;
    this._totalPoints_0 = totalPoints;
  }
  Circle.prototype.toString = function () {
    return '' + 'Circle(x=' + this._x_4 + ', y=' + this._y_4 + ', radius=' + this._radius + ', totalPoints=' + this._totalPoints_0 + ')';
  };
  Circle.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_4);
    result = imul(result, 31) + getNumberHashCode(this._y_4) | 0;
    result = imul(result, 31) + getNumberHashCode(this._radius) | 0;
    result = imul(result, 31) + this._totalPoints_0 | 0;
    return result;
  };
  Circle.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Circle))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Circle ? other : THROW_CCE();
    if (!equals_1(this._x_4, tmp0_other_with_cast._x_4))
      return false;
    if (!equals_1(this._y_4, tmp0_other_with_cast._y_4))
      return false;
    if (!equals_1(this._radius, tmp0_other_with_cast._radius))
      return false;
    if (!(this._totalPoints_0 === tmp0_other_with_cast._totalPoints_0))
      return false;
    return true;
  };
  Circle.$metadata$ = {
    simpleName: 'Circle',
    kind: 'class',
    interfaces: []
  };
  function Rectangle_0(rect_3) {
    Companion_getInstance_46();
    Shape2d.call(this);
    this._rect_0 = rect_3;
    this._type_0 = 3;
    var tmp = this;
    var tmp_0 = Companion_getInstance_33();
    tmp._paths_1 = listOf_0(tmp_0.invoke_h6a0xc_k$(4, _no_name_provided_$factory_49(this)));
    this._closed_0 = true;
  }
  Rectangle_0.prototype._get_height__0_k$ = function () {
    return this._rect_0._height_0;
  };
  Rectangle_0.prototype._get_width__0_k$ = function () {
    return this._rect_0._width_0;
  };
  Rectangle_0.prototype._get_x__0_k$ = function () {
    return this._rect_0._x_2;
  };
  Rectangle_0.prototype._get_y__0_k$ = function () {
    return this._rect_0._y_2;
  };
  Rectangle_0.prototype._get_type__0_k$ = function () {
    return this._type_0;
  };
  Rectangle_0.prototype._get_paths__0_k$ = function () {
    return this._paths_1;
  };
  Rectangle_0.prototype.containsPoint_ngl742_k$ = function (x, y) {
    var tmp;
    var containsLower = _get_left__0(this);
    if (x <= _get_right__0(this) ? containsLower <= x : false) {
      var containsLower_0 = _get_top_(this);
      tmp = y <= _get_bottom_(this) ? containsLower_0 <= y : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Rectangle_0.prototype.toString = function () {
    return '' + 'Rectangle(x=' + _get_niceStr_(this._get_x__0_k$()) + ', y=' + _get_niceStr_(this._get_y__0_k$()) + ', width=' + _get_niceStr_(this._get_width__0_k$()) + ', height=' + _get_niceStr_(this._get_height__0_k$()) + ')';
  };
  Rectangle_0.prototype.hashCode = function () {
    return this._rect_0.hashCode();
  };
  Rectangle_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Rectangle_0 ? other : THROW_CCE();
    if (!this._rect_0.equals(tmp0_other_with_cast._rect_0))
      return false;
    return true;
  };
  Rectangle_0.$metadata$ = {
    simpleName: 'Rectangle',
    kind: 'class',
    interfaces: [WithArea, IRectangle]
  };
  function Path(vectorPath, closed) {
    Companion_getInstance_47();
    Shape2d.call(this);
    this._vectorPath = vectorPath;
    this._closed_1 = closed;
    this._type_1 = 4;
    var tmp = this;
    tmp._paths_2 = listOf_0(getPoints2$default(this._vectorPath, null, 1, null));
  }
  Path.prototype._get_type__0_k$ = function () {
    return this._type_1;
  };
  Path.prototype._get_paths__0_k$ = function () {
    return this._paths_2;
  };
  Path.prototype.containsPoint_ngl742_k$ = function (x, y) {
    return this._closed_1 ? this._vectorPath.containsPoint_ngl742_k$(x, y) : false;
  };
  Path.prototype.toString = function () {
    return '' + 'Path(vectorPath=' + this._vectorPath + ', closed=' + this._closed_1 + ')';
  };
  Path.prototype.hashCode = function () {
    var result = hashCode(this._vectorPath);
    result = imul(result, 31) + (this._closed_1 | 0) | 0;
    return result;
  };
  Path.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Path))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Path ? other : THROW_CCE();
    if (!equals_1(this._vectorPath, tmp0_other_with_cast._vectorPath))
      return false;
    if (!(this._closed_1 === tmp0_other_with_cast._closed_1))
      return false;
    return true;
  };
  Path.$metadata$ = {
    simpleName: 'Path',
    kind: 'class',
    interfaces: []
  };
  function Polygon(points) {
    Companion_getInstance_48();
    Shape2d.call(this);
    this._points = points;
    this._type_2 = 5;
    this._paths_3 = listOf_0(this._points);
    this._closed_2 = true;
    var tmp = this;
    tmp._vectorPath$delegate_0 = lazy(_no_name_provided_$factory_50(this));
  }
  Polygon.prototype._get_type__0_k$ = function () {
    return this._type_2;
  };
  Polygon.prototype._get_paths__0_k$ = function () {
    return this._paths_3;
  };
  Polygon.prototype._get_vectorPath__0_k$ = function () {
    var tmp0_getValue_0 = vectorPath$factory_0();
    return this._vectorPath$delegate_0._get_value__0_k$();
  };
  Polygon.prototype.containsPoint_ngl742_k$ = function (x, y) {
    return this._get_vectorPath__0_k$().containsPoint_ngl742_k$(x, y);
  };
  Polygon.prototype.toString = function () {
    return '' + 'Polygon(points=' + this._points + ')';
  };
  Polygon.prototype.hashCode = function () {
    return hashCode(this._points);
  };
  Polygon.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Polygon))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Polygon ? other : THROW_CCE();
    if (!equals_1(this._points, tmp0_other_with_cast._points))
      return false;
    return true;
  };
  Polygon.$metadata$ = {
    simpleName: 'Polygon',
    kind: 'class',
    interfaces: []
  };
  function Polyline(points) {
    Companion_getInstance_49();
    Shape2d.call(this);
    this._points_0 = points;
    this._type_3 = 6;
    this._paths_4 = listOf_0(this._points_0);
    this._closed_3 = false;
  }
  Polyline.prototype._get_type__0_k$ = function () {
    return this._type_3;
  };
  Polyline.prototype._get_paths__0_k$ = function () {
    return this._paths_4;
  };
  Polyline.prototype.containsPoint_ngl742_k$ = function (x, y) {
    return false;
  };
  Polyline.prototype.toString = function () {
    return '' + 'Polyline(points=' + this._points_0 + ')';
  };
  Polyline.prototype.hashCode = function () {
    return hashCode(this._points_0);
  };
  Polyline.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Polyline))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Polyline ? other : THROW_CCE();
    if (!equals_1(this._points_0, tmp0_other_with_cast._points_0))
      return false;
    return true;
  };
  Polyline.$metadata$ = {
    simpleName: 'Polyline',
    kind: 'class',
    interfaces: [WithArea]
  };
  function Complex(items) {
    Companion_getInstance_50();
    Shape2d.call(this);
    this._items_2 = items;
    this._type_4 = 7;
    var tmp = this;
    tmp._paths$delegate = lazy(_no_name_provided_$factory_51(this));
    this._closed_4 = false;
  }
  Complex.prototype._get_type__0_k$ = function () {
    return this._type_4;
  };
  Complex.prototype._get_paths__0_k$ = function () {
    var tmp0_getValue_0 = paths$factory();
    return this._paths$delegate._get_value__0_k$();
  };
  Complex.prototype.containsPoint_ngl742_k$ = function (x, y) {
    var tmp0_fastForEach_0 = this._items_2;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      if (tmp1__anonymous__3.containsPoint_ngl742_k$(x, y))
        return true;
    }
    return false;
  };
  Complex.prototype.toString = function () {
    return '' + 'Complex(items=' + this._items_2 + ')';
  };
  Complex.prototype.hashCode = function () {
    return hashCode(this._items_2);
  };
  Complex.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Complex))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Complex ? other : THROW_CCE();
    if (!equals_1(this._items_2, tmp0_other_with_cast._items_2))
      return false;
    return true;
  };
  Complex.$metadata$ = {
    simpleName: 'Complex',
    kind: 'class',
    interfaces: []
  };
  function Shape2d() {
    Companion_getInstance_51();
  }
  Shape2d.prototype.containsPoint_n7xxde_k$ = function (x, y, mat) {
    return this.containsPoint_ngl742_k$(mat.transformX_ngl742_k$(x, y), mat.transformY_ngl742_k$(x, y));
  };
  Shape2d.$metadata$ = {
    simpleName: 'Shape2d',
    kind: 'class',
    interfaces: []
  };
  function toShape2d(_this_, closed) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this_, 10));
    var tmp0_iterator_1_2 = _this_.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(toShape2d_0(item_2_3, closed));
      Unit_getInstance();
    }
    return new Complex(tmp0_mapTo_0_1);
  }
  function toShape2d$default(_this_, closed, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      closed = true;
    return toShape2d(_this_, closed);
  }
  function toShape2d_0(_this_, closed) {
    return toShape2dOld(_this_, closed);
  }
  function toShape2d$default_0(_this_, closed, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      closed = true;
    return toShape2d_0(_this_, closed);
  }
  function toShape2dNew(_this_, closed) {
    return new Path(_this_, closed);
  }
  function toShape2dNew$default(_this_, closed, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      closed = true;
    return toShape2dNew(_this_, closed);
  }
  function optimizedIntersect(l, ml, r, mr) {
    if (ml == null ? mr == null : false)
      return optimizedIntersect_0(l, r);
    var radiusL = dtx(ml, l._radius, l._radius);
    var radiusR = dtx(mr, r._radius, r._radius);
    return Companion_getInstance_32().distance_i6u10_k$(tx(ml, l._x_4, l._y_4), ty(ml, l._x_4, l._y_4), tx(mr, r._x_4, r._y_4), ty(mr, r._x_4, r._y_4)) < radiusL + radiusR;
  }
  function getPoints2(_this_, out) {
    var ix_3 = 0.0;
    var iy_4 = 0.0;
    var lx_5 = {_v: 0.0};
    var ly_6 = {_v: 0.0};
    Unit_getInstance();
    var n_1_7 = 0;
    var tmp0_fastForEach_0_8 = _this_._commands;
    var n_1_9 = 0;
    while (n_1_9 < tmp0_fastForEach_0_8._get_size__0_k$()) {
      var tmp0_2_11 = n_1_9;
      n_1_9 = tmp0_2_11 + 1 | 0;
      var tmp1__anonymous__2_3_10 = tmp0_fastForEach_0_8.getAt_ha5a7z_k$(tmp0_2_11);
      var tmp0_subject_3_4_12 = tmp1__anonymous__2_3_10;
      Command_getInstance();
      if (tmp0_subject_3_4_12 === 0) {
        var tmp1_4_5_14 = n_1_7;
        n_1_7 = tmp1_4_5_14 + 1 | 0;
        var tmp2__anonymous__18_13 = _this_._data_11.get_ha5a7z_k$(tmp1_4_5_14);
        var tmp2_5_6_16 = n_1_7;
        n_1_7 = tmp2_5_6_16 + 1 | 0;
        var tmp3__anonymous__18_15 = _this_._data_11.get_ha5a7z_k$(tmp2_5_6_16);
        ix_3 = tmp2__anonymous__18_13;
        iy_4 = tmp3__anonymous__18_15;
        out.add_ngl742_k$(tmp2__anonymous__18_13, tmp3__anonymous__18_15);
        var tmp0_also_0_20_18 = Unit_getInstance();
        lx_5._v = tmp2__anonymous__18_13;
        var tmp1_also_0_19_17 = tmp0_also_0_20_18;
        ly_6._v = tmp3__anonymous__18_15;
      } else {
        Command_getInstance();
        if (tmp0_subject_3_4_12 === 1) {
          var tmp3_6_7_20 = n_1_7;
          n_1_7 = tmp3_6_7_20 + 1 | 0;
          var tmp4__anonymous__21_19 = _this_._data_11.get_ha5a7z_k$(tmp3_6_7_20);
          var tmp4_7_8_22 = n_1_7;
          n_1_7 = tmp4_7_8_22 + 1 | 0;
          var tmp5__anonymous__21_21 = _this_._data_11.get_ha5a7z_k$(tmp4_7_8_22);
          out.add_ngl742_k$(tmp4__anonymous__21_19, tmp5__anonymous__21_21);
          var tmp0_also_0_23_24 = Unit_getInstance();
          lx_5._v = tmp4__anonymous__21_19;
          var tmp1_also_0_22_23 = tmp0_also_0_23_24;
          ly_6._v = tmp5__anonymous__21_21;
          Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_3_4_12 === 2) {
            var tmp5_8_9_26 = n_1_7;
            n_1_7 = tmp5_8_9_26 + 1 | 0;
            var tmp6__anonymous__24_25 = _this_._data_11.get_ha5a7z_k$(tmp5_8_9_26);
            var tmp6_9_10_28 = n_1_7;
            n_1_7 = tmp6_9_10_28 + 1 | 0;
            var tmp7__anonymous__24_27 = _this_._data_11.get_ha5a7z_k$(tmp6_9_10_28);
            var tmp7_10_11_30 = n_1_7;
            n_1_7 = tmp7_10_11_30 + 1 | 0;
            var tmp8__anonymous__24_29 = _this_._data_11.get_ha5a7z_k$(tmp7_10_11_30);
            var tmp8_11_12_32 = n_1_7;
            n_1_7 = tmp8_11_12_32 + 1 | 0;
            var tmp9__anonymous__24_31 = _this_._data_11.get_ha5a7z_k$(tmp8_11_12_32);
            var sum_25_33 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp6__anonymous__24_25, tmp7__anonymous__24_27) + Companion_getInstance_32().distance_i6u10_k$(tmp6__anonymous__24_25, tmp7__anonymous__24_27, tmp8__anonymous__24_29, tmp9__anonymous__24_31);
            var tmp0_approximateCurve_0_26_34 = numberToInt(sum_25_33);
            var rcurveSteps_1_27_35 = Math.max(tmp0_approximateCurve_0_26_34, 20);
            var dt_2_28_36 = 1.0 / rcurveSteps_1_27_35;
            var lastX_3_29_37 = {_v: 0.0};
            var lastY_4_30_38 = {_v: 0.0};
            var prevX_5_31_39 = {_v: 0.0};
            var prevY_6_32_40 = {_v: 0.0};
            var emittedCount_7_33_41 = {_v: 0};
            var tmp0_quadCalc_0_16_34_42 = Companion_getInstance_41();
            var tmp1_quadCalc_0_17_35_43 = lx_5._v;
            var tmp2_quadCalc_0_18_36_44 = ly_6._v;
            var t1_1_19_37_45 = 1.0;
            var a_2_20_38_46 = t1_1_19_37_45 * t1_1_19_37_45;
            var c_3_21_39_47 = 0.0;
            var b_4_22_40_48 = 2 * t1_1_19_37_45 * 0.0;
            var tmp3__anonymous__5_23_41_49 = a_2_20_38_46 * tmp1_quadCalc_0_17_35_43 + b_4_22_40_48 * tmp6__anonymous__24_25 + c_3_21_39_47 * tmp8__anonymous__24_29;
            var tmp4__anonymous__5_24_42_50 = a_2_20_38_46 * tmp2_quadCalc_0_18_36_44 + b_4_22_40_48 * tmp7__anonymous__24_27 + c_3_21_39_47 * tmp9__anonymous__24_31;
            lastX_3_29_37._v = tmp3__anonymous__5_23_41_49;
            lastY_4_30_38._v = tmp4__anonymous__5_24_42_50;
            var inductionVariable = 1;
            if (inductionVariable < rcurveSteps_1_27_35)
              do {
                var n_10_44_52 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_11_45_53 = n_10_44_52 * dt_2_28_36;
                var tmp0_quadCalc_0_16_46_54 = Companion_getInstance_41();
                var tmp1_quadCalc_0_17_47_55 = lx_5._v;
                var tmp2_quadCalc_0_18_48_56 = ly_6._v;
                var t1_1_19_49_57 = 1 - ratio_11_45_53;
                var a_2_20_50_58 = t1_1_19_49_57 * t1_1_19_49_57;
                var c_3_21_51_59 = ratio_11_45_53 * ratio_11_45_53;
                var b_4_22_52_60 = 2 * t1_1_19_49_57 * ratio_11_45_53;
                var tmp3__anonymous__5_23_53_61 = a_2_20_50_58 * tmp1_quadCalc_0_17_47_55 + b_4_22_52_60 * tmp6__anonymous__24_25 + c_3_21_51_59 * tmp8__anonymous__24_29;
                var tmp4__anonymous__5_24_54_62 = a_2_20_50_58 * tmp2_quadCalc_0_18_48_56 + b_4_22_52_60 * tmp7__anonymous__24_27 + c_3_21_51_59 * tmp9__anonymous__24_31;
                out.add_ngl742_k$(tmp3__anonymous__5_23_53_61, tmp4__anonymous__5_24_54_62);
                Unit_getInstance();
                var tmp0_14_2_27_55_63 = emittedCount_7_33_41._v;
                emittedCount_7_33_41._v = tmp0_14_2_27_55_63 + 1 | 0;
                Unit_getInstance();
                lastX_3_29_37._v = prevX_5_31_39._v;
                lastY_4_30_38._v = prevY_6_32_40._v;
                prevX_5_31_39._v = tmp3__anonymous__5_23_53_61;
                prevY_6_32_40._v = tmp4__anonymous__5_24_54_62;
              }
               while (inductionVariable < rcurveSteps_1_27_35);
            var tmp1_also_0_56_64 = lx_5._v = tmp8__anonymous__24_29;
            ly_6._v = tmp9__anonymous__24_31;
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_3_4_12 === 3) {
              var tmp9_12_13_66 = n_1_7;
              n_1_7 = tmp9_12_13_66 + 1 | 0;
              var tmp10__anonymous__57_65 = _this_._data_11.get_ha5a7z_k$(tmp9_12_13_66);
              var tmp10_13_14_68 = n_1_7;
              n_1_7 = tmp10_13_14_68 + 1 | 0;
              var tmp11__anonymous__57_67 = _this_._data_11.get_ha5a7z_k$(tmp10_13_14_68);
              var tmp11_14_15_70 = n_1_7;
              n_1_7 = tmp11_14_15_70 + 1 | 0;
              var tmp12__anonymous__57_69 = _this_._data_11.get_ha5a7z_k$(tmp11_14_15_70);
              var tmp12_15_16_72 = n_1_7;
              n_1_7 = tmp12_15_16_72 + 1 | 0;
              var tmp13__anonymous__57_71 = _this_._data_11.get_ha5a7z_k$(tmp12_15_16_72);
              var tmp13_16_17_74 = n_1_7;
              n_1_7 = tmp13_16_17_74 + 1 | 0;
              var tmp14__anonymous__57_73 = _this_._data_11.get_ha5a7z_k$(tmp13_16_17_74);
              var tmp14_17_18_76 = n_1_7;
              n_1_7 = tmp14_17_18_76 + 1 | 0;
              var tmp15__anonymous__57_75 = _this_._data_11.get_ha5a7z_k$(tmp14_17_18_76);
              var sum_58_77 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp10__anonymous__57_65, tmp11__anonymous__57_67) + Companion_getInstance_32().distance_i6u10_k$(tmp10__anonymous__57_65, tmp11__anonymous__57_67, tmp12__anonymous__57_69, tmp13__anonymous__57_71) + Companion_getInstance_32().distance_i6u10_k$(tmp12__anonymous__57_69, tmp13__anonymous__57_71, tmp14__anonymous__57_73, tmp15__anonymous__57_75);
              var tmp0_approximateCurve_0_59_78 = numberToInt(sum_58_77);
              var rcurveSteps_1_60_79 = Math.max(tmp0_approximateCurve_0_59_78, 20);
              var dt_2_61_80 = 1.0 / rcurveSteps_1_60_79;
              var lastX_3_62_81 = {_v: 0.0};
              var lastY_4_63_82 = {_v: 0.0};
              var prevX_5_64_83 = {_v: 0.0};
              var prevY_6_65_84 = {_v: 0.0};
              var emittedCount_7_66_85 = {_v: 0};
              var tmp0_cubicCalc_0_16_67_86 = Companion_getInstance_41();
              var tmp1_cubicCalc_0_17_68_87 = lx_5._v;
              var tmp2_cubicCalc_0_18_69_88 = ly_6._v;
              var cx_1_19_70_89 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_68_87);
              var bx_2_20_71_90 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_70_89;
              var ax_3_21_72_91 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_68_87 - cx_1_19_70_89 - bx_2_20_71_90;
              var cy_4_22_73_92 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_69_88);
              var by_5_23_74_93 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_73_92;
              var ay_6_24_75_94 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_69_88 - cy_4_22_73_92 - by_5_23_74_93;
              var tSquared_7_25_76_95 = 0.0;
              var tCubed_8_26_77_96 = tSquared_7_25_76_95 * 0.0;
              var tmp3__anonymous__9_27_78_97 = ax_3_21_72_91 * tCubed_8_26_77_96 + bx_2_20_71_90 * tSquared_7_25_76_95 + cx_1_19_70_89 * 0.0 + tmp1_cubicCalc_0_17_68_87;
              var tmp4__anonymous__9_28_79_98 = ay_6_24_75_94 * tCubed_8_26_77_96 + by_5_23_74_93 * tSquared_7_25_76_95 + cy_4_22_73_92 * 0.0 + tmp2_cubicCalc_0_18_69_88;
              lastX_3_62_81._v = tmp3__anonymous__9_27_78_97;
              lastY_4_63_82._v = tmp4__anonymous__9_28_79_98;
              var inductionVariable_0 = 1;
              if (inductionVariable_0 < rcurveSteps_1_60_79)
                do {
                  var n_10_81_100 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var ratio_11_82_101 = n_10_81_100 * dt_2_61_80;
                  var tmp0_cubicCalc_0_16_83_102 = Companion_getInstance_41();
                  var tmp1_cubicCalc_0_17_84_103 = lx_5._v;
                  var tmp2_cubicCalc_0_18_85_104 = ly_6._v;
                  var cx_1_19_86_105 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_84_103);
                  var bx_2_20_87_106 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_86_105;
                  var ax_3_21_88_107 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_84_103 - cx_1_19_86_105 - bx_2_20_87_106;
                  var cy_4_22_89_108 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_85_104);
                  var by_5_23_90_109 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_89_108;
                  var ay_6_24_91_110 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_85_104 - cy_4_22_89_108 - by_5_23_90_109;
                  var tSquared_7_25_92_111 = ratio_11_82_101 * ratio_11_82_101;
                  var tCubed_8_26_93_112 = tSquared_7_25_92_111 * ratio_11_82_101;
                  var tmp3__anonymous__9_27_94_113 = ax_3_21_88_107 * tCubed_8_26_93_112 + bx_2_20_87_106 * tSquared_7_25_92_111 + cx_1_19_86_105 * ratio_11_82_101 + tmp1_cubicCalc_0_17_84_103;
                  var tmp4__anonymous__9_28_95_114 = ay_6_24_91_110 * tCubed_8_26_93_112 + by_5_23_90_109 * tSquared_7_25_92_111 + cy_4_22_89_108 * ratio_11_82_101 + tmp2_cubicCalc_0_18_85_104;
                  out.add_ngl742_k$(tmp3__anonymous__9_27_94_113, tmp4__anonymous__9_28_95_114);
                  Unit_getInstance();
                  var tmp0_14_2_31_96_115 = emittedCount_7_66_85._v;
                  emittedCount_7_66_85._v = tmp0_14_2_31_96_115 + 1 | 0;
                  Unit_getInstance();
                  lastX_3_62_81._v = prevX_5_64_83._v;
                  lastY_4_63_82._v = prevY_6_65_84._v;
                  prevX_5_64_83._v = tmp3__anonymous__9_27_94_113;
                  prevY_6_65_84._v = tmp4__anonymous__9_28_95_114;
                }
                 while (inductionVariable_0 < rcurveSteps_1_60_79);
              var tmp1_also_0_97_116 = lx_5._v = tmp14__anonymous__57_73;
              ly_6._v = tmp15__anonymous__57_75;
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_3_4_12 === 4) {
                var tmp0__anonymous__118 = ix_3;
                var tmp1__anonymous__118 = iy_4;
                out.add_ngl742_k$(tmp0__anonymous__118, tmp1__anonymous__118);
                Unit_getInstance();
                Unit_getInstance();
                Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
    return out;
  }
  function getPoints2$default(_this_, out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      out = PointArrayList_init_$Create$(0, 1, null);
    }return getPoints2(_this_, out);
  }
  function toShape2dOld(_this_, closed) {
    var tmp0_map_0 = toPathList(_this_);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(toShape2d_1(item_2_3, closed));
      Unit_getInstance();
    }
    var items = tmp0_mapTo_0_1;
    var tmp0_subject = items._get_size__0_k$();
    switch (tmp0_subject) {
      case 0:
        return Empty_getInstance();
      case 1:
        return first(items);
      default:return new Complex(items);
    }
  }
  function optimizedIntersect_0(l, r) {
    return Companion_getInstance_32().distance_i6u10_k$(l._x_4, l._y_4, r._x_4, r._y_4) < l._radius + r._radius;
  }
  function dtx(_this_, x, y) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.deltaTransformX_ngl742_k$(x, y);
    return tmp1_elvis_lhs == null ? x : tmp1_elvis_lhs;
  }
  function tx(_this_, x, y) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.transformX_ngl742_k$(x, y);
    return tmp1_elvis_lhs == null ? x : tmp1_elvis_lhs;
  }
  function ty(_this_, x, y) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.transformY_ngl742_k$(x, y);
    return tmp1_elvis_lhs == null ? y : tmp1_elvis_lhs;
  }
  function toShape2d_1(_this_, closed) {
    if (closed ? _this_._get_size__0_k$() === 4 : false) {
      var x0 = _this_.getX_ha5a7z_k$(0);
      var y0 = _this_.getY_ha5a7z_k$(0);
      var x1 = _this_.getX_ha5a7z_k$(2);
      var y1 = _this_.getY_ha5a7z_k$(2);
      if (((_this_.getX_ha5a7z_k$(1) === x1 ? _this_.getY_ha5a7z_k$(1) === y0 : false) ? _this_.getX_ha5a7z_k$(3) === x0 : false) ? _this_.getY_ha5a7z_k$(3) === y1 : false) {
        return new Rectangle_0(Companion_getInstance_35().fromBounds_i6u10_k$(x0, y0, x1, y1));
      }}return closed ? new Polygon(_this_) : new Polyline(_this_);
  }
  function vectorPath$factory() {
    return getPropertyCallableRef('vectorPath', 1, KProperty1, function (receiver) {
      return receiver._get_vectorPath__0_k$();
    }, null);
  }
  function vectorPath$factory_0() {
    return getPropertyCallableRef('vectorPath', 1, KProperty1, function (receiver) {
      return receiver._get_vectorPath__0_k$();
    }, null);
  }
  function paths$factory() {
    return getPropertyCallableRef('paths', 1, KProperty1, function (receiver) {
      return receiver._get_paths__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_47(this$0) {
    var i = new _no_name_provided__67(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_48(this$0) {
    var i = new _no_name_provided__68(this$0);
    return function (p1) {
      i.invoke_xoz56j_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_49(this$0) {
    var i = new _no_name_provided__69(this$0);
    return function (p1) {
      i.invoke_xoz56j_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_50(this$0) {
    var i = new _no_name_provided__70(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_51(this$0) {
    var i = new _no_name_provided__71(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function Companion_53() {
    Companion_instance_52 = this;
  }
  Companion_53.prototype.getIntersectXY_4h0tbn_k$ = function (a, b, out) {
    var Ax_1 = a._ax;
    var Ay_2 = a._ay;
    var Bx_3 = a._bx;
    var By_4 = a._by;
    var Cx_5 = b._ax;
    var Cy_6 = b._ay;
    var Dx_7 = b._bx;
    var Dy_8 = b._by;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getIntersectXY_0 = Companion_getInstance_28();
      var a1_1 = By_4 - Ay_2;
      var b1_2 = Ax_1 - Bx_3;
      var c1_3 = a1_1 * Ax_1 + b1_2 * Ay_2;
      var a2_4 = Dy_8 - Cy_6;
      var b2_5 = Cx_5 - Dx_7;
      var c2_6 = a2_4 * Cx_5 + b2_5 * Cy_6;
      var determinant_7 = a1_1 * b2_5 - a2_4 * b1_2;
      if (determinant_7 === 0.0) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var x_8 = (b2_5 * c1_3 - b1_2 * c2_6) / determinant_7;
      var y_9 = (a1_1 * c2_6 - a2_4 * c1_3) / determinant_7;
      var tmp1__anonymous__10 = floorCeil(x_8);
      var tmp2__anonymous__10 = floorCeil(y_9);
      return out.setTo_ngl742_k$(tmp1__anonymous__10, tmp2__anonymous__10);
    }
     while (false);
    Unit_getInstance();
    return null;
  };
  Companion_53.prototype.angleBetween_om8571_k$ = function (a, b) {
    return minus_2(b._get_angle__gxicn3_k$(), a._get_angle__gxicn3_k$());
  };
  Companion_53.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_52;
  function Companion_getInstance_52() {
    if (Companion_instance_52 == null)
      new Companion_53();
    return Companion_instance_52;
  }
  function Edge() {
    Companion_getInstance_52();
    this._ax = 0;
    this._ay = 0;
    this._bx = 0;
    this._by = 0;
    this._wind = 0;
    this._dy = 0;
    this._dx = 0;
    this._isCoplanarX = false;
    this._isCoplanarY = false;
    this._h = 0;
  }
  Edge.prototype.getX_ha5a7z_k$ = function (n) {
    return n === 0 ? this._ax : this._bx;
  };
  Edge.prototype.getY_ha5a7z_k$ = function (n) {
    return n === 0 ? this._ay : this._by;
  };
  Edge.prototype.copyFrom_tw2c07_k$ = function (other) {
    return this.setTo_ggpfpb_k$(other._ax, other._ay, other._bx, other._by, other._wind);
  };
  Edge.prototype.setTo_ggpfpb_k$ = function (ax, ay, bx, by, wind) {
    this._ax = ax;
    this._ay = ay;
    this._bx = bx;
    this._by = by;
    this._dx = bx - ax | 0;
    this._dy = by - ay | 0;
    this._isCoplanarX = ay === by;
    this._isCoplanarY = ax === bx;
    this._wind = wind;
    this._h = this._isCoplanarY ? 0 : ay - (imul(ax, this._dy) / this._dx | 0) | 0;
    return this;
  };
  Edge.prototype._get_minY__0_k$ = function () {
    var tmp0_min_0 = this._ay;
    var tmp1_min_0 = this._by;
    return Math.min(tmp0_min_0, tmp1_min_0);
  };
  Edge.prototype._get_maxY__0_k$ = function () {
    var tmp0_max_0 = this._ay;
    var tmp1_max_0 = this._by;
    return Math.max(tmp0_max_0, tmp1_max_0);
  };
  Edge.prototype.containsY_ha5a7z_k$ = function (y) {
    return y >= this._ay ? y < this._by : false;
  };
  Edge.prototype.intersectX_ha5a7z_k$ = function (y) {
    return this._isCoplanarY ? this._ax : imul(y - this._h | 0, this._dx) / this._dy | 0;
  };
  Edge.prototype._get_angle__gxicn3_k$ = function () {
    var tmp0_between_0 = Companion_getInstance_26();
    var tmp1_between_0 = this._ax;
    var tmp2_between_0 = this._ay;
    var tmp3_between_0 = this._bx;
    var tmp4_between_0 = this._by;
    var tmp0_between_0_1 = tmp1_between_0;
    var tmp1_between_0_2 = tmp2_between_0;
    var tmp2_between_0_3 = tmp3_between_0;
    var tmp3_between_0_4 = tmp4_between_0;
    return Angle_between(tmp0_between_0_1, tmp1_between_0_2, tmp2_between_0_3, tmp3_between_0_4);
  };
  Edge.prototype.toString = function () {
    return '' + 'Edge([' + this._ax + ',' + this._ay + ']-[' + this._bx + ',' + this._by + '])';
  };
  Edge.$metadata$ = {
    simpleName: 'Edge',
    kind: 'class',
    interfaces: []
  };
  var LineCap_BUTT_instance;
  var LineCap_SQUARE_instance;
  var LineCap_ROUND_instance;
  function Companion_54() {
    Companion_instance_53 = this;
  }
  Companion_54.prototype.get_uch40_k$ = function (str) {
    var tmp0_subject = str;
    switch (tmp0_subject) {
      case null:
        return LineCap_BUTT_getInstance();
      case 'BUTT':
      case 'butt':
        return LineCap_BUTT_getInstance();
      case 'SQUARE':
      case 'square':
        return LineCap_SQUARE_getInstance();
      case 'ROUND':
      case 'round':
        return LineCap_ROUND_getInstance();
      default:return LineCap_BUTT_getInstance();
    }
  };
  Companion_54.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_53;
  function Companion_getInstance_53() {
    if (Companion_instance_53 == null)
      new Companion_54();
    return Companion_instance_53;
  }
  var LineCap_entriesInitialized;
  function LineCap_initEntries() {
    if (LineCap_entriesInitialized)
      return Unit_getInstance();
    LineCap_entriesInitialized = true;
    LineCap_BUTT_instance = new LineCap('BUTT', 0);
    LineCap_SQUARE_instance = new LineCap('SQUARE', 1);
    LineCap_ROUND_instance = new LineCap('ROUND', 2);
    Companion_getInstance_53();
  }
  function LineCap(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LineCap.$metadata$ = {
    simpleName: 'LineCap',
    kind: 'class',
    interfaces: []
  };
  function LineCap_BUTT_getInstance() {
    LineCap_initEntries();
    return LineCap_BUTT_instance;
  }
  function LineCap_SQUARE_getInstance() {
    LineCap_initEntries();
    return LineCap_SQUARE_instance;
  }
  function LineCap_ROUND_getInstance() {
    LineCap_initEntries();
    return LineCap_ROUND_instance;
  }
  var LineJoin_BEVEL_instance;
  var LineJoin_ROUND_instance;
  var LineJoin_MITER_instance;
  function Companion_55() {
    Companion_instance_54 = this;
    this._SQUARE = LineJoin_BEVEL_getInstance();
  }
  Companion_55.prototype.get_uch40_k$ = function (str) {
    var tmp0_subject = str;
    switch (tmp0_subject) {
      case null:
        return LineJoin_MITER_getInstance();
      case 'MITER':
      case 'miter':
        return LineJoin_MITER_getInstance();
      case 'BEVEL':
      case 'bevel':
        return LineJoin_BEVEL_getInstance();
      case 'SQUARE':
      case 'square':
        return this._SQUARE;
      case 'ROUND':
      case 'round':
        return LineJoin_ROUND_getInstance();
      default:return LineJoin_MITER_getInstance();
    }
  };
  Companion_55.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_54;
  function Companion_getInstance_54() {
    if (Companion_instance_54 == null)
      new Companion_55();
    return Companion_instance_54;
  }
  var LineJoin_entriesInitialized;
  function LineJoin_initEntries() {
    if (LineJoin_entriesInitialized)
      return Unit_getInstance();
    LineJoin_entriesInitialized = true;
    LineJoin_BEVEL_instance = new LineJoin('BEVEL', 0);
    LineJoin_ROUND_instance = new LineJoin('ROUND', 1);
    LineJoin_MITER_instance = new LineJoin('MITER', 2);
    Companion_getInstance_54();
  }
  function LineJoin(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LineJoin.$metadata$ = {
    simpleName: 'LineJoin',
    kind: 'class',
    interfaces: []
  };
  function LineJoin_BEVEL_getInstance() {
    LineJoin_initEntries();
    return LineJoin_BEVEL_instance;
  }
  function LineJoin_ROUND_getInstance() {
    LineJoin_initEntries();
    return LineJoin_ROUND_instance;
  }
  function LineJoin_MITER_getInstance() {
    LineJoin_initEntries();
    return LineJoin_MITER_instance;
  }
  function _no_name_provided__72() {
  }
  _no_name_provided__72.prototype.invoke_xf6auj_k$ = function (it) {
    it.clear_0_k$();
    Unit_getInstance();
  };
  _no_name_provided__72.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xf6auj_k$(p1 instanceof Bucket ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__72.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__73() {
  }
  _no_name_provided__73.prototype.invoke_ha5a7z_k$ = function (it) {
    return new Bucket();
  };
  _no_name_provided__73.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__73.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Bucket() {
    this._edges = FastArrayList_init_$Create$();
  }
  Bucket.prototype.clear_0_k$ = function () {
    this._edges.clear_sv8swh_k$();
    return this;
  };
  Bucket.$metadata$ = {
    simpleName: 'Bucket',
    kind: 'class',
    interfaces: []
  };
  function Buckets(pool, ySize) {
    this._pool = pool;
    this._ySize = ySize;
    this._buckets = FastIntMap();
  }
  Buckets.prototype._get_size__0_k$ = function () {
    return _get_size_(this._buckets);
  };
  Buckets.prototype.getIndex_ha5a7z_k$ = function (y) {
    return y / this._ySize | 0;
  };
  Buckets.prototype.getForIndex_ha5a7z_k$ = function (index_0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getOrPut_0 = this._buckets;
      var res_1 = tmp0_getOrPut_0.get(index_0);
      if (!(res_1 == null)) {
        tmp$ret$0 = res_1;
        break l$ret$1;
      }var out_2 = this._pool.alloc_0_k$();
      tmp0_getOrPut_0.set(index_0, out_2);
      tmp$ret$0 = out_2;
    }
     while (false);
    return tmp$ret$0;
  };
  Buckets.prototype.getForYOrNull_ha5a7z_k$ = function (y) {
    var tmp0_get_0 = this._buckets;
    var tmp1_get_0 = this.getIndex_ha5a7z_k$(y);
    return tmp0_get_0.get(tmp1_get_0);
  };
  Buckets.prototype.clear_sv8swh_k$ = function () {
    var tmp0_fastForEach_0 = this._buckets;
    var mapIterator_1_1 = tmp0_fastForEach_0.keys();
    $l$break: while (true) {
      var v_2_2 = mapIterator_1_1.next();
      if (v_2_2.done)
        break $l$break;
      var tmp0__anonymous__3_3 = v_2_2.value;
      var tmp1__anonymous__4 = ensureNotNull(tmp0_fastForEach_0.get(tmp0__anonymous__3_3));
      this._pool.free_iav7o_k$(tmp1__anonymous__4.clear_0_k$());
    }
    var tmp2_clear_0 = this._buckets;
    tmp2_clear_0.clear();
  };
  Buckets.prototype.addThresold_g6t0o8_k$ = function (edge, threshold) {
    var min_0 = this.getIndex_ha5a7z_k$(edge._get_minY__0_k$());
    var max = this.getIndex_ha5a7z_k$(edge._get_maxY__0_k$());
    if ((max - min_0 | 0) < threshold) {
      var inductionVariable = min_0;
      if (inductionVariable <= max)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.getForIndex_ha5a7z_k$(n)._edges.add_2bq_k$(edge);
          Unit_getInstance();
        }
         while (!(n === max));
      return true;
    }return false;
  };
  Buckets.prototype.addThresold$default_32cixm_k$ = function (edge, threshold, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      threshold = IntCompanionObject_getInstance()._MAX_VALUE_5;
    return this.addThresold_g6t0o8_k$(edge, threshold);
  };
  Buckets.$metadata$ = {
    simpleName: 'Buckets',
    kind: 'class',
    interfaces: []
  };
  function AllBuckets() {
    var tmp = this;
    var tmp_0 = _no_name_provided_$factory_53();
    tmp._pool_0 = Pool_init_$Create$(tmp_0, 0, _no_name_provided_$factory_54(), 2, null);
    var tmp_1 = this;
    Companion_getInstance_55();
    tmp_1._small = new Buckets(this._pool_0, 80);
    var tmp_2 = this;
    Companion_getInstance_55();
    tmp_2._medium = new Buckets(this._pool_0, 320);
    var tmp_3 = this;
    Companion_getInstance_55();
    tmp_3._big = new Buckets(this._pool_0, 1280);
  }
  AllBuckets.prototype.add_ekpeoo_k$ = function (edge) {
    if (this._small.addThresold_g6t0o8_k$(edge, 4))
      return Unit_getInstance();
    if (this._medium.addThresold_g6t0o8_k$(edge, 4))
      return Unit_getInstance();
    this._big.addThresold$default_32cixm_k$(edge, 0, 2, null);
    Unit_getInstance();
  };
  AllBuckets.prototype.clear_sv8swh_k$ = function () {
    this._small.clear_sv8swh_k$();
    this._medium.clear_sv8swh_k$();
    this._big.clear_sv8swh_k$();
  };
  AllBuckets.$metadata$ = {
    simpleName: 'AllBuckets',
    kind: 'class',
    interfaces: []
  };
  function addPoint($this, x, y) {
    $this._points_1.add_ngl742_k$(x, y);
    Unit_getInstance();
  }
  function addEdge($this, ax, ay, bx, by) {
    if (ax === bx ? ay === by : false)
      return Unit_getInstance();
    var isHorizontal = ay === by;
    var iax = $this._get_s__xaho5p_k$(ax);
    var ibx = $this._get_s__xaho5p_k$(bx);
    var iay = $this._get_s__xaho5p_k$(ay);
    var iby = $this._get_s__xaho5p_k$(by);
    var edge = ay < by ? $this._edgesPool.alloc_0_k$().setTo_ggpfpb_k$(iax, iay, ibx, iby, 1) : $this._edgesPool.alloc_0_k$().setTo_ggpfpb_k$(ibx, iby, iax, iay, -1);
    $this._allEdges.add_2bq_k$(edge);
    Unit_getInstance();
    if (isHorizontal) {
      $this._hedges.add_2bq_k$(edge);
      Unit_getInstance();
    } else {
      $this._edges_0.add_2bq_k$(edge);
      Unit_getInstance();
      $this._buckets_0.add_ekpeoo_k$(edge);
    }
    $this._boundsBuilder.add_ngl742_k$(ax, ay);
    Unit_getInstance();
    $this._boundsBuilder.add_ngl742_k$(bx, by);
    Unit_getInstance();
  }
  function XWithWind() {
    this._x_5 = new IntArrayList(1024);
    this._w_0 = new IntArrayList(1024);
  }
  XWithWind.prototype._get_size__0_k$ = function () {
    return this._x_5._get_size__0_k$();
  };
  XWithWind.prototype.add_rvwcgf_k$ = function (x, wind) {
    this._x_5.add_majfzk_k$(x);
    this._w_0.add_majfzk_k$(wind);
  };
  XWithWind.prototype.clear_sv8swh_k$ = function () {
    this._x_5.clear_sv8swh_k$();
    this._w_0.clear_sv8swh_k$();
  };
  XWithWind.prototype.toString = function () {
    return '' + 'XWithWind(' + this._x_5 + ', ' + this._w_0 + ')';
  };
  XWithWind.$metadata$ = {
    simpleName: 'XWithWind',
    kind: 'class',
    interfaces: []
  };
  function IntArrayListSort() {
    IntArrayListSort_instance = this;
    SortOps.call(this);
  }
  IntArrayListSort.prototype.compare_t186c6_k$ = function (subject, l, r) {
    return compareTo(subject._x_5.getAt_ha5a7z_k$(l), subject._x_5.getAt_ha5a7z_k$(r));
  };
  IntArrayListSort.prototype.compare_7j2snf_k$ = function (subject, l, r) {
    return this.compare_t186c6_k$(subject instanceof XWithWind ? subject : THROW_CCE(), l, r);
  };
  IntArrayListSort.prototype.swap_rnd8yh_k$ = function (subject, indexL, indexR) {
    subject._x_5.swap_rvwcgf_k$(indexL, indexR);
    subject._w_0.swap_rvwcgf_k$(indexL, indexR);
  };
  IntArrayListSort.prototype.swap_n1r3z0_k$ = function (subject, indexL, indexR) {
    return this.swap_rnd8yh_k$(subject instanceof XWithWind ? subject : THROW_CCE(), indexL, indexR);
  };
  IntArrayListSort.$metadata$ = {
    simpleName: 'IntArrayListSort',
    kind: 'object',
    interfaces: []
  };
  var IntArrayListSort_instance;
  function IntArrayListSort_getInstance() {
    if (IntArrayListSort_instance == null)
      new IntArrayListSort();
    return IntArrayListSort_instance;
  }
  function _no_name_provided__74() {
  }
  _no_name_provided__74.prototype.invoke_ha5a7z_k$ = function (it) {
    return new Edge();
  };
  _no_name_provided__74.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__74.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PolygonScanline() {
    RastScale.call(this);
    this._version = -1;
    this._winding = Winding_NON_ZERO_getInstance();
    this._boundsBuilder = new BoundsBuilder();
    var tmp = this;
    tmp._edgesPool = Pool_init_$Create$_1(0, _no_name_provided_$factory_52(), 1, null);
    this._edges_0 = FastArrayList_init_$Create$();
    this._hedges = FastArrayList_init_$Create$();
    this._allEdges = FastArrayList_init_$Create$();
    this._buckets_0 = new AllBuckets();
    this._closed_5 = true;
    var tmp_0 = this;
    tmp_0._points_1 = PointArrayList_init_$Create$(0, 1, null);
    this._moveToX = 0.0;
    this._moveToY = 0.0;
    this._lastX = 0.0;
    this._lastY = 0.0;
    this._lastMoveTo = false;
    this._tempXW = new XWithWind();
    this._edgesChecked = 0;
    this._ss = new IntSegmentSet();
  }
  PolygonScanline.prototype.getBounds_uebyw0_k$ = function (out) {
    return this._boundsBuilder.getBounds_uebyw0_k$(out);
  };
  PolygonScanline.prototype.reset_sv8swh_k$ = function () {
    this._closed_5 = true;
    this._boundsBuilder.reset_sv8swh_k$();
    var tmp0_fastForEach_0 = this._edges_0;
    var array_1 = tmp0_fastForEach_0._array_4;
    var n_2 = 0;
    while (n_2 < array_1.length) {
      var tmp0_4 = n_2;
      n_2 = tmp0_4 + 1 | 0;
      var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
      var tmp1__anonymous__5 = tmp0_unsafeCast_0_3;
      this._edgesPool.free_iav7o_k$(tmp1__anonymous__5);
    }
    var tmp2_fastForEach_0 = this._hedges;
    var array_1_0 = tmp2_fastForEach_0._array_4;
    var n_2_0 = 0;
    while (n_2_0 < array_1_0.length) {
      var tmp0_4_0 = n_2_0;
      n_2_0 = tmp0_4_0 + 1 | 0;
      var tmp0_unsafeCast_0_3_0 = array_1_0[tmp0_4_0];
      var tmp3__anonymous__5 = tmp0_unsafeCast_0_3_0;
      this._edgesPool.free_iav7o_k$(tmp3__anonymous__5);
    }
    this._edges_0.clear_sv8swh_k$();
    this._hedges.clear_sv8swh_k$();
    this._allEdges.clear_sv8swh_k$();
    this._points_1.clear_0_k$();
    Unit_getInstance();
    this._buckets_0.clear_sv8swh_k$();
    this._moveToX = 0.0;
    this._moveToY = 0.0;
    this._lastX = 0.0;
    this._lastY = 0.0;
    this._lastMoveTo = false;
  };
  PolygonScanline.prototype._get_edgesSize__0_k$ = function () {
    return this._edges_0._get_size__0_k$();
  };
  PolygonScanline.prototype.isNotEmpty_0_k$ = function () {
    return this._get_edgesSize__0_k$() > 0;
  };
  PolygonScanline.prototype.moveTo_ul66c3_k$ = function (x, y) {
    this._lastX = x;
    this._lastY = y;
    this._moveToX = x;
    this._moveToY = y;
    this._lastMoveTo = true;
  };
  PolygonScanline.prototype.lineTo_ul66c3_k$ = function (x, y) {
    if (this._lastMoveTo) {
      addPoint(this, this._lastX, this._lastY);
    }addEdge(this, this._lastX, this._lastY, x, y);
    addPoint(this, x, y);
    this._lastX = x;
    this._lastY = y;
    this._lastMoveTo = false;
  };
  PolygonScanline.prototype.add_qvfozx_k$ = function (path_0) {
    var ix_3 = 0.0;
    var iy_4 = 0.0;
    var lx_5 = {_v: 0.0};
    var ly_6 = {_v: 0.0};
    if (false)
      this.close_sv8swh_k$();
    var n_1_7 = 0;
    var tmp0_fastForEach_0_8 = path_0._commands;
    var n_1_9 = 0;
    while (n_1_9 < tmp0_fastForEach_0_8._get_size__0_k$()) {
      var tmp0_2_11 = n_1_9;
      n_1_9 = tmp0_2_11 + 1 | 0;
      var tmp1__anonymous__2_3_10 = tmp0_fastForEach_0_8.getAt_ha5a7z_k$(tmp0_2_11);
      var tmp0_subject_3_4_12 = tmp1__anonymous__2_3_10;
      Command_getInstance();
      if (tmp0_subject_3_4_12 === 0) {
        var tmp1_4_5_14 = n_1_7;
        n_1_7 = tmp1_4_5_14 + 1 | 0;
        var tmp2__anonymous__18_13 = path_0._data_11.get_ha5a7z_k$(tmp1_4_5_14);
        var tmp2_5_6_16 = n_1_7;
        n_1_7 = tmp2_5_6_16 + 1 | 0;
        var tmp3__anonymous__18_15 = path_0._data_11.get_ha5a7z_k$(tmp2_5_6_16);
        ix_3 = tmp2__anonymous__18_13;
        iy_4 = tmp3__anonymous__18_15;
        var tmp0_also_0_20_18 = this.add_pux2sr_k$(tmp2__anonymous__18_13, tmp3__anonymous__18_15, true);
        lx_5._v = tmp2__anonymous__18_13;
        var tmp1_also_0_19_17 = tmp0_also_0_20_18;
        ly_6._v = tmp3__anonymous__18_15;
      } else {
        Command_getInstance();
        if (tmp0_subject_3_4_12 === 1) {
          var tmp3_6_7_20 = n_1_7;
          n_1_7 = tmp3_6_7_20 + 1 | 0;
          var tmp4__anonymous__21_19 = path_0._data_11.get_ha5a7z_k$(tmp3_6_7_20);
          var tmp4_7_8_22 = n_1_7;
          n_1_7 = tmp4_7_8_22 + 1 | 0;
          var tmp5__anonymous__21_21 = path_0._data_11.get_ha5a7z_k$(tmp4_7_8_22);
          var tmp0_also_0_23_24 = this.add_pux2sr_k$(tmp4__anonymous__21_19, tmp5__anonymous__21_21, false);
          lx_5._v = tmp4__anonymous__21_19;
          var tmp1_also_0_22_23 = tmp0_also_0_23_24;
          ly_6._v = tmp5__anonymous__21_21;
          Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_3_4_12 === 2) {
            var tmp5_8_9_26 = n_1_7;
            n_1_7 = tmp5_8_9_26 + 1 | 0;
            var tmp6__anonymous__24_25 = path_0._data_11.get_ha5a7z_k$(tmp5_8_9_26);
            var tmp6_9_10_28 = n_1_7;
            n_1_7 = tmp6_9_10_28 + 1 | 0;
            var tmp7__anonymous__24_27 = path_0._data_11.get_ha5a7z_k$(tmp6_9_10_28);
            var tmp7_10_11_30 = n_1_7;
            n_1_7 = tmp7_10_11_30 + 1 | 0;
            var tmp8__anonymous__24_29 = path_0._data_11.get_ha5a7z_k$(tmp7_10_11_30);
            var tmp8_11_12_32 = n_1_7;
            n_1_7 = tmp8_11_12_32 + 1 | 0;
            var tmp9__anonymous__24_31 = path_0._data_11.get_ha5a7z_k$(tmp8_11_12_32);
            var sum_25_33 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp6__anonymous__24_25, tmp7__anonymous__24_27) + Companion_getInstance_32().distance_i6u10_k$(tmp6__anonymous__24_25, tmp7__anonymous__24_27, tmp8__anonymous__24_29, tmp9__anonymous__24_31);
            var tmp0_approximateCurve_0_26_34 = numberToInt(sum_25_33);
            var rcurveSteps_1_27_35 = Math.max(tmp0_approximateCurve_0_26_34, 20);
            var dt_2_28_36 = 1.0 / rcurveSteps_1_27_35;
            var lastX_3_29_37 = {_v: 0.0};
            var lastY_4_30_38 = {_v: 0.0};
            var prevX_5_31_39 = {_v: 0.0};
            var prevY_6_32_40 = {_v: 0.0};
            var emittedCount_7_33_41 = {_v: 0};
            var tmp0_quadCalc_0_16_34_42 = Companion_getInstance_41();
            var tmp1_quadCalc_0_17_35_43 = lx_5._v;
            var tmp2_quadCalc_0_18_36_44 = ly_6._v;
            var t1_1_19_37_45 = 1.0;
            var a_2_20_38_46 = t1_1_19_37_45 * t1_1_19_37_45;
            var c_3_21_39_47 = 0.0;
            var b_4_22_40_48 = 2 * t1_1_19_37_45 * 0.0;
            var tmp3__anonymous__5_23_41_49 = a_2_20_38_46 * tmp1_quadCalc_0_17_35_43 + b_4_22_40_48 * tmp6__anonymous__24_25 + c_3_21_39_47 * tmp8__anonymous__24_29;
            var tmp4__anonymous__5_24_42_50 = a_2_20_38_46 * tmp2_quadCalc_0_18_36_44 + b_4_22_40_48 * tmp7__anonymous__24_27 + c_3_21_39_47 * tmp9__anonymous__24_31;
            lastX_3_29_37._v = tmp3__anonymous__5_23_41_49;
            lastY_4_30_38._v = tmp4__anonymous__5_24_42_50;
            var inductionVariable = 1;
            if (inductionVariable < rcurveSteps_1_27_35)
              do {
                var n_10_44_52 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_11_45_53 = n_10_44_52 * dt_2_28_36;
                var tmp0_quadCalc_0_16_46_54 = Companion_getInstance_41();
                var tmp1_quadCalc_0_17_47_55 = lx_5._v;
                var tmp2_quadCalc_0_18_48_56 = ly_6._v;
                var t1_1_19_49_57 = 1 - ratio_11_45_53;
                var a_2_20_50_58 = t1_1_19_49_57 * t1_1_19_49_57;
                var c_3_21_51_59 = ratio_11_45_53 * ratio_11_45_53;
                var b_4_22_52_60 = 2 * t1_1_19_49_57 * ratio_11_45_53;
                var tmp3__anonymous__5_23_53_61 = a_2_20_50_58 * tmp1_quadCalc_0_17_47_55 + b_4_22_52_60 * tmp6__anonymous__24_25 + c_3_21_51_59 * tmp8__anonymous__24_29;
                var tmp4__anonymous__5_24_54_62 = a_2_20_50_58 * tmp2_quadCalc_0_18_48_56 + b_4_22_52_60 * tmp7__anonymous__24_27 + c_3_21_51_59 * tmp9__anonymous__24_31;
                this.add_pux2sr_k$(tmp3__anonymous__5_23_53_61, tmp4__anonymous__5_24_54_62, false);
                var tmp0_14_2_27_55_63 = emittedCount_7_33_41._v;
                emittedCount_7_33_41._v = tmp0_14_2_27_55_63 + 1 | 0;
                Unit_getInstance();
                lastX_3_29_37._v = prevX_5_31_39._v;
                lastY_4_30_38._v = prevY_6_32_40._v;
                prevX_5_31_39._v = tmp3__anonymous__5_23_53_61;
                prevY_6_32_40._v = tmp4__anonymous__5_24_54_62;
              }
               while (inductionVariable < rcurveSteps_1_27_35);
            var tmp1_also_0_56_64 = lx_5._v = tmp8__anonymous__24_29;
            ly_6._v = tmp9__anonymous__24_31;
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_3_4_12 === 3) {
              var tmp9_12_13_66 = n_1_7;
              n_1_7 = tmp9_12_13_66 + 1 | 0;
              var tmp10__anonymous__57_65 = path_0._data_11.get_ha5a7z_k$(tmp9_12_13_66);
              var tmp10_13_14_68 = n_1_7;
              n_1_7 = tmp10_13_14_68 + 1 | 0;
              var tmp11__anonymous__57_67 = path_0._data_11.get_ha5a7z_k$(tmp10_13_14_68);
              var tmp11_14_15_70 = n_1_7;
              n_1_7 = tmp11_14_15_70 + 1 | 0;
              var tmp12__anonymous__57_69 = path_0._data_11.get_ha5a7z_k$(tmp11_14_15_70);
              var tmp12_15_16_72 = n_1_7;
              n_1_7 = tmp12_15_16_72 + 1 | 0;
              var tmp13__anonymous__57_71 = path_0._data_11.get_ha5a7z_k$(tmp12_15_16_72);
              var tmp13_16_17_74 = n_1_7;
              n_1_7 = tmp13_16_17_74 + 1 | 0;
              var tmp14__anonymous__57_73 = path_0._data_11.get_ha5a7z_k$(tmp13_16_17_74);
              var tmp14_17_18_76 = n_1_7;
              n_1_7 = tmp14_17_18_76 + 1 | 0;
              var tmp15__anonymous__57_75 = path_0._data_11.get_ha5a7z_k$(tmp14_17_18_76);
              var sum_58_77 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp10__anonymous__57_65, tmp11__anonymous__57_67) + Companion_getInstance_32().distance_i6u10_k$(tmp10__anonymous__57_65, tmp11__anonymous__57_67, tmp12__anonymous__57_69, tmp13__anonymous__57_71) + Companion_getInstance_32().distance_i6u10_k$(tmp12__anonymous__57_69, tmp13__anonymous__57_71, tmp14__anonymous__57_73, tmp15__anonymous__57_75);
              var tmp0_approximateCurve_0_59_78 = numberToInt(sum_58_77);
              var rcurveSteps_1_60_79 = Math.max(tmp0_approximateCurve_0_59_78, 20);
              var dt_2_61_80 = 1.0 / rcurveSteps_1_60_79;
              var lastX_3_62_81 = {_v: 0.0};
              var lastY_4_63_82 = {_v: 0.0};
              var prevX_5_64_83 = {_v: 0.0};
              var prevY_6_65_84 = {_v: 0.0};
              var emittedCount_7_66_85 = {_v: 0};
              var tmp0_cubicCalc_0_16_67_86 = Companion_getInstance_41();
              var tmp1_cubicCalc_0_17_68_87 = lx_5._v;
              var tmp2_cubicCalc_0_18_69_88 = ly_6._v;
              var cx_1_19_70_89 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_68_87);
              var bx_2_20_71_90 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_70_89;
              var ax_3_21_72_91 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_68_87 - cx_1_19_70_89 - bx_2_20_71_90;
              var cy_4_22_73_92 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_69_88);
              var by_5_23_74_93 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_73_92;
              var ay_6_24_75_94 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_69_88 - cy_4_22_73_92 - by_5_23_74_93;
              var tSquared_7_25_76_95 = 0.0;
              var tCubed_8_26_77_96 = tSquared_7_25_76_95 * 0.0;
              var tmp3__anonymous__9_27_78_97 = ax_3_21_72_91 * tCubed_8_26_77_96 + bx_2_20_71_90 * tSquared_7_25_76_95 + cx_1_19_70_89 * 0.0 + tmp1_cubicCalc_0_17_68_87;
              var tmp4__anonymous__9_28_79_98 = ay_6_24_75_94 * tCubed_8_26_77_96 + by_5_23_74_93 * tSquared_7_25_76_95 + cy_4_22_73_92 * 0.0 + tmp2_cubicCalc_0_18_69_88;
              lastX_3_62_81._v = tmp3__anonymous__9_27_78_97;
              lastY_4_63_82._v = tmp4__anonymous__9_28_79_98;
              var inductionVariable_0 = 1;
              if (inductionVariable_0 < rcurveSteps_1_60_79)
                do {
                  var n_10_81_100 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var ratio_11_82_101 = n_10_81_100 * dt_2_61_80;
                  var tmp0_cubicCalc_0_16_83_102 = Companion_getInstance_41();
                  var tmp1_cubicCalc_0_17_84_103 = lx_5._v;
                  var tmp2_cubicCalc_0_18_85_104 = ly_6._v;
                  var cx_1_19_86_105 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_84_103);
                  var bx_2_20_87_106 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_86_105;
                  var ax_3_21_88_107 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_84_103 - cx_1_19_86_105 - bx_2_20_87_106;
                  var cy_4_22_89_108 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_85_104);
                  var by_5_23_90_109 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_89_108;
                  var ay_6_24_91_110 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_85_104 - cy_4_22_89_108 - by_5_23_90_109;
                  var tSquared_7_25_92_111 = ratio_11_82_101 * ratio_11_82_101;
                  var tCubed_8_26_93_112 = tSquared_7_25_92_111 * ratio_11_82_101;
                  var tmp3__anonymous__9_27_94_113 = ax_3_21_88_107 * tCubed_8_26_93_112 + bx_2_20_87_106 * tSquared_7_25_92_111 + cx_1_19_86_105 * ratio_11_82_101 + tmp1_cubicCalc_0_17_84_103;
                  var tmp4__anonymous__9_28_95_114 = ay_6_24_91_110 * tCubed_8_26_93_112 + by_5_23_90_109 * tSquared_7_25_92_111 + cy_4_22_89_108 * ratio_11_82_101 + tmp2_cubicCalc_0_18_85_104;
                  this.add_pux2sr_k$(tmp3__anonymous__9_27_94_113, tmp4__anonymous__9_28_95_114, false);
                  var tmp0_14_2_31_96_115 = emittedCount_7_66_85._v;
                  emittedCount_7_66_85._v = tmp0_14_2_31_96_115 + 1 | 0;
                  Unit_getInstance();
                  lastX_3_62_81._v = prevX_5_64_83._v;
                  lastY_4_63_82._v = prevY_6_65_84._v;
                  prevX_5_64_83._v = tmp3__anonymous__9_27_94_113;
                  prevY_6_65_84._v = tmp4__anonymous__9_28_95_114;
                }
                 while (inductionVariable_0 < rcurveSteps_1_60_79);
              var tmp1_also_0_97_116 = lx_5._v = tmp14__anonymous__57_73;
              ly_6._v = tmp15__anonymous__57_75;
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_3_4_12 === 4) {
                var tmp0__anonymous__118 = ix_3;
                var tmp1__anonymous__118 = iy_4;
                this.add_pux2sr_k$(tmp0__anonymous__118, tmp1__anonymous__118, false);
                Unit_getInstance();
                this.close_sv8swh_k$();
              } else {
              }
            }
          }
        }
      }
    }
    if (false)
      this.close_sv8swh_k$();
  };
  PolygonScanline.prototype.add_pux2sr_k$ = function (x, y, move) {
    return move ? this.moveTo_ul66c3_k$(x, y) : this.lineTo_ul66c3_k$(x, y);
  };
  PolygonScanline.prototype.close_sv8swh_k$ = function () {
    this.lineTo_ul66c3_k$(this._moveToX, this._moveToY);
  };
  PolygonScanline.prototype.scanline_qob2xp_k$ = function (y, winding, out) {
    this._edgesChecked = 0;
    this._tempXW.clear_sv8swh_k$();
    out.clear_0_k$();
    Unit_getInstance();
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._edgesChecked;
    var edgesChecked_1 = 0;
    var tmp0_fastForEachY_0_2 = this._buckets_0;
    var tmp0_fastForEachY_0_1_3 = tmp0_fastForEachY_0_2._small;
    if (tmp0_fastForEachY_0_1_3._get_size__0_k$() > 0) {
      var tmp0_safe_receiver_1_2_4 = tmp0_fastForEachY_0_1_3.getForYOrNull_ha5a7z_k$(y);
      if (tmp0_safe_receiver_1_2_4 == null)
        null;
      else {
        var tmp0_fastForEach_0_1_2_3_5 = tmp0_safe_receiver_1_2_4._edges;
        var array_1_2_3_4_6 = tmp0_fastForEach_0_1_2_3_5._array_4;
        var n_2_3_4_5_7 = 0;
        while (n_2_3_4_5_7 < array_1_2_3_4_6.length) {
          var tmp0_4_5_6_8_10 = n_2_3_4_5_7;
          n_2_3_4_5_7 = tmp0_4_5_6_8_10 + 1 | 0;
          var tmp0_unsafeCast_0_3_4_5_7_9 = array_1_2_3_4_6[tmp0_4_5_6_8_10];
          var tmp1__anonymous__7_6_8 = tmp0_unsafeCast_0_3_4_5_7_9;
          var tmp0_26_11 = edgesChecked_1;
          edgesChecked_1 = tmp0_26_11 + 1 | 0;
          Unit_getInstance();
          if (tmp1__anonymous__7_6_8.containsY_ha5a7z_k$(y)) {
            if (!tmp1__anonymous__7_6_8._isCoplanarX) {
              this._tempXW.add_rvwcgf_k$(tmp1__anonymous__7_6_8.intersectX_ha5a7z_k$(y), tmp1__anonymous__7_6_8._wind);
            }}}
        Unit_getInstance();
      }
      Unit_getInstance();
    }var tmp2_fastForEachY_0_9_12 = tmp0_fastForEachY_0_2._medium;
    if (tmp2_fastForEachY_0_9_12._get_size__0_k$() > 0) {
      var tmp0_safe_receiver_1_10_13 = tmp2_fastForEachY_0_9_12.getForYOrNull_ha5a7z_k$(y);
      if (tmp0_safe_receiver_1_10_13 == null)
        null;
      else {
        var tmp0_fastForEach_0_1_2_11_14 = tmp0_safe_receiver_1_10_13._edges;
        var array_1_2_3_12_15 = tmp0_fastForEach_0_1_2_11_14._array_4;
        var n_2_3_4_13_16 = 0;
        while (n_2_3_4_13_16 < array_1_2_3_12_15.length) {
          var tmp0_4_5_6_16_19 = n_2_3_4_13_16;
          n_2_3_4_13_16 = tmp0_4_5_6_16_19 + 1 | 0;
          var tmp0_unsafeCast_0_3_4_5_15_18 = array_1_2_3_12_15[tmp0_4_5_6_16_19];
          var tmp3__anonymous__7_14_17 = tmp0_unsafeCast_0_3_4_5_15_18;
          var tmp0_26_20 = edgesChecked_1;
          edgesChecked_1 = tmp0_26_20 + 1 | 0;
          Unit_getInstance();
          if (tmp3__anonymous__7_14_17.containsY_ha5a7z_k$(y)) {
            if (!tmp3__anonymous__7_14_17._isCoplanarX) {
              this._tempXW.add_rvwcgf_k$(tmp3__anonymous__7_14_17.intersectX_ha5a7z_k$(y), tmp3__anonymous__7_14_17._wind);
            }}}
        Unit_getInstance();
      }
      Unit_getInstance();
    }var tmp4_fastForEachY_0_17_21 = tmp0_fastForEachY_0_2._big;
    if (tmp4_fastForEachY_0_17_21._get_size__0_k$() > 0) {
      var tmp0_safe_receiver_1_18_22 = tmp4_fastForEachY_0_17_21.getForYOrNull_ha5a7z_k$(y);
      if (tmp0_safe_receiver_1_18_22 == null)
        null;
      else {
        var tmp0_fastForEach_0_1_2_19_23 = tmp0_safe_receiver_1_18_22._edges;
        var array_1_2_3_20_24 = tmp0_fastForEach_0_1_2_19_23._array_4;
        var n_2_3_4_21_25 = 0;
        while (n_2_3_4_21_25 < array_1_2_3_20_24.length) {
          var tmp0_4_5_6_24_28 = n_2_3_4_21_25;
          n_2_3_4_21_25 = tmp0_4_5_6_24_28 + 1 | 0;
          var tmp0_unsafeCast_0_3_4_5_23_27 = array_1_2_3_20_24[tmp0_4_5_6_24_28];
          var tmp5__anonymous__7_22_26 = tmp0_unsafeCast_0_3_4_5_23_27;
          var tmp0_26_29 = edgesChecked_1;
          edgesChecked_1 = tmp0_26_29 + 1 | 0;
          Unit_getInstance();
          if (tmp5__anonymous__7_22_26.containsY_ha5a7z_k$(y)) {
            if (!tmp5__anonymous__7_22_26._isCoplanarX) {
              this._tempXW.add_rvwcgf_k$(tmp5__anonymous__7_22_26.intersectX_ha5a7z_k$(y), tmp5__anonymous__7_22_26._wind);
            }}}
        Unit_getInstance();
      }
      Unit_getInstance();
    }tmp._edgesChecked = tmp_0 + edgesChecked_1 | 0;
    genericSort(this._tempXW, 0, this._tempXW._get_size__0_k$() - 1 | 0, IntArrayListSort_getInstance());
    Unit_getInstance();
    var tempX = this._tempXW._x_5;
    var tempW = this._tempXW._w_0;
    if (this._tempXW._get_size__0_k$() >= 2) {
      var tmp1_subject = winding;
      if (tmp1_subject.equals(Winding_EVEN_ODD_getInstance())) {
        var progression = step(until(0, tempX._get_size__0_k$() - 1 | 0), 2);
        var inductionVariable = progression._first_0;
        var last_1 = progression._last;
        var step_0 = progression._step_2;
        if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            var a = tempX.getAt_ha5a7z_k$(i);
            var b = tempX.getAt_ha5a7z_k$(i + 1 | 0);
            out.add_27zxwg_k$(a, b);
            Unit_getInstance();
          }
           while (!(i === last_1));
      } else if (tmp1_subject.equals(Winding_NON_ZERO_getInstance())) {
        var count_0 = 0;
        var startX = 0;
        var endX = 0;
        var pending = false;
        var inductionVariable_0 = 0;
        var last_2 = tempX._get_size__0_k$() - 1 | 0;
        if (inductionVariable_0 < last_2)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a_0 = tempX.getAt_ha5a7z_k$(i_0);
            count_0 = count_0 + tempW.getAt_ha5a7z_k$(i_0) | 0;
            var b_0 = tempX.getAt_ha5a7z_k$(i_0 + 1 | 0);
            if (!(count_0 === 0)) {
              if (pending ? !(a_0 === endX) : false) {
                out.add_27zxwg_k$(startX, endX);
                Unit_getInstance();
                startX = a_0;
                endX = b_0;
              } else {
                if (!pending) {
                  startX = a_0;
                }endX = b_0;
              }
              pending = true;
            }}
           while (inductionVariable_0 < last_2);
        if (pending) {
          out.add_27zxwg_k$(startX, endX);
          Unit_getInstance();
        }}}return out;
  };
  PolygonScanline.prototype.containsPoint_vxd5eo_k$ = function (x, y, winding) {
    return this.containsPointInt_kadvjy_k$(this._get_s__xaho5p_k$(x), this._get_s__xaho5p_k$(y), winding);
  };
  PolygonScanline.prototype.containsPointInt_kadvjy_k$ = function (x, y, winding) {
    var ss = this._ss;
    this.scanline_qob2xp_k$(y, winding, ss.clear_0_k$());
    Unit_getInstance();
    return ss.contains_ha5a7z_k$(x);
  };
  PolygonScanline.$metadata$ = {
    simpleName: 'PolygonScanline',
    kind: 'class',
    interfaces: []
  };
  function Companion_56() {
    Companion_instance_55 = this;
    this._RAST_FIXED_SCALE = 20;
    this._RAST_FIXED_SCALE_HALF = 0;
    this._RAST_SMALL_BUCKET_SIZE = 80;
    this._RAST_MEDIUM_BUCKET_SIZE = 320;
    this._RAST_BIG_BUCKET_SIZE = 1280;
  }
  Companion_56.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_55;
  function Companion_getInstance_55() {
    if (Companion_instance_55 == null)
      new Companion_56();
    return Companion_instance_55;
  }
  function RastScale() {
    Companion_getInstance_55();
  }
  RastScale.prototype._get_sscale__0_k$ = function () {
    Companion_getInstance_55();
    return 20;
  };
  RastScale.prototype._get_hscale__0_k$ = function () {
    Companion_getInstance_55();
    return 0;
  };
  RastScale.prototype._get_s__xaho5p_k$ = function (_this__0) {
    return numberToInt(_this__0 * this._get_sscale__0_k$()) + this._get_hscale__0_k$() | 0;
  };
  RastScale.$metadata$ = {
    simpleName: 'RastScale',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_52() {
    var i = new _no_name_provided__74();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_53() {
    var i = new _no_name_provided__72();
    return function (p1) {
      i.invoke_xf6auj_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_54() {
    var i = new _no_name_provided__73();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  var EdgePoint_A_instance;
  var EdgePoint_B_instance;
  var EdgePoint_entriesInitialized;
  function EdgePoint_initEntries() {
    if (EdgePoint_entriesInitialized)
      return Unit_getInstance();
    EdgePoint_entriesInitialized = true;
    EdgePoint_A_instance = new EdgePoint('A', 0, 0);
    EdgePoint_B_instance = new EdgePoint('B', 1, 1);
  }
  function _get_outFill_($this) {
    var tmp = $this._outFill;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('outFill');
    }
  }
  function EdgePoint(name, ordinal, n) {
    Enum.call(this, name, ordinal);
    this._n = n;
  }
  EdgePoint.$metadata$ = {
    simpleName: 'EdgePoint',
    kind: 'class',
    interfaces: []
  };
  function EdgePoint_A_getInstance() {
    EdgePoint_initEntries();
    return EdgePoint_A_instance;
  }
  function EdgePoint_B_getInstance() {
    EdgePoint_initEntries();
    return EdgePoint_B_instance;
  }
  function StrokeToFill() {
    this._weight = 1;
    this._startCap = LineCap_BUTT_getInstance();
    this._endCap = LineCap_BUTT_getInstance();
    this._joins = LineJoin_BEVEL_getInstance();
    this._miterLimit = 4.0;
    this._strokePoints = new PointIntArrayList(1024);
    this._doJointList = new IntArrayList(1024);
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 2;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new PointIntArrayList(1024);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._fillPoints = tmp_2;
    this._fillPointsLeft = this._fillPoints[0];
    this._fillPointsRight = this._fillPoints[1];
    this._prevEdge = new Edge();
    this._prevEdgeLeft = new Edge();
    this._prevEdgeRight = new Edge();
    this._currEdge = new Edge();
    this._currEdgeLeft = new Edge();
    this._currEdgeRight = new Edge();
    this._tempP1 = Companion_getInstance_32().invoke_0_k$();
    this._tempP2 = Companion_getInstance_32().invoke_0_k$();
    this._tempP3 = Companion_getInstance_32().invoke_0_k$();
  }
  StrokeToFill.prototype.setEdgeDisplaced_csnquz_k$ = function (_this__0, edge, width, angle) {
    var ldx_2 = width * _get_cosine_(angle);
    var ldy_3 = width * _get_sine_(angle);
    _this__0.setTo_ggpfpb_k$(numberToInt(edge._ax + ldx_2), numberToInt(edge._ay + ldy_3), numberToInt(edge._bx + ldx_2), numberToInt(edge._by + ldy_3), edge._wind);
    Unit_getInstance();
    return _this__0;
  };
  StrokeToFill.prototype.addEdgePointA_bpqimo_k$ = function (_this__0, e) {
    return _this__0.add_27zxwg_k$(e._ax, e._ay);
  };
  StrokeToFill.prototype.addEdgePointB_bpqimo_k$ = function (_this__0, e) {
    return _this__0.add_27zxwg_k$(e._bx, e._by);
  };
  StrokeToFill.prototype.add_1vzql2_k$ = function (_this__0, e) {
    var tmp;
    if (!(e == null)) {
      _this__0.add_27zxwg_k$(numberToInt(e._x_1), numberToInt(e._y_1));
      tmp = Unit_getInstance();
    }return tmp;
  };
  StrokeToFill.prototype.doJoin_91mqsc_k$ = function (out, mainPrev, mainCurr, prev, curr, join, miterLimit, scale_1, forcedMiter) {
    var rjoin = forcedMiter ? LineJoin_MITER_getInstance() : join;
    var tmp0_subject = rjoin;
    if (tmp0_subject.equals(LineJoin_MITER_getInstance())) {
      var intersection2 = this._tempP1.setTo_27zxwg_k$(mainPrev._bx, mainPrev._by);
      var intersection = Companion_getInstance_52().getIntersectXY_4h0tbn_k$(prev, curr, this._tempP3);
      if (!(intersection == null)) {
        var dist = Companion_getInstance_32().distance_6xxxj2_k$(intersection, intersection2);
        if (forcedMiter ? true : dist <= miterLimit) {
          this.add_1vzql2_k$(out, intersection);
        } else {
          this.addEdgePointB_bpqimo_k$(out, prev);
          Unit_getInstance();
          this.addEdgePointA_bpqimo_k$(out, curr);
          Unit_getInstance();
        }
      }} else if (tmp0_subject.equals(LineJoin_BEVEL_getInstance())) {
      this.addEdgePointB_bpqimo_k$(out, prev);
      Unit_getInstance();
      this.addEdgePointA_bpqimo_k$(out, curr);
      Unit_getInstance();
    } else if (tmp0_subject.equals(LineJoin_ROUND_getInstance())) {
      var i = Companion_getInstance_52().getIntersectXY_4h0tbn_k$(prev, curr, this._tempP3);
      if (!(i == null)) {
        var count_0 = clamp(numberToInt(Companion_getInstance_32().distance_w0xdj4_k$(prev._bx, prev._by, curr._ax, curr._ay) * scale_1), 4, 64);
        var inductionVariable = 0;
        if (inductionVariable <= count_0)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.add_1vzql2_k$(out, Companion_getInstance_41().quadCalc_5bkw6y_k$(prev._bx, prev._by, i._x_1, i._y_1, curr._ax, curr._ay, n / count_0, this._tempP2));
          }
           while (!(n === count_0));
      } else {
        this.addEdgePointB_bpqimo_k$(out, prev);
        Unit_getInstance();
        this.addEdgePointA_bpqimo_k$(out, curr);
        Unit_getInstance();
      }
    }};
  StrokeToFill.prototype.doCap_kvti7x_k$ = function (l, r, left, right, epoint, cap, scale_1) {
    var angle = epoint.equals(EdgePoint_A_getInstance()) ? unaryMinus(left._get_angle__gxicn3_k$()) : unaryPlus(left._get_angle__gxicn3_k$());
    var lx = left.getX_ha5a7z_k$(epoint._n);
    var ly = left.getY_ha5a7z_k$(epoint._n);
    var rx = right.getX_ha5a7z_k$(epoint._n);
    var ry = right.getY_ha5a7z_k$(epoint._n);
    var tmp0_subject = cap;
    if (tmp0_subject.equals(LineCap_BUTT_getInstance())) {
      l.add_27zxwg_k$(lx, ly);
      Unit_getInstance();
      r.add_27zxwg_k$(rx, ry);
      Unit_getInstance();
    } else if (tmp0_subject.equals(LineCap_ROUND_getInstance()) ? true : tmp0_subject.equals(LineCap_SQUARE_getInstance())) {
      var ax = numberToInt(_get_cosine_(angle) * this._weight / 2);
      var ay = numberToInt(_get_sine_(angle) * this._weight / 2);
      var lx2 = lx + ax | 0;
      var ly2 = ly + ay | 0;
      var rx2 = rx + ax | 0;
      var ry2 = ry + ay | 0;
      if (cap.equals(LineCap_SQUARE_getInstance())) {
        l.add_27zxwg_k$(lx2, ly2);
        Unit_getInstance();
        r.add_27zxwg_k$(rx2, ry2);
        Unit_getInstance();
      } else {
        var count_0 = clamp(numberToInt(Companion_getInstance_32().distance_w0xdj4_k$(lx, ly, rx, ry) * scale_1), 4, 64);
        l.add_27zxwg_k$(lx, ly);
        Unit_getInstance();
        var inductionVariable = 0;
        if (inductionVariable <= count_0)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var m = epoint.equals(EdgePoint_A_getInstance()) ? n : count_0 - n | 0;
            var ratio = m / count_0;
            this.add_1vzql2_k$(r, Companion_getInstance_41().cubicCalc_pzeyfc_k$(lx, ly, lx2, ly2, rx2, ry2, rx, ry, ratio, this._tempP2));
          }
           while (!(n === count_0));
      }
    }};
  StrokeToFill.prototype.computeStroke_1c9e9i_k$ = function (scale_1, closed) {
    if (this._strokePoints.isEmpty_0_k$())
      return Unit_getInstance();
    var weightD2 = this._weight / 2 | 0;
    this._fillPointsLeft.clear_sv8swh_k$();
    this._fillPointsRight.clear_sv8swh_k$();
    var sp = this._strokePoints;
    var nstrokePoints = sp._get_size__0_k$();
    var inductionVariable = 0;
    if (inductionVariable < nstrokePoints)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var isFirst = n === 0;
        var isLast = n === (nstrokePoints - 1 | 0);
        var isMiddle = !isFirst ? !isLast ? true : closed : false;
        var n1 = isLast ? closed ? 1 : n : n + 1 | 0;
        this._prevEdge.copyFrom_tw2c07_k$(this._currEdge);
        Unit_getInstance();
        this._prevEdgeLeft.copyFrom_tw2c07_k$(this._currEdgeLeft);
        Unit_getInstance();
        this._prevEdgeRight.copyFrom_tw2c07_k$(this._currEdgeRight);
        Unit_getInstance();
        var doJoin = !(this._doJointList.getAt_ha5a7z_k$(n) === 0);
        this._currEdge.setTo_ggpfpb_k$(sp.getX_ha5a7z_k$(n), sp.getY_ha5a7z_k$(n), sp.getX_ha5a7z_k$(n1), sp.getY_ha5a7z_k$(n1), 1);
        Unit_getInstance();
        this.setEdgeDisplaced_csnquz_k$(this._currEdgeLeft, this._currEdge, weightD2, minus_2(this._currEdge._get_angle__gxicn3_k$(), _get_degrees__0(90)));
        Unit_getInstance();
        this.setEdgeDisplaced_csnquz_k$(this._currEdgeRight, this._currEdge, weightD2, plus_5(this._currEdge._get_angle__gxicn3_k$(), _get_degrees__0(90)));
        Unit_getInstance();
        if (isFirst) {
          this.doCap_kvti7x_k$(this._fillPointsLeft, this._fillPointsRight, this._currEdgeLeft, this._currEdgeRight, EdgePoint_A_getInstance(), closed ? LineCap_BUTT_getInstance() : this._startCap, scale_1);
        } else if (isMiddle) {
          var angle = Companion_getInstance_52().angleBetween_om8571_k$(this._prevEdge, this._currEdge);
          var leftAngle = Angle__compareTo_impl(angle, _get_degrees__0(0)) > 0;
          if (doJoin) {
            this.doJoin_91mqsc_k$(this._fillPointsLeft, this._prevEdge, this._currEdge, this._prevEdgeLeft, this._currEdgeLeft, this._joins, this._miterLimit, scale_1, leftAngle);
            this.doJoin_91mqsc_k$(this._fillPointsRight, this._prevEdge, this._currEdge, this._prevEdgeRight, this._currEdgeRight, this._joins, this._miterLimit, scale_1, !leftAngle);
          } else {
            this.addEdgePointA_bpqimo_k$(this._fillPointsLeft, this._currEdgeLeft);
            Unit_getInstance();
            this.addEdgePointA_bpqimo_k$(this._fillPointsRight, this._currEdgeRight);
            Unit_getInstance();
          }
        } else if (isLast) {
          if (closed) {
            this.doCap_kvti7x_k$(this._fillPointsLeft, this._fillPointsRight, this._currEdgeLeft, this._currEdgeRight, EdgePoint_B_getInstance(), LineCap_BUTT_getInstance(), scale_1);
          } else {
            this.doCap_kvti7x_k$(this._fillPointsLeft, this._fillPointsRight, this._prevEdgeLeft, this._prevEdgeRight, EdgePoint_B_getInstance(), this._endCap, scale_1);
          }
        }}
       while (inductionVariable < nstrokePoints);
    var inductionVariable_0 = 0;
    var last_1 = this._fillPointsLeft._get_size__0_k$();
    if (inductionVariable_0 < last_1)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var x = this._fillPointsLeft.getX_ha5a7z_k$(n_0);
        var y = this._fillPointsLeft.getY_ha5a7z_k$(n_0);
        if (n_0 === 0) {
          _get_outFill_(this).moveTo_ul66c3_k$(x * scale_1, y * scale_1);
        } else {
          _get_outFill_(this).lineTo_ul66c3_k$(x * scale_1, y * scale_1);
        }
      }
       while (inductionVariable_0 < last_1);
    var inductionVariable_1 = 0;
    var last_2 = this._fillPointsRight._get_size__0_k$();
    if (inductionVariable_1 < last_2)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var m = (this._fillPointsRight._get_size__0_k$() - n_1 | 0) - 1 | 0;
        _get_outFill_(this).lineTo_ul66c3_k$(this._fillPointsRight.getX_ha5a7z_k$(m) * scale_1, this._fillPointsRight.getY_ha5a7z_k$(m) * scale_1);
      }
       while (inductionVariable_1 < last_2);
    _get_outFill_(this).close_sv8swh_k$();
    _get_outFill_(this)._winding_0 = Winding_NON_ZERO_getInstance();
    this._strokePoints.clear_sv8swh_k$();
    this._doJointList.clear_sv8swh_k$();
  };
  StrokeToFill.prototype.set_xbgesl_k$ = function (outFill, weight, startCap, endCap, joins, miterLimit) {
    this._outFill = outFill;
    this._weight = weight;
    this._startCap = startCap;
    this._endCap = endCap;
    this._joins = joins;
    this._miterLimit = miterLimit * weight;
  };
  StrokeToFill.prototype.strokeFill_c8a6en_k$ = function (stroke, lineWidth, joins, startCap, endCap, miterLimit, outFill) {
    Companion_getInstance_55();
    var scale_1 = 20;
    Companion_getInstance_55();
    var iscale = 1.0 / 20;
    this.set_xbgesl_k$(outFill, numberToInt(lineWidth * scale_1), startCap, endCap, joins, miterLimit);
    var ix_3 = 0.0;
    var iy_4 = 0.0;
    var lx_5 = {_v: 0.0};
    var ly_6 = {_v: 0.0};
    if (false)
      this.computeStroke_1c9e9i_k$(iscale, true);
    var n_1_7 = 0;
    var tmp0_fastForEach_0_8 = stroke._commands;
    var n_1_9 = 0;
    while (n_1_9 < tmp0_fastForEach_0_8._get_size__0_k$()) {
      var tmp0_2_11 = n_1_9;
      n_1_9 = tmp0_2_11 + 1 | 0;
      var tmp1__anonymous__2_3_10 = tmp0_fastForEach_0_8.getAt_ha5a7z_k$(tmp0_2_11);
      var tmp0_subject_3_4_12 = tmp1__anonymous__2_3_10;
      Command_getInstance();
      if (tmp0_subject_3_4_12 === 0) {
        var tmp1_4_5_14 = n_1_7;
        n_1_7 = tmp1_4_5_14 + 1 | 0;
        var tmp2__anonymous__18_13 = stroke._data_11.get_ha5a7z_k$(tmp1_4_5_14);
        var tmp2_5_6_16 = n_1_7;
        n_1_7 = tmp2_5_6_16 + 1 | 0;
        var tmp3__anonymous__18_15 = stroke._data_11.get_ha5a7z_k$(tmp2_5_6_16);
        ix_3 = tmp2__anonymous__18_13;
        iy_4 = tmp3__anonymous__18_15;
        this.computeStroke_1c9e9i_k$(iscale, false);
        this._strokePoints.add_27zxwg_k$(numberToInt(tmp2__anonymous__18_13 * scale_1), numberToInt(tmp3__anonymous__18_15 * scale_1));
        Unit_getInstance();
        var tmp0_also_0_20_18 = this._doJointList.add_majfzk_k$(0);
        lx_5._v = tmp2__anonymous__18_13;
        var tmp1_also_0_19_17 = tmp0_also_0_20_18;
        ly_6._v = tmp3__anonymous__18_15;
      } else {
        Command_getInstance();
        if (tmp0_subject_3_4_12 === 1) {
          var tmp3_6_7_20 = n_1_7;
          n_1_7 = tmp3_6_7_20 + 1 | 0;
          var tmp4__anonymous__21_19 = stroke._data_11.get_ha5a7z_k$(tmp3_6_7_20);
          var tmp4_7_8_22 = n_1_7;
          n_1_7 = tmp4_7_8_22 + 1 | 0;
          var tmp5__anonymous__21_21 = stroke._data_11.get_ha5a7z_k$(tmp4_7_8_22);
          if (false)
            this.computeStroke_1c9e9i_k$(iscale, false);
          this._strokePoints.add_27zxwg_k$(numberToInt(tmp4__anonymous__21_19 * scale_1), numberToInt(tmp5__anonymous__21_21 * scale_1));
          Unit_getInstance();
          var tmp0_also_0_23_24 = this._doJointList.add_majfzk_k$(0);
          lx_5._v = tmp4__anonymous__21_19;
          var tmp1_also_0_22_23 = tmp0_also_0_23_24;
          ly_6._v = tmp5__anonymous__21_21;
          this._doJointList.set_rvwcgf_k$(this._doJointList._get_size__0_k$() - 1 | 0, 1);
        } else {
          Command_getInstance();
          if (tmp0_subject_3_4_12 === 2) {
            var tmp5_8_9_26 = n_1_7;
            n_1_7 = tmp5_8_9_26 + 1 | 0;
            var tmp6__anonymous__24_25 = stroke._data_11.get_ha5a7z_k$(tmp5_8_9_26);
            var tmp6_9_10_28 = n_1_7;
            n_1_7 = tmp6_9_10_28 + 1 | 0;
            var tmp7__anonymous__24_27 = stroke._data_11.get_ha5a7z_k$(tmp6_9_10_28);
            var tmp7_10_11_30 = n_1_7;
            n_1_7 = tmp7_10_11_30 + 1 | 0;
            var tmp8__anonymous__24_29 = stroke._data_11.get_ha5a7z_k$(tmp7_10_11_30);
            var tmp8_11_12_32 = n_1_7;
            n_1_7 = tmp8_11_12_32 + 1 | 0;
            var tmp9__anonymous__24_31 = stroke._data_11.get_ha5a7z_k$(tmp8_11_12_32);
            var sum_25_33 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp6__anonymous__24_25, tmp7__anonymous__24_27) + Companion_getInstance_32().distance_i6u10_k$(tmp6__anonymous__24_25, tmp7__anonymous__24_27, tmp8__anonymous__24_29, tmp9__anonymous__24_31);
            var tmp0_approximateCurve_0_26_34 = numberToInt(sum_25_33);
            var rcurveSteps_1_27_35 = Math.max(tmp0_approximateCurve_0_26_34, 20);
            var dt_2_28_36 = 1.0 / rcurveSteps_1_27_35;
            var lastX_3_29_37 = {_v: 0.0};
            var lastY_4_30_38 = {_v: 0.0};
            var prevX_5_31_39 = {_v: 0.0};
            var prevY_6_32_40 = {_v: 0.0};
            var emittedCount_7_33_41 = {_v: 0};
            var tmp0_quadCalc_0_16_34_42 = Companion_getInstance_41();
            var tmp1_quadCalc_0_17_35_43 = lx_5._v;
            var tmp2_quadCalc_0_18_36_44 = ly_6._v;
            var t1_1_19_37_45 = 1.0;
            var a_2_20_38_46 = t1_1_19_37_45 * t1_1_19_37_45;
            var c_3_21_39_47 = 0.0;
            var b_4_22_40_48 = 2 * t1_1_19_37_45 * 0.0;
            var tmp3__anonymous__5_23_41_49 = a_2_20_38_46 * tmp1_quadCalc_0_17_35_43 + b_4_22_40_48 * tmp6__anonymous__24_25 + c_3_21_39_47 * tmp8__anonymous__24_29;
            var tmp4__anonymous__5_24_42_50 = a_2_20_38_46 * tmp2_quadCalc_0_18_36_44 + b_4_22_40_48 * tmp7__anonymous__24_27 + c_3_21_39_47 * tmp9__anonymous__24_31;
            lastX_3_29_37._v = tmp3__anonymous__5_23_41_49;
            lastY_4_30_38._v = tmp4__anonymous__5_24_42_50;
            var inductionVariable = 1;
            if (inductionVariable < rcurveSteps_1_27_35)
              do {
                var n_10_44_52 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_11_45_53 = n_10_44_52 * dt_2_28_36;
                var tmp0_quadCalc_0_16_46_54 = Companion_getInstance_41();
                var tmp1_quadCalc_0_17_47_55 = lx_5._v;
                var tmp2_quadCalc_0_18_48_56 = ly_6._v;
                var t1_1_19_49_57 = 1 - ratio_11_45_53;
                var a_2_20_50_58 = t1_1_19_49_57 * t1_1_19_49_57;
                var c_3_21_51_59 = ratio_11_45_53 * ratio_11_45_53;
                var b_4_22_52_60 = 2 * t1_1_19_49_57 * ratio_11_45_53;
                var tmp3__anonymous__5_23_53_61 = a_2_20_50_58 * tmp1_quadCalc_0_17_47_55 + b_4_22_52_60 * tmp6__anonymous__24_25 + c_3_21_51_59 * tmp8__anonymous__24_29;
                var tmp4__anonymous__5_24_54_62 = a_2_20_50_58 * tmp2_quadCalc_0_18_48_56 + b_4_22_52_60 * tmp7__anonymous__24_27 + c_3_21_51_59 * tmp9__anonymous__24_31;
                if (false)
                  this.computeStroke_1c9e9i_k$(iscale, false);
                this._strokePoints.add_27zxwg_k$(numberToInt(tmp3__anonymous__5_23_53_61 * scale_1), numberToInt(tmp4__anonymous__5_24_54_62 * scale_1));
                Unit_getInstance();
                this._doJointList.add_majfzk_k$(0);
                var tmp0_14_2_27_55_63 = emittedCount_7_33_41._v;
                emittedCount_7_33_41._v = tmp0_14_2_27_55_63 + 1 | 0;
                Unit_getInstance();
                lastX_3_29_37._v = prevX_5_31_39._v;
                lastY_4_30_38._v = prevY_6_32_40._v;
                prevX_5_31_39._v = tmp3__anonymous__5_23_53_61;
                prevY_6_32_40._v = tmp4__anonymous__5_24_54_62;
              }
               while (inductionVariable < rcurveSteps_1_27_35);
            var tmp1_also_0_56_64 = lx_5._v = tmp8__anonymous__24_29;
            ly_6._v = tmp9__anonymous__24_31;
            this._doJointList.set_rvwcgf_k$(this._doJointList._get_size__0_k$() - 1 | 0, 1);
          } else {
            Command_getInstance();
            if (tmp0_subject_3_4_12 === 3) {
              var tmp9_12_13_66 = n_1_7;
              n_1_7 = tmp9_12_13_66 + 1 | 0;
              var tmp10__anonymous__57_65 = stroke._data_11.get_ha5a7z_k$(tmp9_12_13_66);
              var tmp10_13_14_68 = n_1_7;
              n_1_7 = tmp10_13_14_68 + 1 | 0;
              var tmp11__anonymous__57_67 = stroke._data_11.get_ha5a7z_k$(tmp10_13_14_68);
              var tmp11_14_15_70 = n_1_7;
              n_1_7 = tmp11_14_15_70 + 1 | 0;
              var tmp12__anonymous__57_69 = stroke._data_11.get_ha5a7z_k$(tmp11_14_15_70);
              var tmp12_15_16_72 = n_1_7;
              n_1_7 = tmp12_15_16_72 + 1 | 0;
              var tmp13__anonymous__57_71 = stroke._data_11.get_ha5a7z_k$(tmp12_15_16_72);
              var tmp13_16_17_74 = n_1_7;
              n_1_7 = tmp13_16_17_74 + 1 | 0;
              var tmp14__anonymous__57_73 = stroke._data_11.get_ha5a7z_k$(tmp13_16_17_74);
              var tmp14_17_18_76 = n_1_7;
              n_1_7 = tmp14_17_18_76 + 1 | 0;
              var tmp15__anonymous__57_75 = stroke._data_11.get_ha5a7z_k$(tmp14_17_18_76);
              var sum_58_77 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp10__anonymous__57_65, tmp11__anonymous__57_67) + Companion_getInstance_32().distance_i6u10_k$(tmp10__anonymous__57_65, tmp11__anonymous__57_67, tmp12__anonymous__57_69, tmp13__anonymous__57_71) + Companion_getInstance_32().distance_i6u10_k$(tmp12__anonymous__57_69, tmp13__anonymous__57_71, tmp14__anonymous__57_73, tmp15__anonymous__57_75);
              var tmp0_approximateCurve_0_59_78 = numberToInt(sum_58_77);
              var rcurveSteps_1_60_79 = Math.max(tmp0_approximateCurve_0_59_78, 20);
              var dt_2_61_80 = 1.0 / rcurveSteps_1_60_79;
              var lastX_3_62_81 = {_v: 0.0};
              var lastY_4_63_82 = {_v: 0.0};
              var prevX_5_64_83 = {_v: 0.0};
              var prevY_6_65_84 = {_v: 0.0};
              var emittedCount_7_66_85 = {_v: 0};
              var tmp0_cubicCalc_0_16_67_86 = Companion_getInstance_41();
              var tmp1_cubicCalc_0_17_68_87 = lx_5._v;
              var tmp2_cubicCalc_0_18_69_88 = ly_6._v;
              var cx_1_19_70_89 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_68_87);
              var bx_2_20_71_90 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_70_89;
              var ax_3_21_72_91 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_68_87 - cx_1_19_70_89 - bx_2_20_71_90;
              var cy_4_22_73_92 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_69_88);
              var by_5_23_74_93 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_73_92;
              var ay_6_24_75_94 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_69_88 - cy_4_22_73_92 - by_5_23_74_93;
              var tSquared_7_25_76_95 = 0.0;
              var tCubed_8_26_77_96 = tSquared_7_25_76_95 * 0.0;
              var tmp3__anonymous__9_27_78_97 = ax_3_21_72_91 * tCubed_8_26_77_96 + bx_2_20_71_90 * tSquared_7_25_76_95 + cx_1_19_70_89 * 0.0 + tmp1_cubicCalc_0_17_68_87;
              var tmp4__anonymous__9_28_79_98 = ay_6_24_75_94 * tCubed_8_26_77_96 + by_5_23_74_93 * tSquared_7_25_76_95 + cy_4_22_73_92 * 0.0 + tmp2_cubicCalc_0_18_69_88;
              lastX_3_62_81._v = tmp3__anonymous__9_27_78_97;
              lastY_4_63_82._v = tmp4__anonymous__9_28_79_98;
              var inductionVariable_0 = 1;
              if (inductionVariable_0 < rcurveSteps_1_60_79)
                do {
                  var n_10_81_100 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var ratio_11_82_101 = n_10_81_100 * dt_2_61_80;
                  var tmp0_cubicCalc_0_16_83_102 = Companion_getInstance_41();
                  var tmp1_cubicCalc_0_17_84_103 = lx_5._v;
                  var tmp2_cubicCalc_0_18_85_104 = ly_6._v;
                  var cx_1_19_86_105 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_84_103);
                  var bx_2_20_87_106 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_86_105;
                  var ax_3_21_88_107 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_84_103 - cx_1_19_86_105 - bx_2_20_87_106;
                  var cy_4_22_89_108 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_85_104);
                  var by_5_23_90_109 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_89_108;
                  var ay_6_24_91_110 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_85_104 - cy_4_22_89_108 - by_5_23_90_109;
                  var tSquared_7_25_92_111 = ratio_11_82_101 * ratio_11_82_101;
                  var tCubed_8_26_93_112 = tSquared_7_25_92_111 * ratio_11_82_101;
                  var tmp3__anonymous__9_27_94_113 = ax_3_21_88_107 * tCubed_8_26_93_112 + bx_2_20_87_106 * tSquared_7_25_92_111 + cx_1_19_86_105 * ratio_11_82_101 + tmp1_cubicCalc_0_17_84_103;
                  var tmp4__anonymous__9_28_95_114 = ay_6_24_91_110 * tCubed_8_26_93_112 + by_5_23_90_109 * tSquared_7_25_92_111 + cy_4_22_89_108 * ratio_11_82_101 + tmp2_cubicCalc_0_18_85_104;
                  if (false)
                    this.computeStroke_1c9e9i_k$(iscale, false);
                  this._strokePoints.add_27zxwg_k$(numberToInt(tmp3__anonymous__9_27_94_113 * scale_1), numberToInt(tmp4__anonymous__9_28_95_114 * scale_1));
                  Unit_getInstance();
                  this._doJointList.add_majfzk_k$(0);
                  var tmp0_14_2_31_96_115 = emittedCount_7_66_85._v;
                  emittedCount_7_66_85._v = tmp0_14_2_31_96_115 + 1 | 0;
                  Unit_getInstance();
                  lastX_3_62_81._v = prevX_5_64_83._v;
                  lastY_4_63_82._v = prevY_6_65_84._v;
                  prevX_5_64_83._v = tmp3__anonymous__9_27_94_113;
                  prevY_6_65_84._v = tmp4__anonymous__9_28_95_114;
                }
                 while (inductionVariable_0 < rcurveSteps_1_60_79);
              var tmp1_also_0_97_116 = lx_5._v = tmp14__anonymous__57_73;
              ly_6._v = tmp15__anonymous__57_75;
              this._doJointList.set_rvwcgf_k$(this._doJointList._get_size__0_k$() - 1 | 0, 1);
            } else {
              Command_getInstance();
              if (tmp0_subject_3_4_12 === 4) {
                var tmp0__anonymous__118 = ix_3;
                var tmp1__anonymous__118 = iy_4;
                if (false)
                  this.computeStroke_1c9e9i_k$(iscale, false);
                this._strokePoints.add_27zxwg_k$(numberToInt(tmp0__anonymous__118 * scale_1), numberToInt(tmp1__anonymous__118 * scale_1));
                Unit_getInstance();
                this._doJointList.add_majfzk_k$(0);
                this._doJointList.set_rvwcgf_k$(this._doJointList._get_size__0_k$() - 1 | 0, 1);
                this.computeStroke_1c9e9i_k$(iscale, true);
              } else {
              }
            }
          }
        }
      }
    }
    if (false)
      this.computeStroke_1c9e9i_k$(iscale, true);
    this.computeStroke_1c9e9i_k$(iscale, false);
  };
  StrokeToFill.$metadata$ = {
    simpleName: 'StrokeToFill',
    kind: 'class',
    interfaces: []
  };
  function strokeToFill(_this_, lineWidth, joins, startCap, endCap, miterLimit, temp_0, outFill) {
    temp_0.strokeFill_c8a6en_k$(_this_, lineWidth, joins, startCap, endCap, miterLimit, outFill);
    return outFill;
  }
  function moveTo(_this_, x, y) {
    return _this_.moveTo_ul66c3_k$(x, y);
  }
  function lineTo(_this_, x, y) {
    return _this_.lineTo_ul66c3_k$(x, y);
  }
  function quadTo(_this_, controlX, controlY, anchorX, anchorY) {
    return _this_.quadTo_lf7oid_k$(controlX, controlY, anchorX, anchorY);
  }
  function VectorBuilder() {
  }
  VectorBuilder.prototype.quadTo_lf7oid_k$ = function (cx, cy, ax, ay) {
    var x1 = this._get_lastX__0_k$();
    var y1 = this._get_lastY__0_k$();
    var x2 = ax;
    var y2 = ay;
    var tt = 0.6666666666666666;
    var cx1 = x1 + tt * (cx - x1);
    var cy1 = y1 + tt * (cy - y1);
    var cx2 = x2 + tt * (cx - x2);
    var cy2 = y2 + tt * (cy - y2);
    return this.cubicTo_iylh49_k$(cx1, cy1, cx2, cy2, x2, y2);
  };
  VectorBuilder.$metadata$ = {
    simpleName: 'VectorBuilder',
    kind: 'interface',
    interfaces: []
  };
  function roundRect(_this_, x, y, w, h, rx, ry) {
    if (rx === 0.0 ? ry === 0.0 : false) {
      rect(_this_, x, y, w, h);
    } else {
      var r = w < 2 * rx ? w / 2.0 : h < 2 * rx ? h / 2.0 : rx;
      _this_.moveTo_ul66c3_k$(x + r, y);
      arcTo(_this_, x + w, y, x + w, y + h, r);
      arcTo(_this_, x + w, y + h, x, y + h, r);
      arcTo(_this_, x, y + h, x, y, r);
      arcTo(_this_, x, y, x + w, y, r);
      _this_.close_sv8swh_k$();
    }
  }
  function rect(_this_, x, y, width, height) {
    _this_.moveTo_ul66c3_k$(x, y);
    _this_.lineTo_ul66c3_k$(x + width, y);
    _this_.lineTo_ul66c3_k$(x + width, y + height);
    _this_.lineTo_ul66c3_k$(x, y + height);
    _this_.close_sv8swh_k$();
  }
  function transformed(_this_, m, block) {
    return block(transformed_0(_this_, m));
  }
  function isEmpty(_this_) {
    return _this_._get_totalPoints__0_k$() === 0;
  }
  function ellipse(_this_, x, y, rw, rh) {
    var k = 0.5522848;
    var ox = rw / 2 * k;
    var oy = rh / 2 * k;
    var xe = x + rw;
    var ye = y + rh;
    var xm = x + rw / 2;
    var ym = y + rh / 2;
    _this_.moveTo_ul66c3_k$(x, ym);
    _this_.cubicTo_iylh49_k$(x, ym - oy, xm - ox, y, xm, y);
    _this_.cubicTo_iylh49_k$(xm + ox, y, xe, ym - oy, xe, ym);
    _this_.cubicTo_iylh49_k$(xe, ym + oy, xm + ox, ye, xm, ye);
    _this_.cubicTo_iylh49_k$(xm - ox, ye, x, ym + oy, x, ym);
    _this_.close_sv8swh_k$();
  }
  function circle(_this_, x, y, radius) {
    return arc(_this_, x, y, radius, _get_degrees__0(0), _get_degrees__0(360));
  }
  function roundRect_0(_this_, x, y, w, h, rx, ry) {
    return roundRect(_this_, x, y, w, h, rx, ry);
  }
  function line(_this_, x0, y0, x1, y1) {
    return line_0(_this_, x0, y0, x1, y1);
  }
  function rect_0(_this_, rect_3) {
    return rect(_this_, rect_3._get_x__0_k$(), rect_3._get_y__0_k$(), rect_3._get_width__0_k$(), rect_3._get_height__0_k$());
  }
  function moveTo_0(_this_, p) {
    return _this_.moveTo_ul66c3_k$(p._get_x__0_k$(), p._get_y__0_k$());
  }
  function lineTo_0(_this_, p) {
    return _this_.lineTo_ul66c3_k$(p._get_x__0_k$(), p._get_y__0_k$());
  }
  function circle_0(_this_, point, radius) {
    return arc(_this_, point._x_1, point._y_1, radius, _get_degrees__0(0), _get_degrees__0(360));
  }
  function line_0(_this_, x0, y0, x1, y1) {
    var tmp0_also_0 = _this_.moveTo_ul66c3_k$(x0, y0);
    _this_.lineTo_ul66c3_k$(x1, y1);
    return tmp0_also_0;
  }
  function rect_1(_this_, x, y, width, height) {
    return rect(_this_, x, y, width, height);
  }
  function rect_2(_this_, rect_3) {
    return rect_1(_this_, rect_3._get_x__0_k$(), rect_3._get_y__0_k$(), rect_3._get_width__0_k$(), rect_3._get_height__0_k$());
  }
  function isNotEmpty(_this_) {
    return !(_this_._get_totalPoints__0_k$() === 0);
  }
  function polygon(_this_, path_0, close) {
    return polygon_0(_this_, Companion_getInstance_33().invoke_99nbow_k$(path_0), close);
  }
  function polygon$default(_this_, path_0, close, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      close = true;
    return polygon(_this_, path_0, close);
  }
  function arcTo(_this_, ax, ay, cx, cy, r) {
    if (isEmpty(_this_))
      _this_.moveTo_ul66c3_k$(ax, ay);
    var bx = _this_._get_lastX__0_k$();
    var by = _this_._get_lastY__0_k$();
    var b = Companion_getInstance_31().invoke_ngl742_k$(bx, by);
    var a = Companion_getInstance_31().invoke_ngl742_k$(ax, ay);
    var c = Companion_getInstance_31().invoke_ngl742_k$(cx, cy);
    var AB = minus_3(b, a);
    var AC = minus_3(c, a);
    var angle = _Angle___get_radians__impl_(Companion_getInstance_32().angleArc_ghsg5b_k$(AB, AC)) * 0.5;
    var tmp0_sin_0 = 1.5707963267948966 - angle;
    var tmp = r * Math.sin(tmp0_sin_0);
    var x = tmp / Math.sin(angle);
    var A = plus_6(a, times_2(_get_unit_(AB), x));
    var B = plus_6(a, times_2(_get_unit_(AC), x));
    _this_.lineTo_ul66c3_k$(A._get_x__0_k$(), A._get_y__0_k$());
    _this_.quadTo_lf7oid_k$(a._get_x__0_k$(), a._get_y__0_k$(), B._get_x__0_k$(), B._get_y__0_k$());
  }
  function transformed_0(_this_, m) {
    var im = m.inverted$default_3vhimr_k$(null, 1, null);
    var parent = _this_;
    return new _no_name_provided__75(parent, im, m);
  }
  function arc(_this_, x, y, r, start, end) {
    var EPSILON = 1.0E-5;
    var PI_TWO = 6.283185307179586;
    var PI_OVER_TWO = 1.5707963267948966;
    var startAngle = _Angle___get_radians__impl_(start) % PI_TWO;
    var endAngle = _Angle___get_radians__impl_(end) % PI_TWO;
    var tmp0_abs_0 = endAngle - startAngle;
    var tmp1_min_0 = Math.abs(tmp0_abs_0);
    var remainingAngle = Math.min(PI_TWO, tmp1_min_0);
    var tmp;
    var tmp2__get_absoluteValue__0 = remainingAngle;
    if (Math.abs(tmp2__get_absoluteValue__0) < EPSILON) {
      tmp = !equals_1(new Angle(start), new Angle(end));
    } else {
      {
        tmp = false;
      }
    }
    if (tmp)
      remainingAngle = PI_TWO;
    else {
    }
    var sgn = startAngle < endAngle ? 1 : -1;
    var a1 = startAngle;
    var p1 = Companion_getInstance_32().invoke_0_k$();
    var p2 = Companion_getInstance_32().invoke_0_k$();
    var p3 = Companion_getInstance_32().invoke_0_k$();
    var p4 = Companion_getInstance_32().invoke_0_k$();
    var index_0 = 0;
    while (remainingAngle > EPSILON) {
      var tmp_0 = a1;
      var tmp3_min_0 = remainingAngle;
      var a2 = tmp_0 + sgn * Math.min(tmp3_min_0, PI_OVER_TWO);
      var k = 0.5522847498;
      var a = (a2 - a1) / 2.0;
      var x4 = r * Math.cos(a);
      var y4 = r * Math.sin(a);
      var x1 = x4;
      var y1 = -y4;
      var f = k * Math.tan(a);
      var x2 = x1 + f * y4;
      var y2 = y1 + f * x4;
      var x3 = x2;
      var y3 = -y2;
      var ar = a + a1;
      var cos_ar = Math.cos(ar);
      var sin_ar = Math.sin(ar);
      var tmp4_cos_0 = a1;
      var tmp_1 = x + r * Math.cos(tmp4_cos_0);
      var tmp5_sin_0 = a1;
      p1.setTo_ngl742_k$(tmp_1, y + r * Math.sin(tmp5_sin_0));
      Unit_getInstance();
      p2.setTo_ngl742_k$(x + x2 * cos_ar - y2 * sin_ar, y + x2 * sin_ar + y2 * cos_ar);
      Unit_getInstance();
      p3.setTo_ngl742_k$(x + x3 * cos_ar - y3 * sin_ar, y + x3 * sin_ar + y3 * cos_ar);
      Unit_getInstance();
      var tmp_2 = x + r * Math.cos(a2);
      p4.setTo_ngl742_k$(tmp_2, y + r * Math.sin(a2));
      Unit_getInstance();
      if (index_0 === 0)
        _this_.moveTo_ul66c3_k$(p1._x_1, p1._y_1);
      _this_.cubicTo_iylh49_k$(p2._x_1, p2._y_1, p3._x_1, p3._y_1, p4._x_1, p4._y_1);
      var tmp0 = index_0;
      index_0 = tmp0 + 1 | 0;
      Unit_getInstance();
      var tmp_3 = remainingAngle;
      var tmp6_abs_0 = a2 - a1;
      remainingAngle = tmp_3 - Math.abs(tmp6_abs_0);
      a1 = a2;
    }
    if (startAngle === endAngle ? !(index_0 === 0) : false) {
      _this_.close_sv8swh_k$();
    }}
  function polygon_0(_this_, path_0, close) {
    _this_.moveTo_ul66c3_k$(path_0.getX_ha5a7z_k$(0), path_0.getY_ha5a7z_k$(0));
    var inductionVariable = 1;
    var last_1 = path_0._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this_.lineTo_ul66c3_k$(path_0.getX_ha5a7z_k$(i), path_0.getY_ha5a7z_k$(i));
      }
       while (inductionVariable < last_1);
    if (close)
      _this_.close_sv8swh_k$();
  }
  function polygon$default_0(_this_, path_0, close, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      close = true;
    return polygon_0(_this_, path_0, close);
  }
  function rMoveTo(_this_, ax, ay, relative) {
    return relative ? rMoveTo_0(_this_, ax, ay) : _this_.moveTo_ul66c3_k$(ax, ay);
  }
  function rLineTo(_this_, ax, ay, relative) {
    return relative ? rLineTo_0(_this_, ax, ay) : _this_.lineTo_ul66c3_k$(ax, ay);
  }
  function rLineToH(_this_, ax, relative) {
    return relative ? rLineToH_0(_this_, ax) : lineToH(_this_, ax);
  }
  function rLineToV(_this_, ay, relative) {
    return relative ? rLineToV_0(_this_, ay) : lineToV(_this_, ay);
  }
  function rMoveTo_0(_this_, x, y) {
    return _this_.moveTo_ul66c3_k$(_this_._get_lastX__0_k$() + x, _this_._get_lastY__0_k$() + y);
  }
  function rLineTo_0(_this_, x, y) {
    return _this_.lineTo_ul66c3_k$(_this_._get_lastX__0_k$() + x, _this_._get_lastY__0_k$() + y);
  }
  function rLineToH_0(_this_, x) {
    return rLineTo_0(_this_, x, 0.0);
  }
  function lineToH(_this_, x) {
    return _this_.lineTo_ul66c3_k$(x, _this_._get_lastY__0_k$());
  }
  function rLineToV_0(_this_, y) {
    return rLineTo_0(_this_, 0.0, y);
  }
  function lineToV(_this_, y) {
    return _this_.lineTo_ul66c3_k$(_this_._get_lastX__0_k$(), y);
  }
  function _no_name_provided__75($parent, $im, $m) {
    this._$parent = $parent;
    this._$im = $im;
    this._$m = $m;
    this._totalPoints_1 = this._$parent._get_totalPoints__0_k$();
  }
  _no_name_provided__75.prototype._get_lastX__0_k$ = function () {
    return this._$im.transformX_ngl742_k$(this._$parent._get_lastX__0_k$(), this._$parent._get_lastY__0_k$());
  };
  _no_name_provided__75.prototype._get_lastY__0_k$ = function () {
    return this._$im.transformY_ngl742_k$(this._$parent._get_lastX__0_k$(), this._$parent._get_lastY__0_k$());
  };
  _no_name_provided__75.prototype._get_totalPoints__0_k$ = function () {
    return this._totalPoints_1;
  };
  _no_name_provided__75.prototype.tX_ngl742_k$ = function (x, y) {
    return this._$m.transformX_ngl742_k$(x, y);
  };
  _no_name_provided__75.prototype.tY_ngl742_k$ = function (x, y) {
    return this._$m.transformY_ngl742_k$(x, y);
  };
  _no_name_provided__75.prototype.close_sv8swh_k$ = function () {
    return this._$parent.close_sv8swh_k$();
  };
  _no_name_provided__75.prototype.lineTo_ul66c3_k$ = function (x, y) {
    return this._$parent.lineTo_ul66c3_k$(this.tX_ngl742_k$(x, y), this.tY_ngl742_k$(x, y));
  };
  _no_name_provided__75.prototype.moveTo_ul66c3_k$ = function (x, y) {
    return this._$parent.lineTo_ul66c3_k$(this.tX_ngl742_k$(x, y), this.tY_ngl742_k$(x, y));
  };
  _no_name_provided__75.prototype.quadTo_lf7oid_k$ = function (cx, cy, ax, ay) {
    return this._$parent.quadTo_lf7oid_k$(this.tX_ngl742_k$(cx, cy), this.tY_ngl742_k$(cx, cy), this.tX_ngl742_k$(ax, ay), this.tY_ngl742_k$(ax, ay));
  };
  _no_name_provided__75.prototype.cubicTo_iylh49_k$ = function (cx1, cy1, cx2, cy2, ax, ay) {
    return this._$parent.cubicTo_iylh49_k$(this.tX_ngl742_k$(cx1, cy1), this.tY_ngl742_k$(cx1, cy1), this.tX_ngl742_k$(cx2, cy2), this.tY_ngl742_k$(cx2, cy2), this.tX_ngl742_k$(ax, ay), this.tY_ngl742_k$(ax, ay));
  };
  _no_name_provided__75.$metadata$ = {
    kind: 'class',
    interfaces: [VectorBuilder]
  };
  var tempMatrix;
  var identityMatrix;
  function VectorPath_init_$Init$(commands, data, winding, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      commands = IntArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 2) === 0)) {
      data = DoubleArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 4) === 0))
      winding = Winding_EVEN_ODD_getInstance();
    VectorPath.call($this, commands, data, winding);
    return $this;
  }
  function VectorPath_init_$Create$(commands, data, winding, $mask0, $marker) {
    return VectorPath_init_$Init$(commands, data, winding, $mask0, $marker, Object.create(VectorPath.prototype));
  }
  function Companion_57() {
    Companion_instance_56 = this;
    var tmp = this;
    tmp._identityMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  }
  Companion_57.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_56;
  function Companion_getInstance_56() {
    if (Companion_instance_56 == null)
      new Companion_57();
    return Companion_instance_56;
  }
  function ensureMoveTo($this, x, y) {
    if (isEmpty($this))
      $this.moveTo_ul66c3_k$(x, y);
  }
  function Command() {
    Command_instance = this;
    this._MOVE_TO = 0;
    this._LINE_TO = 1;
    this._QUAD_TO = 2;
    this._CUBIC_TO = 3;
    this._CLOSE = 4;
  }
  Command.$metadata$ = {
    simpleName: 'Command',
    kind: 'object',
    interfaces: []
  };
  var Command_instance;
  function Command_getInstance() {
    if (Command_instance == null)
      new Command();
    return Command_instance;
  }
  function VectorPath(commands, data, winding) {
    Companion_getInstance_56();
    this._commands = commands;
    this._data_11 = data;
    this._winding_0 = winding;
    this._version_0 = 0;
    this._lastX_0 = 0.0;
    this._lastY_0 = 0.0;
    this._bezierTemp = new Temp();
    this.__scanline = null;
  }
  VectorPath.prototype._get_commands__0_k$ = function () {
    return this._commands;
  };
  VectorPath.prototype._get_data__0_k$ = function () {
    return this._data_11;
  };
  VectorPath.prototype._set_winding__ohnhtf_k$ = function (_set___) {
    this._winding_0 = _set___;
  };
  VectorPath.prototype._get_winding__0_k$ = function () {
    return this._winding_0;
  };
  VectorPath.prototype.clear_sv8swh_k$ = function () {
    this._commands.clear_sv8swh_k$();
    this._data_11.clear_sv8swh_k$();
    this.lastXY_ul66c3_k$(0.0, 0.0);
    this._version_0 = 0;
    this._get_scanline__0_k$()._version = this._version_0 - 1 | 0;
  };
  VectorPath.prototype._set_lastX__okcceq_k$ = function (_set___) {
    this._lastX_0 = _set___;
  };
  VectorPath.prototype._get_lastX__0_k$ = function () {
    return this._lastX_0;
  };
  VectorPath.prototype._set_lastY__okcceq_k$ = function (_set___) {
    this._lastY_0 = _set___;
  };
  VectorPath.prototype._get_lastY__0_k$ = function () {
    return this._lastY_0;
  };
  VectorPath.prototype.lastXY_ul66c3_k$ = function (x, y) {
    this._set_lastX__okcceq_k$(x);
    this._set_lastY__okcceq_k$(y);
  };
  VectorPath.prototype.moveTo_ul66c3_k$ = function (x, y) {
    Command_getInstance();
    this._commands.add_majfzk_k$(0);
    this._data_11.add_ul66c3_k$(x, y);
    this.lastXY_ul66c3_k$(x, y);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_0;
    tmp0_this._version_0 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.lineTo_ul66c3_k$ = function (x, y) {
    ensureMoveTo(this, x, y);
    Command_getInstance();
    this._commands.add_majfzk_k$(1);
    this._data_11.add_ul66c3_k$(x, y);
    this.lastXY_ul66c3_k$(x, y);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_0;
    tmp0_this._version_0 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.quadTo_lf7oid_k$ = function (cx, cy, ax, ay) {
    ensureMoveTo(this, cx, cy);
    Command_getInstance();
    this._commands.add_majfzk_k$(2);
    this._data_11.add_lf7oid_k$(cx, cy, ax, ay);
    this.lastXY_ul66c3_k$(ax, ay);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_0;
    tmp0_this._version_0 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.cubicTo_iylh49_k$ = function (cx1, cy1, cx2, cy2, ax, ay) {
    ensureMoveTo(this, cx1, cy1);
    Command_getInstance();
    this._commands.add_majfzk_k$(3);
    this._data_11.add_iylh49_k$(cx1, cy1, cx2, cy2, ax, ay);
    this.lastXY_ul66c3_k$(ax, ay);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_0;
    tmp0_this._version_0 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.close_sv8swh_k$ = function () {
    Command_getInstance();
    this._commands.add_majfzk_k$(4);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_0;
    tmp0_this._version_0 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype._get_totalPoints__0_k$ = function () {
    return this._data_11._get_size__0_k$() / 2 | 0;
  };
  VectorPath.prototype.getBounds_3x1wuh_k$ = function (out, bb) {
    bb.reset_sv8swh_k$();
    add_0(bb, this);
    return bb.getBounds_uebyw0_k$(out);
  };
  VectorPath.prototype.getBounds$default_lrzlif_k$ = function (out, bb, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      out = Companion_getInstance_35().invoke_0_k$();
    if (!(($mask0 & 2) === 0))
      bb = new BoundsBuilder();
    return this.getBounds_3x1wuh_k$(out, bb);
  };
  VectorPath.prototype.getPoints_0_k$ = function () {
    return this.getPointList_0_k$().toList_0_k$();
  };
  VectorPath.prototype.getPointList_0_k$ = function () {
    var points = PointArrayList_init_$Create$(0, 1, null);
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = this._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__0_k$()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_ha5a7z_k$(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      Command_getInstance();
      if (tmp0_subject_4_6 === 0) {
        var tmp1_5_7 = n_1;
        n_1 = tmp1_5_7 + 1 | 0;
        var tmp0__anonymous__21 = this._data_11.get_ha5a7z_k$(tmp1_5_7);
        var tmp2_6_8 = n_1;
        n_1 = tmp2_6_8 + 1 | 0;
        var tmp1__anonymous__21 = this._data_11.get_ha5a7z_k$(tmp2_6_8);
        points.add_ngl742_k$(tmp0__anonymous__21, tmp1__anonymous__21);
        Unit_getInstance();
      } else {
        Command_getInstance();
        if (tmp0_subject_4_6 === 1) {
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__22 = this._data_11.get_ha5a7z_k$(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__22 = this._data_11.get_ha5a7z_k$(tmp4_8_10);
          points.add_ngl742_k$(tmp2__anonymous__22, tmp3__anonymous__22);
          Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_4_6 === 2) {
            var tmp5_9_11 = n_1;
            n_1 = tmp5_9_11 + 1 | 0;
            var tmp4__anonymous__23 = this._data_11.get_ha5a7z_k$(tmp5_9_11);
            var tmp6_10_12 = n_1;
            n_1 = tmp6_10_12 + 1 | 0;
            var tmp5__anonymous__23 = this._data_11.get_ha5a7z_k$(tmp6_10_12);
            var tmp7_11_13 = n_1;
            n_1 = tmp7_11_13 + 1 | 0;
            var tmp6__anonymous__23 = this._data_11.get_ha5a7z_k$(tmp7_11_13);
            var tmp8_12_14 = n_1;
            n_1 = tmp8_12_14 + 1 | 0;
            var tmp7__anonymous__23 = this._data_11.get_ha5a7z_k$(tmp8_12_14);
            points.add_ngl742_k$(tmp6__anonymous__23, tmp7__anonymous__23);
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_4_6 === 3) {
              var tmp9_13_15 = n_1;
              n_1 = tmp9_13_15 + 1 | 0;
              var tmp8__anonymous__24 = this._data_11.get_ha5a7z_k$(tmp9_13_15);
              var tmp10_14_16 = n_1;
              n_1 = tmp10_14_16 + 1 | 0;
              var tmp9__anonymous__24 = this._data_11.get_ha5a7z_k$(tmp10_14_16);
              var tmp11_15_17 = n_1;
              n_1 = tmp11_15_17 + 1 | 0;
              var tmp10__anonymous__24 = this._data_11.get_ha5a7z_k$(tmp11_15_17);
              var tmp12_16_18 = n_1;
              n_1 = tmp12_16_18 + 1 | 0;
              var tmp11__anonymous__24 = this._data_11.get_ha5a7z_k$(tmp12_16_18);
              var tmp13_17_19 = n_1;
              n_1 = tmp13_17_19 + 1 | 0;
              var tmp12__anonymous__24 = this._data_11.get_ha5a7z_k$(tmp13_17_19);
              var tmp14_18_20 = n_1;
              n_1 = tmp14_18_20 + 1 | 0;
              var tmp13__anonymous__24 = this._data_11.get_ha5a7z_k$(tmp14_18_20);
              points.add_ngl742_k$(tmp12__anonymous__24, tmp13__anonymous__24);
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_4_6 === 4) {
                Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    return points;
  };
  VectorPath.prototype.containsPoint_ngl742_k$ = function (x, y) {
    return this.containsPoint_vxd5eo_k$(x, y, this._winding_0);
  };
  VectorPath.prototype._get_scanline__0_k$ = function () {
    if (this.__scanline == null)
      this.__scanline = new PolygonScanline();
    var scanline = ensureNotNull(this.__scanline);
    if (!(scanline._version === this._version_0)) {
      scanline.reset_sv8swh_k$();
      scanline.add_qvfozx_k$(this);
      scanline._version = this._version_0;
    }return ensureNotNull(this.__scanline);
  };
  VectorPath.prototype.containsPoint_vxd5eo_k$ = function (x, y, winding) {
    return this._get_scanline__0_k$().containsPoint_vxd5eo_k$(x, y, winding);
  };
  VectorPath.prototype.write_lypuw5_k$ = function (path_0, transform) {
    var tmp0_this = this;
    tmp0_this._commands.plusAssign_i58uhq_k$(path_0._commands);
    if (transform.isIdentity_0_k$()) {
      var tmp1_this = this;
      tmp1_this._data_11.plusAssign_pd4ws6_k$(path_0._data_11);
      this.lastXY_ul66c3_k$(path_0._get_lastX__0_k$(), path_0._get_lastY__0_k$());
    } else {
      var progression = step(until(0, path_0._data_11._get_size__0_k$()), 2);
      var inductionVariable = progression._first_0;
      var last_1 = progression._last;
      var step_0 = progression._step_2;
      if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var x = path_0._data_11.get_ha5a7z_k$(n + 0 | 0);
          var y = path_0._data_11.get_ha5a7z_k$(n + 1 | 0);
          var tmp3_this = this;
          tmp3_this._data_11.plusAssign_okcceq_k$(transform.transformX_ngl742_k$(x, y));
          var tmp4_this = this;
          tmp4_this._data_11.plusAssign_okcceq_k$(transform.transformY_ngl742_k$(x, y));
        }
         while (!(n === last_1));
      this.lastXY_ul66c3_k$(transform.transformX_ngl742_k$(path_0._get_lastX__0_k$(), path_0._get_lastY__0_k$()), transform.transformY_ngl742_k$(path_0._get_lastX__0_k$(), path_0._get_lastY__0_k$()));
    }
    var tmp5_this = this;
    var tmp6 = tmp5_this._version_0;
    tmp5_this._version_0 = tmp6 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.write$default_jet5j6_k$ = function (path_0, transform, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      transform = Companion_getInstance_56()._identityMatrix;
    return this.write_lypuw5_k$(path_0, transform);
  };
  VectorPath.prototype.toSvgString_0_k$ = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var n_1_3 = 0;
    var tmp0_fastForEach_0_2_4 = this._commands;
    var n_1_3_5 = 0;
    while (n_1_3_5 < tmp0_fastForEach_0_2_4._get_size__0_k$()) {
      var tmp0_2_5_7 = n_1_3_5;
      n_1_3_5 = tmp0_2_5_7 + 1 | 0;
      var tmp1__anonymous__3_4_6 = tmp0_fastForEach_0_2_4.getAt_ha5a7z_k$(tmp0_2_5_7);
      var tmp0_subject_4_6_8 = tmp1__anonymous__3_4_6;
      Command_getInstance();
      if (tmp0_subject_4_6_8 === 0) {
        var tmp1_5_7_10 = n_1_3;
        n_1_3 = tmp1_5_7_10 + 1 | 0;
        var tmp0__anonymous__21_9 = this._data_11.get_ha5a7z_k$(tmp1_5_7_10);
        var tmp2_6_8_12 = n_1_3;
        n_1_3 = tmp2_6_8_12 + 1 | 0;
        var tmp1__anonymous__21_11 = this._data_11.get_ha5a7z_k$(tmp2_6_8_12);
        tmp0_apply_0_1.append_uch40_k$('' + 'M' + _get_niceStr_(tmp0__anonymous__21_9) + ',' + _get_niceStr_(tmp1__anonymous__21_11) + ' ');
        Unit_getInstance();
      } else {
        Command_getInstance();
        if (tmp0_subject_4_6_8 === 1) {
          var tmp3_7_9_14 = n_1_3;
          n_1_3 = tmp3_7_9_14 + 1 | 0;
          var tmp2__anonymous__22_13 = this._data_11.get_ha5a7z_k$(tmp3_7_9_14);
          var tmp4_8_10_16 = n_1_3;
          n_1_3 = tmp4_8_10_16 + 1 | 0;
          var tmp3__anonymous__22_15 = this._data_11.get_ha5a7z_k$(tmp4_8_10_16);
          tmp0_apply_0_1.append_uch40_k$('' + 'L' + _get_niceStr_(tmp2__anonymous__22_13) + ',' + _get_niceStr_(tmp3__anonymous__22_15) + ' ');
          Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_4_6_8 === 2) {
            var tmp5_9_11_18 = n_1_3;
            n_1_3 = tmp5_9_11_18 + 1 | 0;
            var tmp4__anonymous__23_17 = this._data_11.get_ha5a7z_k$(tmp5_9_11_18);
            var tmp6_10_12_20 = n_1_3;
            n_1_3 = tmp6_10_12_20 + 1 | 0;
            var tmp5__anonymous__23_19 = this._data_11.get_ha5a7z_k$(tmp6_10_12_20);
            var tmp7_11_13_22 = n_1_3;
            n_1_3 = tmp7_11_13_22 + 1 | 0;
            var tmp6__anonymous__23_21 = this._data_11.get_ha5a7z_k$(tmp7_11_13_22);
            var tmp8_12_14_24 = n_1_3;
            n_1_3 = tmp8_12_14_24 + 1 | 0;
            var tmp7__anonymous__23_23 = this._data_11.get_ha5a7z_k$(tmp8_12_14_24);
            tmp0_apply_0_1.append_uch40_k$('' + 'Q' + _get_niceStr_(tmp4__anonymous__23_17) + ',' + _get_niceStr_(tmp5__anonymous__23_19) + ',' + _get_niceStr_(tmp6__anonymous__23_21) + ',' + _get_niceStr_(tmp7__anonymous__23_23) + ' ');
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_4_6_8 === 3) {
              var tmp9_13_15_26 = n_1_3;
              n_1_3 = tmp9_13_15_26 + 1 | 0;
              var tmp8__anonymous__24_25 = this._data_11.get_ha5a7z_k$(tmp9_13_15_26);
              var tmp10_14_16_28 = n_1_3;
              n_1_3 = tmp10_14_16_28 + 1 | 0;
              var tmp9__anonymous__24_27 = this._data_11.get_ha5a7z_k$(tmp10_14_16_28);
              var tmp11_15_17_30 = n_1_3;
              n_1_3 = tmp11_15_17_30 + 1 | 0;
              var tmp10__anonymous__24_29 = this._data_11.get_ha5a7z_k$(tmp11_15_17_30);
              var tmp12_16_18_32 = n_1_3;
              n_1_3 = tmp12_16_18_32 + 1 | 0;
              var tmp11__anonymous__24_31 = this._data_11.get_ha5a7z_k$(tmp12_16_18_32);
              var tmp13_17_19_34 = n_1_3;
              n_1_3 = tmp13_17_19_34 + 1 | 0;
              var tmp12__anonymous__24_33 = this._data_11.get_ha5a7z_k$(tmp13_17_19_34);
              var tmp14_18_20_36 = n_1_3;
              n_1_3 = tmp14_18_20_36 + 1 | 0;
              var tmp13__anonymous__24_35 = this._data_11.get_ha5a7z_k$(tmp14_18_20_36);
              tmp0_apply_0_1.append_uch40_k$('' + 'C' + _get_niceStr_(tmp8__anonymous__24_25) + ',' + _get_niceStr_(tmp9__anonymous__24_27) + ',' + _get_niceStr_(tmp10__anonymous__24_29) + ',' + _get_niceStr_(tmp11__anonymous__24_31) + ',' + _get_niceStr_(tmp12__anonymous__24_33) + ',' + _get_niceStr_(tmp13__anonymous__24_35) + ' ');
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_4_6_8 === 4) {
                tmp0_apply_0_1.append_uch40_k$('Z ');
                Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    var tmp0_trimEnd_0 = tmp0_apply_0_1.toString();
    return toString_1(trimEnd_0(isCharSequence(tmp0_trimEnd_0) ? tmp0_trimEnd_0 : THROW_CCE()));
  };
  VectorPath.prototype.toString = function () {
    return '' + 'VectorPath(' + this.toSvgString_0_k$() + ')';
  };
  VectorPath.$metadata$ = {
    simpleName: 'VectorPath',
    kind: 'class',
    interfaces: [VectorBuilder]
  };
  function path(_this_, path_0) {
    write(_this_, path_0);
  }
  function applyTransform_0(_this_, m) {
    if (!(m == null)) {
      var progression = step(until(0, _this_._data_11._get_size__0_k$()), 2);
      var inductionVariable = progression._first_0;
      var last_1 = progression._last;
      var step_0 = progression._step_2;
      if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var x = _this_._data_11.getAt_ha5a7z_k$(n + 0 | 0);
          var y = _this_._data_11.getAt_ha5a7z_k$(n + 1 | 0);
          _this_._data_11.set_xewlg1_k$(n + 0 | 0, m.transformX_ngl742_k$(x, y));
          _this_._data_11.set_xewlg1_k$(n + 1 | 0, m.transformY_ngl742_k$(x, y));
        }
         while (!(n === last_1));
    }return _this_;
  }
  function add_0(_this_, path_0) {
    var bb = _this_;
    var lx = 0.0;
    var ly = 0.0;
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = path_0._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__0_k$()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_ha5a7z_k$(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      Command_getInstance();
      if (tmp0_subject_4_6 === 0) {
        var tmp1_5_7 = n_1;
        n_1 = tmp1_5_7 + 1 | 0;
        var tmp0__anonymous__21 = path_0._data_11.get_ha5a7z_k$(tmp1_5_7);
        var tmp2_6_8 = n_1;
        n_1 = tmp2_6_8 + 1 | 0;
        var tmp1__anonymous__21 = path_0._data_11.get_ha5a7z_k$(tmp2_6_8);
        var tmp0_also_0_23 = bb.add_ngl742_k$(tmp0__anonymous__21, tmp1__anonymous__21);
        lx = tmp0__anonymous__21;
        var tmp1_also_0_22 = tmp0_also_0_23;
        ly = tmp1__anonymous__21;
        Unit_getInstance();
      } else {
        Command_getInstance();
        if (tmp0_subject_4_6 === 1) {
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp4_8_10);
          var tmp0_also_0_26 = bb.add_ngl742_k$(tmp2__anonymous__24, tmp3__anonymous__24);
          lx = tmp2__anonymous__24;
          var tmp1_also_0_25 = tmp0_also_0_26;
          ly = tmp3__anonymous__24;
          Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_4_6 === 2) {
            var tmp5_9_11 = n_1;
            n_1 = tmp5_9_11 + 1 | 0;
            var tmp4__anonymous__27 = path_0._data_11.get_ha5a7z_k$(tmp5_9_11);
            var tmp6_10_12 = n_1;
            n_1 = tmp6_10_12 + 1 | 0;
            var tmp5__anonymous__27 = path_0._data_11.get_ha5a7z_k$(tmp6_10_12);
            var tmp7_11_13 = n_1;
            n_1 = tmp7_11_13 + 1 | 0;
            var tmp6__anonymous__27 = path_0._data_11.get_ha5a7z_k$(tmp7_11_13);
            var tmp8_12_14 = n_1;
            n_1 = tmp8_12_14 + 1 | 0;
            var tmp7__anonymous__27 = path_0._data_11.get_ha5a7z_k$(tmp8_12_14);
            var tmp = Companion_getInstance_41();
            var tmp_0 = lx;
            var tmp_1 = ly;
            var tmp0_also_0_29 = bb.add_uebyw0_k$(tmp.quadBounds$default_oascqk_k$(tmp_0, tmp_1, tmp4__anonymous__27, tmp5__anonymous__27, tmp6__anonymous__27, tmp7__anonymous__27, bb._tempRect, null, 128, null));
            lx = tmp6__anonymous__27;
            var tmp1_also_0_28 = tmp0_also_0_29;
            ly = tmp7__anonymous__27;
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_4_6 === 3) {
              var tmp9_13_15 = n_1;
              n_1 = tmp9_13_15 + 1 | 0;
              var tmp8__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp9_13_15);
              var tmp10_14_16 = n_1;
              n_1 = tmp10_14_16 + 1 | 0;
              var tmp9__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp10_14_16);
              var tmp11_15_17 = n_1;
              n_1 = tmp11_15_17 + 1 | 0;
              var tmp10__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp11_15_17);
              var tmp12_16_18 = n_1;
              n_1 = tmp12_16_18 + 1 | 0;
              var tmp11__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp12_16_18);
              var tmp13_17_19 = n_1;
              n_1 = tmp13_17_19 + 1 | 0;
              var tmp12__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp13_17_19);
              var tmp14_18_20 = n_1;
              n_1 = tmp14_18_20 + 1 | 0;
              var tmp13__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp14_18_20);
              var tmp0_also_0_32 = bb.add_uebyw0_k$(Companion_getInstance_41().cubicBounds_iom630_k$(lx, ly, tmp8__anonymous__30, tmp9__anonymous__30, tmp10__anonymous__30, tmp11__anonymous__30, tmp12__anonymous__30, tmp13__anonymous__30, bb._tempRect, path_0._bezierTemp));
              lx = tmp12__anonymous__30;
              var tmp1_also_0_31 = tmp0_also_0_32;
              ly = tmp13__anonymous__30;
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_4_6 === 4) {
                Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
  }
  function write(_this_, path_0) {
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = path_0._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__0_k$()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_ha5a7z_k$(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      Command_getInstance();
      if (tmp0_subject_4_6 === 0) {
        var tmp1_5_7 = n_1;
        n_1 = tmp1_5_7 + 1 | 0;
        var tmp0__anonymous__21 = path_0._data_11.get_ha5a7z_k$(tmp1_5_7);
        var tmp2_6_8 = n_1;
        n_1 = tmp2_6_8 + 1 | 0;
        var tmp1__anonymous__21 = path_0._data_11.get_ha5a7z_k$(tmp2_6_8);
        _this_.moveTo_ul66c3_k$(tmp0__anonymous__21, tmp1__anonymous__21);
      } else {
        Command_getInstance();
        if (tmp0_subject_4_6 === 1) {
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__22 = path_0._data_11.get_ha5a7z_k$(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__22 = path_0._data_11.get_ha5a7z_k$(tmp4_8_10);
          _this_.lineTo_ul66c3_k$(tmp2__anonymous__22, tmp3__anonymous__22);
        } else {
          Command_getInstance();
          if (tmp0_subject_4_6 === 2) {
            var tmp5_9_11 = n_1;
            n_1 = tmp5_9_11 + 1 | 0;
            var tmp4__anonymous__23 = path_0._data_11.get_ha5a7z_k$(tmp5_9_11);
            var tmp6_10_12 = n_1;
            n_1 = tmp6_10_12 + 1 | 0;
            var tmp5__anonymous__23 = path_0._data_11.get_ha5a7z_k$(tmp6_10_12);
            var tmp7_11_13 = n_1;
            n_1 = tmp7_11_13 + 1 | 0;
            var tmp6__anonymous__23 = path_0._data_11.get_ha5a7z_k$(tmp7_11_13);
            var tmp8_12_14 = n_1;
            n_1 = tmp8_12_14 + 1 | 0;
            var tmp7__anonymous__23 = path_0._data_11.get_ha5a7z_k$(tmp8_12_14);
            _this_.quadTo_lf7oid_k$(tmp4__anonymous__23, tmp5__anonymous__23, tmp6__anonymous__23, tmp7__anonymous__23);
          } else {
            Command_getInstance();
            if (tmp0_subject_4_6 === 3) {
              var tmp9_13_15 = n_1;
              n_1 = tmp9_13_15 + 1 | 0;
              var tmp8__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp9_13_15);
              var tmp10_14_16 = n_1;
              n_1 = tmp10_14_16 + 1 | 0;
              var tmp9__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp10_14_16);
              var tmp11_15_17 = n_1;
              n_1 = tmp11_15_17 + 1 | 0;
              var tmp10__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp11_15_17);
              var tmp12_16_18 = n_1;
              n_1 = tmp12_16_18 + 1 | 0;
              var tmp11__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp12_16_18);
              var tmp13_17_19 = n_1;
              n_1 = tmp13_17_19 + 1 | 0;
              var tmp12__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp13_17_19);
              var tmp14_18_20 = n_1;
              n_1 = tmp14_18_20 + 1 | 0;
              var tmp13__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp14_18_20);
              _this_.cubicTo_iylh49_k$(tmp8__anonymous__24, tmp9__anonymous__24, tmp10__anonymous__24, tmp11__anonymous__24, tmp12__anonymous__24, tmp13__anonymous__24);
            } else {
              Command_getInstance();
              if (tmp0_subject_4_6 === 4) {
                _this_.close_sv8swh_k$();
              } else {
              }
            }
          }
        }
      }
    }
  }
  var Winding_EVEN_ODD_instance;
  var Winding_NON_ZERO_instance;
  var Winding_entriesInitialized;
  function Winding_initEntries() {
    if (Winding_entriesInitialized)
      return Unit_getInstance();
    Winding_entriesInitialized = true;
    Winding_EVEN_ODD_instance = new Winding('EVEN_ODD', 0, 'evenOdd');
    Winding_NON_ZERO_instance = new Winding('NON_ZERO', 1, 'nonZero');
  }
  function Winding(name, ordinal, str) {
    Enum.call(this, name, ordinal);
    this._str = str;
  }
  Winding.$metadata$ = {
    simpleName: 'Winding',
    kind: 'class',
    interfaces: []
  };
  function Winding_EVEN_ODD_getInstance() {
    Winding_initEntries();
    return Winding_EVEN_ODD_instance;
  }
  function Winding_NON_ZERO_getInstance() {
    Winding_initEntries();
    return Winding_NON_ZERO_instance;
  }
  function _get_niceStr_(_this_) {
    return almostEquals_0(numberToLong(_this_).toDouble_0_k$(), _this_) ? '' + numberToLong(_this_) : '' + _this_;
  }
  function _get_niceStr__0(_this_) {
    return almostEquals(numberToLong(_this_).toFloat_0_k$(), _this_) ? '' + numberToLong(_this_) : '' + _this_;
  }
  function floorCeil(v) {
    var tmp;
    if (v < 0.0) {
      tmp = Math.ceil(v);
    } else {
      tmp = Math.floor(v);
    }
    return tmp;
  }
  function _no_name_provided__76() {
  }
  _no_name_provided__76.prototype.invoke_0_k$ = function () {
    var tmp0_associateBy_0 = values();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_1q9pf_k$(element_2_4._get_name__0_k$(), element_2_4);
      Unit_getInstance();
    }
    return tmp0_associateByTo_0_2;
  };
  _no_name_provided__76.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_58() {
    Companion_instance_57 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp._ALL$delegate = lazy_0(tmp_0, _no_name_provided_$factory_55());
  }
  Companion_58.prototype._get_LINEAR__0_k$ = function () {
    return Easings_LINEAR_getInstance();
  };
  Companion_58.prototype._get_EASE_IN_OUT_QUAD__0_k$ = function () {
    return Easings_EASE_IN_OUT_QUAD_getInstance();
  };
  Companion_58.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_57;
  function Companion_getInstance_57() {
    if (Companion_instance_57 == null)
      new Companion_58();
    return Companion_instance_57;
  }
  function Easing() {
  }
  Easing.$metadata$ = {
    simpleName: 'Easing',
    kind: 'interface',
    interfaces: []
  };
  function SMOOTH() {
    Easings.call(this, 'SMOOTH', -1);
    Unit_getInstance();
    Easings_SMOOTH_instance = this;
  }
  SMOOTH.prototype.invoke_e2tf9d_k$ = function (it) {
    return it * it * (3 - 2 * it);
  };
  SMOOTH.$metadata$ = {
    simpleName: 'SMOOTH',
    kind: 'class',
    interfaces: []
  };
  var Easings_SMOOTH_instance;
  function EASE_IN_ELASTIC() {
    Easings.call(this, 'EASE_IN_ELASTIC', -1);
    Unit_getInstance();
    Easings_EASE_IN_ELASTIC_instance = this;
  }
  EASE_IN_ELASTIC.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:var p = 0.3;
        var s = p / 4.0;
        var inv = it - 1;
        var tmp0_pow_0 = 10.0 * inv;
        var tmp_0 = -1.0 * Math.pow(2.0, tmp0_pow_0);
        var tmp1_sin_0 = (inv - s) * 6.283185307179586 / p;
        tmp = tmp_0 * Math.sin(tmp1_sin_0);
        break;
    }
    return tmp;
  };
  EASE_IN_ELASTIC.$metadata$ = {
    simpleName: 'EASE_IN_ELASTIC',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_ELASTIC_instance;
  function EASE_OUT_ELASTIC() {
    Easings.call(this, 'EASE_OUT_ELASTIC', -1);
    Unit_getInstance();
    Easings_EASE_OUT_ELASTIC_instance = this;
  }
  EASE_OUT_ELASTIC.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:var p = 0.3;
        var s = p / 4.0;
        var tmp0_pow_0 = -10.0 * it;
        var tmp_0 = Math.pow(2.0, tmp0_pow_0);
        var tmp1_sin_0 = (it - s) * 6.283185307179586 / p;
        tmp = tmp_0 * Math.sin(tmp1_sin_0) + 1;
        break;
    }
    return tmp;
  };
  EASE_OUT_ELASTIC.$metadata$ = {
    simpleName: 'EASE_OUT_ELASTIC',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_ELASTIC_instance;
  function EASE_OUT_BOUNCE() {
    Easings.call(this, 'EASE_OUT_BOUNCE', -1);
    Unit_getInstance();
    Easings_EASE_OUT_BOUNCE_instance = this;
  }
  EASE_OUT_BOUNCE.prototype.invoke_e2tf9d_k$ = function (it) {
    var s = 7.5625;
    var p = 2.75;
    var tmp;
    if (it < 1.0 / p) {
      tmp = s * Math.pow(it, 2.0);
    } else if (it < 2.0 / p) {
      var tmp0_pow_0 = it - 1.5 / p;
      tmp = s * Math.pow(tmp0_pow_0, 2.0) + 0.75;
    } else if (it < 2.5 / p) {
      var tmp1_pow_0 = it - 2.25 / p;
      tmp = s * Math.pow(tmp1_pow_0, 2.0) + 0.9375;
    } else {
      var tmp2_pow_0 = it - 2.625 / p;
      tmp = s * Math.pow(tmp2_pow_0, 2.0) + 0.984375;
    }
    return tmp;
  };
  EASE_OUT_BOUNCE.$metadata$ = {
    simpleName: 'EASE_OUT_BOUNCE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_BOUNCE_instance;
  function LINEAR() {
    Easings.call(this, 'LINEAR', -1);
    Unit_getInstance();
    Easings_LINEAR_instance = this;
  }
  LINEAR.prototype.invoke_e2tf9d_k$ = function (it) {
    return it;
  };
  LINEAR.$metadata$ = {
    simpleName: 'LINEAR',
    kind: 'class',
    interfaces: []
  };
  var Easings_LINEAR_instance;
  function EASE_IN() {
    Easings.call(this, 'EASE_IN', -1);
    Unit_getInstance();
    Easings_EASE_IN_instance = this;
  }
  EASE_IN.prototype.invoke_e2tf9d_k$ = function (it) {
    return it * it * it;
  };
  EASE_IN.$metadata$ = {
    simpleName: 'EASE_IN',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_instance;
  function EASE_OUT() {
    Easings.call(this, 'EASE_OUT', -1);
    Unit_getInstance();
    Easings_EASE_OUT_instance = this;
  }
  EASE_OUT.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_let_0 = it - 1.0;
    return tmp0_let_0 * tmp0_let_0 * tmp0_let_0 + 1;
  };
  EASE_OUT.$metadata$ = {
    simpleName: 'EASE_OUT',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_instance;
  function EASE_IN_OUT() {
    Easings.call(this, 'EASE_IN_OUT', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_instance = this;
  }
  EASE_IN_OUT.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_combine_0 = Easings_EASE_IN_getInstance();
    var tmp1_combine_0 = Easings_EASE_OUT_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_e2tf9d_k$(it * 2.0) : 0.5 * tmp1_combine_0.invoke_e2tf9d_k$((it - 0.5) * 2.0) + 0.5;
  };
  EASE_IN_OUT.$metadata$ = {
    simpleName: 'EASE_IN_OUT',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_instance;
  function EASE_OUT_IN() {
    Easings.call(this, 'EASE_OUT_IN', -1);
    Unit_getInstance();
    Easings_EASE_OUT_IN_instance = this;
  }
  EASE_OUT_IN.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_combine_0 = Easings_EASE_OUT_getInstance();
    var tmp1_combine_0 = Easings_EASE_IN_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_e2tf9d_k$(it * 2.0) : 0.5 * tmp1_combine_0.invoke_e2tf9d_k$((it - 0.5) * 2.0) + 0.5;
  };
  EASE_OUT_IN.$metadata$ = {
    simpleName: 'EASE_OUT_IN',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_IN_instance;
  function EASE_IN_BACK() {
    Easings.call(this, 'EASE_IN_BACK', -1);
    Unit_getInstance();
    Easings_EASE_IN_BACK_instance = this;
  }
  EASE_IN_BACK.prototype.invoke_e2tf9d_k$ = function (it) {
    return Math.pow(it, 2.0) * (2.70158 * it - 1.70158);
  };
  EASE_IN_BACK.$metadata$ = {
    simpleName: 'EASE_IN_BACK',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_BACK_instance;
  function EASE_OUT_BACK() {
    Easings.call(this, 'EASE_OUT_BACK', -1);
    Unit_getInstance();
    Easings_EASE_OUT_BACK_instance = this;
  }
  EASE_OUT_BACK.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_let_0 = it - 1.0;
    return Math.pow(tmp0_let_0, 2.0) * (2.70158 * tmp0_let_0 + 1.70158) + 1.0;
  };
  EASE_OUT_BACK.$metadata$ = {
    simpleName: 'EASE_OUT_BACK',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_BACK_instance;
  function EASE_IN_OUT_BACK() {
    Easings.call(this, 'EASE_IN_OUT_BACK', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_BACK_instance = this;
  }
  EASE_IN_OUT_BACK.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_combine_0 = Easings_EASE_IN_BACK_getInstance();
    var tmp1_combine_0 = Easings_EASE_OUT_BACK_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_e2tf9d_k$(it * 2.0) : 0.5 * tmp1_combine_0.invoke_e2tf9d_k$((it - 0.5) * 2.0) + 0.5;
  };
  EASE_IN_OUT_BACK.$metadata$ = {
    simpleName: 'EASE_IN_OUT_BACK',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_BACK_instance;
  function EASE_OUT_IN_BACK() {
    Easings.call(this, 'EASE_OUT_IN_BACK', -1);
    Unit_getInstance();
    Easings_EASE_OUT_IN_BACK_instance = this;
  }
  EASE_OUT_IN_BACK.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_combine_0 = Easings_EASE_OUT_BACK_getInstance();
    var tmp1_combine_0 = Easings_EASE_IN_BACK_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_e2tf9d_k$(it * 2.0) : 0.5 * tmp1_combine_0.invoke_e2tf9d_k$((it - 0.5) * 2.0) + 0.5;
  };
  EASE_OUT_IN_BACK.$metadata$ = {
    simpleName: 'EASE_OUT_IN_BACK',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_IN_BACK_instance;
  function EASE_IN_OUT_ELASTIC() {
    Easings.call(this, 'EASE_IN_OUT_ELASTIC', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_ELASTIC_instance = this;
  }
  EASE_IN_OUT_ELASTIC.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_combine_0 = Easings_EASE_IN_ELASTIC_getInstance();
    var tmp1_combine_0 = Easings_EASE_OUT_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_e2tf9d_k$(it * 2.0) : 0.5 * tmp1_combine_0.invoke_e2tf9d_k$((it - 0.5) * 2.0) + 0.5;
  };
  EASE_IN_OUT_ELASTIC.$metadata$ = {
    simpleName: 'EASE_IN_OUT_ELASTIC',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_ELASTIC_instance;
  function EASE_OUT_IN_ELASTIC() {
    Easings.call(this, 'EASE_OUT_IN_ELASTIC', -1);
    Unit_getInstance();
    Easings_EASE_OUT_IN_ELASTIC_instance = this;
  }
  EASE_OUT_IN_ELASTIC.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_combine_0 = Easings_EASE_OUT_ELASTIC_getInstance();
    var tmp1_combine_0 = Easings_EASE_IN_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_e2tf9d_k$(it * 2.0) : 0.5 * tmp1_combine_0.invoke_e2tf9d_k$((it - 0.5) * 2.0) + 0.5;
  };
  EASE_OUT_IN_ELASTIC.$metadata$ = {
    simpleName: 'EASE_OUT_IN_ELASTIC',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_IN_ELASTIC_instance;
  function EASE_IN_BOUNCE() {
    Easings.call(this, 'EASE_IN_BOUNCE', -1);
    Unit_getInstance();
    Easings_EASE_IN_BOUNCE_instance = this;
  }
  EASE_IN_BOUNCE.prototype.invoke_e2tf9d_k$ = function (it) {
    return 1.0 - Easings_EASE_OUT_BOUNCE_getInstance().invoke_e2tf9d_k$(1.0 - it);
  };
  EASE_IN_BOUNCE.$metadata$ = {
    simpleName: 'EASE_IN_BOUNCE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_BOUNCE_instance;
  function EASE_IN_OUT_BOUNCE() {
    Easings.call(this, 'EASE_IN_OUT_BOUNCE', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_BOUNCE_instance = this;
  }
  EASE_IN_OUT_BOUNCE.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_combine_0 = Easings_EASE_IN_BOUNCE_getInstance();
    var tmp1_combine_0 = Easings_EASE_OUT_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_e2tf9d_k$(it * 2.0) : 0.5 * tmp1_combine_0.invoke_e2tf9d_k$((it - 0.5) * 2.0) + 0.5;
  };
  EASE_IN_OUT_BOUNCE.$metadata$ = {
    simpleName: 'EASE_IN_OUT_BOUNCE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_BOUNCE_instance;
  function EASE_OUT_IN_BOUNCE() {
    Easings.call(this, 'EASE_OUT_IN_BOUNCE', -1);
    Unit_getInstance();
    Easings_EASE_OUT_IN_BOUNCE_instance = this;
  }
  EASE_OUT_IN_BOUNCE.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_combine_0 = Easings_EASE_OUT_BOUNCE_getInstance();
    var tmp1_combine_0 = Easings_EASE_IN_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_e2tf9d_k$(it * 2.0) : 0.5 * tmp1_combine_0.invoke_e2tf9d_k$((it - 0.5) * 2.0) + 0.5;
  };
  EASE_OUT_IN_BOUNCE.$metadata$ = {
    simpleName: 'EASE_OUT_IN_BOUNCE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_IN_BOUNCE_instance;
  function EASE_IN_QUAD() {
    Easings.call(this, 'EASE_IN_QUAD', -1);
    Unit_getInstance();
    Easings_EASE_IN_QUAD_instance = this;
  }
  EASE_IN_QUAD.prototype.invoke_e2tf9d_k$ = function (it) {
    return 1.0 * it * it;
  };
  EASE_IN_QUAD.$metadata$ = {
    simpleName: 'EASE_IN_QUAD',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_QUAD_instance;
  function EASE_OUT_QUAD() {
    Easings.call(this, 'EASE_OUT_QUAD', -1);
    Unit_getInstance();
    Easings_EASE_OUT_QUAD_instance = this;
  }
  EASE_OUT_QUAD.prototype.invoke_e2tf9d_k$ = function (it) {
    return -1.0 * it * (it - 2);
  };
  EASE_OUT_QUAD.$metadata$ = {
    simpleName: 'EASE_OUT_QUAD',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_QUAD_instance;
  function EASE_IN_OUT_QUAD() {
    Easings.call(this, 'EASE_IN_OUT_QUAD', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_QUAD_instance = this;
  }
  EASE_IN_OUT_QUAD.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_let_0 = it * 2.0;
    var tmp;
    if (tmp0_let_0 < 1.0) {
      tmp = 0.5 * tmp0_let_0 * tmp0_let_0;
    } else {
      tmp = -0.5 * ((tmp0_let_0 - 1) * (tmp0_let_0 - 1 - 2) - 1);
    }
    return tmp;
  };
  EASE_IN_OUT_QUAD.$metadata$ = {
    simpleName: 'EASE_IN_OUT_QUAD',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_QUAD_instance;
  function EASE_SINE() {
    Easings.call(this, 'EASE_SINE', -1);
    Unit_getInstance();
    Easings_EASE_SINE_instance = this;
  }
  EASE_SINE.prototype.invoke_e2tf9d_k$ = function (it) {
    var tmp0_sin_0 = it * 1.5707963267948966;
    return Math.sin(tmp0_sin_0);
  };
  EASE_SINE.$metadata$ = {
    simpleName: 'EASE_SINE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_SINE_instance;
  function EASE_CLAMP_START() {
    Easings.call(this, 'EASE_CLAMP_START', -1);
    Unit_getInstance();
    Easings_EASE_CLAMP_START_instance = this;
  }
  EASE_CLAMP_START.prototype.invoke_e2tf9d_k$ = function (it) {
    return it <= 0.0 ? 0.0 : 1.0;
  };
  EASE_CLAMP_START.$metadata$ = {
    simpleName: 'EASE_CLAMP_START',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_CLAMP_START_instance;
  function EASE_CLAMP_END() {
    Easings.call(this, 'EASE_CLAMP_END', -1);
    Unit_getInstance();
    Easings_EASE_CLAMP_END_instance = this;
  }
  EASE_CLAMP_END.prototype.invoke_e2tf9d_k$ = function (it) {
    return it < 1.0 ? 0.0 : 1.0;
  };
  EASE_CLAMP_END.$metadata$ = {
    simpleName: 'EASE_CLAMP_END',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_CLAMP_END_instance;
  function EASE_CLAMP_MIDDLE() {
    Easings.call(this, 'EASE_CLAMP_MIDDLE', -1);
    Unit_getInstance();
    Easings_EASE_CLAMP_MIDDLE_instance = this;
  }
  EASE_CLAMP_MIDDLE.prototype.invoke_e2tf9d_k$ = function (it) {
    return it < 0.5 ? 0.0 : 1.0;
  };
  EASE_CLAMP_MIDDLE.$metadata$ = {
    simpleName: 'EASE_CLAMP_MIDDLE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_CLAMP_MIDDLE_instance;
  function values() {
    return [Easings_SMOOTH_getInstance(), Easings_EASE_IN_ELASTIC_getInstance(), Easings_EASE_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_BOUNCE_getInstance(), Easings_LINEAR_getInstance(), Easings_EASE_IN_getInstance(), Easings_EASE_OUT_getInstance(), Easings_EASE_IN_OUT_getInstance(), Easings_EASE_OUT_IN_getInstance(), Easings_EASE_IN_BACK_getInstance(), Easings_EASE_OUT_BACK_getInstance(), Easings_EASE_IN_OUT_BACK_getInstance(), Easings_EASE_OUT_IN_BACK_getInstance(), Easings_EASE_IN_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_IN_ELASTIC_getInstance(), Easings_EASE_IN_BOUNCE_getInstance(), Easings_EASE_IN_OUT_BOUNCE_getInstance(), Easings_EASE_OUT_IN_BOUNCE_getInstance(), Easings_EASE_IN_QUAD_getInstance(), Easings_EASE_OUT_QUAD_getInstance(), Easings_EASE_IN_OUT_QUAD_getInstance(), Easings_EASE_SINE_getInstance(), Easings_EASE_CLAMP_START_getInstance(), Easings_EASE_CLAMP_END_getInstance(), Easings_EASE_CLAMP_MIDDLE_getInstance()];
  }
  var Easings_entriesInitialized;
  function Easings_initEntries() {
    if (Easings_entriesInitialized)
      return Unit_getInstance();
    Easings_entriesInitialized = true;
    Easings_SMOOTH_instance = new SMOOTH();
    Easings_EASE_IN_ELASTIC_instance = new EASE_IN_ELASTIC();
    Easings_EASE_OUT_ELASTIC_instance = new EASE_OUT_ELASTIC();
    Easings_EASE_OUT_BOUNCE_instance = new EASE_OUT_BOUNCE();
    Easings_LINEAR_instance = new LINEAR();
    Easings_EASE_IN_instance = new EASE_IN();
    Easings_EASE_OUT_instance = new EASE_OUT();
    Easings_EASE_IN_OUT_instance = new EASE_IN_OUT();
    Easings_EASE_OUT_IN_instance = new EASE_OUT_IN();
    Easings_EASE_IN_BACK_instance = new EASE_IN_BACK();
    Easings_EASE_OUT_BACK_instance = new EASE_OUT_BACK();
    Easings_EASE_IN_OUT_BACK_instance = new EASE_IN_OUT_BACK();
    Easings_EASE_OUT_IN_BACK_instance = new EASE_OUT_IN_BACK();
    Easings_EASE_IN_OUT_ELASTIC_instance = new EASE_IN_OUT_ELASTIC();
    Easings_EASE_OUT_IN_ELASTIC_instance = new EASE_OUT_IN_ELASTIC();
    Easings_EASE_IN_BOUNCE_instance = new EASE_IN_BOUNCE();
    Easings_EASE_IN_OUT_BOUNCE_instance = new EASE_IN_OUT_BOUNCE();
    Easings_EASE_OUT_IN_BOUNCE_instance = new EASE_OUT_IN_BOUNCE();
    Easings_EASE_IN_QUAD_instance = new EASE_IN_QUAD();
    Easings_EASE_OUT_QUAD_instance = new EASE_OUT_QUAD();
    Easings_EASE_IN_OUT_QUAD_instance = new EASE_IN_OUT_QUAD();
    Easings_EASE_SINE_instance = new EASE_SINE();
    Easings_EASE_CLAMP_START_instance = new EASE_CLAMP_START();
    Easings_EASE_CLAMP_END_instance = new EASE_CLAMP_END();
    Easings_EASE_CLAMP_MIDDLE_instance = new EASE_CLAMP_MIDDLE();
  }
  function Easings(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Easings.$metadata$ = {
    simpleName: 'Easings',
    kind: 'class',
    interfaces: [Easing]
  };
  function Easings_SMOOTH_getInstance() {
    Easings_initEntries();
    return Easings_SMOOTH_instance;
  }
  function Easings_EASE_IN_ELASTIC_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_ELASTIC_instance;
  }
  function Easings_EASE_OUT_ELASTIC_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_ELASTIC_instance;
  }
  function Easings_EASE_OUT_BOUNCE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_BOUNCE_instance;
  }
  function Easings_LINEAR_getInstance() {
    Easings_initEntries();
    return Easings_LINEAR_instance;
  }
  function Easings_EASE_IN_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_instance;
  }
  function Easings_EASE_OUT_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_instance;
  }
  function Easings_EASE_IN_OUT_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_instance;
  }
  function Easings_EASE_OUT_IN_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_IN_instance;
  }
  function Easings_EASE_IN_BACK_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_BACK_instance;
  }
  function Easings_EASE_OUT_BACK_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_BACK_instance;
  }
  function Easings_EASE_IN_OUT_BACK_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_BACK_instance;
  }
  function Easings_EASE_OUT_IN_BACK_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_IN_BACK_instance;
  }
  function Easings_EASE_IN_OUT_ELASTIC_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_ELASTIC_instance;
  }
  function Easings_EASE_OUT_IN_ELASTIC_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_IN_ELASTIC_instance;
  }
  function Easings_EASE_IN_BOUNCE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_BOUNCE_instance;
  }
  function Easings_EASE_IN_OUT_BOUNCE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_BOUNCE_instance;
  }
  function Easings_EASE_OUT_IN_BOUNCE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_IN_BOUNCE_instance;
  }
  function Easings_EASE_IN_QUAD_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_QUAD_instance;
  }
  function Easings_EASE_OUT_QUAD_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_QUAD_instance;
  }
  function Easings_EASE_IN_OUT_QUAD_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_QUAD_instance;
  }
  function Easings_EASE_SINE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_SINE_instance;
  }
  function Easings_EASE_CLAMP_START_getInstance() {
    Easings_initEntries();
    return Easings_EASE_CLAMP_START_instance;
  }
  function Easings_EASE_CLAMP_END_getInstance() {
    Easings_initEntries();
    return Easings_EASE_CLAMP_END_instance;
  }
  function Easings_EASE_CLAMP_MIDDLE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_CLAMP_MIDDLE_instance;
  }
  function _no_name_provided_$factory_55() {
    var i = new _no_name_provided__76();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function MutableInterpolable() {
  }
  MutableInterpolable.$metadata$ = {
    simpleName: 'MutableInterpolable',
    kind: 'interface',
    interfaces: []
  };
  function Interpolable() {
  }
  Interpolable.$metadata$ = {
    simpleName: 'Interpolable',
    kind: 'interface',
    interfaces: []
  };
  function interpolate(_this_, l, r) {
    return l + (r - l) * _this_;
  }
  function interpolate_0(_this_, l, r) {
    return numberToInt(l + (r - l | 0) * _this_);
  }
  function minOrElse(_this_, nil) {
    if (_this_.length === 0)
      return nil;
    else {
    }
    DoubleCompanionObject_getInstance();
    var out = Infinity;
    var inductionVariable = 0;
    var last_1 = _get_lastIndex__0(_this_);
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_min_0 = out;
        var tmp1_min_0 = _this_[i];
        out = Math.min(tmp0_min_0, tmp1_min_0);
      }
       while (!(i === last_1));
    return out;
  }
  function maxOrElse(_this_, nil) {
    if (_this_.length === 0)
      return nil;
    else {
    }
    DoubleCompanionObject_getInstance();
    var out = -Infinity;
    var inductionVariable = 0;
    var last_1 = _get_lastIndex__0(_this_);
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_max_0 = out;
        var tmp1_max_0 = _this_[i];
        out = Math.max(tmp0_max_0, tmp1_max_0);
      }
       while (!(i === last_1));
    return out;
  }
  function almostEquals(a, b) {
    return almostZero(a - b);
  }
  function almostEquals_0(a, b) {
    return almostZero_0(a - b);
  }
  function almostZero(a) {
    return Math.abs(a) <= 1.0E-7;
  }
  function almostZero_0(a) {
    return Math.abs(a) <= 1.0E-7;
  }
  function roundDecimalPlaces(_this_, places) {
    var tmp0_pow_0 = places;
    var placesFactor = Math.pow(10.0, tmp0_pow_0);
    return round(_this_ * placesFactor) / placesFactor;
  }
  function clamp(_this_, min_0, max) {
    return _this_ < min_0 ? min_0 : _this_ > max ? max : _this_;
  }
  function insertAt($this, n, min_0, max) {
    $this._min.insertAt_27zxwg_k$(n, min_0);
    Unit_getInstance();
    $this._max.insertAt_27zxwg_k$(n, max);
    Unit_getInstance();
  }
  function removeAt($this, n, count_0) {
    $this._min.removeAt_27zxwg_k$(n, count_0);
    Unit_getInstance();
    $this._max.removeAt_27zxwg_k$(n, count_0);
    Unit_getInstance();
  }
  function IntSegmentSet() {
    this._min = new IntArrayList(16);
    this._max = new IntArrayList(16);
  }
  IntSegmentSet.prototype._get_size__0_k$ = function () {
    return this._min._get_size__0_k$();
  };
  IntSegmentSet.prototype.isEmpty_0_k$ = function () {
    return this._get_size__0_k$() === 0;
  };
  IntSegmentSet.prototype.isNotEmpty_0_k$ = function () {
    return this._get_size__0_k$() > 0;
  };
  IntSegmentSet.prototype.clear_0_k$ = function () {
    this._min.clear_sv8swh_k$();
    this._max.clear_sv8swh_k$();
    return this;
  };
  IntSegmentSet.prototype._get_minMin__0_k$ = function () {
    return this.isNotEmpty_0_k$() ? this._min.getAt_ha5a7z_k$(0) : 0;
  };
  IntSegmentSet.prototype._get_maxMax__0_k$ = function () {
    return this.isNotEmpty_0_k$() ? this._max.getAt_ha5a7z_k$(this._max._get_size__0_k$() - 1 | 0) : 0;
  };
  IntSegmentSet.prototype.findNearIndex_quefpa_k$ = function (x) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_genericBinarySearch_0 = this._get_size__0_k$();
      var low_2 = 0;
      var high_3 = tmp0_genericBinarySearch_0 - 1 | 0;
      while (low_2 <= high_3) {
        var mid_4 = (low_2 + high_3 | 0) / 2 | 0;
        var min_7 = this._min.getAt_ha5a7z_k$(mid_4);
        var max_8 = this._max.getAt_ha5a7z_k$(mid_4);
        var mval_5 = x < min_7 ? 1 : x > max_8 ? -1 : 0;
        if (mval_5 < 0)
          low_2 = mid_4 + 1 | 0;
        else if (mval_5 > 0)
          high_3 = mid_4 - 1 | 0;
        else {
          tmp$ret$0 = mid_4;
          break l$ret$1;
        }
      }
      var tmp1__anonymous__1_9 = low_2;
      var tmp2__anonymous__1_9 = high_3;
      tmp$ret$0 = (-tmp1__anonymous__1_9 | 0) - 1 | 0;
    }
     while (false);
    return _BSearchResult___init__impl_(tmp$ret$0);
  };
  IntSegmentSet.prototype.findLeftBound_ha5a7z_k$ = function (x) {
    var tmp2_genericBinarySearchLeft_0 = this._get_size__0_k$();
    var tmp$ret$0;
    l$ret$1: do {
      var low_2 = 0;
      var high_3 = tmp2_genericBinarySearchLeft_0 - 1 | 0;
      while (low_2 <= high_3) {
        var mid_4 = (low_2 + high_3 | 0) / 2 | 0;
        var mval_5 = compareTo(this._min.getAt_ha5a7z_k$(mid_4), x);
        if (mval_5 < 0)
          low_2 = mid_4 + 1 | 0;
        else if (mval_5 > 0)
          high_3 = mid_4 - 1 | 0;
        else {
          tmp$ret$0 = mid_4;
          break l$ret$1;
        }
      }
      var tmp0__anonymous__1_6 = low_2;
      var tmp1__anonymous__1_6 = high_3;
      tmp$ret$0 = coerceIn(Math.min(tmp0__anonymous__1_6, tmp1__anonymous__1_6), 0, tmp2_genericBinarySearchLeft_0 - 1 | 0);
    }
     while (false);
    return coerceIn(tmp$ret$0, 0, this._get_size__0_k$() - 1 | 0);
  };
  IntSegmentSet.prototype.findRightBound_ha5a7z_k$ = function (x) {
    var tmp2_genericBinarySearchRight_0 = this._get_size__0_k$();
    var tmp$ret$0;
    l$ret$1: do {
      var low_2 = 0;
      var high_3 = tmp2_genericBinarySearchRight_0 - 1 | 0;
      while (low_2 <= high_3) {
        var mid_4 = (low_2 + high_3 | 0) / 2 | 0;
        var mval_5 = compareTo(this._max.getAt_ha5a7z_k$(mid_4), x);
        if (mval_5 < 0)
          low_2 = mid_4 + 1 | 0;
        else if (mval_5 > 0)
          high_3 = mid_4 - 1 | 0;
        else {
          tmp$ret$0 = mid_4;
          break l$ret$1;
        }
      }
      var tmp0__anonymous__1_6 = low_2;
      var tmp1__anonymous__1_6 = high_3;
      tmp$ret$0 = coerceIn(Math.max(tmp0__anonymous__1_6, tmp1__anonymous__1_6), 0, tmp2_genericBinarySearchRight_0 - 1 | 0);
    }
     while (false);
    return coerceIn(tmp$ret$0, 0, this._get_size__0_k$() - 1 | 0);
  };
  IntSegmentSet.prototype.add_27zxwg_k$ = function (min_0, max) {
    var tmp$ret$2;
    l$ret$3: do {
      var tmp0_check_0_2 = min_0 <= max;
      if (!tmp0_check_0_2) {
        var message_2_1_3 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_3));
      }if (this.isEmpty_0_k$())
        insertAt(this, this._get_size__0_k$(), min_0, max);
      else if (min_0 === this._get_maxMax__0_k$())
        this._max.set_rvwcgf_k$(this._max._get_size__0_k$() - 1 | 0, max);
      else if (max === this._get_minMin__0_k$())
        this._min.set_rvwcgf_k$(0, min_0);
      else {
        var removeStart_4 = -1;
        var removeCount_5 = -1;
        var tmp$ret$0;
        l$ret$1: do {
          if (this.isEmpty_0_k$()) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }var nmin_1_6 = this.findLeftBound_ha5a7z_k$(min_0);
          var nmax_2_7 = this.findRightBound_ha5a7z_k$(max);
          var inductionVariable = nmin_1_6;
          if (inductionVariable <= nmax_2_7)
            do {
              var n_4_9 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp1__anonymous__5_10 = this._min.getAt_ha5a7z_k$(n_4_9);
              var tmp2__anonymous__5_11 = this._max.getAt_ha5a7z_k$(n_4_9);
              if (this.intersects_w0xdj4_k$(tmp1__anonymous__5_10, tmp2__anonymous__5_11, min_0, max)) {
                if (removeStart_4 === -1)
                  removeStart_4 = n_4_9;
                var tmp = removeStart_4;
                var tmp0_min_0_6_12 = this._min.getAt_ha5a7z_k$(removeStart_4);
                var tmp1_min_0_7_13 = Math.min(tmp1__anonymous__5_10, min_0);
                this._min.set_rvwcgf_k$(tmp, Math.min(tmp0_min_0_6_12, tmp1_min_0_7_13));
                var tmp_0 = removeStart_4;
                var tmp2_max_0_8_14 = this._max.getAt_ha5a7z_k$(removeStart_4);
                var tmp3_max_0_9_15 = Math.max(tmp2__anonymous__5_11, max);
                this._max.set_rvwcgf_k$(tmp_0, Math.max(tmp2_max_0_8_14, tmp3_max_0_9_15));
                var tmp0_10_16 = removeCount_5;
                removeCount_5 = tmp0_10_16 + 1 | 0;
                Unit_getInstance();
              }}
             while (!(n_4_9 === nmax_2_7));
        }
         while (false);
        if (removeCount_5 === 0)
          Unit_getInstance();
        else if (removeCount_5 > 0)
          removeAt(this, removeStart_4 + 1 | 0, removeCount_5);
        else if (max < this._get_minMin__0_k$())
          insertAt(this, 0, min_0, max);
        else if (min_0 > this._get_maxMax__0_k$())
          insertAt(this, this._get_size__0_k$(), min_0, max);
        else {
          var inductionVariable_0 = coerceAtLeast(this.findLeftBound_ha5a7z_k$(min_0), 1);
          var last_1 = this.findRightBound_ha5a7z_k$(max);
          if (inductionVariable_0 <= last_1)
            do {
              var m_18 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var prevMax_19 = this._max.getAt_ha5a7z_k$(m_18 - 1 | 0);
              var currMin_20 = this._min.getAt_ha5a7z_k$(m_18);
              if (min_0 > prevMax_19 ? max < currMin_20 : false) {
                insertAt(this, m_18, min_0, max);
                tmp$ret$2 = Unit_getInstance();
                break l$ret$3;
              }}
             while (!(m_18 === last_1));
          throw IllegalStateException_init_$Create$_0('Unexpected');
        }
      }
    }
     while (false);
    return this;
  };
  IntSegmentSet.prototype.contains_ha5a7z_k$ = function (v) {
    return _BSearchResult___get_found__impl_(this.findNearIndex_quefpa_k$(v));
  };
  IntSegmentSet.prototype.setToIntersect_iwrchs_k$ = function (a, b) {
    var aSmaller_2 = a._get_size__0_k$() < b._get_size__0_k$();
    var av_3 = aSmaller_2 ? a : b;
    var bv_4 = aSmaller_2 ? b : a;
    var tmp0_also_0_5 = this.clear_0_k$();
    var inductionVariable = 0;
    var last_1 = av_3._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n_2_3_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__anonymous__3_4_8 = av_3._min.getAt_ha5a7z_k$(n_2_3_7);
        var tmp1__anonymous__3_5_9 = av_3._max.getAt_ha5a7z_k$(n_2_3_7);
        var count_1_4_6_10 = 0;
        var tmp$ret$0;
        l$ret$1: do {
          if (bv_4.isEmpty_0_k$()) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }var nmin_1_2_5_7_11 = bv_4.findLeftBound_ha5a7z_k$(tmp0__anonymous__3_4_8);
          var nmax_2_3_6_8_12 = bv_4.findRightBound_ha5a7z_k$(tmp1__anonymous__3_5_9);
          var inductionVariable_0 = nmin_1_2_5_7_11;
          if (inductionVariable_0 <= nmax_2_3_6_8_12)
            do {
              var n_4_5_8_10_14 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp0__anonymous__5_6_9_11_15 = bv_4._min.getAt_ha5a7z_k$(n_4_5_8_10_14);
              var tmp1__anonymous__5_7_10_12_16 = bv_4._max.getAt_ha5a7z_k$(n_4_5_8_10_14);
              if (bv_4.intersects_w0xdj4_k$(tmp0__anonymous__5_6_9_11_15, tmp1__anonymous__5_7_10_12_16, tmp0__anonymous__3_4_8, tmp1__anonymous__3_5_9)) {
                var tmp0__anonymous__9_11_13_17 = Math.max(tmp0__anonymous__5_6_9_11_15, tmp0__anonymous__3_4_8);
                var tmp1__anonymous__9_12_14_18 = Math.min(tmp1__anonymous__5_7_10_12_16, tmp1__anonymous__3_5_9);
                this.add_27zxwg_k$(tmp0__anonymous__9_11_13_17, tmp1__anonymous__9_12_14_18);
                Unit_getInstance();
                var tmp0_6_8_13_15_19 = count_1_4_6_10;
                count_1_4_6_10 = tmp0_6_8_13_15_19 + 1 | 0;
                Unit_getInstance();
              }}
             while (!(n_4_5_8_10_14 === nmax_2_3_6_8_12));
        }
         while (false);
        count_1_4_6_10 > 0;
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    Unit_getInstance();
    return this;
  };
  IntSegmentSet.prototype.intersects_w0xdj4_k$ = function (x1, x2, y1, y2) {
    return x2 >= y1 ? y2 >= x1 : false;
  };
  IntSegmentSet.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_uch40_k$('[');
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n_2_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__anonymous__3_5 = this._min.getAt_ha5a7z_k$(n_2_4);
        var tmp1__anonymous__3_6 = this._max.getAt_ha5a7z_k$(n_2_4);
        var first_4_7 = n_2_4 === 0;
        if (!first_4_7) {
          tmp0_apply_0_1.append_uch40_k$(', ');
          Unit_getInstance();
        }tmp0_apply_0_1.append_uch40_k$('' + tmp0__anonymous__3_5 + '-' + tmp1__anonymous__3_6);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp0_apply_0_1.append_uch40_k$(']');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  IntSegmentSet.$metadata$ = {
    simpleName: 'IntSegmentSet',
    kind: 'class',
    interfaces: []
  };
  function ContactFilter() {
  }
  ContactFilter.prototype.shouldCollide_ak8ea_k$ = function (fixtureA, fixtureB) {
    var filterA = fixtureA._get_filterData__0_k$();
    var filterB = fixtureB._get_filterData__0_k$();
    if (filterA._groupIndex === filterB._groupIndex ? !(filterA._groupIndex === 0) : false) {
      return filterA._groupIndex > 0;
    }var collide = !((filterA._maskBits & filterB._categoryBits) === 0) ? !((filterA._categoryBits & filterB._maskBits) === 0) : false;
    return collide;
  };
  ContactFilter.$metadata$ = {
    simpleName: 'ContactFilter',
    kind: 'class',
    interfaces: []
  };
  function ContactImpulse() {
    this._normalImpulses = new Float32Array(Settings_getInstance()._get_maxManifoldPoints__0_k$());
    this._tangentImpulses = new Float32Array(Settings_getInstance()._get_maxManifoldPoints__0_k$());
    this._count_0 = 0;
  }
  ContactImpulse.$metadata$ = {
    simpleName: 'ContactImpulse',
    kind: 'class',
    interfaces: []
  };
  function PairCallback() {
  }
  PairCallback.$metadata$ = {
    simpleName: 'PairCallback',
    kind: 'interface',
    interfaces: []
  };
  function ParticleQueryCallback() {
  }
  ParticleQueryCallback.$metadata$ = {
    simpleName: 'ParticleQueryCallback',
    kind: 'interface',
    interfaces: []
  };
  function QueryCallback() {
  }
  QueryCallback.$metadata$ = {
    simpleName: 'QueryCallback',
    kind: 'interface',
    interfaces: []
  };
  function TreeCallback() {
  }
  TreeCallback.$metadata$ = {
    simpleName: 'TreeCallback',
    kind: 'interface',
    interfaces: []
  };
  function TreeRayCastCallback() {
  }
  TreeRayCastCallback.$metadata$ = {
    simpleName: 'TreeRayCastCallback',
    kind: 'interface',
    interfaces: []
  };
  function AABB_init_$Init$($this) {
    AABB.call($this);
    var tmp = $this;
    tmp._lowerBound = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = $this;
    tmp_0._upperBound = Vec2_init_$Create$(0.0, 0.0, 3, null);
    return $this;
  }
  function AABB_init_$Create$() {
    return AABB_init_$Init$(Object.create(AABB.prototype));
  }
  function Companion_59() {
    Companion_instance_58 = this;
  }
  Companion_59.prototype.testOverlap_m24bo_k$ = function (a, b) {
    if (b._lowerBound._x_7 - a._upperBound._x_7 > 0.0 ? true : b._lowerBound._y_6 - a._upperBound._y_6 > 0.0) {
      return false;
    }var tmp;
    if (a._lowerBound._x_7 - b._upperBound._x_7 > 0.0 ? true : a._lowerBound._y_6 - b._upperBound._y_6 > 0.0) {
      tmp = false;
    } else {
      tmp = true;
    }
    return tmp;
  };
  Companion_59.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_58;
  function Companion_getInstance_58() {
    if (Companion_instance_58 == null)
      new Companion_59();
    return Companion_instance_58;
  }
  AABB.prototype._get_isValid__0_k$ = function () {
    var dx = this._upperBound._x_7 - this._lowerBound._x_7;
    if (dx < 0.0) {
      return false;
    }var dy = this._upperBound._y_6 - this._lowerBound._y_6;
    var tmp;
    if (dy < 0) {
      tmp = false;
    } else {
      tmp = this._lowerBound._get_isValid__0_k$() ? this._upperBound._get_isValid__0_k$() : false;
    }
    return tmp;
  };
  AABB.prototype._get_perimeter__0_k$ = function () {
    return 2.0 * (this._upperBound._x_7 - this._lowerBound._x_7 + this._upperBound._y_6 - this._lowerBound._y_6);
  };
  AABB.prototype.combine_jodcc5_k$ = function (aabb1, aab) {
    this._lowerBound._x_7 = aabb1._lowerBound._x_7 < aab._lowerBound._x_7 ? aabb1._lowerBound._x_7 : aab._lowerBound._x_7;
    this._lowerBound._y_6 = aabb1._lowerBound._y_6 < aab._lowerBound._y_6 ? aabb1._lowerBound._y_6 : aab._lowerBound._y_6;
    this._upperBound._x_7 = aabb1._upperBound._x_7 > aab._upperBound._x_7 ? aabb1._upperBound._x_7 : aab._upperBound._x_7;
    this._upperBound._y_6 = aabb1._upperBound._y_6 > aab._upperBound._y_6 ? aabb1._upperBound._y_6 : aab._upperBound._y_6;
  };
  AABB.prototype.toString = function () {
    var s = '' + 'AABB[' + this._lowerBound + ' . ' + this._upperBound + ']';
    return s;
  };
  function AABB() {
    Companion_getInstance_58();
  }
  AABB.$metadata$ = {
    simpleName: 'AABB',
    kind: 'class',
    interfaces: []
  };
  var Type_UNKNOWN_instance;
  var Type_EDGE_A_instance;
  var Type_EDGE_B_instance;
  var Type_entriesInitialized_0;
  function Type_initEntries_0() {
    if (Type_entriesInitialized_0)
      return Unit_getInstance();
    Type_entriesInitialized_0 = true;
    Type_UNKNOWN_instance = new Type_0('UNKNOWN', 0);
    Type_EDGE_A_instance = new Type_0('EDGE_A', 1);
    Type_EDGE_B_instance = new Type_0('EDGE_B', 2);
  }
  function Type_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_0.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_UNKNOWN_getInstance() {
    Type_initEntries_0();
    return Type_UNKNOWN_instance;
  }
  function Type_EDGE_A_getInstance() {
    Type_initEntries_0();
    return Type_EDGE_A_instance;
  }
  function Type_EDGE_B_getInstance() {
    Type_initEntries_0();
    return Type_EDGE_B_instance;
  }
  function EdgeResults() {
    this._separation = 0;
    this._edgeIndex = 0;
  }
  EdgeResults.$metadata$ = {
    simpleName: 'EdgeResults',
    kind: 'class',
    interfaces: []
  };
  function ClipVertex() {
    var tmp = this;
    tmp._v_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._id_0 = ContactID_init_$Create$();
  }
  ClipVertex.prototype.set_gz4967_k$ = function (cv) {
    var v1 = cv._v_0;
    this._v_0._x_7 = v1._x_7;
    this._v_0._y_6 = v1._y_6;
    var c = cv._id_0;
    this._id_0._indexA = c._indexA;
    this._id_0._indexB = c._indexB;
    this._id_0._typeA = c._typeA;
    this._id_0._typeB = c._typeB;
  };
  ClipVertex.$metadata$ = {
    simpleName: 'ClipVertex',
    kind: 'class',
    interfaces: []
  };
  function EPAxis() {
    this._type_5 = null;
    this._index_10 = 0;
    this._separation_0 = 0;
  }
  EPAxis.$metadata$ = {
    simpleName: 'EPAxis',
    kind: 'class',
    interfaces: []
  };
  function TempPolygon() {
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Settings_getInstance()._get_maxPolygonVertices__0_k$();
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Vec2_init_$Create$(0.0, 0.0, 3, null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._vertices = tmp_2;
    var tmp_4 = this;
    var tmp_5 = 0;
    var tmp_6 = Settings_getInstance()._get_maxPolygonVertices__0_k$();
    var tmp_7 = fillArrayVal(Array(tmp_6), null);
    while (tmp_5 < tmp_6) {
      var tmp_8 = tmp_5;
      tmp_7[tmp_8] = Vec2_init_$Create$(0.0, 0.0, 3, null);
      tmp_5 = tmp_5 + 1 | 0;
    }
    tmp_4._normals = tmp_7;
    this._count_1 = 0;
  }
  TempPolygon.$metadata$ = {
    simpleName: 'TempPolygon',
    kind: 'class',
    interfaces: []
  };
  function ReferenceFace() {
    this._i1 = 0;
    this._i2 = 0;
    var tmp = this;
    tmp._v1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._v2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_1 = this;
    tmp_1._normal = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_2 = this;
    tmp_2._sideNormal1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._sideOffset1 = 0;
    var tmp_3 = this;
    tmp_3._sideNormal2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._sideOffset2 = 0;
  }
  ReferenceFace.$metadata$ = {
    simpleName: 'ReferenceFace',
    kind: 'class',
    interfaces: []
  };
  function EPCollider() {
    this._m_polygonB = new TempPolygon();
    this._m_xf = Transform_init_$Create$_0();
    var tmp = this;
    tmp._m_centroidB = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._m_v0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_1 = this;
    tmp_1._m_v1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_2 = this;
    tmp_2._m_v2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_3 = this;
    tmp_3._m_v3 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_4 = this;
    tmp_4._m_normal0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_5 = this;
    tmp_5._m_normal1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_6 = this;
    tmp_6._m_normal2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_7 = this;
    tmp_7._m_normal = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._m_type1 = null;
    this._m_type2 = null;
    var tmp_8 = this;
    tmp_8._m_lowerLimit = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_9 = this;
    tmp_9._m_upperLimit = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._m_radius = 0;
    this._m_front = false;
    var tmp_10 = this;
    tmp_10._edge1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_11 = this;
    tmp_11._temp_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_12 = this;
    tmp_12._edge0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_13 = this;
    tmp_13._edge2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_14 = this;
    var tmp_15 = 0;
    var tmp_16 = 2;
    var tmp_17 = fillArrayVal(Array(tmp_16), null);
    while (tmp_15 < tmp_16) {
      var tmp_18 = tmp_15;
      tmp_17[tmp_18] = new ClipVertex();
      tmp_15 = tmp_15 + 1 | 0;
    }
    tmp_14._ie = tmp_17;
    var tmp_19 = this;
    var tmp_20 = 0;
    var tmp_21 = 2;
    var tmp_22 = fillArrayVal(Array(tmp_21), null);
    while (tmp_20 < tmp_21) {
      var tmp_23 = tmp_20;
      tmp_22[tmp_23] = new ClipVertex();
      tmp_20 = tmp_20 + 1 | 0;
    }
    tmp_19._clipPoints1 = tmp_22;
    var tmp_24 = this;
    var tmp_25 = 0;
    var tmp_26 = 2;
    var tmp_27 = fillArrayVal(Array(tmp_26), null);
    while (tmp_25 < tmp_26) {
      var tmp_28 = tmp_25;
      tmp_27[tmp_28] = new ClipVertex();
      tmp_25 = tmp_25 + 1 | 0;
    }
    tmp_24._clipPoints2 = tmp_27;
    this._rf = new ReferenceFace();
    this._edgeAxis = new EPAxis();
    this._polygonAxis = new EPAxis();
    var tmp_29 = this;
    tmp_29._perp = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_30 = this;
    tmp_30._n_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_31 = this;
    tmp_31._poolVec2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  EPCollider.prototype.collide_ousgfk_k$ = function (manifold, edgeA, xfA, polygonB, xfB) {
    Companion_getInstance_70().mulTransToOutUnsafe_84z9o3_k$(xfA, xfB, this._m_xf, this._poolVec2);
    Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._m_xf, polygonB._centroid, this._m_centroidB);
    this._m_v0 = edgeA._vertex0;
    this._m_v1 = edgeA._vertex1;
    this._m_v2 = edgeA._vertex2;
    this._m_v3 = edgeA._vertex3;
    var hasVertex0 = edgeA._hasVertex0;
    var hasVertex3 = edgeA._hasVertex3;
    this._edge1.set_1v0asv_k$(this._m_v2).subLocal_1v0asv_k$(this._m_v1);
    Unit_getInstance();
    this._edge1.normalize_0_k$();
    Unit_getInstance();
    this._m_normal1.set_rybm4g_k$(this._edge1._y_6, -this._edge1._x_7);
    Unit_getInstance();
    var offset1 = Companion_getInstance_71().dot_5kvz1c_k$(this._m_normal1, this._temp_0.set_1v0asv_k$(this._m_centroidB).subLocal_1v0asv_k$(this._m_v1));
    var offset0 = 0.0;
    var offset2 = 0.0;
    var convex1 = false;
    var convex2 = false;
    if (hasVertex0) {
      this._edge0.set_1v0asv_k$(this._m_v1).subLocal_1v0asv_k$(this._m_v0);
      Unit_getInstance();
      this._edge0.normalize_0_k$();
      Unit_getInstance();
      this._m_normal0.set_rybm4g_k$(this._edge0._y_6, -this._edge0._x_7);
      Unit_getInstance();
      convex1 = Companion_getInstance_71().cross_5kvz1c_k$(this._edge0, this._edge1) >= 0.0;
      offset0 = Companion_getInstance_71().dot_5kvz1c_k$(this._m_normal0, this._temp_0.set_1v0asv_k$(this._m_centroidB).subLocal_1v0asv_k$(this._m_v0));
    }if (hasVertex3) {
      this._edge2.set_1v0asv_k$(this._m_v3).subLocal_1v0asv_k$(this._m_v2);
      Unit_getInstance();
      this._edge2.normalize_0_k$();
      Unit_getInstance();
      this._m_normal2.set_rybm4g_k$(this._edge2._y_6, -this._edge2._x_7);
      Unit_getInstance();
      convex2 = Companion_getInstance_71().cross_5kvz1c_k$(this._edge1, this._edge2) > 0.0;
      offset2 = Companion_getInstance_71().dot_5kvz1c_k$(this._m_normal2, this._temp_0.set_1v0asv_k$(this._m_centroidB).subLocal_1v0asv_k$(this._m_v2));
    }if (hasVertex0 ? hasVertex3 : false) {
      if (convex1 ? convex2 : false) {
        this._m_front = (offset0 >= 0.0 ? true : offset1 >= 0.0) ? true : offset2 >= 0.0;
        if (this._m_front) {
          this._m_normal._x_7 = this._m_normal1._x_7;
          this._m_normal._y_6 = this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = this._m_normal0._x_7;
          this._m_lowerLimit._y_6 = this._m_normal0._y_6;
          this._m_upperLimit._x_7 = this._m_normal2._x_7;
          this._m_upperLimit._y_6 = this._m_normal2._y_6;
        } else {
          this._m_normal._x_7 = -this._m_normal1._x_7;
          this._m_normal._y_6 = -this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = -this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = -this._m_normal1._y_6;
          this._m_upperLimit._x_7 = -this._m_normal1._x_7;
          this._m_upperLimit._y_6 = -this._m_normal1._y_6;
        }
      } else if (convex1) {
        this._m_front = offset0 >= 0.0 ? true : offset1 >= 0.0 ? offset2 >= 0.0 : false;
        if (this._m_front) {
          this._m_normal._x_7 = this._m_normal1._x_7;
          this._m_normal._y_6 = this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = this._m_normal0._x_7;
          this._m_lowerLimit._y_6 = this._m_normal0._y_6;
          this._m_upperLimit._x_7 = this._m_normal1._x_7;
          this._m_upperLimit._y_6 = this._m_normal1._y_6;
        } else {
          this._m_normal._x_7 = -this._m_normal1._x_7;
          this._m_normal._y_6 = -this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = -this._m_normal2._x_7;
          this._m_lowerLimit._y_6 = -this._m_normal2._y_6;
          this._m_upperLimit._x_7 = -this._m_normal1._x_7;
          this._m_upperLimit._y_6 = -this._m_normal1._y_6;
        }
      } else if (convex2) {
        this._m_front = offset2 >= 0.0 ? true : offset0 >= 0.0 ? offset1 >= 0.0 : false;
        if (this._m_front) {
          this._m_normal._x_7 = this._m_normal1._x_7;
          this._m_normal._y_6 = this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = this._m_normal1._y_6;
          this._m_upperLimit._x_7 = this._m_normal2._x_7;
          this._m_upperLimit._y_6 = this._m_normal2._y_6;
        } else {
          this._m_normal._x_7 = -this._m_normal1._x_7;
          this._m_normal._y_6 = -this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = -this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = -this._m_normal1._y_6;
          this._m_upperLimit._x_7 = -this._m_normal0._x_7;
          this._m_upperLimit._y_6 = -this._m_normal0._y_6;
        }
      } else {
        this._m_front = (offset0 >= 0.0 ? offset1 >= 0.0 : false) ? offset2 >= 0.0 : false;
        if (this._m_front) {
          this._m_normal._x_7 = this._m_normal1._x_7;
          this._m_normal._y_6 = this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = this._m_normal1._y_6;
          this._m_upperLimit._x_7 = this._m_normal1._x_7;
          this._m_upperLimit._y_6 = this._m_normal1._y_6;
        } else {
          this._m_normal._x_7 = -this._m_normal1._x_7;
          this._m_normal._y_6 = -this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = -this._m_normal2._x_7;
          this._m_lowerLimit._y_6 = -this._m_normal2._y_6;
          this._m_upperLimit._x_7 = -this._m_normal0._x_7;
          this._m_upperLimit._y_6 = -this._m_normal0._y_6;
        }
      }
    } else if (hasVertex0) {
      if (convex1) {
        this._m_front = offset0 >= 0.0 ? true : offset1 >= 0.0;
        if (this._m_front) {
          this._m_normal._x_7 = this._m_normal1._x_7;
          this._m_normal._y_6 = this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = this._m_normal0._x_7;
          this._m_lowerLimit._y_6 = this._m_normal0._y_6;
          this._m_upperLimit._x_7 = -this._m_normal1._x_7;
          this._m_upperLimit._y_6 = -this._m_normal1._y_6;
        } else {
          this._m_normal._x_7 = -this._m_normal1._x_7;
          this._m_normal._y_6 = -this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = this._m_normal1._y_6;
          this._m_upperLimit._x_7 = -this._m_normal1._x_7;
          this._m_upperLimit._y_6 = -this._m_normal1._y_6;
        }
      } else {
        this._m_front = offset0 >= 0.0 ? offset1 >= 0.0 : false;
        if (this._m_front) {
          this._m_normal._x_7 = this._m_normal1._x_7;
          this._m_normal._y_6 = this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = this._m_normal1._y_6;
          this._m_upperLimit._x_7 = -this._m_normal1._x_7;
          this._m_upperLimit._y_6 = -this._m_normal1._y_6;
        } else {
          this._m_normal._x_7 = -this._m_normal1._x_7;
          this._m_normal._y_6 = -this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = this._m_normal1._y_6;
          this._m_upperLimit._x_7 = -this._m_normal0._x_7;
          this._m_upperLimit._y_6 = -this._m_normal0._y_6;
        }
      }
    } else if (hasVertex3) {
      if (convex2) {
        this._m_front = offset1 >= 0.0 ? true : offset2 >= 0.0;
        if (this._m_front) {
          this._m_normal._x_7 = this._m_normal1._x_7;
          this._m_normal._y_6 = this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = -this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = -this._m_normal1._y_6;
          this._m_upperLimit._x_7 = this._m_normal2._x_7;
          this._m_upperLimit._y_6 = this._m_normal2._y_6;
        } else {
          this._m_normal._x_7 = -this._m_normal1._x_7;
          this._m_normal._y_6 = -this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = -this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = -this._m_normal1._y_6;
          this._m_upperLimit._x_7 = this._m_normal1._x_7;
          this._m_upperLimit._y_6 = this._m_normal1._y_6;
        }
      } else {
        this._m_front = offset1 >= 0.0 ? offset2 >= 0.0 : false;
        if (this._m_front) {
          this._m_normal._x_7 = this._m_normal1._x_7;
          this._m_normal._y_6 = this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = -this._m_normal1._x_7;
          this._m_lowerLimit._y_6 = -this._m_normal1._y_6;
          this._m_upperLimit._x_7 = this._m_normal1._x_7;
          this._m_upperLimit._y_6 = this._m_normal1._y_6;
        } else {
          this._m_normal._x_7 = -this._m_normal1._x_7;
          this._m_normal._y_6 = -this._m_normal1._y_6;
          this._m_lowerLimit._x_7 = -this._m_normal2._x_7;
          this._m_lowerLimit._y_6 = -this._m_normal2._y_6;
          this._m_upperLimit._x_7 = this._m_normal1._x_7;
          this._m_upperLimit._y_6 = this._m_normal1._y_6;
        }
      }
    } else {
      this._m_front = offset1 >= 0.0;
      if (this._m_front) {
        this._m_normal._x_7 = this._m_normal1._x_7;
        this._m_normal._y_6 = this._m_normal1._y_6;
        this._m_lowerLimit._x_7 = -this._m_normal1._x_7;
        this._m_lowerLimit._y_6 = -this._m_normal1._y_6;
        this._m_upperLimit._x_7 = -this._m_normal1._x_7;
        this._m_upperLimit._y_6 = -this._m_normal1._y_6;
      } else {
        this._m_normal._x_7 = -this._m_normal1._x_7;
        this._m_normal._y_6 = -this._m_normal1._y_6;
        this._m_lowerLimit._x_7 = this._m_normal1._x_7;
        this._m_lowerLimit._y_6 = this._m_normal1._y_6;
        this._m_upperLimit._x_7 = this._m_normal1._x_7;
        this._m_upperLimit._y_6 = this._m_normal1._y_6;
      }
    }
    this._m_polygonB._count_1 = polygonB._count_4;
    var inductionVariable = 0;
    var last_1 = polygonB._count_4;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._m_xf, polygonB._vertices_2[i], this._m_polygonB._vertices[i]);
        Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(this._m_xf._q, polygonB._normals_0[i], this._m_polygonB._normals[i]);
      }
       while (inductionVariable < last_1);
    this._m_radius = 2.0 * Settings_getInstance()._get_polygonRadius__0_k$();
    manifold._pointCount = 0;
    this.computeEdgeSeparation_9rr16f_k$(this._edgeAxis);
    if (equals_1(this._edgeAxis._type_5, Type_UNKNOWN_getInstance())) {
      return Unit_getInstance();
    }if (this._edgeAxis._separation_0 > this._m_radius) {
      return Unit_getInstance();
    }this.computePolygonSeparation_9rr16f_k$(this._polygonAxis);
    if (!equals_1(this._polygonAxis._type_5, Type_UNKNOWN_getInstance()) ? this._polygonAxis._separation_0 > this._m_radius : false) {
      return Unit_getInstance();
    }var k_relativeTol = 0.98;
    var k_absoluteTol = 0.001;
    var primaryAxis;
    if (equals_1(this._polygonAxis._type_5, Type_UNKNOWN_getInstance())) {
      primaryAxis = this._edgeAxis;
    } else if (this._polygonAxis._separation_0 > k_relativeTol * this._edgeAxis._separation_0 + k_absoluteTol) {
      primaryAxis = this._polygonAxis;
    } else {
      primaryAxis = this._edgeAxis;
    }
    var ie0 = this._ie[0];
    var ie1 = this._ie[1];
    if (equals_1(primaryAxis._type_5, Type_EDGE_A_getInstance())) {
      manifold._type_6 = ManifoldType_FACE_A_getInstance();
      var bestIndex = 0;
      var bestValue = Companion_getInstance_71().dot_5kvz1c_k$(this._m_normal, this._m_polygonB._normals[0]);
      var inductionVariable_0 = 1;
      var last_2 = this._m_polygonB._count_1;
      if (inductionVariable_0 < last_2)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var value = Companion_getInstance_71().dot_5kvz1c_k$(this._m_normal, this._m_polygonB._normals[i_0]);
          if (value < bestValue) {
            bestValue = value;
            bestIndex = i_0;
          }}
         while (inductionVariable_0 < last_2);
      var i1 = bestIndex;
      var i2 = (i1 + 1 | 0) < this._m_polygonB._count_1 ? i1 + 1 | 0 : 0;
      ie0._v_0.set_1v0asv_k$(this._m_polygonB._vertices[i1]);
      Unit_getInstance();
      ie0._id_0._indexA = 0;
      ie0._id_0._indexB = toByte(i1);
      ie0._id_0._typeA = toByte(Type_FACE_getInstance()._get_ordinal__0_k$());
      ie0._id_0._typeB = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
      ie1._v_0.set_1v0asv_k$(this._m_polygonB._vertices[i2]);
      Unit_getInstance();
      ie1._id_0._indexA = 0;
      ie1._id_0._indexB = toByte(i2);
      ie1._id_0._typeA = toByte(Type_FACE_getInstance()._get_ordinal__0_k$());
      ie1._id_0._typeB = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
      if (this._m_front) {
        this._rf._i1 = 0;
        this._rf._i2 = 1;
        this._rf._v1.set_1v0asv_k$(this._m_v1);
        Unit_getInstance();
        this._rf._v2.set_1v0asv_k$(this._m_v2);
        Unit_getInstance();
        this._rf._normal.set_1v0asv_k$(this._m_normal1);
        Unit_getInstance();
      } else {
        this._rf._i1 = 1;
        this._rf._i2 = 0;
        this._rf._v1.set_1v0asv_k$(this._m_v2);
        Unit_getInstance();
        this._rf._v2.set_1v0asv_k$(this._m_v1);
        Unit_getInstance();
        this._rf._normal.set_1v0asv_k$(this._m_normal1).negateLocal_0_k$();
        Unit_getInstance();
      }
    } else {
      manifold._type_6 = ManifoldType_FACE_B_getInstance();
      ie0._v_0.set_1v0asv_k$(this._m_v1);
      Unit_getInstance();
      ie0._id_0._indexA = 0;
      ie0._id_0._indexB = toByte(primaryAxis._index_10);
      ie0._id_0._typeA = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
      ie0._id_0._typeB = toByte(Type_FACE_getInstance()._get_ordinal__0_k$());
      ie1._v_0.set_1v0asv_k$(this._m_v2);
      Unit_getInstance();
      ie1._id_0._indexA = 0;
      ie1._id_0._indexB = toByte(primaryAxis._index_10);
      ie1._id_0._typeA = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
      ie1._id_0._typeB = toByte(Type_FACE_getInstance()._get_ordinal__0_k$());
      this._rf._i1 = primaryAxis._index_10;
      this._rf._i2 = (this._rf._i1 + 1 | 0) < this._m_polygonB._count_1 ? this._rf._i1 + 1 | 0 : 0;
      this._rf._v1.set_1v0asv_k$(this._m_polygonB._vertices[this._rf._i1]);
      Unit_getInstance();
      this._rf._v2.set_1v0asv_k$(this._m_polygonB._vertices[this._rf._i2]);
      Unit_getInstance();
      this._rf._normal.set_1v0asv_k$(this._m_polygonB._normals[this._rf._i1]);
      Unit_getInstance();
    }
    this._rf._sideNormal1.set_rybm4g_k$(this._rf._normal._y_6, -this._rf._normal._x_7);
    Unit_getInstance();
    this._rf._sideNormal2.set_1v0asv_k$(this._rf._sideNormal1).negateLocal_0_k$();
    Unit_getInstance();
    this._rf._sideOffset1 = Companion_getInstance_71().dot_5kvz1c_k$(this._rf._sideNormal1, this._rf._v1);
    this._rf._sideOffset2 = Companion_getInstance_71().dot_5kvz1c_k$(this._rf._sideNormal2, this._rf._v2);
    var np;
    np = Companion_getInstance_59().clipSegmentToLine_jk1s62_k$(this._clipPoints1, this._ie, this._rf._sideNormal1, this._rf._sideOffset1, this._rf._i1);
    if (np < Settings_getInstance()._get_maxManifoldPoints__0_k$()) {
      return Unit_getInstance();
    }np = Companion_getInstance_59().clipSegmentToLine_jk1s62_k$(this._clipPoints2, this._clipPoints1, this._rf._sideNormal2, this._rf._sideOffset2, this._rf._i2);
    if (np < Settings_getInstance()._get_maxManifoldPoints__0_k$()) {
      return Unit_getInstance();
    }if (equals_1(primaryAxis._type_5, Type_EDGE_A_getInstance())) {
      manifold._localNormal_0.set_1v0asv_k$(this._rf._normal);
      Unit_getInstance();
      manifold._localPoint.set_1v0asv_k$(this._rf._v1);
      Unit_getInstance();
    } else {
      manifold._localNormal_0.set_1v0asv_k$(polygonB._normals_0[this._rf._i1]);
      Unit_getInstance();
      manifold._localPoint.set_1v0asv_k$(polygonB._vertices_2[this._rf._i1]);
      Unit_getInstance();
    }
    var pointCount = 0;
    var inductionVariable_1 = 0;
    var last_3 = Settings_getInstance()._get_maxManifoldPoints__0_k$();
    if (inductionVariable_1 < last_3)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var separation;
        separation = Companion_getInstance_71().dot_5kvz1c_k$(this._rf._normal, this._temp_0.set_1v0asv_k$(this._clipPoints2[i_1]._v_0).subLocal_1v0asv_k$(this._rf._v1));
        if (separation <= this._m_radius) {
          var cp = manifold._points_2[pointCount];
          if (equals_1(primaryAxis._type_5, Type_EDGE_A_getInstance())) {
            Companion_getInstance_70().mulTransToOutUnsafe_kg26ly_k$(this._m_xf, this._clipPoints2[i_1]._v_0, cp._localPoint_0);
            cp._id_1.set_klywkc_k$(this._clipPoints2[i_1]._id_0);
          } else {
            cp._localPoint_0.set_1v0asv_k$(this._clipPoints2[i_1]._v_0);
            Unit_getInstance();
            cp._id_1._typeA = this._clipPoints2[i_1]._id_0._typeB;
            cp._id_1._typeB = this._clipPoints2[i_1]._id_0._typeA;
            cp._id_1._indexA = this._clipPoints2[i_1]._id_0._indexB;
            cp._id_1._indexB = this._clipPoints2[i_1]._id_0._indexA;
          }
          pointCount = pointCount + 1 | 0;
          Unit_getInstance();
        }}
       while (inductionVariable_1 < last_3);
    manifold._pointCount = pointCount;
  };
  EPCollider.prototype.computeEdgeSeparation_9rr16f_k$ = function (axis) {
    axis._type_5 = Type_EDGE_A_getInstance();
    axis._index_10 = this._m_front ? 0 : 1;
    var tmp = axis;
    FloatCompanionObject_getInstance();
    tmp._separation_0 = 3.4028235E38;
    var nx = this._m_normal._x_7;
    var ny = this._m_normal._y_6;
    var inductionVariable = 0;
    var last_1 = this._m_polygonB._count_1;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this._m_polygonB._vertices[i];
        var tempx = v._x_7 - this._m_v1._x_7;
        var tempy = v._y_6 - this._m_v1._y_6;
        var s = nx * tempx + ny * tempy;
        if (s < axis._separation_0) {
          axis._separation_0 = s;
        }}
       while (inductionVariable < last_1);
  };
  EPCollider.prototype.computePolygonSeparation_9rr16f_k$ = function (axis) {
    axis._type_5 = Type_UNKNOWN_getInstance();
    axis._index_10 = -1;
    var tmp = axis;
    FloatCompanionObject_getInstance();
    tmp._separation_0 = -3.4028235E38;
    this._perp._x_7 = -this._m_normal._y_6;
    this._perp._y_6 = this._m_normal._x_7;
    var inductionVariable = 0;
    var last_1 = this._m_polygonB._count_1;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var normalB = this._m_polygonB._normals[i];
        var vB = this._m_polygonB._vertices[i];
        this._n_0._x_7 = -normalB._x_7;
        this._n_0._y_6 = -normalB._y_6;
        var tempx = vB._x_7 - this._m_v1._x_7;
        var tempy = vB._y_6 - this._m_v1._y_6;
        var s1 = this._n_0._x_7 * tempx + this._n_0._y_6 * tempy;
        tempx = vB._x_7 - this._m_v2._x_7;
        tempy = vB._y_6 - this._m_v2._y_6;
        var s2 = this._n_0._x_7 * tempx + this._n_0._y_6 * tempy;
        var s = Companion_getInstance_68().min_rybm4g_k$(s1, s2);
        if (s > this._m_radius) {
          axis._type_5 = Type_EDGE_B_getInstance();
          axis._index_10 = i;
          axis._separation_0 = s;
          return Unit_getInstance();
        }if (this._n_0._x_7 * this._perp._x_7 + this._n_0._y_6 * this._perp._y_6 >= 0.0) {
          if (Companion_getInstance_71().dot_5kvz1c_k$(this._temp_0.set_1v0asv_k$(this._n_0).subLocal_1v0asv_k$(this._m_upperLimit), this._m_normal) < -Settings_getInstance()._get_angularSlop__0_k$()) {
            continue;
          }} else {
          if (Companion_getInstance_71().dot_5kvz1c_k$(this._temp_0.set_1v0asv_k$(this._n_0).subLocal_1v0asv_k$(this._m_lowerLimit), this._m_normal) < -Settings_getInstance()._get_angularSlop__0_k$()) {
            continue;
          }}
        if (s > axis._separation_0) {
          axis._type_5 = Type_EDGE_B_getInstance();
          axis._index_10 = i;
          axis._separation_0 = s;
        }}
       while (inductionVariable < last_1);
  };
  EPCollider.$metadata$ = {
    simpleName: 'EPCollider',
    kind: 'class',
    interfaces: []
  };
  function Companion_60() {
    Companion_instance_59 = this;
    this._NULL_FEATURE = 2147483647;
  }
  Companion_60.prototype.clipSegmentToLine_jk1s62_k$ = function (vOut, vIn, normal, offset_0, vertexIndexA) {
    var numOut = 0;
    var vIn0 = vIn[0];
    var vIn1 = vIn[1];
    var vIn0v = vIn0._v_0;
    var vIn1v = vIn1._v_0;
    var distance0 = Companion_getInstance_71().dot_5kvz1c_k$(normal, vIn0v) - offset_0;
    var distance1 = Companion_getInstance_71().dot_5kvz1c_k$(normal, vIn1v) - offset_0;
    if (distance0 <= 0.0) {
      var tmp0 = numOut;
      numOut = tmp0 + 1 | 0;
      vOut[tmp0].set_gz4967_k$(vIn0);
    }if (distance1 <= 0.0) {
      var tmp1 = numOut;
      numOut = tmp1 + 1 | 0;
      vOut[tmp1].set_gz4967_k$(vIn1);
    }if (distance0 * distance1 < 0.0) {
      var interp = distance0 / (distance0 - distance1);
      var vOutNO = vOut[numOut];
      vOutNO._v_0._x_7 = vIn0v._x_7 + interp * (vIn1v._x_7 - vIn0v._x_7);
      vOutNO._v_0._y_6 = vIn0v._y_6 + interp * (vIn1v._y_6 - vIn0v._y_6);
      vOutNO._id_0._indexA = toByte(vertexIndexA);
      vOutNO._id_0._indexB = vIn0._id_0._indexB;
      vOutNO._id_0._typeA = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
      vOutNO._id_0._typeB = toByte(Type_FACE_getInstance()._get_ordinal__0_k$());
      numOut = numOut + 1 | 0;
      Unit_getInstance();
    }return numOut;
  };
  Companion_60.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_59;
  function Companion_getInstance_59() {
    if (Companion_instance_59 == null)
      new Companion_60();
    return Companion_instance_59;
  }
  function Collision(pool) {
    Companion_getInstance_59();
    this._pool_1 = pool;
    this._input_0 = new DistanceInput();
    this._cache = new SimplexCache();
    this._output = new DistanceOutput();
    var tmp = this;
    tmp._temp_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._xf = Transform_init_$Create$_0();
    var tmp_0 = this;
    tmp_0._n_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_1 = this;
    tmp_1._v1_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._results1 = new EdgeResults();
    this._results2 = new EdgeResults();
    var tmp_2 = this;
    var tmp_3 = 0;
    var tmp_4 = 2;
    var tmp_5 = fillArrayVal(Array(tmp_4), null);
    while (tmp_3 < tmp_4) {
      var tmp_6 = tmp_3;
      tmp_5[tmp_6] = new ClipVertex();
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_2._incidentEdge = tmp_5;
    var tmp_7 = this;
    tmp_7._localTangent = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_8 = this;
    tmp_8._localNormal = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_9 = this;
    tmp_9._planePoint = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_10 = this;
    tmp_10._tangent = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_11 = this;
    tmp_11._v11 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_12 = this;
    tmp_12._v12 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_13 = this;
    var tmp_14 = 0;
    var tmp_15 = 2;
    var tmp_16 = fillArrayVal(Array(tmp_15), null);
    while (tmp_14 < tmp_15) {
      var tmp_17 = tmp_14;
      tmp_16[tmp_17] = new ClipVertex();
      tmp_14 = tmp_14 + 1 | 0;
    }
    tmp_13._clipPoints1_0 = tmp_16;
    var tmp_18 = this;
    var tmp_19 = 0;
    var tmp_20 = 2;
    var tmp_21 = fillArrayVal(Array(tmp_20), null);
    while (tmp_19 < tmp_20) {
      var tmp_22 = tmp_19;
      tmp_21[tmp_22] = new ClipVertex();
      tmp_19 = tmp_19 + 1 | 0;
    }
    tmp_18._clipPoints2_0 = tmp_21;
    var tmp_23 = this;
    tmp_23._Q = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_24 = this;
    tmp_24._e = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._cf = ContactID_init_$Create$();
    var tmp_25 = this;
    tmp_25._e1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_26 = this;
    tmp_26._P = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._collider = new EPCollider();
    var tmp_27 = this;
    tmp_27._poolVec2_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_28 = this;
    tmp_28._d_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  Collision.prototype.testOverlap_nv312u_k$ = function (shapeA, indexA, shapeB, indexB, xfA, xfB) {
    this._input_0._proxyA.set_qlrvod_k$(shapeA, indexA);
    this._input_0._proxyB.set_qlrvod_k$(shapeB, indexB);
    this._input_0._transformA.set_3pfibf_k$(xfA);
    Unit_getInstance();
    this._input_0._transformB.set_3pfibf_k$(xfB);
    Unit_getInstance();
    this._input_0._useRadii = true;
    this._cache._count_2 = 0;
    this._pool_1._get_distance__0_k$().distance_hqzae0_k$(this._output, this._cache, this._input_0);
    return this._output._distance < 10.0 * Settings_getInstance()._EPSILON;
  };
  Collision.prototype.collideCircles_nsbyyf_k$ = function (manifold, circle1, xfA, circle2, xfB) {
    manifold._pointCount = 0;
    var circle1p = circle1._p_0;
    var circle2p = circle2._p_0;
    var pAx = xfA._q._c_0 * circle1p._x_7 - xfA._q._s * circle1p._y_6 + xfA._p_1._x_7;
    var pAy = xfA._q._s * circle1p._x_7 + xfA._q._c_0 * circle1p._y_6 + xfA._p_1._y_6;
    var pBx = xfB._q._c_0 * circle2p._x_7 - xfB._q._s * circle2p._y_6 + xfB._p_1._x_7;
    var pBy = xfB._q._s * circle2p._x_7 + xfB._q._c_0 * circle2p._y_6 + xfB._p_1._y_6;
    var dx = pBx - pAx;
    var dy = pBy - pAy;
    var distSqr = dx * dx + dy * dy;
    var radius = circle1._get_radius__0_k$() + circle2._get_radius__0_k$();
    if (distSqr > radius * radius) {
      return Unit_getInstance();
    }manifold._type_6 = ManifoldType_CIRCLES_getInstance();
    manifold._localPoint.set_1v0asv_k$(circle1p);
    Unit_getInstance();
    manifold._localNormal_0.setZero_sv8swh_k$();
    manifold._pointCount = 1;
    manifold._points_2[0]._localPoint_0.set_1v0asv_k$(circle2p);
    Unit_getInstance();
    manifold._points_2[0]._id_1.zero_sv8swh_k$();
  };
  Collision.prototype.collidePolygonAndCircle_18q6rj_k$ = function (manifold, polygon_1, xfA, circle_1, xfB) {
    manifold._pointCount = 0;
    var circlep = circle_1._p_0;
    var xfBq = xfB._q;
    var xfAq = xfA._q;
    var cx = xfBq._c_0 * circlep._x_7 - xfBq._s * circlep._y_6 + xfB._p_1._x_7;
    var cy = xfBq._s * circlep._x_7 + xfBq._c_0 * circlep._y_6 + xfB._p_1._y_6;
    var px = cx - xfA._p_1._x_7;
    var py = cy - xfA._p_1._y_6;
    var cLocalx = xfAq._c_0 * px + xfAq._s * py;
    var cLocaly = -xfAq._s * px + xfAq._c_0 * py;
    var normalIndex = 0;
    FloatCompanionObject_getInstance();
    var separation = -3.4028235E38;
    var radius = polygon_1._get_radius__0_k$() + circle_1._get_radius__0_k$();
    var vertexCount = polygon_1._count_4;
    var s;
    var vertices = polygon_1._vertices_2;
    var normals = polygon_1._normals_0;
    var inductionVariable = 0;
    if (inductionVariable < vertexCount)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var vertex = vertices[i];
        var tempx = cLocalx - vertex._x_7;
        var tempy = cLocaly - vertex._y_6;
        s = normals[i]._x_7 * tempx + normals[i]._y_6 * tempy;
        if (s > radius) {
          return Unit_getInstance();
        }if (s > separation) {
          separation = s;
          normalIndex = i;
        }}
       while (inductionVariable < vertexCount);
    var vertIndex1 = normalIndex;
    var vertIndex2 = (vertIndex1 + 1 | 0) < vertexCount ? vertIndex1 + 1 | 0 : 0;
    var v1 = vertices[vertIndex1];
    var v2 = vertices[vertIndex2];
    if (separation < Settings_getInstance()._EPSILON) {
      manifold._pointCount = 1;
      manifold._type_6 = ManifoldType_FACE_A_getInstance();
      var normal = normals[normalIndex];
      manifold._localNormal_0._x_7 = normal._x_7;
      manifold._localNormal_0._y_6 = normal._y_6;
      manifold._localPoint._x_7 = (v1._x_7 + v2._x_7) * 0.5;
      manifold._localPoint._y_6 = (v1._y_6 + v2._y_6) * 0.5;
      var mpoint = manifold._points_2[0];
      mpoint._localPoint_0._x_7 = circlep._x_7;
      mpoint._localPoint_0._y_6 = circlep._y_6;
      mpoint._id_1.zero_sv8swh_k$();
      return Unit_getInstance();
    }var tempX = cLocalx - v1._x_7;
    var tempY = cLocaly - v1._y_6;
    var temp2X = v2._x_7 - v1._x_7;
    var temp2Y = v2._y_6 - v1._y_6;
    var u1 = tempX * temp2X + tempY * temp2Y;
    var temp3X = cLocalx - v2._x_7;
    var temp3Y = cLocaly - v2._y_6;
    var temp4X = v1._x_7 - v2._x_7;
    var temp4Y = v1._y_6 - v2._y_6;
    var u2 = temp3X * temp4X + temp3Y * temp4Y;
    if (u1 <= 0.0) {
      var dx = cLocalx - v1._x_7;
      var dy = cLocaly - v1._y_6;
      if (dx * dx + dy * dy > radius * radius) {
        return Unit_getInstance();
      }manifold._pointCount = 1;
      manifold._type_6 = ManifoldType_FACE_A_getInstance();
      manifold._localNormal_0._x_7 = cLocalx - v1._x_7;
      manifold._localNormal_0._y_6 = cLocaly - v1._y_6;
      manifold._localNormal_0.normalize_0_k$();
      Unit_getInstance();
      manifold._localPoint.set_1v0asv_k$(v1);
      Unit_getInstance();
      manifold._points_2[0]._localPoint_0.set_1v0asv_k$(circlep);
      Unit_getInstance();
      manifold._points_2[0]._id_1.zero_sv8swh_k$();
    } else if (u2 <= 0.0) {
      var dx_0 = cLocalx - v2._x_7;
      var dy_0 = cLocaly - v2._y_6;
      if (dx_0 * dx_0 + dy_0 * dy_0 > radius * radius) {
        return Unit_getInstance();
      }manifold._pointCount = 1;
      manifold._type_6 = ManifoldType_FACE_A_getInstance();
      manifold._localNormal_0._x_7 = cLocalx - v2._x_7;
      manifold._localNormal_0._y_6 = cLocaly - v2._y_6;
      manifold._localNormal_0.normalize_0_k$();
      Unit_getInstance();
      manifold._localPoint.set_1v0asv_k$(v2);
      Unit_getInstance();
      manifold._points_2[0]._localPoint_0.set_1v0asv_k$(circlep);
      Unit_getInstance();
      manifold._points_2[0]._id_1.zero_sv8swh_k$();
    } else {
      var fcx = (v1._x_7 + v2._x_7) * 0.5;
      var fcy = (v1._y_6 + v2._y_6) * 0.5;
      var tx_0 = cLocalx - fcx;
      var ty_0 = cLocaly - fcy;
      var normal_0 = normals[vertIndex1];
      separation = tx_0 * normal_0._x_7 + ty_0 * normal_0._y_6;
      if (separation > radius) {
        return Unit_getInstance();
      }manifold._pointCount = 1;
      manifold._type_6 = ManifoldType_FACE_A_getInstance();
      manifold._localNormal_0.set_1v0asv_k$(normals[vertIndex1]);
      Unit_getInstance();
      manifold._localPoint._x_7 = fcx;
      manifold._localPoint._y_6 = fcy;
      manifold._points_2[0]._localPoint_0.set_1v0asv_k$(circlep);
      Unit_getInstance();
      manifold._points_2[0]._id_1.zero_sv8swh_k$();
    }
  };
  Collision.prototype.findMaxSeparation_9gui7a_k$ = function (results, poly1, xf1, poly2, xf2) {
    var count1 = poly1._count_4;
    var count2 = poly2._count_4;
    var n1s = poly1._normals_0;
    var v1s = poly1._vertices_2;
    var v2s = poly2._vertices_2;
    Companion_getInstance_70().mulTransToOutUnsafe_84z9o3_k$(xf2, xf1, this._xf, this._poolVec2_0);
    var xfq = this._xf._q;
    var bestIndex = 0;
    FloatCompanionObject_getInstance();
    var maxSeparation = -3.4028235E38;
    var inductionVariable = 0;
    if (inductionVariable < count1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(xfq, n1s[i], this._n_1);
        Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xf, v1s[i], this._v1_0);
        FloatCompanionObject_getInstance();
        var si = 3.4028235E38;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < count2)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var v2sj = v2s[j];
            var sij = this._n_1._x_7 * (v2sj._x_7 - this._v1_0._x_7) + this._n_1._y_6 * (v2sj._y_6 - this._v1_0._y_6);
            if (sij < si) {
              si = sij;
            }}
           while (inductionVariable_0 < count2);
        if (si > maxSeparation) {
          maxSeparation = si;
          bestIndex = i;
        }}
       while (inductionVariable < count1);
    results._edgeIndex = bestIndex;
    results._separation = maxSeparation;
  };
  Collision.prototype.findIncidentEdge_cmiglc_k$ = function (c, poly1, xf1, edge1, poly2, xf2) {
    var count1 = poly1._count_4;
    var normals1 = poly1._normals_0;
    var count2 = poly2._count_4;
    var vertices2 = poly2._vertices_2;
    var normals2 = poly2._normals_0;
    var tmp0_assert_0 = 0 <= edge1 ? edge1 < count1 : false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var c0 = c[0];
    var c1 = c[1];
    var xf1q = xf1._q;
    var xf2q = xf2._q;
    var v = normals1[edge1];
    var tempx = xf1q._c_0 * v._x_7 - xf1q._s * v._y_6;
    var tempy = xf1q._s * v._x_7 + xf1q._c_0 * v._y_6;
    var normal1x = xf2q._c_0 * tempx + xf2q._s * tempy;
    var normal1y = -xf2q._s * tempx + xf2q._c_0 * tempy;
    var index_0 = 0;
    FloatCompanionObject_getInstance();
    var minDot = 3.4028235E38;
    var inductionVariable = 0;
    if (inductionVariable < count2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = normals2[i];
        var dot_0 = normal1x * b._x_7 + normal1y * b._y_6;
        if (dot_0 < minDot) {
          minDot = dot_0;
          index_0 = i;
        }}
       while (inductionVariable < count2);
    var i1 = index_0;
    var i2 = (i1 + 1 | 0) < count2 ? i1 + 1 | 0 : 0;
    var v1 = vertices2[i1];
    var out = c0._v_0;
    out._x_7 = xf2q._c_0 * v1._x_7 - xf2q._s * v1._y_6 + xf2._p_1._x_7;
    out._y_6 = xf2q._s * v1._x_7 + xf2q._c_0 * v1._y_6 + xf2._p_1._y_6;
    c0._id_0._indexA = toByte(edge1);
    c0._id_0._indexB = toByte(i1);
    c0._id_0._typeA = toByte(Type_FACE_getInstance()._get_ordinal__0_k$());
    c0._id_0._typeB = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
    var v2 = vertices2[i2];
    var out1 = c1._v_0;
    out1._x_7 = xf2q._c_0 * v2._x_7 - xf2q._s * v2._y_6 + xf2._p_1._x_7;
    out1._y_6 = xf2q._s * v2._x_7 + xf2q._c_0 * v2._y_6 + xf2._p_1._y_6;
    c1._id_0._indexA = toByte(edge1);
    c1._id_0._indexB = toByte(i2);
    c1._id_0._typeA = toByte(Type_FACE_getInstance()._get_ordinal__0_k$());
    c1._id_0._typeB = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
  };
  Collision.prototype.collidePolygons_3luy0j_k$ = function (manifold, polyA, xfA, polyB, xfB) {
    manifold._pointCount = 0;
    var totalRadius = polyA._get_radius__0_k$() + polyB._get_radius__0_k$();
    this.findMaxSeparation_9gui7a_k$(this._results1, polyA, xfA, polyB, xfB);
    if (this._results1._separation > totalRadius) {
      return Unit_getInstance();
    }this.findMaxSeparation_9gui7a_k$(this._results2, polyB, xfB, polyA, xfA);
    if (this._results2._separation > totalRadius) {
      return Unit_getInstance();
    }var poly1;
    var poly2;
    var xf1;
    var xf2;
    var edge1;
    var flip_0;
    var k_tol = 0.1 * Settings_getInstance()._get_linearSlop__0_k$();
    if (this._results2._separation > this._results1._separation + k_tol) {
      poly1 = polyB;
      poly2 = polyA;
      xf1 = xfB;
      xf2 = xfA;
      edge1 = this._results2._edgeIndex;
      manifold._type_6 = ManifoldType_FACE_B_getInstance();
      flip_0 = true;
    } else {
      poly1 = polyA;
      poly2 = polyB;
      xf1 = xfA;
      xf2 = xfB;
      edge1 = this._results1._edgeIndex;
      manifold._type_6 = ManifoldType_FACE_A_getInstance();
      flip_0 = false;
    }
    var xf1q = xf1._q;
    this.findIncidentEdge_cmiglc_k$(this._incidentEdge, poly1, xf1, edge1, poly2, xf2);
    var count1 = poly1._count_4;
    var vertices1 = poly1._vertices_2;
    var iv1 = edge1;
    var iv2 = (edge1 + 1 | 0) < count1 ? edge1 + 1 | 0 : 0;
    this._v11.set_1v0asv_k$(vertices1[iv1]);
    Unit_getInstance();
    this._v12.set_1v0asv_k$(vertices1[iv2]);
    Unit_getInstance();
    this._localTangent._x_7 = this._v12._x_7 - this._v11._x_7;
    this._localTangent._y_6 = this._v12._y_6 - this._v11._y_6;
    this._localTangent.normalize_0_k$();
    Unit_getInstance();
    this._localNormal._x_7 = 1.0 * this._localTangent._y_6;
    this._localNormal._y_6 = -1.0 * this._localTangent._x_7;
    this._planePoint._x_7 = (this._v11._x_7 + this._v12._x_7) * 0.5;
    this._planePoint._y_6 = (this._v11._y_6 + this._v12._y_6) * 0.5;
    this._tangent._x_7 = xf1q._c_0 * this._localTangent._x_7 - xf1q._s * this._localTangent._y_6;
    this._tangent._y_6 = xf1q._s * this._localTangent._x_7 + xf1q._c_0 * this._localTangent._y_6;
    var normalx = 1.0 * this._tangent._y_6;
    var normaly = -1.0 * this._tangent._x_7;
    Companion_getInstance_70().mulToOut_kg26ly_k$(xf1, this._v11, this._v11);
    Companion_getInstance_70().mulToOut_kg26ly_k$(xf1, this._v12, this._v12);
    var frontOffset = normalx * this._v11._x_7 + normaly * this._v11._y_6;
    var sideOffset1 = -(this._tangent._x_7 * this._v11._x_7 + this._tangent._y_6 * this._v11._y_6) + totalRadius;
    var sideOffset2 = this._tangent._x_7 * this._v12._x_7 + this._tangent._y_6 * this._v12._y_6 + totalRadius;
    var np;
    this._tangent.negateLocal_0_k$();
    Unit_getInstance();
    np = Companion_getInstance_59().clipSegmentToLine_jk1s62_k$(this._clipPoints1_0, this._incidentEdge, this._tangent, sideOffset1, iv1);
    this._tangent.negateLocal_0_k$();
    Unit_getInstance();
    if (np < 2) {
      return Unit_getInstance();
    }np = Companion_getInstance_59().clipSegmentToLine_jk1s62_k$(this._clipPoints2_0, this._clipPoints1_0, this._tangent, sideOffset2, iv2);
    if (np < 2) {
      return Unit_getInstance();
    }manifold._localNormal_0.set_1v0asv_k$(this._localNormal);
    Unit_getInstance();
    manifold._localPoint.set_1v0asv_k$(this._planePoint);
    Unit_getInstance();
    var pointCount = 0;
    var inductionVariable = 0;
    var last_1 = Settings_getInstance()._get_maxManifoldPoints__0_k$();
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var separation = normalx * this._clipPoints2_0[i]._v_0._x_7 + normaly * this._clipPoints2_0[i]._v_0._y_6 - frontOffset;
        if (separation <= totalRadius) {
          var cp = manifold._points_2[pointCount];
          var out = cp._localPoint_0;
          var px = this._clipPoints2_0[i]._v_0._x_7 - xf2._p_1._x_7;
          var py = this._clipPoints2_0[i]._v_0._y_6 - xf2._p_1._y_6;
          out._x_7 = xf2._q._c_0 * px + xf2._q._s * py;
          out._y_6 = -xf2._q._s * px + xf2._q._c_0 * py;
          cp._id_1.set_klywkc_k$(this._clipPoints2_0[i]._id_0);
          if (flip_0) {
            cp._id_1.flip_sv8swh_k$();
          }pointCount = pointCount + 1 | 0;
          Unit_getInstance();
        }}
       while (inductionVariable < last_1);
    manifold._pointCount = pointCount;
  };
  Collision.prototype.collideEdgeAndCircle_4g9njw_k$ = function (manifold, edgeA, xfA, circleB, xfB) {
    manifold._pointCount = 0;
    Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(xfB, circleB._p_0, this._temp_1);
    Companion_getInstance_70().mulTransToOutUnsafe_kg26ly_k$(xfA, this._temp_1, this._Q);
    var A = edgeA._vertex1;
    var B = edgeA._vertex2;
    this._e.set_1v0asv_k$(B).subLocal_1v0asv_k$(A);
    Unit_getInstance();
    var u = Companion_getInstance_71().dot_5kvz1c_k$(this._e, this._temp_1.set_1v0asv_k$(B).subLocal_1v0asv_k$(this._Q));
    var v = Companion_getInstance_71().dot_5kvz1c_k$(this._e, this._temp_1.set_1v0asv_k$(this._Q).subLocal_1v0asv_k$(A));
    var radius = edgeA._get_radius__0_k$() + circleB._get_radius__0_k$();
    this._cf._indexB = 0;
    this._cf._typeB = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
    if (v <= 0.0) {
      var P = A;
      this._d_0.set_1v0asv_k$(this._Q).subLocal_1v0asv_k$(P);
      Unit_getInstance();
      var dd = Companion_getInstance_71().dot_5kvz1c_k$(this._d_0, this._d_0);
      if (dd > radius * radius) {
        return Unit_getInstance();
      }if (edgeA._hasVertex0) {
        var A1 = edgeA._vertex0;
        var B1 = A;
        this._e1.set_1v0asv_k$(B1).subLocal_1v0asv_k$(A1);
        Unit_getInstance();
        var u1 = Companion_getInstance_71().dot_5kvz1c_k$(this._e1, this._temp_1.set_1v0asv_k$(B1).subLocal_1v0asv_k$(this._Q));
        if (u1 > 0.0) {
          return Unit_getInstance();
        }}this._cf._indexA = 0;
      this._cf._typeA = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
      manifold._pointCount = 1;
      manifold._type_6 = ManifoldType_CIRCLES_getInstance();
      manifold._localNormal_0.setZero_sv8swh_k$();
      manifold._localPoint.set_1v0asv_k$(P);
      Unit_getInstance();
      manifold._points_2[0]._id_1.set_klywkc_k$(this._cf);
      manifold._points_2[0]._localPoint_0.set_1v0asv_k$(circleB._p_0);
      Unit_getInstance();
      return Unit_getInstance();
    }if (u <= 0.0) {
      var P_0 = B;
      this._d_0.set_1v0asv_k$(this._Q).subLocal_1v0asv_k$(P_0);
      Unit_getInstance();
      var dd_0 = Companion_getInstance_71().dot_5kvz1c_k$(this._d_0, this._d_0);
      if (dd_0 > radius * radius) {
        return Unit_getInstance();
      }if (edgeA._hasVertex3) {
        var B2 = edgeA._vertex3;
        var A2 = B;
        var e2 = this._e1;
        e2.set_1v0asv_k$(B2).subLocal_1v0asv_k$(A2);
        Unit_getInstance();
        var v2 = Companion_getInstance_71().dot_5kvz1c_k$(e2, this._temp_1.set_1v0asv_k$(this._Q).subLocal_1v0asv_k$(A2));
        if (v2 > 0.0) {
          return Unit_getInstance();
        }}this._cf._indexA = 1;
      this._cf._typeA = toByte(Type_VERTEX_getInstance()._get_ordinal__0_k$());
      manifold._pointCount = 1;
      manifold._type_6 = ManifoldType_CIRCLES_getInstance();
      manifold._localNormal_0.setZero_sv8swh_k$();
      manifold._localPoint.set_1v0asv_k$(P_0);
      Unit_getInstance();
      manifold._points_2[0]._id_1.set_klywkc_k$(this._cf);
      manifold._points_2[0]._localPoint_0.set_1v0asv_k$(circleB._p_0);
      Unit_getInstance();
      return Unit_getInstance();
    }var den = Companion_getInstance_71().dot_5kvz1c_k$(this._e, this._e);
    var tmp0_assert_0 = den > 0.0;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }this._P.set_1v0asv_k$(A).mulLocal_dbmacu_k$(u).addLocal_1v0asv_k$(this._temp_1.set_1v0asv_k$(B).mulLocal_dbmacu_k$(v));
    Unit_getInstance();
    this._P.mulLocal_dbmacu_k$(1.0 / den);
    Unit_getInstance();
    this._d_0.set_1v0asv_k$(this._Q).subLocal_1v0asv_k$(this._P);
    Unit_getInstance();
    var dd_1 = Companion_getInstance_71().dot_5kvz1c_k$(this._d_0, this._d_0);
    if (dd_1 > radius * radius) {
      return Unit_getInstance();
    }this._n_1._x_7 = -this._e._y_6;
    this._n_1._y_6 = this._e._x_7;
    if (Companion_getInstance_71().dot_5kvz1c_k$(this._n_1, this._temp_1.set_1v0asv_k$(this._Q).subLocal_1v0asv_k$(A)) < 0.0) {
      this._n_1.set_rybm4g_k$(-this._n_1._x_7, -this._n_1._y_6);
      Unit_getInstance();
    }this._n_1.normalize_0_k$();
    Unit_getInstance();
    this._cf._indexA = 0;
    this._cf._typeA = toByte(Type_FACE_getInstance()._get_ordinal__0_k$());
    manifold._pointCount = 1;
    manifold._type_6 = ManifoldType_FACE_A_getInstance();
    manifold._localNormal_0.set_1v0asv_k$(this._n_1);
    Unit_getInstance();
    manifold._localPoint.set_1v0asv_k$(A);
    Unit_getInstance();
    manifold._points_2[0]._id_1.set_klywkc_k$(this._cf);
    manifold._points_2[0]._localPoint_0.set_1v0asv_k$(circleB._p_0);
    Unit_getInstance();
  };
  Collision.prototype.collideEdgeAndPolygon_ousgfk_k$ = function (manifold, edgeA, xfA, polygonB, xfB) {
    this._collider.collide_ousgfk_k$(manifold, edgeA, xfA, polygonB, xfB);
  };
  Collision.$metadata$ = {
    simpleName: 'Collision',
    kind: 'class',
    interfaces: []
  };
  var Type_VERTEX_instance;
  var Type_FACE_instance;
  var Type_entriesInitialized_1;
  function Type_initEntries_1() {
    if (Type_entriesInitialized_1)
      return Unit_getInstance();
    Type_entriesInitialized_1 = true;
    Type_VERTEX_instance = new Type_1('VERTEX', 0);
    Type_FACE_instance = new Type_1('FACE', 1);
  }
  function Type_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_1.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function ContactID_init_$Init$($this) {
    ContactID.call($this);
    return $this;
  }
  function ContactID_init_$Create$() {
    return ContactID_init_$Init$(Object.create(ContactID.prototype));
  }
  function Type_VERTEX_getInstance() {
    Type_initEntries_1();
    return Type_VERTEX_instance;
  }
  function Type_FACE_getInstance() {
    Type_initEntries_1();
    return Type_FACE_instance;
  }
  ContactID.prototype._get_key__0_k$ = function () {
    return this._indexA << 24 | this._indexB << 16 | this._typeA << 8 | this._typeB;
  };
  ContactID.prototype.isEqual_vmt5qr_k$ = function (cid) {
    return this._get_key__0_k$() === cid._get_key__0_k$();
  };
  ContactID.prototype.set_klywkc_k$ = function (c) {
    this._indexA = c._indexA;
    this._indexB = c._indexB;
    this._typeA = c._typeA;
    this._typeB = c._typeB;
  };
  ContactID.prototype.flip_sv8swh_k$ = function () {
    var tempA = this._indexA;
    this._indexA = this._indexB;
    this._indexB = tempA;
    tempA = this._typeA;
    this._typeA = this._typeB;
    this._typeB = tempA;
  };
  ContactID.prototype.zero_sv8swh_k$ = function () {
    this._indexA = 0;
    this._indexB = 0;
    this._typeA = 0;
    this._typeB = 0;
  };
  ContactID.prototype.compareTo_vmt5qr_k$ = function (o) {
    return this._get_key__0_k$() - o._get_key__0_k$() | 0;
  };
  ContactID.prototype.compareTo_2c5_k$ = function (other) {
    return this.compareTo_vmt5qr_k$(other instanceof ContactID ? other : THROW_CCE());
  };
  function ContactID() {
    this._indexA = 0;
    this._indexB = 0;
    this._typeA = 0;
    this._typeB = 0;
  }
  ContactID.$metadata$ = {
    simpleName: 'ContactID',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Distance_init_$Init$(stats, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      stats = new Stats();
    Distance.call($this, stats);
    return $this;
  }
  function Distance_init_$Create$(stats, $mask0, $marker) {
    return Distance_init_$Init$(stats, $mask0, $marker, Object.create(Distance.prototype));
  }
  function SimplexVertex($outer) {
    this._$this_5 = $outer;
    var tmp = this;
    tmp._wA = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._wB = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_1 = this;
    tmp_1._w_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._a_0 = 0;
    this._indexA_0 = 0;
    this._indexB_0 = 0;
  }
  SimplexVertex.prototype.set_yrsdwr_k$ = function (sv) {
    this._wA.set_1v0asv_k$(sv._wA);
    Unit_getInstance();
    this._wB.set_1v0asv_k$(sv._wB);
    Unit_getInstance();
    this._w_1.set_1v0asv_k$(sv._w_1);
    Unit_getInstance();
    this._a_0 = sv._a_0;
    this._indexA_0 = sv._indexA_0;
    this._indexB_0 = sv._indexB_0;
  };
  SimplexVertex.$metadata$ = {
    simpleName: 'SimplexVertex',
    kind: 'class',
    interfaces: []
  };
  function SimplexCache() {
    this._metric = 0;
    this._count_2 = 0;
    this._indexA_1 = new Int32Array(3);
    this._indexB_1 = new Int32Array(3);
    this._metric = 0.0;
    this._count_2 = 0;
    this._indexA_1[0] = IntCompanionObject_getInstance()._MAX_VALUE_5;
    this._indexA_1[1] = IntCompanionObject_getInstance()._MAX_VALUE_5;
    this._indexA_1[2] = IntCompanionObject_getInstance()._MAX_VALUE_5;
    this._indexB_1[0] = IntCompanionObject_getInstance()._MAX_VALUE_5;
    this._indexB_1[1] = IntCompanionObject_getInstance()._MAX_VALUE_5;
    this._indexB_1[2] = IntCompanionObject_getInstance()._MAX_VALUE_5;
  }
  SimplexCache.$metadata$ = {
    simpleName: 'SimplexCache',
    kind: 'class',
    interfaces: []
  };
  function Simplex($outer) {
    this._$this_6 = $outer;
    this._m_v1_0 = new SimplexVertex(this._$this_6);
    this._m_v2_0 = new SimplexVertex(this._$this_6);
    this._m_v3_0 = new SimplexVertex(this._$this_6);
    var tmp = this;
    var tmp0_arrayOf_0 = [this._m_v1_0, this._m_v2_0, this._m_v3_0];
    tmp._vertices_0 = tmp0_arrayOf_0;
    this._m_count = 0;
    var tmp_0 = this;
    tmp_0._e12 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_1 = this;
    tmp_1._case2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_2 = this;
    tmp_2._case22 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_3 = this;
    tmp_3._case3 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_4 = this;
    tmp_4._case33 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_5 = this;
    tmp_5._e13 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_6 = this;
    tmp_6._e23 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_7 = this;
    tmp_7._w1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_8 = this;
    tmp_8._w2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_9 = this;
    tmp_9._w3 = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  Simplex.prototype._get_metric__0_k$ = function () {
    var tmp0_subject = this._m_count;
    switch (tmp0_subject) {
      case 0:
        {
          var message_2_1 = 'Check failed.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
        }

        return 0.0;
      case 1:
        return 0.0;
      case 2:
        return Companion_getInstance_68().distance_5kvz1c_k$(this._m_v1_0._w_1, this._m_v2_0._w_1);
      case 3:
        this._case3.set_1v0asv_k$(this._m_v2_0._w_1).subLocal_1v0asv_k$(this._m_v1_0._w_1);
        Unit_getInstance();
        this._case33.set_1v0asv_k$(this._m_v3_0._w_1).subLocal_1v0asv_k$(this._m_v1_0._w_1);
        Unit_getInstance();
        return Companion_getInstance_71().cross_5kvz1c_k$(this._case3, this._case33);
      default:{
          var message_2_1_0 = 'Check failed.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
        }

        return 0.0;
    }
  };
  Simplex.prototype.readCache_vnwdgn_k$ = function (cache, proxyA, transformA, proxyB, transformB) {
    var tmp0_assert_0 = cache._count_2 <= 3;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }this._m_count = cache._count_2;
    var inductionVariable = 0;
    var last_1 = this._m_count;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this._vertices_0[i];
        v._indexA_0 = cache._indexA_1[i];
        v._indexB_0 = cache._indexB_1[i];
        var wALocal = proxyA.getVertex_ha5a7z_k$(v._indexA_0);
        var wBLocal = proxyB.getVertex_ha5a7z_k$(v._indexB_0);
        Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(transformA, wALocal, v._wA);
        Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(transformB, wBLocal, v._wB);
        v._w_1.set_1v0asv_k$(v._wB).subLocal_1v0asv_k$(v._wA);
        Unit_getInstance();
        v._a_0 = 0.0;
      }
       while (inductionVariable < last_1);
    if (this._m_count > 1) {
      var metric1 = cache._metric;
      var metric2 = this._get_metric__0_k$();
      if ((metric2 < 0.5 * metric1 ? true : 2.0 * metric1 < metric2) ? true : metric2 < Settings_getInstance()._EPSILON) {
        this._m_count = 0;
      }}if (this._m_count === 0) {
      var v_0 = this._vertices_0[0];
      v_0._indexA_0 = 0;
      v_0._indexB_0 = 0;
      var wALocal_0 = proxyA.getVertex_ha5a7z_k$(0);
      var wBLocal_0 = proxyB.getVertex_ha5a7z_k$(0);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(transformA, wALocal_0, v_0._wA);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(transformB, wBLocal_0, v_0._wB);
      v_0._w_1.set_1v0asv_k$(v_0._wB).subLocal_1v0asv_k$(v_0._wA);
      Unit_getInstance();
      this._m_count = 1;
    }};
  Simplex.prototype.writeCache_ykxnvd_k$ = function (cache) {
    cache._metric = this._get_metric__0_k$();
    cache._count_2 = this._m_count;
    var inductionVariable = 0;
    var last_1 = this._m_count;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        cache._indexA_1[i] = this._vertices_0[i]._indexA_0;
        cache._indexB_1[i] = this._vertices_0[i]._indexB_0;
      }
       while (inductionVariable < last_1);
  };
  Simplex.prototype.getSearchDirection_ftoxb6_k$ = function (out) {
    var tmp0_subject = this._m_count;
    switch (tmp0_subject) {
      case 1:
        out.set_1v0asv_k$(this._m_v1_0._w_1).negateLocal_0_k$();
        Unit_getInstance();
        return Unit_getInstance();
      case 2:
        this._e12.set_1v0asv_k$(this._m_v2_0._w_1).subLocal_1v0asv_k$(this._m_v1_0._w_1);
        Unit_getInstance();
        out.set_1v0asv_k$(this._m_v1_0._w_1).negateLocal_0_k$();
        Unit_getInstance();
        var sgn = Companion_getInstance_71().cross_5kvz1c_k$(this._e12, out);
        if (sgn > 0.0) {
          Companion_getInstance_71().crossToOutUnsafe_ohincz_k$(1.0, this._e12, out);
          return Unit_getInstance();
        } else {
          Companion_getInstance_71().crossToOutUnsafe_6kg5i7_k$(this._e12, 1.0, out);
          return Unit_getInstance();
        }

        break;
      default:{
          var message_2_1 = 'Check failed.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
        }

        out.setZero_sv8swh_k$();
        return Unit_getInstance();
    }
  };
  Simplex.prototype.getClosestPoint_ftoxb6_k$ = function (out) {
    var tmp0_subject = this._m_count;
    switch (tmp0_subject) {
      case 0:
        {
          var message_2_1 = 'Check failed.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
        }

        out.setZero_sv8swh_k$();
        return Unit_getInstance();
      case 1:
        out.set_1v0asv_k$(this._m_v1_0._w_1);
        Unit_getInstance();
        return Unit_getInstance();
      case 2:
        this._case22.set_1v0asv_k$(this._m_v2_0._w_1).mulLocal_dbmacu_k$(this._m_v2_0._a_0);
        Unit_getInstance();
        this._case2.set_1v0asv_k$(this._m_v1_0._w_1).mulLocal_dbmacu_k$(this._m_v1_0._a_0).addLocal_1v0asv_k$(this._case22);
        Unit_getInstance();
        out.set_1v0asv_k$(this._case2);
        Unit_getInstance();
        return Unit_getInstance();
      case 3:
        out.setZero_sv8swh_k$();
        return Unit_getInstance();
      default:{
          var message_2_1_0 = 'Check failed.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
        }

        out.setZero_sv8swh_k$();
        return Unit_getInstance();
    }
  };
  Simplex.prototype.getWitnessPoints_j3n83z_k$ = function (pA, pB) {
    var tmp0_subject = this._m_count;
    switch (tmp0_subject) {
      case 0:
        {
          var message_2_1 = 'Check failed.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
        }

        break;
      case 1:
        pA.set_1v0asv_k$(this._m_v1_0._wA);
        Unit_getInstance();
        pB.set_1v0asv_k$(this._m_v1_0._wB);
        Unit_getInstance();
        break;
      case 2:
        this._case2.set_1v0asv_k$(this._m_v1_0._wA).mulLocal_dbmacu_k$(this._m_v1_0._a_0);
        Unit_getInstance();
        pA.set_1v0asv_k$(this._m_v2_0._wA).mulLocal_dbmacu_k$(this._m_v2_0._a_0).addLocal_1v0asv_k$(this._case2);
        Unit_getInstance();
        this._case2.set_1v0asv_k$(this._m_v1_0._wB).mulLocal_dbmacu_k$(this._m_v1_0._a_0);
        Unit_getInstance();
        pB.set_1v0asv_k$(this._m_v2_0._wB).mulLocal_dbmacu_k$(this._m_v2_0._a_0).addLocal_1v0asv_k$(this._case2);
        Unit_getInstance();
        break;
      case 3:
        pA.set_1v0asv_k$(this._m_v1_0._wA).mulLocal_dbmacu_k$(this._m_v1_0._a_0);
        Unit_getInstance();
        this._case3.set_1v0asv_k$(this._m_v2_0._wA).mulLocal_dbmacu_k$(this._m_v2_0._a_0);
        Unit_getInstance();
        this._case33.set_1v0asv_k$(this._m_v3_0._wA).mulLocal_dbmacu_k$(this._m_v3_0._a_0);
        Unit_getInstance();
        pA.addLocal_1v0asv_k$(this._case3).addLocal_1v0asv_k$(this._case33);
        Unit_getInstance();
        pB.set_1v0asv_k$(pA);
        Unit_getInstance();
        break;
      default:{
          var message_2_1_0 = 'Check failed.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
        }

        break;
    }
  };
  Simplex.prototype.solve2_sv8swh_k$ = function () {
    var w1 = this._m_v1_0._w_1;
    var w2 = this._m_v2_0._w_1;
    this._e12.set_1v0asv_k$(w2).subLocal_1v0asv_k$(w1);
    Unit_getInstance();
    var d12_2 = -Companion_getInstance_71().dot_5kvz1c_k$(w1, this._e12);
    if (d12_2 <= 0.0) {
      this._m_v1_0._a_0 = 1.0;
      this._m_count = 1;
      return Unit_getInstance();
    }var d12_1 = Companion_getInstance_71().dot_5kvz1c_k$(w2, this._e12);
    if (d12_1 <= 0.0) {
      this._m_v2_0._a_0 = 1.0;
      this._m_count = 1;
      this._m_v1_0.set_yrsdwr_k$(this._m_v2_0);
      return Unit_getInstance();
    }var inv_d12 = 1.0 / (d12_1 + d12_2);
    this._m_v1_0._a_0 = d12_1 * inv_d12;
    this._m_v2_0._a_0 = d12_2 * inv_d12;
    this._m_count = 2;
  };
  Simplex.prototype.solve3_sv8swh_k$ = function () {
    this._w1.set_1v0asv_k$(this._m_v1_0._w_1);
    Unit_getInstance();
    this._w2.set_1v0asv_k$(this._m_v2_0._w_1);
    Unit_getInstance();
    this._w3.set_1v0asv_k$(this._m_v3_0._w_1);
    Unit_getInstance();
    this._e12.set_1v0asv_k$(this._w2).subLocal_1v0asv_k$(this._w1);
    Unit_getInstance();
    var w1e12 = Companion_getInstance_71().dot_5kvz1c_k$(this._w1, this._e12);
    var w2e12 = Companion_getInstance_71().dot_5kvz1c_k$(this._w2, this._e12);
    var d12_1 = w2e12;
    var d12_2 = -w1e12;
    this._e13.set_1v0asv_k$(this._w3).subLocal_1v0asv_k$(this._w1);
    Unit_getInstance();
    var w1e13 = Companion_getInstance_71().dot_5kvz1c_k$(this._w1, this._e13);
    var w3e13 = Companion_getInstance_71().dot_5kvz1c_k$(this._w3, this._e13);
    var d13_1 = w3e13;
    var d13_2 = -w1e13;
    this._e23.set_1v0asv_k$(this._w3).subLocal_1v0asv_k$(this._w2);
    Unit_getInstance();
    var w2e23 = Companion_getInstance_71().dot_5kvz1c_k$(this._w2, this._e23);
    var w3e23 = Companion_getInstance_71().dot_5kvz1c_k$(this._w3, this._e23);
    var d23_1 = w3e23;
    var d23_2 = -w2e23;
    var n123 = Companion_getInstance_71().cross_5kvz1c_k$(this._e12, this._e13);
    var d123_1 = n123 * Companion_getInstance_71().cross_5kvz1c_k$(this._w2, this._w3);
    var d123_2 = n123 * Companion_getInstance_71().cross_5kvz1c_k$(this._w3, this._w1);
    var d123_3 = n123 * Companion_getInstance_71().cross_5kvz1c_k$(this._w1, this._w2);
    if (d12_2 <= 0.0 ? d13_2 <= 0.0 : false) {
      this._m_v1_0._a_0 = 1.0;
      this._m_count = 1;
      return Unit_getInstance();
    }if ((d12_1 > 0.0 ? d12_2 > 0.0 : false) ? d123_3 <= 0.0 : false) {
      var inv_d12 = 1.0 / (d12_1 + d12_2);
      this._m_v1_0._a_0 = d12_1 * inv_d12;
      this._m_v2_0._a_0 = d12_2 * inv_d12;
      this._m_count = 2;
      return Unit_getInstance();
    }if ((d13_1 > 0.0 ? d13_2 > 0.0 : false) ? d123_2 <= 0.0 : false) {
      var inv_d13 = 1.0 / (d13_1 + d13_2);
      this._m_v1_0._a_0 = d13_1 * inv_d13;
      this._m_v3_0._a_0 = d13_2 * inv_d13;
      this._m_count = 2;
      this._m_v2_0.set_yrsdwr_k$(this._m_v3_0);
      return Unit_getInstance();
    }if (d12_1 <= 0.0 ? d23_2 <= 0.0 : false) {
      this._m_v2_0._a_0 = 1.0;
      this._m_count = 1;
      this._m_v1_0.set_yrsdwr_k$(this._m_v2_0);
      return Unit_getInstance();
    }if (d13_1 <= 0.0 ? d23_1 <= 0.0 : false) {
      this._m_v3_0._a_0 = 1.0;
      this._m_count = 1;
      this._m_v1_0.set_yrsdwr_k$(this._m_v3_0);
      return Unit_getInstance();
    }if ((d23_1 > 0.0 ? d23_2 > 0.0 : false) ? d123_1 <= 0.0 : false) {
      var inv_d23 = 1.0 / (d23_1 + d23_2);
      this._m_v2_0._a_0 = d23_1 * inv_d23;
      this._m_v3_0._a_0 = d23_2 * inv_d23;
      this._m_count = 2;
      this._m_v1_0.set_yrsdwr_k$(this._m_v3_0);
      return Unit_getInstance();
    }var inv_d123 = 1.0 / (d123_1 + d123_2 + d123_3);
    this._m_v1_0._a_0 = d123_1 * inv_d123;
    this._m_v2_0._a_0 = d123_2 * inv_d123;
    this._m_v3_0._a_0 = d123_3 * inv_d123;
    this._m_count = 3;
  };
  Simplex.$metadata$ = {
    simpleName: 'Simplex',
    kind: 'class',
    interfaces: []
  };
  function DistanceProxy() {
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Settings_getInstance()._get_maxPolygonVertices__0_k$();
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Vec2_init_$Create$(0.0, 0.0, 3, null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._m_vertices = tmp_2;
    this._vertexCount = 0;
    this._m_radius_0 = 0.0;
    var tmp_4 = this;
    var tmp_5 = 0;
    var tmp_6 = 2;
    var tmp_7 = fillArrayVal(Array(tmp_6), null);
    while (tmp_5 < tmp_6) {
      var tmp_8 = tmp_5;
      tmp_7[tmp_8] = Vec2_init_$Create$(0.0, 0.0, 3, null);
      tmp_5 = tmp_5 + 1 | 0;
    }
    tmp_4._m_buffer = tmp_7;
  }
  DistanceProxy.prototype.set_qlrvod_k$ = function (shape, index_0) {
    var tmp0_subject = shape.getType_0_k$();
    if (tmp0_subject.equals(ShapeType_CIRCLE_getInstance())) {
      var circle_1 = shape instanceof CircleShape ? shape : THROW_CCE();
      this._m_vertices[0].set_1v0asv_k$(circle_1._p_0);
      Unit_getInstance();
      this._vertexCount = 1;
      this._m_radius_0 = circle_1._get_radius__0_k$();
    } else if (tmp0_subject.equals(ShapeType_POLYGON_getInstance())) {
      var poly = shape instanceof PolygonShape ? shape : THROW_CCE();
      this._vertexCount = poly._count_4;
      this._m_radius_0 = poly._get_radius__0_k$();
      var inductionVariable = 0;
      var last_1 = this._vertexCount;
      if (inductionVariable < last_1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this._m_vertices[i].set_1v0asv_k$(poly._vertices_2[i]);
          Unit_getInstance();
        }
         while (inductionVariable < last_1);
    } else if (tmp0_subject.equals(ShapeType_CHAIN_getInstance())) {
      var chain = shape instanceof ChainShape ? shape : THROW_CCE();
      var tmp0_assert_0 = 0 <= index_0 ? index_0 < chain._count_3 : false;
      if (!tmp0_assert_0) {
        var message_2_1 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
      }this._m_buffer[0] = ensureNotNull(chain._vertices_1)[index_0];
      if ((index_0 + 1 | 0) < chain._count_3) {
        this._m_buffer[1] = ensureNotNull(chain._vertices_1)[index_0 + 1 | 0];
      } else {
        this._m_buffer[1] = ensureNotNull(chain._vertices_1)[0];
      }
      this._m_vertices[0].set_1v0asv_k$(this._m_buffer[0]);
      Unit_getInstance();
      this._m_vertices[1].set_1v0asv_k$(this._m_buffer[1]);
      Unit_getInstance();
      this._vertexCount = 2;
      this._m_radius_0 = chain._get_radius__0_k$();
    } else if (tmp0_subject.equals(ShapeType_EDGE_getInstance())) {
      var edge = shape instanceof EdgeShape ? shape : THROW_CCE();
      this._m_vertices[0].set_1v0asv_k$(edge._vertex1);
      Unit_getInstance();
      this._m_vertices[1].set_1v0asv_k$(edge._vertex2);
      Unit_getInstance();
      this._vertexCount = 2;
      this._m_radius_0 = edge._get_radius__0_k$();
    } else {
      {
        var message_2_1_0 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
      }
    }
  };
  DistanceProxy.prototype.getSupport_1v0asv_k$ = function (d) {
    var bestIndex = 0;
    var bestValue = Companion_getInstance_71().dot_5kvz1c_k$(this._m_vertices[0], d);
    var inductionVariable = 1;
    var last_1 = this._vertexCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var value = Companion_getInstance_71().dot_5kvz1c_k$(this._m_vertices[i], d);
        if (value > bestValue) {
          bestIndex = i;
          bestValue = value;
        }}
       while (inductionVariable < last_1);
    return bestIndex;
  };
  DistanceProxy.prototype.getVertex_ha5a7z_k$ = function (index_0) {
    var tmp0_assert_0 = 0 <= index_0 ? index_0 < this._vertexCount : false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }return this._m_vertices[index_0];
  };
  DistanceProxy.$metadata$ = {
    simpleName: 'DistanceProxy',
    kind: 'class',
    interfaces: []
  };
  function Companion_61() {
    Companion_instance_60 = this;
    this._MAX_ITERS = 20;
  }
  Companion_61.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_60;
  function Companion_getInstance_60() {
    if (Companion_instance_60 == null)
      new Companion_61();
    return Companion_instance_60;
  }
  function Stats() {
    this._GJK_CALLS = 0;
    this._GJK_ITERS = 0;
    this._GJK_MAX_ITERS = 20;
  }
  Stats.$metadata$ = {
    simpleName: 'Stats',
    kind: 'class',
    interfaces: []
  };
  function Distance(stats) {
    Companion_getInstance_60();
    this._stats = stats;
    this._simplex = new Simplex(this);
    this._saveA = new Int32Array(3);
    this._saveB = new Int32Array(3);
    var tmp = this;
    tmp._closestPoint = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._d_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_1 = this;
    tmp_1._temp_2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_2 = this;
    tmp_2._normal_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  Distance.prototype.distance_hqzae0_k$ = function (output_0, cache, input) {
    var tmp0_this = this._stats;
    var tmp1 = tmp0_this._GJK_CALLS;
    tmp0_this._GJK_CALLS = tmp1 + 1 | 0;
    Unit_getInstance();
    var proxyA = input._proxyA;
    var proxyB = input._proxyB;
    var transformA = input._transformA;
    var transformB = input._transformB;
    this._simplex.readCache_vnwdgn_k$(cache, proxyA, transformA, proxyB, transformB);
    var vertices = this._simplex._vertices_0;
    var saveCount = 0;
    this._simplex.getClosestPoint_ftoxb6_k$(this._closestPoint);
    var distanceSqr1 = this._closestPoint.lengthSquared_0_k$();
    var distanceSqr2 = distanceSqr1;
    var iter = 0;
    $l$break_2: while (iter < Companion_getInstance_60()._MAX_ITERS) {
      saveCount = this._simplex._m_count;
      var inductionVariable = 0;
      if (inductionVariable < saveCount)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this._saveA[i] = vertices[i]._indexA_0;
          this._saveB[i] = vertices[i]._indexB_0;
        }
         while (inductionVariable < saveCount);
      var tmp3_subject = this._simplex._m_count;
      switch (tmp3_subject) {
        case 1:
          break;
        case 2:
          this._simplex.solve2_sv8swh_k$();
          break;
        case 3:
          this._simplex.solve3_sv8swh_k$();
          break;
        default:{
            var message_2_1 = 'Check failed.';
            throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
          }

          break;
      }
      if (this._simplex._m_count === 3) {
        break $l$break_2;
      }this._simplex.getClosestPoint_ftoxb6_k$(this._closestPoint);
      distanceSqr2 = this._closestPoint.lengthSquared_0_k$();
      if (distanceSqr2 >= distanceSqr1) {
      }distanceSqr1 = distanceSqr2;
      this._simplex.getSearchDirection_ftoxb6_k$(this._d_1);
      if (this._d_1.lengthSquared_0_k$() < Settings_getInstance()._EPSILON * Settings_getInstance()._EPSILON) {
        break $l$break_2;
      }var vertex = vertices[this._simplex._m_count];
      Companion_getInstance_69().mulTransUnsafe_6ywscr_k$(transformA._q, this._d_1.negateLocal_0_k$(), this._temp_2);
      vertex._indexA_0 = proxyA.getSupport_1v0asv_k$(this._temp_2);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(transformA, proxyA.getVertex_ha5a7z_k$(vertex._indexA_0), vertex._wA);
      Companion_getInstance_69().mulTransUnsafe_6ywscr_k$(transformB._q, this._d_1.negateLocal_0_k$(), this._temp_2);
      vertex._indexB_0 = proxyB.getSupport_1v0asv_k$(this._temp_2);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(transformB, proxyB.getVertex_ha5a7z_k$(vertex._indexB_0), vertex._wB);
      vertex._w_1.set_1v0asv_k$(vertex._wB).subLocal_1v0asv_k$(vertex._wA);
      Unit_getInstance();
      iter = iter + 1 | 0;
      Unit_getInstance();
      var tmp4_this = this._stats;
      tmp4_this._GJK_ITERS = tmp4_this._GJK_ITERS + 1 | 0;
      Unit_getInstance();
      var duplicate = false;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < saveCount)
        $l$break_1: do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (vertex._indexA_0 === this._saveA[i_0] ? vertex._indexB_0 === this._saveB[i_0] : false) {
            duplicate = true;
            break $l$break_1;
          }}
         while (inductionVariable_0 < saveCount);
      if (duplicate) {
        break $l$break_2;
      }var tmp6_this = this._simplex;
      tmp6_this._m_count = tmp6_this._m_count + 1 | 0;
      Unit_getInstance();
    }
    this._stats._GJK_MAX_ITERS = Companion_getInstance_68().max_27zxwg_k$(this._stats._GJK_MAX_ITERS, iter);
    this._simplex.getWitnessPoints_j3n83z_k$(output_0._pointA, output_0._pointB);
    output_0._distance = Companion_getInstance_68().distance_5kvz1c_k$(output_0._pointA, output_0._pointB);
    output_0._iterations = iter;
    this._simplex.writeCache_ykxnvd_k$(cache);
    if (input._useRadii) {
      var rA = proxyA._m_radius_0;
      var rB = proxyB._m_radius_0;
      if (output_0._distance > rA + rB ? output_0._distance > Settings_getInstance()._EPSILON : false) {
        var tmp7_this = output_0;
        tmp7_this._distance = tmp7_this._distance - (rA + rB);
        this._normal_0.set_1v0asv_k$(output_0._pointB).subLocal_1v0asv_k$(output_0._pointA);
        Unit_getInstance();
        this._normal_0.normalize_0_k$();
        Unit_getInstance();
        this._temp_2.set_1v0asv_k$(this._normal_0).mulLocal_dbmacu_k$(rA);
        Unit_getInstance();
        output_0._pointA.addLocal_1v0asv_k$(this._temp_2);
        Unit_getInstance();
        this._temp_2.set_1v0asv_k$(this._normal_0).mulLocal_dbmacu_k$(rB);
        Unit_getInstance();
        output_0._pointB.subLocal_1v0asv_k$(this._temp_2);
        Unit_getInstance();
      } else {
        output_0._pointA.addLocal_1v0asv_k$(output_0._pointB).mulLocal_dbmacu_k$(0.5);
        Unit_getInstance();
        output_0._pointB.set_1v0asv_k$(output_0._pointA);
        Unit_getInstance();
        output_0._distance = 0.0;
      }
    }};
  Distance.$metadata$ = {
    simpleName: 'Distance',
    kind: 'class',
    interfaces: []
  };
  function DistanceInput() {
    this._proxyA = new DistanceProxy();
    this._proxyB = new DistanceProxy();
    this._transformA = Transform_init_$Create$_0();
    this._transformB = Transform_init_$Create$_0();
    this._useRadii = false;
  }
  DistanceInput.$metadata$ = {
    simpleName: 'DistanceInput',
    kind: 'class',
    interfaces: []
  };
  function DistanceOutput() {
    var tmp = this;
    tmp._pointA = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._pointB = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._distance = 0;
    this._iterations = 0;
  }
  DistanceOutput.$metadata$ = {
    simpleName: 'DistanceOutput',
    kind: 'class',
    interfaces: []
  };
  var ManifoldType_CIRCLES_instance;
  var ManifoldType_FACE_A_instance;
  var ManifoldType_FACE_B_instance;
  var ManifoldType_entriesInitialized;
  function ManifoldType_initEntries() {
    if (ManifoldType_entriesInitialized)
      return Unit_getInstance();
    ManifoldType_entriesInitialized = true;
    ManifoldType_CIRCLES_instance = new ManifoldType('CIRCLES', 0);
    ManifoldType_FACE_A_instance = new ManifoldType('FACE_A', 1);
    ManifoldType_FACE_B_instance = new ManifoldType('FACE_B', 2);
  }
  function ManifoldType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  ManifoldType.$metadata$ = {
    simpleName: 'ManifoldType',
    kind: 'class',
    interfaces: []
  };
  function Manifold_init_$Init$($this) {
    Manifold.call($this);
    var tmp = $this;
    var tmp_0 = 0;
    var tmp_1 = Settings_getInstance()._get_maxManifoldPoints__0_k$();
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = ManifoldPoint_init_$Create$();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._points_2 = tmp_2;
    var tmp_4 = $this;
    tmp_4._localNormal_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_5 = $this;
    tmp_5._localPoint = Vec2_init_$Create$(0.0, 0.0, 3, null);
    $this._pointCount = 0;
    return $this;
  }
  function Manifold_init_$Create$() {
    return Manifold_init_$Init$(Object.create(Manifold.prototype));
  }
  function ManifoldType_CIRCLES_getInstance() {
    ManifoldType_initEntries();
    return ManifoldType_CIRCLES_instance;
  }
  function ManifoldType_FACE_A_getInstance() {
    ManifoldType_initEntries();
    return ManifoldType_FACE_A_instance;
  }
  function ManifoldType_FACE_B_getInstance() {
    ManifoldType_initEntries();
    return ManifoldType_FACE_B_instance;
  }
  Manifold.prototype.set_d0p1al_k$ = function (cp) {
    var inductionVariable = 0;
    var last_1 = cp._pointCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._points_2[i].set_a0ffpb_k$(cp._points_2[i]);
      }
       while (inductionVariable < last_1);
    this._type_6 = cp._type_6;
    this._localNormal_0.set_1v0asv_k$(cp._localNormal_0);
    Unit_getInstance();
    this._localPoint.set_1v0asv_k$(cp._localPoint);
    Unit_getInstance();
    this._pointCount = cp._pointCount;
  };
  function Manifold() {
    this._type_6 = ManifoldType_CIRCLES_getInstance();
    this._pointCount = 0;
  }
  Manifold.$metadata$ = {
    simpleName: 'Manifold',
    kind: 'class',
    interfaces: []
  };
  function ManifoldPoint_init_$Init$($this) {
    ManifoldPoint.call($this);
    var tmp = $this;
    tmp._localPoint_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    $this._tangentImpulse = 0.0;
    $this._normalImpulse = $this._tangentImpulse;
    $this._id_1 = ContactID_init_$Create$();
    return $this;
  }
  function ManifoldPoint_init_$Create$() {
    return ManifoldPoint_init_$Init$(Object.create(ManifoldPoint.prototype));
  }
  ManifoldPoint.prototype.set_a0ffpb_k$ = function (cp) {
    this._localPoint_0.set_1v0asv_k$(cp._localPoint_0);
    Unit_getInstance();
    this._normalImpulse = cp._normalImpulse;
    this._tangentImpulse = cp._tangentImpulse;
    this._id_1.set_klywkc_k$(cp._id_1);
  };
  function ManifoldPoint() {
    this._normalImpulse = 0;
    this._tangentImpulse = 0;
  }
  ManifoldPoint.$metadata$ = {
    simpleName: 'ManifoldPoint',
    kind: 'class',
    interfaces: []
  };
  function RayCastInput() {
    this._maxFraction = 0;
    var tmp = this;
    tmp._p1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._p2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._maxFraction = 0.0;
  }
  RayCastInput.$metadata$ = {
    simpleName: 'RayCastInput',
    kind: 'class',
    interfaces: []
  };
  function RayCastOutput() {
    this._fraction = 0;
    var tmp = this;
    tmp._normal_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._fraction = 0.0;
  }
  RayCastOutput.$metadata$ = {
    simpleName: 'RayCastOutput',
    kind: 'class',
    interfaces: []
  };
  var TOIOutputState_UNKNOWN_instance;
  var TOIOutputState_FAILED_instance;
  var TOIOutputState_OVERLAPPED_instance;
  var TOIOutputState_TOUCHING_instance;
  var TOIOutputState_SEPARATED_instance;
  var TOIOutputState_entriesInitialized;
  function TOIOutputState_initEntries() {
    if (TOIOutputState_entriesInitialized)
      return Unit_getInstance();
    TOIOutputState_entriesInitialized = true;
    TOIOutputState_UNKNOWN_instance = new TOIOutputState('UNKNOWN', 0);
    TOIOutputState_FAILED_instance = new TOIOutputState('FAILED', 1);
    TOIOutputState_OVERLAPPED_instance = new TOIOutputState('OVERLAPPED', 2);
    TOIOutputState_TOUCHING_instance = new TOIOutputState('TOUCHING', 3);
    TOIOutputState_SEPARATED_instance = new TOIOutputState('SEPARATED', 4);
  }
  function TimeOfImpact_init_$Init$(pool, stats, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      stats = new Stats_0();
    TimeOfImpact.call($this, pool, stats);
    return $this;
  }
  function TimeOfImpact_init_$Create$(pool, stats, $mask0, $marker) {
    return TimeOfImpact_init_$Init$(pool, stats, $mask0, $marker, Object.create(TimeOfImpact.prototype));
  }
  function TOIInput() {
    this._proxyA_0 = new DistanceProxy();
    this._proxyB_0 = new DistanceProxy();
    this._sweepA = new Sweep();
    this._sweepB = new Sweep();
    this._tMax = 0;
  }
  TOIInput.$metadata$ = {
    simpleName: 'TOIInput',
    kind: 'class',
    interfaces: []
  };
  function TOIOutputState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  TOIOutputState.$metadata$ = {
    simpleName: 'TOIOutputState',
    kind: 'class',
    interfaces: []
  };
  function TOIOutput() {
    this._state_2 = null;
    this._t = 0;
  }
  TOIOutput.$metadata$ = {
    simpleName: 'TOIOutput',
    kind: 'class',
    interfaces: []
  };
  function Companion_62() {
    Companion_instance_61 = this;
    this._MAX_ITERATIONS = 20;
    this._MAX_ROOT_ITERATIONS = 50;
  }
  Companion_62.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_61;
  function Companion_getInstance_61() {
    if (Companion_instance_61 == null)
      new Companion_62();
    return Companion_instance_61;
  }
  function Stats_0() {
    this._toiCalls = 0;
    this._toiIters = 0;
    this._toiMaxIters = 0;
    this._toiRootIters = 0;
    this._toiMaxRootIters = 0;
  }
  Stats_0.$metadata$ = {
    simpleName: 'Stats',
    kind: 'class',
    interfaces: []
  };
  function TOIOutputState_UNKNOWN_getInstance() {
    TOIOutputState_initEntries();
    return TOIOutputState_UNKNOWN_instance;
  }
  function TOIOutputState_FAILED_getInstance() {
    TOIOutputState_initEntries();
    return TOIOutputState_FAILED_instance;
  }
  function TOIOutputState_OVERLAPPED_getInstance() {
    TOIOutputState_initEntries();
    return TOIOutputState_OVERLAPPED_instance;
  }
  function TOIOutputState_TOUCHING_getInstance() {
    TOIOutputState_initEntries();
    return TOIOutputState_TOUCHING_instance;
  }
  function TOIOutputState_SEPARATED_getInstance() {
    TOIOutputState_initEntries();
    return TOIOutputState_SEPARATED_instance;
  }
  function TimeOfImpact(pool, stats) {
    Companion_getInstance_61();
    this._pool_2 = pool;
    this._stats_0 = stats;
    this._cache_0 = new SimplexCache();
    this._distanceInput = new DistanceInput();
    this._xfA = Transform_init_$Create$_0();
    this._xfB = Transform_init_$Create$_0();
    this._distanceOutput = new DistanceOutput();
    this._fcn = new SeparationFunction();
    this._indexes = new Int32Array(2);
    this._sweepA_0 = new Sweep();
    this._sweepB_0 = new Sweep();
  }
  TimeOfImpact.prototype.timeOfImpact_808z7q_k$ = function (output_0, input) {
    var tmp0_this = this._stats_0;
    tmp0_this._toiCalls = tmp0_this._toiCalls + 1 | 0;
    Unit_getInstance();
    output_0._state_2 = TOIOutputState_UNKNOWN_getInstance();
    output_0._t = input._tMax;
    var proxyA = input._proxyA_0;
    var proxyB = input._proxyB_0;
    this._sweepA_0.set_dd6kcl_k$(input._sweepA);
    Unit_getInstance();
    this._sweepB_0.set_dd6kcl_k$(input._sweepB);
    Unit_getInstance();
    this._sweepA_0.normalize_sv8swh_k$();
    this._sweepB_0.normalize_sv8swh_k$();
    var tMax = input._tMax;
    var totalRadius = proxyA._m_radius_0 + proxyB._m_radius_0;
    var target = Companion_getInstance_68().max_rybm4g_k$(Settings_getInstance()._get_linearSlop__0_k$(), totalRadius - 3.0 * Settings_getInstance()._get_linearSlop__0_k$());
    var tolerance = 0.25 * Settings_getInstance()._get_linearSlop__0_k$();
    var tmp0_assert_0 = target > tolerance;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var t1 = 0.0;
    var iter = 0;
    this._cache_0._count_2 = 0;
    this._distanceInput._proxyA = input._proxyA_0;
    this._distanceInput._proxyB = input._proxyB_0;
    this._distanceInput._useRadii = false;
    $l$break_9: while (true) {
      this._sweepA_0.getTransform_il1pfm_k$(this._xfA, t1);
      this._sweepB_0.getTransform_il1pfm_k$(this._xfB, t1);
      this._distanceInput._transformA = this._xfA;
      this._distanceInput._transformB = this._xfB;
      this._pool_2._get_distance__0_k$().distance_hqzae0_k$(this._distanceOutput, this._cache_0, this._distanceInput);
      if (this._distanceOutput._distance <= 0.0) {
        output_0._state_2 = TOIOutputState_OVERLAPPED_getInstance();
        output_0._t = 0.0;
        break $l$break_9;
      }if (this._distanceOutput._distance < target + tolerance) {
        output_0._state_2 = TOIOutputState_TOUCHING_getInstance();
        output_0._t = t1;
        break $l$break_9;
      }this._fcn.initialize_78ozjw_k$(this._cache_0, proxyA, this._sweepA_0, proxyB, this._sweepB_0, t1);
      Unit_getInstance();
      var done = false;
      var t2 = tMax;
      var pushBackIter = 0;
      $l$break_7: while (true) {
        var s2 = this._fcn.findMinSeparation_vcjpjq_k$(this._indexes, t2);
        if (s2 > target + tolerance) {
          output_0._state_2 = TOIOutputState_SEPARATED_getInstance();
          output_0._t = tMax;
          done = true;
          break $l$break_7;
        }if (s2 > target - tolerance) {
          t1 = t2;
          break $l$break_7;
        }var s1 = this._fcn.evaluate_ex40b2_k$(this._indexes[0], this._indexes[1], t1);
        if (s1 < target - tolerance) {
          output_0._state_2 = TOIOutputState_FAILED_getInstance();
          output_0._t = t1;
          done = true;
          break $l$break_7;
        }if (s1 <= target + tolerance) {
          output_0._state_2 = TOIOutputState_TOUCHING_getInstance();
          output_0._t = t1;
          done = true;
          break $l$break_7;
        }var rootIterCount = 0;
        var a1 = t1;
        var a2 = t2;
        $l$break_6: while (true) {
          var t;
          if ((rootIterCount & 1) === 1) {
            t = a1 + (target - s1) * (a2 - a1) / (s2 - s1);
          } else {
            t = 0.5 * (a1 + a2);
          }
          rootIterCount = rootIterCount + 1 | 0;
          Unit_getInstance();
          var tmp1_this = this._stats_0;
          tmp1_this._toiRootIters = tmp1_this._toiRootIters + 1 | 0;
          Unit_getInstance();
          var s = this._fcn.evaluate_ex40b2_k$(this._indexes[0], this._indexes[1], t);
          if (Companion_getInstance_68().abs_dbmacu_k$(s - target) < tolerance) {
            t2 = t;
            break $l$break_6;
          }if (s > target) {
            a1 = t;
            s1 = s;
          } else {
            a2 = t;
            s2 = s;
          }
          if (rootIterCount === Companion_getInstance_61()._MAX_ROOT_ITERATIONS) {
            break $l$break_6;
          }}
        this._stats_0._toiMaxRootIters = Companion_getInstance_68().max_27zxwg_k$(this._stats_0._toiMaxRootIters, rootIterCount);
        pushBackIter = pushBackIter + 1 | 0;
        Unit_getInstance();
        if (pushBackIter === Settings_getInstance()._get_maxPolygonVertices__0_k$() ? true : rootIterCount === Companion_getInstance_61()._MAX_ROOT_ITERATIONS) {
          break $l$break_7;
        }}
      iter = iter + 1 | 0;
      Unit_getInstance();
      var tmp2_this = this._stats_0;
      tmp2_this._toiIters = tmp2_this._toiIters + 1 | 0;
      Unit_getInstance();
      if (done) {
        break $l$break_9;
      }if (iter === Companion_getInstance_61()._MAX_ITERATIONS) {
        output_0._state_2 = TOIOutputState_FAILED_getInstance();
        output_0._t = t1;
        break $l$break_9;
      }}
    this._stats_0._toiMaxIters = Companion_getInstance_68().max_27zxwg_k$(this._stats_0._toiMaxIters, iter);
  };
  TimeOfImpact.$metadata$ = {
    simpleName: 'TimeOfImpact',
    kind: 'class',
    interfaces: []
  };
  function SeparationFunction() {
    var tmp = this;
    tmp._m_localPoint = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._m_axis = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_1 = this;
    tmp_1._localPointA = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_2 = this;
    tmp_2._localPointB = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_3 = this;
    tmp_3._pointA_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_4 = this;
    tmp_4._pointB_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_5 = this;
    tmp_5._localPointA1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_6 = this;
    tmp_6._localPointA2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_7 = this;
    tmp_7._normal_2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_8 = this;
    tmp_8._localPointB1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_9 = this;
    tmp_9._localPointB2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_10 = this;
    tmp_10._temp_3 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._xfa = Transform_init_$Create$_0();
    this._xfb = Transform_init_$Create$_0();
    var tmp_11 = this;
    tmp_11._axisA = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_12 = this;
    tmp_12._axisB = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  SeparationFunction.prototype._get_m_proxyA__0_k$ = function () {
    var tmp = this._m_proxyA;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('m_proxyA');
    }
  };
  SeparationFunction.prototype._get_m_proxyB__0_k$ = function () {
    var tmp = this._m_proxyB;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('m_proxyB');
    }
  };
  SeparationFunction.prototype._get_m_type__0_k$ = function () {
    var tmp = this._m_type;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('m_type');
    }
  };
  SeparationFunction.prototype._get_m_sweepA__0_k$ = function () {
    var tmp = this._m_sweepA;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('m_sweepA');
    }
  };
  SeparationFunction.prototype._get_m_sweepB__0_k$ = function () {
    var tmp = this._m_sweepB;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('m_sweepB');
    }
  };
  SeparationFunction.prototype.initialize_78ozjw_k$ = function (cache, proxyA, sweepA, proxyB, sweepB, t1) {
    this._m_proxyA = proxyA;
    this._m_proxyB = proxyB;
    var count_0 = cache._count_2;
    var tmp0_assert_0 = 0 < count_0 ? count_0 < 3 : false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }this._m_sweepA = sweepA;
    this._m_sweepB = sweepB;
    this._get_m_sweepA__0_k$().getTransform_il1pfm_k$(this._xfa, t1);
    this._get_m_sweepB__0_k$().getTransform_il1pfm_k$(this._xfb, t1);
    if (count_0 === 1) {
      this._m_type = Type_POINTS_getInstance();
      this._localPointA.set_1v0asv_k$(this._get_m_proxyA__0_k$().getVertex_ha5a7z_k$(cache._indexA_1[0]));
      Unit_getInstance();
      this._localPointB.set_1v0asv_k$(this._get_m_proxyB__0_k$().getVertex_ha5a7z_k$(cache._indexB_1[0]));
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfa, this._localPointA, this._pointA_0);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfb, this._localPointB, this._pointB_0);
      this._m_axis.set_1v0asv_k$(this._pointB_0).subLocal_1v0asv_k$(this._pointA_0);
      Unit_getInstance();
      var s = this._m_axis.normalize_0_k$();
      return s;
    } else if (cache._indexA_1[0] === cache._indexA_1[1]) {
      this._m_type = Type_FACE_B_getInstance();
      this._localPointB1.set_1v0asv_k$(this._get_m_proxyB__0_k$().getVertex_ha5a7z_k$(cache._indexB_1[0]));
      Unit_getInstance();
      this._localPointB2.set_1v0asv_k$(this._get_m_proxyB__0_k$().getVertex_ha5a7z_k$(cache._indexB_1[1]));
      Unit_getInstance();
      this._temp_3.set_1v0asv_k$(this._localPointB2).subLocal_1v0asv_k$(this._localPointB1);
      Unit_getInstance();
      Companion_getInstance_71().crossToOutUnsafe_6kg5i7_k$(this._temp_3, 1.0, this._m_axis);
      this._m_axis.normalize_0_k$();
      Unit_getInstance();
      Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(this._xfb._q, this._m_axis, this._normal_2);
      this._m_localPoint.set_1v0asv_k$(this._localPointB1).addLocal_1v0asv_k$(this._localPointB2).mulLocal_dbmacu_k$(0.5);
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfb, this._m_localPoint, this._pointB_0);
      this._localPointA.set_1v0asv_k$(proxyA.getVertex_ha5a7z_k$(cache._indexA_1[0]));
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfa, this._localPointA, this._pointA_0);
      this._temp_3.set_1v0asv_k$(this._pointA_0).subLocal_1v0asv_k$(this._pointB_0);
      Unit_getInstance();
      var s_0 = Companion_getInstance_71().dot_5kvz1c_k$(this._temp_3, this._normal_2);
      if (s_0 < 0.0) {
        this._m_axis.negateLocal_0_k$();
        Unit_getInstance();
        s_0 = -s_0;
      }return s_0;
    } else {
      this._m_type = Type_FACE_A_getInstance();
      this._localPointA1.set_1v0asv_k$(this._get_m_proxyA__0_k$().getVertex_ha5a7z_k$(cache._indexA_1[0]));
      Unit_getInstance();
      this._localPointA2.set_1v0asv_k$(this._get_m_proxyA__0_k$().getVertex_ha5a7z_k$(cache._indexA_1[1]));
      Unit_getInstance();
      this._temp_3.set_1v0asv_k$(this._localPointA2).subLocal_1v0asv_k$(this._localPointA1);
      Unit_getInstance();
      Companion_getInstance_71().crossToOutUnsafe_6kg5i7_k$(this._temp_3, 1.0, this._m_axis);
      this._m_axis.normalize_0_k$();
      Unit_getInstance();
      Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(this._xfa._q, this._m_axis, this._normal_2);
      this._m_localPoint.set_1v0asv_k$(this._localPointA1).addLocal_1v0asv_k$(this._localPointA2).mulLocal_dbmacu_k$(0.5);
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfa, this._m_localPoint, this._pointA_0);
      this._localPointB.set_1v0asv_k$(this._get_m_proxyB__0_k$().getVertex_ha5a7z_k$(cache._indexB_1[0]));
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfb, this._localPointB, this._pointB_0);
      this._temp_3.set_1v0asv_k$(this._pointB_0).subLocal_1v0asv_k$(this._pointA_0);
      Unit_getInstance();
      var s_1 = Companion_getInstance_71().dot_5kvz1c_k$(this._temp_3, this._normal_2);
      if (s_1 < 0.0) {
        this._m_axis.negateLocal_0_k$();
        Unit_getInstance();
        s_1 = -s_1;
      }return s_1;
    }
  };
  SeparationFunction.prototype.findMinSeparation_vcjpjq_k$ = function (indexes, t) {
    this._get_m_sweepA__0_k$().getTransform_il1pfm_k$(this._xfa, t);
    this._get_m_sweepB__0_k$().getTransform_il1pfm_k$(this._xfb, t);
    var tmp0_subject = this._get_m_type__0_k$();
    if (tmp0_subject.equals(Type_POINTS_getInstance())) {
      Companion_getInstance_69().mulTransUnsafe_6ywscr_k$(this._xfa._q, this._m_axis, this._axisA);
      Companion_getInstance_69().mulTransUnsafe_6ywscr_k$(this._xfb._q, this._m_axis.negateLocal_0_k$(), this._axisB);
      this._m_axis.negateLocal_0_k$();
      Unit_getInstance();
      indexes[0] = this._get_m_proxyA__0_k$().getSupport_1v0asv_k$(this._axisA);
      indexes[1] = this._get_m_proxyB__0_k$().getSupport_1v0asv_k$(this._axisB);
      this._localPointA.set_1v0asv_k$(this._get_m_proxyA__0_k$().getVertex_ha5a7z_k$(indexes[0]));
      Unit_getInstance();
      this._localPointB.set_1v0asv_k$(this._get_m_proxyB__0_k$().getVertex_ha5a7z_k$(indexes[1]));
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfa, this._localPointA, this._pointA_0);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfb, this._localPointB, this._pointB_0);
      var separation = Companion_getInstance_71().dot_5kvz1c_k$(this._pointB_0.subLocal_1v0asv_k$(this._pointA_0), this._m_axis);
      return separation;
    } else if (tmp0_subject.equals(Type_FACE_A_getInstance())) {
      Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(this._xfa._q, this._m_axis, this._normal_2);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfa, this._m_localPoint, this._pointA_0);
      Companion_getInstance_69().mulTransUnsafe_6ywscr_k$(this._xfb._q, this._normal_2.negateLocal_0_k$(), this._axisB);
      this._normal_2.negateLocal_0_k$();
      Unit_getInstance();
      indexes[0] = -1;
      indexes[1] = this._get_m_proxyB__0_k$().getSupport_1v0asv_k$(this._axisB);
      this._localPointB.set_1v0asv_k$(this._get_m_proxyB__0_k$().getVertex_ha5a7z_k$(indexes[1]));
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfb, this._localPointB, this._pointB_0);
      var separation_0 = Companion_getInstance_71().dot_5kvz1c_k$(this._pointB_0.subLocal_1v0asv_k$(this._pointA_0), this._normal_2);
      return separation_0;
    } else if (tmp0_subject.equals(Type_FACE_B_getInstance())) {
      Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(this._xfb._q, this._m_axis, this._normal_2);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfb, this._m_localPoint, this._pointB_0);
      Companion_getInstance_69().mulTransUnsafe_6ywscr_k$(this._xfa._q, this._normal_2.negateLocal_0_k$(), this._axisA);
      this._normal_2.negateLocal_0_k$();
      Unit_getInstance();
      indexes[1] = -1;
      indexes[0] = this._get_m_proxyA__0_k$().getSupport_1v0asv_k$(this._axisA);
      this._localPointA.set_1v0asv_k$(this._get_m_proxyA__0_k$().getVertex_ha5a7z_k$(indexes[0]));
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfa, this._localPointA, this._pointA_0);
      var separation_1 = Companion_getInstance_71().dot_5kvz1c_k$(this._pointA_0.subLocal_1v0asv_k$(this._pointB_0), this._normal_2);
      return separation_1;
    } else {
      {
        var message_2_1 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
      }
      indexes[0] = -1;
      indexes[1] = -1;
      return 0.0;
    }
  };
  SeparationFunction.prototype.evaluate_ex40b2_k$ = function (indexA, indexB, t) {
    this._get_m_sweepA__0_k$().getTransform_il1pfm_k$(this._xfa, t);
    this._get_m_sweepB__0_k$().getTransform_il1pfm_k$(this._xfb, t);
    var tmp0_subject = this._get_m_type__0_k$();
    if (tmp0_subject.equals(Type_POINTS_getInstance())) {
      this._localPointA.set_1v0asv_k$(this._get_m_proxyA__0_k$().getVertex_ha5a7z_k$(indexA));
      Unit_getInstance();
      this._localPointB.set_1v0asv_k$(this._get_m_proxyB__0_k$().getVertex_ha5a7z_k$(indexB));
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfa, this._localPointA, this._pointA_0);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfb, this._localPointB, this._pointB_0);
      var separation = Companion_getInstance_71().dot_5kvz1c_k$(this._pointB_0.subLocal_1v0asv_k$(this._pointA_0), this._m_axis);
      return separation;
    } else if (tmp0_subject.equals(Type_FACE_A_getInstance())) {
      Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(this._xfa._q, this._m_axis, this._normal_2);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfa, this._m_localPoint, this._pointA_0);
      this._localPointB.set_1v0asv_k$(this._get_m_proxyB__0_k$().getVertex_ha5a7z_k$(indexB));
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfb, this._localPointB, this._pointB_0);
      var separation_0 = Companion_getInstance_71().dot_5kvz1c_k$(this._pointB_0.subLocal_1v0asv_k$(this._pointA_0), this._normal_2);
      return separation_0;
    } else if (tmp0_subject.equals(Type_FACE_B_getInstance())) {
      Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(this._xfb._q, this._m_axis, this._normal_2);
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfb, this._m_localPoint, this._pointB_0);
      this._localPointA.set_1v0asv_k$(this._get_m_proxyA__0_k$().getVertex_ha5a7z_k$(indexA));
      Unit_getInstance();
      Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xfa, this._localPointA, this._pointA_0);
      var separation_1 = Companion_getInstance_71().dot_5kvz1c_k$(this._pointA_0.subLocal_1v0asv_k$(this._pointB_0), this._normal_2);
      return separation_1;
    } else {
      {
        var message_2_1 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
      }
      return 0.0;
    }
  };
  SeparationFunction.$metadata$ = {
    simpleName: 'SeparationFunction',
    kind: 'class',
    interfaces: []
  };
  var Type_POINTS_instance;
  var Type_FACE_A_instance;
  var Type_FACE_B_instance;
  var Type_entriesInitialized_2;
  function Type_initEntries_2() {
    if (Type_entriesInitialized_2)
      return Unit_getInstance();
    Type_entriesInitialized_2 = true;
    Type_POINTS_instance = new Type_2('POINTS', 0);
    Type_FACE_A_instance = new Type_2('FACE_A', 1);
    Type_FACE_B_instance = new Type_2('FACE_B', 2);
  }
  function Type_2(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_2.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_POINTS_getInstance() {
    Type_initEntries_2();
    return Type_POINTS_instance;
  }
  function Type_FACE_A_getInstance() {
    Type_initEntries_2();
    return Type_FACE_A_instance;
  }
  function Type_FACE_B_getInstance() {
    Type_initEntries_2();
    return Type_FACE_B_instance;
  }
  function WorldManifold() {
    var tmp = this;
    tmp._normal_3 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = Settings_getInstance()._get_maxManifoldPoints__0_k$();
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = Vec2_init_$Create$(0.0, 0.0, 3, null);
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._points_3 = tmp_3;
    this._separations = new Float32Array(Settings_getInstance()._get_maxManifoldPoints__0_k$());
    var tmp_5 = this;
    tmp_5._pool3 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_6 = this;
    tmp_6._pool4 = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  WorldManifold.prototype.initialize_aezuj7_k$ = function (manifold, xfA, radiusA, xfB, radiusB) {
    if (manifold._pointCount === 0) {
      return Unit_getInstance();
    }var tmp0_subject = manifold._type_6;
    if (tmp0_subject.equals(ManifoldType_CIRCLES_getInstance())) {
      var pointA = this._pool3;
      var pointB = this._pool4;
      this._normal_3._x_7 = 1.0;
      this._normal_3._y_6 = 0.0;
      var v = manifold._localPoint;
      pointA._x_7 = xfA._q._c_0 * v._x_7 - xfA._q._s * v._y_6 + xfA._p_1._x_7;
      pointA._y_6 = xfA._q._s * v._x_7 + xfA._q._c_0 * v._y_6 + xfA._p_1._y_6;
      var mp0p = manifold._points_2[0]._localPoint_0;
      pointB._x_7 = xfB._q._c_0 * mp0p._x_7 - xfB._q._s * mp0p._y_6 + xfB._p_1._x_7;
      pointB._y_6 = xfB._q._s * mp0p._x_7 + xfB._q._c_0 * mp0p._y_6 + xfB._p_1._y_6;
      if (Companion_getInstance_68().distanceSquared_5kvz1c_k$(pointA, pointB) > Settings_getInstance()._EPSILON * Settings_getInstance()._EPSILON) {
        this._normal_3._x_7 = pointB._x_7 - pointA._x_7;
        this._normal_3._y_6 = pointB._y_6 - pointA._y_6;
        this._normal_3.normalize_0_k$();
        Unit_getInstance();
      }var cAx = this._normal_3._x_7 * radiusA + pointA._x_7;
      var cAy = this._normal_3._y_6 * radiusA + pointA._y_6;
      var cBx = -this._normal_3._x_7 * radiusB + pointB._x_7;
      var cBy = -this._normal_3._y_6 * radiusB + pointB._y_6;
      this._points_3[0]._x_7 = (cAx + cBx) * 0.5;
      this._points_3[0]._y_6 = (cAy + cBy) * 0.5;
      this._separations[0] = (cBx - cAx) * this._normal_3._x_7 + (cBy - cAy) * this._normal_3._y_6;
    } else if (tmp0_subject.equals(ManifoldType_FACE_A_getInstance())) {
      var planePoint = this._pool3;
      Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(xfA._q, manifold._localNormal_0, this._normal_3);
      Companion_getInstance_70().mulToOut_kg26ly_k$(xfA, manifold._localPoint, planePoint);
      var clipPoint = this._pool4;
      var inductionVariable = 0;
      var last_1 = manifold._pointCount;
      if (inductionVariable < last_1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          Companion_getInstance_70().mulToOut_kg26ly_k$(xfB, manifold._points_2[i]._localPoint_0, clipPoint);
          var scalar = radiusA - ((clipPoint._x_7 - planePoint._x_7) * this._normal_3._x_7 + (clipPoint._y_6 - planePoint._y_6) * this._normal_3._y_6);
          var cAx_0 = this._normal_3._x_7 * scalar + clipPoint._x_7;
          var cAy_0 = this._normal_3._y_6 * scalar + clipPoint._y_6;
          var cBx_0 = -this._normal_3._x_7 * radiusB + clipPoint._x_7;
          var cBy_0 = -this._normal_3._y_6 * radiusB + clipPoint._y_6;
          this._points_3[i]._x_7 = (cAx_0 + cBx_0) * 0.5;
          this._points_3[i]._y_6 = (cAy_0 + cBy_0) * 0.5;
          this._separations[i] = (cBx_0 - cAx_0) * this._normal_3._x_7 + (cBy_0 - cAy_0) * this._normal_3._y_6;
        }
         while (inductionVariable < last_1);
    } else if (tmp0_subject.equals(ManifoldType_FACE_B_getInstance())) {
      var planePoint_0 = this._pool3;
      Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(xfB._q, manifold._localNormal_0, this._normal_3);
      Companion_getInstance_70().mulToOut_kg26ly_k$(xfB, manifold._localPoint, planePoint_0);
      var clipPoint_0 = this._pool4;
      var inductionVariable_0 = 0;
      var last_2 = manifold._pointCount;
      if (inductionVariable_0 < last_2)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          Companion_getInstance_70().mulToOut_kg26ly_k$(xfA, manifold._points_2[i_0]._localPoint_0, clipPoint_0);
          var scalar_0 = radiusB - ((clipPoint_0._x_7 - planePoint_0._x_7) * this._normal_3._x_7 + (clipPoint_0._y_6 - planePoint_0._y_6) * this._normal_3._y_6);
          var cBx_1 = this._normal_3._x_7 * scalar_0 + clipPoint_0._x_7;
          var cBy_1 = this._normal_3._y_6 * scalar_0 + clipPoint_0._y_6;
          var cAx_1 = -this._normal_3._x_7 * radiusA + clipPoint_0._x_7;
          var cAy_1 = -this._normal_3._y_6 * radiusA + clipPoint_0._y_6;
          this._points_3[i_0]._x_7 = (cAx_1 + cBx_1) * 0.5;
          this._points_3[i_0]._y_6 = (cAy_1 + cBy_1) * 0.5;
          this._separations[i_0] = (cAx_1 - cBx_1) * this._normal_3._x_7 + (cAy_1 - cBy_1) * this._normal_3._y_6;
        }
         while (inductionVariable_0 < last_2);
      this._normal_3._x_7 = -this._normal_3._x_7;
      this._normal_3._y_6 = -this._normal_3._y_6;
    }};
  WorldManifold.$metadata$ = {
    simpleName: 'WorldManifold',
    kind: 'class',
    interfaces: []
  };
  function Companion_63() {
    Companion_instance_62 = this;
    this._NULL_PROXY = -1;
  }
  Companion_63.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_62;
  function Companion_getInstance_62() {
    if (Companion_instance_62 == null)
      new Companion_63();
    return Companion_instance_62;
  }
  function BroadPhase() {
  }
  BroadPhase.$metadata$ = {
    simpleName: 'BroadPhase',
    kind: 'interface',
    interfaces: []
  };
  function BroadPhaseStrategy() {
  }
  BroadPhaseStrategy.$metadata$ = {
    simpleName: 'BroadPhaseStrategy',
    kind: 'interface',
    interfaces: []
  };
  function DefaultBroadPhaseBuffer(m_tree) {
    this._m_tree = m_tree;
    this._proxyCount = 0;
    this._m_moveBuffer = null;
    this._m_moveCapacity = 0;
    this._m_moveCount = 0;
    this._m_pairBuffer = null;
    this._m_pairCapacity = 0;
    this._m_pairCount = 0;
    this._m_queryProxyId = 0;
    this._proxyCount = 0;
    this._m_pairCapacity = 16;
    this._m_pairCount = 0;
    this._m_pairBuffer = longArray(this._m_pairCapacity);
    this._m_moveCapacity = 16;
    this._m_moveCount = 0;
    this._m_moveBuffer = new Int32Array(this._m_moveCapacity);
    this._m_queryProxyId = Companion_getInstance_62()._NULL_PROXY;
  }
  DefaultBroadPhaseBuffer.prototype.createProxy_ojzcmo_k$ = function (aabb, userData) {
    var proxyId = this._m_tree.createProxy_ojzcmo_k$(aabb, userData);
    var tmp0_this = this;
    tmp0_this._proxyCount = tmp0_this._proxyCount + 1 | 0;
    Unit_getInstance();
    this.bufferMove_majfzk_k$(proxyId);
    return proxyId;
  };
  DefaultBroadPhaseBuffer.prototype.destroyProxy_majfzk_k$ = function (proxyId) {
    this.unbufferMove_majfzk_k$(proxyId);
    var tmp0_this = this;
    tmp0_this._proxyCount = tmp0_this._proxyCount - 1 | 0;
    Unit_getInstance();
    this._m_tree.destroyProxy_majfzk_k$(proxyId);
  };
  DefaultBroadPhaseBuffer.prototype.moveProxy_cdborz_k$ = function (proxyId, aabb, displacement) {
    var buffer = this._m_tree.moveProxy_dsi6ps_k$(proxyId, aabb, displacement);
    if (buffer) {
      this.bufferMove_majfzk_k$(proxyId);
    }};
  DefaultBroadPhaseBuffer.prototype.getUserData_ha5a7z_k$ = function (proxyId) {
    return this._m_tree.getUserData_ha5a7z_k$(proxyId);
  };
  DefaultBroadPhaseBuffer.prototype.testOverlap_27zxwg_k$ = function (proxyIdA, proxyIdB) {
    var a = this._m_tree.getFatAABB_ha5a7z_k$(proxyIdA);
    var b = this._m_tree.getFatAABB_ha5a7z_k$(proxyIdB);
    if (b._lowerBound._x_7 - a._upperBound._x_7 > 0.0 ? true : b._lowerBound._y_6 - a._upperBound._y_6 > 0.0) {
      return false;
    }var tmp;
    if (a._lowerBound._x_7 - b._upperBound._x_7 > 0.0 ? true : a._lowerBound._y_6 - b._upperBound._y_6 > 0.0) {
      tmp = false;
    } else {
      tmp = true;
    }
    return tmp;
  };
  DefaultBroadPhaseBuffer.prototype.updatePairs_mno5cw_k$ = function (callback) {
    this._m_pairCount = 0;
    var inductionVariable = 0;
    var last_1 = this._m_moveCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._m_queryProxyId = ensureNotNull(this._m_moveBuffer)[i];
        if (this._m_queryProxyId === Companion_getInstance_62()._NULL_PROXY) {
          continue;
        }var fatAABB = this._m_tree.getFatAABB_ha5a7z_k$(this._m_queryProxyId);
        this._m_tree.query_qronny_k$(this, fatAABB);
      }
       while (inductionVariable < last_1);
    this._m_moveCount = 0;
    Arrays_sort_0(ensureNotNull(this._m_pairBuffer), 0, this._m_pairCount);
    var i_0 = 0;
    while (i_0 < this._m_pairCount) {
      var primaryPair = ensureNotNull(this._m_pairBuffer)[i_0];
      var userDataA = this._m_tree.getUserData_ha5a7z_k$(primaryPair.shr_ha5a7z_k$(32).toInt_0_k$());
      var userDataB = this._m_tree.getUserData_ha5a7z_k$(primaryPair.toInt_0_k$());
      callback.addPair_23fbgv_k$(userDataA, userDataB);
      i_0 = i_0 + 1 | 0;
      Unit_getInstance();
      $l$break: while (i_0 < this._m_pairCount) {
        var pair = ensureNotNull(this._m_pairBuffer)[i_0];
        if (!pair.equals(primaryPair)) {
          break $l$break;
        }i_0 = i_0 + 1 | 0;
        Unit_getInstance();
      }
    }
  };
  DefaultBroadPhaseBuffer.prototype.query_qronny_k$ = function (callback, aabb) {
    this._m_tree.query_qronny_k$(callback, aabb);
  };
  DefaultBroadPhaseBuffer.prototype.bufferMove_majfzk_k$ = function (proxyId) {
    if (this._m_moveCount === this._m_moveCapacity) {
      var old = this._m_moveBuffer;
      var tmp0_this = this;
      tmp0_this._m_moveCapacity = imul(tmp0_this._m_moveCapacity, 2);
      this._m_moveBuffer = new Int32Array(this._m_moveCapacity);
      var tmp0_arraycopy_0 = ensureNotNull(old);
      var tmp1_arraycopy_0 = ensureNotNull(this._m_moveBuffer);
      var tmp2_arraycopy_0 = old.length;
      var tmp0_copyInto_0_2 = 0 + tmp2_arraycopy_0 | 0;
      arrayCopy_0(tmp0_arraycopy_0, tmp1_arraycopy_0, 0, 0, tmp0_copyInto_0_2);
      Unit_getInstance();
    }ensureNotNull(this._m_moveBuffer)[this._m_moveCount] = proxyId;
    var tmp1_this = this;
    tmp1_this._m_moveCount = tmp1_this._m_moveCount + 1 | 0;
    Unit_getInstance();
  };
  DefaultBroadPhaseBuffer.prototype.unbufferMove_majfzk_k$ = function (proxyId) {
    var inductionVariable = 0;
    var last_1 = this._m_moveCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (ensureNotNull(this._m_moveBuffer)[i] === proxyId) {
          ensureNotNull(this._m_moveBuffer)[i] = Companion_getInstance_62()._NULL_PROXY;
        }}
       while (inductionVariable < last_1);
  };
  DefaultBroadPhaseBuffer.prototype.treeCallback_ha5a7z_k$ = function (proxyId) {
    if (proxyId === this._m_queryProxyId) {
      return true;
    }if (this._m_pairCount === this._m_pairCapacity) {
      var oldBuffer = this._m_pairBuffer;
      var tmp0_this = this;
      tmp0_this._m_pairCapacity = imul(tmp0_this._m_pairCapacity, 2);
      this._m_pairBuffer = longArray(this._m_pairCapacity);
      var tmp0_arraycopy_0 = ensureNotNull(oldBuffer);
      var tmp1_arraycopy_0 = ensureNotNull(this._m_pairBuffer);
      var tmp2_arraycopy_0 = oldBuffer.length;
      var tmp0_copyInto_0_2 = 0 + tmp2_arraycopy_0 | 0;
      arrayCopy_0(tmp0_arraycopy_0, tmp1_arraycopy_0, 0, 0, tmp0_copyInto_0_2);
      Unit_getInstance();
      var inductionVariable = oldBuffer.length;
      var last_1 = this._m_pairCapacity;
      if (inductionVariable < last_1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          ensureNotNull(this._m_pairBuffer)[i] = new Long(0, 0);
        }
         while (inductionVariable < last_1);
    }if (proxyId < this._m_queryProxyId) {
      ensureNotNull(this._m_pairBuffer)[this._m_pairCount] = toLong(proxyId).shl_ha5a7z_k$(32).or_wiekkq_k$(toLong(this._m_queryProxyId));
    } else {
      ensureNotNull(this._m_pairBuffer)[this._m_pairCount] = toLong(this._m_queryProxyId).shl_ha5a7z_k$(32).or_wiekkq_k$(toLong(proxyId));
    }
    var tmp2_this = this;
    tmp2_this._m_pairCount = tmp2_this._m_pairCount + 1 | 0;
    Unit_getInstance();
    return true;
  };
  DefaultBroadPhaseBuffer.$metadata$ = {
    simpleName: 'DefaultBroadPhaseBuffer',
    kind: 'class',
    interfaces: [TreeCallback, BroadPhase]
  };
  function allocateNode($this) {
    if ($this._m_freeList === Companion_getInstance_63()._NULL_NODE) {
      var tmp0_assert_0 = $this._m_nodeCount === $this._m_nodeCapacity;
      if (!tmp0_assert_0) {
        var message_2_1 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
      }var old = $this._m_nodes;
      var tmp0_this = $this;
      tmp0_this._m_nodeCapacity = imul(tmp0_this._m_nodeCapacity, 2);
      var tmp = $this;
      var tmp1_arrayOfNulls_0 = $this._m_nodeCapacity;
      var tmp_0 = fillArrayVal(Array(tmp1_arrayOfNulls_0), null);
      tmp._m_nodes = isArray(tmp_0) ? tmp_0 : THROW_CCE();
      var tmp2_arraycopy_0 = ensureNotNull(old);
      var tmp3_arraycopy_0 = ensureNotNull($this._m_nodes);
      var tmp4_arraycopy_0 = old.length;
      var tmp0_copyInto_0_2 = 0 + tmp4_arraycopy_0 | 0;
      arrayCopy_0(tmp2_arraycopy_0, tmp3_arraycopy_0, 0, 0, tmp0_copyInto_0_2);
      Unit_getInstance();
      var inductionVariable = $this._m_nodeCapacity - 1 | 0;
      var last_1 = $this._m_nodeCount;
      if (last_1 <= inductionVariable)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          ensureNotNull($this._m_nodes)[i] = new DynamicTreeNode(i);
          ensureNotNull($this._m_nodes)[i]._parent = i === ($this._m_nodeCapacity - 1 | 0) ? null : ensureNotNull($this._m_nodes)[i + 1 | 0];
          ensureNotNull($this._m_nodes)[i]._height_2 = -1;
        }
         while (!(i === last_1));
      $this._m_freeList = $this._m_nodeCount;
    }var nodeId = $this._m_freeList;
    var treeNode = ensureNotNull($this._m_nodes)[nodeId];
    $this._m_freeList = !(treeNode._parent == null) ? ensureNotNull(treeNode._parent)._id_2 : Companion_getInstance_63()._NULL_NODE;
    treeNode._parent = null;
    treeNode._child1 = null;
    treeNode._child2 = null;
    treeNode._height_2 = 0;
    treeNode._userData = null;
    var tmp2_this = $this;
    tmp2_this._m_nodeCount = tmp2_this._m_nodeCount + 1 | 0;
    Unit_getInstance();
    return treeNode;
  }
  function freeNode($this, node) {
    var tmp0_assert_0 = !(node == null);
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = 0 < $this._m_nodeCount;
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }node._parent = !($this._m_freeList === Companion_getInstance_63()._NULL_NODE) ? ensureNotNull($this._m_nodes)[$this._m_freeList] : null;
    node._height_2 = -1;
    $this._m_freeList = node._id_2;
    var tmp0_this = $this;
    var tmp1 = tmp0_this._m_nodeCount;
    tmp0_this._m_nodeCount = tmp1 - 1 | 0;
    Unit_getInstance();
  }
  function insertLeaf($this, leaf_index) {
    var leaf = ensureNotNull($this._m_nodes)[leaf_index];
    if ($this._m_root == null) {
      $this._m_root = leaf;
      ensureNotNull($this._m_root)._parent = null;
      return Unit_getInstance();
    }var leafAABB = leaf._aabb_0;
    var index_0 = $this._m_root;
    $l$break: while (!(ensureNotNull(index_0)._child1 == null)) {
      var node = index_0;
      var child1 = node._child1;
      var child2 = node._child2;
      var area = node._aabb_0._get_perimeter__0_k$();
      $this._combinedAABB.combine_jodcc5_k$(node._aabb_0, leafAABB);
      var combinedArea = $this._combinedAABB._get_perimeter__0_k$();
      var cost = 2.0 * combinedArea;
      var inheritanceCost = 2.0 * (combinedArea - area);
      var cost1;
      if (ensureNotNull(child1)._child1 == null) {
        $this._combinedAABB.combine_jodcc5_k$(leafAABB, child1._aabb_0);
        cost1 = $this._combinedAABB._get_perimeter__0_k$() + inheritanceCost;
      } else {
        $this._combinedAABB.combine_jodcc5_k$(leafAABB, child1._aabb_0);
        var oldArea = child1._aabb_0._get_perimeter__0_k$();
        var newArea = $this._combinedAABB._get_perimeter__0_k$();
        cost1 = newArea - oldArea + inheritanceCost;
      }
      var cost2;
      if (ensureNotNull(child2)._child1 == null) {
        $this._combinedAABB.combine_jodcc5_k$(leafAABB, child2._aabb_0);
        cost2 = $this._combinedAABB._get_perimeter__0_k$() + inheritanceCost;
      } else {
        $this._combinedAABB.combine_jodcc5_k$(leafAABB, child2._aabb_0);
        var oldArea_0 = child2._aabb_0._get_perimeter__0_k$();
        var newArea_0 = $this._combinedAABB._get_perimeter__0_k$();
        cost2 = newArea_0 - oldArea_0 + inheritanceCost;
      }
      if (cost < cost1 ? cost < cost2 : false) {
        break $l$break;
      }if (cost1 < cost2) {
        index_0 = child1;
      } else {
        index_0 = child2;
      }
    }
    var sibling = index_0;
    var oldParent = ensureNotNull($this._m_nodes)[sibling._id_2]._parent;
    var newParent = allocateNode($this);
    newParent._parent = oldParent;
    newParent._userData = null;
    newParent._aabb_0.combine_jodcc5_k$(leafAABB, sibling._aabb_0);
    newParent._height_2 = sibling._height_2 + 1 | 0;
    if (!(oldParent == null)) {
      if (oldParent._child1 === sibling) {
        oldParent._child1 = newParent;
      } else {
        oldParent._child2 = newParent;
      }
      newParent._child1 = sibling;
      newParent._child2 = leaf;
      sibling._parent = newParent;
      leaf._parent = newParent;
    } else {
      newParent._child1 = sibling;
      newParent._child2 = leaf;
      sibling._parent = newParent;
      leaf._parent = newParent;
      $this._m_root = newParent;
    }
    index_0 = leaf._parent;
    while (!(index_0 == null)) {
      index_0 = balance($this, index_0);
      var child1_0 = index_0._child1;
      var child2_0 = index_0._child2;
      var tmp0_assert_0 = !(child1_0 == null);
      if (!tmp0_assert_0) {
        var message_2_1 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
      }var tmp1_assert_0 = !(child2_0 == null);
      if (!tmp1_assert_0) {
        var message_2_1_0 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
      }index_0._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(ensureNotNull(child1_0)._height_2, ensureNotNull(child2_0)._height_2) | 0;
      index_0._aabb_0.combine_jodcc5_k$(child1_0._aabb_0, child2_0._aabb_0);
      index_0 = index_0._parent;
    }
  }
  function removeLeaf($this, leaf) {
    if (leaf === $this._m_root) {
      $this._m_root = null;
      return Unit_getInstance();
    }var parent = leaf._parent;
    var tmp0_safe_receiver = parent;
    var grandParent = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._parent;
    var sibling;
    if (ensureNotNull(parent)._child1 === leaf) {
      sibling = ensureNotNull(ensureNotNull(parent)._child2);
    } else {
      sibling = ensureNotNull(ensureNotNull(parent)._child1);
    }
    if (!(grandParent == null)) {
      if (grandParent._child1 === parent) {
        grandParent._child1 = sibling;
      } else {
        grandParent._child2 = sibling;
      }
      sibling._parent = grandParent;
      freeNode($this, parent);
      var index_0 = grandParent;
      while (!(index_0 == null)) {
        index_0 = balance($this, index_0);
        var child1 = index_0._child1;
        var child2 = index_0._child2;
        index_0._aabb_0.combine_jodcc5_k$(ensureNotNull(child1)._aabb_0, ensureNotNull(child2)._aabb_0);
        index_0._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(child1._height_2, child2._height_2) | 0;
        index_0 = index_0._parent;
      }
    } else {
      $this._m_root = sibling;
      sibling._parent = null;
      freeNode($this, parent);
    }
  }
  function balance($this, iA) {
    var tmp0_assert_0 = !(iA == null);
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var A = iA;
    if (ensureNotNull(A)._child1 == null ? true : A._height_2 < 2) {
      return iA;
    }var iB = A._child1;
    var iC = A._child2;
    var tmp1_assert_0 = 0 <= ensureNotNull(iB)._id_2 ? iB._id_2 < $this._m_nodeCapacity : false;
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }var tmp2_assert_0 = 0 <= ensureNotNull(iC)._id_2 ? iC._id_2 < $this._m_nodeCapacity : false;
    if (!tmp2_assert_0) {
      var message_2_1_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
    }var B = iB;
    var C = iC;
    var balance_0 = C._height_2 - B._height_2 | 0;
    if (balance_0 > 1) {
      var iF = C._child1;
      var iG = C._child2;
      var F = iF;
      var G = iG;
      var tmp3_assert_0 = !(F == null);
      if (!tmp3_assert_0) {
        var message_2_1_2 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_2));
      }var tmp4_assert_0 = !(G == null);
      if (!tmp4_assert_0) {
        var message_2_1_3 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_3));
      }var tmp5_assert_0 = 0 <= ensureNotNull(iF)._id_2 ? iF._id_2 < $this._m_nodeCapacity : false;
      if (!tmp5_assert_0) {
        var message_2_1_4 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_4));
      }var tmp6_assert_0 = 0 <= ensureNotNull(iG)._id_2 ? iG._id_2 < $this._m_nodeCapacity : false;
      if (!tmp6_assert_0) {
        var message_2_1_5 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_5));
      }C._child1 = iA;
      C._parent = A._parent;
      A._parent = iC;
      if (!(C._parent == null)) {
        if (ensureNotNull(C._parent)._child1 === iA) {
          ensureNotNull(C._parent)._child1 = iC;
        } else {
          var tmp7_assert_0 = ensureNotNull(C._parent)._child2 === iA;
          if (!tmp7_assert_0) {
            var message_2_1_6 = 'Check failed.';
            throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_6));
          }ensureNotNull(C._parent)._child2 = iC;
        }
      } else {
        $this._m_root = iC;
      }
      if (ensureNotNull(F)._height_2 > ensureNotNull(G)._height_2) {
        C._child2 = iF;
        A._child2 = iG;
        G._parent = iA;
        A._aabb_0.combine_jodcc5_k$(B._aabb_0, G._aabb_0);
        C._aabb_0.combine_jodcc5_k$(A._aabb_0, F._aabb_0);
        A._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(B._height_2, G._height_2) | 0;
        C._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(A._height_2, F._height_2) | 0;
      } else {
        C._child2 = iG;
        A._child2 = iF;
        F._parent = iA;
        A._aabb_0.combine_jodcc5_k$(B._aabb_0, F._aabb_0);
        C._aabb_0.combine_jodcc5_k$(A._aabb_0, G._aabb_0);
        A._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(B._height_2, F._height_2) | 0;
        C._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(A._height_2, G._height_2) | 0;
      }
      return iC;
    }if (balance_0 < -1) {
      var iD = B._child1;
      var iE = B._child2;
      var D = iD;
      var E = iE;
      var tmp8_assert_0 = 0 <= ensureNotNull(iD)._id_2 ? iD._id_2 < $this._m_nodeCapacity : false;
      if (!tmp8_assert_0) {
        var message_2_1_7 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_7));
      }var tmp9_assert_0 = 0 <= ensureNotNull(iE)._id_2 ? iE._id_2 < $this._m_nodeCapacity : false;
      if (!tmp9_assert_0) {
        var message_2_1_8 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_8));
      }B._child1 = iA;
      B._parent = A._parent;
      A._parent = iB;
      if (!(B._parent == null)) {
        if (ensureNotNull(B._parent)._child1 === iA) {
          ensureNotNull(B._parent)._child1 = iB;
        } else {
          var tmp10_assert_0 = ensureNotNull(B._parent)._child2 === iA;
          if (!tmp10_assert_0) {
            var message_2_1_9 = 'Check failed.';
            throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_9));
          }ensureNotNull(B._parent)._child2 = iB;
        }
      } else {
        $this._m_root = iB;
      }
      if (ensureNotNull(D)._height_2 > ensureNotNull(E)._height_2) {
        B._child2 = iD;
        A._child1 = iE;
        E._parent = iA;
        A._aabb_0.combine_jodcc5_k$(C._aabb_0, E._aabb_0);
        B._aabb_0.combine_jodcc5_k$(A._aabb_0, D._aabb_0);
        A._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(C._height_2, E._height_2) | 0;
        B._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(A._height_2, D._height_2) | 0;
      } else {
        B._child2 = iE;
        A._child1 = iD;
        D._parent = iA;
        A._aabb_0.combine_jodcc5_k$(C._aabb_0, D._aabb_0);
        B._aabb_0.combine_jodcc5_k$(A._aabb_0, E._aabb_0);
        A._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(C._height_2, D._height_2) | 0;
        B._height_2 = 1 + Companion_getInstance_68().max_27zxwg_k$(A._height_2, E._height_2) | 0;
      }
      return iB;
    }return iA;
  }
  function Companion_64() {
    Companion_instance_63 = this;
    this._MAX_STACK_SIZE = 64;
    this._NULL_NODE = -1;
  }
  Companion_64.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_63;
  function Companion_getInstance_63() {
    if (Companion_instance_63 == null)
      new Companion_64();
    return Companion_instance_63;
  }
  function DynamicTree() {
    Companion_getInstance_63();
    this._m_root = null;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 16;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new DynamicTreeNode(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._m_nodes = tmp_2;
    this._m_nodeCount = 0;
    this._m_nodeCapacity = 16;
    this._m_freeList = 0;
    var tmp_4 = this;
    var tmp_5 = 0;
    var tmp_6 = 4;
    var tmp_7 = fillArrayVal(Array(tmp_6), null);
    while (tmp_5 < tmp_6) {
      var tmp_8 = tmp_5;
      tmp_7[tmp_8] = Vec2_init_$Create$(0.0, 0.0, 3, null);
      tmp_5 = tmp_5 + 1 | 0;
    }
    tmp_4._drawVecs = tmp_7;
    var tmp_9 = this;
    tmp_9._nodeStack = fillArrayVal(Array(20), null);
    this._nodeStackIndex = 0;
    var tmp_10 = this;
    tmp_10._r = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._aabb = AABB_init_$Create$();
    this._subInput = new RayCastInput();
    this._combinedAABB = AABB_init_$Create$();
    this._color = Color3f_init_$Create$();
    var tmp_11 = this;
    tmp_11._textVec = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var inductionVariable = this._m_nodeCapacity - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        ensureNotNull(this._m_nodes)[i]._parent = i === (this._m_nodeCapacity - 1 | 0) ? null : ensureNotNull(this._m_nodes)[i + 1 | 0];
        ensureNotNull(this._m_nodes)[i]._height_2 = -1;
      }
       while (0 <= inductionVariable);
  }
  DynamicTree.prototype.createProxy_ojzcmo_k$ = function (aabb, userData) {
    var tmp0_assert_0 = aabb._get_isValid__0_k$();
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var node = allocateNode(this);
    var proxyId = node._id_2;
    var nodeAABB = node._aabb_0;
    nodeAABB._lowerBound._x_7 = aabb._lowerBound._x_7 - Settings_getInstance()._get_aabbExtension__0_k$();
    nodeAABB._lowerBound._y_6 = aabb._lowerBound._y_6 - Settings_getInstance()._get_aabbExtension__0_k$();
    nodeAABB._upperBound._x_7 = aabb._upperBound._x_7 + Settings_getInstance()._get_aabbExtension__0_k$();
    nodeAABB._upperBound._y_6 = aabb._upperBound._y_6 + Settings_getInstance()._get_aabbExtension__0_k$();
    node._userData = userData;
    insertLeaf(this, proxyId);
    return proxyId;
  };
  DynamicTree.prototype.destroyProxy_majfzk_k$ = function (proxyId) {
    var tmp0_assert_0 = 0 <= proxyId ? proxyId < this._m_nodeCapacity : false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var node = ensureNotNull(this._m_nodes)[proxyId];
    var tmp1_assert_0 = node._child1 == null;
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }removeLeaf(this, node);
    freeNode(this, node);
  };
  DynamicTree.prototype.moveProxy_dsi6ps_k$ = function (proxyId, aabb, displacement) {
    var tmp0_assert_0 = aabb._get_isValid__0_k$();
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = 0 <= proxyId ? proxyId < this._m_nodeCapacity : false;
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }var node = ensureNotNull(this._m_nodes)[proxyId];
    var tmp2_assert_0 = node._child1 == null;
    if (!tmp2_assert_0) {
      var message_2_1_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
    }var nodeAABB = node._aabb_0;
    if (((nodeAABB._lowerBound._x_7 <= aabb._lowerBound._x_7 ? nodeAABB._lowerBound._y_6 <= aabb._lowerBound._y_6 : false) ? aabb._upperBound._x_7 <= nodeAABB._upperBound._x_7 : false) ? aabb._upperBound._y_6 <= nodeAABB._upperBound._y_6 : false) {
      return false;
    }removeLeaf(this, node);
    var lowerBound_0 = nodeAABB._lowerBound;
    var upperBound_0 = nodeAABB._upperBound;
    lowerBound_0._x_7 = aabb._lowerBound._x_7 - Settings_getInstance()._get_aabbExtension__0_k$();
    lowerBound_0._y_6 = aabb._lowerBound._y_6 - Settings_getInstance()._get_aabbExtension__0_k$();
    upperBound_0._x_7 = aabb._upperBound._x_7 + Settings_getInstance()._get_aabbExtension__0_k$();
    upperBound_0._y_6 = aabb._upperBound._y_6 + Settings_getInstance()._get_aabbExtension__0_k$();
    var dx = displacement._x_7 * Settings_getInstance()._get_aabbMultiplier__0_k$();
    var dy = displacement._y_6 * Settings_getInstance()._get_aabbMultiplier__0_k$();
    if (dx < 0.0) {
      var tmp0_this = lowerBound_0;
      tmp0_this._x_7 = tmp0_this._x_7 + dx;
    } else {
      var tmp1_this = upperBound_0;
      tmp1_this._x_7 = tmp1_this._x_7 + dx;
    }
    if (dy < 0.0) {
      var tmp2_this = lowerBound_0;
      tmp2_this._y_6 = tmp2_this._y_6 + dy;
    } else {
      var tmp3_this = upperBound_0;
      tmp3_this._y_6 = tmp3_this._y_6 + dy;
    }
    insertLeaf(this, proxyId);
    return true;
  };
  DynamicTree.prototype.getUserData_ha5a7z_k$ = function (proxyId) {
    var tmp0_assert_0 = 0 <= proxyId ? proxyId < this._m_nodeCapacity : false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }return ensureNotNull(this._m_nodes)[proxyId]._userData;
  };
  DynamicTree.prototype.getFatAABB_ha5a7z_k$ = function (proxyId) {
    var tmp0_assert_0 = 0 <= proxyId ? proxyId < this._m_nodeCapacity : false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }return ensureNotNull(this._m_nodes)[proxyId]._aabb_0;
  };
  DynamicTree.prototype.query_qronny_k$ = function (callback, aabb) {
    var tmp0_assert_0 = aabb._get_isValid__0_k$();
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }this._nodeStackIndex = 0;
    var tmp = this._nodeStack;
    var tmp0_this = this;
    var tmp1 = tmp0_this._nodeStackIndex;
    tmp0_this._nodeStackIndex = tmp1 + 1 | 0;
    tmp[tmp1] = this._m_root;
    while (this._nodeStackIndex > 0) {
      var tmp_0 = this._nodeStack;
      var tmp2_this = this;
      tmp2_this._nodeStackIndex = tmp2_this._nodeStackIndex - 1 | 0;
      var tmp3_elvis_lhs = tmp_0[tmp2_this._nodeStackIndex];
      var tmp_1;
      if (tmp3_elvis_lhs == null) {
        continue;
      } else {
        tmp_1 = tmp3_elvis_lhs;
      }
      var node = tmp_1;
      if (Companion_getInstance_58().testOverlap_m24bo_k$(node._aabb_0, aabb)) {
        if (node._child1 == null) {
          var proceed = callback.treeCallback_ha5a7z_k$(node._id_2);
          if (!proceed) {
            return Unit_getInstance();
          }} else {
          if (((this._nodeStack.length - this._nodeStackIndex | 0) - 2 | 0) <= 0) {
            var tmp1_arrayOfNulls_0 = imul(this._nodeStack.length, 2);
            var newBuffer = fillArrayVal(Array(tmp1_arrayOfNulls_0), null);
            var tmp2_arraycopy_0 = this._nodeStack;
            var tmp3_arraycopy_0 = this._nodeStack.length;
            var tmp0_copyInto_0_2 = 0 + tmp3_arraycopy_0 | 0;
            arrayCopy_0(tmp2_arraycopy_0, newBuffer, 0, 0, tmp0_copyInto_0_2);
            Unit_getInstance();
            this._nodeStack = newBuffer;
          }var tmp_2 = this._nodeStack;
          var tmp4_this = this;
          var tmp5 = tmp4_this._nodeStackIndex;
          tmp4_this._nodeStackIndex = tmp5 + 1 | 0;
          tmp_2[tmp5] = node._child1;
          var tmp_3 = this._nodeStack;
          var tmp6_this = this;
          var tmp7 = tmp6_this._nodeStackIndex;
          tmp6_this._nodeStackIndex = tmp7 + 1 | 0;
          tmp_3[tmp7] = node._child2;
        }
      }}
  };
  DynamicTree.$metadata$ = {
    simpleName: 'DynamicTree',
    kind: 'class',
    interfaces: [BroadPhaseStrategy]
  };
  function DynamicTreeNode(id) {
    this._id_2 = id;
    this._$$delegate_0_0 = new Mixin_0();
    this._aabb_0 = AABB_init_$Create$();
    this._userData = Unit_getInstance();
    this._parent = null;
    this._child1 = null;
    this._child2 = null;
    this._height_2 = 0;
  }
  DynamicTreeNode.$metadata$ = {
    simpleName: 'DynamicTreeNode',
    kind: 'class',
    interfaces: [Box2dTypedUserData]
  };
  function ChainShape() {
  }
  ChainShape.prototype.getChildEdge_kjy5fq_k$ = function (edge, index_0) {
    var tmp0_assert_0 = 0 <= index_0 ? index_0 < (this._count_3 - 1 | 0) : false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }edge._set_radius__cpozfn_k$(this._get_radius__0_k$());
    var v0 = ensureNotNull(this._vertices_1)[index_0 + 0 | 0];
    var v1 = ensureNotNull(this._vertices_1)[index_0 + 1 | 0];
    edge._vertex1._x_7 = v0._x_7;
    edge._vertex1._y_6 = v0._y_6;
    edge._vertex2._x_7 = v1._x_7;
    edge._vertex2._y_6 = v1._y_6;
    if (index_0 > 0) {
      var v = ensureNotNull(this._vertices_1)[index_0 - 1 | 0];
      edge._vertex0._x_7 = v._x_7;
      edge._vertex0._y_6 = v._y_6;
      edge._hasVertex0 = true;
    } else {
      edge._vertex0._x_7 = this._prevVertex._x_7;
      edge._vertex0._y_6 = this._prevVertex._y_6;
      edge._hasVertex0 = this._hasPrevVertex;
    }
    if (index_0 < (this._count_3 - 2 | 0)) {
      var v_0 = ensureNotNull(this._vertices_1)[index_0 + 2 | 0];
      edge._vertex3._x_7 = v_0._x_7;
      edge._vertex3._y_6 = v_0._y_6;
      edge._hasVertex3 = true;
    } else {
      edge._vertex3._x_7 = this._nextVertex._x_7;
      edge._vertex3._y_6 = this._nextVertex._y_6;
      edge._hasVertex3 = this._hasNextVertex;
    }
  };
  ChainShape.$metadata$ = {
    simpleName: 'ChainShape',
    kind: 'class',
    interfaces: []
  };
  function CircleShape_init_$Init$(radius, $this) {
    CircleShape.call($this);
    $this._set_radius__cpozfn_k$(numberToDouble(radius));
    return $this;
  }
  function CircleShape_init_$Create$(radius) {
    return CircleShape_init_$Init$(radius, Object.create(CircleShape.prototype));
  }
  function CircleShape() {
    Shape.call(this, ShapeType_CIRCLE_getInstance());
    var tmp = this;
    tmp._p_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  CircleShape.prototype.clone_0_k$ = function () {
    var shape = new CircleShape();
    shape._p_0._x_7 = this._p_0._x_7;
    shape._p_0._y_6 = this._p_0._y_6;
    shape._set_radius__cpozfn_k$(this._get_radius__0_k$());
    return shape;
  };
  CircleShape.prototype.getChildCount_0_k$ = function () {
    return 1;
  };
  CircleShape.prototype.computeDistanceToOut_m1unj2_k$ = function (xf, p, childIndex, normalOut) {
    var xfq = xf._q;
    var centerx = xfq._c_0 * this._p_0._x_7 - xfq._s * this._p_0._y_6 + xf._p_1._x_7;
    var centery = xfq._s * this._p_0._x_7 + xfq._c_0 * this._p_0._y_6 + xf._p_1._y_6;
    var dx = p._x_7 - centerx;
    var dy = p._y_6 - centery;
    var d1 = Companion_getInstance_68().sqrt_dbmacu_k$(dx * dx + dy * dy);
    normalOut._x_7 = dx * 1 / d1;
    normalOut._y_6 = dy * 1 / d1;
    return d1 - this._get_radius__0_k$();
  };
  CircleShape.prototype.raycast_nhm1uj_k$ = function (output_0, input, transform, childIndex) {
    var inputp1 = input._p1;
    var inputp2 = input._p2;
    var tq = transform._q;
    var tp = transform._p_1;
    var positionx = tq._c_0 * this._p_0._x_7 - tq._s * this._p_0._y_6 + tp._x_7;
    var positiony = tq._s * this._p_0._x_7 + tq._c_0 * this._p_0._y_6 + tp._y_6;
    var sx = inputp1._x_7 - positionx;
    var sy = inputp1._y_6 - positiony;
    var b = sx * sx + sy * sy - this._get_radius__0_k$() * this._get_radius__0_k$();
    var rx = inputp2._x_7 - inputp1._x_7;
    var ry = inputp2._y_6 - inputp1._y_6;
    var c = sx * rx + sy * ry;
    var rr = rx * rx + ry * ry;
    var sigma = c * c - rr * b;
    if (sigma < 0.0 ? true : rr < Settings_getInstance()._EPSILON) {
      return false;
    }var a = -(c + Companion_getInstance_68().sqrt_dbmacu_k$(sigma));
    if (0.0 <= a ? a <= input._maxFraction * rr : false) {
      a = a / rr;
      output_0._fraction = a;
      output_0._normal_1._x_7 = rx * a + sx;
      output_0._normal_1._y_6 = ry * a + sy;
      output_0._normal_1.normalize_0_k$();
      Unit_getInstance();
      return true;
    }return false;
  };
  CircleShape.prototype.computeAABB_n67093_k$ = function (aabb, transform, childIndex) {
    var tq = transform._q;
    var tp = transform._p_1;
    var px = tq._c_0 * this._p_0._x_7 - tq._s * this._p_0._y_6 + tp._x_7;
    var py = tq._s * this._p_0._x_7 + tq._c_0 * this._p_0._y_6 + tp._y_6;
    aabb._lowerBound._x_7 = px - this._get_radius__0_k$();
    aabb._lowerBound._y_6 = py - this._get_radius__0_k$();
    aabb._upperBound._x_7 = px + this._get_radius__0_k$();
    aabb._upperBound._y_6 = py + this._get_radius__0_k$();
  };
  CircleShape.prototype.computeMass_onjsjz_k$ = function (massData, density) {
    massData._mass = density * Settings_getInstance()._PI_0 * this._get_radius__0_k$() * this._get_radius__0_k$();
    massData._center._x_7 = this._p_0._x_7;
    massData._center._y_6 = this._p_0._y_6;
    massData._I = massData._mass * (0.5 * this._get_radius__0_k$() * this._get_radius__0_k$() + (this._p_0._x_7 * this._p_0._x_7 + this._p_0._y_6 * this._p_0._y_6));
  };
  CircleShape.$metadata$ = {
    simpleName: 'CircleShape',
    kind: 'class',
    interfaces: []
  };
  function EdgeShape() {
    Shape.call(this, ShapeType_EDGE_getInstance());
    var tmp = this;
    tmp._vertex1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._vertex2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_1 = this;
    tmp_1._vertex0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_2 = this;
    tmp_2._vertex3 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._hasVertex0 = false;
    this._hasVertex3 = false;
    var tmp_3 = this;
    tmp_3._normal_4 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._set_radius__cpozfn_k$(Settings_getInstance()._get_polygonRadius__0_k$());
  }
  EdgeShape.prototype.getChildCount_0_k$ = function () {
    return 1;
  };
  EdgeShape.prototype.computeDistanceToOut_m1unj2_k$ = function (xf, p, childIndex, normalOut) {
    var xfqc = xf._q._c_0;
    var xfqs = xf._q._s;
    var xfpx = xf._p_1._x_7;
    var xfpy = xf._p_1._y_6;
    var v1x = xfqc * this._vertex1._x_7 - xfqs * this._vertex1._y_6 + xfpx;
    var v1y = xfqs * this._vertex1._x_7 + xfqc * this._vertex1._y_6 + xfpy;
    var v2x = xfqc * this._vertex2._x_7 - xfqs * this._vertex2._y_6 + xfpx;
    var v2y = xfqs * this._vertex2._x_7 + xfqc * this._vertex2._y_6 + xfpy;
    var dx = p._x_7 - v1x;
    var dy = p._y_6 - v1y;
    var sx = v2x - v1x;
    var sy = v2y - v1y;
    var ds = dx * sx + dy * sy;
    if (ds > 0) {
      var s2 = sx * sx + sy * sy;
      if (ds > s2) {
        dx = p._x_7 - v2x;
        dy = p._y_6 - v2y;
      } else {
        dx = dx - ds / s2 * sx;
        dy = dy - ds / s2 * sy;
      }
    }var d1 = Companion_getInstance_68().sqrt_dbmacu_k$(dx * dx + dy * dy);
    if (d1 > 0) {
      normalOut._x_7 = 1 / d1 * dx;
      normalOut._y_6 = 1 / d1 * dy;
    } else {
      normalOut._x_7 = 0.0;
      normalOut._y_6 = 0.0;
    }
    return d1;
  };
  EdgeShape.prototype.raycast_nhm1uj_k$ = function (output_0, input, xf, childIndex) {
    var tempx;
    var tempy;
    var v1 = this._vertex1;
    var v2 = this._vertex2;
    var xfq = xf._q;
    var xfp = xf._p_1;
    tempx = input._p1._x_7 - xfp._x_7;
    tempy = input._p1._y_6 - xfp._y_6;
    var p1x = xfq._c_0 * tempx + xfq._s * tempy;
    var p1y = -xfq._s * tempx + xfq._c_0 * tempy;
    tempx = input._p2._x_7 - xfp._x_7;
    tempy = input._p2._y_6 - xfp._y_6;
    var p2x = xfq._c_0 * tempx + xfq._s * tempy;
    var p2y = -xfq._s * tempx + xfq._c_0 * tempy;
    var dx = p2x - p1x;
    var dy = p2y - p1y;
    this._normal_4._x_7 = v2._y_6 - v1._y_6;
    this._normal_4._y_6 = v1._x_7 - v2._x_7;
    this._normal_4.normalize_0_k$();
    Unit_getInstance();
    var normalx = this._normal_4._x_7;
    var normaly = this._normal_4._y_6;
    tempx = v1._x_7 - p1x;
    tempy = v1._y_6 - p1y;
    var numerator = normalx * tempx + normaly * tempy;
    var denominator = normalx * dx + normaly * dy;
    if (denominator === 0.0) {
      return false;
    }var t = numerator / denominator;
    if (t < 0.0 ? true : 1.0 < t) {
      return false;
    }var qx = p1x + t * dx;
    var qy = p1y + t * dy;
    var rx = v2._x_7 - v1._x_7;
    var ry = v2._y_6 - v1._y_6;
    var rr = rx * rx + ry * ry;
    if (rr === 0.0) {
      return false;
    }tempx = qx - v1._x_7;
    tempy = qy - v1._y_6;
    var s = (tempx * rx + tempy * ry) / rr;
    if (s < 0.0 ? true : 1.0 < s) {
      return false;
    }output_0._fraction = t;
    if (numerator > 0.0) {
      output_0._normal_1._x_7 = -xfq._c_0 * this._normal_4._x_7 + xfq._s * this._normal_4._y_6;
      output_0._normal_1._y_6 = -xfq._s * this._normal_4._x_7 - xfq._c_0 * this._normal_4._y_6;
    } else {
      output_0._normal_1._x_7 = xfq._c_0 * this._normal_4._x_7 - xfq._s * this._normal_4._y_6;
      output_0._normal_1._y_6 = xfq._s * this._normal_4._x_7 + xfq._c_0 * this._normal_4._y_6;
    }
    return true;
  };
  EdgeShape.prototype.computeAABB_n67093_k$ = function (aabb, xf, childIndex) {
    var lowerBound_0 = aabb._lowerBound;
    var upperBound_0 = aabb._upperBound;
    var xfq = xf._q;
    var v1x = xfq._c_0 * this._vertex1._x_7 - xfq._s * this._vertex1._y_6 + xf._p_1._x_7;
    var v1y = xfq._s * this._vertex1._x_7 + xfq._c_0 * this._vertex1._y_6 + xf._p_1._y_6;
    var v2x = xfq._c_0 * this._vertex2._x_7 - xfq._s * this._vertex2._y_6 + xf._p_1._x_7;
    var v2y = xfq._s * this._vertex2._x_7 + xfq._c_0 * this._vertex2._y_6 + xf._p_1._y_6;
    lowerBound_0._x_7 = v1x < v2x ? v1x : v2x;
    lowerBound_0._y_6 = v1y < v2y ? v1y : v2y;
    upperBound_0._x_7 = v1x > v2x ? v1x : v2x;
    upperBound_0._y_6 = v1y > v2y ? v1y : v2y;
    var tmp0_this = lowerBound_0;
    tmp0_this._x_7 = tmp0_this._x_7 - this._get_radius__0_k$();
    var tmp1_this = lowerBound_0;
    tmp1_this._y_6 = tmp1_this._y_6 - this._get_radius__0_k$();
    var tmp2_this = upperBound_0;
    tmp2_this._x_7 = tmp2_this._x_7 + this._get_radius__0_k$();
    var tmp3_this = upperBound_0;
    tmp3_this._y_6 = tmp3_this._y_6 + this._get_radius__0_k$();
  };
  EdgeShape.prototype.computeMass_onjsjz_k$ = function (massData, density) {
    massData._mass = 0.0;
    massData._center.set_1v0asv_k$(this._vertex1).addLocal_1v0asv_k$(this._vertex2).mulLocal_dbmacu_k$(0.5);
    Unit_getInstance();
    massData._I = 0.0;
  };
  EdgeShape.prototype.clone_0_k$ = function () {
    var edge = new EdgeShape();
    edge._set_radius__cpozfn_k$(this._get_radius__0_k$());
    edge._hasVertex0 = this._hasVertex0;
    edge._hasVertex3 = this._hasVertex3;
    edge._vertex0.set_1v0asv_k$(this._vertex0);
    Unit_getInstance();
    edge._vertex1.set_1v0asv_k$(this._vertex1);
    Unit_getInstance();
    edge._vertex2.set_1v0asv_k$(this._vertex2);
    Unit_getInstance();
    edge._vertex3.set_1v0asv_k$(this._vertex3);
    Unit_getInstance();
    return edge;
  };
  EdgeShape.$metadata$ = {
    simpleName: 'EdgeShape',
    kind: 'class',
    interfaces: []
  };
  function MassData_init_$Init$($this) {
    MassData.call($this);
    $this._I = 0.0;
    $this._mass = $this._I;
    var tmp = $this;
    tmp._center = Vec2_init_$Create$(0.0, 0.0, 3, null);
    return $this;
  }
  function MassData_init_$Create$() {
    return MassData_init_$Init$(Object.create(MassData.prototype));
  }
  function MassData() {
    this._mass = 0;
    this._I = 0;
  }
  MassData.$metadata$ = {
    simpleName: 'MassData',
    kind: 'class',
    interfaces: []
  };
  function Companion_65() {
    Companion_instance_64 = this;
    this._m_debug = false;
  }
  Companion_65.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_64;
  function Companion_getInstance_64() {
    if (Companion_instance_64 == null)
      new Companion_65();
    return Companion_instance_64;
  }
  function PolygonShape() {
    Companion_getInstance_64();
    Shape.call(this, ShapeType_POLYGON_getInstance());
    var tmp = this;
    tmp._centroid = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = Settings_getInstance()._get_maxPolygonVertices__0_k$();
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = Vec2_init_$Create$(0.0, 0.0, 3, null);
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._vertices_2 = tmp_3;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = Settings_getInstance()._get_maxPolygonVertices__0_k$();
    var tmp_8 = fillArrayVal(Array(tmp_7), null);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      tmp_8[tmp_9] = Vec2_init_$Create$(0.0, 0.0, 3, null);
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5._normals_0 = tmp_8;
    this._count_4 = 0;
    var tmp_10 = this;
    tmp_10._pool1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_11 = this;
    tmp_11._pool2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_12 = this;
    tmp_12._pool3_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_13 = this;
    tmp_13._pool4_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._poolt1 = Transform_init_$Create$_0();
    this._set_radius__cpozfn_k$(Settings_getInstance()._get_polygonRadius__0_k$());
    this._centroid.setZero_sv8swh_k$();
  }
  PolygonShape.prototype.clone_0_k$ = function () {
    var shape = new PolygonShape();
    shape._centroid.set_1v0asv_k$(this._centroid);
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = shape._normals_0.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        shape._normals_0[i].set_1v0asv_k$(this._normals_0[i]);
        Unit_getInstance();
        shape._vertices_2[i].set_1v0asv_k$(this._vertices_2[i]);
        Unit_getInstance();
      }
       while (inductionVariable <= last_1);
    shape._set_radius__cpozfn_k$(this._get_radius__0_k$());
    shape._count_4 = this._count_4;
    return shape;
  };
  PolygonShape.prototype.getChildCount_0_k$ = function () {
    return 1;
  };
  PolygonShape.prototype.computeAABB_n67093_k$ = function (aabb, xf, childIndex) {
    var lower = aabb._lowerBound;
    var upper = aabb._upperBound;
    var v1 = this._vertices_2[0];
    var xfqc = xf._q._c_0;
    var xfqs = xf._q._s;
    var xfpx = xf._p_1._x_7;
    var xfpy = xf._p_1._y_6;
    lower._x_7 = xfqc * v1._x_7 - xfqs * v1._y_6 + xfpx;
    lower._y_6 = xfqs * v1._x_7 + xfqc * v1._y_6 + xfpy;
    upper._x_7 = lower._x_7;
    upper._y_6 = lower._y_6;
    var inductionVariable = 1;
    var last_1 = this._count_4;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v2 = this._vertices_2[i];
        var vx = xfqc * v2._x_7 - xfqs * v2._y_6 + xfpx;
        var vy = xfqs * v2._x_7 + xfqc * v2._y_6 + xfpy;
        lower._x_7 = lower._x_7 < vx ? lower._x_7 : vx;
        lower._y_6 = lower._y_6 < vy ? lower._y_6 : vy;
        upper._x_7 = upper._x_7 > vx ? upper._x_7 : vx;
        upper._y_6 = upper._y_6 > vy ? upper._y_6 : vy;
      }
       while (inductionVariable < last_1);
    var tmp1_this = lower;
    tmp1_this._x_7 = tmp1_this._x_7 - this._get_radius__0_k$();
    var tmp2_this = lower;
    tmp2_this._y_6 = tmp2_this._y_6 - this._get_radius__0_k$();
    var tmp3_this = upper;
    tmp3_this._x_7 = tmp3_this._x_7 + this._get_radius__0_k$();
    var tmp4_this = upper;
    tmp4_this._y_6 = tmp4_this._y_6 + this._get_radius__0_k$();
  };
  PolygonShape.prototype.computeDistanceToOut_m1unj2_k$ = function (xf, p, childIndex, normalOut) {
    var xfqc = xf._q._c_0;
    var xfqs = xf._q._s;
    var tx_0 = p._x_7 - xf._p_1._x_7;
    var ty_0 = p._y_6 - xf._p_1._y_6;
    var pLocalx = xfqc * tx_0 + xfqs * ty_0;
    var pLocaly = -xfqs * tx_0 + xfqc * ty_0;
    FloatCompanionObject_getInstance();
    var maxDistance = -3.4028235E38;
    var normalForMaxDistanceX = pLocalx;
    var normalForMaxDistanceY = pLocaly;
    var inductionVariable = 0;
    var last_1 = this._count_4;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var vertex = this._vertices_2[i];
        var normal = this._normals_0[i];
        tx_0 = pLocalx - vertex._x_7;
        ty_0 = pLocaly - vertex._y_6;
        var dot_0 = normal._x_7 * tx_0 + normal._y_6 * ty_0;
        if (dot_0 > maxDistance) {
          maxDistance = dot_0;
          normalForMaxDistanceX = normal._x_7;
          normalForMaxDistanceY = normal._y_6;
        }}
       while (inductionVariable < last_1);
    var distance;
    if (maxDistance > 0) {
      var minDistanceX = normalForMaxDistanceX;
      var minDistanceY = normalForMaxDistanceY;
      var minDistance2 = maxDistance * maxDistance;
      var inductionVariable_0 = 0;
      var last_2 = this._count_4;
      if (inductionVariable_0 < last_2)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var vertex_0 = this._vertices_2[i_0];
          var distanceVecX = pLocalx - vertex_0._x_7;
          var distanceVecY = pLocaly - vertex_0._y_6;
          var distance2 = distanceVecX * distanceVecX + distanceVecY * distanceVecY;
          if (minDistance2 > distance2) {
            minDistanceX = distanceVecX;
            minDistanceY = distanceVecY;
            minDistance2 = distance2;
          }}
         while (inductionVariable_0 < last_2);
      distance = Companion_getInstance_68().sqrt_dbmacu_k$(minDistance2);
      normalOut._x_7 = xfqc * minDistanceX - xfqs * minDistanceY;
      normalOut._y_6 = xfqs * minDistanceX + xfqc * minDistanceY;
      normalOut.normalize_0_k$();
      Unit_getInstance();
    } else {
      distance = maxDistance;
      normalOut._x_7 = xfqc * normalForMaxDistanceX - xfqs * normalForMaxDistanceY;
      normalOut._y_6 = xfqs * normalForMaxDistanceX + xfqc * normalForMaxDistanceY;
    }
    return distance;
  };
  PolygonShape.prototype.raycast_nhm1uj_k$ = function (output_0, input, xf, childIndex) {
    var xfqc = xf._q._c_0;
    var xfqs = xf._q._s;
    var xfp = xf._p_1;
    var tempx;
    var tempy;
    tempx = input._p1._x_7 - xfp._x_7;
    tempy = input._p1._y_6 - xfp._y_6;
    var p1x = xfqc * tempx + xfqs * tempy;
    var p1y = -xfqs * tempx + xfqc * tempy;
    tempx = input._p2._x_7 - xfp._x_7;
    tempy = input._p2._y_6 - xfp._y_6;
    var p2x = xfqc * tempx + xfqs * tempy;
    var p2y = -xfqs * tempx + xfqc * tempy;
    var dx = p2x - p1x;
    var dy = p2y - p1y;
    var lower = 0.0;
    var upper = input._maxFraction;
    var index_0 = -1;
    var inductionVariable = 0;
    var last_1 = this._count_4;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var normal = this._normals_0[i];
        var vertex = this._vertices_2[i];
        var tempxn = vertex._x_7 - p1x;
        var tempyn = vertex._y_6 - p1y;
        var numerator = normal._x_7 * tempxn + normal._y_6 * tempyn;
        var denominator = normal._x_7 * dx + normal._y_6 * dy;
        if (denominator === 0.0) {
          if (numerator < 0.0) {
            return false;
          }} else {
          if (denominator < 0.0 ? numerator < lower * denominator : false) {
            lower = numerator / denominator;
            index_0 = i;
          } else if (denominator > 0.0 ? numerator < upper * denominator : false) {
            upper = numerator / denominator;
          }}
        if (upper < lower) {
          return false;
        }}
       while (inductionVariable < last_1);
    var tmp0_assert_0 = 0.0 <= lower ? lower <= input._maxFraction : false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }if (index_0 >= 0) {
      output_0._fraction = lower;
      var normal_0 = this._normals_0[index_0];
      var out = output_0._normal_1;
      out._x_7 = xfqc * normal_0._x_7 - xfqs * normal_0._y_6;
      out._y_6 = xfqs * normal_0._x_7 + xfqc * normal_0._y_6;
      return true;
    }return false;
  };
  PolygonShape.prototype.computeMass_onjsjz_k$ = function (massData, density) {
    var tmp0_assert_0 = this._count_4 >= 3;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var center = this._pool1;
    center.setZero_sv8swh_k$();
    var area = 0.0;
    var I = 0.0;
    var s = this._pool2;
    s.setZero_sv8swh_k$();
    var inductionVariable = 0;
    var last_1 = this._count_4;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        s.addLocal_1v0asv_k$(this._vertices_2[i]);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    s.mulLocal_dbmacu_k$(1.0 / this._count_4);
    Unit_getInstance();
    var k_inv3 = 1.0 / 3.0;
    var e1 = this._pool3_0;
    var e2 = this._pool4_0;
    var inductionVariable_0 = 0;
    var last_2 = this._count_4;
    if (inductionVariable_0 < last_2)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        e1.set_1v0asv_k$(this._vertices_2[i_0]).subLocal_1v0asv_k$(s);
        Unit_getInstance();
        e2.set_1v0asv_k$(s).negateLocal_0_k$().addLocal_1v0asv_k$((i_0 + 1 | 0) < this._count_4 ? this._vertices_2[i_0 + 1 | 0] : this._vertices_2[0]);
        Unit_getInstance();
        var D = Companion_getInstance_71().cross_5kvz1c_k$(e1, e2);
        var triangleArea = 0.5 * D;
        area = area + triangleArea;
        var tmp2_this = center;
        tmp2_this._x_7 = tmp2_this._x_7 + triangleArea * k_inv3 * (e1._x_7 + e2._x_7);
        var tmp3_this = center;
        tmp3_this._y_6 = tmp3_this._y_6 + triangleArea * k_inv3 * (e1._y_6 + e2._y_6);
        var ex1 = e1._x_7;
        var ey1 = e1._y_6;
        var ex2 = e2._x_7;
        var ey2 = e2._y_6;
        var intx2 = ex1 * ex1 + ex2 * ex1 + ex2 * ex2;
        var inty2 = ey1 * ey1 + ey2 * ey1 + ey2 * ey2;
        I = I + 0.25 * k_inv3 * D * (intx2 + inty2);
      }
       while (inductionVariable_0 < last_2);
    massData._mass = density * area;
    var tmp1_assert_0 = area > Settings_getInstance()._EPSILON;
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }center.mulLocal_dbmacu_k$(1.0 / area);
    Unit_getInstance();
    massData._center.set_1v0asv_k$(center).addLocal_1v0asv_k$(s);
    Unit_getInstance();
    massData._I = I * density;
    var tmp4_this = massData;
    tmp4_this._I = tmp4_this._I + massData._mass * Companion_getInstance_71().dot_5kvz1c_k$(massData._center, massData._center);
  };
  PolygonShape.$metadata$ = {
    simpleName: 'PolygonShape',
    kind: 'class',
    interfaces: []
  };
  function Shape(m_type) {
    this._m_type_0 = m_type;
    this._radius_0 = 0.0;
  }
  Shape.prototype._set_radius__cpozfn_k$ = function (_set___) {
    this._radius_0 = _set___;
  };
  Shape.prototype._get_radius__0_k$ = function () {
    return this._radius_0;
  };
  Shape.prototype.getType_0_k$ = function () {
    return this._m_type_0;
  };
  Shape.$metadata$ = {
    simpleName: 'Shape',
    kind: 'class',
    interfaces: []
  };
  var ShapeType_CIRCLE_instance;
  var ShapeType_EDGE_instance;
  var ShapeType_POLYGON_instance;
  var ShapeType_CHAIN_instance;
  function values_0() {
    return [ShapeType_CIRCLE_getInstance(), ShapeType_EDGE_getInstance(), ShapeType_POLYGON_getInstance(), ShapeType_CHAIN_getInstance()];
  }
  var ShapeType_entriesInitialized;
  function ShapeType_initEntries() {
    if (ShapeType_entriesInitialized)
      return Unit_getInstance();
    ShapeType_entriesInitialized = true;
    ShapeType_CIRCLE_instance = new ShapeType('CIRCLE', 0);
    ShapeType_EDGE_instance = new ShapeType('EDGE', 1);
    ShapeType_POLYGON_instance = new ShapeType('POLYGON', 2);
    ShapeType_CHAIN_instance = new ShapeType('CHAIN', 3);
  }
  function ShapeType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  ShapeType.$metadata$ = {
    simpleName: 'ShapeType',
    kind: 'class',
    interfaces: []
  };
  function ShapeType_CIRCLE_getInstance() {
    ShapeType_initEntries();
    return ShapeType_CIRCLE_instance;
  }
  function ShapeType_EDGE_getInstance() {
    ShapeType_initEntries();
    return ShapeType_EDGE_instance;
  }
  function ShapeType_POLYGON_getInstance() {
    ShapeType_initEntries();
    return ShapeType_POLYGON_instance;
  }
  function ShapeType_CHAIN_getInstance() {
    ShapeType_initEntries();
    return ShapeType_CHAIN_instance;
  }
  function BufferUtils() {
    BufferUtils_instance = this;
  }
  BufferUtils.prototype.reallocateBuffer_uahium_k$ = function (klass, oldBuffer, oldCapacity, newCapacity) {
    var tmp0_assert_0 = newCapacity > oldCapacity;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp = 0;
    var tmp_0 = newCapacity;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = (!(oldBuffer == null) ? tmp_2 < oldCapacity : false) ? oldBuffer[tmp_2] : klass();
      tmp = tmp + 1 | 0;
    }
    var tmp_3 = tmp_1;
    return isArray(tmp_3) ? tmp_3 : THROW_CCE();
  };
  BufferUtils.$metadata$ = {
    simpleName: 'BufferUtils',
    kind: 'object',
    interfaces: []
  };
  var BufferUtils_instance;
  function BufferUtils_getInstance() {
    if (BufferUtils_instance == null)
      new BufferUtils();
    return BufferUtils_instance;
  }
  function Color3f_init_$Init$($this) {
    Color3f.call($this);
    $this._z_0 = 0.0;
    $this._y_5 = $this._z_0;
    $this._x_6 = $this._y_5;
    return $this;
  }
  function Color3f_init_$Create$() {
    return Color3f_init_$Init$(Object.create(Color3f.prototype));
  }
  function Color3f_init_$Init$_0(r, g, b, $this) {
    Color3f.call($this);
    $this._x_6 = r;
    $this._y_5 = g;
    $this._z_0 = b;
    return $this;
  }
  function Color3f_init_$Create$_0(r, g, b) {
    return Color3f_init_$Init$_0(r, g, b, Object.create(Color3f.prototype));
  }
  function Companion_66() {
    Companion_instance_65 = this;
    this._WHITE = Color3f_init_$Create$_0(1.0, 1.0, 1.0);
    this._BLACK = Color3f_init_$Create$_0(0.0, 0.0, 0.0);
    this._BLUE = Color3f_init_$Create$_0(0.0, 0.0, 1.0);
    this._GREEN = Color3f_init_$Create$_0(0.0, 1.0, 0.0);
    this._RED = Color3f_init_$Create$_0(1.0, 0.0, 0.0);
  }
  Companion_66.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_65;
  function Companion_getInstance_65() {
    if (Companion_instance_65 == null)
      new Companion_66();
    return Companion_instance_65;
  }
  function Color3f() {
    Companion_getInstance_65();
    this._x_6 = 0;
    this._y_5 = 0;
    this._z_0 = 0;
  }
  Color3f.$metadata$ = {
    simpleName: 'Color3f',
    kind: 'class',
    interfaces: []
  };
  function Mat22_init_$Init$($this) {
    Mat22.call($this);
    var tmp = $this;
    tmp._ex = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = $this;
    tmp_0._ey = Vec2_init_$Create$(0.0, 0.0, 3, null);
    return $this;
  }
  function Mat22_init_$Create$() {
    return Mat22_init_$Init$(Object.create(Mat22.prototype));
  }
  function Companion_67() {
    Companion_instance_66 = this;
  }
  Companion_67.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_66;
  function Companion_getInstance_66() {
    if (Companion_instance_66 == null)
      new Companion_67();
    return Companion_instance_66;
  }
  Mat22.prototype.toString = function () {
    var s = '';
    s = s + ('[' + this._ex._x_7 + ',' + this._ey._x_7 + ']\n');
    s = s + ('[' + this._ex._y_6 + ',' + this._ey._y_6 + ']');
    return s;
  };
  Mat22.prototype.setZero_sv8swh_k$ = function () {
    this._ex._x_7 = 0.0;
    this._ey._x_7 = 0.0;
    this._ex._y_6 = 0.0;
    this._ey._y_6 = 0.0;
  };
  Mat22.prototype.invertToOut_puyjoi_k$ = function (out) {
    var a = this._ex._x_7;
    var b = this._ey._x_7;
    var c = this._ex._y_6;
    var d = this._ey._y_6;
    var det = a * d - b * c;
    det = 1.0 / det;
    out._ex._x_7 = det * d;
    out._ey._x_7 = -det * b;
    out._ex._y_6 = -det * c;
    out._ey._y_6 = det * a;
  };
  Mat22.prototype.hashCode = function () {
    var prime = 31;
    var result = 1;
    var tmp = imul(prime, result);
    var tmp0_safe_receiver = this._ex;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(prime, result);
    var tmp2_safe_receiver = this._ey;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    return result;
  };
  Mat22.prototype.equals = function (obj) {
    if (this === obj)
      return true;
    if (obj == null)
      return false;
    if (!getKClassFromExpression_0(this).equals(getKClassFromExpression_0(obj)))
      return false;
    var other = (obj == null ? true : obj instanceof Mat22) ? obj : THROW_CCE();
    if (this._ex == null) {
      var tmp0_safe_receiver = other;
      if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._ex) == null))
        return false;
      else {
      }
    } else {
      var tmp1_safe_receiver = other;
      if (!this._ex.equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver._ex))
        return false;
      else {
      }
    }
    if (this._ey == null) {
      var tmp2_safe_receiver = other;
      if (!((tmp2_safe_receiver == null ? null : tmp2_safe_receiver._ey) == null))
        return false;
      else {
      }
    } else {
      var tmp3_safe_receiver = other;
      if (!this._ey.equals(tmp3_safe_receiver == null ? null : tmp3_safe_receiver._ey))
        return false;
      else {
      }
    }
    return true;
  };
  function Mat22() {
    Companion_getInstance_66();
  }
  Mat22.$metadata$ = {
    simpleName: 'Mat22',
    kind: 'class',
    interfaces: []
  };
  function Mat33_init_$Init$($this) {
    Mat33.call($this);
    var tmp = $this;
    tmp._ex_0 = Vec3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_0 = $this;
    tmp_0._ey_0 = Vec3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_1 = $this;
    tmp_1._ez = Vec3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    return $this;
  }
  function Mat33_init_$Create$() {
    return Mat33_init_$Init$(Object.create(Mat33.prototype));
  }
  function Mat33_init_$Init$_0(argCol1, argCol2, argCol3, $this) {
    Mat33.call($this);
    $this._ex_0 = argCol1.clone_0_k$();
    $this._ey_0 = argCol2.clone_0_k$();
    $this._ez = argCol3.clone_0_k$();
    return $this;
  }
  function Mat33_init_$Create$_0(argCol1, argCol2, argCol3) {
    return Mat33_init_$Init$_0(argCol1, argCol2, argCol3, Object.create(Mat33.prototype));
  }
  function Companion_68() {
    Companion_instance_67 = this;
    this._IDENTITY = Mat33_init_$Create$_0(new Vec3(1.0, 0.0, 0.0), new Vec3(0.0, 1.0, 0.0), new Vec3(0.0, 0.0, 1.0));
  }
  Companion_68.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_67;
  function Companion_getInstance_67() {
    if (Companion_instance_67 == null)
      new Companion_68();
    return Companion_instance_67;
  }
  Mat33.prototype.hashCode = function () {
    var prime = 31;
    var result = 1;
    var tmp = imul(prime, result);
    var tmp0_safe_receiver = this._ex_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(prime, result);
    var tmp2_safe_receiver = this._ey_0;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_1 = imul(prime, result);
    var tmp4_safe_receiver = this._ez;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.hashCode();
    result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    return result;
  };
  Mat33.prototype.equals = function (obj) {
    if (this === obj)
      return true;
    if (obj == null)
      return false;
    if (!getKClassFromExpression_0(this).equals(getKClassFromExpression_0(obj)))
      return false;
    var other = (obj == null ? true : obj instanceof Mat33) ? obj : THROW_CCE();
    if (this._ex_0 == null) {
      var tmp0_safe_receiver = other;
      if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._ex_0) == null))
        return false;
      else {
      }
    } else {
      var tmp1_safe_receiver = other;
      if (!this._ex_0.equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver._ex_0))
        return false;
      else {
      }
    }
    if (this._ey_0 == null) {
      var tmp2_safe_receiver = other;
      if (!((tmp2_safe_receiver == null ? null : tmp2_safe_receiver._ey_0) == null))
        return false;
      else {
      }
    } else {
      var tmp3_safe_receiver = other;
      if (!this._ey_0.equals(tmp3_safe_receiver == null ? null : tmp3_safe_receiver._ey_0))
        return false;
      else {
      }
    }
    if (this._ez == null) {
      var tmp4_safe_receiver = other;
      if (!((tmp4_safe_receiver == null ? null : tmp4_safe_receiver._ez) == null))
        return false;
      else {
      }
    } else {
      var tmp5_safe_receiver = other;
      if (!this._ez.equals(tmp5_safe_receiver == null ? null : tmp5_safe_receiver._ez))
        return false;
      else {
      }
    }
    return true;
  };
  function Mat33() {
    Companion_getInstance_67();
  }
  Mat33.$metadata$ = {
    simpleName: 'Mat33',
    kind: 'class',
    interfaces: []
  };
  function Companion_69() {
    Companion_instance_68 = this;
    this._PI = 3.1415927;
    this._TWOPI = 6.2831855;
    this._INV_PI = 1.0 / this._PI;
    this._HALF_PI = this._PI / 2;
    this._QUARTER_PI = this._PI / 4;
    this._THREE_HALVES_PI = this._TWOPI - this._HALF_PI;
    this._DEG2RAD = this._PI / 180;
    this._RAD2DEG = 180 / this._PI;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Settings_getInstance()._SINCOS_LUT_LENGTH;
    var tmp_2 = new Float32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var tmp0_sin_0 = tmp_3 * Settings_getInstance()._SINCOS_LUT_PRECISION;
      tmp_2[tmp_3] = Math.sin(tmp0_sin_0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._sinLUT = tmp_2;
  }
  Companion_69.prototype.sin_dbmacu_k$ = function (x) {
    var tmp;
    if (Settings_getInstance()._get_SINCOS_LUT_ENABLED__0_k$()) {
      tmp = this.sinLUT_dbmacu_k$(x);
    } else {
      var tmp0_sin_0 = x;
      tmp = Math.sin(tmp0_sin_0);
    }
    return tmp;
  };
  Companion_69.prototype.sinLUT_dbmacu_k$ = function (x) {
    var x_0 = x;
    x_0 = x_0 % this._TWOPI;
    if (x_0 < 0) {
      x_0 = x_0 + this._TWOPI;
    }if (Settings_getInstance()._get_SINCOS_LUT_LERP__0_k$()) {
      x_0 = x_0 / Settings_getInstance()._SINCOS_LUT_PRECISION;
      var index_0 = numberToInt(x_0);
      if (!(index_0 === 0)) {
        x_0 = x_0 % index_0;
      }var tmp;
      if (index_0 === (Settings_getInstance()._SINCOS_LUT_LENGTH - 1 | 0)) {
        tmp = (1 - x_0) * this._sinLUT[index_0] + x_0 * this._sinLUT[0];
      } else {
        tmp = (1 - x_0) * this._sinLUT[index_0] + x_0 * this._sinLUT[index_0 + 1 | 0];
      }
      return tmp;
    } else {
      return this._sinLUT[Companion_getInstance_68().round_dbmacu_k$(x_0 / Settings_getInstance()._SINCOS_LUT_PRECISION) % Settings_getInstance()._SINCOS_LUT_LENGTH];
    }
  };
  Companion_69.prototype.cos_dbmacu_k$ = function (x) {
    var tmp;
    if (Settings_getInstance()._get_SINCOS_LUT_ENABLED__0_k$()) {
      tmp = this.sinLUT_dbmacu_k$(this._HALF_PI - x);
    } else {
      var tmp0_cos_0 = x;
      tmp = Math.cos(tmp0_cos_0);
    }
    return tmp;
  };
  Companion_69.prototype.abs_dbmacu_k$ = function (x) {
    var tmp;
    if (Settings_getInstance()._get_FAST_ABS__0_k$()) {
      tmp = x > 0 ? x : -x;
    } else {
      tmp = Math.abs(x);
    }
    return tmp;
  };
  Companion_69.prototype.floor_dbmacu_k$ = function (x) {
    var tmp;
    if (Settings_getInstance()._get_FAST_FLOOR__0_k$()) {
      tmp = this.fastFloor_dbmacu_k$(x);
    } else {
      var tmp0_floor_0 = x;
      tmp = numberToInt(Math.floor(tmp0_floor_0));
    }
    return tmp;
  };
  Companion_69.prototype.fastFloor_dbmacu_k$ = function (x) {
    var y = numberToInt(x);
    return x < y ? y - 1 | 0 : y;
  };
  Companion_69.prototype.round_dbmacu_k$ = function (x) {
    return Settings_getInstance()._get_FAST_ROUND__0_k$() ? this.floor_dbmacu_k$(x + 0.5) : numberToInt(round(x));
  };
  Companion_69.prototype.max_rybm4g_k$ = function (a, b) {
    return a > b ? a : b;
  };
  Companion_69.prototype.max_27zxwg_k$ = function (a, b) {
    return a > b ? a : b;
  };
  Companion_69.prototype.min_rybm4g_k$ = function (a, b) {
    return a < b ? a : b;
  };
  Companion_69.prototype.min_27zxwg_k$ = function (a, b) {
    return a < b ? a : b;
  };
  Companion_69.prototype.clamp_ae5le_k$ = function (a, low, high) {
    return this.max_rybm4g_k$(low, this.min_rybm4g_k$(a, high));
  };
  Companion_69.prototype.sqrt_dbmacu_k$ = function (x) {
    var tmp0_sqrt_0 = x;
    return Math.sqrt(tmp0_sqrt_0);
  };
  Companion_69.prototype.distanceSquared_5kvz1c_k$ = function (v1, v2) {
    var dx = v1._x_7 - v2._x_7;
    var dy = v1._y_6 - v2._y_6;
    return dx * dx + dy * dy;
  };
  Companion_69.prototype.distance_5kvz1c_k$ = function (v1, v2) {
    return this.sqrt_dbmacu_k$(this.distanceSquared_5kvz1c_k$(v1, v2));
  };
  Companion_69.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_68;
  function Companion_getInstance_68() {
    if (Companion_instance_68 == null)
      new Companion_69();
    return Companion_instance_68;
  }
  function Rot_init_$Init$($this) {
    Rot.call($this);
    $this.setIdentity_0_k$();
    Unit_getInstance();
    return $this;
  }
  function Rot_init_$Create$() {
    return Rot_init_$Init$(Object.create(Rot.prototype));
  }
  function Companion_70() {
    Companion_instance_69 = this;
  }
  Companion_70.prototype.mul_iky4dd_k$ = function (q, r, out) {
    var tempc = q._c_0 * r._c_0 - q._s * r._s;
    out._s = q._s * r._c_0 + q._c_0 * r._s;
    out._c_0 = tempc;
  };
  Companion_70.prototype.mulTransUnsafe_iky4dd_k$ = function (q, r, out) {
    out._s = q._c_0 * r._s - q._s * r._c_0;
    out._c_0 = q._c_0 * r._c_0 + q._s * r._s;
  };
  Companion_70.prototype.mulToOut_6ywscr_k$ = function (q, v, out) {
    var tempy = q._s * v._x_7 + q._c_0 * v._y_6;
    out._x_7 = q._c_0 * v._x_7 - q._s * v._y_6;
    out._y_6 = tempy;
  };
  Companion_70.prototype.mulToOutUnsafe_6ywscr_k$ = function (q, v, out) {
    out._x_7 = q._c_0 * v._x_7 - q._s * v._y_6;
    out._y_6 = q._s * v._x_7 + q._c_0 * v._y_6;
  };
  Companion_70.prototype.mulTransUnsafe_6ywscr_k$ = function (q, v, out) {
    out._x_7 = q._c_0 * v._x_7 + q._s * v._y_6;
    out._y_6 = -q._s * v._x_7 + q._c_0 * v._y_6;
  };
  Companion_70.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_69;
  function Companion_getInstance_69() {
    if (Companion_instance_69 == null)
      new Companion_70();
    return Companion_instance_69;
  }
  Rot.prototype.toString = function () {
    return '' + 'Rot(s:' + this._s + ', c:' + this._c_0 + ')';
  };
  Rot.prototype.setRadians_dbmacu_k$ = function (angleRadians) {
    this._s = Companion_getInstance_68().sin_dbmacu_k$(angleRadians);
    this._c_0 = Companion_getInstance_68().cos_dbmacu_k$(angleRadians);
    return this;
  };
  Rot.prototype.set_dork62_k$ = function (other) {
    this._s = other._s;
    this._c_0 = other._c_0;
    return this;
  };
  Rot.prototype.setIdentity_0_k$ = function () {
    this._s = 0.0;
    this._c_0 = 1.0;
    return this;
  };
  function Rot() {
    Companion_getInstance_69();
    this._s = 0;
    this._c_0 = 0;
  }
  Rot.$metadata$ = {
    simpleName: 'Rot',
    kind: 'class',
    interfaces: []
  };
  var _FAST_ABS;
  var _FAST_FLOOR;
  var _FAST_CEIL;
  var _FAST_ROUND;
  var _FAST_ATAN2;
  var _FAST_POW;
  var _CONTACT_STACK_INIT_SIZE;
  var _SINCOS_LUT_ENABLED;
  var _SINCOS_LUT_LERP;
  var _maxManifoldPoints;
  var _maxPolygonVertices;
  var _aabbExtension;
  var _aabbMultiplier;
  var _linearSlop;
  var _angularSlop;
  var _polygonRadius;
  var _maxSubSteps;
  var _maxTOIContacts;
  var _velocityThreshold;
  var _maxLinearCorrection;
  var _maxAngularCorrection;
  var _maxTranslation;
  var _maxTranslationSquared;
  var _maxRotation;
  var _maxRotationSquared;
  var _baumgarte;
  var _toiBaugarte;
  var _timeToSleep;
  var _linearSleepTolerance;
  var _angularSleepTolerance;
  function Settings() {
    Settings_instance = this;
    this._EPSILON = 1.1920929E-7;
    this._PI_0 = 3.1415927;
    this._SINCOS_LUT_PRECISION = 1.1E-4;
    var tmp = this;
    var tmp0_ceil_0 = 6.283185307179586 / this._SINCOS_LUT_PRECISION;
    tmp._SINCOS_LUT_LENGTH = numberToInt(Math.ceil(tmp0_ceil_0));
    this._invalidParticleIndex = -1;
    this._particleStride = 0.75;
    this._minParticleWeight = 1.0;
    this._maxParticleWeight = 5.0;
    this._maxTriadDistance = 2;
    this._maxTriadDistanceSquared = imul(this._maxTriadDistance, this._maxTriadDistance);
    this._minParticleBufferCapacity = 256;
  }
  Settings.prototype._get_FAST_ABS__0_k$ = function () {
    return _FAST_ABS;
  };
  Settings.prototype._get_FAST_FLOOR__0_k$ = function () {
    return _FAST_FLOOR;
  };
  Settings.prototype._get_FAST_ROUND__0_k$ = function () {
    return _FAST_ROUND;
  };
  Settings.prototype._get_CONTACT_STACK_INIT_SIZE__0_k$ = function () {
    return _CONTACT_STACK_INIT_SIZE;
  };
  Settings.prototype._get_SINCOS_LUT_ENABLED__0_k$ = function () {
    return _SINCOS_LUT_ENABLED;
  };
  Settings.prototype._get_SINCOS_LUT_LERP__0_k$ = function () {
    return _SINCOS_LUT_LERP;
  };
  Settings.prototype._get_maxManifoldPoints__0_k$ = function () {
    return _maxManifoldPoints;
  };
  Settings.prototype._get_maxPolygonVertices__0_k$ = function () {
    return _maxPolygonVertices;
  };
  Settings.prototype._get_aabbExtension__0_k$ = function () {
    return _aabbExtension;
  };
  Settings.prototype._get_aabbMultiplier__0_k$ = function () {
    return _aabbMultiplier;
  };
  Settings.prototype._get_linearSlop__0_k$ = function () {
    return _linearSlop;
  };
  Settings.prototype._get_angularSlop__0_k$ = function () {
    return _angularSlop;
  };
  Settings.prototype._get_polygonRadius__0_k$ = function () {
    return _polygonRadius;
  };
  Settings.prototype._get_maxSubSteps__0_k$ = function () {
    return _maxSubSteps;
  };
  Settings.prototype._get_maxTOIContacts__0_k$ = function () {
    return _maxTOIContacts;
  };
  Settings.prototype._get_velocityThreshold__0_k$ = function () {
    return _velocityThreshold;
  };
  Settings.prototype._get_maxLinearCorrection__0_k$ = function () {
    return _maxLinearCorrection;
  };
  Settings.prototype._get_maxTranslation__0_k$ = function () {
    return _maxTranslation;
  };
  Settings.prototype._get_maxTranslationSquared__0_k$ = function () {
    return _maxTranslationSquared;
  };
  Settings.prototype._get_maxRotation__0_k$ = function () {
    return _maxRotation;
  };
  Settings.prototype._get_maxRotationSquared__0_k$ = function () {
    return _maxRotationSquared;
  };
  Settings.prototype._get_baumgarte__0_k$ = function () {
    return _baumgarte;
  };
  Settings.prototype._get_toiBaugarte__0_k$ = function () {
    return _toiBaugarte;
  };
  Settings.prototype._get_timeToSleep__0_k$ = function () {
    return _timeToSleep;
  };
  Settings.prototype._get_linearSleepTolerance__0_k$ = function () {
    return _linearSleepTolerance;
  };
  Settings.prototype._get_angularSleepTolerance__0_k$ = function () {
    return _angularSleepTolerance;
  };
  Settings.$metadata$ = {
    simpleName: 'Settings',
    kind: 'object',
    interfaces: []
  };
  var Settings_instance;
  function Settings_getInstance() {
    if (Settings_instance == null)
      new Settings();
    return Settings_instance;
  }
  function Sweep() {
    var tmp = this;
    tmp._localCenter = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._c0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_1 = this;
    tmp_1._c_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._a0 = 0;
    this._a_1 = 0;
    this._alpha0 = 0;
  }
  Sweep.prototype.toString = function () {
    var s = '' + 'Sweep:\nlocalCenter: ' + this._localCenter + '\n';
    s = s + ('' + 'c0: ' + this._c0 + ', c: ' + this._c_1 + '\n');
    s = s + ('' + 'a0: ' + this._a0 + ', a: ' + this._a_1 + '\n');
    s = s + ('' + 'alpha0: ' + this._alpha0);
    return s;
  };
  Sweep.prototype.normalize_sv8swh_k$ = function () {
    var d = Companion_getInstance_68()._TWOPI * Companion_getInstance_68().floor_dbmacu_k$(this._a0 / Companion_getInstance_68()._TWOPI);
    var tmp0_this = this;
    tmp0_this._a0 = tmp0_this._a0 - d;
    var tmp1_this = this;
    tmp1_this._a_1 = tmp1_this._a_1 - d;
  };
  Sweep.prototype.set_dd6kcl_k$ = function (other) {
    this._localCenter.set_1v0asv_k$(other._localCenter);
    Unit_getInstance();
    this._c0.set_1v0asv_k$(other._c0);
    Unit_getInstance();
    this._c_1.set_1v0asv_k$(other._c_1);
    Unit_getInstance();
    this._a0 = other._a0;
    this._a_1 = other._a_1;
    this._alpha0 = other._alpha0;
    return this;
  };
  Sweep.prototype.getTransform_il1pfm_k$ = function (xf, beta) {
    var tmp0_assert_0 = !(xf == null);
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }xf._p_1._x_7 = (1.0 - beta) * this._c0._x_7 + beta * this._c_1._x_7;
    xf._p_1._y_6 = (1.0 - beta) * this._c0._y_6 + beta * this._c_1._y_6;
    var angle = (1.0 - beta) * this._a0 + beta * this._a_1;
    xf._q.setRadians_dbmacu_k$(angle);
    Unit_getInstance();
    var q = xf._q;
    var tmp0_this = xf._p_1;
    tmp0_this._x_7 = tmp0_this._x_7 - (q._c_0 * this._localCenter._x_7 - q._s * this._localCenter._y_6);
    var tmp1_this = xf._p_1;
    tmp1_this._y_6 = tmp1_this._y_6 - (q._s * this._localCenter._x_7 + q._c_0 * this._localCenter._y_6);
  };
  Sweep.prototype.advance_cpozfn_k$ = function (alpha_0) {
    var tmp0_assert_0 = this._alpha0 < 1.0;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var beta = (alpha_0 - this._alpha0) / (1.0 - this._alpha0);
    var tmp0_this = this._c0;
    tmp0_this._x_7 = tmp0_this._x_7 + beta * (this._c_1._x_7 - this._c0._x_7);
    var tmp1_this = this._c0;
    tmp1_this._y_6 = tmp1_this._y_6 + beta * (this._c_1._y_6 - this._c0._y_6);
    var tmp2_this = this;
    tmp2_this._a0 = tmp2_this._a0 + beta * (this._a_1 - this._a0);
    this._alpha0 = alpha_0;
  };
  Sweep.$metadata$ = {
    simpleName: 'Sweep',
    kind: 'class',
    interfaces: []
  };
  function Timer() {
    this._resetNanos = new Long(0, 0);
    this.reset_sv8swh_k$();
  }
  Timer.prototype._get_milliseconds__0_k$ = function () {
    var tmp0_div_0 = System_nanoTime().minus_wiekkq_k$(this._resetNanos);
    var tmp1_times_0 = tmp0_div_0.div_wiekkq_k$(new Long(1000, 0));
    return tmp1_times_0.toFloat_0_k$() * 1.0 / 1000;
  };
  Timer.prototype.reset_sv8swh_k$ = function () {
    this._resetNanos = System_nanoTime();
  };
  Timer.$metadata$ = {
    simpleName: 'Timer',
    kind: 'class',
    interfaces: []
  };
  function Transform_init_$Init$_0($this) {
    Transform_0.call($this);
    var tmp = $this;
    tmp._p_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    $this._q = Rot_init_$Create$();
    return $this;
  }
  function Transform_init_$Create$_0() {
    return Transform_init_$Init$_0(Object.create(Transform_0.prototype));
  }
  function Companion_71() {
    Companion_instance_70 = this;
  }
  Companion_71.prototype.mulToOut_kg26ly_k$ = function (T, v, out) {
    var tempy = T._q._s * v._x_7 + T._q._c_0 * v._y_6 + T._p_1._y_6;
    out._x_7 = T._q._c_0 * v._x_7 - T._q._s * v._y_6 + T._p_1._x_7;
    out._y_6 = tempy;
  };
  Companion_71.prototype.mulToOutUnsafe_kg26ly_k$ = function (T, v, out) {
    var tmp0_assert_0 = !(v === out);
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }out._x_7 = T._q._c_0 * v._x_7 - T._q._s * v._y_6 + T._p_1._x_7;
    out._y_6 = T._q._s * v._x_7 + T._q._c_0 * v._y_6 + T._p_1._y_6;
  };
  Companion_71.prototype.mulTransToOutUnsafe_kg26ly_k$ = function (T, v, out) {
    var tmp0_assert_0 = !(v === out);
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var px = v._x_7 - T._p_1._x_7;
    var py = v._y_6 - T._p_1._y_6;
    out._x_7 = T._q._c_0 * px + T._q._s * py;
    out._y_6 = -T._q._s * px + T._q._c_0 * py;
  };
  Companion_71.prototype.mulToOut_hym17k_k$ = function (A, B, out) {
    var tmp0_assert_0 = !(out === A);
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }Companion_getInstance_69().mul_iky4dd_k$(A._q, B._q, out._q);
    Companion_getInstance_69().mulToOut_6ywscr_k$(A._q, B._p_1, out._p_1);
    out._p_1.addLocal_1v0asv_k$(A._p_1);
    Unit_getInstance();
  };
  Companion_71.prototype.mulTransToOutUnsafe_84z9o3_k$ = function (A, B, out, pool) {
    var tmp0_assert_0 = !(out === A);
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = !(out === B);
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }Companion_getInstance_69().mulTransUnsafe_iky4dd_k$(A._q, B._q, out._q);
    pool.set_1v0asv_k$(B._p_1).subLocal_1v0asv_k$(A._p_1);
    Unit_getInstance();
    Companion_getInstance_69().mulTransUnsafe_6ywscr_k$(A._q, pool, out._p_1);
  };
  Companion_71.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_70;
  function Companion_getInstance_70() {
    if (Companion_instance_70 == null)
      new Companion_71();
    return Companion_instance_70;
  }
  Transform_0.prototype.set_3pfibf_k$ = function (xf) {
    this._p_1.set_1v0asv_k$(xf._p_1);
    Unit_getInstance();
    this._q.set_dork62_k$(xf._q);
    Unit_getInstance();
    return this;
  };
  Transform_0.prototype.toString = function () {
    var s = 'XForm:\n';
    s = s + ('' + 'Position: ' + this._p_1 + '\n');
    s = s + ('' + 'R: \n' + this._q + '\n');
    return s;
  };
  function Transform_0() {
    Companion_getInstance_70();
  }
  Transform_0.$metadata$ = {
    simpleName: 'Transform',
    kind: 'class',
    interfaces: []
  };
  var __dummy;
  function Vec2_init_$Init$(x, y, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0.0;
    if (!(($mask0 & 2) === 0))
      y = 0.0;
    Vec2.call($this, x, y);
    return $this;
  }
  function Vec2_init_$Create$(x, y, $mask0, $marker) {
    return Vec2_init_$Init$(x, y, $mask0, $marker, Object.create(Vec2.prototype));
  }
  function Companion_72() {
    Companion_instance_71 = this;
  }
  Companion_72.prototype.dot_5kvz1c_k$ = function (a, b) {
    return a._x_7 * b._x_7 + a._y_6 * b._y_6;
  };
  Companion_72.prototype.cross_5kvz1c_k$ = function (a, b) {
    return a._x_7 * b._y_6 - a._y_6 * b._x_7;
  };
  Companion_72.prototype.crossToOutUnsafe_6kg5i7_k$ = function (a, s, out) {
    var tmp0_assert_0 = !(out === a);
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }out._x_7 = s * a._y_6;
    out._y_6 = -s * a._x_7;
  };
  Companion_72.prototype.cross_xhyk1r_k$ = function (s, a) {
    return new Vec2(-s * a._y_6, s * a._x_7);
  };
  Companion_72.prototype.crossToOutUnsafe_ohincz_k$ = function (s, a, out) {
    var tmp0_assert_0 = !(out === a);
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }out._x_7 = -s * a._y_6;
    out._y_6 = s * a._x_7;
  };
  Companion_72.prototype.minToOut_ly9802_k$ = function (a, b, out) {
    out._x_7 = a._x_7 < b._x_7 ? a._x_7 : b._x_7;
    out._y_6 = a._y_6 < b._y_6 ? a._y_6 : b._y_6;
  };
  Companion_72.prototype.maxToOut_ly9802_k$ = function (a, b, out) {
    out._x_7 = a._x_7 > b._x_7 ? a._x_7 : b._x_7;
    out._y_6 = a._y_6 > b._y_6 ? a._y_6 : b._y_6;
  };
  Companion_72.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_71;
  function Companion_getInstance_71() {
    if (Companion_instance_71 == null)
      new Companion_72();
    return Companion_instance_71;
  }
  function Vec2(x, y) {
    Companion_getInstance_71();
    this._x_7 = x;
    this._y_6 = y;
  }
  Vec2.prototype._get_isValid__0_k$ = function () {
    return ((!isNaN_1(this._x_7) ? !isInfinite(this._x_7) : false) ? !isNaN_1(this._y_6) : false) ? !isInfinite(this._y_6) : false;
  };
  Vec2.prototype.setZero_sv8swh_k$ = function () {
    this._x_7 = 0.0;
    this._y_6 = 0.0;
  };
  Vec2.prototype.set_rybm4g_k$ = function (x, y) {
    this._x_7 = x;
    this._y_6 = y;
    return this;
  };
  Vec2.prototype.set_1v0asv_k$ = function (v) {
    this._x_7 = v._x_7;
    this._y_6 = v._y_6;
    return this;
  };
  Vec2.prototype.add_1v0asv_k$ = function (v) {
    return new Vec2(this._x_7 + v._x_7, this._y_6 + v._y_6);
  };
  Vec2.prototype.negateLocal_0_k$ = function () {
    this._x_7 = -this._x_7;
    this._y_6 = -this._y_6;
    return this;
  };
  Vec2.prototype.addLocal_1v0asv_k$ = function (v) {
    var tmp0_this_2 = this;
    tmp0_this_2._x_7 = tmp0_this_2._x_7 + v._x_7;
    var tmp1_this_3 = this;
    tmp1_this_3._y_6 = tmp1_this_3._y_6 + v._y_6;
    return this;
  };
  Vec2.prototype.subLocal_1v0asv_k$ = function (v) {
    var tmp0_this_2 = this;
    tmp0_this_2._x_7 = tmp0_this_2._x_7 - v._x_7;
    var tmp1_this_3 = this;
    tmp1_this_3._y_6 = tmp1_this_3._y_6 - v._y_6;
    return this;
  };
  Vec2.prototype.mulLocal_dbmacu_k$ = function (a) {
    var tmp0_this_2 = this;
    tmp0_this_2._x_7 = tmp0_this_2._x_7 * a;
    var tmp1_this_3 = this;
    tmp1_this_3._y_6 = tmp1_this_3._y_6 * a;
    return this;
  };
  Vec2.prototype.length_0_k$ = function () {
    return Companion_getInstance_68().sqrt_dbmacu_k$(this._x_7 * this._x_7 + this._y_6 * this._y_6);
  };
  Vec2.prototype.lengthSquared_0_k$ = function () {
    return this._x_7 * this._x_7 + this._y_6 * this._y_6;
  };
  Vec2.prototype.normalize_0_k$ = function () {
    var length = this.length_0_k$();
    if (length < Settings_getInstance()._EPSILON) {
      return 0.0;
    }var invLength = 1.0 / length;
    var tmp0_this = this;
    tmp0_this._x_7 = tmp0_this._x_7 * invLength;
    var tmp1_this = this;
    tmp1_this._y_6 = tmp1_this._y_6 * invLength;
    return length;
  };
  Vec2.prototype.toString = function () {
    return '' + '(' + this._x_7 + ',' + this._y_6 + ')';
  };
  Vec2.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_7);
    result = imul(result, 31) + getNumberHashCode(this._y_6) | 0;
    return result;
  };
  Vec2.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Vec2))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Vec2 ? other : THROW_CCE();
    if (!equals_1(this._x_7, tmp0_other_with_cast._x_7))
      return false;
    if (!equals_1(this._y_6, tmp0_other_with_cast._y_6))
      return false;
    return true;
  };
  Vec2.$metadata$ = {
    simpleName: 'Vec2',
    kind: 'class',
    interfaces: []
  };
  function Vec3_init_$Init$(x, y, z, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0;
    if (!(($mask0 & 2) === 0))
      y = 0;
    if (!(($mask0 & 4) === 0))
      z = 0;
    Vec3.call($this, x, y, z);
    return $this;
  }
  function Vec3_init_$Create$(x, y, z, $mask0, $marker) {
    return Vec3_init_$Init$(x, y, z, $mask0, $marker, Object.create(Vec3.prototype));
  }
  function Vec3_init_$Init$_0(copy, $this) {
    Vec3.call($this, copy._x_8, copy._y_7, copy._z_1);
    return $this;
  }
  function Vec3_init_$Create$_0(copy) {
    return Vec3_init_$Init$_0(copy, Object.create(Vec3.prototype));
  }
  function Companion_73() {
    Companion_instance_72 = this;
  }
  Companion_73.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_72;
  function Companion_getInstance_72() {
    if (Companion_instance_72 == null)
      new Companion_73();
    return Companion_instance_72;
  }
  function Vec3(x, y, z) {
    Companion_getInstance_72();
    this._x_8 = x;
    this._y_7 = y;
    this._z_1 = z;
  }
  Vec3.prototype.clone_0_k$ = function () {
    return Vec3_init_$Create$_0(this);
  };
  Vec3.prototype.toString = function () {
    return '' + '(' + this._x_8 + ',' + this._y_7 + ',' + this._z_1 + ')';
  };
  Vec3.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_8);
    result = imul(result, 31) + getNumberHashCode(this._y_7) | 0;
    result = imul(result, 31) + getNumberHashCode(this._z_1) | 0;
    return result;
  };
  Vec3.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Vec3))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Vec3 ? other : THROW_CCE();
    if (!equals_1(this._x_8, tmp0_other_with_cast._x_8))
      return false;
    if (!equals_1(this._y_7, tmp0_other_with_cast._y_7))
      return false;
    if (!equals_1(this._z_1, tmp0_other_with_cast._z_1))
      return false;
    return true;
  };
  Vec3.$metadata$ = {
    simpleName: 'Vec3',
    kind: 'class',
    interfaces: []
  };
  function ViewInfo() {
    this._view = null;
    this._x_9 = 0.0;
    this._y_8 = 0.0;
    this._rotation_0 = _get_degrees__0(0);
    this._onStage = false;
  }
  ViewInfo.$metadata$ = {
    simpleName: 'ViewInfo',
    kind: 'class',
    interfaces: []
  };
  function Companion_74() {
    Companion_instance_73 = this;
    this._e_islandFlag = 1;
    this._e_awakeFlag = 2;
    this._e_autoSleepFlag = 4;
    this._e_bulletFlag = 8;
    this._e_fixedRotationFlag = 16;
    this._e_activeFlag = 32;
    this._e_toiFlag = 64;
  }
  Companion_74.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_73;
  function Companion_getInstance_73() {
    if (Companion_instance_73 == null)
      new Companion_74();
    return Companion_instance_73;
  }
  function Body_0(bd, world) {
    Companion_getInstance_73();
    this._world = world;
    this._$$delegate_0_1 = new Mixin_0();
    this._bodyDef = bd;
    this._didReset = true;
    this._viewInfo = new ViewInfo();
    this._flags = 0;
    this._islandIndex = 0;
    this._xf_0 = Transform_init_$Create$_0();
    this._xf0 = Transform_init_$Create$_0();
    this._sweep = new Sweep();
    var tmp = this;
    tmp.__linearVelocity = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this.__angularVelocity = 0.0;
    var tmp_0 = this;
    tmp_0._force = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._torque = 0.0;
    this._prev_0 = null;
    this._m_next = null;
    this._m_fixtureList = null;
    this._m_fixtureCount = 0;
    this._m_jointList = null;
    this._m_contactList = null;
    this._m_mass = 0;
    this._m_invMass = 0;
    this._m_I = 0;
    this._m_invI = 0;
    this._m_linearDamping = 0;
    this._m_angularDamping = 0;
    this._gravityScale = 0;
    this._m_sleepTime = 0;
    this._userData_0 = null;
    var tmp_1 = this;
    tmp_1._fixDef = FixtureDef_init_$Create$(null, null, 0.0, 0.0, 0.0, false, null, 127, null);
    this._pmd = MassData_init_$Create$();
    this._pxf = Transform_init_$Create$_0();
    var tmp0_assert_0 = bd._position_0._get_isValid__0_k$();
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = bd._linearVelocity._get_isValid__0_k$();
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }var tmp2_assert_0 = bd._gravityScale_0 >= 0.0;
    if (!tmp2_assert_0) {
      var message_2_1_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
    }var tmp3_assert_0 = bd._angularDamping >= 0.0;
    if (!tmp3_assert_0) {
      var message_2_1_2 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_2));
    }var tmp4_assert_0 = bd._linearDamping >= 0.0;
    if (!tmp4_assert_0) {
      var message_2_1_3 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_3));
    }this._flags = 0;
    if (bd._bullet) {
      this._flags = this._flags | Companion_getInstance_73()._e_bulletFlag;
    }if (bd._fixedRotation) {
      this._flags = this._flags | Companion_getInstance_73()._e_fixedRotationFlag;
    }if (bd._allowSleep) {
      this._flags = this._flags | Companion_getInstance_73()._e_autoSleepFlag;
    }if (bd._awake) {
      this._flags = this._flags | Companion_getInstance_73()._e_awakeFlag;
    }if (bd._active) {
      this._flags = this._flags | Companion_getInstance_73()._e_activeFlag;
    }this._xf_0._p_1.set_1v0asv_k$(bd._position_0);
    Unit_getInstance();
    this._xf_0._q.setRadians_dbmacu_k$(bd._angleRadians);
    Unit_getInstance();
    this._sweep._localCenter.setZero_sv8swh_k$();
    this._sweep._c0.set_1v0asv_k$(this._xf_0._p_1);
    Unit_getInstance();
    this._sweep._c_1.set_1v0asv_k$(this._xf_0._p_1);
    Unit_getInstance();
    this._sweep._a0 = bd._angleRadians;
    this._sweep._a_1 = bd._angleRadians;
    this._sweep._alpha0 = 0.0;
    this._m_jointList = null;
    this._m_contactList = null;
    this._prev_0 = null;
    this._m_next = null;
    this.__linearVelocity.set_1v0asv_k$(bd._linearVelocity);
    Unit_getInstance();
    this.__angularVelocity = bd._angularVelocity;
    this._m_linearDamping = bd._linearDamping;
    this._m_angularDamping = bd._angularDamping;
    this._gravityScale = bd._gravityScale_0;
    this._force.setZero_sv8swh_k$();
    this._torque = 0.0;
    this._m_sleepTime = 0.0;
    this.__type = bd._type_7;
    if (this.__type === BodyType_DYNAMIC_getInstance()) {
      this._m_mass = 1.0;
      this._m_invMass = 1.0;
    } else {
      this._m_mass = 0.0;
      this._m_invMass = 0.0;
    }
    this._m_I = 0.0;
    this._m_invI = 0.0;
    this._userData_0 = bd._userData_1;
    this._m_fixtureList = null;
    this._m_fixtureCount = 0;
  }
  Body_0.prototype.set_fm38x_k$ = function (key, value) {
    this._$$delegate_0_1.set_fm38x_k$(key, value);
  };
  Body_0.prototype.get_3xhjti_k$ = function (key) {
    return this._$$delegate_0_1.get_3xhjti_k$(key);
  };
  Body_0.prototype._get_transform__0_k$ = function () {
    return this._xf_0;
  };
  Body_0.prototype.getNext_0_k$ = function () {
    return this._m_next;
  };
  Body_0.prototype.getContactList_0_k$ = function () {
    return this._m_contactList;
  };
  Body_0.prototype.getMass_0_k$ = function () {
    return this._m_mass;
  };
  Body_0.prototype._get_position__0_k$ = function () {
    return this._xf_0._p_1;
  };
  Body_0.prototype._get_angleRadians__0_k$ = function () {
    return this._sweep._a_1;
  };
  Body_0.prototype._get_angle__gxicn3_k$ = function () {
    return _get_radians__1(this._get_angleRadians__0_k$());
  };
  Body_0.prototype._get_worldCenter__0_k$ = function () {
    return this._sweep._c_1;
  };
  Body_0.prototype._get_localCenter__0_k$ = function () {
    return this._sweep._localCenter;
  };
  Body_0.prototype._set_linearVelocity__ftoxb6_k$ = function (v) {
    if (this.__type === BodyType_STATIC_getInstance()) {
      return Unit_getInstance();
    }if (Companion_getInstance_71().dot_5kvz1c_k$(v, v) > 0.0) {
      this._set_isAwake__rpwsgn_k$(true);
    }this.__linearVelocity.set_1v0asv_k$(v);
    Unit_getInstance();
  };
  Body_0.prototype._get_linearVelocity__0_k$ = function () {
    return this.__linearVelocity;
  };
  Body_0.prototype._set_linearVelocityX__cpozfn_k$ = function (v) {
    this._set_linearVelocity__ftoxb6_k$(this._get_linearVelocity__0_k$().set_rybm4g_k$(v, this._get_linearVelocity__0_k$()._y_6));
  };
  Body_0.prototype._set_linearVelocityY__cpozfn_k$ = function (v) {
    this._set_linearVelocity__ftoxb6_k$(this._get_linearVelocity__0_k$().set_rybm4g_k$(this._get_linearVelocity__0_k$()._x_7, v));
  };
  Body_0.prototype._set_angularVelocity__cpozfn_k$ = function (w) {
    if (this.__type === BodyType_STATIC_getInstance()) {
      return Unit_getInstance();
    }if (w * w > 0.0) {
      this._set_isAwake__rpwsgn_k$(true);
    }this.__angularVelocity = w;
  };
  Body_0.prototype._get_inertia__0_k$ = function () {
    return this._m_I + this._m_mass * (this._sweep._localCenter._x_7 * this._sweep._localCenter._x_7 + this._sweep._localCenter._y_6 * this._sweep._localCenter._y_6);
  };
  Body_0.prototype._get_type__0_k$ = function () {
    return this.__type;
  };
  Body_0.prototype._get_isBullet__0_k$ = function () {
    return (this._flags & Companion_getInstance_73()._e_bulletFlag) === Companion_getInstance_73()._e_bulletFlag;
  };
  Body_0.prototype._set_isAwake__rpwsgn_k$ = function (flag) {
    if (flag) {
      if ((this._flags & Companion_getInstance_73()._e_awakeFlag) === 0) {
        this._flags = this._flags | Companion_getInstance_73()._e_awakeFlag;
        this._m_sleepTime = 0.0;
      }} else {
      this._flags = this._flags & ~Companion_getInstance_73()._e_awakeFlag;
      this._m_sleepTime = 0.0;
      this.__linearVelocity.setZero_sv8swh_k$();
      this.__angularVelocity = 0.0;
      this._force.setZero_sv8swh_k$();
      this._torque = 0.0;
    }
  };
  Body_0.prototype._get_isAwake__0_k$ = function () {
    return (this._flags & Companion_getInstance_73()._e_awakeFlag) === Companion_getInstance_73()._e_awakeFlag;
  };
  Body_0.prototype._set_isActive__rpwsgn_k$ = function (flag) {
    var tmp0_assert_0 = this._world._get_isLocked__0_k$() === false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }if (flag === this._get_isActive__0_k$()) {
      return Unit_getInstance();
    }if (flag) {
      this._flags = this._flags | Companion_getInstance_73()._e_activeFlag;
      var broadPhase = this._world._m_contactManager._m_broadPhase;
      var f = this._m_fixtureList;
      while (!(f == null)) {
        f.createProxies_844mye_k$(broadPhase, this._xf_0);
        f = f._m_next_0;
      }
    } else {
      this._flags = this._flags & ~Companion_getInstance_73()._e_activeFlag;
      var broadPhase_0 = this._world._m_contactManager._m_broadPhase;
      var f_0 = this._m_fixtureList;
      while (!(f_0 == null)) {
        f_0.destroyProxies_7gve4v_k$(broadPhase_0);
        f_0 = f_0._m_next_0;
      }
      var ce = this._m_contactList;
      while (!(ce == null)) {
        var ce0 = ce;
        ce = ce._next_5;
        this._world._m_contactManager.destroy_qmxzzw_k$(ensureNotNull(ce0._contact));
      }
      this._m_contactList = null;
    }
  };
  Body_0.prototype._get_isActive__0_k$ = function () {
    return (this._flags & Companion_getInstance_73()._e_activeFlag) === Companion_getInstance_73()._e_activeFlag;
  };
  Body_0.prototype.createFixture_n3zf3w_k$ = function (def) {
    var tmp0_assert_0 = this._world._get_isLocked__0_k$() === false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }if (this._world._get_isLocked__0_k$() === true) {
      return null;
    }var fixture = new Fixture();
    fixture.create_gpltrr_k$(this, def);
    if ((this._flags & Companion_getInstance_73()._e_activeFlag) === Companion_getInstance_73()._e_activeFlag) {
      var broadPhase = this._world._m_contactManager._m_broadPhase;
      fixture.createProxies_844mye_k$(broadPhase, this._xf_0);
    }fixture._m_next_0 = this._m_fixtureList;
    this._m_fixtureList = fixture;
    var tmp0_this = this;
    tmp0_this._m_fixtureCount = tmp0_this._m_fixtureCount + 1 | 0;
    Unit_getInstance();
    fixture._m_body = this;
    if (fixture._m_density > 0.0) {
      this.resetMassData_sv8swh_k$();
    }this._world._m_flags = this._world._m_flags | Companion_getInstance_76()._NEW_FIXTURE;
    return fixture;
  };
  Body_0.prototype.setTransformRadians_qzvxhq_k$ = function (position_0, angleRadians) {
    var tmp0_assert_0 = this._world._get_isLocked__0_k$() === false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }if (this._world._get_isLocked__0_k$() === true) {
      return Unit_getInstance();
    }this._xf_0._q.setRadians_dbmacu_k$(angleRadians);
    Unit_getInstance();
    this._xf_0._p_1.set_1v0asv_k$(position_0);
    Unit_getInstance();
    Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xf_0, this._sweep._localCenter, this._sweep._c_1);
    this._sweep._a_1 = angleRadians;
    this._sweep._c0.set_1v0asv_k$(this._sweep._c_1);
    Unit_getInstance();
    this._sweep._a0 = this._sweep._a_1;
    var broadPhase = this._world._m_contactManager._m_broadPhase;
    var f = this._m_fixtureList;
    while (!(f == null)) {
      f.synchronize_clrj23_k$(broadPhase, this._xf_0, this._xf_0);
      f = f._m_next_0;
    }
  };
  Body_0.prototype.setTransform_fe2466_k$ = function (position_0, angle) {
    return this.setTransformRadians_qzvxhq_k$(position_0, _Angle___get_radians__impl_(angle));
  };
  Body_0.prototype.applyLinearImpulse_gzag95_k$ = function (impulse, point, wake) {
    if (!(this.__type === BodyType_DYNAMIC_getInstance())) {
      return Unit_getInstance();
    }if (!this._get_isAwake__0_k$()) {
      if (wake) {
        this._set_isAwake__rpwsgn_k$(true);
      } else {
        return Unit_getInstance();
      }
    }var tmp0_this = this.__linearVelocity;
    tmp0_this._x_7 = tmp0_this._x_7 + impulse._x_7 * this._m_invMass;
    var tmp1_this = this.__linearVelocity;
    tmp1_this._y_6 = tmp1_this._y_6 + impulse._y_6 * this._m_invMass;
    var tmp2_this = this;
    tmp2_this.__angularVelocity = tmp2_this.__angularVelocity + this._m_invI * ((point._x_7 - this._sweep._c_1._x_7) * impulse._y_6 - (point._y_6 - this._sweep._c_1._y_6) * impulse._x_7);
  };
  Body_0.prototype.resetMassData_sv8swh_k$ = function () {
    this._m_mass = 0.0;
    this._m_invMass = 0.0;
    this._m_I = 0.0;
    this._m_invI = 0.0;
    this._sweep._localCenter.setZero_sv8swh_k$();
    if (this.__type === BodyType_STATIC_getInstance() ? true : this.__type === BodyType_KINEMATIC_getInstance()) {
      this._sweep._c0.set_1v0asv_k$(this._xf_0._p_1);
      Unit_getInstance();
      this._sweep._c_1.set_1v0asv_k$(this._xf_0._p_1);
      Unit_getInstance();
      this._sweep._a0 = this._sweep._a_1;
      return Unit_getInstance();
    }var tmp0_assert_0 = this.__type === BodyType_DYNAMIC_getInstance();
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var localCenter = this._world._pool_4.popVec2_0_k$();
    localCenter.setZero_sv8swh_k$();
    var temp_0 = this._world._pool_4.popVec2_0_k$();
    var massData = this._pmd;
    var f = this._m_fixtureList;
    while (!(f == null)) {
      if (f._m_density === 0.0) {
        f = f._m_next_0;
        continue;
      }f.getMassData_ov4cnv_k$(massData);
      var tmp0_this = this;
      tmp0_this._m_mass = tmp0_this._m_mass + massData._mass;
      temp_0.set_1v0asv_k$(massData._center).mulLocal_dbmacu_k$(massData._mass);
      Unit_getInstance();
      localCenter.addLocal_1v0asv_k$(temp_0);
      Unit_getInstance();
      var tmp1_this = this;
      tmp1_this._m_I = tmp1_this._m_I + massData._I;
      f = f._m_next_0;
    }
    if (this._m_mass > 0.0) {
      this._m_invMass = 1.0 / this._m_mass;
      localCenter.mulLocal_dbmacu_k$(this._m_invMass);
      Unit_getInstance();
    } else {
      this._m_mass = 1.0;
      this._m_invMass = 1.0;
    }
    if (this._m_I > 0.0 ? (this._flags & Companion_getInstance_73()._e_fixedRotationFlag) === 0 : false) {
      var tmp2_this = this;
      tmp2_this._m_I = tmp2_this._m_I - this._m_mass * Companion_getInstance_71().dot_5kvz1c_k$(localCenter, localCenter);
      var tmp1_assert_0 = this._m_I > 0.0;
      if (!tmp1_assert_0) {
        var message_2_1_0 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
      }this._m_invI = 1.0 / this._m_I;
    } else {
      this._m_I = 0.0;
      this._m_invI = 0.0;
    }
    var oldCenter = this._world._pool_4.popVec2_0_k$();
    oldCenter.set_1v0asv_k$(this._sweep._c_1);
    Unit_getInstance();
    this._sweep._localCenter.set_1v0asv_k$(localCenter);
    Unit_getInstance();
    Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(this._xf_0, this._sweep._localCenter, this._sweep._c0);
    this._sweep._c_1.set_1v0asv_k$(this._sweep._c0);
    Unit_getInstance();
    temp_0.set_1v0asv_k$(this._sweep._c_1).subLocal_1v0asv_k$(oldCenter);
    Unit_getInstance();
    var temp2 = oldCenter;
    Companion_getInstance_71().crossToOutUnsafe_ohincz_k$(this.__angularVelocity, temp_0, temp2);
    this.__linearVelocity.addLocal_1v0asv_k$(temp2);
    Unit_getInstance();
    this._world._pool_4.pushVec2_majfzk_k$(3);
  };
  Body_0.prototype.synchronizeFixtures_sv8swh_k$ = function () {
    var xf1 = this._pxf;
    xf1._q._s = Companion_getInstance_68().sin_dbmacu_k$(this._sweep._a0);
    xf1._q._c_0 = Companion_getInstance_68().cos_dbmacu_k$(this._sweep._a0);
    xf1._p_1._x_7 = this._sweep._c0._x_7 - xf1._q._c_0 * this._sweep._localCenter._x_7 + xf1._q._s * this._sweep._localCenter._y_6;
    xf1._p_1._y_6 = this._sweep._c0._y_6 - xf1._q._s * this._sweep._localCenter._x_7 - xf1._q._c_0 * this._sweep._localCenter._y_6;
    var f = this._m_fixtureList;
    while (!(f == null)) {
      f.synchronize_clrj23_k$(this._world._m_contactManager._m_broadPhase, xf1, this._xf_0);
      f = f._m_next_0;
    }
  };
  Body_0.prototype.synchronizeTransform_sv8swh_k$ = function () {
    this._xf_0._q._s = Companion_getInstance_68().sin_dbmacu_k$(this._sweep._a_1);
    this._xf_0._q._c_0 = Companion_getInstance_68().cos_dbmacu_k$(this._sweep._a_1);
    var q = this._xf_0._q;
    var v = this._sweep._localCenter;
    this._xf_0._p_1._x_7 = this._sweep._c_1._x_7 - q._c_0 * v._x_7 + q._s * v._y_6;
    this._xf_0._p_1._y_6 = this._sweep._c_1._y_6 - q._s * v._x_7 - q._c_0 * v._y_6;
  };
  Body_0.prototype.shouldCollide_ywoppm_k$ = function (other) {
    if (!(this.__type === BodyType_DYNAMIC_getInstance()) ? !(other.__type === BodyType_DYNAMIC_getInstance()) : false) {
      return false;
    }var jn = this._m_jointList;
    while (!(jn == null)) {
      if (jn.other__error === other) {
        if (ensureNotNull(jn.joint__error).getCollideConnected_0_k$() === false) {
          return false;
        }}jn = jn.next__error;
    }
    return true;
  };
  Body_0.prototype.advance_cpozfn_k$ = function (t) {
    this._sweep.advance_cpozfn_k$(t);
    this._sweep._c_1.set_1v0asv_k$(this._sweep._c0);
    Unit_getInstance();
    this._sweep._a_1 = this._sweep._a0;
    this._xf_0._q.setRadians_dbmacu_k$(this._sweep._a_1);
    Unit_getInstance();
    Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(this._xf_0._q, this._sweep._localCenter, this._xf_0._p_1);
    this._xf_0._p_1.mulLocal_dbmacu_k$(-1.0).addLocal_1v0asv_k$(this._sweep._c_1);
    Unit_getInstance();
  };
  Body_0.$metadata$ = {
    simpleName: 'Body',
    kind: 'class',
    interfaces: [Box2dTypedUserData]
  };
  function BodyDef_init_$Init$(type, userData, position_0, angleRadians, linearVelocity, angularVelocity, linearDamping, angularDamping, allowSleep, awake, fixedRotation, bullet, active, gravityScale, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = BodyType_STATIC_getInstance();
    if (!(($mask0 & 2) === 0))
      userData = null;
    if (!(($mask0 & 4) === 0)) {
      position_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    }if (!(($mask0 & 8) === 0))
      angleRadians = 0.0;
    if (!(($mask0 & 16) === 0)) {
      linearVelocity = Vec2_init_$Create$(0.0, 0.0, 3, null);
    }if (!(($mask0 & 32) === 0))
      angularVelocity = 0.0;
    if (!(($mask0 & 64) === 0))
      linearDamping = 0.0;
    if (!(($mask0 & 128) === 0))
      angularDamping = 0.0;
    if (!(($mask0 & 256) === 0))
      allowSleep = true;
    if (!(($mask0 & 512) === 0))
      awake = true;
    if (!(($mask0 & 1024) === 0))
      fixedRotation = false;
    if (!(($mask0 & 2048) === 0))
      bullet = false;
    if (!(($mask0 & 4096) === 0))
      active = true;
    if (!(($mask0 & 8192) === 0))
      gravityScale = 1.0;
    BodyDef.call($this, type, userData, position_0, angleRadians, linearVelocity, angularVelocity, linearDamping, angularDamping, allowSleep, awake, fixedRotation, bullet, active, gravityScale);
    return $this;
  }
  function BodyDef_init_$Create$(type, userData, position_0, angleRadians, linearVelocity, angularVelocity, linearDamping, angularDamping, allowSleep, awake, fixedRotation, bullet, active, gravityScale, $mask0, $marker) {
    return BodyDef_init_$Init$(type, userData, position_0, angleRadians, linearVelocity, angularVelocity, linearDamping, angularDamping, allowSleep, awake, fixedRotation, bullet, active, gravityScale, $mask0, $marker, Object.create(BodyDef.prototype));
  }
  function BodyDef(type, userData, position_0, angleRadians, linearVelocity, angularVelocity, linearDamping, angularDamping, allowSleep, awake, fixedRotation, bullet, active, gravityScale) {
    this._type_7 = type;
    this._userData_1 = userData;
    this._position_0 = position_0;
    this._angleRadians = angleRadians;
    this._linearVelocity = linearVelocity;
    this._angularVelocity = angularVelocity;
    this._linearDamping = linearDamping;
    this._angularDamping = angularDamping;
    this._allowSleep = allowSleep;
    this._awake = awake;
    this._fixedRotation = fixedRotation;
    this._bullet = bullet;
    this._active = active;
    this._gravityScale_0 = gravityScale;
    this._$$delegate_0_2 = new Mixin_0();
  }
  BodyDef.prototype.toString = function () {
    return '' + 'BodyDef(type=' + this._type_7 + ', userData=' + this._userData_1 + ', position=' + this._position_0 + ', angleRadians=' + this._angleRadians + ', linearVelocity=' + this._linearVelocity + ', angularVelocity=' + this._angularVelocity + ', linearDamping=' + this._linearDamping + ', angularDamping=' + this._angularDamping + ', allowSleep=' + this._allowSleep + ', awake=' + this._awake + ', fixedRotation=' + this._fixedRotation + ', bullet=' + this._bullet + ', active=' + this._active + ', gravityScale=' + this._gravityScale_0 + ')';
  };
  BodyDef.prototype.hashCode = function () {
    var result = this._type_7.hashCode();
    result = imul(result, 31) + (this._userData_1 == null ? 0 : hashCode(this._userData_1)) | 0;
    result = imul(result, 31) + this._position_0.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._angleRadians) | 0;
    result = imul(result, 31) + this._linearVelocity.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._angularVelocity) | 0;
    result = imul(result, 31) + getNumberHashCode(this._linearDamping) | 0;
    result = imul(result, 31) + getNumberHashCode(this._angularDamping) | 0;
    result = imul(result, 31) + (this._allowSleep | 0) | 0;
    result = imul(result, 31) + (this._awake | 0) | 0;
    result = imul(result, 31) + (this._fixedRotation | 0) | 0;
    result = imul(result, 31) + (this._bullet | 0) | 0;
    result = imul(result, 31) + (this._active | 0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._gravityScale_0) | 0;
    return result;
  };
  BodyDef.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BodyDef))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof BodyDef ? other : THROW_CCE();
    if (!this._type_7.equals(tmp0_other_with_cast._type_7))
      return false;
    if (!equals_1(this._userData_1, tmp0_other_with_cast._userData_1))
      return false;
    if (!this._position_0.equals(tmp0_other_with_cast._position_0))
      return false;
    if (!equals_1(this._angleRadians, tmp0_other_with_cast._angleRadians))
      return false;
    if (!this._linearVelocity.equals(tmp0_other_with_cast._linearVelocity))
      return false;
    if (!equals_1(this._angularVelocity, tmp0_other_with_cast._angularVelocity))
      return false;
    if (!equals_1(this._linearDamping, tmp0_other_with_cast._linearDamping))
      return false;
    if (!equals_1(this._angularDamping, tmp0_other_with_cast._angularDamping))
      return false;
    if (!(this._allowSleep === tmp0_other_with_cast._allowSleep))
      return false;
    if (!(this._awake === tmp0_other_with_cast._awake))
      return false;
    if (!(this._fixedRotation === tmp0_other_with_cast._fixedRotation))
      return false;
    if (!(this._bullet === tmp0_other_with_cast._bullet))
      return false;
    if (!(this._active === tmp0_other_with_cast._active))
      return false;
    if (!equals_1(this._gravityScale_0, tmp0_other_with_cast._gravityScale_0))
      return false;
    return true;
  };
  BodyDef.$metadata$ = {
    simpleName: 'BodyDef',
    kind: 'class',
    interfaces: [Box2dTypedUserData]
  };
  var BodyType_STATIC_instance;
  var BodyType_KINEMATIC_instance;
  var BodyType_DYNAMIC_instance;
  function Companion_75() {
    Companion_instance_74 = this;
    var tmp = this;
    var tmp0_associateBy_0 = values_1();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_toUpperCase_0_6 = element_2_4._get_name__0_k$();
      tmp0_associateByTo_0_2.put_1q9pf_k$(tmp0_toUpperCase_0_6.toUpperCase(), element_2_4);
      Unit_getInstance();
    }
    tmp._BY_NAME = tmp0_associateByTo_0_2;
  }
  Companion_75.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_74;
  function Companion_getInstance_74() {
    if (Companion_instance_74 == null)
      new Companion_75();
    return Companion_instance_74;
  }
  function values_1() {
    return [BodyType_STATIC_getInstance(), BodyType_KINEMATIC_getInstance(), BodyType_DYNAMIC_getInstance()];
  }
  var BodyType_entriesInitialized;
  function BodyType_initEntries() {
    if (BodyType_entriesInitialized)
      return Unit_getInstance();
    BodyType_entriesInitialized = true;
    BodyType_STATIC_instance = new BodyType('STATIC', 0);
    BodyType_KINEMATIC_instance = new BodyType('KINEMATIC', 1);
    BodyType_DYNAMIC_instance = new BodyType('DYNAMIC', 2);
    Companion_getInstance_74();
  }
  function BodyType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  BodyType.$metadata$ = {
    simpleName: 'BodyType',
    kind: 'class',
    interfaces: []
  };
  function BodyType_STATIC_getInstance() {
    BodyType_initEntries();
    return BodyType_STATIC_instance;
  }
  function BodyType_KINEMATIC_getInstance() {
    BodyType_initEntries();
    return BodyType_KINEMATIC_instance;
  }
  function BodyType_DYNAMIC_getInstance() {
    BodyType_initEntries();
    return BodyType_DYNAMIC_instance;
  }
  function ContactManager(pool, m_broadPhase) {
    this._pool_3 = pool;
    this._m_broadPhase = m_broadPhase;
    this._m_contactList_0 = null;
    this._m_contactCount = 0;
    this._m_contactFilter = new ContactFilter();
    this._m_contactListener = null;
  }
  ContactManager.prototype.addPair_23fbgv_k$ = function (proxyUserDataA, proxyUserDataB) {
    var proxyA = (proxyUserDataA == null ? true : proxyUserDataA instanceof FixtureProxy) ? proxyUserDataA : THROW_CCE();
    var proxyB = (proxyUserDataB == null ? true : proxyUserDataB instanceof FixtureProxy) ? proxyUserDataB : THROW_CCE();
    var fixtureA = ensureNotNull(proxyA)._fixture;
    var fixtureB = ensureNotNull(proxyB)._fixture;
    var indexA = proxyA._childIndex;
    var indexB = proxyB._childIndex;
    var bodyA = ensureNotNull(fixtureA).getBody_0_k$();
    var bodyB = ensureNotNull(fixtureB).getBody_0_k$();
    if (equals_1(bodyA, bodyB)) {
      return Unit_getInstance();
    }var edge = ensureNotNull(bodyB).getContactList_0_k$();
    while (!(edge == null)) {
      if (equals_1(edge._other, bodyA)) {
        var fA = ensureNotNull(edge._contact).getFixtureA_0_k$();
        var fB = ensureNotNull(edge._contact).getFixtureB_0_k$();
        var iA = ensureNotNull(edge._contact).getChildIndexA_0_k$();
        var iB = ensureNotNull(edge._contact).getChildIndexB_0_k$();
        if (((equals_1(fA, fixtureA) ? iA === indexA : false) ? equals_1(fB, fixtureB) : false) ? iB === indexB : false) {
          return Unit_getInstance();
        }if (((equals_1(fA, fixtureB) ? iA === indexB : false) ? equals_1(fB, fixtureA) : false) ? iB === indexA : false) {
          return Unit_getInstance();
        }}edge = edge._next_5;
    }
    if (bodyB.shouldCollide_ywoppm_k$(ensureNotNull(bodyA)) === false) {
      return Unit_getInstance();
    }if (!(this._m_contactFilter == null) ? ensureNotNull(this._m_contactFilter).shouldCollide_ak8ea_k$(fixtureA, fixtureB) === false : false) {
      return Unit_getInstance();
    }var tmp0_elvis_lhs = this._pool_3.popContact_jgapkw_k$(fixtureA, indexA, fixtureB, indexB);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var c = tmp;
    fixtureA = c.getFixtureA_0_k$();
    fixtureB = c.getFixtureB_0_k$();
    indexA = c.getChildIndexA_0_k$();
    indexB = c.getChildIndexB_0_k$();
    bodyA = ensureNotNull(fixtureA).getBody_0_k$();
    bodyB = ensureNotNull(fixtureB).getBody_0_k$();
    c._m_prev = null;
    c._m_next_1 = this._m_contactList_0;
    if (!(this._m_contactList_0 == null)) {
      ensureNotNull(this._m_contactList_0)._m_prev = c;
    }this._m_contactList_0 = c;
    c._m_nodeA._contact = c;
    c._m_nodeA._other = bodyB;
    c._m_nodeA._prev_1 = null;
    c._m_nodeA._next_5 = ensureNotNull(bodyA)._m_contactList;
    if (!(bodyA._m_contactList == null)) {
      ensureNotNull(bodyA._m_contactList)._prev_1 = c._m_nodeA;
    }bodyA._m_contactList = c._m_nodeA;
    c._m_nodeB._contact = c;
    c._m_nodeB._other = bodyA;
    c._m_nodeB._prev_1 = null;
    c._m_nodeB._next_5 = ensureNotNull(bodyB)._m_contactList;
    if (!(bodyB._m_contactList == null)) {
      ensureNotNull(bodyB._m_contactList)._prev_1 = c._m_nodeB;
    }bodyB._m_contactList = c._m_nodeB;
    if (!fixtureA._get_isSensor__0_k$() ? !fixtureB._get_isSensor__0_k$() : false) {
      bodyA._set_isAwake__rpwsgn_k$(true);
      bodyB._set_isAwake__rpwsgn_k$(true);
    }var tmp1_this = this;
    tmp1_this._m_contactCount = tmp1_this._m_contactCount + 1 | 0;
    Unit_getInstance();
  };
  ContactManager.prototype.findNewContacts_sv8swh_k$ = function () {
    this._m_broadPhase.updatePairs_mno5cw_k$(this);
  };
  ContactManager.prototype.destroy_qmxzzw_k$ = function (c) {
    var fixtureA = c.getFixtureA_0_k$();
    var fixtureB = c.getFixtureB_0_k$();
    var bodyA = ensureNotNull(fixtureA).getBody_0_k$();
    var bodyB = ensureNotNull(fixtureB).getBody_0_k$();
    if (!(this._m_contactListener == null) ? c._get_isTouching__0_k$() : false) {
      ensureNotNull(this._m_contactListener).endContact_qmxzzw_k$(c);
    }if (!(c._m_prev == null)) {
      ensureNotNull(c._m_prev)._m_next_1 = c._m_next_1;
    }if (!(c._m_next_1 == null)) {
      ensureNotNull(c._m_next_1)._m_prev = c._m_prev;
    }if (c === this._m_contactList_0) {
      this._m_contactList_0 = c._m_next_1;
    }if (!(c._m_nodeA._prev_1 == null)) {
      ensureNotNull(c._m_nodeA._prev_1)._next_5 = c._m_nodeA._next_5;
    }if (!(c._m_nodeA._next_5 == null)) {
      ensureNotNull(c._m_nodeA._next_5)._prev_1 = c._m_nodeA._prev_1;
    }if (equals_1(c._m_nodeA, ensureNotNull(bodyA)._m_contactList)) {
      bodyA._m_contactList = c._m_nodeA._next_5;
    }if (!(c._m_nodeB._prev_1 == null)) {
      ensureNotNull(c._m_nodeB._prev_1)._next_5 = c._m_nodeB._next_5;
    }if (!(c._m_nodeB._next_5 == null)) {
      ensureNotNull(c._m_nodeB._next_5)._prev_1 = c._m_nodeB._prev_1;
    }if (equals_1(c._m_nodeB, ensureNotNull(bodyB)._m_contactList)) {
      bodyB._m_contactList = c._m_nodeB._next_5;
    }this._pool_3.pushContact_qmxzzw_k$(c);
    var tmp0_this = this;
    tmp0_this._m_contactCount = tmp0_this._m_contactCount - 1 | 0;
    Unit_getInstance();
  };
  ContactManager.prototype.collide_sv8swh_k$ = function () {
    var c = this._m_contactList_0;
    while (!(c == null)) {
      var fixtureA = c.getFixtureA_0_k$();
      var fixtureB = c.getFixtureB_0_k$();
      var indexA = c.getChildIndexA_0_k$();
      var indexB = c.getChildIndexB_0_k$();
      var bodyA = ensureNotNull(fixtureA).getBody_0_k$();
      var bodyB = ensureNotNull(fixtureB).getBody_0_k$();
      if ((c._m_flags_0 & Companion_getInstance_77()._FILTER_FLAG) === Companion_getInstance_77()._FILTER_FLAG) {
        if (ensureNotNull(bodyB).shouldCollide_ywoppm_k$(ensureNotNull(bodyA)) === false) {
          var cNuke = c;
          c = cNuke.getNext_0_k$();
          this.destroy_qmxzzw_k$(cNuke);
          continue;
        }if (!(this._m_contactFilter == null) ? ensureNotNull(this._m_contactFilter).shouldCollide_ak8ea_k$(fixtureA, fixtureB) === false : false) {
          var cNuke_0 = c;
          c = cNuke_0.getNext_0_k$();
          this.destroy_qmxzzw_k$(cNuke_0);
          continue;
        }c._m_flags_0 = c._m_flags_0 & ~Companion_getInstance_77()._FILTER_FLAG;
      }var activeA = ensureNotNull(bodyA)._get_isAwake__0_k$() ? !(bodyA.__type === BodyType_STATIC_getInstance()) : false;
      var activeB = ensureNotNull(bodyB)._get_isAwake__0_k$() ? !(bodyB.__type === BodyType_STATIC_getInstance()) : false;
      if (activeA === false ? activeB === false : false) {
        c = c.getNext_0_k$();
        continue;
      }var proxyIdA = ensureNotNull(fixtureA._m_proxies)[indexA]._proxyId;
      var proxyIdB = ensureNotNull(fixtureB._m_proxies)[indexB]._proxyId;
      var overlap = this._m_broadPhase.testOverlap_27zxwg_k$(proxyIdA, proxyIdB);
      if (overlap === false) {
        var cNuke_1 = c;
        c = cNuke_1.getNext_0_k$();
        this.destroy_qmxzzw_k$(cNuke_1);
        continue;
      }c.update_cbzc8c_k$(this._m_contactListener);
      c = c.getNext_0_k$();
    }
  };
  ContactManager.$metadata$ = {
    simpleName: 'ContactManager',
    kind: 'class',
    interfaces: [PairCallback]
  };
  function Filter() {
    this._categoryBits = 1;
    this._maskBits = 65535;
    this._groupIndex = 0;
  }
  Filter.prototype.set_lzwv5b_k$ = function (argOther) {
    this._categoryBits = argOther._categoryBits;
    this._maskBits = argOther._maskBits;
    this._groupIndex = argOther._groupIndex;
  };
  Filter.$metadata$ = {
    simpleName: 'Filter',
    kind: 'class',
    interfaces: []
  };
  function Fixture() {
    this._$$delegate_0_3 = new Mixin_0();
    this._m_density = 0;
    this._m_next_0 = null;
    this._m_body = null;
    this._m_shape = null;
    this._m_friction = 0;
    this._m_restitution = 0;
    this._m_proxies = null;
    this._m_proxyCount = 0;
    this._m_filter = new Filter();
    this._m_isSensor = false;
    this._userData_2 = null;
    this._pool1_0 = AABB_init_$Create$();
    this._pool2_0 = AABB_init_$Create$();
    var tmp = this;
    tmp._displacement = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  Fixture.prototype.getBody_0_k$ = function () {
    return this._m_body;
  };
  Fixture.prototype.getShape_0_k$ = function () {
    return this._m_shape;
  };
  Fixture.prototype._get_type__0_k$ = function () {
    return ensureNotNull(this._m_shape).getType_0_k$();
  };
  Fixture.prototype._get_isSensor__0_k$ = function () {
    return this._m_isSensor;
  };
  Fixture.prototype._get_filterData__0_k$ = function () {
    return this._m_filter;
  };
  Fixture.prototype.raycast_vrsk3a_k$ = function (output_0, input, childIndex) {
    return ensureNotNull(this._m_shape).raycast_nhm1uj_k$(output_0, input, ensureNotNull(this._m_body)._xf_0, childIndex);
  };
  Fixture.prototype.getMassData_ov4cnv_k$ = function (massData) {
    ensureNotNull(this._m_shape).computeMass_onjsjz_k$(massData, this._m_density);
  };
  Fixture.prototype.getAABB_ha5a7z_k$ = function (childIndex) {
    var tmp0_assert_0 = childIndex >= 0 ? childIndex < this._m_proxyCount : false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }return ensureNotNull(this._m_proxies)[childIndex]._aabb_1;
  };
  Fixture.prototype.computeDistance_7zj6nx_k$ = function (p, childIndex, normalOut) {
    return ensureNotNull(this._m_shape).computeDistanceToOut_m1unj2_k$(ensureNotNull(this._m_body)._get_transform__0_k$(), p, childIndex, normalOut);
  };
  Fixture.prototype.create_gpltrr_k$ = function (body, def) {
    this._userData_2 = def._userData_3;
    this._m_friction = def._friction;
    this._m_restitution = def._restitution;
    this._m_body = body;
    this._m_next_0 = null;
    this._m_filter.set_lzwv5b_k$(def._filter);
    this._m_isSensor = def._isSensor;
    this._m_shape = ensureNotNull(def._shape).clone_0_k$();
    var childCount = ensureNotNull(this._m_shape).getChildCount_0_k$();
    if (this._m_proxies == null) {
      var tmp = this;
      var tmp_0 = 0;
      var tmp_1 = childCount;
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        tmp_2[tmp_3] = new FixtureProxy();
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp._m_proxies = tmp_2;
      var inductionVariable = 0;
      if (inductionVariable < childCount)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          ensureNotNull(this._m_proxies)[i]._fixture = null;
          ensureNotNull(this._m_proxies)[i]._proxyId = Companion_getInstance_62()._NULL_PROXY;
        }
         while (inductionVariable < childCount);
    }if (ensureNotNull(this._m_proxies).length < childCount) {
      var old = this._m_proxies;
      var newLen = Companion_getInstance_68().max_27zxwg_k$(imul(ensureNotNull(old).length, 2), childCount);
      var tmp_4 = this;
      var tmp_5 = fillArrayVal(Array(newLen), null);
      tmp_4._m_proxies = isArray(tmp_5) ? tmp_5 : THROW_CCE();
      var tmp0_arraycopy_0 = ensureNotNull(this._m_proxies);
      var tmp1_arraycopy_0 = old.length;
      var tmp0_copyInto_0_2 = 0 + tmp1_arraycopy_0 | 0;
      arrayCopy_0(old, tmp0_arraycopy_0, 0, 0, tmp0_copyInto_0_2);
      Unit_getInstance();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < newLen)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (i_0 >= old.length) {
            ensureNotNull(this._m_proxies)[i_0] = new FixtureProxy();
          }ensureNotNull(this._m_proxies)[i_0]._fixture = null;
          ensureNotNull(this._m_proxies)[i_0]._proxyId = Companion_getInstance_62()._NULL_PROXY;
        }
         while (inductionVariable_0 < newLen);
    }this._m_proxyCount = 0;
    this._m_density = def._density;
  };
  Fixture.prototype.destroy_sv8swh_k$ = function () {
    var tmp0_assert_0 = this._m_proxyCount === 0;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }this._m_shape = null;
    this._m_proxies = null;
    this._m_next_0 = null;
  };
  Fixture.prototype.createProxies_844mye_k$ = function (broadPhase, xf) {
    var tmp0_assert_0 = this._m_proxyCount === 0;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }this._m_proxyCount = ensureNotNull(this._m_shape).getChildCount_0_k$();
    var inductionVariable = 0;
    var last_1 = this._m_proxyCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var proxy = ensureNotNull(this._m_proxies)[i];
        ensureNotNull(this._m_shape).computeAABB_n67093_k$(proxy._aabb_1, xf, i);
        proxy._proxyId = broadPhase.createProxy_ojzcmo_k$(proxy._aabb_1, proxy);
        proxy._fixture = this;
        proxy._childIndex = i;
      }
       while (inductionVariable < last_1);
  };
  Fixture.prototype.destroyProxies_7gve4v_k$ = function (broadPhase) {
    var inductionVariable = 0;
    var last_1 = this._m_proxyCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var proxy = ensureNotNull(this._m_proxies)[i];
        broadPhase.destroyProxy_majfzk_k$(proxy._proxyId);
        proxy._proxyId = Companion_getInstance_62()._NULL_PROXY;
      }
       while (inductionVariable < last_1);
    this._m_proxyCount = 0;
  };
  Fixture.prototype.synchronize_clrj23_k$ = function (broadPhase, transform1, transform2) {
    if (this._m_proxyCount === 0) {
      return Unit_getInstance();
    }var inductionVariable = 0;
    var last_1 = this._m_proxyCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var proxy = ensureNotNull(this._m_proxies)[i];
        var aabb1 = this._pool1_0;
        var aab = this._pool2_0;
        ensureNotNull(this._m_shape).computeAABB_n67093_k$(aabb1, transform1, proxy._childIndex);
        ensureNotNull(this._m_shape).computeAABB_n67093_k$(aab, transform2, proxy._childIndex);
        proxy._aabb_1._lowerBound._x_7 = aabb1._lowerBound._x_7 < aab._lowerBound._x_7 ? aabb1._lowerBound._x_7 : aab._lowerBound._x_7;
        proxy._aabb_1._lowerBound._y_6 = aabb1._lowerBound._y_6 < aab._lowerBound._y_6 ? aabb1._lowerBound._y_6 : aab._lowerBound._y_6;
        proxy._aabb_1._upperBound._x_7 = aabb1._upperBound._x_7 > aab._upperBound._x_7 ? aabb1._upperBound._x_7 : aab._upperBound._x_7;
        proxy._aabb_1._upperBound._y_6 = aabb1._upperBound._y_6 > aab._upperBound._y_6 ? aabb1._upperBound._y_6 : aab._upperBound._y_6;
        this._displacement._x_7 = transform2._p_1._x_7 - transform1._p_1._x_7;
        this._displacement._y_6 = transform2._p_1._y_6 - transform1._p_1._y_6;
        broadPhase.moveProxy_cdborz_k$(proxy._proxyId, proxy._aabb_1, this._displacement);
      }
       while (inductionVariable < last_1);
  };
  Fixture.$metadata$ = {
    simpleName: 'Fixture',
    kind: 'class',
    interfaces: [Box2dTypedUserData]
  };
  function FixtureDef_init_$Init$(shape, userData, friction, restitution, density, isSensor, filter, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      shape = null;
    if (!(($mask0 & 2) === 0))
      userData = null;
    if (!(($mask0 & 4) === 0))
      friction = 0.2;
    if (!(($mask0 & 8) === 0))
      restitution = 0.0;
    if (!(($mask0 & 16) === 0))
      density = 0.0;
    if (!(($mask0 & 32) === 0))
      isSensor = false;
    if (!(($mask0 & 64) === 0))
      filter = new Filter();
    FixtureDef.call($this, shape, userData, friction, restitution, density, isSensor, filter);
    return $this;
  }
  function FixtureDef_init_$Create$(shape, userData, friction, restitution, density, isSensor, filter, $mask0, $marker) {
    return FixtureDef_init_$Init$(shape, userData, friction, restitution, density, isSensor, filter, $mask0, $marker, Object.create(FixtureDef.prototype));
  }
  function FixtureDef(shape, userData, friction, restitution, density, isSensor, filter) {
    this._shape = shape;
    this._userData_3 = userData;
    this._friction = friction;
    this._restitution = restitution;
    this._density = density;
    this._isSensor = isSensor;
    this._filter = filter;
    this._$$delegate_0_4 = new Mixin_0();
  }
  FixtureDef.prototype.toString = function () {
    return '' + 'FixtureDef(shape=' + this._shape + ', userData=' + this._userData_3 + ', friction=' + this._friction + ', restitution=' + this._restitution + ', density=' + this._density + ', isSensor=' + this._isSensor + ', filter=' + this._filter + ')';
  };
  FixtureDef.prototype.hashCode = function () {
    var result = this._shape == null ? 0 : hashCode(this._shape);
    result = imul(result, 31) + (this._userData_3 == null ? 0 : hashCode(this._userData_3)) | 0;
    result = imul(result, 31) + getNumberHashCode(this._friction) | 0;
    result = imul(result, 31) + getNumberHashCode(this._restitution) | 0;
    result = imul(result, 31) + getNumberHashCode(this._density) | 0;
    result = imul(result, 31) + (this._isSensor | 0) | 0;
    result = imul(result, 31) + hashCode(this._filter) | 0;
    return result;
  };
  FixtureDef.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FixtureDef))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FixtureDef ? other : THROW_CCE();
    if (!equals_1(this._shape, tmp0_other_with_cast._shape))
      return false;
    if (!equals_1(this._userData_3, tmp0_other_with_cast._userData_3))
      return false;
    if (!equals_1(this._friction, tmp0_other_with_cast._friction))
      return false;
    if (!equals_1(this._restitution, tmp0_other_with_cast._restitution))
      return false;
    if (!equals_1(this._density, tmp0_other_with_cast._density))
      return false;
    if (!(this._isSensor === tmp0_other_with_cast._isSensor))
      return false;
    if (!equals_1(this._filter, tmp0_other_with_cast._filter))
      return false;
    return true;
  };
  FixtureDef.$metadata$ = {
    simpleName: 'FixtureDef',
    kind: 'class',
    interfaces: [Box2dTypedUserData]
  };
  function FixtureProxy() {
    this._aabb_1 = AABB_init_$Create$();
    this._fixture = null;
    this._childIndex = 0;
    this._proxyId = 0;
  }
  FixtureProxy.$metadata$ = {
    simpleName: 'FixtureProxy',
    kind: 'class',
    interfaces: []
  };
  function Island() {
    this._m_listener = null;
    this._m_bodies = null;
    this._m_contacts = null;
    this._m_joints = null;
    this._m_positions = null;
    this._m_velocities = null;
    this._m_bodyCount = 0;
    this._m_jointCount = 0;
    this._m_contactCount_0 = 0;
    this._m_bodyCapacity = 0;
    this._m_contactCapacity = 0;
    this._m_jointCapacity = 0;
    this._contactSolver = new ContactSolver();
    this._timer = new Timer();
    this._solverData = new SolverData();
    this._solverDef = new ContactSolverDef();
    this._toiContactSolver = new ContactSolver();
    this._toiSolverDef = new ContactSolverDef();
    this._impulse = new ContactImpulse();
  }
  Island.prototype.init_81qlpv_k$ = function (bodyCapacity, contactCapacity, jointCapacity, listener) {
    this._m_bodyCapacity = bodyCapacity;
    this._m_contactCapacity = contactCapacity;
    this._m_jointCapacity = jointCapacity;
    this._m_bodyCount = 0;
    this._m_contactCount_0 = 0;
    this._m_jointCount = 0;
    this._m_listener = listener;
    if (this._m_bodies == null ? true : this._m_bodyCapacity > ensureNotNull(this._m_bodies).length) {
      var tmp = this;
      var tmp0_arrayOfNulls_0 = this._m_bodyCapacity;
      var tmp_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
      tmp._m_bodies = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    }if (this._m_joints == null ? true : this._m_jointCapacity > ensureNotNull(this._m_joints).length) {
      var tmp_1 = this;
      var tmp1_arrayOfNulls_0 = this._m_jointCapacity;
      var tmp_2 = fillArrayVal(Array(tmp1_arrayOfNulls_0), null);
      tmp_1._m_joints = isArray(tmp_2) ? tmp_2 : THROW_CCE();
    }if (this._m_contacts == null ? true : this._m_contactCapacity > ensureNotNull(this._m_contacts).length) {
      var tmp_3 = this;
      var tmp2_arrayOfNulls_0 = this._m_contactCapacity;
      var tmp_4 = fillArrayVal(Array(tmp2_arrayOfNulls_0), null);
      tmp_3._m_contacts = isArray(tmp_4) ? tmp_4 : THROW_CCE();
    }if (this._m_velocities == null ? true : this._m_bodyCapacity > ensureNotNull(this._m_velocities).length) {
      var tmp_5;
      if (this._m_velocities == null) {
        tmp_5 = [];
      } else {
        tmp_5 = this._m_velocities;
      }
      var old = tmp_5;
      var tmp_6 = this;
      var tmp3_arrayOfNulls_0 = this._m_bodyCapacity;
      var tmp_7 = fillArrayVal(Array(tmp3_arrayOfNulls_0), null);
      tmp_6._m_velocities = isArray(tmp_7) ? tmp_7 : THROW_CCE();
      var tmp4_arraycopy_0 = ensureNotNull(old);
      var tmp5_arraycopy_0 = ensureNotNull(this._m_velocities);
      var tmp6_arraycopy_0 = ensureNotNull(old).length;
      var tmp0_copyInto_0_2 = 0 + tmp6_arraycopy_0 | 0;
      arrayCopy_0(tmp4_arraycopy_0, tmp5_arraycopy_0, 0, 0, tmp0_copyInto_0_2);
      Unit_getInstance();
      var inductionVariable = ensureNotNull(old).length;
      var last_1 = ensureNotNull(this._m_velocities).length;
      if (inductionVariable < last_1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          ensureNotNull(this._m_velocities)[i] = new Velocity();
        }
         while (inductionVariable < last_1);
    }if (this._m_positions == null ? true : this._m_bodyCapacity > ensureNotNull(this._m_positions).length) {
      var tmp_8;
      if (this._m_positions == null) {
        tmp_8 = [];
      } else {
        tmp_8 = this._m_positions;
      }
      var old_0 = tmp_8;
      var tmp_9 = this;
      var tmp7_arrayOfNulls_0 = this._m_bodyCapacity;
      var tmp_10 = fillArrayVal(Array(tmp7_arrayOfNulls_0), null);
      tmp_9._m_positions = isArray(tmp_10) ? tmp_10 : THROW_CCE();
      var tmp8_arraycopy_0 = ensureNotNull(old_0);
      var tmp9_arraycopy_0 = ensureNotNull(this._m_positions);
      var tmp10_arraycopy_0 = ensureNotNull(old_0).length;
      var tmp0_copyInto_0_2_0 = 0 + tmp10_arraycopy_0 | 0;
      arrayCopy_0(tmp8_arraycopy_0, tmp9_arraycopy_0, 0, 0, tmp0_copyInto_0_2_0);
      Unit_getInstance();
      var inductionVariable_0 = ensureNotNull(old_0).length;
      var last_2 = ensureNotNull(this._m_positions).length;
      if (inductionVariable_0 < last_2)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          ensureNotNull(this._m_positions)[i_0] = new Position();
        }
         while (inductionVariable_0 < last_2);
    }};
  Island.prototype.clear_sv8swh_k$ = function () {
    this._m_bodyCount = 0;
    this._m_contactCount_0 = 0;
    this._m_jointCount = 0;
  };
  Island.prototype.solve_jh2qai_k$ = function (profile, step_0, gravity, allowSleep) {
    var h = step_0._dt;
    var inductionVariable = 0;
    var last_1 = this._m_bodyCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = ensureNotNull(this._m_bodies)[i];
        var bm_sweep = b._sweep;
        var c = bm_sweep._c_1;
        var a = bm_sweep._a_1;
        var v = b.__linearVelocity;
        var w = b.__angularVelocity;
        bm_sweep._c0.set_1v0asv_k$(bm_sweep._c_1);
        Unit_getInstance();
        bm_sweep._a0 = bm_sweep._a_1;
        if (b.__type === BodyType_DYNAMIC_getInstance()) {
          var tmp1_this = v;
          tmp1_this._x_7 = tmp1_this._x_7 + h * (b._gravityScale * gravity._x_7 + b._m_invMass * b._force._x_7);
          var tmp2_this = v;
          tmp2_this._y_6 = tmp2_this._y_6 + h * (b._gravityScale * gravity._y_6 + b._m_invMass * b._force._y_6);
          w = w + h * b._m_invI * b._torque;
          var tmp3_this = v;
          tmp3_this._x_7 = tmp3_this._x_7 * (1.0 / (1.0 + h * b._m_linearDamping));
          var tmp4_this = v;
          tmp4_this._y_6 = tmp4_this._y_6 * (1.0 / (1.0 + h * b._m_linearDamping));
          w = w * (1.0 / (1.0 + h * b._m_angularDamping));
        }ensureNotNull(this._m_positions)[i]._c_2._x_7 = c._x_7;
        ensureNotNull(this._m_positions)[i]._c_2._y_6 = c._y_6;
        ensureNotNull(this._m_positions)[i]._a_2 = a;
        ensureNotNull(this._m_velocities)[i]._v_1._x_7 = v._x_7;
        ensureNotNull(this._m_velocities)[i]._v_1._y_6 = v._y_6;
        ensureNotNull(this._m_velocities)[i]._w_2 = w;
      }
       while (inductionVariable < last_1);
    this._timer.reset_sv8swh_k$();
    this._solverData._step_6 = step_0;
    this._solverData._positions = this._m_positions;
    this._solverData._velocities = this._m_velocities;
    this._solverDef._step_8 = step_0;
    this._solverDef._contacts = this._m_contacts;
    this._solverDef._count_5 = this._m_contactCount_0;
    this._solverDef._positions_0 = this._m_positions;
    this._solverDef._velocities_0 = this._m_velocities;
    this._contactSolver.init_a505ec_k$(this._solverDef);
    this._contactSolver.initializeVelocityConstraints_sv8swh_k$();
    if (step_0._warmStarting) {
      this._contactSolver.warmStart_sv8swh_k$();
    }var inductionVariable_0 = 0;
    var last_2 = this._m_jointCount;
    if (inductionVariable_0 < last_2)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        ensureNotNull(this._m_joints)[i_0].initVelocityConstraints_8wbslw_k$(this._solverData);
      }
       while (inductionVariable_0 < last_2);
    profile._solveInit.accum_cpozfn_k$(this._timer._get_milliseconds__0_k$());
    this._timer.reset_sv8swh_k$();
    var inductionVariable_1 = 0;
    var last_3 = step_0._velocityIterations;
    if (inductionVariable_1 < last_3)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_4 = this._m_jointCount;
        if (inductionVariable_2 < last_4)
          do {
            var j = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            ensureNotNull(this._m_joints)[j].solveVelocityConstraints_8wbslw_k$(this._solverData);
          }
           while (inductionVariable_2 < last_4);
        this._contactSolver.solveVelocityConstraints_sv8swh_k$();
      }
       while (inductionVariable_1 < last_3);
    this._contactSolver.storeImpulses_sv8swh_k$();
    profile._solveVelocity.accum_cpozfn_k$(this._timer._get_milliseconds__0_k$());
    var inductionVariable_3 = 0;
    var last_5 = this._m_bodyCount;
    if (inductionVariable_3 < last_5)
      do {
        var i_2 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var c_0 = ensureNotNull(this._m_positions)[i_2]._c_2;
        var a_0 = ensureNotNull(this._m_positions)[i_2]._a_2;
        var v_0 = ensureNotNull(this._m_velocities)[i_2]._v_1;
        var w_0 = ensureNotNull(this._m_velocities)[i_2]._w_2;
        var translationx = v_0._x_7 * h;
        var translationy = v_0._y_6 * h;
        if (translationx * translationx + translationy * translationy > Settings_getInstance()._get_maxTranslationSquared__0_k$()) {
          var ratio = Settings_getInstance()._get_maxTranslation__0_k$() / Companion_getInstance_68().sqrt_dbmacu_k$(translationx * translationx + translationy * translationy);
          var tmp9_this = v_0;
          tmp9_this._x_7 = tmp9_this._x_7 * ratio;
          var tmp10_this = v_0;
          tmp10_this._y_6 = tmp10_this._y_6 * ratio;
        }var rotation_0 = h * w_0;
        if (rotation_0 * rotation_0 > Settings_getInstance()._get_maxRotationSquared__0_k$()) {
          var ratio_0 = Settings_getInstance()._get_maxRotation__0_k$() / Companion_getInstance_68().abs_dbmacu_k$(rotation_0);
          w_0 = w_0 * ratio_0;
        }var tmp11_this = c_0;
        tmp11_this._x_7 = tmp11_this._x_7 + h * v_0._x_7;
        var tmp12_this = c_0;
        tmp12_this._y_6 = tmp12_this._y_6 + h * v_0._y_6;
        a_0 = a_0 + h * w_0;
        ensureNotNull(this._m_positions)[i_2]._a_2 = a_0;
        ensureNotNull(this._m_velocities)[i_2]._w_2 = w_0;
      }
       while (inductionVariable_3 < last_5);
    this._timer.reset_sv8swh_k$();
    var positionSolved = false;
    var inductionVariable_4 = 0;
    var last_6 = step_0._positionIterations;
    if (inductionVariable_4 < last_6)
      $l$break: do {
        var i_3 = inductionVariable_4;
        inductionVariable_4 = inductionVariable_4 + 1 | 0;
        var contactsOkay = this._contactSolver.solvePositionConstraints_0_k$();
        var jointsOkay = true;
        var inductionVariable_5 = 0;
        var last_7 = this._m_jointCount;
        if (inductionVariable_5 < last_7)
          do {
            var j_0 = inductionVariable_5;
            inductionVariable_5 = inductionVariable_5 + 1 | 0;
            var jointOkay = ensureNotNull(this._m_joints)[j_0].solvePositionConstraints_kq7mj_k$(this._solverData);
            jointsOkay = jointsOkay ? jointOkay : false;
          }
           while (inductionVariable_5 < last_7);
        if (contactsOkay ? jointsOkay : false) {
          positionSolved = true;
          break $l$break;
        }}
       while (inductionVariable_4 < last_6);
    var inductionVariable_6 = 0;
    var last_8 = this._m_bodyCount;
    if (inductionVariable_6 < last_8)
      do {
        var i_4 = inductionVariable_6;
        inductionVariable_6 = inductionVariable_6 + 1 | 0;
        var body = ensureNotNull(this._m_bodies)[i_4];
        body._sweep._c_1._x_7 = ensureNotNull(this._m_positions)[i_4]._c_2._x_7;
        body._sweep._c_1._y_6 = ensureNotNull(this._m_positions)[i_4]._c_2._y_6;
        body._sweep._a_1 = ensureNotNull(this._m_positions)[i_4]._a_2;
        body.__linearVelocity._x_7 = ensureNotNull(this._m_velocities)[i_4]._v_1._x_7;
        body.__linearVelocity._y_6 = ensureNotNull(this._m_velocities)[i_4]._v_1._y_6;
        body.__angularVelocity = ensureNotNull(this._m_velocities)[i_4]._w_2;
        body.synchronizeTransform_sv8swh_k$();
      }
       while (inductionVariable_6 < last_8);
    profile._solvePosition.accum_cpozfn_k$(this._timer._get_milliseconds__0_k$());
    this.report_xuxbf0_k$(this._contactSolver._m_velocityConstraints);
    if (allowSleep) {
      FloatCompanionObject_getInstance();
      var minSleepTime = 3.4028235E38;
      var linTolSqr = Settings_getInstance()._get_linearSleepTolerance__0_k$() * Settings_getInstance()._get_linearSleepTolerance__0_k$();
      var angTolSqr = Settings_getInstance()._get_angularSleepTolerance__0_k$() * Settings_getInstance()._get_angularSleepTolerance__0_k$();
      var inductionVariable_7 = 0;
      var last_9 = this._m_bodyCount;
      if (inductionVariable_7 < last_9)
        do {
          var i_5 = inductionVariable_7;
          inductionVariable_7 = inductionVariable_7 + 1 | 0;
          var b_0 = ensureNotNull(this._m_bodies)[i_5];
          if (b_0._get_type__0_k$() === BodyType_STATIC_getInstance()) {
            continue;
          }if (((b_0._flags & Companion_getInstance_73()._e_autoSleepFlag) === 0 ? true : b_0.__angularVelocity * b_0.__angularVelocity > angTolSqr) ? true : Companion_getInstance_71().dot_5kvz1c_k$(b_0.__linearVelocity, b_0.__linearVelocity) > linTolSqr) {
            b_0._m_sleepTime = 0.0;
            minSleepTime = 0.0;
          } else {
            var tmp17_this = b_0;
            tmp17_this._m_sleepTime = tmp17_this._m_sleepTime + h;
            minSleepTime = Companion_getInstance_68().min_rybm4g_k$(minSleepTime, b_0._m_sleepTime);
          }
        }
         while (inductionVariable_7 < last_9);
      if (minSleepTime >= Settings_getInstance()._get_timeToSleep__0_k$() ? positionSolved : false) {
        var inductionVariable_8 = 0;
        var last_10 = this._m_bodyCount;
        if (inductionVariable_8 < last_10)
          do {
            var i_6 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + 1 | 0;
            var b_1 = ensureNotNull(this._m_bodies)[i_6];
            b_1._set_isAwake__rpwsgn_k$(false);
          }
           while (inductionVariable_8 < last_10);
      }}};
  Island.prototype.solveTOI_lehp1s_k$ = function (subStep, toiIndexA, toiIndexB) {
    var tmp0_assert_0 = toiIndexA < this._m_bodyCount;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = toiIndexB < this._m_bodyCount;
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }var inductionVariable = 0;
    var last_1 = this._m_bodyCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        ensureNotNull(this._m_positions)[i]._c_2._x_7 = ensureNotNull(this._m_bodies)[i]._sweep._c_1._x_7;
        ensureNotNull(this._m_positions)[i]._c_2._y_6 = ensureNotNull(this._m_bodies)[i]._sweep._c_1._y_6;
        ensureNotNull(this._m_positions)[i]._a_2 = ensureNotNull(this._m_bodies)[i]._sweep._a_1;
        ensureNotNull(this._m_velocities)[i]._v_1._x_7 = ensureNotNull(this._m_bodies)[i].__linearVelocity._x_7;
        ensureNotNull(this._m_velocities)[i]._v_1._y_6 = ensureNotNull(this._m_bodies)[i].__linearVelocity._y_6;
        ensureNotNull(this._m_velocities)[i]._w_2 = ensureNotNull(this._m_bodies)[i].__angularVelocity;
      }
       while (inductionVariable < last_1);
    this._toiSolverDef._contacts = this._m_contacts;
    this._toiSolverDef._count_5 = this._m_contactCount_0;
    this._toiSolverDef._step_8 = subStep;
    this._toiSolverDef._positions_0 = this._m_positions;
    this._toiSolverDef._velocities_0 = this._m_velocities;
    this._toiContactSolver.init_a505ec_k$(this._toiSolverDef);
    var inductionVariable_0 = 0;
    var last_2 = subStep._positionIterations;
    if (inductionVariable_0 < last_2)
      $l$break: do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var contactsOkay = this._toiContactSolver.solveTOIPositionConstraints_27zxwg_k$(toiIndexA, toiIndexB);
        if (contactsOkay) {
          break $l$break;
        }}
       while (inductionVariable_0 < last_2);
    ensureNotNull(this._m_bodies)[toiIndexA]._sweep._c0._x_7 = ensureNotNull(this._m_positions)[toiIndexA]._c_2._x_7;
    ensureNotNull(this._m_bodies)[toiIndexA]._sweep._c0._y_6 = ensureNotNull(this._m_positions)[toiIndexA]._c_2._y_6;
    ensureNotNull(this._m_bodies)[toiIndexA]._sweep._a0 = ensureNotNull(this._m_positions)[toiIndexA]._a_2;
    ensureNotNull(this._m_bodies)[toiIndexB]._sweep._c0.set_1v0asv_k$(ensureNotNull(this._m_positions)[toiIndexB]._c_2);
    Unit_getInstance();
    ensureNotNull(this._m_bodies)[toiIndexB]._sweep._a0 = ensureNotNull(this._m_positions)[toiIndexB]._a_2;
    this._toiContactSolver.initializeVelocityConstraints_sv8swh_k$();
    var inductionVariable_1 = 0;
    var last_3 = subStep._velocityIterations;
    if (inductionVariable_1 < last_3)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        this._toiContactSolver.solveVelocityConstraints_sv8swh_k$();
      }
       while (inductionVariable_1 < last_3);
    var h = subStep._dt;
    var inductionVariable_2 = 0;
    var last_4 = this._m_bodyCount;
    if (inductionVariable_2 < last_4)
      do {
        var i_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var c = ensureNotNull(this._m_positions)[i_2]._c_2;
        var a = ensureNotNull(this._m_positions)[i_2]._a_2;
        var v = ensureNotNull(this._m_velocities)[i_2]._v_1;
        var w = ensureNotNull(this._m_velocities)[i_2]._w_2;
        var translationx = v._x_7 * h;
        var translationy = v._y_6 * h;
        if (translationx * translationx + translationy * translationy > Settings_getInstance()._get_maxTranslationSquared__0_k$()) {
          var ratio = Settings_getInstance()._get_maxTranslation__0_k$() / Companion_getInstance_68().sqrt_dbmacu_k$(translationx * translationx + translationy * translationy);
          v.mulLocal_dbmacu_k$(ratio);
          Unit_getInstance();
        }var rotation_0 = h * w;
        if (rotation_0 * rotation_0 > Settings_getInstance()._get_maxRotationSquared__0_k$()) {
          var ratio_0 = Settings_getInstance()._get_maxRotation__0_k$() / Companion_getInstance_68().abs_dbmacu_k$(rotation_0);
          w = w * ratio_0;
        }var tmp4_this = c;
        tmp4_this._x_7 = tmp4_this._x_7 + v._x_7 * h;
        var tmp5_this = c;
        tmp5_this._y_6 = tmp5_this._y_6 + v._y_6 * h;
        a = a + h * w;
        ensureNotNull(this._m_positions)[i_2]._c_2._x_7 = c._x_7;
        ensureNotNull(this._m_positions)[i_2]._c_2._y_6 = c._y_6;
        ensureNotNull(this._m_positions)[i_2]._a_2 = a;
        ensureNotNull(this._m_velocities)[i_2]._v_1._x_7 = v._x_7;
        ensureNotNull(this._m_velocities)[i_2]._v_1._y_6 = v._y_6;
        ensureNotNull(this._m_velocities)[i_2]._w_2 = w;
        var body = ensureNotNull(this._m_bodies)[i_2];
        body._sweep._c_1._x_7 = c._x_7;
        body._sweep._c_1._y_6 = c._y_6;
        body._sweep._a_1 = a;
        body.__linearVelocity._x_7 = v._x_7;
        body.__linearVelocity._y_6 = v._y_6;
        body.__angularVelocity = w;
        body.synchronizeTransform_sv8swh_k$();
      }
       while (inductionVariable_2 < last_4);
    this.report_xuxbf0_k$(this._toiContactSolver._m_velocityConstraints);
  };
  Island.prototype.add_h0xjxj_k$ = function (body) {
    var tmp0_assert_0 = this._m_bodyCount < this._m_bodyCapacity;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }body._islandIndex = this._m_bodyCount;
    ensureNotNull(this._m_bodies)[this._m_bodyCount] = body;
    var tmp0_this = this;
    tmp0_this._m_bodyCount = tmp0_this._m_bodyCount + 1 | 0;
    Unit_getInstance();
  };
  Island.prototype.add_qmxzzw_k$ = function (contact) {
    var tmp0_assert_0 = this._m_contactCount_0 < this._m_contactCapacity;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp = ensureNotNull(this._m_contacts);
    var tmp0_this = this;
    var tmp1 = tmp0_this._m_contactCount_0;
    tmp0_this._m_contactCount_0 = tmp1 + 1 | 0;
    tmp[tmp1] = contact;
  };
  Island.prototype.add_lmrdrw_k$ = function (joint) {
    var tmp0_assert_0 = this._m_jointCount < this._m_jointCapacity;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp = ensureNotNull(this._m_joints);
    var tmp0_this = this;
    var tmp1 = tmp0_this._m_jointCount;
    tmp0_this._m_jointCount = tmp1 + 1 | 0;
    tmp[tmp1] = joint;
  };
  Island.prototype.report_xuxbf0_k$ = function (constraints) {
    if (this._m_listener == null) {
      return Unit_getInstance();
    }var inductionVariable = 0;
    var last_1 = this._m_contactCount_0;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = ensureNotNull(this._m_contacts)[i];
        var vc = constraints[i];
        this._impulse._count_0 = vc._pointCount_1;
        var inductionVariable_0 = 0;
        var last_2 = vc._pointCount_1;
        if (inductionVariable_0 < last_2)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this._impulse._normalImpulses[j] = vc._points_4[j]._normalImpulse_0;
            this._impulse._tangentImpulses[j] = vc._points_4[j]._tangentImpulse_0;
          }
           while (inductionVariable_0 < last_2);
        ensureNotNull(this._m_listener).postSolve_rjqjrx_k$(c, this._impulse);
      }
       while (inductionVariable < last_1);
  };
  Island.$metadata$ = {
    simpleName: 'Island',
    kind: 'class',
    interfaces: []
  };
  function ProfileEntry() {
    this._longAvg = 0;
    this._shortAvg = 0;
    this._min_0 = 0;
    this._max_0 = 0;
    this._accum = 0;
    var tmp = this;
    FloatCompanionObject_getInstance();
    tmp._min_0 = 3.4028235E38;
    var tmp_0 = this;
    FloatCompanionObject_getInstance();
    tmp_0._max_0 = -3.4028235E38;
  }
  ProfileEntry.prototype.record_cpozfn_k$ = function (value) {
    this._longAvg = this._longAvg * (1 - Companion_getInstance_75()._LONG_FRACTION) + value * Companion_getInstance_75()._LONG_FRACTION;
    this._shortAvg = this._shortAvg * (1 - Companion_getInstance_75()._SHORT_FRACTION) + value * Companion_getInstance_75()._SHORT_FRACTION;
    this._min_0 = Companion_getInstance_68().min_rybm4g_k$(value, this._min_0);
    this._max_0 = Companion_getInstance_68().max_rybm4g_k$(value, this._max_0);
  };
  ProfileEntry.prototype.startAccum_sv8swh_k$ = function () {
    this._accum = 0.0;
  };
  ProfileEntry.prototype.accum_cpozfn_k$ = function (value) {
    var tmp0_this = this;
    tmp0_this._accum = tmp0_this._accum + value;
  };
  ProfileEntry.prototype.endAccum_sv8swh_k$ = function () {
    this.record_cpozfn_k$(this._accum);
  };
  ProfileEntry.prototype.toString = function () {
    return '' + this._shortAvg + ' (' + this._longAvg + ') [' + this._min_0 + ',' + this._max_0 + ']';
  };
  ProfileEntry.$metadata$ = {
    simpleName: 'ProfileEntry',
    kind: 'class',
    interfaces: []
  };
  function Companion_76() {
    Companion_instance_75 = this;
    this._LONG_AVG_NUMS = 20;
    this._LONG_FRACTION = 1.0 / this._LONG_AVG_NUMS;
    this._SHORT_AVG_NUMS = 5;
    this._SHORT_FRACTION = 1.0 / this._SHORT_AVG_NUMS;
  }
  Companion_76.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_75;
  function Companion_getInstance_75() {
    if (Companion_instance_75 == null)
      new Companion_76();
    return Companion_instance_75;
  }
  function Profile() {
    Companion_getInstance_75();
    this._step_5 = new ProfileEntry();
    this._stepInit = new ProfileEntry();
    this._collide = new ProfileEntry();
    this._solveParticleSystem = new ProfileEntry();
    this._solve = new ProfileEntry();
    this._solveInit = new ProfileEntry();
    this._solveVelocity = new ProfileEntry();
    this._solvePosition = new ProfileEntry();
    this._broadphase = new ProfileEntry();
    this._solveTOI = new ProfileEntry();
  }
  Profile.$metadata$ = {
    simpleName: 'Profile',
    kind: 'class',
    interfaces: []
  };
  function SolverData() {
    this._step_6 = null;
    this._positions = null;
    this._velocities = null;
  }
  SolverData.$metadata$ = {
    simpleName: 'SolverData',
    kind: 'class',
    interfaces: []
  };
  function TimeStep() {
    this._dt = 0;
    this._inv_dt = 0;
    this._dtRatio = 0;
    this._velocityIterations = 0;
    this._positionIterations = 0;
    this._warmStarting = false;
  }
  TimeStep.$metadata$ = {
    simpleName: 'TimeStep',
    kind: 'class',
    interfaces: []
  };
  function World_init_$Init$(gravityX, gravityY, pool, strategy, $this) {
    World.call($this, new Vec2(numberToDouble(gravityX), numberToDouble(gravityY)), pool, new DefaultBroadPhaseBuffer(strategy));
    return $this;
  }
  function World_init_$Init$_0(gravityX, gravityY, pool, strategy, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      gravityX = 0.0;
    if (!(($mask0 & 2) === 0))
      gravityY = 9.8;
    if (!(($mask0 & 4) === 0))
      pool = new DefaultWorldPool(Companion_getInstance_76()._WORLD_POOL_SIZE, Companion_getInstance_76()._WORLD_POOL_CONTAINER_SIZE);
    if (!(($mask0 & 8) === 0))
      strategy = new DynamicTree();
    World_init_$Init$(gravityX, gravityY, pool, strategy, $this);
    return $this;
  }
  function World_init_$Create$(gravityX, gravityY, pool, strategy, $mask0, $marker) {
    return World_init_$Init$_0(gravityX, gravityY, pool, strategy, $mask0, $marker, Object.create(World.prototype));
  }
  function addType($this, creator, type1, type2) {
    var register_0 = new ContactRegister();
    register_0._creator = creator;
    register_0._primary = true;
    $this._contactStacks[type1._get_ordinal__0_k$()][type2._get_ordinal__0_k$()] = register_0;
    if (!(type1 === type2)) {
      var register2 = new ContactRegister();
      register2._creator = creator;
      register2._primary = false;
      $this._contactStacks[type2._get_ordinal__0_k$()][type1._get_ordinal__0_k$()] = register2;
    }}
  function initializeRegisters($this) {
    addType($this, $this._pool_4._get_circleContactStack__0_k$(), ShapeType_CIRCLE_getInstance(), ShapeType_CIRCLE_getInstance());
    addType($this, $this._pool_4._get_polyCircleContactStack__0_k$(), ShapeType_POLYGON_getInstance(), ShapeType_CIRCLE_getInstance());
    addType($this, $this._pool_4._get_polyContactStack__0_k$(), ShapeType_POLYGON_getInstance(), ShapeType_POLYGON_getInstance());
    addType($this, $this._pool_4._get_edgeCircleContactStack__0_k$(), ShapeType_EDGE_getInstance(), ShapeType_CIRCLE_getInstance());
    addType($this, $this._pool_4._get_edgePolyContactStack__0_k$(), ShapeType_EDGE_getInstance(), ShapeType_POLYGON_getInstance());
    addType($this, $this._pool_4._get_chainCircleContactStack__0_k$(), ShapeType_CHAIN_getInstance(), ShapeType_CIRCLE_getInstance());
    addType($this, $this._pool_4._get_chainPolyContactStack__0_k$(), ShapeType_CHAIN_getInstance(), ShapeType_POLYGON_getInstance());
  }
  function solve($this, step_0) {
    $this._profile._solveInit.startAccum_sv8swh_k$();
    $this._profile._solveVelocity.startAccum_sv8swh_k$();
    $this._profile._solvePosition.startAccum_sv8swh_k$();
    var b_2 = $this._bodyList;
    while (!(b_2 == null)) {
      ensureNotNull(b_2)._xf0.set_3pfibf_k$(ensureNotNull(b_2)._xf_0);
      Unit_getInstance();
      b_2 = ensureNotNull(b_2)._m_next;
    }
    $this._island.init_81qlpv_k$($this._bodyCount, $this._m_contactManager._m_contactCount, $this._jointCount, $this._m_contactManager._m_contactListener);
    var b_2_0 = $this._bodyList;
    while (!(b_2_0 == null)) {
      ensureNotNull(b_2_0)._flags = ensureNotNull(b_2_0)._flags & ~Companion_getInstance_73()._e_islandFlag;
      b_2_0 = ensureNotNull(b_2_0)._m_next;
    }
    var c = $this._m_contactManager._m_contactList_0;
    while (!(c == null)) {
      c._m_flags_0 = c._m_flags_0 & ~Companion_getInstance_77()._ISLAND_FLAG;
      c = c._m_next_1;
    }
    var j = $this._jointList;
    while (!(j == null)) {
      j.islandFlag__error = false;
      j = j.next__error;
    }
    var stackSize = $this._bodyCount;
    if ($this._stack.length < stackSize) {
      var tmp = $this;
      tmp._stack = fillArrayVal(Array(stackSize), null);
    }var seed = $this._bodyList;
    while (!(seed == null)) {
      if ((seed._flags & Companion_getInstance_73()._e_islandFlag) === Companion_getInstance_73()._e_islandFlag) {
        seed = seed._m_next;
        continue;
      }if (seed._get_isAwake__0_k$() === false ? true : seed._get_isActive__0_k$() === false) {
        seed = seed._m_next;
        continue;
      }if (seed._get_type__0_k$() === BodyType_STATIC_getInstance()) {
        seed = seed._m_next;
        continue;
      }$this._island.clear_sv8swh_k$();
      var stackCount = 0;
      var tmp_0 = $this._stack;
      var tmp0 = stackCount;
      stackCount = tmp0 + 1 | 0;
      tmp_0[tmp0] = seed;
      seed._flags = seed._flags | Companion_getInstance_73()._e_islandFlag;
      while (stackCount > 0) {
        var tmp_1 = $this._stack;
        stackCount = stackCount - 1 | 0;
        var b = ensureNotNull(tmp_1[stackCount]);
        var tmp0_assert_0 = b._get_isActive__0_k$() === true;
        if (!tmp0_assert_0) {
          var message_2_1 = 'Check failed.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
        }$this._island.add_h0xjxj_k$(b);
        b._set_isAwake__rpwsgn_k$(true);
        if (b._get_type__0_k$() === BodyType_STATIC_getInstance()) {
          continue;
        }var ce = b._m_contactList;
        while (!(ce == null)) {
          var contact = ce._contact;
          if ((ensureNotNull(contact)._m_flags_0 & Companion_getInstance_77()._ISLAND_FLAG) === Companion_getInstance_77()._ISLAND_FLAG) {
            ce = ce._next_5;
            continue;
          }if (contact._get_isEnabled__0_k$() === false ? true : contact._get_isTouching__0_k$() === false) {
            ce = ce._next_5;
            continue;
          }var sensorA = ensureNotNull(contact._m_fixtureA)._m_isSensor;
          var sensorB = ensureNotNull(contact._m_fixtureB)._m_isSensor;
          if (sensorA ? true : sensorB) {
            ce = ce._next_5;
            continue;
          }$this._island.add_qmxzzw_k$(contact);
          contact._m_flags_0 = contact._m_flags_0 | Companion_getInstance_77()._ISLAND_FLAG;
          var other = ce._other;
          if ((ensureNotNull(other)._flags & Companion_getInstance_73()._e_islandFlag) === Companion_getInstance_73()._e_islandFlag) {
            ce = ce._next_5;
            continue;
          }var tmp1_assert_0 = stackCount < stackSize;
          if (!tmp1_assert_0) {
            var message_2_1_0 = 'Check failed.';
            throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
          }var tmp_2 = $this._stack;
          var tmp1 = stackCount;
          stackCount = tmp1 + 1 | 0;
          tmp_2[tmp1] = other;
          other._flags = other._flags | Companion_getInstance_73()._e_islandFlag;
          ce = ce._next_5;
        }
        var je = b._m_jointList;
        while (!(je == null)) {
          if (ensureNotNull(je.joint__error).islandFlag__error === true) {
            je = je.next__error;
            continue;
          }var other_0 = je.other__error;
          if (ensureNotNull(other_0)._get_isActive__0_k$() === false) {
            je = je.next__error;
            continue;
          }$this._island.add_lmrdrw_k$(ensureNotNull(je.joint__error));
          ensureNotNull(je.joint__error).islandFlag__error = true;
          if ((other_0._flags & Companion_getInstance_73()._e_islandFlag) === Companion_getInstance_73()._e_islandFlag) {
            je = je.next__error;
            continue;
          }var tmp2_assert_0 = stackCount < stackSize;
          if (!tmp2_assert_0) {
            var message_2_1_1 = 'Check failed.';
            throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
          }var tmp_3 = $this._stack;
          var tmp2 = stackCount;
          stackCount = tmp2 + 1 | 0;
          tmp_3[tmp2] = other_0;
          other_0._flags = other_0._flags | Companion_getInstance_73()._e_islandFlag;
          je = je.next__error;
        }
      }
      $this._island.solve_jh2qai_k$($this._profile, step_0, $this._gravity, $this._isSleepingAllowed);
      var inductionVariable = 0;
      var last_1 = $this._island._m_bodyCount;
      if (inductionVariable < last_1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var b_0 = ensureNotNull($this._island._m_bodies)[i];
          if (b_0._get_type__0_k$() === BodyType_STATIC_getInstance()) {
            b_0._flags = b_0._flags & ~Companion_getInstance_73()._e_islandFlag;
          }}
         while (inductionVariable < last_1);
      seed = seed._m_next;
    }
    $this._profile._solveInit.endAccum_sv8swh_k$();
    $this._profile._solveVelocity.endAccum_sv8swh_k$();
    $this._profile._solvePosition.endAccum_sv8swh_k$();
    $this._broadphaseTimer.reset_sv8swh_k$();
    var b_1 = $this._bodyList;
    while (!(b_1 == null)) {
      if ((ensureNotNull(b_1)._flags & Companion_getInstance_73()._e_islandFlag) === 0) {
        b_1 = ensureNotNull(b_1).getNext_0_k$();
        continue;
      }if (ensureNotNull(b_1)._get_type__0_k$() === BodyType_STATIC_getInstance()) {
        b_1 = ensureNotNull(b_1).getNext_0_k$();
        continue;
      }ensureNotNull(b_1).synchronizeFixtures_sv8swh_k$();
      b_1 = ensureNotNull(b_1).getNext_0_k$();
    }
    $this._m_contactManager.findNewContacts_sv8swh_k$();
    $this._profile._broadphase.record_cpozfn_k$($this._broadphaseTimer._get_milliseconds__0_k$());
  }
  function solveTOI($this, step_0) {
    var island = $this._toiIsland;
    island.init_81qlpv_k$(imul(2, Settings_getInstance()._get_maxTOIContacts__0_k$()), Settings_getInstance()._get_maxTOIContacts__0_k$(), 0, $this._m_contactManager._m_contactListener);
    if ($this._m_stepComplete) {
      var b = $this._bodyList;
      while (!(b == null)) {
        b._flags = b._flags & ~Companion_getInstance_73()._e_islandFlag;
        b._sweep._alpha0 = 0.0;
        b = b._m_next;
      }
      var c = $this._m_contactManager._m_contactList_0;
      while (!(c == null)) {
        c._m_flags_0 = c._m_flags_0 & ~(Companion_getInstance_77()._TOI_FLAG | Companion_getInstance_77()._ISLAND_FLAG);
        c._m_toiCount = 0.0;
        c._m_toi = 1.0;
        c = c._m_next_1;
      }
    }$l$break_2: while (true) {
      var minContact = null;
      var minAlpha = 1.0;
      var c_0 = $this._m_contactManager._m_contactList_0;
      while (!(c_0 == null)) {
        if (c_0._get_isEnabled__0_k$() === false) {
          c_0 = c_0._m_next_1;
          continue;
        }if (c_0._m_toiCount > Settings_getInstance()._get_maxSubSteps__0_k$()) {
          c_0 = c_0._m_next_1;
          continue;
        }var alpha_0 = 1.0;
        if (!((c_0._m_flags_0 & Companion_getInstance_77()._TOI_FLAG) === 0)) {
          alpha_0 = c_0._m_toi;
        } else {
          var fA = c_0.getFixtureA_0_k$();
          var fB = c_0.getFixtureB_0_k$();
          if (ensureNotNull(fA)._get_isSensor__0_k$() ? true : ensureNotNull(fB)._get_isSensor__0_k$()) {
            c_0 = c_0._m_next_1;
            continue;
          }var bA = fA.getBody_0_k$();
          var bB = fB.getBody_0_k$();
          var typeA = ensureNotNull(bA).__type;
          var typeB = ensureNotNull(bB).__type;
          var tmp0_assert_0 = typeA === BodyType_DYNAMIC_getInstance() ? true : typeB === BodyType_DYNAMIC_getInstance();
          if (!tmp0_assert_0) {
            var message_2_1 = 'Check failed.';
            throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
          }var activeA = bA._get_isAwake__0_k$() ? !(typeA === BodyType_STATIC_getInstance()) : false;
          var activeB = bB._get_isAwake__0_k$() ? !(typeB === BodyType_STATIC_getInstance()) : false;
          if (activeA === false ? activeB === false : false) {
            c_0 = c_0._m_next_1;
            continue;
          }var collideA = bA._get_isBullet__0_k$() ? true : !(typeA === BodyType_DYNAMIC_getInstance());
          var collideB = bB._get_isBullet__0_k$() ? true : !(typeB === BodyType_DYNAMIC_getInstance());
          if (collideA === false ? collideB === false : false) {
            c_0 = c_0._m_next_1;
            continue;
          }var alpha0 = bA._sweep._alpha0;
          if (bA._sweep._alpha0 < bB._sweep._alpha0) {
            alpha0 = bB._sweep._alpha0;
            bA._sweep.advance_cpozfn_k$(alpha0);
          } else if (bB._sweep._alpha0 < bA._sweep._alpha0) {
            alpha0 = bA._sweep._alpha0;
            bB._sweep.advance_cpozfn_k$(alpha0);
          }var tmp1_assert_0 = alpha0 < 1.0;
          if (!tmp1_assert_0) {
            var message_2_1_0 = 'Check failed.';
            throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
          }var indexA = c_0.getChildIndexA_0_k$();
          var indexB = c_0.getChildIndexB_0_k$();
          var input = $this._toiInput;
          input._proxyA_0.set_qlrvod_k$(ensureNotNull(fA.getShape_0_k$()), indexA);
          input._proxyB_0.set_qlrvod_k$(ensureNotNull(fB.getShape_0_k$()), indexB);
          input._sweepA.set_dd6kcl_k$(bA._sweep);
          Unit_getInstance();
          input._sweepB.set_dd6kcl_k$(bB._sweep);
          Unit_getInstance();
          input._tMax = 1.0;
          $this._pool_4._get_timeOfImpact__0_k$().timeOfImpact_808z7q_k$($this._toiOutput, input);
          var beta = $this._toiOutput._t;
          if ($this._toiOutput._state_2 === TOIOutputState_TOUCHING_getInstance()) {
            alpha_0 = Companion_getInstance_68().min_rybm4g_k$(alpha0 + (1.0 - alpha0) * beta, 1.0);
          } else {
            alpha_0 = 1.0;
          }
          c_0._m_toi = alpha_0;
          c_0._m_flags_0 = c_0._m_flags_0 | Companion_getInstance_77()._TOI_FLAG;
        }
        if (alpha_0 < minAlpha) {
          minContact = c_0;
          minAlpha = alpha_0;
        }c_0 = c_0._m_next_1;
      }
      if (minContact == null ? true : 1.0 - 10.0 * Settings_getInstance()._EPSILON < minAlpha) {
        $this._m_stepComplete = true;
        break $l$break_2;
      }var fA_0 = minContact.getFixtureA_0_k$();
      var fB_0 = minContact.getFixtureB_0_k$();
      var bA_0 = ensureNotNull(fA_0).getBody_0_k$();
      var bB_0 = ensureNotNull(fB_0).getBody_0_k$();
      $this._backup1.set_dd6kcl_k$(ensureNotNull(bA_0)._sweep);
      Unit_getInstance();
      $this._backup2.set_dd6kcl_k$(ensureNotNull(bB_0)._sweep);
      Unit_getInstance();
      bA_0.advance_cpozfn_k$(minAlpha);
      bB_0.advance_cpozfn_k$(minAlpha);
      minContact.update_cbzc8c_k$($this._m_contactManager._m_contactListener);
      minContact._m_flags_0 = minContact._m_flags_0 & ~Companion_getInstance_77()._TOI_FLAG;
      var tmp0_this = minContact;
      tmp0_this._m_toiCount = tmp0_this._m_toiCount + 1;
      Unit_getInstance();
      if (minContact._get_isEnabled__0_k$() === false ? true : minContact._get_isTouching__0_k$() === false) {
        minContact._set_isEnabled__rpwsgn_k$(false);
        bA_0._sweep.set_dd6kcl_k$($this._backup1);
        Unit_getInstance();
        bB_0._sweep.set_dd6kcl_k$($this._backup2);
        Unit_getInstance();
        bA_0.synchronizeTransform_sv8swh_k$();
        bB_0.synchronizeTransform_sv8swh_k$();
        continue $l$break_2;
      }bA_0._set_isAwake__rpwsgn_k$(true);
      bB_0._set_isAwake__rpwsgn_k$(true);
      island.clear_sv8swh_k$();
      island.add_h0xjxj_k$(bA_0);
      island.add_h0xjxj_k$(bB_0);
      island.add_qmxzzw_k$(minContact);
      bA_0._flags = bA_0._flags | Companion_getInstance_73()._e_islandFlag;
      bB_0._flags = bB_0._flags | Companion_getInstance_73()._e_islandFlag;
      minContact._m_flags_0 = minContact._m_flags_0 | Companion_getInstance_77()._ISLAND_FLAG;
      $this._tempBodies[0] = bA_0;
      $this._tempBodies[1] = bB_0;
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var body = ensureNotNull($this._tempBodies[i]);
          if (body.__type === BodyType_DYNAMIC_getInstance()) {
            var ce = body._m_contactList;
            $l$break_1: while (!(ce == null)) {
              if (island._m_bodyCount === island._m_bodyCapacity) {
                break $l$break_1;
              }if (island._m_contactCount_0 === island._m_contactCapacity) {
                break $l$break_1;
              }var contact = ce._contact;
              if (!((ensureNotNull(contact)._m_flags_0 & Companion_getInstance_77()._ISLAND_FLAG) === 0)) {
                ce = ce._next_5;
                continue $l$break_1;
              }var other = ce._other;
              if ((ensureNotNull(other).__type === BodyType_DYNAMIC_getInstance() ? body._get_isBullet__0_k$() === false : false) ? ensureNotNull(other)._get_isBullet__0_k$() === false : false) {
                ce = ce._next_5;
                continue $l$break_1;
              }var sensorA = ensureNotNull(contact._m_fixtureA)._m_isSensor;
              var sensorB = ensureNotNull(contact._m_fixtureB)._m_isSensor;
              if (sensorA ? true : sensorB) {
                ce = ce._next_5;
                continue $l$break_1;
              }$this._backup1.set_dd6kcl_k$(ensureNotNull(other)._sweep);
              Unit_getInstance();
              if ((other._flags & Companion_getInstance_73()._e_islandFlag) === 0) {
                other.advance_cpozfn_k$(minAlpha);
              }contact.update_cbzc8c_k$($this._m_contactManager._m_contactListener);
              if (contact._get_isEnabled__0_k$() === false) {
                other._sweep.set_dd6kcl_k$($this._backup1);
                Unit_getInstance();
                other.synchronizeTransform_sv8swh_k$();
                ce = ce._next_5;
                continue $l$break_1;
              }if (contact._get_isTouching__0_k$() === false) {
                other._sweep.set_dd6kcl_k$($this._backup1);
                Unit_getInstance();
                other.synchronizeTransform_sv8swh_k$();
                ce = ce._next_5;
                continue $l$break_1;
              }contact._m_flags_0 = contact._m_flags_0 | Companion_getInstance_77()._ISLAND_FLAG;
              island.add_qmxzzw_k$(contact);
              if (!((other._flags & Companion_getInstance_73()._e_islandFlag) === 0)) {
                ce = ce._next_5;
                continue $l$break_1;
              }other._flags = other._flags | Companion_getInstance_73()._e_islandFlag;
              if (!(other.__type === BodyType_STATIC_getInstance())) {
                other._set_isAwake__rpwsgn_k$(true);
              }island.add_h0xjxj_k$(other);
              ce = ce._next_5;
            }
          }}
         while (inductionVariable <= 1);
      $this._subStep._dt = (1.0 - minAlpha) * step_0._dt;
      $this._subStep._inv_dt = 1.0 / $this._subStep._dt;
      $this._subStep._dtRatio = 1.0;
      $this._subStep._positionIterations = 20;
      $this._subStep._velocityIterations = step_0._velocityIterations;
      $this._subStep._warmStarting = false;
      island.solveTOI_lehp1s_k$($this._subStep, bA_0._islandIndex, bB_0._islandIndex);
      var inductionVariable_0 = 0;
      var last_1 = island._m_bodyCount;
      if (inductionVariable_0 < last_1)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var body_0 = ensureNotNull(island._m_bodies)[i_0];
          body_0._flags = body_0._flags & ~Companion_getInstance_73()._e_islandFlag;
          if (!(body_0.__type === BodyType_DYNAMIC_getInstance())) {
            continue;
          }body_0.synchronizeFixtures_sv8swh_k$();
          var ce_0 = body_0._m_contactList;
          while (!(ce_0 == null)) {
            ensureNotNull(ce_0._contact)._m_flags_0 = ensureNotNull(ce_0._contact)._m_flags_0 & ~(Companion_getInstance_77()._TOI_FLAG | Companion_getInstance_77()._ISLAND_FLAG);
            ce_0 = ce_0._next_5;
          }
        }
         while (inductionVariable_0 < last_1);
      $this._m_contactManager.findNewContacts_sv8swh_k$();
      if ($this._isSubStepping) {
        $this._m_stepComplete = false;
        break $l$break_2;
      }}
  }
  function Companion_77() {
    Companion_instance_76 = this;
    this._WORLD_POOL_SIZE = 100;
    this._WORLD_POOL_CONTAINER_SIZE = 10;
    this._NEW_FIXTURE = 1;
    this._LOCKED = 2;
    this._CLEAR_FORCES = 4;
    this._LIQUID_INT = 1234598372;
  }
  Companion_77.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_76;
  function Companion_getInstance_76() {
    if (Companion_instance_76 == null)
      new Companion_77();
    return Companion_instance_76;
  }
  function World(gravity, pool, broadPhase) {
    Companion_getInstance_76();
    this._pool_4 = pool;
    this._$$delegate_0_5 = new Mixin_0();
    this._customScale = 1.0;
    this._activeContacts = 0;
    this._contactPoolCount = 0;
    this._userData_4 = null;
    this._m_flags = Companion_getInstance_76()._CLEAR_FORCES;
    this._m_contactManager = new ContactManager(this, broadPhase);
    this._bodyList = null;
    this._jointList = null;
    this._bodyCount = 0;
    this._jointCount = 0;
    var tmp = this;
    tmp._gravity = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._isSleepingAllowed = true;
    this._destructionListener = null;
    this._particleDestructionListener = null;
    this._m_debugDraw = null;
    this._m_inv_dt0 = 0.0;
    this._isWarmStarting = true;
    this._isContinuousPhysics = true;
    this._isSubStepping = false;
    this._m_stepComplete = true;
    this._profile = new Profile();
    this._m_particleSystem = new ParticleSystem(this);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = values_0().length;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      var tmp0_arrayOfNulls_0 = values_0().length;
      var tmp_5 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
      tmp_3[tmp_4] = isArray(tmp_5) ? tmp_5 : THROW_CCE();
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._contactStacks = tmp_3;
    this._step_7 = new TimeStep();
    this._stepTimer = new Timer();
    this._tempTimer = new Timer();
    this._color_0 = Color3f_init_$Create$();
    this._xf_1 = Transform_init_$Create$_0();
    var tmp_6 = this;
    tmp_6._cA = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_7 = this;
    tmp_7._cB = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._avs = new Vec2ArrayPool();
    this._wqwrapper = new WorldQueryWrapper();
    this._wrcwrapper = new WorldRayCastWrapper();
    this._input_1 = new RayCastInput();
    this._island = new Island();
    var tmp_8 = this;
    tmp_8._stack = fillArrayVal(Array(10), null);
    this._broadphaseTimer = new Timer();
    this._toiIsland = new Island();
    this._toiInput = new TOIInput();
    this._toiOutput = new TOIOutput();
    this._subStep = new TimeStep();
    var tmp_9 = this;
    tmp_9._tempBodies = fillArrayVal(Array(2), null);
    this._backup1 = new Sweep();
    this._backup2 = new Sweep();
    this._liquidLength = 0.12;
    this._averageLinearVel = -1.0;
    var tmp_10 = this;
    tmp_10._liquidOffset = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_11 = this;
    tmp_11._circCenterMoved = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._liquidColor = Color3f_init_$Create$_0(0.4, 0.4, 1.0);
    var tmp_12 = this;
    tmp_12._center_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_13 = this;
    tmp_13._axis = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_14 = this;
    tmp_14._v1_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_15 = this;
    tmp_15._v2_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._tlvertices = new Vec2ArrayPool();
    this._gravity.set_1v0asv_k$(gravity);
    Unit_getInstance();
    initializeRegisters(this);
  }
  World.prototype.set_fm38x_k$ = function (key, value) {
    this._$$delegate_0_5.set_fm38x_k$(key, value);
  };
  World.prototype._get_world__0_k$ = function () {
    return this;
  };
  World.prototype._get_isLocked__0_k$ = function () {
    return (this._m_flags & Companion_getInstance_76()._LOCKED) === Companion_getInstance_76()._LOCKED;
  };
  World.prototype.popContact_jgapkw_k$ = function (fixtureA, indexA, fixtureB, indexB) {
    var type1 = fixtureA._get_type__0_k$();
    var type2 = fixtureB._get_type__0_k$();
    var reg = this._contactStacks[type1._get_ordinal__0_k$()][type2._get_ordinal__0_k$()];
    if (!(reg == null)) {
      if (reg._primary) {
        var c = ensureNotNull(reg._creator).pop_0_k$();
        c.init_593scx_k$(fixtureA, indexA, fixtureB, indexB);
        return c;
      } else {
        var c_0 = ensureNotNull(reg._creator).pop_0_k$();
        c_0.init_593scx_k$(fixtureB, indexB, fixtureA, indexA);
        return c_0;
      }
    } else {
      return null;
    }
  };
  World.prototype.pushContact_qmxzzw_k$ = function (contact) {
    var fixtureA = contact.getFixtureA_0_k$();
    var fixtureB = contact.getFixtureB_0_k$();
    if ((contact._m_manifold._pointCount > 0 ? !ensureNotNull(fixtureA)._get_isSensor__0_k$() : false) ? !ensureNotNull(fixtureB)._get_isSensor__0_k$() : false) {
      ensureNotNull(fixtureA.getBody_0_k$())._set_isAwake__rpwsgn_k$(true);
      ensureNotNull(fixtureB.getBody_0_k$())._set_isAwake__rpwsgn_k$(true);
    }var type1 = ensureNotNull(fixtureA)._get_type__0_k$();
    var type2 = ensureNotNull(fixtureB)._get_type__0_k$();
    var creator = this._contactStacks[type1._get_ordinal__0_k$()][type2._get_ordinal__0_k$()]._creator;
    ensureNotNull(creator).push_jxzaet_k$(contact);
  };
  World.prototype.createBody_kicyo5_k$ = function (def) {
    var tmp0_assert_0 = this._get_isLocked__0_k$() === false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }if (this._get_isLocked__0_k$()) {
      throw IllegalStateException_init_$Create$_0('World is locked');
    }var b = new Body_0(def, this);
    b._prev_0 = null;
    b._m_next = this._bodyList;
    if (!(this._bodyList == null)) {
      ensureNotNull(this._bodyList)._prev_0 = b;
    }this._bodyList = b;
    var tmp0_this = this;
    tmp0_this._bodyCount = tmp0_this._bodyCount + 1 | 0;
    Unit_getInstance();
    return b;
  };
  World.prototype.destroyBody_h0xjxj_k$ = function (body) {
    var tmp0_assert_0 = this._bodyCount > 0;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = this._get_isLocked__0_k$() === false;
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }if (this._get_isLocked__0_k$()) {
      return Unit_getInstance();
    }var je = body._m_jointList;
    while (!(je == null)) {
      var je0 = je;
      je = je.next__error;
      if (!(this._destructionListener == null)) {
        ensureNotNull(this._destructionListener).sayGoodbye_lmrdrw_k$(ensureNotNull(je0.joint__error));
      }this.destroyJoint_ye0h4x_k$(je0.joint__error);
      body._m_jointList = je;
    }
    body._m_jointList = null;
    var ce = body._m_contactList;
    while (!(ce == null)) {
      var ce0 = ce;
      ce = ce._next_5;
      this._m_contactManager.destroy_qmxzzw_k$(ensureNotNull(ce0._contact));
    }
    body._m_contactList = null;
    var f = body._m_fixtureList;
    while (!(f == null)) {
      var f0 = f;
      f = f._m_next_0;
      if (!(this._destructionListener == null)) {
        ensureNotNull(this._destructionListener).sayGoodbye_4dqz3k_k$(f0);
      }f0.destroyProxies_7gve4v_k$(this._m_contactManager._m_broadPhase);
      f0.destroy_sv8swh_k$();
      body._m_fixtureList = f;
      var tmp0_this = body;
      tmp0_this._m_fixtureCount = tmp0_this._m_fixtureCount - 1 | 0;
    }
    body._m_fixtureList = null;
    body._m_fixtureCount = 0;
    if (!(body._prev_0 == null)) {
      ensureNotNull(body._prev_0)._m_next = body._m_next;
    }if (!(body._m_next == null)) {
      ensureNotNull(body._m_next)._prev_0 = body._prev_0;
    }if (equals_1(body, this._bodyList)) {
      this._bodyList = body._m_next;
    }var tmp1_this = this;
    tmp1_this._bodyCount = tmp1_this._bodyCount - 1 | 0;
    Unit_getInstance();
  };
  World.prototype.destroyJoint_ye0h4x_k$ = function (j) {
    var tmp0_assert_0 = this._get_isLocked__0_k$() === false;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }if (this._get_isLocked__0_k$()) {
      return Unit_getInstance();
    }var collideConnected = ensureNotNull(j).getCollideConnected_0_k$();
    if (!(j.prev__error == null)) {
      ensureNotNull(j.prev__error).next__error = j.next__error;
    }if (!(j.next__error == null)) {
      ensureNotNull(j.next__error).prev__error = j.prev__error;
    }if (j === this._jointList) {
      this._jointList = j.next__error;
    }var bodyA = j.bodyA__error;
    var bodyB = j.bodyB__error;
    ensureNotNull(bodyA)._set_isAwake__rpwsgn_k$(true);
    ensureNotNull(bodyB)._set_isAwake__rpwsgn_k$(true);
    if (!(j.edgeA__error.prev__error == null)) {
      ensureNotNull(j.edgeA__error.prev__error).next__error = j.edgeA__error.next__error;
    }if (!(j.edgeA__error.next__error == null)) {
      ensureNotNull(j.edgeA__error.next__error).prev__error = j.edgeA__error.prev__error;
    }if (equals_1(j.edgeA__error, bodyA._m_jointList)) {
      bodyA._m_jointList = j.edgeA__error.next__error;
    }j.edgeA__error.prev__error = null;
    j.edgeA__error.next__error = null;
    if (!(j.edgeB__error.prev__error == null)) {
      ensureNotNull(j.edgeB__error.prev__error).next__error = j.edgeB__error.next__error;
    }if (!(j.edgeB__error.next__error == null)) {
      ensureNotNull(j.edgeB__error.next__error).prev__error = j.edgeB__error.prev__error;
    }if (equals_1(j.edgeB__error, bodyB._m_jointList)) {
      bodyB._m_jointList = j.edgeB__error.next__error;
    }j.edgeB__error.prev__error = null;
    j.edgeB__error.next__error = null;
    Companion_getInstance_79().destroy_lmrdrw_k$(j);
    var tmp1_assert_0 = this._jointCount > 0;
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }var tmp0_this = this;
    tmp0_this._jointCount = tmp0_this._jointCount - 1 | 0;
    Unit_getInstance();
    if (collideConnected === false) {
      var edge = bodyB.getContactList_0_k$();
      while (!(edge == null)) {
        if (equals_1(edge._other, bodyA)) {
          ensureNotNull(edge._contact).flagForFiltering_sv8swh_k$();
        }edge = edge._next_5;
      }
    }};
  World.prototype.step_tte0sd_k$ = function (dt, velocityIterations, positionIterations) {
    this._stepTimer.reset_sv8swh_k$();
    this._tempTimer.reset_sv8swh_k$();
    if ((this._m_flags & Companion_getInstance_76()._NEW_FIXTURE) === Companion_getInstance_76()._NEW_FIXTURE) {
      this._m_contactManager.findNewContacts_sv8swh_k$();
      this._m_flags = this._m_flags & ~Companion_getInstance_76()._NEW_FIXTURE;
    }this._m_flags = this._m_flags | Companion_getInstance_76()._LOCKED;
    this._step_7._dt = dt;
    this._step_7._velocityIterations = velocityIterations;
    this._step_7._positionIterations = positionIterations;
    if (dt > 0.0) {
      this._step_7._inv_dt = 1.0 / dt;
    } else {
      this._step_7._inv_dt = 0.0;
    }
    this._step_7._dtRatio = this._m_inv_dt0 * dt;
    this._step_7._warmStarting = this._isWarmStarting;
    this._profile._stepInit.record_cpozfn_k$(this._tempTimer._get_milliseconds__0_k$());
    this._tempTimer.reset_sv8swh_k$();
    this._m_contactManager.collide_sv8swh_k$();
    this._profile._collide.record_cpozfn_k$(this._tempTimer._get_milliseconds__0_k$());
    if (this._m_stepComplete ? this._step_7._dt > 0.0 : false) {
      this._tempTimer.reset_sv8swh_k$();
      this._m_particleSystem.solve_zeyqa8_k$(this._step_7);
      this._profile._solveParticleSystem.record_cpozfn_k$(this._tempTimer._get_milliseconds__0_k$());
      this._tempTimer.reset_sv8swh_k$();
      solve(this, this._step_7);
      this._profile._solve.record_cpozfn_k$(this._tempTimer._get_milliseconds__0_k$());
    }if (this._isContinuousPhysics ? this._step_7._dt > 0.0 : false) {
      this._tempTimer.reset_sv8swh_k$();
      solveTOI(this, this._step_7);
      this._profile._solveTOI.record_cpozfn_k$(this._tempTimer._get_milliseconds__0_k$());
    }if (this._step_7._dt > 0.0) {
      this._m_inv_dt0 = this._step_7._inv_dt;
    }if ((this._m_flags & Companion_getInstance_76()._CLEAR_FORCES) === Companion_getInstance_76()._CLEAR_FORCES) {
      this.clearForces_sv8swh_k$();
    }this._m_flags = this._m_flags & ~Companion_getInstance_76()._LOCKED;
    this._profile._step_5.record_cpozfn_k$(this._stepTimer._get_milliseconds__0_k$());
  };
  World.prototype.clearForces_sv8swh_k$ = function () {
    var body = this._bodyList;
    while (!(body == null)) {
      body._force.setZero_sv8swh_k$();
      body._torque = 0.0;
      body = body.getNext_0_k$();
    }
  };
  World.prototype.queryAABB_9v5ah4_k$ = function (callback, aabb) {
    this._wqwrapper._broadPhase = this._m_contactManager._m_broadPhase;
    this._wqwrapper._callback = callback;
    this._m_contactManager._m_broadPhase.query_qronny_k$(this._wqwrapper, aabb);
  };
  World.$metadata$ = {
    simpleName: 'World',
    kind: 'class',
    interfaces: [WorldRef, Box2dTypedUserData]
  };
  function WorldQueryWrapper() {
    this._broadPhase = null;
    this._callback = null;
  }
  WorldQueryWrapper.prototype.treeCallback_ha5a7z_k$ = function (nodeId) {
    var tmp = ensureNotNull(this._broadPhase).getUserData_ha5a7z_k$(nodeId);
    var proxy = (tmp == null ? true : tmp instanceof FixtureProxy) ? tmp : THROW_CCE();
    return ensureNotNull(this._callback).reportFixture_zd7wjj_k$(ensureNotNull(ensureNotNull(proxy)._fixture));
  };
  WorldQueryWrapper.$metadata$ = {
    simpleName: 'WorldQueryWrapper',
    kind: 'class',
    interfaces: [TreeCallback]
  };
  function WorldRayCastWrapper() {
    this._output_0 = new RayCastOutput();
    var tmp = this;
    tmp._temp_4 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._point = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._broadPhase_0 = null;
    this._callback_0 = null;
  }
  WorldRayCastWrapper.$metadata$ = {
    simpleName: 'WorldRayCastWrapper',
    kind: 'class',
    interfaces: [TreeRayCastCallback]
  };
  function WorldRef() {
  }
  WorldRef.$metadata$ = {
    simpleName: 'WorldRef',
    kind: 'interface',
    interfaces: []
  };
  function ChainAndCircleContact(argPool) {
    Contact.call(this, argPool);
    this._edge = new EdgeShape();
  }
  ChainAndCircleContact.prototype.init_593scx_k$ = function (fA, indexA, fB, indexB) {
    Contact.prototype.init_593scx_k$.call(this, fA, indexA, fB, indexB);
    var tmp0_assert_0 = ensureNotNull(this._get_m_fixtureA__0_k$())._get_type__0_k$() === ShapeType_CHAIN_getInstance();
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = ensureNotNull(this._get_m_fixtureB__0_k$())._get_type__0_k$() === ShapeType_CIRCLE_getInstance();
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }};
  ChainAndCircleContact.prototype.evaluate_1b6ibn_k$ = function (manifold, xfA, xfB) {
    var tmp = ensureNotNull(this._get_m_fixtureA__0_k$())._m_shape;
    var chain = tmp instanceof ChainShape ? tmp : THROW_CCE();
    chain.getChildEdge_kjy5fq_k$(this._edge, this._get_m_indexA__0_k$());
    var tmp_0 = this._get_pool__0_k$()._get_collision__0_k$();
    var tmp_1 = ensureNotNull(this._get_m_fixtureB__0_k$())._m_shape;
    tmp_0.collideEdgeAndCircle_4g9njw_k$(manifold, this._edge, xfA, tmp_1 instanceof CircleShape ? tmp_1 : THROW_CCE(), xfB);
  };
  ChainAndCircleContact.$metadata$ = {
    simpleName: 'ChainAndCircleContact',
    kind: 'class',
    interfaces: []
  };
  function ChainAndPolygonContact(argPool) {
    Contact.call(this, argPool);
    this._edge_0 = new EdgeShape();
  }
  ChainAndPolygonContact.prototype.init_593scx_k$ = function (fA, indexA, fB, indexB) {
    Contact.prototype.init_593scx_k$.call(this, fA, indexA, fB, indexB);
    var tmp0_assert_0 = ensureNotNull(this._get_m_fixtureA__0_k$())._get_type__0_k$() === ShapeType_CHAIN_getInstance();
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = ensureNotNull(this._get_m_fixtureB__0_k$())._get_type__0_k$() === ShapeType_POLYGON_getInstance();
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }};
  ChainAndPolygonContact.prototype.evaluate_1b6ibn_k$ = function (manifold, xfA, xfB) {
    var tmp = ensureNotNull(this._get_m_fixtureA__0_k$())._m_shape;
    var chain = tmp instanceof ChainShape ? tmp : THROW_CCE();
    chain.getChildEdge_kjy5fq_k$(this._edge_0, this._get_m_indexA__0_k$());
    var tmp_0 = this._get_pool__0_k$()._get_collision__0_k$();
    var tmp_1 = ensureNotNull(this._get_m_fixtureB__0_k$())._m_shape;
    tmp_0.collideEdgeAndPolygon_ousgfk_k$(manifold, this._edge_0, xfA, tmp_1 instanceof PolygonShape ? tmp_1 : THROW_CCE(), xfB);
  };
  ChainAndPolygonContact.$metadata$ = {
    simpleName: 'ChainAndPolygonContact',
    kind: 'class',
    interfaces: []
  };
  function CircleContact(argPool) {
    Contact.call(this, argPool);
  }
  CircleContact.prototype.evaluate_1b6ibn_k$ = function (manifold, xfA, xfB) {
    var tmp = this._get_pool__0_k$()._get_collision__0_k$();
    var tmp_0 = ensureNotNull(this._get_m_fixtureA__0_k$())._m_shape;
    var tmp_1 = tmp_0 instanceof CircleShape ? tmp_0 : THROW_CCE();
    var tmp_2 = ensureNotNull(this._get_m_fixtureB__0_k$())._m_shape;
    tmp.collideCircles_nsbyyf_k$(manifold, tmp_1, xfA, tmp_2 instanceof CircleShape ? tmp_2 : THROW_CCE(), xfB);
  };
  CircleContact.$metadata$ = {
    simpleName: 'CircleContact',
    kind: 'class',
    interfaces: []
  };
  function Companion_78() {
    Companion_instance_77 = this;
    this._ISLAND_FLAG = 1;
    this._TOUCHING_FLAG = 2;
    this._ENABLED_FLAG = 4;
    this._FILTER_FLAG = 8;
    this._BULLET_HIT_FLAG = 16;
    this._TOI_FLAG = 32;
  }
  Companion_78.prototype.mixFriction_rybm4g_k$ = function (friction1, friction2) {
    return Companion_getInstance_68().sqrt_dbmacu_k$(friction1 * friction2);
  };
  Companion_78.prototype.mixRestitution_rybm4g_k$ = function (restitution1, restitution2) {
    return restitution1 > restitution2 ? restitution1 : restitution2;
  };
  Companion_78.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_77;
  function Companion_getInstance_77() {
    if (Companion_instance_77 == null)
      new Companion_78();
    return Companion_instance_77;
  }
  function Contact(pool) {
    Companion_getInstance_77();
    this._pool_5 = pool;
    this._m_flags_0 = 0;
    this._m_prev = null;
    this._m_next_1 = null;
    this._m_nodeA = new ContactEdge();
    this._m_nodeB = new ContactEdge();
    this._m_fixtureA = null;
    this._m_fixtureB = null;
    this._m_indexA = 0;
    this._m_indexB = 0;
    this._m_manifold = Manifold_init_$Create$();
    this._m_toiCount = 0;
    this._m_toi = 0;
    this._m_friction_0 = 0;
    this._m_restitution_0 = 0;
    this._m_tangentSpeed = 0;
    this._oldManifold = Manifold_init_$Create$();
  }
  Contact.prototype._get_pool__0_k$ = function () {
    return this._pool_5;
  };
  Contact.prototype.getNext_0_k$ = function () {
    return this._m_next_1;
  };
  Contact.prototype._get_m_fixtureA__0_k$ = function () {
    return this._m_fixtureA;
  };
  Contact.prototype._get_m_fixtureB__0_k$ = function () {
    return this._m_fixtureB;
  };
  Contact.prototype.getFixtureA_0_k$ = function () {
    return this._m_fixtureA;
  };
  Contact.prototype.getFixtureB_0_k$ = function () {
    return this._m_fixtureB;
  };
  Contact.prototype._get_m_indexA__0_k$ = function () {
    return this._m_indexA;
  };
  Contact.prototype.getChildIndexA_0_k$ = function () {
    return this._m_indexA;
  };
  Contact.prototype.getChildIndexB_0_k$ = function () {
    return this._m_indexB;
  };
  Contact.prototype.getManifold_0_k$ = function () {
    return this._m_manifold;
  };
  Contact.prototype._get_isTouching__0_k$ = function () {
    return (this._m_flags_0 & Companion_getInstance_77()._TOUCHING_FLAG) === Companion_getInstance_77()._TOUCHING_FLAG;
  };
  Contact.prototype._set_isEnabled__rpwsgn_k$ = function (flag) {
    var tmp;
    if (flag) {
      this._m_flags_0 = this._m_flags_0 | Companion_getInstance_77()._ENABLED_FLAG;
      tmp = Unit_getInstance();
    } else {
      this._m_flags_0 = this._m_flags_0 & ~Companion_getInstance_77()._ENABLED_FLAG;
      tmp = Unit_getInstance();
    }
    return tmp;
  };
  Contact.prototype._get_isEnabled__0_k$ = function () {
    return (this._m_flags_0 & Companion_getInstance_77()._ENABLED_FLAG) === Companion_getInstance_77()._ENABLED_FLAG;
  };
  Contact.prototype.init_593scx_k$ = function (fA, indexA, fB, indexB) {
    this._m_flags_0 = Companion_getInstance_77()._ENABLED_FLAG;
    this._m_fixtureA = fA;
    this._m_fixtureB = fB;
    this._m_indexA = indexA;
    this._m_indexB = indexB;
    this._m_manifold._pointCount = 0;
    this._m_prev = null;
    this._m_next_1 = null;
    ensureNotNull(this._m_nodeA)._contact = null;
    ensureNotNull(this._m_nodeA)._prev_1 = null;
    ensureNotNull(this._m_nodeA)._next_5 = null;
    ensureNotNull(this._m_nodeA)._other = null;
    ensureNotNull(this._m_nodeB)._contact = null;
    ensureNotNull(this._m_nodeB)._prev_1 = null;
    ensureNotNull(this._m_nodeB)._next_5 = null;
    ensureNotNull(this._m_nodeB)._other = null;
    this._m_toiCount = 0.0;
    this._m_friction_0 = Companion_getInstance_77().mixFriction_rybm4g_k$(fA._m_friction, fB._m_friction);
    this._m_restitution_0 = Companion_getInstance_77().mixRestitution_rybm4g_k$(fA._m_restitution, fB._m_restitution);
    this._m_tangentSpeed = 0.0;
  };
  Contact.prototype.flagForFiltering_sv8swh_k$ = function () {
    this._m_flags_0 = this._m_flags_0 | Companion_getInstance_77()._FILTER_FLAG;
  };
  Contact.prototype.update_cbzc8c_k$ = function (listener) {
    this._oldManifold.set_d0p1al_k$(this._m_manifold);
    this._m_flags_0 = this._m_flags_0 | Companion_getInstance_77()._ENABLED_FLAG;
    var touching = false;
    var wasTouching = (this._m_flags_0 & Companion_getInstance_77()._TOUCHING_FLAG) === Companion_getInstance_77()._TOUCHING_FLAG;
    var sensorA = ensureNotNull(this._m_fixtureA)._get_isSensor__0_k$();
    var sensorB = ensureNotNull(this._m_fixtureB)._get_isSensor__0_k$();
    var sensor = sensorA ? true : sensorB;
    var bodyA = ensureNotNull(ensureNotNull(this._m_fixtureA)._m_body);
    var bodyB = ensureNotNull(ensureNotNull(this._m_fixtureB)._m_body);
    var xfA = bodyA._xf_0;
    var xfB = bodyB._xf_0;
    if (sensor) {
      var shapeA = ensureNotNull(ensureNotNull(this._m_fixtureA)._m_shape);
      var shapeB = ensureNotNull(ensureNotNull(this._m_fixtureB)._m_shape);
      touching = this._pool_5._get_collision__0_k$().testOverlap_nv312u_k$(shapeA, this._m_indexA, shapeB, this._m_indexB, xfA, xfB);
      this._m_manifold._pointCount = 0;
    } else {
      this.evaluate_1b6ibn_k$(this._m_manifold, xfA, xfB);
      touching = this._m_manifold._pointCount > 0;
      var inductionVariable = 0;
      var last_1 = this._m_manifold._pointCount;
      if (inductionVariable < last_1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var mp2 = this._m_manifold._points_2[i];
          mp2._normalImpulse = 0.0;
          mp2._tangentImpulse = 0.0;
          var id2 = mp2._id_1;
          var inductionVariable_0 = 0;
          var last_2 = this._oldManifold._pointCount;
          if (inductionVariable_0 < last_2)
            $l$break: do {
              var j = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var mp1 = this._oldManifold._points_2[j];
              if (mp1._id_1.isEqual_vmt5qr_k$(id2)) {
                mp2._normalImpulse = mp1._normalImpulse;
                mp2._tangentImpulse = mp1._tangentImpulse;
                break $l$break;
              }}
             while (inductionVariable_0 < last_2);
        }
         while (inductionVariable < last_1);
      if (!(touching === wasTouching)) {
        ensureNotNull(bodyA)._set_isAwake__rpwsgn_k$(true);
        ensureNotNull(bodyB)._set_isAwake__rpwsgn_k$(true);
      }}
    if (touching) {
      this._m_flags_0 = this._m_flags_0 | Companion_getInstance_77()._TOUCHING_FLAG;
    } else {
      this._m_flags_0 = this._m_flags_0 & ~Companion_getInstance_77()._TOUCHING_FLAG;
    }
    if (listener == null) {
      return Unit_getInstance();
    }if (wasTouching === false ? touching === true : false) {
      listener.beginContact_qmxzzw_k$(this);
    }if (wasTouching === true ? touching === false : false) {
      listener.endContact_qmxzzw_k$(this);
    }if (sensor === false ? touching : false) {
      listener.preSolve_auuqje_k$(this, this._oldManifold);
    }};
  Contact.$metadata$ = {
    simpleName: 'Contact',
    kind: 'class',
    interfaces: []
  };
  function ContactEdge() {
    this._other = null;
    this._contact = null;
    this._prev_1 = null;
    this._next_5 = null;
  }
  ContactEdge.$metadata$ = {
    simpleName: 'ContactEdge',
    kind: 'class',
    interfaces: []
  };
  function ContactPositionConstraint() {
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Settings_getInstance()._get_maxManifoldPoints__0_k$();
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Vec2_init_$Create$(0.0, 0.0, 3, null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._localPoints = tmp_2;
    var tmp_4 = this;
    tmp_4._localNormal_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_5 = this;
    tmp_5._localPoint_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._indexA_2 = 0;
    this._indexB_2 = 0;
    this._invMassA = 0;
    this._invMassB = 0;
    var tmp_6 = this;
    tmp_6._localCenterA = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_7 = this;
    tmp_7._localCenterB = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._invIA = 0;
    this._invIB = 0;
    this._type_8 = null;
    this._radiusA = 0;
    this._radiusB = 0;
    this._pointCount_0 = 0;
  }
  ContactPositionConstraint.$metadata$ = {
    simpleName: 'ContactPositionConstraint',
    kind: 'class',
    interfaces: []
  };
  function ContactRegister() {
    this._creator = null;
    this._primary = false;
  }
  ContactRegister.$metadata$ = {
    simpleName: 'ContactRegister',
    kind: 'class',
    interfaces: []
  };
  function solveVelocityConstraints2($this, vc, mA, mB, iA, iB, normal, normalx, normaly) {
    var cp1 = vc._points_4[0];
    var cp2 = vc._points_4[1];
    var cp1rA = cp1._rA;
    var cp1rB = cp1._rB;
    var cp2rA = cp2._rA;
    var cp2rB = cp2._rB;
    var ax = cp1._normalImpulse_0;
    var ay = cp2._normalImpulse_0;
    var dv1x = -$this._wB_0 * cp1rB._y_6 + ensureNotNull($this._vB)._x_7 - ensureNotNull($this._vA)._x_7 + $this._wA_0 * cp1rA._y_6;
    var dv1y = $this._wB_0 * cp1rB._x_7 + ensureNotNull($this._vB)._y_6 - ensureNotNull($this._vA)._y_6 - $this._wA_0 * cp1rA._x_7;
    var dv2x = -$this._wB_0 * cp2rB._y_6 + ensureNotNull($this._vB)._x_7 - ensureNotNull($this._vA)._x_7 + $this._wA_0 * cp2rA._y_6;
    var dv2y = $this._wB_0 * cp2rB._x_7 + ensureNotNull($this._vB)._y_6 - ensureNotNull($this._vA)._y_6 - $this._wA_0 * cp2rA._x_7;
    var vn1 = dv1x * normalx + dv1y * normaly;
    var vn2 = dv2x * normalx + dv2y * normaly;
    var bx = vn1 - cp1._velocityBias;
    var by = vn2 - cp2._velocityBias;
    var R = vc._K;
    bx = bx - (R._ex._x_7 * ax + R._ey._x_7 * ay);
    by = by - (R._ex._y_6 * ax + R._ey._y_6 * ay);
    var R1 = vc._normalMass_0;
    var xx = R1._ex._x_7 * bx + R1._ey._x_7 * by;
    var xy_2 = R1._ex._y_6 * bx + R1._ey._y_6 * by;
    xx = xx * -1.0;
    xy_2 = xy_2 * -1.0;
    if (xx >= 0.0 ? xy_2 >= 0.0 : false) {
      solveVelocityConstraints2a($this, mA, mB, iA, iB, normal, normalx, normaly, cp1, cp2, cp1rA, cp1rB, cp2rA, cp2rB, ax, ay, xx, xy_2);
    } else {
      xx = -cp1._normalMass * bx;
      xy_2 = 0.0;
      vn1 = 0.0;
      vn2 = vc._K._ex._y_6 * xx + by;
      if (xx >= 0.0 ? vn2 >= 0.0 : false) {
        solveVelocityConstraints2b($this, mA, mB, iA, iB, normal, normalx, normaly, cp1, cp2, cp1rA, cp1rB, cp2rA, cp2rB, ax, ay, xx, xy_2);
      } else {
        xx = 0.0;
        xy_2 = -cp2._normalMass * by;
        vn1 = vc._K._ey._x_7 * xy_2 + bx;
        vn2 = 0.0;
        if (xy_2 >= 0.0 ? vn1 >= 0.0 : false) {
          solveVelocityConstraints2c($this, mA, mB, iA, iB, normal, normalx, normaly, cp1, cp2, cp1rA, cp1rB, cp2rA, cp2rB, ax, ay, xx, xy_2);
        } else {
          xx = 0.0;
          xy_2 = 0.0;
          vn1 = bx;
          vn2 = by;
          if (vn1 >= 0.0 ? vn2 >= 0.0 : false) {
            solveVelocityConstraints2d($this, mA, mB, iA, iB, normalx, normaly, cp1, cp2, cp1rA, cp1rB, cp2rA, cp2rB, ax, ay, xx, xy_2);
          } else {
          }
        }
      }
    }
  }
  function solveVelocityConstraints2d($this, mA, mB, iA, iB, normalx, normaly, cp1, cp2, cp1rA, cp1rB, cp2rA, cp2rB, ax, ay, xx, xy_2) {
    var dx = xx - ax;
    var dy = xy_2 - ay;
    var P1x = normalx * dx;
    var P1y = normaly * dx;
    var P2x = normalx * dy;
    var P2y = normaly * dy;
    var tmp0_this = ensureNotNull($this._vA);
    tmp0_this._x_7 = tmp0_this._x_7 - mA * (P1x + P2x);
    var tmp1_this = ensureNotNull($this._vA);
    tmp1_this._y_6 = tmp1_this._y_6 - mA * (P1y + P2y);
    var tmp2_this = ensureNotNull($this._vB);
    tmp2_this._x_7 = tmp2_this._x_7 + mB * (P1x + P2x);
    var tmp3_this = ensureNotNull($this._vB);
    tmp3_this._y_6 = tmp3_this._y_6 + mB * (P1y + P2y);
    var tmp4_this = $this;
    tmp4_this._wA_0 = tmp4_this._wA_0 - iA * (cp1rA._x_7 * P1y - cp1rA._y_6 * P1x + (cp2rA._x_7 * P2y - cp2rA._y_6 * P2x));
    var tmp5_this = $this;
    tmp5_this._wB_0 = tmp5_this._wB_0 + iB * (cp1rB._x_7 * P1y - cp1rB._y_6 * P1x + (cp2rB._x_7 * P2y - cp2rB._y_6 * P2x));
    cp1._normalImpulse_0 = xx;
    cp2._normalImpulse_0 = xy_2;
  }
  function solveVelocityConstraints2c($this, mA, mB, iA, iB, normal, normalx, normaly, cp1, cp2, cp1rA, cp1rB, cp2rA, cp2rB, ax, ay, xx, xy_2) {
    var vn2;
    var dx = xx - ax;
    var dy = xy_2 - ay;
    var P1x = normalx * dx;
    var P1y = normaly * dx;
    var P2x = normalx * dy;
    var P2y = normaly * dy;
    var tmp0_this = ensureNotNull($this._vA);
    tmp0_this._x_7 = tmp0_this._x_7 - mA * (P1x + P2x);
    var tmp1_this = ensureNotNull($this._vA);
    tmp1_this._y_6 = tmp1_this._y_6 - mA * (P1y + P2y);
    var tmp2_this = ensureNotNull($this._vB);
    tmp2_this._x_7 = tmp2_this._x_7 + mB * (P1x + P2x);
    var tmp3_this = ensureNotNull($this._vB);
    tmp3_this._y_6 = tmp3_this._y_6 + mB * (P1y + P2y);
    var tmp4_this = $this;
    tmp4_this._wA_0 = tmp4_this._wA_0 - iA * (cp1rA._x_7 * P1y - cp1rA._y_6 * P1x + (cp2rA._x_7 * P2y - cp2rA._y_6 * P2x));
    var tmp5_this = $this;
    tmp5_this._wB_0 = tmp5_this._wB_0 + iB * (cp1rB._x_7 * P1y - cp1rB._y_6 * P1x + (cp2rB._x_7 * P2y - cp2rB._y_6 * P2x));
    cp1._normalImpulse_0 = xx;
    cp2._normalImpulse_0 = xy_2;
    if (Companion_getInstance_78()._DEBUG_SOLVER) {
      var dv2 = ensureNotNull($this._vB).add_1v0asv_k$(Companion_getInstance_71().cross_xhyk1r_k$($this._wB_0, cp2rB).subLocal_1v0asv_k$(ensureNotNull($this._vA)).subLocal_1v0asv_k$(Companion_getInstance_71().cross_xhyk1r_k$($this._wA_0, cp2rA)));
      vn2 = Companion_getInstance_71().dot_5kvz1c_k$(dv2, normal);
    }}
  function solveVelocityConstraints2b($this, mA, mB, iA, iB, normal, normalx, normaly, cp1, cp2, cp1rA, cp1rB, cp2rA, cp2rB, ax, ay, xx, xy_2) {
    var vn1;
    var dx = xx - ax;
    var dy = xy_2 - ay;
    var P1x = normalx * dx;
    var P1y = normaly * dx;
    var P2x = normalx * dy;
    var P2y = normaly * dy;
    var tmp0_this = ensureNotNull($this._vA);
    tmp0_this._x_7 = tmp0_this._x_7 - mA * (P1x + P2x);
    var tmp1_this = ensureNotNull($this._vA);
    tmp1_this._y_6 = tmp1_this._y_6 - mA * (P1y + P2y);
    var tmp2_this = ensureNotNull($this._vB);
    tmp2_this._x_7 = tmp2_this._x_7 + mB * (P1x + P2x);
    var tmp3_this = ensureNotNull($this._vB);
    tmp3_this._y_6 = tmp3_this._y_6 + mB * (P1y + P2y);
    var tmp4_this = $this;
    tmp4_this._wA_0 = tmp4_this._wA_0 - iA * (cp1rA._x_7 * P1y - cp1rA._y_6 * P1x + (cp2rA._x_7 * P2y - cp2rA._y_6 * P2x));
    var tmp5_this = $this;
    tmp5_this._wB_0 = tmp5_this._wB_0 + iB * (cp1rB._x_7 * P1y - cp1rB._y_6 * P1x + (cp2rB._x_7 * P2y - cp2rB._y_6 * P2x));
    cp1._normalImpulse_0 = xx;
    cp2._normalImpulse_0 = xy_2;
    if (Companion_getInstance_78()._DEBUG_SOLVER) {
      var dv1 = ensureNotNull($this._vB).add_1v0asv_k$(Companion_getInstance_71().cross_xhyk1r_k$($this._wB_0, cp1rB).subLocal_1v0asv_k$(ensureNotNull($this._vA)).subLocal_1v0asv_k$(Companion_getInstance_71().cross_xhyk1r_k$($this._wA_0, cp1rA)));
      vn1 = Companion_getInstance_71().dot_5kvz1c_k$(dv1, normal);
    }}
  function solveVelocityConstraints2a($this, mA, mB, iA, iB, normal, normalx, normaly, cp1, cp2, cp1rA, cp1rB, cp2rA, cp2rB, ax, ay, xx, xy_2) {
    var vn1;
    var vn2;
    var dx = xx - ax;
    var dy = xy_2 - ay;
    var P1x = dx * normalx;
    var P1y = dx * normaly;
    var P2x = dy * normalx;
    var P2y = dy * normaly;
    var tmp0_this = ensureNotNull($this._vA);
    tmp0_this._x_7 = tmp0_this._x_7 - mA * (P1x + P2x);
    var tmp1_this = ensureNotNull($this._vA);
    tmp1_this._y_6 = tmp1_this._y_6 - mA * (P1y + P2y);
    var tmp2_this = ensureNotNull($this._vB);
    tmp2_this._x_7 = tmp2_this._x_7 + mB * (P1x + P2x);
    var tmp3_this = ensureNotNull($this._vB);
    tmp3_this._y_6 = tmp3_this._y_6 + mB * (P1y + P2y);
    var tmp4_this = $this;
    tmp4_this._wA_0 = tmp4_this._wA_0 - iA * (cp1rA._x_7 * P1y - cp1rA._y_6 * P1x + (cp2rA._x_7 * P2y - cp2rA._y_6 * P2x));
    var tmp5_this = $this;
    tmp5_this._wB_0 = tmp5_this._wB_0 + iB * (cp1rB._x_7 * P1y - cp1rB._y_6 * P1x + (cp2rB._x_7 * P2y - cp2rB._y_6 * P2x));
    cp1._normalImpulse_0 = xx;
    cp2._normalImpulse_0 = xy_2;
    if (Companion_getInstance_78()._DEBUG_SOLVER) {
      var dv1 = ensureNotNull($this._vB).add_1v0asv_k$(Companion_getInstance_71().cross_xhyk1r_k$($this._wB_0, cp1rB).subLocal_1v0asv_k$(ensureNotNull($this._vA)).subLocal_1v0asv_k$(Companion_getInstance_71().cross_xhyk1r_k$($this._wA_0, cp1rA)));
      var dv2 = ensureNotNull($this._vB).add_1v0asv_k$(Companion_getInstance_71().cross_xhyk1r_k$($this._wB_0, cp2rB).subLocal_1v0asv_k$(ensureNotNull($this._vA)).subLocal_1v0asv_k$(Companion_getInstance_71().cross_xhyk1r_k$($this._wA_0, cp2rA)));
      vn1 = Companion_getInstance_71().dot_5kvz1c_k$(dv1, normal);
      vn2 = Companion_getInstance_71().dot_5kvz1c_k$(dv2, normal);
    }}
  function solveVelocityConstraints1($this, point, mA, mB, iA, iB, normalx, normaly) {
    var dvx = -$this._wB_0 * point._rB._y_6 + ensureNotNull($this._vB)._x_7 - ensureNotNull($this._vA)._x_7 + $this._wA_0 * point._rA._y_6;
    var dvy = $this._wB_0 * point._rB._x_7 + ensureNotNull($this._vB)._y_6 - ensureNotNull($this._vA)._y_6 - $this._wA_0 * point._rA._x_7;
    var vn = dvx * normalx + dvy * normaly;
    var lambda = -point._normalMass * (vn - point._velocityBias);
    var a = point._normalImpulse_0 + lambda;
    var newImpulse = a > 0.0 ? a : 0.0;
    lambda = newImpulse - point._normalImpulse_0;
    point._normalImpulse_0 = newImpulse;
    var Px = normalx * lambda;
    var Py = normaly * lambda;
    var tmp0_this = ensureNotNull($this._vA);
    tmp0_this._x_7 = tmp0_this._x_7 - Px * mA;
    var tmp1_this = ensureNotNull($this._vA);
    tmp1_this._y_6 = tmp1_this._y_6 - Py * mA;
    var tmp2_this = $this;
    tmp2_this._wA_0 = tmp2_this._wA_0 - iA * (point._rA._x_7 * Py - point._rA._y_6 * Px);
    var tmp3_this = ensureNotNull($this._vB);
    tmp3_this._x_7 = tmp3_this._x_7 + Px * mB;
    var tmp4_this = ensureNotNull($this._vB);
    tmp4_this._y_6 = tmp4_this._y_6 + Py * mB;
    var tmp5_this = $this;
    tmp5_this._wB_0 = tmp5_this._wB_0 + iB * (point._rB._x_7 * Py - point._rB._y_6 * Px);
  }
  function solveVelocityConstraints0($this, vc, mA, mB, iA, iB, pointCount, tangentx, tangenty, friction) {
    var inductionVariable = 0;
    if (inductionVariable < pointCount)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var vcp = vc._points_4[j];
        var a = vcp._rA;
        var dvx = -$this._wB_0 * vcp._rB._y_6 + ensureNotNull($this._vB)._x_7 - ensureNotNull($this._vA)._x_7 + $this._wA_0 * a._y_6;
        var dvy = $this._wB_0 * vcp._rB._x_7 + ensureNotNull($this._vB)._y_6 - ensureNotNull($this._vA)._y_6 - $this._wA_0 * a._x_7;
        var vt = dvx * tangentx + dvy * tangenty - vc._tangentSpeed;
        var lambda = vcp._tangentMass * -vt;
        var maxFriction = friction * vcp._normalImpulse_0;
        var newImpulse = Companion_getInstance_68().clamp_ae5le_k$(vcp._tangentImpulse_0 + lambda, -maxFriction, maxFriction);
        lambda = newImpulse - vcp._tangentImpulse_0;
        vcp._tangentImpulse_0 = newImpulse;
        var Px = tangentx * lambda;
        var Py = tangenty * lambda;
        var tmp1_this = ensureNotNull($this._vA);
        tmp1_this._x_7 = tmp1_this._x_7 - Px * mA;
        var tmp2_this = ensureNotNull($this._vA);
        tmp2_this._y_6 = tmp2_this._y_6 - Py * mA;
        var tmp3_this = $this;
        tmp3_this._wA_0 = tmp3_this._wA_0 - iA * (vcp._rA._x_7 * Py - vcp._rA._y_6 * Px);
        var tmp4_this = ensureNotNull($this._vB);
        tmp4_this._x_7 = tmp4_this._x_7 + Px * mB;
        var tmp5_this = ensureNotNull($this._vB);
        tmp5_this._y_6 = tmp5_this._y_6 + Py * mB;
        var tmp6_this = $this;
        tmp6_this._wB_0 = tmp6_this._wB_0 + iB * (vcp._rB._x_7 * Py - vcp._rB._y_6 * Px);
      }
       while (inductionVariable < pointCount);
  }
  function ContactSolverDef() {
    this._step_8 = null;
    this._contacts = null;
    this._count_5 = 0;
    this._positions_0 = null;
    this._velocities_0 = null;
  }
  ContactSolverDef.$metadata$ = {
    simpleName: 'ContactSolverDef',
    kind: 'class',
    interfaces: []
  };
  function Companion_79() {
    Companion_instance_78 = this;
    this._DEBUG_SOLVER = false;
    this._k_errorTol = 0.001;
    this._INITIAL_NUM_CONSTRAINTS = 256;
    this._k_maxConditionNumber = 100.0;
  }
  Companion_79.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_78;
  function Companion_getInstance_78() {
    if (Companion_instance_78 == null)
      new Companion_79();
    return Companion_instance_78;
  }
  function ContactSolver() {
    Companion_getInstance_78();
    this._m_step = null;
    this._m_positions_0 = null;
    this._m_velocities_0 = null;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_getInstance_78()._INITIAL_NUM_CONSTRAINTS;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new ContactPositionConstraint();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._m_positionConstraints = tmp_2;
    var tmp_4 = this;
    var tmp_5 = 0;
    var tmp_6 = Companion_getInstance_78()._INITIAL_NUM_CONSTRAINTS;
    var tmp_7 = fillArrayVal(Array(tmp_6), null);
    while (tmp_5 < tmp_6) {
      var tmp_8 = tmp_5;
      tmp_7[tmp_8] = new ContactVelocityConstraint();
      tmp_5 = tmp_5 + 1 | 0;
    }
    tmp_4._m_velocityConstraints = tmp_7;
    this._m_contacts_0 = null;
    this._m_count_0 = 0;
    this._xfA_0 = Transform_init_$Create$_0();
    this._xfB_0 = Transform_init_$Create$_0();
    this._worldManifold = new WorldManifold();
    this._psolver = new PositionSolverManifold();
    this._vA = null;
    this._vB = null;
    this._wA_0 = 0;
    this._wB_0 = 0;
  }
  ContactSolver.prototype.init_a505ec_k$ = function (def) {
    this._m_step = def._step_8;
    this._m_count_0 = def._count_5;
    if (this._m_positionConstraints.length < this._m_count_0) {
      var old = this._m_positionConstraints;
      var tmp = this;
      var tmp0_arrayOfNulls_0 = Companion_getInstance_68().max_27zxwg_k$(imul(old.length, 2), this._m_count_0);
      var tmp_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
      tmp._m_positionConstraints = isArray(tmp_0) ? tmp_0 : THROW_CCE();
      var tmp1_arraycopy_0 = this._m_positionConstraints;
      var tmp2_arraycopy_0 = old.length;
      var tmp0_copyInto_0_2 = 0 + tmp2_arraycopy_0 | 0;
      arrayCopy_0(old, tmp1_arraycopy_0, 0, 0, tmp0_copyInto_0_2);
      Unit_getInstance();
      var inductionVariable = old.length;
      var last_1 = this._m_positionConstraints.length;
      if (inductionVariable < last_1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this._m_positionConstraints[i] = new ContactPositionConstraint();
        }
         while (inductionVariable < last_1);
    }if (this._m_velocityConstraints.length < this._m_count_0) {
      var old_0 = this._m_velocityConstraints;
      var tmp_1 = this;
      var tmp3_arrayOfNulls_0 = Companion_getInstance_68().max_27zxwg_k$(imul(old_0.length, 2), this._m_count_0);
      var tmp_2 = fillArrayVal(Array(tmp3_arrayOfNulls_0), null);
      tmp_1._m_velocityConstraints = isArray(tmp_2) ? tmp_2 : THROW_CCE();
      var tmp4_arraycopy_0 = this._m_velocityConstraints;
      var tmp5_arraycopy_0 = old_0.length;
      var tmp0_copyInto_0_2_0 = 0 + tmp5_arraycopy_0 | 0;
      arrayCopy_0(old_0, tmp4_arraycopy_0, 0, 0, tmp0_copyInto_0_2_0);
      Unit_getInstance();
      var inductionVariable_0 = old_0.length;
      var last_2 = this._m_velocityConstraints.length;
      if (inductionVariable_0 < last_2)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this._m_velocityConstraints[i_0] = new ContactVelocityConstraint();
        }
         while (inductionVariable_0 < last_2);
    }this._m_positions_0 = def._positions_0;
    this._m_velocities_0 = def._velocities_0;
    this._m_contacts_0 = def._contacts;
    var inductionVariable_1 = 0;
    var last_3 = this._m_count_0;
    if (inductionVariable_1 < last_3)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var contact = ensureNotNull(this._m_contacts_0)[i_1];
        var fixtureA = contact._m_fixtureA;
        var fixtureB = contact._m_fixtureB;
        var shapeA = ensureNotNull(fixtureA).getShape_0_k$();
        var shapeB = ensureNotNull(fixtureB).getShape_0_k$();
        var radiusA = ensureNotNull(shapeA)._radius_0;
        var radiusB = ensureNotNull(shapeB)._radius_0;
        var bodyA = fixtureA.getBody_0_k$();
        var bodyB = fixtureB.getBody_0_k$();
        var manifold = contact.getManifold_0_k$();
        var pointCount = manifold._pointCount;
        var vc = this._m_velocityConstraints[i_1];
        vc._friction_0 = contact._m_friction_0;
        vc._restitution_0 = contact._m_restitution_0;
        vc._tangentSpeed = contact._m_tangentSpeed;
        vc._indexA_3 = ensureNotNull(bodyA)._islandIndex;
        vc._indexB_3 = ensureNotNull(bodyB)._islandIndex;
        vc._invMassA_0 = bodyA._m_invMass;
        vc._invMassB_0 = bodyB._m_invMass;
        vc._invIA_0 = bodyA._m_invI;
        vc._invIB_0 = bodyB._m_invI;
        vc._contactIndex = i_1;
        vc._pointCount_1 = pointCount;
        vc._K.setZero_sv8swh_k$();
        vc._normalMass_0.setZero_sv8swh_k$();
        var pc = this._m_positionConstraints[i_1];
        pc._indexA_2 = bodyA._islandIndex;
        pc._indexB_2 = bodyB._islandIndex;
        pc._invMassA = bodyA._m_invMass;
        pc._invMassB = bodyB._m_invMass;
        pc._localCenterA.set_1v0asv_k$(bodyA._sweep._localCenter);
        Unit_getInstance();
        pc._localCenterB.set_1v0asv_k$(bodyB._sweep._localCenter);
        Unit_getInstance();
        pc._invIA = bodyA._m_invI;
        pc._invIB = bodyB._m_invI;
        pc._localNormal_1.set_1v0asv_k$(manifold._localNormal_0);
        Unit_getInstance();
        pc._localPoint_1.set_1v0asv_k$(manifold._localPoint);
        Unit_getInstance();
        pc._pointCount_0 = pointCount;
        pc._radiusA = radiusA;
        pc._radiusB = radiusB;
        pc._type_8 = manifold._type_6;
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < pointCount)
          do {
            var j = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cp = manifold._points_2[j];
            var vcp = vc._points_4[j];
            if (ensureNotNull(this._m_step)._warmStarting) {
              vcp._normalImpulse_0 = ensureNotNull(this._m_step)._dtRatio * cp._normalImpulse;
              vcp._tangentImpulse_0 = ensureNotNull(this._m_step)._dtRatio * cp._tangentImpulse;
            } else {
              vcp._normalImpulse_0 = 0.0;
              vcp._tangentImpulse_0 = 0.0;
            }
            vcp._rA.setZero_sv8swh_k$();
            vcp._rB.setZero_sv8swh_k$();
            vcp._normalMass = 0.0;
            vcp._tangentMass = 0.0;
            vcp._velocityBias = 0.0;
            pc._localPoints[j]._x_7 = cp._localPoint_0._x_7;
            pc._localPoints[j]._y_6 = cp._localPoint_0._y_6;
          }
           while (inductionVariable_2 < pointCount);
      }
       while (inductionVariable_1 < last_3);
  };
  ContactSolver.prototype.warmStart_sv8swh_k$ = function () {
    var inductionVariable = 0;
    var last_1 = this._m_count_0;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var vc = this._m_velocityConstraints[i];
        var indexA = vc._indexA_3;
        var indexB = vc._indexB_3;
        var mA = vc._invMassA_0;
        var iA = vc._invIA_0;
        var mB = vc._invMassB_0;
        var iB = vc._invIB_0;
        var pointCount = vc._pointCount_1;
        var vA = ensureNotNull(this._m_velocities_0)[indexA]._v_1;
        var wA = ensureNotNull(this._m_velocities_0)[indexA]._w_2;
        var vB = ensureNotNull(this._m_velocities_0)[indexB]._v_1;
        var wB = ensureNotNull(this._m_velocities_0)[indexB]._w_2;
        var normal = vc._normal_5;
        var tangentx = 1.0 * normal._y_6;
        var tangenty = -1.0 * normal._x_7;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < pointCount)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var vcp = vc._points_4[j];
            var Px = tangentx * vcp._tangentImpulse_0 + normal._x_7 * vcp._normalImpulse_0;
            var Py = tangenty * vcp._tangentImpulse_0 + normal._y_6 * vcp._normalImpulse_0;
            wA = wA - iA * (vcp._rA._x_7 * Py - vcp._rA._y_6 * Px);
            var tmp2_this = vA;
            tmp2_this._x_7 = tmp2_this._x_7 - Px * mA;
            var tmp3_this = vA;
            tmp3_this._y_6 = tmp3_this._y_6 - Py * mA;
            wB = wB + iB * (vcp._rB._x_7 * Py - vcp._rB._y_6 * Px);
            var tmp4_this = vB;
            tmp4_this._x_7 = tmp4_this._x_7 + Px * mB;
            var tmp5_this = vB;
            tmp5_this._y_6 = tmp5_this._y_6 + Py * mB;
          }
           while (inductionVariable_0 < pointCount);
        ensureNotNull(this._m_velocities_0)[indexA]._w_2 = wA;
        ensureNotNull(this._m_velocities_0)[indexB]._w_2 = wB;
      }
       while (inductionVariable < last_1);
  };
  ContactSolver.prototype.initializeVelocityConstraints_sv8swh_k$ = function () {
    var inductionVariable = 0;
    var last_1 = this._m_count_0;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var vc = this._m_velocityConstraints[i];
        var pc = this._m_positionConstraints[i];
        var radiusA = pc._radiusA;
        var radiusB = pc._radiusB;
        var manifold = ensureNotNull(this._m_contacts_0)[vc._contactIndex].getManifold_0_k$();
        var indexA = vc._indexA_3;
        var indexB = vc._indexB_3;
        var mA = vc._invMassA_0;
        var mB = vc._invMassB_0;
        var iA = vc._invIA_0;
        var iB = vc._invIB_0;
        var localCenterA = pc._localCenterA;
        var localCenterB = pc._localCenterB;
        var cA = ensureNotNull(this._m_positions_0)[indexA]._c_2;
        var aA = ensureNotNull(this._m_positions_0)[indexA]._a_2;
        var vA = ensureNotNull(this._m_velocities_0)[indexA]._v_1;
        var wA = ensureNotNull(this._m_velocities_0)[indexA]._w_2;
        var cB = ensureNotNull(this._m_positions_0)[indexB]._c_2;
        var aB = ensureNotNull(this._m_positions_0)[indexB]._a_2;
        var vB = ensureNotNull(this._m_velocities_0)[indexB]._v_1;
        var wB = ensureNotNull(this._m_velocities_0)[indexB]._w_2;
        var xfAq = this._xfA_0._q;
        var xfBq = this._xfB_0._q;
        xfAq.setRadians_dbmacu_k$(aA);
        Unit_getInstance();
        xfBq.setRadians_dbmacu_k$(aB);
        Unit_getInstance();
        this._xfA_0._p_1._x_7 = cA._x_7 - (xfAq._c_0 * localCenterA._x_7 - xfAq._s * localCenterA._y_6);
        this._xfA_0._p_1._y_6 = cA._y_6 - (xfAq._s * localCenterA._x_7 + xfAq._c_0 * localCenterA._y_6);
        this._xfB_0._p_1._x_7 = cB._x_7 - (xfBq._c_0 * localCenterB._x_7 - xfBq._s * localCenterB._y_6);
        this._xfB_0._p_1._y_6 = cB._y_6 - (xfBq._s * localCenterB._x_7 + xfBq._c_0 * localCenterB._y_6);
        this._worldManifold.initialize_aezuj7_k$(manifold, this._xfA_0, radiusA, this._xfB_0, radiusB);
        var vcnormal = vc._normal_5;
        vcnormal._x_7 = this._worldManifold._normal_3._x_7;
        vcnormal._y_6 = this._worldManifold._normal_3._y_6;
        var pointCount = vc._pointCount_1;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < pointCount)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var vcp = vc._points_4[j];
            var wmPj = this._worldManifold._points_3[j];
            var vcprA = vcp._rA;
            var vcprB = vcp._rB;
            vcprA._x_7 = wmPj._x_7 - cA._x_7;
            vcprA._y_6 = wmPj._y_6 - cA._y_6;
            vcprB._x_7 = wmPj._x_7 - cB._x_7;
            vcprB._y_6 = wmPj._y_6 - cB._y_6;
            var rnA = vcprA._x_7 * vcnormal._y_6 - vcprA._y_6 * vcnormal._x_7;
            var rnB = vcprB._x_7 * vcnormal._y_6 - vcprB._y_6 * vcnormal._x_7;
            var kNormal = mA + mB + iA * rnA * rnA + iB * rnB * rnB;
            vcp._normalMass = kNormal > 0.0 ? 1.0 / kNormal : 0.0;
            var tangentx = 1.0 * vcnormal._y_6;
            var tangenty = -1.0 * vcnormal._x_7;
            var rtA = vcprA._x_7 * tangenty - vcprA._y_6 * tangentx;
            var rtB = vcprB._x_7 * tangenty - vcprB._y_6 * tangentx;
            var kTangent = mA + mB + iA * rtA * rtA + iB * rtB * rtB;
            vcp._tangentMass = kTangent > 0.0 ? 1.0 / kTangent : 0.0;
            vcp._velocityBias = 0.0;
            var tempx = vB._x_7 + -wB * vcprB._y_6 - vA._x_7 - -wA * vcprA._y_6;
            var tempy = vB._y_6 + wB * vcprB._x_7 - vA._y_6 - wA * vcprA._x_7;
            var vRel = vcnormal._x_7 * tempx + vcnormal._y_6 * tempy;
            if (vRel < -Settings_getInstance()._get_velocityThreshold__0_k$()) {
              vcp._velocityBias = -vc._restitution_0 * vRel;
            }}
           while (inductionVariable_0 < pointCount);
        if (vc._pointCount_1 === 2) {
          var vcp1 = vc._points_4[0];
          var vcp2 = vc._points_4[1];
          var rn1A = vcp1._rA._x_7 * vcnormal._y_6 - vcp1._rA._y_6 * vcnormal._x_7;
          var rn1B = vcp1._rB._x_7 * vcnormal._y_6 - vcp1._rB._y_6 * vcnormal._x_7;
          var rn2A = vcp2._rA._x_7 * vcnormal._y_6 - vcp2._rA._y_6 * vcnormal._x_7;
          var rn2B = vcp2._rB._x_7 * vcnormal._y_6 - vcp2._rB._y_6 * vcnormal._x_7;
          var k11 = mA + mB + iA * rn1A * rn1A + iB * rn1B * rn1B;
          var k22 = mA + mB + iA * rn2A * rn2A + iB * rn2B * rn2B;
          var k12 = mA + mB + iA * rn1A * rn2A + iB * rn1B * rn2B;
          if (k11 * k11 < Companion_getInstance_78()._k_maxConditionNumber * (k11 * k22 - k12 * k12)) {
            vc._K._ex._x_7 = k11;
            vc._K._ex._y_6 = k12;
            vc._K._ey._x_7 = k12;
            vc._K._ey._y_6 = k22;
            vc._K.invertToOut_puyjoi_k$(vc._normalMass_0);
          } else {
            vc._pointCount_1 = 1;
          }
        }}
       while (inductionVariable < last_1);
  };
  ContactSolver.prototype.storeImpulses_sv8swh_k$ = function () {
    var inductionVariable = 0;
    var last_1 = this._m_count_0;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var vc = this._m_velocityConstraints[i];
        var manifold = ensureNotNull(this._m_contacts_0)[vc._contactIndex].getManifold_0_k$();
        var inductionVariable_0 = 0;
        var last_2 = vc._pointCount_1;
        if (inductionVariable_0 < last_2)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            manifold._points_2[j]._normalImpulse = vc._points_4[j]._normalImpulse_0;
            manifold._points_2[j]._tangentImpulse = vc._points_4[j]._tangentImpulse_0;
          }
           while (inductionVariable_0 < last_2);
      }
       while (inductionVariable < last_1);
  };
  ContactSolver.prototype.solvePositionConstraints_0_k$ = function () {
    var minSeparation = 0.0;
    var inductionVariable = 0;
    var last_1 = this._m_count_0;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var pc = this._m_positionConstraints[i];
        var indexA = pc._indexA_2;
        var indexB = pc._indexB_2;
        var mA = pc._invMassA;
        var iA = pc._invIA;
        var localCenterA = pc._localCenterA;
        var localCenterAx = localCenterA._x_7;
        var localCenterAy = localCenterA._y_6;
        var mB = pc._invMassB;
        var iB = pc._invIB;
        var localCenterB = pc._localCenterB;
        var localCenterBx = localCenterB._x_7;
        var localCenterBy = localCenterB._y_6;
        var pointCount = pc._pointCount_0;
        var cA = ensureNotNull(this._m_positions_0)[indexA]._c_2;
        var aA = ensureNotNull(this._m_positions_0)[indexA]._a_2;
        var cB = ensureNotNull(this._m_positions_0)[indexB]._c_2;
        var aB = ensureNotNull(this._m_positions_0)[indexB]._a_2;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < pointCount)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var xfAq = this._xfA_0._q;
            var xfBq = this._xfB_0._q;
            xfAq.setRadians_dbmacu_k$(aA);
            Unit_getInstance();
            xfBq.setRadians_dbmacu_k$(aB);
            Unit_getInstance();
            this._xfA_0._p_1._x_7 = cA._x_7 - xfAq._c_0 * localCenterAx + xfAq._s * localCenterAy;
            this._xfA_0._p_1._y_6 = cA._y_6 - xfAq._s * localCenterAx - xfAq._c_0 * localCenterAy;
            this._xfB_0._p_1._x_7 = cB._x_7 - xfBq._c_0 * localCenterBx + xfBq._s * localCenterBy;
            this._xfB_0._p_1._y_6 = cB._y_6 - xfBq._s * localCenterBx - xfBq._c_0 * localCenterBy;
            var psm = this._psolver;
            psm.initialize_sfs4qh_k$(pc, this._xfA_0, this._xfB_0, j);
            var normal = psm._normal_6;
            var point = psm._point_0;
            var separation = psm._separation_1;
            var rAx = point._x_7 - cA._x_7;
            var rAy = point._y_6 - cA._y_6;
            var rBx = point._x_7 - cB._x_7;
            var rBy = point._y_6 - cB._y_6;
            minSeparation = Companion_getInstance_68().min_rybm4g_k$(minSeparation, separation);
            var C = Companion_getInstance_68().clamp_ae5le_k$(Settings_getInstance()._get_baumgarte__0_k$() * (separation + Settings_getInstance()._get_linearSlop__0_k$()), -Settings_getInstance()._get_maxLinearCorrection__0_k$(), 0.0);
            var rnA = rAx * normal._y_6 - rAy * normal._x_7;
            var rnB = rBx * normal._y_6 - rBy * normal._x_7;
            var K = mA + mB + iA * rnA * rnA + iB * rnB * rnB;
            var impulse = K > 0.0 ? -C / K : 0.0;
            var Px = normal._x_7 * impulse;
            var Py = normal._y_6 * impulse;
            var tmp2_this = cA;
            tmp2_this._x_7 = tmp2_this._x_7 - Px * mA;
            var tmp3_this = cA;
            tmp3_this._y_6 = tmp3_this._y_6 - Py * mA;
            aA = aA - iA * (rAx * Py - rAy * Px);
            var tmp4_this = cB;
            tmp4_this._x_7 = tmp4_this._x_7 + Px * mB;
            var tmp5_this = cB;
            tmp5_this._y_6 = tmp5_this._y_6 + Py * mB;
            aB = aB + iB * (rBx * Py - rBy * Px);
          }
           while (inductionVariable_0 < pointCount);
        ensureNotNull(this._m_positions_0)[indexA]._a_2 = aA;
        ensureNotNull(this._m_positions_0)[indexB]._a_2 = aB;
      }
       while (inductionVariable < last_1);
    return minSeparation >= -3.0 * Settings_getInstance()._get_linearSlop__0_k$();
  };
  ContactSolver.prototype.solveTOIPositionConstraints_27zxwg_k$ = function (toiIndexA, toiIndexB) {
    var minSeparation = 0.0;
    var inductionVariable = 0;
    var last_1 = this._m_count_0;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var pc = this._m_positionConstraints[i];
        var indexA = pc._indexA_2;
        var indexB = pc._indexB_2;
        var localCenterA = pc._localCenterA;
        var localCenterB = pc._localCenterB;
        var localCenterAx = localCenterA._x_7;
        var localCenterAy = localCenterA._y_6;
        var localCenterBx = localCenterB._x_7;
        var localCenterBy = localCenterB._y_6;
        var pointCount = pc._pointCount_0;
        var mA = 0.0;
        var iA = 0.0;
        if (indexA === toiIndexA ? true : indexA === toiIndexB) {
          mA = pc._invMassA;
          iA = pc._invIA;
        }var mB = 0.0;
        var iB = 0.0;
        if (indexB === toiIndexA ? true : indexB === toiIndexB) {
          mB = pc._invMassB;
          iB = pc._invIB;
        }var cA = ensureNotNull(this._m_positions_0)[indexA]._c_2;
        var aA = ensureNotNull(this._m_positions_0)[indexA]._a_2;
        var cB = ensureNotNull(this._m_positions_0)[indexB]._c_2;
        var aB = ensureNotNull(this._m_positions_0)[indexB]._a_2;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < pointCount)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var xfAq = this._xfA_0._q;
            var xfBq = this._xfB_0._q;
            xfAq.setRadians_dbmacu_k$(aA);
            Unit_getInstance();
            xfBq.setRadians_dbmacu_k$(aB);
            Unit_getInstance();
            this._xfA_0._p_1._x_7 = cA._x_7 - xfAq._c_0 * localCenterAx + xfAq._s * localCenterAy;
            this._xfA_0._p_1._y_6 = cA._y_6 - xfAq._s * localCenterAx - xfAq._c_0 * localCenterAy;
            this._xfB_0._p_1._x_7 = cB._x_7 - xfBq._c_0 * localCenterBx + xfBq._s * localCenterBy;
            this._xfB_0._p_1._y_6 = cB._y_6 - xfBq._s * localCenterBx - xfBq._c_0 * localCenterBy;
            var psm = this._psolver;
            psm.initialize_sfs4qh_k$(pc, this._xfA_0, this._xfB_0, j);
            var normal = psm._normal_6;
            var point = psm._point_0;
            var separation = psm._separation_1;
            var rAx = point._x_7 - cA._x_7;
            var rAy = point._y_6 - cA._y_6;
            var rBx = point._x_7 - cB._x_7;
            var rBy = point._y_6 - cB._y_6;
            minSeparation = Companion_getInstance_68().min_rybm4g_k$(minSeparation, separation);
            var C = Companion_getInstance_68().clamp_ae5le_k$(Settings_getInstance()._get_toiBaugarte__0_k$() * (separation + Settings_getInstance()._get_linearSlop__0_k$()), -Settings_getInstance()._get_maxLinearCorrection__0_k$(), 0.0);
            var rnA = rAx * normal._y_6 - rAy * normal._x_7;
            var rnB = rBx * normal._y_6 - rBy * normal._x_7;
            var K = mA + mB + iA * rnA * rnA + iB * rnB * rnB;
            var impulse = K > 0.0 ? -C / K : 0.0;
            var Px = normal._x_7 * impulse;
            var Py = normal._y_6 * impulse;
            var tmp2_this = cA;
            tmp2_this._x_7 = tmp2_this._x_7 - Px * mA;
            var tmp3_this = cA;
            tmp3_this._y_6 = tmp3_this._y_6 - Py * mA;
            aA = aA - iA * (rAx * Py - rAy * Px);
            var tmp4_this = cB;
            tmp4_this._x_7 = tmp4_this._x_7 + Px * mB;
            var tmp5_this = cB;
            tmp5_this._y_6 = tmp5_this._y_6 + Py * mB;
            aB = aB + iB * (rBx * Py - rBy * Px);
          }
           while (inductionVariable_0 < pointCount);
        ensureNotNull(this._m_positions_0)[indexA]._a_2 = aA;
        ensureNotNull(this._m_positions_0)[indexB]._a_2 = aB;
      }
       while (inductionVariable < last_1);
    return minSeparation >= -1.5 * Settings_getInstance()._get_linearSlop__0_k$();
  };
  ContactSolver.prototype.solveVelocityConstraints_sv8swh_k$ = function () {
    var inductionVariable = 0;
    var last_1 = this._m_count_0;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var vc = this._m_velocityConstraints[i];
        var indexA = vc._indexA_3;
        var indexB = vc._indexB_3;
        var mA = vc._invMassA_0;
        var mB = vc._invMassB_0;
        var iA = vc._invIA_0;
        var iB = vc._invIB_0;
        var pointCount = vc._pointCount_1;
        this._vA = ensureNotNull(this._m_velocities_0)[indexA]._v_1;
        this._wA_0 = ensureNotNull(this._m_velocities_0)[indexA]._w_2;
        this._vB = ensureNotNull(this._m_velocities_0)[indexB]._v_1;
        this._wB_0 = ensureNotNull(this._m_velocities_0)[indexB]._w_2;
        var normal = vc._normal_5;
        var normalx = normal._x_7;
        var normaly = normal._y_6;
        var tangentx = 1.0 * vc._normal_5._y_6;
        var tangenty = -1.0 * vc._normal_5._x_7;
        var friction = vc._friction_0;
        solveVelocityConstraints0(this, vc, mA, mB, iA, iB, pointCount, tangentx, tangenty, friction);
        if (vc._pointCount_1 === 1) {
          solveVelocityConstraints1(this, vc._points_4[0], mA, mB, iA, iB, normalx, normaly);
        } else {
          solveVelocityConstraints2(this, vc, mA, mB, iA, iB, normal, normalx, normaly);
        }
        ensureNotNull(this._m_velocities_0)[indexA]._w_2 = this._wA_0;
        ensureNotNull(this._m_velocities_0)[indexB]._w_2 = this._wB_0;
      }
       while (inductionVariable < last_1);
  };
  ContactSolver.$metadata$ = {
    simpleName: 'ContactSolver',
    kind: 'class',
    interfaces: []
  };
  function VelocityConstraintPoint() {
    var tmp = this;
    tmp._rA = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._rB = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._normalImpulse_0 = 0;
    this._tangentImpulse_0 = 0;
    this._normalMass = 0;
    this._tangentMass = 0;
    this._velocityBias = 0;
  }
  VelocityConstraintPoint.$metadata$ = {
    simpleName: 'VelocityConstraintPoint',
    kind: 'class',
    interfaces: []
  };
  function ContactVelocityConstraint() {
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Settings_getInstance()._get_maxManifoldPoints__0_k$();
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new VelocityConstraintPoint();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._points_4 = tmp_2;
    var tmp_4 = this;
    tmp_4._normal_5 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._normalMass_0 = Mat22_init_$Create$();
    this._K = Mat22_init_$Create$();
    this._indexA_3 = 0;
    this._indexB_3 = 0;
    this._invMassA_0 = 0;
    this._invMassB_0 = 0;
    this._invIA_0 = 0;
    this._invIB_0 = 0;
    this._friction_0 = 0;
    this._restitution_0 = 0;
    this._tangentSpeed = 0;
    this._pointCount_1 = 0;
    this._contactIndex = 0;
  }
  ContactVelocityConstraint.$metadata$ = {
    simpleName: 'ContactVelocityConstraint',
    kind: 'class',
    interfaces: []
  };
  function EdgeAndCircleContact(argPool) {
    Contact.call(this, argPool);
  }
  EdgeAndCircleContact.prototype.init_593scx_k$ = function (fA, indexA, fB, indexB) {
    Contact.prototype.init_593scx_k$.call(this, fA, indexA, fB, indexB);
    var tmp0_assert_0 = ensureNotNull(this._get_m_fixtureA__0_k$())._get_type__0_k$() === ShapeType_EDGE_getInstance();
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = ensureNotNull(this._get_m_fixtureB__0_k$())._get_type__0_k$() === ShapeType_CIRCLE_getInstance();
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }};
  EdgeAndCircleContact.prototype.evaluate_1b6ibn_k$ = function (manifold, xfA, xfB) {
    var tmp = this._get_pool__0_k$()._get_collision__0_k$();
    var tmp_0 = ensureNotNull(this._get_m_fixtureA__0_k$())._m_shape;
    var tmp_1 = tmp_0 instanceof EdgeShape ? tmp_0 : THROW_CCE();
    var tmp_2 = ensureNotNull(this._get_m_fixtureB__0_k$())._m_shape;
    tmp.collideEdgeAndCircle_4g9njw_k$(manifold, tmp_1, xfA, tmp_2 instanceof CircleShape ? tmp_2 : THROW_CCE(), xfB);
  };
  EdgeAndCircleContact.$metadata$ = {
    simpleName: 'EdgeAndCircleContact',
    kind: 'class',
    interfaces: []
  };
  function EdgeAndPolygonContact(argPool) {
    Contact.call(this, argPool);
  }
  EdgeAndPolygonContact.prototype.init_593scx_k$ = function (fA, indexA, fB, indexB) {
    Contact.prototype.init_593scx_k$.call(this, fA, indexA, fB, indexB);
    var tmp0_assert_0 = ensureNotNull(this._get_m_fixtureA__0_k$())._get_type__0_k$() === ShapeType_EDGE_getInstance();
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_assert_0 = ensureNotNull(this._get_m_fixtureB__0_k$())._get_type__0_k$() === ShapeType_POLYGON_getInstance();
    if (!tmp1_assert_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }};
  EdgeAndPolygonContact.prototype.evaluate_1b6ibn_k$ = function (manifold, xfA, xfB) {
    var tmp = this._get_pool__0_k$()._get_collision__0_k$();
    var tmp_0 = ensureNotNull(this._get_m_fixtureA__0_k$())._m_shape;
    var tmp_1 = tmp_0 instanceof EdgeShape ? tmp_0 : THROW_CCE();
    var tmp_2 = ensureNotNull(this._get_m_fixtureB__0_k$())._m_shape;
    tmp.collideEdgeAndPolygon_ousgfk_k$(manifold, tmp_1, xfA, tmp_2 instanceof PolygonShape ? tmp_2 : THROW_CCE(), xfB);
  };
  EdgeAndPolygonContact.$metadata$ = {
    simpleName: 'EdgeAndPolygonContact',
    kind: 'class',
    interfaces: []
  };
  function PolygonAndCircleContact(argPool) {
    Contact.call(this, argPool);
  }
  PolygonAndCircleContact.prototype.evaluate_1b6ibn_k$ = function (manifold, xfA, xfB) {
    var tmp = this._get_pool__0_k$()._get_collision__0_k$();
    var tmp_0 = ensureNotNull(this._get_m_fixtureA__0_k$())._m_shape;
    var tmp_1 = tmp_0 instanceof PolygonShape ? tmp_0 : THROW_CCE();
    var tmp_2 = ensureNotNull(this._get_m_fixtureB__0_k$())._m_shape;
    tmp.collidePolygonAndCircle_18q6rj_k$(manifold, tmp_1, xfA, tmp_2 instanceof CircleShape ? tmp_2 : THROW_CCE(), xfB);
  };
  PolygonAndCircleContact.$metadata$ = {
    simpleName: 'PolygonAndCircleContact',
    kind: 'class',
    interfaces: []
  };
  function PolygonContact(argPool) {
    Contact.call(this, argPool);
  }
  PolygonContact.prototype.evaluate_1b6ibn_k$ = function (manifold, xfA, xfB) {
    var tmp = this._get_pool__0_k$()._get_collision__0_k$();
    var tmp_0 = ensureNotNull(this._get_m_fixtureA__0_k$())._m_shape;
    var tmp_1 = tmp_0 instanceof PolygonShape ? tmp_0 : THROW_CCE();
    var tmp_2 = ensureNotNull(this._get_m_fixtureB__0_k$())._m_shape;
    tmp.collidePolygons_3luy0j_k$(manifold, tmp_1, xfA, tmp_2 instanceof PolygonShape ? tmp_2 : THROW_CCE(), xfB);
  };
  PolygonContact.$metadata$ = {
    simpleName: 'PolygonContact',
    kind: 'class',
    interfaces: []
  };
  function Position() {
    var tmp = this;
    tmp._c_2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._a_2 = 0;
  }
  Position.$metadata$ = {
    simpleName: 'Position',
    kind: 'class',
    interfaces: []
  };
  function PositionSolverManifold() {
    var tmp = this;
    tmp._normal_6 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._point_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._separation_1 = 0;
  }
  PositionSolverManifold.prototype.initialize_sfs4qh_k$ = function (pc, xfA, xfB, index_0) {
    var tmp0_assert_0 = pc._pointCount_0 > 0;
    if (!tmp0_assert_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var xfAq = xfA._q;
    var xfBq = xfB._q;
    var pcLocalPointsI = pc._localPoints[index_0];
    var tmp0_subject = pc._type_8;
    if (equals_1(tmp0_subject, ManifoldType_CIRCLES_getInstance())) {
      var plocalPoint = pc._localPoint_1;
      var pLocalPoints0 = pc._localPoints[0];
      var pointAx = xfAq._c_0 * plocalPoint._x_7 - xfAq._s * plocalPoint._y_6 + xfA._p_1._x_7;
      var pointAy = xfAq._s * plocalPoint._x_7 + xfAq._c_0 * plocalPoint._y_6 + xfA._p_1._y_6;
      var pointBx = xfBq._c_0 * pLocalPoints0._x_7 - xfBq._s * pLocalPoints0._y_6 + xfB._p_1._x_7;
      var pointBy = xfBq._s * pLocalPoints0._x_7 + xfBq._c_0 * pLocalPoints0._y_6 + xfB._p_1._y_6;
      this._normal_6._x_7 = pointBx - pointAx;
      this._normal_6._y_6 = pointBy - pointAy;
      this._normal_6.normalize_0_k$();
      Unit_getInstance();
      this._point_0._x_7 = (pointAx + pointBx) * 0.5;
      this._point_0._y_6 = (pointAy + pointBy) * 0.5;
      var tempx = pointBx - pointAx;
      var tempy = pointBy - pointAy;
      this._separation_1 = tempx * this._normal_6._x_7 + tempy * this._normal_6._y_6 - pc._radiusA - pc._radiusB;
    } else if (equals_1(tmp0_subject, ManifoldType_FACE_A_getInstance())) {
      var pcLocalNormal = pc._localNormal_1;
      var pcLocalPoint = pc._localPoint_1;
      this._normal_6._x_7 = xfAq._c_0 * pcLocalNormal._x_7 - xfAq._s * pcLocalNormal._y_6;
      this._normal_6._y_6 = xfAq._s * pcLocalNormal._x_7 + xfAq._c_0 * pcLocalNormal._y_6;
      var planePointx = xfAq._c_0 * pcLocalPoint._x_7 - xfAq._s * pcLocalPoint._y_6 + xfA._p_1._x_7;
      var planePointy = xfAq._s * pcLocalPoint._x_7 + xfAq._c_0 * pcLocalPoint._y_6 + xfA._p_1._y_6;
      var clipPointx = xfBq._c_0 * pcLocalPointsI._x_7 - xfBq._s * pcLocalPointsI._y_6 + xfB._p_1._x_7;
      var clipPointy = xfBq._s * pcLocalPointsI._x_7 + xfBq._c_0 * pcLocalPointsI._y_6 + xfB._p_1._y_6;
      var tempx_0 = clipPointx - planePointx;
      var tempy_0 = clipPointy - planePointy;
      this._separation_1 = tempx_0 * this._normal_6._x_7 + tempy_0 * this._normal_6._y_6 - pc._radiusA - pc._radiusB;
      this._point_0._x_7 = clipPointx;
      this._point_0._y_6 = clipPointy;
    } else if (equals_1(tmp0_subject, ManifoldType_FACE_B_getInstance())) {
      var pcLocalNormal_0 = pc._localNormal_1;
      var pcLocalPoint_0 = pc._localPoint_1;
      this._normal_6._x_7 = xfBq._c_0 * pcLocalNormal_0._x_7 - xfBq._s * pcLocalNormal_0._y_6;
      this._normal_6._y_6 = xfBq._s * pcLocalNormal_0._x_7 + xfBq._c_0 * pcLocalNormal_0._y_6;
      var planePointx_0 = xfBq._c_0 * pcLocalPoint_0._x_7 - xfBq._s * pcLocalPoint_0._y_6 + xfB._p_1._x_7;
      var planePointy_0 = xfBq._s * pcLocalPoint_0._x_7 + xfBq._c_0 * pcLocalPoint_0._y_6 + xfB._p_1._y_6;
      var clipPointx_0 = xfAq._c_0 * pcLocalPointsI._x_7 - xfAq._s * pcLocalPointsI._y_6 + xfA._p_1._x_7;
      var clipPointy_0 = xfAq._s * pcLocalPointsI._x_7 + xfAq._c_0 * pcLocalPointsI._y_6 + xfA._p_1._y_6;
      var tempx_1 = clipPointx_0 - planePointx_0;
      var tempy_1 = clipPointy_0 - planePointy_0;
      this._separation_1 = tempx_1 * this._normal_6._x_7 + tempy_1 * this._normal_6._y_6 - pc._radiusA - pc._radiusB;
      this._point_0._x_7 = clipPointx_0;
      this._point_0._y_6 = clipPointy_0;
      var tmp1_this = this._normal_6;
      tmp1_this._x_7 = tmp1_this._x_7 * -1.0;
      var tmp2_this = this._normal_6;
      tmp2_this._y_6 = tmp2_this._y_6 * -1.0;
    }};
  PositionSolverManifold.$metadata$ = {
    simpleName: 'PositionSolverManifold',
    kind: 'class',
    interfaces: []
  };
  function Velocity() {
    var tmp = this;
    tmp._v_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._w_2 = 0;
  }
  Velocity.$metadata$ = {
    simpleName: 'Velocity',
    kind: 'class',
    interfaces: []
  };
  function Companion_80() {
    Companion_instance_79 = this;
  }
  Companion_80.prototype.destroy_lmrdrw_k$ = function (joint) {
    joint.destructor_sv8swh_k$();
  };
  Companion_80.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_79;
  function Companion_getInstance_79() {
    if (Companion_instance_79 == null)
      new Companion_80();
    return Companion_instance_79;
  }
  function Arrays_sort(array, fromIndex, toIndex) {
    var sorted_0 = sortedArray(copyOfRange_0(array, fromIndex, toIndex));
    var tmp0_arraycopy_0 = toIndex - fromIndex | 0;
    var tmp0_copyInto_0_2_1 = 0 + tmp0_arraycopy_0 | 0;
    arrayCopy_0(sorted_0, array, fromIndex, 0, tmp0_copyInto_0_2_1);
    Unit_getInstance();
  }
  function Arrays_sort_0(array, fromIndex, toIndex) {
    var sorted_0 = sortedArray_0(copyOfRange_1(array, fromIndex, toIndex));
    var tmp0_arraycopy_0 = toIndex - fromIndex | 0;
    var tmp0_copyInto_0_2 = 0 + tmp0_arraycopy_0 | 0;
    arrayCopy_0(sorted_0, array, fromIndex, 0, tmp0_copyInto_0_2);
    Unit_getInstance();
  }
  function ParticleBodyContact() {
    this._index_11 = 0;
    this._body = null;
    this._weight_0 = 0;
    var tmp = this;
    tmp._normal_7 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._mass_0 = 0;
  }
  ParticleBodyContact.$metadata$ = {
    simpleName: 'ParticleBodyContact',
    kind: 'class',
    interfaces: []
  };
  function ParticleColor_init_$Init$($this) {
    ParticleColor.call($this);
    $this._r_0 = 127;
    $this._g = 127;
    $this._b_0 = 127;
    $this._a_3 = 50;
    return $this;
  }
  function ParticleColor_init_$Create$() {
    return ParticleColor_init_$Init$(Object.create(ParticleColor.prototype));
  }
  ParticleColor.prototype.set_lceezu_k$ = function (color_0) {
    this._r_0 = color_0._r_0;
    this._g = color_0._g;
    this._b_0 = color_0._b_0;
    this._a_3 = color_0._a_3;
  };
  function ParticleColor() {
    this._r_0 = 0;
    this._g = 0;
    this._b_0 = 0;
    this._a_3 = 0;
  }
  ParticleColor.$metadata$ = {
    simpleName: 'ParticleColor',
    kind: 'class',
    interfaces: []
  };
  function ParticleContact() {
    this._indexA_4 = 0;
    this._indexB_4 = 0;
    this._flags_0 = 0;
    this._weight_1 = 0;
    var tmp = this;
    tmp._normal_8 = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  ParticleContact.$metadata$ = {
    simpleName: 'ParticleContact',
    kind: 'class',
    interfaces: []
  };
  function ParticleDef() {
    this._$$delegate_0_6 = new Mixin_0();
    this._flags_1 = 0;
    var tmp = this;
    tmp._position_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._velocity = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._color_1 = null;
    this._userData_5 = null;
  }
  ParticleDef.$metadata$ = {
    simpleName: 'ParticleDef',
    kind: 'class',
    interfaces: [Box2dTypedUserData]
  };
  function ParticleGroupType() {
    ParticleGroupType_instance = this;
    this._b2_solidParticleGroup = 1;
    this._b2_rigidParticleGroup = 2;
  }
  ParticleGroupType.$metadata$ = {
    simpleName: 'ParticleGroupType',
    kind: 'object',
    interfaces: []
  };
  var ParticleGroupType_instance;
  function ParticleGroupType_getInstance() {
    if (ParticleGroupType_instance == null)
      new ParticleGroupType();
    return ParticleGroupType_instance;
  }
  function _no_name_provided__77() {
  }
  _no_name_provided__77.prototype.invoke_0_k$ = function () {
    return new ParticleBodyContact();
  };
  _no_name_provided__77.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function lowerBound($this, ray, length, tag) {
    var length_0 = length;
    var left = 0;
    var step_0;
    var curr;
    while (length_0 > 0) {
      step_0 = length_0 / 2 | 0;
      curr = left + step_0 | 0;
      if (ray[curr].tag__error.compareTo_wiekkq_k$(tag) < 0) {
        left = curr + 1 | 0;
        length_0 = length_0 - (step_0 + 1 | 0) | 0;
      } else {
        length_0 = step_0;
      }
    }
    return left;
  }
  function upperBound($this, ray, length, tag) {
    var length_0 = length;
    var left = 0;
    var step_0;
    var curr;
    while (length_0 > 0) {
      step_0 = length_0 / 2 | 0;
      curr = left + step_0 | 0;
      if (ray[curr].tag__error.compareTo_wiekkq_k$(tag) <= 0) {
        left = curr + 1 | 0;
        length_0 = length_0 - (step_0 + 1 | 0) | 0;
      } else {
        length_0 = step_0;
      }
    }
    return left;
  }
  function NewIndices() {
    this._start = 0;
    this._mid = 0;
    this._end = 0;
  }
  NewIndices.$metadata$ = {
    simpleName: 'NewIndices',
    kind: 'class',
    interfaces: []
  };
  function ParticleBuffer(dataClass) {
    this._dataClass = dataClass;
    this._data_12 = null;
    this._userSuppliedCapacity = 0;
  }
  ParticleBuffer.$metadata$ = {
    simpleName: 'ParticleBuffer',
    kind: 'class',
    interfaces: []
  };
  function ParticleBufferInt() {
    this._data_13 = null;
    this._userSuppliedCapacity_0 = 0;
  }
  ParticleBufferInt.$metadata$ = {
    simpleName: 'ParticleBufferInt',
    kind: 'class',
    interfaces: []
  };
  function CreateParticleGroupCallback() {
    this._system = null;
    this._def = null;
    this._firstIndex = 0;
  }
  CreateParticleGroupCallback.$metadata$ = {
    simpleName: 'CreateParticleGroupCallback',
    kind: 'class',
    interfaces: [VoronoiDiagramCallback]
  };
  function DestroyParticlesInShapeCallback() {
    this._callDestructionListener = false;
    this._destroyed = 0;
  }
  DestroyParticlesInShapeCallback.$metadata$ = {
    simpleName: 'DestroyParticlesInShapeCallback',
    kind: 'class',
    interfaces: [ParticleQueryCallback]
  };
  function UpdateBodyContactsCallback() {
    this._system_0 = null;
    var tmp = this;
    tmp._tempVec = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  UpdateBodyContactsCallback.prototype.reportFixture_zd7wjj_k$ = function (fixture) {
    if (fixture._get_isSensor__0_k$()) {
      return true;
    }var shape = fixture.getShape_0_k$();
    var b = fixture.getBody_0_k$();
    var bp = ensureNotNull(b)._get_worldCenter__0_k$();
    var bm = b.getMass_0_k$();
    var bI = b._get_inertia__0_k$() - bm * b._get_localCenter__0_k$().lengthSquared_0_k$();
    var invBm = bm > 0 ? 1.0 / bm : 0.0;
    var invBI = bI > 0 ? 1.0 / bI : 0.0;
    var childCount = ensureNotNull(shape).getChildCount_0_k$();
    var inductionVariable = 0;
    if (inductionVariable < childCount)
      do {
        var childIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var aabb = fixture.getAABB_ha5a7z_k$(childIndex);
        var aabblowerBoundx = aabb._lowerBound._x_7 - ensureNotNull(this._system_0)._m_particleDiameter;
        var aabblowerBoundy = aabb._lowerBound._y_6 - ensureNotNull(this._system_0)._m_particleDiameter;
        var aabbupperBoundx = aabb._upperBound._x_7 + ensureNotNull(this._system_0)._m_particleDiameter;
        var aabbupperBoundy = aabb._upperBound._y_6 + ensureNotNull(this._system_0)._m_particleDiameter;
        var firstProxy = lowerBound(Companion_getInstance_80(), ensureNotNull(this._system_0)._m_proxyBuffer, ensureNotNull(this._system_0)._m_proxyCount_0, Companion_getInstance_80().computeTag_rybm4g_k$(ensureNotNull(this._system_0)._m_inverseDiameter * aabblowerBoundx, ensureNotNull(this._system_0)._m_inverseDiameter * aabblowerBoundy));
        var lastProxy = upperBound(Companion_getInstance_80(), ensureNotNull(this._system_0)._m_proxyBuffer, ensureNotNull(this._system_0)._m_proxyCount_0, Companion_getInstance_80().computeTag_rybm4g_k$(ensureNotNull(this._system_0)._m_inverseDiameter * aabbupperBoundx, ensureNotNull(this._system_0)._m_inverseDiameter * aabbupperBoundy));
        var inductionVariable_0 = firstProxy;
        if (inductionVariable_0 < lastProxy)
          do {
            var proxy = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = ensureNotNull(this._system_0)._m_proxyBuffer[proxy].index__error;
            var ap = ensureNotNull(ensureNotNull(this._system_0)._m_positionBuffer._data_12)[a];
            if (((aabblowerBoundx <= ap._x_7 ? ap._x_7 <= aabbupperBoundx : false) ? aabblowerBoundy <= ap._y_6 : false) ? ap._y_6 <= aabbupperBoundy : false) {
              var d;
              var n = this._tempVec;
              d = fixture.computeDistance_7zj6nx_k$(ap, childIndex, n);
              if (d < ensureNotNull(this._system_0)._m_particleDiameter) {
                var invAm = !((ensureNotNull(ensureNotNull(this._system_0)._m_flagsBuffer._data_13)[a] & ParticleType_getInstance()._b2_wallParticle) === 0) ? 0.0 : ensureNotNull(ensureNotNull(this._system_0)._get_particleInvMass__0_k$());
                var rpx = ap._x_7 - bp._x_7;
                var rpy = ap._y_6 - bp._y_6;
                var rpn = rpx * n._y_6 - rpy * n._x_7;
                if (ensureNotNull(this._system_0)._m_bodyContactCount >= ensureNotNull(this._system_0)._m_bodyContactCapacity) {
                  var oldCapacity = ensureNotNull(this._system_0)._m_bodyContactCapacity;
                  var newCapacity = !(ensureNotNull(this._system_0)._m_bodyContactCount === 0) ? imul(2, ensureNotNull(this._system_0)._m_bodyContactCount) : Settings_getInstance()._minParticleBufferCapacity;
                  var tmp = ensureNotNull(this._system_0);
                  var tmp_0 = BufferUtils_getInstance();
                  tmp._m_bodyContactBuffer = tmp_0.reallocateBuffer_uahium_k$(_no_name_provided_$factory_63(), ensureNotNull(this._system_0)._m_bodyContactBuffer, oldCapacity, newCapacity);
                  ensureNotNull(this._system_0)._m_bodyContactCapacity = newCapacity;
                }var contact = ensureNotNull(this._system_0)._m_bodyContactBuffer[ensureNotNull(this._system_0)._m_bodyContactCount];
                contact._index_11 = a;
                contact._body = b;
                contact._weight_0 = 1 - d * ensureNotNull(this._system_0)._m_inverseDiameter;
                contact._normal_7._x_7 = -n._x_7;
                contact._normal_7._y_6 = -n._y_6;
                contact._mass_0 = 1 / (invAm + invBm + invBI * rpn * rpn);
                var tmp2_this = ensureNotNull(this._system_0);
                var tmp3 = tmp2_this._m_bodyContactCount;
                tmp2_this._m_bodyContactCount = tmp3 + 1 | 0;
                Unit_getInstance();
              }}}
           while (inductionVariable_0 < lastProxy);
      }
       while (inductionVariable < childCount);
    return true;
  };
  UpdateBodyContactsCallback.$metadata$ = {
    simpleName: 'UpdateBodyContactsCallback',
    kind: 'class',
    interfaces: [QueryCallback]
  };
  function SolveCollisionCallback() {
    this._system_1 = null;
    this._step_9 = null;
    this._input_2 = new RayCastInput();
    this._output_1 = new RayCastOutput();
    var tmp = this;
    tmp._tempVec_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    var tmp_0 = this;
    tmp_0._tempVec2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
  }
  SolveCollisionCallback.prototype.reportFixture_zd7wjj_k$ = function (fixture) {
    if (fixture._get_isSensor__0_k$()) {
      return true;
    }var shape = fixture.getShape_0_k$();
    var body = fixture.getBody_0_k$();
    var childCount = ensureNotNull(shape).getChildCount_0_k$();
    var inductionVariable = 0;
    if (inductionVariable < childCount)
      do {
        var childIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var aabb = fixture.getAABB_ha5a7z_k$(childIndex);
        var aabblowerBoundx = aabb._lowerBound._x_7 - ensureNotNull(this._system_1)._m_particleDiameter;
        var aabblowerBoundy = aabb._lowerBound._y_6 - ensureNotNull(this._system_1)._m_particleDiameter;
        var aabbupperBoundx = aabb._upperBound._x_7 + ensureNotNull(this._system_1)._m_particleDiameter;
        var aabbupperBoundy = aabb._upperBound._y_6 + ensureNotNull(this._system_1)._m_particleDiameter;
        var firstProxy = lowerBound(Companion_getInstance_80(), ensureNotNull(this._system_1)._m_proxyBuffer, ensureNotNull(this._system_1)._m_proxyCount_0, Companion_getInstance_80().computeTag_rybm4g_k$(ensureNotNull(this._system_1)._m_inverseDiameter * aabblowerBoundx, ensureNotNull(this._system_1)._m_inverseDiameter * aabblowerBoundy));
        var lastProxy = upperBound(Companion_getInstance_80(), ensureNotNull(this._system_1)._m_proxyBuffer, ensureNotNull(this._system_1)._m_proxyCount_0, Companion_getInstance_80().computeTag_rybm4g_k$(ensureNotNull(this._system_1)._m_inverseDiameter * aabbupperBoundx, ensureNotNull(this._system_1)._m_inverseDiameter * aabbupperBoundy));
        var inductionVariable_0 = firstProxy;
        if (inductionVariable_0 < lastProxy)
          do {
            var proxy = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = ensureNotNull(this._system_1)._m_proxyBuffer[proxy].index__error;
            var ap = ensureNotNull(ensureNotNull(this._system_1)._m_positionBuffer._data_12)[a];
            if (((aabblowerBoundx <= ap._x_7 ? ap._x_7 <= aabbupperBoundx : false) ? aabblowerBoundy <= ap._y_6 : false) ? ap._y_6 <= aabbupperBoundy : false) {
              var av = ensureNotNull(ensureNotNull(this._system_1)._m_velocityBuffer._data_12)[a];
              var temp_0 = this._tempVec_0;
              Companion_getInstance_70().mulTransToOutUnsafe_kg26ly_k$(ensureNotNull(body)._xf0, ap, temp_0);
              Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(body._xf_0, temp_0, this._input_2._p1);
              this._input_2._p2._x_7 = ap._x_7 + ensureNotNull(this._step_9)._dt * av._x_7;
              this._input_2._p2._y_6 = ap._y_6 + ensureNotNull(this._step_9)._dt * av._y_6;
              this._input_2._maxFraction = 1.0;
              if (fixture.raycast_vrsk3a_k$(this._output_1, this._input_2, childIndex)) {
                var p = this._tempVec_0;
                p._x_7 = (1 - this._output_1._fraction) * this._input_2._p1._x_7 + this._output_1._fraction * this._input_2._p2._x_7 + Settings_getInstance()._get_linearSlop__0_k$() * this._output_1._normal_1._x_7;
                p._y_6 = (1 - this._output_1._fraction) * this._input_2._p1._y_6 + this._output_1._fraction * this._input_2._p2._y_6 + Settings_getInstance()._get_linearSlop__0_k$() * this._output_1._normal_1._y_6;
                var vx = ensureNotNull(this._step_9)._inv_dt * (p._x_7 - ap._x_7);
                var vy = ensureNotNull(this._step_9)._inv_dt * (p._y_6 - ap._y_6);
                av._x_7 = vx;
                av._y_6 = vy;
                var particleMass = ensureNotNull(this._system_1)._get_particleMass__0_k$();
                var ax = particleMass * (av._x_7 - vx);
                var ay = particleMass * (av._y_6 - vy);
                var b = this._output_1._normal_1;
                var fdn = ax * b._x_7 + ay * b._y_6;
                var f = this._tempVec2;
                f._x_7 = fdn * b._x_7;
                f._y_6 = fdn * b._y_6;
                body.applyLinearImpulse_gzag95_k$(f, p, true);
              }}}
           while (inductionVariable_0 < lastProxy);
      }
       while (inductionVariable < childCount);
    return true;
  };
  SolveCollisionCallback.$metadata$ = {
    simpleName: 'SolveCollisionCallback',
    kind: 'class',
    interfaces: [QueryCallback]
  };
  function Test() {
    Test_instance = this;
  }
  Test.prototype.IsProxyInvalid_7b3mxk_k$ = function (proxy) {
    return proxy.index__error < 0;
  };
  Test.prototype.IsContactInvalid_k1mkdg_k$ = function (contact) {
    return contact._indexA_4 < 0 ? true : contact._indexB_4 < 0;
  };
  Test.prototype.IsBodyContactInvalid_p5qsm6_k$ = function (contact) {
    return contact._index_11 < 0;
  };
  Test.prototype.IsPairInvalid_u0tc1c_k$ = function (pair) {
    return pair.indexA__error < 0 ? true : pair.indexB__error < 0;
  };
  Test.prototype.IsTriadInvalid_7daoag_k$ = function (triad) {
    return (triad.indexA__error < 0 ? true : triad.indexB__error < 0) ? true : triad.indexC__error < 0;
  };
  Test.$metadata$ = {
    simpleName: 'Test',
    kind: 'object',
    interfaces: []
  };
  var Test_instance;
  function Test_getInstance() {
    if (Test_instance == null)
      new Test();
    return Test_instance;
  }
  function Companion_81() {
    Companion_instance_80 = this;
    this._k_pairFlags = ParticleType_getInstance()._b2_springParticle;
    this._k_triadFlags = ParticleType_getInstance()._b2_elasticParticle;
    this._k_noPressureFlags = ParticleType_getInstance()._b2_powderParticle;
    this._xTruncBits = 12;
    this._yTruncBits = 12;
    this._tagBits = 31;
    this._yOffset = toLong(1 << (this._yTruncBits - 1 | 0));
    this._yShift = this._tagBits - this._yTruncBits | 0;
    this._xShift = (this._tagBits - this._yTruncBits | 0) - this._xTruncBits | 0;
    this._xScale = toLong(1 << this._xShift);
    var tmp = this;
    var tmp0_times_0 = this._xScale;
    var tmp1_times_0 = 1 << (this._xTruncBits - 1 | 0);
    tmp._xOffset = tmp0_times_0.times_wiekkq_k$(toLong(tmp1_times_0));
    this._xMask = (1 << this._xTruncBits) - 1 | 0;
    this._yMask = (1 << this._yTruncBits) - 1 | 0;
  }
  Companion_81.prototype.computeTag_rybm4g_k$ = function (x, y) {
    var tmp = numberToLong(y + this._yOffset.toFloat_0_k$()).shl_ha5a7z_k$(this._yShift);
    var tmp0_times_0 = this._xScale;
    return tmp.plus_wiekkq_k$(numberToLong(tmp0_times_0.toFloat_0_k$() * x).plus_wiekkq_k$(this._xOffset));
  };
  Companion_81.prototype.computeRelativeTag_b914za_k$ = function (tag, x, y) {
    return tag.plus_wiekkq_k$(toLong(y << this._yShift)).plus_wiekkq_k$(toLong(x << this._xShift));
  };
  Companion_81.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_80;
  function Companion_getInstance_80() {
    if (Companion_instance_80 == null)
      new Companion_81();
    return Companion_instance_80;
  }
  function _no_name_provided__78() {
  }
  _no_name_provided__78.prototype.invoke_0_k$ = function () {
    return Vec2_init_$Create$(0.0, 0.0, 3, null);
  };
  _no_name_provided__78.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__79() {
  }
  _no_name_provided__79.prototype.invoke_0_k$ = function () {
    return Vec2_init_$Create$(0.0, 0.0, 3, null);
  };
  _no_name_provided__79.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__80() {
  }
  _no_name_provided__80.prototype.invoke_0_k$ = function () {
    return ParticleColor_init_$Create$();
  };
  _no_name_provided__80.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__81() {
  }
  _no_name_provided__81.prototype.invoke_0_k$ = function () {
    return new Object();
  };
  _no_name_provided__81.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__82() {
  }
  _no_name_provided__82.prototype.invoke_0_k$ = function () {
    return new ParticleContact();
  };
  _no_name_provided__82.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__83() {
  }
  _no_name_provided__83.prototype.invoke_0_k$ = function () {
    return Vec2_init_$Create$(0.0, 0.0, 3, null);
  };
  _no_name_provided__83.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__84() {
  }
  _no_name_provided__84.prototype.invoke_0_k$ = function () {
    return ParticleColor_init_$Create$();
  };
  _no_name_provided__84.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ParticleSystem(m_world) {
    Companion_getInstance_80();
    this._m_world = m_world;
    this._m_timestamp = 0;
    this._m_allParticleFlags = 0;
    this._m_allGroupFlags = 0;
    this._m_density_0 = 1.0;
    this._m_inverseDensity = 1.0;
    this._particleGravityScale = 1.0;
    this._m_particleDiameter = 1.0;
    this._m_inverseDiameter = 1.0;
    this._m_squaredDiameter = 1.0;
    this._particleCount = 0;
    this._m_internalAllocatedCapacity = 0;
    this._m_maxCount = 0;
    this._m_flagsBuffer = new ParticleBufferInt();
    var tmp = this;
    tmp._m_positionBuffer = new ParticleBuffer(_no_name_provided_$factory_56());
    var tmp_0 = this;
    tmp_0._m_velocityBuffer = new ParticleBuffer(_no_name_provided_$factory_57());
    this._m_accumulationBuffer = new Float32Array(0);
    var tmp_1 = this;
    tmp_1._m_accumulation2Buffer = [];
    this._m_depthBuffer = null;
    var tmp_2 = this;
    tmp_2._m_colorBuffer = new ParticleBuffer(_no_name_provided_$factory_58());
    var tmp_3 = this;
    tmp_3._particleGroupBuffer = [];
    var tmp_4 = this;
    tmp_4._m_userDataBuffer = new ParticleBuffer(_no_name_provided_$factory_59());
    this._m_proxyCount_0 = 0;
    this._m_proxyCapacity = 0;
    var tmp_5 = this;
    tmp_5._m_proxyBuffer = [];
    this._m_contactCount_1 = 0;
    this._m_contactCapacity_0 = 0;
    var tmp_6 = this;
    tmp_6._m_contactBuffer = [];
    this._m_bodyContactCount = 0;
    this._m_bodyContactCapacity = 0;
    var tmp_7 = this;
    tmp_7._m_bodyContactBuffer = [];
    this._m_pairCount_0 = 0;
    this._m_pairCapacity_0 = 0;
    var tmp_8 = this;
    tmp_8._m_pairBuffer_0 = [];
    this._m_triadCount = 0;
    this._m_triadCapacity = 0;
    var tmp_9 = this;
    tmp_9._m_triadBuffer = [];
    this._particleGroupCount = 0;
    this._m_groupList = null;
    this._m_pressureStrength = 0.05;
    this._particleDamping = 1.0;
    this._m_elasticStrength = 0.25;
    this._m_springStrength = 0.25;
    this._m_viscousStrength = 0.25;
    this._m_surfaceTensionStrengthA = 0.1;
    this._m_surfaceTensionStrengthB = 0.2;
    this._m_powderStrength = 0.5;
    this._m_ejectionStrength = 0.5;
    this._m_colorMixingStrength = 0.5;
    this._temp_5 = AABB_init_$Create$();
    this._dpcallback = new DestroyParticlesInShapeCallback();
    this._temp2 = AABB_init_$Create$();
    var tmp_10 = this;
    tmp_10._tempVec_1 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._tempTransform = Transform_init_$Create$_0();
    this._tempTransform2 = Transform_init_$Create$_0();
    this._createParticleGroupCallback = new CreateParticleGroupCallback();
    this._tempParticleDef = new ParticleDef();
    this._ubccallback = new UpdateBodyContactsCallback();
    this._sccallback = new SolveCollisionCallback();
    var tmp_11 = this;
    tmp_11._tempVec2_0 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._tempRot = Rot_init_$Create$();
    this._tempXf = Transform_init_$Create$_0();
    this._tempXf2 = Transform_init_$Create$_0();
    this._newIndices = new NewIndices();
  }
  ParticleSystem.prototype._get_particleStride__0_k$ = function () {
    return Settings_getInstance()._particleStride * this._m_particleDiameter;
  };
  ParticleSystem.prototype._get_particleMass__0_k$ = function () {
    var stride = this._get_particleStride__0_k$();
    return this._m_density_0 * stride * stride;
  };
  ParticleSystem.prototype._get_particleInvMass__0_k$ = function () {
    return 1.777777 * this._m_inverseDensity * this._m_inverseDiameter * this._m_inverseDiameter;
  };
  ParticleSystem.prototype.destroyParticleGroup_1ockol_k$ = function (group) {
    var tmp0_assert_0 = this._particleGroupCount > 0;
    if (!tmp0_assert_0) {
      var message_2_1_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
    }var tmp1_assert_0 = !(group == null);
    if (!tmp1_assert_0) {
      var message_2_1_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1_0));
    }if (!(this._m_world._particleDestructionListener == null)) {
      ensureNotNull(this._m_world._particleDestructionListener).sayGoodbye_5icem_k$(ensureNotNull(group));
    }var inductionVariable = ensureNotNull(group).m_firstIndex__error;
    var last_1 = group.m_lastIndex__error;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        ensureNotNull(this._particleGroupBuffer)[i] = null;
      }
       while (inductionVariable < last_1);
    if (!(group.m_prev__error == null)) {
      ensureNotNull(group.m_prev__error).m_next__error = group.m_next__error;
    }if (!(group.m_next__error == null)) {
      ensureNotNull(group.m_next__error).m_prev__error = group.m_prev__error;
    }if (equals_1(group, this._m_groupList)) {
      this._m_groupList = group.m_next__error;
    }var tmp1_this = this;
    tmp1_this._particleGroupCount = tmp1_this._particleGroupCount - 1 | 0;
    Unit_getInstance();
  };
  ParticleSystem.prototype.addContact_rvwcgf_k$ = function (a, b) {
    var tmp0_assert_0 = !(a === b);
    if (!tmp0_assert_0) {
      var message_2_1_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
    }var pa = ensureNotNull(this._m_positionBuffer._data_12)[a];
    var pb = ensureNotNull(this._m_positionBuffer._data_12)[b];
    var dx = pb._x_7 - pa._x_7;
    var dy = pb._y_6 - pa._y_6;
    var d2 = dx * dx + dy * dy;
    if (d2 < this._m_squaredDiameter) {
      if (this._m_contactCount_1 >= this._m_contactCapacity_0) {
        var oldCapacity = this._m_contactCapacity_0;
        var newCapacity = !(this._m_contactCount_1 === 0) ? imul(2, this._m_contactCount_1) : Settings_getInstance()._minParticleBufferCapacity;
        var tmp = this;
        var tmp_0 = BufferUtils_getInstance();
        tmp._m_contactBuffer = tmp_0.reallocateBuffer_uahium_k$(_no_name_provided_$factory_60(), this._m_contactBuffer, oldCapacity, newCapacity);
        this._m_contactCapacity_0 = newCapacity;
      }var tmp_1;
      if (!(d2 === 0.0)) {
        tmp_1 = Companion_getInstance_68().sqrt_dbmacu_k$(1 / d2);
      } else {
        FloatCompanionObject_getInstance();
        tmp_1 = 3.4028235E38;
      }
      var invD = tmp_1;
      var contact = this._m_contactBuffer[this._m_contactCount_1];
      contact._indexA_4 = a;
      contact._indexB_4 = b;
      contact._flags_0 = ensureNotNull(this._m_flagsBuffer._data_13)[a] | ensureNotNull(this._m_flagsBuffer._data_13)[b];
      contact._weight_1 = 1 - d2 * invD * this._m_inverseDiameter;
      contact._normal_8._x_7 = invD * dx;
      contact._normal_8._y_6 = invD * dy;
      var tmp0_this = this;
      var tmp1 = tmp0_this._m_contactCount_1;
      tmp0_this._m_contactCount_1 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  ParticleSystem.prototype.updateContacts_rpwsgn_k$ = function (exceptZombie) {
    var inductionVariable = 0;
    var last_1 = this._m_proxyCount_0;
    if (inductionVariable < last_1)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var proxy = this._m_proxyBuffer[p];
        var i = proxy.index__error;
        var pos = ensureNotNull(this._m_positionBuffer._data_12)[i];
        proxy.tag__error = Companion_getInstance_80().computeTag_rybm4g_k$(this._m_inverseDiameter * pos._x_7, this._m_inverseDiameter * pos._y_6);
      }
       while (inductionVariable < last_1);
    Arrays_sort(this._m_proxyBuffer, 0, this._m_proxyCount_0);
    this._m_contactCount_1 = 0;
    var c_index = 0;
    var inductionVariable_0 = 0;
    var last_2 = this._m_proxyCount_0;
    if (inductionVariable_0 < last_2)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var a = this._m_proxyBuffer[i_0];
        var rightTag = Companion_getInstance_80().computeRelativeTag_b914za_k$(a.tag__error, 1, 0);
        var inductionVariable_1 = i_0 + 1 | 0;
        var last_3 = this._m_proxyCount_0;
        if (inductionVariable_1 < last_3)
          $l$break: do {
            var j = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var b = this._m_proxyBuffer[j];
            if (rightTag.compareTo_wiekkq_k$(b.tag__error) < 0) {
              break $l$break;
            }this.addContact_rvwcgf_k$(a.index__error, b.index__error);
          }
           while (inductionVariable_1 < last_3);
        var bottomLeftTag = Companion_getInstance_80().computeRelativeTag_b914za_k$(a.tag__error, -1, 1);
        $l$break_0: while (c_index < this._m_proxyCount_0) {
          var c = this._m_proxyBuffer[c_index];
          if (bottomLeftTag.compareTo_wiekkq_k$(c.tag__error) <= 0) {
            break $l$break_0;
          }var tmp3 = c_index;
          c_index = tmp3 + 1 | 0;
          Unit_getInstance();
        }
        var bottomRightTag = Companion_getInstance_80().computeRelativeTag_b914za_k$(a.tag__error, 1, 1);
        var inductionVariable_2 = c_index;
        var last_4 = this._m_proxyCount_0;
        if (inductionVariable_2 < last_4)
          $l$break_1: do {
            var b_index = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var b_0 = this._m_proxyBuffer[b_index];
            if (bottomRightTag.compareTo_wiekkq_k$(b_0.tag__error) < 0) {
              break $l$break_1;
            }this.addContact_rvwcgf_k$(a.index__error, b_0.index__error);
          }
           while (inductionVariable_2 < last_4);
      }
       while (inductionVariable_0 < last_2);
    if (exceptZombie) {
      var j_0 = this._m_contactCount_1;
      var i_1 = 0;
      while (i_1 < j_0) {
        if (!((this._m_contactBuffer[i_1]._flags_0 & ParticleType_getInstance()._b2_zombieParticle) === 0)) {
          j_0 = j_0 - 1 | 0;
          Unit_getInstance();
          var temp_0 = this._m_contactBuffer[j_0];
          this._m_contactBuffer[j_0] = this._m_contactBuffer[i_1];
          this._m_contactBuffer[i_1] = temp_0;
          i_1 = i_1 - 1 | 0;
          Unit_getInstance();
        }var tmp5 = i_1;
        i_1 = tmp5 + 1 | 0;
        Unit_getInstance();
      }
      this._m_contactCount_1 = j_0;
    }};
  ParticleSystem.prototype.updateBodyContacts_sv8swh_k$ = function () {
    var aabb = this._temp_5;
    var tmp = aabb._lowerBound;
    FloatCompanionObject_getInstance();
    tmp._x_7 = 3.4028235E38;
    var tmp_0 = aabb._lowerBound;
    FloatCompanionObject_getInstance();
    tmp_0._y_6 = 3.4028235E38;
    var tmp_1 = aabb._upperBound;
    FloatCompanionObject_getInstance();
    tmp_1._x_7 = -3.4028235E38;
    var tmp_2 = aabb._upperBound;
    FloatCompanionObject_getInstance();
    tmp_2._y_6 = -3.4028235E38;
    var inductionVariable = 0;
    var last_1 = this._particleCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var p = ensureNotNull(this._m_positionBuffer._data_12)[i];
        Companion_getInstance_71().minToOut_ly9802_k$(aabb._lowerBound, p, aabb._lowerBound);
        Companion_getInstance_71().maxToOut_ly9802_k$(aabb._upperBound, p, aabb._upperBound);
      }
       while (inductionVariable < last_1);
    var tmp1_this = aabb._lowerBound;
    tmp1_this._x_7 = tmp1_this._x_7 - this._m_particleDiameter;
    var tmp2_this = aabb._lowerBound;
    tmp2_this._y_6 = tmp2_this._y_6 - this._m_particleDiameter;
    var tmp3_this = aabb._upperBound;
    tmp3_this._x_7 = tmp3_this._x_7 + this._m_particleDiameter;
    var tmp4_this = aabb._upperBound;
    tmp4_this._y_6 = tmp4_this._y_6 + this._m_particleDiameter;
    this._m_bodyContactCount = 0;
    this._ubccallback._system_0 = this;
    this._m_world.queryAABB_9v5ah4_k$(this._ubccallback, aabb);
  };
  ParticleSystem.prototype.solveCollision_zeyqa8_k$ = function (step_0) {
    var aabb = this._temp_5;
    var lowerBound_0 = aabb._lowerBound;
    var upperBound_0 = aabb._upperBound;
    var tmp = lowerBound_0;
    FloatCompanionObject_getInstance();
    tmp._x_7 = 3.4028235E38;
    var tmp_0 = lowerBound_0;
    FloatCompanionObject_getInstance();
    tmp_0._y_6 = 3.4028235E38;
    var tmp_1 = upperBound_0;
    FloatCompanionObject_getInstance();
    tmp_1._x_7 = -3.4028235E38;
    var tmp_2 = upperBound_0;
    FloatCompanionObject_getInstance();
    tmp_2._y_6 = -3.4028235E38;
    var inductionVariable = 0;
    var last_1 = this._particleCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = ensureNotNull(this._m_velocityBuffer._data_12)[i];
        var p1 = ensureNotNull(this._m_positionBuffer._data_12)[i];
        var p1x = p1._x_7;
        var p1y = p1._y_6;
        var p2x = p1x + step_0._dt * v._x_7;
        var p2y = p1y + step_0._dt * v._y_6;
        var bx = p1x < p2x ? p1x : p2x;
        var by = p1y < p2y ? p1y : p2y;
        lowerBound_0._x_7 = lowerBound_0._x_7 < bx ? lowerBound_0._x_7 : bx;
        lowerBound_0._y_6 = lowerBound_0._y_6 < by ? lowerBound_0._y_6 : by;
        var b1x = p1x > p2x ? p1x : p2x;
        var b1y = p1y > p2y ? p1y : p2y;
        upperBound_0._x_7 = upperBound_0._x_7 > b1x ? upperBound_0._x_7 : b1x;
        upperBound_0._y_6 = upperBound_0._y_6 > b1y ? upperBound_0._y_6 : b1y;
      }
       while (inductionVariable < last_1);
    this._sccallback._step_9 = step_0;
    this._sccallback._system_1 = this;
    this._m_world.queryAABB_9v5ah4_k$(this._sccallback, aabb);
  };
  ParticleSystem.prototype.solve_zeyqa8_k$ = function (step_0) {
    var tmp0_this = this;
    tmp0_this._m_timestamp = tmp0_this._m_timestamp + 1 | 0;
    Unit_getInstance();
    if (this._particleCount === 0) {
      return Unit_getInstance();
    }this._m_allParticleFlags = 0;
    var inductionVariable = 0;
    var last_1 = this._particleCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._m_allParticleFlags = this._m_allParticleFlags | ensureNotNull(this._m_flagsBuffer._data_13)[i];
      }
       while (inductionVariable < last_1);
    if (!((this._m_allParticleFlags & ParticleType_getInstance()._b2_zombieParticle) === 0)) {
      this.solveZombie_sv8swh_k$();
    }if (this._particleCount === 0) {
      return Unit_getInstance();
    }this._m_allGroupFlags = 0;
    var group = this._m_groupList;
    while (!(group == null)) {
      this._m_allGroupFlags = this._m_allGroupFlags | group.m_groupFlags__error;
      group = group.getNext_0_k$();
    }
    var gravityx = step_0._dt * this._particleGravityScale * this._m_world._gravity._x_7;
    var gravityy = step_0._dt * this._particleGravityScale * this._m_world._gravity._y_6;
    var criticalVelocytySquared = this.getCriticalVelocitySquared_bzpqkh_k$(step_0);
    var inductionVariable_0 = 0;
    var last_2 = this._particleCount;
    if (inductionVariable_0 < last_2)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var v = ensureNotNull(this._m_velocityBuffer._data_12)[i_0];
        var tmp3_this = v;
        tmp3_this._x_7 = tmp3_this._x_7 + gravityx;
        var tmp4_this = v;
        tmp4_this._y_6 = tmp4_this._y_6 + gravityy;
        var v2 = v._x_7 * v._x_7 + v._y_6 * v._y_6;
        if (v2 > criticalVelocytySquared) {
          var tmp;
          if (v2 === 0.0) {
            FloatCompanionObject_getInstance();
            tmp = 3.4028235E38;
          } else {
            tmp = Companion_getInstance_68().sqrt_dbmacu_k$(criticalVelocytySquared / v2);
          }
          var a = tmp;
          var tmp5_this = v;
          tmp5_this._x_7 = tmp5_this._x_7 * a;
          var tmp6_this = v;
          tmp6_this._y_6 = tmp6_this._y_6 * a;
        }}
       while (inductionVariable_0 < last_2);
    this.solveCollision_zeyqa8_k$(step_0);
    if (!((this._m_allGroupFlags & ParticleGroupType_getInstance()._b2_rigidParticleGroup) === 0)) {
      this.solveRigid_zeyqa8_k$(step_0);
    }if (!((this._m_allParticleFlags & ParticleType_getInstance()._b2_wallParticle) === 0)) {
      this.solveWall_zeyqa8_k$(step_0);
    }var inductionVariable_1 = 0;
    var last_3 = this._particleCount;
    if (inductionVariable_1 < last_3)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var pos = ensureNotNull(this._m_positionBuffer._data_12)[i_1];
        var vel = ensureNotNull(this._m_velocityBuffer._data_12)[i_1];
        var tmp8_this = pos;
        tmp8_this._x_7 = tmp8_this._x_7 + step_0._dt * vel._x_7;
        var tmp9_this = pos;
        tmp9_this._y_6 = tmp9_this._y_6 + step_0._dt * vel._y_6;
      }
       while (inductionVariable_1 < last_3);
    this.updateBodyContacts_sv8swh_k$();
    this.updateContacts_rpwsgn_k$(false);
    if (!((this._m_allParticleFlags & ParticleType_getInstance()._b2_viscousParticle) === 0)) {
      this.solveViscous_zeyqa8_k$(step_0);
    }if (!((this._m_allParticleFlags & ParticleType_getInstance()._b2_powderParticle) === 0)) {
      this.solvePowder_zeyqa8_k$(step_0);
    }if (!((this._m_allParticleFlags & ParticleType_getInstance()._b2_tensileParticle) === 0)) {
      this.solveTensile_zeyqa8_k$(step_0);
    }if (!((this._m_allParticleFlags & ParticleType_getInstance()._b2_elasticParticle) === 0)) {
      this.solveElastic_zeyqa8_k$(step_0);
    }if (!((this._m_allParticleFlags & ParticleType_getInstance()._b2_springParticle) === 0)) {
      this.solveSpring_zeyqa8_k$(step_0);
    }if (!((this._m_allGroupFlags & ParticleGroupType_getInstance()._b2_solidParticleGroup) === 0)) {
      this.solveSolid_zeyqa8_k$(step_0);
    }if (!((this._m_allParticleFlags & ParticleType_getInstance()._b2_colorMixingParticle) === 0)) {
      this.solveColorMixing_zeyqa8_k$(step_0);
    }this.solvePressure_zeyqa8_k$(step_0);
    this.solveDamping_zeyqa8_k$(step_0);
  };
  ParticleSystem.prototype.solvePressure_zeyqa8_k$ = function (step_0) {
    var inductionVariable = 0;
    var last_1 = this._particleCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._m_accumulationBuffer[i] = 0.0;
      }
       while (inductionVariable < last_1);
    var inductionVariable_0 = 0;
    var last_2 = this._m_bodyContactCount;
    if (inductionVariable_0 < last_2)
      do {
        var k = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var contact = this._m_bodyContactBuffer[k];
        var a = contact._index_11;
        var w = contact._weight_0;
        var tmp2_array = this._m_accumulationBuffer;
        var tmp3_index0 = a;
        tmp2_array[tmp3_index0] = tmp2_array[tmp3_index0] + w;
      }
       while (inductionVariable_0 < last_2);
    var inductionVariable_1 = 0;
    var last_3 = this._m_contactCount_1;
    if (inductionVariable_1 < last_3)
      do {
        var k_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var contact_0 = this._m_contactBuffer[k_0];
        var a_0 = contact_0._indexA_4;
        var b = contact_0._indexB_4;
        var w_0 = contact_0._weight_1;
        var tmp5_array = this._m_accumulationBuffer;
        var tmp6_index0 = a_0;
        tmp5_array[tmp6_index0] = tmp5_array[tmp6_index0] + w_0;
        var tmp7_array = this._m_accumulationBuffer;
        var tmp8_index0 = b;
        tmp7_array[tmp8_index0] = tmp7_array[tmp8_index0] + w_0;
      }
       while (inductionVariable_1 < last_3);
    if (!((this._m_allParticleFlags & Companion_getInstance_80()._k_noPressureFlags) === 0)) {
      var inductionVariable_2 = 0;
      var last_4 = this._particleCount;
      if (inductionVariable_2 < last_4)
        do {
          var i_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          if (!((ensureNotNull(this._m_flagsBuffer._data_13)[i_0] & Companion_getInstance_80()._k_noPressureFlags) === 0)) {
            this._m_accumulationBuffer[i_0] = 0.0;
          }}
         while (inductionVariable_2 < last_4);
    }var pressurePerWeight = this._m_pressureStrength * this.getCriticalPressure_bzpqkh_k$(step_0);
    var inductionVariable_3 = 0;
    var last_5 = this._particleCount;
    if (inductionVariable_3 < last_5)
      do {
        var i_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var w_1 = ensureNotNull(this._m_accumulationBuffer)[i_1];
        var h = pressurePerWeight * Companion_getInstance_68().max_rybm4g_k$(0.0, Companion_getInstance_68().min_rybm4g_k$(w_1, Settings_getInstance()._maxParticleWeight) - Settings_getInstance()._minParticleWeight);
        this._m_accumulationBuffer[i_1] = h;
      }
       while (inductionVariable_3 < last_5);
    var velocityPerPressure = step_0._dt / (this._m_density_0 * this._m_particleDiameter);
    var inductionVariable_4 = 0;
    var last_6 = this._m_bodyContactCount;
    if (inductionVariable_4 < last_6)
      do {
        var k_1 = inductionVariable_4;
        inductionVariable_4 = inductionVariable_4 + 1 | 0;
        var contact_1 = this._m_bodyContactBuffer[k_1];
        var a_1 = contact_1._index_11;
        var b_0 = contact_1._body;
        var w_2 = contact_1._weight_0;
        var m = contact_1._mass_0;
        var n = contact_1._normal_7;
        var p = ensureNotNull(this._m_positionBuffer._data_12)[a_1];
        var h_0 = ensureNotNull(this._m_accumulationBuffer)[a_1] + pressurePerWeight * w_2;
        var f = this._tempVec_1;
        var coef = velocityPerPressure * w_2 * m * h_0;
        f._x_7 = coef * n._x_7;
        f._y_6 = coef * n._y_6;
        var velData = ensureNotNull(this._m_velocityBuffer._data_12)[a_1];
        var particleInvMass = this._get_particleInvMass__0_k$();
        var tmp12_this = velData;
        tmp12_this._x_7 = tmp12_this._x_7 - particleInvMass * f._x_7;
        var tmp13_this = velData;
        tmp13_this._y_6 = tmp13_this._y_6 - particleInvMass * f._y_6;
        ensureNotNull(b_0).applyLinearImpulse_gzag95_k$(f, p, true);
      }
       while (inductionVariable_4 < last_6);
    var inductionVariable_5 = 0;
    var last_7 = this._m_contactCount_1;
    if (inductionVariable_5 < last_7)
      do {
        var k_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + 1 | 0;
        var contact_2 = this._m_contactBuffer[k_2];
        var a_2 = contact_2._indexA_4;
        var b_1 = contact_2._indexB_4;
        var w_3 = contact_2._weight_1;
        var n_0 = contact_2._normal_8;
        var h_1 = ensureNotNull(this._m_accumulationBuffer)[a_2] + ensureNotNull(this._m_accumulationBuffer)[b_1];
        var fx = velocityPerPressure * w_3 * h_1 * n_0._x_7;
        var fy = velocityPerPressure * w_3 * h_1 * n_0._y_6;
        var velDataA = ensureNotNull(this._m_velocityBuffer._data_12)[a_2];
        var velDataB = ensureNotNull(this._m_velocityBuffer._data_12)[b_1];
        var tmp15_this = velDataA;
        tmp15_this._x_7 = tmp15_this._x_7 - fx;
        var tmp16_this = velDataA;
        tmp16_this._y_6 = tmp16_this._y_6 - fy;
        var tmp17_this = velDataB;
        tmp17_this._x_7 = tmp17_this._x_7 + fx;
        var tmp18_this = velDataB;
        tmp18_this._y_6 = tmp18_this._y_6 + fy;
      }
       while (inductionVariable_5 < last_7);
  };
  ParticleSystem.prototype.solveDamping_zeyqa8_k$ = function (step_0) {
    var damping = this._particleDamping;
    var inductionVariable = 0;
    var last_1 = this._m_bodyContactCount;
    if (inductionVariable < last_1)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var contact = this._m_bodyContactBuffer[k];
        var a = contact._index_11;
        var b = contact._body;
        var w = contact._weight_0;
        var m = contact._mass_0;
        var n = contact._normal_7;
        var p = ensureNotNull(this._m_positionBuffer._data_12)[a];
        var tempX = p._x_7 - ensureNotNull(b)._sweep._c_1._x_7;
        var tempY = p._y_6 - ensureNotNull(b)._sweep._c_1._y_6;
        var velA = ensureNotNull(this._m_velocityBuffer._data_12)[a];
        var vx = -ensureNotNull(b).__angularVelocity * tempY + ensureNotNull(b).__linearVelocity._x_7 - velA._x_7;
        var vy = ensureNotNull(b).__angularVelocity * tempX + ensureNotNull(b).__linearVelocity._y_6 - velA._y_6;
        var vn = vx * n._x_7 + vy * n._y_6;
        if (vn < 0) {
          var f = this._tempVec_1;
          f._x_7 = damping * w * m * vn * n._x_7;
          f._y_6 = damping * w * m * vn * n._y_6;
          var invMass = this._get_particleInvMass__0_k$();
          var tmp1_this = velA;
          tmp1_this._x_7 = tmp1_this._x_7 + invMass * f._x_7;
          var tmp2_this = velA;
          tmp2_this._y_6 = tmp2_this._y_6 + invMass * f._y_6;
          f._x_7 = -f._x_7;
          f._y_6 = -f._y_6;
          ensureNotNull(b).applyLinearImpulse_gzag95_k$(f, p, true);
        }}
       while (inductionVariable < last_1);
    var inductionVariable_0 = 0;
    var last_2 = this._m_contactCount_1;
    if (inductionVariable_0 < last_2)
      do {
        var k_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var contact_0 = this._m_contactBuffer[k_0];
        var a_0 = contact_0._indexA_4;
        var b_0 = contact_0._indexB_4;
        var w_0 = contact_0._weight_1;
        var n_0 = contact_0._normal_8;
        var velA_0 = ensureNotNull(this._m_velocityBuffer._data_12)[a_0];
        var velB = ensureNotNull(this._m_velocityBuffer._data_12)[b_0];
        var vx_0 = velB._x_7 - velA_0._x_7;
        var vy_0 = velB._y_6 - velA_0._y_6;
        var vn_0 = vx_0 * n_0._x_7 + vy_0 * n_0._y_6;
        if (vn_0 < 0) {
          var fx = damping * w_0 * vn_0 * n_0._x_7;
          var fy = damping * w_0 * vn_0 * n_0._y_6;
          var tmp4_this = velA_0;
          tmp4_this._x_7 = tmp4_this._x_7 + fx;
          var tmp5_this = velA_0;
          tmp5_this._y_6 = tmp5_this._y_6 + fy;
          var tmp6_this = velB;
          tmp6_this._x_7 = tmp6_this._x_7 - fx;
          var tmp7_this = velB;
          tmp7_this._y_6 = tmp7_this._y_6 - fy;
        }}
       while (inductionVariable_0 < last_2);
  };
  ParticleSystem.prototype.solveWall_zeyqa8_k$ = function (step_0) {
    var inductionVariable = 0;
    var last_1 = this._particleCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!((ensureNotNull(this._m_flagsBuffer._data_13)[i] & ParticleType_getInstance()._b2_wallParticle) === 0)) {
          var r = ensureNotNull(this._m_velocityBuffer._data_12)[i];
          r._x_7 = 0.0;
          r._y_6 = 0.0;
        }}
       while (inductionVariable < last_1);
  };
  ParticleSystem.prototype.solveRigid_zeyqa8_k$ = function (step_0) {
    var group = this._m_groupList;
    while (!(group == null)) {
      if (!((group.m_groupFlags__error & ParticleGroupType_getInstance()._b2_rigidParticleGroup) === 0)) {
        group.updateStatistics_sv8swh_k$();
        var temp_0 = this._tempVec_1;
        var cross = this._tempVec2_0;
        var rotation_0 = this._tempRot;
        rotation_0.setRadians_dbmacu_k$(step_0._dt * group.m_angularVelocity__error);
        Unit_getInstance();
        Companion_getInstance_69().mulToOutUnsafe_6ywscr_k$(rotation_0, group.m_center__error, cross);
        temp_0.set_1v0asv_k$(group.m_linearVelocity__error).mulLocal_dbmacu_k$(step_0._dt).addLocal_1v0asv_k$(group.m_center__error).subLocal_1v0asv_k$(cross);
        Unit_getInstance();
        this._tempXf._p_1.set_1v0asv_k$(temp_0);
        Unit_getInstance();
        this._tempXf._q.set_dork62_k$(rotation_0);
        Unit_getInstance();
        Companion_getInstance_70().mulToOut_hym17k_k$(this._tempXf, group.m_transform__error, group.m_transform__error);
        var velocityTransform = this._tempXf2;
        velocityTransform._p_1._x_7 = step_0._inv_dt * this._tempXf._p_1._x_7;
        velocityTransform._p_1._y_6 = step_0._inv_dt * this._tempXf._p_1._y_6;
        velocityTransform._q._s = step_0._inv_dt * this._tempXf._q._s;
        velocityTransform._q._c_0 = step_0._inv_dt * (this._tempXf._q._c_0 - 1);
        var inductionVariable = group.m_firstIndex__error;
        var last_1 = group.m_lastIndex__error;
        if (inductionVariable < last_1)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            Companion_getInstance_70().mulToOutUnsafe_kg26ly_k$(velocityTransform, ensureNotNull(this._m_positionBuffer._data_12)[i], ensureNotNull(this._m_velocityBuffer._data_12)[i]);
          }
           while (inductionVariable < last_1);
      }group = group.getNext_0_k$();
    }
  };
  ParticleSystem.prototype.solveElastic_zeyqa8_k$ = function (step_0) {
    var elasticStrength = step_0._inv_dt * this._m_elasticStrength;
    var inductionVariable = 0;
    var last_1 = this._m_triadCount;
    if (inductionVariable < last_1)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var triad = this._m_triadBuffer[k];
        if (!((triad.flags__error & ParticleType_getInstance()._b2_elasticParticle) === 0)) {
          var a = triad.indexA__error;
          var b = triad.indexB__error;
          var c = triad.indexC__error;
          var oa = triad.pa__error;
          var ob = triad.pb__error;
          var oc = triad.pc__error;
          var pa = ensureNotNull(this._m_positionBuffer._data_12)[a];
          var pb = ensureNotNull(this._m_positionBuffer._data_12)[b];
          var pc = ensureNotNull(this._m_positionBuffer._data_12)[c];
          var px = 0.3333333333333333 * (pa._x_7 + pb._x_7 + pc._x_7);
          var py = 0.3333333333333333 * (pa._y_6 + pb._y_6 + pc._y_6);
          var rs = Companion_getInstance_71().cross_5kvz1c_k$(oa, pa) + Companion_getInstance_71().cross_5kvz1c_k$(ob, pb) + Companion_getInstance_71().cross_5kvz1c_k$(oc, pc);
          var rc = Companion_getInstance_71().dot_5kvz1c_k$(oa, pa) + Companion_getInstance_71().dot_5kvz1c_k$(ob, pb) + Companion_getInstance_71().dot_5kvz1c_k$(oc, pc);
          var r2 = rs * rs + rc * rc;
          var tmp;
          if (r2 === 0.0) {
            FloatCompanionObject_getInstance();
            tmp = 3.4028235E38;
          } else {
            tmp = Companion_getInstance_68().sqrt_dbmacu_k$(1.0 / r2);
          }
          var invR = tmp;
          rs = rs * invR;
          rc = rc * invR;
          var strength = elasticStrength * triad.strength__error;
          var roax = rc * oa._x_7 - rs * oa._y_6;
          var roay = rs * oa._x_7 + rc * oa._y_6;
          var robx = rc * ob._x_7 - rs * ob._y_6;
          var roby = rs * ob._x_7 + rc * ob._y_6;
          var rocx = rc * oc._x_7 - rs * oc._y_6;
          var rocy = rs * oc._x_7 + rc * oc._y_6;
          var va = ensureNotNull(this._m_velocityBuffer._data_12)[a];
          var vb = ensureNotNull(this._m_velocityBuffer._data_12)[b];
          var vc = ensureNotNull(this._m_velocityBuffer._data_12)[c];
          var tmp1_this = va;
          tmp1_this._x_7 = tmp1_this._x_7 + strength * (roax - (pa._x_7 - px));
          var tmp2_this = va;
          tmp2_this._y_6 = tmp2_this._y_6 + strength * (roay - (pa._y_6 - py));
          var tmp3_this = vb;
          tmp3_this._x_7 = tmp3_this._x_7 + strength * (robx - (pb._x_7 - px));
          var tmp4_this = vb;
          tmp4_this._y_6 = tmp4_this._y_6 + strength * (roby - (pb._y_6 - py));
          var tmp5_this = vc;
          tmp5_this._x_7 = tmp5_this._x_7 + strength * (rocx - (pc._x_7 - px));
          var tmp6_this = vc;
          tmp6_this._y_6 = tmp6_this._y_6 + strength * (rocy - (pc._y_6 - py));
        }}
       while (inductionVariable < last_1);
  };
  ParticleSystem.prototype.solveSpring_zeyqa8_k$ = function (step_0) {
    var springStrength = step_0._inv_dt * this._m_springStrength;
    var inductionVariable = 0;
    var last_1 = this._m_pairCount_0;
    if (inductionVariable < last_1)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var pair = this._m_pairBuffer_0[k];
        if (!((pair.flags__error & ParticleType_getInstance()._b2_springParticle) === 0)) {
          var a = pair.indexA__error;
          var b = pair.indexB__error;
          var pa = ensureNotNull(this._m_positionBuffer._data_12)[a];
          var pb = ensureNotNull(this._m_positionBuffer._data_12)[b];
          var dx = pb._x_7 - pa._x_7;
          var dy = pb._y_6 - pa._y_6;
          var r0 = pair.distance__error;
          var r1 = Companion_getInstance_68().sqrt_dbmacu_k$(dx * dx + dy * dy);
          if (r1 === 0.0) {
            FloatCompanionObject_getInstance();
            r1 = 3.4028235E38;
          }var strength = springStrength * pair.strength__error;
          var fx = strength * (r0 - r1) / r1 * dx;
          var fy = strength * (r0 - r1) / r1 * dy;
          var va = ensureNotNull(this._m_velocityBuffer._data_12)[a];
          var vb = ensureNotNull(this._m_velocityBuffer._data_12)[b];
          var tmp1_this = va;
          tmp1_this._x_7 = tmp1_this._x_7 - fx;
          var tmp2_this = va;
          tmp2_this._y_6 = tmp2_this._y_6 - fy;
          var tmp3_this = vb;
          tmp3_this._x_7 = tmp3_this._x_7 + fx;
          var tmp4_this = vb;
          tmp4_this._y_6 = tmp4_this._y_6 + fy;
        }}
       while (inductionVariable < last_1);
  };
  ParticleSystem.prototype.solveTensile_zeyqa8_k$ = function (step_0) {
    var tmp = this;
    tmp._m_accumulation2Buffer = this.requestParticleBuffer_jbn1qm_k$(_no_name_provided_$factory_61(), this._m_accumulation2Buffer);
    var inductionVariable = 0;
    var last_1 = this._particleCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._m_accumulationBuffer[i] = 0.0;
        ensureNotNull(this._m_accumulation2Buffer)[i].setZero_sv8swh_k$();
      }
       while (inductionVariable < last_1);
    var inductionVariable_0 = 0;
    var last_2 = this._m_contactCount_1;
    if (inductionVariable_0 < last_2)
      do {
        var k = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var contact = this._m_contactBuffer[k];
        if (!((contact._flags_0 & ParticleType_getInstance()._b2_tensileParticle) === 0)) {
          var a = contact._indexA_4;
          var b = contact._indexB_4;
          var w = contact._weight_1;
          var n = contact._normal_8;
          var tmp2_array = this._m_accumulationBuffer;
          var tmp3_index0 = a;
          tmp2_array[tmp3_index0] = tmp2_array[tmp3_index0] + w;
          var tmp4_array = this._m_accumulationBuffer;
          var tmp5_index0 = b;
          tmp4_array[tmp5_index0] = tmp4_array[tmp5_index0] + w;
          var a2A = ensureNotNull(this._m_accumulation2Buffer)[a];
          var a2B = ensureNotNull(this._m_accumulation2Buffer)[b];
          var inter = (1 - w) * w;
          var tmp6_this = a2A;
          tmp6_this._x_7 = tmp6_this._x_7 - inter * n._x_7;
          var tmp7_this = a2A;
          tmp7_this._y_6 = tmp7_this._y_6 - inter * n._y_6;
          var tmp8_this = a2B;
          tmp8_this._x_7 = tmp8_this._x_7 + inter * n._x_7;
          var tmp9_this = a2B;
          tmp9_this._y_6 = tmp9_this._y_6 + inter * n._y_6;
        }}
       while (inductionVariable_0 < last_2);
    var strengthA = this._m_surfaceTensionStrengthA * this.getCriticalVelocity_bzpqkh_k$(step_0);
    var strengthB = this._m_surfaceTensionStrengthB * this.getCriticalVelocity_bzpqkh_k$(step_0);
    var inductionVariable_1 = 0;
    var last_3 = this._m_contactCount_1;
    if (inductionVariable_1 < last_3)
      do {
        var k_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var contact_0 = this._m_contactBuffer[k_0];
        if (!((contact_0._flags_0 & ParticleType_getInstance()._b2_tensileParticle) === 0)) {
          var a_0 = contact_0._indexA_4;
          var b_0 = contact_0._indexB_4;
          var w_0 = contact_0._weight_1;
          var n_0 = contact_0._normal_8;
          var a2A_0 = ensureNotNull(this._m_accumulation2Buffer)[a_0];
          var a2B_0 = ensureNotNull(this._m_accumulation2Buffer)[b_0];
          var h = ensureNotNull(this._m_accumulationBuffer)[a_0] + ensureNotNull(this._m_accumulationBuffer)[b_0];
          var sx = a2B_0._x_7 - a2A_0._x_7;
          var sy = a2B_0._y_6 - a2A_0._y_6;
          var fn = (strengthA * (h - 2) + strengthB * (sx * n_0._x_7 + sy * n_0._y_6)) * w_0;
          var fx = fn * n_0._x_7;
          var fy = fn * n_0._y_6;
          var va = ensureNotNull(this._m_velocityBuffer._data_12)[a_0];
          var vb = ensureNotNull(this._m_velocityBuffer._data_12)[b_0];
          var tmp11_this = va;
          tmp11_this._x_7 = tmp11_this._x_7 - fx;
          var tmp12_this = va;
          tmp12_this._y_6 = tmp12_this._y_6 - fy;
          var tmp13_this = vb;
          tmp13_this._x_7 = tmp13_this._x_7 + fx;
          var tmp14_this = vb;
          tmp14_this._y_6 = tmp14_this._y_6 + fy;
        }}
       while (inductionVariable_1 < last_3);
  };
  ParticleSystem.prototype.solveViscous_zeyqa8_k$ = function (step_0) {
    var viscousStrength = this._m_viscousStrength;
    var inductionVariable = 0;
    var last_1 = this._m_bodyContactCount;
    if (inductionVariable < last_1)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var contact = this._m_bodyContactBuffer[k];
        var a = contact._index_11;
        if (!((ensureNotNull(this._m_flagsBuffer._data_13)[a] & ParticleType_getInstance()._b2_viscousParticle) === 0)) {
          var b = contact._body;
          var w = contact._weight_0;
          var m = contact._mass_0;
          var p = ensureNotNull(this._m_positionBuffer._data_12)[a];
          var va = ensureNotNull(this._m_velocityBuffer._data_12)[a];
          var tempX = p._x_7 - ensureNotNull(b)._sweep._c_1._x_7;
          var tempY = p._y_6 - ensureNotNull(b)._sweep._c_1._y_6;
          var vx = -ensureNotNull(b).__angularVelocity * tempY + ensureNotNull(b).__linearVelocity._x_7 - va._x_7;
          var vy = ensureNotNull(b).__angularVelocity * tempX + ensureNotNull(b).__linearVelocity._y_6 - va._y_6;
          var f = this._tempVec_1;
          var pInvMass = this._get_particleInvMass__0_k$();
          f._x_7 = viscousStrength * m * w * vx;
          f._y_6 = viscousStrength * m * w * vy;
          var tmp1_this = va;
          tmp1_this._x_7 = tmp1_this._x_7 + pInvMass * f._x_7;
          var tmp2_this = va;
          tmp2_this._y_6 = tmp2_this._y_6 + pInvMass * f._y_6;
          f._x_7 = -f._x_7;
          f._y_6 = -f._y_6;
          ensureNotNull(b).applyLinearImpulse_gzag95_k$(f, p, true);
        }}
       while (inductionVariable < last_1);
    var inductionVariable_0 = 0;
    var last_2 = this._m_contactCount_1;
    if (inductionVariable_0 < last_2)
      do {
        var k_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var contact_0 = this._m_contactBuffer[k_0];
        if (!((contact_0._flags_0 & ParticleType_getInstance()._b2_viscousParticle) === 0)) {
          var a_0 = contact_0._indexA_4;
          var b_0 = contact_0._indexB_4;
          var w_0 = contact_0._weight_1;
          var va_0 = ensureNotNull(this._m_velocityBuffer._data_12)[a_0];
          var vb = ensureNotNull(this._m_velocityBuffer._data_12)[b_0];
          var vx_0 = vb._x_7 - va_0._x_7;
          var vy_0 = vb._y_6 - va_0._y_6;
          var fx = viscousStrength * w_0 * vx_0;
          var fy = viscousStrength * w_0 * vy_0;
          var tmp4_this = va_0;
          tmp4_this._x_7 = tmp4_this._x_7 + fx;
          var tmp5_this = va_0;
          tmp5_this._y_6 = tmp5_this._y_6 + fy;
          var tmp6_this = vb;
          tmp6_this._x_7 = tmp6_this._x_7 - fx;
          var tmp7_this = vb;
          tmp7_this._y_6 = tmp7_this._y_6 - fy;
        }}
       while (inductionVariable_0 < last_2);
  };
  ParticleSystem.prototype.solvePowder_zeyqa8_k$ = function (step_0) {
    var powderStrength = this._m_powderStrength * this.getCriticalVelocity_bzpqkh_k$(step_0);
    var minWeight = 1.0 - Settings_getInstance()._particleStride;
    var inductionVariable = 0;
    var last_1 = this._m_bodyContactCount;
    if (inductionVariable < last_1)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var contact = this._m_bodyContactBuffer[k];
        var a = contact._index_11;
        if (!((ensureNotNull(this._m_flagsBuffer._data_13)[a] & ParticleType_getInstance()._b2_powderParticle) === 0)) {
          var w = contact._weight_0;
          if (w > minWeight) {
            var b = contact._body;
            var m = contact._mass_0;
            var p = ensureNotNull(this._m_positionBuffer._data_12)[a];
            var n = contact._normal_7;
            var f = this._tempVec_1;
            var va = ensureNotNull(this._m_velocityBuffer._data_12)[a];
            var inter = powderStrength * m * (w - minWeight);
            var pInvMass = this._get_particleInvMass__0_k$();
            f._x_7 = inter * n._x_7;
            f._y_6 = inter * n._y_6;
            var tmp1_this = va;
            tmp1_this._x_7 = tmp1_this._x_7 - pInvMass * f._x_7;
            var tmp2_this = va;
            tmp2_this._y_6 = tmp2_this._y_6 - pInvMass * f._y_6;
            ensureNotNull(b).applyLinearImpulse_gzag95_k$(f, p, true);
          }}}
       while (inductionVariable < last_1);
    var inductionVariable_0 = 0;
    var last_2 = this._m_contactCount_1;
    if (inductionVariable_0 < last_2)
      do {
        var k_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var contact_0 = this._m_contactBuffer[k_0];
        if (!((contact_0._flags_0 & ParticleType_getInstance()._b2_powderParticle) === 0)) {
          var w_0 = contact_0._weight_1;
          if (w_0 > minWeight) {
            var a_0 = contact_0._indexA_4;
            var b_0 = contact_0._indexB_4;
            var n_0 = contact_0._normal_8;
            var va_0 = ensureNotNull(this._m_velocityBuffer._data_12)[a_0];
            var vb = ensureNotNull(this._m_velocityBuffer._data_12)[b_0];
            var inter_0 = powderStrength * (w_0 - minWeight);
            var fx = inter_0 * n_0._x_7;
            var fy = inter_0 * n_0._y_6;
            var tmp4_this = va_0;
            tmp4_this._x_7 = tmp4_this._x_7 - fx;
            var tmp5_this = va_0;
            tmp5_this._y_6 = tmp5_this._y_6 - fy;
            var tmp6_this = vb;
            tmp6_this._x_7 = tmp6_this._x_7 + fx;
            var tmp7_this = vb;
            tmp7_this._y_6 = tmp7_this._y_6 + fy;
          }}}
       while (inductionVariable_0 < last_2);
  };
  ParticleSystem.prototype.solveSolid_zeyqa8_k$ = function (step_0) {
    this._m_depthBuffer = this.requestParticleBuffer_4qe7os_k$(this._m_depthBuffer);
    var ejectionStrength = step_0._inv_dt * this._m_ejectionStrength;
    var inductionVariable = 0;
    var last_1 = this._m_contactCount_1;
    if (inductionVariable < last_1)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var contact = this._m_contactBuffer[k];
        var a = contact._indexA_4;
        var b = contact._indexB_4;
        if (!equals_1(ensureNotNull(this._particleGroupBuffer)[a], ensureNotNull(this._particleGroupBuffer)[b])) {
          var w = contact._weight_1;
          var n = contact._normal_8;
          var h = ensureNotNull(this._m_depthBuffer)[a] + ensureNotNull(this._m_depthBuffer)[b];
          var va = ensureNotNull(this._m_velocityBuffer._data_12)[a];
          var vb = ensureNotNull(this._m_velocityBuffer._data_12)[b];
          var inter = ejectionStrength * h * w;
          var fx = inter * n._x_7;
          var fy = inter * n._y_6;
          var tmp1_this = va;
          tmp1_this._x_7 = tmp1_this._x_7 - fx;
          var tmp2_this = va;
          tmp2_this._y_6 = tmp2_this._y_6 - fy;
          var tmp3_this = vb;
          tmp3_this._x_7 = tmp3_this._x_7 + fx;
          var tmp4_this = vb;
          tmp4_this._y_6 = tmp4_this._y_6 + fy;
        }}
       while (inductionVariable < last_1);
  };
  ParticleSystem.prototype.solveColorMixing_zeyqa8_k$ = function (step_0) {
    var tmp = this._m_colorBuffer;
    tmp._data_12 = this.requestParticleBuffer_jbn1qm_k$(_no_name_provided_$factory_62(), this._m_colorBuffer._data_12);
    var colorMixing256 = numberToInt(256 * this._m_colorMixingStrength);
    var inductionVariable = 0;
    var last_1 = this._m_contactCount_1;
    if (inductionVariable < last_1)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var contact = this._m_contactBuffer[k];
        var a = contact._indexA_4;
        var b = contact._indexB_4;
        if (!((ensureNotNull(this._m_flagsBuffer._data_13)[a] & ensureNotNull(this._m_flagsBuffer._data_13)[b] & ParticleType_getInstance()._b2_colorMixingParticle) === 0)) {
          var colorA = ensureNotNull(ensureNotNull(this._m_colorBuffer._data_12)[a]);
          var colorB = ensureNotNull(ensureNotNull(this._m_colorBuffer._data_12)[b]);
          var dr = imul(colorMixing256, (colorB._r_0 & 255) - (colorA._r_0 & 255) | 0) >>> 8;
          var dg = imul(colorMixing256, (colorB._g & 255) - (colorA._g & 255) | 0) >>> 8;
          var db = imul(colorMixing256, (colorB._b_0 & 255) - (colorA._b_0 & 255) | 0) >>> 8;
          var da = imul(colorMixing256, (colorB._a_3 & 255) - (colorA._a_3 & 255) | 0) >>> 8;
          colorA._r_0 = toByte(colorA._r_0 + dr | 0);
          colorA._g = toByte(colorA._g + dg | 0);
          colorA._b_0 = toByte(colorA._b_0 + db | 0);
          colorA._a_3 = toByte(colorA._a_3 + da | 0);
          colorB._r_0 = toByte(colorB._r_0 - dr | 0);
          colorB._g = toByte(colorB._g - dg | 0);
          colorB._b_0 = toByte(colorB._b_0 - db | 0);
          colorB._a_3 = toByte(colorB._a_3 - da | 0);
        }}
       while (inductionVariable < last_1);
  };
  ParticleSystem.prototype.solveZombie_sv8swh_k$ = function () {
    var newCount = 0;
    var newIndices = new Int32Array(this._particleCount);
    var inductionVariable = 0;
    var last_1 = this._particleCount;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var flags = ensureNotNull(this._m_flagsBuffer._data_13)[i];
        if (!((flags & ParticleType_getInstance()._b2_zombieParticle) === 0)) {
          var destructionListener = this._m_world._particleDestructionListener;
          if (!((flags & ParticleType_getInstance()._b2_destructionListener) === 0) ? !(destructionListener == null) : false) {
            destructionListener.sayGoodbye_majfzk_k$(i);
          }newIndices[i] = Settings_getInstance()._invalidParticleIndex;
        } else {
          newIndices[i] = newCount;
          if (!(i === newCount)) {
            ensureNotNull(ensureNotNull(this._m_flagsBuffer)._data_13)[newCount] = ensureNotNull(this._m_flagsBuffer._data_13)[i];
            ensureNotNull(this._m_positionBuffer._data_12)[newCount].set_1v0asv_k$(ensureNotNull(this._m_positionBuffer._data_12)[i]);
            Unit_getInstance();
            ensureNotNull(this._m_velocityBuffer._data_12)[newCount].set_1v0asv_k$(ensureNotNull(this._m_velocityBuffer._data_12)[i]);
            Unit_getInstance();
            ensureNotNull(this._particleGroupBuffer)[newCount] = ensureNotNull(ensureNotNull(this._particleGroupBuffer)[i]);
            if (!(this._m_depthBuffer == null)) {
              ensureNotNull(this._m_depthBuffer)[newCount] = ensureNotNull(this._m_depthBuffer)[i];
            }if (!(this._m_colorBuffer._data_12 == null)) {
              ensureNotNull(this._m_colorBuffer._data_12)[newCount].set_lceezu_k$(ensureNotNull(this._m_colorBuffer._data_12)[i]);
            }if (!(this._m_userDataBuffer._data_12 == null)) {
              ensureNotNull(ensureNotNull(this._m_userDataBuffer)._data_12)[newCount] = ensureNotNull(this._m_userDataBuffer._data_12)[i];
            }}var tmp1 = newCount;
          newCount = tmp1 + 1 | 0;
          Unit_getInstance();
        }
      }
       while (inductionVariable < last_1);
    var inductionVariable_0 = 0;
    var last_2 = this._m_proxyCount_0;
    if (inductionVariable_0 < last_2)
      do {
        var k = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var proxy = this._m_proxyBuffer[k];
        proxy.index__error = newIndices[proxy.index__error];
      }
       while (inductionVariable_0 < last_2);
    var j = this._m_proxyCount_0;
    var i_2 = 0;
    while (i_2 < j) {
      if (Test_getInstance().IsProxyInvalid_7b3mxk_k$(this._m_proxyBuffer[i_2])) {
        j = j - 1 | 0;
        Unit_getInstance();
        var temp_3 = this._m_proxyBuffer[j];
        this._m_proxyBuffer[j] = this._m_proxyBuffer[i_2];
        this._m_proxyBuffer[i_2] = temp_3;
        i_2 = i_2 - 1 | 0;
        Unit_getInstance();
      }var tmp0_4 = i_2;
      i_2 = tmp0_4 + 1 | 0;
      Unit_getInstance();
    }
    this._m_proxyCount_0 = j;
    var inductionVariable_1 = 0;
    var last_3 = this._m_contactCount_1;
    if (inductionVariable_1 < last_3)
      do {
        var k_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var contact = this._m_contactBuffer[k_0];
        contact._indexA_4 = newIndices[contact._indexA_4];
        contact._indexB_4 = newIndices[contact._indexB_4];
      }
       while (inductionVariable_1 < last_3);
    j = this._m_contactCount_1;
    var i_2_0 = 0;
    while (i_2_0 < j) {
      if (Test_getInstance().IsContactInvalid_k1mkdg_k$(this._m_contactBuffer[i_2_0])) {
        j = j - 1 | 0;
        Unit_getInstance();
        var temp_3_0 = this._m_contactBuffer[j];
        this._m_contactBuffer[j] = this._m_contactBuffer[i_2_0];
        this._m_contactBuffer[i_2_0] = temp_3_0;
        i_2_0 = i_2_0 - 1 | 0;
        Unit_getInstance();
      }var tmp0_4_0 = i_2_0;
      i_2_0 = tmp0_4_0 + 1 | 0;
      Unit_getInstance();
    }
    this._m_contactCount_1 = j;
    var inductionVariable_2 = 0;
    var last_4 = this._m_bodyContactCount;
    if (inductionVariable_2 < last_4)
      do {
        var k_1 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var contact_0 = this._m_bodyContactBuffer[k_1];
        contact_0._index_11 = newIndices[contact_0._index_11];
      }
       while (inductionVariable_2 < last_4);
    j = this._m_bodyContactCount;
    var i_2_1 = 0;
    while (i_2_1 < j) {
      if (Test_getInstance().IsBodyContactInvalid_p5qsm6_k$(this._m_bodyContactBuffer[i_2_1])) {
        j = j - 1 | 0;
        Unit_getInstance();
        var temp_3_1 = this._m_bodyContactBuffer[j];
        this._m_bodyContactBuffer[j] = this._m_bodyContactBuffer[i_2_1];
        this._m_bodyContactBuffer[i_2_1] = temp_3_1;
        i_2_1 = i_2_1 - 1 | 0;
        Unit_getInstance();
      }var tmp0_4_1 = i_2_1;
      i_2_1 = tmp0_4_1 + 1 | 0;
      Unit_getInstance();
    }
    this._m_bodyContactCount = j;
    var inductionVariable_3 = 0;
    var last_5 = this._m_pairCount_0;
    if (inductionVariable_3 < last_5)
      do {
        var k_2 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var pair = this._m_pairBuffer_0[k_2];
        pair.indexA__error = newIndices[pair.indexA__error];
        pair.indexB__error = newIndices[pair.indexB__error];
      }
       while (inductionVariable_3 < last_5);
    j = this._m_pairCount_0;
    var i_2_2 = 0;
    while (i_2_2 < j) {
      if (Test_getInstance().IsPairInvalid_u0tc1c_k$(this._m_pairBuffer_0[i_2_2])) {
        j = j - 1 | 0;
        Unit_getInstance();
        var temp_3_2 = this._m_pairBuffer_0[j];
        this._m_pairBuffer_0[j] = this._m_pairBuffer_0[i_2_2];
        this._m_pairBuffer_0[i_2_2] = temp_3_2;
        i_2_2 = i_2_2 - 1 | 0;
        Unit_getInstance();
      }var tmp0_4_2 = i_2_2;
      i_2_2 = tmp0_4_2 + 1 | 0;
      Unit_getInstance();
    }
    this._m_pairCount_0 = j;
    var inductionVariable_4 = 0;
    var last_6 = this._m_triadCount;
    if (inductionVariable_4 < last_6)
      do {
        var k_3 = inductionVariable_4;
        inductionVariable_4 = inductionVariable_4 + 1 | 0;
        var triad = this._m_triadBuffer[k_3];
        triad.indexA__error = newIndices[triad.indexA__error];
        triad.indexB__error = newIndices[triad.indexB__error];
        triad.indexC__error = newIndices[triad.indexC__error];
      }
       while (inductionVariable_4 < last_6);
    j = this._m_triadCount;
    var i_2_3 = 0;
    while (i_2_3 < j) {
      if (Test_getInstance().IsTriadInvalid_7daoag_k$(this._m_triadBuffer[i_2_3])) {
        j = j - 1 | 0;
        Unit_getInstance();
        var temp_3_3 = this._m_triadBuffer[j];
        this._m_triadBuffer[j] = this._m_triadBuffer[i_2_3];
        this._m_triadBuffer[i_2_3] = temp_3_3;
        i_2_3 = i_2_3 - 1 | 0;
        Unit_getInstance();
      }var tmp0_4_3 = i_2_3;
      i_2_3 = tmp0_4_3 + 1 | 0;
      Unit_getInstance();
    }
    this._m_triadCount = j;
    var group_2 = this._m_groupList;
    while (!(group_2 == null)) {
      var firstIndex_3 = newCount;
      var lastIndex_4 = 0;
      var modified_5 = false;
      var inductionVariable_5 = ensureNotNull(group_2).m_firstIndex__error;
      var last_7 = ensureNotNull(group_2).m_lastIndex__error;
      if (inductionVariable_5 < last_7)
        do {
          var i_7 = inductionVariable_5;
          inductionVariable_5 = inductionVariable_5 + 1 | 0;
          j = newIndices[i_7];
          if (j >= 0) {
            firstIndex_3 = Companion_getInstance_68().min_27zxwg_k$(firstIndex_3, j);
            lastIndex_4 = Companion_getInstance_68().max_27zxwg_k$(lastIndex_4, j + 1 | 0);
          } else {
            modified_5 = true;
          }
        }
         while (inductionVariable_5 < last_7);
      if (firstIndex_3 < lastIndex_4) {
        ensureNotNull(group_2).m_firstIndex__error = firstIndex_3;
        ensureNotNull(group_2).m_lastIndex__error = lastIndex_4;
        if (modified_5) {
          if (!((ensureNotNull(group_2).m_groupFlags__error & ParticleGroupType_getInstance()._b2_rigidParticleGroup) === 0)) {
            ensureNotNull(group_2).m_toBeSplit__error = true;
          }}} else {
        ensureNotNull(group_2).m_firstIndex__error = 0;
        ensureNotNull(group_2).m_lastIndex__error = 0;
        if (ensureNotNull(group_2).m_destroyAutomatically__error) {
          ensureNotNull(group_2).m_toBeDestroyed__error = true;
        }}
      group_2 = ensureNotNull(group_2).getNext_0_k$();
    }
    this._particleCount = newCount;
    var group = this._m_groupList;
    while (!(group == null)) {
      var next_0 = ensureNotNull(group).getNext_0_k$();
      if (ensureNotNull(group).m_toBeDestroyed__error) {
        this.destroyParticleGroup_1ockol_k$(group);
      } else if (ensureNotNull(group).m_toBeSplit__error) {
      }group = next_0;
    }
  };
  ParticleSystem.prototype.getCriticalVelocity_bzpqkh_k$ = function (step_0) {
    return this._m_particleDiameter * step_0._inv_dt;
  };
  ParticleSystem.prototype.getCriticalVelocitySquared_bzpqkh_k$ = function (step_0) {
    var velocity = this.getCriticalVelocity_bzpqkh_k$(step_0);
    return velocity * velocity;
  };
  ParticleSystem.prototype.getCriticalPressure_bzpqkh_k$ = function (step_0) {
    return this._m_density_0 * this.getCriticalVelocitySquared_bzpqkh_k$(step_0);
  };
  ParticleSystem.prototype.requestParticleBuffer_jbn1qm_k$ = function (newInstance, buffer) {
    var buffer_0 = buffer;
    if (buffer_0 == null) {
      var tmp = 0;
      var tmp_0 = this._m_internalAllocatedCapacity;
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = newInstance();
        tmp = tmp + 1 | 0;
      }
      var tmp_3 = tmp_1;
      buffer_0 = isArray(tmp_3) ? tmp_3 : THROW_CCE();
    }return buffer_0;
  };
  ParticleSystem.prototype.requestParticleBuffer_4qe7os_k$ = function (buffer) {
    var buffer_0 = buffer;
    if (buffer_0 == null) {
      buffer_0 = new Float32Array(this._m_internalAllocatedCapacity);
    }return buffer_0;
  };
  ParticleSystem.$metadata$ = {
    simpleName: 'ParticleSystem',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_56() {
    var i = new _no_name_provided__78();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_57() {
    var i = new _no_name_provided__79();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_58() {
    var i = new _no_name_provided__80();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_59() {
    var i = new _no_name_provided__81();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_60() {
    var i = new _no_name_provided__82();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_61() {
    var i = new _no_name_provided__83();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_62() {
    var i = new _no_name_provided__84();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_63() {
    var i = new _no_name_provided__77();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function ParticleType() {
    ParticleType_instance = this;
    this._b2_waterParticle = 0;
    this._b2_zombieParticle = 2;
    this._b2_wallParticle = 4;
    this._b2_springParticle = 8;
    this._b2_elasticParticle = 16;
    this._b2_viscousParticle = 32;
    this._b2_powderParticle = 64;
    this._b2_tensileParticle = 128;
    this._b2_colorMixingParticle = 256;
    this._b2_destructionListener = 512;
  }
  ParticleType.$metadata$ = {
    simpleName: 'ParticleType',
    kind: 'object',
    interfaces: []
  };
  var ParticleType_instance;
  function ParticleType_getInstance() {
    if (ParticleType_instance == null)
      new ParticleType();
    return ParticleType_instance;
  }
  function VoronoiDiagramCallback() {
  }
  VoronoiDiagramCallback.$metadata$ = {
    simpleName: 'VoronoiDiagramCallback',
    kind: 'interface',
    interfaces: []
  };
  function IDynamicStack() {
  }
  IDynamicStack.$metadata$ = {
    simpleName: 'IDynamicStack',
    kind: 'interface',
    interfaces: []
  };
  function IWorldPool() {
  }
  IWorldPool.$metadata$ = {
    simpleName: 'IWorldPool',
    kind: 'interface',
    interfaces: []
  };
  function Vec2ArrayPool() {
    this._map_3 = HashMap_init_$Create$();
  }
  Vec2ArrayPool.$metadata$ = {
    simpleName: 'Vec2ArrayPool',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__85() {
  }
  _no_name_provided__85.prototype.invoke_0_k$ = function () {
    return Vec2_init_$Create$(0.0, 0.0, 3, null);
  };
  _no_name_provided__85.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__86() {
  }
  _no_name_provided__86.prototype.invoke_0_k$ = function () {
    return Vec3_init_$Create$(0.0, 0.0, 0.0, 7, null);
  };
  _no_name_provided__86.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__87() {
  }
  _no_name_provided__87.prototype.invoke_0_k$ = function () {
    return Mat22_init_$Create$();
  };
  _no_name_provided__87.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__88() {
  }
  _no_name_provided__88.prototype.invoke_0_k$ = function () {
    return Mat33_init_$Create$();
  };
  _no_name_provided__88.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__89() {
  }
  _no_name_provided__89.prototype.invoke_0_k$ = function () {
    return AABB_init_$Create$();
  };
  _no_name_provided__89.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__90() {
  }
  _no_name_provided__90.prototype.invoke_0_k$ = function () {
    return Rot_init_$Create$();
  };
  _no_name_provided__90.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__91(this$0) {
    this._this$0_21 = this$0;
  }
  _no_name_provided__91.prototype.invoke_0_k$ = function () {
    return new PolygonContact(this._this$0_21._world_0);
  };
  _no_name_provided__91.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__92() {
  }
  _no_name_provided__92.prototype.invoke_ha5a7z_k$ = function (it) {
    return fillArrayVal(Array(it), null);
  };
  _no_name_provided__92.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__92.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__93(this$0) {
    this._this$0_22 = this$0;
  }
  _no_name_provided__93.prototype.invoke_0_k$ = function () {
    return new CircleContact(this._this$0_22._world_0);
  };
  _no_name_provided__93.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__94() {
  }
  _no_name_provided__94.prototype.invoke_ha5a7z_k$ = function (it) {
    return fillArrayVal(Array(it), null);
  };
  _no_name_provided__94.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__94.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__95(this$0) {
    this._this$0_23 = this$0;
  }
  _no_name_provided__95.prototype.invoke_0_k$ = function () {
    return new PolygonAndCircleContact(this._this$0_23._world_0);
  };
  _no_name_provided__95.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__96() {
  }
  _no_name_provided__96.prototype.invoke_ha5a7z_k$ = function (it) {
    return fillArrayVal(Array(it), null);
  };
  _no_name_provided__96.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__96.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__97(this$0) {
    this._this$0_24 = this$0;
  }
  _no_name_provided__97.prototype.invoke_0_k$ = function () {
    return new EdgeAndCircleContact(this._this$0_24._world_0);
  };
  _no_name_provided__97.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__98() {
  }
  _no_name_provided__98.prototype.invoke_ha5a7z_k$ = function (it) {
    return fillArrayVal(Array(it), null);
  };
  _no_name_provided__98.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__98.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__99(this$0) {
    this._this$0_25 = this$0;
  }
  _no_name_provided__99.prototype.invoke_0_k$ = function () {
    return new EdgeAndPolygonContact(this._this$0_25._world_0);
  };
  _no_name_provided__99.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__100() {
  }
  _no_name_provided__100.prototype.invoke_ha5a7z_k$ = function (it) {
    return fillArrayVal(Array(it), null);
  };
  _no_name_provided__100.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__100.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__101(this$0) {
    this._this$0_26 = this$0;
  }
  _no_name_provided__101.prototype.invoke_0_k$ = function () {
    return new ChainAndCircleContact(this._this$0_26._world_0);
  };
  _no_name_provided__101.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__102() {
  }
  _no_name_provided__102.prototype.invoke_ha5a7z_k$ = function (it) {
    return fillArrayVal(Array(it), null);
  };
  _no_name_provided__102.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__102.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__103(this$0) {
    this._this$0_27 = this$0;
  }
  _no_name_provided__103.prototype.invoke_0_k$ = function () {
    return new ChainAndPolygonContact(this._this$0_27._world_0);
  };
  _no_name_provided__103.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__104() {
  }
  _no_name_provided__104.prototype.invoke_ha5a7z_k$ = function (it) {
    return fillArrayVal(Array(it), null);
  };
  _no_name_provided__104.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__104.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function DefaultWorldPool(argSize, argContainerSize) {
    this._world_0 = this;
    var tmp = this;
    tmp._vecs = new LambdaOrderedStack(argSize, argContainerSize, _no_name_provided_$factory_64());
    var tmp_0 = this;
    tmp_0._vec3s = new LambdaOrderedStack(argSize, argContainerSize, _no_name_provided_$factory_65());
    var tmp_1 = this;
    tmp_1._mats = new LambdaOrderedStack(argSize, argContainerSize, _no_name_provided_$factory_66());
    var tmp_2 = this;
    tmp_2._mat33s = new LambdaOrderedStack(argSize, argContainerSize, _no_name_provided_$factory_67());
    var tmp_3 = this;
    tmp_3._aabbs = new LambdaOrderedStack(argSize, argContainerSize, _no_name_provided_$factory_68());
    var tmp_4 = this;
    tmp_4._rots = new LambdaOrderedStack(argSize, argContainerSize, _no_name_provided_$factory_69());
    this._afloats = HashMap_init_$Create$();
    this._aints = HashMap_init_$Create$();
    this._avecs = HashMap_init_$Create$();
    var tmp_5 = this;
    var tmp_6 = _no_name_provided_$factory_70(this);
    tmp_5._pcstack = new ContactMutableStack(tmp_6, _no_name_provided_$factory_71());
    var tmp_7 = this;
    var tmp_8 = _no_name_provided_$factory_72(this);
    tmp_7._ccstack = new ContactMutableStack(tmp_8, _no_name_provided_$factory_73());
    var tmp_9 = this;
    var tmp_10 = _no_name_provided_$factory_74(this);
    tmp_9._cpstack = new ContactMutableStack(tmp_10, _no_name_provided_$factory_75());
    var tmp_11 = this;
    var tmp_12 = _no_name_provided_$factory_76(this);
    tmp_11._ecstack = new ContactMutableStack(tmp_12, _no_name_provided_$factory_77());
    var tmp_13 = this;
    var tmp_14 = _no_name_provided_$factory_78(this);
    tmp_13._epstack = new ContactMutableStack(tmp_14, _no_name_provided_$factory_79());
    var tmp_15 = this;
    var tmp_16 = _no_name_provided_$factory_80(this);
    tmp_15._chcstack = new ContactMutableStack(tmp_16, _no_name_provided_$factory_81());
    var tmp_17 = this;
    var tmp_18 = _no_name_provided_$factory_82(this);
    tmp_17._chpstack = new ContactMutableStack(tmp_18, _no_name_provided_$factory_83());
    this._collision = new Collision(this);
    var tmp_19 = this;
    tmp_19._timeOfImpact = TimeOfImpact_init_$Create$(this, null, 2, null);
    var tmp_20 = this;
    tmp_20._distance_0 = Distance_init_$Create$(null, 1, null);
  }
  DefaultWorldPool.prototype._get_collision__0_k$ = function () {
    return this._collision;
  };
  DefaultWorldPool.prototype._get_timeOfImpact__0_k$ = function () {
    return this._timeOfImpact;
  };
  DefaultWorldPool.prototype._get_distance__0_k$ = function () {
    return this._distance_0;
  };
  DefaultWorldPool.prototype._get_polyContactStack__0_k$ = function () {
    return this._pcstack;
  };
  DefaultWorldPool.prototype._get_circleContactStack__0_k$ = function () {
    return this._ccstack;
  };
  DefaultWorldPool.prototype._get_polyCircleContactStack__0_k$ = function () {
    return this._cpstack;
  };
  DefaultWorldPool.prototype._get_edgeCircleContactStack__0_k$ = function () {
    return this._ecstack;
  };
  DefaultWorldPool.prototype._get_edgePolyContactStack__0_k$ = function () {
    return this._epstack;
  };
  DefaultWorldPool.prototype._get_chainCircleContactStack__0_k$ = function () {
    return this._chcstack;
  };
  DefaultWorldPool.prototype._get_chainPolyContactStack__0_k$ = function () {
    return this._chpstack;
  };
  DefaultWorldPool.prototype.popVec2_0_k$ = function () {
    return this._vecs.pop_0_k$();
  };
  DefaultWorldPool.prototype.pushVec2_majfzk_k$ = function (argNum) {
    this._vecs.push_majfzk_k$(argNum);
  };
  DefaultWorldPool.$metadata$ = {
    simpleName: 'DefaultWorldPool',
    kind: 'class',
    interfaces: [IWorldPool]
  };
  function LambdaOrderedStack(argSize, argContainerSize, newInstanceLambda) {
    OrderedStack.call(this, argSize, argContainerSize);
    this._newInstanceLambda = newInstanceLambda;
  }
  LambdaOrderedStack.prototype.newInstance_0_k$ = function () {
    return this._newInstanceLambda();
  };
  LambdaOrderedStack.$metadata$ = {
    simpleName: 'LambdaOrderedStack',
    kind: 'class',
    interfaces: []
  };
  function ContactMutableStack(newInstanceLambda, newArrayLambda) {
    MutableStack.call(this, Settings_getInstance()._get_CONTACT_STACK_INIT_SIZE__0_k$());
    this._newInstanceLambda_0 = newInstanceLambda;
    this._newArrayLambda = newArrayLambda;
  }
  ContactMutableStack.prototype.newInstance_0_k$ = function () {
    return this._newInstanceLambda_0();
  };
  ContactMutableStack.prototype.newArray_ha5a7z_k$ = function (size_2) {
    var tmp = this._newArrayLambda(size_2);
    return isArray(tmp) ? tmp : THROW_CCE();
  };
  ContactMutableStack.$metadata$ = {
    simpleName: 'ContactMutableStack',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_64() {
    var i = new _no_name_provided__85();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_65() {
    var i = new _no_name_provided__86();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_66() {
    var i = new _no_name_provided__87();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_67() {
    var i = new _no_name_provided__88();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_68() {
    var i = new _no_name_provided__89();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_69() {
    var i = new _no_name_provided__90();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_70(this$0) {
    var i = new _no_name_provided__91(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_71() {
    var i = new _no_name_provided__92();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_72(this$0) {
    var i = new _no_name_provided__93(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_73() {
    var i = new _no_name_provided__94();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_74(this$0) {
    var i = new _no_name_provided__95(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_75() {
    var i = new _no_name_provided__96();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_76(this$0) {
    var i = new _no_name_provided__97(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_77() {
    var i = new _no_name_provided__98();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_78(this$0) {
    var i = new _no_name_provided__99(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_79() {
    var i = new _no_name_provided__100();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_80(this$0) {
    var i = new _no_name_provided__101(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_81() {
    var i = new _no_name_provided__102();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_82(this$0) {
    var i = new _no_name_provided__103(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_83() {
    var i = new _no_name_provided__104();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function ensureInit($this) {
    if ($this._stack_0 == null) {
      extendStack($this, $this._argInitSize);
    }}
  function extendStack($this, argSize) {
    var newStack = $this.newArray_ha5a7z_k$(argSize);
    if (!($this._stack_0 == null)) {
      var tmp0_arraycopy_0 = ensureNotNull($this._stack_0);
      var tmp1_arraycopy_0 = $this._size_4;
      var tmp0_copyInto_0_2_1 = 0 + tmp1_arraycopy_0 | 0;
      arrayCopy_0(tmp0_arraycopy_0, newStack, 0, 0, tmp0_copyInto_0_2_1);
      Unit_getInstance();
    }var inductionVariable = 0;
    var last_1 = newStack.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        newStack[i] = $this.newInstance_0_k$();
      }
       while (inductionVariable <= last_1);
    $this._stack_0 = newStack;
    $this._size_4 = newStack.length;
  }
  function MutableStack(argInitSize) {
    this._argInitSize = argInitSize;
    this._stack_0 = null;
    this._index_12 = 0;
    this._size_4 = 0;
  }
  MutableStack.prototype.pop_0_k$ = function () {
    ensureInit(this);
    if (this._index_12 >= this._size_4) {
      extendStack(this, imul(this._size_4, 2));
    }var tmp = ensureNotNull(this._stack_0);
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_12;
    tmp0_this._index_12 = tmp1 + 1 | 0;
    return tmp[tmp1];
  };
  MutableStack.prototype.push_jxzaet_k$ = function (argObject) {
    ensureInit(this);
    var tmp0_assert_0 = this._index_12 > 0;
    if (!tmp0_assert_0) {
      var message_2_1_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
    }var tmp = ensureNotNull(this._stack_0);
    var tmp0_this = this;
    tmp0_this._index_12 = tmp0_this._index_12 - 1 | 0;
    tmp[tmp0_this._index_12] = argObject;
  };
  MutableStack.$metadata$ = {
    simpleName: 'MutableStack',
    kind: 'class',
    interfaces: [IDynamicStack]
  };
  function _get_pool_($this) {
    var tmp0_getValue_0 = pool$factory();
    return $this._pool$delegate._get_value__0_k$();
  }
  function _no_name_provided__105(this$0) {
    this._this$0_28 = this$0;
  }
  _no_name_provided__105.prototype.invoke_0_k$ = function () {
    var tmp = 0;
    var tmp_0 = this._this$0_28._size_5;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp_3 = this._this$0_28.newInstance_0_k$();
      tmp_1[tmp_2] = isObject(tmp_3) ? tmp_3 : THROW_CCE();
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
  _no_name_provided__105.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function OrderedStack(size_2, argContainerSize) {
    this._size_5 = size_2;
    var tmp = this;
    tmp._pool$delegate = lazy(_no_name_provided_$factory_84(this));
    this._index_13 = 0;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = argContainerSize;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = Unit_getInstance();
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._container = tmp_3;
  }
  OrderedStack.prototype.pop_0_k$ = function () {
    var tmp0_assert_0 = this._index_13 < this._size_5;
    if (!tmp0_assert_0) {
      var message_2_1_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
    }var tmp = _get_pool_(this);
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_13;
    tmp0_this._index_13 = tmp1 + 1 | 0;
    var tmp_0 = tmp[tmp1];
    return isObject(tmp_0) ? tmp_0 : THROW_CCE();
  };
  OrderedStack.prototype.push_majfzk_k$ = function (argNum) {
    var tmp0_this = this;
    tmp0_this._index_13 = tmp0_this._index_13 - argNum | 0;
    var tmp0_assert_0 = this._index_13 >= 0;
    if (!tmp0_assert_0) {
      var message_2_1_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
    }};
  OrderedStack.$metadata$ = {
    simpleName: 'OrderedStack',
    kind: 'class',
    interfaces: []
  };
  function pool$factory() {
    return getPropertyCallableRef('pool', 1, KProperty1, function (receiver) {
      return _get_pool_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_84(this$0) {
    var i = new _no_name_provided__105(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function Key_1() {
  }
  Key_1.$metadata$ = {
    simpleName: 'Key',
    kind: 'class',
    interfaces: []
  };
  function Mixin_0() {
    this._typedUserData = null;
  }
  Mixin_0.prototype.get_3xhjti_k$ = function (key) {
    var tmp0_safe_receiver = this._typedUserData;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_2bw_k$(key);
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  Mixin_0.prototype.set_fm38x_k$ = function (key, value) {
    if (!(value == null)) {
      if (this._typedUserData == null)
        this._typedUserData = LinkedHashMap_init_$Create$();
      var tmp0_safe_receiver = this._typedUserData;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.put_1q9pf_k$(key, value);
        Unit_getInstance();
      }
      Unit_getInstance();
    } else {
      var tmp1_safe_receiver = this._typedUserData;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver.remove_2bw_k$(key);
      Unit_getInstance();
    }
  };
  Mixin_0.$metadata$ = {
    simpleName: 'Mixin',
    kind: 'class',
    interfaces: [Box2dTypedUserData]
  };
  function Box2dTypedUserData() {
  }
  Box2dTypedUserData.$metadata$ = {
    simpleName: 'Box2dTypedUserData',
    kind: 'interface',
    interfaces: []
  };
  function System_nanoTime() {
    return numberToLong(Date.now()).times_wiekkq_k$(new Long(1000000, 0));
  }
  function Companion_82() {
    Companion_instance_81 = this;
    this._DEFAULT_FORMAT = Companion_getInstance_81().invoke_6wfw3l_k$('EEE, dd MMM yyyy HH:mm:ss z');
    this._FORMAT1 = Companion_getInstance_81().invoke_6wfw3l_k$("yyyy-MM-dd'T'HH:mm:ssXXX");
    this._FORMAT2 = Companion_getInstance_81().invoke_6wfw3l_k$("yyyy-MM-dd'T'HH:mm:ss.SSSZ");
    this._FORMAT_DATE = Companion_getInstance_81().invoke_6wfw3l_k$('yyyy-MM-dd');
    this._FORMATS = listOf([this._DEFAULT_FORMAT, this._FORMAT1, this._FORMAT2, this._FORMAT_DATE]);
  }
  Companion_82.prototype.invoke_6wfw3l_k$ = function (pattern) {
    return PatternDateFormat_init_$Create$(pattern, null, null, null, 14, null);
  };
  Companion_82.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_81;
  function Companion_getInstance_81() {
    if (Companion_instance_81 == null)
      new Companion_82();
    return Companion_instance_81;
  }
  function DateFormat() {
  }
  DateFormat.$metadata$ = {
    simpleName: 'DateFormat',
    kind: 'interface',
    interfaces: []
  };
  function format(_this_, dd) {
    return _this_.format_q2f7m8_k$(DateTime__toOffsetUnadjusted_impl(dd, Companion_getInstance_92().fromMinutes_ttklb2_k$(0.0)));
  }
  var DatePart_Year_instance;
  var DatePart_DayOfYear_instance;
  var DatePart_Month_instance;
  var DatePart_Day_instance;
  var DatePart_entriesInitialized;
  function DatePart_initEntries() {
    if (DatePart_entriesInitialized)
      return Unit_getInstance();
    DatePart_entriesInitialized = true;
    DatePart_Year_instance = new DatePart('Year', 0);
    DatePart_DayOfYear_instance = new DatePart('DayOfYear', 1);
    DatePart_Month_instance = new DatePart('Month', 2);
    DatePart_Day_instance = new DatePart('Day', 3);
  }
  function DatePart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  DatePart.$metadata$ = {
    simpleName: 'DatePart',
    kind: 'class',
    interfaces: []
  };
  function timeToMillisUnchecked($this, hour, minute, second) {
    return hour * 3600000 + minute * 60000 + second * 1000;
  }
  function DatePart_Year_getInstance() {
    DatePart_initEntries();
    return DatePart_Year_instance;
  }
  function DatePart_DayOfYear_getInstance() {
    DatePart_initEntries();
    return DatePart_DayOfYear_instance;
  }
  function DatePart_Month_getInstance() {
    DatePart_initEntries();
    return DatePart_Month_instance;
  }
  function DatePart_Day_getInstance() {
    DatePart_initEntries();
    return DatePart_Day_instance;
  }
  function _DateTime___init__impl_(unixMillis) {
    return unixMillis;
  }
  function _DateTime___get_unixMillis__impl_(this_0) {
    return this_0;
  }
  function Companion_83() {
    Companion_instance_82 = this;
    this._serialVersionUID_4 = new Long(1, 0);
    this._EPOCH = _DateTime___init__impl_(0.0);
    this._EPOCH_INTERNAL_MILLIS = 6.21355968E13;
  }
  Companion_83.prototype.createAdjusted_y89drc_k$ = function (year, month, day, hour, minute, second, milliseconds) {
    var dy = year;
    var dm = month;
    var dd = day;
    var th = hour;
    var tm = minute;
    var ts = second;
    tm = tm + cycleSteps(ts, 0, 59) | 0;
    ts = cycle(ts, 0, 59);
    th = th + cycleSteps(tm, 0, 59) | 0;
    tm = cycle(tm, 0, 59);
    dd = dd + cycleSteps(th, 0, 23) | 0;
    th = cycle(th, 0, 23);
    $l$break: while (true) {
      var dup = Companion_getInstance_88().invoke_ha5a7z_k$(dm).days_ha5a7z_k$(dy);
      dm = dm + cycleSteps(dd, 1, dup) | 0;
      dd = cycle(dd, 1, dup);
      dy = dy + cycleSteps(dm, 1, 12) | 0;
      dm = cycle(dm, 1, 12);
      if (cycle(dd, 1, Companion_getInstance_88().invoke_ha5a7z_k$(dm).days_ha5a7z_k$(dy)) === dd) {
        break $l$break;
      }}
    return this.createUnchecked_y89drc_k$(dy, dm, dd, th, tm, ts, milliseconds);
  };
  Companion_83.prototype.createAdjusted$default_24ynig_k$ = function (year, month, day, hour, minute, second, milliseconds, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      hour = 0;
    if (!(($mask0 & 16) === 0))
      minute = 0;
    if (!(($mask0 & 32) === 0))
      second = 0;
    if (!(($mask0 & 64) === 0))
      milliseconds = 0;
    return this.createAdjusted_y89drc_k$(year, month, day, hour, minute, second, milliseconds);
  };
  Companion_83.prototype.createUnchecked_y89drc_k$ = function (year, month, day, hour, minute, second, milliseconds) {
    return _DateTime___init__impl_(Companion_getInstance_82().dateToMillisUnchecked_fcwjfj_k$(year, month, day) + timeToMillisUnchecked(Companion_getInstance_82(), hour, minute, second) + milliseconds);
  };
  Companion_83.prototype.fromUnix_y6lwjq_k$ = function (unix) {
    return _DateTime___init__impl_(unix);
  };
  Companion_83.prototype.now_utobi1_k$ = function () {
    return _DateTime___init__impl_(KlockInternal_getInstance()._get_currentTime__0_k$());
  };
  Companion_83.prototype.dateToMillisUnchecked_fcwjfj_k$ = function (year, month, day) {
    return (((_Year___get_daysSinceOne__impl_(_Year___init__impl_(year)) + Companion_getInstance_88().invoke_ha5a7z_k$(month).daysToStart_ha5a7z_k$(year) | 0) + day | 0) - 1 | 0) * 8.64E7 - 6.21355968E13;
  };
  Companion_83.prototype.getDatePart_ydqlpr_k$ = function (millis, part) {
    var totalDays = toInt2(millis / 86400000);
    var year = Companion_getInstance_95().fromDays_eros0m_k$(totalDays);
    if (part.equals(DatePart_Year_getInstance()))
      return _Year___get_year__impl_(year);
    var isLeap = _Year___get_isLeap__impl_(year);
    var startYearDays = _Year___get_daysSinceOne__impl_(year);
    var dayOfYear = 1 + umod_0(totalDays - startYearDays | 0, _Year___get_days__impl_(year)) | 0;
    if (part.equals(DatePart_DayOfYear_getInstance()))
      return dayOfYear;
    var tmp0_elvis_lhs = Companion_getInstance_88().fromDayOfYear_sv7uuf_k$(dayOfYear, isLeap);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = '' + 'Invalid dayOfYear=' + dayOfYear + ', isLeap=' + isLeap;
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var month = tmp;
    if (part.equals(DatePart_Month_getInstance()))
      return month._index1;
    var dayOfMonth = dayOfYear - month.daysToStart_vcj5fe_k$(isLeap) | 0;
    if (part.equals(DatePart_Day_getInstance()))
      return dayOfMonth;
    throw IllegalStateException_init_$Create$_0('Invalid DATE_PART');
  };
  Companion_83.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_82;
  function Companion_getInstance_82() {
    if (Companion_instance_82 == null)
      new Companion_83();
    return Companion_instance_82;
  }
  function _DateTime___get_yearOneMillis__impl_(this_0) {
    Companion_getInstance_82();
    return 6.21355968E13 + _DateTime___get_unixMillis__impl_(this_0);
  }
  function _DateTime___get_unixMillisDouble__impl_(this_0) {
    return _DateTime___get_unixMillis__impl_(this_0);
  }
  function _DateTime___get_year__impl_(this_0) {
    return _Year___init__impl_(_DateTime___get_yearInt__impl_(this_0));
  }
  function _DateTime___get_yearInt__impl_(this_0) {
    return Companion_getInstance_82().getDatePart_ydqlpr_k$(_DateTime___get_yearOneMillis__impl_(this_0), DatePart_Year_getInstance());
  }
  function _DateTime___get_month__impl_(this_0) {
    return Companion_getInstance_88().get_ha5a7z_k$(_DateTime___get_month1__impl_(this_0));
  }
  function _DateTime___get_month1__impl_(this_0) {
    return Companion_getInstance_82().getDatePart_ydqlpr_k$(_DateTime___get_yearOneMillis__impl_(this_0), DatePart_Month_getInstance());
  }
  function _DateTime___get_dayOfMonth__impl_(this_0) {
    return Companion_getInstance_82().getDatePart_ydqlpr_k$(_DateTime___get_yearOneMillis__impl_(this_0), DatePart_Day_getInstance());
  }
  function _DateTime___get_dayOfWeek__impl_(this_0) {
    return Companion_getInstance_84().get_ha5a7z_k$(_DateTime___get_dayOfWeekInt__impl_(this_0));
  }
  function _DateTime___get_dayOfWeekInt__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0) / 86400000 + 1, 7);
  }
  function _DateTime___get_hours__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0) / 3600000, 24);
  }
  function _DateTime___get_minutes__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0) / 60000, 60);
  }
  function _DateTime___get_seconds__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0) / 1000, 60);
  }
  function _DateTime___get_milliseconds__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0), 1000);
  }
  function DateTime__toOffsetUnadjusted_impl(this_0, offset_0) {
    return DateTime__toOffsetUnadjusted_impl_0(this_0, _get_offset_(offset_0));
  }
  function DateTime__toOffsetUnadjusted_impl_0(this_0, offset_0) {
    return Companion_getInstance_83().local_2oik2t_k$(this_0, offset_0);
  }
  function DateTime__plus_impl(this_0, delta_0) {
    return DateTime__add_impl(this_0, 0, _TimeSpan___get_milliseconds__impl_(delta_0));
  }
  function DateTime__minus_impl(this_0, delta_0) {
    return DateTime__plus_impl(this_0, TimeSpan__unaryMinus_impl(delta_0));
  }
  function DateTime__minus_impl_0(this_0, other) {
    var tmp0__get_milliseconds__0 = _DateTime___get_unixMillisDouble__impl_(this_0) - _DateTime___get_unixMillisDouble__impl_(other);
    return Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp0__get_milliseconds__0);
  }
  function DateTime__compareTo_impl(this_0, other) {
    return compareTo(_DateTime___get_unixMillis__impl_(this_0), _DateTime___get_unixMillis__impl_(other));
  }
  function DateTime__compareTo_impl_0(this_0, other) {
    var tmp = this_0._unixMillis;
    return DateTime__compareTo_impl(tmp, other instanceof DateTime ? other._unixMillis : THROW_CCE());
  }
  function DateTime__add_impl(this_0, deltaMonths, deltaMilliseconds) {
    var tmp;
    if (deltaMonths === 0 ? deltaMilliseconds === 0.0 : false) {
      tmp = this_0;
    } else if (deltaMonths === 0) {
      tmp = _DateTime___init__impl_(_DateTime___get_unixMillis__impl_(this_0) + deltaMilliseconds);
    } else {
      var year = _DateTime___get_year__impl_(this_0);
      var month = _DateTime___get_month__impl_(this_0)._index1;
      var day = _DateTime___get_dayOfMonth__impl_(this_0);
      var i = (month - 1 | 0) + deltaMonths | 0;
      if (i >= 0) {
        Companion_getInstance_88();
        month = i % 12 + 1 | 0;
        var tmp_0 = year;
        Companion_getInstance_88();
        year = Year__plus_impl(tmp_0, i / 12 | 0);
      } else {
        Companion_getInstance_88();
        var tmp_1 = i + 1 | 0;
        Companion_getInstance_88();
        month = 12 + tmp_1 % 12 | 0;
        var tmp_2 = year;
        Companion_getInstance_88();
        var tmp_3 = i - (12 - 1 | 0) | 0;
        Companion_getInstance_88();
        year = Year__plus_impl(tmp_2, tmp_3 / 12 | 0);
      }
      var days = Companion_getInstance_88().invoke_ha5a7z_k$(month).days_i0fyvo_k$(year);
      if (day > days)
        day = days;
      tmp = _DateTime___init__impl_(Companion_getInstance_82().dateToMillisUnchecked_fcwjfj_k$(_Year___get_year__impl_(year), month, day) + _DateTime___get_yearOneMillis__impl_(this_0) % 86400000 + deltaMilliseconds);
    }
    return tmp;
  }
  function DateTime__toString_impl(this_0) {
    return format(Companion_getInstance_81()._DEFAULT_FORMAT, this_0);
  }
  function DateTime__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function DateTime__equals_impl(this_0, other) {
    if (!(other instanceof DateTime))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DateTime ? other._unixMillis : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function DateTime(unixMillis) {
    Companion_getInstance_82();
    this._unixMillis = unixMillis;
  }
  DateTime.prototype.compareTo_puc0wa_k$ = function (other) {
    return DateTime__compareTo_impl(this._unixMillis, other);
  };
  DateTime.prototype.compareTo_2c5_k$ = function (other) {
    return DateTime__compareTo_impl_0(this, other);
  };
  DateTime.prototype.toString = function () {
    return DateTime__toString_impl(this._unixMillis);
  };
  DateTime.prototype.hashCode = function () {
    return DateTime__hashCode_impl(this._unixMillis);
  };
  DateTime.prototype.equals = function (other) {
    return DateTime__equals_impl(this._unixMillis, other);
  };
  DateTime.$metadata$ = {
    simpleName: 'DateTime',
    kind: 'class',
    interfaces: [Comparable, Serializable_0]
  };
  function Companion_84() {
    Companion_instance_83 = this;
    this._serialVersionUID_5 = new Long(1, 0);
  }
  Companion_84.prototype.local_2oik2t_k$ = function (local, offset_0) {
    return new DateTimeTz(local, offset_0);
  };
  Companion_84.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_83;
  function Companion_getInstance_83() {
    if (Companion_instance_83 == null)
      new Companion_84();
    return Companion_instance_83;
  }
  function DateTimeTz(adjusted, offset_0) {
    Companion_getInstance_83();
    this._adjusted = adjusted;
    this._offset = offset_0;
  }
  DateTimeTz.prototype._get_local__utobi1_k$ = function () {
    return this._adjusted;
  };
  DateTimeTz.prototype._get_utc__utobi1_k$ = function () {
    return DateTime__minus_impl(this._adjusted, _TimezoneOffset___get_time__impl_(this._offset));
  };
  DateTimeTz.prototype.hashCode = function () {
    return DateTime__hashCode_impl(this._get_local__utobi1_k$()) + _TimezoneOffset___get_totalMinutesInt__impl_(this._offset) | 0;
  };
  DateTimeTz.prototype.equals = function (other) {
    var tmp;
    if (other instanceof DateTimeTz) {
      tmp = _DateTime___get_unixMillisDouble__impl_(this._get_utc__utobi1_k$()) === _DateTime___get_unixMillisDouble__impl_(other._get_utc__utobi1_k$());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  DateTimeTz.prototype.compareTo_q2f7m8_k$ = function (other) {
    return compareTo(_DateTime___get_unixMillis__impl_(this._get_utc__utobi1_k$()), _DateTime___get_unixMillis__impl_(other._get_utc__utobi1_k$()));
  };
  DateTimeTz.prototype.compareTo_2c5_k$ = function (other) {
    return this.compareTo_q2f7m8_k$(other instanceof DateTimeTz ? other : THROW_CCE());
  };
  DateTimeTz.prototype.toString = function () {
    return Companion_getInstance_81()._DEFAULT_FORMAT.format_q2f7m8_k$(this);
  };
  DateTimeTz.$metadata$ = {
    simpleName: 'DateTimeTz',
    kind: 'class',
    interfaces: [Comparable, Serializable_0]
  };
  var DayOfWeek_Sunday_instance;
  var DayOfWeek_Monday_instance;
  var DayOfWeek_Tuesday_instance;
  var DayOfWeek_Wednesday_instance;
  var DayOfWeek_Thursday_instance;
  var DayOfWeek_Friday_instance;
  var DayOfWeek_Saturday_instance;
  function Companion_85() {
    Companion_instance_84 = this;
    this._serialVersionUID_6 = new Long(1, 0);
    this._Count = 7;
    this._BY_INDEX0 = values_2();
  }
  Companion_85.prototype.get_ha5a7z_k$ = function (index0) {
    return this._BY_INDEX0[umod_0(index0, 7)];
  };
  Companion_85.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_84;
  function Companion_getInstance_84() {
    if (Companion_instance_84 == null)
      new Companion_85();
    return Companion_instance_84;
  }
  function values_2() {
    return [DayOfWeek_Sunday_getInstance(), DayOfWeek_Monday_getInstance(), DayOfWeek_Tuesday_getInstance(), DayOfWeek_Wednesday_getInstance(), DayOfWeek_Thursday_getInstance(), DayOfWeek_Friday_getInstance(), DayOfWeek_Saturday_getInstance()];
  }
  var DayOfWeek_entriesInitialized;
  function DayOfWeek_initEntries() {
    if (DayOfWeek_entriesInitialized)
      return Unit_getInstance();
    DayOfWeek_entriesInitialized = true;
    DayOfWeek_Sunday_instance = new DayOfWeek('Sunday', 0, 0);
    DayOfWeek_Monday_instance = new DayOfWeek('Monday', 1, 1);
    DayOfWeek_Tuesday_instance = new DayOfWeek('Tuesday', 2, 2);
    DayOfWeek_Wednesday_instance = new DayOfWeek('Wednesday', 3, 3);
    DayOfWeek_Thursday_instance = new DayOfWeek('Thursday', 4, 4);
    DayOfWeek_Friday_instance = new DayOfWeek('Friday', 5, 5);
    DayOfWeek_Saturday_instance = new DayOfWeek('Saturday', 6, 6);
    Companion_getInstance_84();
  }
  function DayOfWeek(name, ordinal, index0) {
    Enum.call(this, name, ordinal);
    this._index0 = index0;
  }
  DayOfWeek.prototype.index0Locale_34479d_k$ = function (locale) {
    return umod_0(this._index0 - locale._get_firstDayOfWeek__0_k$()._index0 | 0, 7);
  };
  DayOfWeek.prototype.localName_34479d_k$ = function (locale) {
    return locale._get_daysOfWeek__0_k$().get_ha5a7z_k$(this._index0);
  };
  DayOfWeek.prototype.localShortName_34479d_k$ = function (locale) {
    return locale._get_daysOfWeekShort__0_k$().get_ha5a7z_k$(this._index0);
  };
  DayOfWeek.$metadata$ = {
    simpleName: 'DayOfWeek',
    kind: 'class',
    interfaces: [Serializable_0]
  };
  function DayOfWeekWithLocale(dayOfWeek, locale) {
    this._dayOfWeek = dayOfWeek;
    this._locale = locale;
  }
  DayOfWeekWithLocale.prototype.compareTo_y8lq0_k$ = function (other) {
    if (!equals_1(other._locale, this._locale)) {
      throw IllegalStateException_init_$Create$_0("Can't compare two day of weeks with different locales");
    }return this._locale._daysOfWeekComparator.compare(this._dayOfWeek, other._dayOfWeek);
  };
  DayOfWeekWithLocale.prototype.compareTo_2c5_k$ = function (other) {
    return this.compareTo_y8lq0_k$(other instanceof DayOfWeekWithLocale ? other : THROW_CCE());
  };
  DayOfWeekWithLocale.prototype.toString = function () {
    return '' + 'DayOfWeekWithLocale(dayOfWeek=' + this._dayOfWeek + ', locale=' + this._locale + ')';
  };
  DayOfWeekWithLocale.prototype.hashCode = function () {
    var result = this._dayOfWeek.hashCode();
    result = imul(result, 31) + hashCode(this._locale) | 0;
    return result;
  };
  DayOfWeekWithLocale.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DayOfWeekWithLocale))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DayOfWeekWithLocale ? other : THROW_CCE();
    if (!this._dayOfWeek.equals(tmp0_other_with_cast._dayOfWeek))
      return false;
    if (!equals_1(this._locale, tmp0_other_with_cast._locale))
      return false;
    return true;
  };
  DayOfWeekWithLocale.$metadata$ = {
    simpleName: 'DayOfWeekWithLocale',
    kind: 'class',
    interfaces: [Comparable]
  };
  function DayOfWeek_Sunday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Sunday_instance;
  }
  function DayOfWeek_Monday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Monday_instance;
  }
  function DayOfWeek_Tuesday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Tuesday_instance;
  }
  function DayOfWeek_Wednesday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Wednesday_instance;
  }
  function DayOfWeek_Thursday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Thursday_instance;
  }
  function DayOfWeek_Friday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Friday_instance;
  }
  function DayOfWeek_Saturday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Saturday_instance;
  }
  function _Frequency___init__impl_(hertz) {
    return hertz;
  }
  function _Frequency___get_hertz__impl_(this_0) {
    return this_0;
  }
  function _Frequency___get_timeSpan__impl_(this_0) {
    var tmp0__get_seconds__0 = 1.0 / _Frequency___get_hertz__impl_(this_0);
    return Companion_getInstance_92().fromSeconds_ttklb2_k$(tmp0__get_seconds__0);
  }
  function toFrequency(_this_) {
    return _get_timesPerSecond__0(_this_);
  }
  function _get_timesPerSecond_(_this_) {
    return _Frequency___init__impl_(_this_);
  }
  function _get_timesPerSecond__0(_this_) {
    return _Frequency___init__impl_(1.0 / _TimeSpan___get_seconds__impl_(_this_));
  }
  var KlockLocale_default;
  function Companion_86() {
    Companion_instance_85 = this;
    English.call(this);
  }
  Companion_86.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_85;
  function Companion_getInstance_85() {
    if (Companion_instance_85 == null)
      new Companion_86();
    return Companion_instance_85;
  }
  function Companion_87() {
    Companion_instance_86 = this;
  }
  Companion_87.prototype._get_default__0_k$ = function () {
    return KlockLocale_default;
  };
  Companion_87.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_86;
  function Companion_getInstance_86() {
    if (Companion_instance_86 == null)
      new Companion_87();
    return Companion_instance_86;
  }
  function English() {
    Companion_getInstance_85();
    KlockLocale.call(this);
    this._ISO639_1 = 'en';
    this._firstDayOfWeek = DayOfWeek_Sunday_getInstance();
    this._daysOfWeek = listOf(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']);
    this._months = listOf(['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']);
    this._formatTimeMedium = this.format_6wfw3l_k$('h:mm:ss a');
    this._formatTimeShort = this.format_6wfw3l_k$('h:mm a');
  }
  English.prototype._get_firstDayOfWeek__0_k$ = function () {
    return this._firstDayOfWeek;
  };
  English.prototype._get_daysOfWeek__0_k$ = function () {
    return this._daysOfWeek;
  };
  English.prototype._get_months__0_k$ = function () {
    return this._months;
  };
  English.$metadata$ = {
    simpleName: 'English',
    kind: 'class',
    interfaces: []
  };
  function sam$kotlin_Comparator$0_0(function_0) {
    this._function_0 = function_0;
  }
  sam$kotlin_Comparator$0_0.prototype.compare_1qgdm_k$ = function (a, b) {
    return this._function_0(a, b);
  };
  sam$kotlin_Comparator$0_0.prototype.compare = function (a, b) {
    return this.compare_1qgdm_k$(a, b);
  };
  sam$kotlin_Comparator$0_0.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__106(this$0) {
    this._this$0_29 = this$0;
  }
  _no_name_provided__106.prototype.invoke_0_k$ = function () {
    var tmp0_map_0 = this._this$0_29._get_months__0_k$();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(substr(item_2_3, 0, 3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  };
  _no_name_provided__106.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__107(this$0) {
    this._this$0_30 = this$0;
  }
  _no_name_provided__107.prototype.invoke_0_k$ = function () {
    var tmp0_map_0 = this._this$0_30._get_daysOfWeek__0_k$();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(substr(item_2_3, 0, 3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  };
  _no_name_provided__107.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__108(this$0) {
    this._this$0_31 = this$0;
  }
  _no_name_provided__108.prototype.invoke_5ba9s0_k$ = function (a, b) {
    return compareTo(a.index0Locale_34479d_k$(this._this$0_31), b.index0Locale_34479d_k$(this._this$0_31));
  };
  _no_name_provided__108.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof DayOfWeek ? p1 : THROW_CCE();
    return this.invoke_5ba9s0_k$(tmp, p2 instanceof DayOfWeek ? p2 : THROW_CCE());
  };
  _no_name_provided__108.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function KlockLocale() {
    Companion_getInstance_86();
    var tmp = this;
    tmp._monthsShort$delegate = klockLazyOrGet(_no_name_provided_$factory_85(this));
    var tmp_0 = this;
    tmp_0._daysOfWeekShort$delegate = klockLazyOrGet(_no_name_provided_$factory_86(this));
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = 7;
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      tmp_4[tmp_5] = new DayOfWeekWithLocale(Companion_getInstance_84().get_ha5a7z_k$(tmp_5), this);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1._daysOfWeekWithLocaleList = tmp_4;
    var tmp_6 = this;
    var tmp_7 = _no_name_provided_$factory_87(this);
    tmp_6._daysOfWeekComparator = new sam$kotlin_Comparator$0_0(tmp_7);
    var tmp_8 = this;
    var tmp_9 = 0;
    var tmp_10 = 32;
    var tmp_11 = fillArrayVal(Array(tmp_10), null);
    while (tmp_9 < tmp_10) {
      var tmp_12 = tmp_9;
      var tmp_13;
      if (11 <= tmp_12 ? tmp_12 <= 13 : false) {
        tmp_13 = '' + tmp_12 + 'th';
      } else {
        var tmp0_subject = tmp_12 % 10;
        switch (tmp0_subject) {
          case 1:
            tmp_13 = '' + tmp_12 + 'st';
            break;
          case 2:
            tmp_13 = '' + tmp_12 + 'nd';
            break;
          case 3:
            tmp_13 = '' + tmp_12 + 'rd';
            break;
          default:tmp_13 = '' + tmp_12 + 'th';
            break;
        }
      }
      tmp_11[tmp_12] = tmp_13;
      tmp_9 = tmp_9 + 1 | 0;
    }
    tmp_8._ordinals = tmp_11;
    this._h12Marker = listOf(['AM', 'OM']);
    this._formatDateTimeMedium = this.format_6wfw3l_k$('MMM d, y h:mm:ss a');
    this._formatDateTimeShort = this.format_6wfw3l_k$('M/d/yy h:mm a');
    this._formatDateFull = this.format_6wfw3l_k$('EEEE, MMMM d, y');
    this._formatDateLong = this.format_6wfw3l_k$('MMMM d, y');
    this._formatDateMedium = this.format_6wfw3l_k$('MMM d, y');
    this._formatDateShort = this.format_6wfw3l_k$('M/d/yy');
    this._formatTimeMedium_0 = this.format_6wfw3l_k$('HH:mm:ss');
    this._formatTimeShort_0 = this.format_6wfw3l_k$('HH:mm');
  }
  KlockLocale.prototype._get_daysOfWeekShort__0_k$ = function () {
    var tmp0_getValue_0 = daysOfWeekShort$factory();
    return this._daysOfWeekShort$delegate._get_value__0_k$();
  };
  KlockLocale.prototype._get_ordinals__0_k$ = function () {
    return this._ordinals;
  };
  KlockLocale.prototype.getOrdinalByDay_j8161d_k$ = function (day, context) {
    return this._get_ordinals__0_k$()[day];
  };
  KlockLocale.prototype.getOrdinalByDay$default_q7p5ri_k$ = function (day, context, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      context = Companion_getInstance_87()._Default;
    return $handler == null ? this.getOrdinalByDay_j8161d_k$(day, context) : $handler(day, context);
  };
  KlockLocale.prototype.format_6wfw3l_k$ = function (str) {
    return PatternDateFormat_init_$Create$(str, this, null, null, 12, null);
  };
  KlockLocale.$metadata$ = {
    simpleName: 'KlockLocale',
    kind: 'class',
    interfaces: []
  };
  function daysOfWeekShort$factory() {
    return getPropertyCallableRef('daysOfWeekShort', 1, KProperty1, function (receiver) {
      return receiver._get_daysOfWeekShort__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_85(this$0) {
    var i = new _no_name_provided__106(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_86(this$0) {
    var i = new _no_name_provided__107(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_87(this$0) {
    var i = new _no_name_provided__108(this$0);
    return function (p1, p2) {
      return i.invoke_5ba9s0_k$(p1, p2);
    };
  }
  function KlockLocaleContext_init_$Init$(gender, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      gender = KlockLocaleGender_Neuter_getInstance();
    KlockLocaleContext.call($this, gender);
    return $this;
  }
  function KlockLocaleContext_init_$Create$(gender, $mask0, $marker) {
    return KlockLocaleContext_init_$Init$(gender, $mask0, $marker, Object.create(KlockLocaleContext.prototype));
  }
  function Companion_88() {
    Companion_instance_87 = this;
    var tmp = this;
    tmp._Default = KlockLocaleContext_init_$Create$(null, 1, null);
  }
  Companion_88.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_87;
  function Companion_getInstance_87() {
    if (Companion_instance_87 == null)
      new Companion_88();
    return Companion_instance_87;
  }
  function KlockLocaleContext(gender) {
    Companion_getInstance_87();
    this._gender = gender;
  }
  KlockLocaleContext.prototype.toString = function () {
    return '' + 'KlockLocaleContext(gender=' + this._gender + ')';
  };
  KlockLocaleContext.prototype.hashCode = function () {
    return this._gender.hashCode();
  };
  KlockLocaleContext.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KlockLocaleContext))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof KlockLocaleContext ? other : THROW_CCE();
    if (!this._gender.equals(tmp0_other_with_cast._gender))
      return false;
    return true;
  };
  KlockLocaleContext.$metadata$ = {
    simpleName: 'KlockLocaleContext',
    kind: 'class',
    interfaces: []
  };
  var KlockLocaleGender_Neuter_instance;
  var KlockLocaleGender_Masculine_instance;
  var KlockLocaleGender_entriesInitialized;
  function KlockLocaleGender_initEntries() {
    if (KlockLocaleGender_entriesInitialized)
      return Unit_getInstance();
    KlockLocaleGender_entriesInitialized = true;
    KlockLocaleGender_Neuter_instance = new KlockLocaleGender('Neuter', 0);
    KlockLocaleGender_Masculine_instance = new KlockLocaleGender('Masculine', 1);
  }
  function KlockLocaleGender(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  KlockLocaleGender.$metadata$ = {
    simpleName: 'KlockLocaleGender',
    kind: 'class',
    interfaces: []
  };
  function KlockLocaleGender_Neuter_getInstance() {
    KlockLocaleGender_initEntries();
    return KlockLocaleGender_Neuter_instance;
  }
  function TimedResult(result, time) {
    this._result_1 = result;
    this._time = time;
  }
  TimedResult.prototype.component1_0_k$ = function () {
    return this._result_1;
  };
  TimedResult.prototype.component2_nsqrdp_k$ = function () {
    return this._time;
  };
  TimedResult.prototype.toString = function () {
    return '' + 'TimedResult(result=' + this._result_1 + ', time=' + new TimeSpan(this._time) + ')';
  };
  TimedResult.prototype.hashCode = function () {
    var result = this._result_1 == null ? 0 : hashCode(this._result_1);
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._time) | 0;
    return result;
  };
  TimedResult.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TimedResult))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TimedResult ? other : THROW_CCE();
    if (!equals_1(this._result_1, tmp0_other_with_cast._result_1))
      return false;
    if (!equals_1(new TimeSpan(this._time), new TimeSpan(tmp0_other_with_cast._time)))
      return false;
    return true;
  };
  TimedResult.$metadata$ = {
    simpleName: 'TimedResult',
    kind: 'class',
    interfaces: []
  };
  function YEAR_DAYS($this, isLeap) {
    return isLeap ? $this._YEAR_DAYS_LEAP : $this._YEAR_DAYS_COMMON;
  }
  function generateDaysToStart($this, leap) {
    var total = 0;
    var tmp = 0;
    var tmp_0 = 13;
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      total = total + (tmp_2 === 0 ? 0 : Companion_getInstance_88()._BY_INDEX0_0[tmp_2 - 1 | 0].days_vcj5fe_k$(leap)) | 0;
      tmp_1[tmp_2] = total;
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function Month_init_$Init$(name, ordinal, index1, daysCommon, daysLeap, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      daysLeap = daysCommon;
    Month.call($this, name, ordinal, index1, daysCommon, daysLeap);
    return $this;
  }
  function Month_init_$Create$(name, ordinal, index1, daysCommon, daysLeap, $mask0, $marker) {
    return Month_init_$Init$(name, ordinal, index1, daysCommon, daysLeap, $mask0, $marker, Object.create(Month.prototype));
  }
  var Month_January_instance;
  var Month_February_instance;
  var Month_March_instance;
  var Month_April_instance;
  var Month_May_instance;
  var Month_June_instance;
  var Month_July_instance;
  var Month_August_instance;
  var Month_September_instance;
  var Month_October_instance;
  var Month_November_instance;
  var Month_December_instance;
  function Companion_89() {
    Companion_instance_88 = this;
    this._serialVersionUID_7 = new Long(1, 0);
    this._Count_0 = 12;
    this._BY_INDEX0_0 = values_3();
    this._YEAR_DAYS_LEAP = generateDaysToStart(this, true);
    this._YEAR_DAYS_COMMON = generateDaysToStart(this, false);
  }
  Companion_89.prototype.invoke_ha5a7z_k$ = function (index1) {
    return this.adjusted_ha5a7z_k$(index1);
  };
  Companion_89.prototype.get_ha5a7z_k$ = function (index1) {
    return this.adjusted_ha5a7z_k$(index1);
  };
  Companion_89.prototype.adjusted_ha5a7z_k$ = function (index1) {
    return this._BY_INDEX0_0[umod_0(index1 - 1 | 0, 12)];
  };
  Companion_89.prototype.fromDayOfYear_sv7uuf_k$ = function (dayOfYear, leap) {
    var days = YEAR_DAYS(this, leap);
    var day0 = dayOfYear - 1 | 0;
    var guess = day0 / 32 | 0;
    var tmp;
    if (0 <= guess ? guess <= 11 : false) {
      var containsLower = days[guess];
      tmp = day0 < days[guess + 1 | 0] ? containsLower <= day0 : false;
    } else {
      tmp = false;
    }
    if (tmp)
      return Companion_getInstance_88().get_ha5a7z_k$(guess + 1 | 0);
    else {
    }
    var tmp_0;
    if (0 <= guess ? guess <= 10 : false) {
      var containsLower_0 = days[guess + 1 | 0];
      tmp_0 = day0 < days[guess + 2 | 0] ? containsLower_0 <= day0 : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0)
      return Companion_getInstance_88().get_ha5a7z_k$(guess + 2 | 0);
    else {
    }
    return null;
  };
  Companion_89.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_88;
  function Companion_getInstance_88() {
    if (Companion_instance_88 == null)
      new Companion_89();
    return Companion_instance_88;
  }
  function values_3() {
    return [Month_January_getInstance(), Month_February_getInstance(), Month_March_getInstance(), Month_April_getInstance(), Month_May_getInstance(), Month_June_getInstance(), Month_July_getInstance(), Month_August_getInstance(), Month_September_getInstance(), Month_October_getInstance(), Month_November_getInstance(), Month_December_getInstance()];
  }
  var Month_entriesInitialized;
  function Month_initEntries() {
    if (Month_entriesInitialized)
      return Unit_getInstance();
    Month_entriesInitialized = true;
    Month_January_instance = Month_init_$Create$('January', 0, 1, 31, 0, 16, null);
    Month_February_instance = new Month('February', 1, 2, 28, 29);
    Month_March_instance = Month_init_$Create$('March', 2, 3, 31, 0, 16, null);
    Month_April_instance = Month_init_$Create$('April', 3, 4, 30, 0, 16, null);
    Month_May_instance = Month_init_$Create$('May', 4, 5, 31, 0, 16, null);
    Month_June_instance = Month_init_$Create$('June', 5, 6, 30, 0, 16, null);
    Month_July_instance = Month_init_$Create$('July', 6, 7, 31, 0, 16, null);
    Month_August_instance = Month_init_$Create$('August', 7, 8, 31, 0, 16, null);
    Month_September_instance = Month_init_$Create$('September', 8, 9, 30, 0, 16, null);
    Month_October_instance = Month_init_$Create$('October', 9, 10, 31, 0, 16, null);
    Month_November_instance = Month_init_$Create$('November', 10, 11, 30, 0, 16, null);
    Month_December_instance = Month_init_$Create$('December', 11, 12, 31, 0, 16, null);
    Companion_getInstance_88();
  }
  function Month(name, ordinal, index1, daysCommon, daysLeap) {
    Enum.call(this, name, ordinal);
    this._index1 = index1;
    this._daysCommon = daysCommon;
    this._daysLeap = daysLeap;
  }
  Month.prototype._get_index0__0_k$ = function () {
    return this._index1 - 1 | 0;
  };
  Month.prototype.days_vcj5fe_k$ = function (leap) {
    return leap ? this._daysLeap : this._daysCommon;
  };
  Month.prototype.days_ha5a7z_k$ = function (year) {
    return this.days_vcj5fe_k$(_Year___get_isLeap__impl_(_Year___init__impl_(year)));
  };
  Month.prototype.days_i0fyvo_k$ = function (year) {
    return this.days_vcj5fe_k$(_Year___get_isLeap__impl_(year));
  };
  Month.prototype.daysToStart_vcj5fe_k$ = function (leap) {
    return YEAR_DAYS(Companion_getInstance_88(), leap)[this._get_index0__0_k$()];
  };
  Month.prototype.daysToStart_ha5a7z_k$ = function (year) {
    return this.daysToStart_vcj5fe_k$(_Year___get_isLeap__impl_(_Year___init__impl_(year)));
  };
  Month.prototype.localName_34479d_k$ = function (locale) {
    return locale._get_months__0_k$().get_ha5a7z_k$(this._get_index0__0_k$());
  };
  Month.$metadata$ = {
    simpleName: 'Month',
    kind: 'class',
    interfaces: [Serializable_0]
  };
  function Month_January_getInstance() {
    Month_initEntries();
    return Month_January_instance;
  }
  function Month_February_getInstance() {
    Month_initEntries();
    return Month_February_instance;
  }
  function Month_March_getInstance() {
    Month_initEntries();
    return Month_March_instance;
  }
  function Month_April_getInstance() {
    Month_initEntries();
    return Month_April_instance;
  }
  function Month_May_getInstance() {
    Month_initEntries();
    return Month_May_instance;
  }
  function Month_June_getInstance() {
    Month_initEntries();
    return Month_June_instance;
  }
  function Month_July_getInstance() {
    Month_initEntries();
    return Month_July_instance;
  }
  function Month_August_getInstance() {
    Month_initEntries();
    return Month_August_instance;
  }
  function Month_September_getInstance() {
    Month_initEntries();
    return Month_September_instance;
  }
  function Month_October_getInstance() {
    Month_initEntries();
    return Month_October_instance;
  }
  function Month_November_getInstance() {
    Month_initEntries();
    return Month_November_instance;
  }
  function Month_December_getInstance() {
    Month_initEntries();
    return Month_December_instance;
  }
  function Companion_90() {
    Companion_instance_89 = this;
    this._serialVersionUID_8 = new Long(1, 0);
    this._DEFAULT = new Options(false);
    this._WITH_OPTIONAL = new Options(true);
  }
  Companion_90.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_89;
  function Companion_getInstance_89() {
    if (Companion_instance_89 == null)
      new Companion_90();
    return Companion_instance_89;
  }
  function PatternDateFormat_init_$Init$(format_0, locale, tzNames, options, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      locale = null;
    if (!(($mask0 & 4) === 0))
      tzNames = Companion_getInstance_93()._DEFAULT_0;
    if (!(($mask0 & 8) === 0))
      options = Companion_getInstance_89()._DEFAULT;
    PatternDateFormat.call($this, format_0, locale, tzNames, options);
    return $this;
  }
  function PatternDateFormat_init_$Create$(format_0, locale, tzNames, options, $mask0, $marker) {
    return PatternDateFormat_init_$Init$(format_0, locale, tzNames, options, $mask0, $marker, Object.create(PatternDateFormat.prototype));
  }
  function Companion_91() {
    Companion_instance_90 = this;
    this._serialVersionUID_9 = new Long(1, 0);
  }
  Companion_91.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_90;
  function Companion_getInstance_90() {
    if (Companion_instance_90 == null)
      new Companion_91();
    return Companion_instance_90;
  }
  function Options(optionalSupport) {
    Companion_getInstance_89();
    this._optionalSupport = optionalSupport;
  }
  Options.prototype.toString = function () {
    return '' + 'Options(optionalSupport=' + this._optionalSupport + ')';
  };
  Options.prototype.hashCode = function () {
    return this._optionalSupport | 0;
  };
  Options.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Options))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Options ? other : THROW_CCE();
    if (!(this._optionalSupport === tmp0_other_with_cast._optionalSupport))
      return false;
    return true;
  };
  Options.$metadata$ = {
    simpleName: 'Options',
    kind: 'class',
    interfaces: [Serializable_0]
  };
  function PatternDateFormat(format_0, locale, tzNames, options) {
    Companion_getInstance_90();
    this._format = format_0;
    this._locale_0 = locale;
    this._tzNames = tzNames;
    this._options_0 = options;
    this._openOffsets = LinkedHashMap_init_$Create$();
    this._closeOffsets = LinkedHashMap_init_$Create$();
    var tmp = this;
    var tmp0_also_0 = ArrayList_init_$Create$();
    var s_2 = MicroStrReader_init_$Create$(this._format, 0, 2, null);
    while (s_2._get_hasMore__0_k$()) {
      if (s_2.peekChar_0_k$().equals(new Char(39))) {
        var start_1_4 = s_2._offset_0;
        s_2.tryRead_wi8o78_k$(new Char(39));
        Unit_getInstance();
        while (s_2._get_hasMore__0_k$() ? !s_2.readChar_0_k$().equals(new Char(39)) : false)
          Unit_getInstance();
        var end_2_5 = s_2._offset_0;
        var tmp0_substring_0_6 = s_2._str_0;
        var escapedChunk_3 = tmp0_substring_0_6.substring(start_1_4, end_2_5);
        tmp0_also_0.add_2bq_k$(escapedChunk_3);
        Unit_getInstance();
        continue;
      }if (this._options_0._optionalSupport) {
        var offset_7 = tmp0_also_0._get_size__0_k$();
        if (s_2.tryRead_wi8o78_k$(new Char(91))) {
          increment(this._openOffsets, offset_7);
          continue;
        }if (s_2.tryRead_wi8o78_k$(new Char(93))) {
          increment(this._closeOffsets, offset_7 - 1 | 0);
          continue;
        }}var tmp0_elvis_lhs_8 = s_2.tryReadOrNull_6wfw3l_k$('do');
      tmp0_also_0.add_2bq_k$(tmp0_elvis_lhs_8 == null ? readRepeatedChar(s_2) : tmp0_elvis_lhs_8);
      Unit_getInstance();
    }
    tmp._chunks = toList_3(tmp0_also_0);
    var tmp_0 = this;
    var tmp0_map_0 = this._chunks;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp0_subject_5 = item_2_3;
      var tmp_1;
      switch (tmp0_subject_5) {
        case 'E':
        case 'EE':
        case 'EEE':
        case 'EEEE':
        case 'EEEEE':
        case 'EEEEEE':
          tmp_1 = '(\\w+)';
          break;
        case 'z':
        case 'zzz':
          tmp_1 = '([\\w\\s\\-+:]+)';
          break;
        case 'do':
          tmp_1 = '(\\d{1,2}\\w+)';
          break;
        case 'd':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'dd':
          tmp_1 = '(\\d{2})';
          break;
        case 'M':
          tmp_1 = '(\\d{1,5})';
          break;
        case 'MM':
          tmp_1 = '(\\d{2})';
          break;
        case 'MMM':
        case 'MMMM':
        case 'MMMMM':
          tmp_1 = '(\\w+)';
          break;
        case 'y':
          tmp_1 = '(\\d{1,5})';
          break;
        case 'yy':
          tmp_1 = '(\\d{2})';
          break;
        case 'yyy':
          tmp_1 = '(\\d{3})';
          break;
        case 'yyyy':
          tmp_1 = '(\\d{4})';
          break;
        case 'YYYY':
          tmp_1 = '(\\d{4})';
          break;
        case 'H':
        case 'k':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'HH':
        case 'kk':
          tmp_1 = '(\\d{2})';
          break;
        case 'h':
        case 'K':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'hh':
        case 'KK':
          tmp_1 = '(\\d{2})';
          break;
        case 'm':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'mm':
          tmp_1 = '(\\d{2})';
          break;
        case 's':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'ss':
          tmp_1 = '(\\d{2})';
          break;
        case 'S':
          tmp_1 = '(\\d{1,6})';
          break;
        case 'SS':
          tmp_1 = '(\\d{2})';
          break;
        case 'SSS':
          tmp_1 = '(\\d{3})';
          break;
        case 'SSSS':
          tmp_1 = '(\\d{4})';
          break;
        case 'SSSSS':
          tmp_1 = '(\\d{5})';
          break;
        case 'SSSSSS':
          tmp_1 = '(\\d{6})';
          break;
        case 'SSSSSSS':
          tmp_1 = '(\\d{7})';
          break;
        case 'SSSSSSSS':
          tmp_1 = '(\\d{8})';
          break;
        case 'SSSSSSSSS':
          tmp_1 = '(\\d{9})';
          break;
        case 'X':
        case 'XX':
        case 'XXX':
        case 'x':
        case 'xx':
        case 'xxx':
          tmp_1 = '([\\w:\\+\\-]+)';
          break;
        case 'a':
          tmp_1 = '(\\w+)';
          break;
        case ' ':
          tmp_1 = '(\\s+)';
          break;
        default:var tmp_2;
          var tmp_3 = new Char(39);
          if (startsWith$default(item_2_3, tmp_3, false, 2, null)) {
            tmp_2 = '(' + Companion_getInstance_14().escape_6wfw3l_k$(substr(item_2_3, 1, item_2_3.length - 2 | 0)) + ')';
          } else {
            {
              tmp_2 = '(' + Companion_getInstance_14().escape_6wfw3l_k$(item_2_3) + ')';
            }
          }

          tmp_1 = tmp_2;
          break;
      }
      tmp0_mapTo_0_1.add_2bq_k$(tmp_1);
      Unit_getInstance();
    }
    tmp_0._regexChunks = tmp0_mapTo_0_1;
    this._rx2 = Regex_init_$Create$('^' + this.matchingRegexString_0_k$() + '$');
  }
  PatternDateFormat.prototype._get_realLocale__0_k$ = function () {
    var tmp0_elvis_lhs = this._locale_0;
    return tmp0_elvis_lhs == null ? Companion_getInstance_86()._get_default__0_k$() : tmp0_elvis_lhs;
  };
  PatternDateFormat.prototype.matchingRegexString_0_k$ = function () {
    var tmp0_mapIndexed_0 = this._regexChunks;
    var tmp0_mapIndexedTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_mapIndexed_0, 10));
    var index_1_2 = 0;
    var tmp0_iterator_2_3 = tmp0_mapIndexed_0.iterator_0_k$();
    while (tmp0_iterator_2_3.hasNext_0_k$()) {
      var item_3_4 = tmp0_iterator_2_3.next_0_k$();
      var tmp1_4_5 = index_1_2;
      index_1_2 = tmp1_4_5 + 1 | 0;
      var tmp1__anonymous__6 = checkIndexOverflow(tmp1_4_5);
      var tmp;
      if (this._options_0._optionalSupport) {
        var tmp0_getOrElse_0_8 = this._openOffsets;
        var tmp0_elvis_lhs_1_9 = tmp0_getOrElse_0_8.get_2bw_k$(tmp1__anonymous__6);
        var tmp_0;
        if (tmp0_elvis_lhs_1_9 == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = tmp0_elvis_lhs_1_9;
        }
        var opens_7 = tmp_0;
        var tmp1_getOrElse_0_11 = this._closeOffsets;
        var tmp0_elvis_lhs_1_12 = tmp1_getOrElse_0_11.get_2bw_k$(tmp1__anonymous__6);
        var tmp_1;
        if (tmp0_elvis_lhs_1_12 == null) {
          tmp_1 = 0;
        } else {
          tmp_1 = tmp0_elvis_lhs_1_12;
        }
        var closes_10 = tmp_1;
        var tmp0_apply_0_1_13 = StringBuilder_init_$Create$_0();
        var inductionVariable = 0;
        if (inductionVariable < opens_7)
          do {
            var index_2_4_15 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            tmp0_apply_0_1_13.append_uch40_k$('(?:');
            Unit_getInstance();
          }
           while (inductionVariable < opens_7);
        tmp0_apply_0_1_13.append_uch40_k$(item_3_4);
        Unit_getInstance();
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < closes_10)
          do {
            var index_2_6_17 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            tmp0_apply_0_1_13.append_uch40_k$(')?');
            Unit_getInstance();
          }
           while (inductionVariable_0 < closes_10);
        tmp = tmp0_apply_0_1_13.toString();
      } else {
        tmp = item_3_4;
      }
      tmp0_mapIndexedTo_0_1.add_2bq_k$(tmp);
      Unit_getInstance();
    }
    return joinToString$default_0(tmp0_mapIndexedTo_0_1, '', null, null, 0, null, null, 62, null);
  };
  PatternDateFormat.prototype.format_q2f7m8_k$ = function (dd) {
    var utc_0 = dd._get_local__utobi1_k$();
    var out = '';
    var tmp0_iterator = this._chunks.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var name = tmp0_iterator.next_0_k$();
      var nlen = name.length;
      var tmp = out;
      var tmp1_subject = name;
      var tmp_0;
      switch (tmp1_subject) {
        case 'E':
        case 'EE':
        case 'EEE':
          tmp_0 = Companion_getInstance_84().get_ha5a7z_k$(_DateTime___get_dayOfWeek__impl_(utc_0)._index0).localShortName_34479d_k$(this._get_realLocale__0_k$());
          break;
        case 'EEEE':
        case 'EEEEE':
        case 'EEEEEE':
          tmp_0 = Companion_getInstance_84().get_ha5a7z_k$(_DateTime___get_dayOfWeek__impl_(utc_0)._index0).localName_34479d_k$(this._get_realLocale__0_k$());
          break;
        case 'z':
        case 'zzz':
          tmp_0 = _TimezoneOffset___get_timeZone__impl_(dd._offset);
          break;
        case 'd':
        case 'dd':
          tmp_0 = padded(_DateTime___get_dayOfMonth__impl_(utc_0), nlen);
          break;
        case 'do':
          var tmp_1 = this._get_realLocale__0_k$();
          var tmp_2 = _DateTime___get_dayOfMonth__impl_(utc_0);
          tmp_0 = tmp_1.getOrdinalByDay$default_q7p5ri_k$(tmp_2, null, 2, null);
          break;
        case 'M':
        case 'MM':
          tmp_0 = padded(_DateTime___get_month1__impl_(utc_0), nlen);
          break;
        case 'MMM':
          tmp_0 = substr(Companion_getInstance_88().get_ha5a7z_k$(_DateTime___get_month1__impl_(utc_0)).localName_34479d_k$(this._get_realLocale__0_k$()), 0, 3);
          break;
        case 'MMMM':
          tmp_0 = Companion_getInstance_88().get_ha5a7z_k$(_DateTime___get_month1__impl_(utc_0)).localName_34479d_k$(this._get_realLocale__0_k$());
          break;
        case 'MMMMM':
          tmp_0 = substr(Companion_getInstance_88().get_ha5a7z_k$(_DateTime___get_month1__impl_(utc_0)).localName_34479d_k$(this._get_realLocale__0_k$()), 0, 1);
          break;
        case 'y':
          tmp_0 = _DateTime___get_yearInt__impl_(utc_0);
          break;
        case 'yy':
          tmp_0 = padded(_DateTime___get_yearInt__impl_(utc_0) % 100, 2);
          break;
        case 'yyy':
          tmp_0 = padded(_DateTime___get_yearInt__impl_(utc_0) % 1000, 3);
          break;
        case 'yyyy':
          tmp_0 = padded(_DateTime___get_yearInt__impl_(utc_0), 4);
          break;
        case 'YYYY':
          tmp_0 = padded(_DateTime___get_yearInt__impl_(utc_0), 4);
          break;
        case 'H':
        case 'HH':
          tmp_0 = padded(mconvertRangeZero(_DateTime___get_hours__impl_(utc_0), 24), nlen);
          break;
        case 'k':
        case 'kk':
          tmp_0 = padded(mconvertRangeNonZero(_DateTime___get_hours__impl_(utc_0), 24), nlen);
          break;
        case 'h':
        case 'hh':
          tmp_0 = padded(mconvertRangeNonZero(_DateTime___get_hours__impl_(utc_0), 12), nlen);
          break;
        case 'K':
        case 'KK':
          tmp_0 = padded(mconvertRangeZero(_DateTime___get_hours__impl_(utc_0), 12), nlen);
          break;
        case 'm':
        case 'mm':
          tmp_0 = padded(_DateTime___get_minutes__impl_(utc_0), nlen);
          break;
        case 's':
        case 'ss':
          tmp_0 = padded(_DateTime___get_seconds__impl_(utc_0), nlen);
          break;
        case 'S':
        case 'SS':
        case 'SSS':
        case 'SSSS':
        case 'SSSSS':
        case 'SSSSSS':
        case 'SSSSSSS':
        case 'SSSSSSSS':
        case 'SSSSSSSSS':
          var milli = _DateTime___get_milliseconds__impl_(utc_0);
          var tmp0_log10_0 = _DateTime___get_milliseconds__impl_(utc_0);
          var base10length = numberToInt(Math.log10(tmp0_log10_0)) + 1 | 0;
          var tmp_3;
          if (base10length > name.length) {
            var tmp_4 = milli;
            var tmp1_pow_0 = imul(-1, base10length - name.length | 0);
            tmp_3 = numberToInt(tmp_4 * Math.pow(10.0, tmp1_pow_0));
          } else {
            tmp_3 = substr('' + padded(milli, 3) + '000000', 0, name.length);
          }

          tmp_0 = tmp_3;
          break;
        case 'X':
        case 'XX':
        case 'XXX':
        case 'x':
        case 'xx':
        case 'xxx':
          var tmp_5;
          var tmp_6;
          if (startsWith$default_1(name, 'X', false, 2, null)) {
            tmp_6 = _TimezoneOffset___get_totalMinutesInt__impl_(dd._offset) === 0;
          } else {
            {
              tmp_6 = false;
            }
          }

          if (tmp_6) {
            tmp_5 = 'Z';
          } else {
            {
              var p = _TimezoneOffset___get_totalMinutesInt__impl_(dd._offset) >= 0 ? '+' : '-';
              var tmp2__get_absoluteValue__0 = _TimezoneOffset___get_totalMinutesInt__impl_(dd._offset) / 60 | 0;
              var hours = abs(tmp2__get_absoluteValue__0);
              var tmp3__get_absoluteValue__0 = _TimezoneOffset___get_totalMinutesInt__impl_(dd._offset) % 60;
              var minutes = abs(tmp3__get_absoluteValue__0);
              var tmp2_subject = name;
              switch (tmp2_subject) {
                case 'X':
                case 'x':
                  tmp_5 = '' + p + padded(hours, 2);
                  break;
                case 'XX':
                case 'xx':
                  tmp_5 = '' + p + padded(hours, 2) + padded(minutes, 2);
                  break;
                case 'XXX':
                case 'xxx':
                  tmp_5 = '' + p + padded(hours, 2) + ':' + padded(minutes, 2);
                  break;
                default:tmp_5 = name;
                  break;
              }
            }
          }

          tmp_0 = tmp_5;
          break;
        case 'a':
          tmp_0 = _DateTime___get_hours__impl_(utc_0) < 12 ? 'am' : 'pm';
          break;
        default:var tmp_7;
          var tmp_8 = new Char(39);
          if (startsWith$default(name, tmp_8, false, 2, null)) {
            var tmp4_substring_0 = name.length - 1 | 0;
            tmp_7 = name.substring(1, tmp4_substring_0);
          } else {
            {
              tmp_7 = name;
            }
          }

          tmp_0 = tmp_7;
          break;
      }
      out = tmp + tmp_0;
    }
    return out;
  };
  PatternDateFormat.prototype.toString = function () {
    return this._format;
  };
  PatternDateFormat.prototype.hashCode = function () {
    var result = getStringHashCode(this._format);
    result = imul(result, 31) + (this._locale_0 == null ? 0 : hashCode(this._locale_0)) | 0;
    result = imul(result, 31) + this._tzNames.hashCode() | 0;
    result = imul(result, 31) + this._options_0.hashCode() | 0;
    return result;
  };
  PatternDateFormat.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PatternDateFormat))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PatternDateFormat ? other : THROW_CCE();
    if (!(this._format === tmp0_other_with_cast._format))
      return false;
    if (!equals_1(this._locale_0, tmp0_other_with_cast._locale_0))
      return false;
    if (!this._tzNames.equals(tmp0_other_with_cast._tzNames))
      return false;
    if (!this._options_0.equals(tmp0_other_with_cast._options_0))
      return false;
    return true;
  };
  PatternDateFormat.$metadata$ = {
    simpleName: 'PatternDateFormat',
    kind: 'class',
    interfaces: [DateFormat, Serializable_0]
  };
  function readRepeatedChar(_this_) {
    var start_1 = _this_._offset_0;
    var c_4 = _this_.readChar_0_k$();
    while (_this_._get_hasMore__0_k$() ? _this_.tryRead_wi8o78_k$(c_4) : false)
      Unit_getInstance();
    var end_2 = _this_._offset_0;
    var tmp0_substring_0 = _this_._str_0;
    return tmp0_substring_0.substring(start_1, end_2);
  }
  function mconvertRangeZero(value, size_2) {
    return umod_0(value, size_2);
  }
  function mconvertRangeNonZero(value, size_2) {
    var res = umod_0(value, size_2);
    return res === 0 ? size_2 : res;
  }
  function PerformanceCounter() {
    PerformanceCounter_instance = this;
  }
  PerformanceCounter.prototype._get_microseconds__0_k$ = function () {
    return _HRTimeSpan___get_microsecondsDouble__impl_(KlockInternal_getInstance()._get_hrNow__k7znw9_k$());
  };
  PerformanceCounter.prototype._get_reference__nsqrdp_k$ = function () {
    return _get_timeSpan_(KlockInternal_getInstance()._get_hrNow__k7znw9_k$());
  };
  PerformanceCounter.$metadata$ = {
    simpleName: 'PerformanceCounter',
    kind: 'object',
    interfaces: []
  };
  var PerformanceCounter_instance;
  function PerformanceCounter_getInstance() {
    if (PerformanceCounter_instance == null)
      new PerformanceCounter();
    return PerformanceCounter_instance;
  }
  function Companion_92() {
    Companion_instance_91 = this;
  }
  Companion_92.prototype.now_utobi1_k$ = function () {
    return Companion_getInstance_82().now_utobi1_k$();
  };
  Companion_92.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: [TimeProvider]
  };
  var Companion_instance_91;
  function Companion_getInstance_91() {
    if (Companion_instance_91 == null)
      new Companion_92();
    return Companion_instance_91;
  }
  function TimeProvider() {
  }
  TimeProvider.$metadata$ = {
    simpleName: 'TimeProvider',
    kind: 'interface',
    interfaces: []
  };
  function _TimeSpan___init__impl_(milliseconds) {
    return milliseconds;
  }
  function _TimeSpan___get_milliseconds__impl_(this_0) {
    return this_0;
  }
  function _TimeSpan___get_nanoseconds__impl_(this_0) {
    var tmp = _TimeSpan___get_milliseconds__impl_(this_0);
    Companion_getInstance_92();
    return tmp / 1.0E-6;
  }
  function _TimeSpan___get_microsecondsInt__impl_(this_0) {
    var tmp = _TimeSpan___get_milliseconds__impl_(this_0);
    Companion_getInstance_92();
    return numberToInt(tmp / 0.001);
  }
  function _TimeSpan___get_seconds__impl_(this_0) {
    return _TimeSpan___get_milliseconds__impl_(this_0) / 1000;
  }
  function _TimeSpan___get_millisecondsLong__impl_(this_0) {
    return numberToLong(_TimeSpan___get_milliseconds__impl_(this_0));
  }
  function TimeSpan__compareTo_impl(this_0, other) {
    return compareTo(_TimeSpan___get_milliseconds__impl_(this_0), _TimeSpan___get_milliseconds__impl_(other));
  }
  function TimeSpan__compareTo_impl_0(this_0, other) {
    var tmp = this_0._milliseconds;
    return TimeSpan__compareTo_impl(tmp, other instanceof TimeSpan ? other._milliseconds : THROW_CCE());
  }
  function TimeSpan__unaryMinus_impl(this_0) {
    return _TimeSpan___init__impl_(-_TimeSpan___get_milliseconds__impl_(this_0));
  }
  function TimeSpan__plus_impl(this_0, other) {
    return _TimeSpan___init__impl_(_TimeSpan___get_milliseconds__impl_(this_0) + _TimeSpan___get_milliseconds__impl_(other));
  }
  function TimeSpan__minus_impl(this_0, other) {
    return TimeSpan__plus_impl(this_0, TimeSpan__unaryMinus_impl(other));
  }
  function TimeSpan__times_impl(this_0, scale_1) {
    return _TimeSpan___init__impl_(_TimeSpan___get_milliseconds__impl_(this_0) * scale_1);
  }
  function TimeSpan__times_impl_0(this_0, scale_1) {
    return _TimeSpan___init__impl_(_TimeSpan___get_milliseconds__impl_(this_0) * scale_1);
  }
  function TimeSpan__div_impl(this_0, scale_1) {
    return _TimeSpan___init__impl_(_TimeSpan___get_milliseconds__impl_(this_0) / scale_1);
  }
  function TimeSpan__div_impl_0(this_0, other) {
    return _TimeSpan___get_milliseconds__impl_(this_0) / _TimeSpan___get_milliseconds__impl_(other);
  }
  function Companion_93() {
    Companion_instance_92 = this;
    this._serialVersionUID_10 = new Long(1, 0);
    this._MILLIS_PER_MICROSECOND = 0.001;
    this._MILLIS_PER_NANOSECOND = 1.0E-6;
    this._ZERO = _TimeSpan___init__impl_(0.0);
    var tmp = this;
    DoubleCompanionObject_getInstance();
    tmp._NIL = _TimeSpan___init__impl_(NaN);
    this._timeSteps = listOf([60, 60, 24]);
  }
  Companion_93.prototype.fromMilliseconds_ttklb2_k$ = function (ms) {
    var tmp0_subject = ms;
    return tmp0_subject === 0.0 ? this._ZERO : _TimeSpan___init__impl_(ms);
  };
  Companion_93.prototype.fromNanoseconds_ttklb2_k$ = function (s) {
    return this.fromMilliseconds_ttklb2_k$(s * 1.0E-6);
  };
  Companion_93.prototype.fromMicroseconds_ttklb2_k$ = function (s) {
    return this.fromMilliseconds_ttklb2_k$(s * 0.001);
  };
  Companion_93.prototype.fromSeconds_ttklb2_k$ = function (s) {
    return this.fromMilliseconds_ttklb2_k$(s * 1000);
  };
  Companion_93.prototype.fromMinutes_ttklb2_k$ = function (s) {
    return this.fromMilliseconds_ttklb2_k$(s * 60000);
  };
  Companion_93.prototype.fromHours_ttklb2_k$ = function (s) {
    return this.fromMilliseconds_ttklb2_k$(s * 3600000);
  };
  Companion_93.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_92;
  function Companion_getInstance_92() {
    if (Companion_instance_92 == null)
      new Companion_93();
    return Companion_instance_92;
  }
  function TimeSpan__toString_impl(this_0) {
    return '' + _get_niceStr__1(_TimeSpan___get_milliseconds__impl_(this_0)) + 'ms';
  }
  function TimeSpan__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function TimeSpan__equals_impl(this_0, other) {
    if (!(other instanceof TimeSpan))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TimeSpan ? other._milliseconds : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function TimeSpan(milliseconds) {
    Companion_getInstance_92();
    this._milliseconds = milliseconds;
  }
  TimeSpan.prototype.compareTo_wv9l0m_k$ = function (other) {
    return TimeSpan__compareTo_impl(this._milliseconds, other);
  };
  TimeSpan.prototype.compareTo_2c5_k$ = function (other) {
    return TimeSpan__compareTo_impl_0(this, other);
  };
  TimeSpan.prototype.toString = function () {
    return TimeSpan__toString_impl(this._milliseconds);
  };
  TimeSpan.prototype.hashCode = function () {
    return TimeSpan__hashCode_impl(this._milliseconds);
  };
  TimeSpan.prototype.equals = function (other) {
    return TimeSpan__equals_impl(this._milliseconds, other);
  };
  TimeSpan.$metadata$ = {
    simpleName: 'TimeSpan',
    kind: 'class',
    interfaces: [Comparable, Serializable_0]
  };
  function min(a, b) {
    var tmp0_min_0 = _TimeSpan___get_milliseconds__impl_(a);
    var tmp1_min_0 = _TimeSpan___get_milliseconds__impl_(b);
    var tmp2__get_milliseconds__0 = Math.min(tmp0_min_0, tmp1_min_0);
    return Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp2__get_milliseconds__0);
  }
  function clamp_0(_this_, min_0, max) {
    return TimeSpan__compareTo_impl(_this_, min_0) < 0 ? min_0 : TimeSpan__compareTo_impl(_this_, max) > 0 ? max : _this_;
  }
  function TimezoneNames_init_$Init$(tz, $this) {
    TimezoneNames.call($this, toMap(tz));
    return $this;
  }
  function TimezoneNames_init_$Create$(tz) {
    return TimezoneNames_init_$Init$(tz, Object.create(TimezoneNames.prototype));
  }
  function Companion_94() {
    Companion_instance_93 = this;
    this._serialVersionUID_11 = new Long(1, 0);
    var tmp = this;
    var tmp_0 = to('PDT', new TimeSpan(Companion_getInstance_92().fromHours_ttklb2_k$(-7.0)));
    var tmp_1 = to('PST', new TimeSpan(Companion_getInstance_92().fromHours_ttklb2_k$(-8.0)));
    var tmp_2 = to('GMT', new TimeSpan(Companion_getInstance_92().fromHours_ttklb2_k$(0.0)));
    tmp._DEFAULT_0 = TimezoneNames_init_$Create$([tmp_0, tmp_1, tmp_2, to('UTC', new TimeSpan(Companion_getInstance_92().fromHours_ttklb2_k$(0.0)))]);
  }
  Companion_94.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_93;
  function Companion_getInstance_93() {
    if (Companion_instance_93 == null)
      new Companion_94();
    return Companion_instance_93;
  }
  function TimezoneNames(namesToOffsets) {
    Companion_getInstance_93();
    this._namesToOffsets = namesToOffsets;
  }
  TimezoneNames.prototype.toString = function () {
    return '' + 'TimezoneNames(namesToOffsets=' + this._namesToOffsets + ')';
  };
  TimezoneNames.prototype.hashCode = function () {
    return hashCode(this._namesToOffsets);
  };
  TimezoneNames.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TimezoneNames))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TimezoneNames ? other : THROW_CCE();
    if (!equals_1(this._namesToOffsets, tmp0_other_with_cast._namesToOffsets))
      return false;
    return true;
  };
  TimezoneNames.$metadata$ = {
    simpleName: 'TimezoneNames',
    kind: 'class',
    interfaces: [Serializable_0]
  };
  function _TimezoneOffset___init__impl_(totalMilliseconds) {
    return totalMilliseconds;
  }
  function _TimezoneOffset___get_totalMilliseconds__impl_(this_0) {
    return this_0;
  }
  function _TimezoneOffset___get_positive__impl_(this_0) {
    return _TimezoneOffset___get_totalMilliseconds__impl_(this_0) >= 0.0;
  }
  function _TimezoneOffset___get_time__impl_(this_0) {
    var tmp0__get_milliseconds__0 = _TimezoneOffset___get_totalMilliseconds__impl_(this_0);
    return Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp0__get_milliseconds__0);
  }
  function _TimezoneOffset___get_totalMinutes__impl_(this_0) {
    return _TimezoneOffset___get_totalMilliseconds__impl_(this_0) / 60000;
  }
  function _TimezoneOffset___get_totalMinutesInt__impl_(this_0) {
    return numberToInt(_TimezoneOffset___get_totalMinutes__impl_(this_0));
  }
  function _TimezoneOffset___get_timeZone__impl_(this_0) {
    var sign = _TimezoneOffset___get_positive__impl_(this_0) ? '+' : '-';
    var hour = padded(_TimezoneOffset___get_deltaHoursAbs__impl_(this_0), 2);
    var minute = padded(_TimezoneOffset___get_deltaMinutesAbs__impl_(this_0), 2);
    var tmp;
    var tmp_0 = new TimeSpan(_TimezoneOffset___get_time__impl_(this_0));
    if (equals_1(tmp_0, new TimeSpan(Companion_getInstance_92().fromMinutes_ttklb2_k$(0.0)))) {
      tmp = 'UTC';
    } else {
      {
        tmp = '' + 'GMT' + sign + hour + minute;
      }
    }
    return tmp;
  }
  function _get_deltaTotalMinutesAbs_($this) {
    return abs(numberToInt(_TimezoneOffset___get_totalMinutes__impl_($this)));
  }
  function _TimezoneOffset___get_deltaHoursAbs__impl_(this_0) {
    return _get_deltaTotalMinutesAbs_(this_0) / 60 | 0;
  }
  function _TimezoneOffset___get_deltaMinutesAbs__impl_(this_0) {
    return _get_deltaTotalMinutesAbs_(this_0) % 60;
  }
  function Companion_95() {
    Companion_instance_94 = this;
    this._serialVersionUID_12 = new Long(1, 0);
  }
  Companion_95.prototype.invoke_y33v0e_k$ = function (time) {
    return _TimezoneOffset___init__impl_(_TimeSpan___get_milliseconds__impl_(time));
  };
  Companion_95.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_94;
  function Companion_getInstance_94() {
    if (Companion_instance_94 == null)
      new Companion_95();
    return Companion_instance_94;
  }
  function _get_offset_(_this_) {
    return Companion_getInstance_94().invoke_y33v0e_k$(_this_);
  }
  function _Year___init__impl_(year) {
    return year;
  }
  function _Year___get_year__impl_(this_0) {
    return this_0;
  }
  function Companion_96() {
    Companion_instance_95 = this;
    this._serialVersionUID_13 = new Long(1, 0);
    this._DAYS_COMMON = 365;
    this._DAYS_LEAP = 366;
    this._LEAP_PER_4_YEARS = 1;
    this._LEAP_PER_100_YEARS = 24;
    this._LEAP_PER_400_YEARS = 97;
    this._DAYS_PER_4_YEARS = 1461;
    this._DAYS_PER_100_YEARS = 36524;
    this._DAYS_PER_400_YEARS = 146097;
  }
  Companion_96.prototype.isLeap_ha5a7z_k$ = function (year) {
    return year % 4 === 0 ? !(year % 100 === 0) ? true : year % 400 === 0 : false;
  };
  Companion_96.prototype.fromDays_eros0m_k$ = function (days) {
    var v400 = days / 146097 | 0;
    var r400 = days - imul(v400, 146097) | 0;
    var tmp0_min_0 = r400 / 36524 | 0;
    var v100 = Math.min(tmp0_min_0, 3);
    var r100 = r400 - imul(v100, 36524) | 0;
    var v4 = r100 / 1461 | 0;
    var r4 = r100 - imul(v4, 1461) | 0;
    var tmp1_min_0 = r4 / 365 | 0;
    var v1 = Math.min(tmp1_min_0, 3);
    var extra = days < 0 ? 0 : 1;
    return _Year___init__impl_((((extra + v1 | 0) + imul(v4, 4) | 0) + imul(v100, 100) | 0) + imul(v400, 400) | 0);
  };
  Companion_96.prototype.days_vcj5fe_k$ = function (isLeap) {
    return isLeap ? 366 : 365;
  };
  Companion_96.prototype.leapCountSinceOne_ha5a7z_k$ = function (year) {
    if (year < 1) {
      var leapCount = 0;
      var y = 1;
      while (y >= year) {
        if (_Year___get_isLeap__impl_(_Year___init__impl_(y))) {
          var tmp0 = leapCount;
          leapCount = tmp0 - 1 | 0;
          Unit_getInstance();
        }var tmp1 = y;
        y = tmp1 - 1 | 0;
        Unit_getInstance();
      }
      return leapCount;
    }var y1 = year - 1 | 0;
    var res = ((y1 / 4 | 0) - (y1 / 100 | 0) | 0) + (y1 / 400 | 0) | 0;
    return res;
  };
  Companion_96.prototype.daysSinceOne_ha5a7z_k$ = function (year) {
    return imul(365, year - 1 | 0) + this.leapCountSinceOne_ha5a7z_k$(year) | 0;
  };
  Companion_96.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_95;
  function Companion_getInstance_95() {
    if (Companion_instance_95 == null)
      new Companion_96();
    return Companion_instance_95;
  }
  function _Year___get_isLeap__impl_(this_0) {
    return Companion_getInstance_95().isLeap_ha5a7z_k$(_Year___get_year__impl_(this_0));
  }
  function _Year___get_days__impl_(this_0) {
    return Companion_getInstance_95().days_vcj5fe_k$(_Year___get_isLeap__impl_(this_0));
  }
  function _Year___get_daysSinceOne__impl_(this_0) {
    return Companion_getInstance_95().daysSinceOne_ha5a7z_k$(_Year___get_year__impl_(this_0));
  }
  function Year__plus_impl(this_0, delta_0) {
    return _Year___init__impl_(_Year___get_year__impl_(this_0) + delta_0 | 0);
  }
  function _HRTimeSpan___init__impl_(nanosecondsRaw) {
    return nanosecondsRaw;
  }
  function _HRTimeSpan___get_nanosecondsRaw__impl_(this_0) {
    return this_0;
  }
  function Companion_97() {
    Companion_instance_96 = this;
    this._ZERO_0 = _HRTimeSpan___init__impl_(0.0);
    var tmp = this;
    DoubleCompanionObject_getInstance();
    tmp._NIL_0 = _HRTimeSpan___init__impl_(NaN);
  }
  Companion_97.prototype.fromSeconds_nj2146_k$ = function (value) {
    return _HRTimeSpan___init__impl_(round(value * 1000000000));
  };
  Companion_97.prototype.fromMilliseconds_nj2146_k$ = function (value) {
    return _HRTimeSpan___init__impl_(round(value * 1000000));
  };
  Companion_97.prototype.fromNanoseconds_nj2146_k$ = function (value) {
    return _HRTimeSpan___init__impl_(round(value));
  };
  Companion_97.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_96;
  function Companion_getInstance_96() {
    if (Companion_instance_96 == null)
      new Companion_97();
    return Companion_instance_96;
  }
  function _HRTimeSpan___get_microsecondsDouble__impl_(this_0) {
    return _HRTimeSpan___get_nanosecondsRaw__impl_(this_0) / 1000;
  }
  function HRTimeSpan__plus_impl(this_0, other) {
    return Companion_getInstance_96().fromNanoseconds_nj2146_k$(_HRTimeSpan___get_nanosecondsRaw__impl_(this_0) + _HRTimeSpan___get_nanosecondsRaw__impl_(other));
  }
  function _get_timeSpan_(_this_) {
    var tmp0__get_nanoseconds__0 = _HRTimeSpan___get_nanosecondsRaw__impl_(_this_);
    return Companion_getInstance_92().fromNanoseconds_ttklb2_k$(tmp0__get_nanoseconds__0);
  }
  function increment(_this_, key) {
    var value_1 = _this_.get_2bw_k$(key);
    if (value_1 == null) {
      var answer_2 = 0;
      _this_.put_1q9pf_k$(key, answer_2);
      Unit_getInstance();
    } else {
    }
    Unit_getInstance();
    var tmp0_set_0 = ensureNotNull(_this_.get_2bw_k$(key)) + 1 | 0;
    _this_.put_1q9pf_k$(key, tmp0_set_0);
    Unit_getInstance();
  }
  function MicroStrReader_init_$Init$(str, offset_0, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      offset_0 = 0;
    MicroStrReader.call($this, str, offset_0);
    return $this;
  }
  function MicroStrReader_init_$Create$(str, offset_0, $mask0, $marker) {
    return MicroStrReader_init_$Init$(str, offset_0, $mask0, $marker, Object.create(MicroStrReader.prototype));
  }
  function MicroStrReader(str, offset_0) {
    this._str_0 = str;
    this._offset_0 = offset_0;
  }
  MicroStrReader.prototype._get_available__0_k$ = function () {
    return this._str_0.length - this._offset_0 | 0;
  };
  MicroStrReader.prototype._get_hasMore__0_k$ = function () {
    return this._offset_0 < this._str_0.length;
  };
  MicroStrReader.prototype._get_eof__0_k$ = function () {
    return !this._get_hasMore__0_k$();
  };
  MicroStrReader.prototype.peekChar_0_k$ = function () {
    return charSequenceGet(this._str_0, this._offset_0);
  };
  MicroStrReader.prototype.readChar_0_k$ = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._offset_0;
    tmp0_this._offset_0 = tmp1 + 1 | 0;
    return charSequenceGet(this._str_0, tmp1);
  };
  MicroStrReader.prototype.tryRead_wi8o78_k$ = function (expected) {
    if (this._get_eof__0_k$() ? true : !this.peekChar_0_k$().equals(expected))
      return false;
    this.readChar_0_k$();
    Unit_getInstance();
    return true;
  };
  MicroStrReader.prototype.tryReadOrNull_6wfw3l_k$ = function (expected) {
    return this.tryRead_6wfw3l_k$(expected) ? expected : null;
  };
  MicroStrReader.prototype.tryRead_6wfw3l_k$ = function (expected) {
    if (expected.length > this._get_available__0_k$())
      return false;
    var inductionVariable = 0;
    var last_1 = charSequenceLength(expected) - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!charSequenceGet(this._str_0, this._offset_0 + n | 0).equals(charSequenceGet(expected, n)))
          return false;
      }
       while (inductionVariable <= last_1);
    var tmp1_this = this;
    tmp1_this._offset_0 = tmp1_this._offset_0 + expected.length | 0;
    return true;
  };
  MicroStrReader.$metadata$ = {
    simpleName: 'MicroStrReader',
    kind: 'class',
    interfaces: []
  };
  function _get_niceStr__1(_this_) {
    var tmp;
    if (Math.floor(_this_) === _this_) {
      tmp = '' + numberToInt(_this_);
    } else {
      {
        tmp = '' + _this_;
      }
    }
    return tmp;
  }
  function substr(_this_, start, length) {
    var low = clamp_1(start >= 0 ? start : _this_.length + start | 0, 0, _this_.length);
    var high = clamp_1(length >= 0 ? low + length | 0 : _this_.length + length | 0, 0, _this_.length);
    var tmp;
    if (high < low) {
      tmp = '';
    } else {
      tmp = _this_.substring(low, high);
    }
    return tmp;
  }
  function padded(_this_, count_0) {
    var res = padStart(abs(_this_).toString(), count_0, new Char(48));
    var tmp;
    if (_this_ < 0) {
      return '' + '-' + res;
    } else {
      tmp = res;
    }
    return tmp;
  }
  function umod_0(_this_, that) {
    var remainder = _this_ % that;
    return remainder < 0 ? remainder + that | 0 : remainder;
  }
  function clamp_1(_this_, min_0, max) {
    return _this_ < min_0 ? min_0 : _this_ > max ? max : _this_;
  }
  function cycleSteps(_this_, min_0, max) {
    return (_this_ - min_0 | 0) / ((max - min_0 | 0) + 1 | 0) | 0;
  }
  function cycle(_this_, min_0, max) {
    return umod_0(_this_ - min_0 | 0, (max - min_0 | 0) + 1 | 0) + min_0 | 0;
  }
  function toInt2(_this_) {
    var tmp;
    if (_this_ < 0.0) {
      tmp = numberToInt(Math.floor(_this_));
    } else {
      tmp = numberToInt(_this_);
    }
    return tmp;
  }
  function toIntMod(_this_, mod_1) {
    return toInt2(umod_1(_this_, mod_1));
  }
  function umod_1(_this_, that) {
    var remainder = _this_ % that;
    return remainder < 0.0 ? remainder + that : remainder;
  }
  var ExtendedTimezoneNames;
  function utc(hours, minutes) {
    var tmp = Companion_getInstance_92().fromHours_ttklb2_k$(hours);
    return TimeSpan__plus_impl(tmp, Companion_getInstance_92().fromMinutes_ttklb2_k$(minutes));
  }
  function utc$default(hours, minutes, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      minutes = 0;
    return utc(hours, minutes);
  }
  function ExtendedTimezoneNames$init$() {
    var tmp = to('ACDT', new TimeSpan(utc(10, 30)));
    var tmp_0 = to('ACST', new TimeSpan(utc(9, 30)));
    var tmp_1 = to('ACT', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_2 = to('ACWST', new TimeSpan(utc(8, 45)));
    var tmp_3 = to('ADT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_4 = to('AEDT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_5 = to('AEST', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_6 = to('AFT', new TimeSpan(utc(4, 30)));
    var tmp_7 = to('AKDT', new TimeSpan(utc$default(-8, 0, 2, null)));
    var tmp_8 = to('AKST', new TimeSpan(utc$default(-9, 0, 2, null)));
    var tmp_9 = to('ALMT', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_10 = to('AMST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_11 = to('AMT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_12 = to('AMT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_13 = to('ANAT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_14 = to('AQTT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_15 = to('ART', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_16 = to('AST', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_17 = to('AST', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_18 = to('AWST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_19 = to('AZOST', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_20 = to('AZOT', new TimeSpan(utc$default(-1, 0, 2, null)));
    var tmp_21 = to('AZT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_22 = to('BDT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_23 = to('BIOT', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_24 = to('BIT', new TimeSpan(utc$default(-12, 0, 2, null)));
    var tmp_25 = to('BOT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_26 = to('BRST', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_27 = to('BRT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_28 = to('BST', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_29 = to('BST', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_30 = to('BST', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_31 = to('BTT', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_32 = to('CAT', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_33 = to('CCT', new TimeSpan(utc(6, 30)));
    var tmp_34 = to('CDT', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_35 = to('CDT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_36 = to('CEST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_37 = to('CET', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_38 = to('CHADT', new TimeSpan(utc(13, 45)));
    var tmp_39 = to('CHAST', new TimeSpan(utc(12, 45)));
    var tmp_40 = to('CHOT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_41 = to('CHOST', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_42 = to('CHST', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_43 = to('CHUT', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_44 = to('CIST', new TimeSpan(utc$default(-8, 0, 2, null)));
    var tmp_45 = to('CIT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_46 = to('CKT', new TimeSpan(utc$default(-10, 0, 2, null)));
    var tmp_47 = to('CLST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_48 = to('CLT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_49 = to('COST', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_50 = to('COT', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_51 = to('CST', new TimeSpan(utc$default(-6, 0, 2, null)));
    var tmp_52 = to('CST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_53 = to('CST', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_54 = to('CT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_55 = to('CVT', new TimeSpan(utc$default(-1, 0, 2, null)));
    var tmp_56 = to('CWST', new TimeSpan(utc(8, 45)));
    var tmp_57 = to('CXT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_58 = to('DAVT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_59 = to('DDUT', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_60 = to('DFT', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_61 = to('EASST', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_62 = to('EAST', new TimeSpan(utc$default(-6, 0, 2, null)));
    var tmp_63 = to('EAT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_64 = to('ECT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_65 = to('ECT', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_66 = to('EDT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_67 = to('EEST', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_68 = to('EET', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_69 = to('EGST', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_70 = to('EGT', new TimeSpan(utc$default(-1, 0, 2, null)));
    var tmp_71 = to('EIT', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_72 = to('EST', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_73 = to('FET', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_74 = to('FJT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_75 = to('FKST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_76 = to('FKT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_77 = to('FNT', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_78 = to('GALT', new TimeSpan(utc$default(-6, 0, 2, null)));
    var tmp_79 = to('GAMT', new TimeSpan(utc$default(-9, 0, 2, null)));
    var tmp_80 = to('GET', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_81 = to('GFT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_82 = to('GILT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_83 = to('GIT', new TimeSpan(utc$default(-9, 0, 2, null)));
    var tmp_84 = to('GMT', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_85 = to('GST', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_86 = to('GST', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_87 = to('GYT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_88 = to('HDT', new TimeSpan(utc$default(-9, 0, 2, null)));
    var tmp_89 = to('HAEC', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_90 = to('HST', new TimeSpan(utc$default(-10, 0, 2, null)));
    var tmp_91 = to('HKT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_92 = to('HMT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_93 = to('HOVST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_94 = to('HOVT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_95 = to('ICT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_96 = to('IDLW', new TimeSpan(utc$default(-12, 0, 2, null)));
    var tmp_97 = to('IDT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_98 = to('IOT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_99 = to('IRDT', new TimeSpan(utc(4, 30)));
    var tmp_100 = to('IRKT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_101 = to('IRST', new TimeSpan(utc(3, 30)));
    var tmp_102 = to('IST', new TimeSpan(utc(5, 30)));
    var tmp_103 = to('IST', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_104 = to('IST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_105 = to('JST', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_106 = to('KALT', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_107 = to('KGT', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_108 = to('KOST', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_109 = to('KRAT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_110 = to('KST', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_111 = to('LHST', new TimeSpan(utc(10, 30)));
    var tmp_112 = to('LHST', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_113 = to('LINT', new TimeSpan(utc$default(14, 0, 2, null)));
    var tmp_114 = to('MAGT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_115 = to('MART', new TimeSpan(utc(-9, 30)));
    var tmp_116 = to('MAWT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_117 = to('MDT', new TimeSpan(utc$default(-6, 0, 2, null)));
    var tmp_118 = to('MET', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_119 = to('MEST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_120 = to('MHT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_121 = to('MIST', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_122 = to('MIT', new TimeSpan(utc(-9, 30)));
    var tmp_123 = to('MMT', new TimeSpan(utc(6, 30)));
    var tmp_124 = to('MSK', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_125 = to('MST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_126 = to('MST', new TimeSpan(utc$default(-7, 0, 2, null)));
    var tmp_127 = to('MUT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_128 = to('MVT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_129 = to('MYT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_130 = to('NCT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_131 = to('NDT', new TimeSpan(utc(-2, 30)));
    var tmp_132 = to('NFT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_133 = to('NOVT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_134 = to('NPT', new TimeSpan(utc(5, 45)));
    var tmp_135 = to('NST', new TimeSpan(utc(-3, 30)));
    var tmp_136 = to('NT', new TimeSpan(utc(-3, 30)));
    var tmp_137 = to('NUT', new TimeSpan(utc$default(-11, 0, 2, null)));
    var tmp_138 = to('NZDT', new TimeSpan(utc$default(13, 0, 2, null)));
    var tmp_139 = to('NZST', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_140 = to('OMST', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_141 = to('ORAT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_142 = to('PDT', new TimeSpan(utc$default(-7, 0, 2, null)));
    var tmp_143 = to('PET', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_144 = to('PETT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_145 = to('PGT', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_146 = to('PHOT', new TimeSpan(utc$default(13, 0, 2, null)));
    var tmp_147 = to('PHT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_148 = to('PKT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_149 = to('PMDT', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_150 = to('PMST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_151 = to('PONT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_152 = to('PST', new TimeSpan(utc$default(-8, 0, 2, null)));
    var tmp_153 = to('PST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_154 = to('PYST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_155 = to('PYT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_156 = to('RET', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_157 = to('ROTT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_158 = to('SAKT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_159 = to('SAMT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_160 = to('SAST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_161 = to('SBT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_162 = to('SCT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_163 = to('SDT', new TimeSpan(utc$default(-10, 0, 2, null)));
    var tmp_164 = to('SGT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_165 = to('SLST', new TimeSpan(utc(5, 30)));
    var tmp_166 = to('SRET', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_167 = to('SRT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_168 = to('SST', new TimeSpan(utc$default(-11, 0, 2, null)));
    var tmp_169 = to('SST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_170 = to('SYOT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_171 = to('TAHT', new TimeSpan(utc$default(-10, 0, 2, null)));
    var tmp_172 = to('THA', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_173 = to('TFT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_174 = to('TJT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_175 = to('TKT', new TimeSpan(utc$default(13, 0, 2, null)));
    var tmp_176 = to('TLT', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_177 = to('TMT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_178 = to('TRT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_179 = to('TOT', new TimeSpan(utc$default(13, 0, 2, null)));
    var tmp_180 = to('TVT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_181 = to('ULAST', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_182 = to('ULAT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_183 = to('UTC', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_184 = to('UYST', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_185 = to('UYT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_186 = to('UZT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_187 = to('VET', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_188 = to('VLAT', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_189 = to('VOLT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_190 = to('VOST', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_191 = to('VUT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_192 = to('WAKT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_193 = to('WAST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_194 = to('WAT', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_195 = to('WEST', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_196 = to('WET', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_197 = to('WIT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_198 = to('WST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_199 = to('YAKT', new TimeSpan(utc$default(9, 0, 2, null)));
    return TimezoneNames_init_$Create$([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, tmp_64, tmp_65, tmp_66, tmp_67, tmp_68, tmp_69, tmp_70, tmp_71, tmp_72, tmp_73, tmp_74, tmp_75, tmp_76, tmp_77, tmp_78, tmp_79, tmp_80, tmp_81, tmp_82, tmp_83, tmp_84, tmp_85, tmp_86, tmp_87, tmp_88, tmp_89, tmp_90, tmp_91, tmp_92, tmp_93, tmp_94, tmp_95, tmp_96, tmp_97, tmp_98, tmp_99, tmp_100, tmp_101, tmp_102, tmp_103, tmp_104, tmp_105, tmp_106, tmp_107, tmp_108, tmp_109, tmp_110, tmp_111, tmp_112, tmp_113, tmp_114, tmp_115, tmp_116, tmp_117, tmp_118, tmp_119, tmp_120, tmp_121, tmp_122, tmp_123, tmp_124, tmp_125, tmp_126, tmp_127, tmp_128, tmp_129, tmp_130, tmp_131, tmp_132, tmp_133, tmp_134, tmp_135, tmp_136, tmp_137, tmp_138, tmp_139, tmp_140, tmp_141, tmp_142, tmp_143, tmp_144, tmp_145, tmp_146, tmp_147, tmp_148, tmp_149, tmp_150, tmp_151, tmp_152, tmp_153, tmp_154, tmp_155, tmp_156, tmp_157, tmp_158, tmp_159, tmp_160, tmp_161, tmp_162, tmp_163, tmp_164, tmp_165, tmp_166, tmp_167, tmp_168, tmp_169, tmp_170, tmp_171, tmp_172, tmp_173, tmp_174, tmp_175, tmp_176, tmp_177, tmp_178, tmp_179, tmp_180, tmp_181, tmp_182, tmp_183, tmp_184, tmp_185, tmp_186, tmp_187, tmp_188, tmp_189, tmp_190, tmp_191, tmp_192, tmp_193, tmp_194, tmp_195, tmp_196, tmp_197, tmp_198, tmp_199, to('YEKT', new TimeSpan(utc$default(5, 0, 2, null)))]);
  }
  var klockIsKotlinNative;
  function klockLazyOrGet(initializer) {
    return lazy(initializer);
  }
  function klockAtomicLazy(initializer) {
    return lazy(initializer);
  }
  var isNode;
  function _get_initialHrTime_() {
    var tmp0_getValue_0 = initialHrTime$factory();
    return initialHrTime$delegate._get_value__0_k$();
  }
  var initialHrTime$delegate;
  function Serializable_0() {
  }
  Serializable_0.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function KlockInternal() {
    KlockInternal_instance = this;
  }
  KlockInternal.prototype._get_currentTime__0_k$ = function () {
    var tmp0_unsafeCast_0 = Date.now();
    return tmp0_unsafeCast_0;
  };
  KlockInternal.prototype._get_hrNow__k7znw9_k$ = function () {
    var tmp;
    if (isNode) {
      var tmp0_unsafeCast_0 = process.hrtime(_get_initialHrTime_());
      var result = tmp0_unsafeCast_0;
      tmp = HRTimeSpan__plus_impl(Companion_getInstance_96().fromSeconds_nj2146_k$(result[0]), Companion_getInstance_96().fromNanoseconds_nj2146_k$(result[1]));
    } else {
      tmp = Companion_getInstance_96().fromMilliseconds_nj2146_k$(window.performance.now());
    }
    return tmp;
  };
  KlockInternal.$metadata$ = {
    simpleName: 'KlockInternal',
    kind: 'object',
    interfaces: []
  };
  var KlockInternal_instance;
  function KlockInternal_getInstance() {
    if (KlockInternal_instance == null)
      new KlockInternal();
    return KlockInternal_instance;
  }
  function _no_name_provided__109() {
  }
  _no_name_provided__109.prototype.invoke_0_k$ = function () {
    return process.hrtime();
  };
  _no_name_provided__109.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function initialHrTime$factory() {
    return getPropertyCallableRef('initialHrTime', 0, KProperty0, function () {
      return _get_initialHrTime_();
    }, null);
  }
  function _no_name_provided_$factory_88() {
    var i = new _no_name_provided__109();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function arrayadd(array, value, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0 = toShort(array[n] + value);
        array[n] = tmp0_set_0;
      }
       while (inductionVariable < end);
  }
  function arraycopy_2(src, srcPos, dst, dstPos, size_2) {
    var tmp0_copyInto_0 = srcPos + size_2 | 0;
    arrayCopy_0(src, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_3(src, srcPos, dst, dstPos, size_2) {
    var tmp0_copyInto_0 = srcPos + size_2 | 0;
    arrayCopy_0(src, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_4(src, srcPos, dst, dstPos, size_2) {
    var tmp0_copyInto_0 = isArray(dst) ? dst : THROW_CCE();
    var tmp1_copyInto_0 = srcPos + size_2 | 0;
    arrayCopy_0(src, tmp0_copyInto_0, dstPos, srcPos, tmp1_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_5(src, srcPos, dst, dstPos, size_2) {
    var tmp0_copyInto_0 = srcPos + size_2 | 0;
    arrayCopy_0(src, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_6(src, srcPos, dst, dstPos, size_2) {
    var tmp0_copyInto_0 = srcPos + size_2 | 0;
    arrayCopy_0(src, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_7(src, srcPos, dst, dstPos, size_2) {
    var tmp0_copyInto_0 = srcPos + size_2 | 0;
    arrayCopy_0(src, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arrayfill(array, value, start, end) {
    return fill_2(array, value, start, end);
  }
  function _UByteArrayInt___init__impl_(bytes) {
    return bytes;
  }
  function _UByteArrayInt___get_bytes__impl_(this_0) {
    return this_0;
  }
  function _UByteArrayInt___get_size__impl_(this_0) {
    return _UByteArrayInt___get_bytes__impl_(this_0).length;
  }
  function UByteArrayInt__get_impl(this_0, index_0) {
    return _UByteArrayInt___get_bytes__impl_(this_0)[index_0] & 255;
  }
  function UByteArrayInt__set_impl(this_0, index_0, value) {
    return _UByteArrayInt___get_bytes__impl_(this_0)[index_0] = toByte(value);
  }
  function UByteArrayInt(size_2) {
    return _UByteArrayInt___init__impl_(new Int8Array(size_2));
  }
  function asByteArray(_this_) {
    return _UByteArrayInt___get_bytes__impl_(_this_);
  }
  function extract(_this_, offset_0, count_0) {
    return _this_ >>> offset_0 & mask(count_0);
  }
  function extract_0(_this_, offset_0) {
    return !((_this_ >>> offset_0 & 1) === 0);
  }
  function signExtend(_this_, bits) {
    return _this_ << (32 - bits | 0) >> (32 - bits | 0);
  }
  function insert(_this_, value, offset_0, count_0) {
    var mask_0 = mask(count_0);
    var clearValue = _this_ & ~(mask_0 << offset_0);
    return clearValue | (value & mask_0) << offset_0;
  }
  function extractBool(_this_, offset_0) {
    return extract_0(_this_, offset_0);
  }
  function extractScaledFF(_this_, offset_0, count_0) {
    return extractScaled(_this_, offset_0, count_0, 255);
  }
  function extractScaledFFDefault(_this_, offset_0, count_0, default_0) {
    return count_0 === 0 ? default_0 : extractScaled(_this_, offset_0, count_0, 255);
  }
  function insertScaledFF(_this_, value, offset_0, count_0) {
    return count_0 === 0 ? _this_ : insertScaled(_this_, value, offset_0, count_0, 255);
  }
  function extract8(_this_, offset_0) {
    return _this_ >>> offset_0 & 255;
  }
  function insert8(_this_, value, offset_0) {
    return insert(_this_, value, offset_0, 8);
  }
  function insert_0(_this_, value, offset_0) {
    return insert(_this_, value ? 1 : 0, offset_0, 1);
  }
  function setBits(_this_, bits, set_0) {
    return set_0 ? setBits_0(_this_, bits) : unsetBits(_this_, bits);
  }
  function extractByte(_this_, offset_0) {
    return toByte(_this_ >>> offset_0);
  }
  function mask(_this_) {
    return (1 << _this_) - 1 | 0;
  }
  function extractScaled(_this_, offset_0, count_0, scale_1) {
    return imul(extract(_this_, offset_0, count_0), scale_1) / mask(count_0) | 0;
  }
  function insertScaled(_this_, value, offset_0, count_0, scale_1) {
    return insert(_this_, imul(value, mask(count_0)) / scale_1 | 0, offset_0, count_0);
  }
  function setBits_0(_this_, bits) {
    return _this_ | bits;
  }
  function unsetBits(_this_, bits) {
    return _this_ & ~bits;
  }
  function asInt32Buffer(_this_) {
    return sliceInt32Buffer$default(_this_, 0, 0, 3, null);
  }
  function sliceInt32Buffer(_this_, offset_0, size_2) {
    return new Int32Array(_this_, imul(offset_0, 4), size_2);
  }
  function sliceInt32Buffer$default(_this_, offset_0, size_2, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset_0 = 0;
    if (!(($mask0 & 2) === 0)) {
      size_2 = (_this_.byteLength / 4 | 0) - offset_0 | 0;
    }return sliceInt32Buffer(_this_, offset_0, size_2);
  }
  function asInt8Buffer(_this_) {
    return sliceInt8Buffer$default(_this_, 0, 0, 3, null);
  }
  function asInt16Buffer(_this_) {
    return sliceInt16Buffer$default(_this_, 0, 0, 3, null);
  }
  function asFloat32Buffer(_this_) {
    return sliceFloat32Buffer$default(_this_, 0, 0, 3, null);
  }
  function asFloat64Buffer(_this_) {
    return sliceFloat64Buffer$default(_this_, 0, 0, 3, null);
  }
  function sliceInt8Buffer(_this_, offset_0, size_2) {
    return new Int8Array(_this_, imul(offset_0, 1), size_2);
  }
  function sliceInt8Buffer$default(_this_, offset_0, size_2, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset_0 = 0;
    if (!(($mask0 & 2) === 0)) {
      size_2 = (_this_.byteLength / 1 | 0) - offset_0 | 0;
    }return sliceInt8Buffer(_this_, offset_0, size_2);
  }
  function sliceInt16Buffer(_this_, offset_0, size_2) {
    return new Int16Array(_this_, imul(offset_0, 2), size_2);
  }
  function sliceInt16Buffer$default(_this_, offset_0, size_2, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset_0 = 0;
    if (!(($mask0 & 2) === 0)) {
      size_2 = (_this_.byteLength / 2 | 0) - offset_0 | 0;
    }return sliceInt16Buffer(_this_, offset_0, size_2);
  }
  function sliceFloat32Buffer(_this_, offset_0, size_2) {
    return new Float32Array(_this_, imul(offset_0, 4), size_2);
  }
  function sliceFloat32Buffer$default(_this_, offset_0, size_2, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset_0 = 0;
    if (!(($mask0 & 2) === 0)) {
      size_2 = (_this_.byteLength / 4 | 0) - offset_0 | 0;
    }return sliceFloat32Buffer(_this_, offset_0, size_2);
  }
  function sliceFloat64Buffer(_this_, offset_0, size_2) {
    return new Float64Array(_this_, imul(offset_0, 8), size_2);
  }
  function sliceFloat64Buffer$default(_this_, offset_0, size_2, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset_0 = 0;
    if (!(($mask0 & 2) === 0)) {
      size_2 = (_this_.byteLength / 8 | 0) - offset_0 | 0;
    }return sliceFloat64Buffer(_this_, offset_0, size_2);
  }
  function ByteArrayBuilder_init_$Init$(data, size_2, allowGrow, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      size_2 = data.length;
    if (!(($mask0 & 4) === 0))
      allowGrow = true;
    ByteArrayBuilder.call($this, data, size_2, allowGrow);
    return $this;
  }
  function ByteArrayBuilder_init_$Create$(data, size_2, allowGrow, $mask0, $marker) {
    return ByteArrayBuilder_init_$Init$(data, size_2, allowGrow, $mask0, $marker, Object.create(ByteArrayBuilder.prototype));
  }
  function ByteArrayBuilder_init_$Init$_0(initialCapacity, $this) {
    var tmp = new Int8Array(initialCapacity);
    ByteArrayBuilder_init_$Init$(tmp, 0, false, 4, null, $this);
    return $this;
  }
  function ByteArrayBuilder_init_$Create$_0(initialCapacity) {
    return ByteArrayBuilder_init_$Init$_0(initialCapacity, Object.create(ByteArrayBuilder.prototype));
  }
  function ByteArrayBuilder_init_$Init$_1(initialCapacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialCapacity = 4096;
    ByteArrayBuilder_init_$Init$_0(initialCapacity, $this);
    return $this;
  }
  function ByteArrayBuilder_init_$Create$_1(initialCapacity, $mask0, $marker) {
    return ByteArrayBuilder_init_$Init$_1(initialCapacity, $mask0, $marker, Object.create(ByteArrayBuilder.prototype));
  }
  function ensure_1($this, expected) {
    if ($this._data_14.length < expected) {
      if (!$this._allowGrow_0)
        throw RuntimeException_init_$Create$('ByteArrayBuffer configured to not grow!');
      var newSize = imul($this._data_14.length + 7 | 0, 5);
      var realNewSize = newSize < 0 ? IntCompanionObject_getInstance()._MAX_VALUE_5 / 2 | 0 : newSize;
      if (newSize < 0 ? expected > realNewSize : false) {
        throw IllegalStateException_init_$Create$_0("ByteArrayBuffer can't grow that much");
      }var tmp = $this;
      var tmp_0 = $this._data_14;
      tmp._data_14 = copyOf(tmp_0, Math.max(expected, realNewSize));
    }}
  function ensureCount($this, count_0) {
    ensure_1($this, $this.__size_1 + count_0 | 0);
  }
  function ByteArrayBuilder(data, size_2, allowGrow) {
    this._data_14 = data;
    this._allowGrow_0 = allowGrow;
    this.__size_1 = size_2;
  }
  ByteArrayBuilder.prototype._set_size__majfzk_k$ = function (value) {
    var oldPosition = this.__size_1;
    var newPosition = value;
    ensure_1(this, newPosition);
    this.__size_1 = newPosition;
    if (newPosition > oldPosition) {
      arrayfill(this._data_14, 0, oldPosition, newPosition);
    }};
  ByteArrayBuilder.prototype._get_size__0_k$ = function () {
    return this.__size_1;
  };
  ByteArrayBuilder.prototype.append_ysdrhq_k$ = function (array, offset_0, len) {
    ensureCount(this, len);
    arraycopy_2(array, offset_0, this._data_14, this.__size_1, len);
    var tmp0_this = this;
    tmp0_this.__size_1 = tmp0_this.__size_1 + len | 0;
  };
  ByteArrayBuilder.prototype.append$default_ffc7am_k$ = function (array, offset_0, len, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset_0 = 0;
    if (!(($mask0 & 4) === 0))
      len = array.length - offset_0 | 0;
    return this.append_ysdrhq_k$(array, offset_0, len);
  };
  ByteArrayBuilder.prototype.appendFast_hpsj51_k$ = function (v) {
    ensure_1(this, this.__size_1 + 1 | 0);
    var tmp = this._data_14;
    var tmp0_this = this;
    var tmp1 = tmp0_this.__size_1;
    tmp0_this.__size_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v;
  };
  ByteArrayBuilder.prototype.toByteArray_0_k$ = function () {
    return copyOf(this._data_14, this.__size_1);
  };
  ByteArrayBuilder.$metadata$ = {
    simpleName: 'ByteArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function readS16(_this_, o, little) {
    return little ? readS16LE(_this_, o) : readS16BE(_this_, o);
  }
  function write16(_this_, o, v, little) {
    return little ? write16LE(_this_, o, v) : write16BE(_this_, o, v);
  }
  function readU16BE(_this_, o) {
    return u8(_this_, o + 1 | 0) << 0 | u8(_this_, o + 0 | 0) << 8;
  }
  function readS32BE(_this_, o) {
    return u8(_this_, o + 3 | 0) << 0 | u8(_this_, o + 2 | 0) << 8 | u8(_this_, o + 1 | 0) << 16 | u8(_this_, o + 0 | 0) << 24;
  }
  function write32LE(_this_, o, v) {
    _this_[o + 0 | 0] = extractByte(v, 0);
    _this_[o + 1 | 0] = extractByte(v, 8);
    _this_[o + 2 | 0] = extractByte(v, 16);
    return _this_[o + 3 | 0] = extractByte(v, 24);
  }
  function readU16LE(_this_, o) {
    return u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8;
  }
  function readS32LE(_this_, o) {
    return u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16 | u8(_this_, o + 3 | 0) << 24;
  }
  function write16LE(_this_, o, v) {
    _this_[o + 0 | 0] = extractByte(v, 0);
    return _this_[o + 1 | 0] = extractByte(v, 8);
  }
  function write8(_this_, o, v) {
    return _this_[o] = toByte(v);
  }
  function readU24LE(_this_, o) {
    return u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16;
  }
  function readU24BE(_this_, o) {
    return u8(_this_, o + 2 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 0 | 0) << 16;
  }
  function write16BE(_this_, o, v) {
    _this_[o + 1 | 0] = extractByte(v, 0);
    return _this_[o + 0 | 0] = extractByte(v, 8);
  }
  function write24LE(_this_, o, v) {
    _this_[o + 0 | 0] = extractByte(v, 0);
    _this_[o + 1 | 0] = extractByte(v, 8);
    return _this_[o + 2 | 0] = extractByte(v, 16);
  }
  function write24BE(_this_, o, v) {
    _this_[o + 2 | 0] = extractByte(v, 0);
    _this_[o + 1 | 0] = extractByte(v, 8);
    return _this_[o + 0 | 0] = extractByte(v, 16);
  }
  function write32BE(_this_, o, v) {
    _this_[o + 3 | 0] = extractByte(v, 0);
    _this_[o + 2 | 0] = extractByte(v, 8);
    _this_[o + 1 | 0] = extractByte(v, 16);
    return _this_[o + 0 | 0] = extractByte(v, 24);
  }
  function readU8(_this_, o) {
    return _this_[o] & 255;
  }
  function readS16LE(_this_, o) {
    return signExtend(u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8, 16);
  }
  function readS24LE(_this_, o) {
    return signExtend(u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16, 24);
  }
  function readIntArrayLE(_this_, o, count_0) {
    var tmp0_readTypedArray_0 = new Int32Array(count_0);
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n_3_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__4 = o + imul(n_3_3, 4) | 0;
        tmp0_readTypedArray_0[n_3_3] = readS32LE(_this_, tmp1__anonymous__4);
      }
       while (inductionVariable < count_0);
    return tmp0_readTypedArray_0;
  }
  function readS16BE(_this_, o) {
    return signExtend(u8(_this_, o + 1 | 0) << 0 | u8(_this_, o + 0 | 0) << 8, 16);
  }
  function u8(_this_, o) {
    return _this_[o] & 255;
  }
  function readS8(_this_, o) {
    return _this_[o];
  }
  function readU32LE(_this_, o) {
    var tmp0__get_unsigned__0 = u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16 | u8(_this_, o + 3 | 0) << 24;
    return toLong(tmp0__get_unsigned__0).and_wiekkq_k$(new Long(-1, 0));
  }
  function readF32LE(_this_, o) {
    var tmp0_fromBits_0 = FloatCompanionObject_getInstance();
    var tmp1_fromBits_0 = u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16 | u8(_this_, o + 3 | 0) << 24;
    return floatFromBits(tmp1_fromBits_0);
  }
  function readS64LE(_this_, o) {
    var tmp0_read32LE_0 = o + 0 | 0;
    var tmp1__get_unsigned__0 = u8(_this_, tmp0_read32LE_0 + 0 | 0) << 0 | u8(_this_, tmp0_read32LE_0 + 1 | 0) << 8 | u8(_this_, tmp0_read32LE_0 + 2 | 0) << 16 | u8(_this_, tmp0_read32LE_0 + 3 | 0) << 24;
    var tmp = toLong(tmp1__get_unsigned__0).and_wiekkq_k$(new Long(-1, 0)).shl_ha5a7z_k$(0);
    var tmp2_read32LE_0 = o + 4 | 0;
    var tmp3__get_unsigned__0 = u8(_this_, tmp2_read32LE_0 + 0 | 0) << 0 | u8(_this_, tmp2_read32LE_0 + 1 | 0) << 8 | u8(_this_, tmp2_read32LE_0 + 2 | 0) << 16 | u8(_this_, tmp2_read32LE_0 + 3 | 0) << 24;
    return tmp.or_wiekkq_k$(toLong(tmp3__get_unsigned__0).and_wiekkq_k$(new Long(-1, 0)).shl_ha5a7z_k$(32));
  }
  function readS64BE(_this_, o) {
    var tmp0_read32BE_0 = o + 4 | 0;
    var tmp1__get_unsigned__0 = u8(_this_, tmp0_read32BE_0 + 3 | 0) << 0 | u8(_this_, tmp0_read32BE_0 + 2 | 0) << 8 | u8(_this_, tmp0_read32BE_0 + 1 | 0) << 16 | u8(_this_, tmp0_read32BE_0 + 0 | 0) << 24;
    var tmp = toLong(tmp1__get_unsigned__0).and_wiekkq_k$(new Long(-1, 0)).shl_ha5a7z_k$(0);
    var tmp2_read32BE_0 = o + 0 | 0;
    var tmp3__get_unsigned__0 = u8(_this_, tmp2_read32BE_0 + 3 | 0) << 0 | u8(_this_, tmp2_read32BE_0 + 2 | 0) << 8 | u8(_this_, tmp2_read32BE_0 + 1 | 0) << 16 | u8(_this_, tmp2_read32BE_0 + 0 | 0) << 24;
    return tmp.or_wiekkq_k$(toLong(tmp3__get_unsigned__0).and_wiekkq_k$(new Long(-1, 0)).shl_ha5a7z_k$(32));
  }
  function readByteArray(_this_, o, count_0) {
    return copyOfRange_2(_this_, o, o + count_0 | 0);
  }
  function readShortArrayBE(_this_, o, count_0) {
    var tmp0_readTypedArray_0 = new Int16Array(count_0);
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n_3_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__3 = o + imul(n_3_2, 2) | 0;
        tmp0_readTypedArray_0[n_3_2] = toShort(readS16BE(_this_, tmp1__anonymous__3));
      }
       while (inductionVariable < count_0);
    return tmp0_readTypedArray_0;
  }
  function readCharArrayBE(_this_, o, count_0) {
    var tmp0_readTypedArray_0 = charArray(count_0);
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n_3_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__3 = o + imul(n_3_2, 2) | 0;
        tmp0_readTypedArray_0[n_3_2] = numberToChar(readS16BE(_this_, tmp1__anonymous__3));
      }
       while (inductionVariable < count_0);
    return tmp0_readTypedArray_0;
  }
  function writeArrayLE(_this_, o, array) {
    var tmp0_wa_0 = array.length;
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < tmp0_wa_0) {
      do {
        var n_3_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__4 = o + imul(n_3_3, 2) | 0;
        write16LE(_this_, tmp1__anonymous__4, array[n_3_3]);
      }
       while (inductionVariable < tmp0_wa_0);
      tmp = Unit_getInstance();
    }return tmp;
  }
  function sizeAligned(_this_, $this) {
    return $this.getSizeAligned_ha5a7z_k$(_this_);
  }
  function Companion_98() {
    Companion_instance_97 = this;
  }
  Companion_98.prototype.getSizeAligned_ha5a7z_k$ = function (size_2) {
    return (size_2 + 15 | 0) & -16;
  };
  Companion_98.prototype.allocUnaligned_ha5a7z_k$ = function (size_2) {
    return new FBuffer(new ArrayBuffer(size_2), size_2);
  };
  Companion_98.prototype.alloc_ha5a7z_k$ = function (size_2) {
    return this.allocUnaligned_ha5a7z_k$(sizeAligned(size_2, this));
  };
  Companion_98.prototype.allocNoDirectUnaligned_ha5a7z_k$ = function (size_2) {
    return new FBuffer(new ArrayBuffer(size_2), size_2);
  };
  Companion_98.prototype.allocNoDirect_ha5a7z_k$ = function (size_2) {
    return this.allocNoDirectUnaligned_ha5a7z_k$(sizeAligned(size_2, this));
  };
  Companion_98.prototype.invoke_ha5a7z_k$ = function (size_2) {
    var tmp0_MemBufferAlloc_0 = sizeAligned(size_2, this);
    return new FBuffer(new ArrayBuffer(tmp0_MemBufferAlloc_0), size_2);
  };
  Companion_98.prototype.copy_4b5zmu_k$ = function (src, srcPos, dst, dstPos, length) {
    return arraycopy_11(src, srcPos, dst._get_buffer__0_k$(), dstPos, length);
  };
  Companion_98.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_97;
  function Companion_getInstance_97() {
    if (Companion_instance_97 == null)
      new Companion_98();
    return Companion_instance_97;
  }
  function FBuffer(mem, size_2) {
    Companion_getInstance_97();
    this._mem = mem;
    this._size_6 = size_2;
    this._data_15 = getData(this._mem);
    this._arrayByte = asInt8Buffer(this._mem);
    this._arrayShort = asInt16Buffer(this._mem);
    this._arrayInt = asInt32Buffer(this._mem);
    this._arrayFloat = asFloat32Buffer(this._mem);
    this._arrayDouble = asFloat64Buffer(this._mem);
    this._fast32 = NewFast32Buffer(this._mem);
  }
  FBuffer.prototype._get_buffer__0_k$ = function () {
    return this._mem;
  };
  FBuffer.prototype.set_rvwcgf_k$ = function (index_0, value) {
    var tmp0_set_0 = this._arrayByte;
    var tmp1_set_0 = toByte(value);
    tmp0_set_0[index_0] = tmp1_set_0;
  };
  FBuffer.prototype.getByte_ha5a7z_k$ = function (index_0) {
    var tmp0_get_0 = this._arrayByte;
    return tmp0_get_0[index_0];
  };
  FBuffer.prototype.getInt_ha5a7z_k$ = function (index_0) {
    var tmp0_get_0 = this._arrayInt;
    return tmp0_get_0[index_0];
  };
  FBuffer.prototype.setByte_lzfo9m_k$ = function (index_0, value) {
    var tmp0_set_0 = this._arrayByte;
    tmp0_set_0[index_0] = value;
  };
  FBuffer.prototype.setInt_rvwcgf_k$ = function (index_0, value) {
    var tmp0_set_0 = this._arrayInt;
    tmp0_set_0[index_0] = value;
  };
  FBuffer.prototype.setFloat_z49mik_k$ = function (index_0, value) {
    var tmp0_set_0 = this._arrayFloat;
    tmp0_set_0[index_0] = value;
  };
  FBuffer.prototype.getAlignedUInt8_ha5a7z_k$ = function (index_0) {
    return Uint8Buffer__get_impl(_Uint8Buffer___init__impl_(this._arrayByte), index_0) & 255;
  };
  FBuffer.prototype.getAlignedUInt16_ha5a7z_k$ = function (index_0) {
    var tmp0_get_0 = this._arrayShort;
    return tmp0_get_0[index_0] & 65535;
  };
  FBuffer.prototype.setAlignedInt32_rvwcgf_k$ = function (index_0, value) {
    var tmp0_set_0 = this._arrayInt;
    tmp0_set_0[index_0] = value;
  };
  FBuffer.prototype.getAlignedInt32_ha5a7z_k$ = function (index_0) {
    var tmp0_get_0 = this._arrayInt;
    return tmp0_get_0[index_0];
  };
  FBuffer.prototype.setAlignedFloat32_z49mik_k$ = function (index_0, value) {
    var tmp0_set_0 = this._arrayFloat;
    tmp0_set_0[index_0] = value;
  };
  FBuffer.prototype.getUnalignedInt8_ha5a7z_k$ = function (index_0) {
    return getByte(this._data_15, index_0);
  };
  FBuffer.prototype.getUnalignedUInt8_ha5a7z_k$ = function (index_0) {
    return getByte(this._data_15, index_0) & 255;
  };
  FBuffer.prototype.getUnalignedInt16_ha5a7z_k$ = function (index_0) {
    return getShort(this._data_15, index_0);
  };
  FBuffer.prototype.getUnalignedUInt16_ha5a7z_k$ = function (index_0) {
    return getShort(this._data_15, index_0) & 65535;
  };
  FBuffer.prototype.getUnalignedInt32_ha5a7z_k$ = function (index_0) {
    return getInt(this._data_15, index_0);
  };
  FBuffer.prototype.getUnalignedFloat32_ha5a7z_k$ = function (index_0) {
    return getFloat(this._data_15, index_0);
  };
  FBuffer.prototype.setAlignedArrayInt8_46tb3l_k$ = function (dstPos, src, srcPos, len) {
    return Companion_getInstance_97().copy_4b5zmu_k$(src, srcPos, this, dstPos, len);
  };
  FBuffer.$metadata$ = {
    simpleName: 'FBuffer',
    kind: 'class',
    interfaces: []
  };
  function _Uint8Buffer___init__impl_(b) {
    return b;
  }
  function _Uint8Buffer___get_b__impl_(this_0) {
    return this_0;
  }
  function Uint8Buffer__get_impl(this_0, index_0) {
    var tmp0_get_0 = _Uint8Buffer___get_b__impl_(this_0);
    return tmp0_get_0[index_0] & 255;
  }
  function FixedSizeByteArrayBuilder_init_$Init$(size_2, $this) {
    FixedSizeByteArrayBuilder.call($this, new Int8Array(size_2));
    return $this;
  }
  function FixedSizeByteArrayBuilder_init_$Create$(size_2) {
    return FixedSizeByteArrayBuilder_init_$Init$(size_2, Object.create(FixedSizeByteArrayBuilder.prototype));
  }
  function FixedSizeByteArrayBuilder(data) {
    this._data_16 = data;
    this._size_7 = 0;
  }
  FixedSizeByteArrayBuilder.prototype.clear_sv8swh_k$ = function () {
    this._size_7 = 0;
  };
  FixedSizeByteArrayBuilder.prototype.append_ysdrhq_k$ = function (array, offset_0, len) {
    arraycopy_2(array, offset_0, this._data_16, this._size_7, len);
    var tmp0_this = this;
    tmp0_this._size_7 = tmp0_this._size_7 + len | 0;
  };
  FixedSizeByteArrayBuilder.prototype.appendFast_hpsj51_k$ = function (v) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._size_7;
    tmp0_this._size_7 = tmp1 + 1 | 0;
    this._data_16[tmp1] = v;
  };
  FixedSizeByteArrayBuilder.$metadata$ = {
    simpleName: 'FixedSizeByteArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function arrayinterleave(out, outPos, array1, array1Pos, array2, array2Pos, size_2, temp_0) {
    try {
      temp_0._ptr = out;
      var m_2 = outPos;
      var inductionVariable = 0;
      if (inductionVariable < size_2)
        do {
          var n_4 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1_6 = m_2;
          m_2 = tmp1_6 + 1 | 0;
          var tmp0_set_0_5 = tmp1_6;
          var tmp1_set_0_7 = array1[array1Pos + n_4 | 0];
          temp_0._ptr[tmp0_set_0_5] = tmp1_set_0_7;
          var tmp2_9 = m_2;
          m_2 = tmp2_9 + 1 | 0;
          var tmp2_set_0_8 = tmp2_9;
          var tmp3_set_0_10 = array2[array2Pos + n_4 | 0];
          temp_0._ptr[tmp2_set_0_8] = tmp3_set_0_10;
        }
         while (inductionVariable < size_2);
    }finally {
      temp_0._ptr = EmptyShortArray;
    }
  }
  function KmemGCImpl() {
    this._threshold = 0;
    this._thresholdAllocations = new Long(0, 0);
    this._autotune = true;
    this._cyclicCollectorEnabled = true;
  }
  KmemGCImpl.$metadata$ = {
    simpleName: 'KmemGCImpl',
    kind: 'class',
    interfaces: []
  };
  function clamp_2(_this_, min_0, max) {
    return _this_ < min_0 ? min_0 : _this_ > max ? max : _this_;
  }
  function toIntClamp(_this_, min_0, max) {
    if (_this_.compareTo_wiekkq_k$(toLong(min_0)) < 0)
      return min_0;
    if (_this_.compareTo_wiekkq_k$(toLong(max)) > 0)
      return max;
    return _this_.toInt_0_k$();
  }
  function toIntClamp$default(_this_, min_0, max, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      min_0 = IntCompanionObject_getInstance()._MIN_VALUE_5;
    if (!(($mask0 & 2) === 0))
      max = IntCompanionObject_getInstance()._MAX_VALUE_5;
    return toIntClamp(_this_, min_0, max);
  }
  function ilog2_0(v) {
    var tmp;
    if (v === 0) {
      tmp = -1;
    } else {
      tmp = 31 - Math.clz32(v) | 0;
    }
    return tmp;
  }
  function clamp01(_this_) {
    return clamp_3(_this_, 0.0, 1.0);
  }
  function clamp01_0(_this_) {
    return clamp_4(_this_, 0.0, 1.0);
  }
  function convertRangeClamped(_this_, srcMin, srcMax, dstMin, dstMax) {
    return clamp_3(convertRange_0(_this_, srcMin, srcMax, dstMin, dstMax), dstMin, dstMax);
  }
  function toIntRound(_this_) {
    return numberToLong(round(_this_)).toInt_0_k$();
  }
  function toIntFloor(_this_) {
    return numberToInt(Math.floor(_this_));
  }
  function toIntCeil(_this_) {
    return numberToInt(Math.ceil(_this_));
  }
  function clamp_3(_this_, min_0, max) {
    return _this_ < min_0 ? min_0 : _this_ > max ? max : _this_;
  }
  function convertRange(_this_, srcMin, srcMax, dstMin, dstMax) {
    return numberToInt(dstMin + (dstMax - dstMin | 0) * ((_this_ - srcMin | 0) / (srcMax - srcMin | 0)));
  }
  function convertRange_0(_this_, srcMin, srcMax, dstMin, dstMax) {
    return dstMin + (dstMax - dstMin) * ((_this_ - srcMin) / (srcMax - srcMin));
  }
  function _get_nextPowerOfTwo_(_this_) {
    var v = _this_;
    var tmp0 = v;
    v = tmp0 - 1 | 0;
    Unit_getInstance();
    v = v | v >> 1;
    v = v | v >> 2;
    v = v | v >> 4;
    v = v | v >> 8;
    v = v | v >> 16;
    var tmp1 = v;
    v = tmp1 + 1 | 0;
    Unit_getInstance();
    return v;
  }
  function umod_2(_this_, other) {
    var rm = _this_ % other;
    var remainder = rm === 0 ? 0 : rm;
    return remainder < 0 ? remainder + other | 0 : remainder;
  }
  function _get_isEven_(_this_) {
    return _this_ % 2 === 0;
  }
  function _get_isOdd_(_this_) {
    return _this_ % 2 === 1;
  }
  function clamp_4(_this_, min_0, max) {
    return _this_ < min_0 ? min_0 : _this_ > max ? max : _this_;
  }
  function isNanOrInfinite(_this_) {
    return isNaN_0(_this_) ? true : isInfinite_0(_this_);
  }
  function nextAlignedTo(_this_, align) {
    return isAlignedTo(_this_, align) ? _this_ : imul((_this_ / align | 0) + 1 | 0, align);
  }
  function clamp_5(_this_, min_0, max) {
    return _this_.compareTo_wiekkq_k$(min_0) < 0 ? min_0 : _this_.compareTo_wiekkq_k$(max) > 0 ? max : _this_;
  }
  function _get_isPowerOfTwo_(_this_) {
    return _get_nextPowerOfTwo_(_this_) === _this_;
  }
  function isAlignedTo(_this_, alignment) {
    return alignment === 0 ? true : _this_ % alignment === 0;
  }
  function Fast32Buffer(buffer) {
    this._buffer_3 = buffer;
    this._f32 = new Float32Array(this._buffer_3);
    this._i32 = new Int32Array(this._buffer_3);
  }
  Fast32Buffer.$metadata$ = {
    simpleName: 'Fast32Buffer',
    kind: 'class',
    interfaces: []
  };
  function arraycopy_8(src, srcPos, dst, dstPos, size_2) {
    if (size_2 <= 128) {
      var inductionVariable = 0;
      if (inductionVariable < size_2)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_set_0 = dstPos + n | 0;
          var tmp1_set_0 = src[srcPos + n | 0];
          dst[tmp0_set_0] = tmp1_set_0;
        }
         while (inductionVariable < size_2);
      return Unit_getInstance();
    }arraycopy_12(src, srcPos, dst.buffer, dstPos, size_2);
  }
  function arraycopy_9(src, srcPos, dst, dstPos, size_2) {
    if (!(src === dst) ? size_2 <= 128 : false) {
      var inductionVariable = 0;
      if (inductionVariable < size_2)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1_set_0 = dstPos + n | 0;
          var tmp0_get_0 = srcPos + n | 0;
          var tmp2_set_0 = src[tmp0_get_0];
          dst[tmp1_set_0] = tmp2_set_0;
        }
         while (inductionVariable < size_2);
      return Unit_getInstance();
    }var tmp = src.buffer;
    var tmp_0 = imul(srcPos, 4);
    arraycopy_10(tmp, tmp_0, dst.buffer, imul(dstPos, 4), imul(size_2, 4));
  }
  function getData(_this_) {
    return new DataView(_this_);
  }
  function NewFast32Buffer(mem) {
    return new Fast32BufferF(mem);
  }
  function arraycopy_10(src, srcPos, dst, dstPos, size_2) {
    (new Int8Array(dst, dstPos, size_2)).set(new Int8Array(src, srcPos, size_2), 0);
  }
  function arraycopy_11(src, srcPos, dst, dstPos, size_2) {
    var tmp = new Int8Array(dst);
    return tmp.set(src.subarray(srcPos, srcPos + size_2 | 0), dstPos);
  }
  function arraycopy_12(src, srcPos, dst, dstPos, size_2) {
    var tmp = new Int16Array(dst);
    return tmp.set(src.subarray(srcPos, srcPos + size_2 | 0), dstPos);
  }
  function arraycopy_13(src, srcPos, dst, dstPos, size_2) {
    var tmp = new Int32Array(dst);
    return tmp.set(src.subarray(srcPos, srcPos + size_2 | 0), dstPos);
  }
  function arraycopy_14(src, srcPos, dst, dstPos, size_2) {
    var tmp = new Float32Array(dst);
    return tmp.set(src.subarray(srcPos, srcPos + size_2 | 0), dstPos);
  }
  function getByte(_this_, index_0) {
    return _this_.getInt8(index_0);
  }
  function getShort(_this_, index_0) {
    return _this_.getInt16(index_0, true);
  }
  function getInt(_this_, index_0) {
    return _this_.getInt32(index_0, true);
  }
  function getFloat(_this_, index_0) {
    return _this_.getFloat32(index_0, true);
  }
  function Fast32BufferF(buffer) {
    Fast32Buffer.call(this, buffer);
  }
  Fast32BufferF.$metadata$ = {
    simpleName: 'Fast32BufferF',
    kind: 'class',
    interfaces: []
  };
  function arraycopy_15(src, srcPos, dst, dstPos, size_2) {
    if (!(src === dst) ? size_2 <= 128 : false) {
      var inductionVariable = 0;
      if (inductionVariable < size_2)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1_set_0 = dstPos + n | 0;
          var tmp0_get_0 = srcPos + n | 0;
          var tmp2_set_0 = src[tmp0_get_0];
          dst[tmp1_set_0] = tmp2_set_0;
        }
         while (inductionVariable < size_2);
      return Unit_getInstance();
    }var tmp = src.buffer;
    var tmp_0 = imul(srcPos, 4);
    arraycopy_10(tmp, tmp_0, dst.buffer, imul(dstPos, 4), imul(size_2, 4));
  }
  function arraycopy_16(src, srcPos, dst, dstPos, size_2) {
    if (size_2 <= 128) {
      var inductionVariable = 0;
      if (inductionVariable < size_2)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_set_0 = dstPos + n | 0;
          var tmp1_set_0 = src[srcPos + n | 0];
          dst[tmp0_set_0] = tmp1_set_0;
        }
         while (inductionVariable < size_2);
      return Unit_getInstance();
    }arraycopy_11(src, srcPos, dst.buffer, dstPos, size_2);
  }
  function arraycopy_17(src, srcPos, dst, dstPos, size_2) {
    if (size_2 <= 128) {
      var inductionVariable = 0;
      if (inductionVariable < size_2)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_set_0 = dstPos + n | 0;
          var tmp1_set_0 = src[srcPos + n | 0];
          dst[tmp0_set_0] = tmp1_set_0;
        }
         while (inductionVariable < size_2);
      return Unit_getInstance();
    }arraycopy_14(src, srcPos, dst.buffer, dstPos, size_2);
  }
  function arraycopy_18(src, srcPos, dst, dstPos, size_2) {
    if (size_2 <= 128) {
      var inductionVariable = 0;
      if (inductionVariable < size_2)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_set_0 = dstPos + n | 0;
          var tmp1_set_0 = src[srcPos + n | 0];
          dst[tmp0_set_0] = tmp1_set_0;
        }
         while (inductionVariable < size_2);
      return Unit_getInstance();
    }arraycopy_13(src, srcPos, dst.buffer, dstPos, size_2);
  }
  var KmemGC;
  function _no_name_provided__110() {
    KmemGCImpl.call(this);
  }
  _no_name_provided__110.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function KmemGC$init$() {
    return new _no_name_provided__110();
  }
  var EmptyByteArray;
  var EmptyShortArray;
  var EmptyIntArray;
  var EmptyFloatArray;
  function FastShortTransfer() {
    this._ptr = EmptyShortArray;
  }
  FastShortTransfer.$metadata$ = {
    simpleName: 'FastShortTransfer',
    kind: 'class',
    interfaces: []
  };
  var randomUnittesting;
  function fromBase64(_this_, ignoreSpaces) {
    return ignoreSpaces ? Base64_getInstance().decodeIgnoringSpaces_6wfw3l_k$(_this_) : Base64_getInstance().decode_6wfw3l_k$(_this_);
  }
  function fromBase64$default(_this_, ignoreSpaces, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      ignoreSpaces = false;
    return fromBase64(_this_, ignoreSpaces);
  }
  function toBase64(_this_) {
    return Base64_getInstance().encode_b1bk5f_k$(_this_);
  }
  function readU8_0(_this_, $this, index_0) {
    return _this_[index_0] & 255;
  }
  function readU24BE_0(_this_, $this, index_0) {
    return readU8_0(_this_, $this, index_0 + 0 | 0) << 16 | readU8_0(_this_, $this, index_0 + 1 | 0) << 8 | readU8_0(_this_, $this, index_0 + 2 | 0) << 0;
  }
  function Base64() {
    Base64_instance = this;
    this._TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var tmp = this;
    var tmp0_apply_0 = new Int32Array(256);
    var inductionVariable = 0;
    if (inductionVariable <= 255)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0[n_3] = -1;
      }
       while (inductionVariable <= 255);
    var inductionVariable_0 = 0;
    var last_1 = Base64_getInstance()._TABLE.length;
    if (inductionVariable_0 < last_1)
      do {
        var n_5 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        tmp0_apply_0[charSequenceGet(Base64_getInstance()._TABLE, n_5).toInt_0_k$()] = n_5;
      }
       while (inductionVariable_0 < last_1);
    tmp._DECODE = tmp0_apply_0;
  }
  Base64.prototype.decode_6wfw3l_k$ = function (str) {
    var tmp = 0;
    var tmp_0 = str.length;
    var tmp_1 = new Int8Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = charSequenceGet(str, tmp_2).toByte_0_k$();
      tmp = tmp + 1 | 0;
    }
    var src = tmp_1;
    var dst = new Int8Array(src.length);
    return copyOf(dst, this.decode_9or1wg_k$(src, dst));
  };
  Base64.prototype.decodeIgnoringSpaces_6wfw3l_k$ = function (str) {
    var tmp = replace$default_0(str, ' ', '', false, 4, null);
    var tmp_0 = replace$default_0(tmp, '\n', '', false, 4, null);
    return this.decode_6wfw3l_k$(replace$default_0(tmp_0, '\r', '', false, 4, null));
  };
  Base64.prototype.decode_9or1wg_k$ = function (src, dst) {
    var m = 0;
    var n = 0;
    while (n < src.length) {
      var d = this._DECODE[readU8_0(src, this, n)];
      if (d < 0) {
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        Unit_getInstance();
        continue;
      }var tmp;
      if (n < src.length) {
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        tmp = this._DECODE[readU8_0(src, this, tmp1)];
      } else {
        tmp = 64;
      }
      var b0 = tmp;
      var tmp_0;
      if (n < src.length) {
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        tmp_0 = this._DECODE[readU8_0(src, this, tmp2)];
      } else {
        tmp_0 = 64;
      }
      var b1 = tmp_0;
      var tmp_1;
      if (n < src.length) {
        var tmp3 = n;
        n = tmp3 + 1 | 0;
        tmp_1 = this._DECODE[readU8_0(src, this, tmp3)];
      } else {
        tmp_1 = 64;
      }
      var b2 = tmp_1;
      var tmp_2;
      if (n < src.length) {
        var tmp4 = n;
        n = tmp4 + 1 | 0;
        tmp_2 = this._DECODE[readU8_0(src, this, tmp4)];
      } else {
        tmp_2 = 64;
      }
      var b3 = tmp_2;
      var tmp5 = m;
      m = tmp5 + 1 | 0;
      dst[tmp5] = toByte(b0 << 2 | b1 >> 4);
      if (b2 < 64) {
        var tmp6 = m;
        m = tmp6 + 1 | 0;
        dst[tmp6] = toByte(b1 << 4 | b2 >> 2);
        if (b3 < 64) {
          var tmp7 = m;
          m = tmp7 + 1 | 0;
          dst[tmp7] = toByte(b2 << 6 | b3);
        }}}
    return m;
  };
  Base64.prototype.encode_b1bk5f_k$ = function (src) {
    var out = StringBuilder_init_$Create$((imul(src.length, 4) / 3 | 0) + 4 | 0);
    var ipos = 0;
    var extraBytes = src.length % 3;
    while (ipos < (src.length - 2 | 0)) {
      var num = readU24BE_0(src, this, ipos);
      ipos = ipos + 3 | 0;
      out.append_wi8o78_k$(charSequenceGet(this._TABLE, num >>> 18 & 63));
      Unit_getInstance();
      out.append_wi8o78_k$(charSequenceGet(this._TABLE, num >>> 12 & 63));
      Unit_getInstance();
      out.append_wi8o78_k$(charSequenceGet(this._TABLE, num >>> 6 & 63));
      Unit_getInstance();
      out.append_wi8o78_k$(charSequenceGet(this._TABLE, num >>> 0 & 63));
      Unit_getInstance();
    }
    if (extraBytes === 1) {
      var tmp0 = ipos;
      ipos = tmp0 + 1 | 0;
      var num_0 = readU8_0(src, this, tmp0);
      out.append_wi8o78_k$(charSequenceGet(this._TABLE, num_0 >>> 2));
      Unit_getInstance();
      out.append_wi8o78_k$(charSequenceGet(this._TABLE, num_0 << 4 & 63));
      Unit_getInstance();
      out.append_wi8o78_k$(new Char(61));
      Unit_getInstance();
      out.append_wi8o78_k$(new Char(61));
      Unit_getInstance();
    } else if (extraBytes === 2) {
      var tmp2 = ipos;
      ipos = tmp2 + 1 | 0;
      var tmp = readU8_0(src, this, tmp2) << 8;
      var tmp1 = ipos;
      ipos = tmp1 + 1 | 0;
      var tmp_0 = tmp | readU8_0(src, this, tmp1);
      out.append_wi8o78_k$(charSequenceGet(this._TABLE, tmp_0 >>> 10));
      Unit_getInstance();
      out.append_wi8o78_k$(charSequenceGet(this._TABLE, tmp_0 >>> 4 & 63));
      Unit_getInstance();
      out.append_wi8o78_k$(charSequenceGet(this._TABLE, tmp_0 << 2 & 63));
      Unit_getInstance();
      out.append_wi8o78_k$(new Char(61));
      Unit_getInstance();
    }return out.toString();
  };
  Base64.$metadata$ = {
    simpleName: 'Base64',
    kind: 'object',
    interfaces: []
  };
  var Base64_instance;
  function Base64_getInstance() {
    if (Base64_instance == null)
      new Base64();
    return Base64_instance;
  }
  function encode($this, src, dst, digits) {
    var inductionVariable = 0;
    var last_1 = src.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = src[n] & 255;
        dst.append_wi8o78_k$(charSequenceGet(digits, v >>> 4 & 15));
        Unit_getInstance();
        dst.append_wi8o78_k$(charSequenceGet(digits, v >>> 0 & 15));
        Unit_getInstance();
      }
       while (inductionVariable <= last_1);
  }
  function encodeBase($this, data, digits) {
    var tmp0_buildString_0 = imul(data.length, 2);
    var tmp0_apply_0_1 = StringBuilder_init_$Create$(tmp0_buildString_0);
    encode(Hex_getInstance(), data, tmp0_apply_0_1, digits);
    return tmp0_apply_0_1.toString();
  }
  function Hex() {
    Hex_instance = this;
    this._DIGITS = '0123456789ABCDEF';
    var tmp = this;
    var tmp0_toUpperCase_0 = '0123456789ABCDEF';
    tmp._DIGITS_UPPER = tmp0_toUpperCase_0.toUpperCase();
    var tmp_0 = this;
    var tmp0_toLowerCase_0 = '0123456789ABCDEF';
    tmp_0._DIGITS_LOWER = tmp0_toLowerCase_0.toLowerCase();
  }
  Hex.prototype.decodeHexDigit_wi8o78_k$ = function (c) {
    var result = this.decodeChar_wi8o78_k$(c);
    if (result < 0) {
      var tmp0_error_0 = '' + "Invalid hex digit '" + c + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }return result;
  };
  Hex.prototype.decodeChar_wi8o78_k$ = function (c) {
    var tmp0_subject = c;
    return (new Char(48) <= tmp0_subject ? tmp0_subject <= new Char(57) : false) ? c.minus_wi8o78_k$(new Char(48)) : (new Char(97) <= tmp0_subject ? tmp0_subject <= new Char(102) : false) ? c.minus_wi8o78_k$(new Char(97)) + 10 | 0 : (new Char(65) <= tmp0_subject ? tmp0_subject <= new Char(70) : false) ? c.minus_wi8o78_k$(new Char(65)) + 10 | 0 : -1;
  };
  Hex.prototype.encodeCharLower_ha5a7z_k$ = function (v) {
    return charSequenceGet(this._DIGITS_LOWER, v);
  };
  Hex.prototype.encodeCharUpper_ha5a7z_k$ = function (v) {
    return charSequenceGet(this._DIGITS_UPPER, v);
  };
  Hex.prototype.appendHexByte_ertsrb_k$ = function (appender, value) {
    appender.append_wi8o78_k$(this.encodeCharLower_ha5a7z_k$(value >>> 4 & 15));
    Unit_getInstance();
    appender.append_wi8o78_k$(this.encodeCharLower_ha5a7z_k$(value >>> 0 & 15));
    Unit_getInstance();
  };
  Hex.prototype.decode_nwdxb8_k$ = function (str, out) {
    var tmp0_decode_0_2 = Hex_getInstance();
    var inductionVariable = 0;
    var last_1 = str.length / 2 | 0;
    if (inductionVariable < last_1)
      do {
        var n_2_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0_3_5 = tmp0_decode_0_2.decodeHexDigit_wi8o78_k$(charSequenceGet(str, imul(n_2_4, 2) + 0 | 0));
        var c1_4_6 = tmp0_decode_0_2.decodeHexDigit_wi8o78_k$(charSequenceGet(str, imul(n_2_4, 2) + 1 | 0));
        var tmp1__anonymous__5_7 = toByte(c0_3_5 << 4 | c1_4_6);
        out[n_2_4] = tmp1__anonymous__5_7;
      }
       while (inductionVariable < last_1);
    return out;
  };
  Hex.prototype.decode$default_vx7yh3_k$ = function (str, out, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      out = new Int8Array(str.length / 2 | 0);
    return this.decode_nwdxb8_k$(str, out);
  };
  Hex.prototype.encodeLower_b1bk5f_k$ = function (src) {
    return encodeBase(this, src, this._DIGITS_LOWER);
  };
  Hex.$metadata$ = {
    simpleName: 'Hex',
    kind: 'object',
    interfaces: []
  };
  var Hex_instance;
  function Hex_getInstance() {
    if (Hex_instance == null)
      new Hex();
    return Hex_instance;
  }
  function _get_hex_(_this_) {
    return '' + '0x' + _get_shex_(_this_);
  }
  function _get_hex__0(_this_) {
    return Hex_getInstance().encodeLower_b1bk5f_k$(_this_);
  }
  function _get_unhex_(_this_) {
    var tmp = Hex_getInstance();
    return tmp.decode$default_vx7yh3_k$(_this_, null, 2, null);
  }
  function _get_shex_(_this_) {
    var out = '';
    var inductionVariable = 0;
    if (inductionVariable < 8)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = _this_ >>> imul(7 - n | 0, 4) & 15;
        out = out + Hex_getInstance().encodeCharUpper_ha5a7z_k$(v);
      }
       while (inductionVariable < 8);
    return out;
  }
  function appendHexByte(_this_, value) {
    return Hex_getInstance().appendHexByte_ertsrb_k$(_this_, value);
  }
  var isNodeJs$delegate;
  var _global;
  function _no_name_provided__111() {
  }
  _no_name_provided__111.prototype.invoke_0_k$ = function () {
    var tmp0_unsafeCast_0 = typeof process === 'object' && typeof require === 'function';
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__111.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_89() {
    var i = new _no_name_provided__111();
    return function () {
      return i.invoke_0_k$();
    };
  }
  var Kind_ERROR_instance;
  var Kind_WARN_instance;
  var Kind_INFO_instance;
  var Kind_DEBUG_instance;
  var Kind_TRACE_instance;
  var Kind_LOG_instance;
  var Kind_entriesInitialized;
  function Kind_initEntries() {
    if (Kind_entriesInitialized)
      return Unit_getInstance();
    Kind_entriesInitialized = true;
    Kind_ERROR_instance = new Kind('ERROR', 0, 0, Color_RED_getInstance());
    Kind_WARN_instance = new Kind('WARN', 1, 1, Color_YELLOW_getInstance());
    Kind_INFO_instance = new Kind('INFO', 2, 2, Color_BLUE_getInstance());
    Kind_DEBUG_instance = new Kind('DEBUG', 3, 3, Color_CYAN_getInstance());
    Kind_TRACE_instance = new Kind('TRACE', 4, 4, Color_GREEN_getInstance());
    Kind_LOG_instance = new Kind('LOG', 5, 5, null);
  }
  function Kind(name, ordinal, level, color_0) {
    Enum.call(this, name, ordinal);
    this._level = level;
    this._color_2 = color_0;
  }
  Kind.$metadata$ = {
    simpleName: 'Kind',
    kind: 'class',
    interfaces: []
  };
  function Kind_ERROR_getInstance() {
    Kind_initEntries();
    return Kind_ERROR_instance;
  }
  function Kind_WARN_getInstance() {
    Kind_initEntries();
    return Kind_WARN_instance;
  }
  function Kind_INFO_getInstance() {
    Kind_initEntries();
    return Kind_INFO_instance;
  }
  function Kind_DEBUG_getInstance() {
    Kind_initEntries();
    return Kind_DEBUG_instance;
  }
  function Kind_TRACE_getInstance() {
    Kind_initEntries();
    return Kind_TRACE_instance;
  }
  function Kind_LOG_getInstance() {
    Kind_initEntries();
    return Kind_LOG_instance;
  }
  function BaseConsole() {
  }
  BaseConsole.prototype.log_ahhys2_k$ = function (kind, msg) {
    println(this.logToString_fj5a81_k$(kind, msg.slice()));
  };
  BaseConsole.prototype.logToString_fj5a81_k$ = function (kind, msg) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var color_3 = kind._color_2;
    if (!(color_3 == null)) {
      this.appendFgColor$default_dyn3vg_k$(tmp0_apply_0_1, color_3, false, 2, null);
      Unit_getInstance();
    }joinTo$default(msg, tmp0_apply_0_1, ', ', null, null, 0, null, null, 124, null);
    Unit_getInstance();
    if (!(color_3 == null)) {
      this.appendReset_85vhob_k$(tmp0_apply_0_1);
      Unit_getInstance();
    }return tmp0_apply_0_1.toString();
  };
  BaseConsole.prototype.log_c2g51s_k$ = function (msg) {
    return this.log_ahhys2_k$(Kind_LOG_getInstance(), msg.slice());
  };
  BaseConsole.prototype.trace_c2g51s_k$ = function (msg) {
    return this.log_ahhys2_k$(Kind_TRACE_getInstance(), msg.slice());
  };
  BaseConsole.prototype.debug_c2g51s_k$ = function (msg) {
    return this.log_ahhys2_k$(Kind_DEBUG_getInstance(), msg.slice());
  };
  BaseConsole.prototype.info_c2g51s_k$ = function (msg) {
    return this.log_ahhys2_k$(Kind_INFO_getInstance(), msg.slice());
  };
  BaseConsole.prototype.warn_c2g51s_k$ = function (msg) {
    return this.log_ahhys2_k$(Kind_WARN_getInstance(), msg.slice());
  };
  BaseConsole.prototype.error_c2g51s_k$ = function (msg) {
    return this.log_ahhys2_k$(Kind_ERROR_getInstance(), msg.slice());
  };
  BaseConsole.$metadata$ = {
    simpleName: 'BaseConsole',
    kind: 'class',
    interfaces: [AnsiEscape]
  };
  var Color_BLACK_instance;
  var Color_RED_instance;
  var Color_GREEN_instance;
  var Color_YELLOW_instance;
  var Color_BLUE_instance;
  var Color_PURPLE_instance;
  var Color_CYAN_instance;
  var Color_WHITE_instance;
  var Color_entriesInitialized;
  function Color_initEntries() {
    if (Color_entriesInitialized)
      return Unit_getInstance();
    Color_entriesInitialized = true;
    Color_BLACK_instance = new Color('BLACK', 0, 0);
    Color_RED_instance = new Color('RED', 1, 1);
    Color_GREEN_instance = new Color('GREEN', 2, 2);
    Color_YELLOW_instance = new Color('YELLOW', 3, 3);
    Color_BLUE_instance = new Color('BLUE', 4, 4);
    Color_PURPLE_instance = new Color('PURPLE', 5, 5);
    Color_CYAN_instance = new Color('CYAN', 6, 6);
    Color_WHITE_instance = new Color('WHITE', 7, 7);
  }
  function Color(name, ordinal, index_0) {
    Enum.call(this, name, ordinal);
    this._index_14 = index_0;
  }
  Color.$metadata$ = {
    simpleName: 'Color',
    kind: 'class',
    interfaces: []
  };
  function Color_RED_getInstance() {
    Color_initEntries();
    return Color_RED_instance;
  }
  function Color_GREEN_getInstance() {
    Color_initEntries();
    return Color_GREEN_instance;
  }
  function Color_YELLOW_getInstance() {
    Color_initEntries();
    return Color_YELLOW_instance;
  }
  function Color_BLUE_getInstance() {
    Color_initEntries();
    return Color_BLUE_instance;
  }
  function Color_CYAN_getInstance() {
    Color_initEntries();
    return Color_CYAN_instance;
  }
  function AnsiEscape() {
  }
  AnsiEscape.prototype.appendAnsiScape_jbsthk_k$ = function (_this__0, code, extra, char) {
    _this__0.append_wi8o78_k$(new Char(27));
    Unit_getInstance();
    _this__0.append_wi8o78_k$(new Char(91));
    Unit_getInstance();
    _this__0.append_wi7j7l_k$(code);
    Unit_getInstance();
    if (!(extra == null)) {
      _this__0.append_uch40_k$(extra);
      Unit_getInstance();
    }_this__0.append_wi8o78_k$(char);
    Unit_getInstance();
    return _this__0;
  };
  AnsiEscape.prototype.appendAnsiScape$default_ojj93a_k$ = function (_this__0, code, extra, char, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      extra = null;
    if (!(($mask0 & 4) === 0))
      char = new Char(109);
    return $handler == null ? this.appendAnsiScape_jbsthk_k$(_this__0, code, extra, char) : $handler(code, extra, char);
  };
  AnsiEscape.prototype.appendReset_85vhob_k$ = function (_this__0) {
    return this.appendAnsiScape$default_ojj93a_k$(_this__0, 0, null, new Char(0), 6, null);
  };
  AnsiEscape.prototype.appendFgColor_2ur4wq_k$ = function (_this__0, color_0, bright) {
    var tmp = 30 + color_0._index_14 | 0;
    var tmp_0 = bright ? ';1' : null;
    return this.appendAnsiScape$default_ojj93a_k$(_this__0, tmp, tmp_0, new Char(0), 4, null);
  };
  AnsiEscape.prototype.appendFgColor$default_dyn3vg_k$ = function (_this__0, color_0, bright, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      bright = false;
    return $handler == null ? this.appendFgColor_2ur4wq_k$(_this__0, color_0, bright) : $handler(color_0, bright);
  };
  AnsiEscape.$metadata$ = {
    simpleName: 'AnsiEscape',
    kind: 'interface',
    interfaces: []
  };
  var Level_NONE_instance;
  var Level_FATAL_instance;
  var Level_ERROR_instance;
  var Level_WARN_instance;
  var Level_INFO_instance;
  var Level_DEBUG_instance;
  var Level_TRACE_instance;
  function valueOf(value) {
    switch (value) {
      case 'NONE':
        return Level_NONE_getInstance();
      case 'FATAL':
        return Level_FATAL_getInstance();
      case 'ERROR':
        return Level_ERROR_getInstance();
      case 'WARN':
        return Level_WARN_getInstance();
      case 'INFO':
        return Level_INFO_getInstance();
      case 'DEBUG':
        return Level_DEBUG_getInstance();
      case 'TRACE':
        return Level_TRACE_getInstance();
      default:Level_initEntries();
        THROW_ISE();
        break;
    }
  }
  var Level_entriesInitialized;
  function Level_initEntries() {
    if (Level_entriesInitialized)
      return Unit_getInstance();
    Level_entriesInitialized = true;
    Level_NONE_instance = new Level('NONE', 0, 0);
    Level_FATAL_instance = new Level('FATAL', 1, 1);
    Level_ERROR_instance = new Level('ERROR', 2, 2);
    Level_WARN_instance = new Level('WARN', 3, 3);
    Level_INFO_instance = new Level('INFO', 4, 4);
    Level_DEBUG_instance = new Level('DEBUG', 5, 5);
    Level_TRACE_instance = new Level('TRACE', 6, 6);
  }
  function Companion_99() {
    Companion_instance_98 = this;
    this._Logger_loggers = new KloggerAtomicRef(emptyMap());
    this._Logger_levels = new KloggerAtomicRef(emptyMap());
    this._Logger_outputs = new KloggerAtomicRef(emptyMap());
    this._defaultLevel$delegate = new KloggerAtomicRef(null);
    this._defaultOutput$delegate = new KloggerAtomicRef(DefaultLogOutput_getInstance());
  }
  Companion_99.prototype._set_defaultLevel__nfm93o_k$ = function (_set___) {
    return setValue(this._defaultLevel$delegate, this, defaultLevel$factory(), _set___);
  };
  Companion_99.prototype._get_defaultLevel__0_k$ = function () {
    return getValue(this._defaultLevel$delegate, this, defaultLevel$factory_0());
  };
  Companion_99.prototype._set_defaultOutput__nkezbu_k$ = function (_set___) {
    return setValue(this._defaultOutput$delegate, this, defaultOutput$factory(), _set___);
  };
  Companion_99.prototype._get_defaultOutput__0_k$ = function () {
    return getValue(this._defaultOutput$delegate, this, defaultOutput$factory_0());
  };
  Companion_99.prototype.invoke_6wfw3l_k$ = function (name) {
    var tmp0_get_0 = this._Logger_loggers;
    var tmp0_elvis_lhs = tmp0_get_0._value_4.get_2bw_k$(name);
    return tmp0_elvis_lhs == null ? new Logger(name, true) : tmp0_elvis_lhs;
  };
  Companion_99.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_98;
  function Companion_getInstance_98() {
    if (Companion_instance_98 == null)
      new Companion_99();
    return Companion_instance_98;
  }
  function Level(name, ordinal, index_0) {
    Enum.call(this, name, ordinal);
    this._index_15 = index_0;
  }
  Level.$metadata$ = {
    simpleName: 'Level',
    kind: 'class',
    interfaces: []
  };
  function Output() {
  }
  Output.$metadata$ = {
    simpleName: 'Output',
    kind: 'interface',
    interfaces: []
  };
  function ConsoleLogOutput() {
    ConsoleLogOutput_instance = this;
  }
  ConsoleLogOutput.prototype.output_kbo5o0_k$ = function (logger_1, level, msg) {
    var tmp0_subject = level;
    if (tmp0_subject.equals(Level_ERROR_getInstance()))
      Console_getInstance().error_c2g51s_k$([logger_1._name_2, msg]);
    else if (tmp0_subject.equals(Level_WARN_getInstance()))
      Console_getInstance().warn_c2g51s_k$([logger_1._name_2, msg]);
    else
      Console_getInstance().log_c2g51s_k$([logger_1._name_2, msg]);
  };
  ConsoleLogOutput.$metadata$ = {
    simpleName: 'ConsoleLogOutput',
    kind: 'object',
    interfaces: [Output]
  };
  var ConsoleLogOutput_instance;
  function ConsoleLogOutput_getInstance() {
    if (ConsoleLogOutput_instance == null)
      new ConsoleLogOutput();
    return ConsoleLogOutput_instance;
  }
  function Level_NONE_getInstance() {
    Level_initEntries();
    return Level_NONE_instance;
  }
  function Level_FATAL_getInstance() {
    Level_initEntries();
    return Level_FATAL_instance;
  }
  function Level_ERROR_getInstance() {
    Level_initEntries();
    return Level_ERROR_instance;
  }
  function Level_WARN_getInstance() {
    Level_initEntries();
    return Level_WARN_instance;
  }
  function Level_INFO_getInstance() {
    Level_initEntries();
    return Level_INFO_instance;
  }
  function Level_DEBUG_getInstance() {
    Level_initEntries();
    return Level_DEBUG_instance;
  }
  function Level_TRACE_getInstance() {
    Level_initEntries();
    return Level_TRACE_instance;
  }
  function Logger(name, dummy) {
    Companion_getInstance_98();
    this._name_2 = name;
    this._dummy = dummy;
    var tmp1_set_0 = Companion_getInstance_98()._Logger_loggers;
    var tmp2_set_0 = this._name_2;
    var tmp = tmp1_set_0;
    var tmp0__anonymous__1_1 = tmp1_set_0._value_4;
    var tmp0_also_0_2 = HashMap_init_$Create$_2(tmp0__anonymous__1_1);
    tmp0_also_0_2.put_1q9pf_k$(tmp2_set_0, this);
    Unit_getInstance();
    tmp._value_4 = tmp0_also_0_2;
    var tmp4_set_0 = Companion_getInstance_98()._Logger_levels;
    var tmp5_set_0 = this._name_2;
    var tmp_0 = tmp4_set_0;
    var tmp3__anonymous__1_1 = tmp4_set_0._value_4;
    var tmp0_also_0_2_0 = HashMap_init_$Create$_2(tmp3__anonymous__1_1);
    tmp0_also_0_2_0.put_1q9pf_k$(tmp5_set_0, null);
    Unit_getInstance();
    tmp_0._value_4 = tmp0_also_0_2_0;
    var tmp7_set_0 = Companion_getInstance_98()._Logger_outputs;
    var tmp8_set_0 = this._name_2;
    var tmp_1 = tmp7_set_0;
    var tmp6__anonymous__1_1 = tmp7_set_0._value_4;
    var tmp0_also_0_2_1 = HashMap_init_$Create$_2(tmp6__anonymous__1_1);
    tmp0_also_0_2_1.put_1q9pf_k$(tmp8_set_0, null);
    Unit_getInstance();
    tmp_1._value_4 = tmp0_also_0_2_1;
  }
  Logger.prototype._set_level__xpnttj_k$ = function (value) {
    var tmp1_set_0_2 = Companion_getInstance_98()._Logger_levels;
    var tmp2_set_0_3 = this._name_2;
    var tmp = tmp1_set_0_2;
    var tmp0__anonymous__1_1_4 = tmp1_set_0_2._value_4;
    var tmp0_also_0_2_5 = HashMap_init_$Create$_2(tmp0__anonymous__1_1_4);
    tmp0_also_0_2_5.put_1q9pf_k$(tmp2_set_0_3, value);
    Unit_getInstance();
    tmp._value_4 = tmp0_also_0_2_5;
    return Unit_getInstance();
  };
  Logger.prototype._get_level__0_k$ = function () {
    var tmp0_get_0 = Companion_getInstance_98()._Logger_levels;
    var tmp1_get_0 = this._name_2;
    var tmp0_elvis_lhs = tmp0_get_0._value_4.get_2bw_k$(tmp1_get_0);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? Companion_getInstance_98()._get_defaultLevel__0_k$() : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Level_WARN_getInstance() : tmp1_elvis_lhs;
  };
  Logger.prototype._get_output__0_k$ = function () {
    var tmp0_get_0 = Companion_getInstance_98()._Logger_outputs;
    var tmp1_get_0 = this._name_2;
    var tmp0_elvis_lhs = tmp0_get_0._value_4.get_2bw_k$(tmp1_get_0);
    return tmp0_elvis_lhs == null ? Companion_getInstance_98()._get_defaultOutput__0_k$() : tmp0_elvis_lhs;
  };
  Logger.prototype.isEnabled_5xis2i_k$ = function (level) {
    return level._index_15 <= this._get_level__0_k$()._index_15;
  };
  Logger.prototype.actualLog_sbdqh6_k$ = function (level, msg) {
    return this._get_output__0_k$().output_kbo5o0_k$(this, level, msg);
  };
  Logger.$metadata$ = {
    simpleName: 'Logger',
    kind: 'class',
    interfaces: []
  };
  function defaultLevel$factory() {
    return getPropertyCallableRef('defaultLevel', 1, KMutableProperty1, function (receiver) {
      return receiver._get_defaultLevel__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_defaultLevel__nfm93o_k$(value);
    });
  }
  function defaultLevel$factory_0() {
    return getPropertyCallableRef('defaultLevel', 1, KMutableProperty1, function (receiver) {
      return receiver._get_defaultLevel__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_defaultLevel__nfm93o_k$(value);
    });
  }
  function defaultOutput$factory() {
    return getPropertyCallableRef('defaultOutput', 1, KMutableProperty1, function (receiver) {
      return receiver._get_defaultOutput__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_defaultOutput__nkezbu_k$(value);
    });
  }
  function defaultOutput$factory_0() {
    return getPropertyCallableRef('defaultOutput', 1, KMutableProperty1, function (receiver) {
      return receiver._get_defaultOutput__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_defaultOutput__nkezbu_k$(value);
    });
  }
  function getValue(_this_, receiver, property) {
    return _this_._value_4;
  }
  function setValue(_this_, receiver, property, value) {
    _this_._value_4 = value;
  }
  function Console_0() {
    Console_instance = this;
    BaseConsole.call(this);
  }
  Console_0.prototype.log_ahhys2_k$ = function (kind, msg) {
    var tmp0_subject = kind;
    if (tmp0_subject.equals(Kind_ERROR_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].slice.call(msg));
      }());
    else if (tmp0_subject.equals(Kind_WARN_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.warn.apply($externalVarargReceiverTmp, [].slice.call(msg));
      }());
    else if (tmp0_subject.equals(Kind_INFO_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.info.apply($externalVarargReceiverTmp, [].slice.call(msg));
      }());
    else if (tmp0_subject.equals(Kind_DEBUG_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg));
      }());
    else if (tmp0_subject.equals(Kind_TRACE_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg));
      }());
    else if (tmp0_subject.equals(Kind_LOG_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg));
      }());
  };
  Console_0.$metadata$ = {
    simpleName: 'Console',
    kind: 'object',
    interfaces: []
  };
  var Console_instance;
  function Console_getInstance() {
    if (Console_instance == null)
      new Console_0();
    return Console_instance;
  }
  function DefaultLogOutput() {
    DefaultLogOutput_instance = this;
  }
  DefaultLogOutput.prototype.output_kbo5o0_k$ = function (logger_1, level, msg) {
    return ConsoleLogOutput_getInstance().output_kbo5o0_k$(logger_1, level, msg);
  };
  DefaultLogOutput.$metadata$ = {
    simpleName: 'DefaultLogOutput',
    kind: 'object',
    interfaces: [Output]
  };
  var DefaultLogOutput_instance;
  function DefaultLogOutput_getInstance() {
    if (DefaultLogOutput_instance == null)
      new DefaultLogOutput();
    return DefaultLogOutput_instance;
  }
  function KloggerAtomicRef(initial) {
    this._value_4 = initial;
  }
  KloggerAtomicRef.$metadata$ = {
    simpleName: 'KloggerAtomicRef',
    kind: 'class',
    interfaces: []
  };
  var isNative;
  function None() {
    None_instance = this;
    TraceBase.call(this);
  }
  None.$metadata$ = {
    simpleName: 'None',
    kind: 'object',
    interfaces: []
  };
  var None_instance;
  function None_getInstance() {
    if (None_instance == null)
      new None();
    return None_instance;
  }
  function TraceBase() {
  }
  TraceBase.prototype.atomicfu$Trace$append$1 = function (event) {
  };
  TraceBase.prototype.atomicfu$Trace$append$2 = function (event1, event2) {
  };
  TraceBase.prototype.atomicfu$Trace$append$3 = function (event1, event2, event3) {
  };
  TraceBase.prototype.atomicfu$Trace$append$4 = function (event1, event2, event3, event4) {
  };
  TraceBase.$metadata$ = {
    simpleName: 'TraceBase',
    kind: 'class',
    interfaces: []
  };
  function AtomicRef(value) {
    this._value_5 = value;
  }
  AtomicRef.prototype._set_value__iav7o_k$ = function (_set___) {
    this._value_5 = _set___;
  };
  AtomicRef.prototype._get_value__0_k$ = function () {
    return this._value_5;
  };
  AtomicRef.prototype.atomicfu$compareAndSet = function (expect, update_0) {
    if (!(this._value_5 === expect))
      return false;
    this._value_5 = update_0;
    return true;
  };
  AtomicRef.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this._value_5;
    this._value_5 = value;
    return oldValue;
  };
  AtomicRef.prototype.toString = function () {
    return toString_0(this._value_5);
  };
  AtomicRef.$metadata$ = {
    simpleName: 'AtomicRef',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicRef.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicRef.prototype._get_value__0_k$,
    set: AtomicRef.prototype._set_value__iav7o_k$
  });
  function atomic(initial) {
    return atomic_3(initial, None_getInstance());
  }
  function AtomicBoolean(value) {
    this._value_6 = value;
  }
  AtomicBoolean.prototype._set_value__rpwsgn_k$ = function (_set___) {
    this._value_6 = _set___;
  };
  AtomicBoolean.prototype._get_value__0_k$ = function () {
    return this._value_6;
  };
  AtomicBoolean.prototype.atomicfu$compareAndSet = function (expect, update_0) {
    if (!(this._value_6 === expect))
      return false;
    this._value_6 = update_0;
    return true;
  };
  AtomicBoolean.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this._value_6;
    this._value_6 = value;
    return oldValue;
  };
  AtomicBoolean.prototype.toString = function () {
    return this._value_6.toString();
  };
  AtomicBoolean.$metadata$ = {
    simpleName: 'AtomicBoolean',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicBoolean.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicBoolean.prototype._get_value__0_k$,
    set: AtomicBoolean.prototype._set_value__rpwsgn_k$
  });
  function atomic_0(initial) {
    return atomic_5(initial, None_getInstance());
  }
  function AtomicInt(value) {
    this._value_7 = value;
  }
  AtomicInt.prototype._set_value__majfzk_k$ = function (_set___) {
    this._value_7 = _set___;
  };
  AtomicInt.prototype._get_value__0_k$ = function () {
    return this._value_7;
  };
  AtomicInt.prototype.atomicfu$compareAndSet = function (expect, update_0) {
    if (!(this._value_7 === expect))
      return false;
    this._value_7 = update_0;
    return true;
  };
  AtomicInt.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this._value_7;
    this._value_7 = value;
    return oldValue;
  };
  AtomicInt.prototype.atomicfu$getAndIncrement = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_7;
    tmp0_this._value_7 = tmp1 + 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.atomicfu$getAndDecrement = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_7;
    tmp0_this._value_7 = tmp1 - 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.atomicfu$getAndAdd = function (delta_0) {
    var oldValue = this._value_7;
    var tmp0_this = this;
    tmp0_this._value_7 = tmp0_this._value_7 + delta_0 | 0;
    return oldValue;
  };
  AtomicInt.prototype.atomicfu$addAndGet = function (delta_0) {
    var tmp0_this = this;
    tmp0_this._value_7 = tmp0_this._value_7 + delta_0 | 0;
    return this._value_7;
  };
  AtomicInt.prototype.atomicfu$incrementAndGet = function () {
    var tmp0_this = this;
    tmp0_this._value_7 = tmp0_this._value_7 + 1 | 0;
    return tmp0_this._value_7;
  };
  AtomicInt.prototype.atomicfu$decrementAndGet = function () {
    var tmp0_this = this;
    tmp0_this._value_7 = tmp0_this._value_7 - 1 | 0;
    return tmp0_this._value_7;
  };
  AtomicInt.prototype.toString = function () {
    return this._value_7.toString();
  };
  AtomicInt.$metadata$ = {
    simpleName: 'AtomicInt',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicInt.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicInt.prototype._get_value__0_k$,
    set: AtomicInt.prototype._set_value__majfzk_k$
  });
  function atomic_1(initial) {
    return atomic_7(initial, None_getInstance());
  }
  function AtomicLong(value) {
    this._value_8 = value;
  }
  AtomicLong.prototype._set_value__kdfck9_k$ = function (_set___) {
    this._value_8 = _set___;
  };
  AtomicLong.prototype._get_value__0_k$ = function () {
    return this._value_8;
  };
  AtomicLong.prototype.atomicfu$compareAndSet = function (expect, update_0) {
    if (!this._value_8.equals(expect))
      return false;
    this._value_8 = update_0;
    return true;
  };
  AtomicLong.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this._value_8;
    this._value_8 = value;
    return oldValue;
  };
  AtomicLong.prototype.atomicfu$getAndIncrement$long = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_8;
    tmp0_this._value_8 = tmp1.inc_0_k$();
    return tmp1;
  };
  AtomicLong.prototype.atomicfu$getAndDecrement$long = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_8;
    tmp0_this._value_8 = tmp1.dec_0_k$();
    return tmp1;
  };
  AtomicLong.prototype.atomicfu$getAndAdd$long = function (delta_0) {
    var oldValue = this._value_8;
    var tmp0_this = this;
    tmp0_this._value_8 = tmp0_this._value_8.plus_wiekkq_k$(delta_0);
    return oldValue;
  };
  AtomicLong.prototype.atomicfu$addAndGet$long = function (delta_0) {
    var tmp0_this = this;
    tmp0_this._value_8 = tmp0_this._value_8.plus_wiekkq_k$(delta_0);
    return this._value_8;
  };
  AtomicLong.prototype.atomicfu$incrementAndGet$long = function () {
    var tmp0_this = this;
    tmp0_this._value_8 = tmp0_this._value_8.inc_0_k$();
    return tmp0_this._value_8;
  };
  AtomicLong.prototype.atomicfu$decrementAndGet$long = function () {
    var tmp0_this = this;
    tmp0_this._value_8 = tmp0_this._value_8.dec_0_k$();
    return tmp0_this._value_8;
  };
  AtomicLong.prototype.toString = function () {
    return this._value_8.toString();
  };
  AtomicLong.$metadata$ = {
    simpleName: 'AtomicLong',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicLong.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicLong.prototype._get_value__0_k$,
    set: AtomicLong.prototype._set_value__kdfck9_k$
  });
  function atomic_2(initial, trace) {
    return atomic_3(initial, trace === void 1 ? None_getInstance() : trace);
  }
  function atomic_3(initial, trace) {
    return new AtomicRef(initial);
  }
  function atomic_4(initial, trace) {
    return atomic_5(initial, trace === void 1 ? None_getInstance() : trace);
  }
  function atomic_5(initial, trace) {
    return new AtomicBoolean(initial);
  }
  function atomic_6(initial, trace) {
    return atomic_7(initial, trace === void 1 ? None_getInstance() : trace);
  }
  function atomic_7(initial, trace) {
    return new AtomicInt(initial);
  }
  function atomic_8(initial, trace) {
    return atomic_9(initial, trace === void 1 ? None_getInstance() : trace);
  }
  function atomic_9(initial, trace) {
    return new AtomicLong(initial);
  }
  function AbstractCoroutine(parentContext, initParentJob, active) {
    JobSupport.call(this, active);
    if (initParentJob)
      this.initParentJob_64sshe_k$(parentContext.get_9uvjra_k$(Key_getInstance_2()));
    this._context = parentContext.plus_d7pszg_k$(this);
  }
  AbstractCoroutine.prototype._get_context__0_k$ = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_coroutineContext__0_k$ = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_isActive__0_k$ = function () {
    return JobSupport.prototype._get_isActive__0_k$.call(this);
  };
  AbstractCoroutine.prototype.onCompleted_iav7o_k$ = function (value) {
  };
  AbstractCoroutine.prototype.onCancelled_mnel9l_k$ = function (cause, handled) {
  };
  AbstractCoroutine.prototype.cancellationExceptionMessage_0_k$ = function () {
    return '' + _get_classSimpleName_(this) + ' was cancelled';
  };
  AbstractCoroutine.prototype.onCompletionInternal_qi8yb4_k$ = function (state) {
    if (state instanceof CompletedExceptionally)
      this.onCancelled_mnel9l_k$(state._cause, state._get_handled__0_k$());
    else {
      {
        this.onCompleted_iav7o_k$((state == null ? true : isObject(state)) ? state : THROW_CCE());
      }
    }
  };
  AbstractCoroutine.prototype.resumeWith_bnunh2_k$ = function (result) {
    var state = this.makeCompletingOnce_wi7j7l_k$(toState$default(result, null, 1, null));
    if (state === COMPLETING_WAITING_CHILDREN)
      return Unit_getInstance();
    this.afterResume_qi8yb4_k$(state);
  };
  AbstractCoroutine.prototype.afterResume_qi8yb4_k$ = function (state) {
    return this.afterCompletion_qi8yb4_k$(state);
  };
  AbstractCoroutine.prototype.handleOnCompletionException_1ti8hr_k$ = function (exception) {
    handleCoroutineException(this._context, exception);
  };
  AbstractCoroutine.prototype.nameString_0_k$ = function () {
    var tmp0_elvis_lhs = _get_coroutineName_(this._context);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return JobSupport.prototype.nameString_0_k$.call(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '' + '"' + coroutineName + '":' + JobSupport.prototype.nameString_0_k$.call(this);
  };
  AbstractCoroutine.prototype.start_hfyz87_k$ = function (start, receiver, block) {
    start.invoke_huaxoh_k$(block, receiver, this);
  };
  AbstractCoroutine.$metadata$ = {
    simpleName: 'AbstractCoroutine',
    kind: 'class',
    interfaces: [Job, Continuation, CoroutineScope]
  };
  function joinAll(_this_, $cont) {
    var tmp = new $joinAllCOROUTINE$0(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function $joinAllCOROUTINE$0(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this_ = _this_;
  }
  $joinAllCOROUTINE$0.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._tmp0_iterator_10 = this.__this_.iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator_10.hasNext_0_k$()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._element_21 = this._tmp0_iterator_10.next_0_k$();
            this._state_1 = 2;
            suspendResult = this._element_21.join_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $joinAllCOROUTINE$0.$metadata$ = {
    simpleName: '$joinAllCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function launch(_this_, context, start, block) {
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = start._get_isLazy__0_k$() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
    coroutine.start_hfyz87_k$(start, coroutine, block);
    return coroutine;
  }
  function async(_this_, context, start, block) {
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = start._get_isLazy__0_k$() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
    coroutine.start_hfyz87_k$(start, coroutine, block);
    return coroutine;
  }
  function StandaloneCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, true, active);
  }
  StandaloneCoroutine.prototype.handleJobException_onfaoi_k$ = function (exception) {
    handleCoroutineException(this._get_context__0_k$(), exception);
    return true;
  };
  StandaloneCoroutine.$metadata$ = {
    simpleName: 'StandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function LazyStandaloneCoroutine(parentContext, block) {
    StandaloneCoroutine.call(this, parentContext, false);
    this._continuation = createCoroutineUnintercepted(block, this, this);
  }
  LazyStandaloneCoroutine.prototype.onStart_sv8swh_k$ = function () {
    startCoroutineCancellable_0(this._continuation, this);
  };
  LazyStandaloneCoroutine.$metadata$ = {
    simpleName: 'LazyStandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function $awaitCOROUTINE$1(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__0 = _this_;
  }
  $awaitCOROUTINE$1.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__0.awaitInternal_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return (suspendResult == null ? true : isObject(suspendResult)) ? suspendResult : THROW_CCE();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitCOROUTINE$1.$metadata$ = {
    simpleName: '$awaitCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function DeferredCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, true, active);
  }
  DeferredCoroutine.prototype.await_0_k$ = function ($cont) {
    var tmp = new $awaitCOROUTINE$1(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  DeferredCoroutine.$metadata$ = {
    simpleName: 'DeferredCoroutine',
    kind: 'class',
    interfaces: [Deferred, SelectClause1]
  };
  function LazyDeferredCoroutine(parentContext, block) {
    DeferredCoroutine.call(this, parentContext, false);
    this._continuation_0 = createCoroutineUnintercepted(block, this, this);
  }
  LazyDeferredCoroutine.prototype.onStart_sv8swh_k$ = function () {
    startCoroutineCancellable_0(this._continuation_0, this);
  };
  LazyDeferredCoroutine.$metadata$ = {
    simpleName: 'LazyDeferredCoroutine',
    kind: 'class',
    interfaces: []
  };
  function CancellableContinuation() {
  }
  CancellableContinuation.$metadata$ = {
    simpleName: 'CancellableContinuation',
    kind: 'interface',
    interfaces: [Continuation]
  };
  function disposeOnCancellation(_this_, handle) {
    var tmp0__get_asHandler__0 = new DisposeOnCancel(handle);
    return _this_.invokeOnCancellation_aip8gd_k$(tmp0__get_asHandler__0);
  }
  function DisposeOnCancel(handle) {
    CancelHandler.call(this);
    this._handle = handle;
  }
  DisposeOnCancel.prototype.invoke_houul8_k$ = function (cause) {
    return this._handle.dispose_sv8swh_k$();
  };
  DisposeOnCancel.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  DisposeOnCancel.prototype.toString = function () {
    return '' + 'DisposeOnCancel[' + this._handle + ']';
  };
  DisposeOnCancel.$metadata$ = {
    simpleName: 'DisposeOnCancel',
    kind: 'class',
    interfaces: []
  };
  function removeOnCancellation(_this_, node) {
    var tmp0__get_asHandler__0 = new RemoveOnCancel(node);
    return _this_.invokeOnCancellation_aip8gd_k$(tmp0__get_asHandler__0);
  }
  function getOrCreateCancellableContinuation(delegate) {
    if (!(delegate instanceof DispatchedContinuation)) {
      return new CancellableContinuationImpl(delegate, 1);
    } else {
    }
    var tmp0_safe_receiver = delegate.claimReusableCancellableContinuation_0_k$();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0;
      if (tmp0_safe_receiver.resetStateReusable_0_k$()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        {
          tmp_0 = null;
        }
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function RemoveOnCancel(node) {
    BeforeResumeCancelHandler.call(this);
    this._node = node;
  }
  RemoveOnCancel.prototype.invoke_houul8_k$ = function (cause) {
    this._node.remove_0_k$();
    Unit_getInstance();
  };
  RemoveOnCancel.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  RemoveOnCancel.prototype.toString = function () {
    return '' + 'RemoveOnCancel[' + this._node + ']';
  };
  RemoveOnCancel.$metadata$ = {
    simpleName: 'RemoveOnCancel',
    kind: 'class',
    interfaces: []
  };
  var RESUME_TOKEN;
  function _get_stateDebugRepresentation_($this) {
    var tmp0_subject = $this._get_state__0_k$();
    var tmp;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
      tmp = 'Active';
    } else {
      if (tmp0_subject instanceof CancelledContinuation) {
        tmp = 'Cancelled';
      } else {
        {
          tmp = 'Completed';
        }
      }
    }
    return tmp;
  }
  function isReusable($this) {
    var tmp;
    var tmp_0 = $this._delegate_0;
    if (tmp_0 instanceof DispatchedContinuation) {
      tmp = $this._delegate_0.isReusable_mmp58q_k$($this);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  }
  function cancelLater($this, cause) {
    if (!_get_isReusableMode_($this._get_resumeMode__0_k$()))
      return false;
    if (!isReusable($this))
      return false;
    var tmp = $this._delegate_0;
    var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
    return dispatched.postponeCancellation_onfaoi_k$(cause);
  }
  function callCancelHandler($this, handler, cause) {
    var tmp;
    try {
      tmp = invokeIt(handler, cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException($this._get_context__0_k$(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + $this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function trySuspend($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_7;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.atomicfu$compareAndSet(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:throw IllegalStateException_init_$Create$_0('Already suspended');
      }
    }
    Unit_getInstance();
  }
  function tryResume($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_7;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.atomicfu$compareAndSet(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:throw IllegalStateException_init_$Create$_0('Already resumed');
      }
    }
    Unit_getInstance();
  }
  function installParentHandle($this) {
    var tmp0_elvis_lhs = $this._get_context__0_k$().get_9uvjra_k$(Key_getInstance_2());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var tmp0__get_asHandler__0 = new ChildContinuation($this);
    var handle = parent.invokeOnCompletion$default_n4h7x8_k$(true, false, tmp0__get_asHandler__0, 2, null);
    $this._parentHandle = handle;
    return handle;
  }
  function releaseClaimedReusableContinuation($this) {
    var tmp = $this._delegate_0;
    var tmp0_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tryReleaseClaimedContinuation_7b8qoa_k$($this);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var cancellationCause = tmp_0;
    $this.detachChild_sv8swh_k$();
    $this.cancel_h62ekz_k$(cancellationCause);
    Unit_getInstance();
  }
  function multipleHandlersError($this, handler, state) {
    var tmp0_error_0 = '' + "It's prohibited to register multiple handlers, tried to register " + handler + ', already has ' + state;
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  }
  function makeCancelHandler($this, handler) {
    var tmp;
    if (handler instanceof CancelHandler) {
      tmp = handler;
    } else {
      {
        tmp = new InvokeOnCancel(handler);
      }
    }
    return tmp;
  }
  function dispatchResume($this, mode) {
    if (tryResume($this))
      return Unit_getInstance();
    dispatch($this, mode);
  }
  function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
    var tmp;
    if (proposedUpdate instanceof CompletedExceptionally) {
      tmp = proposedUpdate;
    } else {
      if (!_get_isCancellableMode_(resumeMode) ? idempotent == null : false) {
        tmp = proposedUpdate;
      } else {
        var tmp_0;
        var tmp_1;
        if (!(onCancellation == null)) {
          tmp_1 = true;
        } else {
          var tmp_2;
          if (state instanceof CancelHandler) {
            tmp_2 = !(state instanceof BeforeResumeCancelHandler);
          } else {
            {
              tmp_2 = false;
            }
          }
          tmp_1 = tmp_2;
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          {
            tmp_0 = !(idempotent == null);
          }
        }
        if (tmp_0) {
          var tmp_3 = state instanceof CancelHandler ? state : null;
          tmp = CompletedContinuation_init_$Create$(proposedUpdate, tmp_3, onCancellation, idempotent, null, 16, null);
        } else {
          {
            tmp = proposedUpdate;
          }
        }
      }
    }
    return tmp;
  }
  function resumeImpl($this, proposedUpdate, resumeMode, onCancellation) {
    var tmp0_loop_0 = $this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_5;
        var tmp0_subject_2 = tmp1__anonymous__1;
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
          var update_3 = resumedState($this, tmp1__anonymous__1, proposedUpdate, resumeMode, onCancellation, null);
          if (!$this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_3)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }detachChildIfNonResuable($this);
          dispatchResume($this, resumeMode);
          return Unit_getInstance();
        } else {
          if (tmp0_subject_2 instanceof CancelledContinuation) {
            if (tmp1__anonymous__1.makeResumed_0_k$()) {
              var tmp1_safe_receiver_4 = onCancellation;
              if (tmp1_safe_receiver_4 == null)
                null;
              else {
                $this.callOnCancellation_5kfjg_k$(tmp1_safe_receiver_4, tmp1__anonymous__1._get_cause__0_k$());
                Unit_getInstance();
              }
              Unit_getInstance();
              return Unit_getInstance();
            }} else {
          }
        }
        alreadyResumedError($this, proposedUpdate);
      }
       while (false);
    }
    Unit_getInstance();
  }
  function resumeImpl$default($this, proposedUpdate, resumeMode, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      onCancellation = null;
    return resumeImpl($this, proposedUpdate, resumeMode, onCancellation);
  }
  function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
    var tmp0_loop_0 = $this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_5;
        var tmp0_subject_2 = tmp1__anonymous__1;
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
          var update_3 = resumedState($this, tmp1__anonymous__1, proposedUpdate, $this._get_resumeMode__0_k$(), onCancellation, idempotent);
          if (!$this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_3)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }detachChildIfNonResuable($this);
          return RESUME_TOKEN;
        } else {
          if (tmp0_subject_2 instanceof CompletedContinuation_0) {
            var tmp;
            if (!(idempotent == null) ? tmp1__anonymous__1._idempotentResume === idempotent : false) {
              tmp = RESUME_TOKEN;
            } else {
              tmp = null;
            }
            return tmp;
          } else {
            return null;
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  }
  function alreadyResumedError($this, proposedUpdate) {
    var tmp0_error_0 = '' + 'Already resumed, but proposed with update ' + proposedUpdate;
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  }
  function detachChildIfNonResuable($this) {
    if (!isReusable($this))
      $this.detachChild_sv8swh_k$();
  }
  function CancellableContinuationImpl(delegate, resumeMode) {
    DispatchedTask.call(this, resumeMode);
    this._delegate_0 = delegate;
    this._context_0 = this._delegate_0._get_context__0_k$();
    this.__decision = atomic_1(0);
    this.__state = atomic(Active_getInstance());
    this._parentHandle = null;
  }
  CancellableContinuationImpl.prototype._get_delegate__0_k$ = function () {
    return this._delegate_0;
  };
  CancellableContinuationImpl.prototype._get_context__0_k$ = function () {
    return this._context_0;
  };
  CancellableContinuationImpl.prototype._get_state__0_k$ = function () {
    return this.__state._value_5;
  };
  CancellableContinuationImpl.prototype._get_isCompleted__0_k$ = function () {
    var tmp = this._get_state__0_k$();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  };
  CancellableContinuationImpl.prototype.initCancellability_sv8swh_k$ = function () {
    var tmp0_elvis_lhs = installParentHandle(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    if (this._get_isCompleted__0_k$()) {
      handle.dispose_sv8swh_k$();
      this._parentHandle = NonDisposableHandle_getInstance();
    }};
  CancellableContinuationImpl.prototype.resetStateReusable_0_k$ = function () {
    var state = this.__state._value_5;
    var tmp;
    if (state instanceof CompletedContinuation_0) {
      tmp = !(state._idempotentResume == null);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      this.detachChild_sv8swh_k$();
      return false;
    } else {
    }
    this.__decision._value_7 = 0;
    this.__state._value_5 = Active_getInstance();
    return true;
  };
  CancellableContinuationImpl.prototype.takeState_0_k$ = function () {
    return this._get_state__0_k$();
  };
  CancellableContinuationImpl.prototype.cancelCompletedResult_6goujk_k$ = function (takenState, cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_5;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
        throw IllegalStateException_init_$Create$_0('Not completed');
      } else {
        if (tmp0_subject_2 instanceof CompletedExceptionally)
          return Unit_getInstance();
        else {
          if (tmp0_subject_2 instanceof CompletedContinuation_0) {
            var tmp0_check_0_3 = !tmp1__anonymous__1._get_cancelled__0_k$();
            if (!tmp0_check_0_3) {
              var message_1_4 = 'Must be called at most once';
              throw IllegalStateException_init_$Create$_0(toString_1(message_1_4));
            }var update_5 = tmp1__anonymous__1.copy$default_tn4acp_k$(null, null, null, null, cause, 15, null);
            if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_5)) {
              tmp1__anonymous__1.invokeHandlers_939j49_k$(this, cause);
              return Unit_getInstance();
            }} else {
            {
              if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, CompletedContinuation_init_$Create$(tmp1__anonymous__1, null, null, null, cause, 14, null))) {
                return Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.cancel_h62ekz_k$ = function (cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_5;
        if (!(!(tmp1__anonymous__1 == null) ? isInterface(tmp1__anonymous__1, NotCompleted) : false))
          return false;
        else {
        }
        var update_2 = new CancelledContinuation(this, cause, tmp1__anonymous__1 instanceof CancelHandler);
        if (!this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_2)) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }var tmp0_safe_receiver_3 = tmp1__anonymous__1 instanceof CancelHandler ? tmp1__anonymous__1 : null;
        if (tmp0_safe_receiver_3 == null)
          null;
        else {
          this.callCancelHandler_yvykkv_k$(tmp0_safe_receiver_3, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
        detachChildIfNonResuable(this);
        dispatchResume(this, this._get_resumeMode__0_k$());
        return true;
      }
       while (false);
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.parentCancelled_1ti8hr_k$ = function (cause) {
    if (cancelLater(this, cause))
      return Unit_getInstance();
    this.cancel_h62ekz_k$(cause);
    Unit_getInstance();
    detachChildIfNonResuable(this);
  };
  CancellableContinuationImpl.prototype.callCancelHandler_yvykkv_k$ = function (handler, cause) {
    var tmp;
    try {
      tmp = handler.invoke(cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException(this._get_context__0_k$(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.callOnCancellation_5kfjg_k$ = function (onCancellation, cause) {
    try {
      onCancellation(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineException(this._get_context__0_k$(), new CompletionHandlerException('' + 'Exception in resume onCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
    }
  };
  CancellableContinuationImpl.prototype.getContinuationCancellationCause_jfubq8_k$ = function (parent) {
    return parent.getCancellationException_0_k$();
  };
  CancellableContinuationImpl.prototype.getResult_0_k$ = function () {
    var isReusable_0 = isReusable(this);
    if (trySuspend(this)) {
      if (this._parentHandle == null) {
        installParentHandle(this);
        Unit_getInstance();
      }if (isReusable_0) {
        releaseClaimedReusableContinuation(this);
      }return _get_COROUTINE_SUSPENDED_();
    }if (isReusable_0) {
      releaseClaimedReusableContinuation(this);
    }var state = this._get_state__0_k$();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state._cause, this);
    else {
    }
    if (_get_isCancellableMode_(this._get_resumeMode__0_k$())) {
      var job = this._get_context__0_k$().get_9uvjra_k$(Key_getInstance_2());
      if (!(job == null) ? !job._get_isActive__0_k$() : false) {
        var cause = job.getCancellationException_0_k$();
        this.cancelCompletedResult_6goujk_k$(state, cause);
        throw recoverStackTrace(cause, this);
      }}return this.getSuccessfulResult_6jiqgr_k$(state);
  };
  CancellableContinuationImpl.prototype.resumeWith_bnunh2_k$ = function (result) {
    var tmp = toState(result, this);
    var tmp_0 = this._get_resumeMode__0_k$();
    return resumeImpl$default(this, tmp, tmp_0, null, 8, null);
  };
  CancellableContinuationImpl.prototype.resume_z79gqm_k$ = function (value, onCancellation) {
    return resumeImpl(this, value, this._get_resumeMode__0_k$(), onCancellation);
  };
  CancellableContinuationImpl.prototype.invokeOnCancellation_aip8gd_k$ = function (handler) {
    var cancelHandler = makeCancelHandler(this, handler);
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_5;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (tmp0_subject_2 instanceof Active) {
        if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, cancelHandler))
          return Unit_getInstance();
      } else {
        if (tmp0_subject_2 instanceof CancelHandler)
          multipleHandlersError(this, handler, tmp1__anonymous__1);
        else {
          if (tmp0_subject_2 instanceof CompletedExceptionally) {
            if (!tmp1__anonymous__1.makeHandled_0_k$())
              multipleHandlersError(this, handler, tmp1__anonymous__1);
            if (tmp1__anonymous__1 instanceof CancelledContinuation) {
              var tmp1_safe_receiver_3 = tmp1__anonymous__1 instanceof CompletedExceptionally ? tmp1__anonymous__1 : null;
              callCancelHandler(this, handler, tmp1_safe_receiver_3 == null ? null : tmp1_safe_receiver_3._cause);
            } else {
            }
            return Unit_getInstance();
          } else {
            if (tmp0_subject_2 instanceof CompletedContinuation_0) {
              if (!(tmp1__anonymous__1._cancelHandler == null))
                multipleHandlersError(this, handler, tmp1__anonymous__1);
              if (cancelHandler instanceof BeforeResumeCancelHandler)
                return Unit_getInstance();
              else {
              }
              if (tmp1__anonymous__1._get_cancelled__0_k$()) {
                callCancelHandler(this, handler, tmp1__anonymous__1._cancelCause);
                return Unit_getInstance();
              }var update_4 = tmp1__anonymous__1.copy$default_tn4acp_k$(null, cancelHandler, null, null, null, 29, null);
              if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_4))
                return Unit_getInstance();
            } else {
              {
                if (cancelHandler instanceof BeforeResumeCancelHandler)
                  return Unit_getInstance();
                else {
                }
                var update_5 = CompletedContinuation_init_$Create$(tmp1__anonymous__1, cancelHandler, null, null, null, 28, null);
                if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_5))
                  return Unit_getInstance();
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.detachChild_sv8swh_k$ = function () {
    var tmp0_elvis_lhs = this._parentHandle;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    handle.dispose_sv8swh_k$();
    this._parentHandle = NonDisposableHandle_getInstance();
  };
  CancellableContinuationImpl.prototype.tryResume_ww5y96_k$ = function (value, idempotent) {
    return tryResumeImpl(this, value, idempotent, null);
  };
  CancellableContinuationImpl.prototype.tryResume_9xx6p8_k$ = function (value, idempotent, onCancellation) {
    return tryResumeImpl(this, value, idempotent, onCancellation);
  };
  CancellableContinuationImpl.prototype.completeResume_wu1lm5_k$ = function (token) {
    dispatchResume(this, this._get_resumeMode__0_k$());
  };
  CancellableContinuationImpl.prototype.resumeUndispatched_eocpx4_k$ = function (_this__0, value) {
    var tmp = this._delegate_0;
    var dc = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    var tmp0_safe_receiver = dc;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._dispatcher) === _this__0) {
      tmp_0 = 4;
    } else {
      {
        tmp_0 = this._get_resumeMode__0_k$();
      }
    }
    var tmp_1 = tmp_0;
    resumeImpl$default(this, value, tmp_1, null, 8, null);
  };
  CancellableContinuationImpl.prototype.getSuccessfulResult_6jiqgr_k$ = function (state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof CompletedContinuation_0) {
      var tmp_0 = state._result_2;
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    } else {
      {
        tmp = (state == null ? true : isObject(state)) ? state : THROW_CCE();
      }
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.getExceptionalResult_wi7j7l_k$ = function (state) {
    var tmp0_safe_receiver = DispatchedTask.prototype.getExceptionalResult_wi7j7l_k$.call(this, state);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = recoverStackTrace(tmp0_safe_receiver, this._delegate_0);
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.toString = function () {
    return '' + this.nameString_0_k$() + '(' + toDebugString(this._delegate_0) + '){' + _get_stateDebugRepresentation_(this) + '}@' + _get_hexAddress_(this);
  };
  CancellableContinuationImpl.prototype.nameString_0_k$ = function () {
    return 'CancellableContinuation';
  };
  CancellableContinuationImpl.$metadata$ = {
    simpleName: 'CancellableContinuationImpl',
    kind: 'class',
    interfaces: [CancellableContinuation, CoroutineStackFrame]
  };
  function CancelHandler() {
    CancelHandlerBase.call(this);
  }
  CancelHandler.$metadata$ = {
    simpleName: 'CancelHandler',
    kind: 'class',
    interfaces: [NotCompleted]
  };
  function Active() {
    Active_instance = this;
  }
  Active.prototype.toString = function () {
    return 'Active';
  };
  Active.$metadata$ = {
    simpleName: 'Active',
    kind: 'object',
    interfaces: [NotCompleted]
  };
  var Active_instance;
  function Active_getInstance() {
    if (Active_instance == null)
      new Active();
    return Active_instance;
  }
  function NotCompleted() {
  }
  NotCompleted.$metadata$ = {
    simpleName: 'NotCompleted',
    kind: 'interface',
    interfaces: []
  };
  function CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      cancelHandler = null;
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    if (!(($mask0 & 8) === 0))
      idempotentResume = null;
    if (!(($mask0 & 16) === 0))
      cancelCause = null;
    CompletedContinuation_0.call($this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
    return $this;
  }
  function CompletedContinuation_init_$Create$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker) {
    return CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, Object.create(CompletedContinuation_0.prototype));
  }
  function CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    this._result_2 = result;
    this._cancelHandler = cancelHandler;
    this._onCancellation = onCancellation;
    this._idempotentResume = idempotentResume;
    this._cancelCause = cancelCause;
  }
  CompletedContinuation_0.prototype._get_cancelled__0_k$ = function () {
    return !(this._cancelCause == null);
  };
  CompletedContinuation_0.prototype.invokeHandlers_939j49_k$ = function (cont, cause) {
    var tmp0_safe_receiver = this._cancelHandler;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cont.callCancelHandler_yvykkv_k$(tmp0_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._onCancellation;
    if (tmp1_safe_receiver == null)
      null;
    else {
      cont.callOnCancellation_5kfjg_k$(tmp1_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  CompletedContinuation_0.prototype.copy_wkt0jr_k$ = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.copy$default_tn4acp_k$ = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      result = this._result_2;
    if (!(($mask0 & 2) === 0))
      cancelHandler = this._cancelHandler;
    if (!(($mask0 & 4) === 0))
      onCancellation = this._onCancellation;
    if (!(($mask0 & 8) === 0))
      idempotentResume = this._idempotentResume;
    if (!(($mask0 & 16) === 0))
      cancelCause = this._cancelCause;
    return this.copy_wkt0jr_k$(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.toString = function () {
    return '' + 'CompletedContinuation(result=' + this._result_2 + ', cancelHandler=' + this._cancelHandler + ', onCancellation=' + this._onCancellation + ', idempotentResume=' + this._idempotentResume + ', cancelCause=' + this._cancelCause + ')';
  };
  CompletedContinuation_0.prototype.hashCode = function () {
    var result = this._result_2 == null ? 0 : hashCode(this._result_2);
    result = imul(result, 31) + (this._cancelHandler == null ? 0 : hashCode(this._cancelHandler)) | 0;
    result = imul(result, 31) + (this._onCancellation == null ? 0 : hashCode(this._onCancellation)) | 0;
    result = imul(result, 31) + (this._idempotentResume == null ? 0 : hashCode(this._idempotentResume)) | 0;
    result = imul(result, 31) + (this._cancelCause == null ? 0 : hashCode(this._cancelCause)) | 0;
    return result;
  };
  CompletedContinuation_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedContinuation_0 ? other : THROW_CCE();
    if (!equals_1(this._result_2, tmp0_other_with_cast._result_2))
      return false;
    if (!equals_1(this._cancelHandler, tmp0_other_with_cast._cancelHandler))
      return false;
    if (!equals_1(this._onCancellation, tmp0_other_with_cast._onCancellation))
      return false;
    if (!equals_1(this._idempotentResume, tmp0_other_with_cast._idempotentResume))
      return false;
    if (!equals_1(this._cancelCause, tmp0_other_with_cast._cancelCause))
      return false;
    return true;
  };
  CompletedContinuation_0.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'class',
    interfaces: []
  };
  function BeforeResumeCancelHandler() {
    CancelHandler.call(this);
  }
  BeforeResumeCancelHandler.$metadata$ = {
    simpleName: 'BeforeResumeCancelHandler',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCancel(handler) {
    CancelHandler.call(this);
    this._handler = handler;
  }
  InvokeOnCancel.prototype.invoke_houul8_k$ = function (cause) {
    this._handler(cause);
  };
  InvokeOnCancel.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  InvokeOnCancel.prototype.toString = function () {
    return '' + 'InvokeOnCancel[' + _get_classSimpleName_(this._handler) + '@' + _get_hexAddress_(this) + ']';
  };
  InvokeOnCancel.$metadata$ = {
    simpleName: 'InvokeOnCancel',
    kind: 'class',
    interfaces: []
  };
  function CompletableDeferred() {
  }
  CompletableDeferred.$metadata$ = {
    simpleName: 'CompletableDeferred',
    kind: 'interface',
    interfaces: [Deferred]
  };
  function CompletableDeferred_0(parent) {
    return new CompletableDeferredImpl(parent);
  }
  function CompletableDeferred$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return CompletableDeferred_0(parent);
  }
  function CompletableDeferred_1(value) {
    var tmp0_apply_0 = new CompletableDeferredImpl(null);
    tmp0_apply_0.complete_2c5_k$(value);
    Unit_getInstance();
    return tmp0_apply_0;
  }
  function $awaitCOROUTINE$2(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__1 = _this_;
  }
  $awaitCOROUTINE$2.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__1.awaitInternal_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return (suspendResult == null ? true : isObject(suspendResult)) ? suspendResult : THROW_CCE();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitCOROUTINE$2.$metadata$ = {
    simpleName: '$awaitCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function CompletableDeferredImpl(parent) {
    JobSupport.call(this, true);
    this.initParentJob_64sshe_k$(parent);
  }
  CompletableDeferredImpl.prototype._get_onCancelComplete__0_k$ = function () {
    return true;
  };
  CompletableDeferredImpl.prototype.await_0_k$ = function ($cont) {
    var tmp = new $awaitCOROUTINE$2(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  CompletableDeferredImpl.prototype.complete_2c5_k$ = function (value) {
    return this.makeCompleting_wi7j7l_k$(value);
  };
  CompletableDeferredImpl.prototype.completeExceptionally_onfaoi_k$ = function (exception) {
    return this.makeCompleting_wi7j7l_k$(CompletedExceptionally_init_$Create$(exception, false, 2, null));
  };
  CompletableDeferredImpl.$metadata$ = {
    simpleName: 'CompletableDeferredImpl',
    kind: 'class',
    interfaces: [CompletableDeferred, SelectClause1]
  };
  function completeWith(_this_, result) {
    var exception_1 = Result__exceptionOrNull_impl(result);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _Result___get_value__impl_(result);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = _this_.complete_2c5_k$(tmp0__anonymous__2);
    } else {
      tmp = _this_.completeExceptionally_onfaoi_k$(exception_1);
    }
    return tmp;
  }
  function CompletableJob() {
  }
  CompletableJob.$metadata$ = {
    simpleName: 'CompletableJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      handled = false;
    CompletedExceptionally.call($this, cause, handled);
    return $this;
  }
  function CompletedExceptionally_init_$Create$(cause, handled, $mask0, $marker) {
    return CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, Object.create(CompletedExceptionally.prototype));
  }
  function CompletedExceptionally(cause, handled) {
    this._cause = cause;
    this.__handled = atomic_0(handled);
  }
  CompletedExceptionally.prototype._get_cause__0_k$ = function () {
    return this._cause;
  };
  CompletedExceptionally.prototype._get_handled__0_k$ = function () {
    return this.__handled._value_6;
  };
  CompletedExceptionally.prototype.makeHandled_0_k$ = function () {
    return this.__handled.atomicfu$compareAndSet(false, true);
  };
  CompletedExceptionally.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '[' + this._cause + ']';
  };
  CompletedExceptionally.$metadata$ = {
    simpleName: 'CompletedExceptionally',
    kind: 'class',
    interfaces: []
  };
  function CancelledContinuation(continuation, cause, handled) {
    var tmp0_elvis_lhs = cause;
    CompletedExceptionally.call(this, tmp0_elvis_lhs == null ? CancellationException_init_$Create$('' + 'Continuation ' + continuation + ' was cancelled normally') : tmp0_elvis_lhs, handled);
    this.__resumed = atomic_0(false);
  }
  CancelledContinuation.prototype.makeResumed_0_k$ = function () {
    return this.__resumed.atomicfu$compareAndSet(false, true);
  };
  CancelledContinuation.$metadata$ = {
    simpleName: 'CancelledContinuation',
    kind: 'class',
    interfaces: []
  };
  function toState(_this_, caller) {
    var exception_1 = Result__exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _Result___get_value__impl_(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = tmp0__anonymous__2;
    } else {
      var tmp_1 = recoverStackTrace(exception_1, caller);
      tmp = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
    }
    return tmp;
  }
  function toState_0(_this_, onCancellation) {
    var exception_1 = Result__exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _Result___get_value__impl_(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = !(onCancellation == null) ? new CompletedWithCancellation(tmp0__anonymous__2, onCancellation) : tmp0__anonymous__2;
    } else {
      tmp = CompletedExceptionally_init_$Create$(exception_1, false, 2, null);
    }
    return tmp;
  }
  function toState$default(_this_, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancellation = null;
    return toState_0(_this_, onCancellation);
  }
  function CompletedWithCancellation(result, onCancellation) {
    this._result_3 = result;
    this._onCancellation_0 = onCancellation;
  }
  CompletedWithCancellation.prototype.toString = function () {
    return '' + 'CompletedWithCancellation(result=' + this._result_3 + ', onCancellation=' + this._onCancellation_0 + ')';
  };
  CompletedWithCancellation.prototype.hashCode = function () {
    var result = this._result_3 == null ? 0 : hashCode(this._result_3);
    result = imul(result, 31) + hashCode(this._onCancellation_0) | 0;
    return result;
  };
  CompletedWithCancellation.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedWithCancellation))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedWithCancellation ? other : THROW_CCE();
    if (!equals_1(this._result_3, tmp0_other_with_cast._result_3))
      return false;
    if (!equals_1(this._onCancellation_0, tmp0_other_with_cast._onCancellation_0))
      return false;
    return true;
  };
  CompletedWithCancellation.$metadata$ = {
    simpleName: 'CompletedWithCancellation',
    kind: 'class',
    interfaces: []
  };
  function recoverResult(state, uCont) {
    var tmp;
    if (state instanceof CompletedExceptionally) {
      var tmp0_failure_0 = Companion_getInstance_3();
      var tmp1_failure_0 = recoverStackTrace(state._cause, uCont);
      tmp = _Result___init__impl_(createFailure(tmp1_failure_0));
    } else {
      {
        var tmp2_success_0 = Companion_getInstance_3();
        var tmp3_success_0 = (state == null ? true : isObject(state)) ? state : THROW_CCE();
        tmp = _Result___init__impl_(tmp3_success_0);
      }
    }
    return tmp;
  }
  function _no_name_provided__112() {
  }
  _no_name_provided__112.prototype.invoke_k332zt_k$ = function (it) {
    return it instanceof CoroutineDispatcher ? it : null;
  };
  _no_name_provided__112.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_k332zt_k$((!(p1 == null) ? isInterface(p1, Element_0) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__112.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Key_2() {
    Key_instance_0 = this;
    var tmp = Key_getInstance();
    AbstractCoroutineContextKey.call(this, tmp, _no_name_provided_$factory_90());
  }
  Key_2.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: []
  };
  var Key_instance_0;
  function Key_getInstance_0() {
    if (Key_instance_0 == null)
      new Key_2();
    return Key_instance_0;
  }
  function CoroutineDispatcher() {
    Key_getInstance_0();
    AbstractCoroutineContextElement.call(this, Key_getInstance());
  }
  CoroutineDispatcher.prototype.isDispatchNeeded_d7pszg_k$ = function (context) {
    return true;
  };
  CoroutineDispatcher.prototype.interceptContinuation_x4ijla_k$ = function (continuation) {
    return new DispatchedContinuation(this, continuation);
  };
  CoroutineDispatcher.prototype.releaseInterceptedContinuation_h7c6yl_k$ = function (continuation) {
    var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
    dispatched.release_sv8swh_k$();
  };
  CoroutineDispatcher.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this);
  };
  CoroutineDispatcher.$metadata$ = {
    simpleName: 'CoroutineDispatcher',
    kind: 'class',
    interfaces: [ContinuationInterceptor]
  };
  function _no_name_provided_$factory_90() {
    var i = new _no_name_provided__112();
    return function (p1) {
      return i.invoke_k332zt_k$(p1);
    };
  }
  function handleCoroutineException(context, exception) {
    try {
      var tmp0_safe_receiver = context.get_9uvjra_k$(Key_getInstance_1());
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.handleException_ym78xn_k$(context, exception);
        return Unit_getInstance();
      }
      Unit_getInstance();
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineExceptionImpl(context, handlerException(exception, $p));
        return Unit_getInstance();
      } else {
        {
          throw $p;
        }
      }
    }
    handleCoroutineExceptionImpl(context, exception);
  }
  function Key_3() {
    Key_instance_1 = this;
  }
  Key_3.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_1;
  function Key_getInstance_1() {
    if (Key_instance_1 == null)
      new Key_3();
    return Key_instance_1;
  }
  function handlerException(originalException, thrownException) {
    if (originalException === thrownException)
      return originalException;
    var tmp0_apply_0 = RuntimeException_init_$Create$_0('Exception while trying to handle coroutine exception', thrownException);
    return tmp0_apply_0;
  }
  function CoroutineScope() {
  }
  CoroutineScope.$metadata$ = {
    simpleName: 'CoroutineScope',
    kind: 'interface',
    interfaces: []
  };
  function CoroutineScope_0(context) {
    var tmp;
    if (!(context.get_9uvjra_k$(Key_getInstance_2()) == null)) {
      tmp = context;
    } else {
      tmp = context.plus_d7pszg_k$(Job$default(null, 1, null));
    }
    return new ContextScope(tmp);
  }
  function coroutineScope(block, $cont) {
    var tmp0__anonymous__1 = $cont;
    var coroutine_2 = new ScopeCoroutine(tmp0__anonymous__1._get_context__0_k$(), tmp0__anonymous__1);
    return startUndispatchedOrReturn(coroutine_2, coroutine_2, block);
  }
  var CoroutineStart_DEFAULT_instance;
  var CoroutineStart_LAZY_instance;
  var CoroutineStart_ATOMIC_instance;
  var CoroutineStart_UNDISPATCHED_instance;
  var CoroutineStart_entriesInitialized;
  function CoroutineStart_initEntries() {
    if (CoroutineStart_entriesInitialized)
      return Unit_getInstance();
    CoroutineStart_entriesInitialized = true;
    CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
    CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
    CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
    CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
  }
  function CoroutineStart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineStart.prototype.invoke_huaxoh_k$ = function (block, receiver, completion) {
    var tmp0_subject = this;
    var tmp;
    if (tmp0_subject.equals(CoroutineStart_DEFAULT_getInstance())) {
      tmp = startCoroutineCancellable$default(block, receiver, completion, null, 4, null);
    } else if (tmp0_subject.equals(CoroutineStart_ATOMIC_getInstance())) {
      tmp = startCoroutine_0(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_UNDISPATCHED_getInstance())) {
      tmp = startCoroutineUndispatched(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_LAZY_getInstance())) {
      tmp = Unit_getInstance();
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CoroutineStart.prototype._get_isLazy__0_k$ = function () {
    return this === CoroutineStart_LAZY_getInstance();
  };
  CoroutineStart.$metadata$ = {
    simpleName: 'CoroutineStart',
    kind: 'class',
    interfaces: []
  };
  function CoroutineStart_DEFAULT_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_DEFAULT_instance;
  }
  function CoroutineStart_LAZY_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_LAZY_instance;
  }
  function CoroutineStart_ATOMIC_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_ATOMIC_instance;
  }
  function CoroutineStart_UNDISPATCHED_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_UNDISPATCHED_instance;
  }
  function CopyableThrowable() {
  }
  CopyableThrowable.$metadata$ = {
    simpleName: 'CopyableThrowable',
    kind: 'interface',
    interfaces: []
  };
  function Deferred() {
  }
  Deferred.$metadata$ = {
    simpleName: 'Deferred',
    kind: 'interface',
    interfaces: [Job]
  };
  function Delay() {
  }
  Delay.prototype.invokeOnTimeout_x8mf2g_k$ = function (timeMillis, block, context) {
    return _get_DefaultDelay_().invokeOnTimeout_x8mf2g_k$(timeMillis, block, context);
  };
  Delay.$metadata$ = {
    simpleName: 'Delay',
    kind: 'interface',
    interfaces: []
  };
  function delay(timeMillis, $cont) {
    if (timeMillis.compareTo_wiekkq_k$(new Long(0, 0)) <= 0)
      return Unit_getInstance();
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_sv8swh_k$();
    Companion_getInstance_17();
    if (timeMillis.compareTo_wiekkq_k$(new Long(-1, 2147483647)) < 0) {
      _get_delay_(cancellable_2_2._get_context__0_k$()).scheduleResumeAfterDelay_tkxym4_k$(timeMillis, cancellable_2_2);
    } else {
    }
    return cancellable_2_2.getResult_0_k$();
  }
  function _get_delay_(_this_) {
    var tmp = _this_.get_9uvjra_k$(Key_getInstance());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? _get_DefaultDelay_() : tmp0_elvis_lhs;
  }
  function delta($this, unconfined) {
    return unconfined ? new Long(0, 1) : new Long(1, 0);
  }
  function EventLoop() {
    CoroutineDispatcher.call(this);
    this._useCount = new Long(0, 0);
    this._shared = false;
    this._unconfinedQueue = null;
  }
  EventLoop.prototype.processUnconfinedEvent_0_k$ = function () {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.removeFirstOrNull_0_k$();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.run_sv8swh_k$();
    return true;
  };
  EventLoop.prototype.dispatchUnconfined_3yrun8_k$ = function (task) {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new ArrayQueue();
      this._unconfinedQueue = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.addLast_iav7o_k$(task);
  };
  EventLoop.prototype._get_isUnconfinedLoopActive__0_k$ = function () {
    return this._useCount.compareTo_wiekkq_k$(delta(this, true)) >= 0;
  };
  EventLoop.prototype._get_isUnconfinedQueueEmpty__0_k$ = function () {
    var tmp0_safe_receiver = this._unconfinedQueue;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_isEmpty__0_k$();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  EventLoop.prototype.incrementUseCount_rpwsgn_k$ = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.plus_wiekkq_k$(delta(this, unconfined));
    if (!unconfined)
      this._shared = true;
  };
  EventLoop.prototype.decrementUseCount_rpwsgn_k$ = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.minus_wiekkq_k$(delta(this, unconfined));
    if (this._useCount.compareTo_wiekkq_k$(new Long(0, 0)) > 0)
      return Unit_getInstance();
    if (this._shared) {
      this.shutdown_sv8swh_k$();
    }};
  EventLoop.prototype.shutdown_sv8swh_k$ = function () {
  };
  EventLoop.$metadata$ = {
    simpleName: 'EventLoop',
    kind: 'class',
    interfaces: []
  };
  function ThreadLocalEventLoop() {
    ThreadLocalEventLoop_instance = this;
    this._ref = new CommonThreadLocal();
  }
  ThreadLocalEventLoop.prototype._get_eventLoop__0_k$ = function () {
    var tmp0_elvis_lhs = this._ref.get_0_k$();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = createEventLoop();
      ThreadLocalEventLoop_getInstance()._ref.set_iav7o_k$(tmp0_also_0);
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ThreadLocalEventLoop.$metadata$ = {
    simpleName: 'ThreadLocalEventLoop',
    kind: 'object',
    interfaces: []
  };
  var ThreadLocalEventLoop_instance;
  function ThreadLocalEventLoop_getInstance() {
    if (ThreadLocalEventLoop_instance == null)
      new ThreadLocalEventLoop();
    return ThreadLocalEventLoop_instance;
  }
  function CompletionHandlerException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, CompletionHandlerException);
  }
  CompletionHandlerException.$metadata$ = {
    simpleName: 'CompletionHandlerException',
    kind: 'class',
    interfaces: []
  };
  function CoroutinesInternalError(message, cause) {
    Error_init_$Init$_1(message, cause, this);
    captureStack(this, CoroutinesInternalError);
  }
  CoroutinesInternalError.$metadata$ = {
    simpleName: 'CoroutinesInternalError',
    kind: 'class',
    interfaces: []
  };
  function DisposableHandle() {
  }
  DisposableHandle.$metadata$ = {
    simpleName: 'DisposableHandle',
    kind: 'interface',
    interfaces: []
  };
  function Key_4() {
    Key_instance_2 = this;
  }
  Key_4.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_2;
  function Key_getInstance_2() {
    if (Key_instance_2 == null)
      new Key_4();
    return Key_instance_2;
  }
  function Job() {
  }
  Job.prototype.cancel$default_44too_k$ = function (cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return $handler == null ? this.cancel_fnv408_k$(cause) : $handler(cause);
  };
  Job.prototype.invokeOnCompletion$default_n4h7x8_k$ = function (onCancelling, invokeImmediately, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancelling = false;
    if (!(($mask0 & 2) === 0))
      invokeImmediately = true;
    return $handler == null ? this.invokeOnCompletion_431mg2_k$(onCancelling, invokeImmediately, handler) : $handler(onCancelling, invokeImmediately, handler);
  };
  Job.$metadata$ = {
    simpleName: 'Job',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function ChildJob() {
  }
  ChildJob.$metadata$ = {
    simpleName: 'ChildJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ParentJob() {
  }
  ParentJob.$metadata$ = {
    simpleName: 'ParentJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ChildHandle() {
  }
  ChildHandle.$metadata$ = {
    simpleName: 'ChildHandle',
    kind: 'interface',
    interfaces: [DisposableHandle]
  };
  function NonDisposableHandle() {
    NonDisposableHandle_instance = this;
  }
  NonDisposableHandle.prototype._get_parent__0_k$ = function () {
    return null;
  };
  NonDisposableHandle.prototype.dispose_sv8swh_k$ = function () {
  };
  NonDisposableHandle.prototype.childCancelled_onfaoi_k$ = function (cause) {
    return false;
  };
  NonDisposableHandle.prototype.toString = function () {
    return 'NonDisposableHandle';
  };
  NonDisposableHandle.$metadata$ = {
    simpleName: 'NonDisposableHandle',
    kind: 'object',
    interfaces: [DisposableHandle, ChildHandle]
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    if (NonDisposableHandle_instance == null)
      new NonDisposableHandle();
    return NonDisposableHandle_instance;
  }
  function ensureActive(_this_) {
    var tmp0_safe_receiver = _this_.get_9uvjra_k$(Key_getInstance_2());
    if (tmp0_safe_receiver == null)
      null;
    else {
      ensureActive_0(tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function ensureActive_0(_this_) {
    if (!_this_._get_isActive__0_k$())
      throw _this_.getCancellationException_0_k$();
  }
  function Job_0(parent) {
    return new JobImpl(parent);
  }
  function Job$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return Job_0(parent);
  }
  function _get_job_(_this_) {
    var tmp0_elvis_lhs = _this_.get_9uvjra_k$(Key_getInstance_2());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = '' + "Current context doesn't contain Job in it: " + _this_;
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function cancel(_this_, cause) {
    var tmp0_safe_receiver = _this_.get_9uvjra_k$(Key_getInstance_2());
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel_fnv408_k$(cause);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function cancel$default(_this_, cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return cancel(_this_, cause);
  }
  function cancelChildren(_this_, cause) {
    var tmp0_safe_receiver = _this_.get_9uvjra_k$(Key_getInstance_2());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_children__0_k$();
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp0_iterator_1 = tmp1_safe_receiver.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        element_2.cancel_fnv408_k$(cause);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function cancelChildren$default(_this_, cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return cancelChildren(_this_, cause);
  }
  function cancelAndJoin(_this_, $cont) {
    _this_.cancel$default_44too_k$(null, 1, null);
    return _this_.join_sv8swh_k$($cont);
  }
  function disposeOnCompletion(_this_, handle) {
    var tmp0__get_asHandler__0 = new DisposeOnCompletion(handle);
    return _this_.invokeOnCompletion_wjzpsu_k$(tmp0__get_asHandler__0);
  }
  var COMPLETING_ALREADY;
  var COMPLETING_WAITING_CHILDREN;
  var COMPLETING_RETRY;
  var TOO_LATE_TO_CANCEL;
  var SEALED;
  var EMPTY_NEW;
  var EMPTY_ACTIVE;
  function Empty_0(isActive) {
    this._isActive = isActive;
  }
  Empty_0.prototype._get_isActive__0_k$ = function () {
    return this._isActive;
  };
  Empty_0.prototype._get_list__0_k$ = function () {
    return null;
  };
  Empty_0.prototype.toString = function () {
    return '' + 'Empty{' + (this._isActive ? 'Active' : 'New') + '}';
  };
  Empty_0.$metadata$ = {
    simpleName: 'Empty',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function Incomplete() {
  }
  Incomplete.$metadata$ = {
    simpleName: 'Incomplete',
    kind: 'interface',
    interfaces: []
  };
  function NodeList_0() {
    LinkedListHead.call(this);
  }
  NodeList_0.prototype._get_isActive__0_k$ = function () {
    return true;
  };
  NodeList_0.prototype._get_list__0_k$ = function () {
    return this;
  };
  NodeList_0.prototype.getString_6wfw3l_k$ = function (state) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_uch40_k$('List{');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$(state);
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('}[');
    Unit_getInstance();
    var first_3 = true;
    var cur_1_4 = this._get__next__0_k$();
    while (!equals_1(cur_1_4, this)) {
      if (cur_1_4 instanceof JobNode) {
        var tmp0__anonymous__2_5 = cur_1_4;
        if (first_3)
          first_3 = false;
        else {
          tmp0_apply_0_1.append_uch40_k$(', ');
          Unit_getInstance();
        }
        tmp0_apply_0_1.append_wi7j7l_k$(tmp0__anonymous__2_5);
        Unit_getInstance();
      } else {
      }
      cur_1_4 = cur_1_4.__next;
    }
    tmp0_apply_0_1.append_uch40_k$(']');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  NodeList_0.prototype.toString = function () {
    return DEBUG ? this.getString_6wfw3l_k$('Active') : anyToString(this);
  };
  NodeList_0.$metadata$ = {
    simpleName: 'NodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function JobNode() {
    CompletionHandlerBase.call(this);
  }
  JobNode.prototype._get_job__0_k$ = function () {
    var tmp = this._job;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('job');
    }
  };
  JobNode.prototype._get_isActive__0_k$ = function () {
    return true;
  };
  JobNode.prototype._get_list__0_k$ = function () {
    return null;
  };
  JobNode.prototype.dispose_sv8swh_k$ = function () {
    return this._get_job__0_k$().removeNode_2kg835_k$(this);
  };
  JobNode.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '[job@' + _get_hexAddress_(this._get_job__0_k$()) + ']';
  };
  JobNode.$metadata$ = {
    simpleName: 'JobNode',
    kind: 'class',
    interfaces: [DisposableHandle, Incomplete]
  };
  function _set_exceptionsHolder_($this, value) {
    $this.__exceptionsHolder._value_5 = value;
  }
  function _get_exceptionsHolder_($this) {
    return $this.__exceptionsHolder._value_5;
  }
  function allocateList($this) {
    return ArrayList_init_$Create$_0(4);
  }
  function finalizeFinishingState($this, state, proposedUpdate) {
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
    var wasCancelling = false;
    wasCancelling = state._get_isCancelling__0_k$();
    var exceptions_2 = state.sealLocked_h62ekz_k$(proposedException);
    var finalCause_3 = getFinalRootCause($this, state, exceptions_2);
    if (!(finalCause_3 == null))
      addSuppressedExceptions($this, finalCause_3, exceptions_2);
    var finalException = finalCause_3;
    var tmp;
    if (finalException == null) {
      tmp = proposedUpdate;
    } else if (finalException === proposedException) {
      tmp = proposedUpdate;
    } else {
      tmp = CompletedExceptionally_init_$Create$(finalException, false, 2, null);
    }
    var finalState = tmp;
    if (!(finalException == null)) {
      var handled = cancelParent($this, finalException) ? true : $this.handleJobException_onfaoi_k$(finalException);
      if (handled) {
        (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).makeHandled_0_k$();
        Unit_getInstance();
      }}if (!wasCancelling)
      $this.onCancelling_houul8_k$(finalException);
    $this.onCompletionInternal_qi8yb4_k$(finalState);
    var casSuccess = $this.__state_0.atomicfu$compareAndSet(state, boxIncomplete(finalState));
    completeStateFinalization($this, state, finalState);
    return finalState;
  }
  function getFinalRootCause($this, state, exceptions) {
    if (exceptions.isEmpty_0_k$()) {
      if (state._get_isCancelling__0_k$()) {
        var tmp0_elvis_lhs_1 = null;
        return new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_0_k$() : tmp0_elvis_lhs_1, null, $this);
      }return null;
    }var tmp$ret$0;
    l$ret$1: do {
      var tmp0_iterator_1 = exceptions.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!(element_2 instanceof CancellationException)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var firstNonCancellation = tmp$ret$0;
    if (!(firstNonCancellation == null))
      return firstNonCancellation;
    var first_2 = exceptions.get_ha5a7z_k$(0);
    if (first_2 instanceof TimeoutCancellationException) {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp0_iterator_1_0 = exceptions.iterator_0_k$();
        while (tmp0_iterator_1_0.hasNext_0_k$()) {
          var element_2_0 = tmp0_iterator_1_0.next_0_k$();
          var tmp;
          if (!(element_2_0 === first_2)) {
            tmp = element_2_0 instanceof TimeoutCancellationException;
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$2 = element_2_0;
            break l$ret$3;
          } else {
          }
        }
        tmp$ret$2 = null;
      }
       while (false);
      var detailedTimeoutException = tmp$ret$2;
      if (!(detailedTimeoutException == null))
        return detailedTimeoutException;
    } else {
    }
    return first_2;
  }
  function addSuppressedExceptions($this, rootCause, exceptions) {
    if (exceptions._get_size__0_k$() <= 1)
      return Unit_getInstance();
    var seenExceptions = identitySet(exceptions._get_size__0_k$());
    var unwrappedCause = unwrap(rootCause);
    var tmp0_iterator = exceptions.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var exception = tmp0_iterator.next_0_k$();
      var unwrapped = unwrap(exception);
      var tmp;
      var tmp_0;
      if (!(unwrapped === rootCause) ? !(unwrapped === unwrappedCause) : false) {
        tmp_0 = !(unwrapped instanceof CancellationException);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = seenExceptions.add_2bq_k$(unwrapped);
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
      } else {
      }
    }
  }
  function tryFinalizeSimpleState($this, state, update_0) {
    if (!$this.__state_0.atomicfu$compareAndSet(state, boxIncomplete(update_0)))
      return false;
    $this.onCancelling_houul8_k$(null);
    $this.onCompletionInternal_qi8yb4_k$(update_0);
    completeStateFinalization($this, state, update_0);
    return true;
  }
  function completeStateFinalization($this, state, update_0) {
    var tmp0_safe_receiver = $this._get_parentHandle__0_k$();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_sv8swh_k$();
      $this._set_parentHandle__kbopvd_k$(NonDisposableHandle_getInstance());
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = update_0 instanceof CompletedExceptionally ? update_0 : null;
    var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._cause;
    if (state instanceof JobNode) {
      try {
        state.invoke(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          $this.handleOnCompletionException_1ti8hr_k$(new CompletionHandlerException('' + 'Exception in completion handler ' + state + ' for ' + $this, $p));
        } else {
          {
            throw $p;
          }
        }
      }
    } else {
      {
        var tmp2_safe_receiver = state._get_list__0_k$();
        if (tmp2_safe_receiver == null)
          null;
        else {
          notifyCompletion(tmp2_safe_receiver, $this, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
    }
  }
  function notifyCancelling($this, list, cause) {
    $this.onCancelling_houul8_k$(cause);
    var exception_1 = null;
    var cur_1 = list._get__next__0_k$();
    while (!equals_1(cur_1, list)) {
      if (cur_1 instanceof JobCancellingNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_1ti8hr_k$(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    Unit_getInstance();
    cancelParent($this, cause);
    Unit_getInstance();
  }
  function cancelParent($this, cause) {
    if ($this._get_isScopedCoroutine__0_k$())
      return true;
    var isCancellation = cause instanceof CancellationException;
    var parent = $this._get_parentHandle__0_k$();
    if (parent === null ? true : parent === NonDisposableHandle_getInstance()) {
      return isCancellation;
    }return parent.childCancelled_onfaoi_k$(cause) ? true : isCancellation;
  }
  function notifyCompletion(_this_, $this, cause) {
    var exception_1 = null;
    var cur_1 = _this_._get__next__0_k$();
    while (!equals_1(cur_1, _this_)) {
      if (cur_1 instanceof JobNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_1ti8hr_k$(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function startInternal($this, state) {
    var tmp0_subject = state;
    if (tmp0_subject instanceof Empty_0) {
      if (state._isActive)
        return 0;
      if (!$this.__state_0.atomicfu$compareAndSet(state, EMPTY_ACTIVE))
        return -1;
      $this.onStart_sv8swh_k$();
      return 1;
    } else {
      if (tmp0_subject instanceof InactiveNodeList) {
        if (!$this.__state_0.atomicfu$compareAndSet(state, state._list_2))
          return -1;
        $this.onStart_sv8swh_k$();
        return 1;
      } else {
        return 0;
      }
    }
  }
  function makeNode($this, handler, onCancelling) {
    var tmp;
    if (onCancelling) {
      var tmp0_elvis_lhs = handler instanceof JobCancellingNode ? handler : null;
      tmp = tmp0_elvis_lhs == null ? new InvokeOnCancelling(handler) : tmp0_elvis_lhs;
    } else {
      var tmp1_safe_receiver = handler instanceof JobNode ? handler : null;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = tmp1_safe_receiver;
      }
      var tmp2_elvis_lhs = tmp_0;
      tmp = tmp2_elvis_lhs == null ? new InvokeOnCompletion(handler) : tmp2_elvis_lhs;
    }
    var node = tmp;
    node._job = $this;
    return node;
  }
  function addLastAtomic($this, expect, list, node) {
    var tmp$ret$0;
    l$ret$1: do {
      if (!($this._get_state__0_k$() === expect)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      list.addLast_qdrmxw_k$(node);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function promoteEmptyToNodeList($this, state) {
    var list = new NodeList_0();
    var update_0 = state._isActive ? list : new InactiveNodeList(list);
    $this.__state_0.atomicfu$compareAndSet(state, update_0);
    Unit_getInstance();
  }
  function promoteSingleToNodeList($this, state) {
    state.addOneIfEmpty_fpxpjn_k$(new NodeList_0());
    Unit_getInstance();
    var list = state.__next;
    $this.__state_0.atomicfu$compareAndSet(state, list);
    Unit_getInstance();
  }
  function joinInternal($this) {
    while (true) {
      var tmp0__anonymous__1 = $this._get_state__0_k$();
      if (!(!(tmp0__anonymous__1 == null) ? isInterface(tmp0__anonymous__1, Incomplete) : false))
        return false;
      else {
      }
      if (startInternal($this, tmp0__anonymous__1) >= 0)
        return true;
    }
    Unit_getInstance();
  }
  function joinSuspend($this, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_sv8swh_k$();
    var tmp0__get_asHandler__0_4 = new ResumeOnCompletion(cancellable_2_2);
    disposeOnCancellation(cancellable_2_2, $this.invokeOnCompletion_wjzpsu_k$(tmp0__get_asHandler__0_4));
    return cancellable_2_2.getResult_0_k$();
  }
  function cancelMakeCompleting($this, cause) {
    while (true) {
      var tmp0__anonymous__1 = $this._get_state__0_k$();
      var tmp;
      if (!(!(tmp0__anonymous__1 == null) ? isInterface(tmp0__anonymous__1, Incomplete) : false)) {
        tmp = true;
      } else {
        {
          var tmp_0;
          if (tmp0__anonymous__1 instanceof Finishing) {
            tmp_0 = tmp0__anonymous__1._get_isCompleting__0_k$();
          } else {
            {
              tmp_0 = false;
            }
          }
          tmp = tmp_0;
        }
      }
      if (tmp) {
        return COMPLETING_ALREADY;
      } else {
      }
      var tmp_1 = createCauseException($this, cause);
      var proposedUpdate_2 = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
      var finalState_3 = tryMakeCompleting($this, tmp0__anonymous__1, proposedUpdate_2);
      if (!(finalState_3 === COMPLETING_RETRY))
        return finalState_3;
    }
    Unit_getInstance();
  }
  function createCauseException($this, cause) {
    var tmp0_subject = cause;
    var tmp;
    if (tmp0_subject == null ? true : tmp0_subject instanceof Error) {
      var tmp1_elvis_lhs = cause;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_elvis_lhs_1 = null;
        tmp_0 = new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_0_k$() : tmp0_elvis_lhs_1, null, $this);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      {
        tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).getChildJobCancellationCause_0_k$();
      }
    }
    return tmp;
  }
  function makeCancelling($this, cause) {
    var causeExceptionCache = null;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = $this._get_state__0_k$();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Finishing) {
          if (tmp0__anonymous__1._get_isSealed__0_k$())
            return TOO_LATE_TO_CANCEL;
          var wasCancelling_2_4 = tmp0__anonymous__1._get_isCancelling__0_k$();
          if (!(cause == null) ? true : !wasCancelling_2_4) {
            var tmp0_elvis_lhs_4_6 = causeExceptionCache;
            var tmp;
            if (tmp0_elvis_lhs_4_6 == null) {
              var tmp0_also_0_5_7 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_5_7;
              tmp = tmp0_also_0_5_7;
            } else {
              tmp = tmp0_elvis_lhs_4_6;
            }
            var causeException_3_5 = tmp;
            tmp0__anonymous__1.addExceptionLocked_1ti8hr_k$(causeException_3_5);
          }var tmp1_takeIf_0_6_8 = tmp0__anonymous__1._get_rootCause__0_k$();
          var tmp_0;
          if (!wasCancelling_2_4) {
            tmp_0 = tmp1_takeIf_0_6_8;
          } else {
            {
              tmp_0 = null;
            }
          }
          var notifyRootCause_3 = tmp_0;
          var tmp1_safe_receiver_9 = notifyRootCause_3;
          if (tmp1_safe_receiver_9 == null)
            null;
          else {
            notifyCancelling($this, tmp0__anonymous__1._list_1, tmp1_safe_receiver_9);
            Unit_getInstance();
          }
          Unit_getInstance();
          return COMPLETING_ALREADY;
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var tmp2_elvis_lhs_11 = causeExceptionCache;
            var tmp_1;
            if (tmp2_elvis_lhs_11 == null) {
              var tmp0_also_0_12 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_12;
              tmp_1 = tmp0_also_0_12;
            } else {
              tmp_1 = tmp2_elvis_lhs_11;
            }
            var causeException_10 = tmp_1;
            if (tmp0__anonymous__1._get_isActive__0_k$()) {
              if (tryMakeCancelling($this, tmp0__anonymous__1, causeException_10))
                return COMPLETING_ALREADY;
            } else {
              var finalState_13 = tryMakeCompleting($this, tmp0__anonymous__1, CompletedExceptionally_init_$Create$(causeException_10, false, 2, null));
              if (finalState_13 === COMPLETING_ALREADY) {
                var tmp1_error_0_14 = '' + 'Cannot happen in ' + tmp0__anonymous__1;
                throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0_14));
              } else if (finalState_13 === COMPLETING_RETRY) {
                tmp$ret$0 = Unit_getInstance();
                break l$ret$1;
              } else
                return finalState_13;
            }
          } else {
            return TOO_LATE_TO_CANCEL;
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  }
  function getOrPromoteCancellingList($this, state) {
    var tmp1_elvis_lhs = state._get_list__0_k$();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_subject = state;
      var tmp_0;
      if (tmp0_subject instanceof Empty_0) {
        tmp_0 = new NodeList_0();
      } else {
        if (tmp0_subject instanceof JobNode) {
          promoteSingleToNodeList($this, state);
          tmp_0 = null;
        } else {
          {
            var tmp0_error_0 = '' + 'State should have list: ' + state;
            throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
          }
        }
      }
      tmp = tmp_0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryMakeCancelling($this, state, rootCause) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var cancelling = new Finishing(list, false, rootCause);
    if (!$this.__state_0.atomicfu$compareAndSet(state, cancelling))
      return false;
    notifyCancelling($this, list, rootCause);
    return true;
  }
  function tryMakeCompleting($this, state, proposedUpdate) {
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return COMPLETING_ALREADY;
    else {
    }
    var tmp;
    var tmp_0;
    var tmp_1;
    if (state instanceof Empty_0) {
      tmp_1 = true;
    } else {
      {
        tmp_1 = state instanceof JobNode;
      }
    }
    if (tmp_1) {
      tmp_0 = !(state instanceof ChildHandleNode);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = !(proposedUpdate instanceof CompletedExceptionally);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
        return proposedUpdate;
      }return COMPLETING_RETRY;
    } else {
    }
    return tryMakeCompletingSlowPath($this, state, proposedUpdate);
  }
  function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return COMPLETING_RETRY;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
    var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
    var notifyRootCause = null;
    if (finishing._get_isCompleting__0_k$())
      return COMPLETING_ALREADY;
    finishing._set_isCompleting__rpwsgn_k$(true);
    if (!(finishing === state)) {
      if (!$this.__state_0.atomicfu$compareAndSet(state, finishing))
        return COMPLETING_RETRY;
    }var wasCancelling_2 = finishing._get_isCancelling__0_k$();
    var tmp0_safe_receiver_3 = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    if (tmp0_safe_receiver_3 == null)
      null;
    else {
      finishing.addExceptionLocked_1ti8hr_k$(tmp0_safe_receiver_3._cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp0_takeIf_0_4 = finishing._get_rootCause__0_k$();
    var tmp_0;
    if (!wasCancelling_2) {
      tmp_0 = tmp0_takeIf_0_4;
    } else {
      {
        tmp_0 = null;
      }
    }
    notifyRootCause = tmp_0;
    var tmp2_safe_receiver = notifyRootCause;
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCancelling($this, list, tmp2_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    var child = firstChild($this, state);
    if (!(child == null) ? tryWaitForChild($this, finishing, child, proposedUpdate) : false)
      return COMPLETING_WAITING_CHILDREN;
    return finalizeFinishingState($this, finishing, proposedUpdate);
  }
  function _get_exceptionOrNull_(_this_, $this) {
    var tmp0_safe_receiver = _this_ instanceof CompletedExceptionally ? _this_ : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  }
  function firstChild($this, state) {
    var tmp1_elvis_lhs = state instanceof ChildHandleNode ? state : null;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = state._get_list__0_k$();
      tmp = tmp0_safe_receiver == null ? null : nextChild(tmp0_safe_receiver, $this);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryWaitForChild($this, state, child, proposedUpdate) {
    var $this_0 = $this;
    var state_0 = state;
    var child_0 = child;
    var proposedUpdate_0 = proposedUpdate;
    while (true) {
      var $this_1 = $this_0;
      var state_1 = state_0;
      var child_1 = child_0;
      var proposedUpdate_1 = proposedUpdate_0;
      var tmp0__get_asHandler__0 = new ChildCompletion($this_1, state_1, child_1, proposedUpdate_1);
      var handle = child_1._childJob.invokeOnCompletion$default_n4h7x8_k$(false, false, tmp0__get_asHandler__0, 1, null);
      if (!(handle === NonDisposableHandle_getInstance()))
        return true;
      var tmp0_elvis_lhs = nextChild(child_1, $this_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      $this_0 = $this_1;
      state_0 = state_1;
      child_0 = nextChild_0;
      proposedUpdate_0 = proposedUpdate_1;
      continue;
    }
  }
  function continueCompleting($this, state, lastChild, proposedUpdate) {
    var waitChild = nextChild(lastChild, $this);
    if (!(waitChild == null) ? tryWaitForChild($this, state, waitChild, proposedUpdate) : false)
      return Unit_getInstance();
    var finalState = finalizeFinishingState($this, state, proposedUpdate);
    $this.afterCompletion_qi8yb4_k$(finalState);
  }
  function nextChild(_this_, $this) {
    var cur = _this_;
    $l$break: while (true) {
      var tmp0__get_isRemoved__0 = cur;
      if (!tmp0__get_isRemoved__0.__removed) {
        break $l$break;
      }var tmp1__get_prevNode__0 = cur;
      cur = tmp1__get_prevNode__0.__prev;
    }
    while (true) {
      var tmp2__get_nextNode__0 = cur;
      cur = tmp2__get_nextNode__0.__next;
      var tmp3__get_isRemoved__0 = cur;
      if (tmp3__get_isRemoved__0.__removed)
        continue;
      else {
      }
      if (cur instanceof ChildHandleNode)
        return cur;
      else {
      }
      if (cur instanceof NodeList_0)
        return null;
      else {
      }
    }
  }
  function stateString($this, state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_isCancelling__0_k$() ? 'Cancelling' : state._get_isCompleting__0_k$() ? 'Completing' : 'Active';
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
        tmp = state._get_isActive__0_k$() ? 'Active' : 'New';
      } else {
        if (tmp0_subject instanceof CompletedExceptionally) {
          tmp = 'Cancelled';
        } else {
          {
            tmp = 'Completed';
          }
        }
      }
    }
    return tmp;
  }
  function Finishing(list, isCompleting, rootCause) {
    this._list_1 = list;
    this.__isCompleting = atomic_0(isCompleting);
    this.__rootCause = atomic(rootCause);
    this.__exceptionsHolder = atomic(null);
  }
  Finishing.prototype._get_list__0_k$ = function () {
    return this._list_1;
  };
  Finishing.prototype._set_isCompleting__rpwsgn_k$ = function (value) {
    this.__isCompleting._value_6 = value;
  };
  Finishing.prototype._get_isCompleting__0_k$ = function () {
    return this.__isCompleting._value_6;
  };
  Finishing.prototype._set_rootCause__houul8_k$ = function (value) {
    this.__rootCause._value_5 = value;
  };
  Finishing.prototype._get_rootCause__0_k$ = function () {
    return this.__rootCause._value_5;
  };
  Finishing.prototype._get_isSealed__0_k$ = function () {
    return _get_exceptionsHolder_(this) === SEALED;
  };
  Finishing.prototype._get_isCancelling__0_k$ = function () {
    return !(this._get_rootCause__0_k$() == null);
  };
  Finishing.prototype._get_isActive__0_k$ = function () {
    return this._get_rootCause__0_k$() == null;
  };
  Finishing.prototype.sealLocked_h62ekz_k$ = function (proposedException) {
    var eh = _get_exceptionsHolder_(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        var tmp0_also_0 = allocateList(this);
        tmp0_also_0.add_2bq_k$(eh);
        Unit_getInstance();
        tmp = tmp0_also_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
          }
        }
      }
    }
    var list = tmp;
    var rootCause = this._get_rootCause__0_k$();
    var tmp0_safe_receiver = rootCause;
    if (tmp0_safe_receiver == null)
      null;
    else {
      list.add_vz2mgm_k$(0, tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    if (!(proposedException == null) ? !equals_1(proposedException, rootCause) : false) {
      list.add_2bq_k$(proposedException);
      Unit_getInstance();
    }_set_exceptionsHolder_(this, SEALED);
    return list;
  };
  Finishing.prototype.addExceptionLocked_1ti8hr_k$ = function (exception) {
    var rootCause = this._get_rootCause__0_k$();
    if (rootCause == null) {
      this._set_rootCause__houul8_k$(exception);
      return Unit_getInstance();
    }if (exception === rootCause)
      return Unit_getInstance();
    var eh = _get_exceptionsHolder_(this);
    if (eh == null)
      _set_exceptionsHolder_(this, exception);
    else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_getInstance();
        var tmp0_apply_0 = allocateList(this);
        tmp0_apply_0.add_2bq_k$(eh);
        Unit_getInstance();
        tmp0_apply_0.add_2bq_k$(exception);
        Unit_getInstance();
        _set_exceptionsHolder_(this, tmp0_apply_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).add_2bq_k$(exception);
          Unit_getInstance();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
          }
        }
      }
    }
  };
  Finishing.prototype.toString = function () {
    return '' + 'Finishing[cancelling=' + this._get_isCancelling__0_k$() + ', completing=' + this._get_isCompleting__0_k$() + ', rootCause=' + this._get_rootCause__0_k$() + ', exceptions=' + _get_exceptionsHolder_(this) + ', list=' + this._list_1 + ']';
  };
  Finishing.$metadata$ = {
    simpleName: 'Finishing',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildCompletion(parent, state, child, proposedUpdate) {
    JobNode.call(this);
    this._parent_0 = parent;
    this._state_3 = state;
    this._child = child;
    this._proposedUpdate = proposedUpdate;
  }
  ChildCompletion.prototype.invoke_houul8_k$ = function (cause) {
    continueCompleting(this._parent_0, this._state_3, this._child, this._proposedUpdate);
  };
  ChildCompletion.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  ChildCompletion.$metadata$ = {
    simpleName: 'ChildCompletion',
    kind: 'class',
    interfaces: []
  };
  function AwaitContinuation(delegate, job) {
    CancellableContinuationImpl.call(this, delegate, 1);
    this._job_0 = job;
  }
  AwaitContinuation.prototype.getContinuationCancellationCause_jfubq8_k$ = function (parent) {
    var state = this._job_0._get_state__0_k$();
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state._get_rootCause__0_k$();
      if (tmp0_safe_receiver == null)
        null;
      else {
        return tmp0_safe_receiver;
      }
      Unit_getInstance();
    } else {
    }
    if (state instanceof CompletedExceptionally)
      return state._cause;
    else {
    }
    return parent.getCancellationException_0_k$();
  };
  AwaitContinuation.prototype.nameString_0_k$ = function () {
    return 'AwaitContinuation';
  };
  AwaitContinuation.$metadata$ = {
    simpleName: 'AwaitContinuation',
    kind: 'class',
    interfaces: []
  };
  function awaitSuspend($this, $cont) {
    var tmp0__anonymous__1 = $cont;
    var cont_2 = new AwaitContinuation(intercepted(tmp0__anonymous__1), $this);
    cont_2.initCancellability_sv8swh_k$();
    var tmp0__get_asHandler__0_3 = new ResumeAwaitOnCompletion(cont_2);
    disposeOnCancellation(cont_2, $this.invokeOnCompletion_wjzpsu_k$(tmp0__get_asHandler__0_3));
    return cont_2.getResult_0_k$();
  }
  function _no_name_provided__113(this$0, resultContinuation) {
    this._this$0_32 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__113.prototype.invoke_8hb6eb_k$ = function ($this$sequence, $cont) {
    var tmp = this.create_nli7bc_k$($this$sequence, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__113.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_8hb6eb_k$(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__113.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            this._state0 = this._this$0_32._get_state__0_k$();
            var tmp_0 = this._state0;
            if (tmp_0 instanceof ChildHandleNode) {
              this._state_1 = 6;
              suspendResult = this._$this$sequence.yield_iav7o_k$(this._state0._childJob, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                var tmp_1 = this._state0;
                if (!(tmp_1 == null) ? isInterface(tmp_1, Incomplete) : false) {
                  this._tmp0_safe_receiver1 = this._state0._get_list__0_k$();
                  if (this._tmp0_safe_receiver1 == null) {
                    this._WHEN_RESULT2 = null;
                    this._state_1 = 5;
                    continue $sm;
                  } else {
                    this._cur_1_23 = this._tmp0_safe_receiver1._get__next__0_k$();
                    this._state_1 = 1;
                    continue $sm;
                  }
                } else {
                  {
                    this._state_1 = 7;
                    continue $sm;
                  }
                }
              }
            }

            break;
          case 1:
            if (!!equals_1(this._cur_1_23, this._tmp0_safe_receiver1)) {
              this._state_1 = 4;
              continue $sm;
            }
            var tmp_2 = this._cur_1_23;
            if (tmp_2 instanceof ChildHandleNode) {
              var tmp_3 = this;
              tmp_3._tmp0__anonymous__2_34 = this._cur_1_23;
              this._state_1 = 2;
              suspendResult = this._$this$sequence.yield_iav7o_k$(this._tmp0__anonymous__2_34._childJob, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 3;
                continue $sm;
              }
            }

            break;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._cur_1_23 = this._cur_1_23.__next;
            this._state_1 = 1;
            continue $sm;
          case 4:
            this._WHEN_RESULT2 = Unit_getInstance();
            this._state_1 = 5;
            continue $sm;
          case 5:
            Unit_getInstance();
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 8) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__113.prototype.create_nli7bc_k$ = function ($this$sequence, completion) {
    var i = new _no_name_provided__113(this._this$0_32, completion);
    i._$this$sequence = $this$sequence;
    return i;
  };
  _no_name_provided__113.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function JobSupport(active) {
    this.__state_0 = atomic(active ? EMPTY_ACTIVE : EMPTY_NEW);
    this.__parentHandle = atomic(null);
  }
  JobSupport.prototype._get_key__0_k$ = function () {
    return Key_getInstance_2();
  };
  JobSupport.prototype._set_parentHandle__kbopvd_k$ = function (value) {
    this.__parentHandle._value_5 = value;
  };
  JobSupport.prototype._get_parentHandle__0_k$ = function () {
    return this.__parentHandle._value_5;
  };
  JobSupport.prototype.initParentJob_64sshe_k$ = function (parent) {
    if (parent == null) {
      this._set_parentHandle__kbopvd_k$(NonDisposableHandle_getInstance());
      return Unit_getInstance();
    }parent.start_0_k$();
    Unit_getInstance();
    var handle = parent.attachChild_o588si_k$(this);
    this._set_parentHandle__kbopvd_k$(handle);
    if (this._get_isCompleted__0_k$()) {
      handle.dispose_sv8swh_k$();
      this._set_parentHandle__kbopvd_k$(NonDisposableHandle_getInstance());
    }};
  JobSupport.prototype._get_state__0_k$ = function () {
    var tmp0_loop_0 = this.__state_0;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_5;
      if (!(tmp1__anonymous__1 instanceof OpDescriptor))
        return tmp1__anonymous__1;
      else {
      }
      tmp1__anonymous__1.perform_wi7j7l_k$(this);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_isActive__0_k$ = function () {
    var state = this._get_state__0_k$();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state._get_isActive__0_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  JobSupport.prototype._get_isCompleted__0_k$ = function () {
    var tmp = this._get_state__0_k$();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  };
  JobSupport.prototype._get_isCancelled__0_k$ = function () {
    var state = this._get_state__0_k$();
    var tmp;
    if (state instanceof CompletedExceptionally) {
      tmp = true;
    } else {
      {
        var tmp_0;
        if (state instanceof Finishing) {
          tmp_0 = state._get_isCancelling__0_k$();
        } else {
          {
            tmp_0 = false;
          }
        }
        tmp = tmp_0;
      }
    }
    return tmp;
  };
  JobSupport.prototype.start_0_k$ = function () {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__0_k$();
      var tmp0_subject_2 = startInternal(this, tmp0__anonymous__1);
      if (tmp0_subject_2 === 0)
        return false;
      else if (tmp0_subject_2 === 1)
        return true;
    }
    Unit_getInstance();
  };
  JobSupport.prototype.onStart_sv8swh_k$ = function () {
  };
  JobSupport.prototype.getCancellationException_0_k$ = function () {
    var state = this._get_state__0_k$();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state._get_rootCause__0_k$();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.toCancellationException_ntgz4s_k$(tmp0_safe_receiver, '' + _get_classSimpleName_(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var tmp1_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          tmp = this.toCancellationException$default_f52skm_k$(state._cause, null, 1, null);
        } else {
          {
            tmp = new JobCancellationException('' + _get_classSimpleName_(this) + ' has completed normally', null, this);
          }
        }
      }
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException_ntgz4s_k$ = function (_this__0, message) {
    var tmp0_elvis_lhs = _this__0 instanceof CancellationException ? _this__0 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_elvis_lhs_1 = message;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_0_k$() : tmp0_elvis_lhs_1, _this__0, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException$default_f52skm_k$ = function (_this__0, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      message = null;
    return this.toCancellationException_ntgz4s_k$(_this__0, message);
  };
  JobSupport.prototype.invokeOnCompletion_wjzpsu_k$ = function (handler) {
    return this.invokeOnCompletion_431mg2_k$(false, true, handler);
  };
  JobSupport.prototype.invokeOnCompletion_431mg2_k$ = function (onCancelling, invokeImmediately, handler) {
    var node = makeNode(this, handler, onCancelling);
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__0_k$();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Empty_0) {
          if (tmp0__anonymous__1._isActive) {
            if (this.__state_0.atomicfu$compareAndSet(tmp0__anonymous__1, node))
              return node;
          } else
            promoteEmptyToNodeList(this, tmp0__anonymous__1);
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var list_3 = tmp0__anonymous__1._get_list__0_k$();
            if (list_3 == null) {
              promoteSingleToNodeList(this, tmp0__anonymous__1 instanceof JobNode ? tmp0__anonymous__1 : THROW_CCE());
            } else {
              var rootCause_4 = null;
              var handle_5 = NonDisposableHandle_getInstance();
              var tmp;
              if (onCancelling) {
                tmp = tmp0__anonymous__1 instanceof Finishing;
              } else {
                tmp = false;
              }
              if (tmp) {
                rootCause_4 = tmp0__anonymous__1._get_rootCause__0_k$();
                var tmp_0;
                if (rootCause_4 == null) {
                  tmp_0 = true;
                } else {
                  var tmp_1;
                  if (handler instanceof ChildHandleNode) {
                    tmp_1 = !tmp0__anonymous__1._get_isCompleting__0_k$();
                  } else {
                    {
                      tmp_1 = false;
                    }
                  }
                  tmp_0 = tmp_1;
                }
                if (tmp_0) {
                  if (!addLastAtomic(this, tmp0__anonymous__1, list_3, node)) {
                    tmp$ret$0 = Unit_getInstance();
                    break l$ret$1;
                  }if (rootCause_4 == null)
                    return node;
                  handle_5 = node;
                } else {
                }
              } else {
              }
              if (!(rootCause_4 == null)) {
                if (invokeImmediately)
                  invokeIt(handler, rootCause_4);
                return handle_5;
              } else {
                if (addLastAtomic(this, tmp0__anonymous__1, list_3, node))
                  return node;
              }
            }
          } else {
            {
              if (invokeImmediately) {
                var tmp1_safe_receiver_6 = tmp0__anonymous__1 instanceof CompletedExceptionally ? tmp0__anonymous__1 : null;
                invokeIt(handler, tmp1_safe_receiver_6 == null ? null : tmp1_safe_receiver_6._cause);
              }return NonDisposableHandle_getInstance();
            }
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.join_sv8swh_k$ = function ($cont) {
    if (!joinInternal(this)) {
      ensureActive($cont._get_context__0_k$());
      return Unit_getInstance();
    }return joinSuspend(this, $cont);
  };
  JobSupport.prototype.removeNode_2kg835_k$ = function (node) {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__0_k$();
      var tmp0_subject_2 = tmp0__anonymous__1;
      if (tmp0_subject_2 instanceof JobNode) {
        if (!(tmp0__anonymous__1 === node))
          return Unit_getInstance();
        if (this.__state_0.atomicfu$compareAndSet(tmp0__anonymous__1, EMPTY_ACTIVE))
          return Unit_getInstance();
      } else {
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
          if (!(tmp0__anonymous__1._get_list__0_k$() == null)) {
            node.remove_0_k$();
            Unit_getInstance();
          }return Unit_getInstance();
        } else {
          return Unit_getInstance();
        }
      }
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_onCancelComplete__0_k$ = function () {
    return false;
  };
  JobSupport.prototype.cancel_fnv408_k$ = function (cause) {
    var tmp0_elvis_lhs = cause;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_elvis_lhs_1 = null;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_0_k$() : tmp0_elvis_lhs_1, null, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    this.cancelInternal_1ti8hr_k$(tmp);
  };
  JobSupport.prototype.cancellationExceptionMessage_0_k$ = function () {
    return 'Job was cancelled';
  };
  JobSupport.prototype.cancelInternal_1ti8hr_k$ = function (cause) {
    this.cancelImpl_wi7j7l_k$(cause);
    Unit_getInstance();
  };
  JobSupport.prototype.parentCancelled_f2sghn_k$ = function (parentJob) {
    this.cancelImpl_wi7j7l_k$(parentJob);
    Unit_getInstance();
  };
  JobSupport.prototype.childCancelled_onfaoi_k$ = function (cause) {
    if (cause instanceof CancellationException)
      return true;
    else {
    }
    return this.cancelImpl_wi7j7l_k$(cause) ? this._get_handlesException__0_k$() : false;
  };
  JobSupport.prototype.cancelCoroutine_h62ekz_k$ = function (cause) {
    return this.cancelImpl_wi7j7l_k$(cause);
  };
  JobSupport.prototype.cancelImpl_wi7j7l_k$ = function (cause) {
    var finalState = COMPLETING_ALREADY;
    if (this._get_onCancelComplete__0_k$()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === COMPLETING_WAITING_CHILDREN)
        return true;
    }if (finalState === COMPLETING_ALREADY) {
      finalState = makeCancelling(this, cause);
    }var tmp;
    if (finalState === COMPLETING_ALREADY) {
      tmp = true;
    } else if (finalState === COMPLETING_WAITING_CHILDREN) {
      tmp = true;
    } else if (finalState === TOO_LATE_TO_CANCEL) {
      tmp = false;
    } else {
      this.afterCompletion_qi8yb4_k$(finalState);
      tmp = true;
    }
    return tmp;
  };
  JobSupport.prototype.getChildJobCancellationCause_0_k$ = function () {
    var state = this._get_state__0_k$();
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_rootCause__0_k$();
    } else {
      if (tmp0_subject instanceof CompletedExceptionally) {
        tmp = state._cause;
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
          var tmp0_error_0 = '' + 'Cannot be cancelling child in this state: ' + state;
          throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
        } else {
          {
            tmp = null;
          }
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp1_elvis_lhs == null ? new JobCancellationException('' + 'Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  };
  JobSupport.prototype.makeCompleting_wi7j7l_k$ = function (proposedUpdate) {
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__0_k$();
        var finalState_2 = tryMakeCompleting(this, tmp0__anonymous__1, proposedUpdate);
        if (finalState_2 === COMPLETING_ALREADY)
          return false;
        else if (finalState_2 === COMPLETING_WAITING_CHILDREN)
          return true;
        else if (finalState_2 === COMPLETING_RETRY) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          this.afterCompletion_qi8yb4_k$(finalState_2);
          return true;
        }
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.makeCompletingOnce_wi7j7l_k$ = function (proposedUpdate) {
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__0_k$();
        var finalState_2 = tryMakeCompleting(this, tmp0__anonymous__1, proposedUpdate);
        if (finalState_2 === COMPLETING_ALREADY)
          throw IllegalStateException_init_$Create$_1('' + 'Job ' + this + ' is already complete or completing, ' + ('' + 'but is being completed with ' + proposedUpdate), _get_exceptionOrNull_(proposedUpdate, this));
        else if (finalState_2 === COMPLETING_RETRY) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else
          return finalState_2;
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_children__0_k$ = function () {
    return sequence(_no_name_provided_$factory_91(this, null));
  };
  JobSupport.prototype.attachChild_o588si_k$ = function (child) {
    var tmp0__get_asHandler__0 = new ChildHandleNode(child);
    var tmp = this.invokeOnCompletion$default_n4h7x8_k$(true, false, tmp0__get_asHandler__0, 2, null);
    return isInterface(tmp, ChildHandle) ? tmp : THROW_CCE();
  };
  JobSupport.prototype.handleOnCompletionException_1ti8hr_k$ = function (exception) {
    throw exception;
  };
  JobSupport.prototype.onCancelling_houul8_k$ = function (cause) {
  };
  JobSupport.prototype._get_isScopedCoroutine__0_k$ = function () {
    return false;
  };
  JobSupport.prototype._get_handlesException__0_k$ = function () {
    return true;
  };
  JobSupport.prototype.handleJobException_onfaoi_k$ = function (exception) {
    return false;
  };
  JobSupport.prototype.onCompletionInternal_qi8yb4_k$ = function (state) {
  };
  JobSupport.prototype.afterCompletion_qi8yb4_k$ = function (state) {
  };
  JobSupport.prototype.toString = function () {
    return '' + this.toDebugString_0_k$() + '@' + _get_hexAddress_(this);
  };
  JobSupport.prototype.toDebugString_0_k$ = function () {
    return '' + this.nameString_0_k$() + '{' + stateString(this, this._get_state__0_k$()) + '}';
  };
  JobSupport.prototype.nameString_0_k$ = function () {
    return _get_classSimpleName_(this);
  };
  JobSupport.prototype.awaitInternal_0_k$ = function ($cont) {
    $l$break: while (true) {
      var state = this._get_state__0_k$();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        if (state instanceof CompletedExceptionally) {
          var tmp0_recoverAndThrow_0 = state._cause;
          throw tmp0_recoverAndThrow_0;
        } else {
        }
        return unboxState(state);
      } else {
      }
      if (startInternal(this, state) >= 0)
        break $l$break;
    }
    return awaitSuspend(this, $cont);
  };
  JobSupport.$metadata$ = {
    simpleName: 'JobSupport',
    kind: 'class',
    interfaces: [Job, ChildJob, ParentJob, SelectClause0]
  };
  function boxIncomplete(_this_) {
    var tmp;
    if (!(_this_ == null) ? isInterface(_this_, Incomplete) : false) {
      tmp = new IncompleteStateBox(_this_);
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function JobCancellingNode() {
    JobNode.call(this);
  }
  JobCancellingNode.$metadata$ = {
    simpleName: 'JobCancellingNode',
    kind: 'class',
    interfaces: []
  };
  function InactiveNodeList(list) {
    this._list_2 = list;
  }
  InactiveNodeList.prototype._get_list__0_k$ = function () {
    return this._list_2;
  };
  InactiveNodeList.prototype._get_isActive__0_k$ = function () {
    return false;
  };
  InactiveNodeList.prototype.toString = function () {
    return DEBUG ? this._list_2.getString_6wfw3l_k$('New') : anyToString(this);
  };
  InactiveNodeList.$metadata$ = {
    simpleName: 'InactiveNodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildHandleNode(childJob) {
    JobCancellingNode.call(this);
    this._childJob = childJob;
  }
  ChildHandleNode.prototype._get_parent__0_k$ = function () {
    return this._get_job__0_k$();
  };
  ChildHandleNode.prototype.invoke_houul8_k$ = function (cause) {
    return this._childJob.parentCancelled_f2sghn_k$(this._get_job__0_k$());
  };
  ChildHandleNode.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  ChildHandleNode.prototype.childCancelled_onfaoi_k$ = function (cause) {
    return this._get_job__0_k$().childCancelled_onfaoi_k$(cause);
  };
  ChildHandleNode.$metadata$ = {
    simpleName: 'ChildHandleNode',
    kind: 'class',
    interfaces: [ChildHandle]
  };
  function InvokeOnCancelling(handler) {
    JobCancellingNode.call(this);
    this._handler_0 = handler;
    this.__invoked = atomic_1(0);
  }
  InvokeOnCancelling.prototype.invoke_houul8_k$ = function (cause) {
    if (this.__invoked.atomicfu$compareAndSet(0, 1))
      this._handler_0(cause);
  };
  InvokeOnCancelling.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  InvokeOnCancelling.$metadata$ = {
    simpleName: 'InvokeOnCancelling',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCompletion(handler) {
    JobNode.call(this);
    this._handler_1 = handler;
  }
  InvokeOnCompletion.prototype.invoke_houul8_k$ = function (cause) {
    return this._handler_1(cause);
  };
  InvokeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  InvokeOnCompletion.$metadata$ = {
    simpleName: 'InvokeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function ResumeOnCompletion(continuation) {
    JobNode.call(this);
    this._continuation_1 = continuation;
  }
  ResumeOnCompletion.prototype.invoke_houul8_k$ = function (cause) {
    var tmp0_resume_0 = this._continuation_1;
    var tmp0_success_0_1 = Companion_getInstance_3();
    return tmp0_resume_0.resumeWith_bnunh2_k$(_Result___init__impl_(Unit_getInstance()));
  };
  ResumeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  ResumeOnCompletion.$metadata$ = {
    simpleName: 'ResumeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function unboxState(_this_) {
    var tmp0_safe_receiver = _this_ instanceof IncompleteStateBox ? _this_ : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._state_4;
    return tmp1_elvis_lhs == null ? _this_ : tmp1_elvis_lhs;
  }
  function ResumeAwaitOnCompletion(continuation) {
    JobNode.call(this);
    this._continuation_2 = continuation;
  }
  ResumeAwaitOnCompletion.prototype.invoke_houul8_k$ = function (cause) {
    var state = this._get_job__0_k$()._get_state__0_k$();
    if (state instanceof CompletedExceptionally) {
      var tmp0_resumeWithException_0 = this._continuation_2;
      var tmp1_resumeWithException_0 = state._cause;
      var tmp0_failure_0_1 = Companion_getInstance_3();
      tmp0_resumeWithException_0.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(tmp1_resumeWithException_0)));
    } else {
      {
        var tmp2_resume_0 = this._continuation_2;
        var tmp = unboxState(state);
        var tmp3_resume_0 = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
        var tmp0_success_0_1 = Companion_getInstance_3();
        tmp2_resume_0.resumeWith_bnunh2_k$(_Result___init__impl_(tmp3_resume_0));
      }
    }
  };
  ResumeAwaitOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  ResumeAwaitOnCompletion.$metadata$ = {
    simpleName: 'ResumeAwaitOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function IncompleteStateBox(state) {
    this._state_4 = state;
  }
  IncompleteStateBox.$metadata$ = {
    simpleName: 'IncompleteStateBox',
    kind: 'class',
    interfaces: []
  };
  function ChildContinuation(child) {
    JobCancellingNode.call(this);
    this._child_0 = child;
  }
  ChildContinuation.prototype.invoke_houul8_k$ = function (cause) {
    this._child_0.parentCancelled_1ti8hr_k$(this._child_0.getContinuationCancellationCause_jfubq8_k$(this._get_job__0_k$()));
  };
  ChildContinuation.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  ChildContinuation.$metadata$ = {
    simpleName: 'ChildContinuation',
    kind: 'class',
    interfaces: []
  };
  function handlesException($this) {
    var tmp = $this._get_parentHandle__0_k$();
    var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_job__0_k$();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parentJob = tmp_0;
    while (true) {
      if (parentJob._get_handlesException__0_k$())
        return true;
      var tmp_1 = parentJob._get_parentHandle__0_k$();
      var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._get_job__0_k$();
      var tmp_2;
      if (tmp3_elvis_lhs == null) {
        return false;
      } else {
        tmp_2 = tmp3_elvis_lhs;
      }
      parentJob = tmp_2;
    }
  }
  function JobImpl(parent) {
    JobSupport.call(this, true);
    this.initParentJob_64sshe_k$(parent);
    this._handlesException = handlesException(this);
  }
  JobImpl.prototype._get_onCancelComplete__0_k$ = function () {
    return true;
  };
  JobImpl.prototype._get_handlesException__0_k$ = function () {
    return this._handlesException;
  };
  JobImpl.$metadata$ = {
    simpleName: 'JobImpl',
    kind: 'class',
    interfaces: [CompletableJob]
  };
  function DisposeOnCompletion(handle) {
    JobNode.call(this);
    this._handle_0 = handle;
  }
  DisposeOnCompletion.prototype.invoke_houul8_k$ = function (cause) {
    return this._handle_0.dispose_sv8swh_k$();
  };
  DisposeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  DisposeOnCompletion.$metadata$ = {
    simpleName: 'DisposeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_91(this$0, resultContinuation) {
    var i = new _no_name_provided__113(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_8hb6eb_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function MainCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
  }
  MainCoroutineDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0_k$();
    return tmp0_elvis_lhs == null ? '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) : tmp0_elvis_lhs;
  };
  MainCoroutineDispatcher.prototype.toStringInternalImpl_0_k$ = function () {
    var main_0 = Dispatchers_getInstance()._Main;
    if (this === main_0)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main_0._get_immediate__0_k$();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  };
  MainCoroutineDispatcher.$metadata$ = {
    simpleName: 'MainCoroutineDispatcher',
    kind: 'class',
    interfaces: []
  };
  function SupervisorJob(parent) {
    return new SupervisorJobImpl(parent);
  }
  function SupervisorJob$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return SupervisorJob(parent);
  }
  function SupervisorJobImpl(parent) {
    JobImpl.call(this, parent);
  }
  SupervisorJobImpl.prototype.childCancelled_onfaoi_k$ = function (cause) {
    return false;
  };
  SupervisorJobImpl.$metadata$ = {
    simpleName: 'SupervisorJobImpl',
    kind: 'class',
    interfaces: []
  };
  function TimeoutCancellationException_init_$Init$(message, $this) {
    TimeoutCancellationException.call($this, message, null);
    return $this;
  }
  function TimeoutCancellationException_init_$Create$(message) {
    var tmp = TimeoutCancellationException_init_$Init$(message, Object.create(TimeoutCancellationException.prototype));
    captureStack(tmp, TimeoutCancellationException_init_$Create$);
    return tmp;
  }
  function TimeoutCancellationException(message, coroutine) {
    CancellationException_init_$Init$(message, this);
    this._coroutine = coroutine;
    captureStack(this, TimeoutCancellationException);
  }
  TimeoutCancellationException.$metadata$ = {
    simpleName: 'TimeoutCancellationException',
    kind: 'class',
    interfaces: [CopyableThrowable]
  };
  function withTimeout(timeMillis, block, $cont) {
    if (timeMillis.compareTo_wiekkq_k$(new Long(0, 0)) <= 0)
      throw TimeoutCancellationException_init_$Create$('Timed out immediately');
    var tmp0__anonymous__1 = $cont;
    return setupTimeout(new TimeoutCoroutine(timeMillis, tmp0__anonymous__1), block);
  }
  function setupTimeout(coroutine, block) {
    var cont = coroutine._get_uCont__0_k$();
    var context = cont._get_context__0_k$();
    disposeOnCompletion(coroutine, _get_delay_(context).invokeOnTimeout_x8mf2g_k$(coroutine._time_0, coroutine, coroutine._get_context__0_k$()));
    Unit_getInstance();
    return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
  }
  function TimeoutCoroutine(time, uCont) {
    ScopeCoroutine.call(this, uCont._get_context__0_k$(), uCont);
    this._time_0 = time;
  }
  TimeoutCoroutine.prototype.run_sv8swh_k$ = function () {
    this.cancelCoroutine_h62ekz_k$(TimeoutCancellationException_0(this._time_0, this));
    Unit_getInstance();
  };
  TimeoutCoroutine.prototype.nameString_0_k$ = function () {
    return '' + ScopeCoroutine.prototype.nameString_0_k$.call(this) + '(timeMillis=' + this._time_0 + ')';
  };
  TimeoutCoroutine.$metadata$ = {
    simpleName: 'TimeoutCoroutine',
    kind: 'class',
    interfaces: [Runnable]
  };
  function TimeoutCancellationException_0(time, coroutine) {
    return new TimeoutCancellationException('' + 'Timed out waiting for ' + time + ' ms', coroutine);
  }
  function Unconfined() {
    Unconfined_instance = this;
    CoroutineDispatcher.call(this);
  }
  Unconfined.prototype.isDispatchNeeded_d7pszg_k$ = function (context) {
    return false;
  };
  Unconfined.prototype.dispatch_7n0ou3_k$ = function (context, block) {
    var yieldContext = context.get_9uvjra_k$(Key_getInstance_3());
    if (!(yieldContext == null)) {
      yieldContext.dispatcherWasUnconfined__error = true;
      return Unit_getInstance();
    }throw UnsupportedOperationException_init_$Create$_0('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  };
  Unconfined.prototype.toString = function () {
    return 'Dispatchers.Unconfined';
  };
  Unconfined.$metadata$ = {
    simpleName: 'Unconfined',
    kind: 'object',
    interfaces: []
  };
  var Unconfined_instance;
  function Unconfined_getInstance() {
    if (Unconfined_instance == null)
      new Unconfined();
    return Unconfined_instance;
  }
  function Key_5() {
    Key_instance_3 = this;
  }
  Key_5.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_3;
  function Key_getInstance_3() {
    if (Key_instance_3 == null)
      new Key_5();
    return Key_instance_3;
  }
  var EMPTY;
  var OFFER_SUCCESS;
  var OFFER_FAILED;
  var POLL_FAILED;
  var ENQUEUE_FAILED;
  var HANDLER_INVOKED;
  function receiveSuspend($this, receiveMode, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = getOrCreateCancellableContinuation(intercepted(tmp0__anonymous__1_1));
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if ($this._get_onUndeliveredElement__0_k$() == null) {
        tmp = new ReceiveElement(isInterface(cancellable_2_2, CancellableContinuation) ? cancellable_2_2 : THROW_CCE(), receiveMode);
      } else {
        tmp = new ReceiveElementWithUndeliveredHandler(isInterface(cancellable_2_2, CancellableContinuation) ? cancellable_2_2 : THROW_CCE(), receiveMode, $this._get_onUndeliveredElement__0_k$());
      }
      var receive_4 = tmp;
      while (true) {
        if (enqueueReceive($this, receive_4)) {
          removeReceiveOnCancel($this, cancellable_2_2, receive_4);
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }var result_5 = $this.pollInternal_0_k$();
        if (result_5 instanceof Closed) {
          receive_4.resumeReceiveClosed_tt36wi_k$(result_5);
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
        }
        if (!(result_5 === POLL_FAILED)) {
          var tmp_0 = receive_4.resumeValue_2bq_k$((result_5 == null ? true : isObject(result_5)) ? result_5 : THROW_CCE());
          cancellable_2_2.resume_z79gqm_k$(tmp_0, receive_4.resumeOnCancellationFun_2bq_k$((result_5 == null ? true : isObject(result_5)) ? result_5 : THROW_CCE()));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }}
    }
     while (false);
    return cancellable_2_2.getResult_0_k$();
  }
  function enqueueReceive($this, receive) {
    var tmp0_also_0 = $this.enqueueReceiveInternal_a6rukz_k$(receive);
    if (tmp0_also_0)
      $this.onReceiveEnqueued_sv8swh_k$();
    return tmp0_also_0;
  }
  function removeReceiveOnCancel($this, cont, receive) {
    var tmp0__get_asHandler__0 = new RemoveReceiveOnCancel($this, receive);
    return cont.invokeOnCancellation_aip8gd_k$(tmp0__get_asHandler__0);
  }
  function RemoveReceiveOnCancel($outer, receive) {
    this._$this_7 = $outer;
    BeforeResumeCancelHandler.call(this);
    this._receive = receive;
  }
  RemoveReceiveOnCancel.prototype.invoke_houul8_k$ = function (cause) {
    if (this._receive.remove_0_k$())
      this._$this_7.onReceiveDequeued_sv8swh_k$();
  };
  RemoveReceiveOnCancel.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  RemoveReceiveOnCancel.prototype.toString = function () {
    return '' + 'RemoveReceiveOnCancel[' + this._receive + ']';
  };
  RemoveReceiveOnCancel.$metadata$ = {
    simpleName: 'RemoveReceiveOnCancel',
    kind: 'class',
    interfaces: []
  };
  function ReceiveElement(cont, receiveMode) {
    Receive.call(this);
    this._cont = cont;
    this._receiveMode = receiveMode;
  }
  ReceiveElement.prototype._get_cont__0_k$ = function () {
    return this._cont;
  };
  ReceiveElement.prototype.resumeValue_2bq_k$ = function (value) {
    var tmp0_subject = this._receiveMode;
    return tmp0_subject === 1 ? new ChannelResult(Companion_getInstance_99().success_ifowbi_k$(value)) : value;
  };
  ReceiveElement.prototype.tryResumeReceive_c24eu3_k$ = function (value, otherOp) {
    var tmp = this.resumeValue_2bq_k$(value);
    var tmp0_safe_receiver = otherOp;
    var tmp1_elvis_lhs = this._cont.tryResume_9xx6p8_k$(tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.desc__error, this.resumeOnCancellationFun_2bq_k$(value));
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var token = tmp_0;
    var tmp2_safe_receiver = otherOp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.finishPrepare_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
    return RESUME_TOKEN;
  };
  ReceiveElement.prototype.completeResumeReceive_jxzaet_k$ = function (value) {
    return this._cont.completeResume_wu1lm5_k$(RESUME_TOKEN);
  };
  ReceiveElement.prototype.resumeReceiveClosed_tt36wi_k$ = function (closed) {
    if (this._receiveMode === 1) {
      var tmp0_resume_0 = this._cont;
      var tmp1_resume_0 = Companion_getInstance_99().closed_ja109j_k$(closed._closeCause);
      var tmp0_success_0_1 = Companion_getInstance_3();
      tmp0_resume_0.resumeWith_bnunh2_k$(_Result___init__impl_(new ChannelResult(tmp1_resume_0)));
    } else {
      var tmp2_resumeWithException_0 = this._cont;
      var tmp3_resumeWithException_0 = closed._get_receiveException__0_k$();
      var tmp0_failure_0_1 = Companion_getInstance_3();
      tmp2_resumeWithException_0.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(tmp3_resumeWithException_0)));
    }
  };
  ReceiveElement.prototype.toString = function () {
    return '' + 'ReceiveElement@' + _get_hexAddress_(this) + '[receiveMode=' + this._receiveMode + ']';
  };
  ReceiveElement.$metadata$ = {
    simpleName: 'ReceiveElement',
    kind: 'class',
    interfaces: []
  };
  function ReceiveElementWithUndeliveredHandler(cont, receiveMode, onUndeliveredElement) {
    ReceiveElement.call(this, cont, receiveMode);
    this._onUndeliveredElement = onUndeliveredElement;
  }
  ReceiveElementWithUndeliveredHandler.prototype.resumeOnCancellationFun_2bq_k$ = function (value) {
    return bindCancellationFun(this._onUndeliveredElement, value, this._get_cont__0_k$()._get_context__0_k$());
  };
  ReceiveElementWithUndeliveredHandler.$metadata$ = {
    simpleName: 'ReceiveElementWithUndeliveredHandler',
    kind: 'class',
    interfaces: []
  };
  function AbstractChannel(onUndeliveredElement) {
    AbstractSendChannel.call(this, onUndeliveredElement);
  }
  AbstractChannel.prototype.pollInternal_0_k$ = function () {
    while (true) {
      var tmp0_elvis_lhs = this.takeFirstSendOrPeekClosed_0_k$();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return POLL_FAILED;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var send = tmp;
      var token = send.tryResumeSend_bnu8a3_k$(null);
      if (!(token == null)) {
        send.completeResumeSend_sv8swh_k$();
        return send._get_pollResult__0_k$();
      }send.undeliveredElement_sv8swh_k$();
    }
  };
  AbstractChannel.prototype._get_isClosedForReceive__0_k$ = function () {
    return !(this._get_closedForReceive__0_k$() == null) ? this._get_isBufferEmpty__0_k$() : false;
  };
  AbstractChannel.prototype.receive_0_k$ = function ($cont) {
    var result = this.pollInternal_0_k$();
    var tmp;
    if (!(result === POLL_FAILED)) {
      tmp = !(result instanceof Closed);
    } else {
      tmp = false;
    }
    if (tmp) {
      return (result == null ? true : isObject(result)) ? result : THROW_CCE();
    } else {
    }
    return receiveSuspend(this, 0, $cont);
  };
  AbstractChannel.prototype.enqueueReceiveInternal_a6rukz_k$ = function (receive) {
    var tmp;
    if (this._get_isBufferAlwaysEmpty__0_k$()) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_addLastIfPrev_0 = this._get_queue__0_k$();
        var tmp1__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
        if (!!(tmp1__anonymous__1 instanceof Send)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
        tmp0_addLastIfPrev_0.addLast_qdrmxw_k$(receive);
        tmp$ret$0 = true;
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp2_addLastIfPrevAndIf_0 = this._get_queue__0_k$();
        var tmp3__anonymous__1 = tmp2_addLastIfPrevAndIf_0.__prev;
        if (!!(tmp3__anonymous__1 instanceof Send)) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        if (!this._get_isBufferEmpty__0_k$()) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        tmp2_addLastIfPrevAndIf_0.addLast_qdrmxw_k$(receive);
        tmp$ret$2 = true;
      }
       while (false);
      tmp = tmp$ret$2;
    }
    return tmp;
  };
  AbstractChannel.prototype.receiveCatching_e9ymgp_k$ = function ($cont) {
    var result = this.pollInternal_0_k$();
    if (!(result === POLL_FAILED)) {
      var tmp;
      if (result instanceof Closed) {
        tmp = Companion_getInstance_99().closed_ja109j_k$(result._closeCause);
      } else {
        {
          var tmp_0 = Companion_getInstance_99();
          tmp = tmp_0.success_ifowbi_k$((result == null ? true : isObject(result)) ? result : THROW_CCE());
        }
      }
      return tmp;
    }var tmp_1 = receiveSuspend(this, 1, $cont);
    if (tmp_1 === _get_COROUTINE_SUSPENDED_())
      return tmp_1;
    return tmp_1._holder;
  };
  AbstractChannel.prototype.cancel_fnv408_k$ = function (cause) {
    if (this._get_isClosedForReceive__0_k$())
      return Unit_getInstance();
    var tmp0_elvis_lhs = cause;
    this.cancelInternal_h62ekz_k$(tmp0_elvis_lhs == null ? CancellationException_init_$Create$('' + _get_classSimpleName_(this) + ' was cancelled') : tmp0_elvis_lhs);
    Unit_getInstance();
  };
  AbstractChannel.prototype.cancelInternal_h62ekz_k$ = function (cause) {
    var tmp0_also_0 = this.close_h62ekz_k$(cause);
    this.onCancelIdempotent_rpwsgn_k$(tmp0_also_0);
    return tmp0_also_0;
  };
  AbstractChannel.prototype.onCancelIdempotent_rpwsgn_k$ = function (wasClosed) {
    var tmp0_elvis_lhs = this._get_closedForSend__0_k$();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Cannot happen');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var closed = tmp;
    var list = _InlineList___init__impl__0(null, 1, null);
    $l$break: while (true) {
      var previous = closed.__prev;
      if (previous instanceof LinkedListHead) {
        break $l$break;
      } else {
      }
      if (!previous.remove_0_k$()) {
        previous.helpRemove_sv8swh_k$();
        continue $l$break;
      }var tmp_0 = list;
      list = InlineList__plus_impl(tmp_0, previous instanceof Send ? previous : THROW_CCE());
    }
    this.onCancelIdempotentList_x8is0l_k$(list, closed);
  };
  AbstractChannel.prototype.onCancelIdempotentList_x8is0l_k$ = function (list, closed) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_subject_1 = _get_holder_(list);
      if (tmp0_subject_1 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        if (!(tmp0_subject_1 instanceof ArrayList)) {
          var tmp = _get_holder_(list);
          var tmp0__anonymous__5 = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
          tmp0__anonymous__5.resumeSendClosed_tt36wi_k$(closed);
        } else {
          {
            var tmp_0 = _get_holder_(list);
            var list_2 = tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE();
            var inductionVariable = list_2._get_size__0_k$() - 1 | 0;
            if (0 <= inductionVariable)
              do {
                var i_4 = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                var tmp1__anonymous__5 = list_2.get_ha5a7z_k$(i_4);
                tmp1__anonymous__5.resumeSendClosed_tt36wi_k$(closed);
              }
               while (0 <= inductionVariable);
          }
        }
      }
    }
     while (false);
  };
  AbstractChannel.prototype.takeFirstReceiveOrPeekClosed_0_k$ = function () {
    var tmp0_also_0 = AbstractSendChannel.prototype.takeFirstReceiveOrPeekClosed_0_k$.call(this);
    var tmp;
    if (!(tmp0_also_0 == null)) {
      tmp = !(tmp0_also_0 instanceof Closed);
    } else {
      tmp = false;
    }
    if (tmp)
      this.onReceiveDequeued_sv8swh_k$();
    else {
    }
    return tmp0_also_0;
  };
  AbstractChannel.prototype.onReceiveEnqueued_sv8swh_k$ = function () {
  };
  AbstractChannel.prototype.onReceiveDequeued_sv8swh_k$ = function () {
  };
  AbstractChannel.$metadata$ = {
    simpleName: 'AbstractChannel',
    kind: 'class',
    interfaces: [Channel]
  };
  function _get_isFullImpl_($this) {
    var tmp;
    var tmp0__get_nextNode__0 = $this._queue;
    var tmp_0 = tmp0__get_nextNode__0.__next;
    if (!isInterface(tmp_0, ReceiveOrClosed)) {
      tmp = $this._get_isBufferFull__0_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  }
  function sendSuspend($this, element, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = getOrCreateCancellableContinuation(intercepted(tmp0__anonymous__1_1));
    var tmp$ret$0;
    l$ret$1: do {
      loop: while (true) {
        if (_get_isFullImpl_($this)) {
          var send_4 = $this._onUndeliveredElement_0 == null ? new SendElement(element, cancellable_2_2) : new SendElementWithUndeliveredHandler(element, cancellable_2_2, $this._onUndeliveredElement_0);
          var enqueueResult_5 = $this.enqueueSend_hwdu4p_k$(send_4);
          if (enqueueResult_5 == null) {
            removeOnCancellation(cancellable_2_2, send_4);
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          } else {
            if (enqueueResult_5 instanceof Closed) {
              helpCloseAndResumeWithSendException(cancellable_2_2, $this, element, enqueueResult_5);
              tmp$ret$0 = Unit_getInstance();
              break l$ret$1;
            } else {
              if (enqueueResult_5 === ENQUEUE_FAILED) {
              } else {
                if (enqueueResult_5 instanceof Receive) {
                } else {
                  {
                    var tmp0_error_0_6 = '' + 'enqueueSend returned ' + enqueueResult_5;
                    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_6));
                  }
                }
              }
            }
          }
        }var offerResult_7 = $this.offerInternal_2bq_k$(element);
        if (offerResult_7 === OFFER_SUCCESS) {
          var tmp0_success_0_1_8 = Companion_getInstance_3();
          cancellable_2_2.resumeWith_bnunh2_k$(_Result___init__impl_(Unit_getInstance()));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          if (offerResult_7 === OFFER_FAILED)
            continue loop;
          else {
            if (offerResult_7 instanceof Closed) {
              helpCloseAndResumeWithSendException(cancellable_2_2, $this, element, offerResult_7);
              tmp$ret$0 = Unit_getInstance();
              break l$ret$1;
            } else {
              {
                var tmp1_error_0_9 = '' + 'offerInternal returned ' + offerResult_7;
                throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0_9));
              }
            }
          }
        }
      }
    }
     while (false);
    return cancellable_2_2.getResult_0_k$();
  }
  function helpCloseAndResumeWithSendException(_this_, $this, element, closed) {
    helpClose($this, closed);
    var sendException = closed._get_sendException__0_k$();
    var tmp0_safe_receiver = $this._onUndeliveredElement_0;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = callUndeliveredElementCatchingException$default(tmp0_safe_receiver, element, null, 2, null);
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      addSuppressed(tmp1_safe_receiver, sendException);
      var tmp0_failure_0_1_2 = Companion_getInstance_3();
      _this_.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(tmp1_safe_receiver)));
      return Unit_getInstance();
    }
    Unit_getInstance();
    var tmp0_failure_0_1 = Companion_getInstance_3();
    _this_.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(sendException)));
  }
  function invokeOnCloseHandler($this, cause) {
    var handler = $this._onCloseHandler._value_5;
    if ((!(handler === null) ? !(handler === HANDLER_INVOKED) : false) ? $this._onCloseHandler.atomicfu$compareAndSet(handler, HANDLER_INVOKED) : false) {
      ((!(handler == null) ? typeof handler === 'function' : false) ? handler : THROW_CCE())(cause);
    }}
  function helpClose($this, closed) {
    var closedList = _InlineList___init__impl__0(null, 1, null);
    $l$break: while (true) {
      var tmp = closed.__prev;
      var tmp0_elvis_lhs = tmp instanceof Receive ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$break;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var previous = tmp_0;
      if (!previous.remove_0_k$()) {
        previous.helpRemove_sv8swh_k$();
        continue $l$break;
      }closedList = InlineList__plus_impl(closedList, previous);
    }
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_forEachReversed_0 = closedList;
      var tmp0_subject_1 = _get_holder_(tmp0_forEachReversed_0);
      if (tmp0_subject_1 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        if (!(tmp0_subject_1 instanceof ArrayList)) {
          var tmp_1 = _get_holder_(tmp0_forEachReversed_0);
          var tmp1__anonymous__5 = (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE();
          tmp1__anonymous__5.resumeReceiveClosed_tt36wi_k$(closed);
        } else {
          {
            var tmp_2 = _get_holder_(tmp0_forEachReversed_0);
            var list_2 = tmp_2 instanceof ArrayList ? tmp_2 : THROW_CCE();
            var inductionVariable = list_2._get_size__0_k$() - 1 | 0;
            if (0 <= inductionVariable)
              do {
                var i_4 = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                var tmp2__anonymous__5 = list_2.get_ha5a7z_k$(i_4);
                tmp2__anonymous__5.resumeReceiveClosed_tt36wi_k$(closed);
              }
               while (0 <= inductionVariable);
          }
        }
      }
    }
     while (false);
    $this.onClosedIdempotent_qdrmxw_k$(closed);
  }
  function _get_queueDebugStateString_($this) {
    var tmp0__get_nextNode__0 = $this._queue;
    var head = tmp0__get_nextNode__0.__next;
    if (head === $this._queue)
      return 'EmptyQueue';
    var tmp0_subject = head;
    var tmp;
    if (tmp0_subject instanceof Closed) {
      tmp = toString_1(head);
    } else {
      if (tmp0_subject instanceof Receive) {
        tmp = 'ReceiveQueued';
      } else {
        if (tmp0_subject instanceof Send) {
          tmp = 'SendQueued';
        } else {
          {
            tmp = '' + 'UNEXPECTED:' + head;
          }
        }
      }
    }
    var result = tmp;
    var tmp1__get_prevNode__0 = $this._queue;
    var tail = tmp1__get_prevNode__0.__prev;
    if (!(tail === head)) {
      result = result + ('' + ',queueSize=' + countQueueSize($this));
      if (tail instanceof Closed)
        result = result + ('' + ',closedForSend=' + tail);
      else {
      }
    }return result;
  }
  function countQueueSize($this) {
    var size_2 = 0;
    var tmp0_forEach_0 = $this._queue;
    var cur_1 = tmp0_forEach_0._get__next__0_k$();
    while (!equals_1(cur_1, tmp0_forEach_0)) {
      if (cur_1 instanceof LinkedListNode) {
        var tmp1__anonymous__2 = cur_1;
        var tmp0_3 = size_2;
        size_2 = tmp0_3 + 1 | 0;
        Unit_getInstance();
      } else {
      }
      cur_1 = cur_1.__next;
    }
    return size_2;
  }
  function SendBuffered(element) {
    Send.call(this);
    this._element_0 = element;
  }
  SendBuffered.prototype._get_pollResult__0_k$ = function () {
    return this._element_0;
  };
  SendBuffered.prototype.tryResumeSend_bnu8a3_k$ = function (otherOp) {
    var tmp0_also_0 = RESUME_TOKEN;
    var tmp0_safe_receiver_2 = otherOp;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.finishPrepare_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_also_0;
  };
  SendBuffered.prototype.completeResumeSend_sv8swh_k$ = function () {
  };
  SendBuffered.prototype.resumeSendClosed_tt36wi_k$ = function (closed) {
  };
  SendBuffered.prototype.toString = function () {
    return '' + 'SendBuffered@' + _get_hexAddress_(this) + '(' + this._element_0 + ')';
  };
  SendBuffered.$metadata$ = {
    simpleName: 'SendBuffered',
    kind: 'class',
    interfaces: []
  };
  function AbstractSendChannel(onUndeliveredElement) {
    this._onUndeliveredElement_0 = onUndeliveredElement;
    this._queue = new LinkedListHead();
    this._onCloseHandler = atomic(null);
  }
  AbstractSendChannel.prototype._get_onUndeliveredElement__0_k$ = function () {
    return this._onUndeliveredElement_0;
  };
  AbstractSendChannel.prototype._get_queue__0_k$ = function () {
    return this._queue;
  };
  AbstractSendChannel.prototype.offerInternal_2bq_k$ = function (element) {
    while (true) {
      var tmp0_elvis_lhs = this.takeFirstReceiveOrPeekClosed_0_k$();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return OFFER_FAILED;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var receive = tmp;
      var token = receive.tryResumeReceive_c24eu3_k$(element, null);
      if (!(token == null)) {
        receive.completeResumeReceive_jxzaet_k$(element);
        return receive._get_offerResult__0_k$();
      }}
  };
  AbstractSendChannel.prototype._get_closedForSend__0_k$ = function () {
    var tmp0__get_prevNode__0 = this._queue;
    var tmp = tmp0__get_prevNode__0.__prev;
    var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      helpClose(this, tmp0_safe_receiver);
      tmp_0 = tmp0_safe_receiver;
    }
    return tmp_0;
  };
  AbstractSendChannel.prototype._get_closedForReceive__0_k$ = function () {
    var tmp0__get_nextNode__0 = this._queue;
    var tmp = tmp0__get_nextNode__0.__next;
    var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      helpClose(this, tmp0_safe_receiver);
      tmp_0 = tmp0_safe_receiver;
    }
    return tmp_0;
  };
  AbstractSendChannel.prototype.takeFirstSendOrPeekClosed_0_k$ = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_removeFirstIfIsInstanceOfOrPeekIf_0 = this._queue;
      var next_1 = tmp1_removeFirstIfIsInstanceOfOrPeekIf_0.__next;
      if (next_1 === tmp1_removeFirstIfIsInstanceOfOrPeekIf_0) {
        tmp$ret$0 = null;
        break l$ret$1;
      }if (!(next_1 instanceof Send)) {
        tmp$ret$0 = null;
        break l$ret$1;
      } else {
      }
      var tmp2__anonymous__3 = next_1;
      if (tmp2__anonymous__3 instanceof Closed) {
        tmp$ret$0 = next_1;
        break l$ret$1;
      } else {
      }
      var tmp0_check_0 = next_1.remove_0_k$();
      if (!tmp0_check_0) {
        var message_1 = 'Should remove';
        throw IllegalStateException_init_$Create$_0(toString_1(message_1));
      }tmp$ret$0 = next_1;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractSendChannel.prototype.sendBuffered_2bq_k$ = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_addLastIfPrev_0 = this._queue;
      var tmp1_addLastIfPrev_0 = new SendBuffered(element);
      var tmp2__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
      if (isInterface(tmp2__anonymous__1, ReceiveOrClosed))
        return tmp2__anonymous__1;
      else {
      }
      if (!true) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      tmp0_addLastIfPrev_0.addLast_qdrmxw_k$(tmp1_addLastIfPrev_0);
      tmp$ret$0 = true;
    }
     while (false);
    Unit_getInstance();
    return null;
  };
  AbstractSendChannel.prototype.send_jxzaet_k$ = function (element, $cont) {
    if (this.offerInternal_2bq_k$(element) === OFFER_SUCCESS)
      return Unit_getInstance();
    return sendSuspend(this, element, $cont);
  };
  AbstractSendChannel.prototype.enqueueSend_hwdu4p_k$ = function (send) {
    if (this._get_isBufferAlwaysFull__0_k$()) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_addLastIfPrev_0 = this._queue;
        var tmp1__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
        if (isInterface(tmp1__anonymous__1, ReceiveOrClosed))
          return tmp1__anonymous__1;
        else {
        }
        if (!true) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
        tmp0_addLastIfPrev_0.addLast_qdrmxw_k$(send);
        tmp$ret$0 = true;
      }
       while (false);
      Unit_getInstance();
    } else {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp2_addLastIfPrevAndIf_0 = this._queue;
        var tmp3__anonymous__1 = tmp2_addLastIfPrevAndIf_0.__prev;
        if (isInterface(tmp3__anonymous__1, ReceiveOrClosed))
          return tmp3__anonymous__1;
        else {
        }
        if (!true) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        if (!this._get_isBufferFull__0_k$()) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        tmp2_addLastIfPrevAndIf_0.addLast_qdrmxw_k$(send);
        tmp$ret$2 = true;
      }
       while (false);
      if (!tmp$ret$2)
        return ENQUEUE_FAILED;
      else {
      }
    }
    return null;
  };
  AbstractSendChannel.prototype.close_h62ekz_k$ = function (cause) {
    var closed = new Closed(cause);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_addLastIfPrev_0 = this._queue;
      var tmp1__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
      if (!!(tmp1__anonymous__1 instanceof Closed)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      tmp0_addLastIfPrev_0.addLast_qdrmxw_k$(closed);
      tmp$ret$0 = true;
    }
     while (false);
    var closeAdded = tmp$ret$0;
    var tmp;
    if (closeAdded) {
      tmp = closed;
    } else {
      var tmp2__get_prevNode__0 = this._queue;
      var tmp_0 = tmp2__get_prevNode__0.__prev;
      tmp = tmp_0 instanceof Closed ? tmp_0 : THROW_CCE();
    }
    var actuallyClosed = tmp;
    helpClose(this, actuallyClosed);
    if (closeAdded)
      invokeOnCloseHandler(this, cause);
    return closeAdded;
  };
  AbstractSendChannel.prototype.onClosedIdempotent_qdrmxw_k$ = function (closed) {
  };
  AbstractSendChannel.prototype.takeFirstReceiveOrPeekClosed_0_k$ = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_removeFirstIfIsInstanceOfOrPeekIf_0 = this._queue;
      var next_1 = tmp1_removeFirstIfIsInstanceOfOrPeekIf_0.__next;
      if (next_1 === tmp1_removeFirstIfIsInstanceOfOrPeekIf_0) {
        tmp$ret$0 = null;
        break l$ret$1;
      }if (!isInterface(next_1, ReceiveOrClosed)) {
        tmp$ret$0 = null;
        break l$ret$1;
      } else {
      }
      var tmp2__anonymous__3 = next_1;
      if (tmp2__anonymous__3 instanceof Closed) {
        tmp$ret$0 = next_1;
        break l$ret$1;
      } else {
      }
      var tmp0_check_0 = next_1.remove_0_k$();
      if (!tmp0_check_0) {
        var message_1 = 'Should remove';
        throw IllegalStateException_init_$Create$_0(toString_1(message_1));
      }tmp$ret$0 = next_1;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractSendChannel.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '{' + _get_queueDebugStateString_(this) + '}' + this._get_bufferDebugString__0_k$();
  };
  AbstractSendChannel.prototype._get_bufferDebugString__0_k$ = function () {
    return '';
  };
  AbstractSendChannel.$metadata$ = {
    simpleName: 'AbstractSendChannel',
    kind: 'class',
    interfaces: [SendChannel]
  };
  function Send() {
    LinkedListNode.call(this);
  }
  Send.prototype.undeliveredElement_sv8swh_k$ = function () {
  };
  Send.$metadata$ = {
    simpleName: 'Send',
    kind: 'class',
    interfaces: []
  };
  function ReceiveOrClosed() {
  }
  ReceiveOrClosed.$metadata$ = {
    simpleName: 'ReceiveOrClosed',
    kind: 'interface',
    interfaces: []
  };
  function Closed(closeCause) {
    Send.call(this);
    this._closeCause = closeCause;
  }
  Closed.prototype._get_sendException__0_k$ = function () {
    var tmp0_elvis_lhs = this._closeCause;
    return tmp0_elvis_lhs == null ? new ClosedSendChannelException('Channel was closed') : tmp0_elvis_lhs;
  };
  Closed.prototype._get_receiveException__0_k$ = function () {
    var tmp0_elvis_lhs = this._closeCause;
    return tmp0_elvis_lhs == null ? new ClosedReceiveChannelException('Channel was closed') : tmp0_elvis_lhs;
  };
  Closed.prototype._get_offerResult__0_k$ = function () {
    return this;
  };
  Closed.prototype._get_pollResult__0_k$ = function () {
    return this;
  };
  Closed.prototype.tryResumeSend_bnu8a3_k$ = function (otherOp) {
    var tmp0_also_0 = RESUME_TOKEN;
    var tmp0_safe_receiver_2 = otherOp;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.finishPrepare_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_also_0;
  };
  Closed.prototype.completeResumeSend_sv8swh_k$ = function () {
  };
  Closed.prototype.tryResumeReceive_c24eu3_k$ = function (value, otherOp) {
    var tmp0_also_0 = RESUME_TOKEN;
    var tmp0_safe_receiver_2 = otherOp;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.finishPrepare_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_also_0;
  };
  Closed.prototype.completeResumeReceive_jxzaet_k$ = function (value) {
  };
  Closed.prototype.resumeSendClosed_tt36wi_k$ = function (closed) {
    return Unit_getInstance();
  };
  Closed.prototype.toString = function () {
    return '' + 'Closed@' + _get_hexAddress_(this) + '[' + this._closeCause + ']';
  };
  Closed.$metadata$ = {
    simpleName: 'Closed',
    kind: 'class',
    interfaces: [ReceiveOrClosed]
  };
  function Receive() {
    LinkedListNode.call(this);
  }
  Receive.prototype._get_offerResult__0_k$ = function () {
    return OFFER_SUCCESS;
  };
  Receive.prototype.resumeOnCancellationFun_2bq_k$ = function (value) {
    return null;
  };
  Receive.$metadata$ = {
    simpleName: 'Receive',
    kind: 'class',
    interfaces: [ReceiveOrClosed]
  };
  function SendElement(pollResult, cont) {
    Send.call(this);
    this._pollResult = pollResult;
    this._cont_0 = cont;
  }
  SendElement.prototype._get_pollResult__0_k$ = function () {
    return this._pollResult;
  };
  SendElement.prototype._get_cont__0_k$ = function () {
    return this._cont_0;
  };
  SendElement.prototype.tryResumeSend_bnu8a3_k$ = function (otherOp) {
    var tmp0_safe_receiver = otherOp;
    var tmp1_elvis_lhs = this._cont_0.tryResume_ww5y96_k$(Unit_getInstance(), tmp0_safe_receiver == null ? null : tmp0_safe_receiver.desc__error);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var token = tmp;
    var tmp2_safe_receiver = otherOp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.finishPrepare_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
    return RESUME_TOKEN;
  };
  SendElement.prototype.completeResumeSend_sv8swh_k$ = function () {
    return this._cont_0.completeResume_wu1lm5_k$(RESUME_TOKEN);
  };
  SendElement.prototype.resumeSendClosed_tt36wi_k$ = function (closed) {
    var tmp0_resumeWithException_0 = this._cont_0;
    var tmp1_resumeWithException_0 = closed._get_sendException__0_k$();
    var tmp0_failure_0_1 = Companion_getInstance_3();
    return tmp0_resumeWithException_0.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(tmp1_resumeWithException_0)));
  };
  SendElement.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '(' + this._get_pollResult__0_k$() + ')';
  };
  SendElement.$metadata$ = {
    simpleName: 'SendElement',
    kind: 'class',
    interfaces: []
  };
  function SendElementWithUndeliveredHandler(pollResult, cont, onUndeliveredElement) {
    SendElement.call(this, pollResult, cont);
    this._onUndeliveredElement_1 = onUndeliveredElement;
  }
  SendElementWithUndeliveredHandler.prototype.remove_0_k$ = function () {
    if (!SendElement.prototype.remove_0_k$.call(this))
      return false;
    this.undeliveredElement_sv8swh_k$();
    return true;
  };
  SendElementWithUndeliveredHandler.prototype.undeliveredElement_sv8swh_k$ = function () {
    callUndeliveredElement(this._onUndeliveredElement_1, this._get_pollResult__0_k$(), this._get_cont__0_k$()._get_context__0_k$());
  };
  SendElementWithUndeliveredHandler.$metadata$ = {
    simpleName: 'SendElementWithUndeliveredHandler',
    kind: 'class',
    interfaces: []
  };
  function updateBufferSize($this, currentSize) {
    if (currentSize < $this._capacity_1) {
      $this._size_8._value_7 = currentSize + 1 | 0;
      return null;
    }var tmp0_subject = $this._onBufferOverflow;
    var tmp;
    if (tmp0_subject.equals(BufferOverflow_SUSPEND_getInstance())) {
      tmp = OFFER_FAILED;
    } else if (tmp0_subject.equals(BufferOverflow_DROP_LATEST_getInstance())) {
      tmp = OFFER_SUCCESS;
    } else if (tmp0_subject.equals(BufferOverflow_DROP_OLDEST_getInstance())) {
      tmp = null;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function enqueueElement($this, currentSize, element) {
    if (currentSize < $this._capacity_1) {
      ensureCapacity($this, currentSize);
      $this._buffer_4[($this._head_0 + currentSize | 0) % $this._buffer_4.length] = element;
    } else {
      $this._buffer_4[$this._head_0 % $this._buffer_4.length] = null;
      $this._buffer_4[($this._head_0 + currentSize | 0) % $this._buffer_4.length] = element;
      $this._head_0 = ($this._head_0 + 1 | 0) % $this._buffer_4.length;
    }
  }
  function ensureCapacity($this, currentSize) {
    if (currentSize >= $this._buffer_4.length) {
      var tmp0_min_0 = imul($this._buffer_4.length, 2);
      var tmp1_min_0 = $this._capacity_1;
      var newSize = Math.min(tmp0_min_0, tmp1_min_0);
      var newBuffer = fillArrayVal(Array(newSize), null);
      var inductionVariable = 0;
      if (inductionVariable < currentSize)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          newBuffer[i] = $this._buffer_4[($this._head_0 + i | 0) % $this._buffer_4.length];
        }
         while (inductionVariable < currentSize);
      fill_1(newBuffer, EMPTY, currentSize, newSize);
      $this._buffer_4 = newBuffer;
      $this._head_0 = 0;
    }}
  function ArrayChannel(capacity, onBufferOverflow, onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
    this._capacity_1 = capacity;
    this._onBufferOverflow = onBufferOverflow;
    var tmp0_require_0 = this._capacity_1 >= 1;
    if (!tmp0_require_0) {
      var message_1 = '' + 'ArrayChannel capacity must be at least 1, but ' + this._capacity_1 + ' was specified';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }this._lock = new NoOpLock();
    var tmp = this;
    var tmp0_min_0 = this._capacity_1;
    var tmp1_arrayOfNulls_0 = Math.min(tmp0_min_0, 8);
    var tmp2_apply_0 = fillArrayVal(Array(tmp1_arrayOfNulls_0), null);
    fill$default(tmp2_apply_0, EMPTY, 0, 0, 6, null);
    tmp._buffer_4 = tmp2_apply_0;
    this._head_0 = 0;
    this._size_8 = atomic_1(0);
  }
  ArrayChannel.prototype._get_isBufferAlwaysEmpty__0_k$ = function () {
    return false;
  };
  ArrayChannel.prototype._get_isBufferEmpty__0_k$ = function () {
    return this._size_8._value_7 === 0;
  };
  ArrayChannel.prototype._get_isBufferAlwaysFull__0_k$ = function () {
    return false;
  };
  ArrayChannel.prototype._get_isBufferFull__0_k$ = function () {
    return this._size_8._value_7 === this._capacity_1 ? this._onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) : false;
  };
  ArrayChannel.prototype._get_isClosedForReceive__0_k$ = function () {
    var tmp0_withLock_0 = this._lock;
    return AbstractChannel.prototype._get_isClosedForReceive__0_k$.call(this);
  };
  ArrayChannel.prototype.offerInternal_2bq_k$ = function (element) {
    var receive = null;
    var tmp0_withLock_0 = this._lock;
    var tmp$ret$0;
    l$ret$1: do {
      var size_2 = this._size_8._value_7;
      var tmp0_safe_receiver_3 = this._get_closedForSend__0_k$();
      if (tmp0_safe_receiver_3 == null)
        null;
      else {
        return tmp0_safe_receiver_3;
      }
      Unit_getInstance();
      var tmp1_safe_receiver_4 = updateBufferSize(this, size_2);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        return tmp1_safe_receiver_4;
      }
      Unit_getInstance();
      if (size_2 === 0) {
        loop: while (true) {
          var tmp2_elvis_lhs_5 = this.takeFirstReceiveOrPeekClosed_0_k$();
          var tmp;
          if (tmp2_elvis_lhs_5 == null) {
            break loop;
          } else {
            tmp = tmp2_elvis_lhs_5;
          }
          receive = tmp;
          if (receive instanceof Closed) {
            this._size_8._value_7 = size_2;
            return ensureNotNull(receive);
          } else {
          }
          var token_6 = ensureNotNull(receive).tryResumeReceive_c24eu3_k$(element, null);
          if (!(token_6 == null)) {
            this._size_8._value_7 = size_2;
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }}
      }enqueueElement(this, size_2, element);
      return OFFER_SUCCESS;
    }
     while (false);
    ensureNotNull(receive).completeResumeReceive_jxzaet_k$(element);
    return ensureNotNull(receive)._get_offerResult__0_k$();
  };
  ArrayChannel.prototype.enqueueSend_hwdu4p_k$ = function (send) {
    var tmp0_withLock_0 = this._lock;
    return AbstractChannel.prototype.enqueueSend_hwdu4p_k$.call(this, send);
  };
  ArrayChannel.prototype.pollInternal_0_k$ = function () {
    var send = null;
    var resumed = false;
    var result = null;
    var tmp0_withLock_0 = this._lock;
    var size_2 = this._size_8._value_7;
    if (size_2 === 0) {
      var tmp0_elvis_lhs_3 = this._get_closedForSend__0_k$();
      return tmp0_elvis_lhs_3 == null ? POLL_FAILED : tmp0_elvis_lhs_3;
    }result = this._buffer_4[this._head_0];
    this._buffer_4[this._head_0] = null;
    this._size_8._value_7 = size_2 - 1 | 0;
    var replacement_4 = POLL_FAILED;
    if (size_2 === this._capacity_1) {
      loop: while (true) {
        var tmp1_elvis_lhs_5 = this.takeFirstSendOrPeekClosed_0_k$();
        var tmp;
        if (tmp1_elvis_lhs_5 == null) {
          break loop;
        } else {
          tmp = tmp1_elvis_lhs_5;
        }
        send = tmp;
        var token_6 = ensureNotNull(send).tryResumeSend_bnu8a3_k$(null);
        if (!(token_6 == null)) {
          resumed = true;
          replacement_4 = ensureNotNull(send)._get_pollResult__0_k$();
          break loop;
        }ensureNotNull(send).undeliveredElement_sv8swh_k$();
      }
    }var tmp_0;
    if (!(replacement_4 === POLL_FAILED)) {
      tmp_0 = !(replacement_4 instanceof Closed);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      this._size_8._value_7 = size_2;
      this._buffer_4[(this._head_0 + size_2 | 0) % this._buffer_4.length] = replacement_4;
    } else {
    }
    this._head_0 = (this._head_0 + 1 | 0) % this._buffer_4.length;
    if (resumed)
      ensureNotNull(send).completeResumeSend_sv8swh_k$();
    return result;
  };
  ArrayChannel.prototype.enqueueReceiveInternal_a6rukz_k$ = function (receive) {
    var tmp0_withLock_0 = this._lock;
    return AbstractChannel.prototype.enqueueReceiveInternal_a6rukz_k$.call(this, receive);
  };
  ArrayChannel.prototype.onCancelIdempotent_rpwsgn_k$ = function (wasClosed) {
    var onUndeliveredElement = this._get_onUndeliveredElement__0_k$();
    var undeliveredElementException = null;
    var tmp0_withLock_0 = this._lock;
    var tmp0_repeat_0_2 = this._size_8._value_7;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0_2)
      do {
        var index_2_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var value_4_5 = this._buffer_4[this._head_0];
        if (!(onUndeliveredElement == null) ? !(value_4_5 === EMPTY) : false) {
          undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, (value_4_5 == null ? true : isObject(value_4_5)) ? value_4_5 : THROW_CCE(), undeliveredElementException);
        }this._buffer_4[this._head_0] = EMPTY;
        this._head_0 = (this._head_0 + 1 | 0) % this._buffer_4.length;
      }
       while (inductionVariable < tmp0_repeat_0_2);
    this._size_8._value_7 = 0;
    AbstractChannel.prototype.onCancelIdempotent_rpwsgn_k$.call(this, wasClosed);
    var tmp0_safe_receiver = undeliveredElementException;
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  };
  ArrayChannel.prototype._get_bufferDebugString__0_k$ = function () {
    return '' + '(buffer:capacity=' + this._capacity_1 + ',size=' + this._size_8._value_7 + ')';
  };
  ArrayChannel.$metadata$ = {
    simpleName: 'ArrayChannel',
    kind: 'class',
    interfaces: []
  };
  var BufferOverflow_SUSPEND_instance;
  var BufferOverflow_DROP_OLDEST_instance;
  var BufferOverflow_DROP_LATEST_instance;
  var BufferOverflow_entriesInitialized;
  function BufferOverflow_initEntries() {
    if (BufferOverflow_entriesInitialized)
      return Unit_getInstance();
    BufferOverflow_entriesInitialized = true;
    BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
    BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
    BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
  }
  function BufferOverflow(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  BufferOverflow.$metadata$ = {
    simpleName: 'BufferOverflow',
    kind: 'class',
    interfaces: []
  };
  function BufferOverflow_SUSPEND_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_SUSPEND_instance;
  }
  function BufferOverflow_DROP_OLDEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_OLDEST_instance;
  }
  function BufferOverflow_DROP_LATEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_LATEST_instance;
  }
  function ReceiveChannel() {
  }
  ReceiveChannel.$metadata$ = {
    simpleName: 'ReceiveChannel',
    kind: 'interface',
    interfaces: []
  };
  function Factory() {
    Factory_instance = this;
    this._UNLIMITED = 2147483647;
    this._RENDEZVOUS = 0;
    this._CONFLATED = -1;
    this._BUFFERED = -2;
    this._OPTIONAL_CHANNEL = -3;
    this._DEFAULT_BUFFER_PROPERTY_NAME = 'kotlinx.coroutines.channels.defaultBuffer';
    this._CHANNEL_DEFAULT_CAPACITY = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
  }
  Factory.$metadata$ = {
    simpleName: 'Factory',
    kind: 'object',
    interfaces: []
  };
  var Factory_instance;
  function Factory_getInstance() {
    if (Factory_instance == null)
      new Factory();
    return Factory_instance;
  }
  function Channel() {
  }
  Channel.$metadata$ = {
    simpleName: 'Channel',
    kind: 'interface',
    interfaces: [SendChannel, ReceiveChannel]
  };
  function Channel_0(capacity, onBufferOverflow, onUndeliveredElement) {
    var tmp0_subject = capacity;
    var tmp;
    Factory_getInstance();
    if (tmp0_subject === 0) {
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new RendezvousChannel(onUndeliveredElement) : new ArrayChannel(1, onBufferOverflow, onUndeliveredElement);
    } else {
      Factory_getInstance();
      if (tmp0_subject === -1) {
        var tmp0_require_0 = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance());
        if (!tmp0_require_0) {
          var message_1 = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
          throw IllegalArgumentException_init_$Create$(toString_1(message_1));
        }tmp = new ConflatedChannel(onUndeliveredElement);
      } else {
        Factory_getInstance();
        if (tmp0_subject === 2147483647) {
          tmp = new LinkedListChannel(onUndeliveredElement);
        } else {
          Factory_getInstance();
          if (tmp0_subject === -2) {
            tmp = new ArrayChannel(onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? Factory_getInstance()._CHANNEL_DEFAULT_CAPACITY : 1, onBufferOverflow, onUndeliveredElement);
          } else {
            {
              tmp = (capacity === 1 ? onBufferOverflow.equals(BufferOverflow_DROP_OLDEST_getInstance()) : false) ? new ConflatedChannel(onUndeliveredElement) : new ArrayChannel(capacity, onBufferOverflow, onUndeliveredElement);
            }
          }
        }
      }
    }
    return tmp;
  }
  function Channel$default(capacity, onBufferOverflow, onUndeliveredElement, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      Factory_getInstance();
      capacity = 0;
    }if (!(($mask0 & 2) === 0))
      onBufferOverflow = BufferOverflow_SUSPEND_getInstance();
    if (!(($mask0 & 4) === 0))
      onUndeliveredElement = null;
    return Channel_0(capacity, onBufferOverflow, onUndeliveredElement);
  }
  function _ChannelResult___init__impl_(holder) {
    return holder;
  }
  function _ChannelResult___get_holder__impl_(this_0) {
    return this_0;
  }
  function _ChannelResult___get_isClosed__impl_(this_0) {
    var tmp = _ChannelResult___get_holder__impl_(this_0);
    return tmp instanceof Closed_0;
  }
  function ChannelResult__getOrThrow_impl(this_0) {
    var tmp = _ChannelResult___get_holder__impl_(this_0);
    if (!(tmp instanceof Failed)) {
      var tmp_0 = _ChannelResult___get_holder__impl_(this_0);
      return (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    } else {
    }
    var tmp_1;
    var tmp_2 = _ChannelResult___get_holder__impl_(this_0);
    if (tmp_2 instanceof Closed_0) {
      tmp_1 = !(_ChannelResult___get_holder__impl_(this_0)._cause_0 == null);
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1)
      throw _ChannelResult___get_holder__impl_(this_0)._cause_0;
    else {
    }
    var tmp0_error_0 = '' + "Trying to call 'getOrThrow' on a failed channel result: " + _ChannelResult___get_holder__impl_(this_0);
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  }
  function ChannelResult__exceptionOrNull_impl(this_0) {
    var tmp = _ChannelResult___get_holder__impl_(this_0);
    var tmp0_safe_receiver = tmp instanceof Closed_0 ? tmp : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause_0;
  }
  function Failed() {
  }
  Failed.prototype.toString = function () {
    return 'Failed';
  };
  Failed.$metadata$ = {
    simpleName: 'Failed',
    kind: 'class',
    interfaces: []
  };
  function Closed_0(cause) {
    Failed.call(this);
    this._cause_0 = cause;
  }
  Closed_0.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Closed_0) {
      tmp = equals_1(this._cause_0, other._cause_0);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Closed_0.prototype.hashCode = function () {
    var tmp0_hashCode_0 = this._cause_0;
    var tmp0_safe_receiver_2 = tmp0_hashCode_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    return tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
  };
  Closed_0.prototype.toString = function () {
    return '' + 'Closed(' + this._cause_0 + ')';
  };
  Closed_0.$metadata$ = {
    simpleName: 'Closed',
    kind: 'class',
    interfaces: []
  };
  function Companion_100() {
    Companion_instance_99 = this;
    this._failed = new Failed();
  }
  Companion_100.prototype.success_ifowbi_k$ = function (value) {
    return _ChannelResult___init__impl_(value);
  };
  Companion_100.prototype.closed_ja109j_k$ = function (cause) {
    return _ChannelResult___init__impl_(new Closed_0(cause));
  };
  Companion_100.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_99;
  function Companion_getInstance_99() {
    if (Companion_instance_99 == null)
      new Companion_100();
    return Companion_instance_99;
  }
  function ChannelResult__toString_impl(this_0) {
    var tmp0_subject = _ChannelResult___get_holder__impl_(this_0);
    var tmp;
    if (tmp0_subject instanceof Closed_0) {
      tmp = toString_1(_ChannelResult___get_holder__impl_(this_0));
    } else {
      {
        tmp = '' + 'Value(' + _ChannelResult___get_holder__impl_(this_0) + ')';
      }
    }
    return tmp;
  }
  function ChannelResult__hashCode_impl(this_0) {
    return this_0 == null ? 0 : hashCode(this_0);
  }
  function ChannelResult__equals_impl(this_0, other) {
    if (!(other instanceof ChannelResult))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ChannelResult ? other._holder : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ChannelResult(holder) {
    Companion_getInstance_99();
    this._holder = holder;
  }
  ChannelResult.prototype.toString = function () {
    return ChannelResult__toString_impl(this._holder);
  };
  ChannelResult.prototype.hashCode = function () {
    return ChannelResult__hashCode_impl(this._holder);
  };
  ChannelResult.prototype.equals = function (other) {
    return ChannelResult__equals_impl(this._holder, other);
  };
  ChannelResult.$metadata$ = {
    simpleName: 'ChannelResult',
    kind: 'class',
    interfaces: []
  };
  function SendChannel() {
  }
  SendChannel.prototype.close$default_xa3v0r_k$ = function (cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return $handler == null ? this.close_h62ekz_k$(cause) : $handler(cause);
  };
  SendChannel.$metadata$ = {
    simpleName: 'SendChannel',
    kind: 'interface',
    interfaces: []
  };
  function ClosedReceiveChannelException(message) {
    NoSuchElementException_init_$Init$_0(message, this);
    captureStack(this, ClosedReceiveChannelException);
  }
  ClosedReceiveChannelException.$metadata$ = {
    simpleName: 'ClosedReceiveChannelException',
    kind: 'class',
    interfaces: []
  };
  function ClosedSendChannelException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, ClosedSendChannelException);
  }
  ClosedSendChannelException.$metadata$ = {
    simpleName: 'ClosedSendChannelException',
    kind: 'class',
    interfaces: []
  };
  function ChannelCoroutine(parentContext, _channel, initParentJob, active) {
    AbstractCoroutine.call(this, parentContext, initParentJob, active);
    this.__channel = _channel;
  }
  ChannelCoroutine.prototype._get__channel__0_k$ = function () {
    return this.__channel;
  };
  ChannelCoroutine.prototype.close_h62ekz_k$ = function (cause) {
    return this.__channel.close_h62ekz_k$(cause);
  };
  ChannelCoroutine.prototype.receive_0_k$ = function ($cont) {
    return this.__channel.receive_0_k$($cont);
  };
  ChannelCoroutine.prototype.receiveCatching_e9ymgp_k$ = function ($cont) {
    return this.__channel.receiveCatching_e9ymgp_k$($cont);
  };
  ChannelCoroutine.prototype.send_jxzaet_k$ = function (element, $cont) {
    return this.__channel.send_jxzaet_k$(element, $cont);
  };
  ChannelCoroutine.prototype.cancel_fnv408_k$ = function (cause) {
    if (this._get_isCancelled__0_k$())
      return Unit_getInstance();
    var tmp0_elvis_lhs = cause;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_elvis_lhs_1 = null;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_0_k$() : tmp0_elvis_lhs_1, null, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    this.cancelInternal_1ti8hr_k$(tmp);
  };
  ChannelCoroutine.prototype.cancelInternal_1ti8hr_k$ = function (cause) {
    var exception = this.toCancellationException$default_f52skm_k$(cause, null, 1, null);
    this.__channel.cancel_fnv408_k$(exception);
    this.cancelCoroutine_h62ekz_k$(exception);
    Unit_getInstance();
  };
  ChannelCoroutine.$metadata$ = {
    simpleName: 'ChannelCoroutine',
    kind: 'class',
    interfaces: [Channel]
  };
  function cancelConsumed(_this_, cause) {
    var tmp0_safe_receiver = cause;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp0_elvis_lhs_2 = tmp0_safe_receiver instanceof CancellationException ? tmp0_safe_receiver : null;
      tmp = tmp0_elvis_lhs_2 == null ? CancellationException_init_$Create$_0('Channel was consumed, consumer had failed', tmp0_safe_receiver) : tmp0_elvis_lhs_2;
    }
    _this_.cancel_fnv408_k$(tmp);
  }
  function updateValueLocked($this, element) {
    var old = $this._value_9;
    var tmp;
    if (old === EMPTY) {
      tmp = null;
    } else {
      var tmp0_safe_receiver = $this._get_onUndeliveredElement__0_k$();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp_1 = (old == null ? true : isObject(old)) ? old : THROW_CCE();
        tmp_0 = callUndeliveredElementCatchingException$default(tmp0_safe_receiver, tmp_1, null, 2, null);
      }
      tmp = tmp_0;
    }
    var undeliveredElementException = tmp;
    $this._value_9 = element;
    return undeliveredElementException;
  }
  function ConflatedChannel(onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
    this._lock_0 = new NoOpLock();
    this._value_9 = EMPTY;
  }
  ConflatedChannel.prototype._get_isBufferAlwaysEmpty__0_k$ = function () {
    return false;
  };
  ConflatedChannel.prototype._get_isBufferEmpty__0_k$ = function () {
    return this._value_9 === EMPTY;
  };
  ConflatedChannel.prototype._get_isBufferAlwaysFull__0_k$ = function () {
    return false;
  };
  ConflatedChannel.prototype._get_isBufferFull__0_k$ = function () {
    return false;
  };
  ConflatedChannel.prototype.offerInternal_2bq_k$ = function (element) {
    var receive = null;
    var tmp0_withLock_0 = this._lock_0;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_safe_receiver_2 = this._get_closedForSend__0_k$();
      if (tmp0_safe_receiver_2 == null)
        null;
      else {
        return tmp0_safe_receiver_2;
      }
      Unit_getInstance();
      if (this._value_9 === EMPTY) {
        loop: while (true) {
          var tmp1_elvis_lhs_3 = this.takeFirstReceiveOrPeekClosed_0_k$();
          var tmp;
          if (tmp1_elvis_lhs_3 == null) {
            break loop;
          } else {
            tmp = tmp1_elvis_lhs_3;
          }
          receive = tmp;
          if (receive instanceof Closed) {
            return ensureNotNull(receive);
          } else {
          }
          var token_4 = ensureNotNull(receive).tryResumeReceive_c24eu3_k$(element, null);
          if (!(token_4 == null)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }}
      }var tmp2_safe_receiver_5 = updateValueLocked(this, element);
      if (tmp2_safe_receiver_5 == null)
        null;
      else {
        throw tmp2_safe_receiver_5;
      }
      Unit_getInstance();
      return OFFER_SUCCESS;
    }
     while (false);
    ensureNotNull(receive).completeResumeReceive_jxzaet_k$(element);
    return ensureNotNull(receive)._get_offerResult__0_k$();
  };
  ConflatedChannel.prototype.pollInternal_0_k$ = function () {
    var result = null;
    var tmp0_withLock_0 = this._lock_0;
    if (this._value_9 === EMPTY) {
      var tmp0_elvis_lhs_2 = this._get_closedForSend__0_k$();
      return tmp0_elvis_lhs_2 == null ? POLL_FAILED : tmp0_elvis_lhs_2;
    }result = this._value_9;
    this._value_9 = EMPTY;
    return result;
  };
  ConflatedChannel.prototype.onCancelIdempotent_rpwsgn_k$ = function (wasClosed) {
    var undeliveredElementException = null;
    var tmp0_withLock_0 = this._lock_0;
    undeliveredElementException = updateValueLocked(this, EMPTY);
    AbstractChannel.prototype.onCancelIdempotent_rpwsgn_k$.call(this, wasClosed);
    var tmp0_safe_receiver = undeliveredElementException;
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  };
  ConflatedChannel.prototype.enqueueReceiveInternal_a6rukz_k$ = function (receive) {
    var tmp0_withLock_0 = this._lock_0;
    return AbstractChannel.prototype.enqueueReceiveInternal_a6rukz_k$.call(this, receive);
  };
  ConflatedChannel.prototype._get_bufferDebugString__0_k$ = function () {
    return '' + '(value=' + this._value_9 + ')';
  };
  ConflatedChannel.$metadata$ = {
    simpleName: 'ConflatedChannel',
    kind: 'class',
    interfaces: []
  };
  function LinkedListChannel(onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
  }
  LinkedListChannel.prototype._get_isBufferAlwaysEmpty__0_k$ = function () {
    return true;
  };
  LinkedListChannel.prototype._get_isBufferEmpty__0_k$ = function () {
    return true;
  };
  LinkedListChannel.prototype._get_isBufferAlwaysFull__0_k$ = function () {
    return false;
  };
  LinkedListChannel.prototype._get_isBufferFull__0_k$ = function () {
    return false;
  };
  LinkedListChannel.prototype.offerInternal_2bq_k$ = function (element) {
    while (true) {
      var result = AbstractChannel.prototype.offerInternal_2bq_k$.call(this, element);
      if (result === OFFER_SUCCESS)
        return OFFER_SUCCESS;
      else {
        if (result === OFFER_FAILED) {
          var sendResult = this.sendBuffered_2bq_k$(element);
          if (sendResult == null)
            return OFFER_SUCCESS;
          else {
            if (sendResult instanceof Closed)
              return sendResult;
            else {
            }
          }
        } else {
          if (result instanceof Closed)
            return result;
          else {
            {
              var tmp0_error_0 = '' + 'Invalid offerInternal result ' + result;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
            }
          }
        }
      }
    }
  };
  LinkedListChannel.prototype.onCancelIdempotentList_x8is0l_k$ = function (list, closed) {
    var undeliveredElementException = null;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_subject_1 = _get_holder_(list);
      if (tmp0_subject_1 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        if (!(tmp0_subject_1 instanceof ArrayList)) {
          var tmp = _get_holder_(list);
          var tmp0__anonymous__5 = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
          var tmp0_subject_6 = tmp0__anonymous__5;
          if (tmp0_subject_6 instanceof SendBuffered) {
            var tmp1_safe_receiver_7 = this._get_onUndeliveredElement__0_k$();
            var tmp_0;
            if (tmp1_safe_receiver_7 == null) {
              tmp_0 = null;
            } else {
              var tmp_1 = tmp0__anonymous__5._element_0;
              tmp_0 = callUndeliveredElementCatchingException(tmp1_safe_receiver_7, (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE(), undeliveredElementException);
            }
            undeliveredElementException = tmp_0;
          } else {
            tmp0__anonymous__5.resumeSendClosed_tt36wi_k$(closed);
          }
        } else {
          {
            var tmp_2 = _get_holder_(list);
            var list_2 = tmp_2 instanceof ArrayList ? tmp_2 : THROW_CCE();
            var inductionVariable = list_2._get_size__0_k$() - 1 | 0;
            if (0 <= inductionVariable)
              do {
                var i_4 = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                var tmp1__anonymous__5 = list_2.get_ha5a7z_k$(i_4);
                var tmp0_subject_6_0 = tmp1__anonymous__5;
                if (tmp0_subject_6_0 instanceof SendBuffered) {
                  var tmp1_safe_receiver_7_0 = this._get_onUndeliveredElement__0_k$();
                  var tmp_3;
                  if (tmp1_safe_receiver_7_0 == null) {
                    tmp_3 = null;
                  } else {
                    var tmp_4 = tmp1__anonymous__5._element_0;
                    tmp_3 = callUndeliveredElementCatchingException(tmp1_safe_receiver_7_0, (tmp_4 == null ? true : isObject(tmp_4)) ? tmp_4 : THROW_CCE(), undeliveredElementException);
                  }
                  undeliveredElementException = tmp_3;
                } else {
                  tmp1__anonymous__5.resumeSendClosed_tt36wi_k$(closed);
                }
              }
               while (0 <= inductionVariable);
          }
        }
      }
    }
     while (false);
    var tmp0_safe_receiver = undeliveredElementException;
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  };
  LinkedListChannel.$metadata$ = {
    simpleName: 'LinkedListChannel',
    kind: 'class',
    interfaces: []
  };
  function produce(_this_, context, capacity, block) {
    return produce_0(_this_, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
  }
  function ProducerScope() {
  }
  ProducerScope.$metadata$ = {
    simpleName: 'ProducerScope',
    kind: 'interface',
    interfaces: [CoroutineScope, SendChannel]
  };
  function produce_0(_this_, context, capacity, onBufferOverflow, start, onCompletion, block) {
    var channel = Channel$default(capacity, onBufferOverflow, null, 4, null);
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = new ProducerCoroutine(newContext, channel);
    if (!(onCompletion == null)) {
      coroutine.invokeOnCompletion_wjzpsu_k$(onCompletion);
      Unit_getInstance();
    }coroutine.start_hfyz87_k$(start, coroutine, block);
    return coroutine;
  }
  function ProducerCoroutine(parentContext, channel) {
    ChannelCoroutine.call(this, parentContext, channel, true, true);
  }
  ProducerCoroutine.prototype._get_isActive__0_k$ = function () {
    return ChannelCoroutine.prototype._get_isActive__0_k$.call(this);
  };
  ProducerCoroutine.prototype.onCompleted_89eg7z_k$ = function (value) {
    var tmp = this._get__channel__0_k$();
    tmp.close$default_xa3v0r_k$(null, 1, null);
    Unit_getInstance();
  };
  ProducerCoroutine.prototype.onCompleted_iav7o_k$ = function (value) {
    return this.onCompleted_89eg7z_k$(value instanceof Unit ? value : THROW_CCE());
  };
  ProducerCoroutine.prototype.onCancelled_mnel9l_k$ = function (cause, handled) {
    var processed = this._get__channel__0_k$().close_h62ekz_k$(cause);
    if (!processed ? !handled : false)
      handleCoroutineException(this._get_context__0_k$(), cause);
  };
  ProducerCoroutine.$metadata$ = {
    simpleName: 'ProducerCoroutine',
    kind: 'class',
    interfaces: [ProducerScope]
  };
  function RendezvousChannel(onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
  }
  RendezvousChannel.prototype._get_isBufferAlwaysEmpty__0_k$ = function () {
    return true;
  };
  RendezvousChannel.prototype._get_isBufferEmpty__0_k$ = function () {
    return true;
  };
  RendezvousChannel.prototype._get_isBufferAlwaysFull__0_k$ = function () {
    return true;
  };
  RendezvousChannel.prototype._get_isBufferFull__0_k$ = function () {
    return true;
  };
  RendezvousChannel.$metadata$ = {
    simpleName: 'RendezvousChannel',
    kind: 'class',
    interfaces: []
  };
  function flow(block) {
    return new SafeFlow(block);
  }
  function asFlow(_this_) {
    return new _no_name_provided__1_7(_this_);
  }
  function emptyFlow() {
    return EmptyFlow_getInstance();
  }
  function SafeFlow(block) {
    AbstractFlow.call(this);
    this._block = block;
  }
  SafeFlow.prototype.collectSafely_l0hod5_k$ = function (collector, $cont) {
    return this._block(collector, $cont);
  };
  SafeFlow.$metadata$ = {
    simpleName: 'SafeFlow',
    kind: 'class',
    interfaces: []
  };
  function EmptyFlow() {
    EmptyFlow_instance = this;
  }
  EmptyFlow.prototype.collect_vrznvx_k$ = function (collector, $cont) {
    return Unit_getInstance();
  };
  EmptyFlow.prototype.collect_l0hod5_k$ = function (collector, $cont) {
    return this.collect_vrznvx_k$(collector, $cont);
  };
  EmptyFlow.$metadata$ = {
    simpleName: 'EmptyFlow',
    kind: 'object',
    interfaces: [Flow]
  };
  var EmptyFlow_instance;
  function EmptyFlow_getInstance() {
    if (EmptyFlow_instance == null)
      new EmptyFlow();
    return EmptyFlow_instance;
  }
  function $collect_2COROUTINE$5(_this_, collector, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__2 = _this_;
    this._collector = collector;
  }
  $collect_2COROUTINE$5.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._tmp0_iterator_1_70 = this.__this__2._$this_asFlow.iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator_1_70.hasNext_0_k$()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._element_2_81 = this._tmp0_iterator_1_70.next_0_k$();
            this._state_1 = 2;
            suspendResult = this._collector.emit_iav7o_k$(this._element_2_81, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $collect_2COROUTINE$5.$metadata$ = {
    simpleName: '$collect_2COROUTINE$5',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_7($this_asFlow) {
    this._$this_asFlow = $this_asFlow;
  }
  _no_name_provided__1_7.prototype.collect_2_l0hod5_k$ = function (collector, $cont) {
    var tmp = new $collect_2COROUTINE$5(this, collector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__1_7.prototype.collect_l0hod5_k$ = function (collector, $cont) {
    return this.collect_2_l0hod5_k$(collector, $cont);
  };
  _no_name_provided__1_7.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Flow]
  };
  function emitAll(_this_, channel, $cont) {
    return emitAllImpl(_this_, channel, true, $cont);
  }
  function emitAllImpl(_this_, channel, consume, $cont) {
    var tmp = new $emitAllImplCOROUTINE$6(_this_, channel, consume, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function $emitAllImplCOROUTINE$6(_this_, channel, consume, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__3 = _this_;
    this._channel_0 = channel;
    this._consume = consume;
  }
  $emitAllImplCOROUTINE$6.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            ensureActive_1(this.__this__3);
            this._cause0 = null;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 9;
            this._exceptionState = 8;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (false) {
              this._state_1 = 7;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = this._channel_0.receiveCatching_e9ymgp_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._unboxed2 = suspendResult._holder;
            suspendResult = this._unboxed2;
            this._state_1 = 4;
            continue $sm;
          case 4:
            this._result3 = suspendResult;
            if (_ChannelResult___get_isClosed__impl_(this._result3)) {
              var tmp0_safe_receiver = ChannelResult__exceptionOrNull_impl(this._result3);
              if (tmp0_safe_receiver == null)
                null;
              else {
                throw tmp0_safe_receiver;
              }
              Unit_getInstance();
              this._state_1 = 7;
              continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._state_1 = 6;
            suspendResult = this.__this__3.emit_iav7o_k$(ChannelResult__getOrThrow_impl(this._result3), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._state_1 = 2;
            continue $sm;
          case 7:
            this._tmp$ret$01 = Unit_getInstance();
            this._exceptionState = 11;
            this._state_1 = 10;
            continue $sm;
          case 8:
            this._exceptionState = 9;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              var tmp_1 = this;
              this._cause0 = e;
              throw e;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 9:
            this._exceptionState = 11;
            var t = this._exception_0;
            if (this._consume)
              cancelConsumed(this._channel_0, this._cause0);
            throw t;
          case 10:
            if (this._consume)
              cancelConsumed(this._channel_0, this._cause0);
            return Unit_getInstance();
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $emitAllImplCOROUTINE$6.$metadata$ = {
    simpleName: '$emitAllImplCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function Flow() {
  }
  Flow.$metadata$ = {
    simpleName: 'Flow',
    kind: 'interface',
    interfaces: []
  };
  function $collectCOROUTINE$7(_this_, collector, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__4 = _this_;
    this._collector_0 = collector;
  }
  $collectCOROUTINE$7.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            var tmp_0 = this;
            tmp_0._safeCollector0 = new SafeCollector(this._collector_0, this._get_context__0_k$());
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 4;
            this._state_1 = 2;
            suspendResult = this.__this__4.collectSafely_l0hod5_k$(this._safeCollector0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._tmp$ret$01_0 = suspendResult;
            this._exceptionState = 5;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._safeCollector0.releaseIntercepted_sv8swh_k$();
            return Unit_getInstance();
          case 4:
            this._exceptionState = 5;
            var t = this._exception_0;
            this._safeCollector0.releaseIntercepted_sv8swh_k$();
            throw t;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $collectCOROUTINE$7.$metadata$ = {
    simpleName: '$collectCOROUTINE$7',
    kind: 'class',
    interfaces: []
  };
  function AbstractFlow() {
  }
  AbstractFlow.prototype.collect_l0hod5_k$ = function (collector, $cont) {
    var tmp = new $collectCOROUTINE$7(this, collector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AbstractFlow.$metadata$ = {
    simpleName: 'AbstractFlow',
    kind: 'class',
    interfaces: [Flow, CancellableFlow]
  };
  function FlowCollector() {
  }
  FlowCollector.$metadata$ = {
    simpleName: 'FlowCollector',
    kind: 'interface',
    interfaces: []
  };
  function checkOwnership(_this_, owner) {
    if (!(_this_._owner === owner))
      throw _this_;
  }
  function checkContext(_this_, currentContext) {
    var result = currentContext.fold_cq605b_k$(0, _no_name_provided_$factory_92(_this_));
    if (!(result === _this_._collectContextSize)) {
      var tmp0_error_0 = 'Flow invariant is violated:\n' + ('' + '\t\tFlow was collected in ' + _this_._collectContext + ',\n') + ('' + '\t\tbut emission happened in ' + currentContext + '.\n') + "\t\tPlease refer to 'flow' documentation or use 'flowOn' instead";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }}
  function transitiveCoroutineParent(_this_, collectJob) {
    var $this = _this_;
    var collectJob_0 = collectJob;
    while (true) {
      var $this_0 = $this;
      var collectJob_1 = collectJob_0;
      if ($this_0 === null)
        return null;
      if ($this_0 === collectJob_1)
        return $this_0;
      if (!($this_0 instanceof ScopeCoroutine))
        return $this_0;
      else {
      }
      $this = $this_0._get_parent__0_k$();
      collectJob_0 = collectJob_1;
      continue;
    }
  }
  function _no_name_provided__114($this_checkContext) {
    this._$this_checkContext = $this_checkContext;
  }
  _no_name_provided__114.prototype.invoke_c68gd4_k$ = function (count_0, element) {
    var key = element._get_key__0_k$();
    var collectElement = this._$this_checkContext._collectContext.get_9uvjra_k$(key);
    if (!(key === Key_getInstance_2())) {
      return !(element === collectElement) ? IntCompanionObject_getInstance()._MIN_VALUE_5 : count_0 + 1 | 0;
    }var collectJob = (collectElement == null ? true : isInterface(collectElement, Job)) ? collectElement : THROW_CCE();
    var emissionParentJob = transitiveCoroutineParent(isInterface(element, Job) ? element : THROW_CCE(), collectJob);
    if (!(emissionParentJob === collectJob)) {
      var tmp0_error_0 = 'Flow invariant is violated:\n\t\tEmission from another coroutine is detected.\n' + ('' + '\t\tChild of ' + emissionParentJob + ', expected child of ' + collectJob + '.\n') + '\t\tFlowCollector is not thread-safe and concurrent emissions are prohibited.\n' + "\t\tTo mitigate this restriction please use 'channelFlow' builder instead of 'flow'";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }return collectJob == null ? count_0 : count_0 + 1 | 0;
  };
  _no_name_provided__114.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_c68gd4_k$(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__114.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_92($this_checkContext) {
    var i = new _no_name_provided__114($this_checkContext);
    return function (p1, p2) {
      return i.invoke_c68gd4_k$(p1, p2);
    };
  }
  function CancellableFlow() {
  }
  CancellableFlow.$metadata$ = {
    simpleName: 'CancellableFlow',
    kind: 'interface',
    interfaces: [Flow]
  };
  function ensureActive_1(_this_) {
    if (_this_ instanceof ThrowingCollector)
      throw _this_._e_0;
    else {
    }
  }
  function ThrowingCollector() {
  }
  ThrowingCollector.$metadata$ = {
    simpleName: 'ThrowingCollector',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function toList_6(_this_, destination, $cont) {
    return toCollection_2(_this_, destination, $cont);
  }
  function toList$default(_this_, destination, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      destination = ArrayList_init_$Create$();
    return toList_6(_this_, destination, $cont);
  }
  function toCollection_2(_this_, destination, $cont) {
    var tmp = new $toCollectionCOROUTINE$13(_this_, destination, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__1_8($destination) {
    this._$destination = $destination;
  }
  _no_name_provided__1_8.prototype.emit_2_iav7o_k$ = function (value, $cont) {
    this._$destination.add_2bq_k$(value);
    return Unit_getInstance();
  };
  _no_name_provided__1_8.prototype.emit_iav7o_k$ = function (value, $cont) {
    return this.emit_2_iav7o_k$((value == null ? true : isObject(value)) ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_8.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function $toCollectionCOROUTINE$13(_this_, destination, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__5 = _this_;
    this._destination = destination;
  }
  $toCollectionCOROUTINE$13.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__5.collect_l0hod5_k$(new _no_name_provided__1_8(this._destination), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return this._destination;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $toCollectionCOROUTINE$13.$metadata$ = {
    simpleName: '$toCollectionCOROUTINE$13',
    kind: 'class',
    interfaces: []
  };
  function firstOrNull_1(_this_, $cont) {
    var tmp = new $firstOrNullCOROUTINE$14(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__2_0($result) {
    this._$result = $result;
  }
  _no_name_provided__2_0.prototype.emit_3_iav7o_k$ = function (value, $cont) {
    this._$result._v = value;
    if (!false) {
      throw new AbortFlowException(this);
    } else {
    }
  };
  _no_name_provided__2_0.prototype.emit_iav7o_k$ = function (value, $cont) {
    return this.emit_3_iav7o_k$((value == null ? true : isObject(value)) ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__2_0.$metadata$ = {
    simpleName: '<no name provided>_2',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function $firstOrNullCOROUTINE$14(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__6 = _this_;
  }
  $firstOrNullCOROUTINE$14.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._result0 = {_v: null};
            var tmp_0 = this;
            tmp_0._collector_11 = new _no_name_provided__2_0(this._result0);
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__6.collect_l0hod5_k$(this._collector_11, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._exceptionState = 4;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._exceptionState = 4;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof AbortFlowException) {
              var e_7 = this._exception_0;
              checkOwnership(e_7, this._collector_11);
              this._state_1 = 3;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            this._exceptionState = 4;
            return this._result0._v;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $firstOrNullCOROUTINE$14.$metadata$ = {
    simpleName: '$firstOrNullCOROUTINE$14',
    kind: 'class',
    interfaces: []
  };
  function ensureCapacity_0($this) {
    var currentSize = $this._elements.length;
    var newCapacity = currentSize << 1;
    var newElements = fillArrayVal(Array(newCapacity), null);
    var tmp0_copyInto_0 = $this._elements;
    var tmp1_copyInto_0 = $this._head_1;
    var tmp2_copyInto_0 = tmp0_copyInto_0.length;
    arrayCopy_0(tmp0_copyInto_0, newElements, 0, tmp1_copyInto_0, tmp2_copyInto_0);
    Unit_getInstance();
    var tmp3_copyInto_0 = $this._elements;
    var tmp4_copyInto_0 = $this._elements.length - $this._head_1 | 0;
    var tmp5_copyInto_0 = $this._head_1;
    arrayCopy_0(tmp3_copyInto_0, newElements, tmp4_copyInto_0, 0, tmp5_copyInto_0);
    Unit_getInstance();
    $this._elements = newElements;
    $this._head_1 = 0;
    $this._tail = currentSize;
  }
  function ArrayQueue() {
    var tmp = this;
    tmp._elements = fillArrayVal(Array(16), null);
    this._head_1 = 0;
    this._tail = 0;
  }
  ArrayQueue.prototype._get_isEmpty__0_k$ = function () {
    return this._head_1 === this._tail;
  };
  ArrayQueue.prototype.addLast_iav7o_k$ = function (element) {
    this._elements[this._tail] = element;
    this._tail = (this._tail + 1 | 0) & (this._elements.length - 1 | 0);
    if (this._tail === this._head_1)
      ensureCapacity_0(this);
  };
  ArrayQueue.prototype.removeFirstOrNull_0_k$ = function () {
    if (this._head_1 === this._tail)
      return null;
    var element = this._elements[this._head_1];
    this._elements[this._head_1] = null;
    this._head_1 = (this._head_1 + 1 | 0) & (this._elements.length - 1 | 0);
    return isObject(element) ? element : THROW_CCE();
  };
  ArrayQueue.$metadata$ = {
    simpleName: 'ArrayQueue',
    kind: 'class',
    interfaces: []
  };
  function OpDescriptor() {
  }
  OpDescriptor.$metadata$ = {
    simpleName: 'OpDescriptor',
    kind: 'class',
    interfaces: []
  };
  var UNDEFINED;
  var REUSABLE_CLAIMED;
  function resumeCancellableWith(_this_, result, onCancellation) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof DispatchedContinuation) {
      var tmp1_resumeCancellableWith_0 = _this_;
      var state_1 = toState_0(result, onCancellation);
      var tmp_0;
      if (tmp1_resumeCancellableWith_0._dispatcher.isDispatchNeeded_d7pszg_k$(tmp1_resumeCancellableWith_0._get_context__0_k$())) {
        tmp1_resumeCancellableWith_0.__state_1 = state_1;
        tmp1_resumeCancellableWith_0._set_resumeMode__majfzk_k$(1);
        tmp_0 = tmp1_resumeCancellableWith_0._dispatcher.dispatch_7n0ou3_k$(tmp1_resumeCancellableWith_0._get_context__0_k$(), tmp1_resumeCancellableWith_0);
      } else {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_executeUnconfined_0 = 1;
          var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop__0_k$();
          if (false ? eventLoop_2._get_isUnconfinedQueueEmpty__0_k$() : false) {
            tmp$ret$0 = false;
            break l$ret$1;
          }var tmp_1;
          if (eventLoop_2._get_isUnconfinedLoopActive__0_k$()) {
            tmp1_resumeCancellableWith_0.__state_1 = state_1;
            tmp1_resumeCancellableWith_0._set_resumeMode__majfzk_k$(tmp0_executeUnconfined_0);
            eventLoop_2.dispatchUnconfined_3yrun8_k$(tmp1_resumeCancellableWith_0);
            tmp_1 = true;
          } else {
            eventLoop_2.incrementUseCount_rpwsgn_k$(true);
            try {
              var tmp$ret$2;
              l$ret$3: do {
                var job_1_4 = tmp1_resumeCancellableWith_0._get_context__0_k$().get_9uvjra_k$(Key_getInstance_2());
                if (!(job_1_4 == null) ? !job_1_4._get_isActive__0_k$() : false) {
                  var cause_2_5 = job_1_4.getCancellationException_0_k$();
                  tmp1_resumeCancellableWith_0.cancelCompletedResult_6goujk_k$(state_1, cause_2_5);
                  var tmp0_failure_0_1_6 = Companion_getInstance_3();
                  tmp1_resumeCancellableWith_0.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(cause_2_5)));
                  tmp$ret$2 = true;
                  break l$ret$3;
                }tmp$ret$2 = false;
              }
               while (false);
              if (!tmp$ret$2) {
                var tmp0_withContinuationContext_0_7 = tmp1_resumeCancellableWith_0._continuation_3;
                var tmp1_withContinuationContext_0_8 = tmp1_resumeCancellableWith_0._countOrElement;
                tmp1_resumeCancellableWith_0._continuation_3.resumeWith_bnunh2_k$(result);
              } else {
              }
              $l$break: while (true) {
                if (!eventLoop_2.processUnconfinedEvent_0_k$())
                  break $l$break;
              }
            } catch ($p) {
              if ($p instanceof Error) {
                tmp1_resumeCancellableWith_0.handleFatalException_amk5yv_k$($p, null);
              } else {
                {
                  throw $p;
                }
              }
            }
            finally {
              eventLoop_2.decrementUseCount_rpwsgn_k$(true);
            }
            tmp_1 = false;
          }
          tmp$ret$0 = tmp_1;
        }
         while (false);
        tmp_0 = Unit_getInstance();
      }
      tmp = tmp_0;
    } else {
      {
        tmp = _this_.resumeWith_bnunh2_k$(result);
      }
    }
    return tmp;
  }
  function resumeCancellableWith$default(_this_, result, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      onCancellation = null;
    return resumeCancellableWith(_this_, result, onCancellation);
  }
  function DispatchedContinuation(dispatcher, continuation) {
    DispatchedTask.call(this, -1);
    this._dispatcher = dispatcher;
    this._continuation_3 = continuation;
    this.__state_1 = UNDEFINED;
    this._countOrElement = threadContextElements(this._get_context__0_k$());
    this.__reusableCancellableContinuation = atomic(null);
  }
  DispatchedContinuation.prototype._get_context__0_k$ = function () {
    return this._continuation_3._get_context__0_k$();
  };
  DispatchedContinuation.prototype._get_reusableCancellableContinuation__0_k$ = function () {
    var tmp = this.__reusableCancellableContinuation._value_5;
    return tmp instanceof CancellableContinuationImpl ? tmp : null;
  };
  DispatchedContinuation.prototype.isReusable_mmp58q_k$ = function (requester) {
    var tmp0_elvis_lhs = this.__reusableCancellableContinuation._value_5;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    if (value instanceof CancellableContinuationImpl)
      return value === requester;
    else {
    }
    return true;
  };
  DispatchedContinuation.prototype.awaitReusability_sv8swh_k$ = function () {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_5;
      if (!(tmp1__anonymous__1 === REUSABLE_CLAIMED))
        return Unit_getInstance();
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.release_sv8swh_k$ = function () {
    this.awaitReusability_sv8swh_k$();
    var tmp0_safe_receiver = this._get_reusableCancellableContinuation__0_k$();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.detachChild_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.claimReusableCancellableContinuation_0_k$ = function () {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_5;
      if (tmp1__anonymous__1 === null) {
        this.__reusableCancellableContinuation._value_5 = REUSABLE_CLAIMED;
        return null;
      } else {
        if (tmp1__anonymous__1 instanceof CancellableContinuationImpl) {
          if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(tmp1__anonymous__1, REUSABLE_CLAIMED)) {
            return tmp1__anonymous__1 instanceof CancellableContinuationImpl ? tmp1__anonymous__1 : THROW_CCE();
          }} else {
          if (tmp1__anonymous__1 === REUSABLE_CLAIMED) {
          } else {
            if (tmp1__anonymous__1 instanceof Error) {
            } else {
              {
                var tmp0_error_0_2 = '' + 'Inconsistent state ' + tmp1__anonymous__1;
                throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_2));
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.tryReleaseClaimedContinuation_7b8qoa_k$ = function (continuation) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_5;
      if (tmp1__anonymous__1 === REUSABLE_CLAIMED) {
        if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(REUSABLE_CLAIMED, continuation))
          return null;
      } else {
        if (tmp1__anonymous__1 instanceof Error) {
          var tmp0_require_0_2 = this.__reusableCancellableContinuation.atomicfu$compareAndSet(tmp1__anonymous__1, null);
          if (!tmp0_require_0_2) {
            var message_2_1_3 = 'Failed requirement.';
            throw IllegalArgumentException_init_$Create$(toString_1(message_2_1_3));
          }return tmp1__anonymous__1;
        } else {
          {
            var tmp1_error_0_4 = '' + 'Inconsistent state ' + tmp1__anonymous__1;
            throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0_4));
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.postponeCancellation_onfaoi_k$ = function (cause) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_5;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (equals_1(tmp0_subject_2, REUSABLE_CLAIMED)) {
        if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(REUSABLE_CLAIMED, cause))
          return true;
      } else {
        if (tmp0_subject_2 instanceof Error)
          return true;
        else {
          {
            if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(tmp1__anonymous__1, null))
              return false;
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.takeState_0_k$ = function () {
    var state = this.__state_1;
    this.__state_1 = UNDEFINED;
    return state;
  };
  DispatchedContinuation.prototype._get_delegate__0_k$ = function () {
    return this;
  };
  DispatchedContinuation.prototype.resumeWith_bnunh2_k$ = function (result) {
    var context = this._continuation_3._get_context__0_k$();
    var state = toState$default(result, null, 1, null);
    if (this._dispatcher.isDispatchNeeded_d7pszg_k$(context)) {
      this.__state_1 = state;
      this._set_resumeMode__majfzk_k$(0);
      this._dispatcher.dispatch_7n0ou3_k$(context, this);
    } else {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_executeUnconfined_0 = 0;
        var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop__0_k$();
        if (false ? eventLoop_2._get_isUnconfinedQueueEmpty__0_k$() : false) {
          tmp$ret$0 = false;
          break l$ret$1;
        }var tmp;
        if (eventLoop_2._get_isUnconfinedLoopActive__0_k$()) {
          this.__state_1 = state;
          this._set_resumeMode__majfzk_k$(tmp0_executeUnconfined_0);
          eventLoop_2.dispatchUnconfined_3yrun8_k$(this);
          tmp = true;
        } else {
          eventLoop_2.incrementUseCount_rpwsgn_k$(true);
          try {
            var tmp0_withCoroutineContext_0_4 = this._get_context__0_k$();
            var tmp1_withCoroutineContext_0_5 = this._countOrElement;
            this._continuation_3.resumeWith_bnunh2_k$(result);
            $l$break: while (true) {
              if (!eventLoop_2.processUnconfinedEvent_0_k$())
                break $l$break;
            }
          } catch ($p) {
            if ($p instanceof Error) {
              this.handleFatalException_amk5yv_k$($p, null);
            } else {
              {
                throw $p;
              }
            }
          }
          finally {
            eventLoop_2.decrementUseCount_rpwsgn_k$(true);
          }
          tmp = false;
        }
        tmp$ret$0 = tmp;
      }
       while (false);
      Unit_getInstance();
    }
  };
  DispatchedContinuation.prototype.cancelCompletedResult_6goujk_k$ = function (takenState, cause) {
    if (takenState instanceof CompletedWithCancellation) {
      takenState._onCancellation_0(cause);
    } else {
    }
  };
  DispatchedContinuation.prototype.toString = function () {
    return '' + 'DispatchedContinuation[' + this._dispatcher + ', ' + toDebugString(this._continuation_3) + ']';
  };
  DispatchedContinuation.$metadata$ = {
    simpleName: 'DispatchedContinuation',
    kind: 'class',
    interfaces: [CoroutineStackFrame, Continuation]
  };
  function DispatchedTask(resumeMode) {
    SchedulerTask.call(this);
    this._resumeMode = resumeMode;
  }
  DispatchedTask.prototype._set_resumeMode__majfzk_k$ = function (_set___) {
    this._resumeMode = _set___;
  };
  DispatchedTask.prototype._get_resumeMode__0_k$ = function () {
    return this._resumeMode;
  };
  DispatchedTask.prototype.cancelCompletedResult_6goujk_k$ = function (takenState, cause) {
  };
  DispatchedTask.prototype.getSuccessfulResult_6jiqgr_k$ = function (state) {
    return (state == null ? true : isObject(state)) ? state : THROW_CCE();
  };
  DispatchedTask.prototype.getExceptionalResult_wi7j7l_k$ = function (state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  };
  DispatchedTask.prototype.run_sv8swh_k$ = function () {
    var taskContext = _get_taskContext_(this);
    var fatalException = null;
    try {
      var tmp = this._get_delegate__0_k$();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate._continuation_3;
      var tmp0_withContinuationContext_0 = delegate._countOrElement;
      var context_2 = continuation._get_context__0_k$();
      var state_3 = this.takeState_0_k$();
      var exception_4 = this.getExceptionalResult_wi7j7l_k$(state_3);
      var job_5 = (exception_4 == null ? _get_isCancellableMode_(this._resumeMode) : false) ? context_2.get_9uvjra_k$(Key_getInstance_2()) : null;
      if (!(job_5 == null) ? !job_5._get_isActive__0_k$() : false) {
        var cause_6 = job_5.getCancellationException_0_k$();
        this.cancelCompletedResult_6goujk_k$(state_3, cause_6);
        var tmp0_failure_0_7 = Companion_getInstance_3();
        var tmp1_failure_0_8 = recoverStackTrace(cause_6, continuation);
        continuation.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(tmp1_failure_0_8)));
      } else {
        if (!(exception_4 == null)) {
          var tmp0_failure_0_1_9 = Companion_getInstance_3();
          continuation.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(exception_4)));
        } else {
          var tmp2_resume_0_10 = this.getSuccessfulResult_6jiqgr_k$(state_3);
          var tmp0_success_0_1_11 = Companion_getInstance_3();
          continuation.resumeWith_bnunh2_k$(_Result___init__impl_(tmp2_resume_0_10));
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        fatalException = $p;
      } else {
        {
          throw $p;
        }
      }
    }
    finally {
      var tmp_0;
      try {
        var tmp0_success_0_1 = Companion_getInstance_3();
        var tmp1_success_0_2 = Unit_getInstance();
        tmp_0 = _Result___init__impl_(Unit_getInstance());
      } catch ($p_0) {
        var tmp_1;
        if ($p_0 instanceof Error) {
          var tmp2_failure_0_4 = Companion_getInstance_3();
          tmp_1 = _Result___init__impl_(createFailure($p_0));
        } else {
          {
            throw $p_0;
          }
        }
        tmp_0 = tmp_1;
      }
      var result = tmp_0;
      this.handleFatalException_amk5yv_k$(fatalException, Result__exceptionOrNull_impl(result));
    }
  };
  DispatchedTask.prototype.handleFatalException_amk5yv_k$ = function (exception, finallyException) {
    if (exception === null ? finallyException === null : false)
      return Unit_getInstance();
    if (!(exception === null) ? !(finallyException === null) : false) {
    }var tmp0_elvis_lhs = exception;
    var cause = tmp0_elvis_lhs == null ? finallyException : tmp0_elvis_lhs;
    var reason = new CoroutinesInternalError('' + 'Fatal exception in coroutines machinery for ' + this + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", ensureNotNull(cause));
    handleCoroutineException(this._get_delegate__0_k$()._get_context__0_k$(), reason);
  };
  DispatchedTask.$metadata$ = {
    simpleName: 'DispatchedTask',
    kind: 'class',
    interfaces: []
  };
  function _get_isReusableMode_(_this_) {
    return _this_ === 2;
  }
  function _get_isCancellableMode_(_this_) {
    return _this_ === 1 ? true : _this_ === 2;
  }
  function dispatch(_this_, mode) {
    var delegate = _this_._get_delegate__0_k$();
    var undispatched = mode === 4;
    var tmp;
    var tmp_0;
    if (!undispatched) {
      tmp_0 = delegate instanceof DispatchedContinuation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = _get_isCancellableMode_(mode) === _get_isCancellableMode_(_this_._resumeMode);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var dispatcher = delegate._dispatcher;
      var context = delegate._get_context__0_k$();
      if (dispatcher.isDispatchNeeded_d7pszg_k$(context)) {
        dispatcher.dispatch_7n0ou3_k$(context, _this_);
      } else {
        resumeUnconfined(_this_);
      }
    } else {
      {
        resume(_this_, delegate, undispatched);
      }
    }
  }
  function resumeUnconfined(_this_) {
    var eventLoop = ThreadLocalEventLoop_getInstance()._get_eventLoop__0_k$();
    if (eventLoop._get_isUnconfinedLoopActive__0_k$()) {
      eventLoop.dispatchUnconfined_3yrun8_k$(_this_);
    } else {
      eventLoop.incrementUseCount_rpwsgn_k$(true);
      try {
        resume(_this_, _this_._get_delegate__0_k$(), true);
        $l$break: while (true) {
          if (!eventLoop.processUnconfinedEvent_0_k$())
            break $l$break;
        }
      } catch ($p) {
        if ($p instanceof Error) {
          _this_.handleFatalException_amk5yv_k$($p, null);
        } else {
          {
            throw $p;
          }
        }
      }
      finally {
        eventLoop.decrementUseCount_rpwsgn_k$(true);
      }
    }
  }
  function resume(_this_, delegate, undispatched) {
    var state = _this_.takeState_0_k$();
    var exception = _this_.getExceptionalResult_wi7j7l_k$(state);
    var tmp;
    if (!(exception == null)) {
      var tmp0_failure_0 = Companion_getInstance_3();
      tmp = _Result___init__impl_(createFailure(exception));
    } else {
      var tmp1_success_0 = Companion_getInstance_3();
      var tmp2_success_0 = _this_.getSuccessfulResult_6jiqgr_k$(state);
      tmp = _Result___init__impl_(tmp2_success_0);
    }
    var result = tmp;
    if (undispatched) {
      var tmp3_resumeUndispatchedWith_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
      var tmp0_withContinuationContext_0_1 = tmp3_resumeUndispatchedWith_0._continuation_3;
      var tmp1_withContinuationContext_0_2 = tmp3_resumeUndispatchedWith_0._countOrElement;
      tmp3_resumeUndispatchedWith_0._continuation_3.resumeWith_bnunh2_k$(result);
    } else
      delegate.resumeWith_bnunh2_k$(result);
  }
  function _InlineList___init__impl_(holder) {
    return holder;
  }
  function _InlineList___init__impl__0(holder, $mask0, $marker) {
    if (!(($mask0 & 1) === 0))
      holder = null;
    var tmp = _InlineList___init__impl_(holder);
    return tmp;
  }
  function _get_holder_($this) {
    return $this;
  }
  function InlineList__plus_impl(this_0, element) {
    var tmp0_subject = _get_holder_(this_0);
    var tmp;
    if (tmp0_subject == null) {
      tmp = _InlineList___init__impl_(element);
    } else {
      if (tmp0_subject instanceof ArrayList) {
        var tmp_0 = _get_holder_(this_0);
        (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).add_2bq_k$(element);
        Unit_getInstance();
        tmp = _InlineList___init__impl_(_get_holder_(this_0));
      } else {
        {
          var list = ArrayList_init_$Create$_0(4);
          var tmp_1 = _get_holder_(this_0);
          list.add_2bq_k$((tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE());
          Unit_getInstance();
          list.add_2bq_k$(element);
          Unit_getInstance();
          tmp = _InlineList___init__impl_(list);
        }
      }
    }
    return tmp;
  }
  function bindCancellationFun(_this_, element, context) {
    return _no_name_provided_$factory_93(_this_, element, context);
  }
  function UndeliveredElementException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, UndeliveredElementException);
  }
  UndeliveredElementException.$metadata$ = {
    simpleName: 'UndeliveredElementException',
    kind: 'class',
    interfaces: []
  };
  function callUndeliveredElementCatchingException(_this_, element, undeliveredElementException) {
    try {
      _this_(element);
    } catch ($p) {
      if ($p instanceof Error) {
        if (!(undeliveredElementException == null) ? !(undeliveredElementException.cause === $p) : false) {
        } else {
          return new UndeliveredElementException('' + 'Exception in undelivered element handler for ' + element, $p);
        }
      } else {
        {
          throw $p;
        }
      }
    }
    return undeliveredElementException;
  }
  function callUndeliveredElementCatchingException$default(_this_, element, undeliveredElementException, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      undeliveredElementException = null;
    return callUndeliveredElementCatchingException(_this_, element, undeliveredElementException);
  }
  function callUndeliveredElement(_this_, element, context) {
    var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this_, element, null);
    if (tmp0_safe_receiver == null)
      null;
    else {
      handleCoroutineException(context, tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function _no_name_provided__115($this_bindCancellationFun, $element, $context) {
    this._$this_bindCancellationFun = $this_bindCancellationFun;
    this._$element = $element;
    this._$context = $context;
  }
  _no_name_provided__115.prototype.invoke_1ti8hr_k$ = function (_anonymous_parameter_0_) {
    callUndeliveredElement(this._$this_bindCancellationFun, this._$element, this._$context);
  };
  _no_name_provided__115.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_1ti8hr_k$(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__115.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_93($this_bindCancellationFun, $element, $context) {
    var i = new _no_name_provided__115($this_bindCancellationFun, $element, $context);
    return function (p1) {
      i.invoke_1ti8hr_k$(p1);
      return Unit_getInstance();
    };
  }
  function ContextScope(context) {
    this._coroutineContext = context;
  }
  ContextScope.prototype._get_coroutineContext__0_k$ = function () {
    return this._coroutineContext;
  };
  ContextScope.prototype.toString = function () {
    return '' + 'CoroutineScope(coroutineContext=' + this._coroutineContext + ')';
  };
  ContextScope.$metadata$ = {
    simpleName: 'ContextScope',
    kind: 'class',
    interfaces: [CoroutineScope]
  };
  function ScopeCoroutine(context, uCont) {
    AbstractCoroutine.call(this, context, true, true);
    this._uCont = uCont;
  }
  ScopeCoroutine.prototype._get_uCont__0_k$ = function () {
    return this._uCont;
  };
  ScopeCoroutine.prototype._get_isScopedCoroutine__0_k$ = function () {
    return true;
  };
  ScopeCoroutine.prototype._get_parent__0_k$ = function () {
    var tmp0_safe_receiver = this._get_parentHandle__0_k$();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_parent__0_k$();
  };
  ScopeCoroutine.prototype.afterCompletion_qi8yb4_k$ = function (state) {
    var tmp = intercepted(this._uCont);
    var tmp_0 = recoverResult(state, this._uCont);
    resumeCancellableWith$default(tmp, tmp_0, null, 2, null);
  };
  ScopeCoroutine.prototype.afterResume_qi8yb4_k$ = function (state) {
    this._uCont.resumeWith_bnunh2_k$(recoverResult(state, this._uCont));
  };
  ScopeCoroutine.$metadata$ = {
    simpleName: 'ScopeCoroutine',
    kind: 'class',
    interfaces: [CoroutineStackFrame]
  };
  function Symbol(symbol) {
    this._symbol = symbol;
  }
  Symbol.prototype.toString = function () {
    return '' + '<' + this._symbol + '>';
  };
  Symbol.$metadata$ = {
    simpleName: 'Symbol',
    kind: 'class',
    interfaces: []
  };
  function systemProp(propertyName, defaultValue, minValue, maxValue) {
    return systemProp_0(propertyName, toLong(defaultValue), toLong(minValue), toLong(maxValue)).toInt_0_k$();
  }
  function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
    var tmp0_elvis_lhs = systemProp_1(propertyName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return defaultValue;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp1_elvis_lhs = toLongOrNull(value);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp0_error_0 = '' + "System property '" + propertyName + "' has unrecognized value '" + value + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parsed = tmp_0;
    if (!(minValue.compareTo_wiekkq_k$(parsed) <= 0 ? parsed.compareTo_wiekkq_k$(maxValue) <= 0 : false)) {
      var tmp1_error_0 = '' + "System property '" + propertyName + "' should be in range " + minValue + '..' + maxValue + ", but is '" + parsed + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
    }return parsed;
  }
  function startCoroutineCancellable(_this_, receiver, completion, onCancellation) {
    var tmp;
    try {
      var tmp_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
      var tmp0_success_0_3 = Companion_getInstance_3();
      tmp = resumeCancellableWith(tmp_0, _Result___init__impl_(Unit_getInstance()), onCancellation);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var tmp0_failure_0 = Companion_getInstance_3();
        tmp_1 = completion.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure($p)));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function startCoroutineCancellable$default(_this_, receiver, completion, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    return startCoroutineCancellable(_this_, receiver, completion, onCancellation);
  }
  function startCoroutineCancellable_0(_this_, fatalCompletion) {
    var tmp;
    try {
      var tmp_0 = intercepted(_this_);
      var tmp0_success_0_4 = Companion_getInstance_3();
      var tmp_1 = _Result___init__impl_(Unit_getInstance());
      tmp = resumeCancellableWith$default(tmp_0, tmp_1, null, 2, null);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var tmp0_failure_0_2 = Companion_getInstance_3();
        tmp_2 = fatalCompletion.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure($p)));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function startUndispatchedOrReturn(_this_, receiver, block) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      try {
        tmp = block(receiver, _this_);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          tmp_0 = CompletedExceptionally_init_$Create$($p, false, 2, null);
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var result_1 = tmp;
      if (result_1 === _get_COROUTINE_SUSPENDED_()) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var state_3 = _this_.makeCompletingOnce_wi7j7l_k$(result_1);
      if (state_3 === COMPLETING_WAITING_CHILDREN) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var tmp_1;
      if (state_3 instanceof CompletedExceptionally) {
        var tmp_2;
        var tmp0__anonymous__5 = state_3._cause;
        {
          throw recoverStackTrace(state_3._cause, _this_._uCont);
        }
        tmp_1 = tmp_2;
      } else {
        {
          tmp_1 = unboxState(state_3);
        }
      }
      tmp$ret$0 = tmp_1;
    }
     while (false);
    return tmp$ret$0;
  }
  function startCoroutineUndispatched(_this_, receiver, completion) {
    var tmp$ret$0;
    l$ret$1: do {
      var actualCompletion_1 = completion;
      var tmp;
      try {
        var tmp0_withCoroutineContext_0_8 = completion._get_context__0_k$();
        tmp = _this_(receiver, actualCompletion_1);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp0_failure_0_1_4 = Companion_getInstance_3();
          actualCompletion_1.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure($p)));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var value_2 = tmp;
      if (!(value_2 === _get_COROUTINE_SUSPENDED_())) {
        var tmp0_resume_0_5 = (value_2 == null ? true : isObject(value_2)) ? value_2 : THROW_CCE();
        var tmp0_success_0_1_6 = Companion_getInstance_3();
        actualCompletion_1.resumeWith_bnunh2_k$(_Result___init__impl_(tmp0_resume_0_5));
      }}
     while (false);
  }
  function startUndispatchedOrReturnIgnoreTimeout(_this_, receiver, block) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      try {
        tmp = block(receiver, _this_);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          tmp_0 = CompletedExceptionally_init_$Create$($p, false, 2, null);
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var result_1 = tmp;
      if (result_1 === _get_COROUTINE_SUSPENDED_()) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var state_3 = _this_.makeCompletingOnce_wi7j7l_k$(result_1);
      if (state_3 === COMPLETING_WAITING_CHILDREN) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var tmp_1;
      if (state_3 instanceof CompletedExceptionally) {
        var tmp_2;
        var tmp0__anonymous__5 = state_3._cause;
        var tmp_3;
        if (tmp0__anonymous__5 instanceof TimeoutCancellationException) {
          tmp_3 = tmp0__anonymous__5._coroutine === _this_;
        } else {
          {
            tmp_3 = false;
          }
        }
        if (!tmp_3) {
          throw recoverStackTrace(state_3._cause, _this_._uCont);
        } else {
          if (result_1 instanceof CompletedExceptionally) {
            throw recoverStackTrace(result_1._cause, _this_._uCont);
          } else {
            {
              tmp_2 = result_1;
            }
          }
        }
        tmp_1 = tmp_2;
      } else {
        {
          tmp_1 = unboxState(state_3);
        }
      }
      tmp$ret$0 = tmp_1;
    }
     while (false);
    return tmp$ret$0;
  }
  function SelectClause0() {
  }
  SelectClause0.$metadata$ = {
    simpleName: 'SelectClause0',
    kind: 'interface',
    interfaces: []
  };
  function SelectClause1() {
  }
  SelectClause1.$metadata$ = {
    simpleName: 'SelectClause1',
    kind: 'interface',
    interfaces: []
  };
  function CompletionHandlerBase() {
    LinkedListNode.call(this);
  }
  CompletionHandlerBase.$metadata$ = {
    simpleName: 'CompletionHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function invokeIt(_this_, cause) {
    var tmp0_subject = typeof _this_;
    if (tmp0_subject === 'function')
      _this_(cause);
    else {
      _this_.invoke(cause);
    }
  }
  function CancelHandlerBase() {
  }
  CancelHandlerBase.$metadata$ = {
    simpleName: 'CancelHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function toDebugString(_this_) {
    return toString_1(_this_);
  }
  function newCoroutineContext(_this_, context) {
    var combined = _this_._get_coroutineContext__0_k$().plus_d7pszg_k$(context);
    return (!(combined === Dispatchers_getInstance()._Default_0) ? combined.get_9uvjra_k$(Key_getInstance()) == null : false) ? combined.plus_d7pszg_k$(Dispatchers_getInstance()._Default_0) : combined;
  }
  function _get_coroutineName_(_this_) {
    return null;
  }
  function createDefaultDispatcher() {
    var tmp;
    if ((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.product == 'ReactNative' : false) {
      tmp = NodeDispatcher_getInstance();
    } else {
      if (isJsdom()) {
        tmp = NodeDispatcher_getInstance();
      } else {
        var tmp_0;
        var tmp_1;
        if (!(typeof window === 'undefined')) {
          var tmp0_asDynamic_0 = window;
          tmp_1 = tmp0_asDynamic_0 != null;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var tmp1_asDynamic_0 = window;
          tmp_0 = !(typeof tmp1_asDynamic_0.addEventListener === 'undefined');
        } else {
          {
            tmp_0 = false;
          }
        }
        if (tmp_0) {
          tmp = asCoroutineDispatcher(window);
        } else {
          if (typeof process === 'undefined') {
            tmp = SetTimeoutDispatcher_getInstance();
          } else {
            {
              tmp = NodeDispatcher_getInstance();
            }
          }
        }
      }
    }
    return tmp;
  }
  function isJsdom() {
    return ((((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.userAgent != null : false) ? !(typeof navigator.userAgent === 'undefined') : false) ? !(typeof navigator.userAgent.match === 'undefined') : false) ? navigator.userAgent.match('\\bjsdom\\b') : false;
  }
  function _get_DefaultDelay_() {
    var tmp = Dispatchers_getInstance()._Default_0;
    return isInterface(tmp, Delay) ? tmp : THROW_CCE();
  }
  function handleCoroutineExceptionImpl(context, exception) {
    console.error(exception);
  }
  var counter;
  var DEBUG;
  function _get_classSimpleName_(_this_) {
    var tmp0_elvis_lhs = getKClassFromExpression_0(_this_)._get_simpleName__0_k$();
    return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
  }
  function _get_hexAddress_(_this_) {
    var result = _this_.__debug_counter;
    if (!(typeof result === 'number')) {
      counter = counter + 1 | 0;
      result = counter;
      _this_.__debug_counter = result;
    }return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
  }
  function Dispatchers() {
    Dispatchers_instance = this;
    this._Default_0 = createDefaultDispatcher();
    this._Main = new JsMainDispatcher(this._Default_0, false);
    this._Unconfined = Unconfined_getInstance();
  }
  Dispatchers.$metadata$ = {
    simpleName: 'Dispatchers',
    kind: 'object',
    interfaces: []
  };
  var Dispatchers_instance;
  function Dispatchers_getInstance() {
    if (Dispatchers_instance == null)
      new Dispatchers();
    return Dispatchers_instance;
  }
  function JsMainDispatcher(delegate, invokeImmediately) {
    MainCoroutineDispatcher.call(this);
    this._delegate_1 = delegate;
    this._invokeImmediately = invokeImmediately;
    this._immediate = this._invokeImmediately ? this : new JsMainDispatcher(this._delegate_1, true);
  }
  JsMainDispatcher.prototype._get_immediate__0_k$ = function () {
    return this._immediate;
  };
  JsMainDispatcher.prototype.isDispatchNeeded_d7pszg_k$ = function (context) {
    return !this._invokeImmediately;
  };
  JsMainDispatcher.prototype.dispatch_7n0ou3_k$ = function (context, block) {
    return this._delegate_1.dispatch_7n0ou3_k$(context, block);
  };
  JsMainDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0_k$();
    return tmp0_elvis_lhs == null ? this._delegate_1.toString() : tmp0_elvis_lhs;
  };
  JsMainDispatcher.$metadata$ = {
    simpleName: 'JsMainDispatcher',
    kind: 'class',
    interfaces: []
  };
  function createEventLoop() {
    return new UnconfinedEventLoop();
  }
  function UnconfinedEventLoop() {
    EventLoop.call(this);
  }
  UnconfinedEventLoop.prototype.dispatch_7n0ou3_k$ = function (context, block) {
    unsupported();
  };
  UnconfinedEventLoop.$metadata$ = {
    simpleName: 'UnconfinedEventLoop',
    kind: 'class',
    interfaces: []
  };
  function unsupported() {
    throw UnsupportedOperationException_init_$Create$_0('runBlocking event loop is not supported');
  }
  function JobCancellationException(message, cause, job) {
    CancellationException_init_$Init$_0(message, cause, this);
    this._job_1 = job;
    captureStack(this, JobCancellationException);
  }
  JobCancellationException.prototype.toString = function () {
    return '' + CancellationException.prototype.toString.call(this) + '; job=' + this._job_1;
  };
  JobCancellationException.prototype.equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        {
          tmp_2 = false;
        }
      }
      if (tmp_2) {
        tmp_1 = equals_1(other._job_1, this._job_1);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = equals_1(other.cause, this.cause);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  JobCancellationException.prototype.hashCode = function () {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this._job_1) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  JobCancellationException.$metadata$ = {
    simpleName: 'JobCancellationException',
    kind: 'class',
    interfaces: []
  };
  function NodeDispatcher() {
    NodeDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  NodeDispatcher.prototype.scheduleQueueProcessing_sv8swh_k$ = function () {
    process.nextTick(this._get_messageQueue__0_k$()._processQueue);
  };
  NodeDispatcher.$metadata$ = {
    simpleName: 'NodeDispatcher',
    kind: 'object',
    interfaces: []
  };
  var NodeDispatcher_instance;
  function NodeDispatcher_getInstance() {
    if (NodeDispatcher_instance == null)
      new NodeDispatcher();
    return NodeDispatcher_instance;
  }
  function SetTimeoutDispatcher() {
    SetTimeoutDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  SetTimeoutDispatcher.prototype.scheduleQueueProcessing_sv8swh_k$ = function () {
    setTimeout(this._get_messageQueue__0_k$()._processQueue, 0);
    Unit_getInstance();
  };
  SetTimeoutDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutDispatcher',
    kind: 'object',
    interfaces: []
  };
  var SetTimeoutDispatcher_instance;
  function SetTimeoutDispatcher_getInstance() {
    if (SetTimeoutDispatcher_instance == null)
      new SetTimeoutDispatcher();
    return SetTimeoutDispatcher_instance;
  }
  function _no_name_provided__116(this$0) {
    this._this$0_33 = this$0;
  }
  _no_name_provided__116.prototype.invoke_sv8swh_k$ = function () {
    this._this$0_33.process_sv8swh_k$();
  };
  _no_name_provided__116.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__116.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ScheduledMessageQueue($outer) {
    this._$this_8 = $outer;
    MessageQueue.call(this);
    var tmp = this;
    tmp._processQueue = _no_name_provided_$factory_94(this);
  }
  ScheduledMessageQueue.prototype.schedule_sv8swh_k$ = function () {
    this._$this_8.scheduleQueueProcessing_sv8swh_k$();
  };
  ScheduledMessageQueue.prototype.reschedule_sv8swh_k$ = function () {
    setTimeout(this._processQueue, 0);
    Unit_getInstance();
  };
  ScheduledMessageQueue.$metadata$ = {
    simpleName: 'ScheduledMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__117($block) {
    this._$block_0 = $block;
  }
  _no_name_provided__117.prototype.invoke_sv8swh_k$ = function () {
    this._$block_0.run_sv8swh_k$();
  };
  _no_name_provided__117.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__117.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__118($continuation, this$0) {
    this._$continuation = $continuation;
    this._this$0_34 = this$0;
  }
  _no_name_provided__118.prototype.invoke_sv8swh_k$ = function () {
    this._$continuation.resumeUndispatched_eocpx4_k$(this._this$0_34, Unit_getInstance());
  };
  _no_name_provided__118.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__118.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SetTimeoutBasedDispatcher() {
    CoroutineDispatcher.call(this);
    this._messageQueue = new ScheduledMessageQueue(this);
  }
  SetTimeoutBasedDispatcher.prototype._get_messageQueue__0_k$ = function () {
    return this._messageQueue;
  };
  SetTimeoutBasedDispatcher.prototype.dispatch_7n0ou3_k$ = function (context, block) {
    this._messageQueue.enqueue_iz8ddj_k$(block);
  };
  SetTimeoutBasedDispatcher.prototype.invokeOnTimeout_x8mf2g_k$ = function (timeMillis, block, context) {
    var handle = setTimeout(_no_name_provided_$factory_95(block), delayToInt(timeMillis));
    return new ClearTimeout(handle);
  };
  SetTimeoutBasedDispatcher.prototype.scheduleResumeAfterDelay_tkxym4_k$ = function (timeMillis, continuation) {
    var handle = setTimeout(_no_name_provided_$factory_96(continuation, this), delayToInt(timeMillis));
    var tmp0__get_asHandler__0 = new ClearTimeout(handle);
    continuation.invokeOnCancellation_aip8gd_k$(tmp0__get_asHandler__0);
  };
  SetTimeoutBasedDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutBasedDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function MessageQueue() {
    ArrayQueue.call(this);
    this._yieldEvery = 16;
    this._scheduled = false;
  }
  MessageQueue.prototype.enqueue_iz8ddj_k$ = function (element) {
    this.addLast_iav7o_k$(element);
    if (!this._scheduled) {
      this._scheduled = true;
      this.schedule_sv8swh_k$();
    }};
  MessageQueue.prototype.process_sv8swh_k$ = function () {
    try {
      var tmp0_repeat_0 = this._yieldEvery;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_repeat_0)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_elvis_lhs_5 = this.removeFirstOrNull_0_k$();
          var tmp;
          if (tmp0_elvis_lhs_5 == null) {
            return Unit_getInstance();
          } else {
            tmp = tmp0_elvis_lhs_5;
          }
          var element_4 = tmp;
          element_4.run_sv8swh_k$();
        }
         while (inductionVariable < tmp0_repeat_0);
    }finally {
      if (this._get_isEmpty__0_k$()) {
        this._scheduled = false;
      } else {
        this.reschedule_sv8swh_k$();
      }
    }
  };
  MessageQueue.$metadata$ = {
    simpleName: 'MessageQueue',
    kind: 'class',
    interfaces: []
  };
  function delayToInt(timeMillis) {
    return coerceIn_0(timeMillis, new Long(0, 0), new Long(2147483647, 0)).toInt_0_k$();
  }
  function ClearTimeout(handle) {
    CancelHandler.call(this);
    this._handle_1 = handle;
  }
  ClearTimeout.prototype.dispose_sv8swh_k$ = function () {
    clearTimeout(this._handle_1);
  };
  ClearTimeout.prototype.invoke_houul8_k$ = function (cause) {
    this.dispose_sv8swh_k$();
  };
  ClearTimeout.prototype.invoke = function (cause) {
    return this.invoke_houul8_k$(cause);
  };
  ClearTimeout.prototype.toString = function () {
    return '' + 'ClearTimeout[' + this._handle_1 + ']';
  };
  ClearTimeout.$metadata$ = {
    simpleName: 'ClearTimeout',
    kind: 'class',
    interfaces: [DisposableHandle]
  };
  function _no_name_provided__119($continuation, this$0) {
    this._$continuation_0 = $continuation;
    this._this$0_35 = this$0;
  }
  _no_name_provided__119.prototype.invoke_sv8swh_k$ = function () {
    this._$continuation_0.resumeUndispatched_eocpx4_k$(this._this$0_35, Unit_getInstance());
  };
  _no_name_provided__119.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__119.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__120($block) {
    this._$block_1 = $block;
  }
  _no_name_provided__120.prototype.invoke_sv8swh_k$ = function () {
    this._$block_1.run_sv8swh_k$();
  };
  _no_name_provided__120.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__120.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__121(this$0, $handle) {
    this._this$0_36 = this$0;
    this._$handle = $handle;
  }
  _no_name_provided__121.prototype.dispose_sv8swh_k$ = function () {
    this._this$0_36._window.clearTimeout(this._$handle);
  };
  _no_name_provided__121.$metadata$ = {
    kind: 'class',
    interfaces: [DisposableHandle]
  };
  function WindowDispatcher(window_0) {
    CoroutineDispatcher.call(this);
    this._window = window_0;
    this._queue_0 = new WindowMessageQueue(this._window);
  }
  WindowDispatcher.prototype.dispatch_7n0ou3_k$ = function (context, block) {
    return this._queue_0.enqueue_iz8ddj_k$(block);
  };
  WindowDispatcher.prototype.scheduleResumeAfterDelay_tkxym4_k$ = function (timeMillis, continuation) {
    this._window.setTimeout(_no_name_provided_$factory_97(continuation, this), delayToInt(timeMillis));
    Unit_getInstance();
  };
  WindowDispatcher.prototype.invokeOnTimeout_x8mf2g_k$ = function (timeMillis, block, context) {
    var handle = this._window.setTimeout(_no_name_provided_$factory_98(block), delayToInt(timeMillis));
    return new _no_name_provided__121(this, handle);
  };
  WindowDispatcher.$metadata$ = {
    simpleName: 'WindowDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function _no_name_provided__122(this$0) {
    this._this$0_37 = this$0;
  }
  _no_name_provided__122.prototype.invoke_h9nkbz_k$ = function (event) {
    if (event.source == this._this$0_37._window_0 ? event.data == this._this$0_37._messageName : false) {
      event.stopPropagation();
      this._this$0_37.process_sv8swh_k$();
    }};
  _no_name_provided__122.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_h9nkbz_k$((p1 == null ? true : p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__122.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__123(this$0) {
    this._this$0_38 = this$0;
  }
  _no_name_provided__123.prototype.invoke_89eg7z_k$ = function (it) {
    this._this$0_38.process_sv8swh_k$();
  };
  _no_name_provided__123.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_89eg7z_k$(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__123.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function WindowMessageQueue(window_0) {
    MessageQueue.call(this);
    this._window_0 = window_0;
    this._messageName = 'dispatchCoroutine';
    this._window_0.addEventListener('message', _no_name_provided_$factory_99(this), true);
  }
  WindowMessageQueue.prototype.schedule_sv8swh_k$ = function () {
    var tmp = Promise.resolve(Unit_getInstance());
    tmp.then(_no_name_provided_$factory_100(this));
    Unit_getInstance();
  };
  WindowMessageQueue.prototype.reschedule_sv8swh_k$ = function () {
    this._window_0.postMessage(this._messageName, '*');
  };
  WindowMessageQueue.$metadata$ = {
    simpleName: 'WindowMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_94(this$0) {
    var i = new _no_name_provided__116(this$0);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_95($block) {
    var i = new _no_name_provided__117($block);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_96($continuation, this$0) {
    var i = new _no_name_provided__118($continuation, this$0);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_97($continuation, this$0) {
    var i = new _no_name_provided__119($continuation, this$0);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_98($block) {
    var i = new _no_name_provided__120($block);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_99(this$0) {
    var i = new _no_name_provided__122(this$0);
    return function (p1) {
      i.invoke_h9nkbz_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_100(this$0) {
    var i = new _no_name_provided__123(this$0);
    return function (p1) {
      i.invoke_89eg7z_k$(p1);
      return Unit_getInstance();
    };
  }
  function Runnable() {
  }
  Runnable.$metadata$ = {
    simpleName: 'Runnable',
    kind: 'interface',
    interfaces: []
  };
  function SchedulerTask() {
  }
  SchedulerTask.$metadata$ = {
    simpleName: 'SchedulerTask',
    kind: 'class',
    interfaces: [Runnable]
  };
  function _get_taskContext_(_this_) {
    return Unit_getInstance();
  }
  function asCoroutineDispatcher(_this_) {
    var tmp0_elvis_lhs = _this_.coroutineDispatcher;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new WindowDispatcher(_this_);
      _this_.coroutineDispatcher = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AbortFlowException(owner) {
    CancellationException_init_$Init$('Flow was aborted, no more elements needed', this);
    this._owner = owner;
    captureStack(this, AbortFlowException);
  }
  AbortFlowException.$metadata$ = {
    simpleName: 'AbortFlowException',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__124() {
  }
  _no_name_provided__124.prototype.invoke_c68gd4_k$ = function (count_0, _anonymous_parameter_1_) {
    return count_0 + 1 | 0;
  };
  _no_name_provided__124.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_c68gd4_k$(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__124.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SafeCollector(collector, collectContext) {
    this._collector_1 = collector;
    this._collectContext = collectContext;
    var tmp = this;
    tmp._collectContextSize = this._collectContext.fold_cq605b_k$(0, _no_name_provided_$factory_101());
    this._lastEmissionContext = null;
  }
  SafeCollector.prototype.emit_iav7o_k$ = function (value, $cont) {
    var currentContext = $cont._get_context__0_k$();
    ensureActive(currentContext);
    if (!(this._lastEmissionContext === currentContext)) {
      checkContext(this, currentContext);
      this._lastEmissionContext = currentContext;
    }return this._collector_1.emit_iav7o_k$(value, $cont);
  };
  SafeCollector.prototype.releaseIntercepted_sv8swh_k$ = function () {
  };
  SafeCollector.$metadata$ = {
    simpleName: 'SafeCollector',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function _no_name_provided_$factory_101() {
    var i = new _no_name_provided__124();
    return function (p1, p2) {
      return i.invoke_c68gd4_k$(p1, p2);
    };
  }
  function identitySet(expectedSize) {
    return HashSet_init_$Create$(expectedSize);
  }
  function NoOpLock() {
  }
  NoOpLock.$metadata$ = {
    simpleName: 'NoOpLock',
    kind: 'class',
    interfaces: []
  };
  function LinkedListHead() {
    LinkedListNode.call(this);
  }
  LinkedListHead.prototype.remove_0_k$ = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  LinkedListHead.$metadata$ = {
    simpleName: 'LinkedListHead',
    kind: 'class',
    interfaces: []
  };
  function LinkedListNode() {
    this.__next = this;
    this.__prev = this;
    this.__removed = false;
  }
  LinkedListNode.prototype._get__next__0_k$ = function () {
    return this.__next;
  };
  LinkedListNode.prototype.addLast_qdrmxw_k$ = function (node) {
    var prev = this.__prev;
    node.__next = this;
    node.__prev = prev;
    prev.__next = node;
    this.__prev = node;
  };
  LinkedListNode.prototype.remove_0_k$ = function () {
    if (this.__removed)
      return false;
    var prev = this.__prev;
    var next_0 = this.__next;
    prev.__next = next_0;
    next_0.__prev = prev;
    this.__removed = true;
    return true;
  };
  LinkedListNode.prototype.addOneIfEmpty_fpxpjn_k$ = function (node) {
    if (!(this.__next === this))
      return false;
    this.addLast_qdrmxw_k$(node);
    return true;
  };
  LinkedListNode.prototype.helpRemove_sv8swh_k$ = function () {
  };
  LinkedListNode.$metadata$ = {
    simpleName: 'LinkedListNode',
    kind: 'class',
    interfaces: []
  };
  function unwrap(exception) {
    return exception;
  }
  function CoroutineStackFrame() {
  }
  CoroutineStackFrame.$metadata$ = {
    simpleName: 'CoroutineStackFrame',
    kind: 'interface',
    interfaces: []
  };
  function recoverStackTrace(exception, continuation) {
    return exception;
  }
  function systemProp_1(propertyName) {
    return null;
  }
  function threadContextElements(context) {
    return 0;
  }
  function CommonThreadLocal() {
    this._value_10 = null;
  }
  CommonThreadLocal.prototype.get_0_k$ = function () {
    var tmp = this._value_10;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  CommonThreadLocal.prototype.set_iav7o_k$ = function (value) {
    this._value_10 = value;
  };
  CommonThreadLocal.$metadata$ = {
    simpleName: 'CommonThreadLocal',
    kind: 'class',
    interfaces: []
  };
  function $writeCOROUTINE$0(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__7 = _this_;
    this._buffer_5 = buffer;
    this._offset_1 = offset_0;
    this._len = len;
  }
  $writeCOROUTINE$0.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            if (this._len <= 0)
              return Unit_getInstance();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this.__this__7._temp_6._get_availableRead__0_k$() > this.__this__7._bufferSize)) {
              this._state_1 = 3;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = this.__this__7._notifyRead.receive_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            this.__this__7._temp_6.write_irqg4d_k$(this._buffer_5, this._offset_1, this._len);
            Unit_getInstance();
            this._state_1 = 4;
            suspendResult = this.__this__7._notifyWrite.send_jxzaet_k$(Unit_getInstance(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$0.$metadata$ = {
    simpleName: '$writeCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $readCOROUTINE$1(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__8 = _this_;
    this._buffer_6 = buffer;
    this._offset_2 = offset_0;
    this._len_0 = len;
  }
  $readCOROUTINE$1.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            if (this._len_0 <= 0)
              return this._len_0;
            this._state_1 = 1;
            suspendResult = this.__this__8._notifyRead.send_jxzaet_k$(Unit_getInstance(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!(!this.__this__8._completed ? this.__this__8._temp_6._get_availableRead__0_k$() === 0 : false)) {
              this._state_1 = 4;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = this.__this__8._notifyWrite.receive_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._state_1 = 2;
            continue $sm;
          case 4:
            if (this.__this__8._completed ? this.__this__8._temp_6._get_availableRead__0_k$() === 0 : false)
              return -1;
            return this.__this__8._temp_6.read_irqg4d_k$(this._buffer_6, this._offset_2, this._len_0);
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$1.$metadata$ = {
    simpleName: '$readCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function AsyncByteArrayDeque(bufferSize) {
    this._bufferSize = bufferSize;
    var tmp = this;
    Factory_getInstance();
    tmp._notifyRead = Channel$default(-1, null, null, 6, null);
    var tmp_0 = this;
    Factory_getInstance();
    tmp_0._notifyWrite = Channel$default(-1, null, null, 6, null);
    var tmp_1 = this;
    var tmp_2 = ilog2_0(this._bufferSize) + 1 | 0;
    tmp_1._temp_6 = ByteArrayDeque_init_$Create$(tmp_2, false, 2, null);
    this._completed = false;
  }
  AsyncByteArrayDeque.prototype.write_ysdrhq_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $writeCOROUTINE$0(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncByteArrayDeque.prototype.read_irqg4d_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $readCOROUTINE$1(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncByteArrayDeque.prototype.close_sv8swh_k$ = function ($cont) {
    this._completed = true;
    return this._notifyWrite.send_jxzaet_k$(Unit_getInstance(), $cont);
  };
  AsyncByteArrayDeque.$metadata$ = {
    simpleName: 'AsyncByteArrayDeque',
    kind: 'class',
    interfaces: [AsyncOutputStream, AsyncInputStream]
  };
  function AsyncCloseable() {
  }
  AsyncCloseable.$metadata$ = {
    simpleName: 'AsyncCloseable',
    kind: 'interface',
    interfaces: []
  };
  var DEFAULT_SUSPEND_TEST_TIMEOUT;
  function launchImmediately(context, callback) {
    return launchImmediately_0(CoroutineScope_0(context), callback);
  }
  function launchImmediately_0(_this_, callback) {
    return _launch(_this_, CoroutineStart_UNDISPATCHED_getInstance(), callback);
  }
  function _launch(_this_, start, callback) {
    var tmp = _this_._get_coroutineContext__0_k$();
    return launch(_this_, tmp, start, _no_name_provided_$factory_102(callback, null));
  }
  function asyncImmediately(context, callback) {
    return asyncImmediately_0(CoroutineScope_0(context), callback);
  }
  function asyncImmediately_0(_this_, callback) {
    return _async(_this_, CoroutineStart_UNDISPATCHED_getInstance(), callback);
  }
  function _async(_this_, start, callback) {
    var tmp = _this_._get_coroutineContext__0_k$();
    return async(_this_, tmp, start, _no_name_provided_$factory_103(callback, null));
  }
  function launchUnscopedAndWait(_this_, block, $cont) {
    var deferred = CompletableDeferred$default(null, 1, null);
    startCoroutine(block, new _no_name_provided__127(_this_, deferred));
    return deferred.await_0_k$($cont);
  }
  function launchUnscoped(_this_, block) {
    return launchUnscoped_0(_this_._get_coroutineContext__0_k$(), block);
  }
  function launchUnscoped_0(_this_, block) {
    startCoroutine(block, new _no_name_provided__128(_this_));
  }
  function launch_0(context, callback) {
    return launchImmediately_0(CoroutineScope_0(context), callback);
  }
  function _no_name_provided__125($callback, resultContinuation) {
    this._$callback = $callback;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__125.prototype.invoke_2i3g7c_k$ = function ($this$launch, $cont) {
    var tmp = this.create_y6imfn_k$($this$launch, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__125.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_2i3g7c_k$((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__125.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$callback(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof CancellationException) {
              var e = this._exception_0;
              throw e;
            } else {
              {
                var tmp_1 = this._exception_0;
                if (tmp_1 instanceof Error) {
                  var e_0 = this._exception_0;
                  printStackTrace_0(e_0);
                  throw e_0;
                } else {
                  {
                    throw this._exception_0;
                  }
                }
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__125.prototype.create_y6imfn_k$ = function ($this$launch, completion) {
    var i = new _no_name_provided__125(this._$callback, completion);
    i._$this$launch = $this$launch;
    return i;
  };
  _no_name_provided__125.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__126($callback, resultContinuation) {
    this._$callback_0 = $callback;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__126.prototype.invoke_mzru1z_k$ = function ($this$async, $cont) {
    var tmp = this.create_y6imfn_k$($this$async, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__126.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_mzru1z_k$((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__126.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$callback_0(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._TRY_RESULT0 = suspendResult;
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof CancellationException) {
              var e = this._exception_0;
              var tmp_1 = this;
              throw e;
            } else {
              {
                var tmp_2 = this._exception_0;
                if (tmp_2 instanceof Error) {
                  var e_0 = this._exception_0;
                  var tmp_3 = this;
                  printStackTrace_0(e_0);
                  throw e_0;
                } else {
                  {
                    throw this._exception_0;
                  }
                }
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return this._TRY_RESULT0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__126.prototype.create_y6imfn_k$ = function ($this$async, completion) {
    var i = new _no_name_provided__126(this._$callback_0, completion);
    i._$this$async = $this$async;
    return i;
  };
  _no_name_provided__126.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__127($this_launchUnscopedAndWait, $deferred) {
    this._$this_launchUnscopedAndWait = $this_launchUnscopedAndWait;
    this._$deferred = $deferred;
    this._context_1 = this._$this_launchUnscopedAndWait;
  }
  _no_name_provided__127.prototype._get_context__0_k$ = function () {
    return this._context_1;
  };
  _no_name_provided__127.prototype.resumeWith_bnunh2_k$ = function (result) {
    completeWith(this._$deferred, result);
    Unit_getInstance();
  };
  _no_name_provided__127.$metadata$ = {
    kind: 'class',
    interfaces: [Continuation]
  };
  function _no_name_provided__128($this_launchUnscoped) {
    this._$this_launchUnscoped = $this_launchUnscoped;
    this._context_2 = this._$this_launchUnscoped;
  }
  _no_name_provided__128.prototype._get_context__0_k$ = function () {
    return this._context_2;
  };
  _no_name_provided__128.prototype.resumeWith_6zvzl9_k$ = function (result) {
    if (_Result___get_isFailure__impl_(result)) {
      var tmp0_safe_receiver = Result__exceptionOrNull_impl(result);
      if (tmp0_safe_receiver == null)
        null;
      else {
        printStackTrace_0(tmp0_safe_receiver);
        Unit_getInstance();
      }
      Unit_getInstance();
    }};
  _no_name_provided__128.prototype.resumeWith_bnunh2_k$ = function (result) {
    return this.resumeWith_6zvzl9_k$(result);
  };
  _no_name_provided__128.$metadata$ = {
    kind: 'class',
    interfaces: [Continuation]
  };
  function _no_name_provided_$factory_102($callback, resultContinuation) {
    var i = new _no_name_provided__125($callback, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_2i3g7c_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_103($callback, resultContinuation) {
    var i = new _no_name_provided__126($callback, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_mzru1z_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function DEFAULT_SUSPEND_TEST_TIMEOUT$init$() {
    return Companion_getInstance_92().fromSeconds_ttklb2_k$(20.0);
  }
  function _no_name_provided__129($oldPromise, $func, resultContinuation) {
    this._$oldPromise = $oldPromise;
    this._$func = $func;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__129.prototype.invoke_0_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__129.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._tmp0_safe_receiver0 = this._$oldPromise;
            if (this._tmp0_safe_receiver0 == null) {
              this._WHEN_RESULT1 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0.await_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            Unit_getInstance();
            this._state_1 = 3;
            suspendResult = this._$func(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__129.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__129(this._$oldPromise, this._$func, completion);
    return i;
  };
  _no_name_provided__129.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $invokeCOROUTINE$4(_this_, func, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__9 = _this_;
    this._func = func;
  }
  $invokeCOROUTINE$4.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            tmp_0._task0 = this.__this__9.sync_o46ou5_k$(this._get_context__0_k$(), this._func);
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._task0.await_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var res = suspendResult;
            return res;
          case 2:
            this._exceptionState = 3;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              throw e;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$4.$metadata$ = {
    simpleName: '$invokeCOROUTINE$4',
    kind: 'class',
    interfaces: []
  };
  function AsyncThread() {
    this._lastPromise = null;
  }
  AsyncThread.prototype.invoke_bdq1br_k$ = function (func, $cont) {
    var tmp = new $invokeCOROUTINE$4(this, func, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncThread.prototype.sync_o46ou5_k$ = function (context, func) {
    var oldPromise = this._lastPromise;
    var promise = asyncImmediately(context, _no_name_provided_$factory_104(oldPromise, func, null));
    this._lastPromise = promise;
    return promise;
  };
  AsyncThread.$metadata$ = {
    simpleName: 'AsyncThread',
    kind: 'class',
    interfaces: [AsyncInvokable]
  };
  function AsyncInvokable() {
  }
  AsyncInvokable.$metadata$ = {
    simpleName: 'AsyncInvokable',
    kind: 'interface',
    interfaces: []
  };
  function AsyncThread2() {
    this._lock_1 = new Lock();
    this._lastPromise_0 = CompletableDeferred_1(Unit_getInstance());
  }
  AsyncThread2.$metadata$ = {
    simpleName: 'AsyncThread2',
    kind: 'class',
    interfaces: [AsyncInvokable]
  };
  function _no_name_provided_$factory_104($oldPromise, $func, resultContinuation) {
    var i = new _no_name_provided__129($oldPromise, $func, resultContinuation);
    var l = function ($cont) {
      return i.invoke_0_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function toChannel(_this_, $cont) {
    return produce$default(0, _no_name_provided_$factory_105(_this_, null), 1, null, $cont);
  }
  function produce_1(capacity, block, $cont) {
    var tmp = CoroutineScope_0($cont._get_context__0_k$());
    return produce(tmp, $cont._get_context__0_k$(), capacity, block);
  }
  function produce$default(capacity, block, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      capacity = 0;
    return produce_1(capacity, block, $cont);
  }
  function _no_name_provided__130($this_toChannel, resultContinuation) {
    this._$this_toChannel = $this_toChannel;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__130.prototype.invoke_v1qnec_k$ = function ($this$produce, $cont) {
    var tmp = this.create_gnusrd_k$($this$produce, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__130.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_v1qnec_k$((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__130.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._tmp0_iterator0 = this._$this_toChannel.iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator0.hasNext_0_k$()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._v1_2 = this._tmp0_iterator0.next_0_k$();
            this._state_1 = 2;
            suspendResult = this._$this$produce.send_jxzaet_k$(this._v1_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__130.prototype.create_gnusrd_k$ = function ($this$produce, completion) {
    var i = new _no_name_provided__130(this._$this_toChannel, completion);
    i._$this$produce = $this$produce;
    return i;
  };
  _no_name_provided__130.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided_$factory_105($this_toChannel, resultContinuation) {
    var i = new _no_name_provided__130($this_toChannel, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_v1qnec_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function delay_0(time, $cont) {
    return delay(_TimeSpan___get_millisecondsLong__impl_(time), $cont);
  }
  function delay_1(_this_, time, $cont) {
    return delay(_TimeSpan___get_millisecondsLong__impl_(time), $cont);
  }
  function withTimeout_0(time, block, $cont) {
    var tmp = new $withTimeoutCOROUTINE$7(time, block, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function $withTimeoutCOROUTINE$7(time, block, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._time_1 = time;
    this._block_0 = block;
  }
  $withTimeoutCOROUTINE$7.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            if (equals_1(new TimeSpan(this._time_1), new TimeSpan(Companion_getInstance_92()._NIL))) {
              this._state_1 = 2;
              suspendResult = this._block_0(CoroutineScope_0(this._get_context__0_k$()), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = withTimeout(_TimeSpan___get_millisecondsLong__impl_(this._time_1), this._block_0, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT0 = suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._WHEN_RESULT0 = suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            return this._WHEN_RESULT0;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $withTimeoutCOROUTINE$7.$metadata$ = {
    simpleName: '$withTimeoutCOROUTINE$7',
    kind: 'class',
    interfaces: []
  };
  function Signal_init_$Init$(onRegister, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      onRegister = _no_name_provided_$factory_106();
    }Signal.call($this, onRegister);
    return $this;
  }
  function Signal_init_$Create$(onRegister, $mask0, $marker) {
    return Signal_init_$Init$(onRegister, $mask0, $marker, Object.create(Signal.prototype));
  }
  function _no_name_provided__131() {
  }
  _no_name_provided__131.prototype.invoke_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  _no_name_provided__131.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__131.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Signal(onRegister) {
    BaseSignal.call(this, onRegister);
  }
  Signal.prototype.add_o72mru_k$ = function (handler) {
    return this._add_ohhqd7_k$(false, handler);
  };
  Signal.prototype.invoke_o72mru_k$ = function (handler) {
    return this.add_o72mru_k$(handler);
  };
  Signal.prototype.invoke_iav7o_k$ = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      if (this._handlers.isEmpty_0_k$()) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }try {
        var tmp0_this_1 = this;
        var tmp1_2 = tmp0_this_1._iterating;
        tmp0_this_1._iterating = tmp1_2 + 1 | 0;
        Unit_getInstance();
        var tmp0_fastIterateRemove_0 = this._handlers;
        var n_1 = 0;
        var m_2 = 0;
        while (n_1 < tmp0_fastIterateRemove_0._get_size__0_k$()) {
          if (m_2 >= 0 ? !(m_2 === n_1) : false) {
            tmp0_fastIterateRemove_0.set_ddb1qf_k$(m_2, tmp0_fastIterateRemove_0.get_ha5a7z_k$(n_1));
            Unit_getInstance();
          }var tmp1__anonymous__3_6 = tmp0_fastIterateRemove_0.get_ha5a7z_k$(n_1);
          var remove_4_7 = tmp1__anonymous__3_6._once;
          var tmp5__anonymous__8 = tmp1__anonymous__3_6._item;
          tmp5__anonymous__8(value);
          if (remove_4_7) {
            var tmp0_3 = m_2;
            m_2 = tmp0_3 - 1 | 0;
            Unit_getInstance();
          } else {
          }
          var tmp1_4 = n_1;
          n_1 = tmp1_4 + 1 | 0;
          Unit_getInstance();
          var tmp2_5 = m_2;
          m_2 = tmp2_5 + 1 | 0;
          Unit_getInstance();
        }
        while (tmp0_fastIterateRemove_0._get_size__0_k$() > m_2) {
          tmp0_fastIterateRemove_0.removeAt_ha5a7z_k$(tmp0_fastIterateRemove_0._get_size__0_k$() - 1 | 0);
          Unit_getInstance();
        }
        Unit_getInstance();
      }finally {
        var tmp2_this_5 = this;
        var tmp3_6 = tmp2_this_5._iterating;
        tmp2_this_5._iterating = tmp3_6 - 1 | 0;
        Unit_getInstance();
        var tmp2_isNotEmpty_0 = this._handlersToRemove;
        if (!tmp2_isNotEmpty_0.isEmpty_0_k$()) {
          var tmp3_fastIterateRemove_0 = this._handlersToRemove;
          var n_1_0 = 0;
          var m_2_0 = 0;
          while (n_1_0 < tmp3_fastIterateRemove_0._get_size__0_k$()) {
            if (m_2_0 >= 0 ? !(m_2_0 === n_1_0) : false) {
              tmp3_fastIterateRemove_0.set_ddb1qf_k$(m_2_0, tmp3_fastIterateRemove_0.get_ha5a7z_k$(n_1_0));
              Unit_getInstance();
            }var tmp4__anonymous__7_6 = tmp3_fastIterateRemove_0.get_ha5a7z_k$(n_1_0);
            this._handlers.remove_2bq_k$(tmp4__anonymous__7_6);
            Unit_getInstance();
            {
              var tmp0_3_0 = m_2_0;
              m_2_0 = tmp0_3_0 - 1 | 0;
              Unit_getInstance();
            }
            var tmp1_4_0 = n_1_0;
            n_1_0 = tmp1_4_0 + 1 | 0;
            Unit_getInstance();
            var tmp2_5_0 = m_2_0;
            m_2_0 = tmp2_5_0 + 1 | 0;
            Unit_getInstance();
          }
          while (tmp3_fastIterateRemove_0._get_size__0_k$() > m_2_0) {
            tmp3_fastIterateRemove_0.removeAt_ha5a7z_k$(tmp3_fastIterateRemove_0._get_size__0_k$() - 1 | 0);
            Unit_getInstance();
          }
          Unit_getInstance();
        } else {
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  Signal.$metadata$ = {
    simpleName: 'Signal',
    kind: 'class',
    interfaces: []
  };
  function Node_0($outer, once, item) {
    this._$this_9 = $outer;
    this._once = once;
    this._item = item;
  }
  Node_0.prototype.close_sv8swh_k$ = function () {
    if (this._$this_9._iterating > 0) {
      this._$this_9._handlersToRemove.add_2bq_k$(this);
      Unit_getInstance();
    } else {
      this._$this_9._handlers.remove_2bq_k$(this);
      Unit_getInstance();
    }
  };
  Node_0.$metadata$ = {
    simpleName: 'Node',
    kind: 'class',
    interfaces: [Closeable]
  };
  function BaseSignal(onRegister) {
    this._onRegister = onRegister;
    this._handlers = FastArrayList_init_$Create$();
    this._handlersToRemove = FastArrayList_init_$Create$();
    this._iterating = 0;
  }
  BaseSignal.prototype._get_listenerCount__0_k$ = function () {
    return this._handlers._get_size__0_k$();
  };
  BaseSignal.prototype._get_hasListeners__0_k$ = function () {
    return this._get_listenerCount__0_k$() > 0;
  };
  BaseSignal.prototype._add_ohhqd7_k$ = function (once, handler) {
    this._onRegister();
    var node = new Node_0(this, once, handler);
    this._handlers.add_2bq_k$(node);
    Unit_getInstance();
    return node;
  };
  BaseSignal.$metadata$ = {
    simpleName: 'BaseSignal',
    kind: 'class',
    interfaces: []
  };
  function AsyncSignal_init_$Init$(onRegister, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      onRegister = _no_name_provided_$factory_107();
    }AsyncSignal.call($this, onRegister);
    return $this;
  }
  function AsyncSignal_init_$Create$(onRegister, $mask0, $marker) {
    return AsyncSignal_init_$Init$(onRegister, $mask0, $marker, Object.create(AsyncSignal.prototype));
  }
  function _no_name_provided__132() {
  }
  _no_name_provided__132.prototype.invoke_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  _no_name_provided__132.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__132.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $invokeCOROUTINE$8(_this_, value, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__10 = _this_;
    this._value_11 = value;
  }
  $invokeCOROUTINE$8.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (this.__this__10._handlers.isEmpty_0_k$()) {
              this._tmp$ret$00 = Unit_getInstance();
              this._state_1 = 10;
              continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            var tmp0_this_1 = this.__this__10;
            var tmp1_2 = tmp0_this_1._iterating;
            tmp0_this_1._iterating = tmp1_2 + 1 | 0;
            Unit_getInstance();
            var tmp_0 = this;
            tmp_0._tmp0_fastIterateRemove_0_32 = this.__this__10._handlers;
            this._n_1_43 = 0;
            this._m_2_54 = 0;
            this._state_1 = 4;
            continue $sm;
          case 4:
            if (!(this._n_1_43 < this._tmp0_fastIterateRemove_0_32._get_size__0_k$())) {
              this._state_1 = 7;
              continue $sm;
            }
            if (this._m_2_54 >= 0 ? !(this._m_2_54 === this._n_1_43) : false) {
              this._tmp0_fastIterateRemove_0_32.set_ddb1qf_k$(this._m_2_54, this._tmp0_fastIterateRemove_0_32.get_ha5a7z_k$(this._n_1_43));
              Unit_getInstance();
            }
            var tmp_1 = this;
            tmp_1._tmp1__anonymous__6_65 = this._tmp0_fastIterateRemove_0_32.get_ha5a7z_k$(this._n_1_43);
            this._remove_7_76 = this._tmp1__anonymous__6_65._once;
            var tmp_2 = this;
            tmp_2._tmp0__anonymous__217 = this._tmp1__anonymous__6_65._item;
            this._state_1 = 5;
            suspendResult = this._tmp0__anonymous__217(this._value_11, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            if (this._remove_7_76) {
              var tmp0_3_8 = this._m_2_54;
              this._m_2_54 = tmp0_3_8 - 1 | 0;
              Unit_getInstance();
              this._state_1 = 6;
              continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 6:
            var tmp1_4_9 = this._n_1_43;
            this._n_1_43 = tmp1_4_9 + 1 | 0;
            Unit_getInstance();
            var tmp2_5_10 = this._m_2_54;
            this._m_2_54 = tmp2_5_10 + 1 | 0;
            Unit_getInstance();
            this._state_1 = 4;
            continue $sm;
          case 7:
            while (this._tmp0_fastIterateRemove_0_32._get_size__0_k$() > this._m_2_54) {
              this._tmp0_fastIterateRemove_0_32.removeAt_ha5a7z_k$(this._tmp0_fastIterateRemove_0_32._get_size__0_k$() - 1 | 0);
              Unit_getInstance();
            }

            var tmp_3 = this;
            tmp_3._tmp$ret$21 = Unit_getInstance();
            this._exceptionState = 11;
            this._state_1 = 8;
            continue $sm;
          case 8:
            var tmp2_this_11 = this.__this__10;
            var tmp3_12 = tmp2_this_11._iterating;
            tmp2_this_11._iterating = tmp3_12 - 1 | 0;
            Unit_getInstance();
            var tmp2_isNotEmpty_0_13 = this.__this__10._handlersToRemove;
            if (!tmp2_isNotEmpty_0_13.isEmpty_0_k$()) {
              var tmp3_fastIterateRemove_0_14 = this.__this__10._handlersToRemove;
              var n_1_15 = 0;
              var m_2_16 = 0;
              while (n_1_15 < tmp3_fastIterateRemove_0_14._get_size__0_k$()) {
                if (m_2_16 >= 0 ? !(m_2_16 === n_1_15) : false) {
                  tmp3_fastIterateRemove_0_14.set_ddb1qf_k$(m_2_16, tmp3_fastIterateRemove_0_14.get_ha5a7z_k$(n_1_15));
                  Unit_getInstance();
                }var tmp4__anonymous__6_17 = tmp3_fastIterateRemove_0_14.get_ha5a7z_k$(n_1_15);
                this.__this__10._handlers.remove_2bq_k$(tmp4__anonymous__6_17);
                Unit_getInstance();
                {
                  var tmp0_3_18 = m_2_16;
                  m_2_16 = tmp0_3_18 - 1 | 0;
                  Unit_getInstance();
                }
                var tmp1_4_19 = n_1_15;
                n_1_15 = tmp1_4_19 + 1 | 0;
                Unit_getInstance();
                var tmp2_5_20 = m_2_16;
                m_2_16 = tmp2_5_20 + 1 | 0;
                Unit_getInstance();
              }
              while (tmp3_fastIterateRemove_0_14._get_size__0_k$() > m_2_16) {
                tmp3_fastIterateRemove_0_14.removeAt_ha5a7z_k$(tmp3_fastIterateRemove_0_14._get_size__0_k$() - 1 | 0);
                Unit_getInstance();
              }
              Unit_getInstance();
            } else {
            }

            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 10;
            continue $sm;
          case 9:
            this._exceptionState = 11;
            var t = this._exception_0;
            var tmp2_this_11_0 = this.__this__10;
            var tmp3_12_0 = tmp2_this_11_0._iterating;
            tmp2_this_11_0._iterating = tmp3_12_0 - 1 | 0;
            Unit_getInstance();
            var tmp2_isNotEmpty_0_13_0 = this.__this__10._handlersToRemove;
            if (!tmp2_isNotEmpty_0_13_0.isEmpty_0_k$()) {
              var tmp3_fastIterateRemove_0_14_0 = this.__this__10._handlersToRemove;
              var n_1_15_0 = 0;
              var m_2_16_0 = 0;
              while (n_1_15_0 < tmp3_fastIterateRemove_0_14_0._get_size__0_k$()) {
                if (m_2_16_0 >= 0 ? !(m_2_16_0 === n_1_15_0) : false) {
                  tmp3_fastIterateRemove_0_14_0.set_ddb1qf_k$(m_2_16_0, tmp3_fastIterateRemove_0_14_0.get_ha5a7z_k$(n_1_15_0));
                  Unit_getInstance();
                }var tmp4__anonymous__6_17_0 = tmp3_fastIterateRemove_0_14_0.get_ha5a7z_k$(n_1_15_0);
                this.__this__10._handlers.remove_2bq_k$(tmp4__anonymous__6_17_0);
                Unit_getInstance();
                {
                  var tmp0_3_18_0 = m_2_16_0;
                  m_2_16_0 = tmp0_3_18_0 - 1 | 0;
                  Unit_getInstance();
                }
                var tmp1_4_19_0 = n_1_15_0;
                n_1_15_0 = tmp1_4_19_0 + 1 | 0;
                Unit_getInstance();
                var tmp2_5_20_0 = m_2_16_0;
                m_2_16_0 = tmp2_5_20_0 + 1 | 0;
                Unit_getInstance();
              }
              while (tmp3_fastIterateRemove_0_14_0._get_size__0_k$() > m_2_16_0) {
                tmp3_fastIterateRemove_0_14_0.removeAt_ha5a7z_k$(tmp3_fastIterateRemove_0_14_0._get_size__0_k$() - 1 | 0);
                Unit_getInstance();
              }
              Unit_getInstance();
            } else {
            }

            throw t;
          case 10:
            return Unit_getInstance();
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$8.$metadata$ = {
    simpleName: '$invokeCOROUTINE$8',
    kind: 'class',
    interfaces: []
  };
  function AsyncSignal(onRegister) {
    BaseSignal.call(this, onRegister);
  }
  AsyncSignal.prototype.invoke_iav7o_k$ = function (value, $cont) {
    var tmp = new $invokeCOROUTINE$8(this, value, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncSignal.$metadata$ = {
    simpleName: 'AsyncSignal',
    kind: 'class',
    interfaces: []
  };
  function invoke(_this_) {
    return _this_.invoke_iav7o_k$(Unit_getInstance());
  }
  function _no_name_provided_$factory_106() {
    var i = new _no_name_provided__131();
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_107() {
    var i = new _no_name_provided__132();
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function runBlockingNoSuspensions(callback) {
    var completed = {_v: false};
    var rresult = {_v: null};
    var resultEx = {_v: null};
    var suspendCount = {_v: 0};
    startCoroutineUndispatched_0(callback, new _no_name_provided__134(suspendCount, resultEx, completed, rresult));
    if (!completed._v) {
      invalidOp('' + 'runBlockingNoSuspensions was not completed synchronously! suspendCount=' + suspendCount._v);
    }if (!(resultEx._v == null))
      throw ensureNotNull(resultEx._v);
    var tmp;
    if (rresult._v == null) {
      throwUninitializedPropertyAccessException('rresult');
    } else {
      tmp = rresult._v;
    }
    return tmp;
  }
  function startCoroutineUndispatched_0(_this_, completion) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      try {
        var tmp0_withCoroutineContext_0_4 = completion._get_context__0_k$();
        tmp = _this_(completion);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp0_failure_0_1 = Companion_getInstance_3();
          completion.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure($p)));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var value_1 = tmp;
      if (!(value_1 === _get_COROUTINE_SUSPENDED_())) {
        var tmp0_resume_0 = (value_1 == null ? true : isObject(value_1)) ? value_1 : THROW_CCE();
        var tmp0_success_0_1 = Companion_getInstance_3();
        completion.resumeWith_bnunh2_k$(_Result___init__impl_(tmp0_resume_0));
      }}
     while (false);
  }
  function _get_unitInstance_($this) {
    return Unit_getInstance();
  }
  function _no_name_provided__133($suspendCount) {
    this._$suspendCount = $suspendCount;
    AbstractCoroutineContextElement.call(this, Key_getInstance());
    this._key_2 = Key_getInstance();
  }
  _no_name_provided__133.prototype._get_key__0_k$ = function () {
    return this._key_2;
  };
  _no_name_provided__133.prototype.interceptContinuation_x4ijla_k$ = function (continuation) {
    var tmp0_2 = this._$suspendCount._v;
    this._$suspendCount._v = tmp0_2 + 1 | 0;
    Unit_getInstance();
    return continuation;
  };
  _no_name_provided__133.prototype.scheduleResumeAfterDelay_tkxym4_k$ = function (timeMillis, continuation) {
    var tmp0_success_0_1 = Companion_getInstance_3();
    return continuation.resumeWith_bnunh2_k$(_Result___init__impl_(Unit_getInstance()));
  };
  _no_name_provided__133.$metadata$ = {
    kind: 'class',
    interfaces: [ContinuationInterceptor, Delay]
  };
  function _no_name_provided__134($suspendCount, $resultEx, $completed, $rresult) {
    this._$suspendCount_0 = $suspendCount;
    this._$resultEx = $resultEx;
    this._$completed = $completed;
    this._$rresult = $rresult;
    var tmp = this;
    tmp._context_3 = new _no_name_provided__133(this._$suspendCount_0);
  }
  _no_name_provided__134.prototype._get_context__0_k$ = function () {
    return this._context_3;
  };
  _no_name_provided__134.prototype.resumeWith_suddo1_k$ = function (result) {
    var exception = Result__exceptionOrNull_impl(result);
    if (!(exception == null)) {
      this._$resultEx._v = exception;
      this._$completed._v = true;
      printStackTrace_0(exception);
    } else {
      throwOnFailure(result);
      var tmp = _Result___get_value__impl_(result);
      var tmp0_elvis_lhs = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp_1 = _get_unitInstance_(this);
        var tmp_2;
        if (isObject(Unit_getInstance())) {
          tmp_2 = Unit_getInstance();
        } else {
          {
            tmp_2 = THROW_CCE();
          }
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var rvalue = tmp_0;
      this._$rresult._v = rvalue;
      this._$completed._v = true;
    }
  };
  _no_name_provided__134.prototype.resumeWith_bnunh2_k$ = function (result) {
    return this.resumeWith_suddo1_k$(result);
  };
  _no_name_provided__134.$metadata$ = {
    kind: 'class',
    interfaces: [Continuation]
  };
  function CompressionMethod() {
  }
  CompressionMethod.prototype.uncompress_hzt0ks_k$ = function (reader_0, out, $cont) {
    unsupported_0();
  };
  CompressionMethod.prototype.compress_ydifiq_k$ = function (i, o, context, $cont) {
    unsupported_0();
  };
  CompressionMethod.$metadata$ = {
    simpleName: 'CompressionMethod',
    kind: 'interface',
    interfaces: []
  };
  function uncompressed(_this_, method, $cont) {
    return uncompressStream(method, _this_, $cont);
  }
  function CompressionContext_init_$Init$(level, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      level = 6;
    CompressionContext.call($this, level);
    return $this;
  }
  function CompressionContext_init_$Create$(level, $mask0, $marker) {
    return CompressionContext_init_$Init$(level, $mask0, $marker, Object.create(CompressionContext.prototype));
  }
  function CompressionContext(level) {
    this._level_0 = level;
    this._name_3 = null;
    this._custom = null;
  }
  CompressionContext.$metadata$ = {
    simpleName: 'CompressionContext',
    kind: 'class',
    interfaces: []
  };
  function uncompressStream(_this_, input, $cont) {
    return asyncStreamWriter$default(0, _no_name_provided_$factory_108(_this_, input, null), 1, null, $cont);
  }
  function uncompress(_this_, i, o, $cont) {
    var tmp = new $uncompressCOROUTINE$11(_this_, i, o, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function uncompress_0(_this_, method, outputSizeHint) {
    var buffer_1 = ByteArrayBuilder_init_$Create$_0(outputSizeHint);
    var s_2 = MemorySyncStream(buffer_1);
    uncompress_1(method, openSync$default(_this_, null, 1, null), s_2);
    return buffer_1.toByteArray_0_k$();
  }
  function uncompress$default(_this_, method, outputSizeHint, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      outputSizeHint = imul(_this_.length, 2);
    return uncompress_0(_this_, method, outputSizeHint);
  }
  function compress(_this_, method, context, outputSizeHint) {
    var buffer_1 = ByteArrayBuilder_init_$Create$_0(outputSizeHint);
    var s_2 = MemorySyncStream(buffer_1);
    compress_0(method, openSync$default(_this_, null, 1, null), s_2, context);
    return buffer_1.toByteArray_0_k$();
  }
  function compress$default(_this_, method, context, outputSizeHint, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      context = CompressionContext_init_$Create$(0, 1, null);
    }if (!(($mask0 & 4) === 0))
      outputSizeHint = numberToInt(_this_.length * 1.1);
    return compress(_this_, method, context, outputSizeHint);
  }
  function uncompress_1(_this_, i, o) {
    return runBlockingNoSuspensions(_no_name_provided_$factory_109(_this_, i, o, null));
  }
  function compress_0(_this_, i, o, context) {
    return runBlockingNoSuspensions(_no_name_provided_$factory_110(_this_, i, o, context, null));
  }
  function compress_1(_this_, i, o, context, $cont) {
    var tmp = new $compressCOROUTINE$12(_this_, i, o, context, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__135($this_uncompressStream, $input, resultContinuation) {
    this._$this_uncompressStream = $this_uncompressStream;
    this._$input_1 = $input;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__135.prototype.invoke_1vupv5_k$ = function (output_0, $cont) {
    var tmp = this.create_oeiigk_k$(output_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__135.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_1vupv5_k$((!(p1 == null) ? isInterface(p1, AsyncOutputStream) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__135.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = uncompress(this._$this_uncompressStream, this._$input_1, this._output_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__135.prototype.create_oeiigk_k$ = function (output_0, completion) {
    var i = new _no_name_provided__135(this._$this_uncompressStream, this._$input_1, completion);
    i._output_2 = output_0;
    return i;
  };
  _no_name_provided__135.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__136($this_uncompress, $i, $o, resultContinuation) {
    this._$this_uncompress = $this_uncompress;
    this._$i = $i;
    this._$o = $o;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__136.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__136.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__136.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = uncompress(this._$this_uncompress, toAsyncInputStream(this._$i), toAsyncOutputStream(this._$o), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__136.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__136(this._$this_uncompress, this._$i, this._$o, completion);
    return i;
  };
  _no_name_provided__136.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__137($this_compress, $i, $o, $context, resultContinuation) {
    this._$this_compress = $this_compress;
    this._$i_0 = $i;
    this._$o_0 = $o;
    this._$context_0 = $context;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__137.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__137.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__137.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = compress_1(this._$this_compress, toAsyncInputStream(this._$i_0), toAsyncOutputStream(this._$o_0), this._$context_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__137.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__137(this._$this_compress, this._$i_0, this._$o_0, this._$context_0, completion);
    return i;
  };
  _no_name_provided__137.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $uncompressCOROUTINE$11(_this_, i, o, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__11 = _this_;
    this._i = i;
    this._o = o;
  }
  $uncompressCOROUTINE$11.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = Companion_getInstance_104().forInput_k2ey2z_k$(this._i, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__11.uncompress_hzt0ks_k$(this._ARGUMENT0, this._o, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $uncompressCOROUTINE$11.$metadata$ = {
    simpleName: '$uncompressCOROUTINE$11',
    kind: 'class',
    interfaces: []
  };
  function $compressCOROUTINE$12(_this_, i, o, context, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__12 = _this_;
    this._i_0 = i;
    this._o_0 = o;
    this._context_4 = context;
  }
  $compressCOROUTINE$12.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = Companion_getInstance_104().forInput_k2ey2z_k$(this._i_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_0 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__12.compress_ydifiq_k$(this._ARGUMENT0_0, this._o_0, this._context_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $compressCOROUTINE$12.$metadata$ = {
    simpleName: '$compressCOROUTINE$12',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_108($this_uncompressStream, $input, resultContinuation) {
    var i = new _no_name_provided__135($this_uncompressStream, $input, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1vupv5_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_109($this_uncompress, $i, $o, resultContinuation) {
    var i = new _no_name_provided__136($this_uncompress, $i, $o, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_110($this_compress, $i, $o, $context, resultContinuation) {
    var i = new _no_name_provided__137($this_compress, $i, $o, $context, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _get_Deflate_() {
    var tmp0_getValue_0 = Deflate$factory();
    return Deflate$delegate._get_value__0_k$();
  }
  var Deflate$delegate;
  function Companion_101() {
    Companion_instance_100 = this;
    this._FLUSH_SIZE = 8388608;
    this._EXTRA_SIZE = 131072;
  }
  Companion_101.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_100;
  function Companion_getInstance_100() {
    if (Companion_instance_100 == null)
      new Companion_101();
    return Companion_instance_100;
  }
  function SlidingWindowWithOutput(sliding, out, flushSize, extraSize) {
    Companion_getInstance_100();
    this._sliding = sliding;
    this._out = out;
    this._flushSize = flushSize;
    this._extraSize = extraSize;
    this._bab = FixedSizeByteArrayBuilder_init_$Create$(this._flushSize + this._extraSize | 0);
  }
  SlidingWindowWithOutput.prototype._get_mustFlush__0_k$ = function () {
    return this._bab._size_7 >= this._flushSize;
  };
  SlidingWindowWithOutput.prototype.getPutCopyOut_rvwcgf_k$ = function (distance, length) {
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this._sliding.getPut_ha5a7z_k$(distance);
        this._bab.appendFast_hpsj51_k$(toByte(v));
      }
       while (inductionVariable < length);
  };
  SlidingWindowWithOutput.prototype.putOut_ysdrhq_k$ = function (bytes, offset_0, len) {
    this._bab.append_ysdrhq_k$(bytes, offset_0, len);
    this._sliding.putBytes_ysdrhq_k$(bytes, offset_0, len);
  };
  SlidingWindowWithOutput.prototype.putOut_hpsj51_k$ = function (byte) {
    this._bab.appendFast_hpsj51_k$(byte);
    this._sliding.put_ha5a7z_k$(byte & 255);
    Unit_getInstance();
  };
  SlidingWindowWithOutput.$metadata$ = {
    simpleName: 'SlidingWindowWithOutput',
    kind: 'class',
    interfaces: []
  };
  function Companion_102() {
    Companion_instance_101 = this;
    DeflatePortable.call(this, 15);
    var tmp = this;
    var tmp_0 = new HuffmanTree();
    var tmp0_apply_0 = new Int32Array(288);
    var inductionVariable = 0;
    if (inductionVariable <= 143)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0[n_3] = 8;
      }
       while (inductionVariable <= 143);
    var inductionVariable_0 = 144;
    if (inductionVariable_0 <= 255)
      do {
        var n_5 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        tmp0_apply_0[n_5] = 9;
      }
       while (inductionVariable_0 <= 255);
    var inductionVariable_1 = 256;
    if (inductionVariable_1 <= 279)
      do {
        var n_7 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        tmp0_apply_0[n_7] = 7;
      }
       while (inductionVariable_1 <= 279);
    var inductionVariable_2 = 280;
    if (inductionVariable_2 <= 287)
      do {
        var n_9 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        tmp0_apply_0[n_9] = 8;
      }
       while (inductionVariable_2 <= 287);
    tmp._FIXED_TREE = tmp_0.fromLengths$default_gakitm_k$(tmp0_apply_0, 0, 0, 6, null);
    var tmp_1 = this;
    var tmp_2 = new HuffmanTree();
    var tmp_3 = 0;
    var tmp_4 = 32;
    var tmp_5 = new Int32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      var tmp_6 = tmp_3;
      tmp_5[tmp_6] = 5;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_1._FIXED_DIST = tmp_2.fromLengths$default_gakitm_k$(tmp_5, 0, 0, 6, null);
    var tmp_7 = this;
    tmp_7._LEN_EXTRA = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0]);
    var tmp_8 = this;
    tmp_8._LEN_BASE = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]);
    var tmp_9 = this;
    tmp_9._DIST_EXTRA = new Int32Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
    var tmp_10 = this;
    tmp_10._DIST_BASE = new Int32Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]);
    var tmp_11 = this;
    tmp_11._HCLENPOS = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  }
  Companion_102.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_101;
  function Companion_getInstance_101() {
    if (Companion_instance_101 == null)
      new Companion_102();
    return Companion_instance_101;
  }
  function $compressCOROUTINE$13(_this_, i, o, context, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__13 = _this_;
    this._i_1 = i;
    this._o_1 = o;
    this._context_5 = context;
  }
  $compressCOROUTINE$13.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = hasAvailable(this._i_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            if (!suspendResult) {
              this._state_1 = 9;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = getAvailable_0(this._i_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._available0 = suspendResult;
            var tmp_0 = this;
            tmp_0._chunkSize1 = (this._available0.compareTo_wiekkq_k$(new Long(65535, 0)) <= 0 ? this._available0 : new Long(65535, 0)).toInt_0_k$();
            this._state_1 = 4;
            suspendResult = write8_0(this._o_1, toLong(this._chunkSize1).compareTo_wiekkq_k$(this._available0) >= 0 ? 1 : 0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._state_1 = 5;
            suspendResult = write16LE_0(this._o_1, this._chunkSize1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._state_1 = 6;
            suspendResult = write16LE_0(this._o_1, ~this._chunkSize1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._state_1 = 7;
            suspendResult = readBytesExact(this._i_1, this._chunkSize1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._ARGUMENT2 = suspendResult;
            this._state_1 = 8;
            suspendResult = writeBytes(this._o_1, this._ARGUMENT2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._state_1 = 1;
            continue $sm;
          case 9:
            return Unit_getInstance();
          case 10:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $compressCOROUTINE$13.$metadata$ = {
    simpleName: '$compressCOROUTINE$13',
    kind: 'class',
    interfaces: []
  };
  function $uncompressCOROUTINE$14(_this_, reader_0, out, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__14 = _this_;
    this._reader = reader_0;
    this._out_0 = out;
  }
  $uncompressCOROUTINE$14.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 20;
            this._sout0 = new SlidingWindowWithOutput(new SlidingWindow(this.__this__14._windowBits), this._out_0, this._reader._bigChunkSize, this._reader._readWithSize);
            this._lastBlock1 = false;
            this._tempTree2 = new HuffmanTree();
            this._tempDist3 = new HuffmanTree();
            this._codeLenCodeLen4 = new Int32Array(32);
            this._lengths5 = new Int32Array(512);
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!!this._lastBlock1) {
              this._state_1 = 17;
              continue $sm;
            }
            if (false ? true : this._sout0._get_mustFlush__0_k$()) {
              this._state_1 = 2;
              suspendResult = this._sout0._out.write_ysdrhq_k$(this._sout0._bab._data_16, 0, this._sout0._bab._size_7, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            this._sout0._bab.clear_sv8swh_k$();
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (this._reader._get_requirePrepare__0_k$()) {
              this._state_1 = 4;
              suspendResult = this._reader.prepareBytesUpTo_ha5a7z_k$(this._reader._bigChunkSize, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            Unit_getInstance();
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._lastBlock1 = this._reader.sreadBit_0_k$();
            this._blockType6 = this._reader.readBits_ha5a7z_k$(2);
            var containsArg = this._blockType6;
            if (!(0 <= containsArg ? containsArg <= 2 : false)) {
              throw IllegalStateException_init_$Create$_0('invalid bit');
            } else {
            }

            if (this._blockType6 === 0) {
              this._len7 = this._reader.su16LE_0_k$();
              this._nlen8 = this._reader.su16LE_0_k$();
              this._nnlen9 = ~this._nlen8 & 65535;
              if (!(this._len7 === this._nnlen9)) {
                var tmp_0 = this;
                tmp_0._tmp0_error_010 = '' + 'Invalid deflate stream: len(' + this._len7 + ') != ~nlen(' + this._nnlen9 + ') :: nlen=' + this._nlen8;
                throw IllegalStateException_init_$Create$_0(toString_1(this._tmp0_error_010));
              }this._state_1 = 13;
              suspendResult = this._reader.abytes$default_jitirp_k$(this._len7, null, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              if (this._blockType6 === 1) {
                this._tree11 = Companion_getInstance_101()._FIXED_TREE;
                this._dist12 = Companion_getInstance_101()._FIXED_DIST;
              } else {
                var hlit = this._reader.readBits_ha5a7z_k$(5) + 257 | 0;
                var hdist = this._reader.readBits_ha5a7z_k$(5) + 1 | 0;
                var hclen = this._reader.readBits_ha5a7z_k$(4) + 4 | 0;
                var tmp1_fill_0 = this._codeLenCodeLen4.length;
                fill_0(this._codeLenCodeLen4, 0, 0, tmp1_fill_0);
                var inductionVariable = 0;
                if (inductionVariable < hclen)
                  do {
                    var i = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    this._codeLenCodeLen4[Companion_getInstance_101()._HCLENPOS[i]] = this._reader.readBits_ha5a7z_k$(3);
                  }
                   while (inductionVariable < hclen);
                this._tempTree2.setFromLengths$default_fc0b9j_k$(this._codeLenCodeLen4, 0, 0, 6, null);
                var codeLen = this._tempTree2;
                var hlithdist = hlit + hdist | 0;
                var n = 0;
                var tmp2_fill_0 = this._lengths5.length;
                fill_0(this._lengths5, 0, 0, tmp2_fill_0);
                while (n < hlithdist) {
                  var value = codeLen.read_ifkopv_k$(this._reader);
                  if (!(0 <= value ? value <= 18 : false)) {
                    throw IllegalStateException_init_$Create$_0('Invalid');
                  }var tmp1_subject = value;
                  {
                    var len;
                    switch (tmp1_subject) {
                      case 16:
                        len = this._reader.readBits_ha5a7z_k$(2) + 3 | 0;
                        break;
                      case 17:
                        len = this._reader.readBits_ha5a7z_k$(3) + 3 | 0;
                        break;
                      case 18:
                        len = this._reader.readBits_ha5a7z_k$(7) + 11 | 0;
                        break;
                      default:len = 1;
                        break;
                    }
                  }
                  var tmp2_subject = value;
                  {
                    var vv;
                    switch (tmp2_subject) {
                      case 16:
                        vv = this._lengths5[n - 1 | 0];
                        break;
                      case 17:
                        vv = 0;
                        break;
                      case 18:
                        vv = 0;
                        break;
                      default:vv = value;
                        break;
                    }
                  }
                  var tmp3_fill_0 = n;
                  var tmp4_fill_0 = n + len | 0;
                  fill_0(this._lengths5, vv, tmp3_fill_0, tmp4_fill_0);
                  n = n + len | 0;
                }
                this._tempTree2.setFromLengths_6gxn8n_k$(this._lengths5, 0, hlit);
                this._tempDist3.setFromLengths_6gxn8n_k$(this._lengths5, hlit, hlithdist);
                this._tree11 = this._tempTree2;
                this._dist12 = this._tempDist3;
              }
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 6:
            if (false) {
              this._state_1 = 12;
              continue $sm;
            }
            if (this._reader._get_requirePrepare__0_k$()) {
              this._state_1 = 7;
              suspendResult = this._reader.prepareBytesUpTo_ha5a7z_k$(this._reader._bigChunkSize, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 8;
              continue $sm;
            }

            break;
          case 7:
            Unit_getInstance();
            this._state_1 = 8;
            continue $sm;
          case 8:
            this._value13 = this._tree11.read_ifkopv_k$(this._reader);
            if (this._value13 === 256) {
              this._state_1 = 12;
              continue $sm;
            } else {
              this._state_1 = 9;
              continue $sm;
            }

            break;
          case 9:
            if (this._value13 < 256) {
              this._sout0.putOut_hpsj51_k$(toByte(this._value13));
            } else {
              var zlenof = this._value13 - 257 | 0;
              var lengthExtra = this._reader.readBits_ha5a7z_k$(Companion_getInstance_101()._LEN_EXTRA[zlenof]);
              var distanceData = this._dist12.read_ifkopv_k$(this._reader);
              var distanceExtra = this._reader.readBits_ha5a7z_k$(Companion_getInstance_101()._DIST_EXTRA[distanceData]);
              var distance = Companion_getInstance_101()._DIST_BASE[distanceData] + distanceExtra | 0;
              var length = Companion_getInstance_101()._LEN_BASE[zlenof] + lengthExtra | 0;
              this._sout0.getPutCopyOut_rvwcgf_k$(distance, length);
            }

            if (false ? true : this._sout0._get_mustFlush__0_k$()) {
              this._state_1 = 10;
              suspendResult = this._sout0._out.write_ysdrhq_k$(this._sout0._bab._data_16, 0, this._sout0._bab._size_7, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 11;
              continue $sm;
            }

            break;
          case 10:
            this._sout0._bab.clear_sv8swh_k$();
            this._state_1 = 11;
            continue $sm;
          case 11:
            this._state_1 = 6;
            continue $sm;
          case 12:
            this._state_1 = 16;
            continue $sm;
          case 13:
            this._bytes14 = suspendResult;
            this._sout0.putOut_ysdrhq_k$(this._bytes14, 0, this._len7);
            if (false ? true : this._sout0._get_mustFlush__0_k$()) {
              this._state_1 = 14;
              suspendResult = this._sout0._out.write_ysdrhq_k$(this._sout0._bab._data_16, 0, this._sout0._bab._size_7, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 15;
              continue $sm;
            }

            break;
          case 14:
            this._sout0._bab.clear_sv8swh_k$();
            this._state_1 = 15;
            continue $sm;
          case 15:
            this._state_1 = 16;
            continue $sm;
          case 16:
            this._state_1 = 1;
            continue $sm;
          case 17:
            if (true) {
              this._state_1 = 18;
              suspendResult = this._sout0._out.write_ysdrhq_k$(this._sout0._bab._data_16, 0, this._sout0._bab._size_7, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 19;
              continue $sm;
            }

            break;
          case 18:
            this._sout0._bab.clear_sv8swh_k$();
            this._state_1 = 19;
            continue $sm;
          case 19:
            return Unit_getInstance();
          case 20:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 20) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $uncompressCOROUTINE$14.$metadata$ = {
    simpleName: '$uncompressCOROUTINE$14',
    kind: 'class',
    interfaces: []
  };
  function DeflatePortable(windowBits) {
    Companion_getInstance_101();
    this._windowBits = windowBits;
  }
  DeflatePortable.prototype.compress_ydifiq_k$ = function (i, o, context, $cont) {
    var tmp = new $compressCOROUTINE$13(this, i, o, context, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  DeflatePortable.prototype.uncompress_hzt0ks_k$ = function (reader_0, out, $cont) {
    var tmp = new $uncompressCOROUTINE$14(this, reader_0, out, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  DeflatePortable.$metadata$ = {
    simpleName: 'DeflatePortable',
    kind: 'class',
    interfaces: [CompressionMethod]
  };
  function _no_name_provided__138() {
  }
  _no_name_provided__138.prototype.invoke_0_k$ = function () {
    return Deflate(15);
  };
  _no_name_provided__138.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Deflate$factory() {
    return getPropertyCallableRef('Deflate', 0, KProperty0, function () {
      return _get_Deflate_();
    }, null);
  }
  function _no_name_provided_$factory_111() {
    var i = new _no_name_provided__138();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided__139() {
  }
  _no_name_provided__139.prototype.invoke_0_k$ = function () {
    return _get_Deflate_();
  };
  _no_name_provided__139.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_103() {
    Companion_instance_102 = this;
    GZIP.call(this, _no_name_provided_$factory_112());
  }
  Companion_103.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_102;
  function Companion_getInstance_102() {
    if (Companion_instance_102 == null)
      new Companion_103();
    return Companion_instance_102;
  }
  function GZIP(deflater) {
    Companion_getInstance_102();
    GZIPBase.call(this, true, deflater);
  }
  GZIP.$metadata$ = {
    simpleName: 'GZIP',
    kind: 'class',
    interfaces: []
  };
  function $writeCOROUTINE$19(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__15 = _this_;
    this._buffer_7 = buffer;
    this._offset_3 = offset_0;
    this._len_1 = len;
  }
  $writeCOROUTINE$19.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (this._len_1 > 0) {
              this.__this__15._$ccrc32._v = CRC32_getInstance().update_9piif6_k$(this.__this__15._$ccrc32._v, this._buffer_7, this._offset_3, this._len_1);
              this.__this__15._$csize._v = this.__this__15._$csize._v + this._len_1 | 0;
              this._state_1 = 1;
              suspendResult = this.__this__15._$out.write_ysdrhq_k$(this._buffer_7, this._offset_3, this._len_1, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$19.$metadata$ = {
    simpleName: '$writeCOROUTINE$19',
    kind: 'class',
    interfaces: []
  };
  function $readCOROUTINE$20(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__16 = _this_;
    this._buffer_8 = buffer;
    this._offset_4 = offset_0;
    this._len_2 = len;
  }
  $readCOROUTINE$20.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__16._$i_1.read_irqg4d_k$(this._buffer_8, this._offset_4, this._len_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var read_0 = suspendResult;
            if (read_0 > 0) {
              this.__this__16._$crc32._v = CRC32_getInstance().update_9piif6_k$(this.__this__16._$crc32._v, this._buffer_8, this._offset_4, read_0);
              this.__this__16._$size._v = this.__this__16._$size._v + read_0 | 0;
            }
            return read_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$20.$metadata$ = {
    simpleName: '$readCOROUTINE$20',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__140($out, $ccrc32, $csize) {
    this._$out = $out;
    this._$ccrc32 = $ccrc32;
    this._$csize = $csize;
    this._$$delegate_0_7 = this._$out;
  }
  _no_name_provided__140.prototype.close_sv8swh_k$ = function ($cont) {
    return this._$$delegate_0_7.close_sv8swh_k$($cont);
  };
  _no_name_provided__140.prototype.write_majfzk_k$ = function (byte, $cont) {
    return this._$$delegate_0_7.write_majfzk_k$(byte, $cont);
  };
  _no_name_provided__140.prototype.write_ysdrhq_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $writeCOROUTINE$19(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__140.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncOutputStream]
  };
  function _no_name_provided__141($i, $crc32, $size) {
    this._$i_1 = $i;
    this._$crc32 = $crc32;
    this._$size = $size;
    this._$$delegate_0_8 = this._$i_1;
  }
  _no_name_provided__141.prototype.close_sv8swh_k$ = function ($cont) {
    return this._$$delegate_0_8.close_sv8swh_k$($cont);
  };
  _no_name_provided__141.prototype.getLength_0_k$ = function ($cont) {
    return this._$$delegate_0_8.getLength_0_k$($cont);
  };
  _no_name_provided__141.prototype.getPosition_0_k$ = function ($cont) {
    return this._$$delegate_0_8.getPosition_0_k$($cont);
  };
  _no_name_provided__141.prototype.hasLength_0_k$ = function ($cont) {
    return this._$$delegate_0_8.hasLength_0_k$($cont);
  };
  _no_name_provided__141.prototype.read_0_k$ = function ($cont) {
    return this._$$delegate_0_8.read_0_k$($cont);
  };
  _no_name_provided__141.prototype.read_irqg4d_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $readCOROUTINE$20(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__141.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncInputStreamWithLength]
  };
  function $uncompressCOROUTINE$17(_this_, reader_0, out, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__17 = _this_;
    this._reader_0 = reader_0;
    this._out_1 = out;
  }
  $uncompressCOROUTINE$17.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 12;
            this._r0 = this._reader_0;
            if (this._r0._get_requirePrepare__0_k$()) {
              this._state_1 = 1;
              suspendResult = this._r0.prepareBytesUpTo_ha5a7z_k$(this._r0._bigChunkSize, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!(this._r0.su8_0_k$() === 31) ? true : !(this._r0.su8_0_k$() === 139)) {
              throw IllegalStateException_init_$Create$_0('Not a GZIP file');
            }
            this._method1 = this._r0.su8_0_k$();
            if (!(this._method1 === 8)) {
              throw IllegalStateException_init_$Create$_0('Just supported deflate in GZIP');
            }
            this._ftext2 = this._r0.sreadBit_0_k$();
            this._fhcrc3 = this._r0.sreadBit_0_k$();
            this._fextra4 = this._r0.sreadBit_0_k$();
            this._fname5 = this._r0.sreadBit_0_k$();
            this._fcomment6 = this._r0.sreadBit_0_k$();
            this._reserved7 = this._r0.readBits_ha5a7z_k$(3);
            this._mtime8 = this._r0.su32LE_0_k$();
            this._xfl9 = this._r0.su8_0_k$();
            this._os10 = this._r0.su8_0_k$();
            if (this._fextra4) {
              this._state_1 = 3;
              var tmp_0 = this._r0.su16LE_0_k$();
              suspendResult = this._r0.abytes$default_jitirp_k$(tmp_0, null, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1._WHEN_RESULT11 = new Int8Array([]);
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 3:
            this._WHEN_RESULT11 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            this._extra12 = this._WHEN_RESULT11;
            if (this._fname5) {
              this._state_1 = 5;
              suspendResult = this._r0.strz_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT13 = null;
              this._state_1 = 6;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 5:
            this._WHEN_RESULT13 = suspendResult;
            this._state_1 = 6;
            continue $sm;
          case 6:
            this._name14 = this._WHEN_RESULT13;
            if (this._fcomment6) {
              this._state_1 = 7;
              suspendResult = this._r0.strz_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT15 = null;
              this._state_1 = 8;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 7:
            this._WHEN_RESULT15 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 8:
            this._comment16 = this._WHEN_RESULT15;
            this._crc1617 = this._fhcrc3 ? this._r0.su16LE_0_k$() : 0;
            this._ccrc3218 = {_v: CRC32_getInstance()._initialValue_0};
            this._csize19 = {_v: 0};
            this._state_1 = 9;
            var tmp_2 = this.__this__17._deflater();
            suspendResult = tmp_2.uncompress_hzt0ks_k$(this._r0, new _no_name_provided__140(this._out_1, this._ccrc3218, this._csize19), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            if (this._r0._get_requirePrepare__0_k$()) {
              this._state_1 = 10;
              suspendResult = this._r0.prepareBytesUpTo_ha5a7z_k$(this._r0._bigChunkSize, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 11;
              continue $sm;
            }

            break;
          case 10:
            Unit_getInstance();
            this._state_1 = 11;
            continue $sm;
          case 11:
            var crc32 = this._r0.su32LE_0_k$();
            var size_2 = this._r0.su32LE_0_k$();
            if (this.__this__17._checkCrc ? !(this._csize19._v === size_2) ? true : !(this._ccrc3218._v === crc32) : false) {
              invalidOp('' + "Size doesn't match SIZE(" + _get_hex_(this._csize19._v) + ' != ' + _get_hex_(size_2) + ') || CRC32(' + _get_hex_(this._ccrc3218._v) + ' != ' + _get_hex_(crc32) + ')');
            }
            return Unit_getInstance();
          case 12:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 12) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $uncompressCOROUTINE$17.$metadata$ = {
    simpleName: '$uncompressCOROUTINE$17',
    kind: 'class',
    interfaces: []
  };
  function $compressCOROUTINE$18(_this_, i, o, context, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__18 = _this_;
    this._i_2 = i;
    this._o_2 = o;
    this._context_6 = context;
  }
  $compressCOROUTINE$18.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 12;
            this._state_1 = 1;
            suspendResult = write8_0(this._o_2, 31, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = write8_0(this._o_2, 139, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 3;
            suspendResult = write8_0(this._o_2, 8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._state_1 = 4;
            suspendResult = write8_0(this._o_2, 0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._state_1 = 5;
            suspendResult = write32LE_0(this._o_2, 0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._state_1 = 6;
            suspendResult = write8_0(this._o_2, 0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._state_1 = 7;
            suspendResult = write8_0(this._o_2, 0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._size0 = {_v: 0};
            this._crc321 = {_v: CRC32_getInstance()._initialValue_0};
            this._ARGUMENT2_0 = this.__this__18._deflater();
            this._state_1 = 8;
            var tmp_0 = Companion_getInstance_104();
            suspendResult = tmp_0.forInput_k2ey2z_k$(new _no_name_provided__141(this._i_2, this._crc321, this._size0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._ARGUMENT3 = suspendResult;
            this._state_1 = 9;
            suspendResult = this._ARGUMENT2_0.compress_ydifiq_k$(this._ARGUMENT3, this._o_2, this._context_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._state_1 = 10;
            suspendResult = write32LE_0(this._o_2, this._crc321._v, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            this._state_1 = 11;
            suspendResult = write32LE_0(this._o_2, this._size0._v, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            return Unit_getInstance();
          case 12:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 12) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $compressCOROUTINE$18.$metadata$ = {
    simpleName: '$compressCOROUTINE$18',
    kind: 'class',
    interfaces: []
  };
  function GZIPBase(checkCrc, deflater) {
    this._checkCrc = checkCrc;
    this._deflater = deflater;
  }
  GZIPBase.prototype.uncompress_hzt0ks_k$ = function (reader_0, out, $cont) {
    var tmp = new $uncompressCOROUTINE$17(this, reader_0, out, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  GZIPBase.prototype.compress_ydifiq_k$ = function (i, o, context, $cont) {
    var tmp = new $compressCOROUTINE$18(this, i, o, context, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  GZIPBase.$metadata$ = {
    simpleName: 'GZIPBase',
    kind: 'class',
    interfaces: [CompressionMethod]
  };
  function _no_name_provided_$factory_112() {
    var i = new _no_name_provided__139();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided__142() {
  }
  _no_name_provided__142.prototype.invoke_ha5a7z_k$ = function (it) {
    return Deflate(it);
  };
  _no_name_provided__142.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__142.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $writeCOROUTINE$23(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__19 = _this_;
    this._buffer_9 = buffer;
    this._offset_5 = offset_0;
    this._len_3 = len;
  }
  $writeCOROUTINE$23.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__19._$o_1.write_ysdrhq_k$(this._buffer_9, this._offset_5, this._len_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this.__this__19._$chash._v = Adler32_getInstance().update_9piif6_k$(this.__this__19._$chash._v, this._buffer_9, this._offset_5, this._len_3);
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$23.$metadata$ = {
    simpleName: '$writeCOROUTINE$23',
    kind: 'class',
    interfaces: []
  };
  function $readCOROUTINE$24(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__20 = _this_;
    this._buffer_10 = buffer;
    this._offset_6 = offset_0;
    this._len_4 = len;
  }
  $readCOROUTINE$24.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__20._$i_2.read_irqg4d_k$(this._buffer_10, this._offset_6, this._len_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var read_0 = suspendResult;
            if (read_0 > 0) {
              this.__this__20._$adler._v = Adler32_getInstance().update_9piif6_k$(this.__this__20._$adler._v, this._buffer_10, this._offset_6, read_0);
            }
            return read_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$24.$metadata$ = {
    simpleName: '$readCOROUTINE$24',
    kind: 'class',
    interfaces: []
  };
  function Companion_104() {
    Companion_instance_103 = this;
    ZLib.call(this, _no_name_provided_$factory_113());
  }
  Companion_104.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_103;
  function Companion_getInstance_103() {
    if (Companion_instance_103 == null)
      new Companion_104();
    return Companion_instance_103;
  }
  function _no_name_provided__143($o, $chash) {
    this._$o_1 = $o;
    this._$chash = $chash;
  }
  _no_name_provided__143.prototype.close_sv8swh_k$ = function ($cont) {
    return this._$o_1.close_sv8swh_k$($cont);
  };
  _no_name_provided__143.prototype.write_ysdrhq_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $writeCOROUTINE$23(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__143.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncOutputStream]
  };
  function _no_name_provided__144($i, $adler) {
    this._$i_2 = $i;
    this._$adler = $adler;
    this._$$delegate_0_9 = this._$i_2;
  }
  _no_name_provided__144.prototype.close_sv8swh_k$ = function ($cont) {
    return this._$$delegate_0_9.close_sv8swh_k$($cont);
  };
  _no_name_provided__144.prototype.getLength_0_k$ = function ($cont) {
    return this._$$delegate_0_9.getLength_0_k$($cont);
  };
  _no_name_provided__144.prototype.getPosition_0_k$ = function ($cont) {
    return this._$$delegate_0_9.getPosition_0_k$($cont);
  };
  _no_name_provided__144.prototype.hasLength_0_k$ = function ($cont) {
    return this._$$delegate_0_9.hasLength_0_k$($cont);
  };
  _no_name_provided__144.prototype.read_0_k$ = function ($cont) {
    return this._$$delegate_0_9.read_0_k$($cont);
  };
  _no_name_provided__144.prototype.read_irqg4d_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $readCOROUTINE$24(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__144.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncInputStreamWithLength]
  };
  function $uncompressCOROUTINE$21(_this_, reader_0, out, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__21 = _this_;
    this._reader_1 = reader_0;
    this._out_2 = out;
  }
  $uncompressCOROUTINE$21.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._r0_0 = this._reader_1;
            this._o1 = this._out_2;
            if (this._r0_0._get_requirePrepare__0_k$()) {
              this._state_1 = 1;
              suspendResult = this._r0_0.prepareBytesUpTo_ha5a7z_k$(this._r0_0._bigChunkSize, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._cmf2 = this._r0_0.su8_0_k$();
            this._flg3 = this._r0_0.su8_0_k$();
            if (!((imul(this._cmf2, 256) + this._flg3 | 0) % 31 === 0)) {
              throw IllegalStateException_init_$Create$_0('bad zlib header');
            }
            this._compressionMethod4 = extract(this._cmf2, 0, 4);
            if (!(this._compressionMethod4 === 8)) {
              var tmp_0 = this;
              tmp_0._tmp0_error_05 = '' + 'Invalid zlib stream compressionMethod=' + this._compressionMethod4;
              throw IllegalStateException_init_$Create$_0(toString_1(this._tmp0_error_05));
            }
            this._windowBits6 = extract(this._cmf2, 4, 4) + 8 | 0;
            this._fcheck7 = extract(this._flg3, 0, 5);
            this._hasDict8 = extract_0(this._flg3, 5);
            this._flevel9 = extract(this._flg3, 6, 2);
            this._dictid10 = 0;
            if (this._hasDict8) {
              this._dictid10 = this._r0_0.su32LE_0_k$();
              var tmp1_TODO_0 = '' + 'Unsupported custom dictionaries (Provided DICTID=' + this._dictid10 + ')';
              throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp1_TODO_0);
            }
            this._chash11 = {_v: Adler32_getInstance()._initialValue};
            this._state_1 = 3;
            var tmp_1 = this.__this__21._deflater_0(this._windowBits6);
            suspendResult = tmp_1.uncompress_hzt0ks_k$(this._r0_0, new _no_name_provided__143(this._o1, this._chash11), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            if (this._r0_0._get_requirePrepare__0_k$()) {
              this._state_1 = 4;
              suspendResult = this._r0_0.prepareBytesUpTo_ha5a7z_k$(this._r0_0._bigChunkSize, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            Unit_getInstance();
            this._state_1 = 5;
            continue $sm;
          case 5:
            var adler32 = this._r0_0.su32BE_0_k$();
            if (!(this._chash11._v === adler32)) {
              invalidOp('' + "Adler32 doesn't match " + _get_hex_(this._chash11._v) + ' != ' + _get_hex_(adler32));
            }
            return Unit_getInstance();
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $uncompressCOROUTINE$21.$metadata$ = {
    simpleName: '$uncompressCOROUTINE$21',
    kind: 'class',
    interfaces: []
  };
  function $compressCOROUTINE$22(_this_, i, o, context, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__22 = _this_;
    this._i_3 = i;
    this._o_3 = o;
    this._context_7 = context;
  }
  $compressCOROUTINE$22.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._slidingBits0 = 15;
            this._clevel1 = this._context_7._level_0 <= 0 ? 0 : this._context_7._level_0 < 6 ? 1 : this._context_7._level_0 < 9 ? 2 : 3;
            this._cmf2_0 = 8 | (this._slidingBits0 - 8 | 0) << 4;
            this._flg3_0 = 0 | this._clevel1 << 6;
            this._fcheck4 = 0;
            var inductionVariable = 0;
            if (inductionVariable < 32)
              $l$break: do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if ((imul(this._cmf2_0, 256) + (this._flg3_0 | n) | 0) % 31 === 0) {
                  this._fcheck4 = n;
                  break $l$break;
                }}
               while (inductionVariable < 32);
            this._state_1 = 1;
            suspendResult = write8_0(this._o_3, this._cmf2_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = write8_0(this._o_3, this._flg3_0 | this._fcheck4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._adler5 = {_v: Adler32_getInstance()._initialValue};
            this._state_1 = 3;
            var tmp_0 = this.__this__22._deflater_0(this._slidingBits0);
            suspendResult = compress_1(tmp_0, new _no_name_provided__144(this._i_3, this._adler5), this._o_3, this._context_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._state_1 = 4;
            suspendResult = write32BE_0(this._o_3, this._adler5._v, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $compressCOROUTINE$22.$metadata$ = {
    simpleName: '$compressCOROUTINE$22',
    kind: 'class',
    interfaces: []
  };
  function ZLib(deflater) {
    Companion_getInstance_103();
    this._deflater_0 = deflater;
  }
  ZLib.prototype.uncompress_hzt0ks_k$ = function (reader_0, out, $cont) {
    var tmp = new $uncompressCOROUTINE$21(this, reader_0, out, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  ZLib.prototype.compress_ydifiq_k$ = function (i, o, context, $cont) {
    var tmp = new $compressCOROUTINE$22(this, i, o, context, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  ZLib.$metadata$ = {
    simpleName: 'ZLib',
    kind: 'class',
    interfaces: [CompressionMethod]
  };
  function _no_name_provided_$factory_113() {
    var i = new _no_name_provided__142();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function $forInputCOROUTINE$25(_this_, s, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__23 = _this_;
    this._s_0 = s;
  }
  $forInputCOROUTINE$25.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            var tmp_0 = this._s_0;
            if (isInterface(tmp_0, AsyncGetLengthStream)) {
              this._state_1 = 1;
              suspendResult = this._s_0.hasLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._WHEN_RESULT0_0 = false;
                this._state_1 = 2;
                continue $sm;
              }
            }

            break;
          case 1:
            this._WHEN_RESULT0_0 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (this._WHEN_RESULT0_0) {
              var tmp_1 = this;
              tmp_1._tmp2_max_01 = 32768;
              this._state_1 = 4;
              suspendResult = this._s_0.getLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 3:
            return BitReader_init_$Create$(this._s_0, 0, 0, 6, null);
          case 4:
            var tmp0_min_0 = suspendResult;
            var tmp1_min_0 = new Long(8388608, 0);
            var ARGUMENT = tmp0_min_0.compareTo_wiekkq_k$(tmp1_min_0) <= 0 ? tmp0_min_0 : tmp1_min_0;
            var tmp3_max_0 = ARGUMENT.toInt_0_k$();
            var bigChunkSize = Math.max(this._tmp2_max_01, tmp3_max_0);
            var tmp4_max_0 = bigChunkSize / 2 | 0;
            var tmp5_max_0 = 32768;
            var readWithSize = Math.max(tmp4_max_0, tmp5_max_0);
            return new BitReader(this._s_0, bigChunkSize, readWithSize);
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forInputCOROUTINE$25.$metadata$ = {
    simpleName: '$forInputCOROUTINE$25',
    kind: 'class',
    interfaces: []
  };
  function BitReader_init_$Init$(s, bigChunkSize, readWithSize, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      Companion_getInstance_104();
      bigChunkSize = 8388608;
    }if (!(($mask0 & 4) === 0)) {
      Companion_getInstance_104();
      readWithSize = 32768;
    }BitReader.call($this, s, bigChunkSize, readWithSize);
    return $this;
  }
  function BitReader_init_$Create$(s, bigChunkSize, readWithSize, $mask0, $marker) {
    return BitReader_init_$Init$(s, bigChunkSize, readWithSize, $mask0, $marker, Object.create(BitReader.prototype));
  }
  function Companion_105() {
    Companion_instance_104 = this;
    this._BIG_CHUNK_SIZE = 8388608;
    this._READ_WHEN_LESS_THAN = 32768;
  }
  Companion_105.prototype.forInput_k2ey2z_k$ = function (s, $cont) {
    var tmp = new $forInputCOROUTINE$25(this, s, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Companion_105.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_104;
  function Companion_getInstance_104() {
    if (Companion_instance_104 == null)
      new Companion_105();
    return Companion_instance_104;
  }
  function $prepareBytesUpToCOROUTINE$27(_this_, expectedBytes, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__24 = _this_;
    this._expectedBytes = expectedBytes;
  }
  $prepareBytesUpToCOROUTINE$27.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this.__this__24._sbuffers._get_availableRead__0_k$() < this._expectedBytes)) {
              this._state_1 = 4;
              continue $sm;
            }
            this._state_1 = 2;
            var tmp_0 = this;
            var tmp0_min_0 = this.__this__24._tempBA.length;
            tmp_0._tmp1_min_00 = Math.min(tmp0_min_0, this._expectedBytes);
            var tmp_1 = this;
            tmp_1._tmp2_min_01 = this.__this__24._sbuffers._get_availableWrite__0_k$();
            suspendResult = this.__this__24._s_1.read_irqg4d_k$(this.__this__24._tempBA, 0, Math.min(this._tmp1_min_00, this._tmp2_min_01), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var read_0 = suspendResult;
            if (read_0 <= 0) {
              this._state_1 = 4;
              continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this.__this__24._sbuffers.write_irqg4d_k$(this.__this__24._tempBA, 0, read_0);
            Unit_getInstance();
            var tmp0_this = this.__this__24;
            tmp0_this._sbuffersPos = tmp0_this._sbuffersPos + read_0;
            this._state_1 = 1;
            continue $sm;
          case 4:
            return this.__this__24;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $prepareBytesUpToCOROUTINE$27.$metadata$ = {
    simpleName: '$prepareBytesUpToCOROUTINE$27',
    kind: 'class',
    interfaces: []
  };
  function $abytesCOROUTINE$28(_this_, count_0, out, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__25 = _this_;
    this._count_6 = count_0;
    this._out_3 = out;
  }
  $abytesCOROUTINE$28.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__25.prepareBytesUpTo_ha5a7z_k$(this._count_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.sbytes_yc609u_k$(this._count_6, this._out_3);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $abytesCOROUTINE$28.$metadata$ = {
    simpleName: '$abytesCOROUTINE$28',
    kind: 'class',
    interfaces: []
  };
  function $readCOROUTINE$29(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__26 = _this_;
    this._buffer_11 = buffer;
    this._offset_7 = offset_0;
    this._len_5 = len;
  }
  $readCOROUTINE$29.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__26.prepareBytesUpTo_ha5a7z_k$(this._len_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT._sbuffers;
            return ARGUMENT_0.read_irqg4d_k$(this._buffer_11, this._offset_7, this._len_5);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$29.$metadata$ = {
    simpleName: '$readCOROUTINE$29',
    kind: 'class',
    interfaces: []
  };
  function $strzCOROUTINE$30(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__27 = _this_;
  }
  $strzCOROUTINE$30.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._buffer_10_0 = ByteArrayBuilder_init_$Create$_0(4096);
            this._s_21 = MemorySyncStream(this._buffer_10_0);
            this.__this__27._bitdata = 0;
            this.__this__27._bitsavailable = 0;
            Unit_getInstance();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this._state_1 = 5;
              continue $sm;
            }
            if (this.__this__27._get_requirePrepare__0_k$()) {
              this._state_1 = 2;
              suspendResult = this.__this__27.prepareBytesUpTo_ha5a7z_k$(this.__this__27._bigChunkSize, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            Unit_getInstance();
            this._state_1 = 3;
            continue $sm;
          case 3:
            var c_4 = this.__this__27._sbuffers.readByte_0_k$();
            if (c_4 === 0) {
              this._state_1 = 5;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            write8_1(this._s_21, c_4);
            this._state_1 = 1;
            continue $sm;
          case 5:
            var ARGUMENT = this._buffer_10_0.toByteArray_0_k$();
            var tmp_0 = ASCII_getInstance();
            return toString$default(ARGUMENT, tmp_0, 0, 0, 6, null);
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $strzCOROUTINE$30.$metadata$ = {
    simpleName: '$strzCOROUTINE$30',
    kind: 'class',
    interfaces: []
  };
  function $getLengthCOROUTINE$32(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__28 = _this_;
  }
  $getLengthCOROUTINE$32.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this.__this__28._s_1;
            tmp_0._tmp0_safe_receiver0_0 = isInterface(tmp_1, AsyncGetLengthStream) ? tmp_1 : null;
            if (this._tmp0_safe_receiver0_0 == null) {
              this._WHEN_RESULT1_0 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0_0.getLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1_0 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = this._WHEN_RESULT1_0;
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              throw IllegalStateException_init_$Create$_0('Length not available on Stream');
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }

            return tmp_2;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getLengthCOROUTINE$32.$metadata$ = {
    simpleName: '$getLengthCOROUTINE$32',
    kind: 'class',
    interfaces: []
  };
  function BitReader(s, bigChunkSize, readWithSize) {
    Companion_getInstance_104();
    this._s_1 = s;
    this._bigChunkSize = bigChunkSize;
    this._readWithSize = readWithSize;
    this._bitdata = 0;
    this._bitsavailable = 0;
    this._sbuffers = new RingBuffer(ilog2_0(this._bigChunkSize));
    this._sbuffersPos = 0.0;
    this._tempBA = new Int8Array(this._bigChunkSize);
    this._temp_7 = new Int8Array(4);
  }
  BitReader.prototype._get_requirePrepare__0_k$ = function () {
    return this._sbuffers._get_availableRead__0_k$() < this._readWithSize;
  };
  BitReader.prototype.prepareBytesUpTo_ha5a7z_k$ = function (expectedBytes, $cont) {
    var tmp = new $prepareBytesUpToCOROUTINE$27(this, expectedBytes, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BitReader.prototype.ensureBits_majfzk_k$ = function (bitcount) {
    while (this._bitsavailable < bitcount) {
      var tmp = this;
      var tmp_0 = this._bitdata;
      tmp._bitdata = tmp_0 | this._sbuffers.readByte_0_k$() << this._bitsavailable;
      var tmp0_this = this;
      tmp0_this._bitsavailable = tmp0_this._bitsavailable + 8 | 0;
    }
  };
  BitReader.prototype.peekBits_ha5a7z_k$ = function (bitcount) {
    return this._bitdata & ((1 << bitcount) - 1 | 0);
  };
  BitReader.prototype.skipBits_majfzk_k$ = function (bitcount) {
    this._bitdata = this._bitdata >>> bitcount;
    var tmp0_this = this;
    tmp0_this._bitsavailable = tmp0_this._bitsavailable - bitcount | 0;
  };
  BitReader.prototype.readBits_ha5a7z_k$ = function (bitcount) {
    this.ensureBits_majfzk_k$(bitcount);
    var readed = this.peekBits_ha5a7z_k$(bitcount);
    this.skipBits_majfzk_k$(bitcount);
    return readed;
  };
  BitReader.prototype.sreadBit_0_k$ = function () {
    return !(this.readBits_ha5a7z_k$(1) === 0);
  };
  BitReader.prototype.sbytes_noalign_bbbfxr_k$ = function (count_0, out) {
    var offset_0 = 0;
    var count_1 = count_0;
    if (this._bitsavailable >= 8) {
      if (!(this._bitsavailable % 8 === 0)) {
        var bits = this._bitsavailable % 8;
        this.skipBits_majfzk_k$(bits);
      }while (this._bitsavailable >= 8) {
        var byte = toByte(this.readBits_ha5a7z_k$(8));
        var tmp0 = offset_0;
        offset_0 = tmp0 + 1 | 0;
        out[tmp0] = byte;
        var tmp1 = count_1;
        count_1 = tmp1 - 1 | 0;
        Unit_getInstance();
      }
    }this._bitdata = 0;
    this._bitsavailable = 0;
    Unit_getInstance();
    this._sbuffers.read_irqg4d_k$(out, offset_0, count_1);
    Unit_getInstance();
  };
  BitReader.prototype.sbytes_yc609u_k$ = function (count_0, out) {
    this.sbytes_noalign_bbbfxr_k$(count_0, out);
    return out;
  };
  BitReader.prototype.su8_0_k$ = function () {
    this._bitdata = 0;
    this._bitsavailable = 0;
    var tmp0__su8_0 = this;
    return tmp0__su8_0._sbuffers.readByte_0_k$();
  };
  BitReader.prototype.su16LE_0_k$ = function () {
    this.sbytes_noalign_bbbfxr_k$(2, this._temp_7);
    return readU16LE(this._temp_7, 0);
  };
  BitReader.prototype.su32LE_0_k$ = function () {
    this.sbytes_noalign_bbbfxr_k$(4, this._temp_7);
    return readS32LE(this._temp_7, 0);
  };
  BitReader.prototype.su32BE_0_k$ = function () {
    this.sbytes_noalign_bbbfxr_k$(4, this._temp_7);
    return readS32BE(this._temp_7, 0);
  };
  BitReader.prototype.abytes_yc609u_k$ = function (count_0, out, $cont) {
    var tmp = new $abytesCOROUTINE$28(this, count_0, out, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BitReader.prototype.abytes$default_jitirp_k$ = function (count_0, out, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      out = new Int8Array(count_0);
    return this.abytes_yc609u_k$(count_0, out, $cont);
  };
  BitReader.prototype.read_irqg4d_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $readCOROUTINE$29(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BitReader.prototype.close_sv8swh_k$ = function ($cont) {
    return this._s_1.close_sv8swh_k$($cont);
  };
  BitReader.prototype.strz_0_k$ = function ($cont) {
    var tmp = new $strzCOROUTINE$30(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BitReader.prototype.getPosition_0_k$ = function ($cont) {
    return numberToLong(this._sbuffersPos);
  };
  BitReader.prototype.getLength_0_k$ = function ($cont) {
    var tmp = new $getLengthCOROUTINE$32(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BitReader.$metadata$ = {
    simpleName: 'BitReader',
    kind: 'class',
    interfaces: [AsyncInputStreamWithLength]
  };
  function Companion_106() {
    Companion_instance_105 = this;
    this._INVALID_VALUE = -1;
    this._INCOMPLETE_VALUE = -2;
    this._NIL_1 = 1023;
    this._MAX_LEN = 16;
    this._MAX_CODES = 288;
    this._ENABLE_EXPERIMENTAL_FAST_READ = true;
    this._ENABLE_EXPERIMENTAL_FAST_READ_V2 = true;
    this._FAST_BITS = 10;
  }
  Companion_106.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_105;
  function Companion_getInstance_105() {
    if (Companion_instance_105 == null)
      new Companion_106();
    return Companion_instance_105;
  }
  function resetAlloc($this) {
    $this._nodeOffset = 0;
  }
  function alloc($this, value, left, right) {
    var tmp0_this = $this;
    var tmp1 = tmp0_this._nodeOffset;
    tmp0_this._nodeOffset = tmp1 + 1 | 0;
    var tmp0_apply_0 = tmp1;
    $this._value_12[tmp0_apply_0] = value;
    $this._left_1[tmp0_apply_0] = left;
    $this._right[tmp0_apply_0] = right;
    return tmp0_apply_0;
  }
  function allocLeaf($this, value) {
    Companion_getInstance_105();
    Companion_getInstance_105();
    return alloc($this, value, 1023, 1023);
  }
  function allocNode($this, left, right) {
    Companion_getInstance_105();
    return alloc($this, -1, left, right);
  }
  function computeFastLookup($this) {
    Companion_getInstance_105();
    {
      var tmp0_fill_0 = $this._FAST_INFO;
      Companion_getInstance_105();
      var tmp1_fill_0 = -1;
      var tmp2_fill_0 = tmp0_fill_0.length;
      fill_0(tmp0_fill_0, tmp1_fill_0, 0, tmp2_fill_0);
      computeEncodedValues($this, $this._root, 0, 0);
    }
  }
  function computeEncodedValues($this, node, encoded, encodedBits) {
    var tmp = $this._value_12[node];
    Companion_getInstance_105();
    if (tmp === -1) {
      Companion_getInstance_105();
      if (encodedBits < 10) {
        computeEncodedValues($this, $this._left_1[node], encoded, encodedBits + 1 | 0);
        computeEncodedValues($this, $this._right[node], encoded | 1 << encodedBits, encodedBits + 1 | 0);
      } else {
        {
          Companion_getInstance_105();
          writeVariants($this, encoded, encodedBits, node, -2);
        }
      }
    } else {
      {
        writeVariants($this, encoded, encodedBits, node, $this._value_12[node]);
      }
    }
  }
  function writeVariants($this, encoded, encodedBits, node, nvalue) {
    var encodedInfo = nvalue & 65535 | encodedBits << 16;
    Companion_getInstance_105();
    var rangeCount = 1 << (10 - encodedBits | 0);
    var inductionVariable = 0;
    if (inductionVariable < rangeCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var i = encoded | n << encodedBits;
        $this._FAST_INFO[i] = encodedInfo;
        $this._FAST_NODE[i] = node;
      }
       while (inductionVariable < rangeCount);
  }
  function HuffmanTree() {
    Companion_getInstance_105();
    this._value_12 = new Int32Array(1024);
    this._left_1 = new Int32Array(1024);
    this._right = new Int32Array(1024);
    this._nodeOffset = 0;
    var tmp = this;
    Companion_getInstance_105();
    tmp._root = 1023;
    this._ncodes = 0;
    var tmp_0 = this;
    var tmp_1 = 0;
    Companion_getInstance_105();
    var tmp_2 = 1 << 10;
    var tmp_3 = new Int32Array(tmp_2);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      Companion_getInstance_105();
      tmp_3[tmp_4] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._FAST_INFO = tmp_3;
    var tmp_5 = this;
    var tmp_6 = 0;
    Companion_getInstance_105();
    var tmp_7 = 1 << 10;
    var tmp_8 = new Int32Array(tmp_7);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      tmp_8[tmp_9] = 0;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5._FAST_NODE = tmp_8;
    var tmp_10 = this;
    Companion_getInstance_105();
    tmp_10._COUNTS = new Int32Array(16 + 1 | 0);
    var tmp_11 = this;
    Companion_getInstance_105();
    tmp_11._OFFSETS = new Int32Array(16 + 1 | 0);
    var tmp_12 = this;
    Companion_getInstance_105();
    tmp_12._COFFSET = new Int32Array(16 + 1 | 0);
    var tmp_13 = this;
    Companion_getInstance_105();
    tmp_13._CODES = new Int32Array(288);
  }
  HuffmanTree.prototype.read_ifkopv_k$ = function (reader_0) {
    Companion_getInstance_105();
    {
      Companion_getInstance_105();
      reader_0.ensureBits_majfzk_k$(10);
    }
    var node = this._root;
    var tmp;
    Companion_getInstance_105();
    {
      var tmp_0 = reader_0._bitsavailable;
      Companion_getInstance_105();
      tmp = tmp_0 >= 10;
    }
    if (tmp) {
      Companion_getInstance_105();
      var bits = reader_0.peekBits_ha5a7z_k$(10);
      var raw = this._FAST_INFO[bits];
      var value = toShort(raw);
      var len = raw >> 16;
      if (len > 0) {
        reader_0.skipBits_majfzk_k$(len);
        Companion_getInstance_105();
        if (value === -2) {
          node = this._FAST_NODE[bits];
        } else {
          {
            return value;
          }
        }
      }} else {
    }
    $l$1: do {
      $l$0: do {
        var tmp_1;
        if (reader_0.sreadBit_0_k$()) {
          var tmp0__get_right__0 = node;
          tmp_1 = this._right[tmp0__get_right__0];
        } else {
          var tmp1__get_left__0 = node;
          tmp_1 = this._left_1[tmp1__get_left__0];
        }
        node = tmp_1;
      }
       while (false);
      var tmp_2;
      var tmp_3 = node;
      Companion_getInstance_105();
      if (!(tmp_3 === 1023)) {
        var tmp2__get_value__0 = node;
        var tmp_4 = this._value_12[tmp2__get_value__0];
        Companion_getInstance_105();
        tmp_2 = tmp_4 === -1;
      } else {
        {
          tmp_2 = false;
        }
      }
    }
     while (tmp_2);
    var tmp3__get_value__0 = node;
    return this._value_12[tmp3__get_value__0];
  };
  HuffmanTree.prototype.fromLengths_6n0z48_k$ = function (codeLengths, start, end) {
    this.setFromLengths_6gxn8n_k$(codeLengths, start, end);
    return this;
  };
  HuffmanTree.prototype.fromLengths$default_gakitm_k$ = function (codeLengths, start, end, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      start = 0;
    if (!(($mask0 & 4) === 0))
      end = codeLengths.length;
    return this.fromLengths_6n0z48_k$(codeLengths, start, end);
  };
  HuffmanTree.prototype.setFromLengths_6gxn8n_k$ = function (codeLengths, start, end) {
    var oldOffset = 0;
    var oldCount = 0;
    var ncodes = end - start | 0;
    resetAlloc(this);
    var tmp0_fill_0 = this._COUNTS;
    var tmp1_fill_0 = tmp0_fill_0.length;
    fill_0(tmp0_fill_0, 0, 0, tmp1_fill_0);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var codeLen = codeLengths[n];
        var tmp;
        if (0 <= codeLen) {
          Companion_getInstance_105();
          tmp = codeLen <= 16;
        } else {
          tmp = false;
        }
        if (!tmp) {
          var tmp2_error_0 = '' + 'Invalid HuffmanTree.codeLengths ' + codeLen;
          throw IllegalStateException_init_$Create$_0(toString_1(tmp2_error_0));
        } else {
        }
        var tmp1_array = this._COUNTS;
        var tmp2_index0 = codeLen;
        var tmp3 = tmp1_array[tmp2_index0];
        tmp1_array[tmp2_index0] = tmp3 + 1 | 0;
        Unit_getInstance();
      }
       while (inductionVariable < end);
    var currentOffset = 0;
    var inductionVariable_0 = 0;
    Companion_getInstance_105();
    var last_1 = 16;
    if (inductionVariable_0 < last_1)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var count_0 = this._COUNTS[n_0];
        this._OFFSETS[n_0] = currentOffset;
        this._COFFSET[n_0] = currentOffset;
        currentOffset = currentOffset + count_0 | 0;
      }
       while (inductionVariable_0 < last_1);
    var inductionVariable_1 = start;
    if (inductionVariable_1 < end)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var codeLen_0 = codeLengths[n_1];
        var tmp6_array = this._COFFSET;
        var tmp7_index0 = codeLen_0;
        var tmp8 = tmp6_array[tmp7_index0];
        tmp6_array[tmp7_index0] = tmp8 + 1 | 0;
        this._CODES[tmp8] = n_1 - start | 0;
      }
       while (inductionVariable_1 < end);
    Companion_getInstance_105();
    var inductionVariable_2 = 16;
    if (1 <= inductionVariable_2)
      do {
        var i = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + -1 | 0;
        var newOffset = this._nodeOffset;
        var OFFSET = this._OFFSETS[i];
        var SIZE = this._COUNTS[i];
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < SIZE)
          do {
            var j = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            allocLeaf(this, this._CODES[OFFSET + j | 0]);
            Unit_getInstance();
          }
           while (inductionVariable_3 < SIZE);
        var progression = step(until(0, oldCount), 2);
        var inductionVariable_4 = progression._first_0;
        var last_2 = progression._last;
        var step_0 = progression._step_2;
        if ((step_0 > 0 ? inductionVariable_4 <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable_4 : false)
          do {
            var j_0 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + step_0 | 0;
            allocNode(this, oldOffset + j_0 | 0, (oldOffset + j_0 | 0) + 1 | 0);
            Unit_getInstance();
          }
           while (!(j_0 === last_2));
        oldOffset = newOffset;
        oldCount = SIZE + (oldCount / 2 | 0) | 0;
        if (oldCount >= 2 ? !(oldCount % 2 === 0) : false) {
          var tmp3_error_0 = '' + 'This canonical code does not represent a Huffman code tree: ' + oldCount;
          throw IllegalStateException_init_$Create$_0(toString_1(tmp3_error_0));
        }}
       while (1 <= inductionVariable_2);
    if (!(oldCount === 2)) {
      throw IllegalStateException_init_$Create$_0('This canonical code does not represent a Huffman code tree');
    }this._root = allocNode(this, this._nodeOffset - 2 | 0, this._nodeOffset - 1 | 0);
    this._ncodes = ncodes;
    Companion_getInstance_105();
    {
      computeFastLookup(this);
    }
  };
  HuffmanTree.prototype.setFromLengths$default_fc0b9j_k$ = function (codeLengths, start, end, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      start = 0;
    if (!(($mask0 & 4) === 0))
      end = codeLengths.length;
    return this.setFromLengths_6gxn8n_k$(codeLengths, start, end);
  };
  HuffmanTree.$metadata$ = {
    simpleName: 'HuffmanTree',
    kind: 'class',
    interfaces: []
  };
  function SlidingWindow(nbits) {
    this._nbits_1 = nbits;
    this._data_17 = new Int8Array(1 << this._nbits_1);
    this._mask_4 = this._data_17.length - 1 | 0;
    this._pos = 0;
  }
  SlidingWindow.prototype.get_ha5a7z_k$ = function (offset_0) {
    return this._data_17[(this._pos - offset_0 | 0) & this._mask_4] & 255;
  };
  SlidingWindow.prototype.getPut_ha5a7z_k$ = function (offset_0) {
    return this.put_ha5a7z_k$(this.get_ha5a7z_k$(offset_0));
  };
  SlidingWindow.prototype.put_ha5a7z_k$ = function (value) {
    this._data_17[this._pos] = toByte(value);
    this._pos = (this._pos + 1 | 0) & this._mask_4;
    return value;
  };
  SlidingWindow.prototype.putBytes_ysdrhq_k$ = function (bytes, offset_0, len) {
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__get_unsigned__0 = bytes[offset_0 + n | 0];
        this.put_ha5a7z_k$(tmp0__get_unsigned__0 & 255);
        Unit_getInstance();
      }
       while (inductionVariable < len);
  };
  SlidingWindow.$metadata$ = {
    simpleName: 'SlidingWindow',
    kind: 'class',
    interfaces: []
  };
  function $invokeCOROUTINE$33(_this_, s, caseSensitive, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__29 = _this_;
    this._s_2 = s;
    this._caseSensitive = caseSensitive;
  }
  $invokeCOROUTINE$33.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_also_00 = new ZipFile(false, this._s_2, this._caseSensitive);
            this._state_1 = 1;
            suspendResult = read(this._tmp0_also_00, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return this._tmp0_also_00;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$33.$metadata$ = {
    simpleName: '$invokeCOROUTINE$33',
    kind: 'class',
    interfaces: []
  };
  function Companion_107() {
    Companion_instance_106 = this;
    var tmp = this;
    tmp._PK_END = new Int8Array([80, 75, 5, 6]);
  }
  Companion_107.prototype.invoke_u23hy3_k$ = function (s, caseSensitive, $cont) {
    var tmp = new $invokeCOROUTINE$33(this, s, caseSensitive, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Companion_107.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_106;
  function Companion_getInstance_106() {
    if (Companion_instance_106 == null)
      new Companion_107();
    return Companion_instance_106;
  }
  function read($this, $cont) {
    var tmp = new $readCOROUTINE$34($this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function $readCOROUTINE$34(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__30 = _this_;
  }
  $readCOROUTINE$34.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 18;
            this._endBytes0 = EMPTY_BYTE_ARRAY;
            this._state_1 = 1;
            suspendResult = this.__this__30._s_3.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1 = suspendResult;
            if (this._ARGUMENT1.compareTo_wiekkq_k$(new Long(8, 0)) <= 0) {
              this._state_1 = 17;
              suspendResult = this.__this__30._s_3.getLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._pk_endIndex2 = -1;
            this._state_1 = 3;
            suspendResult = this.__this__30._s_3.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._fileLength3 = suspendResult;
            this._tmp0_iterator4 = listOf([22, 256, 4096, 65536]).iterator_0_k$();
            this._state_1 = 4;
            continue $sm;
          case 4:
            if (!this._tmp0_iterator4.hasNext_0_k$()) {
              this._state_1 = 9;
              continue $sm;
            }
            this._chunkSize5 = this._tmp0_iterator4.next_0_k$();
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_max_06 = this._fileLength3.minus_wiekkq_k$(toLong(this._chunkSize5));
            tmp_0._pos7 = (new Long(0, 0)).compareTo_wiekkq_k$(this._tmp0_max_06) >= 0 ? new Long(0, 0) : this._tmp0_max_06;
            this._state_1 = 5;
            suspendResult = this.__this__30._s_3.setPosition_kdfck9_k$(this._pos7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._state_1 = 6;
            suspendResult = this.__this__30._s_3.getAvailable_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._ARGUMENT8 = suspendResult;
            var tmp_2 = this;
            tmp_2._tmp1_max_09 = toIntClamp$default(this._ARGUMENT8, 0, 0, 3, null);
            this._bytesLen10 = Math.max(this._chunkSize5, this._tmp1_max_09);
            this._state_1 = 7;
            suspendResult = readBytesExact(this.__this__30._s_3, this._bytesLen10, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._ebytes11 = suspendResult;
            this._endBytes0 = this._ebytes11;
            this._pk_endIndex2 = indexOf_9(this._endBytes0, Companion_getInstance_106()._PK_END);
            if (this._pk_endIndex2 >= 0) {
              this._state_1 = 9;
              continue $sm;
            } else {
              this._state_1 = 8;
              continue $sm;
            }

            break;
          case 8:
            this._state_1 = 4;
            continue $sm;
          case 9:
            if (this._pk_endIndex2 < 0) {
              this._ARGUMENT12 = this._pk_endIndex2;
              this._ARGUMENT13 = _get_hex__0(sliceArray(this._endBytes0, until(this._endBytes0.length - 32 | 0, this._endBytes0.length)));
              this._state_1 = 16;
              suspendResult = this.__this__30._s_3.getLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 10;
              continue $sm;
            }

            break;
          case 10:
            var tmp_3 = this;
            var tmp_4 = copyOfRange_2(this._endBytes0, this._pk_endIndex2, this._endBytes0.length);
            tmp_3._data14 = openSync$default(tmp_4, null, 1, null);
            this._magic_215 = readS32BE_1(this._data14);
            if (!(this._magic_215 === 1347093766))
              throw IllegalStateException_init_$Create$_0('' + 'Not a zip file ' + _get_hex_(this._magic_215) + ' instead of ' + _get_hex_(1347092738));
            this._diskNumber_316 = readU16LE_1(this._data14);
            this._startDiskNumber_417 = readU16LE_1(this._data14);
            this._entriesOnDisk_518 = readU16LE_1(this._data14);
            this._entriesInDirectory_619 = readU16LE_1(this._data14);
            this._directorySize_720 = readS32LE_1(this._data14);
            this._directoryOffset_821 = readS32LE_1(this._data14);
            this._commentLength_922 = readU16LE_1(this._data14);
            this._state_1 = 11;
            var tmp_5 = toLong(this._directoryOffset_821);
            var tmp_6 = toLong(this._directorySize_720);
            suspendResult = sliceWithSize$default(this.__this__30._s_3, tmp_5, tmp_6, false, 4, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._ARGUMENT23 = suspendResult;
            this._state_1 = 12;
            suspendResult = readAvailable(this._ARGUMENT23, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._ARGUMENT24 = suspendResult;
            var tmp_7 = this;
            tmp_7._ds_1025 = openSync$default(this._ARGUMENT24, null, 1, null);
            this._tmp0_iterator_1126 = until(0, this._entriesInDirectory_619).iterator_0_k$();
            this._state_1 = 13;
            continue $sm;
          case 13:
            if (!this._tmp0_iterator_1126.hasNext_0_k$()) {
              this._state_1 = 15;
              continue $sm;
            }
            this._n_1227 = this._tmp0_iterator_1126.next_0_k$();
            this._magic_2_1328 = readS32BE_1(this._ds_1025);
            if (!(this._magic_2_1328 === 1347092738))
              throw IllegalStateException_init_$Create$_0('' + 'Not a zip file record ' + _get_hex_(this._magic_2_1328) + ' instead of ' + _get_hex_(1347092738));
            this._versionMade_3_1429 = readU16LE_1(this._ds_1025);
            this._versionExtract_4_1530 = readU16LE_1(this._ds_1025);
            this._flags_5_1631 = readU16LE_1(this._ds_1025);
            this._compressionMethod_6_1732 = readU16LE_1(this._ds_1025);
            this._fileTime_7_1833 = readU16LE_1(this._ds_1025);
            this._fileDate_8_1934 = readU16LE_1(this._ds_1025);
            this._crc_9_2035 = readS32LE_1(this._ds_1025);
            this._compressedSize_10_2136 = readS32LE_1(this._ds_1025);
            this._uncompressedSize_11_2237 = readS32LE_1(this._ds_1025);
            this._fileNameLength_12_2338 = readU16LE_1(this._ds_1025);
            this._extraLength_13_2439 = readU16LE_1(this._ds_1025);
            this._fileCommentLength_14_2540 = readU16LE_1(this._ds_1025);
            this._diskNumberStart_15_2641 = readU16LE_1(this._ds_1025);
            this._internalAttributes_16_2742 = readU16LE_1(this._ds_1025);
            this._externalAttributes_17_2843 = readS32LE_1(this._ds_1025);
            this._headerOffset_18_2944 = readU32LE_1(this._ds_1025);
            var tmp_8 = this;
            tmp_8._name_19_3045 = readString$default_0(this._ds_1025, this._fileNameLength_12_2338, null, 2, null);
            this._extra_20_3146 = readBytes_0(this._ds_1025, this._extraLength_13_2439);
            var tmp_9 = this;
            tmp_9._isDirectory_21_3247 = endsWith$default_1(this._name_19_3045, '/', false, 2, null);
            this._normalizedName_22_3348 = this.__this__30.normalizeName_6wfw3l_k$(this._name_19_3045);
            this._baseFolder_23_3449 = substringBeforeLast(this._normalizedName_22_3348, new Char(47), '');
            var tmp_10 = this;
            var tmp_11 = new Char(47);
            tmp_10._baseName_24_3550 = substringAfterLast$default(this._normalizedName_22_3348, tmp_11, null, 2, null);
            var tmp_12 = this;
            var tmp_13 = this;
            tmp_13._tmp0_getOrPut_0_26_3751 = this.__this__30._filesPerFolder;
            this._value_1_27_3852 = this._tmp0_getOrPut_0_26_3751.get_2bw_k$(this._baseFolder_23_3449);
            var tmp_14;
            if (this._value_1_27_3852 == null) {
              var answer_2_28_39 = LinkedHashMap_init_$Create$();
              this._tmp0_getOrPut_0_26_3751.put_1q9pf_k$(this._baseFolder_23_3449, answer_2_28_39);
              Unit_getInstance();
              tmp_14 = answer_2_28_39;
            } else {
              tmp_14 = this._value_1_27_3852;
            }

            tmp_12._folder_25_3653 = tmp_14;
            this._state_1 = 14;
            suspendResult = sliceStart$default(this.__this__30._s_3, this._headerOffset_18_2944, false, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 14:
            var headerEntry_29_40 = suspendResult;
            var tmp0_time_31_42 = new DosFileDateTime(this._fileTime_7_1833, this._fileDate_8_1934);
            var tmp1_inode_32_43 = toLong(this._n_1227);
            var tmp2_offset_33_44 = this._headerOffset_18_2944.toInt_0_k$();
            var tmp3_compressedSize_34_45 = toLong(this._compressedSize_10_2136).and_wiekkq_k$(new Long(-1, 0));
            var tmp4_uncompressedSize_35_46 = toLong(this._uncompressedSize_11_2237).and_wiekkq_k$(new Long(-1, 0));
            var entry_30_41 = new ZipEntry2(this._name_19_3045, this._compressionMethod_6_1732, this._isDirectory_21_3247, tmp0_time_31_42, tmp2_offset_33_44, tmp1_inode_32_43, headerEntry_29_40, tmp3_compressedSize_34_45, tmp4_uncompressedSize_35_46);
            var components_36_47 = plus(listOf_0(''), getPathFullComponents(_PathInfo___init__impl_(this._normalizedName_22_3348)));
            var inductionVariable = 1;
            var last_1 = components_36_47._get_size__0_k$();
            if (inductionVariable < last_1)
              do {
                var m_38_49 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var f_39_50 = components_36_47.get_ha5a7z_k$(m_38_49 - 1 | 0);
                var c_40_51 = components_36_47.get_ha5a7z_k$(m_38_49);
                var tmp1_contains_0_41_52 = this.__this__30._files;
                if (!(isInterface(tmp1_contains_0_41_52, Map_0) ? tmp1_contains_0_41_52 : THROW_CCE()).containsKey_2bw_k$(c_40_51)) {
                  var tmp2_getOrPut_0_43_54 = this.__this__30._filesPerFolder;
                  var value_1_44_55 = tmp2_getOrPut_0_43_54.get_2bw_k$(f_39_50);
                  var tmp_15;
                  if (value_1_44_55 == null) {
                    var answer_2_45_56 = LinkedHashMap_init_$Create$();
                    tmp2_getOrPut_0_43_54.put_1q9pf_k$(f_39_50, answer_2_45_56);
                    Unit_getInstance();
                    tmp_15 = answer_2_45_56;
                  } else {
                    tmp_15 = value_1_44_55;
                  }
                  var folder2_42_53 = tmp_15;
                  var tmp6_time_47_58 = new DosFileDateTime(0, 0);
                  var tmp7_headerEntry_48_59 = openAsync$default(new Int8Array([]), null, 1, null);
                  var entry2_46_57 = new ZipEntry2(c_40_51, 0, true, tmp6_time_47_58, 0, new Long(0, 0), tmp7_headerEntry_48_59, new Long(0, 0), new Long(0, 0));
                  var tmp3_set_0_49_60 = _get_baseName__0(_PathInfo___init__impl_(c_40_51));
                  folder2_42_53.put_1q9pf_k$(tmp3_set_0_49_60, entry2_46_57);
                  Unit_getInstance();
                  var tmp4_set_0_50_61 = this.__this__30._files;
                  tmp4_set_0_50_61.put_1q9pf_k$(c_40_51, entry2_46_57);
                  Unit_getInstance();
                } else {
                }
              }
               while (inductionVariable < last_1);
            this._folder_25_3653.put_1q9pf_k$(this._baseName_24_3550, entry_30_41);
            Unit_getInstance();
            var tmp5_set_0_51_62 = this.__this__30._files;
            tmp5_set_0_51_62.put_1q9pf_k$(this._normalizedName_22_3348, entry_30_41);
            Unit_getInstance();
            Unit_getInstance();
            this._state_1 = 13;
            continue $sm;
          case 15:
            var tmp0_set_0_63 = this.__this__30._files;
            var tmp1_time_65 = new DosFileDateTime(0, 0);
            var tmp2_headerEntry_66 = openAsync$default(new Int8Array([]), null, 1, null);
            var tmp1_set_0_64 = new ZipEntry2('', 0, true, tmp1_time_65, 0, new Long(0, 0), tmp2_headerEntry_66, new Long(0, 0), new Long(0, 0));
            tmp0_set_0_63.put_1q9pf_k$('', tmp1_set_0_64);
            Unit_getInstance();
            Unit_getInstance();
            Unit_getInstance();
            return Unit_getInstance();
          case 16:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = '' + 'Not a zip file (pk_endIndex < 0) : pk_endIndex=' + this._ARGUMENT12 + ' : ' + this._ARGUMENT13 + ' : ' + ARGUMENT;
            throw IllegalArgumentException_init_$Create$(ARGUMENT_0);
          case 17:
            var ARGUMENT_1 = suspendResult;
            var ARGUMENT_2 = '' + 'Zip file is too small length=' + ARGUMENT_1;
            throw IllegalArgumentException_init_$Create$(ARGUMENT_2);
          case 18:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 18) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$34.$metadata$ = {
    simpleName: '$readCOROUTINE$34',
    kind: 'class',
    interfaces: []
  };
  function ZipFile(dummy, s, caseSensitive) {
    Companion_getInstance_106();
    this._dummy_0 = dummy;
    this._s_3 = s;
    this._caseSensitive_0 = caseSensitive;
    this._files = LinkedHashMap_init_$Create$();
    this._filesPerFolder = LinkedHashMap_init_$Create$();
  }
  ZipFile.prototype.normalizeName_6wfw3l_k$ = function (name) {
    var tmp;
    if (this._caseSensitive_0) {
      tmp = trim(name, charArrayOf([new Char(47)]));
    } else {
      var tmp0_toLowerCase_0 = trim(name, charArrayOf([new Char(47)]));
      tmp = tmp0_toLowerCase_0.toLowerCase();
    }
    return tmp;
  };
  ZipFile.$metadata$ = {
    simpleName: 'ZipFile',
    kind: 'class',
    interfaces: []
  };
  function ZipEntry2(path_0, compressionMethod, isDirectory, time, offset_0, inode, headerEntry, compressedSize, uncompressedSize) {
    this._path = path_0;
    this._compressionMethod = compressionMethod;
    this._isDirectory = isDirectory;
    this._time_2 = time;
    this._offset_8 = offset_0;
    this._inode = inode;
    this._headerEntry = headerEntry;
    this._compressedSize = compressedSize;
    this._uncompressedSize = uncompressedSize;
  }
  ZipEntry2.prototype.toString = function () {
    return '' + 'ZipEntry2(path=' + this._path + ', compressionMethod=' + this._compressionMethod + ', isDirectory=' + this._isDirectory + ', time=' + this._time_2 + ', offset=' + this._offset_8 + ', inode=' + this._inode + ', headerEntry=' + this._headerEntry + ', compressedSize=' + this._compressedSize + ', uncompressedSize=' + this._uncompressedSize + ')';
  };
  ZipEntry2.prototype.hashCode = function () {
    var result = getStringHashCode(this._path);
    result = imul(result, 31) + this._compressionMethod | 0;
    result = imul(result, 31) + (this._isDirectory | 0) | 0;
    result = imul(result, 31) + this._time_2.hashCode() | 0;
    result = imul(result, 31) + this._offset_8 | 0;
    result = imul(result, 31) + this._inode.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._headerEntry) | 0;
    result = imul(result, 31) + this._compressedSize.hashCode() | 0;
    result = imul(result, 31) + this._uncompressedSize.hashCode() | 0;
    return result;
  };
  ZipEntry2.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ZipEntry2))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ZipEntry2 ? other : THROW_CCE();
    if (!(this._path === tmp0_other_with_cast._path))
      return false;
    if (!(this._compressionMethod === tmp0_other_with_cast._compressionMethod))
      return false;
    if (!(this._isDirectory === tmp0_other_with_cast._isDirectory))
      return false;
    if (!this._time_2.equals(tmp0_other_with_cast._time_2))
      return false;
    if (!(this._offset_8 === tmp0_other_with_cast._offset_8))
      return false;
    if (!this._inode.equals(tmp0_other_with_cast._inode))
      return false;
    if (!equals_1(this._headerEntry, tmp0_other_with_cast._headerEntry))
      return false;
    if (!this._compressedSize.equals(tmp0_other_with_cast._compressedSize))
      return false;
    if (!this._uncompressedSize.equals(tmp0_other_with_cast._uncompressedSize))
      return false;
    return true;
  };
  ZipEntry2.$metadata$ = {
    simpleName: 'ZipEntry2',
    kind: 'class',
    interfaces: []
  };
  function DosFileDateTime(dosTime, dosDate) {
    this._dosTime = dosTime;
    this._dosDate = dosDate;
    var tmp = this;
    var tmp_0 = Companion_getInstance_82();
    var tmp_1 = this._get_fullYear__0_k$();
    var tmp_2 = this._get_month1__0_k$();
    var tmp_3 = this._get_day__0_k$();
    var tmp_4 = this._get_hours__0_k$();
    var tmp_5 = this._get_minutes__0_k$();
    var tmp_6 = this._get_seconds__0_k$();
    tmp._utc = tmp_0.createAdjusted$default_24ynig_k$(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, 0, 64, null);
  }
  DosFileDateTime.prototype._get_seconds__0_k$ = function () {
    return imul(2, extract(this._dosTime, 0, 5));
  };
  DosFileDateTime.prototype._get_minutes__0_k$ = function () {
    return extract(this._dosTime, 5, 6);
  };
  DosFileDateTime.prototype._get_hours__0_k$ = function () {
    return extract(this._dosTime, 11, 5);
  };
  DosFileDateTime.prototype._get_day__0_k$ = function () {
    return extract(this._dosDate, 0, 5);
  };
  DosFileDateTime.prototype._get_month1__0_k$ = function () {
    return extract(this._dosDate, 5, 4);
  };
  DosFileDateTime.prototype._get_fullYear__0_k$ = function () {
    return 1980 + extract(this._dosDate, 9, 7) | 0;
  };
  DosFileDateTime.prototype.toString = function () {
    return '' + 'DosFileDateTime(dosTime=' + this._dosTime + ', dosDate=' + this._dosDate + ')';
  };
  DosFileDateTime.prototype.hashCode = function () {
    var result = this._dosTime;
    result = imul(result, 31) + this._dosDate | 0;
    return result;
  };
  DosFileDateTime.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DosFileDateTime))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DosFileDateTime ? other : THROW_CCE();
    if (!(this._dosTime === tmp0_other_with_cast._dosTime))
      return false;
    if (!(this._dosDate === tmp0_other_with_cast._dosDate))
      return false;
    return true;
  };
  DosFileDateTime.$metadata$ = {
    simpleName: 'DosFileDateTime',
    kind: 'class',
    interfaces: []
  };
  function KorAtomicRef(initial, dummy) {
    this._value_13 = initial;
  }
  KorAtomicRef.prototype._get_value__0_k$ = function () {
    return this._value_13;
  };
  KorAtomicRef.$metadata$ = {
    simpleName: 'KorAtomicRef',
    kind: 'class',
    interfaces: [KorAtomicBase]
  };
  function KorAtomicRef_0(initial) {
    return korAtomic(initial);
  }
  function KorAtomicBase() {
  }
  KorAtomicBase.$metadata$ = {
    simpleName: 'KorAtomicBase',
    kind: 'interface',
    interfaces: []
  };
  function KorAtomicBoolean(initial, dummy) {
    this._value_14 = initial;
  }
  KorAtomicBoolean.prototype._set_value__rpwsgn_k$ = function (_set___) {
    this._value_14 = _set___;
  };
  KorAtomicBoolean.prototype._get_value__0_k$ = function () {
    return this._value_14;
  };
  KorAtomicBoolean.$metadata$ = {
    simpleName: 'KorAtomicBoolean',
    kind: 'class',
    interfaces: [KorAtomicBase]
  };
  function _Dyn___init__impl_(value) {
    return value;
  }
  function _Dyn___get_value__impl_(this_0) {
    return this_0;
  }
  function Companion_108() {
    Companion_instance_107 = this;
  }
  Companion_108.prototype._get_global__l8f35o_k$ = function () {
    return _get_dyn_(dynApi._get_global__0_k$());
  };
  Companion_108.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_107;
  function Companion_getInstance_107() {
    if (Companion_instance_107 == null)
      new Companion_108();
    return Companion_instance_107;
  }
  function Dyn__set_impl(this_0, key, value) {
    var tmp0_subject = value;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, MutableMap) : false) {
      var tmp = _Dyn___get_value__impl_(this_0);
      var tmp0_set_0 = (!(tmp == null) ? isInterface(tmp, MutableMap) : false) ? tmp : THROW_CCE();
      tmp0_set_0.put_1q9pf_k$(key, value);
      Unit_getInstance();
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, MutableList) : false) {
        var tmp_0 = _Dyn___get_value__impl_(this_0);
        ((!(tmp_0 == null) ? isInterface(tmp_0, MutableList) : false) ? tmp_0 : THROW_CCE()).set_ddb1qf_k$(Dyn__toInt_impl(_get_dyn_(key)), value);
        Unit_getInstance();
      } else {
        dynApi.set_ih9ei8_k$(_Dyn___get_value__impl_(this_0), toString_0(key), value);
      }
    }
  }
  function _Dyn___get_listAny__impl_(this_0) {
    var tmp;
    if (_Dyn___get_value__impl_(this_0) == null) {
      tmp = emptyList();
    } else {
      var tmp_0 = _Dyn___get_value__impl_(this_0);
      if (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) {
        tmp = _Dyn___get_value__impl_(this_0);
      } else {
        var tmp_1 = _Dyn___get_value__impl_(this_0);
        if (!(tmp_1 == null) ? isInterface(tmp_1, Iterable) : false) {
          tmp = toList_3(_Dyn___get_value__impl_(this_0));
        } else {
          {
            tmp = listOf_0(_Dyn___get_value__impl_(this_0));
          }
        }
      }
    }
    return tmp;
  }
  function Dyn__toNumber_impl(this_0, receiver) {
    var tmp = toIntOrNull(receiver);
    var tmp0_elvis_lhs = (tmp == null ? true : isNumber(tmp)) ? tmp : null;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? toDoubleOrNull(receiver) : tmp0_elvis_lhs;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      DoubleCompanionObject_getInstance();
      tmp_0 = NaN;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  function Dyn__toBool_impl(this_0, extraStrings) {
    var tmp0_subject = _Dyn___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject == null) {
      tmp = false;
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
        tmp = _Dyn___get_value__impl_(this_0);
      } else {
        {
          var tmp1_elvis_lhs = Dyn__toBoolOrNull_impl(this_0, extraStrings);
          tmp = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
        }
      }
    }
    return tmp;
  }
  function Dyn__toBool$default_impl(this_0, extraStrings, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      extraStrings = true;
    return Dyn__toBool_impl(this_0, extraStrings);
  }
  function Dyn__toBoolOrNull_impl(this_0, extraStrings) {
    var tmp0_subject = _Dyn___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject == null) {
      tmp = null;
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
        tmp = _Dyn___get_value__impl_(this_0);
      } else {
        if (isNumber(tmp0_subject)) {
          tmp = !(Dyn__toDouble_impl(this_0) === 0.0);
        } else {
          if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
            var tmp_0;
            if (extraStrings) {
              var tmp0_toLowerCase_0 = _Dyn___get_value__impl_(this_0);
              var tmp1_subject = tmp0_toLowerCase_0.toLowerCase();
              switch (tmp1_subject) {
                case '':
                case '0':
                case 'false':
                case 'NaN':
                case 'null':
                case 'undefined':
                case 'ko':
                case 'no':
                  tmp_0 = false;
                  break;
                default:tmp_0 = true;
                  break;
              }
            } else {
              var tmp_1;
              var tmp_2;
              var tmp1_isNotEmpty_0 = _Dyn___get_value__impl_(this_0);
              if (charSequenceLength(tmp1_isNotEmpty_0) > 0) {
                tmp_2 = !equals_1(_Dyn___get_value__impl_(this_0), '0');
              } else {
                {
                  tmp_2 = false;
                }
              }
              if (tmp_2) {
                tmp_1 = !equals_1(_Dyn___get_value__impl_(this_0), 'false');
              } else {
                {
                  tmp_1 = false;
                }
              }
              tmp_0 = tmp_1;
            }
            tmp = tmp_0;
          } else {
            {
              tmp = null;
            }
          }
        }
      }
    }
    return tmp;
  }
  function Dyn__toNumber_impl_0(this_0) {
    var tmp0_subject = _Dyn___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject == null) {
      tmp = 0;
    } else {
      if (isNumber(tmp0_subject)) {
        tmp = _Dyn___get_value__impl_(this_0);
      } else {
        if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
          tmp = _Dyn___get_value__impl_(this_0) ? 1 : 0;
        } else {
          if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
            var tmp_0 = _Dyn___get_value__impl_(this_0);
            var tmp1_elvis_lhs = toIntSafe$default(tmp_0, 0, 1, null);
            var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? toDoubleSafe(_Dyn___get_value__impl_(this_0)) : tmp1_elvis_lhs;
            tmp = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
          } else {
            {
              tmp = Dyn__toNumber_impl(this_0, toString_1(_Dyn___get_value__impl_(this_0)));
            }
          }
        }
      }
    }
    return tmp;
  }
  function Dyn__toByte_impl(this_0) {
    return numberToByte(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toChar_impl(this_0) {
    var tmp;
    var tmp_0 = _Dyn___get_value__impl_(this_0);
    if (tmp_0 instanceof Char) {
      tmp = _Dyn___get_value__impl_(this_0);
    } else {
      var tmp_1;
      var tmp_2 = _Dyn___get_value__impl_(this_0);
      if (!(tmp_2 == null) ? typeof tmp_2 === 'string' : false) {
        tmp_1 = _Dyn___get_value__impl_(this_0).length === 1;
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp = first_1(_Dyn___get_value__impl_(this_0));
      } else {
        {
          tmp = numberToChar(Dyn__toNumber_impl_0(this_0));
        }
      }
    }
    return tmp;
  }
  function Dyn__toShort_impl(this_0) {
    return numberToShort(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toInt_impl(this_0) {
    return numberToInt(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toLong_impl(this_0) {
    return numberToLong(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toFloat_impl(this_0) {
    return numberToDouble(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toDouble_impl(this_0) {
    return numberToDouble(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toIntDefault_impl(this_0, default_0) {
    var tmp0_subject = _Dyn___get_value__impl_(this_0);
    var tmp;
    if (isNumber(tmp0_subject)) {
      tmp = Dyn__toInt_impl(this_0);
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
        var tmp1_elvis_lhs = toIntSafe(_Dyn___get_value__impl_(this_0), 10);
        tmp = tmp1_elvis_lhs == null ? default_0 : tmp1_elvis_lhs;
      } else {
        {
          tmp = default_0;
        }
      }
    }
    return tmp;
  }
  function Dyn__toIntDefault$default_impl(this_0, default_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      default_0 = 0;
    return Dyn__toIntDefault_impl(this_0, default_0);
  }
  function _Dyn___get_int__impl_(this_0) {
    return Dyn__toIntDefault$default_impl(this_0, 0, 1, null);
  }
  function _get_dyn_(_this_) {
    return _Dyn___init__impl_(_this_);
  }
  function toIntSafe(_this_, radix) {
    return toIntOrNull_0(_this_, radix);
  }
  function toIntSafe$default(_this_, radix, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      radix = 10;
    return toIntSafe(_this_, radix);
  }
  function toDoubleSafe(_this_) {
    return toDoubleOrNull(_this_);
  }
  var defaultDynApi;
  var dynApi;
  function DynApi() {
  }
  DynApi.prototype._get_global__0_k$ = function () {
    return null;
  };
  DynApi.$metadata$ = {
    simpleName: 'DynApi',
    kind: 'interface',
    interfaces: []
  };
  function Companion_109() {
    Companion_instance_108 = this;
    KDynamic.call(this);
  }
  Companion_109.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_108;
  function Companion_getInstance_108() {
    if (Companion_instance_108 == null)
      new Companion_109();
    return Companion_instance_108;
  }
  function KDynamic() {
    Companion_getInstance_108();
  }
  KDynamic.prototype._get_global__0_k$ = function () {
    return _Dyn___get_value__impl_(Companion_getInstance_107()._get_global__l8f35o_k$());
  };
  KDynamic.prototype.set_3qffwg_k$ = function (_this__0, key, value) {
    return Dyn__set_impl(_get_dyn_(_this__0), key, value);
  };
  KDynamic.prototype._get_list__kajtkh_k$ = function (_this__0) {
    return _Dyn___get_listAny__impl_(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toBool_kajtkh_k$ = function (_this__0) {
    var tmp = _get_dyn_(_this__0);
    return Dyn__toBool$default_impl(tmp, false, 1, null);
  };
  KDynamic.prototype.toByte_kajtkh_k$ = function (_this__0) {
    return Dyn__toByte_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toChar_kajtkh_k$ = function (_this__0) {
    return Dyn__toChar_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toShort_kajtkh_k$ = function (_this__0) {
    return Dyn__toShort_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toInt_kajtkh_k$ = function (_this__0) {
    return Dyn__toInt_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toLong_kajtkh_k$ = function (_this__0) {
    return Dyn__toLong_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toFloat_kajtkh_k$ = function (_this__0) {
    return Dyn__toFloat_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toDouble_kajtkh_k$ = function (_this__0) {
    return Dyn__toDouble_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype._get_int__kajtkh_k$ = function (_this__0) {
    return _Dyn___get_int__impl_(_get_dyn_(_this__0));
  };
  KDynamic.$metadata$ = {
    simpleName: 'KDynamic',
    kind: 'class',
    interfaces: []
  };
  var Mapper;
  function TypeContext(mapper) {
    KDynamic.call(this);
    this._mapper = mapper;
  }
  TypeContext.$metadata$ = {
    simpleName: 'TypeContext',
    kind: 'class',
    interfaces: []
  };
  function UntypeContext(map_0) {
    this._map_4 = map_0;
  }
  UntypeContext.$metadata$ = {
    simpleName: 'UntypeContext',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__145() {
  }
  _no_name_provided__145.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return $this$registerType.toBool_kajtkh_k$(it);
  };
  _no_name_provided__145.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__145.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__146() {
  }
  _no_name_provided__146.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return $this$registerType.toByte_kajtkh_k$(it);
  };
  _no_name_provided__146.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__146.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__147() {
  }
  _no_name_provided__147.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return $this$registerType.toChar_kajtkh_k$(it);
  };
  _no_name_provided__147.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__147.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__148() {
  }
  _no_name_provided__148.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return $this$registerType.toShort_kajtkh_k$(it);
  };
  _no_name_provided__148.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__148.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__149() {
  }
  _no_name_provided__149.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return $this$registerType.toInt_kajtkh_k$(it);
  };
  _no_name_provided__149.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__149.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__150() {
  }
  _no_name_provided__150.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return $this$registerType.toLong_kajtkh_k$(it);
  };
  _no_name_provided__150.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__150.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__151() {
  }
  _no_name_provided__151.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return $this$registerType.toFloat_kajtkh_k$(it);
  };
  _no_name_provided__151.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__151.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__152() {
  }
  _no_name_provided__152.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return $this$registerType.toDouble_kajtkh_k$(it);
  };
  _no_name_provided__152.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__152.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__153() {
  }
  _no_name_provided__153.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return toSet_0($this$registerType._get_list__kajtkh_k$(it));
  };
  _no_name_provided__153.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__153.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__154() {
  }
  _no_name_provided__154.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return $this$registerType._get_list__kajtkh_k$(it);
  };
  _no_name_provided__154.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__154.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__155() {
  }
  _no_name_provided__155.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    return toMutableList_3($this$registerType._get_list__kajtkh_k$(it));
  };
  _no_name_provided__155.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__155.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__156() {
  }
  _no_name_provided__156.prototype.invoke_a7p0jt_k$ = function ($this$registerType, it) {
    var tmp0_safe_receiver = it;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  };
  _no_name_provided__156.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_a7p0jt_k$(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__156.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ObjectMapper() {
    var tmp = this;
    tmp.__typers = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    tmp_0.__untypers = LinkedHashMap_init_$Create$();
    this._fallbackTyper = null;
    this._fallbackUntyper = null;
    this._typeCtx = new TypeContext(this);
    this._untypeCtx = new UntypeContext(this);
    var tmp_1 = PrimitiveClasses_getInstance()._get_booleanClass__0_k$();
    this.registerType_6m096n_k$(tmp_1, _no_name_provided_$factory_114());
    Unit_getInstance();
    var tmp_2 = PrimitiveClasses_getInstance()._get_byteClass__0_k$();
    this.registerType_6m096n_k$(tmp_2, _no_name_provided_$factory_115());
    Unit_getInstance();
    var tmp_3 = getKClass_0(Char);
    this.registerType_6m096n_k$(tmp_3, _no_name_provided_$factory_116());
    Unit_getInstance();
    var tmp_4 = PrimitiveClasses_getInstance()._get_shortClass__0_k$();
    this.registerType_6m096n_k$(tmp_4, _no_name_provided_$factory_117());
    Unit_getInstance();
    var tmp_5 = PrimitiveClasses_getInstance()._get_intClass__0_k$();
    this.registerType_6m096n_k$(tmp_5, _no_name_provided_$factory_118());
    Unit_getInstance();
    var tmp_6 = getKClass_0(Long);
    this.registerType_6m096n_k$(tmp_6, _no_name_provided_$factory_119());
    Unit_getInstance();
    var tmp_7 = PrimitiveClasses_getInstance()._get_floatClass__0_k$();
    this.registerType_6m096n_k$(tmp_7, _no_name_provided_$factory_120());
    Unit_getInstance();
    var tmp_8 = PrimitiveClasses_getInstance()._get_doubleClass__0_k$();
    this.registerType_6m096n_k$(tmp_8, _no_name_provided_$factory_121());
    Unit_getInstance();
    var tmp_9 = getKClass_0(Set);
    this.registerType_6m096n_k$(tmp_9, _no_name_provided_$factory_122());
    Unit_getInstance();
    var tmp_10 = getKClass_0(List);
    this.registerType_6m096n_k$(tmp_10, _no_name_provided_$factory_123());
    Unit_getInstance();
    var tmp_11 = getKClass_0(MutableList);
    this.registerType_6m096n_k$(tmp_11, _no_name_provided_$factory_124());
    Unit_getInstance();
    var tmp_12 = PrimitiveClasses_getInstance()._get_stringClass__0_k$();
    this.registerType_6m096n_k$(tmp_12, _no_name_provided_$factory_125());
    Unit_getInstance();
  }
  ObjectMapper.prototype.registerType_6m096n_k$ = function (clazz, generate) {
    var tmp0_set_0_2 = this.__typers;
    tmp0_set_0_2.put_1q9pf_k$(clazz, generate);
    Unit_getInstance();
    return this;
  };
  ObjectMapper.$metadata$ = {
    simpleName: 'ObjectMapper',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_114() {
    var i = new _no_name_provided__145();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_115() {
    var i = new _no_name_provided__146();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_116() {
    var i = new _no_name_provided__147();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_117() {
    var i = new _no_name_provided__148();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_118() {
    var i = new _no_name_provided__149();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_119() {
    var i = new _no_name_provided__150();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_120() {
    var i = new _no_name_provided__151();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_121() {
    var i = new _no_name_provided__152();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_122() {
    var i = new _no_name_provided__153();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_123() {
    var i = new _no_name_provided__154();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_124() {
    var i = new _no_name_provided__155();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_125() {
    var i = new _no_name_provided__156();
    return function (p1, p2) {
      return i.invoke_a7p0jt_k$(p1, p2);
    };
  }
  function normalize(_this_) {
    var path_0 = _PathInfo___get_fullPath__impl_(_this_);
    var schemeIndex = indexOf$default_0(path_0, ':', 0, false, 6, null);
    var tmp;
    if (schemeIndex >= 0) {
      var tmp_0;
      var tmp_1 = path_0.substring(schemeIndex);
      if (startsWith$default_1(tmp_1, '://', false, 2, null)) {
        tmp_0 = 3;
      } else {
        {
          tmp_0 = 1;
        }
      }
      var take_3 = tmp_0;
      var tmp0_substring_0 = schemeIndex + take_3 | 0;
      var tmp_2 = path_0.substring(0, tmp0_substring_0);
      var tmp1_substring_0 = schemeIndex + take_3 | 0;
      tmp = tmp_2 + normalize(_get_pathInfo_(path_0.substring(tmp1_substring_0)));
    } else {
      var tmp_3 = new Char(92);
      var tmp_4 = new Char(47);
      var path2 = replace$default(path_0, tmp_3, tmp_4, false, 4, null);
      var out = ArrayList_init_$Create$();
      var tmp2_fastForEach_0 = split$default_0(path2, ['/'], false, 0, 6, null);
      var n_1 = 0;
      while (n_1 < tmp2_fastForEach_0._get_size__0_k$()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp3__anonymous__3 = tmp2_fastForEach_0.get_ha5a7z_k$(tmp0_2);
        var tmp0_subject_4 = tmp3__anonymous__3;
        switch (tmp0_subject_4) {
          case '':
          case '.':
            if (out.isEmpty_0_k$()) {
              out.add_2bq_k$('');
              Unit_getInstance();
            } else
              Unit_getInstance();
            break;
          case '..':
            if (!out.isEmpty_0_k$()) {
              out.removeAt_ha5a7z_k$(out._get_size__0_k$() - 1 | 0);
              Unit_getInstance();
            } else {
            }

            break;
          default:out.add_2bq_k$(tmp3__anonymous__3);
            Unit_getInstance();
            break;
        }
      }
      tmp = joinToString$default_0(out, '/', null, null, 0, null, null, 62, null);
    }
    return tmp;
  }
  function _PathInfo___init__impl_(fullPath) {
    return fullPath;
  }
  function _PathInfo___get_fullPath__impl_(this_0) {
    return this_0;
  }
  function _get_pathInfo_(_this_) {
    return _PathInfo___init__impl_(_this_);
  }
  function VfsNamed(pathInfo) {
    this._pathInfo = pathInfo;
  }
  VfsNamed.prototype._get_pathInfo__i519nt_k$ = function () {
    return this._pathInfo;
  };
  VfsNamed.$metadata$ = {
    simpleName: 'VfsNamed',
    kind: 'class',
    interfaces: [Path_0]
  };
  function _get_folder_(_this_) {
    return _get_folder__0(_this_._get_pathInfo__i519nt_k$());
  }
  function combine(_this_, access) {
    var base = _PathInfo___get_fullPath__impl_(_this_);
    var access_0 = _PathInfo___get_fullPath__impl_(access);
    return _get_pathInfo_(isAbsolute(_get_pathInfo_(access_0)) ? normalize(_get_pathInfo_(access_0)) : normalize(_get_pathInfo_('' + base + '/' + access_0)));
  }
  function _get_baseName_(_this_) {
    return _get_baseName__0(_this_._get_pathInfo__i519nt_k$());
  }
  function _get_fullNameWithoutExtension_(_this_) {
    return _get_fullNameWithoutExtension__0(_this_._get_pathInfo__i519nt_k$());
  }
  function lightCombine(_this_, access) {
    var base = _PathInfo___get_fullPath__impl_(_this_);
    var access_0 = _PathInfo___get_fullPath__impl_(access);
    var tmp;
    if (charSequenceLength(base) > 0) {
      tmp = trimEnd(base, charArrayOf([new Char(47)])) + '/' + trim(access_0, charArrayOf([new Char(47)]));
    } else {
      {
        tmp = access_0;
      }
    }
    var res = tmp;
    return _get_pathInfo_(res);
  }
  function Path_0() {
  }
  Path_0.$metadata$ = {
    simpleName: 'Path',
    kind: 'interface',
    interfaces: []
  };
  function parts(_this_) {
    var tmp = _PathInfo___get_fullPath__impl_(_this_);
    var tmp_0 = charArrayOf([new Char(47)]);
    return split$default(tmp, tmp_0, false, 0, 6, null);
  }
  function _get_folder__0(_this_) {
    var tmp0_substring_0 = _PathInfo___get_fullPath__impl_(_this_);
    var tmp = _get_fullPathNormalized_(_this_);
    var tmp_0 = new Char(47);
    var tmp0_elvis_lhs = lastIndexOfOrNull$default(tmp, tmp_0, 0, 2, null);
    var tmp1_substring_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    return tmp0_substring_0.substring(0, tmp1_substring_0);
  }
  function isAbsolute(_this_) {
    var base = _PathInfo___get_fullPath__impl_(_this_);
    if (charSequenceLength(base) === 0)
      return false;
    else {
    }
    var tmp = new Char(92);
    var tmp_0 = new Char(47);
    var tmp_1 = replace$default(base, tmp, tmp_0, false, 4, null);
    var tmp_2 = new Char(47);
    var b = substringBefore$default(tmp_1, tmp_2, null, 2, null);
    if (charSequenceLength(b) === 0)
      return true;
    else {
    }
    var tmp_3 = new Char(58);
    if (contains$default(b, tmp_3, false, 2, null))
      return true;
    else {
    }
    return false;
  }
  function _get_baseName__0(_this_) {
    var tmp = _get_fullPathNormalized_(_this_);
    var tmp_0 = new Char(47);
    return substringAfterLast$default(tmp, tmp_0, null, 2, null);
  }
  function _get_fullNameWithoutExtension__0(_this_) {
    return '' + _get_folderWithSlash_(_this_) + _get_baseNameWithoutExtension_(_this_);
  }
  function _get_fullPathNormalized_(_this_) {
    var tmp = _PathInfo___get_fullPath__impl_(_this_);
    var tmp_0 = new Char(92);
    var tmp_1 = new Char(47);
    return replace$default(tmp, tmp_0, tmp_1, false, 4, null);
  }
  function _get_folderWithSlash_(_this_) {
    var tmp0_substring_0 = _PathInfo___get_fullPath__impl_(_this_);
    var tmp = _get_fullPathNormalized_(_this_);
    var tmp_0 = new Char(47);
    var tmp0_safe_receiver = lastIndexOfOrNull$default(tmp, tmp_0, 0, 2, null);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver + 1 | 0;
    var tmp1_substring_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return tmp0_substring_0.substring(0, tmp1_substring_0);
  }
  function _get_baseNameWithoutExtension_(_this_) {
    return substringBeforeLast(_get_baseName__0(_this_), new Char(46), _get_baseName__0(_this_));
  }
  function _get_extensionLC_(_this_) {
    var tmp0_toLowerCase_0 = _get_extension_(_this_);
    return tmp0_toLowerCase_0.toLowerCase();
  }
  function _get_extensionLC__0(_this_) {
    return _get_extensionLC_(_this_._get_pathInfo__i519nt_k$());
  }
  function _get_extension_(_this_) {
    return substringAfterLast(_get_baseName__0(_this_), new Char(46), '');
  }
  function getPathFullComponents(_this_) {
    var out = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last_1 = _get_fullPathNormalized_(_this_).length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_subject = charSequenceGet(_get_fullPathNormalized_(_this_), n);
        if (tmp1_subject.equals(new Char(47)) ? true : tmp1_subject.equals(new Char(92))) {
          var tmp0_substring_0 = _get_fullPathNormalized_(_this_);
          var tmp1_plusAssign_0 = tmp0_substring_0.substring(0, n);
          out.add_2bq_k$(tmp1_plusAssign_0);
          Unit_getInstance();
        }}
       while (inductionVariable < last_1);
    var tmp2_plusAssign_0 = _get_fullPathNormalized_(_this_);
    out.add_2bq_k$(tmp2_plusAssign_0);
    Unit_getInstance();
    return out;
  }
  function SimpleStorage() {
  }
  SimpleStorage.$metadata$ = {
    simpleName: 'SimpleStorage',
    kind: 'interface',
    interfaces: []
  };
  function $emit_2COROUTINE$60(_this_, value, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__31 = _this_;
    this._value_15 = value;
  }
  $emit_2COROUTINE$60.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__31._this$0_39.transform_7bxu44_k$(this._value_15, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_1 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__31._$this_flow.emit_iav7o_k$(this._ARGUMENT0_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $emit_2COROUTINE$60.$metadata$ = {
    simpleName: '$emit_2COROUTINE$60',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_9($this_flow, this$0) {
    this._$this_flow = $this_flow;
    this._this$0_39 = this$0;
  }
  _no_name_provided__1_9.prototype.emit_2_ba5hwt_k$ = function (value, $cont) {
    var tmp = new $emit_2COROUTINE$60(this, value, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__1_9.prototype.emit_iav7o_k$ = function (value, $cont) {
    return this.emit_2_ba5hwt_k$(value instanceof VfsFile ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_9.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function initOnce($this, $cont) {
    var tmp = new $initOnceCOROUTINE$46($this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__157(this$0, $path, resultContinuation) {
    this._this$0_40 = this$0;
    this._$path = $path;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__157.prototype.invoke_8bppsg_k$ = function ($this$flow, $cont) {
    var tmp = this.create_bv35dh_k$($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__157.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_8bppsg_k$((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__157.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = initOnce(this._this$0_40, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            this._state_1 = 2;
            suspendResult = this._this$0_40.access_6wfw3l_k$(this._$path, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT0_2 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT0_2.list_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._tmp0_collect_01 = suspendResult;
            this._state_1 = 4;
            suspendResult = this._tmp0_collect_01.collect_l0hod5_k$(new _no_name_provided__1_9(this._$this$flow, this._this$0_40), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__157.prototype.create_bv35dh_k$ = function ($this$flow, completion) {
    var i = new _no_name_provided__157(this._this$0_40, this._$path, completion);
    i._$this$flow = $this$flow;
    return i;
  };
  _no_name_provided__157.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $getUnderlyingUnscapedFileCOROUTINE$45(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__32 = _this_;
    this._path_0 = path_0;
  }
  $getUnderlyingUnscapedFileCOROUTINE$45.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__32, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_3 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_3.access_6wfw3l_k$(this._path_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_0 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_0.getUnderlyingUnscapedFile_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getUnderlyingUnscapedFileCOROUTINE$45.$metadata$ = {
    simpleName: '$getUnderlyingUnscapedFileCOROUTINE$45',
    kind: 'class',
    interfaces: []
  };
  function $initOnceCOROUTINE$46(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__33 = _this_;
  }
  $initOnceCOROUTINE$46.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (!this.__this__33._initialized) {
              this.__this__33._initialized = true;
              this._state_1 = 1;
              suspendResult = this.__this__33.init_sv8swh_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            return this.__this__33;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $initOnceCOROUTINE$46.$metadata$ = {
    simpleName: '$initOnceCOROUTINE$46',
    kind: 'class',
    interfaces: []
  };
  function $openCOROUTINE$48(_this_, path_0, mode, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__34 = _this_;
    this._path_1 = path_0;
    this._mode = mode;
  }
  $openCOROUTINE$48.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__34, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_4 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_4.access_6wfw3l_k$(this._path_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_1 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_1.open_izlxhr_k$(this._mode, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openCOROUTINE$48.$metadata$ = {
    simpleName: '$openCOROUTINE$48',
    kind: 'class',
    interfaces: []
  };
  function $readRangeCOROUTINE$49(_this_, path_0, range, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__35 = _this_;
    this._path_2 = path_0;
    this._range_0 = range;
  }
  $readRangeCOROUTINE$49.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__35, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_5 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_5.access_6wfw3l_k$(this._path_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_2 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_2.readRangeBytes_tt3iev_k$(this._range_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readRangeCOROUTINE$49.$metadata$ = {
    simpleName: '$readRangeCOROUTINE$49',
    kind: 'class',
    interfaces: []
  };
  function $statCOROUTINE$52(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__36 = _this_;
    this._path_3 = path_0;
  }
  $statCOROUTINE$52.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__36, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_6 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_6.access_6wfw3l_k$(this._path_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_3 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_3.stat_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            var tmp_0 = this.__this__36.file_6wfw3l_k$(this._path_3);
            var tmp_1 = new Long(0, 0);
            var tmp_2 = new Long(0, 0);
            var tmp_3 = new Long(0, 0);
            return ARGUMENT.copy$default_mj4u0a_k$(tmp_0, false, false, tmp_1, tmp_2, tmp_3, 0, null, null, null, null, null, null, null, 16382, null);
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $statCOROUTINE$52.$metadata$ = {
    simpleName: '$statCOROUTINE$52',
    kind: 'class',
    interfaces: []
  };
  function $listSimpleCOROUTINE$53(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__37 = _this_;
    this._path_4 = path_0;
  }
  $listSimpleCOROUTINE$53.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__37, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_7 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_7.access_6wfw3l_k$(this._path_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_4 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_4.listSimple_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $listSimpleCOROUTINE$53.$metadata$ = {
    simpleName: '$listSimpleCOROUTINE$53',
    kind: 'class',
    interfaces: []
  };
  var Kind_DELETED_instance;
  var Kind_MODIFIED_instance;
  var Kind_CREATED_instance;
  var Kind_RENAMED_instance;
  var Kind_entriesInitialized_0;
  function Kind_initEntries_0() {
    if (Kind_entriesInitialized_0)
      return Unit_getInstance();
    Kind_entriesInitialized_0 = true;
    Kind_DELETED_instance = new Kind_0('DELETED', 0);
    Kind_MODIFIED_instance = new Kind_0('MODIFIED', 1);
    Kind_CREATED_instance = new Kind_0('CREATED', 2);
    Kind_RENAMED_instance = new Kind_0('RENAMED', 3);
  }
  function FileEvent_init_$Init$(kind, file, other, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      other = null;
    FileEvent.call($this, kind, file, other);
    return $this;
  }
  function FileEvent_init_$Create$(kind, file, other, $mask0, $marker) {
    return FileEvent_init_$Init$(kind, file, other, $mask0, $marker, Object.create(FileEvent.prototype));
  }
  function Kind_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Kind_0.$metadata$ = {
    simpleName: 'Kind',
    kind: 'class',
    interfaces: []
  };
  function Kind_MODIFIED_getInstance() {
    Kind_initEntries_0();
    return Kind_MODIFIED_instance;
  }
  function Proxy() {
    Vfs.call(this);
    this._initialized = false;
  }
  Proxy.prototype.transform_7bxu44_k$ = function (_this__0, $cont) {
    return this.file_6wfw3l_k$(_this__0._path_7);
  };
  Proxy.prototype.getUnderlyingUnscapedFile_6wfw3l_k$ = function (path_0, $cont) {
    var tmp = new $getUnderlyingUnscapedFileCOROUTINE$45(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Proxy.prototype.init_sv8swh_k$ = function ($cont) {
  };
  Proxy.prototype.open_4jc6oe_k$ = function (path_0, mode, $cont) {
    var tmp = new $openCOROUTINE$48(this, path_0, mode, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Proxy.prototype.readRange_743hkm_k$ = function (path_0, range, $cont) {
    var tmp = new $readRangeCOROUTINE$49(this, path_0, range, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Proxy.prototype.stat_6wfw3l_k$ = function (path_0, $cont) {
    var tmp = new $statCOROUTINE$52(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Proxy.prototype.listSimple_6wfw3l_k$ = function (path_0, $cont) {
    var tmp = new $listSimpleCOROUTINE$53(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Proxy.prototype.listFlow_6wfw3l_k$ = function (path_0, $cont) {
    return flow(_no_name_provided_$factory_127(this, path_0, null));
  };
  Proxy.$metadata$ = {
    simpleName: 'Proxy',
    kind: 'class',
    interfaces: []
  };
  function FileEvent(kind, file, other) {
    this._kind = kind;
    this._file = file;
    this._other_0 = other;
  }
  FileEvent.prototype.toString = function () {
    return !(this._other_0 == null) ? '' + this._kind + '(' + this._file + ', ' + this._other_0 + ')' : '' + this._kind + '(' + this._file + ')';
  };
  FileEvent.prototype.hashCode = function () {
    var result = this._kind.hashCode();
    result = imul(result, 31) + this._file.hashCode() | 0;
    result = imul(result, 31) + (this._other_0 == null ? 0 : this._other_0.hashCode()) | 0;
    return result;
  };
  FileEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FileEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FileEvent ? other : THROW_CCE();
    if (!this._kind.equals(tmp0_other_with_cast._kind))
      return false;
    if (!this._file.equals(tmp0_other_with_cast._file))
      return false;
    if (!equals_1(this._other_0, tmp0_other_with_cast._other_0))
      return false;
    return true;
  };
  FileEvent.$metadata$ = {
    simpleName: 'FileEvent',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__158(this$0, $path, resultContinuation) {
    this._this$0_41 = this$0;
    this._$path_0 = $path;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__158.prototype.invoke_8bppsg_k$ = function ($this$flow, $cont) {
    var tmp = this.create_bv35dh_k$($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__158.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_8bppsg_k$((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__158.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this._this$0_41.listSimple_6wfw3l_k$(this._$path_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_8 = suspendResult;
            this._state_1 = 2;
            suspendResult = toChannel(this._ARGUMENT0_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_5 = suspendResult;
            this._state_1 = 3;
            suspendResult = emitAll(this._$this$flow_0, this._ARGUMENT1_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__158.prototype.create_bv35dh_k$ = function ($this$flow, completion) {
    var i = new _no_name_provided__158(this._this$0_41, this._$path_0, completion);
    i._$this$flow_0 = $this$flow;
    return i;
  };
  _no_name_provided__158.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $readRangeCOROUTINE$38(_this_, path_0, range, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__38 = _this_;
    this._path_5 = path_0;
    this._range_1 = range;
  }
  $readRangeCOROUTINE$38.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            this._state_1 = 1;
            suspendResult = this.__this__38.open_4jc6oe_k$(this._path_5, VfsOpenMode_READ_getInstance(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._s0 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            this._s0._position_6 = this._range_1._get_start__0_k$();
            var tmp_0 = this;
            var tmp_1 = this;
            var tmp0_minus_0 = toLong(IntCompanionObject_getInstance()._MAX_VALUE_5);
            tmp_1._tmp1_min_03 = tmp0_minus_0.minus_wiekkq_k$(new Long(1, 0));
            var tmp_2 = this;
            tmp_2._tmp2_min_04 = this._range_1._get_endInclusive__0_k$().minus_wiekkq_k$(this._range_1._get_start__0_k$());
            tmp_0._readCount5 = (this._tmp1_min_03.compareTo_wiekkq_k$(this._tmp2_min_04) <= 0 ? this._tmp1_min_03 : this._tmp2_min_04).toInt_0_k$() + 1 | 0;
            this._state_1 = 4;
            suspendResult = readBytesUpTo(this._s0, this._readCount5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$02 = suspendResult;
            this._exceptionState = 11;
            this._state_1 = 5;
            var tmp_3 = this;
            continue $sm;
          case 5:
            this._tmp6 = this._tmp$ret$02;
            this._state_1 = 6;
            suspendResult = this._s0.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            return this._tmp6;
          case 7:
            this._state_1 = 8;
            suspendResult = this._s0.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            return Unit_getInstance();
          case 9:
            this._exceptionState = 11;
            this._t7 = this._exception_0;
            this._state_1 = 10;
            suspendResult = this._s0.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            throw this._t7;
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readRangeCOROUTINE$38.$metadata$ = {
    simpleName: '$readRangeCOROUTINE$38',
    kind: 'class',
    interfaces: []
  };
  function $listSimpleCOROUTINE$43(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__39 = _this_;
    this._path_6 = path_0;
  }
  $listSimpleCOROUTINE$43.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__39.listFlow_6wfw3l_k$(this._path_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_9 = suspendResult;
            this._state_1 = 2;
            suspendResult = toList$default(this._ARGUMENT0_9, null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $listSimpleCOROUTINE$43.$metadata$ = {
    simpleName: '$listSimpleCOROUTINE$43',
    kind: 'class',
    interfaces: []
  };
  function Vfs() {
  }
  Vfs.prototype._get_absolutePath__0_k$ = function () {
    return '';
  };
  Vfs.prototype.getAbsolutePath_6wfw3l_k$ = function (path_0) {
    return _PathInfo___get_fullPath__impl_(lightCombine(_get_pathInfo_(this._get_absolutePath__0_k$()), _get_pathInfo_(path_0)));
  };
  Vfs.prototype._get_root__0_k$ = function () {
    return new VfsFile(this, '');
  };
  Vfs.prototype.get_6wfw3l_k$ = function (path_0) {
    return this._get_root__0_k$().get_6wfw3l_k$(path_0);
  };
  Vfs.prototype.file_6wfw3l_k$ = function (path_0) {
    return this._get_root__0_k$().get_6wfw3l_k$(path_0);
  };
  Vfs.prototype.close_sv8swh_k$ = function ($cont) {
    return Unit_getInstance();
  };
  Vfs.prototype.createExistsStat_83exln_k$ = function (path_0, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id) {
    return new VfsStat(this.file_6wfw3l_k$(path_0), true, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
  };
  Vfs.prototype.createExistsStat$default_r7ry8g_k$ = function (path_0, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      device = new Long(-1, -1);
    if (!(($mask0 & 16) === 0))
      inode = new Long(-1, -1);
    if (!(($mask0 & 32) === 0))
      mode = 511;
    if (!(($mask0 & 64) === 0))
      owner = 'nobody';
    if (!(($mask0 & 128) === 0))
      group = 'nobody';
    if (!(($mask0 & 256) === 0))
      createTime = Companion_getInstance_82()._EPOCH;
    if (!(($mask0 & 512) === 0))
      modifiedTime = Companion_getInstance_82()._EPOCH;
    if (!(($mask0 & 1024) === 0))
      lastAccessTime = modifiedTime;
    if (!(($mask0 & 2048) === 0))
      extraInfo = null;
    if (!(($mask0 & 4096) === 0))
      id = null;
    return this.createExistsStat_83exln_k$(path_0, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
  };
  Vfs.prototype.createNonExistsStat_kg0j0g_k$ = function (path_0, extraInfo) {
    var tmp = this.file_6wfw3l_k$(path_0);
    var tmp_0 = new Long(0, 0);
    var tmp_1 = new Long(-1, -1);
    var tmp_2 = new Long(-1, -1);
    var tmp_3 = Companion_getInstance_82()._EPOCH;
    var tmp_4 = Companion_getInstance_82()._EPOCH;
    var tmp_5 = Companion_getInstance_82()._EPOCH;
    return VfsStat_init_$Create$(tmp, false, false, tmp_0, tmp_1, tmp_2, 511, 'nobody', 'nobody', tmp_3, tmp_4, tmp_5, extraInfo, null, 8192, null);
  };
  Vfs.prototype.createNonExistsStat$default_r8spfi_k$ = function (path_0, extraInfo, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      extraInfo = null;
    return this.createNonExistsStat_kg0j0g_k$(path_0, extraInfo);
  };
  Vfs.prototype.open_4jc6oe_k$ = function (path_0, mode, $cont) {
    unsupported_0();
  };
  Vfs.prototype.readRange_743hkm_k$ = function (path_0, range, $cont) {
    var tmp = new $readRangeCOROUTINE$38(this, path_0, range, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Vfs.prototype.stat_6wfw3l_k$ = function (path_0, $cont) {
    return this.createNonExistsStat$default_r8spfi_k$(path_0, null, 2, null);
  };
  Vfs.prototype.listSimple_6wfw3l_k$ = function (path_0, $cont) {
    var tmp = new $listSimpleCOROUTINE$43(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Vfs.prototype.listFlow_6wfw3l_k$ = function (path_0, $cont) {
    return flow(_no_name_provided_$factory_126(this, path_0, null));
  };
  Vfs.prototype.getUnderlyingUnscapedFile_6wfw3l_k$ = function (path_0, $cont) {
    return FinalVfsFile_init_$Create$(this, path_0);
  };
  Vfs.prototype.toString = function () {
    return _get_portableSimpleName_(getKClassFromExpression_0(this));
  };
  Vfs.$metadata$ = {
    simpleName: 'Vfs',
    kind: 'class',
    interfaces: [AsyncCloseable]
  };
  function VfsOpenMode_init_$Init$(name, ordinal, cmode, write_2, createIfNotExists, truncate, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      createIfNotExists = false;
    if (!(($mask0 & 32) === 0))
      truncate = false;
    VfsOpenMode.call($this, name, ordinal, cmode, write_2, createIfNotExists, truncate);
    return $this;
  }
  function VfsOpenMode_init_$Create$(name, ordinal, cmode, write_2, createIfNotExists, truncate, $mask0, $marker) {
    return VfsOpenMode_init_$Init$(name, ordinal, cmode, write_2, createIfNotExists, truncate, $mask0, $marker, Object.create(VfsOpenMode.prototype));
  }
  var VfsOpenMode_READ_instance;
  var VfsOpenMode_WRITE_instance;
  var VfsOpenMode_APPEND_instance;
  var VfsOpenMode_CREATE_OR_TRUNCATE_instance;
  var VfsOpenMode_CREATE_instance;
  var VfsOpenMode_CREATE_NEW_instance;
  var VfsOpenMode_entriesInitialized;
  function VfsOpenMode_initEntries() {
    if (VfsOpenMode_entriesInitialized)
      return Unit_getInstance();
    VfsOpenMode_entriesInitialized = true;
    VfsOpenMode_READ_instance = VfsOpenMode_init_$Create$('READ', 0, 'rb', false, false, false, 48, null);
    VfsOpenMode_WRITE_instance = VfsOpenMode_init_$Create$('WRITE', 1, 'r+b', true, true, false, 32, null);
    VfsOpenMode_APPEND_instance = VfsOpenMode_init_$Create$('APPEND', 2, 'a+b', true, true, false, 32, null);
    VfsOpenMode_CREATE_OR_TRUNCATE_instance = new VfsOpenMode('CREATE_OR_TRUNCATE', 3, 'w+b', true, true, true);
    VfsOpenMode_CREATE_instance = VfsOpenMode_init_$Create$('CREATE', 4, 'w+b', true, true, false, 32, null);
    VfsOpenMode_CREATE_NEW_instance = VfsOpenMode_init_$Create$('CREATE_NEW', 5, 'w+b', true, false, false, 48, null);
  }
  function VfsOpenMode(name, ordinal, cmode, write_2, createIfNotExists, truncate) {
    Enum.call(this, name, ordinal);
    this._cmode = cmode;
    this._write = write_2;
    this._createIfNotExists = createIfNotExists;
    this._truncate = truncate;
  }
  VfsOpenMode.$metadata$ = {
    simpleName: 'VfsOpenMode',
    kind: 'class',
    interfaces: []
  };
  function VfsStat_init_$Init$(file, exists, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      device = new Long(-1, -1);
    if (!(($mask0 & 32) === 0))
      inode = new Long(-1, -1);
    if (!(($mask0 & 64) === 0))
      mode = 511;
    if (!(($mask0 & 128) === 0))
      owner = 'nobody';
    if (!(($mask0 & 256) === 0))
      group = 'nobody';
    if (!(($mask0 & 512) === 0))
      createTime = Companion_getInstance_82()._EPOCH;
    if (!(($mask0 & 1024) === 0))
      modifiedTime = createTime;
    if (!(($mask0 & 2048) === 0))
      lastAccessTime = modifiedTime;
    if (!(($mask0 & 4096) === 0))
      extraInfo = null;
    if (!(($mask0 & 8192) === 0))
      id = null;
    VfsStat.call($this, file, exists, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
    return $this;
  }
  function VfsStat_init_$Create$(file, exists, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $marker) {
    return VfsStat_init_$Init$(file, exists, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $marker, Object.create(VfsStat.prototype));
  }
  function VfsStat(file, exists, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id) {
    this._file_0 = file;
    this._exists = exists;
    this._isDirectory_0 = isDirectory;
    this._size_9 = size_2;
    this._device = device;
    this._inode_0 = inode;
    this._mode_0 = mode;
    this._owner_0 = owner;
    this._group = group;
    this._createTime = createTime;
    this._modifiedTime = modifiedTime;
    this._lastAccessTime = lastAccessTime;
    this._extraInfo = extraInfo;
    this._id_3 = id;
  }
  VfsStat.prototype._get_pathInfo__i519nt_k$ = function () {
    return this._file_0._get_pathInfo__i519nt_k$();
  };
  VfsStat.prototype.toString_vcj5fe_k$ = function (showFile) {
    var tmp0_also_0 = ArrayList_init_$Create$_0(16);
    if (showFile) {
      tmp0_also_0.add_2bq_k$('' + 'file=' + this._file_0);
      Unit_getInstance();
    } else {
      tmp0_also_0.add_2bq_k$('' + 'file=' + this._file_0._get_absolutePath__0_k$());
      Unit_getInstance();
    }
    tmp0_also_0.add_2bq_k$('' + 'exists=' + this._exists);
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'isDirectory=' + this._isDirectory_0);
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'size=' + this._size_9);
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'device=' + this._device);
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'inode=' + this._inode_0);
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'mode=' + this._mode_0);
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'owner=' + this._owner_0);
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'group=' + this._group);
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'createTime=' + new DateTime(this._createTime));
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'modifiedTime=' + new DateTime(this._modifiedTime));
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'lastAccessTime=' + new DateTime(this._lastAccessTime));
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'extraInfo=' + this._extraInfo);
    Unit_getInstance();
    tmp0_also_0.add_2bq_k$('' + 'id=' + this._id_3);
    Unit_getInstance();
    return 'VfsStat(' + joinToString$default_0(tmp0_also_0, ', ', null, null, 0, null, null, 62, null) + ')';
  };
  VfsStat.prototype.toString = function () {
    return this.toString_vcj5fe_k$(true);
  };
  VfsStat.prototype.copy_3a0o3m_k$ = function (file, exists, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id) {
    return new VfsStat(file, exists, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
  };
  VfsStat.prototype.copy$default_mj4u0a_k$ = function (file, exists, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      file = this._file_0;
    if (!(($mask0 & 2) === 0))
      exists = this._exists;
    if (!(($mask0 & 4) === 0))
      isDirectory = this._isDirectory_0;
    if (!(($mask0 & 8) === 0))
      size_2 = this._size_9;
    if (!(($mask0 & 16) === 0))
      device = this._device;
    if (!(($mask0 & 32) === 0))
      inode = this._inode_0;
    if (!(($mask0 & 64) === 0))
      mode = this._mode_0;
    if (!(($mask0 & 128) === 0))
      owner = this._owner_0;
    if (!(($mask0 & 256) === 0))
      group = this._group;
    if (!(($mask0 & 512) === 0))
      createTime = this._createTime;
    if (!(($mask0 & 1024) === 0))
      modifiedTime = this._modifiedTime;
    if (!(($mask0 & 2048) === 0))
      lastAccessTime = this._lastAccessTime;
    if (!(($mask0 & 4096) === 0))
      extraInfo = this._extraInfo;
    if (!(($mask0 & 8192) === 0))
      id = this._id_3;
    return this.copy_3a0o3m_k$(file, exists, isDirectory, size_2, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
  };
  VfsStat.prototype.hashCode = function () {
    var result = this._file_0.hashCode();
    result = imul(result, 31) + (this._exists | 0) | 0;
    result = imul(result, 31) + (this._isDirectory_0 | 0) | 0;
    result = imul(result, 31) + this._size_9.hashCode() | 0;
    result = imul(result, 31) + this._device.hashCode() | 0;
    result = imul(result, 31) + this._inode_0.hashCode() | 0;
    result = imul(result, 31) + this._mode_0 | 0;
    result = imul(result, 31) + getStringHashCode(this._owner_0) | 0;
    result = imul(result, 31) + getStringHashCode(this._group) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._createTime) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._modifiedTime) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._lastAccessTime) | 0;
    result = imul(result, 31) + (this._extraInfo == null ? 0 : hashCode(this._extraInfo)) | 0;
    result = imul(result, 31) + (this._id_3 == null ? 0 : getStringHashCode(this._id_3)) | 0;
    return result;
  };
  VfsStat.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsStat))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VfsStat ? other : THROW_CCE();
    if (!this._file_0.equals(tmp0_other_with_cast._file_0))
      return false;
    if (!(this._exists === tmp0_other_with_cast._exists))
      return false;
    if (!(this._isDirectory_0 === tmp0_other_with_cast._isDirectory_0))
      return false;
    if (!this._size_9.equals(tmp0_other_with_cast._size_9))
      return false;
    if (!this._device.equals(tmp0_other_with_cast._device))
      return false;
    if (!this._inode_0.equals(tmp0_other_with_cast._inode_0))
      return false;
    if (!(this._mode_0 === tmp0_other_with_cast._mode_0))
      return false;
    if (!(this._owner_0 === tmp0_other_with_cast._owner_0))
      return false;
    if (!(this._group === tmp0_other_with_cast._group))
      return false;
    if (!equals_1(new DateTime(this._createTime), new DateTime(tmp0_other_with_cast._createTime)))
      return false;
    if (!equals_1(new DateTime(this._modifiedTime), new DateTime(tmp0_other_with_cast._modifiedTime)))
      return false;
    if (!equals_1(new DateTime(this._lastAccessTime), new DateTime(tmp0_other_with_cast._lastAccessTime)))
      return false;
    if (!equals_1(this._extraInfo, tmp0_other_with_cast._extraInfo))
      return false;
    if (!(this._id_3 == tmp0_other_with_cast._id_3))
      return false;
    return true;
  };
  VfsStat.$metadata$ = {
    simpleName: 'VfsStat',
    kind: 'class',
    interfaces: [Path_0]
  };
  function VfsV2() {
    Vfs.call(this);
  }
  VfsV2.prototype.listFlow_6wfw3l_k$ = function (path_0, $cont) {
    return emptyFlow();
  };
  VfsV2.$metadata$ = {
    simpleName: 'VfsV2',
    kind: 'class',
    interfaces: []
  };
  function VfsOpenMode_READ_getInstance() {
    VfsOpenMode_initEntries();
    return VfsOpenMode_READ_instance;
  }
  function _no_name_provided_$factory_126(this$0, $path, resultContinuation) {
    var i = new _no_name_provided__158(this$0, $path, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_8bppsg_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_127(this$0, $path, resultContinuation) {
    var i = new _no_name_provided__157(this$0, $path, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_8bppsg_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided__1_9_0($this_flow) {
    this._$this_flow_0 = $this_flow;
  }
  _no_name_provided__1_9_0.prototype.emit_2_10_ba5hwt_k$ = function (value, $cont) {
    return this._$this_flow_0.emit_iav7o_k$(value, $cont);
  };
  _no_name_provided__1_9_0.prototype.emit_iav7o_k$ = function (value, $cont) {
    return this.emit_2_10_ba5hwt_k$(value instanceof VfsFile ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_9_0.$metadata$ = {
    simpleName: '<no name provided>_1_9',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function $emit_2COROUTINE$81(_this_, value, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__40 = _this_;
    this._value_16 = value;
  }
  $emit_2COROUTINE$81.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            if (this.__this__40._$filter(this._value_16)) {
              this._state_1 = 1;
              suspendResult = this.__this__40._$this_flow_1.emit_iav7o_k$(this._value_16, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 1:
            this._state_1 = 2;
            suspendResult = this._value_16.stat_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._stat_70 = suspendResult;
            if (this._stat_70._isDirectory_0) {
              this._state_1 = 3;
              suspendResult = this._value_16.listRecursive_u4ifb1_k$(this.__this__40._$filter, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 3:
            this._tmp0_collect_0_81 = suspendResult;
            this._state_1 = 4;
            suspendResult = this._tmp0_collect_0_81.collect_l0hod5_k$(new _no_name_provided__1_9_0(this.__this__40._$this_flow_1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._state_1 = 6;
            continue $sm;
          case 6:
            return Unit_getInstance();
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $emit_2COROUTINE$81.$metadata$ = {
    simpleName: '$emit_2COROUTINE$81',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_10($filter, $this_flow) {
    this._$filter = $filter;
    this._$this_flow_1 = $this_flow;
  }
  _no_name_provided__1_10.prototype.emit_2_ba5hwt_k$ = function (value, $cont) {
    var tmp = new $emit_2COROUTINE$81(this, value, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__1_10.prototype.emit_iav7o_k$ = function (value, $cont) {
    return this.emit_2_ba5hwt_k$(value instanceof VfsFile ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_10.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function _no_name_provided__159() {
  }
  _no_name_provided__159.prototype.invoke_edgwu6_k$ = function (it) {
    return true;
  };
  _no_name_provided__159.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_edgwu6_k$(p1 instanceof VfsFile ? p1 : THROW_CCE());
  };
  _no_name_provided__159.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__160(this$0, $filter, resultContinuation) {
    this._this$0_42 = this$0;
    this._$filter_0 = $filter;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__160.prototype.invoke_8bppsg_k$ = function ($this$flow, $cont) {
    var tmp = this.create_bv35dh_k$($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__160.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_8bppsg_k$((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__160.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._this$0_42.list_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_collect_00 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._tmp0_collect_00.collect_l0hod5_k$(new _no_name_provided__1_10(this._$filter_0, this._$this$flow_1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__160.prototype.create_bv35dh_k$ = function ($this$flow, completion) {
    var i = new _no_name_provided__160(this._this$0_42, this._$filter_0, completion);
    i._$this$flow_1 = $this$flow;
    return i;
  };
  _no_name_provided__160.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $readStringCOROUTINE$67(_this_, charset, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__41 = _this_;
    this._charset = charset;
  }
  $readStringCOROUTINE$67.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__41.read_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return toString$default(ARGUMENT, this._charset, 0, 0, 6, null);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readStringCOROUTINE$67.$metadata$ = {
    simpleName: '$readStringCOROUTINE$67',
    kind: 'class',
    interfaces: []
  };
  function VfsFile(vfs, path_0) {
    VfsNamed.call(this, _get_pathInfo_(path_0));
    this._vfs = vfs;
    this._path_7 = path_0;
    var tmp = this;
    tmp._$$delegate_0_10 = Mixin_init_$Create$(null, 1, null);
  }
  VfsFile.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_10._set_extra__n1onou_k$(_set___);
  };
  VfsFile.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_10._get_extra__0_k$();
  };
  VfsFile.prototype._get_parent__0_k$ = function () {
    return new VfsFile(this._vfs, _get_folder_(this));
  };
  VfsFile.prototype._get_absolutePath__0_k$ = function () {
    return this._vfs.getAbsolutePath_6wfw3l_k$(this._path_7);
  };
  VfsFile.prototype.get_6wfw3l_k$ = function (path_0) {
    return new VfsFile(this._vfs, _PathInfo___get_fullPath__impl_(combine(_get_pathInfo_(this._path_7), _get_pathInfo_(path_0))));
  };
  VfsFile.prototype.withExtension_6wfw3l_k$ = function (ext) {
    var tmp = _get_fullNameWithoutExtension_(this);
    var tmp_0;
    if (charSequenceLength(ext) > 0) {
      tmp_0 = '' + '.' + ext;
    } else {
      {
        tmp_0 = '';
      }
    }
    return new VfsFile(this._vfs, tmp + tmp_0);
  };
  VfsFile.prototype.open_izlxhr_k$ = function (mode, $cont) {
    return this._vfs.open_4jc6oe_k$(this._path_7, mode, $cont);
  };
  VfsFile.prototype.open$default_da58he_k$ = function (mode, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      mode = VfsOpenMode_READ_getInstance();
    return this.open_izlxhr_k$(mode, $cont);
  };
  VfsFile.prototype.readRangeBytes_tt3iev_k$ = function (range, $cont) {
    return this._vfs.readRange_743hkm_k$(this._path_7, range, $cont);
  };
  VfsFile.prototype.readRangeBytes_em8bnc_k$ = function (range, $cont) {
    return this._vfs.readRange_743hkm_k$(this._path_7, toLongRange(range), $cont);
  };
  VfsFile.prototype.readAll_0_k$ = function ($cont) {
    return this._vfs.readRange_743hkm_k$(this._path_7, LONG_ZERO_TO_MAX_RANGE, $cont);
  };
  VfsFile.prototype.read_0_k$ = function ($cont) {
    return this.readAll_0_k$($cont);
  };
  VfsFile.prototype.readBytes_0_k$ = function ($cont) {
    return this.readAll_0_k$($cont);
  };
  VfsFile.prototype.readString_8i7s9v_k$ = function (charset, $cont) {
    var tmp = new $readStringCOROUTINE$67(this, charset, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  VfsFile.prototype.readString$default_8s0uio_k$ = function (charset, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      charset = UTF8;
    return this.readString_8i7s9v_k$(charset, $cont);
  };
  VfsFile.prototype.stat_0_k$ = function ($cont) {
    return this._vfs.stat_6wfw3l_k$(this._path_7, $cont);
  };
  VfsFile.prototype.listSimple_0_k$ = function ($cont) {
    return this._vfs.listSimple_6wfw3l_k$(this._path_7, $cont);
  };
  VfsFile.prototype.list_0_k$ = function ($cont) {
    return this._vfs.listFlow_6wfw3l_k$(this._path_7, $cont);
  };
  VfsFile.prototype.listRecursive_u4ifb1_k$ = function (filter, $cont) {
    return flow(_no_name_provided_$factory_129(this, filter, null));
  };
  VfsFile.prototype.listRecursive$default_wd3a4q_k$ = function (filter, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0)) {
      filter = _no_name_provided_$factory_128();
    }return this.listRecursive_u4ifb1_k$(filter, $cont);
  };
  VfsFile.prototype.jail_0_k$ = function () {
    return JailVfs(this);
  };
  VfsFile.prototype.getUnderlyingUnscapedFile_0_k$ = function ($cont) {
    return this._vfs.getUnderlyingUnscapedFile_6wfw3l_k$(this._path_7, $cont);
  };
  VfsFile.prototype.toString = function () {
    return '' + this._vfs + '[' + this._path_7 + ']';
  };
  VfsFile.prototype.hashCode = function () {
    var result = hashCode(this._vfs);
    result = imul(result, 31) + getStringHashCode(this._path_7) | 0;
    return result;
  };
  VfsFile.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsFile))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VfsFile ? other : THROW_CCE();
    if (!equals_1(this._vfs, tmp0_other_with_cast._vfs))
      return false;
    if (!(this._path_7 === tmp0_other_with_cast._path_7))
      return false;
    return true;
  };
  VfsFile.$metadata$ = {
    simpleName: 'VfsFile',
    kind: 'class',
    interfaces: [AsyncInputOpenable, Extra]
  };
  function FinalVfsFile_init_$Init$(vfs, path_0, $this) {
    FinalVfsFile.call($this, vfs.get_6wfw3l_k$(path_0));
    return $this;
  }
  function FinalVfsFile_init_$Create$(vfs, path_0) {
    return FinalVfsFile_init_$Init$(vfs, path_0, Object.create(FinalVfsFile.prototype));
  }
  function FinalVfsFile(file) {
    this._file_1 = file;
  }
  FinalVfsFile.prototype._get_vfs__0_k$ = function () {
    return this._file_1._vfs;
  };
  FinalVfsFile.prototype._get_path__0_k$ = function () {
    return this._file_1._path_7;
  };
  FinalVfsFile.prototype.toString = function () {
    return '' + 'FinalVfsFile(file=' + this._file_1 + ')';
  };
  FinalVfsFile.prototype.hashCode = function () {
    return this._file_1.hashCode();
  };
  FinalVfsFile.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FinalVfsFile))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FinalVfsFile ? other : THROW_CCE();
    if (!this._file_1.equals(tmp0_other_with_cast._file_1))
      return false;
    return true;
  };
  FinalVfsFile.$metadata$ = {
    simpleName: 'FinalVfsFile',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_128() {
    var i = new _no_name_provided__159();
    return function (p1) {
      return i.invoke_edgwu6_k$(p1);
    };
  }
  function _no_name_provided_$factory_129(this$0, $filter, resultContinuation) {
    var i = new _no_name_provided__160(this$0, $filter, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_8bppsg_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function JailVfs(jailRoot) {
    return (new _no_name_provided__161(jailRoot))._get_root__0_k$();
  }
  function _no_name_provided__161($jailRoot) {
    this._$jailRoot = $jailRoot;
    Proxy.call(this);
    this._baseJail = normalize(this._$jailRoot._get_pathInfo__i519nt_k$());
  }
  _no_name_provided__161.prototype.access_6wfw3l_k$ = function (path_0, $cont) {
    return this._$jailRoot.get_6wfw3l_k$(trim(normalize(_get_pathInfo_(path_0)), charArrayOf([new Char(47)])));
  };
  _no_name_provided__161.prototype.transform_7bxu44_k$ = function (_this__0, $cont) {
    var outPath = normalize(_get_pathInfo_(_this__0._path_7));
    if (!startsWith$default_1(outPath, this._baseJail, false, 2, null))
      throw UnsupportedOperationException_init_$Create$_0('' + 'Jail not base root : ' + _this__0._path_7 + ' | ' + this._baseJail);
    else {
    }
    var tmp0_substring_0 = this._baseJail.length;
    return this.file_6wfw3l_k$(outPath.substring(tmp0_substring_0));
  };
  _no_name_provided__161.prototype._get_absolutePath__0_k$ = function () {
    return this._$jailRoot._get_absolutePath__0_k$();
  };
  _no_name_provided__161.prototype.toString = function () {
    return '' + 'JailVfs(' + this._$jailRoot + ')';
  };
  _no_name_provided__161.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var resourcesVfsDebug;
  function LocalVfs() {
  }
  LocalVfs.$metadata$ = {
    simpleName: 'LocalVfs',
    kind: 'class',
    interfaces: []
  };
  function _get_localCurrentDirVfs_() {
    return _get_applicationVfs_();
  }
  function updateInfo($this, newInfo, $cont) {
    var tmp = new $updateInfoCOROUTINE$89($this, newInfo, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function $updateInfoCOROUTINE$89(_this_, newInfo, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__42 = _this_;
    this._newInfo = newInfo;
  }
  $updateInfoCOROUTINE$89.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (!this.__this__42._$info._v.equals(this._newInfo)) {
              this.__this__42._$info._v = this._newInfo;
              this._state_1 = 1;
              suspendResult = this.__this__42._this$0_44._files_0.setEntryInfo_v3wzy5_k$(this.__this__42._$info._v, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $updateInfoCOROUTINE$89.$metadata$ = {
    simpleName: '$updateInfoCOROUTINE$89',
    kind: 'class',
    interfaces: []
  };
  function $writeCOROUTINE$90(_this_, position_0, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__43 = _this_;
    this._position_2 = position_0;
    this._buffer_12 = buffer;
    this._offset_9 = offset_0;
    this._len_6 = len;
  }
  $writeCOROUTINE$90.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__43._this$0_44._files_0.writeData_xwvjwp_k$(this.__this__43._$npath, this._position_2, this._buffer_12, this._offset_9, this._len_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._state_1 = 2;
            var tmp_0 = this.__this__43._$info._v;
            var tmp_1 = this;
            tmp_1._tmp0_max_00 = this.__this__43._$info._v._size_10;
            var tmp_2 = this;
            tmp_2._tmp1_max_01 = this._position_2.plus_wiekkq_k$(toLong(this._len_6));
            var tmp_3 = this._tmp0_max_00.compareTo_wiekkq_k$(this._tmp1_max_01) >= 0 ? this._tmp0_max_00 : this._tmp1_max_01;
            suspendResult = updateInfo(this.__this__43, tmp_0.copy$default_vao3k4_k$(null, false, tmp_3, null, null, null, 59, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$90.$metadata$ = {
    simpleName: '$writeCOROUTINE$90',
    kind: 'class',
    interfaces: []
  };
  function now($this) {
    return $this._timeProvider.now_utobi1_k$();
  }
  function initOnce_0($this, $cont) {
    var tmp = new $initOnceCOROUTINE$83($this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function ensureParentDirectory($this, nparent, npath, $cont) {
    var tmp = new $ensureParentDirectoryCOROUTINE$85($this, nparent, npath, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__162(this$0) {
    this._this$0_43 = this$0;
  }
  _no_name_provided__162.prototype.invoke_0_k$ = function () {
    return this._this$0_43._timeProvider;
  };
  _no_name_provided__162.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__163($info, this$0, $npath) {
    this._$info = $info;
    this._this$0_44 = this$0;
    this._$npath = $npath;
    AsyncStreamBase.call(this);
  }
  _no_name_provided__163.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    return this._this$0_44._files_0.readData_li5eee_k$(this._$npath, position_0, buffer, offset_0, len, $cont);
  };
  _no_name_provided__163.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len, $cont) {
    var tmp = new $writeCOROUTINE$90(this, position_0, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__163.prototype.getLength_0_k$ = function ($cont) {
    return this._$info._v._size_10;
  };
  _no_name_provided__163.prototype.close_sv8swh_k$ = function ($cont) {
  };
  _no_name_provided__163.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $initOnceCOROUTINE$83(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__44 = _this_;
  }
  $initOnceCOROUTINE$83.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            if (!this.__this__44._initialized_0) {
              this.__this__44._initialized_0 = true;
              this._state_1 = 1;
              suspendResult = this.__this__44._files_0.hasEntryInfo_6wfw3l_k$('/', this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT0_10 = suspendResult;
            if (!this._ARGUMENT0_10) {
              this._now1 = now(this.__this__44);
              this._state_1 = 2;
              var tmp_0 = new Long(0, 0);
              suspendResult = this.__this__44._files_0.setEntryInfo_v3wzy5_k$(EntryInfo_init_$Create$('/', false, tmp_0, null, this._now1, this._now1, 8, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._state_1 = 4;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $initOnceCOROUTINE$83.$metadata$ = {
    simpleName: '$initOnceCOROUTINE$83',
    kind: 'class',
    interfaces: []
  };
  function $statCOROUTINE$84(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__45 = _this_;
    this._path_8 = path_0;
  }
  $statCOROUTINE$84.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = initOnce_0(this.__this__45, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._npath0 = this.__this__45.normalizePath_uk8unn_k$(this._path_8);
            this._state_1 = 2;
            suspendResult = this.__this__45._files_0.getEntryInfo_6wfw3l_k$(this._npath0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return this.__this__45.createNonExistsStat$default_r8spfi_k$(this._path_8, null, 2, null);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var entry = tmp_0;
            var tmp_1 = entry._get_isDirectory__0_k$();
            var tmp_2 = new Long(0, 0);
            var tmp_3 = new Long(0, 0);
            return this.__this__45.createExistsStat$default_r7ry8g_k$(this._path_8, tmp_1, entry._size_10, tmp_2, tmp_3, 0, null, null, entry._createdTime, entry._modifiedTime_0, null, null, null, 7416, null);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $statCOROUTINE$84.$metadata$ = {
    simpleName: '$statCOROUTINE$84',
    kind: 'class',
    interfaces: []
  };
  function $ensureParentDirectoryCOROUTINE$85(_this_, nparent, npath, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__46 = _this_;
    this._nparent = nparent;
    this._npath = npath;
  }
  $ensureParentDirectoryCOROUTINE$85.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this.__this__46._files_0.hasEntryInfo_6wfw3l_k$(this._nparent, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_11 = suspendResult;
            if (!this._ARGUMENT0_11) {
              throw new IOException('' + "Parent directory '" + this._nparent + "' for file '" + this._npath + "' doesn't exists");
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._state_1 = 3;
            suspendResult = this.__this__46._files_0.getEntryInfo_6wfw3l_k$(this._nparent, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            var parent = ensureNotNull(ARGUMENT);
            if (parent._isFile)
              throw new IOException('' + "'" + this._nparent + "' is a file");
            return parent;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $ensureParentDirectoryCOROUTINE$85.$metadata$ = {
    simpleName: '$ensureParentDirectoryCOROUTINE$85',
    kind: 'class',
    interfaces: []
  };
  function $listFlowCOROUTINE$87(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__47 = _this_;
    this._path_9 = path_0;
  }
  $listFlowCOROUTINE$87.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = initOnce_0(this.__this__47, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._npath0_0 = this.__this__47.normalizePath_uk8unn_k$(this._path_9);
            this._state_1 = 2;
            suspendResult = this.__this__47._files_0.getEntryInfo_6wfw3l_k$(this._npath0_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              throw new IOException('' + "Can't find '" + this._path_9 + "'");
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var entry = tmp_0;
            var tmp0_map_0 = entry._children_0;
            var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
            var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
            while (tmp0_iterator_1_2.hasNext_0_k$()) {
              var item_2_3 = tmp0_iterator_1_2.next_0_k$();
              tmp0_mapTo_0_1.add_2bq_k$(new VfsFile(this.__this__47, item_2_3));
              Unit_getInstance();
            }

            return asFlow(tmp0_mapTo_0_1);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $listFlowCOROUTINE$87.$metadata$ = {
    simpleName: '$listFlowCOROUTINE$87',
    kind: 'class',
    interfaces: []
  };
  function $openCOROUTINE$88(_this_, path_0, mode, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__48 = _this_;
    this._path_10 = path_0;
    this._mode_1 = mode;
  }
  $openCOROUTINE$88.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._state_1 = 1;
            suspendResult = initOnce_0(this.__this__48, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._npath0_1 = this.__this__48.normalizePath_uk8unn_k$(this._path_10);
            this._nparent1 = this.__this__48.normalizePath_uk8unn_k$(_get_folder__0(_PathInfo___init__impl_(this._npath0_1)));
            this._state_1 = 2;
            suspendResult = ensureParentDirectory(this.__this__48, this._nparent1, this._npath0_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._parent2 = suspendResult;
            this._state_1 = 3;
            suspendResult = this.__this__48._files_0.hasEntryInfo_6wfw3l_k$(this._npath0_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._ARGUMENT3_0 = suspendResult;
            if (!this._ARGUMENT3_0) {
              if (!this._mode_1._createIfNotExists)
                throw new IOException('' + "File '" + this._npath0_1 + "' doesn't exists");
              this._state_1 = 4;
              var tmp_0 = new Long(0, 0);
              var tmp_1 = plus_0(this._parent2._children_0, this._npath0_1);
              suspendResult = this.__this__48._files_0.setEntryInfo_v3wzy5_k$(this._parent2.copy$default_vao3k4_k$(null, false, tmp_0, tmp_1, null, null, 55, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._now4 = now(this.__this__48);
            this._state_1 = 6;
            suspendResult = this.__this__48._files_0.getEntryInfo_6wfw3l_k$(this._npath0_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              var tmp0_children = emptyList();
              tmp_2 = new EntryInfo(this._npath0_1, true, new Long(0, 0), tmp0_children, this._now4, this._now4);
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }

            var ARGUMENT = tmp_2;
            var info = {_v: ARGUMENT};
            if (info._v._get_isDirectory__0_k$())
              throw new IOException("Can't open a directory");
            var tmp_3 = new _no_name_provided__163(info, this.__this__48, this._npath0_1);
            return toAsyncStream$default(tmp_3, new Long(0, 0), 1, null);
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openCOROUTINE$88.$metadata$ = {
    simpleName: '$openCOROUTINE$88',
    kind: 'class',
    interfaces: []
  };
  function MapLikeStorageVfs(storage) {
    VfsV2.call(this);
    this._storage_3 = storage;
    this._timeProvider = Companion_getInstance_91();
    var tmp = this;
    tmp._files_0 = new StorageFiles(this._storage_3, _no_name_provided_$factory_130(this));
    this._initialized_0 = false;
    this._writeLock = new AsyncThread2();
  }
  MapLikeStorageVfs.prototype.normalizePath_uk8unn_k$ = function (_this__0) {
    var tmp = trim(_this__0, charArrayOf([new Char(47)]));
    var tmp_0 = new Char(92);
    var tmp_1 = new Char(47);
    return '/' + replace$default(tmp, tmp_0, tmp_1, false, 4, null);
  };
  MapLikeStorageVfs.prototype.stat_6wfw3l_k$ = function (path_0, $cont) {
    var tmp = new $statCOROUTINE$84(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  MapLikeStorageVfs.prototype.listFlow_6wfw3l_k$ = function (path_0, $cont) {
    var tmp = new $listFlowCOROUTINE$87(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  MapLikeStorageVfs.prototype.open_4jc6oe_k$ = function (path_0, mode, $cont) {
    var tmp = new $openCOROUTINE$88(this, path_0, mode, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  MapLikeStorageVfs.prototype.toString = function () {
    return 'MapLikeStorageVfs';
  };
  MapLikeStorageVfs.$metadata$ = {
    simpleName: 'MapLikeStorageVfs',
    kind: 'class',
    interfaces: []
  };
  function EntryInfo_init_$Init$(fullPath, isFile, size_2, children_0, createdTime, modifiedTime, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      size_2 = new Long(0, 0);
    if (!(($mask0 & 8) === 0)) {
      children_0 = emptyList();
    }if (!(($mask0 & 16) === 0))
      createdTime = Companion_getInstance_82()._EPOCH;
    if (!(($mask0 & 32) === 0))
      modifiedTime = Companion_getInstance_82()._EPOCH;
    EntryInfo.call($this, fullPath, isFile, size_2, children_0, createdTime, modifiedTime);
    return $this;
  }
  function EntryInfo_init_$Create$(fullPath, isFile, size_2, children_0, createdTime, modifiedTime, $mask0, $marker) {
    return EntryInfo_init_$Init$(fullPath, isFile, size_2, children_0, createdTime, modifiedTime, $mask0, $marker, Object.create(EntryInfo.prototype));
  }
  function _no_name_provided__164(this$0) {
    this._this$0_45 = this$0;
  }
  _no_name_provided__164.prototype.invoke_0_k$ = function () {
    var tmp = new Char(47);
    return substringBeforeLast$default(this._this$0_45._fullPath, tmp, null, 2, null);
  };
  _no_name_provided__164.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_110() {
    Companion_instance_109 = this;
    this._CHUNK_SIZE = 16384;
  }
  Companion_110.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_109;
  function Companion_getInstance_109() {
    if (Companion_instance_109 == null)
      new Companion_110();
    return Companion_instance_109;
  }
  function EntryInfo(fullPath, isFile, size_2, children_0, createdTime, modifiedTime) {
    this._fullPath = fullPath;
    this._isFile = isFile;
    this._size_10 = size_2;
    this._children_0 = children_0;
    this._createdTime = createdTime;
    this._modifiedTime_0 = modifiedTime;
    var tmp = this;
    tmp._parentFullPath$delegate = lazy(_no_name_provided_$factory_131(this));
  }
  EntryInfo.prototype._get_isDirectory__0_k$ = function () {
    return !this._isFile;
  };
  EntryInfo.prototype.copy_8omsue_k$ = function (fullPath, isFile, size_2, children_0, createdTime, modifiedTime) {
    return new EntryInfo(fullPath, isFile, size_2, children_0, createdTime, modifiedTime);
  };
  EntryInfo.prototype.copy$default_vao3k4_k$ = function (fullPath, isFile, size_2, children_0, createdTime, modifiedTime, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      fullPath = this._fullPath;
    if (!(($mask0 & 2) === 0))
      isFile = this._isFile;
    if (!(($mask0 & 4) === 0))
      size_2 = this._size_10;
    if (!(($mask0 & 8) === 0))
      children_0 = this._children_0;
    if (!(($mask0 & 16) === 0))
      createdTime = this._createdTime;
    if (!(($mask0 & 32) === 0))
      modifiedTime = this._modifiedTime_0;
    return this.copy_8omsue_k$(fullPath, isFile, size_2, children_0, createdTime, modifiedTime);
  };
  EntryInfo.prototype.toString = function () {
    return '' + 'EntryInfo(fullPath=' + this._fullPath + ', isFile=' + this._isFile + ', size=' + this._size_10 + ', children=' + this._children_0 + ', createdTime=' + new DateTime(this._createdTime) + ', modifiedTime=' + new DateTime(this._modifiedTime_0) + ')';
  };
  EntryInfo.prototype.hashCode = function () {
    var result = getStringHashCode(this._fullPath);
    result = imul(result, 31) + (this._isFile | 0) | 0;
    result = imul(result, 31) + this._size_10.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._children_0) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._createdTime) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._modifiedTime_0) | 0;
    return result;
  };
  EntryInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntryInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof EntryInfo ? other : THROW_CCE();
    if (!(this._fullPath === tmp0_other_with_cast._fullPath))
      return false;
    if (!(this._isFile === tmp0_other_with_cast._isFile))
      return false;
    if (!this._size_10.equals(tmp0_other_with_cast._size_10))
      return false;
    if (!equals_1(this._children_0, tmp0_other_with_cast._children_0))
      return false;
    if (!equals_1(new DateTime(this._createdTime), new DateTime(tmp0_other_with_cast._createdTime)))
      return false;
    if (!equals_1(new DateTime(this._modifiedTime_0), new DateTime(tmp0_other_with_cast._modifiedTime_0)))
      return false;
    return true;
  };
  EntryInfo.$metadata$ = {
    simpleName: 'EntryInfo',
    kind: 'class',
    interfaces: []
  };
  function $setEntryInfoCOROUTINE$91(_this_, info, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__49 = _this_;
    this._info = info;
  }
  $setEntryInfoCOROUTINE$91.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__49.getEntryInfo_6wfw3l_k$(this._info._fullPath, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._oldEntry0 = suspendResult;
            if (!(this._oldEntry0 == null)) {
            }
            this._key1 = this.__this__49.getStatsKey_6wfw3l_k$(this._info._fullPath);
            var tmp_0 = this;
            var tmp_1 = Json_getInstance();
            var tmp_2 = linkedMapOf([to(isFile$factory().callableName, this._info._isFile), to(size$factory().callableName, this._info._size_10.toDouble_0_k$()), to(children$factory().callableName, this._info._children_0), to(createdTime$factory().callableName, _DateTime___get_unixMillisDouble__impl_(this._info._createdTime)), to(modifiedTime$factory().callableName, _DateTime___get_unixMillisDouble__impl_(this._info._modifiedTime_0))]);
            tmp_0._content2 = tmp_1.stringify$default_7j38zt_k$(tmp_2, false, 2, null);
            this._state_1 = 2;
            suspendResult = this.__this__49._storage_4.set_wbz76b_k$(this._key1, this._content2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $setEntryInfoCOROUTINE$91.$metadata$ = {
    simpleName: '$setEntryInfoCOROUTINE$91',
    kind: 'class',
    interfaces: []
  };
  function $hasEntryInfoCOROUTINE$92(_this_, fileName, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__50 = _this_;
    this._fileName = fileName;
  }
  $hasEntryInfoCOROUTINE$92.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__50.getEntryInfo_6wfw3l_k$(this._fileName, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT == null;
            return !ARGUMENT_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $hasEntryInfoCOROUTINE$92.$metadata$ = {
    simpleName: '$hasEntryInfoCOROUTINE$92',
    kind: 'class',
    interfaces: []
  };
  function $getEntryInfoCOROUTINE$93(_this_, fileName, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__51 = _this_;
    this._fileName_0 = fileName;
  }
  $getEntryInfoCOROUTINE$93.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__51._storage_4.get_6wfw3l_k$(this.__this__51.getStatsKey_6wfw3l_k$(this._fileName_0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var info = tmp_0;
            var tmp_1 = Json_getInstance();
            var tmp_2 = tmp_1.parse$default_7dtpy2_k$(info, null, 2, null);
            var di = (!(tmp_2 == null) ? isInterface(tmp_2, Map_0) : false) ? tmp_2 : THROW_CCE();
            var tmp_3 = ensureNotNull(di.get_2bw_k$(isFile$factory_0().callableName));
            var tmp_4 = typeof tmp_3 === 'boolean' ? tmp_3 : THROW_CCE();
            var tmp_5 = ensureNotNull(di.get_2bw_k$(size$factory_0().callableName));
            var tmp_6 = numberToLong(isNumber(tmp_5) ? tmp_5 : THROW_CCE());
            var tmp_7 = di.get_2bw_k$(children$factory_0().callableName);
            var tmp_8 = toList_3((!(tmp_7 == null) ? isInterface(tmp_7, Iterable) : false) ? tmp_7 : THROW_CCE());
            var tmp_9 = Companion_getInstance_82();
            var tmp_10 = di.get_2bw_k$(createdTime$factory_0().callableName);
            var tmp_11 = tmp_9.fromUnix_y6lwjq_k$(numberToDouble(isNumber(tmp_10) ? tmp_10 : THROW_CCE()));
            var tmp_12 = Companion_getInstance_82();
            var tmp_13 = di.get_2bw_k$(modifiedTime$factory_0().callableName);
            return new EntryInfo(this._fileName_0, tmp_4, tmp_6, tmp_8, tmp_11, tmp_12.fromUnix_y6lwjq_k$(numberToDouble(isNumber(tmp_13) ? tmp_13 : THROW_CCE())));
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getEntryInfoCOROUTINE$93.$metadata$ = {
    simpleName: '$getEntryInfoCOROUTINE$93',
    kind: 'class',
    interfaces: []
  };
  function $setFileChunkCOROUTINE$96(_this_, fileName, chunk, data, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__52 = _this_;
    this._fileName_1 = fileName;
    this._chunk = chunk;
    this._data_18 = data;
  }
  $setFileChunkCOROUTINE$96.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__52._storage_4.set_wbz76b_k$(this.__this__52.getChunkKey_8i7b4u_k$(this._fileName_1, this._chunk), _get_hex__0(this._data_18), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $setFileChunkCOROUTINE$96.$metadata$ = {
    simpleName: '$setFileChunkCOROUTINE$96',
    kind: 'class',
    interfaces: []
  };
  function $getFileChunkCOROUTINE$97(_this_, fileName, chunk, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__53 = _this_;
    this._fileName_2 = fileName;
    this._chunk_0 = chunk;
  }
  $getFileChunkCOROUTINE$97.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__53._storage_4.get_6wfw3l_k$(this.__this__53.getChunkKey_8i7b4u_k$(this._fileName_2, this._chunk_0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            return tmp0_safe_receiver == null ? null : _get_unhex_(tmp0_safe_receiver);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getFileChunkCOROUTINE$97.$metadata$ = {
    simpleName: '$getFileChunkCOROUTINE$97',
    kind: 'class',
    interfaces: []
  };
  function $writeDataCOROUTINE$98(_this_, fileName, position_0, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__54 = _this_;
    this._fileName_3 = fileName;
    this._position_3 = position_0;
    this._buffer_13 = buffer;
    this._offset_10 = offset_0;
    this._len_7 = len;
  }
  $writeDataCOROUTINE$98.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._pending0 = this._len_7;
            this._apos1 = this._position_3;
            this._aoffset2 = this._offset_10;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this._pending0 > 0)) {
              this._state_1 = 4;
              continue $sm;
            }
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_div_03 = this._apos1;
            var tmp_2 = this;
            tmp_2._tmp1_div_04 = Companion_getInstance_109()._CHUNK_SIZE;
            tmp_0._chunk5 = this._tmp0_div_03.div_wiekkq_k$(toLong(this._tmp1_div_04)).toInt_0_k$();
            var tmp_3 = this;
            var tmp_4 = this;
            tmp_4._tmp2_rem_06 = this._apos1;
            var tmp_5 = this;
            tmp_5._tmp3_rem_07 = Companion_getInstance_109()._CHUNK_SIZE;
            tmp_3._inChunk8 = this._tmp2_rem_06.rem_wiekkq_k$(toLong(this._tmp3_rem_07)).toInt_0_k$();
            this._state_1 = 2;
            suspendResult = this.__this__54.getFileChunk_8i7b4u_k$(this._fileName_3, this._chunk5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._tmp0_elvis_lhs9 = suspendResult;
            var tmp_6 = this;
            var tmp_7;
            if (this._tmp0_elvis_lhs9 == null) {
              tmp_7 = new Int8Array([]);
            } else {
              tmp_7 = this._tmp0_elvis_lhs9;
            }

            tmp_6._c10 = tmp_7;
            this._available11 = Companion_getInstance_109()._CHUNK_SIZE - this._inChunk8 | 0;
            var tmp_8 = this;
            var tmp_9 = this;
            tmp_9._tmp4_min_012 = this._pending0;
            tmp_8._written13 = Math.min(this._available11, this._tmp4_min_012);
            if (this._written13 <= 0) {
              invalidOp('Unexpected written');
            }
            this._cc14 = copyOf(this._c10, this._inChunk8 + this._written13 | 0);
            arraycopy_2(this._buffer_13, this._aoffset2, this._cc14, this._inChunk8, this._written13);
            this._state_1 = 3;
            suspendResult = this.__this__54.setFileChunk_ba91rk_k$(this._fileName_3, this._chunk5, this._cc14, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._pending0 = this._pending0 - this._written13 | 0;
            var tmp_10 = this;
            var tmp5_plus_0 = this._apos1;
            tmp_10._apos1 = tmp5_plus_0.plus_wiekkq_k$(toLong(this._written13));
            this._aoffset2 = this._aoffset2 + this._written13 | 0;
            this._state_1 = 1;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeDataCOROUTINE$98.$metadata$ = {
    simpleName: '$writeDataCOROUTINE$98',
    kind: 'class',
    interfaces: []
  };
  function $readDataCOROUTINE$99(_this_, fileName, position_0, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__55 = _this_;
    this._fileName_4 = fileName;
    this._position_4 = position_0;
    this._buffer_14 = buffer;
    this._offset_11 = offset_0;
    this._len_8 = len;
  }
  $readDataCOROUTINE$99.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__55.getEntryInfo_6wfw3l_k$(this._fileName_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_elvis_lhs0 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (this._tmp0_elvis_lhs0 == null) {
              return -1;
            } else {
              tmp_1 = this._tmp0_elvis_lhs0;
            }

            tmp_0._info1 = tmp_1;
            if (this._position_4.compareTo_wiekkq_k$(this._info1._size_10) >= 0)
              return 0;
            var tmp_2 = this;
            var tmp_3 = this;
            tmp_3._tmp0_div_02 = Companion_getInstance_109()._CHUNK_SIZE;
            tmp_2._chunk3 = this._position_4.div_wiekkq_k$(toLong(this._tmp0_div_02)).toInt_0_k$();
            var tmp_4 = this;
            var tmp_5 = this;
            tmp_5._tmp1_rem_04 = Companion_getInstance_109()._CHUNK_SIZE;
            tmp_4._inChunk5 = this._position_4.rem_wiekkq_k$(toLong(this._tmp1_rem_04)).toInt_0_k$();
            this._state_1 = 2;
            suspendResult = this.__this__55.getFileChunk_8i7b4u_k$(this._fileName_4, this._chunk3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_6;
            if (tmp1_elvis_lhs == null) {
              return 0;
            } else {
              tmp_6 = tmp1_elvis_lhs;
            }

            var c = tmp_6;
            var available = c.length - this._inChunk5 | 0;
            var read_0 = Math.min(available, this._len_8);
            arraycopy_2(c, this._inChunk5, this._buffer_14, this._offset_11, read_0);
            return read_0;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readDataCOROUTINE$99.$metadata$ = {
    simpleName: '$readDataCOROUTINE$99',
    kind: 'class',
    interfaces: []
  };
  function StorageFiles(storage, timeProvider) {
    Companion_getInstance_109();
    this._storage_4 = storage;
    this._timeProvider_0 = timeProvider;
  }
  StorageFiles.prototype.getStatsKey_6wfw3l_k$ = function (fileName) {
    return '' + 'korio_stats_v1_' + fileName;
  };
  StorageFiles.prototype.getChunkKey_8i7b4u_k$ = function (fileName, chunk) {
    return '' + 'korio_chunk' + chunk + '_v1_' + fileName;
  };
  StorageFiles.prototype.setEntryInfo_v3wzy5_k$ = function (info, $cont) {
    var tmp = new $setEntryInfoCOROUTINE$91(this, info, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  StorageFiles.prototype.hasEntryInfo_6wfw3l_k$ = function (fileName, $cont) {
    var tmp = new $hasEntryInfoCOROUTINE$92(this, fileName, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  StorageFiles.prototype.getEntryInfo_6wfw3l_k$ = function (fileName, $cont) {
    var tmp = new $getEntryInfoCOROUTINE$93(this, fileName, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  StorageFiles.prototype.setFileChunk_ba91rk_k$ = function (fileName, chunk, data, $cont) {
    var tmp = new $setFileChunkCOROUTINE$96(this, fileName, chunk, data, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  StorageFiles.prototype.getFileChunk_8i7b4u_k$ = function (fileName, chunk, $cont) {
    var tmp = new $getFileChunkCOROUTINE$97(this, fileName, chunk, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  StorageFiles.prototype.writeData_xwvjwp_k$ = function (fileName, position_0, buffer, offset_0, len, $cont) {
    var tmp = new $writeDataCOROUTINE$98(this, fileName, position_0, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  StorageFiles.prototype.readData_li5eee_k$ = function (fileName, position_0, buffer, offset_0, len, $cont) {
    var tmp = new $readDataCOROUTINE$99(this, fileName, position_0, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  StorageFiles.$metadata$ = {
    simpleName: 'StorageFiles',
    kind: 'class',
    interfaces: []
  };
  function isFile$factory() {
    return getPropertyCallableRef('isFile', 1, KProperty1, function (receiver) {
      return receiver._isFile;
    }, null);
  }
  function size$factory() {
    return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
      return receiver._size_10;
    }, null);
  }
  function children$factory() {
    return getPropertyCallableRef('children', 1, KProperty1, function (receiver) {
      return receiver._children_0;
    }, null);
  }
  function createdTime$factory() {
    return getPropertyCallableRef('createdTime', 1, KProperty1, function (receiver) {
      return new DateTime(receiver._createdTime);
    }, null);
  }
  function modifiedTime$factory() {
    return getPropertyCallableRef('modifiedTime', 1, KProperty1, function (receiver) {
      return new DateTime(receiver._modifiedTime_0);
    }, null);
  }
  function isFile$factory_0() {
    return getPropertyCallableRef('isFile', 1, KProperty1, function (receiver) {
      return receiver._isFile;
    }, null);
  }
  function size$factory_0() {
    return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
      return receiver._size_10;
    }, null);
  }
  function children$factory_0() {
    return getPropertyCallableRef('children', 1, KProperty1, function (receiver) {
      return receiver._children_0;
    }, null);
  }
  function createdTime$factory_0() {
    return getPropertyCallableRef('createdTime', 1, KProperty1, function (receiver) {
      return new DateTime(receiver._createdTime);
    }, null);
  }
  function modifiedTime$factory_0() {
    return getPropertyCallableRef('modifiedTime', 1, KProperty1, function (receiver) {
      return new DateTime(receiver._modifiedTime_0);
    }, null);
  }
  function _no_name_provided_$factory_130(this$0) {
    var i = new _no_name_provided__162(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_131(this$0) {
    var i = new _no_name_provided__164(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function MemoryVfs(items, caseSensitive) {
    var vfs = new NodeVfs(caseSensitive);
    var tmp0_iterator = items._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var tmp1_loop_parameter = tmp0_iterator.next_0_k$();
      var path_0 = tmp1_loop_parameter._get_key__0_k$();
      var stream = tmp1_loop_parameter._get_value__0_k$();
      var info = _PathInfo___init__impl_(path_0);
      var folderNode = vfs._rootNode.access_2f0f39_k$(_get_folder__0(info), true);
      var fileNode = folderNode.createChild_2f0f39_k$(_get_baseName__0(info), false);
      fileNode._stream = stream;
    }
    return vfs._get_root__0_k$();
  }
  function MemoryVfs$default(items, caseSensitive, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      items = LinkedHashMap_init_$Create$();
    if (!(($mask0 & 2) === 0))
      caseSensitive = true;
    return MemoryVfs(items, caseSensitive);
  }
  function VfsFileFromData(data, ext) {
    var tmp = mapOf_0(to('' + 'file.' + ext, data));
    return MemoryVfsMix$default(tmp, false, null, 6, null).get_6wfw3l_k$('' + 'file.' + ext);
  }
  function MemoryVfsMix(items, caseSensitive, charset) {
    var tmp1_mapValuesTo_0_1 = LinkedHashMap_init_$Create$_1(mapCapacity(items._get_size__0_k$()));
    var tmp0_associateByTo_0_2 = items._get_entries__0_k$();
    var tmp0_iterator_1_3 = tmp0_associateByTo_0_2.iterator_0_k$();
    while (tmp0_iterator_1_3.hasNext_0_k$()) {
      var element_2_4 = tmp0_iterator_1_3.next_0_k$();
      var tmp = element_2_4._get_key__0_k$();
      var v_6 = element_2_4._get_value__0_k$();
      var tmp0_subject_7 = v_6;
      var tmp_0;
      if (tmp0_subject_7 instanceof SyncStream) {
        tmp_0 = toAsync(v_6);
      } else {
        if (isByteArray(tmp0_subject_7)) {
          tmp_0 = openAsync$default(v_6, null, 1, null);
        } else {
          if (typeof tmp0_subject_7 === 'string') {
            tmp_0 = openAsync_0(v_6, charset);
          } else {
            {
              var tmp_1 = toString_1(v_6);
              var tmp_2 = toByteArray$default(tmp_1, charset, 0, 0, 6, null);
              tmp_0 = openAsync$default(tmp_2, null, 1, null);
            }
          }
        }
      }
      tmp1_mapValuesTo_0_1.put_1q9pf_k$(tmp, tmp_0);
      Unit_getInstance();
    }
    return MemoryVfs(tmp1_mapValuesTo_0_1, caseSensitive);
  }
  function MemoryVfsMix$default(items, caseSensitive, charset, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      items = LinkedHashMap_init_$Create$();
    if (!(($mask0 & 2) === 0))
      caseSensitive = true;
    if (!(($mask0 & 4) === 0))
      charset = UTF8;
    return MemoryVfsMix(items, caseSensitive, charset);
  }
  function Mountable() {
  }
  Mountable.$metadata$ = {
    simpleName: 'Mountable',
    kind: 'interface',
    interfaces: []
  };
  function MountableVfs(closeMounts, callback, $cont) {
    var tmp = new $MountableVfsCOROUTINE$100(closeMounts, callback, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function MountableVfs$default(closeMounts, callback, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      closeMounts = false;
    return MountableVfs(closeMounts, callback, $cont);
  }
  function unmountInternal($this, folder) {
    removeAll($this._mounts, _no_name_provided_$factory_132(folder));
    Unit_getInstance();
  }
  function resort($this) {
    var tmp0_sortByDescending_0 = $this._mounts;
    if (tmp0_sortByDescending_0._get_size__0_k$() > 1) {
      var tmp = _no_name_provided_$factory_133();
      sortWith(tmp0_sortByDescending_0, new sam$kotlin_Comparator$0_1(tmp));
    }}
  function sam$kotlin_Comparator$0_1(function_0) {
    this._function_1 = function_0;
  }
  sam$kotlin_Comparator$0_1.prototype.compare_1qgdm_k$ = function (a, b) {
    return this._function_1(a, b);
  };
  sam$kotlin_Comparator$0_1.prototype.compare = function (a, b) {
    return this.compare_1qgdm_k$(a, b);
  };
  sam$kotlin_Comparator$0_1.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__165($folder) {
    this._$folder = $folder;
  }
  _no_name_provided__165.prototype.invoke_bpluv1_k$ = function (it) {
    return it._first === normalize(_get_pathInfo_(this._$folder));
  };
  _no_name_provided__165.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_bpluv1_k$(p1 instanceof Pair ? p1 : THROW_CCE());
  };
  _no_name_provided__165.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__166() {
  }
  _no_name_provided__166.prototype.invoke_p96d7k_k$ = function (a, b) {
    var tmp = b._first.length;
    return compareValues(tmp, a._first.length);
  };
  _no_name_provided__166.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Pair ? p1 : THROW_CCE();
    return this.invoke_p96d7k_k$(tmp, p2 instanceof Pair ? p2 : THROW_CCE());
  };
  _no_name_provided__166.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $closeCOROUTINE$101(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__56 = _this_;
  }
  $closeCOROUTINE$101.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            if (this.__this__56._closeMounts) {
              var tmp_0 = this;
              tmp_0._tmp0_fastForEach_00 = this.__this__56._mounts;
              this._n_11 = 0;
              this._state_1 = 1;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 1:
            if (!(this._n_11 < this._tmp0_fastForEach_00._get_size__0_k$())) {
              this._state_1 = 3;
              continue $sm;
            }
            var tmp_1 = this;
            var tmp0_2 = this._n_11;
            this._n_11 = tmp0_2 + 1 | 0;
            tmp_1._tmp1__anonymous__32 = this._tmp0_fastForEach_00.get_ha5a7z_k$(tmp0_2);
            this._state_1 = 2;
            suspendResult = this._tmp1__anonymous__32._second._vfs.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            this._state_1 = 4;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $closeCOROUTINE$101.$metadata$ = {
    simpleName: '$closeCOROUTINE$101',
    kind: 'class',
    interfaces: []
  };
  function MountableVfs_0(closeMounts) {
    Proxy.call(this);
    this._closeMounts = closeMounts;
    this._mounts = ArrayList_init_$Create$();
  }
  MountableVfs_0.prototype.close_sv8swh_k$ = function ($cont) {
    var tmp = new $closeCOROUTINE$101(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  MountableVfs_0.prototype.mount_7u3n0j_k$ = function (folder, file) {
    unmountInternal(this, folder);
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._mounts;
    var tmp1_plusAssign_0_4 = to(normalize(_get_pathInfo_(folder)), file);
    tmp0_plusAssign_0_3.add_2bq_k$(tmp1_plusAssign_0_4);
    Unit_getInstance();
    resort(this);
    return this;
  };
  MountableVfs_0.prototype.access_6wfw3l_k$ = function (path_0, $cont) {
    var rpath = normalize(_get_pathInfo_(path_0));
    var tmp0_fastForEach_0 = this._mounts;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      var base_4 = tmp1__anonymous__3.component1_0_k$();
      var file_5 = tmp1__anonymous__3.component2_0_k$();
      if (startsWith$default_1(rpath, base_4, false, 2, null)) {
        var tmp0_substring_0_6 = base_4.length;
        return file_5.get_6wfw3l_k$(rpath.substring(tmp0_substring_0_6));
      } else {
      }
    }
    throw new FileNotFoundException(path_0);
  };
  MountableVfs_0.prototype.toString = function () {
    return 'MountableVfs';
  };
  MountableVfs_0.$metadata$ = {
    simpleName: 'MountableVfs',
    kind: 'class',
    interfaces: [Mountable]
  };
  function $MountableVfsCOROUTINE$100(closeMounts, callback, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._closeMounts_0 = closeMounts;
    this._callback_1 = callback;
  }
  $MountableVfsCOROUTINE$100.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_also_00_0 = new MountableVfs_0(this._closeMounts_0);
            this._state_1 = 1;
            suspendResult = this._callback_1(this._tmp0_also_00_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = this._tmp0_also_00_0;
            return ARGUMENT._get_root__0_k$();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $MountableVfsCOROUTINE$100.$metadata$ = {
    simpleName: '$MountableVfsCOROUTINE$100',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_132($folder) {
    var i = new _no_name_provided__165($folder);
    return function (p1) {
      return i.invoke_bpluv1_k$(p1);
    };
  }
  function _no_name_provided_$factory_133() {
    var i = new _no_name_provided__166();
    return function (p1, p2) {
      return i.invoke_p96d7k_k$(p1, p2);
    };
  }
  function Node_init_$Init$($outer, name, isDirectory, parent, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      isDirectory = false;
    if (!(($mask0 & 8) === 0))
      parent = null;
    Node_1.call($this, $outer, name, isDirectory, parent);
    return $this;
  }
  function Node_init_$Create$($outer, name, isDirectory, parent, $mask0, $marker) {
    return Node_init_$Init$($outer, name, isDirectory, parent, $mask0, $marker, Object.create(Node_1.prototype));
  }
  function Node_1($outer, name, isDirectory, parent) {
    this._$this_10 = $outer;
    this._name_4 = name;
    this._isDirectory_1 = isDirectory;
    var tmp = this;
    var tmp0_toLowerCase_0 = this._name_4;
    tmp._nameLC = tmp0_toLowerCase_0.toLowerCase();
    this._parent_1 = null;
    this._set_parent__tybx6o_k$(parent);
    this._data_19 = null;
    var tmp_0 = this;
    tmp_0._children_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    tmp_1._childrenLC = LinkedHashMap_init_$Create$();
    this._stream = null;
  }
  Node_1.prototype.iterator_0_k$ = function () {
    return this._children_1._get_values__0_k$().iterator_0_k$();
  };
  Node_1.prototype._set_parent__tybx6o_k$ = function (value) {
    if (!(this._parent_1 == null)) {
      ensureNotNull(this._parent_1)._children_1.remove_2bw_k$(this._name_4);
      Unit_getInstance();
      ensureNotNull(this._parent_1)._childrenLC.remove_2bw_k$(this._nameLC);
      Unit_getInstance();
    }this._parent_1 = value;
    var tmp0_safe_receiver = this._parent_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._children_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp0_set_0 = this._name_4;
      tmp1_safe_receiver.put_1q9pf_k$(tmp0_set_0, this);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp2_safe_receiver = this._parent_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._childrenLC;
    if (tmp3_safe_receiver == null)
      null;
    else {
      var tmp1_set_0 = this._nameLC;
      tmp3_safe_receiver.put_1q9pf_k$(tmp1_set_0, this);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  Node_1.prototype._get_root__0_k$ = function () {
    var tmp0_safe_receiver = this._parent_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_root__0_k$();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  };
  Node_1.prototype.child_6wfw3l_k$ = function (name) {
    var tmp0_subject = name;
    var tmp;
    switch (tmp0_subject) {
      case '':
      case '.':
        tmp = this;
        break;
      case '..':
        tmp = this._parent_1;
        break;
      default:var tmp_0;
        if (this._$this_10._caseSensitive_1) {
          tmp_0 = this._children_1.get_2bw_k$(name);
        } else {
          tmp_0 = this._childrenLC.get_2bw_k$(name.toLowerCase());
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  Node_1.prototype.createChild_2f0f39_k$ = function (name, isDirectory) {
    return new Node_1(this._$this_10, name, isDirectory, this);
  };
  Node_1.prototype.get_6wfw3l_k$ = function (path_0) {
    return this.access_2f0f39_k$(path_0, false);
  };
  Node_1.prototype.access_2f0f39_k$ = function (path_0, createFolders) {
    var tmp;
    var tmp_0 = new Char(47);
    if (startsWith$default(path_0, tmp_0, false, 2, null)) {
      tmp = this._get_root__0_k$();
    } else {
      {
        tmp = this;
      }
    }
    var node = tmp;
    var tmp0_fastForEach_0 = parts(_get_pathInfo_(path_0));
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      var child_4 = node.child_6wfw3l_k$(tmp1__anonymous__3);
      if (child_4 == null ? createFolders : false)
        child_4 = node.createChild_2f0f39_k$(tmp1__anonymous__3, true);
      var tmp0_elvis_lhs_5 = child_4;
      var tmp_1;
      if (tmp0_elvis_lhs_5 == null) {
        throw new FileNotFoundException('' + "Can't find '" + tmp1__anonymous__3 + "' in " + path_0);
      } else {
        tmp_1 = tmp0_elvis_lhs_5;
      }
      node = tmp_1;
    }
    return node;
  };
  Node_1.prototype.access$default_zmr95_k$ = function (path_0, createFolders, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      createFolders = false;
    return this.access_2f0f39_k$(path_0, createFolders);
  };
  Node_1.$metadata$ = {
    simpleName: 'Node',
    kind: 'class',
    interfaces: [Iterable]
  };
  function createStream($this, s, vfsFile) {
    var tmp = new _no_name_provided__167(s, $this, vfsFile);
    return toAsyncStream$default(tmp, new Long(0, 0), 1, null);
  }
  function _no_name_provided__167($s, this$0, $vfsFile) {
    this._$s = $s;
    this._this$0_46 = this$0;
    this._$vfsFile = $vfsFile;
    AsyncStreamBase.call(this);
  }
  _no_name_provided__167.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    return this._$s.read_pwamfb_k$(position_0, buffer, offset_0, len);
  };
  _no_name_provided__167.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len, $cont) {
    this._$s.write_8wseoo_k$(position_0, buffer, offset_0, len);
    var tmp = Kind_MODIFIED_getInstance();
    this._this$0_46._events.invoke_iav7o_k$(FileEvent_init_$Create$(tmp, this._$vfsFile, null, 4, null));
  };
  _no_name_provided__167.prototype.getLength_0_k$ = function ($cont) {
    return this._$s._get_length__0_k$();
  };
  _no_name_provided__167.prototype.close_sv8swh_k$ = function ($cont) {
    return this._$s.close_sv8swh_k$();
  };
  _no_name_provided__167.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__168(this$0, $path, resultContinuation) {
    this._this$0_47 = this$0;
    this._$path_1 = $path;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__168.prototype.invoke_8bppsg_k$ = function ($this$flow, $cont) {
    var tmp = this.create_bv35dh_k$($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__168.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_8bppsg_k$((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__168.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._node0 = this._this$0_47._rootNode.get_6wfw3l_k$(this._$path_1);
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_iterator_01 = this._node0._children_1;
            tmp_0._tmp0_iterator2 = this._tmp0_iterator_01._get_entries__0_k$().iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator2.hasNext_0_k$()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._tmp1_loop_parameter3 = this._tmp0_iterator2.next_0_k$();
            var tmp_2 = this;
            tmp_2._name4 = this._tmp1_loop_parameter3._get_key__0_k$();
            this._state_1 = 2;
            suspendResult = this._$this$flow_2.emit_iav7o_k$(this._this$0_47.file_6wfw3l_k$('' + this._$path_1 + '/' + this._name4), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__168.prototype.create_bv35dh_k$ = function ($this$flow, completion) {
    var i = new _no_name_provided__168(this._this$0_47, this._$path_1, completion);
    i._$this$flow_2 = $this$flow;
    return i;
  };
  _no_name_provided__168.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $statCOROUTINE$102(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__57 = _this_;
    this._path_11 = path_0;
  }
  $statCOROUTINE$102.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._exceptionState = 3;
            var tmp_0 = this;
            tmp_0._node1 = this.__this__57._rootNode.access$default_zmr95_k$(this._path_11, false, 2, null);
            this._tmp0_safe_receiver2 = this._node1._stream;
            if (this._tmp0_safe_receiver2 == null) {
              this._WHEN_RESULT3 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver2.getLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT3 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = this._WHEN_RESULT3;
            var length = tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs;
            var tmp_1 = this;
            var tmp_2 = new Long(0, 0);
            var tmp_3 = new Long(0, 0);
            tmp_1._TRY_RESULT0_0 = this.__this__57.createExistsStat$default_r7ry8g_k$(this._path_11, this._node1._isDirectory_1, length, tmp_2, tmp_3, 0, null, null, null, null, null, null, null, 8184, null);
            this._exceptionState = 4;
            this._state_1 = 5;
            continue $sm;
          case 3:
            this._exceptionState = 4;
            var tmp_4 = this._exception_0;
            if (tmp_4 instanceof Error) {
              var e = this._exception_0;
              var tmp_5 = this;
              tmp_5._TRY_RESULT0_0 = this.__this__57.createNonExistsStat$default_r8spfi_k$(this._path_11, null, 2, null);
              this._state_1 = 5;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            throw this._exception_0;
          case 5:
            this._exceptionState = 4;
            return this._TRY_RESULT0_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $statCOROUTINE$102.$metadata$ = {
    simpleName: '$statCOROUTINE$102',
    kind: 'class',
    interfaces: []
  };
  function NodeVfs(caseSensitive) {
    VfsV2.call(this);
    this._caseSensitive_1 = caseSensitive;
    var tmp = this;
    tmp._events = Signal_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._rootNode = Node_init_$Create$(this, '', true, null, 8, null);
  }
  NodeVfs.prototype.open_4jc6oe_k$ = function (path_0, mode, $cont) {
    var pathInfo = _PathInfo___init__impl_(path_0);
    var tmp = _get_folder__0(pathInfo);
    var folder = this._rootNode.access$default_zmr95_k$(tmp, false, 2, null);
    var node = folder.child_6wfw3l_k$(_get_baseName__0(pathInfo));
    var vfsFile = this.get_6wfw3l_k$(path_0);
    if (node == null ? mode._createIfNotExists : false) {
      node = folder.createChild_2f0f39_k$(_get_baseName__0(pathInfo), false);
      var tmp_0 = node;
      tmp_0._stream = createStream(this, MemorySyncStream$default(null, 1, null)._base_2, vfsFile);
    } else if (mode._truncate) {
      var tmp0_safe_receiver = node;
      if (tmp0_safe_receiver == null) {
        Unit_getInstance();
      } else {
        var tmp_1 = tmp0_safe_receiver;
        tmp_1._stream = createStream(this, MemorySyncStream$default(null, 1, null)._base_2, vfsFile);
      }
    }var tmp1_safe_receiver = node;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._stream;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.duplicate_0_k$();
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      throw new FileNotFoundException(path_0);
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    return tmp_2;
  };
  NodeVfs.prototype.stat_6wfw3l_k$ = function (path_0, $cont) {
    var tmp = new $statCOROUTINE$102(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  NodeVfs.prototype.listFlow_6wfw3l_k$ = function (path_0, $cont) {
    return flow(_no_name_provided_$factory_134(this, path_0, null));
  };
  NodeVfs.prototype.toString = function () {
    return 'NodeVfs';
  };
  NodeVfs.$metadata$ = {
    simpleName: 'NodeVfs',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_134(this$0, $path, resultContinuation) {
    var i = new _no_name_provided__168(this$0, $path, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_8bppsg_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  var defaultUniSchema;
  function UniSchemaProviders_init_$Init$(providers, $this) {
    var capacity_1 = coerceAtLeast(mapCapacity(providers.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = providers;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_1q9pf_k$(element_2_4._name_5, element_2_4);
      Unit_getInstance();
    }
    UniSchemaProviders.call($this, tmp0_associateByTo_0_2);
    return $this;
  }
  function UniSchemaProviders_init_$Create$(providers) {
    return UniSchemaProviders_init_$Init$(providers, Object.create(UniSchemaProviders.prototype));
  }
  function UniSchemaProviders(providers) {
    this._providers = providers;
  }
  UniSchemaProviders.$metadata$ = {
    simpleName: 'UniSchemaProviders',
    kind: 'class',
    interfaces: []
  };
  function UniSchema(name, provider) {
    this._name_5 = name;
    this._provider = provider;
  }
  UniSchema.$metadata$ = {
    simpleName: 'UniSchema',
    kind: 'class',
    interfaces: []
  };
  function _get_uniVfs_(_this_) {
    var tmp = UniversalVfs_getInstance();
    var tmp_0 = defaultUniSchema;
    return tmp.invoke$default_uuk44h_k$(_this_, tmp_0, null, 4, null);
  }
  function UniversalVfs() {
    UniversalVfs_instance = this;
  }
  UniversalVfs.prototype.invoke_l2amm5_k$ = function (uri, providers, base) {
    var tmp;
    if (Companion_getInstance_113().isAbsolute_6wfw3l_k$(uri)) {
      var uriUri = Companion_getInstance_113().invoke_6wfw3l_k$(uri);
      var tmp0_get_0 = providers._providers;
      var tmp1_get_0 = uriUri._scheme;
      var builder = (isInterface(tmp0_get_0, Map_0) ? tmp0_get_0 : THROW_CCE()).get_2bw_k$(tmp1_get_0);
      var tmp_0;
      if (!(builder == null)) {
        tmp_0 = builder._provider(uriUri);
      } else {
        invalidOp('' + "Unsupported scheme '" + uriUri._scheme + "'");
      }
      tmp = tmp_0;
    } else if (!(base == null)) {
      tmp = base.get_6wfw3l_k$(uri);
    } else {
      tmp = _get_localCurrentDirVfs_().get_6wfw3l_k$(uri);
    }
    return tmp;
  };
  UniversalVfs.prototype.invoke$default_uuk44h_k$ = function (uri, providers, base, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      base = null;
    return this.invoke_l2amm5_k$(uri, providers, base);
  };
  UniversalVfs.$metadata$ = {
    simpleName: 'UniversalVfs',
    kind: 'object',
    interfaces: []
  };
  var UniversalVfs_instance;
  function UniversalVfs_getInstance() {
    if (UniversalVfs_instance == null)
      new UniversalVfs();
    return UniversalVfs_instance;
  }
  function _no_name_provided__169() {
  }
  _no_name_provided__169.prototype.invoke_lysikz_k$ = function (it) {
    return UrlVfs$default(it, null, false, 6, null);
  };
  _no_name_provided__169.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_lysikz_k$(p1 instanceof URL_0 ? p1 : THROW_CCE());
  };
  _no_name_provided__169.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__170() {
  }
  _no_name_provided__170.prototype.invoke_lysikz_k$ = function (it) {
    return UrlVfs$default(it, null, false, 6, null);
  };
  _no_name_provided__170.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_lysikz_k$(p1 instanceof URL_0 ? p1 : THROW_CCE());
  };
  _no_name_provided__170.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__171() {
  }
  _no_name_provided__171.prototype.invoke_lysikz_k$ = function (it) {
    return _get_rootLocalVfs_().get_6wfw3l_k$(it._path_16);
  };
  _no_name_provided__171.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_lysikz_k$(p1 instanceof URL_0 ? p1 : THROW_CCE());
  };
  _no_name_provided__171.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_135() {
    var i = new _no_name_provided__169();
    return function (p1) {
      return i.invoke_lysikz_k$(p1);
    };
  }
  function _no_name_provided_$factory_136() {
    var i = new _no_name_provided__170();
    return function (p1) {
      return i.invoke_lysikz_k$(p1);
    };
  }
  function _no_name_provided_$factory_137() {
    var i = new _no_name_provided__171();
    return function (p1) {
      return i.invoke_lysikz_k$(p1);
    };
  }
  function defaultUniSchema$init$() {
    var tmp = new UniSchema('http', _no_name_provided_$factory_135());
    var tmp_0 = new UniSchema('https', _no_name_provided_$factory_136());
    return UniSchemaProviders_init_$Create$([tmp, tmp_0, new UniSchema('file', _no_name_provided_$factory_137())]);
  }
  function UrlVfs(url, client, failFromStatus) {
    return (new UrlVfs_0(url.copy$default_2za93v_k$(false, null, null, null, '', null, null, 0, 207, null)._get_fullUrl__0_k$(), Unit_getInstance(), client, failFromStatus)).get_6wfw3l_k$(url._path_16);
  }
  function UrlVfs$default(url, client, failFromStatus, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      client = createHttpClient();
    if (!(($mask0 & 4) === 0))
      failFromStatus = true;
    return UrlVfs(url, client, failFromStatus);
  }
  function $readCOROUTINE$109(_this_, position_0, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__58 = _this_;
    this._position_5 = position_0;
    this._buffer_15 = buffer;
    this._offset_12 = offset_0;
    this._len_9 = len;
  }
  $readCOROUTINE$109.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            if (this._len_9 === 0)
              return 0;
            this._state_1 = 1;
            suspendResult = _readRangeBase(this.__this__58._this$0_48, this.__this__58._$fullUrl, until_0(this._position_5, this._position_5.plus_wiekkq_k$(toLong(this._len_9))), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._res0 = suspendResult;
            this._s1 = this._res0._content;
            this._coffset2 = this._offset_12;
            this._pending3 = this._len_9;
            this._totalRead4 = 0;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!(this._pending3 > 0)) {
              this._state_1 = 5;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = this._s1.read_irqg4d_k$(this._buffer_15, this._coffset2, this._pending3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var read_0 = suspendResult;
            if (read_0 < 0 ? this._totalRead4 === 0 : false)
              return read_0;
            if (read_0 <= 0) {
              this._state_1 = 5;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this._pending3 = this._pending3 - read_0 | 0;
            this._totalRead4 = this._totalRead4 + read_0 | 0;
            this._coffset2 = this._coffset2 + read_0 | 0;
            this._state_1 = 2;
            continue $sm;
          case 5:
            return this._totalRead4;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$109.$metadata$ = {
    simpleName: '$readCOROUTINE$109',
    kind: 'class',
    interfaces: []
  };
  function $getLengthCOROUTINE$110(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__59 = _this_;
  }
  $getLengthCOROUTINE$110.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__59.hasLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            if (suspendResult) {
              this._WHEN_RESULT0_1 = this.__this__59._$stat._size_9;
              this._state_1 = 2;
              continue $sm;
            } else {
              var tmp_0 = this;
              unsupported_0();
            }

            break;
          case 2:
            return this._WHEN_RESULT0_1;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getLengthCOROUTINE$110.$metadata$ = {
    simpleName: '$getLengthCOROUTINE$110',
    kind: 'class',
    interfaces: []
  };
  function _readRangeBase($this, fullUrl, range, $cont) {
    var tmp = new $_readRangeBaseCOROUTINE$105($this, fullUrl, range, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__172(this$0, $fullUrl, $stat) {
    this._this$0_48 = this$0;
    this._$fullUrl = $fullUrl;
    this._$stat = $stat;
    AsyncStreamBase.call(this);
  }
  _no_name_provided__172.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    var tmp = new $readCOROUTINE$109(this, position_0, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__172.prototype.hasLength_0_k$ = function ($cont) {
    return this._$stat._size_9.compareTo_wiekkq_k$(new Long(0, 0)) >= 0;
  };
  _no_name_provided__172.prototype.getLength_0_k$ = function ($cont) {
    var tmp = new $getLengthCOROUTINE$110(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__172.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $openCOROUTINE$103(_this_, path_0, mode, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__60 = _this_;
    this._path_12 = path_0;
    this._mode_2 = mode;
  }
  $openCOROUTINE$103.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._exceptionState = 4;
            this._fullUrl0 = this.__this__60.getFullUrl_6wfw3l_k$(this._path_12);
            if (startsWith$default_1(this._fullUrl0, 'file:', false, 2, null)) {
              this._state_1 = 3;
              suspendResult = this.__this__60._client.readBytes$default_nx2een_k$(this._fullUrl0, null, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 1;
                continue $sm;
              }
            }

            break;
          case 1:
            this._state_1 = 2;
            suspendResult = this.__this__60.stat_6wfw3l_k$(this._path_12, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var stat = suspendResult;
            var tmp_0 = stat._extraInfo;
            var response = tmp_0 instanceof Response_0 ? tmp_0 : null;
            if (!stat._exists) {
              throw new FileNotFoundException('' + 'Unexistant ' + this._fullUrl0 + ' : ' + response);
            }
            var tmp_1 = new _no_name_provided__172(this.__this__60, this._fullUrl0, stat);
            var tmp_2 = toAsyncStream$default(tmp_1, new Long(0, 0), 1, null);
            return buffered$default(tmp_2, 0, 0, 3, null);
          case 3:
            var ARGUMENT = suspendResult;
            return openAsync$default(ARGUMENT, null, 1, null);
          case 4:
            this._exceptionState = 5;
            var tmp_3 = this._exception_0;
            if (tmp_3 instanceof RuntimeException) {
              var e = this._exception_0;
              var tmp0_elvis_lhs = e.message;
              throw new FileNotFoundException(tmp0_elvis_lhs == null ? 'error' : tmp0_elvis_lhs);
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 5:
            throw this._exception_0;
          case 6:
            this._exceptionState = 5;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openCOROUTINE$103.$metadata$ = {
    simpleName: '$openCOROUTINE$103',
    kind: 'class',
    interfaces: []
  };
  function $_readRangeBaseCOROUTINE$105(_this_, fullUrl, range, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__61 = _this_;
    this._fullUrl = fullUrl;
    this._range_2 = range;
  }
  $_readRangeBaseCOROUTINE$105.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            var tmp_0 = Companion_getInstance_114()._GET;
            var tmp_1 = Headers_init_$Create$_0(this._range_2.equals(LONG_ZERO_TO_MAX_RANGE) ? LinkedHashMap_init_$Create$() : linkedHashMapOf([to('range', '' + 'bytes=' + this._range_2._get_start__0_k$() + '-' + this._range_2._get_endInclusive__0_k$())]));
            suspendResult = this.__this__61._client.request$default_ou1vmx_k$(tmp_0, this._fullUrl, tmp_1, null, null, 24, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_also_00_1 = suspendResult;
            if (this.__this__61._failFromStatus) {
              if (this._tmp0_also_00_1._status === 404)
                throw new FileNotFoundException('' + this._fullUrl + ' not found');
              this._state_1 = 2;
              suspendResult = this._tmp0_also_00_1.checkErrors_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            Unit_getInstance();
            this._state_1 = 3;
            continue $sm;
          case 3:
            return this._tmp0_also_00_1;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $_readRangeBaseCOROUTINE$105.$metadata$ = {
    simpleName: '$_readRangeBaseCOROUTINE$105',
    kind: 'class',
    interfaces: []
  };
  function $readRangeCOROUTINE$106(_this_, path_0, range, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__62 = _this_;
    this._path_13 = path_0;
    this._range_3 = range;
  }
  $readRangeCOROUTINE$106.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = _readRangeBase(this.__this__62, this.__this__62.getFullUrl_6wfw3l_k$(this._path_13), this._range_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_12 = suspendResult;
            this._ARGUMENT1_6 = this._ARGUMENT0_12._content;
            this._state_1 = 2;
            suspendResult = readAll(this._ARGUMENT1_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readRangeCOROUTINE$106.$metadata$ = {
    simpleName: '$readRangeCOROUTINE$106',
    kind: 'class',
    interfaces: []
  };
  function $statCOROUTINE$108(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__63 = _this_;
    this._path_14 = path_0;
  }
  $statCOROUTINE$108.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._fullUrl0_0 = this.__this__63.getFullUrl_6wfw3l_k$(this._path_14);
            if (startsWith$default_1(this._fullUrl0_0, 'file:', false, 2, null)) {
              this._exceptionState = 3;
              this._state_1 = 2;
              suspendResult = this.__this__63._client.readBytes$default_nx2een_k$(this._fullUrl0_0, null, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 1;
                var tmp_0 = Companion_getInstance_114()._HEAD;
                suspendResult = this.__this__63._client.request$default_ou1vmx_k$(tmp_0, this._fullUrl0_0, null, null, null, 28, null, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            }

            break;
          case 1:
            var result = suspendResult;
            var tmp_1 = this;
            var tmp_2;
            if (result._success) {
              var tmp0_safe_receiver = result._headers_0.get_6wfw3l_k$(Companion_getInstance_116()._ContentLength);
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toLongOrNull(tmp0_safe_receiver);
              var tmp_3 = tmp1_elvis_lhs == null ? new Long(-1, -1) : tmp1_elvis_lhs;
              var tmp_4 = new Long(0, 0);
              var tmp_5 = new Long(0, 0);
              tmp_2 = this.__this__63.createExistsStat$default_r7ry8g_k$(this._path_14, false, tmp_3, tmp_4, tmp_5, 0, null, null, null, null, null, result, null, 6136, null);
            } else {
              tmp_2 = this.__this__63.createNonExistsStat_kg0j0g_k$(this._path_14, result);
            }

            tmp_1._WHEN_RESULT1_1 = tmp_2;
            this._state_1 = 5;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT.length;
            var size_2 = toLong(ARGUMENT_0);
            var tmp_6 = this;
            var tmp_7 = new Long(0, 0);
            var tmp_8 = new Long(0, 0);
            tmp_6._TRY_RESULT2 = this.__this__63.createExistsStat$default_r7ry8g_k$(this._path_14, false, size_2, tmp_7, tmp_8, 0, null, null, null, null, null, null, null, 6136, null);
            this._exceptionState = 6;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._exceptionState = 6;
            var tmp_9 = this._exception_0;
            if (tmp_9 instanceof Error) {
              var e = this._exception_0;
              var tmp_10 = this;
              printStackTrace_0(e);
              tmp_10._TRY_RESULT2 = this.__this__63.createNonExistsStat$default_r8spfi_k$(this._path_14, null, 2, null);
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 6;
            this._WHEN_RESULT1_1 = this._TRY_RESULT2;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT1_1;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $statCOROUTINE$108.$metadata$ = {
    simpleName: '$statCOROUTINE$108',
    kind: 'class',
    interfaces: []
  };
  function UrlVfs_0(url, dummy, client, failFromStatus) {
    Vfs.call(this);
    this._url = url;
    this._dummy_1 = dummy;
    this._client = client;
    this._failFromStatus = failFromStatus;
    this._absolutePath = this._url;
  }
  UrlVfs_0.prototype._get_absolutePath__0_k$ = function () {
    return this._absolutePath;
  };
  UrlVfs_0.prototype.getFullUrl_6wfw3l_k$ = function (path_0) {
    var result = trim(this._url, charArrayOf([new Char(47)])) + new Char(47) + trim(path_0, charArrayOf([new Char(47)]));
    return result;
  };
  UrlVfs_0.prototype.open_4jc6oe_k$ = function (path_0, mode, $cont) {
    var tmp = new $openCOROUTINE$103(this, path_0, mode, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  UrlVfs_0.prototype.readRange_743hkm_k$ = function (path_0, range, $cont) {
    var tmp = new $readRangeCOROUTINE$106(this, path_0, range, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  UrlVfs_0.prototype.stat_6wfw3l_k$ = function (path_0, $cont) {
    var tmp = new $statCOROUTINE$108(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  UrlVfs_0.prototype.toString = function () {
    return 'UrlVfs';
  };
  UrlVfs_0.$metadata$ = {
    simpleName: 'UrlVfs',
    kind: 'class',
    interfaces: []
  };
  function UrlVfs_1(url, client, failFromStatus) {
    return UrlVfs(Companion_getInstance_113().invoke_6wfw3l_k$(url), client, failFromStatus);
  }
  function UrlVfs$default_0(url, client, failFromStatus, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      client = createHttpClient();
    if (!(($mask0 & 4) === 0))
      failFromStatus = true;
    return UrlVfs_1(url, client, failFromStatus);
  }
  function openAsZip(_this_, caseSensitive, useNativeDecompression, callback, $cont) {
    var tmp = new $openAsZipCOROUTINE$111(_this_, caseSensitive, useNativeDecompression, callback, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function openAsZip$default(_this_, caseSensitive, useNativeDecompression, callback, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      caseSensitive = true;
    if (!(($mask0 & 2) === 0))
      useNativeDecompression = true;
    return openAsZip(_this_, caseSensitive, useNativeDecompression, callback, $cont);
  }
  function openAsZip_0(_this_, caseSensitive, useNativeDecompression, $cont) {
    var tmp = new $openAsZipCOROUTINE$112(_this_, caseSensitive, useNativeDecompression, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function ZipVfs(s, zipFile, caseSensitive, closeStream, useNativeDecompression, $cont) {
    var tmp = new $ZipVfsCOROUTINE$113(s, zipFile, caseSensitive, closeStream, useNativeDecompression, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function toStat(_this_, file) {
    var vfs = file._vfs;
    var tmp;
    if (!(_this_ == null)) {
      var tmp_0 = new Long(0, 0);
      tmp = vfs.createExistsStat$default_r7ry8g_k$(file._path_7, _this_._isDirectory, _this_._uncompressedSize, tmp_0, _this_._inode, 0, null, null, _this_._time_2._utc, null, null, null, null, 7912, null);
    } else {
      tmp = vfs.createNonExistsStat$default_r8spfi_k$(file._path_7, null, 2, null);
    }
    return tmp;
  }
  function _no_name_provided__173($zipFile, $path, this$0, resultContinuation) {
    this._$zipFile = $zipFile;
    this._$path_2 = $path;
    this._this$0_49 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__173.prototype.invoke_8bppsg_k$ = function ($this$flow, $cont) {
    var tmp = this.create_bv35dh_k$($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__173.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_8bppsg_k$((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__173.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            var tmp_1 = this;
            var tmp0_elvis_lhs = this._$zipFile._filesPerFolder.get_2bw_k$(this._$zipFile.normalizeName_6wfw3l_k$(this._$path_2));
            tmp_1._tmp0_iterator_00 = tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$() : tmp0_elvis_lhs;
            tmp_0._tmp1_iterator1 = this._tmp0_iterator_00._get_entries__0_k$().iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp1_iterator1.hasNext_0_k$()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._tmp2_loop_parameter2 = this._tmp1_iterator1.next_0_k$();
            var tmp_2 = this;
            tmp_2._entry3 = this._tmp2_loop_parameter2._get_value__0_k$();
            this._state_1 = 2;
            suspendResult = this._$this$flow_3.emit_iav7o_k$(this._this$0_49._vfs_0.get_6wfw3l_k$(this._entry3._path), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__173.prototype.create_bv35dh_k$ = function ($this$flow, completion) {
    var i = new _no_name_provided__173(this._$zipFile, this._$path_2, this._this$0_49, completion);
    i._$this$flow_3 = $this$flow;
    return i;
  };
  _no_name_provided__173.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $closeCOROUTINE$114(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__64 = _this_;
  }
  $closeCOROUTINE$114.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (this.__this__64._$closeStream) {
              this._state_1 = 1;
              suspendResult = this.__this__64._$s_0.close_sv8swh_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $closeCOROUTINE$114.$metadata$ = {
    simpleName: '$closeCOROUTINE$114',
    kind: 'class',
    interfaces: []
  };
  function $openCOROUTINE$115(_this_, path_0, mode, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__65 = _this_;
    this._path_15 = path_0;
    this._mode_3 = mode;
  }
  $openCOROUTINE$115.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 21;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.__this__65._$zipFile_0._files.get_2bw_k$(this.__this__65._$zipFile_0.normalizeName_6wfw3l_k$(this._path_15));
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              throw new FileNotFoundException('' + "Path: '" + this._path_15 + "'");
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0._entry0 = tmp_1;
            if (this._entry0._isDirectory)
              throw new IOException('' + "Can't open a zip directory for " + this._mode_3);
            this._state_1 = 1;
            var tmp_2 = new Long(0, 0);
            suspendResult = sliceStart$default(this._entry0._headerEntry, tmp_2, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._base1 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._base1.getAvailable_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT2_1 = suspendResult;
            if (this._ARGUMENT2_1.compareTo_wiekkq_k$(new Long(16, 0)) < 0) {
              throw IllegalStateException_init_$Create$_0('Chunk to small to be a ZIP chunk');
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._state_1 = 4;
            suspendResult = readS32BE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._ARGUMENT3_1 = suspendResult;
            this._ARGUMENT4 = this._ARGUMENT3_1 === 1347093252;
            if (!this._ARGUMENT4) {
              throw IllegalStateException_init_$Create$_0('Not a zip file (readS32BE() != 0x504B_0304)');
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._state_1 = 6;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._version_25 = suspendResult;
            this._state_1 = 7;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._flags_36 = suspendResult;
            this._state_1 = 8;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._compressionType_47 = suspendResult;
            this._state_1 = 9;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._fileTime_58 = suspendResult;
            this._state_1 = 10;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            this._fileDate_69 = suspendResult;
            this._state_1 = 11;
            suspendResult = readS32LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._crc_710 = suspendResult;
            this._state_1 = 12;
            suspendResult = readS32LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._compressedSize_811 = suspendResult;
            this._state_1 = 13;
            suspendResult = readS32LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 13:
            this._uncompressedSize_912 = suspendResult;
            this._state_1 = 14;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 14:
            this._fileNameLength_1013 = suspendResult;
            this._state_1 = 15;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 15:
            this._extraLength_1114 = suspendResult;
            this._state_1 = 16;
            suspendResult = readString$default(this._base1, this._fileNameLength_1013, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 16:
            this._name_1215 = suspendResult;
            this._state_1 = 17;
            suspendResult = readBytesExact(this._base1, this._extraLength_1114, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 17:
            this._extra_1316 = suspendResult;
            this._state_1 = 18;
            suspendResult = readSlice(this._base1, this._entry0._compressedSize, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 18:
            this._compressedData_1417 = suspendResult;
            this._tmp0_subject_1518 = this._entry0._compressionMethod;
            if (this._tmp0_subject_1518 === 0) {
              this._WHEN_RESULT19 = this._compressedData_1417;
              this._state_1 = 20;
              continue $sm;
            } else {
              var tmp_3 = this;
              var tmp1_subject_17 = this._entry0._compressionMethod;
              var tmp_4;
              if (tmp1_subject_17 === 8) {
                tmp_4 = this.__this__65._$useNativeDecompression ? _get_Deflate_() : Companion_getInstance_101();
              } else {
                var tmp0_TODO_0_18 = '' + 'Not implemented zip method ' + this._entry0._compressionMethod;
                throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0_18);
              }
              tmp_3._method_1620 = tmp_4;
              this._state_1 = 19;
              suspendResult = uncompressed(this._compressedData_1417, this._method_1620, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 19:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = withLength(ARGUMENT, toLong(this._uncompressedSize_912));
            this._WHEN_RESULT19 = toAsyncStream_0(ARGUMENT_0);
            this._state_1 = 20;
            continue $sm;
          case 20:
            return this._WHEN_RESULT19;
          case 21:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 21) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openCOROUTINE$115.$metadata$ = {
    simpleName: '$openCOROUTINE$115',
    kind: 'class',
    interfaces: []
  };
  function Impl($closeStream, $s, $zipFile, $useNativeDecompression) {
    this._$closeStream = $closeStream;
    this._$s_0 = $s;
    this._$zipFile_0 = $zipFile;
    this._$useNativeDecompression = $useNativeDecompression;
    VfsV2.call(this);
    this._vfs_0 = this;
  }
  Impl.prototype.close_sv8swh_k$ = function ($cont) {
    var tmp = new $closeCOROUTINE$114(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Impl.prototype.open_4jc6oe_k$ = function (path_0, mode, $cont) {
    var tmp = new $openCOROUTINE$115(this, path_0, mode, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Impl.prototype.stat_6wfw3l_k$ = function (path_0, $cont) {
    return toStat(this._$zipFile_0._files.get_2bw_k$(this._$zipFile_0.normalizeName_6wfw3l_k$(path_0)), this.get_6wfw3l_k$(path_0));
  };
  Impl.prototype.listFlow_6wfw3l_k$ = function (path_0, $cont) {
    return flow(_no_name_provided_$factory_138(this._$zipFile_0, path_0, this, null));
  };
  Impl.prototype.toString = function () {
    return '' + 'ZipVfs(' + this._$zipFile_0 + ')';
  };
  Impl.$metadata$ = {
    simpleName: 'Impl',
    kind: 'class',
    interfaces: []
  };
  function $openAsZipCOROUTINE$111(_this_, caseSensitive, useNativeDecompression, callback, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__66 = _this_;
    this._caseSensitive_2 = caseSensitive;
    this._useNativeDecompression = useNativeDecompression;
    this._callback_2 = callback;
  }
  $openAsZipCOROUTINE$111.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            this._state_1 = 1;
            suspendResult = openAsZip_0(this.__this__66, this._caseSensitive_2, this._useNativeDecompression, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._file0 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            this._state_1 = 4;
            suspendResult = this._callback_2(this._file0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$02_0 = suspendResult;
            this._exceptionState = 11;
            this._state_1 = 5;
            var tmp_0 = this;
            continue $sm;
          case 5:
            this._tmp3 = this._tmp$ret$02_0;
            this._state_1 = 6;
            suspendResult = this._file0._vfs.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            return this._tmp3;
          case 7:
            this._state_1 = 8;
            suspendResult = this._file0._vfs.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            return Unit_getInstance();
          case 9:
            this._exceptionState = 11;
            this._t4 = this._exception_0;
            this._state_1 = 10;
            suspendResult = this._file0._vfs.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            throw this._t4;
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openAsZipCOROUTINE$111.$metadata$ = {
    simpleName: '$openAsZipCOROUTINE$111',
    kind: 'class',
    interfaces: []
  };
  function $openAsZipCOROUTINE$112(_this_, caseSensitive, useNativeDecompression, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__67 = _this_;
    this._caseSensitive_3 = caseSensitive;
    this._useNativeDecompression_0 = useNativeDecompression;
  }
  $openAsZipCOROUTINE$112.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__67.open_izlxhr_k$(VfsOpenMode_READ_getInstance(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_13 = suspendResult;
            this._state_1 = 2;
            suspendResult = ZipVfs(this._ARGUMENT0_13, this.__this__67, this._caseSensitive_3, true, this._useNativeDecompression_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openAsZipCOROUTINE$112.$metadata$ = {
    simpleName: '$openAsZipCOROUTINE$112',
    kind: 'class',
    interfaces: []
  };
  function $ZipVfsCOROUTINE$113(s, zipFile, caseSensitive, closeStream, useNativeDecompression, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._s_4 = s;
    this._zipFile = zipFile;
    this._caseSensitive_4 = caseSensitive;
    this._closeStream = closeStream;
    this._useNativeDecompression_1 = useNativeDecompression;
  }
  $ZipVfsCOROUTINE$113.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = Companion_getInstance_106().invoke_u23hy3_k$(this._s_4, this._caseSensitive_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var zipFile = suspendResult;
            return (new Impl(this._closeStream, this._s_4, zipFile, this._useNativeDecompression_1))._get_root__0_k$();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $ZipVfsCOROUTINE$113.$metadata$ = {
    simpleName: '$ZipVfsCOROUTINE$113',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_138($zipFile, $path, this$0, resultContinuation) {
    var i = new _no_name_provided__173($zipFile, $path, this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_8bppsg_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function indexOf_9(_this_, other) {
    var full = _this_;
    var inductionVariable = 0;
    var last_1 = full.length - other.length | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_all_0 = _get_indices_(other);
          var tmp;
          if (isInterface(tmp0_all_0, Collection)) {
            tmp = tmp0_all_0.isEmpty_0_k$();
          } else {
            {
              tmp = false;
            }
          }
          if (tmp) {
            tmp$ret$0 = true;
            break l$ret$1;
          } else {
          }
          var inductionVariable_0 = tmp0_all_0._get_first__0_k$();
          var last_2 = tmp0_all_0._get_last__0_k$();
          if (inductionVariable_0 <= last_2)
            do {
              var element_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (!(full[n + element_2 | 0] === other[element_2])) {
                tmp$ret$0 = false;
                break l$ret$1;
              } else {
              }
            }
             while (!(element_2 === last_2));
          tmp$ret$0 = true;
        }
         while (false);
        if (tmp$ret$0)
          return n;
        else {
        }
      }
       while (inductionVariable < last_1);
    return -1;
  }
  function _get_bytesTempPool_() {
    var tmp0_getValue_0 = bytesTempPool$factory();
    return bytesTempPool$delegate._local.get_0_k$();
  }
  var bytesTempPool$delegate;
  function _get_smallBytesPool_() {
    var tmp0_getValue_0 = smallBytesPool$factory();
    return smallBytesPool$delegate._local.get_0_k$();
  }
  var smallBytesPool$delegate;
  function _no_name_provided__174() {
  }
  _no_name_provided__174.prototype.invoke_ha5a7z_k$ = function (it) {
    return new Int8Array(65536);
  };
  _no_name_provided__174.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__174.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__175() {
  }
  _no_name_provided__175.prototype.invoke_0_k$ = function () {
    return Pool_init_$Create$_0(1, _no_name_provided_$factory_141());
  };
  _no_name_provided__175.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__176() {
  }
  _no_name_provided__176.prototype.invoke_ha5a7z_k$ = function (it) {
    return new Int8Array(16);
  };
  _no_name_provided__176.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__176.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__177() {
  }
  _no_name_provided__177.prototype.invoke_0_k$ = function () {
    return Pool_init_$Create$_0(16, _no_name_provided_$factory_142());
  };
  _no_name_provided__177.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function bytesTempPool$factory() {
    return getPropertyCallableRef('bytesTempPool', 0, KProperty0, function () {
      return _get_bytesTempPool_();
    }, null);
  }
  function smallBytesPool$factory() {
    return getPropertyCallableRef('smallBytesPool', 0, KProperty0, function () {
      return _get_smallBytesPool_();
    }, null);
  }
  function _no_name_provided_$factory_139() {
    var i = new _no_name_provided__175();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_140() {
    var i = new _no_name_provided__177();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_141() {
    var i = new _no_name_provided__174();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_142() {
    var i = new _no_name_provided__176();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  var LATIN1;
  var UTF16_LE;
  var UTF16_BE;
  function ISO_8859_1() {
    ISO_8859_1_instance = this;
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0_1.append_wi8o78_k$(numberToChar(n_4));
        Unit_getInstance();
      }
       while (inductionVariable < 256);
    SingleByteCharset.call(this, 'ISO-8859-1', tmp0_apply_0_1.toString());
  }
  ISO_8859_1.$metadata$ = {
    simpleName: 'ISO_8859_1',
    kind: 'object',
    interfaces: []
  };
  var ISO_8859_1_instance;
  function ISO_8859_1_getInstance() {
    if (ISO_8859_1_instance == null)
      new ISO_8859_1();
    return ISO_8859_1_instance;
  }
  function UTF16Charset(le) {
    Charset.call(this, 'UTF-16-' + (le ? 'LE' : 'BE'));
    this._le = le;
  }
  UTF16Charset.prototype.estimateNumberOfCharactersForBytes_ha5a7z_k$ = function (nbytes) {
    return imul(nbytes, 2);
  };
  UTF16Charset.prototype.estimateNumberOfBytesForCharacters_ha5a7z_k$ = function (nchars) {
    return imul(nchars, 2);
  };
  UTF16Charset.prototype.decode_g45q85_k$ = function (out, src, start, end) {
    var progression = step(until(start, end), 2);
    var inductionVariable = progression._first_0;
    var last_1 = progression._last;
    var step_0 = progression._step_2;
    if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var char = numberToChar(readS16(src, n, this._le));
        out.append_wi8o78_k$(char);
        Unit_getInstance();
      }
       while (!(n === last_1));
  };
  UTF16Charset.prototype.encode_kaapbp_k$ = function (out, src, start, end) {
    var temp_0 = new Int8Array(2);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__get_code__0 = charSequenceGet(src, n);
        write16(temp_0, 0, tmp0__get_code__0.toInt_0_k$(), this._le);
        out.append$default_ffc7am_k$(temp_0, 0, 0, 6, null);
      }
       while (inductionVariable < end);
  };
  UTF16Charset.$metadata$ = {
    simpleName: 'UTF16Charset',
    kind: 'class',
    interfaces: []
  };
  function SingleByteCharset(name, conv) {
    BaseSingleByteCharset.call(this, name);
    this._conv = conv;
    var tmp = this;
    var tmp0_apply_0 = IntIntMap_init_$Create$(0, 0.0, 3, null);
    var inductionVariable = 0;
    var last_1 = this._conv.length;
    if (inductionVariable < last_1)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__get_code__0_4 = charSequenceGet(this._conv, n_3);
        tmp0_apply_0.set_27zxwg_k$(tmp0__get_code__0_4.toInt_0_k$(), n_3);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp._v_2 = tmp0_apply_0;
  }
  SingleByteCharset.prototype.encode_kaapbp_k$ = function (out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__get_code__0 = charSequenceGet(src, n);
        var c = tmp0__get_code__0.toInt_0_k$();
        var tmp1_append_0 = this._v_2.contains_ha5a7z_k$(c) ? toByte(this._v_2.get_ha5a7z_k$(c)) : 63;
        out.appendFast_hpsj51_k$(tmp1_append_0);
        Unit_getInstance();
      }
       while (inductionVariable < end);
  };
  SingleByteCharset.prototype.decode_g45q85_k$ = function (out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.append_wi8o78_k$(charSequenceGet(this._conv, src[n] & 255));
        Unit_getInstance();
      }
       while (inductionVariable < end);
  };
  SingleByteCharset.$metadata$ = {
    simpleName: 'SingleByteCharset',
    kind: 'class',
    interfaces: []
  };
  function Companion_111() {
    Companion_instance_110 = this;
  }
  Companion_111.prototype.appendCodePointV_ip6ytn_k$ = function (_this__0, codePoint) {
    if ((55296 <= codePoint ? codePoint <= 57343 : false) ? true : codePoint > 65535) {
      var U0 = codePoint - 65536 | 0;
      var hs = extract(U0, 10, 10);
      var ls = extract(U0, 0, 10);
      _this__0.append_wi8o78_k$(numberToChar(55296 | hs));
      Unit_getInstance();
      _this__0.append_wi8o78_k$(numberToChar(56320 | ls));
      Unit_getInstance();
    } else {
      _this__0.append_wi8o78_k$(numberToChar(codePoint));
      Unit_getInstance();
    }
  };
  Companion_111.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_110;
  function Companion_getInstance_110() {
    if (Companion_instance_110 == null)
      new Companion_111();
    return Companion_instance_110;
  }
  function Charset(name) {
    Companion_getInstance_110();
    this._name_6 = name;
  }
  Charset.prototype.estimateNumberOfCharactersForBytes_ha5a7z_k$ = function (nbytes) {
    return imul(nbytes, 2);
  };
  Charset.prototype.estimateNumberOfBytesForCharacters_ha5a7z_k$ = function (nchars) {
    return imul(nchars, 2);
  };
  Charset.$metadata$ = {
    simpleName: 'Charset',
    kind: 'class',
    interfaces: []
  };
  function BaseSingleByteCharset(name) {
    Charset.call(this, name);
  }
  BaseSingleByteCharset.prototype.estimateNumberOfCharactersForBytes_ha5a7z_k$ = function (nbytes) {
    return nbytes;
  };
  BaseSingleByteCharset.prototype.estimateNumberOfBytesForCharacters_ha5a7z_k$ = function (nchars) {
    return nchars;
  };
  BaseSingleByteCharset.$metadata$ = {
    simpleName: 'BaseSingleByteCharset',
    kind: 'class',
    interfaces: []
  };
  function toString_3(_this_, charset, start, end) {
    var out = StringBuilder_init_$Create$(charset.estimateNumberOfCharactersForBytes_ha5a7z_k$(end - start | 0));
    charset.decode_g45q85_k$(out, _this_, start, end);
    return out.toString();
  }
  function toString$default(_this_, charset, start, end, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      start = 0;
    if (!(($mask0 & 4) === 0))
      end = _this_.length;
    return toString_3(_this_, charset, start, end);
  }
  function toByteArray(_this_, charset, start, end) {
    var out = ByteArrayBuilder_init_$Create$_0(charset.estimateNumberOfBytesForCharacters_ha5a7z_k$(end - start | 0));
    charset.encode_kaapbp_k$(out, _this_, start, end);
    return out.toByteArray_0_k$();
  }
  function toByteArray$default(_this_, charset, start, end, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      charset = UTF8;
    if (!(($mask0 & 2) === 0))
      start = 0;
    if (!(($mask0 & 4) === 0))
      end = _this_.length;
    return toByteArray(_this_, charset, start, end);
  }
  function createByte($this, codePoint, shift) {
    return codePoint >> shift & 63 | 128;
  }
  function UTC8CharsetBase(name) {
    Charset.call(this, name);
  }
  UTC8CharsetBase.prototype.estimateNumberOfCharactersForBytes_ha5a7z_k$ = function (nbytes) {
    return imul(nbytes, 2);
  };
  UTC8CharsetBase.prototype.estimateNumberOfBytesForCharacters_ha5a7z_k$ = function (nchars) {
    return imul(nchars, 2);
  };
  UTC8CharsetBase.prototype.encode_kaapbp_k$ = function (out, src, start, end) {
    var tmp0_decodeCodePoints_0 = Companion_getInstance_110();
    var highSurrogate_1 = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      loop: do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var char_4 = charSequenceGet(src, n_3).toInt_0_k$();
        var tmp;
        if (55296 <= char_4 ? char_4 <= 57343 : false) {
          var tmp1_subject_6 = extract(char_4, 10, 6);
          var tmp_0;
          switch (tmp1_subject_6) {
            case 54:
              highSurrogate_1 = char_4 & 1023;
              continue loop;
            case 55:
              tmp_0 = 65536 + (highSurrogate_1 << 10 | char_4 & 1023) | 0;
              break;
            default:var tmp0_error_0_7 = '' + 'Unknown ' + char_4;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_7));
          }
          tmp = tmp_0;
        } else {
          tmp = char_4;
        }
        var codePoint_5 = tmp;
        if ((codePoint_5 & -128) === 0) {
          var tmp0_append_0_9 = toByte(codePoint_5);
          out.appendFast_hpsj51_k$(tmp0_append_0_9);
          Unit_getInstance();
        } else {
          if ((codePoint_5 & -2048) === 0) {
            var tmp1_append_0_10 = toByte(codePoint_5 >> 6 & 31 | 192);
            out.appendFast_hpsj51_k$(tmp1_append_0_10);
            Unit_getInstance();
          } else if ((codePoint_5 & -65536) === 0) {
            var tmp2_append_0_11 = toByte(codePoint_5 >> 12 & 15 | 224);
            out.appendFast_hpsj51_k$(tmp2_append_0_11);
            Unit_getInstance();
            var tmp3_append_0_12 = toByte(createByte(this, codePoint_5, 6));
            out.appendFast_hpsj51_k$(tmp3_append_0_12);
            Unit_getInstance();
          } else if ((codePoint_5 & -2097152) === 0) {
            var tmp4_append_0_13 = toByte(codePoint_5 >> 18 & 7 | 240);
            out.appendFast_hpsj51_k$(tmp4_append_0_13);
            Unit_getInstance();
            var tmp5_append_0_14 = toByte(createByte(this, codePoint_5, 12));
            out.appendFast_hpsj51_k$(tmp5_append_0_14);
            Unit_getInstance();
            var tmp6_append_0_15 = toByte(createByte(this, codePoint_5, 6));
            out.appendFast_hpsj51_k$(tmp6_append_0_15);
            Unit_getInstance();
          }var tmp7_append_0_16 = toByte(codePoint_5 & 63 | 128);
          out.appendFast_hpsj51_k$(tmp7_append_0_16);
          Unit_getInstance();
        }
      }
       while (inductionVariable < end);
  };
  UTC8CharsetBase.prototype.decode_g45q85_k$ = function (out, src, start, end) {
    if ((start < 0 ? true : start > src.length) ? true : end < 0 ? true : end > src.length) {
      throw IllegalStateException_init_$Create$_0('Out of bounds');
    }var i = start;
    while (i < end) {
      var c = src[i] & 255;
      var tmp0_subject = c >> 4;
      if (0 <= tmp0_subject ? tmp0_subject <= 7 : false) {
        Companion_getInstance_110().appendCodePointV_ip6ytn_k$(out, c);
        i = i + 1 | 0;
      } else if (12 <= tmp0_subject ? tmp0_subject <= 13 : false) {
        Companion_getInstance_110().appendCodePointV_ip6ytn_k$(out, (c & 31) << 6 | src[i + 1 | 0] & 63);
        i = i + 2 | 0;
      } else if (tmp0_subject === 14) {
        Companion_getInstance_110().appendCodePointV_ip6ytn_k$(out, (c & 15) << 12 | (src[i + 1 | 0] & 63) << 6 | src[i + 2 | 0] & 63);
        i = i + 3 | 0;
      } else if (tmp0_subject === 15) {
        Companion_getInstance_110().appendCodePointV_ip6ytn_k$(out, insert(insert(insert(insert(0, extract(src[i + 0 | 0], 0, 3), 18, 3), extract(src[i + 1 | 0], 0, 6), 12, 6), extract(src[i + 2 | 0], 0, 6), 6, 6), extract(src[i + 3 | 0], 0, 6), 0, 6));
        i = i + 4 | 0;
      } else {
        out.append_wi8o78_k$(new Char(65533));
        Unit_getInstance();
        i = i + 1 | 0;
      }
    }
  };
  UTC8CharsetBase.$metadata$ = {
    simpleName: 'UTC8CharsetBase',
    kind: 'class',
    interfaces: []
  };
  function ASCII() {
    ASCII_instance = this;
    BaseSingleByteCharset.call(this, 'ASCII');
  }
  ASCII.prototype.encode_kaapbp_k$ = function (out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_append_0 = charSequenceGet(src, n).toByte_0_k$();
        out.appendFast_hpsj51_k$(tmp0_append_0);
        Unit_getInstance();
      }
       while (inductionVariable < end);
  };
  ASCII.prototype.decode_g45q85_k$ = function (out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.append_wi8o78_k$(numberToChar(src[n]));
        Unit_getInstance();
      }
       while (inductionVariable < end);
  };
  ASCII.$metadata$ = {
    simpleName: 'ASCII',
    kind: 'object',
    interfaces: []
  };
  var ASCII_instance;
  function ASCII_getInstance() {
    if (ASCII_instance == null)
      new ASCII();
    return ASCII_instance;
  }
  function Charsets() {
    Charsets_instance = this;
  }
  Charsets.prototype._get_LATIN1__0_k$ = function () {
    return LATIN1;
  };
  Charsets.$metadata$ = {
    simpleName: 'Charsets',
    kind: 'object',
    interfaces: []
  };
  var Charsets_instance;
  function Charsets_getInstance() {
    if (Charsets_instance == null)
      new Charsets();
    return Charsets_instance;
  }
  function _no_name_provided__178($callback) {
    this._$callback_1 = $callback;
  }
  _no_name_provided__178.prototype.close_sv8swh_k$ = function () {
    return this._$callback_1();
  };
  _no_name_provided__178.$metadata$ = {
    kind: 'class',
    interfaces: [Closeable]
  };
  function Companion_112() {
    Companion_instance_111 = this;
  }
  Companion_112.prototype.invoke_qgl0n5_k$ = function (callback) {
    return new _no_name_provided__178(callback);
  };
  Companion_112.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_111;
  function Companion_getInstance_111() {
    if (Companion_instance_111 == null)
      new Companion_112();
    return Companion_instance_111;
  }
  function Closeable() {
  }
  Closeable.$metadata$ = {
    simpleName: 'Closeable',
    kind: 'interface',
    interfaces: []
  };
  function OptionalCloseable() {
  }
  OptionalCloseable.$metadata$ = {
    simpleName: 'OptionalCloseable',
    kind: 'interface',
    interfaces: [Closeable]
  };
  function Disposable() {
  }
  Disposable.$metadata$ = {
    simpleName: 'Disposable',
    kind: 'interface',
    interfaces: []
  };
  function Cancellable() {
  }
  Cancellable.$metadata$ = {
    simpleName: 'Cancellable',
    kind: 'interface',
    interfaces: []
  };
  function cancel_0(_this_) {
    return _this_.cancel_1ti8hr_k$(CancellationException_init_$Create$(''));
  }
  function cancel_1(_this_, e) {
    var tmp0_iterator_2 = _this_.iterator_0_k$();
    while (tmp0_iterator_2.hasNext_0_k$()) {
      var c_3 = tmp0_iterator_2.next_0_k$();
      c_3.cancel_1ti8hr_k$(e);
    }
    return Unit_getInstance();
  }
  var customEnvironments;
  function Companion_113() {
    Companion_instance_112 = this;
  }
  Companion_113.prototype.get_6wfw3l_k$ = function (key) {
    var tmp0_safe_receiver = customEnvironments;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_2bw_k$(key);
    return tmp1_elvis_lhs == null ? EnvironmentInternal_getInstance().get_6wfw3l_k$(key) : tmp1_elvis_lhs;
  };
  Companion_113.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: [Environment]
  };
  var Companion_instance_112;
  function Companion_getInstance_112() {
    if (Companion_instance_112 == null)
      new Companion_113();
    return Companion_instance_112;
  }
  function Environment() {
  }
  Environment.$metadata$ = {
    simpleName: 'Environment',
    kind: 'interface',
    interfaces: []
  };
  function unsupported_0() {
    throw UnsupportedOperationException_init_$Create$_0('unsupported');
  }
  function invalidOp(msg) {
    throw new InvalidOperationException(msg);
  }
  function InvalidOperationException_init_$Init$(str, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      str = 'Invalid Operation';
    InvalidOperationException.call($this, str);
    return $this;
  }
  function InvalidOperationException_init_$Create$(str, $mask0, $marker) {
    var tmp = InvalidOperationException_init_$Init$(str, $mask0, $marker, Object.create(InvalidOperationException.prototype));
    captureStack(tmp, InvalidOperationException_init_$Create$);
    return tmp;
  }
  function InvalidOperationException(str) {
    Exception_init_$Init$_0(str, this);
    captureStack(this, InvalidOperationException);
  }
  InvalidOperationException.$metadata$ = {
    simpleName: 'InvalidOperationException',
    kind: 'class',
    interfaces: []
  };
  function _get_invalidOp_() {
    throw InvalidOperationException_init_$Create$(null, 1, null);
  }
  function unsupported_1(msg) {
    throw UnsupportedOperationException_init_$Create$_0(msg);
  }
  var formatRegex;
  var replaceNonPrintableCharactersRegex$delegate;
  function substr_0(_this_, start, length) {
    var low = clamp_2(start >= 0 ? start : _this_.length + start | 0, 0, _this_.length);
    var high = clamp_2(length >= 0 ? low + length | 0 : _this_.length + length | 0, 0, _this_.length);
    var tmp;
    if (high >= low) {
      tmp = _this_.substring(low, high);
    } else {
      tmp = '';
    }
    return tmp;
  }
  function String_fromCharArray(arrays, offset_0, size_2) {
    return concatToString(arrays, offset_0, offset_0 + size_2 | 0);
  }
  function lastIndexOfOrNull(_this_, char, startIndex) {
    var tmp0_takeIf_0 = lastIndexOf$default(_this_, char, startIndex, false, 4, null);
    var tmp;
    if (tmp0_takeIf_0 >= 0) {
      tmp = tmp0_takeIf_0;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function lastIndexOfOrNull$default(_this_, char, startIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__5(_this_);
    return lastIndexOfOrNull(_this_, char, startIndex);
  }
  function substr_1(_this_, start) {
    return substr_0(_this_, start, _this_.length);
  }
  function _no_name_provided__179() {
  }
  _no_name_provided__179.prototype.invoke_0_k$ = function () {
    return Regex_init_$Create$('[^ -~]');
  };
  _no_name_provided__179.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_143() {
    var i = new _no_name_provided__179();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided__180(this$0) {
    this._this$0_50 = this$0;
    NativeThreadLocal.call(this);
  }
  _no_name_provided__180.prototype.initialValue_0_k$ = function () {
    return this._this$0_50._gen_0();
  };
  _no_name_provided__180.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function threadLocal(gen) {
    this._gen_0 = gen;
    var tmp = this;
    tmp._local = new _no_name_provided__180(this);
  }
  threadLocal.$metadata$ = {
    simpleName: 'threadLocal',
    kind: 'class',
    interfaces: []
  };
  function AsyncSocketFactory() {
  }
  AsyncSocketFactory.$metadata$ = {
    simpleName: 'AsyncSocketFactory',
    kind: 'class',
    interfaces: []
  };
  var MimeType_byExtensions$delegate;
  function _no_name_provided__181() {
  }
  _no_name_provided__181.prototype.invoke_0_k$ = function () {
    return LinkedHashMap_init_$Create$();
  };
  _no_name_provided__181.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_144() {
    var i = new _no_name_provided__181();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function QueryString() {
    QueryString_instance = this;
  }
  QueryString.prototype.decode_3ajhph_k$ = function (str) {
    var out = LinkedHashMap_init_$Create$();
    var tmp = charArrayOf([new Char(38)]);
    var tmp0_fastForEach_0 = split$default(str, tmp, false, 0, 6, null);
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      var tmp_0 = charArrayOf([new Char(61)]);
      var parts_4 = split$default(tmp1__anonymous__3, tmp_0, false, 2, 2, null);
      var key_5 = Companion_getInstance_113().decodeComponent_1d8j4y_k$(parts_4.get_ha5a7z_k$(0), UTF8, true);
      var tmp_1 = Companion_getInstance_113();
      var tmp_2;
      if (1 <= _get_lastIndex__4(parts_4)) {
        tmp_2 = parts_4.get_ha5a7z_k$(1);
      } else {
        tmp_2 = key_5;
      }
      var value_6 = tmp_1.decodeComponent_1d8j4y_k$(tmp_2, UTF8, true);
      var value_1_8 = out.get_2bw_k$(key_5);
      var tmp_3;
      if (value_1_8 == null) {
        var answer_2_9 = ArrayList_init_$Create$();
        out.put_1q9pf_k$(key_5, answer_2_9);
        Unit_getInstance();
        tmp_3 = answer_2_9;
      } else {
        tmp_3 = value_1_8;
      }
      var list_7 = tmp_3;
      list_7.add_2bq_k$(value_6);
      Unit_getInstance();
    }
    return out;
  };
  QueryString.$metadata$ = {
    simpleName: 'QueryString',
    kind: 'object',
    interfaces: []
  };
  var QueryString_instance;
  function QueryString_getInstance() {
    if (QueryString_instance == null)
      new QueryString();
    return QueryString_instance;
  }
  function Companion_114() {
    Companion_instance_113 = this;
    this._DEFAULT_PORT = 0;
    this._schemeRegex = Regex_init_$Create$('\\w+:');
  }
  Companion_114.prototype.defaultPortForScheme_uch40_k$ = function (scheme) {
    var tmp0_subject = scheme;
    switch (tmp0_subject) {
      case 'ftp':
        return 21;
      case 'ftps':
        return 990;
      case 'http':
      case 'ws':
        return 80;
      case 'https':
      case 'wss':
        return 443;
      default:return -1;
    }
  };
  Companion_114.prototype.invoke_u5s38a_k$ = function (scheme, userInfo, host, path_0, query, fragment, opaque, port) {
    return new URL_0(opaque, scheme, userInfo, host, path_0, query, fragment, port);
  };
  Companion_114.prototype.invoke$default_bj3nqc_k$ = function (scheme, userInfo, host, path_0, query, fragment, opaque, port, $mask0, $handler) {
    if (!(($mask0 & 64) === 0))
      opaque = false;
    if (!(($mask0 & 128) === 0))
      port = this._DEFAULT_PORT;
    return this.invoke_u5s38a_k$(scheme, userInfo, host, path_0, query, fragment, opaque, port);
  };
  Companion_114.prototype.invoke_6wfw3l_k$ = function (url) {
    var r = StrReader_init_$Create$(url, null, 0, 6, null);
    var schemeColon = r.tryRegex_x1socs_k$(this._schemeRegex);
    var tmp;
    if (!(schemeColon == null)) {
      var isHierarchical = !(r.tryLit_6wfw3l_k$('//') == null);
      var nonScheme = r.readRemaining_0_k$();
      var scheme = dropLast(schemeColon, 1);
      var tmp_0 = new Char(35);
      var nonFragment = substringBefore$default(nonScheme, tmp_0, null, 2, null);
      var fragment = substringAfterOrNull(nonScheme, new Char(35));
      var tmp_1 = new Char(63);
      var nonQuery = substringBefore$default(nonFragment, tmp_1, null, 2, null);
      var query = substringAfterOrNull(nonFragment, new Char(63));
      var tmp_2 = new Char(47);
      var authority = substringBefore$default(nonQuery, tmp_2, null, 2, null);
      var path_0 = substringAfterOrNull(nonQuery, new Char(47));
      var tmp_3 = new Char(64);
      var hostWithPort = substringAfter$default(authority, tmp_3, null, 2, null);
      var userInfo = substringBeforeOrNull(authority, new Char(64));
      var tmp_4 = new Char(58);
      var host = substringBefore$default(hostWithPort, tmp_4, null, 2, null);
      var port = substringAfterOrNull(hostWithPort, new Char(58));
      var tmp2_opaque = !isHierarchical;
      var tmp_5;
      if (charSequenceLength(host) > 0) {
        tmp_5 = host;
      } else {
        {
          tmp_5 = null;
        }
      }
      var tmp3_host = tmp_5;
      var tmp4_path = !(path_0 == null) ? '' + '/' + path_0 : '';
      var tmp0_safe_receiver = port;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
      var tmp5_port = tmp1_elvis_lhs == null ? this._DEFAULT_PORT : tmp1_elvis_lhs;
      tmp = Companion_getInstance_113().invoke_u5s38a_k$(scheme, userInfo, tmp3_host, tmp4_path, query, fragment, tmp2_opaque, tmp5_port);
    } else {
      var tmp_6 = new Char(35);
      var nonFragment_0 = substringBefore$default(url, tmp_6, null, 2, null);
      var fragment_0 = substringAfterOrNull(url, new Char(35));
      var tmp_7 = new Char(63);
      var path_1 = substringBefore$default(nonFragment_0, tmp_7, null, 2, null);
      var query_0 = substringAfterOrNull(nonFragment_0, new Char(63));
      var tmp_8 = Companion_getInstance_113();
      tmp = tmp_8.invoke$default_bj3nqc_k$(null, null, null, path_1, query_0, fragment_0, false, 0, 128, null);
    }
    return tmp;
  };
  Companion_114.prototype.isAbsolute_6wfw3l_k$ = function (url) {
    return !(StrReader_init_$Create$(url, null, 0, 6, null).tryRegex_x1socs_k$(this._schemeRegex) == null);
  };
  Companion_114.prototype.resolve_jg38oy_k$ = function (base, access) {
    var tmp;
    if (this.isAbsolute_6wfw3l_k$(access)) {
      tmp = access;
    } else {
      if (startsWith$default_1(access, '/', false, 2, null)) {
        var tmp_0 = Companion_getInstance_113().invoke_6wfw3l_k$(base);
        tmp = tmp_0.copy$default_2za93v_k$(false, null, null, null, access, null, null, 0, 239, null)._get_fullUrl__0_k$();
      } else {
        {
          var tmp0_run_0 = Companion_getInstance_113().invoke_6wfw3l_k$(base);
          var tmp_1 = new Char(47);
          var tmp_2 = '' + '/' + trimStart(normalize(_get_pathInfo_('' + substringBeforeLast$default(tmp0_run_0._path_16, tmp_1, null, 2, null) + '/' + access)), charArrayOf([new Char(47)]));
          tmp = tmp0_run_0.copy$default_2za93v_k$(false, null, null, null, tmp_2, null, null, 0, 239, null)._get_fullUrl__0_k$();
        }
      }
    }
    return tmp;
  };
  Companion_114.prototype.decodeComponent_1d8j4y_k$ = function (s, charset, formUrlEncoded) {
    var bos = ByteArrayBuilder_init_$Create$_1(0, 1, null);
    var len = s.length;
    var n = 0;
    while (n < len) {
      var c = charSequenceGet(s, n);
      var tmp0_subject = c;
      if (tmp0_subject.equals(new Char(37))) {
        var tmp0_append_0 = toByte(toInt_0(substr_0(s, n + 1 | 0, 2), 16));
        bos.appendFast_hpsj51_k$(tmp0_append_0);
        Unit_getInstance();
        n = n + 2 | 0;
      } else if (tmp0_subject.equals(new Char(43)))
        if (formUrlEncoded) {
          var tmp1_append_0 = 32;
          bos.appendFast_hpsj51_k$(tmp1_append_0);
          Unit_getInstance();
        } else {
          var tmp2_append_0 = 43;
          bos.appendFast_hpsj51_k$(tmp2_append_0);
          Unit_getInstance();
        }
       else {
        var tmp3_append_0 = c.toByte_0_k$();
        bos.appendFast_hpsj51_k$(tmp3_append_0);
        Unit_getInstance();
      }
      var tmp1 = n;
      n = tmp1 + 1 | 0;
      Unit_getInstance();
    }
    var tmp = bos.toByteArray_0_k$();
    return toString$default(tmp, charset, 0, 0, 6, null);
  };
  Companion_114.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_113;
  function Companion_getInstance_113() {
    if (Companion_instance_113 == null)
      new Companion_114();
    return Companion_instance_113;
  }
  function _no_name_provided__182(this$0) {
    this._this$0_51 = this$0;
  }
  _no_name_provided__182.prototype.invoke_0_k$ = function () {
    return this._this$0_51.toUrlString$default_29kf1o_k$(false, null, 3, null).toString();
  };
  _no_name_provided__182.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__183(this$0) {
    this._this$0_52 = this$0;
  }
  _no_name_provided__183.prototype.invoke_0_k$ = function () {
    return this._this$0_52.toUrlString$default_29kf1o_k$(false, null, 2, null).toString();
  };
  _no_name_provided__183.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__184(this$0) {
    this._this$0_53 = this$0;
  }
  _no_name_provided__184.prototype.invoke_0_k$ = function () {
    var tmp;
    if (!(this._this$0_53._query == null)) {
      tmp = '' + this._this$0_53._path_16 + '?' + this._this$0_53._query;
    } else {
      tmp = this._this$0_53._path_16;
    }
    return tmp;
  };
  _no_name_provided__184.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function URL_0(isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort) {
    Companion_getInstance_113();
    this._isOpaque = isOpaque;
    this._scheme = scheme;
    this._userInfo = userInfo;
    this._host = host;
    this._path_16 = path_0;
    this._query = query;
    this._fragment = fragment;
    this._defaultPort = defaultPort;
    var tmp = this;
    tmp._fullUrl$delegate = lazy(_no_name_provided_$factory_145(this));
    var tmp_0 = this;
    tmp_0._fullUrlWithoutScheme$delegate = lazy(_no_name_provided_$factory_146(this));
    var tmp_1 = this;
    tmp_1._pathWithQuery$delegate = lazy(_no_name_provided_$factory_147(this));
  }
  URL_0.prototype._get_defaultSchemePort__0_k$ = function () {
    return Companion_getInstance_113().defaultPortForScheme_uch40_k$(this._scheme);
  };
  URL_0.prototype._get_port__0_k$ = function () {
    return this._defaultPort === Companion_getInstance_113()._DEFAULT_PORT ? this._get_defaultSchemePort__0_k$() : this._defaultPort;
  };
  URL_0.prototype._get_fullUrl__0_k$ = function () {
    var tmp0_getValue_0 = fullUrl$factory();
    return this._fullUrl$delegate._get_value__0_k$();
  };
  URL_0.prototype.toUrlString_v57vch_k$ = function (includeScheme, out) {
    if (includeScheme ? !(this._scheme == null) : false) {
      out.append_uch40_k$('' + this._scheme + ':');
      Unit_getInstance();
      if (!this._isOpaque) {
        out.append_uch40_k$('//');
        Unit_getInstance();
      }}if (!(this._userInfo == null)) {
      out.append_uch40_k$('' + this._userInfo + '@');
      Unit_getInstance();
    }if (!(this._host == null)) {
      out.append_uch40_k$(this._host);
      Unit_getInstance();
    }if (!(this._get_port__0_k$() === Companion_getInstance_113()._DEFAULT_PORT) ? !(this._get_port__0_k$() === this._get_defaultSchemePort__0_k$()) : false) {
      out.append_wi8o78_k$(new Char(58)).append_wi7j7l_k$(this._get_port__0_k$());
      Unit_getInstance();
    }out.append_uch40_k$(this._path_16);
    Unit_getInstance();
    if (!(this._query == null)) {
      out.append_uch40_k$('' + '?' + this._query);
      Unit_getInstance();
    }if (!(this._fragment == null)) {
      out.append_uch40_k$('' + '#' + this._fragment);
      Unit_getInstance();
    }return out;
  };
  URL_0.prototype.toUrlString$default_29kf1o_k$ = function (includeScheme, out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      includeScheme = true;
    if (!(($mask0 & 2) === 0))
      out = StringBuilder_init_$Create$_0();
    return this.toUrlString_v57vch_k$(includeScheme, out);
  };
  URL_0.prototype.toString = function () {
    return this._get_fullUrl__0_k$();
  };
  URL_0.prototype.copy_r02uik_k$ = function (isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort) {
    return new URL_0(isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort);
  };
  URL_0.prototype.copy$default_2za93v_k$ = function (isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      isOpaque = this._isOpaque;
    if (!(($mask0 & 2) === 0))
      scheme = this._scheme;
    if (!(($mask0 & 4) === 0))
      userInfo = this._userInfo;
    if (!(($mask0 & 8) === 0))
      host = this._host;
    if (!(($mask0 & 16) === 0))
      path_0 = this._path_16;
    if (!(($mask0 & 32) === 0))
      query = this._query;
    if (!(($mask0 & 64) === 0))
      fragment = this._fragment;
    if (!(($mask0 & 128) === 0))
      defaultPort = this._defaultPort;
    return this.copy_r02uik_k$(isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort);
  };
  URL_0.prototype.hashCode = function () {
    var result = this._isOpaque | 0;
    result = imul(result, 31) + (this._scheme == null ? 0 : getStringHashCode(this._scheme)) | 0;
    result = imul(result, 31) + (this._userInfo == null ? 0 : getStringHashCode(this._userInfo)) | 0;
    result = imul(result, 31) + (this._host == null ? 0 : getStringHashCode(this._host)) | 0;
    result = imul(result, 31) + getStringHashCode(this._path_16) | 0;
    result = imul(result, 31) + (this._query == null ? 0 : getStringHashCode(this._query)) | 0;
    result = imul(result, 31) + (this._fragment == null ? 0 : getStringHashCode(this._fragment)) | 0;
    result = imul(result, 31) + this._defaultPort | 0;
    return result;
  };
  URL_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof URL_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof URL_0 ? other : THROW_CCE();
    if (!(this._isOpaque === tmp0_other_with_cast._isOpaque))
      return false;
    if (!(this._scheme == tmp0_other_with_cast._scheme))
      return false;
    if (!(this._userInfo == tmp0_other_with_cast._userInfo))
      return false;
    if (!(this._host == tmp0_other_with_cast._host))
      return false;
    if (!(this._path_16 === tmp0_other_with_cast._path_16))
      return false;
    if (!(this._query == tmp0_other_with_cast._query))
      return false;
    if (!(this._fragment == tmp0_other_with_cast._fragment))
      return false;
    if (!(this._defaultPort === tmp0_other_with_cast._defaultPort))
      return false;
    return true;
  };
  URL_0.$metadata$ = {
    simpleName: 'URL',
    kind: 'class',
    interfaces: []
  };
  function fullUrl$factory() {
    return getPropertyCallableRef('fullUrl', 1, KProperty1, function (receiver) {
      return receiver._get_fullUrl__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_145(this$0) {
    var i = new _no_name_provided__182(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_146(this$0) {
    var i = new _no_name_provided__183(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_147(this$0) {
    var i = new _no_name_provided__184(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  var Methods_ALL_instance;
  var Methods_OPTIONS_instance;
  var Methods_GET_instance;
  var Methods_HEAD_instance;
  var Methods_POST_instance;
  var Methods_PUT_instance;
  var Methods_DELETE_instance;
  var Methods_TRACE_instance;
  var Methods_CONNECT_instance;
  var Methods_PATCH_instance;
  var Methods_entriesInitialized;
  function Methods_initEntries() {
    if (Methods_entriesInitialized)
      return Unit_getInstance();
    Methods_entriesInitialized = true;
    Methods_ALL_instance = new Methods('ALL', 0);
    Methods_OPTIONS_instance = new Methods('OPTIONS', 1);
    Methods_GET_instance = new Methods('GET', 2);
    Methods_HEAD_instance = new Methods('HEAD', 3);
    Methods_POST_instance = new Methods('POST', 4);
    Methods_PUT_instance = new Methods('PUT', 5);
    Methods_DELETE_instance = new Methods('DELETE', 6);
    Methods_TRACE_instance = new Methods('TRACE', 7);
    Methods_CONNECT_instance = new Methods('CONNECT', 8);
    Methods_PATCH_instance = new Methods('PATCH', 9);
  }
  function Companion_115() {
    Companion_instance_114 = this;
    this._OPTIONS = Methods_OPTIONS_getInstance();
    this._GET = Methods_GET_getInstance();
    this._HEAD = Methods_HEAD_getInstance();
    this._POST = Methods_POST_getInstance();
    this._PUT = Methods_PUT_getInstance();
    this._DELETE = Methods_DELETE_getInstance();
    this._TRACE = Methods_TRACE_getInstance();
    this._CONNECT = Methods_CONNECT_getInstance();
    this._PATCH = Methods_PATCH_getInstance();
    this.__values_3 = listOf([this._OPTIONS, this._GET, this._HEAD, this._POST, this._PUT, this._DELETE, this._TRACE, this._CONNECT, this._PATCH]);
    var tmp = this;
    var tmp0_map_0 = this.__values_3;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(to(item_2_3._get_name__0_k$(), item_2_3));
      Unit_getInstance();
    }
    tmp._valuesMap = toMap_0(tmp0_mapTo_0_1);
  }
  Companion_115.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_114;
  function Companion_getInstance_114() {
    if (Companion_instance_114 == null)
      new Companion_115();
    return Companion_instance_114;
  }
  function HttpException_init_$Init$(statusCode, msg, statusText, headers, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      msg = '' + 'Error' + statusCode;
    if (!(($mask0 & 4) === 0)) {
      var tmp0_elvis_lhs = HttpStatusMessage_getInstance()._CODES_0.get_2bw_k$(statusCode);
      statusText = tmp0_elvis_lhs == null ? '' + 'Error' + statusCode : tmp0_elvis_lhs;
    }if (!(($mask0 & 8) === 0))
      headers = Headers_init_$Create$([]);
    HttpException.call($this, statusCode, msg, statusText, headers);
    return $this;
  }
  function HttpException_init_$Create$(statusCode, msg, statusText, headers, $mask0, $marker) {
    var tmp = HttpException_init_$Init$(statusCode, msg, statusText, headers, $mask0, $marker, Object.create(HttpException.prototype));
    captureStack(tmp, HttpException_init_$Create$);
    return tmp;
  }
  function Companion_116() {
    Companion_instance_115 = this;
  }
  Companion_116.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_115;
  function Companion_getInstance_115() {
    if (Companion_instance_115 == null)
      new Companion_116();
    return Companion_instance_115;
  }
  function Headers_init_$Init$(items, $this) {
    Headers_0.call($this, toList(items));
    return $this;
  }
  function Headers_init_$Create$(items) {
    return Headers_init_$Init$(items, Object.create(Headers_0.prototype));
  }
  function Headers_init_$Init$_0(map_0, $this) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(map_0._get_size__0_k$());
    var tmp0_iterator_1_2 = map_0._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(to(item_2_3._get_key__0_k$(), item_2_3._get_value__0_k$()));
      Unit_getInstance();
    }
    Headers_0.call($this, tmp0_mapTo_0_1);
    return $this;
  }
  function Headers_init_$Create$_0(map_0) {
    return Headers_init_$Init$_0(map_0, Object.create(Headers_0.prototype));
  }
  function Headers_init_$Init$_1(str, $this) {
    Headers_0.call($this, Companion_getInstance_116().parse_uch40_k$(str)._items_3);
    return $this;
  }
  function Headers_init_$Create$_1(str) {
    return Headers_init_$Init$_1(str, Object.create(Headers_0.prototype));
  }
  function Companion_117() {
    Companion_instance_116 = this;
    this._ContentLength = 'Content-Length';
    this._ContentType = 'Content-Type';
  }
  Companion_117.prototype.parse_uch40_k$ = function (str) {
    if (str == null)
      return Headers_init_$Create$([]);
    var tmp0_map_0 = split$default_0(str, ['\n'], false, 0, 6, null);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp = toString_1(trim_0(isCharSequence(item_2_3) ? item_2_3 : THROW_CCE()));
      var tmp_0 = charArrayOf([new Char(58)]);
      var parts_5 = split$default(tmp, tmp_0, false, 2, 2, null);
      var tmp_1;
      if (parts_5._get_size__0_k$() >= 2) {
        var tmp0_trim_0_6 = parts_5.get_ha5a7z_k$(0);
        var tmp_2 = toString_1(trim_0(isCharSequence(tmp0_trim_0_6) ? tmp0_trim_0_6 : THROW_CCE()));
        var tmp1_trim_0_7 = parts_5.get_ha5a7z_k$(1);
        tmp_1 = to(tmp_2, toString_1(trim_0(isCharSequence(tmp1_trim_0_7) ? tmp1_trim_0_7 : THROW_CCE())));
      } else {
        tmp_1 = null;
      }
      tmp0_mapTo_0_1.add_2bq_k$(tmp_1);
      Unit_getInstance();
    }
    return new Headers_0(filterNotNull(tmp0_mapTo_0_1));
  };
  Companion_117.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_116;
  function Companion_getInstance_116() {
    if (Companion_instance_116 == null)
      new Companion_117();
    return Companion_instance_116;
  }
  function _no_name_provided__185() {
  }
  _no_name_provided__185.prototype.invoke_k4siew_k$ = function (a, b) {
    var tmp0_toLowerCase_0_3 = a._first;
    var tmp = tmp0_toLowerCase_0_3.toLowerCase();
    var tmp0_toLowerCase_0_3_0 = b._first;
    return compareValues(tmp, tmp0_toLowerCase_0_3_0.toLowerCase());
  };
  _no_name_provided__185.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Pair ? p1 : THROW_CCE();
    return this.invoke_k4siew_k$(tmp, p2 instanceof Pair ? p2 : THROW_CCE());
  };
  _no_name_provided__185.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Methods(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Methods.$metadata$ = {
    simpleName: 'Methods',
    kind: 'class',
    interfaces: [Method]
  };
  function Method() {
  }
  Method.$metadata$ = {
    simpleName: 'Method',
    kind: 'interface',
    interfaces: []
  };
  function HttpException(statusCode, msg, statusText, headers) {
    Companion_getInstance_115();
    IOException.call(this, '' + statusCode + ' ' + statusText + ' - ' + msg);
    this._statusCode = statusCode;
    this._msg = msg;
    this._statusText = statusText;
    this._headers = headers;
    captureStack(this, HttpException);
  }
  HttpException.$metadata$ = {
    simpleName: 'HttpException',
    kind: 'class',
    interfaces: []
  };
  function Headers_0(items) {
    Companion_getInstance_116();
    this._items_3 = items;
  }
  Headers_0.prototype.iterator_0_k$ = function () {
    return this._items_3.iterator_0_k$();
  };
  Headers_0.prototype.get_6wfw3l_k$ = function (key) {
    return this.getFirst_6wfw3l_k$(key);
  };
  Headers_0.prototype.getFirst_6wfw3l_k$ = function (key) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._items_3;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (equals_0(element_2._first, key, true)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_safe_receiver = tmp$ret$0;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._second;
  };
  Headers_0.prototype.toListGrouped_0_k$ = function () {
    var tmp0_groupBy_0 = this._items_3;
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_groupBy_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp0_toLowerCase_0_9 = element_2_3._first;
      var key_3_4 = tmp0_toLowerCase_0_9.toLowerCase();
      var value_1_6 = tmp0_groupByTo_0_1.get_2bw_k$(key_3_4);
      var tmp;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_1q9pf_k$(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp = answer_2_7;
      } else {
        tmp = value_1_6;
      }
      var list_4_5 = tmp;
      list_4_5.add_2bq_k$(element_2_3);
      Unit_getInstance();
    }
    var tmp1_map_0 = tmp0_groupByTo_0_1;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp1_map_0._get_size__0_k$());
    var tmp0_iterator_1_2_0 = tmp1_map_0._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_0_k$();
      var tmp_0 = first(item_2_3._get_value__0_k$())._first;
      var tmp0_map_0_5 = item_2_3._get_value__0_k$();
      var tmp0_mapTo_0_1_6 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_5, 10));
      var tmp0_iterator_1_2_7 = tmp0_map_0_5.iterator_0_k$();
      while (tmp0_iterator_1_2_7.hasNext_0_k$()) {
        var item_2_3_8 = tmp0_iterator_1_2_7.next_0_k$();
        tmp0_mapTo_0_1_6.add_2bq_k$(item_2_3_8._second);
        Unit_getInstance();
      }
      tmp0_mapTo_0_1.add_2bq_k$(to(tmp_0, tmp0_mapTo_0_1_6));
      Unit_getInstance();
    }
    var tmp2_sortedBy_0 = tmp0_mapTo_0_1;
    var tmp_1 = _no_name_provided_$factory_148();
    return sortedWith(tmp2_sortedBy_0, new sam$kotlin_Comparator$0_2(tmp_1));
  };
  Headers_0.prototype.withReplaceHeaders_85x2sk_k$ = function (newHeaders) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(newHeaders, 10));
    var tmp0_iterator_1_2 = newHeaders.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp0_toLowerCase_0_5 = item_2_3._first;
      tmp0_mapTo_0_1.add_2bq_k$(tmp0_toLowerCase_0_5.toLowerCase());
      Unit_getInstance();
    }
    var replaceKeys = toSet_0(tmp0_mapTo_0_1);
    var tmp0_filter_0 = this._items_3;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2_0 = tmp0_filter_0.iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2_0.next_0_k$();
      var tmp0_toLowerCase_0_5_0 = element_2_3._first;
      if (!replaceKeys.contains_2bq_k$(tmp0_toLowerCase_0_5_0.toLowerCase())) {
        tmp0_filterTo_0_1.add_2bq_k$(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return new Headers_0(plus(tmp0_filterTo_0_1, toList_3(newHeaders)));
  };
  Headers_0.prototype.withReplaceHeaders_slpm60_k$ = function (newHeaders) {
    return this.withReplaceHeaders_85x2sk_k$(toList(newHeaders));
  };
  Headers_0.prototype.withReplaceHeaders_8cap5q_k$ = function (newHeaders) {
    return this.withReplaceHeaders_85x2sk_k$(toList_3(newHeaders));
  };
  Headers_0.prototype.toString = function () {
    var tmp = this.toListGrouped_0_k$();
    return '' + 'Headers(' + joinToString$default_0(tmp, ', ', null, null, 0, null, null, 62, null) + ')';
  };
  Headers_0.prototype.hashCode = function () {
    return hashCode(this._items_3);
  };
  Headers_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Headers_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Headers_0 ? other : THROW_CCE();
    if (!equals_1(this._items_3, tmp0_other_with_cast._items_3))
      return false;
    return true;
  };
  Headers_0.$metadata$ = {
    simpleName: 'Headers',
    kind: 'class',
    interfaces: [Iterable]
  };
  function sam$kotlin_Comparator$0_2(function_0) {
    this._function_2 = function_0;
  }
  sam$kotlin_Comparator$0_2.prototype.compare_1qgdm_k$ = function (a, b) {
    return this._function_2(a, b);
  };
  sam$kotlin_Comparator$0_2.prototype.compare = function (a, b) {
    return this.compare_1qgdm_k$(a, b);
  };
  sam$kotlin_Comparator$0_2.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function Methods_OPTIONS_getInstance() {
    Methods_initEntries();
    return Methods_OPTIONS_instance;
  }
  function Methods_GET_getInstance() {
    Methods_initEntries();
    return Methods_GET_instance;
  }
  function Methods_HEAD_getInstance() {
    Methods_initEntries();
    return Methods_HEAD_instance;
  }
  function Methods_POST_getInstance() {
    Methods_initEntries();
    return Methods_POST_instance;
  }
  function Methods_PUT_getInstance() {
    Methods_initEntries();
    return Methods_PUT_instance;
  }
  function Methods_DELETE_getInstance() {
    Methods_initEntries();
    return Methods_DELETE_instance;
  }
  function Methods_TRACE_getInstance() {
    Methods_initEntries();
    return Methods_TRACE_instance;
  }
  function Methods_CONNECT_getInstance() {
    Methods_initEntries();
    return Methods_CONNECT_instance;
  }
  function Methods_PATCH_getInstance() {
    Methods_initEntries();
    return Methods_PATCH_instance;
  }
  function _no_name_provided_$factory_148() {
    var i = new _no_name_provided__185();
    return function (p1, p2) {
      return i.invoke_k4siew_k$(p1, p2);
    };
  }
  function _get__defaultHttpFactory_() {
    var tmp0_getValue_0 = _defaultHttpFactory$factory();
    return _defaultHttpFactory$delegate._get_value__0_k$();
  }
  var _defaultHttpFactory$delegate;
  function Companion_118() {
    Companion_instance_117 = this;
  }
  Companion_118.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_117;
  function Companion_getInstance_117() {
    if (Companion_instance_117 == null)
      new Companion_118();
    return Companion_instance_117;
  }
  function _no_name_provided__186() {
  }
  _no_name_provided__186.prototype.invoke_0_k$ = function () {
    return UTF8;
  };
  _no_name_provided__186.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $readAllBytesCOROUTINE$119(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__68 = _this_;
  }
  $readAllBytesCOROUTINE$119.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readAll(this.__this__68._content, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var allContent = suspendResult;
            return allContent;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAllBytesCOROUTINE$119.$metadata$ = {
    simpleName: '$readAllBytesCOROUTINE$119',
    kind: 'class',
    interfaces: []
  };
  function $readAllStringCOROUTINE$120(_this_, charset, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__69 = _this_;
    this._charset_0 = charset;
  }
  $readAllStringCOROUTINE$120.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__69.readAllBytes_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var bytes = suspendResult;
            return toString$default(bytes, this._charset_0, 0, 0, 6, null);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAllStringCOROUTINE$120.$metadata$ = {
    simpleName: '$readAllStringCOROUTINE$120',
    kind: 'class',
    interfaces: []
  };
  function $checkErrorsCOROUTINE$121(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__70 = _this_;
  }
  $checkErrorsCOROUTINE$121.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (!this.__this__70._success) {
              this._ARGUMENT0_14 = this.__this__70._status;
              this._state_1 = 2;
              suspendResult = this.__this__70.readAllString$default_8s0uio_k$(null, 1, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            return this.__this__70;
          case 2:
            var ARGUMENT = suspendResult;
            throw HttpException_init_$Create$(this._ARGUMENT0_14, ARGUMENT, this.__this__70._statusText_0, null, 8, null);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $checkErrorsCOROUTINE$121.$metadata$ = {
    simpleName: '$checkErrorsCOROUTINE$121',
    kind: 'class',
    interfaces: []
  };
  function RequestConfig_init_$Init$(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      followRedirects = true;
    if (!(($mask0 & 2) === 0))
      throwErrors = false;
    if (!(($mask0 & 4) === 0))
      maxRedirects = 10;
    if (!(($mask0 & 8) === 0))
      referer = null;
    if (!(($mask0 & 16) === 0))
      simulateBrowser = false;
    RequestConfig.call($this, followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
    return $this;
  }
  function RequestConfig_init_$Create$(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $mask0, $marker) {
    return RequestConfig_init_$Init$(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $mask0, $marker, Object.create(RequestConfig.prototype));
  }
  function Response_0(status, statusText, headers, rawContent, content) {
    Companion_getInstance_117();
    this._status = status;
    this._statusText_0 = statusText;
    this._headers_0 = headers;
    this._rawContent = rawContent;
    this._content = content;
    this._success = this._status < 400;
    var tmp = this;
    tmp._responseCharset$delegate = lazy(_no_name_provided_$factory_150());
  }
  Response_0.prototype.readAllBytes_0_k$ = function ($cont) {
    var tmp = new $readAllBytesCOROUTINE$119(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Response_0.prototype._get_responseCharset__0_k$ = function () {
    var tmp0_getValue_0 = responseCharset$factory();
    return this._responseCharset$delegate._get_value__0_k$();
  };
  Response_0.prototype.readAllString_8i7s9v_k$ = function (charset, $cont) {
    var tmp = new $readAllStringCOROUTINE$120(this, charset, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Response_0.prototype.readAllString$default_8s0uio_k$ = function (charset, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      charset = this._get_responseCharset__0_k$();
    return this.readAllString_8i7s9v_k$(charset, $cont);
  };
  Response_0.prototype.checkErrors_0_k$ = function ($cont) {
    var tmp = new $checkErrorsCOROUTINE$121(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Response_0.prototype.toCompletedResponse_7df4x3_k$ = function (content) {
    return new CompletedResponse(this._status, this._statusText_0, this._headers_0, content);
  };
  Response_0.prototype.toString = function () {
    return '' + 'Response(status=' + this._status + ', statusText=' + this._statusText_0 + ', headers=' + this._headers_0 + ', rawContent=' + this._rawContent + ', content=' + this._content + ')';
  };
  Response_0.prototype.hashCode = function () {
    var result = this._status;
    result = imul(result, 31) + getStringHashCode(this._statusText_0) | 0;
    result = imul(result, 31) + this._headers_0.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._rawContent) | 0;
    result = imul(result, 31) + hashCode(this._content) | 0;
    return result;
  };
  Response_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Response_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Response_0 ? other : THROW_CCE();
    if (!(this._status === tmp0_other_with_cast._status))
      return false;
    if (!(this._statusText_0 === tmp0_other_with_cast._statusText_0))
      return false;
    if (!this._headers_0.equals(tmp0_other_with_cast._headers_0))
      return false;
    if (!equals_1(this._rawContent, tmp0_other_with_cast._rawContent))
      return false;
    if (!equals_1(this._content, tmp0_other_with_cast._content))
      return false;
    return true;
  };
  Response_0.$metadata$ = {
    simpleName: 'Response',
    kind: 'class',
    interfaces: []
  };
  function CompletedResponse(status, statusText, headers, content) {
    this._status_0 = status;
    this._statusText_1 = statusText;
    this._headers_1 = headers;
    this._content_0 = content;
    this._success_0 = this._status_0 < 400;
  }
  CompletedResponse.prototype.toString = function () {
    return '' + 'CompletedResponse(status=' + this._status_0 + ', statusText=' + this._statusText_1 + ', headers=' + this._headers_1 + ', content=' + this._content_0 + ')';
  };
  CompletedResponse.prototype.hashCode = function () {
    var result = this._status_0;
    result = imul(result, 31) + getStringHashCode(this._statusText_1) | 0;
    result = imul(result, 31) + this._headers_1.hashCode() | 0;
    result = imul(result, 31) + (this._content_0 == null ? 0 : hashCode(this._content_0)) | 0;
    return result;
  };
  CompletedResponse.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedResponse))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedResponse ? other : THROW_CCE();
    if (!(this._status_0 === tmp0_other_with_cast._status_0))
      return false;
    if (!(this._statusText_1 === tmp0_other_with_cast._statusText_1))
      return false;
    if (!this._headers_1.equals(tmp0_other_with_cast._headers_1))
      return false;
    if (!equals_1(this._content_0, tmp0_other_with_cast._content_0))
      return false;
    return true;
  };
  CompletedResponse.$metadata$ = {
    simpleName: 'CompletedResponse',
    kind: 'class',
    interfaces: []
  };
  function RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    this._followRedirects = followRedirects;
    this._throwErrors = throwErrors;
    this._maxRedirects = maxRedirects;
    this._referer = referer;
    this._simulateBrowser = simulateBrowser;
  }
  RequestConfig.prototype.copy_51mu91_k$ = function (followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    return new RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  };
  RequestConfig.prototype.copy$default_z3d493_k$ = function (followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      followRedirects = this._followRedirects;
    if (!(($mask0 & 2) === 0))
      throwErrors = this._throwErrors;
    if (!(($mask0 & 4) === 0))
      maxRedirects = this._maxRedirects;
    if (!(($mask0 & 8) === 0))
      referer = this._referer;
    if (!(($mask0 & 16) === 0))
      simulateBrowser = this._simulateBrowser;
    return this.copy_51mu91_k$(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  };
  RequestConfig.prototype.toString = function () {
    return '' + 'RequestConfig(followRedirects=' + this._followRedirects + ', throwErrors=' + this._throwErrors + ', maxRedirects=' + this._maxRedirects + ', referer=' + this._referer + ', simulateBrowser=' + this._simulateBrowser + ')';
  };
  RequestConfig.prototype.hashCode = function () {
    var result = this._followRedirects | 0;
    result = imul(result, 31) + (this._throwErrors | 0) | 0;
    result = imul(result, 31) + this._maxRedirects | 0;
    result = imul(result, 31) + (this._referer == null ? 0 : getStringHashCode(this._referer)) | 0;
    result = imul(result, 31) + (this._simulateBrowser | 0) | 0;
    return result;
  };
  RequestConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestConfig))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RequestConfig ? other : THROW_CCE();
    if (!(this._followRedirects === tmp0_other_with_cast._followRedirects))
      return false;
    if (!(this._throwErrors === tmp0_other_with_cast._throwErrors))
      return false;
    if (!(this._maxRedirects === tmp0_other_with_cast._maxRedirects))
      return false;
    if (!(this._referer == tmp0_other_with_cast._referer))
      return false;
    if (!(this._simulateBrowser === tmp0_other_with_cast._simulateBrowser))
      return false;
    return true;
  };
  RequestConfig.$metadata$ = {
    simpleName: 'RequestConfig',
    kind: 'class',
    interfaces: []
  };
  function mergeUrls($this, base, append) {
    return Companion_getInstance_113().resolve_jg38oy_k$(base, append);
  }
  function Companion_119() {
    Companion_instance_118 = this;
    this._DEFAULT_USER_AGENT = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.81 Safari/537.36';
    this._DEFAULT_ACCEPT = 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8';
    this._DEFAULT_LANGUAGE = 'en-us';
    this._DEFAULT_ENCODING = 'gzip, deflate';
    this._DEFAULT_CONNECTION = 'Close';
  }
  Companion_119.prototype.combineHeadersForHost_fgqsci_k$ = function (headers, host) {
    var out = Headers_init_$Create$([to('User-Agent', this._DEFAULT_USER_AGENT), to('Accept', this._DEFAULT_ACCEPT), to('Accept-Language', this._DEFAULT_LANGUAGE), to('Accept-Encoding', this._DEFAULT_ENCODING), to('Connection', this._DEFAULT_CONNECTION)]).withReplaceHeaders_8cap5q_k$(headers);
    return !(host == null) ? out.withReplaceHeaders_slpm60_k$([to('Host', host)]) : out;
  };
  Companion_119.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_118;
  function Companion_getInstance_118() {
    if (Companion_instance_118 == null)
      new Companion_119();
    return Companion_instance_118;
  }
  function $requestCOROUTINE$122(_this_, method, url, headers, content, config, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__71 = _this_;
    this._method = method;
    this._url_0 = url;
    this._headers_2 = headers;
    this._content_1 = content;
    this._config = config;
  }
  $requestCOROUTINE$122.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._tmp0_safe_receiver0_1 = this._content_1;
            if (this._tmp0_safe_receiver0_1 == null) {
              this._WHEN_RESULT1_2 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0_1.getLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1_2 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._tmp1_elvis_lhs2 = this._WHEN_RESULT1_2;
            this._contentLength3 = this._tmp1_elvis_lhs2 == null ? new Long(0, 0) : this._tmp1_elvis_lhs2;
            this._actualHeaders4 = this._headers_2;
            var tmp_0;
            if (!(this._content_1 == null)) {
              l$ret$1: do {
                var tmp_1;
                var tmp_2 = this._headers_2;
                if (isInterface(tmp_2, Collection)) {
                  tmp_1 = this._headers_2.isEmpty_0_k$();
                } else {
                  {
                    tmp_1 = false;
                  }
                }
                if (tmp_1) {
                  this._tmp$ret$05 = false;
                  break l$ret$1;
                } else {
                }
                var tmp0_iterator_1 = this._headers_2.iterator_0_k$();
                while (tmp0_iterator_1.hasNext_0_k$()) {
                  var element_2 = tmp0_iterator_1.next_0_k$();
                  if (equals_0(element_2._first, Companion_getInstance_116()._ContentLength, true)) {
                    this._tmp$ret$05 = true;
                    break l$ret$1;
                  } else {
                  }
                }
                this._tmp$ret$05 = false;
              }
               while (false);
              tmp_0 = !this._tmp$ret$05;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this._actualHeaders4 = this._actualHeaders4.withReplaceHeaders_slpm60_k$([to(Companion_getInstance_116()._ContentLength, '' + this._contentLength3)]);
            } else {
            }

            if (this._config._simulateBrowser) {
              this._actualHeaders4 = Companion_getInstance_118().combineHeadersForHost_fgqsci_k$(this._actualHeaders4, null);
            }
            this._state_1 = 3;
            suspendResult = this.__this__71.requestInternal_ap218m_k$(this._method, this._url_0, this._actualHeaders4, this._content_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._tmp0_apply_06 = suspendResult;
            if (this._config._throwErrors) {
              this._state_1 = 4;
              suspendResult = this._tmp0_apply_06.checkErrors_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            Unit_getInstance();
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._response7 = this._tmp0_apply_06;
            if (this._config._followRedirects ? this._config._maxRedirects >= 0 : false) {
              this._redirectLocation8 = this._response7._headers_0.get_6wfw3l_k$('location');
              if (!(this._redirectLocation8 == null)) {
                this._state_1 = 8;
                var tmp_3 = mergeUrls(this.__this__71, this._url_0, this._redirectLocation8);
                var tmp_4 = this._headers_2.withReplaceHeaders_slpm60_k$([to('Referer', this._url_0)]);
                var tmp_5 = this._config._maxRedirects - 1 | 0;
                suspendResult = this.__this__71.request_mrb3i1_k$(this._method, tmp_3, tmp_4, this._content_1, this._config.copy$default_z3d493_k$(false, false, tmp_5, null, false, 27, null), this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._state_1 = 6;
                continue $sm;
              }
            } else {
              this._state_1 = 7;
              continue $sm;
            }

            break;
          case 6:
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._response7;
          case 8:
            return suspendResult;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $requestCOROUTINE$122.$metadata$ = {
    simpleName: '$requestCOROUTINE$122',
    kind: 'class',
    interfaces: []
  };
  function $requestAsBytesCOROUTINE$124(_this_, method, url, headers, content, config, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__72 = _this_;
    this._method_0 = method;
    this._url_1 = url;
    this._headers_3 = headers;
    this._content_2 = content;
    this._config_0 = config;
  }
  $requestAsBytesCOROUTINE$124.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__72.request_mrb3i1_k$(this._method_0, this._url_1, this._headers_3, this._content_2, this._config_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._res0_0 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._res0_0.readAllBytes_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this._res0_0.toCompletedResponse_7df4x3_k$(ARGUMENT);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $requestAsBytesCOROUTINE$124.$metadata$ = {
    simpleName: '$requestAsBytesCOROUTINE$124',
    kind: 'class',
    interfaces: []
  };
  function $readBytesCOROUTINE$125(_this_, url, config, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__73 = _this_;
    this._url_2 = url;
    this._config_1 = config;
  }
  $readBytesCOROUTINE$125.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = Companion_getInstance_114()._GET;
            suspendResult = this.__this__73.requestAsBytes$default_ou1vmx_k$(tmp_0, this._url_2, null, null, this._config_1.copy$default_z3d493_k$(false, true, 0, null, false, 29, null), 12, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT._content_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesCOROUTINE$125.$metadata$ = {
    simpleName: '$readBytesCOROUTINE$125',
    kind: 'class',
    interfaces: []
  };
  function HttpClient() {
    Companion_getInstance_118();
    this._ignoreSslCertificates = false;
  }
  HttpClient.prototype.request_mrb3i1_k$ = function (method, url, headers, content, config, $cont) {
    var tmp = new $requestCOROUTINE$122(this, method, url, headers, content, config, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HttpClient.prototype.request$default_ou1vmx_k$ = function (method, url, headers, content, config, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      headers = Headers_init_$Create$([]);
    if (!(($mask0 & 8) === 0))
      content = null;
    if (!(($mask0 & 16) === 0)) {
      config = RequestConfig_init_$Create$(false, false, 0, null, false, 31, null);
    }return this.request_mrb3i1_k$(method, url, headers, content, config, $cont);
  };
  HttpClient.prototype.requestAsBytes_mrb3i1_k$ = function (method, url, headers, content, config, $cont) {
    var tmp = new $requestAsBytesCOROUTINE$124(this, method, url, headers, content, config, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HttpClient.prototype.requestAsBytes$default_ou1vmx_k$ = function (method, url, headers, content, config, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      headers = Headers_init_$Create$([]);
    if (!(($mask0 & 8) === 0))
      content = null;
    if (!(($mask0 & 16) === 0)) {
      config = RequestConfig_init_$Create$(false, false, 0, null, false, 31, null);
    }return this.requestAsBytes_mrb3i1_k$(method, url, headers, content, config, $cont);
  };
  HttpClient.prototype.readBytes_fyprsk_k$ = function (url, config, $cont) {
    var tmp = new $readBytesCOROUTINE$125(this, url, config, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HttpClient.prototype.readBytes$default_nx2een_k$ = function (url, config, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0)) {
      config = RequestConfig_init_$Create$(false, false, 0, null, false, 31, null);
    }return this.readBytes_fyprsk_k$(url, config, $cont);
  };
  HttpClient.$metadata$ = {
    simpleName: 'HttpClient',
    kind: 'class',
    interfaces: []
  };
  function createHttpClient() {
    return _get_defaultHttpFactory_().createClient_0_k$();
  }
  function HttpStatusMessage() {
    HttpStatusMessage_instance = this;
    this._CODES_0 = linkedMapOf([to(100, 'Continue'), to(101, 'Switching Protocols'), to(200, 'OK'), to(201, 'Created'), to(202, 'Accepted'), to(203, 'Non-Authoritative Information'), to(204, 'No Content'), to(205, 'Reset Content'), to(206, 'Partial Content'), to(300, 'Multiple Choices'), to(301, 'Moved Permanently'), to(302, 'Found'), to(303, 'See Other'), to(304, 'Not Modified'), to(305, 'Use Proxy'), to(307, 'Temporary Redirect'), to(400, 'Bad Request'), to(401, 'Unauthorized'), to(402, 'Payment Required'), to(403, 'Forbidden'), to(404, 'Not Found'), to(405, 'Method Not Allowed'), to(406, 'Not Acceptable'), to(407, 'Proxy Authentication Required'), to(408, 'Request Timeout'), to(409, 'Conflict'), to(410, 'Gone'), to(411, 'Length Required'), to(412, 'Precondition Failed'), to(413, 'Request Entity Too Large'), to(414, 'Request-URI Too Long'), to(415, 'Unsupported Media Type'), to(416, 'Requested Range Not Satisfiable'), to(417, 'Expectation Failed'), to(418, "I'm a teapot"), to(422, 'Unprocessable Entity (WebDAV - RFC 4918)'), to(423, 'Locked (WebDAV - RFC 4918)'), to(424, 'Failed Dependency (WebDAV) (RFC 4918)'), to(425, 'Unassigned'), to(426, 'Upgrade Required (RFC 7231)'), to(428, 'Precondition Required'), to(429, 'Too Many Requests'), to(431, 'Request Header Fileds Too Large)'), to(449, 'Error449'), to(451, 'Unavailable for Legal Reasons'), to(500, 'Internal Server Error'), to(501, 'Not Implemented'), to(502, 'Bad Gateway'), to(503, 'Service Unavailable'), to(504, 'Gateway Timeout'), to(505, 'HTTP Version Not Supported'), to(506, 'Variant Also Negotiates (RFC 2295)'), to(507, 'Insufficient Storage (WebDAV - RFC 4918)'), to(508, 'Loop Detected (WebDAV)'), to(509, 'Bandwidth Limit Exceeded'), to(510, 'Not Extended (RFC 2774)'), to(511, 'Network Authentication Required')]);
  }
  HttpStatusMessage.$metadata$ = {
    simpleName: 'HttpStatusMessage',
    kind: 'object',
    interfaces: []
  };
  var HttpStatusMessage_instance;
  function HttpStatusMessage_getInstance() {
    if (HttpStatusMessage_instance == null)
      new HttpStatusMessage();
    return HttpStatusMessage_instance;
  }
  function ProxiedHttpFactory(parent) {
    this._parent_2 = parent;
    this._$$delegate_0_11 = parent;
  }
  ProxiedHttpFactory.prototype.createClient_0_k$ = function () {
    return this._$$delegate_0_11.createClient_0_k$();
  };
  ProxiedHttpFactory.$metadata$ = {
    simpleName: 'ProxiedHttpFactory',
    kind: 'class',
    interfaces: [HttpFactory]
  };
  function HttpFactory() {
  }
  HttpFactory.$metadata$ = {
    simpleName: 'HttpFactory',
    kind: 'interface',
    interfaces: []
  };
  function _get_defaultHttpFactory_() {
    return _get__defaultHttpFactory_();
  }
  function _no_name_provided__187() {
  }
  _no_name_provided__187.prototype.invoke_0_k$ = function () {
    return new ProxiedHttpFactory(_get_httpFactory_());
  };
  _no_name_provided__187.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _defaultHttpFactory$factory() {
    return getPropertyCallableRef('_defaultHttpFactory', 0, KProperty0, function () {
      return _get__defaultHttpFactory_();
    }, null);
  }
  function responseCharset$factory() {
    return getPropertyCallableRef('responseCharset', 1, KProperty1, function (receiver) {
      return receiver._get_responseCharset__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_149() {
    var i = new _no_name_provided__187();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_150() {
    var i = new _no_name_provided__186();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function Resourceable() {
  }
  Resourceable.$metadata$ = {
    simpleName: 'Resourceable',
    kind: 'interface',
    interfaces: []
  };
  function ResourcesContainer() {
  }
  ResourcesContainer.$metadata$ = {
    simpleName: 'ResourcesContainer',
    kind: 'interface',
    interfaces: []
  };
  function Resources_init_$Init$(coroutineContext, root, parent, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      root = _get_resourcesVfs_();
    if (!(($mask0 & 4) === 0))
      parent = null;
    Resources.call($this, coroutineContext, root, parent);
    return $this;
  }
  function Resources_init_$Create$(coroutineContext, root, parent, $mask0, $marker) {
    return Resources_init_$Init$(coroutineContext, root, parent, $mask0, $marker, Object.create(Resources.prototype));
  }
  function Resources(coroutineContext, root, parent) {
    this._coroutineContext_0 = coroutineContext;
    this._root_0 = root;
    this._parent_3 = parent;
    this._map_5 = LinkedHashMap_init_$Create$();
  }
  Resources.$metadata$ = {
    simpleName: 'Resources',
    kind: 'class',
    interfaces: [ResourcesContainer]
  };
  function Companion_120() {
    Companion_instance_119 = this;
    this._DEFAULT_1 = new Context(false, false);
    this._FAST = new Context(true, true);
  }
  Companion_120.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_119;
  function Companion_getInstance_119() {
    if (Companion_instance_119 == null)
      new Companion_120();
    return Companion_instance_119;
  }
  function CustomSerializer() {
  }
  CustomSerializer.$metadata$ = {
    simpleName: 'CustomSerializer',
    kind: 'interface',
    interfaces: []
  };
  function Context(optimizedNumericLists, useFastArrayList) {
    Companion_getInstance_119();
    this._optimizedNumericLists = optimizedNumericLists;
    this._useFastArrayList = useFastArrayList;
  }
  Context.prototype.createArrayList_1gxw90_k$ = function () {
    return this._useFastArrayList ? FastArrayList_init_$Create$() : ArrayList_init_$Create$();
  };
  Context.prototype.toString = function () {
    return '' + 'Context(optimizedNumericLists=' + this._optimizedNumericLists + ', useFastArrayList=' + this._useFastArrayList + ')';
  };
  Context.prototype.hashCode = function () {
    var result = this._optimizedNumericLists | 0;
    result = imul(result, 31) + (this._useFastArrayList | 0) | 0;
    return result;
  };
  Context.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Context))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Context ? other : THROW_CCE();
    if (!(this._optimizedNumericLists === tmp0_other_with_cast._optimizedNumericLists))
      return false;
    if (!(this._useFastArrayList === tmp0_other_with_cast._useFastArrayList))
      return false;
    return true;
  };
  Context.$metadata$ = {
    simpleName: 'Context',
    kind: 'class',
    interfaces: []
  };
  function parseNumber($this, s) {
    var start = s._pos_0;
    $l$break: while (true) {
      var tmp;
      if (s._get_hasMore__0_k$()) {
        var tmp0__anonymous__1 = s.peekChar_0_k$();
        tmp = (((((tmp0__anonymous__1.compareTo_wi8o78_k$(new Char(48)) >= 0 ? tmp0__anonymous__1.compareTo_wi8o78_k$(new Char(57)) <= 0 : false) ? true : tmp0__anonymous__1.equals(new Char(46))) ? true : tmp0__anonymous__1.equals(new Char(101))) ? true : tmp0__anonymous__1.equals(new Char(69))) ? true : tmp0__anonymous__1.equals(new Char(45))) ? true : tmp0__anonymous__1.equals(new Char(43));
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }s.readChar_0_k$();
      Unit_getInstance();
    }
    var end = s._pos_0;
    return NumberParser_getInstance().parseDouble_os2q01_k$(s._str_3, start, end);
  }
  function encodeString($this, str) {
    var tmp0_apply_0 = StringBuilder_init_$Create$_0();
    encodeString_0(Json_getInstance(), str, tmp0_apply_0);
    return tmp0_apply_0.toString();
  }
  function encodeString_0($this, str, b) {
    b.append_wi8o78_k$(new Char(34));
    Unit_getInstance();
    var indexedObject = str;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var c = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp1_subject = c;
      if (tmp1_subject.equals(new Char(92))) {
        b.append_uch40_k$('\\\\');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(47))) {
        b.append_uch40_k$('\\/');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(39))) {
        b.append_uch40_k$("\\'");
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(34))) {
        b.append_uch40_k$('\\"');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(8))) {
        b.append_uch40_k$('\\b');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(12))) {
        b.append_uch40_k$('\\f');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(10))) {
        b.append_uch40_k$('\\n');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(13))) {
        b.append_uch40_k$('\\r');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(9))) {
        b.append_uch40_k$('\\t');
        Unit_getInstance();
      } else {
        b.append_wi8o78_k$(c);
        Unit_getInstance();
      }
    }
    b.append_wi8o78_k$(new Char(34));
    Unit_getInstance();
  }
  function invalidJson($this, msg) {
    throw new IOException(msg);
  }
  function invalidJson$default($this, msg, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      msg = 'Invalid JSON';
    return invalidJson($this, msg);
  }
  function Json_0() {
    Json_instance = this;
  }
  Json_0.prototype.parse_gz3cuh_k$ = function (s, context) {
    return this.parse_q8aq9d_k$(StrReader_init_$Create$(s, null, 0, 6, null), context);
  };
  Json_0.prototype.parse$default_7dtpy2_k$ = function (s, context, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      context = Companion_getInstance_119()._DEFAULT_1;
    return this.parse_gz3cuh_k$(s, context);
  };
  Json_0.prototype.stringify_cowtt3_k$ = function (obj, pretty) {
    var tmp;
    if (pretty) {
      var tmp0_apply_0 = Indenter_init_$Create$(null, 1, null);
      Json_getInstance().stringifyPretty_louw82_k$(obj, tmp0_apply_0);
      tmp = tmp0_apply_0.toString_vtwmt5_k$(true, '\t');
    } else {
      var tmp1_apply_0 = StringBuilder_init_$Create$_0();
      Json_getInstance().stringify_tmoijd_k$(obj, tmp1_apply_0);
      tmp = tmp1_apply_0.toString();
    }
    return tmp;
  };
  Json_0.prototype.stringify$default_7j38zt_k$ = function (obj, pretty, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      pretty = false;
    return this.stringify_cowtt3_k$(obj, pretty);
  };
  Json_0.prototype.parse_q8aq9d_k$ = function (s, context) {
    var ic = s.skipSpaces_0_k$().read_0_k$();
    var tmp;
    if (ic.equals(new Char(123))) {
      var tmp0_apply_0 = LinkedHashMap_init_$Create$();
      obj: while (true) {
        var tmp0_subject_2 = s.skipSpaces_0_k$().read_0_k$();
        if (tmp0_subject_2.equals(new Char(125)))
          break obj;
        else if (tmp0_subject_2.equals(new Char(44)))
          continue obj;
        else {
          s.unread$default_l3mjq9_k$(0, 1, null);
          Unit_getInstance();
        }
        var tmp_0 = Json_getInstance().parse_q8aq9d_k$(s, context);
        var key_3 = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
        s.skipSpaces_0_k$().skipExpect_9o0tv_k$(new Char(58));
        var value_4 = Json_getInstance().parse_q8aq9d_k$(s, context);
        tmp0_apply_0.put_1q9pf_k$(key_3, value_4);
        Unit_getInstance();
      }
      tmp = tmp0_apply_0;
    } else if (ic.equals(new Char(91))) {
      var out = null;
      var outNumber = null;
      array: while (true) {
        var tmp0_subject = s.skipSpaces_0_k$().read_0_k$();
        if (tmp0_subject.equals(new Char(93)))
          break array;
        else if (tmp0_subject.equals(new Char(44)))
          continue array;
        else {
          s.unread$default_l3mjq9_k$(0, 1, null);
          Unit_getInstance();
        }
        var tmp_1;
        if (out == null ? context._optimizedNumericLists : false) {
          var containsArg = s.peek_0_k$();
          tmp_1 = new Char(48) <= containsArg ? containsArg <= new Char(57) : false;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          if (outNumber == null) {
            outNumber = DoubleArrayList_init_$Create$(0, 1, null);
          }outNumber.add_okcceq_k$(parseNumber(this, s));
        } else {
          {
            if (out == null)
              out = context.createArrayList_1gxw90_k$();
            if (!(outNumber == null)) {
              var tmp1_fastForEach_0 = outNumber;
              var n_1 = 0;
              while (n_1 < tmp1_fastForEach_0._get_size__0_k$()) {
                var tmp0_2 = n_1;
                n_1 = tmp0_2 + 1 | 0;
                var tmp2__anonymous__3 = tmp1_fastForEach_0.getAt_ha5a7z_k$(tmp0_2);
                out.add_2bq_k$(tmp2__anonymous__3);
                Unit_getInstance();
              }
              outNumber = null;
            }out.add_2bq_k$(this.parse_q8aq9d_k$(s, context));
            Unit_getInstance();
          }
        }
      }
      var tmp1_elvis_lhs = outNumber;
      var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? out : tmp1_elvis_lhs;
      tmp = tmp2_elvis_lhs == null ? context.createArrayList_1gxw90_k$() : tmp2_elvis_lhs;
    } else if (((((((((((ic.equals(new Char(45)) ? true : ic.equals(new Char(43))) ? true : ic.equals(new Char(48))) ? true : ic.equals(new Char(49))) ? true : ic.equals(new Char(50))) ? true : ic.equals(new Char(51))) ? true : ic.equals(new Char(52))) ? true : ic.equals(new Char(53))) ? true : ic.equals(new Char(54))) ? true : ic.equals(new Char(55))) ? true : ic.equals(new Char(56))) ? true : ic.equals(new Char(57))) {
      s.unread$default_l3mjq9_k$(0, 1, null);
      Unit_getInstance();
      var dres = parseNumber(this, s);
      tmp = numberToInt(dres) === dres ? numberToInt(dres) : dres;
    } else if ((ic.equals(new Char(116)) ? true : ic.equals(new Char(102))) ? true : ic.equals(new Char(110))) {
      s.unread$default_l3mjq9_k$(0, 1, null);
      Unit_getInstance();
      var tmp_2;
      if (s.tryRead_6wfw3l_k$('true')) {
        tmp_2 = true;
      } else if (s.tryRead_6wfw3l_k$('false')) {
        tmp_2 = false;
      } else if (s.tryRead_6wfw3l_k$('null')) {
        tmp_2 = null;
      } else {
        invalidJson$default(this, null, 2, null);
      }
      tmp = tmp_2;
    } else if (ic.equals(new Char(34))) {
      s.unread$default_l3mjq9_k$(0, 1, null);
      Unit_getInstance();
      tmp = s.readStringLit$default_gexuk8_k$(false, 1, null);
    } else {
      invalidJson(this, '' + "Not expected '" + ic + "'");
    }
    return tmp;
  };
  Json_0.prototype.stringify_tmoijd_k$ = function (obj, b) {
    var tmp0_subject = obj;
    if (tmp0_subject == null) {
      b.append_uch40_k$('null');
      Unit_getInstance();
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
        b.append_uch40_k$(obj ? 'true' : 'false');
        Unit_getInstance();
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Map_0) : false) {
          b.append_wi8o78_k$(new Char(123));
          Unit_getInstance();
          var iterator_0 = obj._get_entries__0_k$().iterator_0_k$();
          var index_0 = 0;
          while (iterator_0.hasNext_0_k$()) {
            var i = index_0;
            index_0 = index_0 + 1 | 0;
            var v = iterator_0.next_0_k$();
            if (!(i === 0)) {
              b.append_wi8o78_k$(new Char(44));
              Unit_getInstance();
            }this.stringify_tmoijd_k$(v._get_key__0_k$(), b);
            b.append_wi8o78_k$(new Char(58));
            Unit_getInstance();
            this.stringify_tmoijd_k$(v._get_value__0_k$(), b);
          }
          b.append_wi8o78_k$(new Char(125));
          Unit_getInstance();
        } else {
          if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Iterable) : false) {
            b.append_wi8o78_k$(new Char(91));
            Unit_getInstance();
            var iterator_1 = obj.iterator_0_k$();
            var index_1 = 0;
            while (iterator_1.hasNext_0_k$()) {
              var i_0 = index_1;
              index_1 = index_1 + 1 | 0;
              var v_0 = iterator_1.next_0_k$();
              if (!(i_0 === 0)) {
                b.append_wi8o78_k$(new Char(44));
                Unit_getInstance();
              }this.stringify_tmoijd_k$(v_0, b);
            }
            b.append_wi8o78_k$(new Char(93));
            Unit_getInstance();
          } else {
            if (tmp0_subject instanceof Enum)
              encodeString_0(this, obj._name, b);
            else {
              if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false)
                encodeString_0(this, obj, b);
              else {
                if (isNumber(tmp0_subject)) {
                  b.append_uch40_k$('' + obj);
                  Unit_getInstance();
                } else {
                  if (!(tmp0_subject == null) ? isInterface(tmp0_subject, CustomSerializer) : false)
                    obj.encodeToJson_ssmqhm_k$(b);
                  else {
                    {
                      invalidOp('' + "Don't know how to serialize " + obj);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  Json_0.prototype.stringifyPretty_louw82_k$ = function (obj, b) {
    var tmp0_subject = obj;
    if (tmp0_subject == null) {
      b.inline_6wfw3l_k$('null');
      Unit_getInstance();
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
        b.inline_6wfw3l_k$(obj ? 'true' : 'false');
        Unit_getInstance();
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Map_0) : false) {
          b.line_6wfw3l_k$('{');
          Unit_getInstance();
          b._indent_sv8swh_k$();
          try {
            var entries_2 = obj._get_entries__0_k$();
            var iterator_0 = entries_2.iterator_0_k$();
            var index_0 = 0;
            while (iterator_0.hasNext_0_k$()) {
              var i_5 = index_0;
              index_0 = index_0 + 1 | 0;
              var v_6 = iterator_0.next_0_k$();
              if (!(i_5 === 0)) {
                b.line_6wfw3l_k$(',');
                Unit_getInstance();
              }b.inline_6wfw3l_k$(encodeString(Json_getInstance(), '' + v_6._get_key__0_k$()));
              Unit_getInstance();
              b.inline_6wfw3l_k$(': ');
              Unit_getInstance();
              Json_getInstance().stringifyPretty_louw82_k$(v_6._get_value__0_k$(), b);
              if (i_5 === (entries_2._get_size__0_k$() - 1 | 0)) {
                b.line_6wfw3l_k$('');
                Unit_getInstance();
              }}
          }finally {
            b._unindent_sv8swh_k$();
          }
          Unit_getInstance();
          b.inline_6wfw3l_k$('}');
          Unit_getInstance();
        } else {
          if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Iterable) : false) {
            b.line_6wfw3l_k$('[');
            Unit_getInstance();
            b._indent_sv8swh_k$();
            try {
              var entries_2_0 = toList_3(obj);
              var iterator_1 = entries_2_0.iterator_0_k$();
              var index_1 = 0;
              while (iterator_1.hasNext_0_k$()) {
                var i_5_0 = index_1;
                index_1 = index_1 + 1 | 0;
                var v_6_0 = iterator_1.next_0_k$();
                if (!(i_5_0 === 0)) {
                  b.line_6wfw3l_k$(',');
                  Unit_getInstance();
                }Json_getInstance().stringifyPretty_louw82_k$(v_6_0, b);
                if (i_5_0 === (entries_2_0._get_size__0_k$() - 1 | 0)) {
                  b.line_6wfw3l_k$('');
                  Unit_getInstance();
                }}
            }finally {
              b._unindent_sv8swh_k$();
            }
            Unit_getInstance();
            b.inline_6wfw3l_k$(']');
            Unit_getInstance();
          } else {
            if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
              b.inline_6wfw3l_k$(encodeString(this, obj));
              Unit_getInstance();
            } else {
              if (isNumber(tmp0_subject)) {
                b.inline_6wfw3l_k$('' + obj);
                Unit_getInstance();
              } else {
                if (!(tmp0_subject == null) ? isInterface(tmp0_subject, CustomSerializer) : false) {
                  var tmp0_apply_0 = StringBuilder_init_$Create$_0();
                  obj.encodeToJson_ssmqhm_k$(tmp0_apply_0);
                  b.inline_6wfw3l_k$(tmp0_apply_0.toString());
                  Unit_getInstance();
                } else {
                  {
                    invalidOp('' + "Don't know how to serialize " + obj);
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  Json_0.$metadata$ = {
    simpleName: 'Json',
    kind: 'object',
    interfaces: []
  };
  var Json_instance;
  function Json_getInstance() {
    if (Json_instance == null)
      new Json_0();
    return Json_instance;
  }
  function parse$level(stream) {
    var children_0 = ArrayList_init_$Create$();
    while (stream.hasNext_0_k$()) {
      var tag = stream.next_0_k$();
      var tmp0_subject = tag;
      if (tmp0_subject instanceof ProcessingInstructionTag)
        Unit_getInstance();
      else {
        if (tmp0_subject instanceof CommentTag) {
          children_0.add_2bq_k$(Companion_getInstance_120().Comment_6wfw3l_k$(tag._text));
          Unit_getInstance();
        } else {
          if (tmp0_subject instanceof Text_0) {
            children_0.add_2bq_k$(tag._cdata ? Companion_getInstance_120().CData_6wfw3l_k$(tag._text_0) : Companion_getInstance_120().Text_6wfw3l_k$(tag._text_0));
            Unit_getInstance();
          } else {
            if (tmp0_subject instanceof OpenCloseTag) {
              var tmp = Companion_getInstance_120();
              children_0.add_2bq_k$(tmp.Tag_wgyptl_k$(tag._name_8, tag._attributes_0, emptyList()));
              Unit_getInstance();
            } else {
              if (tmp0_subject instanceof OpenTag) {
                var out = parse$level(stream);
                var tmp1_safe_receiver = out._close;
                if (!((tmp1_safe_receiver == null ? null : tmp1_safe_receiver._name_10) === tag._name_9)) {
                  var tmp2_safe_receiver = out._close;
                  throw IllegalArgumentException_init_$Create$('' + 'Expected ' + tag._name_9 + ' but was ' + (tmp2_safe_receiver == null ? null : tmp2_safe_receiver._name_10));
                } else {
                }
                children_0.add_2bq_k$(new Xml(Type_NODE_getInstance(), tag._name_9, tag._attributes_1, out._children_2, ''));
                Unit_getInstance();
              } else {
                if (tmp0_subject instanceof CloseTag)
                  return new Level_0(children_0, tag);
                else {
                  throw IllegalArgumentException_init_$Create$('' + 'Unhandled ' + tag);
                }
              }
            }
          }
        }
      }
    }
    return new Level_0(children_0, null);
  }
  function Level_0(children_0, close) {
    this._children_2 = children_0;
    this._close = close;
  }
  Level_0.prototype.toString = function () {
    return '' + 'Level(children=' + this._children_2 + ', close=' + this._close + ')';
  };
  Level_0.prototype.hashCode = function () {
    var result = hashCode(this._children_2);
    result = imul(result, 31) + (this._close == null ? 0 : hashCode(this._close)) | 0;
    return result;
  };
  Level_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Level_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Level_0 ? other : THROW_CCE();
    if (!equals_1(this._children_2, tmp0_other_with_cast._children_2))
      return false;
    if (!equals_1(this._close, tmp0_other_with_cast._close))
      return false;
    return true;
  };
  Level_0.$metadata$ = {
    simpleName: 'Level',
    kind: 'class',
    interfaces: []
  };
  var Type_NODE_instance;
  var Type_TEXT_instance;
  var Type_COMMENT_instance;
  var Type_entriesInitialized_3;
  function Type_initEntries_3() {
    if (Type_entriesInitialized_3)
      return Unit_getInstance();
    Type_entriesInitialized_3 = true;
    Type_NODE_instance = new Type_3('NODE', 0);
    Type_TEXT_instance = new Type_3('TEXT', 1);
    Type_COMMENT_instance = new Type_3('COMMENT', 2);
  }
  function ProcessingInstructionTag(name, attributes) {
    Element_1.call(this);
    this._name_7 = name;
    this._attributes = attributes;
  }
  ProcessingInstructionTag.$metadata$ = {
    simpleName: 'ProcessingInstructionTag',
    kind: 'class',
    interfaces: []
  };
  function OpenCloseTag(name, attributes) {
    Element_1.call(this);
    this._name_8 = name;
    this._attributes_0 = attributes;
  }
  OpenCloseTag.$metadata$ = {
    simpleName: 'OpenCloseTag',
    kind: 'class',
    interfaces: []
  };
  function OpenTag(name, attributes) {
    Element_1.call(this);
    this._name_9 = name;
    this._attributes_1 = attributes;
  }
  OpenTag.$metadata$ = {
    simpleName: 'OpenTag',
    kind: 'class',
    interfaces: []
  };
  function CommentTag(text) {
    Element_1.call(this);
    this._text = text;
  }
  CommentTag.$metadata$ = {
    simpleName: 'CommentTag',
    kind: 'class',
    interfaces: []
  };
  function CloseTag(name) {
    Element_1.call(this);
    this._name_10 = name;
  }
  CloseTag.$metadata$ = {
    simpleName: 'CloseTag',
    kind: 'class',
    interfaces: []
  };
  function Text_0(text) {
    Element_1.call(this);
    this._text_0 = text;
    this._cdata = false;
  }
  Text_0.$metadata$ = {
    simpleName: 'Text',
    kind: 'class',
    interfaces: []
  };
  function matchStringOrId(_this_, $this) {
    var tmp0_elvis_lhs = _this_.matchSingleOrDoubleQuoteString_0_k$();
    return tmp0_elvis_lhs == null ? _this_.matchIdentifier_0_k$() : tmp0_elvis_lhs;
  }
  function xmlSequence($this, r) {
    return sequence(_no_name_provided_$factory_152(r, null));
  }
  function Xml2Iterable(reader2) {
    this._reader2 = reader2;
    this._reader_2 = this._reader2.clone_0_k$();
  }
  Xml2Iterable.prototype.iterator_0_k$ = function () {
    return xmlSequence(Stream_getInstance(), this._reader_2).iterator_0_k$();
  };
  Xml2Iterable.$metadata$ = {
    simpleName: 'Xml2Iterable',
    kind: 'class',
    interfaces: [Iterable]
  };
  function Element_1() {
  }
  Element_1.$metadata$ = {
    simpleName: 'Element',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__188($r, resultContinuation) {
    this._$r = $r;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__188.prototype.invoke_m6va0z_k$ = function ($this$sequence, $cont) {
    var tmp = this.create_jmweu0_k$($this$sequence, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__188.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_m6va0z_k$(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__188.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!!this._$r._get_eof__0_k$()) {
              this._state_1 = 7;
              continue $sm;
            }
            var tmp_0 = this;
            var tmp0_elvis_lhs = this._$r.readUntil_wi8o78_k$(new Char(60));
            tmp_0._str0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            if (charSequenceLength(this._str0) > 0) {
              this._state_1 = 2;
              suspendResult = this._$this$sequence_0.yield_iav7o_k$(new Text_0(Entities_getInstance().decode_6wfw3l_k$(this._str0)), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 3;
                continue $sm;
              }
            }

            break;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (this._$r._get_eof__0_k$()) {
              this._state_1 = 7;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this._$r.skipExpect_9o0tv_k$(new Char(60));
            this._res1 = null;
            if (this._$r.tryExpect_6wfw3l_k$('![CDATA[')) {
              var start = this._$r._pos_0;
              $l$break: while (!this._$r._get_eof__0_k$()) {
                var end = this._$r._pos_0;
                if (this._$r.tryExpect_6wfw3l_k$(']]>')) {
                  var tmp_1 = this;
                  var tmp0_also_0 = new Text_0(this._$r.createRange_27zxwg_k$(start, end)._get_text__0_k$());
                  tmp0_also_0._cdata = true;
                  tmp_1._res1 = tmp0_also_0;
                  break $l$break;
                }this._$r.readChar_0_k$();
                Unit_getInstance();
              }
            } else if (this._$r.tryExpect_6wfw3l_k$('!--')) {
              var start_0 = this._$r._pos_0;
              $l$break_0: while (!this._$r._get_eof__0_k$()) {
                var end_0 = this._$r._pos_0;
                if (this._$r.tryExpect_6wfw3l_k$('-->')) {
                  this._res1 = new CommentTag(this._$r.createRange_27zxwg_k$(start_0, end_0)._get_text__0_k$());
                  break $l$break_0;
                }this._$r.readChar_0_k$();
                Unit_getInstance();
              }
            } else {
              this._$r.skipSpaces_0_k$();
              Unit_getInstance();
              var processingInstruction = this._$r.tryExpect_wi8o78_k$(new Char(63));
              var processingEntityOrDocType = this._$r.tryExpect_wi8o78_k$(new Char(33));
              var close = this._$r.tryExpect_wi8o78_k$(new Char(47)) ? true : processingEntityOrDocType;
              this._$r.skipSpaces_0_k$();
              Unit_getInstance();
              var tmp1_elvis_lhs = this._$r.matchIdentifier_0_k$();
              var tmp_2;
              if (tmp1_elvis_lhs == null) {
                var tmp1_error_0 = '' + "Couldn't match identifier after '<', offset=" + this._$r._pos_0 + ", around='" + this._$r.peek_ha5a7z_k$(10) + "'";
                throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
              } else {
                tmp_2 = tmp1_elvis_lhs;
              }
              var name = tmp_2;
              this._$r.skipSpaces_0_k$();
              Unit_getInstance();
              var attributes = LinkedHashMap_init_$Create$();
              while ((!this._$r.peekChar_0_k$().equals(new Char(63)) ? !this._$r.peekChar_0_k$().equals(new Char(47)) : false) ? !this._$r.peekChar_0_k$().equals(new Char(62)) : false) {
                var tmp2_elvis_lhs = matchStringOrId(this._$r, Stream_getInstance());
                var tmp_3;
                if (tmp2_elvis_lhs == null) {
                  throw IllegalArgumentException_init_$Create$('' + 'Malformed document or unsupported xml construct around ~' + this._$r.peek_ha5a7z_k$(10) + "~ for name '" + name + "'");
                } else {
                  tmp_3 = tmp2_elvis_lhs;
                }
                var key = tmp_3;
                this._$r.skipSpaces_0_k$();
                Unit_getInstance();
                if (this._$r.tryExpect_6wfw3l_k$('=')) {
                  this._$r.skipSpaces_0_k$();
                  Unit_getInstance();
                  var argsQuote = matchStringOrId(this._$r, Stream_getInstance());
                  var tmp_4;
                  if (!(argsQuote == null)) {
                    var tmp_5 = Entities_getInstance();
                    var tmp2_substring_0 = argsQuote.length - 1 | 0;
                    tmp_4 = tmp_5.decode_6wfw3l_k$(argsQuote.substring(1, tmp2_substring_0));
                  } else {
                    tmp_4 = Entities_getInstance().decode_6wfw3l_k$(ensureNotNull(this._$r.matchIdentifier_0_k$()));
                  }
                  var tmp3_set_0 = tmp_4;
                  attributes.put_1q9pf_k$(key, tmp3_set_0);
                  Unit_getInstance();
                } else {
                  attributes.put_1q9pf_k$(key, key);
                  Unit_getInstance();
                }
                this._$r.skipSpaces_0_k$();
                Unit_getInstance();
              }
              var openclose = this._$r.tryExpect_wi8o78_k$(new Char(47));
              var processingInstructionEnd = this._$r.tryExpect_wi8o78_k$(new Char(63));
              this._$r.skipExpect_9o0tv_k$(new Char(62));
              this._res1 = (processingInstruction ? true : processingEntityOrDocType) ? new ProcessingInstructionTag(name, attributes) : openclose ? new OpenCloseTag(name, attributes) : close ? new CloseTag(name) : new OpenTag(name, attributes);
            }

            if (!(this._res1 == null)) {
              this._state_1 = 5;
              suspendResult = this._$this$sequence_0.yield_iav7o_k$(this._res1, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 5:
            this._state_1 = 6;
            continue $sm;
          case 6:
            this._state_1 = 1;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 8) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__188.prototype.create_jmweu0_k$ = function ($this$sequence, completion) {
    var i = new _no_name_provided__188(this._$r, completion);
    i._$this$sequence_0 = $this$sequence;
    return i;
  };
  _no_name_provided__188.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function Companion_121() {
    Companion_instance_120 = this;
    this._NAME_RAW = '_raw_';
    this._NAME_TEXT = '_text_';
    this._NAME_CDATA = '_cdata_';
    this._NAME_COMMENT = '_comment_';
  }
  Companion_121.prototype.Tag_wgyptl_k$ = function (tagName, attributes, children_0) {
    var tmp = Type_NODE_getInstance();
    var tmp0_filterTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = attributes._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      if (!(element_2_3._get_value__0_k$() == null)) {
        tmp0_filterTo_0_1.put_1q9pf_k$(element_2_3._get_key__0_k$(), element_2_3._get_value__0_k$());
        Unit_getInstance();
      } else {
      }
    }
    var tmp0_map_0 = tmp0_filterTo_0_1;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0._get_size__0_k$());
    var tmp0_iterator_1_2_0 = tmp0_map_0._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(to(item_2_3._get_key__0_k$(), toString_0(item_2_3._get_value__0_k$())));
      Unit_getInstance();
    }
    return new Xml(tmp, tagName, toMap_0(tmp0_mapTo_0_1), children_0, '');
  };
  Companion_121.prototype.Text_6wfw3l_k$ = function (text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap_init_$Create$();
    return new Xml(tmp, '_text_', tmp_0, emptyList(), text);
  };
  Companion_121.prototype.CData_6wfw3l_k$ = function (text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap_init_$Create$();
    return new Xml(tmp, '_cdata_', tmp_0, emptyList(), text);
  };
  Companion_121.prototype.Comment_6wfw3l_k$ = function (text) {
    var tmp = Type_COMMENT_getInstance();
    var tmp_0 = LinkedHashMap_init_$Create$();
    return new Xml(tmp, '_comment_', tmp_0, emptyList(), text);
  };
  Companion_121.prototype.parse_6wfw3l_k$ = function (str) {
    try {
      var stream = Stream_getInstance().parse_6wfw3l_k$(str).iterator_0_k$();
      var children_0 = parse$level(stream)._children_2;
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_iterator_1 = children_0.iterator_0_k$();
        while (tmp0_iterator_1.hasNext_0_k$()) {
          var element_2 = tmp0_iterator_1.next_0_k$();
          if (element_2._type_9.equals(Type_NODE_getInstance())) {
            tmp$ret$0 = element_2;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      var tmp0_elvis_lhs = tmp$ret$0;
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(children_0) : tmp0_elvis_lhs;
      return tmp1_elvis_lhs == null ? Companion_getInstance_120().Text_6wfw3l_k$('') : tmp1_elvis_lhs;
    } catch ($p) {
      if ($p instanceof NoSuchElementException) {
        println('' + 'ERROR: XML: ' + str + ' thrown a NoSuchElementException');
        return Companion_getInstance_120().Text_6wfw3l_k$('!!ERRORED!!');
      } else {
        {
          throw $p;
        }
      }
    }
  };
  Companion_121.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_120;
  function Companion_getInstance_120() {
    if (Companion_instance_120 == null)
      new Companion_121();
    return Companion_instance_120;
  }
  function Type_3(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_3.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Entities() {
    Entities_instance = this;
    this._charToEntity = linkedMapOf([to(new Char(34), '&quot;'), to(new Char(39), '&apos;'), to(new Char(60), '&lt;'), to(new Char(62), '&gt;'), to(new Char(38), '&amp;')]);
    var tmp = this;
    var tmp_0 = Companion_getInstance_122();
    var tmp0_toTypedArray_0 = this._charToEntity._get_values__0_k$();
    tmp._entities = tmp_0.fromList_ortqkv_k$(copyToArray_0(tmp0_toTypedArray_0));
    this._entityToChar = flip(this._charToEntity);
  }
  Entities.prototype.encode_6wfw3l_k$ = function (str) {
    var tmp0_apply_0_1_1 = StringBuilder_init_$Create$_0();
    var inductionVariable = 0;
    var last_1 = str.length;
    if (inductionVariable < last_1)
      do {
        var n_4_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__anonymous__4 = charSequenceGet(str, n_4_3);
        var entry_5 = Entities_getInstance()._charToEntity.get_2bw_k$(tmp0__anonymous__4);
        if (!(entry_5 == null)) {
          tmp0_apply_0_1_1.append_uch40_k$(entry_5);
          Unit_getInstance();
        } else {
          tmp0_apply_0_1_1.append_wi8o78_k$(tmp0__anonymous__4);
          Unit_getInstance();
        }
      }
       while (inductionVariable < last_1);
    return tmp0_apply_0_1_1.toString();
  };
  Entities.prototype.decode_6wfw3l_k$ = function (str) {
    return this.decode_hku29z_k$(StrReader_init_$Create$(str, null, 0, 6, null));
  };
  Entities.prototype.decode_hku29z_k$ = function (r) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    $l$break: while (!r._get_eof__0_k$()) {
      var plain_3 = r.readUntil_wi8o78_k$(new Char(38));
      if (!(plain_3 == null)) {
        tmp0_apply_0_1.append_uch40_k$(plain_3);
        Unit_getInstance();
      }if (r._get_eof__0_k$())
        break $l$break;
      r.skipExpect_9o0tv_k$(new Char(38));
      var tmp0_elvis_lhs_5 = r.readUntilIncluded_wi8o78_k$(new Char(59));
      var value_4 = tmp0_elvis_lhs_5 == null ? '' : tmp0_elvis_lhs_5;
      var full_6 = '' + '&' + value_4;
      var tmp = new Char(35);
      if (startsWith$default(value_4, tmp, false, 2, null)) {
        var tmp0_substring_0_7 = value_4.length - 1 | 0;
        tmp0_apply_0_1.append_wi8o78_k$(numberToChar(toInt(value_4.substring(1, tmp0_substring_0_7))));
        Unit_getInstance();
      } else {
        var tmp1_contains_0_8 = Entities_getInstance()._entityToChar;
        if ((isInterface(tmp1_contains_0_8, Map_0) ? tmp1_contains_0_8 : THROW_CCE()).containsKey_2bw_k$(full_6)) {
          tmp0_apply_0_1.append_wi7j7l_k$(Entities_getInstance()._entityToChar.get_2bw_k$(full_6));
          Unit_getInstance();
        } else {
          {
            tmp0_apply_0_1.append_uch40_k$(full_6);
            Unit_getInstance();
          }
        }
      }
    }
    return tmp0_apply_0_1.toString();
  };
  Entities.$metadata$ = {
    simpleName: 'Entities',
    kind: 'object',
    interfaces: []
  };
  var Entities_instance;
  function Entities_getInstance() {
    if (Entities_instance == null)
      new Entities();
    return Entities_instance;
  }
  function Stream() {
    Stream_instance = this;
  }
  Stream.prototype.parse_6wfw3l_k$ = function (str) {
    return this.parse_hku29z_k$(StrReader_init_$Create$(str, null, 0, 6, null));
  };
  Stream.prototype.parse_hku29z_k$ = function (r) {
    return new Xml2Iterable(r);
  };
  Stream.$metadata$ = {
    simpleName: 'Stream',
    kind: 'object',
    interfaces: []
  };
  var Stream_instance;
  function Stream_getInstance() {
    if (Stream_instance == null)
      new Stream();
    return Stream_instance;
  }
  function _no_name_provided__189() {
  }
  _no_name_provided__189.prototype.invoke_ou535b_k$ = function (it) {
    return it._get_text__0_k$();
  };
  _no_name_provided__189.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ou535b_k$(p1 instanceof Xml ? p1 : THROW_CCE());
  };
  _no_name_provided__189.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Type_NODE_getInstance() {
    Type_initEntries_3();
    return Type_NODE_instance;
  }
  function Type_TEXT_getInstance() {
    Type_initEntries_3();
    return Type_TEXT_instance;
  }
  function Type_COMMENT_getInstance() {
    Type_initEntries_3();
    return Type_COMMENT_instance;
  }
  function Xml(type, name, attributes, allChildren, content) {
    Companion_getInstance_120();
    this._type_9 = type;
    this._name_11 = name;
    this._attributes_2 = attributes;
    this._allChildren = allChildren;
    this._content_3 = content;
    this._attributesLC = toCaseInsensitiveMap(this._attributes_2);
    var tmp = this;
    var tmp0_toLowerCase_0 = this._name_11;
    var tmp1_trim_0 = tmp0_toLowerCase_0.toLowerCase();
    tmp._nameLC_0 = toString_1(trim_0(isCharSequence(tmp1_trim_0) ? tmp1_trim_0 : THROW_CCE()));
  }
  Xml.prototype._get_allChildrenNoComments__0_k$ = function () {
    var tmp0_filter_0 = this._allChildren;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_filter_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      if (!_get_isComment_(element_2_3)) {
        tmp0_filterTo_0_1.add_2bq_k$(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return tmp0_filterTo_0_1;
  };
  Xml.prototype._get_allNodeChildren__0_k$ = function () {
    var tmp0_filter_0 = this._allChildren;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_filter_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      if (_get_isNode_(element_2_3)) {
        tmp0_filterTo_0_1.add_2bq_k$(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return tmp0_filterTo_0_1;
  };
  Xml.prototype._get_text__0_k$ = function () {
    var tmp0_subject = this._type_9;
    var tmp;
    if (tmp0_subject.equals(Type_NODE_getInstance())) {
      tmp = joinToString$default_0(this._allChildren, '', null, null, 0, null, _no_name_provided_$factory_151(), 30, null);
    } else if (tmp0_subject.equals(Type_TEXT_getInstance())) {
      tmp = this._content_3;
    } else if (tmp0_subject.equals(Type_COMMENT_getInstance())) {
      tmp = '';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  Xml.prototype._get_attributesStr__0_k$ = function () {
    var tmp0_map_0 = toList_4(this._attributes_2);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$('' + ' ' + item_2_3._first + '="' + item_2_3._second + '"');
      Unit_getInstance();
    }
    return joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null);
  };
  Xml.prototype._get_outerXml__0_k$ = function () {
    var tmp0_subject = this._type_9;
    var tmp;
    if (tmp0_subject.equals(Type_NODE_getInstance())) {
      var tmp_0;
      if (this._allChildren.isEmpty_0_k$()) {
        tmp_0 = '' + '<' + this._name_11 + this._get_attributesStr__0_k$() + '/>';
      } else {
        var tmp0_map_0 = this._allChildren;
        var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
        var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
        while (tmp0_iterator_1_2.hasNext_0_k$()) {
          var item_2_3 = tmp0_iterator_1_2.next_0_k$();
          tmp0_mapTo_0_1.add_2bq_k$(item_2_3._get_outerXml__0_k$());
          Unit_getInstance();
        }
        var children_0 = joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null);
        tmp_0 = '' + '<' + this._name_11 + this._get_attributesStr__0_k$() + '>' + children_0 + '<\/' + this._name_11 + '>';
      }
      tmp = tmp_0;
    } else if (tmp0_subject.equals(Type_TEXT_getInstance())) {
      var tmp1_subject = this._name_11;
      var tmp_1;
      Companion_getInstance_120();
      if (tmp1_subject === '_text_') {
        tmp_1 = Entities_getInstance().encode_6wfw3l_k$(this._content_3);
      } else {
        Companion_getInstance_120();
        if (tmp1_subject === '_cdata_') {
          tmp_1 = '' + '<![CDATA[' + this._content_3 + ']]>';
        } else {
          Companion_getInstance_120();
          if (tmp1_subject === '_raw_') {
            tmp_1 = this._content_3;
          } else {
            {
              tmp_1 = this._content_3;
            }
          }
        }
      }
      tmp = tmp_1;
    } else if (tmp0_subject.equals(Type_COMMENT_getInstance())) {
      tmp = '' + '<!--' + this._content_3 + '-->';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  Xml.prototype.get_6wfw3l_k$ = function (name) {
    return this.children_6wfw3l_k$(name);
  };
  Xml.prototype.children_6wfw3l_k$ = function (name) {
    var tmp0_filter_0 = this._allChildren;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_filter_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      if (equals_0(element_2_3._name_11, name, true)) {
        tmp0_filterTo_0_1.add_2bq_k$(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return tmp0_filterTo_0_1;
  };
  Xml.prototype.child_6wfw3l_k$ = function (name) {
    return firstOrNull_0(this.children_6wfw3l_k$(name));
  };
  Xml.prototype.getString_6wfw3l_k$ = function (name) {
    return this._attributesLC.get_2bw_k$(name);
  };
  Xml.prototype.getInt_6wfw3l_k$ = function (name) {
    var tmp0_safe_receiver = this._attributesLC.get_2bw_k$(name);
    return tmp0_safe_receiver == null ? null : toInt(tmp0_safe_receiver);
  };
  Xml.prototype.double_qmgruq_k$ = function (name, defaultValue) {
    var tmp0_safe_receiver = this._attributesLC.get_2bw_k$(name);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toDoubleOrNull(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? defaultValue : tmp1_elvis_lhs;
  };
  Xml.prototype.double$default_s8e18k_k$ = function (name, defaultValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      defaultValue = 0.0;
    return this.double_qmgruq_k$(name, defaultValue);
  };
  Xml.prototype.boolean_2f0f39_k$ = function (name, defaultValue) {
    var tmp0_elvis_lhs = this.booleanOrNull_6wfw3l_k$(name);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  };
  Xml.prototype.booleanOrNull_6wfw3l_k$ = function (name) {
    var tmp0_toLowerCase_0 = this.str$default_877n1b_k$(name, null, 2, null);
    var tmp0_subject = tmp0_toLowerCase_0.toLowerCase();
    switch (tmp0_subject) {
      case 'true':
      case '1':
        return true;
      case 'false':
      case '0':
        return false;
      default:return null;
    }
  };
  Xml.prototype.int_8i7b4u_k$ = function (name, defaultValue) {
    var tmp0_safe_receiver = this._attributesLC.get_2bw_k$(name);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? defaultValue : tmp1_elvis_lhs;
  };
  Xml.prototype.int$default_6ncsww_k$ = function (name, defaultValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      defaultValue = 0;
    return this.int_8i7b4u_k$(name, defaultValue);
  };
  Xml.prototype.str_jg38oy_k$ = function (name, defaultValue) {
    var tmp0_elvis_lhs = this._attributesLC.get_2bw_k$(name);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  };
  Xml.prototype.str$default_877n1b_k$ = function (name, defaultValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      defaultValue = '';
    return this.str_jg38oy_k$(name, defaultValue);
  };
  Xml.prototype.doubleNull_6wfw3l_k$ = function (name) {
    var tmp0_safe_receiver = this._attributesLC.get_2bw_k$(name);
    return tmp0_safe_receiver == null ? null : toDoubleOrNull(tmp0_safe_receiver);
  };
  Xml.prototype.intNull_6wfw3l_k$ = function (name) {
    var tmp0_safe_receiver = this._attributesLC.get_2bw_k$(name);
    return tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
  };
  Xml.prototype.strNull_6wfw3l_k$ = function (name) {
    return this._attributesLC.get_2bw_k$(name);
  };
  Xml.prototype.toString = function () {
    return this._get_outerXml__0_k$();
  };
  Xml.prototype.hashCode = function () {
    var result = this._type_9.hashCode();
    result = imul(result, 31) + getStringHashCode(this._name_11) | 0;
    result = imul(result, 31) + hashCode(this._attributes_2) | 0;
    result = imul(result, 31) + hashCode(this._allChildren) | 0;
    result = imul(result, 31) + getStringHashCode(this._content_3) | 0;
    return result;
  };
  Xml.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Xml))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Xml ? other : THROW_CCE();
    if (!this._type_9.equals(tmp0_other_with_cast._type_9))
      return false;
    if (!(this._name_11 === tmp0_other_with_cast._name_11))
      return false;
    if (!equals_1(this._attributes_2, tmp0_other_with_cast._attributes_2))
      return false;
    if (!equals_1(this._allChildren, tmp0_other_with_cast._allChildren))
      return false;
    if (!(this._content_3 === tmp0_other_with_cast._content_3))
      return false;
    return true;
  };
  Xml.$metadata$ = {
    simpleName: 'Xml',
    kind: 'class',
    interfaces: []
  };
  function Xml_0(str) {
    return Companion_getInstance_120().parse_6wfw3l_k$(str);
  }
  function _get_isText_(_this_) {
    return _this_._type_9.equals(Type_TEXT_getInstance());
  }
  function _get_isComment_(_this_) {
    return _this_._type_9.equals(Type_COMMENT_getInstance());
  }
  function _get_isNode_(_this_) {
    return _this_._type_9.equals(Type_NODE_getInstance());
  }
  function readXml(_this_, $cont) {
    var tmp = new $readXmlCOROUTINE$141(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function children(_this_, name) {
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = _this_.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      var list_3_4 = element_2_3.children_6wfw3l_k$(name);
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    return tmp0_flatMapTo_0_1;
  }
  function get_0(_this_, name) {
    return children(_this_, name);
  }
  function $readXmlCOROUTINE$141(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__74 = _this_;
  }
  $readXmlCOROUTINE$141.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__74.readString$default_8s0uio_k$(null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return Xml_0(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readXmlCOROUTINE$141.$metadata$ = {
    simpleName: '$readXmlCOROUTINE$141',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_151() {
    var i = new _no_name_provided__189();
    return function (p1) {
      return i.invoke_ou535b_k$(p1);
    };
  }
  function _no_name_provided_$factory_152($r, resultContinuation) {
    var i = new _no_name_provided__188($r, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_m6va0z_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  var EMPTY_BYTE_ARRAY;
  function AsyncStream_init_$Init$(base, position_0, queue, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      position_0 = new Long(0, 0);
    if (!(($mask0 & 4) === 0))
      queue = false;
    AsyncStream.call($this, base, position_0, queue);
    return $this;
  }
  function AsyncStream_init_$Create$(base, position_0, queue, $mask0, $marker) {
    return AsyncStream_init_$Init$(base, position_0, queue, $mask0, $marker, Object.create(AsyncStream.prototype));
  }
  function _get_readQueue_($this) {
    var tmp0_getValue_0 = readQueue$factory();
    return $this._readQueue$delegate._get_value__0_k$();
  }
  function _get_writeQueue_($this) {
    var tmp0_getValue_0 = writeQueue$factory();
    return $this._writeQueue$delegate._get_value__0_k$();
  }
  function readInternal($this, buffer, offset_0, len, $cont) {
    var tmp = new $readInternalCOROUTINE$144($this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function writeInternal($this, buffer, offset_0, len, $cont) {
    var tmp = new $writeInternalCOROUTINE$145($this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__190() {
  }
  _no_name_provided__190.prototype.invoke_0_k$ = function () {
    return new AsyncThread();
  };
  _no_name_provided__190.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__191() {
  }
  _no_name_provided__191.prototype.invoke_0_k$ = function () {
    return new AsyncThread();
  };
  _no_name_provided__191.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__192(this$0, $buffer, $offset, $len, resultContinuation) {
    this._this$0_54 = this$0;
    this._$buffer = $buffer;
    this._$offset = $offset;
    this._$len = $len;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__192.prototype.invoke_0_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__192.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readInternal(this._this$0_54, this._$buffer, this._$offset, this._$len, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__192.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__192(this._this$0_54, this._$buffer, this._$offset, this._$len, completion);
    return i;
  };
  _no_name_provided__192.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__193(this$0, $buffer, $offset, $len, resultContinuation) {
    this._this$0_55 = this$0;
    this._$buffer_0 = $buffer;
    this._$offset_0 = $offset;
    this._$len_0 = $len;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__193.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__193.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__193.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = writeInternal(this._this$0_55, this._$buffer_0, this._$offset_0, this._$len_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__193.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__193(this._this$0_55, this._$buffer_0, this._$offset_0, this._$len_0, completion);
    return i;
  };
  _no_name_provided__193.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $readCOROUTINE$142(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__75 = _this_;
    this._buffer_16 = buffer;
    this._offset_13 = offset_0;
    this._len_10 = len;
  }
  $readCOROUTINE$142.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            if (this.__this__75._queue_1) {
              this._state_1 = 2;
              var tmp_0 = _get_readQueue_(this.__this__75);
              suspendResult = tmp_0.invoke_bdq1br_k$(_no_name_provided_$factory_155(this.__this__75, this._buffer_16, this._offset_13, this._len_10, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = readInternal(this.__this__75, this._buffer_16, this._offset_13, this._len_10, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT0_2 = suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._WHEN_RESULT0_2 = suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            return this._WHEN_RESULT0_2;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$142.$metadata$ = {
    simpleName: '$readCOROUTINE$142',
    kind: 'class',
    interfaces: []
  };
  function $writeCOROUTINE$143(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__76 = _this_;
    this._buffer_17 = buffer;
    this._offset_14 = offset_0;
    this._len_11 = len;
  }
  $writeCOROUTINE$143.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            if (this.__this__76._queue_1) {
              this._state_1 = 2;
              var tmp_0 = _get_writeQueue_(this.__this__76);
              suspendResult = tmp_0.invoke_bdq1br_k$(_no_name_provided_$factory_156(this.__this__76, this._buffer_17, this._offset_14, this._len_11, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = writeInternal(this.__this__76, this._buffer_17, this._offset_14, this._len_11, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$143.$metadata$ = {
    simpleName: '$writeCOROUTINE$143',
    kind: 'class',
    interfaces: []
  };
  function $readInternalCOROUTINE$144(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__77 = _this_;
    this._buffer_18 = buffer;
    this._offset_15 = offset_0;
    this._len_12 = len;
  }
  $readInternalCOROUTINE$144.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__77._base.read_pwamfb_k$(this.__this__77._position_6, this._buffer_18, this._offset_15, this._len_12, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var read_0 = suspendResult;
            if (read_0 >= 0) {
              var tmp0_this = this.__this__77;
              var tmp_0 = tmp0_this;
              var tmp0_plus_0 = tmp0_this._position_6;
              tmp_0._position_6 = tmp0_plus_0.plus_wiekkq_k$(toLong(read_0));
            }
            return read_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readInternalCOROUTINE$144.$metadata$ = {
    simpleName: '$readInternalCOROUTINE$144',
    kind: 'class',
    interfaces: []
  };
  function $writeInternalCOROUTINE$145(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__78 = _this_;
    this._buffer_19 = buffer;
    this._offset_16 = offset_0;
    this._len_13 = len;
  }
  $writeInternalCOROUTINE$145.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__78._base.write_8wseoo_k$(this.__this__78._position_6, this._buffer_19, this._offset_16, this._len_13, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_this = this.__this__78;
            var tmp_0 = tmp0_this;
            var tmp0_plus_0 = tmp0_this._position_6;
            tmp_0._position_6 = tmp0_plus_0.plus_wiekkq_k$(toLong(this._len_13));
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeInternalCOROUTINE$145.$metadata$ = {
    simpleName: '$writeInternalCOROUTINE$145',
    kind: 'class',
    interfaces: []
  };
  function $getAvailableCOROUTINE$146(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__79 = _this_;
  }
  $getAvailableCOROUTINE$146.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__79.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_15 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__79.getPosition_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this._ARGUMENT0_15.minus_wiekkq_k$(ARGUMENT);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getAvailableCOROUTINE$146.$metadata$ = {
    simpleName: '$getAvailableCOROUTINE$146',
    kind: 'class',
    interfaces: []
  };
  function $eofCOROUTINE$147(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__80 = _this_;
  }
  $eofCOROUTINE$147.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this.__this__80.hasAvailable_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            if (suspendResult) {
              this._state_1 = 2;
              suspendResult = this.__this__80.getAvailable_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT0_3 = false;
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            var ARGUMENT = suspendResult;
            this._WHEN_RESULT0_3 = ARGUMENT.compareTo_wiekkq_k$(new Long(0, 0)) <= 0;
            this._state_1 = 3;
            continue $sm;
          case 3:
            return this._WHEN_RESULT0_3;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $eofCOROUTINE$147.$metadata$ = {
    simpleName: '$eofCOROUTINE$147',
    kind: 'class',
    interfaces: []
  };
  function AsyncStream(base, position_0, queue) {
    this._base = base;
    this._position_6 = position_0;
    this._queue_1 = queue;
    var tmp = this;
    tmp._$$delegate_0_12 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._readQueue$delegate = lazy(_no_name_provided_$factory_153());
    var tmp_1 = this;
    tmp_1._writeQueue$delegate = lazy(_no_name_provided_$factory_154());
  }
  AsyncStream.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_12._set_extra__n1onou_k$(_set___);
  };
  AsyncStream.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_12._get_extra__0_k$();
  };
  AsyncStream.prototype.read_irqg4d_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $readCOROUTINE$142(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncStream.prototype.write_ysdrhq_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $writeCOROUTINE$143(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncStream.prototype.setPosition_kdfck9_k$ = function (value, $cont) {
    this._position_6 = value;
  };
  AsyncStream.prototype.getPosition_0_k$ = function ($cont) {
    return this._position_6;
  };
  AsyncStream.prototype.getLength_0_k$ = function ($cont) {
    return this._base.getLength_0_k$($cont);
  };
  AsyncStream.prototype.hasAvailable_0_k$ = function ($cont) {
    return this.hasLength_0_k$($cont);
  };
  AsyncStream.prototype.getAvailable_0_k$ = function ($cont) {
    var tmp = new $getAvailableCOROUTINE$146(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncStream.prototype.eof_0_k$ = function ($cont) {
    var tmp = new $eofCOROUTINE$147(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncStream.prototype.close_sv8swh_k$ = function ($cont) {
    return this._base.close_sv8swh_k$($cont);
  };
  AsyncStream.prototype.duplicate_0_k$ = function () {
    var tmp = this._position_6;
    return AsyncStream_init_$Create$(this._base, tmp, false, 4, null);
  };
  AsyncStream.$metadata$ = {
    simpleName: 'AsyncStream',
    kind: 'class',
    interfaces: [Extra, AsyncInputStream, AsyncInputStreamWithLength, AsyncOutputStream, AsyncPositionLengthStream, AsyncCloseable]
  };
  function buffered(_this_, blockSize, blocksToRead) {
    return toAsyncStream(new BufferedStreamBase(_this_._base, blockSize, blocksToRead), _this_._position_6);
  }
  function buffered$default(_this_, blockSize, blocksToRead, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      blockSize = 2048;
    if (!(($mask0 & 2) === 0))
      blocksToRead = 16;
    return buffered(_this_, blockSize, blocksToRead);
  }
  function toAsyncStream(_this_, position_0) {
    return AsyncStream_init_$Create$(_this_, position_0, false, 4, null);
  }
  function toAsyncStream$default(_this_, position_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      position_0 = new Long(0, 0);
    return toAsyncStream(_this_, position_0);
  }
  function AsyncStreamBase() {
  }
  AsyncStreamBase.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncStreamBase.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len, $cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncStreamBase.prototype.getLength_0_k$ = function ($cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncStreamBase.prototype.close_sv8swh_k$ = function ($cont) {
    return Unit_getInstance();
  };
  AsyncStreamBase.$metadata$ = {
    simpleName: 'AsyncStreamBase',
    kind: 'class',
    interfaces: [AsyncCloseable, AsyncRAInputStream, AsyncRAOutputStream, AsyncLengthStream]
  };
  function $readCOROUTINE$148(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__81 = _this_;
  }
  $readCOROUTINE$148.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_alloc_01 = _get_smallBytesPool_();
            this._temp_12 = this._tmp0_alloc_01.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            this._state_1 = 4;
            suspendResult = this.__this__81.read_irqg4d_k$(this._temp_12, 0, 1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var ARGUMENT = suspendResult;
            if (ARGUMENT > 0) {
              var tmp_1 = this;
              var tmp0__get_unsigned__0_3 = this._temp_12[0];
              tmp_1._WHEN_RESULT5 = tmp0__get_unsigned__0_3 & 255;
              this._state_1 = 5;
              continue $sm;
            } else {
              this._WHEN_RESULT5 = -1;
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._tmp$ret$04 = this._WHEN_RESULT5;
            this._exceptionState = 10;
            this._state_1 = 6;
            var tmp_2 = this;
            continue $sm;
          case 6:
            var tmp_3 = this._tmp$ret$04;
            this._tmp0_alloc_01.free_iav7o_k$(this._temp_12);
            this._tmp$ret$40 = tmp_3;
            this._state_1 = 8;
            continue $sm;
          case 7:
            this._tmp0_alloc_01.free_iav7o_k$(this._temp_12);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 8;
            continue $sm;
          case 8:
            return this._tmp$ret$40;
          case 9:
            this._exceptionState = 10;
            var t = this._exception_0;
            this._tmp0_alloc_01.free_iav7o_k$(this._temp_12);
            throw t;
          case 10:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$148.$metadata$ = {
    simpleName: '$readCOROUTINE$148',
    kind: 'class',
    interfaces: []
  };
  function AsyncInputStream() {
  }
  AsyncInputStream.prototype.read_0_k$ = function ($cont) {
    var tmp = new $readCOROUTINE$148(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncInputStream.$metadata$ = {
    simpleName: 'AsyncInputStream',
    kind: 'interface',
    interfaces: [AsyncBaseStream]
  };
  function readAll(_this_, $cont) {
    var tmp = new $readAllCOROUTINE$149(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function $writeCOROUTINE$150(_this_, byte, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__82 = _this_;
    this._byte = byte;
  }
  $writeCOROUTINE$150.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_alloc_01_0 = _get_smallBytesPool_();
            this._temp_12_0 = this._tmp0_alloc_01_0.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._temp_12_0[0] = toByte(this._byte);
            this._state_1 = 4;
            suspendResult = this.__this__82.write_ysdrhq_k$(this._temp_12_0, 0, 1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$04_0 = suspendResult;
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_1 = this;
            continue $sm;
          case 5:
            var tmp_2 = this;
            tmp_2._tmp$ret$40_0 = this._tmp0_alloc_01_0.free_iav7o_k$(this._temp_12_0);
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_alloc_01_0.free_iav7o_k$(this._temp_12_0);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_alloc_01_0.free_iav7o_k$(this._temp_12_0);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$150.$metadata$ = {
    simpleName: '$writeCOROUTINE$150',
    kind: 'class',
    interfaces: []
  };
  function AsyncOutputStream() {
  }
  AsyncOutputStream.prototype.write$default_ffc7am_k$ = function (buffer, offset_0, len, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      offset_0 = 0;
    if (!(($mask0 & 4) === 0))
      len = buffer.length - offset_0 | 0;
    return $handler == null ? this.write_ysdrhq_k$(buffer, offset_0, len, $cont) : $handler(buffer, offset_0, len);
  };
  AsyncOutputStream.prototype.write_majfzk_k$ = function (byte, $cont) {
    var tmp = new $writeCOROUTINE$150(this, byte, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncOutputStream.$metadata$ = {
    simpleName: 'AsyncOutputStream',
    kind: 'interface',
    interfaces: [AsyncBaseStream]
  };
  function readU8_1(_this_, $cont) {
    return _this_.read_0_k$($cont);
  }
  function readS32BE_0(_this_, $cont) {
    var tmp = new $readS32BECOROUTINE$152(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readBytesExact(_this_, len, $cont) {
    var tmp = new $readBytesExactCOROUTINE$153(_this_, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function AsyncInputStreamWithLength() {
  }
  AsyncInputStreamWithLength.$metadata$ = {
    simpleName: 'AsyncInputStreamWithLength',
    kind: 'interface',
    interfaces: [AsyncInputStream, AsyncGetPositionStream, AsyncGetLengthStream]
  };
  function AsyncPositionLengthStream() {
  }
  AsyncPositionLengthStream.$metadata$ = {
    simpleName: 'AsyncPositionLengthStream',
    kind: 'interface',
    interfaces: [AsyncPositionStream, AsyncLengthStream]
  };
  function $_readCOROUTINE$154(_this_, position_0, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__83 = _this_;
    this._position_7 = position_0;
    this._buffer_20 = buffer;
    this._offset_17 = offset_0;
    this._len_14 = len;
  }
  $_readCOROUTINE$154.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._state_1 = 1;
            suspendResult = this.__this__83._base_0.hasLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            if (suspendResult) {
              this._state_1 = 2;
              suspendResult = this.__this__83._base_0.getLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT0_4 = false;
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            this._ARGUMENT1_7 = suspendResult;
            this._WHEN_RESULT0_4 = this._position_7.compareTo_wiekkq_k$(this._ARGUMENT1_7) >= 0;
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (this._WHEN_RESULT0_4) {
              return -1;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 4:
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_div_02_0 = this.__this__83._bsize;
            tmp_0._sector3 = this._position_7.div_wiekkq_k$(toLong(this._tmp0_div_02_0));
            if (!this.__this__83._cachedSector.equals(this._sector3)) {
              this._state_1 = 5;
              var tmp_2 = this;
              tmp_2._tmp1_times_04 = this.__this__83._bsize;
              suspendResult = readBytes(this.__this__83._base_0, this._sector3.times_wiekkq_k$(toLong(this._tmp1_times_04)), this.__this__83._bsize, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 5:
            var ARGUMENT = suspendResult;
            this.__this__83._cachedData = ARGUMENT;
            this.__this__83._cachedSector = this._sector3;
            this._state_1 = 6;
            continue $sm;
          case 6:
            var tmp2_rem_0 = this.__this__83._bsize;
            var soffset = this._position_7.rem_wiekkq_k$(toLong(tmp2_rem_0)).toInt_0_k$();
            var available = this.__this__83._cachedData.length - soffset | 0;
            var toRead = Math.min(available, this._len_14);
            arraycopy_2(this.__this__83._cachedData, soffset, this._buffer_20, this._offset_17, toRead);
            return toRead;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $_readCOROUTINE$154.$metadata$ = {
    simpleName: '$_readCOROUTINE$154',
    kind: 'class',
    interfaces: []
  };
  function BufferedStreamBase(base, blockSize, blocksToRead) {
    AsyncStreamBase.call(this);
    this._base_0 = base;
    this._blockSize = blockSize;
    this._blocksToRead = blocksToRead;
    this._bsize = imul(this._blockSize, this._blocksToRead);
    var tmp = this;
    tmp._cachedData = new Int8Array([]);
    this._cachedSector = new Long(-1, -1);
  }
  BufferedStreamBase.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    return this._read_pwamfb_k$(position_0, buffer, offset_0, len, $cont);
  };
  BufferedStreamBase.prototype._read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    var tmp = new $_readCOROUTINE$154(this, position_0, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BufferedStreamBase.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len, $cont) {
    return this._base_0.write_8wseoo_k$(position_0, buffer, offset_0, len, $cont);
  };
  BufferedStreamBase.prototype.getLength_0_k$ = function ($cont) {
    return this._base_0.getLength_0_k$($cont);
  };
  BufferedStreamBase.prototype.close_sv8swh_k$ = function ($cont) {
    return this._base_0.close_sv8swh_k$($cont);
  };
  BufferedStreamBase.$metadata$ = {
    simpleName: 'BufferedStreamBase',
    kind: 'class',
    interfaces: []
  };
  function AsyncRAInputStream() {
  }
  AsyncRAInputStream.$metadata$ = {
    simpleName: 'AsyncRAInputStream',
    kind: 'interface',
    interfaces: []
  };
  function AsyncRAOutputStream() {
  }
  AsyncRAOutputStream.$metadata$ = {
    simpleName: 'AsyncRAOutputStream',
    kind: 'interface',
    interfaces: []
  };
  function AsyncLengthStream() {
  }
  AsyncLengthStream.$metadata$ = {
    simpleName: 'AsyncLengthStream',
    kind: 'interface',
    interfaces: [AsyncGetLengthStream]
  };
  function AsyncBaseStream() {
  }
  AsyncBaseStream.$metadata$ = {
    simpleName: 'AsyncBaseStream',
    kind: 'interface',
    interfaces: [AsyncCloseable]
  };
  function AsyncGetPositionStream() {
  }
  AsyncGetPositionStream.prototype.getPosition_0_k$ = function ($cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncGetPositionStream.$metadata$ = {
    simpleName: 'AsyncGetPositionStream',
    kind: 'interface',
    interfaces: [AsyncBaseStream]
  };
  function $hasLengthCOROUTINE$155(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__84 = _this_;
  }
  $hasLengthCOROUTINE$155.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__84.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            this._TRY_RESULT0_1 = true;
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof UnsupportedOperationException) {
              var t = this._exception_0;
              var tmp_1 = this;
              tmp_1._TRY_RESULT0_1 = false;
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return this._TRY_RESULT0_1;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $hasLengthCOROUTINE$155.$metadata$ = {
    simpleName: '$hasLengthCOROUTINE$155',
    kind: 'class',
    interfaces: []
  };
  function AsyncGetLengthStream() {
  }
  AsyncGetLengthStream.prototype.hasLength_0_k$ = function ($cont) {
    var tmp = new $hasLengthCOROUTINE$155(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncGetLengthStream.prototype.getLength_0_k$ = function ($cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncGetLengthStream.$metadata$ = {
    simpleName: 'AsyncGetLengthStream',
    kind: 'interface',
    interfaces: [AsyncBaseStream]
  };
  function readExact(_this_, buffer, offset_0, len, $cont) {
    var tmp = new $readExactCOROUTINE$157(_this_, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function AsyncPositionStream() {
  }
  AsyncPositionStream.$metadata$ = {
    simpleName: 'AsyncPositionStream',
    kind: 'interface',
    interfaces: [AsyncGetPositionStream]
  };
  function readBytes(_this_, position_0, count_0, $cont) {
    var tmp = new $readBytesCOROUTINE$158(_this_, position_0, count_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function MemoryAsyncStreamBase(data) {
    AsyncStreamBase.call(this);
    this._data_20 = data;
  }
  MemoryAsyncStreamBase.prototype._get_ilength__0_k$ = function () {
    return this._data_20._get_size__0_k$();
  };
  MemoryAsyncStreamBase.prototype.getLength_0_k$ = function ($cont) {
    return toLong(this._get_ilength__0_k$());
  };
  MemoryAsyncStreamBase.prototype.checkPosition_kdfck9_k$ = function (position_0) {
    var tmp;
    if (position_0.compareTo_wiekkq_k$(new Long(0, 0)) < 0) {
      invalidOp('' + 'Invalid position ' + position_0);
    }return tmp;
  };
  MemoryAsyncStreamBase.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    this.checkPosition_kdfck9_k$(position_0);
    if (!((new Long(0, 0)).compareTo_wiekkq_k$(position_0) <= 0 ? position_0.compareTo_wiekkq_k$(toLong(this._get_ilength__0_k$())) < 0 : false))
      return 0;
    var tmp0_min_0 = toLong(this._get_ilength__0_k$());
    var tmp1_min_0 = position_0.plus_wiekkq_k$(toLong(len));
    var end = tmp0_min_0.compareTo_wiekkq_k$(tmp1_min_0) <= 0 ? tmp0_min_0 : tmp1_min_0;
    var tmp2_max_0 = end.minus_wiekkq_k$(position_0).toInt_0_k$();
    var actualLen = Math.max(tmp2_max_0, 0);
    arraycopy_2(this._data_20._data_14, position_0.toInt_0_k$(), buffer, offset_0, actualLen);
    return actualLen;
  };
  MemoryAsyncStreamBase.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len, $cont) {
    this.checkPosition_kdfck9_k$(position_0);
    var tmp = this._data_20;
    var tmp0_max_0 = this._data_20._get_size__0_k$();
    var tmp1_max_0 = position_0.plus_wiekkq_k$(toLong(len)).toInt_0_k$();
    tmp._set_size__majfzk_k$(Math.max(tmp0_max_0, tmp1_max_0));
    arraycopy_2(buffer, offset_0, this._data_20._data_14, position_0.toInt_0_k$(), len);
  };
  MemoryAsyncStreamBase.prototype.close_sv8swh_k$ = function ($cont) {
    return Unit_getInstance();
  };
  MemoryAsyncStreamBase.prototype.toString = function () {
    return '' + 'MemoryAsyncStreamBase(' + this._data_20._get_size__0_k$() + ')';
  };
  MemoryAsyncStreamBase.$metadata$ = {
    simpleName: 'MemoryAsyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function asyncStreamWriter(bufferSize, process_1, $cont) {
    var deque = new AsyncByteArrayDeque(bufferSize);
    var tmp = $cont._get_context__0_k$();
    var job = launchImmediately(tmp, _no_name_provided_$factory_157(process_1, deque, null));
    return new _no_name_provided__196(deque, job);
  }
  function asyncStreamWriter$default(bufferSize, process_1, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      bufferSize = 32768;
    return asyncStreamWriter(bufferSize, process_1, $cont);
  }
  function AsyncInputOpenable() {
  }
  AsyncInputOpenable.$metadata$ = {
    simpleName: 'AsyncInputOpenable',
    kind: 'interface',
    interfaces: []
  };
  function readBytesUpTo(_this_, len, $cont) {
    var tmp = new $readBytesUpToCOROUTINE$160(_this_, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function writeBytes(_this_, data, $cont) {
    return _this_.write_ysdrhq_k$(data, 0, data.length, $cont);
  }
  function write8_0(_this_, v, $cont) {
    return _this_.write_majfzk_k$(v, $cont);
  }
  function write32LE_0(_this_, v, $cont) {
    var tmp = new $write32LECOROUTINE$161(_this_, v, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readBytesUpToCopy(_this_, out, $cont) {
    var tmp = new $readBytesUpToCopyCOROUTINE$163(_this_, out, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function getAvailable(_this_, $cont) {
    var tmp = new $getAvailableCOROUTINE$164(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readBytesUpTo_0(_this_, out, offset_0, len, $cont) {
    var tmp = new $readBytesUpToCOROUTINE$165(_this_, out, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function getAvailable_0(_this_, $cont) {
    var tmp = new $getAvailableCOROUTINE$166(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function write16LE_0(_this_, v, $cont) {
    var tmp = new $write16LECOROUTINE$167(_this_, v, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function hasAvailable(_this_, $cont) {
    var tmp = new $hasAvailableCOROUTINE$168(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function toAsync(_this_) {
    return toAsyncStream(toAsync_0(_this_._base_2), _this_._get_position__0_k$());
  }
  function readStream(_this_, length, $cont) {
    return readSlice(_this_, toLong(length), $cont);
  }
  function toSyncOrNull(_this_) {
    var tmp0_safe_receiver = _this_ instanceof SyncAsyncStreamBase ? _this_ : null;
    var tmp2_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._sync;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver = _this_ instanceof MemoryAsyncStreamBase ? _this_ : null;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = new MemorySyncStreamBase(tmp1_safe_receiver._data_20);
      }
      tmp = tmp_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    return tmp;
  }
  function readString(_this_, len, charset, $cont) {
    var tmp = new $readStringCOROUTINE$170(_this_, len, charset, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readString$default(_this_, len, charset, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return readString(_this_, len, charset, $cont);
  }
  function readS8_0(_this_, $cont) {
    var tmp = new $readS8COROUTINE$171(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readS64LE_0(_this_, $cont) {
    var tmp = new $readS64LECOROUTINE$172(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readS32LE_0(_this_, $cont) {
    var tmp = new $readS32LECOROUTINE$173(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function writeString(_this_, string, charset, $cont) {
    return writeBytes(_this_, toByteArray$default(string, charset, 0, 0, 6, null), $cont);
  }
  function writeString$default(_this_, string, charset, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return writeString(_this_, string, charset, $cont);
  }
  function writeShortArrayLE(_this_, array, $cont) {
    var tmp = imul(array.length, 2);
    return writeTempBytes(_this_, tmp, _no_name_provided_$factory_158(array), $cont);
  }
  function readS16LE_0(_this_, $cont) {
    var tmp = new $readS16LECOROUTINE$174(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readU32LE_0(_this_, $cont) {
    var tmp = new $readU32LECOROUTINE$175(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function toAsyncInputStream(_this_) {
    return new _no_name_provided__198(_this_);
  }
  function toAsyncOutputStream(_this_) {
    return new _no_name_provided__199(_this_);
  }
  function write32BE_0(_this_, v, $cont) {
    var tmp = new $write32BECOROUTINE$176(_this_, v, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function toAsync_0(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof MemorySyncStreamBase) {
      tmp = new MemoryAsyncStreamBase(_this_._data_21);
    } else {
      {
        tmp = new SyncAsyncStreamBase(_this_);
      }
    }
    return tmp;
  }
  function readSlice(_this_, length, $cont) {
    var tmp = new $readSliceCOROUTINE$177(_this_, length, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function SyncAsyncStreamBase(sync) {
    AsyncStreamBase.call(this);
    this._sync = sync;
  }
  SyncAsyncStreamBase.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    return this._sync.read_pwamfb_k$(position_0, buffer, offset_0, len);
  };
  SyncAsyncStreamBase.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len, $cont) {
    return this._sync.write_8wseoo_k$(position_0, buffer, offset_0, len);
  };
  SyncAsyncStreamBase.prototype.getLength_0_k$ = function ($cont) {
    return this._sync._get_length__0_k$();
  };
  SyncAsyncStreamBase.$metadata$ = {
    simpleName: 'SyncAsyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function writeTempBytes(_this_, size_2, block, $cont) {
    var tmp = new $writeTempBytesCOROUTINE$178(_this_, size_2, block, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function sliceWithSize(_this_, start, length, closeParent, $cont) {
    return sliceWithBounds(_this_, start, start.plus_wiekkq_k$(length), closeParent, $cont);
  }
  function sliceWithSize$default(_this_, start, length, closeParent, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      closeParent = false;
    return sliceWithSize(_this_, start, length, closeParent, $cont);
  }
  function sliceWithBounds(_this_, start, end, closeParent, $cont) {
    var tmp = new $sliceWithBoundsCOROUTINE$179(_this_, start, end, closeParent, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function clampPosition($this, position_0) {
    return clamp_5(position_0, $this._baseStart, $this._baseEnd);
  }
  function clampPositionLen($this, position_0, len) {
    if (position_0.compareTo_wiekkq_k$(new Long(0, 0)) < 0)
      throw IllegalArgumentException_init_$Create$('Invalid position');
    var targetStartPosition = clampPosition($this, $this._baseStart.plus_wiekkq_k$(position_0));
    var targetEndPosition = clampPosition($this, targetStartPosition.plus_wiekkq_k$(toLong(len)));
    var targetLen = targetEndPosition.minus_wiekkq_k$(targetStartPosition).toInt_0_k$();
    return new Pair(targetStartPosition, targetLen);
  }
  function $closeCOROUTINE$180(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__85 = _this_;
  }
  $closeCOROUTINE$180.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (this.__this__85._closeParent) {
              this._state_1 = 1;
              suspendResult = this.__this__85._base_1.close_sv8swh_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $closeCOROUTINE$180.$metadata$ = {
    simpleName: '$closeCOROUTINE$180',
    kind: 'class',
    interfaces: []
  };
  function SliceAsyncStreamBase(base, baseStart, baseEnd, closeParent) {
    AsyncStreamBase.call(this);
    this._base_1 = base;
    this._baseStart = baseStart;
    this._baseEnd = baseEnd;
    this._closeParent = closeParent;
    this._baseLength = this._baseEnd.minus_wiekkq_k$(this._baseStart);
  }
  SliceAsyncStreamBase.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    var tmp0_container = clampPositionLen(this, position_0, len);
    var targetStartPosition = tmp0_container.component1_0_k$();
    var targetLen = tmp0_container.component2_0_k$();
    return this._base_1.read_pwamfb_k$(targetStartPosition, buffer, offset_0, targetLen, $cont);
  };
  SliceAsyncStreamBase.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len, $cont) {
    var tmp0_container = clampPositionLen(this, position_0, len);
    var targetStartPosition = tmp0_container.component1_0_k$();
    var targetLen = tmp0_container.component2_0_k$();
    return this._base_1.write_8wseoo_k$(targetStartPosition, buffer, offset_0, targetLen, $cont);
  };
  SliceAsyncStreamBase.prototype.getLength_0_k$ = function ($cont) {
    return this._baseLength;
  };
  SliceAsyncStreamBase.prototype.close_sv8swh_k$ = function ($cont) {
    var tmp = new $closeCOROUTINE$180(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  SliceAsyncStreamBase.prototype.toString = function () {
    return '' + 'SliceAsyncStreamBase(' + this._base_1 + ', ' + this._baseStart + ', ' + this._baseEnd + ')';
  };
  SliceAsyncStreamBase.$metadata$ = {
    simpleName: 'SliceAsyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function sliceStart(_this_, start, closeParent, $cont) {
    var tmp = new $sliceStartCOROUTINE$181(_this_, start, closeParent, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function sliceStart$default(_this_, start, closeParent, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      start = new Long(0, 0);
    if (!(($mask0 & 2) === 0))
      closeParent = false;
    return sliceStart(_this_, start, closeParent, $cont);
  }
  function readU16LE_0(_this_, $cont) {
    var tmp = new $readU16LECOROUTINE$182(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function toAsyncStream_0(_this_) {
    var input = isInterface(_this_, AsyncInputStream) ? _this_ : null;
    var output_0 = isInterface(_this_, AsyncOutputStream) ? _this_ : null;
    var rlenSet = isInterface(_this_, AsyncLengthStream) ? _this_ : null;
    var rlenGet = isInterface(_this_, AsyncGetLengthStream) ? _this_ : null;
    var closeable = _this_;
    var tmp = new _no_name_provided__200(input, output_0, rlenSet, rlenGet, closeable);
    return toAsyncStream$default(tmp, new Long(0, 0), 1, null);
  }
  function withLength(_this_, length) {
    var base = _this_;
    var currentPos = {_v: new Long(0, 0)};
    return new _no_name_provided__201(base, currentPos, length);
  }
  function SeekNotSupportedException_init_$Init$(message, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      message = 'Seeking not supported!';
    SeekNotSupportedException.call($this, message);
    return $this;
  }
  function SeekNotSupportedException_init_$Create$(message, $mask0, $marker) {
    var tmp = SeekNotSupportedException_init_$Init$(message, $mask0, $marker, Object.create(SeekNotSupportedException.prototype));
    captureStack(tmp, SeekNotSupportedException_init_$Create$);
    return tmp;
  }
  function SeekNotSupportedException(message) {
    UnsupportedOperationException_init_$Init$_0(message, this);
    captureStack(this, SeekNotSupportedException);
  }
  SeekNotSupportedException.$metadata$ = {
    simpleName: 'SeekNotSupportedException',
    kind: 'class',
    interfaces: []
  };
  function readAvailable(_this_, $cont) {
    return readAll(_this_, $cont);
  }
  function _no_name_provided__194($deque) {
    this._$deque = $deque;
  }
  _no_name_provided__194.prototype.write_ysdrhq_k$ = function (buffer, offset_0, len, $cont) {
    return this._$deque.write_ysdrhq_k$(buffer, offset_0, len, $cont);
  };
  _no_name_provided__194.prototype.write_majfzk_k$ = function (byte, $cont) {
    return this._$deque.write_majfzk_k$(byte, $cont);
  };
  _no_name_provided__194.prototype.close_sv8swh_k$ = function ($cont) {
    return this._$deque.close_sv8swh_k$($cont);
  };
  _no_name_provided__194.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncOutputStream]
  };
  function _no_name_provided__195($process, $deque, resultContinuation) {
    this._$process = $process;
    this._$deque_0 = $deque;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__195.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__195.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__195.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 4;
            this._exceptionState = 3;
            this._state_1 = 2;
            suspendResult = this._$process(new _no_name_provided__194(this._$deque_0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._tmp$ret$00_0 = suspendResult;
            this._exceptionState = 8;
            this._state_1 = 6;
            continue $sm;
          case 3:
            this._exceptionState = 4;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              this._e1_0 = this._exception_0;
              var tmp_1 = this;
              tmp_1._tmp$ret$00_0 = printStackTrace_0(this._e1_0);
              this._exceptionState = 8;
              this._state_1 = 6;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 8;
            this._t2 = this._exception_0;
            this._state_1 = 5;
            suspendResult = this._$deque_0.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            throw this._t2;
          case 6:
            this._state_1 = 7;
            suspendResult = this._$deque_0.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 8) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__195.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__195(this._$process, this._$deque_0, completion);
    return i;
  };
  _no_name_provided__195.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function checkException($this) {
  }
  function _no_name_provided__196($deque, $job) {
    this._$deque_1 = $deque;
    this._$job = $job;
  }
  _no_name_provided__196.prototype.read_irqg4d_k$ = function (buffer, offset_0, len, $cont) {
    checkException(this);
    return this._$deque_1.read_irqg4d_k$(buffer, offset_0, len, $cont);
  };
  _no_name_provided__196.prototype.read_0_k$ = function ($cont) {
    checkException(this);
    return this._$deque_1.read_0_k$($cont);
  };
  _no_name_provided__196.prototype.close_sv8swh_k$ = function ($cont) {
    this._$job.cancel$default_44too_k$(null, 1, null);
  };
  _no_name_provided__196.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncInputStream]
  };
  function _no_name_provided__197($array) {
    this._$array_1 = $array;
  }
  _no_name_provided__197.prototype.invoke_cbyp2q_k$ = function ($this$writeTempBytes) {
    writeArrayLE($this$writeTempBytes, 0, this._$array_1);
  };
  _no_name_provided__197.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_cbyp2q_k$((!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__197.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $getPositionCOROUTINE$183(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__86 = _this_;
  }
  $getPositionCOROUTINE$183.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this.__this__86._sync_0;
            var tmp0_safe_receiver = isInterface(tmp_1, SyncPositionStream) ? tmp_1 : null;
            tmp_0._tmp1_elvis_lhs0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_position__0_k$();
            if (this._tmp1_elvis_lhs0 == null) {
              this._state_1 = 1;
              suspendResult = AsyncGetPositionStream.prototype.getPosition_0_k$.call(this.__this__86, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT1_3 = this._tmp1_elvis_lhs0;
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1_3 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return this._WHEN_RESULT1_3;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getPositionCOROUTINE$183.$metadata$ = {
    simpleName: '$getPositionCOROUTINE$183',
    kind: 'class',
    interfaces: []
  };
  function $getLengthCOROUTINE$184(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__87 = _this_;
  }
  $getLengthCOROUTINE$184.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this.__this__87._sync_0;
            var tmp0_safe_receiver = isInterface(tmp_1, SyncLengthStream) ? tmp_1 : null;
            tmp_0._tmp1_elvis_lhs0_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_length__0_k$();
            if (this._tmp1_elvis_lhs0_0 == null) {
              this._state_1 = 1;
              suspendResult = AsyncGetLengthStream.prototype.getLength_0_k$.call(this.__this__87, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT1_4 = this._tmp1_elvis_lhs0_0;
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1_4 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return this._WHEN_RESULT1_4;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getLengthCOROUTINE$184.$metadata$ = {
    simpleName: '$getLengthCOROUTINE$184',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__198($this_toAsyncInputStream) {
    this._$this_toAsyncInputStream = $this_toAsyncInputStream;
    this._sync_0 = this._$this_toAsyncInputStream;
  }
  _no_name_provided__198.prototype.read_irqg4d_k$ = function (buffer, offset_0, len, $cont) {
    return this._sync_0.read_irqg4d_k$(buffer, offset_0, len);
  };
  _no_name_provided__198.prototype.close_sv8swh_k$ = function ($cont) {
    var tmp = this._sync_0;
    var tmp0_safe_receiver_2 = isInterface(tmp, Closeable) ? tmp : null;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.close_sv8swh_k$();
      Unit_getInstance();
    }
    return Unit_getInstance();
  };
  _no_name_provided__198.prototype.getPosition_0_k$ = function ($cont) {
    var tmp = new $getPositionCOROUTINE$183(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__198.prototype.getLength_0_k$ = function ($cont) {
    var tmp = new $getLengthCOROUTINE$184(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__198.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncInputStreamWithLength]
  };
  function _no_name_provided__199($this_toAsyncOutputStream) {
    this._$this_toAsyncOutputStream = $this_toAsyncOutputStream;
  }
  _no_name_provided__199.prototype.write_ysdrhq_k$ = function (buffer, offset_0, len, $cont) {
    return this._$this_toAsyncOutputStream.write_ysdrhq_k$(buffer, offset_0, len);
  };
  _no_name_provided__199.prototype.close_sv8swh_k$ = function ($cont) {
    var tmp = this._$this_toAsyncOutputStream;
    var tmp0_safe_receiver_2 = isInterface(tmp, Closeable) ? tmp : null;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.close_sv8swh_k$();
      Unit_getInstance();
    }
    return Unit_getInstance();
  };
  _no_name_provided__199.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncOutputStream]
  };
  function checkPosition($this, position_0) {
    if (!position_0.equals($this._expectedPosition)) {
      throw SeekNotSupportedException_init_$Create$(null, 1, null);
    }}
  function $readCOROUTINE$185(_this_, position_0, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__88 = _this_;
    this._position_8 = position_0;
    this._buffer_21 = buffer;
    this._offset_18 = offset_0;
    this._len_15 = len;
  }
  $readCOROUTINE$185.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            if (this.__this__88._$input_2 == null)
              throw UnsupportedOperationException_init_$Create$();
            checkPosition(this.__this__88, this._position_8);
            this._state_1 = 1;
            suspendResult = this.__this__88._$input_2.read_irqg4d_k$(this._buffer_21, this._offset_18, this._len_15, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var read_0 = suspendResult;
            if (read_0 > 0) {
              var tmp0_this = this.__this__88;
              var tmp_0 = tmp0_this;
              var tmp0_plus_0 = tmp0_this._expectedPosition;
              tmp_0._expectedPosition = tmp0_plus_0.plus_wiekkq_k$(toLong(read_0));
            }
            return read_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$185.$metadata$ = {
    simpleName: '$readCOROUTINE$185',
    kind: 'class',
    interfaces: []
  };
  function $writeCOROUTINE$186(_this_, position_0, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__89 = _this_;
    this._position_9 = position_0;
    this._buffer_22 = buffer;
    this._offset_19 = offset_0;
    this._len_16 = len;
  }
  $writeCOROUTINE$186.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            if (this.__this__89._$output == null)
              throw UnsupportedOperationException_init_$Create$();
            checkPosition(this.__this__89, this._position_9);
            this._state_1 = 1;
            suspendResult = this.__this__89._$output.write_ysdrhq_k$(this._buffer_22, this._offset_19, this._len_16, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_this = this.__this__89;
            var tmp_0 = tmp0_this;
            var tmp0_plus_0 = tmp0_this._expectedPosition;
            tmp_0._expectedPosition = tmp0_plus_0.plus_wiekkq_k$(toLong(this._len_16));
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$186.$metadata$ = {
    simpleName: '$writeCOROUTINE$186',
    kind: 'class',
    interfaces: []
  };
  function $getLengthCOROUTINE$188(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__90 = _this_;
  }
  $getLengthCOROUTINE$188.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._tmp0_safe_receiver0_2 = this.__this__90._$rlenGet;
            if (this._tmp0_safe_receiver0_2 == null) {
              this._WHEN_RESULT1_5 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0_2.getLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1_5 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = this._WHEN_RESULT1_5;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              throw UnsupportedOperationException_init_$Create$();
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            return tmp_0;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getLengthCOROUTINE$188.$metadata$ = {
    simpleName: '$getLengthCOROUTINE$188',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__200($input, $output, $rlenSet, $rlenGet, $closeable) {
    this._$input_2 = $input;
    this._$output = $output;
    this._$rlenSet = $rlenSet;
    this._$rlenGet = $rlenGet;
    this._$closeable = $closeable;
    AsyncStreamBase.call(this);
    this._expectedPosition = new Long(0, 0);
  }
  _no_name_provided__200.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    var tmp = new $readCOROUTINE$185(this, position_0, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__200.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len, $cont) {
    var tmp = new $writeCOROUTINE$186(this, position_0, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__200.prototype.getLength_0_k$ = function ($cont) {
    var tmp = new $getLengthCOROUTINE$188(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__200.prototype.close_sv8swh_k$ = function ($cont) {
    return this._$closeable.close_sv8swh_k$($cont);
  };
  _no_name_provided__200.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $readCOROUTINE$189(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__91 = _this_;
    this._buffer_23 = buffer;
    this._offset_20 = offset_0;
    this._len_17 = len;
  }
  $readCOROUTINE$189.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__91._$base.read_irqg4d_k$(this._buffer_23, this._offset_20, this._len_17, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var read_0 = suspendResult;
            if (read_0 >= 0) {
              var tmp0_plus_0 = this.__this__91._$currentPos._v;
              this.__this__91._$currentPos._v = tmp0_plus_0.plus_wiekkq_k$(toLong(read_0));
            }
            return read_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$189.$metadata$ = {
    simpleName: '$readCOROUTINE$189',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__201($base, $currentPos, $length) {
    this._$base = $base;
    this._$currentPos = $currentPos;
    this._$length = $length;
    this._$$delegate_0_13 = this._$base;
  }
  _no_name_provided__201.prototype.read_0_k$ = function ($cont) {
    return this._$$delegate_0_13.read_0_k$($cont);
  };
  _no_name_provided__201.prototype.close_sv8swh_k$ = function ($cont) {
    return this._$$delegate_0_13.close_sv8swh_k$($cont);
  };
  _no_name_provided__201.prototype.read_irqg4d_k$ = function (buffer, offset_0, len, $cont) {
    var tmp = new $readCOROUTINE$189(this, buffer, offset_0, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__201.prototype.getPosition_0_k$ = function ($cont) {
    return this._$currentPos._v;
  };
  _no_name_provided__201.prototype.getLength_0_k$ = function ($cont) {
    return this._$length;
  };
  _no_name_provided__201.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncInputStream, AsyncGetLengthStream, AsyncGetPositionStream]
  };
  function $readAllCOROUTINE$149(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__92 = _this_;
  }
  $readAllCOROUTINE$149.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 18;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 16;
            var tmp_0;
            var tmp_1 = this.__this__92;
            if (isInterface(tmp_1, AsyncGetPositionStream)) {
              var tmp_2 = this.__this__92;
              tmp_0 = isInterface(tmp_2, AsyncGetLengthStream);
            } else {
              {
                tmp_0 = false;
              }
            }

            if (tmp_0) {
              this._state_1 = 10;
              suspendResult = this.__this__92.getLength_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                var tmp_3 = this.__this__92;
                if (tmp_3 instanceof AsyncStream) {
                  this._state_1 = 2;
                  suspendResult = this.__this__92.hasAvailable_0_k$(this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    this._WHEN_RESULT2_0 = false;
                    this._state_1 = 3;
                    continue $sm;
                  }
                }
                Unit_getInstance();
              }
            }

            break;
          case 2:
            this._WHEN_RESULT2_0 = suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (this._WHEN_RESULT2_0) {
              this._state_1 = 8;
              suspendResult = this.__this__92.getAvailable_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              var tmp_4 = this;
              tmp_4._out3 = ByteArrayBuilder_init_$Create$_1(0, 1, null);
              this._temp4 = new Int8Array(4096);
              this._state_1 = 4;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 4:
            if (false) {
              this._state_1 = 7;
              continue $sm;
            }
            this._state_1 = 5;
            suspendResult = this.__this__92.read_irqg4d_k$(this._temp4, 0, this._temp4.length, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._r5 = suspendResult;
            if (this._r5 <= 0) {
              this._state_1 = 7;
              continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 6:
            this._out3.append_ysdrhq_k$(this._temp4, 0, this._r5);
            this._state_1 = 4;
            continue $sm;
          case 7:
            this._WHEN_RESULT1_6 = this._out3.toByteArray_0_k$();
            this._state_1 = 13;
            continue $sm;
          case 8:
            this._ARGUMENT6 = suspendResult;
            this._available7 = this._ARGUMENT6.toInt_0_k$();
            this._state_1 = 9;
            suspendResult = readBytesExact(this.__this__92, this._available7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._WHEN_RESULT1_6 = suspendResult;
            this._state_1 = 13;
            continue $sm;
          case 10:
            this._ARGUMENT8_0 = suspendResult;
            this._state_1 = 11;
            suspendResult = this.__this__92.getPosition_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._ARGUMENT9 = suspendResult;
            this._available10 = this._ARGUMENT8_0.minus_wiekkq_k$(this._ARGUMENT9);
            this._state_1 = 12;
            suspendResult = readBytesExact(this.__this__92, this._available10.toInt_0_k$(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._WHEN_RESULT1_6 = suspendResult;
            this._state_1 = 13;
            continue $sm;
          case 13:
            this._tmp$ret$00_1 = this._WHEN_RESULT1_6;
            this._exceptionState = 18;
            this._state_1 = 14;
            continue $sm;
          case 14:
            this._tmp11 = this._tmp$ret$00_1;
            this._state_1 = 15;
            suspendResult = this.__this__92.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 15:
            return this._tmp11;
          case 16:
            this._exceptionState = 18;
            this._t12 = this._exception_0;
            this._state_1 = 17;
            suspendResult = this.__this__92.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 17:
            throw this._t12;
          case 18:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 18) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAllCOROUTINE$149.$metadata$ = {
    simpleName: '$readAllCOROUTINE$149',
    kind: 'class',
    interfaces: []
  };
  function $readS32BECOROUTINE$152(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__93 = _this_;
  }
  $readS32BECOROUTINE$152.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_allocThis_01 = _get_smallBytesPool_();
            this._temp_12_1 = this._tmp0_allocThis_01.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__93.read_irqg4d_k$(this._temp_12_1, 0, 4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_2_3 = suspendResult;
            if (!(read_2_3 === 4)) {
              var tmp0_error_0_4 = '' + "Couldn't read exact size=4 but read=" + read_2_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4));
            }
            var tmp_1 = this;
            tmp_1._tmp$ret$04_1 = readS32BE(this._temp_12_1, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_2 = this;
            continue $sm;
          case 5:
            var tmp_3 = this._tmp$ret$04_1;
            this._tmp0_allocThis_01.free_iav7o_k$(this._temp_12_1);
            this._tmp$ret$40_1 = tmp_3;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_01.free_iav7o_k$(this._temp_12_1);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$40_1;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_01.free_iav7o_k$(this._temp_12_1);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS32BECOROUTINE$152.$metadata$ = {
    simpleName: '$readS32BECOROUTINE$152',
    kind: 'class',
    interfaces: []
  };
  function $readBytesExactCOROUTINE$153(_this_, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__94 = _this_;
    this._len_18 = len;
  }
  $readBytesExactCOROUTINE$153.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_apply_00 = new Int8Array(this._len_18);
            this._state_1 = 1;
            suspendResult = readExact(this.__this__94, this._tmp0_apply_00, 0, this._len_18, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return this._tmp0_apply_00;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesExactCOROUTINE$153.$metadata$ = {
    simpleName: '$readBytesExactCOROUTINE$153',
    kind: 'class',
    interfaces: []
  };
  function $readExactCOROUTINE$157(_this_, buffer, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__95 = _this_;
    this._buffer_24 = buffer;
    this._offset_21 = offset_0;
    this._len_19 = len;
  }
  $readExactCOROUTINE$157.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._remaining0 = this._len_19;
            this._coffset1 = this._offset_21;
            this._reader2_0 = this.__this__95;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this._remaining0 > 0)) {
              this._state_1 = 4;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = this._reader2_0.read_irqg4d_k$(this._buffer_24, this._coffset1, this._remaining0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var read_0 = suspendResult;
            if (read_0 < 0) {
              this._state_1 = 4;
              continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            if (read_0 === 0)
              throw new EOFException('' + 'Not enough data. Expected=' + this._len_19 + ', Read=' + (this._len_19 - this._remaining0 | 0) + ', Remaining=' + this._remaining0);
            this._coffset1 = this._coffset1 + read_0 | 0;
            this._remaining0 = this._remaining0 - read_0 | 0;
            this._state_1 = 1;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readExactCOROUTINE$157.$metadata$ = {
    simpleName: '$readExactCOROUTINE$157',
    kind: 'class',
    interfaces: []
  };
  function $readBytesCOROUTINE$158(_this_, position_0, count_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__96 = _this_;
    this._position_10 = position_0;
    this._count_7 = count_0;
  }
  $readBytesCOROUTINE$158.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._out0 = new Int8Array(this._count_7);
            this._state_1 = 1;
            suspendResult = this.__this__96.read_pwamfb_k$(this._position_10, this._out0, 0, this._out0.length, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var readLen = suspendResult;
            return copyOf(this._out0, readLen);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesCOROUTINE$158.$metadata$ = {
    simpleName: '$readBytesCOROUTINE$158',
    kind: 'class',
    interfaces: []
  };
  function $readBytesUpToCOROUTINE$160(_this_, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__97 = _this_;
    this._len_20 = len;
  }
  $readBytesUpToCOROUTINE$160.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._BYTES_TEMP_SIZE0 = 4096;
            if (this._len_20 <= this._BYTES_TEMP_SIZE0) {
              this._state_1 = 9;
              suspendResult = readBytesUpToCopy(this.__this__97, new Int8Array(this._len_20), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            var tmp_0 = this.__this__97;
            if (isInterface(tmp_0, AsyncPositionLengthStream)) {
              this._state_1 = 7;
              suspendResult = getAvailable(this.__this__97, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 2;
                continue $sm;
              }
            }

            break;
          case 2:
            this._pending1 = this._len_20;
            this._temp2_0 = new Int8Array(this._BYTES_TEMP_SIZE0);
            var tmp_1 = this;
            tmp_1._bout3 = ByteArrayBuilder_init_$Create$_1(0, 1, null);
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (!(this._pending1 > 0)) {
              this._state_1 = 6;
              continue $sm;
            }
            this._state_1 = 4;
            var tmp_2 = this;
            tmp_2._tmp1_min_04 = this._temp2_0.length;
            var tmp_3 = this;
            tmp_3._tmp2_min_05 = this._pending1;
            suspendResult = this.__this__97.read_irqg4d_k$(this._temp2_0, 0, Math.min(this._tmp1_min_04, this._tmp2_min_05), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._read6 = suspendResult;
            if (this._read6 <= 0) {
              this._state_1 = 6;
              continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._bout3.append_ysdrhq_k$(this._temp2_0, 0, this._read6);
            this._pending1 = this._pending1 - this._read6 | 0;
            this._state_1 = 3;
            continue $sm;
          case 6:
            return this._bout3.toByteArray_0_k$();
          case 7:
            this._ARGUMENT7 = suspendResult;
            var tmp_4 = this;
            tmp_4._tmp0_min_08 = toIntClamp$default(this._ARGUMENT7, 0, 0, 3, null);
            this._ARGUMENT9_0 = Math.min(this._len_20, this._tmp0_min_08);
            this._ARGUMENT10 = new Int8Array(this._ARGUMENT9_0);
            this._state_1 = 8;
            suspendResult = readBytesUpToCopy(this.__this__97, this._ARGUMENT10, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            return suspendResult;
          case 9:
            return suspendResult;
          case 10:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesUpToCOROUTINE$160.$metadata$ = {
    simpleName: '$readBytesUpToCOROUTINE$160',
    kind: 'class',
    interfaces: []
  };
  function $write32LECOROUTINE$161(_this_, v, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__98 = _this_;
    this._v_3 = v;
  }
  $write32LECOROUTINE$161.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_alloc_01_1 = _get_smallBytesPool_();
            this._temp_12_2 = this._tmp0_alloc_01_1.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            write32LE(this._temp_12_2, 0, this._v_3);
            this._state_1 = 4;
            suspendResult = this.__this__98.write_ysdrhq_k$(this._temp_12_2, 0, 4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$04_2 = suspendResult;
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_1 = this;
            continue $sm;
          case 5:
            var tmp_2 = this;
            tmp_2._tmp$ret$40_2 = this._tmp0_alloc_01_1.free_iav7o_k$(this._temp_12_2);
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_alloc_01_1.free_iav7o_k$(this._temp_12_2);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_alloc_01_1.free_iav7o_k$(this._temp_12_2);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $write32LECOROUTINE$161.$metadata$ = {
    simpleName: '$write32LECOROUTINE$161',
    kind: 'class',
    interfaces: []
  };
  function $readBytesUpToCopyCOROUTINE$163(_this_, out, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__99 = _this_;
    this._out_4 = out;
  }
  $readBytesUpToCopyCOROUTINE$163.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readBytesUpTo_0(this.__this__99, this._out_4, 0, this._out_4.length, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var pos = suspendResult;
            return this._out_4.length === pos ? this._out_4 : copyOf(this._out_4, pos);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesUpToCopyCOROUTINE$163.$metadata$ = {
    simpleName: '$readBytesUpToCopyCOROUTINE$163',
    kind: 'class',
    interfaces: []
  };
  function $getAvailableCOROUTINE$164(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__100 = _this_;
  }
  $getAvailableCOROUTINE$164.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__100.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_16 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__100.getPosition_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this._ARGUMENT0_16.minus_wiekkq_k$(ARGUMENT);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getAvailableCOROUTINE$164.$metadata$ = {
    simpleName: '$getAvailableCOROUTINE$164',
    kind: 'class',
    interfaces: []
  };
  function $readBytesUpToCOROUTINE$165(_this_, out, offset_0, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__101 = _this_;
    this._out_5 = out;
    this._offset_22 = offset_0;
    this._len_21 = len;
  }
  $readBytesUpToCOROUTINE$165.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._total0 = 0;
            this._pending1_0 = this._len_21;
            this._offset2 = this._offset_22;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this._state_1 = 5;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = this.__this__101.read_irqg4d_k$(this._out_5, this._offset2, this._pending1_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var result = suspendResult;
            if (result <= 0) {
              this._state_1 = 5;
              continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._offset2 = this._offset2 + result | 0;
            this._pending1_0 = this._pending1_0 - result | 0;
            this._total0 = this._total0 + result | 0;
            this._state_1 = 1;
            continue $sm;
          case 4:
            throw this._exception_0;
          case 5:
            return this._total0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesUpToCOROUTINE$165.$metadata$ = {
    simpleName: '$readBytesUpToCOROUTINE$165',
    kind: 'class',
    interfaces: []
  };
  function $getAvailableCOROUTINE$166(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__102 = _this_;
  }
  $getAvailableCOROUTINE$166.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__102.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_17 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__102.getPosition_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this._ARGUMENT0_17.minus_wiekkq_k$(ARGUMENT);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getAvailableCOROUTINE$166.$metadata$ = {
    simpleName: '$getAvailableCOROUTINE$166',
    kind: 'class',
    interfaces: []
  };
  function $write16LECOROUTINE$167(_this_, v, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__103 = _this_;
    this._v_4 = v;
  }
  $write16LECOROUTINE$167.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_alloc_01_2 = _get_smallBytesPool_();
            this._temp_12_3 = this._tmp0_alloc_01_2.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            write16LE(this._temp_12_3, 0, this._v_4);
            this._state_1 = 4;
            suspendResult = this.__this__103.write_ysdrhq_k$(this._temp_12_3, 0, 2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$04_3 = suspendResult;
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_1 = this;
            continue $sm;
          case 5:
            var tmp_2 = this;
            tmp_2._tmp$ret$40_3 = this._tmp0_alloc_01_2.free_iav7o_k$(this._temp_12_3);
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_alloc_01_2.free_iav7o_k$(this._temp_12_3);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_alloc_01_2.free_iav7o_k$(this._temp_12_3);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $write16LECOROUTINE$167.$metadata$ = {
    simpleName: '$write16LECOROUTINE$167',
    kind: 'class',
    interfaces: []
  };
  function $hasAvailableCOROUTINE$168(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__104 = _this_;
  }
  $hasAvailableCOROUTINE$168.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = getAvailable_0(this.__this__104, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.compareTo_wiekkq_k$(new Long(0, 0)) > 0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $hasAvailableCOROUTINE$168.$metadata$ = {
    simpleName: '$hasAvailableCOROUTINE$168',
    kind: 'class',
    interfaces: []
  };
  function $readStringCOROUTINE$170(_this_, len, charset, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__105 = _this_;
    this._len_22 = len;
    this._charset_1 = charset;
  }
  $readStringCOROUTINE$170.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readBytesExact(this.__this__105, this._len_22, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return toString$default(ARGUMENT, this._charset_1, 0, 0, 6, null);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readStringCOROUTINE$170.$metadata$ = {
    simpleName: '$readStringCOROUTINE$170',
    kind: 'class',
    interfaces: []
  };
  function $readS8COROUTINE$171(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__106 = _this_;
  }
  $readS8COROUTINE$171.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__106.read_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = toByte(ARGUMENT);
            return ARGUMENT_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS8COROUTINE$171.$metadata$ = {
    simpleName: '$readS8COROUTINE$171',
    kind: 'class',
    interfaces: []
  };
  function $readS64LECOROUTINE$172(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__107 = _this_;
  }
  $readS64LECOROUTINE$172.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_allocThis_0_11 = _get_smallBytesPool_();
            this._temp_1_22 = this._tmp0_allocThis_0_11.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__107.read_irqg4d_k$(this._temp_1_22, 0, 8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_3_3 = suspendResult;
            if (!(read_3_3 === 8)) {
              var tmp0_error_0_4_4 = '' + "Couldn't read exact size=8 but read=" + read_3_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4_4));
            }
            var tmp_1 = this;
            tmp_1._tmp$ret$04_4 = readS64LE(this._temp_1_22, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_2 = this;
            continue $sm;
          case 5:
            var tmp_3 = this._tmp$ret$04_4;
            this._tmp0_allocThis_0_11.free_iav7o_k$(this._temp_1_22);
            this._tmp$ret$40_4 = tmp_3;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_0_11.free_iav7o_k$(this._temp_1_22);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$40_4;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_0_11.free_iav7o_k$(this._temp_1_22);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS64LECOROUTINE$172.$metadata$ = {
    simpleName: '$readS64LECOROUTINE$172',
    kind: 'class',
    interfaces: []
  };
  function $readS32LECOROUTINE$173(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__108 = _this_;
  }
  $readS32LECOROUTINE$173.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_allocThis_0_11_0 = _get_smallBytesPool_();
            this._temp_1_22_0 = this._tmp0_allocThis_0_11_0.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__108.read_irqg4d_k$(this._temp_1_22_0, 0, 4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_3_3 = suspendResult;
            if (!(read_3_3 === 4)) {
              var tmp0_error_0_4_4 = '' + "Couldn't read exact size=4 but read=" + read_3_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4_4));
            }
            var tmp_1 = this;
            tmp_1._tmp$ret$04_5 = readS32LE(this._temp_1_22_0, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_2 = this;
            continue $sm;
          case 5:
            var tmp_3 = this._tmp$ret$04_5;
            this._tmp0_allocThis_0_11_0.free_iav7o_k$(this._temp_1_22_0);
            this._tmp$ret$40_5 = tmp_3;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_0_11_0.free_iav7o_k$(this._temp_1_22_0);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$40_5;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_0_11_0.free_iav7o_k$(this._temp_1_22_0);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS32LECOROUTINE$173.$metadata$ = {
    simpleName: '$readS32LECOROUTINE$173',
    kind: 'class',
    interfaces: []
  };
  function $readS16LECOROUTINE$174(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__109 = _this_;
  }
  $readS16LECOROUTINE$174.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_allocThis_0_11_1 = _get_smallBytesPool_();
            this._temp_1_22_1 = this._tmp0_allocThis_0_11_1.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__109.read_irqg4d_k$(this._temp_1_22_1, 0, 2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_3_3 = suspendResult;
            if (!(read_3_3 === 2)) {
              var tmp0_error_0_4_4 = '' + "Couldn't read exact size=2 but read=" + read_3_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4_4));
            }
            var tmp_1 = this;
            tmp_1._tmp$ret$04_6 = readS16LE(this._temp_1_22_1, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_2 = this;
            continue $sm;
          case 5:
            var tmp_3 = this._tmp$ret$04_6;
            this._tmp0_allocThis_0_11_1.free_iav7o_k$(this._temp_1_22_1);
            this._tmp$ret$40_6 = tmp_3;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_0_11_1.free_iav7o_k$(this._temp_1_22_1);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$40_6;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_0_11_1.free_iav7o_k$(this._temp_1_22_1);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS16LECOROUTINE$174.$metadata$ = {
    simpleName: '$readS16LECOROUTINE$174',
    kind: 'class',
    interfaces: []
  };
  function $readU32LECOROUTINE$175(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__110 = _this_;
  }
  $readU32LECOROUTINE$175.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_allocThis_0_11_2 = _get_smallBytesPool_();
            this._temp_1_22_2 = this._tmp0_allocThis_0_11_2.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__110.read_irqg4d_k$(this._temp_1_22_2, 0, 4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_3_3 = suspendResult;
            if (!(read_3_3 === 4)) {
              var tmp0_error_0_4_4 = '' + "Couldn't read exact size=4 but read=" + read_3_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4_4));
            }
            var tmp_1 = this;
            tmp_1._tmp$ret$04_7 = readU32LE(this._temp_1_22_2, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_2 = this;
            continue $sm;
          case 5:
            var tmp_3 = this._tmp$ret$04_7;
            this._tmp0_allocThis_0_11_2.free_iav7o_k$(this._temp_1_22_2);
            this._tmp$ret$40_7 = tmp_3;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_0_11_2.free_iav7o_k$(this._temp_1_22_2);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$40_7;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_0_11_2.free_iav7o_k$(this._temp_1_22_2);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readU32LECOROUTINE$175.$metadata$ = {
    simpleName: '$readU32LECOROUTINE$175',
    kind: 'class',
    interfaces: []
  };
  function $write32BECOROUTINE$176(_this_, v, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__111 = _this_;
    this._v_5 = v;
  }
  $write32BECOROUTINE$176.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_alloc_01_3 = _get_smallBytesPool_();
            this._temp_12_4 = this._tmp0_alloc_01_3.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            write32BE(this._temp_12_4, 0, this._v_5);
            this._state_1 = 4;
            suspendResult = this.__this__111.write_ysdrhq_k$(this._temp_12_4, 0, 4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$04_8 = suspendResult;
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_1 = this;
            continue $sm;
          case 5:
            var tmp_2 = this;
            tmp_2._tmp$ret$40_8 = this._tmp0_alloc_01_3.free_iav7o_k$(this._temp_12_4);
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_alloc_01_3.free_iav7o_k$(this._temp_12_4);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_alloc_01_3.free_iav7o_k$(this._temp_12_4);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $write32BECOROUTINE$176.$metadata$ = {
    simpleName: '$write32BECOROUTINE$176',
    kind: 'class',
    interfaces: []
  };
  function $readSliceCOROUTINE$177(_this_, length, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__112 = _this_;
    this._length_1 = length;
  }
  $readSliceCOROUTINE$177.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this.__this__112.getPosition_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._start0 = suspendResult;
            this._state_1 = 2;
            suspendResult = sliceWithSize$default(this.__this__112, this._start0, this._length_1, false, 4, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._out1 = suspendResult;
            this._state_1 = 3;
            suspendResult = this.__this__112.setPosition_kdfck9_k$(this._start0.plus_wiekkq_k$(this._length_1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return this._out1;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readSliceCOROUTINE$177.$metadata$ = {
    simpleName: '$readSliceCOROUTINE$177',
    kind: 'class',
    interfaces: []
  };
  function $writeTempBytesCOROUTINE$178(_this_, size_2, block, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__113 = _this_;
    this._size_11 = size_2;
    this._block_1 = block;
  }
  $writeTempBytesCOROUTINE$178.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            if (this._size_11 <= 65536) {
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              var tmp_0 = this;
              tmp_0._tmp1_apply_01 = new Int8Array(this._size_11);
              this._block_1(this._tmp1_apply_01);
              suspendResult = this.__this__113.write$default_ffc7am_k$(this._tmp1_apply_01, 0, 0, 6, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._state_1 = 9;
            continue $sm;
          case 2:
            var tmp_1 = this;
            tmp_1._tmp0_allocThis_02 = _get_bytesTempPool_();
            this._temp_13 = this._tmp0_allocThis_02.alloc_0_k$();
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._state_1 = 4;
            continue $sm;
          case 4:
            this._exceptionState = 10;
            this._state_1 = 5;
            this._block_1(this._temp_13);
            suspendResult = this.__this__113.write_ysdrhq_k$(this._temp_13, 0, this._size_11, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._tmp$ret$05_0 = suspendResult;
            this._exceptionState = 11;
            this._state_1 = 6;
            var tmp_2 = this;
            continue $sm;
          case 6:
            var tmp_3 = this;
            tmp_3._tmp$ret$40_9 = this._tmp0_allocThis_02.free_iav7o_k$(this._temp_13);
            this._state_1 = 8;
            continue $sm;
          case 7:
            this._tmp0_allocThis_02.free_iav7o_k$(this._temp_13);
            if (false) {
              this._state_1 = 2;
              continue $sm;
            }
            this._state_1 = 8;
            continue $sm;
          case 8:
            this._state_1 = 9;
            continue $sm;
          case 9:
            return Unit_getInstance();
          case 10:
            this._exceptionState = 11;
            var t = this._exception_0;
            this._tmp0_allocThis_02.free_iav7o_k$(this._temp_13);
            throw t;
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeTempBytesCOROUTINE$178.$metadata$ = {
    simpleName: '$writeTempBytesCOROUTINE$178',
    kind: 'class',
    interfaces: []
  };
  function $sliceWithBoundsCOROUTINE$179(_this_, start, end, closeParent, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__114 = _this_;
    this._start_0 = start;
    this._end_0 = end;
    this._closeParent_0 = closeParent;
  }
  $sliceWithBoundsCOROUTINE$179.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__114.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var len = suspendResult;
            var clampedStart = clamp_5(this._start_0, new Long(0, 0), len);
            var clampedEnd = clamp_5(this._end_0, new Long(0, 0), len);
            var tmp_0;
            var tmp_1 = this.__this__114._base;
            if (tmp_1 instanceof SliceAsyncStreamBase) {
              var tmp_2 = new SliceAsyncStreamBase(this.__this__114._base._base_1, this.__this__114._base._baseStart.plus_wiekkq_k$(clampedStart), this.__this__114._base._baseStart.plus_wiekkq_k$(clampedEnd), this._closeParent_0);
              tmp_0 = toAsyncStream$default(tmp_2, new Long(0, 0), 1, null);
            } else {
              {
                var tmp_3 = new SliceAsyncStreamBase(this.__this__114._base, clampedStart, clampedEnd, this._closeParent_0);
                tmp_0 = toAsyncStream$default(tmp_3, new Long(0, 0), 1, null);
              }
            }

            return tmp_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sliceWithBoundsCOROUTINE$179.$metadata$ = {
    simpleName: '$sliceWithBoundsCOROUTINE$179',
    kind: 'class',
    interfaces: []
  };
  function $sliceStartCOROUTINE$181(_this_, start, closeParent, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__115 = _this_;
    this._start_1 = start;
    this._closeParent_1 = closeParent;
  }
  $sliceStartCOROUTINE$181.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__115.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_18 = suspendResult;
            this._state_1 = 2;
            suspendResult = sliceWithBounds(this.__this__115, this._start_1, this._ARGUMENT0_18, this._closeParent_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sliceStartCOROUTINE$181.$metadata$ = {
    simpleName: '$sliceStartCOROUTINE$181',
    kind: 'class',
    interfaces: []
  };
  function $readU16LECOROUTINE$182(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__116 = _this_;
  }
  $readU16LECOROUTINE$182.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_allocThis_0_11_3 = _get_smallBytesPool_();
            this._temp_1_22_3 = this._tmp0_allocThis_0_11_3.alloc_0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__116.read_irqg4d_k$(this._temp_1_22_3, 0, 2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_3_3 = suspendResult;
            if (!(read_3_3 === 2)) {
              var tmp0_error_0_4_4 = '' + "Couldn't read exact size=2 but read=" + read_3_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4_4));
            }
            var tmp_1 = this;
            tmp_1._tmp$ret$04_9 = readU16LE(this._temp_1_22_3, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_2 = this;
            continue $sm;
          case 5:
            var tmp_3 = this._tmp$ret$04_9;
            this._tmp0_allocThis_0_11_3.free_iav7o_k$(this._temp_1_22_3);
            this._tmp$ret$40_10 = tmp_3;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_0_11_3.free_iav7o_k$(this._temp_1_22_3);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$40_10;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_0_11_3.free_iav7o_k$(this._temp_1_22_3);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readU16LECOROUTINE$182.$metadata$ = {
    simpleName: '$readU16LECOROUTINE$182',
    kind: 'class',
    interfaces: []
  };
  function readQueue$factory() {
    return getPropertyCallableRef('readQueue', 1, KProperty1, function (receiver) {
      return _get_readQueue_(receiver);
    }, null);
  }
  function writeQueue$factory() {
    return getPropertyCallableRef('writeQueue', 1, KProperty1, function (receiver) {
      return _get_writeQueue_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_153() {
    var i = new _no_name_provided__190();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_154() {
    var i = new _no_name_provided__191();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_155(this$0, $buffer, $offset, $len, resultContinuation) {
    var i = new _no_name_provided__192(this$0, $buffer, $offset, $len, resultContinuation);
    var l = function ($cont) {
      return i.invoke_0_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_156(this$0, $buffer, $offset, $len, resultContinuation) {
    var i = new _no_name_provided__193(this$0, $buffer, $offset, $len, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_157($process, $deque, resultContinuation) {
    var i = new _no_name_provided__195($process, $deque, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_158($array) {
    var i = new _no_name_provided__197($array);
    return function (p1) {
      i.invoke_cbyp2q_k$(p1);
      return Unit_getInstance();
    };
  }
  function FastByteArrayInputStream_init_$Init$(ba, offset_0, start, end, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      offset_0 = 0;
    if (!(($mask0 & 4) === 0))
      start = 0;
    if (!(($mask0 & 8) === 0))
      end = ba.length;
    FastByteArrayInputStream.call($this, ba, offset_0, start, end);
    return $this;
  }
  function FastByteArrayInputStream_init_$Create$(ba, offset_0, start, end, $mask0, $marker) {
    return FastByteArrayInputStream_init_$Init$(ba, offset_0, start, end, $mask0, $marker, Object.create(FastByteArrayInputStream.prototype));
  }
  function offset($this, count_0) {
    var out = $this._offset_23;
    var tmp0_this = $this;
    tmp0_this._offset_23 = tmp0_this._offset_23 + count_0 | 0;
    return out;
  }
  function FastByteArrayInputStream(ba, offset_0, start, end) {
    this._ba = ba;
    this._start_2 = start;
    this._end_1 = end;
    this._offset_23 = offset_0 + this._start_2 | 0;
  }
  FastByteArrayInputStream.prototype._set_position__majfzk_k$ = function (value) {
    this._offset_23 = this._start_2 + value | 0;
  };
  FastByteArrayInputStream.prototype._get_position__0_k$ = function () {
    return this._offset_23 - this._start_2 | 0;
  };
  FastByteArrayInputStream.prototype.coerceRange_quadv7_k$ = function (_this__0) {
    return coerceIn(_this__0, this._start_2, this._end_1);
  };
  FastByteArrayInputStream.prototype.extractString_470xh9_k$ = function (offset_0, length, charset) {
    var start = this._start_2 + offset_0 | 0;
    var end = start + length | 0;
    return toString_3(this._ba, charset, start, end);
  };
  FastByteArrayInputStream.prototype.readSlice_ha5a7z_k$ = function (size_2) {
    var out = this.sliceWithSize_27zxwg_k$(this._get_position__0_k$(), size_2);
    var tmp0_this = this;
    tmp0_this._offset_23 = tmp0_this._offset_23 + size_2 | 0;
    return out;
  };
  FastByteArrayInputStream.prototype.sliceStart_ha5a7z_k$ = function (offset_0) {
    return new FastByteArrayInputStream(this._ba, 0, this.coerceRange_quadv7_k$(this._start_2 + offset_0 | 0), this._end_1);
  };
  FastByteArrayInputStream.prototype.sliceStart$default_l3mjq9_k$ = function (offset_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset_0 = 0;
    return this.sliceStart_ha5a7z_k$(offset_0);
  };
  FastByteArrayInputStream.prototype.clone_0_k$ = function () {
    return new FastByteArrayInputStream(this._ba, this._get_position__0_k$(), this._start_2, this._end_1);
  };
  FastByteArrayInputStream.prototype.sliceWithSize_27zxwg_k$ = function (offset_0, len) {
    return new FastByteArrayInputStream(this._ba, 0, this.coerceRange_quadv7_k$(this._start_2 + offset_0 | 0), this.coerceRange_quadv7_k$((this._start_2 + offset_0 | 0) + len | 0));
  };
  FastByteArrayInputStream.prototype.readBytesExact_ha5a7z_k$ = function (len) {
    var out_1 = copyOfRange_2(this._ba, this._offset_23, this._offset_23 + len | 0);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_23 = tmp0_this_2._offset_23 + len | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readS8_0_k$ = function () {
    return readS8(this._ba, offset(this, 1));
  };
  FastByteArrayInputStream.prototype.readU8_0_k$ = function () {
    return readU8(this._ba, offset(this, 1));
  };
  FastByteArrayInputStream.prototype.readS16LE_0_k$ = function () {
    return readS16LE(this._ba, offset(this, 2));
  };
  FastByteArrayInputStream.prototype.readS16BE_0_k$ = function () {
    return readS16BE(this._ba, offset(this, 2));
  };
  FastByteArrayInputStream.prototype.readU16BE_0_k$ = function () {
    return readU16BE(this._ba, offset(this, 2));
  };
  FastByteArrayInputStream.prototype.readS32BE_0_k$ = function () {
    return readS32BE(this._ba, offset(this, 4));
  };
  FastByteArrayInputStream.prototype.readF32LE_0_k$ = function () {
    return readF32LE(this._ba, offset(this, 4));
  };
  FastByteArrayInputStream.prototype.readS64BE_0_k$ = function () {
    return readS64BE(this._ba, offset(this, 8));
  };
  FastByteArrayInputStream.prototype.readBytes_ha5a7z_k$ = function (count_0) {
    return readByteArray(this._ba, offset(this, count_0), count_0);
  };
  FastByteArrayInputStream.prototype.readShortArrayBE_ha5a7z_k$ = function (count_0) {
    return readShortArrayBE(this._ba, offset(this, imul(count_0, 2)), count_0);
  };
  FastByteArrayInputStream.prototype.readCharArrayBE_ha5a7z_k$ = function (count_0) {
    return readCharArrayBE(this._ba, offset(this, imul(count_0, 2)), count_0);
  };
  FastByteArrayInputStream.prototype.readIntArrayLE_ha5a7z_k$ = function (count_0) {
    return readIntArrayLE(this._ba, offset(this, imul(count_0, 4)), count_0);
  };
  FastByteArrayInputStream.prototype.readU_VL_0_k$ = function () {
    var result = this.readU8_0_k$();
    if ((result & 128) === 0)
      return result;
    result = result & 127 | this.readU8_0_k$() << 7;
    if ((result & 16384) === 0)
      return result;
    result = result & 16383 | this.readU8_0_k$() << 14;
    if ((result & 2097152) === 0)
      return result;
    result = result & 2097151 | this.readU8_0_k$() << 21;
    if ((result & 268435456) === 0)
      return result;
    result = result & 268435455 | this.readU8_0_k$() << 28;
    return result;
  };
  FastByteArrayInputStream.prototype.readS_VL_0_k$ = function () {
    var v = this.readU_VL_0_k$();
    var sign = !((v & 1) === 0);
    var uvalue = v >>> 1;
    return sign ? (-uvalue | 0) - 1 | 0 : uvalue;
  };
  FastByteArrayInputStream.prototype.readString_hcs1b6_k$ = function (len, charset) {
    var tmp = this.readBytes_ha5a7z_k$(len);
    return toString$default(tmp, charset, 0, 0, 6, null);
  };
  FastByteArrayInputStream.prototype.readString$default_589s1r_k$ = function (len, charset, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return this.readString_hcs1b6_k$(len, charset);
  };
  FastByteArrayInputStream.prototype.readStringz_hcs1b6_k$ = function (len, charset) {
    var res = this.readBytes_ha5a7z_k$(len);
    var index_0 = indexOf$default_2(res, 0, 0, 0, 0, 14, null);
    var tmp = copyOf(res, index_0 < 0 ? len : index_0);
    return toString$default(tmp, charset, 0, 0, 6, null);
  };
  FastByteArrayInputStream.prototype.readStringz$default_589s1r_k$ = function (len, charset, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return this.readStringz_hcs1b6_k$(len, charset);
  };
  FastByteArrayInputStream.prototype.readStringVL_8i7s9v_k$ = function (charset) {
    return this.readString_hcs1b6_k$(this.readU_VL_0_k$(), charset);
  };
  FastByteArrayInputStream.prototype.readStringVL$default_8s0uio_k$ = function (charset, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      charset = UTF8;
    return this.readStringVL_8i7s9v_k$(charset);
  };
  FastByteArrayInputStream.prototype.getBackingArrayUnsafe_0_k$ = function () {
    return this._ba;
  };
  FastByteArrayInputStream.$metadata$ = {
    simpleName: 'FastByteArrayInputStream',
    kind: 'class',
    interfaces: []
  };
  function openFastStream(_this_, offset_0) {
    return FastByteArrayInputStream_init_$Create$(_this_, offset_0, 0, 0, 12, null);
  }
  function openFastStream$default(_this_, offset_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset_0 = 0;
    return openFastStream(_this_, offset_0);
  }
  function toSyncStream(_this_) {
    var tmp = new ReadonlySyncStreamBase(_this_._ba, _this_._start_2, _this_._end_1 - _this_._start_2 | 0);
    return tmp.open$default_6dfvrs_k$(new Long(0, 0), 1, null);
  }
  function openAsync(_this_, mode) {
    return toAsyncStream(new MemoryAsyncStreamBase(ByteArrayBuilder_init_$Create$(_this_, 0, true, 2, null)), new Long(0, 0));
  }
  function openAsync$default(_this_, mode, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      mode = 'r';
    return openAsync(_this_, mode);
  }
  function SyncStream(base, position_0) {
    this._base_2 = base;
    var tmp = this;
    tmp._$$delegate_0_14 = Mixin_init_$Create$(null, 1, null);
    this._smallTemp = this._base_2._smallTemp_0;
    this._separateReadWrite = this._base_2._get_separateReadWrite__0_k$();
    this._positionRead = position_0;
    this._positionWrite = position_0;
    this._position_11 = position_0;
    this._markPos = new Long(0, 0);
  }
  SyncStream.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_14._set_extra__n1onou_k$(_set___);
  };
  SyncStream.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_14._get_extra__0_k$();
  };
  SyncStream.prototype._set_positionRead__kdfck9_k$ = function (value) {
    if (this._separateReadWrite)
      this._positionRead = value;
    else
      this._set_position__kdfck9_k$(value);
  };
  SyncStream.prototype._get_positionRead__0_k$ = function () {
    return this._separateReadWrite ? this._positionRead : this._get_position__0_k$();
  };
  SyncStream.prototype._set_positionWrite__kdfck9_k$ = function (value) {
    if (this._separateReadWrite)
      this._positionWrite = value;
    else
      this._set_position__kdfck9_k$(value);
  };
  SyncStream.prototype._get_positionWrite__0_k$ = function () {
    return this._separateReadWrite ? this._positionWrite : this._get_position__0_k$();
  };
  SyncStream.prototype._set_position__kdfck9_k$ = function (value) {
    var tmp;
    if (this._separateReadWrite) {
      tmp = this._set_positionRead__kdfck9_k$(value);
    } else {
      this._position_11 = value;
      tmp = Unit_getInstance();
    }
    return tmp;
  };
  SyncStream.prototype._get_position__0_k$ = function () {
    return this._separateReadWrite ? this._get_positionRead__0_k$() : this._position_11;
  };
  SyncStream.prototype.read_irqg4d_k$ = function (buffer, offset_0, len) {
    var read_0 = this._base_2.read_pwamfb_k$(this._get_positionRead__0_k$(), buffer, offset_0, len);
    var tmp0_this = this;
    var tmp0_plus_0 = tmp0_this._get_positionRead__0_k$();
    tmp0_this._set_positionRead__kdfck9_k$(tmp0_plus_0.plus_wiekkq_k$(toLong(read_0)));
    return read_0;
  };
  SyncStream.prototype.skip_majfzk_k$ = function (count_0) {
    var tmp0_this = this;
    var tmp0_plus_0 = tmp0_this._get_positionRead__0_k$();
    tmp0_this._set_positionRead__kdfck9_k$(tmp0_plus_0.plus_wiekkq_k$(toLong(count_0)));
  };
  SyncStream.prototype.read_0_k$ = function () {
    var size_2 = this.read_irqg4d_k$(this._smallTemp, 0, 1);
    if (size_2 <= 0)
      return -1;
    var tmp0__get_unsigned__0 = this._smallTemp[0];
    return tmp0__get_unsigned__0 & 255;
  };
  SyncStream.prototype.write_ysdrhq_k$ = function (buffer, offset_0, len) {
    this._base_2.write_8wseoo_k$(this._get_positionWrite__0_k$(), buffer, offset_0, len);
    var tmp0_this = this;
    var tmp0_plus_0 = tmp0_this._get_positionWrite__0_k$();
    tmp0_this._set_positionWrite__kdfck9_k$(tmp0_plus_0.plus_wiekkq_k$(toLong(len)));
  };
  SyncStream.prototype.write_majfzk_k$ = function (byte) {
    this._smallTemp[0] = toByte(byte);
    this.write_ysdrhq_k$(this._smallTemp, 0, 1);
  };
  SyncStream.prototype._get_length__0_k$ = function () {
    return this._base_2._get_length__0_k$();
  };
  SyncStream.prototype._get_availableRead__0_k$ = function () {
    return this._get_length__0_k$().minus_wiekkq_k$(this._get_positionRead__0_k$());
  };
  SyncStream.prototype._get_available__0_k$ = function () {
    return this._get_availableRead__0_k$();
  };
  SyncStream.prototype.close_sv8swh_k$ = function () {
    return this._base_2.close_sv8swh_k$();
  };
  SyncStream.prototype.toString = function () {
    return '' + 'SyncStream(' + this._base_2 + ', ' + this._get_position__0_k$() + ')';
  };
  SyncStream.$metadata$ = {
    simpleName: 'SyncStream',
    kind: 'class',
    interfaces: [Extra, Closeable, SyncInputStream, SyncPositionStream, SyncOutputStream, SyncLengthStream, MarkableSyncInputStream]
  };
  function openSync(_this_, mode) {
    return toSyncStream_0(new MemorySyncStreamBase(ByteArrayBuilder_init_$Create$(_this_, 0, false, 6, null)), new Long(0, 0));
  }
  function openSync$default(_this_, mode, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      mode = 'r';
    return openSync(_this_, mode);
  }
  function readString_0(_this_, len, charset) {
    var tmp = readBytes_0(_this_, len);
    return toString$default(tmp, charset, 0, 0, 6, null);
  }
  function readString$default_0(_this_, len, charset, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return readString_0(_this_, len, charset);
  }
  function write8_1(_this_, v) {
    return _this_.write_majfzk_k$(v);
  }
  function write32BE_1(_this_, v) {
    write8_1(_this_, v >>> 24 & 255);
    write8_1(_this_, v >>> 16 & 255);
    write8_1(_this_, v >>> 8 & 255);
    return write8_1(_this_, v & 255);
  }
  function writeBytes_0(_this_, data) {
    return _this_.write_ysdrhq_k$(data, 0, data.length);
  }
  function SyncInputStream() {
  }
  SyncInputStream.prototype.read$default_82dsjl_k$ = function (buffer, offset_0, len, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset_0 = 0;
    if (!(($mask0 & 4) === 0))
      len = buffer.length - offset_0 | 0;
    return $handler == null ? this.read_irqg4d_k$(buffer, offset_0, len) : $handler(buffer, offset_0, len);
  };
  SyncInputStream.prototype.read_0_k$ = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_alloc_0 = _get_smallBytesPool_();
      var temp_1 = tmp0_alloc_0.alloc_0_k$();
      try {
        var tmp;
        if (this.read_irqg4d_k$(temp_1, 0, 1) > 0) {
          var tmp0__get_unsigned__0_3 = temp_1[0];
          tmp = tmp0__get_unsigned__0_3 & 255;
        } else {
          tmp = -1;
        }
        tmp$ret$0 = tmp;
        break l$ret$1;
      }finally {
        tmp0_alloc_0.free_iav7o_k$(temp_1);
      }
    }
     while (false);
    return tmp$ret$0;
  };
  SyncInputStream.$metadata$ = {
    simpleName: 'SyncInputStream',
    kind: 'interface',
    interfaces: [OptionalCloseable]
  };
  function SyncPositionStream() {
  }
  SyncPositionStream.$metadata$ = {
    simpleName: 'SyncPositionStream',
    kind: 'interface',
    interfaces: []
  };
  function SyncOutputStream() {
  }
  SyncOutputStream.prototype.write_majfzk_k$ = function (byte) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_alloc_0 = _get_smallBytesPool_();
      var temp_1 = tmp0_alloc_0.alloc_0_k$();
      try {
        temp_1[0] = toByte(byte);
        tmp$ret$0 = this.write_ysdrhq_k$(temp_1, 0, 1);
        break l$ret$1;
      }finally {
        tmp0_alloc_0.free_iav7o_k$(temp_1);
      }
    }
     while (false);
    return tmp$ret$0;
  };
  SyncOutputStream.$metadata$ = {
    simpleName: 'SyncOutputStream',
    kind: 'interface',
    interfaces: [OptionalCloseable]
  };
  function SyncLengthStream() {
  }
  SyncLengthStream.$metadata$ = {
    simpleName: 'SyncLengthStream',
    kind: 'interface',
    interfaces: []
  };
  function MarkableSyncInputStream() {
  }
  MarkableSyncInputStream.$metadata$ = {
    simpleName: 'MarkableSyncInputStream',
    kind: 'interface',
    interfaces: [SyncInputStream]
  };
  function SyncStreamBase() {
    this._smallTemp_0 = new Int8Array(16);
  }
  SyncStreamBase.prototype._get_separateReadWrite__0_k$ = function () {
    return false;
  };
  SyncStreamBase.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len) {
    unsupported_0();
  };
  SyncStreamBase.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len) {
    unsupported_0();
  };
  SyncStreamBase.prototype._get_length__0_k$ = function () {
    unsupported_0();
  };
  SyncStreamBase.prototype.close_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  SyncStreamBase.prototype.open_wiekkq_k$ = function (position_0) {
    return new SyncStream(this, position_0);
  };
  SyncStreamBase.prototype.open$default_6dfvrs_k$ = function (position_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      position_0 = new Long(0, 0);
    return this.open_wiekkq_k$(position_0);
  };
  SyncStreamBase.$metadata$ = {
    simpleName: 'SyncStreamBase',
    kind: 'class',
    interfaces: [Closeable, SyncRAInputStream, SyncRAOutputStream, SyncLengthStream]
  };
  function toSyncStream_0(_this_, position_0) {
    return new SyncStream(_this_, position_0);
  }
  function toSyncStream$default(_this_, position_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      position_0 = new Long(0, 0);
    return toSyncStream_0(_this_, position_0);
  }
  function MemorySyncStreamBase(data) {
    SyncStreamBase.call(this);
    this._data_21 = data;
  }
  MemorySyncStreamBase.prototype._get_ilength__0_k$ = function () {
    return this._data_21._get_size__0_k$();
  };
  MemorySyncStreamBase.prototype._get_length__0_k$ = function () {
    return toLong(this._data_21._get_size__0_k$());
  };
  MemorySyncStreamBase.prototype.checkPosition_kdfck9_k$ = function (position_0) {
    if (position_0.compareTo_wiekkq_k$(new Long(0, 0)) < 0) {
      invalidOp('' + 'Invalid position ' + position_0);
    }};
  MemorySyncStreamBase.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len) {
    this.checkPosition_kdfck9_k$(position_0);
    var ipos = position_0.toInt_0_k$();
    if (!((new Long(0, 0)).compareTo_wiekkq_k$(position_0) <= 0 ? position_0.compareTo_wiekkq_k$(toLong(this._get_ilength__0_k$())) < 0 : false))
      return 0;
    var tmp0_min_0 = this._get_ilength__0_k$();
    var tmp1_min_0 = ipos + len | 0;
    var end = Math.min(tmp0_min_0, tmp1_min_0);
    var tmp2_max_0 = end - ipos | 0;
    var actualLen = Math.max(tmp2_max_0, 0);
    arraycopy_2(this._data_21._data_14, ipos, buffer, offset_0, actualLen);
    return actualLen;
  };
  MemorySyncStreamBase.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len) {
    this.checkPosition_kdfck9_k$(position_0);
    var tmp = this._data_21;
    var tmp0_max_0 = this._data_21._get_size__0_k$();
    var tmp1_max_0 = position_0.plus_wiekkq_k$(toLong(len)).toInt_0_k$();
    tmp._set_size__majfzk_k$(Math.max(tmp0_max_0, tmp1_max_0));
    arraycopy_2(buffer, offset_0, this._data_21._data_14, position_0.toInt_0_k$(), len);
  };
  MemorySyncStreamBase.prototype.close_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  MemorySyncStreamBase.prototype.toString = function () {
    return '' + 'MemorySyncStreamBase(' + this._data_21._get_size__0_k$() + ')';
  };
  MemorySyncStreamBase.$metadata$ = {
    simpleName: 'MemorySyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function readBytes_0(_this_, len) {
    var bytes = new Int8Array(len);
    return copyOf(bytes, _this_.read_irqg4d_k$(bytes, 0, len));
  }
  function MemorySyncStream(data) {
    var tmp = new MemorySyncStreamBase(data);
    return toSyncStream$default(tmp, new Long(0, 0), 1, null);
  }
  function SyncRAInputStream() {
  }
  SyncRAInputStream.$metadata$ = {
    simpleName: 'SyncRAInputStream',
    kind: 'interface',
    interfaces: []
  };
  function SyncRAOutputStream() {
  }
  SyncRAOutputStream.$metadata$ = {
    simpleName: 'SyncRAOutputStream',
    kind: 'interface',
    interfaces: []
  };
  function readU8_2(_this_) {
    return _this_.read_0_k$();
  }
  function MemorySyncStream_0(data) {
    var tmp = new MemorySyncStreamBase(ByteArrayBuilder_init_$Create$(data, 0, false, 6, null));
    return toSyncStream$default(tmp, new Long(0, 0), 1, null);
  }
  function MemorySyncStream$default(data, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      data = EMPTY_BYTE_ARRAY;
    return MemorySyncStream_0(data);
  }
  function readS32BE_1(_this_) {
    return readU8_2(_this_) << 24 | readU8_2(_this_) << 16 | readU8_2(_this_) << 8 | readU8_2(_this_);
  }
  function readStringz(_this_, len, charset) {
    var res = readBytes_0(_this_, len);
    var index_0 = indexOf_2(res, 0);
    var tmp = copyOf(res, index_0 < 0 ? len : index_0);
    return toString$default(tmp, charset, 0, 0, 6, null);
  }
  function readStringz$default(_this_, len, charset, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return readStringz(_this_, len, charset);
  }
  function readStream_0(_this_, length) {
    return readSlice_0(_this_, length);
  }
  function readAll_0(_this_) {
    return readBytes_0(_this_, _this_._get_available__0_k$().toInt_0_k$());
  }
  function _get_eof_(_this_) {
    return _this_._get_available__0_k$().compareTo_wiekkq_k$(new Long(0, 0)) <= 0;
  }
  function readU16LE_1(_this_) {
    return readU8_2(_this_) | readU8_2(_this_) << 8;
  }
  function readS16LE_1(_this_) {
    return signExtend(readU16LE_1(_this_), 16);
  }
  function write16LE_1(_this_, v) {
    write8_1(_this_, v & 255);
    return write8_1(_this_, v >>> 8 & 255);
  }
  function sliceStart_0(_this_, start) {
    return sliceWithBounds_0(_this_, start, _this_._get_length__0_k$());
  }
  function sliceStart$default_0(_this_, start, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      start = new Long(0, 0);
    return sliceStart_0(_this_, start);
  }
  function readS32LE_1(_this_) {
    return readU8_2(_this_) | readU8_2(_this_) << 8 | readU8_2(_this_) << 16 | readU8_2(_this_) << 24;
  }
  function write32LE_1(_this_, v) {
    write8_1(_this_, v & 255);
    write8_1(_this_, v >>> 8 & 255);
    write8_1(_this_, v >>> 16 & 255);
    return write8_1(_this_, v >>> 24 & 255);
  }
  function ReadonlySyncStreamBase(data, offset_0, size_2) {
    SyncStreamBase.call(this);
    this._data_22 = data;
    this._offset_24 = offset_0;
    this._size_12 = size_2;
  }
  ReadonlySyncStreamBase.prototype._get_ilength__0_k$ = function () {
    return this._size_12;
  };
  ReadonlySyncStreamBase.prototype._get_length__0_k$ = function () {
    return toLong(this._data_22.length);
  };
  ReadonlySyncStreamBase.prototype.checkPosition_kdfck9_k$ = function (position_0) {
    if (position_0.compareTo_wiekkq_k$(new Long(0, 0)) < 0) {
      invalidOp('' + 'Invalid position ' + position_0);
    }};
  ReadonlySyncStreamBase.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len) {
    this.checkPosition_kdfck9_k$(position_0);
    var ipos = position_0.toInt_0_k$();
    if (!((new Long(0, 0)).compareTo_wiekkq_k$(position_0) <= 0 ? position_0.compareTo_wiekkq_k$(toLong(this._get_ilength__0_k$())) < 0 : false))
      return 0;
    var tmp0_min_0 = this._get_ilength__0_k$();
    var tmp1_min_0 = ipos + len | 0;
    var end = Math.min(tmp0_min_0, tmp1_min_0);
    var tmp2_max_0 = end - ipos | 0;
    var actualLen = Math.max(tmp2_max_0, 0);
    arraycopy_2(this._data_22, ipos + this._offset_24 | 0, buffer, offset_0, actualLen);
    return actualLen;
  };
  ReadonlySyncStreamBase.prototype.close_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  ReadonlySyncStreamBase.prototype.toString = function () {
    return '' + 'ReadonlySyncStreamBase(' + this._data_22.length + ')';
  };
  ReadonlySyncStreamBase.$metadata$ = {
    simpleName: 'ReadonlySyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function readSlice_0(_this_, length) {
    var tmp0_apply_0 = sliceWithSize_0(_this_, _this_._get_position__0_k$(), length);
    var tmp0_this_2 = _this_;
    tmp0_this_2._set_position__kdfck9_k$(tmp0_this_2._get_position__0_k$().plus_wiekkq_k$(length));
    return tmp0_apply_0;
  }
  function sliceWithBounds_0(_this_, start, end) {
    var len = _this_._get_length__0_k$();
    var clampedStart = clamp_5(start, new Long(0, 0), len);
    var clampedEnd = clamp_5(end, new Long(0, 0), len);
    var tmp = _this_._base_2;
    if (tmp instanceof SliceSyncStreamBase) {
      var tmp_0 = new SliceSyncStreamBase(_this_._base_2._base_3, _this_._base_2._baseStart_0.plus_wiekkq_k$(clampedStart), _this_._base_2._baseStart_0.plus_wiekkq_k$(clampedEnd));
      return toSyncStream$default(tmp_0, new Long(0, 0), 1, null);
    } else {
      {
        var tmp_1 = new SliceSyncStreamBase(_this_._base_2, clampedStart, clampedEnd);
        return toSyncStream$default(tmp_1, new Long(0, 0), 1, null);
      }
    }
  }
  function sliceWithSize_0(_this_, position_0, length) {
    return sliceWithBounds_0(_this_, position_0, position_0.plus_wiekkq_k$(length));
  }
  function clampPosition_0($this, position_0) {
    return clamp_5(position_0, $this._baseStart_0, $this._baseEnd_0);
  }
  function clampPositionLen_0($this, position_0, len) {
    if (position_0.compareTo_wiekkq_k$(new Long(0, 0)) < 0)
      throw IllegalArgumentException_init_$Create$('Invalid position');
    var targetStartPosition = clampPosition_0($this, $this._baseStart_0.plus_wiekkq_k$(position_0));
    var targetEndPosition = clampPosition_0($this, targetStartPosition.plus_wiekkq_k$(toLong(len)));
    var targetLen = targetEndPosition.minus_wiekkq_k$(targetStartPosition).toInt_0_k$();
    return new Pair(targetStartPosition, targetLen);
  }
  function SliceSyncStreamBase(base, baseStart, baseEnd) {
    SyncStreamBase.call(this);
    this._base_3 = base;
    this._baseStart_0 = baseStart;
    this._baseEnd_0 = baseEnd;
    this._baseLength_0 = this._baseEnd_0.minus_wiekkq_k$(this._baseStart_0);
  }
  SliceSyncStreamBase.prototype._get_separateReadWrite__0_k$ = function () {
    return this._base_3._get_separateReadWrite__0_k$();
  };
  SliceSyncStreamBase.prototype._get_length__0_k$ = function () {
    return this._baseLength_0;
  };
  SliceSyncStreamBase.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len) {
    var tmp0_container = clampPositionLen_0(this, position_0, len);
    var targetStartPosition = tmp0_container.component1_0_k$();
    var targetLen = tmp0_container.component2_0_k$();
    return this._base_3.read_pwamfb_k$(targetStartPosition, buffer, offset_0, targetLen);
  };
  SliceSyncStreamBase.prototype.write_8wseoo_k$ = function (position_0, buffer, offset_0, len) {
    var tmp0_container = clampPositionLen_0(this, position_0, len);
    var targetStartPosition = tmp0_container.component1_0_k$();
    var targetLen = tmp0_container.component2_0_k$();
    return this._base_3.write_8wseoo_k$(targetStartPosition, buffer, offset_0, targetLen);
  };
  SliceSyncStreamBase.prototype.close_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  SliceSyncStreamBase.prototype.toString = function () {
    return '' + 'SliceAsyncStreamBase(' + this._base_3 + ', ' + this._baseStart_0 + ', ' + this._baseEnd_0 + ')';
  };
  SliceSyncStreamBase.$metadata$ = {
    simpleName: 'SliceSyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function openAsync_0(_this_, charset) {
    return toAsync(openSync(toByteArray$default(_this_, charset, 0, 0, 6, null), 'r'));
  }
  function readU32LE_1(_this_) {
    return toLong(readU8_2(_this_) | readU8_2(_this_) << 8 | readU8_2(_this_) << 16 | readU8_2(_this_) << 24).and_wiekkq_k$(new Long(-1, 0));
  }
  var traceTimes$delegate;
  function _no_name_provided__202() {
  }
  _no_name_provided__202.prototype.invoke_0_k$ = function () {
    return Companion_getInstance_112().get_6wfw3l_k$('TRACE_TIMES') === 'true';
  };
  _no_name_provided__202.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_159() {
    var i = new _no_name_provided__202();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function indexOf_10(_this_, v, startOffset, endOffset, default_0) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = startOffset;
      if (inductionVariable < endOffset)
        do {
          var n_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[n_2] === v) {
            tmp$ret$0 = n_2;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable < endOffset);
      tmp$ret$0 = default_0;
    }
     while (false);
    return tmp$ret$0;
  }
  function indexOf$default_2(_this_, v, startOffset, endOffset, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startOffset = 0;
    if (!(($mask0 & 4) === 0))
      endOffset = _this_.length;
    if (!(($mask0 & 8) === 0))
      default_0 = -1;
    return indexOf_10(_this_, v, startOffset, endOffset, default_0);
  }
  function isWhitespaceFast(_this_) {
    return ((_this_.equals(new Char(32)) ? true : _this_.equals(new Char(9))) ? true : _this_.equals(new Char(13))) ? true : _this_.equals(new Char(10));
  }
  function isLetterDigitOrUnderscore(_this_) {
    return (isLetterOrDigit(_this_) ? true : _this_.equals(new Char(95))) ? true : _this_.equals(new Char(36));
  }
  function isLetterOrDigit(_this_) {
    return isLetter(_this_) ? true : isDigit(_this_);
  }
  function isLetter(_this_) {
    return (new Char(97) <= _this_ ? _this_ <= new Char(122) : false) ? true : new Char(65) <= _this_ ? _this_ <= new Char(90) : false;
  }
  function isDigit(_this_) {
    return new Char(48) <= _this_ ? _this_ <= new Char(57) : false;
  }
  function _get_isNumeric_(_this_) {
    return ((isDigit(_this_) ? true : _this_.equals(new Char(46))) ? true : _this_.equals(new Char(101))) ? true : _this_.equals(new Char(45));
  }
  function isLetterOrUnderscore(_this_) {
    return (isLetter(_this_) ? true : _this_.equals(new Char(95))) ? true : _this_.equals(new Char(36));
  }
  function Text_1() {
  }
  Text_1.$metadata$ = {
    simpleName: 'Text',
    kind: 'interface',
    interfaces: [Action]
  };
  function Marker() {
  }
  Marker.$metadata$ = {
    simpleName: 'Marker',
    kind: 'class',
    interfaces: [Action]
  };
  function Inline(str) {
    this._str_1 = str;
  }
  Inline.prototype._get_str__0_k$ = function () {
    return this._str_1;
  };
  Inline.prototype.toString = function () {
    return '' + 'Inline(str=' + this._str_1 + ')';
  };
  Inline.prototype.hashCode = function () {
    return getStringHashCode(this._str_1);
  };
  Inline.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Inline))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Inline ? other : THROW_CCE();
    if (!(this._str_1 === tmp0_other_with_cast._str_1))
      return false;
    return true;
  };
  Inline.$metadata$ = {
    simpleName: 'Inline',
    kind: 'class',
    interfaces: [Text_1]
  };
  function Line(str) {
    this._str_2 = str;
  }
  Line.prototype._get_str__0_k$ = function () {
    return this._str_2;
  };
  Line.prototype.toString = function () {
    return '' + 'Line(str=' + this._str_2 + ')';
  };
  Line.prototype.hashCode = function () {
    return getStringHashCode(this._str_2);
  };
  Line.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!(this._str_2 === tmp0_other_with_cast._str_2))
      return false;
    return true;
  };
  Line.$metadata$ = {
    simpleName: 'Line',
    kind: 'class',
    interfaces: [Text_1]
  };
  function LineDeferred() {
  }
  LineDeferred.$metadata$ = {
    simpleName: 'LineDeferred',
    kind: 'class',
    interfaces: [Action]
  };
  function EmptyLineOnce() {
    EmptyLineOnce_instance = this;
  }
  EmptyLineOnce.$metadata$ = {
    simpleName: 'EmptyLineOnce',
    kind: 'object',
    interfaces: [Action]
  };
  var EmptyLineOnce_instance;
  function EmptyLineOnce_getInstance() {
    if (EmptyLineOnce_instance == null)
      new EmptyLineOnce();
    return EmptyLineOnce_instance;
  }
  function Indent() {
    Indent_instance = this;
  }
  Indent.$metadata$ = {
    simpleName: 'Indent',
    kind: 'object',
    interfaces: [Action]
  };
  var Indent_instance;
  function Indent_getInstance() {
    if (Indent_instance == null)
      new Indent();
    return Indent_instance;
  }
  function Unindent() {
    Unindent_instance = this;
  }
  Unindent.$metadata$ = {
    simpleName: 'Unindent',
    kind: 'object',
    interfaces: [Action]
  };
  var Unindent_instance;
  function Unindent_getInstance() {
    if (Unindent_instance == null)
      new Unindent();
    return Unindent_instance;
  }
  function Indenter_init_$Init$(actions, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      actions = ArrayList_init_$Create$();
    }Indenter.call($this, actions);
    return $this;
  }
  function Indenter_init_$Create$(actions, $mask0, $marker) {
    return Indenter_init_$Init$(actions, $mask0, $marker, Object.create(Indenter.prototype));
  }
  function INDENTS() {
    INDENTS_instance = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 1024;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = '';
      tmp_0 = tmp_0 + 1 | 0;
    }
    var tmp0_apply_0 = tmp_2;
    var indent_2 = StringBuilder_init_$Create$_0();
    var inductionVariable = 0;
    var last_1 = tmp0_apply_0.length;
    if (inductionVariable < last_1)
      do {
        var n_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0[n_4] = indent_2.toString();
        indent_2.append_uch40_k$('\t');
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp._INDENTS = tmp0_apply_0;
  }
  INDENTS.prototype.get_ha5a7z_k$ = function (index_0) {
    if (index_0 >= this._INDENTS.length) {
      var tmp0_TODO_0 = '' + 'Too much indentation ' + index_0;
      throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
    }return index_0 <= 0 ? '' : this._INDENTS[index_0];
  };
  INDENTS.$metadata$ = {
    simpleName: 'INDENTS',
    kind: 'object',
    interfaces: []
  };
  var INDENTS_instance;
  function INDENTS_getInstance() {
    if (INDENTS_instance == null)
      new INDENTS();
    return INDENTS_instance;
  }
  function Action() {
  }
  Action.$metadata$ = {
    simpleName: 'Action',
    kind: 'interface',
    interfaces: []
  };
  function Companion_122() {
    Companion_instance_121 = this;
    var tmp = this;
    var tmp0_gen_0 = Companion_getInstance_121();
    var indenter_1 = Indenter_init_$Create$(null, 1, null);
    Unit_getInstance();
    tmp._EMPTY_4 = indenter_1;
  }
  Companion_122.prototype.invoke_mwdkab_k$ = function (init) {
    var indenter_1 = Indenter_init_$Create$(null, 1, null);
    init(indenter_1);
    return indenter_1;
  };
  Companion_122.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_121;
  function Companion_getInstance_121() {
    if (Companion_instance_121 == null)
      new Companion_122();
    return Companion_instance_121;
  }
  function IndenterEvaluator(markHandler, indentEmptyLines, doIndent) {
    this._markHandler = markHandler;
    this._indentEmptyLines = indentEmptyLines;
    this._doIndent = doIndent;
    this._out_6 = StringBuilder_init_$Create$_0();
    this._line = 0;
    this._newLine = true;
    this._indentIndex = 0;
    this._allowEmptyLine = false;
  }
  IndenterEvaluator.prototype.outAppend_6wfw3l_k$ = function (str) {
    return this._out_6.append_uch40_k$(str);
  };
  IndenterEvaluator.prototype.outAppend_wi8o78_k$ = function (str) {
    return this._out_6.append_wi8o78_k$(str);
  };
  IndenterEvaluator.prototype.doLine_sv8swh_k$ = function () {
    if (this._doIndent) {
      this.outAppend_wi8o78_k$(new Char(10));
      Unit_getInstance();
    }var tmp0_this = this;
    var tmp1 = tmp0_this._line;
    tmp0_this._line = tmp1 + 1 | 0;
    Unit_getInstance();
    this._newLine = true;
  };
  IndenterEvaluator.prototype.eval_6xo57o_k$ = function (actions) {
    var n_1 = 0;
    while (n_1 < actions._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp0__anonymous__3 = actions.get_ha5a7z_k$(tmp0_2);
      var tmp0_subject_4 = tmp0__anonymous__3;
      if (isInterface(tmp0_subject_4, Text_1)) {
        if (this._newLine) {
          var tmp;
          if (!this._indentEmptyLines) {
            var tmp0_isEmpty_0_5 = tmp0__anonymous__3._get_str__0_k$();
            tmp = charSequenceLength(tmp0_isEmpty_0_5) === 0;
          } else {
            tmp = false;
          }
          if (tmp) {
            this.doLine_sv8swh_k$();
          } else {
            {
              if (this._doIndent) {
                this.outAppend_6wfw3l_k$(INDENTS_getInstance().get_ha5a7z_k$(this._indentIndex));
                Unit_getInstance();
              } else {
                this.outAppend_6wfw3l_k$(' ');
                Unit_getInstance();
              }
            }
          }
        }this.outAppend_6wfw3l_k$(tmp0__anonymous__3._get_str__0_k$());
        Unit_getInstance();
        if (tmp0__anonymous__3 instanceof Line) {
          var tmp1_this_6 = this;
          var tmp_0 = tmp1_this_6;
          var tmp_1 = tmp1_this_6._line;
          var tmp1_count_0_7 = tmp0__anonymous__3._get_str__0_k$();
          var count_1_8 = 0;
          var indexedObject = tmp1_count_0_7;
          var inductionVariable = 0;
          var last_1 = indexedObject.length;
          while (inductionVariable < last_1) {
            var element_3_10 = charSequenceGet(indexedObject, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            if (element_3_10.equals(new Char(10))) {
              count_1_8 = count_1_8 + 1 | 0;
              Unit_getInstance();
            } else {
            }
          }
          tmp_0._line = tmp_1 + count_1_8 | 0;
          this.doLine_sv8swh_k$();
        } else {
          {
            this._newLine = false;
          }
        }
        this._allowEmptyLine = true;
      } else {
        if (tmp0_subject_4 instanceof LineDeferred)
          this.eval_6xo57o_k$(tmp0__anonymous__3._callback_3()._actions);
        else {
          if (equals_1(tmp0_subject_4, Indent_getInstance()) ? true : equals_1(tmp0_subject_4, Unindent_getInstance())) {
            this._allowEmptyLine = false;
            var tmp2_this_11 = this;
            tmp2_this_11._indentIndex = tmp2_this_11._indentIndex + (equals_1(tmp0__anonymous__3, Indent_getInstance()) ? 1 : -1) | 0;
          } else {
            if (equals_1(tmp0_subject_4, EmptyLineOnce_getInstance())) {
              if (this._allowEmptyLine) {
                this.doLine_sv8swh_k$();
                this._allowEmptyLine = false;
              }} else {
              if (tmp0_subject_4 instanceof Marker) {
                var tmp3_safe_receiver_12 = this._markHandler;
                if (tmp3_safe_receiver_12 == null)
                  null;
                else
                  tmp3_safe_receiver_12(this._out_6, this._line, tmp0__anonymous__3._data_23);
                Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
  };
  IndenterEvaluator.$metadata$ = {
    simpleName: 'IndenterEvaluator',
    kind: 'class',
    interfaces: []
  };
  function Indenter(actions) {
    Companion_getInstance_121();
    this._actions = actions;
    this._indentEmptyLines_0 = true;
    this._out_7 = '';
  }
  Indenter.prototype.inline_6wfw3l_k$ = function (str) {
    this._actions.add_2bq_k$(new Inline(str));
    Unit_getInstance();
    return this;
  };
  Indenter.prototype.line_eak92k_k$ = function (indenter) {
    this._actions.addAll_dxd4eo_k$(indenter._actions);
    Unit_getInstance();
    return this;
  };
  Indenter.prototype.line_6wfw3l_k$ = function (str) {
    this._actions.add_2bq_k$(new Line(str));
    Unit_getInstance();
    return this;
  };
  Indenter.prototype._indent_sv8swh_k$ = function () {
    this._actions.add_2bq_k$(Indent_getInstance());
    Unit_getInstance();
  };
  Indenter.prototype._unindent_sv8swh_k$ = function () {
    this._actions.add_2bq_k$(Unindent_getInstance());
    Unit_getInstance();
  };
  Indenter.prototype.toString_tivkuu_k$ = function (markHandler, doIndent) {
    var tmp0_apply_0 = new IndenterEvaluator(markHandler, this._indentEmptyLines_0, doIndent);
    tmp0_apply_0.eval_6xo57o_k$(this._actions);
    return tmp0_apply_0._out_6.toString();
  };
  Indenter.prototype.toString_vtwmt5_k$ = function (doIndent, indentChunk) {
    var out = this.toString_tivkuu_k$(null, doIndent);
    var tmp;
    if (indentChunk === '\t') {
      tmp = out;
    } else {
      tmp = replace$default_0(out, '\t', indentChunk, false, 4, null);
    }
    return tmp;
  };
  Indenter.prototype.toString = function () {
    return this.toString_tivkuu_k$(null, true);
  };
  Indenter.$metadata$ = {
    simpleName: 'Indenter',
    kind: 'class',
    interfaces: []
  };
  function _get_niceStr__2(_this_) {
    var tmp;
    if (round(_this_) === _this_) {
      tmp = '' + numberToLong(_this_);
    } else {
      {
        tmp = '' + _this_;
      }
    }
    return tmp;
  }
  function toStringDecimal(_this_, decimalPlaces, skipTrailingZeros) {
    if (isNanOrInfinite(_this_))
      return _this_.toString();
    var res = _this_.toString();
    var tmp = new Char(69);
    var containsEup = contains$default(res, tmp, false, 2, null);
    var tmp_0 = new Char(101);
    var containsElo = contains$default(res, tmp_0, false, 2, null);
    var tmp_1;
    if (containsEup ? true : containsElo) {
      var tmp_2 = charArrayOf([containsEup ? new Char(69) : new Char(101)]);
      var tmp0_container = split$default(res, tmp_2, false, 2, 2, null);
      var base = tmp0_container.get_ha5a7z_k$(0);
      var exp = tmp0_container.get_ha5a7z_k$(1);
      var tmp_3;
      if (contains$default_0(base, '.', false, 2, null)) {
        tmp_3 = base;
      } else {
        {
          tmp_3 = '' + base + '.0';
        }
      }
      var rbase = tmp_3;
      var expInt = toInt(exp);
      var zeros = repeat('0', abs(expInt) + 2 | 0);
      var part = expInt > 0 ? '' + rbase + zeros : '' + zeros + rbase;
      var pointIndex = indexOf$default_0(part, '.', 0, false, 6, null);
      var outIndex = pointIndex + expInt | 0;
      var part2 = replace$default_0(part, '.', '', false, 4, null);
      var tmp0_replace_0 = substr_0(part2, 0, outIndex) + '.' + substr_1(part2, outIndex);
      var tmp1_replace_0 = Regex_init_$Create$('^0+\\.');
      tmp_1 = tmp1_replace_0.replace_abi4bo_k$(tmp0_replace_0, '0.');
    } else {
      tmp_1 = res;
    }
    var rez = tmp_1;
    var tmp_4 = charArrayOf([new Char(46)]);
    var parts_0 = split$default(rez, tmp_4, false, 2, 2, null);
    var tmp_5;
    if (0 <= _get_lastIndex__4(parts_0)) {
      tmp_5 = parts_0.get_ha5a7z_k$(0);
    } else {
      tmp_5 = '0';
    }
    var integral = tmp_5;
    var tmp_6;
    if (1 <= _get_lastIndex__4(parts_0)) {
      tmp_6 = parts_0.get_ha5a7z_k$(1);
    } else {
      tmp_6 = '0';
    }
    var decimal = tmp_6;
    if (decimalPlaces === 0)
      return integral;
    var out = integral + '.' + substr_0(decimal + repeat('0', decimalPlaces), 0, decimalPlaces);
    if (skipTrailingZeros) {
      $l$break: while (true) {
        var tmp_7 = out;
        var tmp_8 = new Char(48);
        if (!endsWith$default(tmp_7, tmp_8, false, 2, null)) {
          break $l$break;
        }var tmp2_substring_0 = out;
        var tmp3_substring_0 = out.length - 1 | 0;
        out = tmp2_substring_0.substring(0, tmp3_substring_0);
      }
      var tmp_9 = out;
      var tmp_10 = new Char(46);
      if (endsWith$default(tmp_9, tmp_10, false, 2, null)) {
        var tmp4_substring_0 = out;
        var tmp5_substring_0 = out.length - 1 | 0;
        out = tmp4_substring_0.substring(0, tmp5_substring_0);
      } else {
      }
    }return out;
  }
  function _get_niceStr__3(_this_) {
    return round(_this_) === _this_ ? '' + numberToLong(_this_) : '' + _this_;
  }
  function NumberParser() {
    NumberParser_instance = this;
  }
  NumberParser.prototype.parseInt_tkm0xq_k$ = function (str, start, end, radix) {
    var positive = true;
    var out = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(str, n);
        if (c.equals(new Char(45)) ? true : c.equals(new Char(43))) {
          positive = c.equals(new Char(43));
        } else {
          var value = ctypeAsInt(c);
          if (value < 0)
            break loop;
          out = imul(out, radix);
          out = out + value | 0;
        }
      }
       while (inductionVariable < end);
    return positive ? out : -out | 0;
  };
  NumberParser.prototype.parseDouble_os2q01_k$ = function (str, start, end) {
    var out = 0.0;
    var frac = 1.0;
    var pointSeen = false;
    var eSeen = false;
    var negate_0 = false;
    var negateExponent = false;
    var exponent = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(str, n);
        var tmp1_subject = c;
        if (tmp1_subject.equals(new Char(101)) ? true : tmp1_subject.equals(new Char(69)))
          eSeen = true;
        else if (tmp1_subject.equals(new Char(45))) {
          if (eSeen)
            negateExponent = true;
          else
            negate_0 = true;
        } else if (tmp1_subject.equals(new Char(46)))
          pointSeen = true;
        else {
          if (eSeen) {
            exponent = imul(exponent, 10);
            exponent = exponent + ctypeAsInt(c) | 0;
          } else {
            if (pointSeen)
              frac = frac / 10;
            out = out * 10;
            out = out + ctypeAsInt(c);
          }
        }
      }
       while (inductionVariable < end);
    var tmp = out * frac;
    var tmp0_pow_0 = negateExponent ? -exponent | 0 : exponent;
    var res = tmp * Math.pow(10.0, tmp0_pow_0);
    return negate_0 ? -res : res;
  };
  NumberParser.$metadata$ = {
    simpleName: 'NumberParser',
    kind: 'object',
    interfaces: []
  };
  var NumberParser_instance;
  function NumberParser_getInstance() {
    if (NumberParser_instance == null)
      new NumberParser();
    return NumberParser_instance;
  }
  function ctypeAsInt(_this_) {
    return (_this_.compareTo_wi8o78_k$(new Char(48)) >= 0 ? _this_.compareTo_wi8o78_k$(new Char(57)) <= 0 : false) ? _this_.minus_wi8o78_k$(new Char(48)) : (_this_.compareTo_wi8o78_k$(new Char(97)) >= 0 ? _this_.compareTo_wi8o78_k$(new Char(122)) <= 0 : false) ? _this_.minus_wi8o78_k$(new Char(97)) + 10 | 0 : (_this_.compareTo_wi8o78_k$(new Char(65)) >= 0 ? _this_.compareTo_wi8o78_k$(new Char(90)) <= 0 : false) ? _this_.minus_wi8o78_k$(new Char(65)) + 10 | 0 : -1;
  }
  function _no_name_provided__203() {
  }
  _no_name_provided__203.prototype.invoke_0_k$ = function () {
    var tmp0_toLowerCase_0 = OS_getInstance()._get_rawName__0_k$();
    return tmp0_toLowerCase_0.toLowerCase();
  };
  _no_name_provided__203.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__204() {
  }
  _no_name_provided__204.prototype.invoke_0_k$ = function () {
    var tmp0_toLowerCase_0 = OS_getInstance()._get_platformName__0_k$();
    return tmp0_toLowerCase_0.toLowerCase();
  };
  _no_name_provided__204.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__205() {
  }
  _no_name_provided__205.prototype.invoke_0_k$ = function () {
    var tmp = OS_getInstance()._get_rawNameLC__0_k$();
    return contains$default_0(tmp, 'win', false, 2, null);
  };
  _no_name_provided__205.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__206() {
  }
  _no_name_provided__206.prototype.invoke_0_k$ = function () {
    var tmp;
    var tmp_0;
    var tmp_1 = OS_getInstance()._get_rawNameLC__0_k$();
    if (contains$default_0(tmp_1, 'nix', false, 2, null)) {
      tmp_0 = true;
    } else {
      {
        var tmp_2 = OS_getInstance()._get_rawNameLC__0_k$();
        tmp_0 = contains$default_0(tmp_2, 'nux', false, 2, null);
      }
    }
    if (tmp_0) {
      tmp = true;
    } else {
      {
        var tmp_3 = OS_getInstance()._get_rawNameLC__0_k$();
        tmp = contains$default_0(tmp_3, 'aix', false, 2, null);
      }
    }
    return tmp;
  };
  _no_name_provided__206.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__207() {
  }
  _no_name_provided__207.prototype.invoke_0_k$ = function () {
    var tmp = OS_getInstance()._get_rawNameLC__0_k$();
    return contains$default_0(tmp, 'mac', false, 2, null);
  };
  _no_name_provided__207.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__208() {
  }
  _no_name_provided__208.prototype.invoke_0_k$ = function () {
    var tmp = OS_getInstance()._get_rawNameLC__0_k$();
    return contains$default_0(tmp, 'ios', false, 2, null);
  };
  _no_name_provided__208.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__209() {
  }
  _no_name_provided__209.prototype.invoke_0_k$ = function () {
    var tmp = OS_getInstance()._get_platformNameLC__0_k$();
    return contains$default_0(tmp, 'android', false, 2, null);
  };
  _no_name_provided__209.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__210() {
  }
  _no_name_provided__210.prototype.invoke_0_k$ = function () {
    var tmp = OS_getInstance()._get_rawNameLC__0_k$();
    return contains$default_0(tmp, 'watchos', false, 2, null);
  };
  _no_name_provided__210.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__211() {
  }
  _no_name_provided__211.prototype.invoke_0_k$ = function () {
    var tmp = OS_getInstance()._get_rawNameLC__0_k$();
    return contains$default_0(tmp, 'tvos', false, 2, null);
  };
  _no_name_provided__211.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function OS() {
    OS_instance = this;
    var tmp = this;
    tmp._rawNameLC$delegate = lazy(_no_name_provided_$factory_160());
    var tmp_0 = this;
    tmp_0._platformNameLC$delegate = lazy(_no_name_provided_$factory_161());
    var tmp_1 = this;
    tmp_1._isWindows$delegate = lazy(_no_name_provided_$factory_162());
    var tmp_2 = this;
    tmp_2._isLinux$delegate = lazy(_no_name_provided_$factory_163());
    var tmp_3 = this;
    tmp_3._isMac$delegate = lazy(_no_name_provided_$factory_164());
    var tmp_4 = this;
    tmp_4._isIos$delegate = lazy(_no_name_provided_$factory_165());
    var tmp_5 = this;
    tmp_5._isAndroid$delegate = lazy(_no_name_provided_$factory_166());
    var tmp_6 = this;
    tmp_6._isWatchos$delegate = lazy(_no_name_provided_$factory_167());
    var tmp_7 = this;
    tmp_7._isTvos$delegate = lazy(_no_name_provided_$factory_168());
  }
  OS.prototype._get_rawName__0_k$ = function () {
    return _get_rawOsName_();
  };
  OS.prototype._get_rawNameLC__0_k$ = function () {
    var tmp0_getValue_0 = rawNameLC$factory();
    return this._rawNameLC$delegate._get_value__0_k$();
  };
  OS.prototype._get_platformName__0_k$ = function () {
    return rawPlatformName;
  };
  OS.prototype._get_platformNameLC__0_k$ = function () {
    var tmp0_getValue_0 = platformNameLC$factory();
    return this._platformNameLC$delegate._get_value__0_k$();
  };
  OS.prototype._get_isWindows__0_k$ = function () {
    var tmp0_getValue_0 = isWindows$factory();
    return this._isWindows$delegate._get_value__0_k$();
  };
  OS.prototype._get_isMac__0_k$ = function () {
    var tmp0_getValue_0 = isMac$factory();
    return this._isMac$delegate._get_value__0_k$();
  };
  OS.prototype._get_isNative__0_k$ = function () {
    return rawPlatformName === 'native';
  };
  OS.prototype._get_isJsNodeJs__0_k$ = function () {
    return this._get_platformNameLC__0_k$() === 'node.js';
  };
  OS.prototype._get_isJsBrowser__0_k$ = function () {
    return this._get_platformNameLC__0_k$() === 'web.js';
  };
  OS.$metadata$ = {
    simpleName: 'OS',
    kind: 'object',
    interfaces: []
  };
  var OS_instance;
  function OS_getInstance() {
    if (OS_instance == null)
      new OS();
    return OS_instance;
  }
  function rawNameLC$factory() {
    return getPropertyCallableRef('rawNameLC', 1, KProperty1, function (receiver) {
      return receiver._get_rawNameLC__0_k$();
    }, null);
  }
  function platformNameLC$factory() {
    return getPropertyCallableRef('platformNameLC', 1, KProperty1, function (receiver) {
      return receiver._get_platformNameLC__0_k$();
    }, null);
  }
  function isWindows$factory() {
    return getPropertyCallableRef('isWindows', 1, KProperty1, function (receiver) {
      return receiver._get_isWindows__0_k$();
    }, null);
  }
  function isMac$factory() {
    return getPropertyCallableRef('isMac', 1, KProperty1, function (receiver) {
      return receiver._get_isMac__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_160() {
    var i = new _no_name_provided__203();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_161() {
    var i = new _no_name_provided__204();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_162() {
    var i = new _no_name_provided__205();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_163() {
    var i = new _no_name_provided__206();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_164() {
    var i = new _no_name_provided__207();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_165() {
    var i = new _no_name_provided__208();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_166() {
    var i = new _no_name_provided__209();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_167() {
    var i = new _no_name_provided__210();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_168() {
    var i = new _no_name_provided__211();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided__212($callback, resultContinuation) {
    this._$callback_2 = $callback;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__212.prototype.invoke_0_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__212.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$callback_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__212.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__212(this._$callback_2, completion);
    return i;
  };
  _no_name_provided__212.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function AsyncOnce() {
    this._promise = null;
  }
  AsyncOnce.prototype.invoke_juk2pn_k$ = function (callback, $cont) {
    if (this._promise == null) {
      var tmp = this;
      var tmp_0 = $cont._get_context__0_k$();
      tmp._promise = asyncImmediately(tmp_0, _no_name_provided_$factory_169(callback, null));
    }return ensureNotNull(this._promise).await_0_k$($cont);
  };
  AsyncOnce.$metadata$ = {
    simpleName: 'AsyncOnce',
    kind: 'class',
    interfaces: []
  };
  function Once() {
    this._completed_0 = false;
  }
  Once.$metadata$ = {
    simpleName: 'Once',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_169($callback, resultContinuation) {
    var i = new _no_name_provided__212($callback, resultContinuation);
    var l = function ($cont) {
      return i.invoke_0_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  var LONG_ZERO_TO_MAX_RANGE;
  function toLongRange(_this_) {
    return toLong(_this_._get_start__0_k$()).rangeTo_wiekkq_k$(toLong(_this_._get_endInclusive__0_k$()));
  }
  function LONG_ZERO_TO_MAX_RANGE$init$() {
    var tmp = new Long(0, 0);
    Companion_getInstance_17();
    return tmp.rangeTo_wiekkq_k$(new Long(-1, 2147483647));
  }
  function _get_length__0(_this_) {
    return (_this_._get_endInclusive__0_k$() - _this_._get_start__0_k$() | 0) + 1 | 0;
  }
  function _get_endExclusive_(_this_) {
    return _this_._get_endInclusive__0_k$() + 1 | 0;
  }
  function Companion_123() {
    Companion_instance_122 = this;
  }
  Companion_123.prototype.fromList_ortqkv_k$ = function (lits) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(lits.length);
    var indexedObject = lits;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_2bq_k$(item_2_3.length);
      Unit_getInstance();
    }
    var tmp0_toTypedArray_0 = distinct(reversed(sorted(tmp0_mapTo_0_1)));
    var lengths = copyToArray_0(tmp0_toTypedArray_0);
    var map_0 = LinkedHashMap_init_$Create$();
    var n_1 = 0;
    while (n_1 < lits.length) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = lits[tmp0_2];
      map_0.put_1q9pf_k$(tmp1__anonymous__3, true);
      Unit_getInstance();
    }
    return new Literals(lits, map_0, lengths);
  };
  Companion_123.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_122;
  function Companion_getInstance_122() {
    if (Companion_instance_122 == null)
      new Companion_123();
    return Companion_instance_122;
  }
  function Companion_124() {
    Companion_instance_123 = this;
  }
  Companion_124.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_123;
  function Companion_getInstance_123() {
    if (Companion_instance_123 == null)
      new Companion_124();
    return Companion_instance_123;
  }
  function StrReader_init_$Init$(str, file, pos, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      file = 'file';
    if (!(($mask0 & 4) === 0))
      pos = 0;
    StrReader.call($this, str, file, pos);
    return $this;
  }
  function StrReader_init_$Create$(str, file, pos, $mask0, $marker) {
    return StrReader_init_$Init$(str, file, pos, $mask0, $marker, Object.create(StrReader.prototype));
  }
  function Companion_125() {
    Companion_instance_124 = this;
  }
  Companion_125.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_124;
  function Companion_getInstance_124() {
    if (Companion_instance_124 == null)
      new Companion_125();
    return Companion_instance_124;
  }
  function posSkip($this, count_0) {
    var out = $this._pos_0;
    var tmp0_this = $this;
    tmp0_this._pos_0 = tmp0_this._pos_0 + count_0 | 0;
    return out;
  }
  function substr_2($this, pos, length) {
    var tmp3_substring_0 = $this._str_3;
    var tmp0_min_0 = $this._length_2;
    var tmp4_substring_0 = Math.min(pos, tmp0_min_0);
    var tmp1_min_0 = pos + length | 0;
    var tmp2_min_0 = $this._length_2;
    var tmp5_substring_0 = Math.min(tmp1_min_0, tmp2_min_0);
    return tmp3_substring_0.substring(tmp4_substring_0, tmp5_substring_0);
  }
  function Literals(lits, map_0, lengths) {
    Companion_getInstance_122();
    this._lits = lits;
    this._map_6 = map_0;
    this._lengths = lengths;
  }
  Literals.prototype.toString = function () {
    return '' + 'Literals(' + joinToString$default(this._lits, ' ', null, null, 0, null, null, 62, null) + ')';
  };
  Literals.$metadata$ = {
    simpleName: 'Literals',
    kind: 'class',
    interfaces: []
  };
  function TRange(min_0, max, reader_0) {
    Companion_getInstance_123();
    this._min_1 = min_0;
    this._max_1 = max;
    this._reader_3 = reader_0;
  }
  TRange.prototype.toString = function () {
    return '' + this._min_1 + ':' + this._max_1;
  };
  TRange.prototype._get_text__0_k$ = function () {
    return this._reader_3.slice_27zxwg_k$(this._min_1, this._max_1);
  };
  TRange.$metadata$ = {
    simpleName: 'TRange',
    kind: 'class',
    interfaces: []
  };
  function StrReader(str, file, pos) {
    Companion_getInstance_124();
    this._str_3 = str;
    this._file_2 = file;
    this._pos_0 = pos;
    this._tempCharArray = charArray(this._str_3.length);
    this._length_2 = this._str_3.length;
  }
  StrReader.prototype._get_available__0_k$ = function () {
    return this._length_2 - this._pos_0 | 0;
  };
  StrReader.prototype._get_eof__0_k$ = function () {
    return this._pos_0 >= this._str_3.length;
  };
  StrReader.prototype._get_hasMore__0_k$ = function () {
    return this._pos_0 < this._str_3.length;
  };
  StrReader.prototype.createRange_27zxwg_k$ = function (start, end) {
    return new TRange(start, end, this);
  };
  StrReader.prototype.slice_27zxwg_k$ = function (start, end) {
    var tmp0_substring_0 = this._str_3;
    return tmp0_substring_0.substring(start, end);
  };
  StrReader.prototype.peek_ha5a7z_k$ = function (count_0) {
    return substr_2(this, this._pos_0, count_0);
  };
  StrReader.prototype.peek_0_k$ = function () {
    return this._get_hasMore__0_k$() ? charSequenceGet(this._str_3, this._pos_0) : new Char(0);
  };
  StrReader.prototype.peekChar_0_k$ = function () {
    return this._get_hasMore__0_k$() ? charSequenceGet(this._str_3, this._pos_0) : new Char(0);
  };
  StrReader.prototype.read_ha5a7z_k$ = function (count_0) {
    var tmp0_apply_0 = this.peek_ha5a7z_k$(count_0);
    this.skip_ha5a7z_k$(count_0);
    Unit_getInstance();
    return tmp0_apply_0;
  };
  StrReader.prototype.skipUntil_9o0tv_k$ = function (char) {
    var tmp = this._pos_0;
    var skipPos = indexOf$default(this._str_3, char, tmp, false, 4, null);
    this._pos_0 = skipPos >= 0 ? skipPos : this._length_2;
  };
  StrReader.prototype.skipUntilIncluded_9o0tv_k$ = function (char) {
    this.skipUntil_9o0tv_k$(char);
    if (this._get_hasMore__0_k$() ? this.peekChar_0_k$().equals(char) : false) {
      this.skip_ha5a7z_k$(1);
      Unit_getInstance();
    }};
  StrReader.prototype.readUntil_wi8o78_k$ = function (char) {
    var start_1 = this._pos_0;
    this.skipUntil_9o0tv_k$(char);
    var end_2 = this._pos_0;
    return end_2 > start_1 ? this.slice_27zxwg_k$(start_1, end_2) : null;
  };
  StrReader.prototype.readUntilIncluded_wi8o78_k$ = function (char) {
    var start_1 = this._pos_0;
    this.skipUntilIncluded_9o0tv_k$(char);
    var end_2 = this._pos_0;
    return end_2 > start_1 ? this.slice_27zxwg_k$(start_1, end_2) : null;
  };
  StrReader.prototype.unread_ha5a7z_k$ = function (count_0) {
    var tmp0_this = this;
    tmp0_this._pos_0 = tmp0_this._pos_0 - count_0 | 0;
    return this;
  };
  StrReader.prototype.unread$default_l3mjq9_k$ = function (count_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      count_0 = 1;
    return this.unread_ha5a7z_k$(count_0);
  };
  StrReader.prototype.readChar_0_k$ = function () {
    return this._get_hasMore__0_k$() ? charSequenceGet(this._str_3, posSkip(this, 1)) : new Char(0);
  };
  StrReader.prototype.read_0_k$ = function () {
    return this._get_hasMore__0_k$() ? charSequenceGet(this._str_3, posSkip(this, 1)) : new Char(0);
  };
  StrReader.prototype.readRemaining_0_k$ = function () {
    return this.read_ha5a7z_k$(this._get_available__0_k$());
  };
  StrReader.prototype.skipExpect_9o0tv_k$ = function (expected) {
    var readed = this.readChar_0_k$();
    if (!readed.equals(expected))
      throw IllegalArgumentException_init_$Create$('' + "Expected '" + expected + "' but found '" + readed + "' at " + this._pos_0);
  };
  StrReader.prototype.skip_ha5a7z_k$ = function (count_0) {
    var tmp0_this = this;
    tmp0_this._pos_0 = tmp0_this._pos_0 + count_0 | 0;
    return this;
  };
  StrReader.prototype.tryLit_6wfw3l_k$ = function (lit) {
    if (!(substr_2(this, this._pos_0, lit.length) === lit))
      return null;
    var tmp0_this = this;
    tmp0_this._pos_0 = tmp0_this._pos_0 + lit.length | 0;
    return lit;
  };
  StrReader.prototype.skipSpaces_0_k$ = function () {
    $l$break: while (true) {
      var tmp;
      if (this._get_hasMore__0_k$()) {
        var tmp0__anonymous__1_2 = this.peekChar_0_k$();
        tmp = isWhitespaceFast(tmp0__anonymous__1_2);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }this.readChar_0_k$();
      Unit_getInstance();
    }
    return this;
  };
  StrReader.prototype.matchIdentifier_0_k$ = function () {
    var start_1_1 = this._pos_0;
    $l$break: while (true) {
      var tmp;
      if (this._get_hasMore__0_k$()) {
        var tmp0__anonymous__3 = this.peekChar_0_k$();
        tmp = ((isLetterDigitOrUnderscore(tmp0__anonymous__3) ? true : tmp0__anonymous__3.equals(new Char(45))) ? true : tmp0__anonymous__3.equals(new Char(126))) ? true : tmp0__anonymous__3.equals(new Char(58));
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }this.readChar_0_k$();
      Unit_getInstance();
    }
    var end_2_2 = this._pos_0;
    return end_2_2 > start_1_1 ? this.slice_27zxwg_k$(start_1_1, end_2_2) : null;
  };
  StrReader.prototype.matchSingleOrDoubleQuoteString_0_k$ = function () {
    var tmp0_subject = this.peekChar_0_k$();
    var tmp;
    if (tmp0_subject.equals(new Char(39)) ? true : tmp0_subject.equals(new Char(34))) {
      var start_1 = this._pos_0;
      var quoteType_4 = this.readChar_0_k$();
      this.readUntil_wi8o78_k$(quoteType_4);
      Unit_getInstance();
      this.readChar_0_k$();
      Unit_getInstance();
      var end_2 = this._pos_0;
      tmp = end_2 > start_1 ? this.slice_27zxwg_k$(start_1, end_2) : null;
    } else {
      tmp = null;
    }
    return tmp;
  };
  StrReader.prototype.tryRegex_x1socs_k$ = function (v) {
    var tmp0_substring_0 = this._str_3;
    var tmp1_substring_0 = this._pos_0;
    var tmp = tmp0_substring_0.substring(tmp1_substring_0);
    var tmp0_elvis_lhs = v.find$default_5nuume_k$(tmp, 0, 2, null);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var result = tmp_0;
    var m = ensureNotNull(result._get_groups__0_k$().get_ha5a7z_k$(0))._value;
    var tmp1_this = this;
    tmp1_this._pos_0 = tmp1_this._pos_0 + m.length | 0;
    return m;
  };
  StrReader.prototype.clone_0_k$ = function () {
    return new StrReader(this._str_3, this._file_2, this._pos_0);
  };
  StrReader.prototype.tryRead_6wfw3l_k$ = function (str) {
    if (this.peek_ha5a7z_k$(str.length) === str) {
      this.skip_ha5a7z_k$(str.length);
      Unit_getInstance();
      return true;
    }return false;
  };
  StrReader.prototype.readFixedSizeInt_27zxwg_k$ = function (count_0, radix) {
    var tmp0_min_0 = this._get_available__0_k$();
    var readCount = Math.min(tmp0_min_0, count_0);
    this.skip_ha5a7z_k$(readCount);
    Unit_getInstance();
    return NumberParser_getInstance().parseInt_tkm0xq_k$(this._str_3, this._pos_0 - readCount | 0, this._pos_0, radix);
  };
  StrReader.prototype.readStringLit_vcj5fe_k$ = function (reportErrors) {
    var out = this._tempCharArray;
    var outp = 0;
    var quotec = this.read_0_k$();
    var tmp0_subject = quotec;
    if (tmp0_subject.equals(new Char(34)) ? true : tmp0_subject.equals(new Char(39)))
      Unit_getInstance();
    else {
      invalidOp('Invalid string literal');
    }
    var closed = false;
    loop: while (this._get_hasMore__0_k$()) {
      var c = this.read_0_k$();
      if (c.equals(new Char(92))) {
        var cc = this.read_0_k$();
        var tmp2 = outp;
        outp = tmp2 + 1 | 0;
        var tmp1_subject = cc;
        var tmp;
        if (tmp1_subject.equals(new Char(92))) {
          tmp = new Char(92);
        } else if (tmp1_subject.equals(new Char(47))) {
          tmp = new Char(47);
        } else if (tmp1_subject.equals(new Char(39))) {
          tmp = new Char(39);
        } else if (tmp1_subject.equals(new Char(34))) {
          tmp = new Char(34);
        } else if (tmp1_subject.equals(new Char(98))) {
          tmp = new Char(8);
        } else if (tmp1_subject.equals(new Char(102))) {
          tmp = new Char(12);
        } else if (tmp1_subject.equals(new Char(110))) {
          tmp = new Char(10);
        } else if (tmp1_subject.equals(new Char(114))) {
          tmp = new Char(13);
        } else if (tmp1_subject.equals(new Char(116))) {
          tmp = new Char(9);
        } else if (tmp1_subject.equals(new Char(117))) {
          tmp = numberToChar(this.readFixedSizeInt_27zxwg_k$(4, 16));
        } else {
          throw new IOException('' + "Invalid char '" + cc + "'");
        }
        out[tmp2] = tmp;
      } else if (c.equals(quotec)) {
        closed = true;
        break loop;
      } else {
        var tmp3 = outp;
        outp = tmp3 + 1 | 0;
        out[tmp3] = c;
      }
    }
    if (!closed ? reportErrors : false) {
      throw RuntimeException_init_$Create$('' + "String literal not closed! '" + this._str_3 + "'");
    }return String_fromCharArray(out, 0, outp);
  };
  StrReader.prototype.readStringLit$default_gexuk8_k$ = function (reportErrors, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      reportErrors = true;
    return this.readStringLit_vcj5fe_k$(reportErrors);
  };
  StrReader.prototype.tryExpect_6wfw3l_k$ = function (str) {
    var inductionVariable = 0;
    var last_1 = str.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!this.peekOffset_ha5a7z_k$(n).equals(charSequenceGet(str, n)))
          return false;
      }
       while (inductionVariable < last_1);
    this.skip_ha5a7z_k$(str.length);
    Unit_getInstance();
    return true;
  };
  StrReader.prototype.tryExpect_wi8o78_k$ = function (str) {
    if (!this.peekChar_0_k$().equals(str))
      return false;
    this.skip_ha5a7z_k$(1);
    Unit_getInstance();
    return true;
  };
  StrReader.prototype.peekOffset_ha5a7z_k$ = function (offset_0) {
    var tmp0_getOrElse_0 = this._str_3;
    var tmp1_getOrElse_0 = this._pos_0 + offset_0 | 0;
    var tmp;
    if (tmp1_getOrElse_0 >= 0 ? tmp1_getOrElse_0 <= _get_lastIndex__5(tmp0_getOrElse_0) : false) {
      tmp = charSequenceGet(tmp0_getOrElse_0, tmp1_getOrElse_0);
    } else {
      tmp = new Char(0);
    }
    return tmp;
  };
  StrReader.$metadata$ = {
    simpleName: 'StrReader',
    kind: 'class',
    interfaces: []
  };
  function reader(_this_, file, pos) {
    return new StrReader(_this_, file, pos);
  }
  function reader$default(_this_, file, pos, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      file = 'file';
    if (!(($mask0 & 2) === 0))
      pos = 0;
    return reader(_this_, file, pos);
  }
  function unquote(_this_) {
    var tmp;
    if (isQuoted(_this_)) {
      var tmp0_substring_0 = _this_.length - 1 | 0;
      tmp = unescape(_this_.substring(1, tmp0_substring_0));
    } else {
      tmp = _this_;
    }
    return tmp;
  }
  function isQuoted(_this_) {
    var tmp;
    var tmp_0 = new Char(34);
    if (startsWith$default(_this_, tmp_0, false, 2, null)) {
      var tmp_1 = new Char(34);
      tmp = endsWith$default(_this_, tmp_1, false, 2, null);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  }
  function unescape(_this_) {
    var out = StringBuilder_init_$Create$_0();
    var n = 0;
    while (n < _this_.length) {
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var c = charSequenceGet(_this_, tmp0);
      var tmp1_subject = c;
      if (tmp1_subject.equals(new Char(92))) {
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var c2 = charSequenceGet(_this_, tmp2);
        var tmp3_subject = c2;
        if (tmp3_subject.equals(new Char(92))) {
          out.append_wi8o78_k$(new Char(92));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(34))) {
          out.append_wi8o78_k$(new Char(34));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(110))) {
          out.append_wi8o78_k$(new Char(10));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(114))) {
          out.append_wi8o78_k$(new Char(13));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(116))) {
          out.append_wi8o78_k$(new Char(9));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(117))) {
          var tmp0_substring_0 = n;
          var tmp1_substring_0 = n + 4 | 0;
          var chars = _this_.substring(tmp0_substring_0, tmp1_substring_0);
          n = n + 4 | 0;
          out.append_wi8o78_k$(numberToChar(toInt_0(chars, 16)));
          Unit_getInstance();
        } else {
          out.append_uch40_k$('' + '\\' + c2);
          Unit_getInstance();
        }
      } else {
        out.append_wi8o78_k$(c);
        Unit_getInstance();
      }
    }
    return out.toString();
  }
  function substringAfterOrNull(_this_, delimiter) {
    var tmp;
    if (contains$default(_this_, delimiter, false, 2, null)) {
      tmp = substringAfter$default(_this_, delimiter, null, 2, null);
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function substringBeforeOrNull(_this_, delimiter) {
    var tmp;
    if (contains$default(_this_, delimiter, false, 2, null)) {
      tmp = substringBefore$default(_this_, delimiter, null, 2, null);
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function Adler32() {
    Adler32_instance = this;
    this._BASE = 65521;
    this._initialValue = 1;
  }
  Adler32.prototype.update_9piif6_k$ = function (old, data, offset_0, len) {
    var s1 = old >>> 0 & 65535;
    var s2 = old >>> 16 & 65535;
    var inductionVariable = offset_0;
    var last_1 = offset_0 + len | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        s1 = (s1 + (data[n] & 255) | 0) % 65521;
        s2 = (s2 + s1 | 0) % 65521;
      }
       while (inductionVariable < last_1);
    return s2 << 16 | s1;
  };
  Adler32.$metadata$ = {
    simpleName: 'Adler32',
    kind: 'object',
    interfaces: [SimpleChecksum]
  };
  var Adler32_instance;
  function Adler32_getInstance() {
    if (Adler32_instance == null)
      new Adler32();
    return Adler32_instance;
  }
  function CRC32() {
    CRC32_instance = this;
    this._initialValue_0 = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 256;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var c = tmp_3;
      var inductionVariable = 0;
      if (inductionVariable < 8)
        do {
          var k = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          c = !((c & 1) === 0) ? -306674912 ^ c >>> 1 : c >>> 1;
        }
         while (inductionVariable < 8);
      tmp_2[tmp_3] = c;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._TABLE_0 = tmp_2;
  }
  CRC32.prototype.update_9piif6_k$ = function (old, data, offset_0, len) {
    var c = ~old;
    var table = this._TABLE_0;
    var inductionVariable = offset_0;
    var last_1 = offset_0 + len | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        c = table[(c ^ data[n] & 255) & 255] ^ c >>> 8;
      }
       while (inductionVariable < last_1);
    return ~c;
  };
  CRC32.$metadata$ = {
    simpleName: 'CRC32',
    kind: 'object',
    interfaces: [SimpleChecksum]
  };
  var CRC32_instance;
  function CRC32_getInstance() {
    if (CRC32_instance == null)
      new CRC32();
    return CRC32_instance;
  }
  function SimpleChecksum() {
  }
  SimpleChecksum.prototype.update$default_esd280_k$ = function (old, data, offset_0, len, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      offset_0 = 0;
    if (!(($mask0 & 8) === 0))
      len = data.length - offset_0 | 0;
    return $handler == null ? this.update_9piif6_k$(old, data, offset_0, len) : $handler(old, data, offset_0, len);
  };
  SimpleChecksum.$metadata$ = {
    simpleName: 'SimpleChecksum',
    kind: 'interface',
    interfaces: []
  };
  function _get_Language_CURRENT_() {
    var tmp0_getValue_0 = Language_CURRENT$factory();
    return Language_CURRENT$delegate._get_value__0_k$();
  }
  var Language_CURRENT$delegate;
  function _no_name_provided__213() {
  }
  _no_name_provided__213.prototype.invoke_0_k$ = function () {
    var tmp0_mapNotNull_0 = _get_systemLanguageStrings_();
    var tmp0_mapNotNullTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_mapNotNull_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp = Companion_getInstance_125()._BY_ID;
      var tmp_0 = new Char(45);
      var tmp0_safe_receiver_2_4_4 = tmp.get_2bw_k$(substringBefore$default(element_2_3, tmp_0, null, 2, null));
      if (tmp0_safe_receiver_2_4_4 == null)
        null;
      else {
        tmp0_mapNotNullTo_0_1.add_2bq_k$(tmp0_safe_receiver_2_4_4);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    return tmp0_mapNotNullTo_0_1;
  };
  _no_name_provided__213.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__214() {
  }
  _no_name_provided__214.prototype.invoke_0_k$ = function () {
    var tmp0_elvis_lhs = firstOrNull(Companion_getInstance_125()._get_SYSTEM_LANGS__0_k$());
    return tmp0_elvis_lhs == null ? Language_ENGLISH_getInstance() : tmp0_elvis_lhs;
  };
  _no_name_provided__214.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var Language_JAPANESE_instance;
  var Language_ENGLISH_instance;
  var Language_FRENCH_instance;
  var Language_SPANISH_instance;
  var Language_GERMAN_instance;
  var Language_ITALIAN_instance;
  var Language_DUTCH_instance;
  var Language_PORTUGUESE_instance;
  var Language_RUSSIAN_instance;
  var Language_KOREAN_instance;
  var Language_CHINESE_instance;
  function Companion_126() {
    Companion_instance_125 = this;
    var tmp = this;
    var tmp0_map_0 = values_4();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0.length);
    var indexedObject = tmp0_map_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_toLowerCase_0_5 = item_2_3._get_name__0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(to(tmp0_toLowerCase_0_5.toLowerCase(), item_2_3));
      Unit_getInstance();
    }
    var tmp1_map_0 = values_4();
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(tmp1_map_0.length);
    var indexedObject_0 = tmp1_map_0;
    var inductionVariable_0 = 0;
    var last_2 = indexedObject_0.length;
    while (inductionVariable_0 < last_2) {
      var item_2_3_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      tmp0_mapTo_0_1_0.add_2bq_k$(to(item_2_3_0._iso6391, item_2_3_0));
      Unit_getInstance();
    }
    var tmp_0 = plus(tmp0_mapTo_0_1, tmp0_mapTo_0_1_0);
    var tmp2_map_0 = values_4();
    var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(tmp2_map_0.length);
    var indexedObject_1 = tmp2_map_0;
    var inductionVariable_1 = 0;
    var last_3 = indexedObject_1.length;
    while (inductionVariable_1 < last_3) {
      var item_2_3_1 = indexedObject_1[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      tmp0_mapTo_0_1_1.add_2bq_k$(to(item_2_3_1._iso6392, item_2_3_1));
      Unit_getInstance();
    }
    tmp._BY_ID = toMap_0(plus(tmp_0, tmp0_mapTo_0_1_1));
    var tmp_1 = this;
    tmp_1._SYSTEM_LANGS$delegate = lazy(_no_name_provided_$factory_171());
    var tmp_2 = this;
    tmp_2._SYSTEM$delegate = lazy(_no_name_provided_$factory_172());
  }
  Companion_126.prototype._get_SYSTEM_LANGS__0_k$ = function () {
    var tmp0_getValue_0 = SYSTEM_LANGS$factory();
    return this._SYSTEM_LANGS$delegate._get_value__0_k$();
  };
  Companion_126.prototype._get_SYSTEM__0_k$ = function () {
    var tmp0_getValue_0 = SYSTEM$factory();
    return this._SYSTEM$delegate._get_value__0_k$();
  };
  Companion_126.prototype._get_CURRENT__0_k$ = function () {
    return _get_Language_CURRENT_()._get_value__0_k$();
  };
  Companion_126.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_125;
  function Companion_getInstance_125() {
    if (Companion_instance_125 == null)
      new Companion_126();
    return Companion_instance_125;
  }
  function values_4() {
    return [Language_JAPANESE_getInstance(), Language_ENGLISH_getInstance(), Language_FRENCH_getInstance(), Language_SPANISH_getInstance(), Language_GERMAN_getInstance(), Language_ITALIAN_getInstance(), Language_DUTCH_getInstance(), Language_PORTUGUESE_getInstance(), Language_RUSSIAN_getInstance(), Language_KOREAN_getInstance(), Language_CHINESE_getInstance()];
  }
  var Language_entriesInitialized;
  function Language_initEntries() {
    if (Language_entriesInitialized)
      return Unit_getInstance();
    Language_entriesInitialized = true;
    Language_JAPANESE_instance = new Language('JAPANESE', 0, 'ja', 'jpn');
    Language_ENGLISH_instance = new Language('ENGLISH', 1, 'en', 'eng');
    Language_FRENCH_instance = new Language('FRENCH', 2, 'fr', 'fra');
    Language_SPANISH_instance = new Language('SPANISH', 3, 'es', 'spa');
    Language_GERMAN_instance = new Language('GERMAN', 4, 'de', 'deu');
    Language_ITALIAN_instance = new Language('ITALIAN', 5, 'it', 'ita');
    Language_DUTCH_instance = new Language('DUTCH', 6, 'nl', 'nld');
    Language_PORTUGUESE_instance = new Language('PORTUGUESE', 7, 'pt', 'por');
    Language_RUSSIAN_instance = new Language('RUSSIAN', 8, 'ru', 'rus');
    Language_KOREAN_instance = new Language('KOREAN', 9, 'ko', 'kor');
    Language_CHINESE_instance = new Language('CHINESE', 10, 'zh', 'zho');
    Companion_getInstance_125();
  }
  function Language(name, ordinal, iso6391, iso6392) {
    Enum.call(this, name, ordinal);
    this._iso6391 = iso6391;
    this._iso6392 = iso6392;
  }
  Language.$metadata$ = {
    simpleName: 'Language',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__215() {
  }
  _no_name_provided__215.prototype.invoke_0_k$ = function () {
    return KorAtomicRef_0(Companion_getInstance_125()._get_SYSTEM__0_k$());
  };
  _no_name_provided__215.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Language_JAPANESE_getInstance() {
    Language_initEntries();
    return Language_JAPANESE_instance;
  }
  function Language_ENGLISH_getInstance() {
    Language_initEntries();
    return Language_ENGLISH_instance;
  }
  function Language_FRENCH_getInstance() {
    Language_initEntries();
    return Language_FRENCH_instance;
  }
  function Language_SPANISH_getInstance() {
    Language_initEntries();
    return Language_SPANISH_instance;
  }
  function Language_GERMAN_getInstance() {
    Language_initEntries();
    return Language_GERMAN_instance;
  }
  function Language_ITALIAN_getInstance() {
    Language_initEntries();
    return Language_ITALIAN_instance;
  }
  function Language_DUTCH_getInstance() {
    Language_initEntries();
    return Language_DUTCH_instance;
  }
  function Language_PORTUGUESE_getInstance() {
    Language_initEntries();
    return Language_PORTUGUESE_instance;
  }
  function Language_RUSSIAN_getInstance() {
    Language_initEntries();
    return Language_RUSSIAN_instance;
  }
  function Language_KOREAN_getInstance() {
    Language_initEntries();
    return Language_KOREAN_instance;
  }
  function Language_CHINESE_getInstance() {
    Language_initEntries();
    return Language_CHINESE_instance;
  }
  function Language_CURRENT$factory() {
    return getPropertyCallableRef('Language_CURRENT', 0, KProperty0, function () {
      return _get_Language_CURRENT_();
    }, null);
  }
  function SYSTEM_LANGS$factory() {
    return getPropertyCallableRef('SYSTEM_LANGS', 1, KProperty1, function (receiver) {
      return receiver._get_SYSTEM_LANGS__0_k$();
    }, null);
  }
  function SYSTEM$factory() {
    return getPropertyCallableRef('SYSTEM', 1, KProperty1, function (receiver) {
      return receiver._get_SYSTEM__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_170() {
    var i = new _no_name_provided__215();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_171() {
    var i = new _no_name_provided__213();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_172() {
    var i = new _no_name_provided__214();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _get_jsLocalStorageVfs_() {
    var tmp0_getValue_0 = jsLocalStorageVfs$factory();
    return jsLocalStorageVfs$delegate._get_value__0_k$();
  }
  var jsLocalStorageVfs$delegate;
  function _no_name_provided__216() {
  }
  _no_name_provided__216.prototype.get_6wfw3l_k$ = function (key, $cont) {
    var tmp0_get_0 = localStorage;
    return tmp0_get_0[key];
  };
  _no_name_provided__216.prototype.set_wbz76b_k$ = function (key, value, $cont) {
    var tmp0_set_0_2 = localStorage;
    return tmp0_set_0_2[key] = value;
  };
  _no_name_provided__216.$metadata$ = {
    kind: 'class',
    interfaces: [SimpleStorage]
  };
  function _no_name_provided__217() {
  }
  _no_name_provided__217.prototype.invoke_0_k$ = function () {
    return new MapLikeStorageVfs(new _no_name_provided__216());
  };
  _no_name_provided__217.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function jsLocalStorageVfs$factory() {
    return getPropertyCallableRef('jsLocalStorageVfs', 0, KProperty0, function () {
      return _get_jsLocalStorageVfs_();
    }, null);
  }
  function _no_name_provided_$factory_173() {
    var i = new _no_name_provided__217();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _get_jsbaseUrl_() {
    var tmp0_getValue_0 = jsbaseUrl$factory();
    return jsbaseUrl$delegate._get_value__0_k$();
  }
  var jsbaseUrl$delegate;
  var globalDynamic;
  var global;
  function _get_isWeb_() {
    var tmp0_getValue_0 = isWeb$factory();
    return isWeb$delegate._get_value__0_k$();
  }
  var isWeb$delegate;
  function _get_isWorker_() {
    var tmp0_getValue_0 = isWorker$factory();
    return isWorker$delegate._get_value__0_k$();
  }
  var isWorker$delegate;
  function _get_isNodeJs_() {
    var tmp0_getValue_0 = isNodeJs$factory();
    return isNodeJs$delegate_0._get_value__0_k$();
  }
  var isNodeJs$delegate_0;
  function _get_isShell_() {
    return (!_get_isWeb_() ? !_get_isNodeJs_() : false) ? !_get_isWorker_() : false;
  }
  function jsObjectKeysArray(obj) {
    var tmp = jsToArray(jsObjectKeys(obj));
    return isArray(tmp) ? tmp : THROW_CCE();
  }
  function jsToArray(obj) {
    var tmp = 0;
    var tmp_0 = obj.length;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = obj[tmp_2];
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function jsObjectKeys(obj) {
    return jsObjectKeys$outlinedJsCode$(obj);
  }
  function jsObjectKeys$outlinedJsCode$(obj) {
    return Object.keys(obj);
  }
  function _no_name_provided__218() {
  }
  _no_name_provided__218.prototype.invoke_0_k$ = function () {
    var tmp0_safe_receiver = document.location;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.href;
    var href = tmp1_elvis_lhs == null ? '.' : tmp1_elvis_lhs;
    var tmp;
    if (endsWith$default_1(href, '/', false, 2, null)) {
      tmp = href;
    } else {
      {
        var tmp_0 = new Char(47);
        tmp = substringBeforeLast$default(href, tmp_0, null, 2, null);
      }
    }
    return tmp;
  };
  _no_name_provided__218.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__219() {
  }
  _no_name_provided__219.prototype.invoke_0_k$ = function () {
    var tmp0_unsafeCast_0 = typeof window === 'object';
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__219.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__220() {
  }
  _no_name_provided__220.prototype.invoke_0_k$ = function () {
    var tmp0_unsafeCast_0 = typeof importScripts === 'function';
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__220.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__221() {
  }
  _no_name_provided__221.prototype.invoke_0_k$ = function () {
    var tmp0_unsafeCast_0 = typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__221.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function jsbaseUrl$factory() {
    return getPropertyCallableRef('jsbaseUrl', 0, KProperty0, function () {
      return _get_jsbaseUrl_();
    }, null);
  }
  function isWeb$factory() {
    return getPropertyCallableRef('isWeb', 0, KProperty0, function () {
      return _get_isWeb_();
    }, null);
  }
  function isWorker$factory() {
    return getPropertyCallableRef('isWorker', 0, KProperty0, function () {
      return _get_isWorker_();
    }, null);
  }
  function isNodeJs$factory() {
    return getPropertyCallableRef('isNodeJs', 0, KProperty0, function () {
      return _get_isNodeJs_();
    }, null);
  }
  function _no_name_provided_$factory_174() {
    var i = new _no_name_provided__218();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_175() {
    var i = new _no_name_provided__219();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_176() {
    var i = new _no_name_provided__220();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_177() {
    var i = new _no_name_provided__221();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function Deflate(windowBits) {
    return new DeflatePortable(windowBits);
  }
  function korAtomic(initial) {
    return new KorAtomicRef(initial, true);
  }
  function korAtomic_0(initial) {
    return new KorAtomicBoolean(initial, true);
  }
  function Lock() {
  }
  Lock.$metadata$ = {
    simpleName: 'Lock',
    kind: 'class',
    interfaces: []
  };
  function DynamicInternal() {
    DynamicInternal_instance = this;
    this._global = typeof global !== 'undefined' ? global : window;
  }
  DynamicInternal.prototype._get_global__0_k$ = function () {
    return this._global;
  };
  DynamicInternal.prototype.set_ih9ei8_k$ = function (instance, key, value) {
    instance[key] = value;
  };
  DynamicInternal.$metadata$ = {
    simpleName: 'DynamicInternal',
    kind: 'object',
    interfaces: [DynApi]
  };
  var DynamicInternal_instance;
  function DynamicInternal_getInstance() {
    if (DynamicInternal_instance == null)
      new DynamicInternal();
    return DynamicInternal_instance;
  }
  function toVfs(_this_) {
    var file = _this_;
    return (new _no_name_provided__224(file)).get_6wfw3l_k$(file.name);
  }
  function openAsync_1(_this_) {
    var tmp = new BlobAsyncBaseStream(_this_);
    return buffered(toAsyncStream$default(tmp, new Long(0, 0), 1, null), 65536, 16);
  }
  function _no_name_provided__222($reader, $len, $buffer, $offset, $deferred) {
    this._$reader = $reader;
    this._$len_1 = $len;
    this._$buffer_1 = $buffer;
    this._$offset_1 = $offset;
    this._$deferred_0 = $deferred;
  }
  _no_name_provided__222.prototype.invoke_5tgw3j_k$ = function (it) {
    var tmp0_unsafeCast_0 = this._$reader.result;
    var ab = tmp0_unsafeCast_0;
    var tmp1_min_0 = ab.byteLength;
    var minLen = Math.min(tmp1_min_0, this._$len_1);
    arraycopy_2(toByteArray_0(new Int8Array(ab)), 0, this._$buffer_1, this._$offset_1, minLen);
    return this._$deferred_0.complete_2c5_k$(minLen);
  };
  _no_name_provided__222.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_5tgw3j_k$(p1 instanceof Event ? p1 : THROW_CCE());
  };
  _no_name_provided__222.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__223($deferred, $reader) {
    this._$deferred_1 = $deferred;
    this._$reader_0 = $reader;
  }
  _no_name_provided__223.prototype.invoke_5tgw3j_k$ = function (it) {
    return this._$deferred_1.completeExceptionally_onfaoi_k$(newThrowable('' + this._$reader_0.error, void 1));
  };
  _no_name_provided__223.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_5tgw3j_k$(p1 instanceof Event ? p1 : THROW_CCE());
  };
  _no_name_provided__223.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BlobAsyncBaseStream(blob) {
    AsyncStreamBase.call(this);
    this._blob = blob;
  }
  BlobAsyncBaseStream.prototype.close_sv8swh_k$ = function ($cont) {
  };
  BlobAsyncBaseStream.prototype.read_pwamfb_k$ = function (position_0, buffer, offset_0, len, $cont) {
    var deferred = CompletableDeferred$default(null, 1, null);
    var reader_0 = new FileReader();
    reader_0.onload = _no_name_provided_$factory_178(reader_0, len, buffer, offset_0, deferred);
    reader_0.onerror = _no_name_provided_$factory_179(deferred, reader_0);
    var tmp0_unsafeCast_0 = this._blob;
    reader_0.readAsArrayBuffer(tmp0_unsafeCast_0.slice(position_0.toDouble_0_k$(), position_0.toDouble_0_k$() + len));
    return deferred.await_0_k$($cont);
  };
  BlobAsyncBaseStream.prototype.getLength_0_k$ = function ($cont) {
    return numberToLong(this._blob.size);
  };
  BlobAsyncBaseStream.$metadata$ = {
    simpleName: 'BlobAsyncBaseStream',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__224($file) {
    this._$file = $file;
    Vfs.call(this);
    this._absolutePath_0 = this._$file.name;
  }
  _no_name_provided__224.prototype._get_absolutePath__0_k$ = function () {
    return this._absolutePath_0;
  };
  _no_name_provided__224.prototype.open_4jc6oe_k$ = function (path_0, mode, $cont) {
    return openAsync_1(this._$file);
  };
  _no_name_provided__224.prototype.listSimple_6wfw3l_k$ = function (path_0, $cont) {
    var tmp;
    switch (path_0) {
      case '/':
      case '':
        tmp = listOf_0(this.get_6wfw3l_k$(this._$file.name));
        break;
      default:tmp = emptyList();
        break;
    }
    return tmp;
  };
  _no_name_provided__224.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_178($reader, $len, $buffer, $offset, $deferred) {
    var i = new _no_name_provided__222($reader, $len, $buffer, $offset, $deferred);
    return function (p1) {
      return i.invoke_5tgw3j_k$(p1);
    };
  }
  function _no_name_provided_$factory_179($deferred, $reader) {
    var i = new _no_name_provided__223($deferred, $reader);
    return function (p1) {
      return i.invoke_5tgw3j_k$(p1);
    };
  }
  var File_separatorChar;
  function _get_tmpdir_() {
    var tmp0_getValue_0 = tmpdir$factory();
    return tmpdir$delegate._get_value__0_k$();
  }
  var tmpdir$delegate;
  function _get_absoluteCwd_() {
    var tmp0_getValue_0 = absoluteCwd$factory();
    return absoluteCwd$delegate._get_value__0_k$();
  }
  var absoluteCwd$delegate;
  function _get_resourcesVfs_() {
    var tmp0_getValue_0 = resourcesVfs$factory();
    return resourcesVfs$delegate._get_value__0_k$();
  }
  var resourcesVfs$delegate;
  function _get_rootLocalVfs_() {
    var tmp0_getValue_0 = rootLocalVfs$factory();
    return rootLocalVfs$delegate._get_value__0_k$();
  }
  var rootLocalVfs$delegate;
  function _get_applicationVfs_() {
    var tmp0_getValue_0 = applicationVfs$factory();
    return applicationVfs$delegate._get_value__0_k$();
  }
  var applicationVfs$delegate;
  var applicationDataVfs$delegate;
  var cacheVfs$delegate;
  var externalStorageVfs$delegate;
  var userHomeVfs$delegate;
  var tempVfs$delegate;
  function localVfs(path_0, async_0) {
    var tmp;
    {
      var tmp_0 = _get_jsbaseUrl_();
      tmp = UrlVfs$default_0(tmp_0, null, false, 6, null).get_6wfw3l_k$(path_0);
    }
    return tmp;
  }
  function localVfs$default(path_0, async_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      async_0 = true;
    return localVfs(path_0, async_0);
  }
  function _no_name_provided__225() {
  }
  _no_name_provided__225.prototype.invoke_0_k$ = function () {
    return '/tmp';
  };
  _no_name_provided__225.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__226() {
  }
  _no_name_provided__226.prototype.invoke_0_k$ = function () {
    return '.';
  };
  _no_name_provided__226.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__227() {
  }
  _no_name_provided__227.prototype.invoke_0_k$ = function () {
    return _get_applicationVfs_().jail_0_k$();
  };
  _no_name_provided__227.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__228() {
  }
  _no_name_provided__228.prototype.invoke_0_k$ = function () {
    var tmp = _get_absoluteCwd_();
    return localVfs$default(tmp, false, 2, null);
  };
  _no_name_provided__228.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__229() {
  }
  _no_name_provided__229.prototype.invoke_0_k$ = function () {
    var tmp = _get_absoluteCwd_();
    return localVfs$default(tmp, false, 2, null);
  };
  _no_name_provided__229.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__230() {
  }
  _no_name_provided__230.prototype.invoke_0_k$ = function () {
    return _get_jsLocalStorageVfs_()._get_root__0_k$();
  };
  _no_name_provided__230.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__231() {
  }
  _no_name_provided__231.prototype.invoke_0_k$ = function () {
    return MemoryVfs$default(null, false, 3, null);
  };
  _no_name_provided__231.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__232() {
  }
  _no_name_provided__232.prototype.invoke_0_k$ = function () {
    var tmp = _get_absoluteCwd_();
    return localVfs$default(tmp, false, 2, null);
  };
  _no_name_provided__232.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__233() {
  }
  _no_name_provided__233.prototype.invoke_0_k$ = function () {
    var tmp = _get_absoluteCwd_();
    return localVfs$default(tmp, false, 2, null);
  };
  _no_name_provided__233.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__234() {
  }
  _no_name_provided__234.prototype.invoke_0_k$ = function () {
    var tmp;
    if (_get_isNodeJs_()) {
      var tmp_0 = _get_tmpdir_();
      tmp = localVfs$default(tmp_0, false, 2, null);
    } else {
      tmp = MemoryVfs$default(null, false, 3, null);
    }
    return tmp;
  };
  _no_name_provided__234.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function tmpdir$factory() {
    return getPropertyCallableRef('tmpdir', 0, KProperty0, function () {
      return _get_tmpdir_();
    }, null);
  }
  function absoluteCwd$factory() {
    return getPropertyCallableRef('absoluteCwd', 0, KProperty0, function () {
      return _get_absoluteCwd_();
    }, null);
  }
  function resourcesVfs$factory() {
    return getPropertyCallableRef('resourcesVfs', 0, KProperty0, function () {
      return _get_resourcesVfs_();
    }, null);
  }
  function rootLocalVfs$factory() {
    return getPropertyCallableRef('rootLocalVfs', 0, KProperty0, function () {
      return _get_rootLocalVfs_();
    }, null);
  }
  function applicationVfs$factory() {
    return getPropertyCallableRef('applicationVfs', 0, KProperty0, function () {
      return _get_applicationVfs_();
    }, null);
  }
  function _no_name_provided_$factory_180() {
    var i = new _no_name_provided__225();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_181() {
    var i = new _no_name_provided__226();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_182() {
    var i = new _no_name_provided__227();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_183() {
    var i = new _no_name_provided__228();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_184() {
    var i = new _no_name_provided__229();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_185() {
    var i = new _no_name_provided__230();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_186() {
    var i = new _no_name_provided__231();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_187() {
    var i = new _no_name_provided__232();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_188() {
    var i = new _no_name_provided__233();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_189() {
    var i = new _no_name_provided__234();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _get_portableSimpleName_(_this_) {
    var tmp0_elvis_lhs = _this_._get_simpleName__0_k$();
    return tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs;
  }
  function EnvironmentInternal() {
    EnvironmentInternal_instance = this;
    var tmp = this;
    var tmp_0;
    if (OS_getInstance()._get_isJsNodeJs__0_k$()) {
      var tmp0_associate_0 = jsObjectKeysArray(process.env);
      var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associate_0.length), 16);
      var tmp1_associateTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
      var indexedObject = tmp0_associate_0;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2_4 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_plusAssign_0_5 = to(element_2_4, process.env[element_2_4]);
        tmp1_associateTo_0_2.put_1q9pf_k$(tmp0_plusAssign_0_5._first, tmp0_plusAssign_0_5._second);
        Unit_getInstance();
      }
      tmp_0 = tmp1_associateTo_0_2;
    } else {
      var tmp_1 = QueryString_getInstance();
      var tmp0_safe_receiver = document.location;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.search;
      var tmp1_map_0 = tmp_1.decode_3ajhph_k$(trimStart(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs, charArrayOf([new Char(63)])));
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp1_map_0._get_size__0_k$());
      var tmp0_iterator_1_2 = tmp1_map_0._get_entries__0_k$().iterator_0_k$();
      while (tmp0_iterator_1_2.hasNext_0_k$()) {
        var item_2_3 = tmp0_iterator_1_2.next_0_k$();
        var tmp_2 = item_2_3._get_key__0_k$();
        var tmp0_elvis_lhs_5 = firstOrNull(item_2_3._get_value__0_k$());
        tmp0_mapTo_0_1.add_2bq_k$(to(tmp_2, tmp0_elvis_lhs_5 == null ? item_2_3._get_key__0_k$() : tmp0_elvis_lhs_5));
        Unit_getInstance();
      }
      tmp_0 = toMap_0(tmp0_mapTo_0_1);
    }
    tmp._allEnvs = tmp_0;
    var tmp_3 = this;
    var tmp0_map_0 = this._allEnvs;
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(tmp0_map_0._get_size__0_k$());
    var tmp0_iterator_1_2_0 = tmp0_map_0._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var item_2_3_0 = tmp0_iterator_1_2_0.next_0_k$();
      var tmp0_toUpperCase_0_5 = item_2_3_0._get_key__0_k$();
      tmp0_mapTo_0_1_0.add_2bq_k$(to(tmp0_toUpperCase_0_5.toUpperCase(), item_2_3_0._get_value__0_k$()));
      Unit_getInstance();
    }
    tmp_3._allEnvsUpperCase = toMap_0(tmp0_mapTo_0_1_0);
  }
  EnvironmentInternal.prototype.get_6wfw3l_k$ = function (key) {
    return this._allEnvsUpperCase.get_2bw_k$(key.toUpperCase());
  };
  EnvironmentInternal.$metadata$ = {
    simpleName: 'EnvironmentInternal',
    kind: 'object',
    interfaces: []
  };
  var EnvironmentInternal_instance;
  function EnvironmentInternal_getInstance() {
    if (EnvironmentInternal_instance == null)
      new EnvironmentInternal();
    return EnvironmentInternal_instance;
  }
  function FileNotFoundException(msg) {
    IOException.call(this, msg);
    captureStack(this, FileNotFoundException);
  }
  FileNotFoundException.$metadata$ = {
    simpleName: 'FileNotFoundException',
    kind: 'class',
    interfaces: []
  };
  function printStackTrace_0(_this_) {
    var e = _this_;
    try {
      var tmp = console;
      tmp.error(e);
      var tmp_0 = console;
      tmp_0.error(e.stack);
    } catch ($p) {
      console.error('Error logging into console');
      try {
        console.error($p);
      } catch ($p_0) {
      }
    }
  }
  function IOException(msg) {
    Exception_init_$Init$_0(msg, this);
    captureStack(this, IOException);
  }
  IOException.$metadata$ = {
    simpleName: 'IOException',
    kind: 'class',
    interfaces: []
  };
  function EOFException(msg) {
    IOException.call(this, msg);
    captureStack(this, EOFException);
  }
  EOFException.$metadata$ = {
    simpleName: 'EOFException',
    kind: 'class',
    interfaces: []
  };
  function NativeThreadLocal() {
    this._value_17 = this.initialValue_0_k$();
  }
  NativeThreadLocal.prototype.get_0_k$ = function () {
    return this._value_17;
  };
  NativeThreadLocal.$metadata$ = {
    simpleName: 'NativeThreadLocal',
    kind: 'class',
    interfaces: []
  };
  var UTF8;
  function _no_name_provided__235() {
    UTC8CharsetBase.call(this, 'UTF-8');
    var tmp = this;
    var tmp_0;
    try {
      tmp_0 = new TextDecoder('utf-8');
    } catch ($p) {
      var tmp_1;
      {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    tmp._textDecoder = tmp_0;
    var tmp_2 = this;
    var tmp_3;
    try {
      tmp_3 = new TextEncoder('utf-8');
    } catch ($p_0) {
      var tmp_4;
      {
        tmp_4 = null;
      }
      tmp_3 = tmp_4;
    }
    tmp_2._textEncoder = tmp_3;
  }
  _no_name_provided__235.prototype.decode_g45q85_k$ = function (out, src, start, end) {
    if (!(this._textDecoder == null)) {
      var srcBuffer = src;
      out.append_uch40_k$(this._textDecoder.decode(new Int8Array(srcBuffer.buffer, start, end - start | 0)));
      Unit_getInstance();
    } else {
      UTC8CharsetBase.prototype.decode_g45q85_k$.call(this, out, src, start, end);
    }
  };
  _no_name_provided__235.prototype.encode_kaapbp_k$ = function (out, src, start, end) {
    if (!(this._textEncoder == null)) {
      var ba = this._textEncoder.encode(toString_1(charSequenceSubSequence(src, start, end)));
      var tmp0_unsafeCast_0 = new Int8Array(ba.buffer);
      out.append$default_ffc7am_k$(tmp0_unsafeCast_0, 0, 0, 6, null);
    } else {
      UTC8CharsetBase.prototype.encode_kaapbp_k$.call(this, out, src, start, end);
    }
  };
  _no_name_provided__235.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UTF8$init$() {
    return new _no_name_provided__235();
  }
  var asyncSocketFactory$delegate;
  function _no_name_provided__236() {
    AsyncSocketFactory.call(this);
  }
  _no_name_provided__236.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__237() {
  }
  _no_name_provided__237.prototype.invoke_0_k$ = function () {
    return new _no_name_provided__236();
  };
  _no_name_provided__237.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_190() {
    var i = new _no_name_provided__237();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _get_httpFactory_() {
    var tmp0_getValue_0 = httpFactory$factory();
    return httpFactory$delegate._get_value__0_k$();
  }
  var httpFactory$delegate;
  function Companion_127() {
    Companion_instance_126 = this;
    var tmp = this;
    var tmp0_lowercase_0 = Companion_getInstance_116()._ContentLength;
    tmp._unsafeHeadersNormalized = setOf(['connection', tmp0_lowercase_0.toLowerCase()]);
  }
  Companion_127.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_126;
  function Companion_getInstance_126() {
    if (Companion_instance_126 == null)
      new Companion_127();
    return Companion_instance_126;
  }
  function _no_name_provided__238($xhr, $deferred) {
    this._$xhr = $xhr;
    this._$deferred_2 = $deferred;
  }
  _no_name_provided__238.prototype.invoke_5tgw3j_k$ = function (e) {
    var tmp0_unsafeCast_0 = this._$xhr.response;
    var tmp1_unsafeCast_0 = new Int8Array(tmp0_unsafeCast_0);
    var out = tmp1_unsafeCast_0;
    var tmp = this._$xhr.status;
    var tmp_0 = this._$xhr.statusText;
    var tmp_1 = Headers_init_$Create$_1(this._$xhr.getAllResponseHeaders());
    var tmp_2 = openAsync$default(out, null, 1, null);
    return this._$deferred_2.complete_2c5_k$(new Response_0(tmp, tmp_0, tmp_1, tmp_2, openAsync$default(out, null, 1, null)));
  };
  _no_name_provided__238.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_5tgw3j_k$(p1 instanceof Event ? p1 : THROW_CCE());
  };
  _no_name_provided__238.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__239($deferred, $xhr, $url) {
    this._$deferred_3 = $deferred;
    this._$xhr_0 = $xhr;
    this._$url = $url;
  }
  _no_name_provided__239.prototype.invoke_5tgw3j_k$ = function (e) {
    return this._$deferred_3.completeExceptionally_onfaoi_k$(RuntimeException_init_$Create$('' + 'Error status=' + this._$xhr_0.status + ",'" + this._$xhr_0.statusText + "' opening " + this._$url));
  };
  _no_name_provided__239.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_5tgw3j_k$(p1 instanceof Event ? p1 : THROW_CCE());
  };
  _no_name_provided__239.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__240($deferred, $xhr) {
    this._$deferred_4 = $deferred;
    this._$xhr_1 = $xhr;
  }
  _no_name_provided__240.prototype.invoke_houul8_k$ = function (it) {
    if (this._$deferred_4._get_isCancelled__0_k$()) {
      this._$xhr_1.abort();
    }};
  _no_name_provided__240.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_houul8_k$((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__240.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $requestInternalCOROUTINE$190(_this_, method, url, headers, content, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__117 = _this_;
    this._method_1 = method;
    this._url_3 = url;
    this._headers_4 = headers;
    this._content_4 = content;
  }
  $requestInternalCOROUTINE$190.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            tmp_0._deferred0 = CompletableDeferred_0(Job$default(null, 1, null));
            this._xhr1 = new XMLHttpRequest();
            this._xhr1.open(this._method_1._get_name__0_k$(), this._url_3, true);
            var tmp_1 = this;
            tmp_1._tmp0__get_ARRAYBUFFER__02 = null;
            var tmp_2 = this;
            tmp_2._tmp0_unsafeCast_0_13 = 'arraybuffer';
            this._xhr1.responseType = this._tmp0_unsafeCast_0_13;
            this._xhr1.onload = _no_name_provided_$factory_192(this._xhr1, this._deferred0);
            this._xhr1.onerror = _no_name_provided_$factory_193(this._deferred0, this._xhr1, this._url_3);
            var tmp0_iterator = this._headers_4.iterator_0_k$();
            while (tmp0_iterator.hasNext_0_k$()) {
              var header = tmp0_iterator.next_0_k$();
              var tmp1_lowercase_0 = header._first;
              var tmp2_trim_0 = tmp1_lowercase_0.toLowerCase();
              var hnname = toString_1(trim_0(isCharSequence(tmp2_trim_0) ? tmp2_trim_0 : THROW_CCE()));
              if (!Companion_getInstance_126()._unsafeHeadersNormalized.contains_2bq_k$(hnname)) {
                this._xhr1.setRequestHeader(header._first, header._second);
              }}

            this._deferred0.invokeOnCompletion_wjzpsu_k$(_no_name_provided_$factory_194(this._deferred0, this._xhr1));
            Unit_getInstance();
            if (!(this._content_4 == null)) {
              this._state_1 = 1;
              suspendResult = readAll(this._content_4, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._xhr1.send();
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT4_0 = suspendResult;
            this._xhr1.send(this._ARGUMENT4_0);
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            suspendResult = this._deferred0.await_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $requestInternalCOROUTINE$190.$metadata$ = {
    simpleName: '$requestInternalCOROUTINE$190',
    kind: 'class',
    interfaces: []
  };
  function HttpClientBrowserJs() {
    Companion_getInstance_126();
    HttpClient.call(this);
  }
  HttpClientBrowserJs.prototype.requestInternal_ap218m_k$ = function (method, url, headers, content, $cont) {
    var tmp = new $requestInternalCOROUTINE$190(this, method, url, headers, content, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HttpClientBrowserJs.$metadata$ = {
    simpleName: 'HttpClientBrowserJs',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__241() {
  }
  _no_name_provided__241.prototype.createClient_0_k$ = function () {
    return new HttpClientBrowserJs();
  };
  _no_name_provided__241.$metadata$ = {
    kind: 'class',
    interfaces: [HttpFactory]
  };
  function _no_name_provided__242() {
  }
  _no_name_provided__242.prototype.invoke_0_k$ = function () {
    return new _no_name_provided__241();
  };
  _no_name_provided__242.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function httpFactory$factory() {
    return getPropertyCallableRef('httpFactory', 0, KProperty0, function () {
      return _get_httpFactory_();
    }, null);
  }
  function _no_name_provided_$factory_191() {
    var i = new _no_name_provided__242();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_192($xhr, $deferred) {
    var i = new _no_name_provided__238($xhr, $deferred);
    return function (p1) {
      return i.invoke_5tgw3j_k$(p1);
    };
  }
  function _no_name_provided_$factory_193($deferred, $xhr, $url) {
    var i = new _no_name_provided__239($deferred, $xhr, $url);
    return function (p1) {
      return i.invoke_5tgw3j_k$(p1);
    };
  }
  function _no_name_provided_$factory_194($deferred, $xhr) {
    var i = new _no_name_provided__240($deferred, $xhr);
    return function (p1) {
      i.invoke_houul8_k$(p1);
      return Unit_getInstance();
    };
  }
  function toByteArray_0(_this_) {
    var tout = _this_;
    var tmp;
    if (!(tout == null) ? isByteArray(tout) : false) {
      tmp = tout;
    } else {
      {
        var out = new Int8Array(_this_.length);
        var inductionVariable = 0;
        var last_1 = out.length - 1 | 0;
        if (inductionVariable <= last_1)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            out[n] = _this_[n];
          }
           while (inductionVariable <= last_1);
        tmp = out;
      }
    }
    return tmp;
  }
  function _get_rawOsName_() {
    var tmp0_getValue_0 = rawOsName$factory();
    return rawOsName$delegate._get_value__0_k$();
  }
  var rawOsName$delegate;
  var rawPlatformName;
  function _no_name_provided__243() {
  }
  _no_name_provided__243.prototype.invoke_0_k$ = function () {
    var tmp;
    if (_get_isNodeJs_()) {
      var tmp0_unsafeCast_0 = process.platform;
      tmp = tmp0_unsafeCast_0;
    } else {
      var tmp1_unsafeCast_0 = navigator.platform;
      tmp = tmp1_unsafeCast_0;
    }
    return tmp;
  };
  _no_name_provided__243.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function rawOsName$factory() {
    return getPropertyCallableRef('rawOsName', 0, KProperty0, function () {
      return _get_rawOsName_();
    }, null);
  }
  function _no_name_provided_$factory_195() {
    var i = new _no_name_provided__243();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function rawPlatformName$init$() {
    return _get_isWeb_() ? 'web.js' : _get_isNodeJs_() ? 'node.js' : _get_isWorker_() ? 'worker.js' : _get_isShell_() ? 'shell.js' : 'js';
  }
  function _get_systemLanguageStrings_() {
    var tmp0_getValue_0 = systemLanguageStrings$factory();
    return systemLanguageStrings$delegate._get_value__0_k$();
  }
  var systemLanguageStrings$delegate;
  function _no_name_provided__244() {
  }
  _no_name_provided__244.prototype.invoke_0_k$ = function () {
    var tmp;
    if (_get_isNodeJs_()) {
      var env = process.env;
      var tmp0_elvis_lhs = env.LANG;
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? env.LANGUAGE : tmp0_elvis_lhs;
      var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? env.LC_ALL : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? env.LC_MESSAGES : tmp2_elvis_lhs;
      tmp = listOf_0(tmp3_elvis_lhs == null ? 'english' : tmp3_elvis_lhs);
    } else {
      tmp = asList(window.navigator.languages);
    }
    return tmp;
  };
  _no_name_provided__244.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function systemLanguageStrings$factory() {
    return getPropertyCallableRef('systemLanguageStrings', 0, KProperty0, function () {
      return _get_systemLanguageStrings_();
    }, null);
  }
  function _no_name_provided_$factory_196() {
    var i = new _no_name_provided__244();
    return function () {
      return i.invoke_0_k$();
    };
  }
  var GrowMethod_GROW_IMAGE_instance;
  var GrowMethod_NEW_IMAGES_instance;
  var GrowMethod_entriesInitialized;
  function GrowMethod_initEntries() {
    if (GrowMethod_entriesInitialized)
      return Unit_getInstance();
    GrowMethod_entriesInitialized = true;
    GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
    GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
  }
  function MutableAtlas_init_$Init$(width, height, border, premultiplied, allowToGrow, growMethod, $this) {
    var tmp = Companion_getInstance_42();
    MutableAtlas.call($this, tmp.invoke$default_zcmln7_k$(width, height, null, 4, null), border, premultiplied, allowToGrow, growMethod);
    return $this;
  }
  function MutableAtlas_init_$Init$_0(width, height, border, premultiplied, allowToGrow, growMethod, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 2048;
    if (!(($mask0 & 2) === 0))
      height = width;
    if (!(($mask0 & 4) === 0))
      border = 2;
    if (!(($mask0 & 8) === 0))
      premultiplied = true;
    if (!(($mask0 & 16) === 0))
      allowToGrow = true;
    if (!(($mask0 & 32) === 0))
      growMethod = GrowMethod_NEW_IMAGES_getInstance();
    MutableAtlas_init_$Init$(width, height, border, premultiplied, allowToGrow, growMethod, $this);
    return $this;
  }
  function MutableAtlas_init_$Create$(width, height, border, premultiplied, allowToGrow, growMethod, $mask0, $marker) {
    return MutableAtlas_init_$Init$_0(width, height, border, premultiplied, allowToGrow, growMethod, $mask0, $marker, Object.create(MutableAtlas.prototype));
  }
  function GrowMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  GrowMethod.$metadata$ = {
    simpleName: 'GrowMethod',
    kind: 'class',
    interfaces: []
  };
  function Entry_1(slice_1, data) {
    this._slice = slice_1;
    this._data_24 = data;
  }
  Entry_1.prototype.toString = function () {
    return '' + 'Entry(slice=' + this._slice + ', data=' + this._data_24 + ')';
  };
  Entry_1.prototype.hashCode = function () {
    var result = hashCode(this._slice);
    result = imul(result, 31) + (this._data_24 == null ? 0 : hashCode(this._data_24)) | 0;
    return result;
  };
  Entry_1.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_1))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Entry_1 ? other : THROW_CCE();
    if (!equals_1(this._slice, tmp0_other_with_cast._slice))
      return false;
    if (!equals_1(this._data_24, tmp0_other_with_cast._data_24))
      return false;
    return true;
  };
  Entry_1.$metadata$ = {
    simpleName: 'Entry',
    kind: 'class',
    interfaces: []
  };
  function reconstructWithSize($this, width, height) {
    var slices = toList_3($this._entries);
    var tmp = $this;
    var tmp_0 = Companion_getInstance_42();
    tmp._binPacker = tmp_0.invoke$default_zcmln7_k$(width, height, null, 4, null);
    var tmp_1 = $this;
    tmp_1._bitmap = Bitmap32_init_$Create$(width, height, null, $this._premultiplied, 4, null);
    $this._allBitmaps.clear_sv8swh_k$();
    $this._allBitmaps.add_2bq_k$($this._bitmap);
    Unit_getInstance();
    $this._entriesByName.clear_sv8swh_k$();
    $this._entries.clear_sv8swh_k$();
    var tmp0_iterator = slices.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var entry = tmp0_iterator.next_0_k$();
      $this.add_3jnwib_k$(entry._slice, entry._data_24, entry._slice._get_name__0_k$());
      Unit_getInstance();
    }
  }
  function grow_1($this, bmp) {
    var tmp0_subject = $this._growMethod;
    if (tmp0_subject.equals(GrowMethod_GROW_IMAGE_getInstance()))
      reconstructWithSize($this, imul($this._get_width__0_k$(), 2), imul($this._get_height__0_k$(), 2));
    else if (tmp0_subject.equals(GrowMethod_NEW_IMAGES_getInstance())) {
      if (bmp._get_width__0_k$() > $this._get_width__0_k$() ? true : bmp._get_height__0_k$() > $this._get_height__0_k$()) {
        var tmp0_error_0 = '' + 'Atlas is too small (' + $this._get_width__0_k$() + 'x' + $this._get_height__0_k$() + ') to hold a slice of (' + bmp._get_width__0_k$() + 'x' + bmp._get_height__0_k$() + ')';
        throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
      }var tmp = $this;
      var tmp_0 = Companion_getInstance_42();
      var tmp_1 = $this._get_width__0_k$();
      var tmp_2 = $this._get_height__0_k$();
      tmp._binPacker = tmp_0.invoke$default_zcmln7_k$(tmp_1, tmp_2, null, 4, null);
      var tmp_3 = $this;
      var tmp_4 = $this._get_width__0_k$();
      var tmp_5 = $this._get_height__0_k$();
      tmp_3._bitmap = Bitmap32_init_$Create$(tmp_4, tmp_5, null, $this._premultiplied, 4, null);
      $this._allBitmaps.add_2bq_k$($this._bitmap);
      Unit_getInstance();
    }}
  function GrowMethod_GROW_IMAGE_getInstance() {
    GrowMethod_initEntries();
    return GrowMethod_GROW_IMAGE_instance;
  }
  function GrowMethod_NEW_IMAGES_getInstance() {
    GrowMethod_initEntries();
    return GrowMethod_NEW_IMAGES_instance;
  }
  function MutableAtlas(binPacker, border, premultiplied, allowToGrow, growMethod) {
    this._binPacker = binPacker;
    this._border = border;
    this._premultiplied = premultiplied;
    this._allowToGrow = allowToGrow;
    this._growMethod = growMethod;
    var tmp = this;
    var tmp_0 = this._get_width__0_k$();
    var tmp_1 = this._get_height__0_k$();
    tmp._bitmap = Bitmap32_init_$Create$(tmp_0, tmp_1, null, this._premultiplied, 4, null);
    this._allBitmaps = arrayListOf([this._bitmap]);
    var tmp_2 = this;
    tmp_2._entries = ArrayList_init_$Create$();
    this._entriesByName = LinkedHashMap_init_$Create$();
    this._biggestEmptyEntry = null;
  }
  MutableAtlas.prototype._get_width__0_k$ = function () {
    return numberToInt(this._binPacker._width_1);
  };
  MutableAtlas.prototype._get_height__0_k$ = function () {
    return numberToInt(this._binPacker._height_1);
  };
  MutableAtlas.prototype._get_size__0_k$ = function () {
    return this._entries._get_size__0_k$();
  };
  MutableAtlas.prototype.add_eklde7_k$ = function (bmp, data, name) {
    return this.add_3jnwib_k$(slice$default(bmp, null, name, 1, null), data, name);
  };
  MutableAtlas.prototype.add$default_3pfalt_k$ = function (bmp, data, name, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      name = '' + 'Slice' + this._get_size__0_k$();
    return this.add_eklde7_k$(bmp, data, name);
  };
  MutableAtlas.prototype.add_bahizy_k$ = function (bmp, data, name) {
    var tmp;
    var tmp_0;
    if (bmp instanceof BitmapSlice) {
      var tmp_1 = bmp._get_bmp__0_k$();
      tmp_0 = tmp_1 instanceof Bitmap32;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this.add_3jnwib_k$(bmp instanceof BitmapSlice ? bmp : THROW_CCE(), data, name);
    } else {
      {
        tmp = this.add_eklde7_k$(extract_2(bmp).toBMP32IfRequired_0_k$(), data, name);
      }
    }
    return tmp;
  };
  MutableAtlas.prototype.add$default_em5mj4_k$ = function (bmp, data, name, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      name = bmp._name_12;
    return this.add_bahizy_k$(bmp, data, name);
  };
  MutableAtlas.prototype.add_3jnwib_k$ = function (bmp, data, name) {
    try {
      var tmp0_elvis_lhs = name;
      var rname = tmp0_elvis_lhs == null ? '' + 'Slice' + this._get_size__0_k$() : tmp0_elvis_lhs;
      var isEmpty_0 = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty_0 ? !(this._biggestEmptyEntry == null) : false) {
        var bigEmptySlice = ensureNotNull(this._biggestEmptyEntry)._slice;
        if (bigEmptySlice._get_width__0_k$() >= bmp._get_width__0_k$() ? bigEmptySlice._get_height__0_k$() >= bmp._get_height__0_k$() : false) {
          var tmp = Companion_getInstance_36().invoke_ihmn6a_k$(0, 0, bmp._get_width__0_k$(), bmp._get_height__0_k$());
          entry = new Entry_1(bigEmptySlice.slice$default_7tbffz_k$(tmp, null, 2, null), data);
        }}if (entry == null) {
        var rect_3 = this._binPacker.add_ngl742_k$(bmp._get_width__0_k$() + imul(this._border, 2), bmp._get_height__0_k$() + imul(this._border, 2));
        var slice_1 = sliceWithSize_1(this._bitmap, numberToInt(rect_3._get_left__0_k$() + this._border), numberToInt(rect_3._get_top__0_k$() + this._border), bmp._get_width__0_k$(), bmp._get_height__0_k$(), rname);
        var dstX = slice_1._get_left__0_k$();
        var dstY = slice_1._get_top__0_k$();
        this._bitmap.draw_ree07h_k$(bmp, dstX, dstY);
        expandBorder(this._bitmap, new RectangleInt(slice_1._get_bounds__t4v1qq_k$()), this._border);
        entry = new Entry_1(slice_1, data);
        if (this._biggestEmptyEntry == null ? true : bmp._get_area__0_k$() > ensureNotNull(this._biggestEmptyEntry)._slice._get_area__0_k$()) {
          this._biggestEmptyEntry = entry;
        }}var tmp1_this = this;
      var tmp0_plusAssign_0 = tmp1_this._entries;
      var tmp1_plusAssign_0 = entry;
      tmp0_plusAssign_0.add_2bq_k$(tmp1_plusAssign_0);
      Unit_getInstance();
      var tmp2_set_0 = this._entriesByName;
      var tmp3_set_0 = entry;
      tmp2_set_0.put_1q9pf_k$(rname, tmp3_set_0);
      Unit_getInstance();
      var tmp2_this = this._bitmap;
      var tmp3 = tmp2_this._get_contentVersion__0_k$();
      tmp2_this._set_contentVersion__majfzk_k$(tmp3 + 1 | 0);
      Unit_getInstance();
      return entry;
    } catch ($p) {
      if ($p instanceof Error) {
        if (!this._allowToGrow)
          throw $p;
        grow_1(this, bmp);
        return this.add_3jnwib_k$(bmp, data, name);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  MutableAtlas.$metadata$ = {
    simpleName: 'MutableAtlas',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__245(this$0) {
    this._this$0_56 = this$0;
  }
  _no_name_provided__245.prototype.invoke_wd8tzq_k$ = function () {
    return Companion_getInstance_135().invoke_spsmd3_k$(imul(this._this$0_56._width_2, 2));
  };
  _no_name_provided__245.prototype.invoke_0_k$ = function () {
    return new RgbaArray(this.invoke_wd8tzq_k$());
  };
  _no_name_provided__245.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Bitmap(width, height, bpp, premultiplied, backingArray) {
    this._width_2 = width;
    this._height_3 = height;
    this._bpp = bpp;
    this._premultiplied_0 = premultiplied;
    this._backingArray = backingArray;
    var tmp = this;
    tmp._$$delegate_0_15 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._tempRgba$delegate = lazy(_no_name_provided_$factory_197(this));
    this._contentVersion = 0;
    this._texture = null;
    this._mipmaps = false;
  }
  Bitmap.prototype._get_width__0_k$ = function () {
    return this._width_2;
  };
  Bitmap.prototype._get_height__0_k$ = function () {
    return this._height_3;
  };
  Bitmap.prototype._get_bpp__0_k$ = function () {
    return this._bpp;
  };
  Bitmap.prototype._set_premultiplied__rpwsgn_k$ = function (_set___) {
    this._premultiplied_0 = _set___;
  };
  Bitmap.prototype._get_premultiplied__0_k$ = function () {
    return this._premultiplied_0;
  };
  Bitmap.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_15._set_extra__n1onou_k$(_set___);
  };
  Bitmap.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_15._get_extra__0_k$();
  };
  Bitmap.prototype._get_tempRgba__wd8tzq_k$ = function () {
    var tmp0_getValue_0 = tempRgba$factory();
    return this._tempRgba$delegate._get_value__0_k$()._ints;
  };
  Bitmap.prototype._set_contentVersion__majfzk_k$ = function (_set___) {
    this._contentVersion = _set___;
  };
  Bitmap.prototype._get_contentVersion__0_k$ = function () {
    return this._contentVersion;
  };
  Bitmap.prototype._get_stride__0_k$ = function () {
    return imul(this._width_2, this._bpp) / 8 | 0;
  };
  Bitmap.prototype._get_area__0_k$ = function () {
    return imul(this._width_2, this._height_3);
  };
  Bitmap.prototype.index_27zxwg_k$ = function (x, y) {
    return imul(y, this._width_2) + x | 0;
  };
  Bitmap.prototype.lock_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  Bitmap.prototype.unlock_ixubtt_k$ = function (rect_3) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._contentVersion;
    tmp0_this._contentVersion = tmp1 + 1 | 0;
    return tmp1;
  };
  Bitmap.prototype.readPixelsUnsafe_c3kirt_k$ = function (x, y, width, height, out, offset_0) {
    var n = offset_0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            RgbaArray__set_impl(out, tmp2, this.getRgba_aewswh_k$(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  };
  Bitmap.prototype.writePixelsUnsafe_c3kirt_k$ = function (x, y, width, height, out, offset_0) {
    var n = offset_0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            this.setRgba_5mmwyp_k$(tmp, tmp_0, RgbaArray__get_impl(out, tmp2));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  };
  Bitmap.prototype.setRgba_5mmwyp_k$ = function (x, y, v) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  Bitmap.prototype.getRgba_aewswh_k$ = function (x, y) {
    return Colors_getInstance()._TRANSPARENT_BLACK;
  };
  Bitmap.prototype.setInt_zd700_k$ = function (x, y, color_0) {
    return Unit_getInstance();
  };
  Bitmap.prototype.getInt_27zxwg_k$ = function (x, y) {
    return 0;
  };
  Bitmap.prototype.getRgbaClamped_aewswh_k$ = function (x, y) {
    return this.inBounds_27zxwg_k$(x, y) ? this.getRgba_aewswh_k$(x, y) : Colors_getInstance()._TRANSPARENT_BLACK;
  };
  Bitmap.prototype.getRgbaSampled_saxtsd_k$ = function (x, y) {
    if (((x < 0.0 ? true : x >= this._width_2) ? true : y < 0.0) ? true : y >= this._height_3)
      return Colors_getInstance()._TRANSPARENT_BLACK;
    var x0 = toIntFloor(x);
    var x1 = toIntCeil(x);
    var y0 = toIntFloor(y);
    var y1 = toIntCeil(y);
    var xratio = x % 1;
    var yratio = y % 1;
    var c00 = this.getRgbaClamped_aewswh_k$(x0, y0);
    var c10 = this.inBounds_27zxwg_k$(x1, y0) ? this.getRgbaClamped_aewswh_k$(x1, y0) : c00;
    var c01 = this.inBounds_27zxwg_k$(x1, y1) ? this.getRgbaClamped_aewswh_k$(x0, y1) : c00;
    var c11 = this.inBounds_27zxwg_k$(x1, y1) ? this.getRgbaClamped_aewswh_k$(x1, y1) : c01;
    var c1 = Companion_getInstance_136().mixRgba_8z8h9u_k$(c00, c10, xratio);
    var c2 = Companion_getInstance_136().mixRgba_8z8h9u_k$(c01, c11, xratio);
    return Companion_getInstance_136().mixRgba_8z8h9u_k$(c1, c2, yratio);
  };
  Bitmap.prototype.copy_ffs0tm_k$ = function (srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.clampWidth_ha5a7z_k$(srcX);
    var srcX1 = src.clampWidth_ha5a7z_k$(srcX + width | 0);
    var srcY0 = src.clampHeight_ha5a7z_k$(srcY);
    var srcY1 = src.clampHeight_ha5a7z_k$(srcY + height | 0);
    var dstX0 = dst.clampWidth_ha5a7z_k$(dstX);
    var dstX1 = dst.clampWidth_ha5a7z_k$(dstX + width | 0);
    var dstY0 = dst.clampHeight_ha5a7z_k$(dstY);
    var dstY1 = dst.clampHeight_ha5a7z_k$(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    var tmp0_min_0 = srcX1 - srcX0 | 0;
    var tmp1_min_0 = dstX1 - dstX0 | 0;
    var width_0 = Math.min(tmp0_min_0, tmp1_min_0);
    var tmp2_min_0 = srcY1 - srcY0 | 0;
    var tmp3_min_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(tmp2_min_0, tmp3_min_0);
    this.copyUnchecked_ffs0tm_k$(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  };
  Bitmap.prototype.copyUnchecked_ffs0tm_k$ = function (srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.readPixelsUnsafe_c3kirt_k$(srcX, srcY + y | 0, width, 1, this._get_tempRgba__wd8tzq_k$(), 0);
        dst.writePixelsUnsafe_c3kirt_k$(dstX, dstY + y | 0, width, 1, this._get_tempRgba__wd8tzq_k$(), 0);
      }
       while (inductionVariable < height);
  };
  Bitmap.prototype.inBoundsX_ha5a7z_k$ = function (x) {
    return x >= 0 ? x < this._width_2 : false;
  };
  Bitmap.prototype.inBoundsY_ha5a7z_k$ = function (y) {
    return y >= 0 ? y < this._height_3 : false;
  };
  Bitmap.prototype.inBounds_27zxwg_k$ = function (x, y) {
    return this.inBoundsX_ha5a7z_k$(x) ? this.inBoundsY_ha5a7z_k$(y) : false;
  };
  Bitmap.prototype.clampX_ha5a7z_k$ = function (x) {
    return clamp_2(x, 0, this._width_2 - 1 | 0);
  };
  Bitmap.prototype.clampY_ha5a7z_k$ = function (y) {
    return clamp_2(y, 0, this._height_3 - 1 | 0);
  };
  Bitmap.prototype.clampWidth_ha5a7z_k$ = function (x) {
    return clamp_2(x, 0, this._width_2);
  };
  Bitmap.prototype.clampHeight_ha5a7z_k$ = function (y) {
    return clamp_2(y, 0, this._height_3);
  };
  Bitmap.prototype.flipY_0_k$ = function () {
    var inductionVariable = 0;
    var last_1 = this._height_3 / 2 | 0;
    if (inductionVariable < last_1)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.swapRows_rvwcgf_k$(y, (this._height_3 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last_1);
    return this;
  };
  Bitmap.prototype.swapRows_rvwcgf_k$ = function (y0, y1) {
    var inductionVariable = 0;
    var last_1 = this._width_2;
    if (inductionVariable < last_1)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.getInt_27zxwg_k$(x, y0);
        var c1 = this.getInt_27zxwg_k$(x, y1);
        this.setInt_zd700_k$(x, y0, c1);
        this.setInt_zd700_k$(x, y1, c0);
      }
       while (inductionVariable < last_1);
  };
  Bitmap.prototype.getContext2d_vcj5fe_k$ = function (antialiasing) {
    throw UnsupportedOperationException_init_$Create$_0('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  };
  Bitmap.prototype.createWithThisFormat_27zxwg_k$ = function (width, height) {
    invalidOp('' + 'Unsupported createWithThisFormat (' + this + ')');
  };
  Bitmap.prototype.toBMP32_0_k$ = function () {
    var tmp0_also_0 = Bitmap32_init_$Create$(this._width_2, this._height_3, null, this._premultiplied_0, 4, null);
    this.readPixelsUnsafe_c3kirt_k$(0, 0, this._width_2, this._height_3, tmp0_also_0._data_25, 0);
    return tmp0_also_0;
  };
  Bitmap.prototype.toBMP32IfRequired_0_k$ = function () {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      {
        tmp = this.toBMP32_0_k$();
      }
    }
    return tmp;
  };
  Bitmap.$metadata$ = {
    simpleName: 'Bitmap',
    kind: 'class',
    interfaces: [Sizeable, Extra]
  };
  function extract_1(_this_, x, y, width, height) {
    var out = createWithThisFormatTyped(_this_, width, height);
    _this_.copy_ffs0tm_k$(x, y, out, 0, 0, width, height);
    return out;
  }
  function createWithThisFormatTyped(_this_, width, height) {
    var tmp0_fastCastTo_0 = _this_.createWithThisFormat_27zxwg_k$(width, height);
    return tmp0_fastCastTo_0;
  }
  function mipmaps(_this_, enable) {
    _this_._mipmaps = enable;
    return _this_;
  }
  function tempRgba$factory() {
    return getPropertyCallableRef('tempRgba', 1, KProperty1, function (receiver) {
      return new RgbaArray(receiver._get_tempRgba__wd8tzq_k$());
    }, null);
  }
  function _no_name_provided_$factory_197(this$0) {
    var i = new _no_name_provided__245(this$0);
    return function () {
      return new RgbaArray(i.invoke_wd8tzq_k$());
    };
  }
  function Bitmap32_init_$Init$(width, height, data, premultiplied, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      data = Companion_getInstance_135().invoke_spsmd3_k$(imul(width, height));
    if (!(($mask0 & 8) === 0))
      premultiplied = false;
    Bitmap32.call($this, width, height, data, premultiplied);
    return $this;
  }
  function Bitmap32_init_$Create$(width, height, data, premultiplied, $mask0, $marker) {
    return Bitmap32_init_$Init$(width, height, data, premultiplied, $mask0, $marker, Object.create(Bitmap32.prototype));
  }
  function Bitmap32_init_$Init$_0(width, height, value, premultiplied, $this) {
    Bitmap32_init_$Init$(width, height, null, premultiplied, 4, null, $this);
    RgbaArray__fill$default_impl($this._data_25, value, 0, 0, 6, null);
    return $this;
  }
  function Bitmap32_init_$Create$_0(width, height, value, premultiplied) {
    return Bitmap32_init_$Init$_0(width, height, value, premultiplied, Object.create(Bitmap32.prototype));
  }
  function Companion_128() {
    Companion_instance_127 = this;
  }
  Companion_128.prototype.invoke_3e3oii_k$ = function (width, height, premultiplied) {
    return Bitmap32_init_$Create$_0(width, height, Colors_getInstance()._TRANSPARENT_BLACK, premultiplied);
  };
  Companion_128.prototype.copyChannel_gfwdxt_k$ = function (src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel._shift;
    var dstShift = dstChannel._shift;
    var dstClear = dstChannel._clearMask;
    var dstData = dst._data_25;
    var srcData = src._data_25;
    var inductionVariable = 0;
    var last_1 = dst._get_area__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = _RgbaArray___get_ints__impl_(srcData)[n] >>> srcShift & 255;
        RgbaArray__set_impl(dstData, n, _RGBA___init__impl_(_RgbaArray___get_ints__impl_(dstData)[n] & dstClear | c << dstShift));
      }
       while (inductionVariable < last_1);
  };
  Companion_128.prototype.copyChannel_91r7hw_k$ = function (src, dst, dstChannel) {
    var destShift = imul(dstChannel._index_16, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last_1 = dst._get_area__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src._get_data__0_k$()[n] & 255;
        RgbaArray__set_impl(dst._data_25, n, _RGBA___init__impl_(_RgbaArray___get_ints__impl_(dst._data_25)[n] & destClear | c << destShift));
      }
       while (inductionVariable < last_1);
  };
  Companion_128.prototype.copyChannel_okdjg2_k$ = function (src, srcChannel, dst) {
    var shift = srcChannel._shift;
    var inductionVariable = 0;
    var last_1 = src._get_area__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst._get_data__0_k$()[n] = toByte(_RgbaArray___get_ints__impl_(src._data_25)[n] >>> shift & 255);
      }
       while (inductionVariable < last_1);
  };
  Companion_128.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_127;
  function Companion_getInstance_127() {
    if (Companion_instance_127 == null)
      new Companion_128();
    return Companion_instance_127;
  }
  function Bitmap32(width, height, data, premultiplied) {
    Companion_getInstance_127();
    Bitmap.call(this, width, height, 32, premultiplied, new RgbaArray(data));
    this._data_25 = data;
    this._dataPremult = _RgbaPremultipliedArray___init__impl_(_RgbaArray___get_ints__impl_(this._data_25));
    if (_RgbaArray___get_size__impl_(this._data_25) < imul(width, height))
      throw RuntimeException_init_$Create$('' + 'Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + _RgbaArray___get_size__impl_(this._data_25) + '), area=' + imul(width, height));
    var tmp = this;
    var tmp_0 = Companion_getInstance_135();
    tmp._temp_8 = tmp_0.invoke_spsmd3_k$(Math.max(width, height));
    this._bounds = new RectangleInt(Companion_getInstance_36().invoke_ihmn6a_k$(0, 0, width, height));
  }
  Bitmap32.prototype.createWithThisFormat_27zxwg_k$ = function (width, height) {
    return Bitmap32_init_$Create$(width, height, null, this._get_premultiplied__0_k$(), 4, null);
  };
  Bitmap32.prototype.copyUnchecked_ffs0tm_k$ = function (srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return Bitmap.prototype.copyUnchecked_ffs0tm_k$.call(this, srcX, srcY, dst, dstX, dstY, width, height);
    else {
    }
    var src = this;
    var srcArray = src._data_25;
    var dstArray = dst._data_25;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy_3(_RgbaArray___get_ints__impl_(srcArray), src.index_27zxwg_k$(srcX, srcY + y | 0), _RgbaArray___get_ints__impl_(dstArray), dst.index_27zxwg_k$(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  };
  Bitmap32.prototype.set_5mmwyp_k$ = function (x, y, color_0) {
    RgbaArray__set_impl(this._data_25, this.index_27zxwg_k$(x, y), color_0);
  };
  Bitmap32.prototype.get_aewswh_k$ = function (x, y) {
    return RgbaArray__get_impl(this._data_25, this.index_27zxwg_k$(x, y));
  };
  Bitmap32.prototype.setInt_zd700_k$ = function (x, y, color_0) {
    RgbaArray__set_impl(this._data_25, this.index_27zxwg_k$(x, y), _RGBA___init__impl_(color_0));
  };
  Bitmap32.prototype.getInt_27zxwg_k$ = function (x, y) {
    return _RgbaArray___get_ints__impl_(this._data_25)[this.index_27zxwg_k$(x, y)];
  };
  Bitmap32.prototype.getRgba_aewswh_k$ = function (x, y) {
    return RgbaArray__get_impl(this._data_25, this.index_27zxwg_k$(x, y));
  };
  Bitmap32.prototype.setRgba_5mmwyp_k$ = function (x, y, v) {
    RgbaArray__set_impl(this._data_25, this.index_27zxwg_k$(x, y), v);
  };
  Bitmap32.prototype._drawUnchecked_1w577z_k$ = function (src, dx, dy, sleft, stop, sright, sbottom, mix_2) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var dstData = dst._data_25;
    var srcData = src._data_25;
    var dstDataPremult = dst._dataPremult;
    var srcDataPremult = src._dataPremult;
    var dstPremultiplied = this._get_premultiplied__0_k$();
    var srcPremultiplied = src._get_premultiplied__0_k$();
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.index_27zxwg_k$(dx, dy + y | 0);
        var srcOffset = src.index_27zxwg_k$(sleft, stop + y | 0);
        if (mix_2) {
          if (dstPremultiplied ? srcPremultiplied : false) {
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < width)
              do {
                var x = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                RgbaPremultipliedArray__set_impl(dstDataPremult, dstOffset + x | 0, mix(RgbaPremultipliedArray__get_impl(dstDataPremult, dstOffset + x | 0), RgbaPremultipliedArray__get_impl(srcDataPremult, srcOffset + x | 0)));
              }
               while (inductionVariable_0 < width);
          } else if (dstPremultiplied ? !srcPremultiplied : false) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                RgbaPremultipliedArray__set_impl(dstDataPremult, dstOffset + x_0 | 0, mix(RgbaPremultipliedArray__get_impl(dstDataPremult, dstOffset + x_0 | 0), _RGBA___get_premultiplied__impl_(RgbaArray__get_impl(srcData, srcOffset + x_0 | 0))));
              }
               while (inductionVariable_1 < width);
          } else if (!dstPremultiplied ? srcPremultiplied : false) {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                RgbaArray__set_impl(dstData, dstOffset + x_1 | 0, _RGBAPremultiplied___get_depremultiplied__impl_(mix(_RGBA___get_premultiplied__impl_(RgbaArray__get_impl(dstData, dstOffset + x_1 | 0)), RgbaPremultipliedArray__get_impl(srcDataPremult, srcOffset + x_1 | 0))));
              }
               while (inductionVariable_2 < width);
          } else if (!dstPremultiplied ? !srcPremultiplied : false) {
            var inductionVariable_3 = 0;
            if (inductionVariable_3 < width)
              do {
                var x_2 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                RgbaArray__set_impl(dstData, dstOffset + x_2 | 0, _RGBAPremultiplied___get_depremultiplied__impl_(mix(_RGBA___get_premultiplied__impl_(RgbaArray__get_impl(dstData, dstOffset + x_2 | 0)), _RGBA___get_premultiplied__impl_(RgbaArray__get_impl(srcData, srcOffset + x_2 | 0)))));
              }
               while (inductionVariable_3 < width);
          }} else {
          if (dstPremultiplied === srcPremultiplied)
            arraycopy_19(srcData, srcOffset, dstData, dstOffset, width);
          else if (dstPremultiplied ? !srcPremultiplied : false) {
            var inductionVariable_4 = 0;
            if (inductionVariable_4 < width)
              do {
                var x_3 = inductionVariable_4;
                inductionVariable_4 = inductionVariable_4 + 1 | 0;
                RgbaPremultipliedArray__set_impl(dstDataPremult, dstOffset + x_3 | 0, _RGBA___get_premultiplied__impl_(RgbaArray__get_impl(srcData, srcOffset + x_3 | 0)));
              }
               while (inductionVariable_4 < width);
          } else if (!dstPremultiplied ? srcPremultiplied : false) {
            var inductionVariable_5 = 0;
            if (inductionVariable_5 < width)
              do {
                var x_4 = inductionVariable_5;
                inductionVariable_5 = inductionVariable_5 + 1 | 0;
                RgbaArray__set_impl(dstData, dstOffset + x_4 | 0, _RGBAPremultiplied___get_depremultiplied__impl_(RgbaPremultipliedArray__get_impl(srcDataPremult, srcOffset + x_4 | 0)));
              }
               while (inductionVariable_5 < width);
          }}
      }
       while (inductionVariable < height);
  };
  Bitmap32.prototype._draw_1w577z_k$ = function (src, dx, dy, sleft, stop, sright, sbottom, mix_2) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }var availableWidth = this._get_width__0_k$() - dx_0 | 0;
    var availableHeight = this._get_height__0_k$() - dy_0 | 0;
    var tmp0_min_0 = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, tmp0_min_0);
    var tmp1_min_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, tmp1_min_0);
    this._drawUnchecked_1w577z_k$(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix_2);
  };
  Bitmap32.prototype._drawPut_c5zn7z_k$ = function (mix_2, other, _dx, _dy) {
    this._draw_1w577z_k$(other, _dx, _dy, 0, 0, other._get_width__0_k$(), other._get_height__0_k$(), mix_2);
  };
  Bitmap32.prototype.fill_59zpz3_k$ = function (color_0, x, y, width, height) {
    var x1 = this.clampX_ha5a7z_k$(x);
    var x2 = this.clampX_ha5a7z_k$((x + width | 0) - 1 | 0);
    var y1 = this.clampY_ha5a7z_k$(y);
    var y2 = this.clampY_ha5a7z_k$((y + height | 0) - 1 | 0);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__fill_impl(this._data_25, color_0, this.index_27zxwg_k$(x1, cy), this.index_27zxwg_k$(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  };
  Bitmap32.prototype.fill$default_g8ip_k$ = function (color_0, x, y, width, height, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      x = 0;
    if (!(($mask0 & 4) === 0))
      y = 0;
    if (!(($mask0 & 8) === 0))
      width = this._get_width__0_k$() - x | 0;
    if (!(($mask0 & 16) === 0))
      height = this._get_height__0_k$() - y | 0;
    return this.fill_59zpz3_k$(color_0, x, y, width, height);
  };
  Bitmap32.prototype._draw_zfokvp_k$ = function (src, dx, dy, mix_2) {
    var b = src._get_bounds__t4v1qq_k$();
    this._draw_1w577z_k$(src._bmp, dx, dy, _RectangleInt___get_left__impl_(b), _RectangleInt___get_top__impl_(b), _RectangleInt___get_right__impl_(b), _RectangleInt___get_bottom__impl_(b), mix_2);
  };
  Bitmap32.prototype.put_bvdyk7_k$ = function (src, dx, dy) {
    return this._drawPut_c5zn7z_k$(false, src, dx, dy);
  };
  Bitmap32.prototype.draw_bvdyk7_k$ = function (src, dx, dy) {
    return this._drawPut_c5zn7z_k$(true, src, dx, dy);
  };
  Bitmap32.prototype.draw_ree07h_k$ = function (src, dx, dy) {
    return this._draw_zfokvp_k$(src, dx, dy, true);
  };
  Bitmap32.prototype.writeChannel_gx7ucp_k$ = function (destination, input, source) {
    return Companion_getInstance_127().copyChannel_gfwdxt_k$(input, source, this, destination);
  };
  Bitmap32.prototype.writeChannel_mzlnw_k$ = function (destination, input) {
    return Companion_getInstance_127().copyChannel_91r7hw_k$(input, this, destination);
  };
  Bitmap32.prototype.extractChannel_j18suz_k$ = function (channel, out) {
    Companion_getInstance_127().copyChannel_okdjg2_k$(this, channel, out);
    return out;
  };
  Bitmap32.prototype.extractChannel$default_hpmngo_k$ = function (channel, out, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      var tmp = this._get_width__0_k$();
      var tmp_0 = this._get_height__0_k$();
      out = Bitmap8_init_$Create$(tmp, tmp_0, null, null, 12, null);
    }return this.extractChannel_j18suz_k$(channel, out);
  };
  Bitmap32.prototype.toString = function () {
    return '' + 'Bitmap32(' + this._get_width__0_k$() + ', ' + this._get_height__0_k$() + ')';
  };
  Bitmap32.prototype.swapRows_rvwcgf_k$ = function (y0, y1) {
    var s0 = this.index_27zxwg_k$(0, y0);
    var s1 = this.index_27zxwg_k$(0, y1);
    arraycopy_19(this._data_25, s0, this._temp_8, 0, this._get_width__0_k$());
    arraycopy_19(this._data_25, s1, this._data_25, s0, this._get_width__0_k$());
    arraycopy_19(this._temp_8, 0, this._data_25, s1, this._get_width__0_k$());
  };
  Bitmap32.prototype.writeDecoded_8gssww_k$ = function (color_0, data, offset_0, littleEndian) {
    decode(color_0, data, offset_0, this._data_25, 0, this._get_area__0_k$(), littleEndian);
    return this;
  };
  Bitmap32.prototype.writeDecoded$default_erzun2_k$ = function (color_0, data, offset_0, littleEndian, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      offset_0 = 0;
    if (!(($mask0 & 8) === 0))
      littleEndian = true;
    return this.writeDecoded_8gssww_k$(color_0, data, offset_0, littleEndian);
  };
  Bitmap32.prototype.clone_0_k$ = function () {
    var tmp = this._get_width__0_k$();
    var tmp_0 = this._get_height__0_k$();
    var tmp0_copyOf_0 = _RgbaArray___get_ints__impl_(this._data_25);
    return new Bitmap32(tmp, tmp_0, _RgbaArray___init__impl_(tmp0_copyOf_0.slice()), this._get_premultiplied__0_k$());
  };
  Bitmap32.prototype.getContext2d_vcj5fe_k$ = function (antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  };
  Bitmap32.prototype.premultipliedIfRequired_0_k$ = function () {
    return this._get_premultiplied__0_k$() ? this : this.copyPremultiplied();
  };
  Bitmap32.prototype.depremultipliedIfRequired_0_k$ = function () {
    return !this._get_premultiplied__0_k$() ? this : this.depremultiplied_0_k$();
  };
  Bitmap32.prototype.copyPremultiplied = function () {
    var tmp0_apply_0 = this.clone_0_k$();
    tmp0_apply_0.premultiplyInplaceIfRequired_sv8swh_k$();
    return tmp0_apply_0;
  };
  Bitmap32.prototype.depremultiplied_0_k$ = function () {
    var tmp0_apply_0 = this.clone_0_k$();
    tmp0_apply_0.depremultiplyInplace_sv8swh_k$();
    return tmp0_apply_0;
  };
  Bitmap32.prototype.premultiplyInplaceIfRequired_sv8swh_k$ = function () {
    if (this._get_premultiplied__0_k$())
      return Unit_getInstance();
    this._set_premultiplied__rpwsgn_k$(true);
    var tmp0_updateColors_0 = this._get_width__0_k$() - 0 | 0;
    var tmp1_updateColors_0 = this._get_height__0_k$() - 0 | 0;
    var inductionVariable = 0;
    var last_1 = 0 + tmp1_updateColors_0 | 0;
    if (inductionVariable < last_1)
      do {
        var y_2_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n_3_3 = this.index_27zxwg_k$(0, 0 + y_2_2 | 0);
        var inductionVariable_0 = 0;
        var last_2 = 0 + tmp0_updateColors_0 | 0;
        if (inductionVariable_0 < last_2)
          do {
            var x_5_5 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2_6_7 = n_3_3;
            n_3_3 = tmp2_6_7 + 1 | 0;
            var tmp0__anonymous__7_6 = tmp2_6_7;
            var tmp2__anonymous__8 = RgbaArray__get_impl(this._data_25, tmp0__anonymous__7_6);
            RgbaArray__set_impl(this._data_25, tmp0__anonymous__7_6, asNonPremultiplied(_RGBA___get_premultiplied__impl_(tmp2__anonymous__8)));
          }
           while (inductionVariable_0 < last_2);
      }
       while (inductionVariable < last_1);
  };
  Bitmap32.prototype.depremultiplyInplace_sv8swh_k$ = function () {
    if (!this._get_premultiplied__0_k$())
      return Unit_getInstance();
    this._set_premultiplied__rpwsgn_k$(false);
    var tmp0_updateColors_0 = this._get_width__0_k$() - 0 | 0;
    var tmp1_updateColors_0 = this._get_height__0_k$() - 0 | 0;
    var inductionVariable = 0;
    var last_1 = 0 + tmp1_updateColors_0 | 0;
    if (inductionVariable < last_1)
      do {
        var y_2_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n_3_3 = this.index_27zxwg_k$(0, 0 + y_2_2 | 0);
        var inductionVariable_0 = 0;
        var last_2 = 0 + tmp0_updateColors_0 | 0;
        if (inductionVariable_0 < last_2)
          do {
            var x_5_5 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2_6_7 = n_3_3;
            n_3_3 = tmp2_6_7 + 1 | 0;
            var tmp0__anonymous__7_6 = tmp2_6_7;
            var tmp2__anonymous__8 = RgbaArray__get_impl(this._data_25, tmp0__anonymous__7_6);
            RgbaArray__set_impl(this._data_25, tmp0__anonymous__7_6, _RGBAPremultiplied___get_depremultiplied__impl_(asPremultiplied(tmp2__anonymous__8)));
          }
           while (inductionVariable_0 < last_2);
      }
       while (inductionVariable < last_1);
  };
  Bitmap32.prototype.iterator_0_k$ = function () {
    return RgbaArray__iterator_impl(this._data_25);
  };
  Bitmap32.prototype.setRowChunk_6ztocq_k$ = function (x, y, data, width, increment_0) {
    if (increment_0 === 1) {
      arraycopy_19(data, 0, this._data_25, this.index_27zxwg_k$(x, y), width);
    } else {
      var m = this.index_27zxwg_k$(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          _RgbaArray___get_ints__impl_(this._data_25)[m] = _RgbaArray___get_ints__impl_(data)[n];
          m = m + increment_0 | 0;
        }
         while (inductionVariable < width);
    }
  };
  Bitmap32.prototype.toBMP32_0_k$ = function () {
    return this;
  };
  Bitmap32.$metadata$ = {
    simpleName: 'Bitmap32',
    kind: 'class',
    interfaces: [Iterable]
  };
  function isFullyTransparent(_this_) {
    var bmp = _this_._bmp;
    var data = _this_._bmp._data_25;
    var width = _this_._get_right__0_k$() - _this_._get_left__0_k$() | 0;
    var inductionVariable = _this_._get_top__0_k$();
    var last_1 = _this_._get_bottom__0_k$();
    if (inductionVariable < last_1)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var index_0 = bmp.index_27zxwg_k$(_this_._get_left__0_k$(), y);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(_RGBA___get_a__impl_(RgbaArray__get_impl(data, index_0 + n | 0)) === 0))
              return false;
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < last_1);
    return true;
  }
  function expandBorder(_this_, area, border) {
    var data = _RgbaArray___get_ints__impl_(_this_._data_25);
    var x0Index = _this_.index_27zxwg_k$(_get_left__1(area), _get_top__0(area));
    var x1Index = _this_.index_27zxwg_k$(_get_right__1(area) - 1 | 0, _get_top__0(area));
    var inductionVariable = 0;
    var last_1 = area._get_height__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x0Color = data[x0Index];
        var x1Color = data[x1Index];
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < border)
          do {
            var m = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            data[(x0Index - m | 0) - 1 | 0] = x0Color;
            data[(x1Index + m | 0) + 1 | 0] = x1Color;
          }
           while (inductionVariable_0 < border);
        x0Index = x0Index + _this_._get_width__0_k$() | 0;
        x1Index = x1Index + _this_._get_width__0_k$() | 0;
      }
       while (inductionVariable < last_1);
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < border)
      do {
        var m_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var x = _get_left__1(area) - border | 0;
        var npixels = area._get_width__0_k$() + imul(border, 2) | 0;
        arraycopy_3(data, _this_.index_27zxwg_k$(x, _get_top__0(area)), data, _this_.index_27zxwg_k$(x, (_get_top__0(area) - m_0 | 0) - 1 | 0), npixels);
        arraycopy_3(data, _this_.index_27zxwg_k$(x, _get_bottom__0(area) - 1 | 0), data, _this_.index_27zxwg_k$(x, _get_bottom__0(area) + m_0 | 0), npixels);
      }
       while (inductionVariable_1 < border);
  }
  function Bitmap8_init_$Init$(width, height, data, palette, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      data = new Int8Array(imul(width, height));
    if (!(($mask0 & 8) === 0))
      palette = Companion_getInstance_135().invoke_spsmd3_k$(256);
    Bitmap8.call($this, width, height, data, palette);
    return $this;
  }
  function Bitmap8_init_$Create$(width, height, data, palette, $mask0, $marker) {
    return Bitmap8_init_$Init$(width, height, data, palette, $mask0, $marker, Object.create(Bitmap8.prototype));
  }
  function Companion_129() {
    Companion_instance_128 = this;
  }
  Companion_129.prototype.copyRect_z7zcaf_k$ = function (src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.copy_ffs0tm_k$(srcX, srcY, dst, dstX, dstY, width, height);
  };
  Companion_129.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_128;
  function Companion_getInstance_128() {
    if (Companion_instance_128 == null)
      new Companion_129();
    return Companion_instance_128;
  }
  function Bitmap8(width, height, data, palette) {
    Companion_getInstance_128();
    BitmapIndexed.call(this, 8, width, height, data, palette);
  }
  Bitmap8.prototype.createWithThisFormat_27zxwg_k$ = function (width, height) {
    return Bitmap8_init_$Create$(width, height, null, this._get_palette__wd8tzq_k$(), 4, null);
  };
  Bitmap8.prototype.setInt_zd700_k$ = function (x, y, color_0) {
    return this.setIntIndex_rvwcgf_k$(this.index_27zxwg_k$(x, y), color_0);
  };
  Bitmap8.prototype.getInt_27zxwg_k$ = function (x, y) {
    return UByteArrayInt__get_impl(this._get_datau__kl5kxp_k$(), this.index_27zxwg_k$(x, y));
  };
  Bitmap8.prototype.getRgba_aewswh_k$ = function (x, y) {
    var tmp = this._get_palette__wd8tzq_k$();
    return RgbaArray__get_impl(tmp, this.getInt_27zxwg_k$(x, y));
  };
  Bitmap8.prototype.getIntIndex_ha5a7z_k$ = function (n) {
    return UByteArrayInt__get_impl(this._get_datau__kl5kxp_k$(), n);
  };
  Bitmap8.prototype.setIntIndex_rvwcgf_k$ = function (n, color_0) {
    return UByteArrayInt__set_impl(this._get_datau__kl5kxp_k$(), n, color_0);
  };
  Bitmap8.prototype.copyUnchecked_ffs0tm_k$ = function (srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return BitmapIndexed.prototype.copyUnchecked_ffs0tm_k$.call(this, srcX, srcY, dst, dstX, dstY, width, height);
    else {
    }
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this._get_data__0_k$();
        var tmp_0 = this.index_27zxwg_k$(srcX, srcY + y | 0);
        arraycopy_2(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE())._get_data__0_k$(), dst.index_27zxwg_k$(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  };
  Bitmap8.prototype.toString = function () {
    return '' + 'Bitmap8(' + this._get_width__0_k$() + ', ' + this._get_height__0_k$() + ', palette=' + _RgbaArray___get_size__impl_(this._get_palette__wd8tzq_k$()) + ')';
  };
  Bitmap8.$metadata$ = {
    simpleName: 'Bitmap8',
    kind: 'class',
    interfaces: []
  };
  var BitmapChannel_RED_instance;
  var BitmapChannel_GREEN_instance;
  var BitmapChannel_BLUE_instance;
  var BitmapChannel_ALPHA_instance;
  function Companion_130() {
    Companion_instance_129 = this;
    this._ALL = values_5();
  }
  Companion_130.prototype.get_ha5a7z_k$ = function (index_0) {
    return this._ALL[index_0];
  };
  Companion_130.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_129;
  function Companion_getInstance_129() {
    if (Companion_instance_129 == null)
      new Companion_130();
    return Companion_instance_129;
  }
  function values_5() {
    return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
  }
  var BitmapChannel_entriesInitialized;
  function BitmapChannel_initEntries() {
    if (BitmapChannel_entriesInitialized)
      return Unit_getInstance();
    BitmapChannel_entriesInitialized = true;
    BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
    BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
    BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
    BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
    Companion_getInstance_129();
  }
  function BitmapChannel(name, ordinal, index_0) {
    Enum.call(this, name, ordinal);
    this._index_16 = index_0;
    this._shift = imul(this._index_16, 8);
    this._setMask = 255 << this._shift;
    this._clearMask = ~this._setMask;
  }
  BitmapChannel.$metadata$ = {
    simpleName: 'BitmapChannel',
    kind: 'class',
    interfaces: []
  };
  function BitmapChannel_RED_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_RED_instance;
  }
  function BitmapChannel_GREEN_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_GREEN_instance;
  }
  function BitmapChannel_BLUE_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_BLUE_instance;
  }
  function BitmapChannel_ALPHA_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_ALPHA_instance;
  }
  function BitmapIndexed(bpp, width, height, data, palette) {
    Bitmap.call(this, width, height, bpp, false, data);
    this._data_26 = data;
    this._palette = palette;
    if (this._data_26.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException_init_$Create$('' + 'Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + this._data_26.length + '), area=' + imul(width, height));
    var tmp = this;
    tmp._temp_9 = new Int8Array(Math.max(width, height));
    this._datau = _UByteArrayInt___init__impl_(this._data_26);
    this._n8_dbpp = 8 / bpp | 0;
    this._n8_dbppLog2 = ilog2_0(this._n8_dbpp);
    this._n8_dbppMask = this._n8_dbpp - 1 | 0;
  }
  BitmapIndexed.prototype._get_data__0_k$ = function () {
    return this._data_26;
  };
  BitmapIndexed.prototype._get_palette__wd8tzq_k$ = function () {
    return this._palette;
  };
  BitmapIndexed.prototype.toString = function () {
    return '' + 'BitmapIndexed(bpp=' + this._get_bpp__0_k$() + ', width=' + this._get_width__0_k$() + ', height=' + this._get_height__0_k$() + ', clut=' + _RgbaArray___get_size__impl_(this._palette) + ')';
  };
  BitmapIndexed.prototype._get_datau__kl5kxp_k$ = function () {
    return this._datau;
  };
  BitmapIndexed.prototype.getInt_27zxwg_k$ = function (x, y) {
    return this.getIntIndex_ha5a7z_k$(this.index_27zxwg_k$(x, y));
  };
  BitmapIndexed.prototype.setInt_zd700_k$ = function (x, y, color_0) {
    return this.setIntIndex_rvwcgf_k$(this.index_27zxwg_k$(x, y), color_0);
  };
  BitmapIndexed.prototype.getIntIndex_ha5a7z_k$ = function (n) {
    var iD = this.index_d_ha5a7z_k$(n);
    var iM = this.index_m_ha5a7z_k$(n);
    return extract(UByteArrayInt__get_impl(this._datau, iD), imul(this._get_bpp__0_k$(), iM), this._get_bpp__0_k$());
  };
  BitmapIndexed.prototype.setIntIndex_rvwcgf_k$ = function (n, color_0) {
    var iD = this.index_d_ha5a7z_k$(n);
    var iM = this.index_m_ha5a7z_k$(n);
    UByteArrayInt__set_impl(this._datau, iD, insert(UByteArrayInt__get_impl(this._datau, iD), color_0, imul(this._get_bpp__0_k$(), iM), this._get_bpp__0_k$()));
  };
  BitmapIndexed.prototype.getRgba_aewswh_k$ = function (x, y) {
    var tmp = this._palette;
    return RgbaArray__get_impl(tmp, this.getInt_27zxwg_k$(x, y));
  };
  BitmapIndexed.prototype.index_d_27zxwg_k$ = function (x, y) {
    return this.index_d_ha5a7z_k$(this.index_27zxwg_k$(x, y));
  };
  BitmapIndexed.prototype.index_d_ha5a7z_k$ = function (n) {
    return n >>> this._n8_dbppLog2;
  };
  BitmapIndexed.prototype.index_m_ha5a7z_k$ = function (n) {
    return n & this._n8_dbppMask;
  };
  BitmapIndexed.prototype.setRow_bbbfxr_k$ = function (y, row) {
    arraycopy_2(row, 0, this._data_26, this.index_27zxwg_k$(0, y), this._get_stride__0_k$());
  };
  BitmapIndexed.prototype.swapRows_rvwcgf_k$ = function (y0, y1) {
    var s0 = this.index_d_27zxwg_k$(0, y0);
    var s1 = this.index_d_27zxwg_k$(0, y1);
    arraycopy_2(this._data_26, s0, this._temp_9, 0, this._get_stride__0_k$());
    arraycopy_2(this._data_26, s1, this._data_26, s0, this._get_stride__0_k$());
    arraycopy_2(this._temp_9, 0, this._data_26, s1, this._get_stride__0_k$());
  };
  BitmapIndexed.prototype.setRowChunk_fu24oi_k$ = function (x, y, data, width, increment_0) {
    if (increment_0 === 1) {
      arraycopy_2(data, 0, this._data_26, this.index_27zxwg_k$(x, y), width / this._n8_dbpp | 0);
    } else {
      var m = this.index_27zxwg_k$(x, y);
      var inductionVariable = 0;
      var last_1 = width / this._n8_dbpp | 0;
      if (inductionVariable < last_1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this._data_26[m] = data[n];
          m = m + increment_0 | 0;
        }
         while (inductionVariable < last_1);
    }
  };
  BitmapIndexed.prototype.toBMP32_0_k$ = function () {
    var tmp = this._get_width__0_k$();
    var tmp_0 = this._get_height__0_k$();
    var tmp0_also_0 = Bitmap32_init_$Create$(tmp, tmp_0, null, this._get_premultiplied__0_k$(), 4, null);
    var out_2 = _RgbaArray___get_ints__impl_(tmp0_also_0._data_25);
    var pal_3 = _RgbaArray___get_ints__impl_(this._palette);
    var inductionVariable = 0;
    var last_1 = this._get_area__0_k$();
    if (inductionVariable < last_1)
      do {
        var n_5 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_2[n_5] = pal_3[this.getIntIndex_ha5a7z_k$(n_5)];
      }
       while (inductionVariable < last_1);
    return tmp0_also_0;
  };
  BitmapIndexed.$metadata$ = {
    simpleName: 'BitmapIndexed',
    kind: 'class',
    interfaces: []
  };
  function BitmapSlice_init_$Init$(bmp, bounds_0, name, rotated, virtFrame, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      name = null;
    if (!(($mask0 & 8) === 0))
      rotated = false;
    if (!(($mask0 & 16) === 0))
      virtFrame = null;
    BitmapSlice.call($this, bmp, bounds_0, name, rotated, virtFrame);
    return $this;
  }
  function BitmapSlice_init_$Create$(bmp, bounds_0, name, rotated, virtFrame, $mask0, $marker) {
    return BitmapSlice_init_$Init$(bmp, bounds_0, name, rotated, virtFrame, $mask0, $marker, Object.create(BitmapSlice.prototype));
  }
  function BitmapSlice(bmp, bounds_0, name, rotated, virtFrame) {
    BmpSlice.call(this, bmp, bounds_0, name, rotated, virtFrame);
    this._bmp = bmp;
    var tmp = this;
    tmp._$$delegate_0_16 = Mixin_init_$Create$(null, 1, null);
  }
  BitmapSlice.prototype._get_bmp__0_k$ = function () {
    return this._bmp;
  };
  BitmapSlice.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_16._set_extra__n1onou_k$(_set___);
  };
  BitmapSlice.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_16._get_extra__0_k$();
  };
  BitmapSlice.prototype.extract_0_k$ = function () {
    return extract_1(this._bmp, _RectangleInt___get_x__impl_(this._get_bounds__t4v1qq_k$()), _RectangleInt___get_y__impl_(this._get_bounds__t4v1qq_k$()), _RectangleInt___get_width__impl_(this._get_bounds__t4v1qq_k$()), _RectangleInt___get_height__impl_(this._get_bounds__t4v1qq_k$()));
  };
  BitmapSlice.prototype.sliceWithBounds_w0abts_k$ = function (left, top, right, bottom, name) {
    var tmp = _RectangleInt___get_left__impl_(this._get_bounds__t4v1qq_k$());
    var tmp_0 = _RectangleInt___get_top__impl_(this._get_bounds__t4v1qq_k$());
    var tmp_1 = _RectangleInt___get_right__impl_(this._get_bounds__t4v1qq_k$());
    var tmp_2 = _RectangleInt___get_bottom__impl_(this._get_bounds__t4v1qq_k$());
    var tmp_3 = createRectangleInt$default(tmp, tmp_0, tmp_1, tmp_2, left, top, right, bottom, false, 256, null);
    return BitmapSlice_init_$Create$(this._bmp, tmp_3, name, false, null, 24, null);
  };
  BitmapSlice.prototype.sliceWithSize_w0abts_k$ = function (x, y, width, height, name) {
    return this.sliceWithBounds_w0abts_k$(x, y, x + width | 0, y + height | 0, name);
  };
  BitmapSlice.prototype.slice_8pfdf3_k$ = function (rect_3, name) {
    return this.sliceWithBounds_w0abts_k$(_RectangleInt___get_left__impl_(rect_3), _RectangleInt___get_top__impl_(rect_3), _RectangleInt___get_right__impl_(rect_3), _RectangleInt___get_bottom__impl_(rect_3), name);
  };
  BitmapSlice.prototype.toString = function () {
    return '' + 'BitmapSlice(' + this._get_name__0_k$() + ':' + new SizeInt(Companion_getInstance_39().invoke_aaxa64_k$(_RectangleInt___get_width__impl_(this._get_bounds__t4v1qq_k$()), _RectangleInt___get_height__impl_(this._get_bounds__t4v1qq_k$()))) + ')';
  };
  BitmapSlice.$metadata$ = {
    simpleName: 'BitmapSlice',
    kind: 'class',
    interfaces: [Extra]
  };
  function slice(_this_, bounds_0, name) {
    return BitmapSlice_init_$Create$(_this_, bounds_0, name, false, null, 24, null);
  }
  function slice$default(_this_, bounds_0, name, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      bounds_0 = Companion_getInstance_36().invoke_ihmn6a_k$(0, 0, _this_._width_2, _this_._height_3);
    if (!(($mask0 & 2) === 0))
      name = null;
    return slice(_this_, bounds_0, name);
  }
  function BmpSlice(bmpBase, bounds_0, name, rotated, virtFrame) {
    this._bmpBase = bmpBase;
    this._bounds_0 = bounds_0;
    this._name_12 = name;
    this._rotated = rotated;
    this._virtFrame = virtFrame;
    this._bmp_0 = this._bmpBase;
    this._bmpWidth = this._bmpBase._width_2;
    this._bmpHeight = this._bmpBase._width_2;
    this._tl = Point_init_$Create$(this._get_left__0_k$() / this._bmpBase._width_2, this._get_top__0_k$() / this._bmpBase._height_3);
    this._br = Point_init_$Create$(this._get_right__0_k$() / this._bmpBase._width_2, this._get_bottom__0_k$() / this._bmpBase._height_3);
    this._tr = new Point(this._br._x_1, this._tl._y_1);
    this._bl = new Point(this._tl._x_1, this._br._y_1);
    var tmp = this;
    var tmp0_arrayOf_0 = [this._tl, this._tr, this._br, this._bl];
    tmp._points_5 = tmp0_arrayOf_0;
    this._offset_25 = this._rotated ? 1 : 0;
    this._p0 = getCyclic_0(this._points_5, this._offset_25 + 0 | 0);
    this._p1_0 = getCyclic_0(this._points_5, this._offset_25 + 1 | 0);
    this._p2_0 = getCyclic_0(this._points_5, this._offset_25 + 2 | 0);
    this._p3 = getCyclic_0(this._points_5, this._offset_25 + 3 | 0);
    var tmp_0 = this;
    var tmp_1 = this._virtFrame;
    tmp_0._trimmed = !((tmp_1 == null ? null : new RectangleInt(tmp_1)) == null);
    var tmp_2 = this;
    var tmp0_safe_receiver = this._virtFrame;
    var tmp_3;
    var tmp_4 = tmp0_safe_receiver;
    if ((tmp_4 == null ? null : new RectangleInt(tmp_4)) == null) {
      tmp_3 = null;
    } else {
      {
        tmp_3 = _RectangleInt___get_x__impl_(tmp0_safe_receiver);
      }
    }
    var tmp1_elvis_lhs = tmp_3;
    tmp_2._frameOffsetX = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_5 = this;
    var tmp0_safe_receiver_0 = this._virtFrame;
    var tmp_6;
    var tmp_7 = tmp0_safe_receiver_0;
    if ((tmp_7 == null ? null : new RectangleInt(tmp_7)) == null) {
      tmp_6 = null;
    } else {
      {
        tmp_6 = _RectangleInt___get_y__impl_(tmp0_safe_receiver_0);
      }
    }
    var tmp1_elvis_lhs_0 = tmp_6;
    tmp_5._frameOffsetY = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
    var tmp_8 = this;
    var tmp0_safe_receiver_1 = this._virtFrame;
    var tmp_9;
    var tmp_10 = tmp0_safe_receiver_1;
    if ((tmp_10 == null ? null : new RectangleInt(tmp_10)) == null) {
      tmp_9 = null;
    } else {
      {
        tmp_9 = _RectangleInt___get_width__impl_(tmp0_safe_receiver_1);
      }
    }
    var tmp1_elvis_lhs_1 = tmp_9;
    tmp_8._frameWidth = tmp1_elvis_lhs_1 == null ? _RectangleInt___get_width__impl_(this._bounds_0) : tmp1_elvis_lhs_1;
    var tmp_11 = this;
    var tmp0_safe_receiver_2 = this._virtFrame;
    var tmp_12;
    var tmp_13 = tmp0_safe_receiver_2;
    if ((tmp_13 == null ? null : new RectangleInt(tmp_13)) == null) {
      tmp_12 = null;
    } else {
      {
        tmp_12 = _RectangleInt___get_height__impl_(tmp0_safe_receiver_2);
      }
    }
    var tmp1_elvis_lhs_2 = tmp_12;
    tmp_11._frameHeight = tmp1_elvis_lhs_2 == null ? _RectangleInt___get_height__impl_(this._bounds_0) : tmp1_elvis_lhs_2;
    this._parent_4 = null;
    this._tl_x = this._p0._x_1;
    this._tl_y = this._p0._y_1;
    this._tr_x = this._p1_0._x_1;
    this._tr_y = this._p1_0._y_1;
    this._br_x = this._p2_0._x_1;
    this._br_y = this._p2_0._y_1;
    this._bl_x = this._p3._x_1;
    this._bl_y = this._p3._y_1;
    this._rotatedAngle = 0;
  }
  BmpSlice.prototype._get_bmpBase__0_k$ = function () {
    return this._bmpBase;
  };
  BmpSlice.prototype._get_bounds__t4v1qq_k$ = function () {
    return this._bounds_0;
  };
  BmpSlice.prototype._get_name__0_k$ = function () {
    return this._name_12;
  };
  BmpSlice.prototype.getOrNull_0_k$ = function () {
    return this;
  };
  BmpSlice.prototype._get_bmp__0_k$ = function () {
    return this._bmp_0;
  };
  BmpSlice.prototype._get_left__0_k$ = function () {
    return _RectangleInt___get_left__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_top__0_k$ = function () {
    return _RectangleInt___get_top__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_width__0_k$ = function () {
    return _RectangleInt___get_width__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_height__0_k$ = function () {
    return _RectangleInt___get_height__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_area__0_k$ = function () {
    return imul(this._get_width__0_k$(), this._get_height__0_k$());
  };
  BmpSlice.prototype._get_right__0_k$ = function () {
    return _RectangleInt___get_right__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_bottom__0_k$ = function () {
    return _RectangleInt___get_bottom__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_tl_x__0_k$ = function () {
    return this._tl_x;
  };
  BmpSlice.prototype._get_tl_y__0_k$ = function () {
    return this._tl_y;
  };
  BmpSlice.prototype._get_tr_x__0_k$ = function () {
    return this._tr_x;
  };
  BmpSlice.prototype._get_tr_y__0_k$ = function () {
    return this._tr_y;
  };
  BmpSlice.prototype._get_br_x__0_k$ = function () {
    return this._br_x;
  };
  BmpSlice.prototype._get_br_y__0_k$ = function () {
    return this._br_y;
  };
  BmpSlice.prototype._get_bl_x__0_k$ = function () {
    return this._bl_x;
  };
  BmpSlice.prototype._get_bl_y__0_k$ = function () {
    return this._bl_y;
  };
  BmpSlice.prototype.readPixels_y0il1s_k$ = function (x, y, width, height, out, offset_0) {
    var tmp0_check_0 = 0 <= x ? x < this._get_width__0_k$() : false;
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var tmp1_check_0 = 0 <= y ? y < this._get_height__0_k$() : false;
    if (!tmp1_check_0) {
      var message_2_1_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
    }var containsUpper = this._get_width__0_k$();
    var containsArg = x + width | 0;
    var tmp2_check_0 = 0 <= containsArg ? containsArg <= containsUpper : false;
    if (!tmp2_check_0) {
      var message_2_1_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_1));
    }var containsUpper_0 = this._get_height__0_k$();
    var containsArg_0 = y + height | 0;
    var tmp3_check_0 = 0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false;
    if (!tmp3_check_0) {
      var message_2_1_2 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_2));
    }var tmp4_check_0 = _RgbaArray___get_size__impl_(out) >= (offset_0 + imul(width, height) | 0);
    if (!tmp4_check_0) {
      var message_2_1_3 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_3));
    }this._bmpBase.readPixelsUnsafe_c3kirt_k$(this._get_left__0_k$() + x | 0, this._get_top__0_k$() + y | 0, width, height, out, offset_0);
    return out;
  };
  BmpSlice.prototype.readPixels$default_jhni3z_k$ = function (x, y, width, height, out, offset_0, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      out = Companion_getInstance_135().invoke_spsmd3_k$(imul(width, height));
    if (!(($mask0 & 32) === 0))
      offset_0 = 0;
    return this.readPixels_y0il1s_k$(x, y, width, height, out, offset_0);
  };
  BmpSlice.prototype.sliceWithBounds_w0abts_k$ = function (left, top, right, bottom, name) {
    var tmp = this._get_bmp__0_k$();
    var tmp_0 = _RectangleInt___get_left__impl_(this._bounds_0);
    var tmp_1 = _RectangleInt___get_top__impl_(this._bounds_0);
    var tmp_2 = _RectangleInt___get_right__impl_(this._bounds_0);
    var tmp_3 = _RectangleInt___get_bottom__impl_(this._bounds_0);
    var tmp_4 = createRectangleInt$default(tmp_0, tmp_1, tmp_2, tmp_3, left, top, right, bottom, false, 256, null);
    return BitmapSlice_init_$Create$(tmp, tmp_4, name, false, null, 24, null);
  };
  BmpSlice.prototype.sliceWithBounds$default_cox0wy_k$ = function (left, top, right, bottom, name, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      name = null;
    return $handler == null ? this.sliceWithBounds_w0abts_k$(left, top, right, bottom, name) : $handler(left, top, right, bottom, name);
  };
  BmpSlice.prototype.sliceWithSize_w0abts_k$ = function (x, y, width, height, name) {
    return this.sliceWithBounds_w0abts_k$(x, y, x + width | 0, y + height | 0, name);
  };
  BmpSlice.prototype.sliceWithSize$default_cox0wy_k$ = function (x, y, width, height, name, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      name = null;
    return $handler == null ? this.sliceWithSize_w0abts_k$(x, y, width, height, name) : $handler(x, y, width, height, name);
  };
  BmpSlice.prototype.slice_8pfdf3_k$ = function (rect_3, name) {
    return this.sliceWithBounds_w0abts_k$(_RectangleInt___get_left__impl_(rect_3), _RectangleInt___get_top__impl_(rect_3), _RectangleInt___get_right__impl_(rect_3), _RectangleInt___get_bottom__impl_(rect_3), name);
  };
  BmpSlice.prototype.slice$default_7tbffz_k$ = function (rect_3, name, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      name = null;
    return $handler == null ? this.slice_8pfdf3_k$(rect_3, name) : $handler(new RectangleInt(rect_3), name);
  };
  BmpSlice.$metadata$ = {
    simpleName: 'BmpSlice',
    kind: 'class',
    interfaces: [Extra, BmpCoords, Resourceable]
  };
  function createRectangleInt(bleft, btop, bright, bbottom, left, top, right, bottom, allowInvalidBounds) {
    return Companion_getInstance_36().fromBounds_ihmn6a_k$(clamp_2(bleft + left | 0, bleft, bright), clamp_2(btop + top | 0, btop, bbottom), clamp_2(bleft + right | 0, allowInvalidBounds ? bleft : bleft + left | 0, bright), clamp_2(btop + bottom | 0, allowInvalidBounds ? btop : btop + top | 0, bbottom));
  }
  function createRectangleInt$default(bleft, btop, bright, bbottom, left, top, right, bottom, allowInvalidBounds, $mask0, $handler) {
    if (!(($mask0 & 256) === 0))
      allowInvalidBounds = false;
    return createRectangleInt(bleft, btop, bright, bbottom, left, top, right, bottom, allowInvalidBounds);
  }
  function BmpCoords() {
  }
  BmpCoords.$metadata$ = {
    simpleName: 'BmpCoords',
    kind: 'interface',
    interfaces: []
  };
  function extract_2(_this_) {
    return extract_1(_this_._bmpBase, _this_._get_left__0_k$(), _this_._get_top__0_k$(), _this_._get_width__0_k$(), _this_._get_height__0_k$());
  }
  function sliceWithSize_1(_this_, x, y, width, height, name) {
    return sliceWithBounds_1(_this_, x, y, x + width | 0, y + height | 0, name);
  }
  function sliceWithSize$default_0(_this_, x, y, width, height, name, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      name = null;
    return sliceWithSize_1(_this_, x, y, width, height, name);
  }
  function sliceWithBounds_1(_this_, left, top, right, bottom, name) {
    return slice(_this_, createRectangleInt$default(0, 0, _this_._width_2, _this_._height_3, left, top, right, bottom, false, 256, null), name);
  }
  var Bitmaps_transparent;
  var Bitmaps_white;
  function Bitmaps() {
    Bitmaps_instance = this;
  }
  Bitmaps.$metadata$ = {
    simpleName: 'Bitmaps',
    kind: 'object',
    interfaces: []
  };
  var Bitmaps_instance;
  function Bitmaps_getInstance() {
    if (Bitmaps_instance == null)
      new Bitmaps();
    return Bitmaps_instance;
  }
  function Bitmaps_transparent$init$() {
    var tmp = Bitmap32_init_$Create$(1, 1, null, false, 12, null);
    return slice$default(tmp, null, 'transparent', 1, null);
  }
  function Bitmaps_white$init$() {
    var tmp1_invoke_0 = Companion_getInstance_135();
    var tmp0_apply_0 = _RgbaArray___init__impl_(new Int32Array(1));
    var inductionVariable = 0;
    if (inductionVariable < 1)
      do {
        var n_3_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__set_impl(tmp0_apply_0, n_3_3, Colors_getInstance()._WHITE_0);
      }
       while (inductionVariable < 1);
    var tmp = Bitmap32_init_$Create$(1, 1, tmp0_apply_0, false, 8, null);
    return slice$default(tmp, null, 'white', 1, null);
  }
  function DistanceBitmap_init_$Init$(width, height, d, px, py, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      d = new Float32Array(imul(width, height));
    if (!(($mask0 & 8) === 0))
      px = new Int32Array(imul(width, height));
    if (!(($mask0 & 16) === 0))
      py = new Int32Array(imul(width, height));
    DistanceBitmap.call($this, width, height, d, px, py);
    return $this;
  }
  function DistanceBitmap_init_$Create$(width, height, d, px, py, $mask0, $marker) {
    return DistanceBitmap_init_$Init$(width, height, d, px, py, $mask0, $marker, Object.create(DistanceBitmap.prototype));
  }
  function Companion_131() {
    Companion_instance_130 = this;
    this._d1 = 1.0;
    this._d2 = 1.4142135;
  }
  Companion_131.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_130;
  function Companion_getInstance_130() {
    if (Companion_instance_130 == null)
      new Companion_131();
    return Companion_instance_130;
  }
  function setFromBitmap$getAlpha(_this_, x, y, min_0) {
    return _this_.inBounds_27zxwg_k$(x, y) ? _RGBA___get_a__impl_(_this_.getRgba_aewswh_k$(x, y)) >= min_0 : false;
  }
  function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
    if (this$0.getDist_27zxwg_k$(x + dx | 0, y + dy | 0) + d < this$0.getDist_27zxwg_k$(x, y)) {
      this$0.setPosXYRel_jthg1_k$(x, y, x + dx | 0, y + dy | 0);
      var tmp0_hypot_0 = x - this$0.getPosX_27zxwg_k$(x, y) | 0;
      var tmp1_hypot_0 = y - this$0.getPosY_27zxwg_k$(x, y) | 0;
      this$0.setDist_5fhccj_k$(x, y, Math.hypot(tmp0_hypot_0, tmp1_hypot_0));
    }}
  function DistanceBitmap(width, height, d, px, py) {
    Companion_getInstance_130();
    this._width_3 = width;
    this._height_4 = height;
    this._d_2 = d;
    this._px = px;
    this._py = py;
    this._area_0 = imul(this._width_3, this._height_4);
    var tmp0_assert_0 = this._d_2.length >= this._area_0;
    if (!tmp0_assert_0)
      throw AssertionError_init_$Create$();
    var tmp1_assert_0 = this._px.length >= this._area_0;
    if (!tmp1_assert_0)
      throw AssertionError_init_$Create$();
    var tmp2_assert_0 = this._py.length >= this._area_0;
    if (!tmp2_assert_0)
      throw AssertionError_init_$Create$();
  }
  DistanceBitmap.prototype.inBoundsX_ha5a7z_k$ = function (x) {
    return x >= 0 ? x < this._width_3 : false;
  };
  DistanceBitmap.prototype.inBoundsY_ha5a7z_k$ = function (y) {
    return y >= 0 ? y < this._height_4 : false;
  };
  DistanceBitmap.prototype.inBounds_27zxwg_k$ = function (x, y) {
    return this.inBoundsX_ha5a7z_k$(x) ? this.inBoundsY_ha5a7z_k$(y) : false;
  };
  DistanceBitmap.prototype.index_27zxwg_k$ = function (x, y) {
    return imul(y, this._width_3) + x | 0;
  };
  DistanceBitmap.prototype.getDist_27zxwg_k$ = function (x, y) {
    var tmp;
    if (this.inBounds_27zxwg_k$(x, y)) {
      tmp = this._d_2[this.index_27zxwg_k$(x, y)];
    } else {
      FloatCompanionObject_getInstance();
      tmp = Infinity;
    }
    return tmp;
  };
  DistanceBitmap.prototype.getPosX_27zxwg_k$ = function (x, y) {
    return this.inBounds_27zxwg_k$(x, y) ? this._px[this.index_27zxwg_k$(x, y)] : -1;
  };
  DistanceBitmap.prototype.getPosY_27zxwg_k$ = function (x, y) {
    return this.inBounds_27zxwg_k$(x, y) ? this._py[this.index_27zxwg_k$(x, y)] : -1;
  };
  DistanceBitmap.prototype.setDist_5fhccj_k$ = function (x, y, d) {
    if (!this.inBounds_27zxwg_k$(x, y))
      return Unit_getInstance();
    this._d_2[this.index_27zxwg_k$(x, y)] = d;
  };
  DistanceBitmap.prototype.setPosXY_jthg1_k$ = function (x, y, px, py) {
    if (!this.inBounds_27zxwg_k$(x, y))
      return Unit_getInstance();
    var index_0 = this.index_27zxwg_k$(x, y);
    this._px[index_0] = px;
    this._py[index_0] = py;
  };
  DistanceBitmap.prototype.setPosXYRel_jthg1_k$ = function (x, y, px, py) {
    return this.setPosXY_jthg1_k$(x, y, this.getPosX_27zxwg_k$(px, py), this.getPosY_27zxwg_k$(px, py));
  };
  DistanceBitmap.prototype.setFromBitmap_fq7mh5_k$ = function (bmp, thresold) {
    var tmp0_assert_0 = this._width_3 === bmp._width_2;
    if (!tmp0_assert_0)
      throw AssertionError_init_$Create$();
    var tmp1_assert_0 = this._height_4 === bmp._height_3;
    if (!tmp1_assert_0)
      throw AssertionError_init_$Create$();
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last_1 = this._height_4;
    if (inductionVariable < last_1)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_2 = this._width_3;
        if (inductionVariable_0 < last_2)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            FloatCompanionObject_getInstance();
            this.setDist_5fhccj_k$(x, y, Infinity);
            this.setPosXY_jthg1_k$(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_2);
      }
       while (inductionVariable < last_1);
    var inductionVariable_1 = 0;
    var last_3 = this._height_4;
    if (inductionVariable_1 < last_3)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_4 = this._width_3;
        if (inductionVariable_2 < last_4)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (((!(left === cur) ? true : !(right === cur)) ? true : !(up === cur)) ? true : !(down === cur)) {
              this.setDist_5fhccj_k$(x_0, y_0, 0.0);
              this.setPosXY_jthg1_k$(x_0, y_0, x_0, y_0);
            }}
           while (inductionVariable_2 < last_4);
      }
       while (inductionVariable_1 < last_3);
    var inductionVariable_3 = 0;
    var last_5 = this._height_4;
    if (inductionVariable_3 < last_5)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_6 = this._width_3;
        if (inductionVariable_4 < last_6)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            Companion_getInstance_130();
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            Companion_getInstance_130();
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            Companion_getInstance_130();
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            Companion_getInstance_130();
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_6);
      }
       while (inductionVariable_3 < last_5);
    var inductionVariable_5 = this._height_4 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this._width_3 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            Companion_getInstance_130();
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            Companion_getInstance_130();
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            Companion_getInstance_130();
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            Companion_getInstance_130();
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this._height_4 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this._width_3 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.setDist_5fhccj_k$(x_3, y_3, -this.getDist_27zxwg_k$(x_3, y_3));
            }}
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  };
  DistanceBitmap.$metadata$ = {
    simpleName: 'DistanceBitmap',
    kind: 'class',
    interfaces: []
  };
  function distanceMap(_this_, out, thresold) {
    out.setFromBitmap_fq7mh5_k$(_this_, thresold);
    return out;
  }
  function distanceMap$default(_this_, out, thresold, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      out = DistanceBitmap_init_$Create$(_this_._width_2, _this_._height_3, null, null, null, 28, null);
    }if (!(($mask0 & 2) === 0))
      thresold = 0.5;
    return distanceMap(_this_, out, thresold);
  }
  function FloatBitmap32() {
  }
  FloatBitmap32.$metadata$ = {
    simpleName: 'FloatBitmap32',
    kind: 'class',
    interfaces: []
  };
  function NativeImage(width, height, data, premultiplied) {
    Bitmap.call(this, width, height, 32, premultiplied, null);
    this._data_28 = data;
    this._name_13 = 'NativeImage';
  }
  NativeImage.prototype._get_forcedTexId__0_k$ = function () {
    return -1;
  };
  NativeImage.prototype._get_forcedTexTarget__0_k$ = function () {
    return -1;
  };
  NativeImage.prototype._get_name__0_k$ = function () {
    return this._name_13;
  };
  NativeImage.prototype.toBMP32_0_k$ = function () {
    var tmp0_also_0 = Bitmap32_init_$Create$_0(this._get_width__0_k$(), this._get_height__0_k$(), Colors_getInstance()._TRANSPARENT_BLACK, this._get_premultiplied__0_k$());
    this.readPixelsUnsafe_c3kirt_k$(0, 0, this._get_width__0_k$(), this._get_height__0_k$(), tmp0_also_0._data_25, 0);
    return tmp0_also_0;
  };
  NativeImage.prototype.setRgba_5mmwyp_k$ = function (x, y, v) {
    RgbaArray__set_impl(this._get_tempRgba__wd8tzq_k$(), 0, v);
    this.writePixelsUnsafe_c3kirt_k$(x, y, 1, 1, this._get_tempRgba__wd8tzq_k$(), 0);
  };
  NativeImage.prototype.getRgba_aewswh_k$ = function (x, y) {
    this.readPixelsUnsafe_c3kirt_k$(x, y, 1, 1, this._get_tempRgba__wd8tzq_k$(), 0);
    return RgbaArray__get_impl(this._get_tempRgba__wd8tzq_k$(), 0);
  };
  NativeImage.prototype.setInt_zd700_k$ = function (x, y, color_0) {
    return this.setRgba_5mmwyp_k$(x, y, _RGBA___init__impl_(color_0));
  };
  NativeImage.prototype.getInt_27zxwg_k$ = function (x, y) {
    return _RGBA___get_value__impl_(this.getRgba_aewswh_k$(x, y));
  };
  NativeImage.prototype.swapRows_rvwcgf_k$ = function (y0, y1) {
    this.readPixelsUnsafe_c3kirt_k$(0, y0, this._get_width__0_k$(), 1, this._get_tempRgba__wd8tzq_k$(), 0);
    this.readPixelsUnsafe_c3kirt_k$(0, y1, this._get_width__0_k$(), 1, this._get_tempRgba__wd8tzq_k$(), this._get_width__0_k$());
    this.writePixelsUnsafe_c3kirt_k$(0, y1, this._get_width__0_k$(), 1, this._get_tempRgba__wd8tzq_k$(), 0);
    this.writePixelsUnsafe_c3kirt_k$(0, y0, this._get_width__0_k$(), 1, this._get_tempRgba__wd8tzq_k$(), this._get_width__0_k$());
  };
  NativeImage.prototype.createWithThisFormat_27zxwg_k$ = function (width, height) {
    return NativeImage$default(width, height, null, 4, null);
  };
  NativeImage.prototype.toString = function () {
    return '' + this._get_name__0_k$() + '(' + this._get_width__0_k$() + ', ' + this._get_height__0_k$() + ')';
  };
  NativeImage.$metadata$ = {
    simpleName: 'NativeImage',
    kind: 'class',
    interfaces: []
  };
  function NativeImage_0(width, height, premultiplied) {
    return nativeImageFormatProvider.create_y42205_k$(width, height, premultiplied);
  }
  function NativeImage$default(width, height, premultiplied, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      premultiplied = null;
    return NativeImage_0(width, height, premultiplied);
  }
  function ensureNative(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof NativeImage) {
      tmp = _this_;
    } else {
      {
        tmp = nativeImageFormatProvider.copy_nc8knv_k$(_this_);
      }
    }
    return tmp;
  }
  function NativeImageOrBitmap32(width, height, native, premultiplied) {
    var tmp;
    if (native) {
      tmp = NativeImage_0(width, height, premultiplied);
    } else {
      var tmp0_elvis_lhs = premultiplied;
      tmp = Bitmap32_init_$Create$(width, height, null, tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs, 4, null);
    }
    return tmp;
  }
  function NativeImageOrBitmap32$default(width, height, native, premultiplied, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      native = true;
    if (!(($mask0 & 8) === 0))
      premultiplied = null;
    return NativeImageOrBitmap32(width, height, native, premultiplied);
  }
  function NinePatchBmpSlice_init_$Init$(content, info, bmpSlice, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      bmpSlice = content;
    NinePatchBmpSlice.call($this, content, info, bmpSlice);
    return $this;
  }
  function NinePatchBmpSlice_init_$Create$(content, info, bmpSlice, $mask0, $marker) {
    return NinePatchBmpSlice_init_$Init$(content, info, bmpSlice, $mask0, $marker, Object.create(NinePatchBmpSlice.prototype));
  }
  function Companion_132() {
    Companion_instance_131 = this;
  }
  Companion_132.prototype.createSimple_xwrnax_k$ = function (bmp, left, top, right, bottom) {
    var tmp = NinePatchInfo_init_$Create$(bmp._get_width__0_k$(), bmp._get_height__0_k$(), left, top, right, bottom, bmp);
    return NinePatchBmpSlice_init_$Create$(bmp, tmp, null, 4, null);
  };
  Companion_132.prototype.invoke_nc8knv_k$ = function (bmp) {
    return this.invoke_uoiv7r_k$(slice$default(bmp, null, null, 3, null));
  };
  Companion_132.prototype.invoke_uoiv7r_k$ = function (bmpSlice) {
    var tmp = bmpSlice._get_width__0_k$() - 1 | 0;
    var tmp_0 = bmpSlice._get_height__0_k$() - 1 | 0;
    var content = bmpSlice.sliceWithBounds$default_cox0wy_k$(1, 1, tmp, tmp_0, null, 16, null);
    var tmp_1 = bmpSlice._get_width__0_k$();
    var topPixels_2 = bmpSlice.readPixels$default_jhni3z_k$(0, 0, tmp_1, 1, null, 0, 48, null);
    var tmp_2 = bmpSlice._get_height__0_k$();
    var leftPixels_3 = bmpSlice.readPixels$default_jhni3z_k$(0, 0, 1, tmp_2, null, 0, 48, null);
    var tmp2_computeRle_0_4 = until(1, bmpSlice._get_width__0_k$() - 1 | 0);
    var first_1_5 = true;
    var pos_2_6 = 0;
    var startpos_3_7 = 0;
    var lastRes_4_8 = null;
    var out_5_9 = FastArrayList_init_$Create$();
    var inductionVariable = tmp2_computeRle_0_4._get_first__0_k$();
    var last_1 = tmp2_computeRle_0_4._get_last__0_k$();
    if (inductionVariable <= last_1)
      do {
        var it_7_11 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current_8_12 = !(_RGBA___get_a__impl_(RgbaArray__get_impl(topPixels_2, it_7_11)) === 0);
        if (!first_1_5) {
          var tmp_3;
          if (lastRes_4_8 == null) {
            throwUninitializedPropertyAccessException('lastRes');
          } else {
            tmp_3 = lastRes_4_8;
          }
          if (!(current_8_12 === tmp_3)) {
            var tmp_4;
            if (lastRes_4_8 == null) {
              throwUninitializedPropertyAccessException('lastRes');
            } else {
              tmp_4 = lastRes_4_8;
            }
            var tmp0_plusAssign_0_13 = to(tmp_4, until(startpos_3_7, pos_2_6));
            out_5_9.add_2bq_k$(tmp0_plusAssign_0_13);
            Unit_getInstance();
            startpos_3_7 = pos_2_6;
          } else {
          }
        }lastRes_4_8 = current_8_12;
        first_1_5 = false;
        var tmp1_9_14 = pos_2_6;
        pos_2_6 = tmp1_9_14 + 1 | 0;
        Unit_getInstance();
      }
       while (!(it_7_11 === last_1));
    if (!(startpos_3_7 === pos_2_6)) {
      var tmp_5;
      if (lastRes_4_8 == null) {
        throwUninitializedPropertyAccessException('lastRes');
      } else {
        tmp_5 = lastRes_4_8;
      }
      var tmp1_plusAssign_0_15 = to(tmp_5, until(startpos_3_7, pos_2_6));
      out_5_9.add_2bq_k$(tmp1_plusAssign_0_15);
      Unit_getInstance();
    }var tmp5_computeRle_0_16 = until(1, bmpSlice._get_height__0_k$() - 1 | 0);
    var first_1_17 = true;
    var pos_2_18 = 0;
    var startpos_3_19 = 0;
    var lastRes_4_20 = null;
    var out_5_21 = FastArrayList_init_$Create$();
    var inductionVariable_0 = tmp5_computeRle_0_16._get_first__0_k$();
    var last_2 = tmp5_computeRle_0_16._get_last__0_k$();
    if (inductionVariable_0 <= last_2)
      do {
        var it_7_23 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var current_8_24 = !(_RGBA___get_a__impl_(RgbaArray__get_impl(leftPixels_3, it_7_23)) === 0);
        if (!first_1_17) {
          var tmp_6;
          if (lastRes_4_20 == null) {
            throwUninitializedPropertyAccessException('lastRes');
          } else {
            tmp_6 = lastRes_4_20;
          }
          if (!(current_8_24 === tmp_6)) {
            var tmp_7;
            if (lastRes_4_20 == null) {
              throwUninitializedPropertyAccessException('lastRes');
            } else {
              tmp_7 = lastRes_4_20;
            }
            var tmp3_plusAssign_0_25 = to(tmp_7, until(startpos_3_19, pos_2_18));
            out_5_21.add_2bq_k$(tmp3_plusAssign_0_25);
            Unit_getInstance();
            startpos_3_19 = pos_2_18;
          } else {
          }
        }lastRes_4_20 = current_8_24;
        first_1_17 = false;
        var tmp1_9_26 = pos_2_18;
        pos_2_18 = tmp1_9_26 + 1 | 0;
        Unit_getInstance();
      }
       while (!(it_7_23 === last_2));
    if (!(startpos_3_19 === pos_2_18)) {
      var tmp_8;
      if (lastRes_4_20 == null) {
        throwUninitializedPropertyAccessException('lastRes');
      } else {
        tmp_8 = lastRes_4_20;
      }
      var tmp4_plusAssign_0_27 = to(tmp_8, until(startpos_3_19, pos_2_18));
      out_5_21.add_2bq_k$(tmp4_plusAssign_0_27);
      Unit_getInstance();
    }return new NinePatchBmpSlice(content, new NinePatchInfo(out_5_9, out_5_21, content._get_width__0_k$(), content._get_height__0_k$(), content), bmpSlice);
  };
  Companion_132.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_131;
  function Companion_getInstance_131() {
    if (Companion_instance_131 == null)
      new Companion_132();
    return Companion_instance_131;
  }
  function NinePatchBmpSlice(content, info, bmpSlice) {
    Companion_getInstance_131();
    this._content_5 = content;
    this._info_0 = info;
    this._bmpSlice = bmpSlice;
  }
  NinePatchBmpSlice.prototype._get_width__0_k$ = function () {
    return this._bmpSlice._get_width__0_k$();
  };
  NinePatchBmpSlice.prototype._get_height__0_k$ = function () {
    return this._bmpSlice._get_height__0_k$();
  };
  NinePatchBmpSlice.prototype.getSegmentBmpSlice_ngrvll_k$ = function (segment) {
    return ensureNotNull(segment._bmpSlice_0);
  };
  NinePatchBmpSlice.$metadata$ = {
    simpleName: 'NinePatchBmpSlice',
    kind: 'class',
    interfaces: []
  };
  function asNinePatchSimple(_this_, left, top, right, bottom) {
    return Companion_getInstance_131().createSimple_xwrnax_k$(_this_, left, top, right, bottom);
  }
  function _no_name_provided__246(this$0) {
    this._this$0_57 = this$0;
  }
  _no_name_provided__246.prototype.invoke_0_k$ = function () {
    var tmp0_safe_receiver = this._this$0_57._bmpSlice_0;
    return tmp0_safe_receiver == null ? null : extract_2(tmp0_safe_receiver);
  };
  _no_name_provided__246.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function NinePatchInfo_init_$Init$(width, height, left, top, right, bottom, content, $this) {
    NinePatchInfo.call($this, listOf([to(false, until(0, left)), to(true, until(left, right)), to(false, until(right, width))]), listOf([to(false, until(0, top)), to(true, until(top, bottom)), to(false, until(bottom, height))]), width, height, content);
    return $this;
  }
  function NinePatchInfo_init_$Create$(width, height, left, top, right, bottom, content) {
    return NinePatchInfo_init_$Init$(width, height, left, top, right, bottom, content, Object.create(NinePatchInfo.prototype));
  }
  function AxisSegment(scaled, range) {
    this._scaled = scaled;
    this._range_4 = range;
  }
  AxisSegment.prototype._get_fixed__0_k$ = function () {
    return !this._scaled;
  };
  AxisSegment.prototype._get_length__0_k$ = function () {
    return _get_length__0(this._range_4);
  };
  AxisSegment.prototype.computedLength_52bl8a_k$ = function (axis, boundsLength) {
    var scale_1 = clamp_3(boundsLength / axis._totalLen, 0.0, 1.0);
    var tmp;
    if (this._get_fixed__0_k$()) {
      tmp = this._get_length__0_k$() * scale_1;
    } else {
      var variableSize = boundsLength - axis._fixedLen * scale_1;
      tmp = variableSize * (this._get_length__0_k$() / axis._scaledLen);
    }
    return tmp;
  };
  AxisSegment.$metadata$ = {
    simpleName: 'AxisSegment',
    kind: 'class',
    interfaces: []
  };
  function AxisInfo(ranges, totalLen) {
    this._totalLen = totalLen;
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(ranges, 10));
    var tmp0_iterator_1_2 = ranges.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(new AxisSegment(item_2_3._first, item_2_3._second));
      Unit_getInstance();
    }
    tmp._segments = toFastList(tmp0_mapTo_0_1);
    var tmp_0 = this;
    var tmp0_filter_0 = this._segments;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2_0 = tmp0_filter_0.iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2_0.next_0_k$();
      if (element_2_3._get_fixed__0_k$()) {
        tmp0_filterTo_0_1.add_2bq_k$(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    var tmp1_sumOf_0 = tmp0_filterTo_0_1;
    var sum_1_0 = 0;
    var tmp0_iterator_2 = tmp1_sumOf_0.iterator_0_k$();
    while (tmp0_iterator_2.hasNext_0_k$()) {
      var element_3 = tmp0_iterator_2.next_0_k$();
      var tmp_1 = sum_1_0;
      sum_1_0 = tmp_1 + element_3._get_length__0_k$() | 0;
    }
    var tmp2_max_0 = sum_1_0;
    tmp_0._fixedLen = Math.max(1, tmp2_max_0);
    var tmp_2 = this;
    var tmp0_filter_0_0 = this._segments;
    var tmp0_filterTo_0_1_0 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2_1 = tmp0_filter_0_0.iterator_0_k$();
    while (tmp0_iterator_1_2_1.hasNext_0_k$()) {
      var element_2_3_0 = tmp0_iterator_1_2_1.next_0_k$();
      if (element_2_3_0._scaled) {
        tmp0_filterTo_0_1_0.add_2bq_k$(element_2_3_0);
        Unit_getInstance();
      } else {
      }
    }
    var tmp1_sumOf_0_0 = tmp0_filterTo_0_1_0;
    var sum_1_1 = 0;
    var tmp0_iterator_2_0 = tmp1_sumOf_0_0.iterator_0_k$();
    while (tmp0_iterator_2_0.hasNext_0_k$()) {
      var element_3_0 = tmp0_iterator_2_0.next_0_k$();
      var tmp_3 = sum_1_1;
      sum_1_1 = tmp_3 + element_3_0._get_length__0_k$() | 0;
    }
    var tmp2_max_0_0 = sum_1_1;
    tmp_2._scaledLen = Math.max(1, tmp2_max_0_0);
  }
  AxisInfo.$metadata$ = {
    simpleName: 'AxisInfo',
    kind: 'class',
    interfaces: []
  };
  function Segment(info, rect_3, x, y) {
    this._info_1 = info;
    this._rect_1 = rect_3;
    this._x_10 = x;
    this._y_9 = y;
    var tmp = this;
    tmp._$$delegate_0_17 = Mixin_init_$Create$(null, 1, null);
    this._scaleX_0 = this._x_10._scaled;
    this._scaleY_0 = this._y_9._scaled;
    var tmp_0 = this;
    var tmp0_safe_receiver = this._info_1._content_6;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      tmp_1 = tmp0_safe_receiver.slice$default_7tbffz_k$(this._rect_1, null, 2, null);
    }
    tmp_0._bmpSlice_0 = tmp_1;
    var tmp_2 = this;
    tmp_2._bmp$delegate = lazy(_no_name_provided_$factory_198(this));
  }
  Segment.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_17._set_extra__n1onou_k$(_set___);
  };
  Segment.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_17._get_extra__0_k$();
  };
  Segment.$metadata$ = {
    simpleName: 'Segment',
    kind: 'class',
    interfaces: [Extra]
  };
  function NinePatchInfo(xranges, yranges, width, height, content) {
    this._xranges = xranges;
    this._yranges = yranges;
    this._width_4 = width;
    this._height_5 = height;
    this._content_6 = content;
    this._xaxis = new AxisInfo(this._xranges, this._width_4);
    this._yaxis = new AxisInfo(this._yranges, this._height_5);
    this._xsegments = this._xaxis._segments;
    this._ysegments = this._yaxis._segments;
    this._fixedWidth = this._xaxis._fixedLen;
    this._fixedHeight = this._yaxis._fixedLen;
    this._scaledWidth = this._xaxis._scaledLen;
    this._scaledHeight = this._yaxis._scaledLen;
    var tmp = this;
    var tmp0_map_0 = this._ysegments;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp0_map_0_5 = this._xsegments;
      var tmp0_mapTo_0_1_6 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_5, 10));
      var tmp0_iterator_1_2_7 = tmp0_map_0_5.iterator_0_k$();
      while (tmp0_iterator_1_2_7.hasNext_0_k$()) {
        var item_2_3_8 = tmp0_iterator_1_2_7.next_0_k$();
        tmp0_mapTo_0_1_6.add_2bq_k$(new Segment(this, Companion_getInstance_36().fromBounds_ihmn6a_k$(item_2_3_8._range_4._get_start__0_k$(), item_2_3._range_4._get_start__0_k$(), _get_endExclusive_(item_2_3_8._range_4), _get_endExclusive_(item_2_3._range_4)), item_2_3_8, item_2_3));
        Unit_getInstance();
      }
      tmp0_mapTo_0_1.add_2bq_k$(toFastList(tmp0_mapTo_0_1_6));
      Unit_getInstance();
    }
    tmp._segments_0 = toFastList(tmp0_mapTo_0_1);
    this._xComputed = new Int32Array(64);
    this._yComputed = new Int32Array(64);
  }
  NinePatchInfo.prototype._get_totalSegments__0_k$ = function () {
    return imul(this._xsegments._get_size__0_k$(), this._ysegments._get_size__0_k$());
  };
  NinePatchInfo.prototype.computeScale_zk7u_k$ = function (bounds_0, new_0, callback) {
    return new_0 ? this.computeScaleNew_8olqzm_k$(bounds_0, callback) : this.computeScaleOld_8olqzm_k$(bounds_0, callback);
  };
  NinePatchInfo.prototype.computeScale$default_acnxy2_k$ = function (bounds_0, new_0, callback, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      new_0 = true;
    return this.computeScale_zk7u_k$(bounds_0, new_0, callback);
  };
  NinePatchInfo.prototype.computeScaleOld_8olqzm_k$ = function (bounds_0, callback) {
    var ry = 0;
    var iterator_0 = this._ysegments.iterator_0_k$();
    var index_0 = 0;
    while (iterator_0.hasNext_0_k$()) {
      var yindex = index_0;
      index_0 = index_0 + 1 | 0;
      var y = iterator_0.next_0_k$();
      var segHeight = numberToInt(y.computedLength_52bl8a_k$(this._yaxis, _RectangleInt___get_height__impl_(bounds_0)));
      var rx = 0;
      var iterator_1 = this._xsegments.iterator_0_k$();
      var index_1 = 0;
      while (iterator_1.hasNext_0_k$()) {
        var xindex = index_1;
        index_1 = index_1 + 1 | 0;
        var x = iterator_1.next_0_k$();
        var segWidth = numberToInt(x.computedLength_52bl8a_k$(this._xaxis, _RectangleInt___get_width__impl_(bounds_0)));
        var seg = this._segments_0.get_ha5a7z_k$(yindex).get_ha5a7z_k$(xindex);
        var segLeft = rx + _RectangleInt___get_left__impl_(bounds_0) | 0;
        var segTop = ry + _RectangleInt___get_top__impl_(bounds_0) | 0;
        callback(seg, segLeft, segTop, segWidth, segHeight);
        rx = rx + segWidth | 0;
      }
      ry = ry + segHeight | 0;
    }
  };
  NinePatchInfo.prototype.computeScaleNew_8olqzm_k$ = function (bounds_0, callback) {
    var tmp0_fastForEachWithIndex_0 = this._ysegments;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEachWithIndex_0._get_size__0_k$()) {
      var tmp1__anonymous__3 = n_1;
      var tmp2__anonymous__3 = tmp0_fastForEachWithIndex_0.get_ha5a7z_k$(n_1);
      this._yComputed[tmp1__anonymous__3] = IntCompanionObject_getInstance()._MAX_VALUE_5;
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      Unit_getInstance();
    }
    var tmp3_fastForEachWithIndex_0 = this._xsegments;
    var n_1_0 = 0;
    while (n_1_0 < tmp3_fastForEachWithIndex_0._get_size__0_k$()) {
      var tmp4__anonymous__3 = n_1_0;
      var tmp5__anonymous__3 = tmp3_fastForEachWithIndex_0.get_ha5a7z_k$(n_1_0);
      this._xComputed[tmp4__anonymous__3] = IntCompanionObject_getInstance()._MAX_VALUE_5;
      var tmp0_2_0 = n_1_0;
      n_1_0 = tmp0_2_0 + 1 | 0;
      Unit_getInstance();
    }
    var tmp6_fastForEachWithIndex_0 = this._ysegments;
    var n_1_1 = 0;
    while (n_1_1 < tmp6_fastForEachWithIndex_0._get_size__0_k$()) {
      var tmp7__anonymous__3 = n_1_1;
      var tmp8__anonymous__3 = tmp6_fastForEachWithIndex_0.get_ha5a7z_k$(n_1_1);
      var segHeight_4 = tmp8__anonymous__3.computedLength_52bl8a_k$(this._yaxis, _RectangleInt___get_height__impl_(bounds_0));
      var tmp0_fastForEachWithIndex_0_5 = this._xsegments;
      var n_1_6 = 0;
      while (n_1_6 < tmp0_fastForEachWithIndex_0_5._get_size__0_k$()) {
        var tmp1__anonymous__3_7 = n_1_6;
        var tmp2__anonymous__3_8 = tmp0_fastForEachWithIndex_0_5.get_ha5a7z_k$(n_1_6);
        var segWidth_4_9 = tmp2__anonymous__3_8.computedLength_52bl8a_k$(this._xaxis, _RectangleInt___get_width__impl_(bounds_0));
        if (tmp2__anonymous__3_8._get_fixed__0_k$() ? tmp8__anonymous__3._get_fixed__0_k$() : false) {
          var xScale_5_10 = segWidth_4_9 / tmp2__anonymous__3_8._get_length__0_k$();
          var yScale_6_11 = segHeight_4 / tmp8__anonymous__3._get_length__0_k$();
          var minScale_7_12 = Math.min(xScale_5_10, yScale_6_11);
          var tmp0_min_0_8_13 = this._xComputed[tmp1__anonymous__3_7];
          var tmp1_min_0_9_14 = numberToInt(tmp2__anonymous__3_8._get_length__0_k$() * minScale_7_12);
          this._xComputed[tmp1__anonymous__3_7] = Math.min(tmp0_min_0_8_13, tmp1_min_0_9_14);
          var tmp2_min_0_10_15 = this._yComputed[tmp7__anonymous__3];
          var tmp3_min_0_11_16 = numberToInt(tmp8__anonymous__3._get_length__0_k$() * minScale_7_12);
          this._yComputed[tmp7__anonymous__3] = Math.min(tmp2_min_0_10_15, tmp3_min_0_11_16);
        } else {
          var tmp4_min_0_12_17 = this._xComputed[tmp1__anonymous__3_7];
          var tmp5_min_0_13_18 = numberToInt(segWidth_4_9);
          this._xComputed[tmp1__anonymous__3_7] = Math.min(tmp4_min_0_12_17, tmp5_min_0_13_18);
          var tmp6_min_0_14_19 = this._yComputed[tmp7__anonymous__3];
          var tmp7_min_0_15_20 = numberToInt(segHeight_4);
          this._yComputed[tmp7__anonymous__3] = Math.min(tmp6_min_0_14_19, tmp7_min_0_15_20);
        }
        var tmp0_2_21 = n_1_6;
        n_1_6 = tmp0_2_21 + 1 | 0;
        Unit_getInstance();
      }
      var tmp0_2_1 = n_1_1;
      n_1_1 = tmp0_2_1 + 1 | 0;
      Unit_getInstance();
    }
    var denormalizedWidth = sum(this._xComputed);
    var denormalizedHeight = sum(this._yComputed);
    var tmp9_mapIndexed_0 = this._xsegments;
    var tmp0_mapIndexedTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp9_mapIndexed_0, 10));
    var index_1_2 = 0;
    var tmp0_iterator_2_3 = tmp9_mapIndexed_0.iterator_0_k$();
    while (tmp0_iterator_2_3.hasNext_0_k$()) {
      var item_3_4 = tmp0_iterator_2_3.next_0_k$();
      var tmp1_4_5 = index_1_2;
      index_1_2 = tmp1_4_5 + 1 | 0;
      var tmp10__anonymous__6 = checkIndexOverflow(tmp1_4_5);
      tmp0_mapIndexedTo_0_1.add_2bq_k$(item_3_4._scaled ? this._xComputed[tmp10__anonymous__6] : 0);
      Unit_getInstance();
    }
    var denormalizedScaledWidth = sum_1(tmp0_mapIndexedTo_0_1);
    var tmp11_mapIndexed_0 = this._ysegments;
    var tmp0_mapIndexedTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp11_mapIndexed_0, 10));
    var index_1_2_0 = 0;
    var tmp0_iterator_2_3_0 = tmp11_mapIndexed_0.iterator_0_k$();
    while (tmp0_iterator_2_3_0.hasNext_0_k$()) {
      var item_3_4_0 = tmp0_iterator_2_3_0.next_0_k$();
      var tmp1_4_5_0 = index_1_2_0;
      index_1_2_0 = tmp1_4_5_0 + 1 | 0;
      var tmp12__anonymous__6 = checkIndexOverflow(tmp1_4_5_0);
      tmp0_mapIndexedTo_0_1_0.add_2bq_k$(item_3_4_0._scaled ? this._yComputed[tmp12__anonymous__6] : 0);
      Unit_getInstance();
    }
    var denormalizedScaledHeight = sum_1(tmp0_mapIndexedTo_0_1_0);
    var xScaledRatio = denormalizedWidth > 0 ? denormalizedScaledWidth / denormalizedWidth : 1.0;
    var yScaledRatio = denormalizedWidth > 0 ? denormalizedScaledHeight / denormalizedHeight : 1.0;
    var inductionVariable = 0;
    if (inductionVariable < 2)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var segments = n === 0 ? this._ysegments : this._xsegments;
        var computed = n === 0 ? this._yComputed : this._xComputed;
        var denormalizedScaledLen = n === 0 ? denormalizedScaledHeight : denormalizedScaledWidth;
        var side = n === 0 ? _RectangleInt___get_height__impl_(bounds_0) : _RectangleInt___get_width__impl_(bounds_0);
        var scaledRatio = n === 0 ? yScaledRatio : xScaledRatio;
        var scaledSide = side * scaledRatio;
        var n_1_2 = 0;
        while (n_1_2 < segments._get_size__0_k$()) {
          var tmp13__anonymous__3 = n_1_2;
          var tmp14__anonymous__3 = segments.get_ha5a7z_k$(n_1_2);
          if (tmp14__anonymous__3._scaled) {
            computed[tmp13__anonymous__3] = numberToInt(scaledSide * (computed[tmp13__anonymous__3] / denormalizedScaledLen));
          }var tmp0_2_2 = n_1_2;
          n_1_2 = tmp0_2_2 + 1 | 0;
          Unit_getInstance();
        }
      }
       while (inductionVariable < 2);
    var xRemaining = _RectangleInt___get_width__impl_(bounds_0) - sum(this._xComputed) | 0;
    var yRemaining = _RectangleInt___get_height__impl_(bounds_0) - sum(this._yComputed) | 0;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp15_indexOfFirst_0 = this._xsegments;
      var index_1 = 0;
      var tmp0_iterator_2 = tmp15_indexOfFirst_0.iterator_0_k$();
      while (tmp0_iterator_2.hasNext_0_k$()) {
        var item_3 = tmp0_iterator_2.next_0_k$();
        if (item_3._scaled) {
          tmp$ret$0 = index_1;
          break l$ret$1;
        } else {
        }
        var tmp1_4 = index_1;
        index_1 = tmp1_4 + 1 | 0;
        Unit_getInstance();
      }
      tmp$ret$0 = -1;
    }
     while (false);
    var xScaledFirst = tmp$ret$0;
    var tmp$ret$2;
    l$ret$3: do {
      var tmp16_indexOfFirst_0 = this._ysegments;
      var index_1_0 = 0;
      var tmp0_iterator_2_0 = tmp16_indexOfFirst_0.iterator_0_k$();
      while (tmp0_iterator_2_0.hasNext_0_k$()) {
        var item_3_0 = tmp0_iterator_2_0.next_0_k$();
        if (item_3_0._scaled) {
          tmp$ret$2 = index_1_0;
          break l$ret$3;
        } else {
        }
        var tmp1_4_0 = index_1_0;
        index_1_0 = tmp1_4_0 + 1 | 0;
        Unit_getInstance();
      }
      tmp$ret$2 = -1;
    }
     while (false);
    var yScaledFirst = tmp$ret$2;
    if (xRemaining > 0 ? xScaledFirst >= 0 : false) {
      var tmp1_array = this._xComputed;
      var tmp2_index0 = xScaledFirst;
      tmp1_array[tmp2_index0] = tmp1_array[tmp2_index0] + xRemaining | 0;
    }if (yRemaining > 0 ? yScaledFirst >= 0 : false) {
      var tmp3_array = this._yComputed;
      var tmp4_index0 = yScaledFirst;
      tmp3_array[tmp4_index0] = tmp3_array[tmp4_index0] + yRemaining | 0;
    }var ry = 0;
    var inductionVariable_0 = 0;
    var last_1 = this._ysegments._get_size__0_k$() - 1 | 0;
    if (inductionVariable_0 <= last_1)
      do {
        var yindex = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var segHeight = this._yComputed[yindex];
        var rx = 0;
        var inductionVariable_1 = 0;
        var last_2 = this._xsegments._get_size__0_k$() - 1 | 0;
        if (inductionVariable_1 <= last_2)
          do {
            var xindex = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var segWidth = this._xComputed[xindex];
            var seg = this._segments_0.get_ha5a7z_k$(yindex).get_ha5a7z_k$(xindex);
            var segLeft = rx + _RectangleInt___get_left__impl_(bounds_0) | 0;
            var segTop = ry + _RectangleInt___get_top__impl_(bounds_0) | 0;
            callback(seg, segLeft, segTop, segWidth, segHeight);
            rx = rx + segWidth | 0;
          }
           while (inductionVariable_1 <= last_2);
        ry = ry + segHeight | 0;
      }
       while (inductionVariable_0 <= last_1);
  };
  NinePatchInfo.$metadata$ = {
    simpleName: 'NinePatchInfo',
    kind: 'class',
    interfaces: []
  };
  function readNinePatch(_this_, format_0, $cont) {
    var tmp = new $readNinePatchCOROUTINE$0(_this_, format_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readNinePatch$default(_this_, format_0, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      format_0 = RegisteredImageFormats_getInstance();
    return readNinePatch(_this_, format_0, $cont);
  }
  function $readNinePatchCOROUTINE$0(_this_, format_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__118 = _this_;
    this._format_0 = format_0;
  }
  $readNinePatchCOROUTINE$0.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._ARGUMENT0_19 = Companion_getInstance_131();
            this._state_1 = 1;
            suspendResult = readBitmap$default(this.__this__118, this._format_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT.toBMP32_0_k$();
            return this._ARGUMENT0_19.invoke_nc8knv_k$(ARGUMENT_0);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readNinePatchCOROUTINE$0.$metadata$ = {
    simpleName: '$readNinePatchCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_198(this$0) {
    var i = new _no_name_provided__246(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function Palette_init_$Init$(colors, names, changeStart, changeEnd, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      names = null;
    if (!(($mask0 & 4) === 0))
      changeStart = 0;
    if (!(($mask0 & 8) === 0))
      changeEnd = 0;
    Palette.call($this, colors, names, changeStart, changeEnd);
    return $this;
  }
  function Palette_init_$Create$(colors, names, changeStart, changeEnd, $mask0, $marker) {
    return Palette_init_$Init$(colors, names, changeStart, changeEnd, $mask0, $marker, Object.create(Palette.prototype));
  }
  function Palette(colors, names, changeStart, changeEnd) {
    this._colors = colors;
    this._names = names;
    this._changeStart = changeStart;
    this._changeEnd = changeEnd;
  }
  Palette.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_uch40_k$('Palette(');
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = _RgbaArray___get_size__impl_(this._colors);
    if (inductionVariable < last_1)
      do {
        var n_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color_5 = RgbaArray__get_impl(this._colors, n_4);
        var tmp1_safe_receiver_7 = this._names;
        var name_6 = tmp1_safe_receiver_7 == null ? null : tmp1_safe_receiver_7[n_4];
        if (n_4 > 0) {
          tmp0_apply_0_1.append_uch40_k$(', ');
          Unit_getInstance();
        }if (!(name_6 == null)) {
          tmp0_apply_0_1.append_uch40_k$(name_6);
          Unit_getInstance();
          tmp0_apply_0_1.append_uch40_k$(': ');
          Unit_getInstance();
        }tmp0_apply_0_1.append_uch40_k$(RGBA__toString_impl(color_5));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp0_apply_0_1.append_uch40_k$(')');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  Palette.$metadata$ = {
    simpleName: 'Palette',
    kind: 'class',
    interfaces: []
  };
  function applyEffect(_this_, effect) {
    var safeBorder = _get_safeBorder_(effect);
    var out = Companion_getInstance_127().invoke_3e3oii_k$(_this_._get_width__0_k$() + imul(safeBorder, 2) | 0, _this_._get_height__0_k$() + imul(safeBorder, 2) | 0, _this_._get_premultiplied__0_k$());
    out.put_bvdyk7_k$(_this_, safeBorder, safeBorder);
    applyEffectInline(out, effect);
    return out;
  }
  function _get_safeBorder_(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_safeBorder__0_k$();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  function applyEffectInline(_this_, effect) {
    if (effect == null)
      return Unit_getInstance();
    if (!(effect.blurRadius__error === 0)) {
      blurInplace(_this_, effect.blurRadius__error);
    }if ((!(effect.dropShadowRadius__error === 0) ? true : !(effect.dropShadowX__error === 0)) ? true : !(effect.dropShadowY__error === 0)) {
      dropShadowInplace(_this_, effect.dropShadowX__error, effect.dropShadowY__error, effect.dropShadowRadius__error, effect.dropShadowColor__error);
      Unit_getInstance();
    }if (!(effect.borderSize__error === 0)) {
      borderInline(_this_, effect.borderSize__error, effect.borderColor__error);
    }}
  function blurInplace(_this_, r) {
    var r_0 = coerceAtMost(coerceAtMost(r, (_this_._get_width__0_k$() / 2 | 0) - 1 | 0), (_this_._get_height__0_k$() / 2 | 0) - 1 | 0);
    var tmp = _this_._get_width__0_k$();
    var tmp_0 = _this_._get_height__0_k$();
    var t1 = Bitmap8_init_$Create$(tmp, tmp_0, null, null, 12, null);
    var tmp_1 = _this_._get_width__0_k$();
    var tmp_2 = _this_._get_height__0_k$();
    var t2 = Bitmap8_init_$Create$(tmp_1, tmp_2, null, null, 12, null);
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var channel = Companion_getInstance_129().get_ha5a7z_k$(n);
        _this_.extractChannel_j18suz_k$(channel, t1);
        Unit_getInstance();
        arraycopy_2(t1._get_data__0_k$(), 0, t2._get_data__0_k$(), 0, t2._get_area__0_k$());
        gaussBlur(t1._get_data__0_k$(), t2._get_data__0_k$(), _this_._get_width__0_k$(), _this_._get_height__0_k$(), r_0);
        _this_.writeChannel_mzlnw_k$(channel, t2);
      }
       while (inductionVariable < 4);
  }
  function gaussBlur(scl, tcl, w, h, r) {
    var a = 0;
    var b = 0;
    var c = 0;
    var n_1 = 3;
    var tmp0_sqrt_0 = 12.0 * r * r / n_1 + 1;
    var wIdeal_2 = Math.sqrt(tmp0_sqrt_0);
    var wl_3 = toIntFloor(wIdeal_2);
    if (wl_3 % 2 === 0) {
      var tmp0_4 = wl_3;
      wl_3 = tmp0_4 - 1 | 0;
      Unit_getInstance();
    }var wu_5 = wl_3 + 2 | 0;
    var mIdeal_6 = (12.0 * r * r - imul(imul(n_1, wl_3), wl_3) - imul(imul(4, n_1), wl_3) - imul(3, n_1)) / (imul(-4, wl_3) - 4 | 0);
    var m_7 = round(mIdeal_6);
    var tmp1__anonymous__8 = 0.0 < m_7 ? wl_3 : wu_5;
    var tmp2__anonymous__8 = 1.0 < m_7 ? wl_3 : wu_5;
    var tmp3__anonymous__8 = 2.0 < m_7 ? wl_3 : wu_5;
    a = tmp1__anonymous__8;
    b = tmp2__anonymous__8;
    c = tmp3__anonymous__8;
    boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
    boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
    boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
  }
  function boxBlur(scl, tcl, w, h, r) {
    arraycopy_2(scl, 0, tcl, 0, scl.length);
    boxBlurH(tcl, scl, w, h, r);
    boxBlurT(scl, tcl, w, h, r);
  }
  function boxBlurH(scl, tcl, w, h, r) {
    var arr = (r + r | 0) + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < h)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ti = imul(i, w);
        var li = ti;
        var ri = ti + r | 0;
        var fv = readU8(scl, ti);
        var lv = readU8(scl, (ti + w | 0) - 1 | 0);
        var v = imul(r + 1 | 0, fv);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < r)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            v = v + readU8(scl, ti + j | 0) | 0;
          }
           while (inductionVariable_0 < r);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= r)
          do {
            var j_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp = v;
            var tmp3 = ri;
            ri = tmp3 + 1 | 0;
            v = tmp + (readU8(scl, tmp3) - fv | 0) | 0;
            var tmp4 = ti;
            ti = tmp4 + 1 | 0;
            tcl[tmp4] = toByte(v / arr | 0);
          }
           while (!(j_0 === r));
        var inductionVariable_2 = r + 1 | 0;
        var last_1 = w - r | 0;
        if (inductionVariable_2 < last_1)
          do {
            var j_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var tmp_0 = v;
            var tmp7 = ri;
            ri = tmp7 + 1 | 0;
            var tmp_1 = readU8(scl, tmp7);
            var tmp6 = li;
            li = tmp6 + 1 | 0;
            v = tmp_0 + (tmp_1 - readU8(scl, tmp6) | 0) | 0;
            var tmp8 = ti;
            ti = tmp8 + 1 | 0;
            tcl[tmp8] = toByte(v / arr | 0);
          }
           while (inductionVariable_2 < last_1);
        var inductionVariable_3 = w - r | 0;
        if (inductionVariable_3 < w)
          do {
            var j_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var tmp_2 = v;
            var tmp10 = li;
            li = tmp10 + 1 | 0;
            v = tmp_2 + (lv - readU8(scl, tmp10) | 0) | 0;
            var tmp11 = ti;
            ti = tmp11 + 1 | 0;
            tcl[tmp11] = toByte(v / arr | 0);
          }
           while (inductionVariable_3 < w);
      }
       while (inductionVariable < h);
  }
  function boxBlurT(scl, tcl, w, h, r) {
    var arr = (r + r | 0) + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < w)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ti = i;
        var li = ti;
        var ri = ti + imul(r, w) | 0;
        var fv = readU8(scl, ti);
        var lv = readU8(scl, ti + imul(w, h - 1 | 0) | 0);
        var v = imul(r + 1 | 0, fv);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < r)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            v = v + readU8(scl, ti + imul(j, w) | 0) | 0;
          }
           while (inductionVariable_0 < r);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= r)
          do {
            var j_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            v = v + (readU8(scl, ri) - fv | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            ri = ri + w | 0;
            ti = ti + w | 0;
          }
           while (!(j_0 === r));
        var inductionVariable_2 = r + 1 | 0;
        var last_1 = h - r | 0;
        if (inductionVariable_2 < last_1)
          do {
            var j_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            v = v + (readU8(scl, ri) - readU8(scl, li) | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            li = li + w | 0;
            ri = ri + w | 0;
            ti = ti + w | 0;
          }
           while (inductionVariable_2 < last_1);
        var inductionVariable_3 = h - r | 0;
        if (inductionVariable_3 < h)
          do {
            var j_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            v = v + (lv - readU8(scl, li) | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            li = li + w | 0;
            ti = ti + w | 0;
          }
           while (inductionVariable_3 < h);
      }
       while (inductionVariable < w);
  }
  function blur(_this_, r) {
    var tmp = _this_._get_width__0_k$() + imul(r, 2) | 0;
    var tmp_0 = _this_._get_height__0_k$() + imul(r, 2) | 0;
    var out = Bitmap8_init_$Create$(tmp, tmp_0, null, null, 12, null);
    Companion_getInstance_128().copyRect_z7zcaf_k$(_this_, 0, 0, out, r, r, _this_._get_width__0_k$(), _this_._get_height__0_k$());
    blurInplace_0(out, r);
    return out;
  }
  function blurInplace_0(_this_, r) {
    var r_0 = coerceAtMost(coerceAtMost(r, (_this_._get_width__0_k$() / 2 | 0) - 1 | 0), (_this_._get_height__0_k$() / 2 | 0) - 1 | 0);
    var tmp = _this_._get_width__0_k$();
    var tmp_0 = _this_._get_height__0_k$();
    var t2 = Bitmap8_init_$Create$(tmp, tmp_0, null, null, 12, null);
    arraycopy_2(_this_._get_data__0_k$(), 0, t2._get_data__0_k$(), 0, _this_._get_area__0_k$());
    gaussBlur(t2._get_data__0_k$(), _this_._get_data__0_k$(), _this_._get_width__0_k$(), _this_._get_height__0_k$(), r_0);
  }
  function borderInline(_this_, r, color_0) {
    var out = _this_;
    var distance = distanceMap$default(out, null, 0.0, 3, null);
    var inductionVariable = 0;
    var last_1 = out._get_height__0_k$();
    if (inductionVariable < last_1)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_2 = out._get_width__0_k$();
        if (inductionVariable_0 < last_2)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var dist = distance.getDist_27zxwg_k$(x, y);
            if (dist < (r + 1 | 0)) {
              var alpha_0 = dist >= r ? 1.0 - dist % 1.0 : 1.0;
              var rcolor = alpha_0 === 1.0 ? color_0 : RGBA__withAf_impl(color_0, _RGBA___get_af__impl_(color_0) * alpha_0);
              out.set_5mmwyp_k$(x, y, Companion_getInstance_136().mix_5llkhf_k$(rcolor, out.get_aewswh_k$(x, y)));
            }}
           while (inductionVariable_0 < last_2);
      }
       while (inductionVariable < last_1);
  }
  function dropShadowInplace(_this_, x, y, r, color_0) {
    var copy_2 = _this_.clone_0_k$();
    var pcolor_3 = _RGBA___get_premultiplied__impl_(color_0);
    var tmp = BitmapChannel_ALPHA_getInstance();
    var tmp0_also_0_5 = blur(_this_.extractChannel$default_hpmngo_k$(tmp, null, 2, null), r);
    tmp0_also_0_5._set_premultiplied__rpwsgn_k$(true);
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n_3_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__set_impl(tmp0_also_0_5._get_palette__wd8tzq_k$(), n_3_7, Companion_getInstance_136().invoke_fnl2i9_k$(imul(_RGBAPremultiplied___get_r__impl_(pcolor_3), n_3_7) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl_(pcolor_3), n_3_7) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl_(pcolor_3), n_3_7) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl_(pcolor_3), n_3_7) / 255 | 0));
      }
       while (inductionVariable < 256);
    var shadow_4 = tmp0_also_0_5.toBMP32_0_k$();
    var tmp_0 = Colors_getInstance()._TRANSPARENT_BLACK;
    _this_.fill$default_g8ip_k$(tmp_0, 0, 0, 0, 0, 30, null);
    _this_.draw_bvdyk7_k$(shadow_4, x - r | 0, y - r | 0);
    _this_.draw_bvdyk7_k$(copy_2, 0, 0);
    return _this_;
  }
  function BGRA() {
    BGRA_instance = this;
    var tmp = this;
    tmp._$$delegate_0_18 = new Mixin_1(32, 16, 8, 8, 8, 0, 8, 24, 8);
  }
  BGRA.prototype.getA_ha5a7z_k$ = function (v) {
    return this._$$delegate_0_18.getA_ha5a7z_k$(v);
  };
  BGRA.prototype.getB_ha5a7z_k$ = function (v) {
    return this._$$delegate_0_18.getB_ha5a7z_k$(v);
  };
  BGRA.prototype.getG_ha5a7z_k$ = function (v) {
    return this._$$delegate_0_18.getG_ha5a7z_k$(v);
  };
  BGRA.prototype.getR_ha5a7z_k$ = function (v) {
    return this._$$delegate_0_18.getR_ha5a7z_k$(v);
  };
  BGRA.prototype.pack_w0xdj4_k$ = function (r, g, b, a) {
    return this._$$delegate_0_18.pack_w0xdj4_k$(r, g, b, a);
  };
  BGRA.prototype._get_bpp__0_k$ = function () {
    return this._$$delegate_0_18._bpp_1;
  };
  BGRA.$metadata$ = {
    simpleName: 'BGRA',
    kind: 'object',
    interfaces: [ColorFormat]
  };
  var BGRA_instance;
  function BGRA_getInstance() {
    if (BGRA_instance == null)
      new BGRA();
    return BGRA_instance;
  }
  function ColorFormat32() {
    this._bpp_0 = 32;
  }
  ColorFormat32.prototype._get_bpp__0_k$ = function () {
    return this._bpp_0;
  };
  ColorFormat32.$metadata$ = {
    simpleName: 'ColorFormat32',
    kind: 'class',
    interfaces: [ColorFormat]
  };
  function decode(_this_, data, dataOffset, out, outOffset, size_2, littleEndian) {
    var tmp0_subject = _this_._get_bpp__0_k$();
    var tmp;
    switch (tmp0_subject) {
      case 16:
        var tmp_0;
        if (littleEndian) {
          tmp_0 = _no_name_provided_$factory_199();
        } else {
          tmp_0 = _no_name_provided_$factory_200();
        }

        tmp = tmp_0;
        break;
      case 24:
        var tmp_1;
        if (littleEndian) {
          tmp_1 = _no_name_provided_$factory_201();
        } else {
          tmp_1 = _no_name_provided_$factory_202();
        }

        tmp = tmp_1;
        break;
      case 32:
        var tmp_2;
        if (littleEndian) {
          tmp_2 = _no_name_provided_$factory_203();
        } else {
          tmp_2 = _no_name_provided_$factory_204();
        }

        tmp = tmp_2;
        break;
      default:throw IllegalArgumentException_init_$Create$('' + 'Unsupported bpp ' + _this_._get_bpp__0_k$());
    }
    var readFunc = tmp;
    var io_1 = dataOffset;
    var oo_2 = outOffset;
    var bytesPerPixel_3 = _get_bytesPerPixel_(_this_);
    var outdata_4 = out;
    var Bpp_5 = numberToInt(bytesPerPixel_3);
    var inductionVariable = 0;
    if (inductionVariable < size_2)
      do {
        var n_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c_8 = readFunc(data, io_1);
        io_1 = io_1 + Bpp_5 | 0;
        var tmp1_9 = oo_2;
        oo_2 = tmp1_9 + 1 | 0;
        RgbaArray__set_impl(outdata_4, tmp1_9, Companion_getInstance_136().invoke_fnl2i9_k$(_this_.getR_ha5a7z_k$(c_8), _this_.getG_ha5a7z_k$(c_8), _this_.getB_ha5a7z_k$(c_8), _this_.getA_ha5a7z_k$(c_8)));
      }
       while (inductionVariable < size_2);
  }
  function decode$default(_this_, data, dataOffset, out, outOffset, size_2, littleEndian, $mask0, $handler) {
    if (!(($mask0 & 32) === 0))
      littleEndian = true;
    return decode(_this_, data, dataOffset, out, outOffset, size_2, littleEndian);
  }
  function Mixin_1(bpp, rOffset, rSize, gOffset, gSize, bOffset, bSize, aOffset, aSize) {
    this._bpp_1 = bpp;
    this._rOffset = rOffset;
    this._rSize = rSize;
    this._gOffset = gOffset;
    this._gSize = gSize;
    this._bOffset = bOffset;
    this._bSize = bSize;
    this._aOffset = aOffset;
    this._aSize = aSize;
  }
  Mixin_1.prototype._get_bpp__0_k$ = function () {
    return this._bpp_1;
  };
  Mixin_1.prototype.getR_ha5a7z_k$ = function (v) {
    return extractScaledFF(v, this._rOffset, this._rSize);
  };
  Mixin_1.prototype.getG_ha5a7z_k$ = function (v) {
    return extractScaledFF(v, this._gOffset, this._gSize);
  };
  Mixin_1.prototype.getB_ha5a7z_k$ = function (v) {
    return extractScaledFF(v, this._bOffset, this._bSize);
  };
  Mixin_1.prototype.getA_ha5a7z_k$ = function (v) {
    return extractScaledFFDefault(v, this._aOffset, this._aSize, 255);
  };
  Mixin_1.prototype.pack_w0xdj4_k$ = function (r, g, b, a) {
    return insertScaledFF(insertScaledFF(insertScaledFF(insertScaledFF(0, r, this._rOffset, this._rSize), g, this._gOffset, this._gSize), b, this._bOffset, this._bSize), a, this._aOffset, this._aSize);
  };
  Mixin_1.$metadata$ = {
    simpleName: 'Mixin',
    kind: 'class',
    interfaces: [ColorFormat]
  };
  function ColorFormat() {
  }
  ColorFormat.$metadata$ = {
    simpleName: 'ColorFormat',
    kind: 'interface',
    interfaces: []
  };
  function encode_0(_this_, colors, colorsOffset, size_2, littleEndian) {
    var out = new Int8Array(numberToInt(size_2 * _get_bytesPerPixel_(_this_)));
    encode_1(_this_, colors, colorsOffset, out, 0, size_2, littleEndian);
    return out;
  }
  function _get_bytesPerPixel_(_this_) {
    return _this_._get_bpp__0_k$() / 8;
  }
  function encode_1(_this_, colors, colorsOffset, out, outOffset, size_2, littleEndian) {
    var io = colorsOffset;
    var oo = outOffset;
    var Bpp = numberToInt(_get_bytesPerPixel_(_this_));
    var inductionVariable = 0;
    if (inductionVariable < size_2)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1 = io;
        io = tmp1 + 1 | 0;
        var c = RgbaArray__get_impl(colors, tmp1);
        var ec = _this_.pack_w0xdj4_k$(_RGBA___get_r__impl_(c), _RGBA___get_g__impl_(c), _RGBA___get_b__impl_(c), _RGBA___get_a__impl_(c));
        var tmp2_subject = _this_._get_bpp__0_k$();
        switch (tmp2_subject) {
          case 16:
            if (littleEndian)
              write16LE(out, oo, ec);
            else
              write16BE(out, oo, ec);
            break;
          case 24:
            if (littleEndian)
              write24LE(out, oo, ec);
            else
              write24BE(out, oo, ec);
            break;
          case 32:
            if (littleEndian)
              write32LE(out, oo, ec);
            else
              write32BE(out, oo, ec);
            break;
          default:throw IllegalArgumentException_init_$Create$('' + 'Unsupported bpp ' + _this_._get_bpp__0_k$());
        }
        oo = oo + Bpp | 0;
      }
       while (inductionVariable < size_2);
  }
  function ColorFormat24() {
    this._bpp_2 = 24;
  }
  ColorFormat24.prototype._get_bpp__0_k$ = function () {
    return this._bpp_2;
  };
  ColorFormat24.$metadata$ = {
    simpleName: 'ColorFormat24',
    kind: 'class',
    interfaces: [ColorFormat]
  };
  function _no_name_provided__247() {
  }
  _no_name_provided__247.prototype.invoke_kqg9r2_k$ = function (p0, p1) {
    return readU16LE(p0, p1);
  };
  _no_name_provided__247.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_kqg9r2_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__247.prototype._get_name__0_k$ = function () {
    return 'readU16LE';
  };
  _no_name_provided__247.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__248() {
  }
  _no_name_provided__248.prototype.invoke_kqg9r2_k$ = function (p0, p1) {
    return readU16BE(p0, p1);
  };
  _no_name_provided__248.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_kqg9r2_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__248.prototype._get_name__0_k$ = function () {
    return 'readU16BE';
  };
  _no_name_provided__248.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__249() {
  }
  _no_name_provided__249.prototype.invoke_kqg9r2_k$ = function (p0, p1) {
    return readU24LE(p0, p1);
  };
  _no_name_provided__249.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_kqg9r2_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__249.prototype._get_name__0_k$ = function () {
    return 'readU24LE';
  };
  _no_name_provided__249.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__250() {
  }
  _no_name_provided__250.prototype.invoke_kqg9r2_k$ = function (p0, p1) {
    return readU24BE(p0, p1);
  };
  _no_name_provided__250.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_kqg9r2_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__250.prototype._get_name__0_k$ = function () {
    return 'readU24BE';
  };
  _no_name_provided__250.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__251() {
  }
  _no_name_provided__251.prototype.invoke_kqg9r2_k$ = function (p0, p1) {
    return readS32LE(p0, p1);
  };
  _no_name_provided__251.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_kqg9r2_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__251.prototype._get_name__0_k$ = function () {
    return 'readS32LE';
  };
  _no_name_provided__251.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__252() {
  }
  _no_name_provided__252.prototype.invoke_kqg9r2_k$ = function (p0, p1) {
    return readS32BE(p0, p1);
  };
  _no_name_provided__252.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_kqg9r2_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__252.prototype._get_name__0_k$ = function () {
    return 'readS32BE';
  };
  _no_name_provided__252.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_199() {
    var i = new _no_name_provided__247();
    var l = function (p1, p2) {
      return i.invoke_kqg9r2_k$(p1, p2);
    };
    l.callableName = i._get_name__0_k$();
    return l;
  }
  function _no_name_provided_$factory_200() {
    var i = new _no_name_provided__248();
    var l = function (p1, p2) {
      return i.invoke_kqg9r2_k$(p1, p2);
    };
    l.callableName = i._get_name__0_k$();
    return l;
  }
  function _no_name_provided_$factory_201() {
    var i = new _no_name_provided__249();
    var l = function (p1, p2) {
      return i.invoke_kqg9r2_k$(p1, p2);
    };
    l.callableName = i._get_name__0_k$();
    return l;
  }
  function _no_name_provided_$factory_202() {
    var i = new _no_name_provided__250();
    var l = function (p1, p2) {
      return i.invoke_kqg9r2_k$(p1, p2);
    };
    l.callableName = i._get_name__0_k$();
    return l;
  }
  function _no_name_provided_$factory_203() {
    var i = new _no_name_provided__251();
    var l = function (p1, p2) {
      return i.invoke_kqg9r2_k$(p1, p2);
    };
    l.callableName = i._get_name__0_k$();
    return l;
  }
  function _no_name_provided_$factory_204() {
    var i = new _no_name_provided__252();
    var l = function (p1, p2) {
      return i.invoke_kqg9r2_k$(p1, p2);
    };
    l.callableName = i._get_name__0_k$();
    return l;
  }
  var ColorAdd_NEUTRAL;
  function _ColorAdd___init__impl_(value) {
    return value;
  }
  function _ColorAdd___get_value__impl_(this_0) {
    return this_0;
  }
  function _ColorAdd___get_r__impl_(this_0) {
    return ColorAdd_unpackComponent(_ColorAdd___get_value__impl_(this_0) >>> 0 & 255);
  }
  function _ColorAdd___get_g__impl_(this_0) {
    return ColorAdd_unpackComponent(_ColorAdd___get_value__impl_(this_0) >>> 8 & 255);
  }
  function _ColorAdd___get_b__impl_(this_0) {
    return ColorAdd_unpackComponent(_ColorAdd___get_value__impl_(this_0) >>> 16 & 255);
  }
  function _ColorAdd___get_a__impl_(this_0) {
    return ColorAdd_unpackComponent(_ColorAdd___get_value__impl_(this_0) >>> 24 & 255);
  }
  function _ColorAdd___get_shex__impl_(this_0) {
    return _get_shex_(_ColorAdd___get_value__impl_(this_0));
  }
  function Companion_133() {
    Companion_instance_132 = this;
  }
  Companion_133.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_132;
  function Companion_getInstance_132() {
    if (Companion_instance_132 == null)
      new Companion_133();
    return Companion_instance_132;
  }
  function ColorAdd__toString_impl(this_0) {
    return '' + 'ColorAdd(value=' + this_0 + ')';
  }
  function ColorAdd__hashCode_impl(this_0) {
    return this_0;
  }
  function ColorAdd__equals_impl(this_0, other) {
    if (!(other instanceof ColorAdd))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ColorAdd ? other._value_18 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function ColorAdd(value) {
    Companion_getInstance_132();
    this._value_18 = value;
  }
  ColorAdd.prototype.toString = function () {
    return ColorAdd__toString_impl(this._value_18);
  };
  ColorAdd.prototype.hashCode = function () {
    return ColorAdd__hashCode_impl(this._value_18);
  };
  ColorAdd.prototype.equals = function (other) {
    return ColorAdd__equals_impl(this._value_18, other);
  };
  ColorAdd.$metadata$ = {
    simpleName: 'ColorAdd',
    kind: 'class',
    interfaces: []
  };
  function ColorAdd_unpackComponent(v) {
    return imul(v - 127 | 0, 2);
  }
  function ColorAdd_pack(r, g, b, a) {
    return ColorAdd_packComponent(r) << 0 | ColorAdd_packComponent(g) << 8 | ColorAdd_packComponent(b) << 16 | ColorAdd_packComponent(a) << 24;
  }
  function ColorAdd_packComponent(v) {
    return clamp_2(127 + (v >> 1) | 0, 0, 255);
  }
  function Companion_134() {
    Companion_instance_133 = this;
  }
  Companion_134.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_133;
  function Companion_getInstance_133() {
    if (Companion_instance_133 == null)
      new Companion_134();
    return Companion_instance_133;
  }
  function computeColors($this) {
    if ($this._dirty) {
      $this._dirty = false;
      $this.__colorMul = Companion_getInstance_136().float_cz83z_k$($this.__mR, $this.__mG, $this.__mB, $this.__mA);
      var tmp = $this;
      var tmp0_invoke_0 = Companion_getInstance_132();
      var tmp1_invoke_0 = $this.__aR;
      var tmp2_invoke_0 = $this.__aG;
      var tmp3_invoke_0 = $this.__aB;
      var tmp4_invoke_0 = $this.__aA;
      tmp.__colorAdd = _ColorAdd___init__impl_(ColorAdd_pack(tmp1_invoke_0, tmp2_invoke_0, tmp3_invoke_0, tmp4_invoke_0));
    }}
  function ColorTransform(_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA) {
    Companion_getInstance_133();
    this.__mR = _mR;
    this.__mG = _mG;
    this.__mB = _mB;
    this.__mA = _mA;
    this.__aR = _aR;
    this.__aG = _aG;
    this.__aB = _aB;
    this.__aA = _aA;
    this._dirty = true;
    this.__colorMul = Colors_getInstance()._WHITE_0;
    this.__colorAdd = _ColorAdd___init__impl_(0);
  }
  ColorTransform.prototype.setToInterpolated_a01zgt_k$ = function (ratio, l, r) {
    return this.setTo_ajkz0c_k$(interpolate(ratio, l._get_mR__0_k$(), r._get_mR__0_k$()), interpolate(ratio, l._get_mG__0_k$(), r._get_mG__0_k$()), interpolate(ratio, l._get_mB__0_k$(), r._get_mB__0_k$()), interpolate(ratio, l._get_mA__0_k$(), r._get_mA__0_k$()), interpolate_0(ratio, l._get_aR__0_k$(), r._get_aR__0_k$()), interpolate_0(ratio, l._get_aG__0_k$(), r._get_aG__0_k$()), interpolate_0(ratio, l._get_aB__0_k$(), r._get_aB__0_k$()), interpolate_0(ratio, l._get_aA__0_k$(), r._get_aA__0_k$()));
  };
  ColorTransform.prototype._set_colorMul__f52nlt_k$ = function (v) {
    var mR = _RGBA___get_rd__impl_(v);
    var mG = _RGBA___get_gd__impl_(v);
    var mB = _RGBA___get_bd__impl_(v);
    var mA = _RGBA___get_ad__impl_(v);
    if (((!(this.__mR === mR) ? true : !(this.__mG === mG)) ? true : !(this.__mB === mB)) ? true : !(this.__mA === mA)) {
      this.__mR = mR;
      this.__mG = mG;
      this.__mB = mB;
      this.__mA = mA;
      this._dirty = true;
    }};
  ColorTransform.prototype._get_colorMul__12t64v_k$ = function () {
    computeColors(this);
    return this.__colorMul;
  };
  ColorTransform.prototype._set_colorAdd__fii3aj_k$ = function (v) {
    this._set_aR__majfzk_k$(_ColorAdd___get_r__impl_(v));
    this._set_aG__majfzk_k$(_ColorAdd___get_g__impl_(v));
    this._set_aB__majfzk_k$(_ColorAdd___get_b__impl_(v));
    this._set_aA__majfzk_k$(_ColorAdd___get_a__impl_(v));
    if (((!(this.__aR === this._get_aR__0_k$()) ? true : !(this.__aG === this._get_aG__0_k$())) ? true : !(this.__aB === this._get_aB__0_k$())) ? true : !(this.__aA === this._get_aA__0_k$())) {
      this.__aR = this._get_aR__0_k$();
      this.__aG = this._get_aG__0_k$();
      this.__aB = this._get_aB__0_k$();
      this.__aA = this._get_aA__0_k$();
      this._dirty = true;
    }};
  ColorTransform.prototype._get_colorAdd__7hz20p_k$ = function () {
    computeColors(this);
    return this.__colorAdd;
  };
  ColorTransform.prototype._set_mR__okcceq_k$ = function (v) {
    this.__mR = v;
    this._dirty = true;
  };
  ColorTransform.prototype._get_mR__0_k$ = function () {
    return this.__mR;
  };
  ColorTransform.prototype._set_mG__okcceq_k$ = function (v) {
    this.__mG = v;
    this._dirty = true;
  };
  ColorTransform.prototype._get_mG__0_k$ = function () {
    return this.__mG;
  };
  ColorTransform.prototype._set_mB__okcceq_k$ = function (v) {
    this.__mB = v;
    this._dirty = true;
  };
  ColorTransform.prototype._get_mB__0_k$ = function () {
    return this.__mB;
  };
  ColorTransform.prototype._set_mA__okcceq_k$ = function (v) {
    this.__mA = v;
    this._dirty = true;
  };
  ColorTransform.prototype._get_mA__0_k$ = function () {
    return this.__mA;
  };
  ColorTransform.prototype._set_aR__majfzk_k$ = function (v) {
    this.__aR = v;
    this._dirty = true;
  };
  ColorTransform.prototype._get_aR__0_k$ = function () {
    return this.__aR;
  };
  ColorTransform.prototype._set_aG__majfzk_k$ = function (v) {
    this.__aG = v;
    this._dirty = true;
  };
  ColorTransform.prototype._get_aG__0_k$ = function () {
    return this.__aG;
  };
  ColorTransform.prototype._set_aB__majfzk_k$ = function (v) {
    this.__aB = v;
    this._dirty = true;
  };
  ColorTransform.prototype._get_aB__0_k$ = function () {
    return this.__aB;
  };
  ColorTransform.prototype._set_aA__majfzk_k$ = function (v) {
    this.__aA = v;
    this._dirty = true;
  };
  ColorTransform.prototype._get_aA__0_k$ = function () {
    return this.__aA;
  };
  ColorTransform.prototype.setTo_ajkz0c_k$ = function (mR, mG, mB, mA, aR, aG, aB, aA) {
    this.__mR = mR;
    this.__mG = mG;
    this.__mB = mB;
    this.__mA = mA;
    this.__aR = aR;
    this.__aG = aG;
    this.__aB = aB;
    this.__aA = aA;
    this._dirty = true;
    return this;
  };
  ColorTransform.prototype.copyFrom_33nyfb_k$ = function (t) {
    this.__mR = t.__mR;
    this.__mG = t.__mG;
    this.__mB = t.__mB;
    this.__mA = t.__mA;
    this.__aR = t.__aR;
    this.__aG = t.__aG;
    this.__aB = t.__aB;
    this.__aA = t.__aA;
    this._dirty = t._dirty;
    this.__colorAdd = t.__colorAdd;
    this.__colorMul = t.__colorMul;
    return this;
  };
  ColorTransform.prototype.setToConcat_qc4ape_k$ = function (l, r) {
    return this.setTo_ajkz0c_k$(l._get_mR__0_k$() * r._get_mR__0_k$(), l._get_mG__0_k$() * r._get_mG__0_k$(), l._get_mB__0_k$() * r._get_mB__0_k$(), l._get_mA__0_k$() * r._get_mA__0_k$(), l._get_aR__0_k$() + r._get_aR__0_k$() | 0, l._get_aG__0_k$() + r._get_aG__0_k$() | 0, l._get_aB__0_k$() + r._get_aB__0_k$() | 0, l._get_aA__0_k$() + r._get_aA__0_k$() | 0);
  };
  ColorTransform.prototype.toString = function () {
    return '' + 'ColorTransform(*[' + _get_niceStr__3(this._get_mR__0_k$()) + ', ' + _get_niceStr__3(this._get_mG__0_k$()) + ', ' + _get_niceStr__3(this._get_mB__0_k$()) + ', ' + _get_niceStr__3(this._get_mA__0_k$()) + ']+[' + this._get_aR__0_k$() + ', ' + this._get_aG__0_k$() + ', ' + this._get_aB__0_k$() + ', ' + this._get_aA__0_k$() + '])';
  };
  ColorTransform.prototype.copy_ajkz0c_k$ = function (_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA) {
    return new ColorTransform(_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA);
  };
  ColorTransform.prototype.copy$default_tv4bwa_k$ = function (_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      _mR = this.__mR;
    if (!(($mask0 & 2) === 0))
      _mG = this.__mG;
    if (!(($mask0 & 4) === 0))
      _mB = this.__mB;
    if (!(($mask0 & 8) === 0))
      _mA = this.__mA;
    if (!(($mask0 & 16) === 0))
      _aR = this.__aR;
    if (!(($mask0 & 32) === 0))
      _aG = this.__aG;
    if (!(($mask0 & 64) === 0))
      _aB = this.__aB;
    if (!(($mask0 & 128) === 0))
      _aA = this.__aA;
    return this.copy_ajkz0c_k$(_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA);
  };
  ColorTransform.prototype.hashCode = function () {
    var result = getNumberHashCode(this.__mR);
    result = imul(result, 31) + getNumberHashCode(this.__mG) | 0;
    result = imul(result, 31) + getNumberHashCode(this.__mB) | 0;
    result = imul(result, 31) + getNumberHashCode(this.__mA) | 0;
    result = imul(result, 31) + this.__aR | 0;
    result = imul(result, 31) + this.__aG | 0;
    result = imul(result, 31) + this.__aB | 0;
    result = imul(result, 31) + this.__aA | 0;
    return result;
  };
  ColorTransform.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransform))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ColorTransform ? other : THROW_CCE();
    if (!equals_1(this.__mR, tmp0_other_with_cast.__mR))
      return false;
    if (!equals_1(this.__mG, tmp0_other_with_cast.__mG))
      return false;
    if (!equals_1(this.__mB, tmp0_other_with_cast.__mB))
      return false;
    if (!equals_1(this.__mA, tmp0_other_with_cast.__mA))
      return false;
    if (!(this.__aR === tmp0_other_with_cast.__aR))
      return false;
    if (!(this.__aG === tmp0_other_with_cast.__aG))
      return false;
    if (!(this.__aB === tmp0_other_with_cast.__aB))
      return false;
    if (!(this.__aA === tmp0_other_with_cast.__aA))
      return false;
    return true;
  };
  ColorTransform.$metadata$ = {
    simpleName: 'ColorTransform',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable]
  };
  function toColorAdd(_this_) {
    var tmp0_invoke_0 = Companion_getInstance_132();
    var tmp1_invoke_0 = _RGBA___get_r__impl_(_this_);
    var tmp2_invoke_0 = _RGBA___get_g__impl_(_this_);
    var tmp3_invoke_0 = _RGBA___get_b__impl_(_this_);
    var tmp4_invoke_0 = _RGBA___get_a__impl_(_this_);
    return _ColorAdd___init__impl_(ColorAdd_pack(tmp1_invoke_0, tmp2_invoke_0, tmp3_invoke_0, tmp4_invoke_0));
  }
  function WithDefault(defaultColor) {
    this._defaultColor = defaultColor;
  }
  WithDefault.prototype.get_xr0bn6_k$ = function (str) {
    var tmp = Colors_getInstance();
    return tmp.get$default_ec4c2w_k$(str, this._defaultColor, false, 4, null);
  };
  WithDefault.$metadata$ = {
    simpleName: 'WithDefault',
    kind: 'class',
    interfaces: []
  };
  function Colors() {
    Colors_instance = this;
    this._WHITE_0 = Companion_getInstance_136().invoke_fnl2i9_k$(255, 255, 255, 255);
    this._BLACK_0 = Companion_getInstance_136().invoke_fnl2i9_k$(0, 0, 0, 255);
    this._RED_0 = Companion_getInstance_136().invoke_fnl2i9_k$(255, 0, 0, 255);
    this._GREEN_0 = Companion_getInstance_136().invoke_fnl2i9_k$(0, 255, 0, 255);
    this._BLUE_0 = Companion_getInstance_136().invoke_fnl2i9_k$(0, 0, 255, 255);
    this._TRANSPARENT_BLACK = Companion_getInstance_136().invoke_fnl2i9_k$(0, 0, 0, 0);
    this._TRANSPARENT_WHITE = Companion_getInstance_136().invoke_fnl2i9_k$(255, 255, 255, 0);
    this._ALICEBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(240, 248, 255);
    this._ANTIQUEWHITE = Companion_getInstance_136().invoke_6v5qfk_k$(250, 235, 215);
    this._AQUA = Companion_getInstance_136().invoke_6v5qfk_k$(0, 255, 255);
    this._AQUAMARINE = Companion_getInstance_136().invoke_6v5qfk_k$(127, 255, 212);
    this._AZURE = Companion_getInstance_136().invoke_6v5qfk_k$(240, 255, 255);
    this._BEIGE = Companion_getInstance_136().invoke_6v5qfk_k$(245, 245, 220);
    this._BISQUE = Companion_getInstance_136().invoke_6v5qfk_k$(255, 228, 196);
    this._BLANCHEDALMOND = Companion_getInstance_136().invoke_6v5qfk_k$(255, 235, 205);
    this._BLUEVIOLET = Companion_getInstance_136().invoke_6v5qfk_k$(138, 43, 226);
    this._BROWN = Companion_getInstance_136().invoke_6v5qfk_k$(165, 42, 42);
    this._BURLYWOOD = Companion_getInstance_136().invoke_6v5qfk_k$(222, 184, 135);
    this._CADETBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(95, 158, 160);
    this._CHARTREUSE = Companion_getInstance_136().invoke_6v5qfk_k$(127, 255, 0);
    this._CHOCOLATE = Companion_getInstance_136().invoke_6v5qfk_k$(210, 105, 30);
    this._CORAL = Companion_getInstance_136().invoke_6v5qfk_k$(255, 127, 80);
    this._CORNFLOWERBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(100, 149, 237);
    this._CORNSILK = Companion_getInstance_136().invoke_6v5qfk_k$(255, 248, 220);
    this._CRIMSON = Companion_getInstance_136().invoke_6v5qfk_k$(220, 20, 60);
    this._DARKBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(0, 0, 139);
    this._CYAN = Companion_getInstance_136().invoke_6v5qfk_k$(0, 255, 255);
    this._DARKCYAN = Companion_getInstance_136().invoke_6v5qfk_k$(0, 139, 139);
    this._DARKGOLDENROD = Companion_getInstance_136().invoke_6v5qfk_k$(184, 134, 11);
    this._DARKGRAY = Companion_getInstance_136().invoke_6v5qfk_k$(169, 169, 169);
    this._DARKGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(0, 100, 0);
    this._DARKGREY = Companion_getInstance_136().invoke_6v5qfk_k$(169, 169, 169);
    this._DARKKHAKI = Companion_getInstance_136().invoke_6v5qfk_k$(189, 183, 107);
    this._MAGENTA = Companion_getInstance_136().invoke_6v5qfk_k$(255, 0, 255);
    this._DARKMAGENTA = Companion_getInstance_136().invoke_6v5qfk_k$(139, 0, 139);
    this._DARKOLIVEGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(85, 107, 47);
    this._DARKORANGE = Companion_getInstance_136().invoke_6v5qfk_k$(255, 140, 0);
    this._DARKORCHID = Companion_getInstance_136().invoke_6v5qfk_k$(153, 50, 204);
    this._DARKRED = Companion_getInstance_136().invoke_6v5qfk_k$(139, 0, 0);
    this._DARKSALMON = Companion_getInstance_136().invoke_6v5qfk_k$(233, 150, 122);
    this._DARKSEAGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(143, 188, 143);
    this._DARKSLATEBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(72, 61, 139);
    this._DARKSLATEGRAY = Companion_getInstance_136().invoke_6v5qfk_k$(47, 79, 79);
    this._DARKSLATEGREY = Companion_getInstance_136().invoke_6v5qfk_k$(47, 79, 79);
    this._DARKTURQUOISE = Companion_getInstance_136().invoke_6v5qfk_k$(0, 206, 209);
    this._DARKVIOLET = Companion_getInstance_136().invoke_6v5qfk_k$(148, 0, 211);
    this._DEEPPINK = Companion_getInstance_136().invoke_6v5qfk_k$(255, 20, 147);
    this._DEEPSKYBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(0, 191, 255);
    this._DIMGRAY = Companion_getInstance_136().invoke_6v5qfk_k$(105, 105, 105);
    this._DIMGREY = Companion_getInstance_136().invoke_6v5qfk_k$(105, 105, 105);
    this._DODGERBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(30, 144, 255);
    this._FIREBRICK = Companion_getInstance_136().invoke_6v5qfk_k$(178, 34, 34);
    this._FLORALWHITE = Companion_getInstance_136().invoke_6v5qfk_k$(255, 250, 240);
    this._FORESTGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(34, 139, 34);
    this._FUCHSIA = Companion_getInstance_136().invoke_6v5qfk_k$(255, 0, 255);
    this._GAINSBORO = Companion_getInstance_136().invoke_6v5qfk_k$(220, 220, 220);
    this._GHOSTWHITE = Companion_getInstance_136().invoke_6v5qfk_k$(248, 248, 255);
    this._GOLD = Companion_getInstance_136().invoke_6v5qfk_k$(255, 215, 0);
    this._GOLDENROD = Companion_getInstance_136().invoke_6v5qfk_k$(218, 165, 32);
    this._GREENYELLOW = Companion_getInstance_136().invoke_6v5qfk_k$(173, 255, 47);
    this._HONEYDEW = Companion_getInstance_136().invoke_6v5qfk_k$(240, 255, 240);
    this._HOTPINK = Companion_getInstance_136().invoke_6v5qfk_k$(255, 105, 180);
    this._INDIANRED = Companion_getInstance_136().invoke_6v5qfk_k$(205, 92, 92);
    this._INDIGO = Companion_getInstance_136().invoke_6v5qfk_k$(75, 0, 130);
    this._IVORY = Companion_getInstance_136().invoke_6v5qfk_k$(255, 255, 240);
    this._KHAKI = Companion_getInstance_136().invoke_6v5qfk_k$(240, 230, 140);
    this._LAVENDER = Companion_getInstance_136().invoke_6v5qfk_k$(230, 230, 250);
    this._LAVENDERBLUSH = Companion_getInstance_136().invoke_6v5qfk_k$(255, 240, 245);
    this._LAWNGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(124, 252, 0);
    this._LEMONCHIFFON = Companion_getInstance_136().invoke_6v5qfk_k$(255, 250, 205);
    this._LIGHTBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(173, 216, 230);
    this._LIGHTCORAL = Companion_getInstance_136().invoke_6v5qfk_k$(240, 128, 128);
    this._LIGHTCYAN = Companion_getInstance_136().invoke_6v5qfk_k$(224, 255, 255);
    this._LIGHTGOLDENRODYELLOW = Companion_getInstance_136().invoke_6v5qfk_k$(250, 250, 210);
    this._LIGHTGRAY = Companion_getInstance_136().invoke_6v5qfk_k$(211, 211, 211);
    this._LIGHTGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(144, 238, 144);
    this._LIGHTGREY = Companion_getInstance_136().invoke_6v5qfk_k$(211, 211, 211);
    this._LIGHTPINK = Companion_getInstance_136().invoke_6v5qfk_k$(255, 182, 193);
    this._LIGHTSALMON = Companion_getInstance_136().invoke_6v5qfk_k$(255, 160, 122);
    this._LIGHTSEAGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(32, 178, 170);
    this._LIGHTSKYBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(135, 206, 250);
    this._LIGHTSLATEGRAY = Companion_getInstance_136().invoke_6v5qfk_k$(119, 136, 153);
    this._LIGHTSLATEGREY = Companion_getInstance_136().invoke_6v5qfk_k$(119, 136, 153);
    this._LIGHTSTEELBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(176, 196, 222);
    this._LIGHTYELLOW = Companion_getInstance_136().invoke_6v5qfk_k$(255, 255, 224);
    this._LIME = Companion_getInstance_136().invoke_6v5qfk_k$(0, 255, 0);
    this._LIMEGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(50, 205, 50);
    this._LINEN = Companion_getInstance_136().invoke_6v5qfk_k$(250, 240, 230);
    this._MAROON = Companion_getInstance_136().invoke_6v5qfk_k$(128, 0, 0);
    this._MEDIUMAQUAMARINE = Companion_getInstance_136().invoke_6v5qfk_k$(102, 205, 170);
    this._MEDIUMBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(0, 0, 205);
    this._MEDIUMORCHID = Companion_getInstance_136().invoke_6v5qfk_k$(186, 85, 211);
    this._MEDIUMPURPLE = Companion_getInstance_136().invoke_6v5qfk_k$(147, 112, 219);
    this._MEDIUMSEAGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(60, 179, 113);
    this._MEDIUMSLATEBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(123, 104, 238);
    this._MEDIUMSPRINGGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(0, 250, 154);
    this._MEDIUMTURQUOISE = Companion_getInstance_136().invoke_6v5qfk_k$(72, 209, 204);
    this._MEDIUMVIOLETRED = Companion_getInstance_136().invoke_6v5qfk_k$(199, 21, 133);
    this._MIDNIGHTBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(25, 25, 112);
    this._MINTCREAM = Companion_getInstance_136().invoke_6v5qfk_k$(245, 255, 250);
    this._MISTYROSE = Companion_getInstance_136().invoke_6v5qfk_k$(255, 228, 225);
    this._MOCCASIN = Companion_getInstance_136().invoke_6v5qfk_k$(255, 228, 181);
    this._NAVAJOWHITE = Companion_getInstance_136().invoke_6v5qfk_k$(255, 222, 173);
    this._NAVY = Companion_getInstance_136().invoke_6v5qfk_k$(0, 0, 128);
    this._OLDLACE = Companion_getInstance_136().invoke_6v5qfk_k$(253, 245, 230);
    this._OLIVE = Companion_getInstance_136().invoke_6v5qfk_k$(128, 128, 0);
    this._OLIVEDRAB = Companion_getInstance_136().invoke_6v5qfk_k$(107, 142, 35);
    this._ORANGE = Companion_getInstance_136().invoke_6v5qfk_k$(255, 165, 0);
    this._ORANGERED = Companion_getInstance_136().invoke_6v5qfk_k$(255, 69, 0);
    this._ORCHID = Companion_getInstance_136().invoke_6v5qfk_k$(218, 112, 214);
    this._PALEGOLDENROD = Companion_getInstance_136().invoke_6v5qfk_k$(238, 232, 170);
    this._PALEGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(152, 251, 152);
    this._PALETURQUOISE = Companion_getInstance_136().invoke_6v5qfk_k$(175, 238, 238);
    this._PALEVIOLETRED = Companion_getInstance_136().invoke_6v5qfk_k$(219, 112, 147);
    this._PAPAYAWHIP = Companion_getInstance_136().invoke_6v5qfk_k$(255, 239, 213);
    this._PEACHPUFF = Companion_getInstance_136().invoke_6v5qfk_k$(255, 218, 185);
    this._PERU = Companion_getInstance_136().invoke_6v5qfk_k$(205, 133, 63);
    this._PINK = Companion_getInstance_136().invoke_6v5qfk_k$(255, 192, 203);
    this._PLUM = Companion_getInstance_136().invoke_6v5qfk_k$(221, 160, 221);
    this._POWDERBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(176, 224, 230);
    this._PURPLE = Companion_getInstance_136().invoke_6v5qfk_k$(128, 0, 128);
    this._ROSYBROWN = Companion_getInstance_136().invoke_6v5qfk_k$(188, 143, 143);
    this._ROYALBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(65, 105, 225);
    this._SADDLEBROWN = Companion_getInstance_136().invoke_6v5qfk_k$(139, 69, 19);
    this._SALMON = Companion_getInstance_136().invoke_6v5qfk_k$(250, 128, 114);
    this._SANDYBROWN = Companion_getInstance_136().invoke_6v5qfk_k$(244, 164, 96);
    this._SEAGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(46, 139, 87);
    this._SEASHELL = Companion_getInstance_136().invoke_6v5qfk_k$(255, 245, 238);
    this._SIENNA = Companion_getInstance_136().invoke_6v5qfk_k$(160, 82, 45);
    this._SILVER = Companion_getInstance_136().invoke_6v5qfk_k$(192, 192, 192);
    this._SKYBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(135, 206, 235);
    this._SLATEBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(106, 90, 205);
    this._SLATEGRAY = Companion_getInstance_136().invoke_6v5qfk_k$(112, 128, 144);
    this._SLATEGREY = Companion_getInstance_136().invoke_6v5qfk_k$(112, 128, 144);
    this._SNOW = Companion_getInstance_136().invoke_6v5qfk_k$(255, 250, 250);
    this._SPRINGGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(0, 255, 127);
    this._STEELBLUE = Companion_getInstance_136().invoke_6v5qfk_k$(70, 130, 180);
    this._TAN = Companion_getInstance_136().invoke_6v5qfk_k$(210, 180, 140);
    this._TEAL = Companion_getInstance_136().invoke_6v5qfk_k$(0, 128, 128);
    this._THISTLE = Companion_getInstance_136().invoke_6v5qfk_k$(216, 191, 216);
    this._TOMATO = Companion_getInstance_136().invoke_6v5qfk_k$(255, 99, 71);
    this._TURQUOISE = Companion_getInstance_136().invoke_6v5qfk_k$(64, 224, 208);
    this._VIOLET = Companion_getInstance_136().invoke_6v5qfk_k$(238, 130, 238);
    this._WHEAT = Companion_getInstance_136().invoke_6v5qfk_k$(245, 222, 179);
    this._WHITESMOKE = Companion_getInstance_136().invoke_6v5qfk_k$(245, 245, 245);
    this._YELLOWGREEN = Companion_getInstance_136().invoke_6v5qfk_k$(154, 205, 50);
    this._YELLOW = Companion_getInstance_136().invoke_6v5qfk_k$(255, 255, 0);
    this._colorsByName = mapOf([to('black', new RGBA(this._BLACK_0)), to('white', new RGBA(this._WHITE_0)), to('red', new RGBA(this._RED_0)), to('green', new RGBA(this._GREEN_0)), to('blue', new RGBA(this._BLUE_0)), to('aliceblue', new RGBA(this._ALICEBLUE)), to('antiquewhite', new RGBA(this._ANTIQUEWHITE)), to('aqua', new RGBA(this._AQUA)), to('aquamarine', new RGBA(this._AQUAMARINE)), to('azure', new RGBA(this._AZURE)), to('beige', new RGBA(this._BEIGE)), to('bisque', new RGBA(this._BISQUE)), to('blanchedalmond', new RGBA(this._BLANCHEDALMOND)), to('blueviolet', new RGBA(this._BLUEVIOLET)), to('brown', new RGBA(this._BROWN)), to('burlywood', new RGBA(this._BURLYWOOD)), to('cadetblue', new RGBA(this._CADETBLUE)), to('chartreuse', new RGBA(this._CHARTREUSE)), to('chocolate', new RGBA(this._CHOCOLATE)), to('coral', new RGBA(this._CORAL)), to('cornflowerblue', new RGBA(this._CORNFLOWERBLUE)), to('cornsilk', new RGBA(this._CORNSILK)), to('crimson', new RGBA(this._CRIMSON)), to('darkblue', new RGBA(this._DARKBLUE)), to('darkcyan', new RGBA(this._DARKCYAN)), to('darkgoldenrod', new RGBA(this._DARKGOLDENROD)), to('darkgray', new RGBA(this._DARKGRAY)), to('darkgreen', new RGBA(this._DARKGREEN)), to('darkgrey', new RGBA(this._DARKGREY)), to('darkkhaki', new RGBA(this._DARKKHAKI)), to('darkmagenta', new RGBA(this._DARKMAGENTA)), to('darkolivegreen', new RGBA(this._DARKOLIVEGREEN)), to('darkorange', new RGBA(this._DARKORANGE)), to('darkorchid', new RGBA(this._DARKORCHID)), to('darkred', new RGBA(this._DARKRED)), to('darksalmon', new RGBA(this._DARKSALMON)), to('darkseagreen', new RGBA(this._DARKSEAGREEN)), to('darkslateblue', new RGBA(this._DARKSLATEBLUE)), to('darkslategray', new RGBA(this._DARKSLATEGRAY)), to('darkslategrey', new RGBA(this._DARKSLATEGREY)), to('darkturquoise', new RGBA(this._DARKTURQUOISE)), to('darkviolet', new RGBA(this._DARKVIOLET)), to('deeppink', new RGBA(this._DEEPPINK)), to('deepskyblue', new RGBA(this._DEEPSKYBLUE)), to('dimgray', new RGBA(this._DIMGRAY)), to('dimgrey', new RGBA(this._DIMGREY)), to('dodgerblue', new RGBA(this._DODGERBLUE)), to('firebrick', new RGBA(this._FIREBRICK)), to('floralwhite', new RGBA(this._FLORALWHITE)), to('forestgreen', new RGBA(this._FORESTGREEN)), to('fuchsia', new RGBA(this._FUCHSIA)), to('gainsboro', new RGBA(this._GAINSBORO)), to('ghostwhite', new RGBA(this._GHOSTWHITE)), to('gold', new RGBA(this._GOLD)), to('goldenrod', new RGBA(this._GOLDENROD)), to('greenyellow', new RGBA(this._GREENYELLOW)), to('honeydew', new RGBA(this._HONEYDEW)), to('hotpink', new RGBA(this._HOTPINK)), to('indianred', new RGBA(this._INDIANRED)), to('indigo', new RGBA(this._INDIGO)), to('ivory', new RGBA(this._IVORY)), to('khaki', new RGBA(this._KHAKI)), to('lavender', new RGBA(this._LAVENDER)), to('lavenderblush', new RGBA(this._LAVENDERBLUSH)), to('lawngreen', new RGBA(this._LAWNGREEN)), to('lemonchiffon', new RGBA(this._LEMONCHIFFON)), to('lightblue', new RGBA(this._LIGHTBLUE)), to('lightcoral', new RGBA(this._LIGHTCORAL)), to('lightcyan', new RGBA(this._LIGHTCYAN)), to('lightgoldenrodyellow', new RGBA(this._LIGHTGOLDENRODYELLOW)), to('lightgray', new RGBA(this._LIGHTGRAY)), to('lightgreen', new RGBA(this._LIGHTGREEN)), to('lightgrey', new RGBA(this._LIGHTGREY)), to('lightpink', new RGBA(this._LIGHTPINK)), to('lightsalmon', new RGBA(this._LIGHTSALMON)), to('lightseagreen', new RGBA(this._LIGHTSEAGREEN)), to('lightskyblue', new RGBA(this._LIGHTSKYBLUE)), to('lightslategray', new RGBA(this._LIGHTSLATEGRAY)), to('lightslategrey', new RGBA(this._LIGHTSLATEGREY)), to('lightsteelblue', new RGBA(this._LIGHTSTEELBLUE)), to('lightyellow', new RGBA(this._LIGHTYELLOW)), to('lime', new RGBA(this._LIME)), to('limegreen', new RGBA(this._LIMEGREEN)), to('linen', new RGBA(this._LINEN)), to('maroon', new RGBA(this._MAROON)), to('mediumaquamarine', new RGBA(this._MEDIUMAQUAMARINE)), to('mediumblue', new RGBA(this._MEDIUMBLUE)), to('mediumorchid', new RGBA(this._MEDIUMORCHID)), to('mediumpurple', new RGBA(this._MEDIUMPURPLE)), to('mediumseagreen', new RGBA(this._MEDIUMSEAGREEN)), to('mediumslateblue', new RGBA(this._MEDIUMSLATEBLUE)), to('mediumspringgreen', new RGBA(this._MEDIUMSPRINGGREEN)), to('mediumturquoise', new RGBA(this._MEDIUMTURQUOISE)), to('mediumvioletred', new RGBA(this._MEDIUMVIOLETRED)), to('midnightblue', new RGBA(this._MIDNIGHTBLUE)), to('mintcream', new RGBA(this._MINTCREAM)), to('mistyrose', new RGBA(this._MISTYROSE)), to('moccasin', new RGBA(this._MOCCASIN)), to('navajowhite', new RGBA(this._NAVAJOWHITE)), to('navy', new RGBA(this._NAVY)), to('oldlace', new RGBA(this._OLDLACE)), to('olive', new RGBA(this._OLIVE)), to('olivedrab', new RGBA(this._OLIVEDRAB)), to('orange', new RGBA(this._ORANGE)), to('orangered', new RGBA(this._ORANGERED)), to('orchid', new RGBA(this._ORCHID)), to('palegoldenrod', new RGBA(this._PALEGOLDENROD)), to('palegreen', new RGBA(this._PALEGREEN)), to('paleturquoise', new RGBA(this._PALETURQUOISE)), to('palevioletred', new RGBA(this._PALEVIOLETRED)), to('papayawhip', new RGBA(this._PAPAYAWHIP)), to('peachpuff', new RGBA(this._PEACHPUFF)), to('peru', new RGBA(this._PERU)), to('pink', new RGBA(this._PINK)), to('plum', new RGBA(this._PLUM)), to('powderblue', new RGBA(this._POWDERBLUE)), to('purple', new RGBA(this._PURPLE)), to('rosybrown', new RGBA(this._ROSYBROWN)), to('royalblue', new RGBA(this._ROYALBLUE)), to('saddlebrown', new RGBA(this._SADDLEBROWN)), to('salmon', new RGBA(this._SALMON)), to('sandybrown', new RGBA(this._SANDYBROWN)), to('seagreen', new RGBA(this._SEAGREEN)), to('seashell', new RGBA(this._SEASHELL)), to('sienna', new RGBA(this._SIENNA)), to('silver', new RGBA(this._SILVER)), to('skyblue', new RGBA(this._SKYBLUE)), to('slateblue', new RGBA(this._SLATEBLUE)), to('slategray', new RGBA(this._SLATEGRAY)), to('slategrey', new RGBA(this._SLATEGREY)), to('snow', new RGBA(this._SNOW)), to('springgreen', new RGBA(this._SPRINGGREEN)), to('steelblue', new RGBA(this._STEELBLUE)), to('tan', new RGBA(this._TAN)), to('teal', new RGBA(this._TEAL)), to('thistle', new RGBA(this._THISTLE)), to('tomato', new RGBA(this._TOMATO)), to('turquoise', new RGBA(this._TURQUOISE)), to('violet', new RGBA(this._VIOLET)), to('wheat', new RGBA(this._WHEAT)), to('whitesmoke', new RGBA(this._WHITESMOKE)), to('yellowgreen', new RGBA(this._YELLOWGREEN)), to('yellow', new RGBA(this._YELLOW))]);
  }
  Colors.prototype.get_xr0bn6_k$ = function (str) {
    return this.get_h7esko_k$(str, Colors_getInstance()._TRANSPARENT_BLACK, true);
  };
  Colors.prototype.get_h7esko_k$ = function (str, default_0, errorOnDefault) {
    try {
      if (startsWith$default_1(str, '#', false, 2, null)) {
        var hex = substr_1(str, 1);
        if (!setOf([3, 4, 6, 8]).contains_2bq_k$(hex.length))
          return this._BLACK_0;
        var chars = hex.length < 6 ? 1 : 2;
        var scale_1 = hex.length < 6 ? 17.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt_0(substr_0(hex, imul(0, chars), chars), 16) * scale_1);
        var g = numberToInt(toInt_0(substr_0(hex, imul(1, chars), chars), 16) * scale_1);
        var b = numberToInt(toInt_0(substr_0(hex, imul(2, chars), chars), 16) * scale_1);
        var a = hasAlpha ? numberToInt(toInt_0(substr_0(hex, imul(3, chars), chars), 16) * scale_1) : 255;
        return Companion_getInstance_136().invoke_fnl2i9_k$(r, g, b, a);
      } else {
        if (startsWith_1(str, 'RGBA(', true)) {
          var tmp = removeSuffix(removePrefix(str.toUpperCase(), 'RGBA('), ')');
          var parts_0 = split$default_0(tmp, [','], false, 0, 6, null);
          var tmp_0;
          if (0 <= _get_lastIndex__4(parts_0)) {
            tmp_0 = parts_0.get_ha5a7z_k$(0);
          } else {
            tmp_0 = '0';
          }
          var tmp0_elvis_lhs = toIntOrNull(tmp_0);
          var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          var tmp_1;
          if (1 <= _get_lastIndex__4(parts_0)) {
            tmp_1 = parts_0.get_ha5a7z_k$(1);
          } else {
            tmp_1 = '0';
          }
          var tmp1_elvis_lhs = toIntOrNull(tmp_1);
          var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
          var tmp_2;
          if (2 <= _get_lastIndex__4(parts_0)) {
            tmp_2 = parts_0.get_ha5a7z_k$(2);
          } else {
            tmp_2 = '0';
          }
          var tmp2_elvis_lhs = toIntOrNull(tmp_2);
          var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
          var tmp_3;
          if (3 <= _get_lastIndex__4(parts_0)) {
            tmp_3 = parts_0.get_ha5a7z_k$(3);
          } else {
            tmp_3 = '1.0';
          }
          var tmp3_elvis_lhs = toDoubleOrNull(tmp_3);
          var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
          return Companion_getInstance_136().invoke_fnl2i9_k$(r_0, g_0, b_0, numberToInt(af * 255));
        } else {
          {
            var tmp_4 = this._colorsByName.get_2bw_k$(str.toLowerCase());
            var col = tmp_4 == null ? null : tmp_4._value_19;
            var tmp_5;
            var tmp_6 = col;
            if ((tmp_6 == null ? null : new RGBA(tmp_6)) == null) {
              tmp_5 = errorOnDefault;
            } else {
              {
                tmp_5 = false;
              }
            }
            if (tmp_5) {
              var tmp_7 = '' + '#' + str;
              return this.get$default_ec4c2w_k$(tmp_7, default_0, false, 4, null);
            } else {
            }
            var tmp4_elvis_lhs = col;
            var tmp_8;
            var tmp_9 = tmp4_elvis_lhs;
            if ((tmp_9 == null ? null : new RGBA(tmp_9)) == null) {
              tmp_8 = default_0;
            } else {
              {
                tmp_8 = tmp4_elvis_lhs;
              }
            }
            return tmp_8;
          }
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        printStackTrace_0($p);
        return Colors_getInstance()._RED_0;
      } else {
        {
          throw $p;
        }
      }
    }
  };
  Colors.prototype.get$default_ec4c2w_k$ = function (str, default_0, errorOnDefault, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      errorOnDefault = false;
    return this.get_h7esko_k$(str, default_0, errorOnDefault);
  };
  Colors.$metadata$ = {
    simpleName: 'Colors',
    kind: 'object',
    interfaces: []
  };
  var Colors_instance;
  function Colors_getInstance() {
    if (Colors_instance == null)
      new Colors();
    return Colors_instance;
  }
  function Companion_135() {
    Companion_instance_134 = this;
    RGB.call(this, 0, 8, 16);
  }
  Companion_135.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_134;
  function Companion_getInstance_134() {
    if (Companion_instance_134 == null)
      new Companion_135();
    return Companion_instance_134;
  }
  function RGB(rOffset, gOffset, bOffset) {
    Companion_getInstance_134();
    ColorFormat24.call(this);
    this._rOffset_0 = rOffset;
    this._gOffset_0 = gOffset;
    this._bOffset_0 = bOffset;
  }
  RGB.prototype.getR_ha5a7z_k$ = function (v) {
    return extract8(v, this._rOffset_0);
  };
  RGB.prototype.getG_ha5a7z_k$ = function (v) {
    return extract8(v, this._gOffset_0);
  };
  RGB.prototype.getB_ha5a7z_k$ = function (v) {
    return extract8(v, this._bOffset_0);
  };
  RGB.prototype.getA_ha5a7z_k$ = function (v) {
    return 255;
  };
  RGB.prototype.pack_w0xdj4_k$ = function (r, g, b, a) {
    return insert8(insert8(insert8(0, r, this._rOffset_0), g, this._gOffset_0), b, this._bOffset_0);
  };
  RGB.$metadata$ = {
    simpleName: 'RGB',
    kind: 'class',
    interfaces: []
  };
  function BGR() {
    BGR_instance = this;
    RGB.call(this, 16, 8, 0);
  }
  BGR.$metadata$ = {
    simpleName: 'BGR',
    kind: 'object',
    interfaces: []
  };
  var BGR_instance;
  function BGR_getInstance() {
    if (BGR_instance == null)
      new BGR();
    return BGR_instance;
  }
  function _RgbaArray___init__impl_(ints) {
    return ints;
  }
  function _RgbaArray___get_ints__impl_(this_0) {
    return this_0;
  }
  function Companion_136() {
    Companion_instance_135 = this;
  }
  Companion_136.prototype.invoke_spsmd3_k$ = function (size_2) {
    return _RgbaArray___init__impl_(new Int32Array(size_2));
  };
  Companion_136.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_135;
  function Companion_getInstance_135() {
    if (Companion_instance_135 == null)
      new Companion_136();
    return Companion_instance_135;
  }
  function RgbaArray__contains_impl(this_0, element) {
    return contains(_RgbaArray___get_ints__impl_(this_0), _RGBA___get_value__impl_(element));
  }
  function RgbaArray__contains_impl_0(this_0, element) {
    if (!(element instanceof RGBA))
      return false;
    else {
    }
    var tmp = this_0._ints;
    return RgbaArray__contains_impl(tmp, element instanceof RGBA ? element._value_19 : THROW_CCE());
  }
  function RgbaArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$()._value_19;
        if (!RgbaArray__contains_impl(this_0, element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function RgbaArray__containsAll_impl_0(this_0, elements) {
    return RgbaArray__containsAll_impl(this_0._ints, elements);
  }
  function RgbaArray__indexOf_impl(this_0, element) {
    return indexOf_0(_RgbaArray___get_ints__impl_(this_0), _RGBA___get_value__impl_(element));
  }
  function RgbaArray__indexOf_impl_0(this_0, element) {
    if (!(element instanceof RGBA))
      return -1;
    else {
    }
    var tmp = this_0._ints;
    return RgbaArray__indexOf_impl(tmp, element instanceof RGBA ? element._value_19 : THROW_CCE());
  }
  function RgbaArray__isEmpty_impl(this_0) {
    var tmp0_isEmpty_0 = _RgbaArray___get_ints__impl_(this_0);
    return tmp0_isEmpty_0.length === 0;
  }
  function RgbaArray__iterator_impl(this_0) {
    return RgbaArray__listIterator_impl(this_0, 0);
  }
  function RgbaArray__listIterator_impl(this_0, index_0) {
    return new GenericListIterator(new RgbaArray(this_0), index_0);
  }
  function _RgbaArray___get_size__impl_(this_0) {
    return _RgbaArray___get_ints__impl_(this_0).length;
  }
  function RgbaArray__get_impl(this_0, index_0) {
    return _RGBA___init__impl_(_RgbaArray___get_ints__impl_(this_0)[index_0]);
  }
  function RgbaArray__get_impl_0(this_0, index_0) {
    return new RGBA(RgbaArray__get_impl(this_0._ints, index_0));
  }
  function RgbaArray__set_impl(this_0, index_0, color_0) {
    return _RgbaArray___get_ints__impl_(this_0)[index_0] = _RGBA___get_value__impl_(color_0);
  }
  function RgbaArray__fill_impl(this_0, value, start, end) {
    var tmp0_fill_0 = _RgbaArray___get_ints__impl_(this_0);
    var tmp1_fill_0 = _RGBA___get_value__impl_(value);
    return fill_0(tmp0_fill_0, tmp1_fill_0, start, end);
  }
  function RgbaArray__fill$default_impl(this_0, value, start, end, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      start = 0;
    if (!(($mask0 & 4) === 0))
      end = _RgbaArray___get_size__impl_(this_0);
    return RgbaArray__fill_impl(this_0, value, start, end);
  }
  function RgbaArray__toString_impl(this_0) {
    return '' + 'RgbaArray(' + _RgbaArray___get_size__impl_(this_0) + ')';
  }
  function RgbaArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function RgbaArray__equals_impl(this_0, other) {
    if (!(other instanceof RgbaArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RgbaArray ? other._ints : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function RgbaArray(ints) {
    Companion_getInstance_135();
    this._ints = ints;
  }
  RgbaArray.prototype.contains_mpdz1q_k$ = function (element) {
    return RgbaArray__contains_impl(this._ints, element);
  };
  RgbaArray.prototype.contains_2bq_k$ = function (element) {
    return RgbaArray__contains_impl_0(this, element);
  };
  RgbaArray.prototype.containsAll_qcv5i4_k$ = function (elements) {
    return RgbaArray__containsAll_impl(this._ints, elements);
  };
  RgbaArray.prototype.containsAll_dxd4eo_k$ = function (elements) {
    return RgbaArray__containsAll_impl_0(this, elements);
  };
  RgbaArray.prototype.indexOf_mpdz1q_k$ = function (element) {
    return RgbaArray__indexOf_impl(this._ints, element);
  };
  RgbaArray.prototype.indexOf_2bq_k$ = function (element) {
    return RgbaArray__indexOf_impl_0(this, element);
  };
  RgbaArray.prototype.isEmpty_0_k$ = function () {
    return RgbaArray__isEmpty_impl(this._ints);
  };
  RgbaArray.prototype.iterator_0_k$ = function () {
    return RgbaArray__iterator_impl(this._ints);
  };
  RgbaArray.prototype.listIterator_ha5a7z_k$ = function (index_0) {
    return RgbaArray__listIterator_impl(this._ints, index_0);
  };
  RgbaArray.prototype._get_size__0_k$ = function () {
    return _RgbaArray___get_size__impl_(this._ints);
  };
  RgbaArray.prototype.get_kxqjbk_k$ = function (index_0) {
    return RgbaArray__get_impl(this._ints, index_0);
  };
  RgbaArray.prototype.get_ha5a7z_k$ = function (index_0) {
    return RgbaArray__get_impl_0(this, index_0);
  };
  RgbaArray.prototype.toString = function () {
    return RgbaArray__toString_impl(this._ints);
  };
  RgbaArray.prototype.hashCode = function () {
    return RgbaArray__hashCode_impl(this._ints);
  };
  RgbaArray.prototype.equals = function (other) {
    return RgbaArray__equals_impl(this._ints, other);
  };
  RgbaArray.$metadata$ = {
    simpleName: 'RgbaArray',
    kind: 'class',
    interfaces: [List]
  };
  function blendComponent($this, c1, c2, factor) {
    return numberToInt(c1 * (1.0 - factor) + c2 * factor) & 255;
  }
  function _RGBA___init__impl_(value) {
    return value;
  }
  function _RGBA___get_value__impl_(this_0) {
    return this_0;
  }
  function RGBA__transformed_impl(this_0, m) {
    return new RGBA(this_0);
  }
  function _RGBA___get_color__impl_(this_0) {
    return this_0;
  }
  function _RGBA___get_r__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) >>> 0 & 255;
  }
  function _RGBA___get_g__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) >>> 8 & 255;
  }
  function _RGBA___get_b__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) >>> 16 & 255;
  }
  function _RGBA___get_a__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) >>> 24 & 255;
  }
  function _RGBA___get_rf__impl_(this_0) {
    return _RGBA___get_r__impl_(this_0) / 255.0;
  }
  function _RGBA___get_gf__impl_(this_0) {
    return _RGBA___get_g__impl_(this_0) / 255.0;
  }
  function _RGBA___get_bf__impl_(this_0) {
    return _RGBA___get_b__impl_(this_0) / 255.0;
  }
  function _RGBA___get_af__impl_(this_0) {
    return _RGBA___get_a__impl_(this_0) / 255.0;
  }
  function _RGBA___get_rd__impl_(this_0) {
    return _RGBA___get_r__impl_(this_0) / 255.0;
  }
  function _RGBA___get_gd__impl_(this_0) {
    return _RGBA___get_g__impl_(this_0) / 255.0;
  }
  function _RGBA___get_bd__impl_(this_0) {
    return _RGBA___get_b__impl_(this_0) / 255.0;
  }
  function _RGBA___get_ad__impl_(this_0) {
    return _RGBA___get_a__impl_(this_0) / 255.0;
  }
  function _RGBA___get_rgb__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) & 16777215;
  }
  function RGBA__withA_impl(this_0, v) {
    return _RGBA___init__impl_(_RGBA___get_value__impl_(this_0) & 16777215 | (v & 255) << 24);
  }
  function RGBA__withAd_impl(this_0, v) {
    return RGBA__withA_impl(this_0, d2i(v));
  }
  function RGBA__withAf_impl(this_0, v) {
    return RGBA__withA_impl(this_0, f2i(v));
  }
  function _RGBA___get_hexString__impl_(this_0) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_wi8o78_k$(new Char(35));
    Unit_getInstance();
    appendHexByte(tmp0_apply_0_1, _RGBA___get_r__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_g__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_b__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_a__impl_(this_0));
    return tmp0_apply_0_1.toString();
  }
  function _RGBA___get_hexStringNoAlpha__impl_(this_0) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_wi8o78_k$(new Char(35));
    Unit_getInstance();
    appendHexByte(tmp0_apply_0_1, _RGBA___get_r__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_g__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_b__impl_(this_0));
    return tmp0_apply_0_1.toString();
  }
  function _RGBA___get_htmlColor__impl_(this_0) {
    return '' + 'rgba(' + _RGBA___get_r__impl_(this_0) + ', ' + _RGBA___get_g__impl_(this_0) + ', ' + _RGBA___get_b__impl_(this_0) + ', ' + _get_niceStr__2(_RGBA___get_af__impl_(this_0)) + ')';
  }
  function _RGBA___get_htmlStringSimple__impl_(this_0) {
    return _RGBA___get_hexStringNoAlpha__impl_(this_0);
  }
  function RGBA__toString_impl(this_0) {
    return _RGBA___get_hexString__impl_(this_0);
  }
  function RGBA__compareTo_impl(this_0, other) {
    return compareTo(_RGBA___get_value__impl_(this_0), _RGBA___get_value__impl_(other));
  }
  function RGBA__compareTo_impl_0(this_0, other) {
    var tmp = this_0._value_19;
    return RGBA__compareTo_impl(tmp, other instanceof RGBA ? other._value_19 : THROW_CCE());
  }
  function _RGBA___get_premultiplied__impl_(this_0) {
    var A = _RGBA___get_a__impl_(this_0) + 1 | 0;
    var RB = imul(_RGBA___get_value__impl_(this_0) & 16711935, A) >>> 8 & 16711935;
    var G = imul(_RGBA___get_value__impl_(this_0) & 65280, A) >>> 8 & 65280;
    return _RGBAPremultiplied___init__impl_(_RGBA___get_value__impl_(this_0) & -16777216 | RB | G);
  }
  function RGBA__times_impl(this_0, other) {
    return Companion_getInstance_136().multiply_5llkhf_k$(this_0, other);
  }
  function Companion_137() {
    Companion_instance_136 = this;
    ColorFormat32.call(this);
  }
  Companion_137.prototype.float_cz83z_k$ = function (r, g, b, a) {
    return this.unclamped_fnl2i9_k$(f2i(r), f2i(g), f2i(b), f2i(a));
  };
  Companion_137.prototype.unclamped_fnl2i9_k$ = function (r, g, b, a) {
    return _RGBA___init__impl_(packIntUnchecked(r, g, b, a));
  };
  Companion_137.prototype.invoke_fnl2i9_k$ = function (r, g, b, a) {
    return _RGBA___init__impl_(packIntClamped(r, g, b, a));
  };
  Companion_137.prototype.invoke_6v5qfk_k$ = function (r, g, b) {
    return _RGBA___init__impl_(packIntClamped(r, g, b, 255));
  };
  Companion_137.prototype.invoke_aewswh_k$ = function (rgb, a) {
    return _RGBA___init__impl_(rgb & 16777215 | a << 24);
  };
  Companion_137.prototype.invoke_abrt0h_k$ = function (rgba) {
    return rgba;
  };
  Companion_137.prototype.getR_ha5a7z_k$ = function (v) {
    return _RGBA___get_r__impl_(_RGBA___init__impl_(v));
  };
  Companion_137.prototype.getG_ha5a7z_k$ = function (v) {
    return _RGBA___get_g__impl_(_RGBA___init__impl_(v));
  };
  Companion_137.prototype.getB_ha5a7z_k$ = function (v) {
    return _RGBA___get_b__impl_(_RGBA___init__impl_(v));
  };
  Companion_137.prototype.getA_ha5a7z_k$ = function (v) {
    return _RGBA___get_a__impl_(_RGBA___init__impl_(v));
  };
  Companion_137.prototype.pack_w0xdj4_k$ = function (r, g, b, a) {
    return _RGBA___get_value__impl_(Companion_getInstance_136().invoke_fnl2i9_k$(r, g, b, a));
  };
  Companion_137.prototype.mixRgbFactor256_s4p3o4_k$ = function (c1, c2, factor256) {
    return _RGBA___init__impl_(this.mixRgbFactor256_fcwjfj_k$(_RGBA___get_value__impl_(c1), _RGBA___get_value__impl_(c2), factor256));
  };
  Companion_137.prototype.mixRgbFactor256_fcwjfj_k$ = function (c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8;
  };
  Companion_137.prototype.mixRgb_8z8h9u_k$ = function (c1, c2, factor) {
    return this.mixRgbFactor256_s4p3o4_k$(c1, c2, numberToInt(factor * 256));
  };
  Companion_137.prototype.mixRgba_8z8h9u_k$ = function (c1, c2, factor) {
    return Companion_getInstance_136().invoke_aewswh_k$(_RGBA___get_rgb__impl_(this.mixRgb_8z8h9u_k$(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl_(c1), _RGBA___get_a__impl_(c2), factor));
  };
  Companion_137.prototype.mix_5llkhf_k$ = function (dst, src) {
    var srcA = _RGBA___get_a__impl_(src);
    var iSrcA = 255 - srcA | 0;
    var tmp0_subject = srcA;
    switch (tmp0_subject) {
      case 0:
        return dst;
      case 255:
        return src;
      default:return Companion_getInstance_136().invoke_aewswh_k$(_RGBA___get_rgb__impl_(this.mixRgbFactor256_s4p3o4_k$(dst, src, srcA + 1 | 0)), clamp0_255(srcA + (imul(_RGBA___get_a__impl_(dst), iSrcA) / 255 | 0) | 0));
    }
  };
  Companion_137.prototype.multiply_5llkhf_k$ = function (c1, c2) {
    return Companion_getInstance_136().invoke_fnl2i9_k$(imul(_RGBA___get_r__impl_(c1), _RGBA___get_r__impl_(c2)) / 255 | 0, imul(_RGBA___get_g__impl_(c1), _RGBA___get_g__impl_(c2)) / 255 | 0, imul(_RGBA___get_b__impl_(c1), _RGBA___get_b__impl_(c2)) / 255 | 0, imul(_RGBA___get_a__impl_(c1), _RGBA___get_a__impl_(c2)) / 255 | 0);
  };
  Companion_137.prototype.interpolate_8z8h9u_k$ = function (src, dst, ratio) {
    return Companion_getInstance_136().invoke_fnl2i9_k$(interpolate_0(ratio, _RGBA___get_r__impl_(src), _RGBA___get_r__impl_(dst)), interpolate_0(ratio, _RGBA___get_g__impl_(src), _RGBA___get_g__impl_(dst)), interpolate_0(ratio, _RGBA___get_b__impl_(src), _RGBA___get_b__impl_(dst)), interpolate_0(ratio, _RGBA___get_a__impl_(src), _RGBA___get_a__impl_(dst)));
  };
  Companion_137.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_136;
  function Companion_getInstance_136() {
    if (Companion_instance_136 == null)
      new Companion_137();
    return Companion_instance_136;
  }
  function RGBA__hashCode_impl(this_0) {
    return this_0;
  }
  function RGBA__equals_impl(this_0, other) {
    if (!(other instanceof RGBA))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RGBA ? other._value_19 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function RGBA(value) {
    Companion_getInstance_136();
    this._value_19 = value;
  }
  RGBA.prototype.transformed_lwp7hs_k$ = function (m) {
    return RGBA__transformed_impl(this._value_19, m);
  };
  RGBA.prototype.toString = function () {
    return RGBA__toString_impl(this._value_19);
  };
  RGBA.prototype.compareTo_mpdz1q_k$ = function (other) {
    return RGBA__compareTo_impl(this._value_19, other);
  };
  RGBA.prototype.compareTo_2c5_k$ = function (other) {
    return RGBA__compareTo_impl_0(this, other);
  };
  RGBA.prototype.hashCode = function () {
    return RGBA__hashCode_impl(this._value_19);
  };
  RGBA.prototype.equals = function (other) {
    return RGBA__equals_impl(this._value_19, other);
  };
  RGBA.$metadata$ = {
    simpleName: 'RGBA',
    kind: 'class',
    interfaces: [Comparable, Interpolable, Paint]
  };
  function _RgbaPremultipliedArray___init__impl_(ints) {
    return ints;
  }
  function _RgbaPremultipliedArray___get_ints__impl_(this_0) {
    return this_0;
  }
  function Companion_138() {
    Companion_instance_137 = this;
  }
  Companion_138.prototype.invoke_dguj8z_k$ = function (size_2) {
    return _RgbaPremultipliedArray___init__impl_(new Int32Array(size_2));
  };
  Companion_138.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_137;
  function Companion_getInstance_137() {
    if (Companion_instance_137 == null)
      new Companion_138();
    return Companion_instance_137;
  }
  function _RgbaPremultipliedArray___get_size__impl_(this_0) {
    return _RgbaPremultipliedArray___get_ints__impl_(this_0).length;
  }
  function RgbaPremultipliedArray__get_impl(this_0, index_0) {
    return _RGBAPremultiplied___init__impl_(_RgbaPremultipliedArray___get_ints__impl_(this_0)[index_0]);
  }
  function RgbaPremultipliedArray__set_impl(this_0, index_0, color_0) {
    return _RgbaPremultipliedArray___get_ints__impl_(this_0)[index_0] = _RGBAPremultiplied___get_value__impl_(color_0);
  }
  function RgbaPremultipliedArray__fill_impl(this_0, value, start, end) {
    var tmp0_fill_0 = _RgbaPremultipliedArray___get_ints__impl_(this_0);
    var tmp1_fill_0 = _RGBAPremultiplied___get_value__impl_(value);
    return fill_0(tmp0_fill_0, tmp1_fill_0, start, end);
  }
  function RgbaPremultipliedArray__toString_impl(this_0) {
    return '' + 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl_(this_0) + ')';
  }
  function RgbaPremultipliedArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function RgbaPremultipliedArray__equals_impl(this_0, other) {
    if (!(other instanceof RgbaPremultipliedArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other._ints_0 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function RgbaPremultipliedArray(ints) {
    Companion_getInstance_137();
    this._ints_0 = ints;
  }
  RgbaPremultipliedArray.prototype.toString = function () {
    return RgbaPremultipliedArray__toString_impl(this._ints_0);
  };
  RgbaPremultipliedArray.prototype.hashCode = function () {
    return RgbaPremultipliedArray__hashCode_impl(this._ints_0);
  };
  RgbaPremultipliedArray.prototype.equals = function (other) {
    return RgbaPremultipliedArray__equals_impl(this._ints_0, other);
  };
  RgbaPremultipliedArray.$metadata$ = {
    simpleName: 'RgbaPremultipliedArray',
    kind: 'class',
    interfaces: []
  };
  function _RGBAPremultiplied___init__impl_(value) {
    return value;
  }
  function _RGBAPremultiplied___get_value__impl_(this_0) {
    return this_0;
  }
  function _RGBAPremultiplied___init__impl__0(r, g, b, a) {
    var tmp = _RGBAPremultiplied___init__impl_(packIntClamped(r, g, b, a));
    return tmp;
  }
  function _RGBAPremultiplied___get_r__impl_(this_0) {
    return _RGBAPremultiplied___get_value__impl_(this_0) >>> 0 & 255;
  }
  function _RGBAPremultiplied___get_g__impl_(this_0) {
    return _RGBAPremultiplied___get_value__impl_(this_0) >>> 8 & 255;
  }
  function _RGBAPremultiplied___get_b__impl_(this_0) {
    return _RGBAPremultiplied___get_value__impl_(this_0) >>> 16 & 255;
  }
  function _RGBAPremultiplied___get_a__impl_(this_0) {
    return _RGBAPremultiplied___get_value__impl_(this_0) >>> 24 & 255;
  }
  function _RGBAPremultiplied___get_af__impl_(this_0) {
    return _RGBAPremultiplied___get_a__impl_(this_0) / 255.0;
  }
  function _RGBAPremultiplied___get_depremultiplied__impl_(this_0) {
    var A = _RGBAPremultiplied___get_a__impl_(this_0);
    var Af = 255.0 / A;
    var R = numberToInt(_RGBAPremultiplied___get_r__impl_(this_0) * Af);
    var G = numberToInt(_RGBAPremultiplied___get_g__impl_(this_0) * Af);
    var B = numberToInt(_RGBAPremultiplied___get_b__impl_(this_0) * Af);
    return Companion_getInstance_136().invoke_fnl2i9_k$(R, G, B, A);
  }
  function RGBAPremultiplied__scaled256_impl(this_0, s) {
    var rb = imul(_RGBAPremultiplied___get_value__impl_(this_0) & 16711935, s) >>> 8 & 16711935;
    var g = imul(_RGBAPremultiplied___get_value__impl_(this_0) & 65280, s) >>> 8 & 65280;
    var a = imul(_RGBAPremultiplied___get_value__impl_(this_0) >>> 24, s) >>> 8 << 24;
    return _RGBAPremultiplied___init__impl_(rb | g | a);
  }
  function RGBAPremultiplied__scaled_impl(this_0, alpha_0) {
    return RGBAPremultiplied__scaled256_impl(this_0, numberToInt(clamp01_0(alpha_0) * 256));
  }
  function Companion_139() {
    Companion_instance_138 = this;
    this._RB_MASK = 16711935;
    this._GA_MASK = -16711936;
  }
  Companion_139.prototype.blendAlpha_ua2wah_k$ = function (dst, src) {
    return _RGBAPremultiplied___init__impl_(sumPacked4MulR(_RGBAPremultiplied___get_value__impl_(src), _RGBAPremultiplied___get_value__impl_(dst), 256 - _RGBAPremultiplied___get_a__impl_(src) | 0));
  };
  Companion_139.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_138;
  function Companion_getInstance_138() {
    if (Companion_instance_138 == null)
      new Companion_139();
    return Companion_instance_138;
  }
  function asPremultiplied(_this_) {
    return _RGBAPremultiplied___init__impl_(_RGBA___get_value__impl_(_this_));
  }
  function asNonPremultiplied(_this_) {
    return _RGBA___init__impl_(_RGBAPremultiplied___get_value__impl_(_this_));
  }
  function arraycopy_19(src, srcPos, dst, dstPos, size_2) {
    return arraycopy_3(_RgbaArray___get_ints__impl_(src), srcPos, _RgbaArray___get_ints__impl_(dst), dstPos, size_2);
  }
  function mix(_this_, src) {
    var dst = _this_;
    var srcAf = _RGBAPremultiplied___get_af__impl_(src);
    var oneMSrcAf = 1.0 - srcAf;
    var outA = numberToInt(_RGBAPremultiplied___get_a__impl_(src) + _RGBAPremultiplied___get_a__impl_(dst) * oneMSrcAf);
    var outR = numberToInt(_RGBAPremultiplied___get_r__impl_(src) + _RGBAPremultiplied___get_r__impl_(dst) * oneMSrcAf);
    var outG = numberToInt(_RGBAPremultiplied___get_g__impl_(src) + _RGBAPremultiplied___get_g__impl_(dst) * oneMSrcAf);
    var outB = numberToInt(_RGBAPremultiplied___get_b__impl_(src) + _RGBAPremultiplied___get_b__impl_(dst) * oneMSrcAf);
    return _RGBAPremultiplied___init__impl__0(outR, outG, outB, outA);
  }
  function mix_0(dst, dstX, src, srcX, count_0) {
    return mix_1(dst, dstX, dst, dstX, src, srcX, count_0);
  }
  function mix_1(tgt, tgtX, dst, dstX, src, srcX, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl(tgt, tgtX + n | 0, Companion_getInstance_138().blendAlpha_ua2wah_k$(RgbaPremultipliedArray__get_impl(dst, dstX + n | 0), RgbaPremultipliedArray__get_impl(src, srcX + n | 0)));
      }
       while (inductionVariable < count_0);
  }
  function scale(color_0, colorOffset, alpha_0, alphaOffset, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a = clamp01_0(alpha_0[alphaOffset + n | 0]);
        if (a === 1.0)
          continue;
        RgbaPremultipliedArray__set_impl(color_0, colorOffset + n | 0, RGBAPremultiplied__scaled_impl(RgbaPremultipliedArray__get_impl(color_0, colorOffset + n | 0), a));
      }
       while (inductionVariable < count_0);
  }
  function premultiply(src, srcN, dst, dstN, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl(dst, dstN + n | 0, _RGBA___get_premultiplied__impl_(RgbaArray__get_impl(src, srcN + n | 0)));
      }
       while (inductionVariable < count_0);
  }
  function depremultiply(src, srcN, dst, dstN, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__set_impl(dst, dstN + n | 0, _RGBAPremultiplied___get_depremultiplied__impl_(RgbaPremultipliedArray__get_impl(src, srcN + n | 0)));
      }
       while (inductionVariable < count_0);
  }
  function makeDirty($this) {
    $this._dirty_0 = true;
  }
  function Companion_140() {
    Companion_instance_139 = this;
  }
  Companion_140.prototype.valueOf_3fnd3f_k$ = function (hex, color_0) {
    return color_0.setTo_mpdz1q_k$(Colors_getInstance().get_xr0bn6_k$(hex));
  };
  Companion_140.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_139;
  function Companion_getInstance_139() {
    if (Companion_instance_139 == null)
      new Companion_140();
    return Companion_instance_139;
  }
  function RGBAf(_r, _g, _b, _a) {
    Companion_getInstance_139();
    this.__r = _r;
    this.__g = _g;
    this.__b = _b;
    this.__a = _a;
    this._dirty_0 = true;
    this.__rgba = _RGBA___init__impl_(-1);
  }
  RGBAf.prototype._get_r__0_k$ = function () {
    return this.__r;
  };
  RGBAf.prototype._get_g__0_k$ = function () {
    return this.__g;
  };
  RGBAf.prototype._get_b__0_k$ = function () {
    return this.__b;
  };
  RGBAf.prototype._get_a__0_k$ = function () {
    return this.__a;
  };
  RGBAf.prototype.setTo_bha9a8_k$ = function (r, g, b, a) {
    this.__r = r;
    this.__g = g;
    this.__b = b;
    this.__a = a;
    makeDirty(this);
    return this;
  };
  RGBAf.prototype.setTo_mpdz1q_k$ = function (color_0) {
    return this.setTo_bha9a8_k$(_RGBA___get_rf__impl_(color_0), _RGBA___get_gf__impl_(color_0), _RGBA___get_bf__impl_(color_0), _RGBA___get_af__impl_(color_0));
  };
  RGBAf.prototype.toString = function () {
    return '' + 'RGBAf(' + _get_niceStr__2(this._get_r__0_k$()) + ', ' + _get_niceStr__2(this._get_g__0_k$()) + ', ' + _get_niceStr__2(this._get_b__0_k$()) + ', ' + _get_niceStr__2(this._get_a__0_k$()) + ')';
  };
  RGBAf.$metadata$ = {
    simpleName: 'RGBAf',
    kind: 'class',
    interfaces: []
  };
  function Companion_141() {
    Companion_instance_140 = this;
  }
  Companion_141.prototype.buildKey_27zxwg_k$ = function (f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  };
  Companion_141.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_140;
  function Companion_getInstance_140() {
    if (Companion_instance_140 == null)
      new Companion_141();
    return Companion_instance_140;
  }
  function _no_name_provided__253(this$0) {
    this._this$0_58 = this$0;
  }
  _no_name_provided__253.prototype.invoke_0_k$ = function () {
    return this._this$0_58._texture_0.extract_0_k$().toBMP32_0_k$();
  };
  _no_name_provided__253.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BitmapFont_init_$Init$(fontSize, lineHeight, base, glyphs, kernings, atlas, name, $mask0, $marker, $this) {
    if (!(($mask0 & 32) === 0)) {
      var tmp0_safe_receiver = glyphs._get_values__0_k$().iterator_0_k$().next_0_k$();
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._texture_0;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_bmpBase__0_k$();
      var tmp;
      if (tmp2_elvis_lhs == null) {
        var tmp0__get_transparent__0 = Bitmaps_getInstance();
        tmp = Bitmaps_transparent._get_bmpBase__0_k$();
      } else {
        tmp = tmp2_elvis_lhs;
      }
      atlas = tmp;
    }if (!(($mask0 & 64) === 0))
      name = 'BitmapFont';
    BitmapFont.call($this, fontSize, lineHeight, base, glyphs, kernings, atlas, name);
    return $this;
  }
  function BitmapFont_init_$Create$(fontSize, lineHeight, base, glyphs, kernings, atlas, name, $mask0, $marker) {
    return BitmapFont_init_$Init$(fontSize, lineHeight, base, glyphs, kernings, atlas, name, $mask0, $marker, Object.create(BitmapFont.prototype));
  }
  function _get_naturalFontMetrics_($this) {
    var tmp0_getValue_0 = naturalFontMetrics$factory();
    return $this._naturalFontMetrics$delegate._get_value__0_k$();
  }
  function getTextScale($this, size_2) {
    return size_2 / $this._fontSize_0;
  }
  function Kerning(first_2, second, amount) {
    Companion_getInstance_140();
    this._first_3 = first_2;
    this._second_0 = second;
    this._amount = amount;
  }
  Kerning.$metadata$ = {
    simpleName: 'Kerning',
    kind: 'class',
    interfaces: []
  };
  function Glyph(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this._fontSize = fontSize;
    this._id_4 = id;
    this._texture_0 = texture;
    this._xoffset = xoffset;
    this._yoffset = yoffset;
    this._xadvance = xadvance;
    var tmp = this;
    tmp._bmp$delegate_0 = lazy(_no_name_provided_$factory_209(this));
    this._naturalMetrics = new GlyphMetrics(this._fontSize, true, -1, Companion_getInstance_35().invoke_w0xdj4_k$(this._xoffset, this._yoffset, this._texture_0._get_width__0_k$(), this._texture_0._get_height__0_k$()), this._xadvance);
  }
  Glyph.prototype._get_bmp__0_k$ = function () {
    var tmp0_getValue_0 = bmp$factory();
    return this._bmp$delegate_0._get_value__0_k$();
  };
  Glyph.prototype.toString = function () {
    return '' + 'Glyph(fontSize=' + this._fontSize + ', id=' + this._id_4 + ', texture=' + this._texture_0 + ', xoffset=' + this._xoffset + ', yoffset=' + this._yoffset + ', xadvance=' + this._xadvance + ')';
  };
  Glyph.prototype.hashCode = function () {
    var result = getNumberHashCode(this._fontSize);
    result = imul(result, 31) + this._id_4 | 0;
    result = imul(result, 31) + hashCode(this._texture_0) | 0;
    result = imul(result, 31) + this._xoffset | 0;
    result = imul(result, 31) + this._yoffset | 0;
    result = imul(result, 31) + this._xadvance | 0;
    return result;
  };
  Glyph.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals_1(this._fontSize, tmp0_other_with_cast._fontSize))
      return false;
    if (!(this._id_4 === tmp0_other_with_cast._id_4))
      return false;
    if (!equals_1(this._texture_0, tmp0_other_with_cast._texture_0))
      return false;
    if (!(this._xoffset === tmp0_other_with_cast._xoffset))
      return false;
    if (!(this._yoffset === tmp0_other_with_cast._yoffset))
      return false;
    if (!(this._xadvance === tmp0_other_with_cast._xadvance))
      return false;
    return true;
  };
  Glyph.$metadata$ = {
    simpleName: 'Glyph',
    kind: 'class',
    interfaces: []
  };
  function Companion_142() {
    Companion_instance_141 = this;
  }
  Companion_142.prototype.invoke_2rc259_k$ = function (font, fontSize, chars, fontName, paint, mipmaps_0, effect) {
    var fontSize_0 = numberToDouble(fontSize);
    var fmetrics = font.getFontMetrics$default_2k781i_k$(fontSize_0, null, 2, null);
    var tmp0_map_0 = chars._codePoints;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0.length);
    var indexedObject = tmp0_map_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_2bq_k$(font.getGlyphMetrics$default_vit8xo_k$(fontSize_0, item_2_3, null, 4, null));
      Unit_getInstance();
    }
    var glyphMetrics = tmp0_mapTo_0_1;
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(glyphMetrics, 10));
    var tmp0_iterator_1_2 = glyphMetrics.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3_0 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1_0.add_2bq_k$((item_2_3_0._get_width__0_k$() + 4) * (fmetrics._get_lineHeight__0_k$() + 4));
      Unit_getInstance();
    }
    var requiredArea = toIntCeil(sum_0(tmp0_mapTo_0_1_0));
    var tmp1_sqrt_0 = requiredArea;
    var requiredAreaSide = toIntCeil(Math.sqrt(tmp1_sqrt_0));
    var tmp = _get_nextPowerOfTwo_(requiredAreaSide);
    var tmp_0 = _get_nextPowerOfTwo_(requiredAreaSide);
    var matlas = MutableAtlas_init_$Create$(tmp, tmp_0, 0, false, false, null, 60, null);
    var border = 2;
    var indexedObject_0 = chars._codePoints;
    var inductionVariable_0 = 0;
    var last_2 = indexedObject_0.length;
    while (inductionVariable_0 < last_2) {
      var codePoint = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var result = renderGlyphToBitmap$default(font, fontSize_0, codePoint, paint, true, effect, 1, false, 64, null);
      var tmp_1 = result._bmp_1.toBMP32_0_k$().premultipliedIfRequired_0_k$();
      matlas.add$default_3pfalt_k$(tmp_1, result, null, 4, null);
      Unit_getInstance();
    }
    var fm = first(matlas._entries)._data_24._fmetrics;
    var atlas = matlas._bitmap;
    var tmp_2 = fmetrics._get_lineHeight__0_k$();
    var tmp_3 = fmetrics._top;
    var tmp2_associate_0 = matlas._entries;
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp2_associate_0, 10)), 16);
    var tmp1_associateTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = tmp2_associate_0.iterator_0_k$();
    while (tmp0_iterator_1_3.hasNext_0_k$()) {
      var element_2_4 = tmp0_iterator_1_3.next_0_k$();
      var slice_7 = element_2_4._slice;
      var g_8 = first(element_2_4._data_24._glyphs_0);
      var m_9 = g_8._metrics_0;
      var tmp0_plusAssign_0_5 = to(g_8._codePoint, new Glyph(fontSize_0, g_8._codePoint, slice_7, -border | 0, numberToInt(border - m_9._get_height__0_k$() - m_9._get_top__0_k$()) + numberToInt(fm._ascent) | 0, toIntCeil(m_9._xadvance_0)));
      tmp1_associateTo_0_2.put_1q9pf_k$(tmp0_plusAssign_0_5._first, tmp0_plusAssign_0_5._second);
      Unit_getInstance();
    }
    var tmp_4 = toIntMap(tmp1_associateTo_0_2);
    return new BitmapFont(fontSize_0, tmp_2, tmp_3, tmp_4, IntMap_init_$Create$(0, 0.0, 3, null), mipmaps(atlas, mipmaps_0), fontName);
  };
  Companion_142.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_141;
  function Companion_getInstance_141() {
    if (Companion_instance_141 == null)
      new Companion_142();
    return Companion_instance_141;
  }
  function _no_name_provided__254(this$0) {
    this._this$0_59 = this$0;
  }
  _no_name_provided__254.prototype.invoke_0_k$ = function () {
    var ascent = this._this$0_59._base_4;
    var baseline = 0.0;
    var descent = this._this$0_59._lineHeight - this._this$0_59._base_4;
    var tmp = -descent;
    var tmp_0 = -descent;
    var width_2 = 0.0;
    var tmp0_iterator_3 = this._this$0_59._glyphs._get_values__0_k$().iterator_0_k$();
    while (tmp0_iterator_3.hasNext_0_k$()) {
      var glyph_4 = tmp0_iterator_3.next_0_k$();
      if (!(glyph_4 == null)) {
        var tmp0_max_0_5 = width_2;
        var tmp1_max_0_6 = glyph_4._texture_0._get_width__0_k$();
        width_2 = Math.max(tmp0_max_0_5, tmp1_max_0_6);
      }}
    return new FontMetrics(this._this$0_59._fontSize_0, ascent, ascent, baseline, tmp, tmp_0, 0.0, width_2);
  };
  _no_name_provided__254.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__255(this$0) {
    this._this$0_60 = this$0;
  }
  _no_name_provided__255.prototype.invoke_0_k$ = function () {
    var tmp0__get_transparent__0 = Bitmaps_getInstance();
    return new Glyph(this._this$0_60._fontSize_0, -1, Bitmaps_transparent, 0, 0, 0);
  };
  _no_name_provided__255.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__256(this$0) {
    this._this$0_61 = this$0;
  }
  _no_name_provided__256.prototype.invoke_0_k$ = function () {
    var tmp0_elvis_lhs = this._this$0_61._glyphs.get_ha5a7z_k$(this._this$0_61._glyphs._get_keys__0_k$().iterator_0_k$().next_0_k$());
    return tmp0_elvis_lhs == null ? this._this$0_61._get_dummyGlyph__0_k$() : tmp0_elvis_lhs;
  };
  _no_name_provided__256.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__257(this$0) {
    this._this$0_62 = this$0;
  }
  _no_name_provided__257.prototype.invoke_0_k$ = function () {
    return this._this$0_62._get_anyGlyph__0_k$()._texture_0._get_bmpBase__0_k$();
  };
  _no_name_provided__257.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BitmapFont(fontSize, lineHeight, base, glyphs, kernings, atlas, name) {
    Companion_getInstance_141();
    this._fontSize_0 = fontSize;
    this._lineHeight = lineHeight;
    this._base_4 = base;
    this._glyphs = glyphs;
    this._kernings = kernings;
    this._atlas = atlas;
    this._name_14 = name;
    var tmp = this;
    tmp._$$delegate_0_19 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._naturalFontMetrics$delegate = lazy(_no_name_provided_$factory_205(this));
    this._naturalNonExistantGlyphMetrics = new GlyphMetrics(this._fontSize_0, false, 0, Companion_getInstance_35().invoke_0_k$(), 0.0);
    var tmp_1 = this;
    tmp_1._dummyGlyph$delegate = lazy(_no_name_provided_$factory_206(this));
    var tmp_2 = this;
    tmp_2._anyGlyph$delegate = lazy(_no_name_provided_$factory_207(this));
    var tmp_3 = this;
    tmp_3._baseBmp$delegate = lazy(_no_name_provided_$factory_208(this));
  }
  BitmapFont.prototype._get_name__0_k$ = function () {
    return this._name_14;
  };
  BitmapFont.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_19._set_extra__n1onou_k$(_set___);
  };
  BitmapFont.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_19._get_extra__0_k$();
  };
  BitmapFont.prototype.getOrNull_0_k$ = function () {
    return this;
  };
  BitmapFont.prototype.getFontMetrics_sqtkiv_k$ = function (size_2, metrics) {
    return metrics.copyFromNewSize_1pu7zb_k$(_get_naturalFontMetrics_(this), size_2);
  };
  BitmapFont.prototype.getGlyphMetrics_xejy1t_k$ = function (size_2, codePoint, metrics) {
    var tmp0_safe_receiver = this._glyphs.get_ha5a7z_k$(codePoint);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._naturalMetrics;
    return metrics.copyFromNewSize_n1q0an_k$(tmp1_elvis_lhs == null ? this._naturalNonExistantGlyphMetrics : tmp1_elvis_lhs, size_2, codePoint);
  };
  BitmapFont.prototype.getKerning_jw27q7_k$ = function (size_2, leftCodePoint, rightCodePoint) {
    var tmp = getTextScale(this, size_2);
    var tmp0_safe_receiver = this.getKerning_27zxwg_k$(leftCodePoint, rightCodePoint);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._amount;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    return tmp * (tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs);
  };
  BitmapFont.prototype.renderGlyph_its5jl_k$ = function (ctx, size_2, codePoint, x, y, fill_4, metrics) {
    var scale_1 = getTextScale(this, size_2);
    var tmp0_elvis_lhs = this._glyphs.get_ha5a7z_k$(codePoint);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var tmp0_takeIf_0 = this.getGlyphMetrics_xejy1t_k$(size_2, codePoint, metrics);
    var tmp_0;
    if (tmp0_takeIf_0._existing) {
      tmp_0 = tmp0_takeIf_0;
    } else {
      {
        tmp_0 = null;
      }
    }
    var tmp1_elvis_lhs = tmp_0;
    if (tmp1_elvis_lhs == null)
      return Unit_getInstance();
    else
      tmp1_elvis_lhs;
    Unit_getInstance();
    if (metrics._get_width__0_k$() === 0.0 ? metrics._get_height__0_k$() === 0.0 : false)
      return Unit_getInstance();
    var texX = x + metrics._get_left__0_k$();
    var texY = y + metrics._get_top__0_k$();
    var swidth = metrics._get_width__0_k$();
    var sheight = metrics._get_height__0_k$();
    var tmp_1;
    if (equals_1(ctx._get_fillStyle__0_k$(), new RGBA(_get_DefaultPaint_()))) {
      tmp_1 = g._get_bmp__0_k$();
    } else {
      var tmp_2 = g._get_bmp__0_k$()._get_width__0_k$();
      var tmp_3 = g._get_bmp__0_k$()._get_height__0_k$();
      var tmp1_context2d_0 = Bitmap32_init_$Create$(tmp_2, tmp_3, null, false, 12, null);
      tmp1_context2d_0.lock_sv8swh_k$();
      try {
        var ctx_2_1 = tmp1_context2d_0.getContext2d_vcj5fe_k$(true);
        try {
          var t_1_3 = ctx_2_1._state_5._transform_6;
          var a_2_4 = t_1_3._a;
          var b_3_5 = t_1_3._b;
          var c_4_6 = t_1_3._c;
          var d_5_7 = t_1_3._d;
          var tx_6_8 = t_1_3._tx;
          var ty_7_9 = t_1_3._ty;
          try {
            var tmp_4 = 1.0 / scale_1;
            ctx_2_1.scale$default_hdt4os_k$(tmp_4, 0.0, 2, null);
            Unit_getInstance();
            ctx_2_1._set_fillStyle__y73s1i_k$(ctx._get_fillStyle__0_k$());
            var tmp0_fillRect_0_9_10 = ctx_2_1._get_width__0_k$() * scale_1;
            var tmp1_fillRect_0_10_11 = ctx_2_1._get_height__0_k$() * scale_1;
            ctx_2_1.fillRect_lf7oid_k$(0.0, 0.0, numberToDouble(tmp0_fillRect_0_9_10), numberToDouble(tmp1_fillRect_0_10_11));
          }finally {
            t_1_3.setTo_hmhsjq_k$(a_2_4, b_3_5, c_4_6, d_5_7, tx_6_8, ty_7_9);
            Unit_getInstance();
          }
        }finally {
          ctx_2_1.dispose_sv8swh_k$();
        }
      }finally {
        tmp1_context2d_0.unlock_ixubtt_k$(null);
        Unit_getInstance();
      }
      var bmpFill = tmp1_context2d_0;
      bmpFill.writeChannel_gx7ucp_k$(BitmapChannel_ALPHA_getInstance(), g._get_bmp__0_k$(), BitmapChannel_ALPHA_getInstance());
      tmp_1 = bmpFill;
    }
    var bmp = tmp_1;
    ctx.drawImage_c2z1l2_k$(bmp, texX, texY - metrics._get_height__0_k$(), swidth, sheight);
  };
  BitmapFont.prototype.getKerning_27zxwg_k$ = function (first_2, second) {
    return this._kernings.get_ha5a7z_k$(Companion_getInstance_140().buildKey_27zxwg_k$(first_2, second));
  };
  BitmapFont.prototype._get_dummyGlyph__0_k$ = function () {
    var tmp0_getValue_0 = dummyGlyph$factory();
    return this._dummyGlyph$delegate._get_value__0_k$();
  };
  BitmapFont.prototype._get_anyGlyph__0_k$ = function () {
    var tmp0_getValue_0 = anyGlyph$factory();
    return this._anyGlyph$delegate._get_value__0_k$();
  };
  BitmapFont.prototype._get_baseBmp__0_k$ = function () {
    var tmp0_getValue_0 = baseBmp$factory();
    return this._baseBmp$delegate._get_value__0_k$();
  };
  BitmapFont.prototype.get_ha5a7z_k$ = function (charCode) {
    var tmp0_elvis_lhs = this._glyphs.get_ha5a7z_k$(charCode);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this._glyphs.get_ha5a7z_k$(32) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? this._get_dummyGlyph__0_k$() : tmp1_elvis_lhs;
  };
  BitmapFont.$metadata$ = {
    simpleName: 'BitmapFont',
    kind: 'class',
    interfaces: [Font, Extra]
  };
  function toBitmapFont(_this_, fontSize, chars, fontName, paint, mipmaps_0, effect) {
    return Companion_getInstance_141().invoke_2rc259_k$(_this_, fontSize, chars, fontName, paint, mipmaps_0, effect);
  }
  function toBitmapFont$default(_this_, fontSize, chars, fontName, paint, mipmaps_0, effect, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      chars = Companion_getInstance_142()._LATIN_ALL;
    if (!(($mask0 & 4) === 0))
      fontName = _this_._get_name__0_k$();
    if (!(($mask0 & 8) === 0))
      paint = new RGBA(Colors_getInstance()._WHITE_0);
    if (!(($mask0 & 16) === 0))
      mipmaps_0 = true;
    if (!(($mask0 & 32) === 0))
      effect = null;
    return toBitmapFont(_this_, fontSize, chars, fontName, paint, mipmaps_0, effect);
  }
  function readBitmapFont(_this_, imageFormat, mipmaps_0, $cont) {
    var tmp = new $readBitmapFontCOROUTINE$1(_this_, imageFormat, mipmaps_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readBitmapFontXml(content, fntFile, textures, imageFormat, mipmaps_0, $cont) {
    var tmp = new $readBitmapFontXmlCOROUTINE$2(content, fntFile, textures, imageFormat, mipmaps_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readBitmapFontTxt(content, fntFile, textures, imageFormat, mipmaps_0, $cont) {
    var tmp = new $readBitmapFontTxtCOROUTINE$3(content, fntFile, textures, imageFormat, mipmaps_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__258() {
  }
  _no_name_provided__258.prototype.invoke_8h2c01_k$ = function (_anonymous_parameter_0_, it) {
    return Companion_getInstance_140().buildKey_27zxwg_k$(it._first_3, it._second_0);
  };
  _no_name_provided__258.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_8h2c01_k$(tmp, p2 instanceof Kerning ? p2 : THROW_CCE());
  };
  _no_name_provided__258.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $readBitmapFontCOROUTINE$1(_this_, imageFormat, mipmaps_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__119 = _this_;
    this._imageFormat = imageFormat;
    this._mipmaps_0 = mipmaps_0;
  }
  $readBitmapFontCOROUTINE$1.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._fntFile0 = this.__this__119;
            this._state_1 = 1;
            suspendResult = this._fntFile0.readString$default_8s0uio_k$(null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_trim_01 = suspendResult;
            var tmp_0 = this;
            var tmp_1 = this._tmp0_trim_01;
            tmp_0._content2_0 = toString_1(trim_0(isCharSequence(tmp_1) ? tmp_1 : THROW_CCE()));
            var tmp_2 = this;
            tmp_2._textures3 = HashMap_init_$Create$();
            var tmp_3 = new Char(60);
            if (startsWith$default(this._content2_0, tmp_3, false, 2, null)) {
              this._state_1 = 3;
              suspendResult = readBitmapFontXml(this._content2_0, this._fntFile0, this._textures3, this._imageFormat, this._mipmaps_0, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                if (startsWith$default_1(this._content2_0, 'info', false, 2, null)) {
                  this._state_1 = 2;
                  suspendResult = readBitmapFontTxt(this._content2_0, this._fntFile0, this._textures3, this._imageFormat, this._mipmaps_0, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    var tmp_4 = this;
                    var tmp1_TODO_0 = '' + 'Unsupported font type starting with ' + substr_0(this._content2_0, 0, 16);
                    throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp1_TODO_0);
                  }
                }
                Unit_getInstance();
              }
            }

            break;
          case 2:
            this._WHEN_RESULT4 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._WHEN_RESULT4 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            return this._WHEN_RESULT4;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapFontCOROUTINE$1.$metadata$ = {
    simpleName: '$readBitmapFontCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $readBitmapFontXmlCOROUTINE$2(content, fntFile, textures, imageFormat, mipmaps_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._content_7 = content;
    this._fntFile = fntFile;
    this._textures = textures;
    this._imageFormat_0 = imageFormat;
    this._mipmaps_1 = mipmaps_0;
  }
  $readBitmapFontXmlCOROUTINE$2.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._xml0 = Xml_0(this._content_7);
            var tmp_0 = this;
            var tmp0_safe_receiver = firstOrNull_0(this._xml0.get_6wfw3l_k$('info'));
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.double_qmgruq_k$('size', 16.0);
            tmp_0._fontSize1 = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
            var tmp_1 = this;
            var tmp2_safe_receiver = firstOrNull_0(this._xml0.get_6wfw3l_k$('common'));
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.double_qmgruq_k$('lineHeight', 16.0);
            tmp_1._lineHeight2 = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
            var tmp_2 = this;
            var tmp4_safe_receiver = firstOrNull_0(this._xml0.get_6wfw3l_k$('common'));
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.double_qmgruq_k$('base', 16.0);
            tmp_2._base3 = tmp5_elvis_lhs == null ? 16.0 : tmp5_elvis_lhs;
            this._tmp6_iterator4 = get_0(this._xml0.get_6wfw3l_k$('pages'), 'page').iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp6_iterator4.hasNext_0_k$()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._page5 = this._tmp6_iterator4.next_0_k$();
            var tmp_3 = this;
            tmp_3._id6 = this._page5.int$default_6ncsww_k$('id', 0, 2, null);
            var tmp_4 = this;
            tmp_4._file7 = this._page5.str$default_877n1b_k$('file', null, 2, null);
            this._texFile8 = this._fntFile._get_parent__0_k$().get_6wfw3l_k$(this._file7);
            this._state_1 = 2;
            suspendResult = readBitmap$default(this._texFile8, this._imageFormat_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this._mipmaps_1);
            var tex = slice$default(ARGUMENT_0, null, null, 3, null);
            this._textures.put_1q9pf_k$(this._id6, tex);
            Unit_getInstance();
            this._state_1 = 1;
            continue $sm;
          case 3:
            var tmp0_map_0 = get_0(this._xml0.get_6wfw3l_k$('chars'), 'char');
            var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
            var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
            while (tmp0_iterator_1_2.hasNext_0_k$()) {
              var item_2_3 = tmp0_iterator_1_2.next_0_k$();
              var page_5 = item_2_3.int$default_6ncsww_k$('page', 0, 2, null);
              var tmp0_elvis_lhs_7 = this._textures.get_2bw_k$(page_5);
              var texture_6 = tmp0_elvis_lhs_7 == null ? first_0(this._textures._get_values__0_k$()) : tmp0_elvis_lhs_7;
              var tmp_5 = item_2_3.int$default_6ncsww_k$('id', 0, 2, null);
              var tmp_6 = item_2_3.int$default_6ncsww_k$('x', 0, 2, null);
              var tmp_7 = item_2_3.int$default_6ncsww_k$('y', 0, 2, null);
              var tmp_8 = item_2_3.int$default_6ncsww_k$('width', 0, 2, null);
              var tmp_9 = item_2_3.int$default_6ncsww_k$('height', 0, 2, null);
              var tmp_10 = texture_6.sliceWithSize$default_cox0wy_k$(tmp_6, tmp_7, tmp_8, tmp_9, null, 16, null);
              var tmp_11 = item_2_3.int$default_6ncsww_k$('xoffset', 0, 2, null);
              var tmp_12 = item_2_3.int$default_6ncsww_k$('yoffset', 0, 2, null);
              tmp0_mapTo_0_1.add_2bq_k$(new Glyph(this._fontSize1, tmp_5, tmp_10, tmp_11, tmp_12, item_2_3.int$default_6ncsww_k$('xadvance', 0, 2, null)));
              Unit_getInstance();
            }

            var glyphs = tmp0_mapTo_0_1;
            var tmp1_map_0 = get_0(this._xml0.get_6wfw3l_k$('kernings'), 'kerning');
            var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
            var tmp0_iterator_1_2_0 = tmp1_map_0.iterator_0_k$();
            while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
              var item_2_3_0 = tmp0_iterator_1_2_0.next_0_k$();
              var tmp_13 = item_2_3_0.int$default_6ncsww_k$('first', 0, 2, null);
              var tmp_14 = item_2_3_0.int$default_6ncsww_k$('second', 0, 2, null);
              tmp0_mapTo_0_1_0.add_2bq_k$(new Kerning(tmp_13, tmp_14, item_2_3_0.int$default_6ncsww_k$('amount', 0, 2, null)));
              Unit_getInstance();
            }

            var kernings = tmp0_mapTo_0_1_0;
            var tmp7_atlas = first_0(this._textures._get_values__0_k$())._get_bmpBase__0_k$();
            var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(glyphs, 10));
            var tmp0_iterator_1_2_1 = glyphs.iterator_0_k$();
            while (tmp0_iterator_1_2_1.hasNext_0_k$()) {
              var item_2_3_1 = tmp0_iterator_1_2_1.next_0_k$();
              tmp0_mapTo_0_1_1.add_2bq_k$(to(item_2_3_1._id_4, item_2_3_1));
              Unit_getInstance();
            }

            var tmp8_glyphs = toIntMap(toMap_0(tmp0_mapTo_0_1_1));
            var tmp0_mapTo_0_1_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(kernings, 10));
            var tmp0_iterator_1_2_2 = kernings.iterator_0_k$();
            while (tmp0_iterator_1_2_2.hasNext_0_k$()) {
              var item_2_3_2 = tmp0_iterator_1_2_2.next_0_k$();
              tmp0_mapTo_0_1_2.add_2bq_k$(to(Companion_getInstance_140().buildKey_27zxwg_k$(item_2_3_2._first_3, item_2_3_2._second_0), item_2_3_2));
              Unit_getInstance();
            }

            var tmp9_kernings = toIntMap(toMap_0(tmp0_mapTo_0_1_2));
            return BitmapFont_init_$Create$(this._fontSize1, this._lineHeight2, this._base3, tmp8_glyphs, tmp9_kernings, tmp7_atlas, null, 64, null);
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapFontXmlCOROUTINE$2.$metadata$ = {
    simpleName: '$readBitmapFontXmlCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function $readBitmapFontTxtCOROUTINE$3(content, fntFile, textures, imageFormat, mipmaps_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._content_8 = content;
    this._fntFile_0 = fntFile;
    this._textures_0 = textures;
    this._imageFormat_1 = imageFormat;
    this._mipmaps_2 = mipmaps_0;
  }
  $readBitmapFontTxtCOROUTINE$3.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            var tmp_0 = this;
            tmp_0._kernings0 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1._glyphs1 = ArrayList_init_$Create$();
            this._lineHeight2_0 = 16.0;
            this._fontSize3 = 16.0;
            this._base4 = null;
            this._tmp0_iterator5 = lines(this._content_8).iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator5.hasNext_0_k$()) {
              this._state_1 = 4;
              continue $sm;
            }
            this._rline6 = this._tmp0_iterator5.next_0_k$();
            var tmp_2 = this;
            var tmp_3 = this._rline6;
            tmp_2._line7 = toString_1(trim_0(isCharSequence(tmp_3) ? tmp_3 : THROW_CCE()));
            this._map8 = LinkedHashMap_init_$Create$();
            var tmp_4 = charArrayOf([new Char(32)]);
            var tmp1_iterator = split$default(this._line7, tmp_4, false, 0, 6, null).iterator_0_k$();
            while (tmp1_iterator.hasNext_0_k$()) {
              var part = tmp1_iterator.next_0_k$();
              var tmp_5 = charArrayOf([new Char(61)]);
              var tmp2_container = plus(split$default(part, tmp_5, false, 0, 6, null), listOf(['', '']));
              var key = tmp2_container.get_ha5a7z_k$(0);
              var value = tmp2_container.get_ha5a7z_k$(1);
              this._map8.put_1q9pf_k$(key, value);
              Unit_getInstance();
            }

            if (startsWith$default_1(this._line7, 'info', false, 2, null)) {
              var tmp_6 = this;
              var tmp3_safe_receiver = this._map8.get_2bw_k$('size');
              var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toDouble(tmp3_safe_receiver);
              tmp_6._fontSize3 = tmp4_elvis_lhs == null ? 16.0 : tmp4_elvis_lhs;
              this._state_1 = 3;
              continue $sm;
            } else {
              {
                if (startsWith$default_1(this._line7, 'page', false, 2, null)) {
                  var tmp_7 = this;
                  var tmp5_safe_receiver = this._map8.get_2bw_k$('id');
                  var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : toInt(tmp5_safe_receiver);
                  tmp_7._id9 = tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs;
                  var tmp_8 = this;
                  var tmp7_safe_receiver = this._map8.get_2bw_k$('file');
                  var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : unquote(tmp7_safe_receiver);
                  var tmp_9;
                  if (tmp8_elvis_lhs == null) {
                    throw IllegalStateException_init_$Create$_0('page without file');
                  } else {
                    tmp_9 = tmp8_elvis_lhs;
                  }
                  tmp_8._file10 = tmp_9;
                  this._state_1 = 2;
                  var tmp_10 = this._fntFile_0._get_parent__0_k$().get_6wfw3l_k$(this._file10);
                  suspendResult = readBitmap$default(tmp_10, this._imageFormat_1, null, 2, null, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    if (startsWith$default_1(this._line7, 'common ', false, 2, null)) {
                      var tmp_11 = this;
                      var tmp9_safe_receiver = this._map8.get_2bw_k$('lineHeight');
                      var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : toDoubleOrNull(tmp9_safe_receiver);
                      tmp_11._lineHeight2_0 = tmp10_elvis_lhs == null ? 16.0 : tmp10_elvis_lhs;
                      var tmp_12 = this;
                      var tmp11_safe_receiver = this._map8.get_2bw_k$('base');
                      tmp_12._base4 = tmp11_safe_receiver == null ? null : toDoubleOrNull(tmp11_safe_receiver);
                      this._state_1 = 3;
                      continue $sm;
                    } else {
                      {
                        if (startsWith$default_1(this._line7, 'char ', false, 2, null)) {
                          var tmp12_safe_receiver = this._map8.get_2bw_k$('page');
                          var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : toIntOrNull(tmp12_safe_receiver);
                          var page = tmp13_elvis_lhs == null ? 0 : tmp13_elvis_lhs;
                          var tmp14_elvis_lhs = this._textures_0.get_2bw_k$(page);
                          var texture = tmp14_elvis_lhs == null ? first_0(this._textures_0._get_values__0_k$()) : tmp14_elvis_lhs;
                          var tmp1_invoke_0 = Companion_getInstance_108();
                          var tmp2__anonymous__1 = Companion_getInstance_108();
                          var id_2 = tmp2__anonymous__1._get_int__kajtkh_k$(this._map8.get_2bw_k$('id'));
                          var tmp0_xoffset_3 = tmp2__anonymous__1._get_int__kajtkh_k$(this._map8.get_2bw_k$('xoffset'));
                          var tmp1_yoffset_4 = tmp2__anonymous__1._get_int__kajtkh_k$(this._map8.get_2bw_k$('yoffset'));
                          var tmp2_xadvance_5 = tmp2__anonymous__1._get_int__kajtkh_k$(this._map8.get_2bw_k$('xadvance'));
                          var tmp3_texture_6 = texture.sliceWithSize_w0abts_k$(tmp2__anonymous__1._get_int__kajtkh_k$(this._map8.get_2bw_k$('x')), tmp2__anonymous__1._get_int__kajtkh_k$(this._map8.get_2bw_k$('y')), tmp2__anonymous__1._get_int__kajtkh_k$(this._map8.get_2bw_k$('width')), tmp2__anonymous__1._get_int__kajtkh_k$(this._map8.get_2bw_k$('height')), '' + 'glyph-' + numberToChar(id_2));
                          var tmp3_plusAssign_0 = new Glyph(this._fontSize3, id_2, tmp3_texture_6, tmp0_xoffset_3, tmp1_yoffset_4, tmp2_xadvance_5);
                          this._glyphs1.add_2bq_k$(tmp3_plusAssign_0);
                          Unit_getInstance();
                          this._state_1 = 3;
                          continue $sm;
                        } else {
                          {
                            if (startsWith$default_1(this._line7, 'kerning ', false, 2, null)) {
                              var tmp15_safe_receiver = this._map8.get_2bw_k$('first');
                              var tmp16_elvis_lhs = tmp15_safe_receiver == null ? null : toIntOrNull(tmp15_safe_receiver);
                              var tmp_13 = tmp16_elvis_lhs == null ? 0 : tmp16_elvis_lhs;
                              var tmp17_safe_receiver = this._map8.get_2bw_k$('second');
                              var tmp18_elvis_lhs = tmp17_safe_receiver == null ? null : toIntOrNull(tmp17_safe_receiver);
                              var tmp_14 = tmp18_elvis_lhs == null ? 0 : tmp18_elvis_lhs;
                              var tmp19_safe_receiver = this._map8.get_2bw_k$('amount');
                              var tmp20_elvis_lhs = tmp19_safe_receiver == null ? null : toIntOrNull(tmp19_safe_receiver);
                              var tmp4_plusAssign_0 = new Kerning(tmp_13, tmp_14, tmp20_elvis_lhs == null ? 0 : tmp20_elvis_lhs);
                              this._kernings0.add_2bq_k$(tmp4_plusAssign_0);
                              Unit_getInstance();
                              this._state_1 = 3;
                              continue $sm;
                            } else {
                              {
                                this._state_1 = 3;
                                continue $sm;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this._mipmaps_2);
            var tmp0_set_0 = slice$default(ARGUMENT_0, null, null, 3, null);
            this._textures_0.put_1q9pf_k$(this._id9, tmp0_set_0);
            Unit_getInstance();
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._state_1 = 1;
            continue $sm;
          case 4:
            var tmp22_atlas = first_0(this._textures_0._get_values__0_k$())._get_bmpBase__0_k$();
            var tmp21_elvis_lhs = this._base4;
            var tmp23_base = tmp21_elvis_lhs == null ? this._lineHeight2_0 : tmp21_elvis_lhs;
            var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._glyphs1, 10));
            var tmp0_iterator_1_2 = this._glyphs1.iterator_0_k$();
            while (tmp0_iterator_1_2.hasNext_0_k$()) {
              var item_2_3 = tmp0_iterator_1_2.next_0_k$();
              tmp0_mapTo_0_1.add_2bq_k$(to(item_2_3._id_4, item_2_3));
              Unit_getInstance();
            }

            var tmp24_glyphs = toIntMap(toMap_0(tmp0_mapTo_0_1));
            var tmp25_kernings = associateByInt(this._kernings0, _no_name_provided_$factory_210());
            var tmp_15 = this._fontSize3;
            var tmp_16 = this._lineHeight2_0;
            return BitmapFont_init_$Create$(tmp_15, tmp_16, tmp23_base, tmp24_glyphs, tmp25_kernings, tmp22_atlas, null, 64, null);
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapFontTxtCOROUTINE$3.$metadata$ = {
    simpleName: '$readBitmapFontTxtCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function naturalFontMetrics$factory() {
    return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
      return _get_naturalFontMetrics_(receiver);
    }, null);
  }
  function bmp$factory() {
    return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
      return receiver._get_bmp__0_k$();
    }, null);
  }
  function dummyGlyph$factory() {
    return getPropertyCallableRef('dummyGlyph', 1, KProperty1, function (receiver) {
      return receiver._get_dummyGlyph__0_k$();
    }, null);
  }
  function anyGlyph$factory() {
    return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
      return receiver._get_anyGlyph__0_k$();
    }, null);
  }
  function baseBmp$factory() {
    return getPropertyCallableRef('baseBmp', 1, KProperty1, function (receiver) {
      return receiver._get_baseBmp__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_205(this$0) {
    var i = new _no_name_provided__254(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_206(this$0) {
    var i = new _no_name_provided__255(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_207(this$0) {
    var i = new _no_name_provided__256(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_208(this$0) {
    var i = new _no_name_provided__257(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_209(this$0) {
    var i = new _no_name_provided__253(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_210() {
    var i = new _no_name_provided__258();
    return function (p1, p2) {
      return i.invoke_8h2c01_k$(p1, p2);
    };
  }
  function CharacterSet_init_$Init$(chars, $this) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(charSequenceLength(chars));
    var indexedObject = chars;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_2bq_k$(item_2_3.toInt_0_k$());
      Unit_getInstance();
    }
    CharacterSet.call($this, toIntArray(tmp0_mapTo_0_1));
    return $this;
  }
  function CharacterSet_init_$Create$(chars) {
    return CharacterSet_init_$Init$(chars, Object.create(CharacterSet.prototype));
  }
  function Companion_143() {
    Companion_instance_142 = this;
    this._SPACE = CharacterSet_init_$Create$(' ');
    var tmp = this;
    var tmp_0 = (new Char(65)).rangeTo_wi8o78_k$(new Char(90));
    tmp._UPPERCASE = CharacterSet_init_$Create$(joinToString$default_0(tmp_0, '', null, null, 0, null, null, 62, null));
    var tmp_1 = this;
    var tmp_2 = (new Char(97)).rangeTo_wi8o78_k$(new Char(122));
    tmp_1._LOWERCASE = CharacterSet_init_$Create$(joinToString$default_0(tmp_2, '', null, null, 0, null, null, 62, null));
    var tmp_3 = this;
    var tmp_4 = (new Char(48)).rangeTo_wi8o78_k$(new Char(57));
    tmp_3._NUMBERS = CharacterSet_init_$Create$(joinToString$default_0(tmp_4, '', null, null, 0, null, null, 62, null));
    this._PUNCTUATION = CharacterSet_init_$Create$('!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}');
    this._LATIN_BASIC = CharacterSet_init_$Create$('\xE7\xC7 \xF1\xD1 \xE5\xC5 \xE6\xC6 \xFF \xA2\xA3\xA5P\xAA\xB0\xBF\xAC\xBD\xBC\xA1\xAB\xBB\xDF\xB5\xF8\xB1\xF7\xB0\xB7.\xB2 \xE1\xE9\xED\xF3\xFA\xE4\xEB\xEF\xF6\xFC\xE0\xE8\xEC\xF2\xF9\xE2\xEA\xEE\xF4\xFB \xC1\xC9\xCD\xD3\xDA\xC4\xCB\xCF\xD6\xDC\xC0\xC8\xCC\xD2\xD9\xC2\xCA\xCE\xD4\xDB');
    this._CYRILLIC = CharacterSet_init_$Create$('\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F');
    this._LATIN_ALL = this._SPACE.plus_9n1urp_k$(this._UPPERCASE).plus_9n1urp_k$(this._LOWERCASE).plus_9n1urp_k$(this._NUMBERS).plus_9n1urp_k$(this._PUNCTUATION).plus_9n1urp_k$(this._LATIN_BASIC);
  }
  Companion_143.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_142;
  function Companion_getInstance_142() {
    if (Companion_instance_142 == null)
      new Companion_143();
    return Companion_instance_142;
  }
  function CharacterSet(codePoints) {
    Companion_getInstance_142();
    this._codePoints = codePoints;
  }
  CharacterSet.prototype.plus_9n1urp_k$ = function (other) {
    var tmp0_plus_0 = this._codePoints;
    var tmp1_plus_0 = other._codePoints;
    return new CharacterSet(primitiveArrayConcat([tmp0_plus_0, tmp1_plus_0]));
  };
  CharacterSet.$metadata$ = {
    simpleName: 'CharacterSet',
    kind: 'class',
    interfaces: []
  };
  var DefaultTtfFontBytes;
  function _get_DefaultTtfFont_() {
    var tmp0_getValue_0 = DefaultTtfFont$factory();
    return DefaultTtfFont$delegate._get_value__0_k$();
  }
  var DefaultTtfFont$delegate;
  function _no_name_provided__259() {
  }
  _no_name_provided__259.prototype.invoke_0_k$ = function () {
    var start_1 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
    var result_2 = TtfFont_init_$Create$_0(DefaultTtfFontBytes, true, 'Default Font', false, 8, null);
    var end_3 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
    var tmp0__get_microseconds__0_5 = end_3 - start_1;
    var elapsed_4 = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_5);
    var res = new TimedResult(result_2, elapsed_4);
    return res._result_1;
  };
  _no_name_provided__259.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function DefaultTtfFont$factory() {
    return getPropertyCallableRef('DefaultTtfFont', 0, KProperty0, function () {
      return _get_DefaultTtfFont_();
    }, null);
  }
  function _no_name_provided_$factory_211() {
    var i = new _no_name_provided__259();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function DefaultTtfFontBytes$init$() {
    var tmp = fromBase64$default('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', false, 1, null);
    var tmp_0 = Companion_getInstance_103();
    return uncompress$default(tmp, tmp_0, 0, 2, null);
  }
  function Font() {
  }
  Font.prototype.getOrNull_0_k$ = function () {
    return this;
  };
  Font.prototype.getFontMetrics$default_2k781i_k$ = function (size_2, metrics, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      metrics = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    }return $handler == null ? this.getFontMetrics_sqtkiv_k$(size_2, metrics) : $handler(size_2, metrics);
  };
  Font.prototype.getGlyphMetrics$default_vit8xo_k$ = function (size_2, codePoint, metrics, $mask0, $handler) {
    if (!(($mask0 & 4) === 0)) {
      metrics = GlyphMetrics_init_$Create$(0.0, false, 0, null, 0.0, 31, null);
    }return $handler == null ? this.getGlyphMetrics_xejy1t_k$(size_2, codePoint, metrics) : $handler(size_2, codePoint, metrics);
  };
  Font.$metadata$ = {
    simpleName: 'Font',
    kind: 'interface',
    interfaces: [Resourceable]
  };
  function drawText(_this_, ctx, size_2, text, paint, x, y, fill_4, renderer, placed) {
    var actions = new _no_name_provided__260(ctx, x, y, paint, size_2, placed, fill_4);
    renderer.invoke_q7g7zr_k$(actions, text, size_2, _this_);
  }
  function drawText$default(_this_, ctx, size_2, text, paint, x, y, fill_4, renderer, placed, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      x = 0.0;
    if (!(($mask0 & 32) === 0))
      y = 0.0;
    if (!(($mask0 & 64) === 0))
      fill_4 = true;
    if (!(($mask0 & 128) === 0)) {
      var tmp = DefaultStringTextRenderer;
      renderer = isInterface(tmp, TextRenderer) ? tmp : THROW_CCE();
    }if (!(($mask0 & 256) === 0))
      placed = null;
    return drawText(_this_, ctx, size_2, text, paint, x, y, fill_4, renderer, placed);
  }
  function getTextBounds(_this_, size_2, text, out, renderer) {
    var actions = new BoundBuilderTextRendererActions();
    renderer.invoke_q7g7zr_k$(actions, text, size_2, _this_);
    actions._bb.getBounds_uebyw0_k$(out._bounds_2);
    Unit_getInstance();
    actions._flbb.getBounds_uebyw0_k$(out._firstLineBounds);
    Unit_getInstance();
    out._nlines = actions._get_nlines__0_k$();
    _this_.getFontMetrics_sqtkiv_k$(size_2, out._fontMetrics);
    Unit_getInstance();
    return out;
  }
  function getTextBounds$default(_this_, size_2, text, out, renderer, $mask0, $handler) {
    if (!(($mask0 & 4) === 0)) {
      out = TextMetrics_init_$Create$(null, null, null, 0, 15, null);
    }if (!(($mask0 & 8) === 0)) {
      var tmp = DefaultStringTextRenderer;
      renderer = isInterface(tmp, TextRenderer) ? tmp : THROW_CCE();
    }return getTextBounds(_this_, size_2, text, out, renderer);
  }
  function TextToBitmapResult(bmp, fmetrics, metrics, glyphs) {
    this._bmp_1 = bmp;
    this._fmetrics = fmetrics;
    this._metrics = metrics;
    this._glyphs_0 = glyphs;
  }
  TextToBitmapResult.prototype.toString = function () {
    return '' + 'TextToBitmapResult(bmp=' + this._bmp_1 + ', fmetrics=' + this._fmetrics + ', metrics=' + this._metrics + ', glyphs=' + this._glyphs_0 + ')';
  };
  TextToBitmapResult.prototype.hashCode = function () {
    var result = hashCode(this._bmp_1);
    result = imul(result, 31) + this._fmetrics.hashCode() | 0;
    result = imul(result, 31) + this._metrics.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._glyphs_0) | 0;
    return result;
  };
  TextToBitmapResult.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals_1(this._bmp_1, tmp0_other_with_cast._bmp_1))
      return false;
    if (!this._fmetrics.equals(tmp0_other_with_cast._fmetrics))
      return false;
    if (!this._metrics.equals(tmp0_other_with_cast._metrics))
      return false;
    if (!equals_1(this._glyphs_0, tmp0_other_with_cast._glyphs_0))
      return false;
    return true;
  };
  TextToBitmapResult.$metadata$ = {
    simpleName: 'TextToBitmapResult',
    kind: 'class',
    interfaces: [BaseTextMetricsResult]
  };
  function renderTextToBitmap(_this_, size_2, text, paint, background, fill_4, border, renderer, returnGlyphs, nativeRendering, drawBorder) {
    var font = _this_;
    var bounds_0 = getTextBounds$default(_this_, size_2, text, null, renderer, 4, null);
    var glyphs = ArrayList_init_$Create$();
    var iwidth = (toIntCeil(bounds_0._get_width__0_k$()) + imul(border, 2) | 0) + 1 | 0;
    var iheight = (toIntCeil(drawBorder ? bounds_0._get_allLineHeight__0_k$() : bounds_0._get_height__0_k$()) + imul(border, 2) | 0) + 1 | 0;
    var tmp;
    if (nativeRendering) {
      tmp = NativeImage$default(iwidth, iheight, null, 4, null);
    } else {
      tmp = Bitmap32_init_$Create$(iwidth, iheight, null, true, 4, null);
    }
    var image = tmp;
    image.lock_sv8swh_k$();
    try {
      var ctx_2_1 = image.getContext2d_vcj5fe_k$(true);
      try {
        if (!equals_1(background, NonePaint_getInstance())) {
          var oldStyle_1_3 = ctx_2_1._get_fillStyle__0_k$();
          ctx_2_1._set_fillStyle__y73s1i_k$(background);
          try {
            ctx_2_1.fillRect_lf7oid_k$(0.0, 0.0, numberToDouble(iwidth), numberToDouble(iheight));
          }finally {
            ctx_2_1._set_fillStyle__y73s1i_k$(oldStyle_1_3);
          }
        }var index_4 = {_v: 0};
        var tmp_0 = bounds_0._get_drawLeft__0_k$();
        var tmp_1 = bounds_0._get_ascent__0_k$();
        drawText(font, ctx_2_1, size_2, text, paint, tmp_0, tmp_1, fill_4, renderer, _no_name_provided_$factory_212(returnGlyphs, index_4, glyphs));
      }finally {
        ctx_2_1.dispose_sv8swh_k$();
      }
    }finally {
      image.unlock_ixubtt_k$(null);
      Unit_getInstance();
    }
    Unit_getInstance();
    return new TextToBitmapResult(image, bounds_0._fontMetrics, bounds_0, glyphs);
  }
  function renderTextToBitmap$default(_this_, size_2, text, paint, background, fill_4, border, renderer, returnGlyphs, nativeRendering, drawBorder, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      paint = new RGBA(_get_DefaultPaint_());
    if (!(($mask0 & 8) === 0))
      background = NonePaint_getInstance();
    if (!(($mask0 & 16) === 0))
      fill_4 = true;
    if (!(($mask0 & 32) === 0))
      border = 0;
    if (!(($mask0 & 64) === 0)) {
      var tmp = DefaultStringTextRenderer;
      renderer = isInterface(tmp, TextRenderer) ? tmp : THROW_CCE();
    }if (!(($mask0 & 128) === 0))
      returnGlyphs = true;
    if (!(($mask0 & 256) === 0))
      nativeRendering = true;
    if (!(($mask0 & 512) === 0))
      drawBorder = false;
    return renderTextToBitmap(_this_, size_2, text, paint, background, fill_4, border, renderer, returnGlyphs, nativeRendering, drawBorder);
  }
  function PlacedGlyphMetrics(codePoint, x, y, metrics, transform, index_0) {
    this._codePoint = codePoint;
    this._x_11 = x;
    this._y_10 = y;
    this._metrics_0 = metrics;
    this._transform_0 = transform;
    this._index_17 = index_0;
  }
  PlacedGlyphMetrics.prototype.toString = function () {
    return '' + 'PlacedGlyphMetrics(codePoint=' + this._codePoint + ', x=' + this._x_11 + ', y=' + this._y_10 + ', metrics=' + this._metrics_0 + ', transform=' + this._transform_0 + ', index=' + this._index_17 + ')';
  };
  PlacedGlyphMetrics.prototype.hashCode = function () {
    var result = this._codePoint;
    result = imul(result, 31) + getNumberHashCode(this._x_11) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y_10) | 0;
    result = imul(result, 31) + this._metrics_0.hashCode() | 0;
    result = imul(result, 31) + this._transform_0.hashCode() | 0;
    result = imul(result, 31) + this._index_17 | 0;
    return result;
  };
  PlacedGlyphMetrics.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this._codePoint === tmp0_other_with_cast._codePoint))
      return false;
    if (!equals_1(this._x_11, tmp0_other_with_cast._x_11))
      return false;
    if (!equals_1(this._y_10, tmp0_other_with_cast._y_10))
      return false;
    if (!this._metrics_0.equals(tmp0_other_with_cast._metrics_0))
      return false;
    if (!this._transform_0.equals(tmp0_other_with_cast._transform_0))
      return false;
    if (!(this._index_17 === tmp0_other_with_cast._index_17))
      return false;
    return true;
  };
  PlacedGlyphMetrics.$metadata$ = {
    simpleName: 'PlacedGlyphMetrics',
    kind: 'class',
    interfaces: []
  };
  function BaseTextMetricsResult() {
  }
  BaseTextMetricsResult.$metadata$ = {
    simpleName: 'BaseTextMetricsResult',
    kind: 'interface',
    interfaces: []
  };
  function renderGlyphToBitmap(_this_, size_2, codePoint, paint, fill_4, effect, border, nativeRendering) {
    var font = _this_;
    var fmetrics = _this_.getFontMetrics$default_2k781i_k$(size_2, null, 2, null);
    var gmetrics = _this_.getGlyphMetrics$default_vit8xo_k$(size_2, codePoint, null, 4, null);
    var gx = -gmetrics._get_left__0_k$();
    var gy = gmetrics._get_height__0_k$() + gmetrics._get_top__0_k$();
    var border2 = imul(border, 2);
    var iwidth = toIntCeil(gmetrics._get_width__0_k$()) + border2 | 0;
    var iheight = toIntCeil(gmetrics._get_height__0_k$()) + border2 | 0;
    var tmp;
    if (nativeRendering) {
      tmp = NativeImage$default(iwidth, iheight, null, 4, null);
    } else {
      tmp = Bitmap32_init_$Create$(iwidth, iheight, null, true, 4, null);
    }
    var image = tmp;
    image.lock_sv8swh_k$();
    try {
      var ctx_2_1 = image.getContext2d_vcj5fe_k$(true);
      try {
        ctx_2_1._set_fillStyle__y73s1i_k$(paint);
        font.renderGlyph_its5jl_k$(ctx_2_1, size_2, codePoint, gx + border, gy + border, true, gmetrics);
        if (fill_4)
          ctx_2_1.fill_sv8swh_k$();
        else
          ctx_2_1.stroke_sv8swh_k$();
      }finally {
        ctx_2_1.dispose_sv8swh_k$();
      }
    }finally {
      image.unlock_ixubtt_k$(null);
      Unit_getInstance();
    }
    Unit_getInstance();
    var imageOut = applyEffect(image.toBMP32IfRequired_0_k$(), effect);
    var tmp_0 = TextMetrics_init_$Create$(null, null, null, 0, 15, null);
    var tmp_1 = gx + border;
    var tmp_2 = gy + border;
    return new TextToBitmapResult(imageOut, fmetrics, tmp_0, listOf_0(new PlacedGlyphMetrics(codePoint, tmp_1, tmp_2, gmetrics, Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null), 0)));
  }
  function renderGlyphToBitmap$default(_this_, size_2, codePoint, paint, fill_4, effect, border, nativeRendering, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      paint = new RGBA(_get_DefaultPaint_());
    if (!(($mask0 & 8) === 0))
      fill_4 = true;
    if (!(($mask0 & 16) === 0))
      effect = null;
    if (!(($mask0 & 32) === 0))
      border = 1;
    if (!(($mask0 & 64) === 0))
      nativeRendering = true;
    return renderGlyphToBitmap(_this_, size_2, codePoint, paint, fill_4, effect, border, nativeRendering);
  }
  function _no_name_provided__260($ctx, $x, $y, $paint, $size, $placed, $fill) {
    this._$ctx = $ctx;
    this._$x = $x;
    this._$y = $y;
    this._$paint = $paint;
    this._$size_0 = $size;
    this._$placed = $placed;
    this._$fill = $fill;
    TextRendererActions.call(this);
  }
  _no_name_provided__260.prototype.put_ha5a7z_k$ = function (codePoint) {
    if (!(this._$ctx == null)) {
      var t_1 = this._$ctx._state_5._transform_6;
      var a_2 = t_1._a;
      var b_3 = t_1._b;
      var c_4 = t_1._c;
      var d_5 = t_1._d;
      var tx_6 = t_1._tx;
      var ty_7 = t_1._ty;
      try {
        var m_9 = this.getGlyphMetrics_ha5a7z_k$(codePoint);
        this._$ctx.translate_ngl742_k$(this._get_x__0_k$() + this._$x, this._get_y__0_k$() + this._$y);
        Unit_getInstance();
        this._$ctx.transform_lwp7hs_k$(this._get_transform__0_k$());
        Unit_getInstance();
        var tmp0_elvis_lhs_11 = this._get_paint__0_k$();
        var tmp1_elvis_lhs_10 = tmp0_elvis_lhs_11 == null ? this._$paint : tmp0_elvis_lhs_11;
        this._$ctx._set_fillStyle__y73s1i_k$(tmp1_elvis_lhs_10 == null ? NonePaint_getInstance() : tmp1_elvis_lhs_10);
        this._get_font__0_k$().renderGlyph_its5jl_k$(this._$ctx, this._$size_0, codePoint, 0.0, 0.0, true, this._get_glyphMetrics__0_k$());
        var tmp2_safe_receiver_12 = this._$placed;
        if (tmp2_safe_receiver_12 == null)
          null;
        else
          tmp2_safe_receiver_12(codePoint, this._get_x__0_k$() + this._$x, this._get_y__0_k$() + this._$y, this._$size_0, this._get_glyphMetrics__0_k$(), this._get_transform__0_k$());
        Unit_getInstance();
        if (this._$fill)
          this._$ctx.fill_sv8swh_k$();
        else
          this._$ctx.stroke_sv8swh_k$();
      }finally {
        t_1.setTo_hmhsjq_k$(a_2, b_3, c_4, d_5, tx_6, ty_7);
        Unit_getInstance();
      }
    } else {
      var tmp0_safe_receiver = this._$placed;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(codePoint, this._get_x__0_k$() + this._$x, this._get_y__0_k$() + this._$y, this._$size_0, this._get_glyphMetrics__0_k$(), this._get_transform__0_k$());
      Unit_getInstance();
    }
    return this._get_glyphMetrics__0_k$();
  };
  _no_name_provided__260.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__261($returnGlyphs, $index_4, $glyphs) {
    this._$returnGlyphs = $returnGlyphs;
    this._$index_4 = $index_4;
    this._$glyphs = $glyphs;
  }
  _no_name_provided__261.prototype.invoke_eopkqu_k$ = function (codePoint, x, y, size_2, metrics, transform) {
    if (this._$returnGlyphs) {
      var tmp = metrics.clone_0_k$();
      var tmp_0 = transform.clone_0_k$();
      var tmp0_7 = this._$index_4._v;
      this._$index_4._v = tmp0_7 + 1 | 0;
      var tmp0_plusAssign_0_6 = new PlacedGlyphMetrics(codePoint, x, y, tmp, tmp_0, tmp0_7);
      this._$glyphs.add_2bq_k$(tmp0_plusAssign_0_6);
      Unit_getInstance();
    }};
  _no_name_provided__261.prototype.invoke_g729kt_k$ = function (p1, p2, p3, p4, p5, p6) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    var tmp_3 = p5 instanceof GlyphMetrics ? p5 : THROW_CCE();
    this.invoke_eopkqu_k$(tmp, tmp_0, tmp_1, tmp_2, tmp_3, p6 instanceof Matrix ? p6 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__261.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_212($returnGlyphs, $index_4, $glyphs) {
    var i = new _no_name_provided__261($returnGlyphs, $index_4, $glyphs);
    return function (p1, p2, p3, p4, p5, p6) {
      i.invoke_eopkqu_k$(p1, p2, p3, p4, p5, p6);
      return Unit_getInstance();
    };
  }
  function readFont(_this_, preload, imageFormat, mipmaps_0, $cont) {
    var tmp = new $readFontCOROUTINE$4(_this_, preload, imageFormat, mipmaps_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readFont$default(_this_, preload, imageFormat, mipmaps_0, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      preload = false;
    if (!(($mask0 & 2) === 0))
      imageFormat = RegisteredImageFormats_getInstance();
    if (!(($mask0 & 4) === 0))
      mipmaps_0 = true;
    return readFont(_this_, preload, imageFormat, mipmaps_0, $cont);
  }
  function $emit_2_8_4_4COROUTINE$6(_this_, value, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__120 = _this_;
    this._value_20 = value;
  }
  $emit_2_8_4_4COROUTINE$6.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (_get_extensionLC__0(this._value_20) === 'ttf' ? true : _get_extensionLC__0(this._value_20) === 'fnt') {
              this._state_1 = 3;
              suspendResult = this.__this__120._$collector.emit_iav7o_k$(this._value_20, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 2;
                continue $sm;
              }
            }

            break;
          case 2:
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._tmp$ret$00_2 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $emit_2_8_4_4COROUTINE$6.$metadata$ = {
    simpleName: '$emit_2_8_4_4COROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_7_3_3($collector) {
    this._$collector = $collector;
  }
  _no_name_provided__1_7_3_3.prototype.emit_2_8_4_4_ba5hwt_k$ = function (value, $cont) {
    var tmp = new $emit_2_8_4_4COROUTINE$6(this, value, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__1_7_3_3.prototype.emit_iav7o_k$ = function (value, $cont) {
    return this.emit_2_8_4_4_ba5hwt_k$(value instanceof VfsFile ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_7_3_3.$metadata$ = {
    simpleName: '<no name provided>_1_7_3_3',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function $collect_2_2_2COROUTINE$5(_this_, collector, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__121 = _this_;
    this._collector_2 = collector;
  }
  $collect_2_2_2COROUTINE$5.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__121._$tmp0_filter_0.collect_l0hod5_k$(new _no_name_provided__1_7_3_3(this._collector_2), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $collect_2_2_2COROUTINE$5.$metadata$ = {
    simpleName: '$collect_2_2_2COROUTINE$5',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_1_1($tmp0_filter_0) {
    this._$tmp0_filter_0 = $tmp0_filter_0;
  }
  _no_name_provided__1_1_1.prototype.collect_2_2_2_8bppsg_k$ = function (collector, $cont) {
    var tmp = new $collect_2_2_2COROUTINE$5(this, collector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__1_1_1.prototype.collect_l0hod5_k$ = function (collector, $cont) {
    return this.collect_2_2_2_8bppsg_k$(collector, $cont);
  };
  _no_name_provided__1_1_1.$metadata$ = {
    simpleName: '<no name provided>_1_1_1',
    kind: 'class',
    interfaces: [Flow]
  };
  function _no_name_provided__262(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__262.prototype.invoke_edgwu6_k$ = function (it, $cont) {
    var tmp = this.create_alpgry_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__262.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_edgwu6_k$(p1 instanceof VfsFile ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__262.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = this._it.listRecursive$default_wd3a4q_k$(null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_filter_00 = suspendResult;
            var tmp_0 = this;
            tmp_0._ARGUMENT1_8 = new _no_name_provided__1_1_1(this._tmp0_filter_00);
            this._state_1 = 2;
            suspendResult = firstOrNull_1(this._ARGUMENT1_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._tmp0_safe_receiver2_0 = suspendResult;
            if (this._tmp0_safe_receiver2_0 == null) {
              this._WHEN_RESULT3_0 = null;
              this._state_1 = 4;
              continue $sm;
            } else {
              this._state_1 = 3;
              suspendResult = readFont$default(this._tmp0_safe_receiver2_0, false, null, false, 7, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 3:
            this._WHEN_RESULT3_0 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            var tmp1_elvis_lhs = this._WHEN_RESULT3_0;
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              throw IllegalStateException_init_$Create$_0("Can't find TTF or FNT on zip");
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            return tmp_1;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__262.prototype.create_alpgry_k$ = function (it, completion) {
    var i = new _no_name_provided__262(completion);
    i._it = it;
    return i;
  };
  _no_name_provided__262.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $readFontCOROUTINE$4(_this_, preload, imageFormat, mipmaps_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__122 = _this_;
    this._preload = preload;
    this._imageFormat_2 = imageFormat;
    this._mipmaps_3 = mipmaps_0;
  }
  $readFontCOROUTINE$4.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._state_1 = 1;
            suspendResult = this.__this__122.readRangeBytes_em8bnc_k$(until(0, 16), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._header0 = suspendResult;
            this._tmp0_subject1 = readS32BE(this._header0, 0);
            if (this._tmp0_subject1 === 65536) {
              this._state_1 = 4;
              suspendResult = readTtfFont$default(this.__this__122, this._preload, false, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              if (this._tmp0_subject1 === 1330926671) {
                var tmp_0 = this;
                throw new NotImplementedError('An operation is not implemented: Unsupported OpenType fonts');
              } else {
                if (this._tmp0_subject1 === 1347093252) {
                  this._state_1 = 3;
                  suspendResult = openAsZip$default(this.__this__122, false, false, _no_name_provided_$factory_213(null), 3, null, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  this._state_1 = 2;
                  suspendResult = readBitmapFont(this.__this__122, this._imageFormat_2, this._mipmaps_3, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                }
                Unit_getInstance();
              }
              Unit_getInstance();
            }

            break;
          case 2:
            this._WHEN_RESULT2_1 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 3:
            this._WHEN_RESULT2_1 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 4:
            this._WHEN_RESULT2_1 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT2_1;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readFontCOROUTINE$4.$metadata$ = {
    simpleName: '$readFontCOROUTINE$4',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_213(resultContinuation) {
    var i = new _no_name_provided__262(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_edgwu6_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function FontRegistry() {
  }
  FontRegistry.prototype.get_6wfw3l_k$ = function (name) {
    return new SystemFont(_SystemFont___init__impl_(name));
  };
  FontRegistry.$metadata$ = {
    simpleName: 'FontRegistry',
    kind: 'interface',
    interfaces: []
  };
  function SystemFontRegistry() {
    SystemFontRegistry_instance = this;
    DefaultFontRegistry.call(this);
    var tmp = this;
    var tmp_0 = _get_DefaultTtfFont_();
    tmp._DEFAULT_FONT = register$default(tmp_0, null, 'sans-serif', 1, null);
  }
  SystemFontRegistry.$metadata$ = {
    simpleName: 'SystemFontRegistry',
    kind: 'object',
    interfaces: []
  };
  var SystemFontRegistry_instance;
  function SystemFontRegistry_getInstance() {
    if (SystemFontRegistry_instance == null)
      new SystemFontRegistry();
    return SystemFontRegistry_instance;
  }
  function DefaultFontRegistry() {
    this._registeredFonts = new CopyOnWriteFrozenMap();
  }
  DefaultFontRegistry.prototype.normalizeName_6wfw3l_k$ = function (name) {
    var tmp0_trim_0 = name.toLowerCase();
    return toString_1(trim_0(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE()));
  };
  DefaultFontRegistry.prototype.register_bigmsa_k$ = function (font, name) {
    var tmp0_set_0_2 = this._registeredFonts;
    var tmp1_set_0_3 = this.normalizeName_6wfw3l_k$(name);
    tmp0_set_0_2.put_1q9pf_k$(tmp1_set_0_3, font);
    Unit_getInstance();
    return font;
  };
  DefaultFontRegistry.prototype.get_6wfw3l_k$ = function (name) {
    var tmp0_elvis_lhs = this._registeredFonts.get_2bw_k$(this.normalizeName_6wfw3l_k$(name));
    return tmp0_elvis_lhs == null ? new SystemFont(_SystemFont___init__impl_(name)) : tmp0_elvis_lhs;
  };
  DefaultFontRegistry.$metadata$ = {
    simpleName: 'DefaultFontRegistry',
    kind: 'class',
    interfaces: [FontRegistry]
  };
  function register(_this_, registry, name) {
    registry.register_bigmsa_k$(_this_, name);
    Unit_getInstance();
    return _this_;
  }
  function register$default(_this_, registry, name, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      registry = SystemFontRegistry_getInstance();
    if (!(($mask0 & 2) === 0))
      name = _this_._get_name__0_k$();
    return register(_this_, registry, name);
  }
  function GlyphPath_init_$Init$(path_0, colorPaths, bitmap, bitmapOffset, bitmapScale, transform, scale_1, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      path_0 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    }if (!(($mask0 & 2) === 0))
      colorPaths = null;
    if (!(($mask0 & 4) === 0))
      bitmap = null;
    if (!(($mask0 & 8) === 0))
      bitmapOffset = Point_init_$Create$_0(0, 0);
    if (!(($mask0 & 16) === 0))
      bitmapScale = Point_init_$Create$_0(1, 1);
    if (!(($mask0 & 32) === 0)) {
      transform = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }if (!(($mask0 & 64) === 0))
      scale_1 = 1.0;
    GlyphPath.call($this, path_0, colorPaths, bitmap, bitmapOffset, bitmapScale, transform, scale_1);
    return $this;
  }
  function GlyphPath_init_$Create$(path_0, colorPaths, bitmap, bitmapOffset, bitmapScale, transform, scale_1, $mask0, $marker) {
    return GlyphPath_init_$Init$(path_0, colorPaths, bitmap, bitmapOffset, bitmapScale, transform, scale_1, $mask0, $marker, Object.create(GlyphPath.prototype));
  }
  function GlyphPath(path_0, colorPaths, bitmap, bitmapOffset, bitmapScale, transform, scale_1) {
    this._path_17 = path_0;
    this._colorPaths = colorPaths;
    this._bitmap_0 = bitmap;
    this._bitmapOffset = bitmapOffset;
    this._bitmapScale = bitmapScale;
    this._transform_1 = transform;
    this._scale = scale_1;
  }
  GlyphPath.prototype.draw_h81jc_k$ = function (c) {
    var t_1 = c._state_5._transform_6;
    var a_2 = t_1._a;
    var b_3 = t_1._b;
    var c_4 = t_1._c;
    var d_5 = t_1._d;
    var tx_6 = t_1._tx;
    var ty_7 = t_1._ty;
    try {
      c.beginPath_sv8swh_k$();
      c.transform_lwp7hs_k$(this._transform_1);
      Unit_getInstance();
      if (!(this._bitmap_0 == null)) {
        c.drawImage_c2z1l2_k$(ensureNotNull(this._bitmap_0), this._bitmapOffset._x_1, this._bitmapOffset._y_1, ensureNotNull(this._bitmap_0)._width_2 * this._bitmapScale._x_1, ensureNotNull(this._bitmap_0)._height_3 * this._bitmapScale._y_1);
      } else if (!(this._colorPaths == null)) {
        var tmp0_safe_receiver_9 = this._colorPaths;
        if (tmp0_safe_receiver_9 == null)
          null;
        else {
          var n_1_10 = 0;
          while (n_1_10 < tmp0_safe_receiver_9._get_size__0_k$()) {
            var tmp0_2_12 = n_1_10;
            n_1_10 = tmp0_2_12 + 1 | 0;
            var tmp0__anonymous__3_11 = tmp0_safe_receiver_9.get_ha5a7z_k$(tmp0_2_12);
            c.draw_ndfaxx_k$(tmp0__anonymous__3_11);
          }
          Unit_getInstance();
        }
        Unit_getInstance();
      } else {
        c.draw_ndfaxx_k$(this._path_17);
      }
    }finally {
      t_1.setTo_hmhsjq_k$(a_2, b_3, c_4, d_5, tx_6, ty_7);
      Unit_getInstance();
    }
  };
  GlyphPath.prototype.toString = function () {
    return '' + 'GlyphPath(path=' + this._path_17 + ', colorPaths=' + this._colorPaths + ', bitmap=' + this._bitmap_0 + ', bitmapOffset=' + this._bitmapOffset + ', bitmapScale=' + this._bitmapScale + ', transform=' + this._transform_1 + ', scale=' + this._scale + ')';
  };
  GlyphPath.prototype.hashCode = function () {
    var result = hashCode(this._path_17);
    result = imul(result, 31) + (this._colorPaths == null ? 0 : hashCode(this._colorPaths)) | 0;
    result = imul(result, 31) + (this._bitmap_0 == null ? 0 : hashCode(this._bitmap_0)) | 0;
    result = imul(result, 31) + this._bitmapOffset.hashCode() | 0;
    result = imul(result, 31) + this._bitmapScale.hashCode() | 0;
    result = imul(result, 31) + this._transform_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._scale) | 0;
    return result;
  };
  GlyphPath.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!equals_1(this._path_17, tmp0_other_with_cast._path_17))
      return false;
    if (!equals_1(this._colorPaths, tmp0_other_with_cast._colorPaths))
      return false;
    if (!equals_1(this._bitmap_0, tmp0_other_with_cast._bitmap_0))
      return false;
    if (!this._bitmapOffset.equals(tmp0_other_with_cast._bitmapOffset))
      return false;
    if (!this._bitmapScale.equals(tmp0_other_with_cast._bitmapScale))
      return false;
    if (!this._transform_1.equals(tmp0_other_with_cast._transform_1))
      return false;
    if (!equals_1(this._scale, tmp0_other_with_cast._scale))
      return false;
    return true;
  };
  GlyphPath.$metadata$ = {
    simpleName: 'GlyphPath',
    kind: 'class',
    interfaces: [Drawable]
  };
  function FontMetrics_init_$Init$(size_2, top, ascent, baseline, descent, bottom, leading, maxWidth, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      size_2 = 0.0;
    if (!(($mask0 & 2) === 0))
      top = 0.0;
    if (!(($mask0 & 4) === 0))
      ascent = 0.0;
    if (!(($mask0 & 8) === 0))
      baseline = 0.0;
    if (!(($mask0 & 16) === 0))
      descent = 0.0;
    if (!(($mask0 & 32) === 0))
      bottom = 0.0;
    if (!(($mask0 & 64) === 0))
      leading = 0.0;
    if (!(($mask0 & 128) === 0))
      maxWidth = 0.0;
    FontMetrics.call($this, size_2, top, ascent, baseline, descent, bottom, leading, maxWidth);
    return $this;
  }
  function FontMetrics_init_$Create$(size_2, top, ascent, baseline, descent, bottom, leading, maxWidth, $mask0, $marker) {
    return FontMetrics_init_$Init$(size_2, top, ascent, baseline, descent, bottom, leading, maxWidth, $mask0, $marker, Object.create(FontMetrics.prototype));
  }
  function FontMetrics(size_2, top, ascent, baseline, descent, bottom, leading, maxWidth) {
    this._size_13 = size_2;
    this._top = top;
    this._ascent = ascent;
    this._baseline = baseline;
    this._descent = descent;
    this._bottom = bottom;
    this._leading = leading;
    this._maxWidth = maxWidth;
  }
  FontMetrics.prototype._get_emHeight__0_k$ = function () {
    return this._ascent - this._descent;
  };
  FontMetrics.prototype._get_lineHeight__0_k$ = function () {
    return this._top - this._bottom;
  };
  FontMetrics.prototype.copyFromNewSize_1pu7zb_k$ = function (other, size_2) {
    return this.copyFromScaled_1pu7zb_k$(other, size_2 / other._size_13);
  };
  FontMetrics.prototype.copyFromScaled_1pu7zb_k$ = function (other, scale_1) {
    this._size_13 = other._size_13 * scale_1;
    this._top = other._top * scale_1;
    this._ascent = other._ascent * scale_1;
    this._baseline = other._baseline * scale_1;
    this._descent = other._descent * scale_1;
    this._bottom = other._bottom * scale_1;
    this._leading = other._leading * scale_1;
    this._maxWidth = other._maxWidth * scale_1;
    return this;
  };
  FontMetrics.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_uch40_k$('FontMetrics(');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'size=' + toIntRound(this._size_13) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'top=' + toIntRound(this._top) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'ascent=' + toIntRound(this._ascent) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'baseline=' + toIntRound(this._baseline) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'descent=' + toIntRound(this._descent) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'bottom=' + toIntRound(this._bottom) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'leading=' + toIntRound(this._leading) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'emHeight=' + toIntRound(this._get_emHeight__0_k$()) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'lineHeight=' + toIntRound(this._get_lineHeight__0_k$()));
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$(')');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  FontMetrics.prototype.hashCode = function () {
    var result = getNumberHashCode(this._size_13);
    result = imul(result, 31) + getNumberHashCode(this._top) | 0;
    result = imul(result, 31) + getNumberHashCode(this._ascent) | 0;
    result = imul(result, 31) + getNumberHashCode(this._baseline) | 0;
    result = imul(result, 31) + getNumberHashCode(this._descent) | 0;
    result = imul(result, 31) + getNumberHashCode(this._bottom) | 0;
    result = imul(result, 31) + getNumberHashCode(this._leading) | 0;
    result = imul(result, 31) + getNumberHashCode(this._maxWidth) | 0;
    return result;
  };
  FontMetrics.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals_1(this._size_13, tmp0_other_with_cast._size_13))
      return false;
    if (!equals_1(this._top, tmp0_other_with_cast._top))
      return false;
    if (!equals_1(this._ascent, tmp0_other_with_cast._ascent))
      return false;
    if (!equals_1(this._baseline, tmp0_other_with_cast._baseline))
      return false;
    if (!equals_1(this._descent, tmp0_other_with_cast._descent))
      return false;
    if (!equals_1(this._bottom, tmp0_other_with_cast._bottom))
      return false;
    if (!equals_1(this._leading, tmp0_other_with_cast._leading))
      return false;
    if (!equals_1(this._maxWidth, tmp0_other_with_cast._maxWidth))
      return false;
    return true;
  };
  FontMetrics.$metadata$ = {
    simpleName: 'FontMetrics',
    kind: 'class',
    interfaces: []
  };
  function GlyphMetrics_init_$Init$(size_2, existing, codePoint, bounds_0, xadvance, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      size_2 = 0.0;
    if (!(($mask0 & 2) === 0))
      existing = false;
    if (!(($mask0 & 4) === 0))
      codePoint = 0;
    if (!(($mask0 & 8) === 0))
      bounds_0 = Companion_getInstance_35().invoke_0_k$();
    if (!(($mask0 & 16) === 0))
      xadvance = 0.0;
    GlyphMetrics.call($this, size_2, existing, codePoint, bounds_0, xadvance);
    return $this;
  }
  function GlyphMetrics_init_$Create$(size_2, existing, codePoint, bounds_0, xadvance, $mask0, $marker) {
    return GlyphMetrics_init_$Init$(size_2, existing, codePoint, bounds_0, xadvance, $mask0, $marker, Object.create(GlyphMetrics.prototype));
  }
  function GlyphMetrics(size_2, existing, codePoint, bounds_0, xadvance) {
    this._size_14 = size_2;
    this._existing = existing;
    this._codePoint_0 = codePoint;
    this._bounds_1 = bounds_0;
    this._xadvance_0 = xadvance;
  }
  GlyphMetrics.prototype._get_left__0_k$ = function () {
    return this._bounds_1._get_left__0_k$();
  };
  GlyphMetrics.prototype._get_top__0_k$ = function () {
    return this._bounds_1._get_top__0_k$();
  };
  GlyphMetrics.prototype._get_width__0_k$ = function () {
    return this._bounds_1._width_0;
  };
  GlyphMetrics.prototype._get_height__0_k$ = function () {
    return this._bounds_1._height_0;
  };
  GlyphMetrics.prototype.clone_0_k$ = function () {
    var tmp = this._bounds_1.clone_0_k$();
    return this.copy$default_z6tqcq_k$(0.0, false, 0, tmp, 0.0, 23, null);
  };
  GlyphMetrics.prototype.copyFromNewSize_n1q0an_k$ = function (other, size_2, codePoint) {
    return this.copyFromScaled_n1q0an_k$(other, size_2 / other._size_14, codePoint);
  };
  GlyphMetrics.prototype.copyFromScaled_n1q0an_k$ = function (other, scale_1, codePoint) {
    this._size_14 = other._size_14;
    this._existing = other._existing;
    this._codePoint_0 = codePoint;
    this._bounds_1.setTo_i6u10_k$(other._bounds_1._x_2 * scale_1, other._bounds_1._y_2 * scale_1, other._bounds_1._width_0 * scale_1, other._bounds_1._height_0 * scale_1);
    Unit_getInstance();
    this._xadvance_0 = other._xadvance_0 * scale_1;
    return this;
  };
  GlyphMetrics.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_uch40_k$('GlyphMetrics(');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'codePoint=' + this._codePoint_0 + " ('" + numberToChar(this._codePoint_0) + "'), ");
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'existing=' + this._existing + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'xadvance=' + roundToInt(this._xadvance_0) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + 'bounds=' + new RectangleInt(this._bounds_1.toInt_t4v1qq_k$()));
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$(')');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  GlyphMetrics.prototype.copy_of3r4r_k$ = function (size_2, existing, codePoint, bounds_0, xadvance) {
    return new GlyphMetrics(size_2, existing, codePoint, bounds_0, xadvance);
  };
  GlyphMetrics.prototype.copy$default_z6tqcq_k$ = function (size_2, existing, codePoint, bounds_0, xadvance, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      size_2 = this._size_14;
    if (!(($mask0 & 2) === 0))
      existing = this._existing;
    if (!(($mask0 & 4) === 0))
      codePoint = this._codePoint_0;
    if (!(($mask0 & 8) === 0))
      bounds_0 = this._bounds_1;
    if (!(($mask0 & 16) === 0))
      xadvance = this._xadvance_0;
    return this.copy_of3r4r_k$(size_2, existing, codePoint, bounds_0, xadvance);
  };
  GlyphMetrics.prototype.hashCode = function () {
    var result = getNumberHashCode(this._size_14);
    result = imul(result, 31) + (this._existing | 0) | 0;
    result = imul(result, 31) + this._codePoint_0 | 0;
    result = imul(result, 31) + this._bounds_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._xadvance_0) | 0;
    return result;
  };
  GlyphMetrics.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals_1(this._size_14, tmp0_other_with_cast._size_14))
      return false;
    if (!(this._existing === tmp0_other_with_cast._existing))
      return false;
    if (!(this._codePoint_0 === tmp0_other_with_cast._codePoint_0))
      return false;
    if (!this._bounds_1.equals(tmp0_other_with_cast._bounds_1))
      return false;
    if (!equals_1(this._xadvance_0, tmp0_other_with_cast._xadvance_0))
      return false;
    return true;
  };
  GlyphMetrics.$metadata$ = {
    simpleName: 'GlyphMetrics',
    kind: 'class',
    interfaces: []
  };
  function TextMetrics_init_$Init$(bounds_0, firstLineBounds, fontMetrics, nlines, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      bounds_0 = Companion_getInstance_35().invoke_0_k$();
    if (!(($mask0 & 2) === 0))
      firstLineBounds = Companion_getInstance_35().invoke_0_k$();
    if (!(($mask0 & 4) === 0)) {
      fontMetrics = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    }if (!(($mask0 & 8) === 0))
      nlines = 0;
    TextMetrics_0.call($this, bounds_0, firstLineBounds, fontMetrics, nlines);
    return $this;
  }
  function TextMetrics_init_$Create$(bounds_0, firstLineBounds, fontMetrics, nlines, $mask0, $marker) {
    return TextMetrics_init_$Init$(bounds_0, firstLineBounds, fontMetrics, nlines, $mask0, $marker, Object.create(TextMetrics_0.prototype));
  }
  function TextMetrics_0(bounds_0, firstLineBounds, fontMetrics, nlines) {
    this._bounds_2 = bounds_0;
    this._firstLineBounds = firstLineBounds;
    this._fontMetrics = fontMetrics;
    this._nlines = nlines;
  }
  TextMetrics_0.prototype._get_left__0_k$ = function () {
    return this._bounds_2._get_left__0_k$();
  };
  TextMetrics_0.prototype._get_top__0_k$ = function () {
    return this._bounds_2._get_top__0_k$();
  };
  TextMetrics_0.prototype._get_width__0_k$ = function () {
    return this._bounds_2._width_0;
  };
  TextMetrics_0.prototype._get_height__0_k$ = function () {
    return this._bounds_2._height_0;
  };
  TextMetrics_0.prototype._get_drawLeft__0_k$ = function () {
    return -this._get_left__0_k$();
  };
  TextMetrics_0.prototype._get_drawTop__0_k$ = function () {
    return this._firstLineBounds._height_0 + this._firstLineBounds._get_top__0_k$();
  };
  TextMetrics_0.prototype._get_ascent__0_k$ = function () {
    return this._fontMetrics._ascent;
  };
  TextMetrics_0.prototype._get_lineHeight__0_k$ = function () {
    return this._fontMetrics._get_lineHeight__0_k$();
  };
  TextMetrics_0.prototype._get_allLineHeight__0_k$ = function () {
    return this._get_lineHeight__0_k$() * this._nlines;
  };
  TextMetrics_0.prototype.toString = function () {
    return '' + 'TextMetrics[' + _get_niceStr__3(this._get_left__0_k$()) + ', ' + _get_niceStr__3(this._get_top__0_k$()) + ', ' + _get_niceStr__3(this._get_width__0_k$()) + ', ' + _get_niceStr__3(this._get_height__0_k$()) + '][' + _get_niceStr__3(this._get_drawLeft__0_k$()) + ', ' + _get_niceStr__3(this._get_drawTop__0_k$()) + ']';
  };
  TextMetrics_0.prototype.hashCode = function () {
    var result = this._bounds_2.hashCode();
    result = imul(result, 31) + this._firstLineBounds.hashCode() | 0;
    result = imul(result, 31) + this._fontMetrics.hashCode() | 0;
    result = imul(result, 31) + this._nlines | 0;
    return result;
  };
  TextMetrics_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextMetrics_0 ? other : THROW_CCE();
    if (!this._bounds_2.equals(tmp0_other_with_cast._bounds_2))
      return false;
    if (!this._firstLineBounds.equals(tmp0_other_with_cast._firstLineBounds))
      return false;
    if (!this._fontMetrics.equals(tmp0_other_with_cast._fontMetrics))
      return false;
    if (!(this._nlines === tmp0_other_with_cast._nlines))
      return false;
    return true;
  };
  TextMetrics_0.$metadata$ = {
    simpleName: 'TextMetrics',
    kind: 'class',
    interfaces: []
  };
  var linuxFolders;
  var windowsFolders;
  var macosFolders;
  var iosFolders;
  var androidFolders;
  var emojiFontNames;
  function NativeSystemFontProvider() {
  }
  NativeSystemFontProvider.prototype.getSystemFontGlyph_t2m31f_k$ = function (systemFont, size_2, codePoint, path_0) {
    return null;
  };
  NativeSystemFontProvider.prototype.getSystemFontMetrics_1r9gu8_k$ = function (systemFont, size_2, metrics) {
    var ascentRatio = 0.8;
    metrics._size_13 = size_2;
    metrics._top = size_2 * ascentRatio;
    metrics._ascent = metrics._top;
    metrics._baseline = 0.0;
    metrics._descent = -size_2 * (1.0 - ascentRatio);
    metrics._bottom = metrics._descent;
    metrics._maxWidth = size_2;
  };
  NativeSystemFontProvider.prototype.getSystemFontGlyphMetrics_6537ui_k$ = function (systemFont, size_2, codePoint, metrics) {
    metrics._existing = false;
    metrics._bounds_1.setTo_i6u10_k$(0.0, 0.0, size_2, size_2);
    Unit_getInstance();
    metrics._xadvance_0 = size_2;
  };
  NativeSystemFontProvider.prototype.getSystemFontKerning_nig4ll_k$ = function (systemFont, size_2, leftCodePoint, rightCodePoint) {
    return 0.0;
  };
  NativeSystemFontProvider.$metadata$ = {
    simpleName: 'NativeSystemFontProvider',
    kind: 'class',
    interfaces: []
  };
  function FallbackNativeSystemFontProvider(ttf) {
    TtfNativeSystemFontProvider.call(this);
    this._ttf = ttf;
    this._vfs_1 = VfsFileFromData(this._ttf.getAllBytesUnsafe_0_k$(), 'ttf');
  }
  FallbackNativeSystemFontProvider.prototype.loadFontByName_6wfw3l_k$ = function (name) {
    return this._ttf;
  };
  FallbackNativeSystemFontProvider.$metadata$ = {
    simpleName: 'FallbackNativeSystemFontProvider',
    kind: 'class',
    interfaces: []
  };
  function _get_ttfCache_($this) {
    var tmp0_getValue_0 = ttfCache$factory();
    return $this._ttfCache$delegate._get_value__0_k$();
  }
  function _no_name_provided__263() {
  }
  _no_name_provided__263.prototype.invoke_0_k$ = function () {
    return LinkedHashMap_init_$Create$();
  };
  _no_name_provided__263.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TtfNativeSystemFontProvider() {
    NativeSystemFontProvider.call(this);
    var tmp = this;
    tmp._ttfCache$delegate = lazy(_no_name_provided_$factory_214());
  }
  TtfNativeSystemFontProvider.prototype.normalizeName_uk8unn_k$ = function (_this__0) {
    var tmp0_trim_0 = _this__0.toLowerCase();
    return toString_1(trim_0(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE()));
  };
  TtfNativeSystemFontProvider.prototype.locateFontByName_6wfw3l_k$ = function (name) {
    var normalizedName = this.normalizeName_uk8unn_k$(name);
    var tmp0_getOrPut_0 = _get_ttfCache_(this);
    var value_1 = tmp0_getOrPut_0.get_2bw_k$(normalizedName);
    var tmp;
    if (value_1 == null) {
      var answer_2 = this.loadFontByName_6wfw3l_k$(name);
      tmp0_getOrPut_0.put_1q9pf_k$(normalizedName, answer_2);
      Unit_getInstance();
      tmp = answer_2;
    } else {
      tmp = value_1;
    }
    return tmp;
  };
  TtfNativeSystemFontProvider.prototype.ttf_hr7i5m_k$ = function (systemFont) {
    var tmp0_elvis_lhs = this.locateFontByName_6wfw3l_k$(_SystemFont___get_name__impl_(systemFont));
    return tmp0_elvis_lhs == null ? _get_DefaultTtfFont_() : tmp0_elvis_lhs;
  };
  TtfNativeSystemFontProvider.prototype.getSystemFontGlyph_t2m31f_k$ = function (systemFont, size_2, codePoint, path_0) {
    return this.ttf_hr7i5m_k$(systemFont).getGlyphPath_ua72x3_k$(size_2, codePoint, path_0);
  };
  TtfNativeSystemFontProvider.prototype.getSystemFontMetrics_1r9gu8_k$ = function (systemFont, size_2, metrics) {
    this.ttf_hr7i5m_k$(systemFont).getFontMetrics_sqtkiv_k$(size_2, metrics);
    Unit_getInstance();
  };
  TtfNativeSystemFontProvider.prototype.getSystemFontGlyphMetrics_6537ui_k$ = function (systemFont, size_2, codePoint, metrics) {
    this.ttf_hr7i5m_k$(systemFont).getGlyphMetrics_xejy1t_k$(size_2, codePoint, metrics);
    Unit_getInstance();
  };
  TtfNativeSystemFontProvider.prototype.getSystemFontKerning_nig4ll_k$ = function (systemFont, size_2, leftCodePoint, rightCodePoint) {
    return this.ttf_hr7i5m_k$(systemFont).getKerning_jw27q7_k$(size_2, leftCodePoint, rightCodePoint);
  };
  TtfNativeSystemFontProvider.$metadata$ = {
    simpleName: 'TtfNativeSystemFontProvider',
    kind: 'class',
    interfaces: []
  };
  function ttfCache$factory() {
    return getPropertyCallableRef('ttfCache', 1, KProperty1, function (receiver) {
      return _get_ttfCache_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_214() {
    var i = new _no_name_provided__263();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _SystemFont___init__impl_(name) {
    return name;
  }
  function _SystemFont___get_name__impl_(this_0) {
    return this_0;
  }
  function Companion_144() {
    Companion_instance_143 = this;
  }
  Companion_144.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_143;
  function Companion_getInstance_143() {
    if (Companion_instance_143 == null)
      new Companion_144();
    return Companion_instance_143;
  }
  function SystemFont__getFontMetrics_impl(this_0, size_2, metrics) {
    nativeSystemFontProvider.getSystemFontMetrics_1r9gu8_k$(this_0, size_2, metrics);
    return metrics;
  }
  function SystemFont__getGlyphMetrics_impl(this_0, size_2, codePoint, metrics) {
    nativeSystemFontProvider.getSystemFontGlyphMetrics_6537ui_k$(this_0, size_2, codePoint, metrics);
    return metrics;
  }
  function SystemFont__getKerning_impl(this_0, size_2, leftCodePoint, rightCodePoint) {
    return nativeSystemFontProvider.getSystemFontKerning_nig4ll_k$(this_0, size_2, leftCodePoint, rightCodePoint);
  }
  function SystemFont__getGlyphPath_impl(this_0, size_2, codePoint, path_0) {
    return nativeSystemFontProvider.getSystemFontGlyph_t2m31f_k$(this_0, size_2, codePoint, path_0);
  }
  function SystemFont__toString_impl(this_0) {
    return '' + 'SystemFont(name=' + _SystemFont___get_name__impl_(this_0) + ')';
  }
  function SystemFont__hashCode_impl(this_0) {
    return getStringHashCode(_SystemFont___get_name__impl_(this_0));
  }
  function SystemFont__equals_impl(this_0, other) {
    if (!(other instanceof SystemFont))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SystemFont ? other._name_15 : THROW_CCE();
    if (!(_SystemFont___get_name__impl_(this_0) === _SystemFont___get_name__impl_(tmp0_other_with_cast)))
      return false;
    return true;
  }
  function SystemFont(name) {
    Companion_getInstance_143();
    this._name_15 = name;
  }
  SystemFont.prototype._get_name__0_k$ = function () {
    return _SystemFont___get_name__impl_(this._name_15);
  };
  SystemFont.prototype.getFontMetrics_sqtkiv_k$ = function (size_2, metrics) {
    return SystemFont__getFontMetrics_impl(this._name_15, size_2, metrics);
  };
  SystemFont.prototype.getGlyphMetrics_xejy1t_k$ = function (size_2, codePoint, metrics) {
    return SystemFont__getGlyphMetrics_impl(this._name_15, size_2, codePoint, metrics);
  };
  SystemFont.prototype.getKerning_jw27q7_k$ = function (size_2, leftCodePoint, rightCodePoint) {
    return SystemFont__getKerning_impl(this._name_15, size_2, leftCodePoint, rightCodePoint);
  };
  SystemFont.prototype.getGlyphPath_ua72x3_k$ = function (size_2, codePoint, path_0) {
    return SystemFont__getGlyphPath_impl(this._name_15, size_2, codePoint, path_0);
  };
  SystemFont.prototype.toString = function () {
    return SystemFont__toString_impl(this._name_15);
  };
  SystemFont.prototype.hashCode = function () {
    return SystemFont__hashCode_impl(this._name_15);
  };
  SystemFont.prototype.equals = function (other) {
    return SystemFont__equals_impl(this._name_15, other);
  };
  SystemFont.$metadata$ = {
    simpleName: 'SystemFont',
    kind: 'class',
    interfaces: [VectorFont, Resourceable]
  };
  function readHeaderTables($this, s) {
    var tmp0_apply_0_3 = s.readU16BE_0_k$();
    if (!(tmp0_apply_0_3 === 1) ? !(tmp0_apply_0_3 === 20308) : false) {
      invalidOp('Not a TTF/OTF file');
    }var majorVersion_2 = tmp0_apply_0_3;
    var tmp1_apply_0_5 = s.readU16BE_0_k$();
    if (!(tmp1_apply_0_5 === 0) ? !(tmp1_apply_0_5 === 21583) : false) {
      invalidOp('Not a TTF/OTF file');
    }var minorVersion_4 = tmp1_apply_0_5;
    var numTables_6 = s.readU16BE_0_k$();
    var searchRange_7 = s.readU16BE_0_k$();
    var entrySelector_8 = s.readU16BE_0_k$();
    var rangeShift_9 = s.readU16BE_0_k$();
    var tmp2_map_0_11 = until(0, numTables_6);
    var tmp0_mapTo_0_1_12 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0_11, 10));
    var inductionVariable = tmp2_map_0_11._get_first__0_k$();
    var last_1 = tmp2_map_0_11._get_last__0_k$();
    if (inductionVariable <= last_1)
      do {
        var item_2_3_14 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_mapTo_0_1_12.add_2bq_k$(new Table(s.readStringz$default_589s1r_k$(4, null, 2, null), s.readS32BE_0_k$(), s.readS32BE_0_k$(), s.readS32BE_0_k$()));
        Unit_getInstance();
      }
       while (!(item_2_3_14 === last_1));
    var tables_10 = tmp0_mapTo_0_1_12;
    var tablesByName_15 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_16 = tables_10.iterator_0_k$();
    while (tmp0_iterator_16.hasNext_0_k$()) {
      var table_17 = tmp0_iterator_16.next_0_k$();
      table_17._s_5 = s.sliceWithSize_27zxwg_k$(table_17._offset_26, table_17._length_3);
      var tmp3_set_0_18 = table_17._id_5;
      tablesByName_15.put_1q9pf_k$(tmp3_set_0_18, table_17);
      Unit_getInstance();
    }
    return tablesByName_15;
  }
  var NameId_COPYRIGHT_instance;
  var NameId_NAME_instance;
  var NameId_STYLE_instance;
  var NameId_UNAME_instance;
  var NameId_COMPLETE_NAME_instance;
  var NameId_RELEASE_VERSION_instance;
  var NameId_POSTSCRIPT_NAME_instance;
  var NameId_TRADEMARK_instance;
  var NameId_MANUFACTURER_instance;
  var NameId_DESIGNER_instance;
  var NameId_DESCRIPTION_instance;
  var NameId_URL_VENDOR_instance;
  var NameId_URL_DESIGNER_instance;
  var NameId_LICENSE_DESCRIPTION_instance;
  var NameId_LICENSE_URL_instance;
  var NameId_RESERVED_15_instance;
  var NameId_PREFERRED_FAMILY_instance;
  var NameId_PREFERRED_SUBFAMILY_instance;
  var NameId_COMPATIBLE_FULL_instance;
  var NameId_SAMPLE_TEXT_instance;
  var NameId_POSTSCRIPT_CID_instance;
  var NameId_WWS_FAMILY_NAME_instance;
  var NameId_WWS_SUBFAMILY_NAME_instance;
  var NameId_LIGHT_BACKGROUND_instance;
  var NameId_DARK_BACKGROUND_instance;
  var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
  function Companion_145() {
    Companion_instance_144 = this;
    this._MAX_ID = 26;
  }
  Companion_145.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_144;
  function Companion_getInstance_144() {
    if (Companion_instance_144 == null)
      new Companion_145();
    return Companion_instance_144;
  }
  function values_6() {
    return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
  }
  var NameId_entriesInitialized;
  function NameId_initEntries() {
    if (NameId_entriesInitialized)
      return Unit_getInstance();
    NameId_entriesInitialized = true;
    NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
    NameId_NAME_instance = new NameId('NAME', 1, 1);
    NameId_STYLE_instance = new NameId('STYLE', 2, 2);
    NameId_UNAME_instance = new NameId('UNAME', 3, 3);
    NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
    NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
    NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
    NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
    NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
    NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
    NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
    NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
    NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
    NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
    NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
    NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
    NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
    NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
    NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
    NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
    NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
    NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
    NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
    NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
    NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
    NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
    Companion_getInstance_144();
  }
  function BitmapGlyphInfo_init_$Init$(glyphID, imageFormat, offset_0, size_2, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance, $mask0, $marker, $this) {
    if (!(($mask0 & 32) === 0))
      height = 0;
    if (!(($mask0 & 64) === 0))
      width = 0;
    if (!(($mask0 & 128) === 0))
      horiBearingX = 0;
    if (!(($mask0 & 256) === 0))
      horiBearingY = 0;
    if (!(($mask0 & 512) === 0))
      horiAdvance = 0;
    if (!(($mask0 & 1024) === 0))
      vertBearingX = 0;
    if (!(($mask0 & 2048) === 0))
      vertBearingY = 0;
    if (!(($mask0 & 4096) === 0))
      vertAdvance = 0;
    BitmapGlyphInfo.call($this, glyphID, imageFormat, offset_0, size_2, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance);
    return $this;
  }
  function BitmapGlyphInfo_init_$Create$(glyphID, imageFormat, offset_0, size_2, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance, $mask0, $marker) {
    return BitmapGlyphInfo_init_$Init$(glyphID, imageFormat, offset_0, size_2, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance, $mask0, $marker, Object.create(BitmapGlyphInfo.prototype));
  }
  function Contour_init_$Init$(x, y, onCurve_0, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0;
    if (!(($mask0 & 2) === 0))
      y = 0;
    if (!(($mask0 & 4) === 0))
      onCurve_0 = false;
    Contour.call($this, x, y, onCurve_0);
    return $this;
  }
  function Contour_init_$Create$(x, y, onCurve_0, $mask0, $marker) {
    return Contour_init_$Init$(x, y, onCurve_0, $mask0, $marker, Object.create(Contour.prototype));
  }
  function GlyphGraphicsPath_init_$Init$(glpyhIndex, commands, data, winding, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      commands = IntArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 4) === 0)) {
      data = DoubleArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 8) === 0))
      winding = Winding_EVEN_ODD_getInstance();
    GlyphGraphicsPath.call($this, glpyhIndex, commands, data, winding);
    return $this;
  }
  function GlyphGraphicsPath_init_$Create$(glpyhIndex, commands, data, winding, $mask0, $marker) {
    return GlyphGraphicsPath_init_$Init$(glpyhIndex, commands, data, winding, $mask0, $marker, Object.create(GlyphGraphicsPath.prototype));
  }
  function onCurve($this, n) {
    return !(($this._flags_3[n] & 1) === 0);
  }
  function contour($this, n, out) {
    out._x_12 = $this._xPos[n];
    out._y_11 = $this._yPos[n];
    out._onCurve = onCurve($this, n);
    return out;
  }
  function TtfFont_init_$Init$(d, freeze, extName, onlyReadMetadata, $this) {
    TtfFont.call($this, openFastStream$default(d, 0, 1, null), freeze, extName, onlyReadMetadata);
    return $this;
  }
  function TtfFont_init_$Create$(d, freeze, extName, onlyReadMetadata) {
    return TtfFont_init_$Init$(d, freeze, extName, onlyReadMetadata, Object.create(TtfFont.prototype));
  }
  function TtfFont_init_$Init$_0(d, freeze, extName, onlyReadMetadata, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      freeze = false;
    if (!(($mask0 & 4) === 0))
      extName = null;
    if (!(($mask0 & 8) === 0))
      onlyReadMetadata = false;
    TtfFont_init_$Init$(d, freeze, extName, onlyReadMetadata, $this);
    return $this;
  }
  function TtfFont_init_$Create$_0(d, freeze, extName, onlyReadMetadata, $mask0, $marker) {
    return TtfFont_init_$Init$_0(d, freeze, extName, onlyReadMetadata, $mask0, $marker, Object.create(TtfFont.prototype));
  }
  function getTextScale_0($this, size_2) {
    return size_2 / $this._unitsPerEm;
  }
  function NamesInfo() {
    var tmp = this;
    Companion_getInstance_144();
    var tmp0_arrayOfNulls_0 = 26;
    tmp._names_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var tmp_0 = this;
    Companion_getInstance_144();
    tmp_0._namesOffsets = new Int32Array(26);
    var tmp_1 = this;
    var tmp_2 = 0;
    Companion_getInstance_144();
    var tmp_3 = 26;
    var tmp_4 = new Int32Array(tmp_3);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      tmp_4[tmp_5] = -1;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1._namesLengths = tmp_4;
    var tmp_6 = this;
    var tmp_7 = 0;
    Companion_getInstance_144();
    var tmp_8 = 26;
    var tmp_9 = fillArrayVal(Array(tmp_8), null);
    while (tmp_7 < tmp_8) {
      var tmp_10 = tmp_7;
      tmp_9[tmp_10] = UTF8;
      tmp_7 = tmp_7 + 1 | 0;
    }
    tmp_6._namesCharsets = tmp_9;
    this._namesS = null;
  }
  NamesInfo.prototype._get_ttfName__0_k$ = function () {
    var tmp0_elvis_lhs = this.getName_dde93m_k$(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.getName_dde93m_k$(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  };
  NamesInfo.prototype.getName_ha5a7z_k$ = function (nameId) {
    if (this._names_0[nameId] == null) {
      var nameLength = this._namesLengths[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this._namesS).extractString_470xh9_k$(this._namesOffsets[nameId], nameLength, this._namesCharsets[nameId]);
      var tmp;
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0).equals(new Char(0))) {
          var tmp0_filterTo_0_1 = StringBuilder_init_$Create$_0();
          var inductionVariable = 0;
          var last_1 = charSequenceLength(string);
          if (inductionVariable < last_1)
            do {
              var index_2_3 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element_3_4 = charSequenceGet(string, index_2_3);
              if (!element_3_4.equals(new Char(0))) {
                tmp0_filterTo_0_1.append_wi8o78_k$(element_3_4);
                Unit_getInstance();
              } else {
              }
            }
             while (inductionVariable < last_1);
          tmp = tmp0_filterTo_0_1.toString();
        } else {
          {
            tmp = string;
          }
        }
      }
      this._names_0[nameId] = tmp;
    }return this._names_0[nameId];
  };
  NamesInfo.prototype.getName_dde93m_k$ = function (nameId) {
    return this.getName_ha5a7z_k$(nameId._id_6);
  };
  NamesInfo.prototype.toMap_0_k$ = function () {
    var tmp0_map_0 = values_6();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0.length);
    var indexedObject = tmp0_map_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_2bq_k$(to(item_2_3, this.getName_dde93m_k$(item_2_3)));
      Unit_getInstance();
    }
    return toMap_0(tmp0_mapTo_0_1);
  };
  NamesInfo.prototype.toString = function () {
    return '' + 'NamesInfo(' + this.toMap_0_k$() + ')';
  };
  NamesInfo.$metadata$ = {
    simpleName: 'NamesInfo',
    kind: 'class',
    interfaces: []
  };
  function getCharacterMapOrNull($this, key) {
    return $this._characterMaps.get_2bw_k$(key);
  }
  function addCharacterMap($this, codePoint, index_0) {
    var tmp0_set_0 = $this._characterMaps;
    tmp0_set_0.put_1q9pf_k$(codePoint, index_0);
    Unit_getInstance();
    var tmp1_set_0 = $this._characterMapsReverse;
    tmp1_set_0.put_1q9pf_k$(index_0, codePoint);
    Unit_getInstance();
  }
  function Table(id, checksum, offset_0, length) {
    this._id_5 = id;
    this._checksum = checksum;
    this._offset_26 = offset_0;
    this._length_3 = length;
  }
  Table.prototype._get_s__0_k$ = function () {
    var tmp = this._s_5;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('s');
    }
  };
  Table.prototype.open_0_k$ = function () {
    return this._get_s__0_k$().clone_0_k$();
  };
  Table.prototype.toString = function () {
    return '' + 'Table(id=' + this._id_5 + ', checksum=' + this._checksum + ', offset=' + this._offset_26 + ', length=' + this._length_3 + ')';
  };
  Table.prototype.hashCode = function () {
    var result = getStringHashCode(this._id_5);
    result = imul(result, 31) + this._checksum | 0;
    result = imul(result, 31) + this._offset_26 | 0;
    result = imul(result, 31) + this._length_3 | 0;
    return result;
  };
  Table.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this._id_5 === tmp0_other_with_cast._id_5))
      return false;
    if (!(this._checksum === tmp0_other_with_cast._checksum))
      return false;
    if (!(this._offset_26 === tmp0_other_with_cast._offset_26))
      return false;
    if (!(this._length_3 === tmp0_other_with_cast._length_3))
      return false;
    return true;
  };
  Table.$metadata$ = {
    simpleName: 'Table',
    kind: 'class',
    interfaces: []
  };
  function HorMetric(advanceWidth, lsb) {
    this._advanceWidth = advanceWidth;
    this._lsb = lsb;
  }
  HorMetric.prototype.toString = function () {
    return '' + 'HorMetric(advanceWidth=' + this._advanceWidth + ', lsb=' + this._lsb + ')';
  };
  HorMetric.prototype.hashCode = function () {
    var result = this._advanceWidth;
    result = imul(result, 31) + this._lsb | 0;
    return result;
  };
  HorMetric.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this._advanceWidth === tmp0_other_with_cast._advanceWidth))
      return false;
    if (!(this._lsb === tmp0_other_with_cast._lsb))
      return false;
    return true;
  };
  HorMetric.$metadata$ = {
    simpleName: 'HorMetric',
    kind: 'class',
    interfaces: []
  };
  function readHeaderTables_0($this) {
    var tmp = Companion_getInstance_145();
    $this._tablesByName.putAll_nn707j_k$(readHeaderTables(tmp, $this._s_7.sliceStart$default_l3mjq9_k$(0, 1, null)));
  }
  function Companion_146() {
    Companion_instance_145 = this;
  }
  Companion_146.prototype.readNamesSection_wndrit_k$ = function (s, info) {
    var format_2 = s.readU16BE_0_k$();
    var count_3 = s.readU16BE_0_k$();
    var stringOffset_4 = s.readU16BE_0_k$();
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < count_3) {
      do {
        var n_6 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId_7 = s.readU16BE_0_k$();
        var encodingId_8 = s.readU16BE_0_k$();
        var languageId_9 = s.readU16BE_0_k$();
        var nameId_10 = s.readU16BE_0_k$();
        var length_11 = s.readU16BE_0_k$();
        var offset_12 = s.readU16BE_0_k$();
        var tmp_0;
        if (nameId_10 < 0) {
          tmp_0 = true;
        } else {
          Companion_getInstance_144();
          tmp_0 = nameId_10 >= 26;
        }
        if (tmp_0)
          continue;
        else {
        }
        var tmp1_subject_14 = encodingId_8;
        {
          var charset_13;
          switch (tmp1_subject_14) {
            case 0:
              charset_13 = UTF8;
              break;
            case 1:
              charset_13 = UTF16_BE;
              break;
            default:charset_13 = UTF16_BE;
              break;
          }
        }
        if ((platformId_7 === 0 ? languageId_9 === 0 : false) ? true : info._namesLengths[nameId_10] === -1) {
          info._namesOffsets[nameId_10] = stringOffset_4 + offset_12 | 0;
          info._namesLengths[nameId_10] = length_11;
          info._namesCharsets[nameId_10] = charset_13;
          info._namesS = s;
        }}
       while (inductionVariable < count_3);
      tmp = Unit_getInstance();
    }return tmp;
  };
  Companion_146.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_145;
  function Companion_getInstance_145() {
    if (Companion_instance_145 == null)
      new Companion_146();
    return Companion_instance_145;
  }
  function NameId(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this._id_6 = id;
  }
  NameId.$metadata$ = {
    simpleName: 'NameId',
    kind: 'class',
    interfaces: []
  };
  function readNames($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('name');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      Companion_getInstance_145().readNamesSection_wndrit_k$(tmp0_safe_receiver_1, $this._namesi);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readLoca($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('loca');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var tmp0_subject_4 = $this._indexToLocFormat;
      var tmp;
      switch (tmp0_subject_4) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:_get_invalidOp_();
          break;
      }
      var bytesPerEntry_3 = tmp;
      var data_5 = tmp0_safe_receiver_1.readBytesExact_ha5a7z_k$(imul(bytesPerEntry_3, $this._numGlyphs + 1 | 0));
      var tmp_0 = $this;
      var tmp0_run_0_6 = FastByteArrayInputStream_init_$Create$(data_5, 0, 0, 0, 14, null);
      var tmp0_subject_2_7 = $this._indexToLocFormat;
      var tmp_1;
      switch (tmp0_subject_2_7) {
        case 0:
          var tmp_3_8 = 0;
          var tmp_4_9 = $this._numGlyphs + 1 | 0;
          var tmp_5_10 = new Int32Array(tmp_4_9);
          while (tmp_3_8 < tmp_4_9) {
            var tmp_6_11 = tmp_3_8;
            tmp_5_10[tmp_6_11] = imul(tmp0_run_0_6.readU16BE_0_k$(), 2);
            tmp_3_8 = tmp_3_8 + 1 | 0;
          }

          tmp_1 = tmp_5_10;
          break;
        case 1:
          var tmp_7_12 = 0;
          var tmp_8_13 = $this._numGlyphs + 1 | 0;
          var tmp_9_14 = new Int32Array(tmp_8_13);
          while (tmp_7_12 < tmp_8_13) {
            var tmp_10_15 = tmp_7_12;
            tmp_9_14[tmp_10_15] = tmp0_run_0_6.readS32BE_0_k$();
            tmp_7_12 = tmp_7_12 + 1 | 0;
          }

          tmp_1 = tmp_9_14;
          break;
        default:_get_invalidOp_();
          break;
      }
      tmp_0._locs = tmp_1;
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readHead($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('head');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var tmp0_apply_0_3 = tmp0_safe_receiver_1.readU16BE_0_k$();
      if (!(tmp0_apply_0_3 === 1)) {
        invalidOp('Invalid TTF');
      }Unit_getInstance();
      var tmp1_apply_0_4 = tmp0_safe_receiver_1.readU16BE_0_k$();
      if (!(tmp1_apply_0_4 === 0)) {
        invalidOp('Invalid TTF');
      }Unit_getInstance();
      $this._fontRev = $this.readFixed_v83o64_k$(tmp0_safe_receiver_1);
      var checkSumAdjustment_5 = tmp0_safe_receiver_1.readS32BE_0_k$();
      var tmp2_apply_0_6 = tmp0_safe_receiver_1.readS32BE_0_k$();
      if (!(tmp2_apply_0_6 === 1594834165)) {
        invalidOp('' + 'Invalid magic ' + _get_hex_(tmp2_apply_0_6));
      }Unit_getInstance();
      var flags_7 = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._unitsPerEm = tmp0_safe_receiver_1.readU16BE_0_k$();
      var created_8 = tmp0_safe_receiver_1.readS64BE_0_k$().times_wiekkq_k$(new Long(1000, 0));
      var modified_9 = tmp0_safe_receiver_1.readS64BE_0_k$().times_wiekkq_k$(new Long(1000, 0));
      $this._xMin_0 = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._yMin_0 = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._xMax_0 = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._yMax_0 = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._macStyle = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._lowestRecPPEM = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._fontDirectionHint = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._indexToLocFormat = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._glyphDataFormat = tmp0_safe_receiver_1.readS16BE_0_k$();
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readMaxp($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('maxp');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var version_3 = $this.readFixed_v83o64_k$(tmp0_safe_receiver_1);
      $this._numGlyphs = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxPoints = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxContours = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxCompositePoints = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxCompositeContours = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxZones = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxTwilightPoints = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxStorage = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxFunctionDefs = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxInstructionDefs = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxStackElements = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxSizeOfInstructions = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxComponentElements = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._maxComponentDepth = tmp0_safe_receiver_1.readU16BE_0_k$();
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readHhea($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('hhea');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      $this._hheaVersion = $this.readFixed_v83o64_k$(tmp0_safe_receiver_1);
      $this._ascender_0 = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._descender_0 = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._lineGap = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._advanceWidthMax = tmp0_safe_receiver_1.readU16BE_0_k$();
      $this._minLeftSideBearing = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._minRightSideBearing = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._xMaxExtent = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._caretSlopeRise = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._caretSlopeRun = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._caretOffset_0 = tmp0_safe_receiver_1.readS16BE_0_k$();
      tmp0_safe_receiver_1.readS16BE_0_k$();
      Unit_getInstance();
      tmp0_safe_receiver_1.readS16BE_0_k$();
      Unit_getInstance();
      tmp0_safe_receiver_1.readS16BE_0_k$();
      Unit_getInstance();
      tmp0_safe_receiver_1.readS16BE_0_k$();
      Unit_getInstance();
      $this._metricDataFormat = tmp0_safe_receiver_1.readS16BE_0_k$();
      $this._numberOfHMetrics = tmp0_safe_receiver_1.readU16BE_0_k$();
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readHmtx($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('hmtx');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var tmp0_map_0_4 = until(0, $this._numberOfHMetrics);
      var tmp0_mapTo_0_1_5 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_4, 10));
      var inductionVariable = tmp0_map_0_4._get_first__0_k$();
      var last_1 = tmp0_map_0_4._get_last__0_k$();
      if (inductionVariable <= last_1)
        do {
          var item_2_3_7 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          tmp0_mapTo_0_1_5.add_2bq_k$(new HorMetric(tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readS16BE_0_k$()));
          Unit_getInstance();
        }
         while (!(item_2_3_7 === last_1));
      var firstMetrics_3 = tmp0_mapTo_0_1_5;
      var lastAdvanceWidth_8 = last(firstMetrics_3)._advanceWidth;
      var tmp1_map_0_10 = until(0, $this._numGlyphs - $this._numberOfHMetrics | 0);
      var tmp0_mapTo_0_1_11 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0_10, 10));
      var inductionVariable_0 = tmp1_map_0_10._get_first__0_k$();
      var last_2 = tmp1_map_0_10._get_last__0_k$();
      if (inductionVariable_0 <= last_2)
        do {
          var item_2_3_13 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          tmp0_mapTo_0_1_11.add_2bq_k$(new HorMetric(lastAdvanceWidth_8, tmp0_safe_receiver_1.readS16BE_0_k$()));
          Unit_getInstance();
        }
         while (!(item_2_3_13 === last_2));
      var compressedMetrics_9 = tmp0_mapTo_0_1_11;
      $this._horMetrics = plus(firstMetrics_3, compressedMetrics_9);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readCpal($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('CPAL');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var version_3 = tmp0_safe_receiver_1.readU16BE_0_k$();
      var tmp0_subject_4 = version_3;
      switch (tmp0_subject_4) {
        case 0:
        case 1:
          var numPaletteEntries_5 = tmp0_safe_receiver_1.readU16BE_0_k$();
          var numPalettes_6 = tmp0_safe_receiver_1.readU16BE_0_k$();
          var numColorRecords_7 = tmp0_safe_receiver_1.readU16BE_0_k$();
          var colorRecordsArrayOffset_8 = tmp0_safe_receiver_1.readS32BE_0_k$();
          var colorRecordIndices_9 = tmp0_safe_receiver_1.readShortArrayBE_ha5a7z_k$(numPalettes_6);
          var paletteTypesArrayOffset_10 = version_3 === 1 ? tmp0_safe_receiver_1.readS32BE_0_k$() : -1;
          var paletteLabelsArrayOffset_11 = version_3 === 1 ? tmp0_safe_receiver_1.readS32BE_0_k$() : -1;
          var paletteEntryLabelsArrayOffset_12 = version_3 === 1 ? tmp0_safe_receiver_1.readS32BE_0_k$() : -1;
          tmp0_safe_receiver_1._set_position__majfzk_k$(colorRecordsArrayOffset_8);
          var colorInts_13 = tmp0_safe_receiver_1.readIntArrayLE_ha5a7z_k$(numColorRecords_7);
          var inductionVariable = 0;
          var last_1 = colorInts_13.length;
          if (inductionVariable < last_1)
            do {
              var n_15 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c_16 = _RGBA___init__impl_(colorInts_13[n_15]);
              colorInts_13[n_15] = _RGBA___get_value__impl_(Companion_getInstance_136().invoke_fnl2i9_k$(_RGBA___get_b__impl_(c_16), _RGBA___get_g__impl_(c_16), _RGBA___get_r__impl_(c_16), _RGBA___get_a__impl_(c_16)));
            }
             while (inductionVariable < last_1);
          var tmp = $this;
          var tmp0_mapTo_0_1_17 = ArrayList_init_$Create$_0(colorRecordIndices_9.length);
          var indexedObject = colorRecordIndices_9;
          var inductionVariable_0 = 0;
          var last_2 = indexedObject.length;
          while (inductionVariable_0 < last_2) {
            var item_2_3_19 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp_0 = _RgbaArray___init__impl_(copyOfRange(colorInts_13, item_2_3_19, item_2_3_19 + numPaletteEntries_5 | 0));
            tmp0_mapTo_0_1_17.add_2bq_k$(Palette_init_$Create$(tmp_0, null, 0, 0, 14, null));
            Unit_getInstance();
          }

          tmp._palettes = tmp0_mapTo_0_1_17;
          break;
        default:println('TTF WARNING CPAL version != 0,1');
          break;
      }
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function ColorBitmapInfo(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    this._indexSubTableArrayOffset = indexSubTableArrayOffset;
    this._indexTablesSize = indexTablesSize;
    this._numberofIndexSubTables = numberofIndexSubTables;
    this._colorRef = colorRef;
    this._hori = hori;
    this._vert = vert;
    this._startGlyphIndex = startGlyphIndex;
    this._endGlyphIndex = endGlyphIndex;
    this._ppemX = ppemX;
    this._ppemY = ppemY;
    this._bitDepth = bitDepth;
    this._flags_2 = flags;
  }
  ColorBitmapInfo.prototype.toString = function () {
    return '' + 'ColorBitmapInfo(indexSubTableArrayOffset=' + this._indexSubTableArrayOffset + ', indexTablesSize=' + this._indexTablesSize + ', numberofIndexSubTables=' + this._numberofIndexSubTables + ', colorRef=' + this._colorRef + ', hori=' + this._hori + ', vert=' + this._vert + ', startGlyphIndex=' + this._startGlyphIndex + ', endGlyphIndex=' + this._endGlyphIndex + ', ppemX=' + this._ppemX + ', ppemY=' + this._ppemY + ', bitDepth=' + this._bitDepth + ', flags=' + this._flags_2 + ')';
  };
  ColorBitmapInfo.prototype.hashCode = function () {
    var result = this._indexSubTableArrayOffset;
    result = imul(result, 31) + this._indexTablesSize | 0;
    result = imul(result, 31) + this._numberofIndexSubTables | 0;
    result = imul(result, 31) + this._colorRef | 0;
    result = imul(result, 31) + this._hori.hashCode() | 0;
    result = imul(result, 31) + this._vert.hashCode() | 0;
    result = imul(result, 31) + this._startGlyphIndex | 0;
    result = imul(result, 31) + this._endGlyphIndex | 0;
    result = imul(result, 31) + this._ppemX | 0;
    result = imul(result, 31) + this._ppemY | 0;
    result = imul(result, 31) + this._bitDepth | 0;
    result = imul(result, 31) + this._flags_2 | 0;
    return result;
  };
  ColorBitmapInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this._indexSubTableArrayOffset === tmp0_other_with_cast._indexSubTableArrayOffset))
      return false;
    if (!(this._indexTablesSize === tmp0_other_with_cast._indexTablesSize))
      return false;
    if (!(this._numberofIndexSubTables === tmp0_other_with_cast._numberofIndexSubTables))
      return false;
    if (!(this._colorRef === tmp0_other_with_cast._colorRef))
      return false;
    if (!this._hori.equals(tmp0_other_with_cast._hori))
      return false;
    if (!this._vert.equals(tmp0_other_with_cast._vert))
      return false;
    if (!(this._startGlyphIndex === tmp0_other_with_cast._startGlyphIndex))
      return false;
    if (!(this._endGlyphIndex === tmp0_other_with_cast._endGlyphIndex))
      return false;
    if (!(this._ppemX === tmp0_other_with_cast._ppemX))
      return false;
    if (!(this._ppemY === tmp0_other_with_cast._ppemY))
      return false;
    if (!(this._bitDepth === tmp0_other_with_cast._bitDepth))
      return false;
    if (!(this._flags_2 === tmp0_other_with_cast._flags_2))
      return false;
    return true;
  };
  ColorBitmapInfo.$metadata$ = {
    simpleName: 'ColorBitmapInfo',
    kind: 'class',
    interfaces: []
  };
  function SbitLineMetrics(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    this._ascender = ascender;
    this._descender = descender;
    this._widthMax = widthMax;
    this._caretSlopeNumerator = caretSlopeNumerator;
    this._caretSlopeDenominator = caretSlopeDenominator;
    this._caretOffset = caretOffset;
    this._minOriginSB = minOriginSB;
    this._minAdvanceSB = minAdvanceSB;
    this._maxBeforeBL = maxBeforeBL;
    this._minAfterBL = minAfterBL;
    this._pad1 = pad1;
    this._pad2 = pad2;
  }
  SbitLineMetrics.prototype.toString = function () {
    return '' + 'SbitLineMetrics(ascender=' + this._ascender + ', descender=' + this._descender + ', widthMax=' + this._widthMax + ', caretSlopeNumerator=' + this._caretSlopeNumerator + ', caretSlopeDenominator=' + this._caretSlopeDenominator + ', caretOffset=' + this._caretOffset + ', minOriginSB=' + this._minOriginSB + ', minAdvanceSB=' + this._minAdvanceSB + ', maxBeforeBL=' + this._maxBeforeBL + ', minAfterBL=' + this._minAfterBL + ', pad1=' + this._pad1 + ', pad2=' + this._pad2 + ')';
  };
  SbitLineMetrics.prototype.hashCode = function () {
    var result = this._ascender;
    result = imul(result, 31) + this._descender | 0;
    result = imul(result, 31) + this._widthMax | 0;
    result = imul(result, 31) + this._caretSlopeNumerator | 0;
    result = imul(result, 31) + this._caretSlopeDenominator | 0;
    result = imul(result, 31) + this._caretOffset | 0;
    result = imul(result, 31) + this._minOriginSB | 0;
    result = imul(result, 31) + this._minAdvanceSB | 0;
    result = imul(result, 31) + this._maxBeforeBL | 0;
    result = imul(result, 31) + this._minAfterBL | 0;
    result = imul(result, 31) + this._pad1 | 0;
    result = imul(result, 31) + this._pad2 | 0;
    return result;
  };
  SbitLineMetrics.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this._ascender === tmp0_other_with_cast._ascender))
      return false;
    if (!(this._descender === tmp0_other_with_cast._descender))
      return false;
    if (!(this._widthMax === tmp0_other_with_cast._widthMax))
      return false;
    if (!(this._caretSlopeNumerator === tmp0_other_with_cast._caretSlopeNumerator))
      return false;
    if (!(this._caretSlopeDenominator === tmp0_other_with_cast._caretSlopeDenominator))
      return false;
    if (!(this._caretOffset === tmp0_other_with_cast._caretOffset))
      return false;
    if (!(this._minOriginSB === tmp0_other_with_cast._minOriginSB))
      return false;
    if (!(this._minAdvanceSB === tmp0_other_with_cast._minAdvanceSB))
      return false;
    if (!(this._maxBeforeBL === tmp0_other_with_cast._maxBeforeBL))
      return false;
    if (!(this._minAfterBL === tmp0_other_with_cast._minAfterBL))
      return false;
    if (!(this._pad1 === tmp0_other_with_cast._pad1))
      return false;
    if (!(this._pad2 === tmp0_other_with_cast._pad2))
      return false;
    return true;
  };
  SbitLineMetrics.$metadata$ = {
    simpleName: 'SbitLineMetrics',
    kind: 'class',
    interfaces: []
  };
  function readSibLineMetrics(_this_, $this) {
    return new SbitLineMetrics(_this_.readS8_0_k$(), _this_.readS8_0_k$(), _this_.readU8_0_k$(), _this_.readS8_0_k$(), _this_.readS8_0_k$(), _this_.readS8_0_k$(), _this_.readS8_0_k$(), _this_.readS8_0_k$(), _this_.readS8_0_k$(), _this_.readS8_0_k$(), _this_.readS8_0_k$(), _this_.readS8_0_k$());
  }
  function BitmapGlyphInfo(glyphID, imageFormat, offset_0, size_2, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    this._glyphID = glyphID;
    this._imageFormat_3 = imageFormat;
    this._offset_27 = offset_0;
    this._size_15 = size_2;
    this._info_2 = info;
    this._height_6 = height;
    this._width_5 = width;
    this._horiBearingX = horiBearingX;
    this._horiBearingY = horiBearingY;
    this._horiAdvance = horiAdvance;
    this._vertBearingX = vertBearingX;
    this._vertBearingY = vertBearingY;
    this._vertAdvance = vertAdvance;
    this._s_6 = null;
    this._bitmap_1 = null;
  }
  BitmapGlyphInfo.prototype._get_descender__0_k$ = function () {
    return this._info_2._hori._descender;
  };
  BitmapGlyphInfo.prototype.getBitmap_vcj5fe_k$ = function (cache) {
    var tmp0_elvis_lhs = this._bitmap_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0 = PNG_getInstance();
      var tmp_1 = toSyncStream(ensureNotNull(this._s_6));
      tmp = tmp_0.decode$default_nu4l15_k$(tmp_1, null, 2, null);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this._bitmap_1 = bmp;
    return bmp;
  };
  BitmapGlyphInfo.prototype.getBitmap$default_gexuk8_k$ = function (cache, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cache = false;
    return this.getBitmap_vcj5fe_k$(cache);
  };
  BitmapGlyphInfo.prototype.toString = function () {
    return '' + 'BitmapGlyphInfo(glyphID=' + this._glyphID + ', imageFormat=' + this._imageFormat_3 + ', offset=' + this._offset_27 + ', size=' + this._size_15 + ', info=' + this._info_2 + ', height=' + this._height_6 + ', width=' + this._width_5 + ', horiBearingX=' + this._horiBearingX + ', horiBearingY=' + this._horiBearingY + ', horiAdvance=' + this._horiAdvance + ', vertBearingX=' + this._vertBearingX + ', vertBearingY=' + this._vertBearingY + ', vertAdvance=' + this._vertAdvance + ')';
  };
  BitmapGlyphInfo.prototype.hashCode = function () {
    var result = this._glyphID;
    result = imul(result, 31) + this._imageFormat_3 | 0;
    result = imul(result, 31) + this._offset_27 | 0;
    result = imul(result, 31) + this._size_15 | 0;
    result = imul(result, 31) + this._info_2.hashCode() | 0;
    result = imul(result, 31) + this._height_6 | 0;
    result = imul(result, 31) + this._width_5 | 0;
    result = imul(result, 31) + this._horiBearingX | 0;
    result = imul(result, 31) + this._horiBearingY | 0;
    result = imul(result, 31) + this._horiAdvance | 0;
    result = imul(result, 31) + this._vertBearingX | 0;
    result = imul(result, 31) + this._vertBearingY | 0;
    result = imul(result, 31) + this._vertAdvance | 0;
    return result;
  };
  BitmapGlyphInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this._glyphID === tmp0_other_with_cast._glyphID))
      return false;
    if (!(this._imageFormat_3 === tmp0_other_with_cast._imageFormat_3))
      return false;
    if (!(this._offset_27 === tmp0_other_with_cast._offset_27))
      return false;
    if (!(this._size_15 === tmp0_other_with_cast._size_15))
      return false;
    if (!this._info_2.equals(tmp0_other_with_cast._info_2))
      return false;
    if (!(this._height_6 === tmp0_other_with_cast._height_6))
      return false;
    if (!(this._width_5 === tmp0_other_with_cast._width_5))
      return false;
    if (!(this._horiBearingX === tmp0_other_with_cast._horiBearingX))
      return false;
    if (!(this._horiBearingY === tmp0_other_with_cast._horiBearingY))
      return false;
    if (!(this._horiAdvance === tmp0_other_with_cast._horiAdvance))
      return false;
    if (!(this._vertBearingX === tmp0_other_with_cast._vertBearingX))
      return false;
    if (!(this._vertBearingY === tmp0_other_with_cast._vertBearingY))
      return false;
    if (!(this._vertAdvance === tmp0_other_with_cast._vertAdvance))
      return false;
    return true;
  };
  BitmapGlyphInfo.$metadata$ = {
    simpleName: 'BitmapGlyphInfo',
    kind: 'class',
    interfaces: []
  };
  function readCblc($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('CBLC');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var majorVersion_3 = tmp0_safe_receiver_1.readU16BE_0_k$();
      var minorVersion_4 = tmp0_safe_receiver_1.readU16BE_0_k$();
      var tmp0_subject_5 = majorVersion_3;
      if (tmp0_subject_5 === 3) {
        var numSizes_6 = tmp0_safe_receiver_1.readS32BE_0_k$();
        var tmp_8 = 0;
        var tmp_9 = numSizes_6;
        var tmp_10 = fillArrayVal(Array(tmp_9), null);
        while (tmp_8 < tmp_9) {
          var tmp_11 = tmp_8;
          tmp_10[tmp_11] = new ColorBitmapInfo(tmp0_safe_receiver_1.readS32BE_0_k$(), tmp0_safe_receiver_1.readS32BE_0_k$(), tmp0_safe_receiver_1.readS32BE_0_k$(), tmp0_safe_receiver_1.readS32BE_0_k$(), readSibLineMetrics(tmp0_safe_receiver_1, $this), readSibLineMetrics(tmp0_safe_receiver_1, $this), tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readU8_0_k$(), tmp0_safe_receiver_1.readU8_0_k$(), tmp0_safe_receiver_1.readU8_0_k$(), tmp0_safe_receiver_1.readS8_0_k$());
          tmp_8 = tmp_8 + 1 | 0;
        }
        var colorBitmapInfos_7 = toList(tmp_10);
        var tmp1_iterator_12 = colorBitmapInfos_7.iterator_0_k$();
        while (tmp1_iterator_12.hasNext_0_k$()) {
          var cbi_13 = tmp1_iterator_12.next_0_k$();
          var glyphCount_14 = cbi_13._endGlyphIndex - cbi_13._startGlyphIndex | 0;
          tmp0_safe_receiver_1._set_position__majfzk_k$(cbi_13._indexSubTableArrayOffset);
          var tmp_16 = 0;
          var tmp_17 = cbi_13._numberofIndexSubTables;
          var tmp_18 = fillArrayVal(Array(tmp_17), null);
          while (tmp_16 < tmp_17) {
            var tmp_19 = tmp_16;
            tmp_18[tmp_19] = new Subtable(tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readS32BE_0_k$());
            tmp_16 = tmp_16 + 1 | 0;
          }
          var subtables_15 = tmp_18;
          var indexedObject = subtables_15;
          var inductionVariable = 0;
          var last_1 = indexedObject.length;
          while (inductionVariable < last_1) {
            var subtable_21 = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp0_safe_receiver_1._set_position__majfzk_k$(cbi_13._indexSubTableArrayOffset + subtable_21._additionalOffsetToIndexSubtable | 0);
            var indexFormat_22 = tmp0_safe_receiver_1.readU16BE_0_k$();
            var imageFormat_23 = tmp0_safe_receiver_1.readU16BE_0_k$();
            var imageDataOffset_24 = tmp0_safe_receiver_1.readS32BE_0_k$();
            var tmp3_subject_26 = indexFormat_22;
            var tmp;
            if (tmp3_subject_26 === 1) {
              var tmp_27 = 0;
              var tmp_28 = subtable_21._get_numGlyphs__0_k$() + 1 | 0;
              var tmp_29 = fillArrayVal(Array(tmp_28), null);
              while (tmp_27 < tmp_28) {
                var tmp_30 = tmp_27;
                tmp_29[tmp_30] = imageDataOffset_24 + tmp0_safe_receiver_1.readS32BE_0_k$() | 0;
                tmp_27 = tmp_27 + 1 | 0;
              }
              tmp = tmp_29;
            } else {
              tmp = [];
            }
            var offsets_25 = tmp;
            var inductionVariable_0 = 0;
            var last_2 = offsets_25.length - 1 | 0;
            if (inductionVariable_0 < last_2)
              do {
                var n_32 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset_33 = offsets_25[n_32];
                var size_34 = offsets_25[n_32 + 1 | 0] - offset_33 | 0;
                var glyphID_35 = (subtable_21._firstGlyphIndex + n_32 | 0) - 1 | 0;
                var tmp0_set_0_36 = $this._bitmapGlyphInfos;
                var tmp1_set_0_37 = BitmapGlyphInfo_init_$Create$(glyphID_35, imageFormat_23, offset_33, size_34, cbi_13, 0, 0, 0, 0, 0, 0, 0, 0, 8160, null);
                tmp0_set_0_36.put_1q9pf_k$(glyphID_35, tmp1_set_0_37);
                Unit_getInstance();
              }
               while (inductionVariable_0 < last_2);
          }
        }
      } else {
        println('' + 'Unsupported CBLC ' + majorVersion_3 + '.' + minorVersion_4);
      }
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readCbdt($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('CBDT');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var majorVersion_3 = tmp0_safe_receiver_1.readU16BE_0_k$();
      var minorVersion_4 = tmp0_safe_receiver_1.readU16BE_0_k$();
      var tmp0_subject_5 = majorVersion_3;
      if (tmp0_subject_5 === 3) {
        var tmp1_iterator_6 = $this._bitmapGlyphInfos._get_values__0_k$().iterator_0_k$();
        while (tmp1_iterator_6.hasNext_0_k$()) {
          var i_7 = tmp1_iterator_6.next_0_k$();
          var format_8 = i_7._imageFormat_3;
          var tmp2_subject_9 = format_8;
          if (tmp2_subject_9 === 17 ? true : tmp2_subject_9 === 18) {
            i_7._height_6 = tmp0_safe_receiver_1.readU8_0_k$();
            i_7._width_5 = tmp0_safe_receiver_1.readU8_0_k$();
            i_7._horiBearingX = tmp0_safe_receiver_1.readS8_0_k$();
            i_7._horiBearingY = tmp0_safe_receiver_1.readS8_0_k$();
            i_7._horiAdvance = tmp0_safe_receiver_1.readU8_0_k$();
            i_7._vertBearingX = format_8 === 18 ? tmp0_safe_receiver_1.readS8_0_k$() : i_7._horiBearingX;
            i_7._vertBearingY = format_8 === 18 ? tmp0_safe_receiver_1.readS8_0_k$() : i_7._horiBearingY;
            i_7._vertAdvance = format_8 === 18 ? tmp0_safe_receiver_1.readS8_0_k$() : i_7._horiAdvance;
          }var dataLen_10 = tmp0_safe_receiver_1.readS32BE_0_k$();
          i_7._s_6 = tmp0_safe_receiver_1.readSlice_ha5a7z_k$(dataLen_10);
        }
      } else {
        println('' + 'Unsupported CBDT ' + majorVersion_3 + '.' + minorVersion_4);
      }
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readColr($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('COLR');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var version_3 = tmp0_safe_receiver_1.readU16BE_0_k$();
      var tmp0_subject_4 = version_3;
      if (tmp0_subject_4 === 0) {
        var numBaseGlyphRecords_5 = tmp0_safe_receiver_1.readU16BE_0_k$();
        var baseGlyphRecordsOffset_6 = tmp0_safe_receiver_1.readS32BE_0_k$();
        var layerRecordsOffset_7 = tmp0_safe_receiver_1.readS32BE_0_k$();
        var numLayerRecords_8 = tmp0_safe_receiver_1.readU16BE_0_k$();
        tmp0_safe_receiver_1._set_position__majfzk_k$(layerRecordsOffset_7);
        var tmp = $this;
        var tmp_9 = 0;
        var tmp_10 = numLayerRecords_8;
        var tmp_11 = fillArrayVal(Array(tmp_10), null);
        while (tmp_9 < tmp_10) {
          var tmp_12 = tmp_9;
          tmp_11[tmp_12] = new ColrLayerInfo($this, tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readU16BE_0_k$());
          tmp_9 = tmp_9 + 1 | 0;
        }
        tmp._colrLayerInfos = tmp_11;
        tmp0_safe_receiver_1._set_position__majfzk_k$(baseGlyphRecordsOffset_6);
        var inductionVariable = 0;
        if (inductionVariable < numBaseGlyphRecords_5)
          do {
            var n_14 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var info_15 = new ColrGlyphInfo($this, tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readU16BE_0_k$());
            $this._colrGlyphInfos.set_bq5tp3_k$(info_15._glyphID_1, info_15);
            Unit_getInstance();
          }
           while (inductionVariable < numBaseGlyphRecords_5);
      } else {
        println('TTF WARNING CCOL version != 0');
      }
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readCmap($this) {
    var tmp0_safe_receiver_1 = $this.openTable_6wfw3l_k$('cmap');
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var version_3 = tmp0_safe_receiver_1.readU16BE_0_k$();
      var numTables_4 = tmp0_safe_receiver_1.readU16BE_0_k$();
      var tmp0_map_0_6 = until(0, numTables_4);
      var tmp0_mapTo_0_1_7 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_6, 10));
      var inductionVariable = tmp0_map_0_6._get_first__0_k$();
      var last_1 = tmp0_map_0_6._get_last__0_k$();
      if (inductionVariable <= last_1)
        do {
          var item_2_3_9 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          tmp0_mapTo_0_1_7.add_2bq_k$(new EncodingRecord(tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readU16BE_0_k$(), tmp0_safe_receiver_1.readS32BE_0_k$()));
          Unit_getInstance();
        }
         while (!(item_2_3_9 === last_1));
      var tables_5 = tmp0_mapTo_0_1_7;
      var tmp0_iterator_10 = tables_5.iterator_0_k$();
      while (tmp0_iterator_10.hasNext_0_k$()) {
        var table_11 = tmp0_iterator_10.next_0_k$();
        var tmp1_run_0_12 = tmp0_safe_receiver_1.sliceStart_ha5a7z_k$(table_11._offset_28);
        var format_2_13 = tmp1_run_0_12.readU16BE_0_k$();
        var tmp0_subject_3_14 = format_2_13;
        switch (tmp0_subject_3_14) {
          case 0:
            println('' + 'UNSUPPORTED CMAP format = ' + format_2_13);
            break;
          case 2:
            println('' + 'UNSUPPORTED CMAP format = ' + format_2_13);
            break;
          case 4:
            var length_4_15 = tmp1_run_0_12.readU16BE_0_k$();
            var language_5_16 = tmp1_run_0_12.readU16BE_0_k$();
            var segCount_6_17 = tmp1_run_0_12.readU16BE_0_k$() / 2 | 0;
            var searchRangeS_7_18 = tmp1_run_0_12.readU16BE_0_k$();
            var entrySelector_8_19 = tmp1_run_0_12.readU16BE_0_k$();
            var rangeShift_9_20 = tmp1_run_0_12.readU16BE_0_k$();
            var endCount_10_21 = tmp1_run_0_12.readCharArrayBE_ha5a7z_k$(segCount_6_17);
            tmp1_run_0_12.readU16BE_0_k$();
            Unit_getInstance();
            var startCount_11_22 = tmp1_run_0_12.readCharArrayBE_ha5a7z_k$(segCount_6_17);
            var idDelta_12_23 = tmp1_run_0_12.readShortArrayBE_ha5a7z_k$(segCount_6_17);
            var rangeOffsetPos_13_24 = tmp1_run_0_12._get_position__0_k$();
            var idRangeOffset_14_25 = tmp1_run_0_12.readCharArrayBE_ha5a7z_k$(segCount_6_17);
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < segCount_6_17)
              do {
                var n_16_27 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ec_17_28 = endCount_10_21[n_16_27].toInt_0_k$();
                var sc_18_29 = startCount_11_22[n_16_27].toInt_0_k$();
                var delta_19_30 = idDelta_12_23[n_16_27];
                var iro_20_31 = idRangeOffset_14_25[n_16_27].toInt_0_k$();
                var inductionVariable_1 = sc_18_29;
                if (inductionVariable_1 <= ec_17_28)
                  do {
                    var c_22_33 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var index_23_34;
                    if (!(iro_20_31 === 0)) {
                      var glyphIndexOffset_24_35 = rangeOffsetPos_13_24 + imul(n_16_27, 2) | 0;
                      glyphIndexOffset_24_35 = glyphIndexOffset_24_35 + iro_20_31 | 0;
                      glyphIndexOffset_24_35 = glyphIndexOffset_24_35 + imul(c_22_33 - sc_18_29 | 0, 2) | 0;
                      index_23_34 = tmp1_run_0_12.sliceStart_ha5a7z_k$(glyphIndexOffset_24_35).readU16BE_0_k$();
                      if (!(index_23_34 === 0)) {
                        index_23_34 = index_23_34 + delta_19_30 | 0;
                      }} else {
                      index_23_34 = c_22_33 + delta_19_30 | 0;
                    }
                    addCharacterMap($this, c_22_33, index_23_34 & 65535);
                  }
                   while (!(c_22_33 === ec_17_28));
              }
               while (inductionVariable_0 < segCount_6_17);
            break;
          case 6:
            var length_25_36 = tmp1_run_0_12.readU16BE_0_k$();
            var language_26_37 = tmp1_run_0_12.readU16BE_0_k$();
            var firstCode_27_38 = tmp1_run_0_12.readU16BE_0_k$();
            var entryCount_28_39 = tmp1_run_0_12.readU16BE_0_k$();
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < entryCount_28_39)
              do {
                var n_30_41 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                addCharacterMap($this, firstCode_27_38 + tmp1_run_0_12.readU16BE_0_k$() | 0, n_30_41);
              }
               while (inductionVariable_2 < entryCount_28_39);
            break;
          case 8:
            println('' + 'UNSUPPORTED CMAP format = ' + format_2_13);
            break;
          case 10:
            println('' + 'UNSUPPORTED CMAP format = ' + format_2_13);
            break;
          case 12:
            tmp1_run_0_12.readU16BE_0_k$();
            Unit_getInstance();
            var length_31_42 = tmp1_run_0_12.readS32BE_0_k$();
            var language_32_43 = tmp1_run_0_12.readS32BE_0_k$();
            var numGroups_33_44 = tmp1_run_0_12.readS32BE_0_k$();
            var inductionVariable_3 = 0;
            if (inductionVariable_3 < numGroups_33_44)
              do {
                var n_35_46 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                var startCharCode_36_47 = tmp1_run_0_12.readS32BE_0_k$();
                var endCharCode_37_48 = tmp1_run_0_12.readS32BE_0_k$();
                var startGlyphId_38_49 = tmp1_run_0_12.readS32BE_0_k$();
                var glyphId_39_50 = startGlyphId_38_49;
                var inductionVariable_4 = startCharCode_36_47;
                if (inductionVariable_4 <= endCharCode_37_48)
                  do {
                    var c_41_52 = inductionVariable_4;
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    addCharacterMap($this, c_41_52, glyphId_39_50);
                    var tmp6_42_53 = glyphId_39_50;
                    glyphId_39_50 = tmp6_42_53 + 1 | 0;
                    Unit_getInstance();
                  }
                   while (!(c_41_52 === endCharCode_37_48));
              }
               while (inductionVariable_3 < numGroups_33_44);
            break;
          case 13:
            println('' + 'UNSUPPORTED CMAP format = ' + format_2_13);
            break;
          case 14:
            break;
          default:println('' + 'UNSUPPORTED CMAP format = ' + format_2_13);
            break;
        }
      }
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function Contour(x, y, onCurve_0) {
    this._x_12 = x;
    this._y_11 = y;
    this._onCurve = onCurve_0;
  }
  Contour.prototype.toString = function () {
    return '' + 'Contour(x=' + this._x_12 + ', y=' + this._y_11 + ', onCurve=' + this._onCurve + ')';
  };
  Contour.prototype.hashCode = function () {
    var result = this._x_12;
    result = imul(result, 31) + this._y_11 | 0;
    result = imul(result, 31) + (this._onCurve | 0) | 0;
    return result;
  };
  Contour.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this._x_12 === tmp0_other_with_cast._x_12))
      return false;
    if (!(this._y_11 === tmp0_other_with_cast._y_11))
      return false;
    if (!(this._onCurve === tmp0_other_with_cast._onCurve))
      return false;
    return true;
  };
  Contour.$metadata$ = {
    simpleName: 'Contour',
    kind: 'class',
    interfaces: []
  };
  function GlyphReference(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this._glyph = glyph;
    this._x_13 = x;
    this._y_12 = y;
    this._scaleX_1 = scaleX;
    this._scale01 = scale01;
    this._scale10 = scale10;
    this._scaleY_1 = scaleY;
  }
  GlyphReference.prototype.toString = function () {
    return '' + 'GlyphReference(glyph=' + this._glyph + ', x=' + this._x_13 + ', y=' + this._y_12 + ', scaleX=' + this._scaleX_1 + ', scale01=' + this._scale01 + ', scale10=' + this._scale10 + ', scaleY=' + this._scaleY_1 + ')';
  };
  GlyphReference.prototype.hashCode = function () {
    var result = hashCode(this._glyph);
    result = imul(result, 31) + this._x_13 | 0;
    result = imul(result, 31) + this._y_12 | 0;
    result = imul(result, 31) + getNumberHashCode(this._scaleX_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scale01) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scale10) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scaleY_1) | 0;
    return result;
  };
  GlyphReference.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals_1(this._glyph, tmp0_other_with_cast._glyph))
      return false;
    if (!(this._x_13 === tmp0_other_with_cast._x_13))
      return false;
    if (!(this._y_12 === tmp0_other_with_cast._y_12))
      return false;
    if (!equals_1(this._scaleX_1, tmp0_other_with_cast._scaleX_1))
      return false;
    if (!equals_1(this._scale01, tmp0_other_with_cast._scale01))
      return false;
    if (!equals_1(this._scale10, tmp0_other_with_cast._scale10))
      return false;
    if (!equals_1(this._scaleY_1, tmp0_other_with_cast._scaleY_1))
      return false;
    return true;
  };
  GlyphReference.$metadata$ = {
    simpleName: 'GlyphReference',
    kind: 'class',
    interfaces: []
  };
  function ColrLayerInfo($outer, glyphID, paletteIndex) {
    this._$this_11 = $outer;
    this._glyphID_0 = glyphID;
    this._paletteIndex = paletteIndex;
  }
  ColrLayerInfo.prototype.color_kxqjbk_k$ = function (pal) {
    var tmp0_getOrElse_0 = getCyclic(this._$this_11._palettes, pal)._colors;
    var tmp1_getOrElse_0 = this._paletteIndex;
    var tmp;
    if (tmp1_getOrElse_0 >= 0 ? tmp1_getOrElse_0 <= _get_lastIndex__4(new RgbaArray(tmp0_getOrElse_0)) : false) {
      tmp = (new RgbaArray(tmp0_getOrElse_0)).get_ha5a7z_k$(tmp1_getOrElse_0)._value_19;
    } else {
      tmp = Colors_getInstance()._FUCHSIA;
    }
    return tmp;
  };
  ColrLayerInfo.prototype._get_color__12t64v_k$ = function () {
    return this.color_kxqjbk_k$(0);
  };
  ColrLayerInfo.prototype.getColorPath_ha5a7z_k$ = function (pal) {
    var tmp0_safe_receiver = this._$this_11.getGlyphByIndex$default_ya9yh2_k$(this._glyphID_0, false, 0, 6, null);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_path__0_k$();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = new RGBA(this.color_kxqjbk_k$(pal));
      tmp = FillShape_init_$Create$(tmp1_safe_receiver, null, tmp_0, null, 8, null);
    }
    return tmp;
  };
  ColrLayerInfo.prototype.toString = function () {
    return '' + 'ColrLayerInfo(' + this._glyphID_0 + ', ' + this._paletteIndex + ', ' + new RGBA(this._get_color__12t64v_k$()) + ')';
  };
  ColrLayerInfo.$metadata$ = {
    simpleName: 'ColrLayerInfo',
    kind: 'class',
    interfaces: []
  };
  function ColrGlyphInfo($outer, glyphID, firstLayerIndex, numLayers) {
    this._$this_12 = $outer;
    this._glyphID_1 = glyphID;
    this._firstLayerIndex = firstLayerIndex;
    this._numLayers = numLayers;
  }
  ColrGlyphInfo.prototype.get_ha5a7z_k$ = function (index_0) {
    return this._$this_12._colrLayerInfos[this._firstLayerIndex + index_0 | 0];
  };
  ColrGlyphInfo.prototype.toList_0_k$ = function () {
    var tmp = 0;
    var tmp_0 = this._numLayers;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.get_ha5a7z_k$(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList(tmp_1);
  };
  ColrGlyphInfo.prototype.getColorPaths_ha5a7z_k$ = function (pal) {
    var tmp0_mapNotNull_0 = this.toList_0_k$();
    var tmp0_mapNotNullTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_mapNotNull_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp0_safe_receiver_2_4_4 = element_2_3.getColorPath_ha5a7z_k$(pal);
      if (tmp0_safe_receiver_2_4_4 == null)
        null;
      else {
        tmp0_mapNotNullTo_0_1.add_2bq_k$(tmp0_safe_receiver_2_4_4);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    return tmp0_mapNotNullTo_0_1;
  };
  ColrGlyphInfo.prototype.getColorPaths$default_l3mjq9_k$ = function (pal, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      pal = 0;
    return this.getColorPaths_ha5a7z_k$(pal);
  };
  ColrGlyphInfo.prototype.toString = function () {
    return '' + 'ColrGlyphInfo[' + this._glyphID_1 + '][' + this._numLayers + '](' + this.toList_0_k$() + ')';
  };
  ColrGlyphInfo.$metadata$ = {
    simpleName: 'ColrGlyphInfo',
    kind: 'class',
    interfaces: []
  };
  function GlyphGraphicsPath(glpyhIndex, commands, data, winding) {
    GraphicsPath.call(this, commands, data, winding);
    this._glpyhIndex = glpyhIndex;
  }
  GlyphGraphicsPath.prototype.toString = function () {
    return '' + 'GraphicsPath(glpyhIndex=' + this._glpyhIndex + ', "' + toSvgPathString$default(this, null, 0, 3, null) + '")';
  };
  GlyphGraphicsPath.$metadata$ = {
    simpleName: 'GlyphGraphicsPath',
    kind: 'class',
    interfaces: []
  };
  function Glyph_0($outer, index_0, xMin, yMin, xMax, yMax, advanceWidth) {
    this._$this_13 = $outer;
    this._index_18 = index_0;
    this._xMin = xMin;
    this._yMin = yMin;
    this._xMax = xMax;
    this._yMax = yMax;
    this._advanceWidth_0 = advanceWidth;
    var tmp = this;
    var size_2 = this._$this_13._unitsPerEm;
    var scale_3 = getTextScale_0(this._$this_13, size_2);
    tmp._metrics1px = new GlyphMetrics(size_2, true, -1, Companion_getInstance_35().fromBounds_i6u10_k$(this._xMin * scale_3, this._yMin * scale_3, this._xMax * scale_3, this._yMax * scale_3), this._advanceWidth_0 * scale_3);
  }
  Glyph_0.prototype._get_index__0_k$ = function () {
    return this._index_18;
  };
  Glyph_0.prototype._get_advanceWidth__0_k$ = function () {
    return this._advanceWidth_0;
  };
  Glyph_0.prototype._get_colorEntry__0_k$ = function () {
    return this._$this_13._colrGlyphInfos.get_ha5a7z_k$(this._index_18);
  };
  Glyph_0.prototype._get_bitmapEntry__0_k$ = function () {
    return this._$this_13._bitmapGlyphInfos.get_2bw_k$(this._index_18);
  };
  Glyph_0.$metadata$ = {
    simpleName: 'Glyph',
    kind: 'class',
    interfaces: []
  };
  function CompositeGlyph($outer, index_0, xMin, yMin, xMax, yMax, refs, advanceWidth) {
    this._$this_14 = $outer;
    Glyph_0.call(this, $outer, index_0, xMin, yMin, xMax, yMax, advanceWidth);
    this._refs = refs;
    var tmp = this;
    var tmp0_map_0 = this._refs;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      var gpath_5 = item_2_3._glyph._get_path__0_k$();
      var tmp_0 = new IntArrayList(gpath_5._get_commands__0_k$()._get_size__0_k$());
      var tmp_1 = new DoubleArrayList(gpath_5._get_data__0_k$()._get_size__0_k$());
      var tmp0_also_0_6 = GlyphGraphicsPath_init_$Create$(item_2_3._glyph._index_18, tmp_0, tmp_1, null, 8, null);
      var m_2_7 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
      m_2_7.translate_27zxwg_k$(item_2_3._x_13, -item_2_3._y_12 | 0);
      Unit_getInstance();
      m_2_7.scale_rybm4g_k$(item_2_3._scaleX_1, item_2_3._scaleY_1);
      Unit_getInstance();
      tmp0_also_0_6.write_lypuw5_k$(item_2_3._glyph._get_path__0_k$(), m_2_7);
      tmp0_mapTo_0_1.add_2bq_k$(tmp0_also_0_6);
      Unit_getInstance();
    }
    tmp._paths_5 = tmp0_mapTo_0_1;
    var tmp_2 = this;
    var commandsSize_2 = 0;
    var dataSize_3 = 0;
    var tmp0_fastForEach_0_4 = this._paths_5;
    var n_1_5 = 0;
    while (n_1_5 < tmp0_fastForEach_0_4._get_size__0_k$()) {
      var tmp0_2_7 = n_1_5;
      n_1_5 = tmp0_2_7 + 1 | 0;
      var tmp1__anonymous__3_6 = tmp0_fastForEach_0_4.get_ha5a7z_k$(tmp0_2_7);
      commandsSize_2 = commandsSize_2 + tmp1__anonymous__3_6._get_commands__0_k$()._get_size__0_k$() | 0;
      dataSize_3 = dataSize_3 + tmp1__anonymous__3_6._get_data__0_k$()._get_size__0_k$() | 0;
    }
    var tmp_3 = new IntArrayList(commandsSize_2);
    var tmp_4 = new DoubleArrayList(dataSize_3);
    var tmp2_also_0_8 = GlyphGraphicsPath_init_$Create$(index_0, tmp_3, tmp_4, null, 8, null);
    var tmp0_fastForEach_0_2_9 = this._paths_5;
    var n_1_3_10 = 0;
    while (n_1_3_10 < tmp0_fastForEach_0_2_9._get_size__0_k$()) {
      var tmp0_2_5_12 = n_1_3_10;
      n_1_3_10 = tmp0_2_5_12 + 1 | 0;
      var tmp1__anonymous__3_4_11 = tmp0_fastForEach_0_2_9.get_ha5a7z_k$(tmp0_2_5_12);
      tmp2_also_0_8.write$default_jet5j6_k$(tmp1__anonymous__3_4_11, null, 2, null);
    }
    tmp_2._path_18 = tmp2_also_0_8;
  }
  CompositeGlyph.prototype.toString = function () {
    return '' + 'CompositeGlyph[' + this._get_advanceWidth__0_k$() + '](' + this._refs + ')';
  };
  CompositeGlyph.prototype._get_path__0_k$ = function () {
    return this._path_18;
  };
  CompositeGlyph.$metadata$ = {
    simpleName: 'CompositeGlyph',
    kind: 'class',
    interfaces: []
  };
  function SimpleGlyph($outer, index_0, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth) {
    this._$this_15 = $outer;
    Glyph_0.call(this, $outer, index_0, xMin, yMin, xMax, yMax, advanceWidth);
    this._contoursIndices = contoursIndices;
    this._flags_3 = flags;
    this._xPos = xPos;
    this._yPos = yPos;
    var tmp = this;
    var commandSize_2 = 0;
    var dataSize_3 = 0;
    var inductionVariable = 0;
    var last_1 = this._contoursIndices.length - 1 | 0;
    if (inductionVariable < last_1)
      do {
        var n_2_5 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart_3_6 = this._contoursIndices[n_2_5] + 1 | 0;
        var cend_4_7 = this._contoursIndices[n_2_5 + 1 | 0];
        var csize_5_8 = (cend_4_7 - cstart_3_6 | 0) + 1 | 0;
        commandSize_2 = commandSize_2 + (1 + imul(csize_5_8, 2) | 0) | 0;
        dataSize_3 = dataSize_3 + (2 + imul(csize_5_8, 8) | 0) | 0;
      }
       while (inductionVariable < last_1);
    var tmp_0 = new IntArrayList(commandSize_2);
    var tmp_1 = new DoubleArrayList(dataSize_3);
    var tmp0_also_0_9 = GlyphGraphicsPath_init_$Create$(index_0, tmp_0, tmp_1, null, 8, null);
    var inductionVariable_0 = 0;
    var last_2 = this._contoursIndices.length - 1 | 0;
    if (inductionVariable_0 < last_2)
      do {
        var n_2_3_11 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_3_4_12 = this._contoursIndices[n_2_3_11] + 1 | 0;
        var cend_4_5_13 = this._contoursIndices[n_2_3_11 + 1 | 0];
        var csize_5_6_14 = (cend_4_5_13 - cstart_3_4_12 | 0) + 1 | 0;
        var curr_7_7_15 = contour(this, cend_4_5_13, this._$this_15._tempContours[0]);
        var next_8_8_16 = contour(this, cstart_3_4_12, this._$this_15._tempContours[1]);
        if (curr_7_7_15._onCurve)
          moveTo(tmp0_also_0_9, curr_7_7_15._x_12, -curr_7_7_15._y_11 | 0);
        else if (next_8_8_16._onCurve)
          moveTo(tmp0_also_0_9, next_8_8_16._x_12, -next_8_8_16._y_11 | 0);
        else
          moveTo(tmp0_also_0_9, imul(curr_7_7_15._x_12 + next_8_8_16._x_12 | 0, 0), -numberToInt((curr_7_7_15._y_11 + next_8_8_16._y_11 | 0) * 0.5) | 0);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_5_6_14)
          do {
            var cpos_10_10_18 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev_11_11_19 = curr_7_7_15;
            curr_7_7_15 = next_8_8_16;
            next_8_8_16 = contour(this, cstart_3_4_12 + (cpos_10_10_18 + 1 | 0) % csize_5_6_14 | 0, this._$this_15._tempContours[(cpos_10_10_18 + 2 | 0) % 3]);
            if (curr_7_7_15._onCurve) {
              lineTo(tmp0_also_0_9, curr_7_7_15._x_12, -curr_7_7_15._y_11 | 0);
            } else {
              var prev2X_12_12_20 = prev_11_11_19._x_12;
              var prev2Y_13_13_21 = prev_11_11_19._y_11;
              var next2X_14_14_22 = next_8_8_16._x_12;
              var next2Y_15_15_23 = next_8_8_16._y_11;
              if (!prev_11_11_19._onCurve) {
                prev2X_12_12_20 = numberToInt((curr_7_7_15._x_12 + prev_11_11_19._x_12 | 0) * 0.5);
                prev2Y_13_13_21 = numberToInt((curr_7_7_15._y_11 + prev_11_11_19._y_11 | 0) * 0.5);
                lineTo(tmp0_also_0_9, prev2X_12_12_20, -prev2Y_13_13_21 | 0);
              }if (!next_8_8_16._onCurve) {
                next2X_14_14_22 = numberToInt((curr_7_7_15._x_12 + next_8_8_16._x_12 | 0) * 0.5);
                next2Y_15_15_23 = numberToInt((curr_7_7_15._y_11 + next_8_8_16._y_11 | 0) * 0.5);
              }lineTo(tmp0_also_0_9, prev2X_12_12_20, -prev2Y_13_13_21 | 0);
              quadTo(tmp0_also_0_9, curr_7_7_15._x_12, -curr_7_7_15._y_11 | 0, next2X_14_14_22, -next2Y_15_15_23 | 0);
            }
          }
           while (inductionVariable_1 < csize_5_6_14);
        tmp0_also_0_9.close_sv8swh_k$();
      }
       while (inductionVariable_0 < last_2);
    tmp._path_19 = tmp0_also_0_9;
    this._paths_6 = listOf_0(this._path_19);
  }
  SimpleGlyph.prototype.toString = function () {
    return '' + 'SimpleGlyph[' + this._get_advanceWidth__0_k$() + '](' + this._get_index__0_k$() + ') : ' + this._path_19;
  };
  SimpleGlyph.prototype._get_path__0_k$ = function () {
    return this._path_19;
  };
  SimpleGlyph.$metadata$ = {
    simpleName: 'SimpleGlyph',
    kind: 'class',
    interfaces: []
  };
  function readF2DOT14(_this_, $this) {
    var v = _this_.readS16BE_0_k$();
    var i = v >> 14;
    var f = v & 16383;
    return i + f / 16384.0;
  }
  function readMixBE(_this_, $this, signed, word) {
    var tmp;
    if (!word ? signed : false) {
      tmp = _this_.readS8_0_k$();
    } else if (!word ? !signed : false) {
      tmp = _this_.readU8_0_k$();
    } else if (word ? signed : false) {
      tmp = _this_.readS16BE_0_k$();
    } else if (word ? !signed : false) {
      tmp = _this_.readU16BE_0_k$();
    } else {
      _get_invalidOp_();
    }
    return tmp;
  }
  function readGlyph(_this_, $this, index_0) {
    var ncontours = _this_.readS16BE_0_k$();
    var xMin = _this_.readS16BE_0_k$();
    var yMin = _this_.readS16BE_0_k$();
    var xMax = _this_.readS16BE_0_k$();
    var yMax = _this_.readS16BE_0_k$();
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      var references = ArrayList_init_$Create$();
      do {
        var flags = _this_.readU16BE_0_k$();
        var glyphIndex = _this_.readU16BE_0_k$();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = readMixBE(_this_, $this, signed, words);
        var y = readMixBE(_this_, $this, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = readF2DOT14(_this_, $this);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = readF2DOT14(_this_, $this);
          scaleY = readF2DOT14(_this_, $this);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = readF2DOT14(_this_, $this);
          scale01 = readF2DOT14(_this_, $this);
          scale10 = readF2DOT14(_this_, $this);
          scaleY = readF2DOT14(_this_, $this);
        }var ref = new GlyphReference(ensureNotNull($this.getGlyphByIndex$default_ya9yh2_k$(glyphIndex, false, 0, 6, null)), x, y, scaleX, scale01, scale10, scaleY);
        references.add_2bq_k$(ref);
        Unit_getInstance();
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      return new CompositeGlyph($this, index_0, xMin, yMin, xMax, yMax, references, $this._horMetrics.get_ha5a7z_k$(index_0)._advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this_.readU16BE_0_k$();
        }
         while (!(n === ncontours));
      var instructionLength = _this_.readU16BE_0_k$();
      var instructions = _this_.readBytesExact_ha5a7z_k$(instructionLength);
      var tmp1_safe_receiver = lastOrNull(contoursIndices);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver + 1 | 0;
      var numPoints = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
      var flags_0 = IntArrayList_init_$Create$(0, 1, null);
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this_.readU8_0_k$();
        flags_0.add_majfzk_k$(cf);
        if (!((cf & 8) === 0)) {
          var count_0 = _this_.readU8_0_k$();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count_0)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.add_majfzk_k$(cf);
            }
             while (inductionVariable_0 < count_0);
          npos = npos + (count_0 + 1 | 0) | 0;
        } else {
          var tmp4 = npos;
          npos = tmp4 + 1 | 0;
          Unit_getInstance();
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy_2 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy_2 === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.getAt_ha5a7z_k$(n_1);
              var b1 = !((flag >>> (1 + xy_2 | 0) & 1) === 0);
              var b2 = !((flag >>> (4 + xy_2 | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this_.readU8_0_k$();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this_.readS16BE_0_k$() | 0;
              }pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      return new SimpleGlyph($this, index_0, xMin, yMin, xMax, yMax, contoursIndices, flags_0.toIntArray_0_k$(), xPos, yPos, $this._horMetrics.get_ha5a7z_k$(index_0)._advanceWidth);
    }
  }
  function Subtable(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this._firstGlyphIndex = firstGlyphIndex;
    this._lastGlyphIndex = lastGlyphIndex;
    this._additionalOffsetToIndexSubtable = additionalOffsetToIndexSubtable;
  }
  Subtable.prototype._get_numGlyphs__0_k$ = function () {
    return this._lastGlyphIndex - this._firstGlyphIndex | 0;
  };
  Subtable.prototype.toString = function () {
    return '' + 'Subtable(firstGlyphIndex=' + this._firstGlyphIndex + ', lastGlyphIndex=' + this._lastGlyphIndex + ', additionalOffsetToIndexSubtable=' + this._additionalOffsetToIndexSubtable + ')';
  };
  Subtable.prototype.hashCode = function () {
    var result = this._firstGlyphIndex;
    result = imul(result, 31) + this._lastGlyphIndex | 0;
    result = imul(result, 31) + this._additionalOffsetToIndexSubtable | 0;
    return result;
  };
  Subtable.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Subtable))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Subtable ? other : THROW_CCE();
    if (!(this._firstGlyphIndex === tmp0_other_with_cast._firstGlyphIndex))
      return false;
    if (!(this._lastGlyphIndex === tmp0_other_with_cast._lastGlyphIndex))
      return false;
    if (!(this._additionalOffsetToIndexSubtable === tmp0_other_with_cast._additionalOffsetToIndexSubtable))
      return false;
    return true;
  };
  Subtable.$metadata$ = {
    simpleName: 'Subtable',
    kind: 'class',
    interfaces: []
  };
  function EncodingRecord(platformId, encodingId, offset_0) {
    this._platformId = platformId;
    this._encodingId = encodingId;
    this._offset_28 = offset_0;
  }
  EncodingRecord.prototype.toString = function () {
    return '' + 'EncodingRecord(platformId=' + this._platformId + ', encodingId=' + this._encodingId + ', offset=' + this._offset_28 + ')';
  };
  EncodingRecord.prototype.hashCode = function () {
    var result = this._platformId;
    result = imul(result, 31) + this._encodingId | 0;
    result = imul(result, 31) + this._offset_28 | 0;
    return result;
  };
  EncodingRecord.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EncodingRecord))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof EncodingRecord ? other : THROW_CCE();
    if (!(this._platformId === tmp0_other_with_cast._platformId))
      return false;
    if (!(this._encodingId === tmp0_other_with_cast._encodingId))
      return false;
    if (!(this._offset_28 === tmp0_other_with_cast._offset_28))
      return false;
    return true;
  };
  EncodingRecord.$metadata$ = {
    simpleName: 'EncodingRecord',
    kind: 'class',
    interfaces: []
  };
  function NameId_COPYRIGHT_getInstance() {
    NameId_initEntries();
    return NameId_COPYRIGHT_instance;
  }
  function NameId_NAME_getInstance() {
    NameId_initEntries();
    return NameId_NAME_instance;
  }
  function NameId_STYLE_getInstance() {
    NameId_initEntries();
    return NameId_STYLE_instance;
  }
  function NameId_UNAME_getInstance() {
    NameId_initEntries();
    return NameId_UNAME_instance;
  }
  function NameId_COMPLETE_NAME_getInstance() {
    NameId_initEntries();
    return NameId_COMPLETE_NAME_instance;
  }
  function NameId_RELEASE_VERSION_getInstance() {
    NameId_initEntries();
    return NameId_RELEASE_VERSION_instance;
  }
  function NameId_POSTSCRIPT_NAME_getInstance() {
    NameId_initEntries();
    return NameId_POSTSCRIPT_NAME_instance;
  }
  function NameId_TRADEMARK_getInstance() {
    NameId_initEntries();
    return NameId_TRADEMARK_instance;
  }
  function NameId_MANUFACTURER_getInstance() {
    NameId_initEntries();
    return NameId_MANUFACTURER_instance;
  }
  function NameId_DESIGNER_getInstance() {
    NameId_initEntries();
    return NameId_DESIGNER_instance;
  }
  function NameId_DESCRIPTION_getInstance() {
    NameId_initEntries();
    return NameId_DESCRIPTION_instance;
  }
  function NameId_URL_VENDOR_getInstance() {
    NameId_initEntries();
    return NameId_URL_VENDOR_instance;
  }
  function NameId_URL_DESIGNER_getInstance() {
    NameId_initEntries();
    return NameId_URL_DESIGNER_instance;
  }
  function NameId_LICENSE_DESCRIPTION_getInstance() {
    NameId_initEntries();
    return NameId_LICENSE_DESCRIPTION_instance;
  }
  function NameId_LICENSE_URL_getInstance() {
    NameId_initEntries();
    return NameId_LICENSE_URL_instance;
  }
  function NameId_RESERVED_15_getInstance() {
    NameId_initEntries();
    return NameId_RESERVED_15_instance;
  }
  function NameId_PREFERRED_FAMILY_getInstance() {
    NameId_initEntries();
    return NameId_PREFERRED_FAMILY_instance;
  }
  function NameId_PREFERRED_SUBFAMILY_getInstance() {
    NameId_initEntries();
    return NameId_PREFERRED_SUBFAMILY_instance;
  }
  function NameId_COMPATIBLE_FULL_getInstance() {
    NameId_initEntries();
    return NameId_COMPATIBLE_FULL_instance;
  }
  function NameId_SAMPLE_TEXT_getInstance() {
    NameId_initEntries();
    return NameId_SAMPLE_TEXT_instance;
  }
  function NameId_POSTSCRIPT_CID_getInstance() {
    NameId_initEntries();
    return NameId_POSTSCRIPT_CID_instance;
  }
  function NameId_WWS_FAMILY_NAME_getInstance() {
    NameId_initEntries();
    return NameId_WWS_FAMILY_NAME_instance;
  }
  function NameId_WWS_SUBFAMILY_NAME_getInstance() {
    NameId_initEntries();
    return NameId_WWS_SUBFAMILY_NAME_instance;
  }
  function NameId_LIGHT_BACKGROUND_getInstance() {
    NameId_initEntries();
    return NameId_LIGHT_BACKGROUND_instance;
  }
  function NameId_DARK_BACKGROUND_getInstance() {
    NameId_initEntries();
    return NameId_DARK_BACKGROUND_instance;
  }
  function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
    NameId_initEntries();
    return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
  }
  function TtfFont(s, freeze, extName, onlyReadMetadata) {
    Companion_getInstance_145();
    this._s_7 = s;
    this._freeze = freeze;
    this._extName = extName;
    this._onlyReadMetadata = onlyReadMetadata;
    this._namesi = new NamesInfo();
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 3;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Contour_init_$Create$(0, 0, false, 7, null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._tempContours = tmp_2;
    this._numGlyphs = 0;
    this._maxPoints = 0;
    this._maxContours = 0;
    this._maxCompositePoints = 0;
    this._maxCompositeContours = 0;
    this._maxZones = 0;
    this._maxTwilightPoints = 0;
    this._maxStorage = 0;
    this._maxFunctionDefs = 0;
    this._maxInstructionDefs = 0;
    this._maxStackElements = 0;
    this._maxSizeOfInstructions = 0;
    this._maxComponentElements = 0;
    this._maxComponentDepth = 0;
    this._hheaVersion = Companion_getInstance_146().invoke_27zxwg_k$(0, 0);
    this._ascender_0 = 0;
    this._descender_0 = 0;
    this._lineGap = 0;
    this._advanceWidthMax = 0;
    this._minLeftSideBearing = 0;
    this._minRightSideBearing = 0;
    this._xMaxExtent = 0;
    this._caretSlopeRise = 0;
    this._caretSlopeRun = 0;
    this._caretOffset_0 = 0;
    this._metricDataFormat = 0;
    this._numberOfHMetrics = 0;
    this._locs = new Int32Array(0);
    this._fontRev = Companion_getInstance_146().invoke_27zxwg_k$(0, 0);
    this._unitsPerEm = 128;
    this._xMin_0 = 0;
    this._yMin_0 = 0;
    this._xMax_0 = 0;
    this._yMax_0 = 0;
    this._macStyle = 0;
    this._lowestRecPPEM = 0;
    this._fontDirectionHint = 0;
    this._indexToLocFormat = 0;
    this._glyphDataFormat = 0;
    var tmp_4 = this;
    tmp_4._horMetrics = emptyList();
    this._characterMaps = LinkedHashMap_init_$Create$();
    this._characterMapsReverse = LinkedHashMap_init_$Create$();
    this._tablesByName = LinkedHashMap_init_$Create$();
    var tmp_5 = this;
    tmp_5._glyphCache = IntMap_init_$Create$(512, 0.0, 2, null);
    this._bitmapGlyphInfos = LinkedHashMap_init_$Create$();
    var tmp_6 = this;
    tmp_6._colrLayerInfos = [];
    var tmp_7 = this;
    tmp_7._colrGlyphInfos = IntMap_init_$Create$(0, 0.0, 3, null);
    var tmp_8 = this;
    tmp_8._palettes = emptyList();
    this._frozen = false;
    readHeaderTables_0(this);
    readHead(this);
    readMaxp(this);
    readHhea(this);
    readNames(this);
    if (!this._onlyReadMetadata) {
      readLoca(this);
      readCmap(this);
      readHmtx(this);
      readCpal(this);
      readColr(this);
      readCblc(this);
      readCbdt(this);
    }if (this._freeze) {
      var tmp0_fastForEach_0 = this.getAllGlyphs_vcj5fe_k$(true);
      var n_1 = 0;
      while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
        Unit_getInstance();
        tmp1__anonymous__3._get_path__0_k$();
        Unit_getInstance();
      }
    }this._frozen = true;
    var tmp_9 = this;
    var tmp0_also_0 = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    var scale_2 = getTextScale_0(this, 1.0);
    tmp0_also_0._size_13 = 1.0;
    tmp0_also_0._top = this._yMax_0 * scale_2;
    tmp0_also_0._ascent = this._ascender_0 * scale_2;
    tmp0_also_0._baseline = 0.0 * scale_2;
    tmp0_also_0._descent = this._descender_0 * scale_2;
    tmp0_also_0._bottom = this._yMin_0 * scale_2;
    tmp0_also_0._leading = this._lineGap * scale_2;
    tmp0_also_0._maxWidth = this._advanceWidthMax * scale_2;
    tmp_9._fontMetrics1px = tmp0_also_0;
    this._isOpenType = false;
    this._nonExistantGlyphMetrics1px = new GlyphMetrics(1.0, false, 0, Companion_getInstance_35().invoke_0_k$(), 0.0);
  }
  TtfFont.prototype.getAllBytesUnsafe_0_k$ = function () {
    return this._s_7.getBackingArrayUnsafe_0_k$();
  };
  TtfFont.prototype.getFontMetrics_sqtkiv_k$ = function (size_2, metrics) {
    return metrics.copyFromNewSize_1pu7zb_k$(this._fontMetrics1px, size_2);
  };
  TtfFont.prototype.getGlyphMetrics_xejy1t_k$ = function (size_2, codePoint, metrics) {
    var tmp0_safe_receiver = this.getGlyphByCodePoint$default_pqwnyh_k$(codePoint, false, 2, null);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._metrics1px;
    return metrics.copyFromNewSize_n1q0an_k$(tmp1_elvis_lhs == null ? this._nonExistantGlyphMetrics1px : tmp1_elvis_lhs, size_2, codePoint);
  };
  TtfFont.prototype.getKerning_jw27q7_k$ = function (size_2, leftCodePoint, rightCodePoint) {
    return 0.0;
  };
  TtfFont.prototype.getGlyphPath_ua72x3_k$ = function (size_2, codePoint, path_0) {
    var tmp0_elvis_lhs = this.getGlyphByCodePoint$default_pqwnyh_k$(codePoint, false, 2, null);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale_1 = getTextScale_0(this, size_2);
    path_0._path_17 = g._get_path__0_k$();
    var tmp_0 = path_0;
    var tmp1_safe_receiver = g._get_colorEntry__0_k$();
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      tmp_1 = tmp1_safe_receiver.getColorPaths$default_l3mjq9_k$(0, 1, null);
    }
    tmp_0._colorPaths = tmp_1;
    var bitmapEntry = g._get_bitmapEntry__0_k$();
    var tmp2_safe_receiver = bitmapEntry;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      tmp_2 = tmp2_safe_receiver.getBitmap$default_gexuk8_k$(false, 1, null);
    }
    var bitmap = tmp_2;
    path_0._bitmap_0 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this._unitsPerEm / bitmapEntry._info_2._ppemX;
      var scaleY = this._unitsPerEm / bitmapEntry._info_2._ppemY;
      path_0._bitmapOffset.setTo_ngl742_k$(0.0, ((-bitmapEntry._height_6 | 0) - bitmapEntry._get_descender__0_k$() | 0) * scaleY);
      Unit_getInstance();
      path_0._bitmapScale.setTo_ngl742_k$(scaleX, scaleY);
      Unit_getInstance();
    }path_0._transform_1.identity_0_k$();
    Unit_getInstance();
    path_0._transform_1.scale_ngl742_k$(scale_1, scale_1);
    Unit_getInstance();
    path_0._scale = scale_1;
    return path_0;
  };
  TtfFont.prototype._get_ttfName__0_k$ = function () {
    return this._namesi._get_ttfName__0_k$();
  };
  TtfFont.prototype._get_name__0_k$ = function () {
    var tmp0_elvis_lhs = this._extName;
    return tmp0_elvis_lhs == null ? this._get_ttfName__0_k$() : tmp0_elvis_lhs;
  };
  TtfFont.prototype.toString = function () {
    return '' + 'TtfFont(name=' + this._get_name__0_k$() + ')';
  };
  TtfFont.prototype.readFixed_v83o64_k$ = function (_this__0) {
    return Companion_getInstance_146().invoke_27zxwg_k$(_this__0.readS16LE_0_k$(), _this__0.readS16LE_0_k$());
  };
  TtfFont.prototype.openTable_6wfw3l_k$ = function (name) {
    var tmp0_safe_receiver = this._tablesByName.get_2bw_k$(name);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.open_0_k$();
  };
  TtfFont.prototype.getGlyphByCodePoint_sv7uuf_k$ = function (codePoint, cache) {
    var tmp0_safe_receiver = getCharacterMapOrNull(this, codePoint);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = this.getGlyphByIndex_smj4jc_k$(tmp0_safe_receiver, cache, codePoint);
    }
    return tmp;
  };
  TtfFont.prototype.getGlyphByCodePoint$default_pqwnyh_k$ = function (codePoint, cache, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      cache = true;
    return this.getGlyphByCodePoint_sv7uuf_k$(codePoint, cache);
  };
  TtfFont.prototype.getGlyphByIndex_smj4jc_k$ = function (index_0, cache, codePoint) {
    var tmp0_elvis_lhs = getOrNull(this._locs, index_0);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull(this._locs, index_0 + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size_2 = end - start | 0;
    var tmp;
    if (!(size_2 === 0)) {
      var tmp2_elvis_lhs = this._glyphCache.get_ha5a7z_k$(index_0);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp0_safe_receiver_1 = this.openTable_6wfw3l_k$('glyf');
        var tmp_1;
        if (tmp0_safe_receiver_1 == null) {
          tmp_1 = null;
        } else {
          var tmp0__anonymous__2 = ensureNotNull(this._tablesByName.get_2bw_k$('glyf'));
          var tmp0_also_0_3 = readGlyph(tmp0_safe_receiver_1.sliceStart_ha5a7z_k$(start), this, index_0);
          Unit_getInstance();
          tmp_1 = tmp0_also_0_3;
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      var tmp1_also_0 = new SimpleGlyph(this, index_0, 0, 0, 0, 0, new Int32Array([]), new Int32Array([]), new Int32Array([]), new Int32Array([]), this._horMetrics.get_ha5a7z_k$(index_0)._advanceWidth);
      Unit_getInstance();
      tmp = tmp1_also_0;
    }
    var glyph = tmp;
    if (cache ? !this._frozen : false) {
      this._glyphCache.set_bq5tp3_k$(index_0, glyph);
      Unit_getInstance();
    }return glyph;
  };
  TtfFont.prototype.getGlyphByIndex$default_ya9yh2_k$ = function (index_0, cache, codePoint, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      cache = true;
    if (!(($mask0 & 4) === 0))
      codePoint = -1;
    return this.getGlyphByIndex_smj4jc_k$(index_0, cache, codePoint);
  };
  TtfFont.prototype.getAllGlyphs_vcj5fe_k$ = function (cache) {
    var tmp0_mapNotNull_0 = until(0, this._numGlyphs);
    var tmp0_mapNotNullTo_0_1 = ArrayList_init_$Create$();
    var inductionVariable = tmp0_mapNotNull_0._get_first__0_k$();
    var last_1 = tmp0_mapNotNull_0._get_last__0_k$();
    if (inductionVariable <= last_1)
      do {
        var element_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver_2_4_4 = this.getGlyphByIndex$default_ya9yh2_k$(element_2_3, cache, 0, 4, null);
        if (tmp0_safe_receiver_2_4_4 == null)
          null;
        else {
          tmp0_mapNotNullTo_0_1.add_2bq_k$(tmp0_safe_receiver_2_4_4);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
       while (!(element_2_3 === last_1));
    return tmp0_mapNotNullTo_0_1;
  };
  TtfFont.$metadata$ = {
    simpleName: 'TtfFont',
    kind: 'class',
    interfaces: [VectorFont]
  };
  function Companion_147() {
    Companion_instance_146 = this;
  }
  Companion_147.prototype.invoke_27zxwg_k$ = function (num, den) {
    return insert(insert(0, num, 0, 16), den, 16, 16);
  };
  Companion_147.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_146;
  function Companion_getInstance_146() {
    if (Companion_instance_146 == null)
      new Companion_147();
    return Companion_instance_146;
  }
  function readTtfFont(_this_, preload, onlyReadMetadata, $cont) {
    var tmp = new $readTtfFontCOROUTINE$9(_this_, preload, onlyReadMetadata, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readTtfFont$default(_this_, preload, onlyReadMetadata, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      preload = false;
    if (!(($mask0 & 2) === 0))
      onlyReadMetadata = false;
    return readTtfFont(_this_, preload, onlyReadMetadata, $cont);
  }
  function $readTtfFontCOROUTINE$9(_this_, preload, onlyReadMetadata, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__123 = _this_;
    this._preload_0 = preload;
    this._onlyReadMetadata_0 = onlyReadMetadata;
  }
  $readTtfFontCOROUTINE$9.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__123.readAll_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return TtfFont_init_$Create$(ARGUMENT, this._preload_0, _get_baseName_(this.__this__123), this._onlyReadMetadata_0);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readTtfFontCOROUTINE$9.$metadata$ = {
    simpleName: '$readTtfFontCOROUTINE$9',
    kind: 'class',
    interfaces: []
  };
  function VectorFont() {
  }
  VectorFont.prototype.getGlyphPath$default_pwme3u_k$ = function (size_2, codePoint, path_0, $mask0, $handler) {
    if (!(($mask0 & 4) === 0)) {
      path_0 = GlyphPath_init_$Create$(null, null, null, null, null, null, 0.0, 127, null);
    }return $handler == null ? this.getGlyphPath_ua72x3_k$(size_2, codePoint, path_0) : $handler(size_2, codePoint, path_0);
  };
  VectorFont.prototype.renderGlyph_its5jl_k$ = function (ctx, size_2, codePoint, x, y, fill_4, metrics) {
    this.getGlyphMetrics_xejy1t_k$(size_2, codePoint, metrics);
    Unit_getInstance();
    var g = this.getGlyphPath$default_pwme3u_k$(size_2, codePoint, null, 4, null);
    if (!(g == null)) {
      var t_1 = ctx._state_5._transform_6;
      var a_2 = t_1._a;
      var b_3 = t_1._b;
      var c_4 = t_1._c;
      var d_5 = t_1._d;
      var tx_6 = t_1._tx;
      var ty_7 = t_1._ty;
      try {
        ctx.translate_ngl742_k$(x, y);
        Unit_getInstance();
        g.draw_h81jc_k$(ctx);
      }finally {
        t_1.setTo_hmhsjq_k$(a_2, b_3, c_4, d_5, tx_6, ty_7);
        Unit_getInstance();
      }
      if (fill_4)
        ctx.fill_sv8swh_k$();
      else
        ctx.stroke_sv8swh_k$();
    }};
  VectorFont.$metadata$ = {
    simpleName: 'VectorFont',
    kind: 'interface',
    interfaces: [Font]
  };
  function BmImageInfo() {
    ImageInfo.call(this);
    this._flipX = false;
    this._flipY = false;
  }
  BmImageInfo.$metadata$ = {
    simpleName: 'BmImageInfo',
    kind: 'class',
    interfaces: []
  };
  function BMP() {
    BMP_instance = this;
    ImageFormat.call(this, ['bmp']);
  }
  BMP.prototype.decodeHeader_55aaqy_k$ = function (s, props) {
    if (!(readStringz$default(s, 2, null, 2, null) === 'BM'))
      return null;
    else {
    }
    var size_2 = readS32LE_1(s);
    var reserved1 = readS16LE_1(s);
    var reserved2 = readS16LE_1(s);
    var offBits = readS32LE_1(s);
    var bsize = readS32LE_1(s);
    var width = readS32LE_1(s);
    var height = readS32LE_1(s);
    var planes = readS16LE_1(s);
    var bitcount = readS16LE_1(s);
    var tmp0_apply_0 = new BmImageInfo();
    tmp0_apply_0._flipX = width < 0;
    tmp0_apply_0._flipY = height >= 0;
    tmp0_apply_0._set_width__majfzk_k$(abs(width));
    tmp0_apply_0._set_height__majfzk_k$(abs(height));
    tmp0_apply_0._set_bitsPerPixel__majfzk_k$(bitcount);
    return tmp0_apply_0;
  };
  BMP.prototype.readImage_55aaqy_k$ = function (s, props) {
    var tmp0_elvis_lhs = this.decodeHeader_55aaqy_k$(s, props);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('Not a BMP file');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var h = tmp;
    var compression = readS32LE_1(s);
    var sizeImage = readS32LE_1(s);
    var pixelsPerMeterX = readS32LE_1(s);
    var pixelsPerMeterY = readS32LE_1(s);
    var clrUsed = readS32LE_1(s);
    var clrImportant = readS32LE_1(s);
    var tmp1_subject = h._get_bitsPerPixel__0_k$();
    var tmp_0;
    switch (tmp1_subject) {
      case 8:
        var tmp_1 = h._get_width__0_k$();
        var tmp_2 = h._get_height__0_k$();
        var out = Bitmap8_init_$Create$(tmp_1, tmp_2, null, null, 12, null);
        var inductionVariable = 0;
        if (inductionVariable < 256)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            RgbaArray__set_impl(out._get_palette__wd8tzq_k$(), n, Companion_getInstance_136().invoke_aewswh_k$(readS32LE_1(s), 255));
          }
           while (inductionVariable < 256);
        var inductionVariable_0 = 0;
        var last_1 = h._get_height__0_k$();
        if (inductionVariable_0 < last_1)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.setRow_bbbfxr_k$((h._get_height__0_k$() - n_0 | 0) - 1 | 0, readBytes_0(s, h._get_width__0_k$()));
          }
           while (inductionVariable_0 < last_1);
        var tmp_3 = Companion_getInstance_148();
        var tmp_4 = listOf_0(tmp_3.invoke$default_ecgccd_k$(out, null, 0, 0, false, false, null, 0, 254, null));
        tmp_0 = ImageData_init_$Create$(tmp_4, 0, 0, 0, null, null, null, 126, null);
        break;
      case 24:
      case 32:
        var bytesPerRow = imul(h._get_width__0_k$(), h._get_bitsPerPixel__0_k$()) / 8 | 0;
        var tmp_5 = h._get_width__0_k$();
        var tmp_6 = h._get_height__0_k$();
        var out_0 = Bitmap32_init_$Create$(tmp_5, tmp_6, null, false, 12, null);
        var row = new Int8Array(bytesPerRow);
        var format_0 = h._get_bitsPerPixel__0_k$() === 24 ? BGR_getInstance() : BGRA_getInstance();
        var padding = 4 - bytesPerRow % 4 | 0;
        var flipY = h._flipY;
        var inductionVariable_1 = 0;
        var last_2 = h._get_height__0_k$();
        if (inductionVariable_1 < last_2)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var y = h._flipY ? (h._get_height__0_k$() - n_1 | 0) - 1 | 0 : n_1;
            s.read$default_82dsjl_k$(row, 0, 0, 6, null);
            Unit_getInstance();
            var tmp_7 = out_0.index_27zxwg_k$(0, y);
            var tmp_8 = h._get_width__0_k$();
            decode$default(format_0, row, 0, out_0._data_25, tmp_7, tmp_8, false, 32, null);
            if (!(padding === 0)) {
              s.skip_majfzk_k$(padding);
            }}
           while (inductionVariable_1 < last_2);
        var tmp_9 = Companion_getInstance_148();
        var tmp_10 = listOf_0(tmp_9.invoke$default_ecgccd_k$(out_0, null, 0, 0, false, false, null, 0, 254, null));
        tmp_0 = ImageData_init_$Create$(tmp_10, 0, 0, 0, null, null, null, 126, null);
        break;
      default:var tmp0_TODO_0 = '' + 'Unsupported bitsPerPixel=' + h._get_bitsPerPixel__0_k$();
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
    }
    return tmp_0;
  };
  BMP.prototype.writeImage_bwcin2_k$ = function (image, s, props) {
    var bmp = image._get_mainBitmap__0_k$().toBMP32_0_k$();
    write8_1(s, 66);
    write8_1(s, 77);
    write32LE_1(s, imul(4, bmp._get_area__0_k$()));
    write32LE_1(s, 0);
    write32LE_1(s, 54);
    write32LE_1(s, 40);
    write32LE_1(s, bmp._get_width__0_k$());
    write32LE_1(s, imul(bmp._get_height__0_k$(), 2));
    write16LE_1(s, 1);
    write16LE_1(s, 32);
    write32LE_1(s, 0);
    write32LE_1(s, imul(4, bmp._get_area__0_k$()));
    write32LE_1(s, 2834);
    write32LE_1(s, 2834);
    write32LE_1(s, 0);
    write32LE_1(s, 0);
    var inductionVariable = 0;
    var last_1 = bmp._get_height__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = (bmp._get_height__0_k$() - 1 | 0) - n | 0;
        writeBytes_0(s, encode_0(BGRA_getInstance(), bmp._data_25, imul(y, bmp._get_width__0_k$()), bmp._get_width__0_k$(), true));
      }
       while (inductionVariable < last_1);
  };
  BMP.$metadata$ = {
    simpleName: 'BMP',
    kind: 'object',
    interfaces: []
  };
  var BMP_instance;
  function BMP_getInstance() {
    if (BMP_instance == null)
      new BMP();
    return BMP_instance;
  }
  var fourcc$delegate;
  function _no_name_provided__264() {
  }
  _no_name_provided__264.prototype.invoke_0_k$ = function () {
    return '    ';
  };
  _no_name_provided__264.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_215() {
    var i = new _no_name_provided__264();
    return function () {
      return i.invoke_0_k$();
    };
  }
  var Direction_FORWARD_instance;
  var Direction_REVERSE_instance;
  var Direction_PING_PONG_instance;
  var Direction_entriesInitialized;
  function Direction_initEntries() {
    if (Direction_entriesInitialized)
      return Unit_getInstance();
    Direction_entriesInitialized = true;
    Direction_FORWARD_instance = new Direction('FORWARD', 0);
    Direction_REVERSE_instance = new Direction('REVERSE', 1);
    Direction_PING_PONG_instance = new Direction('PING_PONG', 2);
  }
  function ImageAnimation_init_$Init$(frames, direction, name, layers, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0)) {
      var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2 = frames.iterator_0_k$();
      while (tmp0_iterator_1_2.hasNext_0_k$()) {
        var element_2_3 = tmp0_iterator_1_2.next_0_k$();
        var list_3_4 = element_2_3._layerData;
        addAll(tmp0_flatMapTo_0_1, list_3_4);
        Unit_getInstance();
      }
      var tmp0_map_0 = tmp0_flatMapTo_0_1;
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var tmp0_iterator_1_2_0 = tmp0_map_0.iterator_0_k$();
      while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
        var item_2_3 = tmp0_iterator_1_2_0.next_0_k$();
        tmp0_mapTo_0_1.add_2bq_k$(item_2_3._layer);
        Unit_getInstance();
      }
      var tmp1_sortedBy_0 = distinct(tmp0_mapTo_0_1);
      var tmp = _no_name_provided_$factory_216();
      layers = sortedWith(tmp1_sortedBy_0, new sam$kotlin_Comparator$0_3(tmp));
    }ImageAnimation.call($this, frames, direction, name, layers);
    return $this;
  }
  function ImageAnimation_init_$Create$(frames, direction, name, layers, $mask0, $marker) {
    return ImageAnimation_init_$Init$(frames, direction, name, layers, $mask0, $marker, Object.create(ImageAnimation.prototype));
  }
  function Direction(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Direction.$metadata$ = {
    simpleName: 'Direction',
    kind: 'class',
    interfaces: []
  };
  function sam$kotlin_Comparator$0_3(function_0) {
    this._function_3 = function_0;
  }
  sam$kotlin_Comparator$0_3.prototype.compare_1qgdm_k$ = function (a, b) {
    return this._function_3(a, b);
  };
  sam$kotlin_Comparator$0_3.prototype.compare = function (a, b) {
    return this.compare_1qgdm_k$(a, b);
  };
  sam$kotlin_Comparator$0_3.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__265() {
  }
  _no_name_provided__265.prototype.invoke_7vprcw_k$ = function (a, b) {
    var tmp = a._index_20;
    return compareValues(tmp, b._index_20);
  };
  _no_name_provided__265.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof ImageLayer ? p1 : THROW_CCE();
    return this.invoke_7vprcw_k$(tmp, p2 instanceof ImageLayer ? p2 : THROW_CCE());
  };
  _no_name_provided__265.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Direction_FORWARD_getInstance() {
    Direction_initEntries();
    return Direction_FORWARD_instance;
  }
  function ImageAnimation(frames, direction, name, layers) {
    this._frames = frames;
    this._direction = direction;
    this._name_16 = name;
    this._layers = layers;
  }
  ImageAnimation.$metadata$ = {
    simpleName: 'ImageAnimation',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_216() {
    var i = new _no_name_provided__265();
    return function (p1, p2) {
      return i.invoke_7vprcw_k$(p1, p2);
    };
  }
  function ImageData_init_$Init$(frames, loopCount, width, height, layers, animations, name, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      loopCount = 0;
    if (!(($mask0 & 4) === 0)) {
      var tmp0_safe_receiver = firstOrNull(frames);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_width__0_k$();
      width = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    }if (!(($mask0 & 8) === 0)) {
      var tmp2_safe_receiver = firstOrNull(frames);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._get_height__0_k$();
      height = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    }if (!(($mask0 & 16) === 0))
      layers = fastArrayListOf([]);
    if (!(($mask0 & 32) === 0))
      animations = fastArrayListOf([]);
    if (!(($mask0 & 64) === 0))
      name = null;
    ImageData_0.call($this, frames, loopCount, width, height, layers, animations, name);
    return $this;
  }
  function ImageData_init_$Create$(frames, loopCount, width, height, layers, animations, name, $mask0, $marker) {
    return ImageData_init_$Init$(frames, loopCount, width, height, layers, animations, name, $mask0, $marker, Object.create(ImageData_0.prototype));
  }
  function Companion_148() {
    Companion_instance_147 = this;
  }
  Companion_148.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_147;
  function Companion_getInstance_147() {
    if (Companion_instance_147 == null)
      new Companion_148();
    return Companion_instance_147;
  }
  function sam$kotlin_Comparator$0_4(function_0) {
    this._function_4 = function_0;
  }
  sam$kotlin_Comparator$0_4.prototype.compare_1qgdm_k$ = function (a, b) {
    return this._function_4(a, b);
  };
  sam$kotlin_Comparator$0_4.prototype.compare = function (a, b) {
    return this.compare_1qgdm_k$(a, b);
  };
  sam$kotlin_Comparator$0_4.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__266() {
  }
  _no_name_provided__266.prototype.invoke_7j2v4_k$ = function (a, b) {
    var tmp;
    if (b._get_main__0_k$()) {
      tmp = IntCompanionObject_getInstance()._MAX_VALUE_5;
    } else {
      tmp = imul(imul(b._get_bitmap__0_k$()._width_2, b._get_bitmap__0_k$()._height_3), imul(b._get_bitmap__0_k$()._bpp, b._get_bitmap__0_k$()._bpp));
    }
    var tmp_0 = tmp;
    var tmp_1;
    if (a._get_main__0_k$()) {
      tmp_1 = IntCompanionObject_getInstance()._MAX_VALUE_5;
    } else {
      tmp_1 = imul(imul(a._get_bitmap__0_k$()._width_2, a._get_bitmap__0_k$()._height_3), imul(a._get_bitmap__0_k$()._bpp, a._get_bitmap__0_k$()._bpp));
    }
    return compareValues(tmp_0, tmp_1);
  };
  _no_name_provided__266.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof ImageFrame ? p1 : THROW_CCE();
    return this.invoke_7j2v4_k$(tmp, p2 instanceof ImageFrame ? p2 : THROW_CCE());
  };
  _no_name_provided__266.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ImageData_0(frames, loopCount, width, height, layers, animations, name) {
    Companion_getInstance_147();
    this._frames_0 = frames;
    this._loopCount = loopCount;
    this._width_6 = width;
    this._height_7 = height;
    this._layers_0 = layers;
    this._animations = animations;
    this._name_17 = name;
    var tmp = this;
    tmp._$$delegate_0_20 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    var tmp_1 = Direction_FORWARD_getInstance();
    tmp_0._defaultAnimation = ImageAnimation_init_$Create$(this._frames_0, tmp_1, 'default', null, 8, null);
    var tmp_2 = this;
    var tmp0_associateBy_0 = this._animations;
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateBy_0, 10)), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = tmp0_associateBy_0.iterator_0_k$();
    while (tmp0_iterator_1_3.hasNext_0_k$()) {
      var element_2_4 = tmp0_iterator_1_3.next_0_k$();
      tmp0_associateByTo_0_2.put_1q9pf_k$(element_2_4._name_16, element_2_4);
      Unit_getInstance();
    }
    tmp_2._animationsByName = tmp0_associateByTo_0_2;
    var tmp_3 = this;
    var tmp0_associateBy_0_0 = this._frames_0;
    var capacity_1_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateBy_0_0, 10)), 16);
    var tmp0_associateByTo_0_2_0 = LinkedHashMap_init_$Create$_1(capacity_1_0);
    var tmp0_iterator_1_3_0 = tmp0_associateBy_0_0.iterator_0_k$();
    while (tmp0_iterator_1_3_0.hasNext_0_k$()) {
      var element_2_4_0 = tmp0_iterator_1_3_0.next_0_k$();
      tmp0_associateByTo_0_2_0.put_1q9pf_k$(element_2_4_0._get_name__0_k$(), element_2_4_0);
      Unit_getInstance();
    }
    tmp_3._framesByName = tmp0_associateByTo_0_2_0;
    var tmp_4 = this;
    var tmp0_sortedByDescending_0 = this._frames_0;
    var tmp_5 = _no_name_provided_$factory_217();
    tmp_4._framesSortedByProority = sortedWith(tmp0_sortedByDescending_0, new sam$kotlin_Comparator$0_4(tmp_5));
  }
  ImageData_0.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_20._set_extra__n1onou_k$(_set___);
  };
  ImageData_0.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_20._get_extra__0_k$();
  };
  ImageData_0.prototype._get_mainBitmap__0_k$ = function () {
    var tmp0_safe_receiver = firstOrNull(this._framesSortedByProority);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_bitmap__0_k$();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('No bitmap found');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  ImageData_0.prototype.toString = function () {
    return '' + 'ImageData(' + this._frames_0 + ')';
  };
  ImageData_0.$metadata$ = {
    simpleName: 'ImageData',
    kind: 'class',
    interfaces: [Extra]
  };
  function _no_name_provided_$factory_217() {
    var i = new _no_name_provided__266();
    return function (p1, p2) {
      return i.invoke_7j2v4_k$(p1, p2);
    };
  }
  function ImageDecodingProps_init_$Init$(filename, width, height, extra, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      filename = 'unknown';
    if (!(($mask0 & 2) === 0))
      width = null;
    if (!(($mask0 & 4) === 0))
      height = null;
    if (!(($mask0 & 8) === 0))
      extra = null;
    ImageDecodingProps.call($this, filename, width, height, extra);
    return $this;
  }
  function ImageDecodingProps_init_$Create$(filename, width, height, extra, $mask0, $marker) {
    return ImageDecodingProps_init_$Init$(filename, width, height, extra, $mask0, $marker, Object.create(ImageDecodingProps.prototype));
  }
  function ImageDecodingProps(filename, width, height, extra) {
    this._filename = filename;
    this._width_7 = width;
    this._height_8 = height;
    this._extra_0 = extra;
  }
  ImageDecodingProps.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._extra_0 = _set___;
  };
  ImageDecodingProps.prototype._get_extra__0_k$ = function () {
    return this._extra_0;
  };
  ImageDecodingProps.prototype.copy_7aiom4_k$ = function (filename, width, height, extra) {
    return new ImageDecodingProps(filename, width, height, extra);
  };
  ImageDecodingProps.prototype.copy$default_lan0jj_k$ = function (filename, width, height, extra, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      filename = this._filename;
    if (!(($mask0 & 2) === 0))
      width = this._width_7;
    if (!(($mask0 & 4) === 0))
      height = this._height_8;
    if (!(($mask0 & 8) === 0))
      extra = this._extra_0;
    return this.copy_7aiom4_k$(filename, width, height, extra);
  };
  ImageDecodingProps.prototype.toString = function () {
    return '' + 'ImageDecodingProps(filename=' + this._filename + ', width=' + this._width_7 + ', height=' + this._height_8 + ', extra=' + this._extra_0 + ')';
  };
  ImageDecodingProps.prototype.hashCode = function () {
    var result = getStringHashCode(this._filename);
    result = imul(result, 31) + (this._width_7 == null ? 0 : this._width_7) | 0;
    result = imul(result, 31) + (this._height_8 == null ? 0 : this._height_8) | 0;
    result = imul(result, 31) + (this._extra_0 == null ? 0 : hashCode(this._extra_0)) | 0;
    return result;
  };
  ImageDecodingProps.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this._filename === tmp0_other_with_cast._filename))
      return false;
    if (!(this._width_7 == tmp0_other_with_cast._width_7))
      return false;
    if (!(this._height_8 == tmp0_other_with_cast._height_8))
      return false;
    if (!equals_1(this._extra_0, tmp0_other_with_cast._extra_0))
      return false;
    return true;
  };
  ImageDecodingProps.$metadata$ = {
    simpleName: 'ImageDecodingProps',
    kind: 'class',
    interfaces: [Extra]
  };
  function ImageFormat(exts) {
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(exts.length);
    var indexedObject = exts;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_trim_0_5 = item_2_3.toLowerCase();
      tmp0_mapTo_0_1.add_2bq_k$(toString_1(trim_0(isCharSequence(tmp0_trim_0_5) ? tmp0_trim_0_5 : THROW_CCE())));
      Unit_getInstance();
    }
    tmp._extensions = toSet_0(tmp0_mapTo_0_1);
  }
  ImageFormat.prototype.readImage_55aaqy_k$ = function (s, props) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  ImageFormat.prototype.writeImage_bwcin2_k$ = function (image, s, props) {
    throw UnsupportedOperationException_init_$Create$();
  };
  ImageFormat.prototype.decodeHeader_55aaqy_k$ = function (s, props) {
    var tmp;
    try {
      var bmp_3 = this.read_55aaqy_k$(s, props);
      var tmp0_apply_0_4 = new ImageInfo();
      tmp0_apply_0_4._width_8 = bmp_3._width_2;
      tmp0_apply_0_4._height_9 = bmp_3._height_3;
      tmp0_apply_0_4._bitsPerPixel = bmp_3._bpp;
      tmp = tmp0_apply_0_4;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        printStackTrace_0($p);
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  ImageFormat.prototype.read_55aaqy_k$ = function (s, props) {
    return this.readImage_55aaqy_k$(s, props)._get_mainBitmap__0_k$();
  };
  ImageFormat.prototype.check_55aaqy_k$ = function (s, props) {
    var tmp;
    try {
      tmp = !(this.decodeHeader_55aaqy_k$(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        printStackTrace_0($p);
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  };
  ImageFormat.prototype.decode_55aaqy_k$ = function (s, props) {
    return this.read_55aaqy_k$(s, props);
  };
  ImageFormat.prototype.decode$default_nu4l15_k$ = function (s, props, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      props = ImageDecodingProps_init_$Create$(null, null, null, null, 15, null);
    }return this.decode_55aaqy_k$(s, props);
  };
  ImageFormat.prototype.decode_ik60dn_k$ = function (s, props) {
    return this.read_55aaqy_k$(openSync$default(s, null, 1, null), props);
  };
  ImageFormat.prototype.decode$default_hc9x6a_k$ = function (s, props, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      props = ImageDecodingProps_init_$Create$(null, null, null, null, 15, null);
    }return this.decode_ik60dn_k$(s, props);
  };
  ImageFormat.prototype.encode_gyo1be_k$ = function (frames, props) {
    var tmp0_MemorySyncStreamToByteArray_0 = imul(_get_area_(frames), 4);
    var buffer_1 = ByteArrayBuilder_init_$Create$_0(tmp0_MemorySyncStreamToByteArray_0);
    var s_2 = MemorySyncStream(buffer_1);
    this.writeImage_bwcin2_k$(ImageData_init_$Create$(frames, 0, 0, 0, null, null, null, 126, null), s_2, props);
    return buffer_1.toByteArray_0_k$();
  };
  ImageFormat.prototype.encode_iz02hh_k$ = function (bitmap, props) {
    var tmp = Companion_getInstance_148();
    return this.encode_gyo1be_k$(listOf_0(tmp.invoke$default_ecgccd_k$(bitmap, null, 0, 0, false, false, null, 0, 254, null)), props);
  };
  ImageFormat.prototype.encode$default_tm5rke_k$ = function (bitmap, props, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      props = ImageEncodingProps_init_$Create$('unknown', 0.0, null, 6, null);
    }return this.encode_iz02hh_k$(bitmap, props);
  };
  ImageFormat.prototype.toString = function () {
    return '' + 'ImageFormat(' + this._extensions + ')';
  };
  ImageFormat.$metadata$ = {
    simpleName: 'ImageFormat',
    kind: 'class',
    interfaces: []
  };
  function ImageEncodingProps_init_$Init$(filename, quality, extra, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      filename = '';
    if (!(($mask0 & 2) === 0))
      quality = 0.81;
    if (!(($mask0 & 4) === 0))
      extra = null;
    ImageEncodingProps.call($this, filename, quality, extra);
    return $this;
  }
  function ImageEncodingProps_init_$Create$(filename, quality, extra, $mask0, $marker) {
    return ImageEncodingProps_init_$Init$(filename, quality, extra, $mask0, $marker, Object.create(ImageEncodingProps.prototype));
  }
  function ImageEncodingProps(filename, quality, extra) {
    this._filename_0 = filename;
    this._quality = quality;
    this._extra_1 = extra;
  }
  ImageEncodingProps.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._extra_1 = _set___;
  };
  ImageEncodingProps.prototype._get_extra__0_k$ = function () {
    return this._extra_1;
  };
  ImageEncodingProps.prototype.toString = function () {
    return '' + 'ImageEncodingProps(filename=' + this._filename_0 + ', quality=' + this._quality + ', extra=' + this._extra_1 + ')';
  };
  ImageEncodingProps.prototype.hashCode = function () {
    var result = getStringHashCode(this._filename_0);
    result = imul(result, 31) + getNumberHashCode(this._quality) | 0;
    result = imul(result, 31) + (this._extra_1 == null ? 0 : hashCode(this._extra_1)) | 0;
    return result;
  };
  ImageEncodingProps.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageEncodingProps))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ImageEncodingProps ? other : THROW_CCE();
    if (!(this._filename_0 === tmp0_other_with_cast._filename_0))
      return false;
    if (!equals_1(this._quality, tmp0_other_with_cast._quality))
      return false;
    if (!equals_1(this._extra_1, tmp0_other_with_cast._extra_1))
      return false;
    return true;
  };
  ImageEncodingProps.$metadata$ = {
    simpleName: 'ImageEncodingProps',
    kind: 'class',
    interfaces: [Extra]
  };
  function ImageFormats_init_$Init$(formats, $this) {
    ImageFormats.call($this, toList(formats));
    return $this;
  }
  function ImageFormats_init_$Create$(formats) {
    return ImageFormats_init_$Init$(formats, Object.create(ImageFormats.prototype));
  }
  function ImageFormats(formats) {
    ImageFormat.call(this, ['']);
    var tmp = this;
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = formats.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp_0;
      if (element_2_3 instanceof ImageFormats) {
        tmp_0 = toList_3(element_2_3._formats);
      } else {
        {
          tmp_0 = listOf_0(element_2_3);
        }
      }
      var list_3_4 = tmp_0;
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    tmp._formats = toSet_0(tmp0_flatMapTo_0_1);
  }
  ImageFormats.prototype.decodeHeader_55aaqy_k$ = function (s, props) {
    var tmp0_iterator = this._formats.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var format_0 = tmp0_iterator.next_0_k$();
      var tmp;
      try {
        var tmp1_elvis_lhs = format_0.decodeHeader_55aaqy_k$(sliceStart$default_0(s, new Long(0, 0), 1, null), props);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          continue;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          continue;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_1;
      }
      return tmp;
    }
    return null;
  };
  ImageFormats.prototype.readImage_55aaqy_k$ = function (s, props) {
    var tmp0_iterator = this._formats.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var format_0 = tmp0_iterator.next_0_k$();
      if (format_0.check_55aaqy_k$(sliceStart$default_0(s, new Long(0, 0), 1, null), props)) {
        return format_0.readImage_55aaqy_k$(sliceStart$default_0(s, new Long(0, 0), 1, null), props);
      } else {
      }
    }
    var tmp = 'No suitable image format : MAGIC:' + readString_0(sliceStart$default_0(s, new Long(0, 0), 1, null), 4, ASCII_getInstance()) + '(';
    var tmp_0 = tmp + _get_hex__0(readBytes_0(sliceStart$default_0(s, new Long(0, 0), 1, null), 4)) + ') (';
    var tmp_1 = readBytes_0(sliceStart$default_0(s, new Long(0, 0), 1, null), 4);
    var tmp_2 = ASCII_getInstance();
    throw UnsupportedOperationException_init_$Create$_0(tmp_0 + toString$default(tmp_1, tmp_2, 0, 0, 6, null) + ')');
  };
  ImageFormats.prototype.writeImage_bwcin2_k$ = function (image, s, props) {
    var ext = _get_extensionLC_(_PathInfo___init__impl_(props._filename_0));
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._formats;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (element_2._extensions.contains_2bq_k$(ext)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_elvis_lhs = tmp$ret$0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_flatMap_0 = this._formats;
      var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2 = tmp1_flatMap_0.iterator_0_k$();
      while (tmp0_iterator_1_2.hasNext_0_k$()) {
        var element_2_3 = tmp0_iterator_1_2.next_0_k$();
        var list_3_4 = element_2_3._extensions;
        addAll(tmp0_flatMapTo_0_1, list_3_4);
        Unit_getInstance();
      }
      throw UnsupportedOperationException_init_$Create$_0('' + "Don't know how to generate file for extension '" + ext + "' (supported extensions " + tmp0_flatMapTo_0_1 + ') (props ' + props + ')');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var format_0 = tmp;
    format_0.writeImage_bwcin2_k$(image, s, props);
  };
  ImageFormats.$metadata$ = {
    simpleName: 'ImageFormats',
    kind: 'class',
    interfaces: []
  };
  function Companion_149() {
    Companion_instance_148 = this;
  }
  Companion_149.prototype.invoke_i9w67y_k$ = function (bitmap, time, targetX, targetY, main_0, includeInAtlas, name, index_0) {
    var tmp = new ImageLayer(0, null);
    var tmp_0 = slice$default(bitmap, null, name, 1, null);
    return new ImageFrame(index_0, time, fastArrayListOf([ImageFrameLayer_init_$Create$(tmp, tmp_0, targetX, targetY, main_0, includeInAtlas, null, 64, null)]));
  };
  Companion_149.prototype.invoke$default_ecgccd_k$ = function (bitmap, time, targetX, targetY, main_0, includeInAtlas, name, index_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      time = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    }if (!(($mask0 & 4) === 0))
      targetX = 0;
    if (!(($mask0 & 8) === 0))
      targetY = 0;
    if (!(($mask0 & 16) === 0))
      main_0 = true;
    if (!(($mask0 & 32) === 0))
      includeInAtlas = true;
    if (!(($mask0 & 64) === 0))
      name = null;
    if (!(($mask0 & 128) === 0))
      index_0 = 0;
    return this.invoke_i9w67y_k$(bitmap, time, targetX, targetY, main_0, includeInAtlas, name, index_0);
  };
  Companion_149.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_148;
  function Companion_getInstance_148() {
    if (Companion_instance_148 == null)
      new Companion_149();
    return Companion_instance_148;
  }
  function ImageFrame(index_0, time, layerData) {
    Companion_getInstance_148();
    this._index_19 = index_0;
    this._time_3 = time;
    this._layerData = layerData;
    var tmp = this;
    tmp._$$delegate_0_21 = Mixin_init_$Create$(null, 1, null);
    this._first_4 = firstOrNull(this._layerData);
  }
  ImageFrame.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_21._set_extra__n1onou_k$(_set___);
  };
  ImageFrame.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_21._get_extra__0_k$();
  };
  ImageFrame.prototype._get_slice__0_k$ = function () {
    var tmp0_safe_receiver = this._first_4;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._slice_0;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0__get_transparent__0 = Bitmaps_getInstance();
      tmp = Bitmaps_transparent;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  ImageFrame.prototype._get_targetX__0_k$ = function () {
    var tmp0_safe_receiver = this._first_4;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._targetX;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  ImageFrame.prototype._get_targetY__0_k$ = function () {
    var tmp0_safe_receiver = this._first_4;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._targetY;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  ImageFrame.prototype._get_main__0_k$ = function () {
    var tmp0_safe_receiver = this._first_4;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._main;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  ImageFrame.prototype._get_width__0_k$ = function () {
    return this._get_slice__0_k$()._get_width__0_k$();
  };
  ImageFrame.prototype._get_height__0_k$ = function () {
    return this._get_slice__0_k$()._get_height__0_k$();
  };
  ImageFrame.prototype._get_area__0_k$ = function () {
    return this._get_slice__0_k$()._get_area__0_k$();
  };
  ImageFrame.prototype._get_bitmap__0_k$ = function () {
    var tmp0_safe_receiver = this._first_4;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_bitmap__0_k$();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0__get_transparent__0 = Bitmaps_getInstance();
      tmp = Bitmaps_transparent._bmp;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  ImageFrame.prototype._get_name__0_k$ = function () {
    return this._get_slice__0_k$()._name_12;
  };
  ImageFrame.prototype.toString = function () {
    return '' + 'ImageFrame(' + this._get_slice__0_k$() + ', time=' + new TimeSpan(this._time_3) + ', targetX=' + this._get_targetX__0_k$() + ', targetY=' + this._get_targetY__0_k$() + ', main=' + this._get_main__0_k$() + ')';
  };
  ImageFrame.$metadata$ = {
    simpleName: 'ImageFrame',
    kind: 'class',
    interfaces: [Extra]
  };
  function _get_area_(_this_) {
    var sum_1_0 = 0;
    var tmp0_iterator_2 = _this_.iterator_0_k$();
    while (tmp0_iterator_2.hasNext_0_k$()) {
      var element_3 = tmp0_iterator_2.next_0_k$();
      var tmp = sum_1_0;
      sum_1_0 = tmp + element_3._get_area__0_k$() | 0;
    }
    return sum_1_0;
  }
  function ImageFrameLayer_init_$Init$(layer, slice_1, targetX, targetY, main_0, includeInAtlas, linkedFrameLayer, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      targetX = 0;
    if (!(($mask0 & 8) === 0))
      targetY = 0;
    if (!(($mask0 & 16) === 0))
      main_0 = true;
    if (!(($mask0 & 32) === 0))
      includeInAtlas = true;
    if (!(($mask0 & 64) === 0))
      linkedFrameLayer = null;
    ImageFrameLayer.call($this, layer, slice_1, targetX, targetY, main_0, includeInAtlas, linkedFrameLayer);
    return $this;
  }
  function ImageFrameLayer_init_$Create$(layer, slice_1, targetX, targetY, main_0, includeInAtlas, linkedFrameLayer, $mask0, $marker) {
    return ImageFrameLayer_init_$Init$(layer, slice_1, targetX, targetY, main_0, includeInAtlas, linkedFrameLayer, $mask0, $marker, Object.create(ImageFrameLayer.prototype));
  }
  function ImageFrameLayer(layer, slice_1, targetX, targetY, main_0, includeInAtlas, linkedFrameLayer) {
    this._layer = layer;
    this._targetX = targetX;
    this._targetY = targetY;
    this._main = main_0;
    this._includeInAtlas = includeInAtlas;
    this._linkedFrameLayer = linkedFrameLayer;
    this.__bitmap = null;
    this.__bitmap32 = null;
    this._slice_0 = slice_1;
  }
  ImageFrameLayer.prototype._get_bitmap__0_k$ = function () {
    if (this.__bitmap == null)
      this.__bitmap = extract_2(this._slice_0);
    return ensureNotNull(this.__bitmap);
  };
  ImageFrameLayer.$metadata$ = {
    simpleName: 'ImageFrameLayer',
    kind: 'class',
    interfaces: []
  };
  function ImageInfo() {
    var tmp = this;
    tmp._$$delegate_0_22 = Mixin_init_$Create$(null, 1, null);
    this._width_8 = 0;
    this._height_9 = 0;
    this._bitsPerPixel = 8;
  }
  ImageInfo.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_22._set_extra__n1onou_k$(_set___);
  };
  ImageInfo.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_22._get_extra__0_k$();
  };
  ImageInfo.prototype._set_width__majfzk_k$ = function (_set___) {
    this._width_8 = _set___;
  };
  ImageInfo.prototype._get_width__0_k$ = function () {
    return this._width_8;
  };
  ImageInfo.prototype._set_height__majfzk_k$ = function (_set___) {
    this._height_9 = _set___;
  };
  ImageInfo.prototype._get_height__0_k$ = function () {
    return this._height_9;
  };
  ImageInfo.prototype._set_bitsPerPixel__majfzk_k$ = function (_set___) {
    this._bitsPerPixel = _set___;
  };
  ImageInfo.prototype._get_bitsPerPixel__0_k$ = function () {
    return this._bitsPerPixel;
  };
  ImageInfo.prototype.toString = function () {
    return '' + 'ImageInfo(width=' + this._width_8 + ', height=' + this._height_9 + ', bpp=' + this._bitsPerPixel + ', extra=' + this._get_extra__0_k$() + ')';
  };
  ImageInfo.$metadata$ = {
    simpleName: 'ImageInfo',
    kind: 'class',
    interfaces: [Extra]
  };
  function ImageLayer(index_0, name) {
    this._index_20 = index_0;
    this._name_18 = name;
  }
  ImageLayer.$metadata$ = {
    simpleName: 'ImageLayer',
    kind: 'class',
    interfaces: []
  };
  var kritaLoadLayers$delegate;
  var kritaPartialImageLayers$delegate;
  function _no_name_provided__267() {
  }
  _no_name_provided__267.prototype.invoke_0_k$ = function () {
    return true;
  };
  _no_name_provided__267.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__268() {
  }
  _no_name_provided__268.prototype.invoke_0_k$ = function () {
    return false;
  };
  _no_name_provided__268.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_218() {
    var i = new _no_name_provided__267();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_219() {
    var i = new _no_name_provided__268();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function kritaLoadLayers$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_218();
    return new Property(null, tmp0_extraProperty_0);
  }
  function kritaPartialImageLayers$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_219();
    return new Property(null, tmp0_extraProperty_0);
  }
  var nativeImageLoadingEnabled;
  function readBitmapOptimized(_this_, formats, premultiplied, $cont) {
    var tmp = new $readBitmapOptimizedCOROUTINE$13(_this_, formats, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readBitmapOptimized$default(_this_, formats, premultiplied, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      formats = RegisteredImageFormats_getInstance();
    if (!(($mask0 & 2) === 0))
      premultiplied = true;
    return readBitmapOptimized(_this_, formats, premultiplied, $cont);
  }
  function readBitmapSlice(_this_, premultiplied, name, atlas, $cont) {
    var tmp = new $readBitmapSliceCOROUTINE$14(_this_, premultiplied, name, atlas, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readBitmapSlice$default(_this_, premultiplied, name, atlas, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      premultiplied = true;
    if (!(($mask0 & 2) === 0))
      name = null;
    if (!(($mask0 & 4) === 0))
      atlas = null;
    return readBitmapSlice(_this_, premultiplied, name, atlas, $cont);
  }
  function readVectorImage(_this_, $cont) {
    return readSVG(_this_, $cont);
  }
  function readBitmap(_this_, formats, props, $cont) {
    var tmp = new $readBitmapCOROUTINE$15(_this_, formats, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readBitmap$default(_this_, formats, props, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      formats = RegisteredImageFormats_getInstance();
    if (!(($mask0 & 2) === 0)) {
      props = ImageDecodingProps_init_$Create$(null, null, null, null, 15, null);
    }return readBitmap(_this_, formats, props, $cont);
  }
  function $readBitmapOptimizedCOROUTINE$13(_this_, formats, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__124 = _this_;
    this._formats_0 = formats;
    this._premultiplied_1 = premultiplied;
  }
  $readBitmapOptimizedCOROUTINE$13.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = nativeImageFormatProvider.decode_d6lbr8_k$(this.__this__124, this._premultiplied_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            this._exceptionState = 4;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              this._t0 = this._exception_0;
              printStackTrace_0(this._t0);
              this._state_1 = 3;
              suspendResult = readBitmap$default(this.__this__124, this._formats_0, null, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapOptimizedCOROUTINE$13.$metadata$ = {
    simpleName: '$readBitmapOptimizedCOROUTINE$13',
    kind: 'class',
    interfaces: []
  };
  function $readBitmapSliceCOROUTINE$14(_this_, premultiplied, name, atlas, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__125 = _this_;
    this._premultiplied_2 = premultiplied;
    this._name_19 = name;
    this._atlas_0 = atlas;
  }
  $readBitmapSliceCOROUTINE$14.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readBitmapOptimized$default(this.__this__125, null, this._premultiplied_2, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var result = suspendResult;
            var tmp_0;
            if (!(this._atlas_0 == null)) {
              tmp_0 = this._atlas_0.add_eklde7_k$(result.toBMP32IfRequired_0_k$(), Unit_getInstance(), this._name_19)._slice;
            } else {
              tmp_0 = slice$default(result, null, null, 3, null);
            }

            return tmp_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapSliceCOROUTINE$14.$metadata$ = {
    simpleName: '$readBitmapSliceCOROUTINE$14',
    kind: 'class',
    interfaces: []
  };
  function $readBitmapCOROUTINE$15(_this_, formats, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__126 = _this_;
    this._formats_1 = formats;
    this._props = props;
  }
  $readBitmapCOROUTINE$15.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            if (nativeImageLoadingEnabled) {
              this._exceptionState = 3;
              this._state_1 = 2;
              suspendResult = nativeImageFormatProvider.decode_edgwu6_k$(this.__this__126, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this.__this__126.read_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT2_2 = suspendResult;
            var tmp_0 = this;
            var tmp_1 = _get_baseName_(this.__this__126);
            tmp_0._WHEN_RESULT0_5 = this._formats_1.decode_ik60dn_k$(this._ARGUMENT2_2, this._props.copy$default_lan0jj_k$(tmp_1, null, null, null, 14, null));
            this._state_1 = 6;
            continue $sm;
          case 2:
            this._TRY_RESULT1 = suspendResult;
            this._exceptionState = 7;
            this._state_1 = 5;
            continue $sm;
          case 3:
            this._exceptionState = 7;
            var tmp_2 = this._exception_0;
            if (tmp_2 instanceof Error) {
              this._e3 = this._exception_0;
              println('' + "Couldn't read native image: " + this._e3);
              printStackTrace_0(this._e3);
              this._state_1 = 4;
              suspendResult = this.__this__126.read_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            var ARGUMENT = suspendResult;
            var tmp_3 = this;
            var tmp_4 = _get_baseName_(this.__this__126);
            tmp_3._TRY_RESULT1 = this._formats_1.decode_ik60dn_k$(ARGUMENT, this._props.copy$default_lan0jj_k$(tmp_4, null, null, null, 14, null));
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._exceptionState = 7;
            this._WHEN_RESULT0_5 = this._TRY_RESULT1;
            this._state_1 = 6;
            continue $sm;
          case 6:
            return this._WHEN_RESULT0_5;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapCOROUTINE$15.$metadata$ = {
    simpleName: '$readBitmapCOROUTINE$15',
    kind: 'class',
    interfaces: []
  };
  function $decodeCOROUTINE$16(_this_, vfs, path_0, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__127 = _this_;
    this._vfs_2 = vfs;
    this._path_20 = path_0;
    this._premultiplied_3 = premultiplied;
  }
  $decodeCOROUTINE$16.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._vfs_2.file_6wfw3l_k$(this._path_20).readBytes_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_20 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__127.decode_b1bk5f_k$(this._ARGUMENT0_20, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$16.$metadata$ = {
    simpleName: '$decodeCOROUTINE$16',
    kind: 'class',
    interfaces: []
  };
  function $decodeCOROUTINE$17(_this_, file, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__128 = _this_;
    this._file_3 = file;
    this._premultiplied_4 = premultiplied;
  }
  $decodeCOROUTINE$17.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._file_3.getUnderlyingUnscapedFile_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_21 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__128.decode_v6gvbk_k$(this._ARGUMENT0_21, this._premultiplied_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$17.$metadata$ = {
    simpleName: '$decodeCOROUTINE$17',
    kind: 'class',
    interfaces: []
  };
  function NativeImageFormatProvider() {
  }
  NativeImageFormatProvider.prototype.decode_s6xc1l_k$ = function (vfs, path_0, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$16(this, vfs, path_0, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  NativeImageFormatProvider.prototype.decode_v6gvbk_k$ = function (file, premultiplied, $cont) {
    return this.decode_s6xc1l_k$(file._get_vfs__0_k$(), file._get_path__0_k$(), premultiplied, $cont);
  };
  NativeImageFormatProvider.prototype.decode_d6lbr8_k$ = function (file, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$17(this, file, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  NativeImageFormatProvider.prototype.decode_b1bk5f_k$ = function (data, $cont) {
    return this.decode_wodl3r_k$(data, true, $cont);
  };
  NativeImageFormatProvider.prototype.decode_edgwu6_k$ = function (file, $cont) {
    return this.decode_d6lbr8_k$(file, true, $cont);
  };
  NativeImageFormatProvider.prototype.copy_nc8knv_k$ = function (bmp) {
    var tmp0_apply_0 = this.create_y42205_k$(bmp._width_2, bmp._height_3, bmp._premultiplied_0);
    tmp0_apply_0.lock_sv8swh_k$();
    try {
      var ctx_2_1_2 = tmp0_apply_0.getContext2d_vcj5fe_k$(true);
      try {
        var tmp0_drawImage_0_3_3 = bmp._width_2;
        var tmp1_drawImage_0_4_4 = bmp._height_3;
        ctx_2_1_2.drawImage_c2z1l2_k$(bmp, 0.0, 0.0, numberToDouble(tmp0_drawImage_0_3_3), numberToDouble(tmp1_drawImage_0_4_4));
      }finally {
        ctx_2_1_2.dispose_sv8swh_k$();
      }
    }finally {
      tmp0_apply_0.unlock_ixubtt_k$(null);
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_apply_0;
  };
  NativeImageFormatProvider.$metadata$ = {
    simpleName: 'NativeImageFormatProvider',
    kind: 'class',
    interfaces: []
  };
  function $decodeCOROUTINE$18(_this_, vfs, path_0, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__129 = _this_;
    this._vfs_3 = vfs;
    this._path_21 = path_0;
    this._premultiplied_5 = premultiplied;
  }
  $decodeCOROUTINE$18.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._vfs_3.get_6wfw3l_k$(this._path_21).readBytes_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_22 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__129.decode_wodl3r_k$(this._ARGUMENT0_22, this._premultiplied_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$18.$metadata$ = {
    simpleName: '$decodeCOROUTINE$18',
    kind: 'class',
    interfaces: []
  };
  function BaseNativeImageFormatProvider() {
    NativeImageFormatProvider.call(this);
  }
  BaseNativeImageFormatProvider.prototype._get_formats__0_k$ = function () {
    return RegisteredImageFormats_getInstance();
  };
  BaseNativeImageFormatProvider.prototype.decode_wodl3r_k$ = function (data, premultiplied, $cont) {
    var tmp = this._get_formats__0_k$();
    return this.wrapNative_21ku2n_k$(tmp.decode$default_hc9x6a_k$(data, null, 2, null), premultiplied);
  };
  BaseNativeImageFormatProvider.prototype.decode_s6xc1l_k$ = function (vfs, path_0, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$18(this, vfs, path_0, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BaseNativeImageFormatProvider.prototype.createBitmapNativeImage_nc8knv_k$ = function (bmp) {
    return BitmapNativeImage_init_$Create$(bmp);
  };
  BaseNativeImageFormatProvider.prototype.wrapNative_21ku2n_k$ = function (bmp, premultiplied) {
    var bmp32 = bmp.toBMP32_0_k$();
    return this.createBitmapNativeImage_nc8knv_k$(premultiplied ? bmp32.premultipliedIfRequired_0_k$() : bmp32.depremultipliedIfRequired_0_k$());
  };
  BaseNativeImageFormatProvider.prototype.create_y42205_k$ = function (width, height, premultiplied) {
    var tmp0_elvis_lhs = premultiplied;
    return this.createBitmapNativeImage_nc8knv_k$(Bitmap32_init_$Create$(width, height, null, tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs, 4, null));
  };
  BaseNativeImageFormatProvider.prototype.copy_nc8knv_k$ = function (bmp) {
    return this.createBitmapNativeImage_nc8knv_k$(bmp);
  };
  BaseNativeImageFormatProvider.$metadata$ = {
    simpleName: 'BaseNativeImageFormatProvider',
    kind: 'class',
    interfaces: []
  };
  function BitmapNativeImage_init_$Init$(bitmap, $this) {
    BitmapNativeImage.call($this, bitmap.toBMP32_0_k$());
    return $this;
  }
  function BitmapNativeImage_init_$Create$(bitmap) {
    return BitmapNativeImage_init_$Init$(bitmap, Object.create(BitmapNativeImage.prototype));
  }
  function BitmapNativeImage(bitmap) {
    NativeImage.call(this, bitmap._get_width__0_k$(), bitmap._get_height__0_k$(), bitmap, bitmap._get_premultiplied__0_k$());
    this._bitmap_2 = bitmap;
    this._intData = _RgbaArray___get_ints__impl_(this._bitmap_2._data_25);
  }
  BitmapNativeImage.prototype.getContext2d_vcj5fe_k$ = function (antialiasing) {
    return this._bitmap_2.getContext2d_vcj5fe_k$(antialiasing);
  };
  BitmapNativeImage.prototype.toBMP32_0_k$ = function () {
    return this._bitmap_2;
  };
  BitmapNativeImage.prototype.readPixelsUnsafe_c3kirt_k$ = function (x, y, width, height, out, offset_0) {
    return this._bitmap_2.readPixelsUnsafe_c3kirt_k$(x, y, width, height, out, offset_0);
  };
  BitmapNativeImage.prototype.writePixelsUnsafe_c3kirt_k$ = function (x, y, width, height, out, offset_0) {
    return this._bitmap_2.writePixelsUnsafe_c3kirt_k$(x, y, width, height, out, offset_0);
  };
  BitmapNativeImage.prototype.setRgba_5mmwyp_k$ = function (x, y, v) {
    return this._bitmap_2.setRgba_5mmwyp_k$(x, y, v);
  };
  BitmapNativeImage.prototype.getRgba_aewswh_k$ = function (x, y) {
    return this._bitmap_2.getRgba_aewswh_k$(x, y);
  };
  BitmapNativeImage.$metadata$ = {
    simpleName: 'BitmapNativeImage',
    kind: 'class',
    interfaces: []
  };
  var Colorspace_GRAYSCALE_instance;
  var Colorspace_RGB_instance;
  var Colorspace_INDEXED_instance;
  var Colorspace_GRAYSCALE_ALPHA_instance;
  var Colorspace_RGBA_instance;
  function Companion_150() {
    Companion_instance_149 = this;
    var tmp = this;
    var tmp0_associateBy_0 = values_7();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_1q9pf_k$(element_2_4._id_7, element_2_4);
      Unit_getInstance();
    }
    tmp._BY_ID_0 = tmp0_associateByTo_0_2;
  }
  Companion_150.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_149;
  function Companion_getInstance_149() {
    if (Companion_instance_149 == null)
      new Companion_150();
    return Companion_instance_149;
  }
  function values_7() {
    return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
  }
  var Colorspace_entriesInitialized;
  function Colorspace_initEntries() {
    if (Colorspace_entriesInitialized)
      return Unit_getInstance();
    Colorspace_entriesInitialized = true;
    Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0);
    Colorspace_RGB_instance = new Colorspace('RGB', 1, 2);
    Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3);
    Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4);
    Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6);
    Companion_getInstance_149();
  }
  function InterlacedPass(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this._startingRow = startingRow;
    this._startingCol = startingCol;
    this._rowIncrement = rowIncrement;
    this._colIncrement = colIncrement;
    this._blockHeight = blockHeight;
    this._blockWidth = blockWidth;
    var tmp = this;
    var tmp0_log2_0 = this._colIncrement;
    tmp._colIncrementShift = numberToInt(Math.log2(tmp0_log2_0));
  }
  InterlacedPass.prototype.toString = function () {
    return '' + 'InterlacedPass(startingRow=' + this._startingRow + ', startingCol=' + this._startingCol + ', rowIncrement=' + this._rowIncrement + ', colIncrement=' + this._colIncrement + ', blockHeight=' + this._blockHeight + ', blockWidth=' + this._blockWidth + ')';
  };
  InterlacedPass.prototype.hashCode = function () {
    var result = this._startingRow;
    result = imul(result, 31) + this._startingCol | 0;
    result = imul(result, 31) + this._rowIncrement | 0;
    result = imul(result, 31) + this._colIncrement | 0;
    result = imul(result, 31) + this._blockHeight | 0;
    result = imul(result, 31) + this._blockWidth | 0;
    return result;
  };
  InterlacedPass.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this._startingRow === tmp0_other_with_cast._startingRow))
      return false;
    if (!(this._startingCol === tmp0_other_with_cast._startingCol))
      return false;
    if (!(this._rowIncrement === tmp0_other_with_cast._rowIncrement))
      return false;
    if (!(this._colIncrement === tmp0_other_with_cast._colIncrement))
      return false;
    if (!(this._blockHeight === tmp0_other_with_cast._blockHeight))
      return false;
    if (!(this._blockWidth === tmp0_other_with_cast._blockWidth))
      return false;
    return true;
  };
  InterlacedPass.$metadata$ = {
    simpleName: 'InterlacedPass',
    kind: 'class',
    interfaces: []
  };
  function Colorspace(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this._id_7 = id;
  }
  Colorspace.$metadata$ = {
    simpleName: 'Colorspace',
    kind: 'class',
    interfaces: []
  };
  function Header(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this._width_9 = width;
    this._height_10 = height;
    this._bitsPerChannel = bitsPerChannel;
    this._colorspace = colorspace;
    this._compressionmethod = compressionmethod;
    this._filtermethod = filtermethod;
    this._interlacemethod = interlacemethod;
    var tmp = this;
    var tmp0_subject = this._colorspace;
    var tmp_0;
    if (tmp0_subject.equals(Colorspace_GRAYSCALE_getInstance())) {
      tmp_0 = 1;
    } else if (tmp0_subject.equals(Colorspace_INDEXED_getInstance())) {
      tmp_0 = 1;
    } else if (tmp0_subject.equals(Colorspace_GRAYSCALE_ALPHA_getInstance())) {
      tmp_0 = 2;
    } else if (tmp0_subject.equals(Colorspace_RGB_getInstance())) {
      tmp_0 = 3;
    } else if (tmp0_subject.equals(Colorspace_RGBA_getInstance())) {
      tmp_0 = 4;
    } else {
      noWhenBranchMatchedException();
    }
    tmp._components_0 = tmp_0;
    this._stride = imul(imul(this._width_9, this._components_0), this._bitsPerChannel) / 8 | 0;
  }
  Header.$metadata$ = {
    simpleName: 'Header',
    kind: 'class',
    interfaces: []
  };
  function readCommon($this, s, readHeader) {
    var magic = readS32BE_1(s);
    if (!(magic === -1991225785))
      throw IllegalArgumentException_init_$Create$('' + 'Invalid PNG file magic: ' + _get_hex_(magic) + '!=' + _get_hex_(-1991225785));
    readS32BE_1(s);
    Unit_getInstance();
    var pheader = {_v: null};
    var pngdata = ByteArrayBuilder_init_$Create$_1(0, 1, null);
    var rgbPalette = UByteArrayInt(768);
    var tmp = 0;
    var tmp_0 = 256;
    var tmp_1 = new Int8Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = -1;
      tmp = tmp + 1 | 0;
    }
    var aPalette = _UByteArrayInt___init__impl_(tmp_1);
    var paletteCount = {_v: 0};
    while (!_get_eof_(s) ? readCommon$readChunk(s, pheader, paletteCount, rgbPalette, aPalette, pngdata) : false) {
      if (readHeader ? !(pheader._v == null) : false)
        return pheader._v;
    }
    var tmp0_elvis_lhs = pheader._v;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('PNG without header!');
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var header = tmp_3;
    var width = header._width_9;
    var height = header._height_10;
    var outputSizeHint = imul(imul(1 + width | 0, height), header._components_0);
    var tmp_4 = pngdata.toByteArray_0_k$();
    var tmp_5 = Companion_getInstance_103();
    var databb = uncompress$default(tmp_4, tmp_5, 0, 2, null);
    var databbp = 0;
    var context = new DecodingContext(header);
    var bpp = context._header._components_0;
    var row32 = context._row32;
    var tmp_6;
    if (header._components_0 === 1) {
      var tmp0_map_0 = until(0, paletteCount._v);
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var inductionVariable = tmp0_map_0._get_first__0_k$();
      var last_1 = tmp0_map_0._get_last__0_k$();
      if (inductionVariable <= last_1)
        do {
          var item_2_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          tmp0_mapTo_0_1.add_2bq_k$(_RGBA___get_value__impl_(Companion_getInstance_136().invoke_fnl2i9_k$(UByteArrayInt__get_impl(rgbPalette, imul(item_2_3, 3) + 0 | 0), UByteArrayInt__get_impl(rgbPalette, imul(item_2_3, 3) + 1 | 0), UByteArrayInt__get_impl(rgbPalette, imul(item_2_3, 3) + 2 | 0), UByteArrayInt__get_impl(aPalette, item_2_3))));
          Unit_getInstance();
        }
         while (!(item_2_3 === last_1));
      tmp_6 = Bitmap8_init_$Create$(width, height, null, _RgbaArray___init__impl_(toIntArray(tmp0_mapTo_0_1)), 4, null);
    } else {
      tmp_6 = Bitmap32_init_$Create$(width, height, null, false, 12, null);
    }
    var bmp = tmp_6;
    var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
    var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
    var tmp1_subject = header._interlacemethod;
    var passes = tmp1_subject === 1 ? $this._InterlacedPasses : $this._NormalPasses;
    var tmp2_iterator = passes.iterator_0_k$();
    while (tmp2_iterator.hasNext_0_k$()) {
      var pass = tmp2_iterator.next_0_k$();
      var progression = step(until(pass._startingRow, height), pass._rowIncrement);
      var inductionVariable_0 = progression._first_0;
      var last_2 = progression._last;
      var step_0 = progression._step_2;
      if ((step_0 > 0 ? inductionVariable_0 <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable_0 : false)
        do {
          var row = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          var col = pass._startingCol;
          var colIncrement = pass._colIncrement;
          var pixelsInThisRow = width >>> pass._colIncrementShift;
          var bytesInThisRow = imul(imul(pixelsInThisRow, header._components_0), header._bitsPerChannel) / 8 | 0;
          var tmp4 = databbp;
          databbp = tmp4 + 1 | 0;
          var filter = databb[tmp4] & 255;
          var currentRow = context._currentRow;
          var lastRow = context._lastRow;
          arraycopy_2(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
          databbp = databbp + bytesInThisRow | 0;
          if (!(bmp8 == null)) {
            $this.applyFilter$default_gs58v0_k$(filter, lastRow, currentRow, header._components_0, 0, 16, null);
            var tmp5_subject = header._bitsPerChannel;
            switch (tmp5_subject) {
              case 1:
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < width)
                  do {
                    var n = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var tmp1_set_0 = bmp;
                    var tmp2_set_0 = col + n | 0;
                    var tmp3_set_0 = extract(UByteArrayInt__get_impl(currentRow, n / 8 | 0), 7 - imul(n % 8, 1) | 0, 1);
                    tmp1_set_0.setInt_zd700_k$(tmp2_set_0, row, tmp3_set_0);
                  }
                   while (inductionVariable_1 < width);
                break;
              case 2:
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < width)
                  do {
                    var n_0 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var tmp4_set_0 = bmp;
                    var tmp5_set_0 = col + n_0 | 0;
                    var tmp6_set_0 = extract(UByteArrayInt__get_impl(currentRow, n_0 / 4 | 0), 6 - imul(n_0 % 4, 2) | 0, 2);
                    tmp4_set_0.setInt_zd700_k$(tmp5_set_0, row, tmp6_set_0);
                  }
                   while (inductionVariable_2 < width);
                break;
              case 4:
                var inductionVariable_3 = 0;
                if (inductionVariable_3 < width)
                  do {
                    var n_1 = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var tmp7_set_0 = bmp;
                    var tmp8_set_0 = col + n_1 | 0;
                    var tmp9_set_0 = extract(UByteArrayInt__get_impl(currentRow, n_1 / 2 | 0), 4 - imul(n_1 % 2, 4) | 0, 4);
                    tmp7_set_0.setInt_zd700_k$(tmp8_set_0, row, tmp9_set_0);
                  }
                   while (inductionVariable_3 < width);
                break;
              case 8:
                bmp8.setRowChunk_fu24oi_k$(col, row, asByteArray(currentRow), width, colIncrement);
                break;
              default:var tmp10_error_0 = '' + 'Unsupported header.bitsPerChannel=' + header._bitsPerChannel;
                throw IllegalStateException_init_$Create$_0(toString_1(tmp10_error_0));
            }
          } else if (!(bmp32 == null)) {
            var tmp9_subject = header._bitsPerChannel;
            if (tmp9_subject === 8) {
              $this.applyFilter_1n193w_k$(filter, lastRow, currentRow, bpp, bytesInThisRow);
              var tmp10_subject = bpp;
              switch (tmp10_subject) {
                case 3:
                  var tmp_7 = Companion_getInstance_134();
                  var tmp_8 = asByteArray(currentRow);
                  decode$default(tmp_7, tmp_8, 0, row32, 0, pixelsInThisRow, false, 32, null);
                  break;
                case 4:
                  var tmp_9 = Companion_getInstance_136();
                  var tmp_10 = asByteArray(currentRow);
                  decode$default(tmp_9, tmp_10, 0, row32, 0, pixelsInThisRow, false, 32, null);
                  break;
                default:var tmp11_TODO_0 = '' + 'Bytes: ' + bpp;
                  throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp11_TODO_0);
              }
              bmp32.setRowChunk_6ztocq_k$(col, row, row32, width, colIncrement);
            } else {
              var tmp12_error_0 = '' + 'Unsupported header.bitsPerChannel=' + header._bitsPerChannel;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp12_error_0));
            }
          }context.swapRows_sv8swh_k$();
        }
         while (!(row === last_2));
    }
    return bmp;
  }
  function DecodingContext(header) {
    this._header = header;
    this._lastRow = UByteArrayInt(this._header._stride);
    this._currentRow = UByteArrayInt(this._header._stride);
    this._row32 = Companion_getInstance_135().invoke_spsmd3_k$(this._header._width_9);
  }
  DecodingContext.prototype.swapRows_sv8swh_k$ = function () {
    var temp_0 = this._currentRow;
    this._currentRow = this._lastRow;
    this._lastRow = temp_0;
  };
  DecodingContext.$metadata$ = {
    simpleName: 'DecodingContext',
    kind: 'class',
    interfaces: []
  };
  function writeImage$writeChunk($s, name, data) {
    var nameBytes = copyOf(toByteArray$default(name, null, 0, 0, 7, null), 4);
    var crc = CRC32_getInstance()._initialValue_0;
    var tmp = CRC32_getInstance();
    var tmp_0 = crc;
    crc = tmp.update$default_esd280_k$(tmp_0, nameBytes, 0, 0, 12, null);
    var tmp_1 = CRC32_getInstance();
    var tmp_2 = crc;
    crc = tmp_1.update$default_esd280_k$(tmp_2, data, 0, 0, 12, null);
    write32BE_1($s, data.length);
    writeBytes_0($s, nameBytes);
    writeBytes_0($s, data);
    write32BE_1($s, crc);
  }
  function writeImage$compress(level, data) {
    var tmp = Companion_getInstance_103();
    var tmp_0 = new CompressionContext(level);
    return compress$default(data, tmp, tmp_0, 0, 4, null);
  }
  function writeImage$writeChunk_0($s, name, initialCapacity, callback) {
    var buffer_1 = ByteArrayBuilder_init_$Create$_0(initialCapacity);
    var s_2 = MemorySyncStream(buffer_1);
    callback(s_2);
    return writeImage$writeChunk($s, name, buffer_1.toByteArray_0_k$());
  }
  function writeImage$writeHeader(width, height, $s, colorspace) {
    writeImage$writeChunk_0($s, 'IHDR', 13, _no_name_provided_$factory_223(width, height, colorspace));
  }
  function readCommon$readChunk(_this_, pheader, paletteCount, rgbPalette, aPalette, pngdata) {
    var length = readS32BE_1(_this_);
    var type = readStringz$default(_this_, 4, null, 2, null);
    var data = readStream_0(_this_, toLong(length));
    var crc = readS32BE_1(_this_);
    var tmp0_subject = type;
    switch (tmp0_subject) {
      case 'IHDR':
        var tmp = readS32BE_1(data);
        var tmp_0 = readS32BE_1(data);
        var tmp_1 = readU8_2(data);
        var tmp0_elvis_lhs_2 = Companion_getInstance_149()._BY_ID_0.get_2bw_k$(readU8_2(data));
        pheader._v = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs_2 == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs_2, readU8_2(data), readU8_2(data), readU8_2(data));
        break;
      case 'PLTE':
        var tmp0_max_0 = paletteCount._v;
        var tmp1_max_0 = data._get_length__0_k$().toInt_0_k$() / 3 | 0;
        paletteCount._v = Math.max(tmp0_max_0, tmp1_max_0);
        data.read_irqg4d_k$(asByteArray(rgbPalette), 0, data._get_length__0_k$().toInt_0_k$());
        Unit_getInstance();
        break;
      case 'tRNS':
        var tmp2_max_0 = paletteCount._v;
        var tmp3_max_0 = data._get_length__0_k$().toInt_0_k$();
        paletteCount._v = Math.max(tmp2_max_0, tmp3_max_0);
        data.read_irqg4d_k$(asByteArray(aPalette), 0, data._get_length__0_k$().toInt_0_k$());
        Unit_getInstance();
        break;
      case 'IDAT':
        var tmp_2 = readAll_0(data);
        pngdata.append$default_ffc7am_k$(tmp_2, 0, 0, 6, null);
        break;
      case 'IEND':
        return false;
    }
    return true;
  }
  function _no_name_provided__269($bitmap) {
    this._$bitmap = $bitmap;
  }
  _no_name_provided__269.prototype.invoke_tk82hz_k$ = function ($this$writeChunk) {
    var tmp0_iterator = RgbaArray__iterator_impl(this._$bitmap._get_palette__wd8tzq_k$());
    while (tmp0_iterator.hasNext_0_k$()) {
      var c = tmp0_iterator.next_0_k$()._value_19;
      write8_1($this$writeChunk, _RGBA___get_r__impl_(c));
      write8_1($this$writeChunk, _RGBA___get_g__impl_(c));
      write8_1($this$writeChunk, _RGBA___get_b__impl_(c));
    }
  };
  _no_name_provided__269.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_tk82hz_k$(p1 instanceof SyncStream ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__269.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__270($bitmap) {
    this._$bitmap_0 = $bitmap;
  }
  _no_name_provided__270.prototype.invoke_tk82hz_k$ = function ($this$writeChunk) {
    var tmp0_iterator = RgbaArray__iterator_impl(this._$bitmap_0._get_palette__wd8tzq_k$());
    while (tmp0_iterator.hasNext_0_k$()) {
      var c = tmp0_iterator.next_0_k$()._value_19;
      write8_1($this$writeChunk, _RGBA___get_a__impl_(c));
    }
  };
  _no_name_provided__270.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_tk82hz_k$(p1 instanceof SyncStream ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__270.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__271() {
  }
  _no_name_provided__271.prototype.invoke_tk82hz_k$ = function ($this$writeChunk) {
    return Unit_getInstance();
  };
  _no_name_provided__271.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_tk82hz_k$(p1 instanceof SyncStream ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__271.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__272($width, $height, $colorspace) {
    this._$width = $width;
    this._$height = $height;
    this._$colorspace = $colorspace;
  }
  _no_name_provided__272.prototype.invoke_tk82hz_k$ = function ($this$writeChunk) {
    write32BE_1($this$writeChunk, this._$width);
    write32BE_1($this$writeChunk, this._$height);
    write8_1($this$writeChunk, 8);
    write8_1($this$writeChunk, this._$colorspace._id_7);
    write8_1($this$writeChunk, 0);
    write8_1($this$writeChunk, 0);
    write8_1($this$writeChunk, 0);
  };
  _no_name_provided__272.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_tk82hz_k$(p1 instanceof SyncStream ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__272.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Colorspace_GRAYSCALE_getInstance() {
    Colorspace_initEntries();
    return Colorspace_GRAYSCALE_instance;
  }
  function Colorspace_RGB_getInstance() {
    Colorspace_initEntries();
    return Colorspace_RGB_instance;
  }
  function Colorspace_INDEXED_getInstance() {
    Colorspace_initEntries();
    return Colorspace_INDEXED_instance;
  }
  function Colorspace_GRAYSCALE_ALPHA_getInstance() {
    Colorspace_initEntries();
    return Colorspace_GRAYSCALE_ALPHA_instance;
  }
  function Colorspace_RGBA_getInstance() {
    Colorspace_initEntries();
    return Colorspace_RGBA_instance;
  }
  function PNG() {
    PNG_instance = this;
    ImageFormat.call(this, ['png']);
    this._MAGIC1 = -1991225785;
    this._MAGIC2 = 218765834;
    this._InterlacedPasses = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    this._NormalPasses = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
  }
  PNG.prototype.decodeHeader_55aaqy_k$ = function (s, props) {
    var tmp;
    try {
      var tmp_0 = readCommon(this, s, true);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      var tmp0_apply_0 = new ImageInfo();
      tmp0_apply_0._width_8 = header._width_9;
      tmp0_apply_0._height_9 = header._height_10;
      tmp0_apply_0._bitsPerPixel = header._bitsPerChannel;
      tmp = tmp0_apply_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        tmp_1 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  };
  PNG.prototype.writeImage_bwcin2_k$ = function (image, s, props) {
    var bitmap = image._get_mainBitmap__0_k$();
    var width = bitmap._width_2;
    var height = bitmap._height_3;
    write32BE_1(s, -1991225785);
    write32BE_1(s, 218765834);
    var level = numberToInt(convertRangeClamped(props._quality, 0.0, 1.0, 0.0, 9.0));
    var tmp0_subject = bitmap;
    if (tmp0_subject instanceof Bitmap8) {
      writeImage$writeHeader(width, height, s, Colorspace_INDEXED_getInstance());
      var tmp = imul(_RgbaArray___get_size__impl_(bitmap._get_palette__wd8tzq_k$()), 3);
      writeImage$writeChunk_0(s, 'PLTE', tmp, _no_name_provided_$factory_220(bitmap));
      var tmp_0 = imul(_RgbaArray___get_size__impl_(bitmap._get_palette__wd8tzq_k$()), 1);
      writeImage$writeChunk_0(s, 'tRNS', tmp_0, _no_name_provided_$factory_221(bitmap));
      var out = new Int8Array(height + imul(width, height) | 0);
      var pos = 0;
      var inductionVariable = 0;
      if (inductionVariable < height)
        do {
          var y = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp2 = pos;
          pos = tmp2 + 1 | 0;
          write8(out, tmp2, 0);
          var index_0 = bitmap.index_27zxwg_k$(0, y);
          arraycopy_2(bitmap._get_data__0_k$(), index_0, out, pos, width);
          pos = pos + width | 0;
        }
         while (inductionVariable < height);
      writeImage$writeChunk(s, 'IDAT', writeImage$compress(level, out));
    } else {
      {
        var bmp = bitmap.toBMP32_0_k$();
        writeImage$writeHeader(width, height, s, Colorspace_RGBA_getInstance());
        var out_0 = new Int8Array(height + imul(imul(width, height), 4) | 0);
        var pos_0 = 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < height)
          do {
            var y_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp4 = pos_0;
            pos_0 = tmp4 + 1 | 0;
            write8(out_0, tmp4, 0);
            var index_1 = bmp.index_27zxwg_k$(0, y_0);
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var c = bmp._get_premultiplied__0_k$() ? _RGBAPremultiplied___get_depremultiplied__impl_(asPremultiplied(RgbaArray__get_impl(bmp._data_25, index_1 + x | 0))) : RgbaArray__get_impl(bmp._data_25, index_1 + x | 0);
                var tmp6 = pos_0;
                pos_0 = tmp6 + 1 | 0;
                write8(out_0, tmp6, _RGBA___get_r__impl_(c));
                var tmp7 = pos_0;
                pos_0 = tmp7 + 1 | 0;
                write8(out_0, tmp7, _RGBA___get_g__impl_(c));
                var tmp8 = pos_0;
                pos_0 = tmp8 + 1 | 0;
                write8(out_0, tmp8, _RGBA___get_b__impl_(c));
                var tmp9 = pos_0;
                pos_0 = tmp9 + 1 | 0;
                write8(out_0, tmp9, _RGBA___get_a__impl_(c));
              }
               while (inductionVariable_1 < width);
          }
           while (inductionVariable_0 < height);
        writeImage$writeChunk(s, 'IDAT', writeImage$compress(level, out_0));
      }
    }
    writeImage$writeChunk_0(s, 'IEND', 0, _no_name_provided_$factory_222());
  };
  PNG.prototype.readImage_55aaqy_k$ = function (s, props) {
    var tmp = Companion_getInstance_148();
    var tmp_0 = readCommon(this, s, false);
    var tmp_1 = tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE();
    var tmp_2 = listOf_0(tmp.invoke$default_ecgccd_k$(tmp_1, null, 0, 0, false, false, null, 0, 254, null));
    return ImageData_init_$Create$(tmp_2, 0, 0, 0, null, null, null, 126, null);
  };
  PNG.prototype.paethPredictor_fcwjfj_k$ = function (a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return (pa <= pb ? pa <= pc : false) ? a : pb <= pc ? b : c;
  };
  PNG.prototype.applyFilter_1n193w_k$ = function (filter, p, c, bpp, size_2) {
    var tmp0_subject = filter;
    switch (tmp0_subject) {
      case 0:
        Unit_getInstance();
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size_2)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp2_array = c;
            var tmp3_index0 = n;
            UByteArrayInt__set_impl(tmp2_array, tmp3_index0, UByteArrayInt__get_impl(tmp2_array, tmp3_index0) + UByteArrayInt__get_impl(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size_2);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size_2)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp5_array = c;
            var tmp6_index0 = n_0;
            UByteArrayInt__set_impl(tmp5_array, tmp6_index0, UByteArrayInt__get_impl(tmp5_array, tmp6_index0) + UByteArrayInt__get_impl(p, n_0) | 0);
          }
           while (inductionVariable_0 < size_2);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp8_array = c;
            var tmp9_index0 = n_1;
            UByteArrayInt__set_impl(tmp8_array, tmp9_index0, UByteArrayInt__get_impl(tmp8_array, tmp9_index0) + (UByteArrayInt__get_impl(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size_2)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var tmp11_array = c;
            var tmp12_index0 = n_2;
            UByteArrayInt__set_impl(tmp11_array, tmp12_index0, UByteArrayInt__get_impl(tmp11_array, tmp12_index0) + ((UByteArrayInt__get_impl(c, n_2 - bpp | 0) + UByteArrayInt__get_impl(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size_2);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var tmp14_array = c;
            var tmp15_index0 = n_3;
            UByteArrayInt__set_impl(tmp14_array, tmp15_index0, UByteArrayInt__get_impl(tmp14_array, tmp15_index0) + UByteArrayInt__get_impl(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size_2)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            var tmp17_array = c;
            var tmp18_index0 = n_4;
            UByteArrayInt__set_impl(tmp17_array, tmp18_index0, UByteArrayInt__get_impl(tmp17_array, tmp18_index0) + this.paethPredictor_fcwjfj_k$(UByteArrayInt__get_impl(c, n_4 - bpp | 0), UByteArrayInt__get_impl(p, n_4), UByteArrayInt__get_impl(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size_2);
        break;
      default:var tmp0_TODO_0 = '' + 'Filter: ' + filter;
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
    }
  };
  PNG.prototype.applyFilter$default_gs58v0_k$ = function (filter, p, c, bpp, size_2, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      size_2 = _UByteArrayInt___get_size__impl_(c);
    return this.applyFilter_1n193w_k$(filter, p, c, bpp, size_2);
  };
  PNG.$metadata$ = {
    simpleName: 'PNG',
    kind: 'object',
    interfaces: []
  };
  var PNG_instance;
  function PNG_getInstance() {
    if (PNG_instance == null)
      new PNG();
    return PNG_instance;
  }
  function _no_name_provided_$factory_220($bitmap) {
    var i = new _no_name_provided__269($bitmap);
    return function (p1) {
      i.invoke_tk82hz_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_221($bitmap) {
    var i = new _no_name_provided__270($bitmap);
    return function (p1) {
      i.invoke_tk82hz_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_222() {
    var i = new _no_name_provided__271();
    return function (p1) {
      i.invoke_tk82hz_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_223($width, $height, $colorspace) {
    var i = new _no_name_provided__272($width, $height, $colorspace);
    return function (p1) {
      i.invoke_tk82hz_k$(p1);
      return Unit_getInstance();
    };
  }
  var RegisteredImageFormats_formats;
  function RegisteredImageFormats() {
    RegisteredImageFormats_instance = this;
    ImageFormat.call(this, []);
  }
  RegisteredImageFormats.prototype._set_formats__nv0xm4_k$ = function (value) {
    RegisteredImageFormats_formats = value;
    return Unit_getInstance();
  };
  RegisteredImageFormats.prototype._get_formats__0_k$ = function () {
    return RegisteredImageFormats_formats;
  };
  RegisteredImageFormats.prototype.register_mo7ym5_k$ = function (formats) {
    this._set_formats__nv0xm4_k$(new ImageFormats(plus_1(this._get_formats__0_k$()._formats, formats)));
  };
  RegisteredImageFormats.prototype.readImage_55aaqy_k$ = function (s, props) {
    return this._get_formats__0_k$().readImage_55aaqy_k$(s, props);
  };
  RegisteredImageFormats.prototype.writeImage_bwcin2_k$ = function (image, s, props) {
    return this._get_formats__0_k$().writeImage_bwcin2_k$(image, s, props);
  };
  RegisteredImageFormats.prototype.decodeHeader_55aaqy_k$ = function (s, props) {
    return this._get_formats__0_k$().decodeHeader_55aaqy_k$(s, props);
  };
  RegisteredImageFormats.prototype.toString = function () {
    return '' + 'RegisteredImageFormats(' + this._get_formats__0_k$() + ')';
  };
  RegisteredImageFormats.$metadata$ = {
    simpleName: 'RegisteredImageFormats',
    kind: 'object',
    interfaces: []
  };
  var RegisteredImageFormats_instance;
  function RegisteredImageFormats_getInstance() {
    if (RegisteredImageFormats_instance == null)
      new RegisteredImageFormats();
    return RegisteredImageFormats_instance;
  }
  function Info(width, height, flipY, bitsPerPixel) {
    this._width_10 = width;
    this._height_11 = height;
    this._flipY_0 = flipY;
    this._bitsPerPixel_0 = bitsPerPixel;
    this._area_1 = imul(this._width_10, this._height_11);
    this._bytes = this._bitsPerPixel_0 / 8 | 0;
  }
  Info.$metadata$ = {
    simpleName: 'Info',
    kind: 'class',
    interfaces: []
  };
  function TGA() {
    TGA_instance = this;
    ImageFormat.call(this, ['tga']);
  }
  TGA.prototype.decodeHeader_55aaqy_k$ = function (s, props) {
    var tmp;
    try {
      var tmp0_success_0_1 = Companion_getInstance_3();
      var tmp0_apply_0_6 = new ImageInfo();
      var h_2_7 = TGA_getInstance().readHeader_f1lhq0_k$(s);
      tmp0_apply_0_6._width_8 = h_2_7._width_10;
      tmp0_apply_0_6._height_9 = h_2_7._height_11;
      tmp0_apply_0_6._bitsPerPixel = h_2_7._bitsPerPixel_0;
      var tmp1_success_0_2 = tmp0_apply_0_6;
      tmp = _Result___init__impl_(tmp1_success_0_2);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var tmp2_failure_0_4 = Companion_getInstance_3();
        tmp_0 = _Result___init__impl_(createFailure($p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var tmp0_getOrNull_0 = tmp;
    var tmp_1;
    if (_Result___get_isFailure__impl_(tmp0_getOrNull_0)) {
      tmp_1 = null;
    } else {
      var tmp_2 = _Result___get_value__impl_(tmp0_getOrNull_0);
      tmp_1 = (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
    }
    return tmp_1;
  };
  TGA.prototype.readHeader_f1lhq0_k$ = function (s) {
    var idLength = readU8_2(s);
    var colorMapType = readU8_2(s);
    var tmp0_subject = colorMapType;
    switch (tmp0_subject) {
      case 0:
      case 1:
        Unit_getInstance();
        break;
      default:throw IllegalStateException_init_$Create$_0('Not a TGA. Unsupported colorMapType');
    }
    var imageType = readU8_2(s);
    var tmp1_subject = imageType;
    switch (tmp1_subject) {
      case 1:
        throw new NotImplementedError('An operation is not implemented: Unsupported indexed');
      case 2:
        Unit_getInstance();
        break;
      case 9:
      case 10:
        throw new NotImplementedError('An operation is not implemented: Unsupported RLE');
      default:throw new NotImplementedError('An operation is not implemented: Unknown TGA');
    }
    var firstIndexEntry = readU16LE_1(s);
    var colorMapLength = readU16LE_1(s);
    var colorMapEntrySize = readU8_2(s);
    var tmp2_this = s;
    var tmp0_plus_0 = tmp2_this._get_position__0_k$();
    var tmp1_plus_0 = imul(colorMapLength, colorMapEntrySize);
    tmp2_this._set_position__kdfck9_k$(tmp0_plus_0.plus_wiekkq_k$(toLong(tmp1_plus_0)));
    var xorig = readS16LE_1(s);
    var yorig = readS16LE_1(s);
    var width = readS16LE_1(s);
    var height = readS16LE_1(s);
    var pixelDepth = readU8_2(s);
    var tmp3_subject = pixelDepth;
    switch (tmp3_subject) {
      case 24:
      case 32:
        Unit_getInstance();
        break;
      default:throw new NotImplementedError('An operation is not implemented: Not a RGBA tga');
    }
    if (width < 0 ? true : height < 0) {
      throw IllegalStateException_init_$Create$_0('Not a TGA. Invalid width/height');
    }var imageDescriptor = readU8_2(s);
    var flipY = (imageDescriptor >>> 5 & 1) === 0;
    var storage = imageDescriptor >>> 6 & 3;
    readBytes_0(s, idLength);
    Unit_getInstance();
    return new Info(width, height, flipY, pixelDepth);
  };
  TGA.prototype.readImage_55aaqy_k$ = function (s, props) {
    var info = this.readHeader_f1lhq0_k$(s);
    var tmp0_subject = info._bitsPerPixel_0;
    var tmp;
    switch (tmp0_subject) {
      case 24:
        tmp = Companion_getInstance_134();
        break;
      case 32:
        tmp = Companion_getInstance_136();
        break;
      default:throw new NotImplementedError('An operation is not implemented: Not a RGBA tga');
    }
    var format_0 = tmp;
    var tmp_0 = Bitmap32_init_$Create$(info._width_10, info._height_11, null, false, 12, null);
    var tmp_1 = readBytes_0(s, imul(info._area_1, info._bytes));
    var out = tmp_0.writeDecoded$default_erzun2_k$(format_0, tmp_1, 0, false, 12, null);
    if (info._flipY_0) {
      out.flipY_0_k$();
      Unit_getInstance();
    }var tmp_2 = Companion_getInstance_148();
    var tmp_3 = listOf_0(tmp_2.invoke$default_ecgccd_k$(out, null, 0, 0, false, false, null, 0, 254, null));
    return ImageData_init_$Create$(tmp_3, 0, 0, 0, null, null, null, 126, null);
  };
  TGA.prototype.writeImage_bwcin2_k$ = function (image, s, props) {
    var bitmap = image._get_mainBitmap__0_k$();
    var tmp0_subject = bitmap;
    if (tmp0_subject instanceof Bitmap8) {
      throw new NotImplementedError('An operation is not implemented: Not implemented encoding TGA Bitmap8');
    } else {
      {
        var bmp = bitmap.toBMP32_0_k$();
        var data = new Int8Array(imul(bmp._get_area__0_k$(), 4));
        var m = 0;
        var tmp1_iterator = RgbaArray__iterator_impl(bmp._data_25);
        while (tmp1_iterator.hasNext_0_k$()) {
          var c = tmp1_iterator.next_0_k$()._value_19;
          var tmp2 = m;
          m = tmp2 + 1 | 0;
          data[tmp2] = toByte(_RGBA___get_b__impl_(c));
          var tmp3 = m;
          m = tmp3 + 1 | 0;
          data[tmp3] = toByte(_RGBA___get_g__impl_(c));
          var tmp4 = m;
          m = tmp4 + 1 | 0;
          data[tmp4] = toByte(_RGBA___get_r__impl_(c));
          var tmp5 = m;
          m = tmp5 + 1 | 0;
          data[tmp5] = toByte(_RGBA___get_a__impl_(c));
        }
        write8_1(s, 0);
        write8_1(s, 0);
        write8_1(s, 2);
        write16LE_1(s, 0);
        write16LE_1(s, 0);
        write8_1(s, 0);
        write16LE_1(s, 0);
        write16LE_1(s, 0);
        write16LE_1(s, bmp._get_width__0_k$());
        write16LE_1(s, bmp._get_height__0_k$());
        write8_1(s, 32);
        write8_1(s, 32);
        writeBytes_0(s, data);
      }
    }
  };
  TGA.$metadata$ = {
    simpleName: 'TGA',
    kind: 'object',
    interfaces: []
  };
  var TGA_instance;
  function TGA_getInstance() {
    if (TGA_instance == null)
      new TGA();
    return TGA_instance;
  }
  function clamp0_255(_this_) {
    var n = _this_ & (-(_this_ >= 0 ? 1 : 0) | 0);
    return (n | (255 - n | 0) >> 31) & 255;
  }
  function sumPacked4MulR(a, b, mul) {
    var dstRB = imul(b & 16711935, mul) >>> 8;
    var dstGA = imul(b >>> 8 & 16711935, mul) >>> 8;
    var r = (a >>> 0 & 255) + (dstRB >>> 0 & 255) | 0;
    var g = (a >>> 8 & 255) + (dstGA >>> 0 & 255) | 0;
    var b_0 = (a >>> 16 & 255) + (dstRB >>> 16 & 255) | 0;
    var a_0 = (a >>> 24 & 255) + (dstGA >>> 16 & 255) | 0;
    return packIntClamped(r, g, b_0, a_0);
  }
  function d2i(v) {
    return numberToInt(clamp01_0(v) * 255);
  }
  function f2i(v) {
    return numberToInt(clamp01_0(v) * 255);
  }
  function packIntUnchecked(r, g, b, a) {
    return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
  }
  function packIntClamped(r, g, b, a) {
    return packIntUnchecked(clamp0_255(r), clamp0_255(g), clamp0_255(b), clamp0_255(a));
  }
  function ColorFiller() {
    BaseFiller.call(this);
    this._color_3 = _RGBA___get_premultiplied__impl_(Colors_getInstance()._RED_0);
  }
  ColorFiller.prototype.set_wb3245_k$ = function (fill_4, state) {
    this._color_3 = _RGBA___get_premultiplied__impl_(_RGBA___get_color__impl_(fill_4));
    return this;
  };
  ColorFiller.prototype.fill_5y0cis_k$ = function (data, offset_0, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl(data, this._color_3, offset_0 + x0 | 0, (offset_0 + x1 | 0) + 1 | 0);
  };
  ColorFiller.$metadata$ = {
    simpleName: 'ColorFiller',
    kind: 'class',
    interfaces: []
  };
  function _get_fill_($this) {
    var tmp = $this._fill;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fill');
    }
  }
  function stopN($this, n) {
    return numberToInt(_get_fill_($this)._stops.get_ha5a7z_k$(n) * $this._NCOLORS);
  }
  function color($this, ratio) {
    return RgbaPremultipliedArray__get_impl($this._colors_0, numberToInt(clamp01(ratio) * ($this._NCOLORS - 1 | 0)));
  }
  function GradientFiller() {
    BaseFiller.call(this);
    this._NCOLORS = 256;
    this._colors_0 = Companion_getInstance_137().invoke_dguj8z_k$(this._NCOLORS);
    var tmp = this;
    tmp._stateInv = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  }
  GradientFiller.prototype.set_w8nzgc_k$ = function (fill_4, state) {
    this._fill = fill_4;
    state._transform_6.inverted_lwp7hs_k$(this._stateInv);
    Unit_getInstance();
    var tmp0_subject_2 = fill_4._get_numberOfStops__0_k$();
    switch (tmp0_subject_2) {
      case 0:
      case 1:
        var color_3 = fill_4._get_numberOfStops__0_k$() === 0 ? Colors_getInstance()._FUCHSIA : _RGBA___init__impl_(first_0(fill_4._colors_1));
        var pcolor_4 = _RGBA___get_premultiplied__impl_(color_3);
        var inductionVariable = 0;
        var last_1 = this._NCOLORS;
        if (inductionVariable < last_1)
          do {
            var n_6 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            RgbaPremultipliedArray__set_impl(this._colors_0, n_6, pcolor_4);
          }
           while (inductionVariable < last_1);
        break;
      default:var inductionVariable_0 = 0;
        var last_2 = stopN(this, 0);
        if (inductionVariable_0 < last_2)
          do {
            var n_8 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            RgbaPremultipliedArray__set_impl(this._colors_0, n_8, _RGBA___get_premultiplied__impl_(_RGBA___init__impl_(first_0(fill_4._colors_1))));
          }
           while (inductionVariable_0 < last_2);
        var inductionVariable_1 = 0;
        var last_3 = fill_4._get_numberOfStops__0_k$() - 1 | 0;
        if (inductionVariable_1 < last_3)
          do {
            var n_10 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var stop0_11 = stopN(this, n_10 + 0 | 0);
            var stop1_12 = stopN(this, n_10 + 1 | 0);
            var color0_13 = _RGBA___init__impl_(fill_4._colors_1.getAt_ha5a7z_k$(n_10 + 0 | 0));
            var color1_14 = _RGBA___init__impl_(fill_4._colors_1.getAt_ha5a7z_k$(n_10 + 1 | 0));
            var inductionVariable_2 = stop0_11;
            if (inductionVariable_2 < stop1_12)
              do {
                var s_16 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var ratio_17 = (s_16 - stop0_11 | 0) / (stop1_12 - stop0_11 | 0);
                RgbaPremultipliedArray__set_impl(this._colors_0, s_16, _RGBA___get_premultiplied__impl_(Companion_getInstance_136().interpolate_8z8h9u_k$(color0_13, color1_14, ratio_17)));
              }
               while (inductionVariable_2 < stop1_12);
          }
           while (inductionVariable_1 < last_3);
        var inductionVariable_3 = stopN(this, fill_4._get_numberOfStops__0_k$() - 1 | 0);
        var last_4 = this._NCOLORS;
        if (inductionVariable_3 < last_4)
          do {
            var n_19 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            _RgbaPremultipliedArray___get_ints__impl_(this._colors_0)[n_19] = last_0(fill_4._colors_1);
          }
           while (inductionVariable_3 < last_4);
        break;
    }
    return this;
  };
  GradientFiller.prototype.fill_5y0cis_k$ = function (data, offset_0, x0, x1, y) {
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl(data, offset_0 + n | 0, color(this, _get_fill_(this).getRatioAt_n7xxde_k$(n, y, this._stateInv)));
      }
       while (!(n === x1));
  };
  GradientFiller.$metadata$ = {
    simpleName: 'GradientFiller',
    kind: 'class',
    interfaces: []
  };
  function BitmapFiller() {
    BaseFiller.call(this);
    this._cycleX = CycleMethod_NO_CYCLE_getInstance();
    this._cycleY = CycleMethod_NO_CYCLE_getInstance();
    var tmp = this;
    var tmp0__get_transparent__0 = Bitmaps_getInstance();
    tmp._texture_1 = Bitmaps_transparent._bmp;
    var tmp_0 = this;
    tmp_0._transform_2 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._linear = true;
    var tmp_1 = this;
    tmp_1._stateTrans = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_2 = this;
    tmp_2._fillTrans = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_3 = this;
    tmp_3._compTrans = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  }
  BitmapFiller.prototype.set_szf2jp_k$ = function (fill_4, state) {
    this._cycleX = fill_4._cycleX_0;
    this._cycleY = fill_4._cycleY_0;
    this._texture_1 = fill_4._bmp32;
    this._transform_2 = fill_4._transform_4;
    this._linear = fill_4._smooth;
    state._transform_6.inverted_lwp7hs_k$(this._stateTrans);
    Unit_getInstance();
    fill_4._transform_4.inverted_lwp7hs_k$(this._fillTrans);
    Unit_getInstance();
    var tmp0_apply_0_2 = this._compTrans;
    tmp0_apply_0_2.identity_0_k$();
    Unit_getInstance();
    tmp0_apply_0_2.multiply_yv84xs_k$(tmp0_apply_0_2, this._stateTrans);
    Unit_getInstance();
    tmp0_apply_0_2.multiply_yv84xs_k$(tmp0_apply_0_2, this._fillTrans);
    Unit_getInstance();
    Unit_getInstance();
    return this;
  };
  BitmapFiller.prototype.lookupLinear_saxtsd_k$ = function (x, y) {
    return this._texture_1.getRgbaSampled_saxtsd_k$(x, y);
  };
  BitmapFiller.prototype.lookupNearest_saxtsd_k$ = function (x, y) {
    return this._texture_1.get_aewswh_k$(numberToInt(x), numberToInt(y));
  };
  BitmapFiller.prototype.fill_5y0cis_k$ = function (data, offset_0, x0, x1, y) {
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tx_0 = this._cycleX.apply_ngl742_k$(this._compTrans.transformX_ngl742_k$(n, y), this._texture_1._get_width__0_k$());
        var ty_0 = this._cycleY.apply_ngl742_k$(this._compTrans.transformY_ngl742_k$(n, y), this._texture_1._get_height__0_k$());
        var color_0 = this._linear ? this.lookupLinear_saxtsd_k$(tx_0, ty_0) : this.lookupNearest_saxtsd_k$(tx_0, ty_0);
        RgbaPremultipliedArray__set_impl(data, offset_0 + n | 0, _RGBA___get_premultiplied__impl_(color_0));
      }
       while (!(n === x1));
  };
  BitmapFiller.$metadata$ = {
    simpleName: 'BitmapFiller',
    kind: 'class',
    interfaces: []
  };
  function BaseFiller() {
  }
  BaseFiller.$metadata$ = {
    simpleName: 'BaseFiller',
    kind: 'class',
    interfaces: []
  };
  function NoneFiller() {
    NoneFiller_instance = this;
    BaseFiller.call(this);
  }
  NoneFiller.prototype.fill_5y0cis_k$ = function (data, offset_0, x0, x1, y) {
    return Unit_getInstance();
  };
  NoneFiller.$metadata$ = {
    simpleName: 'NoneFiller',
    kind: 'object',
    interfaces: []
  };
  var NoneFiller_instance;
  function NoneFiller_getInstance() {
    if (NoneFiller_instance == null)
      new NoneFiller();
    return NoneFiller_instance;
  }
  function Paint() {
  }
  Paint.$metadata$ = {
    simpleName: 'Paint',
    kind: 'interface',
    interfaces: []
  };
  function _get_DefaultPaint_() {
    return Colors_getInstance()._BLACK_0;
  }
  function NonePaint() {
    NonePaint_instance = this;
  }
  NonePaint.prototype.transformed_lwp7hs_k$ = function (m) {
    return this;
  };
  NonePaint.$metadata$ = {
    simpleName: 'NonePaint',
    kind: 'object',
    interfaces: [Paint]
  };
  var NonePaint_instance;
  function NonePaint_getInstance() {
    if (NonePaint_instance == null)
      new NonePaint();
    return NonePaint_instance;
  }
  function GradientPaint_init_$Init$(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units, $mask0, $marker, $this) {
    if (!(($mask0 & 128) === 0)) {
      stops = DoubleArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 256) === 0)) {
      colors = IntArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 512) === 0))
      cycle_0 = CycleMethod_NO_CYCLE_getInstance();
    if (!(($mask0 & 1024) === 0)) {
      transform = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }if (!(($mask0 & 2048) === 0))
      interpolationMethod = GradientInterpolationMethod_NORMAL_getInstance();
    if (!(($mask0 & 4096) === 0))
      units = GradientUnits_OBJECT_BOUNDING_BOX_getInstance();
    GradientPaint.call($this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units);
    return $this;
  }
  function GradientPaint_init_$Create$(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units, $mask0, $marker) {
    return GradientPaint_init_$Init$(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units, $mask0, $marker, Object.create(GradientPaint.prototype));
  }
  function Companion_151() {
    Companion_instance_150 = this;
  }
  Companion_151.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_150;
  function Companion_getInstance_150() {
    if (Companion_instance_150 == null)
      new Companion_151();
    return Companion_instance_150;
  }
  function GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units) {
    Companion_getInstance_150();
    this._kind_0 = kind;
    this._x0 = x0;
    this._y0 = y0;
    this._r0_1 = r0;
    this._x1 = x1;
    this._y1 = y1;
    this._r1 = r1;
    this._stops = stops;
    this._colors_1 = colors;
    this._cycle = cycle_0;
    this._transform_3 = transform;
    this._interpolationMethod = interpolationMethod;
    this._units = units;
    var tmp = this;
    var tmp0_apply_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    tmp0_apply_0.translate_ngl742_k$(-this._x0, -this._y0);
    Unit_getInstance();
    var scale_2 = 1.0 / clamp_3(Companion_getInstance_32().distance_i6u10_k$(this._x0, this._y0, this._x1, this._y1), 1.0, 16000.0);
    tmp0_apply_0.scale_ngl742_k$(scale_2, scale_2);
    Unit_getInstance();
    var tmp0_between_0_3 = Companion_getInstance_26();
    var tmp1_between_0_4 = this._x0;
    var tmp2_between_0_5 = this._y0;
    var tmp3_between_0_6 = this._x1;
    var tmp4_between_0_7 = this._y1;
    tmp0_apply_0.rotate_ubek5g_k$(unaryMinus(Angle_between(tmp1_between_0_4, tmp2_between_0_5, tmp3_between_0_6, tmp4_between_0_7)));
    Unit_getInstance();
    tmp._untransformedGradientMatrix = tmp0_apply_0;
    var tmp_0 = this;
    var tmp0_apply_0_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    tmp0_apply_0_0.copyFrom_v5f3e9_k$(this._untransformedGradientMatrix);
    Unit_getInstance();
    tmp0_apply_0_0.postmultiply_lwp7hs_k$(this._transform_3);
    Unit_getInstance();
    tmp_0._gradientMatrix = tmp0_apply_0_0;
    var tmp_1 = this;
    tmp_1._gradientMatrixInv = this._gradientMatrix.inverted$default_3vhimr_k$(null, 1, null);
    this._r0r1_2 = 2 * this._r0_1 * this._r1;
    this._r0pow2 = this._get_pow2__xaho5p_k$(this._r0_1);
    this._r1pow2 = this._get_pow2__xaho5p_k$(this._r1);
    this._y0_y1 = this._y0 - this._y1;
    this._r0_r1 = this._r0_1 - this._r1;
    this._x0_x1 = this._x0 - this._x1;
    this._radial_scale = 1.0 / (this._get_pow2__xaho5p_k$(this._r0_1 - this._r1) - this._get_pow2__xaho5p_k$(this._x0 - this._x1) - this._get_pow2__xaho5p_k$(this._y0 - this._y1));
  }
  GradientPaint.prototype._get_transform__0_k$ = function () {
    return this._transform_3;
  };
  GradientPaint.prototype._get_numberOfStops__0_k$ = function () {
    return this._stops._get_size__0_k$();
  };
  GradientPaint.prototype.addColorStop_grassx_k$ = function (stop, color_0) {
    return this.add_grassx_k$(stop, color_0);
  };
  GradientPaint.prototype.add_grassx_k$ = function (stop, color_0) {
    var tmp0_this_2 = this;
    tmp0_this_2._stops.plusAssign_okcceq_k$(stop);
    var tmp1_this_3 = this;
    tmp1_this_3._colors_1.plusAssign_majfzk_k$(_RGBA___get_value__impl_(color_0));
    return this;
  };
  GradientPaint.prototype.getRatioAt_ngl742_k$ = function (x, y) {
    var tmp0_subject = this._kind_0;
    var tmp;
    if (tmp0_subject.equals(GradientKind_SWEEP_getInstance())) {
      tmp = div(Companion_getInstance_32().angle_2vxr7h_k$(this._x0, this._y0, x, y), _get_degrees__0(360));
    } else if (tmp0_subject.equals(GradientKind_RADIAL_getInstance())) {
      var tmp_0 = -this._r1 * this._r0_r1 + this._x0_x1 * (this._x1 - x) + this._y0_y1 * (this._y1 - y);
      var tmp0_sqrt_0 = this._r1pow2 * (this._get_pow2__xaho5p_k$(this._x0 - x) + this._get_pow2__xaho5p_k$(this._y0 - y)) - this._r0r1_2 * ((this._x0 - x) * (this._x1 - x) + (this._y0 - y) * (this._y1 - y)) + this._r0pow2 * (this._get_pow2__xaho5p_k$(this._x1 - x) + this._get_pow2__xaho5p_k$(this._y1 - y)) - this._get_pow2__xaho5p_k$(this._x1 * this._y0 - x * this._y0 - this._x0 * this._y1 + x * this._y1 + this._x0 * y - this._x1 * y);
      tmp = 1.0 - (tmp_0 - Math.sqrt(tmp0_sqrt_0)) * this._radial_scale;
    } else {
      tmp = this._gradientMatrix.transformX_ngl742_k$(x, y);
    }
    var tmp_1 = tmp;
    return this._cycle.apply$default_5ig8jr_k$(tmp_1, false, 2, null);
  };
  GradientPaint.prototype._get_pow2__xaho5p_k$ = function (_this__0) {
    return _this__0 * _this__0;
  };
  GradientPaint.prototype.getRatioAt_n7xxde_k$ = function (x, y, m) {
    return this.getRatioAt_ngl742_k$(m.transformX_ngl742_k$(x, y), m.transformY_ngl742_k$(x, y));
  };
  GradientPaint.prototype.applyMatrix_lwp7hs_k$ = function (m) {
    var tmp = m.transformX_ngl742_k$(this._x0, this._y0);
    var tmp_0 = m.transformY_ngl742_k$(this._x0, this._y0);
    var tmp_1 = this._r0_1 * m.transformX_ngl742_k$(1.0, 0.0);
    var tmp_2 = m.transformX_ngl742_k$(this._x1, this._y1);
    var tmp_3 = m.transformY_ngl742_k$(this._x1, this._y1);
    var tmp_4 = this._r1 * m.transformX_ngl742_k$(1.0, 0.0);
    var tmp_5 = DoubleArrayList_init_$Create$_0(this._stops);
    var tmp_6 = IntArrayList_init_$Create$_0(this._colors_1);
    return new GradientPaint(this._kind_0, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, this._cycle, Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null), this._interpolationMethod, this._units);
  };
  GradientPaint.prototype.transformed_lwp7hs_k$ = function (m) {
    return this.applyMatrix_lwp7hs_k$(m);
  };
  GradientPaint.prototype.toString = function () {
    var tmp0_subject = this._kind_0;
    var tmp;
    if (tmp0_subject.equals(GradientKind_LINEAR_getInstance())) {
      tmp = '' + 'LinearGradient(' + this._x0 + ', ' + this._y0 + ', ' + this._x1 + ', ' + this._y1 + ', ' + this._stops + ', ' + this._colors_1 + ')';
    } else if (tmp0_subject.equals(GradientKind_RADIAL_getInstance())) {
      tmp = '' + 'RadialGradient(' + this._x0 + ', ' + this._y0 + ', ' + this._r0_1 + ', ' + this._x1 + ', ' + this._y1 + ', ' + this._r1 + ', ' + this._stops + ', ' + this._colors_1 + ')';
    } else if (tmp0_subject.equals(GradientKind_SWEEP_getInstance())) {
      tmp = '' + 'SweepGradient(' + this._x0 + ', ' + this._y0 + ', ' + this._stops + ', ' + this._colors_1 + ')';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  GradientPaint.prototype.hashCode = function () {
    var result = this._kind_0.hashCode();
    result = imul(result, 31) + getNumberHashCode(this._x0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._r0_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._x1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._r1) | 0;
    result = imul(result, 31) + this._stops.hashCode() | 0;
    result = imul(result, 31) + this._colors_1.hashCode() | 0;
    result = imul(result, 31) + this._cycle.hashCode() | 0;
    result = imul(result, 31) + this._transform_3.hashCode() | 0;
    result = imul(result, 31) + this._interpolationMethod.hashCode() | 0;
    result = imul(result, 31) + this._units.hashCode() | 0;
    return result;
  };
  GradientPaint.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this._kind_0.equals(tmp0_other_with_cast._kind_0))
      return false;
    if (!equals_1(this._x0, tmp0_other_with_cast._x0))
      return false;
    if (!equals_1(this._y0, tmp0_other_with_cast._y0))
      return false;
    if (!equals_1(this._r0_1, tmp0_other_with_cast._r0_1))
      return false;
    if (!equals_1(this._x1, tmp0_other_with_cast._x1))
      return false;
    if (!equals_1(this._y1, tmp0_other_with_cast._y1))
      return false;
    if (!equals_1(this._r1, tmp0_other_with_cast._r1))
      return false;
    if (!this._stops.equals(tmp0_other_with_cast._stops))
      return false;
    if (!this._colors_1.equals(tmp0_other_with_cast._colors_1))
      return false;
    if (!this._cycle.equals(tmp0_other_with_cast._cycle))
      return false;
    if (!this._transform_3.equals(tmp0_other_with_cast._transform_3))
      return false;
    if (!this._interpolationMethod.equals(tmp0_other_with_cast._interpolationMethod))
      return false;
    if (!this._units.equals(tmp0_other_with_cast._units))
      return false;
    return true;
  };
  GradientPaint.$metadata$ = {
    simpleName: 'GradientPaint',
    kind: 'class',
    interfaces: [TransformedPaint]
  };
  function BitmapPaint_init_$Init$(bitmap, transform, cycleX, cycleY, smooth, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      cycleX = CycleMethod_NO_CYCLE_getInstance();
    if (!(($mask0 & 8) === 0))
      cycleY = CycleMethod_NO_CYCLE_getInstance();
    if (!(($mask0 & 16) === 0))
      smooth = true;
    BitmapPaint.call($this, bitmap, transform, cycleX, cycleY, smooth);
    return $this;
  }
  function BitmapPaint_init_$Create$(bitmap, transform, cycleX, cycleY, smooth, $mask0, $marker) {
    return BitmapPaint_init_$Init$(bitmap, transform, cycleX, cycleY, smooth, $mask0, $marker, Object.create(BitmapPaint.prototype));
  }
  function BitmapPaint(bitmap, transform, cycleX, cycleY, smooth) {
    this._bitmap_3 = bitmap;
    this._transform_4 = transform;
    this._cycleX_0 = cycleX;
    this._cycleY_0 = cycleY;
    this._smooth = smooth;
    this._bmp32 = this._bitmap_3.toBMP32_0_k$();
  }
  BitmapPaint.prototype._get_transform__0_k$ = function () {
    return this._transform_4;
  };
  BitmapPaint.prototype._get_repeatX__0_k$ = function () {
    return this._cycleX_0._get_repeating__0_k$();
  };
  BitmapPaint.prototype._get_repeatY__0_k$ = function () {
    return this._cycleY_0._get_repeating__0_k$();
  };
  BitmapPaint.prototype.transformed_lwp7hs_k$ = function (m) {
    var tmp = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null).multiply_yv84xs_k$(m, this._transform_4);
    return BitmapPaint_init_$Create$(this._bitmap_3, tmp, null, null, false, 28, null);
  };
  BitmapPaint.$metadata$ = {
    simpleName: 'BitmapPaint',
    kind: 'class',
    interfaces: [TransformedPaint]
  };
  var GradientKind_LINEAR_instance;
  var GradientKind_RADIAL_instance;
  var GradientKind_SWEEP_instance;
  var GradientKind_entriesInitialized;
  function GradientKind_initEntries() {
    if (GradientKind_entriesInitialized)
      return Unit_getInstance();
    GradientKind_entriesInitialized = true;
    GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
    GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
    GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
  }
  function GradientKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  GradientKind.$metadata$ = {
    simpleName: 'GradientKind',
    kind: 'class',
    interfaces: []
  };
  function TransformedPaint() {
  }
  TransformedPaint.$metadata$ = {
    simpleName: 'TransformedPaint',
    kind: 'interface',
    interfaces: [Paint]
  };
  var GradientInterpolationMethod_LINEAR_instance;
  var GradientInterpolationMethod_NORMAL_instance;
  var GradientInterpolationMethod_entriesInitialized;
  function GradientInterpolationMethod_initEntries() {
    if (GradientInterpolationMethod_entriesInitialized)
      return Unit_getInstance();
    GradientInterpolationMethod_entriesInitialized = true;
    GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
    GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
  }
  function GradientInterpolationMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  GradientInterpolationMethod.$metadata$ = {
    simpleName: 'GradientInterpolationMethod',
    kind: 'class',
    interfaces: []
  };
  var GradientUnits_USER_SPACE_ON_USE_instance;
  var GradientUnits_OBJECT_BOUNDING_BOX_instance;
  var GradientUnits_entriesInitialized;
  function GradientUnits_initEntries() {
    if (GradientUnits_entriesInitialized)
      return Unit_getInstance();
    GradientUnits_entriesInitialized = true;
    GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
    GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
  }
  function GradientUnits(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  GradientUnits.$metadata$ = {
    simpleName: 'GradientUnits',
    kind: 'class',
    interfaces: []
  };
  function GradientKind_LINEAR_getInstance() {
    GradientKind_initEntries();
    return GradientKind_LINEAR_instance;
  }
  function GradientKind_RADIAL_getInstance() {
    GradientKind_initEntries();
    return GradientKind_RADIAL_instance;
  }
  function GradientKind_SWEEP_getInstance() {
    GradientKind_initEntries();
    return GradientKind_SWEEP_instance;
  }
  function GradientInterpolationMethod_NORMAL_getInstance() {
    GradientInterpolationMethod_initEntries();
    return GradientInterpolationMethod_NORMAL_instance;
  }
  function GradientUnits_USER_SPACE_ON_USE_getInstance() {
    GradientUnits_initEntries();
    return GradientUnits_USER_SPACE_ON_USE_instance;
  }
  function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
    GradientUnits_initEntries();
    return GradientUnits_OBJECT_BOUNDING_BOX_instance;
  }
  function _VerticalAlign___init__impl_(ratio) {
    return ratio;
  }
  function _VerticalAlign___get_ratio__impl_(this_0) {
    return this_0;
  }
  function _VerticalAlign___get_ratioFake__impl_(this_0) {
    return equals_1(new VerticalAlign(this_0), new VerticalAlign(Companion_getInstance_151()._BASELINE)) ? 1.0 : _VerticalAlign___get_ratio__impl_(this_0);
  }
  function Companion_152() {
    Companion_instance_151 = this;
    this._TOP = _VerticalAlign___init__impl_(0.0);
    this._MIDDLE = _VerticalAlign___init__impl_(0.5);
    this._BOTTOM = _VerticalAlign___init__impl_(1.0);
    var tmp = this;
    DoubleCompanionObject_getInstance();
    tmp._BASELINE = _VerticalAlign___init__impl_(Infinity);
    var tmp_0 = this;
    var tmp0_arrayOf_0 = [new VerticalAlign(this._TOP), new VerticalAlign(this._MIDDLE), new VerticalAlign(this._BASELINE), new VerticalAlign(this._BOTTOM)];
    tmp_0._values_0 = tmp0_arrayOf_0;
  }
  Companion_152.prototype.invoke_dd2oxv_k$ = function (str) {
    var tmp0_subject = str;
    var tmp;
    switch (tmp0_subject) {
      case 'TOP':
        tmp = this._TOP;
        break;
      case 'MIDDLE':
        tmp = this._MIDDLE;
        break;
      case 'BOTTOM':
        tmp = this._BOTTOM;
        break;
      case 'BASELINE':
        tmp = this._BASELINE;
        break;
      default:var tmp_0 = new Char(40);
        var tmp_1 = substringAfter$default(str, tmp_0, null, 2, null);
        var tmp_2 = new Char(41);
        var tmp1_elvis_lhs = toDoubleOrNull(substringBefore$default(tmp_1, tmp_2, null, 2, null));
        tmp = _VerticalAlign___init__impl_(tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs);
        break;
    }
    return tmp;
  };
  Companion_152.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_151;
  function Companion_getInstance_151() {
    if (Companion_instance_151 == null)
      new Companion_152();
    return Companion_instance_151;
  }
  function VerticalAlign__getOffsetY_impl(this_0, height, baseline) {
    var tmp0_subject = this_0;
    return equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_151()._BASELINE)) ? baseline : -height * _VerticalAlign___get_ratio__impl_(this_0);
  }
  function VerticalAlign__toString_impl(this_0) {
    var tmp0_subject = this_0;
    return equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_151()._TOP)) ? 'TOP' : equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_151()._MIDDLE)) ? 'MIDDLE' : equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_151()._BOTTOM)) ? 'BOTTOM' : equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_151()._BASELINE)) ? 'BASELINE' : '' + 'VerticalAlign(' + _VerticalAlign___get_ratio__impl_(this_0) + ')';
  }
  function VerticalAlign__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function VerticalAlign__equals_impl(this_0, other) {
    if (!(other instanceof VerticalAlign))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VerticalAlign ? other._ratio : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function VerticalAlign(ratio) {
    Companion_getInstance_151();
    this._ratio = ratio;
  }
  VerticalAlign.prototype.toString = function () {
    return VerticalAlign__toString_impl(this._ratio);
  };
  VerticalAlign.prototype.hashCode = function () {
    return VerticalAlign__hashCode_impl(this._ratio);
  };
  VerticalAlign.prototype.equals = function (other) {
    return VerticalAlign__equals_impl(this._ratio, other);
  };
  VerticalAlign.$metadata$ = {
    simpleName: 'VerticalAlign',
    kind: 'class',
    interfaces: []
  };
  function _HorizontalAlign___init__impl_(ratio) {
    return ratio;
  }
  function _HorizontalAlign___get_ratio__impl_(this_0) {
    return this_0;
  }
  function _HorizontalAlign___get_ratioFake__impl_(this_0) {
    return equals_1(new HorizontalAlign(this_0), new HorizontalAlign(Companion_getInstance_152()._JUSTIFY)) ? 0.0 : _HorizontalAlign___get_ratio__impl_(this_0);
  }
  function Companion_153() {
    Companion_instance_152 = this;
    this._JUSTIFY = _HorizontalAlign___init__impl_(-1.0E-5);
    this._LEFT = _HorizontalAlign___init__impl_(0.0);
    this._CENTER = _HorizontalAlign___init__impl_(0.5);
    this._RIGHT = _HorizontalAlign___init__impl_(1.0);
    var tmp = this;
    var tmp0_arrayOf_0 = [new HorizontalAlign(this._LEFT), new HorizontalAlign(this._CENTER), new HorizontalAlign(this._RIGHT), new HorizontalAlign(this._JUSTIFY)];
    tmp._values_1 = tmp0_arrayOf_0;
  }
  Companion_153.prototype.invoke_zfvmlt_k$ = function (str) {
    var tmp0_subject = str;
    var tmp;
    switch (tmp0_subject) {
      case 'LEFT':
        tmp = this._LEFT;
        break;
      case 'CENTER':
        tmp = this._CENTER;
        break;
      case 'RIGHT':
        tmp = this._RIGHT;
        break;
      case 'JUSTIFY':
        tmp = this._JUSTIFY;
        break;
      default:var tmp_0 = new Char(40);
        var tmp_1 = substringAfter$default(str, tmp_0, null, 2, null);
        var tmp_2 = new Char(41);
        var tmp1_elvis_lhs = toDoubleOrNull(substringBefore$default(tmp_1, tmp_2, null, 2, null));
        tmp = _HorizontalAlign___init__impl_(tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs);
        break;
    }
    return tmp;
  };
  Companion_153.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_152;
  function Companion_getInstance_152() {
    if (Companion_instance_152 == null)
      new Companion_153();
    return Companion_instance_152;
  }
  function HorizontalAlign__getOffsetX_impl(this_0, width) {
    var tmp0_subject = this_0;
    return equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_152()._JUSTIFY)) ? 0.0 : width * _HorizontalAlign___get_ratio__impl_(this_0);
  }
  function HorizontalAlign__toString_impl(this_0) {
    var tmp0_subject = this_0;
    return equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_152()._LEFT)) ? 'LEFT' : equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_152()._CENTER)) ? 'CENTER' : equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_152()._RIGHT)) ? 'RIGHT' : equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_152()._JUSTIFY)) ? 'JUSTIFY' : '' + 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl_(this_0) + ')';
  }
  function HorizontalAlign__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function HorizontalAlign__equals_impl(this_0, other) {
    if (!(other instanceof HorizontalAlign))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HorizontalAlign ? other._ratio_0 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function HorizontalAlign(ratio) {
    Companion_getInstance_152();
    this._ratio_0 = ratio;
  }
  HorizontalAlign.prototype.toString = function () {
    return HorizontalAlign__toString_impl(this._ratio_0);
  };
  HorizontalAlign.prototype.hashCode = function () {
    return HorizontalAlign__hashCode_impl(this._ratio_0);
  };
  HorizontalAlign.prototype.equals = function (other) {
    return HorizontalAlign__equals_impl(this._ratio_0, other);
  };
  HorizontalAlign.$metadata$ = {
    simpleName: 'HorizontalAlign',
    kind: 'class',
    interfaces: []
  };
  function Companion_154() {
    Companion_instance_153 = this;
    this._horizontals = listOf([new HorizontalAlign(Companion_getInstance_152()._LEFT), new HorizontalAlign(Companion_getInstance_152()._CENTER), new HorizontalAlign(Companion_getInstance_152()._RIGHT), new HorizontalAlign(Companion_getInstance_152()._JUSTIFY)]);
    var tmp = this;
    var tmp0_map_0 = this._horizontals;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$()._ratio_0;
      tmp0_mapTo_0_1.add_2bq_k$(new TextAlignment(item_2_3, Companion_getInstance_151()._TOP));
      Unit_getInstance();
    }
    tmp._TOP_0 = tmp0_mapTo_0_1;
    var tmp_0 = this;
    var tmp0_map_0_0 = this._horizontals;
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_0, 10));
    var tmp0_iterator_1_2_0 = tmp0_map_0_0.iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var item_2_3_0 = tmp0_iterator_1_2_0.next_0_k$()._ratio_0;
      tmp0_mapTo_0_1_0.add_2bq_k$(new TextAlignment(item_2_3_0, Companion_getInstance_151()._BASELINE));
      Unit_getInstance();
    }
    tmp_0._BASELINE_0 = tmp0_mapTo_0_1_0;
    var tmp_1 = this;
    var tmp0_map_0_1 = this._horizontals;
    var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_1, 10));
    var tmp0_iterator_1_2_1 = tmp0_map_0_1.iterator_0_k$();
    while (tmp0_iterator_1_2_1.hasNext_0_k$()) {
      var item_2_3_1 = tmp0_iterator_1_2_1.next_0_k$()._ratio_0;
      tmp0_mapTo_0_1_1.add_2bq_k$(new TextAlignment(item_2_3_1, Companion_getInstance_151()._MIDDLE));
      Unit_getInstance();
    }
    tmp_1._MIDDLE_0 = tmp0_mapTo_0_1_1;
    var tmp_2 = this;
    var tmp0_map_0_2 = this._horizontals;
    var tmp0_mapTo_0_1_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_2, 10));
    var tmp0_iterator_1_2_2 = tmp0_map_0_2.iterator_0_k$();
    while (tmp0_iterator_1_2_2.hasNext_0_k$()) {
      var item_2_3_2 = tmp0_iterator_1_2_2.next_0_k$()._ratio_0;
      tmp0_mapTo_0_1_2.add_2bq_k$(new TextAlignment(item_2_3_2, Companion_getInstance_151()._BOTTOM));
      Unit_getInstance();
    }
    tmp_2._BOTTOM_0 = tmp0_mapTo_0_1_2;
    this._TOP_LEFT_0 = this._TOP_0.get_ha5a7z_k$(0);
    this._TOP_CENTER_0 = this._TOP_0.get_ha5a7z_k$(1);
    this._TOP_RIGHT_0 = this._TOP_0.get_ha5a7z_k$(2);
    this._TOP_JUSTIFIED = this._TOP_0.get_ha5a7z_k$(3);
    this._BASELINE_LEFT = this._BASELINE_0.get_ha5a7z_k$(0);
    this._BASELINE_CENTER = this._BASELINE_0.get_ha5a7z_k$(1);
    this._BASELINE_RIGHT = this._BASELINE_0.get_ha5a7z_k$(2);
    this._BASELINE_JUSTIFIED = this._BASELINE_0.get_ha5a7z_k$(3);
    this._LEFT_0 = this._TOP_0.get_ha5a7z_k$(0);
    this._CENTER_0 = this._TOP_0.get_ha5a7z_k$(1);
    this._RIGHT_0 = this._TOP_0.get_ha5a7z_k$(2);
    this._JUSTIFIED = this._TOP_0.get_ha5a7z_k$(3);
    this._MIDDLE_LEFT_0 = this._MIDDLE_0.get_ha5a7z_k$(0);
    this._MIDDLE_CENTER_0 = this._MIDDLE_0.get_ha5a7z_k$(1);
    this._MIDDLE_RIGHT_0 = this._MIDDLE_0.get_ha5a7z_k$(2);
    this._MIDDLE_JUSTIFIED = this._MIDDLE_0.get_ha5a7z_k$(3);
    this._BOTTOM_LEFT_0 = this._BOTTOM_0.get_ha5a7z_k$(0);
    this._BOTTOM_CENTER_0 = this._BOTTOM_0.get_ha5a7z_k$(1);
    this._BOTTOM_RIGHT_0 = this._BOTTOM_0.get_ha5a7z_k$(2);
    this._BOTTOM_JUSTIFIED = this._BOTTOM_0.get_ha5a7z_k$(3);
  }
  Companion_154.prototype.fromAlign_ll9jos_k$ = function (horizontal, vertical) {
    var tmp0_subject = horizontal;
    var tmp;
    if (equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_152()._LEFT))) {
      tmp = 0;
    } else if (equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_152()._CENTER))) {
      tmp = 1;
    } else if (equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_152()._RIGHT))) {
      tmp = 2;
    } else if (equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_152()._JUSTIFY))) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    var tmp1_subject = vertical;
    return equals_1(new VerticalAlign(tmp1_subject), new VerticalAlign(Companion_getInstance_151()._TOP)) ? this._TOP_0.get_ha5a7z_k$(horizontalIndex) : equals_1(new VerticalAlign(tmp1_subject), new VerticalAlign(Companion_getInstance_151()._BASELINE)) ? this._BASELINE_0.get_ha5a7z_k$(horizontalIndex) : equals_1(new VerticalAlign(tmp1_subject), new VerticalAlign(Companion_getInstance_151()._MIDDLE)) ? this._MIDDLE_0.get_ha5a7z_k$(horizontalIndex) : equals_1(new VerticalAlign(tmp1_subject), new VerticalAlign(Companion_getInstance_151()._BOTTOM)) ? this._BOTTOM_0.get_ha5a7z_k$(horizontalIndex) : new TextAlignment(horizontal, vertical);
  };
  Companion_154.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_153;
  function Companion_getInstance_153() {
    if (Companion_instance_153 == null)
      new Companion_154();
    return Companion_instance_153;
  }
  function TextAlignment(horizontal, vertical) {
    Companion_getInstance_153();
    this._horizontal = horizontal;
    this._vertical = vertical;
    this._anchor = new Anchor(_HorizontalAlign___get_ratioFake__impl_(this._horizontal), _VerticalAlign___get_ratioFake__impl_(this._vertical));
  }
  TextAlignment.prototype.withHorizontal_l3qhhv_k$ = function (horizontal) {
    return Companion_getInstance_153().fromAlign_ll9jos_k$(horizontal, this._vertical);
  };
  TextAlignment.prototype.withVertical_gepp4v_k$ = function (vertical) {
    return Companion_getInstance_153().fromAlign_ll9jos_k$(this._horizontal, vertical);
  };
  TextAlignment.prototype.toString = function () {
    return '' + 'TextAlignment(horizontal=' + new HorizontalAlign(this._horizontal) + ', vertical=' + new VerticalAlign(this._vertical) + ')';
  };
  TextAlignment.prototype.hashCode = function () {
    var result = HorizontalAlign__hashCode_impl(this._horizontal);
    result = imul(result, 31) + VerticalAlign__hashCode_impl(this._vertical) | 0;
    return result;
  };
  TextAlignment.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals_1(new HorizontalAlign(this._horizontal), new HorizontalAlign(tmp0_other_with_cast._horizontal)))
      return false;
    if (!equals_1(new VerticalAlign(this._vertical), new VerticalAlign(tmp0_other_with_cast._vertical)))
      return false;
    return true;
  };
  TextAlignment.$metadata$ = {
    simpleName: 'TextAlignment',
    kind: 'class',
    interfaces: []
  };
  var DefaultStringTextRenderer;
  function TextRenderer() {
  }
  TextRenderer.prototype._get_version__0_k$ = function () {
    return 0;
  };
  TextRenderer.prototype.invoke_q7g7zr_k$ = function (actions, text, size_2, defaultFont) {
    this.run_61lj1l_k$(actions, text, size_2, defaultFont);
    Unit_getInstance();
  };
  TextRenderer.$metadata$ = {
    simpleName: 'TextRenderer',
    kind: 'interface',
    interfaces: []
  };
  function CreateStringTextRenderer(getVersion, handler) {
    return new _no_name_provided__275(getVersion, handler);
  }
  function CreateStringTextRenderer$default(getVersion, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      getVersion = _no_name_provided_$factory_225();
    }return CreateStringTextRenderer(getVersion, handler);
  }
  function TextRendererActions() {
    var tmp = this;
    tmp._glyphPath = GlyphPath_init_$Create$(null, null, null, null, null, null, 0.0, 127, null);
    var tmp_0 = this;
    tmp_0._glyphMetrics = GlyphMetrics_init_$Create$(0.0, false, 0, null, 0.0, 31, null);
    var tmp_1 = this;
    tmp_1._fontMetrics_0 = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    this._fontSize_1 = 0.0;
    this._x_14 = 0.0;
    this._y_13 = 0.0;
    var tmp_2 = this;
    tmp_2._transform_5 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._paint = null;
    this._tint = Colors_getInstance()._WHITE_0;
  }
  TextRendererActions.prototype._get_glyphMetrics__0_k$ = function () {
    return this._glyphMetrics;
  };
  TextRendererActions.prototype._get_lineHeight__0_k$ = function () {
    return this._fontMetrics_0._get_lineHeight__0_k$();
  };
  TextRendererActions.prototype._get_font__0_k$ = function () {
    var tmp = this._font;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  };
  TextRendererActions.prototype._get_fontSize__0_k$ = function () {
    return this._fontSize_1;
  };
  TextRendererActions.prototype.setFont_ofslah_k$ = function (font, size_2) {
    this._font = font;
    this._fontSize_1 = size_2;
    font.getFontMetrics_sqtkiv_k$(size_2, this._fontMetrics_0);
    Unit_getInstance();
  };
  TextRendererActions.prototype._set_x__okcceq_k$ = function (_set___) {
    this._x_14 = _set___;
  };
  TextRendererActions.prototype._get_x__0_k$ = function () {
    return this._x_14;
  };
  TextRendererActions.prototype._set_y__okcceq_k$ = function (_set___) {
    this._y_13 = _set___;
  };
  TextRendererActions.prototype._get_y__0_k$ = function () {
    return this._y_13;
  };
  TextRendererActions.prototype.reset_sv8swh_k$ = function () {
    this._x_14 = 0.0;
    this._y_13 = 0.0;
  };
  TextRendererActions.prototype.getGlyphMetrics_ha5a7z_k$ = function (codePoint) {
    return this._get_font__0_k$().getGlyphMetrics_xejy1t_k$(this._fontSize_1, codePoint, this._glyphMetrics);
  };
  TextRendererActions.prototype._get_transform__0_k$ = function () {
    return this._transform_5;
  };
  TextRendererActions.prototype._get_paint__0_k$ = function () {
    return this._paint;
  };
  TextRendererActions.prototype.getKerning_27zxwg_k$ = function (leftCodePoint, rightCodePoint) {
    return this._get_font__0_k$().getKerning_jw27q7_k$(this._fontSize_1, leftCodePoint, rightCodePoint);
  };
  TextRendererActions.prototype.advance_okcceq_k$ = function (x) {
    var tmp0_this = this;
    tmp0_this._x_14 = tmp0_this._x_14 + x;
  };
  TextRendererActions.prototype.newLine_okcceq_k$ = function (y) {
    this._x_14 = 0.0;
    var tmp0_this = this;
    tmp0_this._y_13 = tmp0_this._y_13 + y;
  };
  TextRendererActions.$metadata$ = {
    simpleName: 'TextRendererActions',
    kind: 'class',
    interfaces: []
  };
  function add_1($this, x, y) {
    var rx = $this._get_x__0_k$() + $this._get_transform__0_k$().transformX_ngl742_k$(x, y);
    var ry = $this._get_y__0_k$() + $this._get_transform__0_k$().transformY_ngl742_k$(x, y);
    $this._bb.add_ngl742_k$(rx, ry);
    Unit_getInstance();
    if ($this._currentLine === 0) {
      $this._flbb.add_ngl742_k$(rx, ry);
      Unit_getInstance();
    }}
  function add_2($this, rect_3) {
    var fx = rect_3._get_left__0_k$();
    var fy = rect_3._get_top__0_k$();
    var w = rect_3._width_0;
    var h = rect_3._height_0;
    add_1($this, fx, fy);
    add_1($this, fx + w, fy);
    add_1($this, fx + w, fy + h);
    add_1($this, fx, fy + h);
  }
  function BoundBuilderTextRendererActions() {
    TextRendererActions.call(this);
    this._flbb = new BoundsBuilder();
    this._bb = new BoundsBuilder();
    this._currentLine = 0;
  }
  BoundBuilderTextRendererActions.prototype._get_nlines__0_k$ = function () {
    return this._currentLine + 1 | 0;
  };
  BoundBuilderTextRendererActions.prototype.reset_sv8swh_k$ = function () {
    TextRendererActions.prototype.reset_sv8swh_k$.call(this);
    this._currentLine = 0;
    this._bb.reset_sv8swh_k$();
    this._flbb.reset_sv8swh_k$();
  };
  BoundBuilderTextRendererActions.prototype.put_ha5a7z_k$ = function (codePoint) {
    var g = this.getGlyphMetrics_ha5a7z_k$(codePoint);
    add_2(this, g._bounds_1);
    return g;
  };
  BoundBuilderTextRendererActions.prototype.newLine_okcceq_k$ = function (y) {
    TextRendererActions.prototype.newLine_okcceq_k$.call(this, y);
    var tmp0_this = this;
    var tmp1 = tmp0_this._currentLine;
    tmp0_this._currentLine = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  BoundBuilderTextRendererActions.$metadata$ = {
    simpleName: 'BoundBuilderTextRendererActions',
    kind: 'class',
    interfaces: []
  };
  function Entry_init_$Init$(tex, x, y, sx, sy, rot, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      var tmp0__get_transparent__0 = Bitmaps_getInstance();
      tex = Bitmaps_transparent;
    }if (!(($mask0 & 2) === 0))
      x = 0.0;
    if (!(($mask0 & 4) === 0))
      y = 0.0;
    if (!(($mask0 & 8) === 0))
      sx = 1.0;
    if (!(($mask0 & 16) === 0))
      sy = 1.0;
    if (!(($mask0 & 32) === 0))
      rot = _get_radians__0(0);
    Entry_2.call($this, tex, x, y, sx, sy, rot);
    return $this;
  }
  function Entry_init_$Create$(tex, x, y, sx, sy, rot, $mask0, $marker) {
    return Entry_init_$Init$(tex, x, y, sx, sy, rot, $mask0, $marker, Object.create(Entry_2.prototype));
  }
  function Entry_2(tex, x, y, sx, sy, rot) {
    this._tex = tex;
    this._x_15 = x;
    this._y_14 = y;
    this._sx_0 = sx;
    this._sy_0 = sy;
    this._rot = rot;
  }
  Entry_2.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_uch40_k$('Entry(');
    Unit_getInstance();
    tmp0_apply_0_1.append_uch40_k$('' + "'" + this._tex._name_12 + "', " + numberToInt(this._x_15) + ', ' + numberToInt(this._y_14) + ', ' + this._tex._get_width__0_k$() + ', ' + this._tex._get_height__0_k$());
    Unit_getInstance();
    if (!(this._sx_0 === 1.0)) {
      tmp0_apply_0_1.append_uch40_k$('' + ', ' + _get_niceStr__3(this._sx_0));
      Unit_getInstance();
    }if (!(this._sy_0 === 1.0)) {
      tmp0_apply_0_1.append_uch40_k$('' + ', ' + _get_niceStr__3(this._sy_0));
      Unit_getInstance();
    }if (!equals_1(new Angle(this._rot), new Angle(_get_radians__0(0)))) {
      tmp0_apply_0_1.append_uch40_k$('' + ', ' + _get_niceStr__3(_get_degrees_(this._rot)));
      Unit_getInstance();
    }tmp0_apply_0_1.append_uch40_k$(')');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  Entry_2.prototype.hashCode = function () {
    var result = hashCode(this._tex);
    result = imul(result, 31) + getNumberHashCode(this._x_15) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y_14) | 0;
    result = imul(result, 31) + getNumberHashCode(this._sx_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._sy_0) | 0;
    result = imul(result, 31) + Angle__hashCode_impl(this._rot) | 0;
    return result;
  };
  Entry_2.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_2))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Entry_2 ? other : THROW_CCE();
    if (!equals_1(this._tex, tmp0_other_with_cast._tex))
      return false;
    if (!equals_1(this._x_15, tmp0_other_with_cast._x_15))
      return false;
    if (!equals_1(this._y_14, tmp0_other_with_cast._y_14))
      return false;
    if (!equals_1(this._sx_0, tmp0_other_with_cast._sx_0))
      return false;
    if (!equals_1(this._sy_0, tmp0_other_with_cast._sy_0))
      return false;
    if (!equals_1(new Angle(this._rot), new Angle(tmp0_other_with_cast._rot)))
      return false;
    return true;
  };
  Entry_2.$metadata$ = {
    simpleName: 'Entry',
    kind: 'class',
    interfaces: []
  };
  function Text2TextRendererActions() {
    TextRendererActions.call(this);
    this._verticalAlign = Companion_getInstance_151()._TOP;
    this._horizontalAlign = Companion_getInstance_152()._LEFT;
    var tmp = this;
    tmp._arrayTex = ArrayList_init_$Create$();
    this._arrayX = doubleArrayListOf(new Float64Array([]));
    this._arrayY = doubleArrayListOf(new Float64Array([]));
    this._arraySX = doubleArrayListOf(new Float64Array([]));
    this._arraySY = doubleArrayListOf(new Float64Array([]));
    this._arrayRot = doubleArrayListOf(new Float64Array([]));
    var tmp_0 = this;
    tmp_0._tr_0 = Transform_init_$Create$(0.0, 0.0, 0.0, 0.0, null, null, null, 127, null);
  }
  Text2TextRendererActions.prototype._get_size__0_k$ = function () {
    return this._arrayX._get_size__0_k$();
  };
  Text2TextRendererActions.prototype.read_g732d_k$ = function (n, out) {
    out._tex = this._arrayTex.get_ha5a7z_k$(n);
    out._x_15 = this._arrayX.get_ha5a7z_k$(n);
    out._y_14 = this._arrayY.get_ha5a7z_k$(n);
    out._sx_0 = this._arraySX.get_ha5a7z_k$(n);
    out._sy_0 = this._arraySY.get_ha5a7z_k$(n);
    out._rot = _get_radians_(this._arrayRot.get_ha5a7z_k$(n));
    return out;
  };
  Text2TextRendererActions.prototype.mreset_sv8swh_k$ = function () {
    this._arrayTex.clear_sv8swh_k$();
    this._arrayX.clear_sv8swh_k$();
    this._arrayY.clear_sv8swh_k$();
    this._arraySX.clear_sv8swh_k$();
    this._arraySY.clear_sv8swh_k$();
    this._arrayRot.clear_sv8swh_k$();
  };
  Text2TextRendererActions.prototype.put_ha5a7z_k$ = function (codePoint) {
    var tmp = this._get_font__0_k$();
    var bf = tmp instanceof BitmapFont ? tmp : THROW_CCE();
    var m = this.getGlyphMetrics_ha5a7z_k$(codePoint);
    var g = bf.get_ha5a7z_k$(codePoint);
    var x = g._xoffset;
    var tmp_0 = g._yoffset;
    var tmp0_subject = this._verticalAlign;
    var y = tmp_0 - (equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_151()._BASELINE)) ? bf._base_4 : bf._lineHeight * _VerticalAlign___get_ratio__impl_(this._verticalAlign));
    var fontScale = this._get_fontSize__0_k$() / bf._fontSize_0;
    this._tr_0.setMatrixNoReturn_skjkkf_k$(this._get_transform__0_k$());
    this._arrayTex.add_2bq_k$(g._texture_0);
    Unit_getInstance();
    this._arrayX.add_okcceq_k$(this._get_x__0_k$() + this._get_transform__0_k$().transformX_ngl742_k$(x, y) * fontScale);
    this._arrayY.add_okcceq_k$(this._get_y__0_k$() + this._get_transform__0_k$().transformY_ngl742_k$(x, y) * fontScale);
    this._arraySX.add_okcceq_k$(this._tr_0._scaleX * fontScale);
    this._arraySY.add_okcceq_k$(this._tr_0._scaleY * fontScale);
    this._arrayRot.add_okcceq_k$(_Angle___get_radians__impl_(this._tr_0._rotation));
    return m;
  };
  Text2TextRendererActions.$metadata$ = {
    simpleName: 'Text2TextRendererActions',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__273() {
  }
  _no_name_provided__273.prototype.invoke_vzf3w2_k$ = function ($this$CreateStringTextRenderer, text, n, c, c1, g, advance) {
    $this$CreateStringTextRenderer.put_ha5a7z_k$(c);
    Unit_getInstance();
    $this$CreateStringTextRenderer.advance_okcceq_k$(advance);
  };
  _no_name_provided__273.prototype.invoke_c5yqhv_k$ = function (p1, p2, p3, p4, p5, p6, p7) {
    var tmp = p1 instanceof TextRendererActions ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    var tmp_3 = (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE();
    var tmp_4 = p6 instanceof GlyphMetrics ? p6 : THROW_CCE();
    this.invoke_vzf3w2_k$(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, (!(p7 == null) ? typeof p7 === 'number' : false) ? p7 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__273.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__274() {
  }
  _no_name_provided__274.prototype.invoke_0_k$ = function () {
    return 0;
  };
  _no_name_provided__274.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function runStep(_this_, $this, n, c, c1, text) {
    if (c === 10) {
      _this_.newLine_okcceq_k$(_this_._get_lineHeight__0_k$());
    } else {
      var g = _this_.getGlyphMetrics_ha5a7z_k$(c);
      _this_._transform_5.identity_0_k$();
      Unit_getInstance();
      $this._$handler(_this_, text, n, c, c1, g, g._xadvance_0 + _this_.getKerning_27zxwg_k$(c, c1));
    }
  }
  function _no_name_provided__275($getVersion, $handler) {
    this._$getVersion = $getVersion;
    this._$handler = $handler;
  }
  _no_name_provided__275.prototype._get_version__0_k$ = function () {
    return this._$getVersion();
  };
  _no_name_provided__275.prototype.run_71rudb_k$ = function (_this__0, text, size_2, defaultFont) {
    _this__0.reset_sv8swh_k$();
    _this__0.setFont_ofslah_k$(defaultFont, size_2);
    var lastCodePoint = -1;
    var string_1 = text;
    var m_2 = 0;
    var n_3 = 0;
    while (n_3 < string_1.length) {
      var tmp0_6 = n_3;
      n_3 = tmp0_6 + 1 | 0;
      var tmp0__get_code__0_5 = charSequenceGet(string_1, tmp0_6);
      var value_4 = tmp0__get_code__0_5.toInt_0_k$();
      var error_7 = false;
      if ((value_4 & 63488) === 55296) {
        var tmp1_10 = n_3;
        n_3 = tmp1_10 + 1 | 0;
        var tmp1__get_code__0_9 = charSequenceGet(string_1, tmp1_10);
        var extra_8 = tmp1__get_code__0_9.toInt_0_k$();
        if (!((extra_8 & 64512) === 56320)) {
          var tmp2_11 = n_3;
          n_3 = tmp2_11 - 1 | 0;
          Unit_getInstance();
          error_7 = true;
        } else {
          var dataHigh_12 = value_4 & 1023;
          var dataLow_13 = extra_8 & 1023;
          value_4 = (dataLow_13 | dataHigh_12 << 10) + 65536 | 0;
        }
      }var tmp3_14 = m_2;
      m_2 = tmp3_14 + 1 | 0;
      var tmp0__anonymous__15 = tmp3_14;
      var tmp1__anonymous__15 = value_4;
      var tmp2__anonymous__15 = error_7;
      if (tmp0__anonymous__15 > 0) {
        runStep(_this__0, this, tmp0__anonymous__15 - 1 | 0, lastCodePoint, tmp1__anonymous__15, text);
      }lastCodePoint = tmp1__anonymous__15;
    }
    var length = m_2;
    runStep(_this__0, this, length - 1 | 0, lastCodePoint, 0, text);
  };
  _no_name_provided__275.prototype.run_61lj1l_k$ = function (_this__0, text, size_2, defaultFont) {
    return this.run_71rudb_k$(_this__0, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size_2, defaultFont);
  };
  _no_name_provided__275.$metadata$ = {
    kind: 'class',
    interfaces: [TextRenderer]
  };
  function _no_name_provided_$factory_224() {
    var i = new _no_name_provided__273();
    return function (p1, p2, p3, p4, p5, p6, p7) {
      i.invoke_vzf3w2_k$(p1, p2, p3, p4, p5, p6, p7);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_225() {
    var i = new _no_name_provided__274();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function overlaps($this, a0, a1, b0, b1) {
    var min_0 = Math.min(a0, a0);
    var max = Math.max(a1, a1);
    var maxMinor = Math.max(a0, b0);
    var minMajor = Math.min(a1, b1);
    return (min_0 <= maxMinor ? maxMinor <= max : false) ? true : min_0 <= minMajor ? minMajor <= max : false;
  }
  function SegmentHandler() {
    this._xmin_0 = intArrayListOf(new Int32Array([]));
    this._xmax_0 = intArrayListOf(new Int32Array([]));
    this.reset_sv8swh_k$();
  }
  SegmentHandler.prototype._get_size__0_k$ = function () {
    return this._xmin_0._get_size__0_k$();
  };
  SegmentHandler.prototype.reset_sv8swh_k$ = function () {
    this._xmin_0.clear_sv8swh_k$();
    this._xmax_0.clear_sv8swh_k$();
  };
  SegmentHandler.prototype.add_rvwcgf_k$ = function (x0, x1) {
    var inductionVariable = 0;
    var last_1 = this._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this._xmin_0.getAt_ha5a7z_k$(n);
        var xmax = this._xmax_0.getAt_ha5a7z_k$(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          this._xmin_0.set_rvwcgf_k$(n, Math.min(x0, xmin));
          this._xmax_0.set_rvwcgf_k$(n, Math.max(x1, xmax));
          return Unit_getInstance();
        }}
       while (inductionVariable < last_1);
    this._xmin_0.add_majfzk_k$(x0);
    this._xmax_0.add_majfzk_k$(x1);
  };
  SegmentHandler.$metadata$ = {
    simpleName: 'SegmentHandler',
    kind: 'class',
    interfaces: []
  };
  function ScanlineWriter($outer) {
    this._$this_16 = $outer;
    this._compositeMode = _get_DEFAULT_(Companion_getInstance_154());
    this._filler = NoneFiller_getInstance();
    this._ny0 = -1;
    this._ny = -1;
    this._alpha = new Float32Array(this._get_size__0_k$());
    this._hitbits = new Int32Array(this._get_size__0_k$());
    this._origin = Companion_getInstance_137().invoke_dguj8z_k$(this._get_size__0_k$());
    this._color_4 = Companion_getInstance_137().invoke_dguj8z_k$(this._get_size__0_k$());
    this._segments_1 = new SegmentHandler();
    this._subRowCount = 0;
  }
  ScanlineWriter.prototype._get_size__0_k$ = function () {
    return this._$this_16._bmp_2._get_width__0_k$();
  };
  ScanlineWriter.prototype._get_width1__0_k$ = function () {
    return this._$this_16._bmp_2._get_width__0_k$() - 1 | 0;
  };
  ScanlineWriter.prototype.reset_sv8swh_k$ = function () {
    var tmp0_forEachFast_0 = this._segments_1;
    var inductionVariable = 0;
    var last_1 = tmp0_forEachFast_0._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__3 = tmp0_forEachFast_0._xmin_0.getAt_ha5a7z_k$(n_2);
        var tmp2__anonymous__3 = tmp0_forEachFast_0._xmax_0.getAt_ha5a7z_k$(n_2);
        fill(this._alpha, 0.0, tmp1__anonymous__3, tmp2__anonymous__3 + 1 | 0);
        fill_0(this._hitbits, 0, tmp1__anonymous__3, tmp2__anonymous__3 + 1 | 0);
      }
       while (inductionVariable < last_1);
    this._subRowCount = 0;
    this._segments_1.reset_sv8swh_k$();
  };
  ScanlineWriter.prototype.select_zd700_k$ = function (x0, x1, y0) {
    if (this._get_width1__0_k$() < 1)
      return Unit_getInstance();
    var tmp = this._get_width1__0_k$();
    Companion_getInstance_55();
    var x0_0 = coerceIn(x0, 0, imul(tmp, 20));
    var tmp_0 = this._get_width1__0_k$();
    Companion_getInstance_55();
    var x1_0 = coerceIn(x1, 0, imul(tmp_0, 20));
    Companion_getInstance_55();
    var a = x0_0 / 20 | 0;
    Companion_getInstance_55();
    var b = x1_0 / 20 | 0;
    Companion_getInstance_55();
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this._get_width1__0_k$());
    var i1 = coerceIn(b, 0, this._get_width1__0_k$());
    Companion_getInstance_55();
    var i0m = x0_0 % 20;
    Companion_getInstance_55();
    var i1m = x1_0 % 20;
    if (!(this._ny === y)) {
      if (y >= 0)
        this.flush_sv8swh_k$();
      this._ny = y;
      this.reset_sv8swh_k$();
    }if (!(this._ny0 === y0)) {
      this._ny0 = y0;
      var tmp0_this = this;
      var tmp1 = tmp0_this._subRowCount;
      tmp0_this._subRowCount = tmp1 + 1 | 0;
      Unit_getInstance();
    }if (i1 > i0) {
      this._segments_1.add_rvwcgf_k$(i0, i1);
      var tmp_1 = i0m;
      Companion_getInstance_55();
      this.put_z49mik_k$(i0, 1.0 - tmp_1 / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.put_z49mik_k$(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        var tmp_2 = i1m;
        Companion_getInstance_55();
        this.put_z49mik_k$(i1, tmp_2 / 20);
      }}};
  ScanlineWriter.prototype.put_z49mik_k$ = function (x, ratio) {
    var mask_0 = 1 << this._subRowCount;
    if ((this._hitbits[x] & mask_0) === 0) {
      this._hitbits[x] = this._hitbits[x] | mask_0;
      var tmp0_array = this._alpha;
      var tmp1_index0 = x;
      tmp0_array[tmp1_index0] = tmp0_array[tmp1_index0] + ratio;
    }};
  ScanlineWriter.prototype.flush_sv8swh_k$ = function () {
    var containsUpper = this._$this_16._bmp_2._get_height__0_k$();
    var containsArg = this._ny;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_getInstance();
    else {
    }
    var scale_1 = 1.0 / this._subRowCount;
    var tmp0_forEachFast_0 = this._segments_1;
    var inductionVariable = 0;
    var last_1 = tmp0_forEachFast_0._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__3 = tmp0_forEachFast_0._xmin_0.getAt_ha5a7z_k$(n_2);
        var tmp2__anonymous__3 = tmp0_forEachFast_0._xmax_0.getAt_ha5a7z_k$(n_2);
        var x_4 = tmp1__anonymous__3;
        var count_5 = (tmp2__anonymous__3 - tmp1__anonymous__3 | 0) + 1 | 0;
        this._filler.fill_5y0cis_k$(this._color_4, 0, tmp1__anonymous__3, tmp2__anonymous__3, this._ny);
        var inductionVariable_0 = tmp1__anonymous__3;
        if (inductionVariable_0 <= tmp2__anonymous__3)
          do {
            var n_7 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp1_array_8 = this._alpha;
            var tmp2_index0_9 = n_7;
            tmp1_array_8[tmp2_index0_9] = tmp1_array_8[tmp2_index0_9] * scale_1;
          }
           while (!(n_7 === tmp2__anonymous__3));
        scale(this._color_4, tmp1__anonymous__3, this._alpha, tmp1__anonymous__3, count_5);
        var index_10 = this._$this_16._bmp_2.index_27zxwg_k$(0, this._ny) + x_4 | 0;
        if (this._$this_16._bmp_2._get_premultiplied__0_k$())
          arraycopy_3(_RgbaPremultipliedArray___get_ints__impl_(this._$this_16._bmp_2._dataPremult), index_10, _RgbaPremultipliedArray___get_ints__impl_(this._origin), x_4, count_5);
        else
          premultiply(this._$this_16._bmp_2._data_25, index_10, this._origin, x_4, count_5);
        this._compositeMode.blend_o7m4og_k$(this._origin, x_4, this._color_4, x_4, count_5);
        if (this._$this_16._bmp_2._get_premultiplied__0_k$())
          arraycopy_3(_RgbaPremultipliedArray___get_ints__impl_(this._origin), x_4, _RgbaPremultipliedArray___get_ints__impl_(this._$this_16._bmp_2._dataPremult), index_10, count_5);
        else
          depremultiply(this._origin, x_4, this._$this_16._bmp_2._data_25, index_10, count_5);
      }
       while (inductionVariable < last_1);
  };
  ScanlineWriter.$metadata$ = {
    simpleName: 'ScanlineWriter',
    kind: 'class',
    interfaces: []
  };
  function render$flush(this$0, filler, fillPath) {
    if (this$0._rasterizer._path_25.isNotEmpty_0_k$()) {
      this$0._rasterizer._quality_0 = this$0._antialiasing ? 4 : 1;
      this$0._scanlineWriter._filler = filler;
      this$0._scanlineWriter.reset_sv8swh_k$();
      var tmp = fillPath._winding_0;
      this$0._rasterizer.rasterizeFill$default_u3mu3e_k$(this$0._bounds_3, 0, null, tmp, _no_name_provided_$factory_226(this$0), 6, null);
      this$0._scanlineWriter.flush_sv8swh_k$();
      this$0._rasterizer._path_25.reset_sv8swh_k$();
    }}
  function _no_name_provided__276(this$0) {
    this._this$0_63 = this$0;
  }
  _no_name_provided__276.prototype.invoke_zd700_k$ = function (x0, x1, y) {
    this._this$0_63._scanlineWriter.select_zd700_k$(x0, x1, y);
  };
  _no_name_provided__276.prototype.invoke_ifn5k1_k$ = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    this.invoke_zd700_k$(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__276.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Bitmap32Context2d(bmp, antialiasing) {
    Renderer.call(this);
    this._bmp_2 = bmp;
    this._antialiasing = antialiasing;
    this._bounds_3 = _get_float_(this._bmp_2._bounds);
    this._rasterizer = new Rasterizer();
    this._colorFiller = new ColorFiller();
    this._gradientFiller = new GradientFiller();
    this._bitmapFiller = new BitmapFiller();
    this._scanlineWriter = new ScanlineWriter(this);
    var tmp = this;
    tmp._tempPath = VectorPath_init_$Create$(null, null, Winding_EVEN_ODD_getInstance(), 3, null);
    this._tempFillStrokeTemp = new StrokeToFill();
  }
  Bitmap32Context2d.prototype._get_width__0_k$ = function () {
    return this._bmp_2._get_width__0_k$();
  };
  Bitmap32Context2d.prototype._get_height__0_k$ = function () {
    return this._bmp_2._get_height__0_k$();
  };
  Bitmap32Context2d.prototype.render_eshf5c_k$ = function (state, fill_4) {
    var style = fill_4 ? state._fillStyle : state._strokeStyle;
    var tmp0_subject = style;
    var tmp;
    if (tmp0_subject instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (tmp0_subject instanceof RGBA) {
        tmp = this._colorFiller.set_wb3245_k$(style._value_19, state);
      } else {
        if (tmp0_subject instanceof GradientPaint) {
          tmp = this._gradientFiller.set_w8nzgc_k$(style, state);
        } else {
          if (tmp0_subject instanceof BitmapPaint) {
            tmp = this._bitmapFiller.set_szf2jp_k$(style, state);
          } else {
            {
              throw NotImplementedError_init_$Create$(null, 1, null);
            }
          }
        }
      }
    }
    var filler = tmp;
    this._scanlineWriter._compositeMode = state._globalCompositeOperation;
    this._rasterizer.reset_sv8swh_k$();
    this._rasterizer._debug = this._get_debug__0_k$();
    var doingStroke = !fill_4;
    var tmp_0;
    if (fill_4) {
      tmp_0 = state._path_22;
    } else {
      this._tempPath.clear_sv8swh_k$();
      tmp_0 = strokeToFill(state._path_22, state._get_scaledLineWidth__0_k$(), state._lineJoin, state._startLineCap, state._endLineCap, state._miterLimit_0, this._tempFillStrokeTemp, this._tempPath);
    }
    var fillPath = tmp_0;
    if (!(state._clip == null)) {
      this._rasterizer._clip_3._winding = ensureNotNull(state._clip)._get_winding__0_k$();
      var tmp0_emitPoints2_0 = ensureNotNull(state._clip);
      var ix_3 = 0.0;
      var iy_4 = 0.0;
      var lx_5 = {_v: 0.0};
      var ly_6 = {_v: 0.0};
      if (false)
        this._rasterizer._clip_3.close_sv8swh_k$();
      var n_1_7 = 0;
      var tmp0_fastForEach_0_8 = tmp0_emitPoints2_0._commands;
      var n_1_9 = 0;
      while (n_1_9 < tmp0_fastForEach_0_8._get_size__0_k$()) {
        var tmp0_2_11 = n_1_9;
        n_1_9 = tmp0_2_11 + 1 | 0;
        var tmp1__anonymous__2_3_10 = tmp0_fastForEach_0_8.getAt_ha5a7z_k$(tmp0_2_11);
        var tmp0_subject_3_4_12 = tmp1__anonymous__2_3_10;
        Command_getInstance();
        if (tmp0_subject_3_4_12 === 0) {
          var tmp1_4_5_14 = n_1_7;
          n_1_7 = tmp1_4_5_14 + 1 | 0;
          var tmp2__anonymous__18_13 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp1_4_5_14);
          var tmp2_5_6_16 = n_1_7;
          n_1_7 = tmp2_5_6_16 + 1 | 0;
          var tmp3__anonymous__18_15 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp2_5_6_16);
          ix_3 = tmp2__anonymous__18_13;
          iy_4 = tmp3__anonymous__18_15;
          var tmp0_also_0_20_18 = this._rasterizer._clip_3.add_pux2sr_k$(tmp2__anonymous__18_13, tmp3__anonymous__18_15, true);
          lx_5._v = tmp2__anonymous__18_13;
          var tmp1_also_0_19_17 = tmp0_also_0_20_18;
          ly_6._v = tmp3__anonymous__18_15;
        } else {
          Command_getInstance();
          if (tmp0_subject_3_4_12 === 1) {
            var tmp3_6_7_20 = n_1_7;
            n_1_7 = tmp3_6_7_20 + 1 | 0;
            var tmp4__anonymous__21_19 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp3_6_7_20);
            var tmp4_7_8_22 = n_1_7;
            n_1_7 = tmp4_7_8_22 + 1 | 0;
            var tmp5__anonymous__21_21 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp4_7_8_22);
            var tmp0_also_0_23_24 = this._rasterizer._clip_3.add_pux2sr_k$(tmp4__anonymous__21_19, tmp5__anonymous__21_21, false);
            lx_5._v = tmp4__anonymous__21_19;
            var tmp1_also_0_22_23 = tmp0_also_0_23_24;
            ly_6._v = tmp5__anonymous__21_21;
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_3_4_12 === 2) {
              var tmp5_8_9_26 = n_1_7;
              n_1_7 = tmp5_8_9_26 + 1 | 0;
              var tmp6__anonymous__24_25 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp5_8_9_26);
              var tmp6_9_10_28 = n_1_7;
              n_1_7 = tmp6_9_10_28 + 1 | 0;
              var tmp7__anonymous__24_27 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp6_9_10_28);
              var tmp7_10_11_30 = n_1_7;
              n_1_7 = tmp7_10_11_30 + 1 | 0;
              var tmp8__anonymous__24_29 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp7_10_11_30);
              var tmp8_11_12_32 = n_1_7;
              n_1_7 = tmp8_11_12_32 + 1 | 0;
              var tmp9__anonymous__24_31 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp8_11_12_32);
              var sum_25_33 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp6__anonymous__24_25, tmp7__anonymous__24_27) + Companion_getInstance_32().distance_i6u10_k$(tmp6__anonymous__24_25, tmp7__anonymous__24_27, tmp8__anonymous__24_29, tmp9__anonymous__24_31);
              var tmp0_approximateCurve_0_26_34 = numberToInt(sum_25_33);
              var rcurveSteps_1_27_35 = Math.max(tmp0_approximateCurve_0_26_34, 20);
              var dt_2_28_36 = 1.0 / rcurveSteps_1_27_35;
              var lastX_3_29_37 = {_v: 0.0};
              var lastY_4_30_38 = {_v: 0.0};
              var prevX_5_31_39 = {_v: 0.0};
              var prevY_6_32_40 = {_v: 0.0};
              var emittedCount_7_33_41 = {_v: 0};
              var tmp0_quadCalc_0_16_34_42 = Companion_getInstance_41();
              var tmp1_quadCalc_0_17_35_43 = lx_5._v;
              var tmp2_quadCalc_0_18_36_44 = ly_6._v;
              var t1_1_19_37_45 = 1.0;
              var a_2_20_38_46 = t1_1_19_37_45 * t1_1_19_37_45;
              var c_3_21_39_47 = 0.0;
              var b_4_22_40_48 = 2 * t1_1_19_37_45 * 0.0;
              var tmp3__anonymous__5_23_41_49 = a_2_20_38_46 * tmp1_quadCalc_0_17_35_43 + b_4_22_40_48 * tmp6__anonymous__24_25 + c_3_21_39_47 * tmp8__anonymous__24_29;
              var tmp4__anonymous__5_24_42_50 = a_2_20_38_46 * tmp2_quadCalc_0_18_36_44 + b_4_22_40_48 * tmp7__anonymous__24_27 + c_3_21_39_47 * tmp9__anonymous__24_31;
              lastX_3_29_37._v = tmp3__anonymous__5_23_41_49;
              lastY_4_30_38._v = tmp4__anonymous__5_24_42_50;
              var inductionVariable = 1;
              if (inductionVariable < rcurveSteps_1_27_35)
                do {
                  var n_10_44_52 = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var ratio_11_45_53 = n_10_44_52 * dt_2_28_36;
                  var tmp0_quadCalc_0_16_46_54 = Companion_getInstance_41();
                  var tmp1_quadCalc_0_17_47_55 = lx_5._v;
                  var tmp2_quadCalc_0_18_48_56 = ly_6._v;
                  var t1_1_19_49_57 = 1 - ratio_11_45_53;
                  var a_2_20_50_58 = t1_1_19_49_57 * t1_1_19_49_57;
                  var c_3_21_51_59 = ratio_11_45_53 * ratio_11_45_53;
                  var b_4_22_52_60 = 2 * t1_1_19_49_57 * ratio_11_45_53;
                  var tmp3__anonymous__5_23_53_61 = a_2_20_50_58 * tmp1_quadCalc_0_17_47_55 + b_4_22_52_60 * tmp6__anonymous__24_25 + c_3_21_51_59 * tmp8__anonymous__24_29;
                  var tmp4__anonymous__5_24_54_62 = a_2_20_50_58 * tmp2_quadCalc_0_18_48_56 + b_4_22_52_60 * tmp7__anonymous__24_27 + c_3_21_51_59 * tmp9__anonymous__24_31;
                  this._rasterizer._clip_3.add_pux2sr_k$(tmp3__anonymous__5_23_53_61, tmp4__anonymous__5_24_54_62, false);
                  var tmp0_14_2_27_55_63 = emittedCount_7_33_41._v;
                  emittedCount_7_33_41._v = tmp0_14_2_27_55_63 + 1 | 0;
                  Unit_getInstance();
                  lastX_3_29_37._v = prevX_5_31_39._v;
                  lastY_4_30_38._v = prevY_6_32_40._v;
                  prevX_5_31_39._v = tmp3__anonymous__5_23_53_61;
                  prevY_6_32_40._v = tmp4__anonymous__5_24_54_62;
                }
                 while (inductionVariable < rcurveSteps_1_27_35);
              var tmp1_also_0_56_64 = lx_5._v = tmp8__anonymous__24_29;
              ly_6._v = tmp9__anonymous__24_31;
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_3_4_12 === 3) {
                var tmp9_12_13_66 = n_1_7;
                n_1_7 = tmp9_12_13_66 + 1 | 0;
                var tmp10__anonymous__57_65 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp9_12_13_66);
                var tmp10_13_14_68 = n_1_7;
                n_1_7 = tmp10_13_14_68 + 1 | 0;
                var tmp11__anonymous__57_67 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp10_13_14_68);
                var tmp11_14_15_70 = n_1_7;
                n_1_7 = tmp11_14_15_70 + 1 | 0;
                var tmp12__anonymous__57_69 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp11_14_15_70);
                var tmp12_15_16_72 = n_1_7;
                n_1_7 = tmp12_15_16_72 + 1 | 0;
                var tmp13__anonymous__57_71 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp12_15_16_72);
                var tmp13_16_17_74 = n_1_7;
                n_1_7 = tmp13_16_17_74 + 1 | 0;
                var tmp14__anonymous__57_73 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp13_16_17_74);
                var tmp14_17_18_76 = n_1_7;
                n_1_7 = tmp14_17_18_76 + 1 | 0;
                var tmp15__anonymous__57_75 = tmp0_emitPoints2_0._data_11.get_ha5a7z_k$(tmp14_17_18_76);
                var sum_58_77 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp10__anonymous__57_65, tmp11__anonymous__57_67) + Companion_getInstance_32().distance_i6u10_k$(tmp10__anonymous__57_65, tmp11__anonymous__57_67, tmp12__anonymous__57_69, tmp13__anonymous__57_71) + Companion_getInstance_32().distance_i6u10_k$(tmp12__anonymous__57_69, tmp13__anonymous__57_71, tmp14__anonymous__57_73, tmp15__anonymous__57_75);
                var tmp0_approximateCurve_0_59_78 = numberToInt(sum_58_77);
                var rcurveSteps_1_60_79 = Math.max(tmp0_approximateCurve_0_59_78, 20);
                var dt_2_61_80 = 1.0 / rcurveSteps_1_60_79;
                var lastX_3_62_81 = {_v: 0.0};
                var lastY_4_63_82 = {_v: 0.0};
                var prevX_5_64_83 = {_v: 0.0};
                var prevY_6_65_84 = {_v: 0.0};
                var emittedCount_7_66_85 = {_v: 0};
                var tmp0_cubicCalc_0_16_67_86 = Companion_getInstance_41();
                var tmp1_cubicCalc_0_17_68_87 = lx_5._v;
                var tmp2_cubicCalc_0_18_69_88 = ly_6._v;
                var cx_1_19_70_89 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_68_87);
                var bx_2_20_71_90 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_70_89;
                var ax_3_21_72_91 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_68_87 - cx_1_19_70_89 - bx_2_20_71_90;
                var cy_4_22_73_92 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_69_88);
                var by_5_23_74_93 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_73_92;
                var ay_6_24_75_94 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_69_88 - cy_4_22_73_92 - by_5_23_74_93;
                var tSquared_7_25_76_95 = 0.0;
                var tCubed_8_26_77_96 = tSquared_7_25_76_95 * 0.0;
                var tmp3__anonymous__9_27_78_97 = ax_3_21_72_91 * tCubed_8_26_77_96 + bx_2_20_71_90 * tSquared_7_25_76_95 + cx_1_19_70_89 * 0.0 + tmp1_cubicCalc_0_17_68_87;
                var tmp4__anonymous__9_28_79_98 = ay_6_24_75_94 * tCubed_8_26_77_96 + by_5_23_74_93 * tSquared_7_25_76_95 + cy_4_22_73_92 * 0.0 + tmp2_cubicCalc_0_18_69_88;
                lastX_3_62_81._v = tmp3__anonymous__9_27_78_97;
                lastY_4_63_82._v = tmp4__anonymous__9_28_79_98;
                var inductionVariable_0 = 1;
                if (inductionVariable_0 < rcurveSteps_1_60_79)
                  do {
                    var n_10_81_100 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var ratio_11_82_101 = n_10_81_100 * dt_2_61_80;
                    var tmp0_cubicCalc_0_16_83_102 = Companion_getInstance_41();
                    var tmp1_cubicCalc_0_17_84_103 = lx_5._v;
                    var tmp2_cubicCalc_0_18_85_104 = ly_6._v;
                    var cx_1_19_86_105 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_84_103);
                    var bx_2_20_87_106 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_86_105;
                    var ax_3_21_88_107 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_84_103 - cx_1_19_86_105 - bx_2_20_87_106;
                    var cy_4_22_89_108 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_85_104);
                    var by_5_23_90_109 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_89_108;
                    var ay_6_24_91_110 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_85_104 - cy_4_22_89_108 - by_5_23_90_109;
                    var tSquared_7_25_92_111 = ratio_11_82_101 * ratio_11_82_101;
                    var tCubed_8_26_93_112 = tSquared_7_25_92_111 * ratio_11_82_101;
                    var tmp3__anonymous__9_27_94_113 = ax_3_21_88_107 * tCubed_8_26_93_112 + bx_2_20_87_106 * tSquared_7_25_92_111 + cx_1_19_86_105 * ratio_11_82_101 + tmp1_cubicCalc_0_17_84_103;
                    var tmp4__anonymous__9_28_95_114 = ay_6_24_91_110 * tCubed_8_26_93_112 + by_5_23_90_109 * tSquared_7_25_92_111 + cy_4_22_89_108 * ratio_11_82_101 + tmp2_cubicCalc_0_18_85_104;
                    this._rasterizer._clip_3.add_pux2sr_k$(tmp3__anonymous__9_27_94_113, tmp4__anonymous__9_28_95_114, false);
                    var tmp0_14_2_31_96_115 = emittedCount_7_66_85._v;
                    emittedCount_7_66_85._v = tmp0_14_2_31_96_115 + 1 | 0;
                    Unit_getInstance();
                    lastX_3_62_81._v = prevX_5_64_83._v;
                    lastY_4_63_82._v = prevY_6_65_84._v;
                    prevX_5_64_83._v = tmp3__anonymous__9_27_94_113;
                    prevY_6_65_84._v = tmp4__anonymous__9_28_95_114;
                  }
                   while (inductionVariable_0 < rcurveSteps_1_60_79);
                var tmp1_also_0_97_116 = lx_5._v = tmp14__anonymous__57_73;
                ly_6._v = tmp15__anonymous__57_75;
                Unit_getInstance();
              } else {
                Command_getInstance();
                if (tmp0_subject_3_4_12 === 4) {
                  var tmp1__anonymous__118 = ix_3;
                  var tmp2__anonymous__118 = iy_4;
                  this._rasterizer._clip_3.add_pux2sr_k$(tmp1__anonymous__118, tmp2__anonymous__118, false);
                  Unit_getInstance();
                  this._rasterizer._clip_3.close_sv8swh_k$();
                } else {
                }
              }
            }
          }
        }
      }
      if (false)
        this._rasterizer._clip_3.close_sv8swh_k$();
    }this._rasterizer._path_25._winding = ensureNotNull(state._path_22)._get_winding__0_k$();
    var ix_3_0 = 0.0;
    var iy_4_0 = 0.0;
    var lx_5_0 = {_v: 0.0};
    var ly_6_0 = {_v: 0.0};
    if (false) {
      this._rasterizer._path_25.close_sv8swh_k$();
    }var n_1_7_0 = 0;
    var tmp0_fastForEach_0_8_0 = fillPath._commands;
    var n_1_9_0 = 0;
    while (n_1_9_0 < tmp0_fastForEach_0_8_0._get_size__0_k$()) {
      var tmp0_2_11_0 = n_1_9_0;
      n_1_9_0 = tmp0_2_11_0 + 1 | 0;
      var tmp1__anonymous__2_3_10_0 = tmp0_fastForEach_0_8_0.getAt_ha5a7z_k$(tmp0_2_11_0);
      var tmp0_subject_3_4_12_0 = tmp1__anonymous__2_3_10_0;
      Command_getInstance();
      if (tmp0_subject_3_4_12_0 === 0) {
        var tmp1_4_5_14_0 = n_1_7_0;
        n_1_7_0 = tmp1_4_5_14_0 + 1 | 0;
        var tmp2__anonymous__18_13_0 = fillPath._data_11.get_ha5a7z_k$(tmp1_4_5_14_0);
        var tmp2_5_6_16_0 = n_1_7_0;
        n_1_7_0 = tmp2_5_6_16_0 + 1 | 0;
        var tmp3__anonymous__18_15_0 = fillPath._data_11.get_ha5a7z_k$(tmp2_5_6_16_0);
        ix_3_0 = tmp2__anonymous__18_13_0;
        iy_4_0 = tmp3__anonymous__18_15_0;
        if (doingStroke) {
          {
            render$flush(this, filler, fillPath);
          }
        }var tmp0_also_0_20_18_0 = this._rasterizer._path_25.add_pux2sr_k$(tmp2__anonymous__18_13_0, tmp3__anonymous__18_15_0, true);
        lx_5_0._v = tmp2__anonymous__18_13_0;
        var tmp1_also_0_19_17_0 = tmp0_also_0_20_18_0;
        ly_6_0._v = tmp3__anonymous__18_15_0;
      } else {
        Command_getInstance();
        if (tmp0_subject_3_4_12_0 === 1) {
          var tmp3_6_7_20_0 = n_1_7_0;
          n_1_7_0 = tmp3_6_7_20_0 + 1 | 0;
          var tmp4__anonymous__21_19_0 = fillPath._data_11.get_ha5a7z_k$(tmp3_6_7_20_0);
          var tmp4_7_8_22_0 = n_1_7_0;
          n_1_7_0 = tmp4_7_8_22_0 + 1 | 0;
          var tmp5__anonymous__21_21_0 = fillPath._data_11.get_ha5a7z_k$(tmp4_7_8_22_0);
          if (doingStroke) {
            if (false) {
              render$flush(this, filler, fillPath);
            }}var tmp0_also_0_23_24_0 = this._rasterizer._path_25.add_pux2sr_k$(tmp4__anonymous__21_19_0, tmp5__anonymous__21_21_0, false);
          lx_5_0._v = tmp4__anonymous__21_19_0;
          var tmp1_also_0_22_23_0 = tmp0_also_0_23_24_0;
          ly_6_0._v = tmp5__anonymous__21_21_0;
          Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_3_4_12_0 === 2) {
            var tmp5_8_9_26_0 = n_1_7_0;
            n_1_7_0 = tmp5_8_9_26_0 + 1 | 0;
            var tmp6__anonymous__24_25_0 = fillPath._data_11.get_ha5a7z_k$(tmp5_8_9_26_0);
            var tmp6_9_10_28_0 = n_1_7_0;
            n_1_7_0 = tmp6_9_10_28_0 + 1 | 0;
            var tmp7__anonymous__24_27_0 = fillPath._data_11.get_ha5a7z_k$(tmp6_9_10_28_0);
            var tmp7_10_11_30_0 = n_1_7_0;
            n_1_7_0 = tmp7_10_11_30_0 + 1 | 0;
            var tmp8__anonymous__24_29_0 = fillPath._data_11.get_ha5a7z_k$(tmp7_10_11_30_0);
            var tmp8_11_12_32_0 = n_1_7_0;
            n_1_7_0 = tmp8_11_12_32_0 + 1 | 0;
            var tmp9__anonymous__24_31_0 = fillPath._data_11.get_ha5a7z_k$(tmp8_11_12_32_0);
            var sum_25_33_0 = Companion_getInstance_32().distance_i6u10_k$(lx_5_0._v, ly_6_0._v, tmp6__anonymous__24_25_0, tmp7__anonymous__24_27_0) + Companion_getInstance_32().distance_i6u10_k$(tmp6__anonymous__24_25_0, tmp7__anonymous__24_27_0, tmp8__anonymous__24_29_0, tmp9__anonymous__24_31_0);
            var tmp0_approximateCurve_0_26_34_0 = numberToInt(sum_25_33_0);
            var rcurveSteps_1_27_35_0 = Math.max(tmp0_approximateCurve_0_26_34_0, 20);
            var dt_2_28_36_0 = 1.0 / rcurveSteps_1_27_35_0;
            var lastX_3_29_37_0 = {_v: 0.0};
            var lastY_4_30_38_0 = {_v: 0.0};
            var prevX_5_31_39_0 = {_v: 0.0};
            var prevY_6_32_40_0 = {_v: 0.0};
            var emittedCount_7_33_41_0 = {_v: 0};
            var tmp0_quadCalc_0_16_34_42_0 = Companion_getInstance_41();
            var tmp1_quadCalc_0_17_35_43_0 = lx_5_0._v;
            var tmp2_quadCalc_0_18_36_44_0 = ly_6_0._v;
            var t1_1_19_37_45_0 = 1.0;
            var a_2_20_38_46_0 = t1_1_19_37_45_0 * t1_1_19_37_45_0;
            var c_3_21_39_47_0 = 0.0;
            var b_4_22_40_48_0 = 2 * t1_1_19_37_45_0 * 0.0;
            var tmp3__anonymous__5_23_41_49_0 = a_2_20_38_46_0 * tmp1_quadCalc_0_17_35_43_0 + b_4_22_40_48_0 * tmp6__anonymous__24_25_0 + c_3_21_39_47_0 * tmp8__anonymous__24_29_0;
            var tmp4__anonymous__5_24_42_50_0 = a_2_20_38_46_0 * tmp2_quadCalc_0_18_36_44_0 + b_4_22_40_48_0 * tmp7__anonymous__24_27_0 + c_3_21_39_47_0 * tmp9__anonymous__24_31_0;
            lastX_3_29_37_0._v = tmp3__anonymous__5_23_41_49_0;
            lastY_4_30_38_0._v = tmp4__anonymous__5_24_42_50_0;
            var inductionVariable_1 = 1;
            if (inductionVariable_1 < rcurveSteps_1_27_35_0)
              do {
                var n_10_44_52_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var ratio_11_45_53_0 = n_10_44_52_0 * dt_2_28_36_0;
                var tmp0_quadCalc_0_16_46_54_0 = Companion_getInstance_41();
                var tmp1_quadCalc_0_17_47_55_0 = lx_5_0._v;
                var tmp2_quadCalc_0_18_48_56_0 = ly_6_0._v;
                var t1_1_19_49_57_0 = 1 - ratio_11_45_53_0;
                var a_2_20_50_58_0 = t1_1_19_49_57_0 * t1_1_19_49_57_0;
                var c_3_21_51_59_0 = ratio_11_45_53_0 * ratio_11_45_53_0;
                var b_4_22_52_60_0 = 2 * t1_1_19_49_57_0 * ratio_11_45_53_0;
                var tmp3__anonymous__5_23_53_61_0 = a_2_20_50_58_0 * tmp1_quadCalc_0_17_47_55_0 + b_4_22_52_60_0 * tmp6__anonymous__24_25_0 + c_3_21_51_59_0 * tmp8__anonymous__24_29_0;
                var tmp4__anonymous__5_24_54_62_0 = a_2_20_50_58_0 * tmp2_quadCalc_0_18_48_56_0 + b_4_22_52_60_0 * tmp7__anonymous__24_27_0 + c_3_21_51_59_0 * tmp9__anonymous__24_31_0;
                if (doingStroke) {
                  if (false) {
                    render$flush(this, filler, fillPath);
                  }}this._rasterizer._path_25.add_pux2sr_k$(tmp3__anonymous__5_23_53_61_0, tmp4__anonymous__5_24_54_62_0, false);
                var tmp0_14_2_27_55_63_0 = emittedCount_7_33_41_0._v;
                emittedCount_7_33_41_0._v = tmp0_14_2_27_55_63_0 + 1 | 0;
                Unit_getInstance();
                lastX_3_29_37_0._v = prevX_5_31_39_0._v;
                lastY_4_30_38_0._v = prevY_6_32_40_0._v;
                prevX_5_31_39_0._v = tmp3__anonymous__5_23_53_61_0;
                prevY_6_32_40_0._v = tmp4__anonymous__5_24_54_62_0;
              }
               while (inductionVariable_1 < rcurveSteps_1_27_35_0);
            var tmp1_also_0_56_64_0 = lx_5_0._v = tmp8__anonymous__24_29_0;
            ly_6_0._v = tmp9__anonymous__24_31_0;
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_3_4_12_0 === 3) {
              var tmp9_12_13_66_0 = n_1_7_0;
              n_1_7_0 = tmp9_12_13_66_0 + 1 | 0;
              var tmp10__anonymous__57_65_0 = fillPath._data_11.get_ha5a7z_k$(tmp9_12_13_66_0);
              var tmp10_13_14_68_0 = n_1_7_0;
              n_1_7_0 = tmp10_13_14_68_0 + 1 | 0;
              var tmp11__anonymous__57_67_0 = fillPath._data_11.get_ha5a7z_k$(tmp10_13_14_68_0);
              var tmp11_14_15_70_0 = n_1_7_0;
              n_1_7_0 = tmp11_14_15_70_0 + 1 | 0;
              var tmp12__anonymous__57_69_0 = fillPath._data_11.get_ha5a7z_k$(tmp11_14_15_70_0);
              var tmp12_15_16_72_0 = n_1_7_0;
              n_1_7_0 = tmp12_15_16_72_0 + 1 | 0;
              var tmp13__anonymous__57_71_0 = fillPath._data_11.get_ha5a7z_k$(tmp12_15_16_72_0);
              var tmp13_16_17_74_0 = n_1_7_0;
              n_1_7_0 = tmp13_16_17_74_0 + 1 | 0;
              var tmp14__anonymous__57_73_0 = fillPath._data_11.get_ha5a7z_k$(tmp13_16_17_74_0);
              var tmp14_17_18_76_0 = n_1_7_0;
              n_1_7_0 = tmp14_17_18_76_0 + 1 | 0;
              var tmp15__anonymous__57_75_0 = fillPath._data_11.get_ha5a7z_k$(tmp14_17_18_76_0);
              var sum_58_77_0 = Companion_getInstance_32().distance_i6u10_k$(lx_5_0._v, ly_6_0._v, tmp10__anonymous__57_65_0, tmp11__anonymous__57_67_0) + Companion_getInstance_32().distance_i6u10_k$(tmp10__anonymous__57_65_0, tmp11__anonymous__57_67_0, tmp12__anonymous__57_69_0, tmp13__anonymous__57_71_0) + Companion_getInstance_32().distance_i6u10_k$(tmp12__anonymous__57_69_0, tmp13__anonymous__57_71_0, tmp14__anonymous__57_73_0, tmp15__anonymous__57_75_0);
              var tmp0_approximateCurve_0_59_78_0 = numberToInt(sum_58_77_0);
              var rcurveSteps_1_60_79_0 = Math.max(tmp0_approximateCurve_0_59_78_0, 20);
              var dt_2_61_80_0 = 1.0 / rcurveSteps_1_60_79_0;
              var lastX_3_62_81_0 = {_v: 0.0};
              var lastY_4_63_82_0 = {_v: 0.0};
              var prevX_5_64_83_0 = {_v: 0.0};
              var prevY_6_65_84_0 = {_v: 0.0};
              var emittedCount_7_66_85_0 = {_v: 0};
              var tmp0_cubicCalc_0_16_67_86_0 = Companion_getInstance_41();
              var tmp1_cubicCalc_0_17_68_87_0 = lx_5_0._v;
              var tmp2_cubicCalc_0_18_69_88_0 = ly_6_0._v;
              var cx_1_19_70_89_0 = 3.0 * (tmp10__anonymous__57_65_0 - tmp1_cubicCalc_0_17_68_87_0);
              var bx_2_20_71_90_0 = 3.0 * (tmp12__anonymous__57_69_0 - tmp10__anonymous__57_65_0) - cx_1_19_70_89_0;
              var ax_3_21_72_91_0 = tmp14__anonymous__57_73_0 - tmp1_cubicCalc_0_17_68_87_0 - cx_1_19_70_89_0 - bx_2_20_71_90_0;
              var cy_4_22_73_92_0 = 3.0 * (tmp11__anonymous__57_67_0 - tmp2_cubicCalc_0_18_69_88_0);
              var by_5_23_74_93_0 = 3.0 * (tmp13__anonymous__57_71_0 - tmp11__anonymous__57_67_0) - cy_4_22_73_92_0;
              var ay_6_24_75_94_0 = tmp15__anonymous__57_75_0 - tmp2_cubicCalc_0_18_69_88_0 - cy_4_22_73_92_0 - by_5_23_74_93_0;
              var tSquared_7_25_76_95_0 = 0.0;
              var tCubed_8_26_77_96_0 = tSquared_7_25_76_95_0 * 0.0;
              var tmp3__anonymous__9_27_78_97_0 = ax_3_21_72_91_0 * tCubed_8_26_77_96_0 + bx_2_20_71_90_0 * tSquared_7_25_76_95_0 + cx_1_19_70_89_0 * 0.0 + tmp1_cubicCalc_0_17_68_87_0;
              var tmp4__anonymous__9_28_79_98_0 = ay_6_24_75_94_0 * tCubed_8_26_77_96_0 + by_5_23_74_93_0 * tSquared_7_25_76_95_0 + cy_4_22_73_92_0 * 0.0 + tmp2_cubicCalc_0_18_69_88_0;
              lastX_3_62_81_0._v = tmp3__anonymous__9_27_78_97_0;
              lastY_4_63_82_0._v = tmp4__anonymous__9_28_79_98_0;
              var inductionVariable_2 = 1;
              if (inductionVariable_2 < rcurveSteps_1_60_79_0)
                do {
                  var n_10_81_100_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ratio_11_82_101_0 = n_10_81_100_0 * dt_2_61_80_0;
                  var tmp0_cubicCalc_0_16_83_102_0 = Companion_getInstance_41();
                  var tmp1_cubicCalc_0_17_84_103_0 = lx_5_0._v;
                  var tmp2_cubicCalc_0_18_85_104_0 = ly_6_0._v;
                  var cx_1_19_86_105_0 = 3.0 * (tmp10__anonymous__57_65_0 - tmp1_cubicCalc_0_17_84_103_0);
                  var bx_2_20_87_106_0 = 3.0 * (tmp12__anonymous__57_69_0 - tmp10__anonymous__57_65_0) - cx_1_19_86_105_0;
                  var ax_3_21_88_107_0 = tmp14__anonymous__57_73_0 - tmp1_cubicCalc_0_17_84_103_0 - cx_1_19_86_105_0 - bx_2_20_87_106_0;
                  var cy_4_22_89_108_0 = 3.0 * (tmp11__anonymous__57_67_0 - tmp2_cubicCalc_0_18_85_104_0);
                  var by_5_23_90_109_0 = 3.0 * (tmp13__anonymous__57_71_0 - tmp11__anonymous__57_67_0) - cy_4_22_89_108_0;
                  var ay_6_24_91_110_0 = tmp15__anonymous__57_75_0 - tmp2_cubicCalc_0_18_85_104_0 - cy_4_22_89_108_0 - by_5_23_90_109_0;
                  var tSquared_7_25_92_111_0 = ratio_11_82_101_0 * ratio_11_82_101_0;
                  var tCubed_8_26_93_112_0 = tSquared_7_25_92_111_0 * ratio_11_82_101_0;
                  var tmp3__anonymous__9_27_94_113_0 = ax_3_21_88_107_0 * tCubed_8_26_93_112_0 + bx_2_20_87_106_0 * tSquared_7_25_92_111_0 + cx_1_19_86_105_0 * ratio_11_82_101_0 + tmp1_cubicCalc_0_17_84_103_0;
                  var tmp4__anonymous__9_28_95_114_0 = ay_6_24_91_110_0 * tCubed_8_26_93_112_0 + by_5_23_90_109_0 * tSquared_7_25_92_111_0 + cy_4_22_89_108_0 * ratio_11_82_101_0 + tmp2_cubicCalc_0_18_85_104_0;
                  if (doingStroke) {
                    if (false) {
                      render$flush(this, filler, fillPath);
                    }}this._rasterizer._path_25.add_pux2sr_k$(tmp3__anonymous__9_27_94_113_0, tmp4__anonymous__9_28_95_114_0, false);
                  var tmp0_14_2_31_96_115_0 = emittedCount_7_66_85_0._v;
                  emittedCount_7_66_85_0._v = tmp0_14_2_31_96_115_0 + 1 | 0;
                  Unit_getInstance();
                  lastX_3_62_81_0._v = prevX_5_64_83_0._v;
                  lastY_4_63_82_0._v = prevY_6_65_84_0._v;
                  prevX_5_64_83_0._v = tmp3__anonymous__9_27_94_113_0;
                  prevY_6_65_84_0._v = tmp4__anonymous__9_28_95_114_0;
                }
                 while (inductionVariable_2 < rcurveSteps_1_60_79_0);
              var tmp1_also_0_97_116_0 = lx_5_0._v = tmp14__anonymous__57_73_0;
              ly_6_0._v = tmp15__anonymous__57_75_0;
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_3_4_12_0 === 4) {
                var tmp3__anonymous__118 = ix_3_0;
                var tmp4__anonymous__118 = iy_4_0;
                if (doingStroke) {
                  if (false) {
                    render$flush(this, filler, fillPath);
                  }}this._rasterizer._path_25.add_pux2sr_k$(tmp3__anonymous__118, tmp4__anonymous__118, false);
                Unit_getInstance();
                {
                  this._rasterizer._path_25.close_sv8swh_k$();
                }
              } else {
              }
            }
          }
        }
      }
    }
    if (false) {
      this._rasterizer._path_25.close_sv8swh_k$();
    }render$flush(this, filler, fillPath);
  };
  Bitmap32Context2d.$metadata$ = {
    simpleName: 'Bitmap32Context2d',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_226(this$0) {
    var i = new _no_name_provided__276(this$0);
    return function (p1, p2, p3) {
      i.invoke_zd700_k$(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function BitmapVector() {
  }
  BitmapVector.prototype._get_nativeImage__0_k$ = function () {
    var tmp0_getValue_0 = nativeImage$factory();
    return this._nativeImage$delegate._get_value__0_k$();
  };
  BitmapVector.$metadata$ = {
    simpleName: 'BitmapVector',
    kind: 'class',
    interfaces: []
  };
  function nativeImage$factory() {
    return getPropertyCallableRef('nativeImage', 1, KProperty1, function (receiver) {
      return receiver._get_nativeImage__0_k$();
    }, null);
  }
  function _no_name_provided__277() {
  }
  _no_name_provided__277.prototype.invoke_o7m4og_k$ = function (dst, dstN, src, srcN, count_0) {
    mix_0(dst, dstN, src, srcN, count_0);
  };
  _no_name_provided__277.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = p1 instanceof RgbaPremultipliedArray ? p1._ints_0 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof RgbaPremultipliedArray ? p3._ints_0 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_o7m4og_k$(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__277.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__278($func) {
    this._$func_0 = $func;
  }
  _no_name_provided__278.prototype.blend_o7m4og_k$ = function (dst, dstN, src, srcN, count_0) {
    return this._$func_0(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count_0);
  };
  _no_name_provided__278.$metadata$ = {
    kind: 'class',
    interfaces: [CompositeOperation]
  };
  function Companion_155() {
    Companion_instance_154 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_154();
    tmp._UNIMPLEMENTED = tmp_0.invoke_iu2mza_k$(_no_name_provided_$factory_227());
  }
  Companion_155.prototype.invoke_iu2mza_k$ = function (func) {
    return new _no_name_provided__278(func);
  };
  Companion_155.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_154;
  function Companion_getInstance_154() {
    if (Companion_instance_154 == null)
      new Companion_155();
    return Companion_instance_154;
  }
  function CompositeOperation() {
  }
  CompositeOperation.$metadata$ = {
    simpleName: 'CompositeOperation',
    kind: 'interface',
    interfaces: []
  };
  var CompositeMode_CLEAR_instance;
  var CompositeMode_COPY_instance;
  var CompositeMode_SOURCE_OVER_instance;
  var CompositeMode_DESTINATION_OVER_instance;
  var CompositeMode_SOURCE_IN_instance;
  var CompositeMode_DESTINATION_IN_instance;
  var CompositeMode_SOURCE_OUT_instance;
  var CompositeMode_DESTINATION_OUT_instance;
  var CompositeMode_SOURCE_ATOP_instance;
  var CompositeMode_DESTINATION_ATOP_instance;
  var CompositeMode_XOR_instance;
  var CompositeMode_LIGHTER_instance;
  function Companion_156() {
    Companion_instance_155 = this;
  }
  Companion_156.prototype._get_DEFAULT__0_k$ = function () {
    return CompositeMode_SOURCE_OVER_getInstance();
  };
  Companion_156.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_155;
  function Companion_getInstance_155() {
    if (Companion_instance_155 == null)
      new Companion_156();
    return Companion_instance_155;
  }
  function _no_name_provided__279() {
  }
  _no_name_provided__279.prototype.invoke_o7m4og_k$ = function (dst, dstN, src, srcN, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = RgbaPremultipliedArray__get_impl(dst, dstN + n | 0);
        var s = RgbaPremultipliedArray__get_impl(src, srcN + n | 0);
        RgbaPremultipliedArray__set_impl(dst, dstN + n | 0, _RGBA___get_premultiplied__impl_(RGBA__withA_impl(_RGBAPremultiplied___get_depremultiplied__impl_(d), clamp0_255(_RGBAPremultiplied___get_a__impl_(d) - _RGBAPremultiplied___get_a__impl_(s) | 0))));
      }
       while (inductionVariable < count_0);
  };
  _no_name_provided__279.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = p1 instanceof RgbaPremultipliedArray ? p1._ints_0 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof RgbaPremultipliedArray ? p3._ints_0 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_o7m4og_k$(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__279.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__280() {
  }
  _no_name_provided__280.prototype.invoke_o7m4og_k$ = function (dst, dstN, src, srcN, count_0) {
    mix_1(dst, dstN, dst, dstN, src, srcN, count_0);
  };
  _no_name_provided__280.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = p1 instanceof RgbaPremultipliedArray ? p1._ints_0 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof RgbaPremultipliedArray ? p3._ints_0 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_o7m4og_k$(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__280.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__281() {
  }
  _no_name_provided__281.prototype.invoke_o7m4og_k$ = function (dst, dstN, src, srcN, count_0) {
    mix_1(dst, dstN, src, srcN, dst, dstN, count_0);
  };
  _no_name_provided__281.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = p1 instanceof RgbaPremultipliedArray ? p1._ints_0 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof RgbaPremultipliedArray ? p3._ints_0 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_o7m4og_k$(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__281.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var CompositeMode_entriesInitialized;
  function CompositeMode_initEntries() {
    if (CompositeMode_entriesInitialized)
      return Unit_getInstance();
    CompositeMode_entriesInitialized = true;
    var tmp = Companion_getInstance_154();
    CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.invoke_iu2mza_k$(_no_name_provided_$factory_228()));
    CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_154()._UNIMPLEMENTED);
    var tmp_0 = Companion_getInstance_154();
    CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.invoke_iu2mza_k$(_no_name_provided_$factory_229()));
    var tmp_1 = Companion_getInstance_154();
    CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.invoke_iu2mza_k$(_no_name_provided_$factory_230()));
    CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_154()._UNIMPLEMENTED);
    CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_154()._UNIMPLEMENTED);
    CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_154()._UNIMPLEMENTED);
    CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_154()._UNIMPLEMENTED);
    CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_154()._UNIMPLEMENTED);
    CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_154()._UNIMPLEMENTED);
    CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_154()._UNIMPLEMENTED);
    CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_154()._UNIMPLEMENTED);
    Companion_getInstance_155();
  }
  function CompositeMode(name, ordinal, op) {
    Enum.call(this, name, ordinal);
    this._op = op;
  }
  CompositeMode.prototype.blend_o7m4og_k$ = function (dst, dstN, src, srcN, count_0) {
    this._op.blend_o7m4og_k$(dst, dstN, src, srcN, count_0);
  };
  CompositeMode.$metadata$ = {
    simpleName: 'CompositeMode',
    kind: 'class',
    interfaces: [CompositeOperation]
  };
  var BlendMode_NORMAL_instance;
  var BlendMode_MULTIPLY_instance;
  var BlendMode_SCREEN_instance;
  var BlendMode_OVERLAY_instance;
  var BlendMode_DARKEN_instance;
  var BlendMode_LIGHTEN_instance;
  var BlendMode_COLOR_DODGE_instance;
  var BlendMode_COLOR_BURN_instance;
  var BlendMode_HARD_LIGHT_instance;
  var BlendMode_SOFT_LIGHT_instance;
  var BlendMode_DIFFERENCE_instance;
  var BlendMode_EXCLUSION_instance;
  var BlendMode_HUE_instance;
  var BlendMode_SATURATION_instance;
  var BlendMode_COLOR_instance;
  var BlendMode_LUMINOSITY_instance;
  var BlendMode_ADDITION_instance;
  var BlendMode_SUBTRACT_instance;
  var BlendMode_DIVIDE_instance;
  var BlendMode_entriesInitialized;
  function BlendMode_initEntries() {
    if (BlendMode_entriesInitialized)
      return Unit_getInstance();
    BlendMode_entriesInitialized = true;
    BlendMode_NORMAL_instance = new BlendMode('NORMAL', 0, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_MULTIPLY_instance = new BlendMode('MULTIPLY', 1, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_SCREEN_instance = new BlendMode('SCREEN', 2, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_OVERLAY_instance = new BlendMode('OVERLAY', 3, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_DARKEN_instance = new BlendMode('DARKEN', 4, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_LIGHTEN_instance = new BlendMode('LIGHTEN', 5, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_COLOR_DODGE_instance = new BlendMode('COLOR_DODGE', 6, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_COLOR_BURN_instance = new BlendMode('COLOR_BURN', 7, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_HARD_LIGHT_instance = new BlendMode('HARD_LIGHT', 8, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_SOFT_LIGHT_instance = new BlendMode('SOFT_LIGHT', 9, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_DIFFERENCE_instance = new BlendMode('DIFFERENCE', 10, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_EXCLUSION_instance = new BlendMode('EXCLUSION', 11, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_HUE_instance = new BlendMode('HUE', 12, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_SATURATION_instance = new BlendMode('SATURATION', 13, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_COLOR_instance = new BlendMode('COLOR', 14, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_LUMINOSITY_instance = new BlendMode('LUMINOSITY', 15, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_ADDITION_instance = new BlendMode('ADDITION', 16, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_SUBTRACT_instance = new BlendMode('SUBTRACT', 17, Companion_getInstance_154()._UNIMPLEMENTED);
    BlendMode_DIVIDE_instance = new BlendMode('DIVIDE', 18, Companion_getInstance_154()._UNIMPLEMENTED);
  }
  function BlendMode(name, ordinal, op) {
    Enum.call(this, name, ordinal);
    this._op_0 = op;
  }
  BlendMode.prototype.blend_o7m4og_k$ = function (dst, dstN, src, srcN, count_0) {
    this._op_0.blend_o7m4og_k$(dst, dstN, src, srcN, count_0);
  };
  BlendMode.$metadata$ = {
    simpleName: 'BlendMode',
    kind: 'class',
    interfaces: [CompositeOperation]
  };
  function _get_DEFAULT_(_this_) {
    return Companion_getInstance_155()._get_DEFAULT__0_k$();
  }
  function CompositeMode_CLEAR_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_CLEAR_instance;
  }
  function CompositeMode_COPY_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_COPY_instance;
  }
  function CompositeMode_SOURCE_OVER_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_OVER_instance;
  }
  function CompositeMode_DESTINATION_OVER_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_DESTINATION_OVER_instance;
  }
  function CompositeMode_SOURCE_IN_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_IN_instance;
  }
  function CompositeMode_DESTINATION_IN_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_DESTINATION_IN_instance;
  }
  function CompositeMode_SOURCE_OUT_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_OUT_instance;
  }
  function CompositeMode_DESTINATION_OUT_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_DESTINATION_OUT_instance;
  }
  function CompositeMode_SOURCE_ATOP_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_ATOP_instance;
  }
  function CompositeMode_DESTINATION_ATOP_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_DESTINATION_ATOP_instance;
  }
  function CompositeMode_XOR_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_XOR_instance;
  }
  function CompositeMode_LIGHTER_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_LIGHTER_instance;
  }
  function BlendMode_NORMAL_getInstance() {
    BlendMode_initEntries();
    return BlendMode_NORMAL_instance;
  }
  function BlendMode_MULTIPLY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_MULTIPLY_instance;
  }
  function BlendMode_SCREEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SCREEN_instance;
  }
  function BlendMode_OVERLAY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_OVERLAY_instance;
  }
  function BlendMode_DARKEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DARKEN_instance;
  }
  function BlendMode_LIGHTEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_LIGHTEN_instance;
  }
  function BlendMode_COLOR_DODGE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_DODGE_instance;
  }
  function BlendMode_COLOR_BURN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_BURN_instance;
  }
  function BlendMode_HARD_LIGHT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_HARD_LIGHT_instance;
  }
  function BlendMode_SOFT_LIGHT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SOFT_LIGHT_instance;
  }
  function BlendMode_DIFFERENCE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DIFFERENCE_instance;
  }
  function BlendMode_EXCLUSION_getInstance() {
    BlendMode_initEntries();
    return BlendMode_EXCLUSION_instance;
  }
  function BlendMode_HUE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_HUE_instance;
  }
  function BlendMode_SATURATION_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SATURATION_instance;
  }
  function BlendMode_COLOR_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_instance;
  }
  function BlendMode_LUMINOSITY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_LUMINOSITY_instance;
  }
  function _no_name_provided_$factory_227() {
    var i = new _no_name_provided__277();
    return function (p1, p2, p3, p4, p5) {
      i.invoke_o7m4og_k$(p1._ints_0, p2, p3._ints_0, p4, p5);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_228() {
    var i = new _no_name_provided__279();
    return function (p1, p2, p3, p4, p5) {
      i.invoke_o7m4og_k$(p1._ints_0, p2, p3._ints_0, p4, p5);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_229() {
    var i = new _no_name_provided__280();
    return function (p1, p2, p3, p4, p5) {
      i.invoke_o7m4og_k$(p1._ints_0, p2, p3._ints_0, p4, p5);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_230() {
    var i = new _no_name_provided__281();
    return function (p1, p2, p3, p4, p5) {
      i.invoke_o7m4og_k$(p1._ints_0, p2, p3._ints_0, p4, p5);
      return Unit_getInstance();
    };
  }
  function State_init_$Init$(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      transform = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }if (!(($mask0 & 2) === 0))
      clip = null;
    if (!(($mask0 & 4) === 0)) {
      path_0 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    }if (!(($mask0 & 8) === 0))
      lineScaleMode = LineScaleMode_NORMAL_getInstance();
    if (!(($mask0 & 16) === 0))
      lineWidth = 1.0;
    if (!(($mask0 & 32) === 0))
      startLineCap = LineCap_BUTT_getInstance();
    if (!(($mask0 & 64) === 0))
      endLineCap = LineCap_BUTT_getInstance();
    if (!(($mask0 & 128) === 0))
      lineJoin = LineJoin_MITER_getInstance();
    if (!(($mask0 & 256) === 0))
      miterLimit = 4.0;
    if (!(($mask0 & 512) === 0))
      strokeStyle = new RGBA(_get_DefaultPaint_());
    if (!(($mask0 & 1024) === 0))
      fillStyle = new RGBA(_get_DefaultPaint_());
    if (!(($mask0 & 2048) === 0))
      fontRegistry = SystemFontRegistry_getInstance();
    if (!(($mask0 & 4096) === 0))
      font = SystemFontRegistry_getInstance()._DEFAULT_FONT;
    if (!(($mask0 & 8192) === 0))
      fontSize = 24.0;
    if (!(($mask0 & 16384) === 0))
      verticalAlign = Companion_getInstance_151()._BASELINE;
    if (!(($mask0 & 32768) === 0))
      horizontalAlign = Companion_getInstance_152()._LEFT;
    if (!(($mask0 & 65536) === 0))
      globalAlpha = 1.0;
    if (!(($mask0 & 131072) === 0))
      globalCompositeOperation = CompositeMode_SOURCE_OVER_getInstance();
    State.call($this, transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation);
    return $this;
  }
  function State_init_$Create$(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, $mask0, $marker) {
    return State_init_$Init$(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, $mask0, $marker, Object.create(State.prototype));
  }
  function _no_name_provided__282(this$0) {
    this._this$0_64 = this$0;
  }
  _no_name_provided__282.prototype.invoke_0_k$ = function () {
    var tmp = this._this$0_64._transform_6;
    return tmp.toTransform$default_888p34_k$(null, 1, null);
  };
  _no_name_provided__282.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_157() {
    Companion_instance_156 = this;
  }
  Companion_157.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_156;
  function Companion_getInstance_156() {
    if (Companion_instance_156 == null)
      new Companion_157();
    return Companion_instance_156;
  }
  function State(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation) {
    this._transform_6 = transform;
    this._clip = clip;
    this._path_22 = path_0;
    this._lineScaleMode = lineScaleMode;
    this._lineWidth = lineWidth;
    this._startLineCap = startLineCap;
    this._endLineCap = endLineCap;
    this._lineJoin = lineJoin;
    this._miterLimit_0 = miterLimit;
    this._strokeStyle = strokeStyle;
    this._fillStyle = fillStyle;
    this._fontRegistry = fontRegistry;
    this._font_0 = font;
    this._fontSize_2 = fontSize;
    this._verticalAlign_0 = verticalAlign;
    this._horizontalAlign_0 = horizontalAlign;
    this._globalAlpha = globalAlpha;
    this._globalCompositeOperation = globalCompositeOperation;
    var tmp = this;
    tmp._transformTransform$delegate = lazy(_no_name_provided_$factory_231(this));
  }
  State.prototype._get_transformTransform__0_k$ = function () {
    var tmp0_getValue_0 = transformTransform$factory();
    return this._transformTransform$delegate._get_value__0_k$();
  };
  State.prototype._get_scaledLineWidth__0_k$ = function () {
    var tmp = this._lineWidth;
    var tmp0__get_absoluteValue__0 = this._get_transformTransform__0_k$()._get_scaleAvg__0_k$();
    return tmp * Math.abs(tmp0__get_absoluteValue__0);
  };
  State.prototype._set_lineCap__li1cb3_k$ = function (value) {
    this._startLineCap = value;
    this._endLineCap = value;
  };
  State.prototype._get_lineCap__0_k$ = function () {
    return this._startLineCap;
  };
  State.prototype.clone_0_k$ = function () {
    var tmp = this._transform_6.clone_0_k$();
    var tmp0_safe_receiver = this._clip;
    var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.clone_0_k$();
    var tmp_1 = this._path_22.clone_0_k$();
    return this.copy$default_cupedu_k$(tmp, tmp_0, tmp_1, null, 0.0, null, null, null, 0.0, null, null, null, null, 0.0, null, null, 0.0, null, 262136, null);
  };
  State.prototype.copy_kdidsn_k$ = function (transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation) {
    return new State(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation);
  };
  State.prototype.copy$default_cupedu_k$ = function (transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      transform = this._transform_6;
    if (!(($mask0 & 2) === 0))
      clip = this._clip;
    if (!(($mask0 & 4) === 0))
      path_0 = this._path_22;
    if (!(($mask0 & 8) === 0))
      lineScaleMode = this._lineScaleMode;
    if (!(($mask0 & 16) === 0))
      lineWidth = this._lineWidth;
    if (!(($mask0 & 32) === 0))
      startLineCap = this._startLineCap;
    if (!(($mask0 & 64) === 0))
      endLineCap = this._endLineCap;
    if (!(($mask0 & 128) === 0))
      lineJoin = this._lineJoin;
    if (!(($mask0 & 256) === 0))
      miterLimit = this._miterLimit_0;
    if (!(($mask0 & 512) === 0))
      strokeStyle = this._strokeStyle;
    if (!(($mask0 & 1024) === 0))
      fillStyle = this._fillStyle;
    if (!(($mask0 & 2048) === 0))
      fontRegistry = this._fontRegistry;
    if (!(($mask0 & 4096) === 0))
      font = this._font_0;
    if (!(($mask0 & 8192) === 0))
      fontSize = this._fontSize_2;
    if (!(($mask0 & 16384) === 0))
      verticalAlign = this._verticalAlign_0;
    if (!(($mask0 & 32768) === 0))
      horizontalAlign = this._horizontalAlign_0;
    if (!(($mask0 & 65536) === 0))
      globalAlpha = this._globalAlpha;
    if (!(($mask0 & 131072) === 0))
      globalCompositeOperation = this._globalCompositeOperation;
    return this.copy_kdidsn_k$(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation);
  };
  State.prototype.toString = function () {
    return '' + 'State(transform=' + this._transform_6 + ', clip=' + this._clip + ', path=' + this._path_22 + ', lineScaleMode=' + this._lineScaleMode + ', lineWidth=' + this._lineWidth + ', startLineCap=' + this._startLineCap + ', endLineCap=' + this._endLineCap + ', lineJoin=' + this._lineJoin + ', miterLimit=' + this._miterLimit_0 + ', strokeStyle=' + this._strokeStyle + ', fillStyle=' + this._fillStyle + ', fontRegistry=' + this._fontRegistry + ', font=' + this._font_0 + ', fontSize=' + this._fontSize_2 + ', verticalAlign=' + new VerticalAlign(this._verticalAlign_0) + ', horizontalAlign=' + new HorizontalAlign(this._horizontalAlign_0) + ', globalAlpha=' + this._globalAlpha + ', globalCompositeOperation=' + this._globalCompositeOperation + ')';
  };
  State.prototype.hashCode = function () {
    var result = this._transform_6.hashCode();
    result = imul(result, 31) + (this._clip == null ? 0 : hashCode(this._clip)) | 0;
    result = imul(result, 31) + hashCode(this._path_22) | 0;
    result = imul(result, 31) + this._lineScaleMode.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._lineWidth) | 0;
    result = imul(result, 31) + this._startLineCap.hashCode() | 0;
    result = imul(result, 31) + this._endLineCap.hashCode() | 0;
    result = imul(result, 31) + this._lineJoin.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._miterLimit_0) | 0;
    result = imul(result, 31) + hashCode(this._strokeStyle) | 0;
    result = imul(result, 31) + hashCode(this._fillStyle) | 0;
    result = imul(result, 31) + hashCode(this._fontRegistry) | 0;
    result = imul(result, 31) + hashCode(this._font_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._fontSize_2) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl(this._verticalAlign_0) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl(this._horizontalAlign_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._globalAlpha) | 0;
    result = imul(result, 31) + hashCode(this._globalCompositeOperation) | 0;
    return result;
  };
  State.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this._transform_6.equals(tmp0_other_with_cast._transform_6))
      return false;
    if (!equals_1(this._clip, tmp0_other_with_cast._clip))
      return false;
    if (!equals_1(this._path_22, tmp0_other_with_cast._path_22))
      return false;
    if (!this._lineScaleMode.equals(tmp0_other_with_cast._lineScaleMode))
      return false;
    if (!equals_1(this._lineWidth, tmp0_other_with_cast._lineWidth))
      return false;
    if (!this._startLineCap.equals(tmp0_other_with_cast._startLineCap))
      return false;
    if (!this._endLineCap.equals(tmp0_other_with_cast._endLineCap))
      return false;
    if (!this._lineJoin.equals(tmp0_other_with_cast._lineJoin))
      return false;
    if (!equals_1(this._miterLimit_0, tmp0_other_with_cast._miterLimit_0))
      return false;
    if (!equals_1(this._strokeStyle, tmp0_other_with_cast._strokeStyle))
      return false;
    if (!equals_1(this._fillStyle, tmp0_other_with_cast._fillStyle))
      return false;
    if (!equals_1(this._fontRegistry, tmp0_other_with_cast._fontRegistry))
      return false;
    if (!equals_1(this._font_0, tmp0_other_with_cast._font_0))
      return false;
    if (!equals_1(this._fontSize_2, tmp0_other_with_cast._fontSize_2))
      return false;
    if (!equals_1(new VerticalAlign(this._verticalAlign_0), new VerticalAlign(tmp0_other_with_cast._verticalAlign_0)))
      return false;
    if (!equals_1(new HorizontalAlign(this._horizontalAlign_0), new HorizontalAlign(tmp0_other_with_cast._horizontalAlign_0)))
      return false;
    if (!equals_1(this._globalAlpha, tmp0_other_with_cast._globalAlpha))
      return false;
    if (!equals_1(this._globalCompositeOperation, tmp0_other_with_cast._globalCompositeOperation))
      return false;
    return true;
  };
  State.$metadata$ = {
    simpleName: 'State',
    kind: 'class',
    interfaces: []
  };
  function transX($this, x, y) {
    return $this._state_5._transform_6.transformX_ngl742_k$(x, y);
  }
  function transY($this, x, y) {
    return $this._state_5._transform_6.transformY_ngl742_k$(x, y);
  }
  function Context2d(renderer) {
    Companion_getInstance_156();
    this._renderer = renderer;
    var tmp = this;
    tmp._state_5 = State_init_$Create$(null, null, null, null, 0.0, null, null, null, 0.0, null, null, null, null, 0.0, null, null, 0.0, null, 262143, null);
    this._stack_1 = new TGenStack();
    this._moveX = 0.0;
    this._moveY = 0.0;
    this._lastX_1 = 0.0;
    this._lastY_1 = 0.0;
  }
  Context2d.prototype._get_rendererWidth__0_k$ = function () {
    return this._renderer._get_width__0_k$();
  };
  Context2d.prototype._get_rendererHeight__0_k$ = function () {
    return this._renderer._get_height__0_k$();
  };
  Context2d.prototype.rendererRender_eshf5c_k$ = function (state, fill_4) {
    return this._renderer.render_eshf5c_k$(state, fill_4);
  };
  Context2d.prototype.rendererDrawImage_ay2py0_k$ = function (image, x, y, width, height, transform) {
    return this._renderer.drawImage_ay2py0_k$(image, x, y, width, height, transform);
  };
  Context2d.prototype.rendererDispose_sv8swh_k$ = function () {
    return this._renderer.dispose_sv8swh_k$();
  };
  Context2d.prototype.rendererBufferingStart_0_k$ = function () {
    return this._renderer.bufferingStart_0_k$();
  };
  Context2d.prototype.rendererBufferingEnd_sv8swh_k$ = function () {
    return this._renderer.bufferingEnd_sv8swh_k$();
  };
  Context2d.prototype.rendererRenderSystemText_yii0ob_k$ = function (state, font, fontSize, text, x, y, fill_4) {
    var tmp = fill_4 ? state._fillStyle : state._strokeStyle;
    drawText$default(font, this, fontSize, text, tmp, x, y, fill_4, null, null, 384, null);
  };
  Context2d.prototype.fillText_uk3s5w_k$ = function (text, x, y) {
    return this.rendererRenderSystemText_yii0ob_k$(this._state_5, this._get_font__0_k$(), this._get_fontSize__0_k$(), text, x, y, true);
  };
  Context2d.prototype.strokeText_uk3s5w_k$ = function (text, x, y) {
    return this.rendererRenderSystemText_yii0ob_k$(this._state_5, this._get_font__0_k$(), this._get_fontSize__0_k$(), text, x, y, false);
  };
  Context2d.prototype._get_width__0_k$ = function () {
    return this._get_rendererWidth__0_k$();
  };
  Context2d.prototype._get_height__0_k$ = function () {
    return this._get_rendererHeight__0_k$();
  };
  Context2d.prototype.dispose_sv8swh_k$ = function () {
    this.rendererDispose_sv8swh_k$();
  };
  Context2d.prototype._rendererBufferingStart_0_k$ = function () {
    return this.rendererBufferingStart_0_k$();
  };
  Context2d.prototype._rendererBufferingEnd_sv8swh_k$ = function () {
    return this.rendererBufferingEnd_sv8swh_k$();
  };
  Context2d.prototype._set_lineScaleMode__q9fhdc_k$ = function (value) {
    this._state_5._lineScaleMode = value;
    return Unit_getInstance();
  };
  Context2d.prototype._set_lineWidth__okcceq_k$ = function (value) {
    this._state_5._lineWidth = value;
    return Unit_getInstance();
  };
  Context2d.prototype._set_lineCap__li1cb3_k$ = function (value) {
    return this._state_5._set_lineCap__li1cb3_k$(value);
  };
  Context2d.prototype._get_lineCap__0_k$ = function () {
    return this._state_5._get_lineCap__0_k$();
  };
  Context2d.prototype._set_lineJoin__n3bztj_k$ = function (value) {
    this._state_5._lineJoin = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_lineJoin__0_k$ = function () {
    return this._state_5._lineJoin;
  };
  Context2d.prototype._set_strokeStyle__y73s1i_k$ = function (value) {
    this._state_5._strokeStyle = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_strokeStyle__0_k$ = function () {
    return this._state_5._strokeStyle;
  };
  Context2d.prototype._set_fillStyle__y73s1i_k$ = function (value) {
    this._state_5._fillStyle = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_fillStyle__0_k$ = function () {
    return this._state_5._fillStyle;
  };
  Context2d.prototype._get_fontRegistry__0_k$ = function () {
    return this._state_5._fontRegistry;
  };
  Context2d.prototype._set_font__jq2c8m_k$ = function (value) {
    this._state_5._font_0 = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_font__0_k$ = function () {
    return this._state_5._font_0;
  };
  Context2d.prototype._set_fontSize__okcceq_k$ = function (value) {
    this._state_5._fontSize_2 = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_fontSize__0_k$ = function () {
    return this._state_5._fontSize_2;
  };
  Context2d.prototype._set_verticalAlign__4c4bf4_k$ = function (value) {
    this._state_5._verticalAlign_0 = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_verticalAlign__8gdh1a_k$ = function () {
    return this._state_5._verticalAlign_0;
  };
  Context2d.prototype._set_horizontalAlign__4fnuf6_k$ = function (value) {
    this._state_5._horizontalAlign_0 = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_horizontalAlign__mfkab4_k$ = function () {
    return this._state_5._horizontalAlign_0;
  };
  Context2d.prototype._set_globalAlpha__okcceq_k$ = function (value) {
    this._state_5._globalAlpha = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_globalAlpha__0_k$ = function () {
    return this._state_5._globalAlpha;
  };
  Context2d.prototype.save_sv8swh_k$ = function () {
    return this._stack_1.push_xoeh3q_k$(this._state_5.clone_0_k$());
  };
  Context2d.prototype.restore_sv8swh_k$ = function () {
    this._state_5 = this._stack_1.pop_0_k$();
    return Unit_getInstance();
  };
  Context2d.prototype.scale_ngl742_k$ = function (sx, sy) {
    return this._state_5._transform_6.prescale_ngl742_k$(sx, sy);
  };
  Context2d.prototype.scale$default_hdt4os_k$ = function (sx, sy, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      sy = sx;
    return this.scale_ngl742_k$(sx, sy);
  };
  Context2d.prototype.rotate_ubek5g_k$ = function (angle) {
    return this._state_5._transform_6.prerotate_ubek5g_k$(angle);
  };
  Context2d.prototype.translate_ngl742_k$ = function (tx_0, ty_0) {
    return this._state_5._transform_6.pretranslate_ngl742_k$(tx_0, ty_0);
  };
  Context2d.prototype.transform_lwp7hs_k$ = function (m) {
    return this._state_5._transform_6.premultiply_lwp7hs_k$(m);
  };
  Context2d.prototype._set_lastX__okcceq_k$ = function (_set___) {
    this._lastX_1 = _set___;
  };
  Context2d.prototype._get_lastX__0_k$ = function () {
    return this._lastX_1;
  };
  Context2d.prototype._set_lastY__okcceq_k$ = function (_set___) {
    this._lastY_1 = _set___;
  };
  Context2d.prototype._get_lastY__0_k$ = function () {
    return this._lastY_1;
  };
  Context2d.prototype._get_totalPoints__0_k$ = function () {
    return this._state_5._path_22._get_totalPoints__0_k$();
  };
  Context2d.prototype.close_sv8swh_k$ = function () {
    this._state_5._path_22.close_sv8swh_k$();
    this._set_lastX__okcceq_k$(this._moveX);
    this._set_lastY__okcceq_k$(this._moveY);
  };
  Context2d.prototype.moveTo_ul66c3_k$ = function (x, y) {
    this._state_5._path_22.moveTo_ul66c3_k$(transX(this, x, y), transY(this, x, y));
    this._set_lastX__okcceq_k$(x);
    this._set_lastY__okcceq_k$(y);
    this._moveX = x;
    this._moveY = y;
  };
  Context2d.prototype.lineTo_ul66c3_k$ = function (x, y) {
    this._state_5._path_22.lineTo_ul66c3_k$(transX(this, x, y), transY(this, x, y));
    this._set_lastX__okcceq_k$(x);
    this._set_lastY__okcceq_k$(y);
  };
  Context2d.prototype.quadTo_lf7oid_k$ = function (cx, cy, ax, ay) {
    this._state_5._path_22.quadTo_lf7oid_k$(transX(this, cx, cy), transY(this, cx, cy), transX(this, ax, ay), transY(this, ax, ay));
    this._set_lastX__okcceq_k$(ax);
    this._set_lastY__okcceq_k$(ay);
  };
  Context2d.prototype.cubicTo_iylh49_k$ = function (cx1, cy1, cx2, cy2, ax, ay) {
    this._state_5._path_22.cubicTo_iylh49_k$(transX(this, cx1, cy1), transY(this, cx1, cy1), transX(this, cx2, cy2), transY(this, cx2, cy2), transX(this, ax, ay), transY(this, ax, ay));
    this._set_lastX__okcceq_k$(ax);
    this._set_lastY__okcceq_k$(ay);
  };
  Context2d.prototype.path_f4hqzb_k$ = function (path_0) {
    write_0(this, path_0);
  };
  Context2d.prototype.draw_ndfaxx_k$ = function (d) {
    return d.draw_h81jc_k$(this);
  };
  Context2d.prototype.fillRect_lf7oid_k$ = function (x, y, width, height) {
    this.beginPath_sv8swh_k$();
    rect(this, x, y, width, height);
    return this.fill_sv8swh_k$();
  };
  Context2d.prototype.beginPath_sv8swh_k$ = function () {
    var tmp = this._state_5;
    tmp._path_22 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    return Unit_getInstance();
  };
  Context2d.prototype.getBounds_uebyw0_k$ = function (out) {
    var tmp = this._state_5._path_22;
    return tmp.getBounds$default_lrzlif_k$(out, null, 2, null);
  };
  Context2d.prototype.stroke_sv8swh_k$ = function () {
    return !equals_1(this._state_5._strokeStyle, NonePaint_getInstance()) ? this.rendererRender_eshf5c_k$(this._state_5, false) : void 0;
  };
  Context2d.prototype.fill_sv8swh_k$ = function () {
    return !equals_1(this._state_5._fillStyle, NonePaint_getInstance()) ? this.rendererRender_eshf5c_k$(this._state_5, true) : void 0;
  };
  Context2d.prototype.fill_y73s1i_k$ = function (paint) {
    var oldStyle_1 = this._get_fillStyle__0_k$();
    this._set_fillStyle__y73s1i_k$(paint);
    try {
      this.fill_sv8swh_k$();
    }finally {
      this._set_fillStyle__y73s1i_k$(oldStyle_1);
    }
  };
  Context2d.prototype.stroke_y73s1i_k$ = function (paint) {
    var oldStyle_1 = this._get_strokeStyle__0_k$();
    this._set_strokeStyle__y73s1i_k$(paint);
    try {
      this.stroke_sv8swh_k$();
    }finally {
      this._set_strokeStyle__y73s1i_k$(oldStyle_1);
    }
  };
  Context2d.prototype.fillStroke_sv8swh_k$ = function () {
    this.fill_sv8swh_k$();
    return this.stroke_sv8swh_k$();
  };
  Context2d.prototype.clip_juy7ke_k$ = function (path_0, winding) {
    if (!(path_0 == null)) {
      if (this._state_5._clip == null) {
        var tmp = this._state_5;
        tmp._clip = GraphicsPath_init_$Create$(null, null, null, 7, null);
      }ensureNotNull(this._state_5._clip).clear_sv8swh_k$();
      ensureNotNull(this._state_5._clip)._set_winding__ohnhtf_k$(winding);
      var tmp_0 = ensureNotNull(this._state_5._clip);
      tmp_0.write$default_jet5j6_k$(path_0, null, 2, null);
    } else {
      this._state_5._clip = null;
    }
  };
  Context2d.prototype.clip$default_x61tnv_k$ = function (path_0, winding, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      path_0 = this._state_5._path_22;
    if (!(($mask0 & 2) === 0))
      winding = Winding_NON_ZERO_getInstance();
    return this.clip_juy7ke_k$(path_0, winding);
  };
  Context2d.prototype.createColor_abrt0h_k$ = function (color_0) {
    return color_0;
  };
  Context2d.prototype.drawImage_c2z1l2_k$ = function (image, x, y, width, height) {
    return this.rendererDrawImage_ay2py0_k$(image, x, y, width, height, this._state_5._transform_6);
  };
  Context2d.prototype.drawImage$default_aaejay_k$ = function (image, x, y, width, height, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      width = image._width_2;
    if (!(($mask0 & 16) === 0))
      height = image._height_3;
    return $handler == null ? this.drawImage_c2z1l2_k$(image, x, y, width, height) : $handler(image, x, y, width, height);
  };
  Context2d.$metadata$ = {
    simpleName: 'Context2d',
    kind: 'class',
    interfaces: [Disposable, VectorBuilder]
  };
  function write_0(_this_, path_0) {
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = path_0._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__0_k$()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_ha5a7z_k$(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      Command_getInstance();
      if (tmp0_subject_4_6 === 0) {
        var tmp1_5_7 = n_1;
        n_1 = tmp1_5_7 + 1 | 0;
        var tmp0__anonymous__21 = path_0._data_11.get_ha5a7z_k$(tmp1_5_7);
        var tmp2_6_8 = n_1;
        n_1 = tmp2_6_8 + 1 | 0;
        var tmp1__anonymous__21 = path_0._data_11.get_ha5a7z_k$(tmp2_6_8);
        _this_.moveTo_ul66c3_k$(tmp0__anonymous__21, tmp1__anonymous__21);
      } else {
        Command_getInstance();
        if (tmp0_subject_4_6 === 1) {
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__22 = path_0._data_11.get_ha5a7z_k$(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__22 = path_0._data_11.get_ha5a7z_k$(tmp4_8_10);
          _this_.lineTo_ul66c3_k$(tmp2__anonymous__22, tmp3__anonymous__22);
        } else {
          Command_getInstance();
          if (tmp0_subject_4_6 === 2) {
            var tmp5_9_11 = n_1;
            n_1 = tmp5_9_11 + 1 | 0;
            var tmp4__anonymous__23 = path_0._data_11.get_ha5a7z_k$(tmp5_9_11);
            var tmp6_10_12 = n_1;
            n_1 = tmp6_10_12 + 1 | 0;
            var tmp5__anonymous__23 = path_0._data_11.get_ha5a7z_k$(tmp6_10_12);
            var tmp7_11_13 = n_1;
            n_1 = tmp7_11_13 + 1 | 0;
            var tmp6__anonymous__23 = path_0._data_11.get_ha5a7z_k$(tmp7_11_13);
            var tmp8_12_14 = n_1;
            n_1 = tmp8_12_14 + 1 | 0;
            var tmp7__anonymous__23 = path_0._data_11.get_ha5a7z_k$(tmp8_12_14);
            _this_.quadTo_lf7oid_k$(tmp4__anonymous__23, tmp5__anonymous__23, tmp6__anonymous__23, tmp7__anonymous__23);
          } else {
            Command_getInstance();
            if (tmp0_subject_4_6 === 3) {
              var tmp9_13_15 = n_1;
              n_1 = tmp9_13_15 + 1 | 0;
              var tmp8__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp9_13_15);
              var tmp10_14_16 = n_1;
              n_1 = tmp10_14_16 + 1 | 0;
              var tmp9__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp10_14_16);
              var tmp11_15_17 = n_1;
              n_1 = tmp11_15_17 + 1 | 0;
              var tmp10__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp11_15_17);
              var tmp12_16_18 = n_1;
              n_1 = tmp12_16_18 + 1 | 0;
              var tmp11__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp12_16_18);
              var tmp13_17_19 = n_1;
              n_1 = tmp13_17_19 + 1 | 0;
              var tmp12__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp13_17_19);
              var tmp14_18_20 = n_1;
              n_1 = tmp14_18_20 + 1 | 0;
              var tmp13__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp14_18_20);
              _this_.cubicTo_iylh49_k$(tmp8__anonymous__24, tmp9__anonymous__24, tmp10__anonymous__24, tmp11__anonymous__24, tmp12__anonymous__24, tmp13__anonymous__24);
            } else {
              Command_getInstance();
              if (tmp0_subject_4_6 === 4) {
                _this_.close_sv8swh_k$();
              } else {
              }
            }
          }
        }
      }
    }
  }
  function render(_this_) {
    var tmp = render_0(_this_, true);
    return tmp instanceof NativeImage ? tmp : THROW_CCE();
  }
  function render_0(_this_, native) {
    var tmp = _this_._get_width__0_k$();
    var tmp_0 = _this_._get_height__0_k$();
    var tmp0_context2d_0 = NativeImageOrBitmap32$default(tmp, tmp_0, native, null, 8, null);
    tmp0_context2d_0.lock_sv8swh_k$();
    try {
      var ctx_2_1 = tmp0_context2d_0.getContext2d_vcj5fe_k$(true);
      try {
        _this_.draw_h81jc_k$(ctx_2_1);
      }finally {
        ctx_2_1.dispose_sv8swh_k$();
      }
    }finally {
      tmp0_context2d_0.unlock_ixubtt_k$(null);
      Unit_getInstance();
    }
    return tmp0_context2d_0;
  }
  function transformTransform$factory() {
    return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
      return receiver._get_transformTransform__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_231(this$0) {
    var i = new _no_name_provided__282(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  var CycleMethod_NO_CYCLE_instance;
  var CycleMethod_REFLECT_instance;
  var CycleMethod_REPEAT_instance;
  function Companion_158() {
    Companion_instance_157 = this;
  }
  Companion_158.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_157;
  function Companion_getInstance_157() {
    if (Companion_instance_157 == null)
      new Companion_158();
    return Companion_instance_157;
  }
  var CycleMethod_entriesInitialized;
  function CycleMethod_initEntries() {
    if (CycleMethod_entriesInitialized)
      return Unit_getInstance();
    CycleMethod_entriesInitialized = true;
    CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
    CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 1);
    CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
    Companion_getInstance_157();
  }
  function CycleMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CycleMethod.prototype._get_repeating__0_k$ = function () {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance());
  };
  CycleMethod.prototype.apply_om2dwb_k$ = function (ratio, clamp_6) {
    var tmp0_subject = this;
    var tmp;
    if (tmp0_subject.equals(CycleMethod_NO_CYCLE_getInstance())) {
      tmp = clamp_6 ? clamp01(ratio) : ratio;
    } else if (tmp0_subject.equals(CycleMethod_REPEAT_getInstance())) {
      tmp = ratio % 1;
    } else if (tmp0_subject.equals(CycleMethod_REFLECT_getInstance())) {
      var part = ratio % 2;
      tmp = part > 1.0 ? 2.0 - part : part;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CycleMethod.prototype.apply$default_5ig8jr_k$ = function (ratio, clamp_6, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      clamp_6 = false;
    return this.apply_om2dwb_k$(ratio, clamp_6);
  };
  CycleMethod.prototype.apply_ngl742_k$ = function (value, size_2) {
    var tmp = value / size_2;
    return this.apply$default_5ig8jr_k$(tmp, false, 2, null) * size_2;
  };
  CycleMethod.$metadata$ = {
    simpleName: 'CycleMethod',
    kind: 'class',
    interfaces: []
  };
  function CycleMethod_NO_CYCLE_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_NO_CYCLE_instance;
  }
  function CycleMethod_REFLECT_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_REFLECT_instance;
  }
  function CycleMethod_REPEAT_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_REPEAT_instance;
  }
  function Drawable() {
  }
  Drawable.$metadata$ = {
    simpleName: 'Drawable',
    kind: 'interface',
    interfaces: []
  };
  function SizedDrawable() {
  }
  SizedDrawable.$metadata$ = {
    simpleName: 'SizedDrawable',
    kind: 'interface',
    interfaces: [Drawable]
  };
  function BoundsDrawable() {
  }
  BoundsDrawable.prototype._get_width__0_k$ = function () {
    return numberToInt(this._get_bounds__0_k$()._width_0);
  };
  BoundsDrawable.prototype._get_height__0_k$ = function () {
    return numberToInt(this._get_bounds__0_k$()._height_0);
  };
  BoundsDrawable.$metadata$ = {
    simpleName: 'BoundsDrawable',
    kind: 'interface',
    interfaces: [SizedDrawable]
  };
  function GraphicsPath_init_$Init$(commands, data, winding, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      commands = IntArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 2) === 0)) {
      data = DoubleArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 4) === 0))
      winding = Winding_EVEN_ODD_getInstance();
    GraphicsPath.call($this, commands, data, winding);
    return $this;
  }
  function GraphicsPath_init_$Create$(commands, data, winding, $mask0, $marker) {
    return GraphicsPath_init_$Init$(commands, data, winding, $mask0, $marker, Object.create(GraphicsPath.prototype));
  }
  function GraphicsPath(commands, data, winding) {
    VectorPath.call(this, commands, data, winding);
    var tmp = this;
    tmp._$$delegate_0_23 = Mixin_init_$Create$(null, 1, null);
  }
  GraphicsPath.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_23._set_extra__n1onou_k$(_set___);
  };
  GraphicsPath.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_23._get_extra__0_k$();
  };
  GraphicsPath.prototype._get_width__0_k$ = function () {
    return numberToInt(this.getBounds$default_lrzlif_k$(null, null, 3, null)._width_0);
  };
  GraphicsPath.prototype._get_height__0_k$ = function () {
    return numberToInt(this.getBounds$default_lrzlif_k$(null, null, 3, null)._height_0);
  };
  GraphicsPath.prototype.draw_h81jc_k$ = function (c) {
    return c.path_f4hqzb_k$(this);
  };
  GraphicsPath.prototype.clone_0_k$ = function () {
    return new GraphicsPath(IntArrayList_init_$Create$_0(this._get_commands__0_k$()), DoubleArrayList_init_$Create$_0(this._get_data__0_k$()), this._get_winding__0_k$());
  };
  GraphicsPath.prototype.toString = function () {
    return '' + 'GraphicsPath("' + toSvgPathString$default(this, null, 0, 3, null) + '")';
  };
  GraphicsPath.$metadata$ = {
    simpleName: 'GraphicsPath',
    kind: 'class',
    interfaces: [SizedDrawable, Extra]
  };
  var LineScaleMode_NONE_instance;
  var LineScaleMode_HORIZONTAL_instance;
  var LineScaleMode_VERTICAL_instance;
  var LineScaleMode_NORMAL_instance;
  var LineScaleMode_entriesInitialized;
  function LineScaleMode_initEntries() {
    if (LineScaleMode_entriesInitialized)
      return Unit_getInstance();
    LineScaleMode_entriesInitialized = true;
    LineScaleMode_NONE_instance = new LineScaleMode('NONE', 0, false, false);
    LineScaleMode_HORIZONTAL_instance = new LineScaleMode('HORIZONTAL', 1, true, false);
    LineScaleMode_VERTICAL_instance = new LineScaleMode('VERTICAL', 2, false, true);
    LineScaleMode_NORMAL_instance = new LineScaleMode('NORMAL', 3, true, true);
  }
  function LineScaleMode(name, ordinal, hScale, vScale) {
    Enum.call(this, name, ordinal);
    this._hScale = hScale;
    this._vScale = vScale;
  }
  LineScaleMode.$metadata$ = {
    simpleName: 'LineScaleMode',
    kind: 'class',
    interfaces: []
  };
  function LineScaleMode_NORMAL_getInstance() {
    LineScaleMode_initEntries();
    return LineScaleMode_NORMAL_instance;
  }
  function FillShape_init_$Init$(path_0, clip, paint, transform, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0)) {
      transform = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }FillShape.call($this, path_0, clip, paint, transform);
    return $this;
  }
  function FillShape_init_$Create$(path_0, clip, paint, transform, $mask0, $marker) {
    return FillShape_init_$Init$(path_0, clip, paint, transform, $mask0, $marker, Object.create(FillShape.prototype));
  }
  function FillShape(path_0, clip, paint, transform) {
    this._path_23 = path_0;
    this._clip_0 = clip;
    this._paint_0 = paint;
    this._transform_7 = transform;
  }
  FillShape.prototype._get_path__0_k$ = function () {
    return this._path_23;
  };
  FillShape.prototype._get_clip__0_k$ = function () {
    return this._clip_0;
  };
  FillShape.prototype._get_transform__0_k$ = function () {
    return this._transform_7;
  };
  FillShape.prototype.drawInternal_h81jc_k$ = function (c) {
    c.fill_y73s1i_k$(this._paint_0);
  };
  FillShape.prototype.toString = function () {
    return '' + 'FillShape(path=' + this._path_23 + ', clip=' + this._clip_0 + ', paint=' + this._paint_0 + ', transform=' + this._transform_7 + ')';
  };
  FillShape.prototype.hashCode = function () {
    var result = hashCode(this._path_23);
    result = imul(result, 31) + (this._clip_0 == null ? 0 : hashCode(this._clip_0)) | 0;
    result = imul(result, 31) + hashCode(this._paint_0) | 0;
    result = imul(result, 31) + this._transform_7.hashCode() | 0;
    return result;
  };
  FillShape.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!equals_1(this._path_23, tmp0_other_with_cast._path_23))
      return false;
    if (!equals_1(this._clip_0, tmp0_other_with_cast._clip_0))
      return false;
    if (!equals_1(this._paint_0, tmp0_other_with_cast._paint_0))
      return false;
    if (!this._transform_7.equals(tmp0_other_with_cast._transform_7))
      return false;
    return true;
  };
  FillShape.$metadata$ = {
    simpleName: 'FillShape',
    kind: 'class',
    interfaces: [StyledShape]
  };
  function toSvgPathString(_this_, separator, decimalPlaces) {
    var parts_0 = ArrayList_init_$Create$();
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = _this_._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__0_k$()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_ha5a7z_k$(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      Command_getInstance();
      if (tmp0_subject_4_6 === 0) {
        var tmp1_5_7 = n_1;
        n_1 = tmp1_5_7 + 1 | 0;
        var tmp0__anonymous__21 = _this_._data_11.get_ha5a7z_k$(tmp1_5_7);
        var tmp2_6_8 = n_1;
        n_1 = tmp2_6_8 + 1 | 0;
        var tmp1__anonymous__21 = _this_._data_11.get_ha5a7z_k$(tmp2_6_8);
        var tmp0_plusAssign_0_22 = '' + 'M' + toSvgPathString$fixX(tmp0__anonymous__21, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp1__anonymous__21, decimalPlaces);
        parts_0.add_2bq_k$(tmp0_plusAssign_0_22);
        Unit_getInstance();
      } else {
        Command_getInstance();
        if (tmp0_subject_4_6 === 1) {
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__23 = _this_._data_11.get_ha5a7z_k$(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__23 = _this_._data_11.get_ha5a7z_k$(tmp4_8_10);
          var tmp0_plusAssign_0_24 = '' + 'L' + toSvgPathString$fixX(tmp2__anonymous__23, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp3__anonymous__23, decimalPlaces);
          parts_0.add_2bq_k$(tmp0_plusAssign_0_24);
          Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_4_6 === 2) {
            var tmp5_9_11 = n_1;
            n_1 = tmp5_9_11 + 1 | 0;
            var tmp4__anonymous__25 = _this_._data_11.get_ha5a7z_k$(tmp5_9_11);
            var tmp6_10_12 = n_1;
            n_1 = tmp6_10_12 + 1 | 0;
            var tmp5__anonymous__25 = _this_._data_11.get_ha5a7z_k$(tmp6_10_12);
            var tmp7_11_13 = n_1;
            n_1 = tmp7_11_13 + 1 | 0;
            var tmp6__anonymous__25 = _this_._data_11.get_ha5a7z_k$(tmp7_11_13);
            var tmp8_12_14 = n_1;
            n_1 = tmp8_12_14 + 1 | 0;
            var tmp7__anonymous__25 = _this_._data_11.get_ha5a7z_k$(tmp8_12_14);
            var tmp0_plusAssign_0_26 = '' + 'Q' + toSvgPathString$fixX(tmp4__anonymous__25, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp5__anonymous__25, decimalPlaces) + ', ' + toSvgPathString$fixX(tmp6__anonymous__25, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp7__anonymous__25, decimalPlaces);
            parts_0.add_2bq_k$(tmp0_plusAssign_0_26);
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_4_6 === 3) {
              var tmp9_13_15 = n_1;
              n_1 = tmp9_13_15 + 1 | 0;
              var tmp8__anonymous__27 = _this_._data_11.get_ha5a7z_k$(tmp9_13_15);
              var tmp10_14_16 = n_1;
              n_1 = tmp10_14_16 + 1 | 0;
              var tmp9__anonymous__27 = _this_._data_11.get_ha5a7z_k$(tmp10_14_16);
              var tmp11_15_17 = n_1;
              n_1 = tmp11_15_17 + 1 | 0;
              var tmp10__anonymous__27 = _this_._data_11.get_ha5a7z_k$(tmp11_15_17);
              var tmp12_16_18 = n_1;
              n_1 = tmp12_16_18 + 1 | 0;
              var tmp11__anonymous__27 = _this_._data_11.get_ha5a7z_k$(tmp12_16_18);
              var tmp13_17_19 = n_1;
              n_1 = tmp13_17_19 + 1 | 0;
              var tmp12__anonymous__27 = _this_._data_11.get_ha5a7z_k$(tmp13_17_19);
              var tmp14_18_20 = n_1;
              n_1 = tmp14_18_20 + 1 | 0;
              var tmp13__anonymous__27 = _this_._data_11.get_ha5a7z_k$(tmp14_18_20);
              var tmp0_plusAssign_0_28 = '' + 'C' + toSvgPathString$fixX(tmp8__anonymous__27, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp9__anonymous__27, decimalPlaces) + ', ' + toSvgPathString$fixX(tmp10__anonymous__27, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp11__anonymous__27, decimalPlaces) + ', ' + toSvgPathString$fixX(tmp12__anonymous__27, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp13__anonymous__27, decimalPlaces);
              parts_0.add_2bq_k$(tmp0_plusAssign_0_28);
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_4_6 === 4) {
                parts_0.add_2bq_k$('Z');
                Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    return joinToString$default_0(parts_0, '', null, null, 0, null, null, 62, null);
  }
  function toSvgPathString$default(_this_, separator, decimalPlaces, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ' ';
    if (!(($mask0 & 2) === 0))
      decimalPlaces = 1;
    return toSvgPathString(_this_, separator, decimalPlaces);
  }
  function StyledShape() {
  }
  StyledShape.prototype._get_path__0_k$ = function () {
    return null;
  };
  StyledShape.prototype.addBounds_j4ilx6_k$ = function (bb) {
    var tmp0_safe_receiver = this._get_path__0_k$();
    if (tmp0_safe_receiver == null)
      null;
    else {
      add_3(bb, tmp0_safe_receiver, this._get_transform__0_k$());
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  StyledShape.prototype.getPath_gwjbs_k$ = function (path_0) {
    var tmp0_safe_receiver_2 = this._get_path__0_k$();
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      path_0.write$default_jet5j6_k$(tmp0_safe_receiver_2, null, 2, null);
      Unit_getInstance();
    }
    Unit_getInstance();
    return path_0;
  };
  StyledShape.prototype.draw_h81jc_k$ = function (c) {
    var t_1 = c._state_5._transform_6;
    var a_2 = t_1._a;
    var b_3 = t_1._b;
    var c_4 = t_1._c;
    var d_5 = t_1._d;
    var tx_6 = t_1._tx;
    var ty_7 = t_1._ty;
    try {
      c.transform_lwp7hs_k$(this._get_transform__0_k$());
      Unit_getInstance();
      c.beginPath_sv8swh_k$();
      var tmp0_safe_receiver_9 = this._get_path__0_k$();
      if (tmp0_safe_receiver_9 == null)
        null;
      else {
        tmp0_safe_receiver_9.draw_h81jc_k$(c);
        Unit_getInstance();
      }
      Unit_getInstance();
      if (!(this._get_clip__0_k$() == null)) {
        ensureNotNull(this._get_clip__0_k$()).draw_h81jc_k$(c);
        c.clip$default_x61tnv_k$(null, null, 3, null);
      }this.drawInternal_h81jc_k$(c);
    }finally {
      t_1.setTo_hmhsjq_k$(a_2, b_3, c_4, d_5, tx_6, ty_7);
      Unit_getInstance();
    }
  };
  StyledShape.prototype.drawInternal_h81jc_k$ = function (c) {
  };
  StyledShape.$metadata$ = {
    simpleName: 'StyledShape',
    kind: 'interface',
    interfaces: [Shape_0]
  };
  function Shape_0() {
  }
  Shape_0.prototype.getPath_gwjbs_k$ = function (path_0) {
    return path_0;
  };
  Shape_0.prototype.getPath$default_w786tn_k$ = function (path_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      path_0 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    }return $handler == null ? this.getPath_gwjbs_k$(path_0) : $handler(path_0);
  };
  Shape_0.prototype._get_bounds__0_k$ = function () {
    var tmp0_also_0 = new BoundsBuilder();
    this.addBounds_j4ilx6_k$(tmp0_also_0);
    return tmp0_also_0.getBounds$default_3nifib_k$(null, 1, null);
  };
  Shape_0.$metadata$ = {
    simpleName: 'Shape',
    kind: 'interface',
    interfaces: [BoundsDrawable]
  };
  function add_3(_this_, path_0, transform) {
    var bb = _this_;
    var lx = 0.0;
    var ly = 0.0;
    var bezierTemp = new Temp();
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = path_0._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__0_k$()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_ha5a7z_k$(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      Command_getInstance();
      if (tmp0_subject_4_6 === 0) {
        var tmp1_5_7 = n_1;
        n_1 = tmp1_5_7 + 1 | 0;
        var tmp0__anonymous__21 = path_0._data_11.get_ha5a7z_k$(tmp1_5_7);
        var tmp2_6_8 = n_1;
        n_1 = tmp2_6_8 + 1 | 0;
        var tmp1__anonymous__21 = path_0._data_11.get_ha5a7z_k$(tmp2_6_8);
        var tmp0_also_0_23 = bb.add_n7xxde_k$(tmp0__anonymous__21, tmp1__anonymous__21, transform);
        lx = tmp0__anonymous__21;
        var tmp1_also_0_22 = tmp0_also_0_23;
        ly = tmp1__anonymous__21;
        Unit_getInstance();
      } else {
        Command_getInstance();
        if (tmp0_subject_4_6 === 1) {
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__24 = path_0._data_11.get_ha5a7z_k$(tmp4_8_10);
          var tmp0_also_0_26 = bb.add_n7xxde_k$(tmp2__anonymous__24, tmp3__anonymous__24, transform);
          lx = tmp2__anonymous__24;
          var tmp1_also_0_25 = tmp0_also_0_26;
          ly = tmp3__anonymous__24;
          Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_4_6 === 2) {
            var tmp5_9_11 = n_1;
            n_1 = tmp5_9_11 + 1 | 0;
            var tmp4__anonymous__27 = path_0._data_11.get_ha5a7z_k$(tmp5_9_11);
            var tmp6_10_12 = n_1;
            n_1 = tmp6_10_12 + 1 | 0;
            var tmp5__anonymous__27 = path_0._data_11.get_ha5a7z_k$(tmp6_10_12);
            var tmp7_11_13 = n_1;
            n_1 = tmp7_11_13 + 1 | 0;
            var tmp6__anonymous__27 = path_0._data_11.get_ha5a7z_k$(tmp7_11_13);
            var tmp8_12_14 = n_1;
            n_1 = tmp8_12_14 + 1 | 0;
            var tmp7__anonymous__27 = path_0._data_11.get_ha5a7z_k$(tmp8_12_14);
            var tmp = Companion_getInstance_41();
            var tmp_0 = lx;
            var tmp_1 = ly;
            var tmp0_also_0_29 = bb.add_st3qfk_k$(tmp.quadBounds$default_oascqk_k$(tmp_0, tmp_1, tmp4__anonymous__27, tmp5__anonymous__27, tmp6__anonymous__27, tmp7__anonymous__27, bb._tempRect, null, 128, null), transform);
            lx = tmp6__anonymous__27;
            var tmp1_also_0_28 = tmp0_also_0_29;
            ly = tmp7__anonymous__27;
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_4_6 === 3) {
              var tmp9_13_15 = n_1;
              n_1 = tmp9_13_15 + 1 | 0;
              var tmp8__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp9_13_15);
              var tmp10_14_16 = n_1;
              n_1 = tmp10_14_16 + 1 | 0;
              var tmp9__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp10_14_16);
              var tmp11_15_17 = n_1;
              n_1 = tmp11_15_17 + 1 | 0;
              var tmp10__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp11_15_17);
              var tmp12_16_18 = n_1;
              n_1 = tmp12_16_18 + 1 | 0;
              var tmp11__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp12_16_18);
              var tmp13_17_19 = n_1;
              n_1 = tmp13_17_19 + 1 | 0;
              var tmp12__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp13_17_19);
              var tmp14_18_20 = n_1;
              n_1 = tmp14_18_20 + 1 | 0;
              var tmp13__anonymous__30 = path_0._data_11.get_ha5a7z_k$(tmp14_18_20);
              var tmp0_also_0_32 = bb.add_st3qfk_k$(Companion_getInstance_41().cubicBounds_iom630_k$(lx, ly, tmp8__anonymous__30, tmp9__anonymous__30, tmp10__anonymous__30, tmp11__anonymous__30, tmp12__anonymous__30, tmp13__anonymous__30, bb._tempRect, bezierTemp), transform);
              lx = tmp12__anonymous__30;
              var tmp1_also_0_31 = tmp0_also_0_32;
              ly = tmp13__anonymous__30;
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_4_6 === 4) {
                Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
  }
  function CompoundShape(components) {
    this._components_1 = components;
  }
  CompoundShape.prototype.addBounds_j4ilx6_k$ = function (bb) {
    var tmp0_fastForEach_0_2 = this._components_1;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__0_k$()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.get_ha5a7z_k$(tmp0_2_5);
      tmp1__anonymous__3_4.addBounds_j4ilx6_k$(bb);
    }
    return Unit_getInstance();
  };
  CompoundShape.prototype.draw_h81jc_k$ = function (c) {
    var tmp$ret$0;
    l$ret$1: do {
      c._rendererBufferingStart_0_k$();
      Unit_getInstance();
      try {
        var tmp0_fastForEach_0_2 = this._components_1;
        var n_1_3 = 0;
        while (n_1_3 < tmp0_fastForEach_0_2._get_size__0_k$()) {
          var tmp0_2_5 = n_1_3;
          n_1_3 = tmp0_2_5 + 1 | 0;
          var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.get_ha5a7z_k$(tmp0_2_5);
          tmp1__anonymous__3_4.draw_h81jc_k$(c);
        }
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }finally {
        c._rendererBufferingEnd_sv8swh_k$();
      }
    }
     while (false);
    return tmp$ret$0;
  };
  CompoundShape.prototype.getPath_gwjbs_k$ = function (path_0) {
    var tmp0_fastForEach_0_2 = this._components_1;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__0_k$()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.get_ha5a7z_k$(tmp0_2_5);
      tmp1__anonymous__3_4.getPath_gwjbs_k$(path_0);
      Unit_getInstance();
    }
    return path_0;
  };
  CompoundShape.$metadata$ = {
    simpleName: 'CompoundShape',
    kind: 'class',
    interfaces: [Shape_0]
  };
  function PolylineShape(path_0, clip, paint, transform, thickness, pixelHinting, scaleMode, startCaps, endCaps, lineJoin, miterLimit) {
    this._path_24 = path_0;
    this._clip_1 = clip;
    this._paint_1 = paint;
    this._transform_8 = transform;
    this._thickness = thickness;
    this._pixelHinting = pixelHinting;
    this._scaleMode = scaleMode;
    this._startCaps = startCaps;
    this._endCaps = endCaps;
    this._lineJoin_0 = lineJoin;
    this._miterLimit_1 = miterLimit;
    this._tempBB = new BoundsBuilder();
    this._tempRect_0 = Companion_getInstance_35().invoke_0_k$();
  }
  PolylineShape.prototype._get_path__0_k$ = function () {
    return this._path_24;
  };
  PolylineShape.prototype._get_clip__0_k$ = function () {
    return this._clip_1;
  };
  PolylineShape.prototype._get_transform__0_k$ = function () {
    return this._transform_8;
  };
  PolylineShape.prototype.addBounds_j4ilx6_k$ = function (bb) {
    this._tempBB.reset_sv8swh_k$();
    add_0(this._tempBB, this._path_24);
    this._tempBB.getBounds_uebyw0_k$(this._tempRect_0);
    Unit_getInstance();
    var halfThickness = this._thickness / 2;
    var tmp = Math.max(halfThickness, 0.0);
    var tmp_0 = Math.max(halfThickness, 0.0);
    this._tempRect_0.inflate$default_n82wze_k$(tmp, tmp_0, 0.0, 0.0, 12, null);
    Unit_getInstance();
    bb.add_uebyw0_k$(this._tempRect_0);
    Unit_getInstance();
  };
  PolylineShape.prototype.drawInternal_h81jc_k$ = function (c) {
    c._set_lineScaleMode__q9fhdc_k$(this._scaleMode);
    c._set_lineWidth__okcceq_k$(this._thickness);
    c._set_lineCap__li1cb3_k$(this._endCaps);
    c._set_lineJoin__n3bztj_k$(this._lineJoin_0);
    c.stroke_y73s1i_k$(this._paint_1);
  };
  PolylineShape.prototype.toString = function () {
    return '' + 'PolylineShape(path=' + this._path_24 + ', clip=' + this._clip_1 + ', paint=' + this._paint_1 + ', transform=' + this._transform_8 + ', thickness=' + this._thickness + ', pixelHinting=' + this._pixelHinting + ', scaleMode=' + this._scaleMode + ', startCaps=' + this._startCaps + ', endCaps=' + this._endCaps + ', lineJoin=' + this._lineJoin_0 + ', miterLimit=' + this._miterLimit_1 + ')';
  };
  PolylineShape.prototype.hashCode = function () {
    var result = hashCode(this._path_24);
    result = imul(result, 31) + (this._clip_1 == null ? 0 : hashCode(this._clip_1)) | 0;
    result = imul(result, 31) + hashCode(this._paint_1) | 0;
    result = imul(result, 31) + this._transform_8.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._thickness) | 0;
    result = imul(result, 31) + (this._pixelHinting | 0) | 0;
    result = imul(result, 31) + this._scaleMode.hashCode() | 0;
    result = imul(result, 31) + this._startCaps.hashCode() | 0;
    result = imul(result, 31) + this._endCaps.hashCode() | 0;
    result = imul(result, 31) + this._lineJoin_0.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._miterLimit_1) | 0;
    return result;
  };
  PolylineShape.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!equals_1(this._path_24, tmp0_other_with_cast._path_24))
      return false;
    if (!equals_1(this._clip_1, tmp0_other_with_cast._clip_1))
      return false;
    if (!equals_1(this._paint_1, tmp0_other_with_cast._paint_1))
      return false;
    if (!this._transform_8.equals(tmp0_other_with_cast._transform_8))
      return false;
    if (!equals_1(this._thickness, tmp0_other_with_cast._thickness))
      return false;
    if (!(this._pixelHinting === tmp0_other_with_cast._pixelHinting))
      return false;
    if (!this._scaleMode.equals(tmp0_other_with_cast._scaleMode))
      return false;
    if (!this._startCaps.equals(tmp0_other_with_cast._startCaps))
      return false;
    if (!this._endCaps.equals(tmp0_other_with_cast._endCaps))
      return false;
    if (!this._lineJoin_0.equals(tmp0_other_with_cast._lineJoin_0))
      return false;
    if (!equals_1(this._miterLimit_1, tmp0_other_with_cast._miterLimit_1))
      return false;
    return true;
  };
  PolylineShape.$metadata$ = {
    simpleName: 'PolylineShape',
    kind: 'class',
    interfaces: [StyledShape]
  };
  function TextShape(text, x, y, font, fontSize, clip, fill_4, stroke, halign, valign, transform) {
    this._text_1 = text;
    this._x_16 = x;
    this._y_15 = y;
    this._font_1 = font;
    this._fontSize_3 = fontSize;
    this._clip_2 = clip;
    this._fill_0 = fill_4;
    this._stroke = stroke;
    this._halign = halign;
    this._valign = valign;
    this._transform_9 = transform;
  }
  TextShape.prototype._get_clip__0_k$ = function () {
    return this._clip_2;
  };
  TextShape.prototype._get_transform__0_k$ = function () {
    return this._transform_9;
  };
  TextShape.prototype.addBounds_j4ilx6_k$ = function (bb) {
    bb.add_ngl742_k$(this._x_16, this._y_15);
    Unit_getInstance();
    bb.add_ngl742_k$(this._x_16 + this._fontSize_3 * this._text_1.length, this._y_15 + this._fontSize_3);
    Unit_getInstance();
  };
  TextShape.prototype.drawInternal_h81jc_k$ = function (c) {
    var tmp0_font_0 = this._font_1;
    var tmp1_font_0 = this._halign;
    var tmp2_font_0 = this._valign;
    var tmp3_font_0 = c._get_fontSize__0_k$();
    var oldFont_1 = c._get_font__0_k$();
    var oldFontSize_2 = c._get_fontSize__0_k$();
    var oldHalign_3 = c._get_horizontalAlign__mfkab4_k$();
    var oldValign_4 = c._get_verticalAlign__8gdh1a_k$();
    try {
      c._set_font__jq2c8m_k$(tmp0_font_0);
      c._set_fontSize__okcceq_k$(tmp3_font_0);
      c._set_horizontalAlign__4fnuf6_k$(tmp1_font_0);
      c._set_verticalAlign__4c4bf4_k$(tmp2_font_0);
      if (!(this._fill_0 == null))
        c.fillText_uk3s5w_k$(this._text_1, this._x_16, this._y_15);
      if (!(this._stroke == null))
        c.strokeText_uk3s5w_k$(this._text_1, this._x_16, this._y_15);
    }finally {
      c._set_font__jq2c8m_k$(oldFont_1);
      c._set_fontSize__okcceq_k$(oldFontSize_2);
      c._set_horizontalAlign__4fnuf6_k$(oldHalign_3);
      c._set_verticalAlign__4c4bf4_k$(oldValign_4);
    }
  };
  TextShape.$metadata$ = {
    simpleName: 'TextShape',
    kind: 'class',
    interfaces: [StyledShape]
  };
  function toSvgPathString$fixX(_this_, $decimalPlaces) {
    return toStringDecimal(_this_, $decimalPlaces, true);
  }
  function toSvgPathString$fixY(_this_, $decimalPlaces) {
    return toStringDecimal(_this_, $decimalPlaces, true);
  }
  function ShapeBuilder(width, height) {
    Context2d.call(this, Companion_getInstance_161());
    var tmp = this;
    var tmp0_elvis_lhs = width;
    tmp._rendererWidth = tmp0_elvis_lhs == null ? 256 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp0_elvis_lhs_0 = height;
    tmp_0._rendererHeight = tmp0_elvis_lhs_0 == null ? 256 : tmp0_elvis_lhs_0;
    var tmp_1 = this;
    tmp_1._shapes = ArrayList_init_$Create$();
  }
  ShapeBuilder.prototype._get_rendererWidth__0_k$ = function () {
    return this._rendererWidth;
  };
  ShapeBuilder.prototype._get_rendererHeight__0_k$ = function () {
    return this._rendererHeight;
  };
  ShapeBuilder.prototype.rendererRender_eshf5c_k$ = function (state, fill_4) {
    if (isEmpty(state._path_22))
      return Unit_getInstance();
    if (fill_4) {
      var tmp0_this = this;
      var tmp0_plusAssign_0 = tmp0_this._shapes;
      var tmp = state._path_22.clone_0_k$();
      var tmp1_safe_receiver = state._clip;
      var tmp1_plusAssign_0 = new FillShape(tmp, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.clone_0_k$(), state._fillStyle.transformed_lwp7hs_k$(state._transform_6), state._transform_6.clone_0_k$());
      tmp0_plusAssign_0.add_2bq_k$(tmp1_plusAssign_0);
      Unit_getInstance();
    } else {
      var tmp2_this = this;
      var tmp2_plusAssign_0 = tmp2_this._shapes;
      var tmp_0 = state._path_22.clone_0_k$();
      var tmp3_safe_receiver = state._clip;
      var tmp3_plusAssign_0 = new PolylineShape(tmp_0, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.clone_0_k$(), state._strokeStyle.transformed_lwp7hs_k$(state._transform_6), state._transform_6.clone_0_k$(), state._lineWidth, true, state._lineScaleMode, state._startLineCap, state._endLineCap, state._lineJoin, state._miterLimit_0);
      tmp2_plusAssign_0.add_2bq_k$(tmp3_plusAssign_0);
      Unit_getInstance();
    }
    Context2d.prototype.rendererRender_eshf5c_k$.call(this, state, fill_4);
  };
  ShapeBuilder.prototype.rendererRenderSystemText_yii0ob_k$ = function (state, font, fontSize, text, x, y, fill_4) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._shapes;
    var tmp1_safe_receiver = state._clip;
    var tmp1_plusAssign_0 = new TextShape(text, x, y, font, fontSize, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.clone_0_k$(), fill_4 ? state._fillStyle : null, fill_4 ? null : state._strokeStyle, state._horizontalAlign_0, state._verticalAlign_0, state._transform_6.clone_0_k$());
    tmp0_plusAssign_0.add_2bq_k$(tmp1_plusAssign_0);
    Unit_getInstance();
  };
  ShapeBuilder.prototype.rendererDrawImage_ay2py0_k$ = function (image, x, y, width, height, transform) {
    var tmp0_apply_0 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    rect(tmp0_apply_0, x, y, width, height);
    var tmp = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null).scale_ngl742_k$(width / image._width_2, height / image._height_3).translate_ngl742_k$(x, y);
    var tmp_0 = BitmapPaint_init_$Create$(image, tmp, null, null, false, 28, null);
    this.rendererRender_eshf5c_k$(State_init_$Create$(transform, null, tmp0_apply_0, null, 0.0, null, null, null, 0.0, null, tmp_0, null, null, 0.0, null, null, 0.0, null, 261114, null), true);
  };
  ShapeBuilder.prototype.rendererDispose_sv8swh_k$ = function () {
  };
  ShapeBuilder.prototype.rendererBufferingStart_0_k$ = function () {
    return 0;
  };
  ShapeBuilder.prototype.rendererBufferingEnd_sv8swh_k$ = function () {
  };
  ShapeBuilder.prototype.buildShape_0_k$ = function () {
    return new CompoundShape(toList_3(this._shapes));
  };
  ShapeBuilder.prototype.draw_h81jc_k$ = function (c) {
    c.draw_ndfaxx_k$(this.buildShape_0_k$());
  };
  ShapeBuilder.$metadata$ = {
    simpleName: 'ShapeBuilder',
    kind: 'class',
    interfaces: [Drawable]
  };
  function StrokeInfo_init_$Init$(thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      thickness = 1.0;
    if (!(($mask0 & 2) === 0))
      pixelHinting = false;
    if (!(($mask0 & 4) === 0))
      scaleMode = LineScaleMode_NORMAL_getInstance();
    if (!(($mask0 & 8) === 0))
      startCap = LineCap_BUTT_getInstance();
    if (!(($mask0 & 16) === 0))
      endCap = LineCap_BUTT_getInstance();
    if (!(($mask0 & 32) === 0))
      lineJoin = LineJoin_MITER_getInstance();
    if (!(($mask0 & 64) === 0))
      miterLimit = 20.0;
    StrokeInfo.call($this, thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit);
    return $this;
  }
  function StrokeInfo_init_$Create$(thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit, $mask0, $marker) {
    return StrokeInfo_init_$Init$(thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit, $mask0, $marker, Object.create(StrokeInfo.prototype));
  }
  function StrokeInfo(thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit) {
    this._thickness_0 = thickness;
    this._pixelHinting_0 = pixelHinting;
    this._scaleMode_0 = scaleMode;
    this._startCap_0 = startCap;
    this._endCap_0 = endCap;
    this._lineJoin_1 = lineJoin;
    this._miterLimit_2 = miterLimit;
  }
  StrokeInfo.prototype.toString = function () {
    return '' + 'StrokeInfo(thickness=' + this._thickness_0 + ', pixelHinting=' + this._pixelHinting_0 + ', scaleMode=' + this._scaleMode_0 + ', startCap=' + this._startCap_0 + ', endCap=' + this._endCap_0 + ', lineJoin=' + this._lineJoin_1 + ', miterLimit=' + this._miterLimit_2 + ')';
  };
  StrokeInfo.prototype.hashCode = function () {
    var result = getNumberHashCode(this._thickness_0);
    result = imul(result, 31) + (this._pixelHinting_0 | 0) | 0;
    result = imul(result, 31) + this._scaleMode_0.hashCode() | 0;
    result = imul(result, 31) + this._startCap_0.hashCode() | 0;
    result = imul(result, 31) + this._endCap_0.hashCode() | 0;
    result = imul(result, 31) + this._lineJoin_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._miterLimit_2) | 0;
    return result;
  };
  StrokeInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StrokeInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof StrokeInfo ? other : THROW_CCE();
    if (!equals_1(this._thickness_0, tmp0_other_with_cast._thickness_0))
      return false;
    if (!(this._pixelHinting_0 === tmp0_other_with_cast._pixelHinting_0))
      return false;
    if (!this._scaleMode_0.equals(tmp0_other_with_cast._scaleMode_0))
      return false;
    if (!this._startCap_0.equals(tmp0_other_with_cast._startCap_0))
      return false;
    if (!this._endCap_0.equals(tmp0_other_with_cast._endCap_0))
      return false;
    if (!this._lineJoin_1.equals(tmp0_other_with_cast._lineJoin_1))
      return false;
    if (!equals_1(this._miterLimit_2, tmp0_other_with_cast._miterLimit_2))
      return false;
    return true;
  };
  StrokeInfo.$metadata$ = {
    simpleName: 'StrokeInfo',
    kind: 'class',
    interfaces: []
  };
  function Companion_159() {
    Companion_instance_158 = this;
  }
  Companion_159.prototype.parseToMap_6wfw3l_k$ = function (str) {
    return (new CSSDeclarations()).parse_6wfw3l_k$(str)._props_0;
  };
  Companion_159.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_158;
  function Companion_getInstance_158() {
    if (Companion_instance_158 == null)
      new Companion_159();
    return Companion_instance_158;
  }
  function tokenizePath$skipSeparators(_this_) {
    $l$break: while (true) {
      var tmp;
      if (_this_._get_hasMore__0_k$()) {
        var tmp0__anonymous__1 = _this_.peekChar_0_k$();
        tmp = (((tmp0__anonymous__1.equals(new Char(44)) ? true : tmp0__anonymous__1.equals(new Char(32))) ? true : tmp0__anonymous__1.equals(new Char(9))) ? true : tmp0__anonymous__1.equals(new Char(10))) ? true : tmp0__anonymous__1.equals(new Char(13));
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }_this_.readChar_0_k$();
      Unit_getInstance();
    }
  }
  function tokenizePath$readNumber(_this_) {
    tokenizePath$skipSeparators(_this_);
    var first_2 = true;
    var start_1_2 = _this_._pos_0;
    $l$break: while (true) {
      var tmp;
      if (_this_._get_hasMore__0_k$()) {
        var tmp0__anonymous__4 = _this_.peekChar_0_k$();
        var tmp_0;
        if (first_2) {
          first_2 = false;
          tmp_0 = (isDigit(tmp0__anonymous__4) ? true : tmp0__anonymous__4.equals(new Char(45))) ? true : tmp0__anonymous__4.equals(new Char(43));
        } else {
          tmp_0 = isDigit(tmp0__anonymous__4) ? true : tmp0__anonymous__4.equals(new Char(46));
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }_this_.readChar_0_k$();
      Unit_getInstance();
    }
    var end_2_3 = _this_._pos_0;
    var tmp0_elvis_lhs_1 = end_2_3 > start_1_2 ? _this_.slice_27zxwg_k$(start_1_2, end_2_3) : null;
    var str = tmp0_elvis_lhs_1 == null ? '' : tmp0_elvis_lhs_1;
    var tmp_1;
    if (charSequenceLength(str) === 0) {
      tmp_1 = 0.0;
    } else {
      {
        var tmp_2;
        try {
          tmp_2 = toDouble(str);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            printStackTrace_0($p);
            tmp_3 = 0.0;
          } else {
            {
              throw $p;
            }
          }
          tmp_2 = tmp_3;
        }
        tmp_1 = tmp_2;
      }
    }
    return tmp_1;
  }
  function Companion_160() {
    Companion_instance_159 = this;
  }
  Companion_160.prototype.tokenize_6wfw3l_k$ = function (str) {
    var sr = StrReader_init_$Create$(str, null, 0, 6, null);
    var out = ArrayList_init_$Create$();
    $l$break_1: while (sr._get_hasMore__0_k$()) {
      $l$break_0: while (true) {
        sr.skipSpaces_0_k$();
        Unit_getInstance();
        var start_1_2 = sr._pos_0;
        $l$break: while (true) {
          var tmp;
          if (sr._get_hasMore__0_k$()) {
            var tmp0__anonymous__4 = sr.peekChar_0_k$();
            tmp = ((isLetterOrUnderscore(tmp0__anonymous__4) ? true : _get_isNumeric_(tmp0__anonymous__4)) ? true : tmp0__anonymous__4.equals(new Char(45))) ? true : tmp0__anonymous__4.equals(new Char(35));
          } else {
            tmp = false;
          }
          if (!tmp) {
            break $l$break;
          }sr.readChar_0_k$();
          Unit_getInstance();
        }
        var end_2_3 = sr._pos_0;
        var tmp0_elvis_lhs_1 = end_2_3 > start_1_2 ? sr.slice_27zxwg_k$(start_1_2, end_2_3) : null;
        var id = tmp0_elvis_lhs_1 == null ? '' : tmp0_elvis_lhs_1;
        if (charSequenceLength(id) > 0) {
          out.add_2bq_k$(id);
          Unit_getInstance();
        } else {
          {
            break $l$break_0;
          }
        }
      }
      if (sr._get_eof__0_k$())
        break $l$break_1;
      sr.skipSpaces_0_k$();
      Unit_getInstance();
      var symbol = sr.read_0_k$();
      var tmp1_plusAssign_0 = '' + symbol;
      out.add_2bq_k$(tmp1_plusAssign_0);
      Unit_getInstance();
    }
    return out;
  };
  Companion_160.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_159;
  function Companion_getInstance_159() {
    if (Companion_instance_159 == null)
      new Companion_160();
    return Companion_instance_159;
  }
  function SVG_init_$Init$(root, warningProcessor, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      warningProcessor = null;
    SVG.call($this, root, warningProcessor);
    return $this;
  }
  function SVG_init_$Create$(root, warningProcessor, $mask0, $marker) {
    return SVG_init_$Init$(root, warningProcessor, $mask0, $marker, Object.create(SVG.prototype));
  }
  function sqr($this, v) {
    return v * v;
  }
  function vmag($this, x, y) {
    var tmp0_sqrt_0 = x * x + y * y;
    return Math.sqrt(tmp0_sqrt_0);
  }
  function vecrat($this, ux, uy, vx, vy) {
    return (ux * vx + uy * vy) / (vmag($this, ux, uy) * vmag($this, vx, vy));
  }
  function vecang($this, ux, uy, vx, vy) {
    var r = vecrat($this, ux, uy, vx, vy);
    if (r < -1.0)
      r = -1.0;
    if (r > 1.0)
      r = 1.0;
    var tmp = ux * vy < uy * vx ? -1.0 : 1.0;
    var tmp0_acos_0 = r;
    return tmp * Math.acos(tmp0_acos_0);
  }
  function xformPointX($this, x, y, t) {
    return x * t[0] + y * t[2] + t[4];
  }
  function xformPointY($this, x, y, t) {
    return x * t[1] + y * t[3] + t[5];
  }
  function xformVecX($this, x, y, t) {
    return x * t[0] + y * t[2];
  }
  function xformVecY($this, x, y, t) {
    return x * t[1] + y * t[3];
  }
  function applyTransform_1($this, state, transform) {
    state._transform_6.premultiply_lwp7hs_k$(transform);
    Unit_getInstance();
  }
  function CSSDeclarations() {
    Companion_getInstance_158();
    this._props_0 = LinkedHashMap_init_$Create$();
  }
  CSSDeclarations.prototype.parse_6wfw3l_k$ = function (str) {
    return this.parse_67klfr_k$(reader$default(str, null, 0, 3, null));
  };
  CSSDeclarations.prototype.parse_67klfr_k$ = function (_this__0) {
    while (!_this__0._get_eof__0_k$()) {
      this.parseCssDecl_jq9hkm_k$(_this__0);
    }
    return this;
  };
  CSSDeclarations.prototype.parseCssDecl_jq9hkm_k$ = function (_this__0) {
    _this__0.skipSpaces_0_k$();
    Unit_getInstance();
    var id = this.readCssId_67klfr_k$(_this__0);
    _this__0.skipSpaces_0_k$();
    Unit_getInstance();
    _this__0.skipExpect_9o0tv_k$(new Char(58));
    _this__0.skipSpaces_0_k$();
    Unit_getInstance();
    var start_1_2 = _this__0._pos_0;
    $l$break: while (true) {
      var tmp;
      if (_this__0._get_hasMore__0_k$()) {
        var tmp0__anonymous__4 = _this__0.peekChar_0_k$();
        tmp = !tmp0__anonymous__4.equals(new Char(59));
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }_this__0.readChar_0_k$();
      Unit_getInstance();
    }
    var end_2_3 = _this__0._pos_0;
    var tmp0_elvis_lhs_1 = end_2_3 > start_1_2 ? _this__0.slice_27zxwg_k$(start_1_2, end_2_3) : null;
    var tmp1_trim_0 = tmp0_elvis_lhs_1 == null ? '' : tmp0_elvis_lhs_1;
    var value = toString_1(trim_0(isCharSequence(tmp1_trim_0) ? tmp1_trim_0 : THROW_CCE()));
    var tmp2_set_0 = this._props_0;
    tmp2_set_0.put_1q9pf_k$(id, value);
    Unit_getInstance();
    if (!_this__0._get_eof__0_k$()) {
      _this__0.skipExpect_9o0tv_k$(new Char(59));
    }};
  CSSDeclarations.prototype.readCssId_67klfr_k$ = function (_this__0) {
    var start_1_2 = _this__0._pos_0;
    $l$break: while (true) {
      var tmp;
      if (_this__0._get_hasMore__0_k$()) {
        var tmp0__anonymous__4 = _this__0.peekChar_0_k$();
        tmp = isLetterOrDigit(tmp0__anonymous__4) ? true : tmp0__anonymous__4.equals(new Char(45));
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }_this__0.readChar_0_k$();
      Unit_getInstance();
    }
    var end_2_3 = _this__0._pos_0;
    var tmp0_elvis_lhs_1 = end_2_3 > start_1_2 ? _this__0.slice_27zxwg_k$(start_1_2, end_2_3) : null;
    return tmp0_elvis_lhs_1 == null ? '' : tmp0_elvis_lhs_1;
  };
  CSSDeclarations.$metadata$ = {
    simpleName: 'CSSDeclarations',
    kind: 'class',
    interfaces: []
  };
  function Companion_161() {
    Companion_instance_160 = this;
    this._ColorDefaultBlack = new WithDefault(Colors_getInstance()._BLACK_0);
  }
  Companion_161.prototype.parseAttributesAndStyles_ou535b_k$ = function (node) {
    var out = toMutableMap(node._attributes_2);
    var tmp0_safe_receiver = node.getString_6wfw3l_k$('style');
    if (tmp0_safe_receiver == null)
      null;
    else {
      out.putAll_nn707j_k$(Companion_getInstance_158().parseToMap_6wfw3l_k$(tmp0_safe_receiver));
      Unit_getInstance();
    }
    Unit_getInstance();
    return out;
  };
  Companion_161.prototype.parsePercent_qmgruq_k$ = function (str, default_0) {
    var tmp;
    if (endsWith$default_1(str, '%', false, 2, null)) {
      tmp = toDouble(substr_0(str, 0, -1)) / 100.0;
    } else {
      {
        var tmp0_elvis_lhs = toDoubleOrNull(str);
        tmp = tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
      }
    }
    return tmp;
  };
  Companion_161.prototype.parsePercent$default_s8e18k_k$ = function (str, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      default_0 = 0.0;
    return this.parsePercent_qmgruq_k$(str, default_0);
  };
  Companion_161.prototype.parseStops_ou535b_k$ = function (xml) {
    var out = ArrayList_init_$Create$();
    var tmp0_iterator = xml.children_6wfw3l_k$('stop').iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var stop = tmp0_iterator.next_0_k$();
      var info = this.parseAttributesAndStyles_ou535b_k$(stop);
      var offset_0 = 0.0;
      var colorStop = this._ColorDefaultBlack._defaultColor;
      var alphaStop = 1.0;
      var tmp1_iterator = info._get_entries__0_k$().iterator_0_k$();
      while (tmp1_iterator.hasNext_0_k$()) {
        var tmp2_loop_parameter = tmp1_iterator.next_0_k$();
        var key = tmp2_loop_parameter._get_key__0_k$();
        var value = tmp2_loop_parameter._get_value__0_k$();
        var tmp3_subject = key;
        switch (tmp3_subject) {
          case 'offset':
            offset_0 = this.parsePercent$default_s8e18k_k$(value, 0.0, 2, null);
            break;
          case 'stop-color':
            colorStop = this._ColorDefaultBlack.get_xr0bn6_k$(value);
            break;
          case 'stop-opacity':
            var tmp4_elvis_lhs = toDoubleOrNull(value);
            alphaStop = tmp4_elvis_lhs == null ? 1.0 : tmp4_elvis_lhs;
            break;
        }
      }
      var tmp0_plusAssign_0 = new Pair(offset_0, new RGBA(Companion_getInstance_136().invoke_aewswh_k$(_RGBA___get_rgb__impl_(colorStop), numberToInt(alphaStop * 255))));
      out.add_2bq_k$(tmp0_plusAssign_0);
      Unit_getInstance();
    }
    return out;
  };
  Companion_161.prototype.tokenizePath_6wfw3l_k$ = function (str) {
    var sr = StrReader_init_$Create$(str, null, 0, 6, null);
    var out = ArrayList_init_$Create$();
    while (sr._get_hasMore__0_k$()) {
      tokenizePath$skipSeparators(sr);
      var c = sr.peekChar_0_k$();
      var tmp;
      if (((new Char(48) <= c ? c <= new Char(57) : false) ? true : c.equals(new Char(45))) ? true : c.equals(new Char(43))) {
        tmp = new PathTokenNumber(tokenizePath$readNumber(sr));
      } else {
        tmp = new PathTokenCmd(sr.readChar_0_k$());
      }
      var tmp0_plusAssign_0 = tmp;
      out.add_2bq_k$(tmp0_plusAssign_0);
      Unit_getInstance();
    }
    return out;
  };
  Companion_161.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_160;
  function Companion_getInstance_160() {
    if (Companion_instance_160 == null)
      new Companion_161();
    return Companion_instance_160;
  }
  function PathToken() {
  }
  PathToken.$metadata$ = {
    simpleName: 'PathToken',
    kind: 'interface',
    interfaces: []
  };
  function PathTokenNumber(value) {
    this._value_21 = value;
  }
  PathTokenNumber.prototype.toString = function () {
    return '' + 'PathTokenNumber(value=' + this._value_21 + ')';
  };
  PathTokenNumber.prototype.hashCode = function () {
    return getNumberHashCode(this._value_21);
  };
  PathTokenNumber.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PathTokenNumber))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PathTokenNumber ? other : THROW_CCE();
    if (!equals_1(this._value_21, tmp0_other_with_cast._value_21))
      return false;
    return true;
  };
  PathTokenNumber.$metadata$ = {
    simpleName: 'PathTokenNumber',
    kind: 'class',
    interfaces: [PathToken]
  };
  function PathTokenCmd(id) {
    this._id_8 = id;
  }
  PathTokenCmd.prototype.toString = function () {
    return '' + 'PathTokenCmd(id=' + this._id_8 + ')';
  };
  PathTokenCmd.prototype.hashCode = function () {
    return this._id_8.hashCode();
  };
  PathTokenCmd.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PathTokenCmd))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PathTokenCmd ? other : THROW_CCE();
    if (!this._id_8.equals(tmp0_other_with_cast._id_8))
      return false;
    return true;
  };
  PathTokenCmd.$metadata$ = {
    simpleName: 'PathTokenCmd',
    kind: 'class',
    interfaces: [PathToken]
  };
  function drawElement$dumpTokens_47(tokens_45, this$0) {
    var iterator_0 = tokens_45.iterator_0_k$();
    var index_0 = 0;
    while (iterator_0.hasNext_0_k$()) {
      var n_4_50 = index_0;
      index_0 = index_0 + 1 | 0;
      var token_5_51 = iterator_0.next_0_k$();
      var tmp2_safe_receiver_6_52 = this$0._warningProcessor;
      if (tmp2_safe_receiver_6_52 == null)
        null;
      else
        tmp2_safe_receiver_6_52('' + '- ' + n_4_50 + ': ' + token_5_51);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function drawElement$isNextNumber_53(tl_46) {
    var tmp;
    if (tl_46._get_hasMore__0_k$()) {
      var tmp_0 = tl_46.peek_0_k$();
      tmp = tmp_0 instanceof PathTokenNumber;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function drawElement$readNumber_54(tl_46, this$0, tokens_45) {
    while (tl_46._get_hasMore__0_k$()) {
      var token_55 = tl_46.read_0_k$();
      if (token_55 instanceof PathTokenNumber)
        return token_55._value_21;
      else {
      }
      var tmp0_safe_receiver_56 = this$0._warningProcessor;
      if (tmp0_safe_receiver_56 == null)
        null;
      else
        tmp0_safe_receiver_56('' + 'Invalid path (expected number but found ' + token_55 + ') at ' + (tl_46._position - 1 | 0));
      Unit_getInstance();
      drawElement$dumpTokens_47(tokens_45, this$0);
    }
    return 0.0;
  }
  function drawElement$n_57(tl_46, this$0, tokens_45) {
    return drawElement$readNumber_54(tl_46, this$0, tokens_45);
  }
  function drawElement$nX_58($c, tl_46, this$0, tokens_45, relative) {
    return relative ? $c._get_lastX__0_k$() + drawElement$readNumber_54(tl_46, this$0, tokens_45) : drawElement$readNumber_54(tl_46, this$0, tokens_45);
  }
  function drawElement$nY_59($c, tl_46, this$0, tokens_45, relative) {
    return relative ? $c._get_lastY__0_k$() + drawElement$readNumber_54(tl_46, this$0, tokens_45) : drawElement$readNumber_54(tl_46, this$0, tokens_45);
  }
  function drawElement$readNextTokenCmd_60(tl_46, this$0, tokens_45) {
    while (tl_46._get_hasMore__0_k$()) {
      var token_61 = tl_46.read_0_k$();
      if (token_61 instanceof PathTokenCmd)
        return token_61._id_8;
      else {
      }
      var tmp0_safe_receiver_62 = this$0._warningProcessor;
      if (tmp0_safe_receiver_62 == null)
        null;
      else
        tmp0_safe_receiver_62('' + 'Invalid path (expected command but found ' + token_61 + ') at ' + (tl_46._position - 1 | 0));
      Unit_getInstance();
      drawElement$dumpTokens_47(tokens_45, this$0);
    }
    return null;
  }
  function parseTransform$double(doubleArgs, index_0) {
    var tmp;
    if (index_0 >= 0 ? index_0 <= _get_lastIndex__4(doubleArgs) : false) {
      tmp = doubleArgs.get_ha5a7z_k$(index_0);
    } else {
      tmp = 0.0;
    }
    return tmp;
  }
  function SVG(root, warningProcessor) {
    Companion_getInstance_160();
    this._root_1 = root;
    this._warningProcessor = warningProcessor;
    this._x_17 = this._root_1.int_8i7b4u_k$('x', 0);
    this._y_16 = this._root_1.int_8i7b4u_k$('y', 0);
    this._dwidth = this._root_1.double_qmgruq_k$('width', 128.0);
    this._dheight = this._root_1.double_qmgruq_k$('height', 128.0);
    var tmp = this;
    var tmp0_elvis_lhs = this._root_1.getString_6wfw3l_k$('viewBox');
    tmp._viewBox = tmp0_elvis_lhs == null ? '' + '0 0 ' + this._dwidth + ' ' + this._dheight : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp_1 = charArrayOf([new Char(32)]);
    var tmp0_map_0 = split$default(this._viewBox, tmp_1, false, 0, 6, null);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp0_elvis_lhs_5 = toDoubleOrNull(toString_1(trim_0(isCharSequence(item_2_3) ? item_2_3 : THROW_CCE())));
      tmp0_mapTo_0_1.add_2bq_k$(tmp0_elvis_lhs_5 == null ? 0.0 : tmp0_elvis_lhs_5);
      Unit_getInstance();
    }
    tmp_0._viewBoxNumbers = tmp0_mapTo_0_1;
    var tmp_2 = this;
    var tmp0_getOrElse_0 = this._viewBoxNumbers;
    var tmp_3;
    if (0 <= _get_lastIndex__4(tmp0_getOrElse_0)) {
      tmp_3 = tmp0_getOrElse_0.get_ha5a7z_k$(0);
    } else {
      tmp_3 = 0.0;
    }
    var tmp_4 = tmp_3;
    var tmp1_getOrElse_0 = this._viewBoxNumbers;
    var tmp_5;
    if (1 <= _get_lastIndex__4(tmp1_getOrElse_0)) {
      tmp_5 = tmp1_getOrElse_0.get_ha5a7z_k$(1);
    } else {
      tmp_5 = 0.0;
    }
    var tmp_6 = tmp_5;
    var tmp2_getOrElse_0 = this._viewBoxNumbers;
    var tmp_7;
    if (2 <= _get_lastIndex__4(tmp2_getOrElse_0)) {
      tmp_7 = tmp2_getOrElse_0.get_ha5a7z_k$(2);
    } else {
      tmp_7 = this._dwidth;
    }
    var tmp_8 = tmp_7;
    var tmp3_getOrElse_0 = this._viewBoxNumbers;
    var tmp_9;
    if (3 <= _get_lastIndex__4(tmp3_getOrElse_0)) {
      tmp_9 = tmp3_getOrElse_0.get_ha5a7z_k$(3);
    } else {
      tmp_9 = this._dheight;
    }
    tmp_2._viewBoxRectangle = new Rectangle(tmp_4, tmp_6, tmp_8, tmp_9);
    var tmp_10 = this;
    tmp_10._defs = HashMap_init_$Create$();
    this._t_0 = new Float64Array(6);
  }
  SVG.prototype.toString = function () {
    return '' + 'SVG(' + this._get_width__0_k$() + ', ' + this._get_height__0_k$() + ')';
  };
  SVG.prototype._get_width__0_k$ = function () {
    return numberToInt(this._viewBoxRectangle._width_0);
  };
  SVG.prototype._get_height__0_k$ = function () {
    return numberToInt(this._viewBoxRectangle._height_0);
  };
  SVG.prototype.parseDef_dhj6o0_k$ = function (def) {
    var type = def._nameLC_0;
    var tmp0_subject = type;
    switch (tmp0_subject) {
      case 'lineargradient':
      case 'radialgradient':
        var tmp0_toLowerCase_0 = def.str$default_877n1b_k$('id', null, 2, null);
        var id = tmp0_toLowerCase_0.toLowerCase();
        var stops = Companion_getInstance_160().parseStops_ou535b_k$(def);
        var tmp1_elvis_lhs = def.getString_6wfw3l_k$('gradientUnits');
        var tmp2_subject = tmp1_elvis_lhs == null ? 'objectBoundingBox' : tmp1_elvis_lhs;
        var gradientUnits = tmp2_subject === 'userSpaceOnUse' ? GradientUnits_USER_SPACE_ON_USE_getInstance() : GradientUnits_OBJECT_BOUNDING_BOX_getInstance();
        var tmp;
        if (type === 'lineargradient') {
          var x0 = def.double_qmgruq_k$('x1', 0.0);
          var y0 = def.double_qmgruq_k$('y1', 0.0);
          var x1 = def.double_qmgruq_k$('x2', 1.0);
          var y1 = def.double_qmgruq_k$('y2', 1.0);
          var tmp_0 = GradientKind_LINEAR_getInstance();
          tmp = GradientPaint_init_$Create$(tmp_0, x0, y0, 0.0, x1, y1, 0.0, null, null, null, null, null, gradientUnits, 3968, null);
        } else {
          var cx = def.double_qmgruq_k$('cx', 0.0);
          var cy = def.double_qmgruq_k$('cy', 0.0);
          var r = def.double_qmgruq_k$('r', 16.0);
          var fx = def.double_qmgruq_k$('fx', 0.0);
          var fy = def.double_qmgruq_k$('fy', 0.0);
          var tmp_1 = GradientKind_RADIAL_getInstance();
          tmp = GradientPaint_init_$Create$(tmp_1, cx, cy, 0.0, fx, fy, r, null, null, null, null, null, gradientUnits, 3968, null);
        }

        var g = tmp;
        var tmp3_safe_receiver = def.strNull_6wfw3l_k$('xlink:href');
        if (tmp3_safe_receiver == null)
          null;
        else {
          var id_2 = trim(tmp3_safe_receiver, charArrayOf([new Char(35)]));
          var tmp_2 = this._defs.get_2bw_k$(id_2);
          var original_3 = (tmp_2 == null ? true : tmp_2 instanceof GradientPaint) ? tmp_2 : null;
          var tmp0_safe_receiver_4 = original_3;
          if (tmp0_safe_receiver_4 == null)
            null;
          else {
            g._stops.add_pd4ws6_k$(original_3._stops);
            g._colors_1.add_i58uhq_k$(original_3._colors_1);
            Unit_getInstance();
          }
        }

        Unit_getInstance();
        var tmp4_iterator = stops.iterator_0_k$();
        while (tmp4_iterator.hasNext_0_k$()) {
          var tmp5_loop_parameter = tmp4_iterator.next_0_k$();
          var offset_0 = tmp5_loop_parameter.component1_0_k$();
          var color_0 = tmp5_loop_parameter.component2_0_k$()._value_19;
          g.addColorStop_grassx_k$(offset_0, color_0);
          Unit_getInstance();
        }

        var tmp6_safe_receiver = def.getString_6wfw3l_k$('gradientTransform');
        if (tmp6_safe_receiver == null)
          null;
        else {
          g._transform_3.premultiply_lwp7hs_k$(this.parseTransform_6wfw3l_k$(tmp6_safe_receiver));
        }

        Unit_getInstance();
        var tmp1_set_0 = this._defs;
        tmp1_set_0.put_1q9pf_k$(id, g);
        Unit_getInstance();
        break;
      case 'style':
        break;
      case '_text_':
        break;
      default:println('' + "Unhandled def: '" + type + "'");
        break;
    }
  };
  SVG.prototype.draw_h81jc_k$ = function (c) {
    c.save_sv8swh_k$();
    try {
      c._set_strokeStyle__y73s1i_k$(NonePaint_getInstance());
      c._set_fillStyle__y73s1i_k$(new RGBA(Colors_getInstance()._BLACK_0));
      this.drawElement_8kg5y8_k$(this._root_1, c, true);
      Unit_getInstance();
    }finally {
      c.restore_sv8swh_k$();
    }
  };
  SVG.prototype.drawChildren_vcw7m7_k$ = function (xml, c, render_1) {
    var tmp0_iterator = xml._allChildren.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var child = tmp0_iterator.next_0_k$();
      this.drawElement_8kg5y8_k$(child, c, render_1);
      Unit_getInstance();
    }
  };
  SVG.prototype.parseFillStroke_3thyg_k$ = function (c, str2, bounds_0) {
    var tmp0_trim_0 = str2.toLowerCase();
    var str = toString_1(trim_0(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE()));
    var tmp;
    if (startsWith$default_1(str, 'url(', false, 2, null)) {
      var tmp_0 = substr_0(str, 4, -1);
      var tmp_1 = new Char(41);
      var urlPattern = substringBefore$default(tmp_0, tmp_1, null, 2, null);
      var tmp_2 = new Char(41);
      var extra = substringAfter$default(str, tmp_2, null, 2, null);
      var tmp_3;
      if (startsWith$default_1(urlPattern, '#', false, 2, null)) {
        var tmp1_toLowerCase_0 = substr_1(urlPattern, 1);
        var idName = tmp1_toLowerCase_0.toLowerCase();
        var def = this._defs.get_2bw_k$(idName);
        if (def == null) {
          println(this._defs);
          println('' + "Can't find svg definition '" + idName + "'");
        }var tmp0_elvis_lhs = def;
        tmp_3 = tmp0_elvis_lhs == null ? NonePaint_getInstance() : tmp0_elvis_lhs;
      } else {
        {
          println('' + 'Unsupported ' + str);
          tmp_3 = NonePaint_getInstance();
        }
      }
      tmp = tmp_3;
    } else {
      if (startsWith$default_1(str, 'rgba(', false, 2, null)) {
        var tmp_4 = removeSuffix(removePrefix(str, 'rgba('), ')');
        var tmp2_map_0 = split$default_0(tmp_4, [','], false, 0, 6, null);
        var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0, 10));
        var tmp0_iterator_1_2 = tmp2_map_0.iterator_0_k$();
        while (tmp0_iterator_1_2.hasNext_0_k$()) {
          var item_2_3 = tmp0_iterator_1_2.next_0_k$();
          var tmp0_elvis_lhs_5 = toDoubleOrNull(toString_1(trim_0(isCharSequence(item_2_3) ? item_2_3 : THROW_CCE())));
          tmp0_mapTo_0_1.add_2bq_k$(tmp0_elvis_lhs_5 == null ? 0.0 : tmp0_elvis_lhs_5);
          Unit_getInstance();
        }
        var components = tmp0_mapTo_0_1;
        tmp = new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Companion_getInstance_136().invoke_fnl2i9_k$(numberToInt(components.get_ha5a7z_k$(0)), numberToInt(components.get_ha5a7z_k$(1)), numberToInt(components.get_ha5a7z_k$(2)), numberToInt(components.get_ha5a7z_k$(3) * 255))));
      } else {
        if (startsWith$default_1(str, 'rgb(', false, 2, null)) {
          var tmp_5 = removeSuffix(removePrefix(str, 'rgb('), ')');
          var tmp3_map_0 = split$default_0(tmp_5, [','], false, 0, 6, null);
          var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map_0, 10));
          var tmp0_iterator_1_2_0 = tmp3_map_0.iterator_0_k$();
          while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
            var item_2_3_0 = tmp0_iterator_1_2_0.next_0_k$();
            var tmp0_elvis_lhs_5_0 = toDoubleOrNull(toString_1(trim_0(isCharSequence(item_2_3_0) ? item_2_3_0 : THROW_CCE())));
            tmp0_mapTo_0_1_0.add_2bq_k$(tmp0_elvis_lhs_5_0 == null ? 0.0 : tmp0_elvis_lhs_5_0);
            Unit_getInstance();
          }
          var components_0 = tmp0_mapTo_0_1_0;
          tmp = new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Companion_getInstance_136().invoke_fnl2i9_k$(numberToInt(components_0.get_ha5a7z_k$(0)), numberToInt(components_0.get_ha5a7z_k$(1)), numberToInt(components_0.get_ha5a7z_k$(2)), 255)));
        } else {
          {
            var tmp1_subject = str;
            tmp = tmp1_subject === 'none' ? NonePaint_getInstance() : new RGBA(c.createColor_abrt0h_k$(Companion_getInstance_160()._ColorDefaultBlack.get_xr0bn6_k$(str)));
          }
        }
      }
    }
    var res = tmp;
    var tmp2_subject = res;
    var tmp_6;
    if (tmp2_subject instanceof GradientPaint) {
      var m = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
      m.scale_ngl742_k$(bounds_0._width_0, bounds_0._height_0);
      Unit_getInstance();
      var out = res.applyMatrix_lwp7hs_k$(m);
      tmp_6 = out;
    } else {
      {
        tmp_6 = res;
      }
    }
    return tmp_6;
  };
  SVG.prototype.drawElement_8kg5y8_k$ = function (xml, c, render_1) {
    c.save_sv8swh_k$();
    try {
      var bounds_2 = Companion_getInstance_35().invoke_0_k$();
      var nodeName_3 = xml._nameLC_0;
      var drawChildren_4 = false;
      var render_5 = render_1;
      var attributes_6 = Companion_getInstance_160().parseAttributesAndStyles_ou535b_k$(xml);
      var tmp0_safe_receiver_7 = attributes_6.get_2bw_k$('transform');
      if (tmp0_safe_receiver_7 == null)
        null;
      else {
        applyTransform_1(this, c._state_5, this.parseTransform_6wfw3l_k$(tmp0_safe_receiver_7));
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp1_subject_8 = nodeName_3;
      switch (tmp1_subject_8) {
        case 'g':
        case 'a':
        case 'svg':
          drawChildren_4 = true;
          break;
        case 'defs':
          drawChildren_4 = true;
          render_5 = false;
          break;
        case '_text_':
          Unit_getInstance();
          break;
        case '_comment_':
          Unit_getInstance();
          break;
        case 'title':
          Unit_getInstance();
          break;
        case 'lineargradient':
        case 'radialgradient':
          this.parseDef_dhj6o0_k$(xml);
          break;
        case 'rect':
          var x_9 = xml.double$default_s8e18k_k$('x', 0.0, 2, null);
          var y_10 = xml.double$default_s8e18k_k$('y', 0.0, 2, null);
          var width_11 = xml.double$default_s8e18k_k$('width', 0.0, 2, null);
          var height_12 = xml.double$default_s8e18k_k$('height', 0.0, 2, null);
          var ry_13 = xml.double_qmgruq_k$('ry', xml.double$default_s8e18k_k$('rx', 0.0, 2, null));
          var rx_14 = xml.double_qmgruq_k$('rx', xml.double$default_s8e18k_k$('ry', 0.0, 2, null));
          bounds_2.setTo_i6u10_k$(x_9, y_10, width_11, height_12);
          Unit_getInstance();
          roundRect(c, x_9, y_10, width_11, height_12, rx_14, ry_13);
          break;
        case 'circle':
          var cx_15 = xml.double$default_s8e18k_k$('cx', 0.0, 2, null);
          var cy_16 = xml.double$default_s8e18k_k$('cy', 0.0, 2, null);
          var radius_17 = xml.double$default_s8e18k_k$('r', 0.0, 2, null);
          circle(c, cx_15, cy_16, radius_17);
          bounds_2.setBounds_i6u10_k$(cx_15 - radius_17, cy_16 - radius_17, cx_15 + radius_17, cy_16 + radius_17);
          Unit_getInstance();
          break;
        case 'ellipse':
          var cx_18 = xml.double$default_s8e18k_k$('cx', 0.0, 2, null);
          var cy_19 = xml.double$default_s8e18k_k$('cy', 0.0, 2, null);
          var rx_20 = xml.double$default_s8e18k_k$('rx', 0.0, 2, null);
          var ry_21 = xml.double$default_s8e18k_k$('ry', 0.0, 2, null);
          ellipse(c, cx_18 - rx_20, cy_19 - ry_21, rx_20 * 2, ry_21 * 2);
          bounds_2.setBounds_i6u10_k$(cx_18 - rx_20, cy_19 - ry_21, cx_18 + rx_20, cy_19 + ry_21);
          Unit_getInstance();
          break;
        case 'polyline':
        case 'polygon':
          c.beginPath_sv8swh_k$();
          var tmp = xml.str$default_877n1b_k$('points', null, 2, null);
          var ss_22 = StrReader_init_$Create$(tmp, null, 0, 6, null);
          var tmp0_apply_0_1_24 = ArrayList_init_$Create$();
          $l$break: while (true) {
            var tmp0__anonymous__3_25 = tmp0_apply_0_1_24._get_size__0_k$();
            if (!ss_22._get_hasMore__0_k$()) {
              break $l$break;
            }var tmp1__anonymous__4_27 = tmp0_apply_0_1_24._get_size__0_k$();
            $l$break_0: while (true) {
              var tmp_0;
              if (ss_22._get_hasMore__0_k$()) {
                var tmp0__anonymous__1_5_28 = ss_22.peekChar_0_k$();
                tmp_0 = !_get_isNumeric_(tmp0__anonymous__1_5_28);
              } else {
                tmp_0 = false;
              }
              if (!tmp_0) {
                break $l$break_0;
              }ss_22.readChar_0_k$();
              Unit_getInstance();
            }
            var start_1_2_8_31 = ss_22._pos_0;
            $l$break_1: while (true) {
              var tmp_1;
              if (ss_22._get_hasMore__0_k$()) {
                var tmp1__anonymous__4_9_32 = ss_22.peekChar_0_k$();
                tmp_1 = _get_isNumeric_(tmp1__anonymous__4_9_32);
              } else {
                tmp_1 = false;
              }
              if (!tmp_1) {
                break $l$break_1;
              }ss_22.readChar_0_k$();
              Unit_getInstance();
            }
            var end_2_3_10_33 = ss_22._pos_0;
            var tmp0_elvis_lhs_1_7_30 = end_2_3_10_33 > start_1_2_8_31 ? ss_22.slice_27zxwg_k$(start_1_2_8_31, end_2_3_10_33) : null;
            var out_6_29 = toDouble(tmp0_elvis_lhs_1_7_30 == null ? '' : tmp0_elvis_lhs_1_7_30);
            $l$break_2: while (true) {
              var tmp_2;
              if (ss_22._get_hasMore__0_k$()) {
                var tmp2__anonymous__1_11_34 = ss_22.peekChar_0_k$();
                tmp_2 = !_get_isNumeric_(tmp2__anonymous__1_11_34);
              } else {
                tmp_2 = false;
              }
              if (!tmp_2) {
                break $l$break_2;
              }ss_22.readChar_0_k$();
              Unit_getInstance();
            }
            var tmp0_plusAssign_0_2_2_26 = out_6_29;
            tmp0_apply_0_1_24.add_2bq_k$(tmp0_plusAssign_0_2_2_26);
            Unit_getInstance();
          }

          var pps_23 = new ListReader(toList_3(tmp0_apply_0_1_24));
          var path_35 = GraphicsPath_init_$Create$(null, null, null, 7, null);
          var edges_36 = 0;
          path_35.moveTo_ul66c3_k$(pps_23.read_0_k$(), pps_23.read_0_k$());
          while (pps_23._get_hasMore__0_k$()) {
            var x_37 = pps_23.read_0_k$();
            var y_38 = pps_23.read_0_k$();
            path_35.lineTo_ul66c3_k$(x_37, y_38);
            var tmp2_39 = edges_36;
            edges_36 = tmp2_39 + 1 | 0;
            Unit_getInstance();
          }

          if (nodeName_3 === 'polygon')
            path_35.close_sv8swh_k$();
          path_35.getBounds$default_lrzlif_k$(bounds_2, null, 2, null);
          Unit_getInstance();
          c.path_f4hqzb_k$(path_35);
          break;
        case 'line':
          c.beginPath_sv8swh_k$();
          var x1_40 = xml.double$default_s8e18k_k$('x1', 0.0, 2, null);
          var y1_41 = xml.double$default_s8e18k_k$('y1', 0.0, 2, null);
          var x2_42 = xml.double$default_s8e18k_k$('x2', 0.0, 2, null);
          var y2_43 = xml.double$default_s8e18k_k$('y2', 0.0, 2, null);
          c.moveTo_ul66c3_k$(x1_40, y1_41);
          c.lineTo_ul66c3_k$(x2_42, y2_43);
          bounds_2.setBounds_i6u10_k$(x1_40, y1_41, x2_42, y2_43);
          Unit_getInstance();
          break;
        case 'text':
          break;
        case 'path':
          var d_44 = xml.str$default_877n1b_k$('d', null, 2, null);
          var tokens_45 = Companion_getInstance_160().tokenizePath_6wfw3l_k$(d_44);
          var tl_46 = new ListReader(tokens_45);
          c.beginPath_sv8swh_k$();
          c.moveTo_ul66c3_k$(0.0, 0.0);
          var lastCX_63 = 0.0;
          var lastCY_64 = 0.0;
          var lastCmd_65 = new Char(45);
          $l$break_3: while (tl_46._get_hasMore__0_k$()) {
            var tmp3_elvis_lhs_67 = drawElement$readNextTokenCmd_60(tl_46, this, tokens_45);
            var tmp_3;
            if (tmp3_elvis_lhs_67 == null) {
              break $l$break_3;
            } else {
              tmp_3 = tmp3_elvis_lhs_67;
            }
            var cmd_66 = tmp_3;
            if (cmd_66.equals(new Char(0)) ? true : isWhitespaceFast(cmd_66))
              continue $l$break_3;
            var relative_68 = new Char(97) <= cmd_66 ? cmd_66 <= new Char(122) : false;
            var tmp4_subject_70 = lastCmd_65;
            var lastCurve_69 = (((((((tmp4_subject_70.equals(new Char(83)) ? true : tmp4_subject_70.equals(new Char(67))) ? true : tmp4_subject_70.equals(new Char(84))) ? true : tmp4_subject_70.equals(new Char(81))) ? true : tmp4_subject_70.equals(new Char(115))) ? true : tmp4_subject_70.equals(new Char(99))) ? true : tmp4_subject_70.equals(new Char(116))) ? true : tmp4_subject_70.equals(new Char(113))) ? true : false;
            var tmp5_subject_71 = cmd_66;
            if (tmp5_subject_71.equals(new Char(77)) ? true : tmp5_subject_71.equals(new Char(109))) {
              rMoveTo(c, drawElement$n_57(tl_46, this, tokens_45), drawElement$n_57(tl_46, this, tokens_45), relative_68);
              while (drawElement$isNextNumber_53(tl_46))
                rLineTo(c, drawElement$n_57(tl_46, this, tokens_45), drawElement$n_57(tl_46, this, tokens_45), relative_68);
            } else if (tmp5_subject_71.equals(new Char(76)) ? true : tmp5_subject_71.equals(new Char(108)))
              while (drawElement$isNextNumber_53(tl_46))
                rLineTo(c, drawElement$n_57(tl_46, this, tokens_45), drawElement$n_57(tl_46, this, tokens_45), relative_68);
            else if (tmp5_subject_71.equals(new Char(72)) ? true : tmp5_subject_71.equals(new Char(104)))
              while (drawElement$isNextNumber_53(tl_46))
                rLineToH(c, drawElement$n_57(tl_46, this, tokens_45), relative_68);
            else if (tmp5_subject_71.equals(new Char(86)) ? true : tmp5_subject_71.equals(new Char(118)))
              while (drawElement$isNextNumber_53(tl_46))
                rLineToV(c, drawElement$n_57(tl_46, this, tokens_45), relative_68);
            else if (tmp5_subject_71.equals(new Char(81)) ? true : tmp5_subject_71.equals(new Char(113)))
              while (drawElement$isNextNumber_53(tl_46)) {
                var cx_72 = drawElement$nX_58(c, tl_46, this, tokens_45, relative_68);
                var cy_73 = drawElement$nY_59(c, tl_46, this, tokens_45, relative_68);
                var x2_74 = drawElement$nX_58(c, tl_46, this, tokens_45, relative_68);
                var y2_75 = drawElement$nY_59(c, tl_46, this, tokens_45, relative_68);
                lastCX_63 = cx_72;
                lastCY_64 = cy_73;
                c.quadTo_lf7oid_k$(cx_72, cy_73, x2_74, y2_75);
              }
             else if (tmp5_subject_71.equals(new Char(67)) ? true : tmp5_subject_71.equals(new Char(99)))
              while (drawElement$isNextNumber_53(tl_46)) {
                var x1_76 = drawElement$nX_58(c, tl_46, this, tokens_45, relative_68);
                var y1_77 = drawElement$nY_59(c, tl_46, this, tokens_45, relative_68);
                var x2_78 = drawElement$nX_58(c, tl_46, this, tokens_45, relative_68);
                var y2_79 = drawElement$nY_59(c, tl_46, this, tokens_45, relative_68);
                var x_80 = drawElement$nX_58(c, tl_46, this, tokens_45, relative_68);
                var y_81 = drawElement$nY_59(c, tl_46, this, tokens_45, relative_68);
                lastCX_63 = x2_78;
                lastCY_64 = y2_79;
                c.cubicTo_iylh49_k$(x1_76, y1_77, x2_78, y2_79, x_80, y_81);
              }
             else if (tmp5_subject_71.equals(new Char(83)) ? true : tmp5_subject_71.equals(new Char(115))) {
              while (drawElement$isNextNumber_53(tl_46)) {
                var x2_82 = drawElement$nX_58(c, tl_46, this, tokens_45, relative_68);
                var y2_83 = drawElement$nY_59(c, tl_46, this, tokens_45, relative_68);
                var x_84 = drawElement$nX_58(c, tl_46, this, tokens_45, relative_68);
                var y_85 = drawElement$nY_59(c, tl_46, this, tokens_45, relative_68);
                var x1_86 = lastCurve_69 ? c._get_lastX__0_k$() * 2 - lastCX_63 : c._get_lastX__0_k$();
                var y1_87 = lastCurve_69 ? c._get_lastY__0_k$() * 2 - lastCY_64 : c._get_lastY__0_k$();
                lastCX_63 = x2_82;
                lastCY_64 = y2_83;
                c.cubicTo_iylh49_k$(x1_86, y1_87, x2_82, y2_83, x_84, y_85);
                lastCurve_69 = true;
              }
            } else if (tmp5_subject_71.equals(new Char(84)) ? true : tmp5_subject_71.equals(new Char(116))) {
              var n_88 = 0;
              while (drawElement$isNextNumber_53(tl_46)) {
                var x2_89 = drawElement$nX_58(c, tl_46, this, tokens_45, relative_68);
                var y2_90 = drawElement$nY_59(c, tl_46, this, tokens_45, relative_68);
                var cx_91 = lastCurve_69 ? c._get_lastX__0_k$() * 2 - lastCX_63 : c._get_lastX__0_k$();
                var cy_92 = lastCurve_69 ? c._get_lastY__0_k$() * 2 - lastCY_64 : c._get_lastY__0_k$();
                lastCX_63 = cx_91;
                lastCY_64 = cy_92;
                c.quadTo_lf7oid_k$(cx_91, cy_92, x2_89, y2_90);
                var tmp6_93 = n_88;
                n_88 = tmp6_93 + 1 | 0;
                Unit_getInstance();
                lastCurve_69 = true;
              }
            } else if (tmp5_subject_71.equals(new Char(65)) ? true : tmp5_subject_71.equals(new Char(97))) {
              var tmp2__get_absoluteValue__0_95 = drawElement$readNumber_54(tl_46, this, tokens_45);
              var rx_94 = Math.abs(tmp2__get_absoluteValue__0_95);
              var tmp3__get_absoluteValue__0_97 = drawElement$readNumber_54(tl_46, this, tokens_45);
              var ry_96 = Math.abs(tmp3__get_absoluteValue__0_97);
              var rotx_98 = drawElement$readNumber_54(tl_46, this, tokens_45) / 180.0 * 3.141592653589793;
              var tmp_4;
              var tmp4__get_absoluteValue__0_100 = drawElement$readNumber_54(tl_46, this, tokens_45);
              if (Math.abs(tmp4__get_absoluteValue__0_100) > 1.0E-6) {
                tmp_4 = 1;
              } else {
                {
                  tmp_4 = 0;
                }
              }
              var fa_99 = tmp_4;
              var tmp_5;
              var tmp5__get_absoluteValue__0_102 = drawElement$readNumber_54(tl_46, this, tokens_45);
              if (Math.abs(tmp5__get_absoluteValue__0_102) > 1.0E-6) {
                tmp_5 = 1;
              } else {
                {
                  tmp_5 = 0;
                }
              }
              var fs_101 = tmp_5;
              var x1_103 = c._get_lastX__0_k$();
              var y1_104 = c._get_lastY__0_k$();
              var x2_105 = drawElement$nX_58(c, tl_46, this, tokens_45, relative_68);
              var y2_106 = drawElement$nY_59(c, tl_46, this, tokens_45, relative_68);
              var dx_107 = x1_103 - x2_105;
              var dy_108 = y1_104 - y2_106;
              var tmp6_hypot_0_110 = dx_107;
              var tmp7_hypot_0_111 = dy_108;
              var d_109 = Math.hypot(tmp6_hypot_0_110, tmp7_hypot_0_111);
              if ((d_109 < 9.999999974752427E-7 ? true : rx_94 < 9.999999974752427E-7) ? true : ry_96 < 9.999999974752427E-7) {
                c.lineTo_ul66c3_k$(x2_105, y2_106);
              } else {
                var sinrx_112 = Math.sin(rotx_98);
                var cosrx_113 = Math.cos(rotx_98);
                var x1p_114 = cosrx_113 * dx_107 / 2.0 + sinrx_112 * dy_108 / 2.0;
                var y1p_115 = -sinrx_112 * dx_107 / 2.0 + cosrx_113 * dy_108 / 2.0;
                var d_116 = sqr(this, x1p_114) / sqr(this, rx_94) + sqr(this, y1p_115) / sqr(this, ry_96);
                if (d_116 > 1.0) {
                  d_116 = sqr(this, d_116);
                  rx_94 = rx_94 * d_116;
                  ry_96 = ry_96 * d_116;
                }var s_117 = 0.0;
                var sa_118 = sqr(this, rx_94) * sqr(this, ry_96) - sqr(this, rx_94) * sqr(this, y1p_115) - sqr(this, ry_96) * sqr(this, x1p_114);
                var sb_119 = sqr(this, rx_94) * sqr(this, y1p_115) + sqr(this, ry_96) * sqr(this, x1p_114);
                if (sa_118 < 0.0)
                  sa_118 = 0.0;
                if (sb_119 > 0.0) {
                  var tmp8_sqrt_0_120 = sa_118 / sb_119;
                  s_117 = Math.sqrt(tmp8_sqrt_0_120);
                }if (fa_99 === fs_101)
                  s_117 = -s_117;
                var cxp_121 = s_117 * rx_94 * y1p_115 / ry_96;
                var cyp_122 = s_117 * -ry_96 * x1p_114 / rx_94;
                var cx_123 = (x1_103 + x2_105) / 2.0 + cosrx_113 * cxp_121 - sinrx_112 * cyp_122;
                var cy_124 = (y1_104 + y2_106) / 2.0 + sinrx_112 * cxp_121 + cosrx_113 * cyp_122;
                var ux_125 = (x1p_114 - cxp_121) / rx_94;
                var uy_126 = (y1p_115 - cyp_122) / ry_96;
                var vx_127 = (-x1p_114 - cxp_121) / rx_94;
                var vy_128 = (-y1p_115 - cyp_122) / ry_96;
                var a1_129 = vecang(this, 1.0, 0.0, ux_125, uy_126);
                var da_130 = vecang(this, ux_125, uy_126, vx_127, vy_128);
                if (fs_101 === 0 ? da_130 > 0.0 : false)
                  da_130 = da_130 - 6.283185307179586;
                else if (fs_101 === 1 ? da_130 < 0.0 : false)
                  da_130 = da_130 + 6.283185307179586;
                this._t_0[0] = cosrx_113;
                this._t_0[1] = sinrx_112;
                this._t_0[2] = -sinrx_112;
                this._t_0[3] = cosrx_113;
                this._t_0[4] = cx_123;
                this._t_0[5] = cy_124;
                var tmp9_abs_0_132 = da_130;
                var ndivs_131 = numberToInt(Math.abs(tmp9_abs_0_132) / 1.5707963267948966 + 1.0);
                var hda_133 = da_130 / ndivs_131 / 2.0;
                var tmp_6 = 4.0 / 3.0;
                var tmp_7 = tmp_6 * (1.0 - Math.cos(hda_133));
                var tmp10_abs_0_135 = tmp_7 / Math.sin(hda_133);
                var kappa_134 = Math.abs(tmp10_abs_0_135);
                if (da_130 < 0.0)
                  kappa_134 = -kappa_134;
                var ptanx_136 = 0.0;
                var ptany_137 = 0.0;
                var px_138 = 0.0;
                var py_139 = 0.0;
                var inductionVariable = 0;
                if (inductionVariable <= ndivs_131)
                  do {
                    var i_141 = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var a_142 = a1_129 + da_130 * (i_141 / ndivs_131);
                    dx_107 = Math.cos(a_142);
                    dy_108 = Math.sin(a_142);
                    var x_143 = xformPointX(this, dx_107 * rx_94, dy_108 * ry_96, this._t_0);
                    var y_144 = xformPointY(this, dx_107 * rx_94, dy_108 * ry_96, this._t_0);
                    var tanx_145 = xformVecX(this, -dy_108 * rx_94 * kappa_134, dx_107 * ry_96 * kappa_134, this._t_0);
                    var tany_146 = xformVecY(this, -dy_108 * rx_94 * kappa_134, dx_107 * ry_96 * kappa_134, this._t_0);
                    if (i_141 > 0) {
                      c.cubicTo_iylh49_k$(px_138 + ptanx_136, py_139 + ptany_137, x_143 - tanx_145, y_144 - tany_146, x_143, y_144);
                    }px_138 = x_143;
                    py_139 = y_144;
                    ptanx_136 = tanx_145;
                    ptany_137 = tany_146;
                  }
                   while (!(i_141 === ndivs_131));
                c._set_lastX__okcceq_k$(x2_105);
                c._set_lastY__okcceq_k$(y2_106);
              }
            } else if (tmp5_subject_71.equals(new Char(90)) ? true : tmp5_subject_71.equals(new Char(122)))
              c.close_sv8swh_k$();
            else {
              var tmp_8 = cmd_66.toInt_0_k$();
              var tmp_9 = c._state_5._path_22;
              var tmp11_TODO_0_147 = '' + "Unsupported command '" + cmd_66 + "' (" + tmp_8 + ") : Parsed: '" + toSvgPathString$default(tmp_9, null, 0, 3, null) + "', Original: '" + d_44 + "'";
              throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp11_TODO_0_147);
            }
            lastCmd_65 = cmd_66;
          }

          var tmp8_safe_receiver_148 = this._warningProcessor;
          if (tmp8_safe_receiver_148 == null)
            null;
          else {
            var tmp_10 = c._state_5._path_22;
            tmp8_safe_receiver_148('' + "Parsed SVG Path: '" + toSvgPathString$default(tmp_10, null, 0, 3, null) + "'");
          }

          Unit_getInstance();
          var tmp9_safe_receiver_149 = this._warningProcessor;
          if (tmp9_safe_receiver_149 == null)
            null;
          else
            tmp9_safe_receiver_149('' + "Original SVG Path: '" + d_44 + "'");
          Unit_getInstance();
          var tmp10_safe_receiver_150 = this._warningProcessor;
          if (tmp10_safe_receiver_150 == null)
            null;
          else
            tmp10_safe_receiver_150('' + 'Points: ' + c._state_5._path_22.getPoints_0_k$());
          Unit_getInstance();
          c.getBounds_uebyw0_k$(bounds_2);
          Unit_getInstance();
          break;
        default:var tmp11_safe_receiver_151 = this._warningProcessor;
          if (tmp11_safe_receiver_151 == null)
            null;
          else
            tmp11_safe_receiver_151('' + "Unhandled SVG node '" + nodeName_3 + "'");
          Unit_getInstance();
          drawChildren_4 = true;
          break;
      }
      var tmp12_iterator_152 = attributes_6._get_entries__0_k$().iterator_0_k$();
      while (tmp12_iterator_152.hasNext_0_k$()) {
        var tmp13_loop_parameter_153 = tmp12_iterator_152.next_0_k$();
        var key_154 = tmp13_loop_parameter_153._get_key__0_k$();
        var it_155 = tmp13_loop_parameter_153._get_value__0_k$();
        var tmp14_subject_156 = key_154;
        switch (tmp14_subject_156) {
          case 'stroke-width':
            var tmp15_elvis_lhs_157 = toDoubleOrNull(it_155);
            c._set_lineWidth__okcceq_k$(tmp15_elvis_lhs_157 == null ? 1.0 : tmp15_elvis_lhs_157);
            break;
          case 'stroke-linejoin':
            c._set_lineJoin__n3bztj_k$(Companion_getInstance_54().get_uch40_k$(it_155));
            break;
          case 'stroke-linecap':
            c._set_lineCap__li1cb3_k$(Companion_getInstance_53().get_uch40_k$(it_155));
            break;
          case 'stroke':
            c._set_strokeStyle__y73s1i_k$(this.parseFillStroke_3thyg_k$(c, it_155, bounds_2));
            break;
          case 'opacity':
            var tmp16_this_158 = c;
            var tmp_11 = tmp16_this_158._get_globalAlpha__0_k$();
            var tmp17_elvis_lhs_159 = toDoubleOrNull(it_155);
            tmp16_this_158._set_globalAlpha__okcceq_k$(tmp_11 * (tmp17_elvis_lhs_159 == null ? 1.0 : tmp17_elvis_lhs_159));
            break;
          case 'fill-opacity':
            var tmp18_this_160 = c;
            var tmp_12 = tmp18_this_160._get_globalAlpha__0_k$();
            var tmp19_elvis_lhs_161 = toDoubleOrNull(it_155);
            tmp18_this_160._set_globalAlpha__okcceq_k$(tmp_12 * (tmp19_elvis_lhs_161 == null ? 1.0 : tmp19_elvis_lhs_161));
            break;
          case 'stroke-opacity':
            var tmp20_this_162 = c;
            var tmp_13 = tmp20_this_162._get_globalAlpha__0_k$();
            var tmp21_elvis_lhs_163 = toDoubleOrNull(it_155);
            tmp20_this_162._set_globalAlpha__okcceq_k$(tmp_13 * (tmp21_elvis_lhs_163 == null ? 1.0 : tmp21_elvis_lhs_163));
            break;
          case 'fill':
            this.applyFill_48hlpl_k$(c, it_155, bounds_2);
            break;
          case 'font-size':
            c._set_fontSize__okcceq_k$(this.parseSizeAsDouble_6wfw3l_k$(it_155));
            break;
          case 'font-family':
            c._set_font__jq2c8m_k$(c._get_fontRegistry__0_k$().get_6wfw3l_k$(it_155));
            break;
          case 'text-anchor':
            var tmp12_trim_0_165 = it_155.toLowerCase();
            var tmp22_subject_164 = toString_1(trim_0(isCharSequence(tmp12_trim_0_165) ? tmp12_trim_0_165 : THROW_CCE()));
            c._set_horizontalAlign__4fnuf6_k$(tmp22_subject_164 === 'left' ? Companion_getInstance_152()._LEFT : (tmp22_subject_164 === 'center' ? true : tmp22_subject_164 === 'middle') ? Companion_getInstance_152()._CENTER : (tmp22_subject_164 === 'right' ? true : tmp22_subject_164 === 'end') ? Companion_getInstance_152()._RIGHT : c._get_horizontalAlign__mfkab4_k$());
            break;
          case 'alignment-baseline':
            var tmp13_trim_0_167 = it_155.toLowerCase();
            var tmp23_subject_166 = toString_1(trim_0(isCharSequence(tmp13_trim_0_167) ? tmp13_trim_0_167 : THROW_CCE()));
            c._set_verticalAlign__4c4bf4_k$(tmp23_subject_166 === 'hanging' ? Companion_getInstance_151()._TOP : (tmp23_subject_166 === 'center' ? true : tmp23_subject_166 === 'middle') ? Companion_getInstance_151()._MIDDLE : tmp23_subject_166 === 'baseline' ? Companion_getInstance_151()._BASELINE : tmp23_subject_166 === 'bottom' ? Companion_getInstance_151()._BOTTOM : c._get_verticalAlign__8gdh1a_k$());
            break;
          case 'fill-rule':
            Unit_getInstance();
            break;
        }
      }
      if (drawChildren_4) {
        this.drawChildren_vcw7m7_k$(xml, c, render_5);
      }var tmp24_subject_168 = nodeName_3;
      if (tmp24_subject_168 === 'text') {
        var tmp14_trim_0_169 = xml._get_text__0_k$();
        var tmp_14 = toString_1(trim_0(isCharSequence(tmp14_trim_0_169) ? tmp14_trim_0_169 : THROW_CCE()));
        var tmp_15 = xml.double$default_s8e18k_k$('x', 0.0, 2, null);
        var tmp_16 = tmp_15 + xml.double$default_s8e18k_k$('dx', 0.0, 2, null);
        var tmp_17 = xml.double$default_s8e18k_k$('y', 0.0, 2, null);
        c.fillText_uk3s5w_k$(tmp_14, tmp_16, tmp_17 + xml.double$default_s8e18k_k$('dy', 0.0, 2, null));
      }c.fillStroke_sv8swh_k$();
    }finally {
      c.restore_sv8swh_k$();
    }
    return c;
  };
  SVG.prototype.parseSizeAsDouble_6wfw3l_k$ = function (size_2) {
    var tmp0_filterTo_0_1 = StringBuilder_init_$Create$_0();
    var inductionVariable = 0;
    var last_1 = charSequenceLength(size_2);
    if (inductionVariable < last_1)
      do {
        var index_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element_3_4 = charSequenceGet(size_2, index_2_3);
        if (!(new Char(97) <= element_3_4 ? element_3_4 <= new Char(122) : false) ? !(new Char(65) <= element_3_4 ? element_3_4 <= new Char(90) : false) : false) {
          tmp0_filterTo_0_1.append_wi8o78_k$(element_3_4);
          Unit_getInstance();
        } else {
        }
      }
       while (inductionVariable < last_1);
    var tmp0_elvis_lhs = toDoubleOrNull(tmp0_filterTo_0_1.toString());
    return tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  };
  SVG.prototype.applyFill_48hlpl_k$ = function (c, str, bounds_0) {
    c._set_fillStyle__y73s1i_k$(this.parseFillStroke_3thyg_k$(c, str, bounds_0));
  };
  SVG.prototype.parseTransform_6wfw3l_k$ = function (str) {
    var tokens = Companion_getInstance_159().tokenize_6wfw3l_k$(str);
    var tr = new ListReader(tokens);
    var out = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    while (tr._get_hasMore__0_k$()) {
      var tmp0_toLowerCase_0 = tr.read_0_k$();
      var id = tmp0_toLowerCase_0.toLowerCase();
      var args = ArrayList_init_$Create$();
      if (tr.peek_0_k$() === '(') {
        tr.read_0_k$();
        Unit_getInstance();
        $l$break: while (true) {
          if (tr.peek_0_k$() === ')') {
            tr.read_0_k$();
            Unit_getInstance();
            break $l$break;
          }if (tr.peek_0_k$() === ',') {
            tr.read_0_k$();
            Unit_getInstance();
            continue $l$break;
          }var tmp1_plusAssign_0 = tr.read_0_k$();
          args.add_2bq_k$(tmp1_plusAssign_0);
          Unit_getInstance();
        }
      }var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(args, 10));
      var tmp0_iterator_1_2 = args.iterator_0_k$();
      while (tmp0_iterator_1_2.hasNext_0_k$()) {
        var item_2_3 = tmp0_iterator_1_2.next_0_k$();
        var tmp0_elvis_lhs_5 = toDoubleOrNull(item_2_3);
        tmp0_mapTo_0_1.add_2bq_k$(tmp0_elvis_lhs_5 == null ? 0.0 : tmp0_elvis_lhs_5);
        Unit_getInstance();
      }
      var doubleArgs = tmp0_mapTo_0_1;
      var tmp0_subject = id;
      switch (tmp0_subject) {
        case 'translate':
          out.pretranslate_ngl742_k$(parseTransform$double(doubleArgs, 0), parseTransform$double(doubleArgs, 1));
          Unit_getInstance();
          break;
        case 'scale':
          out.prescale_ngl742_k$(parseTransform$double(doubleArgs, 0), doubleArgs._get_size__0_k$() >= 2 ? parseTransform$double(doubleArgs, 1) : parseTransform$double(doubleArgs, 0));
          Unit_getInstance();
          break;
        case 'matrix':
          out.premultiply_hmhsjq_k$(parseTransform$double(doubleArgs, 0), parseTransform$double(doubleArgs, 1), parseTransform$double(doubleArgs, 2), parseTransform$double(doubleArgs, 3), parseTransform$double(doubleArgs, 4), parseTransform$double(doubleArgs, 5));
          Unit_getInstance();
          break;
        case 'rotate':
          if (doubleArgs._get_size__0_k$() >= 3) {
            out.pretranslate_ngl742_k$(parseTransform$double(doubleArgs, 1), parseTransform$double(doubleArgs, 2));
            Unit_getInstance();
          }
          out.prerotate_ubek5g_k$(_get_degrees__1(parseTransform$double(doubleArgs, 0)));
          Unit_getInstance();
          if (doubleArgs._get_size__0_k$() >= 3) {
            out.pretranslate_ngl742_k$(-parseTransform$double(doubleArgs, 1), -parseTransform$double(doubleArgs, 2));
            Unit_getInstance();
          }
          break;
        default:invalidOp('' + 'Unsupported transform ' + id + ' : ' + args + ' : ' + doubleArgs + ' (' + str + ')');
          break;
      }
    }
    return out;
  };
  SVG.$metadata$ = {
    simpleName: 'SVG',
    kind: 'class',
    interfaces: [SizedDrawable]
  };
  function readSVG(_this_, $cont) {
    var tmp = new $readSVGCOROUTINE$19(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function $readSVGCOROUTINE$19(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__130 = _this_;
  }
  $readSVGCOROUTINE$19.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readXml(this.__this__130, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return SVG_init_$Create$(ARGUMENT, null, 2, null);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readSVGCOROUTINE$19.$metadata$ = {
    simpleName: '$readSVGCOROUTINE$19',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__283($xmax, $xmin, this$0, $callback) {
    this._$xmax = $xmax;
    this._$xmin = $xmin;
    this._this$0_65 = this$0;
    this._$callback_3 = $callback;
  }
  _no_name_provided__283.prototype.invoke_zd700_k$ = function (a, b, y) {
    if (a <= this._$xmax ? b >= this._$xmin : false) {
      var a0 = coerceIn(a, this._$xmin, this._$xmax);
      var b0 = coerceIn(b, this._$xmin, this._$xmax);
      if (this._this$0_65._debug) {
        println('' + 'RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }this._$callback_3(a0, b0, y);
    } else {
    }
  };
  _no_name_provided__283.prototype.invoke_ifn5k1_k$ = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    this.invoke_zd700_k$(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__283.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Rasterizer() {
    RastScale.call(this);
    this._debug = false;
    this._tempRect_1 = Companion_getInstance_35().invoke_0_k$();
    this._quality_0 = 2;
    this._scale_0 = 1;
    this._path_25 = new PolygonScanline();
    this._clip_3 = new PolygonScanline();
    this._fillSegmentSet = new IntSegmentSet();
    this._clipSegmentSet = new IntSegmentSet();
    this._finalSegmentSet = new IntSegmentSet();
    this._yList_1 = new IntArrayList(1024);
  }
  Rasterizer.prototype.reset_sv8swh_k$ = function () {
    this._path_25.reset_sv8swh_k$();
    this._clip_3.reset_sv8swh_k$();
  };
  Rasterizer.prototype.rasterizeFill_7hf1u3_k$ = function (bounds_0, quality, stats, winding, callback) {
    var tmp0_safe_receiver = stats;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.reset_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
    var xmin = this._get_s__xaho5p_k$(bounds_0._get_left__0_k$());
    var xmax = this._get_s__xaho5p_k$(bounds_0._get_right__0_k$());
    this._path_25.getBounds_uebyw0_k$(this._tempRect_1);
    Unit_getInstance();
    var tmp0_max_0 = bounds_0._get_top__0_k$();
    var tmp1_max_0 = this._tempRect_1._get_top__0_k$();
    var startY = this._get_s__xaho5p_k$(Math.max(tmp0_max_0, tmp1_max_0));
    var tmp2_min_0 = bounds_0._get_bottom__0_k$();
    var tmp3_min_0 = this._tempRect_1._get_bottom__0_k$();
    var endY = this._get_s__xaho5p_k$(Math.min(tmp2_min_0, tmp3_min_0));
    var func = _no_name_provided_$factory_232(xmax, xmin, this, callback);
    this._yList_1.clear_sv8swh_k$();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this._get_sscale__0_k$() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last_1 = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this._get_sscale__0_k$()) / this._scale_0 | 0) / q | 0) | 0;
        this._yList_1.add_majfzk_k$(y);
      }
       while (inductionVariable < last_1);
    var edgesEmitted_2 = 0;
    var edgesChecked_3 = 0;
    var tmp0_fastForEach_0_4 = this._yList_1;
    var n_1_5 = 0;
    while (n_1_5 < tmp0_fastForEach_0_4._get_size__0_k$()) {
      var tmp0_2_7 = n_1_5;
      n_1_5 = tmp0_2_7 + 1 | 0;
      var tmp1__anonymous__3_6 = tmp0_fastForEach_0_4.getAt_ha5a7z_k$(tmp0_2_7);
      this._path_25.scanline_qob2xp_k$(tmp1__anonymous__3_6, winding, this._fillSegmentSet);
      Unit_getInstance();
      edgesChecked_3 = edgesChecked_3 + this._path_25._edgesChecked | 0;
      if (this._clip_3.isNotEmpty_0_k$()) {
        this._clip_3.scanline_qob2xp_k$(tmp1__anonymous__3_6, this._clip_3._winding, this._clipSegmentSet);
        Unit_getInstance();
        edgesChecked_3 = edgesChecked_3 + this._clip_3._edgesChecked | 0;
        this._finalSegmentSet.setToIntersect_iwrchs_k$(this._fillSegmentSet, this._clipSegmentSet);
        Unit_getInstance();
      }var tmp0_fastForEach_0_4_8 = this._clip_3.isNotEmpty_0_k$() ? this._finalSegmentSet : this._fillSegmentSet;
      var inductionVariable_0 = 0;
      var last_2 = tmp0_fastForEach_0_4_8._get_size__0_k$();
      if (inductionVariable_0 < last_2)
        do {
          var n_2_6_10 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp1__anonymous__3_7_11 = tmp0_fastForEach_0_4_8._min.getAt_ha5a7z_k$(n_2_6_10);
          var tmp2__anonymous__3_8_12 = tmp0_fastForEach_0_4_8._max.getAt_ha5a7z_k$(n_2_6_10);
          func(tmp1__anonymous__3_7_11, tmp2__anonymous__3_8_12, tmp1__anonymous__3_6);
          var tmp0_4_9_13 = edgesEmitted_2;
          edgesEmitted_2 = tmp0_4_9_13 + 1 | 0;
          Unit_getInstance();
        }
         while (inductionVariable_0 < last_2);
    }
    var tmp0_safe_receiver_14 = stats;
    if (tmp0_safe_receiver_14 == null)
      null;
    else {
      tmp0_safe_receiver_14.chunk_zd700_k$(edgesChecked_3, edgesEmitted_2, yCount);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  Rasterizer.prototype.rasterizeFill$default_u3mu3e_k$ = function (bounds_0, quality, stats, winding, callback, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      quality = this._quality_0;
    if (!(($mask0 & 4) === 0))
      stats = null;
    if (!(($mask0 & 8) === 0))
      winding = Winding_NON_ZERO_getInstance();
    return this.rasterizeFill_7hf1u3_k$(bounds_0, quality, stats, winding, callback);
  };
  Rasterizer.$metadata$ = {
    simpleName: 'Rasterizer',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_232($xmax, $xmin, this$0, $callback) {
    var i = new _no_name_provided__283($xmax, $xmin, this$0, $callback);
    return function (p1, p2, p3) {
      i.invoke_zd700_k$(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__284($x, $y, $width, $height) {
    this._$x_0 = $x;
    this._$y_0 = $y;
    this._$width_0 = $width;
    this._$height_0 = $height;
  }
  _no_name_provided__284.prototype.invoke_xvzmk5_k$ = function ($this$transformed) {
    rect($this$transformed, this._$x_0, this._$y_0, this._$width_0, this._$height_0);
  };
  _no_name_provided__284.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xvzmk5_k$((!(p1 == null) ? isInterface(p1, VectorBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__284.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Renderer() {
    this._debug_0 = false;
    this._bufferingLevel = 0;
  }
  Renderer.prototype._get_debug__0_k$ = function () {
    return this._debug_0;
  };
  Renderer.prototype.flush_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  Renderer.prototype.bufferingStart_0_k$ = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._bufferingLevel;
    tmp0_this._bufferingLevel = tmp1 + 1 | 0;
    return tmp1;
  };
  Renderer.prototype.bufferingEnd_sv8swh_k$ = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._bufferingLevel;
    tmp0_this._bufferingLevel = tmp1 - 1 | 0;
    Unit_getInstance();
    if (this._bufferingLevel === 0) {
      this.flush_sv8swh_k$();
    }};
  Renderer.prototype.render_eshf5c_k$ = function (state, fill_4) {
    return Unit_getInstance();
  };
  Renderer.prototype.drawImage_ay2py0_k$ = function (image, x, y, width, height, transform) {
    var tmp0_apply_0 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    if (transform.getType_0_k$().equals(Type_IDENTITY_getInstance())) {
      rect(tmp0_apply_0, x, y, width, height);
    } else {
      transformed(tmp0_apply_0, transform, _no_name_provided_$factory_233(x, y, width, height));
    }
    var tmp = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null).scale_ngl742_k$(width / image._width_2, height / image._height_3).translate_ngl742_k$(x, y);
    var tmp_0 = BitmapPaint_init_$Create$(image, tmp, null, null, false, 28, null);
    this.render_eshf5c_k$(State_init_$Create$(transform, null, tmp0_apply_0, null, 0.0, null, null, null, 0.0, null, tmp_0, null, null, 0.0, null, null, 0.0, null, 261114, null), true);
  };
  Renderer.prototype.dispose_sv8swh_k$ = function () {
    this.flush_sv8swh_k$();
  };
  Renderer.$metadata$ = {
    simpleName: 'Renderer',
    kind: 'class',
    interfaces: []
  };
  function Companion_162() {
    Companion_instance_161 = this;
    DummyRenderer.call(this, 128, 128);
  }
  Companion_162.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_161;
  function Companion_getInstance_161() {
    if (Companion_instance_161 == null)
      new Companion_162();
    return Companion_instance_161;
  }
  function DummyRenderer(width, height) {
    Companion_getInstance_161();
    Renderer.call(this);
    this._width_11 = width;
    this._height_12 = height;
  }
  DummyRenderer.prototype._get_width__0_k$ = function () {
    return this._width_11;
  };
  DummyRenderer.prototype._get_height__0_k$ = function () {
    return this._height_12;
  };
  DummyRenderer.$metadata$ = {
    simpleName: 'DummyRenderer',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_233($x, $y, $width, $height) {
    var i = new _no_name_provided__284($x, $y, $width, $height);
    return function (p1) {
      i.invoke_xvzmk5_k$(p1);
      return Unit_getInstance();
    };
  }
  var nativeSystemFontProvider;
  function HtmlCanvas() {
    HtmlCanvas_instance = this;
  }
  HtmlCanvas.prototype.createCanvas_27zxwg_k$ = function (width, height) {
    if (OS_getInstance()._get_isJsNodeJs__0_k$()) {
      throw IllegalStateException_init_$Create$_0('Canvas not available on Node.JS');
    }var tmp0_unsafeCast_0 = document.createElement('canvas');
    var out = tmp0_unsafeCast_0;
    out.width = width;
    out.height = height;
    return toLike(out);
  };
  HtmlCanvas.$metadata$ = {
    simpleName: 'HtmlCanvas',
    kind: 'object',
    interfaces: []
  };
  var HtmlCanvas_instance;
  function HtmlCanvas_getInstance() {
    if (HtmlCanvas_instance == null)
      new HtmlCanvas();
    return HtmlCanvas_instance;
  }
  function toLike(_this_) {
    return _this_;
  }
  function HtmlImage() {
    HtmlImage_instance = this;
  }
  HtmlImage.prototype.createHtmlCanvas_27zxwg_k$ = function (width, height) {
    return HtmlCanvas_getInstance().createCanvas_27zxwg_k$(width, height);
  };
  HtmlImage.prototype.renderToHtmlCanvas_tmevg3_k$ = function (bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl_(bmpData);
    var tmp0_unsafeCast_0 = canvas.getContext('2d');
    var ctx = tmp0_unsafeCast_0;
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl(bmpData, n);
        var tmp1 = m;
        m = tmp1 + 1 | 0;
        var tmp2_set_0 = tmp1;
        var tmp1_asDynamic_0 = _RGBA___get_r__impl_(c);
        var tmp3_set_0 = tmp1_asDynamic_0;
        idataData[tmp2_set_0] = tmp3_set_0;
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        var tmp5_set_0 = tmp2;
        var tmp4_asDynamic_0 = _RGBA___get_g__impl_(c);
        var tmp6_set_0 = tmp4_asDynamic_0;
        idataData[tmp5_set_0] = tmp6_set_0;
        var tmp3 = m;
        m = tmp3 + 1 | 0;
        var tmp8_set_0 = tmp3;
        var tmp7_asDynamic_0 = _RGBA___get_b__impl_(c);
        var tmp9_set_0 = tmp7_asDynamic_0;
        idataData[tmp8_set_0] = tmp9_set_0;
        var tmp4 = m;
        m = tmp4 + 1 | 0;
        var tmp11_set_0 = tmp4;
        var tmp10_asDynamic_0 = _RGBA___get_a__impl_(c);
        var tmp12_set_0 = tmp10_asDynamic_0;
        idataData[tmp11_set_0] = tmp12_set_0;
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  };
  HtmlImage.prototype.renderToHtmlCanvas_8a8z9i_k$ = function (bmp, canvas) {
    return this.renderToHtmlCanvas_tmevg3_k$(bmp.depremultipliedIfRequired_0_k$()._data_25, bmp._get_width__0_k$(), bmp._get_height__0_k$(), canvas);
  };
  HtmlImage.prototype.bitmapToHtmlCanvas_g2ppza_k$ = function (bmp) {
    return this.renderToHtmlCanvas_8a8z9i_k$(bmp, this.createHtmlCanvas_27zxwg_k$(bmp._get_width__0_k$(), bmp._get_height__0_k$()));
  };
  HtmlImage.$metadata$ = {
    simpleName: 'HtmlImage',
    kind: 'object',
    interfaces: []
  };
  var HtmlImage_instance;
  function HtmlImage_getInstance() {
    if (HtmlImage_instance == null)
      new HtmlImage();
    return HtmlImage_instance;
  }
  function toHtmlNative(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof HtmlNativeImage) {
      tmp = _this_;
    } else {
      {
        tmp = HtmlNativeImage_init_$Create$_0(HtmlImage_getInstance().bitmapToHtmlCanvas_g2ppza_k$(_this_.toBMP32_0_k$()));
      }
    }
    return tmp;
  }
  var nativeImageFormatProvider;
  var tempB;
  var tempI;
  var temp8;
  function _get_isLittleEndian_() {
    var tmp0_getValue_0 = isLittleEndian$factory();
    return isLittleEndian$delegate._get_value__0_k$();
  }
  var isLittleEndian$delegate;
  function _no_name_provided__285() {
  }
  _no_name_provided__285.prototype.invoke_0_k$ = function () {
    var tmp0_also_0 = RegisteredImageFormats_getInstance();
    tmp0_also_0.register_mo7ym5_k$([PNG_getInstance()]);
    return tmp0_also_0;
  };
  _no_name_provided__285.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function NodeJsNativeImageFormatProvider() {
    NodeJsNativeImageFormatProvider_instance = this;
    BaseNativeImageFormatProvider.call(this);
    var tmp = this;
    tmp._formats$delegate = lazy(_no_name_provided_$factory_235());
  }
  NodeJsNativeImageFormatProvider.prototype._get_formats__0_k$ = function () {
    var tmp0_getValue_0 = formats$factory();
    return this._formats$delegate._get_value__0_k$();
  };
  NodeJsNativeImageFormatProvider.$metadata$ = {
    simpleName: 'NodeJsNativeImageFormatProvider',
    kind: 'object',
    interfaces: []
  };
  var NodeJsNativeImageFormatProvider_instance;
  function NodeJsNativeImageFormatProvider_getInstance() {
    if (NodeJsNativeImageFormatProvider_instance == null)
      new NodeJsNativeImageFormatProvider();
    return NodeJsNativeImageFormatProvider_instance;
  }
  function $decodeCOROUTINE$20(_this_, data, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__131 = _this_;
    this._data_29 = data;
    this._premultiplied_6 = premultiplied;
  }
  $decodeCOROUTINE$20.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = BrowserImage_getInstance().decodeToCanvas_wodl3r_k$(this._data_29, this._premultiplied_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return HtmlNativeImage_init_$Create$_0(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$20.$metadata$ = {
    simpleName: '$decodeCOROUTINE$20',
    kind: 'class',
    interfaces: []
  };
  function $decodeCOROUTINE$21(_this_, vfs, path_0, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__132 = _this_;
    this._vfs_4 = vfs;
    this._path_26 = path_0;
    this._premultiplied_7 = premultiplied;
  }
  $decodeCOROUTINE$21.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._tmp0_subject0 = this._vfs_4;
            var tmp_0 = this._tmp0_subject0;
            if (tmp_0 instanceof LocalVfs) {
              this._state_1 = 4;
              var tmp_1 = BrowserImage_getInstance();
              suspendResult = tmp_1.loadImage$default_zmr95_k$(this._path_26, false, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                var tmp_2 = this._tmp0_subject0;
                if (tmp_2 instanceof UrlVfs_0) {
                  this._jsUrl2 = this._vfs_4.getFullUrl_6wfw3l_k$(this._path_26);
                  this._state_1 = 3;
                  suspendResult = BrowserImage_getInstance().loadImage_2f0f39_k$(this._jsUrl2, this._premultiplied_7, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    this._ARGUMENT3_2 = BrowserImage_getInstance();
                    this._state_1 = 1;
                    suspendResult = this._vfs_4.get_6wfw3l_k$(this._path_26).readAll_0_k$(this);
                    if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                      return suspendResult;
                    }continue $sm;
                  }
                }
                Unit_getInstance();
              }
            }

            break;
          case 1:
            this._ARGUMENT4_1 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT3_2.decodeToCanvas_wodl3r_k$(this._ARGUMENT4_1, this._premultiplied_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this._WHEN_RESULT1_7 = HtmlNativeImage_init_$Create$_0(ARGUMENT);
            this._state_1 = 5;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this._WHEN_RESULT1_7 = HtmlNativeImage_init_$Create$(ARGUMENT_0);
            this._state_1 = 5;
            continue $sm;
          case 4:
            var ARGUMENT_1 = suspendResult;
            this._WHEN_RESULT1_7 = HtmlNativeImage_init_$Create$(ARGUMENT_1);
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT1_7;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$21.$metadata$ = {
    simpleName: '$decodeCOROUTINE$21',
    kind: 'class',
    interfaces: []
  };
  function HtmlNativeImageFormatProvider() {
    HtmlNativeImageFormatProvider_instance = this;
    NativeImageFormatProvider.call(this);
  }
  HtmlNativeImageFormatProvider.prototype.decode_wodl3r_k$ = function (data, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$20(this, data, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HtmlNativeImageFormatProvider.prototype.decode_s6xc1l_k$ = function (vfs, path_0, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$21(this, vfs, path_0, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HtmlNativeImageFormatProvider.prototype.create_y42205_k$ = function (width, height, premultiplied) {
    return HtmlNativeImage_init_$Create$_0(HtmlCanvas_getInstance().createCanvas_27zxwg_k$(width, height));
  };
  HtmlNativeImageFormatProvider.prototype.copy_nc8knv_k$ = function (bmp) {
    return HtmlNativeImage_init_$Create$_0(HtmlImage_getInstance().bitmapToHtmlCanvas_g2ppza_k$(bmp.toBMP32_0_k$()));
  };
  HtmlNativeImageFormatProvider.$metadata$ = {
    simpleName: 'HtmlNativeImageFormatProvider',
    kind: 'object',
    interfaces: []
  };
  var HtmlNativeImageFormatProvider_instance;
  function HtmlNativeImageFormatProvider_getInstance() {
    if (HtmlNativeImageFormatProvider_instance == null)
      new HtmlNativeImageFormatProvider();
    return HtmlNativeImageFormatProvider_instance;
  }
  function HtmlNativeImage_init_$Init$(img, $this) {
    HtmlNativeImage.call($this, img, img.width, img.height);
    return $this;
  }
  function HtmlNativeImage_init_$Create$(img) {
    return HtmlNativeImage_init_$Init$(img, Object.create(HtmlNativeImage.prototype));
  }
  function HtmlNativeImage_init_$Init$_0(canvas, $this) {
    HtmlNativeImage.call($this, canvas, canvas.width, canvas.height);
    return $this;
  }
  function HtmlNativeImage_init_$Create$_0(canvas) {
    return HtmlNativeImage_init_$Init$_0(canvas, Object.create(HtmlNativeImage.prototype));
  }
  function _no_name_provided__286(this$0, $width, $height) {
    this._this$0_66 = this$0;
    this._$width_1 = $width;
    this._$height_1 = $height;
  }
  _no_name_provided__286.prototype.invoke_0_k$ = function () {
    var tmp;
    var tmp0_asDynamic_0 = this._this$0_66._texSource;
    if (tmp0_asDynamic_0.src !== undefined) {
      var tmp_0 = BrowserImage_getInstance();
      var tmp1_unsafeCast_0 = this._this$0_66._texSource;
      tmp = tmp_0.imageToCanvas_uwb0ef_k$(tmp1_unsafeCast_0, this._$width_1, this._$height_1);
    } else {
      {
        var tmp2_unsafeCast_0 = this._this$0_66._texSource;
        tmp = tmp2_unsafeCast_0;
      }
    }
    var tmp3_also_0 = tmp;
    this._this$0_66._texSource = tmp3_also_0;
    return tmp3_also_0;
  };
  _no_name_provided__286.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__287(this$0) {
    this._this$0_67 = this$0;
  }
  _no_name_provided__287.prototype.invoke_0_k$ = function () {
    var tmp0_unsafeCast_0 = this._this$0_67._get_lazyCanvasElement__0_k$().getContext('2d');
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__287.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function HtmlNativeImage(texSourceBase, width, height) {
    NativeImage.call(this, width, height, texSourceBase, true);
    this._texSourceBase = texSourceBase;
    this._name_20 = 'HtmlNativeImage';
    this._texSource = this._texSourceBase;
    var tmp = this;
    tmp._lazyCanvasElement$delegate = lazy(_no_name_provided_$factory_236(this, width, height));
    var tmp_0 = this;
    tmp_0._ctx$delegate = lazy(_no_name_provided_$factory_237(this));
    var tmp_1 = this;
    tmp_1._lastRefresh = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
  }
  HtmlNativeImage.prototype._get_name__0_k$ = function () {
    return this._name_20;
  };
  HtmlNativeImage.prototype._get_lazyCanvasElement__0_k$ = function () {
    var tmp0_getValue_0 = lazyCanvasElement$factory();
    return this._lazyCanvasElement$delegate._get_value__0_k$();
  };
  HtmlNativeImage.prototype._get_ctx__0_k$ = function () {
    var tmp0_getValue_0 = ctx$factory();
    return this._ctx$delegate._get_value__0_k$();
  };
  HtmlNativeImage.prototype.readPixelsUnsafe_c3kirt_k$ = function (x, y, width, height, out, offset_0) {
    if (width <= 0 ? true : height <= 0)
      return Unit_getInstance();
    var size_2 = imul(width, height);
    var tmp = this._texSourceBase;
    if (tmp instanceof HTMLVideoElement) {
      var now_0 = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
      var elapsedTime = TimeSpan__minus_impl(now_0, this._lastRefresh);
      if (TimeSpan__compareTo_impl(elapsedTime, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(16.0)) >= 0) {
        this._lastRefresh = now_0;
        this._get_ctx__0_k$().clearRect(0.0, 0.0, width, height);
        this._get_ctx__0_k$().drawImage(this._texSourceBase, 0.0, 0.0);
      } else {
      }
    } else {
    }
    var idata = this._get_ctx__0_k$().getImageData(x, y, width, height);
    var tmp0_unsafeCast_0 = asInt32Buffer(idata.data.buffer);
    var data = tmp0_unsafeCast_0;
    arraycopy_3(data, 0, _RgbaArray___get_ints__impl_(out), offset_0, size_2);
    if (_get_isBigEndian_())
      bswap32(_RgbaArray___get_ints__impl_(out), offset_0, size_2);
  };
  HtmlNativeImage.prototype.writePixelsUnsafe_c3kirt_k$ = function (x, y, width, height, out, offset_0) {
    if (width <= 0 ? true : height <= 0)
      return Unit_getInstance();
    var size_2 = imul(width, height);
    var idata = this._get_ctx__0_k$().createImageData(width, height);
    var tmp0_unsafeCast_0 = asInt32Buffer(idata.data.buffer);
    var data = tmp0_unsafeCast_0;
    arraycopy_3(_RgbaArray___get_ints__impl_(out), offset_0, data, 0, size_2);
    if (_get_isBigEndian_())
      bswap32(data, 0, size_2);
    this._get_ctx__0_k$().putImageData(idata, x, y);
  };
  HtmlNativeImage.prototype.getContext2d_vcj5fe_k$ = function (antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this._get_lazyCanvasElement__0_k$()));
  };
  HtmlNativeImage.$metadata$ = {
    simpleName: 'HtmlNativeImage',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__288($img_4, $cancellable_2_2) {
    this._$img_4 = $img_4;
    this._$cancellable_2_2 = $cancellable_2_2;
  }
  _no_name_provided__288.prototype.invoke_xfv2uo_k$ = function (it) {
    var tmp0_resume_0_7 = this._$img_4;
    var tmp0_success_0_1_8 = Companion_getInstance_3();
    this._$cancellable_2_2.resumeWith_bnunh2_k$(_Result___init__impl_(tmp0_resume_0_7));
  };
  _no_name_provided__288.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__288.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__289($jsUrl, $cancellable_2_2) {
    this._$jsUrl = $jsUrl;
    this._$cancellable_2_2_0 = $cancellable_2_2;
  }
  _no_name_provided__289.prototype.invoke_3jifwv_k$ = function (_anonymous_parameter_0_, _anonymous_parameter_1_, _anonymous_parameter_2_, _anonymous_parameter_3_, _anonymous_parameter_4_) {
    var tmp0_resumeWithException_0_10 = RuntimeException_init_$Create$('' + 'error loading image ' + this._$jsUrl);
    var tmp0_failure_0_1_11 = Companion_getInstance_3();
    this._$cancellable_2_2_0.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(tmp0_resumeWithException_0_10)));
  };
  _no_name_provided__289.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = (p1 == null ? true : p1) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_3jifwv_k$(tmp, tmp_0, tmp_1, tmp_2, (p5 == null ? true : isObject(p5)) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__289.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $decodeToCanvasCOROUTINE$22(_this_, bytes, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__133 = _this_;
    this._bytes_0 = bytes;
    this._premultiplied_8 = premultiplied;
  }
  $decodeToCanvasCOROUTINE$22.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            if (OS_getInstance()._get_isJsNodeJs__0_k$()) {
              throw IllegalStateException_init_$Create$_0('Canvas not available on NodeJS');
            }
            var tmp_0 = this;
            this._o_10 = {};
            this._o_10['type'] = 'image/png';
            tmp_0._blob1 = new Blob([this._bytes_0], this._o_10);
            this._blobURL2 = URL.createObjectURL(this._blob1);
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 6;
            this._state_1 = 3;
            suspendResult = this.__this__133.loadCanvas_6wfw3l_k$(this._blobURL2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._tmp$ret$04_10 = suspendResult;
            this._exceptionState = 7;
            this._state_1 = 4;
            var tmp_1 = this;
            continue $sm;
          case 4:
            var tmp_2 = this._tmp$ret$04_10;
            URL.revokeObjectURL(this._blobURL2);
            return tmp_2;
          case 5:
            URL.revokeObjectURL(this._blobURL2);
            return Unit_getInstance();
          case 6:
            this._exceptionState = 7;
            var t = this._exception_0;
            URL.revokeObjectURL(this._blobURL2);
            throw t;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeToCanvasCOROUTINE$22.$metadata$ = {
    simpleName: '$decodeToCanvasCOROUTINE$22',
    kind: 'class',
    interfaces: []
  };
  function $loadCanvasCOROUTINE$23(_this_, jsUrl, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__134 = _this_;
    this._jsUrl = jsUrl;
  }
  $loadCanvasCOROUTINE$23.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__134.loadImage$default_zmr95_k$(this._jsUrl, false, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return this.__this__134.imageToCanvas_nbr3c7_k$(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loadCanvasCOROUTINE$23.$metadata$ = {
    simpleName: '$loadCanvasCOROUTINE$23',
    kind: 'class',
    interfaces: []
  };
  function BrowserImage() {
    BrowserImage_instance = this;
  }
  BrowserImage.prototype.decodeToCanvas_wodl3r_k$ = function (bytes, premultiplied, $cont) {
    var tmp = new $decodeToCanvasCOROUTINE$22(this, bytes, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BrowserImage.prototype.imageToCanvas_nbr3c7_k$ = function (img) {
    return this.imageToCanvas_uwb0ef_k$(img, img.width, img.height);
  };
  BrowserImage.prototype.imageToCanvas_uwb0ef_k$ = function (img, width, height) {
    var canvas = HtmlCanvas_getInstance().createCanvas_27zxwg_k$(width, height);
    var tmp0_unsafeCast_0 = canvas.getContext('2d');
    var ctx = tmp0_unsafeCast_0;
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  };
  BrowserImage.prototype.loadImage_2f0f39_k$ = function (jsUrl, premultiplied, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_sv8swh_k$();
    if (OS_getInstance()._get_isJsNodeJs__0_k$()) {
      throw IllegalStateException_init_$Create$_0('Canvas not available on NodeJS');
    }var tmp0_unsafeCast_0_5 = document.createElement('img');
    var img_4 = tmp0_unsafeCast_0_5;
    img_4.onload = _no_name_provided_$factory_238(img_4, cancellable_2_2);
    img_4.onerror = _no_name_provided_$factory_239(jsUrl, cancellable_2_2);
    img_4.src = jsUrl;
    Unit_getInstance();
    return cancellable_2_2.getResult_0_k$();
  };
  BrowserImage.prototype.loadImage$default_zmr95_k$ = function (jsUrl, premultiplied, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      premultiplied = true;
    return this.loadImage_2f0f39_k$(jsUrl, premultiplied, $cont);
  };
  BrowserImage.prototype.loadCanvas_6wfw3l_k$ = function (jsUrl, $cont) {
    var tmp = new $loadCanvasCOROUTINE$23(this, jsUrl, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BrowserImage.$metadata$ = {
    simpleName: 'BrowserImage',
    kind: 'object',
    interfaces: []
  };
  var BrowserImage_instance;
  function BrowserImage_getInstance() {
    if (BrowserImage_instance == null)
      new BrowserImage();
    return BrowserImage_instance;
  }
  function _get_isBigEndian_() {
    return !_get_isLittleEndian_();
  }
  function bswap32(v, offset_0, size_2) {
    var inductionVariable = offset_0;
    var last_1 = offset_0 + size_2 | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        v[n] = bswap32_0(v[n]);
      }
       while (inductionVariable < last_1);
  }
  function setFont($this, font, fontSize) {
    if (font._get_name__0_k$() === $this._cachedFontName ? fontSize === $this._cachedFontSize : false)
      return Unit_getInstance();
    $this._cachedFontName = font._get_name__0_k$();
    $this._cachedFontSize = fontSize;
    $this._ctx.font = '' + fontSize + "px '" + font._get_name__0_k$() + "'";
  }
  function setState($this, state, fill_4, doSetFont) {
    $this._ctx.globalAlpha = state._globalAlpha;
    $this._ctx.globalCompositeOperation = $this.toJsStr_doxt0q_k$(state._globalCompositeOperation);
    if (doSetFont) {
      setFont($this, state._font_0, state._fontSize_2);
    }if (fill_4) {
      $this._ctx.fillStyle = $this.toJsStr_758899_k$(state._fillStyle);
    } else {
      $this._ctx.lineWidth = state._lineWidth;
      var tmp0_subject = state._lineJoin;
      var tmp;
      if (tmp0_subject.equals(LineJoin_BEVEL_getInstance())) {
        var tmp0__get_BEVEL__0 = null;
        var tmp0_unsafeCast_0_1 = 'bevel';
        tmp = tmp0_unsafeCast_0_1;
      } else if (tmp0_subject.equals(LineJoin_MITER_getInstance())) {
        var tmp1__get_MITER__0 = null;
        var tmp0_unsafeCast_0_1_0 = 'miter';
        tmp = tmp0_unsafeCast_0_1_0;
      } else if (tmp0_subject.equals(LineJoin_ROUND_getInstance())) {
        var tmp2__get_ROUND__0 = null;
        var tmp0_unsafeCast_0_1_1 = 'round';
        tmp = tmp0_unsafeCast_0_1_1;
      } else {
        noWhenBranchMatchedException();
      }
      $this._ctx.lineJoin = tmp;
      var tmp1_subject = state._get_lineCap__0_k$();
      var tmp_0;
      if (tmp1_subject.equals(LineCap_BUTT_getInstance())) {
        var tmp3__get_BUTT__0 = null;
        var tmp0_unsafeCast_0_1_2 = 'butt';
        tmp_0 = tmp0_unsafeCast_0_1_2;
      } else if (tmp1_subject.equals(LineCap_ROUND_getInstance())) {
        var tmp4__get_ROUND__0 = null;
        var tmp0_unsafeCast_0_1_3 = 'round';
        tmp_0 = tmp0_unsafeCast_0_1_3;
      } else if (tmp1_subject.equals(LineCap_SQUARE_getInstance())) {
        var tmp5__get_SQUARE__0 = null;
        var tmp0_unsafeCast_0_1_4 = 'square';
        tmp_0 = tmp0_unsafeCast_0_1_4;
      } else {
        noWhenBranchMatchedException();
      }
      $this._ctx.lineCap = tmp_0;
      $this._ctx.strokeStyle = $this.toJsStr_758899_k$(state._strokeStyle);
    }
  }
  function transformPaint($this, paint) {
    if (isInterface(paint, TransformedPaint)) {
      var m = paint._get_transform__0_k$();
      $this._ctx.transform(m._a, m._b, m._c, m._d, m._tx, m._ty);
    } else {
    }
  }
  function CanvasContext2dRenderer(canvas) {
    Renderer.call(this);
    this._canvas = canvas;
    var tmp = this;
    var tmp0_unsafeCast_0 = this._canvas.getContext('2d');
    tmp._ctx = tmp0_unsafeCast_0;
    var tmp_0 = this;
    DoubleCompanionObject_getInstance();
    tmp_0._cachedFontSize = NaN;
    this._cachedFontName = '';
  }
  CanvasContext2dRenderer.prototype._get_width__0_k$ = function () {
    return this._canvas.width;
  };
  CanvasContext2dRenderer.prototype._get_height__0_k$ = function () {
    return this._canvas.height;
  };
  CanvasContext2dRenderer.prototype.toJsStr_758899_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (tmp0_subject instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl_(_RGBA___get_color__impl_(_this__0._value_19));
      } else {
        if (tmp0_subject instanceof GradientPaint) {
          var tmp1_subject = _this__0._kind_0;
          var tmp_0;
          if (tmp1_subject.equals(GradientKind_LINEAR_getInstance())) {
            var grad = this._ctx.createLinearGradient(_this__0._x0, _this__0._y0, _this__0._x1, _this__0._y1);
            var inductionVariable = 0;
            var last_1 = _this__0._stops._get_size__0_k$();
            if (inductionVariable < last_1)
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var stop = _this__0._stops.getAt_ha5a7z_k$(n);
                var color_0 = _this__0._colors_1.getAt_ha5a7z_k$(n);
                grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl_(_RGBA___init__impl_(color_0)));
              }
               while (inductionVariable < last_1);
            tmp_0 = grad;
          } else if (tmp1_subject.equals(GradientKind_RADIAL_getInstance())) {
            var grad_0 = this._ctx.createRadialGradient(_this__0._x0, _this__0._y0, _this__0._r0_1, _this__0._x1, _this__0._y1, _this__0._r1);
            var inductionVariable_0 = 0;
            var last_2 = _this__0._stops._get_size__0_k$();
            if (inductionVariable_0 < last_2)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var stop_0 = _this__0._stops.getAt_ha5a7z_k$(n_0);
                var color_1 = _this__0._colors_1.getAt_ha5a7z_k$(n_0);
                grad_0.addColorStop(stop_0, _RGBA___get_htmlStringSimple__impl_(_RGBA___init__impl_(color_1)));
              }
               while (inductionVariable_0 < last_2);
            tmp_0 = grad_0;
          } else if (tmp1_subject.equals(GradientKind_SWEEP_getInstance())) {
            tmp_0 = 'fuchsia';
          } else {
            noWhenBranchMatchedException();
          }
          tmp = tmp_0;
        } else {
          if (tmp0_subject instanceof BitmapPaint) {
            var tmp0_unsafeCast_0 = toHtmlNative(_this__0._bitmap_3)._texSource;
            tmp = this._ctx.createPattern(tmp0_unsafeCast_0, (_this__0._get_repeatX__0_k$() ? _this__0._get_repeatY__0_k$() : false) ? 'repeat' : _this__0._get_repeatX__0_k$() ? 'repeat-x' : _this__0._get_repeatY__0_k$() ? 'repeat-y' : 'no-repeat');
          } else {
            {
              tmp = 'black';
            }
          }
        }
      }
    }
    return tmp;
  };
  CanvasContext2dRenderer.prototype.toJsStr_ja016o_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(CompositeMode_CLEAR_getInstance())) {
      tmp = 'clear';
    } else if (tmp0_subject.equals(CompositeMode_COPY_getInstance())) {
      tmp = 'copy';
    } else if (tmp0_subject.equals(CompositeMode_SOURCE_OVER_getInstance())) {
      tmp = 'source-over';
    } else if (tmp0_subject.equals(CompositeMode_DESTINATION_OVER_getInstance())) {
      tmp = 'destination-over';
    } else if (tmp0_subject.equals(CompositeMode_SOURCE_IN_getInstance())) {
      tmp = 'source-in';
    } else if (tmp0_subject.equals(CompositeMode_DESTINATION_IN_getInstance())) {
      tmp = 'destination-in';
    } else if (tmp0_subject.equals(CompositeMode_SOURCE_OUT_getInstance())) {
      tmp = 'source-out';
    } else if (tmp0_subject.equals(CompositeMode_DESTINATION_OUT_getInstance())) {
      tmp = 'destination-out';
    } else if (tmp0_subject.equals(CompositeMode_SOURCE_ATOP_getInstance())) {
      tmp = 'source-atop';
    } else if (tmp0_subject.equals(CompositeMode_DESTINATION_ATOP_getInstance())) {
      tmp = 'destination-atop';
    } else if (tmp0_subject.equals(CompositeMode_XOR_getInstance())) {
      tmp = 'xor';
    } else if (tmp0_subject.equals(CompositeMode_LIGHTER_getInstance())) {
      tmp = 'lighter';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CanvasContext2dRenderer.prototype.toJsStr_k88c7e_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(BlendMode_NORMAL_getInstance())) {
      tmp = 'normal';
    } else if (tmp0_subject.equals(BlendMode_MULTIPLY_getInstance())) {
      tmp = 'multiply';
    } else if (tmp0_subject.equals(BlendMode_SCREEN_getInstance())) {
      tmp = 'screen';
    } else if (tmp0_subject.equals(BlendMode_OVERLAY_getInstance())) {
      tmp = 'overlay';
    } else if (tmp0_subject.equals(BlendMode_DARKEN_getInstance())) {
      tmp = 'darken';
    } else if (tmp0_subject.equals(BlendMode_LIGHTEN_getInstance())) {
      tmp = 'lighten';
    } else if (tmp0_subject.equals(BlendMode_COLOR_DODGE_getInstance())) {
      tmp = 'color-dodge';
    } else if (tmp0_subject.equals(BlendMode_COLOR_BURN_getInstance())) {
      tmp = 'color-burn';
    } else if (tmp0_subject.equals(BlendMode_HARD_LIGHT_getInstance())) {
      tmp = 'hard-light';
    } else if (tmp0_subject.equals(BlendMode_SOFT_LIGHT_getInstance())) {
      tmp = 'soft-light';
    } else if (tmp0_subject.equals(BlendMode_DIFFERENCE_getInstance())) {
      tmp = 'difference';
    } else if (tmp0_subject.equals(BlendMode_EXCLUSION_getInstance())) {
      tmp = 'exclusion';
    } else if (tmp0_subject.equals(BlendMode_HUE_getInstance())) {
      tmp = 'hue';
    } else if (tmp0_subject.equals(BlendMode_SATURATION_getInstance())) {
      tmp = 'saturation';
    } else if (tmp0_subject.equals(BlendMode_COLOR_getInstance())) {
      tmp = 'color';
    } else if (tmp0_subject.equals(BlendMode_LUMINOSITY_getInstance())) {
      tmp = 'luminosity';
    } else {
      var tmp0_lowercase_0 = _this__0._get_name__0_k$();
      tmp = tmp0_lowercase_0.toLowerCase();
    }
    return tmp;
  };
  CanvasContext2dRenderer.prototype.toJsStr_doxt0q_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject instanceof CompositeMode) {
      tmp = this.toJsStr_ja016o_k$(_this__0);
    } else {
      if (tmp0_subject instanceof BlendMode) {
        tmp = this.toJsStr_k88c7e_k$(_this__0);
      } else {
        {
          tmp = 'source-over';
        }
      }
    }
    return tmp;
  };
  CanvasContext2dRenderer.prototype.drawImage_ay2py0_k$ = function (image, x, y, width, height, transform) {
    this._ctx.save();
    try {
      this._ctx.setTransform(transform._a, transform._b, transform._c, transform._d, transform._tx, transform._ty);
      var tmp = ensureNative(image);
      var tmp0_unsafeCast_0 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE())._texSource;
      this._ctx.drawImage(tmp0_unsafeCast_0, x, y, width, height);
    }finally {
      this._ctx.restore();
    }
  };
  CanvasContext2dRenderer.prototype.render_eshf5c_k$ = function (state, fill_4) {
    if (isEmpty(state._path_22))
      return Unit_getInstance();
    var tmp$ret$0;
    l$ret$1: do {
      this._ctx.save();
      try {
        setState(this, state, fill_4, false);
        this._ctx.beginPath();
        var tmp0_visitCmds_0_2 = state._path_22;
        var n_1_3 = 0;
        var tmp0_fastForEach_0_2_4 = tmp0_visitCmds_0_2._commands;
        var n_1_3_5 = 0;
        while (n_1_3_5 < tmp0_fastForEach_0_2_4._get_size__0_k$()) {
          var tmp0_2_5_7 = n_1_3_5;
          n_1_3_5 = tmp0_2_5_7 + 1 | 0;
          var tmp1__anonymous__3_4_6 = tmp0_fastForEach_0_2_4.getAt_ha5a7z_k$(tmp0_2_5_7);
          var tmp0_subject_4_6_8 = tmp1__anonymous__3_4_6;
          Command_getInstance();
          if (tmp0_subject_4_6_8 === 0) {
            var tmp1_5_7_10 = n_1_3;
            n_1_3 = tmp1_5_7_10 + 1 | 0;
            var tmp1__anonymous__21_9 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp1_5_7_10);
            var tmp2_6_8_12 = n_1_3;
            n_1_3 = tmp2_6_8_12 + 1 | 0;
            var tmp2__anonymous__21_11 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp2_6_8_12);
            this._ctx.moveTo(tmp1__anonymous__21_9, tmp2__anonymous__21_11);
          } else {
            Command_getInstance();
            if (tmp0_subject_4_6_8 === 1) {
              var tmp3_7_9_14 = n_1_3;
              n_1_3 = tmp3_7_9_14 + 1 | 0;
              var tmp3__anonymous__22_13 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp3_7_9_14);
              var tmp4_8_10_16 = n_1_3;
              n_1_3 = tmp4_8_10_16 + 1 | 0;
              var tmp4__anonymous__22_15 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp4_8_10_16);
              this._ctx.lineTo(tmp3__anonymous__22_13, tmp4__anonymous__22_15);
            } else {
              Command_getInstance();
              if (tmp0_subject_4_6_8 === 2) {
                var tmp5_9_11_18 = n_1_3;
                n_1_3 = tmp5_9_11_18 + 1 | 0;
                var tmp5__anonymous__23_17 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp5_9_11_18);
                var tmp6_10_12_20 = n_1_3;
                n_1_3 = tmp6_10_12_20 + 1 | 0;
                var tmp6__anonymous__23_19 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp6_10_12_20);
                var tmp7_11_13_22 = n_1_3;
                n_1_3 = tmp7_11_13_22 + 1 | 0;
                var tmp7__anonymous__23_21 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp7_11_13_22);
                var tmp8_12_14_24 = n_1_3;
                n_1_3 = tmp8_12_14_24 + 1 | 0;
                var tmp8__anonymous__23_23 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp8_12_14_24);
                this._ctx.quadraticCurveTo(tmp5__anonymous__23_17, tmp6__anonymous__23_19, tmp7__anonymous__23_21, tmp8__anonymous__23_23);
              } else {
                Command_getInstance();
                if (tmp0_subject_4_6_8 === 3) {
                  var tmp9_13_15_26 = n_1_3;
                  n_1_3 = tmp9_13_15_26 + 1 | 0;
                  var tmp9__anonymous__24_25 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp9_13_15_26);
                  var tmp10_14_16_28 = n_1_3;
                  n_1_3 = tmp10_14_16_28 + 1 | 0;
                  var tmp10__anonymous__24_27 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp10_14_16_28);
                  var tmp11_15_17_30 = n_1_3;
                  n_1_3 = tmp11_15_17_30 + 1 | 0;
                  var tmp11__anonymous__24_29 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp11_15_17_30);
                  var tmp12_16_18_32 = n_1_3;
                  n_1_3 = tmp12_16_18_32 + 1 | 0;
                  var tmp12__anonymous__24_31 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp12_16_18_32);
                  var tmp13_17_19_34 = n_1_3;
                  n_1_3 = tmp13_17_19_34 + 1 | 0;
                  var tmp13__anonymous__24_33 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp13_17_19_34);
                  var tmp14_18_20_36 = n_1_3;
                  n_1_3 = tmp14_18_20_36 + 1 | 0;
                  var tmp14__anonymous__24_35 = tmp0_visitCmds_0_2._data_11.get_ha5a7z_k$(tmp14_18_20_36);
                  this._ctx.bezierCurveTo(tmp9__anonymous__24_25, tmp10__anonymous__24_27, tmp11__anonymous__24_29, tmp12__anonymous__24_31, tmp13__anonymous__24_33, tmp14__anonymous__24_35);
                } else {
                  Command_getInstance();
                  if (tmp0_subject_4_6_8 === 4) {
                    this._ctx.closePath();
                  } else {
                  }
                }
              }
            }
          }
        }
        var m_37 = state._transform_6;
        this._ctx.transform(m_37._a, m_37._b, m_37._c, m_37._d, m_37._tx, m_37._ty);
        var tmp;
        if (fill_4) {
          transformPaint(this, state._fillStyle);
          tmp = this._ctx.fill(this.toCanvasFillRule_j3ozu8_k$(state._path_22._get_winding__0_k$()));
        } else {
          transformPaint(this, state._strokeStyle);
          tmp = this._ctx.stroke();
        }
        tmp$ret$0 = tmp;
        break l$ret$1;
      }finally {
        this._ctx.restore();
      }
    }
     while (false);
  };
  CanvasContext2dRenderer.prototype.toCanvasFillRule_j3ozu8_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(Winding_NON_ZERO_getInstance())) {
      var tmp0__get_NONZERO__0 = null;
      var tmp0_unsafeCast_0_1 = 'nonzero';
      tmp = tmp0_unsafeCast_0_1;
    } else if (tmp0_subject.equals(Winding_EVEN_ODD_getInstance())) {
      var tmp1__get_EVENODD__0 = null;
      var tmp0_unsafeCast_0_1_0 = 'evenodd';
      tmp = tmp0_unsafeCast_0_1_0;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CanvasContext2dRenderer.$metadata$ = {
    simpleName: 'CanvasContext2dRenderer',
    kind: 'class',
    interfaces: []
  };
  function bswap32_0(v) {
    return (v >>> 24 | v << 24 | (v & 65280) << 8 | v >>> 8) & 65280;
  }
  function _no_name_provided__290() {
  }
  _no_name_provided__290.prototype.invoke_0_k$ = function () {
    var tmp0_set_0 = tempI;
    tmp0_set_0[0] = 1;
    var tmp1_get_0 = temp8;
    return tmp1_get_0[0] === 1;
  };
  _no_name_provided__290.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function isLittleEndian$factory() {
    return getPropertyCallableRef('isLittleEndian', 0, KProperty0, function () {
      return _get_isLittleEndian_();
    }, null);
  }
  function formats$factory() {
    return getPropertyCallableRef('formats', 1, KProperty1, function (receiver) {
      return receiver._get_formats__0_k$();
    }, null);
  }
  function lazyCanvasElement$factory() {
    return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
      return receiver._get_lazyCanvasElement__0_k$();
    }, null);
  }
  function ctx$factory() {
    return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
      return receiver._get_ctx__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_234() {
    var i = new _no_name_provided__290();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_235() {
    var i = new _no_name_provided__285();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_236(this$0, $width, $height) {
    var i = new _no_name_provided__286(this$0, $width, $height);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_237(this$0) {
    var i = new _no_name_provided__287(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_238($img_4, $cancellable_2_2) {
    var i = new _no_name_provided__288($img_4, $cancellable_2_2);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_239($jsUrl, $cancellable_2_2) {
    var i = new _no_name_provided__289($jsUrl, $cancellable_2_2);
    return function (p1, p2, p3, p4, p5) {
      i.invoke_3jifwv_k$(p1, p2, p3, p4, p5);
      return Unit_getInstance();
    };
  }
  function nativeImageFormatProvider$init$() {
    return OS_getInstance()._get_isJsNodeJs__0_k$() ? NodeJsNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
  }
  function IKmlGl() {
  }
  IKmlGl.prototype.enableDisable_hwwcoo_k$ = function (cap, enable) {
    if (enable)
      this.enable_majfzk_k$(cap);
    else
      this.disable_majfzk_k$(cap);
  };
  IKmlGl.prototype.drawArraysInstanced_jthg1_k$ = function (mode, first_2, count_0, instancecount) {
    unsupported_1('Not supported instanced drawing');
  };
  IKmlGl.prototype.drawElementsInstanced_s9wiz4_k$ = function (mode, count_0, type, indices, instancecount) {
    unsupported_1('Not supported instanced drawing');
  };
  IKmlGl.prototype.vertexAttribDivisor_rvwcgf_k$ = function (index_0, divisor) {
    unsupported_0();
  };
  IKmlGl.$metadata$ = {
    simpleName: 'IKmlGl',
    kind: 'interface',
    interfaces: []
  };
  function putAsciiString(_this_, str) {
    var n = 0;
    var indexedObject = str;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var c = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0__get_size__0 = _this_._mem;
      if (tmp0__get_size__0.byteLength >= n) {
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        _this_.setByte_lzfo9m_k$(tmp1, c.toByte_0_k$());
      } else {
      }
    }
    var tmp1__get_size__0 = _this_._mem;
    if (tmp1__get_size__0.byteLength >= n) {
      var tmp2 = n;
      n = tmp2 + 1 | 0;
      _this_.setByte_lzfo9m_k$(tmp2, 0);
    } else {
    }
    return _this_;
  }
  function toAsciiString(_this_) {
    var out = '';
    var inductionVariable = 0;
    var tmp0__get_size__0 = _this_._mem;
    var last_1 = tmp0__get_size__0.byteLength;
    if (inductionVariable < last_1)
      $l$break: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = _this_.getByte_ha5a7z_k$(n);
        if (b === 0)
          break $l$break;
        out = out + numberToChar(b);
      }
       while (inductionVariable < last_1);
    return out;
  }
  function _no_name_provided__291() {
  }
  _no_name_provided__291.prototype.invoke_0_k$ = function () {
    return null;
  };
  _no_name_provided__291.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ContextInfo() {
    var tmp = this;
    tmp._current = _no_name_provided_$factory_240();
  }
  ContextInfo.prototype.toString = function () {
    return '' + 'current=' + this._current();
  };
  ContextInfo.$metadata$ = {
    simpleName: 'ContextInfo',
    kind: 'class',
    interfaces: []
  };
  function KmlGl() {
    var tmp = this;
    tmp._$$delegate_0_24 = Mixin_init_$Create$(null, 1, null);
    this._info_3 = new ContextInfo();
    this._DEPTH_BUFFER_BIT = 256;
    this._STENCIL_BUFFER_BIT = 1024;
    this._COLOR_BUFFER_BIT = 16384;
    this._GFALSE = 0;
    this._GTRUE = 1;
    this._POINTS = 0;
    this._LINES = 1;
    this._LINE_LOOP = 2;
    this._LINE_STRIP = 3;
    this._TRIANGLES = 4;
    this._TRIANGLE_STRIP = 5;
    this._TRIANGLE_FAN = 6;
    this._ZERO_1 = 0;
    this._ONE = 1;
    this._SRC_COLOR = 768;
    this._ONE_MINUS_SRC_COLOR = 769;
    this._SRC_ALPHA = 770;
    this._ONE_MINUS_SRC_ALPHA = 771;
    this._DST_ALPHA = 772;
    this._ONE_MINUS_DST_ALPHA = 773;
    this._DST_COLOR = 774;
    this._ONE_MINUS_DST_COLOR = 775;
    this._SRC_ALPHA_SATURATE = 776;
    this._FUNC_ADD = 32774;
    this._BLEND_EQUATION = 32777;
    this._BLEND_EQUATION_RGB = 32777;
    this._BLEND_EQUATION_ALPHA = 34877;
    this._FUNC_SUBTRACT = 32778;
    this._FUNC_REVERSE_SUBTRACT = 32779;
    this._BLEND_DST_RGB = 32968;
    this._BLEND_SRC_RGB = 32969;
    this._BLEND_DST_ALPHA = 32970;
    this._BLEND_SRC_ALPHA = 32971;
    this._CONSTANT_COLOR = 32769;
    this._ONE_MINUS_CONSTANT_COLOR = 32770;
    this._CONSTANT_ALPHA = 32771;
    this._ONE_MINUS_CONSTANT_ALPHA = 32772;
    this._BLEND_COLOR = 32773;
    this._ARRAY_BUFFER = 34962;
    this._ELEMENT_ARRAY_BUFFER = 34963;
    this._ARRAY_BUFFER_BINDING = 34964;
    this._ELEMENT_ARRAY_BUFFER_BINDING = 34965;
    this._STREAM_DRAW = 35040;
    this._STATIC_DRAW = 35044;
    this._DYNAMIC_DRAW = 35048;
    this._BUFFER_SIZE = 34660;
    this._BUFFER_USAGE = 34661;
    this._CURRENT_VERTEX_ATTRIB = 34342;
    this._FRONT = 1028;
    this._BACK = 1029;
    this._FRONT_AND_BACK = 1032;
    this._TEXTURE_2D = 3553;
    this._TEXTURE_3D = 32879;
    this._CULL_FACE = 2884;
    this._BLEND = 3042;
    this._DITHER = 3024;
    this._STENCIL_TEST = 2960;
    this._DEPTH_TEST = 2929;
    this._SCISSOR_TEST = 3089;
    this._POLYGON_OFFSET_FILL = 32823;
    this._SAMPLE_ALPHA_TO_COVERAGE = 32926;
    this._SAMPLE_COVERAGE = 32928;
    this._NO_ERROR = 0;
    this._INVALID_ENUM = 1280;
    this._INVALID_VALUE_0 = 1281;
    this._INVALID_OPERATION = 1282;
    this._OUT_OF_MEMORY = 1285;
    this._CW = 2304;
    this._CCW = 2305;
    this._LINE_WIDTH = 2849;
    this._ALIASED_POINT_SIZE_RANGE = 33901;
    this._ALIASED_LINE_WIDTH_RANGE = 33902;
    this._CULL_FACE_MODE = 2885;
    this._FRONT_FACE = 2886;
    this._DEPTH_RANGE = 2928;
    this._DEPTH_WRITEMASK = 2930;
    this._DEPTH_CLEAR_VALUE = 2931;
    this._DEPTH_FUNC = 2932;
    this._STENCIL_CLEAR_VALUE = 2961;
    this._STENCIL_FUNC = 2962;
    this._STENCIL_FAIL = 2964;
    this._STENCIL_PASS_DEPTH_FAIL = 2965;
    this._STENCIL_PASS_DEPTH_PASS = 2966;
    this._STENCIL_REF = 2967;
    this._STENCIL_VALUE_MASK = 2963;
    this._STENCIL_WRITEMASK = 2968;
    this._STENCIL_BACK_FUNC = 34816;
    this._STENCIL_BACK_FAIL = 34817;
    this._STENCIL_BACK_PASS_DEPTH_FAIL = 34818;
    this._STENCIL_BACK_PASS_DEPTH_PASS = 34819;
    this._STENCIL_BACK_REF = 36003;
    this._STENCIL_BACK_VALUE_MASK = 36004;
    this._STENCIL_BACK_WRITEMASK = 36005;
    this._VIEWPORT = 2978;
    this._SCISSOR_BOX = 3088;
    this._COLOR_CLEAR_VALUE = 3106;
    this._COLOR_WRITEMASK = 3107;
    this._UNPACK_ALIGNMENT = 3317;
    this._PACK_ALIGNMENT = 3333;
    this._MAX_TEXTURE_SIZE = 3379;
    this._MAX_VIEWPORT_DIMS = 3386;
    this._SUBPIXEL_BITS = 3408;
    this._RED_BITS = 3410;
    this._GREEN_BITS = 3411;
    this._BLUE_BITS = 3412;
    this._ALPHA_BITS = 3413;
    this._DEPTH_BITS = 3414;
    this._STENCIL_BITS = 3415;
    this._POLYGON_OFFSET_UNITS = 10752;
    this._POLYGON_OFFSET_FACTOR = 32824;
    this._TEXTURE_BINDING_2D = 32873;
    this._SAMPLE_BUFFERS = 32936;
    this._SAMPLES = 32937;
    this._SAMPLE_COVERAGE_VALUE = 32938;
    this._SAMPLE_COVERAGE_INVERT = 32939;
    this._NUM_COMPRESSED_TEXTURE_FORMATS = 34466;
    this._COMPRESSED_TEXTURE_FORMATS = 34467;
    this._DONT_CARE = 4352;
    this._FASTEST = 4353;
    this._NICEST = 4354;
    this._GENERATE_MIPMAP_HINT = 33170;
    this._BYTE = 5120;
    this._UNSIGNED_BYTE = 5121;
    this._SHORT = 5122;
    this._UNSIGNED_SHORT = 5123;
    this._INT = 5124;
    this._UNSIGNED_INT = 5125;
    this._FLOAT = 5126;
    this._FIXED = 5132;
    this._DEPTH_COMPONENT = 6402;
    this._ALPHA = 6406;
    this._RGB = 6407;
    this._RGBA = 6408;
    this._LUMINANCE = 6409;
    this._LUMINANCE_ALPHA = 6410;
    this._UNSIGNED_SHORT_4_4_4_4 = 32819;
    this._UNSIGNED_SHORT_5_5_5_1 = 32820;
    this._UNSIGNED_SHORT_5_6_5 = 33635;
    this._FRAGMENT_SHADER = 35632;
    this._VERTEX_SHADER = 35633;
    this._MAX_VERTEX_ATTRIBS = 34921;
    this._MAX_VERTEX_UNIFORM_VECTORS = 36347;
    this._MAX_VARYING_VECTORS = 36348;
    this._MAX_COMBINED_TEXTURE_IMAGE_UNITS = 35661;
    this._MAX_VERTEX_TEXTURE_IMAGE_UNITS = 35660;
    this._MAX_TEXTURE_IMAGE_UNITS = 34930;
    this._MAX_FRAGMENT_UNIFORM_VECTORS = 36349;
    this._SHADER_TYPE = 35663;
    this._DELETE_STATUS = 35712;
    this._LINK_STATUS = 35714;
    this._VALIDATE_STATUS = 35715;
    this._ATTACHED_SHADERS = 35717;
    this._ACTIVE_UNIFORMS = 35718;
    this._ACTIVE_UNIFORM_MAX_LENGTH = 35719;
    this._ACTIVE_ATTRIBUTES = 35721;
    this._ACTIVE_ATTRIBUTE_MAX_LENGTH = 35722;
    this._SHADING_LANGUAGE_VERSION = 35724;
    this._CURRENT_PROGRAM = 35725;
    this._NEVER = 512;
    this._LESS = 513;
    this._EQUAL = 514;
    this._LEQUAL = 515;
    this._GREATER = 516;
    this._NOTEQUAL = 517;
    this._GEQUAL = 518;
    this._ALWAYS = 519;
    this._KEEP = 7680;
    this._REPLACE = 7681;
    this._INCR = 7682;
    this._DECR = 7683;
    this._INVERT = 5386;
    this._INCR_WRAP = 34055;
    this._DECR_WRAP = 34056;
    this._VENDOR = 7936;
    this._RENDERER = 7937;
    this._VERSION = 7938;
    this._EXTENSIONS = 7939;
    this._NEAREST = 9728;
    this._LINEAR = 9729;
    this._NEAREST_MIPMAP_NEAREST = 9984;
    this._LINEAR_MIPMAP_NEAREST = 9985;
    this._NEAREST_MIPMAP_LINEAR = 9986;
    this._LINEAR_MIPMAP_LINEAR = 9987;
    this._TEXTURE_MAG_FILTER = 10240;
    this._TEXTURE_MIN_FILTER = 10241;
    this._TEXTURE_WRAP_S = 10242;
    this._TEXTURE_WRAP_T = 10243;
    this._TEXTURE_WRAP_R = 32882;
    this._TEXTURE = 5890;
    this._TEXTURE_CUBE_MAP = 34067;
    this._TEXTURE_BINDING_CUBE_MAP = 34068;
    this._TEXTURE_CUBE_MAP_POSITIVE_X = 34069;
    this._TEXTURE_CUBE_MAP_NEGATIVE_X = 34070;
    this._TEXTURE_CUBE_MAP_POSITIVE_Y = 34071;
    this._TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072;
    this._TEXTURE_CUBE_MAP_POSITIVE_Z = 34073;
    this._TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074;
    this._MAX_CUBE_MAP_TEXTURE_SIZE = 34076;
    this._TEXTURE0 = 33984;
    this._TEXTURE1 = 33985;
    this._TEXTURE2 = 33986;
    this._TEXTURE3 = 33987;
    this._TEXTURE4 = 33988;
    this._TEXTURE5 = 33989;
    this._TEXTURE6 = 33990;
    this._TEXTURE7 = 33991;
    this._TEXTURE8 = 33992;
    this._TEXTURE9 = 33993;
    this._TEXTURE10 = 33994;
    this._TEXTURE11 = 33995;
    this._TEXTURE12 = 33996;
    this._TEXTURE13 = 33997;
    this._TEXTURE14 = 33998;
    this._TEXTURE15 = 33999;
    this._TEXTURE16 = 34000;
    this._TEXTURE17 = 34001;
    this._TEXTURE18 = 34002;
    this._TEXTURE19 = 34003;
    this._TEXTURE20 = 34004;
    this._TEXTURE21 = 34005;
    this._TEXTURE22 = 34006;
    this._TEXTURE23 = 34007;
    this._TEXTURE24 = 34008;
    this._TEXTURE25 = 34009;
    this._TEXTURE26 = 34010;
    this._TEXTURE27 = 34011;
    this._TEXTURE28 = 34012;
    this._TEXTURE29 = 34013;
    this._TEXTURE30 = 34014;
    this._TEXTURE31 = 34015;
    this._ACTIVE_TEXTURE = 34016;
    this._REPEAT = 10497;
    this._CLAMP_TO_EDGE = 33071;
    this._MIRRORED_REPEAT = 33648;
    this._FLOAT_VEC2 = 35664;
    this._FLOAT_VEC3 = 35665;
    this._FLOAT_VEC4 = 35666;
    this._INT_VEC2 = 35667;
    this._INT_VEC3 = 35668;
    this._INT_VEC4 = 35669;
    this._BOOL = 35670;
    this._BOOL_VEC2 = 35671;
    this._BOOL_VEC3 = 35672;
    this._BOOL_VEC4 = 35673;
    this._FLOAT_MAT2 = 35674;
    this._FLOAT_MAT3 = 35675;
    this._FLOAT_MAT4 = 35676;
    this._SAMPLER_2D = 35678;
    this._SAMPLER_CUBE = 35680;
    this._VERTEX_ATTRIB_ARRAY_ENABLED = 34338;
    this._VERTEX_ATTRIB_ARRAY_SIZE = 34339;
    this._VERTEX_ATTRIB_ARRAY_STRIDE = 34340;
    this._VERTEX_ATTRIB_ARRAY_TYPE = 34341;
    this._VERTEX_ATTRIB_ARRAY_NORMALIZED = 34922;
    this._VERTEX_ATTRIB_ARRAY_POINTER = 34373;
    this._VERTEX_ATTRIB_ARRAY_BUFFER_BINDING = 34975;
    this._IMPLEMENTATION_COLOR_READ_TYPE = 35738;
    this._IMPLEMENTATION_COLOR_READ_FORMAT = 35739;
    this._COMPILE_STATUS = 35713;
    this._INFO_LOG_LENGTH = 35716;
    this._SHADER_SOURCE_LENGTH = 35720;
    this._SHADER_COMPILER = 36346;
    this._SHADER_BINARY_FORMATS = 36344;
    this._NUM_SHADER_BINARY_FORMATS = 36345;
    this._LOW_FLOAT = 36336;
    this._MEDIUM_FLOAT = 36337;
    this._HIGH_FLOAT = 36338;
    this._LOW_INT = 36339;
    this._MEDIUM_INT = 36340;
    this._HIGH_INT = 36341;
    this._FRAMEBUFFER = 36160;
    this._RENDERBUFFER = 36161;
    this._RGBA4 = 32854;
    this._RGB5_A1 = 32855;
    this._RGB565 = 36194;
    this._DEPTH_COMPONENT16 = 33189;
    this._STENCIL_INDEX8 = 36168;
    this._RENDERBUFFER_WIDTH = 36162;
    this._RENDERBUFFER_HEIGHT = 36163;
    this._RENDERBUFFER_INTERNAL_FORMAT = 36164;
    this._RENDERBUFFER_RED_SIZE = 36176;
    this._RENDERBUFFER_GREEN_SIZE = 36177;
    this._RENDERBUFFER_BLUE_SIZE = 36178;
    this._RENDERBUFFER_ALPHA_SIZE = 36179;
    this._RENDERBUFFER_DEPTH_SIZE = 36180;
    this._RENDERBUFFER_STENCIL_SIZE = 36181;
    this._FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE = 36048;
    this._FRAMEBUFFER_ATTACHMENT_OBJECT_NAME = 36049;
    this._FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL = 36050;
    this._FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE = 36051;
    this._COLOR_ATTACHMENT0 = 36064;
    this._DEPTH_ATTACHMENT = 36096;
    this._STENCIL_ATTACHMENT = 36128;
    this._NONE = 0;
    this._FRAMEBUFFER_COMPLETE = 36053;
    this._FRAMEBUFFER_INCOMPLETE_ATTACHMENT = 36054;
    this._FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = 36055;
    this._FRAMEBUFFER_INCOMPLETE_DIMENSIONS = 36057;
    this._FRAMEBUFFER_UNSUPPORTED = 36061;
    this._FRAMEBUFFER_BINDING = 36006;
    this._RENDERBUFFER_BINDING = 36007;
    this._MAX_RENDERBUFFER_SIZE = 34024;
    this._INVALID_FRAMEBUFFER_OPERATION = 1286;
  }
  KmlGl.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_24._set_extra__n1onou_k$(_set___);
  };
  KmlGl.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_24._get_extra__0_k$();
  };
  KmlGl.prototype._get_root__0_k$ = function () {
    return this;
  };
  KmlGl.prototype._get_FLOAT__0_k$ = function () {
    return this._FLOAT;
  };
  KmlGl.prototype._get_EXTENSIONS__0_k$ = function () {
    return this._EXTENSIONS;
  };
  KmlGl.prototype._get_INFO_LOG_LENGTH__0_k$ = function () {
    return this._INFO_LOG_LENGTH;
  };
  KmlGl.$metadata$ = {
    simpleName: 'KmlGl',
    kind: 'class',
    interfaces: [Extra, IKmlGl, AGFeatures]
  };
  function Companion_163() {
    Companion_instance_162 = this;
    this._GL_NUM_EXTENSIONS = 33309;
  }
  Companion_163.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_162;
  function Companion_getInstance_162() {
    if (Companion_instance_162 == null)
      new Companion_163();
    return Companion_instance_162;
  }
  function _no_name_provided__292(this$0) {
    this._this$0_68 = this$0;
  }
  _no_name_provided__292.prototype.invoke_0_k$ = function () {
    return this._this$0_68._get_extensions__0_k$().contains_2bq_k$('GL_OES_texture_float') ? true : this._this$0_68._get_extensions__0_k$().contains_2bq_k$('GL_ARB_texture_float');
  };
  _no_name_provided__292.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function KmlGlWithExtensions() {
    Companion_getInstance_162();
    KmlGl.call(this);
    this.__extensions = null;
    var tmp = this;
    tmp._isFloatTextureSupported$delegate = lazy(_no_name_provided_$factory_241(this));
  }
  KmlGlWithExtensions.prototype.getStringi_27zxwg_k$ = function (name, index_0) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  KmlGlWithExtensions.prototype._get_extensions__0_k$ = function () {
    if (this.__extensions == null) {
      var tmp = this;
      var tmp_0;
      try {
        Companion_getInstance_162();
        var numExtensions_2 = getIntegerv(this, 33309);
        if (numExtensions_2 <= 0) {
          throw NotImplementedError_init_$Create$(null, 1, null);
        }var tmp0_mapNotNull_0_3 = until(0, numExtensions_2);
        var tmp0_mapNotNullTo_0_1_4 = ArrayList_init_$Create$();
        var inductionVariable = tmp0_mapNotNull_0_3._get_first__0_k$();
        var last_1 = tmp0_mapNotNull_0_3._get_last__0_k$();
        if (inductionVariable <= last_1)
          do {
            var element_2_3_6 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0_safe_receiver_2_4_4_7 = this.getStringi_27zxwg_k$(this._get_EXTENSIONS__0_k$(), element_2_3_6);
            if (tmp0_safe_receiver_2_4_4_7 == null)
              null;
            else {
              tmp0_mapNotNullTo_0_1_4.add_2bq_k$(tmp0_safe_receiver_2_4_4_7);
              Unit_getInstance();
            }
            Unit_getInstance();
          }
           while (!(element_2_3_6 === last_1));
        tmp_0 = toSet_0(tmp0_mapNotNullTo_0_1_4);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var tmp_2 = this.getString_ha5a7z_k$(this._get_EXTENSIONS__0_k$());
          tmp_1 = toSet_0(split$default_0(tmp_2, [' '], false, 0, 6, null));
        } else {
          {
            throw $p;
          }
        }
        tmp_0 = tmp_1;
      }
      tmp.__extensions = tmp_0;
    }return ensureNotNull(this.__extensions);
  };
  KmlGlWithExtensions.$metadata$ = {
    simpleName: 'KmlGlWithExtensions',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_240() {
    var i = new _no_name_provided__291();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_241(this$0) {
    var i = new _no_name_provided__292(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function getIntegerv(_this_, pname) {
    var tmp0_run_0_1 = Companion_getInstance_97().invoke_ha5a7z_k$(4);
    _this_.getIntegerv_9vfq5l_k$(pname, tmp0_run_0_1);
    return tmp0_run_0_1.getInt_ha5a7z_k$(0);
  }
  function getShaderiv(_this_, shader, type) {
    var tmp0_run_0_1 = Companion_getInstance_97().invoke_ha5a7z_k$(4);
    _this_.getShaderiv_1a3fjs_k$(shader, type, tmp0_run_0_1);
    return tmp0_run_0_1.getInt_ha5a7z_k$(0);
  }
  function getShaderInfoLog(_this_, shader) {
    var size_1_0 = getShaderiv(_this_, shader, _this_._INFO_LOG_LENGTH);
    var tmp0_fbuffer_0 = 4;
    var tmp0_run_0_1 = Companion_getInstance_97().invoke_ha5a7z_k$(tmp0_fbuffer_0);
    var tmp0_run_0_1_3 = Companion_getInstance_97().invoke_ha5a7z_k$(size_1_0);
    _this_.getShaderInfoLog_su8xz3_k$(shader, size_1_0, tmp0_run_0_1, tmp0_run_0_1_3);
    return toAsciiString(tmp0_run_0_1_3);
  }
  function AGFeatures() {
  }
  AGFeatures.$metadata$ = {
    simpleName: 'AGFeatures',
    kind: 'interface',
    interfaces: []
  };
  var BlendEquation_ADD_instance;
  var BlendEquation_SUBTRACT_instance;
  var BlendEquation_REVERSE_SUBTRACT_instance;
  var BlendEquation_entriesInitialized;
  function BlendEquation_initEntries() {
    if (BlendEquation_entriesInitialized)
      return Unit_getInstance();
    BlendEquation_entriesInitialized = true;
    BlendEquation_ADD_instance = new BlendEquation('ADD', 0);
    BlendEquation_SUBTRACT_instance = new BlendEquation('SUBTRACT', 1);
    BlendEquation_REVERSE_SUBTRACT_instance = new BlendEquation('REVERSE_SUBTRACT', 2);
  }
  var BlendFactor_DESTINATION_ALPHA_instance;
  var BlendFactor_DESTINATION_COLOR_instance;
  var BlendFactor_ONE_instance;
  var BlendFactor_ONE_MINUS_DESTINATION_ALPHA_instance;
  var BlendFactor_ONE_MINUS_DESTINATION_COLOR_instance;
  var BlendFactor_ONE_MINUS_SOURCE_ALPHA_instance;
  var BlendFactor_ONE_MINUS_SOURCE_COLOR_instance;
  var BlendFactor_SOURCE_ALPHA_instance;
  var BlendFactor_SOURCE_COLOR_instance;
  var BlendFactor_ZERO_instance;
  var BlendFactor_entriesInitialized;
  function BlendFactor_initEntries() {
    if (BlendFactor_entriesInitialized)
      return Unit_getInstance();
    BlendFactor_entriesInitialized = true;
    BlendFactor_DESTINATION_ALPHA_instance = new BlendFactor('DESTINATION_ALPHA', 0);
    BlendFactor_DESTINATION_COLOR_instance = new BlendFactor('DESTINATION_COLOR', 1);
    BlendFactor_ONE_instance = new BlendFactor('ONE', 2);
    BlendFactor_ONE_MINUS_DESTINATION_ALPHA_instance = new BlendFactor('ONE_MINUS_DESTINATION_ALPHA', 3);
    BlendFactor_ONE_MINUS_DESTINATION_COLOR_instance = new BlendFactor('ONE_MINUS_DESTINATION_COLOR', 4);
    BlendFactor_ONE_MINUS_SOURCE_ALPHA_instance = new BlendFactor('ONE_MINUS_SOURCE_ALPHA', 5);
    BlendFactor_ONE_MINUS_SOURCE_COLOR_instance = new BlendFactor('ONE_MINUS_SOURCE_COLOR', 6);
    BlendFactor_SOURCE_ALPHA_instance = new BlendFactor('SOURCE_ALPHA', 7);
    BlendFactor_SOURCE_COLOR_instance = new BlendFactor('SOURCE_COLOR', 8);
    BlendFactor_ZERO_instance = new BlendFactor('ZERO', 9);
  }
  function Scissor_init_$Init$(x, y, width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0.0;
    if (!(($mask0 & 2) === 0))
      y = 0.0;
    if (!(($mask0 & 4) === 0))
      width = 0.0;
    if (!(($mask0 & 8) === 0))
      height = 0.0;
    Scissor.call($this, x, y, width, height);
    return $this;
  }
  function Scissor_init_$Create$(x, y, width, height, $mask0, $marker) {
    return Scissor_init_$Init$(x, y, width, height, $mask0, $marker, Object.create(Scissor.prototype));
  }
  function Blending_init_$Init$(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      srcA = srcRGB;
    if (!(($mask0 & 8) === 0))
      dstA = dstRGB;
    if (!(($mask0 & 16) === 0))
      eqRGB = BlendEquation_ADD_getInstance();
    if (!(($mask0 & 32) === 0))
      eqA = eqRGB;
    Blending.call($this, srcRGB, dstRGB, srcA, dstA, eqRGB, eqA);
    return $this;
  }
  function Blending_init_$Create$(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $mask0, $marker) {
    return Blending_init_$Init$(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $mask0, $marker, Object.create(Blending.prototype));
  }
  function Blending_init_$Init$_0(src, dst, eq, $this) {
    Blending.call($this, src, dst, src, dst, eq, eq);
    return $this;
  }
  function Blending_init_$Init$_1(src, dst, eq, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      eq = BlendEquation_ADD_getInstance();
    Blending_init_$Init$_0(src, dst, eq, $this);
    return $this;
  }
  function Blending_init_$Create$_0(src, dst, eq, $mask0, $marker) {
    return Blending_init_$Init$_1(src, dst, eq, $mask0, $marker, Object.create(Blending.prototype));
  }
  function Companion_164() {
    Companion_instance_163 = this;
    var tmp = this;
    var tmp_0 = BlendFactor_ONE_getInstance();
    var tmp_1 = BlendFactor_ZERO_getInstance();
    var tmp_2 = BlendFactor_ONE_getInstance();
    var tmp_3 = BlendFactor_ZERO_getInstance();
    tmp._NONE_0 = Blending_init_$Create$(tmp_0, tmp_1, tmp_2, tmp_3, null, null, 48, null);
    var tmp_4 = this;
    var tmp_5 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_6 = BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance();
    var tmp_7 = BlendFactor_ONE_getInstance();
    var tmp_8 = BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance();
    tmp_4._NORMAL = Blending_init_$Create$(tmp_5, tmp_6, tmp_7, tmp_8, null, null, 48, null);
    var tmp_9 = this;
    var tmp_10 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_11 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_12 = BlendFactor_ONE_getInstance();
    var tmp_13 = BlendFactor_ONE_getInstance();
    tmp_9._ADD = Blending_init_$Create$(tmp_10, tmp_11, tmp_12, tmp_13, null, null, 48, null);
  }
  Companion_164.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_163;
  function Companion_getInstance_163() {
    if (Companion_instance_163 == null)
      new Companion_164();
    return Companion_instance_163;
  }
  function _no_name_provided__293() {
  }
  _no_name_provided__293.prototype.invoke_0_k$ = function () {
    return null;
  };
  _no_name_provided__293.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_165() {
    Companion_instance_164 = this;
    var tmp = this;
    tmp._NIL_2 = new SyncBitmapSource(true, 0, 0, _no_name_provided_$factory_247());
  }
  Companion_165.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_164;
  function Companion_getInstance_164() {
    if (Companion_instance_164 == null)
      new Companion_165();
    return Companion_instance_164;
  }
  function _no_name_provided__294($bmp) {
    this._$bmp = $bmp;
  }
  _no_name_provided__294.prototype.invoke_0_k$ = function () {
    return this._$bmp;
  };
  _no_name_provided__294.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__295(this$0, $source, resultContinuation) {
    this._this$0_69 = this$0;
    this._$source = $source;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__295.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__295.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__295.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$source._gen_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this._this$0_69._tempBitmap = ARGUMENT;
            this._this$0_69._generated = true;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__295.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__295(this._this$0_69, this._$source, completion);
    return i;
  };
  _no_name_provided__295.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function TextureUnit_init_$Init$(texture, linear, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      texture = null;
    if (!(($mask0 & 2) === 0))
      linear = true;
    TextureUnit.call($this, texture, linear);
    return $this;
  }
  function TextureUnit_init_$Create$(texture, linear, $mask0, $marker) {
    return TextureUnit_init_$Init$(texture, linear, $mask0, $marker, Object.create(TextureUnit.prototype));
  }
  var Kind_INDEX_instance;
  var Kind_VERTEX_instance;
  var Kind_entriesInitialized_1;
  function Kind_initEntries_1() {
    if (Kind_entriesInitialized_1)
      return Unit_getInstance();
    Kind_entriesInitialized_1 = true;
    Kind_INDEX_instance = new Kind_1('INDEX', 0);
    Kind_VERTEX_instance = new Kind_1('VERTEX', 1);
  }
  function Kind_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Kind_1.$metadata$ = {
    simpleName: 'Kind',
    kind: 'class',
    interfaces: []
  };
  function Kind_INDEX_getInstance() {
    Kind_initEntries_1();
    return Kind_INDEX_instance;
  }
  function Kind_VERTEX_getInstance() {
    Kind_initEntries_1();
    return Kind_VERTEX_instance;
  }
  var DrawType_POINTS_instance;
  var DrawType_LINE_STRIP_instance;
  var DrawType_LINE_LOOP_instance;
  var DrawType_LINES_instance;
  var DrawType_TRIANGLES_instance;
  var DrawType_TRIANGLE_STRIP_instance;
  var DrawType_TRIANGLE_FAN_instance;
  var DrawType_entriesInitialized;
  function DrawType_initEntries() {
    if (DrawType_entriesInitialized)
      return Unit_getInstance();
    DrawType_entriesInitialized = true;
    DrawType_POINTS_instance = new DrawType('POINTS', 0);
    DrawType_LINE_STRIP_instance = new DrawType('LINE_STRIP', 1);
    DrawType_LINE_LOOP_instance = new DrawType('LINE_LOOP', 2);
    DrawType_LINES_instance = new DrawType('LINES', 3);
    DrawType_TRIANGLES_instance = new DrawType('TRIANGLES', 4);
    DrawType_TRIANGLE_STRIP_instance = new DrawType('TRIANGLE_STRIP', 5);
    DrawType_TRIANGLE_FAN_instance = new DrawType('TRIANGLE_FAN', 6);
  }
  var IndexType_UBYTE_instance;
  var IndexType_USHORT_instance;
  var IndexType_UINT_instance;
  var IndexType_entriesInitialized;
  function IndexType_initEntries() {
    if (IndexType_entriesInitialized)
      return Unit_getInstance();
    IndexType_entriesInitialized = true;
    IndexType_UBYTE_instance = new IndexType('UBYTE', 0);
    IndexType_USHORT_instance = new IndexType('USHORT', 1);
    IndexType_UINT_instance = new IndexType('UINT', 2);
  }
  var StencilOp_DECREMENT_SATURATE_instance;
  var StencilOp_DECREMENT_WRAP_instance;
  var StencilOp_INCREMENT_SATURATE_instance;
  var StencilOp_INCREMENT_WRAP_instance;
  var StencilOp_INVERT_instance;
  var StencilOp_KEEP_instance;
  var StencilOp_SET_instance;
  var StencilOp_ZERO_instance;
  var StencilOp_entriesInitialized;
  function StencilOp_initEntries() {
    if (StencilOp_entriesInitialized)
      return Unit_getInstance();
    StencilOp_entriesInitialized = true;
    StencilOp_DECREMENT_SATURATE_instance = new StencilOp('DECREMENT_SATURATE', 0);
    StencilOp_DECREMENT_WRAP_instance = new StencilOp('DECREMENT_WRAP', 1);
    StencilOp_INCREMENT_SATURATE_instance = new StencilOp('INCREMENT_SATURATE', 2);
    StencilOp_INCREMENT_WRAP_instance = new StencilOp('INCREMENT_WRAP', 3);
    StencilOp_INVERT_instance = new StencilOp('INVERT', 4);
    StencilOp_KEEP_instance = new StencilOp('KEEP', 5);
    StencilOp_SET_instance = new StencilOp('SET', 6);
    StencilOp_ZERO_instance = new StencilOp('ZERO', 7);
  }
  var TriangleFace_FRONT_instance;
  var TriangleFace_BACK_instance;
  var TriangleFace_FRONT_AND_BACK_instance;
  var TriangleFace_NONE_instance;
  var TriangleFace_entriesInitialized;
  function TriangleFace_initEntries() {
    if (TriangleFace_entriesInitialized)
      return Unit_getInstance();
    TriangleFace_entriesInitialized = true;
    TriangleFace_FRONT_instance = new TriangleFace('FRONT', 0);
    TriangleFace_BACK_instance = new TriangleFace('BACK', 1);
    TriangleFace_FRONT_AND_BACK_instance = new TriangleFace('FRONT_AND_BACK', 2);
    TriangleFace_NONE_instance = new TriangleFace('NONE', 3);
  }
  var CompareMode_ALWAYS_instance;
  var CompareMode_EQUAL_instance;
  var CompareMode_GREATER_instance;
  var CompareMode_GREATER_EQUAL_instance;
  var CompareMode_LESS_instance;
  var CompareMode_LESS_EQUAL_instance;
  var CompareMode_NEVER_instance;
  var CompareMode_NOT_EQUAL_instance;
  var CompareMode_entriesInitialized;
  function CompareMode_initEntries() {
    if (CompareMode_entriesInitialized)
      return Unit_getInstance();
    CompareMode_entriesInitialized = true;
    CompareMode_ALWAYS_instance = new CompareMode('ALWAYS', 0);
    CompareMode_EQUAL_instance = new CompareMode('EQUAL', 1);
    CompareMode_GREATER_instance = new CompareMode('GREATER', 2);
    CompareMode_GREATER_EQUAL_instance = new CompareMode('GREATER_EQUAL', 3);
    CompareMode_LESS_instance = new CompareMode('LESS', 4);
    CompareMode_LESS_EQUAL_instance = new CompareMode('LESS_EQUAL', 5);
    CompareMode_NEVER_instance = new CompareMode('NEVER', 6);
    CompareMode_NOT_EQUAL_instance = new CompareMode('NOT_EQUAL', 7);
  }
  function ColorMaskState_init_$Init$(red, green, blue, alpha_0, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      red = true;
    if (!(($mask0 & 2) === 0))
      green = true;
    if (!(($mask0 & 4) === 0))
      blue = true;
    if (!(($mask0 & 8) === 0))
      alpha_0 = true;
    ColorMaskState.call($this, red, green, blue, alpha_0);
    return $this;
  }
  function ColorMaskState_init_$Create$(red, green, blue, alpha_0, $mask0, $marker) {
    return ColorMaskState_init_$Init$(red, green, blue, alpha_0, $mask0, $marker, Object.create(ColorMaskState.prototype));
  }
  var FrontFace_BOTH_instance;
  var FrontFace_CW_instance;
  var FrontFace_CCW_instance;
  var FrontFace_entriesInitialized;
  function FrontFace_initEntries() {
    if (FrontFace_entriesInitialized)
      return Unit_getInstance();
    FrontFace_entriesInitialized = true;
    FrontFace_BOTH_instance = new FrontFace('BOTH', 0);
    FrontFace_CW_instance = new FrontFace('CW', 1);
    FrontFace_CCW_instance = new FrontFace('CCW', 2);
  }
  function RenderState_init_$Init$(depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      depthFunc = CompareMode_ALWAYS_getInstance();
    if (!(($mask0 & 2) === 0))
      depthMask = true;
    if (!(($mask0 & 4) === 0))
      depthNear = 0.0;
    if (!(($mask0 & 8) === 0))
      depthFar = 1.0;
    if (!(($mask0 & 16) === 0))
      lineWidth = 1.0;
    if (!(($mask0 & 32) === 0))
      frontFace = FrontFace_BOTH_getInstance();
    RenderState.call($this, depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace);
    return $this;
  }
  function RenderState_init_$Create$(depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace, $mask0, $marker) {
    return RenderState_init_$Init$(depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace, $mask0, $marker, Object.create(RenderState.prototype));
  }
  function StencilState_init_$Init$(enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      enabled = false;
    if (!(($mask0 & 2) === 0))
      triangleFace = TriangleFace_FRONT_AND_BACK_getInstance();
    if (!(($mask0 & 4) === 0))
      compareMode = CompareMode_ALWAYS_getInstance();
    if (!(($mask0 & 8) === 0))
      actionOnBothPass = StencilOp_KEEP_getInstance();
    if (!(($mask0 & 16) === 0))
      actionOnDepthFail = StencilOp_KEEP_getInstance();
    if (!(($mask0 & 32) === 0))
      actionOnDepthPassStencilFail = StencilOp_KEEP_getInstance();
    if (!(($mask0 & 64) === 0))
      referenceValue = 0;
    if (!(($mask0 & 128) === 0))
      readMask = 255;
    if (!(($mask0 & 256) === 0))
      writeMask = 255;
    StencilState.call($this, enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask);
    return $this;
  }
  function StencilState_init_$Create$(enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask, $mask0, $marker) {
    return StencilState_init_$Init$(enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask, $mask0, $marker, Object.create(StencilState.prototype));
  }
  function VertexData_init_$Init$(buffer, layout, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      buffer = new Buffer(Kind_VERTEX_getInstance());
    if (!(($mask0 & 2) === 0))
      layout = VertexLayout_init_$Create$([]);
    VertexData.call($this, buffer, layout);
    return $this;
  }
  function VertexData_init_$Create$(buffer, layout, $mask0, $marker) {
    return VertexData_init_$Init$(buffer, layout, $mask0, $marker, Object.create(VertexData.prototype));
  }
  function Batch_init_$Init$(vertexData, program, type, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      vertexData = fastArrayListOf([VertexData_init_$Create$(null, null, 3, null)]);
    }if (!(($mask0 & 2) === 0))
      program = DefaultShaders_getInstance()._PROGRAM_DEBUG;
    if (!(($mask0 & 4) === 0))
      type = DrawType_TRIANGLES_getInstance();
    if (!(($mask0 & 8) === 0))
      vertexCount = 0;
    if (!(($mask0 & 16) === 0))
      indices = null;
    if (!(($mask0 & 32) === 0))
      indexType = IndexType_USHORT_getInstance();
    if (!(($mask0 & 64) === 0))
      offset_0 = 0;
    if (!(($mask0 & 128) === 0))
      blending = Companion_getInstance_163()._NORMAL;
    if (!(($mask0 & 256) === 0))
      uniforms = Companion_getInstance_165()._EMPTY_5;
    if (!(($mask0 & 512) === 0)) {
      stencil = StencilState_init_$Create$(false, null, null, null, null, null, 0, 0, 0, 511, null);
    }if (!(($mask0 & 1024) === 0)) {
      colorMask = ColorMaskState_init_$Create$(false, false, false, false, 15, null);
    }if (!(($mask0 & 2048) === 0)) {
      renderState = RenderState_init_$Create$(null, false, 0.0, 0.0, 0.0, null, 63, null);
    }if (!(($mask0 & 4096) === 0))
      scissor = null;
    if (!(($mask0 & 8192) === 0))
      instances = 1;
    Batch.call($this, vertexData, program, type, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances);
    return $this;
  }
  function Batch_init_$Create$(vertexData, program, type, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances, $mask0, $marker) {
    return Batch_init_$Init$(vertexData, program, type, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances, $mask0, $marker, Object.create(Batch.prototype));
  }
  function ensureSingleVertexData($this) {
    if ($this._singleVertexData.isEmpty_0_k$()) {
      $this._singleVertexData.add_2bq_k$(VertexData_init_$Create$(null, null, 3, null));
      Unit_getInstance();
    }$this._vertexData = $this._singleVertexData;
  }
  function _no_name_provided__296() {
  }
  _no_name_provided__296.prototype.invoke_dzcoxa_k$ = function ($this$VertexShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$VertexShader.setTo_ag43kx_k$(tmp0_apply_0._v_Tex, tmp0_apply_0._a_Tex);
    $this$VertexShader.setTo_ag43kx_k$($this$VertexShader._out_8, $this$VertexShader.vec4_ldyooh_k$([tmp0_apply_0._a_Pos, $this$VertexShader._get_lit__a9njmo_k$(0.0), $this$VertexShader._get_lit__a9njmo_k$(1.0)]));
    Unit_getInstance();
  };
  _no_name_provided__296.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__296.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__297() {
  }
  _no_name_provided__297.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$FragmentShader.setTo_ag43kx_k$($this$FragmentShader._out_8, $this$FragmentShader.texture2D_s4jwrm_k$(tmp0_apply_0._u_Tex, $this$FragmentShader.get_v2sg9q_k$(tmp0_apply_0._v_Tex, 'xy')));
    Unit_getInstance();
  };
  _no_name_provided__297.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__297.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_166() {
    Companion_instance_165 = this;
    this._EMPTY_5 = new UniformValues();
  }
  Companion_166.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_165;
  function Companion_getInstance_165() {
    if (Companion_instance_165 == null)
      new Companion_166();
    return Companion_instance_165;
  }
  function UniformValues_init_$Init$(pairs, $this) {
    UniformValues.call($this);
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var pair = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      $this.put_r39nsu_k$(pair._first, pair._second);
      Unit_getInstance();
    }
    return $this;
  }
  function UniformValues_init_$Create$(pairs) {
    return UniformValues_init_$Init$(pairs, Object.create(UniformValues.prototype));
  }
  function BlendEquation(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  BlendEquation.$metadata$ = {
    simpleName: 'BlendEquation',
    kind: 'class',
    interfaces: []
  };
  function BlendFactor(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  BlendFactor.$metadata$ = {
    simpleName: 'BlendFactor',
    kind: 'class',
    interfaces: []
  };
  function Scissor(x, y, width, height) {
    this._x_18 = x;
    this._y_17 = y;
    this._width_12 = width;
    this._height_13 = height;
    this._rect_2 = Companion_getInstance_35().invoke_0_k$();
  }
  Scissor.prototype._get_rect__0_k$ = function () {
    this._rect_2.setTo_i6u10_k$(this._x_18, this._y_17, this._width_12, this._height_13);
    Unit_getInstance();
    return this._rect_2;
  };
  Scissor.prototype._get_top__0_k$ = function () {
    return this._y_17;
  };
  Scissor.prototype._get_left__0_k$ = function () {
    return this._x_18;
  };
  Scissor.prototype._get_right__0_k$ = function () {
    return this._x_18 + this._width_12;
  };
  Scissor.prototype._get_bottom__0_k$ = function () {
    return this._y_17 + this._height_13;
  };
  Scissor.prototype.setTo_i6u10_k$ = function (x, y, width, height) {
    this._x_18 = x;
    this._y_17 = y;
    this._width_12 = width;
    this._height_13 = height;
    return this;
  };
  Scissor.prototype.setTo_w0xdj4_k$ = function (x, y, width, height) {
    return this.setTo_i6u10_k$(x, y, width, height);
  };
  Scissor.prototype.setTo_uebyw0_k$ = function (rect_3) {
    return this.setTo_i6u10_k$(rect_3._x_2, rect_3._y_2, rect_3._width_0, rect_3._height_0);
  };
  Scissor.prototype.toString = function () {
    return '' + 'Scissor(x=' + _get_niceStr__3(this._x_18) + ', y=' + _get_niceStr__3(this._y_17) + ', width=' + _get_niceStr__3(this._width_12) + ', height=' + _get_niceStr__3(this._height_13) + ')';
  };
  Scissor.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_18);
    result = imul(result, 31) + getNumberHashCode(this._y_17) | 0;
    result = imul(result, 31) + getNumberHashCode(this._width_12) | 0;
    result = imul(result, 31) + getNumberHashCode(this._height_13) | 0;
    return result;
  };
  Scissor.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Scissor))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Scissor ? other : THROW_CCE();
    if (!equals_1(this._x_18, tmp0_other_with_cast._x_18))
      return false;
    if (!equals_1(this._y_17, tmp0_other_with_cast._y_17))
      return false;
    if (!equals_1(this._width_12, tmp0_other_with_cast._width_12))
      return false;
    if (!equals_1(this._height_13, tmp0_other_with_cast._height_13))
      return false;
    return true;
  };
  Scissor.$metadata$ = {
    simpleName: 'Scissor',
    kind: 'class',
    interfaces: []
  };
  function Blending(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    Companion_getInstance_163();
    this._srcRGB = srcRGB;
    this._dstRGB = dstRGB;
    this._srcA = srcA;
    this._dstA = dstA;
    this._eqRGB = eqRGB;
    this._eqA = eqA;
    var tmp = this;
    var tmp0_hashCode_0 = this._srcRGB;
    var tmp1_hashCode_0 = this._dstRGB;
    var tmp2_hashCode_0 = this._srcA;
    var tmp3_hashCode_0 = this._dstA;
    var tmp4_hashCode_0 = this._eqRGB;
    var tmp5_hashCode_0 = this._eqA;
    var hash_1 = 7;
    var tmp_0 = imul(31, hash_1);
    var tmp0_safe_receiver_2_3 = tmp0_hashCode_0;
    var tmp1_elvis_lhs_1_2 = tmp0_safe_receiver_2_3 == null ? null : hashCode(tmp0_safe_receiver_2_3);
    hash_1 = tmp_0 + (tmp1_elvis_lhs_1_2 == null ? 0 : tmp1_elvis_lhs_1_2) | 0;
    var tmp_1 = imul(31, hash_1);
    var tmp0_safe_receiver_2_5 = tmp1_hashCode_0;
    var tmp1_elvis_lhs_1_4 = tmp0_safe_receiver_2_5 == null ? null : hashCode(tmp0_safe_receiver_2_5);
    hash_1 = tmp_1 + (tmp1_elvis_lhs_1_4 == null ? 0 : tmp1_elvis_lhs_1_4) | 0;
    var tmp_2 = imul(31, hash_1);
    var tmp0_safe_receiver_2_7 = tmp2_hashCode_0;
    var tmp1_elvis_lhs_1_6 = tmp0_safe_receiver_2_7 == null ? null : hashCode(tmp0_safe_receiver_2_7);
    hash_1 = tmp_2 + (tmp1_elvis_lhs_1_6 == null ? 0 : tmp1_elvis_lhs_1_6) | 0;
    var tmp_3 = imul(31, hash_1);
    var tmp0_safe_receiver_2_9 = tmp3_hashCode_0;
    var tmp1_elvis_lhs_1_8 = tmp0_safe_receiver_2_9 == null ? null : hashCode(tmp0_safe_receiver_2_9);
    hash_1 = tmp_3 + (tmp1_elvis_lhs_1_8 == null ? 0 : tmp1_elvis_lhs_1_8) | 0;
    var tmp_4 = imul(31, hash_1);
    var tmp0_safe_receiver_2_11 = tmp4_hashCode_0;
    var tmp1_elvis_lhs_1_10 = tmp0_safe_receiver_2_11 == null ? null : hashCode(tmp0_safe_receiver_2_11);
    hash_1 = tmp_4 + (tmp1_elvis_lhs_1_10 == null ? 0 : tmp1_elvis_lhs_1_10) | 0;
    var tmp_5 = imul(31, hash_1);
    var tmp0_safe_receiver_2_13 = tmp5_hashCode_0;
    var tmp1_elvis_lhs_1_12 = tmp0_safe_receiver_2_13 == null ? null : hashCode(tmp0_safe_receiver_2_13);
    hash_1 = tmp_5 + (tmp1_elvis_lhs_1_12 == null ? 0 : tmp1_elvis_lhs_1_12) | 0;
    tmp._cachedHashCode = hash_1;
  }
  Blending.prototype._get_disabled__0_k$ = function () {
    return ((this._srcRGB.equals(BlendFactor_ONE_getInstance()) ? this._dstRGB.equals(BlendFactor_ZERO_getInstance()) : false) ? this._srcA.equals(BlendFactor_ONE_getInstance()) : false) ? this._dstA.equals(BlendFactor_ZERO_getInstance()) : false;
  };
  Blending.prototype._get_enabled__0_k$ = function () {
    return !this._get_disabled__0_k$();
  };
  Blending.prototype.hashCode = function () {
    return this._cachedHashCode;
  };
  Blending.prototype.toString = function () {
    return '' + 'Blending(srcRGB=' + this._srcRGB + ', dstRGB=' + this._dstRGB + ', srcA=' + this._srcA + ', dstA=' + this._dstA + ', eqRGB=' + this._eqRGB + ', eqA=' + this._eqA + ')';
  };
  Blending.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Blending))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Blending ? other : THROW_CCE();
    if (!this._srcRGB.equals(tmp0_other_with_cast._srcRGB))
      return false;
    if (!this._dstRGB.equals(tmp0_other_with_cast._dstRGB))
      return false;
    if (!this._srcA.equals(tmp0_other_with_cast._srcA))
      return false;
    if (!this._dstA.equals(tmp0_other_with_cast._dstA))
      return false;
    if (!this._eqRGB.equals(tmp0_other_with_cast._eqRGB))
      return false;
    if (!this._eqA.equals(tmp0_other_with_cast._eqA))
      return false;
    return true;
  };
  Blending.$metadata$ = {
    simpleName: 'Blending',
    kind: 'class',
    interfaces: []
  };
  function BitmapSourceBase() {
  }
  BitmapSourceBase.$metadata$ = {
    simpleName: 'BitmapSourceBase',
    kind: 'interface',
    interfaces: []
  };
  function SyncBitmapSource(rgba, width, height, gen) {
    Companion_getInstance_164();
    this._rgba = rgba;
    this._width_13 = width;
    this._height_14 = height;
    this._gen_1 = gen;
  }
  SyncBitmapSource.prototype._get_rgba__0_k$ = function () {
    return this._rgba;
  };
  SyncBitmapSource.prototype._get_width__0_k$ = function () {
    return this._width_13;
  };
  SyncBitmapSource.prototype._get_height__0_k$ = function () {
    return this._height_14;
  };
  SyncBitmapSource.prototype.toString = function () {
    return '' + 'SyncBitmapSource(rgba=' + this._rgba + ', width=' + this._width_13 + ', height=' + this._height_14 + ')';
  };
  SyncBitmapSource.$metadata$ = {
    simpleName: 'SyncBitmapSource',
    kind: 'class',
    interfaces: [BitmapSourceBase]
  };
  function AsyncBitmapSource() {
  }
  AsyncBitmapSource.$metadata$ = {
    simpleName: 'AsyncBitmapSource',
    kind: 'class',
    interfaces: [BitmapSourceBase]
  };
  function Texture($outer) {
    this._$this_17 = $outer;
    this._isFbo = false;
    this._premultiplied_9 = true;
    this._requestMipmaps = false;
    this._mipmaps_4 = false;
    this._source = Companion_getInstance_164()._NIL_2;
    this._uploaded = false;
    this._generating = false;
    this._generated = false;
    this._tempBitmap = null;
    this._ready = false;
    var tmp = this;
    var tmp0_this = this._$this_17;
    var tmp1 = tmp0_this._lastTextureId;
    tmp0_this._lastTextureId = tmp1 + 1 | 0;
    tmp._texId = tmp1;
    var tmp0_this_0 = this._$this_17;
    var tmp1_0 = tmp0_this_0._createdTextureCount;
    tmp0_this_0._createdTextureCount = tmp1_0 + 1 | 0;
    Unit_getInstance();
    this._alreadyClosed = false;
  }
  Texture.prototype._get_premultiplied__0_k$ = function () {
    return this._premultiplied_9;
  };
  Texture.prototype._set_mipmaps__rpwsgn_k$ = function (_set___) {
    this._mipmaps_4 = _set___;
  };
  Texture.prototype._get_mipmaps__0_k$ = function () {
    return this._mipmaps_4;
  };
  Texture.prototype._get_source__0_k$ = function () {
    return this._source;
  };
  Texture.prototype.invalidate_sv8swh_k$ = function () {
    this._uploaded = false;
    this._generating = false;
    this._generated = false;
  };
  Texture.prototype.upload_bltrcm_k$ = function (bmp, mipmaps_0) {
    var tmp;
    if (!(bmp == null)) {
      var tmp_0 = bmp._bpp > 8;
      tmp = new SyncBitmapSource(tmp_0, bmp._width_2, bmp._height_3, _no_name_provided_$factory_248(bmp));
    } else {
      tmp = Companion_getInstance_164()._NIL_2;
    }
    return this.upload_f5ry1a_k$(tmp, mipmaps_0);
  };
  Texture.prototype.upload_f5ry1a_k$ = function (source, mipmaps_0) {
    this._source = source;
    this.uploadedSource_sv8swh_k$();
    this.invalidate_sv8swh_k$();
    this._requestMipmaps = mipmaps_0;
    return this;
  };
  Texture.prototype.uploadedSource_sv8swh_k$ = function () {
  };
  Texture.prototype.bind_sv8swh_k$ = function () {
  };
  Texture.prototype.manualUpload_0_k$ = function () {
    this._uploaded = true;
    return this;
  };
  Texture.prototype.bindEnsuring_sv8swh_k$ = function () {
    this.bind_sv8swh_k$();
    if (this._isFbo)
      return Unit_getInstance();
    var source = this._source;
    if (this._uploaded)
      return Unit_getInstance();
    if (!this._generating) {
      this._generating = true;
      var tmp0_subject = source;
      if (tmp0_subject instanceof SyncBitmapSource) {
        this._tempBitmap = source._gen_1();
        this._generated = true;
      } else {
        if (tmp0_subject instanceof AsyncBitmapSource) {
          launchImmediately(source._coroutineContext_1, _no_name_provided_$factory_249(this, source, null));
          Unit_getInstance();
        } else {
        }
      }
    }if (this._generated) {
      this._uploaded = true;
      this._generating = false;
      this._generated = false;
      this.actualSyncUpload_237s55_k$(source, this._tempBitmap, this._requestMipmaps);
      this._tempBitmap = null;
      this._ready = true;
    }};
  Texture.prototype.actualSyncUpload_237s55_k$ = function (source, bmp, requestMipmaps) {
  };
  Texture.prototype.close_sv8swh_k$ = function () {
    if (!this._alreadyClosed) {
      this._alreadyClosed = true;
      this._source = Companion_getInstance_164()._NIL_2;
      this._tempBitmap = null;
      var tmp0_this = this._$this_17;
      var tmp1 = tmp0_this._deletedTextureCount;
      tmp0_this._deletedTextureCount = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Texture.$metadata$ = {
    simpleName: 'Texture',
    kind: 'class',
    interfaces: [Closeable]
  };
  function TextureUnit(texture, linear) {
    this._texture_2 = texture;
    this._linear_0 = linear;
  }
  TextureUnit.prototype.toString = function () {
    return '' + 'TextureUnit(texture=' + this._texture_2 + ', linear=' + this._linear_0 + ')';
  };
  TextureUnit.prototype.hashCode = function () {
    var result = this._texture_2 == null ? 0 : hashCode(this._texture_2);
    result = imul(result, 31) + (this._linear_0 | 0) | 0;
    return result;
  };
  TextureUnit.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextureUnit))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextureUnit ? other : THROW_CCE();
    if (!equals_1(this._texture_2, tmp0_other_with_cast._texture_2))
      return false;
    if (!(this._linear_0 === tmp0_other_with_cast._linear_0))
      return false;
    return true;
  };
  TextureUnit.$metadata$ = {
    simpleName: 'TextureUnit',
    kind: 'class',
    interfaces: []
  };
  function Buffer(kind) {
    this._kind_1 = kind;
    this._dirty_1 = false;
    this._mem_0 = null;
    this._memOffset = 0;
    this._memLength = 0;
  }
  Buffer.prototype._get_kind__0_k$ = function () {
    return this._kind_1;
  };
  Buffer.prototype._set_dirty__rpwsgn_k$ = function (_set___) {
    this._dirty_1 = _set___;
  };
  Buffer.prototype._get_dirty__0_k$ = function () {
    return this._dirty_1;
  };
  Buffer.prototype._get_mem__0_k$ = function () {
    return this._mem_0;
  };
  Buffer.prototype._get_memOffset__0_k$ = function () {
    return this._memOffset;
  };
  Buffer.prototype._get_memLength__0_k$ = function () {
    return this._memLength;
  };
  Buffer.prototype.afterSetMem_sv8swh_k$ = function () {
  };
  Buffer.prototype.upload_irqg4d_k$ = function (data, offset_0, length) {
    this._mem_0 = Companion_getInstance_97().invoke_ha5a7z_k$(length);
    ensureNotNull(this._mem_0).setAlignedArrayInt8_46tb3l_k$(0, data, offset_0, length);
    this._memOffset = 0;
    this._memLength = length;
    this._dirty_1 = true;
    this.afterSetMem_sv8swh_k$();
    return this;
  };
  Buffer.prototype.upload_u4hn1j_k$ = function (data, offset_0, length) {
    this._mem_0 = data;
    this._memOffset = offset_0;
    this._memLength = length;
    this._dirty_1 = true;
    this.afterSetMem_sv8swh_k$();
    return this;
  };
  Buffer.prototype.close_sv8swh_k$ = function () {
    this._mem_0 = null;
    this._memOffset = 0;
    this._memLength = 0;
    this._dirty_1 = true;
  };
  Buffer.$metadata$ = {
    simpleName: 'Buffer',
    kind: 'class',
    interfaces: [Closeable]
  };
  function DrawType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  DrawType.$metadata$ = {
    simpleName: 'DrawType',
    kind: 'class',
    interfaces: []
  };
  function IndexType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  IndexType.$metadata$ = {
    simpleName: 'IndexType',
    kind: 'class',
    interfaces: []
  };
  function StencilOp(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  StencilOp.$metadata$ = {
    simpleName: 'StencilOp',
    kind: 'class',
    interfaces: []
  };
  function TriangleFace(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  TriangleFace.$metadata$ = {
    simpleName: 'TriangleFace',
    kind: 'class',
    interfaces: []
  };
  function CompareMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CompareMode.$metadata$ = {
    simpleName: 'CompareMode',
    kind: 'class',
    interfaces: []
  };
  function ColorMaskState(red, green, blue, alpha_0) {
    this._red = red;
    this._green = green;
    this._blue = blue;
    this._alpha_0 = alpha_0;
  }
  ColorMaskState.prototype.toString = function () {
    return '' + 'ColorMaskState(red=' + this._red + ', green=' + this._green + ', blue=' + this._blue + ', alpha=' + this._alpha_0 + ')';
  };
  ColorMaskState.prototype.hashCode = function () {
    var result = this._red | 0;
    result = imul(result, 31) + (this._green | 0) | 0;
    result = imul(result, 31) + (this._blue | 0) | 0;
    result = imul(result, 31) + (this._alpha_0 | 0) | 0;
    return result;
  };
  ColorMaskState.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorMaskState))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ColorMaskState ? other : THROW_CCE();
    if (!(this._red === tmp0_other_with_cast._red))
      return false;
    if (!(this._green === tmp0_other_with_cast._green))
      return false;
    if (!(this._blue === tmp0_other_with_cast._blue))
      return false;
    if (!(this._alpha_0 === tmp0_other_with_cast._alpha_0))
      return false;
    return true;
  };
  ColorMaskState.$metadata$ = {
    simpleName: 'ColorMaskState',
    kind: 'class',
    interfaces: []
  };
  function FrontFace(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  FrontFace.$metadata$ = {
    simpleName: 'FrontFace',
    kind: 'class',
    interfaces: []
  };
  function RenderState(depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace) {
    this._depthFunc = depthFunc;
    this._depthMask = depthMask;
    this._depthNear = depthNear;
    this._depthFar = depthFar;
    this._lineWidth_0 = lineWidth;
    this._frontFace = frontFace;
  }
  RenderState.prototype.toString = function () {
    return '' + 'RenderState(depthFunc=' + this._depthFunc + ', depthMask=' + this._depthMask + ', depthNear=' + this._depthNear + ', depthFar=' + this._depthFar + ', lineWidth=' + this._lineWidth_0 + ', frontFace=' + this._frontFace + ')';
  };
  RenderState.prototype.hashCode = function () {
    var result = this._depthFunc.hashCode();
    result = imul(result, 31) + (this._depthMask | 0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._depthNear) | 0;
    result = imul(result, 31) + getNumberHashCode(this._depthFar) | 0;
    result = imul(result, 31) + getNumberHashCode(this._lineWidth_0) | 0;
    result = imul(result, 31) + this._frontFace.hashCode() | 0;
    return result;
  };
  RenderState.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RenderState))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RenderState ? other : THROW_CCE();
    if (!this._depthFunc.equals(tmp0_other_with_cast._depthFunc))
      return false;
    if (!(this._depthMask === tmp0_other_with_cast._depthMask))
      return false;
    if (!equals_1(this._depthNear, tmp0_other_with_cast._depthNear))
      return false;
    if (!equals_1(this._depthFar, tmp0_other_with_cast._depthFar))
      return false;
    if (!equals_1(this._lineWidth_0, tmp0_other_with_cast._lineWidth_0))
      return false;
    if (!this._frontFace.equals(tmp0_other_with_cast._frontFace))
      return false;
    return true;
  };
  RenderState.$metadata$ = {
    simpleName: 'RenderState',
    kind: 'class',
    interfaces: []
  };
  function StencilState(enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask) {
    this._enabled = enabled;
    this._triangleFace = triangleFace;
    this._compareMode = compareMode;
    this._actionOnBothPass = actionOnBothPass;
    this._actionOnDepthFail = actionOnDepthFail;
    this._actionOnDepthPassStencilFail = actionOnDepthPassStencilFail;
    this._referenceValue = referenceValue;
    this._readMask = readMask;
    this._writeMask = writeMask;
  }
  StencilState.prototype.copyFrom_ivptdh_k$ = function (other) {
    this._enabled = other._enabled;
    this._triangleFace = other._triangleFace;
    this._compareMode = other._compareMode;
    this._actionOnBothPass = other._actionOnBothPass;
    this._actionOnDepthFail = other._actionOnDepthFail;
    this._actionOnDepthPassStencilFail = other._actionOnDepthPassStencilFail;
    this._referenceValue = other._referenceValue;
    this._readMask = other._readMask;
    this._writeMask = other._writeMask;
  };
  StencilState.prototype.toString = function () {
    return '' + 'StencilState(enabled=' + this._enabled + ', triangleFace=' + this._triangleFace + ', compareMode=' + this._compareMode + ', actionOnBothPass=' + this._actionOnBothPass + ', actionOnDepthFail=' + this._actionOnDepthFail + ', actionOnDepthPassStencilFail=' + this._actionOnDepthPassStencilFail + ', referenceValue=' + this._referenceValue + ', readMask=' + this._readMask + ', writeMask=' + this._writeMask + ')';
  };
  StencilState.prototype.hashCode = function () {
    var result = this._enabled | 0;
    result = imul(result, 31) + this._triangleFace.hashCode() | 0;
    result = imul(result, 31) + this._compareMode.hashCode() | 0;
    result = imul(result, 31) + this._actionOnBothPass.hashCode() | 0;
    result = imul(result, 31) + this._actionOnDepthFail.hashCode() | 0;
    result = imul(result, 31) + this._actionOnDepthPassStencilFail.hashCode() | 0;
    result = imul(result, 31) + this._referenceValue | 0;
    result = imul(result, 31) + this._readMask | 0;
    result = imul(result, 31) + this._writeMask | 0;
    return result;
  };
  StencilState.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StencilState))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof StencilState ? other : THROW_CCE();
    if (!(this._enabled === tmp0_other_with_cast._enabled))
      return false;
    if (!this._triangleFace.equals(tmp0_other_with_cast._triangleFace))
      return false;
    if (!this._compareMode.equals(tmp0_other_with_cast._compareMode))
      return false;
    if (!this._actionOnBothPass.equals(tmp0_other_with_cast._actionOnBothPass))
      return false;
    if (!this._actionOnDepthFail.equals(tmp0_other_with_cast._actionOnDepthFail))
      return false;
    if (!this._actionOnDepthPassStencilFail.equals(tmp0_other_with_cast._actionOnDepthPassStencilFail))
      return false;
    if (!(this._referenceValue === tmp0_other_with_cast._referenceValue))
      return false;
    if (!(this._readMask === tmp0_other_with_cast._readMask))
      return false;
    if (!(this._writeMask === tmp0_other_with_cast._writeMask))
      return false;
    return true;
  };
  StencilState.$metadata$ = {
    simpleName: 'StencilState',
    kind: 'class',
    interfaces: []
  };
  function VertexData(buffer, layout) {
    this._buffer_25 = buffer;
    this._layout = layout;
  }
  VertexData.prototype.toString = function () {
    return '' + 'VertexData(buffer=' + this._buffer_25 + ', layout=' + this._layout + ')';
  };
  VertexData.prototype.hashCode = function () {
    var result = hashCode(this._buffer_25);
    result = imul(result, 31) + hashCode(this._layout) | 0;
    return result;
  };
  VertexData.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VertexData))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VertexData ? other : THROW_CCE();
    if (!equals_1(this._buffer_25, tmp0_other_with_cast._buffer_25))
      return false;
    if (!equals_1(this._layout, tmp0_other_with_cast._layout))
      return false;
    return true;
  };
  VertexData.$metadata$ = {
    simpleName: 'VertexData',
    kind: 'class',
    interfaces: []
  };
  function Batch(vertexData, program, type, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances) {
    this._vertexData = vertexData;
    this._program = program;
    this._type_10 = type;
    this._vertexCount_0 = vertexCount;
    this._indices = indices;
    this._indexType = indexType;
    this._offset_29 = offset_0;
    this._blending = blending;
    this._uniforms = uniforms;
    this._stencil = stencil;
    this._colorMask = colorMask;
    this._renderState = renderState;
    this._scissor = scissor;
    this._instances = instances;
    this._singleVertexData = FastArrayList_init_$Create$();
  }
  Batch.prototype._set_vertices__exng74_k$ = function (value) {
    ensureSingleVertexData(this);
    this._singleVertexData.get_ha5a7z_k$(0)._buffer_25 = value;
  };
  Batch.prototype._set_vertexLayout__rehsrv_k$ = function (value) {
    ensureSingleVertexData(this);
    this._singleVertexData.get_ha5a7z_k$(0)._layout = value;
  };
  Batch.prototype.toString = function () {
    return '' + 'Batch(vertexData=' + this._vertexData + ', program=' + this._program + ', type=' + this._type_10 + ', vertexCount=' + this._vertexCount_0 + ', indices=' + this._indices + ', indexType=' + this._indexType + ', offset=' + this._offset_29 + ', blending=' + this._blending + ', uniforms=' + this._uniforms + ', stencil=' + this._stencil + ', colorMask=' + this._colorMask + ', renderState=' + this._renderState + ', scissor=' + this._scissor + ', instances=' + this._instances + ')';
  };
  Batch.prototype.hashCode = function () {
    var result = this._vertexData.hashCode();
    result = imul(result, 31) + this._program.hashCode() | 0;
    result = imul(result, 31) + this._type_10.hashCode() | 0;
    result = imul(result, 31) + this._vertexCount_0 | 0;
    result = imul(result, 31) + (this._indices == null ? 0 : hashCode(this._indices)) | 0;
    result = imul(result, 31) + this._indexType.hashCode() | 0;
    result = imul(result, 31) + this._offset_29 | 0;
    result = imul(result, 31) + this._blending.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._uniforms) | 0;
    result = imul(result, 31) + this._stencil.hashCode() | 0;
    result = imul(result, 31) + this._colorMask.hashCode() | 0;
    result = imul(result, 31) + this._renderState.hashCode() | 0;
    result = imul(result, 31) + (this._scissor == null ? 0 : this._scissor.hashCode()) | 0;
    result = imul(result, 31) + this._instances | 0;
    return result;
  };
  Batch.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Batch))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Batch ? other : THROW_CCE();
    if (!this._vertexData.equals(tmp0_other_with_cast._vertexData))
      return false;
    if (!this._program.equals(tmp0_other_with_cast._program))
      return false;
    if (!this._type_10.equals(tmp0_other_with_cast._type_10))
      return false;
    if (!(this._vertexCount_0 === tmp0_other_with_cast._vertexCount_0))
      return false;
    if (!equals_1(this._indices, tmp0_other_with_cast._indices))
      return false;
    if (!this._indexType.equals(tmp0_other_with_cast._indexType))
      return false;
    if (!(this._offset_29 === tmp0_other_with_cast._offset_29))
      return false;
    if (!this._blending.equals(tmp0_other_with_cast._blending))
      return false;
    if (!equals_1(this._uniforms, tmp0_other_with_cast._uniforms))
      return false;
    if (!this._stencil.equals(tmp0_other_with_cast._stencil))
      return false;
    if (!this._colorMask.equals(tmp0_other_with_cast._colorMask))
      return false;
    if (!this._renderState.equals(tmp0_other_with_cast._renderState))
      return false;
    if (!equals_1(this._scissor, tmp0_other_with_cast._scissor))
      return false;
    if (!(this._instances === tmp0_other_with_cast._instances))
      return false;
    return true;
  };
  Batch.$metadata$ = {
    simpleName: 'Batch',
    kind: 'class',
    interfaces: []
  };
  function BaseRenderBuffer() {
  }
  BaseRenderBuffer.prototype.setSize$default_e5nmz5_k$ = function (x, y, width, height, fullWidth, fullHeight, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      fullWidth = width;
    if (!(($mask0 & 32) === 0))
      fullHeight = height;
    return $handler == null ? this.setSize_6try9d_k$(x, y, width, height, fullWidth, fullHeight) : $handler(x, y, width, height, fullWidth, fullHeight);
  };
  BaseRenderBuffer.prototype.init_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  BaseRenderBuffer.prototype.set_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  BaseRenderBuffer.prototype.unset_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  BaseRenderBuffer.$metadata$ = {
    simpleName: 'BaseRenderBuffer',
    kind: 'interface',
    interfaces: []
  };
  function BaseRenderBufferImpl() {
    this._x_19 = 0;
    this._y_18 = 0;
    this._width_14 = 128;
    this._height_15 = 128;
    this._fullWidth = 128;
    this._fullHeight = 128;
    this.__scissor = Companion_getInstance_36().invoke_t4v1qq_k$();
    this._scissor_0 = null;
  }
  BaseRenderBufferImpl.prototype._set_x__majfzk_k$ = function (_set___) {
    this._x_19 = _set___;
  };
  BaseRenderBufferImpl.prototype._get_x__0_k$ = function () {
    return this._x_19;
  };
  BaseRenderBufferImpl.prototype._set_y__majfzk_k$ = function (_set___) {
    this._y_18 = _set___;
  };
  BaseRenderBufferImpl.prototype._get_y__0_k$ = function () {
    return this._y_18;
  };
  BaseRenderBufferImpl.prototype._set_width__majfzk_k$ = function (_set___) {
    this._width_14 = _set___;
  };
  BaseRenderBufferImpl.prototype._get_width__0_k$ = function () {
    return this._width_14;
  };
  BaseRenderBufferImpl.prototype._set_height__majfzk_k$ = function (_set___) {
    this._height_15 = _set___;
  };
  BaseRenderBufferImpl.prototype._get_height__0_k$ = function () {
    return this._height_15;
  };
  BaseRenderBufferImpl.prototype._set_fullWidth__majfzk_k$ = function (_set___) {
    this._fullWidth = _set___;
  };
  BaseRenderBufferImpl.prototype._get_fullWidth__0_k$ = function () {
    return this._fullWidth;
  };
  BaseRenderBufferImpl.prototype._set_fullHeight__majfzk_k$ = function (_set___) {
    this._fullHeight = _set___;
  };
  BaseRenderBufferImpl.prototype._get_fullHeight__0_k$ = function () {
    return this._fullHeight;
  };
  BaseRenderBufferImpl.prototype._get_scissor__k7q7mb_k$ = function () {
    return this._scissor_0;
  };
  BaseRenderBufferImpl.prototype.setSize_6try9d_k$ = function (x, y, width, height, fullWidth, fullHeight) {
    this._set_x__majfzk_k$(x);
    this._set_y__majfzk_k$(y);
    this._set_width__majfzk_k$(width);
    this._set_height__majfzk_k$(height);
    this._set_fullWidth__majfzk_k$(fullWidth);
    this._set_fullHeight__majfzk_k$(fullHeight);
  };
  BaseRenderBufferImpl.$metadata$ = {
    simpleName: 'BaseRenderBufferImpl',
    kind: 'class',
    interfaces: [BaseRenderBuffer]
  };
  function RenderBuffer($outer) {
    this._$this_18 = $outer;
    BaseRenderBufferImpl.call(this);
    this._id_9 = -1;
    this._cachedTexVersion = -1;
    this.__tex = null;
    this._dirty_2 = false;
  }
  RenderBuffer.prototype._get_tex__0_k$ = function () {
    if (!(this._cachedTexVersion === this._$this_18._contextVersion)) {
      this._cachedTexVersion = this._$this_18._contextVersion;
      var tmp = this;
      var tmp0_apply_0 = this._$this_18.createTexture_vcj5fe_k$(true).manualUpload_0_k$();
      tmp0_apply_0._isFbo = true;
      tmp.__tex = tmp0_apply_0;
    }return ensureNotNull(this.__tex);
  };
  RenderBuffer.prototype._set_dirty__rpwsgn_k$ = function (_set___) {
    this._dirty_2 = _set___;
  };
  RenderBuffer.prototype._get_dirty__0_k$ = function () {
    return this._dirty_2;
  };
  RenderBuffer.prototype.setSize_6try9d_k$ = function (x, y, width, height, fullWidth, fullHeight) {
    BaseRenderBufferImpl.prototype.setSize_6try9d_k$.call(this, x, y, width, height, fullWidth, fullHeight);
    this._dirty_2 = true;
  };
  RenderBuffer.prototype.set_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  RenderBuffer.prototype.close_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  RenderBuffer.$metadata$ = {
    simpleName: 'RenderBuffer',
    kind: 'class',
    interfaces: [Closeable]
  };
  function TextureDrawer($outer) {
    this._$this_19 = $outer;
    this._VERTEX_COUNT = 4;
    this._vertices_3 = this._$this_19.createBuffer_ijzjc5_k$(Kind_VERTEX_getInstance());
    this._vertexLayout = VertexLayout_init_$Create$([DefaultShaders_getInstance()._a_Pos, DefaultShaders_getInstance()._a_Tex]);
    this._verticesData = Companion_getInstance_97().invoke_ha5a7z_k$(imul(this._VERTEX_COUNT, this._vertexLayout._totalSize_2));
    var tmp = this;
    var tmp_0 = VertexShader_0(_no_name_provided_$factory_250());
    var tmp_1 = FragmentShader_0(_no_name_provided_$factory_251());
    tmp._program_0 = Program_init_$Create$(tmp_0, tmp_1, null, 4, null);
    this._uniforms_0 = new UniformValues();
  }
  TextureDrawer.$metadata$ = {
    simpleName: 'TextureDrawer',
    kind: 'class',
    interfaces: []
  };
  function UniformValues() {
    Companion_getInstance_165();
    this.__uniforms = FastArrayList_init_$Create$();
    this.__values_4 = FastArrayList_init_$Create$();
    var tmp = this;
    var tmp_0 = this.__uniforms;
    tmp._uniforms_1 = isInterface(tmp_0, List) ? tmp_0 : THROW_CCE();
    var tmp_1 = this;
    var tmp_2 = this.__values_4;
    tmp_1._values_2 = isInterface(tmp_2, List) ? tmp_2 : THROW_CCE();
  }
  UniformValues.prototype._get_keys__0_k$ = function () {
    return this._uniforms_1;
  };
  UniformValues.prototype._get_size__0_k$ = function () {
    return this.__uniforms._get_size__0_k$();
  };
  UniformValues.prototype.clear_sv8swh_k$ = function () {
    this.__uniforms.clear_sv8swh_k$();
    this.__values_4.clear_sv8swh_k$();
  };
  UniformValues.prototype.set_r39nsu_k$ = function (uniform, value) {
    return this.put_r39nsu_k$(uniform, value);
  };
  UniformValues.prototype.put_r39nsu_k$ = function (uniform, value) {
    var inductionVariable = 0;
    var last_1 = this.__uniforms._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.__uniforms.get_ha5a7z_k$(n)._get_name__0_k$() === uniform._get_name__0_k$()) {
          this.__values_4.set_ddb1qf_k$(n, value);
          Unit_getInstance();
          return this;
        }}
       while (inductionVariable < last_1);
    this.__uniforms.add_2bq_k$(uniform);
    Unit_getInstance();
    this.__values_4.add_2bq_k$(value);
    Unit_getInstance();
    return this;
  };
  UniformValues.prototype.put_ehqtxh_k$ = function (uniforms) {
    var inductionVariable = 0;
    var last_1 = uniforms._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.put_r39nsu_k$(uniforms.__uniforms.get_ha5a7z_k$(n), uniforms.__values_4.get_ha5a7z_k$(n));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    return this;
  };
  UniformValues.prototype.setTo_53oll8_k$ = function (uniforms) {
    this.clear_sv8swh_k$();
    this.put_ehqtxh_k$(uniforms);
    Unit_getInstance();
  };
  UniformValues.prototype.toString = function () {
    var tmp0_map_0 = zip(this._get_keys__0_k$(), this._values_2);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$('' + item_2_3._first + '=' + item_2_3._second);
      Unit_getInstance();
    }
    return '{' + joinToString$default_0(tmp0_mapTo_0_1, ', ', null, null, 0, null, null, 62, null) + '}';
  };
  UniformValues.$metadata$ = {
    simpleName: 'UniformValues',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__298(this$0) {
    this._this$0_70 = this$0;
  }
  _no_name_provided__298.prototype.invoke_0_k$ = function () {
    return this._this$0_70.createTexture_0_k$();
  };
  _no_name_provided__298.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__299(this$0) {
    this._this$0_71 = this$0;
  }
  _no_name_provided__299.prototype.invoke_ha5a7z_k$ = function (it) {
    return this._this$0_71.createRenderBuffer_0_k$();
  };
  _no_name_provided__299.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__299.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__300(this$0) {
    this._this$0_72 = this$0;
  }
  _no_name_provided__300.prototype.invoke_0_k$ = function () {
    return this._this$0_72.createMainRenderBuffer_0_k$();
  };
  _no_name_provided__300.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__301(this$0) {
    this._this$0_73 = this$0;
  }
  _no_name_provided__301.prototype.invoke_0_k$ = function () {
    return new TextureDrawer(this._this$0_73);
  };
  _no_name_provided__301.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__302(this$0) {
    this._this$0_74 = this$0;
  }
  _no_name_provided__302.prototype.invoke_0_k$ = function () {
    return this._this$0_74.createTexture_0_k$();
  };
  _no_name_provided__302.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BlendEquation_ADD_getInstance() {
    BlendEquation_initEntries();
    return BlendEquation_ADD_instance;
  }
  function BlendEquation_SUBTRACT_getInstance() {
    BlendEquation_initEntries();
    return BlendEquation_SUBTRACT_instance;
  }
  function BlendEquation_REVERSE_SUBTRACT_getInstance() {
    BlendEquation_initEntries();
    return BlendEquation_REVERSE_SUBTRACT_instance;
  }
  function BlendFactor_DESTINATION_ALPHA_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_DESTINATION_ALPHA_instance;
  }
  function BlendFactor_DESTINATION_COLOR_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_DESTINATION_COLOR_instance;
  }
  function BlendFactor_ONE_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_instance;
  }
  function BlendFactor_ONE_MINUS_DESTINATION_ALPHA_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_MINUS_DESTINATION_ALPHA_instance;
  }
  function BlendFactor_ONE_MINUS_DESTINATION_COLOR_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_MINUS_DESTINATION_COLOR_instance;
  }
  function BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_MINUS_SOURCE_ALPHA_instance;
  }
  function BlendFactor_ONE_MINUS_SOURCE_COLOR_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_MINUS_SOURCE_COLOR_instance;
  }
  function BlendFactor_SOURCE_ALPHA_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_SOURCE_ALPHA_instance;
  }
  function BlendFactor_SOURCE_COLOR_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_SOURCE_COLOR_instance;
  }
  function BlendFactor_ZERO_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ZERO_instance;
  }
  function DrawType_POINTS_getInstance() {
    DrawType_initEntries();
    return DrawType_POINTS_instance;
  }
  function DrawType_LINE_STRIP_getInstance() {
    DrawType_initEntries();
    return DrawType_LINE_STRIP_instance;
  }
  function DrawType_LINE_LOOP_getInstance() {
    DrawType_initEntries();
    return DrawType_LINE_LOOP_instance;
  }
  function DrawType_LINES_getInstance() {
    DrawType_initEntries();
    return DrawType_LINES_instance;
  }
  function DrawType_TRIANGLES_getInstance() {
    DrawType_initEntries();
    return DrawType_TRIANGLES_instance;
  }
  function DrawType_TRIANGLE_STRIP_getInstance() {
    DrawType_initEntries();
    return DrawType_TRIANGLE_STRIP_instance;
  }
  function DrawType_TRIANGLE_FAN_getInstance() {
    DrawType_initEntries();
    return DrawType_TRIANGLE_FAN_instance;
  }
  function IndexType_UBYTE_getInstance() {
    IndexType_initEntries();
    return IndexType_UBYTE_instance;
  }
  function IndexType_USHORT_getInstance() {
    IndexType_initEntries();
    return IndexType_USHORT_instance;
  }
  function IndexType_UINT_getInstance() {
    IndexType_initEntries();
    return IndexType_UINT_instance;
  }
  function StencilOp_DECREMENT_SATURATE_getInstance() {
    StencilOp_initEntries();
    return StencilOp_DECREMENT_SATURATE_instance;
  }
  function StencilOp_DECREMENT_WRAP_getInstance() {
    StencilOp_initEntries();
    return StencilOp_DECREMENT_WRAP_instance;
  }
  function StencilOp_INCREMENT_SATURATE_getInstance() {
    StencilOp_initEntries();
    return StencilOp_INCREMENT_SATURATE_instance;
  }
  function StencilOp_INCREMENT_WRAP_getInstance() {
    StencilOp_initEntries();
    return StencilOp_INCREMENT_WRAP_instance;
  }
  function StencilOp_INVERT_getInstance() {
    StencilOp_initEntries();
    return StencilOp_INVERT_instance;
  }
  function StencilOp_KEEP_getInstance() {
    StencilOp_initEntries();
    return StencilOp_KEEP_instance;
  }
  function StencilOp_SET_getInstance() {
    StencilOp_initEntries();
    return StencilOp_SET_instance;
  }
  function StencilOp_ZERO_getInstance() {
    StencilOp_initEntries();
    return StencilOp_ZERO_instance;
  }
  function TriangleFace_FRONT_AND_BACK_getInstance() {
    TriangleFace_initEntries();
    return TriangleFace_FRONT_AND_BACK_instance;
  }
  function CompareMode_ALWAYS_getInstance() {
    CompareMode_initEntries();
    return CompareMode_ALWAYS_instance;
  }
  function CompareMode_EQUAL_getInstance() {
    CompareMode_initEntries();
    return CompareMode_EQUAL_instance;
  }
  function CompareMode_GREATER_getInstance() {
    CompareMode_initEntries();
    return CompareMode_GREATER_instance;
  }
  function CompareMode_GREATER_EQUAL_getInstance() {
    CompareMode_initEntries();
    return CompareMode_GREATER_EQUAL_instance;
  }
  function CompareMode_LESS_getInstance() {
    CompareMode_initEntries();
    return CompareMode_LESS_instance;
  }
  function CompareMode_LESS_EQUAL_getInstance() {
    CompareMode_initEntries();
    return CompareMode_LESS_EQUAL_instance;
  }
  function CompareMode_NEVER_getInstance() {
    CompareMode_initEntries();
    return CompareMode_NEVER_instance;
  }
  function CompareMode_NOT_EQUAL_getInstance() {
    CompareMode_initEntries();
    return CompareMode_NOT_EQUAL_instance;
  }
  function FrontFace_BOTH_getInstance() {
    FrontFace_initEntries();
    return FrontFace_BOTH_instance;
  }
  function FrontFace_CW_getInstance() {
    FrontFace_initEntries();
    return FrontFace_CW_instance;
  }
  function AG() {
    var tmp = this;
    tmp._$$delegate_0_25 = Mixin_init_$Create$(null, 1, null);
    this._contextVersion = 0;
    this._maxTextureSize = Companion_getInstance_38().invoke_5hnyrx_k$(2048, 2048);
    this._devicePixelRatio = 1.0;
    this._lastTextureId = 0;
    this._createdTextureCount = 0;
    this._deletedTextureCount = 0;
    var tmp_0 = this;
    tmp_0._dummyTexture$delegate = lazy(_no_name_provided_$factory_242(this));
    var tmp_1 = this;
    tmp_1._dummyRenderState = RenderState_init_$Create$(null, false, 0.0, 0.0, 0.0, null, 63, null);
    var tmp_2 = this;
    tmp_2._dummyStencilState = StencilState_init_$Create$(false, null, null, null, null, null, 0, 0, 0, 511, null);
    var tmp_3 = this;
    tmp_3._dummyColorMaskState = ColorMaskState_init_$Create$(false, false, false, false, 15, null);
    var tmp_4 = this;
    tmp_4._batch = Batch_init_$Create$(null, null, null, 0, null, null, 0, null, null, null, null, null, null, 0, 16383, null);
    this._frameRenderBuffers = LinkedHashSet_init_$Create$();
    var tmp_5 = this;
    tmp_5._renderBuffers = Pool_init_$Create$_1(0, _no_name_provided_$factory_243(this), 1, null);
    var tmp_6 = this;
    tmp_6._mainRenderBuffer$delegate = lazy(_no_name_provided_$factory_244(this));
    this._currentRenderBuffer = null;
    var tmp_7 = this;
    tmp_7._textureDrawer$delegate = lazy(_no_name_provided_$factory_245(this));
    this._flipRenderTexture = true;
    var tmp_8 = this;
    tmp_8._drawTempTexture$delegate = lazy(_no_name_provided_$factory_246(this));
  }
  AG.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_25._set_extra__n1onou_k$(_set___);
  };
  AG.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_25._get_extra__0_k$();
  };
  AG.prototype._set_contextVersion__majfzk_k$ = function (_set___) {
    this._contextVersion = _set___;
  };
  AG.prototype._get_contextVersion__0_k$ = function () {
    return this._contextVersion;
  };
  AG.prototype.contextLost_sv8swh_k$ = function () {
    Console_getInstance().info_c2g51s_k$(['AG.contextLost()', this]);
    var tmp0_this = this;
    var tmp1 = tmp0_this._contextVersion;
    tmp0_this._contextVersion = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  AG.prototype._get_devicePixelRatio__0_k$ = function () {
    return this._devicePixelRatio;
  };
  AG.prototype.beforeDoRender_sv8swh_k$ = function () {
  };
  AG.prototype.resized_6try9d_k$ = function (x, y, width, height, fullWidth, fullHeight) {
    this._get_mainRenderBuffer__0_k$().setSize_6try9d_k$(x, y, width, height, fullWidth, fullHeight);
  };
  AG.prototype._get_backWidth__0_k$ = function () {
    return this._get_mainRenderBuffer__0_k$()._get_width__0_k$();
  };
  AG.prototype._get_backHeight__0_k$ = function () {
    return this._get_mainRenderBuffer__0_k$()._get_height__0_k$();
  };
  AG.prototype._get_realBackWidth__0_k$ = function () {
    return this._get_mainRenderBuffer__0_k$()._get_fullWidth__0_k$();
  };
  AG.prototype._get_realBackHeight__0_k$ = function () {
    return this._get_mainRenderBuffer__0_k$()._get_fullHeight__0_k$();
  };
  AG.prototype._get_currentWidth__0_k$ = function () {
    var tmp0_safe_receiver = this._currentRenderBuffer;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_width__0_k$();
    return tmp1_elvis_lhs == null ? this._get_mainRenderBuffer__0_k$()._get_width__0_k$() : tmp1_elvis_lhs;
  };
  AG.prototype._get_currentHeight__0_k$ = function () {
    var tmp0_safe_receiver = this._currentRenderBuffer;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_height__0_k$();
    return tmp1_elvis_lhs == null ? this._get_mainRenderBuffer__0_k$()._get_height__0_k$() : tmp1_elvis_lhs;
  };
  AG.prototype.createTexture_0_k$ = function () {
    return this.createTexture_vcj5fe_k$(true);
  };
  AG.prototype.createTexture_vcj5fe_k$ = function (premultiplied) {
    return new Texture(this);
  };
  AG.prototype.createBuffer_ijzjc5_k$ = function (kind) {
    return new Buffer(kind);
  };
  AG.prototype.createIndexBuffer_0_k$ = function () {
    return this.createBuffer_ijzjc5_k$(Kind_INDEX_getInstance());
  };
  AG.prototype.createVertexBuffer_0_k$ = function () {
    return this.createBuffer_ijzjc5_k$(Kind_VERTEX_getInstance());
  };
  AG.prototype.draw_wguk75_k$ = function (vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances) {
    var tmp0_also_0 = this._batch;
    tmp0_also_0._set_vertices__exng74_k$(vertices);
    tmp0_also_0._program = program;
    tmp0_also_0._type_10 = type;
    tmp0_also_0._set_vertexLayout__rehsrv_k$(vertexLayout);
    tmp0_also_0._vertexCount_0 = vertexCount;
    tmp0_also_0._indices = indices;
    tmp0_also_0._indexType = indexType;
    tmp0_also_0._offset_29 = offset_0;
    tmp0_also_0._blending = blending;
    tmp0_also_0._uniforms = uniforms;
    tmp0_also_0._stencil = stencil;
    tmp0_also_0._colorMask = colorMask;
    tmp0_also_0._renderState = renderState;
    tmp0_also_0._scissor = scissor;
    tmp0_also_0._instances = instances;
    return this.draw_ehteko_k$(tmp0_also_0);
  };
  AG.prototype.draw$default_acdjhv_k$ = function (vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances, $mask0, $handler) {
    if (!(($mask0 & 32) === 0))
      indices = null;
    if (!(($mask0 & 64) === 0))
      indexType = IndexType_USHORT_getInstance();
    if (!(($mask0 & 128) === 0))
      offset_0 = 0;
    if (!(($mask0 & 256) === 0))
      blending = Companion_getInstance_163()._NORMAL;
    if (!(($mask0 & 512) === 0))
      uniforms = Companion_getInstance_165()._EMPTY_5;
    if (!(($mask0 & 1024) === 0))
      stencil = this._dummyStencilState;
    if (!(($mask0 & 2048) === 0))
      colorMask = this._dummyColorMaskState;
    if (!(($mask0 & 4096) === 0))
      renderState = this._dummyRenderState;
    if (!(($mask0 & 8192) === 0))
      scissor = null;
    if (!(($mask0 & 16384) === 0))
      instances = 1;
    return this.draw_wguk75_k$(vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances);
  };
  AG.prototype.drawV2_ci2zg4_k$ = function (vertexData, program, type, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances) {
    var tmp0_also_0 = this._batch;
    tmp0_also_0._vertexData = vertexData;
    tmp0_also_0._program = program;
    tmp0_also_0._type_10 = type;
    tmp0_also_0._vertexCount_0 = vertexCount;
    tmp0_also_0._indices = indices;
    tmp0_also_0._indexType = indexType;
    tmp0_also_0._offset_29 = offset_0;
    tmp0_also_0._blending = blending;
    tmp0_also_0._uniforms = uniforms;
    tmp0_also_0._stencil = stencil;
    tmp0_also_0._colorMask = colorMask;
    tmp0_also_0._renderState = renderState;
    tmp0_also_0._scissor = scissor;
    tmp0_also_0._instances = instances;
    return this.draw_ehteko_k$(tmp0_also_0);
  };
  AG.prototype.drawV2$default_j2y7ju_k$ = function (vertexData, program, type, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      indices = null;
    if (!(($mask0 & 32) === 0))
      indexType = IndexType_USHORT_getInstance();
    if (!(($mask0 & 64) === 0))
      offset_0 = 0;
    if (!(($mask0 & 128) === 0))
      blending = Companion_getInstance_163()._NORMAL;
    if (!(($mask0 & 256) === 0))
      uniforms = Companion_getInstance_165()._EMPTY_5;
    if (!(($mask0 & 512) === 0))
      stencil = this._dummyStencilState;
    if (!(($mask0 & 1024) === 0))
      colorMask = this._dummyColorMaskState;
    if (!(($mask0 & 2048) === 0))
      renderState = this._dummyRenderState;
    if (!(($mask0 & 4096) === 0))
      scissor = null;
    if (!(($mask0 & 8192) === 0))
      instances = 1;
    return this.drawV2_ci2zg4_k$(vertexData, program, type, vertexCount, indices, indexType, offset_0, blending, uniforms, stencil, colorMask, renderState, scissor, instances);
  };
  AG.prototype.draw_ehteko_k$ = function (batch) {
  };
  AG.prototype.disposeTemporalPerFrameStuff_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  AG.prototype._get_mainRenderBuffer__0_k$ = function () {
    var tmp0_getValue_0 = mainRenderBuffer$factory();
    return this._mainRenderBuffer$delegate._get_value__0_k$();
  };
  AG.prototype.createMainRenderBuffer_0_k$ = function () {
    return new BaseRenderBufferImpl();
  };
  AG.prototype.createRenderBuffer_0_k$ = function () {
    return new RenderBuffer(this);
  };
  AG.prototype.flip_sv8swh_k$ = function () {
    this.disposeTemporalPerFrameStuff_sv8swh_k$();
    this._renderBuffers.free_vgcrvo_k$(this._frameRenderBuffers);
    var tmp0_isNotEmpty_0 = this._frameRenderBuffers;
    if (!tmp0_isNotEmpty_0.isEmpty_0_k$())
      this._frameRenderBuffers.clear_sv8swh_k$();
    else {
    }
    this.flipInternal_sv8swh_k$();
  };
  AG.prototype.flipInternal_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  AG.prototype.startFrame_sv8swh_k$ = function () {
  };
  AG.prototype.clear_jnj4is_k$ = function (color_0, depth, stencil, clearColor, clearDepth, clearStencil) {
    return Unit_getInstance();
  };
  AG.prototype.clear$default_qpozyh_k$ = function (color_0, depth, stencil, clearColor, clearDepth, clearStencil, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      color_0 = Colors_getInstance()._TRANSPARENT_BLACK;
    if (!(($mask0 & 2) === 0))
      depth = 1.0;
    if (!(($mask0 & 4) === 0))
      stencil = 0;
    if (!(($mask0 & 8) === 0))
      clearColor = true;
    if (!(($mask0 & 16) === 0))
      clearDepth = true;
    if (!(($mask0 & 32) === 0))
      clearStencil = true;
    var tmp;
    if ($handler == null) {
      tmp = this.clear_jnj4is_k$(color_0, depth, stencil, clearColor, clearDepth, clearStencil);
    } else {
      var tmp_0 = color_0;
      tmp = $handler(tmp_0 == null ? null : new RGBA(tmp_0), depth, stencil, clearColor, clearDepth, clearStencil);
    }
    return tmp;
  };
  AG.prototype._get_currentRenderBuffer__0_k$ = function () {
    return this._currentRenderBuffer;
  };
  AG.prototype._get_renderingToTexture__0_k$ = function () {
    return !(this._currentRenderBuffer === this._get_mainRenderBuffer__0_k$()) ? !(this._currentRenderBuffer === null) : false;
  };
  AG.prototype.setRenderBuffer_rpvbnr_k$ = function (renderBuffer) {
    var old = this._currentRenderBuffer;
    var tmp0_safe_receiver = this._currentRenderBuffer;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.unset_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
    this._currentRenderBuffer = renderBuffer;
    var tmp1_safe_receiver = renderBuffer;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.set_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
    return old;
  };
  AG.$metadata$ = {
    simpleName: 'AG',
    kind: 'class',
    interfaces: [AGFeatures, Extra]
  };
  function toRenderFboIntoBack(_this_) {
    return _this_;
  }
  function toRenderImageIntoFbo(_this_) {
    return _this_;
  }
  function AGWindow() {
  }
  AGWindow.$metadata$ = {
    simpleName: 'AGWindow',
    kind: 'interface',
    interfaces: [AGContainer]
  };
  function AGConfig_init_$Init$(antialiasHint, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      antialiasHint = true;
    AGConfig.call($this, antialiasHint);
    return $this;
  }
  function AGConfig_init_$Create$(antialiasHint, $mask0, $marker) {
    return AGConfig_init_$Init$(antialiasHint, $mask0, $marker, Object.create(AGConfig.prototype));
  }
  function AGConfig(antialiasHint) {
    this._antialiasHint = antialiasHint;
  }
  AGConfig.prototype.toString = function () {
    return '' + 'AGConfig(antialiasHint=' + this._antialiasHint + ')';
  };
  AGConfig.prototype.hashCode = function () {
    return this._antialiasHint | 0;
  };
  AGConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this._antialiasHint === tmp0_other_with_cast._antialiasHint))
      return false;
    return true;
  };
  AGConfig.$metadata$ = {
    simpleName: 'AGConfig',
    kind: 'class',
    interfaces: []
  };
  function AGContainer() {
  }
  AGContainer.$metadata$ = {
    simpleName: 'AGContainer',
    kind: 'interface',
    interfaces: []
  };
  function mainRenderBuffer$factory() {
    return getPropertyCallableRef('mainRenderBuffer', 1, KProperty1, function (receiver) {
      return receiver._get_mainRenderBuffer__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_242(this$0) {
    var i = new _no_name_provided__298(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_243(this$0) {
    var i = new _no_name_provided__299(this$0);
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_244(this$0) {
    var i = new _no_name_provided__300(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_245(this$0) {
    var i = new _no_name_provided__301(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_246(this$0) {
    var i = new _no_name_provided__302(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_247() {
    var i = new _no_name_provided__293();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_248($bmp) {
    var i = new _no_name_provided__294($bmp);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_249(this$0, $source, resultContinuation) {
    var i = new _no_name_provided__295(this$0, $source, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_250() {
    var i = new _no_name_provided__296();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_251() {
    var i = new _no_name_provided__297();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__303() {
  }
  _no_name_provided__303.prototype.invoke_dzcoxa_k$ = function ($this$VertexShader) {
    $this$VertexShader.SET_k3gp7z_k$(DefaultShaders_getInstance()._v_Tex, DefaultShaders_getInstance()._a_Tex);
    $this$VertexShader.SET_k3gp7z_k$(DefaultShaders_getInstance()._v_Col, DefaultShaders_getInstance()._a_Col);
    $this$VertexShader.SET_k3gp7z_k$($this$VertexShader._out_8, $this$VertexShader.times_l29sts_k$($this$VertexShader.times_l29sts_k$(DefaultShaders_getInstance()._u_ProjMat, DefaultShaders_getInstance()._u_ViewMat), $this$VertexShader.vec4_ldyooh_k$([DefaultShaders_getInstance()._a_Pos, $this$VertexShader._get_lit__a9njmo_k$(0.0), $this$VertexShader._get_lit__a9njmo_k$(1.0)])));
  };
  _no_name_provided__303.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__303.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__304() {
  }
  _no_name_provided__304.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    $this$FragmentShader.set_ag43kx_k$($this$FragmentShader._out_8, $this$FragmentShader.vec4_ldyooh_k$([$this$FragmentShader._get_lit__a9njmo_k$(1.0), $this$FragmentShader._get_lit__a9njmo_k$(1.0), $this$FragmentShader._get_lit__a9njmo_k$(0.0), $this$FragmentShader._get_lit__a9njmo_k$(1.0)]));
  };
  _no_name_provided__304.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__304.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__305() {
  }
  _no_name_provided__305.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    $this$FragmentShader.set_ag43kx_k$($this$FragmentShader._out_8, DefaultShaders_getInstance()._v_Col);
  };
  _no_name_provided__305.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__305.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__306() {
  }
  _no_name_provided__306.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    $this$FragmentShader.SET_k3gp7z_k$($this$FragmentShader._out_8, $this$FragmentShader.times_l29sts_k$($this$FragmentShader.get_v2sg9q_k$($this$FragmentShader.texture2D_s4jwrm_k$(DefaultShaders_getInstance()._u_Tex, $this$FragmentShader.get_v2sg9q_k$(DefaultShaders_getInstance()._v_Tex, 'xy')), 'rgba'), DefaultShaders_getInstance()._v_Col));
  };
  _no_name_provided__306.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__306.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__307() {
  }
  _no_name_provided__307.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    $this$FragmentShader.SET_k3gp7z_k$(DefaultShaders_getInstance()._t_Temp0, $this$FragmentShader.texture2D_s4jwrm_k$(DefaultShaders_getInstance()._u_Tex, $this$FragmentShader.get_v2sg9q_k$(DefaultShaders_getInstance()._v_Tex, 'xy')));
    $this$FragmentShader.SET_k3gp7z_k$($this$FragmentShader.get_v2sg9q_k$(DefaultShaders_getInstance()._t_Temp0, 'rgb'), $this$FragmentShader.div_l29sts_k$($this$FragmentShader.get_v2sg9q_k$(DefaultShaders_getInstance()._t_Temp0, 'rgb'), $this$FragmentShader.get_v2sg9q_k$(DefaultShaders_getInstance()._t_Temp0, 'a')));
    $this$FragmentShader.SET_k3gp7z_k$($this$FragmentShader._out_8, $this$FragmentShader.times_l29sts_k$($this$FragmentShader.get_v2sg9q_k$(DefaultShaders_getInstance()._t_Temp0, 'rgba'), DefaultShaders_getInstance()._v_Col));
  };
  _no_name_provided__307.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__307.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__308() {
  }
  _no_name_provided__308.prototype.invoke_dzcoxa_k$ = function ($this$VertexShader) {
    $this$VertexShader.SET_k3gp7z_k$($this$VertexShader._out_8, $this$VertexShader.vec4_ldyooh_k$([DefaultShaders_getInstance()._a_Pos, $this$VertexShader._get_lit__a9njmo_k$(0.0), $this$VertexShader._get_lit__a9njmo_k$(1.0)]));
  };
  _no_name_provided__308.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__308.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__309() {
  }
  _no_name_provided__309.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    $this$FragmentShader.set_ag43kx_k$($this$FragmentShader._out_8, $this$FragmentShader.vec4_ldyooh_k$([$this$FragmentShader._get_lit__a9njmo_k$(1.0), $this$FragmentShader._get_lit__a9njmo_k$(0.0), $this$FragmentShader._get_lit__a9njmo_k$(0.0), $this$FragmentShader._get_lit__a9njmo_k$(1.0)]));
  };
  _no_name_provided__309.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__309.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__310() {
  }
  _no_name_provided__310.prototype.invoke_dzcoxa_k$ = function ($this$VertexShader) {
    $this$VertexShader.SET_k3gp7z_k$($this$VertexShader._out_8, $this$VertexShader.times_l29sts_k$(DefaultShaders_getInstance()._u_ProjMat, $this$VertexShader.vec4_ldyooh_k$([DefaultShaders_getInstance()._a_Pos, $this$VertexShader._get_lit__a9njmo_k$(0.0), $this$VertexShader._get_lit__a9njmo_k$(1.0)])));
  };
  _no_name_provided__310.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__310.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__311() {
  }
  _no_name_provided__311.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    $this$FragmentShader.SET_k3gp7z_k$($this$FragmentShader._out_8, $this$FragmentShader.vec4_ldyooh_k$([$this$FragmentShader._get_lit__a9njmo_k$(1.0), $this$FragmentShader._get_lit__a9njmo_k$(0.0), $this$FragmentShader._get_lit__a9njmo_k$(0.0), $this$FragmentShader._get_lit__a9njmo_k$(1.0)]));
  };
  _no_name_provided__311.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__311.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__312() {
  }
  _no_name_provided__312.prototype.invoke_0_k$ = function () {
    return DefaultShaders_getInstance()._PROGRAM_TINTED_TEXTURE_PREMULT;
  };
  _no_name_provided__312.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function DefaultShaders() {
    DefaultShaders_instance = this;
    var tmp = this;
    var tmp_0 = VarType_TextureUnit_getInstance();
    tmp._u_Tex = Uniform_init_$Create$('u_Tex', tmp_0, null, 4, null);
    var tmp_1 = this;
    var tmp_2 = VarType_Mat4_getInstance();
    tmp_1._u_ProjMat = Uniform_init_$Create$('u_ProjMat', tmp_2, null, 4, null);
    var tmp_3 = this;
    var tmp_4 = VarType_Mat4_getInstance();
    tmp_3._u_ViewMat = Uniform_init_$Create$('u_ViewMat', tmp_4, null, 4, null);
    this._a_Pos = Attribute_init_$Create$('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance());
    this._a_Tex = Attribute_init_$Create$('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance());
    this._a_Col = Attribute_init_$Create$('a_Col', VarType_Byte4_getInstance(), true, Precision_LOW_getInstance());
    this._v_Tex = Varying_init_$Create$('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    var tmp_5 = this;
    var tmp_6 = VarType_Byte4_getInstance();
    tmp_5._v_Col = Varying_init_$Create$_0('v_Col', tmp_6, null, 4, null);
    var tmp_7 = this;
    var tmp_8 = VarType_Float4_getInstance();
    tmp_7._t_Temp0 = Temp_init_$Create$(0, tmp_8, null, 4, null);
    var tmp_9 = this;
    var tmp_10 = VarType_Float4_getInstance();
    tmp_9._t_Temp1 = Temp_init_$Create$(1, tmp_10, null, 4, null);
    var tmp_11 = this;
    var tmp_12 = VarType_Mat2_getInstance();
    tmp_11._t_TempMat2 = Temp_init_$Create$(2, tmp_12, null, 4, null);
    var tmp_13 = this;
    tmp_13._textureUnit = TextureUnit_init_$Create$(null, false, 3, null);
    this._LAYOUT_DEFAULT = VertexLayout_init_$Create$([this._a_Pos, this._a_Tex, this._a_Col]);
    var tmp_14 = this;
    tmp_14._VERTEX_DEFAULT = VertexShader_0(_no_name_provided_$factory_252());
    var tmp_15 = this;
    tmp_15._FRAGMENT_DEBUG = FragmentShader_0(_no_name_provided_$factory_253());
    var tmp_16 = this;
    tmp_16._FRAGMENT_SOLID_COLOR = FragmentShader_0(_no_name_provided_$factory_254());
    var tmp_17 = this;
    tmp_17._PROGRAM_TINTED_TEXTURE = new Program(this._VERTEX_DEFAULT, FragmentShader_0(_no_name_provided_$factory_255()), 'PROGRAM_TINTED_TEXTURE');
    var tmp_18 = this;
    tmp_18._PROGRAM_TINTED_TEXTURE_PREMULT = new Program(this._VERTEX_DEFAULT, FragmentShader_0(_no_name_provided_$factory_256()), 'PROGRAM_TINTED_TEXTURE');
    this._PROGRAM_SOLID_COLOR = new Program(this._VERTEX_DEFAULT, this._FRAGMENT_SOLID_COLOR, 'PROGRAM_SOLID_COLOR');
    this._LAYOUT_DEBUG = VertexLayout_init_$Create$([this._a_Pos]);
    var tmp_19 = this;
    var tmp_20 = VertexShader_0(_no_name_provided_$factory_257());
    tmp_19._PROGRAM_DEBUG = new Program(tmp_20, FragmentShader_0(_no_name_provided_$factory_258()), 'PROGRAM_DEBUG');
    var tmp_21 = this;
    var tmp_22 = VertexShader_0(_no_name_provided_$factory_259());
    tmp_21._PROGRAM_DEBUG_WITH_PROJ = new Program(tmp_22, FragmentShader_0(_no_name_provided_$factory_260()), 'PROGRAM_DEBUG_WITH_PROJ');
    var tmp_23 = this;
    tmp_23._PROGRAM_DEFAULT$delegate = lazy(_no_name_provided_$factory_261());
  }
  DefaultShaders.$metadata$ = {
    simpleName: 'DefaultShaders',
    kind: 'object',
    interfaces: []
  };
  var DefaultShaders_instance;
  function DefaultShaders_getInstance() {
    if (DefaultShaders_instance == null)
      new DefaultShaders();
    return DefaultShaders_instance;
  }
  function _no_name_provided_$factory_252() {
    var i = new _no_name_provided__303();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_253() {
    var i = new _no_name_provided__304();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_254() {
    var i = new _no_name_provided__305();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_255() {
    var i = new _no_name_provided__306();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_256() {
    var i = new _no_name_provided__307();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_257() {
    var i = new _no_name_provided__308();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_258() {
    var i = new _no_name_provided__309();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_259() {
    var i = new _no_name_provided__310();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_260() {
    var i = new _no_name_provided__311();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_261() {
    var i = new _no_name_provided__312();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function ForcedTexId() {
  }
  ForcedTexId.$metadata$ = {
    simpleName: 'ForcedTexId',
    kind: 'interface',
    interfaces: []
  };
  function ForcedTexTarget() {
  }
  ForcedTexTarget.$metadata$ = {
    simpleName: 'ForcedTexTarget',
    kind: 'interface',
    interfaces: []
  };
  function _get_versionString_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = versionString$factory();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = versionString$delegate._name_1;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = versionString$delegate._defaultGen_0(_this_);
        if (_this_._get_extra__0_k$() == null)
          _this_._set_extra__n1onou_k$(ExtraTypeCreate());
        var tmp1_safe_receiver_1_7 = _this_._get_extra__0_k$();
        if (tmp1_safe_receiver_1_7 == null)
          null;
        else {
          var tmp0_elvis_lhs_2_9 = versionString$delegate._name_1;
          var tmp2_set_0_8 = tmp0_elvis_lhs_2_9 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_2_9;
          var tmp3_set_0_10 = r_6;
          tmp1_safe_receiver_1_7.set(tmp2_set_0_8, tmp3_set_0_10);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var versionString$delegate;
  function _get_versionInt_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = versionInt$factory();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = versionInt$delegate._name_1;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = versionInt$delegate._defaultGen_0(_this_);
        if (_this_._get_extra__0_k$() == null)
          _this_._set_extra__n1onou_k$(ExtraTypeCreate());
        var tmp1_safe_receiver_1_7 = _this_._get_extra__0_k$();
        if (tmp1_safe_receiver_1_7 == null)
          null;
        else {
          var tmp0_elvis_lhs_2_9 = versionInt$delegate._name_1;
          var tmp2_set_0_8 = tmp0_elvis_lhs_2_9 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_2_9;
          var tmp3_set_0_10 = r_6;
          tmp1_safe_receiver_1_7.set(tmp2_set_0_8, tmp3_set_0_10);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var versionInt$delegate;
  function ensure_2($this) {
    if (!($this._cachedVersion_0 === $this._$this_21._get_contextVersion__0_k$())) {
      var start_1 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
      var oldCachedVersion_5 = $this._cachedVersion_0;
      $this._cachedVersion_0 = $this._$this_21._get_contextVersion__0_k$();
      $this._id_11 = $this._gl_0.createProgram_0_k$();
      if (Companion_getInstance_166()._get_DEBUG_GLSL__0_k$()) {
        Console_getInstance().warn_c2g51s_k$(['' + 'OpenglAG: Creating program ' + $this._program_1._name_22 + ' with id ' + $this._id_11 + ' because contextVersion: ' + oldCachedVersion_5 + ' != ' + $this._$this_21._get_contextVersion__0_k$()]);
      }var tmp0_elvis_lhs_7 = $this._$this_21._get_glSlVersion__0_k$();
      var guessedGlSlVersion_6 = tmp0_elvis_lhs_7 == null ? _get_versionInt_($this._gl_0) : tmp0_elvis_lhs_7;
      var tmp1_safe_receiver_10 = Companion_getInstance_166()._get_FORCE_GLSL_VERSION__0_k$();
      var tmp3_elvis_lhs_9 = tmp1_safe_receiver_10 == null ? null : toIntOrNull(tmp1_safe_receiver_10);
      var tmp;
      if (tmp3_elvis_lhs_9 == null) {
        var tmp2_subject_11 = guessedGlSlVersion_6;
        tmp = tmp2_subject_11 === 460 ? 460 : (300 <= tmp2_subject_11 ? tmp2_subject_11 <= 450 : false) ? 100 : guessedGlSlVersion_6;
      } else {
        tmp = tmp3_elvis_lhs_9;
      }
      var usedGlSlVersion_8 = tmp;
      if (Companion_getInstance_166()._get_DEBUG_GLSL__0_k$()) {
        Console_getInstance().trace_c2g51s_k$(['' + 'GLSL version: requested=' + $this._$this_21._get_glSlVersion__0_k$() + ', guessed=' + guessedGlSlVersion_6 + ', forced=' + Companion_getInstance_166()._get_FORCE_GLSL_VERSION__0_k$() + '. used=' + usedGlSlVersion_8]);
      }var tmp_0 = $this;
      var tmp0_createShaderCompat_0_12 = $this._gl_0._FRAGMENT_SHADER;
      var tmp_1;
      try {
        tmp_1 = createShader($this, tmp0_createShaderCompat_0_12, toNewGlslStringResult($this._program_1._fragment_0, new GlslConfig($this._$this_21._get_gles__0_k$(), usedGlSlVersion_8, true, $this._$this_21._get_android__0_k$(), $this._programConfig))._result_4);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof ShaderException) {
          tmp_2 = createShader($this, tmp0_createShaderCompat_0_12, toNewGlslStringResult($this._program_1._fragment_0, new GlslConfig($this._$this_21._get_gles__0_k$(), usedGlSlVersion_8, false, $this._$this_21._get_android__0_k$(), $this._programConfig))._result_4);
        } else {
          {
            throw $p;
          }
        }
        tmp_1 = tmp_2;
      }
      tmp_0._fragmentShaderId = tmp_1;
      var tmp_3 = $this;
      var tmp1_createShaderCompat_0_14 = $this._gl_0._VERTEX_SHADER;
      var tmp_4;
      try {
        tmp_4 = createShader($this, tmp1_createShaderCompat_0_14, toNewGlslStringResult($this._program_1._vertex, new GlslConfig($this._$this_21._get_gles__0_k$(), usedGlSlVersion_8, true, $this._$this_21._get_android__0_k$(), $this._programConfig))._result_4);
      } catch ($p_0) {
        var tmp_5;
        if ($p_0 instanceof ShaderException) {
          tmp_5 = createShader($this, tmp1_createShaderCompat_0_14, toNewGlslStringResult($this._program_1._vertex, new GlslConfig($this._$this_21._get_gles__0_k$(), usedGlSlVersion_8, false, $this._$this_21._get_android__0_k$(), $this._programConfig))._result_4);
        } else {
          {
            throw $p_0;
          }
        }
        tmp_4 = tmp_5;
      }
      tmp_3._vertexShaderId = tmp_4;
      $this._gl_0.attachShader_rvwcgf_k$($this._id_11, $this._fragmentShaderId);
      $this._gl_0.attachShader_rvwcgf_k$($this._id_11, $this._vertexShaderId);
      $this._gl_0.linkProgram_majfzk_k$($this._id_11);
      $this._$this_21._tempBuffer1.setInt_rvwcgf_k$(0, 0);
      $this._gl_0.getProgramiv_1a3fjs_k$($this._id_11, $this._gl_0._LINK_STATUS, $this._$this_21._tempBuffer1);
      var end_2 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
      var tmp0__get_microseconds__0_3 = end_2 - start_1;
      var time = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3);
      if (Companion_getInstance_166()._get_DEBUG_GLSL__0_k$()) {
        Console_getInstance().info_c2g51s_k$(['' + 'OpenglAG: Created program ' + $this._program_1._name_22 + ' with id ' + $this._id_11 + ' in time=' + new TimeSpan(time)]);
      }}}
  function createShader($this, type, str) {
    var shaderId = $this._gl_0.createShader_ha5a7z_k$(type);
    $this._gl_0.shaderSource_iyywcx_k$(shaderId, str);
    $this._gl_0.compileShader_majfzk_k$(shaderId);
    var out = getShaderiv($this._gl_0, shaderId, $this._gl_0._COMPILE_STATUS);
    var errorInt = $this._gl_0.getError_0_k$();
    if (!(out === $this._gl_0._GTRUE)) {
      var error = getShaderInfoLog($this._gl_0, shaderId);
      throw new ShaderException(str, error, errorInt, $this._gl_0);
    }return shaderId;
  }
  function setWrapST($this) {
    $this._gl_1.texParameteri_zd700_k$($this._forcedTexTarget, $this._gl_1._TEXTURE_WRAP_S, $this._gl_1._CLAMP_TO_EDGE);
    $this._gl_1.texParameteri_zd700_k$($this._forcedTexTarget, $this._gl_1._TEXTURE_WRAP_T, $this._gl_1._CLAMP_TO_EDGE);
  }
  function setMinMag($this, min_0, mag) {
    $this._gl_1.texParameteri_zd700_k$($this._forcedTexTarget, $this._gl_1._TEXTURE_MIN_FILTER, min_0);
    $this._gl_1.texParameteri_zd700_k$($this._forcedTexTarget, $this._gl_1._TEXTURE_MAG_FILTER, mag);
  }
  function ShaderException(str, error, errorInt, gl) {
    RuntimeException_init_$Init$_0('' + 'Error Compiling Shader : ' + _get_hex_(errorInt) + " : '" + error + "' : source='" + str + "', gl.versionInt=" + _get_versionInt_(gl) + ", gl.versionString='" + _get_versionString_(gl) + "', gl=" + gl, this);
    this._str_4 = str;
    this._error = error;
    this._errorInt = errorInt;
    this._gl = gl;
    captureStack(this, ShaderException);
  }
  ShaderException.$metadata$ = {
    simpleName: 'ShaderException',
    kind: 'class',
    interfaces: []
  };
  function setViewport($this, buffer) {
    $this._get_gl__0_k$().viewport_jthg1_k$(buffer._get_x__0_k$(), buffer._get_y__0_k$(), buffer._get_width__0_k$(), buffer._get_height__0_k$());
  }
  function GlRenderBuffer($outer) {
    this._$this_20 = $outer;
    RenderBuffer.call(this, $outer);
    this._cachedVersion = -1;
    var tmp = this;
    var tmp0_this = this._$this_20;
    var tmp1 = tmp0_this._lastRenderContextId;
    tmp0_this._lastRenderContextId = tmp1 + 1 | 0;
    tmp._id_10 = tmp1;
    this._depth = Companion_getInstance_97().invoke_ha5a7z_k$(4);
    this._framebuffer = Companion_getInstance_97().invoke_ha5a7z_k$(4);
  }
  GlRenderBuffer.prototype._get_ftex__0_k$ = function () {
    var tmp = this._get_tex__0_k$();
    return tmp instanceof GlTexture ? tmp : THROW_CCE();
  };
  GlRenderBuffer.prototype.set_sv8swh_k$ = function () {
    setViewport(this._$this_20, this);
    if (this._get_dirty__0_k$()) {
      this._set_dirty__rpwsgn_k$(false);
      this._$this_20.setSwapInterval_majfzk_k$(0);
      if (!(this._cachedVersion === this._$this_20._get_contextVersion__0_k$())) {
        this._cachedVersion = this._$this_20._get_contextVersion__0_k$();
        this._$this_20._get_gl__0_k$().genRenderbuffers_9vfq5l_k$(1, this._depth);
        this._$this_20._get_gl__0_k$().genFramebuffers_9vfq5l_k$(1, this._framebuffer);
      }this._$this_20._get_gl__0_k$().bindTexture_rvwcgf_k$(this._$this_20._get_gl__0_k$()._TEXTURE_2D, this._get_ftex__0_k$()._get_tex__0_k$());
      this._$this_20._get_gl__0_k$().texParameteri_zd700_k$(this._$this_20._get_gl__0_k$()._TEXTURE_2D, this._$this_20._get_gl__0_k$()._TEXTURE_MAG_FILTER, this._$this_20._get_gl__0_k$()._LINEAR);
      this._$this_20._get_gl__0_k$().texParameteri_zd700_k$(this._$this_20._get_gl__0_k$()._TEXTURE_2D, this._$this_20._get_gl__0_k$()._TEXTURE_MIN_FILTER, this._$this_20._get_gl__0_k$()._LINEAR);
      this._$this_20._get_gl__0_k$().texImage2D_p2mxp1_k$(this._$this_20._get_gl__0_k$()._TEXTURE_2D, 0, this._$this_20._get_gl__0_k$()._RGBA, this._get_width__0_k$(), this._get_height__0_k$(), 0, this._$this_20._get_gl__0_k$()._RGBA, this._$this_20._get_gl__0_k$()._UNSIGNED_BYTE, null);
      this._$this_20._get_gl__0_k$().bindTexture_rvwcgf_k$(this._$this_20._get_gl__0_k$()._TEXTURE_2D, 0);
      this._$this_20._get_gl__0_k$().bindRenderbuffer_rvwcgf_k$(this._$this_20._get_gl__0_k$()._RENDERBUFFER, this._depth.getInt_ha5a7z_k$(0));
      this._$this_20._get_gl__0_k$().renderbufferStorage_jthg1_k$(this._$this_20._get_gl__0_k$()._RENDERBUFFER, this._$this_20._get_gl__0_k$()._DEPTH_COMPONENT16, this._get_width__0_k$(), this._get_height__0_k$());
    }this._$this_20._get_gl__0_k$().bindFramebuffer_rvwcgf_k$(this._$this_20._get_gl__0_k$()._FRAMEBUFFER, this._framebuffer.getInt_ha5a7z_k$(0));
    this._$this_20._get_gl__0_k$().framebufferTexture2D_s9wiz4_k$(this._$this_20._get_gl__0_k$()._FRAMEBUFFER, this._$this_20._get_gl__0_k$()._COLOR_ATTACHMENT0, this._$this_20._get_gl__0_k$()._TEXTURE_2D, this._get_ftex__0_k$()._get_tex__0_k$(), 0);
    this._$this_20._get_gl__0_k$().framebufferRenderbuffer_jthg1_k$(this._$this_20._get_gl__0_k$()._FRAMEBUFFER, this._$this_20._get_gl__0_k$()._DEPTH_ATTACHMENT, this._$this_20._get_gl__0_k$()._RENDERBUFFER, this._depth.getInt_ha5a7z_k$(0));
  };
  GlRenderBuffer.prototype.close_sv8swh_k$ = function () {
    var tmp0_apply_0 = this._$this_20._get_gl__0_k$();
    tmp0_apply_0.deleteFramebuffers_9vfq5l_k$(1, this._framebuffer);
    tmp0_apply_0.deleteRenderbuffers_9vfq5l_k$(1, this._depth);
    this._framebuffer.setInt_rvwcgf_k$(0, 0);
    this._depth.setInt_rvwcgf_k$(0, 0);
    Unit_getInstance();
  };
  GlRenderBuffer.prototype.toString = function () {
    return '' + 'GlRenderBuffer[' + this._id_10 + '](' + this._get_width__0_k$() + ', ' + this._get_height__0_k$() + ')';
  };
  GlRenderBuffer.$metadata$ = {
    simpleName: 'GlRenderBuffer',
    kind: 'class',
    interfaces: []
  };
  function toGl(_this_, $this) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject.equals(BlendEquation_ADD_getInstance())) {
      tmp = $this._get_gl__0_k$()._FUNC_ADD;
    } else if (tmp0_subject.equals(BlendEquation_SUBTRACT_getInstance())) {
      tmp = $this._get_gl__0_k$()._FUNC_SUBTRACT;
    } else if (tmp0_subject.equals(BlendEquation_REVERSE_SUBTRACT_getInstance())) {
      tmp = $this._get_gl__0_k$()._FUNC_REVERSE_SUBTRACT;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function toGl_0(_this_, $this) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject.equals(BlendFactor_DESTINATION_ALPHA_getInstance())) {
      tmp = $this._get_gl__0_k$()._DST_ALPHA;
    } else if (tmp0_subject.equals(BlendFactor_DESTINATION_COLOR_getInstance())) {
      tmp = $this._get_gl__0_k$()._DST_COLOR;
    } else if (tmp0_subject.equals(BlendFactor_ONE_getInstance())) {
      tmp = $this._get_gl__0_k$()._ONE;
    } else if (tmp0_subject.equals(BlendFactor_ONE_MINUS_DESTINATION_ALPHA_getInstance())) {
      tmp = $this._get_gl__0_k$()._ONE_MINUS_DST_ALPHA;
    } else if (tmp0_subject.equals(BlendFactor_ONE_MINUS_DESTINATION_COLOR_getInstance())) {
      tmp = $this._get_gl__0_k$()._ONE_MINUS_DST_COLOR;
    } else if (tmp0_subject.equals(BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance())) {
      tmp = $this._get_gl__0_k$()._ONE_MINUS_SRC_ALPHA;
    } else if (tmp0_subject.equals(BlendFactor_ONE_MINUS_SOURCE_COLOR_getInstance())) {
      tmp = $this._get_gl__0_k$()._ONE_MINUS_SRC_COLOR;
    } else if (tmp0_subject.equals(BlendFactor_SOURCE_ALPHA_getInstance())) {
      tmp = $this._get_gl__0_k$()._SRC_ALPHA;
    } else if (tmp0_subject.equals(BlendFactor_SOURCE_COLOR_getInstance())) {
      tmp = $this._get_gl__0_k$()._SRC_COLOR;
    } else if (tmp0_subject.equals(BlendFactor_ZERO_getInstance())) {
      tmp = $this._get_gl__0_k$()._ZERO_1;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function GlProgram($outer, gl, program, programConfig) {
    this._$this_21 = $outer;
    this._gl_0 = gl;
    this._program_1 = program;
    this._programConfig = programConfig;
    this._cachedVersion_0 = -1;
    this._id_11 = 0;
    this._fragmentShaderId = 0;
    this._vertexShaderId = 0;
    this._cachedAttribLocations = FastStringMap();
  }
  GlProgram.prototype.getAttribLocation_6wfw3l_k$ = function (name) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getOrPut_0 = this._cachedAttribLocations;
      var res_1 = tmp0_getOrPut_0.get(name);
      if (!(res_1 == null)) {
        tmp$ret$0 = res_1;
        break l$ret$1;
      }var out_2 = this._gl_0.getAttribLocation_4wk0sg_k$(this._id_11, name);
      tmp0_getOrPut_0.set(name, out_2);
      tmp$ret$0 = out_2;
    }
     while (false);
    return tmp$ret$0;
  };
  GlProgram.prototype.use_sv8swh_k$ = function () {
    ensure_2(this);
    this._gl_0.useProgram_majfzk_k$(this._id_11);
  };
  GlProgram.prototype.close_sv8swh_k$ = function () {
    this._gl_0.deleteShader_majfzk_k$(this._fragmentShaderId);
    this._gl_0.deleteShader_majfzk_k$(this._vertexShaderId);
    this._gl_0.deleteProgram_majfzk_k$(this._id_11);
  };
  GlProgram.$metadata$ = {
    simpleName: 'GlProgram',
    kind: 'class',
    interfaces: [Closeable]
  };
  function GlBuffer($outer, kind) {
    this._$this_22 = $outer;
    Buffer.call(this, kind);
    this._cachedVersion_1 = -1;
    this._id_12 = -1;
    this._glKind = kind.equals(Kind_INDEX_getInstance()) ? this._$this_22._get_gl__0_k$()._ELEMENT_ARRAY_BUFFER : this._$this_22._get_gl__0_k$()._ARRAY_BUFFER;
  }
  GlBuffer.prototype.afterSetMem_sv8swh_k$ = function () {
  };
  GlBuffer.prototype.close_sv8swh_k$ = function () {
    var tmp0_run_0_1 = Companion_getInstance_97().invoke_ha5a7z_k$(4);
    tmp0_run_0_1.setInt_rvwcgf_k$(0, this._id_12);
    this._$this_22._get_gl__0_k$().deleteBuffers_9vfq5l_k$(1, tmp0_run_0_1);
    this._id_12 = -1;
  };
  GlBuffer.prototype.getGlId_3h8fba_k$ = function (gl) {
    if (!(this._cachedVersion_1 === this._$this_22._get_contextVersion__0_k$())) {
      this._cachedVersion_1 = this._$this_22._get_contextVersion__0_k$();
      this._set_dirty__rpwsgn_k$(true);
      this._id_12 = -1;
    }if (this._id_12 < 0) {
      var tmp = this;
      var tmp0_run_0_1 = Companion_getInstance_97().invoke_ha5a7z_k$(4);
      gl.genBuffers_9vfq5l_k$(1, tmp0_run_0_1);
      tmp._id_12 = tmp0_run_0_1.getInt_ha5a7z_k$(0);
    }if (this._get_dirty__0_k$()) {
      this._bind_ykl8fq_k$(gl, this._id_12);
      if (!(this._get_mem__0_k$() == null)) {
        gl.bufferData_tov2rt_k$(this._glKind, this._get_memLength__0_k$(), ensureNotNull(this._get_mem__0_k$()), gl._STATIC_DRAW);
      }}return this._id_12;
  };
  GlBuffer.prototype._bind_ykl8fq_k$ = function (gl, id) {
    gl.bindBuffer_rvwcgf_k$(this._glKind, id);
  };
  GlBuffer.prototype.bind_c8ca1_k$ = function (gl) {
    this._bind_ykl8fq_k$(gl, this.getGlId_3h8fba_k$(gl));
  };
  GlBuffer.$metadata$ = {
    simpleName: 'GlBuffer',
    kind: 'class',
    interfaces: []
  };
  function GlTexture($outer, gl, premultiplied) {
    this._$this_23 = $outer;
    Texture.call(this, $outer);
    this._gl_1 = gl;
    this._premultiplied_10 = premultiplied;
    this._cachedVersion_2 = -1;
    this._texIds = Companion_getInstance_97().invoke_ha5a7z_k$(4);
    this._forcedTexId = -1;
    this._forcedTexTarget = this._gl_1._TEXTURE_2D;
    this._GL_RGBA32F = 34836;
    this._GL_UNPACK_ALIGNMENT = 3317;
    this._GL_UNPACK_LSB_FIRST = 3313;
    this._GL_UNPACK_ROW_LENGTH = 3314;
    this._GL_UNPACK_SKIP_PIXELS = 3316;
    this._GL_UNPACK_SKIP_ROWS = 3315;
    this._GL_UNPACK_SWAP_BYTES = 3312;
    this._closed_6 = false;
  }
  GlTexture.prototype._get_premultiplied__0_k$ = function () {
    return this._premultiplied_10;
  };
  GlTexture.prototype._get_tex__0_k$ = function () {
    if (this._forcedTexId >= 0)
      return this._forcedTexId;
    if (!(this._cachedVersion_2 === this._$this_23._get_contextVersion__0_k$())) {
      this._cachedVersion_2 = this._$this_23._get_contextVersion__0_k$();
      this.invalidate_sv8swh_k$();
      this._gl_1.genTextures_9vfq5l_k$(1, this._texIds);
    }return this._texIds.getInt_ha5a7z_k$(0);
  };
  GlTexture.prototype.createBufferForBitmap_d898uc_k$ = function (bmp) {
    var tmp0_subject = bmp;
    var tmp;
    if (tmp0_subject == null) {
      tmp = null;
    } else {
      if (tmp0_subject instanceof NativeImage) {
        unsupported_1('Should not call createBufferForBitmap with a NativeImage');
      } else {
        if (tmp0_subject instanceof Bitmap8) {
          var tmp0_also_0 = Companion_getInstance_97().invoke_ha5a7z_k$(bmp._get_area__0_k$());
          arraycopy_16(bmp._get_data__0_k$(), 0, tmp0_also_0._arrayByte, 0, bmp._get_area__0_k$());
          tmp = tmp0_also_0;
        } else {
          if (tmp0_subject instanceof FloatBitmap32) {
            var tmp1_also_0 = Companion_getInstance_97().invoke_ha5a7z_k$(imul(imul(bmp._get_area__0_k$(), 4), 4));
            arraycopy_17(bmp._data_27, 0, tmp1_also_0._arrayFloat, 0, imul(bmp._get_area__0_k$(), 4));
            tmp = tmp1_also_0;
          } else {
            {
              var tmp2_also_0 = Companion_getInstance_97().invoke_ha5a7z_k$(imul(bmp._get_area__0_k$(), 4));
              var abmp_2 = this._premultiplied_10 ? bmp.toBMP32IfRequired_0_k$().premultipliedIfRequired_0_k$() : bmp.toBMP32IfRequired_0_k$().depremultipliedIfRequired_0_k$();
              arraycopy_18(_RgbaArray___get_ints__impl_(abmp_2._data_25), 0, tmp2_also_0._arrayInt, 0, abmp_2._get_area__0_k$());
              tmp = tmp2_also_0;
            }
          }
        }
      }
    }
    return tmp;
  };
  GlTexture.prototype.actualSyncUpload_237s55_k$ = function (source, bmp, requestMipmaps) {
    this._set_mipmaps__rpwsgn_k$(false);
    var bytesPerPixel = source._get_rgba__0_k$() ? 4 : 1;
    var tmp;
    if (source._get_rgba__0_k$()) {
      tmp = this._gl_1._RGBA;
    } else {
      tmp = this._gl_1._LUMINANCE;
    }
    var type = tmp;
    var isFloat = bmp instanceof FloatBitmap32;
    var tmp0_subject = bmp;
    var tmp_0;
    if (tmp0_subject instanceof BitmapVector) {
      tmp_0 = bmp._get_nativeImage__0_k$();
    } else {
      {
        tmp_0 = bmp;
      }
    }
    var bmp_0 = tmp_0;
    var tmp1_subject = bmp_0;
    if (!(tmp1_subject == null) ? isInterface(tmp1_subject, ForcedTexId) : false) {
      this._forcedTexId = bmp_0._get_forcedTexId__0_k$();
      if (!(bmp_0 == null) ? isInterface(bmp_0, ForcedTexTarget) : false)
        this._forcedTexTarget = bmp_0._get_forcedTexTarget__0_k$();
      else {
      }
      return Unit_getInstance();
    } else {
      if (tmp1_subject instanceof NativeImage) {
        if (!(bmp_0._get_forcedTexId__0_k$() === -1)) {
          this._forcedTexId = bmp_0._get_forcedTexId__0_k$();
          if (!(bmp_0._get_forcedTexTarget__0_k$() === -1))
            this._forcedTexTarget = bmp_0._get_forcedTexTarget__0_k$();
          return Unit_getInstance();
        }this._$this_23.prepareUploadNativeTexture_nm2sef_k$(bmp_0);
        if (!(bmp_0._get_area__0_k$() === 0)) {
          this.prepareTexImage2D_sv8swh_k$();
          this._gl_1.texImage2D_4xnpxk_k$(this._forcedTexTarget, 0, type, type, this._gl_1._UNSIGNED_BYTE, bmp_0);
        }} else {
        {
          var buffer = this.createBufferForBitmap_d898uc_k$(bmp_0);
          if (((!(buffer == null) ? !(source._get_width__0_k$() === 0) : false) ? !(source._get_height__0_k$() === 0) : false) ? !(buffer._size_6 === 0) : false) {
            this.prepareTexImage2D_sv8swh_k$();
            var internalFormat = (isFloat ? this._$this_23._get_webgl2__0_k$() ? true : !this._$this_23._get_webgl__0_k$() : false) ? this._GL_RGBA32F : type;
            var format_0 = type;
            var texType = isFloat ? this._gl_1._FLOAT : this._gl_1._UNSIGNED_BYTE;
            this._gl_1.texImage2D_p2mxp1_k$(this._forcedTexTarget, 0, internalFormat, source._get_width__0_k$(), source._get_height__0_k$(), 0, format_0, texType, buffer);
          }}
      }
    }
    if ((requestMipmaps ? _get_isPowerOfTwo_(source._get_width__0_k$()) : false) ? _get_isPowerOfTwo_(source._get_height__0_k$()) : false) {
      this._set_mipmaps__rpwsgn_k$(true);
      this.bind_sv8swh_k$();
      this.setFilter_rpwsgn_k$(true);
      setWrapST(this);
      this._gl_1.generateMipmap_majfzk_k$(this._forcedTexTarget);
    } else {
    }
  };
  GlTexture.prototype.prepareTexImage2D_sv8swh_k$ = function () {
    if (this._$this_23._get_linux__0_k$()) {
      this._gl_1.pixelStorei_rvwcgf_k$(this._GL_UNPACK_LSB_FIRST, this._gl_1._GFALSE);
      this._gl_1.pixelStorei_rvwcgf_k$(this._GL_UNPACK_SWAP_BYTES, this._gl_1._GTRUE);
    }};
  GlTexture.prototype.bind_sv8swh_k$ = function () {
    return this._gl_1.bindTexture_rvwcgf_k$(this._forcedTexTarget, this._get_tex__0_k$());
  };
  GlTexture.prototype.close_sv8swh_k$ = function () {
    Texture.prototype.close_sv8swh_k$.call(this);
    if (!this._closed_6) {
      this._closed_6 = true;
      if (this._cachedVersion_2 === this._$this_23._get_contextVersion__0_k$()) {
        this._gl_1.deleteTextures_9vfq5l_k$(1, this._texIds);
        this._texIds.set_rvwcgf_k$(0, -1);
      } else {
      }
    }};
  GlTexture.prototype.setFilter_rpwsgn_k$ = function (linear) {
    var tmp;
    if (this._get_mipmaps__0_k$()) {
      tmp = linear ? this._gl_1._LINEAR_MIPMAP_NEAREST : this._gl_1._NEAREST_MIPMAP_NEAREST;
    } else {
      tmp = linear ? this._gl_1._LINEAR : this._gl_1._NEAREST;
    }
    var minFilter = tmp;
    var magFilter = linear ? this._gl_1._LINEAR : this._gl_1._NEAREST;
    setWrapST(this);
    setMinMag(this, minFilter, magFilter);
  };
  GlTexture.$metadata$ = {
    simpleName: 'GlTexture',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__313($backBufferTextureBinding2d, this$0, $backBufferRenderBufferBinding, $backBufferFrameBufferBinding) {
    this._$backBufferTextureBinding2d = $backBufferTextureBinding2d;
    this._this$0_75 = this$0;
    this._$backBufferRenderBufferBinding = $backBufferRenderBufferBinding;
    this._$backBufferFrameBufferBinding = $backBufferFrameBufferBinding;
    BaseRenderBufferImpl.call(this);
  }
  _no_name_provided__313.prototype.init_sv8swh_k$ = function () {
    this._$backBufferTextureBinding2d._v = getIntegerv(this._this$0_75._get_gl__0_k$(), this._this$0_75._get_gl__0_k$()._TEXTURE_BINDING_2D);
    this._$backBufferRenderBufferBinding._v = getIntegerv(this._this$0_75._get_gl__0_k$(), this._this$0_75._get_gl__0_k$()._RENDERBUFFER_BINDING);
    this._$backBufferFrameBufferBinding._v = getIntegerv(this._this$0_75._get_gl__0_k$(), this._this$0_75._get_gl__0_k$()._FRAMEBUFFER_BINDING);
  };
  _no_name_provided__313.prototype.set_sv8swh_k$ = function () {
    setViewport(this._this$0_75, this);
    this._this$0_75._get_gl__0_k$().bindTexture_rvwcgf_k$(this._this$0_75._get_gl__0_k$()._TEXTURE_2D, this._$backBufferTextureBinding2d._v);
    this._this$0_75._get_gl__0_k$().bindRenderbuffer_rvwcgf_k$(this._this$0_75._get_gl__0_k$()._RENDERBUFFER, this._$backBufferRenderBufferBinding._v);
    this._this$0_75._get_gl__0_k$().bindFramebuffer_rvwcgf_k$(this._this$0_75._get_gl__0_k$()._FRAMEBUFFER, this._$backBufferFrameBufferBinding._v);
  };
  _no_name_provided__313.prototype.unset_sv8swh_k$ = function () {
    this._$backBufferTextureBinding2d._v = getIntegerv(this._this$0_75._get_gl__0_k$(), this._this$0_75._get_gl__0_k$()._TEXTURE_BINDING_2D);
    this._$backBufferRenderBufferBinding._v = getIntegerv(this._this$0_75._get_gl__0_k$(), this._this$0_75._get_gl__0_k$()._RENDERBUFFER_BINDING);
    this._$backBufferFrameBufferBinding._v = getIntegerv(this._this$0_75._get_gl__0_k$(), this._this$0_75._get_gl__0_k$()._FRAMEBUFFER_BINDING);
  };
  _no_name_provided__313.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AGOpengl() {
    AG.call(this);
    this._isGlAvailable = true;
    this._glSlVersion = null;
    this._gles = false;
    this._linux = false;
    this._android = false;
    this._devicePixelRatio_0 = 1.0;
    this._lastRenderContextId = 0;
    this._TEMP_MAX_MATRICES = 1024;
    this._tempBuffer1 = Companion_getInstance_97().invoke_ha5a7z_k$(4);
    this._tempBuffer_2 = Companion_getInstance_97().invoke_ha5a7z_k$(imul(64, this._TEMP_MAX_MATRICES));
    this._tempBufferM2 = Companion_getInstance_97().allocUnaligned_ha5a7z_k$(16);
    this._tempBufferM3 = Companion_getInstance_97().allocUnaligned_ha5a7z_k$(36);
    this._tempBufferM4 = Companion_getInstance_97().allocUnaligned_ha5a7z_k$(64);
    var tmp = this;
    var tmp0__get_f32__0 = this._tempBuffer_2;
    tmp._tempF32 = tmp0__get_f32__0._arrayFloat;
    this._tempFloats = new Float32Array(imul(16, this._TEMP_MAX_MATRICES));
    var tmp_0 = this;
    var tmp0_arrayOf_0 = [new Matrix3D()];
    tmp_0._mat3dArray = tmp0_arrayOf_0;
    this._finalScissorBL = Companion_getInstance_35().invoke_0_k$();
    this._tempRect_2 = Companion_getInstance_35().invoke_0_k$();
    this._programs = HashMap_init_$Create$();
  }
  AGOpengl.prototype._get_glSlVersion__0_k$ = function () {
    return this._glSlVersion;
  };
  AGOpengl.prototype._get_gles__0_k$ = function () {
    return this._gles;
  };
  AGOpengl.prototype._get_linux__0_k$ = function () {
    return this._linux;
  };
  AGOpengl.prototype._get_android__0_k$ = function () {
    return this._android;
  };
  AGOpengl.prototype._get_webgl__0_k$ = function () {
    return false;
  };
  AGOpengl.prototype._get_webgl2__0_k$ = function () {
    return false;
  };
  AGOpengl.prototype._get_devicePixelRatio__0_k$ = function () {
    return this._devicePixelRatio_0;
  };
  AGOpengl.prototype.contextLost_sv8swh_k$ = function () {
    Console_getInstance().info_c2g51s_k$(['AG.contextLost()', this, this._get_gl__0_k$(), this._get_gl__0_k$()._get_root__0_k$()]);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_contextVersion__0_k$();
    tmp0_this._set_contextVersion__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  AGOpengl.prototype.createBuffer_ijzjc5_k$ = function (kind) {
    return new GlBuffer(this, kind);
  };
  AGOpengl.prototype.setSwapInterval_majfzk_k$ = function (value) {
  };
  AGOpengl.prototype.createMainRenderBuffer_0_k$ = function () {
    var backBufferTextureBinding2d = {_v: 0};
    var backBufferRenderBufferBinding = {_v: 0};
    var backBufferFrameBufferBinding = {_v: 0};
    return new _no_name_provided__313(backBufferTextureBinding2d, this, backBufferRenderBufferBinding, backBufferFrameBufferBinding);
  };
  AGOpengl.prototype.createRenderBuffer_0_k$ = function () {
    return new GlRenderBuffer(this);
  };
  AGOpengl.prototype.toGl_l7s7xl_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(CompareMode_ALWAYS_getInstance())) {
      tmp = this._get_gl__0_k$()._ALWAYS;
    } else if (tmp0_subject.equals(CompareMode_EQUAL_getInstance())) {
      tmp = this._get_gl__0_k$()._EQUAL;
    } else if (tmp0_subject.equals(CompareMode_GREATER_getInstance())) {
      tmp = this._get_gl__0_k$()._GREATER;
    } else if (tmp0_subject.equals(CompareMode_GREATER_EQUAL_getInstance())) {
      tmp = this._get_gl__0_k$()._GEQUAL;
    } else if (tmp0_subject.equals(CompareMode_LESS_getInstance())) {
      tmp = this._get_gl__0_k$()._LESS;
    } else if (tmp0_subject.equals(CompareMode_LESS_EQUAL_getInstance())) {
      tmp = this._get_gl__0_k$()._LEQUAL;
    } else if (tmp0_subject.equals(CompareMode_NEVER_getInstance())) {
      tmp = this._get_gl__0_k$()._NEVER;
    } else if (tmp0_subject.equals(CompareMode_NOT_EQUAL_getInstance())) {
      tmp = this._get_gl__0_k$()._NOTEQUAL;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype.toGl_3v4jjy_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(StencilOp_DECREMENT_SATURATE_getInstance())) {
      tmp = this._get_gl__0_k$()._DECR;
    } else if (tmp0_subject.equals(StencilOp_DECREMENT_WRAP_getInstance())) {
      tmp = this._get_gl__0_k$()._DECR_WRAP;
    } else if (tmp0_subject.equals(StencilOp_INCREMENT_SATURATE_getInstance())) {
      tmp = this._get_gl__0_k$()._INCR;
    } else if (tmp0_subject.equals(StencilOp_INCREMENT_WRAP_getInstance())) {
      tmp = this._get_gl__0_k$()._INCR_WRAP;
    } else if (tmp0_subject.equals(StencilOp_INVERT_getInstance())) {
      tmp = this._get_gl__0_k$()._INVERT;
    } else if (tmp0_subject.equals(StencilOp_KEEP_getInstance())) {
      tmp = this._get_gl__0_k$()._KEEP;
    } else if (tmp0_subject.equals(StencilOp_SET_getInstance())) {
      tmp = this._get_gl__0_k$()._REPLACE;
    } else if (tmp0_subject.equals(StencilOp_ZERO_getInstance())) {
      tmp = this._get_gl__0_k$()._ZERO_1;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype.applyScissorState_t1fy71_k$ = function (scissor) {
    if (this._get_currentRenderBuffer__0_k$() == null) {
    }var tmp0_elvis_lhs = this._get_currentRenderBuffer__0_k$();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentRenderBuffer = tmp;
    if (currentRenderBuffer === this._get_mainRenderBuffer__0_k$()) {
      var realScissors = this._finalScissorBL;
      var tmp1_safe_receiver = realScissors;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver.setTo_i6u10_k$(0.0, 0.0, this._get_realBackWidth__0_k$(), this._get_realBackHeight__0_k$());
      Unit_getInstance();
      if (!(scissor == null)) {
        this._tempRect_2.setTo_i6u10_k$(currentRenderBuffer._get_x__0_k$() + scissor._x_18, (currentRenderBuffer._get_y__0_k$() + currentRenderBuffer._get_height__0_k$() | 0) - (scissor._y_17 + scissor._height_13), scissor._width_12, scissor._height_13);
        Unit_getInstance();
        var tmp2_safe_receiver = realScissors;
        realScissors = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.intersection_x1ktds_k$(this._tempRect_2, realScissors);
      }var renderBufferScissor = currentRenderBuffer._get_scissor__k7q7mb_k$();
      var tmp_0 = renderBufferScissor;
      if (!((tmp_0 == null ? null : new RectangleInt(tmp_0)) == null)) {
        var tmp3_safe_receiver = realScissors;
        realScissors = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.intersection_x1ktds_k$(_RectangleInt___get_rect__impl_(renderBufferScissor), realScissors);
      } else {
      }
      this._get_gl__0_k$().enable_majfzk_k$(this._get_gl__0_k$()._SCISSOR_TEST);
      if (!(realScissors == null)) {
        this._get_gl__0_k$().scissor_jthg1_k$(numberToInt(realScissors._x_2), numberToInt(realScissors._y_2), numberToInt(realScissors._width_0), numberToInt(realScissors._height_0));
      } else {
        this._get_gl__0_k$().scissor_jthg1_k$(0, 0, 0, 0);
      }
    } else {
      this._get_gl__0_k$().enableDisable_hwwcoo_k$(this._get_gl__0_k$()._SCISSOR_TEST, !(scissor == null));
      if (!(scissor == null)) {
        this._get_gl__0_k$().scissor_jthg1_k$(toIntRound(scissor._x_18), toIntRound(scissor._y_17), toIntRound(scissor._width_12), toIntRound(scissor._height_13));
      }}
  };
  AGOpengl.prototype.draw_ehteko_k$ = function (batch) {
    var instances = batch._instances;
    var program = batch._program;
    var type = batch._type_10;
    var vertexCount = batch._vertexCount_0;
    var indices = batch._indices;
    var indexType = batch._indexType;
    var offset_0 = batch._offset_29;
    var blending = batch._blending;
    var uniforms = batch._uniforms;
    var stencil = batch._stencil;
    var colorMask = batch._colorMask;
    var renderState = batch._renderState;
    var scissor = batch._scissor;
    this.applyScissorState_t1fy71_k$(scissor);
    var useExternalSampler = false;
    var inductionVariable = 0;
    var last_1 = uniforms._uniforms_1._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var uniform = uniforms._uniforms_1.get_ha5a7z_k$(n);
        var uniformType = uniform._get_type__0_k$();
        var value = uniforms._values_2.get_ha5a7z_k$(n);
        var tmp1_subject = uniformType;
        if (tmp1_subject.equals(VarType_TextureUnit_getInstance())) {
          var unit = value;
          var tmp0_fastCastTo_0 = unit._texture_2;
          var tex = tmp0_fastCastTo_0;
          if (!(tex == null)) {
            if (!(tex._forcedTexTarget === this._get_gl__0_k$()._TEXTURE_2D) ? !(tex._forcedTexTarget === -1) : false) {
              useExternalSampler = true;
            }}}}
       while (inductionVariable < last_1);
    if (!(indices == null) ? !indices._kind_1.equals(Kind_INDEX_getInstance()) : false) {
      invalidOp('Not a IndexBuffer');
    }var programConfig = useExternalSampler ? Companion_getInstance_168()._EXTERNAL_TEXTURE_SAMPLER : Companion_getInstance_168()._DEFAULT_2;
    var glProgram = this.getProgram_j5q2yu_k$(program, programConfig);
    var tmp2_safe_receiver = (indices == null ? true : indices instanceof GlBuffer) ? indices : null;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.bind_c8ca1_k$(this._get_gl__0_k$());
      Unit_getInstance();
    }
    Unit_getInstance();
    glProgram.use_sv8swh_k$();
    var tmp1_fastForEach_0 = batch._vertexData;
    var array_1 = tmp1_fastForEach_0._array_4;
    var n_2 = 0;
    while (n_2 < array_1.length) {
      var tmp0_4 = n_2;
      n_2 = tmp0_4 + 1 | 0;
      var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
      var tmp2__anonymous__5 = tmp0_unsafeCast_0_3;
      var tmp = tmp2__anonymous__5._buffer_25;
      var vertices_6 = tmp instanceof GlBuffer ? tmp : THROW_CCE();
      var vertexLayout_7 = tmp2__anonymous__5._layout;
      var vattrs_8 = vertexLayout_7._attributes_6;
      var vattrspos_9 = vertexLayout_7._attributePositions;
      if (!vertices_6._get_kind__0_k$().equals(Kind_VERTEX_getInstance())) {
        invalidOp('Not a VertexBuffer');
      }vertices_6.bind_c8ca1_k$(this._get_gl__0_k$());
      var totalSize_10 = vertexLayout_7._totalSize_2;
      var inductionVariable_0 = 0;
      var last_2 = vattrspos_9._get_size__0_k$();
      if (inductionVariable_0 < last_2)
        do {
          var n_12 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var att_13 = vattrs_8.get_ha5a7z_k$(n_12);
          if (!att_13._active_0)
            continue;
          var off_14 = vattrspos_9.get_ha5a7z_k$(n_12);
          var loc_15 = glProgram.getAttribLocation_6wfw3l_k$(att_13._get_name__0_k$());
          var glElementType_16 = this._get_glElementType__23ddef_k$(att_13._get_type__0_k$());
          var elementCount_17 = att_13._get_type__0_k$()._elementCount;
          if (loc_15 >= 0) {
            this._get_gl__0_k$().enableVertexAttribArray_majfzk_k$(loc_15);
            this._get_gl__0_k$().vertexAttribPointer_5h0f29_k$(loc_15, elementCount_17, glElementType_16, att_13._normalized, totalSize_10, toLong(off_14));
            if (!(att_13._divisor === 0)) {
              this._get_gl__0_k$().vertexAttribDivisor_rvwcgf_k$(loc_15, att_13._divisor);
            }}}
         while (inductionVariable_0 < last_2);
    }
    var textureUnit = 0;
    var inductionVariable_1 = 0;
    var last_3 = uniforms._uniforms_1._get_size__0_k$();
    if (inductionVariable_1 < last_3)
      do {
        var n_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var uniform_0 = uniforms._uniforms_1.get_ha5a7z_k$(n_0);
        var uniformName = uniform_0._get_name__0_k$();
        var uniformType_0 = uniform_0._get_type__0_k$();
        var value_0 = uniforms._values_2.get_ha5a7z_k$(n_0);
        var location = this._get_gl__0_k$().getUniformLocation_4wk0sg_k$(glProgram._id_11, uniformName);
        var declArrayCount = uniform_0._get_arrayCount__0_k$();
        var stride = uniform_0._get_type__0_k$()._elementCount;
        var tmp4_subject = uniformType_0;
        if (tmp4_subject.equals(VarType_TextureUnit_getInstance()) ? true : tmp4_subject.equals(VarType_SamplerCube_getInstance())) {
          var unit_0 = value_0;
          this._get_gl__0_k$().activeTexture_majfzk_k$(this._get_gl__0_k$()._TEXTURE0 + textureUnit | 0);
          if (uniformType_0.equals(VarType_TextureUnit_getInstance())) {
            var tmp3_fastCastTo_0 = unit_0._texture_2;
            var tex_0 = tmp3_fastCastTo_0;
            var tmp5_safe_receiver = tex_0;
            if (tmp5_safe_receiver == null)
              null;
            else {
              tmp5_safe_receiver.bindEnsuring_sv8swh_k$();
              Unit_getInstance();
            }
            Unit_getInstance();
            var tmp6_safe_receiver = tex_0;
            if (tmp6_safe_receiver == null)
              null;
            else {
              tmp6_safe_receiver.setFilter_rpwsgn_k$(unit_0._linear_0);
              Unit_getInstance();
            }
            Unit_getInstance();
          } else {
            var tmp4_fastCastTo_0 = unit_0._texture_2;
            var tex_1 = tmp4_fastCastTo_0;
            tex_1.initialiseIfNeeded_sv8swh_k$();
            tex_1.bindEnsuring_sv8swh_k$();
          }
          this._get_gl__0_k$().uniform1i_rvwcgf_k$(location, textureUnit);
          var tmp7 = textureUnit;
          textureUnit = tmp7 + 1 | 0;
          Unit_getInstance();
        } else if ((tmp4_subject.equals(VarType_Mat2_getInstance()) ? true : tmp4_subject.equals(VarType_Mat3_getInstance())) ? true : tmp4_subject.equals(VarType_Mat4_getInstance())) {
          var tmp8_subject = value_0;
          var tmp_0;
          if (isArray(tmp8_subject)) {
            tmp_0 = value_0;
          } else {
            if (tmp8_subject instanceof Matrix3D) {
              var tmp5_also_0 = this._mat3dArray;
              tmp5_also_0[0].copyFrom_srku5d_k$(value_0);
              Unit_getInstance();
              tmp_0 = tmp5_also_0;
            } else {
              {
                throw IllegalStateException_init_$Create$_0('Not an array or a matrix3d');
              }
            }
          }
          var tmp6_fastCastTo_0 = tmp_0;
          var matArray = tmp6_fastCastTo_0;
          var tmp7_min_0 = matArray.length;
          var arrayCount = Math.min(declArrayCount, tmp7_min_0);
          var tmp9_subject = uniformType_0;
          var matSize = tmp9_subject.equals(VarType_Mat2_getInstance()) ? 2 : tmp9_subject.equals(VarType_Mat3_getInstance()) ? 3 : tmp9_subject.equals(VarType_Mat4_getInstance()) ? 4 : -1;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < arrayCount)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              copyToFloatWxH(matArray[n_1], this._tempFloats, matSize, matSize, MajorOrder_COLUMN_getInstance(), imul(n_1, stride));
            }
             while (inductionVariable_2 < arrayCount);
          setFloats(this._tempBuffer_2, 0, this._tempFloats, 0, imul(stride, arrayCount));
          Unit_getInstance();
          if (this._get_webgl__0_k$()) {
            var tmp11_subject = uniformType_0;
            var tb = tmp11_subject.equals(VarType_Mat2_getInstance()) ? this._tempBufferM2 : tmp11_subject.equals(VarType_Mat3_getInstance()) ? this._tempBufferM3 : tmp11_subject.equals(VarType_Mat4_getInstance()) ? this._tempBufferM4 : this._tempBufferM4;
            var inductionVariable_3 = 0;
            if (inductionVariable_3 < arrayCount)
              do {
                var n_3 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                var itLocation = arrayCount === 1 ? location : this._get_gl__0_k$().getUniformLocation_4wk0sg_k$(glProgram._id_11, uniform_0._get_indexNames__0_k$()[n_3]);
                var tmp8__get_f32__0 = this._tempBuffer_2;
                var tmp_1 = imul(n_3, stride);
                arraycopy_15(tmp8__get_f32__0._arrayFloat, tmp_1, tb._arrayFloat, 0, stride);
                var tmp13_subject = uniform_0._get_type__0_k$();
                if (tmp13_subject.equals(VarType_Mat2_getInstance()))
                  this._get_gl__0_k$().uniformMatrix2fv_a0t79e_k$(itLocation, 1, false, tb);
                else if (tmp13_subject.equals(VarType_Mat3_getInstance()))
                  this._get_gl__0_k$().uniformMatrix3fv_a0t79e_k$(itLocation, 1, false, tb);
                else if (tmp13_subject.equals(VarType_Mat4_getInstance()))
                  this._get_gl__0_k$().uniformMatrix4fv_a0t79e_k$(itLocation, 1, false, tb);
                else {
                  invalidOp('' + "Don't know how to set uniform matrix " + uniform_0._get_type__0_k$());
                }
              }
               while (inductionVariable_3 < arrayCount);
          } else {
            var tmp14_subject = uniform_0._get_type__0_k$();
            if (tmp14_subject.equals(VarType_Mat2_getInstance()))
              this._get_gl__0_k$().uniformMatrix2fv_a0t79e_k$(location, arrayCount, false, this._tempBuffer_2);
            else if (tmp14_subject.equals(VarType_Mat3_getInstance()))
              this._get_gl__0_k$().uniformMatrix3fv_a0t79e_k$(location, arrayCount, false, this._tempBuffer_2);
            else if (tmp14_subject.equals(VarType_Mat4_getInstance()))
              this._get_gl__0_k$().uniformMatrix4fv_a0t79e_k$(location, arrayCount, false, this._tempBuffer_2);
            else {
              invalidOp('' + "Don't know how to set uniform matrix " + uniform_0._get_type__0_k$());
            }
          }
        } else if (((tmp4_subject.equals(VarType_Float1_getInstance()) ? true : tmp4_subject.equals(VarType_Float2_getInstance())) ? true : tmp4_subject.equals(VarType_Float3_getInstance())) ? true : tmp4_subject.equals(VarType_Float4_getInstance())) {
          var arrayCount_0 = declArrayCount;
          var tmp15_subject = value_0;
          if (isNumber(tmp15_subject))
            this._tempBuffer_2.setAlignedFloat32_z49mik_k$(0, numberToDouble(value_0));
          else {
            if (tmp15_subject instanceof Vector3D) {
              setFloats(this._tempBuffer_2, 0, value_0._data_10, 0, stride);
              Unit_getInstance();
            } else {
              if (isFloatArray(tmp15_subject)) {
                var tmp9_min_0 = value_0.length / stride | 0;
                arrayCount_0 = Math.min(declArrayCount, tmp9_min_0);
                setFloats(this._tempBuffer_2, 0, value_0, 0, imul(stride, arrayCount_0));
                Unit_getInstance();
              } else {
                if (isArray(tmp15_subject)) {
                  var tmp10_min_0 = value_0.length;
                  arrayCount_0 = Math.min(declArrayCount, tmp10_min_0);
                  var inductionVariable_4 = 0;
                  var last_4 = value_0.length;
                  if (inductionVariable_4 < last_4)
                    do {
                      var n_4 = inductionVariable_4;
                      inductionVariable_4 = inductionVariable_4 + 1 | 0;
                      var tmp_2 = value_0[n_4];
                      var vector = tmp_2 instanceof Vector3D ? tmp_2 : THROW_CCE();
                      setFloats(this._tempBuffer_2, imul(n_4, stride), vector._data_10, 0, stride);
                      Unit_getInstance();
                    }
                     while (inductionVariable_4 < last_4);
                } else {
                  {
                    var tmp11_error_0 = '' + "Unknown type '" + value_0 + "'";
                    throw IllegalStateException_init_$Create$_0(toString_1(tmp11_error_0));
                  }
                }
              }
            }
          }
          if (this._get_webgl__0_k$()) {
            var tb_0 = this._tempBufferM2;
            var inductionVariable_5 = 0;
            if (inductionVariable_5 < arrayCount_0)
              do {
                var n_5 = inductionVariable_5;
                inductionVariable_5 = inductionVariable_5 + 1 | 0;
                var itLocation_0 = arrayCount_0 === 1 ? location : this._get_gl__0_k$().getUniformLocation_4wk0sg_k$(glProgram._id_11, uniform_0._get_indexNames__0_k$()[n_5]);
                var f32 = tb_0._arrayFloat;
                var tmp12__get_f32__0 = this._tempBuffer_2;
                arraycopy_15(tmp12__get_f32__0._arrayFloat, 0, tb_0._arrayFloat, 0, stride);
                var tmp18_subject = uniform_0._get_type__0_k$();
                if (tmp18_subject.equals(VarType_Float1_getInstance())) {
                  var tmp_3 = this._get_gl__0_k$();
                  tmp_3.uniform1f_z49mik_k$(itLocation_0, f32[0]);
                } else if (tmp18_subject.equals(VarType_Float2_getInstance())) {
                  var tmp_4 = this._get_gl__0_k$();
                  var tmp_5 = f32[0];
                  tmp_4.uniform2f_gk2bzk_k$(itLocation_0, tmp_5, f32[1]);
                } else if (tmp18_subject.equals(VarType_Float3_getInstance())) {
                  var tmp_6 = this._get_gl__0_k$();
                  var tmp_7 = f32[0];
                  var tmp_8 = f32[1];
                  tmp_6.uniform3f_tarz9g_k$(itLocation_0, tmp_7, tmp_8, f32[2]);
                } else if (tmp18_subject.equals(VarType_Float4_getInstance())) {
                  var tmp_9 = this._get_gl__0_k$();
                  var tmp_10 = f32[0];
                  var tmp_11 = f32[1];
                  var tmp_12 = f32[2];
                  tmp_9.uniform4f_g45f0w_k$(itLocation_0, tmp_10, tmp_11, tmp_12, f32[3]);
                } else
                  Unit_getInstance();
              }
               while (inductionVariable_5 < arrayCount_0);
          } else {
            var tmp19_subject = uniform_0._get_type__0_k$();
            if (tmp19_subject.equals(VarType_Float1_getInstance()))
              this._get_gl__0_k$().uniform1fv_1a3fjs_k$(location, arrayCount_0, this._tempBuffer_2);
            else if (tmp19_subject.equals(VarType_Float2_getInstance()))
              this._get_gl__0_k$().uniform2fv_1a3fjs_k$(location, arrayCount_0, this._tempBuffer_2);
            else if (tmp19_subject.equals(VarType_Float3_getInstance()))
              this._get_gl__0_k$().uniform3fv_1a3fjs_k$(location, arrayCount_0, this._tempBuffer_2);
            else if (tmp19_subject.equals(VarType_Float4_getInstance()))
              this._get_gl__0_k$().uniform4fv_1a3fjs_k$(location, arrayCount_0, this._tempBuffer_2);
            else
              Unit_getInstance();
          }
        } else {
          invalidOp('' + "Don't know how to set uniform " + uniform_0._get_type__0_k$());
        }
      }
       while (inductionVariable_1 < last_3);
    if (blending._get_enabled__0_k$()) {
      this._get_gl__0_k$().enable_majfzk_k$(this._get_gl__0_k$()._BLEND);
      this._get_gl__0_k$().blendEquationSeparate_rvwcgf_k$(toGl(blending._eqRGB, this), toGl(blending._eqA, this));
      this._get_gl__0_k$().blendFuncSeparate_jthg1_k$(toGl_0(blending._srcRGB, this), toGl_0(blending._dstRGB, this), toGl_0(blending._srcA, this), toGl_0(blending._dstA, this));
    } else {
      this._get_gl__0_k$().disable_majfzk_k$(this._get_gl__0_k$()._BLEND);
    }
    if (renderState._frontFace.equals(FrontFace_BOTH_getInstance())) {
      this._get_gl__0_k$().disable_majfzk_k$(this._get_gl__0_k$()._CULL_FACE);
    } else {
      this._get_gl__0_k$().enable_majfzk_k$(this._get_gl__0_k$()._CULL_FACE);
      this._get_gl__0_k$().frontFace_majfzk_k$(renderState._frontFace.equals(FrontFace_CW_getInstance()) ? this._get_gl__0_k$()._CW : this._get_gl__0_k$()._CCW);
    }
    this._get_gl__0_k$().depthMask_rpwsgn_k$(renderState._depthMask);
    this._get_gl__0_k$().depthRangef_c7v4pd_k$(renderState._depthNear, renderState._depthFar);
    this._get_gl__0_k$().lineWidth_cpozfn_k$(renderState._lineWidth_0);
    if (!renderState._depthFunc.equals(CompareMode_ALWAYS_getInstance())) {
      this._get_gl__0_k$().enable_majfzk_k$(this._get_gl__0_k$()._DEPTH_TEST);
      this._get_gl__0_k$().depthFunc_majfzk_k$(this.toGl_l7s7xl_k$(renderState._depthFunc));
    } else {
      this._get_gl__0_k$().disable_majfzk_k$(this._get_gl__0_k$()._DEPTH_TEST);
    }
    this._get_gl__0_k$().colorMask_7d158x_k$(colorMask._red, colorMask._green, colorMask._blue, colorMask._alpha_0);
    if (stencil._enabled) {
      this._get_gl__0_k$().enable_majfzk_k$(this._get_gl__0_k$()._STENCIL_TEST);
      this._get_gl__0_k$().stencilFunc_zd700_k$(this.toGl_l7s7xl_k$(stencil._compareMode), stencil._referenceValue, stencil._readMask);
      this._get_gl__0_k$().stencilOp_zd700_k$(this.toGl_3v4jjy_k$(stencil._actionOnDepthFail), this.toGl_3v4jjy_k$(stencil._actionOnDepthPassStencilFail), this.toGl_3v4jjy_k$(stencil._actionOnBothPass));
      this._get_gl__0_k$().stencilMask_majfzk_k$(stencil._writeMask);
    } else {
      this._get_gl__0_k$().disable_majfzk_k$(this._get_gl__0_k$()._STENCIL_TEST);
      this._get_gl__0_k$().stencilMask_majfzk_k$(0);
    }
    if (!(indices == null)) {
      if (!(instances === 1)) {
        this._get_gl__0_k$().drawElementsInstanced_s9wiz4_k$(this._get_glDrawMode__8o9mwt_k$(type), vertexCount, this._get_glIndexType__uucihf_k$(indexType), offset_0, instances);
      } else {
        this._get_gl__0_k$().drawElements_jthg1_k$(this._get_glDrawMode__8o9mwt_k$(type), vertexCount, this._get_glIndexType__uucihf_k$(indexType), offset_0);
      }
    } else {
      if (!(instances === 1)) {
        this._get_gl__0_k$().drawArraysInstanced_jthg1_k$(this._get_glDrawMode__8o9mwt_k$(type), offset_0, vertexCount, instances);
      } else {
        this._get_gl__0_k$().drawArrays_zd700_k$(this._get_glDrawMode__8o9mwt_k$(type), offset_0, vertexCount);
      }
    }
    var tmp13_fastForEach_0 = batch._vertexData;
    var array_1_0 = tmp13_fastForEach_0._array_4;
    var n_2_0 = 0;
    while (n_2_0 < array_1_0.length) {
      var tmp0_4_0 = n_2_0;
      n_2_0 = tmp0_4_0 + 1 | 0;
      var tmp0_unsafeCast_0_3_0 = array_1_0[tmp0_4_0];
      var tmp14__anonymous__5 = tmp0_unsafeCast_0_3_0;
      var vattrs_6 = tmp14__anonymous__5._layout._attributes_6;
      var n_1_7 = 0;
      while (n_1_7 < vattrs_6._get_size__0_k$()) {
        var tmp0_2_9 = n_1_7;
        n_1_7 = tmp0_2_9 + 1 | 0;
        var tmp0__anonymous__3_8 = vattrs_6.get_ha5a7z_k$(tmp0_2_9);
        if (tmp0__anonymous__3_8._active_0) {
          var loc_4_10 = glProgram.getAttribLocation_6wfw3l_k$(tmp0__anonymous__3_8._get_name__0_k$());
          if (loc_4_10 >= 0) {
            if (!(tmp0__anonymous__3_8._divisor === 0)) {
              this._get_gl__0_k$().vertexAttribDivisor_rvwcgf_k$(loc_4_10, 0);
            }this._get_gl__0_k$().disableVertexAttribArray_majfzk_k$(loc_4_10);
          }}}
    }
  };
  AGOpengl.prototype._get_glDrawMode__8o9mwt_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(DrawType_POINTS_getInstance())) {
      tmp = this._get_gl__0_k$()._POINTS;
    } else if (tmp0_subject.equals(DrawType_LINE_STRIP_getInstance())) {
      tmp = this._get_gl__0_k$()._LINE_STRIP;
    } else if (tmp0_subject.equals(DrawType_LINE_LOOP_getInstance())) {
      tmp = this._get_gl__0_k$()._LINE_LOOP;
    } else if (tmp0_subject.equals(DrawType_LINES_getInstance())) {
      tmp = this._get_gl__0_k$()._LINES;
    } else if (tmp0_subject.equals(DrawType_TRIANGLE_STRIP_getInstance())) {
      tmp = this._get_gl__0_k$()._TRIANGLE_STRIP;
    } else if (tmp0_subject.equals(DrawType_TRIANGLE_FAN_getInstance())) {
      tmp = this._get_gl__0_k$()._TRIANGLE_FAN;
    } else if (tmp0_subject.equals(DrawType_TRIANGLES_getInstance())) {
      tmp = this._get_gl__0_k$()._TRIANGLES;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype._get_glElementType__23ddef_k$ = function (_this__0) {
    var tmp0_subject = _this__0._kind_3;
    var tmp;
    if (tmp0_subject.equals(VarKind_TBYTE_getInstance())) {
      tmp = this._get_gl__0_k$()._BYTE;
    } else if (tmp0_subject.equals(VarKind_TUNSIGNED_BYTE_getInstance())) {
      tmp = this._get_gl__0_k$()._UNSIGNED_BYTE;
    } else if (tmp0_subject.equals(VarKind_TSHORT_getInstance())) {
      tmp = this._get_gl__0_k$()._SHORT;
    } else if (tmp0_subject.equals(VarKind_TUNSIGNED_SHORT_getInstance())) {
      tmp = this._get_gl__0_k$()._UNSIGNED_SHORT;
    } else if (tmp0_subject.equals(VarKind_TINT_getInstance())) {
      tmp = this._get_gl__0_k$()._UNSIGNED_INT;
    } else if (tmp0_subject.equals(VarKind_TFLOAT_getInstance())) {
      tmp = this._get_gl__0_k$()._FLOAT;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype._get_glIndexType__uucihf_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(IndexType_UBYTE_getInstance())) {
      tmp = this._get_gl__0_k$()._UNSIGNED_BYTE;
    } else if (tmp0_subject.equals(IndexType_USHORT_getInstance())) {
      tmp = this._get_gl__0_k$()._UNSIGNED_SHORT;
    } else if (tmp0_subject.equals(IndexType_UINT_getInstance())) {
      tmp = this._get_gl__0_k$()._UNSIGNED_INT;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype.getProgram_j5q2yu_k$ = function (program, config) {
    var tmp0_getOrPut_0 = this._programs;
    var value_1 = tmp0_getOrPut_0.get_2bw_k$(program);
    var tmp;
    if (value_1 == null) {
      var answer_2 = HashMap_init_$Create$();
      tmp0_getOrPut_0.put_1q9pf_k$(program, answer_2);
      Unit_getInstance();
      tmp = answer_2;
    } else {
      tmp = value_1;
    }
    var tmp1_getOrPut_0 = tmp;
    var value_1_0 = tmp1_getOrPut_0.get_2bw_k$(config);
    var tmp_0;
    if (value_1_0 == null) {
      var answer_2_0 = new GlProgram(this, this._get_gl__0_k$(), program, config);
      tmp1_getOrPut_0.put_1q9pf_k$(config, answer_2_0);
      Unit_getInstance();
      tmp_0 = answer_2_0;
    } else {
      tmp_0 = value_1_0;
    }
    return tmp_0;
  };
  AGOpengl.prototype.clear_jnj4is_k$ = function (color_0, depth, stencil, clearColor, clearDepth, clearStencil) {
    var bits = 0;
    this.applyScissorState_t1fy71_k$(null);
    if (clearColor) {
      bits = bits | this._get_gl__0_k$()._COLOR_BUFFER_BIT;
      this._get_gl__0_k$().clearColor_f95lpr_k$(_RGBA___get_rf__impl_(color_0), _RGBA___get_gf__impl_(color_0), _RGBA___get_bf__impl_(color_0), _RGBA___get_af__impl_(color_0));
    }if (clearDepth) {
      bits = bits | this._get_gl__0_k$()._DEPTH_BUFFER_BIT;
      this._get_gl__0_k$().clearDepthf_cpozfn_k$(depth);
    }if (clearStencil) {
      bits = bits | this._get_gl__0_k$()._STENCIL_BUFFER_BIT;
      this._get_gl__0_k$().stencilMask_majfzk_k$(-1);
      this._get_gl__0_k$().clearStencil_majfzk_k$(stencil);
    }this._get_gl__0_k$().clear_majfzk_k$(bits);
  };
  AGOpengl.prototype.createTexture_vcj5fe_k$ = function (premultiplied) {
    return new GlTexture(this, this._get_gl__0_k$(), premultiplied);
  };
  AGOpengl.prototype.prepareUploadNativeTexture_nm2sef_k$ = function (bmp) {
  };
  AGOpengl.$metadata$ = {
    simpleName: 'AGOpengl',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__314() {
  }
  _no_name_provided__314.prototype.invoke_3h8fba_k$ = function ($this$$receiver) {
    return $this$$receiver.getString_ha5a7z_k$($this$$receiver._SHADING_LANGUAGE_VERSION);
  };
  _no_name_provided__314.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_3h8fba_k$(p1 instanceof KmlGl ? p1 : THROW_CCE());
  };
  _no_name_provided__314.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__315() {
  }
  _no_name_provided__315.prototype.invoke_3h8fba_k$ = function ($this$$receiver) {
    var tmp = _get_versionString_($this$$receiver);
    var tmp0_trim_0 = replace$default_0(tmp, '.', '', false, 4, null);
    var tmp0_elvis_lhs = toIntOrNull(toString_1(trim_0(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE())));
    return tmp0_elvis_lhs == null ? 100 : tmp0_elvis_lhs;
  };
  _no_name_provided__315.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_3h8fba_k$(p1 instanceof KmlGl ? p1 : THROW_CCE());
  };
  _no_name_provided__315.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function versionString$factory() {
    return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
      return _get_versionString_(receiver);
    }, null);
  }
  function versionInt$factory() {
    return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
      return _get_versionInt_(receiver);
    }, null);
  }
  function texRef$factory() {
    return getPropertyCallableRef('texRef', 1, KProperty1, function (receiver) {
      return receiver._get_texRef__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_262() {
    var i = new _no_name_provided__314();
    return function (p1) {
      return i.invoke_3h8fba_k$(p1);
    };
  }
  function _no_name_provided_$factory_263() {
    var i = new _no_name_provided__315();
    return function (p1) {
      return i.invoke_3h8fba_k$(p1);
    };
  }
  function setFloats(_this_, offset_0, data, dataOffset, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this_.setFloat_z49mik_k$(offset_0 + n_3 | 0, data[dataOffset + n_3 | 0]);
      }
       while (inductionVariable < count_0);
    return _this_;
  }
  function DummyAG(width, height) {
    AG.call(this);
    this._nativeComponent = new Object();
    this._backWidth = width;
    this._backHeight = height;
  }
  DummyAG.prototype._get_backWidth__0_k$ = function () {
    return this._backWidth;
  };
  DummyAG.prototype._get_backHeight__0_k$ = function () {
    return this._backHeight;
  };
  DummyAG.$metadata$ = {
    simpleName: 'DummyAG',
    kind: 'class',
    interfaces: []
  };
  function PrintAG_init_$Init$(width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 640;
    if (!(($mask0 & 2) === 0))
      height = 480;
    PrintAG.call($this, width, height);
    return $this;
  }
  function PrintAG_init_$Create$(width, height, $mask0, $marker) {
    return PrintAG_init_$Init$(width, height, $mask0, $marker, Object.create(PrintAG.prototype));
  }
  function PrintAG(width, height) {
    LogBaseAG_init_$Init$(0, 0, 3, null, this);
  }
  PrintAG.prototype.log_a4enbm_k$ = function (str) {
    println('' + 'PrintAG: ' + str);
  };
  PrintAG.$metadata$ = {
    simpleName: 'PrintAG',
    kind: 'class',
    interfaces: []
  };
  function LogAG_init_$Init$(width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 640;
    if (!(($mask0 & 2) === 0))
      height = 480;
    LogAG.call($this, width, height);
    return $this;
  }
  function LogAG_init_$Create$(width, height, $mask0, $marker) {
    return LogAG_init_$Init$(width, height, $mask0, $marker, Object.create(LogAG.prototype));
  }
  function LogAG(width, height) {
    LogBaseAG.call(this, width, height);
    var tmp = this;
    tmp._log = ArrayList_init_$Create$();
  }
  LogAG.prototype.log_a4enbm_k$ = function (str) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._log;
    tmp0_plusAssign_0.add_2bq_k$(str);
    Unit_getInstance();
  };
  LogAG.$metadata$ = {
    simpleName: 'LogAG',
    kind: 'class',
    interfaces: []
  };
  function LogBaseAG_init_$Init$(width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 640;
    if (!(($mask0 & 2) === 0))
      height = 480;
    LogBaseAG.call($this, width, height);
    return $this;
  }
  function LogTexture($outer, id, premultiplied) {
    this._$this_24 = $outer;
    Texture.call(this, $outer);
    this._id_13 = id;
    this._premultiplied_11 = premultiplied;
  }
  LogTexture.prototype._get_premultiplied__0_k$ = function () {
    return this._premultiplied_11;
  };
  LogTexture.prototype.uploadedSource_sv8swh_k$ = function () {
    this._$this_24.log_a4enbm_k$('' + this + '.uploadedBitmap(' + this._get_source__0_k$() + ', ' + this._get_source__0_k$()._get_width__0_k$() + ', ' + this._get_source__0_k$()._get_height__0_k$() + ')');
  };
  LogTexture.prototype.close_sv8swh_k$ = function () {
    Texture.prototype.close_sv8swh_k$.call(this);
    this._$this_24.log_a4enbm_k$('' + this + '.close()');
  };
  LogTexture.prototype.toString = function () {
    return '' + 'Texture[' + this._id_13 + ']';
  };
  LogTexture.$metadata$ = {
    simpleName: 'LogTexture',
    kind: 'class',
    interfaces: []
  };
  function LogBuffer($outer, id, kind) {
    this._$this_25 = $outer;
    Buffer.call(this, kind);
    this._id_14 = id;
  }
  LogBuffer.prototype._get_logmem__0_k$ = function () {
    return this._get_mem__0_k$();
  };
  LogBuffer.prototype._get_logmemOffset__0_k$ = function () {
    return this._get_memOffset__0_k$();
  };
  LogBuffer.prototype.afterSetMem_sv8swh_k$ = function () {
    return this._$this_25.log_a4enbm_k$('' + this + '.afterSetMem(mem[' + ensureNotNull(this._get_mem__0_k$())._size_6 + '])');
  };
  LogBuffer.prototype.close_sv8swh_k$ = function () {
    return this._$this_25.log_a4enbm_k$('' + this + '.close()');
  };
  LogBuffer.prototype.toString = function () {
    return '' + 'Buffer[' + this._id_14 + ']';
  };
  LogBuffer.$metadata$ = {
    simpleName: 'LogBuffer',
    kind: 'class',
    interfaces: []
  };
  function LogRenderBuffer($outer, id, isMain) {
    this._$this_26 = $outer;
    RenderBuffer.call(this, $outer);
    this._id_15 = id;
    this._isMain = isMain;
    if (this._isMain) {
      var tmp = this._$this_26._get_backWidth__0_k$();
      var tmp_0 = this._$this_26._get_backHeight__0_k$();
      this.setSize$default_e5nmz5_k$(0, 0, tmp, tmp_0, 0, 0, 48, null);
    }}
  LogRenderBuffer.prototype.setSize_6try9d_k$ = function (x, y, width, height, fullWidth, fullHeight) {
    return this._$this_26.log_a4enbm_k$('' + this + '.setSize(' + width + ', ' + height + ')');
  };
  LogRenderBuffer.prototype.set_sv8swh_k$ = function () {
    return this._$this_26.log_a4enbm_k$('' + this + '.set()');
  };
  LogRenderBuffer.prototype.close_sv8swh_k$ = function () {
    return this._$this_26.log_a4enbm_k$('' + this + '.close()');
  };
  LogRenderBuffer.prototype.toString = function () {
    return '' + 'RenderBuffer[' + this._id_15 + ']';
  };
  LogRenderBuffer.$metadata$ = {
    simpleName: 'LogRenderBuffer',
    kind: 'class',
    interfaces: []
  };
  function VertexAttributeEx(index_0, attribute, pos, data) {
    this._index_21 = index_0;
    this._attribute = attribute;
    this._pos_1 = pos;
    this._data_30 = data;
    this._layout_0 = this._data_30._layout;
    var tmp = this;
    var tmp_0 = this._data_30._buffer_25;
    tmp._buffer_26 = tmp_0 instanceof LogBuffer ? tmp_0 : THROW_CCE();
  }
  VertexAttributeEx.prototype.toString = function () {
    return '' + 'VertexAttributeEx(index=' + this._index_21 + ', attribute=' + this._attribute + ', pos=' + this._pos_1 + ', data=' + this._data_30 + ')';
  };
  VertexAttributeEx.prototype.hashCode = function () {
    var result = this._index_21;
    result = imul(result, 31) + this._attribute.hashCode() | 0;
    result = imul(result, 31) + this._pos_1 | 0;
    result = imul(result, 31) + this._data_30.hashCode() | 0;
    return result;
  };
  VertexAttributeEx.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VertexAttributeEx))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VertexAttributeEx ? other : THROW_CCE();
    if (!(this._index_21 === tmp0_other_with_cast._index_21))
      return false;
    if (!this._attribute.equals(tmp0_other_with_cast._attribute))
      return false;
    if (!(this._pos_1 === tmp0_other_with_cast._pos_1))
      return false;
    if (!this._data_30.equals(tmp0_other_with_cast._data_30))
      return false;
    return true;
  };
  VertexAttributeEx.$metadata$ = {
    simpleName: 'VertexAttributeEx',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__316() {
  }
  _no_name_provided__316.prototype.invoke_997jt5_k$ = function (it) {
    var tmp;
    if (typeof it === 'number') {
      tmp = _get_niceStr__2(it);
    } else {
      {
        tmp = toString_1(it);
      }
    }
    return tmp;
  };
  _no_name_provided__316.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_997jt5_k$(isNumber(p1) ? p1 : THROW_CCE());
  };
  _no_name_provided__316.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function LogBaseAG(width, height) {
    DummyAG.call(this, width, height);
    this._backWidth_0 = width;
    this._backHeight_0 = height;
    this._textureId = 0;
    this._bufferId = 0;
    this._renderBufferId = 0;
  }
  LogBaseAG.prototype.log_a4enbm_k$ = function (str) {
  };
  LogBaseAG.prototype.clear_jnj4is_k$ = function (color_0, depth, stencil, clearColor, clearDepth, clearStencil) {
    return this.log_a4enbm_k$('' + 'clear(' + new RGBA(color_0) + ', ' + depth + ', ' + stencil + ', ' + clearColor + ', ' + clearDepth + ', ' + clearStencil + ')');
  };
  LogBaseAG.prototype._get_backWidth__0_k$ = function () {
    return this._backWidth_0;
  };
  LogBaseAG.prototype._get_backHeight__0_k$ = function () {
    return this._backHeight_0;
  };
  LogBaseAG.prototype.createTexture_vcj5fe_k$ = function (premultiplied) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._textureId;
    tmp0_this._textureId = tmp1 + 1 | 0;
    var tmp0_apply_0 = new LogTexture(this, tmp1, premultiplied);
    this.log_a4enbm_k$('' + 'createTexture():' + tmp0_apply_0._id_13);
    return tmp0_apply_0;
  };
  LogBaseAG.prototype.createBuffer_ijzjc5_k$ = function (kind) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._bufferId;
    tmp0_this._bufferId = tmp1 + 1 | 0;
    var tmp0_apply_0 = new LogBuffer(this, tmp1, kind);
    this.log_a4enbm_k$('' + 'createBuffer(' + kind + '):' + tmp0_apply_0._id_14);
    return tmp0_apply_0;
  };
  LogBaseAG.prototype.draw_ehteko_k$ = function (batch) {
    var program = batch._program;
    var type = batch._type_10;
    var vertexData = batch._vertexData;
    var vertexCount = batch._vertexCount_0;
    var instances = batch._instances;
    var indices = batch._indices;
    var offset_0 = batch._offset_29;
    var blending = batch._blending;
    var uniforms = batch._uniforms;
    var stencil = batch._stencil;
    var colorMask = batch._colorMask;
    var renderState = batch._renderState;
    var scissor = batch._scissor;
    try {
      this.log_a4enbm_k$('' + 'draw(vertexCount=' + vertexCount + ', instances=' + instances + ', indices=' + indices + ', type=' + type + ', offset=' + offset_0 + ')');
      this.log_a4enbm_k$('' + '::draw.program=' + program);
      this.log_a4enbm_k$('' + '::draw.renderState=' + renderState);
      this.log_a4enbm_k$('' + '::draw.scissor=' + scissor);
      this.log_a4enbm_k$('' + '::draw.stencil=' + stencil);
      this.log_a4enbm_k$('' + '::draw.blending=' + blending);
      this.log_a4enbm_k$('' + '::draw.colorMask=' + colorMask);
      var inductionVariable = 0;
      var last_1 = uniforms._get_size__0_k$();
      if (inductionVariable < last_1)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var uniform = uniforms._get_keys__0_k$().get_ha5a7z_k$(index_0);
          var value = uniforms._values_2.get_ha5a7z_k$(index_0);
          this.log_a4enbm_k$('' + '::draw.uniform.' + uniform + ' = ' + this.convertToStriangle_kajtkh_k$(value));
        }
         while (inductionVariable < last_1);
      var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2 = vertexData.iterator_0_k$();
      while (tmp0_iterator_1_2.hasNext_0_k$()) {
        var element_2_3 = tmp0_iterator_1_2.next_0_k$();
        var tmp0_mapIndexed_0_6 = zip(element_2_3._layout._attributes_6, element_2_3._layout._attributePositions);
        var tmp0_mapIndexedTo_0_1_7 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_mapIndexed_0_6, 10));
        var index_1_2_8 = 0;
        var tmp0_iterator_2_3_9 = tmp0_mapIndexed_0_6.iterator_0_k$();
        while (tmp0_iterator_2_3_9.hasNext_0_k$()) {
          var item_3_4_10 = tmp0_iterator_2_3_9.next_0_k$();
          var tmp1_4_5_12 = index_1_2_8;
          index_1_2_8 = tmp1_4_5_12 + 1 | 0;
          var tmp1__anonymous__6_11 = checkIndexOverflow(tmp1_4_5_12);
          tmp0_mapIndexedTo_0_1_7.add_2bq_k$(new VertexAttributeEx(tmp1__anonymous__6_11, item_3_4_10._first, item_3_4_10._second, element_2_3));
          Unit_getInstance();
        }
        var list_3_4 = tmp0_mapIndexedTo_0_1_7;
        addAll(tmp0_flatMapTo_0_1, list_3_4);
        Unit_getInstance();
      }
      var vertexLayoutAttributesEx = tmp0_flatMapTo_0_1;
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(vertexLayoutAttributesEx, 10));
      var tmp0_iterator_1_2_0 = vertexLayoutAttributesEx.iterator_0_k$();
      while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
        var item_2_3 = tmp0_iterator_1_2_0.next_0_k$();
        tmp0_mapTo_0_1.add_2bq_k$(item_2_3._attribute);
        Unit_getInstance();
      }
      var vertexLayoutAttributes = toSet_0(tmp0_mapTo_0_1);
      var missingUniforms = minus_0(program._uniforms_6, uniforms._get_keys__0_k$());
      var extraUniforms = minus(uniforms._get_keys__0_k$(), program._uniforms_6);
      var missingAttributes = minus_0(vertexLayoutAttributes, program._attributes_5);
      var extraAttributes = minus_0(program._attributes_5, vertexLayoutAttributes);
      if (!missingUniforms.isEmpty_0_k$())
        this.log_a4enbm_k$('' + '::draw.ERROR.Missing:' + missingUniforms);
      else {
      }
      if (!extraUniforms.isEmpty_0_k$())
        this.log_a4enbm_k$('' + '::draw.ERROR.Unexpected:' + extraUniforms);
      else {
      }
      if (!missingAttributes.isEmpty_0_k$())
        this.log_a4enbm_k$('' + '::draw.ERROR.Missing:' + missingAttributes);
      else {
      }
      if (!extraAttributes.isEmpty_0_k$())
        this.log_a4enbm_k$('' + '::draw.ERROR.Unexpected:' + extraAttributes);
      else {
      }
      var tmp;
      if (!(indices == null)) {
        var indexMem = ensureNotNull((indices instanceof LogBuffer ? indices : THROW_CCE())._get_logmem__0_k$());
        var range = until(offset_0, offset_0 + vertexCount | 0);
        var tmp1_safe_receiver = batch;
        var tmp2_subject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._indexType;
        var tmp_0;
        if (equals_1(tmp2_subject, IndexType_UBYTE_getInstance())) {
          var tmp0_also_0_1 = IntArrayList_init_$Create$(0, 1, null);
          var inductionVariable_0 = range._get_first__0_k$();
          var last_2 = range._get_last__0_k$();
          if (inductionVariable_0 <= last_2)
            do {
              var v_3_3 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              tmp0_also_0_1.add_majfzk_k$(indexMem.getAlignedUInt8_ha5a7z_k$(v_3_3));
            }
             while (!(v_3_3 === last_2));
          tmp_0 = tmp0_also_0_1;
        } else if (equals_1(tmp2_subject, IndexType_USHORT_getInstance())) {
          var tmp0_also_0_1_0 = IntArrayList_init_$Create$(0, 1, null);
          var inductionVariable_1 = range._get_first__0_k$();
          var last_3 = range._get_last__0_k$();
          if (inductionVariable_1 <= last_3)
            do {
              var v_3_3_0 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              tmp0_also_0_1_0.add_majfzk_k$(indexMem.getAlignedUInt16_ha5a7z_k$(v_3_3_0));
            }
             while (!(v_3_3_0 === last_3));
          tmp_0 = tmp0_also_0_1_0;
        } else if (equals_1(tmp2_subject, IndexType_UINT_getInstance())) {
          var tmp0_also_0_1_1 = IntArrayList_init_$Create$(0, 1, null);
          var inductionVariable_2 = range._get_first__0_k$();
          var last_4 = range._get_last__0_k$();
          if (inductionVariable_2 <= last_4)
            do {
              var v_3_3_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              tmp0_also_0_1_1.add_majfzk_k$(indexMem.getAlignedInt32_ha5a7z_k$(v_3_3_1));
            }
             while (!(v_3_3_1 === last_4));
          tmp_0 = tmp0_also_0_1_1;
        } else {
          noWhenBranchMatchedException();
        }
        tmp = tmp_0;
      } else {
        var tmp0_toIntList_0 = toList_3(until(0, vertexCount));
        var tmp0_also_0_1_2 = IntArrayList_init_$Create$(0, 1, null);
        var tmp0_iterator_2_2 = tmp0_toIntList_0.iterator_0_k$();
        while (tmp0_iterator_2_2.hasNext_0_k$()) {
          var v_3_3_2 = tmp0_iterator_2_2.next_0_k$();
          tmp0_also_0_1_2.add_majfzk_k$(v_3_3_2);
        }
        tmp = tmp0_also_0_1_2;
      }
      var _indices = tmp;
      var tmp3_iterator = vertexLayoutAttributesEx.iterator_0_k$();
      while (tmp3_iterator.hasNext_0_k$()) {
        var vlae = tmp3_iterator.next_0_k$();
        this.log_a4enbm_k$('' + '::draw.attribute[' + vlae._buffer_26._id_14 + '][' + vlae._index_21 + ']=' + vlae._attribute.toStringEx_0_k$());
      }
      this.log_a4enbm_k$('' + '::draw.indices=' + _indices);
      var tmp4_iterator = listOf([false, true]).iterator_0_k$();
      while (tmp4_iterator.hasNext_0_k$()) {
        var doInstances = tmp4_iterator.next_0_k$();
        var tmp_1;
        if (doInstances) {
          var tmp_2 = 0;
          var tmp_3 = instances;
          var tmp_4 = new Int32Array(tmp_3);
          while (tmp_2 < tmp_3) {
            var tmp_5 = tmp_2;
            tmp_4[tmp_5] = tmp_5;
            tmp_2 = tmp_2 + 1 | 0;
          }
          tmp_1 = toIntArrayList(tmp_4);
        } else {
          tmp_1 = distinct(sorted(_indices));
        }
        var tmp5_iterator = tmp_1.iterator_0_k$();
        while (tmp5_iterator.hasNext_0_k$()) {
          var index_1 = tmp5_iterator.next_0_k$();
          var attributes = ArrayList_init_$Create$();
          var tmp6_iterator = vertexLayoutAttributesEx.iterator_0_k$();
          while (tmp6_iterator.hasNext_0_k$()) {
            var vlae_0 = tmp6_iterator.next_0_k$();
            if (vlae_0._attribute._divisor === 0 === doInstances)
              continue;
            var attribute = vlae_0._attribute;
            var vm = ensureNotNull(vlae_0._buffer_26._get_logmem__0_k$());
            var attributeType = attribute._get_type__0_k$();
            var o = (imul(index_1, vlae_0._layout_0._totalSize_2) + vlae_0._pos_1 | 0) + vlae_0._buffer_26._get_logmemOffset__0_k$() | 0;
            var acount = attributeType._elementCount;
            var tmp7_subject = attributeType._kind_3;
            var tmp_6;
            if (tmp7_subject.equals(VarKind_TBYTE_getInstance())) {
              var tmp1_map_0 = until(0, acount);
              var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
              var inductionVariable_3 = tmp1_map_0._get_first__0_k$();
              var last_5 = tmp1_map_0._get_last__0_k$();
              if (inductionVariable_3 <= last_5)
                do {
                  var item_2_3_0 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  tmp0_mapTo_0_1_0.add_2bq_k$(vm.getUnalignedInt8_ha5a7z_k$(o + imul(item_2_3_0, 1) | 0));
                  Unit_getInstance();
                }
                 while (!(item_2_3_0 === last_5));
              var tmp2_map_0 = tmp0_mapTo_0_1_0;
              var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0, 10));
              var tmp0_iterator_1_2_1 = tmp2_map_0.iterator_0_k$();
              while (tmp0_iterator_1_2_1.hasNext_0_k$()) {
                var item_2_3_1 = tmp0_iterator_1_2_1.next_0_k$();
                tmp0_mapTo_0_1_1.add_2bq_k$(attribute._normalized ? item_2_3_1 / ByteCompanionObject_getInstance()._MAX_VALUE_3 : item_2_3_1);
                Unit_getInstance();
              }
              tmp_6 = tmp0_mapTo_0_1_1;
            } else if (tmp7_subject.equals(VarKind_TUNSIGNED_BYTE_getInstance())) {
              var tmp3_map_0 = until(0, acount);
              var tmp0_mapTo_0_1_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map_0, 10));
              var inductionVariable_4 = tmp3_map_0._get_first__0_k$();
              var last_6 = tmp3_map_0._get_last__0_k$();
              if (inductionVariable_4 <= last_6)
                do {
                  var item_2_3_2 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  tmp0_mapTo_0_1_2.add_2bq_k$(vm.getUnalignedUInt8_ha5a7z_k$(o + imul(item_2_3_2, 1) | 0));
                  Unit_getInstance();
                }
                 while (!(item_2_3_2 === last_6));
              var tmp4_map_0 = tmp0_mapTo_0_1_2;
              var tmp0_mapTo_0_1_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp4_map_0, 10));
              var tmp0_iterator_1_2_2 = tmp4_map_0.iterator_0_k$();
              while (tmp0_iterator_1_2_2.hasNext_0_k$()) {
                var item_2_3_3 = tmp0_iterator_1_2_2.next_0_k$();
                tmp0_mapTo_0_1_3.add_2bq_k$(attribute._normalized ? item_2_3_3 / 255 : item_2_3_3);
                Unit_getInstance();
              }
              tmp_6 = tmp0_mapTo_0_1_3;
            } else if (tmp7_subject.equals(VarKind_TSHORT_getInstance())) {
              var tmp5_map_0 = until(0, acount);
              var tmp0_mapTo_0_1_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp5_map_0, 10));
              var inductionVariable_5 = tmp5_map_0._get_first__0_k$();
              var last_7 = tmp5_map_0._get_last__0_k$();
              if (inductionVariable_5 <= last_7)
                do {
                  var item_2_3_4 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  tmp0_mapTo_0_1_4.add_2bq_k$(vm.getUnalignedInt16_ha5a7z_k$(o + imul(item_2_3_4, 2) | 0));
                  Unit_getInstance();
                }
                 while (!(item_2_3_4 === last_7));
              var tmp6_map_0 = tmp0_mapTo_0_1_4;
              var tmp0_mapTo_0_1_5 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp6_map_0, 10));
              var tmp0_iterator_1_2_3 = tmp6_map_0.iterator_0_k$();
              while (tmp0_iterator_1_2_3.hasNext_0_k$()) {
                var item_2_3_5 = tmp0_iterator_1_2_3.next_0_k$();
                tmp0_mapTo_0_1_5.add_2bq_k$(attribute._normalized ? item_2_3_5 / ShortCompanionObject_getInstance()._MAX_VALUE_4 : item_2_3_5);
                Unit_getInstance();
              }
              tmp_6 = tmp0_mapTo_0_1_5;
            } else if (tmp7_subject.equals(VarKind_TUNSIGNED_SHORT_getInstance())) {
              var tmp7_map_0 = until(0, acount);
              var tmp0_mapTo_0_1_6 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp7_map_0, 10));
              var inductionVariable_6 = tmp7_map_0._get_first__0_k$();
              var last_8 = tmp7_map_0._get_last__0_k$();
              if (inductionVariable_6 <= last_8)
                do {
                  var item_2_3_6 = inductionVariable_6;
                  inductionVariable_6 = inductionVariable_6 + 1 | 0;
                  tmp0_mapTo_0_1_6.add_2bq_k$(vm.getUnalignedUInt16_ha5a7z_k$(o + imul(item_2_3_6, 2) | 0));
                  Unit_getInstance();
                }
                 while (!(item_2_3_6 === last_8));
              var tmp8_map_0 = tmp0_mapTo_0_1_6;
              var tmp0_mapTo_0_1_7 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp8_map_0, 10));
              var tmp0_iterator_1_2_4 = tmp8_map_0.iterator_0_k$();
              while (tmp0_iterator_1_2_4.hasNext_0_k$()) {
                var item_2_3_7 = tmp0_iterator_1_2_4.next_0_k$();
                tmp0_mapTo_0_1_7.add_2bq_k$(attribute._normalized ? item_2_3_7 / 65535 : item_2_3_7);
                Unit_getInstance();
              }
              tmp_6 = tmp0_mapTo_0_1_7;
            } else if (tmp7_subject.equals(VarKind_TINT_getInstance())) {
              var tmp9_map_0 = until(0, acount);
              var tmp0_mapTo_0_1_8 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp9_map_0, 10));
              var inductionVariable_7 = tmp9_map_0._get_first__0_k$();
              var last_9 = tmp9_map_0._get_last__0_k$();
              if (inductionVariable_7 <= last_9)
                do {
                  var item_2_3_8 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  tmp0_mapTo_0_1_8.add_2bq_k$(vm.getUnalignedInt32_ha5a7z_k$(o + imul(item_2_3_8, 4) | 0));
                  Unit_getInstance();
                }
                 while (!(item_2_3_8 === last_9));
              var tmp10_map_0 = tmp0_mapTo_0_1_8;
              var tmp0_mapTo_0_1_9 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp10_map_0, 10));
              var tmp0_iterator_1_2_5 = tmp10_map_0.iterator_0_k$();
              while (tmp0_iterator_1_2_5.hasNext_0_k$()) {
                var item_2_3_9 = tmp0_iterator_1_2_5.next_0_k$();
                tmp0_mapTo_0_1_9.add_2bq_k$(attribute._normalized ? item_2_3_9 / IntCompanionObject_getInstance()._MAX_VALUE_5 : item_2_3_9);
                Unit_getInstance();
              }
              tmp_6 = tmp0_mapTo_0_1_9;
            } else if (tmp7_subject.equals(VarKind_TFLOAT_getInstance())) {
              var tmp11_map_0 = until(0, acount);
              var tmp0_mapTo_0_1_10 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp11_map_0, 10));
              var inductionVariable_8 = tmp11_map_0._get_first__0_k$();
              var last_10 = tmp11_map_0._get_last__0_k$();
              if (inductionVariable_8 <= last_10)
                do {
                  var item_2_3_10 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  tmp0_mapTo_0_1_10.add_2bq_k$(vm.getUnalignedFloat32_ha5a7z_k$(o + imul(item_2_3_10, 4) | 0));
                  Unit_getInstance();
                }
                 while (!(item_2_3_10 === last_10));
              var tmp12_map_0 = tmp0_mapTo_0_1_10;
              var tmp0_mapTo_0_1_11 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp12_map_0, 10));
              var tmp0_iterator_1_2_6 = tmp12_map_0.iterator_0_k$();
              while (tmp0_iterator_1_2_6.hasNext_0_k$()) {
                var item_2_3_11 = tmp0_iterator_1_2_6.next_0_k$();
                tmp0_mapTo_0_1_11.add_2bq_k$(attribute._normalized ? clamp01_0(item_2_3_11) : item_2_3_11);
                Unit_getInstance();
              }
              tmp_6 = tmp0_mapTo_0_1_11;
            } else {
              noWhenBranchMatchedException();
            }
            var info = tmp_6;
            var tmp_7 = attribute._get_name__0_k$();
            var tmp13_plusAssign_0 = '' + tmp_7 + '[' + joinToString$default_0(info, ',', null, null, 0, null, _no_name_provided_$factory_264(), 30, null) + ']';
            attributes.add_2bq_k$(tmp13_plusAssign_0);
            Unit_getInstance();
          }
          if (doInstances) {
            if (!attributes.isEmpty_0_k$()) {
              this.log_a4enbm_k$('' + '::draw.instance[' + index_1 + ']: ' + joinToString$default_0(attributes, ', ', null, null, 0, null, null, 62, null));
            } else {
            }
          } else {
            this.log_a4enbm_k$('' + '::draw.vertex[' + index_1 + ']: ' + joinToString$default_0(attributes, ', ', null, null, 0, null, null, 62, null));
          }
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        this.log_a4enbm_k$('' + 'LogBaseAG.draw.ERROR: ' + $p.message);
        printStackTrace_0($p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  LogBaseAG.prototype.convertToStriangle_kajtkh_k$ = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (!(tmp0_subject == null) ? isIntArray(tmp0_subject) : false) {
      tmp = toList_0(_this__0);
    } else {
      if (!(tmp0_subject == null) ? isFloatArray(tmp0_subject) : false) {
        tmp = toList_1(_this__0);
      } else {
        {
          tmp = _this__0;
        }
      }
    }
    return tmp;
  };
  LogBaseAG.prototype.disposeTemporalPerFrameStuff_sv8swh_k$ = function () {
    return this.log_a4enbm_k$('disposeTemporalPerFrameStuff()');
  };
  LogBaseAG.prototype.createRenderBuffer_0_k$ = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._renderBufferId;
    tmp0_this._renderBufferId = tmp1 + 1 | 0;
    var tmp0_apply_0 = new LogRenderBuffer(this, tmp1, false);
    this.log_a4enbm_k$('' + 'createRenderBuffer():' + tmp0_apply_0._id_15);
    return tmp0_apply_0;
  };
  LogBaseAG.prototype.createMainRenderBuffer_0_k$ = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._renderBufferId;
    tmp0_this._renderBufferId = tmp1 + 1 | 0;
    var tmp0_apply_0 = new LogRenderBuffer(this, tmp1, true);
    this.log_a4enbm_k$('' + 'createMainRenderBuffer():' + tmp0_apply_0._id_15);
    return tmp0_apply_0;
  };
  LogBaseAG.prototype.flipInternal_sv8swh_k$ = function () {
    return this.log_a4enbm_k$('flipInternal()');
  };
  LogBaseAG.$metadata$ = {
    simpleName: 'LogBaseAG',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_264() {
    var i = new _no_name_provided__316();
    return function (p1) {
      return i.invoke_997jt5_k$(p1);
    };
  }
  function _no_name_provided__317() {
  }
  _no_name_provided__317.prototype.invoke_okcceq_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__317.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__317.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__318() {
  }
  _no_name_provided__318.prototype.invoke_okcceq_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__318.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__318.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__319() {
  }
  _no_name_provided__319.prototype.invoke_majfzk_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__319.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_majfzk_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__319.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__320() {
  }
  _no_name_provided__320.prototype.invoke_majfzk_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__320.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_majfzk_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__320.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__321() {
  }
  _no_name_provided__321.prototype.invoke_rpwsgn_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__321.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_rpwsgn_k$((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__321.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UniformFloatStorage(uniforms, uniform, array) {
    this._uniforms_2 = uniforms;
    this._uniform = uniform;
    this._array_5 = array;
    this._uniforms_2.set_r39nsu_k$(this._uniform, this._array_5);
    Unit_getInstance();
  }
  UniformFloatStorage.prototype.doubleDelegate_14fczw_k$ = function (index_0, default_0, onSet) {
    return new DoubleDelegatedUniform(this._uniform, this._array_5, index_0, onSet, default_0);
  };
  UniformFloatStorage.prototype.doubleDelegateX_ucikej_k$ = function (default_0, onSet) {
    return this.doubleDelegate_14fczw_k$(0, default_0, onSet);
  };
  UniformFloatStorage.prototype.doubleDelegateX$default_vmusvy_k$ = function (default_0, onSet, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      default_0 = 0.0;
    if (!(($mask0 & 2) === 0)) {
      onSet = _no_name_provided_$factory_265();
    }return this.doubleDelegateX_ucikej_k$(default_0, onSet);
  };
  UniformFloatStorage.prototype.doubleDelegateY_ucikej_k$ = function (default_0, onSet) {
    return this.doubleDelegate_14fczw_k$(1, default_0, onSet);
  };
  UniformFloatStorage.prototype.doubleDelegateY$default_vmusvy_k$ = function (default_0, onSet, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      default_0 = 0.0;
    if (!(($mask0 & 2) === 0)) {
      onSet = _no_name_provided_$factory_266();
    }return this.doubleDelegateY_ucikej_k$(default_0, onSet);
  };
  UniformFloatStorage.prototype.intDelegate_9chvei_k$ = function (index_0, default_0, onSet) {
    return new IntDelegatedUniform(this._uniform, this._array_5, index_0, onSet, default_0);
  };
  UniformFloatStorage.prototype.intDelegateX_iqk8fv_k$ = function (default_0, onSet) {
    return this.intDelegate_9chvei_k$(0, default_0, onSet);
  };
  UniformFloatStorage.prototype.intDelegateX$default_y6olaq_k$ = function (default_0, onSet, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      default_0 = 0;
    if (!(($mask0 & 2) === 0)) {
      onSet = _no_name_provided_$factory_267();
    }return this.intDelegateX_iqk8fv_k$(default_0, onSet);
  };
  UniformFloatStorage.prototype.intDelegateY_iqk8fv_k$ = function (default_0, onSet) {
    return this.intDelegate_9chvei_k$(1, default_0, onSet);
  };
  UniformFloatStorage.prototype.intDelegateY$default_y6olaq_k$ = function (default_0, onSet, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      default_0 = 0;
    if (!(($mask0 & 2) === 0)) {
      onSet = _no_name_provided_$factory_268();
    }return this.intDelegateY_iqk8fv_k$(default_0, onSet);
  };
  UniformFloatStorage.prototype.boolDelegate_vz6fak_k$ = function (index_0, default_0, onSet) {
    return new BoolDelegatedUniform(this._uniform, this._array_5, index_0, onSet, default_0);
  };
  UniformFloatStorage.prototype.boolDelegateX_493drh_k$ = function (default_0, onSet) {
    return this.boolDelegate_vz6fak_k$(0, default_0, onSet);
  };
  UniformFloatStorage.prototype.boolDelegateX$default_notclq_k$ = function (default_0, onSet, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      default_0 = false;
    if (!(($mask0 & 2) === 0)) {
      onSet = _no_name_provided_$factory_269();
    }return this.boolDelegateX_493drh_k$(default_0, onSet);
  };
  UniformFloatStorage.$metadata$ = {
    simpleName: 'UniformFloatStorage',
    kind: 'class',
    interfaces: []
  };
  function storageFor(_this_, uniform, array) {
    return new UniformFloatStorage(_this_, uniform, array);
  }
  function storageFor$default(_this_, uniform, array, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      array = new Float32Array(4);
    return storageFor(_this_, uniform, array);
  }
  function IntDelegatedUniform(uniform, values_21, index_0, onSet, default_0) {
    this._uniform_0 = uniform;
    this._values_3 = values_21;
    this._index_22 = index_0;
    this._onSet = onSet;
    this._values_3[this._index_22] = default_0;
  }
  IntDelegatedUniform.prototype.getValue_1rt9ub_k$ = function (obj, prop) {
    return numberToInt(this._values_3[this._index_22]);
  };
  IntDelegatedUniform.prototype.setValue_10wnmr_k$ = function (obj, prop, value) {
    this._values_3[this._index_22] = value;
    this._onSet(value);
  };
  IntDelegatedUniform.$metadata$ = {
    simpleName: 'IntDelegatedUniform',
    kind: 'class',
    interfaces: []
  };
  function DoubleDelegatedUniform(uniform, values_21, index_0, onSet, default_0) {
    this._uniform_1 = uniform;
    this._values_4 = values_21;
    this._index_23 = index_0;
    this._onSet_0 = onSet;
    this._values_4[this._index_23] = default_0;
  }
  DoubleDelegatedUniform.prototype.getValue_1rt9ub_k$ = function (obj, prop) {
    return this._values_4[this._index_23];
  };
  DoubleDelegatedUniform.prototype.setValue_bg21lx_k$ = function (obj, prop, value) {
    this._values_4[this._index_23] = value;
    this._onSet_0(value);
  };
  DoubleDelegatedUniform.$metadata$ = {
    simpleName: 'DoubleDelegatedUniform',
    kind: 'class',
    interfaces: []
  };
  function UniformValueStorage(uniforms, uniform, value) {
    this._uniforms_3 = uniforms;
    this._uniform_2 = uniform;
    this._value_22 = value;
    this._uniforms_3.set_r39nsu_k$(this._uniform_2, this._value_22);
    Unit_getInstance();
  }
  UniformValueStorage.$metadata$ = {
    simpleName: 'UniformValueStorage',
    kind: 'class',
    interfaces: []
  };
  function storageForTextureUnit(_this_, uniform, textureUnit) {
    return new UniformValueStorage(_this_, uniform, textureUnit);
  }
  function BoolDelegatedUniform(uniform, values_21, index_0, onSet, default_0) {
    this._uniform_3 = uniform;
    this._values_5 = values_21;
    this._index_24 = index_0;
    this._onSet_1 = onSet;
    this._values_5[this._index_24] = default_0 ? 1 : 0;
  }
  BoolDelegatedUniform.$metadata$ = {
    simpleName: 'BoolDelegatedUniform',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_265() {
    var i = new _no_name_provided__317();
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_266() {
    var i = new _no_name_provided__318();
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_267() {
    var i = new _no_name_provided__319();
    return function (p1) {
      i.invoke_majfzk_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_268() {
    var i = new _no_name_provided__320();
    return function (p1) {
      i.invoke_majfzk_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_269() {
    var i = new _no_name_provided__321();
    return function (p1) {
      i.invoke_rpwsgn_k$(p1);
      return Unit_getInstance();
    };
  }
  function toNewGlslStringResult(_this_, config) {
    return (new GlslGenerator(_this_._type_14, config)).generateResult_w29vw4_k$(_this_._stm);
  }
  function Companion_167() {
    Companion_instance_166 = this;
    this._DEFAULT_VERSION = 100;
    this._FRAGCOLOR = 'fragColor';
    this._GL_FRAGCOLOR = 'gl_FragColor';
  }
  Companion_167.prototype._get_FORCE_GLSL_VERSION__0_k$ = function () {
    return Companion_getInstance_112().get_6wfw3l_k$('FORCE_GLSL_VERSION');
  };
  Companion_167.prototype._get_DEBUG_GLSL__0_k$ = function () {
    return Companion_getInstance_112().get_6wfw3l_k$('DEBUG_GLSL') === 'true';
  };
  Companion_167.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_166;
  function Companion_getInstance_166() {
    if (Companion_instance_166 == null)
      new Companion_167();
    return Companion_instance_166;
  }
  function errorType($this, type) {
    invalidOp('' + "Don't know how to serialize type " + type);
  }
  function Result(generator, result, attributes, uniforms, varyings) {
    this._generator = generator;
    this._result_4 = result;
    this._attributes_3 = attributes;
    this._uniforms_4 = uniforms;
    this._varyings = varyings;
  }
  Result.prototype.toString = function () {
    return '' + 'Result(generator=' + this._generator + ', result=' + this._result_4 + ', attributes=' + this._attributes_3 + ', uniforms=' + this._uniforms_4 + ', varyings=' + this._varyings + ')';
  };
  Result.prototype.hashCode = function () {
    var result = hashCode(this._generator);
    result = imul(result, 31) + getStringHashCode(this._result_4) | 0;
    result = imul(result, 31) + hashCode(this._attributes_3) | 0;
    result = imul(result, 31) + hashCode(this._uniforms_4) | 0;
    result = imul(result, 31) + hashCode(this._varyings) | 0;
    return result;
  };
  Result.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals_1(this._generator, tmp0_other_with_cast._generator))
      return false;
    if (!(this._result_4 === tmp0_other_with_cast._result_4))
      return false;
    if (!equals_1(this._attributes_3, tmp0_other_with_cast._attributes_3))
      return false;
    if (!equals_1(this._uniforms_4, tmp0_other_with_cast._uniforms_4))
      return false;
    if (!equals_1(this._varyings, tmp0_other_with_cast._varyings))
      return false;
    return true;
  };
  Result.$metadata$ = {
    simpleName: 'Result',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__322(this$0) {
    this._this$0_76 = this$0;
  }
  _no_name_provided__322.prototype.invoke_la1pz7_k$ = function ($this$invoke) {
    if (this._this$0_76._get_gles__0_k$()) {
      if (!this._this$0_76._get_android__0_k$()) {
        if (this._this$0_76._get_compatibility__0_k$()) {
          $this$invoke.line_6wfw3l_k$('' + '#version ' + this._this$0_76._get_version__0_k$() + ' compatibility');
          Unit_getInstance();
        } else {
          $this$invoke.line_6wfw3l_k$('' + '#version ' + this._this$0_76._get_version__0_k$());
          Unit_getInstance();
        }
      }if (this._this$0_76._config_2._programConfig_0._externalTextureSampler) {
        $this$invoke.line_6wfw3l_k$('#extension GL_OES_EGL_image_external : require');
        Unit_getInstance();
      }$this$invoke.line_6wfw3l_k$('#ifdef GL_ES');
      Unit_getInstance();
      $this$invoke._indent_sv8swh_k$();
      try {
        $this$invoke.line_6wfw3l_k$('precision highp float;');
        Unit_getInstance();
        $this$invoke.line_6wfw3l_k$('precision highp int;');
        Unit_getInstance();
        $this$invoke.line_6wfw3l_k$('precision lowp sampler2D;');
        Unit_getInstance();
        $this$invoke.line_6wfw3l_k$('precision lowp samplerCube;');
        Unit_getInstance();
      }finally {
        $this$invoke._unindent_sv8swh_k$();
      }
      Unit_getInstance();
      $this$invoke.line_6wfw3l_k$('#else');
      Unit_getInstance();
      $this$invoke._indent_sv8swh_k$();
      try {
        $this$invoke.line_6wfw3l_k$('  #define highp ');
        Unit_getInstance();
        $this$invoke.line_6wfw3l_k$('  #define mediump ');
        Unit_getInstance();
        $this$invoke.line_6wfw3l_k$('  #define lowp ');
        Unit_getInstance();
      }finally {
        $this$invoke._unindent_sv8swh_k$();
      }
      Unit_getInstance();
      $this$invoke.line_6wfw3l_k$('#endif');
      Unit_getInstance();
    }var tmp0_iterator = this._this$0_76._attributes_4.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var it = tmp0_iterator.next_0_k$();
      $this$invoke.line_6wfw3l_k$('' + this._this$0_76._IN + ' ' + this._this$0_76.precToString_ly1m2u_k$(it._get_precision__0_k$()) + this._this$0_76.typeToString_lp1abb_k$(it._get_type__0_k$()) + ' ' + it._get_name__0_k$() + this._this$0_76._get_arrayDecl__5thfx6_k$(it) + ';');
      Unit_getInstance();
    }
    var tmp1_iterator = this._this$0_76._uniforms_5.iterator_0_k$();
    while (tmp1_iterator.hasNext_0_k$()) {
      var it_0 = tmp1_iterator.next_0_k$();
      $this$invoke.line_6wfw3l_k$('' + this._this$0_76._UNIFORM + ' ' + this._this$0_76.precToString_ly1m2u_k$(it_0._get_precision__0_k$()) + this._this$0_76.typeToString_lp1abb_k$(it_0._get_type__0_k$()) + ' ' + it_0._get_name__0_k$() + this._this$0_76._get_arrayDecl__5thfx6_k$(it_0) + ';');
      Unit_getInstance();
    }
    var tmp2_iterator = this._this$0_76._varyings_0.iterator_0_k$();
    while (tmp2_iterator.hasNext_0_k$()) {
      var it_1 = tmp2_iterator.next_0_k$();
      if (this._this$0_76._newGlSlVersion ? it_1._get_name__0_k$() === this._this$0_76._gl_FragColor : false) {
        $this$invoke.line_6wfw3l_k$('' + 'layout(location=0) ' + this._this$0_76._OUT + ' ' + this._this$0_76.precToString_ly1m2u_k$(it_1._get_precision__0_k$()) + this._this$0_76.typeToString_lp1abb_k$(it_1._get_type__0_k$()) + ' ' + it_1._get_name__0_k$() + ';');
        Unit_getInstance();
      } else {
        $this$invoke.line_6wfw3l_k$('' + this._this$0_76._OUT + ' ' + this._this$0_76.precToString_ly1m2u_k$(it_1._get_precision__0_k$()) + this._this$0_76.typeToString_lp1abb_k$(it_1._get_type__0_k$()) + ' ' + it_1._get_name__0_k$() + ';');
        Unit_getInstance();
      }
    }
    var tmp;
    if (charSequenceLength('void main()') === 0) {
      tmp = '{';
    } else {
      {
        tmp = 'void main() {';
      }
    }
    $this$invoke.line_6wfw3l_k$(tmp);
    Unit_getInstance();
    $this$invoke._indent_sv8swh_k$();
    try {
      var tmp0_iterator_2 = this._this$0_76._temps.iterator_0_k$();
      while (tmp0_iterator_2.hasNext_0_k$()) {
        var temp_3 = tmp0_iterator_2.next_0_k$();
        $this$invoke.line_6wfw3l_k$(this._this$0_76.precToString_ly1m2u_k$(temp_3._get_precision__0_k$()) + this._this$0_76.typeToString_lp1abb_k$(temp_3._get_type__0_k$()) + ' ' + temp_3._get_name__0_k$() + ';');
        Unit_getInstance();
      }
      $this$invoke.line_eak92k_k$(this._this$0_76._programIndenter);
      Unit_getInstance();
    }finally {
      $this$invoke._unindent_sv8swh_k$();
    }
    Unit_getInstance();
    $this$invoke.line_6wfw3l_k$('}');
    Unit_getInstance();
    Unit_getInstance();
  };
  _no_name_provided__322.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_la1pz7_k$(p1 instanceof Indenter ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__322.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__323(this$0) {
    this._this$0_77 = this$0;
  }
  _no_name_provided__323.prototype.invoke_ojgi1d_k$ = function (it) {
    return this._this$0_77.visit_ojgi1d_k$(it);
  };
  _no_name_provided__323.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ojgi1d_k$(p1 instanceof Operand ? p1 : THROW_CCE());
  };
  _no_name_provided__323.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__324(this$0) {
    this._this$0_78 = this$0;
  }
  _no_name_provided__324.prototype.invoke_ojgi1d_k$ = function (it) {
    return this._this$0_78.visit_ojgi1d_k$(it);
  };
  _no_name_provided__324.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ojgi1d_k$(p1 instanceof Operand ? p1 : THROW_CCE());
  };
  _no_name_provided__324.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GlslGenerator(kind, config) {
    Companion_getInstance_166();
    Visitor.call(this, '');
    this._kind_2 = kind;
    this._config_2 = config;
    this._newGlSlVersion = false;
    this._IN = this._newGlSlVersion ? 'in' : 'attribute';
    this._OUT = this._newGlSlVersion ? 'out' : 'varying';
    this._UNIFORM = 'uniform';
    this._gl_FragColor = this._newGlSlVersion ? Companion_getInstance_166()._FRAGCOLOR : Companion_getInstance_166()._GL_FRAGCOLOR;
    this._temps = LinkedHashSet_init_$Create$();
    this._attributes_4 = LinkedHashSet_init_$Create$();
    this._varyings_0 = LinkedHashSet_init_$Create$();
    this._uniforms_5 = LinkedHashSet_init_$Create$();
    var tmp = this;
    tmp._programIndenter = Indenter_init_$Create$(null, 1, null);
  }
  GlslGenerator.prototype._get_gles__0_k$ = function () {
    return this._config_2._gles_0;
  };
  GlslGenerator.prototype._get_version__0_k$ = function () {
    return this._config_2._version_1;
  };
  GlslGenerator.prototype._get_compatibility__0_k$ = function () {
    return this._config_2._compatibility;
  };
  GlslGenerator.prototype._get_android__0_k$ = function () {
    return this._config_2._android_0;
  };
  GlslGenerator.prototype.precToString_ly1m2u_k$ = function (prec) {
    var tmp;
    if (!this._get_gles__0_k$()) {
      tmp = '';
    } else {
      var tmp0_subject = prec;
      var tmp_0;
      if (tmp0_subject.equals(Precision_DEFAULT_getInstance())) {
        tmp_0 = '';
      } else if (tmp0_subject.equals(Precision_LOW_getInstance())) {
        tmp_0 = 'lowp ';
      } else if (tmp0_subject.equals(Precision_MEDIUM_getInstance())) {
        tmp_0 = 'mediump ';
      } else if (tmp0_subject.equals(Precision_HIGH_getInstance())) {
        tmp_0 = 'highp ';
      } else {
        noWhenBranchMatchedException();
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  GlslGenerator.prototype.typeToString_lp1abb_k$ = function (type) {
    var tmp0_subject = type;
    var tmp;
    if (tmp0_subject.equals(VarType_Byte4_getInstance())) {
      tmp = 'vec4';
    } else if (tmp0_subject.equals(VarType_Mat2_getInstance())) {
      tmp = 'mat2';
    } else if (tmp0_subject.equals(VarType_Mat3_getInstance())) {
      tmp = 'mat3';
    } else if (tmp0_subject.equals(VarType_Mat4_getInstance())) {
      tmp = 'mat4';
    } else if (tmp0_subject.equals(VarType_TextureUnit_getInstance())) {
      tmp = this._config_2._programConfig_0._externalTextureSampler ? 'samplerExternalOES' : 'sampler2D';
    } else if (tmp0_subject.equals(VarType_Sampler1D_getInstance())) {
      tmp = 'sampler1d';
    } else if (tmp0_subject.equals(VarType_Sampler2D_getInstance())) {
      tmp = 'sampler2d';
    } else if (tmp0_subject.equals(VarType_Sampler3D_getInstance())) {
      tmp = 'sampler3d';
    } else if (tmp0_subject.equals(VarType_SamplerCube_getInstance())) {
      tmp = 'samplerCube';
    } else {
      var tmp1_subject = type._kind_3;
      var tmp_0;
      if ((((tmp1_subject.equals(VarKind_TBYTE_getInstance()) ? true : tmp1_subject.equals(VarKind_TUNSIGNED_BYTE_getInstance())) ? true : tmp1_subject.equals(VarKind_TSHORT_getInstance())) ? true : tmp1_subject.equals(VarKind_TUNSIGNED_SHORT_getInstance())) ? true : tmp1_subject.equals(VarKind_TFLOAT_getInstance())) {
        var tmp2_subject = type._elementCount;
        var tmp_1;
        switch (tmp2_subject) {
          case 1:
            tmp_1 = 'float';
            break;
          case 2:
            tmp_1 = 'vec2';
            break;
          case 3:
            tmp_1 = 'vec3';
            break;
          case 4:
            tmp_1 = 'vec4';
            break;
          default:errorType(this, type);
            break;
        }
        tmp_0 = tmp_1;
      } else if (tmp1_subject.equals(VarKind_TINT_getInstance())) {
        var tmp3_subject = type._elementCount;
        var tmp_2;
        switch (tmp3_subject) {
          case 1:
            tmp_2 = 'int';
            break;
          case 2:
            tmp_2 = 'ivec2';
            break;
          case 3:
            tmp_2 = 'ivec3';
            break;
          case 4:
            tmp_2 = 'ivec4';
            break;
          default:errorType(this, type);
            break;
        }
        tmp_0 = tmp_2;
      } else {
        noWhenBranchMatchedException();
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  GlslGenerator.prototype._get_arrayDecl__5thfx6_k$ = function (_this__0) {
    return !(_this__0._arrayCount === 1) ? '' + '[' + _this__0._arrayCount + ']' : '';
  };
  GlslGenerator.prototype.generateResult_w29vw4_k$ = function (root) {
    this._temps.clear_sv8swh_k$();
    this._attributes_4.clear_sv8swh_k$();
    this._varyings_0.clear_sv8swh_k$();
    this._uniforms_5.clear_sv8swh_k$();
    var tmp = this;
    tmp._programIndenter = Indenter_init_$Create$(null, 1, null);
    if (this._kind_2.equals(ShaderType_FRAGMENT_getInstance()) ? this._newGlSlVersion : false) {
      var tmp_0 = VarType_Float4_getInstance();
      this._varyings_0.add_2bq_k$(Varying_init_$Create$_0(this._gl_FragColor, tmp_0, null, 4, null));
      Unit_getInstance();
    }this.visit_sax4m5_k$(root);
    var tmp_1 = Companion_getInstance_121();
    var tmp0_also_0 = tmp_1.invoke_mwdkab_k$(_no_name_provided_$factory_270(this)).toString();
    if (Companion_getInstance_166()._get_DEBUG_GLSL__0_k$()) {
      Console_getInstance().info_c2g51s_k$(['' + 'GlSlGenerator.version: ' + this._get_version__0_k$()]);
      Console_getInstance().debug_c2g51s_k$(['' + 'GlSlGenerator:\n' + tmp0_also_0]);
    }var result = tmp0_also_0;
    return new Result(this, result, toList_3(this._attributes_4), toList_3(this._uniforms_5), toList_3(this._varyings_0));
  };
  GlslGenerator.prototype.visit_5d7c32_k$ = function (stms) {
    var tmp0_iterator = stms._stms.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var stm = tmp0_iterator.next_0_k$();
      this.visit_sax4m5_k$(stm);
    }
  };
  GlslGenerator.prototype.visit_kk29w9_k$ = function (stm) {
    this._programIndenter.line_6wfw3l_k$('' + this.visit_ojgi1d_k$(stm._to) + ' = ' + this.visit_ojgi1d_k$(stm._from) + ';');
    Unit_getInstance();
  };
  GlslGenerator.prototype.visit_tdgqwb_k$ = function (stm) {
    this._programIndenter.line_6wfw3l_k$('discard;');
    Unit_getInstance();
  };
  GlslGenerator.prototype.visit_s53cxx_k$ = function (operand) {
    var tmp = this.typeToString_lp1abb_k$(operand._type_11) + '(';
    return tmp + joinToString$default(operand._ops, ', ', null, null, 0, null, _no_name_provided_$factory_271(this), 30, null) + ')';
  };
  GlslGenerator.prototype.visit_eyiwk0_k$ = function (operand) {
    return '(' + this.visit_ojgi1d_k$(operand._left_2) + ' ' + operand._op_1 + ' ' + this.visit_ojgi1d_k$(operand._right_0) + ')';
  };
  GlslGenerator.prototype.visit_hakzo_k$ = function (func) {
    var tmp = func._name_21 + '(';
    return tmp + joinToString$default_0(func._ops_0, ', ', null, null, 0, null, _no_name_provided_$factory_272(this), 30, null) + ')';
  };
  GlslGenerator.prototype.visit_1ncxbw_k$ = function (stm) {
    var tmp0_apply_0 = this._programIndenter;
    var tmp0_line_0_2 = '' + 'if (' + this.visit_ojgi1d_k$(stm._cond) + ')';
    var tmp;
    if (charSequenceLength(tmp0_line_0_2) === 0) {
      tmp = '{';
    } else {
      {
        tmp = '' + tmp0_line_0_2 + ' {';
      }
    }
    tmp0_apply_0.line_6wfw3l_k$(tmp);
    Unit_getInstance();
    tmp0_apply_0._indent_sv8swh_k$();
    try {
      this.visit_sax4m5_k$(stm._tbody);
    }finally {
      tmp0_apply_0._unindent_sv8swh_k$();
    }
    Unit_getInstance();
    tmp0_apply_0.line_6wfw3l_k$('}');
    Unit_getInstance();
    Unit_getInstance();
    if (!(stm._fbody == null)) {
      var tmp_0;
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        {
          tmp_0 = 'else {';
        }
      }
      tmp0_apply_0.line_6wfw3l_k$(tmp_0);
      Unit_getInstance();
      tmp0_apply_0._indent_sv8swh_k$();
      try {
        this.visit_sax4m5_k$(ensureNotNull(stm._fbody));
      }finally {
        tmp0_apply_0._unindent_sv8swh_k$();
      }
      Unit_getInstance();
      tmp0_apply_0.line_6wfw3l_k$('}');
      Unit_getInstance();
      Unit_getInstance();
    }Unit_getInstance();
  };
  GlslGenerator.prototype.visit_wyzbbg_k$ = function (operand) {
    Visitor.prototype.visit_wyzbbg_k$.call(this, operand);
    Unit_getInstance();
    var tmp0_subject = operand;
    var tmp;
    if (tmp0_subject instanceof Output_0) {
      var tmp1_subject = this._kind_2;
      var tmp_0;
      if (tmp1_subject.equals(ShaderType_VERTEX_getInstance())) {
        tmp_0 = 'gl_Position';
      } else if (tmp1_subject.equals(ShaderType_FRAGMENT_getInstance())) {
        tmp_0 = this._gl_FragColor;
      } else {
        noWhenBranchMatchedException();
      }
      tmp = tmp_0;
    } else {
      {
        tmp = operand._name_23;
      }
    }
    return tmp;
  };
  GlslGenerator.prototype.visit_h1z1w_k$ = function (temp_0) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._temps;
    tmp0_plusAssign_0.add_2bq_k$(temp_0);
    Unit_getInstance();
    return Visitor.prototype.visit_h1z1w_k$.call(this, temp_0);
  };
  GlslGenerator.prototype.visit_q3xq70_k$ = function (attribute) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._attributes_4;
    tmp0_plusAssign_0.add_2bq_k$(attribute);
    Unit_getInstance();
    return Visitor.prototype.visit_q3xq70_k$.call(this, attribute);
  };
  GlslGenerator.prototype.visit_lodzpk_k$ = function (varying) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._varyings_0;
    tmp0_plusAssign_0.add_2bq_k$(varying);
    Unit_getInstance();
    return Visitor.prototype.visit_lodzpk_k$.call(this, varying);
  };
  GlslGenerator.prototype.visit_uchcck_k$ = function (uniform) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._uniforms_5;
    tmp0_plusAssign_0.add_2bq_k$(uniform);
    Unit_getInstance();
    return Visitor.prototype.visit_uchcck_k$.call(this, uniform);
  };
  GlslGenerator.prototype.visit_v7b893_k$ = function (output_0) {
    return Visitor.prototype.visit_v7b893_k$.call(this, output_0);
  };
  GlslGenerator.prototype.visit_5zwz48_k$ = function (operand) {
    return '' + operand._value_23;
  };
  GlslGenerator.prototype.visit_fjdg6j_k$ = function (operand) {
    var str = '' + operand._value_24;
    var tmp;
    var tmp_0 = new Char(46);
    if (contains$default(str, tmp_0, false, 2, null)) {
      tmp = str;
    } else {
      {
        tmp = '' + str + '.0';
      }
    }
    return tmp;
  };
  GlslGenerator.prototype.visit_kq5s6l_k$ = function (operand) {
    return '' + operand._value_25;
  };
  GlslGenerator.prototype.visit_fllqh2_k$ = function (operand) {
    return this.visit_ojgi1d_k$(operand._left_3) + '.' + operand._swizzle;
  };
  GlslGenerator.prototype.visit_8uyul7_k$ = function (operand) {
    return this.visit_ojgi1d_k$(operand._left_4) + '[' + this.visit_ojgi1d_k$(operand._index_25) + ']';
  };
  GlslGenerator.$metadata$ = {
    simpleName: 'GlslGenerator',
    kind: 'class',
    interfaces: []
  };
  function GlslConfig(gles, version, compatibility, android, programConfig) {
    this._gles_0 = gles;
    this._version_1 = version;
    this._compatibility = compatibility;
    this._android_0 = android;
    this._programConfig_0 = programConfig;
  }
  GlslConfig.prototype.toString = function () {
    return '' + 'GlslConfig(gles=' + this._gles_0 + ', version=' + this._version_1 + ', compatibility=' + this._compatibility + ', android=' + this._android_0 + ', programConfig=' + this._programConfig_0 + ')';
  };
  GlslConfig.prototype.hashCode = function () {
    var result = this._gles_0 | 0;
    result = imul(result, 31) + this._version_1 | 0;
    result = imul(result, 31) + (this._compatibility | 0) | 0;
    result = imul(result, 31) + (this._android_0 | 0) | 0;
    result = imul(result, 31) + this._programConfig_0.hashCode() | 0;
    return result;
  };
  GlslConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this._gles_0 === tmp0_other_with_cast._gles_0))
      return false;
    if (!(this._version_1 === tmp0_other_with_cast._version_1))
      return false;
    if (!(this._compatibility === tmp0_other_with_cast._compatibility))
      return false;
    if (!(this._android_0 === tmp0_other_with_cast._android_0))
      return false;
    if (!this._programConfig_0.equals(tmp0_other_with_cast._programConfig_0))
      return false;
    return true;
  };
  GlslConfig.$metadata$ = {
    simpleName: 'GlslConfig',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_270(this$0) {
    var i = new _no_name_provided__322(this$0);
    return function (p1) {
      i.invoke_la1pz7_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_271(this$0) {
    var i = new _no_name_provided__323(this$0);
    return function (p1) {
      return i.invoke_ojgi1d_k$(p1);
    };
  }
  function _no_name_provided_$factory_272(this$0) {
    var i = new _no_name_provided__324(this$0);
    return function (p1) {
      return i.invoke_ojgi1d_k$(p1);
    };
  }
  function Func_init_$Init$(name, ops, $this) {
    Func.call($this, name, toList(ops));
    return $this;
  }
  function Func_init_$Create$(name, ops) {
    return Func_init_$Init$(name, ops, Object.create(Func.prototype));
  }
  function If_init_$Init$(cond, tbody, fbody, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      fbody = null;
    If.call($this, cond, tbody, fbody);
    return $this;
  }
  function If_init_$Create$(cond, tbody, fbody, $mask0, $marker) {
    return If_init_$Init$(cond, tbody, fbody, $mask0, $marker, Object.create(If.prototype));
  }
  function Stms(stms) {
    Stm.call(this);
    this._stms = stms;
  }
  Stms.prototype.toString = function () {
    return '' + 'Stms(stms=' + this._stms + ')';
  };
  Stms.prototype.hashCode = function () {
    return hashCode(this._stms);
  };
  Stms.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals_1(this._stms, tmp0_other_with_cast._stms))
      return false;
    return true;
  };
  Stms.$metadata$ = {
    simpleName: 'Stms',
    kind: 'class',
    interfaces: []
  };
  function Set_0(to_0, from) {
    Stm.call(this);
    this._to = to_0;
    this._from = from;
  }
  Set_0.prototype.toString = function () {
    return '' + 'Set(to=' + this._to + ', from=' + this._from + ')';
  };
  Set_0.prototype.hashCode = function () {
    var result = hashCode(this._to);
    result = imul(result, 31) + hashCode(this._from) | 0;
    return result;
  };
  Set_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Set_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Set_0 ? other : THROW_CCE();
    if (!equals_1(this._to, tmp0_other_with_cast._to))
      return false;
    if (!equals_1(this._from, tmp0_other_with_cast._from))
      return false;
    return true;
  };
  Set_0.$metadata$ = {
    simpleName: 'Set',
    kind: 'class',
    interfaces: []
  };
  function Discard() {
    Stm.call(this);
  }
  Discard.prototype.equals = function (other) {
    return other instanceof Discard;
  };
  Discard.prototype.hashCode = function () {
    return 1;
  };
  Discard.$metadata$ = {
    simpleName: 'Discard',
    kind: 'class',
    interfaces: []
  };
  function If(cond, tbody, fbody) {
    Stm.call(this);
    this._cond = cond;
    this._tbody = tbody;
    this._fbody = fbody;
  }
  If.prototype.toString = function () {
    return '' + 'If(cond=' + this._cond + ', tbody=' + this._tbody + ', fbody=' + this._fbody + ')';
  };
  If.prototype.hashCode = function () {
    var result = hashCode(this._cond);
    result = imul(result, 31) + hashCode(this._tbody) | 0;
    result = imul(result, 31) + (this._fbody == null ? 0 : hashCode(this._fbody)) | 0;
    return result;
  };
  If.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals_1(this._cond, tmp0_other_with_cast._cond))
      return false;
    if (!equals_1(this._tbody, tmp0_other_with_cast._tbody))
      return false;
    if (!equals_1(this._fbody, tmp0_other_with_cast._fbody))
      return false;
    return true;
  };
  If.$metadata$ = {
    simpleName: 'If',
    kind: 'class',
    interfaces: []
  };
  function Program_init_$Init$(vertex, fragment, name, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      name = 'program';
    Program.call($this, vertex, fragment, name);
    return $this;
  }
  function Program_init_$Create$(vertex, fragment, name, $mask0, $marker) {
    return Program_init_$Init$(vertex, fragment, name, $mask0, $marker, Object.create(Program.prototype));
  }
  function Binop(left, op, right) {
    Operand.call(this, left._get_type__0_k$());
    this._left_2 = left;
    this._op_1 = op;
    this._right_0 = right;
  }
  Binop.prototype.toString = function () {
    return '' + 'Binop(left=' + this._left_2 + ', op=' + this._op_1 + ', right=' + this._right_0 + ')';
  };
  Binop.prototype.hashCode = function () {
    var result = hashCode(this._left_2);
    result = imul(result, 31) + getStringHashCode(this._op_1) | 0;
    result = imul(result, 31) + hashCode(this._right_0) | 0;
    return result;
  };
  Binop.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals_1(this._left_2, tmp0_other_with_cast._left_2))
      return false;
    if (!(this._op_1 === tmp0_other_with_cast._op_1))
      return false;
    if (!equals_1(this._right_0, tmp0_other_with_cast._right_0))
      return false;
    return true;
  };
  Binop.$metadata$ = {
    simpleName: 'Binop',
    kind: 'class',
    interfaces: []
  };
  function IntLiteral() {
  }
  IntLiteral.$metadata$ = {
    simpleName: 'IntLiteral',
    kind: 'class',
    interfaces: []
  };
  function FloatLiteral(value) {
    Operand.call(this, VarType_Float1_getInstance());
    this._value_24 = value;
  }
  FloatLiteral.prototype.toString = function () {
    return '' + 'FloatLiteral(value=' + this._value_24 + ')';
  };
  FloatLiteral.prototype.hashCode = function () {
    return getNumberHashCode(this._value_24);
  };
  FloatLiteral.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals_1(this._value_24, tmp0_other_with_cast._value_24))
      return false;
    return true;
  };
  FloatLiteral.$metadata$ = {
    simpleName: 'FloatLiteral',
    kind: 'class',
    interfaces: []
  };
  function BoolLiteral() {
  }
  BoolLiteral.$metadata$ = {
    simpleName: 'BoolLiteral',
    kind: 'class',
    interfaces: []
  };
  function Vector(type, ops) {
    Operand.call(this, type);
    this._type_11 = type;
    this._ops = ops;
  }
  Vector.prototype._get_type__0_k$ = function () {
    return this._type_11;
  };
  Vector.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this._type_11.equals(other._type_11);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = contentEquals_11(this._ops, other._ops);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Vector.prototype.hashCode = function () {
    return imul(this._type_11.hashCode(), 7) + contentHashCode_8(this._ops) | 0;
  };
  Vector.prototype.toString = function () {
    return '' + 'Vector(type=' + this._type_11 + ', ops=' + toString_1(this._ops) + ')';
  };
  Vector.$metadata$ = {
    simpleName: 'Vector',
    kind: 'class',
    interfaces: []
  };
  function Swizzle(left, swizzle) {
    Operand.call(this, left._get_type__0_k$());
    this._left_3 = left;
    this._swizzle = swizzle;
  }
  Swizzle.prototype.toString = function () {
    return '' + 'Swizzle(left=' + this._left_3 + ', swizzle=' + this._swizzle + ')';
  };
  Swizzle.prototype.hashCode = function () {
    var result = hashCode(this._left_3);
    result = imul(result, 31) + getStringHashCode(this._swizzle) | 0;
    return result;
  };
  Swizzle.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals_1(this._left_3, tmp0_other_with_cast._left_3))
      return false;
    if (!(this._swizzle === tmp0_other_with_cast._swizzle))
      return false;
    return true;
  };
  Swizzle.$metadata$ = {
    simpleName: 'Swizzle',
    kind: 'class',
    interfaces: []
  };
  function ArrayAccess() {
  }
  ArrayAccess.$metadata$ = {
    simpleName: 'ArrayAccess',
    kind: 'class',
    interfaces: []
  };
  function Func(name, ops) {
    Operand.call(this, VarType_Float1_getInstance());
    this._name_21 = name;
    this._ops_0 = ops;
  }
  Func.prototype.toString = function () {
    return '' + 'Func(name=' + this._name_21 + ', ops=' + this._ops_0 + ')';
  };
  Func.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_21);
    result = imul(result, 31) + hashCode(this._ops_0) | 0;
    return result;
  };
  Func.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this._name_21 === tmp0_other_with_cast._name_21))
      return false;
    if (!equals_1(this._ops_0, tmp0_other_with_cast._ops_0))
      return false;
    return true;
  };
  Func.$metadata$ = {
    simpleName: 'Func',
    kind: 'class',
    interfaces: []
  };
  function Stm() {
  }
  Stm.$metadata$ = {
    simpleName: 'Stm',
    kind: 'class',
    interfaces: []
  };
  function Builder(type) {
    this._type_12 = type;
    var tmp = this;
    tmp._outputStms = ArrayList_init_$Create$();
    this._tempLastId = 3;
    this._out_8 = Output_getInstance();
  }
  Builder.prototype.ELSE_p4ir4u_k$ = function (_this__0, callback) {
    var body = new Builder(this._type_12);
    callback(body);
    _this__0._fbody = new Stms(body._outputStms);
  };
  Builder.prototype.SET_k3gp7z_k$ = function (target, expr) {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._outputStms;
    var tmp1_plusAssign_0_4 = new Set_0(target, expr);
    tmp0_plusAssign_0_3.add_2bq_k$(tmp1_plusAssign_0_4);
    return Unit_getInstance();
  };
  Builder.prototype.DISCARD_sv8swh_k$ = function () {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._outputStms;
    var tmp1_plusAssign_0_4 = new Discard();
    tmp0_plusAssign_0_3.add_2bq_k$(tmp1_plusAssign_0_4);
    return Unit_getInstance();
  };
  Builder.prototype.set_ag43kx_k$ = function (_this__0, from) {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._outputStms;
    var tmp1_plusAssign_0_4 = new Set_0(_this__0, from);
    tmp0_plusAssign_0_3.add_2bq_k$(tmp1_plusAssign_0_4);
    return Unit_getInstance();
  };
  Builder.prototype.setTo_ag43kx_k$ = function (_this__0, from) {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._outputStms;
    var tmp1_plusAssign_0_4 = new Set_0(_this__0, from);
    tmp0_plusAssign_0_3.add_2bq_k$(tmp1_plusAssign_0_4);
    return Unit_getInstance();
  };
  Builder.prototype.sin_ojgi1d_k$ = function (arg) {
    return Func_init_$Create$('sin', [arg]);
  };
  Builder.prototype.texture2D_s4jwrm_k$ = function (a, b) {
    return Func_init_$Create$('texture2D', [a, b]);
  };
  Builder.prototype.clamp_h5nd2r_k$ = function (v, min_0, max) {
    return Func_init_$Create$('clamp', [v, min_0, max]);
  };
  Builder.prototype._get_lit__xaho5p_k$ = function (_this__0) {
    return new FloatLiteral(_this__0);
  };
  Builder.prototype._get_lit__a9njmo_k$ = function (_this__0) {
    return new FloatLiteral(_this__0);
  };
  Builder.prototype.vec2_ldyooh_k$ = function (ops) {
    var tmp = VarType_Float2_getInstance();
    return new Vector(tmp, isArray(ops) ? ops : THROW_CCE());
  };
  Builder.prototype.vec4_ldyooh_k$ = function (ops) {
    var tmp = VarType_Float4_getInstance();
    return new Vector(tmp, isArray(ops) ? ops : THROW_CCE());
  };
  Builder.prototype.get_v2sg9q_k$ = function (_this__0, swizzle) {
    return new Swizzle(_this__0, swizzle);
  };
  Builder.prototype._get_x__mp8w81_k$ = function (_this__0) {
    return this.get_v2sg9q_k$(_this__0, 'x');
  };
  Builder.prototype._get_y__mp8w81_k$ = function (_this__0) {
    return this.get_v2sg9q_k$(_this__0, 'y');
  };
  Builder.prototype._get_r__mp8w81_k$ = function (_this__0) {
    return this.get_v2sg9q_k$(_this__0, 'x');
  };
  Builder.prototype.minus_l29sts_k$ = function (_this__0, that) {
    return new Binop(_this__0, '-', that);
  };
  Builder.prototype.plus_l29sts_k$ = function (_this__0, that) {
    return new Binop(_this__0, '+', that);
  };
  Builder.prototype.times_l29sts_k$ = function (_this__0, that) {
    return new Binop(_this__0, '*', that);
  };
  Builder.prototype.div_l29sts_k$ = function (_this__0, that) {
    return new Binop(_this__0, '/', that);
  };
  Builder.prototype.eq_l29sts_k$ = function (_this__0, that) {
    return new Binop(_this__0, '==', that);
  };
  Builder.prototype.ne_l29sts_k$ = function (_this__0, that) {
    return new Binop(_this__0, '!=', that);
  };
  Builder.prototype.le_l29sts_k$ = function (_this__0, that) {
    return new Binop(_this__0, '<=', that);
  };
  Builder.prototype.ge_l29sts_k$ = function (_this__0, that) {
    return new Binop(_this__0, '>=', that);
  };
  Builder.$metadata$ = {
    simpleName: 'Builder',
    kind: 'class',
    interfaces: []
  };
  function Visitor(default_0) {
    this._default_0 = default_0;
  }
  Visitor.prototype.visit_sax4m5_k$ = function (stm) {
    var tmp0_subject = stm;
    var tmp;
    if (tmp0_subject instanceof Stms) {
      tmp = this.visit_5d7c32_k$(stm);
    } else {
      if (tmp0_subject instanceof Set_0) {
        tmp = this.visit_kk29w9_k$(stm);
      } else {
        if (tmp0_subject instanceof If) {
          tmp = this.visit_1ncxbw_k$(stm);
        } else {
          if (tmp0_subject instanceof Discard) {
            tmp = this.visit_tdgqwb_k$(stm);
          } else {
            {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
    return tmp;
  };
  Visitor.prototype.visit_5d7c32_k$ = function (stms) {
    var tmp0_iterator = stms._stms.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var stm = tmp0_iterator.next_0_k$();
      this.visit_sax4m5_k$(stm);
    }
  };
  Visitor.prototype.visit_1ncxbw_k$ = function (stm) {
    this.visit_ojgi1d_k$(stm._cond);
    Unit_getInstance();
    this.visit_sax4m5_k$(stm._tbody);
  };
  Visitor.prototype.visit_kk29w9_k$ = function (stm) {
    this.visit_ojgi1d_k$(stm._from);
    Unit_getInstance();
    this.visit_ojgi1d_k$(stm._to);
    Unit_getInstance();
  };
  Visitor.prototype.visit_tdgqwb_k$ = function (stm) {
  };
  Visitor.prototype.visit_ojgi1d_k$ = function (operand) {
    var tmp0_subject = operand;
    var tmp;
    if (tmp0_subject instanceof Variable) {
      tmp = this.visit_wyzbbg_k$(operand);
    } else {
      if (tmp0_subject instanceof Binop) {
        tmp = this.visit_eyiwk0_k$(operand);
      } else {
        if (tmp0_subject instanceof BoolLiteral) {
          tmp = this.visit_kq5s6l_k$(operand);
        } else {
          if (tmp0_subject instanceof IntLiteral) {
            tmp = this.visit_5zwz48_k$(operand);
          } else {
            if (tmp0_subject instanceof FloatLiteral) {
              tmp = this.visit_fjdg6j_k$(operand);
            } else {
              if (tmp0_subject instanceof Vector) {
                tmp = this.visit_s53cxx_k$(operand);
              } else {
                if (tmp0_subject instanceof Swizzle) {
                  tmp = this.visit_fllqh2_k$(operand);
                } else {
                  if (tmp0_subject instanceof ArrayAccess) {
                    tmp = this.visit_8uyul7_k$(operand);
                  } else {
                    if (tmp0_subject instanceof Func) {
                      tmp = this.visit_hakzo_k$(operand);
                    } else {
                      {
                        invalidOp('' + "Don't know how to visit operand " + operand);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  Visitor.prototype.visit_hakzo_k$ = function (func) {
    var tmp0_iterator = func._ops_0.iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var op = tmp0_iterator.next_0_k$();
      this.visit_ojgi1d_k$(op);
      Unit_getInstance();
    }
    return this._default_0;
  };
  Visitor.prototype.visit_wyzbbg_k$ = function (operand) {
    var tmp0_subject = operand;
    var tmp;
    if (tmp0_subject instanceof Attribute) {
      tmp = this.visit_q3xq70_k$(operand);
    } else {
      if (tmp0_subject instanceof Varying) {
        tmp = this.visit_lodzpk_k$(operand);
      } else {
        if (tmp0_subject instanceof Uniform) {
          tmp = this.visit_uchcck_k$(operand);
        } else {
          if (tmp0_subject instanceof Output_0) {
            tmp = this.visit_v7b893_k$(operand);
          } else {
            if (tmp0_subject instanceof Temp_0) {
              tmp = this.visit_h1z1w_k$(operand);
            } else {
              {
                invalidOp('' + "Don't know how to visit basename " + operand);
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  Visitor.prototype.visit_h1z1w_k$ = function (temp_0) {
    return this._default_0;
  };
  Visitor.prototype.visit_q3xq70_k$ = function (attribute) {
    return this._default_0;
  };
  Visitor.prototype.visit_lodzpk_k$ = function (varying) {
    return this._default_0;
  };
  Visitor.prototype.visit_uchcck_k$ = function (uniform) {
    return this._default_0;
  };
  Visitor.prototype.visit_v7b893_k$ = function (output_0) {
    return this._default_0;
  };
  Visitor.prototype.visit_eyiwk0_k$ = function (operand) {
    this.visit_ojgi1d_k$(operand._left_2);
    Unit_getInstance();
    this.visit_ojgi1d_k$(operand._right_0);
    Unit_getInstance();
    return this._default_0;
  };
  Visitor.prototype.visit_fllqh2_k$ = function (operand) {
    this.visit_ojgi1d_k$(operand._left_3);
    Unit_getInstance();
    return this._default_0;
  };
  Visitor.prototype.visit_8uyul7_k$ = function (operand) {
    this.visit_ojgi1d_k$(operand._left_4);
    Unit_getInstance();
    this.visit_ojgi1d_k$(operand._index_25);
    Unit_getInstance();
    return this._default_0;
  };
  Visitor.prototype.visit_s53cxx_k$ = function (operand) {
    var indexedObject = operand._ops;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.visit_ojgi1d_k$(op);
      Unit_getInstance();
    }
    return this._default_0;
  };
  Visitor.prototype.visit_5zwz48_k$ = function (operand) {
    return this._default_0;
  };
  Visitor.prototype.visit_fjdg6j_k$ = function (operand) {
    return this._default_0;
  };
  Visitor.prototype.visit_kq5s6l_k$ = function (operand) {
    return this._default_0;
  };
  Visitor.$metadata$ = {
    simpleName: 'Visitor',
    kind: 'class',
    interfaces: []
  };
  function Program(vertex, fragment, name) {
    this._vertex = vertex;
    this._fragment_0 = fragment;
    this._name_22 = name;
    this._uniforms_6 = plus_2(this._vertex._get_uniforms__0_k$(), this._fragment_0._get_uniforms__0_k$());
    this._attributes_5 = plus_2(this._vertex._get_attributes__0_k$(), this._fragment_0._get_attributes__0_k$());
    this._cachedHashCode_0 = (imul(this._vertex.hashCode(), 11) + imul(this._fragment_0.hashCode(), 7) | 0) + getStringHashCode(this._name_22) | 0;
  }
  Program.prototype.hashCode = function () {
    return this._cachedHashCode_0;
  };
  Program.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof Program) {
      tmp_1 = this._vertex.equals(other._vertex);
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._fragment_0.equals(other._fragment_0);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_22 === other._name_22;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Program.prototype.close_sv8swh_k$ = function () {
  };
  Program.prototype.toString = function () {
    var tmp0_map_0 = this._attributes_5;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(item_2_3._get_name__0_k$());
      Unit_getInstance();
    }
    var tmp1_map_0 = this._uniforms_6;
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp1_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var item_2_3_0 = tmp0_iterator_1_2_0.next_0_k$();
      tmp0_mapTo_0_1_0.add_2bq_k$(item_2_3_0._get_name__0_k$());
      Unit_getInstance();
    }
    return '' + 'Program(name=' + this._name_22 + ', attributes=' + tmp0_mapTo_0_1 + ', uniforms=' + tmp0_mapTo_0_1_0 + ')';
  };
  Program.$metadata$ = {
    simpleName: 'Program',
    kind: 'class',
    interfaces: [Closeable]
  };
  function Uniform_init_$Init$(name, type, precision, $this) {
    Uniform.call($this, name, type, 1, precision);
    return $this;
  }
  function Uniform_init_$Init$_0(name, type, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      precision = Precision_DEFAULT_getInstance();
    Uniform_init_$Init$(name, type, precision, $this);
    return $this;
  }
  function Uniform_init_$Create$(name, type, precision, $mask0, $marker) {
    return Uniform_init_$Init$_0(name, type, precision, $mask0, $marker, Object.create(Uniform.prototype));
  }
  function Uniform(name, type, arrayCount, precision) {
    Variable.call(this, name, type, arrayCount, precision);
  }
  Uniform.prototype.toString = function () {
    return '' + 'Uniform(' + this._get_name__0_k$() + ')';
  };
  Uniform.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this._id_16 === other._id_16;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__0_k$().equals(other._get_type__0_k$());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Uniform.prototype.hashCode = function () {
    return (this._id_16 + imul(this._get_type__0_k$().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Uniform.$metadata$ = {
    simpleName: 'Uniform',
    kind: 'class',
    interfaces: []
  };
  function Attribute_init_$Init$(name, type, normalized, offset_0, active, precision, divisor, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      offset_0 = null;
    if (!(($mask0 & 16) === 0))
      active = true;
    if (!(($mask0 & 32) === 0))
      precision = Precision_DEFAULT_getInstance();
    if (!(($mask0 & 64) === 0))
      divisor = 0;
    Attribute.call($this, name, type, normalized, offset_0, active, precision, divisor);
    return $this;
  }
  function Attribute_init_$Init$_0(name, type, normalized, precision, $this) {
    Attribute_init_$Init$(name, type, normalized, null, true, precision, 0, 64, null, $this);
    return $this;
  }
  function Attribute_init_$Create$(name, type, normalized, precision) {
    return Attribute_init_$Init$_0(name, type, normalized, precision, Object.create(Attribute.prototype));
  }
  function Attribute_init_$Init$_1(name, type, normalized, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      precision = Precision_DEFAULT_getInstance();
    Attribute_init_$Init$_0(name, type, normalized, precision, $this);
    return $this;
  }
  function Attribute_init_$Create$_0(name, type, normalized, precision, $mask0, $marker) {
    return Attribute_init_$Init$_1(name, type, normalized, precision, $mask0, $marker, Object.create(Attribute.prototype));
  }
  function Attribute(name, type, normalized, offset_0, active, precision, divisor) {
    Variable_init_$Init$(name, type, precision, this);
    this._normalized = normalized;
    this._offset_30 = offset_0;
    this._active_0 = active;
    this._divisor = divisor;
  }
  Attribute.prototype.toString = function () {
    return '' + 'Attribute(' + this._get_name__0_k$() + ')';
  };
  Attribute.prototype.toStringEx_0_k$ = function () {
    return '' + 'Attribute(' + this._get_name__0_k$() + ', type=' + this._get_type__0_k$() + ', normalized=' + this._normalized + ', offset=' + this._offset_30 + ', active=' + this._active_0 + ', precision=' + this._get_precision__0_k$() + ', divisor=' + this._divisor + ')';
  };
  Attribute.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this._id_16 === other._id_16;
    } else {
      {
        tmp_5 = false;
      }
    }
    if (tmp_5) {
      tmp_4 = this._get_type__0_k$().equals(other._get_type__0_k$());
    } else {
      {
        tmp_4 = false;
      }
    }
    if (tmp_4) {
      tmp_3 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_3 = false;
      }
    }
    if (tmp_3) {
      tmp_2 = this._name_23 === other._name_23;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._normalized === (other instanceof Attribute ? other : THROW_CCE())._normalized;
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._offset_30 == other._offset_30;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._active_0 === other._active_0;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Attribute.prototype.hashCode = function () {
    var out = (this._id_16 + imul(this._get_type__0_k$().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
    out = imul(out, 7);
    out = out + (this._normalized | 0) | 0;
    out = imul(out, 7);
    var tmp = out;
    var tmp0_hashCode_0 = this._offset_30;
    var tmp0_safe_receiver_2 = tmp0_hashCode_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    out = tmp + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
    out = imul(out, 7);
    out = out + (this._active_0 | 0) | 0;
    return out;
  };
  Attribute.$metadata$ = {
    simpleName: 'Attribute',
    kind: 'class',
    interfaces: []
  };
  function VarType_init_$Init$(name, ordinal, kind, elementCount, isMatrix, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      isMatrix = false;
    VarType.call($this, name, ordinal, kind, elementCount, isMatrix);
    return $this;
  }
  function VarType_init_$Create$(name, ordinal, kind, elementCount, isMatrix, $mask0, $marker) {
    return VarType_init_$Init$(name, ordinal, kind, elementCount, isMatrix, $mask0, $marker, Object.create(VarType.prototype));
  }
  var VarType_TVOID_instance;
  var VarType_Mat2_instance;
  var VarType_Mat3_instance;
  var VarType_Mat4_instance;
  var VarType_TextureUnit_instance;
  var VarType_Sampler1D_instance;
  var VarType_Sampler2D_instance;
  var VarType_Sampler3D_instance;
  var VarType_SamplerCube_instance;
  var VarType_Int1_instance;
  var VarType_Float1_instance;
  var VarType_Float2_instance;
  var VarType_Float3_instance;
  var VarType_Float4_instance;
  var VarType_Short1_instance;
  var VarType_Short2_instance;
  var VarType_Short3_instance;
  var VarType_Short4_instance;
  var VarType_Bool1_instance;
  var VarType_Byte4_instance;
  var VarType_SByte1_instance;
  var VarType_SByte2_instance;
  var VarType_SByte3_instance;
  var VarType_SByte4_instance;
  var VarType_UByte1_instance;
  var VarType_UByte2_instance;
  var VarType_UByte3_instance;
  var VarType_UByte4_instance;
  var VarType_SShort1_instance;
  var VarType_SShort2_instance;
  var VarType_SShort3_instance;
  var VarType_SShort4_instance;
  var VarType_UShort1_instance;
  var VarType_UShort2_instance;
  var VarType_UShort3_instance;
  var VarType_UShort4_instance;
  var VarType_SInt1_instance;
  var VarType_SInt2_instance;
  var VarType_SInt3_instance;
  var VarType_SInt4_instance;
  function Companion_168() {
    Companion_instance_167 = this;
  }
  Companion_168.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_167;
  function Companion_getInstance_167() {
    if (Companion_instance_167 == null)
      new Companion_168();
    return Companion_instance_167;
  }
  var VarType_entriesInitialized;
  function VarType_initEntries() {
    if (VarType_entriesInitialized)
      return Unit_getInstance();
    VarType_entriesInitialized = true;
    var tmp = VarKind_TBYTE_getInstance();
    VarType_TVOID_instance = VarType_init_$Create$('TVOID', 0, tmp, 0, false, 16, null);
    VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
    VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
    VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
    var tmp_0 = VarKind_TINT_getInstance();
    VarType_TextureUnit_instance = VarType_init_$Create$('TextureUnit', 4, tmp_0, 1, false, 16, null);
    var tmp_1 = VarKind_TFLOAT_getInstance();
    VarType_Sampler1D_instance = VarType_init_$Create$('Sampler1D', 5, tmp_1, 1, false, 16, null);
    var tmp_2 = VarKind_TFLOAT_getInstance();
    VarType_Sampler2D_instance = VarType_init_$Create$('Sampler2D', 6, tmp_2, 1, false, 16, null);
    var tmp_3 = VarKind_TFLOAT_getInstance();
    VarType_Sampler3D_instance = VarType_init_$Create$('Sampler3D', 7, tmp_3, 1, false, 16, null);
    var tmp_4 = VarKind_TFLOAT_getInstance();
    VarType_SamplerCube_instance = VarType_init_$Create$('SamplerCube', 8, tmp_4, 1, false, 16, null);
    var tmp_5 = VarKind_TINT_getInstance();
    VarType_Int1_instance = VarType_init_$Create$('Int1', 9, tmp_5, 1, false, 16, null);
    var tmp_6 = VarKind_TFLOAT_getInstance();
    VarType_Float1_instance = VarType_init_$Create$('Float1', 10, tmp_6, 1, false, 16, null);
    var tmp_7 = VarKind_TFLOAT_getInstance();
    VarType_Float2_instance = VarType_init_$Create$('Float2', 11, tmp_7, 2, false, 16, null);
    var tmp_8 = VarKind_TFLOAT_getInstance();
    VarType_Float3_instance = VarType_init_$Create$('Float3', 12, tmp_8, 3, false, 16, null);
    var tmp_9 = VarKind_TFLOAT_getInstance();
    VarType_Float4_instance = VarType_init_$Create$('Float4', 13, tmp_9, 4, false, 16, null);
    var tmp_10 = VarKind_TSHORT_getInstance();
    VarType_Short1_instance = VarType_init_$Create$('Short1', 14, tmp_10, 1, false, 16, null);
    var tmp_11 = VarKind_TSHORT_getInstance();
    VarType_Short2_instance = VarType_init_$Create$('Short2', 15, tmp_11, 2, false, 16, null);
    var tmp_12 = VarKind_TSHORT_getInstance();
    VarType_Short3_instance = VarType_init_$Create$('Short3', 16, tmp_12, 3, false, 16, null);
    var tmp_13 = VarKind_TSHORT_getInstance();
    VarType_Short4_instance = VarType_init_$Create$('Short4', 17, tmp_13, 4, false, 16, null);
    var tmp_14 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_Bool1_instance = VarType_init_$Create$('Bool1', 18, tmp_14, 1, false, 16, null);
    var tmp_15 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_Byte4_instance = VarType_init_$Create$('Byte4', 19, tmp_15, 4, false, 16, null);
    var tmp_16 = VarKind_TBYTE_getInstance();
    VarType_SByte1_instance = VarType_init_$Create$('SByte1', 20, tmp_16, 1, false, 16, null);
    var tmp_17 = VarKind_TBYTE_getInstance();
    VarType_SByte2_instance = VarType_init_$Create$('SByte2', 21, tmp_17, 2, false, 16, null);
    var tmp_18 = VarKind_TBYTE_getInstance();
    VarType_SByte3_instance = VarType_init_$Create$('SByte3', 22, tmp_18, 3, false, 16, null);
    var tmp_19 = VarKind_TBYTE_getInstance();
    VarType_SByte4_instance = VarType_init_$Create$('SByte4', 23, tmp_19, 4, false, 16, null);
    var tmp_20 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_UByte1_instance = VarType_init_$Create$('UByte1', 24, tmp_20, 1, false, 16, null);
    var tmp_21 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_UByte2_instance = VarType_init_$Create$('UByte2', 25, tmp_21, 2, false, 16, null);
    var tmp_22 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_UByte3_instance = VarType_init_$Create$('UByte3', 26, tmp_22, 3, false, 16, null);
    var tmp_23 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_UByte4_instance = VarType_init_$Create$('UByte4', 27, tmp_23, 4, false, 16, null);
    var tmp_24 = VarKind_TSHORT_getInstance();
    VarType_SShort1_instance = VarType_init_$Create$('SShort1', 28, tmp_24, 1, false, 16, null);
    var tmp_25 = VarKind_TSHORT_getInstance();
    VarType_SShort2_instance = VarType_init_$Create$('SShort2', 29, tmp_25, 2, false, 16, null);
    var tmp_26 = VarKind_TSHORT_getInstance();
    VarType_SShort3_instance = VarType_init_$Create$('SShort3', 30, tmp_26, 3, false, 16, null);
    var tmp_27 = VarKind_TSHORT_getInstance();
    VarType_SShort4_instance = VarType_init_$Create$('SShort4', 31, tmp_27, 4, false, 16, null);
    var tmp_28 = VarKind_TUNSIGNED_SHORT_getInstance();
    VarType_UShort1_instance = VarType_init_$Create$('UShort1', 32, tmp_28, 1, false, 16, null);
    var tmp_29 = VarKind_TUNSIGNED_SHORT_getInstance();
    VarType_UShort2_instance = VarType_init_$Create$('UShort2', 33, tmp_29, 2, false, 16, null);
    var tmp_30 = VarKind_TUNSIGNED_SHORT_getInstance();
    VarType_UShort3_instance = VarType_init_$Create$('UShort3', 34, tmp_30, 3, false, 16, null);
    var tmp_31 = VarKind_TUNSIGNED_SHORT_getInstance();
    VarType_UShort4_instance = VarType_init_$Create$('UShort4', 35, tmp_31, 4, false, 16, null);
    var tmp_32 = VarKind_TINT_getInstance();
    VarType_SInt1_instance = VarType_init_$Create$('SInt1', 36, tmp_32, 1, false, 16, null);
    var tmp_33 = VarKind_TINT_getInstance();
    VarType_SInt2_instance = VarType_init_$Create$('SInt2', 37, tmp_33, 2, false, 16, null);
    var tmp_34 = VarKind_TINT_getInstance();
    VarType_SInt3_instance = VarType_init_$Create$('SInt3', 38, tmp_34, 3, false, 16, null);
    var tmp_35 = VarKind_TINT_getInstance();
    VarType_SInt4_instance = VarType_init_$Create$('SInt4', 39, tmp_35, 4, false, 16, null);
    Companion_getInstance_167();
  }
  function VarType(name, ordinal, kind, elementCount, isMatrix) {
    Enum.call(this, name, ordinal);
    this._kind_3 = kind;
    this._elementCount = elementCount;
    this._isMatrix = isMatrix;
    this._bytesSize = imul(this._kind_3._bytesSize_0, this._elementCount);
  }
  VarType.$metadata$ = {
    simpleName: 'VarType',
    kind: 'class',
    interfaces: []
  };
  function Varying_init_$Init$(name, type, precision, $this) {
    Varying.call($this, name, type, 1, precision);
    return $this;
  }
  function Varying_init_$Create$(name, type, precision) {
    return Varying_init_$Init$(name, type, precision, Object.create(Varying.prototype));
  }
  function Varying_init_$Init$_0(name, type, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      precision = Precision_DEFAULT_getInstance();
    Varying_init_$Init$(name, type, precision, $this);
    return $this;
  }
  function Varying_init_$Create$_0(name, type, precision, $mask0, $marker) {
    return Varying_init_$Init$_0(name, type, precision, $mask0, $marker, Object.create(Varying.prototype));
  }
  function Varying(name, type, arrayCount, precision) {
    Variable.call(this, name, type, arrayCount, precision);
  }
  Varying.prototype.toString = function () {
    return '' + 'Varying(' + this._get_name__0_k$() + ')';
  };
  Varying.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this._id_16 === other._id_16;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__0_k$().equals(other._get_type__0_k$());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Varying.prototype.hashCode = function () {
    return (this._id_16 + imul(this._get_type__0_k$().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Varying.$metadata$ = {
    simpleName: 'Varying',
    kind: 'class',
    interfaces: []
  };
  var Precision_DEFAULT_instance;
  var Precision_LOW_instance;
  var Precision_MEDIUM_instance;
  var Precision_HIGH_instance;
  var Precision_entriesInitialized;
  function Precision_initEntries() {
    if (Precision_entriesInitialized)
      return Unit_getInstance();
    Precision_entriesInitialized = true;
    Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
    Precision_LOW_instance = new Precision('LOW', 1);
    Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
    Precision_HIGH_instance = new Precision('HIGH', 3);
  }
  function Precision(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Precision.$metadata$ = {
    simpleName: 'Precision',
    kind: 'class',
    interfaces: []
  };
  function VertexLayout_init_$Init$(attributes, $this) {
    VertexLayout.call($this, toFastList_0(attributes), null);
    return $this;
  }
  function VertexLayout_init_$Create$(attributes) {
    return VertexLayout_init_$Init$(attributes, Object.create(VertexLayout.prototype));
  }
  function _no_name_provided__325() {
  }
  _no_name_provided__325.prototype.invoke_q3xq70_k$ = function (it) {
    return it._get_name__0_k$();
  };
  _no_name_provided__325.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_q3xq70_k$(p1 instanceof Attribute ? p1 : THROW_CCE());
  };
  _no_name_provided__325.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function VertexLayout(attr, layoutSize) {
    this._layoutSize = layoutSize;
    this._myattr = attr;
    this._attributes_6 = attr;
    this.__lastPos = 0;
    var tmp = this;
    var tmp0_map_0 = this._myattr;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      var a_5 = item_2_3._get_type__0_k$()._kind_3._bytesSize_0;
      tmp0_mapTo_0_1.add_2bq_k$(a_5 <= 1 ? 1 : a_5);
      Unit_getInstance();
    }
    tmp._alignments = tmp0_mapTo_0_1;
    var tmp_0 = this;
    var tmp0_mapInt_0 = this._myattr;
    var tmp0_also_0_1 = IntArrayList_init_$Create$(0, 1, null);
    var tmp0_iterator_2_2 = tmp0_mapInt_0.iterator_0_k$();
    while (tmp0_iterator_2_2.hasNext_0_k$()) {
      var v_3_3 = tmp0_iterator_2_2.next_0_k$();
      if (!(v_3_3._offset_30 == null)) {
        this.__lastPos = v_3_3._offset_30;
      } else {
        this.__lastPos = nextAlignedTo(this.__lastPos, v_3_3._get_type__0_k$()._kind_3._bytesSize_0);
      }
      var out_5 = this.__lastPos;
      var tmp0_this_6 = this;
      tmp0_this_6.__lastPos = tmp0_this_6.__lastPos + v_3_3._get_type__0_k$()._bytesSize | 0;
      tmp0_also_0_1.add_majfzk_k$(out_5);
    }
    tmp_0._attributePositions = tmp0_also_0_1;
    var tmp_1 = this;
    var tmp0_elvis_lhs = maxOrNull(this._alignments);
    tmp_1._maxAlignment = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = this;
    var tmp0_elvis_lhs_2 = this._layoutSize;
    tmp_2._totalSize_2 = tmp0_elvis_lhs_2 == null ? nextAlignedTo(this.__lastPos, this._maxAlignment) : tmp0_elvis_lhs_2;
  }
  VertexLayout.prototype.toString = function () {
    return '' + 'VertexLayout[' + joinToString$default_0(this._myattr, ', ', null, null, 0, null, _no_name_provided_$factory_273(), 30, null) + ']';
  };
  VertexLayout.$metadata$ = {
    simpleName: 'VertexLayout',
    kind: 'class',
    interfaces: []
  };
  function VertexShader(stm) {
    Shader.call(this, ShaderType_VERTEX_getInstance(), stm);
  }
  VertexShader.$metadata$ = {
    simpleName: 'VertexShader',
    kind: 'class',
    interfaces: []
  };
  function VertexShader_0(callback) {
    var builder = new Builder(ShaderType_VERTEX_getInstance());
    callback(builder);
    return new VertexShader(new Stms(builder._outputStms));
  }
  function Output_0() {
    Output_instance = this;
    var tmp = VarType_Float4_getInstance();
    Variable_init_$Init$_0('out', tmp, null, 4, null, this);
  }
  Output_0.prototype.toString = function () {
    return 'Output';
  };
  Output_0.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output_0) {
      tmp_2 = this._id_16 === other._id_16;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__0_k$().equals(other._get_type__0_k$());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Output_0.prototype.hashCode = function () {
    return (this._id_16 + imul(this._get_type__0_k$().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Output_0.$metadata$ = {
    simpleName: 'Output',
    kind: 'object',
    interfaces: []
  };
  var Output_instance;
  function Output_getInstance() {
    if (Output_instance == null)
      new Output_0();
    return Output_instance;
  }
  function Operand(type) {
    this._type_13 = type;
  }
  Operand.prototype._get_type__0_k$ = function () {
    return this._type_13;
  };
  Operand.$metadata$ = {
    simpleName: 'Operand',
    kind: 'class',
    interfaces: []
  };
  function FragmentShader(stm) {
    Shader.call(this, ShaderType_FRAGMENT_getInstance(), stm);
  }
  FragmentShader.$metadata$ = {
    simpleName: 'FragmentShader',
    kind: 'class',
    interfaces: []
  };
  function FragmentShader_0(callback) {
    var builder = new Builder(ShaderType_FRAGMENT_getInstance());
    callback(builder);
    return new FragmentShader(new Stms(builder._outputStms));
  }
  var ShaderType_VERTEX_instance;
  var ShaderType_FRAGMENT_instance;
  var ShaderType_entriesInitialized;
  function ShaderType_initEntries() {
    if (ShaderType_entriesInitialized)
      return Unit_getInstance();
    ShaderType_entriesInitialized = true;
    ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
    ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
  }
  function ShaderType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  ShaderType.$metadata$ = {
    simpleName: 'ShaderType',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__326($out) {
    this._$out_0 = $out;
    Visitor.call(this, Unit_getInstance());
  }
  _no_name_provided__326.prototype.visit_vp7x0r_k$ = function (uniform) {
    this._$out_0.add_2bq_k$(uniform);
    return Unit_getInstance();
  };
  _no_name_provided__326.prototype.visit_uchcck_k$ = function (uniform) {
    this.visit_vp7x0r_k$(uniform);
    return Unit_getInstance();
  };
  _no_name_provided__326.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__327($out) {
    this._$out_1 = $out;
    Visitor.call(this, Unit_getInstance());
  }
  _no_name_provided__327.prototype.visit_nozep9_k$ = function (attribute) {
    this._$out_1.add_2bq_k$(attribute);
    return Unit_getInstance();
  };
  _no_name_provided__327.prototype.visit_q3xq70_k$ = function (attribute) {
    this.visit_nozep9_k$(attribute);
    return Unit_getInstance();
  };
  _no_name_provided__327.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Shader(type, stm) {
    this._type_14 = type;
    this._stm = stm;
    this._stmHashCode = hashCode(this._stm);
    this._cachedHashCode_1 = imul(this._type_14.hashCode(), 17) + this._stmHashCode | 0;
    var tmp = this;
    var tmp0_also_0 = LinkedHashSet_init_$Create$();
    (new _no_name_provided__326(tmp0_also_0)).visit_sax4m5_k$(this._stm);
    tmp._uniforms_7 = toSet_0(tmp0_also_0);
    var tmp_0 = this;
    var tmp0_also_0_0 = LinkedHashSet_init_$Create$();
    (new _no_name_provided__327(tmp0_also_0_0)).visit_sax4m5_k$(this._stm);
    tmp_0._attributes_7 = toSet_0(tmp0_also_0_0);
  }
  Shader.prototype._get_stm__0_k$ = function () {
    return this._stm;
  };
  Shader.prototype._get_uniforms__0_k$ = function () {
    return this._uniforms_7;
  };
  Shader.prototype._get_attributes__0_k$ = function () {
    return this._attributes_7;
  };
  Shader.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof Shader) {
      tmp_1 = this._type_14.equals(other._type_14);
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._stmHashCode === other._stmHashCode;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = equals_1(this._stm, other._stm);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Shader.prototype.hashCode = function () {
    return this._cachedHashCode_1;
  };
  Shader.$metadata$ = {
    simpleName: 'Shader',
    kind: 'class',
    interfaces: []
  };
  function Temp_init_$Init$(id, type, precision, $this) {
    Temp_0.call($this, id, type, 1, precision);
    return $this;
  }
  function Temp_init_$Init$_0(id, type, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      precision = Precision_DEFAULT_getInstance();
    Temp_init_$Init$(id, type, precision, $this);
    return $this;
  }
  function Temp_init_$Create$(id, type, precision, $mask0, $marker) {
    return Temp_init_$Init$_0(id, type, precision, $mask0, $marker, Object.create(Temp_0.prototype));
  }
  function Temp_0(id, type, arrayCount, precision) {
    Variable.call(this, '' + 'temp' + id, type, arrayCount, precision);
  }
  Temp_0.prototype.toString = function () {
    return '' + 'Temp(' + this._get_name__0_k$() + ')';
  };
  Temp_0.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp_0) {
      tmp_2 = this._id_16 === other._id_16;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__0_k$().equals(other._get_type__0_k$());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Temp_0.prototype.hashCode = function () {
    return (this._id_16 + imul(this._get_type__0_k$().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Temp_0.$metadata$ = {
    simpleName: 'Temp',
    kind: 'class',
    interfaces: []
  };
  function Variable_init_$Init$(name, type, precision, $this) {
    Variable.call($this, name, type, 1, precision);
    return $this;
  }
  function Variable_init_$Init$_0(name, type, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      precision = Precision_DEFAULT_getInstance();
    Variable_init_$Init$(name, type, precision, $this);
    return $this;
  }
  function Variable(name, type, arrayCount, precision) {
    Operand.call(this, type);
    this._name_23 = name;
    this._arrayCount = arrayCount;
    this._precision = precision;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this._arrayCount;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = '' + this._name_23 + '[' + tmp_3 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._indexNames = tmp_2;
    this._id_16 = 0;
    this._data_31 = null;
  }
  Variable.prototype._get_name__0_k$ = function () {
    return this._name_23;
  };
  Variable.prototype._get_arrayCount__0_k$ = function () {
    return this._arrayCount;
  };
  Variable.prototype._get_precision__0_k$ = function () {
    return this._precision;
  };
  Variable.prototype._get_indexNames__0_k$ = function () {
    return this._indexNames;
  };
  Variable.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this._id_16 === other._id_16;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__0_k$().equals(other._get_type__0_k$());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Variable.prototype.hashCode = function () {
    return (this._id_16 + imul(this._get_type__0_k$().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Variable.$metadata$ = {
    simpleName: 'Variable',
    kind: 'class',
    interfaces: []
  };
  var VarKind_TBYTE_instance;
  var VarKind_TUNSIGNED_BYTE_instance;
  var VarKind_TSHORT_instance;
  var VarKind_TUNSIGNED_SHORT_instance;
  var VarKind_TINT_instance;
  var VarKind_TFLOAT_instance;
  var VarKind_entriesInitialized;
  function VarKind_initEntries() {
    if (VarKind_entriesInitialized)
      return Unit_getInstance();
    VarKind_entriesInitialized = true;
    VarKind_TBYTE_instance = new VarKind('TBYTE', 0, 1);
    VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 1, 1);
    VarKind_TSHORT_instance = new VarKind('TSHORT', 2, 2);
    VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 3, 2);
    VarKind_TINT_instance = new VarKind('TINT', 4, 4);
    VarKind_TFLOAT_instance = new VarKind('TFLOAT', 5, 4);
  }
  function VarKind(name, ordinal, bytesSize) {
    Enum.call(this, name, ordinal);
    this._bytesSize_0 = bytesSize;
  }
  VarKind.$metadata$ = {
    simpleName: 'VarKind',
    kind: 'class',
    interfaces: []
  };
  function ProgramConfig_init_$Init$(externalTextureSampler, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      externalTextureSampler = false;
    ProgramConfig.call($this, externalTextureSampler);
    return $this;
  }
  function ProgramConfig_init_$Create$(externalTextureSampler, $mask0, $marker) {
    return ProgramConfig_init_$Init$(externalTextureSampler, $mask0, $marker, Object.create(ProgramConfig.prototype));
  }
  function Companion_169() {
    Companion_instance_168 = this;
    var tmp = this;
    tmp._DEFAULT_2 = ProgramConfig_init_$Create$(false, 1, null);
    this._EXTERNAL_TEXTURE_SAMPLER = new ProgramConfig(true);
  }
  Companion_169.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_168;
  function Companion_getInstance_168() {
    if (Companion_instance_168 == null)
      new Companion_169();
    return Companion_instance_168;
  }
  function ProgramConfig(externalTextureSampler) {
    Companion_getInstance_168();
    this._externalTextureSampler = externalTextureSampler;
  }
  ProgramConfig.prototype.toString = function () {
    return '' + 'ProgramConfig(externalTextureSampler=' + this._externalTextureSampler + ')';
  };
  ProgramConfig.prototype.hashCode = function () {
    return this._externalTextureSampler | 0;
  };
  ProgramConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProgramConfig))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProgramConfig ? other : THROW_CCE();
    if (!(this._externalTextureSampler === tmp0_other_with_cast._externalTextureSampler))
      return false;
    return true;
  };
  ProgramConfig.$metadata$ = {
    simpleName: 'ProgramConfig',
    kind: 'class',
    interfaces: []
  };
  function appending(_this_, callback) {
    return new FragmentShader(new Stms(listOf([_this_._get_stm__0_k$(), FragmentShader_0(callback)._get_stm__0_k$()])));
  }
  function VarType_Mat2_getInstance() {
    VarType_initEntries();
    return VarType_Mat2_instance;
  }
  function VarType_Mat3_getInstance() {
    VarType_initEntries();
    return VarType_Mat3_instance;
  }
  function VarType_Mat4_getInstance() {
    VarType_initEntries();
    return VarType_Mat4_instance;
  }
  function VarType_TextureUnit_getInstance() {
    VarType_initEntries();
    return VarType_TextureUnit_instance;
  }
  function VarType_Sampler1D_getInstance() {
    VarType_initEntries();
    return VarType_Sampler1D_instance;
  }
  function VarType_Sampler2D_getInstance() {
    VarType_initEntries();
    return VarType_Sampler2D_instance;
  }
  function VarType_Sampler3D_getInstance() {
    VarType_initEntries();
    return VarType_Sampler3D_instance;
  }
  function VarType_SamplerCube_getInstance() {
    VarType_initEntries();
    return VarType_SamplerCube_instance;
  }
  function VarType_Float1_getInstance() {
    VarType_initEntries();
    return VarType_Float1_instance;
  }
  function VarType_Float2_getInstance() {
    VarType_initEntries();
    return VarType_Float2_instance;
  }
  function VarType_Float3_getInstance() {
    VarType_initEntries();
    return VarType_Float3_instance;
  }
  function VarType_Float4_getInstance() {
    VarType_initEntries();
    return VarType_Float4_instance;
  }
  function VarType_Byte4_getInstance() {
    VarType_initEntries();
    return VarType_Byte4_instance;
  }
  function VarType_UByte1_getInstance() {
    VarType_initEntries();
    return VarType_UByte1_instance;
  }
  function Precision_DEFAULT_getInstance() {
    Precision_initEntries();
    return Precision_DEFAULT_instance;
  }
  function Precision_LOW_getInstance() {
    Precision_initEntries();
    return Precision_LOW_instance;
  }
  function Precision_MEDIUM_getInstance() {
    Precision_initEntries();
    return Precision_MEDIUM_instance;
  }
  function Precision_HIGH_getInstance() {
    Precision_initEntries();
    return Precision_HIGH_instance;
  }
  function ShaderType_VERTEX_getInstance() {
    ShaderType_initEntries();
    return ShaderType_VERTEX_instance;
  }
  function ShaderType_FRAGMENT_getInstance() {
    ShaderType_initEntries();
    return ShaderType_FRAGMENT_instance;
  }
  function VarKind_TBYTE_getInstance() {
    VarKind_initEntries();
    return VarKind_TBYTE_instance;
  }
  function VarKind_TUNSIGNED_BYTE_getInstance() {
    VarKind_initEntries();
    return VarKind_TUNSIGNED_BYTE_instance;
  }
  function VarKind_TSHORT_getInstance() {
    VarKind_initEntries();
    return VarKind_TSHORT_instance;
  }
  function VarKind_TUNSIGNED_SHORT_getInstance() {
    VarKind_initEntries();
    return VarKind_TUNSIGNED_SHORT_instance;
  }
  function VarKind_TINT_getInstance() {
    VarKind_initEntries();
    return VarKind_TINT_instance;
  }
  function VarKind_TFLOAT_getInstance() {
    VarKind_initEntries();
    return VarKind_TFLOAT_instance;
  }
  function _no_name_provided_$factory_273() {
    var i = new _no_name_provided__325();
    return function (p1) {
      return i.invoke_q3xq70_k$(p1);
    };
  }
  function Event_0() {
    this._target_0 = null;
    this.__stopPropagation = false;
  }
  Event_0.$metadata$ = {
    simpleName: 'Event',
    kind: 'class',
    interfaces: []
  };
  function preventDefault(reason) {
    throw new PreventDefaultException(reason);
  }
  function getHandlersFor($this, clazz) {
    if ($this._handlers_0 == null)
      return null;
    var tmp0_safe_receiver = $this._handlers_0;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_2bw_k$(clazz);
    return (tmp == null ? true : tmp instanceof FastArrayList) ? tmp : null;
  }
  function getHandlersForCreate($this, clazz) {
    if ($this._handlers_0 == null)
      $this._handlers_0 = LinkedHashMap_init_$Create$();
    var tmp0_getOrPut_0 = ensureNotNull($this._handlers_0);
    var value_1 = tmp0_getOrPut_0.get_2bw_k$(clazz);
    var tmp;
    if (value_1 == null) {
      var answer_2 = FastArrayList_init_$Create$();
      tmp0_getOrPut_0.put_1q9pf_k$(clazz, answer_2);
      Unit_getInstance();
      tmp = answer_2;
    } else {
      tmp = value_1;
    }
    var tmp_0 = tmp;
    return tmp_0 instanceof FastArrayList ? tmp_0 : THROW_CCE();
  }
  function _no_name_provided__328($handlers, $handler) {
    this._$handlers = $handlers;
    this._$handler_0 = $handler;
  }
  _no_name_provided__328.prototype.invoke_sv8swh_k$ = function () {
    this._$handlers.remove_2bq_k$(this._$handler_0);
    Unit_getInstance();
  };
  _no_name_provided__328.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__328.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Mixin_2() {
    this._handlers_0 = null;
  }
  Mixin_2.prototype.addEventListener_lfkrxw_k$ = function (clazz, handler) {
    var handlers = getHandlersForCreate(this, clazz);
    handlers.add_2bq_k$(handler);
    Unit_getInstance();
    var tmp = Companion_getInstance_111();
    return tmp.invoke_qgl0n5_k$(_no_name_provided_$factory_274(handlers, handler));
  };
  Mixin_2.prototype.dispatch_62irmi_k$ = function (clazz, event) {
    if (this._handlers_0 == null)
      return Unit_getInstance();
    var tmp0_safe_receiver = getHandlersFor(this, clazz);
    if (tmp0_safe_receiver == null)
      null;
    else {
      var array_1 = tmp0_safe_receiver._array_4;
      var n_2 = 0;
      while (n_2 < array_1.length) {
        var tmp0_4 = n_2;
        n_2 = tmp0_4 + 1 | 0;
        var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
        var tmp0__anonymous__5 = tmp0_unsafeCast_0_3;
        tmp0__anonymous__5(event);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  Mixin_2.$metadata$ = {
    simpleName: 'Mixin',
    kind: 'class',
    interfaces: [EventDispatcher]
  };
  function EventDispatcher() {
  }
  EventDispatcher.$metadata$ = {
    simpleName: 'EventDispatcher',
    kind: 'interface',
    interfaces: []
  };
  function PreventDefaultException(reason) {
    Exception_init_$Init$(this);
    this._reason = reason;
    captureStack(this, PreventDefaultException);
  }
  PreventDefaultException.$metadata$ = {
    simpleName: 'PreventDefaultException',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_274($handlers, $handler) {
    var i = new _no_name_provided__328($handlers, $handler);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  var Type_MOVE_instance;
  var Type_DRAG_instance;
  var Type_UP_instance;
  var Type_DOWN_instance;
  var Type_CLICK_instance;
  var Type_ENTER_instance;
  var Type_EXIT_instance;
  var Type_SCROLL_instance;
  var Type_entriesInitialized_4;
  function Type_initEntries_4() {
    if (Type_entriesInitialized_4)
      return Unit_getInstance();
    Type_entriesInitialized_4 = true;
    Type_MOVE_instance = new Type_4('MOVE', 0);
    Type_DRAG_instance = new Type_4('DRAG', 1);
    Type_UP_instance = new Type_4('UP', 2);
    Type_DOWN_instance = new Type_4('DOWN', 3);
    Type_CLICK_instance = new Type_4('CLICK', 4);
    Type_ENTER_instance = new Type_4('ENTER', 5);
    Type_EXIT_instance = new Type_4('EXIT', 6);
    Type_SCROLL_instance = new Type_4('SCROLL', 7);
  }
  var ScrollDeltaMode_PIXEL_instance;
  var ScrollDeltaMode_LINE_instance;
  var ScrollDeltaMode_PAGE_instance;
  var ScrollDeltaMode_entriesInitialized;
  function ScrollDeltaMode_initEntries() {
    if (ScrollDeltaMode_entriesInitialized)
      return Unit_getInstance();
    ScrollDeltaMode_entriesInitialized = true;
    ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
    ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
    ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
  }
  function MouseEvent_init_$Init$(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_MOVE_getInstance();
    if (!(($mask0 & 2) === 0))
      id = 0;
    if (!(($mask0 & 4) === 0))
      x = 0;
    if (!(($mask0 & 8) === 0))
      y = 0;
    if (!(($mask0 & 16) === 0))
      button = MouseButton_NONE_getInstance();
    if (!(($mask0 & 32) === 0))
      buttons = 0;
    if (!(($mask0 & 64) === 0))
      scrollDeltaX = 0.0;
    if (!(($mask0 & 128) === 0))
      scrollDeltaY = 0.0;
    if (!(($mask0 & 256) === 0))
      scrollDeltaZ = 0.0;
    if (!(($mask0 & 512) === 0))
      isShiftDown = false;
    if (!(($mask0 & 1024) === 0))
      isCtrlDown = false;
    if (!(($mask0 & 2048) === 0))
      isAltDown = false;
    if (!(($mask0 & 4096) === 0))
      isMetaDown = false;
    if (!(($mask0 & 8192) === 0))
      scaleCoords = true;
    if (!(($mask0 & 16384) === 0))
      emulated = false;
    MouseEvent_0.call($this, type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated);
    return $this;
  }
  function MouseEvent_init_$Create$(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, $mask0, $marker) {
    return MouseEvent_init_$Init$(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, $mask0, $marker, Object.create(MouseEvent_0.prototype));
  }
  function Type_4(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_4.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function ScrollDeltaMode(name, ordinal, scale_1) {
    Enum.call(this, name, ordinal);
    this._scale_1 = scale_1;
  }
  ScrollDeltaMode.$metadata$ = {
    simpleName: 'ScrollDeltaMode',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__329() {
  }
  _no_name_provided__329.prototype.invoke_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  _no_name_provided__329.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__329.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Type_MOVE_getInstance() {
    Type_initEntries_4();
    return Type_MOVE_instance;
  }
  function Type_DRAG_getInstance() {
    Type_initEntries_4();
    return Type_DRAG_instance;
  }
  function Type_UP_getInstance() {
    Type_initEntries_4();
    return Type_UP_instance;
  }
  function Type_DOWN_getInstance() {
    Type_initEntries_4();
    return Type_DOWN_instance;
  }
  function Type_CLICK_getInstance() {
    Type_initEntries_4();
    return Type_CLICK_instance;
  }
  function Type_ENTER_getInstance() {
    Type_initEntries_4();
    return Type_ENTER_instance;
  }
  function Type_EXIT_getInstance() {
    Type_initEntries_4();
    return Type_EXIT_instance;
  }
  function Type_SCROLL_getInstance() {
    Type_initEntries_4();
    return Type_SCROLL_instance;
  }
  function ScrollDeltaMode_PIXEL_getInstance() {
    ScrollDeltaMode_initEntries();
    return ScrollDeltaMode_PIXEL_instance;
  }
  function ScrollDeltaMode_LINE_getInstance() {
    ScrollDeltaMode_initEntries();
    return ScrollDeltaMode_LINE_instance;
  }
  function ScrollDeltaMode_PAGE_getInstance() {
    ScrollDeltaMode_initEntries();
    return ScrollDeltaMode_PAGE_instance;
  }
  function MouseEvent_0(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated) {
    Event_0.call(this);
    this._type_15 = type;
    this._id_17 = id;
    this._x_20 = x;
    this._y_19 = y;
    this._button = button;
    this._buttons = buttons;
    this._scrollDeltaX = scrollDeltaX;
    this._scrollDeltaY = scrollDeltaY;
    this._scrollDeltaZ = scrollDeltaZ;
    this._isShiftDown = isShiftDown;
    this._isCtrlDown = isCtrlDown;
    this._isAltDown = isAltDown;
    this._isMetaDown = isMetaDown;
    this._scaleCoords = scaleCoords;
    this._emulated = emulated;
    this._component = null;
    this._scrollDeltaMode = ScrollDeltaMode_LINE_getInstance();
    var tmp = this;
    tmp._requestLock = _no_name_provided_$factory_275();
  }
  MouseEvent_0.prototype.copyFrom_jl2fzq_k$ = function (other) {
    this._type_15 = other._type_15;
    this._id_17 = other._id_17;
    this._x_20 = other._x_20;
    this._y_19 = other._y_19;
    this._button = other._button;
    this._buttons = other._buttons;
    this._scrollDeltaX = other._scrollDeltaX;
    this._scrollDeltaY = other._scrollDeltaY;
    this._scrollDeltaZ = other._scrollDeltaZ;
    this._isShiftDown = other._isShiftDown;
    this._isCtrlDown = other._isCtrlDown;
    this._isAltDown = other._isAltDown;
    this._isMetaDown = other._isMetaDown;
    this._scaleCoords = other._scaleCoords;
    this._emulated = other._emulated;
    this._scrollDeltaMode = other._scrollDeltaMode;
  };
  MouseEvent_0.prototype.toString = function () {
    return '' + 'MouseEvent(type=' + this._type_15 + ', id=' + this._id_17 + ', x=' + this._x_20 + ', y=' + this._y_19 + ', button=' + this._button + ', buttons=' + this._buttons + ', scrollDeltaX=' + this._scrollDeltaX + ', scrollDeltaY=' + this._scrollDeltaY + ', scrollDeltaZ=' + this._scrollDeltaZ + ', isShiftDown=' + this._isShiftDown + ', isCtrlDown=' + this._isCtrlDown + ', isAltDown=' + this._isAltDown + ', isMetaDown=' + this._isMetaDown + ', scaleCoords=' + this._scaleCoords + ', emulated=' + this._emulated + ')';
  };
  MouseEvent_0.prototype.hashCode = function () {
    var result = this._type_15.hashCode();
    result = imul(result, 31) + this._id_17 | 0;
    result = imul(result, 31) + this._x_20 | 0;
    result = imul(result, 31) + this._y_19 | 0;
    result = imul(result, 31) + this._button.hashCode() | 0;
    result = imul(result, 31) + this._buttons | 0;
    result = imul(result, 31) + getNumberHashCode(this._scrollDeltaX) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scrollDeltaY) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scrollDeltaZ) | 0;
    result = imul(result, 31) + (this._isShiftDown | 0) | 0;
    result = imul(result, 31) + (this._isCtrlDown | 0) | 0;
    result = imul(result, 31) + (this._isAltDown | 0) | 0;
    result = imul(result, 31) + (this._isMetaDown | 0) | 0;
    result = imul(result, 31) + (this._scaleCoords | 0) | 0;
    result = imul(result, 31) + (this._emulated | 0) | 0;
    return result;
  };
  MouseEvent_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MouseEvent_0 ? other : THROW_CCE();
    if (!this._type_15.equals(tmp0_other_with_cast._type_15))
      return false;
    if (!(this._id_17 === tmp0_other_with_cast._id_17))
      return false;
    if (!(this._x_20 === tmp0_other_with_cast._x_20))
      return false;
    if (!(this._y_19 === tmp0_other_with_cast._y_19))
      return false;
    if (!this._button.equals(tmp0_other_with_cast._button))
      return false;
    if (!(this._buttons === tmp0_other_with_cast._buttons))
      return false;
    if (!equals_1(this._scrollDeltaX, tmp0_other_with_cast._scrollDeltaX))
      return false;
    if (!equals_1(this._scrollDeltaY, tmp0_other_with_cast._scrollDeltaY))
      return false;
    if (!equals_1(this._scrollDeltaZ, tmp0_other_with_cast._scrollDeltaZ))
      return false;
    if (!(this._isShiftDown === tmp0_other_with_cast._isShiftDown))
      return false;
    if (!(this._isCtrlDown === tmp0_other_with_cast._isCtrlDown))
      return false;
    if (!(this._isAltDown === tmp0_other_with_cast._isAltDown))
      return false;
    if (!(this._isMetaDown === tmp0_other_with_cast._isMetaDown))
      return false;
    if (!(this._scaleCoords === tmp0_other_with_cast._scaleCoords))
      return false;
    if (!(this._emulated === tmp0_other_with_cast._emulated))
      return false;
    return true;
  };
  MouseEvent_0.$metadata$ = {
    simpleName: 'MouseEvent',
    kind: 'class',
    interfaces: []
  };
  function ReshapeEvent_init_$Init$(x, y, width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0;
    if (!(($mask0 & 2) === 0))
      y = 0;
    if (!(($mask0 & 4) === 0))
      width = 0;
    if (!(($mask0 & 8) === 0))
      height = 0;
    ReshapeEvent.call($this, x, y, width, height);
    return $this;
  }
  function ReshapeEvent_init_$Create$(x, y, width, height, $mask0, $marker) {
    return ReshapeEvent_init_$Init$(x, y, width, height, $mask0, $marker, Object.create(ReshapeEvent.prototype));
  }
  function ReshapeEvent(x, y, width, height) {
    Event_0.call(this);
    this._x_21 = x;
    this._y_20 = y;
    this._width_15 = width;
    this._height_16 = height;
  }
  ReshapeEvent.prototype.toString = function () {
    return '' + 'ReshapeEvent(x=' + this._x_21 + ', y=' + this._y_20 + ', width=' + this._width_15 + ', height=' + this._height_16 + ')';
  };
  ReshapeEvent.prototype.hashCode = function () {
    var result = this._x_21;
    result = imul(result, 31) + this._y_20 | 0;
    result = imul(result, 31) + this._width_15 | 0;
    result = imul(result, 31) + this._height_16 | 0;
    return result;
  };
  ReshapeEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this._x_21 === tmp0_other_with_cast._x_21))
      return false;
    if (!(this._y_20 === tmp0_other_with_cast._y_20))
      return false;
    if (!(this._width_15 === tmp0_other_with_cast._width_15))
      return false;
    if (!(this._height_16 === tmp0_other_with_cast._height_16))
      return false;
    return true;
  };
  ReshapeEvent.$metadata$ = {
    simpleName: 'ReshapeEvent',
    kind: 'class',
    interfaces: []
  };
  var Type_UP_instance_0;
  var Type_DOWN_instance_0;
  var Type_TYPE_instance;
  var Type_entriesInitialized_5;
  function Type_initEntries_5() {
    if (Type_entriesInitialized_5)
      return Unit_getInstance();
    Type_entriesInitialized_5 = true;
    Type_UP_instance_0 = new Type_5('UP', 0);
    Type_DOWN_instance_0 = new Type_5('DOWN', 1);
    Type_TYPE_instance = new Type_5('TYPE', 2);
  }
  function KeyEvent_init_$Init$(type, id, key, keyCode, character, shift, ctrl, alt, meta, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_UP_getInstance_0();
    if (!(($mask0 & 2) === 0))
      id = 0;
    if (!(($mask0 & 4) === 0))
      key = Key_UP_getInstance();
    if (!(($mask0 & 8) === 0))
      keyCode = 0;
    if (!(($mask0 & 16) === 0))
      character = new Char(0);
    if (!(($mask0 & 32) === 0))
      shift = false;
    if (!(($mask0 & 64) === 0))
      ctrl = false;
    if (!(($mask0 & 128) === 0))
      alt = false;
    if (!(($mask0 & 256) === 0))
      meta = false;
    KeyEvent.call($this, type, id, key, keyCode, character, shift, ctrl, alt, meta);
    return $this;
  }
  function KeyEvent_init_$Create$(type, id, key, keyCode, character, shift, ctrl, alt, meta, $mask0, $marker) {
    return KeyEvent_init_$Init$(type, id, key, keyCode, character, shift, ctrl, alt, meta, $mask0, $marker, Object.create(KeyEvent.prototype));
  }
  function Type_5(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_5.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_UP_getInstance_0() {
    Type_initEntries_5();
    return Type_UP_instance_0;
  }
  function Type_DOWN_getInstance_0() {
    Type_initEntries_5();
    return Type_DOWN_instance_0;
  }
  function Type_TYPE_getInstance() {
    Type_initEntries_5();
    return Type_TYPE_instance;
  }
  function KeyEvent(type, id, key, keyCode, character, shift, ctrl, alt, meta) {
    Event_0.call(this);
    this._type_16 = type;
    this._id_18 = id;
    this._key_3 = key;
    this._keyCode = keyCode;
    this._character = character;
    this._shift_0 = shift;
    this._ctrl = ctrl;
    this._alt = alt;
    this._meta = meta;
    this._deltaTime = Companion_getInstance_92()._ZERO;
  }
  KeyEvent.prototype.toString = function () {
    return '' + 'KeyEvent(type=' + this._type_16 + ', id=' + this._id_18 + ', key=' + this._key_3 + ', keyCode=' + this._keyCode + ', character=' + this._character + ', shift=' + this._shift_0 + ', ctrl=' + this._ctrl + ', alt=' + this._alt + ', meta=' + this._meta + ')';
  };
  KeyEvent.prototype.hashCode = function () {
    var result = this._type_16.hashCode();
    result = imul(result, 31) + this._id_18 | 0;
    result = imul(result, 31) + this._key_3.hashCode() | 0;
    result = imul(result, 31) + this._keyCode | 0;
    result = imul(result, 31) + this._character.hashCode() | 0;
    result = imul(result, 31) + (this._shift_0 | 0) | 0;
    result = imul(result, 31) + (this._ctrl | 0) | 0;
    result = imul(result, 31) + (this._alt | 0) | 0;
    result = imul(result, 31) + (this._meta | 0) | 0;
    return result;
  };
  KeyEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this._type_16.equals(tmp0_other_with_cast._type_16))
      return false;
    if (!(this._id_18 === tmp0_other_with_cast._id_18))
      return false;
    if (!this._key_3.equals(tmp0_other_with_cast._key_3))
      return false;
    if (!(this._keyCode === tmp0_other_with_cast._keyCode))
      return false;
    if (!this._character.equals(tmp0_other_with_cast._character))
      return false;
    if (!(this._shift_0 === tmp0_other_with_cast._shift_0))
      return false;
    if (!(this._ctrl === tmp0_other_with_cast._ctrl))
      return false;
    if (!(this._alt === tmp0_other_with_cast._alt))
      return false;
    if (!(this._meta === tmp0_other_with_cast._meta))
      return false;
    return true;
  };
  KeyEvent.$metadata$ = {
    simpleName: 'KeyEvent',
    kind: 'class',
    interfaces: []
  };
  function GamePadUpdateEvent_init_$Init$(gamepadsLength, gamepads, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      gamepadsLength = 0;
    if (!(($mask0 & 2) === 0)) {
      var tmp = 0;
      var tmp_0 = 8;
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = GamepadInfo_init_$Create$(tmp_2, false, null, null, null, 0, null, 0, 0, 510, null);
        tmp = tmp + 1 | 0;
      }
      gamepads = tmp_1;
    }GamePadUpdateEvent.call($this, gamepadsLength, gamepads);
    return $this;
  }
  function GamePadUpdateEvent_init_$Create$(gamepadsLength, gamepads, $mask0, $marker) {
    return GamePadUpdateEvent_init_$Init$(gamepadsLength, gamepads, $mask0, $marker, Object.create(GamePadUpdateEvent.prototype));
  }
  function GamePadUpdateEvent(gamepadsLength, gamepads) {
    Event_0.call(this);
    this._gamepadsLength = gamepadsLength;
    this._gamepads = gamepads;
  }
  GamePadUpdateEvent.prototype.copyFrom_6k410b_k$ = function (that) {
    this._gamepadsLength = that._gamepadsLength;
    var inductionVariable = 0;
    var last_1 = this._gamepads.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._gamepads[n].copyFrom_ds6720_k$(that._gamepads[n]);
      }
       while (inductionVariable < last_1);
  };
  GamePadUpdateEvent.prototype.toString = function () {
    var tmp0_filter_0 = this._gamepads;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var indexedObject = tmp0_filter_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element_2_3._connected) {
        tmp0_filterTo_0_1.add_2bq_k$(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return '' + 'GamePadUpdateEvent(' + tmp0_filterTo_0_1 + ')';
  };
  GamePadUpdateEvent.prototype.hashCode = function () {
    var result = this._gamepadsLength;
    result = imul(result, 31) + hashCode(this._gamepads) | 0;
    return result;
  };
  GamePadUpdateEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this._gamepadsLength === tmp0_other_with_cast._gamepadsLength))
      return false;
    if (!equals_1(this._gamepads, tmp0_other_with_cast._gamepads))
      return false;
    return true;
  };
  GamePadUpdateEvent.$metadata$ = {
    simpleName: 'GamePadUpdateEvent',
    kind: 'class',
    interfaces: []
  };
  function GamePadStickEvent_init_$Init$(gamepad, stick, x, y, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      gamepad = 0;
    if (!(($mask0 & 2) === 0))
      stick = GameStick_LEFT_getInstance();
    if (!(($mask0 & 4) === 0))
      x = 0.0;
    if (!(($mask0 & 8) === 0))
      y = 0.0;
    GamePadStickEvent.call($this, gamepad, stick, x, y);
    return $this;
  }
  function GamePadStickEvent_init_$Create$(gamepad, stick, x, y, $mask0, $marker) {
    return GamePadStickEvent_init_$Init$(gamepad, stick, x, y, $mask0, $marker, Object.create(GamePadStickEvent.prototype));
  }
  function GamePadStickEvent(gamepad, stick, x, y) {
    Event_0.call(this);
    this._gamepad = gamepad;
    this._stick = stick;
    this._x_22 = x;
    this._y_21 = y;
  }
  GamePadStickEvent.prototype.toString = function () {
    return '' + 'GamePadStickEvent(gamepad=' + this._gamepad + ', stick=' + this._stick + ', x=' + this._x_22 + ', y=' + this._y_21 + ')';
  };
  GamePadStickEvent.prototype.hashCode = function () {
    var result = this._gamepad;
    result = imul(result, 31) + this._stick.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._x_22) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y_21) | 0;
    return result;
  };
  GamePadStickEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadStickEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GamePadStickEvent ? other : THROW_CCE();
    if (!(this._gamepad === tmp0_other_with_cast._gamepad))
      return false;
    if (!this._stick.equals(tmp0_other_with_cast._stick))
      return false;
    if (!equals_1(this._x_22, tmp0_other_with_cast._x_22))
      return false;
    if (!equals_1(this._y_21, tmp0_other_with_cast._y_21))
      return false;
    return true;
  };
  GamePadStickEvent.$metadata$ = {
    simpleName: 'GamePadStickEvent',
    kind: 'class',
    interfaces: []
  };
  var Type_UP_instance_1;
  var Type_DOWN_instance_1;
  var Type_entriesInitialized_6;
  function Type_initEntries_6() {
    if (Type_entriesInitialized_6)
      return Unit_getInstance();
    Type_entriesInitialized_6 = true;
    Type_UP_instance_1 = new Type_6('UP', 0);
    Type_DOWN_instance_1 = new Type_6('DOWN', 1);
  }
  function GamePadButtonEvent_init_$Init$(type, gamepad, button, value, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_DOWN_getInstance_1();
    if (!(($mask0 & 2) === 0))
      gamepad = 0;
    if (!(($mask0 & 4) === 0))
      button = GameButton_BUTTON0_getInstance();
    if (!(($mask0 & 8) === 0))
      value = 0.0;
    GamePadButtonEvent.call($this, type, gamepad, button, value);
    return $this;
  }
  function GamePadButtonEvent_init_$Create$(type, gamepad, button, value, $mask0, $marker) {
    return GamePadButtonEvent_init_$Init$(type, gamepad, button, value, $mask0, $marker, Object.create(GamePadButtonEvent.prototype));
  }
  function Type_6(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_6.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_UP_getInstance_1() {
    Type_initEntries_6();
    return Type_UP_instance_1;
  }
  function Type_DOWN_getInstance_1() {
    Type_initEntries_6();
    return Type_DOWN_instance_1;
  }
  function GamePadButtonEvent(type, gamepad, button, value) {
    Event_0.call(this);
    this._type_17 = type;
    this._gamepad_0 = gamepad;
    this._button_0 = button;
    this._value_26 = value;
  }
  GamePadButtonEvent.prototype.toString = function () {
    return '' + 'GamePadButtonEvent(type=' + this._type_17 + ', gamepad=' + this._gamepad_0 + ', button=' + this._button_0 + ', value=' + this._value_26 + ')';
  };
  GamePadButtonEvent.prototype.hashCode = function () {
    var result = this._type_17.hashCode();
    result = imul(result, 31) + this._gamepad_0 | 0;
    result = imul(result, 31) + this._button_0.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._value_26) | 0;
    return result;
  };
  GamePadButtonEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadButtonEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GamePadButtonEvent ? other : THROW_CCE();
    if (!this._type_17.equals(tmp0_other_with_cast._type_17))
      return false;
    if (!(this._gamepad_0 === tmp0_other_with_cast._gamepad_0))
      return false;
    if (!this._button_0.equals(tmp0_other_with_cast._button_0))
      return false;
    if (!equals_1(this._value_26, tmp0_other_with_cast._value_26))
      return false;
    return true;
  };
  GamePadButtonEvent.$metadata$ = {
    simpleName: 'GamePadButtonEvent',
    kind: 'class',
    interfaces: []
  };
  var Type_CONNECTED_instance;
  var Type_DISCONNECTED_instance;
  var Type_entriesInitialized_7;
  function Type_initEntries_7() {
    if (Type_entriesInitialized_7)
      return Unit_getInstance();
    Type_entriesInitialized_7 = true;
    Type_CONNECTED_instance = new Type_7('CONNECTED', 0);
    Type_DISCONNECTED_instance = new Type_7('DISCONNECTED', 1);
  }
  function GamePadConnectionEvent_init_$Init$(type, gamepad, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_CONNECTED_getInstance();
    if (!(($mask0 & 2) === 0))
      gamepad = 0;
    GamePadConnectionEvent.call($this, type, gamepad);
    return $this;
  }
  function GamePadConnectionEvent_init_$Create$(type, gamepad, $mask0, $marker) {
    return GamePadConnectionEvent_init_$Init$(type, gamepad, $mask0, $marker, Object.create(GamePadConnectionEvent.prototype));
  }
  function Type_7(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_7.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_CONNECTED_getInstance() {
    Type_initEntries_7();
    return Type_CONNECTED_instance;
  }
  function Type_DISCONNECTED_getInstance() {
    Type_initEntries_7();
    return Type_DISCONNECTED_instance;
  }
  function GamePadConnectionEvent(type, gamepad) {
    Event_0.call(this);
    this._type_18 = type;
    this._gamepad_1 = gamepad;
  }
  GamePadConnectionEvent.prototype.toString = function () {
    return '' + 'GamePadConnectionEvent(type=' + this._type_18 + ', gamepad=' + this._gamepad_1 + ')';
  };
  GamePadConnectionEvent.prototype.hashCode = function () {
    var result = this._type_18.hashCode();
    result = imul(result, 31) + this._gamepad_1 | 0;
    return result;
  };
  GamePadConnectionEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this._type_18.equals(tmp0_other_with_cast._type_18))
      return false;
    if (!(this._gamepad_1 === tmp0_other_with_cast._gamepad_1))
      return false;
    return true;
  };
  GamePadConnectionEvent.$metadata$ = {
    simpleName: 'GamePadConnectionEvent',
    kind: 'class',
    interfaces: []
  };
  var Type_START_instance;
  var Type_END_instance;
  var Type_MOVE_instance_0;
  var Type_HOVER_instance;
  var Type_UNKNOWN_instance_0;
  var Type_entriesInitialized_8;
  function Type_initEntries_8() {
    if (Type_entriesInitialized_8)
      return Unit_getInstance();
    Type_entriesInitialized_8 = true;
    Type_START_instance = new Type_8('START', 0);
    Type_END_instance = new Type_8('END', 1);
    Type_MOVE_instance_0 = new Type_8('MOVE', 2);
    Type_HOVER_instance = new Type_8('HOVER', 3);
    Type_UNKNOWN_instance_0 = new Type_8('UNKNOWN', 4);
  }
  function TouchEvent_init_$Init$(type, screen, currentTime, scaleCoords, emulated, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_START_getInstance();
    if (!(($mask0 & 2) === 0))
      screen = 0;
    if (!(($mask0 & 4) === 0))
      currentTime = Companion_getInstance_82()._EPOCH;
    if (!(($mask0 & 8) === 0))
      scaleCoords = true;
    if (!(($mask0 & 16) === 0))
      emulated = false;
    TouchEvent_0.call($this, type, screen, currentTime, scaleCoords, emulated);
    return $this;
  }
  function TouchEvent_init_$Create$(type, screen, currentTime, scaleCoords, emulated, $mask0, $marker) {
    return TouchEvent_init_$Init$(type, screen, currentTime, scaleCoords, emulated, $mask0, $marker, Object.create(TouchEvent_0.prototype));
  }
  function Companion_170() {
    Companion_instance_169 = this;
    this._MAX_TOUCHES = 10;
  }
  Companion_170.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_169;
  function Companion_getInstance_169() {
    if (Companion_instance_169 == null)
      new Companion_170();
    return Companion_instance_169;
  }
  function Type_8(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_8.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__330() {
  }
  _no_name_provided__330.prototype.invoke_clcs4n_k$ = function (it) {
    return it.toString();
  };
  _no_name_provided__330.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_clcs4n_k$(p1 instanceof Touch_0 ? p1 : THROW_CCE());
  };
  _no_name_provided__330.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Type_START_getInstance() {
    Type_initEntries_8();
    return Type_START_instance;
  }
  function Type_END_getInstance() {
    Type_initEntries_8();
    return Type_END_instance;
  }
  function Type_MOVE_getInstance_0() {
    Type_initEntries_8();
    return Type_MOVE_instance_0;
  }
  function TouchEvent_0(type, screen, currentTime, scaleCoords, emulated) {
    Companion_getInstance_169();
    Event_0.call(this);
    this._type_19 = type;
    this._screen = screen;
    this._currentTime = currentTime;
    this._scaleCoords_0 = scaleCoords;
    this._emulated_0 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_getInstance_169()._MAX_TOUCHES;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Touch_init_$Create$(tmp_3, 0, 0.0, 0.0, 0.0, null, null, null, 254, null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._bufferTouches = tmp_2;
    this.__touches = FastArrayList_init_$Create$();
    this.__activeTouches = FastArrayList_init_$Create$();
    this.__touchesById = FastIntMap();
  }
  TouchEvent_0.prototype._get_touches__0_k$ = function () {
    return this.__touches;
  };
  TouchEvent_0.prototype._get_numTouches__0_k$ = function () {
    return this._get_touches__0_k$()._get_size__0_k$();
  };
  TouchEvent_0.prototype.getTouchById_ha5a7z_k$ = function (id) {
    var tmp0_get_0 = this.__touchesById;
    return tmp0_get_0.get(id);
  };
  TouchEvent_0.prototype.toString = function () {
    var tmp = this._type_19;
    var tmp_0 = this._get_numTouches__0_k$();
    var tmp_1 = this._get_touches__0_k$();
    return '' + 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString$default_0(tmp_1, ', ', null, null, 0, null, _no_name_provided_$factory_276(), 30, null) + ')';
  };
  TouchEvent_0.prototype.startFrame_bjxefj_k$ = function (type) {
    this._type_19 = type;
    this._currentTime = Companion_getInstance_82().now_utobi1_k$();
    this.__touches.clear_sv8swh_k$();
    var tmp0_clear_0 = this.__touchesById;
    tmp0_clear_0.clear();
  };
  TouchEvent_0.prototype.endFrame_sv8swh_k$ = function () {
    this.__activeTouches.clear_sv8swh_k$();
    var tmp0_fastForEach_0 = this._get_touches__0_k$();
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      if (tmp1__anonymous__3._get_isActive__0_k$()) {
        this.__activeTouches.add_2bq_k$(tmp1__anonymous__3);
        Unit_getInstance();
      }}
  };
  TouchEvent_0.prototype.getOrAllocTouchById_ha5a7z_k$ = function (id) {
    var tmp0_get_0 = this.__touchesById;
    var tmp0_elvis_lhs = tmp0_get_0.get(id);
    return tmp0_elvis_lhs == null ? this.allocTouchById_ha5a7z_k$(id) : tmp0_elvis_lhs;
  };
  TouchEvent_0.prototype.allocTouchById_ha5a7z_k$ = function (id) {
    var touch_0 = this._bufferTouches[this.__touches._get_size__0_k$()];
    touch_0._id_19 = id;
    this.__touches.add_2bq_k$(touch_0);
    Unit_getInstance();
    var tmp0_set_0 = this.__touchesById;
    var tmp1_set_0 = touch_0._id_19;
    tmp0_set_0.set(tmp1_set_0, touch_0);
    return touch_0;
  };
  TouchEvent_0.prototype.touch_apoz68_k$ = function (id, x, y, status, force, kind, button) {
    var touch_0 = this.getOrAllocTouchById_ha5a7z_k$(id);
    touch_0._x_23 = x;
    touch_0._y_22 = y;
    touch_0._status_1 = status;
    touch_0._force_0 = force;
    touch_0._kind_4 = kind;
    touch_0._button_1 = button;
  };
  TouchEvent_0.prototype.touch$default_grw3b9_k$ = function (id, x, y, status, force, kind, button, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      status = Status_KEEP_getInstance();
    if (!(($mask0 & 16) === 0))
      force = 1.0;
    if (!(($mask0 & 32) === 0))
      kind = Kind_FINGER_getInstance();
    if (!(($mask0 & 64) === 0))
      button = MouseButton_LEFT_getInstance();
    return this.touch_apoz68_k$(id, x, y, status, force, kind, button);
  };
  TouchEvent_0.prototype.touch_v2cgg8_k$ = function (touch_0) {
    this.touch_apoz68_k$(touch_0._id_19, touch_0._x_23, touch_0._y_22, touch_0._status_1, touch_0._force_0, touch_0._kind_4, touch_0._button_1);
  };
  TouchEvent_0.prototype.copyFrom_kaxwi8_k$ = function (other) {
    this._type_19 = other._type_19;
    this._screen = other._screen;
    this._currentTime = other._currentTime;
    this._scaleCoords_0 = other._scaleCoords_0;
    this._emulated_0 = other._emulated_0;
    var inductionVariable = 0;
    var last_1 = Companion_getInstance_169()._MAX_TOUCHES;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._bufferTouches[n].copyFrom_v2cgg8_k$(other._bufferTouches[n]);
      }
       while (inductionVariable < last_1);
    this.__touches.clear_sv8swh_k$();
    this.__activeTouches.clear_sv8swh_k$();
    var tmp0_clear_0 = this.__touchesById;
    tmp0_clear_0.clear();
    var tmp1_fastForEach_0 = other._get_touches__0_k$();
    var n_1 = 0;
    while (n_1 < tmp1_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp2__anonymous__3 = tmp1_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      var touch_4 = this._bufferTouches[tmp2__anonymous__3._index_26];
      this.__touches.add_2bq_k$(touch_4);
      Unit_getInstance();
      if (touch_4._get_isActive__0_k$()) {
        this.__activeTouches.add_2bq_k$(touch_4);
        Unit_getInstance();
      }var tmp0_set_0_5 = this.__touchesById;
      var tmp1_set_0_6 = touch_4._id_19;
      tmp0_set_0_5.set(tmp1_set_0_6, touch_4);
    }
  };
  TouchEvent_0.prototype._get_isStart__0_k$ = function () {
    return this._type_19.equals(Type_START_getInstance());
  };
  TouchEvent_0.prototype._get_isEnd__0_k$ = function () {
    return this._type_19.equals(Type_END_getInstance());
  };
  TouchEvent_0.prototype.hashCode = function () {
    var result = this._type_19.hashCode();
    result = imul(result, 31) + this._screen | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._currentTime) | 0;
    result = imul(result, 31) + (this._scaleCoords_0 | 0) | 0;
    result = imul(result, 31) + (this._emulated_0 | 0) | 0;
    return result;
  };
  TouchEvent_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TouchEvent_0 ? other : THROW_CCE();
    if (!this._type_19.equals(tmp0_other_with_cast._type_19))
      return false;
    if (!(this._screen === tmp0_other_with_cast._screen))
      return false;
    if (!equals_1(new DateTime(this._currentTime), new DateTime(tmp0_other_with_cast._currentTime)))
      return false;
    if (!(this._scaleCoords_0 === tmp0_other_with_cast._scaleCoords_0))
      return false;
    if (!(this._emulated_0 === tmp0_other_with_cast._emulated_0))
      return false;
    return true;
  };
  TouchEvent_0.$metadata$ = {
    simpleName: 'TouchEvent',
    kind: 'class',
    interfaces: []
  };
  var Status_ADD_instance;
  var Status_KEEP_instance;
  var Status_REMOVE_instance;
  var Status_entriesInitialized;
  function Status_initEntries() {
    if (Status_entriesInitialized)
      return Unit_getInstance();
    Status_entriesInitialized = true;
    Status_ADD_instance = new Status('ADD', 0);
    Status_KEEP_instance = new Status('KEEP', 1);
    Status_REMOVE_instance = new Status('REMOVE', 2);
  }
  var Kind_FINGER_instance;
  var Kind_MOUSE_instance;
  var Kind_STYLUS_instance;
  var Kind_ERASER_instance;
  var Kind_UNKNOWN_instance;
  var Kind_entriesInitialized_2;
  function Kind_initEntries_2() {
    if (Kind_entriesInitialized_2)
      return Unit_getInstance();
    Kind_entriesInitialized_2 = true;
    Kind_FINGER_instance = new Kind_2('FINGER', 0);
    Kind_MOUSE_instance = new Kind_2('MOUSE', 1);
    Kind_STYLUS_instance = new Kind_2('STYLUS', 2);
    Kind_ERASER_instance = new Kind_2('ERASER', 3);
    Kind_UNKNOWN_instance = new Kind_2('UNKNOWN', 4);
  }
  function Touch_init_$Init$(index_0, id, x, y, force, status, kind, button, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      index_0 = -1;
    if (!(($mask0 & 2) === 0))
      id = -1;
    if (!(($mask0 & 4) === 0))
      x = 0.0;
    if (!(($mask0 & 8) === 0))
      y = 0.0;
    if (!(($mask0 & 16) === 0))
      force = 1.0;
    if (!(($mask0 & 32) === 0))
      status = Status_KEEP_getInstance();
    if (!(($mask0 & 64) === 0))
      kind = Kind_FINGER_getInstance();
    if (!(($mask0 & 128) === 0))
      button = MouseButton_LEFT_getInstance();
    Touch_0.call($this, index_0, id, x, y, force, status, kind, button);
    return $this;
  }
  function Touch_init_$Create$(index_0, id, x, y, force, status, kind, button, $mask0, $marker) {
    return Touch_init_$Init$(index_0, id, x, y, force, status, kind, button, $mask0, $marker, Object.create(Touch_0.prototype));
  }
  function Status(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Status.$metadata$ = {
    simpleName: 'Status',
    kind: 'class',
    interfaces: []
  };
  function Kind_2(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Kind_2.$metadata$ = {
    simpleName: 'Kind',
    kind: 'class',
    interfaces: []
  };
  function Companion_171() {
    Companion_instance_170 = this;
    var tmp = this;
    tmp._dummy_2 = Touch_init_$Create$(-1, 0, 0.0, 0.0, 0.0, null, null, null, 254, null);
  }
  Companion_171.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_170;
  function Companion_getInstance_170() {
    if (Companion_instance_170 == null)
      new Companion_171();
    return Companion_instance_170;
  }
  function Status_ADD_getInstance() {
    Status_initEntries();
    return Status_ADD_instance;
  }
  function Status_KEEP_getInstance() {
    Status_initEntries();
    return Status_KEEP_instance;
  }
  function Status_REMOVE_getInstance() {
    Status_initEntries();
    return Status_REMOVE_instance;
  }
  function Kind_FINGER_getInstance() {
    Kind_initEntries_2();
    return Kind_FINGER_instance;
  }
  function Kind_MOUSE_getInstance() {
    Kind_initEntries_2();
    return Kind_MOUSE_instance;
  }
  function Touch_0(index_0, id, x, y, force, status, kind, button) {
    Companion_getInstance_170();
    this._index_26 = index_0;
    this._id_19 = id;
    this._x_23 = x;
    this._y_22 = y;
    this._force_0 = force;
    this._status_1 = status;
    this._kind_4 = kind;
    this._button_1 = button;
    var tmp = this;
    tmp._$$delegate_0_26 = Mixin_init_$Create$(null, 1, null);
  }
  Touch_0.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_26._set_extra__n1onou_k$(_set___);
  };
  Touch_0.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_26._get_extra__0_k$();
  };
  Touch_0.prototype._get_isActive__0_k$ = function () {
    return !this._status_1.equals(Status_REMOVE_getInstance());
  };
  Touch_0.prototype.copyFrom_v2cgg8_k$ = function (other) {
    this._id_19 = other._id_19;
    this._x_23 = other._x_23;
    this._y_22 = other._y_22;
    this._force_0 = other._force_0;
    this._status_1 = other._status_1;
    this._kind_4 = other._kind_4;
    this._button_1 = other._button_1;
  };
  Touch_0.prototype.hashCode = function () {
    return this._index_26;
  };
  Touch_0.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Touch_0) {
      tmp = this._index_26 === other._index_26;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Touch_0.prototype.toString = function () {
    return '' + 'Touch(index=' + this._index_26 + ', id=' + this._id_19 + ', x=' + this._x_23 + ', y=' + this._y_22 + ', force=' + this._force_0 + ', status=' + this._status_1 + ', kind=' + this._kind_4 + ', button=' + this._button_1 + ')';
  };
  Touch_0.$metadata$ = {
    simpleName: 'Touch',
    kind: 'class',
    interfaces: [Extra]
  };
  function ResumeEvent() {
    Event_0.call(this);
  }
  ResumeEvent.$metadata$ = {
    simpleName: 'ResumeEvent',
    kind: 'class',
    interfaces: []
  };
  function PauseEvent() {
    Event_0.call(this);
  }
  PauseEvent.$metadata$ = {
    simpleName: 'PauseEvent',
    kind: 'class',
    interfaces: []
  };
  function StopEvent() {
    Event_0.call(this);
  }
  StopEvent.$metadata$ = {
    simpleName: 'StopEvent',
    kind: 'class',
    interfaces: []
  };
  function DestroyEvent() {
    Event_0.call(this);
  }
  DestroyEvent.$metadata$ = {
    simpleName: 'DestroyEvent',
    kind: 'class',
    interfaces: []
  };
  function RenderEvent() {
    Event_0.call(this);
    this._update = true;
  }
  RenderEvent.$metadata$ = {
    simpleName: 'RenderEvent',
    kind: 'class',
    interfaces: []
  };
  function InitEvent() {
    Event_0.call(this);
  }
  InitEvent.$metadata$ = {
    simpleName: 'InitEvent',
    kind: 'class',
    interfaces: []
  };
  function DisposeEvent() {
    Event_0.call(this);
  }
  DisposeEvent.$metadata$ = {
    simpleName: 'DisposeEvent',
    kind: 'class',
    interfaces: []
  };
  function FullScreenEvent_init_$Init$(fullscreen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      fullscreen = false;
    FullScreenEvent.call($this, fullscreen);
    return $this;
  }
  function FullScreenEvent_init_$Create$(fullscreen, $mask0, $marker) {
    return FullScreenEvent_init_$Init$(fullscreen, $mask0, $marker, Object.create(FullScreenEvent.prototype));
  }
  function FullScreenEvent(fullscreen) {
    Event_0.call(this);
    this._fullscreen = fullscreen;
  }
  FullScreenEvent.prototype.toString = function () {
    return '' + 'FullScreenEvent(fullscreen=' + this._fullscreen + ')';
  };
  FullScreenEvent.prototype.hashCode = function () {
    return this._fullscreen | 0;
  };
  FullScreenEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this._fullscreen === tmp0_other_with_cast._fullscreen))
      return false;
    return true;
  };
  FullScreenEvent.$metadata$ = {
    simpleName: 'FullScreenEvent',
    kind: 'class',
    interfaces: []
  };
  var Mode_JS_instance;
  var Mode_Android_instance;
  var Mode_IOS_instance;
  var Mode_entriesInitialized;
  function Mode_initEntries() {
    if (Mode_entriesInitialized)
      return Unit_getInstance();
    Mode_entriesInitialized = true;
    Mode_JS_instance = new Mode('JS', 0);
    Mode_Android_instance = new Mode('Android', 1);
    Mode_IOS_instance = new Mode('IOS', 2);
  }
  function Mode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Mode.$metadata$ = {
    simpleName: 'Mode',
    kind: 'class',
    interfaces: []
  };
  function Mode_JS_getInstance() {
    Mode_initEntries();
    return Mode_JS_instance;
  }
  function Mode_IOS_getInstance() {
    Mode_initEntries();
    return Mode_IOS_instance;
  }
  function TouchBuilder() {
    var tmp = this;
    tmp._old = TouchEvent_init_$Create$(null, 0, null, false, false, 31, null);
    var tmp_0 = this;
    tmp_0._new = TouchEvent_init_$Create$(null, 0, null, false, false, 31, null);
    this._mode_4 = Mode_JS_getInstance();
  }
  TouchBuilder.prototype.startFrame_p1ymd3_k$ = function (type, scaleCoords) {
    this._new._scaleCoords_0 = scaleCoords;
    this._new.startFrame_bjxefj_k$(type);
    var tmp0_subject = this._mode_4;
    if (tmp0_subject.equals(Mode_IOS_getInstance())) {
      this._new.copyFrom_kaxwi8_k$(this._old);
      this._new._type_19 = type;
      var tmp0_fastIterateRemove_0 = this._new.__touches;
      var n_1 = 0;
      var m_2 = 0;
      while (n_1 < tmp0_fastIterateRemove_0._get_size__0_k$()) {
        if (m_2 >= 0 ? !(m_2 === n_1) : false) {
          tmp0_fastIterateRemove_0.set_ddb1qf_k$(m_2, tmp0_fastIterateRemove_0.get_ha5a7z_k$(n_1));
          Unit_getInstance();
        }var tmp1__anonymous__6 = tmp0_fastIterateRemove_0.get_ha5a7z_k$(n_1);
        var tmp;
        if (tmp1__anonymous__6._get_isActive__0_k$()) {
          tmp1__anonymous__6._status_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          var tmp0_remove_0_7 = this._new.__touchesById;
          var tmp1_remove_0_8 = tmp1__anonymous__6._id_19;
          tmp0_remove_0_7.delete(tmp1_remove_0_8);
          tmp = true;
        }
        if (tmp) {
          var tmp0_3 = m_2;
          m_2 = tmp0_3 - 1 | 0;
          Unit_getInstance();
        } else {
        }
        var tmp1_4 = n_1;
        n_1 = tmp1_4 + 1 | 0;
        Unit_getInstance();
        var tmp2_5 = m_2;
        m_2 = tmp2_5 + 1 | 0;
        Unit_getInstance();
      }
      while (tmp0_fastIterateRemove_0._get_size__0_k$() > m_2) {
        tmp0_fastIterateRemove_0.removeAt_ha5a7z_k$(tmp0_fastIterateRemove_0._get_size__0_k$() - 1 | 0);
        Unit_getInstance();
      }
      Unit_getInstance();
    }};
  TouchBuilder.prototype.endFrame_0_k$ = function () {
    var tmp0_subject = this._mode_4;
    if (tmp0_subject.equals(Mode_JS_getInstance())) {
      var tmp0_fastForEach_0 = this._old._get_touches__0_k$();
      var n_1 = 0;
      while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
        if (this._new.getTouchById_ha5a7z_k$(tmp1__anonymous__3._id_19) == null) {
          if (tmp1__anonymous__3._get_isActive__0_k$()) {
            tmp1__anonymous__3._status_1 = Status_REMOVE_getInstance();
            this._new.touch_v2cgg8_k$(tmp1__anonymous__3);
          }}}
    } else if (tmp0_subject.equals(Mode_IOS_getInstance())) {
    }this._new.endFrame_sv8swh_k$();
    this._old.copyFrom_kaxwi8_k$(this._new);
    return this._new;
  };
  TouchBuilder.prototype.touch_3t59h4_k$ = function (id, x, y, force, kind, button) {
    var touch_0 = this._new.getOrAllocTouchById_ha5a7z_k$(id);
    touch_0._x_23 = x;
    touch_0._y_22 = y;
    touch_0._force_0 = force;
    touch_0._kind_4 = kind;
    touch_0._button_1 = button;
    var tmp0_subject = this._mode_4;
    if (tmp0_subject.equals(Mode_IOS_getInstance())) {
      var tmp = touch_0;
      var tmp1_subject = this._new._type_19;
      tmp._status_1 = tmp1_subject.equals(Type_START_getInstance()) ? Status_ADD_getInstance() : tmp1_subject.equals(Type_END_getInstance()) ? Status_REMOVE_getInstance() : Status_KEEP_getInstance();
    } else {
      var oldTouch = this._old.getTouchById_ha5a7z_k$(id);
      touch_0._status_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  };
  TouchBuilder.prototype.touch$default_7fqw1w_k$ = function (id, x, y, force, kind, button, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      force = 1.0;
    if (!(($mask0 & 16) === 0))
      kind = Kind_FINGER_getInstance();
    if (!(($mask0 & 32) === 0))
      button = MouseButton_LEFT_getInstance();
    return this.touch_3t59h4_k$(id, x, y, force, kind, button);
  };
  TouchBuilder.$metadata$ = {
    simpleName: 'TouchBuilder',
    kind: 'class',
    interfaces: []
  };
  var Type_START_instance_0;
  var Type_END_instance_0;
  var Type_DROP_instance;
  var Type_entriesInitialized_9;
  function Type_initEntries_9() {
    if (Type_entriesInitialized_9)
      return Unit_getInstance();
    Type_entriesInitialized_9 = true;
    Type_START_instance_0 = new Type_9('START', 0);
    Type_END_instance_0 = new Type_9('END', 1);
    Type_DROP_instance = new Type_9('DROP', 2);
  }
  function DropFileEvent_init_$Init$(type, files, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_START_getInstance_0();
    if (!(($mask0 & 2) === 0))
      files = null;
    DropFileEvent.call($this, type, files);
    return $this;
  }
  function DropFileEvent_init_$Create$(type, files, $mask0, $marker) {
    return DropFileEvent_init_$Init$(type, files, $mask0, $marker, Object.create(DropFileEvent.prototype));
  }
  function Type_9(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_9.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_START_getInstance_0() {
    Type_initEntries_9();
    return Type_START_instance_0;
  }
  function Type_END_getInstance_0() {
    Type_initEntries_9();
    return Type_END_instance_0;
  }
  function Type_DROP_getInstance() {
    Type_initEntries_9();
    return Type_DROP_instance;
  }
  function DropFileEvent(type, files) {
    Event_0.call(this);
    this._type_20 = type;
    this._files_1 = files;
  }
  DropFileEvent.prototype.toString = function () {
    return '' + 'DropFileEvent(type=' + this._type_20 + ', files=' + this._files_1 + ')';
  };
  DropFileEvent.prototype.hashCode = function () {
    var result = this._type_20.hashCode();
    result = imul(result, 31) + (this._files_1 == null ? 0 : hashCode(this._files_1)) | 0;
    return result;
  };
  DropFileEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this._type_20.equals(tmp0_other_with_cast._type_20))
      return false;
    if (!equals_1(this._files_1, tmp0_other_with_cast._files_1))
      return false;
    return true;
  };
  DropFileEvent.$metadata$ = {
    simpleName: 'DropFileEvent',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_275() {
    var i = new _no_name_provided__329();
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_276() {
    var i = new _no_name_provided__330();
    return function (p1) {
      return i.invoke_clcs4n_k$(p1);
    };
  }
  function getButton(_this_, $this, index_0) {
    return extract_0(_this_, index_0) ? 1.0 : 0.0;
  }
  function _no_name_provided__331(this$0, $info) {
    this._this$0_79 = this$0;
    this._$info_0 = $info;
  }
  _no_name_provided__331.prototype.invoke_uo5qy2_k$ = function (it) {
    return '' + it._get_name__0_k$() + '=' + this._this$0_79.get_ytw0rl_k$(it, this._$info_0);
  };
  _no_name_provided__331.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_uo5qy2_k$(p1 instanceof GameButton ? p1 : THROW_CCE());
  };
  _no_name_provided__331.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GamepadMapping() {
  }
  GamepadMapping.prototype.getRawButton_64rpga_k$ = function (_this__0, index_0) {
    return getButton(_this__0._rawButtonsPressed, this, index_0);
  };
  GamepadMapping.prototype.getRawAxe_64rpga_k$ = function (_this__0, index_0) {
    var tmp0_getOrElse_0 = _this__0._rawAxes;
    var tmp;
    if (index_0 >= 0 ? index_0 <= _get_lastIndex__0(tmp0_getOrElse_0) : false) {
      tmp = tmp0_getOrElse_0[index_0];
    } else {
      tmp = 0.0;
    }
    return tmp;
  };
  GamepadMapping.prototype.toString_hgumif_k$ = function (info) {
    var tmp = '' + this._get_id__0_k$() + '(';
    var tmp_0 = values_8();
    return tmp + joinToString$default(tmp_0, ', ', null, null, 0, null, _no_name_provided_$factory_277(this, info), 30, null) + ')';
  };
  GamepadMapping.$metadata$ = {
    simpleName: 'GamepadMapping',
    kind: 'class',
    interfaces: []
  };
  function Companion_172() {
    Companion_instance_171 = this;
    StandardGamepadMapping.call(this);
  }
  Companion_172.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_171;
  function Companion_getInstance_171() {
    if (Companion_instance_171 == null)
      new Companion_172();
    return Companion_instance_171;
  }
  function StandardGamepadMapping() {
    Companion_getInstance_171();
    GamepadMapping.call(this);
    this._id_20 = 'Standard';
  }
  StandardGamepadMapping.prototype._get_id__0_k$ = function () {
    return this._id_20;
  };
  StandardGamepadMapping.prototype.get_ytw0rl_k$ = function (button, info) {
    var tmp0_subject = button;
    return tmp0_subject.equals(GameButton_BUTTON0_getInstance()) ? this.getRawButton_64rpga_k$(info, 0) : tmp0_subject.equals(GameButton_BUTTON1_getInstance()) ? this.getRawButton_64rpga_k$(info, 1) : tmp0_subject.equals(GameButton_BUTTON2_getInstance()) ? this.getRawButton_64rpga_k$(info, 2) : tmp0_subject.equals(GameButton_BUTTON3_getInstance()) ? this.getRawButton_64rpga_k$(info, 3) : tmp0_subject.equals(GameButton_L1_getInstance()) ? this.getRawButton_64rpga_k$(info, 4) : tmp0_subject.equals(GameButton_R1_getInstance()) ? this.getRawButton_64rpga_k$(info, 5) : tmp0_subject.equals(GameButton_L2_getInstance()) ? this.getRawButton_64rpga_k$(info, 6) : tmp0_subject.equals(GameButton_R2_getInstance()) ? this.getRawButton_64rpga_k$(info, 7) : tmp0_subject.equals(GameButton_SELECT_getInstance()) ? this.getRawButton_64rpga_k$(info, 8) : tmp0_subject.equals(GameButton_START_getInstance()) ? this.getRawButton_64rpga_k$(info, 9) : tmp0_subject.equals(GameButton_L3_getInstance()) ? this.getRawButton_64rpga_k$(info, 10) : tmp0_subject.equals(GameButton_R3_getInstance()) ? this.getRawButton_64rpga_k$(info, 11) : tmp0_subject.equals(GameButton_UP_getInstance()) ? this.getRawButton_64rpga_k$(info, 12) : tmp0_subject.equals(GameButton_DOWN_getInstance()) ? this.getRawButton_64rpga_k$(info, 13) : tmp0_subject.equals(GameButton_LEFT_getInstance()) ? this.getRawButton_64rpga_k$(info, 14) : tmp0_subject.equals(GameButton_RIGHT_getInstance()) ? this.getRawButton_64rpga_k$(info, 15) : tmp0_subject.equals(GameButton_SYSTEM_getInstance()) ? this.getRawButton_64rpga_k$(info, 16) : tmp0_subject.equals(GameButton_LX_getInstance()) ? this.getRawAxe_64rpga_k$(info, 0) : tmp0_subject.equals(GameButton_LY_getInstance()) ? this.getRawAxe_64rpga_k$(info, 1) : tmp0_subject.equals(GameButton_RX_getInstance()) ? this.getRawAxe_64rpga_k$(info, 2) : tmp0_subject.equals(GameButton_RY_getInstance()) ? this.getRawAxe_64rpga_k$(info, 3) : 0.0;
  };
  StandardGamepadMapping.$metadata$ = {
    simpleName: 'StandardGamepadMapping',
    kind: 'class',
    interfaces: []
  };
  var GameButton_LEFT_instance;
  var GameButton_RIGHT_instance;
  var GameButton_UP_instance;
  var GameButton_DOWN_instance;
  var GameButton_BUTTON0_instance;
  var GameButton_BUTTON1_instance;
  var GameButton_BUTTON2_instance;
  var GameButton_BUTTON3_instance;
  var GameButton_SELECT_instance;
  var GameButton_START_instance;
  var GameButton_SYSTEM_instance;
  var GameButton_L1_instance;
  var GameButton_R1_instance;
  var GameButton_L2_instance;
  var GameButton_R2_instance;
  var GameButton_L3_instance;
  var GameButton_R3_instance;
  var GameButton_LX_instance;
  var GameButton_LY_instance;
  var GameButton_RX_instance;
  var GameButton_RY_instance;
  var GameButton_BUTTON4_instance;
  var GameButton_BUTTON5_instance;
  var GameButton_BUTTON6_instance;
  var GameButton_BUTTON7_instance;
  var GameButton_BUTTON8_instance;
  function Companion_173() {
    Companion_instance_172 = this;
    this._BUTTONS = values_8();
    this._MAX_0 = 32;
  }
  Companion_173.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_172;
  function Companion_getInstance_172() {
    if (Companion_instance_172 == null)
      new Companion_173();
    return Companion_instance_172;
  }
  function values_8() {
    return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON0_getInstance(), GameButton_BUTTON1_getInstance(), GameButton_BUTTON2_getInstance(), GameButton_BUTTON3_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance()];
  }
  var GameButton_entriesInitialized;
  function GameButton_initEntries() {
    if (GameButton_entriesInitialized)
      return Unit_getInstance();
    GameButton_entriesInitialized = true;
    GameButton_LEFT_instance = new GameButton('LEFT', 0, 0);
    GameButton_RIGHT_instance = new GameButton('RIGHT', 1, 1);
    GameButton_UP_instance = new GameButton('UP', 2, 2);
    GameButton_DOWN_instance = new GameButton('DOWN', 3, 3);
    GameButton_BUTTON0_instance = new GameButton('BUTTON0', 4, 4);
    GameButton_BUTTON1_instance = new GameButton('BUTTON1', 5, 5);
    GameButton_BUTTON2_instance = new GameButton('BUTTON2', 6, 6);
    GameButton_BUTTON3_instance = new GameButton('BUTTON3', 7, 7);
    GameButton_SELECT_instance = new GameButton('SELECT', 8, 8);
    GameButton_START_instance = new GameButton('START', 9, 9);
    GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10, 10);
    GameButton_L1_instance = new GameButton('L1', 11, 11);
    GameButton_R1_instance = new GameButton('R1', 12, 12);
    GameButton_L2_instance = new GameButton('L2', 13, 13);
    GameButton_R2_instance = new GameButton('R2', 14, 14);
    GameButton_L3_instance = new GameButton('L3', 15, 15);
    GameButton_R3_instance = new GameButton('R3', 16, 16);
    GameButton_LX_instance = new GameButton('LX', 17, 17);
    GameButton_LY_instance = new GameButton('LY', 18, 18);
    GameButton_RX_instance = new GameButton('RX', 19, 19);
    GameButton_RY_instance = new GameButton('RY', 20, 20);
    GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21, 24);
    GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22, 25);
    GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23, 26);
    GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24, 27);
    GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25, 28);
    Companion_getInstance_172();
  }
  function GameButton(name, ordinal, index_0) {
    Enum.call(this, name, ordinal);
    this._index_27 = index_0;
  }
  GameButton.$metadata$ = {
    simpleName: 'GameButton',
    kind: 'class',
    interfaces: []
  };
  function GamepadInfo_init_$Init$(index_0, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      index_0 = 0;
    if (!(($mask0 & 2) === 0))
      connected = false;
    if (!(($mask0 & 4) === 0))
      name = 'unknown';
    if (!(($mask0 & 8) === 0))
      mapping = Companion_getInstance_171();
    if (!(($mask0 & 16) === 0))
      rawButtonsPressure = new Float64Array(64);
    if (!(($mask0 & 32) === 0))
      rawButtonsPressed = 0;
    if (!(($mask0 & 64) === 0))
      rawAxes = new Float64Array(16);
    if (!(($mask0 & 128) === 0))
      axesLength = 0;
    if (!(($mask0 & 256) === 0))
      buttonsLength = 0;
    GamepadInfo.call($this, index_0, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength);
    return $this;
  }
  function GamepadInfo_init_$Create$(index_0, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength, $mask0, $marker) {
    return GamepadInfo_init_$Init$(index_0, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength, $mask0, $marker, Object.create(GamepadInfo.prototype));
  }
  function GamepadInfo(index_0, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength) {
    this._index_28 = index_0;
    this._connected = connected;
    this._name_24 = name;
    this._mapping = mapping;
    this._rawButtonsPressure = rawButtonsPressure;
    this._rawButtonsPressed = rawButtonsPressed;
    this._rawAxes = rawAxes;
    this._axesLength = axesLength;
    this._buttonsLength = buttonsLength;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 2;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Companion_getInstance_32().invoke_0_k$();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._axesData = tmp_2;
  }
  GamepadInfo.prototype.copyFrom_ds6720_k$ = function (that) {
    this._index_28 = that._index_28;
    this._name_24 = that._name_24;
    this._mapping = that._mapping;
    this._rawButtonsPressed = that._rawButtonsPressed;
    this._connected = that._connected;
    this._axesLength = that._axesLength;
    this._buttonsLength = that._buttonsLength;
    var tmp0_min_0 = this._axesData.length;
    var tmp1_min_0 = that._axesData.length;
    arraycopy_4(that._axesData, 0, this._axesData, 0, Math.min(tmp0_min_0, tmp1_min_0));
    var tmp = that._rawButtonsPressure;
    var tmp_0 = this._rawButtonsPressure;
    var tmp2_min_0 = this._rawButtonsPressure.length;
    var tmp3_min_0 = that._rawButtonsPressure.length;
    arraycopy_5(tmp, 0, tmp_0, 0, Math.min(tmp2_min_0, tmp3_min_0));
    var tmp4_min_0 = this._rawAxes.length;
    var tmp5_min_0 = that._rawAxes.length;
    arraycopy_5(that._rawAxes, 0, this._rawAxes, 0, Math.min(tmp4_min_0, tmp5_min_0));
  };
  GamepadInfo.prototype.get_uo5qy2_k$ = function (button) {
    return this._mapping.get_ytw0rl_k$(button, this);
  };
  GamepadInfo.prototype.get_xbrkt4_k$ = function (stick) {
    var tmp0_apply_0 = this._axesData[stick._id_22];
    tmp0_apply_0._x_1 = this.getX_xbrkt4_k$(stick);
    tmp0_apply_0._y_1 = this.getY_xbrkt4_k$(stick);
    return tmp0_apply_0;
  };
  GamepadInfo.prototype.getX_xbrkt4_k$ = function (stick) {
    var tmp0_subject = stick;
    var tmp;
    if (tmp0_subject.equals(GameStick_LEFT_getInstance())) {
      tmp = this.get_uo5qy2_k$(GameButton_LX_getInstance());
    } else if (tmp0_subject.equals(GameStick_RIGHT_getInstance())) {
      tmp = this.get_uo5qy2_k$(GameButton_RX_getInstance());
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  GamepadInfo.prototype.getY_xbrkt4_k$ = function (stick) {
    var tmp0_subject = stick;
    var tmp;
    if (tmp0_subject.equals(GameStick_LEFT_getInstance())) {
      tmp = this.get_uo5qy2_k$(GameButton_LY_getInstance());
    } else if (tmp0_subject.equals(GameStick_RIGHT_getInstance())) {
      tmp = this.get_uo5qy2_k$(GameButton_RY_getInstance());
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  GamepadInfo.prototype.toString = function () {
    return '' + 'Gamepad[' + this._index_28 + '][' + this._name_24 + ']' + this._mapping.toString_hgumif_k$(this);
  };
  GamepadInfo.$metadata$ = {
    simpleName: 'GamepadInfo',
    kind: 'class',
    interfaces: []
  };
  function MouseButton_init_$Init$(name, ordinal, id, bits, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      bits = 1 << id;
    MouseButton.call($this, name, ordinal, id, bits);
    return $this;
  }
  function MouseButton_init_$Create$(name, ordinal, id, bits, $mask0, $marker) {
    return MouseButton_init_$Init$(name, ordinal, id, bits, $mask0, $marker, Object.create(MouseButton.prototype));
  }
  var MouseButton_LEFT_instance;
  var MouseButton_MIDDLE_instance;
  var MouseButton_RIGHT_instance;
  var MouseButton_BUTTON3_instance;
  var MouseButton_BUTTON4_instance;
  var MouseButton_BUTTON5_instance;
  var MouseButton_BUTTON6_instance;
  var MouseButton_BUTTON7_instance;
  var MouseButton_BUTTON_WHEEL_instance;
  var MouseButton_BUTTON_UNKNOWN_instance;
  var MouseButton_NONE_instance;
  function Companion_174() {
    Companion_instance_173 = this;
    this._MAX_1 = MouseButton_NONE_getInstance()._get_ordinal__0_k$() + 1 | 0;
    this._BUTTONS_0 = values_9();
  }
  Companion_174.prototype.get_ha5a7z_k$ = function (id) {
    var tmp0_getOrElse_0 = this._BUTTONS_0;
    var tmp;
    if (id >= 0 ? id <= _get_lastIndex__1(tmp0_getOrElse_0) : false) {
      tmp = tmp0_getOrElse_0[id];
    } else {
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  };
  Companion_174.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_173;
  function Companion_getInstance_173() {
    if (Companion_instance_173 == null)
      new Companion_174();
    return Companion_instance_173;
  }
  function values_9() {
    return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
  }
  var MouseButton_entriesInitialized;
  function MouseButton_initEntries() {
    if (MouseButton_entriesInitialized)
      return Unit_getInstance();
    MouseButton_entriesInitialized = true;
    MouseButton_LEFT_instance = MouseButton_init_$Create$('LEFT', 0, 0, 0, 8, null);
    MouseButton_MIDDLE_instance = MouseButton_init_$Create$('MIDDLE', 1, 1, 0, 8, null);
    MouseButton_RIGHT_instance = MouseButton_init_$Create$('RIGHT', 2, 2, 0, 8, null);
    MouseButton_BUTTON3_instance = MouseButton_init_$Create$('BUTTON3', 3, 3, 0, 8, null);
    MouseButton_BUTTON4_instance = MouseButton_init_$Create$('BUTTON4', 4, 4, 0, 8, null);
    MouseButton_BUTTON5_instance = MouseButton_init_$Create$('BUTTON5', 5, 5, 0, 8, null);
    MouseButton_BUTTON6_instance = MouseButton_init_$Create$('BUTTON6', 6, 6, 0, 8, null);
    MouseButton_BUTTON7_instance = MouseButton_init_$Create$('BUTTON7', 7, 7, 0, 8, null);
    MouseButton_BUTTON_WHEEL_instance = MouseButton_init_$Create$('BUTTON_WHEEL', 8, 8, 0, 8, null);
    MouseButton_BUTTON_UNKNOWN_instance = MouseButton_init_$Create$('BUTTON_UNKNOWN', 9, 10, 0, 8, null);
    MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
    Companion_getInstance_173();
  }
  function MouseButton(name, ordinal, id, bits) {
    Enum.call(this, name, ordinal);
    this._id_21 = id;
    this._bits_2 = bits;
  }
  MouseButton.$metadata$ = {
    simpleName: 'MouseButton',
    kind: 'class',
    interfaces: []
  };
  var Key_SPACE_instance;
  var Key_APOSTROPHE_instance;
  var Key_COMMA_instance;
  var Key_MINUS_instance;
  var Key_PLUS_instance;
  var Key_PERIOD_instance;
  var Key_SLASH_instance;
  var Key_N0_instance;
  var Key_N1_instance;
  var Key_N2_instance;
  var Key_N3_instance;
  var Key_N4_instance;
  var Key_N5_instance;
  var Key_N6_instance;
  var Key_N7_instance;
  var Key_N8_instance;
  var Key_N9_instance;
  var Key_N11_instance;
  var Key_N12_instance;
  var Key_N3D_MODE_instance;
  var Key_SEMICOLON_instance;
  var Key_EQUAL_instance;
  var Key_AT_instance;
  var Key_A_instance;
  var Key_B_instance;
  var Key_C_instance;
  var Key_D_instance;
  var Key_E_instance;
  var Key_F_instance;
  var Key_G_instance;
  var Key_H_instance;
  var Key_I_instance;
  var Key_J_instance;
  var Key_K_instance;
  var Key_L_instance;
  var Key_M_instance;
  var Key_N_instance;
  var Key_O_instance;
  var Key_P_instance;
  var Key_Q_instance;
  var Key_R_instance;
  var Key_S_instance;
  var Key_T_instance;
  var Key_U_instance;
  var Key_V_instance;
  var Key_W_instance;
  var Key_X_instance;
  var Key_Y_instance;
  var Key_Z_instance;
  var Key_LEFT_BRACKET_instance;
  var Key_BACKSLASH_instance;
  var Key_RIGHT_BRACKET_instance;
  var Key_GRAVE_ACCENT_instance;
  var Key_WORLD_1_instance;
  var Key_WORLD_2_instance;
  var Key_ESCAPE_instance;
  var Key_META_instance;
  var Key_ENTER_instance;
  var Key_TAB_instance;
  var Key_BACKSPACE_instance;
  var Key_INSERT_instance;
  var Key_DELETE_instance;
  var Key_RIGHT_instance;
  var Key_LEFT_instance;
  var Key_DOWN_instance;
  var Key_UP_instance;
  var Key_PAGE_UP_instance;
  var Key_PAGE_DOWN_instance;
  var Key_FUNCTION_instance;
  var Key_HELP_instance;
  var Key_MUTE_instance;
  var Key_VOLUME_DOWN_instance;
  var Key_VOLUME_UP_instance;
  var Key_VOLUME_MUTE_instance;
  var Key_HOME_instance;
  var Key_END_instance;
  var Key_CAPS_LOCK_instance;
  var Key_SCROLL_LOCK_instance;
  var Key_NUM_LOCK_instance;
  var Key_PRINT_SCREEN_instance;
  var Key_PAUSE_instance;
  var Key_F1_instance;
  var Key_F2_instance;
  var Key_F3_instance;
  var Key_F4_instance;
  var Key_F5_instance;
  var Key_F6_instance;
  var Key_F7_instance;
  var Key_F8_instance;
  var Key_F9_instance;
  var Key_F10_instance;
  var Key_F11_instance;
  var Key_F12_instance;
  var Key_F13_instance;
  var Key_F14_instance;
  var Key_F15_instance;
  var Key_F16_instance;
  var Key_F17_instance;
  var Key_F18_instance;
  var Key_F19_instance;
  var Key_F20_instance;
  var Key_F21_instance;
  var Key_F22_instance;
  var Key_F23_instance;
  var Key_F24_instance;
  var Key_F25_instance;
  var Key_KP_0_instance;
  var Key_KP_1_instance;
  var Key_KP_2_instance;
  var Key_KP_3_instance;
  var Key_KP_4_instance;
  var Key_KP_5_instance;
  var Key_KP_6_instance;
  var Key_KP_7_instance;
  var Key_KP_8_instance;
  var Key_KP_9_instance;
  var Key_KP_DECIMAL_instance;
  var Key_KP_DIVIDE_instance;
  var Key_KP_MULTIPLY_instance;
  var Key_KP_SUBTRACT_instance;
  var Key_KP_ADD_instance;
  var Key_KP_COMMA_instance;
  var Key_KP_DOT_instance;
  var Key_KP_ENTER_instance;
  var Key_KP_EQUAL_instance;
  var Key_KP_SEPARATOR_instance;
  var Key_KP_LEFT_PAREN_instance;
  var Key_KP_RIGHT_PAREN_instance;
  var Key_LEFT_SHIFT_instance;
  var Key_LEFT_CONTROL_instance;
  var Key_LEFT_ALT_instance;
  var Key_LEFT_SUPER_instance;
  var Key_RIGHT_SHIFT_instance;
  var Key_RIGHT_CONTROL_instance;
  var Key_RIGHT_ALT_instance;
  var Key_RIGHT_SUPER_instance;
  var Key_MENU_instance;
  var Key_BACK_instance;
  var Key_BACKQUOTE_instance;
  var Key_QUOTE_instance;
  var Key_KP_UP_instance;
  var Key_KP_DOWN_instance;
  var Key_KP_LEFT_instance;
  var Key_KP_RIGHT_instance;
  var Key_UNDERLINE_instance;
  var Key_SELECT_KEY_instance;
  var Key_CANCEL_instance;
  var Key_CLEAR_instance;
  var Key_OPEN_BRACKET_instance;
  var Key_CLOSE_BRACKET_instance;
  var Key_PLAY_instance;
  var Key_NONAME_instance;
  var Key_FINAL_instance;
  var Key_OEM102_instance;
  var Key_OEM1_instance;
  var Key_OEM2_instance;
  var Key_OEM3_instance;
  var Key_OEM4_instance;
  var Key_OEM5_instance;
  var Key_OEM6_instance;
  var Key_OEM7_instance;
  var Key_OEM8_instance;
  var Key_LEFT_MENU_instance;
  var Key_RIGHT_MENU_instance;
  var Key_SLEEP_instance;
  var Key_SNAPSHOT_instance;
  var Key_INFO_instance;
  var Key_XBUTTON1_instance;
  var Key_XBUTTON2_instance;
  var Key_XBUTTON3_instance;
  var Key_XBUTTON4_instance;
  var Key_XBUTTON5_instance;
  var Key_XBUTTON6_instance;
  var Key_XBUTTON7_instance;
  var Key_XBUTTON8_instance;
  var Key_XBUTTON9_instance;
  var Key_XBUTTON10_instance;
  var Key_XBUTTON11_instance;
  var Key_XBUTTON12_instance;
  var Key_XBUTTON13_instance;
  var Key_XBUTTON14_instance;
  var Key_XBUTTON15_instance;
  var Key_XBUTTON16_instance;
  var Key_XBUTTON_A_instance;
  var Key_XBUTTON_B_instance;
  var Key_XBUTTON_C_instance;
  var Key_XBUTTON_L1_instance;
  var Key_XBUTTON_L2_instance;
  var Key_XBUTTON_MODE_instance;
  var Key_XBUTTON_R1_instance;
  var Key_XBUTTON_R2_instance;
  var Key_XBUTTON_SELECT_instance;
  var Key_XBUTTON_START_instance;
  var Key_XBUTTON_THUMBL_instance;
  var Key_XBUTTON_THUMBR_instance;
  var Key_XBUTTON_X_instance;
  var Key_XBUTTON_Y_instance;
  var Key_XBUTTON_Z_instance;
  var Key_DPAD_CENTER_instance;
  var Key_DPAD_DOWN_instance;
  var Key_DPAD_DOWN_LEFT_instance;
  var Key_DPAD_DOWN_RIGHT_instance;
  var Key_DPAD_LEFT_instance;
  var Key_DPAD_RIGHT_instance;
  var Key_DPAD_UP_instance;
  var Key_DPAD_UP_LEFT_instance;
  var Key_DPAD_UP_RIGHT_instance;
  var Key_DVR_instance;
  var Key_EISU_instance;
  var Key_ENDCALL_instance;
  var Key_ENVELOPE_instance;
  var Key_EXPLORER_instance;
  var Key_FOCUS_instance;
  var Key_FORWARD_instance;
  var Key_GRAVE_instance;
  var Key_GUIDE_instance;
  var Key_HEADSETHOOK_instance;
  var Key_ABNT_C1_instance;
  var Key_ABNT_C2_instance;
  var Key_ATTN_instance;
  var Key_CRSEL_instance;
  var Key_EREOF_instance;
  var Key_EXECUTE_instance;
  var Key_EXSEL_instance;
  var Key_ICO_CLEAR_instance;
  var Key_ICO_HELP_instance;
  var Key_HENKAN_instance;
  var Key_PAIRING_instance;
  var Key_APP_SWITCH_instance;
  var Key_ASSIST_instance;
  var Key_AVR_INPUT_instance;
  var Key_AVR_POWER_instance;
  var Key_BOOKMARK_instance;
  var Key_BREAK_instance;
  var Key_CAPTIONS_instance;
  var Key_CAMERA_instance;
  var Key_CALL_instance;
  var Key_CALENDAR_instance;
  var Key_BRIGHTNESS_DOWN_instance;
  var Key_BRIGHTNESS_UP_instance;
  var Key_CHANNEL_DOWN_instance;
  var Key_CHANNEL_UP_instance;
  var Key_CALCULATOR_instance;
  var Key_CONTACTS_instance;
  var Key_NOTIFICATION_instance;
  var Key_COPY_instance;
  var Key_CUT_instance;
  var Key_PASTE_instance;
  var Key_SEARCH_instance;
  var Key_SETTINGS_instance;
  var Key_SOFT_LEFT_instance;
  var Key_SOFT_RIGHT_instance;
  var Key_SOFT_SLEEP_instance;
  var Key_STAR_instance;
  var Key_STB_INPUT_instance;
  var Key_STB_POWER_instance;
  var Key_STEM_1_instance;
  var Key_STEM_2_instance;
  var Key_STEM_3_instance;
  var Key_STEM_PRIMARY_instance;
  var Key_SWITCH_CHARSET_instance;
  var Key_SYM_instance;
  var Key_SYSRQ_instance;
  var Key_NUM_instance;
  var Key_TV_instance;
  var Key_TV_ANTENNA_CABLE_instance;
  var Key_TV_AUDIO_DESCRIPTION_instance;
  var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
  var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
  var Key_TV_CONTENTS_MENU_instance;
  var Key_TV_DATA_SERVICE_instance;
  var Key_TV_INPUT_instance;
  var Key_TV_INPUT_COMPONENT_1_instance;
  var Key_TV_INPUT_COMPONENT_2_instance;
  var Key_TV_INPUT_COMPOSITE_1_instance;
  var Key_TV_INPUT_COMPOSITE_2_instance;
  var Key_TV_INPUT_HDMI_1_instance;
  var Key_TV_INPUT_HDMI_2_instance;
  var Key_TV_INPUT_HDMI_3_instance;
  var Key_TV_INPUT_HDMI_4_instance;
  var Key_TV_INPUT_VGA_1_instance;
  var Key_TV_MEDIA_CONTEXT_MENU_instance;
  var Key_TV_NETWORK_instance;
  var Key_TV_NUMBER_ENTRY_instance;
  var Key_TV_POWER_instance;
  var Key_TV_RADIO_SERVICE_instance;
  var Key_TV_SATELLITE_instance;
  var Key_TV_SATELLITE_BS_instance;
  var Key_TV_SATELLITE_CS_instance;
  var Key_TV_SATELLITE_SERVICE_instance;
  var Key_TV_TELETEXT_instance;
  var Key_TV_TERRESTRIAL_ANALOG_instance;
  var Key_TV_TERRESTRIAL_DIGITAL_instance;
  var Key_TV_TIMER_PROGRAMMING_instance;
  var Key_TV_ZOOM_MODE_instance;
  var Key_VOICE_ASSIST_instance;
  var Key_WAKEUP_instance;
  var Key_WINDOW_instance;
  var Key_YEN_instance;
  var Key_ZENKAKU_HANKAKU_instance;
  var Key_ZOOM_IN_instance;
  var Key_ZOOM_OUT_instance;
  var Key_SYSTEM_NAVIGATION_DOWN_instance;
  var Key_SYSTEM_NAVIGATION_LEFT_instance;
  var Key_SYSTEM_NAVIGATION_RIGHT_instance;
  var Key_SYSTEM_NAVIGATION_UP_instance;
  var Key_PICTSYMBOLS_instance;
  var Key_POUND_instance;
  var Key_POWER_instance;
  var Key_PROG_BLUE_instance;
  var Key_PROG_GREEN_instance;
  var Key_PROG_RED_instance;
  var Key_PROG_YELLOW_instance;
  var Key_RO_instance;
  var Key_OEM_ATTN_instance;
  var Key_OEM_AUTO_instance;
  var Key_OEM_AX_instance;
  var Key_OEM_BACKTAB_instance;
  var Key_OEM_CLEAR_instance;
  var Key_OEM_COMMA_instance;
  var Key_OEM_COPY_instance;
  var Key_OEM_CUSEL_instance;
  var Key_OEM_ENLW_instance;
  var Key_OEM_FINISH_instance;
  var Key_OEM_FJ_LOYA_instance;
  var Key_OEM_FJ_MASSHOU_instance;
  var Key_OEM_FJ_ROYA_instance;
  var Key_OEM_FJ_TOUROKU_instance;
  var Key_OEM_JUMP_instance;
  var Key_OEM_MINUS_instance;
  var Key_OEM_PA1_instance;
  var Key_OEM_PA2_instance;
  var Key_OEM_PA3_instance;
  var Key_OEM_PERIOD_instance;
  var Key_OEM_PLUS_instance;
  var Key_OEM_RESET_instance;
  var Key_OEM_WSCTRL_instance;
  var Key_PA1_instance;
  var Key_PACKET_instance;
  var Key_PROCESSKEY_instance;
  var Key_ZOOM_instance;
  var Key_NONE_instance;
  var Key_ACCEPT_instance;
  var Key_APPS_instance;
  var Key_BROWSER_BACK_instance;
  var Key_BROWSER_FAVORITES_instance;
  var Key_BROWSER_FORWARD_instance;
  var Key_BROWSER_HOME_instance;
  var Key_BROWSER_REFRESH_instance;
  var Key_BROWSER_SEARCH_instance;
  var Key_BROWSER_STOP_instance;
  var Key_CAPITAL_instance;
  var Key_CONVERT_instance;
  var Key_ICO_00_instance;
  var Key_JUNJA_instance;
  var Key_KANA_instance;
  var Key_KANJI_instance;
  var Key_KATAKANA_HIRAGANA_instance;
  var Key_LANGUAGE_SWITCH_instance;
  var Key_MUHENKAN_instance;
  var Key_LAUNCH_APP1_instance;
  var Key_LAUNCH_APP2_instance;
  var Key_LAUNCH_MAIL_instance;
  var Key_LAUNCH_MEDIA_SELECT_instance;
  var Key_LEFT_BUTTON_instance;
  var Key_MIDDLE_BUTTON_instance;
  var Key_MUSIC_instance;
  var Key_MEDIA_NEXT_TRACK_instance;
  var Key_MEDIA_PLAY_PAUSE_instance;
  var Key_MEDIA_PREV_TRACK_instance;
  var Key_MEDIA_STOP_instance;
  var Key_MEDIA_PLAY_instance;
  var Key_MEDIA_PAUSE_instance;
  var Key_MEDIA_AUDIO_TRACK_instance;
  var Key_MEDIA_CLOSE_instance;
  var Key_MEDIA_EJECT_instance;
  var Key_MEDIA_FAST_FORWARD_instance;
  var Key_MEDIA_RECORD_instance;
  var Key_MEDIA_REWIND_instance;
  var Key_MEDIA_SKIP_BACKWARD_instance;
  var Key_MEDIA_SKIP_FORWARD_instance;
  var Key_MEDIA_STEP_BACKWARD_instance;
  var Key_MEDIA_STEP_FORWARD_instance;
  var Key_MEDIA_TOP_MENU_instance;
  var Key_MODECHANGE_instance;
  var Key_NEXT_instance;
  var Key_NONCONVERT_instance;
  var Key_OEM_FJ_JISHO_instance;
  var Key_PRIOR_instance;
  var Key_RIGHT_BUTTON_instance;
  var Key_LAST_CHANNEL_instance;
  var Key_MANNER_MODE_instance;
  var Key_NAVIGATE_IN_instance;
  var Key_NAVIGATE_NEXT_instance;
  var Key_NAVIGATE_OUT_instance;
  var Key_NAVIGATE_PREVIOUS_instance;
  var Key_UNDEFINED_instance;
  var Key_UNKNOWN_instance;
  function Companion_175() {
    Companion_instance_174 = this;
    this._MAX_2 = Key_UNKNOWN_getInstance()._get_ordinal__0_k$() + 1 | 0;
    this._RETURN = Key_ENTER_getInstance();
    this._NUMPAD0 = Key_N0_getInstance();
    this._NUMPAD1 = Key_N1_getInstance();
    this._NUMPAD2 = Key_N2_getInstance();
    this._NUMPAD3 = Key_N3_getInstance();
    this._NUMPAD4 = Key_N4_getInstance();
    this._NUMPAD5 = Key_N5_getInstance();
    this._NUMPAD6 = Key_N6_getInstance();
    this._NUMPAD7 = Key_N7_getInstance();
    this._NUMPAD8 = Key_N8_getInstance();
    this._NUMPAD9 = Key_N9_getInstance();
  }
  Companion_175.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_174;
  function Companion_getInstance_174() {
    if (Companion_instance_174 == null)
      new Companion_175();
    return Companion_instance_174;
  }
  var Key_entriesInitialized;
  function Key_initEntries() {
    if (Key_entriesInitialized)
      return Unit_getInstance();
    Key_entriesInitialized = true;
    Key_SPACE_instance = new Key_6('SPACE', 0);
    Key_APOSTROPHE_instance = new Key_6('APOSTROPHE', 1);
    Key_COMMA_instance = new Key_6('COMMA', 2);
    Key_MINUS_instance = new Key_6('MINUS', 3);
    Key_PLUS_instance = new Key_6('PLUS', 4);
    Key_PERIOD_instance = new Key_6('PERIOD', 5);
    Key_SLASH_instance = new Key_6('SLASH', 6);
    Key_N0_instance = new Key_6('N0', 7);
    Key_N1_instance = new Key_6('N1', 8);
    Key_N2_instance = new Key_6('N2', 9);
    Key_N3_instance = new Key_6('N3', 10);
    Key_N4_instance = new Key_6('N4', 11);
    Key_N5_instance = new Key_6('N5', 12);
    Key_N6_instance = new Key_6('N6', 13);
    Key_N7_instance = new Key_6('N7', 14);
    Key_N8_instance = new Key_6('N8', 15);
    Key_N9_instance = new Key_6('N9', 16);
    Key_N11_instance = new Key_6('N11', 17);
    Key_N12_instance = new Key_6('N12', 18);
    Key_N3D_MODE_instance = new Key_6('N3D_MODE', 19);
    Key_SEMICOLON_instance = new Key_6('SEMICOLON', 20);
    Key_EQUAL_instance = new Key_6('EQUAL', 21);
    Key_AT_instance = new Key_6('AT', 22);
    Key_A_instance = new Key_6('A', 23);
    Key_B_instance = new Key_6('B', 24);
    Key_C_instance = new Key_6('C', 25);
    Key_D_instance = new Key_6('D', 26);
    Key_E_instance = new Key_6('E', 27);
    Key_F_instance = new Key_6('F', 28);
    Key_G_instance = new Key_6('G', 29);
    Key_H_instance = new Key_6('H', 30);
    Key_I_instance = new Key_6('I', 31);
    Key_J_instance = new Key_6('J', 32);
    Key_K_instance = new Key_6('K', 33);
    Key_L_instance = new Key_6('L', 34);
    Key_M_instance = new Key_6('M', 35);
    Key_N_instance = new Key_6('N', 36);
    Key_O_instance = new Key_6('O', 37);
    Key_P_instance = new Key_6('P', 38);
    Key_Q_instance = new Key_6('Q', 39);
    Key_R_instance = new Key_6('R', 40);
    Key_S_instance = new Key_6('S', 41);
    Key_T_instance = new Key_6('T', 42);
    Key_U_instance = new Key_6('U', 43);
    Key_V_instance = new Key_6('V', 44);
    Key_W_instance = new Key_6('W', 45);
    Key_X_instance = new Key_6('X', 46);
    Key_Y_instance = new Key_6('Y', 47);
    Key_Z_instance = new Key_6('Z', 48);
    Key_LEFT_BRACKET_instance = new Key_6('LEFT_BRACKET', 49);
    Key_BACKSLASH_instance = new Key_6('BACKSLASH', 50);
    Key_RIGHT_BRACKET_instance = new Key_6('RIGHT_BRACKET', 51);
    Key_GRAVE_ACCENT_instance = new Key_6('GRAVE_ACCENT', 52);
    Key_WORLD_1_instance = new Key_6('WORLD_1', 53);
    Key_WORLD_2_instance = new Key_6('WORLD_2', 54);
    Key_ESCAPE_instance = new Key_6('ESCAPE', 55);
    Key_META_instance = new Key_6('META', 56);
    Key_ENTER_instance = new Key_6('ENTER', 57);
    Key_TAB_instance = new Key_6('TAB', 58);
    Key_BACKSPACE_instance = new Key_6('BACKSPACE', 59);
    Key_INSERT_instance = new Key_6('INSERT', 60);
    Key_DELETE_instance = new Key_6('DELETE', 61);
    Key_RIGHT_instance = new Key_6('RIGHT', 62);
    Key_LEFT_instance = new Key_6('LEFT', 63);
    Key_DOWN_instance = new Key_6('DOWN', 64);
    Key_UP_instance = new Key_6('UP', 65);
    Key_PAGE_UP_instance = new Key_6('PAGE_UP', 66);
    Key_PAGE_DOWN_instance = new Key_6('PAGE_DOWN', 67);
    Key_FUNCTION_instance = new Key_6('FUNCTION', 68);
    Key_HELP_instance = new Key_6('HELP', 69);
    Key_MUTE_instance = new Key_6('MUTE', 70);
    Key_VOLUME_DOWN_instance = new Key_6('VOLUME_DOWN', 71);
    Key_VOLUME_UP_instance = new Key_6('VOLUME_UP', 72);
    Key_VOLUME_MUTE_instance = new Key_6('VOLUME_MUTE', 73);
    Key_HOME_instance = new Key_6('HOME', 74);
    Key_END_instance = new Key_6('END', 75);
    Key_CAPS_LOCK_instance = new Key_6('CAPS_LOCK', 76);
    Key_SCROLL_LOCK_instance = new Key_6('SCROLL_LOCK', 77);
    Key_NUM_LOCK_instance = new Key_6('NUM_LOCK', 78);
    Key_PRINT_SCREEN_instance = new Key_6('PRINT_SCREEN', 79);
    Key_PAUSE_instance = new Key_6('PAUSE', 80);
    Key_F1_instance = new Key_6('F1', 81);
    Key_F2_instance = new Key_6('F2', 82);
    Key_F3_instance = new Key_6('F3', 83);
    Key_F4_instance = new Key_6('F4', 84);
    Key_F5_instance = new Key_6('F5', 85);
    Key_F6_instance = new Key_6('F6', 86);
    Key_F7_instance = new Key_6('F7', 87);
    Key_F8_instance = new Key_6('F8', 88);
    Key_F9_instance = new Key_6('F9', 89);
    Key_F10_instance = new Key_6('F10', 90);
    Key_F11_instance = new Key_6('F11', 91);
    Key_F12_instance = new Key_6('F12', 92);
    Key_F13_instance = new Key_6('F13', 93);
    Key_F14_instance = new Key_6('F14', 94);
    Key_F15_instance = new Key_6('F15', 95);
    Key_F16_instance = new Key_6('F16', 96);
    Key_F17_instance = new Key_6('F17', 97);
    Key_F18_instance = new Key_6('F18', 98);
    Key_F19_instance = new Key_6('F19', 99);
    Key_F20_instance = new Key_6('F20', 100);
    Key_F21_instance = new Key_6('F21', 101);
    Key_F22_instance = new Key_6('F22', 102);
    Key_F23_instance = new Key_6('F23', 103);
    Key_F24_instance = new Key_6('F24', 104);
    Key_F25_instance = new Key_6('F25', 105);
    Key_KP_0_instance = new Key_6('KP_0', 106);
    Key_KP_1_instance = new Key_6('KP_1', 107);
    Key_KP_2_instance = new Key_6('KP_2', 108);
    Key_KP_3_instance = new Key_6('KP_3', 109);
    Key_KP_4_instance = new Key_6('KP_4', 110);
    Key_KP_5_instance = new Key_6('KP_5', 111);
    Key_KP_6_instance = new Key_6('KP_6', 112);
    Key_KP_7_instance = new Key_6('KP_7', 113);
    Key_KP_8_instance = new Key_6('KP_8', 114);
    Key_KP_9_instance = new Key_6('KP_9', 115);
    Key_KP_DECIMAL_instance = new Key_6('KP_DECIMAL', 116);
    Key_KP_DIVIDE_instance = new Key_6('KP_DIVIDE', 117);
    Key_KP_MULTIPLY_instance = new Key_6('KP_MULTIPLY', 118);
    Key_KP_SUBTRACT_instance = new Key_6('KP_SUBTRACT', 119);
    Key_KP_ADD_instance = new Key_6('KP_ADD', 120);
    Key_KP_COMMA_instance = new Key_6('KP_COMMA', 121);
    Key_KP_DOT_instance = new Key_6('KP_DOT', 122);
    Key_KP_ENTER_instance = new Key_6('KP_ENTER', 123);
    Key_KP_EQUAL_instance = new Key_6('KP_EQUAL', 124);
    Key_KP_SEPARATOR_instance = new Key_6('KP_SEPARATOR', 125);
    Key_KP_LEFT_PAREN_instance = new Key_6('KP_LEFT_PAREN', 126);
    Key_KP_RIGHT_PAREN_instance = new Key_6('KP_RIGHT_PAREN', 127);
    Key_LEFT_SHIFT_instance = new Key_6('LEFT_SHIFT', 128);
    Key_LEFT_CONTROL_instance = new Key_6('LEFT_CONTROL', 129);
    Key_LEFT_ALT_instance = new Key_6('LEFT_ALT', 130);
    Key_LEFT_SUPER_instance = new Key_6('LEFT_SUPER', 131);
    Key_RIGHT_SHIFT_instance = new Key_6('RIGHT_SHIFT', 132);
    Key_RIGHT_CONTROL_instance = new Key_6('RIGHT_CONTROL', 133);
    Key_RIGHT_ALT_instance = new Key_6('RIGHT_ALT', 134);
    Key_RIGHT_SUPER_instance = new Key_6('RIGHT_SUPER', 135);
    Key_MENU_instance = new Key_6('MENU', 136);
    Key_BACK_instance = new Key_6('BACK', 137);
    Key_BACKQUOTE_instance = new Key_6('BACKQUOTE', 138);
    Key_QUOTE_instance = new Key_6('QUOTE', 139);
    Key_KP_UP_instance = new Key_6('KP_UP', 140);
    Key_KP_DOWN_instance = new Key_6('KP_DOWN', 141);
    Key_KP_LEFT_instance = new Key_6('KP_LEFT', 142);
    Key_KP_RIGHT_instance = new Key_6('KP_RIGHT', 143);
    Key_UNDERLINE_instance = new Key_6('UNDERLINE', 144);
    Key_SELECT_KEY_instance = new Key_6('SELECT_KEY', 145);
    Key_CANCEL_instance = new Key_6('CANCEL', 146);
    Key_CLEAR_instance = new Key_6('CLEAR', 147);
    Key_OPEN_BRACKET_instance = new Key_6('OPEN_BRACKET', 148);
    Key_CLOSE_BRACKET_instance = new Key_6('CLOSE_BRACKET', 149);
    Key_PLAY_instance = new Key_6('PLAY', 150);
    Key_NONAME_instance = new Key_6('NONAME', 151);
    Key_FINAL_instance = new Key_6('FINAL', 152);
    Key_OEM102_instance = new Key_6('OEM102', 153);
    Key_OEM1_instance = new Key_6('OEM1', 154);
    Key_OEM2_instance = new Key_6('OEM2', 155);
    Key_OEM3_instance = new Key_6('OEM3', 156);
    Key_OEM4_instance = new Key_6('OEM4', 157);
    Key_OEM5_instance = new Key_6('OEM5', 158);
    Key_OEM6_instance = new Key_6('OEM6', 159);
    Key_OEM7_instance = new Key_6('OEM7', 160);
    Key_OEM8_instance = new Key_6('OEM8', 161);
    Key_LEFT_MENU_instance = new Key_6('LEFT_MENU', 162);
    Key_RIGHT_MENU_instance = new Key_6('RIGHT_MENU', 163);
    Key_SLEEP_instance = new Key_6('SLEEP', 164);
    Key_SNAPSHOT_instance = new Key_6('SNAPSHOT', 165);
    Key_INFO_instance = new Key_6('INFO', 166);
    Key_XBUTTON1_instance = new Key_6('XBUTTON1', 167);
    Key_XBUTTON2_instance = new Key_6('XBUTTON2', 168);
    Key_XBUTTON3_instance = new Key_6('XBUTTON3', 169);
    Key_XBUTTON4_instance = new Key_6('XBUTTON4', 170);
    Key_XBUTTON5_instance = new Key_6('XBUTTON5', 171);
    Key_XBUTTON6_instance = new Key_6('XBUTTON6', 172);
    Key_XBUTTON7_instance = new Key_6('XBUTTON7', 173);
    Key_XBUTTON8_instance = new Key_6('XBUTTON8', 174);
    Key_XBUTTON9_instance = new Key_6('XBUTTON9', 175);
    Key_XBUTTON10_instance = new Key_6('XBUTTON10', 176);
    Key_XBUTTON11_instance = new Key_6('XBUTTON11', 177);
    Key_XBUTTON12_instance = new Key_6('XBUTTON12', 178);
    Key_XBUTTON13_instance = new Key_6('XBUTTON13', 179);
    Key_XBUTTON14_instance = new Key_6('XBUTTON14', 180);
    Key_XBUTTON15_instance = new Key_6('XBUTTON15', 181);
    Key_XBUTTON16_instance = new Key_6('XBUTTON16', 182);
    Key_XBUTTON_A_instance = new Key_6('XBUTTON_A', 183);
    Key_XBUTTON_B_instance = new Key_6('XBUTTON_B', 184);
    Key_XBUTTON_C_instance = new Key_6('XBUTTON_C', 185);
    Key_XBUTTON_L1_instance = new Key_6('XBUTTON_L1', 186);
    Key_XBUTTON_L2_instance = new Key_6('XBUTTON_L2', 187);
    Key_XBUTTON_MODE_instance = new Key_6('XBUTTON_MODE', 188);
    Key_XBUTTON_R1_instance = new Key_6('XBUTTON_R1', 189);
    Key_XBUTTON_R2_instance = new Key_6('XBUTTON_R2', 190);
    Key_XBUTTON_SELECT_instance = new Key_6('XBUTTON_SELECT', 191);
    Key_XBUTTON_START_instance = new Key_6('XBUTTON_START', 192);
    Key_XBUTTON_THUMBL_instance = new Key_6('XBUTTON_THUMBL', 193);
    Key_XBUTTON_THUMBR_instance = new Key_6('XBUTTON_THUMBR', 194);
    Key_XBUTTON_X_instance = new Key_6('XBUTTON_X', 195);
    Key_XBUTTON_Y_instance = new Key_6('XBUTTON_Y', 196);
    Key_XBUTTON_Z_instance = new Key_6('XBUTTON_Z', 197);
    Key_DPAD_CENTER_instance = new Key_6('DPAD_CENTER', 198);
    Key_DPAD_DOWN_instance = new Key_6('DPAD_DOWN', 199);
    Key_DPAD_DOWN_LEFT_instance = new Key_6('DPAD_DOWN_LEFT', 200);
    Key_DPAD_DOWN_RIGHT_instance = new Key_6('DPAD_DOWN_RIGHT', 201);
    Key_DPAD_LEFT_instance = new Key_6('DPAD_LEFT', 202);
    Key_DPAD_RIGHT_instance = new Key_6('DPAD_RIGHT', 203);
    Key_DPAD_UP_instance = new Key_6('DPAD_UP', 204);
    Key_DPAD_UP_LEFT_instance = new Key_6('DPAD_UP_LEFT', 205);
    Key_DPAD_UP_RIGHT_instance = new Key_6('DPAD_UP_RIGHT', 206);
    Key_DVR_instance = new Key_6('DVR', 207);
    Key_EISU_instance = new Key_6('EISU', 208);
    Key_ENDCALL_instance = new Key_6('ENDCALL', 209);
    Key_ENVELOPE_instance = new Key_6('ENVELOPE', 210);
    Key_EXPLORER_instance = new Key_6('EXPLORER', 211);
    Key_FOCUS_instance = new Key_6('FOCUS', 212);
    Key_FORWARD_instance = new Key_6('FORWARD', 213);
    Key_GRAVE_instance = new Key_6('GRAVE', 214);
    Key_GUIDE_instance = new Key_6('GUIDE', 215);
    Key_HEADSETHOOK_instance = new Key_6('HEADSETHOOK', 216);
    Key_ABNT_C1_instance = new Key_6('ABNT_C1', 217);
    Key_ABNT_C2_instance = new Key_6('ABNT_C2', 218);
    Key_ATTN_instance = new Key_6('ATTN', 219);
    Key_CRSEL_instance = new Key_6('CRSEL', 220);
    Key_EREOF_instance = new Key_6('EREOF', 221);
    Key_EXECUTE_instance = new Key_6('EXECUTE', 222);
    Key_EXSEL_instance = new Key_6('EXSEL', 223);
    Key_ICO_CLEAR_instance = new Key_6('ICO_CLEAR', 224);
    Key_ICO_HELP_instance = new Key_6('ICO_HELP', 225);
    Key_HENKAN_instance = new Key_6('HENKAN', 226);
    Key_PAIRING_instance = new Key_6('PAIRING', 227);
    Key_APP_SWITCH_instance = new Key_6('APP_SWITCH', 228);
    Key_ASSIST_instance = new Key_6('ASSIST', 229);
    Key_AVR_INPUT_instance = new Key_6('AVR_INPUT', 230);
    Key_AVR_POWER_instance = new Key_6('AVR_POWER', 231);
    Key_BOOKMARK_instance = new Key_6('BOOKMARK', 232);
    Key_BREAK_instance = new Key_6('BREAK', 233);
    Key_CAPTIONS_instance = new Key_6('CAPTIONS', 234);
    Key_CAMERA_instance = new Key_6('CAMERA', 235);
    Key_CALL_instance = new Key_6('CALL', 236);
    Key_CALENDAR_instance = new Key_6('CALENDAR', 237);
    Key_BRIGHTNESS_DOWN_instance = new Key_6('BRIGHTNESS_DOWN', 238);
    Key_BRIGHTNESS_UP_instance = new Key_6('BRIGHTNESS_UP', 239);
    Key_CHANNEL_DOWN_instance = new Key_6('CHANNEL_DOWN', 240);
    Key_CHANNEL_UP_instance = new Key_6('CHANNEL_UP', 241);
    Key_CALCULATOR_instance = new Key_6('CALCULATOR', 242);
    Key_CONTACTS_instance = new Key_6('CONTACTS', 243);
    Key_NOTIFICATION_instance = new Key_6('NOTIFICATION', 244);
    Key_COPY_instance = new Key_6('COPY', 245);
    Key_CUT_instance = new Key_6('CUT', 246);
    Key_PASTE_instance = new Key_6('PASTE', 247);
    Key_SEARCH_instance = new Key_6('SEARCH', 248);
    Key_SETTINGS_instance = new Key_6('SETTINGS', 249);
    Key_SOFT_LEFT_instance = new Key_6('SOFT_LEFT', 250);
    Key_SOFT_RIGHT_instance = new Key_6('SOFT_RIGHT', 251);
    Key_SOFT_SLEEP_instance = new Key_6('SOFT_SLEEP', 252);
    Key_STAR_instance = new Key_6('STAR', 253);
    Key_STB_INPUT_instance = new Key_6('STB_INPUT', 254);
    Key_STB_POWER_instance = new Key_6('STB_POWER', 255);
    Key_STEM_1_instance = new Key_6('STEM_1', 256);
    Key_STEM_2_instance = new Key_6('STEM_2', 257);
    Key_STEM_3_instance = new Key_6('STEM_3', 258);
    Key_STEM_PRIMARY_instance = new Key_6('STEM_PRIMARY', 259);
    Key_SWITCH_CHARSET_instance = new Key_6('SWITCH_CHARSET', 260);
    Key_SYM_instance = new Key_6('SYM', 261);
    Key_SYSRQ_instance = new Key_6('SYSRQ', 262);
    Key_NUM_instance = new Key_6('NUM', 263);
    Key_TV_instance = new Key_6('TV', 264);
    Key_TV_ANTENNA_CABLE_instance = new Key_6('TV_ANTENNA_CABLE', 265);
    Key_TV_AUDIO_DESCRIPTION_instance = new Key_6('TV_AUDIO_DESCRIPTION', 266);
    Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key_6('TV_AUDIO_DESCRIPTION_MIX_DOWN', 267);
    Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key_6('TV_AUDIO_DESCRIPTION_MIX_UP', 268);
    Key_TV_CONTENTS_MENU_instance = new Key_6('TV_CONTENTS_MENU', 269);
    Key_TV_DATA_SERVICE_instance = new Key_6('TV_DATA_SERVICE', 270);
    Key_TV_INPUT_instance = new Key_6('TV_INPUT', 271);
    Key_TV_INPUT_COMPONENT_1_instance = new Key_6('TV_INPUT_COMPONENT_1', 272);
    Key_TV_INPUT_COMPONENT_2_instance = new Key_6('TV_INPUT_COMPONENT_2', 273);
    Key_TV_INPUT_COMPOSITE_1_instance = new Key_6('TV_INPUT_COMPOSITE_1', 274);
    Key_TV_INPUT_COMPOSITE_2_instance = new Key_6('TV_INPUT_COMPOSITE_2', 275);
    Key_TV_INPUT_HDMI_1_instance = new Key_6('TV_INPUT_HDMI_1', 276);
    Key_TV_INPUT_HDMI_2_instance = new Key_6('TV_INPUT_HDMI_2', 277);
    Key_TV_INPUT_HDMI_3_instance = new Key_6('TV_INPUT_HDMI_3', 278);
    Key_TV_INPUT_HDMI_4_instance = new Key_6('TV_INPUT_HDMI_4', 279);
    Key_TV_INPUT_VGA_1_instance = new Key_6('TV_INPUT_VGA_1', 280);
    Key_TV_MEDIA_CONTEXT_MENU_instance = new Key_6('TV_MEDIA_CONTEXT_MENU', 281);
    Key_TV_NETWORK_instance = new Key_6('TV_NETWORK', 282);
    Key_TV_NUMBER_ENTRY_instance = new Key_6('TV_NUMBER_ENTRY', 283);
    Key_TV_POWER_instance = new Key_6('TV_POWER', 284);
    Key_TV_RADIO_SERVICE_instance = new Key_6('TV_RADIO_SERVICE', 285);
    Key_TV_SATELLITE_instance = new Key_6('TV_SATELLITE', 286);
    Key_TV_SATELLITE_BS_instance = new Key_6('TV_SATELLITE_BS', 287);
    Key_TV_SATELLITE_CS_instance = new Key_6('TV_SATELLITE_CS', 288);
    Key_TV_SATELLITE_SERVICE_instance = new Key_6('TV_SATELLITE_SERVICE', 289);
    Key_TV_TELETEXT_instance = new Key_6('TV_TELETEXT', 290);
    Key_TV_TERRESTRIAL_ANALOG_instance = new Key_6('TV_TERRESTRIAL_ANALOG', 291);
    Key_TV_TERRESTRIAL_DIGITAL_instance = new Key_6('TV_TERRESTRIAL_DIGITAL', 292);
    Key_TV_TIMER_PROGRAMMING_instance = new Key_6('TV_TIMER_PROGRAMMING', 293);
    Key_TV_ZOOM_MODE_instance = new Key_6('TV_ZOOM_MODE', 294);
    Key_VOICE_ASSIST_instance = new Key_6('VOICE_ASSIST', 295);
    Key_WAKEUP_instance = new Key_6('WAKEUP', 296);
    Key_WINDOW_instance = new Key_6('WINDOW', 297);
    Key_YEN_instance = new Key_6('YEN', 298);
    Key_ZENKAKU_HANKAKU_instance = new Key_6('ZENKAKU_HANKAKU', 299);
    Key_ZOOM_IN_instance = new Key_6('ZOOM_IN', 300);
    Key_ZOOM_OUT_instance = new Key_6('ZOOM_OUT', 301);
    Key_SYSTEM_NAVIGATION_DOWN_instance = new Key_6('SYSTEM_NAVIGATION_DOWN', 302);
    Key_SYSTEM_NAVIGATION_LEFT_instance = new Key_6('SYSTEM_NAVIGATION_LEFT', 303);
    Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key_6('SYSTEM_NAVIGATION_RIGHT', 304);
    Key_SYSTEM_NAVIGATION_UP_instance = new Key_6('SYSTEM_NAVIGATION_UP', 305);
    Key_PICTSYMBOLS_instance = new Key_6('PICTSYMBOLS', 306);
    Key_POUND_instance = new Key_6('POUND', 307);
    Key_POWER_instance = new Key_6('POWER', 308);
    Key_PROG_BLUE_instance = new Key_6('PROG_BLUE', 309);
    Key_PROG_GREEN_instance = new Key_6('PROG_GREEN', 310);
    Key_PROG_RED_instance = new Key_6('PROG_RED', 311);
    Key_PROG_YELLOW_instance = new Key_6('PROG_YELLOW', 312);
    Key_RO_instance = new Key_6('RO', 313);
    Key_OEM_ATTN_instance = new Key_6('OEM_ATTN', 314);
    Key_OEM_AUTO_instance = new Key_6('OEM_AUTO', 315);
    Key_OEM_AX_instance = new Key_6('OEM_AX', 316);
    Key_OEM_BACKTAB_instance = new Key_6('OEM_BACKTAB', 317);
    Key_OEM_CLEAR_instance = new Key_6('OEM_CLEAR', 318);
    Key_OEM_COMMA_instance = new Key_6('OEM_COMMA', 319);
    Key_OEM_COPY_instance = new Key_6('OEM_COPY', 320);
    Key_OEM_CUSEL_instance = new Key_6('OEM_CUSEL', 321);
    Key_OEM_ENLW_instance = new Key_6('OEM_ENLW', 322);
    Key_OEM_FINISH_instance = new Key_6('OEM_FINISH', 323);
    Key_OEM_FJ_LOYA_instance = new Key_6('OEM_FJ_LOYA', 324);
    Key_OEM_FJ_MASSHOU_instance = new Key_6('OEM_FJ_MASSHOU', 325);
    Key_OEM_FJ_ROYA_instance = new Key_6('OEM_FJ_ROYA', 326);
    Key_OEM_FJ_TOUROKU_instance = new Key_6('OEM_FJ_TOUROKU', 327);
    Key_OEM_JUMP_instance = new Key_6('OEM_JUMP', 328);
    Key_OEM_MINUS_instance = new Key_6('OEM_MINUS', 329);
    Key_OEM_PA1_instance = new Key_6('OEM_PA1', 330);
    Key_OEM_PA2_instance = new Key_6('OEM_PA2', 331);
    Key_OEM_PA3_instance = new Key_6('OEM_PA3', 332);
    Key_OEM_PERIOD_instance = new Key_6('OEM_PERIOD', 333);
    Key_OEM_PLUS_instance = new Key_6('OEM_PLUS', 334);
    Key_OEM_RESET_instance = new Key_6('OEM_RESET', 335);
    Key_OEM_WSCTRL_instance = new Key_6('OEM_WSCTRL', 336);
    Key_PA1_instance = new Key_6('PA1', 337);
    Key_PACKET_instance = new Key_6('PACKET', 338);
    Key_PROCESSKEY_instance = new Key_6('PROCESSKEY', 339);
    Key_ZOOM_instance = new Key_6('ZOOM', 340);
    Key_NONE_instance = new Key_6('NONE', 341);
    Key_ACCEPT_instance = new Key_6('ACCEPT', 342);
    Key_APPS_instance = new Key_6('APPS', 343);
    Key_BROWSER_BACK_instance = new Key_6('BROWSER_BACK', 344);
    Key_BROWSER_FAVORITES_instance = new Key_6('BROWSER_FAVORITES', 345);
    Key_BROWSER_FORWARD_instance = new Key_6('BROWSER_FORWARD', 346);
    Key_BROWSER_HOME_instance = new Key_6('BROWSER_HOME', 347);
    Key_BROWSER_REFRESH_instance = new Key_6('BROWSER_REFRESH', 348);
    Key_BROWSER_SEARCH_instance = new Key_6('BROWSER_SEARCH', 349);
    Key_BROWSER_STOP_instance = new Key_6('BROWSER_STOP', 350);
    Key_CAPITAL_instance = new Key_6('CAPITAL', 351);
    Key_CONVERT_instance = new Key_6('CONVERT', 352);
    Key_ICO_00_instance = new Key_6('ICO_00', 353);
    Key_JUNJA_instance = new Key_6('JUNJA', 354);
    Key_KANA_instance = new Key_6('KANA', 355);
    Key_KANJI_instance = new Key_6('KANJI', 356);
    Key_KATAKANA_HIRAGANA_instance = new Key_6('KATAKANA_HIRAGANA', 357);
    Key_LANGUAGE_SWITCH_instance = new Key_6('LANGUAGE_SWITCH', 358);
    Key_MUHENKAN_instance = new Key_6('MUHENKAN', 359);
    Key_LAUNCH_APP1_instance = new Key_6('LAUNCH_APP1', 360);
    Key_LAUNCH_APP2_instance = new Key_6('LAUNCH_APP2', 361);
    Key_LAUNCH_MAIL_instance = new Key_6('LAUNCH_MAIL', 362);
    Key_LAUNCH_MEDIA_SELECT_instance = new Key_6('LAUNCH_MEDIA_SELECT', 363);
    Key_LEFT_BUTTON_instance = new Key_6('LEFT_BUTTON', 364);
    Key_MIDDLE_BUTTON_instance = new Key_6('MIDDLE_BUTTON', 365);
    Key_MUSIC_instance = new Key_6('MUSIC', 366);
    Key_MEDIA_NEXT_TRACK_instance = new Key_6('MEDIA_NEXT_TRACK', 367);
    Key_MEDIA_PLAY_PAUSE_instance = new Key_6('MEDIA_PLAY_PAUSE', 368);
    Key_MEDIA_PREV_TRACK_instance = new Key_6('MEDIA_PREV_TRACK', 369);
    Key_MEDIA_STOP_instance = new Key_6('MEDIA_STOP', 370);
    Key_MEDIA_PLAY_instance = new Key_6('MEDIA_PLAY', 371);
    Key_MEDIA_PAUSE_instance = new Key_6('MEDIA_PAUSE', 372);
    Key_MEDIA_AUDIO_TRACK_instance = new Key_6('MEDIA_AUDIO_TRACK', 373);
    Key_MEDIA_CLOSE_instance = new Key_6('MEDIA_CLOSE', 374);
    Key_MEDIA_EJECT_instance = new Key_6('MEDIA_EJECT', 375);
    Key_MEDIA_FAST_FORWARD_instance = new Key_6('MEDIA_FAST_FORWARD', 376);
    Key_MEDIA_RECORD_instance = new Key_6('MEDIA_RECORD', 377);
    Key_MEDIA_REWIND_instance = new Key_6('MEDIA_REWIND', 378);
    Key_MEDIA_SKIP_BACKWARD_instance = new Key_6('MEDIA_SKIP_BACKWARD', 379);
    Key_MEDIA_SKIP_FORWARD_instance = new Key_6('MEDIA_SKIP_FORWARD', 380);
    Key_MEDIA_STEP_BACKWARD_instance = new Key_6('MEDIA_STEP_BACKWARD', 381);
    Key_MEDIA_STEP_FORWARD_instance = new Key_6('MEDIA_STEP_FORWARD', 382);
    Key_MEDIA_TOP_MENU_instance = new Key_6('MEDIA_TOP_MENU', 383);
    Key_MODECHANGE_instance = new Key_6('MODECHANGE', 384);
    Key_NEXT_instance = new Key_6('NEXT', 385);
    Key_NONCONVERT_instance = new Key_6('NONCONVERT', 386);
    Key_OEM_FJ_JISHO_instance = new Key_6('OEM_FJ_JISHO', 387);
    Key_PRIOR_instance = new Key_6('PRIOR', 388);
    Key_RIGHT_BUTTON_instance = new Key_6('RIGHT_BUTTON', 389);
    Key_LAST_CHANNEL_instance = new Key_6('LAST_CHANNEL', 390);
    Key_MANNER_MODE_instance = new Key_6('MANNER_MODE', 391);
    Key_NAVIGATE_IN_instance = new Key_6('NAVIGATE_IN', 392);
    Key_NAVIGATE_NEXT_instance = new Key_6('NAVIGATE_NEXT', 393);
    Key_NAVIGATE_OUT_instance = new Key_6('NAVIGATE_OUT', 394);
    Key_NAVIGATE_PREVIOUS_instance = new Key_6('NAVIGATE_PREVIOUS', 395);
    Key_UNDEFINED_instance = new Key_6('UNDEFINED', 396);
    Key_UNKNOWN_instance = new Key_6('UNKNOWN', 397);
    Companion_getInstance_174();
  }
  function Key_6(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Key_6.prototype._get_isFunctionKey__0_k$ = function () {
    var tmp0_subject = this;
    return ((((((((((((((((((((((((tmp0_subject.equals(Key_F1_getInstance()) ? true : tmp0_subject.equals(Key_F2_getInstance())) ? true : tmp0_subject.equals(Key_F3_getInstance())) ? true : tmp0_subject.equals(Key_F4_getInstance())) ? true : tmp0_subject.equals(Key_F5_getInstance())) ? true : tmp0_subject.equals(Key_F6_getInstance())) ? true : tmp0_subject.equals(Key_F7_getInstance())) ? true : tmp0_subject.equals(Key_F8_getInstance())) ? true : tmp0_subject.equals(Key_F9_getInstance())) ? true : tmp0_subject.equals(Key_F10_getInstance())) ? true : tmp0_subject.equals(Key_F11_getInstance())) ? true : tmp0_subject.equals(Key_F12_getInstance())) ? true : tmp0_subject.equals(Key_F13_getInstance())) ? true : tmp0_subject.equals(Key_F14_getInstance())) ? true : tmp0_subject.equals(Key_F15_getInstance())) ? true : tmp0_subject.equals(Key_F16_getInstance())) ? true : tmp0_subject.equals(Key_F17_getInstance())) ? true : tmp0_subject.equals(Key_F18_getInstance())) ? true : tmp0_subject.equals(Key_F19_getInstance())) ? true : tmp0_subject.equals(Key_F20_getInstance())) ? true : tmp0_subject.equals(Key_F21_getInstance())) ? true : tmp0_subject.equals(Key_F22_getInstance())) ? true : tmp0_subject.equals(Key_F23_getInstance())) ? true : tmp0_subject.equals(Key_F24_getInstance())) ? true : tmp0_subject.equals(Key_F25_getInstance())) ? true : false;
  };
  Key_6.$metadata$ = {
    simpleName: 'Key',
    kind: 'class',
    interfaces: []
  };
  var GameStick_LEFT_instance;
  var GameStick_RIGHT_instance;
  function Companion_176() {
    Companion_instance_175 = this;
    this._STICKS = values_10();
  }
  Companion_176.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_175;
  function Companion_getInstance_175() {
    if (Companion_instance_175 == null)
      new Companion_176();
    return Companion_instance_175;
  }
  function values_10() {
    return [GameStick_LEFT_getInstance(), GameStick_RIGHT_getInstance()];
  }
  var GameStick_entriesInitialized;
  function GameStick_initEntries() {
    if (GameStick_entriesInitialized)
      return Unit_getInstance();
    GameStick_entriesInitialized = true;
    GameStick_LEFT_instance = new GameStick('LEFT', 0, 0);
    GameStick_RIGHT_instance = new GameStick('RIGHT', 1, 1);
    Companion_getInstance_175();
  }
  function GameStick(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this._id_22 = id;
  }
  GameStick.$metadata$ = {
    simpleName: 'GameStick',
    kind: 'class',
    interfaces: []
  };
  function GameButton_LEFT_getInstance() {
    GameButton_initEntries();
    return GameButton_LEFT_instance;
  }
  function GameButton_RIGHT_getInstance() {
    GameButton_initEntries();
    return GameButton_RIGHT_instance;
  }
  function GameButton_UP_getInstance() {
    GameButton_initEntries();
    return GameButton_UP_instance;
  }
  function GameButton_DOWN_getInstance() {
    GameButton_initEntries();
    return GameButton_DOWN_instance;
  }
  function GameButton_BUTTON0_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON0_instance;
  }
  function GameButton_BUTTON1_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON1_instance;
  }
  function GameButton_BUTTON2_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON2_instance;
  }
  function GameButton_BUTTON3_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON3_instance;
  }
  function GameButton_SELECT_getInstance() {
    GameButton_initEntries();
    return GameButton_SELECT_instance;
  }
  function GameButton_START_getInstance() {
    GameButton_initEntries();
    return GameButton_START_instance;
  }
  function GameButton_SYSTEM_getInstance() {
    GameButton_initEntries();
    return GameButton_SYSTEM_instance;
  }
  function GameButton_L1_getInstance() {
    GameButton_initEntries();
    return GameButton_L1_instance;
  }
  function GameButton_R1_getInstance() {
    GameButton_initEntries();
    return GameButton_R1_instance;
  }
  function GameButton_L2_getInstance() {
    GameButton_initEntries();
    return GameButton_L2_instance;
  }
  function GameButton_R2_getInstance() {
    GameButton_initEntries();
    return GameButton_R2_instance;
  }
  function GameButton_L3_getInstance() {
    GameButton_initEntries();
    return GameButton_L3_instance;
  }
  function GameButton_R3_getInstance() {
    GameButton_initEntries();
    return GameButton_R3_instance;
  }
  function GameButton_LX_getInstance() {
    GameButton_initEntries();
    return GameButton_LX_instance;
  }
  function GameButton_LY_getInstance() {
    GameButton_initEntries();
    return GameButton_LY_instance;
  }
  function GameButton_RX_getInstance() {
    GameButton_initEntries();
    return GameButton_RX_instance;
  }
  function GameButton_RY_getInstance() {
    GameButton_initEntries();
    return GameButton_RY_instance;
  }
  function GameButton_BUTTON4_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON4_instance;
  }
  function GameButton_BUTTON5_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON5_instance;
  }
  function GameButton_BUTTON6_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON6_instance;
  }
  function GameButton_BUTTON7_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON7_instance;
  }
  function GameButton_BUTTON8_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON8_instance;
  }
  function MouseButton_LEFT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_LEFT_instance;
  }
  function MouseButton_MIDDLE_getInstance() {
    MouseButton_initEntries();
    return MouseButton_MIDDLE_instance;
  }
  function MouseButton_RIGHT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_RIGHT_instance;
  }
  function MouseButton_BUTTON3_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON3_instance;
  }
  function MouseButton_BUTTON4_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON4_instance;
  }
  function MouseButton_BUTTON5_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON5_instance;
  }
  function MouseButton_BUTTON6_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON6_instance;
  }
  function MouseButton_BUTTON7_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON7_instance;
  }
  function MouseButton_BUTTON_WHEEL_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON_WHEEL_instance;
  }
  function MouseButton_BUTTON_UNKNOWN_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON_UNKNOWN_instance;
  }
  function MouseButton_NONE_getInstance() {
    MouseButton_initEntries();
    return MouseButton_NONE_instance;
  }
  function Key_SPACE_getInstance() {
    Key_initEntries();
    return Key_SPACE_instance;
  }
  function Key_APOSTROPHE_getInstance() {
    Key_initEntries();
    return Key_APOSTROPHE_instance;
  }
  function Key_COMMA_getInstance() {
    Key_initEntries();
    return Key_COMMA_instance;
  }
  function Key_MINUS_getInstance() {
    Key_initEntries();
    return Key_MINUS_instance;
  }
  function Key_PLUS_getInstance() {
    Key_initEntries();
    return Key_PLUS_instance;
  }
  function Key_PERIOD_getInstance() {
    Key_initEntries();
    return Key_PERIOD_instance;
  }
  function Key_SLASH_getInstance() {
    Key_initEntries();
    return Key_SLASH_instance;
  }
  function Key_N0_getInstance() {
    Key_initEntries();
    return Key_N0_instance;
  }
  function Key_N1_getInstance() {
    Key_initEntries();
    return Key_N1_instance;
  }
  function Key_N2_getInstance() {
    Key_initEntries();
    return Key_N2_instance;
  }
  function Key_N3_getInstance() {
    Key_initEntries();
    return Key_N3_instance;
  }
  function Key_N4_getInstance() {
    Key_initEntries();
    return Key_N4_instance;
  }
  function Key_N5_getInstance() {
    Key_initEntries();
    return Key_N5_instance;
  }
  function Key_N6_getInstance() {
    Key_initEntries();
    return Key_N6_instance;
  }
  function Key_N7_getInstance() {
    Key_initEntries();
    return Key_N7_instance;
  }
  function Key_N8_getInstance() {
    Key_initEntries();
    return Key_N8_instance;
  }
  function Key_N9_getInstance() {
    Key_initEntries();
    return Key_N9_instance;
  }
  function Key_SEMICOLON_getInstance() {
    Key_initEntries();
    return Key_SEMICOLON_instance;
  }
  function Key_A_getInstance() {
    Key_initEntries();
    return Key_A_instance;
  }
  function Key_B_getInstance() {
    Key_initEntries();
    return Key_B_instance;
  }
  function Key_C_getInstance() {
    Key_initEntries();
    return Key_C_instance;
  }
  function Key_D_getInstance() {
    Key_initEntries();
    return Key_D_instance;
  }
  function Key_E_getInstance() {
    Key_initEntries();
    return Key_E_instance;
  }
  function Key_F_getInstance() {
    Key_initEntries();
    return Key_F_instance;
  }
  function Key_G_getInstance() {
    Key_initEntries();
    return Key_G_instance;
  }
  function Key_H_getInstance() {
    Key_initEntries();
    return Key_H_instance;
  }
  function Key_I_getInstance() {
    Key_initEntries();
    return Key_I_instance;
  }
  function Key_J_getInstance() {
    Key_initEntries();
    return Key_J_instance;
  }
  function Key_K_getInstance() {
    Key_initEntries();
    return Key_K_instance;
  }
  function Key_L_getInstance() {
    Key_initEntries();
    return Key_L_instance;
  }
  function Key_M_getInstance() {
    Key_initEntries();
    return Key_M_instance;
  }
  function Key_N_getInstance() {
    Key_initEntries();
    return Key_N_instance;
  }
  function Key_O_getInstance() {
    Key_initEntries();
    return Key_O_instance;
  }
  function Key_P_getInstance() {
    Key_initEntries();
    return Key_P_instance;
  }
  function Key_Q_getInstance() {
    Key_initEntries();
    return Key_Q_instance;
  }
  function Key_R_getInstance() {
    Key_initEntries();
    return Key_R_instance;
  }
  function Key_S_getInstance() {
    Key_initEntries();
    return Key_S_instance;
  }
  function Key_T_getInstance() {
    Key_initEntries();
    return Key_T_instance;
  }
  function Key_U_getInstance() {
    Key_initEntries();
    return Key_U_instance;
  }
  function Key_V_getInstance() {
    Key_initEntries();
    return Key_V_instance;
  }
  function Key_W_getInstance() {
    Key_initEntries();
    return Key_W_instance;
  }
  function Key_X_getInstance() {
    Key_initEntries();
    return Key_X_instance;
  }
  function Key_Y_getInstance() {
    Key_initEntries();
    return Key_Y_instance;
  }
  function Key_Z_getInstance() {
    Key_initEntries();
    return Key_Z_instance;
  }
  function Key_ESCAPE_getInstance() {
    Key_initEntries();
    return Key_ESCAPE_instance;
  }
  function Key_META_getInstance() {
    Key_initEntries();
    return Key_META_instance;
  }
  function Key_ENTER_getInstance() {
    Key_initEntries();
    return Key_ENTER_instance;
  }
  function Key_TAB_getInstance() {
    Key_initEntries();
    return Key_TAB_instance;
  }
  function Key_BACKSPACE_getInstance() {
    Key_initEntries();
    return Key_BACKSPACE_instance;
  }
  function Key_INSERT_getInstance() {
    Key_initEntries();
    return Key_INSERT_instance;
  }
  function Key_DELETE_getInstance() {
    Key_initEntries();
    return Key_DELETE_instance;
  }
  function Key_RIGHT_getInstance() {
    Key_initEntries();
    return Key_RIGHT_instance;
  }
  function Key_LEFT_getInstance() {
    Key_initEntries();
    return Key_LEFT_instance;
  }
  function Key_DOWN_getInstance() {
    Key_initEntries();
    return Key_DOWN_instance;
  }
  function Key_UP_getInstance() {
    Key_initEntries();
    return Key_UP_instance;
  }
  function Key_PAGE_UP_getInstance() {
    Key_initEntries();
    return Key_PAGE_UP_instance;
  }
  function Key_PAGE_DOWN_getInstance() {
    Key_initEntries();
    return Key_PAGE_DOWN_instance;
  }
  function Key_HOME_getInstance() {
    Key_initEntries();
    return Key_HOME_instance;
  }
  function Key_END_getInstance() {
    Key_initEntries();
    return Key_END_instance;
  }
  function Key_F1_getInstance() {
    Key_initEntries();
    return Key_F1_instance;
  }
  function Key_F2_getInstance() {
    Key_initEntries();
    return Key_F2_instance;
  }
  function Key_F3_getInstance() {
    Key_initEntries();
    return Key_F3_instance;
  }
  function Key_F4_getInstance() {
    Key_initEntries();
    return Key_F4_instance;
  }
  function Key_F5_getInstance() {
    Key_initEntries();
    return Key_F5_instance;
  }
  function Key_F6_getInstance() {
    Key_initEntries();
    return Key_F6_instance;
  }
  function Key_F7_getInstance() {
    Key_initEntries();
    return Key_F7_instance;
  }
  function Key_F8_getInstance() {
    Key_initEntries();
    return Key_F8_instance;
  }
  function Key_F9_getInstance() {
    Key_initEntries();
    return Key_F9_instance;
  }
  function Key_F10_getInstance() {
    Key_initEntries();
    return Key_F10_instance;
  }
  function Key_F11_getInstance() {
    Key_initEntries();
    return Key_F11_instance;
  }
  function Key_F12_getInstance() {
    Key_initEntries();
    return Key_F12_instance;
  }
  function Key_F13_getInstance() {
    Key_initEntries();
    return Key_F13_instance;
  }
  function Key_F14_getInstance() {
    Key_initEntries();
    return Key_F14_instance;
  }
  function Key_F15_getInstance() {
    Key_initEntries();
    return Key_F15_instance;
  }
  function Key_F16_getInstance() {
    Key_initEntries();
    return Key_F16_instance;
  }
  function Key_F17_getInstance() {
    Key_initEntries();
    return Key_F17_instance;
  }
  function Key_F18_getInstance() {
    Key_initEntries();
    return Key_F18_instance;
  }
  function Key_F19_getInstance() {
    Key_initEntries();
    return Key_F19_instance;
  }
  function Key_F20_getInstance() {
    Key_initEntries();
    return Key_F20_instance;
  }
  function Key_F21_getInstance() {
    Key_initEntries();
    return Key_F21_instance;
  }
  function Key_F22_getInstance() {
    Key_initEntries();
    return Key_F22_instance;
  }
  function Key_F23_getInstance() {
    Key_initEntries();
    return Key_F23_instance;
  }
  function Key_F24_getInstance() {
    Key_initEntries();
    return Key_F24_instance;
  }
  function Key_F25_getInstance() {
    Key_initEntries();
    return Key_F25_instance;
  }
  function Key_LEFT_SHIFT_getInstance() {
    Key_initEntries();
    return Key_LEFT_SHIFT_instance;
  }
  function Key_LEFT_CONTROL_getInstance() {
    Key_initEntries();
    return Key_LEFT_CONTROL_instance;
  }
  function Key_LEFT_ALT_getInstance() {
    Key_initEntries();
    return Key_LEFT_ALT_instance;
  }
  function Key_LEFT_SUPER_getInstance() {
    Key_initEntries();
    return Key_LEFT_SUPER_instance;
  }
  function Key_RIGHT_SHIFT_getInstance() {
    Key_initEntries();
    return Key_RIGHT_SHIFT_instance;
  }
  function Key_RIGHT_CONTROL_getInstance() {
    Key_initEntries();
    return Key_RIGHT_CONTROL_instance;
  }
  function Key_RIGHT_ALT_getInstance() {
    Key_initEntries();
    return Key_RIGHT_ALT_instance;
  }
  function Key_RIGHT_SUPER_getInstance() {
    Key_initEntries();
    return Key_RIGHT_SUPER_instance;
  }
  function Key_QUOTE_getInstance() {
    Key_initEntries();
    return Key_QUOTE_instance;
  }
  function Key_UNKNOWN_getInstance() {
    Key_initEntries();
    return Key_UNKNOWN_instance;
  }
  function GameStick_LEFT_getInstance() {
    GameStick_initEntries();
    return GameStick_LEFT_instance;
  }
  function GameStick_RIGHT_getInstance() {
    GameStick_initEntries();
    return GameStick_RIGHT_instance;
  }
  function _no_name_provided_$factory_277(this$0, $info) {
    var i = new _no_name_provided__331(this$0, $info);
    return function (p1) {
      return i.invoke_uo5qy2_k$(p1);
    };
  }
  var GLOBAL_CHECK_GL;
  var Cursor_DEFAULT_instance;
  var Cursor_CROSSHAIR_instance;
  var Cursor_TEXT_instance;
  var Cursor_HAND_instance;
  var Cursor_MOVE_instance;
  var Cursor_WAIT_instance;
  var Cursor_RESIZE_EAST_instance;
  var Cursor_RESIZE_WEST_instance;
  var Cursor_RESIZE_SOUTH_instance;
  var Cursor_RESIZE_NORTH_instance;
  var Cursor_RESIZE_NORTH_EAST_instance;
  var Cursor_RESIZE_NORTH_WEST_instance;
  var Cursor_RESIZE_SOUTH_EAST_instance;
  var Cursor_RESIZE_SOUTH_WEST_instance;
  function Companion_177() {
    Companion_instance_176 = this;
    this._ANGLE_TO_CURSOR = mapOf([to(new Angle(times_1(_get_degrees__0(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(times_1(_get_degrees__0(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(times_1(_get_degrees__0(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(times_1(_get_degrees__0(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(times_1(_get_degrees__0(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(times_1(_get_degrees__0(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(times_1(_get_degrees__0(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(times_1(_get_degrees__0(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
  Companion_177.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_176;
  function Companion_getInstance_176() {
    if (Companion_instance_176 == null)
      new Companion_177();
    return Companion_instance_176;
  }
  var Cursor_entriesInitialized;
  function Cursor_initEntries() {
    if (Cursor_entriesInitialized)
      return Unit_getInstance();
    Cursor_entriesInitialized = true;
    Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
    Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
    Cursor_TEXT_instance = new Cursor('TEXT', 2);
    Cursor_HAND_instance = new Cursor('HAND', 3);
    Cursor_MOVE_instance = new Cursor('MOVE', 4);
    Cursor_WAIT_instance = new Cursor('WAIT', 5);
    Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
    Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
    Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
    Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
    Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
    Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
    Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
    Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
    Companion_getInstance_176();
  }
  function MenuItem_init_$Init$(text, enabled, children_0, action, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      enabled = true;
    if (!(($mask0 & 4) === 0))
      children_0 = null;
    if (!(($mask0 & 8) === 0)) {
      action = _no_name_provided_$factory_279();
    }MenuItem.call($this, text, enabled, children_0, action);
    return $this;
  }
  function MenuItem_init_$Create$(text, enabled, children_0, action, $mask0, $marker) {
    return MenuItem_init_$Init$(text, enabled, children_0, action, $mask0, $marker, Object.create(MenuItem.prototype));
  }
  function _no_name_provided__332() {
  }
  _no_name_provided__332.prototype.invoke_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  _no_name_provided__332.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__332.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var Quality_PERFORMANCE_instance;
  var Quality_QUALITY_instance;
  var Quality_AUTOMATIC_instance;
  var Quality_entriesInitialized;
  function Quality_initEntries() {
    if (Quality_entriesInitialized)
      return Unit_getInstance();
    Quality_entriesInitialized = true;
    Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0);
    Quality_QUALITY_instance = new Quality('QUALITY', 1);
    Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2);
  }
  function ICursor() {
  }
  ICursor.$metadata$ = {
    simpleName: 'ICursor',
    kind: 'interface',
    interfaces: []
  };
  function Cursor(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Cursor.$metadata$ = {
    simpleName: 'Cursor',
    kind: 'class',
    interfaces: [ICursor]
  };
  function MenuItem(text, enabled, children_0, action) {
    this._text_2 = text;
    this._enabled_0 = enabled;
    this._children_3 = children_0;
    this._action = action;
  }
  MenuItem.prototype.toString = function () {
    return '' + 'MenuItem(text=' + this._text_2 + ', enabled=' + this._enabled_0 + ', children=' + this._children_3 + ', action=' + this._action + ')';
  };
  MenuItem.prototype.hashCode = function () {
    var result = this._text_2 == null ? 0 : getStringHashCode(this._text_2);
    result = imul(result, 31) + (this._enabled_0 | 0) | 0;
    result = imul(result, 31) + (this._children_3 == null ? 0 : hashCode(this._children_3)) | 0;
    result = imul(result, 31) + hashCode(this._action) | 0;
    return result;
  };
  MenuItem.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this._text_2 == tmp0_other_with_cast._text_2))
      return false;
    if (!(this._enabled_0 === tmp0_other_with_cast._enabled_0))
      return false;
    if (!equals_1(this._children_3, tmp0_other_with_cast._children_3))
      return false;
    if (!equals_1(this._action, tmp0_other_with_cast._action))
      return false;
    return true;
  };
  MenuItem.$metadata$ = {
    simpleName: 'MenuItem',
    kind: 'class',
    interfaces: []
  };
  function CoroutineKey() {
    CoroutineKey_instance = this;
    var tmp = this;
    tmp._MenuItemSeparatror = MenuItem_init_$Create$(null, false, null, null, 14, null);
  }
  CoroutineKey.$metadata$ = {
    simpleName: 'CoroutineKey',
    kind: 'object',
    interfaces: [Key_0]
  };
  var CoroutineKey_instance;
  function CoroutineKey_getInstance() {
    if (CoroutineKey_instance == null)
      new CoroutineKey();
    return CoroutineKey_instance;
  }
  function _get_fpsCached_($this) {
    return $this._fpsCached$delegate.getValue_1kobyo_k$($this, fpsCached$factory());
  }
  function Quality(name, ordinal) {
    Enum.call(this, name, ordinal);
    this._UPPER_BOUND_RENDERED_PIXELS = 4000000;
  }
  Quality.prototype.computeTargetScale_t704se_k$ = function (width, height, devicePixelRatio, targetPixels) {
    var tmp0_subject = this;
    var tmp;
    if (tmp0_subject.equals(Quality_PERFORMANCE_getInstance())) {
      tmp = 1.0;
    } else if (tmp0_subject.equals(Quality_QUALITY_getInstance())) {
      tmp = devicePixelRatio;
    } else if (tmp0_subject.equals(Quality_AUTOMATIC_getInstance())) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_firstOrNull_0 = listOf([devicePixelRatio, 2.0, 1.0]);
        var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_0_k$();
        while (tmp0_iterator_1.hasNext_0_k$()) {
          var element_2 = tmp0_iterator_1.next_0_k$();
          if (imul(width, height) * element_2 <= targetPixels) {
            tmp$ret$0 = element_2;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      var tmp1_elvis_lhs = tmp$ret$0;
      tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  Quality.prototype.computeTargetScale$default_7cop6o_k$ = function (width, height, devicePixelRatio, targetPixels, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      targetPixels = this._UPPER_BOUND_RENDERED_PIXELS;
    return this.computeTargetScale_t704se_k$(width, height, devicePixelRatio, targetPixels);
  };
  Quality.$metadata$ = {
    simpleName: 'Quality',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__333(this$0) {
    this._this$0_80 = this$0;
  }
  _no_name_provided__333.prototype.invoke_0_k$ = function () {
    return this._this$0_80.computeDisplayRefreshRate_0_k$();
  };
  _no_name_provided__333.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__334($entry, this$0, resultContinuation) {
    this._$entry = $entry;
    this._this$0_81 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__334.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__334.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__334.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$entry(this._this$0_81, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__334.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__334(this._$entry, this._this$0_81, completion);
    return i;
  };
  _no_name_provided__334.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function Cursor_DEFAULT_getInstance() {
    Cursor_initEntries();
    return Cursor_DEFAULT_instance;
  }
  function Cursor_CROSSHAIR_getInstance() {
    Cursor_initEntries();
    return Cursor_CROSSHAIR_instance;
  }
  function Cursor_TEXT_getInstance() {
    Cursor_initEntries();
    return Cursor_TEXT_instance;
  }
  function Cursor_HAND_getInstance() {
    Cursor_initEntries();
    return Cursor_HAND_instance;
  }
  function Cursor_MOVE_getInstance() {
    Cursor_initEntries();
    return Cursor_MOVE_instance;
  }
  function Cursor_WAIT_getInstance() {
    Cursor_initEntries();
    return Cursor_WAIT_instance;
  }
  function Cursor_RESIZE_EAST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_EAST_instance;
  }
  function Cursor_RESIZE_WEST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_WEST_instance;
  }
  function Cursor_RESIZE_SOUTH_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_SOUTH_instance;
  }
  function Cursor_RESIZE_NORTH_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_NORTH_instance;
  }
  function Cursor_RESIZE_NORTH_EAST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_NORTH_EAST_instance;
  }
  function Cursor_RESIZE_NORTH_WEST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_NORTH_WEST_instance;
  }
  function Cursor_RESIZE_SOUTH_EAST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_SOUTH_EAST_instance;
  }
  function Cursor_RESIZE_SOUTH_WEST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_SOUTH_WEST_instance;
  }
  function Quality_PERFORMANCE_getInstance() {
    Quality_initEntries();
    return Quality_PERFORMANCE_instance;
  }
  function Quality_QUALITY_getInstance() {
    Quality_initEntries();
    return Quality_QUALITY_instance;
  }
  function Quality_AUTOMATIC_getInstance() {
    Quality_initEntries();
    return Quality_AUTOMATIC_instance;
  }
  function $waitCloseCOROUTINE$0(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__135 = _this_;
  }
  $waitCloseCOROUTINE$0.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this.__this__135._running) {
              this._state_1 = 3;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = delay_1(this.__this__135, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(100.0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $waitCloseCOROUTINE$0.$metadata$ = {
    simpleName: '$waitCloseCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $loopCOROUTINE$1(_this_, entry, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__136 = _this_;
    this._entry_1 = entry;
  }
  $loopCOROUTINE$1.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = this.__this__136.getCoroutineDispatcherWithCurrentContext_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_23 = suspendResult;
            launchImmediately(this._ARGUMENT0_23, _no_name_provided_$factory_280(this._entry_1, this.__this__136, null));
            Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!this.__this__136._running) {
              this._state_1 = 4;
              continue $sm;
            }
            this._start1 = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
            this.__this__136.frame_sv8swh_k$();
            this._elapsed2 = TimeSpan__minus_impl(PerformanceCounter_getInstance()._get_reference__nsqrdp_k$(), this._start1);
            this._available3 = TimeSpan__minus_impl(this.__this__136._get_counterTimePerFrame__nsqrdp_k$(), this._elapsed2);
            this._state_1 = 3;
            suspendResult = delay_1(this.__this__136, this._available3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._state_1 = 2;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loopCOROUTINE$1.$metadata$ = {
    simpleName: '$loopCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function GameWindow() {
    CoroutineKey_getInstance();
    Mixin_2.call(this);
    var tmp = this;
    tmp._$$delegate_0_27 = Mixin_init_$Create$(null, 1, null);
    this._cursor = Cursor_DEFAULT_getInstance();
    var tmp_0 = this;
    tmp_0._ag = LogAG_init_$Create$(0, 0, 3, null);
    this._coroutineDispatcher = new GameWindowCoroutineDispatcher();
    this._pauseEvent = new PauseEvent();
    this._resumeEvent = new ResumeEvent();
    this._stopEvent = new StopEvent();
    this._destroyEvent = new DestroyEvent();
    this._renderEvent = new RenderEvent();
    this._initEvent = new InitEvent();
    this._disposeEvent = new DisposeEvent();
    var tmp_1 = this;
    tmp_1._fullScreenEvent = FullScreenEvent_init_$Create$(false, 1, null);
    var tmp_2 = this;
    tmp_2._reshapeEvent = ReshapeEvent_init_$Create$(0, 0, 0, 0, 15, null);
    var tmp_3 = this;
    var tmp_4 = new Char(0);
    tmp_3._keyEvent = KeyEvent_init_$Create$(null, 0, null, 0, tmp_4, false, false, false, false, 511, null);
    var tmp_5 = this;
    tmp_5._mouseEvent = MouseEvent_init_$Create$(null, 0, 0, 0, null, 0, 0.0, 0.0, 0.0, false, false, false, false, false, false, 32767, null);
    this._touchBuilder = new TouchBuilder();
    var tmp_6 = this;
    tmp_6._dropFileEvent = DropFileEvent_init_$Create$(null, null, 3, null);
    var tmp_7 = this;
    tmp_7._gamePadUpdateEvent = GamePadUpdateEvent_init_$Create$(0, null, 3, null);
    var tmp_8 = this;
    tmp_8._gamePadConnectionEvent = GamePadConnectionEvent_init_$Create$(null, 0, 3, null);
    var tmp_9 = this;
    var tmp_10 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(1000.0);
    tmp_9._fpsCached$delegate = new IntTimedCache(tmp_10, _no_name_provided_$factory_278(this));
    this._width_16 = 0;
    this._height_17 = 0;
    this._vsync = true;
    this._icon = null;
    this._fullscreen_0 = false;
    this._visible = false;
    this._bgcolor = Colors_getInstance()._BLACK_0;
    var tmp_11 = this;
    tmp_11._onDebugEnabled = Signal_init_$Create$(null, 1, null);
    var tmp_12 = this;
    tmp_12._onDebugChanged = Signal_init_$Create$(null, 1, null);
    this._debugComponent = null;
    this._debug_1 = false;
    this._running = true;
    this._closing = false;
    var tmp_13 = this;
    tmp_13._renderTime = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    var tmp_14 = this;
    tmp_14._updateTime = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    this._surfaceChanged = false;
    this._surfaceX = -1;
    this._surfaceY = -1;
    this._surfaceWidth = -1;
    this._surfaceHeight = -1;
    this._doInitialize = false;
    this._initialized_1 = false;
    this._contextLost = false;
    this._lastTime = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
    this._keysPresing = booleanArray(Companion_getInstance_174()._MAX_2);
    this._mouseButtons = 0;
    this._scrollDeltaX_0 = 0.0;
    this._scrollDeltaY_0 = 0.0;
    this._scrollDeltaZ_0 = 0.0;
    this._scaleCoords_1 = false;
  }
  GameWindow.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_27._set_extra__n1onou_k$(_set___);
  };
  GameWindow.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_27._get_extra__0_k$();
  };
  GameWindow.prototype._set_cursor__gde21z_k$ = function (_set___) {
    this._cursor = _set___;
  };
  GameWindow.prototype._get_cursor__0_k$ = function () {
    return this._cursor;
  };
  GameWindow.prototype._get_key__0_k$ = function () {
    return CoroutineKey_getInstance();
  };
  GameWindow.prototype._get_ag__0_k$ = function () {
    return this._ag;
  };
  GameWindow.prototype._get_coroutineDispatcher__0_k$ = function () {
    return this._coroutineDispatcher;
  };
  GameWindow.prototype.getCoroutineDispatcherWithCurrentContext_d7pszg_k$ = function (coroutineContext) {
    return coroutineContext.plus_d7pszg_k$(this._get_coroutineDispatcher__0_k$());
  };
  GameWindow.prototype.getCoroutineDispatcherWithCurrentContext_0_k$ = function ($cont) {
    return this.getCoroutineDispatcherWithCurrentContext_d7pszg_k$($cont._get_context__0_k$());
  };
  GameWindow.prototype._get_renderEvent__0_k$ = function () {
    return this._renderEvent;
  };
  GameWindow.prototype._get_keyEvent__0_k$ = function () {
    return this._keyEvent;
  };
  GameWindow.prototype._get_mouseEvent__0_k$ = function () {
    return this._mouseEvent;
  };
  GameWindow.prototype._get_touchBuilder__0_k$ = function () {
    return this._touchBuilder;
  };
  GameWindow.prototype._get_gamePadUpdateEvent__0_k$ = function () {
    return this._gamePadUpdateEvent;
  };
  GameWindow.prototype._get_gamePadConnectionEvent__0_k$ = function () {
    return this._gamePadConnectionEvent;
  };
  GameWindow.prototype.onRenderEvent_6lyars_k$ = function (block) {
    this.addEventListener_lfkrxw_k$(getKClass_0(RenderEvent), block);
    Unit_getInstance();
  };
  GameWindow.prototype._get_counterTimePerFrame__nsqrdp_k$ = function () {
    var tmp0__get_microseconds__0 = 1000000.0 / this._get_fps__0_k$();
    return Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0);
  };
  GameWindow.prototype.computeDisplayRefreshRate_0_k$ = function () {
    return 60;
  };
  GameWindow.prototype.registerTime_mqbjv8_k$ = function (name, time) {
  };
  GameWindow.prototype._get_fps__0_k$ = function () {
    return _get_fpsCached_(this);
  };
  GameWindow.prototype._set_title__a4enbm_k$ = function (value) {
    return Unit_getInstance();
  };
  GameWindow.prototype._get_width__0_k$ = function () {
    return this._width_16;
  };
  GameWindow.prototype._get_height__0_k$ = function () {
    return this._height_17;
  };
  GameWindow.prototype._set_icon__1l3fil_k$ = function (_set___) {
    this._icon = _set___;
  };
  GameWindow.prototype._set_fullscreen__rpwsgn_k$ = function (_set___) {
    this._fullscreen_0 = _set___;
  };
  GameWindow.prototype._set_visible__rpwsgn_k$ = function (_set___) {
    this._visible = _set___;
  };
  GameWindow.prototype._set_bgcolor__f52nlt_k$ = function (_set___) {
    this._bgcolor = _set___;
  };
  GameWindow.prototype._set_quality__twhgp3_k$ = function (value) {
    return Unit_getInstance();
  };
  GameWindow.prototype._set_debug__rpwsgn_k$ = function (value) {
    this._debug_1 = value;
    this._onDebugChanged.invoke_iav7o_k$(value);
    if (value)
      invoke(this._onDebugEnabled);
  };
  GameWindow.prototype.setSize_rvwcgf_k$ = function (width, height) {
    return Unit_getInstance();
  };
  GameWindow.prototype.exit_sv8swh_k$ = function () {
    return this.close_sv8swh_k$();
  };
  GameWindow.prototype.close_sv8swh_k$ = function () {
    if (this._closing)
      return Unit_getInstance();
    this._closing = true;
    this._running = false;
    println('GameWindow.close');
    this._get_coroutineDispatcher__0_k$().close_sv8swh_k$();
    var tmp = this._get_coroutineDispatcher__0_k$();
    cancelChildren$default(tmp, null, 1, null);
  };
  GameWindow.prototype.waitClose_sv8swh_k$ = function ($cont) {
    var tmp = new $waitCloseCOROUTINE$0(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  GameWindow.prototype.loop_59tp16_k$ = function (entry, $cont) {
    var tmp = new $loopCOROUTINE$1(this, entry, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  GameWindow.prototype.frame_sv8swh_k$ = function () {
    this.frame$default_v45lde_k$(true, null, 2, null);
  };
  GameWindow.prototype.frame_1ztki7_k$ = function (doUpdate, startTime) {
    var tmp = this;
    var start_1 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
    this.frameRender_sv8swh_k$();
    var end_2 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
    var tmp0__get_microseconds__0_3 = end_2 - start_1;
    tmp._renderTime = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3);
    if (doUpdate) {
      var tmp_0 = this;
      var start_1_0 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
      this.frameUpdate_zah5t7_k$(startTime);
      var end_2_0 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
      var tmp0__get_microseconds__0_3_0 = end_2_0 - start_1_0;
      tmp_0._updateTime = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_0);
    }};
  GameWindow.prototype.frame$default_v45lde_k$ = function (doUpdate, startTime, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startTime = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
    return this.frame_1ztki7_k$(doUpdate, startTime);
  };
  GameWindow.prototype.frameRender_sv8swh_k$ = function () {
    if (this._contextLost) {
      this._contextLost = false;
      this._get_ag__0_k$().contextLost_sv8swh_k$();
    }if (this._surfaceChanged) {
      this._surfaceChanged = false;
      var tmp = this._get_ag__0_k$()._get_mainRenderBuffer__0_k$();
      var tmp_0 = this._surfaceX;
      var tmp_1 = this._surfaceY;
      var tmp_2 = this._surfaceWidth;
      var tmp_3 = this._surfaceHeight;
      tmp.setSize$default_e5nmz5_k$(tmp_0, tmp_1, tmp_2, tmp_3, 0, 0, 48, null);
      this.dispatchReshapeEvent_jthg1_k$(this._surfaceX, this._surfaceY, this._surfaceWidth, this._surfaceHeight);
    }if (this._doInitialize) {
      this._doInitialize = false;
      println('' + '---------------- Trigger AG.initialized ag.mainRenderBuffer.setSize (' + this._get_width__0_k$() + ', ' + this._get_height__0_k$() + ') --------------');
      var tmp0_dispatch_0 = this._initEvent;
      this.dispatch_62irmi_k$(getKClass_0(InitEvent), tmp0_dispatch_0);
    }try {
      this.dispatchRenderEvent_rpwsgn_k$(false);
    } catch ($p) {
      if ($p instanceof Error) {
        println('ERROR GameWindow.frameRender:');
        println($p);
        printStackTrace_0($p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  GameWindow.prototype.frameUpdate_zah5t7_k$ = function (startTime) {
    try {
      var now_0 = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
      var elapsed = TimeSpan__minus_impl(now_0, startTime);
      this._lastTime = now_0;
      var available = TimeSpan__minus_impl(this._get_counterTimePerFrame__nsqrdp_k$(), elapsed);
      this._get_coroutineDispatcher__0_k$().executePending_zah5t7_k$(available);
    } catch ($p) {
      if ($p instanceof Error) {
        println('ERROR GameWindow.frameRender:');
        println($p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  GameWindow.prototype.dispatchRenderEvent_rpwsgn_k$ = function (update_0) {
    var tmp0_also_0 = this._renderEvent;
    tmp0_also_0._update = update_0;
    var tmp1_dispatch_0 = tmp0_also_0;
    return this.dispatch_62irmi_k$(getKClass_0(RenderEvent), tmp1_dispatch_0);
  };
  GameWindow.prototype.dispatchDropfileEvent_c1fqem_k$ = function (type, files) {
    var tmp0_also_0 = this._dropFileEvent;
    tmp0_also_0._type_20 = type;
    tmp0_also_0._files_1 = files;
    var tmp1_dispatch_0 = tmp0_also_0;
    return this.dispatch_62irmi_k$(getKClass_0(DropFileEvent), tmp1_dispatch_0);
  };
  GameWindow.prototype.dispatchReshapeEvent_jthg1_k$ = function (x, y, width, height) {
    this.dispatchReshapeEventEx_6try9d_k$(x, y, width, height, width, height);
  };
  GameWindow.prototype.dispatchReshapeEventEx_6try9d_k$ = function (x, y, width, height, fullWidth, fullHeight) {
    this._get_ag__0_k$().resized_6try9d_k$(x, y, width, height, fullWidth, fullHeight);
    var tmp0_apply_0 = this._reshapeEvent;
    tmp0_apply_0._x_21 = x;
    tmp0_apply_0._y_20 = y;
    tmp0_apply_0._width_15 = width;
    tmp0_apply_0._height_16 = height;
    var tmp1_dispatch_0 = tmp0_apply_0;
    this.dispatch_62irmi_k$(getKClass_0(ReshapeEvent), tmp1_dispatch_0);
  };
  GameWindow.$metadata$ = {
    simpleName: 'GameWindow',
    kind: 'class',
    interfaces: [DialogInterface, Closeable, Element_0, AGWindow, Extra]
  };
  function DialogInterface() {
  }
  DialogInterface.$metadata$ = {
    simpleName: 'DialogInterface',
    kind: 'interface',
    interfaces: [Closeable]
  };
  function configure(_this_, width, height, title, icon, fullscreen, bgcolor) {
    _this_.setSize_rvwcgf_k$(width, height);
    if (!(title == null))
      _this_._set_title__a4enbm_k$(title);
    _this_._set_icon__1l3fil_k$(icon);
    if (!(fullscreen == null))
      _this_._set_fullscreen__rpwsgn_k$(fullscreen);
    _this_._set_bgcolor__f52nlt_k$(bgcolor);
    _this_._set_visible__rpwsgn_k$(true);
  }
  function TimedTask(time, continuation, callback) {
    this._time_4 = time;
    this._continuation_4 = continuation;
    this._callback_4 = callback;
    this._exception_1 = null;
  }
  TimedTask.$metadata$ = {
    simpleName: 'TimedTask',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__335() {
  }
  _no_name_provided__335.prototype.invoke_rfqehs_k$ = function (a, b) {
    return TimeSpan__compareTo_impl(a._time_4, b._time_4);
  };
  _no_name_provided__335.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TimedTask ? p1 : THROW_CCE();
    return this.invoke_rfqehs_k$(tmp, p2 instanceof TimedTask ? p2 : THROW_CCE());
  };
  _no_name_provided__335.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__336($task) {
    this._$task = $task;
  }
  _no_name_provided__336.prototype.invoke_houul8_k$ = function (it) {
    this._$task._exception_1 = it;
  };
  _no_name_provided__336.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_houul8_k$((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__336.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__337(this$0, $task) {
    this._this$0_82 = this$0;
    this._$task_0 = $task;
  }
  _no_name_provided__337.prototype.dispose_sv8swh_k$ = function () {
    this._this$0_82._timedTasks.remove_1hrmez_k$(this._$task_0);
    Unit_getInstance();
  };
  _no_name_provided__337.$metadata$ = {
    kind: 'class',
    interfaces: [DisposableHandle]
  };
  function GameWindowCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
    this._tasks = new TGenQueue();
    var tmp = this;
    var tmp_0 = Companion_getInstance_24();
    tmp._timedTasks = tmp_0.invoke$default_ebmhms_k$(false, _no_name_provided_$factory_281(), 1, null);
    var tmp_1 = this;
    tmp_1._timedTasksTime = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    var tmp_2 = this;
    tmp_2._tasksTime = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
  }
  GameWindowCoroutineDispatcher.prototype.dispatch_7n0ou3_k$ = function (context, block) {
    this._tasks.enqueue_xoeh3q_k$(block);
  };
  GameWindowCoroutineDispatcher.prototype.now_nsqrdp_k$ = function () {
    return PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
  };
  GameWindowCoroutineDispatcher.prototype.scheduleResumeAfterDelay_tkxym4_k$ = function (timeMillis, continuation) {
    var tmp0__get_milliseconds__0 = timeMillis.toDouble_0_k$();
    this.scheduleResumeAfterDelay_qvzte0_k$(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp0__get_milliseconds__0), continuation);
  };
  GameWindowCoroutineDispatcher.prototype.scheduleResumeAfterDelay_qvzte0_k$ = function (time, continuation) {
    var task = new TimedTask(TimeSpan__plus_impl(this.now_nsqrdp_k$(), time), continuation, null);
    continuation.invokeOnCancellation_aip8gd_k$(_no_name_provided_$factory_282(task));
    this._timedTasks.add_1hrmez_k$(task);
    Unit_getInstance();
  };
  GameWindowCoroutineDispatcher.prototype.invokeOnTimeout_x8mf2g_k$ = function (timeMillis, block, context) {
    var tmp = this.now_nsqrdp_k$();
    var tmp0__get_milliseconds__0 = timeMillis.toDouble_0_k$();
    var task = new TimedTask(TimeSpan__plus_impl(tmp, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp0__get_milliseconds__0)), null, block);
    this._timedTasks.add_1hrmez_k$(task);
    Unit_getInstance();
    return new _no_name_provided__337(this, task);
  };
  GameWindowCoroutineDispatcher.prototype.executePending_zah5t7_k$ = function (availableTime) {
    try {
      var startTime = this.now_nsqrdp_k$();
      var tmp = this;
      var start_1 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
      $l$break_0: while (true) {
        var tmp_0;
        var tmp0_isNotEmpty_0_5 = this._timedTasks;
        if (!tmp0_isNotEmpty_0_5.isEmpty_0_k$()) {
          tmp_0 = TimeSpan__compareTo_impl(startTime, this._timedTasks._get_head__0_k$()._time_4) >= 0;
        } else {
          {
            tmp_0 = false;
          }
        }
        if (!tmp_0) {
          break $l$break_0;
        }var item_6 = this._timedTasks.removeHead_0_k$();
        if (!(item_6._exception_1 == null)) {
          var tmp0_safe_receiver_7 = item_6._continuation_4;
          if (tmp0_safe_receiver_7 == null)
            null;
          else {
            var tmp1_resumeWithException_0_8 = ensureNotNull(item_6._exception_1);
            var tmp0_failure_0_1_9 = Companion_getInstance_3();
            tmp0_safe_receiver_7.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(tmp1_resumeWithException_0_8)));
            Unit_getInstance();
          }
          Unit_getInstance();
          if (!(item_6._callback_4 == null)) {
            var tmp1_safe_receiver_10 = item_6._exception_1;
            if (tmp1_safe_receiver_10 == null)
              null;
            else {
              printStackTrace_0(tmp1_safe_receiver_10);
              Unit_getInstance();
            }
            Unit_getInstance();
          }} else {
          var tmp2_safe_receiver_11 = item_6._continuation_4;
          if (tmp2_safe_receiver_11 == null)
            null;
          else {
            var tmp0_success_0_1_12 = Companion_getInstance_3();
            tmp2_safe_receiver_11.resumeWith_bnunh2_k$(_Result___init__impl_(Unit_getInstance()));
            Unit_getInstance();
          }
          Unit_getInstance();
          var tmp3_safe_receiver_13 = item_6._callback_4;
          if (tmp3_safe_receiver_13 == null)
            null;
          else {
            tmp3_safe_receiver_13.run_sv8swh_k$();
            Unit_getInstance();
          }
          Unit_getInstance();
        }
        if (TimeSpan__compareTo_impl(TimeSpan__minus_impl(this.now_nsqrdp_k$(), startTime), availableTime) >= 0) {
          this.informTooMuchCallbacksToHandleInThisFrame_sv8swh_k$();
          break $l$break_0;
        }}
      var end_2 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
      var tmp0__get_microseconds__0_3 = end_2 - start_1;
      tmp._timedTasksTime = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3);
      var tmp_1 = this;
      var start_1_0 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
      $l$break_2: while (true) {
        var tmp0_isNotEmpty_0_5_0 = this._tasks;
        if (!!tmp0_isNotEmpty_0_5_0.isEmpty_0_k$()) {
          break $l$break_2;
        }var task_6 = this._tasks.dequeue_0_k$();
        var start_1_8 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
        var tmp0_safe_receiver_5_9 = task_6;
        if (tmp0_safe_receiver_5_9 == null)
          null;
        else {
          tmp0_safe_receiver_5_9.run_sv8swh_k$();
          Unit_getInstance();
        }
        Unit_getInstance();
        var end_2_10 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
        var tmp0__get_microseconds__0_3_11 = end_2_10 - start_1_8;
        var time_7 = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_11);
        if (TimeSpan__compareTo_impl(TimeSpan__minus_impl(this.now_nsqrdp_k$(), startTime), availableTime) >= 0) {
          this.informTooMuchCallbacksToHandleInThisFrame_sv8swh_k$();
          break $l$break_2;
        }}
      var end_2_0 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
      var tmp0__get_microseconds__0_3_0 = end_2_0 - start_1_0;
      tmp_1._tasksTime = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_0);
    } catch ($p) {
      if ($p instanceof Error) {
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace_0($p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  GameWindowCoroutineDispatcher.prototype.informTooMuchCallbacksToHandleInThisFrame_sv8swh_k$ = function () {
  };
  GameWindowCoroutineDispatcher.prototype.close_sv8swh_k$ = function () {
    this.executePending_zah5t7_k$(Companion_getInstance_92().fromSeconds_ttklb2_k$(1.0));
    println('GameWindowCoroutineDispatcher.close');
    $l$break: while (true) {
      var tmp0_isNotEmpty_0 = this._timedTasks;
      if (!!tmp0_isNotEmpty_0.isEmpty_0_k$()) {
        break $l$break;
      }var tmp0_safe_receiver = this._timedTasks.removeHead_0_k$()._continuation_4;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp0_success_0_1 = Companion_getInstance_3();
        tmp0_safe_receiver.resumeWith_bnunh2_k$(_Result___init__impl_(Unit_getInstance()));
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    $l$break_0: while (true) {
      var tmp1_isNotEmpty_0 = this._tasks;
      if (!!tmp1_isNotEmpty_0.isEmpty_0_k$()) {
        break $l$break_0;
      }var tmp1_safe_receiver = this._tasks.dequeue_0_k$();
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.run_sv8swh_k$();
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  };
  GameWindowCoroutineDispatcher.prototype.toString = function () {
    return 'GameWindowCoroutineDispatcher';
  };
  GameWindowCoroutineDispatcher.$metadata$ = {
    simpleName: 'GameWindowCoroutineDispatcher',
    kind: 'class',
    interfaces: [Delay, Closeable]
  };
  function fpsCached$factory() {
    return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
      return _get_fpsCached_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_278(this$0) {
    var i = new _no_name_provided__333(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_279() {
    var i = new _no_name_provided__332();
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_280($entry, this$0, resultContinuation) {
    var i = new _no_name_provided__334($entry, this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_281() {
    var i = new _no_name_provided__335();
    return function (p1, p2) {
      return i.invoke_rfqehs_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_282($task) {
    var i = new _no_name_provided__336($task);
    return function (p1) {
      i.invoke_houul8_k$(p1);
      return Unit_getInstance();
    };
  }
  function IntTimedCache(ttl, gen) {
    this._ttl = ttl;
    this._gen_3 = gen;
    this._last_4 = Companion_getInstance_82()._EPOCH;
    this._value_27 = 0;
  }
  IntTimedCache.prototype.getValue_1kobyo_k$ = function (obj, property) {
    var now_1 = Companion_getInstance_82().now_utobi1_k$();
    if (TimeSpan__compareTo_impl(DateTime__minus_impl_0(now_1, this._last_4), this._ttl) > 0) {
      this._last_4 = now_1;
      this._value_27 = this._gen_3();
    }return this._value_27;
  };
  IntTimedCache.$metadata$ = {
    simpleName: 'IntTimedCache',
    kind: 'class',
    interfaces: []
  };
  var korgwJvmEngine;
  function UiApplication() {
  }
  UiApplication.$metadata$ = {
    simpleName: 'UiApplication',
    kind: 'class',
    interfaces: [Extra]
  };
  var uiComponent$delegate;
  function UiComponent() {
  }
  UiComponent.$metadata$ = {
    simpleName: 'UiComponent',
    kind: 'class',
    interfaces: [Extra, LengthExtensions]
  };
  function _no_name_provided__338() {
  }
  _no_name_provided__338.prototype.invoke_2ymcb2_k$ = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__338.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_2ymcb2_k$((!(p1 == null) ? isInterface(p1, NativeComponent) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__338.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_283() {
    var i = new _no_name_provided__338();
    return function (p1) {
      return i.invoke_2ymcb2_k$(p1);
    };
  }
  var layoutChildrenPadding$delegate;
  var DEFAULT_WIDTH;
  var DEFAULT_HEIGHT;
  var preferredSize$delegate;
  var minimumSize$delegate;
  var maximumSize$delegate;
  function _no_name_provided__339() {
  }
  _no_name_provided__339.prototype.invoke_0_k$ = function () {
    return 0;
  };
  _no_name_provided__339.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__340() {
  }
  _no_name_provided__340.prototype.invoke_hpd3ay_k$ = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__340.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_hpd3ay_k$(p1 instanceof UiComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__340.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__341() {
  }
  _no_name_provided__341.prototype.invoke_hpd3ay_k$ = function ($this$$receiver) {
    return new Size_0(null, null);
  };
  _no_name_provided__341.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_hpd3ay_k$(p1 instanceof UiComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__341.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__342() {
  }
  _no_name_provided__342.prototype.invoke_hpd3ay_k$ = function ($this$$receiver) {
    return new Size_0(null, null);
  };
  _no_name_provided__342.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_hpd3ay_k$(p1 instanceof UiComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__342.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_284() {
    var i = new _no_name_provided__339();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_285() {
    var i = new _no_name_provided__340();
    return function (p1) {
      return i.invoke_hpd3ay_k$(p1);
    };
  }
  function _no_name_provided_$factory_286() {
    var i = new _no_name_provided__341();
    return function (p1) {
      return i.invoke_hpd3ay_k$(p1);
    };
  }
  function _no_name_provided_$factory_287() {
    var i = new _no_name_provided__342();
    return function (p1) {
      return i.invoke_hpd3ay_k$(p1);
    };
  }
  function LengthExtensions() {
  }
  LengthExtensions.$metadata$ = {
    simpleName: 'LengthExtensions',
    kind: 'interface',
    interfaces: []
  };
  function Fixed() {
    Length.call(this);
  }
  Fixed.$metadata$ = {
    simpleName: 'Fixed',
    kind: 'class',
    interfaces: []
  };
  function PT(v) {
    Fixed.call(this);
    this._v_6 = v;
  }
  PT.prototype.toString = function () {
    return '' + this._v_6 + 'pt';
  };
  PT.prototype.hashCode = function () {
    return getNumberHashCode(this._v_6);
  };
  PT.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PT))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PT ? other : THROW_CCE();
    if (!equals_1(this._v_6, tmp0_other_with_cast._v_6))
      return false;
    return true;
  };
  PT.$metadata$ = {
    simpleName: 'PT',
    kind: 'class',
    interfaces: []
  };
  function Companion_178() {
    Companion_instance_177 = this;
    this._ZERO_2 = new PT(0.0);
  }
  Companion_178.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_177;
  function Companion_getInstance_177() {
    if (Companion_instance_177 == null)
      new Companion_178();
    return Companion_instance_177;
  }
  function Length() {
    Companion_getInstance_177();
  }
  Length.$metadata$ = {
    simpleName: 'Length',
    kind: 'class',
    interfaces: []
  };
  function Size_0(width, height) {
    this._width_17 = width;
    this._height_18 = height;
  }
  Size_0.prototype.toString = function () {
    return '' + 'Size(width=' + this._width_17 + ', height=' + this._height_18 + ')';
  };
  Size_0.prototype.hashCode = function () {
    var result = this._width_17 == null ? 0 : hashCode(this._width_17);
    result = imul(result, 31) + (this._height_18 == null ? 0 : hashCode(this._height_18)) | 0;
    return result;
  };
  Size_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Size_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Size_0 ? other : THROW_CCE();
    if (!equals_1(this._width_17, tmp0_other_with_cast._width_17))
      return false;
    if (!equals_1(this._height_18, tmp0_other_with_cast._height_18))
      return false;
    return true;
  };
  Size_0.$metadata$ = {
    simpleName: 'Size',
    kind: 'class',
    interfaces: []
  };
  function NativeComponent() {
  }
  NativeComponent.$metadata$ = {
    simpleName: 'NativeComponent',
    kind: 'interface',
    interfaces: [Extra]
  };
  function NativeUiFactory() {
  }
  NativeUiFactory.$metadata$ = {
    simpleName: 'NativeUiFactory',
    kind: 'interface',
    interfaces: []
  };
  function DummyUiFactory() {
    DummyUiFactory_instance = this;
  }
  DummyUiFactory.$metadata$ = {
    simpleName: 'DummyUiFactory',
    kind: 'object',
    interfaces: [NativeUiFactory]
  };
  var DummyUiFactory_instance;
  function DummyUiFactory_getInstance() {
    if (DummyUiFactory_instance == null)
      new DummyUiFactory();
    return DummyUiFactory_instance;
  }
  var reactUid$delegate;
  function _no_name_provided__343() {
  }
  _no_name_provided__343.prototype.invoke_hpd3ay_k$ = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__343.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_hpd3ay_k$(p1 instanceof UiComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__343.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_288() {
    var i = new _no_name_provided__343();
    return function (p1) {
      return i.invoke_hpd3ay_k$(p1);
    };
  }
  function alloc_0(_this_, $this) {
    if (_this_ === null)
      return 0;
    if (_this_.id === undefined) {
      if ($this._freeList.isEmpty_0_k$()) {
        throw IllegalStateException_init_$Create$_0('KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)');
      }var index_2 = $this._freeList.removeAt_ha5a7z_k$($this._freeList._get_size__0_k$() - 1 | 0);
      $this._items_4[index_2] = _this_;
      _this_.id = index_2;
    } else {
    }
    var tmp0_unsafeCast_0_3 = _this_.id;
    return tmp0_unsafeCast_0_3;
  }
  function get_1(_this_, $this) {
    var tmp;
    if (!(_this_ === 0)) {
      var tmp0_unsafeCast_0 = $this._items_4[_this_];
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function free(_this_, $this) {
    var tmp;
    if (!(_this_ === 0)) {
      var tmp0_unsafeCast_0_3 = $this._items_4[_this_];
      var out_2 = tmp0_unsafeCast_0_3;
      var tmp0_this_4 = $this;
      var tmp1_plusAssign_0_5 = tmp0_this_4._freeList;
      tmp1_plusAssign_0_5.add_2bq_k$(_this_);
      Unit_getInstance();
      $this._items_4[_this_] = null;
      tmp = out_2;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function sliceIfRequired(_this_, $this, count_0) {
    var tmp;
    if (_this_.length === count_0) {
      tmp = _this_;
    } else {
      {
        tmp = new Float32Array(_this_.buffer, 0, count_0);
      }
    }
    return tmp;
  }
  function _no_name_provided__344(this$0) {
    this._this$0_83 = this$0;
  }
  _no_name_provided__344.prototype.invoke_0_k$ = function () {
    var tmp0_elvis_lhs = this._this$0_83._gl_2.getSupportedExtensions();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toSet(tmp);
  };
  _no_name_provided__344.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__345(this$0) {
    this._this$0_84 = this$0;
  }
  _no_name_provided__345.prototype.invoke_0_k$ = function () {
    return (this._this$0_84._gl_2.getExtension('OES_texture_float_linear') != null ? true : this._this$0_84._gl_2.getExtension('OES_texture_float') != null) ? true : this._this$0_84._webglVersion >= 2;
  };
  _no_name_provided__345.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function KmlGlJsCanvas(canvas, glOpts) {
    KmlGlWithExtensions.call(this);
    this._canvas_0 = canvas;
    this._glOpts = glOpts;
    this._webglVersion = 1;
    var tmp = this;
    var tmp1_elvis_lhs = null;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = this._canvas_0.getContext('webgl2', this._glOpts);
      var tmp_1;
      if (tmp0_safe_receiver == null) {
        tmp_1 = null;
      } else {
        this._webglVersion = 2;
        tmp_1 = tmp0_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? this._canvas_0.getContext('webgl', this._glOpts) : tmp2_elvis_lhs;
    var tmp0_unsafeCast_0 = tmp3_elvis_lhs == null ? this._canvas_0.getContext('experimental-webgl', this._glOpts) : tmp3_elvis_lhs;
    var tmp4_elvis_lhs = tmp0_unsafeCast_0;
    var tmp_2;
    if (tmp4_elvis_lhs == null) {
      try {
        var tmp0_safe_receiver_2 = document.body;
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          var tmp_3 = document.createElement('div');
          var tmp0_apply_0_3 = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
          tmp0_apply_0_3.style.color = 'red';
          tmp0_apply_0_3.style.font = '30px Arial';
          tmp0_apply_0_3.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp0_safe_receiver_2.prepend(tmp0_apply_0_3);
          Unit_getInstance();
        }
        Unit_getInstance();
      } catch ($p) {
        if ($p instanceof Error) {
          printStackTrace_0($p);
        } else {
          {
            throw $p;
          }
        }
      }
      throw IllegalStateException_init_$Create$_0("Can't get webgl context");
    } else {
      tmp_2 = tmp4_elvis_lhs;
    }
    tmp._gl_2 = tmp_2;
    var tmp_4 = this;
    var tmp0_arrayOfNulls_0 = 8192;
    tmp_4._items_4 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._freeList = toMutableList_4(reversed_0(until(1, this._items_4.length)));
    var tmp_5 = this;
    tmp_5._extensions$delegate = lazy(_no_name_provided_$factory_289(this));
    var tmp_6 = this;
    tmp_6._isFloatTextureSupported$delegate_0 = lazy(_no_name_provided_$factory_290(this));
    this.__instancedArraysSet = false;
    this.__instancedArrays = null;
  }
  KmlGlJsCanvas.prototype.activeTexture_majfzk_k$ = function (texture) {
    return this._gl_2.activeTexture(texture);
  };
  KmlGlJsCanvas.prototype.attachShader_rvwcgf_k$ = function (program, shader) {
    return this._gl_2.attachShader(get_1(program, this), get_1(shader, this));
  };
  KmlGlJsCanvas.prototype.bindBuffer_rvwcgf_k$ = function (target, buffer) {
    return this._gl_2.bindBuffer(target, get_1(buffer, this));
  };
  KmlGlJsCanvas.prototype.bindFramebuffer_rvwcgf_k$ = function (target, framebuffer) {
    return this._gl_2.bindFramebuffer(target, get_1(framebuffer, this));
  };
  KmlGlJsCanvas.prototype.bindRenderbuffer_rvwcgf_k$ = function (target, renderbuffer) {
    return this._gl_2.bindRenderbuffer(target, get_1(renderbuffer, this));
  };
  KmlGlJsCanvas.prototype.bindTexture_rvwcgf_k$ = function (target, texture) {
    return this._gl_2.bindTexture(target, get_1(texture, this));
  };
  KmlGlJsCanvas.prototype.blendEquationSeparate_rvwcgf_k$ = function (modeRGB, modeAlpha) {
    return this._gl_2.blendEquationSeparate(modeRGB, modeAlpha);
  };
  KmlGlJsCanvas.prototype.blendFuncSeparate_jthg1_k$ = function (sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this._gl_2.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  };
  KmlGlJsCanvas.prototype.bufferData_tov2rt_k$ = function (target, size_2, data, usage) {
    return this._gl_2.bufferData(target, new Uint8Array(_get_arrayBuffer_(data), 0, size_2), usage);
  };
  KmlGlJsCanvas.prototype.clear_majfzk_k$ = function (mask_0) {
    return this._gl_2.clear(mask_0);
  };
  KmlGlJsCanvas.prototype.clearColor_f95lpr_k$ = function (red, green, blue, alpha_0) {
    return this._gl_2.clearColor(red, green, blue, alpha_0);
  };
  KmlGlJsCanvas.prototype.clearDepthf_cpozfn_k$ = function (d) {
    return this._gl_2.clearDepth(d);
  };
  KmlGlJsCanvas.prototype.clearStencil_majfzk_k$ = function (s) {
    return this._gl_2.clearStencil(s);
  };
  KmlGlJsCanvas.prototype.colorMask_7d158x_k$ = function (red, green, blue, alpha_0) {
    return this._gl_2.colorMask(red, green, blue, alpha_0);
  };
  KmlGlJsCanvas.prototype.compileShader_majfzk_k$ = function (shader) {
    return this._gl_2.compileShader(get_1(shader, this));
  };
  KmlGlJsCanvas.prototype.createProgram_0_k$ = function () {
    return alloc_0(this._gl_2.createProgram(), this);
  };
  KmlGlJsCanvas.prototype.createShader_ha5a7z_k$ = function (type) {
    return alloc_0(this._gl_2.createShader(type), this);
  };
  KmlGlJsCanvas.prototype.deleteBuffers_9vfq5l_k$ = function (n, items) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_4 = items._arrayInt;
        this._gl_2.deleteBuffer(free(tmp0_get_0_4[p_3], this));
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.deleteFramebuffers_9vfq5l_k$ = function (n, items) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_4 = items._arrayInt;
        this._gl_2.deleteFramebuffer(free(tmp0_get_0_4[p_3], this));
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.deleteProgram_majfzk_k$ = function (program) {
    return this._gl_2.deleteProgram(get_1(program, this));
  };
  KmlGlJsCanvas.prototype.deleteRenderbuffers_9vfq5l_k$ = function (n, items) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_4 = items._arrayInt;
        this._gl_2.deleteRenderbuffer(free(tmp0_get_0_4[p_3], this));
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.deleteShader_majfzk_k$ = function (shader) {
    return this._gl_2.deleteShader(get_1(shader, this));
  };
  KmlGlJsCanvas.prototype.deleteTextures_9vfq5l_k$ = function (n, items) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_4 = items._arrayInt;
        this._gl_2.deleteTexture(free(tmp0_get_0_4[p_3], this));
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.depthFunc_majfzk_k$ = function (func) {
    return this._gl_2.depthFunc(func);
  };
  KmlGlJsCanvas.prototype.depthMask_rpwsgn_k$ = function (flag) {
    return this._gl_2.depthMask(flag);
  };
  KmlGlJsCanvas.prototype.depthRangef_c7v4pd_k$ = function (n, f) {
    return this._gl_2.depthRange(n, f);
  };
  KmlGlJsCanvas.prototype.disable_majfzk_k$ = function (cap) {
    return this._gl_2.disable(cap);
  };
  KmlGlJsCanvas.prototype.disableVertexAttribArray_majfzk_k$ = function (index_0) {
    return this._gl_2.disableVertexAttribArray(index_0);
  };
  KmlGlJsCanvas.prototype.drawArrays_zd700_k$ = function (mode, first_2, count_0) {
    return this._gl_2.drawArrays(mode, first_2, count_0);
  };
  KmlGlJsCanvas.prototype.drawElements_jthg1_k$ = function (mode, count_0, type, indices) {
    return this._gl_2.drawElements(mode, count_0, type, indices);
  };
  KmlGlJsCanvas.prototype.enable_majfzk_k$ = function (cap) {
    return this._gl_2.enable(cap);
  };
  KmlGlJsCanvas.prototype.enableVertexAttribArray_majfzk_k$ = function (index_0) {
    return this._gl_2.enableVertexAttribArray(index_0);
  };
  KmlGlJsCanvas.prototype.framebufferRenderbuffer_jthg1_k$ = function (target, attachment, renderbuffertarget, renderbuffer) {
    return this._gl_2.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_1(renderbuffer, this));
  };
  KmlGlJsCanvas.prototype.framebufferTexture2D_s9wiz4_k$ = function (target, attachment, textarget, texture, level) {
    return this._gl_2.framebufferTexture2D(target, attachment, textarget, get_1(texture, this), level);
  };
  KmlGlJsCanvas.prototype.frontFace_majfzk_k$ = function (mode) {
    return this._gl_2.frontFace(mode);
  };
  KmlGlJsCanvas.prototype.genBuffers_9vfq5l_k$ = function (n, buffers) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0_4 = buffers._arrayInt;
        var tmp1_set_0_5 = alloc_0(this._gl_2.createBuffer(), this);
        tmp0_set_0_4[p_3] = tmp1_set_0_5;
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.generateMipmap_majfzk_k$ = function (target) {
    return this._gl_2.generateMipmap(target);
  };
  KmlGlJsCanvas.prototype.genFramebuffers_9vfq5l_k$ = function (n, framebuffers) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0_4 = framebuffers._arrayInt;
        var tmp1_set_0_5 = alloc_0(this._gl_2.createFramebuffer(), this);
        tmp0_set_0_4[p_3] = tmp1_set_0_5;
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.genRenderbuffers_9vfq5l_k$ = function (n, renderbuffers) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0_4 = renderbuffers._arrayInt;
        var tmp1_set_0_5 = alloc_0(this._gl_2.createRenderbuffer(), this);
        tmp0_set_0_4[p_3] = tmp1_set_0_5;
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.genTextures_9vfq5l_k$ = function (n, textures) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0_4 = textures._arrayInt;
        var tmp1_set_0_5 = alloc_0(this._gl_2.createTexture(), this);
        tmp0_set_0_4[p_3] = tmp1_set_0_5;
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.getAttribLocation_4wk0sg_k$ = function (program, name) {
    return this._gl_2.getAttribLocation(get_1(program, this), name);
  };
  KmlGlJsCanvas.prototype.getUniformLocation_4wk0sg_k$ = function (program, name) {
    var tmp0_asDynamic_0_3 = get_1(program, this);
    var prg_2 = tmp0_asDynamic_0_3;
    if (prg_2.uniforms === undefined)
      prg_2.uniforms = {};
    if (prg_2.uniforms[name] === undefined)
      prg_2.uniforms[name] = alloc_0(this._gl_2.getUniformLocation(prg_2, name), this);
    var tmp1_unsafeCast_0_4 = prg_2.uniforms[name];
    return tmp1_unsafeCast_0_4;
  };
  KmlGlJsCanvas.prototype.getError_0_k$ = function () {
    return this._gl_2.getError();
  };
  KmlGlJsCanvas.prototype.getIntegerv_9vfq5l_k$ = function (pname, data) {
    var tmp1_set_0_2 = data._arrayInt;
    var tmp0_unsafeCast_0_4 = this._gl_2.getParameter(pname);
    var tmp2_set_0_3 = tmp0_unsafeCast_0_4;
    return tmp1_set_0_2[0] = tmp2_set_0_3;
  };
  KmlGlJsCanvas.prototype.getProgramiv_1a3fjs_k$ = function (program, pname, params) {
    var tmp0_subject_2 = pname;
    var tmp;
    if (tmp0_subject_2 === this._get_INFO_LOG_LENGTH__0_k$()) {
      var tmp0_set_0_3 = params._arrayInt;
      var tmp1_safe_receiver_7 = this._gl_2.getProgramInfoLog(get_1(program, this));
      var tmp2_safe_receiver_6 = tmp1_safe_receiver_7 == null ? null : tmp1_safe_receiver_7.length;
      var tmp3_elvis_lhs_5 = tmp2_safe_receiver_6 == null ? null : tmp2_safe_receiver_6 + 1 | 0;
      var tmp1_set_0_4 = tmp3_elvis_lhs_5 == null ? 1 : tmp3_elvis_lhs_5;
      tmp = tmp0_set_0_3[0] = tmp1_set_0_4;
    } else {
      var tmp3_set_0_8 = params._arrayInt;
      var tmp2_unsafeCast_0_10 = this._gl_2.getProgramParameter(get_1(program, this), pname);
      var tmp4_set_0_9 = tmp2_unsafeCast_0_10;
      tmp = tmp3_set_0_8[0] = tmp4_set_0_9;
    }
    return tmp;
  };
  KmlGlJsCanvas.prototype.getShaderiv_1a3fjs_k$ = function (shader, pname, params) {
    var tmp0_subject_2 = pname;
    var tmp;
    if (tmp0_subject_2 === this._get_INFO_LOG_LENGTH__0_k$()) {
      var tmp0_set_0_3 = params._arrayInt;
      var tmp1_safe_receiver_7 = this._gl_2.getShaderInfoLog(get_1(shader, this));
      var tmp2_safe_receiver_6 = tmp1_safe_receiver_7 == null ? null : tmp1_safe_receiver_7.length;
      var tmp3_elvis_lhs_5 = tmp2_safe_receiver_6 == null ? null : tmp2_safe_receiver_6 + 1 | 0;
      var tmp1_set_0_4 = tmp3_elvis_lhs_5 == null ? 1 : tmp3_elvis_lhs_5;
      tmp = tmp0_set_0_3[0] = tmp1_set_0_4;
    } else {
      var tmp3_set_0_8 = params._arrayInt;
      var tmp2_unsafeCast_0_10 = this._gl_2.getShaderParameter(get_1(shader, this), pname);
      var tmp4_set_0_9 = tmp2_unsafeCast_0_10;
      tmp = tmp3_set_0_8[0] = tmp4_set_0_9;
    }
    return tmp;
  };
  KmlGlJsCanvas.prototype.getShaderInfoLog_su8xz3_k$ = function (shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs_3 = this._gl_2.getShaderInfoLog(get_1(shader, this));
    var str_2 = tmp0_elvis_lhs_3 == null ? '' : tmp0_elvis_lhs_3;
    var tmp0_set_0_4 = length._arrayInt;
    var tmp1_set_0_5 = str_2.length;
    tmp0_set_0_4[0] = tmp1_set_0_5;
    putAsciiString(infoLog, str_2);
    return Unit_getInstance();
  };
  KmlGlJsCanvas.prototype.getString_ha5a7z_k$ = function (name) {
    var tmp0_unsafeCast_0 = this._gl_2.getParameter(name);
    return tmp0_unsafeCast_0;
  };
  KmlGlJsCanvas.prototype.lineWidth_cpozfn_k$ = function (width) {
    return this._gl_2.lineWidth(width);
  };
  KmlGlJsCanvas.prototype.linkProgram_majfzk_k$ = function (program) {
    return this._gl_2.linkProgram(get_1(program, this));
  };
  KmlGlJsCanvas.prototype.pixelStorei_rvwcgf_k$ = function (pname, param) {
    return this._gl_2.pixelStorei(pname, param);
  };
  KmlGlJsCanvas.prototype.renderbufferStorage_jthg1_k$ = function (target, internalformat, width, height) {
    return this._gl_2.renderbufferStorage(target, internalformat, width, height);
  };
  KmlGlJsCanvas.prototype.scissor_jthg1_k$ = function (x, y, width, height) {
    return this._gl_2.scissor(x, y, width, height);
  };
  KmlGlJsCanvas.prototype.shaderSource_iyywcx_k$ = function (shader, string) {
    return this._gl_2.shaderSource(get_1(shader, this), '' + '#ifdef GL_ES\nprecision mediump float;\n#endif\n' + string);
  };
  KmlGlJsCanvas.prototype.stencilFunc_zd700_k$ = function (func, ref, mask_0) {
    return this._gl_2.stencilFunc(func, ref, mask_0);
  };
  KmlGlJsCanvas.prototype.stencilMask_majfzk_k$ = function (mask_0) {
    return this._gl_2.stencilMask(mask_0);
  };
  KmlGlJsCanvas.prototype.stencilOp_zd700_k$ = function (fail, zfail, zpass) {
    return this._gl_2.stencilOp(fail, zfail, zpass);
  };
  KmlGlJsCanvas.prototype.texImage2D_p2mxp1_k$ = function (target, level, internalformat, width, height, border, format_0, type, pixels) {
    var tmp0_subject = type;
    var tmp;
    if (tmp0_subject === this._get_FLOAT__0_k$()) {
      var tmp1_safe_receiver = pixels;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = tmp1_safe_receiver._arrayFloat;
      }
      tmp = tmp_0;
    } else {
      var tmp2_safe_receiver = pixels;
      tmp = tmp2_safe_receiver == null ? null : _get_arrayUByte_(tmp2_safe_receiver);
    }
    var vpixels = tmp;
    this._gl_2.texImage2D(target, level, internalformat, width, height, border, format_0, type, vpixels);
  };
  KmlGlJsCanvas.prototype.texImage2D_4xnpxk_k$ = function (target, level, internalformat, format_0, type, data) {
    return this._gl_2.texImage2D(target, level, internalformat, format_0, type, (data instanceof HtmlNativeImage ? data : THROW_CCE())._texSource);
  };
  KmlGlJsCanvas.prototype.texParameteri_zd700_k$ = function (target, pname, param) {
    return this._gl_2.texParameteri(target, pname, param);
  };
  KmlGlJsCanvas.prototype.uniform1f_z49mik_k$ = function (location, v0) {
    return this._gl_2.uniform1f(get_1(location, this), v0);
  };
  KmlGlJsCanvas.prototype.uniform1fv_1a3fjs_k$ = function (location, count_0, value) {
    return this._gl_2.uniform1fv(get_1(location, this), value._arrayFloat);
  };
  KmlGlJsCanvas.prototype.uniform1i_rvwcgf_k$ = function (location, v0) {
    return this._gl_2.uniform1i(get_1(location, this), v0);
  };
  KmlGlJsCanvas.prototype.uniform2f_gk2bzk_k$ = function (location, v0, v1) {
    return this._gl_2.uniform2f(get_1(location, this), v0, v1);
  };
  KmlGlJsCanvas.prototype.uniform2fv_1a3fjs_k$ = function (location, count_0, value) {
    return this._gl_2.uniform2fv(get_1(location, this), value._arrayFloat);
  };
  KmlGlJsCanvas.prototype.uniform3f_tarz9g_k$ = function (location, v0, v1, v2) {
    return this._gl_2.uniform3f(get_1(location, this), v0, v1, v2);
  };
  KmlGlJsCanvas.prototype.uniform3fv_1a3fjs_k$ = function (location, count_0, value) {
    return this._gl_2.uniform3fv(get_1(location, this), value._arrayFloat);
  };
  KmlGlJsCanvas.prototype.uniform4f_g45f0w_k$ = function (location, v0, v1, v2, v3) {
    return this._gl_2.uniform4f(get_1(location, this), v0, v1, v2, v3);
  };
  KmlGlJsCanvas.prototype.uniform4fv_1a3fjs_k$ = function (location, count_0, value) {
    return this._gl_2.uniform4fv(get_1(location, this), value._arrayFloat);
  };
  KmlGlJsCanvas.prototype.uniformMatrix2fv_a0t79e_k$ = function (location, count_0, transpose, value) {
    return this._gl_2.uniformMatrix2fv(get_1(location, this), transpose, sliceIfRequired(value._arrayFloat, this, imul(imul(count_0, 2), 2)));
  };
  KmlGlJsCanvas.prototype.uniformMatrix3fv_a0t79e_k$ = function (location, count_0, transpose, value) {
    return this._gl_2.uniformMatrix3fv(get_1(location, this), transpose, sliceIfRequired(value._arrayFloat, this, imul(imul(count_0, 3), 3)));
  };
  KmlGlJsCanvas.prototype.uniformMatrix4fv_a0t79e_k$ = function (location, count_0, transpose, value) {
    return this._gl_2.uniformMatrix4fv(get_1(location, this), transpose, sliceIfRequired(value._arrayFloat, this, imul(imul(count_0, 4), 4)));
  };
  KmlGlJsCanvas.prototype.useProgram_majfzk_k$ = function (program) {
    return this._gl_2.useProgram(get_1(program, this));
  };
  KmlGlJsCanvas.prototype.vertexAttribPointer_5h0f29_k$ = function (index_0, size_2, type, normalized, stride, pointer) {
    return this._gl_2.vertexAttribPointer(index_0, size_2, type, normalized, stride, pointer.toInt_0_k$());
  };
  KmlGlJsCanvas.prototype.viewport_jthg1_k$ = function (x, y, width, height) {
    return this._gl_2.viewport(x, y, width, height);
  };
  KmlGlJsCanvas.prototype._get_extensions__0_k$ = function () {
    var tmp0_getValue_0 = extensions$factory();
    return this._extensions$delegate._get_value__0_k$();
  };
  KmlGlJsCanvas.prototype._get_instancedArrays__0_k$ = function () {
    if (!this.__instancedArraysSet) {
      this.__instancedArraysSet = true;
      this.__instancedArrays = this._gl_2.getExtension('ANGLE_instanced_arrays');
    }return this.__instancedArrays;
  };
  KmlGlJsCanvas.prototype.drawArraysInstanced_jthg1_k$ = function (mode, first_2, count_0, instancecount) {
    if (this._webglVersion >= 2) {
      var tmp0_asDynamic_0 = this._gl_2;
      tmp0_asDynamic_0.drawArraysInstanced(mode, first_2, count_0, instancecount);
    } else {
      this._get_instancedArrays__0_k$().drawArraysInstancedANGLE(mode, first_2, count_0, instancecount);
    }
  };
  KmlGlJsCanvas.prototype.drawElementsInstanced_s9wiz4_k$ = function (mode, count_0, type, indices, instancecount) {
    if (this._webglVersion >= 2) {
      var tmp0_asDynamic_0 = this._gl_2;
      tmp0_asDynamic_0.drawElementsInstanced(mode, count_0, type, indices, instancecount);
    } else {
      this._get_instancedArrays__0_k$().drawElementsInstancedANGLE(mode, count_0, type, indices, instancecount);
    }
  };
  KmlGlJsCanvas.prototype.vertexAttribDivisor_rvwcgf_k$ = function (index_0, divisor) {
    if (this._webglVersion >= 2) {
      var tmp0_asDynamic_0 = this._gl_2;
      tmp0_asDynamic_0.vertexAttribDivisor(index_0, divisor);
    } else {
      this._get_instancedArrays__0_k$().vertexAttribDivisorANGLE(index_0, divisor);
    }
  };
  KmlGlJsCanvas.$metadata$ = {
    simpleName: 'KmlGlJsCanvas',
    kind: 'class',
    interfaces: []
  };
  function extensions$factory() {
    return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
      return receiver._get_extensions__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_289(this$0) {
    var i = new _no_name_provided__344(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_290(this$0) {
    var i = new _no_name_provided__345(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _get_arrayBuffer_(_this_) {
    var tmp = _this_._mem;
    return tmp instanceof ArrayBuffer ? tmp : THROW_CCE();
  }
  function _get_arrayUByte_(_this_) {
    return new Uint8Array(_this_._mem);
  }
  function AGOpenglFactory() {
    AGOpenglFactory_instance = this;
  }
  AGOpenglFactory.prototype._get_isTouchDevice__0_k$ = function () {
    var tmp0_unsafeCast_0 = 'ontouchstart' in window || navigator.maxTouchPoints;
    return tmp0_unsafeCast_0;
  };
  AGOpenglFactory.$metadata$ = {
    simpleName: 'AGOpenglFactory',
    kind: 'object',
    interfaces: []
  };
  var AGOpenglFactory_instance;
  function AGOpenglFactory_getInstance() {
    if (AGOpenglFactory_instance == null)
      new AGOpenglFactory();
    return AGOpenglFactory_instance;
  }
  function _get_korgwCanvasQuery_() {
    var tmp0_getValue_0 = korgwCanvasQuery$factory();
    return korgwCanvasQuery$delegate._get_value__0_k$();
  }
  var korgwCanvasQuery$delegate;
  function AGWebgl_init_$Init$(config, glDecorator, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      glDecorator = _no_name_provided_$factory_292();
    }AGWebgl.call($this, config, glDecorator);
    return $this;
  }
  function AGWebgl_init_$Create$(config, glDecorator, $mask0, $marker) {
    return AGWebgl_init_$Init$(config, glDecorator, $mask0, $marker, Object.create(AGWebgl.prototype));
  }
  function Companion_179() {
    Companion_instance_178 = this;
    this._UNPACK_PREMULTIPLY_ALPHA_WEBGL = 37441;
  }
  Companion_179.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_178;
  function Companion_getInstance_178() {
    if (Companion_instance_178 == null)
      new Companion_179();
    return Companion_instance_178;
  }
  function _no_name_provided__346() {
  }
  _no_name_provided__346.prototype.invoke_3h8fba_k$ = function (it) {
    return it;
  };
  _no_name_provided__346.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_3h8fba_k$(p1 instanceof KmlGl ? p1 : THROW_CCE());
  };
  _no_name_provided__346.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__347(this$0) {
    this._this$0_85 = this$0;
  }
  _no_name_provided__347.prototype.invoke_0_k$ = function () {
    return this._this$0_85.getCanvas_0_k$();
  };
  _no_name_provided__347.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__348() {
  }
  _no_name_provided__348.prototype.invoke_xfv2uo_k$ = function (e) {
    e.preventDefault();
  };
  _no_name_provided__348.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__348.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__349(this$0) {
    this._this$0_86 = this$0;
  }
  _no_name_provided__349.prototype.invoke_xfv2uo_k$ = function (e) {
    var tmp0_this = this._this$0_86;
    var tmp1 = tmp0_this._get_contextVersion__0_k$();
    tmp0_this._set_contextVersion__majfzk_k$(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  _no_name_provided__349.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__349.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AGWebgl(config, glDecorator) {
    Companion_getInstance_178();
    AGOpengl.call(this);
    this._config_3 = config;
    this._glDecorator = glDecorator;
    this._ag_0 = this;
    var tmp = this;
    tmp._canvas$delegate = lazy(_no_name_provided_$factory_293(this));
    this._glOpts_0 = jsObject([to('premultipliedAlpha', true), to('alpha', false), to('stencil', true), to('antialias', this._config_3._antialiasHint)]);
    this._baseGl = new KmlGlJsCanvas(this._get_canvas__0_k$(), this._glOpts_0);
    this._gl_3 = this._glDecorator(this._baseGl);
    var tmp0_asDynamic_0 = window;
    tmp0_asDynamic_0.ag = this;
    this._nativeComponent_0 = this._get_canvas__0_k$();
    this._devicePixelRatio_1 = 1.0;
    var tmp_0 = this._get_canvas__0_k$();
    tmp_0.addEventListener('webglcontextlost', _no_name_provided_$factory_294(), false);
    var tmp_1 = this._get_canvas__0_k$();
    tmp_1.addEventListener('webglcontextrestored', _no_name_provided_$factory_295(this), false);
  }
  AGWebgl.prototype.getCanvas_0_k$ = function () {
    var tmp0_safe_receiver = _get_korgwCanvasQuery_();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = document.querySelector(tmp0_safe_receiver);
      tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      var tmp_2 = document.createElement('canvas');
      tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  };
  AGWebgl.prototype._get_canvas__0_k$ = function () {
    var tmp0_getValue_0 = canvas$factory();
    return this._canvas$delegate._get_value__0_k$();
  };
  AGWebgl.prototype._get_gl__0_k$ = function () {
    return this._gl_3;
  };
  AGWebgl.prototype._get_webgl__0_k$ = function () {
    return true;
  };
  AGWebgl.prototype._get_webgl2__0_k$ = function () {
    return this._baseGl._webglVersion >= 2;
  };
  AGWebgl.prototype._get_tDevicePixelRatio__0_k$ = function () {
    return window.devicePixelRatio;
  };
  AGWebgl.prototype._get_devicePixelRatio__0_k$ = function () {
    return this._get_tDevicePixelRatio__0_k$() <= 0.0 ? 1.0 : isNaN_0(this._get_tDevicePixelRatio__0_k$()) ? 1.0 : isInfinite_0(this._get_tDevicePixelRatio__0_k$()) ? 1.0 : this._get_tDevicePixelRatio__0_k$();
  };
  AGWebgl.prototype.prepareUploadNativeTexture_nm2sef_k$ = function (bmp) {
    var tmp = this._get_gl__0_k$();
    Companion_getInstance_178();
    var tmp0_toInt_0 = bmp._get_premultiplied__0_k$();
    tmp.pixelStorei_rvwcgf_k$(37441, tmp0_toInt_0 ? 1 : 0);
  };
  AGWebgl.$metadata$ = {
    simpleName: 'AGWebgl',
    kind: 'class',
    interfaces: [AGContainer]
  };
  function _get_isCanvasCreatedAndHandled_() {
    return _get_korgwCanvasQuery_() == null;
  }
  function jsObject(pairs) {
    var out = jsEmptyObject();
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var tmp1_loop_parameter = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var k = tmp1_loop_parameter.component1_0_k$();
      var v = tmp1_loop_parameter.component2_0_k$();
      if (!(v == null))
        out[k] = v;
    }
    return out;
  }
  function jsEmptyObject() {
    return {};
  }
  function _no_name_provided__350() {
  }
  _no_name_provided__350.prototype.invoke_0_k$ = function () {
    var tmp0_asDynamic_0 = window;
    var tmp1_unsafeCast_0 = tmp0_asDynamic_0.korgwCanvasQuery;
    return tmp1_unsafeCast_0;
  };
  _no_name_provided__350.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function korgwCanvasQuery$factory() {
    return getPropertyCallableRef('korgwCanvasQuery', 0, KProperty0, function () {
      return _get_korgwCanvasQuery_();
    }, null);
  }
  function canvas$factory() {
    return getPropertyCallableRef('canvas', 1, KProperty1, function (receiver) {
      return receiver._get_canvas__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_291() {
    var i = new _no_name_provided__350();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_292() {
    var i = new _no_name_provided__346();
    return function (p1) {
      return i.invoke_3h8fba_k$(p1);
    };
  }
  function _no_name_provided_$factory_293(this$0) {
    var i = new _no_name_provided__347(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_294() {
    var i = new _no_name_provided__348();
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_295(this$0) {
    var i = new _no_name_provided__349(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  var knownControllers;
  function Nimbus_111_1420_Safari_GamepadMapping() {
    Nimbus_111_1420_Safari_GamepadMapping_instance = this;
    GamepadMapping.call(this);
    this._id_23 = '111-1420-Nimbus';
  }
  Nimbus_111_1420_Safari_GamepadMapping.prototype._get_id__0_k$ = function () {
    return this._id_23;
  };
  Nimbus_111_1420_Safari_GamepadMapping.prototype.get_ytw0rl_k$ = function (button, info) {
    var tmp0_subject = button;
    return tmp0_subject.equals(GameButton_BUTTON0_getInstance()) ? this.getRawButton_64rpga_k$(info, 0) : tmp0_subject.equals(GameButton_BUTTON1_getInstance()) ? this.getRawButton_64rpga_k$(info, 1) : tmp0_subject.equals(GameButton_BUTTON2_getInstance()) ? this.getRawButton_64rpga_k$(info, 2) : tmp0_subject.equals(GameButton_BUTTON3_getInstance()) ? this.getRawButton_64rpga_k$(info, 3) : tmp0_subject.equals(GameButton_L1_getInstance()) ? this.getRawButton_64rpga_k$(info, 4) : tmp0_subject.equals(GameButton_R1_getInstance()) ? this.getRawButton_64rpga_k$(info, 5) : tmp0_subject.equals(GameButton_L2_getInstance()) ? this.getRawButton_64rpga_k$(info, 6) : tmp0_subject.equals(GameButton_R2_getInstance()) ? this.getRawButton_64rpga_k$(info, 7) : tmp0_subject.equals(GameButton_LEFT_getInstance()) ? this.getRawButton_64rpga_k$(info, 8) : tmp0_subject.equals(GameButton_DOWN_getInstance()) ? this.getRawButton_64rpga_k$(info, 9) : tmp0_subject.equals(GameButton_RIGHT_getInstance()) ? this.getRawButton_64rpga_k$(info, 10) : tmp0_subject.equals(GameButton_UP_getInstance()) ? this.getRawButton_64rpga_k$(info, 11) : tmp0_subject.equals(GameButton_SELECT_getInstance()) ? 0.0 : tmp0_subject.equals(GameButton_START_getInstance()) ? 0.0 : tmp0_subject.equals(GameButton_SYSTEM_getInstance()) ? 0.0 : tmp0_subject.equals(GameButton_LX_getInstance()) ? this.getRawAxe_64rpga_k$(info, 0) : tmp0_subject.equals(GameButton_LY_getInstance()) ? this.getRawAxe_64rpga_k$(info, 1) : tmp0_subject.equals(GameButton_RX_getInstance()) ? this.getRawAxe_64rpga_k$(info, 2) : tmp0_subject.equals(GameButton_RY_getInstance()) ? this.getRawAxe_64rpga_k$(info, 3) : 0.0;
  };
  Nimbus_111_1420_Safari_GamepadMapping.$metadata$ = {
    simpleName: 'Nimbus_111_1420_Safari_GamepadMapping',
    kind: 'object',
    interfaces: []
  };
  var Nimbus_111_1420_Safari_GamepadMapping_instance;
  function Nimbus_111_1420_Safari_GamepadMapping_getInstance() {
    if (Nimbus_111_1420_Safari_GamepadMapping_instance == null)
      new Nimbus_111_1420_Safari_GamepadMapping();
    return Nimbus_111_1420_Safari_GamepadMapping_instance;
  }
  function CreateDefaultGameWindow() {
    return OS_getInstance()._get_isJsNodeJs__0_k$() ? new NodeJsGameWindow() : new BrowserGameWindow();
  }
  function NodeJsGameWindow() {
    GameWindow.call(this);
  }
  NodeJsGameWindow.$metadata$ = {
    simpleName: 'NodeJsGameWindow',
    kind: 'class',
    interfaces: []
  };
  function updateGamepad($this) {
    try {
      if (navigator.getGamepads != null) {
        var tmp0_unsafeCast_0 = navigator.getGamepads();
        var gamepads = tmp0_unsafeCast_0;
        var indexedObject = $this._get_gamePadUpdateEvent__0_k$()._gamepads;
        var inductionVariable = 0;
        var last_1 = indexedObject.length;
        while (inductionVariable < last_1) {
          var gp = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          gp._connected = false;
        }
        $this._get_gamePadUpdateEvent__0_k$()._gamepadsLength = gamepads.length;
        var inductionVariable_0 = 0;
        var last_2 = gamepads.length;
        if (inductionVariable_0 < last_2)
          do {
            var gamepadId = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp2_elvis_lhs == null) {
              continue;
            } else {
              tmp = tmp2_elvis_lhs;
            }
            var controller = tmp;
            var tmp3_elvis_lhs = getOrNull_0($this._get_gamePadUpdateEvent__0_k$()._gamepads, gamepadId);
            var tmp_0;
            if (tmp3_elvis_lhs == null) {
              continue;
            } else {
              tmp_0 = tmp3_elvis_lhs;
            }
            var gamepad = tmp_0;
            var tmp4_elvis_lhs = knownControllers.get_2bw_k$(controller.id);
            var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? knownControllers.get_2bw_k$(controller.mapping) : tmp4_elvis_lhs;
            var mapping = tmp5_elvis_lhs == null ? Companion_getInstance_171() : tmp5_elvis_lhs;
            gamepad._connected = controller.connected;
            gamepad._index_28 = controller.index;
            gamepad._name_24 = controller.id;
            gamepad._mapping = mapping;
            gamepad._axesLength = controller.axes.length;
            gamepad._buttonsLength = controller.buttons.length;
            gamepad._rawButtonsPressed = 0;
            var inductionVariable_1 = 0;
            var last_3 = controller.buttons.length;
            if (inductionVariable_1 < last_3)
              do {
                var n_3 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var tmp0_get_0_5 = controller.buttons;
                var button_4 = tmp0_get_0_5[n_3];
                if (button_4.pressed)
                  gamepad._rawButtonsPressed = gamepad._rawButtonsPressed | 1 << n_3;
                gamepad._rawButtonsPressure[n_3] = button_4.value;
              }
               while (inductionVariable_1 < last_3);
            var inductionVariable_2 = 0;
            var last_4 = controller.axes.length;
            if (inductionVariable_2 < last_4)
              do {
                var n_7 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var tmp1_get_0_8 = controller.axes;
                gamepad._rawAxes[n_7] = tmp1_get_0_8[n_7];
              }
               while (inductionVariable_2 < last_4);
            Unit_getInstance();
          }
           while (inductionVariable_0 < last_2);
        var tmp1_dispatch_0 = $this._get_gamePadUpdateEvent__0_k$();
        $this.dispatch_62irmi_k$(getKClass_0(GamePadUpdateEvent), tmp1_dispatch_0);
      }} catch ($p) {
      console.error($p);
    }
  }
  function onResized($this) {
    $this._isTouchDeviceCache = null;
    if (_get_isCanvasCreatedAndHandled_()) {
      var tmp = $this._get_quality__0_k$();
      var tmp_0 = window.innerWidth;
      var tmp_1 = window.innerHeight;
      var tmp_2 = $this._get_ag__0_k$()._get_devicePixelRatio__0_k$();
      var scale_1 = tmp.computeTargetScale$default_7cop6o_k$(tmp_0, tmp_1, tmp_2, 0, 8, null);
      var canvasWidth = numberToInt(window.innerWidth * scale_1);
      var canvasHeight = numberToInt(window.innerHeight * scale_1);
      $this._get_canvas__0_k$().width = canvasWidth;
      $this._get_canvas__0_k$().height = canvasHeight;
      $this._get_canvas__0_k$().style.position = 'absolute';
      $this._get_canvas__0_k$().style.left = '0';
      $this._get_canvas__0_k$().style.right = '0';
      $this._get_canvas__0_k$().style.width = '' + window.innerWidth + 'px';
      $this._get_canvas__0_k$().style.height = '' + window.innerHeight + 'px';
      $this._canvasRatio = scale_1;
    } else {
      $this._canvasRatio = $this._get_canvas__0_k$().width / $this._get_canvas__0_k$().clientWidth;
    }
    $this.dispatchReshapeEvent_jthg1_k$(0, 0, $this._get_canvas__0_k$().width, $this._get_canvas__0_k$().height);
  }
  function doRender($this) {
    var tmp0_dispatch_0 = $this._get_renderEvent__0_k$();
    $this.dispatch_62irmi_k$(getKClass_0(RenderEvent), tmp0_dispatch_0);
  }
  function keyEvent($this, me) {
    var tmp0_subject = me.key;
    var tmp;
    switch (tmp0_subject) {
      case '0':
        tmp = Key_N0_getInstance();
        break;
      case '1':
        tmp = Key_N1_getInstance();
        break;
      case '2':
        tmp = Key_N2_getInstance();
        break;
      case '3':
        tmp = Key_N3_getInstance();
        break;
      case '4':
        tmp = Key_N4_getInstance();
        break;
      case '5':
        tmp = Key_N5_getInstance();
        break;
      case '6':
        tmp = Key_N6_getInstance();
        break;
      case '7':
        tmp = Key_N7_getInstance();
        break;
      case '8':
        tmp = Key_N8_getInstance();
        break;
      case '9':
        tmp = Key_N9_getInstance();
        break;
      case 'a':
        tmp = Key_A_getInstance();
        break;
      case 'b':
        tmp = Key_B_getInstance();
        break;
      case 'c':
        tmp = Key_C_getInstance();
        break;
      case 'd':
        tmp = Key_D_getInstance();
        break;
      case 'e':
        tmp = Key_E_getInstance();
        break;
      case 'f':
        tmp = Key_F_getInstance();
        break;
      case 'g':
        tmp = Key_G_getInstance();
        break;
      case 'h':
        tmp = Key_H_getInstance();
        break;
      case 'i':
        tmp = Key_I_getInstance();
        break;
      case 'j':
        tmp = Key_J_getInstance();
        break;
      case 'k':
        tmp = Key_K_getInstance();
        break;
      case 'l':
        tmp = Key_L_getInstance();
        break;
      case 'm':
        tmp = Key_M_getInstance();
        break;
      case 'n':
        tmp = Key_N_getInstance();
        break;
      case 'o':
        tmp = Key_O_getInstance();
        break;
      case 'p':
        tmp = Key_P_getInstance();
        break;
      case 'q':
        tmp = Key_Q_getInstance();
        break;
      case 'r':
        tmp = Key_R_getInstance();
        break;
      case 's':
        tmp = Key_S_getInstance();
        break;
      case 't':
        tmp = Key_T_getInstance();
        break;
      case 'u':
        tmp = Key_U_getInstance();
        break;
      case 'v':
        tmp = Key_V_getInstance();
        break;
      case 'w':
        tmp = Key_W_getInstance();
        break;
      case 'x':
        tmp = Key_X_getInstance();
        break;
      case 'y':
        tmp = Key_Y_getInstance();
        break;
      case 'z':
        tmp = Key_Z_getInstance();
        break;
      case 'F1':
        tmp = Key_F1_getInstance();
        break;
      case 'F2':
        tmp = Key_F2_getInstance();
        break;
      case 'F3':
        tmp = Key_F3_getInstance();
        break;
      case 'F4':
        tmp = Key_F4_getInstance();
        break;
      case 'F5':
        tmp = Key_F5_getInstance();
        break;
      case 'F6':
        tmp = Key_F6_getInstance();
        break;
      case 'F7':
        tmp = Key_F7_getInstance();
        break;
      case 'F8':
        tmp = Key_F8_getInstance();
        break;
      case 'F9':
        tmp = Key_F9_getInstance();
        break;
      case 'F10':
        tmp = Key_F10_getInstance();
        break;
      case 'F11':
        tmp = Key_F11_getInstance();
        break;
      case 'F12':
        tmp = Key_F12_getInstance();
        break;
      case 'F13':
        tmp = Key_F13_getInstance();
        break;
      case 'F14':
        tmp = Key_F14_getInstance();
        break;
      case 'F15':
        tmp = Key_F15_getInstance();
        break;
      case 'F16':
        tmp = Key_F16_getInstance();
        break;
      case 'F17':
        tmp = Key_F17_getInstance();
        break;
      case 'F18':
        tmp = Key_F18_getInstance();
        break;
      case 'F19':
        tmp = Key_F19_getInstance();
        break;
      case 'F20':
        tmp = Key_F20_getInstance();
        break;
      case 'F21':
        tmp = Key_F21_getInstance();
        break;
      case 'F22':
        tmp = Key_F22_getInstance();
        break;
      case 'F23':
        tmp = Key_F23_getInstance();
        break;
      case 'F24':
        tmp = Key_F24_getInstance();
        break;
      case 'F25':
        tmp = Key_F25_getInstance();
        break;
      case '+':
        tmp = Key_PLUS_getInstance();
        break;
      case '-':
        tmp = Key_MINUS_getInstance();
        break;
      case "'":
        tmp = Key_APOSTROPHE_getInstance();
        break;
      case '"':
        tmp = Key_QUOTE_getInstance();
        break;
      default:var tmp1_subject = me.code;
        var tmp_0;
        switch (tmp1_subject) {
          case 'MetaLeft':
            tmp_0 = Key_LEFT_SUPER_getInstance();
            break;
          case 'MetaRight':
            tmp_0 = Key_RIGHT_SUPER_getInstance();
            break;
          case 'ShiftLeft':
            tmp_0 = Key_LEFT_SHIFT_getInstance();
            break;
          case 'ShiftRight':
            tmp_0 = Key_RIGHT_SHIFT_getInstance();
            break;
          case 'ControlLeft':
            tmp_0 = Key_LEFT_CONTROL_getInstance();
            break;
          case 'ControlRight':
            tmp_0 = Key_RIGHT_CONTROL_getInstance();
            break;
          case 'AltLeft':
            tmp_0 = Key_LEFT_ALT_getInstance();
            break;
          case 'AltRight':
            tmp_0 = Key_RIGHT_ALT_getInstance();
            break;
          case 'Space':
            tmp_0 = Key_SPACE_getInstance();
            break;
          case 'ArrowUp':
            tmp_0 = Key_UP_getInstance();
            break;
          case 'ArrowDown':
            tmp_0 = Key_DOWN_getInstance();
            break;
          case 'ArrowLeft':
            tmp_0 = Key_LEFT_getInstance();
            break;
          case 'ArrowRight':
            tmp_0 = Key_RIGHT_getInstance();
            break;
          case 'PageUp':
            tmp_0 = Key_PAGE_UP_getInstance();
            break;
          case 'PageDown':
            tmp_0 = Key_PAGE_DOWN_getInstance();
            break;
          case 'Home':
            tmp_0 = Key_HOME_getInstance();
            break;
          case 'End':
            tmp_0 = Key_END_getInstance();
            break;
          case 'Enter':
            tmp_0 = Key_ENTER_getInstance();
            break;
          case 'Escape':
            tmp_0 = Key_ESCAPE_getInstance();
            break;
          case 'Backspace':
            tmp_0 = Key_BACKSPACE_getInstance();
            break;
          case 'Delete':
            tmp_0 = Key_DELETE_getInstance();
            break;
          case 'Insert':
            tmp_0 = Key_INSERT_getInstance();
            break;
          case 'Period':
            tmp_0 = Key_PERIOD_getInstance();
            break;
          case 'Comma':
            tmp_0 = Key_COMMA_getInstance();
            break;
          case 'Semicolon':
            tmp_0 = Key_SEMICOLON_getInstance();
            break;
          case 'Slash':
            tmp_0 = Key_SLASH_getInstance();
            break;
          case 'Tab':
            tmp_0 = Key_TAB_getInstance();
            break;
          default:var tmp0_asDynamic_0 = window;
            if (tmp0_asDynamic_0.korgwShowUnsupportedKeys) {
              console.info('' + 'Unsupported key key=' + me.key + ', code=' + me.code);
            } else {
            }

            tmp_0 = Key_UNKNOWN_getInstance();
            break;
        }

        tmp = tmp_0;
        break;
    }
    var key = tmp;
    var tmp1_invoke_0 = $this._get_keyEvent__0_k$();
    var tmp_1 = tmp1_invoke_0;
    var tmp0_subject_2 = me.type;
    var tmp_2;
    switch (tmp0_subject_2) {
      case 'keydown':
        tmp_2 = Type_DOWN_getInstance_0();
        break;
      case 'keyup':
        tmp_2 = Type_UP_getInstance_0();
        break;
      case 'keypress':
        tmp_2 = Type_TYPE_getInstance();
        break;
      default:var tmp0_error_0_3 = '' + 'Unsupported event type ' + me.type;
        throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_3));
    }
    tmp_1._type_16 = tmp_2;
    tmp1_invoke_0._id_18 = 0;
    tmp1_invoke_0._keyCode = me.keyCode;
    tmp1_invoke_0._key_3 = key;
    tmp1_invoke_0._shift_0 = me.shiftKey;
    tmp1_invoke_0._ctrl = me.ctrlKey;
    tmp1_invoke_0._alt = me.altKey;
    tmp1_invoke_0._meta = me.metaKey;
    tmp1_invoke_0._character = numberToChar(me.charCode);
    var tmp2_dispatch_0 = tmp1_invoke_0;
    $this.dispatch_62irmi_k$(getKClass_0(KeyEvent), tmp2_dispatch_0);
    if (key.equals(Key_TAB_getInstance()) ? true : key._get_isFunctionKey__0_k$()) {
      me.preventDefault();
    }}
  function touchEvent($this, e, type) {
    var canvasBounds = $this._get_canvas__0_k$().getBoundingClientRect();
    var tmp0_frame_0 = $this._get_touchBuilder__0_k$();
    var tmp1_frame_0 = Mode_JS_getInstance();
    tmp0_frame_0._mode_4 = tmp1_frame_0;
    tmp0_frame_0.startFrame_p1ymd3_k$(type, false);
    try {
      var inductionVariable = 0;
      var last_1 = e.touches.length;
      if (inductionVariable < last_1)
        do {
          var n_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1_elvis_lhs_5 = e.touches.item(n_3);
          var tmp;
          if (tmp1_elvis_lhs_5 == null) {
            continue;
          } else {
            tmp = tmp1_elvis_lhs_5;
          }
          var touch_4 = tmp;
          var touchId_6 = touch_4.identifier;
          var tmp0_transformEventX_0_7 = touch_4.clientX - canvasBounds.left;
          var tmp_0 = tmp0_transformEventX_0_7 * $this._canvasRatio;
          var tmp1_transformEventY_0_8 = touch_4.clientY - canvasBounds.top;
          var tmp_1 = tmp1_transformEventY_0_8 * $this._canvasRatio;
          var tmp2_unsafeCast_0_10 = touch_4.force;
          var tmp2_elvis_lhs_9 = tmp2_unsafeCast_0_10;
          var tmp_2 = tmp2_elvis_lhs_9 == null ? 1.0 : tmp2_elvis_lhs_9;
          var tmp_3 = Kind_FINGER_getInstance();
          tmp0_frame_0.touch$default_7fqw1w_k$(touchId_6, tmp_0, tmp_1, tmp_2, tmp_3, null, 32, null);
        }
         while (inductionVariable < last_1);
    }finally {
      tmp0_frame_0.endFrame_0_k$();
      Unit_getInstance();
    }
    var tmp2_also_0 = tmp0_frame_0._new;
    Unit_getInstance();
    var tmp3_dispatch_0 = tmp2_also_0;
    $this.dispatch_62irmi_k$(getKClass_0(TouchEvent_0), tmp3_dispatch_0);
  }
  function mouseEvent($this, e, type, pressingType) {
    var canvasBounds = $this._get_canvas__0_k$().getBoundingClientRect();
    var tmp0_transformEventX_0 = e.clientX - canvasBounds.left;
    var tx_0 = numberToInt(tmp0_transformEventX_0 * $this._canvasRatio);
    var tmp1_transformEventY_0 = e.clientY - canvasBounds.top;
    var ty_0 = numberToInt(tmp1_transformEventY_0 * $this._canvasRatio);
    var tmp2_invoke_0 = $this._get_mouseEvent__0_k$();
    tmp2_invoke_0._type_15 = !(e.buttons === 0) ? pressingType : type;
    tmp2_invoke_0._scaleCoords = false;
    tmp2_invoke_0._id_17 = 0;
    tmp2_invoke_0._x_20 = tx_0;
    tmp2_invoke_0._y_19 = ty_0;
    tmp2_invoke_0._button = Companion_getInstance_173().get_ha5a7z_k$(e.button);
    tmp2_invoke_0._buttons = e.buttons;
    tmp2_invoke_0._isShiftDown = e.shiftKey;
    tmp2_invoke_0._isCtrlDown = e.ctrlKey;
    tmp2_invoke_0._isAltDown = e.altKey;
    tmp2_invoke_0._isMetaDown = e.metaKey;
    if (type.equals(Type_SCROLL_getInstance())) {
      var we_2 = e;
      var tmp = tmp2_invoke_0;
      var tmp0_subject_3 = we_2.deltaMode;
      tmp._scrollDeltaMode = tmp0_subject_3 === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp0_subject_3 === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp0_subject_3 === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
      tmp2_invoke_0._scrollDeltaX = we_2.deltaX;
      tmp2_invoke_0._scrollDeltaY = we_2.deltaY;
      tmp2_invoke_0._scrollDeltaZ = we_2.deltaZ;
    }Unit_getInstance();
    if (!$this.is_touch_device_0_k$() ? true : type.equals(Type_SCROLL_getInstance())) {
      var tmp3_dispatch_0 = $this._get_mouseEvent__0_k$();
      $this.dispatch_62irmi_k$(getKClass_0(MouseEvent_0), tmp3_dispatch_0);
    }}
  function mouseEvent$default($this, e, type, pressingType, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      pressingType = type;
    return mouseEvent($this, e, type, pressingType);
  }
  function _get_jsFrame_($this) {
    var tmp = $this._jsFrame;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('jsFrame');
    }
  }
  function _no_name_provided__351(this$0, resultContinuation) {
    this._this$0_87 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__351.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__351.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__351.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._tmp0_safe_receiver0_3 = this._this$0_87._loopJob;
            if (this._tmp0_safe_receiver0_3 == null) {
              this._WHEN_RESULT1_8 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = cancelAndJoin(this._tmp0_safe_receiver0_3, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            var tmp_0 = this;
            tmp_0._WHEN_RESULT1_8 = Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            Unit_getInstance();
            window.close();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__351.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__351(this._this$0_87, completion);
    return i;
  };
  _no_name_provided__351.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__352($entry, this$0, resultContinuation) {
    this._$entry_0 = $entry;
    this._this$0_88 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__352.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__352.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__352.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$entry_0(this._this$0_88, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__352.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__352(this._$entry_0, this._this$0_88, completion);
    return i;
  };
  _no_name_provided__352.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__353(this$0) {
    this._this$0_89 = this$0;
  }
  _no_name_provided__353.prototype.invoke_xfv2uo_k$ = function (it) {
    var tmp = Type_SCROLL_getInstance();
    mouseEvent$default(this._this$0_89, it, tmp, null, 8, null);
  };
  _no_name_provided__353.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__353.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__354(this$0) {
    this._this$0_90 = this$0;
  }
  _no_name_provided__354.prototype.invoke_xfv2uo_k$ = function (it) {
    var tmp = Type_ENTER_getInstance();
    mouseEvent$default(this._this$0_90, it, tmp, null, 8, null);
  };
  _no_name_provided__354.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__354.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__355(this$0) {
    this._this$0_91 = this$0;
  }
  _no_name_provided__355.prototype.invoke_xfv2uo_k$ = function (it) {
    var tmp = Type_EXIT_getInstance();
    mouseEvent$default(this._this$0_91, it, tmp, null, 8, null);
  };
  _no_name_provided__355.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__355.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__356(this$0) {
    this._this$0_92 = this$0;
  }
  _no_name_provided__356.prototype.invoke_xfv2uo_k$ = function (it) {
    mouseEvent(this._this$0_92, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
  };
  _no_name_provided__356.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__356.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__357(this$0) {
    this._this$0_93 = this$0;
  }
  _no_name_provided__357.prototype.invoke_xfv2uo_k$ = function (it) {
    mouseEvent(this._this$0_93, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
  };
  _no_name_provided__357.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__357.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__358(this$0) {
    this._this$0_94 = this$0;
  }
  _no_name_provided__358.prototype.invoke_xfv2uo_k$ = function (it) {
    var tmp = Type_EXIT_getInstance();
    mouseEvent$default(this._this$0_94, it, tmp, null, 8, null);
  };
  _no_name_provided__358.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__358.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__359(this$0) {
    this._this$0_95 = this$0;
  }
  _no_name_provided__359.prototype.invoke_xfv2uo_k$ = function (it) {
    var tmp = Type_UP_getInstance();
    mouseEvent$default(this._this$0_95, it, tmp, null, 8, null);
  };
  _no_name_provided__359.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__359.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__360(this$0) {
    this._this$0_96 = this$0;
  }
  _no_name_provided__360.prototype.invoke_xfv2uo_k$ = function (it) {
    var tmp = Type_DOWN_getInstance();
    mouseEvent$default(this._this$0_96, it, tmp, null, 8, null);
  };
  _no_name_provided__360.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__360.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__361(this$0) {
    this._this$0_97 = this$0;
  }
  _no_name_provided__361.prototype.invoke_xfv2uo_k$ = function (it) {
    var tmp = Type_CLICK_getInstance();
    mouseEvent$default(this._this$0_97, it, tmp, null, 8, null);
  };
  _no_name_provided__361.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__361.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__362(this$0) {
    this._this$0_98 = this$0;
  }
  _no_name_provided__362.prototype.invoke_xfv2uo_k$ = function (it) {
    touchEvent(this._this$0_98, it, Type_START_getInstance());
  };
  _no_name_provided__362.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__362.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__363(this$0) {
    this._this$0_99 = this$0;
  }
  _no_name_provided__363.prototype.invoke_xfv2uo_k$ = function (it) {
    touchEvent(this._this$0_99, it, Type_MOVE_getInstance_0());
  };
  _no_name_provided__363.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__363.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__364(this$0) {
    this._this$0_100 = this$0;
  }
  _no_name_provided__364.prototype.invoke_xfv2uo_k$ = function (it) {
    touchEvent(this._this$0_100, it, Type_END_getInstance());
  };
  _no_name_provided__364.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__364.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__365(this$0) {
    this._this$0_101 = this$0;
  }
  _no_name_provided__365.prototype.invoke_xfv2uo_k$ = function (it) {
    keyEvent(this._this$0_101, it);
  };
  _no_name_provided__365.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__365.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__366(this$0) {
    this._this$0_102 = this$0;
  }
  _no_name_provided__366.prototype.invoke_xfv2uo_k$ = function (it) {
    keyEvent(this._this$0_102, it);
  };
  _no_name_provided__366.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__366.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__367(this$0) {
    this._this$0_103 = this$0;
  }
  _no_name_provided__367.prototype.invoke_xfv2uo_k$ = function (it) {
    keyEvent(this._this$0_103, it);
  };
  _no_name_provided__367.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__367.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__368(this$0) {
    this._this$0_104 = this$0;
  }
  _no_name_provided__368.prototype.invoke_xfv2uo_k$ = function (e) {
    var e_0 = e;
    var tmp0_apply_0 = this._this$0_104._get_gamePadConnectionEvent__0_k$();
    tmp0_apply_0._type_18 = Type_CONNECTED_getInstance();
    tmp0_apply_0._gamepad_1 = e_0.gamepad.index;
    var tmp1_dispatch_0 = tmp0_apply_0;
    this._this$0_104.dispatch_62irmi_k$(getKClass_0(GamePadConnectionEvent), tmp1_dispatch_0);
  };
  _no_name_provided__368.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__368.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__369(this$0) {
    this._this$0_105 = this$0;
  }
  _no_name_provided__369.prototype.invoke_xfv2uo_k$ = function (e) {
    var e_0 = e;
    var tmp0_apply_0 = this._this$0_105._get_gamePadConnectionEvent__0_k$();
    tmp0_apply_0._type_18 = Type_DISCONNECTED_getInstance();
    tmp0_apply_0._gamepad_1 = e_0.gamepad.index;
    var tmp1_dispatch_0 = tmp0_apply_0;
    this._this$0_105.dispatch_62irmi_k$(getKClass_0(GamePadConnectionEvent), tmp1_dispatch_0);
  };
  _no_name_provided__369.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__369.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__370(this$0) {
    this._this$0_106 = this$0;
  }
  _no_name_provided__370.prototype.invoke_xfv2uo_k$ = function (it) {
    onResized(this._this$0_106);
  };
  _no_name_provided__370.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__370.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__371(this$0) {
    this._this$0_107 = this$0;
  }
  _no_name_provided__371.prototype.invoke_qt5vp5_k$ = function (it) {
    this._this$0_107.dispatchDropfileEvent_c1fqem_k$(Type_START_getInstance_0(), null);
  };
  _no_name_provided__371.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qt5vp5_k$(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__371.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__372(this$0) {
    this._this$0_108 = this$0;
  }
  _no_name_provided__372.prototype.invoke_qt5vp5_k$ = function (it) {
    this._this$0_108.dispatchDropfileEvent_c1fqem_k$(Type_END_getInstance_0(), null);
  };
  _no_name_provided__372.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qt5vp5_k$(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__372.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__373(this$0) {
    this._this$0_109 = this$0;
  }
  _no_name_provided__373.prototype.invoke_qt5vp5_k$ = function (it) {
    this._this$0_109.dispatchDropfileEvent_c1fqem_k$(Type_END_getInstance_0(), null);
  };
  _no_name_provided__373.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qt5vp5_k$(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__373.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__374() {
  }
  _no_name_provided__374.prototype.invoke_qt5vp5_k$ = function (it) {
    it.preventDefault();
  };
  _no_name_provided__374.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qt5vp5_k$(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__374.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__375(this$0) {
    this._this$0_110 = this$0;
  }
  _no_name_provided__375.prototype.invoke_qt5vp5_k$ = function (it) {
    this._this$0_110.dispatchDropfileEvent_c1fqem_k$(Type_START_getInstance_0(), null);
  };
  _no_name_provided__375.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qt5vp5_k$(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__375.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__376(this$0) {
    this._this$0_111 = this$0;
  }
  _no_name_provided__376.prototype.invoke_qt5vp5_k$ = function (it) {
    this._this$0_111.dispatchDropfileEvent_c1fqem_k$(Type_END_getInstance_0(), null);
  };
  _no_name_provided__376.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qt5vp5_k$(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__376.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__377(this$0) {
    this._this$0_112 = this$0;
  }
  _no_name_provided__377.prototype.invoke_qt5vp5_k$ = function (it) {
    it.preventDefault();
    this._this$0_112.dispatchDropfileEvent_c1fqem_k$(Type_END_getInstance_0(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    var tmp0_mapNotNull_0 = until(0, items.length);
    var tmp0_mapNotNullTo_0_1 = ArrayList_init_$Create$();
    var inductionVariable = tmp0_mapNotNull_0._get_first__0_k$();
    var last_1 = tmp0_mapNotNull_0._get_last__0_k$();
    if (inductionVariable <= last_1)
      do {
        var element_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver_7 = items[element_2_3];
        var tmp1_safe_receiver_6 = tmp0_safe_receiver_7 == null ? null : tmp0_safe_receiver_7.getAsFile();
        var tmp0_safe_receiver_2_4_4 = tmp1_safe_receiver_6 == null ? null : toVfs(tmp1_safe_receiver_6);
        if (tmp0_safe_receiver_2_4_4 == null)
          null;
        else {
          tmp0_mapNotNullTo_0_1.add_2bq_k$(tmp0_safe_receiver_2_4_4);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
       while (!(element_2_3 === last_1));
    var files = tmp0_mapNotNullTo_0_1;
    this._this$0_112.dispatchDropfileEvent_c1fqem_k$(Type_DROP_getInstance(), files);
  };
  _no_name_provided__377.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qt5vp5_k$(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__377.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__378(this$0) {
    this._this$0_113 = this$0;
  }
  _no_name_provided__378.prototype.invoke_okcceq_k$ = function (step_0) {
    var startTime = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
    window.requestAnimationFrame(_get_jsFrame_(this._this$0_113));
    Unit_getInstance();
    updateGamepad(this._this$0_113);
    try {
      doRender(this._this$0_113);
    }finally {
      var elapsed = TimeSpan__minus_impl(PerformanceCounter_getInstance()._get_reference__nsqrdp_k$(), startTime);
      var available = TimeSpan__minus_impl(this._this$0_113._get_counterTimePerFrame__nsqrdp_k$(), elapsed);
      this._this$0_113._get_coroutineDispatcher__0_k$().executePending_zah5t7_k$(available);
    }
  };
  _no_name_provided__378.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__378.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $loopCOROUTINE$2(_this_, entry, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__137 = _this_;
    this._entry_2 = entry;
  }
  $loopCOROUTINE$2.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__137.getCoroutineDispatcherWithCurrentContext_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = launchImmediately(ARGUMENT, _no_name_provided_$factory_323(this._entry_2, this.__this__137, null));
            this.__this__137._loopJob = ARGUMENT_0;
            _get_jsFrame_(this.__this__137)(0.0);
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loopCOROUTINE$2.$metadata$ = {
    simpleName: '$loopCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function BrowserGameWindow() {
    GameWindow.call(this);
    var tmp = this;
    var tmp_0 = AGConfig_init_$Create$(false, 1, null);
    tmp._ag_1 = AGWebgl_init_$Create$(tmp_0, null, 2, null);
    this._isTouchDeviceCache = null;
    this._quality_1 = Quality_AUTOMATIC_getInstance();
    this._canvasRatio = 1.0;
    this._cursor_0 = Cursor_DEFAULT_getInstance();
    this._icon_0 = null;
    this._loopJob = null;
    var tmp0_asDynamic_0 = window;
    tmp0_asDynamic_0.canvas = this._get_canvas__0_k$();
    var tmp1_asDynamic_0 = window;
    tmp1_asDynamic_0.ag = this._get_ag__0_k$();
    var tmp2_asDynamic_0 = window;
    tmp2_asDynamic_0.gl = this._get_ag__0_k$()._get_gl__0_k$();
    if (_get_isCanvasCreatedAndHandled_()) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(this._get_canvas__0_k$());
      Unit_getInstance();
      var tmp1_safe_receiver = document.body;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
      if (tmp2_safe_receiver == null) {
        Unit_getInstance();
      } else
        tmp2_safe_receiver.margin = '0px';
      var tmp3_safe_receiver = document.body;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
      if (tmp4_safe_receiver == null) {
        Unit_getInstance();
      } else
        tmp4_safe_receiver.padding = '0px';
      var tmp5_safe_receiver = document.body;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
      if (tmp6_safe_receiver == null) {
        Unit_getInstance();
      } else
        tmp6_safe_receiver.overflowX = 'hidden';
      var tmp7_safe_receiver = document.body;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
      if (tmp8_safe_receiver == null) {
        Unit_getInstance();
      } else
        tmp8_safe_receiver.overflowY = 'hidden';
    }var tmp_1 = this._get_canvas__0_k$();
    tmp_1.addEventListener('wheel', _no_name_provided_$factory_296(this));
    var tmp_2 = this._get_canvas__0_k$();
    tmp_2.addEventListener('mouseenter', _no_name_provided_$factory_297(this));
    var tmp_3 = this._get_canvas__0_k$();
    tmp_3.addEventListener('mouseleave', _no_name_provided_$factory_298(this));
    var tmp_4 = this._get_canvas__0_k$();
    tmp_4.addEventListener('mouseover', _no_name_provided_$factory_299(this));
    var tmp_5 = this._get_canvas__0_k$();
    tmp_5.addEventListener('mousemove', _no_name_provided_$factory_300(this));
    var tmp_6 = this._get_canvas__0_k$();
    tmp_6.addEventListener('mouseout', _no_name_provided_$factory_301(this));
    var tmp_7 = this._get_canvas__0_k$();
    tmp_7.addEventListener('mouseup', _no_name_provided_$factory_302(this));
    var tmp_8 = this._get_canvas__0_k$();
    tmp_8.addEventListener('mousedown', _no_name_provided_$factory_303(this));
    var tmp_9 = this._get_canvas__0_k$();
    tmp_9.addEventListener('click', _no_name_provided_$factory_304(this));
    var tmp_10 = this._get_canvas__0_k$();
    tmp_10.addEventListener('touchstart', _no_name_provided_$factory_305(this));
    var tmp_11 = this._get_canvas__0_k$();
    tmp_11.addEventListener('touchmove', _no_name_provided_$factory_306(this));
    var tmp_12 = this._get_canvas__0_k$();
    tmp_12.addEventListener('touchend', _no_name_provided_$factory_307(this));
    var tmp_13 = window;
    tmp_13.addEventListener('keypress', _no_name_provided_$factory_308(this));
    var tmp_14 = window;
    tmp_14.addEventListener('keydown', _no_name_provided_$factory_309(this));
    var tmp_15 = window;
    tmp_15.addEventListener('keyup', _no_name_provided_$factory_310(this));
    var tmp_16 = window;
    tmp_16.addEventListener('gamepadconnected', _no_name_provided_$factory_311(this));
    var tmp_17 = window;
    tmp_17.addEventListener('gamepaddisconnected', _no_name_provided_$factory_312(this));
    var tmp_18 = window;
    tmp_18.addEventListener('resize', _no_name_provided_$factory_313(this));
    var tmp_19 = this._get_canvas__0_k$();
    tmp_19.ondragenter = _no_name_provided_$factory_314(this);
    var tmp_20 = this._get_canvas__0_k$();
    tmp_20.ondragexit = _no_name_provided_$factory_315(this);
    var tmp_21 = this._get_canvas__0_k$();
    tmp_21.ondragleave = _no_name_provided_$factory_316(this);
    var tmp_22 = this._get_canvas__0_k$();
    tmp_22.ondragover = _no_name_provided_$factory_317();
    var tmp_23 = this._get_canvas__0_k$();
    tmp_23.ondragstart = _no_name_provided_$factory_318(this);
    var tmp_24 = this._get_canvas__0_k$();
    tmp_24.ondragend = _no_name_provided_$factory_319(this);
    var tmp_25 = this._get_canvas__0_k$();
    tmp_25.ondrop = _no_name_provided_$factory_320(this);
    onResized(this);
    var tmp_26 = this;
    tmp_26._jsFrame = _no_name_provided_$factory_321(this);
  }
  BrowserGameWindow.prototype._get_ag__0_k$ = function () {
    return this._ag_1;
  };
  BrowserGameWindow.prototype._get_canvas__0_k$ = function () {
    return this._get_ag__0_k$()._get_canvas__0_k$();
  };
  BrowserGameWindow.prototype.is_touch_device_0_k$ = function () {
    if (this._isTouchDeviceCache == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        Unit_getInstance();
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        {
          tmp_1 = false;
        }
        tmp_0 = tmp_1;
      }
      tmp._isTouchDeviceCache = tmp_0;
    }return ensureNotNull(this._isTouchDeviceCache);
  };
  BrowserGameWindow.prototype._set_quality__twhgp3_k$ = function (value) {
    if (!this._quality_1.equals(value)) {
      this._quality_1 = value;
      onResized(this);
    }};
  BrowserGameWindow.prototype._get_quality__0_k$ = function () {
    return this._quality_1;
  };
  BrowserGameWindow.prototype._set_title__a4enbm_k$ = function (value) {
    document.title = value;
  };
  BrowserGameWindow.prototype._get_width__0_k$ = function () {
    return this._get_canvas__0_k$().clientWidth;
  };
  BrowserGameWindow.prototype._get_height__0_k$ = function () {
    return this._get_canvas__0_k$().clientHeight;
  };
  BrowserGameWindow.prototype._set_cursor__gde21z_k$ = function (value) {
    this._cursor_0 = value;
    var tmp = this._get_canvas__0_k$().style;
    var tmp0_subject = value;
    var tmp_0;
    if (tmp0_subject instanceof Cursor) {
      var tmp1_subject = value;
      tmp_0 = tmp1_subject.equals(Cursor_DEFAULT_getInstance()) ? 'default' : tmp1_subject.equals(Cursor_CROSSHAIR_getInstance()) ? 'crosshair' : tmp1_subject.equals(Cursor_TEXT_getInstance()) ? 'text' : tmp1_subject.equals(Cursor_HAND_getInstance()) ? 'pointer' : tmp1_subject.equals(Cursor_MOVE_getInstance()) ? 'move' : tmp1_subject.equals(Cursor_WAIT_getInstance()) ? 'wait' : tmp1_subject.equals(Cursor_RESIZE_EAST_getInstance()) ? 'e-resize' : tmp1_subject.equals(Cursor_RESIZE_WEST_getInstance()) ? 'w-resize' : tmp1_subject.equals(Cursor_RESIZE_SOUTH_getInstance()) ? 's-resize' : tmp1_subject.equals(Cursor_RESIZE_NORTH_getInstance()) ? 'n-resize' : tmp1_subject.equals(Cursor_RESIZE_NORTH_EAST_getInstance()) ? 'ne-resize' : tmp1_subject.equals(Cursor_RESIZE_NORTH_WEST_getInstance()) ? 'nw-resize' : tmp1_subject.equals(Cursor_RESIZE_SOUTH_EAST_getInstance()) ? 'se-resize' : tmp1_subject.equals(Cursor_RESIZE_SOUTH_WEST_getInstance()) ? 'sw-resize' : 'default';
    } else {
      {
        tmp_0 = 'default';
      }
    }
    tmp.cursor = tmp_0;
  };
  BrowserGameWindow.prototype._get_cursor__0_k$ = function () {
    return this._cursor_0;
  };
  BrowserGameWindow.prototype._set_icon__1l3fil_k$ = function (value) {
    this._icon_0 = value;
    if (!(value == null)) {
      var tmp0_unsafeCast_0 = document.querySelector("link[rel*='icon']");
      var link = tmp0_unsafeCast_0;
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      var tmp = PNG_getInstance();
      link.href = 'data:image/png;base64,' + toBase64(tmp.encode$default_tm5rke_k$(value, null, 2, null));
      var tmp1_get_0 = document.getElementsByTagName('head');
      var tmp0_safe_receiver = tmp1_get_0[0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
      Unit_getInstance();
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  };
  BrowserGameWindow.prototype._set_fullscreen__rpwsgn_k$ = function (value) {
    if (!(this._get_fullscreen__0_k$() === value)) {
      try {
        var tmp0_success_0_1 = Companion_getInstance_3();
        var tmp;
        if (value) {
          tmp = this._get_canvas__0_k$().requestFullscreen();
        } else {
          tmp = document.exitFullscreen();
        }
        var tmp1_success_0_2 = tmp;
        _Result___init__impl_(tmp1_success_0_2);
      } catch ($p) {
        if ($p instanceof Error) {
          var tmp2_failure_0_4 = Companion_getInstance_3();
          _Result___init__impl_(createFailure($p));
        } else {
          {
            throw $p;
          }
        }
      }
      Unit_getInstance();
    }};
  BrowserGameWindow.prototype._get_fullscreen__0_k$ = function () {
    return !(document.fullscreenElement == null);
  };
  BrowserGameWindow.prototype._set_visible__rpwsgn_k$ = function (value) {
    return this._get_canvas__0_k$().style.visibility = value ? 'visible' : 'hidden';
  };
  BrowserGameWindow.prototype.setSize_rvwcgf_k$ = function (width, height) {
  };
  BrowserGameWindow.prototype.close_sv8swh_k$ = function () {
    GameWindow.prototype.close_sv8swh_k$.call(this);
    var tmp = this._get_coroutineDispatcher__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_322(this, null));
    Unit_getInstance();
    this._loopJob = null;
  };
  BrowserGameWindow.prototype.loop_59tp16_k$ = function (entry, $cont) {
    var tmp = new $loopCOROUTINE$2(this, entry, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  BrowserGameWindow.$metadata$ = {
    simpleName: 'BrowserGameWindow',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_296(this$0) {
    var i = new _no_name_provided__353(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_297(this$0) {
    var i = new _no_name_provided__354(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_298(this$0) {
    var i = new _no_name_provided__355(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_299(this$0) {
    var i = new _no_name_provided__356(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_300(this$0) {
    var i = new _no_name_provided__357(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_301(this$0) {
    var i = new _no_name_provided__358(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_302(this$0) {
    var i = new _no_name_provided__359(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_303(this$0) {
    var i = new _no_name_provided__360(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_304(this$0) {
    var i = new _no_name_provided__361(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_305(this$0) {
    var i = new _no_name_provided__362(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_306(this$0) {
    var i = new _no_name_provided__363(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_307(this$0) {
    var i = new _no_name_provided__364(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_308(this$0) {
    var i = new _no_name_provided__365(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_309(this$0) {
    var i = new _no_name_provided__366(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_310(this$0) {
    var i = new _no_name_provided__367(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_311(this$0) {
    var i = new _no_name_provided__368(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_312(this$0) {
    var i = new _no_name_provided__369(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_313(this$0) {
    var i = new _no_name_provided__370(this$0);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_314(this$0) {
    var i = new _no_name_provided__371(this$0);
    return function (p1) {
      i.invoke_qt5vp5_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_315(this$0) {
    var i = new _no_name_provided__372(this$0);
    return function (p1) {
      i.invoke_qt5vp5_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_316(this$0) {
    var i = new _no_name_provided__373(this$0);
    return function (p1) {
      i.invoke_qt5vp5_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_317() {
    var i = new _no_name_provided__374();
    return function (p1) {
      i.invoke_qt5vp5_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_318(this$0) {
    var i = new _no_name_provided__375(this$0);
    return function (p1) {
      i.invoke_qt5vp5_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_319(this$0) {
    var i = new _no_name_provided__376(this$0);
    return function (p1) {
      i.invoke_qt5vp5_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_320(this$0) {
    var i = new _no_name_provided__377(this$0);
    return function (p1) {
      i.invoke_qt5vp5_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_321(this$0) {
    var i = new _no_name_provided__378(this$0);
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_322(this$0, resultContinuation) {
    var i = new _no_name_provided__351(this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_323($entry, this$0, resultContinuation) {
    var i = new _no_name_provided__352($entry, this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function knownControllers$init$() {
    var tmp0_associateBy_0 = listOf([Companion_getInstance_171(), Nimbus_111_1420_Safari_GamepadMapping_getInstance()]);
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateBy_0, 10)), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = tmp0_associateBy_0.iterator_0_k$();
    while (tmp0_iterator_1_3.hasNext_0_k$()) {
      var element_2_4 = tmp0_iterator_1_3.next_0_k$();
      tmp0_associateByTo_0_2.put_1q9pf_k$(element_2_4._get_id__0_k$(), element_2_4);
      Unit_getInstance();
    }
    return tmp0_associateByTo_0_2;
  }
  var DEFAULT_UI_FACTORY;
  function _get_defaultAudioFormats_() {
    var tmp0_getValue_0 = defaultAudioFormats$factory();
    return defaultAudioFormats$delegate._get_value__0_k$();
  }
  var defaultAudioFormats$delegate;
  function Companion_180() {
    Companion_instance_179 = this;
  }
  Companion_180.prototype.invoke_p8qwsp_k$ = function (formats) {
    return (new AudioFormats()).register_p8qwsp_k$(formats.slice());
  };
  Companion_180.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_179;
  function Companion_getInstance_179() {
    if (Companion_instance_179 == null)
      new Companion_180();
    return Companion_instance_179;
  }
  function $tryReadInfoCOROUTINE$0(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__138 = _this_;
    this._data_32 = data;
    this._props_1 = props;
  }
  $tryReadInfoCOROUTINE$0.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._tmp0_iterator0_0 = this.__this__138._formats_2.iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator0_0.hasNext_0_k$()) {
              this._state_1 = 6;
              continue $sm;
            }
            this._format1 = this._tmp0_iterator0_0.next_0_k$();
            this._exceptionState = 4;
            this._state_1 = 2;
            suspendResult = this._format1.tryReadInfo_bfyly4_k$(this._data_32.duplicate_0_k$(), this._props_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = suspendResult;
            var WHEN_RESULT;
            if (tmp1_elvis_lhs == null) {
              this._exceptionState = 7;
              this._state_1 = 1;
              continue $sm;
            } else {
              WHEN_RESULT = tmp1_elvis_lhs;
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            return WHEN_RESULT;
          case 4:
            this._exceptionState = 7;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              printStackTrace_0(e);
              this._state_1 = 5;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 5:
            this._exceptionState = 7;
            this._state_1 = 1;
            continue $sm;
          case 6:
            return null;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tryReadInfoCOROUTINE$0.$metadata$ = {
    simpleName: '$tryReadInfoCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $decodeStreamCOROUTINE$1(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__139 = _this_;
    this._data_33 = data;
    this._props_2 = props;
  }
  $decodeStreamCOROUTINE$1.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._tmp0_iterator0_1 = this.__this__139._formats_2.iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator0_1.hasNext_0_k$()) {
              this._state_1 = 8;
              continue $sm;
            }
            this._format1_0 = this._tmp0_iterator0_1.next_0_k$();
            this._exceptionState = 6;
            this._state_1 = 2;
            suspendResult = this._format1_0.tryReadInfo_bfyly4_k$(this._data_33.duplicate_0_k$(), Companion_getInstance_180()._FAST_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT2_3 = suspendResult;
            if (this._ARGUMENT2_3 == null) {
              this._exceptionState = 9;
              this._state_1 = 1;
              continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._state_1 = 4;
            suspendResult = this._format1_0.decodeStream_bfyly4_k$(this._data_33.duplicate_0_k$(), this._props_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var tmp1_elvis_lhs = suspendResult;
            var WHEN_RESULT;
            if (tmp1_elvis_lhs == null) {
              this._exceptionState = 9;
              this._state_1 = 1;
              continue $sm;
            } else {
              WHEN_RESULT = tmp1_elvis_lhs;
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            return WHEN_RESULT;
          case 6:
            this._exceptionState = 9;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              printStackTrace_0(e);
              this._state_1 = 7;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 7:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 8:
            return null;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeStreamCOROUTINE$1.$metadata$ = {
    simpleName: '$decodeStreamCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $decodeStreamOrErrorCOROUTINE$2(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__140 = _this_;
    this._data_34 = data;
    this._props_3 = props;
  }
  $decodeStreamOrErrorCOROUTINE$2.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__140.decodeStream_bfyly4_k$(this._data_34, this._props_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              var tmp0_error_0 = '' + "Can't decode audio stream [" + this.__this__140._formats_2 + ']';
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            return tmp_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeStreamOrErrorCOROUTINE$2.$metadata$ = {
    simpleName: '$decodeStreamOrErrorCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function AudioFormats() {
    Companion_getInstance_179();
    AudioFormat.call(this, []);
    var tmp = this;
    tmp._formats_2 = LinkedHashSet_init_$Create$();
  }
  AudioFormats.prototype.register_p8qwsp_k$ = function (formats) {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._formats_2;
    addAll_0(tmp0_plusAssign_0_3, formats);
    Unit_getInstance();
    return this;
  };
  AudioFormats.prototype.tryReadInfo_bfyly4_k$ = function (data, props, $cont) {
    var tmp = new $tryReadInfoCOROUTINE$0(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AudioFormats.prototype.decodeStream_bfyly4_k$ = function (data, props, $cont) {
    var tmp = new $decodeStreamCOROUTINE$1(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AudioFormats.prototype.decodeStreamOrError_bfyly4_k$ = function (data, props, $cont) {
    var tmp = new $decodeStreamOrErrorCOROUTINE$2(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AudioFormats.prototype.encode_ub8akz_k$ = function (data, out, filename, props, $cont) {
    var ext = _get_extensionLC_(_PathInfo___init__impl_(filename));
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._formats_2;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (element_2._extensions_0.contains_2bq_k$(ext)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_elvis_lhs = tmp$ret$0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw UnsupportedOperationException_init_$Create$_0('' + "Don't know how to generate file for extension '" + ext + "'");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var format_0 = tmp;
    return format_0.encode$default_6xmvo0_k$(data, out, filename, null, 8, null, $cont);
  };
  AudioFormats.$metadata$ = {
    simpleName: 'AudioFormats',
    kind: 'class',
    interfaces: []
  };
  function standardAudioFormats() {
    return Companion_getInstance_179().invoke_p8qwsp_k$([Companion_getInstance_186(), Companion_getInstance_185(), Companion_getInstance_182()]);
  }
  function Info_init_$Init$(duration, channels, decodingTime, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      duration = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    }if (!(($mask0 & 2) === 0))
      channels = 2;
    if (!(($mask0 & 4) === 0))
      decodingTime = null;
    Info_0.call($this, duration, channels, decodingTime);
    return $this;
  }
  function Info_init_$Create$(duration, channels, decodingTime, $mask0, $marker) {
    return Info_init_$Init$(duration, channels, decodingTime, $mask0, $marker, Object.create(Info_0.prototype));
  }
  function Info_0(duration, channels, decodingTime) {
    this._duration = duration;
    this._channels = channels;
    this._decodingTime = decodingTime;
    var tmp = this;
    tmp._$$delegate_0_28 = Mixin_init_$Create$(null, 1, null);
  }
  Info_0.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_28._set_extra__n1onou_k$(_set___);
  };
  Info_0.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_28._get_extra__0_k$();
  };
  Info_0.prototype.toString = function () {
    return '' + 'Info(duration=' + _get_niceStr__4(_TimeSpan___get_milliseconds__impl_(this._duration)) + 'ms, channels=' + this._channels + ')';
  };
  Info_0.prototype.hashCode = function () {
    var result = TimeSpan__hashCode_impl(this._duration);
    result = imul(result, 31) + this._channels | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this._decodingTime;
    if ((tmp_1 == null ? null : new TimeSpan(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      {
        tmp_0 = TimeSpan__hashCode_impl(this._decodingTime);
      }
    }
    result = tmp + tmp_0 | 0;
    return result;
  };
  Info_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Info_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Info_0 ? other : THROW_CCE();
    if (!equals_1(new TimeSpan(this._duration), new TimeSpan(tmp0_other_with_cast._duration)))
      return false;
    if (!(this._channels === tmp0_other_with_cast._channels))
      return false;
    var tmp = this._decodingTime;
    var tmp_0 = tmp == null ? null : new TimeSpan(tmp);
    var tmp_1 = tmp0_other_with_cast._decodingTime;
    if (!equals_1(tmp_0, tmp_1 == null ? null : new TimeSpan(tmp_1)))
      return false;
    else {
    }
    return true;
  };
  Info_0.$metadata$ = {
    simpleName: 'Info',
    kind: 'class',
    interfaces: [Extra]
  };
  function $encodeToByteArrayCOROUTINE$5(_this_, data, filename, format_0, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__141 = _this_;
    this._data_35 = data;
    this._filename_1 = filename;
    this._format_1 = format_0;
    this._props_4 = props;
  }
  $encodeToByteArrayCOROUTINE$5.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._buffer_10_1 = ByteArrayBuilder_init_$Create$_0(4096);
            this._s_21_0 = MemorySyncStream(this._buffer_10_1);
            this._state_1 = 1;
            suspendResult = this._format_1.encode_ub8akz_k$(this._data_35, toAsync(this._s_21_0), this._filename_1, this._props_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return this._buffer_10_1.toByteArray_0_k$();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $encodeToByteArrayCOROUTINE$5.$metadata$ = {
    simpleName: '$encodeToByteArrayCOROUTINE$5',
    kind: 'class',
    interfaces: []
  };
  function AudioFormat(exts) {
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(exts.length);
    var indexedObject = exts;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_trim_0_5 = item_2_3.toLowerCase();
      tmp0_mapTo_0_1.add_2bq_k$(toString_1(trim_0(isCharSequence(tmp0_trim_0_5) ? tmp0_trim_0_5 : THROW_CCE())));
      Unit_getInstance();
    }
    tmp._extensions_0 = toSet_0(tmp0_mapTo_0_1);
  }
  AudioFormat.prototype.tryReadInfo_bfyly4_k$ = function (data, props, $cont) {
    return null;
  };
  AudioFormat.prototype.decodeStream_bfyly4_k$ = function (data, props, $cont) {
    return null;
  };
  AudioFormat.prototype.encode_ub8akz_k$ = function (data, out, filename, props, $cont) {
    unsupported_0();
  };
  AudioFormat.prototype.encode$default_6xmvo0_k$ = function (data, out, filename, props, $mask0, $handler, $cont) {
    if (!(($mask0 & 8) === 0))
      props = Companion_getInstance_181()._DEFAULT_4;
    return $handler == null ? this.encode_ub8akz_k$(data, out, filename, props, $cont) : $handler(data, out, filename, props);
  };
  AudioFormat.prototype.encodeToByteArray_8o1byd_k$ = function (data, filename, format_0, props, $cont) {
    var tmp = new $encodeToByteArrayCOROUTINE$5(this, data, filename, format_0, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AudioFormat.prototype.encodeToByteArray$default_cbf3hi_k$ = function (data, filename, format_0, props, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      filename = 'out.wav';
    if (!(($mask0 & 4) === 0))
      format_0 = this;
    if (!(($mask0 & 8) === 0))
      props = Companion_getInstance_181()._DEFAULT_4;
    return this.encodeToByteArray_8o1byd_k$(data, filename, format_0, props, $cont);
  };
  AudioFormat.prototype.toString = function () {
    return '' + 'AudioFormat(' + sorted(this._extensions_0) + ')';
  };
  AudioFormat.$metadata$ = {
    simpleName: 'AudioFormat',
    kind: 'class',
    interfaces: []
  };
  function AudioDecodingProps_init_$Init$(exactTimings, readInMemory, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      exactTimings = null;
    if (!(($mask0 & 2) === 0))
      readInMemory = true;
    AudioDecodingProps.call($this, exactTimings, readInMemory);
    return $this;
  }
  function AudioDecodingProps_init_$Create$(exactTimings, readInMemory, $mask0, $marker) {
    return AudioDecodingProps_init_$Init$(exactTimings, readInMemory, $mask0, $marker, Object.create(AudioDecodingProps.prototype));
  }
  function Companion_181() {
    Companion_instance_180 = this;
    var tmp = this;
    tmp._DEFAULT_3 = AudioDecodingProps_init_$Create$(null, false, 3, null);
    this._FAST_0 = new AudioDecodingProps(false, false);
  }
  Companion_181.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_180;
  function Companion_getInstance_180() {
    if (Companion_instance_180 == null)
      new Companion_181();
    return Companion_instance_180;
  }
  function AudioDecodingProps(exactTimings, readInMemory) {
    Companion_getInstance_180();
    this._exactTimings = exactTimings;
    this._readInMemory = readInMemory;
  }
  AudioDecodingProps.$metadata$ = {
    simpleName: 'AudioDecodingProps',
    kind: 'class',
    interfaces: []
  };
  function AudioEncodingProps_init_$Init$(quality, filename, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      quality = 0.84;
    if (!(($mask0 & 2) === 0))
      filename = null;
    AudioEncodingProps.call($this, quality, filename);
    return $this;
  }
  function AudioEncodingProps_init_$Create$(quality, filename, $mask0, $marker) {
    return AudioEncodingProps_init_$Init$(quality, filename, $mask0, $marker, Object.create(AudioEncodingProps.prototype));
  }
  function Companion_182() {
    Companion_instance_181 = this;
    var tmp = this;
    tmp._DEFAULT_4 = AudioEncodingProps_init_$Create$(0.0, null, 3, null);
  }
  Companion_182.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_181;
  function Companion_getInstance_181() {
    if (Companion_instance_181 == null)
      new Companion_182();
    return Companion_instance_181;
  }
  function AudioEncodingProps(quality, filename) {
    Companion_getInstance_181();
    this._quality_2 = quality;
    this._filename_2 = filename;
  }
  AudioEncodingProps.$metadata$ = {
    simpleName: 'AudioEncodingProps',
    kind: 'class',
    interfaces: []
  };
  function invalidAudioFormat(message) {
    throw new InvalidAudioFormatException(message);
  }
  function InvalidAudioFormatException(message) {
    RuntimeException_init_$Init$_0(message, this);
    captureStack(this, InvalidAudioFormatException);
  }
  InvalidAudioFormatException.$metadata$ = {
    simpleName: 'InvalidAudioFormatException',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__379() {
  }
  _no_name_provided__379.prototype.invoke_0_k$ = function () {
    return standardAudioFormats();
  };
  _no_name_provided__379.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function defaultAudioFormats$factory() {
    return getPropertyCallableRef('defaultAudioFormats', 0, KProperty0, function () {
      return _get_defaultAudioFormats_();
    }, null);
  }
  function _no_name_provided_$factory_324() {
    var i = new _no_name_provided__379();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function Companion_183() {
    Companion_instance_182 = this;
    MP3.call(this);
  }
  Companion_183.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_182;
  function Companion_getInstance_182() {
    if (Companion_instance_182 == null)
      new Companion_183();
    return Companion_instance_182;
  }
  function MP3() {
    Companion_getInstance_182();
    MP3Base.call(this);
  }
  MP3.$metadata$ = {
    simpleName: 'MP3',
    kind: 'class',
    interfaces: []
  };
  var ChannelMode_STEREO_instance;
  var ChannelMode_JOINT_STEREO_instance;
  var ChannelMode_DUAL_CHANNEL_instance;
  var ChannelMode_SINGLE_CHANNEL_instance;
  function Companion_184() {
    Companion_instance_183 = this;
    var tmp = this;
    var tmp0_map_0 = values_11();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0.length);
    var indexedObject = tmp0_map_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_2bq_k$(to(item_2_3._id_24, item_2_3));
      Unit_getInstance();
    }
    tmp._BY_ID_1 = toMap_0(tmp0_mapTo_0_1);
  }
  Companion_184.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_183;
  function Companion_getInstance_183() {
    if (Companion_instance_183 == null)
      new Companion_184();
    return Companion_instance_183;
  }
  function values_11() {
    return [ChannelMode_STEREO_getInstance(), ChannelMode_JOINT_STEREO_getInstance(), ChannelMode_DUAL_CHANNEL_getInstance(), ChannelMode_SINGLE_CHANNEL_getInstance()];
  }
  var ChannelMode_entriesInitialized;
  function ChannelMode_initEntries() {
    if (ChannelMode_entriesInitialized)
      return Unit_getInstance();
    ChannelMode_entriesInitialized = true;
    ChannelMode_STEREO_instance = new ChannelMode('STEREO', 0, 0, 2);
    ChannelMode_JOINT_STEREO_instance = new ChannelMode('JOINT_STEREO', 1, 1, 1);
    ChannelMode_DUAL_CHANNEL_instance = new ChannelMode('DUAL_CHANNEL', 2, 2, 2);
    ChannelMode_SINGLE_CHANNEL_instance = new ChannelMode('SINGLE_CHANNEL', 3, 3, 1);
    Companion_getInstance_183();
  }
  function ChannelMode(name, ordinal, id, channels) {
    Enum.call(this, name, ordinal);
    this._id_24 = id;
    this._channels_0 = channels;
  }
  ChannelMode.$metadata$ = {
    simpleName: 'ChannelMode',
    kind: 'class',
    interfaces: []
  };
  function Mp3Info(version, layer, bitrate, samplingRate, channelMode, frameSize, samples) {
    this._version_2 = version;
    this._layer_0 = layer;
    this._bitrate = bitrate;
    this._samplingRate = samplingRate;
    this._channelMode = channelMode;
    this._frameSize = frameSize;
    this._samples = samples;
  }
  Mp3Info.prototype.toString = function () {
    return '' + 'Mp3Info(version=' + this._version_2 + ', layer=' + this._layer_0 + ', bitrate=' + this._bitrate + ', samplingRate=' + this._samplingRate + ', channelMode=' + this._channelMode + ', frameSize=' + this._frameSize + ', samples=' + this._samples + ')';
  };
  Mp3Info.prototype.hashCode = function () {
    var result = getStringHashCode(this._version_2);
    result = imul(result, 31) + this._layer_0 | 0;
    result = imul(result, 31) + this._bitrate | 0;
    result = imul(result, 31) + this._samplingRate | 0;
    result = imul(result, 31) + this._channelMode.hashCode() | 0;
    result = imul(result, 31) + this._frameSize | 0;
    result = imul(result, 31) + this._samples | 0;
    return result;
  };
  Mp3Info.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mp3Info))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Mp3Info ? other : THROW_CCE();
    if (!(this._version_2 === tmp0_other_with_cast._version_2))
      return false;
    if (!(this._layer_0 === tmp0_other_with_cast._layer_0))
      return false;
    if (!(this._bitrate === tmp0_other_with_cast._bitrate))
      return false;
    if (!(this._samplingRate === tmp0_other_with_cast._samplingRate))
      return false;
    if (!this._channelMode.equals(tmp0_other_with_cast._channelMode))
      return false;
    if (!(this._frameSize === tmp0_other_with_cast._frameSize))
      return false;
    if (!(this._samples === tmp0_other_with_cast._samples))
      return false;
    return true;
  };
  Mp3Info.$metadata$ = {
    simpleName: 'Mp3Info',
    kind: 'class',
    interfaces: []
  };
  function framesize($this, layer, bitrate, sample_rate, padding_bit) {
    var tmp;
    if (layer === 1) {
      tmp = imul((imul(imul(12, bitrate), 1000) / sample_rate | 0) + padding_bit | 0, 4);
    } else {
      tmp = (imul(imul(144, bitrate), 1000) / sample_rate | 0) + padding_bit | 0;
    }
    return tmp;
  }
  function ChannelMode_STEREO_getInstance() {
    ChannelMode_initEntries();
    return ChannelMode_STEREO_instance;
  }
  function ChannelMode_JOINT_STEREO_getInstance() {
    ChannelMode_initEntries();
    return ChannelMode_JOINT_STEREO_instance;
  }
  function ChannelMode_DUAL_CHANNEL_getInstance() {
    ChannelMode_initEntries();
    return ChannelMode_DUAL_CHANNEL_instance;
  }
  function ChannelMode_SINGLE_CHANNEL_getInstance() {
    ChannelMode_initEntries();
    return ChannelMode_SINGLE_CHANNEL_instance;
  }
  function _getDuration($this, use_cbr_estimate, emit, $cont) {
    var tmp = new $_getDurationCOROUTINE$8($this, use_cbr_estimate, emit, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    var tmp_0 = tmp.doResume_0_k$();
    if (tmp_0 === _get_COROUTINE_SUSPENDED_())
      return tmp_0;
    return tmp_0._milliseconds;
  }
  function _getDuration$default($this, use_cbr_estimate, emit, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      emit = null;
    return _getDuration($this, use_cbr_estimate, emit, $cont);
  }
  function estimateDuration($this, bitrate, channels, offset_0, $cont) {
    var kbps = imul(bitrate, 1000) / 8 | 0;
    var tmp0_minus_0 = $this._dataLength;
    var dataSize = tmp0_minus_0.minus_wiekkq_k$(toLong(offset_0));
    var tmp1_times_0 = 2 / channels | 0;
    var tmp2_div_0 = dataSize.times_wiekkq_k$(toLong(tmp1_times_0)).times_wiekkq_k$(new Long(1000000, 0));
    return tmp2_div_0.div_wiekkq_k$(toLong(kbps));
  }
  function skipID3v2Tag($this, block, $cont) {
    var tmp = new $skipID3v2TagCOROUTINE$9($this, block, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function Companion_185() {
    Companion_instance_184 = this;
    var tmp = this;
    tmp._versions = ['2.5', 'x', '2', '1'];
    var tmp_0 = this;
    tmp_0._layers_1 = new Int32Array([-1, 3, 2, 1]);
    var tmp_1 = this;
    var tmp_2 = this.getBitrateKey_27zxwg_k$(1, 1);
    var tmp_3 = to(tmp_2, new Int32Array([0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448]));
    var tmp_4 = this.getBitrateKey_27zxwg_k$(1, 2);
    var tmp_5 = to(tmp_4, new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384]));
    var tmp_6 = this.getBitrateKey_27zxwg_k$(1, 3);
    var tmp_7 = to(tmp_6, new Int32Array([0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320]));
    var tmp_8 = this.getBitrateKey_27zxwg_k$(2, 1);
    var tmp_9 = to(tmp_8, new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256]));
    var tmp_10 = this.getBitrateKey_27zxwg_k$(2, 2);
    var tmp_11 = to(tmp_10, new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]));
    var tmp_12 = this.getBitrateKey_27zxwg_k$(2, 3);
    tmp_1._bitrates = mapOf([tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, to(tmp_12, new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]))]);
    var tmp_13 = this;
    var tmp_14 = to('1', new Int32Array([44100, 48000, 32000]));
    var tmp_15 = to('2', new Int32Array([22050, 24000, 16000]));
    tmp_13._sampleRates = mapOf([tmp_14, tmp_15, to('2.5', new Int32Array([11025, 12000, 8000]))]);
    this._samples_0 = mapOf([to(1, mapOf([to(1, 384), to(2, 1152), to(3, 1152)])), to(2, mapOf([to(1, 384), to(2, 1152), to(3, 576)]))]);
  }
  Companion_185.prototype.getBitrateKey_27zxwg_k$ = function (version, layer) {
    return imul(version, 10) + layer | 0;
  };
  Companion_185.prototype.parseFrameHeader_4dl9mi_k$ = function (f4) {
    var b0 = UByteArrayInt__get_impl(f4, 0);
    var b1 = UByteArrayInt__get_impl(f4, 1);
    var b2 = UByteArrayInt__get_impl(f4, 2);
    var b3 = UByteArrayInt__get_impl(f4, 3);
    if (!(b0 === 255)) {
      _get_invalidOp_();
    }var version = this._versions[extract(b1, 3, 2)];
    var simple_version = version === '2.5' ? 2 : toInt(version);
    var layer = this._layers_1[extract(b1, 1, 2)];
    var protection_bit = extract(b1, 0, 1);
    var bitrate_key = this.getBitrateKey_27zxwg_k$(simple_version, layer);
    var bitrate_idx = extract(b2, 4, 4);
    var tmp0_safe_receiver = this._bitrates.get_2bw_k$(bitrate_key);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[bitrate_idx];
    var bitrate = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = this._sampleRates.get_2bw_k$(version);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver[extract(b2, 2, 2)];
    var sample_rate = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    var padding_bit = extract(b2, 1, 1);
    var private_bit = extract(b2, 0, 1);
    var channelMode = ensureNotNull(Companion_getInstance_183()._BY_ID_1.get_2bw_k$(extract(b3, 6, 2)));
    var mode_extension_bits = extract(b3, 4, 2);
    var copyright_bit = extract(b3, 3, 1);
    var original_bit = extract(b3, 2, 1);
    var emphasis = extract(b3, 0, 2);
    var tmp = framesize(this, layer, bitrate, sample_rate, padding_bit);
    var tmp4_safe_receiver = this._samples_0.get_2bw_k$(simple_version);
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.get_2bw_k$(layer);
    return new Mp3Info(version, layer, bitrate, sample_rate, channelMode, tmp, tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
  };
  Companion_185.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_184;
  function Companion_getInstance_184() {
    if (Companion_instance_184 == null)
      new Companion_185();
    return Companion_instance_184;
  }
  function $_getDurationCOROUTINE$8(_this_, use_cbr_estimate, emit, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__142 = _this_;
    this._use_cbr_estimate = use_cbr_estimate;
    this._emit = emit;
  }
  $_getDurationCOROUTINE$8.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 18;
            this.__this__142._data_36._position_6 = new Long(0, 0);
            this._fd0 = this.__this__142._data_36.duplicate_0_k$();
            this._state_1 = 1;
            suspendResult = this._fd0.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._len1 = suspendResult;
            this._durationMicroseconds2 = 0.0;
            this._state_1 = 2;
            suspendResult = readStream(this._fd0, 100, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT3_3 = suspendResult;
            this._state_1 = 3;
            suspendResult = skipID3v2Tag(this.__this__142, this._ARGUMENT3_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._offset4 = suspendResult;
            this._pos5 = this._offset4;
            this._info6 = null;
            this._nframes7 = 0;
            this._block28 = _UByteArrayInt___init__impl_(new Int8Array(10));
            this._fdbase9 = this._fd0._base;
            this._fdsync10 = toSyncOrNull(this._fdbase9);
            this._nreads11 = 0;
            this._nskips12 = 0;
            this._nasync13 = 0;
            this._state_1 = 4;
            continue $sm;
          case 4:
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._exceptionState = 17;
            this._state_1 = 6;
            continue $sm;
          case 6:
            if (!(this._pos5.compareTo_wiekkq_k$(this._len1) < 0)) {
              this._state_1 = 15;
              continue $sm;
            }
            if (!(this._fdsync10 == null)) {
              this._WHEN_RESULT16 = this._fdsync10.read_pwamfb_k$(this._pos5, _UByteArrayInt___get_bytes__impl_(this._block28), 0, 10);
              this._state_1 = 8;
              continue $sm;
            } else {
              var tmp0 = this._nasync13;
              this._nasync13 = tmp0 + 1 | 0;
              Unit_getInstance();
              this._fd0._position_6 = this._pos5;
              this._state_1 = 7;
              suspendResult = readBytesUpTo_0(this._fd0, _UByteArrayInt___get_bytes__impl_(this._block28), 0, 10, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 7:
            this._WHEN_RESULT16 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 8:
            this._block2Size17 = this._WHEN_RESULT16;
            var tmp1 = this._nreads11;
            this._nreads11 = tmp1 + 1 | 0;
            Unit_getInstance();
            if (this._block2Size17 < 10) {
              this._state_1 = 15;
              continue $sm;
            } else {
              this._state_1 = 9;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 9:
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_plus_018 = this._pos5;
            tmp_0._pos5 = this._tmp0_plus_018.plus_wiekkq_k$(toLong(this._block2Size17));
            if (UByteArrayInt__get_impl(this._block28, 0) === 255 ? !((UByteArrayInt__get_impl(this._block28, 1) & 224) === 0) : false) {
              this._framePos19 = this._fd0._position_6;
              this._info6 = Companion_getInstance_184().parseFrameHeader_4dl9mi_k$(this._block28);
              var tmp2_safe_receiver = this._emit;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver(this._framePos19, this._durationMicroseconds2, this._info6);
              Unit_getInstance();
              var tmp3 = this._nframes7;
              this._nframes7 = tmp3 + 1 | 0;
              Unit_getInstance();
              this.__this__142._info_4 = this._info6;
              if (this._info6._frameSize === 0) {
                var tmp_2 = this;
                var tmp_3 = this;
                tmp_3._tmp1__get_microseconds__020 = this._durationMicroseconds2;
                tmp_2._tmp$ret$015 = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(this._tmp1__get_microseconds__020);
                this._exceptionState = 18;
                this._state_1 = 14;
                continue $sm;
              } else {
                this._state_1 = 10;
                continue $sm;
              }
            } else {
              var tmp_4 = _UByteArrayInt___get_bytes__impl_(this._block28);
              var tmp_5 = openSync$default(tmp_4, null, 1, null);
              if (readString$default_0(tmp_5, 3, null, 2, null) === 'TAG') {
                var tmp_6 = this;
                var tmp6_plus_0 = this._pos5;
                var tmp7_plus_0 = 118;
                tmp_6._pos5 = tmp6_plus_0.plus_wiekkq_k$(toLong(tmp7_plus_0));
                this._state_1 = 11;
                continue $sm;
              } else {
                {
                  var tmp_7 = this;
                  var tmp8_minus_0 = this._pos5;
                  tmp_7._pos5 = tmp8_minus_0.minus_wiekkq_k$(new Long(9, 0));
                  var tmp4 = this._nskips12;
                  this._nskips12 = tmp4 + 1 | 0;
                  Unit_getInstance();
                  this._state_1 = 11;
                  continue $sm;
                }
              }
            }

            break;
          case 10:
            var tmp_8 = this;
            var tmp_9 = this;
            tmp_9._tmp2_plus_021 = this._pos5;
            var tmp_10 = this;
            tmp_10._tmp3_plus_022 = this._info6._frameSize - 10 | 0;
            tmp_8._pos5 = this._tmp2_plus_021.plus_wiekkq_k$(toLong(this._tmp3_plus_022));
            var tmp_11 = this;
            var tmp_12 = this._durationMicroseconds2;
            var tmp_13 = this;
            tmp_13._tmp4_div_023 = numberToLong(this._info6._samples).times_wiekkq_k$(new Long(1000000, 0));
            var tmp_14 = this;
            tmp_14._tmp5_div_024 = this._info6._samplingRate;
            tmp_11._durationMicroseconds2 = tmp_12 + this._tmp4_div_023.div_wiekkq_k$(toLong(this._tmp5_div_024)).toDouble_0_k$();
            this._state_1 = 11;
            continue $sm;
          case 11:
            if (!(this._info6 == null) ? this._use_cbr_estimate : false) {
              this._state_1 = 13;
              suspendResult = estimateDuration(this.__this__142, this._info6._bitrate, this._info6._channelMode._channels_0, this._offset4.toInt_0_k$(), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 12;
              continue $sm;
            }

            break;
          case 12:
            this._state_1 = 6;
            continue $sm;
          case 13:
            var tmp9__get_microseconds__0 = suspendResult;
            this._tmp$ret$015 = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp9__get_microseconds__0.toDouble_0_k$());
            this._exceptionState = 18;
            this._state_1 = 14;
            continue $sm;
          case 14:
            var tmp_15 = this._tmp$ret$015;
            return new TimeSpan(tmp_15);
          case 15:
            this._tmp$ret$214 = Unit_getInstance();
            this._exceptionState = 18;
            this._state_1 = 16;
            continue $sm;
          case 16:
            var tmp10__get_microseconds__0 = this._durationMicroseconds2;
            return new TimeSpan(Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp10__get_microseconds__0));
          case 17:
            this._exceptionState = 18;
            var t = this._exception_0;
            throw t;
          case 18:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 18) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $_getDurationCOROUTINE$8.$metadata$ = {
    simpleName: '$_getDurationCOROUTINE$8',
    kind: 'class',
    interfaces: []
  };
  function $skipID3v2TagCOROUTINE$9(_this_, block, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__143 = _this_;
    this._block_2 = block;
  }
  $skipID3v2TagCOROUTINE$9.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._b0 = this._block_2.duplicate_0_k$();
            this._state_1 = 1;
            suspendResult = readString(this._b0, 3, Charsets_getInstance()._get_LATIN1__0_k$(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1_9 = suspendResult;
            if (this._ARGUMENT1_9 === 'ID3') {
              this._state_1 = 2;
              suspendResult = readBytesExact(this._b0, 7, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            var bb = suspendResult;
            var id3v2_major_version = readU8(bb, 0);
            var id3v2_minor_version = readU8(bb, 1);
            var id3v2_flags = readU8(bb, 2);
            var z0 = readU8(bb, 3);
            var z1 = readU8(bb, 4);
            var z2 = readU8(bb, 5);
            var z3 = readU8(bb, 6);
            var flag_unsynchronisation = extract_0(id3v2_flags, 7);
            var flag_extended_header = extract_0(id3v2_flags, 6);
            var flag_experimental_ind = extract_0(id3v2_flags, 5);
            var flag_footer_present = extract_0(id3v2_flags, 4);
            if ((((z0 & 128) === 0 ? (z1 & 128) === 0 : false) ? (z2 & 128) === 0 : false) ? (z3 & 128) === 0 : false) {
              var header_size = 10;
              var tag_size = ((imul(z0 & 127, 2097152) + imul(z1 & 127, 16384) | 0) + imul(z2 & 127, 128) | 0) + (z3 & 127) | 0;
              var footer_size = flag_footer_present ? 10 : 0;
              return toLong((header_size + tag_size | 0) + footer_size | 0);
            }
            this._state_1 = 3;
            continue $sm;
          case 3:
            return new Long(0, 0);
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $skipID3v2TagCOROUTINE$9.$metadata$ = {
    simpleName: '$skipID3v2TagCOROUTINE$9',
    kind: 'class',
    interfaces: []
  };
  function Parser(data, dataLength) {
    Companion_getInstance_184();
    this._data_36 = data;
    this._dataLength = dataLength;
    this._info_4 = null;
  }
  Parser.prototype.getDurationEstimate_nsqrdp_k$ = function ($cont) {
    return _getDuration$default(this, true, null, 4, null, $cont);
  };
  Parser.prototype.getDurationExact_nsqrdp_k$ = function ($cont) {
    return _getDuration$default(this, false, null, 4, null, $cont);
  };
  Parser.$metadata$ = {
    simpleName: 'Parser',
    kind: 'class',
    interfaces: []
  };
  function $tryReadInfoCOROUTINE$6(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__144 = _this_;
    this._data_37 = data;
    this._props_5 = props;
  }
  $tryReadInfoCOROUTINE$6.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._exceptionState = 9;
            this._state_1 = 1;
            suspendResult = this._data_37.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1_10 = suspendResult;
            this._parser2 = new Parser(this._data_37, this._ARGUMENT1_10);
            this._start_13 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            this._tmp0_subject_74 = this._props_5._exactTimings;
            if (this._tmp0_subject_74 == null) {
              this._state_1 = 6;
              suspendResult = this._parser2.getDurationExact_nsqrdp_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }this._state_1 = 7;
              continue $sm;
            } else {
              if (this._tmp0_subject_74 === true) {
                this._state_1 = 4;
                suspendResult = this._parser2.getDurationExact_nsqrdp_k$(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }this._state_1 = 5;
                continue $sm;
              } else {
                this._state_1 = 2;
                suspendResult = this._parser2.getDurationEstimate_nsqrdp_k$(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }this._state_1 = 3;
                continue $sm;
              }
              new TimeSpan(Unit_getInstance());
            }

            break;
          case 2:
            var unboxed = suspendResult._milliseconds;
            suspendResult = unboxed;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._WHEN_RESULT5_0 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 4:
            var unboxed_0 = suspendResult._milliseconds;
            suspendResult = unboxed_0;
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._WHEN_RESULT5_0 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 6:
            var unboxed_1 = suspendResult._milliseconds;
            suspendResult = unboxed_1;
            this._state_1 = 7;
            continue $sm;
          case 7:
            this._WHEN_RESULT5_0 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 8:
            var result_2 = this._WHEN_RESULT5_0;
            var end_3 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            var tmp0__get_microseconds__0_5 = end_3 - this._start_13;
            var elapsed_4 = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_5);
            var tmp0_container = new TimedResult(new TimeSpan(result_2), elapsed_4);
            var duration = tmp0_container.component1_0_k$()._milliseconds;
            var decodingTime = tmp0_container.component2_nsqrdp_k$();
            var tmp_0 = this;
            var tmp1_safe_receiver = this._parser2._info_4;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._channelMode;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._channels_0;
            tmp_0._TRY_RESULT0_2 = new Info_0(duration, tmp3_elvis_lhs == null ? 2 : tmp3_elvis_lhs, decodingTime);
            this._exceptionState = 10;
            this._state_1 = 11;
            continue $sm;
          case 9:
            this._exceptionState = 10;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              var tmp_2 = this;
              tmp_2._TRY_RESULT0_2 = null;
              this._state_1 = 11;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 10:
            throw this._exception_0;
          case 11:
            this._exceptionState = 10;
            return this._TRY_RESULT0_2;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tryReadInfoCOROUTINE$6.$metadata$ = {
    simpleName: '$tryReadInfoCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function MP3Base() {
    AudioFormat.call(this, ['mp3']);
  }
  MP3Base.prototype.tryReadInfo_bfyly4_k$ = function (data, props, $cont) {
    var tmp = new $tryReadInfoCOROUTINE$6(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  MP3Base.$metadata$ = {
    simpleName: 'MP3Base',
    kind: 'class',
    interfaces: []
  };
  function Companion_186() {
    Companion_instance_185 = this;
    OGG.call(this);
  }
  Companion_186.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_185;
  function Companion_getInstance_185() {
    if (Companion_instance_185 == null)
      new Companion_186();
    return Companion_instance_185;
  }
  function OGG() {
    Companion_getInstance_185();
    OggBase.call(this);
  }
  OGG.$metadata$ = {
    simpleName: 'OGG',
    kind: 'class',
    interfaces: []
  };
  function PacketTypes() {
    PacketTypes_instance = this;
    this._ID_HEADER = 1;
    this._COMMENT_HEADER = 3;
    this._SETUP_HEADER = 5;
  }
  PacketTypes.$metadata$ = {
    simpleName: 'PacketTypes',
    kind: 'object',
    interfaces: []
  };
  var PacketTypes_instance;
  function PacketTypes_getInstance() {
    if (PacketTypes_instance == null)
      new PacketTypes();
    return PacketTypes_instance;
  }
  function $tryReadInfoCOROUTINE$11(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__145 = _this_;
    this._data_38 = data;
    this._props_6 = props;
  }
  $tryReadInfoCOROUTINE$11.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__145.parse_krvcn3_k$(this._data_38, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._TRY_RESULT0_3 = suspendResult;
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              var tmp_1 = this;
              tmp_1._TRY_RESULT0_3 = null;
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return this._TRY_RESULT0_3;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tryReadInfoCOROUTINE$11.$metadata$ = {
    simpleName: '$tryReadInfoCOROUTINE$11',
    kind: 'class',
    interfaces: []
  };
  function $parseCOROUTINE$12(_this_, s, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__146 = _this_;
    this._s_8 = s;
  }
  $parseCOROUTINE$12.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 29;
            this._channels0 = 2;
            this._sampleRate1 = 44100;
            this._brnom2 = 160000;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = this._s_8.hasAvailable_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            if (!suspendResult) {
              this._state_1 = 28;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = readString$default(this._s_8, 5, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._magic3 = suspendResult;
            if (!(this._magic3 === 'OggS\x00')) {
              invalidAudioFormat('Not an OGG file');
            }
            this._state_1 = 4;
            suspendResult = readS8_0(this._s_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._type4 = suspendResult;
            this._cont5 = extract_0(this._type4, 0);
            this._bos6 = extract_0(this._type4, 1);
            this._eos7 = extract_0(this._type4, 2);
            this._state_1 = 5;
            suspendResult = readS64LE_0(this._s_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._gpos8 = suspendResult;
            this._state_1 = 6;
            suspendResult = readS32LE_0(this._s_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._sn9 = suspendResult;
            this._state_1 = 7;
            suspendResult = readS32LE_0(this._s_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._psn10 = suspendResult;
            this._state_1 = 8;
            suspendResult = readS32LE_0(this._s_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._chk11 = suspendResult;
            this._state_1 = 9;
            suspendResult = readU8_1(this._s_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._pseg12 = suspendResult;
            var tmp_0 = this;
            tmp_0._tmp0_map_013 = until(0, this._pseg12);
            var tmp_1 = this;
            tmp_1._tmp0_mapTo_0_114 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._tmp0_map_013, 10));
            this._tmp0_iterator_1_215 = this._tmp0_map_013.iterator_0_k$();
            this._state_1 = 10;
            continue $sm;
          case 10:
            if (!this._tmp0_iterator_1_215.hasNext_0_k$()) {
              this._state_1 = 12;
              continue $sm;
            }
            this._item_2_316 = this._tmp0_iterator_1_215.next_0_k$();
            this._state_1 = 11;
            suspendResult = readU8_1(this._s_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._ARGUMENT17 = suspendResult;
            this._tmp0_mapTo_0_114.add_2bq_k$(this._ARGUMENT17);
            Unit_getInstance();
            this._state_1 = 10;
            continue $sm;
          case 12:
            this._psizs18 = this._tmp0_mapTo_0_114;
            var tmp_2 = this;
            tmp_2._tmp0_mapTo_0_119 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._psizs18, 10));
            this._tmp0_iterator_1_220 = this._psizs18.iterator_0_k$();
            this._state_1 = 13;
            continue $sm;
          case 13:
            if (!this._tmp0_iterator_1_220.hasNext_0_k$()) {
              this._state_1 = 15;
              continue $sm;
            }
            this._item_2_321 = this._tmp0_iterator_1_220.next_0_k$();
            this._state_1 = 14;
            suspendResult = readStream(this._s_8, this._item_2_321, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 14:
            this._ARGUMENT22 = suspendResult;
            this._tmp0_mapTo_0_119.add_2bq_k$(this._ARGUMENT22);
            Unit_getInstance();
            this._state_1 = 13;
            continue $sm;
          case 15:
            this._pages23 = this._tmp0_mapTo_0_119;
            if (this._bos6) {
              this._info24 = this._pages23.get_ha5a7z_k$(0);
              this._state_1 = 16;
              suspendResult = readU8_1(this._info24, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 27;
              continue $sm;
            }

            break;
          case 16:
            this._packetType25 = suspendResult;
            if (this._packetType25 > 3) {
              invalidOp('Unsupported OGG vorbis file');
            }
            this._state_1 = 17;
            suspendResult = readString$default(this._info24, 6, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 17:
            this._ARGUMENT26 = suspendResult;
            this._ARGUMENT27 = this._ARGUMENT26 === 'vorbis';
            if (!this._ARGUMENT27) {
              invalidOp('Unsupported OGG vorbis file');
            } else {
              this._state_1 = 18;
              continue $sm;
            }

            break;
          case 18:
            this._tmp0_subject28 = this._packetType25;
            PacketTypes_getInstance();
            if (this._tmp0_subject28 === 1) {
              this._state_1 = 19;
              suspendResult = readS32LE_0(this._info24, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                PacketTypes_getInstance();
                if (this._tmp0_subject28 === 3) {
                  Unit_getInstance();
                  this._state_1 = 26;
                  continue $sm;
                } else {
                  {
                    PacketTypes_getInstance();
                    if (this._tmp0_subject28 === 5) {
                      Unit_getInstance();
                      this._state_1 = 26;
                      continue $sm;
                    } else {
                      {
                        this._state_1 = 26;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

            break;
          case 19:
            this._vver29 = suspendResult;
            this._state_1 = 20;
            suspendResult = readU8_1(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 20:
            this._channels0 = suspendResult;
            this._state_1 = 21;
            suspendResult = readS32LE_0(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 21:
            this._sampleRate1 = suspendResult;
            this._state_1 = 22;
            suspendResult = readS32LE_0(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 22:
            this._brmax30 = suspendResult;
            this._state_1 = 23;
            suspendResult = readS32LE_0(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 23:
            this._brnom2 = suspendResult;
            this._state_1 = 24;
            suspendResult = readS32LE_0(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 24:
            this._brmin31 = suspendResult;
            this._state_1 = 25;
            suspendResult = readU8_1(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 25:
            var bsinfo = suspendResult;
            this._state_1 = 26;
            continue $sm;
          case 26:
            this._state_1 = 27;
            continue $sm;
          case 27:
            if (this._eos7) {
              var tmp1__get_microseconds__0 = numberToLong(this._gpos8.toDouble_0_k$() * 1000000.0 / this._sampleRate1);
              var tmp_3 = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp1__get_microseconds__0.toDouble_0_k$());
              var tmp_4 = this._channels0;
              return Info_init_$Create$(tmp_3, tmp_4, null, 4, null);
            }
            this._state_1 = 1;
            continue $sm;
          case 28:
            invalidOp('Cannot parse stream');
            break;
          case 29:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 29) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $parseCOROUTINE$12.$metadata$ = {
    simpleName: '$parseCOROUTINE$12',
    kind: 'class',
    interfaces: []
  };
  function OggBase() {
    AudioFormat.call(this, ['ogg']);
  }
  OggBase.prototype.tryReadInfo_bfyly4_k$ = function (data, props, $cont) {
    var tmp = new $tryReadInfoCOROUTINE$11(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  OggBase.prototype.parse_krvcn3_k$ = function (s, $cont) {
    var tmp = new $parseCOROUTINE$12(this, s, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  OggBase.$metadata$ = {
    simpleName: 'OggBase',
    kind: 'class',
    interfaces: []
  };
  function $readCOROUTINE$15(_this_, out, offset_0, length, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__147 = _this_;
    this._out_9 = out;
    this._offset_31 = offset_0;
    this._length_4 = length;
  }
  $readCOROUTINE$15.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = readBytesUpTo(this.__this__147._buffer_27, imul(imul(this._length_4, this.__this__147._bytesPerSample), this.__this__147._get_channels__0_k$()), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._bytes0 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__147._buffer_27.eof_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.__this__147._finished = ARGUMENT;
            var availableSamples = (this._bytes0.length / this.__this__147._bytesPerSample | 0) / this.__this__147._get_channels__0_k$() | 0;
            var inductionVariable = 0;
            var last_1 = this.__this__147._get_channels__0_k$();
            if (inductionVariable < last_1)
              do {
                var channel = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp1_subject = this.__this__147._bytesPerSample;
                switch (tmp1_subject) {
                  case 1:
                    var tmp0_readBlock_0 = Companion_getInstance_186();
                    var tmp1_readBlock_0 = this.__this__147._get_channels__0_k$();
                    var tmp2_readBlock_0 = this.__this__147._bytesPerSample;
                    var increment_1 = imul(tmp1_readBlock_0, tmp2_readBlock_0);
                    var index_2 = imul(channel, tmp2_readBlock_0);
                    var outc_3 = this._out_9.get_ha5a7z_k$(channel);
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < availableSamples)
                      do {
                        var n_5 = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        var tmp_0 = this._offset_31 + n_5 | 0;
                        var tmp3__anonymous__6 = index_2;
                        outc_3[tmp_0] = coerceToShort(imul(readU8(this._bytes0, tmp3__anonymous__6) - 128 | 0, 255));
                        index_2 = index_2 + increment_1 | 0;
                      }
                       while (inductionVariable_0 < availableSamples);
                    break;
                  case 2:
                    var tmp4_readBlock_0 = Companion_getInstance_186();
                    var tmp5_readBlock_0 = this.__this__147._get_channels__0_k$();
                    var tmp6_readBlock_0 = this.__this__147._bytesPerSample;
                    var increment_1_0 = imul(tmp5_readBlock_0, tmp6_readBlock_0);
                    var index_2_0 = imul(channel, tmp6_readBlock_0);
                    var outc_3_0 = this._out_9.get_ha5a7z_k$(channel);
                    var inductionVariable_1 = 0;
                    if (inductionVariable_1 < availableSamples)
                      do {
                        var n_5_0 = inductionVariable_1;
                        inductionVariable_1 = inductionVariable_1 + 1 | 0;
                        var tmp_1 = this._offset_31 + n_5_0 | 0;
                        var tmp7__anonymous__6 = index_2_0;
                        outc_3_0[tmp_1] = toShort(readS16LE(this._bytes0, tmp7__anonymous__6));
                        index_2_0 = index_2_0 + increment_1_0 | 0;
                      }
                       while (inductionVariable_1 < availableSamples);
                    break;
                  case 3:
                    var tmp8_readBlock_0 = Companion_getInstance_186();
                    var tmp9_readBlock_0 = this.__this__147._get_channels__0_k$();
                    var tmp10_readBlock_0 = this.__this__147._bytesPerSample;
                    var increment_1_1 = imul(tmp9_readBlock_0, tmp10_readBlock_0);
                    var index_2_1 = imul(channel, tmp10_readBlock_0);
                    var outc_3_1 = this._out_9.get_ha5a7z_k$(channel);
                    var inductionVariable_2 = 0;
                    if (inductionVariable_2 < availableSamples)
                      do {
                        var n_5_1 = inductionVariable_2;
                        inductionVariable_2 = inductionVariable_2 + 1 | 0;
                        var tmp_2 = this._offset_31 + n_5_1 | 0;
                        var tmp11__anonymous__6 = index_2_1;
                        outc_3_1[tmp_2] = toShort(readS24LE(this._bytes0, tmp11__anonymous__6) >>> 8);
                        index_2_1 = index_2_1 + increment_1_1 | 0;
                      }
                       while (inductionVariable_2 < availableSamples);
                    break;
                  default:invalidOp('' + 'Unsupported bytesPerSample=' + this.__this__147._bytesPerSample);
                    break;
                }
              }
               while (inductionVariable < last_1);
            return availableSamples;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$15.$metadata$ = {
    simpleName: '$readCOROUTINE$15',
    kind: 'class',
    interfaces: []
  };
  function $cloneCOROUTINE$16(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__148 = _this_;
  }
  $cloneCOROUTINE$16.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = (new WAV()).decodeStream_bfyly4_k$(this.__this__148._data_41.duplicate_0_k$(), this.__this__148._props_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ensureNotNull(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $cloneCOROUTINE$16.$metadata$ = {
    simpleName: '$cloneCOROUTINE$16',
    kind: 'class',
    interfaces: []
  };
  function Fmt_init_$Init$(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      formatTag = -1;
    if (!(($mask0 & 2) === 0))
      channels = 2;
    if (!(($mask0 & 4) === 0))
      samplesPerSec = 44100;
    if (!(($mask0 & 8) === 0))
      avgBytesPerSec = new Long(0, 0);
    if (!(($mask0 & 16) === 0))
      blockAlign = 0;
    if (!(($mask0 & 32) === 0))
      bitsPerSample = 0;
    Fmt.call($this, formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample);
    return $this;
  }
  function Fmt_init_$Create$(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, $mask0, $marker) {
    return Fmt_init_$Init$(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, $mask0, $marker, Object.create(Fmt.prototype));
  }
  function Companion_187() {
    Companion_instance_186 = this;
    WAV.call(this);
  }
  Companion_187.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_186;
  function Companion_getInstance_186() {
    if (Companion_instance_186 == null)
      new Companion_187();
    return Companion_instance_186;
  }
  function Chunk(type, data) {
    this._type_21 = type;
    this._data_39 = data;
  }
  Chunk.prototype.component1_0_k$ = function () {
    return this._type_21;
  };
  Chunk.prototype.component2_0_k$ = function () {
    return this._data_39;
  };
  Chunk.prototype.toString = function () {
    return '' + 'Chunk(type=' + this._type_21 + ', data=' + this._data_39 + ')';
  };
  Chunk.prototype.hashCode = function () {
    var result = getStringHashCode(this._type_21);
    result = imul(result, 31) + hashCode(this._data_39) | 0;
    return result;
  };
  Chunk.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Chunk))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Chunk ? other : THROW_CCE();
    if (!(this._type_21 === tmp0_other_with_cast._type_21))
      return false;
    if (!equals_1(this._data_39, tmp0_other_with_cast._data_39))
      return false;
    return true;
  };
  Chunk.$metadata$ = {
    simpleName: 'Chunk',
    kind: 'class',
    interfaces: []
  };
  function ProcessedChunk(type, data, extra) {
    this._type_22 = type;
    this._data_40 = data;
    this._extra_2 = extra;
  }
  ProcessedChunk.prototype.toString = function () {
    return '' + 'ProcessedChunk(type=' + this._type_22 + ', data=' + this._data_40 + ', extra=' + this._extra_2 + ')';
  };
  ProcessedChunk.prototype.hashCode = function () {
    var result = getStringHashCode(this._type_22);
    result = imul(result, 31) + hashCode(this._data_40) | 0;
    result = imul(result, 31) + hashCode(this._extra_2) | 0;
    return result;
  };
  ProcessedChunk.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessedChunk))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProcessedChunk ? other : THROW_CCE();
    if (!(this._type_22 === tmp0_other_with_cast._type_22))
      return false;
    if (!equals_1(this._data_40, tmp0_other_with_cast._data_40))
      return false;
    if (!equals_1(this._extra_2, tmp0_other_with_cast._extra_2))
      return false;
    return true;
  };
  ProcessedChunk.$metadata$ = {
    simpleName: 'ProcessedChunk',
    kind: 'class',
    interfaces: []
  };
  function WavAudioStream(fmt, buffer, bufferLength, data, props) {
    AudioStream.call(this, fmt._samplesPerSec, fmt._channels_1);
    this._fmt = fmt;
    this._buffer_27 = buffer;
    this._bufferLength = bufferLength;
    this._data_41 = data;
    this._props_7 = props;
    this._bytesPerSample = this._fmt._get_bytesPerSample__0_k$();
    this._finished = false;
  }
  WavAudioStream.prototype._get_finished__0_k$ = function () {
    return this._finished;
  };
  WavAudioStream.prototype._set_currentPositionInSamples__kdfck9_k$ = function (value) {
    this._finished = false;
    var tmp = this._buffer_27;
    var tmp0_times_0_2 = this._bytesPerSample;
    tmp._position_6 = value.times_wiekkq_k$(toLong(tmp0_times_0_2));
    return Unit_getInstance();
  };
  WavAudioStream.prototype.read_cmb8c5_k$ = function (out, offset_0, length, $cont) {
    var tmp = new $readCOROUTINE$15(this, out, offset_0, length, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  WavAudioStream.prototype.clone_0_k$ = function ($cont) {
    var tmp = new $cloneCOROUTINE$16(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  WavAudioStream.$metadata$ = {
    simpleName: 'WavAudioStream',
    kind: 'class',
    interfaces: []
  };
  function Fmt(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample) {
    this._formatTag = formatTag;
    this._channels_1 = channels;
    this._samplesPerSec = samplesPerSec;
    this._avgBytesPerSec = avgBytesPerSec;
    this._blockAlign = blockAlign;
    this._bitsPerSample = bitsPerSample;
  }
  Fmt.prototype._get_bytesPerSample__0_k$ = function () {
    return this._bitsPerSample / 8 | 0;
  };
  Fmt.prototype.toString = function () {
    return '' + 'Fmt(formatTag=' + this._formatTag + ', channels=' + this._channels_1 + ', samplesPerSec=' + this._samplesPerSec + ', avgBytesPerSec=' + this._avgBytesPerSec + ', blockAlign=' + this._blockAlign + ', bitsPerSample=' + this._bitsPerSample + ')';
  };
  Fmt.prototype.hashCode = function () {
    var result = this._formatTag;
    result = imul(result, 31) + this._channels_1 | 0;
    result = imul(result, 31) + this._samplesPerSec | 0;
    result = imul(result, 31) + this._avgBytesPerSec.hashCode() | 0;
    result = imul(result, 31) + this._blockAlign | 0;
    result = imul(result, 31) + this._bitsPerSample | 0;
    return result;
  };
  Fmt.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Fmt))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Fmt ? other : THROW_CCE();
    if (!(this._formatTag === tmp0_other_with_cast._formatTag))
      return false;
    if (!(this._channels_1 === tmp0_other_with_cast._channels_1))
      return false;
    if (!(this._samplesPerSec === tmp0_other_with_cast._samplesPerSec))
      return false;
    if (!this._avgBytesPerSec.equals(tmp0_other_with_cast._avgBytesPerSec))
      return false;
    if (!(this._blockAlign === tmp0_other_with_cast._blockAlign))
      return false;
    if (!(this._bitsPerSample === tmp0_other_with_cast._bitsPerSample))
      return false;
    return true;
  };
  Fmt.$metadata$ = {
    simpleName: 'Fmt',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__380() {
  }
  _no_name_provided__380.prototype.invoke_7qa0iq_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__380.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_7qa0iq_k$(p1 instanceof ProcessedChunk ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__380.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__381($fmt, $buffer) {
    this._$fmt = $fmt;
    this._$buffer_2 = $buffer;
  }
  _no_name_provided__381.prototype.invoke_7qa0iq_k$ = function (it) {
    var extra = it._extra_2;
    var tmp0_subject = extra;
    if (tmp0_subject instanceof Fmt)
      this._$fmt._v = extra;
    else {
    }
    if (it._type_22 === 'data')
      this._$buffer_2._v = it._data_40;
  };
  _no_name_provided__381.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_7qa0iq_k$(p1 instanceof ProcessedChunk ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__381.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__382($fmt, $dataSize, $handle, resultContinuation) {
    this._$fmt_0 = $fmt;
    this._$dataSize = $dataSize;
    this._$handle_0 = $handle;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__382.prototype.invoke_1gnswo_k$ = function ($this$riff, $cont) {
    var tmp = this.create_3jtr03_k$($this$riff, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__382.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_1gnswo_k$(p1 instanceof Chunk ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__382.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._tmp0_container0 = this._$this$riff;
            this._type1 = this._tmp0_container0.component1_0_k$();
            this._d22 = this._tmp0_container0.component2_0_k$();
            this._d3 = this._d22.duplicate_0_k$();
            this._cdata4 = Unit_getInstance();
            this._tmp1_subject5 = this._type1;
            if (this._tmp1_subject5 === 'fmt ') {
              this._state_1 = 2;
              suspendResult = readS16LE_0(this._d3, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              if (this._tmp1_subject5 === 'data') {
                this._ARGUMENT6_0 = this._$dataSize._v;
                this._state_1 = 1;
                suspendResult = this._d3.getLength_0_k$(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                Unit_getInstance();
                this._state_1 = 8;
                continue $sm;
              }
            }

            break;
          case 1:
            this._ARGUMENT7_0 = suspendResult;
            this._ARGUMENT8_1 = this._ARGUMENT6_0.plus_wiekkq_k$(this._ARGUMENT7_0);
            this._$dataSize._v = this._ARGUMENT8_1;
            this._cdata4 = this._d3;
            this._state_1 = 8;
            continue $sm;
          case 2:
            this._ARGUMENT9_1 = suspendResult;
            this._$fmt_0._formatTag = this._ARGUMENT9_1;
            this._state_1 = 3;
            suspendResult = readS16LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._ARGUMENT10_0 = suspendResult;
            this._$fmt_0._channels_1 = this._ARGUMENT10_0;
            this._state_1 = 4;
            suspendResult = readS32LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._ARGUMENT11 = suspendResult;
            this._$fmt_0._samplesPerSec = this._ARGUMENT11;
            this._state_1 = 5;
            suspendResult = readU32LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._ARGUMENT12_0 = suspendResult;
            this._$fmt_0._avgBytesPerSec = this._ARGUMENT12_0;
            this._state_1 = 6;
            suspendResult = readS16LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._ARGUMENT13_0 = suspendResult;
            this._$fmt_0._blockAlign = this._ARGUMENT13_0;
            this._state_1 = 7;
            suspendResult = readS16LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            var ARGUMENT = suspendResult;
            this._$fmt_0._bitsPerSample = ARGUMENT;
            this._cdata4 = this._$fmt_0;
            this._state_1 = 8;
            continue $sm;
          case 8:
            this._$handle_0(new ProcessedChunk(this._$this$riff._type_21, this._$this$riff._data_39, this._cdata4));
            return Unit_getInstance();
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__382.prototype.create_3jtr03_k$ = function ($this$riff, completion) {
    var i = new _no_name_provided__382(this._$fmt_0, this._$dataSize, this._$handle_0, completion);
    i._$this$riff = $this$riff;
    return i;
  };
  _no_name_provided__382.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $tryReadInfoCOROUTINE$13(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__149 = _this_;
    this._data_42 = data;
    this._props_8 = props;
  }
  $tryReadInfoCOROUTINE$13.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__149.parse_k8u93p_k$(this._data_42, _no_name_provided_$factory_325(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._TRY_RESULT0_4 = suspendResult;
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              var tmp_1 = this;
              tmp_1._TRY_RESULT0_4 = null;
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return this._TRY_RESULT0_4;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tryReadInfoCOROUTINE$13.$metadata$ = {
    simpleName: '$tryReadInfoCOROUTINE$13',
    kind: 'class',
    interfaces: []
  };
  function $decodeStreamCOROUTINE$14(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__150 = _this_;
    this._data_43 = data;
    this._props_9 = props;
  }
  $decodeStreamCOROUTINE$14.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = new Long(0, 0);
            tmp_0._fmt0 = {_v: Fmt_init_$Create$(0, 0, 0, tmp_1, 0, 0, 63, null)};
            var tmp_2 = this;
            tmp_2._buffer1 = {_v: toAsync(MemorySyncStream$default(null, 1, null))};
            this._state_1 = 1;
            suspendResult = this.__this__150.parse_k8u93p_k$(this._data_43, _no_name_provided_$factory_326(this._fmt0, this._buffer1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            this._ARGUMENT2_4 = this._fmt0._v;
            this._ARGUMENT3_4 = this._buffer1._v;
            this._state_1 = 2;
            suspendResult = this._buffer1._v.getLength_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return new WavAudioStream(this._ARGUMENT2_4, this._ARGUMENT3_4, ARGUMENT, this._data_43, this._props_9);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeStreamCOROUTINE$14.$metadata$ = {
    simpleName: '$decodeStreamCOROUTINE$14',
    kind: 'class',
    interfaces: []
  };
  function $encodeCOROUTINE$17(_this_, data, out, filename, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__151 = _this_;
    this._data_44 = data;
    this._out_10 = out;
    this._filename_3 = filename;
    this._props_10 = props;
  }
  $encodeCOROUTINE$17.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 15;
            this._state_1 = 1;
            suspendResult = writeString$default(this._out_10, 'RIFF', null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = write32LE_0(this._out_10, 36 + imul(this._data_44._samples_1._totalSamples, 2) | 0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 3;
            suspendResult = writeString$default(this._out_10, 'WAVE', null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._state_1 = 4;
            suspendResult = writeString$default(this._out_10, 'fmt ', null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._state_1 = 5;
            suspendResult = write32LE_0(this._out_10, 16, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._state_1 = 6;
            suspendResult = write16LE_0(this._out_10, 1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._state_1 = 7;
            suspendResult = write16LE_0(this._out_10, this._data_44._get_channels__0_k$(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._state_1 = 8;
            suspendResult = write32LE_0(this._out_10, this._data_44._rate, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._state_1 = 9;
            suspendResult = write32LE_0(this._out_10, imul(imul(this._data_44._rate, this._data_44._get_channels__0_k$()), 2), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._state_1 = 10;
            suspendResult = write16LE_0(this._out_10, 2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            this._state_1 = 11;
            suspendResult = write16LE_0(this._out_10, 16, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._state_1 = 12;
            suspendResult = writeString$default(this._out_10, 'data', null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._state_1 = 13;
            suspendResult = write32LE_0(this._out_10, imul(this._data_44._samples_1._totalSamples, 2), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 13:
            this._state_1 = 14;
            suspendResult = writeShortArrayLE(this._out_10, interleaved$default(this._data_44._samples_1, null, 1, null)._data_49, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 14:
            return Unit_getInstance();
          case 15:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 15) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $encodeCOROUTINE$17.$metadata$ = {
    simpleName: '$encodeCOROUTINE$17',
    kind: 'class',
    interfaces: []
  };
  function $parseCOROUTINE$18(_this_, data, handle, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__152 = _this_;
    this._data_45 = data;
    this._handle_2 = handle;
  }
  $parseCOROUTINE$18.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            var tmp_1 = new Long(0, 0);
            tmp_0._fmt0_0 = Fmt_init_$Create$(0, 0, 0, tmp_1, 0, 0, 63, null);
            this._dataSize1 = {_v: new Long(0, 0)};
            this._state_1 = 1;
            suspendResult = this.__this__152.riff_mp63ih_k$(this._data_45, _no_name_provided_$factory_327(this._fmt0_0, this._dataSize1, this._handle_2, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            if (this._fmt0_0._formatTag < 0) {
              invalidOp("Couldn't find RIFF 'fmt ' chunk");
            }
            var tmp0_times_0 = this._dataSize1._v;
            var tmp1_times_0 = tmp0_times_0.times_wiekkq_k$(new Long(1000, 0));
            var tmp2__get_microseconds__0 = tmp1_times_0.times_wiekkq_k$(new Long(1000, 0)).div_wiekkq_k$(this._fmt0_0._avgBytesPerSec);
            var tmp_2 = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp2__get_microseconds__0.toDouble_0_k$());
            var tmp_3 = this._fmt0_0._channels_1;
            return Info_init_$Create$(tmp_2, tmp_3, null, 4, null);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $parseCOROUTINE$18.$metadata$ = {
    simpleName: '$parseCOROUTINE$18',
    kind: 'class',
    interfaces: []
  };
  function $riffCOROUTINE$19(_this_, data, handler, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__153 = _this_;
    this._data_46 = data;
    this._handler_2 = handler;
  }
  $riffCOROUTINE$19.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 18;
            this._s20 = this._data_46.duplicate_0_k$();
            this._state_1 = 1;
            suspendResult = this._s20.getAvailable_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1_11 = suspendResult;
            if (this._ARGUMENT1_11.compareTo_wiekkq_k$(new Long(12, 0)) < 0) {
              throw IllegalStateException_init_$Create$_0('Not enough data for a RIFF file');
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._state_1 = 3;
            suspendResult = readString$default(this._s20, 4, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._magic2 = suspendResult;
            this._state_1 = 4;
            suspendResult = readS32LE_0(this._s20, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._length3 = suspendResult;
            this._state_1 = 5;
            suspendResult = readString$default(this._s20, 4, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._magic24 = suspendResult;
            if (!(this._magic2 === 'RIFF')) {
              invalidAudioFormat('' + "Not a RIFF file but '" + this._magic2 + "'");
            }
            if (!(this._magic24 === 'WAVE')) {
              invalidAudioFormat('Not a RIFF + WAVE file');
            }
            this._state_1 = 6;
            suspendResult = readStream(this._s20, this._length3 - 4 | 0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._s5 = suspendResult;
            this._state_1 = 7;
            continue $sm;
          case 7:
            this._state_1 = 8;
            suspendResult = this._s5.eof_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._ARGUMENT6_1 = suspendResult;
            if (!!this._ARGUMENT6_1) {
              this._state_1 = 17;
              continue $sm;
            }
            this._state_1 = 9;
            suspendResult = this._s5.getAvailable_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._ARGUMENT7_1 = suspendResult;
            if (this._ARGUMENT7_1.compareTo_wiekkq_k$(new Long(8, 0)) < 0) {
              this._state_1 = 17;
              continue $sm;
            } else {
              this._state_1 = 10;
              continue $sm;
            }

            break;
          case 10:
            this._state_1 = 11;
            suspendResult = readString$default(this._s5, 4, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._type8 = suspendResult;
            this._state_1 = 12;
            suspendResult = readS32LE_0(this._s5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._size9 = suspendResult;
            this._state_1 = 13;
            suspendResult = this._s5.getAvailable_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 13:
            this._ARGUMENT10_1 = suspendResult;
            if (this._ARGUMENT10_1.compareTo_wiekkq_k$(toLong(this._size9)) < 0) {
              this._state_1 = 17;
              continue $sm;
            } else {
              this._state_1 = 14;
              continue $sm;
            }

            break;
          case 14:
            this._state_1 = 15;
            suspendResult = readStream(this._s5, this._size9, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 15:
            this._d11 = suspendResult;
            this._state_1 = 16;
            suspendResult = this._handler_2(new Chunk(this._type8, this._d11), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 16:
            this._state_1 = 7;
            continue $sm;
          case 17:
            return Unit_getInstance();
          case 18:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 18) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $riffCOROUTINE$19.$metadata$ = {
    simpleName: '$riffCOROUTINE$19',
    kind: 'class',
    interfaces: []
  };
  function WAV() {
    Companion_getInstance_186();
    AudioFormat.call(this, ['wav']);
  }
  WAV.prototype.tryReadInfo_bfyly4_k$ = function (data, props, $cont) {
    var tmp = new $tryReadInfoCOROUTINE$13(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  WAV.prototype.decodeStream_bfyly4_k$ = function (data, props, $cont) {
    var tmp = new $decodeStreamCOROUTINE$14(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  WAV.prototype.encode_ub8akz_k$ = function (data, out, filename, props, $cont) {
    var tmp = new $encodeCOROUTINE$17(this, data, out, filename, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  WAV.prototype.parse_k8u93p_k$ = function (data, handle, $cont) {
    var tmp = new $parseCOROUTINE$18(this, data, handle, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  WAV.prototype.riff_mp63ih_k$ = function (data, handler, $cont) {
    var tmp = new $riffCOROUTINE$19(this, data, handler, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  WAV.$metadata$ = {
    simpleName: 'WAV',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_325() {
    var i = new _no_name_provided__380();
    return function (p1) {
      i.invoke_7qa0iq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_326($fmt, $buffer) {
    var i = new _no_name_provided__381($fmt, $buffer);
    return function (p1) {
      i.invoke_7qa0iq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_327($fmt, $dataSize, $handle, resultContinuation) {
    var i = new _no_name_provided__382($fmt, $dataSize, $handle, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1gnswo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  var temp;
  function write_1(_this_, value) {
    temp[0] = value;
    _this_.write_zd834l_k$(temp, 0, 1);
    Unit_getInstance();
  }
  function coerceToShort(_this_) {
    return toShort(coerceIn(_this_, ShortCompanionObject_getInstance()._MIN_VALUE_4, ShortCompanionObject_getInstance()._MAX_VALUE_4));
  }
  function _get_niceStr__4(_this_) {
    var tmp;
    if (Math.floor(_this_) === _this_) {
      tmp = '' + numberToInt(_this_);
    } else {
      {
        tmp = '' + _this_;
      }
    }
    return tmp;
  }
  function SampleConvert() {
    SampleConvert_instance = this;
  }
  SampleConvert.prototype.shortToFloat_dip2j2_k$ = function (v) {
    return v / ShortCompanionObject_getInstance()._MAX_VALUE_4;
  };
  SampleConvert.$metadata$ = {
    simpleName: 'SampleConvert',
    kind: 'object',
    interfaces: []
  };
  var SampleConvert_instance;
  function SampleConvert_getInstance() {
    if (SampleConvert_instance == null)
      new SampleConvert();
    return SampleConvert_instance;
  }
  function _no_name_provided__383() {
  }
  _no_name_provided__383.prototype.invoke_0_k$ = function () {
    return new AudioData(44100, AudioSamples_init_$Create$(2, 0, null, 4, null));
  };
  _no_name_provided__383.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_188() {
    Companion_instance_187 = this;
    var tmp = this;
    tmp._DUMMY$delegate = lazy(_no_name_provided_$factory_329());
  }
  Companion_188.prototype._get_DUMMY__0_k$ = function () {
    var tmp0_getValue_0 = DUMMY$factory();
    return this._DUMMY$delegate._get_value__0_k$();
  };
  Companion_188.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_187;
  function Companion_getInstance_187() {
    if (Companion_instance_187 == null)
      new Companion_188();
    return Companion_instance_187;
  }
  function _no_name_provided__384(this$0) {
    this._this$0_114 = this$0;
  }
  _no_name_provided__384.prototype.invoke_0_k$ = function () {
    return interleaved$default(this._this$0_114._samples_1, null, 1, null);
  };
  _no_name_provided__384.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AudioData(rate, samples) {
    Companion_getInstance_187();
    this._rate = rate;
    this._samples_1 = samples;
    var tmp = this;
    tmp._samplesInterleaved$delegate = lazy(_no_name_provided_$factory_328(this));
  }
  AudioData.prototype._get_channels__0_k$ = function () {
    return this._samples_1._channels_2;
  };
  AudioData.prototype._get_totalSamples__0_k$ = function () {
    return this._samples_1._totalSamples;
  };
  AudioData.prototype.toString = function () {
    return '' + 'AudioData(rate=' + this._rate + ', channels=' + this._get_channels__0_k$() + ', samples=' + this._get_totalSamples__0_k$() + ')';
  };
  AudioData.$metadata$ = {
    simpleName: 'AudioData',
    kind: 'class',
    interfaces: []
  };
  function toStream(_this_) {
    return new AudioDataStream(_this_);
  }
  function AudioDataStream(data) {
    AudioStream.call(this, data._rate, data._get_channels__0_k$());
    this._data_47 = data;
    this._cursor_1 = 0;
    this._finished_0 = false;
  }
  AudioDataStream.prototype._get_finished__0_k$ = function () {
    return this._finished_0;
  };
  AudioDataStream.prototype.read_cmb8c5_k$ = function (out, offset_0, length, $cont) {
    var available = this._data_47._samples_1._totalSamples - this._cursor_1 | 0;
    var toread = Math.min(available, length);
    if (toread > 0) {
      var inductionVariable = 0;
      var last_1 = this._get_channels__0_k$();
      if (inductionVariable < last_1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          arraycopy_6(this._data_47._samples_1.get_ha5a7z_k$(n), this._cursor_1, out.get_ha5a7z_k$(n), offset_0, toread);
        }
         while (inductionVariable < last_1);
      var tmp1_this = this;
      tmp1_this._cursor_1 = tmp1_this._cursor_1 + toread | 0;
    }if (toread <= 0)
      this._finished_0 = true;
    return toread;
  };
  AudioDataStream.prototype.clone_0_k$ = function ($cont) {
    return new AudioDataStream(this._data_47);
  };
  AudioDataStream.$metadata$ = {
    simpleName: 'AudioDataStream',
    kind: 'class',
    interfaces: []
  };
  function DUMMY$factory() {
    return getPropertyCallableRef('DUMMY', 1, KProperty1, function (receiver) {
      return receiver._get_DUMMY__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_328(this$0) {
    var i = new _no_name_provided__384(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_329() {
    var i = new _no_name_provided__383();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function AudioSamples_init_$Init$(channels, totalSamples, data, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0)) {
      var tmp = 0;
      var tmp_0 = channels;
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = new Int16Array(totalSamples);
        tmp = tmp + 1 | 0;
      }
      data = tmp_1;
    }AudioSamples.call($this, channels, totalSamples, data);
    return $this;
  }
  function AudioSamples_init_$Create$(channels, totalSamples, data, $mask0, $marker) {
    return AudioSamples_init_$Init$(channels, totalSamples, data, $mask0, $marker, Object.create(AudioSamples.prototype));
  }
  function AudioSamples(channels, totalSamples, data) {
    this._channels_2 = channels;
    this._totalSamples = totalSamples;
    this._data_48 = data;
    this._fastShortTransfer = new FastShortTransfer();
  }
  AudioSamples.prototype.get_ha5a7z_k$ = function (channel) {
    return this._data_48[channel];
  };
  AudioSamples.prototype.get_27zxwg_k$ = function (channel, sample) {
    return this._data_48[channel][sample];
  };
  AudioSamples.prototype.hashCode = function () {
    return (this._channels_2 + imul(this._totalSamples, 32) | 0) + imul(contentDeepHashCode(this._data_48), 64) | 0;
  };
  AudioSamples.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof AudioSamples) {
      tmp_1 = this._channels_2 === other._channels_2;
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._totalSamples === other._totalSamples;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = contentDeepEquals(this._data_48, other._data_48);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  AudioSamples.prototype.toString = function () {
    return '' + 'AudioSamples(channels=' + this._channels_2 + ', totalSamples=' + this._totalSamples + ')';
  };
  AudioSamples.$metadata$ = {
    simpleName: 'AudioSamples',
    kind: 'class',
    interfaces: [IAudioSamples]
  };
  function AudioSamplesInterleaved_init_$Init$(channels, totalSamples, data, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      data = new Int16Array(imul(totalSamples, channels));
    AudioSamplesInterleaved.call($this, channels, totalSamples, data);
    return $this;
  }
  function AudioSamplesInterleaved_init_$Create$(channels, totalSamples, data, $mask0, $marker) {
    return AudioSamplesInterleaved_init_$Init$(channels, totalSamples, data, $mask0, $marker, Object.create(AudioSamplesInterleaved.prototype));
  }
  function AudioSamplesInterleaved(channels, totalSamples, data) {
    this._channels_3 = channels;
    this._totalSamples_0 = totalSamples;
    this._data_49 = data;
    this._fastShortTransfer_0 = new FastShortTransfer();
  }
  AudioSamplesInterleaved.prototype.toString = function () {
    return '' + 'AudioSamplesInterleaved(channels=' + this._channels_3 + ', totalSamples=' + this._totalSamples_0 + ')';
  };
  AudioSamplesInterleaved.$metadata$ = {
    simpleName: 'AudioSamplesInterleaved',
    kind: 'class',
    interfaces: [IAudioSamples]
  };
  function interleaved(_this_, out) {
    var tmp0_assert_0 = out._data_49.length >= imul(_this_._totalSamples, _this_._channels_2);
    if (!tmp0_assert_0)
      throw AssertionError_init_$Create$();
    var tmp0_subject = _this_._channels_2;
    switch (tmp0_subject) {
      case 1:
        arraycopy_6(_this_._data_48[0], 0, out._data_49, 0, _this_._totalSamples);
        break;
      case 2:
        arrayinterleave(out._data_49, 0, _this_._data_48[0], 0, _this_._data_48[1], 0, _this_._totalSamples, out._fastShortTransfer_0);
        break;
      default:var tmp1_use_0 = out._fastShortTransfer_0;
        var tmp2_use_0 = out._data_49;
        try {
          tmp1_use_0._ptr = tmp2_use_0;
          var channels_2 = _this_._channels_2;
          var inductionVariable = 0;
          if (inductionVariable < channels_2)
            do {
              var c_4 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var m_5 = c_4;
              var inductionVariable_0 = 0;
              var last_1 = _this_._totalSamples;
              if (inductionVariable_0 < last_1)
                do {
                  var n_7 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var tmp0_set_0_8 = m_5;
                  var tmp1_set_0_9 = _this_.get_27zxwg_k$(c_4, n_7);
                  tmp1_use_0._ptr[tmp0_set_0_8] = tmp1_set_0_9;
                  m_5 = m_5 + channels_2 | 0;
                }
                 while (inductionVariable_0 < last_1);
            }
             while (inductionVariable < channels_2);
        }finally {
          tmp1_use_0._ptr = EmptyShortArray;
        }

        break;
    }
    return out;
  }
  function interleaved$default(_this_, out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      out = AudioSamplesInterleaved_init_$Create$(_this_._channels_2, _this_._totalSamples, null, 4, null);
    }return interleaved(_this_, out);
  }
  function IAudioSamples() {
  }
  IAudioSamples.$metadata$ = {
    simpleName: 'IAudioSamples',
    kind: 'interface',
    interfaces: []
  };
  function AudioSamplesDeque(channels) {
    this._channels_4 = channels;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this._channels_4;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = ShortArrayDeque_init_$Create$(0, 1, null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._buffer_28 = tmp_2;
  }
  AudioSamplesDeque.prototype._get_availableRead__0_k$ = function () {
    var tmp0_safe_receiver = getOrNull_0(this._buffer_28, 0);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_availableRead__0_k$();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  AudioSamplesDeque.prototype._get_availableReadMax__0_k$ = function () {
    var tmp0_map_0 = this._buffer_28;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0.length);
    var indexedObject = tmp0_map_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_2bq_k$(item_2_3._get_availableRead__0_k$());
      Unit_getInstance();
    }
    var tmp0_elvis_lhs = maxOrNull(tmp0_mapTo_0_1);
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
  AudioSamplesDeque.prototype.write_fo50v8_k$ = function (samples, offset_0, len) {
    var inductionVariable = 0;
    var last_1 = samples._channels_2;
    if (inductionVariable < last_1)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.write_vmlb5n_k$(channel, samples.get_ha5a7z_k$(channel), offset_0, len);
      }
       while (inductionVariable < last_1);
  };
  AudioSamplesDeque.prototype.write_vmlb5n_k$ = function (channel, data, offset_0, len) {
    this._buffer_28[channel].write_br01yt_k$(data, offset_0, len);
    Unit_getInstance();
  };
  AudioSamplesDeque.prototype.read_cmb8c5_k$ = function (out, offset_0, len) {
    var tmp0_min_0 = this._get_availableRead__0_k$();
    var result = Math.min(len, tmp0_min_0);
    var inductionVariable = 0;
    var last_1 = out._channels_2;
    if (inductionVariable < last_1)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._buffer_28[channel].read_br01yt_k$(out.get_ha5a7z_k$(channel), offset_0, len);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    return result;
  };
  AudioSamplesDeque.prototype.read$default_ejrj0z_k$ = function (out, offset_0, len, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset_0 = 0;
    if (!(($mask0 & 4) === 0))
      len = out._totalSamples - offset_0 | 0;
    return this.read_cmb8c5_k$(out, offset_0, len);
  };
  AudioSamplesDeque.prototype.toString = function () {
    return '' + 'AudioSamplesDeque(channels=' + this._channels_4 + ', availableRead=' + this._get_availableRead__0_k$() + ')';
  };
  AudioSamplesDeque.$metadata$ = {
    simpleName: 'AudioSamplesDeque',
    kind: 'class',
    interfaces: []
  };
  function Companion_189() {
    Companion_instance_188 = this;
  }
  Companion_189.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_188;
  function Companion_getInstance_188() {
    if (Companion_instance_188 == null)
      new Companion_189();
    return Companion_instance_188;
  }
  function AudioStream(rate, channels) {
    Companion_getInstance_188();
    this._rate_0 = rate;
    this._channels_5 = channels;
    this._finished_1 = false;
    this._totalLengthInSamples = null;
    this._currentPositionInSamples = new Long(0, 0);
  }
  AudioStream.prototype._get_channels__0_k$ = function () {
    return this._channels_5;
  };
  AudioStream.prototype._get_finished__0_k$ = function () {
    return this._finished_1;
  };
  AudioStream.prototype._set_currentPositionInSamples__kdfck9_k$ = function (_set___) {
    this._currentPositionInSamples = _set___;
  };
  AudioStream.prototype._set_currentTime__zah5t7_k$ = function (value) {
    this._set_currentPositionInSamples__kdfck9_k$(numberToLong(_TimeSpan___get_seconds__impl_(value) * this._rate_0));
  };
  AudioStream.prototype.read_cmb8c5_k$ = function (out, offset_0, length, $cont) {
    return 0;
  };
  AudioStream.prototype.close_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  AudioStream.$metadata$ = {
    simpleName: 'AudioStream',
    kind: 'class',
    interfaces: [AudioStreamable, Closeable]
  };
  function toData(_this_, maxSamples, $cont) {
    var tmp = new $toDataCOROUTINE$21(_this_, maxSamples, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function toData$default(_this_, maxSamples, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      maxSamples = 13230000;
    return toData(_this_, maxSamples, $cont);
  }
  function $toDataCOROUTINE$21(_this_, maxSamples, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__154 = _this_;
    this._maxSamples = maxSamples;
  }
  $toDataCOROUTINE$21.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._out0_0 = new AudioSamplesDeque(this.__this__154._channels_5);
            var tmp_0 = this;
            tmp_0._buffer1_0 = AudioSamples_init_$Create$(this.__this__154._channels_5, 65536, null, 4, null);
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 8;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!!this.__this__154._get_finished__0_k$()) {
              this._state_1 = 6;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = this.__this__154.read_cmb8c5_k$(this._buffer1_0, 0, this._buffer1_0._totalSamples, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var read_0 = suspendResult;
            if (read_0 <= 0) {
              this._state_1 = 6;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this._out0_0.write_fo50v8_k$(this._buffer1_0, 0, read_0);
            if (this._out0_0._get_availableRead__0_k$() >= this._maxSamples) {
              this._state_1 = 6;
              continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._state_1 = 2;
            continue $sm;
          case 6:
            this._tmp$ret$02_1 = Unit_getInstance();
            this._exceptionState = 9;
            this._state_1 = 7;
            continue $sm;
          case 7:
            this.__this__154.close_sv8swh_k$();
            var maxOutSamples = this._out0_0._get_availableReadMax__0_k$();
            var tmp0_apply_0 = AudioSamples_init_$Create$(this.__this__154._channels_5, maxOutSamples, null, 4, null);
            this._out0_0.read$default_ejrj0z_k$(tmp0_apply_0, 0, 0, 6, null);
            Unit_getInstance();
            return new AudioData(this.__this__154._rate_0, tmp0_apply_0);
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this.__this__154.close_sv8swh_k$();
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $toDataCOROUTINE$21.$metadata$ = {
    simpleName: '$toDataCOROUTINE$21',
    kind: 'class',
    interfaces: []
  };
  function AudioStreamable() {
  }
  AudioStreamable.$metadata$ = {
    simpleName: 'AudioStreamable',
    kind: 'interface',
    interfaces: []
  };
  function $waitCOROUTINE$22(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__155 = _this_;
  }
  $waitCOROUTINE$22.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this.__this__155._get_availableSamples__0_k$() > 0)) {
              this._state_1 = 3;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = delay_0(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(10.0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $waitCOROUTINE$22.$metadata$ = {
    simpleName: '$waitCOROUTINE$22',
    kind: 'class',
    interfaces: []
  };
  function PlatformAudioOutput(coroutineContext, frequency) {
    this._coroutineContext_2 = coroutineContext;
    this._frequency = frequency;
    this._availableSamples = 0;
    this._pitch = 1.0;
    this._volume = 1.0;
    this._panning = 0.0;
  }
  PlatformAudioOutput.prototype._get_coroutineContext__0_k$ = function () {
    return this._coroutineContext_2;
  };
  PlatformAudioOutput.prototype._get_availableSamples__0_k$ = function () {
    return this._availableSamples;
  };
  PlatformAudioOutput.prototype._set_pitch__okcceq_k$ = function (_set___) {
    this._pitch = _set___;
  };
  PlatformAudioOutput.prototype._get_pitch__0_k$ = function () {
    return this._pitch;
  };
  PlatformAudioOutput.prototype._set_volume__okcceq_k$ = function (_set___) {
    this._volume = _set___;
  };
  PlatformAudioOutput.prototype._get_volume__0_k$ = function () {
    return this._volume;
  };
  PlatformAudioOutput.prototype._set_panning__okcceq_k$ = function (_set___) {
    this._panning = _set___;
  };
  PlatformAudioOutput.prototype._get_panning__0_k$ = function () {
    return this._panning;
  };
  PlatformAudioOutput.prototype.add_fo50v8_k$ = function (samples, offset_0, size_2, $cont) {
    return delay_0(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(100.0), $cont);
  };
  PlatformAudioOutput.prototype.start_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  PlatformAudioOutput.prototype.stop_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  PlatformAudioOutput.prototype.wait_sv8swh_k$ = function ($cont) {
    var tmp = new $waitCOROUTINE$22(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  PlatformAudioOutput.$metadata$ = {
    simpleName: 'PlatformAudioOutput',
    kind: 'class',
    interfaces: [Disposable, SoundProps]
  };
  function _no_name_provided__385($stream, resultContinuation) {
    this._$stream = $stream;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__385.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__385.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__385.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$stream.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__385.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__385(this._$stream, completion);
    return i;
  };
  _no_name_provided__385.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $createSoundCOROUTINE$23(_this_, data, streaming, props, name, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__156 = _this_;
    this._data_50 = data;
    this._streaming = streaming;
    this._props_11 = props;
    this._name_25 = name;
  }
  $createSoundCOROUTINE$23.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._state_1 = 1;
            var tmp_0 = this.__this__156._get_audioFormats__0_k$();
            suspendResult = tmp_0.decodeStreamOrError_bfyly4_k$(openAsync$default(this._data_50, null, 1, null), this._props_11, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._stream0 = suspendResult;
            if (this._streaming) {
              this._state_1 = 4;
              suspendResult = this.__this__156.createStreamingSound$default_xj4dbl_k$(this._stream0, true, this._name_25, null, 8, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              suspendResult = toData$default(this._stream0, 0, 1, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 2:
            this._ARGUMENT2_5 = suspendResult;
            this._state_1 = 3;
            suspendResult = this.__this__156.createNonStreamingSound_m8m7dv_k$(this._ARGUMENT2_5, this._name_25, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._WHEN_RESULT1_9 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 4:
            this._WHEN_RESULT1_9 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT1_9;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$23.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$23',
    kind: 'class',
    interfaces: []
  };
  function $createSoundCOROUTINE$24(_this_, vfs, path_0, streaming, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__157 = _this_;
    this._vfs_5 = vfs;
    this._path_27 = path_0;
    this._streaming_0 = streaming;
    this._props_12 = props;
  }
  $createSoundCOROUTINE$24.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            if (this._streaming_0) {
              this._vfsFile1 = this._vfs_5.file_6wfw3l_k$(this._path_27);
              if (this._props_12._readInMemory) {
                this._state_1 = 4;
                suspendResult = this._vfsFile1.readAll_0_k$(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._state_1 = 3;
                suspendResult = this._vfsFile1.open$default_da58he_k$(null, 1, null, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            } else {
              this._state_1 = 1;
              suspendResult = this._vfs_5.file_6wfw3l_k$(this._path_27).read_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT3_5 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__157.createSound_ki5eet_k$(this._ARGUMENT3_5, this._streaming_0, this._props_12, _get_baseName_(this._vfs_5.get_6wfw3l_k$(this._path_27)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._WHEN_RESULT0_6 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 3:
            this._WHEN_RESULT2_2 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 4:
            this._ARGUMENT4_2 = suspendResult;
            var tmp_0 = this;
            tmp_0._WHEN_RESULT2_2 = openAsync$default(this._ARGUMENT4_2, null, 1, null);
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._stream5 = this._WHEN_RESULT2_2;
            this._state_1 = 6;
            suspendResult = this.__this__157._get_audioFormats__0_k$().decodeStreamOrError_bfyly4_k$(this._stream5, this._props_12, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._ARGUMENT6_2 = suspendResult;
            this._state_1 = 7;
            var tmp_1 = _get_baseName_(this._vfsFile1);
            suspendResult = this.__this__157.createStreamingSound$default_xj4dbl_k$(this._ARGUMENT6_2, false, tmp_1, _no_name_provided_$factory_330(this._stream5, null), 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._WHEN_RESULT0_6 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 8:
            return this._WHEN_RESULT0_6;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$24.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$24',
    kind: 'class',
    interfaces: []
  };
  function $createSoundCOROUTINE$25(_this_, file, streaming, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__158 = _this_;
    this._file_4 = file;
    this._streaming_1 = streaming;
    this._props_13 = props;
  }
  $createSoundCOROUTINE$25.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._file_4.getUnderlyingUnscapedFile_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_24 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__158.createSound_wn4mi5_k$(this._ARGUMENT0_24, this._streaming_1, this._props_13, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$25.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$25',
    kind: 'class',
    interfaces: []
  };
  function $createSoundCOROUTINE$26(_this_, data, formats, streaming, name, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__159 = _this_;
    this._data_51 = data;
    this._formats_3 = formats;
    this._streaming_2 = streaming;
    this._name_26 = name;
  }
  $createSoundCOROUTINE$26.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            var tmp_0 = Companion_getInstance_186();
            suspendResult = tmp_0.encodeToByteArray$default_cbf3hi_k$(this._data_51, null, null, null, 14, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_25 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__159.createSound$default_gavy51_k$(this._ARGUMENT0_25, this._streaming_2, null, this._name_26, 4, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$26.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$26',
    kind: 'class',
    interfaces: []
  };
  function NativeSoundProvider() {
    this._target_1 = 'unknown';
    this._initialized_2 = korAtomic_0(false);
    this._audioFormats = Companion_getInstance_179().invoke_p8qwsp_k$([Companion_getInstance_186()]);
  }
  NativeSoundProvider.prototype.initOnce_sv8swh_k$ = function () {
    if (!this._initialized_2._get_value__0_k$()) {
      this._initialized_2._set_value__rpwsgn_k$(true);
      this.init_sv8swh_k$();
    }};
  NativeSoundProvider.prototype.createAudioStream_xvpyth_k$ = function (coroutineContext, freq) {
    return new PlatformAudioOutput(coroutineContext, freq);
  };
  NativeSoundProvider.prototype.init_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  NativeSoundProvider.prototype.createSound_ki5eet_k$ = function (data, streaming, props, name, $cont) {
    var tmp = new $createSoundCOROUTINE$23(this, data, streaming, props, name, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  NativeSoundProvider.prototype.createSound$default_gavy51_k$ = function (data, streaming, props, name, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      streaming = false;
    if (!(($mask0 & 4) === 0))
      props = Companion_getInstance_180()._DEFAULT_3;
    if (!(($mask0 & 8) === 0))
      name = 'Unknown';
    return $handler == null ? this.createSound_ki5eet_k$(data, streaming, props, name, $cont) : $handler(data, streaming, props, name);
  };
  NativeSoundProvider.prototype._get_audioFormats__0_k$ = function () {
    return this._audioFormats;
  };
  NativeSoundProvider.prototype.createSound_nsnru2_k$ = function (vfs, path_0, streaming, props, $cont) {
    var tmp = new $createSoundCOROUTINE$24(this, vfs, path_0, streaming, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  NativeSoundProvider.prototype.createSound$default_tfgdmb_k$ = function (vfs, path_0, streaming, props, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      streaming = false;
    if (!(($mask0 & 8) === 0))
      props = Companion_getInstance_180()._DEFAULT_3;
    return $handler == null ? this.createSound_nsnru2_k$(vfs, path_0, streaming, props, $cont) : $handler(vfs, path_0, streaming, props);
  };
  NativeSoundProvider.prototype.createSound_wn4mi5_k$ = function (file, streaming, props, $cont) {
    return this.createSound_nsnru2_k$(file._get_vfs__0_k$(), file._get_path__0_k$(), streaming, props, $cont);
  };
  NativeSoundProvider.prototype.createSound_ext5mv_k$ = function (file, streaming, props, $cont) {
    var tmp = new $createSoundCOROUTINE$25(this, file, streaming, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  NativeSoundProvider.prototype.createNonStreamingSound_m8m7dv_k$ = function (data, name, $cont) {
    var tmp = toStream(data);
    return this.createStreamingSound$default_xj4dbl_k$(tmp, true, name, null, 8, null, $cont);
  };
  NativeSoundProvider.prototype.createSound_7en3gj_k$ = function (data, formats, streaming, name, $cont) {
    var tmp = new $createSoundCOROUTINE$26(this, data, formats, streaming, name, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  NativeSoundProvider.prototype.createSound$default_3mmvnr_k$ = function (data, formats, streaming, name, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      formats = _get_defaultAudioFormats_();
    if (!(($mask0 & 4) === 0))
      streaming = false;
    if (!(($mask0 & 8) === 0))
      name = 'Unknown';
    return $handler == null ? this.createSound_7en3gj_k$(data, formats, streaming, name, $cont) : $handler(data, formats, streaming, name);
  };
  NativeSoundProvider.prototype.createStreamingSound_4mvr8m_k$ = function (stream, closeStream, name, onComplete, $cont) {
    return new SoundAudioStream($cont._get_context__0_k$(), stream, closeStream, name, onComplete);
  };
  NativeSoundProvider.prototype.createStreamingSound$default_xj4dbl_k$ = function (stream, closeStream, name, onComplete, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      closeStream = false;
    if (!(($mask0 & 4) === 0))
      name = 'Unknown';
    if (!(($mask0 & 8) === 0))
      onComplete = null;
    return this.createStreamingSound_4mvr8m_k$(stream, closeStream, name, onComplete, $cont);
  };
  NativeSoundProvider.$metadata$ = {
    simpleName: 'NativeSoundProvider',
    kind: 'class',
    interfaces: [Disposable]
  };
  function Sound(creationCoroutineContext) {
    this._creationCoroutineContext = creationCoroutineContext;
    this._defaultCoroutineContext = this._creationCoroutineContext;
    this._name_27 = 'UnknownNativeSound';
    this._volume_0 = 1.0;
    this._panning_0 = 0.0;
    this._pitch_0 = 1.0;
    var tmp = this;
    tmp._length_5 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
  }
  Sound.prototype._get_name__0_k$ = function () {
    return this._name_27;
  };
  Sound.prototype._set_volume__okcceq_k$ = function (_set___) {
    this._volume_0 = _set___;
  };
  Sound.prototype._get_volume__0_k$ = function () {
    return this._volume_0;
  };
  Sound.prototype._set_panning__okcceq_k$ = function (_set___) {
    this._panning_0 = _set___;
  };
  Sound.prototype._get_panning__0_k$ = function () {
    return this._panning_0;
  };
  Sound.prototype._set_pitch__okcceq_k$ = function (_set___) {
    this._pitch_0 = _set___;
  };
  Sound.prototype._get_pitch__0_k$ = function () {
    return this._pitch_0;
  };
  Sound.prototype.play_lqrtwd_k$ = function (coroutineContext, params) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  Sound.prototype.play$default_5gxx2y_k$ = function (coroutineContext, params, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      params = Companion_getInstance_189()._DEFAULT_5;
    return $handler == null ? this.play_lqrtwd_k$(coroutineContext, params) : $handler(coroutineContext, params);
  };
  Sound.prototype.play_ucpoml_k$ = function (coroutineContext, times_3, startTime) {
    return this.play_lqrtwd_k$(coroutineContext, PlaybackParameters_init_$Create$(times_3, startTime, null, 0.0, 0.0, 0.0, null, null, 252, null));
  };
  Sound.prototype.playForever_kxy3j2_k$ = function (coroutineContext, startTime) {
    return this.play_ucpoml_k$(coroutineContext, _get_infinitePlaybackTimes_(), startTime);
  };
  Sound.prototype.playForever$default_7k2zgb_k$ = function (coroutineContext, startTime, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      startTime = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    }return this.playForever_kxy3j2_k$(coroutineContext, startTime);
  };
  Sound.prototype.play_1q3i8p_k$ = function (params, $cont) {
    return this.play_lqrtwd_k$($cont._get_context__0_k$(), params);
  };
  Sound.prototype.play$default_58nnw6_k$ = function (params, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      params = Companion_getInstance_189()._DEFAULT_5;
    return this.play_1q3i8p_k$(params, $cont);
  };
  Sound.prototype.toString = function () {
    return '' + "NativeSound('" + this._get_name__0_k$() + "')";
  };
  Sound.$metadata$ = {
    simpleName: 'Sound',
    kind: 'class',
    interfaces: [SoundProps, AudioStreamable]
  };
  function PlaybackParameters_init_$Init$(times_3, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      times_3 = _PlaybackTimes___init__impl_(1);
    }if (!(($mask0 & 2) === 0)) {
      startTime = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    }if (!(($mask0 & 4) === 0)) {
      bufferTime = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.1);
    }if (!(($mask0 & 8) === 0))
      volume = 1.0;
    if (!(($mask0 & 16) === 0))
      pitch = 1.0;
    if (!(($mask0 & 32) === 0))
      panning = 0.0;
    if (!(($mask0 & 64) === 0))
      onCancel = null;
    if (!(($mask0 & 128) === 0))
      onFinish = null;
    PlaybackParameters.call($this, times_3, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish);
    return $this;
  }
  function PlaybackParameters_init_$Create$(times_3, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish, $mask0, $marker) {
    return PlaybackParameters_init_$Init$(times_3, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish, $mask0, $marker, Object.create(PlaybackParameters.prototype));
  }
  function Companion_190() {
    Companion_instance_189 = this;
    var tmp = this;
    var tmp_0 = _PlaybackTimes___init__impl_(1);
    var tmp_1 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    tmp._DEFAULT_5 = PlaybackParameters_init_$Create$(tmp_0, tmp_1, null, 0.0, 0.0, 0.0, null, null, 252, null);
  }
  Companion_190.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_189;
  function Companion_getInstance_189() {
    if (Companion_instance_189 == null)
      new Companion_190();
    return Companion_instance_189;
  }
  function PlaybackParameters(times_3, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish) {
    Companion_getInstance_189();
    this._times = times_3;
    this._startTime = startTime;
    this._bufferTime = bufferTime;
    this._volume_1 = volume;
    this._pitch_1 = pitch;
    this._panning_1 = panning;
    this._onCancel = onCancel;
    this._onFinish = onFinish;
  }
  PlaybackParameters.prototype._get_volume__0_k$ = function () {
    return this._volume_1;
  };
  PlaybackParameters.prototype._get_pitch__0_k$ = function () {
    return this._pitch_1;
  };
  PlaybackParameters.prototype._get_panning__0_k$ = function () {
    return this._panning_1;
  };
  PlaybackParameters.prototype.toString = function () {
    return '' + 'PlaybackParameters(times=' + new PlaybackTimes(this._times) + ', startTime=' + new TimeSpan(this._startTime) + ', bufferTime=' + new TimeSpan(this._bufferTime) + ', volume=' + this._volume_1 + ', pitch=' + this._pitch_1 + ', panning=' + this._panning_1 + ', onCancel=' + this._onCancel + ', onFinish=' + this._onFinish + ')';
  };
  PlaybackParameters.prototype.hashCode = function () {
    var result = PlaybackTimes__hashCode_impl(this._times);
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._startTime) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._bufferTime) | 0;
    result = imul(result, 31) + getNumberHashCode(this._volume_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._pitch_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._panning_1) | 0;
    result = imul(result, 31) + (this._onCancel == null ? 0 : hashCode(this._onCancel)) | 0;
    result = imul(result, 31) + (this._onFinish == null ? 0 : hashCode(this._onFinish)) | 0;
    return result;
  };
  PlaybackParameters.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaybackParameters))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PlaybackParameters ? other : THROW_CCE();
    if (!equals_1(new PlaybackTimes(this._times), new PlaybackTimes(tmp0_other_with_cast._times)))
      return false;
    if (!equals_1(new TimeSpan(this._startTime), new TimeSpan(tmp0_other_with_cast._startTime)))
      return false;
    if (!equals_1(new TimeSpan(this._bufferTime), new TimeSpan(tmp0_other_with_cast._bufferTime)))
      return false;
    if (!equals_1(this._volume_1, tmp0_other_with_cast._volume_1))
      return false;
    if (!equals_1(this._pitch_1, tmp0_other_with_cast._pitch_1))
      return false;
    if (!equals_1(this._panning_1, tmp0_other_with_cast._panning_1))
      return false;
    if (!equals_1(this._onCancel, tmp0_other_with_cast._onCancel))
      return false;
    if (!equals_1(this._onFinish, tmp0_other_with_cast._onFinish))
      return false;
    return true;
  };
  PlaybackParameters.$metadata$ = {
    simpleName: 'PlaybackParameters',
    kind: 'class',
    interfaces: [ReadonlySoundProps]
  };
  function SoundProps() {
  }
  SoundProps.$metadata$ = {
    simpleName: 'SoundProps',
    kind: 'interface',
    interfaces: [ReadonlySoundProps]
  };
  function SoundChannel(sound) {
    this._sound = sound;
    var tmp = this;
    tmp._$$delegate_0_29 = Mixin_init_$Create$(null, 1, null);
    this._startTime_0 = Companion_getInstance_82().now_utobi1_k$();
    this._volume_2 = 1.0;
    this._pitch_2 = 1.0;
    this._panning_2 = 0.0;
  }
  SoundChannel.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_29._set_extra__n1onou_k$(_set___);
  };
  SoundChannel.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_29._get_extra__0_k$();
  };
  SoundChannel.prototype._set_volume__okcceq_k$ = function (_set___) {
    this._volume_2 = _set___;
  };
  SoundChannel.prototype._get_volume__0_k$ = function () {
    return this._volume_2;
  };
  SoundChannel.prototype._set_pitch__okcceq_k$ = function (_set___) {
    this._pitch_2 = _set___;
  };
  SoundChannel.prototype._get_pitch__0_k$ = function () {
    return this._pitch_2;
  };
  SoundChannel.prototype._set_panning__okcceq_k$ = function (_set___) {
    this._panning_2 = _set___;
  };
  SoundChannel.prototype._get_panning__0_k$ = function () {
    return this._panning_2;
  };
  SoundChannel.$metadata$ = {
    simpleName: 'SoundChannel',
    kind: 'class',
    interfaces: [SoundChannelBase, Extra]
  };
  function _PlaybackTimes___init__impl_(count_0) {
    return count_0;
  }
  function _PlaybackTimes___get_count__impl_(this_0) {
    return this_0;
  }
  function Companion_191() {
    Companion_instance_190 = this;
    this._ZERO_3 = _PlaybackTimes___init__impl_(0);
    this._ONE_0 = _PlaybackTimes___init__impl_(1);
    this._INFINITE = _PlaybackTimes___init__impl_(-1);
  }
  Companion_191.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_190;
  function Companion_getInstance_190() {
    if (Companion_instance_190 == null)
      new Companion_191();
    return Companion_instance_190;
  }
  function _PlaybackTimes___get_hasMore__impl_(this_0) {
    return !equals_1(new PlaybackTimes(this_0), new PlaybackTimes(Companion_getInstance_190()._ZERO_3));
  }
  function _PlaybackTimes___get_oneLess__impl_(this_0) {
    return equals_1(new PlaybackTimes(this_0), new PlaybackTimes(Companion_getInstance_190()._INFINITE)) ? Companion_getInstance_190()._INFINITE : _PlaybackTimes___init__impl_(_PlaybackTimes___get_count__impl_(this_0) - 1 | 0);
  }
  function PlaybackTimes__toString_impl(this_0) {
    return _PlaybackTimes___get_count__impl_(this_0) >= 0 ? '' + _PlaybackTimes___get_count__impl_(this_0) + ' times' : 'Infinite times';
  }
  function PlaybackTimes__hashCode_impl(this_0) {
    return this_0;
  }
  function PlaybackTimes__equals_impl(this_0, other) {
    if (!(other instanceof PlaybackTimes))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PlaybackTimes ? other._count_8 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function PlaybackTimes(count_0) {
    Companion_getInstance_190();
    this._count_8 = count_0;
  }
  PlaybackTimes.prototype.toString = function () {
    return PlaybackTimes__toString_impl(this._count_8);
  };
  PlaybackTimes.prototype.hashCode = function () {
    return PlaybackTimes__hashCode_impl(this._count_8);
  };
  PlaybackTimes.prototype.equals = function (other) {
    return PlaybackTimes__equals_impl(this._count_8, other);
  };
  PlaybackTimes.$metadata$ = {
    simpleName: 'PlaybackTimes',
    kind: 'class',
    interfaces: []
  };
  function _get_infinitePlaybackTimes_() {
    return Companion_getInstance_190()._INFINITE;
  }
  function ReadonlySoundProps() {
  }
  ReadonlySoundProps.$metadata$ = {
    simpleName: 'ReadonlySoundProps',
    kind: 'interface',
    interfaces: []
  };
  function SoundChannelBase() {
  }
  SoundChannelBase.$metadata$ = {
    simpleName: 'SoundChannelBase',
    kind: 'interface',
    interfaces: [SoundProps]
  };
  function copySoundPropsFrom(_this_, other) {
    _this_._set_volume__okcceq_k$(other._get_volume__0_k$());
    _this_._set_pitch__okcceq_k$(other._get_pitch__0_k$());
    _this_._set_panning__okcceq_k$(other._get_panning__0_k$());
  }
  function readSound(_this_, props, streaming, $cont) {
    return _get_nativeSoundProvider_().createSound_ext5mv_k$(_this_, streaming, props, $cont);
  }
  function readSound$default(_this_, props, streaming, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      props = Companion_getInstance_180()._DEFAULT_3;
    if (!(($mask0 & 2) === 0))
      streaming = false;
    return readSound(_this_, props, streaming, $cont);
  }
  function _no_name_provided_$factory_330($stream, resultContinuation) {
    var i = new _no_name_provided__385($stream, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function play$close(job) {
    job.cancel$default_44too_k$(null, 1, null);
  }
  function _no_name_provided__386(this$0, $params, $playing, $nas, $paused, resultContinuation) {
    this._this$0_115 = this$0;
    this._$params = $params;
    this._$playing = $playing;
    this._$nas = $nas;
    this._$paused = $paused;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__386.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__386.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__386.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 24;
            this._state_1 = 1;
            suspendResult = this._this$0_115._stream_0.clone_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._stream0_0 = suspendResult;
            this._stream0_0._set_currentTime__zah5t7_k$(this._$params._startTime);
            this._$playing._v = true;
            this._times1 = this._$params._times;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 16;
            this._exceptionState = 15;
            var tmp_0 = this;
            tmp_0._temp3 = AudioSamples_init_$Create$(this._stream0_0._channels_5, 1024, null, 4, null);
            this._nchannels4 = 2;
            this._minBuf5 = numberToInt(imul(this._stream0_0._rate_0, this._nchannels4) * _TimeSpan___get_seconds__impl_(this._$params._bufferTime));
            this._$nas.start_sv8swh_k$();
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (!_PlaybackTimes___get_hasMore__impl_(this._times1)) {
              this._state_1 = 14;
              continue $sm;
            }
            this._state_1 = 4;
            continue $sm;
          case 4:
            if (!!this._stream0_0._get_finished__0_k$()) {
              this._state_1 = 13;
              continue $sm;
            }
            this._state_1 = 5;
            continue $sm;
          case 5:
            if (!this._$paused._v) {
              this._state_1 = 7;
              continue $sm;
            }
            this._state_1 = 6;
            suspendResult = delay_0(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(2.0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._state_1 = 5;
            continue $sm;
          case 7:
            this._state_1 = 8;
            suspendResult = this._stream0_0.read_cmb8c5_k$(this._temp3, 0, this._temp3._totalSamples, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._read6_0 = suspendResult;
            this._state_1 = 9;
            suspendResult = this._$nas.add_fo50v8_k$(this._temp3, 0, this._read6_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._state_1 = 10;
            continue $sm;
          case 10:
            var containsLower = this._minBuf5;
            var containsUpper = imul(this._minBuf5, 2);
            var containsArg = this._$nas._get_availableSamples__0_k$();
            if (!(containsLower <= containsArg ? containsArg <= containsUpper : false)) {
              this._state_1 = 12;
              continue $sm;
            } else {
            }

            this._state_1 = 11;
            suspendResult = delay_0(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(2.0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._state_1 = 10;
            continue $sm;
          case 12:
            this._state_1 = 4;
            continue $sm;
          case 13:
            this._times1 = _PlaybackTimes___get_oneLess__impl_(this._times1);
            this._stream0_0._set_currentPositionInSamples__kdfck9_k$(new Long(0, 0));
            this._state_1 = 3;
            continue $sm;
          case 14:
            this._tmp$ret$02_2 = Unit_getInstance();
            this._exceptionState = 24;
            this._state_1 = 20;
            continue $sm;
          case 15:
            this._exceptionState = 16;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof CancellationException) {
              this._e7 = this._exception_0;
              var tmp_2 = this;
              var tmp0_safe_receiver = this._$params._onCancel;
              if (tmp0_safe_receiver == null)
                null;
              else
                tmp0_safe_receiver();
              tmp_2._tmp$ret$02_2 = Unit_getInstance();
              this._exceptionState = 24;
              this._state_1 = 20;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 16:
            this._exceptionState = 24;
            this._t8 = this._exception_0;
            this._state_1 = 17;
            suspendResult = this._$nas.wait_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 17:
            this._$nas.stop_sv8swh_k$();
            if (this._this$0_115._closeStream_0) {
              this._stream0_0.close_sv8swh_k$();
            }
            this._$playing._v = false;
            var tmp1_safe_receiver = this._$params._onFinish;
            if (tmp1_safe_receiver == null)
              null;
            else
              tmp1_safe_receiver();
            Unit_getInstance();
            this._tmp2_safe_receiver9 = this._this$0_115._onComplete;
            if (this._tmp2_safe_receiver9 == null) {
              this._WHEN_RESULT10 = null;
              this._state_1 = 19;
              continue $sm;
            } else {
              this._state_1 = 18;
              suspendResult = this._tmp2_safe_receiver9(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 18:
            this._WHEN_RESULT10 = suspendResult;
            this._state_1 = 19;
            continue $sm;
          case 19:
            Unit_getInstance();
            throw this._t8;
          case 20:
            this._state_1 = 21;
            suspendResult = this._$nas.wait_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 21:
            this._$nas.stop_sv8swh_k$();
            if (this._this$0_115._closeStream_0) {
              this._stream0_0.close_sv8swh_k$();
            }
            this._$playing._v = false;
            var tmp1_safe_receiver_0 = this._$params._onFinish;
            if (tmp1_safe_receiver_0 == null)
              null;
            else
              tmp1_safe_receiver_0();
            Unit_getInstance();
            this._tmp2_safe_receiver11 = this._this$0_115._onComplete;
            if (this._tmp2_safe_receiver11 == null) {
              this._WHEN_RESULT12 = null;
              this._state_1 = 23;
              continue $sm;
            } else {
              this._state_1 = 22;
              suspendResult = this._tmp2_safe_receiver11(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 22:
            this._WHEN_RESULT12 = suspendResult;
            this._state_1 = 23;
            continue $sm;
          case 23:
            Unit_getInstance();
            return Unit_getInstance();
          case 24:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 24) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__386.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__386(this._this$0_115, this._$params, this._$playing, this._$nas, this._$paused, completion);
    return i;
  };
  _no_name_provided__386.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__387($nas, this$0, $paused, $playing, $job) {
    this._$nas_0 = $nas;
    this._this$0_116 = this$0;
    this._$paused_0 = $paused;
    this._$playing_0 = $playing;
    this._$job_0 = $job;
    SoundChannel.call(this, this$0._nativeSound);
    this._volume$delegate = volume$factory(this._$nas_0);
    this._pitch$delegate = pitch$factory(this._$nas_0);
    this._panning$delegate = panning$factory(this._$nas_0);
  }
  _no_name_provided__387.prototype._set_volume__okcceq_k$ = function (_set___) {
    var tmp0_setValue_0 = volume$factory_0();
    return this._volume$delegate.set(_set___);
  };
  _no_name_provided__387.prototype._get_volume__0_k$ = function () {
    var tmp0_getValue_0 = volume$factory_1();
    return this._volume$delegate.get();
  };
  _no_name_provided__387.prototype._set_pitch__okcceq_k$ = function (_set___) {
    var tmp0_setValue_0 = pitch$factory_0();
    return this._pitch$delegate.set(_set___);
  };
  _no_name_provided__387.prototype._get_pitch__0_k$ = function () {
    var tmp0_getValue_0 = pitch$factory_1();
    return this._pitch$delegate.get();
  };
  _no_name_provided__387.prototype._set_panning__okcceq_k$ = function (_set___) {
    var tmp0_setValue_0 = panning$factory_0();
    return this._panning$delegate.set(_set___);
  };
  _no_name_provided__387.prototype._get_panning__0_k$ = function () {
    var tmp0_getValue_0 = panning$factory_1();
    return this._panning$delegate.get();
  };
  _no_name_provided__387.prototype.stop_sv8swh_k$ = function () {
    return play$close(this._$job_0);
  };
  _no_name_provided__387.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SoundAudioStream(coroutineContext, stream, closeStream, name, onComplete) {
    Sound.call(this, coroutineContext);
    this._stream_0 = stream;
    this._closeStream_0 = closeStream;
    this._name_28 = name;
    this._onComplete = onComplete;
    this._nativeSound = this;
  }
  SoundAudioStream.prototype._get_name__0_k$ = function () {
    return this._name_28;
  };
  SoundAudioStream.prototype.play_lqrtwd_k$ = function (coroutineContext, params) {
    var nas = _get_nativeSoundProvider_().createAudioStream_xvpyth_k$(coroutineContext, this._stream_0._rate_0);
    copySoundPropsFrom(nas, params);
    var playing = {_v: true};
    var paused = {_v: false};
    var job = launchImmediately(coroutineContext, _no_name_provided_$factory_331(this, params, playing, nas, paused, null));
    return new _no_name_provided__387(nas, this, paused, playing, job);
  };
  SoundAudioStream.$metadata$ = {
    simpleName: 'SoundAudioStream',
    kind: 'class',
    interfaces: []
  };
  function volume$factory($b0) {
    return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
      return $b0._get_volume__0_k$();
    }, function (value) {
      return $b0._set_volume__okcceq_k$(value);
    });
  }
  function pitch$factory($b0) {
    return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
      return $b0._get_pitch__0_k$();
    }, function (value) {
      return $b0._set_pitch__okcceq_k$(value);
    });
  }
  function panning$factory($b0) {
    return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
      return $b0._get_panning__0_k$();
    }, function (value) {
      return $b0._set_panning__okcceq_k$(value);
    });
  }
  function volume$factory_0() {
    return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
      return receiver._get_volume__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_volume__okcceq_k$(value);
    });
  }
  function volume$factory_1() {
    return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
      return receiver._get_volume__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_volume__okcceq_k$(value);
    });
  }
  function pitch$factory_0() {
    return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
      return receiver._get_pitch__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_pitch__okcceq_k$(value);
    });
  }
  function pitch$factory_1() {
    return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
      return receiver._get_pitch__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_pitch__okcceq_k$(value);
    });
  }
  function panning$factory_0() {
    return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
      return receiver._get_panning__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_panning__okcceq_k$(value);
    });
  }
  function panning$factory_1() {
    return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
      return receiver._get_panning__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_panning__okcceq_k$(value);
    });
  }
  function _no_name_provided_$factory_331(this$0, $params, $playing, $nas, $paused, resultContinuation) {
    var i = new _no_name_provided__386(this$0, $params, $playing, $nas, $paused, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function $createSoundCOROUTINE$32(_this_, data, streaming, props, name, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__160 = _this_;
    this._data_52 = data;
    this._streaming_3 = streaming;
    this._props_14 = props;
    this._name_29 = name;
  }
  $createSoundCOROUTINE$32.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = HtmlSimpleSound_getInstance().loadSound_b1bk5f_k$(this._data_52, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = AudioBufferOrHTMLMediaElement_init_$Create$(ARGUMENT);
            return new AudioBufferSound(ARGUMENT_0, '#bytes', this._get_context__0_k$(), this._name_29);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$32.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$32',
    kind: 'class',
    interfaces: []
  };
  function $createSoundCOROUTINE$33(_this_, vfs, path_0, streaming, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__161 = _this_;
    this._vfs_6 = vfs;
    this._path_28 = path_0;
    this._streaming_4 = streaming;
    this._props_15 = props;
  }
  $createSoundCOROUTINE$33.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._tmp0_subject0_0 = this._vfs_6;
            var tmp_0;
            var tmp_1 = this._tmp0_subject0_0;
            if (tmp_1 instanceof LocalVfs) {
              tmp_0 = true;
            } else {
              {
                var tmp_2 = this._tmp0_subject0_0;
                tmp_0 = tmp_2 instanceof UrlVfs_0;
              }
            }

            if (tmp_0) {
              var tmp_3 = this;
              var tmp1_subject = this._vfs_6;
              var tmp_4;
              if (tmp1_subject instanceof LocalVfs) {
                tmp_4 = this._path_28;
              } else {
                if (tmp1_subject instanceof UrlVfs_0) {
                  tmp_4 = this._vfs_6.getFullUrl_6wfw3l_k$(this._path_28);
                } else {
                  {
                    _get_invalidOp_();
                  }
                }
              }
              tmp_3._url2 = tmp_4;
              if (this._streaming_4) {
                var tmp_5 = this;
                var tmp_6 = AudioBufferOrHTMLMediaElement_init_$Create$_0(HtmlSimpleSound_getInstance().loadSoundBuffer_6wfw3l_k$(this._url2));
                var tmp_7 = this._get_context__0_k$();
                tmp_5._WHEN_RESULT3_1 = AudioBufferSound_init_$Create$(tmp_6, this._url2, tmp_7, null, 8, null);
                this._state_1 = 4;
                continue $sm;
              } else {
                this._state_1 = 2;
                suspendResult = HtmlSimpleSound_getInstance().loadSound_6wfw3l_k$(this._url2, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            } else {
              {
                this._state_1 = 1;
                suspendResult = NativeSoundProvider.prototype.createSound$default_tfgdmb_k$.call(this.__this__161, this._vfs_6, this._path_28, false, null, 12, NativeSoundProvider.prototype.createSound_nsnru2_k$.bind(this.__this__161), this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            }

            break;
          case 1:
            this._WHEN_RESULT1_10 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = AudioBufferOrHTMLMediaElement_init_$Create$(ARGUMENT);
            var tmp_8 = this;
            var tmp_9 = this._get_context__0_k$();
            tmp_8._WHEN_RESULT3_1 = AudioBufferSound_init_$Create$(ARGUMENT_0, this._url2, tmp_9, null, 8, null);
            this._state_1 = 4;
            continue $sm;
          case 3:
            throw this._exception_0;
          case 4:
            this._WHEN_RESULT1_10 = this._WHEN_RESULT3_1;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT1_10;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$33.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$33',
    kind: 'class',
    interfaces: []
  };
  function HtmlNativeSoundProvider() {
    NativeSoundProvider.call(this);
  }
  HtmlNativeSoundProvider.prototype.init_sv8swh_k$ = function () {
    HtmlSimpleSound_getInstance().ensureUnlockStart_sv8swh_k$();
  };
  HtmlNativeSoundProvider.prototype.createAudioStream_xvpyth_k$ = function (coroutineContext, freq) {
    return new JsPlatformAudioOutput(coroutineContext, freq);
  };
  HtmlNativeSoundProvider.prototype.createSound_ki5eet_k$ = function (data, streaming, props, name, $cont) {
    var tmp = new $createSoundCOROUTINE$32(this, data, streaming, props, name, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HtmlNativeSoundProvider.prototype.createSound_nsnru2_k$ = function (vfs, path_0, streaming, props, $cont) {
    var tmp = new $createSoundCOROUTINE$33(this, vfs, path_0, streaming, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HtmlNativeSoundProvider.$metadata$ = {
    simpleName: 'HtmlNativeSoundProvider',
    kind: 'class',
    interfaces: []
  };
  function AudioBufferSound_init_$Init$(buffer, url, coroutineContext, name, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      name = 'unknown';
    AudioBufferSound.call($this, buffer, url, coroutineContext, name);
    return $this;
  }
  function AudioBufferSound_init_$Create$(buffer, url, coroutineContext, name, $mask0, $marker) {
    return AudioBufferSound_init_$Init$(buffer, url, coroutineContext, name, $mask0, $marker, Object.create(AudioBufferSound.prototype));
  }
  function _no_name_provided__388($channel) {
    this._$channel = $channel;
  }
  _no_name_provided__388.prototype.invoke_89eg7z_k$ = function (it) {
    var tmp0_safe_receiver = this._$channel;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.play_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__388.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_89eg7z_k$(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__388.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__389(this$0, $channel) {
    this._this$0_117 = this$0;
    this._$channel_0 = $channel;
    SoundChannel.call(this, this$0);
    var tmp = this;
    var tmp0_safe_receiver = this._this$0_117._buffer_29;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_duration__0_k$();
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = Companion_getInstance_92().fromSeconds_ttklb2_k$(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp_1;
    var tmp_2 = tmp2_elvis_lhs;
    if ((tmp_2 == null ? null : new TimeSpan(tmp_2)) == null) {
      tmp_1 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    } else {
      {
        tmp_1 = tmp2_elvis_lhs;
      }
    }
    tmp._total = tmp_1;
  }
  _no_name_provided__389.prototype._set_volume__okcceq_k$ = function (value) {
    var tmp0_safe_receiver = this._$channel_0;
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._set_volume__okcceq_k$(value);
  };
  _no_name_provided__389.prototype._get_volume__0_k$ = function () {
    var tmp0_safe_receiver = this._$channel_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._volume_3;
    return tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
  };
  _no_name_provided__389.prototype._set_pitch__okcceq_k$ = function (value) {
    var tmp0_safe_receiver = this._$channel_0;
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._set_pitch__okcceq_k$(value);
  };
  _no_name_provided__389.prototype._get_pitch__0_k$ = function () {
    var tmp0_safe_receiver = this._$channel_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._pitch_3;
    return tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
  };
  _no_name_provided__389.prototype._set_panning__okcceq_k$ = function (value) {
    var tmp0_safe_receiver = this._$channel_0;
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._set_panning__okcceq_k$(value);
  };
  _no_name_provided__389.prototype._get_panning__0_k$ = function () {
    var tmp0_safe_receiver = this._$channel_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._panning_3;
    return tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  };
  _no_name_provided__389.prototype.stop_sv8swh_k$ = function () {
    var tmp0_safe_receiver = this._$channel_0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.stop_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__389.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AudioBufferSound(buffer, url, coroutineContext, name) {
    Sound.call(this, coroutineContext);
    this._buffer_29 = buffer;
    this._url_4 = url;
    this._name_30 = name;
    var tmp = this;
    var tmp0_elvis_lhs = this._buffer_29._get_duration__0_k$();
    var tmp0__get_seconds__0 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    tmp._length_6 = Companion_getInstance_92().fromSeconds_ttklb2_k$(tmp0__get_seconds__0);
  }
  AudioBufferSound.prototype._get_name__0_k$ = function () {
    return this._name_30;
  };
  AudioBufferSound.prototype.play_lqrtwd_k$ = function (coroutineContext, params) {
    var channel = this._buffer_29._get_isNotNull__0_k$() ? HtmlSimpleSound_getInstance().playSound_vypghn_k$(this._buffer_29, params, coroutineContext) : null;
    var tmp = HtmlSimpleSound_getInstance();
    tmp.callOnUnlocked_v88bnd_k$(_no_name_provided_$factory_332(channel));
    Unit_getInstance();
    var tmp0_also_0 = new _no_name_provided__389(this, channel);
    copySoundPropsFrom(tmp0_also_0, params);
    return tmp0_also_0;
  };
  AudioBufferSound.$metadata$ = {
    simpleName: 'AudioBufferSound',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_332($channel) {
    var i = new _no_name_provided__388($channel);
    return function (p1) {
      i.invoke_89eg7z_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__390($htmlAudioElement, this$0, $audioBuffer) {
    this._$htmlAudioElement = $htmlAudioElement;
    this._this$0_118 = this$0;
    this._$audioBuffer = $audioBuffer;
  }
  _no_name_provided__390.prototype.invoke_my7cby_k$ = function ($this$gain) {
    if (!(this._$htmlAudioElement == null)) {
      this._this$0_118._realHtmlAudioElement = clone(this._$htmlAudioElement);
      var tmp = this._this$0_118;
      var tmp_0 = HtmlSimpleSound_getInstance();
      var tmp_1 = ensureNotNull(this._this$0_118._realHtmlAudioElement);
      tmp._sourceNode = tmp_0.source$default_y5ee1m_k$($this$gain, tmp_1, null, 2, null);
    } else if (!(this._$audioBuffer == null)) {
      var tmp_2 = this._this$0_118;
      var tmp_3 = HtmlSimpleSound_getInstance();
      tmp_2._sourceNode = tmp_3.source$default_99mref_k$($this$gain, this._$audioBuffer, null, 2, null);
    }};
  _no_name_provided__390.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_my7cby_k$((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__390.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__391($deferred) {
    this._$deferred_5 = $deferred;
  }
  _no_name_provided__391.prototype.invoke_0_k$ = function () {
    return this._$deferred_5.complete_2c5_k$(Unit_getInstance());
  };
  _no_name_provided__391.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__392($deferred) {
    this._$deferred_6 = $deferred;
  }
  _no_name_provided__392.prototype.invoke_sv8swh_k$ = function () {
    this._$deferred_6.complete_2c5_k$(Unit_getInstance());
    Unit_getInstance();
  };
  _no_name_provided__392.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__392.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__393(this$0, $htmlAudioElement, $audioBuffer) {
    this._this$0_119 = this$0;
    this._$htmlAudioElement_0 = $htmlAudioElement;
    this._$audioBuffer_0 = $audioBuffer;
  }
  _no_name_provided__393.prototype.invoke_rbuzf3_k$ = function ($this$panner) {
    var tmp = this._this$0_119;
    var tmp_0 = HtmlSimpleSound_getInstance();
    tmp._gainNode = tmp_0.gain_lkl9jk_k$($this$panner, _no_name_provided_$factory_336(this._$htmlAudioElement_0, this._this$0_119, this._$audioBuffer_0));
  };
  _no_name_provided__393.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_rbuzf3_k$((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__393.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__394(this$0, $startTime, resultContinuation) {
    this._this$0_120 = this$0;
    this._$startTime = $startTime;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__394.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__394.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__394.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 7;
            this._exceptionState = 6;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!_PlaybackTimes___get_hasMore__impl_(this._this$0_120._times_0)) {
              this._state_1 = 5;
              continue $sm;
            }
            this._this$0_120._startedAt = Companion_getInstance_82().now_utobi1_k$();
            this._this$0_120.createNode_zah5t7_k$(this._$startTime._v._milliseconds);
            this._$startTime._v = new TimeSpan(Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0));
            var tmp_0 = this;
            tmp_0._deferred1 = CompletableDeferred$default(null, 1, null);
            var tmp_1;
            if (this._this$0_120._sourceNode == null) {
              tmp_1 = true;
            } else {
              var tmp0_safe_receiver = this._this$0_120._ctx_0;
              tmp_1 = !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.state) === 'running');
            }

            if (tmp_1) {
              var tmp_2 = window;
              var tmp_3 = _no_name_provided_$factory_337(this._deferred1);
              var tmp0_asDynamic_0 = this._this$0_120._buffer_30;
              var tmp1_unsafeCast_0 = tmp0_asDynamic_0.duration;
              tmp_2.setTimeout(tmp_3, numberToInt(tmp1_unsafeCast_0 * 1000));
              Unit_getInstance();
            } else {
              {
                var tmp1_safe_receiver = this._this$0_120._sourceNode;
                if (tmp1_safe_receiver == null) {
                  Unit_getInstance();
                } else {
                  tmp1_safe_receiver.onended = _no_name_provided_$factory_338(this._deferred1);
                }
              }
            }

            this._state_1 = 3;
            suspendResult = this._deferred1.await_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._this$0_120._times_0 = _PlaybackTimes___get_oneLess__impl_(this._this$0_120._times_0);
            if (!_PlaybackTimes___get_hasMore__impl_(this._this$0_120._times_0)) {
              this._state_1 = 5;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this._state_1 = 2;
            continue $sm;
          case 5:
            this._tmp$ret$00_3 = Unit_getInstance();
            this._exceptionState = 8;
            this._state_1 = 9;
            continue $sm;
          case 6:
            this._exceptionState = 7;
            var tmp_4 = this._exception_0;
            if (tmp_4 instanceof CancellationException) {
              var e = this._exception_0;
              var tmp_5 = this;
              var tmp2_safe_receiver = this._this$0_120._params._onCancel;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver();
              tmp_5._tmp$ret$00_3 = Unit_getInstance();
              this._exceptionState = 8;
              this._state_1 = 9;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 7:
            this._exceptionState = 8;
            var t = this._exception_0;
            this._this$0_120._running_0 = false;
            var realHtmlAudioElement = this._this$0_120._realHtmlAudioElement;
            if (!(realHtmlAudioElement == null)) {
              realHtmlAudioElement.pause();
              realHtmlAudioElement.currentTime = 0.0;
            } else {
              var tmp3_safe_receiver = this._this$0_120._sourceNode;
              if (tmp3_safe_receiver == null)
                null;
              else {
                tmp3_safe_receiver.stop();
                Unit_getInstance();
              }
              Unit_getInstance();
            }

            this._this$0_120._gainNode = null;
            this._this$0_120._pannerNode = null;
            this._this$0_120._sourceNode = null;
            var tmp4_safe_receiver = this._this$0_120._params._onFinish;
            if (tmp4_safe_receiver == null)
              null;
            else
              tmp4_safe_receiver();
            Unit_getInstance();
            throw t;
          case 8:
            throw this._exception_0;
          case 9:
            this._this$0_120._running_0 = false;
            var realHtmlAudioElement_0 = this._this$0_120._realHtmlAudioElement;
            if (!(realHtmlAudioElement_0 == null)) {
              realHtmlAudioElement_0.pause();
              realHtmlAudioElement_0.currentTime = 0.0;
            } else {
              var tmp3_safe_receiver_0 = this._this$0_120._sourceNode;
              if (tmp3_safe_receiver_0 == null)
                null;
              else {
                tmp3_safe_receiver_0.stop();
                Unit_getInstance();
              }
              Unit_getInstance();
            }

            this._this$0_120._gainNode = null;
            this._this$0_120._pannerNode = null;
            this._this$0_120._sourceNode = null;
            var tmp4_safe_receiver_0 = this._this$0_120._params._onFinish;
            if (tmp4_safe_receiver_0 == null)
              null;
            else
              tmp4_safe_receiver_0();
            Unit_getInstance();
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 8) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__394.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__394(this._this$0_120, this._$startTime, completion);
    return i;
  };
  _no_name_provided__394.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__395($source) {
    this._$source_0 = $source;
  }
  _no_name_provided__395.prototype.invoke_sv8swh_k$ = function () {
    this._$source_0.disconnect(0);
    HtmlSimpleSound_getInstance()._unlocked = true;
    Console_getInstance().info_c2g51s_k$(['Web Audio was successfully unlocked']);
    HtmlSimpleSound_getInstance()._unlockDeferred.complete_2c5_k$(Unit_getInstance());
    Unit_getInstance();
  };
  _no_name_provided__395.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__395.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SimpleSoundChannel(buffer, ctx, params, coroutineContext) {
    this._buffer_30 = buffer;
    this._ctx_0 = ctx;
    this._params = params;
    this._coroutineContext_3 = coroutineContext;
    this._gainNode = null;
    this._pannerNode = null;
    this._sourceNode = null;
    this._realHtmlAudioElement = null;
    this._startedAt = Companion_getInstance_82().now_utobi1_k$();
    this._times_0 = this._params._times;
    this._volume_3 = this._params._volume_1;
    this._pitch_3 = this._params._pitch_1;
    this._panning_3 = this._params._panning_1;
    this._running_0 = true;
    this._pausedAt = null;
    this._job_2 = null;
  }
  SimpleSoundChannel.prototype.createNode_zah5t7_k$ = function (startTime) {
    var tmp0_safe_receiver = this._realHtmlAudioElement;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pause();
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._sourceNode;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.disconnect();
      Unit_getInstance();
    }
    Unit_getInstance();
    var htmlAudioElement = this._buffer_30._htmlAudioElement;
    var audioBuffer = this._buffer_30._audioBuffer;
    var tmp0_apply_0 = this._ctx_0.destination;
    var tmp = this;
    var tmp_0 = HtmlSimpleSound_getInstance();
    tmp._pannerNode = tmp_0.panner_eed2pb_k$(tmp0_apply_0, _no_name_provided_$factory_334(this, htmlAudioElement, audioBuffer));
    this.updateNodes_sv8swh_k$();
    Unit_getInstance();
    var realHtmlAudioElement = this._realHtmlAudioElement;
    if (!(realHtmlAudioElement == null)) {
      realHtmlAudioElement.currentTime = _TimeSpan___get_seconds__impl_(startTime);
      realHtmlAudioElement.play();
      Unit_getInstance();
    } else {
      var tmp2_safe_receiver = this._sourceNode;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.start(0.0, _TimeSpan___get_seconds__impl_(startTime));
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  };
  SimpleSoundChannel.prototype.createJobAt_wv9l0m_k$ = function (startTime) {
    if (_get_job_(this._coroutineContext_3)._get_isCompleted__0_k$()) {
      Console_getInstance().warn_c2g51s_k$(["Sound won't play because coroutineContext.job is completed"]);
    }this._startedAt = Companion_getInstance_82().now_utobi1_k$();
    var startTime_0 = {_v: new TimeSpan(startTime)};
    var tmp0_safe_receiver = this._ctx_0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.resume();
      Unit_getInstance();
    }
    Unit_getInstance();
    return launchImmediately(this._coroutineContext_3, _no_name_provided_$factory_335(this, startTime_0, null));
  };
  SimpleSoundChannel.prototype._set_volume__okcceq_k$ = function (value) {
    this._volume_3 = value;
    return this.updateVolume_sv8swh_k$();
  };
  SimpleSoundChannel.prototype._set_pitch__okcceq_k$ = function (value) {
    this._pitch_3 = value;
    return this.updatePitch_sv8swh_k$();
  };
  SimpleSoundChannel.prototype._set_panning__okcceq_k$ = function (value) {
    this._panning_3 = value;
    return this.updatePanning_sv8swh_k$();
  };
  SimpleSoundChannel.prototype.updateNodes_sv8swh_k$ = function () {
    this.updateVolume_sv8swh_k$();
    this.updatePitch_sv8swh_k$();
    this.updatePanning_sv8swh_k$();
  };
  SimpleSoundChannel.prototype.updateVolume_sv8swh_k$ = function () {
    var tmp0_safe_receiver = this._gainNode;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gain;
    if (tmp1_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp1_safe_receiver.value = this._volume_3;
  };
  SimpleSoundChannel.prototype.updatePitch_sv8swh_k$ = function () {
  };
  SimpleSoundChannel.prototype.updatePanning_sv8swh_k$ = function () {
    var tmp0_safe_receiver = this._pannerNode;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.setPosition(this._panning_3, 0.0, 0.0);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._pannerNode;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.setOrientation(0.0, 1.0, 0.0);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  SimpleSoundChannel.prototype.stop_sv8swh_k$ = function () {
    var tmp0_safe_receiver = this._job_2;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel$default_44too_k$(null, 1, null);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  SimpleSoundChannel.prototype.play_sv8swh_k$ = function () {
    if (!(this._job_2 == null) ? !(this._realHtmlAudioElement == null) : false) {
      var tmp0_safe_receiver = this._realHtmlAudioElement;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.play();
      Unit_getInstance();
    } else {
      this.stop_sv8swh_k$();
      this._job_2 = this.createJobAt_wv9l0m_k$(this._params._startTime);
    }
  };
  SimpleSoundChannel.$metadata$ = {
    simpleName: 'SimpleSoundChannel',
    kind: 'class',
    interfaces: []
  };
  function sam$com_soywiz_korio_lang_Cancellable$0(function_0) {
    this._function_5 = function_0;
  }
  sam$com_soywiz_korio_lang_Cancellable$0.prototype.cancel_1ti8hr_k$ = function (e) {
    return this._function_5(e);
  };
  sam$com_soywiz_korio_lang_Cancellable$0.$metadata$ = {
    simpleName: 'sam$com_soywiz_korio_lang_Cancellable$0',
    kind: 'class',
    interfaces: [Cancellable]
  };
  function _no_name_provided__396() {
  }
  _no_name_provided__396.prototype.invoke_qo8tmo_k$ = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__396.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qo8tmo_k$((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__396.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__397() {
  }
  _no_name_provided__397.prototype.invoke_5ofraw_k$ = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__397.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_5ofraw_k$((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__397.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__398($cancelled, $callback) {
    this._$cancelled = $cancelled;
    this._$callback_4 = $callback;
  }
  _no_name_provided__398.prototype.invoke_houul8_k$ = function (it) {
    if (!this._$cancelled._v)
      this._$callback_4(Unit_getInstance());
  };
  _no_name_provided__398.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_houul8_k$((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__398.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__399($cancelled) {
    this._$cancelled_0 = $cancelled;
  }
  _no_name_provided__399.prototype.invoke_1ti8hr_k$ = function (it) {
    this._$cancelled_0._v = true;
  };
  _no_name_provided__399.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_1ti8hr_k$(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__399.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__400($safe_2_2) {
    this._$safe_2_2 = $safe_2_2;
  }
  _no_name_provided__400.prototype.invoke_3zsixp_k$ = function (data) {
    var tmp0_success_0_1_5 = Companion_getInstance_3();
    this._$safe_2_2.resumeWith_bnunh2_k$(_Result___init__impl_(data));
  };
  _no_name_provided__400.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_3zsixp_k$(p1 instanceof AudioBuffer ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__400.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__401($url, $safe_2_2) {
    this._$url_0 = $url;
    this._$safe_2_2_0 = $safe_2_2;
  }
  _no_name_provided__401.prototype.invoke_sv8swh_k$ = function () {
    var tmp0_resumeWithException_0_7 = Exception_init_$Create$('' + 'error decoding ' + this._$url_0);
    var tmp0_failure_0_1_8 = Companion_getInstance_3();
    this._$safe_2_2_0.resumeWith_bnunh2_k$(_Result___init__impl_(createFailure(tmp0_resumeWithException_0_7)));
  };
  _no_name_provided__401.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__401.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__402($unlock, $_scratchBuffer) {
    this._$unlock = $unlock;
    this._$_scratchBuffer = $_scratchBuffer;
  }
  _no_name_provided__402.prototype.invoke_xfv2uo_k$ = function (it) {
    var tmp = document;
    var tmp_0;
    if (this._$unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_0 = this._$unlock._v;
    }
    tmp.removeEventListener('keydown', tmp_0, true);
    var tmp_1 = document;
    var tmp_2;
    if (this._$unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_2 = this._$unlock._v;
    }
    tmp_1.removeEventListener('touchstart', tmp_2, true);
    var tmp_3 = document;
    var tmp_4;
    if (this._$unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_4 = this._$unlock._v;
    }
    tmp_3.removeEventListener('touchend', tmp_4, true);
    var tmp_5 = document;
    var tmp_6;
    if (this._$unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_6 = this._$unlock._v;
    }
    tmp_5.removeEventListener('mousedown', tmp_6, true);
    if (!(HtmlSimpleSound_getInstance()._ctx_1 == null)) {
      var tmp0_asDynamic_0 = window;
      var tmp1_unsafeCast_0 = tmp0_asDynamic_0.globalAudioContext;
      var tmp0_safe_receiver = tmp1_unsafeCast_0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.resume();
        Unit_getInstance();
      }
      Unit_getInstance();
      var source = HtmlSimpleSound_getInstance()._ctx_1.createBufferSource();
      source.buffer = this._$_scratchBuffer;
      source.connect(HtmlSimpleSound_getInstance()._ctx_1.destination);
      Unit_getInstance();
      source.start(0.0);
      var tmp2_asDynamic_0 = HtmlSimpleSound_getInstance()._ctx_1;
      if (typeof tmp2_asDynamic_0.resume === 'function') {
        var tmp3_asDynamic_0 = HtmlSimpleSound_getInstance()._ctx_1;
        tmp3_asDynamic_0.resume();
      } else {
      }
      source.onended = _no_name_provided_$factory_343(source);
    }};
  _no_name_provided__402.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_xfv2uo_k$(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__402.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $loadSoundCOROUTINE$36(_this_, data, url, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__162 = _this_;
    this._data_53 = data;
    this._url_5 = url;
  }
  $loadSoundCOROUTINE$36.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            if (this.__this__162._ctx_1 == null)
              return null;
            this._state_1 = 1;
            var tmp_0 = this;
            tmp_0._tmp0__anonymous__1_10 = this;
            this._safe_2_21 = SafeContinuation_init_$Create$(intercepted(this._tmp0__anonymous__1_10));
            var tmp_1 = HtmlSimpleSound_getInstance()._ctx_1;
            var tmp_2 = _no_name_provided_$factory_344(this._safe_2_21);
            tmp_1.decodeAudioData(this._data_53, tmp_2, _no_name_provided_$factory_345(this._url_5, this._safe_2_21));
            suspendResult = this._safe_2_21.getOrThrow_0_k$();
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loadSoundCOROUTINE$36.$metadata$ = {
    simpleName: '$loadSoundCOROUTINE$36',
    kind: 'class',
    interfaces: []
  };
  function $loadSoundCOROUTINE$37(_this_, url, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__163 = _this_;
    this._url_6 = url;
  }
  $loadSoundCOROUTINE$37.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = _get_uniVfs_(this._url_6).readBytes_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_26 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__163.loadSound_b1bk5f_k$(this._ARGUMENT0_26, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loadSoundCOROUTINE$37.$metadata$ = {
    simpleName: '$loadSoundCOROUTINE$37',
    kind: 'class',
    interfaces: []
  };
  function HtmlSimpleSound() {
    HtmlSimpleSound_instance = this;
    var tmp = this;
    var tmp_0;
    try {
      var tmp_1;
      var tmp0_asDynamic_0 = window;
      if (!(typeof tmp0_asDynamic_0.AudioContext === 'undefined')) {
        tmp_1 = new AudioContext();
      } else {
        var tmp1_asDynamic_0 = window;
        if (!(typeof tmp1_asDynamic_0.webkitAudioContext === 'undefined')) {
          tmp_1 = new webkitAudioContext();
        } else {
          {
            tmp_1 = null;
          }
        }
      }
      var tmp2_also_0 = tmp_1;
      var tmp0_asDynamic_0_2 = window;
      tmp0_asDynamic_0_2.globalAudioContext = tmp2_also_0;
      tmp_0 = tmp2_also_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        console.error($p);
        tmp_2 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp_0 = tmp_2;
    }
    tmp._ctx_1 = tmp_0;
    this._unlocked = false;
    var tmp_3 = this;
    tmp_3._unlockDeferred = CompletableDeferred_0(Job$default(null, 1, null));
    var tmp_4 = this;
    var tmp_5 = this._unlockDeferred;
    tmp_4._unlock = isInterface(tmp_5, Deferred) ? tmp_5 : THROW_CCE();
    var tmp0_safe_receiver = this._ctx_1;
    var _scratchBuffer = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createBuffer(1, 1, 22050);
    var unlock = {_v: null};
    unlock._v = _no_name_provided_$factory_333(unlock, _scratchBuffer);
    var tmp_6 = document;
    var tmp_7;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_7 = unlock._v;
    }
    tmp_6.addEventListener('keydown', tmp_7, true);
    var tmp_8 = document;
    var tmp_9;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_9 = unlock._v;
    }
    tmp_8.addEventListener('touchstart', tmp_9, true);
    var tmp_10 = document;
    var tmp_11;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_11 = unlock._v;
    }
    tmp_10.addEventListener('touchend', tmp_11, true);
    var tmp_12 = document;
    var tmp_13;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_13 = unlock._v;
    }
    tmp_12.addEventListener('mousedown', tmp_13, true);
  }
  HtmlSimpleSound.prototype._get_available__0_k$ = function () {
    return !(this._ctx_1 == null);
  };
  HtmlSimpleSound.prototype.panner_eed2pb_k$ = function (_this__0, callback) {
    var tmp0_elvis_lhs = this._ctx_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var tmp_0;
    try {
      var tmp0_success_0_1 = Companion_getInstance_3();
      var tmp1_success_0_2 = ctx.createPanner();
      tmp_0 = _Result___init__impl_(tmp1_success_0_2);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var tmp2_failure_0_4 = Companion_getInstance_3();
        tmp_1 = _Result___init__impl_(createFailure($p));
      } else {
        {
          throw $p;
        }
      }
      tmp_0 = tmp_1;
    }
    var tmp0_getOrNull_0 = tmp_0;
    var tmp_2;
    if (_Result___get_isFailure__impl_(tmp0_getOrNull_0)) {
      tmp_2 = null;
    } else {
      var tmp_3 = _Result___get_value__impl_(tmp0_getOrNull_0);
      tmp_2 = (tmp_3 == null ? true : isObject(tmp_3)) ? tmp_3 : THROW_CCE();
    }
    var tmp1_elvis_lhs = tmp_2;
    var tmp_4;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_4 = tmp1_elvis_lhs;
    }
    var node = tmp_4;
    callback(node);
    node.connect(_this__0);
    Unit_getInstance();
    return node;
  };
  HtmlSimpleSound.prototype.gain_lkl9jk_k$ = function (_this__0, callback) {
    var tmp0_elvis_lhs = this._ctx_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var node = ctx.createGain();
    callback(node);
    node.connect(_this__0);
    Unit_getInstance();
    return node;
  };
  HtmlSimpleSound.prototype.source_xu8ks6_k$ = function (_this__0, buffer, callback) {
    var tmp0_elvis_lhs = this._ctx_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var node = ctx.createBufferSource();
    node.buffer = buffer;
    callback(node);
    node.connect(_this__0);
    Unit_getInstance();
    return node;
  };
  HtmlSimpleSound.prototype.source$default_99mref_k$ = function (_this__0, buffer, callback, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      callback = _no_name_provided_$factory_339();
    }return this.source_xu8ks6_k$(_this__0, buffer, callback);
  };
  HtmlSimpleSound.prototype.source_e5tplj_k$ = function (_this__0, buffer, callback) {
    var tmp0_elvis_lhs = this._ctx_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var node = ctx.createMediaElementSource(buffer);
    callback(node);
    node.connect(_this__0);
    Unit_getInstance();
    return node;
  };
  HtmlSimpleSound.prototype.source$default_y5ee1m_k$ = function (_this__0, buffer, callback, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      callback = _no_name_provided_$factory_340();
    }return this.source_e5tplj_k$(_this__0, buffer, callback);
  };
  HtmlSimpleSound.prototype.playSound_vypghn_k$ = function (buffer, params, coroutineContext) {
    var tmp0_safe_receiver = this._ctx_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = new SimpleSoundChannel(buffer, tmp0_safe_receiver, params, coroutineContext);
    }
    return tmp;
  };
  HtmlSimpleSound.prototype.ensureUnlockStart_sv8swh_k$ = function () {
    Unit_getInstance();
  };
  HtmlSimpleSound.prototype.callOnUnlocked_v88bnd_k$ = function (callback) {
    var cancelled = {_v: false};
    this._unlock.invokeOnCompletion_wjzpsu_k$(_no_name_provided_$factory_341(cancelled, callback));
    Unit_getInstance();
    var tmp = _no_name_provided_$factory_342(cancelled);
    return new sam$com_soywiz_korio_lang_Cancellable$0(tmp);
  };
  HtmlSimpleSound.prototype.loadSound_kmkfto_k$ = function (data, url, $cont) {
    var tmp = new $loadSoundCOROUTINE$36(this, data, url, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HtmlSimpleSound.prototype.loadSoundBuffer_6wfw3l_k$ = function (url) {
    if (this._ctx_1 == null)
      return null;
    return createAudioElement$default(url, 0.0, false, null, 14, null);
  };
  HtmlSimpleSound.prototype.loadSound_b1bk5f_k$ = function (data, $cont) {
    return this.loadSound_kmkfto_k$(data.buffer, 'ByteArray', $cont);
  };
  HtmlSimpleSound.prototype.loadSound_6wfw3l_k$ = function (url, $cont) {
    var tmp = new $loadSoundCOROUTINE$37(this, url, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  HtmlSimpleSound.$metadata$ = {
    simpleName: 'HtmlSimpleSound',
    kind: 'object',
    interfaces: []
  };
  var HtmlSimpleSound_instance;
  function HtmlSimpleSound_getInstance() {
    if (HtmlSimpleSound_instance == null)
      new HtmlSimpleSound();
    return HtmlSimpleSound_instance;
  }
  function AudioBufferOrHTMLMediaElement_init_$Init$(audioBuffer, $this) {
    AudioBufferOrHTMLMediaElement.call($this, audioBuffer, null);
    return $this;
  }
  function AudioBufferOrHTMLMediaElement_init_$Create$(audioBuffer) {
    return AudioBufferOrHTMLMediaElement_init_$Init$(audioBuffer, Object.create(AudioBufferOrHTMLMediaElement.prototype));
  }
  function AudioBufferOrHTMLMediaElement_init_$Init$_0(htmlMediaElement, $this) {
    AudioBufferOrHTMLMediaElement.call($this, null, htmlMediaElement);
    return $this;
  }
  function AudioBufferOrHTMLMediaElement_init_$Create$_0(htmlMediaElement) {
    return AudioBufferOrHTMLMediaElement_init_$Init$_0(htmlMediaElement, Object.create(AudioBufferOrHTMLMediaElement.prototype));
  }
  function AudioBufferOrHTMLMediaElement(audioBuffer, htmlAudioElement) {
    this._audioBuffer = audioBuffer;
    this._htmlAudioElement = htmlAudioElement;
  }
  AudioBufferOrHTMLMediaElement.prototype._get_isNull__0_k$ = function () {
    return this._audioBuffer == null ? this._htmlAudioElement == null : false;
  };
  AudioBufferOrHTMLMediaElement.prototype._get_isNotNull__0_k$ = function () {
    return !this._get_isNull__0_k$();
  };
  AudioBufferOrHTMLMediaElement.prototype._get_duration__0_k$ = function () {
    return !(this._audioBuffer == null) ? this._audioBuffer.duration : !(this._htmlAudioElement == null) ? this._htmlAudioElement.duration : null;
  };
  AudioBufferOrHTMLMediaElement.$metadata$ = {
    simpleName: 'AudioBufferOrHTMLMediaElement',
    kind: 'class',
    interfaces: []
  };
  function clone(_this_) {
    return createAudioElement(_this_.src, _this_.currentTime, _this_.autoplay, _this_.crossOrigin);
  }
  function createAudioElement(src, currentTime, autoplay, crossOrigin) {
    var out = new Audio(src);
    out.crossOrigin = crossOrigin;
    out.currentTime = currentTime;
    out.autoplay = autoplay;
    out.pause();
    return out;
  }
  function createAudioElement$default(src, currentTime, autoplay, crossOrigin, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      currentTime = 0.0;
    if (!(($mask0 & 4) === 0))
      autoplay = false;
    if (!(($mask0 & 8) === 0))
      crossOrigin = 'anonymous';
    return createAudioElement(src, currentTime, autoplay, crossOrigin);
  }
  function _no_name_provided_$factory_333($unlock, $_scratchBuffer) {
    var i = new _no_name_provided__402($unlock, $_scratchBuffer);
    return function (p1) {
      i.invoke_xfv2uo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_334(this$0, $htmlAudioElement, $audioBuffer) {
    var i = new _no_name_provided__393(this$0, $htmlAudioElement, $audioBuffer);
    return function (p1) {
      i.invoke_rbuzf3_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_335(this$0, $startTime, resultContinuation) {
    var i = new _no_name_provided__394(this$0, $startTime, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_336($htmlAudioElement, this$0, $audioBuffer) {
    var i = new _no_name_provided__390($htmlAudioElement, this$0, $audioBuffer);
    return function (p1) {
      i.invoke_my7cby_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_337($deferred) {
    var i = new _no_name_provided__391($deferred);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_338($deferred) {
    var i = new _no_name_provided__392($deferred);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_339() {
    var i = new _no_name_provided__396();
    return function (p1) {
      i.invoke_qo8tmo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_340() {
    var i = new _no_name_provided__397();
    return function (p1) {
      i.invoke_5ofraw_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_341($cancelled, $callback) {
    var i = new _no_name_provided__398($cancelled, $callback);
    return function (p1) {
      i.invoke_houul8_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_342($cancelled) {
    var i = new _no_name_provided__399($cancelled);
    return function (p1) {
      i.invoke_1ti8hr_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_343($source) {
    var i = new _no_name_provided__395($source);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_344($safe_2_2) {
    var i = new _no_name_provided__400($safe_2_2);
    return function (p1) {
      i.invoke_3zsixp_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_345($url, $safe_2_2) {
    var i = new _no_name_provided__401($url, $safe_2_2);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _get_nativeSoundProvider_() {
    var tmp0_getValue_0 = nativeSoundProvider$factory();
    return nativeSoundProvider$delegate._get_value__0_k$();
  }
  var nativeSoundProvider$delegate;
  function _no_name_provided__403(this$0) {
    this._this$0_121 = this$0;
  }
  _no_name_provided__403.prototype.invoke_qwrio2_k$ = function (it) {
    process_0(this._this$0_121, it);
  };
  _no_name_provided__403.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qwrio2_k$(p1 instanceof AudioProcessingEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__403.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_192() {
    Companion_instance_191 = this;
    this._lastId_0 = 0;
  }
  Companion_192.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_191;
  function Companion_getInstance_191() {
    if (Companion_instance_191 == null)
      new Companion_192();
    return Companion_instance_191;
  }
  function process_0($this, e) {
    var tmp = 0;
    var tmp_0 = e.outputBuffer.numberOfChannels;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = e.outputBuffer.getChannelData(tmp_2);
      tmp = tmp + 1 | 0;
    }
    var outChannels = tmp_1;
    var hasData = true;
    var tmp0_asDynamic_0 = document;
    if (!tmp0_asDynamic_0.hidden) {
      var inductionVariable = 0;
      var last_1 = $this._nchannels;
      if (inductionVariable < last_1)
        do {
          var channel = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var deque = $this._deques[channel];
          var outChannel = outChannels[channel];
          var read_0 = deque.read$default_l2dr7t_k$(outChannel, 0, 0, 6, null);
          if (read_0 < outChannel.length)
            hasData = false;
        }
         while (inductionVariable < last_1);
    } else {
    }
    if (!hasData) {
      var tmp1_this = $this;
      var tmp2 = tmp1_this._missingDataCount;
      tmp1_this._missingDataCount = tmp2 + 1 | 0;
      Unit_getInstance();
    }if ($this._missingDataCount >= 500) {
      $this.stop_sv8swh_k$();
    }}
  function ensureInit_0($this) {
    return $this._node_0;
  }
  function _no_name_provided__404(this$0) {
    this._this$0_122 = this$0;
  }
  _no_name_provided__404.prototype.invoke_89eg7z_k$ = function (it) {
    var tmp = this._this$0_122;
    var tmp0_safe_receiver = HtmlSimpleSound_getInstance()._ctx_1;
    tmp._node_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createScriptProcessor(1024, 2, 2);
    var tmp1_safe_receiver = this._this$0_122._node_0;
    if (tmp1_safe_receiver == null) {
      Unit_getInstance();
    } else {
      tmp1_safe_receiver.onaudioprocess = _no_name_provided_$factory_348(this._this$0_122);
    }
    if (!(HtmlSimpleSound_getInstance()._ctx_1 == null)) {
      var tmp2_safe_receiver = this._this$0_122._node_0;
      if (tmp2_safe_receiver == null)
        null;
      else
        tmp2_safe_receiver.connect(HtmlSimpleSound_getInstance()._ctx_1.destination);
      Unit_getInstance();
    }};
  _no_name_provided__404.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_89eg7z_k$(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__404.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $addCOROUTINE$38(_this_, samples, offset_0, size_2, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__164 = _this_;
    this._samples_2 = samples;
    this._offset_32 = offset_0;
    this._size_16 = size_2;
  }
  $addCOROUTINE$38.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            var tmp0_this = this.__this__164;
            tmp0_this._totalShorts = tmp0_this._totalShorts + this._size_16 | 0;
            if (!HtmlSimpleSound_getInstance()._get_available__0_k$()) {
              this._sampleCount0 = this._size_16 / 2 | 0;
              this._timeSeconds1 = this._sampleCount0 / 41000.0;
              this._state_1 = 4;
              var tmp_0 = this.__this__164._get_coroutineContext__0_k$();
              suspendResult = delay_1(tmp_0, Companion_getInstance_92().fromSeconds_ttklb2_k$(this._timeSeconds1), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this.__this__164.ensureRunning_sv8swh_k$();
              this._schannels2 = this._samples_2._channels_2;
              var inductionVariable = 0;
              var last_1 = this.__this__164._nchannels;
              if (inductionVariable < last_1)
                do {
                  var channel = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var sample = this._samples_2.get_ha5a7z_k$(channel % this._schannels2);
                  var deque = this.__this__164._deques[channel];
                  var inductionVariable_0 = 0;
                  var last_2 = this._size_16;
                  if (inductionVariable_0 < last_2)
                    do {
                      var n = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      write_1(deque, SampleConvert_getInstance().shortToFloat_dip2j2_k$(sample[this._offset_32 + n | 0]));
                    }
                     while (inductionVariable_0 < last_2);
                }
                 while (inductionVariable < last_1);
              this._state_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            if (!(this.__this__164._deques[0]._get_availableRead__0_k$() > imul(this._samples_2._totalSamples, 4))) {
              this._state_1 = 3;
              continue $sm;
            }
            this._state_1 = 2;
            var tmp_1 = this.__this__164._get_coroutineContext__0_k$();
            suspendResult = delay_1(tmp_1, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(4.0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            this._state_1 = 5;
            continue $sm;
          case 4:
            this._state_1 = 5;
            continue $sm;
          case 5:
            return Unit_getInstance();
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $addCOROUTINE$38.$metadata$ = {
    simpleName: '$addCOROUTINE$38',
    kind: 'class',
    interfaces: []
  };
  function JsPlatformAudioOutput(coroutineContext, freq) {
    Companion_getInstance_191();
    PlatformAudioOutput.call(this, coroutineContext, freq);
    this._freq = freq;
    var tmp = this;
    var tmp0_this = Companion_getInstance_191();
    var tmp1 = tmp0_this._lastId_0;
    tmp0_this._lastId_0 = tmp1 + 1 | 0;
    tmp._id_25 = tmp1;
    _get_nativeSoundProvider_().initOnce_sv8swh_k$();
    this._missingDataCount = 0;
    this._nodeRunning = false;
    this._node_0 = null;
    this._nchannels = 2;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this._nchannels;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = FloatArrayDeque_init_$Create$(0, 1, null);
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._deques = tmp_3;
    this._startPromise = null;
    this._totalShorts = 0;
  }
  JsPlatformAudioOutput.prototype.start_sv8swh_k$ = function () {
    if (this._nodeRunning)
      return Unit_getInstance();
    var tmp = this;
    var tmp_0 = HtmlSimpleSound_getInstance();
    tmp._startPromise = tmp_0.callOnUnlocked_v88bnd_k$(_no_name_provided_$factory_347(this));
    this._missingDataCount = 0;
    this._nodeRunning = true;
  };
  JsPlatformAudioOutput.prototype.stop_sv8swh_k$ = function () {
    if (!this._nodeRunning)
      return Unit_getInstance();
    var tmp0_safe_receiver = this._startPromise;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel_0(tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._node_0;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.disconnect();
      Unit_getInstance();
    }
    Unit_getInstance();
    this._nodeRunning = false;
  };
  JsPlatformAudioOutput.prototype.ensureRunning_sv8swh_k$ = function () {
    ensureInit_0(this);
    Unit_getInstance();
    if (!this._nodeRunning) {
      this.start_sv8swh_k$();
    }};
  JsPlatformAudioOutput.prototype._get_availableSamples__0_k$ = function () {
    return this._totalShorts;
  };
  JsPlatformAudioOutput.prototype.add_fo50v8_k$ = function (samples, offset_0, size_2, $cont) {
    var tmp = new $addCOROUTINE$38(this, samples, offset_0, size_2, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  JsPlatformAudioOutput.$metadata$ = {
    simpleName: 'JsPlatformAudioOutput',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__405() {
  }
  _no_name_provided__405.prototype.invoke_0_k$ = function () {
    return new HtmlNativeSoundProvider();
  };
  _no_name_provided__405.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function nativeSoundProvider$factory() {
    return getPropertyCallableRef('nativeSoundProvider', 0, KProperty0, function () {
      return _get_nativeSoundProvider_();
    }, null);
  }
  function _no_name_provided_$factory_346() {
    var i = new _no_name_provided__405();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_347(this$0) {
    var i = new _no_name_provided__404(this$0);
    return function (p1) {
      i.invoke_89eg7z_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_348(this$0) {
    var i = new _no_name_provided__403(this$0);
    return function (p1) {
      i.invoke_qwrio2_k$(p1);
      return Unit_getInstance();
    };
  }
  function AsyncInjector_init_$Init$(parent, level, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    if (!(($mask0 & 2) === 0))
      level = 0;
    AsyncInjector.call($this, parent, level);
    return $this;
  }
  function AsyncInjector_init_$Create$(parent, level, $mask0, $marker) {
    return AsyncInjector_init_$Init$(parent, level, $mask0, $marker, Object.create(AsyncInjector.prototype));
  }
  function RequestContext(initialClazz) {
    this._initialClazz = initialClazz;
  }
  RequestContext.prototype.toString = function () {
    return '' + 'RequestContext(initialClazz=' + this._initialClazz + ')';
  };
  RequestContext.prototype.hashCode = function () {
    return this._initialClazz.hashCode();
  };
  RequestContext.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestContext))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RequestContext ? other : THROW_CCE();
    if (!this._initialClazz.equals(tmp0_other_with_cast._initialClazz))
      return false;
    return true;
  };
  RequestContext.$metadata$ = {
    simpleName: 'RequestContext',
    kind: 'class',
    interfaces: []
  };
  function NotMappedException(clazz, requestedByClass, ctx, msg) {
    RuntimeException_init_$Init$_0(msg, this);
    this._clazz = clazz;
    this._requestedByClass = requestedByClass;
    this._ctx_2 = ctx;
    this._msg_0 = msg;
    captureStack(this, NotMappedException);
  }
  NotMappedException.$metadata$ = {
    simpleName: 'NotMappedException',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__406(this$0, $clazz, $ctx, resultContinuation) {
    this._this$0_123 = this$0;
    this._$clazz = $clazz;
    this._$ctx_0 = $ctx;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__406.prototype.invoke_0_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__406.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_123.get_v4ahoc_k$(this._$clazz, this._$ctx_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__406.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__406(this._this$0_123, this._$clazz, this._$ctx_0, completion);
    return i;
  };
  _no_name_provided__406.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__407($rexception, $rresult) {
    this._$rexception = $rexception;
    this._$rresult_0 = $rresult;
    this._context_8 = EmptyCoroutineContext_getInstance();
  }
  _no_name_provided__407.prototype._get_context__0_k$ = function () {
    return this._context_8;
  };
  _no_name_provided__407.prototype.resumeWith_bnunh2_k$ = function (result) {
    var exception = Result__exceptionOrNull_impl(result);
    if (!(exception == null)) {
      this._$rexception._v = exception;
    } else {
      throwOnFailure(result);
      var tmp = _Result___get_value__impl_(result);
      this._$rresult_0._v = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
    }
  };
  _no_name_provided__407.$metadata$ = {
    kind: 'class',
    interfaces: [Continuation]
  };
  function $getProviderOrNullCOROUTINE$0(_this_, clazz, ctx, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__165 = _this_;
    this._clazz_0 = clazz;
    this._ctx_3 = ctx;
  }
  $getProviderOrNullCOROUTINE$0.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._tmp1_elvis_lhs0_1 = this.__this__165._providersByClass.get_2bw_k$(this._clazz_0);
            if (this._tmp1_elvis_lhs0_1 == null) {
              this._tmp0_safe_receiver2_1 = this.__this__165._parent_5;
              if (this._tmp0_safe_receiver2_1 == null) {
                this._WHEN_RESULT3_2 = null;
                this._state_1 = 2;
                continue $sm;
              } else {
                this._state_1 = 1;
                suspendResult = this._tmp0_safe_receiver2_1.getProviderOrNull_v4ahoc_k$(this._clazz_0, this._ctx_3, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            } else {
              this._WHEN_RESULT1_11 = this._tmp1_elvis_lhs0_1;
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT3_2 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._WHEN_RESULT1_11 = this._WHEN_RESULT3_2;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._tmp4_elvis_lhs4 = this._WHEN_RESULT1_11;
            if (this._tmp4_elvis_lhs4 == null) {
              this._tmp2_safe_receiver6 = this.__this__165._get_nearestFallbackProvider__0_k$();
              if (this._tmp2_safe_receiver6 == null) {
                this._WHEN_RESULT7 = null;
                this._state_1 = 5;
                continue $sm;
              } else {
                this._state_1 = 4;
                suspendResult = this._tmp2_safe_receiver6(this._clazz_0, this._ctx_3, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            } else {
              this._WHEN_RESULT5_1 = this._tmp4_elvis_lhs4;
              this._state_1 = 6;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 4:
            this._WHEN_RESULT7 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            var tmp3_safe_receiver = this._WHEN_RESULT7;
            var tmp_0 = this;
            var tmp_1;
            if (tmp3_safe_receiver == null) {
              tmp_1 = null;
            } else {
              var tmp0_set_0_2 = this.__this__165._providersByClass;
              tmp0_set_0_2.put_1q9pf_k$(this._clazz_0, tmp3_safe_receiver);
              Unit_getInstance();
              tmp_1 = tmp3_safe_receiver;
            }

            tmp_0._WHEN_RESULT5_1 = tmp_1;
            this._state_1 = 6;
            continue $sm;
          case 6:
            var tmp_2 = this._WHEN_RESULT5_1;
            return (tmp_2 == null ? true : isInterface(tmp_2, AsyncObjectProvider)) ? tmp_2 : null;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getProviderOrNullCOROUTINE$0.$metadata$ = {
    simpleName: '$getProviderOrNullCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $getProviderCOROUTINE$1(_this_, clazz, ctx, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__166 = _this_;
    this._clazz_1 = clazz;
    this._ctx_4 = ctx;
  }
  $getProviderCOROUTINE$1.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__166.getProviderOrNull_v4ahoc_k$(this._clazz_1, this._ctx_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              throw new NotMappedException(this._clazz_1, this._ctx_4._initialClazz, this._ctx_4, '' + "Class '" + this._clazz_1 + "' doesn't have constructors " + this._ctx_4);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            return tmp_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getProviderCOROUTINE$1.$metadata$ = {
    simpleName: '$getProviderCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $getCOROUTINE$3(_this_, clazz, ctx, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__167 = _this_;
    this._clazz_2 = clazz;
    this._ctx_5 = ctx;
  }
  $getCOROUTINE$3.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__167.getProvider_v4ahoc_k$(this._clazz_2, this._ctx_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_27 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_27.get_merzw6_k$(this.__this__167, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getCOROUTINE$3.$metadata$ = {
    simpleName: '$getCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function $createdCOROUTINE$5(_this_, instance, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__168 = _this_;
    this._instance = instance;
  }
  $createdCOROUTINE$5.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            var tmp_0 = this._instance;
            if (!(tmp_0 == null) ? isInterface(tmp_0, AsyncDependency) : false) {
              this._state_1 = 1;
              suspendResult = this._instance.init_sv8swh_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 2;
                continue $sm;
              }
            }

            break;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            var tmp_1 = this._instance;
            if (!(tmp_1 == null) ? isInterface(tmp_1, InjectorAsyncDependency) : false) {
              this._state_1 = 3;
              suspendResult = this._instance.init_wh5jqx_k$(this.__this__168, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 4;
                continue $sm;
              }
            }

            break;
          case 3:
            this._state_1 = 4;
            continue $sm;
          case 4:
            return this._instance;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createdCOROUTINE$5.$metadata$ = {
    simpleName: '$createdCOROUTINE$5',
    kind: 'class',
    interfaces: []
  };
  function $deinitCOROUTINE$6(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__169 = _this_;
  }
  $deinitCOROUTINE$6.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_iterator_00_0 = this.__this__169._providersByClass;
            tmp_0._tmp0_iterator1 = this._tmp0_iterator_00_0._get_entries__0_k$().iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator1.hasNext_0_k$()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._pair2 = this._tmp0_iterator1.next_0_k$();
            this._state_1 = 2;
            suspendResult = this._pair2._get_value__0_k$().deinit_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $deinitCOROUTINE$6.$metadata$ = {
    simpleName: '$deinitCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function AsyncInjector(parent, level) {
    this._parent_5 = parent;
    this._level_1 = level;
    this._fallbackProvider = null;
    this._providersByClass = LinkedHashMap_init_$Create$();
    var tmp = this;
    var tmp0_safe_receiver = this._parent_5;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._root_2;
    tmp._root_2 = tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
    this.mapInstance_770c45_k$(getKClass_0(AsyncInjector), this);
    Unit_getInstance();
  }
  AsyncInjector.prototype._get_nearestFallbackProvider__0_k$ = function () {
    var tmp1_elvis_lhs = this._fallbackProvider;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = this._parent_5;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._fallbackProvider;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  AsyncInjector.prototype.child_0_k$ = function () {
    return new AsyncInjector(this, this._level_1 + 1 | 0);
  };
  AsyncInjector.prototype.mapInstance_770c45_k$ = function (clazz, instance) {
    var tmp0_set_0_2 = this._providersByClass;
    var tmp1_set_0_3 = new InstanceAsyncObjectProvider(instance);
    tmp0_set_0_2.put_1q9pf_k$(clazz, tmp1_set_0_3);
    Unit_getInstance();
    return this;
  };
  AsyncInjector.prototype.mapSingleton_tk1g05_k$ = function (clazz, gen) {
    var tmp0_set_0_2 = this._providersByClass;
    var tmp1_set_0_3 = new SingletonAsyncObjectProvider(gen);
    tmp0_set_0_2.put_1q9pf_k$(clazz, tmp1_set_0_3);
    Unit_getInstance();
    return this;
  };
  AsyncInjector.prototype.mapPrototype_tk1g05_k$ = function (clazz, gen) {
    var tmp0_set_0_2 = this._providersByClass;
    var tmp1_set_0_3 = new PrototypeAsyncObjectProvider(gen);
    tmp0_set_0_2.put_1q9pf_k$(clazz, tmp1_set_0_3);
    Unit_getInstance();
    return this;
  };
  AsyncInjector.prototype.getProviderOrNull_v4ahoc_k$ = function (clazz, ctx, $cont) {
    var tmp = new $getProviderOrNullCOROUTINE$0(this, clazz, ctx, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncInjector.prototype.getProvider_v4ahoc_k$ = function (clazz, ctx, $cont) {
    var tmp = new $getProviderCOROUTINE$1(this, clazz, ctx, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncInjector.prototype.getSync_v4ahoc_k$ = function (clazz, ctx) {
    var rresult = {_v: null};
    var rexception = {_v: null};
    var tmp0_suspend_0 = _no_name_provided_$factory_349(this, clazz, ctx, null);
    startCoroutine(tmp0_suspend_0, new _no_name_provided__407(rexception, rresult));
    if (!(rexception._v == null))
      throw ensureNotNull(rexception._v);
    try {
      var tmp;
      if (rresult._v == null) {
        throwUninitializedPropertyAccessException('rresult');
      } else {
        tmp = rresult._v;
      }
      return tmp;
    } catch ($p) {
      if ($p instanceof Error) {
        throw RuntimeException_init_$Create$_0('' + "Couldn't get instance of type " + clazz + ' synchronously', $p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  AsyncInjector.prototype.get_v4ahoc_k$ = function (clazz, ctx, $cont) {
    var tmp = new $getCOROUTINE$3(this, clazz, ctx, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncInjector.prototype.get$default_b3eqw1_k$ = function (clazz, ctx, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      ctx = new RequestContext(clazz);
    return this.get_v4ahoc_k$(clazz, ctx, $cont);
  };
  AsyncInjector.prototype.toString = function () {
    return '' + 'AsyncInjector(level=' + this._level_1 + ')';
  };
  AsyncInjector.prototype.created_7df4x3_k$ = function (instance, $cont) {
    var tmp = new $createdCOROUTINE$5(this, instance, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncInjector.prototype.deinit_sv8swh_k$ = function ($cont) {
    var tmp = new $deinitCOROUTINE$6(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AsyncInjector.$metadata$ = {
    simpleName: 'AsyncInjector',
    kind: 'class',
    interfaces: []
  };
  function InjectorAsyncDependency() {
  }
  InjectorAsyncDependency.$metadata$ = {
    simpleName: 'InjectorAsyncDependency',
    kind: 'interface',
    interfaces: []
  };
  function AsyncDependency() {
  }
  AsyncDependency.$metadata$ = {
    simpleName: 'AsyncDependency',
    kind: 'interface',
    interfaces: []
  };
  function AsyncObjectProvider() {
  }
  AsyncObjectProvider.$metadata$ = {
    simpleName: 'AsyncObjectProvider',
    kind: 'interface',
    interfaces: []
  };
  function $deinitCOROUTINE$7(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__170 = _this_;
  }
  $deinitCOROUTINE$7.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this.__this__170._instance_0;
            tmp_0._tmp0_safe_receiver0_4 = (tmp_1 == null ? true : isInterface(tmp_1, AsyncDestructor)) ? tmp_1 : null;
            if (this._tmp0_safe_receiver0_4 == null) {
              this._WHEN_RESULT1_12 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0_4.deinit_sv8swh_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            var tmp_2 = this;
            tmp_2._WHEN_RESULT1_12 = Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $deinitCOROUTINE$7.$metadata$ = {
    simpleName: '$deinitCOROUTINE$7',
    kind: 'class',
    interfaces: []
  };
  function InstanceAsyncObjectProvider(instance) {
    this._instance_0 = instance;
  }
  InstanceAsyncObjectProvider.prototype.get_merzw6_k$ = function (injector_0, $cont) {
    return this._instance_0;
  };
  InstanceAsyncObjectProvider.prototype.deinit_sv8swh_k$ = function ($cont) {
    var tmp = new $deinitCOROUTINE$7(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  InstanceAsyncObjectProvider.prototype.toString = function () {
    return '' + 'InstanceAsyncObjectProvider(' + this._instance_0 + ')';
  };
  InstanceAsyncObjectProvider.$metadata$ = {
    simpleName: 'InstanceAsyncObjectProvider',
    kind: 'class',
    interfaces: [AsyncObjectProvider]
  };
  function $getCOROUTINE$9(_this_, injector_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__171 = _this_;
    this._injector = injector_0;
  }
  $getCOROUTINE$9.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            if (this.__this__171._value_28 == null) {
              this._state_1 = 1;
              suspendResult = this.__this__171._generator_0(this._injector, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT0_28 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._injector.created_7df4x3_k$(this._ARGUMENT0_28, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.__this__171._value_28 = ARGUMENT;
            this._state_1 = 3;
            continue $sm;
          case 3:
            return ensureNotNull(this.__this__171._value_28);
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getCOROUTINE$9.$metadata$ = {
    simpleName: '$getCOROUTINE$9',
    kind: 'class',
    interfaces: []
  };
  function $deinitCOROUTINE$10(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__172 = _this_;
  }
  $deinitCOROUTINE$10.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this.__this__172._value_28;
            tmp_0._tmp0_safe_receiver0_5 = (tmp_1 == null ? true : isInterface(tmp_1, AsyncDestructor)) ? tmp_1 : null;
            if (this._tmp0_safe_receiver0_5 == null) {
              this._WHEN_RESULT1_13 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0_5.deinit_sv8swh_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            var tmp_2 = this;
            tmp_2._WHEN_RESULT1_13 = Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $deinitCOROUTINE$10.$metadata$ = {
    simpleName: '$deinitCOROUTINE$10',
    kind: 'class',
    interfaces: []
  };
  function SingletonAsyncObjectProvider(generator) {
    this._generator_0 = generator;
    this._value_28 = null;
  }
  SingletonAsyncObjectProvider.prototype.get_merzw6_k$ = function (injector_0, $cont) {
    var tmp = new $getCOROUTINE$9(this, injector_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  SingletonAsyncObjectProvider.prototype.deinit_sv8swh_k$ = function ($cont) {
    var tmp = new $deinitCOROUTINE$10(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  SingletonAsyncObjectProvider.prototype.toString = function () {
    return '' + 'SingletonAsyncObjectProvider(' + this._value_28 + ')';
  };
  SingletonAsyncObjectProvider.$metadata$ = {
    simpleName: 'SingletonAsyncObjectProvider',
    kind: 'class',
    interfaces: [AsyncObjectProvider]
  };
  function $getCOROUTINE$11(_this_, injector_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__173 = _this_;
    this._injector_0 = injector_0;
  }
  $getCOROUTINE$11.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__173._generator_1(this._injector_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_29 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._injector_0.created_7df4x3_k$(this._ARGUMENT0_29, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getCOROUTINE$11.$metadata$ = {
    simpleName: '$getCOROUTINE$11',
    kind: 'class',
    interfaces: []
  };
  function PrototypeAsyncObjectProvider(generator) {
    this._generator_1 = generator;
  }
  PrototypeAsyncObjectProvider.prototype.get_merzw6_k$ = function (injector_0, $cont) {
    var tmp = new $getCOROUTINE$11(this, injector_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  PrototypeAsyncObjectProvider.prototype.deinit_sv8swh_k$ = function ($cont) {
    return Unit_getInstance();
  };
  PrototypeAsyncObjectProvider.prototype.toString = function () {
    return 'PrototypeAsyncObjectProvider()';
  };
  PrototypeAsyncObjectProvider.$metadata$ = {
    simpleName: 'PrototypeAsyncObjectProvider',
    kind: 'class',
    interfaces: [AsyncObjectProvider]
  };
  function AsyncDestructor() {
  }
  AsyncDestructor.$metadata$ = {
    simpleName: 'AsyncDestructor',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_349(this$0, $clazz, $ctx, resultContinuation) {
    var i = new _no_name_provided__406(this$0, $clazz, $ctx, resultContinuation);
    var l = function ($cont) {
      return i.invoke_0_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function Companion_193() {
    Companion_instance_192 = this;
  }
  Companion_193.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Companion_instance_192;
  function Companion_getInstance_192() {
    if (Companion_instance_192 == null)
      new Companion_193();
    return Companion_instance_192;
  }
  function AsyncInjectorContext(injector_0) {
    Companion_getInstance_192();
    this._injector_1 = injector_0;
  }
  AsyncInjectorContext.prototype._get_key__0_k$ = function () {
    return Companion_getInstance_192();
  };
  AsyncInjectorContext.$metadata$ = {
    simpleName: 'AsyncInjectorContext',
    kind: 'class',
    interfaces: [Element_0]
  };
  function injector($cont) {
    var tmp0_safe_receiver = $cont._get_context__0_k$().get_9uvjra_k$(Companion_getInstance_192());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._injector_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('AsyncInjector not in the context, please call withInjector function');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  var debugPrintln$delegate;
  function _no_name_provided__408() {
  }
  _no_name_provided__408.prototype.invoke_hspgua_k$ = function ($this$$receiver) {
    return $this$$receiver._extra_3;
  };
  _no_name_provided__408.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_hspgua_k$(p1 instanceof TemplateConfig ? p1 : THROW_CCE());
  };
  _no_name_provided__408.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__409() {
  }
  _no_name_provided__409.prototype.invoke_qi8yb4_k$ = function (v) {
    println(v);
  };
  _no_name_provided__409.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_qi8yb4_k$((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__409.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__410() {
  }
  _no_name_provided__410.prototype.invoke_0_k$ = function () {
    return _no_name_provided_$factory_352();
  };
  _no_name_provided__410.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_350() {
    var i = new _no_name_provided__408();
    return function (p1) {
      return i.invoke_hspgua_k$(p1);
    };
  }
  function _no_name_provided_$factory_351() {
    var i = new _no_name_provided__410();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_352() {
    var i = new _no_name_provided__409();
    return function (p1) {
      i.invoke_qi8yb4_k$(p1);
      return Unit_getInstance();
    };
  }
  function debugPrintln$delegate$init$() {
    var tmp = _no_name_provided_$factory_350();
    return extraProperty_init_$Create$(tmp, null, _no_name_provided_$factory_351(), 2, null);
  }
  function TemplateConfig() {
  }
  TemplateConfig.$metadata$ = {
    simpleName: 'TemplateConfig',
    kind: 'class',
    interfaces: []
  };
  function ObjectMapper2() {
  }
  ObjectMapper2.$metadata$ = {
    simpleName: 'ObjectMapper2',
    kind: 'class',
    interfaces: []
  };
  var formatRegex_0;
  var charToEntity;
  function extraProperty_init_$Init$(getExtraMap, name, default_0, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      name = null;
    extraProperty.call($this, getExtraMap, name, default_0);
    return $this;
  }
  function extraProperty_init_$Create$(getExtraMap, name, default_0, $mask0, $marker) {
    return extraProperty_init_$Init$(getExtraMap, name, default_0, $mask0, $marker, Object.create(extraProperty.prototype));
  }
  function extraProperty(getExtraMap, name, default_0) {
    this._getExtraMap = getExtraMap;
    this._name_31 = name;
    this._default_1 = default_0;
  }
  extraProperty.$metadata$ = {
    simpleName: 'extraProperty',
    kind: 'class',
    interfaces: []
  };
  var Mapper2;
  function JsObjectMapper2() {
    ObjectMapper2.call(this);
  }
  JsObjectMapper2.$metadata$ = {
    simpleName: 'JsObjectMapper2',
    kind: 'class',
    interfaces: []
  };
  function Config_init_$Init$(module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector_0, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      args = [];
    }if (!(($mask0 & 4) === 0))
      imageFormats = RegisteredImageFormats_getInstance();
    if (!(($mask0 & 8) === 0))
      gameWindow = null;
    if (!(($mask0 & 16) === 0))
      sceneClass = module_0._get_mainScene__0_k$();
    if (!(($mask0 & 32) === 0)) {
      sceneInjects = emptyList();
    }if (!(($mask0 & 64) === 0))
      timeProvider = Companion_getInstance_91();
    if (!(($mask0 & 128) === 0)) {
      injector_0 = AsyncInjector_init_$Create$(null, 0, 3, null);
    }if (!(($mask0 & 256) === 0))
      debug = false;
    if (!(($mask0 & 512) === 0))
      trace = false;
    if (!(($mask0 & 1024) === 0))
      context = null;
    if (!(($mask0 & 2048) === 0))
      fullscreen = null;
    if (!(($mask0 & 4096) === 0))
      blocking = true;
    if (!(($mask0 & 8192) === 0))
      gameId = Korge_getInstance()._DEFAULT_GAME_ID;
    if (!(($mask0 & 16384) === 0))
      settingsFolder = null;
    if (!(($mask0 & 32768) === 0))
      batchMaxQuads = Companion_getInstance_200()._DEFAULT_BATCH_QUADS;
    if (!(($mask0 & 65536) === 0)) {
      constructedViews = _no_name_provided_$factory_366();
    }Config.call($this, module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector_0, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews);
    return $this;
  }
  function Config_init_$Create$(module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector_0, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews, $mask0, $marker) {
    return Config_init_$Init$(module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector_0, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews, $mask0, $marker, Object.create(Config.prototype));
  }
  function _no_name_provided__411() {
  }
  _no_name_provided__411.prototype.invoke_ukkq99_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__411.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_ukkq99_k$(p1 instanceof Views ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__411.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__412($sc, resultContinuation) {
    this._$sc = $sc;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__412.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__412.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__412.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_00 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_01 = this._$sc._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._$sc.changeTo_71zaf0_k$(getKClass_0(EmptyScene), [].slice(), this._tmp0_changeTo_00, this._tmp1_changeTo_01, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__412.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__412(this._$sc, completion);
    return i;
  };
  _no_name_provided__412.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__413($entry, $views, $blocking, $gameWindow, resultContinuation) {
    this._$entry_1 = $entry;
    this._$views = $views;
    this._$blocking = $blocking;
    this._$gameWindow = $gameWindow;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__413.prototype.invoke_2i3g7c_k$ = function ($this$coroutineScope, $cont) {
    var tmp = this.create_y6imfn_k$($this$coroutineScope, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__413.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_2i3g7c_k$((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__413.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this._$entry_1(this._$views._stage_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            if (this._$blocking) {
              this._state_1 = 2;
              suspendResult = this._$gameWindow.waitClose_sv8swh_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__413.prototype.create_y6imfn_k$ = function ($this$coroutineScope, completion) {
    var i = new _no_name_provided__413(this._$entry_1, this._$views, this._$blocking, this._$gameWindow, completion);
    i._$this$coroutineScope = $this$coroutineScope;
    return i;
  };
  _no_name_provided__413.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__414($title, $fullscreen, $width, $height, $virtualWidth, $virtualHeight) {
    this._$title = $title;
    this._$fullscreen = $fullscreen;
    this._$width_2 = $width;
    this._$height_2 = $height;
    this._$virtualWidth = $virtualWidth;
    this._$virtualHeight = $virtualHeight;
    Module.call(this);
    this._title = this._$title;
    this._fullscreen_1 = this._$fullscreen;
    this._windowSize = Companion_getInstance_39().invoke_aaxa64_k$(this._$width_2, this._$height_2);
    this._size_17 = Companion_getInstance_39().invoke_aaxa64_k$(this._$virtualWidth, this._$virtualHeight);
  }
  _no_name_provided__414.prototype._get_title__0_k$ = function () {
    return this._title;
  };
  _no_name_provided__414.prototype._get_fullscreen__0_k$ = function () {
    return this._fullscreen_1;
  };
  _no_name_provided__414.prototype._get_windowSize__qgazdw_k$ = function () {
    return this._windowSize;
  };
  _no_name_provided__414.prototype._get_size__qgazdw_k$ = function () {
    return this._size_17;
  };
  _no_name_provided__414.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__415($entry, $views, $blocking, $gameWindow, resultContinuation) {
    this._$entry_2 = $entry;
    this._$views_0 = $views;
    this._$blocking_0 = $blocking;
    this._$gameWindow_0 = $gameWindow;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__415.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__415.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__415.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = coroutineScope(_no_name_provided_$factory_368(this._$entry_2, this._$views_0, this._$blocking_0, this._$gameWindow_0, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__415.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__415(this._$entry_2, this._$views_0, this._$blocking_0, this._$gameWindow_0, completion);
    return i;
  };
  _no_name_provided__415.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__416($views, resultContinuation) {
    this._$views_1 = $views;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__416.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__416.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__416.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._$views_1.close_sv8swh_k$();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__416.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__416(this._$views_1, completion);
    return i;
  };
  _no_name_provided__416.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function Config(module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector_0, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews) {
    this._module = module_0;
    this._args = args;
    this._imageFormats = imageFormats;
    this._gameWindow = gameWindow;
    this._sceneClass = sceneClass;
    this._sceneInjects = sceneInjects;
    this._timeProvider_1 = timeProvider;
    this._injector_2 = injector_0;
    this._debug_2 = debug;
    this._trace = trace;
    this._context_9 = context;
    this._fullscreen_2 = fullscreen;
    this._blocking = blocking;
    this._gameId = gameId;
    this._settingsFolder = settingsFolder;
    this._batchMaxQuads = batchMaxQuads;
    this._constructedViews = constructedViews;
  }
  Config.prototype.toString = function () {
    return '' + 'Config(module=' + this._module + ', args=' + toString_1(this._args) + ', imageFormats=' + this._imageFormats + ', gameWindow=' + this._gameWindow + ', sceneClass=' + this._sceneClass + ', sceneInjects=' + this._sceneInjects + ', timeProvider=' + this._timeProvider_1 + ', injector=' + this._injector_2 + ', debug=' + this._debug_2 + ', trace=' + this._trace + ', context=' + this._context_9 + ', fullscreen=' + this._fullscreen_2 + ', blocking=' + this._blocking + ', gameId=' + this._gameId + ', settingsFolder=' + this._settingsFolder + ', batchMaxQuads=' + this._batchMaxQuads + ', constructedViews=' + this._constructedViews + ')';
  };
  Config.prototype.hashCode = function () {
    var result = hashCode(this._module);
    result = imul(result, 31) + hashCode(this._args) | 0;
    result = imul(result, 31) + hashCode(this._imageFormats) | 0;
    result = imul(result, 31) + (this._gameWindow == null ? 0 : hashCode(this._gameWindow)) | 0;
    result = imul(result, 31) + this._sceneClass.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._sceneInjects) | 0;
    result = imul(result, 31) + hashCode(this._timeProvider_1) | 0;
    result = imul(result, 31) + hashCode(this._injector_2) | 0;
    result = imul(result, 31) + (this._debug_2 | 0) | 0;
    result = imul(result, 31) + (this._trace | 0) | 0;
    result = imul(result, 31) + (this._context_9 == null ? 0 : hashCode(this._context_9)) | 0;
    result = imul(result, 31) + (this._fullscreen_2 == null ? 0 : this._fullscreen_2 | 0) | 0;
    result = imul(result, 31) + (this._blocking | 0) | 0;
    result = imul(result, 31) + getStringHashCode(this._gameId) | 0;
    result = imul(result, 31) + (this._settingsFolder == null ? 0 : getStringHashCode(this._settingsFolder)) | 0;
    result = imul(result, 31) + this._batchMaxQuads | 0;
    result = imul(result, 31) + hashCode(this._constructedViews) | 0;
    return result;
  };
  Config.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Config))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Config ? other : THROW_CCE();
    if (!equals_1(this._module, tmp0_other_with_cast._module))
      return false;
    if (!equals_1(this._args, tmp0_other_with_cast._args))
      return false;
    if (!equals_1(this._imageFormats, tmp0_other_with_cast._imageFormats))
      return false;
    if (!equals_1(this._gameWindow, tmp0_other_with_cast._gameWindow))
      return false;
    if (!this._sceneClass.equals(tmp0_other_with_cast._sceneClass))
      return false;
    if (!equals_1(this._sceneInjects, tmp0_other_with_cast._sceneInjects))
      return false;
    if (!equals_1(this._timeProvider_1, tmp0_other_with_cast._timeProvider_1))
      return false;
    if (!equals_1(this._injector_2, tmp0_other_with_cast._injector_2))
      return false;
    if (!(this._debug_2 === tmp0_other_with_cast._debug_2))
      return false;
    if (!(this._trace === tmp0_other_with_cast._trace))
      return false;
    if (!equals_1(this._context_9, tmp0_other_with_cast._context_9))
      return false;
    if (!(this._fullscreen_2 == tmp0_other_with_cast._fullscreen_2))
      return false;
    if (!(this._blocking === tmp0_other_with_cast._blocking))
      return false;
    if (!(this._gameId === tmp0_other_with_cast._gameId))
      return false;
    if (!(this._settingsFolder == tmp0_other_with_cast._settingsFolder))
      return false;
    if (!(this._batchMaxQuads === tmp0_other_with_cast._batchMaxQuads))
      return false;
    if (!equals_1(this._constructedViews, tmp0_other_with_cast._constructedViews))
      return false;
    return true;
  };
  Config.$metadata$ = {
    simpleName: 'Config',
    kind: 'class',
    interfaces: []
  };
  function ModuleArgs(args) {
    this._args_0 = args;
  }
  ModuleArgs.prototype.toString = function () {
    return '' + 'ModuleArgs(args=' + toString_1(this._args_0) + ')';
  };
  ModuleArgs.prototype.hashCode = function () {
    return hashCode(this._args_0);
  };
  ModuleArgs.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ModuleArgs))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ModuleArgs ? other : THROW_CCE();
    if (!equals_1(this._args_0, tmp0_other_with_cast._args_0))
      return false;
    return true;
  };
  ModuleArgs.$metadata$ = {
    simpleName: 'ModuleArgs',
    kind: 'class',
    interfaces: []
  };
  function prepareViewsBase$getRealX(ag, x, scaleCoords) {
    return scaleCoords ? x * ag._get_devicePixelRatio__0_k$() : x;
  }
  function prepareViewsBase$getRealY(ag, y, scaleCoords) {
    return scaleCoords ? y * ag._get_devicePixelRatio__0_k$() : y;
  }
  function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, x, y, button) {
    input.toggleButton_qwimd4_k$(button, true);
    input._mouse_0.setTo_ngl742_k$(x, y);
    Unit_getInstance();
    input._mouseDown.setTo_ngl742_k$(x, y);
    Unit_getInstance();
    $views.mouseUpdated_sv8swh_k$();
    downPos.copyFrom_ujo5kx_k$(input._mouse_0);
    Unit_getInstance();
    downTime._v = new DateTime(Companion_getInstance_82().now_utobi1_k$());
    input._mouseInside = true;
  }
  function prepareViewsBase$mouseUp(input, $views, upPos, type, x, y, button) {
    input.toggleButton_qwimd4_k$(button, false);
    input._mouse_0.setTo_ngl742_k$(x, y);
    Unit_getInstance();
    $views.mouseUpdated_sv8swh_k$();
    upPos.copyFrom_ujo5kx_k$($views._input_3._mouse_0);
    Unit_getInstance();
  }
  function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, x, y, inside) {
    $views._input_3._mouse_0.setTo_ngl742_k$(x, y);
    Unit_getInstance();
    $views._input_3._mouseInside = inside;
    if (!inside) {
      moveMouseOutsideInNextFrame._v = true;
    }$views.mouseUpdated_sv8swh_k$();
    moveTime._v = new DateTime(Companion_getInstance_82().now_utobi1_k$());
  }
  function prepareViewsBase$mouseDrag($views, moveTime, type, x, y) {
    $views._input_3._mouse_0.setTo_ngl742_k$(x, y);
    Unit_getInstance();
    $views.mouseUpdated_sv8swh_k$();
    moveTime._v = new DateTime(Companion_getInstance_82().now_utobi1_k$());
  }
  function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, x, y, button, type, status) {
    mouseTouchEvent._screen = 0;
    mouseTouchEvent._emulated_0 = true;
    mouseTouchEvent._currentTime = Companion_getInstance_82().now_utobi1_k$();
    mouseTouchEvent._scaleCoords_0 = false;
    mouseTouchEvent.startFrame_bjxefj_k$(type);
    mouseTouchEvent.touch$default_grw3b9_k$(button._id_21, x, y, status, 0.0, Kind_MOUSE_getInstance(), button, 16, null);
    mouseTouchEvent.endFrame_sv8swh_k$();
    $views.dispatch_62irmi_k$(getKClass_0(TouchEvent_0), mouseTouchEvent);
  }
  function prepareViewsBase$gamepadUpdated(input, e) {
    var tmp0_fastForEach_0 = e._gamepads;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0.length) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0[tmp0_2];
      input._gamepads_1[tmp1__anonymous__3._index_28].copyFrom_ds6720_k$(tmp1__anonymous__3);
    }
    input.updateConnectedGamepads_sv8swh_k$();
  }
  function _no_name_provided__417($module, $config, resultContinuation) {
    this._$module = $module;
    this._$config = $config;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__417.prototype.invoke_n3sqyl_k$ = function ($this$invoke, $cont) {
    var tmp = this.create_e4xug2_k$($this$invoke, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__417.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_n3sqyl_k$(p1 instanceof Stage ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__417.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = RegisteredImageFormats_getInstance();
            var tmp_1 = this;
            tmp_1._tmp0_toTypedArray_00 = this._$module._get_imageFormats__0_k$();
            tmp_0.register_mo7ym5_k$(copyToArray_0(this._tmp0_toTypedArray_00).slice());
            this._injector1 = this._$config._injector_2;
            this._injector1.mapInstance_770c45_k$(getKClass_0(Module), this._$module).mapInstance_770c45_k$(getKClass_0(Config), this._$config);
            Unit_getInstance();
            this._$config._constructedViews(this._$this$invoke._views_15);
            this._state_1 = 1;
            suspendResult = this._$module.configure_k6yfpx_k$(this._injector1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            var tmp_2 = this;
            tmp_2._sc2 = SceneContainer_init_$Create$(this._$this$invoke._views_15, null, 'rootSceneContainer', 2, null);
            var tmp0_this = this._$this$invoke._views_15;
            tmp0_this._stage_0.plusAssign_4l6ao4_k$(this._sc2);
            this._state_1 = 2;
            var tmp_3 = this;
            tmp_3._tmp1_toTypedArray_03 = this._$config._sceneInjects;
            var tmp_4 = copyToArray_0(this._tmp1_toTypedArray_03).slice();
            var tmp_5 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
            suspendResult = this._sc2.changeTo$default_rq00hm_k$(this._$config._sceneClass, tmp_4, tmp_5, null, 8, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            Unit_getInstance();
            this._$this$invoke._views_15.onClose_4udvt5_k$(_no_name_provided_$factory_367(this._sc2, null));
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__417.prototype.create_e4xug2_k$ = function ($this$invoke, completion) {
    var i = new _no_name_provided__417(this._$module, this._$config, completion);
    i._$this$invoke = $this$invoke;
    return i;
  };
  _no_name_provided__417.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__418($realGameWindow, $width, $height, $title, $icon, $fullscreen, $bgcolor, $iconDrawable, $iconPath, $imageFormats, $quality, $injector, $debugAg, $timeProvider, $gameId, $settingsFolder, $batchMaxQuads, $args, $virtualWidth, $virtualHeight, $debug, $scaleAnchor, $scaleMode, $clipBorders, $targetFps, $blocking, $entry, resultContinuation) {
    this._$realGameWindow = $realGameWindow;
    this._$width_3 = $width;
    this._$height_3 = $height;
    this._$title_0 = $title;
    this._$icon = $icon;
    this._$fullscreen_0 = $fullscreen;
    this._$bgcolor = $bgcolor;
    this._$iconDrawable = $iconDrawable;
    this._$iconPath = $iconPath;
    this._$imageFormats = $imageFormats;
    this._$quality = $quality;
    this._$injector = $injector;
    this._$debugAg = $debugAg;
    this._$timeProvider = $timeProvider;
    this._$gameId = $gameId;
    this._$settingsFolder = $settingsFolder;
    this._$batchMaxQuads = $batchMaxQuads;
    this._$args = $args;
    this._$virtualWidth_0 = $virtualWidth;
    this._$virtualHeight_0 = $virtualHeight;
    this._$debug = $debug;
    this._$scaleAnchor = $scaleAnchor;
    this._$scaleMode = $scaleMode;
    this._$clipBorders = $clipBorders;
    this._$targetFps = $targetFps;
    this._$blocking_1 = $blocking;
    this._$entry_3 = $entry;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__418.prototype.invoke_9bp5e0_k$ = function ($this$loop, $cont) {
    var tmp = this.create_nbpffn_k$($this$loop, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__418.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_9bp5e0_k$(p1 instanceof GameWindow ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__418.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 22;
            this._gameWindow0 = this._$this$loop;
            if (OS_getInstance()._get_isNative__0_k$())
              println('Korui[0]');
            l$ret$5: do {
              var start_1 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
              var tmp$ret$2;
              l$ret$3: do {
                var tmp_0 = this;
                var tmp$ret$0;
                l$ret$1: do {
                  try {
                    var tmp0_elvis_lhs_5 = this._$bgcolor;
                    var tmp_1;
                    var tmp_2 = tmp0_elvis_lhs_5;
                    if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
                      tmp_1 = Colors_getInstance()._BLACK_0;
                    } else {
                      {
                        tmp_1 = tmp0_elvis_lhs_5;
                      }
                    }
                    tmp$ret$0 = configure(this._$realGameWindow, this._$width_3, this._$height_3, this._$title_0, this._$icon, this._$fullscreen_0, tmp_1);
                    break l$ret$1;
                  } catch ($p) {
                    var end_2 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
                    var tmp0__get_microseconds__0_3 = end_2 - start_1;
                    this._gameWindow0.registerTime_mqbjv8_k$('configureGameWindow', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3));
                    throw $p;
                  }
                }
                 while (false);
                var end_2_0 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
                var tmp0__get_microseconds__0_3_0 = end_2_0 - start_1;
                tmp_0._tmp$ret$41 = this._gameWindow0.registerTime_mqbjv8_k$('configureGameWindow', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_0));
                break l$ret$5;
              }
               while (false);
              var end_2_1 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
              var tmp0__get_microseconds__0_3_1 = end_2_1 - start_1;
              this._gameWindow0.registerTime_mqbjv8_k$('configureGameWindow', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_1));
            }
             while (false);
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._start_13_0 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._exceptionState = 6;
            if (!(this._$iconDrawable == null)) {
              this._$this$loop._set_icon__1l3fil_k$(render(this._$iconDrawable));
              this._state_1 = 5;
              continue $sm;
            } else {
              if (!(this._$iconPath == null)) {
                this._state_1 = 4;
                var tmp_3 = _get_resourcesVfs_().get_6wfw3l_k$(ensureNotNull(this._$iconPath));
                suspendResult = readBitmapOptimized$default(tmp_3, this._$imageFormats, false, 2, null, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                Unit_getInstance();
                this._state_1 = 5;
                continue $sm;
              }
            }

            break;
          case 4:
            this._ARGUMENT6_3 = suspendResult;
            this._$this$loop._set_icon__1l3fil_k$(this._ARGUMENT6_3);
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._exceptionState = 8;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._exceptionState = 8;
            var tmp_4 = this._exception_0;
            if (tmp_4 instanceof Error) {
              this._e_57 = this._exception_0;
              var tmp0_error_0_6 = Korge_getInstance()._logger;
              var tmp0_log_0_1_7 = Level_ERROR_getInstance();
              if (tmp0_error_0_6.isEnabled_5xis2i_k$(tmp0_log_0_1_7)) {
                tmp0_error_0_6.actualLog_sbdqh6_k$(tmp0_log_0_1_7, "Couldn't get the application icon");
              }printStackTrace_0(this._e_57);
              this._state_1 = 7;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 7:
            var tmp_5 = this;
            this._exceptionState = 8;
            tmp_5._tmp$ret$65 = Unit_getInstance();
            this._exceptionState = 22;
            this._state_1 = 9;
            var tmp_6 = this;
            continue $sm;
          case 8:
            this._exceptionState = 22;
            this._t8_0 = this._exception_0;
            var end_2_2 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            var tmp0__get_microseconds__0_3_2 = end_2_2 - this._start_13_0;
            this._gameWindow0.registerTime_mqbjv8_k$('setIcon', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_2));
            throw this._t8_0;
          case 9:
            var tmp_7 = this;
            var end_2_3 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            var tmp0__get_microseconds__0_3_3 = end_2_3 - this._start_13_0;
            tmp_7._tmp$ret$102 = this._gameWindow0.registerTime_mqbjv8_k$('setIcon', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_3));
            this._state_1 = 11;
            continue $sm;
          case 10:
            var end_2_4 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            var tmp0__get_microseconds__0_3_4 = end_2_4 - this._start_13_0;
            this._gameWindow0.registerTime_mqbjv8_k$('setIcon', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_4));
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 11;
            continue $sm;
          case 11:
            this._$this$loop._set_quality__twhgp3_k$(this._$quality);
            if (OS_getInstance()._get_isNative__0_k$())
              println('CanvasApplicationEx.IN[0]');
            this._input9 = new Input();
            this._stats10 = new Stats_1();
            var tmp_8 = this;
            var tmp_9 = this._get_context__0_k$().plus_d7pszg_k$(this._gameWindow0._get_coroutineDispatcher__0_k$()).plus_d7pszg_k$(new AsyncInjectorContext(this._$injector));
            var tmp_10 = tmp_9.plus_d7pszg_k$(SupervisorJob$default(null, 1, null));
            var tmp_11;
            if (this._$debugAg) {
              tmp_11 = PrintAG_init_$Create$(0, 0, 3, null);
            } else {
              tmp_11 = this._$this$loop._get_ag__0_k$();
            }

            tmp_8._views11 = new Views(tmp_10, tmp_11, this._$injector, this._input9, this._$timeProvider, this._stats10, this._gameWindow0, this._$gameId, this._$settingsFolder, this._$batchMaxQuads);
            if (OS_getInstance()._get_isJsBrowser__0_k$()) {
              var tmp_12 = this;
              tmp_12._tmp0_invoke_012 = Companion_getInstance_108();
              var tmp_13 = this;
              tmp_13._tmp1__anonymous__113 = Companion_getInstance_108();
              this._tmp1__anonymous__113.set_3qffwg_k$(this._tmp1__anonymous__113._get_global__0_k$(), 'views', this._views11);
            }
            var tmp2_mapInstance_0 = new ModuleArgs(this._$args);
            var tmp3_mapInstance_0 = this._$injector.mapInstance_770c45_k$(getKClass_0(ModuleArgs), tmp2_mapInstance_0).mapInstance_770c45_k$(getKClass_0(GameWindow), this._gameWindow0);
            var tmp4_mapInstance_0 = new _no_name_provided__414(this._$title_0, this._$fullscreen_0, this._$width_3, this._$height_3, this._$virtualWidth_0, this._$virtualHeight_0);
            tmp3_mapInstance_0.mapInstance_770c45_k$(getKClass_0(Module), tmp4_mapInstance_0);
            Unit_getInstance();
            this._views11._debugViews = this._$debug;
            this._views11._virtualWidth_0 = this._$virtualWidth_0;
            this._views11._virtualHeight_0 = this._$virtualHeight_0;
            this._views11._scaleAnchor_1 = this._$scaleAnchor;
            this._views11._scaleMode_4 = this._$scaleMode;
            this._views11._clipBorders_1 = this._$clipBorders;
            this._views11._targetFps_1 = this._$targetFps;
            this._state_1 = 12;
            continue $sm;
          case 12:
            this._start_115 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            this._state_1 = 13;
            continue $sm;
          case 13:
            this._state_1 = 14;
            continue $sm;
          case 14:
            this._exceptionState = 21;
            this._state_1 = 15;
            var tmp_14 = Korge_getInstance();
            var tmp_15 = this._$bgcolor;
            var tmp_16 = !((tmp_15 == null ? null : new RGBA(tmp_15)) == null);
            var tmp0_elvis_lhs_5_0 = this._$bgcolor;
            var tmp_17;
            var tmp_18 = tmp0_elvis_lhs_5_0;
            if ((tmp_18 == null ? null : new RGBA(tmp_18)) == null) {
              tmp_17 = Colors_getInstance()._TRANSPARENT_BLACK;
            } else {
              {
                tmp_17 = tmp0_elvis_lhs_5_0;
              }
            }

            var tmp_19 = tmp_17;
            suspendResult = tmp_14.prepareViews$default_s4kc4g_k$(this._views11, this._gameWindow0, tmp_16, tmp_19, null, true, 16, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 15:
            this._tmp$ret$1217 = suspendResult;
            this._exceptionState = 22;
            this._state_1 = 16;
            var tmp_20 = this;
            continue $sm;
          case 16:
            var tmp_21 = this;
            var end_2_5 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            var tmp0__get_microseconds__0_3_5 = end_2_5 - this._start_115;
            tmp_21._tmp$ret$1614 = this._gameWindow0.registerTime_mqbjv8_k$('prepareViews', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_5));
            this._state_1 = 18;
            continue $sm;
          case 17:
            var end_2_6 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            var tmp0__get_microseconds__0_3_6 = end_2_6 - this._start_115;
            this._gameWindow0.registerTime_mqbjv8_k$('prepareViews', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_6));
            if (false) {
              this._state_1 = 12;
              continue $sm;
            }
            this._state_1 = 18;
            continue $sm;
          case 18:
            l$ret$23: do {
              var start_1_0 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
              var tmp$ret$20;
              l$ret$21: do {
                var tmp_22 = this;
                var tmp$ret$18;
                l$ret$19: do {
                  try {
                    tmp$ret$18 = _get_nativeSoundProvider_().initOnce_sv8swh_k$();
                    break l$ret$19;
                  } catch ($p_0) {
                    var end_2_7 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
                    var tmp0__get_microseconds__0_3_7 = end_2_7 - start_1_0;
                    this._gameWindow0.registerTime_mqbjv8_k$('nativeSoundProvider', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_7));
                    throw $p_0;
                  }
                }
                 while (false);
                var end_2_8 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
                var tmp0__get_microseconds__0_3_8 = end_2_8 - start_1_0;
                tmp_22._tmp$ret$2218 = this._gameWindow0.registerTime_mqbjv8_k$('nativeSoundProvider', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_8));
                break l$ret$23;
              }
               while (false);
              var end_2_9 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
              var tmp0__get_microseconds__0_3_9 = end_2_9 - start_1_0;
              this._gameWindow0.registerTime_mqbjv8_k$('nativeSoundProvider', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_9));
            }
             while (false);
            l$ret$29: do {
              var start_1_1 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
              var tmp$ret$26;
              l$ret$27: do {
                var tmp_23 = this;
                var tmp$ret$24;
                l$ret$25: do {
                  try {
                    tmp$ret$24 = completeViews(this._views11);
                    break l$ret$25;
                  } catch ($p_1) {
                    var end_2_10 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
                    var tmp0__get_microseconds__0_3_10 = end_2_10 - start_1_1;
                    this._gameWindow0.registerTime_mqbjv8_k$('completeViews', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_10));
                    throw $p_1;
                  }
                }
                 while (false);
                var end_2_11 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
                var tmp0__get_microseconds__0_3_11 = end_2_11 - start_1_1;
                tmp_23._tmp$ret$2819 = this._gameWindow0.registerTime_mqbjv8_k$('completeViews', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_11));
                break l$ret$29;
              }
               while (false);
              var end_2_12 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
              var tmp0__get_microseconds__0_3_12 = end_2_12 - start_1_1;
              this._gameWindow0.registerTime_mqbjv8_k$('completeViews', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_12));
            }
             while (false);
            launchImmediately_0(this._views11, _no_name_provided_$factory_369(this._$entry_3, this._views11, this._$blocking_1, this._gameWindow0, null));
            Unit_getInstance();
            if (OS_getInstance()._get_isNative__0_k$())
              println('CanvasApplicationEx.IN[1]');
            if (OS_getInstance()._get_isNative__0_k$())
              println('Korui[1]');
            if (this._$blocking_1) {
              this._state_1 = 19;
              suspendResult = this._gameWindow0.waitClose_sv8swh_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 20;
              continue $sm;
            }

            break;
          case 19:
            this._gameWindow0.exit_sv8swh_k$();
            this._state_1 = 20;
            continue $sm;
          case 20:
            return Unit_getInstance();
          case 21:
            this._exceptionState = 22;
            var t = this._exception_0;
            var end_2_13 = PerformanceCounter_getInstance()._get_microseconds__0_k$();
            var tmp0__get_microseconds__0_3_13 = end_2_13 - this._start_115;
            this._gameWindow0.registerTime_mqbjv8_k$('prepareViews', Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_3_13));
            throw t;
          case 22:
            throw this._exception_0;
        }
      } catch ($p_2) {
        if (this._exceptionState === 22) {
          throw $p_2;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p_2;
        }
      }
     while (true);
  };
  _no_name_provided__418.prototype.create_nbpffn_k$ = function ($this$loop, completion) {
    var i = new _no_name_provided__418(this._$realGameWindow, this._$width_3, this._$height_3, this._$title_0, this._$icon, this._$fullscreen_0, this._$bgcolor, this._$iconDrawable, this._$iconPath, this._$imageFormats, this._$quality, this._$injector, this._$debugAg, this._$timeProvider, this._$gameId, this._$settingsFolder, this._$batchMaxQuads, this._$args, this._$virtualWidth_0, this._$virtualHeight_0, this._$debug, this._$scaleAnchor, this._$scaleMode, this._$clipBorders, this._$targetFps, this._$blocking_1, this._$entry_3, completion);
    i._$this$loop = $this$loop;
    return i;
  };
  _no_name_provided__418.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__419(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__419.prototype.invoke_merzw6_k$ = function ($this$mapSingleton, $cont) {
    var tmp = this.create_qg21b2_k$($this$mapSingleton, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__419.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_merzw6_k$(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__419.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          return new ResourcesRoot();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__419.prototype.create_qg21b2_k$ = function ($this$mapSingleton, completion) {
    var i = new _no_name_provided__419(completion);
    i._$this$mapSingleton = $this$mapSingleton;
    return i;
  };
  _no_name_provided__419.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__420(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__420.prototype.invoke_merzw6_k$ = function ($this$mapPrototype, $cont) {
    var tmp = this.create_qg21b2_k$($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__420.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_merzw6_k$(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__420.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          return new EmptyScene();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__420.prototype.create_qg21b2_k$ = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__420(completion);
    i._$this$mapPrototype = $this$mapPrototype;
    return i;
  };
  _no_name_provided__420.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__421($views, $ag, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
    this._$views_2 = $views;
    this._$ag = $ag;
    this._$input_3 = $input;
    this._$downPos = $downPos;
    this._$downTime = $downTime;
    this._$mouseTouchEvent = $mouseTouchEvent;
    this._$upPos = $upPos;
    this._$moveTime = $moveTime;
    this._$moveMouseOutsideInNextFrame = $moveMouseOutsideInNextFrame;
  }
  _no_name_provided__421.prototype.invoke_jl2fzq_k$ = function (e) {
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_5xis2i_k$(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog_sbdqh6_k$(tmp0_log_0_1, '' + 'eventDispatcher.addEventListener<MouseEvent>:' + e);
    }var x = prepareViewsBase$getRealX(this._$ag, e._x_20, e._scaleCoords);
    var y = prepareViewsBase$getRealY(this._$ag, e._y_19, e._scaleCoords);
    var tmp0_subject = e._type_15;
    if (tmp0_subject.equals(Type_DOWN_getInstance())) {
      prepareViewsBase$mouseDown(this._$input_3, this._$views_2, this._$downPos, this._$downTime, 'mouseDown', x, y, e._button);
      prepareViewsBase$dispatchSimulatedTouchEvent(this._$mouseTouchEvent, this._$views_2, x, y, e._button, Type_START_getInstance(), Status_ADD_getInstance());
    } else if (tmp0_subject.equals(Type_UP_getInstance())) {
      prepareViewsBase$mouseUp(this._$input_3, this._$views_2, this._$upPos, 'mouseUp', x, y, e._button);
      prepareViewsBase$dispatchSimulatedTouchEvent(this._$mouseTouchEvent, this._$views_2, x, y, e._button, Type_END_getInstance(), Status_REMOVE_getInstance());
    } else if (tmp0_subject.equals(Type_DRAG_getInstance())) {
      prepareViewsBase$mouseDrag(this._$views_2, this._$moveTime, 'onMouseDrag', x, y);
      prepareViewsBase$dispatchSimulatedTouchEvent(this._$mouseTouchEvent, this._$views_2, x, y, e._button, Type_MOVE_getInstance_0(), Status_KEEP_getInstance());
    } else if (tmp0_subject.equals(Type_MOVE_getInstance()))
      prepareViewsBase$mouseMove(this._$views_2, this._$moveMouseOutsideInNextFrame, this._$moveTime, 'mouseMove', x, y, true);
    else if (tmp0_subject.equals(Type_CLICK_getInstance()))
      Unit_getInstance();
    else if (tmp0_subject.equals(Type_ENTER_getInstance()))
      prepareViewsBase$mouseMove(this._$views_2, this._$moveMouseOutsideInNextFrame, this._$moveTime, 'mouseEnter', x, y, true);
    else if (tmp0_subject.equals(Type_EXIT_getInstance()))
      prepareViewsBase$mouseMove(this._$views_2, this._$moveMouseOutsideInNextFrame, this._$moveTime, 'mouseExit', x, y, false);
    else if (tmp0_subject.equals(Type_SCROLL_getInstance()))
      Unit_getInstance();
    this._$views_2.dispatch_62irmi_k$(getKClass_0(MouseEvent_0), e);
  };
  _no_name_provided__421.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_jl2fzq_k$(p1 instanceof MouseEvent_0 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__421.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__422($views) {
    this._$views_3 = $views;
  }
  _no_name_provided__422.prototype.invoke_hkhmy8_k$ = function (e) {
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_5xis2i_k$(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog_sbdqh6_k$(tmp0_log_0_1, '' + 'eventDispatcher.addEventListener<KeyEvent>:' + e);
    }this._$views_3.dispatch_62irmi_k$(getKClass_0(KeyEvent), e);
  };
  _no_name_provided__422.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_hkhmy8_k$(p1 instanceof KeyEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__422.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__423($views) {
    this._$views_4 = $views;
  }
  _no_name_provided__423.prototype.invoke_vnqfhy_k$ = function (e) {
    this._$views_4.dispatch_62irmi_k$(getKClass_0(ResumeEvent), e);
  };
  _no_name_provided__423.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_vnqfhy_k$(p1 instanceof ResumeEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__423.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__424($views) {
    this._$views_5 = $views;
  }
  _no_name_provided__424.prototype.invoke_ybeyw7_k$ = function (e) {
    this._$views_5.dispatch_62irmi_k$(getKClass_0(PauseEvent), e);
  };
  _no_name_provided__424.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_ybeyw7_k$(p1 instanceof PauseEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__424.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__425($views) {
    this._$views_6 = $views;
  }
  _no_name_provided__425.prototype.invoke_e0n96n_k$ = function (e) {
    this._$views_6.dispatch_62irmi_k$(getKClass_0(StopEvent), e);
  };
  _no_name_provided__425.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_e0n96n_k$(p1 instanceof StopEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__425.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__426($views) {
    this._$views_7 = $views;
  }
  _no_name_provided__426.prototype.invoke_at6r4l_k$ = function (e) {
    try {
      this._$views_7.dispatch_62irmi_k$(getKClass_0(DestroyEvent), e);
    }finally {
      launchImmediately_0(this._$views_7, _no_name_provided_$factory_370(this._$views_7, null));
      Unit_getInstance();
    }
  };
  _no_name_provided__426.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_at6r4l_k$(p1 instanceof DestroyEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__426.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__427($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $ag, $downPos, $downTime, $upPos, $moveTime) {
    this._$input_4 = $input;
    this._$views_8 = $views;
    this._$touchMouseEvent = $touchMouseEvent;
    this._$moveMouseOutsideInNextFrame_0 = $moveMouseOutsideInNextFrame;
    this._$ag_0 = $ag;
    this._$downPos_0 = $downPos;
    this._$downTime_0 = $downTime;
    this._$upPos_0 = $upPos;
    this._$moveTime_0 = $moveTime;
  }
  _no_name_provided__427.prototype.invoke_kaxwi8_k$ = function (e) {
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_5xis2i_k$(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog_sbdqh6_k$(tmp0_log_0_1, '' + 'eventDispatcher.addEventListener<TouchEvent>:' + e);
    }this._$input_4.updateTouches_kaxwi8_k$(e);
    this._$views_8.dispatch_62irmi_k$(getKClass_0(TouchEvent_0), e);
    if (e._get_numTouches__0_k$() === 1) {
      var start = e._get_isStart__0_k$();
      var end = e._get_isEnd__0_k$();
      var t = first(e._get_touches__0_k$());
      var x = prepareViewsBase$getRealX(this._$ag_0, t._x_23, e._scaleCoords_0);
      var y = prepareViewsBase$getRealY(this._$ag_0, t._y_22, e._scaleCoords_0);
      var button = MouseButton_LEFT_getInstance();
      this._$touchMouseEvent._id_17 = 0;
      this._$touchMouseEvent._button = button;
      this._$touchMouseEvent._buttons = end ? 0 : 1 << button._id_21;
      this._$touchMouseEvent._x_20 = numberToInt(x);
      this._$touchMouseEvent._y_19 = numberToInt(y);
      this._$touchMouseEvent._scaleCoords = false;
      this._$touchMouseEvent._emulated = true;
      if (start) {
        prepareViewsBase$mouseDown(this._$input_4, this._$views_8, this._$downPos_0, this._$downTime_0, 'onTouchStart', x, y, button);
        this._$touchMouseEvent._type_15 = Type_DOWN_getInstance();
      } else if (end) {
        prepareViewsBase$mouseUp(this._$input_4, this._$views_8, this._$upPos_0, 'onTouchEnd', x, y, button);
        this._$moveMouseOutsideInNextFrame_0._v = true;
        this._$touchMouseEvent._type_15 = Type_UP_getInstance();
      } else {
        prepareViewsBase$mouseMove(this._$views_8, this._$moveMouseOutsideInNextFrame_0, this._$moveTime_0, 'onTouchMove', x, y, true);
        this._$touchMouseEvent._type_15 = Type_DRAG_getInstance();
      }
      this._$views_8.dispatch_62irmi_k$(getKClass_0(MouseEvent_0), this._$touchMouseEvent);
    }};
  _no_name_provided__427.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_kaxwi8_k$(p1 instanceof TouchEvent_0 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__427.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__428($views) {
    this._$views_9 = $views;
  }
  _no_name_provided__428.prototype.invoke_9dz81c_k$ = function (e) {
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_5xis2i_k$(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog_sbdqh6_k$(tmp0_log_0_1, '' + 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e);
    }this._$views_9.dispatch_62irmi_k$(getKClass_0(GamePadConnectionEvent), e);
  };
  _no_name_provided__428.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_9dz81c_k$(p1 instanceof GamePadConnectionEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__428.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__429($views, $input) {
    this._$views_10 = $views;
    this._$input_5 = $input;
  }
  _no_name_provided__429.prototype.invoke_6k410b_k$ = function (e) {
    prepareViewsBase$gamepadUpdated(this._$input_5, e);
    this._$views_10.dispatch_62irmi_k$(getKClass_0(GamePadUpdateEvent), e);
  };
  _no_name_provided__429.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_6k410b_k$(p1 instanceof GamePadUpdateEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__429.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__430($views, $ag) {
    this._$views_11 = $views;
    this._$ag_1 = $ag;
  }
  _no_name_provided__430.prototype.invoke_c58cn5_k$ = function (e) {
    this._$views_11.resized_rvwcgf_k$(this._$ag_1._get_backWidth__0_k$(), this._$ag_1._get_backHeight__0_k$());
  };
  _no_name_provided__430.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_c58cn5_k$(p1 instanceof ReshapeEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__430.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__431($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
    this._$views_12 = $views;
    this._$renderShown = $renderShown;
    this._$firstRenderDeferred = $firstRenderDeferred;
    this._$fixedSizeStep = $fixedSizeStep;
    this._$moveMouseOutsideInNextFrame_1 = $moveMouseOutsideInNextFrame;
  }
  _no_name_provided__431.prototype.invoke_pg04b7_k$ = function (it) {
    var tmp0_doRender_0 = this._$views_12._ag_6;
    tmp0_doRender_0.beforeDoRender_sv8swh_k$();
    tmp0_doRender_0._get_mainRenderBuffer__0_k$().init_sv8swh_k$();
    var tmp0_setRenderBufferTemporally_0_1 = tmp0_doRender_0._get_mainRenderBuffer__0_k$();
    var old_1_2 = tmp0_doRender_0.setRenderBuffer_rpvbnr_k$(tmp0_setRenderBufferTemporally_0_1);
    try {
      if (!this._$renderShown._v) {
        this._$renderShown._v = true;
        this._$firstRenderDeferred.complete_2c5_k$(Unit_getInstance());
        Unit_getInstance();
      }try {
        this._$views_12.frameUpdateAndRender_zah5t7_k$(this._$fixedSizeStep);
        this._$views_12._input_3._mouseOutside = false;
        if (this._$moveMouseOutsideInNextFrame_1._v) {
          this._$moveMouseOutsideInNextFrame_1._v = false;
          this._$views_12._input_3._mouseOutside = true;
          this._$views_12._input_3._mouseInside = false;
          this._$views_12.mouseUpdated_sv8swh_k$();
        }} catch ($p) {
        if ($p instanceof Error) {
          printStackTrace_0($p);
        } else {
          {
            throw $p;
          }
        }
      }
    }finally {
      tmp0_doRender_0.setRenderBuffer_rpvbnr_k$(old_1_2);
      Unit_getInstance();
    }
  };
  _no_name_provided__431.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_pg04b7_k$(p1 instanceof RenderEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__431.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $invokeCOROUTINE$0(_this_, config, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__174 = _this_;
    this._config_4 = config;
  }
  $invokeCOROUTINE$0.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._module0 = this._config_4._module;
            this._windowSize1 = this._module0._get_windowSize__qgazdw_k$();
            this._tmp0_title2 = this._module0._get_title__0_k$();
            this._tmp1_width3 = _SizeInt___get_width__impl_(this._windowSize1);
            this._tmp2_height4 = _SizeInt___get_height__impl_(this._windowSize1);
            this._tmp3_virtualWidth5 = _SizeInt___get_width__impl_(this._module0._get_size__qgazdw_k$());
            this._tmp4_virtualHeight6 = _SizeInt___get_height__impl_(this._module0._get_size__qgazdw_k$());
            this._tmp5_bgcolor7 = this._module0._get_bgcolor__12t64v_k$();
            this._tmp6_quality8 = this._module0._get_quality__0_k$();
            this._tmp7_iconPath9 = this._module0._get_icon__0_k$();
            this._tmp8_iconDrawable10 = this._module0._get_iconImage__0_k$();
            this._tmp9_imageFormats11 = new ImageFormats(this._module0._get_imageFormats__0_k$());
            this._tmp10_targetFps12 = this._module0._get_targetFps__0_k$();
            this._tmp11_scaleAnchor13 = this._module0._get_scaleAnchor__0_k$();
            this._tmp12_scaleMode14 = this._module0._get_scaleMode__0_k$();
            this._tmp13_clipBorders15 = this._module0._get_clipBorders__0_k$();
            this._tmp14_debug16 = this._config_4._debug_2;
            this._tmp15_fullscreen17 = this._module0._get_fullscreen__0_k$();
            this._tmp16_args18 = this._config_4._args;
            this._tmp17_gameWindow19 = this._config_4._gameWindow;
            this._tmp18_injector20 = this._config_4._injector_2;
            this._tmp19_timeProvider21 = this._config_4._timeProvider_1;
            this._tmp20_blocking22 = this._config_4._blocking;
            this._tmp21_gameId23 = this._config_4._gameId;
            this._tmp22_settingsFolder24 = this._config_4._settingsFolder;
            this._tmp23_batchMaxQuads25 = this._config_4._batchMaxQuads;
            this._state_1 = 1;
            var tmp_0 = Korge_getInstance();
            suspendResult = tmp_0.invoke$default_vg9ark_k$(this._tmp0_title2, this._tmp1_width3, this._tmp2_height4, this._tmp3_virtualWidth5, this._tmp4_virtualHeight6, null, this._tmp7_iconPath9, this._tmp8_iconDrawable10, this._tmp9_imageFormats11, this._tmp6_quality8, this._tmp10_targetFps12, this._tmp11_scaleAnchor13, this._tmp12_scaleMode14, this._tmp13_clipBorders15, this._tmp5_bgcolor7, this._tmp14_debug16, this._tmp15_fullscreen17, this._tmp16_args18, this._tmp17_gameWindow19, this._tmp19_timeProvider21, this._tmp18_injector20, false, this._tmp20_blocking22, this._tmp21_gameId23, this._tmp22_settingsFolder24, this._tmp23_batchMaxQuads25, _no_name_provided_$factory_371(this._module0, this._config_4, null), 2097152, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$0.$metadata$ = {
    simpleName: '$invokeCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $invokeCOROUTINE$1(_this_, title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector_0, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__175 = _this_;
    this._title_0 = title;
    this._width_18 = width;
    this._height_19 = height;
    this._virtualWidth = virtualWidth;
    this._virtualHeight = virtualHeight;
    this._icon_1 = icon;
    this._iconPath = iconPath;
    this._iconDrawable = iconDrawable;
    this._imageFormats_0 = imageFormats;
    this._quality_3 = quality;
    this._targetFps = targetFps;
    this._scaleAnchor = scaleAnchor;
    this._scaleMode_1 = scaleMode;
    this._clipBorders = clipBorders;
    this._bgcolor_0 = bgcolor;
    this._debug_3 = debug;
    this._fullscreen_3 = fullscreen;
    this._args_1 = args;
    this._gameWindow_0 = gameWindow;
    this._timeProvider_2 = timeProvider;
    this._injector_3 = injector_0;
    this._debugAg = debugAg;
    this._blocking_0 = blocking;
    this._gameId_0 = gameId;
    this._settingsFolder_0 = settingsFolder;
    this._batchMaxQuads_0 = batchMaxQuads;
    this._entry_3 = entry;
  }
  $invokeCOROUTINE$1.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            if (!OS_getInstance()._get_isJsBrowser__0_k$()) {
              this._state_1 = 1;
              suspendResult = configureLoggerFromProperties(_get_localCurrentDirVfs_().get_6wfw3l_k$('klogger.properties'), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            var tmp_0 = this;
            var tmp0_elvis_lhs = this._gameWindow_0;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              tmp_1 = this._get_context__0_k$().get_9uvjra_k$(CoroutineKey_getInstance());
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            var tmp1_elvis_lhs = tmp_1;
            tmp_0._realGameWindow0 = tmp1_elvis_lhs == null ? CreateDefaultGameWindow() : tmp1_elvis_lhs;
            var tmp2_elvis_lhs = this._bgcolor_0;
            var tmp_2;
            var tmp_3 = tmp2_elvis_lhs;
            if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
              tmp_2 = Colors_getInstance()._BLACK_0;
            } else {
              {
                tmp_2 = tmp2_elvis_lhs;
              }
            }

            this._realGameWindow0._set_bgcolor__f52nlt_k$(tmp_2);
            this._state_1 = 3;
            suspendResult = this._realGameWindow0.loop_59tp16_k$(_no_name_provided_$factory_372(this._realGameWindow0, this._width_18, this._height_19, this._title_0, this._icon_1, this._fullscreen_3, this._bgcolor_0, this._iconDrawable, this._iconPath, this._imageFormats_0, this._quality_3, this._injector_3, this._debugAg, this._timeProvider_2, this._gameId_0, this._settingsFolder_0, this._batchMaxQuads_0, this._args_1, this._virtualWidth, this._virtualHeight, this._debug_3, this._scaleAnchor, this._scaleMode_1, this._clipBorders, this._targetFps, this._blocking_0, this._entry_3, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$1.$metadata$ = {
    simpleName: '$invokeCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $prepareViewsCOROUTINE$3(_this_, views_0, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__176 = _this_;
    this._views = views_0;
    this._eventDispatcher = eventDispatcher;
    this._clearEachFrame = clearEachFrame;
    this._bgcolor_1 = bgcolor;
    this._fixedSizeStep = fixedSizeStep;
    this._waitForFirstRender = waitForFirstRender;
  }
  $prepareViewsCOROUTINE$3.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._firstRenderDeferred0 = this.__this__176.prepareViewsBase_6ulamt_k$(this._views, this._eventDispatcher, this._clearEachFrame, this._bgcolor_1, this._fixedSizeStep);
            if (this._waitForFirstRender) {
              this._state_1 = 1;
              suspendResult = this._firstRenderDeferred0.await_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $prepareViewsCOROUTINE$3.$metadata$ = {
    simpleName: '$prepareViewsCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function Korge() {
    Korge_instance = this;
    this._logger = Companion_getInstance_98().invoke_6wfw3l_k$('Korge');
    this._DEFAULT_GAME_ID = 'com.soywiz.korge.unknown';
  }
  Korge.prototype.invoke_te0jre_k$ = function (config, $cont) {
    var tmp = new $invokeCOROUTINE$0(this, config, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Korge.prototype.invoke_f6eouf_k$ = function (title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector_0, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, $cont) {
    var tmp = new $invokeCOROUTINE$1(this, title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector_0, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Korge.prototype.invoke$default_vg9ark_k$ = function (title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector_0, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      title = 'Korge';
    if (!(($mask0 & 2) === 0)) {
      DefaultViewport_getInstance();
      width = 1280;
    }if (!(($mask0 & 4) === 0)) {
      DefaultViewport_getInstance();
      height = 720;
    }if (!(($mask0 & 8) === 0))
      virtualWidth = width;
    if (!(($mask0 & 16) === 0))
      virtualHeight = height;
    if (!(($mask0 & 32) === 0))
      icon = null;
    if (!(($mask0 & 64) === 0))
      iconPath = null;
    if (!(($mask0 & 128) === 0))
      iconDrawable = null;
    if (!(($mask0 & 256) === 0))
      imageFormats = ImageFormats_init_$Create$([PNG_getInstance()]);
    if (!(($mask0 & 512) === 0))
      quality = Quality_AUTOMATIC_getInstance();
    if (!(($mask0 & 1024) === 0))
      targetFps = 0.0;
    if (!(($mask0 & 2048) === 0))
      scaleAnchor = Companion_getInstance_25()._MIDDLE_CENTER;
    if (!(($mask0 & 4096) === 0))
      scaleMode = Companion_getInstance_37()._SHOW_ALL;
    if (!(($mask0 & 8192) === 0))
      clipBorders = true;
    if (!(($mask0 & 16384) === 0))
      bgcolor = Colors_getInstance()._BLACK_0;
    if (!(($mask0 & 32768) === 0))
      debug = false;
    if (!(($mask0 & 65536) === 0))
      fullscreen = null;
    if (!(($mask0 & 131072) === 0)) {
      args = [];
    }if (!(($mask0 & 262144) === 0))
      gameWindow = null;
    if (!(($mask0 & 524288) === 0))
      timeProvider = Companion_getInstance_91();
    if (!(($mask0 & 1048576) === 0)) {
      injector_0 = AsyncInjector_init_$Create$(null, 0, 3, null);
    }if (!(($mask0 & 2097152) === 0))
      debugAg = false;
    if (!(($mask0 & 4194304) === 0))
      blocking = true;
    if (!(($mask0 & 8388608) === 0))
      gameId = this._DEFAULT_GAME_ID;
    if (!(($mask0 & 16777216) === 0))
      settingsFolder = null;
    if (!(($mask0 & 33554432) === 0))
      batchMaxQuads = Companion_getInstance_200()._DEFAULT_BATCH_QUADS;
    return this.invoke_f6eouf_k$(title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector_0, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, $cont);
  };
  Korge.prototype.prepareViewsBase_6ulamt_k$ = function (views_0, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep) {
    var injector_0 = views_0._injector_7;
    injector_0.mapInstance_770c45_k$(getKClass_0(Views), views_0);
    Unit_getInstance();
    var tmp0_mapInstance_0 = views_0._ag_6;
    injector_0.mapInstance_770c45_k$(getKClass_0(AG), tmp0_mapInstance_0);
    Unit_getInstance();
    injector_0.mapInstance_770c45_k$(getKClass_0(Resources), views_0._get_globalResources__0_k$());
    Unit_getInstance();
    var tmp = getKClass_0(ResourcesRoot);
    injector_0.mapSingleton_tk1g05_k$(tmp, _no_name_provided_$factory_353(null));
    Unit_getInstance();
    var tmp1_mapInstance_0 = views_0._input_3;
    injector_0.mapInstance_770c45_k$(getKClass_0(Input), tmp1_mapInstance_0);
    Unit_getInstance();
    var tmp2_mapInstance_0 = views_0._stats_2;
    injector_0.mapInstance_770c45_k$(getKClass_0(Stats_1), tmp2_mapInstance_0);
    Unit_getInstance();
    injector_0.mapInstance_770c45_k$(getKClass_0(CoroutineContext), views_0._coroutineContext_6);
    Unit_getInstance();
    var tmp_0 = getKClass_0(EmptyScene);
    injector_0.mapPrototype_tk1g05_k$(tmp_0, _no_name_provided_$factory_354(null));
    Unit_getInstance();
    injector_0.mapInstance_770c45_k$(getKClass_0(TimeProvider), views_0._timeProvider_3);
    Unit_getInstance();
    var input = views_0._input_3;
    var ag = views_0._ag_6;
    var downPos = Companion_getInstance_32().invoke_0_k$();
    var upPos = Companion_getInstance_32().invoke_0_k$();
    var downTime = {_v: new DateTime(Companion_getInstance_82()._EPOCH)};
    var moveTime = {_v: new DateTime(Companion_getInstance_82()._EPOCH)};
    var upTime = Companion_getInstance_82()._EPOCH;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    var mouseTouchEvent = TouchEvent_init_$Create$(null, 0, null, false, false, 31, null);
    var tmp3_addEventListener_0 = _no_name_provided_$factory_355(views_0, ag, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(MouseEvent_0), tmp3_addEventListener_0);
    Unit_getInstance();
    var tmp4_addEventListener_0 = _no_name_provided_$factory_356(views_0);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(KeyEvent), tmp4_addEventListener_0);
    Unit_getInstance();
    var tmp5_addEventListener_0 = _no_name_provided_$factory_357(views_0);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(ResumeEvent), tmp5_addEventListener_0);
    Unit_getInstance();
    var tmp6_addEventListener_0 = _no_name_provided_$factory_358(views_0);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(PauseEvent), tmp6_addEventListener_0);
    Unit_getInstance();
    var tmp7_addEventListener_0 = _no_name_provided_$factory_359(views_0);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(StopEvent), tmp7_addEventListener_0);
    Unit_getInstance();
    var tmp8_addEventListener_0 = _no_name_provided_$factory_360(views_0);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(DestroyEvent), tmp8_addEventListener_0);
    Unit_getInstance();
    var touchMouseEvent = MouseEvent_init_$Create$(null, 0, 0, 0, null, 0, 0.0, 0.0, 0.0, false, false, false, false, false, false, 32767, null);
    var tmp9_addEventListener_0 = _no_name_provided_$factory_361(input, views_0, touchMouseEvent, moveMouseOutsideInNextFrame, ag, downPos, downTime, upPos, moveTime);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(TouchEvent_0), tmp9_addEventListener_0);
    Unit_getInstance();
    var tmp10_addEventListener_0 = _no_name_provided_$factory_362(views_0);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(GamePadConnectionEvent), tmp10_addEventListener_0);
    Unit_getInstance();
    var tmp11_addEventListener_0 = _no_name_provided_$factory_363(views_0, input);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(GamePadUpdateEvent), tmp11_addEventListener_0);
    Unit_getInstance();
    var tmp12_addEventListener_0 = _no_name_provided_$factory_364(views_0, ag);
    eventDispatcher.addEventListener_lfkrxw_k$(getKClass_0(ReshapeEvent), tmp12_addEventListener_0);
    Unit_getInstance();
    var tmp13_dispatch_0 = new ReshapeEvent(0, 0, views_0._get_nativeWidth__0_k$(), views_0._get_nativeHeight__0_k$());
    eventDispatcher.dispatch_62irmi_k$(getKClass_0(ReshapeEvent), tmp13_dispatch_0);
    var renderShown = {_v: false};
    views_0._clearEachFrame_1 = clearEachFrame;
    views_0._clearColor = bgcolor;
    var firstRenderDeferred = CompletableDeferred$default(null, 1, null);
    views_0._gameWindow_1.onRenderEvent_6lyars_k$(_no_name_provided_$factory_365(views_0, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  };
  Korge.prototype.prepareViews_qy8jzo_k$ = function (views_0, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, $cont) {
    var tmp = new $prepareViewsCOROUTINE$3(this, views_0, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Korge.prototype.prepareViews$default_s4kc4g_k$ = function (views_0, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      clearEachFrame = true;
    if (!(($mask0 & 8) === 0))
      bgcolor = Colors_getInstance()._TRANSPARENT_BLACK;
    if (!(($mask0 & 16) === 0))
      fixedSizeStep = Companion_getInstance_92()._NIL;
    if (!(($mask0 & 32) === 0))
      waitForFirstRender = true;
    return this.prepareViews_qy8jzo_k$(views_0, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, $cont);
  };
  Korge.$metadata$ = {
    simpleName: 'Korge',
    kind: 'object',
    interfaces: []
  };
  var Korge_instance;
  function Korge_getInstance() {
    if (Korge_instance == null)
      new Korge();
    return Korge_instance;
  }
  function _no_name_provided_$factory_353(resultContinuation) {
    var i = new _no_name_provided__419(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_merzw6_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_354(resultContinuation) {
    var i = new _no_name_provided__420(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_merzw6_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_355($views, $ag, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
    var i = new _no_name_provided__421($views, $ag, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame);
    return function (p1) {
      i.invoke_jl2fzq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_356($views) {
    var i = new _no_name_provided__422($views);
    return function (p1) {
      i.invoke_hkhmy8_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_357($views) {
    var i = new _no_name_provided__423($views);
    return function (p1) {
      i.invoke_vnqfhy_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_358($views) {
    var i = new _no_name_provided__424($views);
    return function (p1) {
      i.invoke_ybeyw7_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_359($views) {
    var i = new _no_name_provided__425($views);
    return function (p1) {
      i.invoke_e0n96n_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_360($views) {
    var i = new _no_name_provided__426($views);
    return function (p1) {
      i.invoke_at6r4l_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_361($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $ag, $downPos, $downTime, $upPos, $moveTime) {
    var i = new _no_name_provided__427($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $ag, $downPos, $downTime, $upPos, $moveTime);
    return function (p1) {
      i.invoke_kaxwi8_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_362($views) {
    var i = new _no_name_provided__428($views);
    return function (p1) {
      i.invoke_9dz81c_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_363($views, $input) {
    var i = new _no_name_provided__429($views, $input);
    return function (p1) {
      i.invoke_6k410b_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_364($views, $ag) {
    var i = new _no_name_provided__430($views, $ag);
    return function (p1) {
      i.invoke_c58cn5_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_365($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
    var i = new _no_name_provided__431($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame);
    return function (p1) {
      i.invoke_pg04b7_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_366() {
    var i = new _no_name_provided__411();
    return function (p1) {
      i.invoke_ukkq99_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_367($sc, resultContinuation) {
    var i = new _no_name_provided__412($sc, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_368($entry, $views, $blocking, $gameWindow, resultContinuation) {
    var i = new _no_name_provided__413($entry, $views, $blocking, $gameWindow, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_2i3g7c_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_369($entry, $views, $blocking, $gameWindow, resultContinuation) {
    var i = new _no_name_provided__415($entry, $views, $blocking, $gameWindow, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_370($views, resultContinuation) {
    var i = new _no_name_provided__416($views, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_371($module, $config, resultContinuation) {
    var i = new _no_name_provided__417($module, $config, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_n3sqyl_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_372($realGameWindow, $width, $height, $title, $icon, $fullscreen, $bgcolor, $iconDrawable, $iconPath, $imageFormats, $quality, $injector, $debugAg, $timeProvider, $gameId, $settingsFolder, $batchMaxQuads, $args, $virtualWidth, $virtualHeight, $debug, $scaleAnchor, $scaleMode, $clipBorders, $targetFps, $blocking, $entry, resultContinuation) {
    var i = new _no_name_provided__418($realGameWindow, $width, $height, $title, $icon, $fullscreen, $bgcolor, $iconDrawable, $iconPath, $imageFormats, $quality, $injector, $debugAg, $timeProvider, $gameId, $settingsFolder, $batchMaxQuads, $args, $virtualWidth, $virtualHeight, $debug, $scaleAnchor, $scaleMode, $clipBorders, $targetFps, $blocking, $entry, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_9bp5e0_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function AnElement() {
  }
  AnElement.$metadata$ = {
    simpleName: 'AnElement',
    kind: 'interface',
    interfaces: []
  };
  function AnShape(library, shapeSymbol) {
    AnBaseShape.call(this, library, shapeSymbol);
    this._shapeSymbol = shapeSymbol;
    this._dx_0 = this._shapeSymbol._get_bounds__0_k$()._x_2;
    this._dy_0 = this._shapeSymbol._get_bounds__0_k$()._y_2;
    var tmp = this;
    var tmp0_safe_receiver = this._shapeSymbol._textureWithBitmap;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._texture_4;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp0__get_transparent__0 = Bitmaps_getInstance();
      tmp_0 = Bitmaps_transparent;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    tmp._tex_0 = tmp_0;
    var tmp_1 = this;
    var tmp0_safe_receiver_0 = this._shapeSymbol._textureWithBitmap;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0._scale_2;
    tmp_1._texScale = tmp1_elvis_lhs_0 == null ? 1.0 : tmp1_elvis_lhs_0;
    this._texWidth = this._tex_0._get_width__0_k$() / this._texScale;
    this._texHeight = this._tex_0._get_height__0_k$() / this._texScale;
    this._smoothing = true;
  }
  AnShape.prototype._get_dx__0_k$ = function () {
    return this._dx_0;
  };
  AnShape.prototype._get_dy__0_k$ = function () {
    return this._dy_0;
  };
  AnShape.prototype._get_tex__0_k$ = function () {
    return this._tex_0;
  };
  AnShape.prototype._get_texWidth__0_k$ = function () {
    return this._texWidth;
  };
  AnShape.prototype._get_texHeight__0_k$ = function () {
    return this._texHeight;
  };
  AnShape.prototype._get_smoothing__0_k$ = function () {
    return this._smoothing;
  };
  AnShape.$metadata$ = {
    simpleName: 'AnShape',
    kind: 'class',
    interfaces: [AnElement]
  };
  function replaceDepth($this, depth, view) {
    var result = replaceWith($this._unsortedChildren.get_ha5a7z_k$(depth), view);
    $this._unsortedChildren.set_ddb1qf_k$(depth, view);
    Unit_getInstance();
    return result;
  }
  function update($this) {
    var inductionVariable = 0;
    var last_1 = $this._totalDepths;
    if (inductionVariable < last_1)
      do {
        var depth = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_safe_receiver = $this._timelineRunner._currentSubtimeline;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._timelines;
        var tmp;
        if (tmp2_elvis_lhs == null) {
          continue;
        } else {
          tmp = tmp2_elvis_lhs;
        }
        var timelines = tmp;
        var timeline = timelines[depth];
        if (timeline._get_size__0_k$() <= 0)
          continue;
        var hasMultipleFrames = timeline._get_size__0_k$() > 1;
        if ($this._smoothing_0) {
          var tmp3_container = timeline.find_2ntwu5_k$($this._timelineRunner._currentTime_0, $this._tempTimedResult);
          var index_0 = tmp3_container.component1_0_k$();
          var left = tmp3_container.component2_0_k$();
          var right = tmp3_container.component3_0_k$();
          var ratio = tmp3_container.component4_0_k$();
          if (!(left == null))
            $this._maskPushDepths[left._depth_1] = left._clipDepth;
          var view = (!(left == null) ? left._uid >= 0 : false) ? $this._viewUids[left._uid] : $this._dummyDepths[depth];
          var placed = replaceDepth($this, depth, view);
          if (placed ? true : hasMultipleFrames) {
            if ((!(left == null) ? !(right == null) : false) ? left._uid === right._uid : false) {
              Companion_getInstance_194().setToViewInterpolated_4zwj8j_k$(view, left, right, ratio);
            } else {
              var tmp4_safe_receiver = left;
              if (tmp4_safe_receiver == null)
                null;
              else {
                tmp4_safe_receiver.setToView_4l6ao4_k$(view);
                Unit_getInstance();
              }
              Unit_getInstance();
            }
            var tmp_0;
            if (!($this._symbol_0._ninePatch_0 == null)) {
              tmp_0 = view instanceof AnBaseShape;
            } else {
              tmp_0 = false;
            }
            if (tmp_0)
              view._ninePatch = $this._symbol_0._ninePatch_0;
            else {
            }
          }} else {
          var tmp5_container = timeline.findWithoutInterpolation_2ntwu5_k$($this._timelineRunner._currentTime_0, $this._tempTimedResult);
          var index_1 = tmp5_container.component1_0_k$();
          var left_0 = tmp5_container.component2_0_k$();
          if (!(left_0 == null))
            $this._maskPushDepths[left_0._depth_1] = left_0._clipDepth;
          var view_0 = (!(left_0 == null) ? left_0._uid >= 0 : false) ? $this._viewUids[left_0._uid] : $this._dummyDepths[depth];
          var placed_0 = replaceDepth($this, depth, view_0);
          if (placed_0 ? true : hasMultipleFrames) {
            var tmp6_safe_receiver = left_0;
            if (tmp6_safe_receiver == null)
              null;
            else {
              tmp6_safe_receiver.setToView_4l6ao4_k$(view_0);
              Unit_getInstance();
            }
            Unit_getInstance();
            var tmp_1;
            if (!($this._symbol_0._ninePatch_0 == null)) {
              tmp_1 = view_0 instanceof AnBaseShape;
            } else {
              tmp_1 = false;
            }
            if (tmp_1)
              view_0._ninePatch = $this._symbol_0._ninePatch_0;
            else {
            }
          }}
      }
       while (inductionVariable < last_1);
  }
  function updateInternal($this, dt) {
    if ($this._timelineRunner._running_1 ? $this._firstUpdate ? true : !$this._singleFrame : false) {
      $this._firstUpdate = false;
      $this._timelineRunner.update_zah5t7_k$(dt);
      update($this);
    } else {
    }
  }
  function _no_name_provided__432() {
  }
  _no_name_provided__432.prototype.invoke_739q7y_k$ = function ($this$addUpdater, it) {
    updateInternal($this$addUpdater, it);
  };
  _no_name_provided__432.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof AnMovieClip ? p1 : THROW_CCE();
    this.invoke_739q7y_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__432.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AnMovieClip(library, symbol) {
    Container.call(this);
    this._library = library;
    this._symbol_0 = symbol;
    var tmp = this;
    tmp._tempTimedResult = Result_init_$Create$(0, null, null, 0.0, 15, null);
    this._totalDepths = this._symbol_0._limits._totalDepths_0;
    this._totalUids = this._symbol_0._limits._totalUids_0;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this._totalDepths;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = new DummyView();
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._dummyDepths = tmp_3;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this._totalDepths + 10 | 0;
    var tmp_8 = new Int32Array(tmp_7);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      tmp_8[tmp_9] = -1;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5._maskPushDepths = tmp_8;
    var tmp_10 = this;
    var tmp_11 = 0;
    var tmp_12 = this._totalDepths + 10 | 0;
    var tmp_13 = booleanArray(tmp_12);
    while (tmp_11 < tmp_12) {
      var tmp_14 = tmp_11;
      tmp_13[tmp_14] = false;
      tmp_11 = tmp_11 + 1 | 0;
    }
    tmp_10._maskPopDepths = tmp_13;
    var tmp_15 = this;
    var tmp_16 = 0;
    var tmp_17 = this._totalUids;
    var tmp_18 = fillArrayVal(Array(tmp_17), null);
    while (tmp_16 < tmp_17) {
      var tmp_19 = tmp_16;
      var info = this._symbol_0._uidInfo[tmp_19];
      if (info._characterId === this._symbol_0._get_id__0_k$()) {
        throw IllegalStateException_init_$Create$_0('Recursive detection');
      }var tmp_20 = this._library.create_ha5a7z_k$(info._characterId);
      var tmp0_also_0 = tmp_20 instanceof View ? tmp_20 : THROW_CCE();
      tmp0_also_0.addProps_lvinfi_k$(info._extraProps);
      tmp_18[tmp_19] = tmp0_also_0;
      tmp_16 = tmp_16 + 1 | 0;
    }
    tmp_15._viewUids = tmp_18;
    this._firstUpdate = true;
    this._smoothing_0 = this._library._defaultSmoothing;
    this._singleFrame = this._symbol_0._limits._totalFrames <= 1;
    this._unsortedChildren = ArrayList_init_$Create$_1(toList(this._dummyDepths));
    this._timelineRunner = new TimelineRunner(this, this._symbol_0);
    var tmp0_fastForEach_0 = this._dummyDepths;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0.length) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0[tmp0_2];
      this.plusAssign_4l6ao4_k$(tmp1__anonymous__3);
    }
    addUpdater(this, _no_name_provided_$factory_373());
    Unit_getInstance();
    var tmp_21 = this;
    tmp_21._tempMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._tempLocalRenderState = new LocalRenderState();
  }
  AnMovieClip.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (!this._get_visible__0_k$())
      return Unit_getInstance();
    var tmp0_fill_0 = this._maskPopDepths;
    var tmp1_fill_0 = tmp0_fill_0.length;
    fill_3(tmp0_fill_0, false, 0, tmp1_fill_0);
    var usedStencil = false;
    var state = 0;
    var tmp0_safe_receiver_1 = this._get__children__0_k$();
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var array_1 = tmp0_safe_receiver_1._array_4;
      var n_2 = 0;
      while (n_2 < array_1.length) {
        var tmp2__anonymous__2 = n_2;
        var tmp0_unsafeCast_0_3 = array_1[n_2];
        var tmp3__anonymous__2 = tmp0_unsafeCast_0_3;
        var tmp0_getOrElse_0_4 = this._maskPushDepths;
        var tmp;
        if (tmp2__anonymous__2 >= 0 ? tmp2__anonymous__2 <= _get_lastIndex_(tmp0_getOrElse_0_4) : false) {
          tmp = tmp0_getOrElse_0_4[tmp2__anonymous__2];
        } else {
          tmp = -1;
        }
        var maskDepth_3 = tmp;
        if (maskDepth_3 >= 0) {
          if (0 <= maskDepth_3 ? maskDepth_3 <= (this._maskPopDepths.length - 1 | 0) : false) {
            this._maskPopDepths[maskDepth_3] = true;
            var tmp0_this_5 = ctx;
            var tmp1_6 = tmp0_this_5._stencilIndex;
            tmp0_this_5._stencilIndex = tmp1_6 + 1 | 0;
            Unit_getInstance();
            usedStencil = true;
            MaskStates_getInstance()._STATE_SHAPE.set_q6qbft_k$(ctx, ctx._stencilIndex, this._tempLocalRenderState);
            state = 1;
          }}var tmp_0;
        if (ctx._masksEnabled) {
          tmp_0 = true;
        } else {
          tmp_0 = true;
        }
        var showChild_7 = tmp_0;
        if (showChild_7) {
          tmp3__anonymous__2.render_uxru53_k$(ctx);
        }if (maskDepth_3 >= 0) {
          MaskStates_getInstance()._STATE_CONTENT.set_q6qbft_k$(ctx, ctx._stencilIndex, this._tempLocalRenderState);
          state = 2;
        }var tmp1_getOrElse_0_8 = this._maskPopDepths;
        var tmp_1;
        if (tmp2__anonymous__2 >= 0 ? tmp2__anonymous__2 <= _get_lastIndex__2(tmp1_getOrElse_0_8) : false) {
          tmp_1 = tmp1_getOrElse_0_8[tmp2__anonymous__2];
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          MaskStates_getInstance()._STATE_NONE.set_q6qbft_k$(ctx, 0, this._tempLocalRenderState);
          var tmp2_this_9 = ctx;
          var tmp3_10 = tmp2_this_9._stencilIndex;
          tmp2_this_9._stencilIndex = tmp3_10 - 1 | 0;
          Unit_getInstance();
          state = 0;
        } else {
        }
        var tmp0_4 = n_2;
        n_2 = tmp0_4 + 1 | 0;
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    if (usedStencil ? ctx._stencilIndex <= 0 : false) {
      ctx._stencilIndex = 0;
      var tmp0_stencil = ctx._stencilIndex;
      ctx._ag_5.clear$default_qpozyh_k$(null, 0.0, tmp0_stencil, false, false, true, 3, null);
    }};
  AnMovieClip.prototype._set_ratio__okcceq_k$ = function (value) {
    this._timelineRunner._set_ratio__okcceq_k$(value);
    update(this);
  };
  AnMovieClip.prototype._get_ratio__0_k$ = function () {
    return this._timelineRunner._get_ratio__0_k$();
  };
  AnMovieClip.prototype.toString = function () {
    return Container.prototype.toString.call(this) + ':symbol=' + this._symbol_0;
  };
  AnMovieClip.$metadata$ = {
    simpleName: 'AnMovieClip',
    kind: 'class',
    interfaces: [AnElement, AnPlayable]
  };
  function AnEmptyView_init_$Init$(library, symbol, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      symbol = AnSymbolEmpty_getInstance();
    AnEmptyView.call($this, library, symbol);
    return $this;
  }
  function AnEmptyView_init_$Create$(library, symbol, $mask0, $marker) {
    return AnEmptyView_init_$Init$(library, symbol, $mask0, $marker, Object.create(AnEmptyView.prototype));
  }
  function AnEmptyView(library, symbol) {
    DummyView.call(this);
    this._library_0 = library;
    this._symbol_1 = symbol;
  }
  AnEmptyView.$metadata$ = {
    simpleName: 'AnEmptyView',
    kind: 'class',
    interfaces: [AnElement]
  };
  function AnTextField(library, symbol) {
    Container.call(this);
    this._library_1 = library;
    this._symbol_2 = symbol;
    var tmp = this;
    var tmp_0 = Companion_getInstance_213();
    var tmp0_apply_0 = tmp_0.invoke$default_xzsnuq_k$('', 16.0, null, null, null, 28, null);
    tmp0_apply_0._fontsCatalog_1 = this._library_1._fontsCatalog;
    tmp0_apply_0._textBounds_0.copyFrom_uebyw0_k$(this._symbol_2._bounds_4);
    Unit_getInstance();
    tmp0_apply_0._set_html__a4enbm_k$(this._symbol_2._initialHtml);
    tmp0_apply_0.relayout_sv8swh_k$();
    tmp._textField = tmp0_apply_0;
    this.plusAssign_4l6ao4_k$(this._textField);
    this._format$delegate = format$factory(this._textField);
    this._text$delegate = text$factory(this._textField);
    this._html$delegate = html$factory(this._textField);
  }
  AnTextField.$metadata$ = {
    simpleName: 'AnTextField',
    kind: 'class',
    interfaces: [AnElement, IText, IHtml, ViewLeaf]
  };
  function updatedRatio($this) {
    var tmp = $this._morphSymbol._texturesWithBitmap;
    var tmp0__get_seconds__0 = $this._ratio_1;
    var result = tmp.find_2ntwu5_k$(Companion_getInstance_92().fromSeconds_ttklb2_k$(tmp0__get_seconds__0), $this._timedResult);
    var tmp_0 = $this;
    var tmp0_elvis_lhs = result._left_5;
    tmp_0._texWBS = tmp0_elvis_lhs == null ? result._right_1 : tmp0_elvis_lhs;
    var tmp_1 = $this;
    var tmp1_safe_receiver = $this._texWBS;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._bounds_11;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._x_2;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver;
    tmp_1._dx_1 = tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs;
    var tmp_2 = $this;
    var tmp5_safe_receiver = $this._texWBS;
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver._bounds_11;
    var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver._y_2;
    var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver;
    tmp_2._dy_1 = tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs;
    var tmp_3 = $this;
    var tmp9_safe_receiver = $this._texWBS;
    var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : tmp9_safe_receiver._texture_4;
    var tmp_4;
    if (tmp10_elvis_lhs == null) {
      var tmp1__get_transparent__0 = Bitmaps_getInstance();
      tmp_4 = Bitmaps_transparent;
    } else {
      tmp_4 = tmp10_elvis_lhs;
    }
    tmp_3._tex_1 = tmp_4;
    var tmp_5 = $this;
    var tmp11_safe_receiver = $this._texWBS;
    var tmp12_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver._scale_2;
    tmp_5._texScale_0 = tmp12_elvis_lhs == null ? 1.0 : tmp12_elvis_lhs;
    $this._texWidth_0 = $this._tex_1._get_width__0_k$() / $this._texScale_0;
    $this._texHeight_0 = $this._tex_1._get_height__0_k$() / $this._texScale_0;
    $this._smoothing_1 = true;
  }
  function AnMorphShape(library, morphSymbol) {
    AnBaseShape.call(this, library, morphSymbol);
    this._morphSymbol = morphSymbol;
    var tmp = this;
    tmp._timedResult = Result_init_$Create$(0, null, null, 0.0, 15, null);
    this._texWBS = null;
    this._dx_1 = 0.0;
    this._dy_1 = 0.0;
    var tmp_0 = this;
    var tmp0__get_transparent__0 = Bitmaps_getInstance();
    tmp_0._tex_1 = Bitmaps_transparent;
    this._texScale_0 = 1.0;
    this._texWidth_0 = 0.0;
    this._texHeight_0 = 0.0;
    this._smoothing_1 = true;
    this._ratio_1 = 0.0;
    updatedRatio(this);
  }
  AnMorphShape.prototype._get_dx__0_k$ = function () {
    return this._dx_1;
  };
  AnMorphShape.prototype._get_dy__0_k$ = function () {
    return this._dy_1;
  };
  AnMorphShape.prototype._get_tex__0_k$ = function () {
    return this._tex_1;
  };
  AnMorphShape.prototype._get_texWidth__0_k$ = function () {
    return this._texWidth_0;
  };
  AnMorphShape.prototype._get_texHeight__0_k$ = function () {
    return this._texHeight_0;
  };
  AnMorphShape.prototype._get_smoothing__0_k$ = function () {
    return this._smoothing_1;
  };
  AnMorphShape.prototype._set_ratio__okcceq_k$ = function (value) {
    this._ratio_1 = value;
    updatedRatio(this);
  };
  AnMorphShape.prototype._get_ratio__0_k$ = function () {
    return this._ratio_1;
  };
  AnMorphShape.$metadata$ = {
    simpleName: 'AnMorphShape',
    kind: 'class',
    interfaces: [AnElement]
  };
  function AnBaseShape(library, symbol) {
    View_init_$Init$(this);
    this._library_2 = library;
    this._symbol_3 = symbol;
    this._ninePatch = null;
    var tmp = this;
    var tmp0_arrayOf_0 = [new Point(0.0, 0.0), new Point(0.25, 0.25), new Point(0.75, 0.75), new Point(1.0, 1.0)];
    tmp._posCuts = tmp0_arrayOf_0;
    var tmp_0 = this;
    var tmp0_arrayOf_0_0 = [new Point(0.0, 0.0), new Point(0.25, 0.25), new Point(0.75, 0.75), new Point(1.0, 1.0)];
    tmp_0._texCuts = tmp0_arrayOf_0_0;
    this._hitShape = null;
  }
  AnBaseShape.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (!this._get_visible__0_k$())
      return Unit_getInstance();
    var tmp1_use_0 = ctx._batch_0;
    var tmp0_useBatcher_0 = tmp1_use_0._ctx_6;
    if (!(tmp0_useBatcher_0._currentBatcher === tmp1_use_0)) {
      tmp0_useBatcher_0.flush_sv8swh_k$();
      tmp0_useBatcher_0._currentBatcher = tmp1_use_0;
    }if (!(this._ninePatch == null)) {
      var np_2 = ensureNotNull(this._ninePatch);
      var lm_3 = ensureNotNull(this._get_parent__0_k$())._get_localMatrix__0_k$();
      var npLeft_4 = np_2._get_left__0_k$() - this._get_dx__0_k$();
      var npTop_5 = np_2._get_top__0_k$() - this._get_dy__0_k$();
      var npRight_6 = np_2._get_right__0_k$() - this._get_dx__0_k$();
      var npBottom_7 = np_2._get_bottom__0_k$() - this._get_dy__0_k$();
      var ascaleX_8 = lm_3._a;
      var ascaleY_9 = lm_3._d;
      this._posCuts[1].setTo_ngl742_k$(npLeft_4 / this._get_texWidth__0_k$() / ascaleX_8, npTop_5 / this._get_texHeight__0_k$() / ascaleY_9);
      Unit_getInstance();
      this._posCuts[2].setTo_ngl742_k$(1.0 - (this._get_texWidth__0_k$() - npRight_6) / this._get_texWidth__0_k$() / ascaleX_8, 1.0 - (this._get_texHeight__0_k$() - npBottom_7) / this._get_texHeight__0_k$() / ascaleY_9);
      Unit_getInstance();
      this._texCuts[1].setTo_ngl742_k$(npLeft_4 / this._get_texWidth__0_k$(), npTop_5 / this._get_texHeight__0_k$());
      Unit_getInstance();
      this._texCuts[2].setTo_ngl742_k$(npRight_6 / this._get_texWidth__0_k$(), npBottom_7 / this._get_texWidth__0_k$());
      Unit_getInstance();
      var tmp = ctx.getTex_uoiv7r_k$(this._get_tex__0_k$());
      var tmp_0 = this._get_dx__0_k$();
      var tmp_1 = this._get_dy__0_k$();
      var tmp_2 = this._get_texWidth__0_k$();
      var tmp_3 = this._get_texHeight__0_k$();
      var tmp_4 = this._get_globalMatrix__0_k$();
      var tmp_5 = this._get_smoothing__0_k$();
      var tmp_6 = this._get_renderColorMul__12t64v_k$();
      var tmp_7 = this._get_renderColorAdd__7hz20p_k$();
      var tmp_8 = this._get_renderBlendMode__0_k$()._factors;
      tmp1_use_0.drawNinePatch$default_9hr72k_k$(tmp, tmp_0, tmp_1, tmp_2, tmp_3, this._posCuts, this._texCuts, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, null, 4096, null);
    } else {
      var tmp_9 = ctx.getTex_uoiv7r_k$(this._get_tex__0_k$());
      var tmp_10 = this._get_dx__0_k$();
      var tmp_11 = this._get_dy__0_k$();
      var tmp_12 = this._get_texWidth__0_k$();
      var tmp_13 = this._get_texHeight__0_k$();
      var tmp_14 = this._get_globalMatrix__0_k$();
      var tmp_15 = this._get_smoothing__0_k$();
      var tmp_16 = this._get_renderColorMul__12t64v_k$();
      var tmp_17 = this._get_renderColorAdd__7hz20p_k$();
      var tmp_18 = this._get_renderBlendMode__0_k$()._factors;
      tmp1_use_0.drawQuad$default_r2v3rq_k$(tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, null, 1024, null);
    }
  };
  AnBaseShape.prototype._set_hitShape__mda8oa_k$ = function (value) {
    this._hitShape = value;
  };
  AnBaseShape.prototype._get_hitShape__0_k$ = function () {
    var tmp0_elvis_lhs = this._hitShape;
    return tmp0_elvis_lhs == null ? this._symbol_3._path_29 : tmp0_elvis_lhs;
  };
  AnBaseShape.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    out.setTo_bha9a8_k$(this._get_dx__0_k$(), this._get_dy__0_k$(), this._get_texWidth__0_k$(), this._get_texHeight__0_k$());
    Unit_getInstance();
  };
  AnBaseShape.prototype.toString = function () {
    return View.prototype.toString.call(this) + ':symbol=' + this._symbol_3;
  };
  AnBaseShape.$metadata$ = {
    simpleName: 'AnBaseShape',
    kind: 'class',
    interfaces: [AnElement]
  };
  function AnPlayable() {
  }
  AnPlayable.$metadata$ = {
    simpleName: 'AnPlayable',
    kind: 'interface',
    interfaces: []
  };
  function eval_0($this, prev, current) {
    if (TimeSpan__compareTo_impl(prev, current) >= 0)
      return Unit_getInstance();
    var tmp0_safe_receiver = $this._currentSubtimeline;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._actions_0;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var actionsTimeline = tmp;
    var result = actionsTimeline.getRangeIndices_nlo4uw_k$(prev, TimeSpan__minus_impl(current, Companion_getInstance_92().fromMicroseconds_ttklb2_k$(1.0)), $this._tempRangeResult);
    var inductionVariable = result._startIndex_0;
    var last_1 = result._endIndex;
    if (inductionVariable <= last_1)
      execution: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var action = actionsTimeline._objects.get_ha5a7z_k$(n);
        var tmp3_subject = action;
        if (tmp3_subject instanceof AnPlaySoundAction) {
          var tmp_0 = $this._get_library__0_k$()._context_10._coroutineContext_4;
          launchImmediately(tmp_0, _no_name_provided_$factory_374($this, action, null));
          Unit_getInstance();
        } else {
          if (tmp3_subject instanceof AnEventAction) {
            $this._onEvent.invoke_iav7o_k$(action._event);
          } else {
          }
        }
      }
       while (!(n === last_1));
  }
  function _no_name_provided__433(this$0, $action, resultContinuation) {
    this._this$0_124 = this$0;
    this._$action = $action;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__433.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__433.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__433.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            var tmp_0 = this;
            var tmp_1 = this._this$0_124._get_library__0_k$()._symbolsById.get_ha5a7z_k$(this._$action._soundId);
            tmp_0._tmp0_safe_receiver0_6 = tmp_1 instanceof AnSymbolSound ? tmp_1 : THROW_CCE();
            if (this._tmp0_safe_receiver0_6 == null) {
              this._WHEN_RESULT1_14 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0_6.getNativeSound_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1_14 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._tmp1_safe_receiver2 = this._WHEN_RESULT1_14;
            if (this._tmp1_safe_receiver2 == null) {
              this._WHEN_RESULT3_3 = null;
              this._state_1 = 4;
              continue $sm;
            } else {
              this._state_1 = 3;
              suspendResult = this._tmp1_safe_receiver2.play$default_58nnw6_k$(null, 1, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            Unit_getInstance();
            break;
          case 3:
            this._WHEN_RESULT3_3 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            Unit_getInstance();
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__433.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__433(this._this$0_124, this._$action, completion);
    return i;
  };
  _no_name_provided__433.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function TimelineRunner(view, symbol) {
    this._view_0 = view;
    this._symbol_4 = symbol;
    var tmp = this;
    tmp._currentTime_0 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    this._currentStateName = null;
    this._currentSubtimeline = null;
    var tmp_0 = this;
    tmp_0._onStop = Signal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._onChangeState = Signal_init_$Create$(null, 1, null);
    var tmp_2 = this;
    tmp_2._onEvent = Signal_init_$Create$(null, 1, null);
    this._running_1 = true;
    this.gotoAndPlay$default_era0fr_k$('default', null, 2, null);
    var tmp_3 = this;
    tmp_3._tempRangeResult = RangeResult_init_$Create$(0, 0, 3, null);
  }
  TimelineRunner.prototype._get_library__0_k$ = function () {
    return this._view_0._library;
  };
  TimelineRunner.prototype._get_currentStateTotalTime__nsqrdp_k$ = function () {
    var tmp;
    if (!(this._currentSubtimeline == null)) {
      tmp = ensureNotNull(this._currentSubtimeline)._totalTime_0;
    } else {
      tmp = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    }
    return tmp;
  };
  TimelineRunner.prototype._set_running__rpwsgn_k$ = function (value) {
    this._running_1 = value;
    if (!value) {
      this._onStop.invoke_iav7o_k$(Unit_getInstance());
    }};
  TimelineRunner.prototype.gotoAndRunning_8dp7qq_k$ = function (running, name, time) {
    var substate = this._symbol_4._states.get_2bw_k$(name);
    if (!(substate == null)) {
      this._currentStateName = substate._name_33;
      this._currentSubtimeline = substate._subTimeline;
      this._currentTime_0 = TimeSpan__plus_impl(substate._startTime_1, time);
      this._set_running__rpwsgn_k$(running);
      this.update_zah5t7_k$(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0));
      this._onChangeState.invoke_iav7o_k$(name);
    } else {
      println('' + "Can't find state with name '" + name + "' : " + this._symbol_4._states._get_keys__0_k$());
    }
  };
  TimelineRunner.prototype.gotoAndPlay_mqbjv8_k$ = function (name, time) {
    return this.gotoAndRunning_8dp7qq_k$(true, name, time);
  };
  TimelineRunner.prototype.gotoAndPlay$default_era0fr_k$ = function (name, time, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      time = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    }return this.gotoAndPlay_mqbjv8_k$(name, time);
  };
  TimelineRunner.prototype._set_ratio__okcceq_k$ = function (value) {
    this._currentTime_0 = TimeSpan__times_impl_0(this._get_currentStateTotalTime__nsqrdp_k$(), clamp01(value));
  };
  TimelineRunner.prototype._get_ratio__0_k$ = function () {
    return TimeSpan__div_impl_0(this._currentTime_0, this._get_currentStateTotalTime__nsqrdp_k$());
  };
  TimelineRunner.prototype.update_zah5t7_k$ = function (time) {
    if (!this._running_1)
      return Unit_getInstance();
    if (this._currentSubtimeline == null)
      return Unit_getInstance();
    var cs = ensureNotNull(this._currentSubtimeline);
    eval_0(this, this._currentTime_0, min(this._get_currentStateTotalTime__nsqrdp_k$(), TimeSpan__plus_impl(this._currentTime_0, time)));
    var tmp0_this = this;
    tmp0_this._currentTime_0 = TimeSpan__plus_impl(tmp0_this._currentTime_0, time);
    if (TimeSpan__compareTo_impl(this._currentTime_0, this._get_currentStateTotalTime__nsqrdp_k$()) >= 0) {
      var accumulatedTime = TimeSpan__minus_impl(this._currentTime_0, this._get_currentStateTotalTime__nsqrdp_k$());
      var nextState = cs._nextState_1;
      if (nextState == null) {
        this._set_running__rpwsgn_k$(false);
      } else {
        var tmp = cs._nextStatePlay;
        this.gotoAndRunning_8dp7qq_k$(tmp, nextState, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0));
        var tmp1_this = this;
        tmp1_this._currentTime_0 = TimeSpan__plus_impl(tmp1_this._currentTime_0, accumulatedTime);
        eval_0(this, TimeSpan__minus_impl(this._currentTime_0, accumulatedTime), this._currentTime_0);
      }
    }};
  TimelineRunner.$metadata$ = {
    simpleName: 'TimelineRunner',
    kind: 'class',
    interfaces: []
  };
  function format$factory($b0) {
    return getPropertyCallableRef('format', 0, KMutableProperty0, function () {
      return $b0._get_format__0_k$();
    }, function (value) {
      return $b0._set_format__931uz4_k$(value);
    });
  }
  function text$factory($b0) {
    return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
      return $b0._get_text__0_k$();
    }, function (value) {
      return $b0._set_text__a4enbm_k$(value);
    });
  }
  function html$factory($b0) {
    return getPropertyCallableRef('html', 0, KMutableProperty0, function () {
      return $b0._get_html__0_k$();
    }, function (value) {
      return $b0._set_html__a4enbm_k$(value);
    });
  }
  function _no_name_provided_$factory_373() {
    var i = new _no_name_provided__432();
    return function (p1, p2) {
      i.invoke_739q7y_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_374(this$0, $action, resultContinuation) {
    var i = new _no_name_provided__433(this$0, $action, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _get_animateLibraryLoaders_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = animateLibraryLoaders$factory();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = animateLibraryLoaders$delegate._name_0;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = animateLibraryLoaders$delegate._defaultGen();
        var tmp0_elvis_lhs_1_7 = animateLibraryLoaders$delegate._name_0;
        var tmp_0 = tmp0_elvis_lhs_1_7 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_1_7;
        setExtra(_this_, tmp_0, r_6);
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var animateLibraryLoaders$delegate;
  function Companion_194() {
    Companion_instance_193 = this;
  }
  Companion_194.prototype.invoke_sdzoaq_k$ = function (views_0) {
    return new Context_0(views_0._coroutineContext_6, views_0._imageFormats_3);
  };
  Companion_194.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_193;
  function Companion_getInstance_193() {
    if (Companion_instance_193 == null)
      new Companion_194();
    return Companion_instance_193;
  }
  function Context_0(coroutineContext, imageFormats) {
    Companion_getInstance_193();
    this._coroutineContext_4 = coroutineContext;
    this._imageFormats_1 = imageFormats;
  }
  Context_0.prototype.copy_qwvoju_k$ = function (coroutineContext, imageFormats) {
    return new Context_0(coroutineContext, imageFormats);
  };
  Context_0.prototype.copy$default_kj2jzo_k$ = function (coroutineContext, imageFormats, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      coroutineContext = this._coroutineContext_4;
    if (!(($mask0 & 2) === 0))
      imageFormats = this._imageFormats_1;
    return this.copy_qwvoju_k$(coroutineContext, imageFormats);
  };
  Context_0.prototype.toString = function () {
    return '' + 'Context(coroutineContext=' + this._coroutineContext_4 + ', imageFormats=' + this._imageFormats_1 + ')';
  };
  Context_0.prototype.hashCode = function () {
    var result = hashCode(this._coroutineContext_4);
    result = imul(result, 31) + hashCode(this._imageFormats_1) | 0;
    return result;
  };
  Context_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Context_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Context_0 ? other : THROW_CCE();
    if (!equals_1(this._coroutineContext_4, tmp0_other_with_cast._coroutineContext_4))
      return false;
    if (!equals_1(this._imageFormats_1, tmp0_other_with_cast._imageFormats_1))
      return false;
    return true;
  };
  Context_0.$metadata$ = {
    simpleName: 'Context',
    kind: 'class',
    interfaces: []
  };
  function AnLibrary(context, width, height, fps) {
    this._context_10 = context;
    this._width_19 = width;
    this._height_20 = height;
    this._fps = fps;
    var tmp = this;
    tmp._$$delegate_0_30 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._fontsCatalog = FontsCatalog_init_$Create$(null, null, 2, null);
    this._msPerFrameDouble = 1000 / this._fps;
    this._msPerFrame = numberToInt(this._msPerFrameDouble);
    this._bgcolor_2 = Colors_getInstance()._WHITE_0;
    var tmp_1 = this;
    tmp_1._symbolsById = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2._symbolsByName = HashMap_init_$Create$();
    this._defaultSmoothing = true;
  }
  AnLibrary.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_30._set_extra__n1onou_k$(_set___);
  };
  AnLibrary.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_30._get_extra__0_k$();
  };
  AnLibrary.prototype.addSymbol_9dv086_k$ = function (symbol) {
    while (this._symbolsById._get_size__0_k$() <= symbol._id_26) {
      var tmp0_this = this;
      var tmp0_plusAssign_0 = tmp0_this._symbolsById;
      var tmp1_plusAssign_0 = AnSymbolEmpty_getInstance();
      tmp0_plusAssign_0.add_2bq_k$(tmp1_plusAssign_0);
      Unit_getInstance();
    }
    if (symbol._id_26 >= 0) {
      this._symbolsById.set_ddb1qf_k$(symbol._id_26, symbol);
      Unit_getInstance();
    }};
  AnLibrary.prototype.processSymbolNames_sv8swh_k$ = function () {
    var tmp0_fastForEach_0 = this._symbolsById;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      if (!(tmp1__anonymous__3._name_32 == null)) {
        var tmp0_set_0_4 = this._symbolsByName;
        var tmp1_set_0_5 = ensureNotNull(tmp1__anonymous__3._name_32);
        tmp0_set_0_4.put_1q9pf_k$(tmp1_set_0_5, tmp1__anonymous__3);
        Unit_getInstance();
      }}
  };
  AnLibrary.prototype.create_ha5a7z_k$ = function (id) {
    var tmp;
    if (id < 0) {
      var tmp0_TODO_0 = '' + 'id=' + id;
      throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
    } else {
      var tmp1_getOrElse_0 = this._symbolsById;
      var tmp_0;
      if (id >= 0 ? id <= _get_lastIndex__4(tmp1_getOrElse_0) : false) {
        tmp_0 = tmp1_getOrElse_0.get_ha5a7z_k$(id);
      } else {
        tmp_0 = AnSymbolEmpty_getInstance();
      }
      tmp = tmp_0.create_b7ttu0_k$(this);
    }
    return tmp;
  };
  AnLibrary.prototype.createMovieClip_ha5a7z_k$ = function (id) {
    var tmp = this.create_ha5a7z_k$(id);
    return tmp instanceof AnMovieClip ? tmp : THROW_CCE();
  };
  AnLibrary.prototype.createMainTimeLine_0_k$ = function () {
    return this.createMovieClip_ha5a7z_k$(0);
  };
  AnLibrary.$metadata$ = {
    simpleName: 'AnLibrary',
    kind: 'class',
    interfaces: [Extra]
  };
  function AnSymbol(id, name) {
    this._id_26 = id;
    this._name_32 = name;
    var tmp = this;
    tmp._$$delegate_0_31 = Mixin_init_$Create$(null, 1, null);
  }
  AnSymbol.prototype._get_id__0_k$ = function () {
    return this._id_26;
  };
  AnSymbol.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_31._set_extra__n1onou_k$(_set___);
  };
  AnSymbol.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_31._get_extra__0_k$();
  };
  AnSymbol.prototype.create_b7ttu0_k$ = function (library) {
    return AnEmptyView_init_$Create$(library, null, 2, null);
  };
  AnSymbol.prototype.toString = function () {
    return '' + 'Symbol(id=' + this._id_26 + ', name=' + this._name_32 + ')';
  };
  AnSymbol.$metadata$ = {
    simpleName: 'AnSymbol',
    kind: 'class',
    interfaces: [Extra]
  };
  function AnSymbolEmpty() {
    AnSymbolEmpty_instance = this;
    AnSymbol.call(this, -1, '');
  }
  AnSymbolEmpty.$metadata$ = {
    simpleName: 'AnSymbolEmpty',
    kind: 'object',
    interfaces: []
  };
  var AnSymbolEmpty_instance;
  function AnSymbolEmpty_getInstance() {
    if (AnSymbolEmpty_instance == null)
      new AnSymbolEmpty();
    return AnSymbolEmpty_instance;
  }
  function _no_name_provided__434(this$0, resultContinuation) {
    this._this$0_125 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__434.prototype.invoke_0_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__434.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            if (this._this$0_125._inputSound == null) {
              this._exceptionState = 2;
              this._state_1 = 1;
              var tmp_0 = _get_nativeSoundProvider_();
              var tmp0_elvis_lhs = this._this$0_125._dataBytes;
              var tmp_1;
              if (tmp0_elvis_lhs == null) {
                tmp_1 = new Int8Array([]);
              } else {
                tmp_1 = tmp0_elvis_lhs;
              }
              var tmp_2 = tmp_1;
              suspendResult = tmp_0.createSound$default_gavy51_k$(tmp_2, false, null, null, 14, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 1:
            this._TRY_RESULT0_5 = suspendResult;
            this._exceptionState = 6;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 6;
            var tmp_3 = this._exception_0;
            if (tmp_3 instanceof Error) {
              this._e1_1 = this._exception_0;
              this._state_1 = 3;
              var tmp_4 = _get_nativeSoundProvider_();
              var tmp_5 = Companion_getInstance_187()._get_DUMMY__0_k$();
              suspendResult = tmp_4.createSound$default_3mmvnr_k$(tmp_5, null, false, null, 14, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            this._TRY_RESULT0_5 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            this._exceptionState = 6;
            var ARGUMENT = this._TRY_RESULT0_5;
            this._this$0_125._inputSound = ARGUMENT;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return ensureNotNull(this._this$0_125._inputSound);
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__434.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__434(this._this$0_125, completion);
    return i;
  };
  _no_name_provided__434.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function AnSymbolSound(id, name, inputSound, dataBytes) {
    AnSymbol.call(this, id, name);
    this._inputSound = inputSound;
    this._dataBytes = dataBytes;
    this._nativeSoundCache = new AsyncOnce();
  }
  AnSymbolSound.prototype.getNativeSound_0_k$ = function ($cont) {
    return this._nativeSoundCache.invoke_juk2pn_k$(_no_name_provided_$factory_376(this, null), $cont);
  };
  AnSymbolSound.$metadata$ = {
    simpleName: 'AnSymbolSound',
    kind: 'class',
    interfaces: []
  };
  function AnTextFieldSymbol(id, name, initialHtml, bounds_0) {
    AnSymbol.call(this, id, name);
    this._initialHtml = initialHtml;
    this._bounds_4 = bounds_0;
  }
  AnTextFieldSymbol.prototype.create_b7ttu0_k$ = function (library) {
    return new AnTextField(library, this);
  };
  AnTextFieldSymbol.$metadata$ = {
    simpleName: 'AnTextFieldSymbol',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolShape(id, name, bounds_0, textureWithBitmap, path_0) {
    AnSymbolBaseShape.call(this, id, name, bounds_0, path_0);
    this._textureWithBitmap = textureWithBitmap;
  }
  AnSymbolShape.prototype.create_b7ttu0_k$ = function (library) {
    return new AnShape(library, this);
  };
  AnSymbolShape.$metadata$ = {
    simpleName: 'AnSymbolShape',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolMorphShape(id, name, bounds_0, texturesWithBitmap, path_0) {
    AnSymbolBaseShape.call(this, id, name, bounds_0, path_0);
    this._texturesWithBitmap = texturesWithBitmap;
  }
  AnSymbolMorphShape.prototype.create_b7ttu0_k$ = function (library) {
    return new AnMorphShape(library, this);
  };
  AnSymbolMorphShape.$metadata$ = {
    simpleName: 'AnSymbolMorphShape',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolBitmap(id, name, bmp) {
    AnSymbol.call(this, id, name);
    this._bmp_3 = bmp;
  }
  AnSymbolBitmap.$metadata$ = {
    simpleName: 'AnSymbolBitmap',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolMovieClip(id, name, limits) {
    AnSymbol.call(this, id, name);
    this._limits = limits;
    this._ninePatch_0 = null;
    var tmp = this;
    tmp._states = HashMap_init_$Create$();
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this._limits._totalUids_0;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = new AnSymbolUidDef(-1, HashMap_init_$Create$());
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._uidInfo = tmp_3;
  }
  AnSymbolMovieClip.prototype.create_b7ttu0_k$ = function (library) {
    return new AnMovieClip(library, this);
  };
  AnSymbolMovieClip.$metadata$ = {
    simpleName: 'AnSymbolMovieClip',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolUidDef(characterId, extraProps) {
    this._characterId = characterId;
    this._extraProps = extraProps;
  }
  AnSymbolUidDef.$metadata$ = {
    simpleName: 'AnSymbolUidDef',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolBaseShape(id, name, bounds_0, path_0) {
    AnSymbol.call(this, id, name);
    this._bounds_5 = bounds_0;
    this._path_29 = path_0;
  }
  AnSymbolBaseShape.prototype._get_bounds__0_k$ = function () {
    return this._bounds_5;
  };
  AnSymbolBaseShape.$metadata$ = {
    simpleName: 'AnSymbolBaseShape',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolLimits(totalDepths, totalFrames, totalUids, totalTime) {
    this._totalDepths_0 = totalDepths;
    this._totalFrames = totalFrames;
    this._totalUids_0 = totalUids;
    this._totalTime = totalTime;
  }
  AnSymbolLimits.$metadata$ = {
    simpleName: 'AnSymbolLimits',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolMovieClipState(name, subTimeline, startTime) {
    this._name_33 = name;
    this._subTimeline = subTimeline;
    this._startTime_1 = startTime;
  }
  AnSymbolMovieClipState.$metadata$ = {
    simpleName: 'AnSymbolMovieClipState',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolMovieClipSubTimeline(totalDepths) {
    var tmp = this;
    tmp._totalTime_0 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = totalDepths;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = new AnDepthTimeline(tmp_4);
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._timelines = tmp_3;
    var tmp_5 = this;
    tmp_5._actions_0 = Timed_init_$Create$(0, 1, null);
    this._nextState_1 = null;
    this._nextStatePlay = false;
  }
  AnSymbolMovieClipSubTimeline.$metadata$ = {
    simpleName: 'AnSymbolMovieClipSubTimeline',
    kind: 'class',
    interfaces: []
  };
  function AnDepthTimeline(depth) {
    Timed_init_$Init$(0, 1, null, this);
    this._depth_0 = depth;
  }
  AnDepthTimeline.$metadata$ = {
    simpleName: 'AnDepthTimeline',
    kind: 'class',
    interfaces: []
  };
  function AnAction() {
  }
  AnAction.$metadata$ = {
    simpleName: 'AnAction',
    kind: 'interface',
    interfaces: []
  };
  function Companion_195() {
    Companion_instance_194 = this;
  }
  Companion_195.prototype.setToViewInterpolated_4zwj8j_k$ = function (view, l, r, ratio) {
    view.setMatrixInterpolated_zhpt3m_k$(ratio, l._transform_10, r._transform_10);
    view._set_colorTransform__yu9zyi_k$(view._get_colorTransform__0_k$().setToInterpolated_a01zgt_k$(ratio, l._colorTransform, r._colorTransform));
    view._set_ratio__okcceq_k$(interpolate(ratio, l._ratio_2, r._ratio_2));
    view._name_43 = l._name_34;
    view._set_blendMode__9dm7zh_k$(l._blendMode);
  };
  Companion_195.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_194;
  function Companion_getInstance_194() {
    if (Companion_instance_194 == null)
      new Companion_195();
    return Companion_instance_194;
  }
  function AnSymbolTimelineFrame(depth, uid, clipDepth, ratio, transform, name, colorTransform, blendMode) {
    Companion_getInstance_194();
    this._depth_1 = depth;
    this._uid = uid;
    this._clipDepth = clipDepth;
    this._ratio_2 = ratio;
    this._transform_10 = transform;
    this._name_34 = name;
    this._colorTransform = colorTransform;
    this._blendMode = blendMode;
  }
  AnSymbolTimelineFrame.prototype.setToView_4l6ao4_k$ = function (view) {
    view._set_ratio__okcceq_k$(this._ratio_2);
    view.setMatrix_skjkkf_k$(this._transform_10);
    view._name_43 = this._name_34;
    view._set_colorTransform__yu9zyi_k$(this._colorTransform);
    view._set_blendMode__9dm7zh_k$(this._blendMode);
  };
  AnSymbolTimelineFrame.prototype.toString = function () {
    return '' + 'AnSymbolTimelineFrame(depth=' + this._depth_1 + ', uid=' + this._uid + ', clipDepth=' + this._clipDepth + ', ratio=' + this._ratio_2 + ', transform=' + this._transform_10 + ', name=' + this._name_34 + ', colorTransform=' + this._colorTransform + ', blendMode=' + this._blendMode + ')';
  };
  AnSymbolTimelineFrame.prototype.hashCode = function () {
    var result = this._depth_1;
    result = imul(result, 31) + this._uid | 0;
    result = imul(result, 31) + this._clipDepth | 0;
    result = imul(result, 31) + getNumberHashCode(this._ratio_2) | 0;
    result = imul(result, 31) + this._transform_10.hashCode() | 0;
    result = imul(result, 31) + (this._name_34 == null ? 0 : getStringHashCode(this._name_34)) | 0;
    result = imul(result, 31) + this._colorTransform.hashCode() | 0;
    result = imul(result, 31) + this._blendMode.hashCode() | 0;
    return result;
  };
  AnSymbolTimelineFrame.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnSymbolTimelineFrame))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AnSymbolTimelineFrame ? other : THROW_CCE();
    if (!(this._depth_1 === tmp0_other_with_cast._depth_1))
      return false;
    if (!(this._uid === tmp0_other_with_cast._uid))
      return false;
    if (!(this._clipDepth === tmp0_other_with_cast._clipDepth))
      return false;
    if (!equals_1(this._ratio_2, tmp0_other_with_cast._ratio_2))
      return false;
    if (!this._transform_10.equals(tmp0_other_with_cast._transform_10))
      return false;
    if (!(this._name_34 == tmp0_other_with_cast._name_34))
      return false;
    if (!this._colorTransform.equals(tmp0_other_with_cast._colorTransform))
      return false;
    if (!this._blendMode.equals(tmp0_other_with_cast._blendMode))
      return false;
    return true;
  };
  AnSymbolTimelineFrame.$metadata$ = {
    simpleName: 'AnSymbolTimelineFrame',
    kind: 'class',
    interfaces: []
  };
  function AnPlaySoundAction(soundId) {
    this._soundId = soundId;
  }
  AnPlaySoundAction.prototype.toString = function () {
    return '' + 'AnPlaySoundAction(soundId=' + this._soundId + ')';
  };
  AnPlaySoundAction.prototype.hashCode = function () {
    return this._soundId;
  };
  AnPlaySoundAction.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnPlaySoundAction))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AnPlaySoundAction ? other : THROW_CCE();
    if (!(this._soundId === tmp0_other_with_cast._soundId))
      return false;
    return true;
  };
  AnPlaySoundAction.$metadata$ = {
    simpleName: 'AnPlaySoundAction',
    kind: 'class',
    interfaces: [AnAction]
  };
  function AnEventAction(event) {
    this._event = event;
  }
  AnEventAction.prototype.toString = function () {
    return '' + 'AnEventAction(event=' + this._event + ')';
  };
  AnEventAction.prototype.hashCode = function () {
    return getStringHashCode(this._event);
  };
  AnEventAction.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnEventAction))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AnEventAction ? other : THROW_CCE();
    if (!(this._event === tmp0_other_with_cast._event))
      return false;
    return true;
  };
  AnEventAction.$metadata$ = {
    simpleName: 'AnEventAction',
    kind: 'class',
    interfaces: [AnAction]
  };
  function _no_name_provided__435(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__435.prototype.invoke_ai27hu_k$ = function ($this$$receiver, content, views_0, $cont) {
    var tmp = this.create_1fnoca_k$($this$$receiver, content, views_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__435.prototype.invoke_ifn5k1_k$ = function (p1, p2, p3, $cont) {
    var tmp = p1 instanceof VfsFile ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof FastByteArrayInputStream ? p2 : THROW_CCE();
    return this.invoke_ai27hu_k$(tmp, tmp_0, p3 instanceof Views ? p3 : THROW_CCE(), $cont);
  };
  _no_name_provided__435.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readAni(this._$this$$receiver, Companion_getInstance_193().invoke_sdzoaq_k$(this._views_0), this._content_9, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__435.prototype.create_1fnoca_k$ = function ($this$$receiver, content, views_0, completion) {
    var i = new _no_name_provided__435(completion);
    i._$this$$receiver = $this$$receiver;
    i._content_9 = content;
    i._views_0 = views_0;
    return i;
  };
  _no_name_provided__435.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 3
  };
  function _no_name_provided__436(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__436.prototype.invoke_glb5i0_k$ = function (s, injector_0, $cont) {
    var tmp = this.create_ikin58_k$(s, injector_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__436.prototype.invoke_osx4an_k$ = function (p1, p2, $cont) {
    var tmp = p1 instanceof FastByteArrayInputStream ? p1 : THROW_CCE();
    return this.invoke_glb5i0_k$(tmp, p2 instanceof AsyncInjector ? p2 : THROW_CCE(), $cont);
  };
  _no_name_provided__436.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          var tmp_0;
          var tmp_1 = this._s_9.readString$default_589s1r_k$(8, null, 2, null);
          AniFile_getInstance();
          if (tmp_1 === 'KORGEANI') {
            tmp_0 = new KorgeFileLoader('ani', _no_name_provided_$factory_378(null));
          } else {
            {
              tmp_0 = null;
            }
          }
          return tmp_0;
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__436.prototype.create_ikin58_k$ = function (s, injector_0, completion) {
    var i = new _no_name_provided__436(completion);
    i._s_9 = s;
    i._injector_4 = injector_0;
    return i;
  };
  _no_name_provided__436.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__437() {
  }
  _no_name_provided__437.prototype.invoke_0_k$ = function () {
    return arrayListOf([new KorgeFileLoaderTester('core/ani', _no_name_provided_$factory_377(null))]);
  };
  _no_name_provided__437.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function animateLibraryLoaders$factory() {
    return getPropertyCallableRef('animateLibraryLoaders', 1, KProperty1, function (receiver) {
      return _get_animateLibraryLoaders_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_375() {
    var i = new _no_name_provided__437();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_376(this$0, resultContinuation) {
    var i = new _no_name_provided__434(this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_0_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_377(resultContinuation) {
    var i = new _no_name_provided__436(resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_glb5i0_k$(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_378(resultContinuation) {
    var i = new _no_name_provided__435(resultContinuation);
    var l = function (p1, p2, p3, $cont) {
      return i.invoke_ai27hu_k$(p1, p2, p3, $cont);
    };
    l.$arity = 3;
    return l;
  }
  var NodeKind_Parallel_instance;
  var NodeKind_Sequence_instance;
  var NodeKind_entriesInitialized;
  function NodeKind_initEntries() {
    if (NodeKind_entriesInitialized)
      return Unit_getInstance();
    NodeKind_entriesInitialized = true;
    NodeKind_Parallel_instance = new NodeKind('Parallel', 0);
    NodeKind_Sequence_instance = new NodeKind('Sequence', 1);
  }
  function _no_name_provided__438(this$0) {
    this._this$0_126 = this$0;
  }
  _no_name_provided__438.prototype.invoke_0_k$ = function () {
    var tmp;
    if (!(this._this$0_126._lazyVs == null)) {
      var tmp_0 = 0;
      var tmp_1 = this._this$0_126._lazyVs.length;
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        tmp_2[tmp_3] = this._this$0_126._lazyVs[tmp_3]();
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_2;
    } else {
      tmp = this._this$0_126._vs;
    }
    return tmp;
  };
  _no_name_provided__438.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $executeCOROUTINE$8(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__177 = _this_;
  }
  $executeCOROUTINE$8.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.__this__177._lazyTime;
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              var tmp_2 = tmp0_safe_receiver();
              tmp_1 = tmp_2 == null ? null : tmp_2._milliseconds;
            }

            var tmp1_elvis_lhs = tmp_1;
            var tmp_3;
            var tmp_4 = tmp1_elvis_lhs;
            if ((tmp_4 == null ? null : new TimeSpan(tmp_4)) == null) {
              tmp_3 = this.__this__177._time_5;
            } else {
              {
                tmp_3 = tmp1_elvis_lhs;
              }
            }

            tmp_0._rtime0 = tmp_3;
            this._state_1 = 1;
            var tmp_5 = this.__this__177._get_computedVs__0_k$().slice();
            suspendResult = tween$default(this.__this__177._view_1, tmp_5, this._rtime0, this.__this__177._easing, null, false, null, 56, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_6 = this._exception_0;
            if (tmp_6 instanceof CancellationException) {
              var e = this._exception_0;
              if (this.__this__177._$this_27.completeOnCancel_vkkbx6_k$(e)) {
                this.__this__177.executeImmediately_sv8swh_k$();
              }throw e;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $executeCOROUTINE$8.$metadata$ = {
    simpleName: '$executeCOROUTINE$8',
    kind: 'class',
    interfaces: []
  };
  function Animator_init_$Init$(root, time, speed, easing, completeOnCancel, kind, looped, init, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      time = Companion_getInstance_195()._DEFAULT_TIME;
    if (!(($mask0 & 4) === 0))
      speed = Companion_getInstance_195()._DEFAULT_SPEED;
    if (!(($mask0 & 8) === 0))
      easing = Companion_getInstance_195()._DEFAULT_EASING;
    if (!(($mask0 & 16) === 0))
      completeOnCancel = Companion_getInstance_195()._DEFAULT_COMPLETE_ON_CANCEL;
    if (!(($mask0 & 32) === 0))
      kind = NodeKind_Sequence_getInstance();
    if (!(($mask0 & 64) === 0))
      looped = false;
    if (!(($mask0 & 128) === 0)) {
      init = _no_name_provided_$factory_379();
    }Animator.call($this, root, time, speed, easing, completeOnCancel, kind, looped, init);
    return $this;
  }
  function Animator_init_$Create$(root, time, speed, easing, completeOnCancel, kind, looped, init, $mask0, $marker) {
    return Animator_init_$Init$(root, time, speed, easing, completeOnCancel, kind, looped, init, $mask0, $marker, Object.create(Animator.prototype));
  }
  function Companion_196() {
    Companion_instance_195 = this;
    var tmp = this;
    tmp._DEFAULT_TIME = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(500.0);
    this._DEFAULT_SPEED = 128.0;
    this._DEFAULT_EASING = Companion_getInstance_57()._get_EASE_IN_OUT_QUAD__0_k$();
    this._DEFAULT_COMPLETE_ON_CANCEL = true;
  }
  Companion_196.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_195;
  function Companion_getInstance_195() {
    if (Companion_instance_195 == null)
      new Companion_196();
    return Companion_instance_195;
  }
  function NodeKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  NodeKind.$metadata$ = {
    simpleName: 'NodeKind',
    kind: 'class',
    interfaces: []
  };
  function TweenNode($outer, view, vs, lazyVs, time, lazyTime, easing) {
    this._$this_27 = $outer;
    this._view_1 = view;
    this._vs = vs;
    this._lazyVs = lazyVs;
    this._time_5 = time;
    this._lazyTime = lazyTime;
    this._easing = easing;
    var tmp = this;
    tmp._computedVs$delegate = lazy(_no_name_provided_$factory_381(this));
  }
  TweenNode.prototype._get_computedVs__0_k$ = function () {
    var tmp0_getValue_0 = computedVs$factory();
    return this._computedVs$delegate._get_value__0_k$();
  };
  TweenNode.prototype.execute_sv8swh_k$ = function ($cont) {
    var tmp = new $executeCOROUTINE$8(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  TweenNode.prototype.executeImmediately_sv8swh_k$ = function () {
    var tmp0_fastForEach_0 = this._get_computedVs__0_k$();
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0.length) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0[tmp0_2];
      tmp1__anonymous__3.set_okcceq_k$(1.0);
    }
    return Unit_getInstance();
  };
  TweenNode.$metadata$ = {
    simpleName: 'TweenNode',
    kind: 'class',
    interfaces: [BaseAnimatorNode]
  };
  function _no_name_provided__439() {
  }
  _no_name_provided__439.prototype.invoke_njrw7w_k$ = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__439.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_njrw7w_k$(p1 instanceof Animator ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__439.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__440() {
  }
  _no_name_provided__440.prototype.invoke_sv8swh_k$ = function () {
    return Unit_getInstance();
  };
  _no_name_provided__440.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__440.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__441($node_5, resultContinuation) {
    this._$node_5 = $node_5;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__441.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__441.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__441.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$node_5.execute_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__441.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__441(this._$node_5, completion);
    return i;
  };
  _no_name_provided__441.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__442($node_5, resultContinuation) {
    this._$node_5_0 = $node_5;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__442.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__442.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__442.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$node_5_0.execute_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__442.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__442(this._$node_5_0, completion);
    return i;
  };
  _no_name_provided__442.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function NodeKind_Parallel_getInstance() {
    NodeKind_initEntries();
    return NodeKind_Parallel_instance;
  }
  function NodeKind_Sequence_getInstance() {
    NodeKind_initEntries();
    return NodeKind_Sequence_instance;
  }
  function $executeCOROUTINE$6(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__178 = _this_;
  }
  $executeCOROUTINE$6.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 20;
            if (!this.__this__178._initialized_3) {
              this.__this__178._init(this.__this__178);
              this.__this__178._initialized_3 = true;
            }
            this._tmp0_subject0_1 = this.__this__178._kind_5;
            if (this._tmp0_subject0_1.equals(NodeKind_Sequence_getInstance())) {
              this._exceptionState = 17;
              if (this.__this__178._looped) {
                this._nodesCopy_11 = toList_3(this.__this__178._nodes);
                this._state_1 = 11;
                continue $sm;
              } else {
                this._state_1 = 8;
                continue $sm;
              }
            } else {
              if (this._tmp0_subject0_1.equals(NodeKind_Parallel_getInstance())) {
                this._exceptionState = 6;
                if (this.__this__178._looped) {
                  this._nodesCopy_12 = toList_3(this.__this__178._nodes);
                  this._state_1 = 2;
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  tmp_0._jobs_33 = ArrayList_init_$Create$();
                  $l$break: while (true) {
                    var tmp_1 = this;
                    tmp_1._tmp0_isNotEmpty_0_44 = this.__this__178._nodes;
                    if (!!this._tmp0_isNotEmpty_0_44.isEmpty_0_k$()) {
                      break $l$break;
                    }var node_5 = this.__this__178._nodes.removeFirst_0_k$();
                    var tmp_2 = this._get_context__0_k$();
                    var tmp1_plusAssign_0_6 = launchImmediately(tmp_2, _no_name_provided_$factory_382(node_5, null));
                    this._jobs_33.add_2bq_k$(tmp1_plusAssign_0_6);
                    Unit_getInstance();
                  }
                  this._state_1 = 1;
                  suspendResult = joinAll(this._jobs_33, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                }
              } else {
                this._state_1 = 19;
                continue $sm;
              }
            }

            break;
          case 1:
            this._state_1 = 5;
            continue $sm;
          case 2:
            if (false) {
              this._state_1 = 4;
              continue $sm;
            }
            var tmp_3 = this;
            tmp_3._jobs_35 = ArrayList_init_$Create$();
            $l$break_0: while (true) {
              var tmp_4 = this;
              tmp_4._tmp0_isNotEmpty_0_46 = this.__this__178._nodes;
              if (!!this._tmp0_isNotEmpty_0_46.isEmpty_0_k$()) {
                break $l$break_0;
              }var node_5_0 = this.__this__178._nodes.removeFirst_0_k$();
              var tmp_5 = this._get_context__0_k$();
              var tmp1_plusAssign_0_6_0 = launchImmediately(tmp_5, _no_name_provided_$factory_383(node_5_0, null));
              this._jobs_35.add_2bq_k$(tmp1_plusAssign_0_6_0);
              Unit_getInstance();
            }

            this._state_1 = 3;
            suspendResult = joinAll(this._jobs_35, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this.__this__178._nodes.addAll_1asxxx_k$(this._nodesCopy_12);
            Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 4:
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._exceptionState = 20;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._exceptionState = 20;
            var tmp_6 = this._exception_0;
            if (tmp_6 instanceof CancellationException) {
              this._e7_0 = this._exception_0;
              this.__this__178.__onCancel();
              if (this.__this__178.completeOnCancel_vkkbx6_k$(this._e7_0)) {
                $l$break_1: while (true) {
                  var tmp1_isNotEmpty_0 = this.__this__178._nodes;
                  if (!!tmp1_isNotEmpty_0.isEmpty_0_k$()) {
                    break $l$break_1;
                  }this.__this__178._nodes.removeFirst_0_k$().executeImmediately_sv8swh_k$();
                }
              }throw this._e7_0;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 7:
            this._exceptionState = 20;
            this._state_1 = 19;
            continue $sm;
          case 8:
            var tmp_7 = this;
            tmp_7._tmp0_isNotEmpty_0_38 = this.__this__178._nodes;
            if (!!this._tmp0_isNotEmpty_0_38.isEmpty_0_k$()) {
              this._state_1 = 10;
              continue $sm;
            } else {
            }

            this._node_49 = this.__this__178._nodes.removeFirst_0_k$();
            this._state_1 = 9;
            suspendResult = this._node_49.execute_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._state_1 = 8;
            continue $sm;
          case 10:
            this._state_1 = 16;
            continue $sm;
          case 11:
            if (false) {
              this._state_1 = 15;
              continue $sm;
            }
            this._state_1 = 12;
            continue $sm;
          case 12:
            var tmp_8 = this;
            tmp_8._tmp0_isNotEmpty_0_310 = this.__this__178._nodes;
            if (!!this._tmp0_isNotEmpty_0_310.isEmpty_0_k$()) {
              this._state_1 = 14;
              continue $sm;
            } else {
            }

            this._node_411 = this.__this__178._nodes.removeFirst_0_k$();
            this._state_1 = 13;
            suspendResult = this._node_411.execute_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 13:
            this._state_1 = 12;
            continue $sm;
          case 14:
            this.__this__178._nodes.addAll_1asxxx_k$(this._nodesCopy_11);
            Unit_getInstance();
            this._state_1 = 11;
            continue $sm;
          case 15:
            this._state_1 = 16;
            continue $sm;
          case 16:
            this._exceptionState = 20;
            this._state_1 = 18;
            continue $sm;
          case 17:
            this._exceptionState = 20;
            var tmp_9 = this._exception_0;
            if (tmp_9 instanceof CancellationException) {
              var e = this._exception_0;
              this.__this__178.__onCancel();
              if (this.__this__178.completeOnCancel_vkkbx6_k$(e)) {
                $l$break_2: while (true) {
                  var tmp0_isNotEmpty_0 = this.__this__178._nodes;
                  if (!!tmp0_isNotEmpty_0.isEmpty_0_k$()) {
                    break $l$break_2;
                  }this.__this__178._nodes.removeFirst_0_k$().executeImmediately_sv8swh_k$();
                }
              }throw e;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 18:
            this._exceptionState = 20;
            this._state_1 = 19;
            continue $sm;
          case 19:
            return Unit_getInstance();
          case 20:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 20) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $executeCOROUTINE$6.$metadata$ = {
    simpleName: '$executeCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function Animator(root, time, speed, easing, completeOnCancel, kind, looped, init) {
    Companion_getInstance_195();
    this._root_3 = root;
    this._time_6 = time;
    this._speed = speed;
    this._easing_0 = easing;
    this._completeOnCancel = completeOnCancel;
    this._kind_5 = kind;
    this._looped = looped;
    this._init = init;
    this._initialized_3 = false;
    var tmp = this;
    tmp.__onCancel = _no_name_provided_$factory_380();
    this._nodes = TGenDeque_init_$Create$();
  }
  Animator.prototype.execute_sv8swh_k$ = function ($cont) {
    var tmp = new $executeCOROUTINE$6(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Animator.prototype.completeOnCancel_vkkbx6_k$ = function (e) {
    if (e instanceof AnimateCancellationException) {
      var tmp0_elvis_lhs = e._completeOnCancel_0;
      return tmp0_elvis_lhs == null ? this._completeOnCancel : tmp0_elvis_lhs;
    } else {
    }
    return this._completeOnCancel;
  };
  Animator.prototype.executeImmediately_sv8swh_k$ = function () {
    if (!this._initialized_3) {
      this._init(this);
      this._initialized_3 = true;
    }$l$break: while (true) {
      var tmp0_isNotEmpty_0 = this._nodes;
      if (!!tmp0_isNotEmpty_0.isEmpty_0_k$()) {
        break $l$break;
      }this._nodes.removeFirst_0_k$().executeImmediately_sv8swh_k$();
    }
  };
  Animator.prototype.__tween_8qsp2n_k$ = function (vs, lazyVs, time, lazyTime, easing) {
    this._nodes.add_1hrmez_k$(new TweenNode(this, this._root_3, vs.slice(), lazyVs, time, lazyTime, easing));
    Unit_getInstance();
  };
  Animator.prototype.__tween$default_fp6w2r_k$ = function (vs, lazyVs, time, lazyTime, easing, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      lazyVs = null;
    if (!(($mask0 & 4) === 0))
      time = this._time_6;
    if (!(($mask0 & 8) === 0))
      lazyTime = null;
    if (!(($mask0 & 16) === 0))
      easing = this._easing_0;
    return this.__tween_8qsp2n_k$(vs, lazyVs, time, lazyTime, easing);
  };
  Animator.prototype.tween_lgqmq9_k$ = function (vs, time, easing) {
    var tmp = vs.slice();
    return this.__tween$default_fp6w2r_k$(tmp, null, time, null, easing, 10, null);
  };
  Animator.$metadata$ = {
    simpleName: 'Animator',
    kind: 'class',
    interfaces: [BaseAnimatorNode]
  };
  function animateParallel(_this_, time, speed, easing, completeOnCancel, looped, block, $cont) {
    return animate(_this_, time, speed, easing, completeOnCancel, NodeKind_Parallel_getInstance(), looped, block, $cont);
  }
  function animateParallel$default(_this_, time, speed, easing, completeOnCancel, looped, block, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      time = Companion_getInstance_195()._DEFAULT_TIME;
    if (!(($mask0 & 2) === 0))
      speed = Companion_getInstance_195()._DEFAULT_SPEED;
    if (!(($mask0 & 4) === 0))
      easing = Companion_getInstance_195()._DEFAULT_EASING;
    if (!(($mask0 & 8) === 0))
      completeOnCancel = Companion_getInstance_195()._DEFAULT_COMPLETE_ON_CANCEL;
    if (!(($mask0 & 16) === 0))
      looped = false;
    if (!(($mask0 & 32) === 0)) {
      block = _no_name_provided_$factory_384();
    }return animateParallel(_this_, time, speed, easing, completeOnCancel, looped, block, $cont);
  }
  function BaseAnimatorNode() {
  }
  BaseAnimatorNode.$metadata$ = {
    simpleName: 'BaseAnimatorNode',
    kind: 'interface',
    interfaces: []
  };
  function AnimateCancellationException() {
  }
  AnimateCancellationException.$metadata$ = {
    simpleName: 'AnimateCancellationException',
    kind: 'class',
    interfaces: []
  };
  function animate(_this_, time, speed, easing, completeOnCancel, kind, looped, block, $cont) {
    var tmp = new $animateCOROUTINE$9(_this_, time, speed, easing, completeOnCancel, kind, looped, block, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__443() {
  }
  _no_name_provided__443.prototype.invoke_njrw7w_k$ = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__443.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_njrw7w_k$(p1 instanceof Animator ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__443.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $animateCOROUTINE$9(_this_, time, speed, easing, completeOnCancel, kind, looped, block, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__179 = _this_;
    this._time_7 = time;
    this._speed_0 = speed;
    this._easing_1 = easing;
    this._completeOnCancel_1 = completeOnCancel;
    this._kind_6 = kind;
    this._looped_0 = looped;
    this._block_3 = block;
  }
  $animateCOROUTINE$9.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            var tmp0_apply_0 = Animator_init_$Create$(this.__this__179, this._time_7, this._speed_0, this._easing_1, this._completeOnCancel_1, this._kind_6, this._looped_0, null, 128, null);
            this._block_3(tmp0_apply_0);
            tmp_0._tmp1_also_00 = tmp0_apply_0;
            this._state_1 = 1;
            suspendResult = this._tmp1_also_00.execute_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return this._tmp1_also_00;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $animateCOROUTINE$9.$metadata$ = {
    simpleName: '$animateCOROUTINE$9',
    kind: 'class',
    interfaces: []
  };
  function computedVs$factory() {
    return getPropertyCallableRef('computedVs', 1, KProperty1, function (receiver) {
      return receiver._get_computedVs__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_379() {
    var i = new _no_name_provided__439();
    return function (p1) {
      i.invoke_njrw7w_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_380() {
    var i = new _no_name_provided__440();
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_381(this$0) {
    var i = new _no_name_provided__438(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_382($node_5, resultContinuation) {
    var i = new _no_name_provided__442($node_5, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_383($node_5, resultContinuation) {
    var i = new _no_name_provided__441($node_5, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_384() {
    var i = new _no_name_provided__443();
    return function (p1) {
      i.invoke_njrw7w_k$(p1);
      return Unit_getInstance();
    };
  }
  function RangeResult_init_$Init$(startIndex, endIndex, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      startIndex = 0;
    if (!(($mask0 & 2) === 0))
      endIndex = 0;
    RangeResult.call($this, startIndex, endIndex);
    return $this;
  }
  function RangeResult_init_$Create$(startIndex, endIndex, $mask0, $marker) {
    return RangeResult_init_$Init$(startIndex, endIndex, $mask0, $marker, Object.create(RangeResult.prototype));
  }
  function Result_init_$Init$(index_0, left, right, ratio, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      index_0 = 0;
    if (!(($mask0 & 2) === 0))
      left = null;
    if (!(($mask0 & 4) === 0))
      right = null;
    if (!(($mask0 & 8) === 0))
      ratio = 0.0;
    Result_0.call($this, index_0, left, right, ratio);
    return $this;
  }
  function Result_init_$Create$(index_0, left, right, ratio, $mask0, $marker) {
    return Result_init_$Init$(index_0, left, right, ratio, $mask0, $marker, Object.create(Result_0.prototype));
  }
  function Timed_init_$Init$(initialCapacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialCapacity = 7;
    Timed.call($this, initialCapacity);
    return $this;
  }
  function Timed_init_$Create$(initialCapacity, $mask0, $marker) {
    return Timed_init_$Init$(initialCapacity, $mask0, $marker, Object.create(Timed.prototype));
  }
  function swap_0($this, a, b) {
    var tempTime = $this._times_1.get_ha5a7z_k$(b);
    var tempObject = $this._objects.get_ha5a7z_k$(b);
    $this._times_1.set_rvwcgf_k$(b, $this._times_1.get_ha5a7z_k$(a));
    $this._objects.set_ddb1qf_k$(b, $this._objects.get_ha5a7z_k$(a));
    Unit_getInstance();
    $this._times_1.set_rvwcgf_k$(a, tempTime);
    $this._objects.set_ddb1qf_k$(a, tempObject);
    Unit_getInstance();
  }
  function RangeResult(startIndex, endIndex) {
    this._startIndex_0 = startIndex;
    this._endIndex = endIndex;
  }
  RangeResult.prototype.toString = function () {
    return '' + 'RangeResult(startIndex=' + this._startIndex_0 + ', endIndex=' + this._endIndex + ')';
  };
  RangeResult.prototype.hashCode = function () {
    var result = this._startIndex_0;
    result = imul(result, 31) + this._endIndex | 0;
    return result;
  };
  RangeResult.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RangeResult))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RangeResult ? other : THROW_CCE();
    if (!(this._startIndex_0 === tmp0_other_with_cast._startIndex_0))
      return false;
    if (!(this._endIndex === tmp0_other_with_cast._endIndex))
      return false;
    return true;
  };
  RangeResult.$metadata$ = {
    simpleName: 'RangeResult',
    kind: 'class',
    interfaces: []
  };
  function Result_0(index_0, left, right, ratio) {
    this._index_29 = index_0;
    this._left_5 = left;
    this._right_1 = right;
    this._ratio_3 = ratio;
  }
  Result_0.prototype.component1_0_k$ = function () {
    return this._index_29;
  };
  Result_0.prototype.component2_0_k$ = function () {
    return this._left_5;
  };
  Result_0.prototype.component3_0_k$ = function () {
    return this._right_1;
  };
  Result_0.prototype.component4_0_k$ = function () {
    return this._ratio_3;
  };
  Result_0.prototype.toString = function () {
    return '' + 'Result(index=' + this._index_29 + ', left=' + this._left_5 + ', right=' + this._right_1 + ', ratio=' + this._ratio_3 + ')';
  };
  Result_0.prototype.hashCode = function () {
    var result = this._index_29;
    result = imul(result, 31) + (this._left_5 == null ? 0 : hashCode(this._left_5)) | 0;
    result = imul(result, 31) + (this._right_1 == null ? 0 : hashCode(this._right_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this._ratio_3) | 0;
    return result;
  };
  Result_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Result_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Result_0 ? other : THROW_CCE();
    if (!(this._index_29 === tmp0_other_with_cast._index_29))
      return false;
    if (!equals_1(this._left_5, tmp0_other_with_cast._left_5))
      return false;
    if (!equals_1(this._right_1, tmp0_other_with_cast._right_1))
      return false;
    if (!equals_1(this._ratio_3, tmp0_other_with_cast._ratio_3))
      return false;
    return true;
  };
  Result_0.$metadata$ = {
    simpleName: 'Result',
    kind: 'class',
    interfaces: []
  };
  function Timed(initialCapacity) {
    this._times_1 = new IntArrayList(initialCapacity);
    this._objects = ArrayList_init_$Create$_0(initialCapacity);
  }
  Timed.prototype._get_size__0_k$ = function () {
    return this._times_1._get_size__0_k$();
  };
  Timed.prototype._get_entries__0_k$ = function () {
    return zip(this._times_1, this._objects);
  };
  Timed.prototype._get_int__59d170_k$ = function (_this__0) {
    return _TimeSpan___get_microsecondsInt__impl_(_this__0);
  };
  Timed.prototype.add_7kz1ka_k$ = function (time, obj) {
    var time_0 = this._get_int__59d170_k$(time);
    this._times_1.add_majfzk_k$(time_0);
    this._objects.add_2bq_k$(obj);
    Unit_getInstance();
    var m = this._times_1._get_size__0_k$() - 2 | 0;
    while (m >= 0 ? time_0 < this._times_1.get_ha5a7z_k$(m) : false) {
      swap_0(this, m, m + 1 | 0);
      var tmp0 = m;
      m = tmp0 - 1 | 0;
      Unit_getInstance();
    }
  };
  Timed.prototype.findNearIndex_wv9l0m_k$ = function (time) {
    var tmp = this._get_int__59d170_k$(time);
    var res = _BSearchResult___get_raw__impl_(binarySearch$default(this._times_1, tmp, 0, 0, 6, null));
    return res < 0 ? clamp_2((-res | 0) - 1 | 0, 0, this._times_1._get_size__0_k$() - 1 | 0) : res;
  };
  Timed.prototype.getRangeIndices_nlo4uw_k$ = function (startTime, endTime, out) {
    var startIndex = clamp_2(this.findNearIndex_wv9l0m_k$(startTime) - 1 | 0, 0, this._get_size__0_k$() - 1 | 0);
    var endIndex = clamp_2(this.findNearIndex_wv9l0m_k$(endTime) + 1 | 0, 0, this._get_size__0_k$() - 1 | 0);
    var min_0 = IntCompanionObject_getInstance()._MAX_VALUE_5;
    var max = IntCompanionObject_getInstance()._MIN_VALUE_5;
    var rangeLow = this._get_int__59d170_k$(startTime);
    var rangeHigh = this._get_int__59d170_k$(endTime);
    var inductionVariable = startIndex;
    if (inductionVariable <= endIndex)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var time = this._times_1.get_ha5a7z_k$(n);
        if (rangeLow <= time ? time <= rangeHigh : false) {
          var tmp0_min_0 = min_0;
          min_0 = Math.min(tmp0_min_0, n);
          var tmp1_max_0 = max;
          max = Math.max(tmp1_max_0, n);
        }}
       while (!(n === endIndex));
    out._startIndex_0 = min_0;
    out._endIndex = max;
    return out;
  };
  Timed.prototype.find_2ntwu5_k$ = function (time, out) {
    var tmp$ret$0;
    l$ret$1: do {
      if (this._objects.isEmpty_0_k$()) {
        out._index_29 = 0;
        out._left_5 = null;
        out._right_1 = null;
        out._ratio_3 = 0.0;
        tmp$ret$0 = out;
        break l$ret$1;
      }var index_1 = this.findNearIndex_wv9l0m_k$(time);
      var timeInt_2 = this._get_int__59d170_k$(time);
      var timeAtIndex_3 = this._times_1.get_ha5a7z_k$(index_1);
      if (timeInt_2 < timeAtIndex_3 ? index_1 <= 0 : false) {
        var tmp0__anonymous__9 = this._objects.get_ha5a7z_k$(0);
        out._index_29 = 0;
        out._left_5 = null;
        out._right_1 = tmp0__anonymous__9;
        out._ratio_3 = 0.0;
        tmp$ret$0 = out;
        break l$ret$1;
      } else {
        var idx_4 = timeInt_2 < timeAtIndex_3 ? index_1 - 1 | 0 : index_1;
        var curTimeAtIndex_5 = this._times_1.get_ha5a7z_k$(idx_4 + 0 | 0);
        if (curTimeAtIndex_5 === timeInt_2) {
          var tmp1__anonymous__9 = this._objects.get_ha5a7z_k$(idx_4);
          out._index_29 = idx_4;
          out._left_5 = tmp1__anonymous__9;
          out._right_1 = null;
          out._ratio_3 = 0.0;
          tmp$ret$0 = out;
          break l$ret$1;
        } else {
          if (idx_4 >= (this._times_1._get_size__0_k$() - 1 | 0)) {
            var tmp2__anonymous__9 = this._objects._get_size__0_k$();
            var tmp3__anonymous__9 = this._objects.get_ha5a7z_k$(this._objects._get_size__0_k$() - 1 | 0);
            out._index_29 = tmp2__anonymous__9;
            out._left_5 = tmp3__anonymous__9;
            out._right_1 = null;
            out._ratio_3 = 1.0;
            tmp$ret$0 = out;
            break l$ret$1;
          } else {
            var nextTimeAtIndex_6 = this._times_1.get_ha5a7z_k$(idx_4 + 1 | 0);
            var elapsedTime_7 = timeInt_2 - curTimeAtIndex_5 | 0;
            var totalTime_8 = nextTimeAtIndex_6 - curTimeAtIndex_5 | 0;
            var tmp4__anonymous__9 = this._objects.get_ha5a7z_k$(idx_4);
            var tmp5__anonymous__9 = this._objects.get_ha5a7z_k$(idx_4 + 1 | 0);
            var tmp6__anonymous__9 = elapsedTime_7 / totalTime_8;
            out._index_29 = idx_4;
            out._left_5 = tmp4__anonymous__9;
            out._right_1 = tmp5__anonymous__9;
            out._ratio_3 = tmp6__anonymous__9;
            tmp$ret$0 = out;
            break l$ret$1;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  Timed.prototype.findWithoutInterpolation_2ntwu5_k$ = function (time, out) {
    var tmp$ret$0;
    l$ret$1: do {
      if (this._objects.isEmpty_0_k$()) {
        out._index_29 = 0;
        out._left_5 = null;
        out._right_1 = null;
        out._ratio_3 = 0.0;
        tmp$ret$0 = out;
        break l$ret$1;
      }var index_1 = this.findNearIndex_wv9l0m_k$(time);
      var timeInt_2 = this._get_int__59d170_k$(time);
      var timeAtIndex_3 = this._times_1.get_ha5a7z_k$(index_1);
      var tmp;
      if (timeInt_2 < timeAtIndex_3 ? index_1 <= 0 : false) {
        out._index_29 = 0;
        out._left_5 = null;
        out._right_1 = null;
        out._ratio_3 = 0.0;
        tmp = out;
      } else {
        var idx_4 = timeInt_2 < timeAtIndex_3 ? index_1 - 1 | 0 : index_1;
        var curTimeAtIndex_5 = this._times_1.get_ha5a7z_k$(idx_4 + 0 | 0);
        var tmp_0;
        if (curTimeAtIndex_5 === timeInt_2) {
          var tmp0__anonymous__6 = this._objects.get_ha5a7z_k$(idx_4);
          out._index_29 = idx_4;
          out._left_5 = tmp0__anonymous__6;
          out._right_1 = null;
          out._ratio_3 = 0.0;
          tmp_0 = out;
        } else if (idx_4 >= (this._times_1._get_size__0_k$() - 1 | 0)) {
          var tmp1__anonymous__6 = this._objects._get_size__0_k$();
          var tmp2__anonymous__6 = this._objects.get_ha5a7z_k$(this._objects._get_size__0_k$() - 1 | 0);
          out._index_29 = tmp1__anonymous__6;
          out._left_5 = tmp2__anonymous__6;
          out._right_1 = null;
          out._ratio_3 = 0.0;
          tmp_0 = out;
        } else {
          var tmp3__anonymous__6 = this._objects.get_ha5a7z_k$(idx_4);
          out._index_29 = idx_4;
          out._left_5 = tmp3__anonymous__6;
          out._right_1 = null;
          out._ratio_3 = 0.0;
          tmp_0 = out;
        }
        tmp = tmp_0;
      }
      tmp$ret$0 = tmp;
    }
     while (false);
    return tmp$ret$0;
  };
  Timed.prototype.toString = function () {
    return '' + 'Timed(' + this._get_entries__0_k$() + ')';
  };
  Timed.$metadata$ = {
    simpleName: 'Timed',
    kind: 'class',
    interfaces: []
  };
  function readAni(_this_, context, content, $cont) {
    var tmp = new $readAniCOROUTINE$10(_this_, context, content, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function ExternalReaders(atlasReader, readSound_0) {
    this._atlasReader = atlasReader;
    this._readSound = readSound_0;
  }
  ExternalReaders.$metadata$ = {
    simpleName: 'ExternalReaders',
    kind: 'class',
    interfaces: []
  };
  function readLibrary(_this_, $this, context, externalReaders, $cont) {
    var tmp = new $readLibraryCOROUTINE$11($this, _this_, context, externalReaders, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readSymbol(_this_, $this, strings, atlases, sounds) {
    var symbolId = _this_.readU_VL_0_k$();
    var symbolName = strings[_this_.readU_VL_0_k$()];
    var type = _this_.readU_VL_0_k$();
    var tmp0_subject = type;
    var tmp;
    AniFile_getInstance();
    if (tmp0_subject === 0) {
      tmp = AnSymbolEmpty_getInstance();
    } else {
      AniFile_getInstance();
      if (tmp0_subject === 1) {
        var soundId = _this_.readU_VL_0_k$();
        tmp = new AnSymbolSound(symbolId, symbolName, sounds.get_ha5a7z_k$(soundId), null);
      } else {
        AniFile_getInstance();
        if (tmp0_subject === 2) {
          var initialText = strings[_this_.readU_VL_0_k$()];
          var bounds_0 = $this.readRect_v83o64_k$(_this_);
          var tmp1_elvis_lhs = initialText;
          tmp = new AnTextFieldSymbol(symbolId, symbolName, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs, bounds_0);
        } else {
          AniFile_getInstance();
          if (tmp0_subject === 3) {
            var scale_1 = _this_.readF32LE_0_k$();
            var bitmapId = _this_.readU_VL_0_k$();
            var atlas = atlases.get_ha5a7z_k$(bitmapId);
            var textureBounds = $this.readIRect_nb6s6m_k$(_this_);
            var bounds_1 = $this.readRect_v83o64_k$(_this_);
            var bitmap = atlas._first;
            var texture = atlas._second;
            var tmp2_subject = _this_.readU_VL_0_k$();
            var tmp_0;
            switch (tmp2_subject) {
              case 0:
                tmp_0 = null;
                break;
              case 1:
                var cmds = new Int32Array(_this_.readU_VL_0_k$());
                var inductionVariable = 0;
                var last_1 = cmds.length;
                if (inductionVariable < last_1)
                  do {
                    var n = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    cmds[n] = _this_.readU8_0_k$();
                  }
                   while (inductionVariable < last_1);
                var data = new Float64Array(_this_.readU_VL_0_k$());
                var inductionVariable_0 = 0;
                var last_2 = data.length;
                if (inductionVariable_0 < last_2)
                  do {
                    var n_0 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    data[n_0] = _this_.readF32LE_0_k$();
                  }
                   while (inductionVariable_0 < last_2);
                var tmp_1 = IntArrayList_init_$Create$_1(cmds.slice());
                var tmp_2 = DoubleArrayList_init_$Create$_1(data.slice());
                tmp_0 = VectorPath_init_$Create$(tmp_1, tmp_2, null, 4, null);
                break;
              default:tmp_0 = null;
                break;
            }
            var path_0 = tmp_0;
            var tmp_3 = texture.slice$default_7tbffz_k$(textureBounds, null, 2, null);
            tmp = new AnSymbolShape(symbolId, symbolName, bounds_1, new TextureWithBitmapSlice(tmp_3, slice$default(bitmap, textureBounds, null, 2, null), scale_1, bounds_1), path_0);
          } else {
            AniFile_getInstance();
            if (tmp0_subject === 6) {
              var nframes = _this_.readU_VL_0_k$();
              var texturesWithBitmap = new Timed(nframes);
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < nframes)
                do {
                  var n_1 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var tmp0__get_milliseconds__0 = _this_.readU_VL_0_k$();
                  var ratio1000 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp0__get_milliseconds__0);
                  var scale_2 = _this_.readF32LE_0_k$();
                  var bitmapId_0 = _this_.readU_VL_0_k$();
                  var bounds_2 = $this.readRect_v83o64_k$(_this_);
                  var textureBounds_0 = $this.readIRect_nb6s6m_k$(_this_);
                  var atlas_0 = atlases.get_ha5a7z_k$(bitmapId_0);
                  var bitmap_0 = atlas_0._first;
                  var texture_0 = atlas_0._second;
                  var tmp_4 = texture_0.slice$default_7tbffz_k$(textureBounds_0, null, 2, null);
                  texturesWithBitmap.add_7kz1ka_k$(ratio1000, new TextureWithBitmapSlice(tmp_4, slice$default(bitmap_0, textureBounds_0, null, 2, null), scale_2, bounds_2));
                }
                 while (inductionVariable_1 < nframes);
              tmp = new AnSymbolMorphShape(symbolId, symbolName, Companion_getInstance_35().invoke_0_k$(), texturesWithBitmap, null);
            } else {
              AniFile_getInstance();
              if (tmp0_subject === 4) {
                tmp = new AnSymbolBitmap(symbolId, symbolName, Bitmap32_init_$Create$(1, 1, null, false, 12, null));
              } else {
                AniFile_getInstance();
                if (tmp0_subject === 5) {
                  tmp = readMovieClip(_this_, $this, symbolId, symbolName, strings);
                } else {
                  {
                    var tmp1_TODO_0 = '' + 'Type: ' + type;
                    throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp1_TODO_0);
                  }
                }
              }
            }
          }
        }
      }
    }
    var symbol = tmp;
    return symbol;
  }
  function readMovieClip(_this_, $this, symbolId, symbolName, strings) {
    var mcFlags = _this_.readU8_0_k$();
    var totalDepths = _this_.readU_VL_0_k$();
    var totalFrames = _this_.readU_VL_0_k$();
    var tmp0__get_milliseconds__0 = _this_.readU_VL_0_k$();
    var totalTime = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp0__get_milliseconds__0);
    var totalUids = _this_.readU_VL_0_k$();
    var tmp1_map_0 = until(0, totalUids);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var inductionVariable = tmp1_map_0._get_first__0_k$();
    var last_1 = tmp1_map_0._get_last__0_k$();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var charId_5 = _this_.readU_VL_0_k$();
        var extraPropsString_6 = _this_.readStringVL$default_8s0uio_k$(null, 1, null);
        var tmp;
        if (charSequenceLength(extraPropsString_6) === 0) {
          tmp = LinkedHashMap_init_$Create$();
        } else {
          {
            var tmp_0 = Json_getInstance();
            var tmp_1 = tmp_0.parse$default_7dtpy2_k$(extraPropsString_6, null, 2, null);
            tmp = (!(tmp_1 == null) ? isInterface(tmp_1, MutableMap) : false) ? tmp_1 : THROW_CCE();
          }
        }
        var extraProps_7 = tmp;
        tmp0_mapTo_0_1.add_2bq_k$(new AnSymbolUidDef(charId_5, extraProps_7));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    var tmp2_toTypedArray_0 = tmp0_mapTo_0_1;
    var uidsToCharacterIds = copyToArray_0(tmp2_toTypedArray_0);
    var mc = new AnSymbolMovieClip(symbolId, symbolName, new AnSymbolLimits(totalDepths, totalFrames, totalUids, totalTime));
    if (extract_0(mcFlags, 0)) {
      mc._ninePatch_0 = $this.readRect_v83o64_k$(_this_);
    }var tmp3_map_0 = until(0, _this_.readU_VL_0_k$());
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map_0, 10));
    var inductionVariable_0 = tmp3_map_0._get_first__0_k$();
    var last_2 = tmp3_map_0._get_last__0_k$();
    if (inductionVariable_0 <= last_2)
      do {
        var item_2_3_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var ss_5 = new AnSymbolMovieClipSubTimeline(totalDepths);
        var tmp_2 = ss_5;
        var tmp0__get_microseconds__0_6 = _this_.readU_VL_0_k$();
        tmp_2._totalTime_0 = Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0_6);
        var stateFlags_7 = _this_.readU8_0_k$();
        ss_5._nextStatePlay = extract_0(stateFlags_7, 0);
        ss_5._nextState_1 = strings[_this_.readU_VL_0_k$()];
        var numberOfActionFrames_8 = _this_.readU_VL_0_k$();
        var lastFrameTime_9 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < numberOfActionFrames_8)
          do {
            var n_11 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp1__get_milliseconds__0_13 = _this_.readU_VL_0_k$();
            var deltaTime_12 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp1__get_milliseconds__0_13);
            var timeInMs_14 = TimeSpan__plus_impl(lastFrameTime_9, deltaTime_12);
            lastFrameTime_9 = timeInMs_14;
            var tmp2_map_0_16 = until(0, _this_.readU_VL_0_k$());
            var tmp0_mapTo_0_1_17 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0_16, 10));
            var inductionVariable_2 = tmp2_map_0_16._get_first__0_k$();
            var last_3 = tmp2_map_0_16._get_last__0_k$();
            if (inductionVariable_2 <= last_3)
              do {
                var item_2_3_19 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var action_5_20 = _this_.readU8_0_k$();
                var tmp0_subject_6_21 = action_5_20;
                var tmp_3;
                switch (tmp0_subject_6_21) {
                  case 0:
                    tmp_3 = new AnPlaySoundAction(_this_.readU_VL_0_k$());
                    break;
                  case 1:
                    var tmp1_elvis_lhs_7_22 = strings[_this_.readU_VL_0_k$()];
                    tmp_3 = new AnEventAction(tmp1_elvis_lhs_7_22 == null ? '' : tmp1_elvis_lhs_7_22);
                    break;
                  default:throw NotImplementedError_init_$Create$(null, 1, null);
                }
                tmp0_mapTo_0_1_17.add_2bq_k$(tmp_3);
                Unit_getInstance();
              }
               while (!(item_2_3_19 === last_3));
            var actions_15 = tmp0_mapTo_0_1_17;
            var n_1_23 = 0;
            while (n_1_23 < actions_15._get_size__0_k$()) {
              var tmp0_2_25 = n_1_23;
              n_1_23 = tmp0_2_25 + 1 | 0;
              var tmp3__anonymous__3_24 = actions_15.get_ha5a7z_k$(tmp0_2_25);
              ss_5._actions_0.add_7kz1ka_k$(TimeSpan__times_impl(timeInMs_14, 1000), tmp3__anonymous__3_24);
            }
          }
           while (inductionVariable_1 < numberOfActionFrames_8);
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < totalDepths)
          do {
            var depth_27 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var timeline_28 = ss_5._timelines[depth_27];
            var lastUid_29 = -1;
            var lastName_30 = null;
            var lastColorTransform_31 = new ColorTransform(1.0, 1.0, 1.0, 1.0, 0, 0, 0, 0);
            var lastMatrix_32 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
            var lastClipDepth_33 = -1;
            var lastRatio_34 = 0.0;
            var lastFrameTime_35 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
            var lastBlendMode_36 = BlendMode_INHERIT_getInstance();
            var inductionVariable_4 = 0;
            var last_4 = _this_.readU_VL_0_k$();
            if (inductionVariable_4 < last_4)
              do {
                var frameIndex_38 = inductionVariable_4;
                inductionVariable_4 = inductionVariable_4 + 1 | 0;
                var tmp4__get_milliseconds__0_40 = _this_.readU_VL_0_k$();
                var deltaFrameTime_39 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp4__get_milliseconds__0_40);
                var frameTime_41 = TimeSpan__plus_impl(lastFrameTime_35, deltaFrameTime_39);
                lastFrameTime_35 = frameTime_41;
                var flags_42 = _this_.readU_VL_0_k$();
                var hasUid_43 = extract_0(flags_42, 0);
                var hasName_44 = extract_0(flags_42, 1);
                var hasColorTransform_45 = extract_0(flags_42, 2);
                var hasMatrix_46 = extract_0(flags_42, 3);
                var hasClipDepth_47 = extract_0(flags_42, 4);
                var hasRatio_48 = extract_0(flags_42, 5);
                var hasAlpha_49 = extract_0(flags_42, 6);
                var hasBlendMode_50 = extract_0(flags_42, 7);
                if (hasUid_43)
                  lastUid_29 = _this_.readU_VL_0_k$();
                if (hasClipDepth_47)
                  lastClipDepth_33 = _this_.readS16LE_0_k$();
                if (hasName_44)
                  lastName_30 = strings[_this_.readU_VL_0_k$()];
                if (hasAlpha_49) {
                  var tmp_4 = lastColorTransform_31;
                  var ct_51 = tmp_4.copy$default_tv4bwa_k$(0.0, 0.0, 0.0, 0.0, 0, 0, 0, 0, 255, null);
                  ct_51._set_mA__okcceq_k$(_this_.readU8_0_k$() / 255.0);
                  lastColorTransform_31 = ct_51;
                } else if (hasColorTransform_45) {
                  var tmp_5 = lastColorTransform_31;
                  var ct_52 = tmp_5.copy$default_tv4bwa_k$(0.0, 0.0, 0.0, 0.0, 0, 0, 0, 0, 255, null);
                  var ctFlags_53 = _this_.readU8_0_k$();
                  if (extract_0(ctFlags_53, 0))
                    ct_52._set_mR__okcceq_k$(_this_.readU8_0_k$() / 255.0);
                  if (extract_0(ctFlags_53, 1))
                    ct_52._set_mG__okcceq_k$(_this_.readU8_0_k$() / 255.0);
                  if (extract_0(ctFlags_53, 2))
                    ct_52._set_mB__okcceq_k$(_this_.readU8_0_k$() / 255.0);
                  if (extract_0(ctFlags_53, 3))
                    ct_52._set_mA__okcceq_k$(_this_.readU8_0_k$() / 255.0);
                  if (extract_0(ctFlags_53, 4))
                    ct_52._set_aR__majfzk_k$(imul(_this_.readS8_0_k$(), 2));
                  if (extract_0(ctFlags_53, 5))
                    ct_52._set_aG__majfzk_k$(imul(_this_.readS8_0_k$(), 2));
                  if (extract_0(ctFlags_53, 6))
                    ct_52._set_aB__majfzk_k$(imul(_this_.readS8_0_k$(), 2));
                  if (extract_0(ctFlags_53, 7))
                    ct_52._set_aR__majfzk_k$(imul(_this_.readS8_0_k$(), 2));
                  lastColorTransform_31 = ct_52;
                }if (hasMatrix_46) {
                  var tmp_6 = lastMatrix_32;
                  var lm_54 = tmp_6.copy$default_oiwydk_k$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
                  var matrixFlags_55 = _this_.readU8_0_k$();
                  if (extract_0(matrixFlags_55, 0))
                    lm_54._a = _this_.readS_VL_0_k$() / 16384.0;
                  if (extract_0(matrixFlags_55, 1))
                    lm_54._b = _this_.readS_VL_0_k$() / 16384.0;
                  if (extract_0(matrixFlags_55, 2))
                    lm_54._c = _this_.readS_VL_0_k$() / 16384.0;
                  if (extract_0(matrixFlags_55, 3))
                    lm_54._d = _this_.readS_VL_0_k$() / 16384.0;
                  if (extract_0(matrixFlags_55, 4))
                    lm_54._tx = _this_.readS_VL_0_k$() / 20.0;
                  if (extract_0(matrixFlags_55, 5))
                    lm_54._ty = _this_.readS_VL_0_k$() / 20.0;
                  lastMatrix_32 = lm_54;
                }if (hasRatio_48)
                  lastRatio_34 = _this_.readU8_0_k$() / 255.0;
                if (hasBlendMode_50) {
                  var tmp3_elvis_lhs_56 = Companion_getInstance_206()._BY_ORDINAL.get_2bw_k$(_this_.readU8_0_k$());
                  lastBlendMode_36 = tmp3_elvis_lhs_56 == null ? BlendMode_INHERIT_getInstance() : tmp3_elvis_lhs_56;
                }timeline_28.add_7kz1ka_k$(frameTime_41, new AnSymbolTimelineFrame(depth_27, lastUid_29, lastClipDepth_33, lastRatio_34, lastMatrix_32, lastName_30, lastColorTransform_31, lastBlendMode_36));
              }
               while (inductionVariable_4 < last_4);
          }
           while (inductionVariable_3 < totalDepths);
        tmp0_mapTo_0_1_0.add_2bq_k$(ss_5);
        Unit_getInstance();
      }
       while (!(item_2_3_0 === last_2));
    var symbolStates = tmp0_mapTo_0_1_0;
    var inductionVariable_5 = 0;
    var last_5 = uidsToCharacterIds.length;
    if (inductionVariable_5 < last_5)
      do {
        var n = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + 1 | 0;
        mc._uidInfo[n] = uidsToCharacterIds[n];
      }
       while (inductionVariable_5 < last_5);
    var tmp1_this = mc;
    var tmp5_plusAssign_0 = tmp1_this._states;
    var tmp4_map_0 = until(0, _this_.readU_VL_0_k$());
    var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp4_map_0, 10));
    var inductionVariable_6 = tmp4_map_0._get_first__0_k$();
    var last_6 = tmp4_map_0._get_last__0_k$();
    if (inductionVariable_6 <= last_6)
      do {
        var item_2_3_1 = inductionVariable_6;
        inductionVariable_6 = inductionVariable_6 + 1 | 0;
        var tmp0_elvis_lhs_6 = strings[_this_.readU_VL_0_k$()];
        var name_5 = tmp0_elvis_lhs_6 == null ? '' : tmp0_elvis_lhs_6;
        var tmp0__get_milliseconds__0_8 = _this_.readU_VL_0_k$();
        var startTime_7 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp0__get_milliseconds__0_8);
        var stateIndex_9 = _this_.readU_VL_0_k$();
        symbolStates.get_ha5a7z_k$(stateIndex_9)._actions_0.add_7kz1ka_k$(startTime_7, new AnEventAction(name_5));
        tmp0_mapTo_0_1_1.add_2bq_k$(to(name_5, new AnSymbolMovieClipState(name_5, symbolStates.get_ha5a7z_k$(stateIndex_9), startTime_7)));
        Unit_getInstance();
      }
       while (!(item_2_3_1 === last_6));
    var tmp6_plusAssign_0 = toMap_0(tmp0_mapTo_0_1_1);
    tmp5_plusAssign_0.putAll_nn707j_k$(tmp6_plusAssign_0);
    return mc;
  }
  function $readLibraryCOROUTINE$11(_this_, _this__0, context, externalReaders, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__180 = _this_;
    this.__this__181 = _this__0;
    this._context_11 = context;
    this._externalReaders = externalReaders;
  }
  $readLibraryCOROUTINE$11.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            var tmp_0 = this;
            tmp_0._magic0 = this.__this__181.readStringz$default_589s1r_k$(8, null, 2, null);
            AniFile_getInstance();
            if (!(this._magic0 === 'KORGEANI')) {
              AniFile_getInstance();
              invalidOp('' + 'Not a ' + 'KORGEANI' + ' file');
            } else {
            }

            var tmp_1 = this.__this__181.readU_VL_0_k$();
            AniFile_getInstance();
            if (!(tmp_1 === 16)) {
              AniFile_getInstance();
              AniFile_getInstance();
              invalidOp('' + 'Just supported ' + 'KORGEANI' + ' version ' + 16);
            } else {
            }

            this._msPerFrame1 = this.__this__181.readU_VL_0_k$();
            this._width2 = this.__this__181.readU_VL_0_k$();
            this._height3 = this.__this__181.readU_VL_0_k$();
            this._fileFlags4 = this.__this__181.readU_VL_0_k$();
            this._mipmaps5 = extract_0(this._fileFlags4, 0);
            this._smoothInterpolation6 = !extract_0(this._fileFlags4, 1);
            var tmp_2 = this;
            var tmp_3 = this;
            tmp_3._tmp0_apply_07 = new AnLibrary(this._context_11, this._width2, this._height3, 1000.0 / this._msPerFrame1);
            this._tmp0_apply_07._defaultSmoothing = this._smoothInterpolation6;
            tmp_2._library8 = this._tmp0_apply_07;
            var tmp_4 = this;
            var tmp_5 = this;
            tmp_5._tmp1_map_09 = until(1, this.__this__181.readU_VL_0_k$());
            var tmp_6 = this;
            tmp_6._tmp0_mapTo_0_110 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._tmp1_map_09, 10));
            var progression = this._tmp1_map_09;
            var inductionVariable = progression._get_first__0_k$();
            var last_1 = progression._get_last__0_k$();
            if (inductionVariable <= last_1)
              do {
                var item_2_3 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                this._tmp0_mapTo_0_110.add_2bq_k$(this.__this__181.readStringVL$default_8s0uio_k$(null, 1, null));
                Unit_getInstance();
              }
               while (!(item_2_3 === last_1));
            tmp_4._strings11 = plus_4([null], this._tmp0_mapTo_0_110);
            var tmp_7 = this;
            tmp_7._tmp2_map_012 = until(0, this.__this__181.readU_VL_0_k$());
            var tmp_8 = this;
            tmp_8._tmp0_mapTo_0_113 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._tmp2_map_012, 10));
            this._tmp0_iterator_1_214 = this._tmp2_map_012.iterator_0_k$();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator_1_214.hasNext_0_k$()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._item_2_315 = this._tmp0_iterator_1_214.next_0_k$();
            this._state_1 = 2;
            suspendResult = this._externalReaders._atlasReader(this._item_2_315, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._bmp_516 = suspendResult;
            var tmp_9 = this;
            tmp_9._ARGUMENT17_0 = to(this._bmp_516, slice$default(this._bmp_516, null, null, 3, null));
            this._tmp0_mapTo_0_113.add_2bq_k$(this._ARGUMENT17_0);
            Unit_getInstance();
            this._state_1 = 1;
            continue $sm;
          case 3:
            this._atlases18 = this._tmp0_mapTo_0_113;
            var tmp_10 = this;
            tmp_10._tmp3_map_019 = until(0, this.__this__181.readU_VL_0_k$());
            var tmp_11 = this;
            tmp_11._tmp0_mapTo_0_120 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._tmp3_map_019, 10));
            this._tmp0_iterator_1_221 = this._tmp3_map_019.iterator_0_k$();
            this._state_1 = 4;
            continue $sm;
          case 4:
            if (!this._tmp0_iterator_1_221.hasNext_0_k$()) {
              this._state_1 = 6;
              continue $sm;
            }
            this._item_2_322 = this._tmp0_iterator_1_221.next_0_k$();
            this._state_1 = 5;
            suspendResult = this._externalReaders._readSound(this._item_2_322, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            var ARGUMENT = suspendResult;
            this._tmp0_mapTo_0_120.add_2bq_k$(ARGUMENT);
            Unit_getInstance();
            this._state_1 = 4;
            continue $sm;
          case 6:
            var sounds = this._tmp0_mapTo_0_120;
            var tmp4_map_0 = until(0, this.__this__181.readU_VL_0_k$());
            var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp4_map_0, 10));
            var inductionVariable_0 = tmp4_map_0._get_first__0_k$();
            var last_2 = tmp4_map_0._get_last__0_k$();
            if (inductionVariable_0 <= last_2)
              do {
                var item_2_3_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                tmp0_mapTo_0_1.add_2bq_k$(readSymbol(this.__this__181, AnLibraryDeserializer_getInstance(), this._strings11, this._atlases18, sounds));
                Unit_getInstance();
              }
               while (!(item_2_3_0 === last_2));
            var symbols = tmp0_mapTo_0_1;
            var n_1 = 0;
            while (n_1 < symbols._get_size__0_k$()) {
              var tmp0_2 = n_1;
              n_1 = tmp0_2 + 1 | 0;
              var tmp5__anonymous__3 = symbols.get_ha5a7z_k$(tmp0_2);
              this._library8.addSymbol_9dv086_k$(tmp5__anonymous__3);
            }

            this._library8.processSymbolNames_sv8swh_k$();
            return this._library8;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readLibraryCOROUTINE$11.$metadata$ = {
    simpleName: '$readLibraryCOROUTINE$11',
    kind: 'class',
    interfaces: []
  };
  function AnLibraryDeserializer() {
    AnLibraryDeserializer_instance = this;
  }
  AnLibraryDeserializer.prototype.read_cxr8yy_k$ = function (s, context, externalReaders, $cont) {
    return readLibrary(s, this, context, externalReaders, $cont);
  };
  AnLibraryDeserializer.prototype.readRect_v83o64_k$ = function (_this__0) {
    return new Rectangle(_this__0.readS_VL_0_k$() / 20.0, _this__0.readS_VL_0_k$() / 20.0, _this__0.readS_VL_0_k$() / 20.0, _this__0.readS_VL_0_k$() / 20.0);
  };
  AnLibraryDeserializer.prototype.readIRect_nb6s6m_k$ = function (_this__0) {
    return Companion_getInstance_36().invoke_ihmn6a_k$(_this__0.readS_VL_0_k$(), _this__0.readS_VL_0_k$(), _this__0.readS_VL_0_k$(), _this__0.readS_VL_0_k$());
  };
  AnLibraryDeserializer.$metadata$ = {
    simpleName: 'AnLibraryDeserializer',
    kind: 'object',
    interfaces: []
  };
  var AnLibraryDeserializer_instance;
  function AnLibraryDeserializer_getInstance() {
    if (AnLibraryDeserializer_instance == null)
      new AnLibraryDeserializer();
    return AnLibraryDeserializer_instance;
  }
  function readAnimation(_this_, views_0, $cont) {
    var tmp = new $readAnimationCOROUTINE$12(_this_, views_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__444($file, $context, resultContinuation) {
    this._$file_0 = $file;
    this._$context_1 = $context;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__444.prototype.invoke_ha5a7z_k$ = function (index_0, $cont) {
    var tmp = this.create_5i2oyd_k$(index_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__444.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__444.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this._$file_0.withExtension_6wfw3l_k$('' + 'ani.' + this._index_30 + '.png');
            suspendResult = readBitmapOptimized$default(tmp_0, this._$context_1._imageFormats_1, false, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__444.prototype.create_5i2oyd_k$ = function (index_0, completion) {
    var i = new _no_name_provided__444(this._$file_0, this._$context_1, completion);
    i._index_30 = index_0;
    return i;
  };
  _no_name_provided__444.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__445($file, resultContinuation) {
    this._$file_1 = $file;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__445.prototype.invoke_ha5a7z_k$ = function (index_0, $cont) {
    var tmp = this.create_5i2oyd_k$(index_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__445.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__445.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this._$file_1.withExtension_6wfw3l_k$('' + 'ani.' + this._index_31 + '.mp3');
            suspendResult = readSound$default(tmp_0, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__445.prototype.create_5i2oyd_k$ = function (index_0, completion) {
    var i = new _no_name_provided__445(this._$file_1, completion);
    i._index_31 = index_0;
    return i;
  };
  _no_name_provided__445.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $readAniCOROUTINE$10(_this_, context, content, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__182 = _this_;
    this._context_12 = context;
    this._content_10 = content;
  }
  $readAniCOROUTINE$10.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._file0_0 = this.__this__182;
            this._ARGUMENT1_12 = AnLibraryDeserializer_getInstance();
            this._tmp0_elvis_lhs2 = this._content_10;
            if (this._tmp0_elvis_lhs2 == null) {
              this._state_1 = 1;
              suspendResult = this.__this__182.readBytes_0_k$(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT3_4 = this._tmp0_elvis_lhs2;
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT4_3 = suspendResult;
            var tmp_0 = this;
            tmp_0._WHEN_RESULT3_4 = FastByteArrayInputStream_init_$Create$(this._ARGUMENT4_3, 0, 0, 0, 14, null);
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._ARGUMENT5 = this._WHEN_RESULT3_4;
            this._state_1 = 3;
            var tmp_1 = this._get_context__0_k$();
            var tmp_2 = this._context_12.copy$default_kj2jzo_k$(tmp_1, null, 2, null);
            var tmp_3 = _no_name_provided_$factory_385(this._file0_0, this._context_12, null);
            suspendResult = this._ARGUMENT1_12.read_cxr8yy_k$(this._ARGUMENT5, tmp_2, new ExternalReaders(tmp_3, _no_name_provided_$factory_386(this._file0_0, null)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAniCOROUTINE$10.$metadata$ = {
    simpleName: '$readAniCOROUTINE$10',
    kind: 'class',
    interfaces: []
  };
  function $readAnimationCOROUTINE$12(_this_, views_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__183 = _this_;
    this._views_1 = views_0;
  }
  $readAnimationCOROUTINE$12.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._file0_1 = this.__this__183;
            this._state_1 = 1;
            suspendResult = this.__this__183.readBytes_0_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._bytes1 = suspendResult;
            var tmp_0 = this;
            tmp_0._tmp0_fastForEach_02 = _get_animateLibraryLoaders_(this._views_1);
            this._n_13 = 0;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!(this._n_13 < this._tmp0_fastForEach_02._get_size__0_k$())) {
              this._state_1 = 6;
              continue $sm;
            }
            var tmp_1 = this;
            var tmp0_2 = this._n_13;
            this._n_13 = tmp0_2 + 1 | 0;
            tmp_1._tmp1__anonymous__34 = this._tmp0_fastForEach_02.get_ha5a7z_k$(tmp0_2);
            this._state_1 = 3;
            suspendResult = this._tmp1__anonymous__34.invoke_glb5i0_k$(openFastStream$default(this._bytes1, 0, 1, null), this._views_1._injector_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._tmp0_safe_receiver_65 = suspendResult;
            this._tmp1_safe_receiver_56 = this._tmp0_safe_receiver_65 == null ? null : this._tmp0_safe_receiver_65._loader;
            if (this._tmp1_safe_receiver_56 == null) {
              this._WHEN_RESULT7_0 = null;
              this._state_1 = 5;
              continue $sm;
            } else {
              this._state_1 = 4;
              suspendResult = this._tmp1_safe_receiver_56(this._file0_1, openFastStream$default(this._bytes1, 0, 1, null), this._views_1, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 4:
            this._WHEN_RESULT7_0 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            var library_4 = this._WHEN_RESULT7_0;
            if (!(library_4 == null))
              return library_4;
            this._state_1 = 2;
            continue $sm;
          case 6:
            var tmp2_error_0 = '' + 'Unsupported format for ' + this._file0_1 + '. Did you miss installing something? Like: views.registerSwfLoading()';
            throw IllegalStateException_init_$Create$_0(toString_1(tmp2_error_0));
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAnimationCOROUTINE$12.$metadata$ = {
    simpleName: '$readAnimationCOROUTINE$12',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_385($file, $context, resultContinuation) {
    var i = new _no_name_provided__444($file, $context, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_ha5a7z_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_386($file, resultContinuation) {
    var i = new _no_name_provided__445($file, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_ha5a7z_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function AniFile() {
    AniFile_instance = this;
    this._MAGIC = 'KORGEANI';
    this._VERSION_0 = 16;
    this._SYMBOL_TYPE_EMPTY = 0;
    this._SYMBOL_TYPE_SOUND = 1;
    this._SYMBOL_TYPE_TEXT = 2;
    this._SYMBOL_TYPE_SHAPE = 3;
    this._SYMBOL_TYPE_BITMAP = 4;
    this._SYMBOL_TYPE_MOVIE_CLIP = 5;
    this._SYMBOL_TYPE_MORPH_SHAPE = 6;
  }
  AniFile.$metadata$ = {
    simpleName: 'AniFile',
    kind: 'object',
    interfaces: []
  };
  var AniFile_instance;
  function AniFile_getInstance() {
    if (AniFile_instance == null)
      new AniFile();
    return AniFile_instance;
  }
  function BaseView() {
    this.__components = null;
    var tmp = this;
    tmp.__props = LinkedHashMap_init_$Create$();
  }
  BaseView.prototype._get__components__0_k$ = function () {
    return this.__components;
  };
  BaseView.prototype._get_componentsSure__0_k$ = function () {
    if (this.__components == null)
      this.__components = new Components();
    return ensureNotNull(this.__components);
  };
  BaseView.prototype.removeComponent_nayywp_k$ = function (c) {
    var tmp0_safe_receiver = this.__components;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.remove_91onm2_k$(c);
    Unit_getInstance();
  };
  BaseView.prototype.addComponent_ke45cy_k$ = function (c) {
    return this._get_componentsSure__0_k$().add_ke45cy_k$(c);
  };
  BaseView.prototype.addComponent_91onm2_k$ = function (c) {
    return this._get_componentsSure__0_k$().add_91onm2_k$(c);
  };
  BaseView.prototype.addProp_jbb6jz_k$ = function (key, value) {
    var tmp0_set_0 = this.__props;
    tmp0_set_0.put_1q9pf_k$(key, value);
    Unit_getInstance();
  };
  BaseView.prototype.addProps_lvinfi_k$ = function (values_21) {
    var tmp0_iterator = values_21._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var pair = tmp0_iterator.next_0_k$();
      this.addProp_jbb6jz_k$(pair._get_key__0_k$(), pair._get_value__0_k$());
    }
  };
  BaseView.$metadata$ = {
    simpleName: 'BaseView',
    kind: 'class',
    interfaces: []
  };
  function getBounds(_this_, text, format_0, out) {
    var font = _this_;
    var textSize = format_0._get_computedSize__0_k$();
    var width = 0.0;
    var height = 0.0;
    var dy = 0.0;
    var dx = 0.0;
    var glyph = GlyphMetrics_init_$Create$(0.0, false, 0, null, 0.0, 31, null);
    var fmetrics = font.getFontMetrics$default_2k781i_k$(textSize, null, 2, null);
    var inductionVariable = 0;
    var last_1 = text.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = charSequenceGet(text, n).toInt_0_k$();
        if (c1 === 10) {
          dx = 0.0;
          dy = dy + fmetrics._get_lineHeight__0_k$();
          var tmp0_max_0 = height;
          var tmp1_max_0 = dy;
          height = Math.max(tmp0_max_0, tmp1_max_0);
          continue;
        }var c2 = 32;
        if ((n + 1 | 0) < text.length)
          c2 = charSequenceGet(text, n + 1 | 0).toInt_0_k$();
        var kerningOffset = font.getKerning_jw27q7_k$(textSize, c1, c2);
        var glyph_0 = font.getGlyphMetrics_xejy1t_k$(textSize, c1, glyph);
        dx = dx + (glyph_0._xadvance_0 + kerningOffset);
        var tmp2_max_0 = width;
        var tmp3_max_0 = dx;
        width = Math.max(tmp2_max_0, tmp3_max_0);
      }
       while (inductionVariable < last_1);
    height = height + fmetrics._get_lineHeight__0_k$();
    out.setTo_i6u10_k$(0.0, 0.0, width, height);
    Unit_getInstance();
    return out;
  }
  function drawText_0(_this_, font, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering) {
    drawText_1(font, _this_, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering);
  }
  function drawText$default_0(_this_, font, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering, $mask0, $handler) {
    if (!(($mask0 & 32) === 0)) {
      m = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }if (!(($mask0 & 64) === 0))
      colMul = Colors_getInstance()._WHITE_0;
    if (!(($mask0 & 128) === 0)) {
      var tmp0__get_NEUTRAL__0 = Companion_getInstance_132();
      colAdd = ColorAdd_NEUTRAL;
    }if (!(($mask0 & 256) === 0))
      blendMode = BlendMode_INHERIT_getInstance();
    if (!(($mask0 & 512) === 0))
      filtering = true;
    return drawText_0(_this_, font, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering);
  }
  function drawText_1(_this_, ctx, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering) {
    var m2 = m.clone_0_k$();
    var scale_1 = textSize / _this_._fontSize_0;
    m2.pretranslate_ngl742_k$(x, y);
    Unit_getInstance();
    m2.prescale_ngl742_k$(scale_1, scale_1);
    Unit_getInstance();
    var dx = 0.0;
    var dy = 0.0;
    var tmp1_use_0 = ctx._batch_0;
    var tmp0_useBatcher_0 = tmp1_use_0._ctx_6;
    if (!(tmp0_useBatcher_0._currentBatcher === tmp1_use_0)) {
      tmp0_useBatcher_0.flush_sv8swh_k$();
      tmp0_useBatcher_0._currentBatcher = tmp1_use_0;
    }var inductionVariable = 0;
    var last_1 = charSequenceLength(str) - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1_4 = charSequenceGet(str, n_3).toInt_0_k$();
        if (c1_4 === 10) {
          dx = 0.0;
          dy = dy + _this_._fontSize_0;
          continue;
        }var tmp0_getOrElse_0_6 = n_3 + 1 | 0;
        var tmp;
        if (tmp0_getOrElse_0_6 >= 0 ? tmp0_getOrElse_0_6 <= _get_lastIndex__5(str) : false) {
          tmp = charSequenceGet(str, tmp0_getOrElse_0_6);
        } else {
          tmp = new Char(32);
        }
        var c2_5 = tmp.toInt_0_k$();
        var glyph_7 = _this_.get_ha5a7z_k$(c1_4);
        var tex_8 = glyph_7._texture_0;
        var tmp1_tex_9 = ctx.getTex_uoiv7r_k$(tex_8);
        var tmp2_x_10 = dx + glyph_7._xoffset;
        var tmp3_y_11 = dy + glyph_7._yoffset;
        var tmp4_blendFactors_12 = blendMode._factors;
        tmp1_use_0.drawQuad$default_r2v3rq_k$(tmp1_tex_9, tmp2_x_10, tmp3_y_11, 0.0, 0.0, m2, filtering, colMul, colAdd, tmp4_blendFactors_12, null, 1048, null);
        var tmp5_safe_receiver_15 = _this_._kernings.get_ha5a7z_k$(Companion_getInstance_140().buildKey_27zxwg_k$(c1_4, c2_5));
        var tmp6_elvis_lhs_14 = tmp5_safe_receiver_15 == null ? null : tmp5_safe_receiver_15._amount;
        var kerningOffset_13 = tmp6_elvis_lhs_14 == null ? 0 : tmp6_elvis_lhs_14;
        dx = dx + (glyph_7._xadvance + kerningOffset_13 | 0);
      }
       while (inductionVariable <= last_1);
  }
  function UpdateComponentWithViews() {
  }
  UpdateComponentWithViews.$metadata$ = {
    simpleName: 'UpdateComponentWithViews',
    kind: 'interface',
    interfaces: [Component]
  };
  function GamepadComponent() {
  }
  GamepadComponent.$metadata$ = {
    simpleName: 'GamepadComponent',
    kind: 'interface',
    interfaces: [Component]
  };
  function KeyComponent() {
  }
  KeyComponent.$metadata$ = {
    simpleName: 'KeyComponent',
    kind: 'interface',
    interfaces: [Component]
  };
  function MouseComponent() {
  }
  MouseComponent.$metadata$ = {
    simpleName: 'MouseComponent',
    kind: 'interface',
    interfaces: [Component]
  };
  function attach(_this_) {
    _this_._get_view__0_k$().addComponent_ke45cy_k$(_this_);
    Unit_getInstance();
    return _this_;
  }
  function UpdateComponent() {
  }
  UpdateComponent.$metadata$ = {
    simpleName: 'UpdateComponent',
    kind: 'interface',
    interfaces: [Component]
  };
  function attach_0(_this_) {
    _this_._get_view__0_k$().addComponent_91onm2_k$(_this_);
    Unit_getInstance();
    return _this_;
  }
  function detach(_this_) {
    _this_._get_view__0_k$().removeComponent_nayywp_k$(_this_);
    return _this_;
  }
  function Components() {
    this._mouse = null;
    this._key_4 = null;
    this._gamepad_2 = null;
    this._touch = null;
    this._event_0 = null;
    this._updateWV = null;
    this._update_0 = null;
    this._resize = null;
    this._other_1 = null;
  }
  Components.prototype._get_emouse__0_k$ = function () {
    if (this._mouse == null)
      this._mouse = FastArrayList_init_$Create$();
    return ensureNotNull(this._mouse);
  };
  Components.prototype._get_ekey__0_k$ = function () {
    if (this._key_4 == null)
      this._key_4 = FastArrayList_init_$Create$();
    return ensureNotNull(this._key_4);
  };
  Components.prototype._get_egamepad__0_k$ = function () {
    if (this._gamepad_2 == null)
      this._gamepad_2 = FastArrayList_init_$Create$();
    return ensureNotNull(this._gamepad_2);
  };
  Components.prototype._get_etouch__0_k$ = function () {
    if (this._touch == null)
      this._touch = FastArrayList_init_$Create$();
    return ensureNotNull(this._touch);
  };
  Components.prototype._get_eupdateWV__0_k$ = function () {
    if (this._updateWV == null)
      this._updateWV = FastArrayList_init_$Create$();
    return ensureNotNull(this._updateWV);
  };
  Components.prototype._get_eupdate__0_k$ = function () {
    if (this._update_0 == null)
      this._update_0 = FastArrayList_init_$Create$();
    return ensureNotNull(this._update_0);
  };
  Components.prototype.remove_91onm2_k$ = function (c) {
    var tmp0_safe_receiver = this._update_0;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.remove_2bq_k$(c);
  };
  Components.prototype.add_ke45cy_k$ = function (c) {
    var tmp0_plusAssign_0 = this._get_eupdateWV__0_k$();
    tmp0_plusAssign_0.add_2bq_k$(c);
    Unit_getInstance();
    return c;
  };
  Components.prototype.add_91onm2_k$ = function (c) {
    var tmp0_plusAssign_0 = this._get_eupdate__0_k$();
    tmp0_plusAssign_0.add_2bq_k$(c);
    Unit_getInstance();
    return c;
  };
  Components.prototype.findFirstComponentOfType_3uvto2_k$ = function (array, clazz) {
    var array_1 = array._array_4;
    var n_2 = 0;
    while (n_2 < array_1.length) {
      var tmp0_4 = n_2;
      n_2 = tmp0_4 + 1 | 0;
      var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
      var tmp0__anonymous__5 = tmp0_unsafeCast_0_3;
      if (getKClassFromExpression_0(tmp0__anonymous__5).equals(clazz))
        return tmp0__anonymous__5;
    }
    return null;
  };
  Components.$metadata$ = {
    simpleName: 'Components',
    kind: 'class',
    interfaces: []
  };
  function TouchComponent() {
  }
  TouchComponent.$metadata$ = {
    simpleName: 'TouchComponent',
    kind: 'interface',
    interfaces: [Component]
  };
  function Component() {
  }
  Component.$metadata$ = {
    simpleName: 'Component',
    kind: 'interface',
    interfaces: []
  };
  function FixedUpdateComponent_init_$Init$(view, step_0, maxAccumulated, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      maxAccumulated = 10;
    FixedUpdateComponent.call($this, view, step_0, maxAccumulated);
    return $this;
  }
  function FixedUpdateComponent(view, step_0, maxAccumulated) {
    this._view_2 = view;
    this._step_10 = step_0;
    this._maxAccumulated = maxAccumulated;
    var tmp = this;
    tmp._accumulated = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
  }
  FixedUpdateComponent.prototype._get_view__0_k$ = function () {
    return this._view_2;
  };
  FixedUpdateComponent.prototype._get_step__nsqrdp_k$ = function () {
    return this._step_10;
  };
  FixedUpdateComponent.prototype.update_zah5t7_k$ = function (dt) {
    var tmp0_this = this;
    tmp0_this._accumulated = TimeSpan__plus_impl(tmp0_this._accumulated, dt);
    if (TimeSpan__compareTo_impl(this._accumulated, TimeSpan__times_impl(this._step_10, this._maxAccumulated)) >= 0) {
      this._accumulated = TimeSpan__times_impl(this._step_10, this._maxAccumulated);
    }while (TimeSpan__compareTo_impl(this._accumulated, this._step_10) >= 0) {
      var tmp1_this = this;
      tmp1_this._accumulated = TimeSpan__minus_impl(tmp1_this._accumulated, this._step_10);
      this.update_sv8swh_k$();
    }
  };
  FixedUpdateComponent.$metadata$ = {
    simpleName: 'FixedUpdateComponent',
    kind: 'class',
    interfaces: [UpdateComponent]
  };
  var lengths$delegate;
  var width$delegate;
  var height$delegate;
  var x$delegate;
  var y$delegate;
  var scale$delegate;
  var scaleX$delegate;
  var scaleY$delegate;
  function ViewWithLength(view) {
    this._view_3 = view;
  }
  ViewWithLength.$metadata$ = {
    simpleName: 'ViewWithLength',
    kind: 'class',
    interfaces: [LengthExtensions]
  };
  function LengthDelegatedProperty(prop, horizontal, getView) {
    this._prop_0 = prop;
    this._getView = getView;
    var tmp = this;
    var tmp0_elvis_lhs = horizontal;
    tmp._horizontal_0 = tmp0_elvis_lhs == null ? _get_isHorizontal_(this._prop_0) : tmp0_elvis_lhs;
  }
  LengthDelegatedProperty.$metadata$ = {
    simpleName: 'LengthDelegatedProperty',
    kind: 'class',
    interfaces: []
  };
  function ViewWithLengthProp(prop, horizontal) {
    return new LengthDelegatedProperty(prop, horizontal, _no_name_provided_$factory_388());
  }
  function ViewWithLengthProp$default(prop, horizontal, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      horizontal = null;
    return ViewWithLengthProp(prop, horizontal);
  }
  function _get_isHorizontal_(_this_) {
    var tmp0_subject = _this_.callableName;
    var tmp;
    switch (tmp0_subject) {
      case 'x':
      case 'width':
        tmp = true;
        break;
      default:var tmp_0;
        var tmp_1;
        var tmp_2;
        var tmp_3 = _this_.callableName;
        if (contains$default_0(tmp_3, 'x', false, 2, null)) {
          tmp_2 = true;
        } else {
          {
            var tmp_4 = _this_.callableName;
            tmp_2 = contains$default_0(tmp_4, 'X', false, 2, null);
          }
        }

        if (tmp_2) {
          tmp_1 = true;
        } else {
          {
            var tmp_5 = _this_.callableName;
            tmp_1 = contains$default_0(tmp_5, 'width', false, 2, null);
          }
        }

        if (tmp_1) {
          tmp_0 = true;
        } else {
          {
            var tmp_6 = _this_.callableName;
            tmp_0 = contains$default_0(tmp_6, 'Width', false, 2, null);
          }
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  }
  function _no_name_provided__446() {
  }
  _no_name_provided__446.prototype.invoke_upazaj_k$ = function ($this$$receiver) {
    return new ViewWithLength($this$$receiver);
  };
  _no_name_provided__446.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_upazaj_k$(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__446.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__447() {
  }
  _no_name_provided__447.prototype.invoke_t4xgxb_k$ = function (it) {
    return it._view_3;
  };
  _no_name_provided__447.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_t4xgxb_k$(p1 instanceof ViewWithLength ? p1 : THROW_CCE());
  };
  _no_name_provided__447.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function scaledWidth$factory() {
    return getPropertyCallableRef('scaledWidth', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scaledWidth__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_scaledWidth__okcceq_k$(value);
    });
  }
  function scaledHeight$factory() {
    return getPropertyCallableRef('scaledHeight', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scaledHeight__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_scaledHeight__okcceq_k$(value);
    });
  }
  function x$factory() {
    return getPropertyCallableRef('x', 1, KMutableProperty1, function (receiver) {
      return receiver._get_x__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_x__okcceq_k$(value);
    });
  }
  function y$factory() {
    return getPropertyCallableRef('y', 1, KMutableProperty1, function (receiver) {
      return receiver._get_y__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_y__okcceq_k$(value);
    });
  }
  function scale$factory() {
    return getPropertyCallableRef('scale', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scale__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_scale__okcceq_k$(value);
    });
  }
  function scaleX$factory() {
    return getPropertyCallableRef('scaleX', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scaleX__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_scaleX__okcceq_k$(value);
    });
  }
  function scaleY$factory() {
    return getPropertyCallableRef('scaleY', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scaleY__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_scaleY__okcceq_k$(value);
    });
  }
  function _no_name_provided_$factory_387() {
    var i = new _no_name_provided__446();
    return function (p1) {
      return i.invoke_upazaj_k$(p1);
    };
  }
  function _no_name_provided_$factory_388() {
    var i = new _no_name_provided__447();
    return function (p1) {
      return i.invoke_t4xgxb_k$(p1);
    };
  }
  function width$delegate$init$() {
    var tmp = scaledWidth$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function height$delegate$init$() {
    var tmp = scaledHeight$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function x$delegate$init$() {
    var tmp = x$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function y$delegate$init$() {
    var tmp = y$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function scale$delegate$init$() {
    var tmp = scale$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function scaleX$delegate$init$() {
    var tmp = scaleX$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function scaleY$delegate$init$() {
    var tmp = scaleY$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function KorgeDebugNode() {
  }
  KorgeDebugNode.$metadata$ = {
    simpleName: 'KorgeDebugNode',
    kind: 'interface',
    interfaces: []
  };
  function FontsCatalog_init_$Init$(default_0, fonts, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      fonts = HashMap_init_$Create$();
    }FontsCatalog.call($this, default_0, fonts);
    return $this;
  }
  function FontsCatalog_init_$Create$(default_0, fonts, $mask0, $marker) {
    return FontsCatalog_init_$Init$(default_0, fonts, $mask0, $marker, Object.create(FontsCatalog.prototype));
  }
  function Format_init_$Init$(parent, color_0, face, size_2, letterSpacing, kerning, align, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    if (!(($mask0 & 2) === 0))
      color_0 = null;
    if (!(($mask0 & 4) === 0))
      face = null;
    if (!(($mask0 & 8) === 0))
      size_2 = null;
    if (!(($mask0 & 16) === 0))
      letterSpacing = null;
    if (!(($mask0 & 32) === 0))
      kerning = null;
    if (!(($mask0 & 64) === 0))
      align = null;
    Format.call($this, parent, color_0, face, size_2, letterSpacing, kerning, align);
    return $this;
  }
  function Format_init_$Create$(parent, color_0, face, size_2, letterSpacing, kerning, align, $mask0, $marker) {
    return Format_init_$Init$(parent, color_0, face, size_2, letterSpacing, kerning, align, $mask0, $marker, Object.create(Format.prototype));
  }
  function _no_name_provided__448() {
  }
  _no_name_provided__448.prototype.invoke_0_k$ = function () {
    return _get_debugBmpFont_();
  };
  _no_name_provided__448.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__449() {
  }
  _no_name_provided__449.prototype.invoke_0_k$ = function () {
    return 16;
  };
  _no_name_provided__449.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__450() {
  }
  _no_name_provided__450.prototype.invoke_0_k$ = function () {
    return 0.0;
  };
  _no_name_provided__450.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__451() {
  }
  _no_name_provided__451.prototype.invoke_0_k$ = function () {
    return 0;
  };
  _no_name_provided__451.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__452() {
  }
  _no_name_provided__452.prototype.invoke_0_k$ = function () {
    return Companion_getInstance_153()._LEFT_0;
  };
  _no_name_provided__452.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PositionContext_init_$Init$(provider, bounds_0, x, y, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      x = 0.0;
    if (!(($mask0 & 8) === 0))
      y = 0.0;
    PositionContext.call($this, provider, bounds_0, x, y);
    return $this;
  }
  function PositionContext_init_$Create$(provider, bounds_0, x, y, $mask0, $marker) {
    return PositionContext_init_$Init$(provider, bounds_0, x, y, $mask0, $marker, Object.create(PositionContext.prototype));
  }
  function Line_init_$Init$(spans, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      spans = ArrayList_init_$Create$();
    }Line_0.call($this, spans);
    return $this;
  }
  function Line_init_$Create$(spans, $mask0, $marker) {
    return Line_init_$Init$(spans, $mask0, $marker, Object.create(Line_0.prototype));
  }
  function Paragraph_init_$Init$(lines_0, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      lines_0 = ArrayList_init_$Create$();
    }Paragraph.call($this, lines_0);
    return $this;
  }
  function Paragraph_init_$Create$(lines_0, $mask0, $marker) {
    return Paragraph_init_$Init$(lines_0, $mask0, $marker, Object.create(Paragraph.prototype));
  }
  function Document_init_$Init$(paragraphs, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      paragraphs = ArrayList_init_$Create$();
    }Document_0.call($this, paragraphs);
    return $this;
  }
  function Document_init_$Create$(paragraphs, $mask0, $marker) {
    return Document_init_$Init$(paragraphs, $mask0, $marker, Object.create(Document_0.prototype));
  }
  function FontsCatalog(default_0, fonts) {
    this._default_2 = default_0;
    this._fonts = fonts;
  }
  FontsCatalog.prototype.normalize_uk8unn_k$ = function (_this__0) {
    var tmp0_trim_0 = _this__0.toLowerCase();
    return toString_1(trim_0(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE()));
  };
  FontsCatalog.prototype.getBitmapFont_bgj7r1_k$ = function (name, font) {
    var tmp0_elvis_lhs = this._fonts.get_2bw_k$(this.normalize_uk8unn_k$(name));
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? font : tmp0_elvis_lhs;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this._default_2 : tmp1_elvis_lhs;
    return tmp2_elvis_lhs == null ? new SystemFont(_SystemFont___init__impl_(name)) : tmp2_elvis_lhs;
  };
  FontsCatalog.prototype.getBitmapFont$default_uzbn4x_k$ = function (name, font, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      font = null;
    return this.getBitmapFont_bgj7r1_k$(name, font);
  };
  FontsCatalog.prototype.getBitmapFont_khfkyj_k$ = function (font) {
    if (font instanceof BitmapFont)
      return font;
    else {
    }
    var fontName = this.normalize_uk8unn_k$(font._get_name__0_k$());
    var tmp = this._fonts.get_2bw_k$(fontName);
    var tmp0_safe_receiver = tmp instanceof BitmapFont ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      return tmp0_safe_receiver;
    }
    Unit_getInstance();
    var tmp_0 = this._fonts;
    var tmp1_safe_receiver = isInterface(tmp_0, MutableMap) ? tmp_0 : THROW_CCE();
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      var tmp0_getOrPut_0 = '' + fontName + '.$BitmapFont';
      var value_1 = tmp1_safe_receiver.get_2bw_k$(tmp0_getOrPut_0);
      var tmp_2;
      if (value_1 == null) {
        var answer_2 = toBitmapFont$default(font, 32.0, null, null, null, false, null, 62, null);
        tmp1_safe_receiver.put_1q9pf_k$(tmp0_getOrPut_0, answer_2);
        Unit_getInstance();
        tmp_2 = answer_2;
      } else {
        tmp_2 = value_1;
      }
      tmp_1 = tmp_2;
    }
    var tmp_3 = tmp_1;
    return tmp_3 instanceof BitmapFont ? tmp_3 : THROW_CCE();
  };
  FontsCatalog.prototype.getBounds_ldpub3_k$ = function (text, format_0, out) {
    var font = format_0._get_computedFace__0_k$();
    getBounds(this.getBitmapFont_bgj7r1_k$(font._get_name__0_k$(), font), text, format_0, out);
    Unit_getInstance();
  };
  FontsCatalog.$metadata$ = {
    simpleName: 'FontsCatalog',
    kind: 'class',
    interfaces: [MetricsProvider]
  };
  function Format(parent, color_0, face, size_2, letterSpacing, kerning, align) {
    this._parent_6 = parent;
    this._color_5 = color_0;
    this._face = face;
    this._size_18 = size_2;
    this._letterSpacing = letterSpacing;
    this._kerning = kerning;
    this._align = align;
    var tmp = this;
    var tmp_0 = face$factory();
    tmp._computedFace$delegate = new Computed(tmp_0, _no_name_provided_$factory_389());
    var tmp_1 = this;
    var tmp_2 = size$factory_1();
    tmp_1._computedSize$delegate = new Computed(tmp_2, _no_name_provided_$factory_390());
    var tmp_3 = this;
    var tmp_4 = letterSpacing$factory();
    tmp_3._computedLetterSpacing$delegate = new Computed(tmp_4, _no_name_provided_$factory_391());
    var tmp_5 = this;
    var tmp_6 = kerning$factory();
    tmp_5._computedKerning$delegate = new Computed(tmp_6, _no_name_provided_$factory_392());
    var tmp_7 = this;
    var tmp_8 = align$factory();
    tmp_7._computedAlign$delegate = new Computed(tmp_8, _no_name_provided_$factory_393());
  }
  Format.prototype._get_parent__0_k$ = function () {
    return this._parent_6;
  };
  Format.prototype._get_computedColor__12t64v_k$ = function () {
    var tmp0_safe_receiver = this._parent_6;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_computedColor__12t64v_k$();
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
      tmp = this._color_5;
    } else {
      {
        tmp = tmp1_elvis_lhs;
      }
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_1;
    var tmp_2 = tmp2_elvis_lhs;
    if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
      tmp_1 = Colors_getInstance()._WHITE_0;
    } else {
      {
        tmp_1 = tmp2_elvis_lhs;
      }
    }
    return tmp_1;
  };
  Format.prototype._get_computedFace__0_k$ = function () {
    return this._computedFace$delegate.getValue_z85e3i_k$(this, computedFace$factory());
  };
  Format.prototype._get_computedSize__0_k$ = function () {
    return this._computedSize$delegate.getValue_z85e3i_k$(this, computedSize$factory());
  };
  Format.prototype._get_computedLetterSpacing__0_k$ = function () {
    return this._computedLetterSpacing$delegate.getValue_z85e3i_k$(this, computedLetterSpacing$factory());
  };
  Format.prototype._get_computedKerning__0_k$ = function () {
    return this._computedKerning$delegate.getValue_z85e3i_k$(this, computedKerning$factory());
  };
  Format.prototype._get_computedAlign__0_k$ = function () {
    return this._computedAlign$delegate.getValue_z85e3i_k$(this, computedAlign$factory());
  };
  Format.prototype.consolidate_0_k$ = function () {
    return new Format(null, this._get_computedColor__12t64v_k$(), this._get_computedFace__0_k$(), this._get_computedSize__0_k$(), this._get_computedLetterSpacing__0_k$(), this._get_computedKerning__0_k$(), this._get_computedAlign__0_k$());
  };
  Format.prototype.toString = function () {
    var tmp = this._parent_6;
    var tmp_0 = this._color_5;
    return '' + 'Format(parent=' + tmp + ', color=' + (tmp_0 == null ? null : new RGBA(tmp_0)) + ', face=' + this._face + ', size=' + this._size_18 + ', letterSpacing=' + this._letterSpacing + ', kerning=' + this._kerning + ', align=' + this._align + ')';
  };
  Format.prototype.hashCode = function () {
    var result = this._parent_6 == null ? 0 : this._parent_6.hashCode();
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this._color_5;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      {
        tmp_0 = RGBA__hashCode_impl(this._color_5);
      }
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + (this._face == null ? 0 : hashCode(this._face)) | 0;
    result = imul(result, 31) + (this._size_18 == null ? 0 : this._size_18) | 0;
    result = imul(result, 31) + (this._letterSpacing == null ? 0 : getNumberHashCode(this._letterSpacing)) | 0;
    result = imul(result, 31) + (this._kerning == null ? 0 : this._kerning) | 0;
    result = imul(result, 31) + (this._align == null ? 0 : this._align.hashCode()) | 0;
    return result;
  };
  Format.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Format))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Format ? other : THROW_CCE();
    if (!equals_1(this._parent_6, tmp0_other_with_cast._parent_6))
      return false;
    var tmp = this._color_5;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast._color_5;
    if (!equals_1(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    else {
    }
    if (!equals_1(this._face, tmp0_other_with_cast._face))
      return false;
    if (!(this._size_18 == tmp0_other_with_cast._size_18))
      return false;
    if (!equals_1(this._letterSpacing, tmp0_other_with_cast._letterSpacing))
      return false;
    if (!(this._kerning == tmp0_other_with_cast._kerning))
      return false;
    if (!equals_1(this._align, tmp0_other_with_cast._align))
      return false;
    return true;
  };
  Format.$metadata$ = {
    simpleName: 'Format',
    kind: 'class',
    interfaces: [WithParent]
  };
  function MetricsProvider() {
  }
  MetricsProvider.$metadata$ = {
    simpleName: 'MetricsProvider',
    kind: 'interface',
    interfaces: []
  };
  function PositionContext(provider, bounds_0, x, y) {
    this._provider_0 = provider;
    this._bounds_6 = bounds_0;
    this._x_24 = x;
    this._y_23 = y;
  }
  PositionContext.prototype.toString = function () {
    return '' + 'PositionContext(provider=' + this._provider_0 + ', bounds=' + this._bounds_6 + ', x=' + this._x_24 + ', y=' + this._y_23 + ')';
  };
  PositionContext.prototype.hashCode = function () {
    var result = hashCode(this._provider_0);
    result = imul(result, 31) + this._bounds_6.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._x_24) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y_23) | 0;
    return result;
  };
  PositionContext.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PositionContext))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PositionContext ? other : THROW_CCE();
    if (!equals_1(this._provider_0, tmp0_other_with_cast._provider_0))
      return false;
    if (!this._bounds_6.equals(tmp0_other_with_cast._bounds_6))
      return false;
    if (!equals_1(this._x_24, tmp0_other_with_cast._x_24))
      return false;
    if (!equals_1(this._y_23, tmp0_other_with_cast._y_23))
      return false;
    return true;
  };
  PositionContext.$metadata$ = {
    simpleName: 'PositionContext',
    kind: 'class',
    interfaces: []
  };
  function Span(format_0, text) {
    this._format_2 = format_0;
    this._text_3 = text;
    var tmp = this;
    tmp._$$delegate_0_32 = Mixin_init_$Create$(null, 1, null);
    this._bounds_7 = Companion_getInstance_35().invoke_0_k$();
  }
  Span.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_32._set_extra__n1onou_k$(_set___);
  };
  Span.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_32._get_extra__0_k$();
  };
  Span.prototype.doPositioning_ue008l_k$ = function (ctx) {
    ctx._provider_0.getBounds_ldpub3_k$(this._text_3, this._format_2, this._bounds_7);
    var tmp0_this = this._bounds_7;
    tmp0_this._x_2 = tmp0_this._x_2 + ctx._x_24;
    var tmp1_this = ctx;
    tmp1_this._x_24 = tmp1_this._x_24 + this._bounds_7._width_0;
  };
  Span.prototype.toString = function () {
    return '' + 'Span(format=' + this._format_2 + ', text=' + this._text_3 + ')';
  };
  Span.prototype.hashCode = function () {
    var result = this._format_2.hashCode();
    result = imul(result, 31) + getStringHashCode(this._text_3) | 0;
    return result;
  };
  Span.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Span))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Span ? other : THROW_CCE();
    if (!this._format_2.equals(tmp0_other_with_cast._format_2))
      return false;
    if (!(this._text_3 === tmp0_other_with_cast._text_3))
      return false;
    return true;
  };
  Span.$metadata$ = {
    simpleName: 'Span',
    kind: 'class',
    interfaces: [Extra]
  };
  function Line_0(spans) {
    this._spans = spans;
    var tmp = this;
    tmp._$$delegate_0_33 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._format_3 = Format_init_$Create$(null, null, null, null, null, null, null, 127, null);
    this._bounds_8 = Companion_getInstance_35().invoke_0_k$();
  }
  Line_0.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_33._set_extra__n1onou_k$(_set___);
  };
  Line_0.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_33._get_extra__0_k$();
  };
  Line_0.prototype._get_firstNonEmptySpan__0_k$ = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._spans;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        var tmp0_isNotEmpty_0_4 = element_2._text_3;
        if (charSequenceLength(tmp0_isNotEmpty_0_4) > 0) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  };
  Line_0.prototype.doPositioning_ue008l_k$ = function (ctx) {
    ctx._x_24 = ctx._bounds_6._x_2;
    var tmp0_fastForEach_0 = this._spans;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      tmp1__anonymous__3.doPositioning_ue008l_k$(ctx);
    }
    var tmp2_map_0 = this._spans;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0, 10));
    var tmp0_iterator_1_2 = tmp2_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(item_2_3._bounds_7);
      Unit_getInstance();
    }
    bounds(tmp0_mapTo_0_1, this._bounds_8);
    Unit_getInstance();
    var restoreY = this._bounds_8._y_2;
    this._bounds_8.setToAnchoredRectangle_s80lk4_k$(this._bounds_8, this._format_3._get_computedAlign__0_k$()._anchor, ctx._bounds_6);
    Unit_getInstance();
    this._bounds_8._y_2 = restoreY;
    var sx = this._bounds_8._x_2;
    var tmp3_fastForEach_0 = this._spans;
    var n_1_0 = 0;
    while (n_1_0 < tmp3_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_0 = n_1_0;
      n_1_0 = tmp0_2_0 + 1 | 0;
      var tmp4__anonymous__3 = tmp3_fastForEach_0.get_ha5a7z_k$(tmp0_2_0);
      tmp4__anonymous__3._bounds_7._x_2 = sx;
      sx = sx + tmp4__anonymous__3._bounds_7._width_0;
    }
    ctx._x_24 = ctx._bounds_6._x_2;
    var tmp0_this = ctx;
    tmp0_this._y_23 = tmp0_this._y_23 + this._bounds_8._height_0;
  };
  Line_0.prototype.toString = function () {
    return '' + 'Line(spans=' + this._spans + ')';
  };
  Line_0.prototype.hashCode = function () {
    return this._spans.hashCode();
  };
  Line_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Line_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Line_0 ? other : THROW_CCE();
    if (!this._spans.equals(tmp0_other_with_cast._spans))
      return false;
    return true;
  };
  Line_0.$metadata$ = {
    simpleName: 'Line',
    kind: 'class',
    interfaces: [Extra]
  };
  function Paragraph(lines_0) {
    this._lines = lines_0;
    var tmp = this;
    tmp._$$delegate_0_34 = Mixin_init_$Create$(null, 1, null);
    this._bounds_9 = Companion_getInstance_35().invoke_0_k$();
  }
  Paragraph.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_34._set_extra__n1onou_k$(_set___);
  };
  Paragraph.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_34._get_extra__0_k$();
  };
  Paragraph.prototype._get_firstNonEmptyLine__0_k$ = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._lines;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!(element_2._get_firstNonEmptySpan__0_k$() == null)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  };
  Paragraph.prototype.doPositioning_ue008l_k$ = function (ctx) {
    var tmp0_fastForEach_0 = this._lines;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      tmp1__anonymous__3.doPositioning_ue008l_k$(ctx);
    }
    var tmp2_map_0 = this._lines;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0, 10));
    var tmp0_iterator_1_2 = tmp2_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(item_2_3._bounds_8);
      Unit_getInstance();
    }
    bounds(tmp0_mapTo_0_1, this._bounds_9);
    Unit_getInstance();
    ctx._x_24 = this._bounds_9._get_left__0_k$();
    ctx._y_23 = this._bounds_9._get_bottom__0_k$();
  };
  Paragraph.prototype.toString = function () {
    return '' + 'Paragraph(lines=' + this._lines + ')';
  };
  Paragraph.prototype.hashCode = function () {
    return this._lines.hashCode();
  };
  Paragraph.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Paragraph))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Paragraph ? other : THROW_CCE();
    if (!this._lines.equals(tmp0_other_with_cast._lines))
      return false;
    return true;
  };
  Paragraph.$metadata$ = {
    simpleName: 'Paragraph',
    kind: 'class',
    interfaces: [Extra]
  };
  function Document_0(paragraphs) {
    this._paragraphs = paragraphs;
    var tmp = this;
    tmp._$$delegate_0_35 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._defaultFormat = Format_init_$Create$(null, null, null, null, null, null, null, 127, null);
    this._xml = Xml_0('');
    this._bounds_10 = Companion_getInstance_35().invoke_0_k$();
  }
  Document_0.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_35._set_extra__n1onou_k$(_set___);
  };
  Document_0.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_35._get_extra__0_k$();
  };
  Document_0.prototype._get_firstNonEmptyParagraph__0_k$ = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._paragraphs;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!(element_2._get_firstNonEmptyLine__0_k$() == null)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  };
  Document_0.prototype._get_firstNonEmptySpan__0_k$ = function () {
    var tmp0_safe_receiver = this._get_firstNonEmptyParagraph__0_k$();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_firstNonEmptyLine__0_k$();
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_firstNonEmptySpan__0_k$();
  };
  Document_0.prototype._get_firstFormat__0_k$ = function () {
    var tmp0_safe_receiver = this._get_firstNonEmptySpan__0_k$();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._format_2;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      tmp = Format_init_$Create$(null, null, null, null, null, null, null, 127, null);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  Document_0.prototype._get_allSpans__0_k$ = function () {
    var tmp0_flatMap_0 = this._paragraphs;
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_flatMap_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      var list_3_4 = element_2_3._lines;
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    var tmp1_flatMap_0 = tmp0_flatMapTo_0_1;
    var tmp0_flatMapTo_0_1_0 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2_0 = tmp1_flatMap_0.iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var element_2_3_0 = tmp0_iterator_1_2_0.next_0_k$();
      var list_3_4_0 = element_2_3_0._spans;
      addAll(tmp0_flatMapTo_0_1_0, list_3_4_0);
      Unit_getInstance();
    }
    return tmp0_flatMapTo_0_1_0;
  };
  Document_0.prototype.doPositioning_jkszk7_k$ = function (gp, bounds_0) {
    var ctx = PositionContext_init_$Create$(gp, bounds_0, 0.0, 0.0, 12, null);
    var tmp0_fastForEach_0 = this._paragraphs;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      tmp1__anonymous__3.doPositioning_ue008l_k$(ctx);
    }
    var tmp2_map_0 = this._paragraphs;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0, 10));
    var tmp0_iterator_1_2 = tmp2_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(item_2_3._bounds_9);
      Unit_getInstance();
    }
    bounds(tmp0_mapTo_0_1, this._bounds_10);
    Unit_getInstance();
  };
  Document_0.prototype.toString = function () {
    return '' + 'Document(paragraphs=' + this._paragraphs + ')';
  };
  Document_0.prototype.hashCode = function () {
    return this._paragraphs.hashCode();
  };
  Document_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Document_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Document_0 ? other : THROW_CCE();
    if (!this._paragraphs.equals(tmp0_other_with_cast._paragraphs))
      return false;
    return true;
  };
  Document_0.$metadata$ = {
    simpleName: 'Document',
    kind: 'class',
    interfaces: [Extra]
  };
  function HtmlParser(fontsCatalog) {
    this._fontsCatalog_0 = fontsCatalog;
    var tmp = this;
    tmp._document = Document_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._currentLine_0 = Line_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._currentParagraph = Paragraph_init_$Create$(null, 1, null);
  }
  HtmlParser.prototype._get_isDisplayBlock__lng39f_k$ = function (_this__0) {
    return _this__0._name_11 === 'p' ? true : _this__0._name_11 === 'div';
  };
  HtmlParser.prototype.emitText_jmsb8x_k$ = function (format_0, text) {
    if (this._currentLine_0._spans.isEmpty_0_k$()) {
      var tmp = this._currentLine_0;
      tmp._format_3 = Format_init_$Create$(format_0, null, null, null, null, null, null, 126, null);
    }var tmp0_this = this._currentLine_0;
    var tmp0_plusAssign_0 = tmp0_this._spans;
    var tmp1_plusAssign_0 = new Span(Format_init_$Create$(format_0, null, null, null, null, null, null, 126, null), text);
    tmp0_plusAssign_0.add_2bq_k$(tmp1_plusAssign_0);
    Unit_getInstance();
  };
  HtmlParser.prototype.emitEndOfLine_931uz4_k$ = function (format_0) {
    var tmp0_isNotEmpty_0 = this._currentLine_0._spans;
    if (!tmp0_isNotEmpty_0.isEmpty_0_k$()) {
      var tmp0_this = this._currentParagraph;
      var tmp1_plusAssign_0 = tmp0_this._lines;
      var tmp2_plusAssign_0 = this._currentLine_0;
      tmp1_plusAssign_0.add_2bq_k$(tmp2_plusAssign_0);
      Unit_getInstance();
      var tmp1_this = this._document;
      var tmp3_plusAssign_0 = tmp1_this._paragraphs;
      var tmp4_plusAssign_0 = this._currentParagraph;
      tmp3_plusAssign_0.add_2bq_k$(tmp4_plusAssign_0);
      Unit_getInstance();
      var tmp = this;
      tmp._currentParagraph = Paragraph_init_$Create$(null, 1, null);
      var tmp_0 = this;
      tmp_0._currentLine_0 = Line_init_$Create$(null, 1, null);
    } else {
    }
  };
  HtmlParser.prototype.parse_i9co28_k$ = function (xml, format_0) {
    if (_get_isText_(xml)) {
      this.emitText_jmsb8x_k$(format_0, xml._get_text__0_k$());
    } else if (_get_isComment_(xml))
      Unit_getInstance();
    else if (_get_isNode_(xml)) {
      var block = this._get_isDisplayBlock__lng39f_k$(xml);
      var tmp = format_0;
      var tmp0_toLowerCase_0 = xml.str$default_877n1b_k$('align', null, 2, null);
      var tmp0_subject = tmp0_toLowerCase_0.toLowerCase();
      switch (tmp0_subject) {
        case 'center':
          tmp._align = Companion_getInstance_153()._CENTER_0;
          break;
        case 'left':
          tmp._align = Companion_getInstance_153()._LEFT_0;
          break;
        case 'right':
          tmp._align = Companion_getInstance_153()._RIGHT_0;
          break;
        case 'jusitifed':
          tmp._align = Companion_getInstance_153()._JUSTIFIED;
          break;
        default:tmp._align = format_0._align;
          break;
      }
      var face = xml.strNull_6wfw3l_k$('face');
      var tmp_0 = format_0;
      var tmp_1;
      if (!(face == null)) {
        tmp_1 = this._fontsCatalog_0.getBitmapFont$default_uzbn4x_k$(face, null, 2, null);
      } else {
        tmp_1 = format_0._face;
      }
      tmp_0._face = tmp_1;
      var tmp_2 = format_0;
      var tmp1_elvis_lhs = xml.intNull_6wfw3l_k$('size');
      tmp_2._size_18 = tmp1_elvis_lhs == null ? format_0._size_18 : tmp1_elvis_lhs;
      var tmp_3 = format_0;
      var tmp2_elvis_lhs = xml.doubleNull_6wfw3l_k$('letterSpacing');
      tmp_3._letterSpacing = tmp2_elvis_lhs == null ? format_0._letterSpacing : tmp2_elvis_lhs;
      var tmp_4 = format_0;
      var tmp3_elvis_lhs = xml.intNull_6wfw3l_k$('kerning');
      tmp_4._kerning = tmp3_elvis_lhs == null ? format_0._kerning : tmp3_elvis_lhs;
      var tmp_5 = format_0;
      var tmp_6 = Colors_getInstance();
      var tmp4_elvis_lhs = xml.strNull_6wfw3l_k$('color');
      tmp_5._color_5 = tmp_6.get_xr0bn6_k$(tmp4_elvis_lhs == null ? 'white' : tmp4_elvis_lhs);
      var tmp1_fastForEach_0 = xml._get_allChildrenNoComments__0_k$();
      var n_1 = 0;
      while (n_1 < tmp1_fastForEach_0._get_size__0_k$()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp2__anonymous__3 = tmp1_fastForEach_0.get_ha5a7z_k$(tmp0_2);
        this.parse_i9co28_k$(tmp2__anonymous__3, Format_init_$Create$(format_0, null, null, null, null, null, null, 126, null));
        Unit_getInstance();
      }
      if (block) {
        this.emitEndOfLine_931uz4_k$(format_0);
      }}return format_0;
  };
  HtmlParser.prototype.parse_a4enbm_k$ = function (html) {
    var xml = Xml_0(html);
    this._document._xml = xml;
    var format_0 = this.parse_i9co28_k$(xml, this._document._defaultFormat);
    this.emitEndOfLine_931uz4_k$(format_0);
  };
  HtmlParser.$metadata$ = {
    simpleName: 'HtmlParser',
    kind: 'class',
    interfaces: []
  };
  function Html() {
    Html_instance = this;
    var tmp = this;
    tmp._DefaultFontsCatalog = new FontsCatalog(null, emptyMap());
  }
  Html.prototype.parse_yph680_k$ = function (html, fontsCatalog) {
    var tmp0_apply_0 = new HtmlParser(fontsCatalog);
    tmp0_apply_0.parse_a4enbm_k$(html);
    return tmp0_apply_0._document;
  };
  Html.$metadata$ = {
    simpleName: 'Html',
    kind: 'object',
    interfaces: []
  };
  var Html_instance;
  function Html_getInstance() {
    if (Html_instance == null)
      new Html();
    return Html_instance;
  }
  function face$factory() {
    return getPropertyCallableRef('face', 1, KMutableProperty1, function (receiver) {
      return receiver._face;
    }, function (receiver_0, value) {
      receiver_0._face = value;
      return Unit_getInstance();
    });
  }
  function size$factory_1() {
    return getPropertyCallableRef('size', 1, KMutableProperty1, function (receiver) {
      return receiver._size_18;
    }, function (receiver_0, value) {
      receiver_0._size_18 = value;
      return Unit_getInstance();
    });
  }
  function letterSpacing$factory() {
    return getPropertyCallableRef('letterSpacing', 1, KMutableProperty1, function (receiver) {
      return receiver._letterSpacing;
    }, function (receiver_0, value) {
      receiver_0._letterSpacing = value;
      return Unit_getInstance();
    });
  }
  function kerning$factory() {
    return getPropertyCallableRef('kerning', 1, KMutableProperty1, function (receiver) {
      return receiver._kerning;
    }, function (receiver_0, value) {
      receiver_0._kerning = value;
      return Unit_getInstance();
    });
  }
  function align$factory() {
    return getPropertyCallableRef('align', 1, KMutableProperty1, function (receiver) {
      return receiver._align;
    }, function (receiver_0, value) {
      receiver_0._align = value;
      return Unit_getInstance();
    });
  }
  function computedFace$factory() {
    return getPropertyCallableRef('computedFace', 1, KProperty1, function (receiver) {
      return receiver._get_computedFace__0_k$();
    }, null);
  }
  function computedSize$factory() {
    return getPropertyCallableRef('computedSize', 1, KProperty1, function (receiver) {
      return receiver._get_computedSize__0_k$();
    }, null);
  }
  function computedLetterSpacing$factory() {
    return getPropertyCallableRef('computedLetterSpacing', 1, KProperty1, function (receiver) {
      return receiver._get_computedLetterSpacing__0_k$();
    }, null);
  }
  function computedKerning$factory() {
    return getPropertyCallableRef('computedKerning', 1, KProperty1, function (receiver) {
      return receiver._get_computedKerning__0_k$();
    }, null);
  }
  function computedAlign$factory() {
    return getPropertyCallableRef('computedAlign', 1, KProperty1, function (receiver) {
      return receiver._get_computedAlign__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_389() {
    var i = new _no_name_provided__448();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_390() {
    var i = new _no_name_provided__449();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_391() {
    var i = new _no_name_provided__450();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_392() {
    var i = new _no_name_provided__451();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_393() {
    var i = new _no_name_provided__452();
    return function () {
      return i.invoke_0_k$();
    };
  }
  var extraLanguage$delegate;
  function _no_name_provided__453() {
  }
  _no_name_provided__453.prototype.invoke_0_k$ = function () {
    return Companion_getInstance_125()._get_CURRENT__0_k$();
  };
  _no_name_provided__453.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_394() {
    var i = new _no_name_provided__453();
    return function () {
      return i.invoke_0_k$();
    };
  }
  var gamepad$delegate;
  function GamePadEvents(view) {
    this._view_4 = view;
    var tmp = this;
    tmp._gamepads_0 = GamePadUpdateEvent_init_$Create$(0, null, 3, null);
    var tmp_0 = this;
    tmp_0._updated = Signal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._stick_0 = Signal_init_$Create$(null, 1, null);
    var tmp_2 = this;
    tmp_2._button_2 = Signal_init_$Create$(null, 1, null);
    var tmp_3 = this;
    tmp_3._connection = Signal_init_$Create$(null, 1, null);
    var tmp_4 = this;
    tmp_4._oldGamepads = GamePadUpdateEvent_init_$Create$(0, null, 3, null);
    var tmp_5 = this;
    tmp_5._stickEvent = GamePadStickEvent_init_$Create$(0, null, 0.0, 0.0, 15, null);
    var tmp_6 = this;
    tmp_6._buttonEvent = GamePadButtonEvent_init_$Create$(null, 0, null, 0.0, 15, null);
  }
  GamePadEvents.prototype.onGamepadEvent_etpyjn_k$ = function (views_0, event) {
    this._views_2 = views_0;
    this._gamepads_0.copyFrom_6k410b_k$(event);
    var inductionVariable = 0;
    var last_1 = event._gamepadsLength;
    if (inductionVariable < last_1)
      do {
        var gamepadIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var gamepad = event._gamepads[gamepadIndex];
        var oldGamepad = this._oldGamepads._gamepads[gamepadIndex];
        var tmp0_fastForEach_0 = Companion_getInstance_172()._BUTTONS;
        var n_1 = 0;
        while (n_1 < tmp0_fastForEach_0.length) {
          var tmp0_2 = n_1;
          n_1 = tmp0_2 + 1 | 0;
          var tmp1__anonymous__3 = tmp0_fastForEach_0[tmp0_2];
          if (!(gamepad.get_uo5qy2_k$(tmp1__anonymous__3) === oldGamepad.get_uo5qy2_k$(tmp1__anonymous__3))) {
            var tmp0_apply_0_4 = this._buttonEvent;
            tmp0_apply_0_4._gamepad_0 = gamepad._index_28;
            tmp0_apply_0_4._type_17 = !(gamepad.get_uo5qy2_k$(tmp1__anonymous__3) === 0.0) ? Type_DOWN_getInstance_1() : Type_UP_getInstance_1();
            tmp0_apply_0_4._button_0 = tmp1__anonymous__3;
            tmp0_apply_0_4._value_26 = gamepad.get_uo5qy2_k$(tmp1__anonymous__3);
            this._button_2.invoke_iav7o_k$(tmp0_apply_0_4);
          }}
        var tmp2_fastForEach_0 = Companion_getInstance_175()._STICKS;
        var n_1_0 = 0;
        while (n_1_0 < tmp2_fastForEach_0.length) {
          var tmp0_2_0 = n_1_0;
          n_1_0 = tmp0_2_0 + 1 | 0;
          var tmp3__anonymous__3 = tmp2_fastForEach_0[tmp0_2_0];
          var vector_4 = gamepad.get_xbrkt4_k$(tmp3__anonymous__3);
          if (!vector_4.equals(oldGamepad.get_xbrkt4_k$(tmp3__anonymous__3))) {
            var tmp0_apply_0_5 = this._stickEvent;
            tmp0_apply_0_5._gamepad = gamepad._index_28;
            tmp0_apply_0_5._stick = tmp3__anonymous__3;
            tmp0_apply_0_5._x_22 = vector_4._x_1;
            tmp0_apply_0_5._y_21 = vector_4._y_1;
            this._stick_0.invoke_iav7o_k$(tmp0_apply_0_5);
          }}
      }
       while (inductionVariable < last_1);
    this._oldGamepads.copyFrom_6k410b_k$(event);
    this._updated.invoke_iav7o_k$(event);
  };
  GamePadEvents.prototype.onGamepadEvent_j2wo1a_k$ = function (views_0, event) {
    this._views_2 = views_0;
    this._connection.invoke_iav7o_k$(event);
  };
  GamePadEvents.$metadata$ = {
    simpleName: 'GamePadEvents',
    kind: 'class',
    interfaces: [GamepadComponent]
  };
  function _no_name_provided__454() {
  }
  _no_name_provided__454.prototype.invoke_upazaj_k$ = function ($this$$receiver) {
    var tmp3_getOrCreateComponent_0_1 = $this$$receiver._get_componentsSure__0_k$();
    var tmp4_getOrCreateComponent_0_2 = getKClass_0(GamePadEvents);
    var tmp1_getOrCreateComponent_0_4 = tmp3_getOrCreateComponent_0_1._get_egamepad__0_k$();
    var component_1_5 = tmp3_getOrCreateComponent_0_1.findFirstComponentOfType_3uvto2_k$(tmp1_getOrCreateComponent_0_4, tmp4_getOrCreateComponent_0_2);
    if (component_1_5 == null) {
      component_1_5 = new GamePadEvents($this$$receiver);
      var tmp0_plusAssign_0_6 = component_1_5;
      tmp1_getOrCreateComponent_0_4.add_2bq_k$(tmp0_plusAssign_0_6);
      Unit_getInstance();
    }var tmp2_fastCastTo_0_3 = component_1_5;
    return tmp2_fastCastTo_0_3;
  };
  _no_name_provided__454.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_upazaj_k$(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__454.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_395() {
    var i = new _no_name_provided__454();
    return function (p1) {
      return i.invoke_upazaj_k$(p1);
    };
  }
  function InputKeys() {
    this._pressing = booleanArray(Companion_getInstance_174()._MAX_2);
    this._pressingPrev = booleanArray(Companion_getInstance_174()._MAX_2);
    this._shift_1 = false;
    this._ctrl_0 = false;
    this._alt_0 = false;
    this._meta_0 = false;
  }
  InputKeys.prototype.get_dbfq2v_k$ = function (key) {
    return this.pressing_dbfq2v_k$(key);
  };
  InputKeys.prototype.pressing_dbfq2v_k$ = function (key) {
    return this._pressing[key._get_ordinal__0_k$()];
  };
  InputKeys.prototype.triggerKeyEvent_hkhmy8_k$ = function (e) {
    var tmp0_subject = e._type_16;
    if (tmp0_subject.equals(Type_UP_getInstance_0()))
      this._pressing[e._key_3._get_ordinal__0_k$()] = false;
    else if (tmp0_subject.equals(Type_DOWN_getInstance_0()))
      this._pressing[e._key_3._get_ordinal__0_k$()] = true;
    else
      Unit_getInstance();
    this._shift_1 = (e._shift_0 ? true : this.get_dbfq2v_k$(Key_LEFT_SHIFT_getInstance())) ? true : this.get_dbfq2v_k$(Key_RIGHT_SHIFT_getInstance());
    this._ctrl_0 = (e._ctrl ? true : this.get_dbfq2v_k$(Key_LEFT_CONTROL_getInstance())) ? true : this.get_dbfq2v_k$(Key_RIGHT_CONTROL_getInstance());
    this._alt_0 = (e._alt ? true : this.get_dbfq2v_k$(Key_LEFT_ALT_getInstance())) ? true : this.get_dbfq2v_k$(Key_RIGHT_ALT_getInstance());
    this._meta_0 = e._meta ? true : this.get_dbfq2v_k$(Key_META_getInstance());
  };
  InputKeys.prototype.startFrame_zah5t7_k$ = function (delta_0) {
  };
  InputKeys.prototype.endFrame_zah5t7_k$ = function (delta_0) {
    arraycopy_7(this._pressing, 0, this._pressingPrev, 0, this._pressing.length);
  };
  InputKeys.$metadata$ = {
    simpleName: 'InputKeys',
    kind: 'class',
    interfaces: []
  };
  function Companion_197() {
    Companion_instance_196 = this;
    this._KEYCODES = 256;
  }
  Companion_197.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_196;
  function Companion_getInstance_196() {
    if (Companion_instance_196 == null)
      new Companion_197();
    return Companion_instance_196;
  }
  function endFrameOldKeys($this, delta_0) {
    var inductionVariable = 0;
    Companion_getInstance_196();
    var last_1 = 256;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var prev = $this._keysRawPrev[n];
        var curr = $this._keysRaw[n];
        $this._keysJustReleased[n] = prev ? !curr : false;
        $this._keysJustPressed[n] = !prev ? curr : false;
        if (curr) {
          var tmp1_array = $this._keysPressingTime;
          var tmp2_index0 = n;
          tmp1_array[tmp2_index0] = tmp1_array[tmp2_index0] + _TimeSpan___get_nanoseconds__impl_(delta_0);
        } else {
          $this._keysPressingTime[n] = 0.0;
          $this._keysLastTimeTriggered[n] = 0.0;
        }
        var triggerPress = false;
        var tmp0__get_nanoseconds__0 = $this._keysPressingTime[n];
        var pressingTime = Companion_getInstance_92().fromNanoseconds_ttklb2_k$(tmp0__get_nanoseconds__0);
        if ($this._keysPressingTime[n] > 0.0) {
          var tmp3_subject = _TimeSpan___get_milliseconds__impl_(pressingTime);
          var tmp;
          if (0.0 <= tmp3_subject ? tmp3_subject <= 1.0 : false) {
            tmp = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
          } else if (1.0 <= tmp3_subject ? tmp3_subject <= 300.0 : false) {
            tmp = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(100.0);
          } else if (300.0 <= tmp3_subject ? tmp3_subject <= 1000.0 : false) {
            tmp = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(50.0);
          } else {
            tmp = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(20.0);
          }
          var timeBarrier = tmp;
          var tmp1__get_nanoseconds__0 = $this._keysLastTimeTriggered[n];
          var elapsedTime = TimeSpan__minus_impl(pressingTime, Companion_getInstance_92().fromNanoseconds_ttklb2_k$(tmp1__get_nanoseconds__0));
          if (TimeSpan__compareTo_impl(elapsedTime, timeBarrier) >= 0) {
            triggerPress = true;
          }}if (triggerPress) {
          $this._keysLastTimeTriggered[n] = $this._keysPressingTime[n];
        }$this._keysPressing[n] = triggerPress;
      }
       while (inductionVariable < last_1);
    Companion_getInstance_196();
    arraycopy_7($this._keysRaw, 0, $this._keysRawPrev, 0, 256);
  }
  function _no_name_provided__455() {
  }
  _no_name_provided__455.prototype.invoke_0_k$ = function () {
    return AGOpenglFactory_getInstance()._get_isTouchDevice__0_k$();
  };
  _no_name_provided__455.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Input() {
    Companion_getInstance_196();
    var tmp = this;
    tmp._$$delegate_0_36 = Mixin_init_$Create$(null, 1, null);
    this._dummyTouch = Companion_getInstance_170()._dummy_2;
    var tmp_0 = this;
    tmp_0._touch_0 = TouchEvent_init_$Create$(null, 0, null, false, false, 31, null);
    var tmp_1 = this;
    tmp_1.__isTouchDeviceGen = _no_name_provided_$factory_396();
    var tmp_2 = this;
    tmp_2._clickTime = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(400.0);
    this._clickDistance = 20.0;
    this._mouse_0 = new Point(-1000.0, -1000.0);
    this._mouseDown = new Point(-1000.0, -1000.0);
    this._mouseButtons_0 = 0;
    this._mouseOutside = false;
    this._mouseInside = true;
    this._clicked = false;
    this._keys_0 = new InputKeys();
    var tmp_3 = this;
    Companion_getInstance_196();
    tmp_3._keysRaw = booleanArray(256);
    var tmp_4 = this;
    Companion_getInstance_196();
    tmp_4._keysRawPrev = booleanArray(256);
    var tmp_5 = this;
    Companion_getInstance_196();
    tmp_5._keysPressingTime = new Float64Array(256);
    var tmp_6 = this;
    Companion_getInstance_196();
    tmp_6._keysLastTimeTriggered = new Float64Array(256);
    var tmp_7 = this;
    Companion_getInstance_196();
    tmp_7._keysPressing = booleanArray(256);
    var tmp_8 = this;
    Companion_getInstance_196();
    tmp_8._keysJustPressed = booleanArray(256);
    var tmp_9 = this;
    Companion_getInstance_196();
    tmp_9._keysJustReleased = booleanArray(256);
    var tmp_10 = this;
    var tmp0_map_0 = until(0, 8);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var inductionVariable = tmp0_map_0._get_first__0_k$();
    var last_1 = tmp0_map_0._get_last__0_k$();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_mapTo_0_1.add_2bq_k$(GamepadInfo_init_$Create$(item_2_3, false, null, null, null, 0, null, 0, 0, 510, null));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    var tmp1_toTypedArray_0 = tmp0_mapTo_0_1;
    tmp_10._gamepads_1 = copyToArray_0(tmp1_toTypedArray_0);
    var tmp_11 = this;
    tmp_11._connectedGamepads = ArrayList_init_$Create$();
  }
  Input.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_36._set_extra__n1onou_k$(_set___);
  };
  Input.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_36._get_extra__0_k$();
  };
  Input.prototype.updateTouches_kaxwi8_k$ = function (touchEvent_0) {
    this._touch_0.copyFrom_kaxwi8_k$(touchEvent_0);
  };
  Input.prototype.toggleButton_qwimd4_k$ = function (button, down) {
    this._mouseButtons_0 = setBits(this._mouseButtons_0, button._bits_2, down);
  };
  Input.prototype.updateConnectedGamepads_sv8swh_k$ = function () {
    this._connectedGamepads.clear_sv8swh_k$();
    var tmp0_fastForEach_0 = this._gamepads_1;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0.length) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0[tmp0_2];
      if (tmp1__anonymous__3._connected) {
        var tmp0_this_4 = this;
        var tmp0_plusAssign_0_5 = tmp0_this_4._connectedGamepads;
        tmp0_plusAssign_0_5.add_2bq_k$(tmp1__anonymous__3);
        Unit_getInstance();
      }}
  };
  Input.prototype.setKey_hwwcoo_k$ = function (keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this._keysRaw.length - 1 | 0) : false)
      this._keysRaw[pKeyCode] = b;
  };
  Input.prototype.startFrame_zah5t7_k$ = function (delta_0) {
    var tmp0_safe_receiver = this._get_extra__0_k$();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.clear();
    }
    this._keys_0.startFrame_zah5t7_k$(delta_0);
  };
  Input.prototype.endFrame_zah5t7_k$ = function (delta_0) {
    this._clicked = false;
    this._keys_0.endFrame_zah5t7_k$(delta_0);
    endFrameOldKeys(this, delta_0);
  };
  Input.prototype.triggerOldKeyEvent_hkhmy8_k$ = function (e) {
    var tmp0_subject = e._type_16;
    if (tmp0_subject.equals(Type_DOWN_getInstance_0())) {
      this.setKey_hwwcoo_k$(e._keyCode, true);
    } else if (tmp0_subject.equals(Type_UP_getInstance_0())) {
      this.setKey_hwwcoo_k$(e._keyCode, false);
    } else if (tmp0_subject.equals(Type_TYPE_getInstance())) {
    }};
  Input.$metadata$ = {
    simpleName: 'Input',
    kind: 'class',
    interfaces: [Extra]
  };
  function _no_name_provided_$factory_396() {
    var i = new _no_name_provided__455();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _get_keys_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = keys$factory();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = keys$delegate._name_1;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = keys$delegate._defaultGen_0(_this_);
        if (_this_._get_extra__0_k$() == null)
          _this_._set_extra__n1onou_k$(ExtraTypeCreate());
        var tmp1_safe_receiver_1_7 = _this_._get_extra__0_k$();
        if (tmp1_safe_receiver_1_7 == null)
          null;
        else {
          var tmp0_elvis_lhs_2_9 = keys$delegate._name_1;
          var tmp2_set_0_8 = tmp0_elvis_lhs_2_9 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_2_9;
          var tmp3_set_0_10 = r_6;
          tmp1_safe_receiver_1_7.set(tmp2_set_0_8, tmp3_set_0_10);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var keys$delegate;
  function _no_name_provided__456(this$0, $event, resultContinuation) {
    this._this$0_127 = this$0;
    this._$event = $event;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__456.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__456.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__456.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_127._onKeyTyped.invoke_iav7o_k$(this._$event, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__456.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__456(this._this$0_127, this._$event, completion);
    return i;
  };
  _no_name_provided__456.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__457(this$0, $event, resultContinuation) {
    this._this$0_128 = this$0;
    this._$event_0 = $event;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__457.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__457.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__457.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_128._onKeyDown.invoke_iav7o_k$(this._$event_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__457.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__457(this._this$0_128, this._$event_0, completion);
    return i;
  };
  _no_name_provided__457.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__458(this$0, $event, resultContinuation) {
    this._this$0_129 = this$0;
    this._$event_1 = $event;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__458.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__458.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__458.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_129._onKeyUp.invoke_iav7o_k$(this._$event_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__458.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__458(this._this$0_129, this._$event_1, completion);
    return i;
  };
  _no_name_provided__458.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function KeysEvents(view) {
    this._view_5 = view;
    var tmp = this;
    tmp._onKeyDown = AsyncSignal_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._onKeyUp = AsyncSignal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._onKeyTyped = AsyncSignal_init_$Create$(null, 1, null);
  }
  KeysEvents.prototype.onKeyEvent_m6zpgk_k$ = function (_this__0, event) {
    this._views_3 = _this__0;
    var tmp0_subject = event._type_16;
    if (tmp0_subject.equals(Type_TYPE_getInstance())) {
      launchImmediately(_this__0._views_18._coroutineContext_6, _no_name_provided_$factory_398(this, event, null));
      Unit_getInstance();
    } else if (tmp0_subject.equals(Type_DOWN_getInstance_0())) {
      launchImmediately(_this__0._views_18._coroutineContext_6, _no_name_provided_$factory_399(this, event, null));
      Unit_getInstance();
    } else if (tmp0_subject.equals(Type_UP_getInstance_0())) {
      launchImmediately(_this__0._views_18._coroutineContext_6, _no_name_provided_$factory_400(this, event, null));
      Unit_getInstance();
    }};
  KeysEvents.$metadata$ = {
    simpleName: 'KeysEvents',
    kind: 'class',
    interfaces: [KeyComponent]
  };
  function _no_name_provided__459() {
  }
  _no_name_provided__459.prototype.invoke_upazaj_k$ = function ($this$$receiver) {
    var tmp3_getOrCreateComponent_0_1 = $this$$receiver._get_componentsSure__0_k$();
    var tmp4_getOrCreateComponent_0_2 = getKClass_0(KeysEvents);
    var tmp1_getOrCreateComponent_0_4 = tmp3_getOrCreateComponent_0_1._get_ekey__0_k$();
    var component_1_5 = tmp3_getOrCreateComponent_0_1.findFirstComponentOfType_3uvto2_k$(tmp1_getOrCreateComponent_0_4, tmp4_getOrCreateComponent_0_2);
    if (component_1_5 == null) {
      component_1_5 = new KeysEvents($this$$receiver);
      var tmp0_plusAssign_0_6 = component_1_5;
      tmp1_getOrCreateComponent_0_4.add_2bq_k$(tmp0_plusAssign_0_6);
      Unit_getInstance();
    }var tmp2_fastCastTo_0_3 = component_1_5;
    return tmp2_fastCastTo_0_3;
  };
  _no_name_provided__459.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_upazaj_k$(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__459.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function keys$factory() {
    return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
      return _get_keys_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_397() {
    var i = new _no_name_provided__459();
    return function (p1) {
      return i.invoke_upazaj_k$(p1);
    };
  }
  function _no_name_provided_$factory_398(this$0, $event, resultContinuation) {
    var i = new _no_name_provided__456(this$0, $event, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_399(this$0, $event, resultContinuation) {
    var i = new _no_name_provided__457(this$0, $event, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_400(this$0, $event, resultContinuation) {
    var i = new _no_name_provided__458(this$0, $event, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _get_mouse_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = mouse$factory();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = mouse$delegate._name_1;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = mouse$delegate._defaultGen_0(_this_);
        if (_this_._get_extra__0_k$() == null)
          _this_._set_extra__n1onou_k$(ExtraTypeCreate());
        var tmp1_safe_receiver_1_7 = _this_._get_extra__0_k$();
        if (tmp1_safe_receiver_1_7 == null)
          null;
        else {
          var tmp0_elvis_lhs_2_9 = mouse$delegate._name_1;
          var tmp2_set_0_8 = tmp0_elvis_lhs_2_9 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_2_9;
          var tmp3_set_0_10 = r_6;
          tmp1_safe_receiver_1_7.set(tmp2_set_0_8, tmp3_set_0_10);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var mouse$delegate;
  function _set_cursor_(_this_, _set___) {
    var tmp0_setValue_0 = cursor$factory();
    var tmp0_elvis_lhs_1 = cursor$delegate._name_0;
    var tmp = tmp0_elvis_lhs_1 == null ? tmp0_setValue_0.callableName : tmp0_elvis_lhs_1;
    return setExtra(_this_, tmp, _set___);
  }
  function _get_cursor_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = cursor$factory_0();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = cursor$delegate._name_0;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = cursor$delegate._defaultGen();
        var tmp0_elvis_lhs_1_7 = cursor$delegate._name_0;
        var tmp_0 = tmp0_elvis_lhs_1_7 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_1_7;
        setExtra(_this_, tmp_0, r_6);
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var cursor$delegate;
  function mouseHitTest($this, views_0) {
    if (!$this._get_mouseHitSearch__7scsin_k$(views_0._input_3)) {
      $this._set_mouseHitSearch__rw7i5m_k$(views_0._input_3, true);
      $this._set_mouseHitResult__y1442g_k$(views_0._input_3, views_0._stage_0.mouseHitTest_ngl742_k$(views_0._get_nativeMouseX__0_k$(), views_0._get_nativeMouseY__0_k$()));
      var view = $this._get_mouseHitResult__7scsin_k$(views_0._input_3);
      $l$break: while (!(view == null)) {
        if (!(_get_cursor_(view) == null)) {
          break $l$break;
        }view = view._get_parent__0_k$();
      }
      var tmp0_safe_receiver = view;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : _get_cursor_(tmp0_safe_receiver);
      var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
      if (!equals_1(views_0._gameWindow_1._get_cursor__0_k$(), newCursor)) {
        views_0._gameWindow_1._set_cursor__gde21z_k$(newCursor);
      }}return $this._get_mouseHitResult__7scsin_k$(views_0._input_3);
  }
  function _no_name_provided__460() {
  }
  _no_name_provided__460.prototype.invoke_0_k$ = function () {
    return false;
  };
  _no_name_provided__460.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__461() {
  }
  _no_name_provided__461.prototype.invoke_0_k$ = function () {
    return null;
  };
  _no_name_provided__461.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__462() {
  }
  _no_name_provided__462.prototype.invoke_0_k$ = function () {
    return null;
  };
  _no_name_provided__462.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__463() {
  }
  _no_name_provided__463.prototype.invoke_0_k$ = function () {
    return new Once();
  };
  _no_name_provided__463.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__464($views) {
    this._$views_13 = $views;
  }
  _no_name_provided__464.prototype.invoke_8ltlll_k$ = function ($this$null, ctx) {
    var scale_2_5 = ctx._ag_5._get_devicePixelRatio__0_k$();
    var yy_3_6 = 60.0 * scale_2_5;
    var lineHeight_4_7 = 8.0 * scale_2_5;
    var mouseHit_5_8 = mouseHitTest(Companion_getInstance_197(), this._$views_13);
    if (!(mouseHit_5_8 == null)) {
      var bounds_6_9 = mouseHit_5_8.getLocalBoundsOptimizedAnchored_0_k$();
      var tmp2_useBatcher_0_7_10 = $this$null._renderContext;
      var tmp1_use_0_8_11 = tmp2_useBatcher_0_7_10._batch_0;
      var tmp0_useBatcher_0_9_12 = tmp1_use_0_8_11._ctx_6;
      if (!(tmp0_useBatcher_0_9_12._currentBatcher === tmp1_use_0_8_11)) {
        tmp0_useBatcher_0_9_12.flush_sv8swh_k$();
        tmp0_useBatcher_0_9_12._currentBatcher = tmp1_use_0_8_11;
      }var tmp0__get_white__0_3_11_14 = Bitmaps_getInstance();
      var tmp0_tex_2_10_13 = ctx.getTex_uoiv7r_k$(Bitmaps_white);
      var tmp1_x_4_12_15 = bounds_6_9._x_2;
      var tmp2_y_5_13_16 = bounds_6_9._y_2;
      var tmp3_width_6_14_17 = bounds_6_9._width_0;
      var tmp4_height_7_15_18 = bounds_6_9._height_0;
      var tmp5_colorMul_8_16_19 = Companion_getInstance_136().invoke_fnl2i9_k$(255, 0, 0, 63);
      var tmp6_m_9_17_20 = mouseHit_5_8._get_globalMatrix__0_k$();
      tmp1_use_0_8_11.drawQuad$default_r2v3rq_k$(tmp0_tex_2_10_13, tmp1_x_4_12_15, tmp2_y_5_13_16, tmp3_width_6_14_17, tmp4_height_7_15_18, tmp6_m_9_17_20, false, tmp5_colorMul_8_16_19, null, null, null, 1856, null);
      var tmp = _get_debugBmpFont_();
      var tmp_0 = lineHeight_4_7;
      var tmp_1 = mouseHit_5_8.toString() + ' : ' + this._$views_13._get_nativeMouseX__0_k$() + ',' + this._$views_13._get_nativeMouseY__0_k$();
      var tmp_2 = numberToInt(yy_3_6);
      drawText$default_0($this$null._renderContext, tmp, tmp_0, tmp_1, 0, tmp_2, null, null, null, null, false, 992, null);
      yy_3_6 = yy_3_6 + lineHeight_4_7;
    }var mouseHitResultUsed_18_21 = Companion_getInstance_197()._get_mouseHitResultUsed__7scsin_k$($this$null._input_3);
    if (!(mouseHitResultUsed_18_21 == null)) {
      var bounds_19_22 = mouseHitResultUsed_18_21.getLocalBoundsOptimizedAnchored_0_k$();
      var tmp5_useBatcher_0_20_23 = $this$null._renderContext;
      var tmp4_use_0_21_24 = tmp5_useBatcher_0_20_23._batch_0;
      var tmp3_useBatcher_0_22_25 = tmp4_use_0_21_24._ctx_6;
      if (!(tmp3_useBatcher_0_22_25._currentBatcher === tmp4_use_0_21_24)) {
        tmp3_useBatcher_0_22_25.flush_sv8swh_k$();
        tmp3_useBatcher_0_22_25._currentBatcher = tmp4_use_0_21_24;
      }var tmp0__get_white__0_3_24_27 = Bitmaps_getInstance();
      var tmp0_tex_2_23_26 = ctx.getTex_uoiv7r_k$(Bitmaps_white);
      var tmp1_x_4_25_28 = bounds_19_22._x_2;
      var tmp2_y_5_26_29 = bounds_19_22._y_2;
      var tmp3_width_6_27_30 = bounds_19_22._width_0;
      var tmp4_height_7_28_31 = bounds_19_22._height_0;
      var tmp5_colorMul_8_29_32 = Companion_getInstance_136().invoke_fnl2i9_k$(0, 0, 255, 63);
      var tmp6_m_9_30_33 = mouseHitResultUsed_18_21._get_globalMatrix__0_k$();
      tmp4_use_0_21_24.drawQuad$default_r2v3rq_k$(tmp0_tex_2_23_26, tmp1_x_4_25_28, tmp2_y_5_26_29, tmp3_width_6_27_30, tmp4_height_7_28_31, tmp6_m_9_30_33, false, tmp5_colorMul_8_29_32, null, null, null, 1856, null);
      var vview_10_31_34 = mouseHitResultUsed_18_21;
      while (!(vview_10_31_34 == null)) {
        var tmp_3 = _get_debugBmpFont_();
        var tmp_4 = lineHeight_4_7;
        var tmp_5 = vview_10_31_34.toString();
        var tmp_6 = numberToInt(yy_3_6);
        drawText$default_0($this$null._renderContext, tmp_3, tmp_4, tmp_5, 0, tmp_6, null, null, null, null, false, 992, null);
        var tmp7_safe_receiver_11_32_35 = vview_10_31_34;
        vview_10_31_34 = tmp7_safe_receiver_11_32_35 == null ? null : tmp7_safe_receiver_11_32_35._get_parent__0_k$();
        yy_3_6 = yy_3_6 + lineHeight_4_7;
      }
    }};
  _no_name_provided__464.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Views ? p1 : THROW_CCE();
    this.invoke_8ltlll_k$(tmp, p2 instanceof RenderContext ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__464.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_198() {
    Companion_instance_197 = this;
    var tmp = this;
    tmp._mouseHitSearch$delegate = Property_init_$Create$(null, _no_name_provided_$factory_403(), 1, null);
    var tmp_0 = this;
    tmp_0._mouseHitResult$delegate = Property_init_$Create$(null, _no_name_provided_$factory_404(), 1, null);
    var tmp_1 = this;
    tmp_1._mouseHitResultUsed$delegate = Property_init_$Create$(null, _no_name_provided_$factory_405(), 1, null);
    var tmp_2 = this;
    tmp_2._mouseDebugHandlerOnce$delegate = Property_init_$Create$(null, _no_name_provided_$factory_406(), 1, null);
  }
  Companion_198.prototype._set_mouseHitSearch__rw7i5m_k$ = function (_this__0, _set___) {
    var tmp0_setValue_0 = mouseHitSearch$factory();
    var tmp0_elvis_lhs_1 = this._mouseHitSearch$delegate._name_0;
    var tmp = tmp0_elvis_lhs_1 == null ? tmp0_setValue_0.callableName : tmp0_elvis_lhs_1;
    return setExtra(_this__0, tmp, _set___);
  };
  Companion_198.prototype._get_mouseHitSearch__7scsin_k$ = function (_this__0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = mouseHitSearch$factory_0();
      var tmp1_safe_receiver_3 = _this__0._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = this._mouseHitSearch$delegate._name_0;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = this._mouseHitSearch$delegate._defaultGen();
        var tmp0_elvis_lhs_1_7 = this._mouseHitSearch$delegate._name_0;
        var tmp_0 = tmp0_elvis_lhs_1_7 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_1_7;
        setExtra(_this__0, tmp_0, r_6);
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  };
  Companion_198.prototype._set_mouseHitResult__y1442g_k$ = function (_this__0, _set___) {
    var tmp0_setValue_0 = mouseHitResult$factory();
    var tmp0_elvis_lhs_1 = this._mouseHitResult$delegate._name_0;
    var tmp = tmp0_elvis_lhs_1 == null ? tmp0_setValue_0.callableName : tmp0_elvis_lhs_1;
    return setExtra(_this__0, tmp, _set___);
  };
  Companion_198.prototype._get_mouseHitResult__7scsin_k$ = function (_this__0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = mouseHitResult$factory_0();
      var tmp1_safe_receiver_3 = _this__0._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = this._mouseHitResult$delegate._name_0;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = this._mouseHitResult$delegate._defaultGen();
        var tmp0_elvis_lhs_1_7 = this._mouseHitResult$delegate._name_0;
        var tmp_0 = tmp0_elvis_lhs_1_7 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_1_7;
        setExtra(_this__0, tmp_0, r_6);
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  };
  Companion_198.prototype._set_mouseHitResultUsed__y1442g_k$ = function (_this__0, _set___) {
    var tmp0_setValue_0 = mouseHitResultUsed$factory();
    var tmp0_elvis_lhs_1 = this._mouseHitResultUsed$delegate._name_0;
    var tmp = tmp0_elvis_lhs_1 == null ? tmp0_setValue_0.callableName : tmp0_elvis_lhs_1;
    return setExtra(_this__0, tmp, _set___);
  };
  Companion_198.prototype._get_mouseHitResultUsed__7scsin_k$ = function (_this__0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = mouseHitResultUsed$factory_0();
      var tmp1_safe_receiver_3 = _this__0._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = this._mouseHitResultUsed$delegate._name_0;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = this._mouseHitResultUsed$delegate._defaultGen();
        var tmp0_elvis_lhs_1_7 = this._mouseHitResultUsed$delegate._name_0;
        var tmp_0 = tmp0_elvis_lhs_1_7 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_1_7;
        setExtra(_this__0, tmp_0, r_6);
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  };
  Companion_198.prototype._set_mouseDebugHandlerOnce__no9o2n_k$ = function (_this__0, _set___) {
    var tmp0_setValue_0 = mouseDebugHandlerOnce$factory();
    var tmp0_elvis_lhs_1 = this._mouseDebugHandlerOnce$delegate._name_0;
    var tmp = tmp0_elvis_lhs_1 == null ? tmp0_setValue_0.callableName : tmp0_elvis_lhs_1;
    return setExtra(_this__0, tmp, _set___);
  };
  Companion_198.prototype._get_mouseDebugHandlerOnce__hzma7o_k$ = function (_this__0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = mouseDebugHandlerOnce$factory_0();
      var tmp1_safe_receiver_3 = _this__0._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = this._mouseDebugHandlerOnce$delegate._name_0;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = this._mouseDebugHandlerOnce$delegate._defaultGen();
        var tmp0_elvis_lhs_1_7 = this._mouseDebugHandlerOnce$delegate._name_0;
        var tmp_0 = tmp0_elvis_lhs_1_7 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_1_7;
        setExtra(_this__0, tmp_0, r_6);
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  };
  Companion_198.prototype.installDebugExtensionOnce_ukkq99_k$ = function (views_0) {
    var tmp0_invoke_0 = this._get_mouseDebugHandlerOnce__hzma7o_k$(views_0);
    if (!tmp0_invoke_0._completed_0) {
      tmp0_invoke_0._completed_0 = true;
      var tmp0_this_2 = views_0;
      var tmp0_plusAssign_0_3 = tmp0_this_2._debugHandlers;
      tmp0_plusAssign_0_3.add_2bq_k$(_no_name_provided_$factory_407(views_0));
      Unit_getInstance();
    }};
  Companion_198.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_197;
  function Companion_getInstance_197() {
    if (Companion_instance_197 == null)
      new Companion_198();
    return Companion_instance_197;
  }
  function MouseEventsUpdate($outer, view) {
    this._$this_28 = $outer;
    this._view_6 = view;
    var tmp = this;
    tmp._$$delegate_0_37 = Mixin_init_$Create$(null, 1, null);
  }
  MouseEventsUpdate.prototype._get_view__0_k$ = function () {
    return this._view_6;
  };
  MouseEventsUpdate.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_37._set_extra__n1onou_k$(_set___);
  };
  MouseEventsUpdate.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_37._get_extra__0_k$();
  };
  MouseEventsUpdate.prototype.update_2el4wj_k$ = function (views_0, dt) {
    this._$this_28.update_2el4wj_k$(views_0, dt);
  };
  MouseEventsUpdate.$metadata$ = {
    simpleName: 'MouseEventsUpdate',
    kind: 'class',
    interfaces: [UpdateComponentWithViews, Extra]
  };
  function temporalLastEvent($this, lastEventNew, block) {
    var old = $this._lastEvent;
    var tmp = $this;
    var tmp0_elvis_lhs = lastEventNew;
    tmp._lastEvent = tmp0_elvis_lhs == null ? $this._lastEvent : tmp0_elvis_lhs;
    try {
      return block();
    }finally {
      $this._lastEvent = old;
    }
  }
  function _no_name_provided__465($over, this$0) {
    this._$over = $over;
    this._this$0_130 = this$0;
  }
  _no_name_provided__465.prototype.invoke_sv8swh_k$ = function () {
    if (this._$over) {
      this._this$0_130._up.invoke_iav7o_k$(this._this$0_130);
    } else {
      this._this$0_130._upOutside.invoke_iav7o_k$(this._this$0_130);
      this._this$0_130._upOutsideAny.invoke_iav7o_k$(this._this$0_130);
    }
    this._this$0_130._upAnywhere.invoke_iav7o_k$(this._this$0_130);
  };
  _no_name_provided__465.prototype.invoke_0_k$ = function () {
    this.invoke_sv8swh_k$();
    return Unit_getInstance();
  };
  _no_name_provided__465.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function MouseEvents(view) {
    Companion_getInstance_197();
    this._view_7 = view;
    var tmp = this;
    tmp._$$delegate_0_38 = Mixin_init_$Create$(null, 1, null);
    this._view_7._set_mouseEnabled__rpwsgn_k$(true);
    var tmp_0 = this;
    tmp_0._click = Signal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._over = Signal_init_$Create$(null, 1, null);
    var tmp_2 = this;
    tmp_2._out_11 = Signal_init_$Create$(null, 1, null);
    var tmp_3 = this;
    tmp_3._down = Signal_init_$Create$(null, 1, null);
    var tmp_4 = this;
    tmp_4._downFromOutside = Signal_init_$Create$(null, 1, null);
    var tmp_5 = this;
    tmp_5._up = Signal_init_$Create$(null, 1, null);
    var tmp_6 = this;
    tmp_6._upOutside = Signal_init_$Create$(null, 1, null);
    var tmp_7 = this;
    tmp_7._upOutsideExit = Signal_init_$Create$(null, 1, null);
    var tmp_8 = this;
    tmp_8._upOutsideAny = Signal_init_$Create$(null, 1, null);
    var tmp_9 = this;
    tmp_9._upAnywhere = Signal_init_$Create$(null, 1, null);
    var tmp_10 = this;
    tmp_10._move = Signal_init_$Create$(null, 1, null);
    var tmp_11 = this;
    tmp_11._moveAnywhere = Signal_init_$Create$(null, 1, null);
    var tmp_12 = this;
    tmp_12._moveOutside = Signal_init_$Create$(null, 1, null);
    var tmp_13 = this;
    tmp_13._exit = Signal_init_$Create$(null, 1, null);
    var tmp_14 = this;
    tmp_14._scroll = Signal_init_$Create$(null, 1, null);
    var tmp_15 = this;
    tmp_15._scrollAnywhere = Signal_init_$Create$(null, 1, null);
    var tmp_16 = this;
    tmp_16._scrollOutside = Signal_init_$Create$(null, 1, null);
    this._hitTest = null;
    this._lastOver = false;
    this._lastInside = false;
    this._lastPressing = false;
    this._upPosTime = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
    this._downPosTime = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
    this._downPosGlobal = Companion_getInstance_32().invoke_0_k$();
    this._upPosGlobal = Companion_getInstance_32().invoke_0_k$();
    this._startedPosGlobal = Companion_getInstance_32().invoke_0_k$();
    this._lastPosGlobal = Companion_getInstance_32().invoke_0_k$();
    this._currentPosGlobal = Companion_getInstance_32().invoke_0_k$();
    this.__downPosLocal = Companion_getInstance_32().invoke_0_k$();
    this.__upPosLocal = Companion_getInstance_32().invoke_0_k$();
    this.__startedPosLocal = Companion_getInstance_32().invoke_0_k$();
    this.__lastPosLocal = Companion_getInstance_32().invoke_0_k$();
    this.__currentPosLocal = Companion_getInstance_32().invoke_0_k$();
    this.__downPosStage = Companion_getInstance_32().invoke_0_k$();
    this.__upPosStage = Companion_getInstance_32().invoke_0_k$();
    this.__startedPosStage = Companion_getInstance_32().invoke_0_k$();
    this.__lastPosStage = Companion_getInstance_32().invoke_0_k$();
    this.__currentPosStage = Companion_getInstance_32().invoke_0_k$();
    this._clickedCount = 0;
    this._lastEventSet = false;
    this._currentEvent = null;
    var tmp_17 = this;
    tmp_17._lastEvent = MouseEvent_init_$Create$(null, 0, 0, 0, null, 0, 0.0, 0.0, 0.0, false, false, false, false, false, false, 32767, null);
    var tmp_18 = this;
    tmp_18._lastEventUp = MouseEvent_init_$Create$(null, 0, 0, 0, null, 0, 0.0, 0.0, 0.0, false, false, false, false, false, false, 32767, null);
    this._updater = attach(new MouseEventsUpdate(this, this._view_7));
  }
  MouseEvents.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_38._set_extra__n1onou_k$(_set___);
  };
  MouseEvents.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_38._get_extra__0_k$();
  };
  MouseEvents.prototype._get_views__0_k$ = function () {
    var tmp = this._views_4;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  MouseEvents.prototype._get_coroutineContext__0_k$ = function () {
    return this._get_views__0_k$()._coroutineContext_6;
  };
  MouseEvents.prototype._get_isOver__0_k$ = function () {
    var tmp0_safe_receiver = this._hitTest;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this._view_7);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  MouseEvents.prototype._get_pressing__0_k$ = function () {
    return !(this._get_views__0_k$()._input_3._mouseButtons_0 === 0);
  };
  MouseEvents.prototype.toString = function () {
    return this._lastEvent.toString();
  };
  MouseEvents.prototype.onMouseEvent_ja6erc_k$ = function (views_0, event) {
    if (!this._view_7._get_mouseEnabled__0_k$())
      return Unit_getInstance();
    this._views_4 = views_0;
    this._currentEvent = event;
    this._lastEvent.copyFrom_jl2fzq_k$(event);
    this._lastEventSet = true;
    var tmp0_subject = event._type_15;
    if (tmp0_subject.equals(Type_UP_getInstance())) {
      this._lastEventUp.copyFrom_jl2fzq_k$(event);
      this._upPosGlobal.copyFrom_ujo5kx_k$(views_0._input_3._mouse_0);
      Unit_getInstance();
      this._upPosTime = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
      var elapsedTime = TimeSpan__minus_impl(this._upPosTime, this._downPosTime);
      if (this._upPosGlobal.distanceTo_ujo5kx_k$(this._downPosGlobal) < views_0._input_3._clickDistance ? TimeSpan__compareTo_impl(elapsedTime, views_0._input_3._clickTime) < 0 : false) {
        var tmp1_this = this;
        var tmp2 = tmp1_this._clickedCount;
        tmp1_this._clickedCount = tmp2 + 1 | 0;
        Unit_getInstance();
        if (this._get_isOver__0_k$()) {
          this._click.invoke_iav7o_k$(this);
          if (this._click._get_listenerCount__0_k$() > 0) {
            preventDefault(this._view_7);
          }}}} else if (tmp0_subject.equals(Type_DOWN_getInstance())) {
      this._downPosTime = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
      this._downPosGlobal.copyFrom_ujo5kx_k$(views_0._input_3._mouse_0);
      Unit_getInstance();
    } else if (tmp0_subject.equals(Type_SCROLL_getInstance())) {
      if (this._get_isOver__0_k$()) {
        this._scroll.invoke_iav7o_k$(this);
      } else {
        this._scrollOutside.invoke_iav7o_k$(this);
      }
      this._scrollAnywhere.invoke_iav7o_k$(this);
    }};
  MouseEvents.prototype.update_2el4wj_k$ = function (views_0, dt) {
    if (!this._view_7._get_mouseEnabled__0_k$())
      return Unit_getInstance();
    this._views_4 = views_0;
    Companion_getInstance_197().installDebugExtensionOnce_ukkq99_k$(views_0);
    this._hitTest = mouseHitTest(Companion_getInstance_197(), views_0);
    var over = this._get_isOver__0_k$();
    var inside = views_0._input_3._mouseInside;
    if (over)
      Companion_getInstance_197()._set_mouseHitResultUsed__y1442g_k$(views_0._input_3, this._view_7);
    var overChanged = !(this._lastOver === over);
    var insideChanged = !(this._lastInside === inside);
    var pressingChanged = !(this._get_pressing__0_k$() === this._lastPressing);
    this._currentPosGlobal.copyFrom_ujo5kx_k$(views_0._input_3._mouse_0);
    Unit_getInstance();
    if ((!overChanged ? over : false) ? !this._currentPosGlobal.equals(this._lastPosGlobal) : false)
      this._move.invoke_iav7o_k$(this);
    if ((!overChanged ? !over : false) ? !this._currentPosGlobal.equals(this._lastPosGlobal) : false)
      this._moveOutside.invoke_iav7o_k$(this);
    if (!this._currentPosGlobal.equals(this._lastPosGlobal))
      this._moveAnywhere.invoke_iav7o_k$(this);
    if (overChanged ? over : false) {
      this._over.invoke_iav7o_k$(this);
    }if (overChanged ? !over : false) {
      this._out_11.invoke_iav7o_k$(this);
    }if ((over ? pressingChanged : false) ? this._get_pressing__0_k$() : false) {
      this._startedPosGlobal.copyFrom_ujo5kx_k$(this._currentPosGlobal);
      Unit_getInstance();
      this._down.invoke_iav7o_k$(this);
    }if (overChanged ? this._get_pressing__0_k$() : false) {
      this._downFromOutside.invoke_iav7o_k$(this);
    }if (pressingChanged ? !this._get_pressing__0_k$() : false) {
      var tmp = this._lastEventUp;
      temporalLastEvent(this, tmp, _no_name_provided_$factory_408(over, this));
    }if (over ? this._clickedCount > 0 : false) {
    }if (insideChanged ? !inside : false) {
      this._moveOutside.invoke_iav7o_k$(this);
      this._out_11.invoke_iav7o_k$(this);
      this._upOutsideExit.invoke_iav7o_k$(this);
      this._upOutsideAny.invoke_iav7o_k$(this);
      this._exit.invoke_iav7o_k$(this);
    }this._lastOver = over;
    this._lastInside = inside;
    this._lastPressing = this._get_pressing__0_k$();
    this._lastPosGlobal.copyFrom_ujo5kx_k$(this._currentPosGlobal);
    Unit_getInstance();
    this._clickedCount = 0;
  };
  MouseEvents.$metadata$ = {
    simpleName: 'MouseEvents',
    kind: 'class',
    interfaces: [MouseComponent, Extra]
  };
  function _no_name_provided__466() {
  }
  _no_name_provided__466.prototype.invoke_upazaj_k$ = function ($this$$receiver) {
    var tmp3_getOrCreateComponent_0_1 = $this$$receiver._get_componentsSure__0_k$();
    var tmp4_getOrCreateComponent_0_2 = getKClass_0(MouseEvents);
    var tmp1_getOrCreateComponent_0_4 = tmp3_getOrCreateComponent_0_1._get_emouse__0_k$();
    var component_1_5 = tmp3_getOrCreateComponent_0_1.findFirstComponentOfType_3uvto2_k$(tmp1_getOrCreateComponent_0_4, tmp4_getOrCreateComponent_0_2);
    if (component_1_5 == null) {
      component_1_5 = new MouseEvents($this$$receiver);
      var tmp0_plusAssign_0_6 = component_1_5;
      tmp1_getOrCreateComponent_0_4.add_2bq_k$(tmp0_plusAssign_0_6);
      Unit_getInstance();
    }var tmp2_fastCastTo_0_3 = component_1_5;
    return tmp2_fastCastTo_0_3;
  };
  _no_name_provided__466.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_upazaj_k$(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__466.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__467() {
  }
  _no_name_provided__467.prototype.invoke_0_k$ = function () {
    return null;
  };
  _no_name_provided__467.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function mouse$factory() {
    return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
      return _get_mouse_(receiver);
    }, null);
  }
  function cursor$factory() {
    return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
      return _get_cursor_(receiver);
    }, function (receiver_0, value) {
      return _set_cursor_(receiver_0, value);
    });
  }
  function cursor$factory_0() {
    return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
      return _get_cursor_(receiver);
    }, function (receiver_0, value) {
      return _set_cursor_(receiver_0, value);
    });
  }
  function mouseHitSearch$factory() {
    return getPropertyCallableRef('mouseHitSearch', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitSearch__7scsin_k$(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitSearch__rw7i5m_k$(receiver2_0, value);
    });
  }
  function mouseHitSearch$factory_0() {
    return getPropertyCallableRef('mouseHitSearch', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitSearch__7scsin_k$(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitSearch__rw7i5m_k$(receiver2_0, value);
    });
  }
  function mouseHitResult$factory() {
    return getPropertyCallableRef('mouseHitResult', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitResult__7scsin_k$(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitResult__y1442g_k$(receiver2_0, value);
    });
  }
  function mouseHitResult$factory_0() {
    return getPropertyCallableRef('mouseHitResult', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitResult__7scsin_k$(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitResult__y1442g_k$(receiver2_0, value);
    });
  }
  function mouseHitResultUsed$factory() {
    return getPropertyCallableRef('mouseHitResultUsed', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitResultUsed__7scsin_k$(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitResultUsed__y1442g_k$(receiver2_0, value);
    });
  }
  function mouseHitResultUsed$factory_0() {
    return getPropertyCallableRef('mouseHitResultUsed', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitResultUsed__7scsin_k$(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitResultUsed__y1442g_k$(receiver2_0, value);
    });
  }
  function mouseDebugHandlerOnce$factory() {
    return getPropertyCallableRef('mouseDebugHandlerOnce', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseDebugHandlerOnce__hzma7o_k$(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseDebugHandlerOnce__no9o2n_k$(receiver2_0, value);
    });
  }
  function mouseDebugHandlerOnce$factory_0() {
    return getPropertyCallableRef('mouseDebugHandlerOnce', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseDebugHandlerOnce__hzma7o_k$(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseDebugHandlerOnce__no9o2n_k$(receiver2_0, value);
    });
  }
  function _no_name_provided_$factory_401() {
    var i = new _no_name_provided__466();
    return function (p1) {
      return i.invoke_upazaj_k$(p1);
    };
  }
  function _no_name_provided_$factory_402() {
    var i = new _no_name_provided__467();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_403() {
    var i = new _no_name_provided__460();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_404() {
    var i = new _no_name_provided__461();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_405() {
    var i = new _no_name_provided__462();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_406() {
    var i = new _no_name_provided__463();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_407($views) {
    var i = new _no_name_provided__464($views);
    return function (p1, p2) {
      i.invoke_8ltlll_k$(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_408($over, this$0) {
    var i = new _no_name_provided__465($over, this$0);
    return function () {
      i.invoke_sv8swh_k$();
      return Unit_getInstance();
    };
  }
  function cursor$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_402();
    return new Property(null, tmp0_extraProperty_0);
  }
  function Info_init_$Init$_0(index_0, id, local, startLocal, startTime, global_0, startGlobal, time, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      index_0 = -1;
    if (!(($mask0 & 2) === 0))
      id = 0;
    if (!(($mask0 & 4) === 0))
      local = Companion_getInstance_32().invoke_0_k$();
    if (!(($mask0 & 8) === 0))
      startLocal = Companion_getInstance_32().invoke_0_k$();
    if (!(($mask0 & 16) === 0))
      startTime = Companion_getInstance_82()._EPOCH;
    if (!(($mask0 & 32) === 0))
      global_0 = Companion_getInstance_32().invoke_0_k$();
    if (!(($mask0 & 64) === 0))
      startGlobal = Companion_getInstance_32().invoke_0_k$();
    if (!(($mask0 & 128) === 0))
      time = Companion_getInstance_82()._EPOCH;
    Info_1.call($this, index_0, id, local, startLocal, startTime, global_0, startGlobal, time);
    return $this;
  }
  function Info_init_$Create$_0(index_0, id, local, startLocal, startTime, global_0, startGlobal, time, $mask0, $marker) {
    return Info_init_$Init$_0(index_0, id, local, startLocal, startTime, global_0, startGlobal, time, $mask0, $marker, Object.create(Info_1.prototype));
  }
  function Info_1(index_0, id, local, startLocal, startTime, global_0, startGlobal, time) {
    this._index_32 = index_0;
    this._id_27 = id;
    this._local_0 = local;
    this._startLocal = startLocal;
    this._startTime_2 = startTime;
    this._global_0 = global_0;
    this._startGlobal = startGlobal;
    this._time_8 = time;
    var tmp = this;
    tmp._$$delegate_0_39 = Mixin_init_$Create$(null, 1, null);
  }
  Info_1.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_39._set_extra__n1onou_k$(_set___);
  };
  Info_1.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_39._get_extra__0_k$();
  };
  Info_1.prototype._get_elapsedTime__nsqrdp_k$ = function () {
    return DateTime__minus_impl_0(this._time_8, this._startTime_2);
  };
  Info_1.prototype._get_views__0_k$ = function () {
    var tmp = this._views_5;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  Info_1.prototype._get_localX__0_k$ = function () {
    return this._local_0._x_1;
  };
  Info_1.prototype._get_localY__0_k$ = function () {
    return this._local_0._y_1;
  };
  Info_1.prototype.toString = function () {
    return '' + 'Touch[' + this._id_27 + '](' + numberToInt(this._get_localX__0_k$()) + ', ' + numberToInt(this._get_localY__0_k$()) + ')';
  };
  Info_1.prototype.hashCode = function () {
    var result = this._index_32;
    result = imul(result, 31) + this._id_27 | 0;
    result = imul(result, 31) + this._local_0.hashCode() | 0;
    result = imul(result, 31) + this._startLocal.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._startTime_2) | 0;
    result = imul(result, 31) + this._global_0.hashCode() | 0;
    result = imul(result, 31) + this._startGlobal.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._time_8) | 0;
    return result;
  };
  Info_1.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Info_1))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Info_1 ? other : THROW_CCE();
    if (!(this._index_32 === tmp0_other_with_cast._index_32))
      return false;
    if (!(this._id_27 === tmp0_other_with_cast._id_27))
      return false;
    if (!this._local_0.equals(tmp0_other_with_cast._local_0))
      return false;
    if (!this._startLocal.equals(tmp0_other_with_cast._startLocal))
      return false;
    if (!equals_1(new DateTime(this._startTime_2), new DateTime(tmp0_other_with_cast._startTime_2)))
      return false;
    if (!this._global_0.equals(tmp0_other_with_cast._global_0))
      return false;
    if (!this._startGlobal.equals(tmp0_other_with_cast._startGlobal))
      return false;
    if (!equals_1(new DateTime(this._time_8), new DateTime(tmp0_other_with_cast._time_8)))
      return false;
    return true;
  };
  Info_1.$metadata$ = {
    simpleName: 'Info',
    kind: 'class',
    interfaces: [Extra]
  };
  function _no_name_provided__468() {
  }
  _no_name_provided__468.prototype.invoke_ha5a7z_k$ = function (it) {
    return Info_init_$Create$_0(it, 0, null, null, null, null, null, null, 254, null);
  };
  _no_name_provided__468.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__468.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TouchEvents(view) {
    this._view_8 = view;
    var tmp = this;
    tmp._start_3 = Signal_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._move_0 = Signal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._startAll = Signal_init_$Create$(null, 1, null);
    var tmp_2 = this;
    tmp_2._moveAll = Signal_init_$Create$(null, 1, null);
    var tmp_3 = this;
    tmp_3._endAll = Signal_init_$Create$(null, 1, null);
    var tmp_4 = this;
    tmp_4._updateAll = Signal_init_$Create$(null, 1, null);
    var tmp_5 = this;
    tmp_5._end_2 = Signal_init_$Create$(null, 1, null);
    var tmp_6 = this;
    tmp_6._infoPool = Pool_init_$Create$_1(0, _no_name_provided_$factory_409(), 1, null);
    this._infoById = FastIntMap();
    this._infos = FastArrayList_init_$Create$();
  }
  TouchEvents.prototype.copyFrom_bstxxc_k$ = function (_this__0, touch_0) {
    _this__0._id_27 = touch_0._id_19;
    _this__0._global_0.setTo_ngl742_k$(touch_0._x_23, touch_0._y_22);
    Unit_getInstance();
    this._view_8.globalToLocalXY_hj1jb5_k$(touch_0._x_23, touch_0._y_22, _this__0._local_0);
    Unit_getInstance();
    return _this__0;
  };
  TouchEvents.prototype.start_i2uu13_k$ = function (_this__0) {
    _this__0._startLocal.copyFrom_ujo5kx_k$(_this__0._local_0);
    Unit_getInstance();
    _this__0._startGlobal.copyFrom_ujo5kx_k$(_this__0._global_0);
    Unit_getInstance();
    return _this__0;
  };
  TouchEvents.prototype.onTouchEvent_k01v9u_k$ = function (views_0, e) {
    this._infos.clear_sv8swh_k$();
    var now_0 = views_0._timeProvider_3.now_utobi1_k$();
    if (e._type_19.equals(Type_START_getInstance())) {
      var tmp0_fastForEach_0 = e._get_touches__0_k$();
      var n_1 = 0;
      while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
        if (!tmp1__anonymous__3._status_1.equals(Status_KEEP_getInstance())) {
          var info_4 = this.start_i2uu13_k$(this.copyFrom_bstxxc_k$(this._infoPool.alloc_0_k$(), tmp1__anonymous__3));
          info_4._startTime_2 = now_0;
          info_4._views_5 = views_0;
          var tmp0_set_0_5 = this._infoById;
          var tmp1_set_0_6 = info_4._id_27;
          tmp0_set_0_5.set(tmp1_set_0_6, info_4);
          this._start_3.invoke_iav7o_k$(info_4);
        }}
    }var tmp2_fastForEach_0 = e._get_touches__0_k$();
    var n_1_0 = 0;
    while (n_1_0 < tmp2_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_0 = n_1_0;
      n_1_0 = tmp0_2_0 + 1 | 0;
      var tmp3__anonymous__3 = tmp2_fastForEach_0.get_ha5a7z_k$(tmp0_2_0);
      var tmp0_get_0_5 = this._infoById;
      var tmp1_get_0_6 = tmp3__anonymous__3._id_19;
      var info_4_0 = tmp0_get_0_5.get(tmp1_get_0_6);
      if (!(info_4_0 == null)) {
        info_4_0._time_8 = now_0;
        this._infos.add_2bq_k$(this.copyFrom_bstxxc_k$(info_4_0, tmp3__anonymous__3));
        Unit_getInstance();
      }}
    if (e._type_19.equals(Type_START_getInstance())) {
      this._startAll.invoke_iav7o_k$(this);
    }if (e._type_19.equals(Type_MOVE_getInstance_0())) {
      var tmp4_fastForEach_0 = this._infos;
      var array_1 = tmp4_fastForEach_0._array_4;
      var n_2 = 0;
      while (n_2 < array_1.length) {
        var tmp0_4 = n_2;
        n_2 = tmp0_4 + 1 | 0;
        var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
        var tmp5__anonymous__5 = tmp0_unsafeCast_0_3;
        this._move_0.invoke_iav7o_k$(tmp5__anonymous__5);
      }
      this._moveAll.invoke_iav7o_k$(this);
    }if (e._type_19.equals(Type_END_getInstance())) {
      var tmp6_fastForEach_0 = e._get_touches__0_k$();
      var n_1_1 = 0;
      while (n_1_1 < tmp6_fastForEach_0._get_size__0_k$()) {
        var tmp0_2_1 = n_1_1;
        n_1_1 = tmp0_2_1 + 1 | 0;
        var tmp7__anonymous__3 = tmp6_fastForEach_0.get_ha5a7z_k$(tmp0_2_1);
        if (!tmp7__anonymous__3._status_1.equals(Status_KEEP_getInstance())) {
          var tmp0_get_0_5_0 = this._infoById;
          var tmp1_get_0_6_0 = tmp7__anonymous__3._id_19;
          var info_4_1 = tmp0_get_0_5_0.get(tmp1_get_0_6_0);
          if (!(info_4_1 == null)) {
            this._end_2.invoke_iav7o_k$(this.copyFrom_bstxxc_k$(info_4_1, tmp7__anonymous__3));
            this._endAll.invoke_iav7o_k$(this);
            var tmp2_remove_0_7 = this._infoById;
            var tmp3_remove_0_8 = info_4_1._id_27;
            tmp2_remove_0_7.delete(tmp3_remove_0_8);
            this._infoPool.free_iav7o_k$(info_4_1);
          }}}
    }this._updateAll.invoke_iav7o_k$(this);
  };
  TouchEvents.$metadata$ = {
    simpleName: 'TouchEvents',
    kind: 'class',
    interfaces: [TouchComponent]
  };
  function singleTouch(_this_, removeTouch, supportStartAnywhere, block) {
    var ids = FastIntMap();
    touch(_this_, _no_name_provided_$factory_410(_this_, supportStartAnywhere, ids, block, removeTouch));
  }
  function singleTouch$default(_this_, removeTouch, supportStartAnywhere, block, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      removeTouch = false;
    if (!(($mask0 & 2) === 0))
      supportStartAnywhere = false;
    return singleTouch(_this_, removeTouch, supportStartAnywhere, block);
  }
  function SingleTouchHandler() {
    var tmp = this;
    tmp._start_4 = Signal_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._startAnywhere = Signal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._move_1 = Signal_init_$Create$(null, 1, null);
    var tmp_2 = this;
    tmp_2._moveAnywhere_0 = Signal_init_$Create$(null, 1, null);
    var tmp_3 = this;
    tmp_3._end_3 = Signal_init_$Create$(null, 1, null);
    var tmp_4 = this;
    tmp_4._endAnywhere = Signal_init_$Create$(null, 1, null);
    var tmp_5 = this;
    tmp_5._tap = Signal_init_$Create$(null, 1, null);
    var tmp_6 = this;
    tmp_6._tapAnywhere = Signal_init_$Create$(null, 1, null);
  }
  SingleTouchHandler.$metadata$ = {
    simpleName: 'SingleTouchHandler',
    kind: 'class',
    interfaces: []
  };
  function touch(_this_, block) {
    var tmp3_getOrCreateComponent_0_1 = _this_._get_componentsSure__0_k$();
    var tmp4_getOrCreateComponent_0_2 = getKClass_0(TouchEvents);
    var tmp1_getOrCreateComponent_0_4 = tmp3_getOrCreateComponent_0_1._get_etouch__0_k$();
    var component_1_5 = tmp3_getOrCreateComponent_0_1.findFirstComponentOfType_3uvto2_k$(tmp1_getOrCreateComponent_0_4, tmp4_getOrCreateComponent_0_2);
    if (component_1_5 == null) {
      component_1_5 = new TouchEvents(_this_);
      var tmp0_plusAssign_0_6 = component_1_5;
      tmp1_getOrCreateComponent_0_4.add_2bq_k$(tmp0_plusAssign_0_6);
      Unit_getInstance();
    }var tmp2_fastCastTo_0_3 = component_1_5;
    block(tmp2_fastCastTo_0_3);
  }
  function singleTouch$getById(ids, $block, id) {
    var tmp$ret$0;
    l$ret$1: do {
      var res_1 = ids.get(id);
      if (!(res_1 == null)) {
        tmp$ret$0 = res_1;
        break l$ret$1;
      }var tmp0_also_0_4 = SingleTouchInfo_init_$Create$(null, false, 3, null);
      $block(tmp0_also_0_4._handler_3, id);
      var out_2 = tmp0_also_0_4;
      ids.set(id, out_2);
      tmp$ret$0 = out_2;
    }
     while (false);
    return tmp$ret$0;
  }
  function SingleTouchInfo_init_$Init$(handler, startedInside, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      handler = new SingleTouchHandler();
    if (!(($mask0 & 2) === 0))
      startedInside = false;
    SingleTouchInfo.call($this, handler, startedInside);
    return $this;
  }
  function SingleTouchInfo_init_$Create$(handler, startedInside, $mask0, $marker) {
    return SingleTouchInfo_init_$Init$(handler, startedInside, $mask0, $marker, Object.create(SingleTouchInfo.prototype));
  }
  function SingleTouchInfo(handler, startedInside) {
    this._handler_3 = handler;
    this._startedInside = startedInside;
  }
  SingleTouchInfo.$metadata$ = {
    simpleName: 'SingleTouchInfo',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__469($this_singleTouch, $supportStartAnywhere, $ids, $block) {
    this._$this_singleTouch = $this_singleTouch;
    this._$supportStartAnywhere = $supportStartAnywhere;
    this._$ids = $ids;
    this._$block_2 = $block;
  }
  _no_name_provided__469.prototype.invoke_3xauee_k$ = function (it) {
    var info = singleTouch$getById(this._$ids, this._$block_2, it._id_27);
    var handler = info._handler_3;
    info._startedInside = !(hitTest(this._$this_singleTouch, it._global_0) == null);
    if (handler._start_4._get_hasListeners__0_k$() ? info._startedInside : false) {
      handler._start_4.invoke_iav7o_k$(it);
    }if (this._$supportStartAnywhere) {
      handler._startAnywhere.invoke_iav7o_k$(it);
    }};
  _no_name_provided__469.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_3xauee_k$(p1 instanceof Info_1 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__469.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__470($supportStartAnywhere, $this_singleTouch, $ids, $block) {
    this._$supportStartAnywhere_0 = $supportStartAnywhere;
    this._$this_singleTouch_0 = $this_singleTouch;
    this._$ids_0 = $ids;
    this._$block_3 = $block;
  }
  _no_name_provided__470.prototype.invoke_3xauee_k$ = function (it) {
    var info = singleTouch$getById(this._$ids_0, this._$block_3, it._id_27);
    if (!this._$supportStartAnywhere_0 ? !info._startedInside : false)
      return Unit_getInstance();
    var handler = info._handler_3;
    if (handler._move_1._get_hasListeners__0_k$() ? !(hitTest(this._$this_singleTouch_0, it._global_0) == null) : false) {
      handler._move_1.invoke_iav7o_k$(it);
    }handler._moveAnywhere_0.invoke_iav7o_k$(it);
  };
  _no_name_provided__470.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_3xauee_k$(p1 instanceof Info_1 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__470.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__471($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block) {
    this._$supportStartAnywhere_1 = $supportStartAnywhere;
    this._$this_singleTouch_1 = $this_singleTouch;
    this._$removeTouch = $removeTouch;
    this._$ids_1 = $ids;
    this._$block_4 = $block;
  }
  _no_name_provided__471.prototype.invoke_3xauee_k$ = function (it) {
    var info = singleTouch$getById(this._$ids_1, this._$block_4, it._id_27);
    if (!this._$supportStartAnywhere_1 ? !info._startedInside : false)
      return Unit_getInstance();
    var handler = info._handler_3;
    var hitTest_0 = (handler._end_3._get_hasListeners__0_k$() ? true : handler._tap._get_hasListeners__0_k$()) ? !(hitTest(this._$this_singleTouch_1, it._global_0) == null) : false;
    if (hitTest_0) {
      handler._end_3.invoke_iav7o_k$(it);
    }handler._endAnywhere.invoke_iav7o_k$(it);
    if (Companion_getInstance_32().distance_6xxxj2_k$(it._startGlobal, it._global_0) <= it._get_views__0_k$()._input_3._clickDistance ? TimeSpan__compareTo_impl(it._get_elapsedTime__nsqrdp_k$(), it._get_views__0_k$()._input_3._clickTime) <= 0 : false) {
      if (info._startedInside ? hitTest_0 : false) {
        handler._tap.invoke_iav7o_k$(it);
      }handler._tapAnywhere.invoke_iav7o_k$(it);
    }if (this._$removeTouch) {
      var tmp0_remove_0 = it._id_27;
      this._$ids_1.delete(tmp0_remove_0);
    }};
  _no_name_provided__471.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_3xauee_k$(p1 instanceof Info_1 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__471.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__472($this_singleTouch, $supportStartAnywhere, $ids, $block, $removeTouch) {
    this._$this_singleTouch_2 = $this_singleTouch;
    this._$supportStartAnywhere_2 = $supportStartAnywhere;
    this._$ids_2 = $ids;
    this._$block_5 = $block;
    this._$removeTouch_0 = $removeTouch;
  }
  _no_name_provided__472.prototype.invoke_1cxbt6_k$ = function ($this$touch) {
    $this$touch._start_3.invoke_o72mru_k$(_no_name_provided_$factory_411(this._$this_singleTouch_2, this._$supportStartAnywhere_2, this._$ids_2, this._$block_5));
    Unit_getInstance();
    $this$touch._move_0.invoke_o72mru_k$(_no_name_provided_$factory_412(this._$supportStartAnywhere_2, this._$this_singleTouch_2, this._$ids_2, this._$block_5));
    Unit_getInstance();
    $this$touch._end_2.invoke_o72mru_k$(_no_name_provided_$factory_413(this._$supportStartAnywhere_2, this._$this_singleTouch_2, this._$removeTouch_0, this._$ids_2, this._$block_5));
    Unit_getInstance();
  };
  _no_name_provided__472.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_1cxbt6_k$(p1 instanceof TouchEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__472.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_409() {
    var i = new _no_name_provided__468();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_410($this_singleTouch, $supportStartAnywhere, $ids, $block, $removeTouch) {
    var i = new _no_name_provided__472($this_singleTouch, $supportStartAnywhere, $ids, $block, $removeTouch);
    return function (p1) {
      i.invoke_1cxbt6_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_411($this_singleTouch, $supportStartAnywhere, $ids, $block) {
    var i = new _no_name_provided__469($this_singleTouch, $supportStartAnywhere, $ids, $block);
    return function (p1) {
      i.invoke_3xauee_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_412($supportStartAnywhere, $this_singleTouch, $ids, $block) {
    var i = new _no_name_provided__470($supportStartAnywhere, $this_singleTouch, $ids, $block);
    return function (p1) {
      i.invoke_3xauee_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_413($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block) {
    var i = new _no_name_provided__471($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block);
    return function (p1) {
      i.invoke_3xauee_k$(p1);
      return Unit_getInstance();
    };
  }
  function DefaultViewport() {
    DefaultViewport_instance = this;
    this._WIDTH = 1280;
    this._HEIGHT = 720;
  }
  DefaultViewport.$metadata$ = {
    simpleName: 'DefaultViewport',
    kind: 'object',
    interfaces: []
  };
  var DefaultViewport_instance;
  function DefaultViewport_getInstance() {
    if (DefaultViewport_instance == null)
      new DefaultViewport();
    return DefaultViewport_instance;
  }
  function configureLoggerFromProperties(file, $cont) {
    var tmp = new $configureLoggerFromPropertiesCOROUTINE$13(file, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function configureLoggerFromProperties_0(str) {
    var props = Companion_getInstance_198().load_6wfw3l_k$(str);
    var tmp0_iterator = props._get_entries__0_k$().iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var tmp1_loop_parameter = tmp0_iterator.next_0_k$();
      var key = tmp1_loop_parameter._get_key__0_k$();
      var value = tmp1_loop_parameter._get_value__0_k$();
      try {
        var tmp = Companion_getInstance_98().invoke_6wfw3l_k$(key);
        tmp._set_level__xpnttj_k$(valueOf(value.toUpperCase()));
      } catch ($p) {
        if ($p instanceof Error) {
          printStackTrace_0($p);
        } else {
          {
            throw $p;
          }
        }
      }
    }
  }
  function Props_init_$Init$(props, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      props = LinkedHashMap_init_$Create$();
    Props.call($this, props);
    return $this;
  }
  function Props_init_$Create$(props, $mask0, $marker) {
    return Props_init_$Init$(props, $mask0, $marker, Object.create(Props.prototype));
  }
  function Companion_199() {
    Companion_instance_198 = this;
  }
  Companion_199.prototype.load_6wfw3l_k$ = function (str) {
    var tmp0_apply_0 = Props_init_$Create$(null, 1, null);
    tmp0_apply_0.deserializeNew_a4enbm_k$(str);
    return tmp0_apply_0;
  };
  Companion_199.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_198;
  function Companion_getInstance_198() {
    if (Companion_instance_198 == null)
      new Companion_199();
    return Companion_instance_198;
  }
  function Props(props) {
    Companion_getInstance_198();
    this._props_16 = props;
  }
  Props.prototype.clear_sv8swh_k$ = function () {
    this._props_16.clear_sv8swh_k$();
  };
  Props.prototype.containsKey_6wfw3l_k$ = function (key) {
    return this._props_16.containsKey_2bw_k$(key);
  };
  Props.prototype.containsKey_2bw_k$ = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_6wfw3l_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  Props.prototype.get_6wfw3l_k$ = function (key) {
    return this._props_16.get_2bw_k$(key);
  };
  Props.prototype.get_2bw_k$ = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_6wfw3l_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  Props.prototype.isEmpty_0_k$ = function () {
    return this._props_16.isEmpty_0_k$();
  };
  Props.prototype.put_jg38oy_k$ = function (key, value) {
    return this._props_16.put_1q9pf_k$(key, value);
  };
  Props.prototype.put_1q9pf_k$ = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.put_jg38oy_k$(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  Props.prototype.putAll_sf003a_k$ = function (from) {
    this._props_16.putAll_nn707j_k$(from);
  };
  Props.prototype.putAll_nn707j_k$ = function (from) {
    return this.putAll_sf003a_k$(from);
  };
  Props.prototype.remove_6wfw3l_k$ = function (key) {
    return this._props_16.remove_2bw_k$(key);
  };
  Props.prototype.remove_2bw_k$ = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.remove_6wfw3l_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  Props.prototype._get_entries__0_k$ = function () {
    return this._props_16._get_entries__0_k$();
  };
  Props.prototype._get_size__0_k$ = function () {
    return this._props_16._get_size__0_k$();
  };
  Props.prototype._get_values__0_k$ = function () {
    return this._props_16._get_values__0_k$();
  };
  Props.prototype.deserializeAdd_a4enbm_k$ = function (str) {
    var tmp0_iterator = split$default_0(str, ['\n'], false, 0, 6, null).iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var line_1 = tmp0_iterator.next_0_k$();
      var tmp = new Char(35);
      if (startsWith$default(line_1, tmp, false, 2, null))
        continue;
      else {
      }
      if (isBlank(line_1))
        continue;
      var tmp_0 = charArrayOf([new Char(61)]);
      var parts_0 = split$default(line_1, tmp_0, false, 2, 2, null);
      var tmp0_trim_0 = parts_0.get_ha5a7z_k$(0);
      var key = toString_1(trim_0(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE()));
      var tmp_1;
      if (1 <= _get_lastIndex__4(parts_0)) {
        tmp_1 = parts_0.get_ha5a7z_k$(1);
      } else {
        tmp_1 = ' ';
      }
      var tmp1_trim_0 = tmp_1;
      var value = toString_1(trim_0(isCharSequence(tmp1_trim_0) ? tmp1_trim_0 : THROW_CCE()));
      var tmp2_set_0 = this._props_16;
      tmp2_set_0.put_1q9pf_k$(key, value);
      Unit_getInstance();
    }
  };
  Props.prototype.deserializeNew_a4enbm_k$ = function (str) {
    this.clear_sv8swh_k$();
    this.deserializeAdd_a4enbm_k$(str);
  };
  Props.$metadata$ = {
    simpleName: 'Props',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function $configureLoggerFromPropertiesCOROUTINE$13(file, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._file_5 = file;
  }
  $configureLoggerFromPropertiesCOROUTINE$13.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._file_5.readString$default_8s0uio_k$(null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            configureLoggerFromProperties_0(ARGUMENT);
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $configureLoggerFromPropertiesCOROUTINE$13.$metadata$ = {
    simpleName: '$configureLoggerFromPropertiesCOROUTINE$13',
    kind: 'class',
    interfaces: []
  };
  function ParticleContainer(max) {
    this._max_2 = max;
    var tmp = this;
    var tmp_0 = Companion_getInstance_97();
    var tmp_1 = imul(this._max_2, 26);
    FloatCompanionObject_getInstance();
    tmp._data_54 = tmp_0.invoke_ha5a7z_k$(imul(tmp_1, 4));
    var tmp_2 = this;
    var tmp0__get_f32__0 = this._data_54;
    tmp_2._f32_0 = tmp0__get_f32__0._arrayFloat;
    var inductionVariable = 0;
    var last_1 = this._max_2;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var particle = _Particle___init__impl_(n);
        this._set_scale__y3hcra_k$(particle, 1.0);
        this._set_colorR__y3hcra_k$(particle, 1.0);
        this._set_colorG__y3hcra_k$(particle, 1.0);
        this._set_colorB__y3hcra_k$(particle, 1.0);
        this._set_colorA__y3hcra_k$(particle, 1.0);
      }
       while (inductionVariable < last_1);
  }
  ParticleContainer.prototype._set_rotation__f2yw6_k$ = function (_this__0, value) {
    this._set_rotationRadians__y3hcra_k$(_this__0, _Angle___get_radians__impl_(value));
  };
  ParticleContainer.prototype._get_rotation__ybnru0_k$ = function (_this__0) {
    return _get_radians__1(this._get_rotationRadians__b0fba1_k$(_this__0));
  };
  ParticleContainer.prototype._set_x__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 0 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_x__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 0 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_y__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 1 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_y__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 1 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_scale__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 2 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_scale__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 2 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_rotationRadians__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 3 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_rotationRadians__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 3 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_currentTime__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 4 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_currentTime__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 4 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_totalTime__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 5 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_totalTime__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 5 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_colorR__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 6 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_colorR__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 6 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_colorG__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 7 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_colorG__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 7 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_colorB__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 8 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_colorB__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 8 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_colorA__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 9 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_colorA__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 9 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_colorRdelta__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 10 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_colorRdelta__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 10 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_colorGdelta__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 11 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_colorGdelta__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 11 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_colorBdelta__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 12 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_colorBdelta__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 12 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_colorAdelta__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 13 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_colorAdelta__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 13 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_startX__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 14 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_startX__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 14 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_startY__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 15 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_startY__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 15 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_velocityX__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 16 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_velocityX__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 16 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_velocityY__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 17 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_velocityY__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 17 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_radialAcceleration__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 18 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_radialAcceleration__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 18 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_tangentialAcceleration__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 19 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_tangentialAcceleration__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 19 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_emitRadius__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 20 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_emitRadius__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 20 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_emitRadiusDelta__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 21 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_emitRadiusDelta__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 21 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_scaleDelta__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 22 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_scaleDelta__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 22 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_emitRotationRadians__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 23 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_emitRotationRadians__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 23 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_emitRotationDeltaRadians__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 24 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_emitRotationDeltaRadians__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 24 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_rotationDeltaRadians__y3hcra_k$ = function (_this__0, value) {
    var tmp0_set_0 = this._f32_0;
    var tmp1_set_0 = _Particle___get_offset__impl_(_this__0) + 25 | 0;
    tmp0_set_0[tmp1_set_0] = value;
  };
  ParticleContainer.prototype._get_rotationDeltaRadians__b0fba1_k$ = function (_this__0) {
    var tmp0_get_0 = this._f32_0;
    var tmp1_get_0 = _Particle___get_offset__impl_(_this__0) + 25 | 0;
    return tmp0_get_0[tmp1_get_0];
  };
  ParticleContainer.prototype._set_emitRotation__f2yw6_k$ = function (_this__0, value) {
    this._set_emitRotationRadians__y3hcra_k$(_this__0, _Angle___get_radians__impl_(value));
  };
  ParticleContainer.prototype._get_emitRotation__ybnru0_k$ = function (_this__0) {
    return _get_radians__1(this._get_emitRotationRadians__b0fba1_k$(_this__0));
  };
  ParticleContainer.prototype._set_emitRotationDelta__f2yw6_k$ = function (_this__0, value) {
    this._set_emitRotationDeltaRadians__y3hcra_k$(_this__0, _Angle___get_radians__impl_(value));
  };
  ParticleContainer.prototype._get_emitRotationDelta__ybnru0_k$ = function (_this__0) {
    return _get_radians__1(this._get_emitRotationDeltaRadians__b0fba1_k$(_this__0));
  };
  ParticleContainer.prototype._set_rotationDelta__f2yw6_k$ = function (_this__0, value) {
    this._set_rotationDeltaRadians__y3hcra_k$(_this__0, _Angle___get_radians__impl_(value));
  };
  ParticleContainer.prototype._get_rotationDelta__ybnru0_k$ = function (_this__0) {
    return _get_radians__1(this._get_rotationDeltaRadians__b0fba1_k$(_this__0));
  };
  ParticleContainer.prototype._get_color__ip4rd6_k$ = function (_this__0) {
    return Companion_getInstance_136().float_cz83z_k$(this._get_colorR__b0fba1_k$(_this__0), this._get_colorG__b0fba1_k$(_this__0), this._get_colorB__b0fba1_k$(_this__0), this._get_colorA__b0fba1_k$(_this__0));
  };
  ParticleContainer.prototype._get_alive__b0fba1_k$ = function (_this__0) {
    return this._get_currentTime__b0fba1_k$(_this__0) >= 0.0 ? this._get_currentTime__b0fba1_k$(_this__0) < this._get_totalTime__b0fba1_k$(_this__0) : false;
  };
  ParticleContainer.$metadata$ = {
    simpleName: 'ParticleContainer',
    kind: 'class',
    interfaces: []
  };
  function _Particle___init__impl_(index_0) {
    return index_0;
  }
  function _Particle___get_index__impl_(this_0) {
    return this_0;
  }
  function _Particle___get_offset__impl_(this_0) {
    return imul(_Particle___get_index__impl_(this_0), 26);
  }
  var Type_GRAVITY_instance;
  var Type_RADIAL_instance;
  function values_12() {
    return [Type_GRAVITY_getInstance(), Type_RADIAL_getInstance()];
  }
  var Type_entriesInitialized_10;
  function Type_initEntries_10() {
    if (Type_entriesInitialized_10)
      return Unit_getInstance();
    Type_entriesInitialized_10 = true;
    Type_GRAVITY_instance = new Type_10('GRAVITY', 0, 0);
    Type_RADIAL_instance = new Type_10('RADIAL', 1, 1);
  }
  function Type_10(name, ordinal, index_0) {
    Enum.call(this, name, ordinal);
    this._index_33 = index_0;
  }
  Type_10.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Companion_200() {
    Companion_instance_199 = this;
    this._blendFactorMap = mapOf([to(0, BlendFactor_ZERO_getInstance()), to(1, BlendFactor_ONE_getInstance()), to(768, BlendFactor_SOURCE_COLOR_getInstance()), to(769, BlendFactor_ONE_MINUS_SOURCE_COLOR_getInstance()), to(770, BlendFactor_SOURCE_ALPHA_getInstance()), to(771, BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance()), to(772, BlendFactor_DESTINATION_ALPHA_getInstance()), to(773, BlendFactor_ONE_MINUS_DESTINATION_ALPHA_getInstance()), to(774, BlendFactor_DESTINATION_COLOR_getInstance()), to(775, BlendFactor_ONE_MINUS_DESTINATION_COLOR_getInstance())]);
    this._blendFactorMapReversed = flip(this._blendFactorMap);
    var tmp = this;
    var tmp0_associateBy_0 = values_12();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_1q9pf_k$(element_2_4._index_33, element_2_4);
      Unit_getInstance();
    }
    tmp._typeMap = tmp0_associateByTo_0_2;
    this._typeMapReversed = flip(this._typeMap);
  }
  Companion_200.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_199;
  function Companion_getInstance_199() {
    if (Companion_instance_199 == null)
      new Companion_200();
    return Companion_instance_199;
  }
  function Type_GRAVITY_getInstance() {
    Type_initEntries_10();
    return Type_GRAVITY_instance;
  }
  function Type_RADIAL_getInstance() {
    Type_initEntries_10();
    return Type_RADIAL_instance;
  }
  function ParticleEmitter() {
    Companion_getInstance_199();
    this._textureName = null;
    this._texture_3 = null;
    this._sourcePosition = Companion_getInstance_32().invoke_0_k$();
    this._sourcePositionVariance = Companion_getInstance_32().invoke_0_k$();
    this._speed_1 = 100.0;
    this._speedVariance = 30.0;
    this._lifeSpan = 2.0;
    this._lifespanVariance = 1.9;
    this._angle_0 = _get_degrees__1(270.0);
    this._angleVariance = _get_degrees__1(2.0);
    this._gravity_0 = Companion_getInstance_32().invoke_0_k$();
    this._radialAcceleration = 0.0;
    this._tangentialAcceleration = 0.0;
    this._radialAccelVariance = 0.0;
    this._tangentialAccelVariance = 0.0;
    this._startColor = new RGBAf(1.0, 1.0, 1.0, 1.0);
    this._startColorVariance = new RGBAf(0.0, 0.0, 0.0, 0.0);
    this._endColor = new RGBAf(1.0, 1.0, 1.0, 1.0);
    this._endColorVariance = new RGBAf(0.0, 0.0, 0.0, 0.0);
    this._maxParticles = 500;
    this._startSize = 70.0;
    this._startSizeVariance = 50.0;
    this._endSize = 10.0;
    this._endSizeVariance = 5.0;
    this._duration_0 = -1.0;
    this._emitterType = Type_GRAVITY_getInstance();
    this._maxRadius = 0.0;
    this._maxRadiusVariance = 0.0;
    this._minRadius = 0.0;
    this._minRadiusVariance = 0.0;
    this._rotatePerSecond = _get_degrees__1(0.0);
    this._rotatePerSecondVariance = _get_degrees__1(0.0);
    this._blendFuncSource = BlendFactor_ONE_getInstance();
    this._blendFuncDestination = BlendFactor_ONE_getInstance();
    this._rotationStart = _get_degrees__1(0.0);
    this._rotationStartVariance = _get_degrees__1(0.0);
    this._rotationEnd = _get_degrees__1(0.0);
    this._rotationEndVariance = _get_degrees__1(0.0);
  }
  ParticleEmitter.$metadata$ = {
    simpleName: 'ParticleEmitter',
    kind: 'class',
    interfaces: []
  };
  function readParticleEmitter(_this_, $cont) {
    var tmp = new $readParticleEmitterCOROUTINE$14(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readParticleEmitter$point_4(tmp1__anonymous__3) {
    var tmp = tmp1__anonymous__3.double$default_s8e18k_k$('x', 0.0, 2, null);
    return new Point(tmp, tmp1__anonymous__3.double$default_s8e18k_k$('y', 0.0, 2, null));
  }
  function readParticleEmitter$scalar_5(tmp1__anonymous__3) {
    return tmp1__anonymous__3.double$default_s8e18k_k$('value', 0.0, 2, null);
  }
  function readParticleEmitter$blendFactor_6(tmp1__anonymous__3) {
    var tmp0_elvis_lhs_7 = Companion_getInstance_199()._blendFactorMap.get_2bw_k$(numberToInt(readParticleEmitter$scalar_5(tmp1__anonymous__3)));
    return tmp0_elvis_lhs_7 == null ? BlendFactor_ONE_getInstance() : tmp0_elvis_lhs_7;
  }
  function readParticleEmitter$type_8(tmp1__anonymous__3) {
    var tmp0_elvis_lhs_9 = Companion_getInstance_199()._typeMap.get_2bw_k$(numberToInt(readParticleEmitter$scalar_5(tmp1__anonymous__3)));
    return tmp0_elvis_lhs_9 == null ? Type_GRAVITY_getInstance() : tmp0_elvis_lhs_9;
  }
  function readParticleEmitter$angle_10(tmp1__anonymous__3) {
    return _get_degrees__1(tmp1__anonymous__3.double$default_s8e18k_k$('value', 0.0, 2, null));
  }
  function readParticleEmitter$color_11(tmp1__anonymous__3) {
    var tmp0_RGBAf_0_12 = tmp1__anonymous__3.double$default_s8e18k_k$('red', 0.0, 2, null);
    var tmp1_RGBAf_0_13 = tmp1__anonymous__3.double$default_s8e18k_k$('green', 0.0, 2, null);
    var tmp2_RGBAf_0_14 = tmp1__anonymous__3.double$default_s8e18k_k$('blue', 0.0, 2, null);
    var tmp3_RGBAf_0_15 = tmp1__anonymous__3.double$default_s8e18k_k$('alpha', 0.0, 2, null);
    return new RGBAf(numberToDouble(tmp0_RGBAf_0_12), numberToDouble(tmp1_RGBAf_0_13), numberToDouble(tmp2_RGBAf_0_14), numberToDouble(tmp3_RGBAf_0_15));
  }
  function $readParticleEmitterCOROUTINE$14(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__184 = _this_;
  }
  $readParticleEmitterCOROUTINE$14.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._file0_2 = this.__this__184;
            this._emitter1 = new ParticleEmitter();
            this._state_1 = 1;
            suspendResult = readXml(this._file0_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._particleXml2 = suspendResult;
            var tmp_0 = this;
            tmp_0._tmp0_fastForEach_03 = this._particleXml2._get_allChildrenNoComments__0_k$();
            this._n_14 = 0;
            while (this._n_14 < this._tmp0_fastForEach_03._get_size__0_k$()) {
              var tmp0_2 = this._n_14;
              this._n_14 = tmp0_2 + 1 | 0;
              var tmp1__anonymous__3 = this._tmp0_fastForEach_03.get_ha5a7z_k$(tmp0_2);
              var tmp0_toLowerCase_0_17 = tmp1__anonymous__3._name_11;
              var tmp0_subject_16 = tmp0_toLowerCase_0_17.toLowerCase();
              switch (tmp0_subject_16) {
                case 'texture':
                  var tmp_1 = this._emitter1;
                  tmp_1._textureName = tmp1__anonymous__3.str$default_877n1b_k$('name', null, 2, null);
                  break;
                case 'sourceposition':
                  this._emitter1._sourcePosition = readParticleEmitter$point_4(tmp1__anonymous__3);
                  break;
                case 'sourcepositionvariance':
                  this._emitter1._sourcePositionVariance = readParticleEmitter$point_4(tmp1__anonymous__3);
                  break;
                case 'speed':
                  this._emitter1._speed_1 = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'speedvariance':
                  this._emitter1._speedVariance = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'particlelifespan':
                  this._emitter1._lifeSpan = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'particlelifespanvariance':
                  this._emitter1._lifespanVariance = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'angle':
                  this._emitter1._angle_0 = readParticleEmitter$angle_10(tmp1__anonymous__3);
                  break;
                case 'anglevariance':
                  this._emitter1._angleVariance = readParticleEmitter$angle_10(tmp1__anonymous__3);
                  break;
                case 'gravity':
                  this._emitter1._gravity_0 = readParticleEmitter$point_4(tmp1__anonymous__3);
                  break;
                case 'radialacceleration':
                  this._emitter1._radialAcceleration = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'tangentialacceleration':
                  this._emitter1._tangentialAcceleration = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'radialaccelvariance':
                  this._emitter1._radialAccelVariance = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'tangentialaccelvariance':
                  this._emitter1._tangentialAccelVariance = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'startcolor':
                  this._emitter1._startColor = readParticleEmitter$color_11(tmp1__anonymous__3);
                  break;
                case 'startcolorvariance':
                  this._emitter1._startColorVariance = readParticleEmitter$color_11(tmp1__anonymous__3);
                  break;
                case 'finishcolor':
                  this._emitter1._endColor = readParticleEmitter$color_11(tmp1__anonymous__3);
                  break;
                case 'finishcolorvariance':
                  this._emitter1._endColorVariance = readParticleEmitter$color_11(tmp1__anonymous__3);
                  break;
                case 'maxparticles':
                  this._emitter1._maxParticles = numberToInt(readParticleEmitter$scalar_5(tmp1__anonymous__3));
                  break;
                case 'startparticlesize':
                  this._emitter1._startSize = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'startparticlesizevariance':
                  this._emitter1._startSizeVariance = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'finishparticlesize':
                  this._emitter1._endSize = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'finishparticlesizevariance':
                  this._emitter1._endSizeVariance = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'duration':
                  this._emitter1._duration_0 = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'emittertype':
                  this._emitter1._emitterType = readParticleEmitter$type_8(tmp1__anonymous__3);
                  break;
                case 'maxradius':
                  this._emitter1._maxRadius = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'maxradiusvariance':
                  this._emitter1._maxRadiusVariance = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'minradius':
                  this._emitter1._minRadius = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'minradiusvariance':
                  this._emitter1._minRadiusVariance = readParticleEmitter$scalar_5(tmp1__anonymous__3);
                  break;
                case 'rotatepersecond':
                  this._emitter1._rotatePerSecond = readParticleEmitter$angle_10(tmp1__anonymous__3);
                  break;
                case 'rotatepersecondvariance':
                  this._emitter1._rotatePerSecondVariance = readParticleEmitter$angle_10(tmp1__anonymous__3);
                  break;
                case 'blendfuncsource':
                  this._emitter1._blendFuncSource = readParticleEmitter$blendFactor_6(tmp1__anonymous__3);
                  break;
                case 'blendfuncdestination':
                  this._emitter1._blendFuncDestination = readParticleEmitter$blendFactor_6(tmp1__anonymous__3);
                  break;
                case 'rotationstart':
                  this._emitter1._rotationStart = readParticleEmitter$angle_10(tmp1__anonymous__3);
                  break;
                case 'rotationstartvariance':
                  this._emitter1._rotationStartVariance = readParticleEmitter$angle_10(tmp1__anonymous__3);
                  break;
                case 'rotationend':
                  this._emitter1._rotationEnd = readParticleEmitter$angle_10(tmp1__anonymous__3);
                  break;
                case 'rotationendvariance':
                  this._emitter1._rotationEndVariance = readParticleEmitter$angle_10(tmp1__anonymous__3);
                  break;
              }
            }

            this._exceptionState = 3;
            this._state_1 = 2;
            var tmp_2 = this._file0_2._get_parent__0_k$();
            var tmp0_elvis_lhs = this._emitter1._textureName;
            var tmp_3 = tmp_2.get_6wfw3l_k$(tmp0_elvis_lhs == null ? 'texture.png' : tmp0_elvis_lhs);
            suspendResult = readBitmapSlice$default(tmp_3, false, null, null, 7, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this._emitter1._texture_3 = ARGUMENT;
            this._exceptionState = 5;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._exceptionState = 5;
            var tmp_4 = this._exception_0;
            if (tmp_4 instanceof FileNotFoundException) {
              var e = this._exception_0;
              var tmp_5 = this._emitter1;
              var tmp2_context2d_0 = Bitmap32_init_$Create$(64, 64, null, false, 12, null);
              tmp2_context2d_0.lock_sv8swh_k$();
              var tmp$ret$2;
              l$ret$3: do {
                try {
                  var ctx_2_1 = tmp2_context2d_0.getContext2d_vcj5fe_k$(true);
                  var tmp$ret$0;
                  l$ret$1: do {
                    try {
                      var tmp0_createRadialGradient_0_4 = CycleMethod_NO_CYCLE_getInstance();
                      var tmp1_createRadialGradient_0_5 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
                      var tmp_6 = GradientKind_RADIAL_getInstance();
                      var tmp2_fill_0_3 = GradientPaint_init_$Create$(tmp_6, 32.0, 32.0, 0.0, 32.0, 32.0, 32.0, null, null, tmp0_createRadialGradient_0_4, tmp1_createRadialGradient_0_5, null, null, 6528, null).addColorStop_grassx_k$(0.0, Colors_getInstance()._WHITE_0).addColorStop_grassx_k$(0.4, Colors_getInstance()._WHITE_0).addColorStop_grassx_k$(1.0, Colors_getInstance()._TRANSPARENT_WHITE);
                      ctx_2_1.beginPath_sv8swh_k$();
                      circle(ctx_2_1, 32.0, 32.0, 30.0);
                      tmp$ret$0 = ctx_2_1.fill_y73s1i_k$(tmp2_fill_0_3);
                      break l$ret$1;
                    } catch ($p) {
                      ctx_2_1.dispose_sv8swh_k$();
                      throw $p;
                    }
                  }
                   while (false);
                  tmp$ret$2 = ctx_2_1.dispose_sv8swh_k$();
                  break l$ret$3;
                } catch ($p_0) {
                  tmp2_context2d_0.unlock_ixubtt_k$(null);
                  Unit_getInstance();
                  throw $p_0;
                }
              }
               while (false);
              tmp2_context2d_0.unlock_ixubtt_k$(null);
              Unit_getInstance();
              tmp_5._texture_3 = slice$default(tmp2_context2d_0, null, null, 3, null);
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 5;
            return this._emitter1;
          case 5:
            throw this._exception_0;
        }
      } catch ($p_1) {
        if (this._exceptionState === 5) {
          throw $p_1;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p_1;
        }
      }
     while (true);
  };
  $readParticleEmitterCOROUTINE$14.$metadata$ = {
    simpleName: '$readParticleEmitterCOROUTINE$14',
    kind: 'class',
    interfaces: []
  };
  function ParticleEmitterSimulator_init_$Init$(emitter, emitterPos, seed, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      emitterPos = Companion_getInstance_31().invoke_0_k$();
    if (!(($mask0 & 4) === 0))
      seed = Default_getInstance().nextLong_0_k$();
    ParticleEmitterSimulator.call($this, emitter, emitterPos, seed);
    return $this;
  }
  function ParticleEmitterSimulator_init_$Create$(emitter, emitterPos, seed, $mask0, $marker) {
    return ParticleEmitterSimulator_init_$Init$(emitter, emitterPos, seed, $mask0, $marker, Object.create(ParticleEmitterSimulator.prototype));
  }
  function randomVariance($this, base, variance) {
    return base + variance * ($this._random.nextFloat_0_k$() * 2.0 - 1.0);
  }
  function randomVariance_0($this, base, variance) {
    return base + variance * ($this._random.nextDouble_0_k$() * 2.0 - 1.0);
  }
  function randomVariance_1($this, base, variance) {
    return _get_degrees__1(randomVariance_0($this, _get_degrees_(base), _get_degrees_(variance)));
  }
  function ParticleEmitterSimulator(emitter, emitterPos, seed) {
    this._emitter = emitter;
    this._emitterPos = emitterPos;
    this._seed = seed;
    this._random = Random_0(this._seed);
    var tmp = this;
    tmp._totalElapsedTime = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    this._timeUntilStop = Companion_getInstance_92()._NIL;
    this._emitting = true;
    var tmp_0 = this;
    var tmp0_safe_receiver = this._emitter._texture_3;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_width__0_k$();
    tmp_0._textureWidth = tmp1_elvis_lhs == null ? 16 : tmp1_elvis_lhs;
    this._particles = this.init_clrx0m_k$(new ParticleContainer(this._emitter._maxParticles));
  }
  ParticleEmitterSimulator.prototype._get_aliveCount__0_k$ = function () {
    var count_0 = 0;
    var tmp0_fastForEach_0 = this._particles;
    var tmp1_fastForEach_0 = tmp0_fastForEach_0._max_2;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_fastForEach_0)
      do {
        var n_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2__anonymous__3 = _Particle___init__impl_(n_2);
        if (tmp0_fastForEach_0._get_alive__b0fba1_k$(tmp2__anonymous__3)) {
          var tmp0_4 = count_0;
          count_0 = tmp0_4 + 1 | 0;
          Unit_getInstance();
        }}
       while (inductionVariable < tmp1_fastForEach_0);
    Unit_getInstance();
    return count_0;
  };
  ParticleEmitterSimulator.prototype._get_anyAlive__0_k$ = function () {
    return this._get_aliveCount__0_k$() > 0;
  };
  ParticleEmitterSimulator.prototype.init_clrx0m_k$ = function (_this__0) {
    var tmp0_fastForEach_0 = _this__0._max_2;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_fastForEach_0)
      do {
        var n_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__3 = _Particle___init__impl_(n_2);
        this.init_m11sqv_k$(_this__0, tmp1__anonymous__3, true);
        Unit_getInstance();
      }
       while (inductionVariable < tmp0_fastForEach_0);
    return _this__0;
  };
  ParticleEmitterSimulator.prototype.init_m11sqv_k$ = function (_this__0, particle, initialization) {
    var lifespan = coerceAtLeast_0(randomVariance_0(this, this._emitter._lifeSpan, this._emitter._lifespanVariance), 0.001);
    _this__0._set_totalTime__y3hcra_k$(particle, coerceAtLeast_1(lifespan, 0.0));
    if (initialization) {
      var ratio = _Particle___get_index__impl_(particle) / this._emitter._maxParticles;
      var tmp = this._emitter._lifeSpan;
      var tmp0__get_absoluteValue__0 = this._emitter._lifespanVariance;
      _this__0._set_currentTime__y3hcra_k$(particle, -(tmp + Math.abs(tmp0__get_absoluteValue__0)) * ratio);
    } else {
      _this__0._set_currentTime__y3hcra_k$(particle, 0.0);
    }
    var emitterX = this._emitterPos._get_x__0_k$();
    var emitterY = this._emitterPos._get_y__0_k$();
    _this__0._set_x__y3hcra_k$(particle, randomVariance(this, emitterX, this._emitter._sourcePositionVariance._x_1));
    _this__0._set_y__y3hcra_k$(particle, randomVariance(this, emitterY, this._emitter._sourcePositionVariance._y_1));
    _this__0._set_startX__y3hcra_k$(particle, emitterX);
    _this__0._set_startY__y3hcra_k$(particle, emitterY);
    var angle = randomVariance_1(this, this._emitter._angle_0, this._emitter._angleVariance);
    var speed = randomVariance_0(this, this._emitter._speed_1, this._emitter._speedVariance);
    var tmp0_cos_0_1 = _Angle___get_radians__impl_(angle);
    _this__0._set_velocityX__y3hcra_k$(particle, speed * Math.cos(tmp0_cos_0_1));
    var tmp0_sin_0_1 = _Angle___get_radians__impl_(angle);
    _this__0._set_velocityY__y3hcra_k$(particle, speed * Math.sin(tmp0_sin_0_1));
    var startRadius = randomVariance_0(this, this._emitter._maxRadius, this._emitter._maxRadiusVariance);
    var endRadius = randomVariance_0(this, this._emitter._minRadius, this._emitter._minRadiusVariance);
    _this__0._set_emitRadius__y3hcra_k$(particle, startRadius);
    _this__0._set_emitRadiusDelta__y3hcra_k$(particle, (endRadius - startRadius) / lifespan);
    _this__0._set_emitRotation__f2yw6_k$(particle, randomVariance_1(this, this._emitter._angle_0, this._emitter._angleVariance));
    _this__0._set_emitRotationDelta__f2yw6_k$(particle, randomVariance_1(this, this._emitter._rotatePerSecond, this._emitter._rotatePerSecondVariance));
    _this__0._set_radialAcceleration__y3hcra_k$(particle, randomVariance_0(this, this._emitter._radialAcceleration, this._emitter._radialAccelVariance));
    _this__0._set_tangentialAcceleration__y3hcra_k$(particle, randomVariance_0(this, this._emitter._tangentialAcceleration, this._emitter._tangentialAccelVariance));
    var startSize = coerceAtLeast_0(randomVariance_0(this, this._emitter._startSize, this._emitter._startSizeVariance), 0.1);
    var endSize = coerceAtLeast_0(randomVariance_0(this, this._emitter._endSize, this._emitter._endSizeVariance), 0.1);
    _this__0._set_scale__y3hcra_k$(particle, startSize / this._textureWidth);
    _this__0._set_scaleDelta__y3hcra_k$(particle, (endSize - startSize) / lifespan / this._textureWidth);
    _this__0._set_colorR__y3hcra_k$(particle, randomVariance(this, this._emitter._startColor._get_r__0_k$(), this._emitter._startColorVariance._get_r__0_k$()));
    _this__0._set_colorG__y3hcra_k$(particle, randomVariance(this, this._emitter._startColor._get_g__0_k$(), this._emitter._startColorVariance._get_g__0_k$()));
    _this__0._set_colorB__y3hcra_k$(particle, randomVariance(this, this._emitter._startColor._get_b__0_k$(), this._emitter._startColorVariance._get_b__0_k$()));
    _this__0._set_colorA__y3hcra_k$(particle, randomVariance(this, this._emitter._startColor._get_a__0_k$(), this._emitter._startColorVariance._get_a__0_k$()));
    var endColorR = randomVariance(this, this._emitter._endColor._get_r__0_k$(), this._emitter._endColorVariance._get_r__0_k$());
    var endColorG = randomVariance(this, this._emitter._endColor._get_g__0_k$(), this._emitter._endColorVariance._get_g__0_k$());
    var endColorB = randomVariance(this, this._emitter._endColor._get_b__0_k$(), this._emitter._endColorVariance._get_b__0_k$());
    var endColorA = randomVariance(this, this._emitter._endColor._get_a__0_k$(), this._emitter._endColorVariance._get_a__0_k$());
    _this__0._set_colorRdelta__y3hcra_k$(particle, (endColorR - _this__0._get_colorR__b0fba1_k$(particle)) / lifespan);
    _this__0._set_colorGdelta__y3hcra_k$(particle, (endColorG - _this__0._get_colorG__b0fba1_k$(particle)) / lifespan);
    _this__0._set_colorBdelta__y3hcra_k$(particle, (endColorB - _this__0._get_colorB__b0fba1_k$(particle)) / lifespan);
    _this__0._set_colorAdelta__y3hcra_k$(particle, (endColorA - _this__0._get_colorA__b0fba1_k$(particle)) / lifespan);
    var startRotation = randomVariance_1(this, this._emitter._rotationStart, this._emitter._rotationStartVariance);
    var endRotation = randomVariance_1(this, this._emitter._rotationEnd, this._emitter._rotationEndVariance);
    _this__0._set_rotation__f2yw6_k$(particle, startRotation);
    _this__0._set_rotationDelta__f2yw6_k$(particle, div_0(minus_2(endRotation, startRotation), lifespan));
    return particle;
  };
  ParticleEmitterSimulator.prototype.advance_9pfmvy_k$ = function (_this__0, particle, _elapsedTime) {
    var restTime = _this__0._get_totalTime__b0fba1_k$(particle) - _this__0._get_currentTime__b0fba1_k$(particle);
    var elapsedTime = restTime > _elapsedTime ? _elapsedTime : restTime;
    var tmp0_this = _this__0;
    var tmp1_receiver = particle;
    tmp0_this._set_currentTime__y3hcra_k$(tmp1_receiver, tmp0_this._get_currentTime__b0fba1_k$(tmp1_receiver) + elapsedTime);
    if (_this__0._get_currentTime__b0fba1_k$(particle) < 0.0)
      return Unit_getInstance();
    if (!_this__0._get_alive__b0fba1_k$(particle) ? this._emitting : false) {
      this.init_m11sqv_k$(_this__0, particle, false);
      Unit_getInstance();
    }if (!_this__0._get_alive__b0fba1_k$(particle))
      return Unit_getInstance();
    var tmp2_subject = this._emitter._emitterType;
    if (tmp2_subject.equals(Type_RADIAL_getInstance())) {
      var tmp3_this = _this__0;
      var tmp4_receiver = particle;
      tmp3_this._set_emitRotation__f2yw6_k$(tmp4_receiver, plus_5(tmp3_this._get_emitRotation__ybnru0_k$(tmp4_receiver), times(_this__0._get_emitRotationDelta__ybnru0_k$(particle), elapsedTime)));
      var tmp5_this = _this__0;
      var tmp6_receiver = particle;
      tmp5_this._set_emitRadius__y3hcra_k$(tmp6_receiver, tmp5_this._get_emitRadius__b0fba1_k$(tmp6_receiver) + _this__0._get_emitRadiusDelta__b0fba1_k$(particle) * elapsedTime);
      var tmp = this._emitter._sourcePosition._get_xf__0_k$();
      var tmp0_cos_0 = _this__0._get_emitRotation__ybnru0_k$(particle);
      var tmp0_cos_0_1 = _Angle___get_radians__impl_(tmp0_cos_0);
      _this__0._set_x__y3hcra_k$(particle, tmp - Math.cos(tmp0_cos_0_1) * _this__0._get_emitRadius__b0fba1_k$(particle));
      var tmp_0 = this._emitter._sourcePosition._get_yf__0_k$();
      var tmp1_sin_0 = _this__0._get_emitRotation__ybnru0_k$(particle);
      var tmp0_sin_0_1 = _Angle___get_radians__impl_(tmp1_sin_0);
      _this__0._set_y__y3hcra_k$(particle, tmp_0 - Math.sin(tmp0_sin_0_1) * _this__0._get_emitRadius__b0fba1_k$(particle));
    } else if (tmp2_subject.equals(Type_GRAVITY_getInstance())) {
      var distanceX = _this__0._get_x__b0fba1_k$(particle) - _this__0._get_startX__b0fba1_k$(particle);
      var distanceY = _this__0._get_y__b0fba1_k$(particle) - _this__0._get_startY__b0fba1_k$(particle);
      var tmp2_sqrt_0 = distanceX * distanceX + distanceY * distanceY;
      var distanceScalar = coerceAtLeast_1(Math.sqrt(tmp2_sqrt_0), 0.01);
      var radialX = distanceX / distanceScalar;
      var radialY = distanceY / distanceScalar;
      var tangentialX = radialX;
      var tangentialY = radialY;
      radialX = radialX * _this__0._get_radialAcceleration__b0fba1_k$(particle);
      radialY = radialY * _this__0._get_radialAcceleration__b0fba1_k$(particle);
      var newY = tangentialX;
      tangentialX = -tangentialY * _this__0._get_tangentialAcceleration__b0fba1_k$(particle);
      tangentialY = newY * _this__0._get_tangentialAcceleration__b0fba1_k$(particle);
      var tmp7_this = _this__0;
      var tmp8_receiver = particle;
      tmp7_this._set_velocityX__y3hcra_k$(tmp8_receiver, tmp7_this._get_velocityX__b0fba1_k$(tmp8_receiver) + elapsedTime * (this._emitter._gravity_0._x_1 + radialX + tangentialX));
      var tmp9_this = _this__0;
      var tmp10_receiver = particle;
      tmp9_this._set_velocityY__y3hcra_k$(tmp10_receiver, tmp9_this._get_velocityY__b0fba1_k$(tmp10_receiver) + elapsedTime * (this._emitter._gravity_0._y_1 + radialY + tangentialY));
      var tmp11_this = _this__0;
      var tmp12_receiver = particle;
      tmp11_this._set_x__y3hcra_k$(tmp12_receiver, tmp11_this._get_x__b0fba1_k$(tmp12_receiver) + _this__0._get_velocityX__b0fba1_k$(particle) * elapsedTime);
      var tmp13_this = _this__0;
      var tmp14_receiver = particle;
      tmp13_this._set_y__y3hcra_k$(tmp14_receiver, tmp13_this._get_y__b0fba1_k$(tmp14_receiver) + _this__0._get_velocityY__b0fba1_k$(particle) * elapsedTime);
    }var tmp15_this = _this__0;
    var tmp16_receiver = particle;
    tmp15_this._set_scale__y3hcra_k$(tmp16_receiver, tmp15_this._get_scale__b0fba1_k$(tmp16_receiver) + _this__0._get_scaleDelta__b0fba1_k$(particle) * elapsedTime);
    var tmp17_this = _this__0;
    var tmp18_receiver = particle;
    tmp17_this._set_rotation__f2yw6_k$(tmp18_receiver, plus_5(tmp17_this._get_rotation__ybnru0_k$(tmp18_receiver), times_0(_this__0._get_rotationDelta__ybnru0_k$(particle), elapsedTime)));
    var tmp19_this = _this__0;
    var tmp20_receiver = particle;
    tmp19_this._set_colorR__y3hcra_k$(tmp20_receiver, tmp19_this._get_colorR__b0fba1_k$(tmp20_receiver) + _this__0._get_colorRdelta__b0fba1_k$(particle) * elapsedTime);
    var tmp21_this = _this__0;
    var tmp22_receiver = particle;
    tmp21_this._set_colorG__y3hcra_k$(tmp22_receiver, tmp21_this._get_colorG__b0fba1_k$(tmp22_receiver) + _this__0._get_colorGdelta__b0fba1_k$(particle) * elapsedTime);
    var tmp23_this = _this__0;
    var tmp24_receiver = particle;
    tmp23_this._set_colorB__y3hcra_k$(tmp24_receiver, tmp23_this._get_colorB__b0fba1_k$(tmp24_receiver) + _this__0._get_colorBdelta__b0fba1_k$(particle) * elapsedTime);
    var tmp25_this = _this__0;
    var tmp26_receiver = particle;
    tmp25_this._set_colorA__y3hcra_k$(tmp26_receiver, tmp25_this._get_colorA__b0fba1_k$(tmp26_receiver) + _this__0._get_colorAdelta__b0fba1_k$(particle) * elapsedTime);
  };
  ParticleEmitterSimulator.prototype.simulate_zah5t7_k$ = function (time) {
    if (this._emitting) {
      var tmp0_this = this;
      tmp0_this._totalElapsedTime = TimeSpan__plus_impl(tmp0_this._totalElapsedTime, time);
      if (!equals_1(new TimeSpan(this._timeUntilStop), new TimeSpan(Companion_getInstance_92()._NIL)) ? TimeSpan__compareTo_impl(this._totalElapsedTime, this._timeUntilStop) >= 0 : false)
        this._emitting = false;
    }var timeSeconds = _TimeSpan___get_seconds__impl_(time);
    var tmp0_fastForEach_0 = this._particles;
    var tmp1_fastForEach_0 = tmp0_fastForEach_0._max_2;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_fastForEach_0)
      do {
        var n_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2__anonymous__3 = _Particle___init__impl_(n_2);
        this.advance_9pfmvy_k$(tmp0_fastForEach_0, tmp2__anonymous__3, timeSeconds);
      }
       while (inductionVariable < tmp1_fastForEach_0);
    Unit_getInstance();
  };
  ParticleEmitterSimulator.$metadata$ = {
    simpleName: 'ParticleEmitterSimulator',
    kind: 'class',
    interfaces: []
  };
  function ParticleEmitterView_init_$Init$(emitter, emitterPos, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      emitterPos = Companion_getInstance_31().invoke_0_k$();
    ParticleEmitterView.call($this, emitter, emitterPos);
    return $this;
  }
  function ParticleEmitterView_init_$Create$(emitter, emitterPos, $mask0, $marker) {
    return ParticleEmitterView_init_$Init$(emitter, emitterPos, $mask0, $marker, Object.create(ParticleEmitterView.prototype));
  }
  function _no_name_provided__473() {
  }
  _no_name_provided__473.prototype.invoke_pvq8x9_k$ = function ($this$addUpdater, dt) {
    $this$addUpdater._simulator.simulate_zah5t7_k$(dt);
  };
  _no_name_provided__473.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof ParticleEmitterView ? p1 : THROW_CCE();
    this.invoke_pvq8x9_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__473.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__474(this$0, $ctx, resultContinuation) {
    this._this$0_131 = this$0;
    this._$ctx_1 = $ctx;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__474.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__474.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__474.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = ensureNotNull(this._$ctx_1._views_8);
            suspendResult = this._this$0_131.forceLoadTexture$default_nkqr3g_k$(tmp_0, null, this._this$0_131._get_texture__0_k$(), 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__474.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__474(this._this$0_131, this._$ctx_1, completion);
    return i;
  };
  _no_name_provided__474.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $forceLoadTextureCOROUTINE$16(_this_, views_0, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__185 = _this_;
    this._views_6 = views_0;
    this._currentVfs = currentVfs;
    this._sourceFile = sourceFile;
  }
  $forceLoadTextureCOROUTINE$16.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this.__this__185._set_texture__qlpr75_k$(this._sourceFile);
            this.__this__185._textureLoaded = true;
            this._exceptionState = 2;
            this._ARGUMENT0_30 = this.__this__185._emitter_0;
            this._state_1 = 1;
            var tmp_0 = this._currentVfs.get_6wfw3l_k$('' + this._sourceFile);
            suspendResult = readBitmapSlice$default(tmp_0, false, null, null, 7, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this._ARGUMENT0_30._texture_3 = ARGUMENT;
            this._exceptionState = 4;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._exceptionState = 4;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              printStackTrace(e);
              this._state_1 = 3;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            this._exceptionState = 4;
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadTextureCOROUTINE$16.$metadata$ = {
    simpleName: '$forceLoadTextureCOROUTINE$16',
    kind: 'class',
    interfaces: []
  };
  function $forceLoadSourceFileCOROUTINE$17(_this_, views_0, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__186 = _this_;
    this._views_7 = views_0;
    this._currentVfs_0 = currentVfs;
    this._sourceFile_0 = sourceFile;
  }
  $forceLoadSourceFileCOROUTINE$17.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__186.baseForceLoadSourceFile_z71c2l_k$(this.__this__186, this._views_7, this._currentVfs_0, this._sourceFile_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = readParticleEmitter(this._currentVfs_0.get_6wfw3l_k$('' + this._sourceFile_0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.__this__186._emitter_0 = ARGUMENT;
            var tmp_0 = this.__this__186;
            var tmp_1 = this.__this__186._emitter_0;
            var tmp_2 = this.__this__186._get_emitterPos__0_k$();
            tmp_0._simulator = ParticleEmitterSimulator_init_$Create$(tmp_1, tmp_2, new Long(0, 0), 4, null);
            this.__this__186._set_scale__okcceq_k$(1.0);
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadSourceFileCOROUTINE$17.$metadata$ = {
    simpleName: '$forceLoadSourceFileCOROUTINE$17',
    kind: 'class',
    interfaces: []
  };
  function ParticleEmitterView(emitter, emitterPos) {
    View_init_$Init$(this);
    this._$$delegate_0_40 = new Mixin_3();
    this._emitter_0 = emitter;
    var tmp = this;
    tmp._simulator = ParticleEmitterSimulator_init_$Create$(emitter, emitterPos, new Long(0, 0), 4, null);
    this._timeUntilStop$delegate = timeUntilStop$factory(this._simulator);
    this._emitterPos$delegate = emitterPos$factory(this._simulator);
    this._emitting$delegate = emitting$factory(this._simulator);
    this._aliveCount$delegate = aliveCount$factory(this._simulator);
    this._anyAlive$delegate = anyAlive$factory(this._simulator);
    addUpdater(this, _no_name_provided_$factory_414());
    Unit_getInstance();
    this._cachedBlending = Companion_getInstance_163()._NORMAL;
    this._textureLoaded = false;
  }
  ParticleEmitterView.prototype.lazyLoadRenderInternal_hk6fpn_k$ = function (ctx, view) {
    this._$$delegate_0_40.lazyLoadRenderInternal_hk6fpn_k$(ctx, view);
  };
  ParticleEmitterView.prototype._set_sourceFile__qlpr75_k$ = function (_set___) {
    this._$$delegate_0_40._set_sourceFile__qlpr75_k$(_set___);
  };
  ParticleEmitterView.prototype._set_sourceTreeLoaded__rpwsgn_k$ = function (_set___) {
    this._$$delegate_0_40._sourceTreeLoaded = _set___;
  };
  ParticleEmitterView.prototype.baseForceLoadSourceFile_z71c2l_k$ = function (_this__0, views_0, currentVfs, sourceFile, $cont) {
    return this._$$delegate_0_40.baseForceLoadSourceFile_z71c2l_k$(_this__0, views_0, currentVfs, sourceFile, $cont);
  };
  ParticleEmitterView.prototype._get_emitterPos__0_k$ = function () {
    var tmp0_getValue_0 = emitterPos$factory_0();
    return this._emitterPos$delegate.get();
  };
  ParticleEmitterView.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (!this._get_visible__0_k$())
      return Unit_getInstance();
    if (!this._textureLoaded ? !(this._get_texture__0_k$() == null) : false) {
      this._textureLoaded = true;
      launchImmediately(ctx._coroutineContext_5, _no_name_provided_$factory_415(this, ctx, null));
      Unit_getInstance();
    }this.lazyLoadRenderInternal_hk6fpn_k$(ctx, this);
    if (!this._cachedBlending._srcRGB.equals(this._emitter_0._blendFuncSource) ? true : !this._cachedBlending._dstRGB.equals(this._emitter_0._blendFuncDestination)) {
      var tmp = this;
      var tmp_0 = this._emitter_0._blendFuncSource;
      var tmp_1 = this._emitter_0._blendFuncDestination;
      tmp._cachedBlending = Blending_init_$Create$_0(tmp_0, tmp_1, null, 4, null);
    }var tmp0_useBatcher_0 = ctx._batch_0;
    if (!(ctx._currentBatcher === tmp0_useBatcher_0)) {
      ctx.flush_sv8swh_k$();
      ctx._currentBatcher = tmp0_useBatcher_0;
    }var tmp1__anonymous__2 = ctx._ctx2d;
    var tmp0_elvis_lhs_4 = this._emitter_0._texture_3;
    var tmp_2;
    if (tmp0_elvis_lhs_4 == null) {
      return Unit_getInstance();
    } else {
      tmp_2 = tmp0_elvis_lhs_4;
    }
    var texture_3 = tmp_2;
    var cx_5 = texture_3._get_width__0_k$() * 0.5;
    var cy_6 = texture_3._get_height__0_k$() * 0.5;
    var tmp$ret$6;
    l$ret$7: do {
      var tmp0_alloc_0_7 = tmp1__anonymous__2._mpool;
      var temp_1_8 = tmp0_alloc_0_7.alloc_0_k$();
      try {
        temp_1_8.copyFrom_v5f3e9_k$(tmp1__anonymous__2._m);
        Unit_getInstance();
        var tmp_3;
        try {
          var tmp$ret$4;
          l$ret$5: do {
            var oldBlendFactors_1_3_9 = tmp1__anonymous__2._blendFactors;
            try {
              var tmp$ret$2;
              l$ret$3: do {
                var multiplyColor_1_3_4_10 = tmp1__anonymous__2._multiplyColor;
                try {
                  var tmp$ret$0;
                  l$ret$1: do {
                    var filtering_1_3_4_5_11 = tmp1__anonymous__2._filtering;
                    try {
                      tmp1__anonymous__2._blendFactors = this._cachedBlending;
                      tmp1__anonymous__2.setMatrix_skjkkf_k$(this._get_globalMatrix__0_k$());
                      var tmp0_fastForEach_0_6_12 = this._simulator._particles;
                      var tmp1_fastForEach_0_7_13 = tmp0_fastForEach_0_6_12._max_2;
                      var inductionVariable = 0;
                      if (inductionVariable < tmp1_fastForEach_0_7_13)
                        do {
                          var n_2_9_15 = inductionVariable;
                          inductionVariable = inductionVariable + 1 | 0;
                          var tmp2__anonymous__3_10_16 = _Particle___init__impl_(n_2_9_15);
                          if (tmp0_fastForEach_0_6_12._get_alive__b0fba1_k$(tmp2__anonymous__3_10_16)) {
                            var scale_4_11_17 = tmp0_fastForEach_0_6_12._get_scale__b0fba1_k$(tmp2__anonymous__3_10_16);
                            tmp1__anonymous__2._multiplyColor = RGBA__times_impl(tmp0_fastForEach_0_6_12._get_color__ip4rd6_k$(tmp2__anonymous__3_10_16), this._get_colorMul__12t64v_k$());
                            var tmp_4 = ctx.getTex_uoiv7r_k$(texture_3);
                            var tmp_5 = tmp0_fastForEach_0_6_12._get_x__b0fba1_k$(tmp2__anonymous__3_10_16) - cx_5 * scale_4_11_17;
                            var tmp_6 = tmp0_fastForEach_0_6_12._get_y__b0fba1_k$(tmp2__anonymous__3_10_16) - cy_6 * scale_4_11_17;
                            var tmp_7 = scale_4_11_17;
                            tmp1__anonymous__2.imageScale$default_hwup4g_k$(tmp_4, tmp_5, tmp_6, tmp_7, false, 16, null);
                          }}
                         while (inductionVariable < tmp1_fastForEach_0_7_13);
                      tmp$ret$0 = Unit_getInstance();
                      break l$ret$1;
                    }finally {
                      tmp1__anonymous__2._filtering = filtering_1_3_4_5_11;
                    }
                  }
                   while (false);
                  tmp$ret$2 = tmp$ret$0;
                  break l$ret$3;
                }finally {
                  tmp1__anonymous__2._multiplyColor = multiplyColor_1_3_4_10;
                }
              }
               while (false);
              tmp$ret$4 = tmp$ret$2;
              break l$ret$5;
            }finally {
              tmp1__anonymous__2._blendFactors = oldBlendFactors_1_3_9;
            }
          }
           while (false);
          tmp_3 = tmp$ret$4;
        }finally {
          tmp1__anonymous__2._m.copyFrom_v5f3e9_k$(temp_1_8);
          Unit_getInstance();
        }
        tmp$ret$6 = tmp_3;
        break l$ret$7;
      }finally {
        tmp0_alloc_0_7.free_iav7o_k$(temp_1_8);
      }
    }
     while (false);
  };
  ParticleEmitterView.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    out.setBounds_w0xdj4_k$(-30, -30, 30, 30);
    Unit_getInstance();
  };
  ParticleEmitterView.prototype._set_texture__qlpr75_k$ = function (value) {
    this._textureLoaded = false;
    this._emitter_0._textureName = value;
  };
  ParticleEmitterView.prototype._get_texture__0_k$ = function () {
    return this._emitter_0._textureName;
  };
  ParticleEmitterView.prototype.forceLoadTexture_mwdcj_k$ = function (views_0, currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadTextureCOROUTINE$16(this, views_0, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  ParticleEmitterView.prototype.forceLoadTexture$default_nkqr3g_k$ = function (views_0, currentVfs, sourceFile, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      currentVfs = views_0._currentVfs_9;
    if (!(($mask0 & 4) === 0))
      sourceFile = null;
    return this.forceLoadTexture_mwdcj_k$(views_0, currentVfs, sourceFile, $cont);
  };
  ParticleEmitterView.prototype.forceLoadSourceFile_mwdcj_k$ = function (views_0, currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadSourceFileCOROUTINE$17(this, views_0, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  ParticleEmitterView.$metadata$ = {
    simpleName: 'ParticleEmitterView',
    kind: 'class',
    interfaces: [ViewFileRef]
  };
  function timeUntilStop$factory($b0) {
    return getPropertyCallableRef('timeUntilStop', 0, KMutableProperty0, function () {
      return new TimeSpan($b0._timeUntilStop);
    }, function (value) {
      $b0._timeUntilStop = value._milliseconds;
      return Unit_getInstance();
    });
  }
  function emitterPos$factory($b0) {
    return getPropertyCallableRef('emitterPos', 0, KMutableProperty0, function () {
      return $b0._emitterPos;
    }, function (value) {
      $b0._emitterPos = value;
      return Unit_getInstance();
    });
  }
  function emitting$factory($b0) {
    return getPropertyCallableRef('emitting', 0, KMutableProperty0, function () {
      return $b0._emitting;
    }, function (value) {
      $b0._emitting = value;
      return Unit_getInstance();
    });
  }
  function aliveCount$factory($b0) {
    return getPropertyCallableRef('aliveCount', 0, KProperty0, function () {
      return $b0._get_aliveCount__0_k$();
    }, null);
  }
  function anyAlive$factory($b0) {
    return getPropertyCallableRef('anyAlive', 0, KProperty0, function () {
      return $b0._get_anyAlive__0_k$();
    }, null);
  }
  function emitterPos$factory_0() {
    return getPropertyCallableRef('emitterPos', 1, KProperty1, function (receiver) {
      return receiver._get_emitterPos__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_414() {
    var i = new _no_name_provided__473();
    return function (p1, p2) {
      i.invoke_pvq8x9_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_415(this$0, $ctx, resultContinuation) {
    var i = new _no_name_provided__474(this$0, $ctx, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function SmallSet() {
    this._items_5 = FastArrayList_init_$Create$();
  }
  SmallSet.prototype.add_iav7o_k$ = function (item) {
    if (this._items_5.contains_2bq_k$(item))
      return Unit_getInstance();
    this._items_5.add_2bq_k$(item);
    Unit_getInstance();
  };
  SmallSet.prototype.remove_iav7o_k$ = function (item) {
    this._items_5.remove_2bq_k$(item);
    Unit_getInstance();
  };
  SmallSet.prototype.clear_sv8swh_k$ = function () {
    this._items_5.clear_sv8swh_k$();
  };
  SmallSet.$metadata$ = {
    simpleName: 'SmallSet',
    kind: 'class',
    interfaces: []
  };
  function BitmapTextureInfo() {
    this._textureBase = new Base(null, 0, 0);
    this._slices = FastIdentityMap();
  }
  BitmapTextureInfo.prototype.reset_sv8swh_k$ = function () {
    this._textureBase._base_5 = null;
    this._textureBase._version_3 = -1;
    this._textureBase._width_20 = 0;
    this._textureBase._height_21 = 0;
    clear(this._slices);
  };
  BitmapTextureInfo.$metadata$ = {
    simpleName: 'BitmapTextureInfo',
    kind: 'class',
    interfaces: []
  };
  function getTextureInfo($this, bitmap) {
    if ($this._cachedBitmap === bitmap)
      return ensureNotNull($this._cachedBitmapTextureInfo);
    if ($this._cachedBitmap2 === bitmap)
      return ensureNotNull($this._cachedBitmapTextureInfo2);
    $this._referencedBitmapsSinceGC.add_iav7o_k$(bitmap);
    if (equals_1($this._cachedBitmap, bitmap))
      return ensureNotNull($this._cachedBitmapTextureInfo);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getOrPut_0 = $this._bitmapsToTextureBase;
      var res_1 = get(tmp0_getOrPut_0, bitmap);
      if (!(res_1 == null)) {
        tmp$ret$0 = res_1;
        break l$ret$1;
      }var tmp0_also_0_4 = $this._textureInfoPool.alloc_0_k$();
      var base_2_5 = tmp0_also_0_4._textureBase;
      base_2_5._version_3 = -1;
      base_2_5._base_5 = $this._ag_2.createTexture_vcj5fe_k$(bitmap._premultiplied_0);
      base_2_5._width_20 = bitmap._width_2;
      base_2_5._height_21 = bitmap._height_3;
      var out_2 = tmp0_also_0_4;
      set(tmp0_getOrPut_0, bitmap, out_2);
      tmp$ret$0 = out_2;
    }
     while (false);
    var textureInfo = tmp$ret$0;
    $this._cachedBitmap2 = $this._cachedBitmap;
    $this._cachedBitmapTextureInfo2 = $this._cachedBitmapTextureInfo;
    var base = textureInfo._textureBase;
    $this._cachedBitmap = bitmap;
    $this._cachedBitmapTextureInfo = textureInfo;
    if (!(bitmap._contentVersion === base._version_3)) {
      base._version_3 = bitmap._contentVersion;
      base.update_dudbe6_k$(bitmap, bitmap._mipmaps);
    }return textureInfo;
  }
  function removeCache($this) {
    $this._cachedBitmap = null;
    $this._cachedBitmapTextureInfo = null;
    $this._cachedBitmap2 = null;
    $this._cachedBitmapTextureInfo2 = null;
    $this._cachedBmpSlice = null;
    $this._cachedBmpSliceTexture = null;
    $this._cachedBmpSlice2 = null;
    $this._cachedBmpSliceTexture2 = null;
  }
  function _no_name_provided__475() {
  }
  _no_name_provided__475.prototype.invoke_tzuija_k$ = function (it) {
    it.reset_sv8swh_k$();
  };
  _no_name_provided__475.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_tzuija_k$(p1 instanceof BitmapTextureInfo ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__475.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__476() {
  }
  _no_name_provided__476.prototype.invoke_ha5a7z_k$ = function (it) {
    return new BitmapTextureInfo();
  };
  _no_name_provided__476.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__476.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AgBitmapTextureManager(ag) {
    this._ag_2 = ag;
    this._referencedBitmapsSinceGC = new SmallSet();
    this._referencedBitmaps = FastArrayList_init_$Create$();
    this._framesBetweenGC = 60;
    var tmp = this;
    var tmp_0 = _no_name_provided_$factory_416();
    tmp._textureInfoPool = Pool_init_$Create$(tmp_0, 0, _no_name_provided_$factory_417(), 2, null);
    this._bitmapsToTextureBase = FastIdentityMap();
    this._cachedBitmap = null;
    this._cachedBitmapTextureInfo = null;
    this._cachedBitmap2 = null;
    this._cachedBitmapTextureInfo2 = null;
    this._cachedBmpSlice = null;
    this._cachedBmpSliceTexture = null;
    this._cachedBmpSlice2 = null;
    this._cachedBmpSliceTexture2 = null;
    this._fcount = 0;
  }
  AgBitmapTextureManager.prototype.getTextureBase_nc8knv_k$ = function (bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap)._textureBase);
  };
  AgBitmapTextureManager.prototype.getTexture_uoiv7r_k$ = function (slice_1) {
    if (this._cachedBmpSlice === slice_1)
      return ensureNotNull(this._cachedBmpSliceTexture);
    if (this._cachedBmpSlice2 === slice_1)
      return ensureNotNull(this._cachedBmpSliceTexture2);
    var info = getTextureInfo(this, slice_1._bmpBase);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getOrPut_0 = info._slices;
      var res_1 = get(tmp0_getOrPut_0, slice_1);
      if (!(res_1 == null)) {
        tmp$ret$0 = res_1;
        break l$ret$1;
      }var tmp = ensureNotNull(info._textureBase);
      var out_2 = Texture_init_$Create$(tmp, 0, 0, 0, 0, 30, null).slice_uebyw0_k$(Companion_getInstance_35().invoke_w0xdj4_k$(slice_1._get_left__0_k$(), slice_1._get_top__0_k$(), slice_1._get_width__0_k$(), slice_1._get_height__0_k$()));
      set(tmp0_getOrPut_0, slice_1, out_2);
      tmp$ret$0 = out_2;
    }
     while (false);
    var texture = tmp$ret$0;
    this._cachedBmpSlice2 = this._cachedBmpSlice;
    this._cachedBmpSliceTexture2 = this._cachedBmpSliceTexture;
    this._cachedBmpSlice = slice_1;
    this._cachedBmpSliceTexture = texture;
    return texture;
  };
  AgBitmapTextureManager.prototype.afterRender_sv8swh_k$ = function () {
    removeCache(this);
    var tmp0_this = this;
    var tmp1 = tmp0_this._fcount;
    tmp0_this._fcount = tmp1 + 1 | 0;
    Unit_getInstance();
    if (this._fcount >= this._framesBetweenGC) {
      this._fcount = 0;
      this.gc_sv8swh_k$();
    }};
  AgBitmapTextureManager.prototype.gc_sv8swh_k$ = function () {
    var tmp0_fastForEach_0 = this._referencedBitmaps;
    var array_1 = tmp0_fastForEach_0._array_4;
    var n_2 = 0;
    while (n_2 < array_1.length) {
      var tmp0_4 = n_2;
      n_2 = tmp0_4 + 1 | 0;
      var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
      var tmp1__anonymous__5 = tmp0_unsafeCast_0_3;
      var tmp0_contains_0_6 = this._referencedBitmapsSinceGC;
      if (!tmp0_contains_0_6._items_5.contains_2bq_k$(tmp1__anonymous__5)) {
        this.removeBitmap_dwbv7a_k$(tmp1__anonymous__5);
      } else {
      }
    }
    this._referencedBitmaps.clear_sv8swh_k$();
    this._referencedBitmaps.addAll_dxd4eo_k$(this._referencedBitmapsSinceGC._items_5);
    Unit_getInstance();
    this._referencedBitmapsSinceGC.clear_sv8swh_k$();
  };
  AgBitmapTextureManager.prototype.removeBitmap_dwbv7a_k$ = function (bmp) {
    var tmp0_elvis_lhs = getAndRemove(this._bitmapsToTextureBase, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    this._referencedBitmapsSinceGC.remove_iav7o_k$(bmp);
    if (equals_1(this._cachedBitmapTextureInfo, info) ? true : equals_1(this._cachedBitmapTextureInfo2, info))
      removeCache(this);
    info._textureBase.close_sv8swh_k$();
    this._textureInfoPool.free_iav7o_k$(info);
  };
  AgBitmapTextureManager.$metadata$ = {
    simpleName: 'AgBitmapTextureManager',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_416() {
    var i = new _no_name_provided__475();
    return function (p1) {
      i.invoke_tzuija_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_417() {
    var i = new _no_name_provided__476();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  var logger;
  function getShaderProgramIndex($this, premultiplied, preadd) {
    return insert_0(insert_0(0, premultiplied, 0), preadd, 1);
  }
  function _no_name_provided__477() {
  }
  _no_name_provided__477.prototype.invoke_dzcoxa_k$ = function ($this$VertexShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$VertexShader.SET_k3gp7z_k$(tmp0_apply_0._v_Tex, tmp0_apply_0._a_Tex);
    $this$VertexShader.SET_k3gp7z_k$(Companion_getInstance_200()._v_TexIndex, Companion_getInstance_200()._a_TexIndex);
    $this$VertexShader.SET_k3gp7z_k$(Companion_getInstance_200()._v_ColMul, Companion_getInstance_200()._a_ColMul);
    $this$VertexShader.SET_k3gp7z_k$(Companion_getInstance_200()._v_ColAdd, Companion_getInstance_200()._a_ColAdd);
    $this$VertexShader.SET_k3gp7z_k$($this$VertexShader._out_8, $this$VertexShader.times_l29sts_k$($this$VertexShader.times_l29sts_k$(tmp0_apply_0._u_ProjMat, tmp0_apply_0._u_ViewMat), $this$VertexShader.vec4_ldyooh_k$([DefaultShaders_getInstance()._a_Pos, $this$VertexShader._get_lit__a9njmo_k$(0.0), $this$VertexShader._get_lit__a9njmo_k$(1.0)])));
    Unit_getInstance();
  };
  _no_name_provided__477.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__477.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__478($premultiplied, $preadd) {
    this._$premultiplied = $premultiplied;
    this._$preadd = $preadd;
  }
  _no_name_provided__478.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    var inductionVariable = 0;
    var last_1 = 4;
    if (inductionVariable < last_1)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_IF_0_4 = $this$FragmentShader.eq_l29sts_k$(Companion_getInstance_200()._v_TexIndex, $this$FragmentShader._get_lit__a9njmo_k$(n_3));
        var body_1_5 = new Builder($this$FragmentShader._type_12);
        body_1_5.SET_k3gp7z_k$(body_1_5._out_8, body_1_5.texture2D_s4jwrm_k$(Companion_getInstance_200()._u_TexN[n_3], body_1_5.get_v2sg9q_k$(tmp0_apply_0._v_Tex, 'xy')));
        var tmp = new Stms(body_1_5._outputStms);
        var stmIf_2_6 = If_init_$Create$(tmp0_IF_0_4, tmp, null, 4, null);
        var tmp0_this_3_7 = $this$FragmentShader;
        var tmp0_plusAssign_0_4_8 = tmp0_this_3_7._outputStms;
        tmp0_plusAssign_0_4_8.add_2bq_k$(stmIf_2_6);
        Unit_getInstance();
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    if (this._$premultiplied) {
      $this$FragmentShader.SET_k3gp7z_k$($this$FragmentShader.get_v2sg9q_k$($this$FragmentShader._out_8, 'rgb'), $this$FragmentShader.div_l29sts_k$($this$FragmentShader.get_v2sg9q_k$($this$FragmentShader._out_8, 'rgb'), $this$FragmentShader.get_v2sg9q_k$($this$FragmentShader._out_8, 'a')));
    }if (this._$preadd) {
      $this$FragmentShader.SET_k3gp7z_k$($this$FragmentShader._out_8, $this$FragmentShader.times_l29sts_k$($this$FragmentShader.clamp_h5nd2r_k$($this$FragmentShader.plus_l29sts_k$($this$FragmentShader.get_v2sg9q_k$($this$FragmentShader._out_8, 'rgba'), $this$FragmentShader.times_l29sts_k$($this$FragmentShader.minus_l29sts_k$($this$FragmentShader.get_v2sg9q_k$(Companion_getInstance_200()._v_ColAdd, 'rgba'), $this$FragmentShader.vec4_ldyooh_k$([$this$FragmentShader._get_lit__a9njmo_k$(0.5), $this$FragmentShader._get_lit__a9njmo_k$(0.5), $this$FragmentShader._get_lit__a9njmo_k$(0.5), $this$FragmentShader._get_lit__a9njmo_k$(0.5)])), $this$FragmentShader._get_lit__a9njmo_k$(2.0))), $this$FragmentShader._get_lit__a9njmo_k$(0.0), $this$FragmentShader._get_lit__a9njmo_k$(1.0)), $this$FragmentShader.get_v2sg9q_k$(Companion_getInstance_200()._v_ColMul, 'rgba')));
    } else {
      $this$FragmentShader.SET_k3gp7z_k$($this$FragmentShader._out_8, $this$FragmentShader.plus_l29sts_k$($this$FragmentShader.times_l29sts_k$($this$FragmentShader.get_v2sg9q_k$($this$FragmentShader._out_8, 'rgba'), $this$FragmentShader.get_v2sg9q_k$(Companion_getInstance_200()._v_ColMul, 'rgba')), $this$FragmentShader.times_l29sts_k$($this$FragmentShader.minus_l29sts_k$($this$FragmentShader.get_v2sg9q_k$(Companion_getInstance_200()._v_ColAdd, 'rgba'), $this$FragmentShader.vec4_ldyooh_k$([$this$FragmentShader._get_lit__a9njmo_k$(0.5), $this$FragmentShader._get_lit__a9njmo_k$(0.5), $this$FragmentShader._get_lit__a9njmo_k$(0.5), $this$FragmentShader._get_lit__a9njmo_k$(0.5)])), $this$FragmentShader._get_lit__a9njmo_k$(2.0))));
    }
    if (this._$premultiplied) {
      var tmp1_IF_0_9 = $this$FragmentShader.le_l29sts_k$($this$FragmentShader.get_v2sg9q_k$($this$FragmentShader._out_8, 'a'), $this$FragmentShader._get_lit__a9njmo_k$(0.0));
      var body_1_10 = new Builder($this$FragmentShader._type_12);
      body_1_10.DISCARD_sv8swh_k$();
      var tmp_0 = new Stms(body_1_10._outputStms);
      var stmIf_2_11 = If_init_$Create$(tmp1_IF_0_9, tmp_0, null, 4, null);
      var tmp0_this_3_12 = $this$FragmentShader;
      var tmp0_plusAssign_0_4_13 = tmp0_this_3_12._outputStms;
      tmp0_plusAssign_0_4_13.add_2bq_k$(stmIf_2_11);
      Unit_getInstance();
      Unit_getInstance();
    }Unit_getInstance();
  };
  _no_name_provided__478.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__478.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
    var tmp0_set_0 = pos + 0 | 0;
    var tmp1_set_0 = toShort(i0);
    indicesI16[tmp0_set_0] = tmp1_set_0;
    var tmp2_set_0 = pos + 1 | 0;
    var tmp3_set_0 = toShort(i1);
    indicesI16[tmp2_set_0] = tmp3_set_0;
    var tmp4_set_0 = pos + 2 | 0;
    var tmp5_set_0 = toShort(i2);
    indicesI16[tmp4_set_0] = tmp5_set_0;
    var tmp6_set_0 = pos + 3 | 0;
    var tmp7_set_0 = toShort(i3);
    indicesI16[tmp6_set_0] = tmp7_set_0;
    var tmp8_set_0 = pos + 4 | 0;
    var tmp9_set_0 = toShort(i4);
    indicesI16[tmp8_set_0] = tmp9_set_0;
    var tmp10_set_0 = pos + 5 | 0;
    var tmp11_set_0 = toShort(i5);
    indicesI16[tmp10_set_0] = tmp11_set_0;
    return 6;
  }
  function applyMatrix($this, matrix, idx, vcount) {
    var tmp0__get_f32__0 = $this._vertices_4;
    var f32 = tmp0__get_f32__0._arrayFloat;
    var idx_0 = idx;
    var ma = matrix._get_af__0_k$();
    var mb = matrix._get_bf__0_k$();
    var mc = matrix._get_cf__0_k$();
    var md = matrix._get_df__0_k$();
    var mtx = matrix._get_txf__0_k$();
    var mty = matrix._get_tyf__0_k$();
    var inductionVariable = 0;
    if (inductionVariable < vcount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_get_0 = idx_0 + 0 | 0;
        var x = f32[tmp1_get_0];
        var tmp2_get_0 = idx_0 + 1 | 0;
        var y = f32[tmp2_get_0];
        var tmp3_set_0 = idx_0 + 0 | 0;
        var tmp4_set_0 = Companion_getInstance_29().transformXf_ktgjr4_k$(ma, mb, mc, md, mtx, mty, x, y);
        f32[tmp3_set_0] = tmp4_set_0;
        var tmp5_set_0 = idx_0 + 1 | 0;
        var tmp6_set_0 = Companion_getInstance_29().transformYf_ktgjr4_k$(ma, mb, mc, md, mtx, mty, x, y);
        f32[tmp5_set_0] = tmp6_set_0;
        idx_0 = idx_0 + 6 | 0;
      }
       while (inductionVariable < vcount);
  }
  function checkAvailable($this, indices, vertices) {
    return ($this._indexPos + indices | 0) < $this._maxIndices ? true : ($this._vertexPos + vertices | 0) < $this._maxVertices;
  }
  function Companion_201() {
    Companion_instance_200 = this;
    this._DEFAULT_BATCH_QUADS = 4096;
    this._MAX_BATCH_QUADS = 16383;
    var tmp0_trace_0 = logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_5xis2i_k$(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog_sbdqh6_k$(tmp0_log_0_1, 'BatchBuilder2D.Companion[0]');
    }this._a_ColMul = DefaultShaders_getInstance()._a_Col;
    var tmp = this;
    var tmp_0 = VarType_Byte4_getInstance();
    tmp._a_ColAdd = Attribute_init_$Create$_0('a_Col2', tmp_0, true, null, 8, null);
    var tmp0_trace_0_0 = logger;
    var tmp0_log_0_1_0 = Level_TRACE_getInstance();
    if (tmp0_trace_0_0.isEnabled_5xis2i_k$(tmp0_log_0_1_0)) {
      tmp0_trace_0_0.actualLog_sbdqh6_k$(tmp0_log_0_1_0, 'BatchBuilder2D.Companion[1]');
    }this._v_ColMul = DefaultShaders_getInstance()._v_Col;
    var tmp_1 = this;
    var tmp_2 = VarType_Byte4_getInstance();
    tmp_1._v_ColAdd = Varying_init_$Create$_0('v_Col2', tmp_2, null, 4, null);
    this._a_TexIndex = Attribute_init_$Create$('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance());
    this._v_TexIndex = Varying_init_$Create$('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = 4;
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      var tmp_7 = tmp_4;
      var tmp_8 = '' + 'u_Tex' + tmp_7;
      var tmp_9 = VarType_TextureUnit_getInstance();
      tmp_6[tmp_7] = Uniform_init_$Create$(tmp_8, tmp_9, null, 4, null);
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3._u_TexN = tmp_6;
    var tmp0_trace_0_1 = logger;
    var tmp0_log_0_1_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0_1.isEnabled_5xis2i_k$(tmp0_log_0_1_1)) {
      tmp0_trace_0_1.actualLog_sbdqh6_k$(tmp0_log_0_1_1, 'BatchBuilder2D.Companion[2]');
    }this._LAYOUT = VertexLayout_init_$Create$([DefaultShaders_getInstance()._a_Pos, DefaultShaders_getInstance()._a_Tex, this._a_ColMul, this._a_ColAdd]);
    this._LAYOUT_TEX_INDEX = VertexLayout_init_$Create$([this._a_TexIndex]);
    var tmp_10 = this;
    tmp_10._VERTEX = VertexShader_0(_no_name_provided_$factory_420());
    var tmp0_trace_0_2 = logger;
    var tmp0_log_0_1_2 = Level_TRACE_getInstance();
    if (tmp0_trace_0_2.isEnabled_5xis2i_k$(tmp0_log_0_1_2)) {
      tmp0_trace_0_2.actualLog_sbdqh6_k$(tmp0_log_0_1_2, 'BatchBuilder2D.Companion[3]');
    }var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = 4;
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var premultiplied = extractBool(tmp_15, 0);
      var preadd = extractBool(tmp_15, 1);
      tmp_14[tmp_15] = Companion_getInstance_200().buildTextureLookupFragment_oiei0w_k$(premultiplied, preadd);
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11._FRAGMENTS = tmp_14;
    this._FRAGMENT_PRE = this._FRAGMENTS[getShaderProgramIndex(this, true, false)];
    this._FRAGMENT_NOPRE = this._FRAGMENTS[getShaderProgramIndex(this, false, false)];
    var tmp_16 = this;
    var tmp_17 = 0;
    var tmp_18 = 4;
    var tmp_19 = fillArrayVal(Array(tmp_18), null);
    while (tmp_17 < tmp_18) {
      var tmp_20 = tmp_17;
      var premultiplied_0 = extractBool(tmp_20, 0);
      var preadd_0 = extractBool(tmp_20, 1);
      tmp_19[tmp_20] = new Program(Companion_getInstance_200()._VERTEX, Companion_getInstance_200()._FRAGMENTS[tmp_20], '' + 'BatchBuilder2D.' + (premultiplied_0 ? 'Premultiplied' : 'NoPremultiplied') + '.Tinted' + (preadd_0 ? '.Preadd' : ''));
      tmp_17 = tmp_17 + 1 | 0;
    }
    tmp_16._PROGRAMS = tmp_19;
    this._PROGRAM_PRE = this._PROGRAMS[getShaderProgramIndex(this, true, false)];
    this._PROGRAM_NOPRE = this._PROGRAMS[getShaderProgramIndex(this, false, false)];
    var tmp0_trace_0_3 = logger;
    var tmp0_log_0_1_3 = Level_TRACE_getInstance();
    if (tmp0_trace_0_3.isEnabled_5xis2i_k$(tmp0_log_0_1_3)) {
      tmp0_trace_0_3.actualLog_sbdqh6_k$(tmp0_log_0_1_3, 'BatchBuilder2D.Companion[4]');
    }}
  Companion_201.prototype.buildTextureLookupFragment_oiei0w_k$ = function (premultiplied, preadd) {
    return FragmentShader_0(_no_name_provided_$factory_421(premultiplied, preadd));
  };
  Companion_201.prototype.buildTextureLookupFragment$default_etv6iq_k$ = function (premultiplied, preadd, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      preadd = false;
    return this.buildTextureLookupFragment_oiei0w_k$(premultiplied, preadd);
  };
  Companion_201.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_200;
  function Companion_getInstance_200() {
    if (Companion_instance_200 == null)
      new Companion_201();
    return Companion_instance_200;
  }
  function _no_name_provided__479(this$0) {
    this._this$0_132 = this$0;
  }
  _no_name_provided__479.prototype.invoke_89eg7z_k$ = function (it) {
    this._this$0_132.flush$default_9k51td_k$(false, false, 3, null);
  };
  _no_name_provided__479.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_89eg7z_k$(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__479.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__480(this$0) {
    this._this$0_133 = this$0;
  }
  _no_name_provided__480.prototype.invoke_0_k$ = function () {
    var tmp = [to(DefaultShaders_getInstance()._u_ProjMat, this._this$0_133._projMat), to(DefaultShaders_getInstance()._u_ViewMat, this._this$0_133._viewMat)];
    var tmp_0 = 0;
    var tmp_1 = 4;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = to(Companion_getInstance_200()._u_TexN[tmp_3], this._this$0_133._textureUnitN[tmp_3]);
      tmp_0 = tmp_0 + 1 | 0;
    }
    return UniformValues_init_$Create$(arrayConcat([tmp, tmp_2]));
  };
  _no_name_provided__480.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BatchBuilder2D(ctx, reqMaxQuads) {
    Companion_getInstance_200();
    this._ctx_6 = ctx;
    this._reqMaxQuads = reqMaxQuads;
    var tmp = this;
    var tmp0_min_0 = this._reqMaxQuads;
    var tmp1_min_0 = Companion_getInstance_200()._MAX_BATCH_QUADS;
    tmp._maxQuads = Math.min(tmp0_min_0, tmp1_min_0);
    this._texManager = this._ctx_6._agBitmapTextureManager;
    this._ag_3 = this._ctx_6._ag_5;
    var tmp0_trace_0 = logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_5xis2i_k$(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog_sbdqh6_k$(tmp0_log_0_1, 'BatchBuilder2D[0]');
    }this._ctx_6._flushers.add_o72mru_k$(_no_name_provided_$factory_418(this));
    Unit_getInstance();
    this._flipRenderTexture_0 = true;
    this._maxQuadsMargin = this._maxQuads + 9 | 0;
    this._maxVertices = imul(this._maxQuads, 4);
    this._maxIndices = imul(this._maxQuads, 6);
    var tmp0_trace_0_0 = logger;
    var tmp0_log_0_1_0 = Level_TRACE_getInstance();
    if (tmp0_trace_0_0.isEnabled_5xis2i_k$(tmp0_log_0_1_0)) {
      tmp0_trace_0_0.actualLog_sbdqh6_k$(tmp0_log_0_1_0, 'BatchBuilder2D[1]');
    }this._vertices_4 = Companion_getInstance_97().alloc_ha5a7z_k$(imul(24, this._maxVertices));
    this._verticesTexIndex = new Int8Array(this._maxVertices);
    this._indices_0 = Companion_getInstance_97().alloc_ha5a7z_k$(imul(2, this._maxIndices));
    var tmp_0 = this;
    var tmp0__get_i16__0 = this._indices_0;
    tmp_0._indicesI16 = tmp0__get_i16__0._arrayShort;
    var tmp_1 = this;
    var tmp0__get_i32__0 = this._vertices_4;
    tmp_1._verticesI32 = tmp0__get_i32__0._arrayInt;
    var tmp_2 = this;
    var tmp0__get_f32__0 = this._vertices_4;
    tmp_2._verticesF32 = tmp0__get_f32__0._arrayFloat;
    this._verticesData_0 = this._vertices_4._data_15;
    this._verticesFast32 = this._vertices_4._fast32;
    var tmp0_trace_0_1 = logger;
    var tmp0_log_0_1_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0_1.isEnabled_5xis2i_k$(tmp0_log_0_1_1)) {
      tmp0_trace_0_1.actualLog_sbdqh6_k$(tmp0_log_0_1_1, 'BatchBuilder2D[2]');
    }this.__vertexCount = 0;
    this._vertexPos = 0;
    this._indexPos = 0;
    this._currentTexIndex = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = 4;
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      var tmp_7 = tmp_4;
      tmp_6[tmp_7] = null;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3._currentTexN = tmp_6;
    this._currentSmoothing = false;
    this._currentBlendFactors = BlendMode_NORMAL_getInstance_0()._factors;
    this._currentProgram = null;
    var tmp0_trace_0_2 = logger;
    var tmp0_log_0_1_2 = Level_TRACE_getInstance();
    if (tmp0_trace_0_2.isEnabled_5xis2i_k$(tmp0_log_0_1_2)) {
      tmp0_trace_0_2.actualLog_sbdqh6_k$(tmp0_log_0_1_2, 'BatchBuilder2D[3]');
    }this._vertexBuffer = this._ag_3.createVertexBuffer_0_k$();
    this._texIndexVertexBuffer = this._ag_3.createVertexBuffer_0_k$();
    this._indexBuffer = this._ag_3.createIndexBuffer_0_k$();
    var tmp0_trace_0_3 = logger;
    var tmp0_log_0_1_3 = Level_TRACE_getInstance();
    if (tmp0_trace_0_3.isEnabled_5xis2i_k$(tmp0_log_0_1_3)) {
      tmp0_trace_0_3.actualLog_sbdqh6_k$(tmp0_log_0_1_3, 'BatchBuilder2D[4]');
    }var tmp_8 = this;
    tmp_8._stencil_0 = StencilState_init_$Create$(false, null, null, null, null, null, 0, 0, 0, 511, null);
    var tmp0_trace_0_4 = logger;
    var tmp0_log_0_1_4 = Level_TRACE_getInstance();
    if (tmp0_trace_0_4.isEnabled_5xis2i_k$(tmp0_log_0_1_4)) {
      tmp0_trace_0_4.actualLog_sbdqh6_k$(tmp0_log_0_1_4, 'BatchBuilder2D[5]');
    }var tmp_9 = this;
    tmp_9._colorMask_0 = ColorMaskState_init_$Create$(false, false, false, false, 15, null);
    var tmp0_trace_0_5 = logger;
    var tmp0_log_0_1_5 = Level_TRACE_getInstance();
    if (tmp0_trace_0_5.isEnabled_5xis2i_k$(tmp0_log_0_1_5)) {
      tmp0_trace_0_5.actualLog_sbdqh6_k$(tmp0_log_0_1_5, 'BatchBuilder2D[6]');
    }this._scissor_1 = null;
    var tmp_10 = this;
    tmp_10._identity = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp0_trace_0_6 = logger;
    var tmp0_log_0_1_6 = Level_TRACE_getInstance();
    if (tmp0_trace_0_6.isEnabled_5xis2i_k$(tmp0_log_0_1_6)) {
      tmp0_trace_0_6.actualLog_sbdqh6_k$(tmp0_log_0_1_6, 'BatchBuilder2D[7]');
    }this._ptt1 = Companion_getInstance_32().invoke_0_k$();
    this._ptt2 = Companion_getInstance_32().invoke_0_k$();
    this._pt1 = Companion_getInstance_32().invoke_0_k$();
    this._pt2 = Companion_getInstance_32().invoke_0_k$();
    this._pt3 = Companion_getInstance_32().invoke_0_k$();
    this._pt4 = Companion_getInstance_32().invoke_0_k$();
    this._pt5 = Companion_getInstance_32().invoke_0_k$();
    this._pt6 = Companion_getInstance_32().invoke_0_k$();
    this._pt7 = Companion_getInstance_32().invoke_0_k$();
    this._pt8 = Companion_getInstance_32().invoke_0_k$();
    var tmp0_trace_0_7 = logger;
    var tmp0_log_0_1_7 = Level_TRACE_getInstance();
    if (tmp0_trace_0_7.isEnabled_5xis2i_k$(tmp0_log_0_1_7)) {
      tmp0_trace_0_7.actualLog_sbdqh6_k$(tmp0_log_0_1_7, 'BatchBuilder2D[8]');
    }this._projMat = new Matrix3D();
    this._viewMat = new Matrix3D();
    var tmp_11 = this;
    tmp_11._viewMat2D = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp0_trace_0_8 = logger;
    var tmp0_log_0_1_8 = Level_TRACE_getInstance();
    if (tmp0_trace_0_8.isEnabled_5xis2i_k$(tmp0_log_0_1_8)) {
      tmp0_trace_0_8.actualLog_sbdqh6_k$(tmp0_log_0_1_8, 'BatchBuilder2D[9]');
    }var tmp_12 = this;
    var tmp_13 = 0;
    var tmp_14 = 4;
    var tmp_15 = fillArrayVal(Array(tmp_14), null);
    while (tmp_13 < tmp_14) {
      var tmp_16 = tmp_13;
      tmp_15[tmp_16] = new TextureUnit(null, false);
      tmp_13 = tmp_13 + 1 | 0;
    }
    tmp_12._textureUnitN = tmp_15;
    var tmp0_trace_0_9 = logger;
    var tmp0_log_0_1_9 = Level_TRACE_getInstance();
    if (tmp0_trace_0_9.isEnabled_5xis2i_k$(tmp0_log_0_1_9)) {
      tmp0_trace_0_9.actualLog_sbdqh6_k$(tmp0_log_0_1_9, 'BatchBuilder2D[10]');
    }var tmp_17 = this;
    tmp_17._uniforms$delegate = lazy(_no_name_provided_$factory_419(this));
    var tmp0_trace_0_10 = logger;
    var tmp0_log_0_1_10 = Level_TRACE_getInstance();
    if (tmp0_trace_0_10.isEnabled_5xis2i_k$(tmp0_log_0_1_10)) {
      tmp0_trace_0_10.actualLog_sbdqh6_k$(tmp0_log_0_1_10, 'BatchBuilder2D[11]');
    }this._tempRect_3 = Companion_getInstance_35().invoke_0_k$();
    var tmp_18 = this;
    tmp_18._beforeFlush = Signal_init_$Create$(null, 1, null);
    var tmp_19 = this;
    tmp_19._onInstanceCount = Signal_init_$Create$(null, 1, null);
    this._vertexData_0 = fastArrayListOf([new VertexData(this._vertexBuffer, Companion_getInstance_200()._LAYOUT), new VertexData(this._texIndexVertexBuffer, Companion_getInstance_200()._LAYOUT_TEX_INDEX)]);
    this._tempOldUniforms = new UniformValues();
  }
  BatchBuilder2D.prototype._set_vertexCount__majfzk_k$ = function (value) {
    this.__vertexCount = value;
  };
  BatchBuilder2D.prototype._get_vertexCount__0_k$ = function () {
    return this.__vertexCount;
  };
  BatchBuilder2D.prototype._get_uniforms__0_k$ = function () {
    var tmp0_getValue_0 = uniforms$factory();
    return this._uniforms$delegate._get_value__0_k$();
  };
  BatchBuilder2D.prototype.addVertex_rxrs82_k$ = function (x, y, u, v, colorMul, colorAdd, texIndex) {
    var tmp0_this = this;
    tmp0_this._vertexPos = tmp0_this._vertexPos + this._addVertex_vjvcco_k$(this._verticesFast32, this._vertexPos, x, y, u, v, _RGBA___get_value__impl_(colorMul), _ColorAdd___get_value__impl_(colorAdd), texIndex) | 0;
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_vertexCount__0_k$();
    tmp1_this._set_vertexCount__majfzk_k$(tmp2 + 1 | 0);
    Unit_getInstance();
  };
  BatchBuilder2D.prototype._addVertex_vjvcco_k$ = function (vd, vp, x, y, u, v, colorMul, colorAdd, texIndex) {
    var tmp0_setF_0 = vp + 0 | 0;
    var tmp0_set_0_1 = vd._f32;
    tmp0_set_0_1[tmp0_setF_0] = x;
    var tmp1_setF_0 = vp + 1 | 0;
    var tmp0_set_0_1_0 = vd._f32;
    tmp0_set_0_1_0[tmp1_setF_0] = y;
    var tmp2_setF_0 = vp + 2 | 0;
    var tmp0_set_0_1_1 = vd._f32;
    tmp0_set_0_1_1[tmp2_setF_0] = u;
    var tmp3_setF_0 = vp + 3 | 0;
    var tmp0_set_0_1_2 = vd._f32;
    tmp0_set_0_1_2[tmp3_setF_0] = v;
    var tmp4_setI_0 = vp + 4 | 0;
    var tmp0_set_0_1_3 = vd._i32;
    tmp0_set_0_1_3[tmp4_setI_0] = colorMul;
    var tmp5_setI_0 = vp + 5 | 0;
    var tmp0_set_0_1_4 = vd._i32;
    tmp0_set_0_1_4[tmp5_setI_0] = colorAdd;
    this._verticesTexIndex[vp / 6 | 0] = toByte(texIndex);
    return 6;
  };
  BatchBuilder2D.prototype.drawQuadFast_2cetbu_k$ = function (x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, colorAdd, texIndex) {
    this.drawQuadFast_6flsbm_k$(x0, y0, x1, y1, x2, y2, x3, y3, tex._x0_0, tex._y0_0, tex._x1_0, tex._y1_0, colorMul, colorAdd, texIndex);
  };
  BatchBuilder2D.prototype.drawQuadFast$default_vm9dy_k$ = function (x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, colorAdd, texIndex, $mask0, $handler) {
    if (!(($mask0 & 2048) === 0))
      texIndex = this._currentTexIndex;
    return this.drawQuadFast_2cetbu_k$(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, colorAdd, texIndex);
  };
  BatchBuilder2D.prototype.drawQuadFast_6flsbm_k$ = function (x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd, texIndex) {
    this.ensure_rvwcgf_k$(6, 4);
    this.addQuadIndices$default_fa9pg0_k$(0, 1, null);
    this.addQuadVerticesFastNormal_p60c7k_k$(x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, _RGBA___get_value__impl_(colorMul), _ColorAdd___get_value__impl_(colorAdd), texIndex);
  };
  BatchBuilder2D.prototype.addQuadIndices_majfzk_k$ = function (vc) {
    var tmp0_this = this;
    tmp0_this._indexPos = tmp0_this._indexPos + _addIndices(this, this._indicesI16, this._indexPos, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  };
  BatchBuilder2D.prototype.addQuadIndices$default_fa9pg0_k$ = function (vc, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      vc = this._get_vertexCount__0_k$();
    return this.addQuadIndices_majfzk_k$(vc);
  };
  BatchBuilder2D.prototype.addQuadVerticesFastNormal_p60c7k_k$ = function (x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd, texIndex) {
    this._vertexPos = this._addQuadVerticesFastNormal_tla206_k$(this._vertexPos, this._verticesFast32, x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd, texIndex);
    var tmp0_this = this;
    tmp0_this._set_vertexCount__majfzk_k$(tmp0_this._get_vertexCount__0_k$() + 4 | 0);
  };
  BatchBuilder2D.prototype._addQuadVerticesFastNormal_tla206_k$ = function (vp, vd, x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd, texIndex) {
    var vp_0 = vp;
    vp_0 = vp_0 + this._addVertex_vjvcco_k$(vd, vp_0, x0, y0, tx0, ty0, colorMul, colorAdd, texIndex) | 0;
    vp_0 = vp_0 + this._addVertex_vjvcco_k$(vd, vp_0, x1, y1, tx1, ty0, colorMul, colorAdd, texIndex) | 0;
    vp_0 = vp_0 + this._addVertex_vjvcco_k$(vd, vp_0, x2, y2, tx1, ty1, colorMul, colorAdd, texIndex) | 0;
    vp_0 = vp_0 + this._addVertex_vjvcco_k$(vd, vp_0, x3, y3, tx0, ty1, colorMul, colorAdd, texIndex) | 0;
    return vp_0;
  };
  BatchBuilder2D.prototype.drawVertices_br228k_k$ = function (array, matrix, vcount, icount, texIndex) {
    this.ensure_rvwcgf_k$(icount, vcount);
    var i16 = this._indicesI16;
    var ip = this._indexPos;
    var vc = this._get_vertexCount__0_k$();
    var arrayIndices = array._indices_1;
    var tmp0_min_0 = array._isize;
    var icount_0 = Math.min(icount, tmp0_min_0);
    arraycopy_8(arrayIndices, 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this._vertexPos;
    var tmp1__get_i32__0 = array.__data;
    var src = tmp1__get_i32__0._arrayInt;
    var tmp2__get_i32__0 = this._vertices_4;
    var dst = tmp2__get_i32__0._arrayInt;
    arraycopy_9(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this._vertexPos / 6 | 0;
    arrayfill(this._verticesTexIndex, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (!(matrix == null)) {
      applyMatrix(this, matrix, this._vertexPos, vcount);
    }var tmp0_this = this;
    tmp0_this.__vertexCount = tmp0_this.__vertexCount + vcount | 0;
    var tmp1_this = this;
    tmp1_this._vertexPos = tmp1_this._vertexPos + imul(vcount, 6) | 0;
    var tmp2_this = this;
    tmp2_this._indexPos = tmp2_this._indexPos + icount_0 | 0;
  };
  BatchBuilder2D.prototype.drawVertices$default_69bxws_k$ = function (array, matrix, vcount, icount, texIndex, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      vcount = array._vcount;
    if (!(($mask0 & 8) === 0))
      icount = array._isize;
    if (!(($mask0 & 16) === 0))
      texIndex = this._currentTexIndex;
    return this.drawVertices_br228k_k$(array, matrix, vcount, icount, texIndex);
  };
  BatchBuilder2D.prototype.ensure_rvwcgf_k$ = function (indices, vertices) {
    if (!checkAvailable(this, indices, vertices)) {
      this.flush$default_9k51td_k$(false, false, 3, null);
    }if (!checkAvailable(this, indices, vertices)) {
      throw IllegalStateException_init_$Create$_0('Too much vertices');
    }};
  BatchBuilder2D.prototype.setStateFast_jgnct2_k$ = function (tex, smoothing, blendFactors, program) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_setStateFast_0 = tex._base_5;
      var isCurrentStateFast_1 = this.isCurrentStateFast_ww8sek_k$(tmp0_setStateFast_0, smoothing, blendFactors, program);
      if (isCurrentStateFast_1) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }this.flush$default_9k51td_k$(false, false, 3, null);
      this._currentTexIndex = 0;
      this._currentTexN[0] = tmp0_setStateFast_0;
      this._currentSmoothing = smoothing;
      this._currentBlendFactors = (!(tmp0_setStateFast_0 == null) ? tmp0_setStateFast_0._isFbo : false) ? toRenderFboIntoBack(blendFactors) : blendFactors;
      this._currentProgram = program;
    }
     while (false);
    return tmp$ret$0;
  };
  BatchBuilder2D.prototype.hasTex_r4vaaz_k$ = function (tex) {
    var tmp0_fastForEach_0 = this._currentTexN;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0.length) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0[tmp0_2];
      if (tmp1__anonymous__3 === tex)
        return true;
    }
    return false;
  };
  BatchBuilder2D.prototype.isCurrentStateFast_ww8sek_k$ = function (tex, smoothing, blendFactors, program) {
    var hasTex = this.hasTex_r4vaaz_k$(tex);
    if (!(this._currentTexN[0] === null) ? !hasTex : false) {
      var inductionVariable = 1;
      var last_1 = this._currentTexN.length;
      if (inductionVariable < last_1)
        $l$break: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this._currentTexN[n] === null) {
            this._currentTexN[n] = tex;
            hasTex = true;
            break $l$break;
          }}
         while (inductionVariable < last_1);
    }var inductionVariable_0 = 0;
    var last_2 = this._currentTexN.length - 1 | 0;
    if (inductionVariable_0 <= last_2)
      $l$break_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this._currentTexN[n_0]) {
          this._currentTexIndex = n_0;
          break $l$break_0;
        }}
       while (inductionVariable_0 <= last_2);
    return ((hasTex ? this._currentSmoothing === smoothing : false) ? this._currentBlendFactors === blendFactors : false) ? this._currentProgram === program : false;
  };
  BatchBuilder2D.prototype.setStateFast_79xbb3_k$ = function (tex, smoothing, blendFactors, program) {
    this.setStateFast_jgnct2_k$(this._texManager.getTextureBase_nc8knv_k$(tex), smoothing, blendFactors, program);
  };
  BatchBuilder2D.prototype.drawNinePatch_n8a8tu_k$ = function (tex, x, y, width, height, posCuts, texCuts, m, filtering, colorMul, colorAdd, blendFactors, program) {
    this.setStateFast_jgnct2_k$(tex._base_6, filtering, blendFactors, program);
    var texIndex = this._currentTexIndex;
    this.ensure_rvwcgf_k$(54, 16);
    var p_o = this._pt1.setToTransform_12ll73_k$(m, this._ptt1.setTo_rybm4g_k$(x, y));
    var p_dU = this._pt2.setToSub_6xxxj2_k$(this._ptt1.setToTransform_12ll73_k$(m, this._ptt1.setTo_rybm4g_k$(x + width, y)), p_o);
    var p_dV = this._pt3.setToSub_6xxxj2_k$(this._ptt1.setToTransform_12ll73_k$(m, this._ptt1.setTo_rybm4g_k$(x, y + height)), p_o);
    var t_o = this._pt4.setTo_rybm4g_k$(tex._x0_0, tex._y0_0);
    var t_dU = this._pt5.setToSub_6xxxj2_k$(this._ptt1.setTo_rybm4g_k$(tex._x1_0, tex._y0_0), t_o);
    var t_dV = this._pt6.setToSub_6xxxj2_k$(this._ptt1.setTo_rybm4g_k$(tex._x0_0, tex._y1_0), t_o);
    var start = this._get_vertexCount__0_k$();
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var posCutY = posCuts[cy]._y_1;
        var texCutY = texCuts[cy]._y_1;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var cx = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var posCutX = posCuts[cx]._x_1;
            var texCutX = texCuts[cx]._x_1;
            var p = this._pt7.setToAdd_6xxxj2_k$(p_o, this._ptt1.setToAdd_6xxxj2_k$(this._ptt1.setToMul_e1b7r4_k$(p_dU, posCutX), this._ptt2.setToMul_e1b7r4_k$(p_dV, posCutY)));
            var t = this._pt8.setToAdd_6xxxj2_k$(t_o, this._ptt1.setToAdd_6xxxj2_k$(this._ptt1.setToMul_e1b7r4_k$(t_dU, texCutX), this._ptt2.setToMul_e1b7r4_k$(t_dV, texCutY)));
            this.addVertex_rxrs82_k$(p._x_1, p._y_1, t._x_1, t._y_1, colorMul, colorAdd, texIndex);
          }
           while (inductionVariable_0 < 4);
      }
       while (inductionVariable < 4);
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < 3)
      do {
        var cy_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < 3)
          do {
            var cx_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var v0 = (start + imul(cy_0, 4) | 0) + cx_0 | 0;
            var v1 = v0 + 1 | 0;
            var v2 = v0 + 4 | 0;
            var v3 = v0 + 5 | 0;
            var tmp0_set_0_1 = this._indicesI16;
            var tmp0_this_3 = this;
            var tmp1_4 = tmp0_this_3._indexPos;
            tmp0_this_3._indexPos = tmp1_4 + 1 | 0;
            var tmp1_set_0_2 = tmp1_4;
            var tmp2_set_0_5 = toShort(v0);
            tmp0_set_0_1[tmp1_set_0_2] = tmp2_set_0_5;
            var tmp0_set_0_1_0 = this._indicesI16;
            var tmp0_this_3_0 = this;
            var tmp1_4_0 = tmp0_this_3_0._indexPos;
            tmp0_this_3_0._indexPos = tmp1_4_0 + 1 | 0;
            var tmp1_set_0_2_0 = tmp1_4_0;
            var tmp2_set_0_5_0 = toShort(v1);
            tmp0_set_0_1_0[tmp1_set_0_2_0] = tmp2_set_0_5_0;
            var tmp0_set_0_1_1 = this._indicesI16;
            var tmp0_this_3_1 = this;
            var tmp1_4_1 = tmp0_this_3_1._indexPos;
            tmp0_this_3_1._indexPos = tmp1_4_1 + 1 | 0;
            var tmp1_set_0_2_1 = tmp1_4_1;
            var tmp2_set_0_5_1 = toShort(v2);
            tmp0_set_0_1_1[tmp1_set_0_2_1] = tmp2_set_0_5_1;
            var tmp0_set_0_1_2 = this._indicesI16;
            var tmp0_this_3_2 = this;
            var tmp1_4_2 = tmp0_this_3_2._indexPos;
            tmp0_this_3_2._indexPos = tmp1_4_2 + 1 | 0;
            var tmp1_set_0_2_2 = tmp1_4_2;
            var tmp2_set_0_5_2 = toShort(v2);
            tmp0_set_0_1_2[tmp1_set_0_2_2] = tmp2_set_0_5_2;
            var tmp0_set_0_1_3 = this._indicesI16;
            var tmp0_this_3_3 = this;
            var tmp1_4_3 = tmp0_this_3_3._indexPos;
            tmp0_this_3_3._indexPos = tmp1_4_3 + 1 | 0;
            var tmp1_set_0_2_3 = tmp1_4_3;
            var tmp2_set_0_5_3 = toShort(v1);
            tmp0_set_0_1_3[tmp1_set_0_2_3] = tmp2_set_0_5_3;
            var tmp0_set_0_1_4 = this._indicesI16;
            var tmp0_this_3_4 = this;
            var tmp1_4_4 = tmp0_this_3_4._indexPos;
            tmp0_this_3_4._indexPos = tmp1_4_4 + 1 | 0;
            var tmp1_set_0_2_4 = tmp1_4_4;
            var tmp2_set_0_5_4 = toShort(v3);
            tmp0_set_0_1_4[tmp1_set_0_2_4] = tmp2_set_0_5_4;
          }
           while (inductionVariable_2 < 3);
      }
       while (inductionVariable_1 < 3);
  };
  BatchBuilder2D.prototype.drawNinePatch$default_9hr72k_k$ = function (tex, x, y, width, height, posCuts, texCuts, m, filtering, colorMul, colorAdd, blendFactors, program, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      x = 0.0;
    if (!(($mask0 & 4) === 0))
      y = 0.0;
    if (!(($mask0 & 8) === 0))
      width = tex._width_21;
    if (!(($mask0 & 16) === 0))
      height = tex._height_22;
    if (!(($mask0 & 128) === 0))
      m = this._identity;
    if (!(($mask0 & 256) === 0))
      filtering = true;
    if (!(($mask0 & 512) === 0))
      colorMul = Colors_getInstance()._WHITE_0;
    if (!(($mask0 & 1024) === 0)) {
      var tmp0__get_NEUTRAL__0 = Companion_getInstance_132();
      colorAdd = ColorAdd_NEUTRAL;
    }if (!(($mask0 & 2048) === 0))
      blendFactors = BlendMode_NORMAL_getInstance_0()._factors;
    if (!(($mask0 & 4096) === 0))
      program = null;
    return this.drawNinePatch_n8a8tu_k$(tex, x, y, width, height, posCuts, texCuts, m, filtering, colorMul, colorAdd, blendFactors, program);
  };
  BatchBuilder2D.prototype.drawQuad_cfmk44_k$ = function (tex, x, y, width, height, m, filtering, colorMul, colorAdd, blendFactors, program) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.setStateFast_jgnct2_k$(tex._base_6, filtering, blendFactors, program);
    var tmp = m.transformXf_rybm4g_k$(x0, y0);
    var tmp_0 = m.transformYf_rybm4g_k$(x0, y0);
    var tmp_1 = m.transformXf_rybm4g_k$(x1, y0);
    var tmp_2 = m.transformYf_rybm4g_k$(x1, y0);
    var tmp_3 = m.transformXf_rybm4g_k$(x1, y1);
    var tmp_4 = m.transformYf_rybm4g_k$(x1, y1);
    var tmp_5 = m.transformXf_rybm4g_k$(x0, y1);
    var tmp_6 = m.transformYf_rybm4g_k$(x0, y1);
    this.drawQuadFast$default_vm9dy_k$(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tex, colorMul, colorAdd, 0, 2048, null);
  };
  BatchBuilder2D.prototype.drawQuad$default_r2v3rq_k$ = function (tex, x, y, width, height, m, filtering, colorMul, colorAdd, blendFactors, program, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      x = 0.0;
    if (!(($mask0 & 4) === 0))
      y = 0.0;
    if (!(($mask0 & 8) === 0))
      width = tex._width_21;
    if (!(($mask0 & 16) === 0))
      height = tex._height_22;
    if (!(($mask0 & 32) === 0))
      m = this._identity;
    if (!(($mask0 & 64) === 0))
      filtering = true;
    if (!(($mask0 & 128) === 0))
      colorMul = Colors_getInstance()._WHITE_0;
    if (!(($mask0 & 256) === 0)) {
      var tmp0__get_NEUTRAL__0 = Companion_getInstance_132();
      colorAdd = ColorAdd_NEUTRAL;
    }if (!(($mask0 & 512) === 0))
      blendFactors = BlendMode_NORMAL_getInstance_0()._factors;
    if (!(($mask0 & 1024) === 0))
      program = null;
    return this.drawQuad_cfmk44_k$(tex, x, y, width, height, m, filtering, colorMul, colorAdd, blendFactors, program);
  };
  BatchBuilder2D.prototype.uploadVertices_sv8swh_k$ = function () {
    this._vertexBuffer.upload_u4hn1j_k$(this._vertices_4, 0, imul(this._vertexPos, 4));
    Unit_getInstance();
    this._texIndexVertexBuffer.upload_irqg4d_k$(this._verticesTexIndex, 0, this._vertexPos / 6 | 0);
    Unit_getInstance();
  };
  BatchBuilder2D.prototype.uploadIndices_sv8swh_k$ = function () {
    this._indexBuffer.upload_u4hn1j_k$(this._indices_0, 0, imul(this._indexPos, 2));
    Unit_getInstance();
  };
  BatchBuilder2D.prototype.updateStandardUniforms_sv8swh_k$ = function () {
    if (this._flipRenderTexture_0 ? this._ag_3._get_renderingToTexture__0_k$() : false) {
      this._projMat.setToOrtho_tgr0io_k$(this._tempRect_3.setBounds_w0xdj4_k$(0, this._ag_3._get_currentHeight__0_k$(), this._ag_3._get_currentWidth__0_k$(), 0), -1.0, 1.0);
      Unit_getInstance();
    } else {
      this._projMat.setToOrtho_tgr0io_k$(this._tempRect_3.setBounds_w0xdj4_k$(0, 0, this._ag_3._get_currentWidth__0_k$(), this._ag_3._get_currentHeight__0_k$()), -1.0, 1.0);
      Unit_getInstance();
    }
    var inductionVariable = 0;
    var last_1 = 4;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var textureUnit = this._textureUnitN[n];
        textureUnit._texture_2 = this._currentTexN[n];
        textureUnit._linear_0 = this._currentSmoothing;
      }
       while (inductionVariable < last_1);
  };
  BatchBuilder2D.prototype.flush_wyzjbl_k$ = function (uploadVertices, uploadIndices) {
    if (this._get_vertexCount__0_k$() > 0) {
      this.updateStandardUniforms_sv8swh_k$();
      var factors = this._currentBlendFactors;
      if (uploadVertices)
        this.uploadVertices_sv8swh_k$();
      if (uploadIndices)
        this.uploadIndices_sv8swh_k$();
      var realFactors = this._ag_3._get_renderingToTexture__0_k$() ? toRenderImageIntoFbo(factors) : factors;
      var tmp2_vertexData = this._vertexData_0;
      var tmp3_indices = this._indexBuffer;
      var tmp1_elvis_lhs = this._currentProgram;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        var tmp_0;
        var tmp0_safe_receiver = this._currentTexN[0];
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_premultiplied__0_k$()) === true) {
          tmp_0 = Companion_getInstance_200()._PROGRAM_PRE;
        } else {
          {
            tmp_0 = Companion_getInstance_200()._PROGRAM_NOPRE;
          }
        }
        tmp = tmp_0;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var tmp4_program = tmp;
      var tmp5_type = DrawType_TRIANGLES_getInstance();
      var tmp6_vertexCount = this._indexPos;
      var tmp7_uniforms = this._get_uniforms__0_k$();
      var tmp8_stencil = this._stencil_0;
      var tmp9_colorMask = this._colorMask_0;
      var tmp10_scissor = this._scissor_1;
      this._ag_3.drawV2$default_j2y7ju_k$(tmp2_vertexData, tmp4_program, tmp5_type, tmp6_vertexCount, tmp3_indices, null, 0, realFactors, tmp7_uniforms, tmp8_stencil, tmp9_colorMask, null, tmp10_scissor, 0, 10336, null);
      this._beforeFlush.invoke_iav7o_k$(this);
    }this._set_vertexCount__majfzk_k$(0);
    this._vertexPos = 0;
    this._indexPos = 0;
    var inductionVariable = 0;
    var last_1 = 4;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._currentTexN[n] = null;
      }
       while (inductionVariable < last_1);
    this._currentTexIndex = 0;
  };
  BatchBuilder2D.prototype.flush$default_9k51td_k$ = function (uploadVertices, uploadIndices, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      uploadVertices = true;
    if (!(($mask0 & 2) === 0))
      uploadIndices = true;
    return this.flush_wyzjbl_k$(uploadVertices, uploadIndices);
  };
  BatchBuilder2D.$metadata$ = {
    simpleName: 'BatchBuilder2D',
    kind: 'class',
    interfaces: []
  };
  function uniforms$factory() {
    return getPropertyCallableRef('uniforms', 1, KProperty1, function (receiver) {
      return receiver._get_uniforms__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_418(this$0) {
    var i = new _no_name_provided__479(this$0);
    return function (p1) {
      i.invoke_89eg7z_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_419(this$0) {
    var i = new _no_name_provided__480(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_420() {
    var i = new _no_name_provided__477();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_421($premultiplied, $preadd) {
    var i = new _no_name_provided__478($premultiplied, $preadd);
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _get_debugLineRenderContext_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = debugLineRenderContext$factory();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = debugLineRenderContext$delegate._name_1;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = debugLineRenderContext$delegate._defaultGen_0(_this_);
        if (_this_._get_extra__0_k$() == null)
          _this_._set_extra__n1onou_k$(ExtraTypeCreate());
        var tmp1_safe_receiver_1_7 = _this_._get_extra__0_k$();
        if (tmp1_safe_receiver_1_7 == null)
          null;
        else {
          var tmp0_elvis_lhs_2_9 = debugLineRenderContext$delegate._name_1;
          var tmp2_set_0_8 = tmp0_elvis_lhs_2_9 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_2_9;
          var tmp3_set_0_10 = r_6;
          tmp1_safe_receiver_1_7.set(tmp2_set_0_8, tmp3_set_0_10);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var debugLineRenderContext$delegate;
  function addVertex($this, x, y, color_0, m) {
    $this._vertices_5.setAlignedFloat32_z49mik_k$($this._vertexPos_0 + 0 | 0, m.transformXf_rybm4g_k$(x, y));
    $this._vertices_5.setAlignedFloat32_z49mik_k$($this._vertexPos_0 + 1 | 0, m.transformYf_rybm4g_k$(x, y));
    $this._vertices_5.setAlignedInt32_rvwcgf_k$($this._vertexPos_0 + 2 | 0, _RGBA___get_value__impl_(color_0));
    var tmp0_this = $this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._vertexPos_0;
    IntCompanionObject_getInstance();
    tmp._vertexPos_0 = tmp_0 + ($this._LAYOUT_0._totalSize_2 / 4 | 0) | 0;
    var tmp1_this = $this;
    var tmp2 = tmp1_this._vertexCount_1;
    tmp1_this._vertexCount_1 = tmp2 + 1 | 0;
    Unit_getInstance();
  }
  function _no_name_provided__481(this$0) {
    this._this$0_134 = this$0;
  }
  _no_name_provided__481.prototype.invoke_89eg7z_k$ = function (it) {
    this._this$0_134.flush_sv8swh_k$();
  };
  _no_name_provided__481.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_89eg7z_k$(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__481.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__482() {
  }
  _no_name_provided__482.prototype.invoke_dzcoxa_k$ = function ($this$VertexShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$VertexShader.SET_k3gp7z_k$($this$VertexShader._out_8, $this$VertexShader.times_l29sts_k$($this$VertexShader.times_l29sts_k$(tmp0_apply_0._u_ProjMat, tmp0_apply_0._u_ViewMat), $this$VertexShader.vec4_ldyooh_k$([tmp0_apply_0._a_Pos, $this$VertexShader._get_lit__a9njmo_k$(0.0), $this$VertexShader._get_lit__a9njmo_k$(1.0)])));
    $this$VertexShader.SET_k3gp7z_k$(tmp0_apply_0._v_Col, tmp0_apply_0._a_Col);
    Unit_getInstance();
  };
  _no_name_provided__482.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__482.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__483() {
  }
  _no_name_provided__483.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$FragmentShader.set_ag43kx_k$($this$FragmentShader._out_8, tmp0_apply_0._v_Col);
    Unit_getInstance();
  };
  _no_name_provided__483.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__483.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__484(this$0) {
    this._this$0_135 = this$0;
  }
  _no_name_provided__484.prototype.invoke_0_k$ = function () {
    return UniformValues_init_$Create$([to(DefaultShaders_getInstance()._u_ProjMat, this._this$0_135._projMat_0), to(DefaultShaders_getInstance()._u_ViewMat, this._this$0_135._viewMat_0)]);
  };
  _no_name_provided__484.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__485() {
  }
  _no_name_provided__485.prototype.invoke_ha5a7z_k$ = function (it) {
    return new Matrix3D();
  };
  _no_name_provided__485.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__485.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function LineRenderBatcher(ctx) {
    this._ctx_7 = ctx;
    var tmp = this;
    tmp._beforeFlush_0 = Signal_init_$Create$(null, 1, null);
    this._ctx_7._flushers.add_o72mru_k$(_no_name_provided_$factory_423(this));
    Unit_getInstance();
    this._ag_4 = this._ctx_7._ag_5;
    this._color_6 = Colors_getInstance()._YELLOW;
    this._LAYOUT_0 = VertexLayout_init_$Create$([DefaultShaders_getInstance()._a_Pos, DefaultShaders_getInstance()._a_Col]);
    var tmp_0 = this;
    tmp_0._VERTEX_0 = VertexShader_0(_no_name_provided_$factory_424());
    var tmp_1 = this;
    tmp_1._FRAGMENT = FragmentShader_0(_no_name_provided_$factory_425());
    var tmp_2 = this;
    tmp_2._uniforms$delegate_0 = lazy(_no_name_provided_$factory_426(this));
    this._vertexBuffer_0 = this._ag_4.createVertexBuffer_0_k$();
    var tmp_3 = this;
    tmp_3._program_2 = Program_init_$Create$(this._VERTEX_0, this._FRAGMENT, null, 4, null);
    this._maxVertexCount = 1024;
    this._vertices_5 = Companion_getInstance_97().alloc_ha5a7z_k$(imul(24, this._maxVertexCount));
    this._tempRect_4 = Companion_getInstance_35().invoke_0_k$();
    this._projMat_0 = new Matrix3D();
    this._viewMat_0 = new Matrix3D();
    var tmp_4 = this;
    tmp_4._tempViewMat = Pool_init_$Create$_1(0, _no_name_provided_$factory_427(), 1, null);
    this._vertexCount_1 = 0;
    this._vertexPos_0 = 0;
    var tmp_5 = this;
    tmp_5._currentMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  }
  LineRenderBatcher.prototype._get_uniforms__0_k$ = function () {
    var tmp0_getValue_0 = uniforms$factory_0();
    return this._uniforms$delegate_0._get_value__0_k$();
  };
  LineRenderBatcher.prototype.line_ywrosb_k$ = function (x0, y0, x1, y1, color0, color1, m) {
    if (this._vertexCount_1 >= (this._maxVertexCount - 2 | 0)) {
      this.flush_sv8swh_k$();
    }addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  };
  LineRenderBatcher.prototype.line$default_to8tb2_k$ = function (x0, y0, x1, y1, color0, color1, m, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      color0 = this._color_6;
    if (!(($mask0 & 32) === 0))
      color1 = color0;
    if (!(($mask0 & 64) === 0))
      m = this._currentMatrix;
    return this.line_ywrosb_k$(x0, y0, x1, y1, color0, color1, m);
  };
  LineRenderBatcher.prototype.line_klnxz3_k$ = function (x0, y0, x1, y1, color0, color1, m) {
    return this.line_ywrosb_k$(x0, y0, x1, y1, color0, color1, m);
  };
  LineRenderBatcher.prototype.line$default_gfs10m_k$ = function (x0, y0, x1, y1, color0, color1, m, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      color0 = this._color_6;
    if (!(($mask0 & 32) === 0))
      color1 = color0;
    if (!(($mask0 & 64) === 0))
      m = this._currentMatrix;
    return this.line_klnxz3_k$(x0, y0, x1, y1, color0, color1, m);
  };
  LineRenderBatcher.prototype.line_1x718l_k$ = function (x0, y0, x1, y1, color0, color1, m) {
    return this.line_ywrosb_k$(x0, y0, x1, y1, color0, color1, m);
  };
  LineRenderBatcher.prototype.line$default_okckny_k$ = function (x0, y0, x1, y1, color0, color1, m, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      color0 = this._color_6;
    if (!(($mask0 & 32) === 0))
      color1 = color0;
    if (!(($mask0 & 64) === 0))
      m = this._currentMatrix;
    return this.line_1x718l_k$(x0, y0, x1, y1, color0, color1, m);
  };
  LineRenderBatcher.prototype.drawVector_lypuw5_k$ = function (path_0, m) {
    var lastX = {_v: 0.0};
    var lastY = {_v: 0.0};
    var ix_3 = 0.0;
    var iy_4 = 0.0;
    var lx_5 = {_v: 0.0};
    var ly_6 = {_v: 0.0};
    Unit_getInstance();
    var n_1_7 = 0;
    var tmp0_fastForEach_0_8 = path_0._commands;
    var n_1_9 = 0;
    while (n_1_9 < tmp0_fastForEach_0_8._get_size__0_k$()) {
      var tmp0_2_11 = n_1_9;
      n_1_9 = tmp0_2_11 + 1 | 0;
      var tmp1__anonymous__2_3_10 = tmp0_fastForEach_0_8.getAt_ha5a7z_k$(tmp0_2_11);
      var tmp0_subject_3_4_12 = tmp1__anonymous__2_3_10;
      Command_getInstance();
      if (tmp0_subject_3_4_12 === 0) {
        var tmp1_4_5_14 = n_1_7;
        n_1_7 = tmp1_4_5_14 + 1 | 0;
        var tmp2__anonymous__18_13 = path_0._data_11.get_ha5a7z_k$(tmp1_4_5_14);
        var tmp2_5_6_16 = n_1_7;
        n_1_7 = tmp2_5_6_16 + 1 | 0;
        var tmp3__anonymous__18_15 = path_0._data_11.get_ha5a7z_k$(tmp2_5_6_16);
        ix_3 = tmp2__anonymous__18_13;
        iy_4 = tmp3__anonymous__18_15;
        if (false) {
          var tmp = lastX._v;
          var tmp_0 = lastY._v;
          this.line$default_gfs10m_k$(tmp, tmp_0, tmp2__anonymous__18_13, tmp3__anonymous__18_15, null, null, m, 48, null);
        }lastX._v = tmp2__anonymous__18_13;
        var tmp0_also_0_20_18 = lastY._v = tmp3__anonymous__18_15;
        lx_5._v = tmp2__anonymous__18_13;
        var tmp1_also_0_19_17 = tmp0_also_0_20_18;
        ly_6._v = tmp3__anonymous__18_15;
      } else {
        Command_getInstance();
        if (tmp0_subject_3_4_12 === 1) {
          var tmp3_6_7_20 = n_1_7;
          n_1_7 = tmp3_6_7_20 + 1 | 0;
          var tmp4__anonymous__21_19 = path_0._data_11.get_ha5a7z_k$(tmp3_6_7_20);
          var tmp4_7_8_22 = n_1_7;
          n_1_7 = tmp4_7_8_22 + 1 | 0;
          var tmp5__anonymous__21_21 = path_0._data_11.get_ha5a7z_k$(tmp4_7_8_22);
          {
            var tmp_1 = lastX._v;
            var tmp_2 = lastY._v;
            this.line$default_gfs10m_k$(tmp_1, tmp_2, tmp4__anonymous__21_19, tmp5__anonymous__21_21, null, null, m, 48, null);
          }
          lastX._v = tmp4__anonymous__21_19;
          var tmp0_also_0_23_24 = lastY._v = tmp5__anonymous__21_21;
          lx_5._v = tmp4__anonymous__21_19;
          var tmp1_also_0_22_23 = tmp0_also_0_23_24;
          ly_6._v = tmp5__anonymous__21_21;
          Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_3_4_12 === 2) {
            var tmp5_8_9_26 = n_1_7;
            n_1_7 = tmp5_8_9_26 + 1 | 0;
            var tmp6__anonymous__24_25 = path_0._data_11.get_ha5a7z_k$(tmp5_8_9_26);
            var tmp6_9_10_28 = n_1_7;
            n_1_7 = tmp6_9_10_28 + 1 | 0;
            var tmp7__anonymous__24_27 = path_0._data_11.get_ha5a7z_k$(tmp6_9_10_28);
            var tmp7_10_11_30 = n_1_7;
            n_1_7 = tmp7_10_11_30 + 1 | 0;
            var tmp8__anonymous__24_29 = path_0._data_11.get_ha5a7z_k$(tmp7_10_11_30);
            var tmp8_11_12_32 = n_1_7;
            n_1_7 = tmp8_11_12_32 + 1 | 0;
            var tmp9__anonymous__24_31 = path_0._data_11.get_ha5a7z_k$(tmp8_11_12_32);
            var sum_25_33 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp6__anonymous__24_25, tmp7__anonymous__24_27) + Companion_getInstance_32().distance_i6u10_k$(tmp6__anonymous__24_25, tmp7__anonymous__24_27, tmp8__anonymous__24_29, tmp9__anonymous__24_31);
            var tmp0_approximateCurve_0_26_34 = numberToInt(sum_25_33);
            var rcurveSteps_1_27_35 = Math.max(tmp0_approximateCurve_0_26_34, 20);
            var dt_2_28_36 = 1.0 / rcurveSteps_1_27_35;
            var lastX_3_29_37 = {_v: 0.0};
            var lastY_4_30_38 = {_v: 0.0};
            var prevX_5_31_39 = {_v: 0.0};
            var prevY_6_32_40 = {_v: 0.0};
            var emittedCount_7_33_41 = {_v: 0};
            var tmp0_quadCalc_0_16_34_42 = Companion_getInstance_41();
            var tmp1_quadCalc_0_17_35_43 = lx_5._v;
            var tmp2_quadCalc_0_18_36_44 = ly_6._v;
            var t1_1_19_37_45 = 1.0;
            var a_2_20_38_46 = t1_1_19_37_45 * t1_1_19_37_45;
            var c_3_21_39_47 = 0.0;
            var b_4_22_40_48 = 2 * t1_1_19_37_45 * 0.0;
            var tmp3__anonymous__5_23_41_49 = a_2_20_38_46 * tmp1_quadCalc_0_17_35_43 + b_4_22_40_48 * tmp6__anonymous__24_25 + c_3_21_39_47 * tmp8__anonymous__24_29;
            var tmp4__anonymous__5_24_42_50 = a_2_20_38_46 * tmp2_quadCalc_0_18_36_44 + b_4_22_40_48 * tmp7__anonymous__24_27 + c_3_21_39_47 * tmp9__anonymous__24_31;
            lastX_3_29_37._v = tmp3__anonymous__5_23_41_49;
            lastY_4_30_38._v = tmp4__anonymous__5_24_42_50;
            var inductionVariable = 1;
            if (inductionVariable < rcurveSteps_1_27_35)
              do {
                var n_10_44_52 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_11_45_53 = n_10_44_52 * dt_2_28_36;
                var tmp0_quadCalc_0_16_46_54 = Companion_getInstance_41();
                var tmp1_quadCalc_0_17_47_55 = lx_5._v;
                var tmp2_quadCalc_0_18_48_56 = ly_6._v;
                var t1_1_19_49_57 = 1 - ratio_11_45_53;
                var a_2_20_50_58 = t1_1_19_49_57 * t1_1_19_49_57;
                var c_3_21_51_59 = ratio_11_45_53 * ratio_11_45_53;
                var b_4_22_52_60 = 2 * t1_1_19_49_57 * ratio_11_45_53;
                var tmp3__anonymous__5_23_53_61 = a_2_20_50_58 * tmp1_quadCalc_0_17_47_55 + b_4_22_52_60 * tmp6__anonymous__24_25 + c_3_21_51_59 * tmp8__anonymous__24_29;
                var tmp4__anonymous__5_24_54_62 = a_2_20_50_58 * tmp2_quadCalc_0_18_48_56 + b_4_22_52_60 * tmp7__anonymous__24_27 + c_3_21_51_59 * tmp9__anonymous__24_31;
                {
                  var tmp_3 = lastX._v;
                  var tmp_4 = lastY._v;
                  this.line$default_gfs10m_k$(tmp_3, tmp_4, tmp3__anonymous__5_23_53_61, tmp4__anonymous__5_24_54_62, null, null, m, 48, null);
                }
                lastX._v = tmp3__anonymous__5_23_53_61;
                lastY._v = tmp4__anonymous__5_24_54_62;
                var tmp0_14_2_27_55_63 = emittedCount_7_33_41._v;
                emittedCount_7_33_41._v = tmp0_14_2_27_55_63 + 1 | 0;
                Unit_getInstance();
                lastX_3_29_37._v = prevX_5_31_39._v;
                lastY_4_30_38._v = prevY_6_32_40._v;
                prevX_5_31_39._v = tmp3__anonymous__5_23_53_61;
                prevY_6_32_40._v = tmp4__anonymous__5_24_54_62;
              }
               while (inductionVariable < rcurveSteps_1_27_35);
            var tmp1_also_0_56_64 = lx_5._v = tmp8__anonymous__24_29;
            ly_6._v = tmp9__anonymous__24_31;
            Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_3_4_12 === 3) {
              var tmp9_12_13_66 = n_1_7;
              n_1_7 = tmp9_12_13_66 + 1 | 0;
              var tmp10__anonymous__57_65 = path_0._data_11.get_ha5a7z_k$(tmp9_12_13_66);
              var tmp10_13_14_68 = n_1_7;
              n_1_7 = tmp10_13_14_68 + 1 | 0;
              var tmp11__anonymous__57_67 = path_0._data_11.get_ha5a7z_k$(tmp10_13_14_68);
              var tmp11_14_15_70 = n_1_7;
              n_1_7 = tmp11_14_15_70 + 1 | 0;
              var tmp12__anonymous__57_69 = path_0._data_11.get_ha5a7z_k$(tmp11_14_15_70);
              var tmp12_15_16_72 = n_1_7;
              n_1_7 = tmp12_15_16_72 + 1 | 0;
              var tmp13__anonymous__57_71 = path_0._data_11.get_ha5a7z_k$(tmp12_15_16_72);
              var tmp13_16_17_74 = n_1_7;
              n_1_7 = tmp13_16_17_74 + 1 | 0;
              var tmp14__anonymous__57_73 = path_0._data_11.get_ha5a7z_k$(tmp13_16_17_74);
              var tmp14_17_18_76 = n_1_7;
              n_1_7 = tmp14_17_18_76 + 1 | 0;
              var tmp15__anonymous__57_75 = path_0._data_11.get_ha5a7z_k$(tmp14_17_18_76);
              var sum_58_77 = Companion_getInstance_32().distance_i6u10_k$(lx_5._v, ly_6._v, tmp10__anonymous__57_65, tmp11__anonymous__57_67) + Companion_getInstance_32().distance_i6u10_k$(tmp10__anonymous__57_65, tmp11__anonymous__57_67, tmp12__anonymous__57_69, tmp13__anonymous__57_71) + Companion_getInstance_32().distance_i6u10_k$(tmp12__anonymous__57_69, tmp13__anonymous__57_71, tmp14__anonymous__57_73, tmp15__anonymous__57_75);
              var tmp0_approximateCurve_0_59_78 = numberToInt(sum_58_77);
              var rcurveSteps_1_60_79 = Math.max(tmp0_approximateCurve_0_59_78, 20);
              var dt_2_61_80 = 1.0 / rcurveSteps_1_60_79;
              var lastX_3_62_81 = {_v: 0.0};
              var lastY_4_63_82 = {_v: 0.0};
              var prevX_5_64_83 = {_v: 0.0};
              var prevY_6_65_84 = {_v: 0.0};
              var emittedCount_7_66_85 = {_v: 0};
              var tmp0_cubicCalc_0_16_67_86 = Companion_getInstance_41();
              var tmp1_cubicCalc_0_17_68_87 = lx_5._v;
              var tmp2_cubicCalc_0_18_69_88 = ly_6._v;
              var cx_1_19_70_89 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_68_87);
              var bx_2_20_71_90 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_70_89;
              var ax_3_21_72_91 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_68_87 - cx_1_19_70_89 - bx_2_20_71_90;
              var cy_4_22_73_92 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_69_88);
              var by_5_23_74_93 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_73_92;
              var ay_6_24_75_94 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_69_88 - cy_4_22_73_92 - by_5_23_74_93;
              var tSquared_7_25_76_95 = 0.0;
              var tCubed_8_26_77_96 = tSquared_7_25_76_95 * 0.0;
              var tmp3__anonymous__9_27_78_97 = ax_3_21_72_91 * tCubed_8_26_77_96 + bx_2_20_71_90 * tSquared_7_25_76_95 + cx_1_19_70_89 * 0.0 + tmp1_cubicCalc_0_17_68_87;
              var tmp4__anonymous__9_28_79_98 = ay_6_24_75_94 * tCubed_8_26_77_96 + by_5_23_74_93 * tSquared_7_25_76_95 + cy_4_22_73_92 * 0.0 + tmp2_cubicCalc_0_18_69_88;
              lastX_3_62_81._v = tmp3__anonymous__9_27_78_97;
              lastY_4_63_82._v = tmp4__anonymous__9_28_79_98;
              var inductionVariable_0 = 1;
              if (inductionVariable_0 < rcurveSteps_1_60_79)
                do {
                  var n_10_81_100 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var ratio_11_82_101 = n_10_81_100 * dt_2_61_80;
                  var tmp0_cubicCalc_0_16_83_102 = Companion_getInstance_41();
                  var tmp1_cubicCalc_0_17_84_103 = lx_5._v;
                  var tmp2_cubicCalc_0_18_85_104 = ly_6._v;
                  var cx_1_19_86_105 = 3.0 * (tmp10__anonymous__57_65 - tmp1_cubicCalc_0_17_84_103);
                  var bx_2_20_87_106 = 3.0 * (tmp12__anonymous__57_69 - tmp10__anonymous__57_65) - cx_1_19_86_105;
                  var ax_3_21_88_107 = tmp14__anonymous__57_73 - tmp1_cubicCalc_0_17_84_103 - cx_1_19_86_105 - bx_2_20_87_106;
                  var cy_4_22_89_108 = 3.0 * (tmp11__anonymous__57_67 - tmp2_cubicCalc_0_18_85_104);
                  var by_5_23_90_109 = 3.0 * (tmp13__anonymous__57_71 - tmp11__anonymous__57_67) - cy_4_22_89_108;
                  var ay_6_24_91_110 = tmp15__anonymous__57_75 - tmp2_cubicCalc_0_18_85_104 - cy_4_22_89_108 - by_5_23_90_109;
                  var tSquared_7_25_92_111 = ratio_11_82_101 * ratio_11_82_101;
                  var tCubed_8_26_93_112 = tSquared_7_25_92_111 * ratio_11_82_101;
                  var tmp3__anonymous__9_27_94_113 = ax_3_21_88_107 * tCubed_8_26_93_112 + bx_2_20_87_106 * tSquared_7_25_92_111 + cx_1_19_86_105 * ratio_11_82_101 + tmp1_cubicCalc_0_17_84_103;
                  var tmp4__anonymous__9_28_95_114 = ay_6_24_91_110 * tCubed_8_26_93_112 + by_5_23_90_109 * tSquared_7_25_92_111 + cy_4_22_89_108 * ratio_11_82_101 + tmp2_cubicCalc_0_18_85_104;
                  {
                    var tmp_5 = lastX._v;
                    var tmp_6 = lastY._v;
                    this.line$default_gfs10m_k$(tmp_5, tmp_6, tmp3__anonymous__9_27_94_113, tmp4__anonymous__9_28_95_114, null, null, m, 48, null);
                  }
                  lastX._v = tmp3__anonymous__9_27_94_113;
                  lastY._v = tmp4__anonymous__9_28_95_114;
                  var tmp0_14_2_31_96_115 = emittedCount_7_66_85._v;
                  emittedCount_7_66_85._v = tmp0_14_2_31_96_115 + 1 | 0;
                  Unit_getInstance();
                  lastX_3_62_81._v = prevX_5_64_83._v;
                  lastY_4_63_82._v = prevY_6_65_84._v;
                  prevX_5_64_83._v = tmp3__anonymous__9_27_94_113;
                  prevY_6_65_84._v = tmp4__anonymous__9_28_95_114;
                }
                 while (inductionVariable_0 < rcurveSteps_1_60_79);
              var tmp1_also_0_97_116 = lx_5._v = tmp14__anonymous__57_73;
              ly_6._v = tmp15__anonymous__57_75;
              Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_3_4_12 === 4) {
                var tmp0__anonymous__118 = ix_3;
                var tmp1__anonymous__118 = iy_4;
                {
                  var tmp_7 = lastX._v;
                  var tmp_8 = lastY._v;
                  this.line$default_gfs10m_k$(tmp_7, tmp_8, tmp0__anonymous__118, tmp1__anonymous__118, null, null, m, 48, null);
                }
                lastX._v = tmp0__anonymous__118;
                lastY._v = tmp1__anonymous__118;
                Unit_getInstance();
                Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  LineRenderBatcher.prototype.flush_sv8swh_k$ = function () {
    if (this._vertexCount_1 > 0) {
      this._beforeFlush_0.invoke_iav7o_k$(this);
      this._vertexBuffer_0.upload_u4hn1j_k$(this._vertices_5, 0, imul(this._vertexPos_0, 4));
      Unit_getInstance();
      this._projMat_0.setToOrtho_tgr0io_k$(this._tempRect_4.setBounds_w0xdj4_k$(0, 0, this._ag_4._get_backWidth__0_k$(), this._ag_4._get_backHeight__0_k$()), -1.0, 1.0);
      Unit_getInstance();
      var tmp = DrawType_LINES_getInstance();
      var tmp_0 = this._vertexCount_1;
      var tmp_1 = this._get_uniforms__0_k$();
      this._ag_4.draw$default_acdjhv_k$(this._vertexBuffer_0, this._program_2, tmp, this._LAYOUT_0, tmp_0, null, null, 0, null, tmp_1, null, null, null, null, 0, 32224, null);
    }this._vertexCount_1 = 0;
    this._vertexPos_0 = 0;
  };
  LineRenderBatcher.$metadata$ = {
    simpleName: 'LineRenderBatcher',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__486() {
  }
  _no_name_provided__486.prototype.invoke_gr18my_k$ = function ($this$$receiver) {
    return new LineRenderBatcher($this$$receiver);
  };
  _no_name_provided__486.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_gr18my_k$(p1 instanceof RenderContext ? p1 : THROW_CCE());
  };
  _no_name_provided__486.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function debugLineRenderContext$factory() {
    return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
      return _get_debugLineRenderContext_(receiver);
    }, null);
  }
  function uniforms$factory_0() {
    return getPropertyCallableRef('uniforms', 1, KProperty1, function (receiver) {
      return receiver._get_uniforms__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_422() {
    var i = new _no_name_provided__486();
    return function (p1) {
      return i.invoke_gr18my_k$(p1);
    };
  }
  function _no_name_provided_$factory_423(this$0) {
    var i = new _no_name_provided__481(this$0);
    return function (p1) {
      i.invoke_89eg7z_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_424() {
    var i = new _no_name_provided__482();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_425() {
    var i = new _no_name_provided__483();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_426(this$0) {
    var i = new _no_name_provided__484(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_427() {
    var i = new _no_name_provided__485();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function LocalRenderState() {
    var tmp = this;
    tmp._stencil_1 = StencilState_init_$Create$(false, null, null, null, null, null, 0, 0, 0, 511, null);
  }
  LocalRenderState.$metadata$ = {
    simpleName: 'LocalRenderState',
    kind: 'class',
    interfaces: []
  };
  function RenderState_0(stencil, colorMask) {
    this._stencil_2 = stencil;
    this._colorMask_1 = colorMask;
  }
  RenderState_0.prototype.set_q6qbft_k$ = function (ctx, referenceValue, temp_0) {
    ctx.flush_sv8swh_k$();
    if (ctx._masksEnabled) {
      temp_0._stencil_1.copyFrom_ivptdh_k$(this._stencil_2);
      temp_0._stencil_1._referenceValue = referenceValue;
      ctx._batch_0._stencil_0 = temp_0._stencil_1;
      ctx._batch_0._colorMask_0 = this._colorMask_1;
    } else {
      ctx._batch_0._stencil_0 = MaskStates_getInstance()._STATE_NONE._stencil_2;
      ctx._batch_0._colorMask_0 = MaskStates_getInstance()._STATE_NONE._colorMask_1;
    }
  };
  RenderState_0.$metadata$ = {
    simpleName: 'RenderState',
    kind: 'class',
    interfaces: []
  };
  function MaskStates() {
    MaskStates_instance = this;
    var tmp = this;
    tmp._STATE_NONE = new RenderState_0(StencilState_init_$Create$(false, null, null, null, null, null, 0, 0, 0, 510, null), new ColorMaskState(true, true, true, true));
    var tmp_0 = this;
    tmp_0._STATE_SHAPE = new RenderState_0(StencilState_init_$Create$(true, null, CompareMode_ALWAYS_getInstance(), StencilOp_SET_getInstance(), StencilOp_SET_getInstance(), StencilOp_SET_getInstance(), 0, 0, 255, 2, null), new ColorMaskState(false, false, false, false));
    var tmp_1 = this;
    tmp_1._STATE_CONTENT = new RenderState_0(StencilState_init_$Create$(true, null, CompareMode_EQUAL_getInstance(), StencilOp_KEEP_getInstance(), StencilOp_KEEP_getInstance(), StencilOp_KEEP_getInstance(), 0, 255, 0, 2, null), new ColorMaskState(true, true, true, true));
  }
  MaskStates.$metadata$ = {
    simpleName: 'MaskStates',
    kind: 'object',
    interfaces: []
  };
  var MaskStates_instance;
  function MaskStates_getInstance() {
    if (MaskStates_instance == null)
      new MaskStates();
    return MaskStates_instance;
  }
  function _no_name_provided__487() {
  }
  _no_name_provided__487.prototype.invoke_skjkkf_k$ = function (it) {
    it.identity_0_k$();
    Unit_getInstance();
  };
  _no_name_provided__487.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_skjkkf_k$(p1 instanceof Matrix ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__487.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__488() {
  }
  _no_name_provided__488.prototype.invoke_ha5a7z_k$ = function (it) {
    return Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  };
  _no_name_provided__488.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__488.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__489() {
  }
  _no_name_provided__489.prototype.invoke_k8t93k_k$ = function (it) {
    it.identity_0_k$();
    Unit_getInstance();
  };
  _no_name_provided__489.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_k8t93k_k$(p1 instanceof Matrix3D ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__489.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__490() {
  }
  _no_name_provided__490.prototype.invoke_ha5a7z_k$ = function (it) {
    return new Matrix3D();
  };
  _no_name_provided__490.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__490.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__491() {
  }
  _no_name_provided__491.prototype.invoke_bbtl9s_k$ = function (it) {
    it.setTo_27zxwg_k$(0, 0);
    Unit_getInstance();
  };
  _no_name_provided__491.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_bbtl9s_k$(p1 instanceof Point ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__491.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__492() {
  }
  _no_name_provided__492.prototype.invoke_ha5a7z_k$ = function (it) {
    return Companion_getInstance_32().invoke_0_k$();
  };
  _no_name_provided__492.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__492.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RenderContext(ag, bp, stats, coroutineContext, batchMaxQuads) {
    this._ag_5 = ag;
    this._bp = bp;
    this._stats_1 = stats;
    this._coroutineContext_5 = coroutineContext;
    this._batchMaxQuads_1 = batchMaxQuads;
    var tmp = this;
    tmp._$$delegate_0_41 = Mixin_init_$Create$(null, 1, null);
    this._agBitmapTextureManager = new AgBitmapTextureManager(this._ag_5);
    var tmp_0 = this;
    tmp_0._flushers = Signal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    var tmp_2 = this._bp;
    tmp_1._views_8 = tmp_2 instanceof Views ? tmp_2 : null;
    this._debugAnnotateView = null;
    this._stencilIndex = 0;
    this._batch_0 = new BatchBuilder2D(this, this._batchMaxQuads_1);
    this._ctx2d = new RenderContext2D(this._batch_0, this._agBitmapTextureManager);
    var tmp_3 = this;
    var tmp_4 = _no_name_provided_$factory_428();
    tmp_3._matrixPool = new Pool(tmp_4, 8, _no_name_provided_$factory_429());
    var tmp_5 = this;
    var tmp_6 = _no_name_provided_$factory_430();
    tmp_5._matrix3DPool = new Pool(tmp_6, 8, _no_name_provided_$factory_431());
    var tmp_7 = this;
    var tmp_8 = _no_name_provided_$factory_432();
    tmp_7._pointPool = new Pool(tmp_8, 8, _no_name_provided_$factory_433());
    this._masksEnabled = true;
    this._currentBatcher = null;
  }
  RenderContext.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_41._set_extra__n1onou_k$(_set___);
  };
  RenderContext.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_41._get_extra__0_k$();
  };
  RenderContext.prototype._get_virtualBottom__0_k$ = function () {
    return this._bp._get_virtualBottom__0_k$();
  };
  RenderContext.prototype._get_virtualLeft__0_k$ = function () {
    return this._bp._get_virtualLeft__0_k$();
  };
  RenderContext.prototype._get_virtualRight__0_k$ = function () {
    return this._bp._get_virtualRight__0_k$();
  };
  RenderContext.prototype._get_virtualTop__0_k$ = function () {
    return this._bp._get_virtualTop__0_k$();
  };
  RenderContext.prototype.flush_sv8swh_k$ = function () {
    this._currentBatcher = null;
    this._flushers.invoke_iav7o_k$(Unit_getInstance());
  };
  RenderContext.prototype.finish_sv8swh_k$ = function () {
    this._ag_5.flip_sv8swh_k$();
  };
  RenderContext.prototype.getTex_uoiv7r_k$ = function (bmp) {
    return this._agBitmapTextureManager.getTexture_uoiv7r_k$(bmp);
  };
  RenderContext.prototype.getTex_nc8knv_k$ = function (bmp) {
    return this._agBitmapTextureManager.getTextureBase_nc8knv_k$(bmp);
  };
  RenderContext.$metadata$ = {
    simpleName: 'RenderContext',
    kind: 'class',
    interfaces: [Extra, BoundsProvider]
  };
  function _no_name_provided_$factory_428() {
    var i = new _no_name_provided__487();
    return function (p1) {
      i.invoke_skjkkf_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_429() {
    var i = new _no_name_provided__488();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_430() {
    var i = new _no_name_provided__489();
    return function (p1) {
      i.invoke_k8t93k_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_431() {
    var i = new _no_name_provided__490();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_432() {
    var i = new _no_name_provided__491();
    return function (p1) {
      i.invoke_bbtl9s_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_433() {
    var i = new _no_name_provided__492();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  var logger_0;
  function _no_name_provided__493() {
  }
  _no_name_provided__493.prototype.invoke_ha5a7z_k$ = function (it) {
    return Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  };
  _no_name_provided__493.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__493.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__494() {
  }
  _no_name_provided__494.prototype.invoke_ha5a7z_k$ = function (it) {
    return Scissor_init_$Create$(0.0, 0.0, 0.0, 0.0, 15, null);
  };
  _no_name_provided__494.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__494.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RenderContext2D(batch, agBitmapTextureManager) {
    this._batch_1 = batch;
    this._agBitmapTextureManager_0 = agBitmapTextureManager;
    var tmp = this;
    tmp._$$delegate_0_42 = Mixin_init_$Create$(null, 1, null);
    var tmp0_trace_0 = logger_0;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_5xis2i_k$(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog_sbdqh6_k$(tmp0_log_0_1, 'RenderContext2D[0]');
    }var tmp_0 = this;
    tmp_0._mpool = Pool_init_$Create$_1(0, _no_name_provided_$factory_434(), 1, null);
    var tmp0_trace_0_0 = logger_0;
    var tmp0_log_0_1_0 = Level_TRACE_getInstance();
    if (tmp0_trace_0_0.isEnabled_5xis2i_k$(tmp0_log_0_1_0)) {
      tmp0_trace_0_0.actualLog_sbdqh6_k$(tmp0_log_0_1_0, 'RenderContext2D[1]');
    }var tmp_1 = this;
    tmp_1._m = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._blendFactors = Companion_getInstance_163()._NORMAL;
    this._multiplyColor = Colors_getInstance()._WHITE_0;
    this._filtering = true;
    var tmp0_trace_0_1 = logger_0;
    var tmp0_log_0_1_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0_1.isEnabled_5xis2i_k$(tmp0_log_0_1_1)) {
      tmp0_trace_0_1.actualLog_sbdqh6_k$(tmp0_log_0_1_1, 'RenderContext2D[2]');
    }var tmp_2 = this;
    tmp_2._scissorPool = Pool_init_$Create$_0(8, _no_name_provided_$factory_435());
    var tmp_3 = this;
    tmp_3._tempScissor = Scissor_init_$Create$(0.0, 0.0, 0.0, 0.0, 15, null);
  }
  RenderContext2D.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_42._set_extra__n1onou_k$(_set___);
  };
  RenderContext2D.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_42._get_extra__0_k$();
  };
  RenderContext2D.prototype.setMatrix_skjkkf_k$ = function (matrix) {
    this._m.copyFrom_v5f3e9_k$(matrix);
    Unit_getInstance();
  };
  RenderContext2D.prototype.imageScale_ujwokw_k$ = function (texture, x, y, scale_1, filtering) {
    var tmp0_x = x;
    var tmp1_y = y;
    var tmp2_width = texture._width_21 * scale_1;
    var tmp3_height = texture._height_22 * scale_1;
    var tmp4_m = this._m;
    var tmp5_colorMul = this._multiplyColor;
    var tmp6_blendFactors = this._blendFactors;
    this._batch_1.drawQuad$default_r2v3rq_k$(texture, tmp0_x, tmp1_y, tmp2_width, tmp3_height, tmp4_m, filtering, tmp5_colorMul, null, tmp6_blendFactors, null, 1280, null);
  };
  RenderContext2D.prototype.imageScale$default_hwup4g_k$ = function (texture, x, y, scale_1, filtering, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      scale_1 = 1.0;
    if (!(($mask0 & 16) === 0))
      filtering = this._filtering;
    return this.imageScale_ujwokw_k$(texture, x, y, scale_1, filtering);
  };
  RenderContext2D.prototype.scissorStart_lefq8c_k$ = function (scissor) {
    var returnScissor = null;
    this._batch_1.flush$default_9k51td_k$(false, false, 3, null);
    if (!(scissor == null)) {
      var left = this._m.transformX_ngl742_k$(scissor._get_left__0_k$(), scissor._get_top__0_k$());
      var top = this._m.transformY_ngl742_k$(scissor._get_left__0_k$(), scissor._get_top__0_k$());
      var right = this._m.transformX_ngl742_k$(scissor._get_right__0_k$(), scissor._get_bottom__0_k$());
      var bottom = this._m.transformY_ngl742_k$(scissor._get_right__0_k$(), scissor._get_bottom__0_k$());
      returnScissor = this._scissorPool.alloc_0_k$().setTo_i6u10_k$(left, top, right - left, bottom - top);
      this._batch_1._scissor_1 = returnScissor;
    } else {
      this._batch_1._scissor_1 = null;
    }
    return returnScissor;
  };
  RenderContext2D.prototype.scissorEnd_h27edz_k$ = function (oldScissor, returnScissor) {
    if (!(returnScissor == null)) {
      this._scissorPool.free_iav7o_k$(returnScissor);
    }this._batch_1.flush$default_9k51td_k$(false, false, 3, null);
    this._batch_1._scissor_1 = oldScissor;
  };
  RenderContext2D.$metadata$ = {
    simpleName: 'RenderContext2D',
    kind: 'class',
    interfaces: [Extra]
  };
  function _no_name_provided_$factory_434() {
    var i = new _no_name_provided__493();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_435() {
    var i = new _no_name_provided__494();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function Texture_init_$Init$(base, left, top, right, bottom, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      left = 0;
    if (!(($mask0 & 4) === 0))
      top = 0;
    if (!(($mask0 & 8) === 0))
      right = base._width_20;
    if (!(($mask0 & 16) === 0))
      bottom = base._height_21;
    Texture_0.call($this, base, left, top, right, bottom);
    return $this;
  }
  function Texture_init_$Create$(base, left, top, right, bottom, $mask0, $marker) {
    return Texture_init_$Init$(base, left, top, right, bottom, $mask0, $marker, Object.create(Texture_0.prototype));
  }
  function Companion_202() {
    Companion_instance_201 = this;
  }
  Companion_202.prototype.invoke_yvav1y_k$ = function (agBase, width, height) {
    return new Texture_0(new Base(agBase, width, height), 0, 0, width, height);
  };
  Companion_202.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_201;
  function Companion_getInstance_201() {
    if (Companion_instance_201 == null)
      new Companion_202();
    return Companion_instance_201;
  }
  function Base(base, width, height) {
    this._base_5 = base;
    this._width_20 = width;
    this._height_21 = height;
    this._version_3 = -1;
  }
  Base.prototype._get_premultiplied__0_k$ = function () {
    var tmp0_safe_receiver = this._base_5;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_premultiplied__0_k$()) === true;
  };
  Base.prototype.close_sv8swh_k$ = function () {
    var tmp0_safe_receiver = this._base_5;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.close_sv8swh_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
    this._base_5 = null;
  };
  Base.prototype.update_dudbe6_k$ = function (bmp, mipmaps_0) {
    var tmp0_safe_receiver = this._base_5;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.upload_bltrcm_k$(bmp, mipmaps_0);
    Unit_getInstance();
  };
  Base.$metadata$ = {
    simpleName: 'Base',
    kind: 'class',
    interfaces: [Closeable]
  };
  function Texture_0(base, left, top, right, bottom) {
    Companion_getInstance_201();
    this._base_6 = base;
    this._left_6 = left;
    this._top_0 = top;
    this._right_2 = right;
    this._bottom_0 = bottom;
    this._x_25 = this._left_6;
    this._y_24 = this._top_0;
    this._width_21 = this._right_2 - this._left_6 | 0;
    this._height_22 = this._bottom_0 - this._top_0 | 0;
    this._x0_0 = this._left_6 / this._base_6._width_20;
    this._x1_0 = this._right_2 / this._base_6._width_20;
    this._y0_0 = this._top_0 / this._base_6._height_21;
    this._y1_0 = this._bottom_0 / this._base_6._height_21;
  }
  Texture_0.prototype._get_premultiplied__0_k$ = function () {
    return this._base_6._get_premultiplied__0_k$();
  };
  Texture_0.prototype._get_tl_x__0_k$ = function () {
    return this._x0_0;
  };
  Texture_0.prototype._get_tl_y__0_k$ = function () {
    return this._y0_0;
  };
  Texture_0.prototype._get_tr_x__0_k$ = function () {
    return this._x1_0;
  };
  Texture_0.prototype._get_tr_y__0_k$ = function () {
    return this._y0_0;
  };
  Texture_0.prototype._get_bl_x__0_k$ = function () {
    return this._x0_0;
  };
  Texture_0.prototype._get_bl_y__0_k$ = function () {
    return this._y1_0;
  };
  Texture_0.prototype._get_br_x__0_k$ = function () {
    return this._x1_0;
  };
  Texture_0.prototype._get_br_y__0_k$ = function () {
    return this._y1_0;
  };
  Texture_0.prototype.slice_w0xdj4_k$ = function (x, y, width, height) {
    return this.sliceBounds_w0xdj4_k$(x, y, x + width | 0, y + height | 0);
  };
  Texture_0.prototype.slice_uebyw0_k$ = function (rect_3) {
    return this.slice_w0xdj4_k$(numberToInt(rect_3._x_2), numberToInt(rect_3._y_2), numberToInt(rect_3._width_0), numberToInt(rect_3._height_0));
  };
  Texture_0.prototype.sliceBounds_w0xdj4_k$ = function (left, top, right, bottom) {
    var tleft = clamp_2(this._x_25 + left | 0, this._left_6, this._right_2);
    var tright = clamp_2(this._x_25 + right | 0, this._left_6, this._right_2);
    var ttop = clamp_2(this._y_24 + top | 0, this._top_0, this._bottom_0);
    var tbottom = clamp_2(this._y_24 + bottom | 0, this._top_0, this._bottom_0);
    return new Texture_0(this._base_6, tleft, ttop, tright, tbottom);
  };
  Texture_0.prototype.close_sv8swh_k$ = function () {
    return this._base_6.close_sv8swh_k$();
  };
  Texture_0.prototype.toString = function () {
    return '' + 'Texture(' + this._base_6 + ', (x=' + this._x_25 + ', y=' + this._y_24 + ', width=' + this._width_21 + ', height=' + this._height_22 + '))';
  };
  Texture_0.$metadata$ = {
    simpleName: 'Texture',
    kind: 'class',
    interfaces: [Closeable, BmpCoords]
  };
  function TextureWithBitmapSlice(texture, bitmapSlice, scale_1, bounds_0) {
    this._texture_4 = texture;
    this._bitmapSlice = bitmapSlice;
    this._scale_2 = scale_1;
    this._bounds_11 = bounds_0;
  }
  TextureWithBitmapSlice.prototype.toString = function () {
    return '' + 'TextureWithBitmapSlice(texture=' + this._texture_4 + ', bitmapSlice=' + this._bitmapSlice + ', scale=' + this._scale_2 + ', bounds=' + this._bounds_11 + ')';
  };
  TextureWithBitmapSlice.prototype.hashCode = function () {
    var result = hashCode(this._texture_4);
    result = imul(result, 31) + hashCode(this._bitmapSlice) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scale_2) | 0;
    result = imul(result, 31) + this._bounds_11.hashCode() | 0;
    return result;
  };
  TextureWithBitmapSlice.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextureWithBitmapSlice))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextureWithBitmapSlice ? other : THROW_CCE();
    if (!equals_1(this._texture_4, tmp0_other_with_cast._texture_4))
      return false;
    if (!equals_1(this._bitmapSlice, tmp0_other_with_cast._bitmapSlice))
      return false;
    if (!equals_1(this._scale_2, tmp0_other_with_cast._scale_2))
      return false;
    if (!this._bounds_11.equals(tmp0_other_with_cast._bounds_11))
      return false;
    return true;
  };
  TextureWithBitmapSlice.$metadata$ = {
    simpleName: 'TextureWithBitmapSlice',
    kind: 'class',
    interfaces: []
  };
  var TEXTURED_ARRAY_QUAD_INDICES;
  var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
  var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
  function TexturedVertexArray_init_$Init$(vcount, indices, isize, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      isize = indices.length;
    TexturedVertexArray.call($this, vcount, indices, isize);
    return $this;
  }
  function TexturedVertexArray_init_$Create$(vcount, indices, isize, $mask0, $marker) {
    return TexturedVertexArray_init_$Init$(vcount, indices, isize, $mask0, $marker, Object.create(TexturedVertexArray.prototype));
  }
  function Companion_203() {
    Companion_instance_202 = this;
    var tmp = this;
    var tmp_0 = new Int16Array(0);
    tmp._EMPTY_6 = TexturedVertexArray_init_$Create$(0, tmp_0, 0, 4, null);
  }
  Companion_203.prototype.forQuads_ha5a7z_k$ = function (quadCount) {
    var tmp = imul(quadCount, 4);
    var tmp_0 = TEXTURED_ARRAY_quadIndices(quadCount);
    return TexturedVertexArray_init_$Create$(tmp, tmp_0, 0, 4, null);
  };
  Companion_203.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_202;
  function Companion_getInstance_202() {
    if (Companion_instance_202 == null)
      new Companion_203();
    return Companion_instance_202;
  }
  function TexturedVertexArray(vcount, indices, isize) {
    Companion_getInstance_202();
    this._vcount = vcount;
    this._indices_1 = indices;
    this._isize = isize;
    this._initialVcount = this._vcount;
    this.__data = Companion_getInstance_97().allocNoDirect_ha5a7z_k$(imul(imul(6, this._initialVcount), 4));
    this._fast = this.__data._fast32;
    this._offset_33 = 0;
    this._bounds_12 = new BoundsBuilder();
  }
  TexturedVertexArray.prototype.setXY_c7v4pd_k$ = function (x, y) {
    var tmp0_setF_0 = this._fast;
    var tmp1_setF_0 = this._offset_33 + 0 | 0;
    var tmp0_set_0_1 = tmp0_setF_0._f32;
    tmp0_set_0_1[tmp1_setF_0] = x;
    var tmp4_setY_0 = this;
    var tmp2_setF_0 = tmp4_setY_0._fast;
    var tmp3_setF_0 = tmp4_setY_0._offset_33 + 1 | 0;
    var tmp0_set_0_1_0 = tmp2_setF_0._f32;
    tmp0_set_0_1_0[tmp3_setF_0] = y;
    Unit_getInstance();
  };
  TexturedVertexArray.prototype.quadV_ll0d8i_k$ = function (index_0, x, y, u, v, colMul, colAdd) {
    this.quadV_5f2dy1_k$(this._fast, imul(index_0, 6), x, y, u, v, _RGBA___get_value__impl_(colMul), _ColorAdd___get_value__impl_(colAdd));
    Unit_getInstance();
  };
  TexturedVertexArray.prototype.quadV_5f2dy1_k$ = function (fast, pos, x, y, u, v, colMul, colAdd) {
    var tmp0_setF_0 = pos + 0 | 0;
    var tmp0_set_0_1 = fast._f32;
    tmp0_set_0_1[tmp0_setF_0] = x;
    var tmp1_setF_0 = pos + 1 | 0;
    var tmp0_set_0_1_0 = fast._f32;
    tmp0_set_0_1_0[tmp1_setF_0] = y;
    var tmp2_setF_0 = pos + 2 | 0;
    var tmp0_set_0_1_1 = fast._f32;
    tmp0_set_0_1_1[tmp2_setF_0] = u;
    var tmp3_setF_0 = pos + 3 | 0;
    var tmp0_set_0_1_2 = fast._f32;
    tmp0_set_0_1_2[tmp3_setF_0] = v;
    var tmp4_setI_0 = pos + 4 | 0;
    var tmp0_set_0_1_3 = fast._i32;
    tmp0_set_0_1_3[tmp4_setI_0] = colMul;
    var tmp5_setI_0 = pos + 5 | 0;
    var tmp0_set_0_1_4 = fast._i32;
    tmp0_set_0_1_4[tmp5_setI_0] = colAdd;
    return 6;
  };
  TexturedVertexArray.prototype.quadV_hx94cc_k$ = function (index_0, x, y, u, v, colMul, colAdd) {
    return this.quadV_ll0d8i_k$(index_0, x, y, u, v, colMul, colAdd);
  };
  TexturedVertexArray.prototype.quad_vcy9g9_k$ = function (index_0, x, y, width, height, matrix, bmp, colMul, colAdd) {
    this.quad_drsndp_k$(index_0, x, y, width, height, matrix, bmp, colMul, colAdd);
  };
  TexturedVertexArray.prototype.quad_drsndp_k$ = function (index_0, x, y, width, height, matrix, bmp, colMul, colAdd) {
    this.quad_9x3odw_k$(index_0, x, y, width, height, matrix, bmp._get_tl_x__0_k$(), bmp._get_tl_y__0_k$(), bmp._get_tr_x__0_k$(), bmp._get_tr_y__0_k$(), bmp._get_bl_x__0_k$(), bmp._get_bl_y__0_k$(), bmp._get_br_x__0_k$(), bmp._get_br_y__0_k$(), colMul, colAdd);
  };
  TexturedVertexArray.prototype.quad_9x3odw_k$ = function (index_0, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul, colAdd) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix._get_af__0_k$();
    var cf = matrix._get_cf__0_k$();
    var txf = matrix._get_txf__0_k$();
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix._get_df__0_k$();
    var bf = matrix._get_bf__0_k$();
    var tyf = matrix._get_tyf__0_k$();
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this._fast;
    var pos = imul(index_0, 6);
    var cm = _RGBA___get_value__impl_(colMul);
    var ca = _ColorAdd___get_value__impl_(colAdd);
    pos = pos + this.quadV_5f2dy1_k$(fast, pos, x0, y0, tl_x, tl_y, cm, ca) | 0;
    pos = pos + this.quadV_5f2dy1_k$(fast, pos, x1, y1, tr_x, tr_y, cm, ca) | 0;
    pos = pos + this.quadV_5f2dy1_k$(fast, pos, x2, y2, br_x, br_y, cm, ca) | 0;
    pos = pos + this.quadV_5f2dy1_k$(fast, pos, x3, y3, bl_x, bl_y, cm, ca) | 0;
  };
  TexturedVertexArray.prototype._get_x__0_k$ = function () {
    var tmp0_getF_0 = this._fast;
    var tmp1_getF_0 = this._offset_33 + 0 | 0;
    var tmp0_get_0_1 = tmp0_getF_0._f32;
    return tmp0_get_0_1[tmp1_getF_0];
  };
  TexturedVertexArray.prototype._get_y__0_k$ = function () {
    var tmp0_getF_0 = this._fast;
    var tmp1_getF_0 = this._offset_33 + 1 | 0;
    var tmp0_get_0_1 = tmp0_getF_0._f32;
    return tmp0_get_0_1[tmp1_getF_0];
  };
  TexturedVertexArray.prototype.copyFrom_e7bxyc_k$ = function (other) {
    arraycopy_9(other.__data._arrayInt, 0, this.__data._arrayInt, 0, this.__data._size_6 / 4 | 0);
    arraycopy_6(other._indices_1, 0, this._indices_1, 0, this._indices_1.length);
  };
  TexturedVertexArray.prototype.applyMatrix_skjkkf_k$ = function (matrix) {
    var inductionVariable = 0;
    var last_1 = this._vcount;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._offset_33 = imul(n, 6);
        Unit_getInstance();
        var x = this._get_x__0_k$();
        var y = this._get_y__0_k$();
        this.setXY_c7v4pd_k$(matrix.transformXf_rybm4g_k$(x, y), matrix.transformYf_rybm4g_k$(x, y));
      }
       while (inductionVariable < last_1);
  };
  TexturedVertexArray.$metadata$ = {
    simpleName: 'TexturedVertexArray',
    kind: 'class',
    interfaces: []
  };
  function TEXTURED_ARRAY_quadIndices(quadCount) {
    if (quadCount === 0)
      return TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
    var out = new Int16Array(imul(quadCount, 6));
    var m = 0;
    var base = 0;
    var inductionVariable = 0;
    if (inductionVariable < quadCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1 = m;
        m = tmp1 + 1 | 0;
        out[tmp1] = toShort(base + 0 | 0);
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        out[tmp2] = toShort(base + 1 | 0);
        var tmp3 = m;
        m = tmp3 + 1 | 0;
        out[tmp3] = toShort(base + 2 | 0);
        var tmp4 = m;
        m = tmp4 + 1 | 0;
        out[tmp4] = toShort(base + 3 | 0);
        var tmp5 = m;
        m = tmp5 + 1 | 0;
        out[tmp5] = toShort(base + 0 | 0);
        var tmp6 = m;
        m = tmp6 + 1 | 0;
        out[tmp6] = toShort(base + 2 | 0);
        base = base + 4 | 0;
      }
       while (inductionVariable < quadCount);
    return out;
  }
  function TEXTURED_ARRAY_QUAD_INDICES$init$() {
    return new Int16Array([0, 1, 2, 3, 0, 2]);
  }
  function _get_root_($this) {
    var tmp = $this._root_4;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('root');
    }
  }
  function _get_mountable_($this) {
    var tmp = $this._mountable;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('mountable');
    }
  }
  function _no_name_provided__495(this$0, resultContinuation) {
    this._this$0_136 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__495.prototype.invoke_aoeenq_k$ = function ($this$MountableVfs, $cont) {
    var tmp = this.create_8335uj_k$($this$MountableVfs, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__495.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_aoeenq_k$((!(p1 == null) ? isInterface(p1, Mountable) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__495.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_136._mountable = this._$this$MountableVfs;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__495.prototype.create_8335uj_k$ = function ($this$MountableVfs, completion) {
    var i = new _no_name_provided__495(this._this$0_136, completion);
    i._$this$MountableVfs = $this$MountableVfs;
    return i;
  };
  _no_name_provided__495.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $initCOROUTINE$18(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__187 = _this_;
  }
  $initCOROUTINE$18.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = MountableVfs$default(false, _no_name_provided_$factory_436(this.__this__187, null), 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.__this__187._root_4 = ARGUMENT;
            this.__this__187.mount_va28pg_k$('/', _get_resourcesVfs_());
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $initCOROUTINE$18.$metadata$ = {
    simpleName: '$initCOROUTINE$18',
    kind: 'class',
    interfaces: []
  };
  function ResourcesRoot() {
  }
  ResourcesRoot.prototype.mount_va28pg_k$ = function (path_0, file) {
    _get_mountable_(this).mount_7u3n0j_k$(path_0, file);
    Unit_getInstance();
  };
  ResourcesRoot.prototype.init_sv8swh_k$ = function ($cont) {
    var tmp = new $initCOROUTINE$18(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  ResourcesRoot.prototype.toString = function () {
    return '' + 'ResourcesRoot[' + _get_root_(this) + ']';
  };
  ResourcesRoot.$metadata$ = {
    simpleName: 'ResourcesRoot',
    kind: 'class',
    interfaces: [AsyncDependency]
  };
  function _no_name_provided_$factory_436(this$0, resultContinuation) {
    var i = new _no_name_provided__495(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_aoeenq_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _get_debugBmpFont_() {
    var tmp0_getValue_0 = debugBmpFont$factory();
    return debugBmpFont$delegate._get_value__0_k$();
  }
  var debugBmpFont$delegate;
  function DebugBitmapFont() {
    DebugBitmapFont_instance = this;
    var tmp = this;
    tmp._DEBUG_FONT_BYTES = fromBase64$default('iVBORw0KGgoAAAANSUhEUgAAAMAAAADAAQMAAABoEv5EAAAABlBMVEVHcEz///+flKJDAAAAAXRSTlMAQObYZgAABelJREFUeAHFlAGEXNsZx3/f3LOzZzdj7rmbPJnn7cu5Yl8F6BSeRJM3Z/MggMVDUQwKeFhAEXxXikUwKIIiKAooAOBuF4KHAIJiAEVxEFwMeu6Za/OSbquC6d/nc67f/M/3+eZz+AxJ55u/GtYGFm2KxyWbsl3CyCyuuukA4rydOP2D/f7HBP747VXnWU9ZPrp89Ytwx2lyxMGxeJFYnF/aX56+d6r2+z8l8H5+GX3RLTSDp65E7VUPfveoXU+L3/jtVU/dWPTL4ao2GMJQ/G/Ov9BHL37M7Sr0xXO7l+txwZwlu1CNHbPybQdLQ+BaD3lYsjppXkKcEsa0sDJFx3ekdlcnuu77JhSiTl5NE0hTSlcdNw6WX8hZ+nTFxkvsHQmYxvmmMxK3joWu+xpeMbr2Gg3rVCPdvNBAjS2T48Xc68ddAWNA1hQbdq9wwGoME4JBPwVlc3FEsIRq6NhmIJ2T1QR11NMBuB6QHNRfKAksmoh0UGeQThruwwfHkFl5XiWwrWHAoMNVY5l9rcN3D4QbZNmZSkJJHEm3L106ACMwRJy2rrFjwYpNB0MwiYmlagJqDyU63BZY6QTLkYaC8yOspy7phvmp446GCXah1mlwagELQs0sfTd2JFvg+hrSjYBSote4T8ztrRPIXdX8m5RdzmrpOb8nnddzp+uiuTiWlzPtZ7WyenHARcpOg7Cy8sOdxnK3sbbB6utDIYPXVk6OEkiwlATWU8H3oLViquzoBoc8TI6qdxiXgBM71OAig5VtMijFbrs65veuv/ClT0Aj/1d5Yh+X1p2aFP5yXcvaALaxKY5Oe9CPq8FRHzIARtKDPc5EsNQVUIotiRmcjKhHgqGuFaw8OMQmYJuTPWojJAxgiQfSgz05sVrbU2QLjpkc570a8c6F89QVzZr/pF29XQZmIErRHwKNTq6BBRSj+YAaskZES0Sj4f0tWtGVkXd3iYC91dhpCrETDehrIyezxgLd5JSqf9it7UGbgOtB+uGprRoMXQIuOzJgc0vjtI1T7EzXTl9NE/horyQCJbuX4VpzQzvRG0Aw1Lep+Yp3X9H5vFeVWJ8BnDFp5pMGk/fqsF8XhRlc9MBqNHmvUjZbhxhu8dZiTTNLe3VIZ6+BxR1LLPhH2qsK63NXyIZjHn40rp2qhILotDVQip2w8rROl7jGIZYspwC1MiYBKFlP+4hlH8sJywPoHU6d4ETS2TqtDbXTSCnOa/6t4JvOZ+AbSyHOiatSEHsj2dF0oF1JV2qKWa5xPuU8P2Rc65xdq4D9dgk6RhHrtB6L+27byAErp+GA0M+O+oDXt3mG56eKa6VfdFbiPQKWuW/7kbjG5uCYUElkyqaS9H0dJMftNjnEXYNS+6vyCx/w/LPKV6VAlyW1J1RPw6d/M9TAo0Z3NKu5wETflKwN5HExaIS7LfNKHEDhfkUwTc2UfnBAAtlRH2k/VoS6FOvlotS1lc6/ePdEwxHPKKnzPJ4BTkD/fKihd1QDeOCbNGBoJnfbXKPU8zzz2TCS0bzWwE16jrIr2eaHb1N/hD2As5T3ODPA/dFfvr4RDI6i3YPHxdu9Ij7h7PHW8WsdHAa3h5OfOx4X7ZMiZsfbRX9oP9TIV5+lTK+QHTeCXOMmsAsZAjlyZYYg/A9gvz3ba58/udrsXW1S/siRzxiy9q82i/b54mqz3/42xeLq74MDMAwO+hgqfQ7YgbZbY4YcKDYUbXG1+S8gnTjbb5+nvGhvcIRPHYs8q+Toh3bVbnPRAsPWbrcEU3w+2J285sxyzDnYgghErxunVPxkWB2gM3VGLJNT65ozS1fJfCrW6fKbEG0CR010nI2lrqgr6ZzG+6cPygQqsQlYqe9pAvZA7Denzz44XFM76imrBGYatzVIwGubgGH5pUaEIgGErWrwZI3YnYKhLghjmAA8vke7HV8YJaYJvDkCqCup6SVR0ASQ+QAI5QcHwSsTlhloeV0jAXgDy3ECst46AMwojGUOUNRAua3hm64HbPWan8uIMmjJZ+pf9psaQCuD8LwAAAAASUVORK5CYII=', false, 1, null);
  }
  DebugBitmapFont.$metadata$ = {
    simpleName: 'DebugBitmapFont',
    kind: 'object',
    interfaces: []
  };
  var DebugBitmapFont_instance;
  function DebugBitmapFont_getInstance() {
    if (DebugBitmapFont_instance == null)
      new DebugBitmapFont();
    return DebugBitmapFont_instance;
  }
  function _no_name_provided__496() {
  }
  _no_name_provided__496.prototype.invoke_0_k$ = function () {
    var tmp = PNG_getInstance();
    var tmp_0 = DebugBitmapFont_getInstance()._DEBUG_FONT_BYTES;
    var tmp_1 = tmp.decode$default_hc9x6a_k$(tmp_0, null, 2, null).toBMP32_0_k$().copyPremultiplied();
    var tex = slice$default(tmp_1, null, null, 3, null);
    var fntAdvance = 7.0;
    var fntWidth = 8.0;
    var fntHeight = 8.0;
    var fntBlockX = 2.0;
    var fntBlockY = 2.0;
    var fntBlockWidth = 12.0;
    var fntBlockHeight = 12.0;
    var tmp_2 = fntHeight - 1.0;
    var tmp0_associateWith_0 = until(0, 256);
    var result_1 = LinkedHashMap_init_$Create$_1(coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateWith_0, 10)), 16));
    var inductionVariable = tmp0_associateWith_0._get_first__0_k$();
    var last_1 = tmp0_associateWith_0._get_last__0_k$();
    if (inductionVariable <= last_1)
      do {
        var element_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x_5 = element_2_3 % 16;
        var y_6 = element_2_3 / 16 | 0;
        var tmp_3 = numberToInt(x_5 * fntBlockWidth + fntBlockX);
        var tmp_4 = numberToInt(y_6 * fntBlockHeight + fntBlockY);
        var tmp_5 = numberToInt(fntWidth);
        var tmp_6 = numberToInt(fntHeight);
        result_1.put_1q9pf_k$(element_2_3, new Glyph(fntHeight, element_2_3, tex.sliceWithSize$default_cox0wy_k$(tmp_3, tmp_4, tmp_5, tmp_6, null, 16, null), 0, 0, numberToInt(fntAdvance)));
        Unit_getInstance();
      }
       while (!(element_2_3 === last_1));
    var tmp_7 = toIntMap(result_1);
    var tmp_8 = IntMap_init_$Create$(0, 0.0, 3, null);
    return BitmapFont_init_$Create$(fntHeight, fntHeight, tmp_2, tmp_7, tmp_8, null, null, 96, null);
  };
  _no_name_provided__496.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function debugBmpFont$factory() {
    return getPropertyCallableRef('debugBmpFont', 0, KProperty0, function () {
      return _get_debugBmpFont_();
    }, null);
  }
  function _no_name_provided_$factory_437() {
    var i = new _no_name_provided__496();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function Module() {
    this._imageFormats_2 = listOf_0(PNG_getInstance());
    this._bgcolor_3 = Colors_getInstance()._BLACK_0;
    this._title_1 = 'Game';
    this._icon_2 = null;
    this._iconImage = null;
    this._quality_4 = Quality_PERFORMANCE_getInstance();
    this._mainScene = getKClass_0(EmptyScene);
    this._clearEachFrame_0 = true;
    this._targetFps_0 = 0.0;
    this._scaleAnchor_0 = Companion_getInstance_25()._MIDDLE_CENTER;
    this._scaleMode_2 = Companion_getInstance_37()._SHOW_ALL;
    this._clipBorders_0 = true;
    this._fullscreen_4 = null;
  }
  Module.prototype._get_imageFormats__0_k$ = function () {
    return this._imageFormats_2;
  };
  Module.prototype._get_bgcolor__12t64v_k$ = function () {
    return this._bgcolor_3;
  };
  Module.prototype._get_title__0_k$ = function () {
    return this._title_1;
  };
  Module.prototype._get_icon__0_k$ = function () {
    return this._icon_2;
  };
  Module.prototype._get_iconImage__0_k$ = function () {
    return this._iconImage;
  };
  Module.prototype._get_quality__0_k$ = function () {
    return this._quality_4;
  };
  Module.prototype._get_size__qgazdw_k$ = function () {
    var tmp = Companion_getInstance_39();
    DefaultViewport_getInstance();
    DefaultViewport_getInstance();
    return tmp.invoke_aaxa64_k$(1280, 720);
  };
  Module.prototype._get_windowSize__qgazdw_k$ = function () {
    return this._get_size__qgazdw_k$();
  };
  Module.prototype._get_mainScene__0_k$ = function () {
    return this._mainScene;
  };
  Module.prototype._get_targetFps__0_k$ = function () {
    return this._targetFps_0;
  };
  Module.prototype._get_scaleAnchor__0_k$ = function () {
    return this._scaleAnchor_0;
  };
  Module.prototype._get_scaleMode__0_k$ = function () {
    return this._scaleMode_2;
  };
  Module.prototype._get_clipBorders__0_k$ = function () {
    return this._clipBorders_0;
  };
  Module.prototype._get_fullscreen__0_k$ = function () {
    return this._fullscreen_4;
  };
  Module.prototype.configure_k6yfpx_k$ = function (_this__0, $cont) {
    return Unit_getInstance();
  };
  Module.$metadata$ = {
    simpleName: 'Module',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__497(this$0) {
    this._this$0_137 = this$0;
  }
  _no_name_provided__497.prototype.invoke_0_k$ = function () {
    return this._this$0_137._get_views__0_k$()._coroutineContext_6.plus_d7pszg_k$(new AsyncInjectorContext(this._this$0_137._get_injector__0_k$())).plus_d7pszg_k$(Job_0(this._this$0_137._get_views__0_k$()._coroutineContext_6.get_9uvjra_k$(Key_getInstance_2())));
  };
  _no_name_provided__497.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__498(this$0) {
    this._this$0_138 = this$0;
  }
  _no_name_provided__498.prototype.invoke_0_k$ = function () {
    var tmp0_getSync_0 = this._this$0_138._get_injector__0_k$();
    var tmp1_getSync_0 = new RequestContext(getKClass_0(Resources));
    return tmp0_getSync_0.getSync_v4ahoc_k$(getKClass_0(Resources), tmp1_getSync_0);
  };
  _no_name_provided__498.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $initCOROUTINE$21(_this_, injector_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__188 = _this_;
    this._injector_5 = injector_0;
  }
  $initCOROUTINE$21.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this.__this__188._injector_6 = this._injector_5;
            this._state_1 = 1;
            var tmp_0 = getKClass_0(Views);
            suspendResult = this._injector_5.get$default_b3eqw1_k$(tmp_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_31 = suspendResult;
            this.__this__188._set_views__ukkq99_k$(this._ARGUMENT0_31);
            this._state_1 = 2;
            var tmp_1 = getKClass_0(SceneContainer);
            suspendResult = this._injector_5.get$default_b3eqw1_k$(tmp_1, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_13 = suspendResult;
            this.__this__188._sceneContainer = this._ARGUMENT1_13;
            this._state_1 = 3;
            var tmp_2 = getKClass_0(ResourcesRoot);
            suspendResult = this._injector_5.get$default_b3eqw1_k$(tmp_2, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            this.__this__188._resourcesRoot = ARGUMENT;
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $initCOROUTINE$21.$metadata$ = {
    simpleName: '$initCOROUTINE$21',
    kind: 'class',
    interfaces: []
  };
  function $sceneAfterDestroyInternalCOROUTINE$22(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__189 = _this_;
  }
  $sceneAfterDestroyInternalCOROUTINE$22.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this.__this__189.sceneAfterDestroy_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._exceptionState = 2;
            var tmp_0 = this.__this__189._get_coroutineContext__0_k$();
            cancel$default(tmp_0, null, 1, null);
            this._exceptionState = 4;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._exceptionState = 4;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              printStackTrace_0(e);
              this._state_1 = 3;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            this._exceptionState = 4;
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneAfterDestroyInternalCOROUTINE$22.$metadata$ = {
    simpleName: '$sceneAfterDestroyInternalCOROUTINE$22',
    kind: 'class',
    interfaces: []
  };
  function Scene() {
    this.__sceneViewContainer = new Container();
    this._cancellables = new CancellableGroup();
    var tmp = this;
    tmp._coroutineContext$delegate = lazy(_no_name_provided_$factory_438(this));
    var tmp_0 = this;
    var tmp0_apply_0 = this.createSceneView_0_k$();
    var tmp0_this_2 = this;
    tmp0_this_2.__sceneViewContainer.plusAssign_4l6ao4_k$(tmp0_apply_0);
    tmp_0._sceneView = tmp0_apply_0;
    var tmp_1 = this;
    tmp_1._resources$delegate = lazy(_no_name_provided_$factory_439(this));
  }
  Scene.prototype._get_injector__0_k$ = function () {
    var tmp = this._injector_6;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  };
  Scene.prototype._set_views__ukkq99_k$ = function (_set___) {
    this._views_9 = _set___;
  };
  Scene.prototype._get_views__0_k$ = function () {
    var tmp = this._views_9;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  Scene.prototype._get_sceneContainer__0_k$ = function () {
    var tmp = this._sceneContainer;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  };
  Scene.prototype._get_coroutineContext__0_k$ = function () {
    var tmp0_getValue_0 = coroutineContext$factory();
    return this._coroutineContext$delegate._get_value__0_k$();
  };
  Scene.prototype.createSceneView_0_k$ = function () {
    return new Container();
  };
  Scene.prototype.init_wh5jqx_k$ = function (injector_0, $cont) {
    var tmp = new $initCOROUTINE$21(this, injector_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Scene.prototype.sceneInit_zg0dwy_k$ = function (_this__0, $cont) {
  };
  Scene.prototype.sceneMain_zg0dwy_k$ = function (_this__0, $cont) {
  };
  Scene.prototype.sceneAfterInit_sv8swh_k$ = function ($cont) {
  };
  Scene.prototype.sceneBeforeLeaving_sv8swh_k$ = function ($cont) {
  };
  Scene.prototype.sceneDestroy_sv8swh_k$ = function ($cont) {
  };
  Scene.prototype.sceneDestroyInternal_sv8swh_k$ = function ($cont) {
    cancel_0(this._cancellables);
    return this._get_injector__0_k$().deinit_sv8swh_k$($cont);
  };
  Scene.prototype.sceneAfterDestroy_sv8swh_k$ = function ($cont) {
  };
  Scene.prototype.sceneAfterDestroyInternal_sv8swh_k$ = function ($cont) {
    var tmp = new $sceneAfterDestroyInternalCOROUTINE$22(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Scene.$metadata$ = {
    simpleName: 'Scene',
    kind: 'class',
    interfaces: [InjectorAsyncDependency, ViewsContainer, CoroutineScope, KorgeDebugNode, ResourcesContainer]
  };
  function EmptyScene() {
    Scene.call(this);
  }
  EmptyScene.prototype.sceneInit_zg0dwy_k$ = function (_this__0, $cont) {
  };
  EmptyScene.$metadata$ = {
    simpleName: 'EmptyScene',
    kind: 'class',
    interfaces: []
  };
  function coroutineContext$factory() {
    return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
      return receiver._get_coroutineContext__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_438(this$0) {
    var i = new _no_name_provided__497(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_439(this$0) {
    var i = new _no_name_provided__498(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function SceneContainer_init_$Init$(views_0, defaultTransition, name, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      defaultTransition = withEasing(AlphaTransition, Companion_getInstance_57()._get_EASE_IN_OUT_QUAD__0_k$());
    if (!(($mask0 & 4) === 0))
      name = 'sceneContainer';
    SceneContainer.call($this, views_0, defaultTransition, name);
    return $this;
  }
  function SceneContainer_init_$Create$(views_0, defaultTransition, name, $mask0, $marker) {
    return SceneContainer_init_$Init$(views_0, defaultTransition, name, $mask0, $marker, Object.create(SceneContainer.prototype));
  }
  function _changeTo($this, clazz, injects, time, transition, $cont) {
    var tmp = new $_changeToCOROUTINE$24($this, clazz, injects, time, transition, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function VisitEntry(clazz, injects) {
    this._clazz_3 = clazz;
    this._injects = injects;
  }
  VisitEntry.prototype.toString = function () {
    return '' + 'VisitEntry(clazz=' + this._clazz_3 + ', injects=' + this._injects + ')';
  };
  VisitEntry.prototype.hashCode = function () {
    var result = this._clazz_3.hashCode();
    result = imul(result, 31) + hashCode(this._injects) | 0;
    return result;
  };
  VisitEntry.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this._clazz_3.equals(tmp0_other_with_cast._clazz_3))
      return false;
    if (!equals_1(this._injects, tmp0_other_with_cast._injects))
      return false;
    return true;
  };
  VisitEntry.$metadata$ = {
    simpleName: 'VisitEntry',
    kind: 'class',
    interfaces: []
  };
  function Companion_204() {
    Companion_instance_203 = this;
    var tmp = this;
    var tmp_0 = getKClass_0(EmptyScene);
    tmp._EMPTY_VISIT_ENTRY = new VisitEntry(tmp_0, emptyList());
  }
  Companion_204.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_203;
  function Companion_getInstance_203() {
    if (Companion_instance_203 == null)
      new Companion_204();
    return Companion_instance_203;
  }
  function setCurrent($this, entry) {
    while ($this._visitStack._get_size__0_k$() <= $this._visitPos) {
      $this._visitStack.add_2bq_k$(Companion_getInstance_203()._EMPTY_VISIT_ENTRY);
      Unit_getInstance();
    }
    $this._visitStack.set_ddb1qf_k$($this._visitPos, entry);
    Unit_getInstance();
  }
  function _no_name_provided__499($newScene, resultContinuation) {
    this._$newScene = $newScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__499.prototype.invoke_0_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__499.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_apply_00_0 = this._$newScene._sceneView;
            this._state_1 = 1;
            suspendResult = this._$newScene.sceneInit_zg0dwy_k$(this._tmp0_apply_00_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            return this._tmp0_apply_00_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__499.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__499(this._$newScene, completion);
    return i;
  };
  _no_name_provided__499.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__500($newScene, resultContinuation) {
    this._$newScene_0 = $newScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__500.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__500.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__500.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_apply_00_1 = this._$newScene_0._sceneView;
            this._state_1 = 1;
            suspendResult = this._$newScene_0.sceneMain_zg0dwy_k$(this._tmp0_apply_00_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__500.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__500(this._$newScene_0, completion);
    return i;
  };
  _no_name_provided__500.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__501($oldScene, resultContinuation) {
    this._$oldScene = $oldScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__501.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__501.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__501.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$oldScene.sceneBeforeLeaving_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__501.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__501(this._$oldScene, completion);
    return i;
  };
  _no_name_provided__501.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__502() {
  }
  _no_name_provided__502.prototype.invoke_g03kql_k$ = function (p0, p1, p2) {
    return _interpolate(p0, p1, p2);
  };
  _no_name_provided__502.prototype.invoke_ifn5k1_k$ = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    return this.invoke_g03kql_k$(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__502.prototype._get_name__0_k$ = function () {
    return '_interpolate';
  };
  _no_name_provided__502.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__503($oldScene, resultContinuation) {
    this._$oldScene_0 = $oldScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__503.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__503.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__503.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._$oldScene_0.sceneDestroy_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = this._$oldScene_0.sceneDestroyInternal_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__503.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__503(this._$oldScene_0, completion);
    return i;
  };
  _no_name_provided__503.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__504($oldScene, resultContinuation) {
    this._$oldScene_1 = $oldScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__504.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__504.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__504.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$oldScene_1.sceneAfterDestroyInternal_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__504.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__504(this._$oldScene_1, completion);
    return i;
  };
  _no_name_provided__504.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__505($newScene, resultContinuation) {
    this._$newScene_1 = $newScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__505.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__505.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__505.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$newScene_1.sceneAfterInit_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__505.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__505(this._$newScene_1, completion);
    return i;
  };
  _no_name_provided__505.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $_changeToCOROUTINE$24(_this_, clazz, injects, time, transition, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__190 = _this_;
    this._clazz_4 = clazz;
    this._injects_0 = injects;
    this._time_9 = time;
    this._transition = transition;
  }
  $_changeToCOROUTINE$24.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            this._oldScene0 = this.__this__190._currentScene;
            this._sceneInjector1 = this.__this__190._views_10._injector_7.child_0_k$().mapInstance_770c45_k$(getKClass_0(SceneContainer), this.__this__190).mapInstance_770c45_k$(getKClass_0(Resources), new Resources(this.__this__190._get_coroutineContext__0_k$(), this.__this__190._views_10._get_globalResources__0_k$()._root_0, this.__this__190._views_10._get_globalResources__0_k$()));
            this._n_12 = 0;
            while (this._n_12 < this._injects_0.length) {
              var tmp0_2 = this._n_12;
              this._n_12 = tmp0_2 + 1 | 0;
              var tmp0__anonymous__3 = this._injects_0[tmp0_2];
              var tmp_0 = getKClassFromExpression_0(tmp0__anonymous__3);
              this._sceneInjector1.mapInstance_770c45_k$(isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE(), tmp0__anonymous__3);
              Unit_getInstance();
            }

            this._state_1 = 1;
            suspendResult = this._sceneInjector1.get$default_b3eqw1_k$(this._clazz_4, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._newScene3 = suspendResult;
            this.__this__190._currentScene = this._newScene3;
            this.__this__190._transitionView.startNewTransition_fd5cks_k$(this._newScene3.__sceneViewContainer, this._transition);
            this._exceptionState = 3;
            this._state_1 = 2;
            var tmp_1 = this._newScene3._get_coroutineContext__0_k$();
            suspendResult = launchUnscopedAndWait(tmp_1, _no_name_provided_$factory_440(this._newScene3, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            Unit_getInstance();
            this._exceptionState = 11;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._exceptionState = 11;
            var tmp_2 = this._exception_0;
            if (tmp_2 instanceof Error) {
              this._e4 = this._exception_0;
              printStackTrace(this._e4);
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 11;
            launchUnscoped(this._newScene3, _no_name_provided_$factory_441(this._newScene3, null));
            if (!(this._oldScene0 == null)) {
              this._state_1 = 5;
              var tmp_3 = this._oldScene0._get_coroutineContext__0_k$();
              suspendResult = launchUnscopedAndWait(tmp_3, _no_name_provided_$factory_442(this._oldScene0, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 5:
            this._state_1 = 6;
            continue $sm;
          case 6:
            if (TimeSpan__compareTo_impl(this._time_9, Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0)) > 0) {
              this._state_1 = 7;
              var tmp_4 = this;
              tmp_4._tmp1_get_05 = ratio$factory(this.__this__190._transitionView);
              var tmp_5 = _no_name_provided_$factory_443();
              var tmp_6 = [V2_init_$Create$(this._tmp1_get_05, 0.0, 1.0, tmp_5, true, null, null, 96, null)];
              suspendResult = tween$default(this.__this__190._transitionView, tmp_6, this._time_9, null, null, false, null, 60, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this.__this__190._transitionView._set_ratio__okcceq_k$(1.0);
                this._state_1 = 8;
                continue $sm;
              }
            }

            break;
          case 7:
            this._state_1 = 8;
            continue $sm;
          case 8:
            this.__this__190._transitionView.endTransition_sv8swh_k$();
            if (!(this._oldScene0 == null)) {
              this._state_1 = 9;
              var tmp_7 = this._oldScene0._get_coroutineContext__0_k$();
              suspendResult = launchUnscopedAndWait(tmp_7, _no_name_provided_$factory_444(this._oldScene0, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 10;
              continue $sm;
            }

            break;
          case 9:
            launchUnscoped(this._oldScene0, _no_name_provided_$factory_445(this._oldScene0, null));
            this._state_1 = 10;
            continue $sm;
          case 10:
            var tmp_8 = this._newScene3._get_coroutineContext__0_k$();
            launchUnscoped_0(tmp_8, _no_name_provided_$factory_446(this._newScene3, null));
            return this._newScene3;
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $_changeToCOROUTINE$24.$metadata$ = {
    simpleName: '$_changeToCOROUTINE$24',
    kind: 'class',
    interfaces: []
  };
  function SceneContainer(views_0, defaultTransition, name) {
    Companion_getInstance_203();
    Container.call(this);
    this._views_10 = views_0;
    this._defaultTransition = defaultTransition;
    this._set_name__qlpr75_k$(name);
    var tmp = this;
    var tmp0_also_0 = new TransitionView();
    this.plusAssign_4l6ao4_k$(tmp0_also_0);
    tmp._transitionView = tmp0_also_0;
    this._currentScene = null;
    this._visitStack = arrayListOf([Companion_getInstance_203()._EMPTY_VISIT_ENTRY]);
    this._visitPos = 0;
  }
  SceneContainer.prototype._get_coroutineContext__0_k$ = function () {
    return this._views_10._coroutineContext_6;
  };
  SceneContainer.prototype.changeTo_71zaf0_k$ = function (clazz, injects, time, transition, $cont) {
    setCurrent(this, new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $cont);
  };
  SceneContainer.prototype.changeTo$default_rq00hm_k$ = function (clazz, injects, time, transition, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0)) {
      time = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    }if (!(($mask0 & 8) === 0))
      transition = this._defaultTransition;
    return this.changeTo_71zaf0_k$(clazz, injects, time, transition, $cont);
  };
  SceneContainer.$metadata$ = {
    simpleName: 'SceneContainer',
    kind: 'class',
    interfaces: [CoroutineScope]
  };
  function ratio$factory($b0) {
    return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
      return $b0._get_ratio__0_k$();
    }, function (value) {
      return $b0._set_ratio__okcceq_k$(value);
    });
  }
  function _no_name_provided_$factory_440($newScene, resultContinuation) {
    var i = new _no_name_provided__499($newScene, resultContinuation);
    var l = function ($cont) {
      return i.invoke_0_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_441($newScene, resultContinuation) {
    var i = new _no_name_provided__500($newScene, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_442($oldScene, resultContinuation) {
    var i = new _no_name_provided__501($oldScene, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_443() {
    var i = new _no_name_provided__502();
    var l = function (p1, p2, p3) {
      return i.invoke_g03kql_k$(p1, p2, p3);
    };
    l.callableName = i._get_name__0_k$();
    return l;
  }
  function _no_name_provided_$factory_444($oldScene, resultContinuation) {
    var i = new _no_name_provided__503($oldScene, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_445($oldScene, resultContinuation) {
    var i = new _no_name_provided__504($oldScene, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_446($newScene, resultContinuation) {
    var i = new _no_name_provided__505($newScene, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  var AlphaTransition;
  function Transition() {
  }
  Transition.$metadata$ = {
    simpleName: 'Transition',
    kind: 'interface',
    interfaces: []
  };
  function Transition_0(render_1) {
    return new _no_name_provided__507(render_1);
  }
  function TransitionProcess() {
  }
  TransitionProcess.prototype.start_rqulwx_k$ = function (prev, next_0) {
    return Unit_getInstance();
  };
  TransitionProcess.prototype.end_rqulwx_k$ = function (prev, next_0) {
    return Unit_getInstance();
  };
  TransitionProcess.prototype.render_g9l5a0_k$ = function (ctx, prev, next_0, ratio) {
    return Unit_getInstance();
  };
  TransitionProcess.$metadata$ = {
    simpleName: 'TransitionProcess',
    kind: 'interface',
    interfaces: []
  };
  function withEasing(_this_, easing) {
    return new _no_name_provided__509(_this_, easing);
  }
  function _get_transitionProcess_($this) {
    var tmp = $this._transitionProcess;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('transitionProcess');
    }
  }
  function TransitionView() {
    Container.call(this);
    dummyView(this);
    Unit_getInstance();
    dummyView(this);
    Unit_getInstance();
    this._transition_0 = AlphaTransition;
  }
  TransitionView.prototype._get_prev__0_k$ = function () {
    return this.get_ha5a7z_k$(0);
  };
  TransitionView.prototype._get_next__0_k$ = function () {
    return this.get_ha5a7z_k$(1);
  };
  TransitionView.prototype.startNewTransition_fd5cks_k$ = function (next_0, transition) {
    this._transition_0 = transition;
    this._set_ratio__okcceq_k$(0.0);
    this._transitionProcess = transition.create_0_k$();
    this.setViews_rqulwx_k$(this._get_next__0_k$(), next_0);
    _get_transitionProcess_(this).start_rqulwx_k$(this._get_prev__0_k$(), this._get_next__0_k$());
  };
  TransitionView.prototype.endTransition_sv8swh_k$ = function () {
    this._set_ratio__okcceq_k$(1.0);
    _get_transitionProcess_(this).end_rqulwx_k$(this._get_prev__0_k$(), this._get_next__0_k$());
    this.setViews_rqulwx_k$(dummyView(this), this._get_next__0_k$());
  };
  TransitionView.prototype.setViews_rqulwx_k$ = function (prev, next_0) {
    this.removeChildren_sv8swh_k$();
    this.addChild_4l6ao4_k$(prev);
    this.addChild_4l6ao4_k$(next_0);
  };
  TransitionView.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (this._get_ratio__0_k$() <= 0.0)
      this._get_prev__0_k$().render_uxru53_k$(ctx);
    else if (this._get_ratio__0_k$() >= 1.0)
      this._get_next__0_k$().render_uxru53_k$(ctx);
    else
      _get_transitionProcess_(this).render_g9l5a0_k$(ctx, this._get_prev__0_k$(), this._get_next__0_k$(), this._get_ratio__0_k$());
  };
  TransitionView.$metadata$ = {
    simpleName: 'TransitionView',
    kind: 'class',
    interfaces: []
  };
  function MaskTransition(transition, reversed_2, smooth, filtering) {
    return TransitionCreate(_no_name_provided_$factory_448(transition, reversed_2, smooth, filtering));
  }
  function MaskTransition$default(transition, reversed_2, smooth, filtering, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      transition = Companion_getInstance_218()._get_CIRCULAR__0_k$();
    if (!(($mask0 & 2) === 0))
      reversed_2 = false;
    if (!(($mask0 & 4) === 0))
      smooth = true;
    if (!(($mask0 & 8) === 0))
      filtering = true;
    return MaskTransition(transition, reversed_2, smooth, filtering);
  }
  function TransitionCreate(block) {
    return new _no_name_provided__512(block);
  }
  function TransitionProcess_0(render_1) {
    return new _no_name_provided__513(render_1);
  }
  function _no_name_provided__506() {
  }
  _no_name_provided__506.prototype.invoke_g9l5a0_k$ = function (ctx, prev, next_0, ratio) {
    var prevAlpha = prev._get_alpha__0_k$();
    var nextAlpha = next_0._get_alpha__0_k$();
    try {
      prev._set_alpha__okcceq_k$(1.0 - ratio);
      next_0._set_alpha__okcceq_k$(ratio);
      prev.render_uxru53_k$(ctx);
      next_0.render_uxru53_k$(ctx);
    }finally {
      prev._set_alpha__okcceq_k$(prevAlpha);
      next_0._set_alpha__okcceq_k$(nextAlpha);
    }
  };
  _no_name_provided__506.prototype.invoke_rsz85a_k$ = function (p1, p2, p3, p4) {
    var tmp = p1 instanceof RenderContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof View ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof View ? p3 : THROW_CCE();
    this.invoke_g9l5a0_k$(tmp, tmp_0, tmp_1, (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__506.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__507($render) {
    this._$render = $render;
  }
  _no_name_provided__507.prototype.create_0_k$ = function () {
    return this;
  };
  _no_name_provided__507.prototype.render_g9l5a0_k$ = function (ctx, prev, next_0, ratio) {
    return this._$render(ctx, prev, next_0, ratio);
  };
  _no_name_provided__507.$metadata$ = {
    kind: 'class',
    interfaces: [Transition, TransitionProcess]
  };
  function _no_name_provided__508($process, $easing) {
    this._$process_0 = $process;
    this._$easing = $easing;
  }
  _no_name_provided__508.prototype.start_rqulwx_k$ = function (prev, next_0) {
    return this._$process_0.start_rqulwx_k$(prev, next_0);
  };
  _no_name_provided__508.prototype.end_rqulwx_k$ = function (prev, next_0) {
    return this._$process_0.end_rqulwx_k$(prev, next_0);
  };
  _no_name_provided__508.prototype.render_g9l5a0_k$ = function (ctx, prev, next_0, ratio) {
    return this._$process_0.render_g9l5a0_k$(ctx, prev, next_0, this._$easing.invoke_e2tf9d_k$(ratio));
  };
  _no_name_provided__508.$metadata$ = {
    kind: 'class',
    interfaces: [TransitionProcess]
  };
  function _no_name_provided__509($this_withEasing, $easing) {
    this._$this_withEasing = $this_withEasing;
    this._$easing_0 = $easing;
  }
  _no_name_provided__509.prototype.create_0_k$ = function () {
    var process_1 = this._$this_withEasing.create_0_k$();
    return new _no_name_provided__508(process_1, this._$easing_0);
  };
  _no_name_provided__509.$metadata$ = {
    kind: 'class',
    interfaces: [Transition]
  };
  function _no_name_provided__510($filter) {
    this._$filter_1 = $filter;
  }
  _no_name_provided__510.prototype.invoke_g9l5a0_k$ = function (ctx, prev, next_0, ratio) {
    this._$filter_1._set_ratio__okcceq_k$(ratio);
    prev.render_uxru53_k$(ctx);
    next_0.renderFiltered_o3hpcp_k$(ctx, this._$filter_1);
  };
  _no_name_provided__510.prototype.invoke_rsz85a_k$ = function (p1, p2, p3, p4) {
    var tmp = p1 instanceof RenderContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof View ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof View ? p3 : THROW_CCE();
    this.invoke_g9l5a0_k$(tmp, tmp_0, tmp_1, (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__510.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__511($transition, $reversed, $smooth, $filtering) {
    this._$transition = $transition;
    this._$reversed = $reversed;
    this._$smooth = $smooth;
    this._$filtering = $filtering;
  }
  _no_name_provided__511.prototype.invoke_0_k$ = function () {
    var filter = TransitionFilter_init_$Create$(this._$transition, this._$reversed, this._$smooth, 0.0, this._$filtering, 8, null);
    return TransitionProcess_0(_no_name_provided_$factory_449(filter));
  };
  _no_name_provided__511.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__512($block) {
    this._$block_6 = $block;
  }
  _no_name_provided__512.prototype.create_0_k$ = function () {
    return this._$block_6();
  };
  _no_name_provided__512.$metadata$ = {
    kind: 'class',
    interfaces: [Transition]
  };
  function _no_name_provided__513($render) {
    this._$render_0 = $render;
  }
  _no_name_provided__513.prototype.render_g9l5a0_k$ = function (ctx, prev, next_0, ratio) {
    return this._$render_0(ctx, prev, next_0, ratio);
  };
  _no_name_provided__513.$metadata$ = {
    kind: 'class',
    interfaces: [TransitionProcess]
  };
  function _no_name_provided_$factory_447() {
    var i = new _no_name_provided__506();
    return function (p1, p2, p3, p4) {
      i.invoke_g9l5a0_k$(p1, p2, p3, p4);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_448($transition, $reversed, $smooth, $filtering) {
    var i = new _no_name_provided__511($transition, $reversed, $smooth, $filtering);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_449($filter) {
    var i = new _no_name_provided__510($filter);
    return function (p1, p2, p3, p4) {
      i.invoke_g9l5a0_k$(p1, p2, p3, p4);
      return Unit_getInstance();
    };
  }
  function IStorage() {
  }
  IStorage.$metadata$ = {
    simpleName: 'IStorage',
    kind: 'interface',
    interfaces: []
  };
  var storage$delegate;
  function toMap_3(_this_) {
    var tmp0_associateWith_0 = _this_.keys_0_k$();
    var result_1 = LinkedHashMap_init_$Create$_1(coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateWith_0, 10)), 16));
    var tmp0_iterator_1_2 = tmp0_associateWith_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      result_1.put_1q9pf_k$(element_2_3, _this_.getOrNull_6wfw3l_k$(element_2_3));
      Unit_getInstance();
    }
    return result_1;
  }
  function _no_name_provided__514() {
  }
  _no_name_provided__514.prototype.invoke_sdzoaq_k$ = function ($this$$receiver) {
    return new NativeStorage($this$$receiver);
  };
  _no_name_provided__514.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_sdzoaq_k$(p1 instanceof Views ? p1 : THROW_CCE());
  };
  _no_name_provided__514.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_450() {
    var i = new _no_name_provided__514();
    return function (p1) {
      return i.invoke_sdzoaq_k$(p1);
    };
  }
  var fadeThread$delegate;
  var changing$delegate;
  function _no_name_provided__515() {
  }
  _no_name_provided__515.prototype.invoke_0_k$ = function () {
    return new AsyncThread();
  };
  _no_name_provided__515.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__516() {
  }
  _no_name_provided__516.prototype.invoke_0_k$ = function () {
    return false;
  };
  _no_name_provided__516.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_451() {
    var i = new _no_name_provided__515();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_452() {
    var i = new _no_name_provided__516();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function fadeThread$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_451();
    return new Property(null, tmp0_extraProperty_0);
  }
  function changing$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_452();
    return new Property(null, tmp0_extraProperty_0);
  }
  function Named() {
  }
  Named.$metadata$ = {
    simpleName: 'Named',
    kind: 'interface',
    interfaces: []
  };
  function Counter(name) {
    this._name_35 = name;
    this._frameCount = 0.0;
    this._countThisFrame = 0;
    this._totalCount = 0.0;
  }
  Counter.prototype._get_avgCountPerFrame__0_k$ = function () {
    return this._totalCount / this._frameCount;
  };
  Counter.prototype.increment_majfzk_k$ = function (count_0) {
    var tmp0_this = this;
    tmp0_this._countThisFrame = tmp0_this._countThisFrame + count_0 | 0;
  };
  Counter.prototype.startFrame_sv8swh_k$ = function () {
    var tmp0_this = this;
    tmp0_this._totalCount = tmp0_this._totalCount + this._countThisFrame;
    var tmp1_this = this;
    var tmp2 = tmp1_this._frameCount;
    tmp1_this._frameCount = tmp2 + 1;
    Unit_getInstance();
    this._countThisFrame = 0;
  };
  Counter.prototype.toString = function () {
    return '' + 'Counter(' + this._name_35 + '): [frames=' + this._frameCount + ', totalCount=' + this._totalCount + ', countThisFrame=' + this._countThisFrame + ', avgCountPerFrame=' + this._get_avgCountPerFrame__0_k$() + ']';
  };
  Counter.$metadata$ = {
    simpleName: 'Counter',
    kind: 'class',
    interfaces: [Named]
  };
  function RCollection() {
    this._list_3 = ArrayList_init_$Create$();
    this._byName = LinkedHashMap_init_$Create$();
  }
  RCollection.$metadata$ = {
    simpleName: 'RCollection',
    kind: 'class',
    interfaces: []
  };
  function Stats_1() {
    this._counters = new RCollection();
    this._values_6 = new RCollection();
  }
  Stats_1.prototype.startFrame_sv8swh_k$ = function () {
    var tmp0_fastForEach_0 = this._counters._list_3;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      tmp1__anonymous__3.startFrame_sv8swh_k$();
    }
    var tmp2_fastForEach_0 = this._values_6._list_3;
    var n_1_0 = 0;
    while (n_1_0 < tmp2_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_0 = n_1_0;
      n_1_0 = tmp0_2_0 + 1 | 0;
      var tmp3__anonymous__3 = tmp2_fastForEach_0.get_ha5a7z_k$(tmp0_2_0);
      tmp3__anonymous__3.startFrame_sv8swh_k$();
    }
  };
  Stats_1.prototype.counter_6wfw3l_k$ = function (name) {
    var tmp0_getOrPut_0 = this._counters;
    var tmp0_getOrPut_0_1 = tmp0_getOrPut_0._byName;
    var value_1_2 = tmp0_getOrPut_0_1.get_2bw_k$(name);
    var tmp;
    if (value_1_2 == null) {
      var tmp0_apply_0_4_4 = new Counter(name);
      var tmp0_this_2_5_5 = tmp0_getOrPut_0;
      var tmp0_plusAssign_0_3_6_6 = tmp0_this_2_5_5._list_3;
      tmp0_plusAssign_0_3_6_6.add_2bq_k$(tmp0_apply_0_4_4);
      Unit_getInstance();
      var answer_2_3 = tmp0_apply_0_4_4;
      tmp0_getOrPut_0_1.put_1q9pf_k$(name, answer_2_3);
      Unit_getInstance();
      tmp = answer_2_3;
    } else {
      tmp = value_1_2;
    }
    return tmp;
  };
  Stats_1.$metadata$ = {
    simpleName: 'Stats',
    kind: 'class',
    interfaces: []
  };
  var tilemapLog;
  var Orientation_ORTHOGONAL_instance;
  var Orientation_ISOMETRIC_instance;
  var Orientation_STAGGERED_instance;
  var Orientation_HEXAGONAL_instance;
  var Orientation_entriesInitialized;
  function Orientation_initEntries() {
    if (Orientation_entriesInitialized)
      return Unit_getInstance();
    Orientation_entriesInitialized = true;
    Orientation_ORTHOGONAL_instance = new Orientation_0('ORTHOGONAL', 0, 'orthogonal');
    Orientation_ISOMETRIC_instance = new Orientation_0('ISOMETRIC', 1, 'isometric');
    Orientation_STAGGERED_instance = new Orientation_0('STAGGERED', 2, 'staggered');
    Orientation_HEXAGONAL_instance = new Orientation_0('HEXAGONAL', 3, 'hexagonal');
  }
  var RenderOrder_RIGHT_DOWN_instance;
  var RenderOrder_RIGHT_UP_instance;
  var RenderOrder_LEFT_DOWN_instance;
  var RenderOrder_LEFT_UP_instance;
  var RenderOrder_entriesInitialized;
  function RenderOrder_initEntries() {
    if (RenderOrder_entriesInitialized)
      return Unit_getInstance();
    RenderOrder_entriesInitialized = true;
    RenderOrder_RIGHT_DOWN_instance = new RenderOrder('RIGHT_DOWN', 0, 'right-down');
    RenderOrder_RIGHT_UP_instance = new RenderOrder('RIGHT_UP', 1, 'right-up');
    RenderOrder_LEFT_DOWN_instance = new RenderOrder('LEFT_DOWN', 2, 'left-down');
    RenderOrder_LEFT_UP_instance = new RenderOrder('LEFT_UP', 3, 'left-up');
  }
  var StaggerAxis_X_instance;
  var StaggerAxis_Y_instance;
  var StaggerAxis_entriesInitialized;
  function StaggerAxis_initEntries() {
    if (StaggerAxis_entriesInitialized)
      return Unit_getInstance();
    StaggerAxis_entriesInitialized = true;
    StaggerAxis_X_instance = new StaggerAxis('X', 0, 'x');
    StaggerAxis_Y_instance = new StaggerAxis('Y', 1, 'y');
  }
  var StaggerIndex_EVEN_instance;
  var StaggerIndex_ODD_instance;
  var StaggerIndex_entriesInitialized;
  function StaggerIndex_initEntries() {
    if (StaggerIndex_entriesInitialized)
      return Unit_getInstance();
    StaggerIndex_entriesInitialized = true;
    StaggerIndex_EVEN_instance = new StaggerIndex('EVEN', 0, 'even');
    StaggerIndex_ODD_instance = new StaggerIndex('ODD', 1, 'odd');
  }
  var ObjectAlignment_UNSPECIFIED_instance;
  var ObjectAlignment_TOP_LEFT_instance;
  var ObjectAlignment_TOP_instance;
  var ObjectAlignment_TOP_RIGHT_instance;
  var ObjectAlignment_LEFT_instance;
  var ObjectAlignment_CENTER_instance;
  var ObjectAlignment_RIGHT_instance;
  var ObjectAlignment_BOTTOM_LEFT_instance;
  var ObjectAlignment_BOTTOM_instance;
  var ObjectAlignment_BOTTOM_RIGHT_instance;
  function values_13() {
    return [ObjectAlignment_UNSPECIFIED_getInstance(), ObjectAlignment_TOP_LEFT_getInstance(), ObjectAlignment_TOP_getInstance(), ObjectAlignment_TOP_RIGHT_getInstance(), ObjectAlignment_LEFT_getInstance(), ObjectAlignment_CENTER_getInstance(), ObjectAlignment_RIGHT_getInstance(), ObjectAlignment_BOTTOM_LEFT_getInstance(), ObjectAlignment_BOTTOM_getInstance(), ObjectAlignment_BOTTOM_RIGHT_getInstance()];
  }
  var ObjectAlignment_entriesInitialized;
  function ObjectAlignment_initEntries() {
    if (ObjectAlignment_entriesInitialized)
      return Unit_getInstance();
    ObjectAlignment_entriesInitialized = true;
    ObjectAlignment_UNSPECIFIED_instance = new ObjectAlignment('UNSPECIFIED', 0, 'unspecified');
    ObjectAlignment_TOP_LEFT_instance = new ObjectAlignment('TOP_LEFT', 1, 'topleft');
    ObjectAlignment_TOP_instance = new ObjectAlignment('TOP', 2, 'top');
    ObjectAlignment_TOP_RIGHT_instance = new ObjectAlignment('TOP_RIGHT', 3, 'topright');
    ObjectAlignment_LEFT_instance = new ObjectAlignment('LEFT', 4, 'left');
    ObjectAlignment_CENTER_instance = new ObjectAlignment('CENTER', 5, 'center');
    ObjectAlignment_RIGHT_instance = new ObjectAlignment('RIGHT', 6, 'right');
    ObjectAlignment_BOTTOM_LEFT_instance = new ObjectAlignment('BOTTOM_LEFT', 7, 'bottomleft');
    ObjectAlignment_BOTTOM_instance = new ObjectAlignment('BOTTOM', 8, 'bottom');
    ObjectAlignment_BOTTOM_RIGHT_instance = new ObjectAlignment('BOTTOM_RIGHT', 9, 'bottomright');
  }
  var Orientation_ORTHOGONAL_instance_0;
  var Orientation_ISOMETRIC_instance_0;
  function values_14() {
    return [Orientation_ORTHOGONAL_getInstance(), Orientation_ISOMETRIC_getInstance()];
  }
  var Orientation_entriesInitialized_0;
  function Orientation_initEntries_0() {
    if (Orientation_entriesInitialized_0)
      return Unit_getInstance();
    Orientation_entriesInitialized_0 = true;
    Orientation_ORTHOGONAL_instance_0 = new Orientation('ORTHOGONAL', 0, 'orthogonal');
    Orientation_ISOMETRIC_instance_0 = new Orientation('ISOMETRIC', 1, 'isometric');
  }
  function Orientation(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_29 = value;
  }
  Orientation.$metadata$ = {
    simpleName: 'Orientation',
    kind: 'class',
    interfaces: []
  };
  function Orientation_ORTHOGONAL_getInstance() {
    Orientation_initEntries_0();
    return Orientation_ORTHOGONAL_instance_0;
  }
  function Orientation_ISOMETRIC_getInstance() {
    Orientation_initEntries_0();
    return Orientation_ISOMETRIC_instance_0;
  }
  var DrawOrder_INDEX_instance;
  var DrawOrder_TOP_DOWN_instance;
  function values_15() {
    return [DrawOrder_INDEX_getInstance(), DrawOrder_TOP_DOWN_getInstance()];
  }
  var DrawOrder_entriesInitialized;
  function DrawOrder_initEntries() {
    if (DrawOrder_entriesInitialized)
      return Unit_getInstance();
    DrawOrder_entriesInitialized = true;
    DrawOrder_INDEX_instance = new DrawOrder('INDEX', 0, 'index');
    DrawOrder_TOP_DOWN_instance = new DrawOrder('TOP_DOWN', 1, 'topdown');
  }
  function Rectangle_1(width, height) {
    Shape_1.call(this);
    this._width_22 = width;
    this._height_23 = height;
  }
  Rectangle_1.prototype.toVectorPath_0_k$ = function () {
    var tmp0_buildPath_0 = VectorPath_init_$Create$(null, null, null, 7, null);
    rect(tmp0_buildPath_0, 0.0, 0.0, this._width_22, this._height_23);
    return tmp0_buildPath_0;
  };
  Rectangle_1.prototype.toShape2d_0_k$ = function () {
    var tmp0_invoke_0 = Companion_getInstance_46();
    var tmp1_invoke_0 = this._width_22;
    var tmp2_invoke_0 = this._height_23;
    return new Rectangle_0(new Rectangle(0.0, 0.0, tmp1_invoke_0, tmp2_invoke_0));
  };
  Rectangle_1.prototype.toString = function () {
    return '' + 'Rectangle(width=' + this._width_22 + ', height=' + this._height_23 + ')';
  };
  Rectangle_1.prototype.hashCode = function () {
    var result = getNumberHashCode(this._width_22);
    result = imul(result, 31) + getNumberHashCode(this._height_23) | 0;
    return result;
  };
  Rectangle_1.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle_1))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Rectangle_1 ? other : THROW_CCE();
    if (!equals_1(this._width_22, tmp0_other_with_cast._width_22))
      return false;
    if (!equals_1(this._height_23, tmp0_other_with_cast._height_23))
      return false;
    return true;
  };
  Rectangle_1.$metadata$ = {
    simpleName: 'Rectangle',
    kind: 'class',
    interfaces: []
  };
  function Ellipse_0(width, height) {
    Shape_1.call(this);
    this._width_23 = width;
    this._height_24 = height;
  }
  Ellipse_0.prototype.toVectorPath_0_k$ = function () {
    var tmp0_buildPath_0 = VectorPath_init_$Create$(null, null, null, 7, null);
    ellipse(tmp0_buildPath_0, 0.0, 0.0, this._width_23, this._height_24);
    return tmp0_buildPath_0;
  };
  Ellipse_0.prototype.toShape2d_0_k$ = function () {
    var tmp = Companion_getInstance_51();
    return tmp.EllipseOrCircle$default_nyqti8_k$(0.0, 0.0, this._width_23, this._height_24, null, 0, 48, null);
  };
  Ellipse_0.prototype.toString = function () {
    return '' + 'Ellipse(width=' + this._width_23 + ', height=' + this._height_24 + ')';
  };
  Ellipse_0.prototype.hashCode = function () {
    var result = getNumberHashCode(this._width_23);
    result = imul(result, 31) + getNumberHashCode(this._height_24) | 0;
    return result;
  };
  Ellipse_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ellipse_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Ellipse_0 ? other : THROW_CCE();
    if (!equals_1(this._width_23, tmp0_other_with_cast._width_23))
      return false;
    if (!equals_1(this._height_24, tmp0_other_with_cast._height_24))
      return false;
    return true;
  };
  Ellipse_0.$metadata$ = {
    simpleName: 'Ellipse',
    kind: 'class',
    interfaces: []
  };
  function PPoint() {
    PPoint_instance = this;
    Shape_1.call(this);
  }
  PPoint.prototype.toVectorPath_0_k$ = function () {
    var tmp0_buildPath_0 = VectorPath_init_$Create$(null, null, null, 7, null);
    Unit_getInstance();
    return tmp0_buildPath_0;
  };
  PPoint.$metadata$ = {
    simpleName: 'PPoint',
    kind: 'object',
    interfaces: []
  };
  var PPoint_instance;
  function PPoint_getInstance() {
    if (PPoint_instance == null)
      new PPoint();
    return PPoint_instance;
  }
  function Polygon_0(points) {
    Shape_1.call(this);
    this._points_6 = points;
  }
  Polygon_0.prototype.toVectorPath_0_k$ = function () {
    var tmp0_buildPath_0 = VectorPath_init_$Create$(null, null, null, 7, null);
    polygon$default(tmp0_buildPath_0, this._points_6, false, 2, null);
    return tmp0_buildPath_0;
  };
  Polygon_0.prototype.toString = function () {
    return '' + 'Polygon(points=' + this._points_6 + ')';
  };
  Polygon_0.prototype.hashCode = function () {
    return hashCode(this._points_6);
  };
  Polygon_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Polygon_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Polygon_0 ? other : THROW_CCE();
    if (!equals_1(this._points_6, tmp0_other_with_cast._points_6))
      return false;
    return true;
  };
  Polygon_0.$metadata$ = {
    simpleName: 'Polygon',
    kind: 'class',
    interfaces: []
  };
  function Polyline_0(points) {
    Shape_1.call(this);
    this._points_7 = points;
  }
  Polyline_0.prototype.toVectorPath_0_k$ = function () {
    var tmp0_buildPath_0 = VectorPath_init_$Create$(null, null, null, 7, null);
    polygon$default(tmp0_buildPath_0, this._points_7, false, 2, null);
    return tmp0_buildPath_0;
  };
  Polyline_0.prototype.toString = function () {
    return '' + 'Polyline(points=' + this._points_7 + ')';
  };
  Polyline_0.prototype.hashCode = function () {
    return hashCode(this._points_7);
  };
  Polyline_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Polyline_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Polyline_0 ? other : THROW_CCE();
    if (!equals_1(this._points_7, tmp0_other_with_cast._points_7))
      return false;
    return true;
  };
  Polyline_0.$metadata$ = {
    simpleName: 'Polyline',
    kind: 'class',
    interfaces: []
  };
  function Text_2(fontFamily, pixelSize, wordWrap, color_0, bold, italic, underline, strikeout, kerning, hAlign, vAlign) {
    Shape_1.call(this);
    this._fontFamily = fontFamily;
    this._pixelSize = pixelSize;
    this._wordWrap = wordWrap;
    this._color_7 = color_0;
    this._bold = bold;
    this._italic = italic;
    this._underline = underline;
    this._strikeout = strikeout;
    this._kerning_0 = kerning;
    this._hAlign = hAlign;
    this._vAlign = vAlign;
  }
  Text_2.prototype.toVectorPath_0_k$ = function () {
    var tmp0_buildPath_0 = VectorPath_init_$Create$(null, null, null, 7, null);
    Unit_getInstance();
    return tmp0_buildPath_0;
  };
  Text_2.prototype.toString = function () {
    return '' + 'Text(fontFamily=' + this._fontFamily + ', pixelSize=' + this._pixelSize + ', wordWrap=' + this._wordWrap + ', color=' + new RGBA(this._color_7) + ', bold=' + this._bold + ', italic=' + this._italic + ', underline=' + this._underline + ', strikeout=' + this._strikeout + ', kerning=' + this._kerning_0 + ', hAlign=' + this._hAlign + ', vAlign=' + this._vAlign + ')';
  };
  Text_2.prototype.hashCode = function () {
    var result = getStringHashCode(this._fontFamily);
    result = imul(result, 31) + this._pixelSize | 0;
    result = imul(result, 31) + (this._wordWrap | 0) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl(this._color_7) | 0;
    result = imul(result, 31) + (this._bold | 0) | 0;
    result = imul(result, 31) + (this._italic | 0) | 0;
    result = imul(result, 31) + (this._underline | 0) | 0;
    result = imul(result, 31) + (this._strikeout | 0) | 0;
    result = imul(result, 31) + (this._kerning_0 | 0) | 0;
    result = imul(result, 31) + this._hAlign.hashCode() | 0;
    result = imul(result, 31) + this._vAlign.hashCode() | 0;
    return result;
  };
  Text_2.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Text_2))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Text_2 ? other : THROW_CCE();
    if (!(this._fontFamily === tmp0_other_with_cast._fontFamily))
      return false;
    if (!(this._pixelSize === tmp0_other_with_cast._pixelSize))
      return false;
    if (!(this._wordWrap === tmp0_other_with_cast._wordWrap))
      return false;
    if (!equals_1(new RGBA(this._color_7), new RGBA(tmp0_other_with_cast._color_7)))
      return false;
    if (!(this._bold === tmp0_other_with_cast._bold))
      return false;
    if (!(this._italic === tmp0_other_with_cast._italic))
      return false;
    if (!(this._underline === tmp0_other_with_cast._underline))
      return false;
    if (!(this._strikeout === tmp0_other_with_cast._strikeout))
      return false;
    if (!(this._kerning_0 === tmp0_other_with_cast._kerning_0))
      return false;
    if (!this._hAlign.equals(tmp0_other_with_cast._hAlign))
      return false;
    if (!this._vAlign.equals(tmp0_other_with_cast._vAlign))
      return false;
    return true;
  };
  Text_2.$metadata$ = {
    simpleName: 'Text',
    kind: 'class',
    interfaces: []
  };
  function Object_init_$Init$(id, gid, name, type, bounds_0, rotation_0, visible, objectShape, properties, $mask0, $marker, $this) {
    if (!(($mask0 & 128) === 0))
      objectShape = PPoint_getInstance();
    if (!(($mask0 & 256) === 0)) {
      properties = LinkedHashMap_init_$Create$();
    }Object_0.call($this, id, gid, name, type, bounds_0, rotation_0, visible, objectShape, properties);
    return $this;
  }
  function Object_init_$Create$(id, gid, name, type, bounds_0, rotation_0, visible, objectShape, properties, $mask0, $marker) {
    return Object_init_$Init$(id, gid, name, type, bounds_0, rotation_0, visible, objectShape, properties, $mask0, $marker, Object.create(Object_0.prototype));
  }
  function DrawOrder(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_30 = value;
  }
  DrawOrder.$metadata$ = {
    simpleName: 'DrawOrder',
    kind: 'class',
    interfaces: []
  };
  function Shape_1() {
  }
  Shape_1.prototype.toShape2d_0_k$ = function () {
    var tmp = this.toVectorPath_0_k$();
    return toShape2dNew$default(tmp, false, 1, null);
  };
  Shape_1.$metadata$ = {
    simpleName: 'Shape',
    kind: 'class',
    interfaces: []
  };
  function DrawOrder_INDEX_getInstance() {
    DrawOrder_initEntries();
    return DrawOrder_INDEX_instance;
  }
  function DrawOrder_TOP_DOWN_getInstance() {
    DrawOrder_initEntries();
    return DrawOrder_TOP_DOWN_instance;
  }
  var TextHAlignment_LEFT_instance;
  var TextHAlignment_CENTER_instance;
  var TextHAlignment_RIGHT_instance;
  var TextHAlignment_JUSTIFY_instance;
  function values_16() {
    return [TextHAlignment_LEFT_getInstance(), TextHAlignment_CENTER_getInstance(), TextHAlignment_RIGHT_getInstance(), TextHAlignment_JUSTIFY_getInstance()];
  }
  var TextHAlignment_entriesInitialized;
  function TextHAlignment_initEntries() {
    if (TextHAlignment_entriesInitialized)
      return Unit_getInstance();
    TextHAlignment_entriesInitialized = true;
    TextHAlignment_LEFT_instance = new TextHAlignment('LEFT', 0, 'left');
    TextHAlignment_CENTER_instance = new TextHAlignment('CENTER', 1, 'center');
    TextHAlignment_RIGHT_instance = new TextHAlignment('RIGHT', 2, 'right');
    TextHAlignment_JUSTIFY_instance = new TextHAlignment('JUSTIFY', 3, 'justify');
  }
  var TextVAlignment_TOP_instance;
  var TextVAlignment_CENTER_instance;
  var TextVAlignment_BOTTOM_instance;
  function values_17() {
    return [TextVAlignment_TOP_getInstance(), TextVAlignment_CENTER_getInstance(), TextVAlignment_BOTTOM_getInstance()];
  }
  var TextVAlignment_entriesInitialized;
  function TextVAlignment_initEntries() {
    if (TextVAlignment_entriesInitialized)
      return Unit_getInstance();
    TextVAlignment_entriesInitialized = true;
    TextVAlignment_TOP_instance = new TextVAlignment('TOP', 0, 'top');
    TextVAlignment_CENTER_instance = new TextVAlignment('CENTER', 1, 'center');
    TextVAlignment_BOTTOM_instance = new TextVAlignment('BOTTOM', 2, 'bottom');
  }
  function Embedded(format_0, image, encoding, compression, transparent) {
    Image_0.call(this, image._get_width__0_k$(), image._get_height__0_k$(), transparent);
    this._format_4 = format_0;
    this._image = image;
    this._encoding = encoding;
    this._compression = compression;
  }
  Embedded.$metadata$ = {
    simpleName: 'Embedded',
    kind: 'class',
    interfaces: []
  };
  function External_0(source, width, height, transparent) {
    Image_0.call(this, width, height, transparent);
    this._source_0 = source;
  }
  External_0.$metadata$ = {
    simpleName: 'External',
    kind: 'class',
    interfaces: []
  };
  var Encoding_BASE64_instance;
  var Encoding_CSV_instance;
  var Encoding_XML_instance;
  function values_18() {
    return [Encoding_BASE64_getInstance(), Encoding_CSV_getInstance(), Encoding_XML_getInstance()];
  }
  var Encoding_entriesInitialized;
  function Encoding_initEntries() {
    if (Encoding_entriesInitialized)
      return Unit_getInstance();
    Encoding_entriesInitialized = true;
    Encoding_BASE64_instance = new Encoding('BASE64', 0, 'base64');
    Encoding_CSV_instance = new Encoding('CSV', 1, 'csv');
    Encoding_XML_instance = new Encoding('XML', 2, null);
  }
  var Compression_NO_instance;
  var Compression_GZIP_instance;
  var Compression_ZLIB_instance;
  var Compression_ZSTD_instance;
  function values_19() {
    return [Compression_NO_getInstance(), Compression_GZIP_getInstance(), Compression_ZLIB_getInstance(), Compression_ZSTD_getInstance()];
  }
  var Compression_entriesInitialized;
  function Compression_initEntries() {
    if (Compression_entriesInitialized)
      return Unit_getInstance();
    Compression_entriesInitialized = true;
    Compression_NO_instance = new Compression('NO', 0, null);
    Compression_GZIP_instance = new Compression('GZIP', 1, 'gzip');
    Compression_ZLIB_instance = new Compression('ZLIB', 2, 'zlib');
    Compression_ZSTD_instance = new Compression('ZSTD', 3, 'zstd');
  }
  function StringT(value) {
    Property_0.call(this);
    this._value_31 = value;
  }
  StringT.prototype._get_string__0_k$ = function () {
    return this._value_31;
  };
  StringT.$metadata$ = {
    simpleName: 'StringT',
    kind: 'class',
    interfaces: []
  };
  function IntT(value) {
    Property_0.call(this);
    this._value_32 = value;
  }
  IntT.prototype._get_string__0_k$ = function () {
    return '' + this._value_32;
  };
  IntT.$metadata$ = {
    simpleName: 'IntT',
    kind: 'class',
    interfaces: []
  };
  function FloatT(value) {
    Property_0.call(this);
    this._value_33 = value;
  }
  FloatT.prototype._get_string__0_k$ = function () {
    return '' + this._value_33;
  };
  FloatT.$metadata$ = {
    simpleName: 'FloatT',
    kind: 'class',
    interfaces: []
  };
  function BoolT(value) {
    Property_0.call(this);
    this._value_34 = value;
  }
  BoolT.prototype._get_string__0_k$ = function () {
    return '' + this._value_34;
  };
  BoolT.$metadata$ = {
    simpleName: 'BoolT',
    kind: 'class',
    interfaces: []
  };
  function ColorT(value) {
    Property_0.call(this);
    this._value_35 = value;
  }
  ColorT.prototype._get_string__0_k$ = function () {
    return '' + new RGBA(this._value_35);
  };
  ColorT.$metadata$ = {
    simpleName: 'ColorT',
    kind: 'class',
    interfaces: []
  };
  function FileT(path_0) {
    Property_0.call(this);
    this._path_30 = path_0;
  }
  FileT.prototype._get_string__0_k$ = function () {
    return this._path_30;
  };
  FileT.$metadata$ = {
    simpleName: 'FileT',
    kind: 'class',
    interfaces: []
  };
  function ObjectT(id) {
    Property_0.call(this);
    this._id_28 = id;
  }
  ObjectT.prototype._get_string__0_k$ = function () {
    return '' + this._id_28;
  };
  ObjectT.$metadata$ = {
    simpleName: 'ObjectT',
    kind: 'class',
    interfaces: []
  };
  function Tiles_init_$Init$(map_0, encoding, compression, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      map_0 = Bitmap32_init_$Create$(0, 0, null, false, 12, null);
    }if (!(($mask0 & 2) === 0))
      encoding = Encoding_XML_getInstance();
    if (!(($mask0 & 4) === 0))
      compression = Compression_NO_getInstance();
    Tiles.call($this, map_0, encoding, compression);
    return $this;
  }
  function Tiles_init_$Create$(map_0, encoding, compression, $mask0, $marker) {
    return Tiles_init_$Init$(map_0, encoding, compression, $mask0, $marker, Object.create(Tiles.prototype));
  }
  function Objects_init_$Init$(color_0, drawOrder, objects, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      color_0 = Colors_getInstance()._WHITE_0;
    if (!(($mask0 & 2) === 0))
      drawOrder = DrawOrder_TOP_DOWN_getInstance();
    if (!(($mask0 & 4) === 0))
      objects = FastArrayList_init_$Create$();
    Objects.call($this, color_0, drawOrder, objects);
    return $this;
  }
  function Objects_init_$Create$(color_0, drawOrder, objects, $mask0, $marker) {
    return Objects_init_$Init$(color_0, drawOrder, objects, $mask0, $marker, Object.create(Objects.prototype));
  }
  function _no_name_provided__517(this$0) {
    this._this$0_139 = this$0;
  }
  _no_name_provided__517.prototype.invoke_0_k$ = function () {
    var tmp0_associateBy_0 = this._this$0_139._objects_0;
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateBy_0, 10)), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = tmp0_associateBy_0.iterator_0_k$();
    while (tmp0_iterator_1_3.hasNext_0_k$()) {
      var element_2_4 = tmp0_iterator_1_3.next_0_k$();
      tmp0_associateByTo_0_2.put_1q9pf_k$(element_2_4._id_29, element_2_4);
      Unit_getInstance();
    }
    return tmp0_associateByTo_0_2;
  };
  _no_name_provided__517.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__518(this$0) {
    this._this$0_140 = this$0;
  }
  _no_name_provided__518.prototype.invoke_0_k$ = function () {
    var tmp0_associateBy_0 = this._this$0_140._objects_0;
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateBy_0, 10)), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = tmp0_associateBy_0.iterator_0_k$();
    while (tmp0_iterator_1_3.hasNext_0_k$()) {
      var element_2_4 = tmp0_iterator_1_3.next_0_k$();
      tmp0_associateByTo_0_2.put_1q9pf_k$(element_2_4._name_36, element_2_4);
      Unit_getInstance();
    }
    return tmp0_associateByTo_0_2;
  };
  _no_name_provided__518.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__519(this$0) {
    this._this$0_141 = this$0;
  }
  _no_name_provided__519.prototype.invoke_0_k$ = function () {
    var tmp0_groupBy_0 = this._this$0_141._objects_0;
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_groupBy_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var element_2_3 = tmp0_iterator_1_2.next_0_k$();
      var key_3_4 = element_2_3._type_23;
      var value_1_6 = tmp0_groupByTo_0_1.get_2bw_k$(key_3_4);
      var tmp;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_1q9pf_k$(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp = answer_2_7;
      } else {
        tmp = value_1_6;
      }
      var list_4_5 = tmp;
      list_4_5.add_2bq_k$(element_2_3);
      Unit_getInstance();
    }
    return tmp0_groupByTo_0_1;
  };
  _no_name_provided__519.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Image_init_$Init$(image, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      image = null;
    Image.call($this, image);
    return $this;
  }
  function Image_init_$Create$(image, $mask0, $marker) {
    return Image_init_$Init$(image, $mask0, $marker, Object.create(Image.prototype));
  }
  function Group_init_$Init$(layers, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      layers = ArrayList_init_$Create$();
    }Group.call($this, layers);
    return $this;
  }
  function Group_init_$Create$(layers, $mask0, $marker) {
    return Group_init_$Init$(layers, $mask0, $marker, Object.create(Group.prototype));
  }
  function Tiles(map_0, encoding, compression) {
    Layer.call(this);
    this._map_7 = map_0;
    this._encoding_0 = encoding;
    this._compression_0 = compression;
  }
  Tiles.$metadata$ = {
    simpleName: 'Tiles',
    kind: 'class',
    interfaces: []
  };
  function Objects(color_0, drawOrder, objects) {
    Layer.call(this);
    this._color_8 = color_0;
    this._drawOrder = drawOrder;
    this._objects_0 = objects;
    var tmp = this;
    tmp._objectsById$delegate = lazy(_no_name_provided_$factory_453(this));
    var tmp_0 = this;
    tmp_0._objectsByName$delegate = lazy(_no_name_provided_$factory_454(this));
    var tmp_1 = this;
    tmp_1._objectsByType$delegate = lazy(_no_name_provided_$factory_455(this));
  }
  Objects.prototype.toString = function () {
    return '' + 'Objects(color=' + new RGBA(this._color_8) + ', drawOrder=' + this._drawOrder + ', objects=' + this._objects_0 + ')';
  };
  Objects.prototype.hashCode = function () {
    var result = RGBA__hashCode_impl(this._color_8);
    result = imul(result, 31) + this._drawOrder.hashCode() | 0;
    result = imul(result, 31) + this._objects_0.hashCode() | 0;
    return result;
  };
  Objects.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Objects))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Objects ? other : THROW_CCE();
    if (!equals_1(new RGBA(this._color_8), new RGBA(tmp0_other_with_cast._color_8)))
      return false;
    if (!this._drawOrder.equals(tmp0_other_with_cast._drawOrder))
      return false;
    if (!this._objects_0.equals(tmp0_other_with_cast._objects_0))
      return false;
    return true;
  };
  Objects.$metadata$ = {
    simpleName: 'Objects',
    kind: 'class',
    interfaces: []
  };
  function Image(image) {
    Layer.call(this);
    this._image_0 = image;
  }
  Image.$metadata$ = {
    simpleName: 'Image',
    kind: 'class',
    interfaces: []
  };
  function Group(layers) {
    Layer.call(this);
    this._layers_2 = layers;
  }
  Group.$metadata$ = {
    simpleName: 'Group',
    kind: 'class',
    interfaces: []
  };
  function Orientation_0(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_36 = value;
  }
  Orientation_0.$metadata$ = {
    simpleName: 'Orientation',
    kind: 'class',
    interfaces: []
  };
  function RenderOrder(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_37 = value;
  }
  RenderOrder.$metadata$ = {
    simpleName: 'RenderOrder',
    kind: 'class',
    interfaces: []
  };
  function StaggerAxis(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_38 = value;
  }
  StaggerAxis.$metadata$ = {
    simpleName: 'StaggerAxis',
    kind: 'class',
    interfaces: []
  };
  function StaggerIndex(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_39 = value;
  }
  StaggerIndex.$metadata$ = {
    simpleName: 'StaggerIndex',
    kind: 'class',
    interfaces: []
  };
  function ObjectAlignment(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_40 = value;
  }
  ObjectAlignment.$metadata$ = {
    simpleName: 'ObjectAlignment',
    kind: 'class',
    interfaces: []
  };
  function Grid(cellWidth, cellHeight, orientation) {
    this._cellWidth = cellWidth;
    this._cellHeight = cellHeight;
    this._orientation = orientation;
  }
  Grid.$metadata$ = {
    simpleName: 'Grid',
    kind: 'class',
    interfaces: []
  };
  function Object_0(id, gid, name, type, bounds_0, rotation_0, visible, objectShape, properties) {
    this._id_29 = id;
    this._gid = gid;
    this._name_36 = name;
    this._type_23 = type;
    this._bounds_13 = bounds_0;
    this._rotation_1 = rotation_0;
    this._visible_0 = visible;
    this._objectShape = objectShape;
    this._properties = properties;
  }
  Object_0.prototype.getTransform_0_k$ = function () {
    return Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null).pretranslate_ngl742_k$(this._bounds_13._x_2, this._bounds_13._y_2).prerotate_ubek5g_k$(_get_degrees__1(this._rotation_1));
  };
  Object_0.prototype.toShape2dNoTransformed_0_k$ = function () {
    return this._objectShape.toShape2d_0_k$();
  };
  Object_0.prototype.toString = function () {
    return '' + 'Object(id=' + this._id_29 + ', gid=' + this._gid + ', name=' + this._name_36 + ', type=' + this._type_23 + ', bounds=' + this._bounds_13 + ', rotation=' + this._rotation_1 + ', visible=' + this._visible_0 + ', objectShape=' + this._objectShape + ', properties=' + this._properties + ')';
  };
  Object_0.prototype.hashCode = function () {
    var result = this._id_29;
    result = imul(result, 31) + (this._gid == null ? 0 : this._gid) | 0;
    result = imul(result, 31) + getStringHashCode(this._name_36) | 0;
    result = imul(result, 31) + getStringHashCode(this._type_23) | 0;
    result = imul(result, 31) + this._bounds_13.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._rotation_1) | 0;
    result = imul(result, 31) + (this._visible_0 | 0) | 0;
    result = imul(result, 31) + hashCode(this._objectShape) | 0;
    result = imul(result, 31) + hashCode(this._properties) | 0;
    return result;
  };
  Object_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Object_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Object_0 ? other : THROW_CCE();
    if (!(this._id_29 === tmp0_other_with_cast._id_29))
      return false;
    if (!(this._gid == tmp0_other_with_cast._gid))
      return false;
    if (!(this._name_36 === tmp0_other_with_cast._name_36))
      return false;
    if (!(this._type_23 === tmp0_other_with_cast._type_23))
      return false;
    if (!this._bounds_13.equals(tmp0_other_with_cast._bounds_13))
      return false;
    if (!equals_1(this._rotation_1, tmp0_other_with_cast._rotation_1))
      return false;
    if (!(this._visible_0 === tmp0_other_with_cast._visible_0))
      return false;
    if (!equals_1(this._objectShape, tmp0_other_with_cast._objectShape))
      return false;
    if (!equals_1(this._properties, tmp0_other_with_cast._properties))
      return false;
    return true;
  };
  Object_0.$metadata$ = {
    simpleName: 'Object',
    kind: 'class',
    interfaces: []
  };
  function TextHAlignment(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_41 = value;
  }
  TextHAlignment.$metadata$ = {
    simpleName: 'TextHAlignment',
    kind: 'class',
    interfaces: []
  };
  function TextVAlignment(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_42 = value;
  }
  TextVAlignment.$metadata$ = {
    simpleName: 'TextVAlignment',
    kind: 'class',
    interfaces: []
  };
  function Image_0(width, height, transparent) {
    this._width_24 = width;
    this._height_25 = height;
    this._transparent = transparent;
  }
  Image_0.$metadata$ = {
    simpleName: 'Image',
    kind: 'class',
    interfaces: []
  };
  function Encoding(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_43 = value;
  }
  Encoding.$metadata$ = {
    simpleName: 'Encoding',
    kind: 'class',
    interfaces: []
  };
  function Compression(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this._value_44 = value;
  }
  Compression.$metadata$ = {
    simpleName: 'Compression',
    kind: 'class',
    interfaces: []
  };
  function Property_0() {
  }
  Property_0.prototype.toString = function () {
    return this._get_string__0_k$();
  };
  Property_0.$metadata$ = {
    simpleName: 'Property',
    kind: 'class',
    interfaces: []
  };
  function TiledTileset(tileset, data, firstgid) {
    this._tileset = tileset;
    this._data_55 = data;
    this._firstgid = firstgid;
  }
  TiledTileset.prototype._get_maxgid__0_k$ = function () {
    return this._firstgid + this._tileset._get_textures__0_k$().length | 0;
  };
  TiledTileset.prototype.toString = function () {
    return '' + 'TiledTileset(tileset=' + this._tileset + ', data=' + this._data_55 + ', firstgid=' + this._firstgid + ')';
  };
  TiledTileset.prototype.hashCode = function () {
    var result = hashCode(this._tileset);
    result = imul(result, 31) + this._data_55.hashCode() | 0;
    result = imul(result, 31) + this._firstgid | 0;
    return result;
  };
  TiledTileset.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TiledTileset))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TiledTileset ? other : THROW_CCE();
    if (!equals_1(this._tileset, tmp0_other_with_cast._tileset))
      return false;
    if (!this._data_55.equals(tmp0_other_with_cast._data_55))
      return false;
    if (!(this._firstgid === tmp0_other_with_cast._firstgid))
      return false;
    return true;
  };
  TiledTileset.$metadata$ = {
    simpleName: 'TiledTileset',
    kind: 'class',
    interfaces: []
  };
  function Layer() {
    this._id_30 = 1;
    this._name_37 = '';
    this._visible_1 = true;
    this._locked = false;
    this._opacity = 1.0;
    this._tintColor = null;
    this._offsetx = 0.0;
    this._offsety = 0.0;
    var tmp = this;
    tmp._properties_0 = LinkedHashMap_init_$Create$();
  }
  Layer.$metadata$ = {
    simpleName: 'Layer',
    kind: 'class',
    interfaces: []
  };
  function EditorSettings(chunkWidth, chunkHeight) {
    this._chunkWidth = chunkWidth;
    this._chunkHeight = chunkHeight;
  }
  EditorSettings.$metadata$ = {
    simpleName: 'EditorSettings',
    kind: 'class',
    interfaces: []
  };
  function Orientation_ORTHOGONAL_getInstance_0() {
    Orientation_initEntries();
    return Orientation_ORTHOGONAL_instance;
  }
  function Orientation_STAGGERED_getInstance() {
    Orientation_initEntries();
    return Orientation_STAGGERED_instance;
  }
  function RenderOrder_RIGHT_DOWN_getInstance() {
    RenderOrder_initEntries();
    return RenderOrder_RIGHT_DOWN_instance;
  }
  function RenderOrder_RIGHT_UP_getInstance() {
    RenderOrder_initEntries();
    return RenderOrder_RIGHT_UP_instance;
  }
  function RenderOrder_LEFT_DOWN_getInstance() {
    RenderOrder_initEntries();
    return RenderOrder_LEFT_DOWN_instance;
  }
  function RenderOrder_LEFT_UP_getInstance() {
    RenderOrder_initEntries();
    return RenderOrder_LEFT_UP_instance;
  }
  function StaggerAxis_X_getInstance() {
    StaggerAxis_initEntries();
    return StaggerAxis_X_instance;
  }
  function StaggerAxis_Y_getInstance() {
    StaggerAxis_initEntries();
    return StaggerAxis_Y_instance;
  }
  function StaggerIndex_EVEN_getInstance() {
    StaggerIndex_initEntries();
    return StaggerIndex_EVEN_instance;
  }
  function StaggerIndex_ODD_getInstance() {
    StaggerIndex_initEntries();
    return StaggerIndex_ODD_instance;
  }
  function ObjectAlignment_UNSPECIFIED_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_UNSPECIFIED_instance;
  }
  function ObjectAlignment_TOP_LEFT_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_TOP_LEFT_instance;
  }
  function ObjectAlignment_TOP_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_TOP_instance;
  }
  function ObjectAlignment_TOP_RIGHT_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_TOP_RIGHT_instance;
  }
  function ObjectAlignment_LEFT_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_LEFT_instance;
  }
  function ObjectAlignment_CENTER_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_CENTER_instance;
  }
  function ObjectAlignment_RIGHT_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_RIGHT_instance;
  }
  function ObjectAlignment_BOTTOM_LEFT_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_BOTTOM_LEFT_instance;
  }
  function ObjectAlignment_BOTTOM_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_BOTTOM_instance;
  }
  function ObjectAlignment_BOTTOM_RIGHT_getInstance() {
    ObjectAlignment_initEntries();
    return ObjectAlignment_BOTTOM_RIGHT_instance;
  }
  function TextHAlignment_LEFT_getInstance() {
    TextHAlignment_initEntries();
    return TextHAlignment_LEFT_instance;
  }
  function TextHAlignment_CENTER_getInstance() {
    TextHAlignment_initEntries();
    return TextHAlignment_CENTER_instance;
  }
  function TextHAlignment_RIGHT_getInstance() {
    TextHAlignment_initEntries();
    return TextHAlignment_RIGHT_instance;
  }
  function TextHAlignment_JUSTIFY_getInstance() {
    TextHAlignment_initEntries();
    return TextHAlignment_JUSTIFY_instance;
  }
  function TextVAlignment_TOP_getInstance() {
    TextVAlignment_initEntries();
    return TextVAlignment_TOP_instance;
  }
  function TextVAlignment_CENTER_getInstance() {
    TextVAlignment_initEntries();
    return TextVAlignment_CENTER_instance;
  }
  function TextVAlignment_BOTTOM_getInstance() {
    TextVAlignment_initEntries();
    return TextVAlignment_BOTTOM_instance;
  }
  function Encoding_BASE64_getInstance() {
    Encoding_initEntries();
    return Encoding_BASE64_instance;
  }
  function Encoding_CSV_getInstance() {
    Encoding_initEntries();
    return Encoding_CSV_instance;
  }
  function Encoding_XML_getInstance() {
    Encoding_initEntries();
    return Encoding_XML_instance;
  }
  function Compression_NO_getInstance() {
    Compression_initEntries();
    return Compression_NO_instance;
  }
  function Compression_GZIP_getInstance() {
    Compression_initEntries();
    return Compression_GZIP_instance;
  }
  function Compression_ZLIB_getInstance() {
    Compression_initEntries();
    return Compression_ZLIB_instance;
  }
  function Compression_ZSTD_getInstance() {
    Compression_initEntries();
    return Compression_ZSTD_instance;
  }
  function TiledMap(data, tilesets) {
    this._data_56 = data;
    this._tilesets = tilesets;
  }
  TiledMap.prototype._get_tilewidth__0_k$ = function () {
    return this._data_56._tilewidth;
  };
  TiledMap.prototype._get_tileheight__0_k$ = function () {
    return this._data_56._tileheight;
  };
  TiledMap.prototype._get_allLayers__0_k$ = function () {
    return this._data_56._allLayers;
  };
  TiledMap.$metadata$ = {
    simpleName: 'TiledMap',
    kind: 'class',
    interfaces: []
  };
  function toTileSet(_this_) {
    var tilesets = _this_;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tilesets, 10));
    var tmp0_iterator_1_2 = tilesets.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(item_2_3._get_maxgid__0_k$());
      Unit_getInstance();
    }
    var tmp0_elvis_lhs = maxOrNull(tmp0_mapTo_0_1);
    var maxGid = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp = imul(maxGid, 2);
    var tiles = IntMap_init_$Create$(tmp, 0.0, 2, null);
    var tmp_0 = imul(maxGid, 2);
    var collisions = IntMap_init_$Create$(tmp_0, 0.0, 2, null);
    var n_1 = 0;
    while (n_1 < tilesets._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp0__anonymous__3 = tilesets.get_ha5a7z_k$(tmp0_2);
      var tmp0_fastForEach_0_4 = tmp0__anonymous__3._tileset._texturesMap;
      var tmp_1;
      if (tmp0_fastForEach_0_4._hasZero_0) {
        Companion_getInstance_22();
        tmp_1 = 2147483647;
      } else {
        tmp_1 = tmp0_fastForEach_0_4.nextNonEmptyIndex_pb76ll_k$(tmp0_fastForEach_0_4.__keys_2, 0);
      }
      var index_1_1_5 = tmp_1;
      $l$break: while (true) {
        var tmp_2 = index_1_1_5;
        Companion_getInstance_22();
        if (!!(tmp_2 === 2147483646)) {
          break $l$break;
        }var tmp0_subject_2_3_7 = index_1_1_5;
        var tmp_3;
        var tmp_4;
        Companion_getInstance_22();
        if (tmp0_subject_2_3_7 === 2147483647) {
          tmp_4 = true;
        } else {
          {
            Companion_getInstance_22();
            tmp_4 = tmp0_subject_2_3_7 === 2147483646;
          }
        }
        if (tmp_4) {
          tmp_3 = 0;
        } else {
          {
            tmp_3 = tmp0_fastForEach_0_4.__keys_2[index_1_1_5];
          }
        }
        var tmp0__anonymous__3_2_6 = tmp_3;
        var tmp1__anonymous__4_8 = ensureNotNull(tmp0_fastForEach_0_4.get_ha5a7z_k$(tmp0__anonymous__3_2_6));
        var id_5_9 = tmp0__anonymous__3._firstgid + tmp0__anonymous__3_2_6 | 0;
        tiles.set_bq5tp3_k$(id_5_9, tmp1__anonymous__4_8.copy$default_ohfk3m_k$(id_5_9, null, null, 6, null));
        Unit_getInstance();
        var tmp_5 = tmp0_fastForEach_0_4.__keys_2;
        var tmp_6;
        var tmp_7 = index_1_1_5;
        Companion_getInstance_22();
        if (tmp_7 === 2147483647) {
          tmp_6 = 0;
        } else {
          {
            tmp_6 = index_1_1_5 + 1 | 0;
          }
        }
        index_1_1_5 = tmp0_fastForEach_0_4.nextNonEmptyIndex_pb76ll_k$(tmp_5, tmp_6);
      }
      var tmp2_fastForEach_0_10 = tmp0__anonymous__3._tileset._collisionsMap;
      var tmp_8;
      if (tmp2_fastForEach_0_10._hasZero_0) {
        Companion_getInstance_22();
        tmp_8 = 2147483647;
      } else {
        tmp_8 = tmp2_fastForEach_0_10.nextNonEmptyIndex_pb76ll_k$(tmp2_fastForEach_0_10.__keys_2, 0);
      }
      var index_1_1_11 = tmp_8;
      $l$break_0: while (true) {
        var tmp_9 = index_1_1_11;
        Companion_getInstance_22();
        if (!!(tmp_9 === 2147483646)) {
          break $l$break_0;
        }var tmp0_subject_2_3_13 = index_1_1_11;
        var tmp_10;
        var tmp_11;
        Companion_getInstance_22();
        if (tmp0_subject_2_3_13 === 2147483647) {
          tmp_11 = true;
        } else {
          {
            Companion_getInstance_22();
            tmp_11 = tmp0_subject_2_3_13 === 2147483646;
          }
        }
        if (tmp_11) {
          tmp_10 = 0;
        } else {
          {
            tmp_10 = tmp2_fastForEach_0_10.__keys_2[index_1_1_11];
          }
        }
        var tmp0__anonymous__3_2_12 = tmp_10;
        var tmp3__anonymous__4_14 = ensureNotNull(tmp2_fastForEach_0_10.get_ha5a7z_k$(tmp0__anonymous__3_2_12));
        collisions.set_bq5tp3_k$(tmp0__anonymous__3._firstgid + tmp0__anonymous__3_2_12 | 0, tmp3__anonymous__4_14);
        Unit_getInstance();
        var tmp_12 = tmp2_fastForEach_0_10.__keys_2;
        var tmp_13;
        var tmp_14 = index_1_1_11;
        Companion_getInstance_22();
        if (tmp_14 === 2147483647) {
          tmp_13 = 0;
        } else {
          {
            tmp_13 = index_1_1_11 + 1 | 0;
          }
        }
        index_1_1_11 = tmp2_fastForEach_0_10.nextNonEmptyIndex_pb76ll_k$(tmp_12, tmp_13);
      }
    }
    return TileSet_init_$Create$(tiles, 0, 0, collisions, 6, null);
  }
  function TiledMapData_init_$Init$(orientation, renderOrder, compressionLevel, width, height, tilewidth, tileheight, hexSideLength, staggerAxis, staggerIndex, backgroundColor, nextLayerId, nextObjectId, infinite, properties, allLayers, tilesets, editorSettings, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      orientation = Orientation_ORTHOGONAL_getInstance_0();
    if (!(($mask0 & 2) === 0))
      renderOrder = RenderOrder_RIGHT_DOWN_getInstance();
    if (!(($mask0 & 4) === 0))
      compressionLevel = -1;
    if (!(($mask0 & 8) === 0))
      width = 0;
    if (!(($mask0 & 16) === 0))
      height = 0;
    if (!(($mask0 & 32) === 0))
      tilewidth = 0;
    if (!(($mask0 & 64) === 0))
      tileheight = 0;
    if (!(($mask0 & 128) === 0))
      hexSideLength = null;
    if (!(($mask0 & 256) === 0))
      staggerAxis = null;
    if (!(($mask0 & 512) === 0))
      staggerIndex = null;
    if (!(($mask0 & 1024) === 0))
      backgroundColor = null;
    if (!(($mask0 & 2048) === 0))
      nextLayerId = 1;
    if (!(($mask0 & 4096) === 0))
      nextObjectId = 1;
    if (!(($mask0 & 8192) === 0))
      infinite = false;
    if (!(($mask0 & 16384) === 0)) {
      properties = LinkedHashMap_init_$Create$();
    }if (!(($mask0 & 32768) === 0)) {
      allLayers = ArrayList_init_$Create$();
    }if (!(($mask0 & 65536) === 0)) {
      tilesets = ArrayList_init_$Create$();
    }if (!(($mask0 & 131072) === 0))
      editorSettings = null;
    TiledMapData.call($this, orientation, renderOrder, compressionLevel, width, height, tilewidth, tileheight, hexSideLength, staggerAxis, staggerIndex, backgroundColor, nextLayerId, nextObjectId, infinite, properties, allLayers, tilesets, editorSettings);
    return $this;
  }
  function TiledMapData_init_$Create$(orientation, renderOrder, compressionLevel, width, height, tilewidth, tileheight, hexSideLength, staggerAxis, staggerIndex, backgroundColor, nextLayerId, nextObjectId, infinite, properties, allLayers, tilesets, editorSettings, $mask0, $marker) {
    return TiledMapData_init_$Init$(orientation, renderOrder, compressionLevel, width, height, tilewidth, tileheight, hexSideLength, staggerAxis, staggerIndex, backgroundColor, nextLayerId, nextObjectId, infinite, properties, allLayers, tilesets, editorSettings, $mask0, $marker, Object.create(TiledMapData.prototype));
  }
  function TiledMapData(orientation, renderOrder, compressionLevel, width, height, tilewidth, tileheight, hexSideLength, staggerAxis, staggerIndex, backgroundColor, nextLayerId, nextObjectId, infinite, properties, allLayers, tilesets, editorSettings) {
    this._orientation_0 = orientation;
    this._renderOrder = renderOrder;
    this._compressionLevel = compressionLevel;
    this._width_25 = width;
    this._height_26 = height;
    this._tilewidth = tilewidth;
    this._tileheight = tileheight;
    this._hexSideLength = hexSideLength;
    this._staggerAxis = staggerAxis;
    this._staggerIndex = staggerIndex;
    this._backgroundColor = backgroundColor;
    this._nextLayerId = nextLayerId;
    this._nextObjectId = nextObjectId;
    this._infinite = infinite;
    this._properties_1 = properties;
    this._allLayers = allLayers;
    this._tilesets_0 = tilesets;
    this._editorSettings = editorSettings;
  }
  TiledMapData.$metadata$ = {
    simpleName: 'TiledMapData',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__520() {
  }
  _no_name_provided__520.prototype.invoke_6lq1h2_k$ = function (_anonymous_parameter_0_, it) {
    return it._id_31;
  };
  _no_name_provided__520.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_6lq1h2_k$(tmp, p2 instanceof TileData ? p2 : THROW_CCE());
  };
  _no_name_provided__520.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TileSetData(name, firstgid, tileWidth, tileHeight, tileCount, spacing, margin, columns, image, tileOffsetX, tileOffsetY, grid, tilesetSource, objectAlignment, terrains, wangsets, tiles, properties) {
    this._name_38 = name;
    this._firstgid_0 = firstgid;
    this._tileWidth = tileWidth;
    this._tileHeight = tileHeight;
    this._tileCount = tileCount;
    this._spacing = spacing;
    this._margin = margin;
    this._columns = columns;
    this._image_1 = image;
    this._tileOffsetX = tileOffsetX;
    this._tileOffsetY = tileOffsetY;
    this._grid = grid;
    this._tilesetSource = tilesetSource;
    this._objectAlignment = objectAlignment;
    this._terrains = terrains;
    this._wangsets = wangsets;
    this._tiles = tiles;
    this._properties_2 = properties;
    var tmp = this;
    tmp._tilesById = associateByInt(this._tiles, _no_name_provided_$factory_456());
  }
  TileSetData.prototype._get_width__0_k$ = function () {
    var tmp0_safe_receiver = this._image_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._width_24;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  TileSetData.prototype._get_height__0_k$ = function () {
    var tmp0_safe_receiver = this._image_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._height_25;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  TileSetData.prototype.toString = function () {
    return '' + 'TileSetData(name=' + this._name_38 + ', firstgid=' + this._firstgid_0 + ', tileWidth=' + this._tileWidth + ', tileHeight=' + this._tileHeight + ', tileCount=' + this._tileCount + ', spacing=' + this._spacing + ', margin=' + this._margin + ', columns=' + this._columns + ', image=' + this._image_1 + ', tileOffsetX=' + this._tileOffsetX + ', tileOffsetY=' + this._tileOffsetY + ', grid=' + this._grid + ', tilesetSource=' + this._tilesetSource + ', objectAlignment=' + this._objectAlignment + ', terrains=' + this._terrains + ', wangsets=' + this._wangsets + ', tiles=' + this._tiles + ', properties=' + this._properties_2 + ')';
  };
  TileSetData.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_38);
    result = imul(result, 31) + this._firstgid_0 | 0;
    result = imul(result, 31) + this._tileWidth | 0;
    result = imul(result, 31) + this._tileHeight | 0;
    result = imul(result, 31) + this._tileCount | 0;
    result = imul(result, 31) + this._spacing | 0;
    result = imul(result, 31) + this._margin | 0;
    result = imul(result, 31) + this._columns | 0;
    result = imul(result, 31) + (this._image_1 == null ? 0 : hashCode(this._image_1)) | 0;
    result = imul(result, 31) + this._tileOffsetX | 0;
    result = imul(result, 31) + this._tileOffsetY | 0;
    result = imul(result, 31) + (this._grid == null ? 0 : hashCode(this._grid)) | 0;
    result = imul(result, 31) + (this._tilesetSource == null ? 0 : getStringHashCode(this._tilesetSource)) | 0;
    result = imul(result, 31) + this._objectAlignment.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._terrains) | 0;
    result = imul(result, 31) + hashCode(this._wangsets) | 0;
    result = imul(result, 31) + hashCode(this._tiles) | 0;
    result = imul(result, 31) + hashCode(this._properties_2) | 0;
    return result;
  };
  TileSetData.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TileSetData))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TileSetData ? other : THROW_CCE();
    if (!(this._name_38 === tmp0_other_with_cast._name_38))
      return false;
    if (!(this._firstgid_0 === tmp0_other_with_cast._firstgid_0))
      return false;
    if (!(this._tileWidth === tmp0_other_with_cast._tileWidth))
      return false;
    if (!(this._tileHeight === tmp0_other_with_cast._tileHeight))
      return false;
    if (!(this._tileCount === tmp0_other_with_cast._tileCount))
      return false;
    if (!(this._spacing === tmp0_other_with_cast._spacing))
      return false;
    if (!(this._margin === tmp0_other_with_cast._margin))
      return false;
    if (!(this._columns === tmp0_other_with_cast._columns))
      return false;
    if (!equals_1(this._image_1, tmp0_other_with_cast._image_1))
      return false;
    if (!(this._tileOffsetX === tmp0_other_with_cast._tileOffsetX))
      return false;
    if (!(this._tileOffsetY === tmp0_other_with_cast._tileOffsetY))
      return false;
    if (!equals_1(this._grid, tmp0_other_with_cast._grid))
      return false;
    if (!(this._tilesetSource == tmp0_other_with_cast._tilesetSource))
      return false;
    if (!this._objectAlignment.equals(tmp0_other_with_cast._objectAlignment))
      return false;
    if (!equals_1(this._terrains, tmp0_other_with_cast._terrains))
      return false;
    if (!equals_1(this._wangsets, tmp0_other_with_cast._wangsets))
      return false;
    if (!equals_1(this._tiles, tmp0_other_with_cast._tiles))
      return false;
    if (!equals_1(this._properties_2, tmp0_other_with_cast._properties_2))
      return false;
    return true;
  };
  TileSetData.$metadata$ = {
    simpleName: 'TileSetData',
    kind: 'class',
    interfaces: []
  };
  function TerrainData(name, tile, properties) {
    this._name_39 = name;
    this._tile = tile;
    this._properties_3 = properties;
  }
  TerrainData.prototype.toString = function () {
    return '' + 'TerrainData(name=' + this._name_39 + ', tile=' + this._tile + ', properties=' + this._properties_3 + ')';
  };
  TerrainData.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_39);
    result = imul(result, 31) + this._tile | 0;
    result = imul(result, 31) + hashCode(this._properties_3) | 0;
    return result;
  };
  TerrainData.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TerrainData))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TerrainData ? other : THROW_CCE();
    if (!(this._name_39 === tmp0_other_with_cast._name_39))
      return false;
    if (!(this._tile === tmp0_other_with_cast._tile))
      return false;
    if (!equals_1(this._properties_3, tmp0_other_with_cast._properties_3))
      return false;
    return true;
  };
  TerrainData.$metadata$ = {
    simpleName: 'TerrainData',
    kind: 'class',
    interfaces: []
  };
  function TileData(id, type, terrain, probability, image, properties, objectGroup, frames) {
    this._id_31 = id;
    this._type_24 = type;
    this._terrain = terrain;
    this._probability = probability;
    this._image_2 = image;
    this._properties_4 = properties;
    this._objectGroup = objectGroup;
    this._frames_1 = frames;
    var tmp = this;
    var tmp0_elvis_lhs = this._terrain;
    tmp._terrainInfo = new TerrainInfo(tmp0_elvis_lhs == null ? listOf([null, null, null, null]) : tmp0_elvis_lhs);
  }
  TileData.prototype.toString = function () {
    return '' + 'TileData(id=' + this._id_31 + ', type=' + this._type_24 + ', terrain=' + this._terrain + ', probability=' + this._probability + ', image=' + this._image_2 + ', properties=' + this._properties_4 + ', objectGroup=' + this._objectGroup + ', frames=' + this._frames_1 + ')';
  };
  TileData.prototype.hashCode = function () {
    var result = this._id_31;
    result = imul(result, 31) + (this._type_24 == null ? 0 : getStringHashCode(this._type_24)) | 0;
    result = imul(result, 31) + (this._terrain == null ? 0 : hashCode(this._terrain)) | 0;
    result = imul(result, 31) + getNumberHashCode(this._probability) | 0;
    result = imul(result, 31) + (this._image_2 == null ? 0 : hashCode(this._image_2)) | 0;
    result = imul(result, 31) + hashCode(this._properties_4) | 0;
    result = imul(result, 31) + (this._objectGroup == null ? 0 : this._objectGroup.hashCode()) | 0;
    result = imul(result, 31) + (this._frames_1 == null ? 0 : hashCode(this._frames_1)) | 0;
    return result;
  };
  TileData.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TileData))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TileData ? other : THROW_CCE();
    if (!(this._id_31 === tmp0_other_with_cast._id_31))
      return false;
    if (!(this._type_24 == tmp0_other_with_cast._type_24))
      return false;
    if (!equals_1(this._terrain, tmp0_other_with_cast._terrain))
      return false;
    if (!equals_1(this._probability, tmp0_other_with_cast._probability))
      return false;
    if (!equals_1(this._image_2, tmp0_other_with_cast._image_2))
      return false;
    if (!equals_1(this._properties_4, tmp0_other_with_cast._properties_4))
      return false;
    if (!equals_1(this._objectGroup, tmp0_other_with_cast._objectGroup))
      return false;
    if (!equals_1(this._frames_1, tmp0_other_with_cast._frames_1))
      return false;
    return true;
  };
  TileData.$metadata$ = {
    simpleName: 'TileData',
    kind: 'class',
    interfaces: []
  };
  function WangColor(name, color_0, tileId, probability) {
    this._name_40 = name;
    this._color_9 = color_0;
    this._tileId = tileId;
    this._probability_0 = probability;
  }
  WangColor.$metadata$ = {
    simpleName: 'WangColor',
    kind: 'class',
    interfaces: []
  };
  function WangTile(tileId, wangId, hflip, vflip, dflip) {
    this._tileId_0 = tileId;
    this._wangId = wangId;
    this._hflip = hflip;
    this._vflip = vflip;
    this._dflip = dflip;
  }
  WangTile.$metadata$ = {
    simpleName: 'WangTile',
    kind: 'class',
    interfaces: []
  };
  function WangSet(name, tileId, properties, cornerColors, edgeColors, wangtiles) {
    this._name_41 = name;
    this._tileId_1 = tileId;
    this._properties_5 = properties;
    this._cornerColors = cornerColors;
    this._edgeColors = edgeColors;
    this._wangtiles = wangtiles;
  }
  WangSet.$metadata$ = {
    simpleName: 'WangSet',
    kind: 'class',
    interfaces: []
  };
  function AnimationFrameData(tileId, duration) {
    this._tileId_2 = tileId;
    this._duration_1 = duration;
  }
  AnimationFrameData.prototype.toString = function () {
    return '' + 'AnimationFrameData(tileId=' + this._tileId_2 + ', duration=' + this._duration_1 + ')';
  };
  AnimationFrameData.prototype.hashCode = function () {
    var result = this._tileId_2;
    result = imul(result, 31) + this._duration_1 | 0;
    return result;
  };
  AnimationFrameData.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnimationFrameData))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AnimationFrameData ? other : THROW_CCE();
    if (!(this._tileId_2 === tmp0_other_with_cast._tileId_2))
      return false;
    if (!(this._duration_1 === tmp0_other_with_cast._duration_1))
      return false;
    return true;
  };
  AnimationFrameData.$metadata$ = {
    simpleName: 'AnimationFrameData',
    kind: 'class',
    interfaces: []
  };
  function TerrainInfo(info) {
    this._info_5 = info;
  }
  TerrainInfo.prototype.toString = function () {
    return '' + 'TerrainInfo(info=' + this._info_5 + ')';
  };
  TerrainInfo.prototype.hashCode = function () {
    return hashCode(this._info_5);
  };
  TerrainInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TerrainInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TerrainInfo ? other : THROW_CCE();
    if (!equals_1(this._info_5, tmp0_other_with_cast._info_5))
      return false;
    return true;
  };
  TerrainInfo.$metadata$ = {
    simpleName: 'TerrainInfo',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_453(this$0) {
    var i = new _no_name_provided__517(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_454(this$0) {
    var i = new _no_name_provided__518(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_455(this$0) {
    var i = new _no_name_provided__519(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_456() {
    var i = new _no_name_provided__520();
    return function (p1, p2) {
      return i.invoke_6lq1h2_k$(p1, p2);
    };
  }
  var spaces;
  function readTiledMap(_this_, hasTransparentColor, transparentColor, createBorder, atlas, $cont) {
    var tmp = new $readTiledMapCOROUTINE$25(_this_, hasTransparentColor, transparentColor, createBorder, atlas, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readTiledMap$default(_this_, hasTransparentColor, transparentColor, createBorder, atlas, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      hasTransparentColor = false;
    if (!(($mask0 & 2) === 0))
      transparentColor = Colors_getInstance()._FUCHSIA;
    if (!(($mask0 & 4) === 0))
      createBorder = 1;
    if (!(($mask0 & 8) === 0))
      atlas = null;
    return readTiledMap(_this_, hasTransparentColor, transparentColor, createBorder, atlas, $cont);
  }
  function readTiledMapData(_this_, $cont) {
    var tmp = new $readTiledMapDataCOROUTINE$26(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function toTiledSet(_this_, folder, hasTransparentColor, transparentColor, createBorder, atlas, $cont) {
    var tmp = new $toTiledSetCOROUTINE$27(_this_, folder, hasTransparentColor, transparentColor, createBorder, atlas, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function colorFromARGB(color_0, default_0) {
    var tmp;
    var tmp_0 = new Char(35);
    if (!startsWith$default(color_0, tmp_0, false, 2, null)) {
      tmp = true;
    } else {
      {
        tmp = !(color_0.length === 9) ? !(color_0.length === 7) : false;
      }
    }
    if (tmp)
      return default_0;
    else {
    }
    var hex = color_0.substring(1);
    var start = color_0.length === 7 ? 0 : 2;
    var a = color_0.length === 9 ? toInt_0(substr_0(hex, 0, 2), 16) : 255;
    var r = toInt_0(substr_0(hex, start + 0 | 0, 2), 16);
    var g = toInt_0(substr_0(hex, start + 2 | 0, 2), 16);
    var b = toInt_0(substr_0(hex, start + 4 | 0, 2), 16);
    return Companion_getInstance_136().invoke_fnl2i9_k$(r, g, b, a);
  }
  function parseProperties(_this_) {
    var out = LinkedHashMap_init_$Create$();
    var tmp0_iterator = _this_.children_6wfw3l_k$('property').iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var property = tmp0_iterator.next_0_k$();
      var pname = property.str$default_877n1b_k$('name', null, 2, null);
      var tmp1_elvis_lhs = property.strNull_6wfw3l_k$('value');
      var rawValue = tmp1_elvis_lhs == null ? property._get_text__0_k$() : tmp1_elvis_lhs;
      var type = property.str_jg38oy_k$('type', 'string');
      var tmp2_subject = type;
      var tmp;
      switch (tmp2_subject) {
        case 'string':
          tmp = new StringT(rawValue);
          break;
        case 'int':
          var tmp3_elvis_lhs = toIntOrNull(rawValue);
          tmp = new IntT(tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs);
          break;
        case 'float':
          var tmp4_elvis_lhs = toDoubleOrNull(rawValue);
          tmp = new FloatT(tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs);
          break;
        case 'bool':
          tmp = new BoolT(rawValue === 'true');
          break;
        case 'color':
          tmp = new ColorT(colorFromARGB(rawValue, Colors_getInstance()._TRANSPARENT_BLACK));
          break;
        case 'file':
          var tmp_0;
          if (charSequenceLength(rawValue) === 0) {
            tmp_0 = '.';
          } else {
            {
              tmp_0 = rawValue;
            }
          }

          tmp = new FileT(tmp_0);
          break;
        case 'object':
          var tmp5_elvis_lhs = toIntOrNull(rawValue);
          tmp = new ObjectT(tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
          break;
        default:tmp = new StringT(rawValue);
          break;
      }
      var pvalue = tmp;
      out.put_1q9pf_k$(pname, pvalue);
      Unit_getInstance();
    }
    return out;
  }
  function parseTileSetData(tileset, firstgid, tilesetSource) {
    var alignment = tileset.str_jg38oy_k$('objectalignment', 'unspecified');
    var tmp0_find_0 = values_13();
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = tmp0_find_0;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_2_2._value_40 === alignment) {
          tmp$ret$0 = element_2_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_elvis_lhs = tmp$ret$0;
    var objectAlignment = tmp0_elvis_lhs == null ? ObjectAlignment_UNSPECIFIED_getInstance() : tmp0_elvis_lhs;
    var tileOffset = tileset.child_6wfw3l_k$('tileoffset');
    var tmp9_name = tileset.str$default_877n1b_k$('name', null, 2, null);
    var tmp10_tileWidth = tileset.int$default_6ncsww_k$('tilewidth', 0, 2, null);
    var tmp11_tileHeight = tileset.int$default_6ncsww_k$('tileheight', 0, 2, null);
    var tmp12_tileCount = tileset.int_8i7b4u_k$('tilecount', 0);
    var tmp13_spacing = tileset.int_8i7b4u_k$('spacing', 0);
    var tmp14_margin = tileset.int_8i7b4u_k$('margin', 0);
    var tmp15_columns = tileset.int_8i7b4u_k$('columns', 0);
    var tmp1_safe_receiver = tileset.child_6wfw3l_k$('image');
    var tmp16_image = tmp1_safe_receiver == null ? null : parseImage(tmp1_safe_receiver);
    var tmp2_safe_receiver = tileOffset;
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp2_safe_receiver.int$default_6ncsww_k$('x', 0, 2, null);
    }
    var tmp3_elvis_lhs = tmp;
    var tmp17_tileOffsetX = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    var tmp4_safe_receiver = tileOffset;
    var tmp_0;
    if (tmp4_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = tmp4_safe_receiver.int$default_6ncsww_k$('y', 0, 2, null);
    }
    var tmp5_elvis_lhs = tmp_0;
    var tmp18_tileOffsetY = tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs;
    var tmp6_safe_receiver = tileset.child_6wfw3l_k$('grid');
    var tmp19_grid = tmp6_safe_receiver == null ? null : parseGrid(tmp6_safe_receiver);
    var tmp1_map_0 = children(tileset.children_6wfw3l_k$('terraintypes'), 'terrain');
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var tmp0_iterator_1_2 = tmp1_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(parseTerrain(item_2_3));
      Unit_getInstance();
    }
    var tmp20_terrains = tmp0_mapTo_0_1;
    var tmp2_map_0 = children(tileset.children_6wfw3l_k$('wangsets'), 'wangset');
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp2_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var item_2_3_0 = tmp0_iterator_1_2_0.next_0_k$();
      tmp0_mapTo_0_1_0.add_2bq_k$(parseWangSet(item_2_3_0));
      Unit_getInstance();
    }
    var tmp21_wangsets = tmp0_mapTo_0_1_0;
    var tmp7_safe_receiver = tileset.child_6wfw3l_k$('properties');
    var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : parseProperties(tmp7_safe_receiver);
    var tmp_1;
    if (tmp8_elvis_lhs == null) {
      tmp_1 = emptyMap();
    } else {
      tmp_1 = tmp8_elvis_lhs;
    }
    var tmp22_properties = tmp_1;
    var tmp3_map_0 = tileset.children_6wfw3l_k$('tile');
    var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map_0, 10));
    var tmp0_iterator_1_2_1 = tmp3_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2_1.hasNext_0_k$()) {
      var item_2_3_1 = tmp0_iterator_1_2_1.next_0_k$();
      tmp0_mapTo_0_1_1.add_2bq_k$(parseTile(item_2_3_1));
      Unit_getInstance();
    }
    var tmp23_tiles = tmp0_mapTo_0_1_1;
    return new TileSetData(tmp9_name, firstgid, tmp10_tileWidth, tmp11_tileHeight, tmp12_tileCount, tmp13_spacing, tmp14_margin, tmp15_columns, tmp16_image, tmp17_tileOffsetX, tmp18_tileOffsetY, tmp19_grid, tilesetSource, objectAlignment, tmp20_terrains, tmp21_wangsets, tmp23_tiles, tmp22_properties);
  }
  function parseTileLayer(_this_, infinite) {
    var layer = Tiles_init_$Create$(null, null, null, 7, null);
    parseCommonLayerData(_this_, layer);
    var element = _this_;
    var width = element.int$default_6ncsww_k$('width', 0, 2, null);
    var height = element.int$default_6ncsww_k$('height', 0, 2, null);
    var data = element.child_6wfw3l_k$('data');
    var map_0;
    var encoding;
    var compression;
    if (data == null) {
      map_0 = Bitmap32_init_$Create$(width, height, null, false, 12, null);
      encoding = Encoding_CSV_getInstance();
      compression = Compression_NO_getInstance();
    } else {
      var enc = data.strNull_6wfw3l_k$('encoding');
      var com = data.strNull_6wfw3l_k$('compression');
      var tmp0_find_0 = values_18();
      var tmp$ret$0;
      l$ret$1: do {
        var indexedObject = tmp0_find_0;
        var inductionVariable = 0;
        var last_1 = indexedObject.length;
        while (inductionVariable < last_1) {
          var element_2_2 = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (element_2_2._value_43 == enc) {
            tmp$ret$0 = element_2_2;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      var tmp0_elvis_lhs = tmp$ret$0;
      encoding = tmp0_elvis_lhs == null ? Encoding_XML_getInstance() : tmp0_elvis_lhs;
      var tmp1_find_0 = values_19();
      var tmp$ret$2;
      l$ret$3: do {
        var indexedObject_0 = tmp1_find_0;
        var inductionVariable_0 = 0;
        var last_2 = indexedObject_0.length;
        while (inductionVariable_0 < last_2) {
          var element_2_2_0 = indexedObject_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (element_2_2_0._value_44 == com) {
            tmp$ret$2 = element_2_2_0;
            break l$ret$3;
          } else {
          }
        }
        tmp$ret$2 = null;
      }
       while (false);
      var tmp1_elvis_lhs = tmp$ret$2;
      compression = tmp1_elvis_lhs == null ? Compression_NO_getInstance() : tmp1_elvis_lhs;
      var count_0 = imul(width, height);
      var tiles;
      if (infinite) {
        tiles = new Int32Array(count_0);
        var tmp2_forEach_0 = data.children_6wfw3l_k$('chunk');
        var tmp0_iterator_1 = tmp2_forEach_0.iterator_0_k$();
        while (tmp0_iterator_1.hasNext_0_k$()) {
          var element_2 = tmp0_iterator_1.next_0_k$();
          var offsetX_4 = element_2.int$default_6ncsww_k$('x', 0, 2, null);
          var offsetY_5 = element_2.int$default_6ncsww_k$('y', 0, 2, null);
          var cwidth_6 = element_2.int$default_6ncsww_k$('width', 0, 2, null);
          var cheight_7 = element_2.int$default_6ncsww_k$('height', 0, 2, null);
          var tmp0_forEachIndexed_0_8 = parseTileLayer$encodeGids(element_2, encoding, compression, count_0);
          var index_1_9 = 0;
          var indexedObject_1 = tmp0_forEachIndexed_0_8;
          var inductionVariable_1 = 0;
          var last_3 = indexedObject_1.length;
          while (inductionVariable_1 < last_3) {
            var item_3_11 = indexedObject_1[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp1_4_13 = index_1_9;
            index_1_9 = tmp1_4_13 + 1 | 0;
            var tmp1__anonymous__5_12 = tmp1_4_13;
            var x_6_14 = offsetX_4 + tmp1__anonymous__5_12 % cwidth_6 | 0;
            var y_7_15 = offsetY_5 + (tmp1__anonymous__5_12 / cwidth_6 | 0) | 0;
            tiles[x_6_14 + imul(y_7_15, offsetX_4 + cwidth_6 | 0) | 0] = item_3_11;
          }
        }
      } else {
        tiles = parseTileLayer$encodeGids(data, encoding, compression, count_0);
      }
      var tmp = _RgbaArray___init__impl_(tiles);
      map_0 = Bitmap32_init_$Create$(width, height, tmp, false, 8, null);
    }
    layer._map_7 = map_0;
    layer._encoding_0 = encoding;
    layer._compression_0 = compression;
    return layer;
  }
  function parseObjectLayer(_this_) {
    var layer = Objects_init_$Create$(null, null, null, 7, null);
    parseCommonLayerData(_this_, layer);
    var element = _this_;
    var order = element.str_jg38oy_k$('draworder', 'topdown');
    var tmp = layer;
    tmp._color_8 = colorFromARGB(element.str$default_877n1b_k$('color', null, 2, null), Colors_getInstance().get_xr0bn6_k$('#a0a0a4'));
    var tmp_0 = layer;
    var tmp0_find_0 = values_15();
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = tmp0_find_0;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_2_2._value_30 === order) {
          tmp$ret$0 = element_2_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_elvis_lhs = tmp$ret$0;
    tmp_0._drawOrder = tmp0_elvis_lhs == null ? DrawOrder_TOP_DOWN_getInstance() : tmp0_elvis_lhs;
    var tmp1_iterator = element.children_6wfw3l_k$('object').iterator_0_k$();
    while (tmp1_iterator.hasNext_0_k$()) {
      var obj = tmp1_iterator.next_0_k$();
      var tmp_1 = obj.int$default_6ncsww_k$('id', 0, 2, null);
      var tmp_2 = obj.intNull_6wfw3l_k$('gid');
      var tmp_3 = obj.str$default_877n1b_k$('name', null, 2, null);
      var tmp_4 = obj.str$default_877n1b_k$('type', null, 2, null);
      var tmp_5 = obj.double$default_s8e18k_k$('x', 0.0, 2, null);
      var tmp_6 = obj.double$default_s8e18k_k$('y', 0.0, 2, null);
      var tmp_7 = obj.double$default_s8e18k_k$('width', 0.0, 2, null);
      var tmp_8 = new Rectangle(tmp_5, tmp_6, tmp_7, obj.double$default_s8e18k_k$('height', 0.0, 2, null));
      var tmp_9 = obj.double$default_s8e18k_k$('rotation', 0.0, 2, null);
      var tmp_10 = !(obj.int_8i7b4u_k$('visible', 1) === 0);
      var objInstance = Object_init_$Create$(tmp_1, tmp_2, tmp_3, tmp_4, tmp_8, tmp_9, tmp_10, null, null, 384, null);
      var tmp2_safe_receiver = obj.child_6wfw3l_k$('properties');
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : parseProperties(tmp2_safe_receiver);
      if (tmp3_safe_receiver == null)
        null;
      else {
        objInstance._properties.putAll_nn707j_k$(tmp3_safe_receiver);
        Unit_getInstance();
      }
      Unit_getInstance();
      var ellipse_0 = obj.child_6wfw3l_k$('ellipse');
      var point = obj.child_6wfw3l_k$('point');
      var polygon_1 = obj.child_6wfw3l_k$('polygon');
      var polyline = obj.child_6wfw3l_k$('polyline');
      var text = obj.child_6wfw3l_k$('text');
      var tmp_11;
      if (!(ellipse_0 == null)) {
        tmp_11 = new Ellipse_0(objInstance._bounds_13._width_0, objInstance._bounds_13._height_0);
      } else if (!(point == null)) {
        tmp_11 = PPoint_getInstance();
      } else if (!(polygon_1 == null)) {
        tmp_11 = new Polygon_0(parseObjectLayer$readPoints(polygon_1));
      } else if (!(polyline == null)) {
        tmp_11 = new Polyline_0(parseObjectLayer$readPoints(polyline));
      } else if (!(text == null)) {
        var tmp_12 = text.str_jg38oy_k$('fontfamily', 'sans-serif');
        var tmp_13 = text.int_8i7b4u_k$('pixelsize', 16);
        var tmp_14 = text.int_8i7b4u_k$('wrap', 0) === 1;
        var tmp_15 = colorFromARGB(text.str$default_877n1b_k$('color', null, 2, null), Colors_getInstance()._BLACK_0);
        var tmp_16 = text.int$default_6ncsww_k$('bold', 0, 2, null) === 1;
        var tmp_17 = text.int$default_6ncsww_k$('italic', 0, 2, null) === 1;
        var tmp_18 = text.int$default_6ncsww_k$('underline', 0, 2, null) === 1;
        var tmp_19 = text.int$default_6ncsww_k$('strikeout', 0, 2, null) === 1;
        var tmp_20 = text.int_8i7b4u_k$('kerning', 1) === 1;
        var tmp1_let_0 = text.str_jg38oy_k$('halign', 'left');
        var tmp0_find_0_3 = values_16();
        var tmp$ret$2;
        l$ret$3: do {
          var indexedObject_0 = tmp0_find_0_3;
          var inductionVariable_0 = 0;
          var last_2 = indexedObject_0.length;
          while (inductionVariable_0 < last_2) {
            var element_2_2_5 = indexedObject_0[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (element_2_2_5._value_41 === tmp1_let_0) {
              tmp$ret$2 = element_2_2_5;
              break l$ret$3;
            } else {
            }
          }
          tmp$ret$2 = null;
        }
         while (false);
        var tmp0_elvis_lhs_2 = tmp$ret$2;
        var tmp_21 = tmp0_elvis_lhs_2 == null ? TextHAlignment_LEFT_getInstance() : tmp0_elvis_lhs_2;
        var tmp2_let_0 = text.str_jg38oy_k$('valign', 'top');
        var tmp0_find_0_3_0 = values_17();
        var tmp$ret$4;
        l$ret$5: do {
          var indexedObject_1 = tmp0_find_0_3_0;
          var inductionVariable_1 = 0;
          var last_3 = indexedObject_1.length;
          while (inductionVariable_1 < last_3) {
            var element_2_2_5_0 = indexedObject_1[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            if (element_2_2_5_0._value_42 === tmp2_let_0) {
              tmp$ret$4 = element_2_2_5_0;
              break l$ret$5;
            } else {
            }
          }
          tmp$ret$4 = null;
        }
         while (false);
        var tmp0_elvis_lhs_2_0 = tmp$ret$4;
        tmp_11 = new Text_2(tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp0_elvis_lhs_2_0 == null ? TextVAlignment_TOP_getInstance() : tmp0_elvis_lhs_2_0);
      } else {
        tmp_11 = new Rectangle_1(objInstance._bounds_13._width_0, objInstance._bounds_13._height_0);
      }
      var objectShape = tmp_11;
      objInstance._objectShape = objectShape;
      layer._objects_0.add_2bq_k$(objInstance);
      Unit_getInstance();
    }
    return layer;
  }
  function parseImageLayer(_this_) {
    var layer = Image_init_$Create$(null, 1, null);
    parseCommonLayerData(_this_, layer);
    var tmp = layer;
    var tmp0_safe_receiver = _this_.child_6wfw3l_k$('image');
    tmp._image_0 = tmp0_safe_receiver == null ? null : parseImage(tmp0_safe_receiver);
    return layer;
  }
  function parseGroupLayer(_this_, infinite) {
    var layer = Group_init_$Create$(null, 1, null);
    parseCommonLayerData(_this_, layer);
    var tmp0_fastForEach_0 = _this_._get_allChildrenNoComments__0_k$();
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      var tmp0_subject_4 = tmp1__anonymous__3._nameLC_0;
      switch (tmp0_subject_4) {
        case 'layer':
          var tileLayer_5 = parseTileLayer(tmp1__anonymous__3, infinite);
          var tmp1_this_6 = layer;
          var tmp0_plusAssign_0_7 = tmp1_this_6._layers_2;
          tmp0_plusAssign_0_7.add_2bq_k$(tileLayer_5);
          Unit_getInstance();
          break;
        case 'objectgroup':
          var objectLayer_8 = parseObjectLayer(tmp1__anonymous__3);
          var tmp2_this_9 = layer;
          var tmp1_plusAssign_0_10 = tmp2_this_9._layers_2;
          tmp1_plusAssign_0_10.add_2bq_k$(objectLayer_8);
          Unit_getInstance();
          break;
        case 'imagelayer':
          var imageLayer_11 = parseImageLayer(tmp1__anonymous__3);
          var tmp3_this_12 = layer;
          var tmp2_plusAssign_0_13 = tmp3_this_12._layers_2;
          tmp2_plusAssign_0_13.add_2bq_k$(imageLayer_11);
          Unit_getInstance();
          break;
        case 'group':
          var groupLayer_14 = parseGroupLayer(tmp1__anonymous__3, infinite);
          var tmp4_this_15 = layer;
          var tmp3_plusAssign_0_16 = tmp4_this_15._layers_2;
          tmp3_plusAssign_0_16.add_2bq_k$(groupLayer_14);
          Unit_getInstance();
          break;
      }
    }
    return layer;
  }
  function parseImage(_this_) {
    var image = _this_;
    var width = image.int$default_6ncsww_k$('width', 0, 2, null);
    var height = image.int$default_6ncsww_k$('height', 0, 2, null);
    var trans = image.str$default_877n1b_k$('trans', null, 2, null);
    var tmp;
    if (charSequenceLength(trans) === 0) {
      tmp = null;
    } else {
      if (startsWith$default_1(trans, '#', false, 2, null)) {
        tmp = Colors_getInstance().get_xr0bn6_k$(trans);
      } else {
        {
          tmp = Colors_getInstance().get_xr0bn6_k$('' + '#' + trans);
        }
      }
    }
    var transparent = tmp;
    var source = image.str$default_877n1b_k$('source', null, 2, null);
    var tmp_0;
    if (charSequenceLength(source) > 0) {
      tmp_0 = new External_0(source, width, height, transparent);
    } else {
      {
        var tmp0_elvis_lhs = image.child_6wfw3l_k$('data');
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var data = tmp_1;
        var enc = data.strNull_6wfw3l_k$('encoding');
        var com = data.strNull_6wfw3l_k$('compression');
        var tmp0_find_0 = values_18();
        var tmp$ret$0;
        l$ret$1: do {
          var indexedObject = tmp0_find_0;
          var inductionVariable = 0;
          var last_1 = indexedObject.length;
          while (inductionVariable < last_1) {
            var element_2_2 = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            if (element_2_2._value_43 == enc) {
              tmp$ret$0 = element_2_2;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = null;
        }
         while (false);
        var tmp1_elvis_lhs = tmp$ret$0;
        var encoding = tmp1_elvis_lhs == null ? Encoding_XML_getInstance() : tmp1_elvis_lhs;
        var tmp1_find_0 = values_19();
        var tmp$ret$2;
        l$ret$3: do {
          var indexedObject_0 = tmp1_find_0;
          var inductionVariable_0 = 0;
          var last_2 = indexedObject_0.length;
          while (inductionVariable_0 < last_2) {
            var element_2_2_0 = indexedObject_0[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (element_2_2_0._value_44 == com) {
              tmp$ret$2 = element_2_2_0;
              break l$ret$3;
            } else {
            }
          }
          tmp$ret$2 = null;
        }
         while (false);
        var tmp2_elvis_lhs = tmp$ret$2;
        var compression = tmp2_elvis_lhs == null ? Compression_NO_getInstance() : tmp2_elvis_lhs;
        var bitmap = Bitmap32_init_$Create$(width, height, null, false, 12, null);
        tmp_0 = new Embedded(image.str$default_877n1b_k$('format', null, 2, null), bitmap, encoding, compression, transparent);
      }
    }
    return tmp_0;
  }
  function parseGrid(_this_) {
    var grid = _this_;
    var orientation = grid.str$default_877n1b_k$('orientation', null, 2, null);
    var tmp = grid.int$default_6ncsww_k$('width', 0, 2, null);
    var tmp_0 = grid.int$default_6ncsww_k$('height', 0, 2, null);
    var tmp0_find_0 = values_14();
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = tmp0_find_0;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element_2_2._value_29 === orientation) {
          tmp$ret$0 = element_2_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_elvis_lhs = tmp$ret$0;
    return new Grid(tmp, tmp_0, tmp0_elvis_lhs == null ? Orientation_ORTHOGONAL_getInstance() : tmp0_elvis_lhs);
  }
  function parseTerrain(_this_) {
    var tmp = _this_.str$default_877n1b_k$('name', null, 2, null);
    return new TerrainData(tmp, _this_.int$default_6ncsww_k$('tile', 0, 2, null), parseProperties(_this_));
  }
  function parseWangSet(_this_) {
    var wangset = _this_;
    var tmp = wangset.str$default_877n1b_k$('name', null, 2, null);
    var tmp_0 = wangset.int$default_6ncsww_k$('tile', 0, 2, null);
    var tmp_1 = parseProperties(wangset);
    var tmp0_map_0 = wangset.children_6wfw3l_k$('wangcornercolor');
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      tmp0_mapTo_0_1.add_2bq_k$(parseWangSet$parseWangColor(item_2_3));
      Unit_getInstance();
    }
    var tmp1_map_0 = wangset.children_6wfw3l_k$('wangedgecolor');
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp1_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
      var item_2_3_0 = tmp0_iterator_1_2_0.next_0_k$();
      tmp0_mapTo_0_1_0.add_2bq_k$(parseWangSet$parseWangColor(item_2_3_0));
      Unit_getInstance();
    }
    var tmp2_map_0 = wangset.children_6wfw3l_k$('wangtile');
    var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0, 10));
    var tmp0_iterator_1_2_1 = tmp2_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2_1.hasNext_0_k$()) {
      var item_2_3_1 = tmp0_iterator_1_2_1.next_0_k$();
      tmp0_mapTo_0_1_1.add_2bq_k$(parseWangSet$parseWangTile(item_2_3_1));
      Unit_getInstance();
    }
    return new WangSet(tmp, tmp_0, tmp_1, tmp0_mapTo_0_1, tmp0_mapTo_0_1_0, tmp0_mapTo_0_1_1);
  }
  function parseTile(_this_) {
    var tile = _this_;
    var tmp = tile.int$default_6ncsww_k$('id', 0, 2, null);
    var tmp_0 = tile.strNull_6wfw3l_k$('type');
    var tmp0_takeIf_0 = tile.str$default_877n1b_k$('terrain', null, 2, null);
    var tmp_1;
    if (charSequenceLength(tmp0_takeIf_0) > 0) {
      tmp_1 = tmp0_takeIf_0;
    } else {
      {
        tmp_1 = null;
      }
    }
    var tmp0_safe_receiver = tmp_1;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp_3 = charArrayOf([new Char(44)]);
      tmp_2 = split$default(tmp0_safe_receiver, tmp_3, false, 0, 6, null);
    }
    var tmp1_safe_receiver = tmp_2;
    var tmp_4;
    if (tmp1_safe_receiver == null) {
      tmp_4 = null;
    } else {
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_safe_receiver, 10));
      var tmp0_iterator_1_2 = tmp1_safe_receiver.iterator_0_k$();
      while (tmp0_iterator_1_2.hasNext_0_k$()) {
        var item_2_3 = tmp0_iterator_1_2.next_0_k$();
        tmp0_mapTo_0_1.add_2bq_k$(toIntOrNull(item_2_3));
        Unit_getInstance();
      }
      tmp_4 = tmp0_mapTo_0_1;
    }
    var tmp_5 = tmp_4;
    var tmp_6 = tile.double$default_s8e18k_k$('probability', 0.0, 2, null);
    var tmp2_safe_receiver = tile.child_6wfw3l_k$('image');
    var tmp_7 = tmp2_safe_receiver == null ? null : parseImage(tmp2_safe_receiver);
    var tmp3_safe_receiver = tile.child_6wfw3l_k$('properties');
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : parseProperties(tmp3_safe_receiver);
    var tmp_8;
    if (tmp4_elvis_lhs == null) {
      tmp_8 = emptyMap();
    } else {
      tmp_8 = tmp4_elvis_lhs;
    }
    var tmp_9 = tmp_8;
    var tmp5_safe_receiver = tile.child_6wfw3l_k$('objectgroup');
    var tmp_10 = tmp5_safe_receiver == null ? null : parseObjectLayer(tmp5_safe_receiver);
    var tmp6_safe_receiver = tile.child_6wfw3l_k$('animation');
    var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.children_6wfw3l_k$('frame');
    var tmp_11;
    if (tmp7_safe_receiver == null) {
      tmp_11 = null;
    } else {
      var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp7_safe_receiver, 10));
      var tmp0_iterator_1_2_0 = tmp7_safe_receiver.iterator_0_k$();
      while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
        var item_2_3_0 = tmp0_iterator_1_2_0.next_0_k$();
        tmp0_mapTo_0_1_0.add_2bq_k$(parseTile$parseFrame(item_2_3_0));
        Unit_getInstance();
      }
      tmp_11 = tmp0_mapTo_0_1_0;
    }
    return new TileData(tmp, tmp_0, tmp_5, tmp_6, tmp_7, tmp_9, tmp_10, tmp_11);
  }
  function parseCommonLayerData(_this_, layer) {
    var element = _this_;
    var tmp = layer;
    tmp._id_30 = element.int$default_6ncsww_k$('id', 0, 2, null);
    var tmp_0 = layer;
    tmp_0._name_37 = element.str$default_877n1b_k$('name', null, 2, null);
    layer._opacity = element.double_qmgruq_k$('opacity', 1.0);
    layer._visible_1 = element.int_8i7b4u_k$('visible', 1) === 1;
    layer._locked = element.int_8i7b4u_k$('locked', 0) === 1;
    var tmp_1 = layer;
    var tmp0_safe_receiver = element.strNull_6wfw3l_k$('tintcolor');
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      tmp_2 = colorFromARGB(tmp0_safe_receiver, Colors_getInstance()._WHITE_0);
    }
    tmp_1._tintColor = tmp_2;
    var tmp_3 = layer;
    tmp_3._offsetx = element.double$default_s8e18k_k$('offsetx', 0.0, 2, null);
    var tmp_4 = layer;
    tmp_4._offsety = element.double$default_s8e18k_k$('offsety', 0.0, 2, null);
    var tmp1_safe_receiver = element.child_6wfw3l_k$('properties');
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : parseProperties(tmp1_safe_receiver);
    if (tmp2_safe_receiver == null)
      null;
    else {
      layer._properties_0.putAll_nn707j_k$(tmp2_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function parseTileLayer$encodeGids(_this_, encoding, compression, count_0) {
    var tmp0_subject = encoding;
    var tmp;
    if (tmp0_subject.equals(Encoding_XML_getInstance())) {
      var tmp0_map_0 = _this_.children_6wfw3l_k$('tile');
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
      while (tmp0_iterator_1_2.hasNext_0_k$()) {
        var item_2_3 = tmp0_iterator_1_2.next_0_k$();
        tmp0_mapTo_0_1.add_2bq_k$(numberToInt(item_2_3.double$default_s8e18k_k$('gid', 0.0, 2, null)));
        Unit_getInstance();
      }
      tmp = toIntArray(tmp0_mapTo_0_1);
    } else if (tmp0_subject.equals(Encoding_CSV_getInstance())) {
      var tmp1_replace_0 = _this_._get_text__0_k$();
      var tmp2_replace_0 = spaces;
      var tmp_0 = tmp2_replace_0.replace_abi4bo_k$(tmp1_replace_0, '');
      var tmp_1 = charArrayOf([new Char(44)]);
      var tmp3_map_0 = split$default(tmp_0, tmp_1, false, 0, 6, null);
      var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map_0, 10));
      var tmp0_iterator_1_2_0 = tmp3_map_0.iterator_0_k$();
      while (tmp0_iterator_1_2_0.hasNext_0_k$()) {
        var item_2_3_0 = tmp0_iterator_1_2_0.next_0_k$();
        tmp0_mapTo_0_1_0.add_2bq_k$(numberToInt(toDouble(item_2_3_0)));
        Unit_getInstance();
      }
      tmp = toIntArray(tmp0_mapTo_0_1_0);
    } else if (tmp0_subject.equals(Encoding_BASE64_getInstance())) {
      var tmp4_trim_0 = _this_._get_text__0_k$();
      var tmp_2 = toString_1(trim_0(isCharSequence(tmp4_trim_0) ? tmp4_trim_0 : THROW_CCE()));
      var rawContent = fromBase64$default(tmp_2, false, 1, null);
      var tmp1_subject = compression;
      var tmp_3;
      if (tmp1_subject.equals(Compression_NO_getInstance())) {
        tmp_3 = rawContent;
      } else if (tmp1_subject.equals(Compression_GZIP_getInstance())) {
        var tmp_4 = Companion_getInstance_102();
        tmp_3 = uncompress$default(rawContent, tmp_4, 0, 2, null);
      } else if (tmp1_subject.equals(Compression_ZLIB_getInstance())) {
        var tmp_5 = Companion_getInstance_103();
        tmp_3 = uncompress$default(rawContent, tmp_5, 0, 2, null);
      } else {
        invalidOp('' + "Unknown compression '" + compression + "'");
      }
      var content = tmp_3;
      tmp = readIntArrayLE(content, 0, count_0);
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function parseObjectLayer$readPoints(_this_) {
    var tmp0_split_0 = _this_.str$default_877n1b_k$('points', null, 2, null);
    var tmp1_split_0 = spaces;
    var tmp2_map_0 = tmp1_split_0.split_w2qdfo_k$(tmp0_split_0, 0);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0, 10));
    var tmp0_iterator_1_2 = tmp2_map_0.iterator_0_k$();
    while (tmp0_iterator_1_2.hasNext_0_k$()) {
      var item_2_3 = tmp0_iterator_1_2.next_0_k$();
      var tmp = charArrayOf([new Char(44)]);
      var tmp0_map_0_6 = split$default(item_2_3, tmp, false, 0, 6, null);
      var tmp0_mapTo_0_1_7 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_6, 10));
      var tmp0_iterator_1_2_8 = tmp0_map_0_6.iterator_0_k$();
      while (tmp0_iterator_1_2_8.hasNext_0_k$()) {
        var item_2_3_9 = tmp0_iterator_1_2_8.next_0_k$();
        var tmp0_elvis_lhs_5_10 = toDoubleOrNull(toString_1(trim_0(isCharSequence(item_2_3_9) ? item_2_3_9 : THROW_CCE())));
        tmp0_mapTo_0_1_7.add_2bq_k$(tmp0_elvis_lhs_5_10 == null ? 0.0 : tmp0_elvis_lhs_5_10);
        Unit_getInstance();
      }
      var parts_5 = tmp0_mapTo_0_1_7;
      tmp0_mapTo_0_1.add_2bq_k$(new Point(parts_5.get_ha5a7z_k$(0), parts_5.get_ha5a7z_k$(1)));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  }
  function parseWangSet$parseWangColor(_this_) {
    var wangcolor = _this_;
    var tmp = wangcolor.str$default_877n1b_k$('name', null, 2, null);
    var tmp_0 = Colors_getInstance();
    var tmp_1 = tmp_0.get_xr0bn6_k$(wangcolor.str$default_877n1b_k$('color', null, 2, null));
    var tmp_2 = wangcolor.int$default_6ncsww_k$('tile', 0, 2, null);
    return new WangColor(tmp, tmp_1, tmp_2, wangcolor.double$default_s8e18k_k$('probability', 0.0, 2, null));
  }
  function parseWangSet$parseWangTile(_this_) {
    var wangtile = _this_;
    var hflip = wangtile.str$default_877n1b_k$('hflip', null, 2, null);
    var vflip = wangtile.str$default_877n1b_k$('vflip', null, 2, null);
    var dflip = wangtile.str$default_877n1b_k$('dflip', null, 2, null);
    var tmp = wangtile.int$default_6ncsww_k$('tileid', 0, 2, null);
    return new WangTile(tmp, wangtile.int$default_6ncsww_k$('wangid', 0, 2, null), hflip === '1' ? true : hflip === 'true', vflip === '1' ? true : vflip === 'true', dflip === '1' ? true : dflip === 'true');
  }
  function parseTile$parseFrame(_this_) {
    var tmp = _this_.int$default_6ncsww_k$('tileid', 0, 2, null);
    return new AnimationFrameData(tmp, _this_.int$default_6ncsww_k$('duration', 0, 2, null));
  }
  function _no_name_provided__521($vectorPaths, $collisionType, $tile) {
    this._$vectorPaths = $vectorPaths;
    this._$collisionType = $collisionType;
    this._$tile = $tile;
  }
  _no_name_provided__521.prototype.hitTestAny_j5t4vg_k$ = function (x, y, direction) {
    if (!this._$vectorPaths.isEmpty_0_k$()) {
      var array_1 = this._$vectorPaths._array_4;
      var n_2 = 0;
      while (n_2 < array_1.length) {
        var tmp0_4 = n_2;
        n_2 = tmp0_4 + 1 | 0;
        var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
        var tmp0__anonymous__5 = tmp0_unsafeCast_0_3;
        if (tmp0__anonymous__5.hitTestAny_j5t4vg_k$(x, y, direction))
          return true;
      }
    } else {
    }
    return HitTestDirectionFlags__matches_impl(this._$collisionType, direction);
  };
  _no_name_provided__521.prototype.toString = function () {
    return '' + 'HitTestable[id=' + this._$tile._id_31 + '](' + this._$vectorPaths + ')';
  };
  _no_name_provided__521.$metadata$ = {
    kind: 'class',
    interfaces: [TileShapeInfo]
  };
  function $readTiledMapCOROUTINE$25(_this_, hasTransparentColor, transparentColor, createBorder, atlas, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__191 = _this_;
    this._hasTransparentColor = hasTransparentColor;
    this._transparentColor = transparentColor;
    this._createBorder = createBorder;
    this._atlas_1 = atlas;
  }
  $readTiledMapCOROUTINE$25.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._folder0 = this.__this__191._get_parent__0_k$().jail_0_k$();
            this._state_1 = 1;
            suspendResult = readTiledMapData(this.__this__191, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._data1 = suspendResult;
            var tmp_0 = this;
            tmp_0._tiledTilesets2 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1._tmp0_fastForEach_03_0 = this._data1._tilesets_0;
            this._n_14_0 = 0;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!(this._n_14_0 < this._tmp0_fastForEach_03_0._get_size__0_k$())) {
              this._state_1 = 4;
              continue $sm;
            }
            var tmp_2 = this;
            var tmp0_2 = this._n_14_0;
            this._n_14_0 = tmp0_2 + 1 | 0;
            tmp_2._tmp1__anonymous__35 = this._tmp0_fastForEach_03_0.get_ha5a7z_k$(tmp0_2);
            this._state_1 = 3;
            suspendResult = toTiledSet(this._tmp1__anonymous__35, this._folder0, this._hasTransparentColor, this._transparentColor, this._createBorder, this._atlas_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var tmp0_plusAssign_0_4 = suspendResult;
            this._tiledTilesets2.add_2bq_k$(tmp0_plusAssign_0_4);
            Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 4:
            return new TiledMap(this._data1, this._tiledTilesets2);
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readTiledMapCOROUTINE$25.$metadata$ = {
    simpleName: '$readTiledMapCOROUTINE$25',
    kind: 'class',
    interfaces: []
  };
  function $readTiledMapDataCOROUTINE$26(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__192 = _this_;
  }
  $readTiledMapDataCOROUTINE$26.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._file0_3 = this.__this__192;
            this._folder1 = this.__this__192._get_parent__0_k$().jail_0_k$();
            var tmp_0 = this;
            tmp_0._tiledMap2 = TiledMapData_init_$Create$(null, null, 0, 0, 0, 0, 0, null, null, null, null, 0, 0, false, null, null, null, null, 262143, null);
            this._state_1 = 1;
            suspendResult = readXml(this._file0_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._mapXml3 = suspendResult;
            if (!(this._mapXml3._nameLC_0 === 'map')) {
              throw IllegalStateException_init_$Create$_0('Not a TiledMap XML TMX file starting with <map>');
            }
            this._orientation4 = this._mapXml3.getString_6wfw3l_k$('orientation');
            var tmp_1 = this._tiledMap2;
            var tmp0_subject = this._orientation4;
            var tmp_2;
            switch (tmp0_subject) {
              case 'orthogonal':
                tmp_2 = Orientation_ORTHOGONAL_getInstance_0();
                break;
              case 'staggered':
                tmp_2 = Orientation_STAGGERED_getInstance();
                break;
              default:unsupported_1('' + 'Orientation "' + this._orientation4 + '" is not supported');
                break;
            }

            tmp_1._orientation_0 = tmp_2;
            this._renderOrder5 = this._mapXml3.getString_6wfw3l_k$('renderorder');
            var tmp_3 = this._tiledMap2;
            var tmp1_subject = this._renderOrder5;
            switch (tmp1_subject) {
              case 'right-down':
                tmp_3._renderOrder = RenderOrder_RIGHT_DOWN_getInstance();
                break;
              case 'right-up':
                tmp_3._renderOrder = RenderOrder_RIGHT_UP_getInstance();
                break;
              case 'left-down':
                tmp_3._renderOrder = RenderOrder_LEFT_DOWN_getInstance();
                break;
              case 'left-up':
                tmp_3._renderOrder = RenderOrder_LEFT_UP_getInstance();
                break;
              default:tmp_3._renderOrder = RenderOrder_RIGHT_DOWN_getInstance();
                break;
            }

            var tmp_4 = this._tiledMap2;
            var tmp2_elvis_lhs = this._mapXml3.getInt_6wfw3l_k$('compressionlevel');
            tmp_4._compressionLevel = tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
            var tmp_5 = this._tiledMap2;
            var tmp3_elvis_lhs = this._mapXml3.getInt_6wfw3l_k$('width');
            tmp_5._width_25 = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
            var tmp_6 = this._tiledMap2;
            var tmp4_elvis_lhs = this._mapXml3.getInt_6wfw3l_k$('height');
            tmp_6._height_26 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
            var tmp_7 = this._tiledMap2;
            var tmp5_elvis_lhs = this._mapXml3.getInt_6wfw3l_k$('tilewidth');
            tmp_7._tilewidth = tmp5_elvis_lhs == null ? 32 : tmp5_elvis_lhs;
            var tmp_8 = this._tiledMap2;
            var tmp6_elvis_lhs = this._mapXml3.getInt_6wfw3l_k$('tileheight');
            tmp_8._tileheight = tmp6_elvis_lhs == null ? 32 : tmp6_elvis_lhs;
            this._tiledMap2._hexSideLength = this._mapXml3.getInt_6wfw3l_k$('hexsidelength');
            this._staggerAxis6 = this._mapXml3.getString_6wfw3l_k$('staggeraxis');
            var tmp_9 = this._tiledMap2;
            var tmp7_subject = this._staggerAxis6;
            switch (tmp7_subject) {
              case 'x':
                tmp_9._staggerAxis = StaggerAxis_X_getInstance();
                break;
              case 'y':
                tmp_9._staggerAxis = StaggerAxis_Y_getInstance();
                break;
              default:tmp_9._staggerAxis = null;
                break;
            }

            this._staggerIndex7 = this._mapXml3.getString_6wfw3l_k$('staggerindex');
            var tmp_10 = this._tiledMap2;
            var tmp8_subject = this._staggerIndex7;
            switch (tmp8_subject) {
              case 'even':
                tmp_10._staggerIndex = StaggerIndex_EVEN_getInstance();
                break;
              case 'odd':
                tmp_10._staggerIndex = StaggerIndex_ODD_getInstance();
                break;
              default:tmp_10._staggerIndex = null;
                break;
            }

            var tmp_11 = this._tiledMap2;
            var tmp9_safe_receiver = this._mapXml3.getString_6wfw3l_k$('backgroundcolor');
            var tmp_12;
            if (tmp9_safe_receiver == null) {
              tmp_12 = null;
            } else {
              tmp_12 = colorFromARGB(tmp9_safe_receiver, Colors_getInstance()._TRANSPARENT_BLACK);
            }

            tmp_11._backgroundColor = tmp_12;
            this._nextLayerId8 = this._mapXml3.getInt_6wfw3l_k$('nextlayerid');
            this._nextObjectId9 = this._mapXml3.getInt_6wfw3l_k$('nextobjectid');
            this._tiledMap2._infinite = this._mapXml3.getInt_6wfw3l_k$('infinite') === 1;
            var tmp10_safe_receiver = this._mapXml3.child_6wfw3l_k$('properties');
            var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : parseProperties(tmp10_safe_receiver);
            if (tmp11_safe_receiver == null)
              null;
            else {
              this._tiledMap2._properties_1.putAll_nn707j_k$(tmp11_safe_receiver);
              Unit_getInstance();
            }

            Unit_getInstance();
            var tmp_13 = this;
            tmp_13._tmp0_trace_010 = tilemapLog;
            var tmp_14 = this;
            tmp_14._tmp0_log_0_111 = Level_TRACE_getInstance();
            if (this._tmp0_trace_010.isEnabled_5xis2i_k$(this._tmp0_log_0_111)) {
              this._tmp0_trace_010.actualLog_sbdqh6_k$(this._tmp0_log_0_111, '' + 'tilemap: width=' + this._tiledMap2._width_25 + ', height=' + this._tiledMap2._height_26 + ', tilewidth=' + this._tiledMap2._tilewidth + ', tileheight=' + this._tiledMap2._tileheight);
            }
            var tmp_15 = this;
            tmp_15._tmp1_trace_012 = tilemapLog;
            var tmp_16 = this;
            tmp_16._tmp0_log_0_113 = Level_TRACE_getInstance();
            if (this._tmp1_trace_012.isEnabled_5xis2i_k$(this._tmp0_log_0_113)) {
              this._tmp1_trace_012.actualLog_sbdqh6_k$(this._tmp0_log_0_113, '' + 'tilemap: ' + this._tiledMap2);
            }
            this._elements14 = this._mapXml3._get_allChildrenNoComments__0_k$();
            var tmp_17 = this;
            tmp_17._tmp2_trace_015 = tilemapLog;
            var tmp_18 = this;
            tmp_18._tmp0_log_0_116 = Level_TRACE_getInstance();
            if (this._tmp2_trace_015.isEnabled_5xis2i_k$(this._tmp0_log_0_116)) {
              this._tmp2_trace_015.actualLog_sbdqh6_k$(this._tmp0_log_0_116, '' + 'tilemap: elements=' + this._elements14._get_size__0_k$());
            }
            var tmp_19 = this;
            tmp_19._tmp3_trace_017 = tilemapLog;
            var tmp_20 = this;
            tmp_20._tmp0_log_0_118 = Level_TRACE_getInstance();
            if (this._tmp3_trace_017.isEnabled_5xis2i_k$(this._tmp0_log_0_118)) {
              this._tmp3_trace_017.actualLog_sbdqh6_k$(this._tmp0_log_0_118, '' + 'tilemap: elements=' + this._elements14);
            }
            this._n_119 = 0;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!(this._n_119 < this._elements14._get_size__0_k$())) {
              this._state_1 = 6;
              continue $sm;
            }
            var tmp_21 = this;
            var tmp0_2 = this._n_119;
            this._n_119 = tmp0_2 + 1 | 0;
            tmp_21._tmp4__anonymous__320 = this._elements14.get_ha5a7z_k$(tmp0_2);
            this._tmp0_subject_421 = this._tmp4__anonymous__320._nameLC_0;
            if (this._tmp0_subject_421 === 'tileset') {
              var tmp_22 = this;
              tmp_22._tmp0_trace_0_522 = tilemapLog;
              var tmp_23 = this;
              tmp_23._tmp0_log_0_1_623 = Level_TRACE_getInstance();
              if (this._tmp0_trace_0_522.isEnabled_5xis2i_k$(this._tmp0_log_0_1_623)) {
                this._tmp0_trace_0_522.actualLog_sbdqh6_k$(this._tmp0_log_0_1_623, 'tileset');
              }this._firstgid_724 = this._tmp4__anonymous__320.int_8i7b4u_k$('firstgid', 1);
              this._sourcePath_825 = this._tmp4__anonymous__320.getString_6wfw3l_k$('source');
              if (!(this._sourcePath_825 == null)) {
                this._state_1 = 3;
                suspendResult = readXml(this._folder1.get_6wfw3l_k$(this._sourcePath_825), this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._WHEN_RESULT26 = this._tmp4__anonymous__320;
                this._state_1 = 4;
                continue $sm;
              }
            } else {
              if (this._tmp0_subject_421 === 'layer') {
                var layer_13 = parseTileLayer(this._tmp4__anonymous__320, this._tiledMap2._infinite);
                var tmp2_this_14 = this._tiledMap2;
                var tmp3_plusAssign_0_15 = tmp2_this_14._allLayers;
                tmp3_plusAssign_0_15.add_2bq_k$(layer_13);
                Unit_getInstance();
                this._state_1 = 5;
                continue $sm;
              } else {
                if (this._tmp0_subject_421 === 'objectgroup') {
                  var layer_16 = parseObjectLayer(this._tmp4__anonymous__320);
                  var tmp3_this_17 = this._tiledMap2;
                  var tmp4_plusAssign_0_18 = tmp3_this_17._allLayers;
                  tmp4_plusAssign_0_18.add_2bq_k$(layer_16);
                  Unit_getInstance();
                  this._state_1 = 5;
                  continue $sm;
                } else {
                  if (this._tmp0_subject_421 === 'imagelayer') {
                    var layer_19 = parseImageLayer(this._tmp4__anonymous__320);
                    var tmp4_this_20 = this._tiledMap2;
                    var tmp5_plusAssign_0_21 = tmp4_this_20._allLayers;
                    tmp5_plusAssign_0_21.add_2bq_k$(layer_19);
                    Unit_getInstance();
                    this._state_1 = 5;
                    continue $sm;
                  } else {
                    if (this._tmp0_subject_421 === 'group') {
                      var layer_22 = parseGroupLayer(this._tmp4__anonymous__320, this._tiledMap2._infinite);
                      var tmp5_this_23 = this._tiledMap2;
                      var tmp6_plusAssign_0_24 = tmp5_this_23._allLayers;
                      tmp6_plusAssign_0_24.add_2bq_k$(layer_22);
                      Unit_getInstance();
                      this._state_1 = 5;
                      continue $sm;
                    } else {
                      if (this._tmp0_subject_421 === 'editorsettings') {
                        var chunkSize_25 = this._tmp4__anonymous__320.child_6wfw3l_k$('chunksize');
                        var tmp_24 = this._tiledMap2;
                        var tmp6_safe_receiver_27 = chunkSize_25;
                        var tmp7_elvis_lhs_26 = tmp6_safe_receiver_27 == null ? null : tmp6_safe_receiver_27.int_8i7b4u_k$('width', 16);
                        var tmp_25 = tmp7_elvis_lhs_26 == null ? 16 : tmp7_elvis_lhs_26;
                        var tmp8_safe_receiver_29 = chunkSize_25;
                        var tmp9_elvis_lhs_28 = tmp8_safe_receiver_29 == null ? null : tmp8_safe_receiver_29.int_8i7b4u_k$('height', 16);
                        tmp_24._editorSettings = new EditorSettings(tmp_25, tmp9_elvis_lhs_28 == null ? 16 : tmp9_elvis_lhs_28);
                        this._state_1 = 5;
                        continue $sm;
                      } else {
                        this._state_1 = 5;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

            break;
          case 3:
            this._WHEN_RESULT26 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            var tileset_9 = this._WHEN_RESULT26;
            var tmp1_this_10 = this._tiledMap2;
            var tmp1_plusAssign_0_11 = tmp1_this_10._tilesets_0;
            var tmp2_plusAssign_0_12 = parseTileSetData(tileset_9, this._firstgid_724, this._sourcePath_825);
            tmp1_plusAssign_0_11.add_2bq_k$(tmp2_plusAssign_0_12);
            Unit_getInstance();
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._state_1 = 2;
            continue $sm;
          case 6:
            var tmp_26 = this._tiledMap2;
            var tmp12_elvis_lhs = this._nextLayerId8;
            var tmp_27;
            if (tmp12_elvis_lhs == null) {
              var maxLayerId_2 = 0;
              var tmp0_iterator_3 = this._tiledMap2._allLayers.iterator_0_k$();
              while (tmp0_iterator_3.hasNext_0_k$()) {
                var layer_4 = tmp0_iterator_3.next_0_k$();
                if (layer_4._id_30 > maxLayerId_2)
                  maxLayerId_2 = layer_4._id_30;
              }
              tmp_27 = maxLayerId_2 + 1 | 0;
            } else {
              tmp_27 = tmp12_elvis_lhs;
            }

            tmp_26._nextLayerId = tmp_27;
            var tmp_28 = this._tiledMap2;
            var tmp13_elvis_lhs = this._nextObjectId9;
            var tmp_29;
            if (tmp13_elvis_lhs == null) {
              var maxObjectId_2 = 0;
              var tmp0__get_objects__0_1_4 = this._tiledMap2._allLayers;
              var tmp0_filterIsInstanceTo_0_1_2_5 = ArrayList_init_$Create$();
              var tmp0_iterator_1_2_3_6 = tmp0__get_objects__0_1_4.iterator_0_k$();
              while (tmp0_iterator_1_2_3_6.hasNext_0_k$()) {
                var element_2_3_4_7 = tmp0_iterator_1_2_3_6.next_0_k$();
                if (element_2_3_4_7 instanceof Objects) {
                  tmp0_filterIsInstanceTo_0_1_2_5.add_2bq_k$(element_2_3_4_7);
                  Unit_getInstance();
                } else {
                }
              }
              var tmp0_iterator_3_0 = tmp0_filterIsInstanceTo_0_1_2_5.iterator_0_k$();
              while (tmp0_iterator_3_0.hasNext_0_k$()) {
                var objects_8 = tmp0_iterator_3_0.next_0_k$();
                var tmp1_iterator_9 = objects_8._objects_0.iterator_0_k$();
                while (tmp1_iterator_9.hasNext_0_k$()) {
                  var obj_10 = tmp1_iterator_9.next_0_k$();
                  if (obj_10._id_29 > maxObjectId_2)
                    maxObjectId_2 = obj_10._id_29;
                }
              }
              tmp_29 = maxObjectId_2 + 1 | 0;
            } else {
              tmp_29 = tmp13_elvis_lhs;
            }

            tmp_28._nextObjectId = tmp_29;
            return this._tiledMap2;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readTiledMapDataCOROUTINE$26.$metadata$ = {
    simpleName: '$readTiledMapDataCOROUTINE$26',
    kind: 'class',
    interfaces: []
  };
  function $toTiledSetCOROUTINE$27(_this_, folder, hasTransparentColor, transparentColor, createBorder, atlas, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__193 = _this_;
    this._folder = folder;
    this._hasTransparentColor_0 = hasTransparentColor;
    this._transparentColor_0 = transparentColor;
    this._createBorder_0 = createBorder;
    this._atlas_2 = atlas;
  }
  $toTiledSetCOROUTINE$27.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            var tmp_1;
            if (!(this._atlas_2 == null)) {
              tmp_1 = this._atlas_2;
            } else if (this._createBorder_0 > 0) {
              var tmp_2 = clamp_2(this._createBorder_0, 1, 4);
              tmp_1 = MutableAtlas_init_$Create$(2048, 0, tmp_2, false, false, null, 58, null);
            } else {
              tmp_1 = null;
            }

            tmp_0._atlas0 = tmp_1;
            this._tileset1 = this.__this__193;
            this._exceptionState = 3;
            this._tmp0_subject3 = this._tileset1._image_1;
            var tmp_3 = this._tmp0_subject3;
            if (tmp_3 instanceof Embedded) {
              var tmp_4 = this;
              throw NotImplementedError_init_$Create$(null, 1, null);
            } else {
              {
                var tmp_5 = this._tmp0_subject3;
                if (tmp_5 instanceof External_0) {
                  this._state_1 = 1;
                  var tmp_6 = this._folder.get_6wfw3l_k$(this._tileset1._image_1._source_0);
                  suspendResult = readBitmapOptimized$default(tmp_6, null, false, 3, null, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    if (this._tmp0_subject3 == null) {
                      var tmp_7 = this;
                      tmp_7._WHEN_RESULT4_0 = Bitmap32_init_$Create$(0, 0, null, false, 12, null);
                      this._state_1 = 2;
                      continue $sm;
                    } else {
                      var tmp_8 = this;
                      noWhenBranchMatchedException();
                    }
                    Unit_getInstance();
                  }
                }
                Unit_getInstance();
              }
            }

            break;
          case 1:
            var tmp0_let_0 = suspendResult;
            var tmp_9 = this;
            tmp_9._WHEN_RESULT4_0 = !(this._atlas0 == null) ? tmp0_let_0.toBMP32IfRequired_0_k$() : tmp0_let_0;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._TRY_RESULT2_0 = this._WHEN_RESULT4_0;
            this._exceptionState = 4;
            this._state_1 = 5;
            continue $sm;
          case 3:
            this._exceptionState = 4;
            var tmp_10 = this._exception_0;
            if (tmp_10 instanceof Error) {
              var e = this._exception_0;
              var tmp_11 = this;
              printStackTrace_0(e);
              var tmp_12 = this._tileset1._get_width__0_k$();
              var tmp_13 = this._tileset1._get_height__0_k$();
              tmp_11._TRY_RESULT2_0 = Bitmap32_init_$Create$(tmp_12, tmp_13, null, false, 12, null);
              this._state_1 = 5;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            throw this._exception_0;
          case 5:
            this._exceptionState = 4;
            var bmp = this._TRY_RESULT2_0;
            if (this._hasTransparentColor_0) {
              bmp = bmp.toBMP32_0_k$();
              var inductionVariable = 0;
              var last_1 = bmp._get_area__0_k$();
              if (inductionVariable < last_1)
                do {
                  var n = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  if (equals_1(new RGBA(RgbaArray__get_impl(bmp._data_25, n)), new RGBA(this._transparentColor_0)))
                    RgbaArray__set_impl(bmp._data_25, n, Colors_getInstance()._TRANSPARENT_BLACK);
                }
                 while (inductionVariable < last_1);
            }
            var collisionsMap = IntMap_init_$Create$(0, 0.0, 3, null);
            var tmp1_fastForEach_0 = this._tileset1._tiles;
            var n_1 = 0;
            while (n_1 < tmp1_fastForEach_0._get_size__0_k$()) {
              var tmp0_2 = n_1;
              n_1 = tmp0_2 + 1 | 0;
              var tmp2__anonymous__3 = tmp1_fastForEach_0.get_ha5a7z_k$(tmp0_2);
              var collisionType_4 = Companion_getInstance_208().fromString_n6wkrt_k$(tmp2__anonymous__3._type_24, Companion_getInstance_208()._NONE_1);
              var vectorPaths_5 = fastArrayListOf([]);
              if (!(tmp2__anonymous__3._objectGroup == null)) {
                var tmp0_fastForEach_0_6 = tmp2__anonymous__3._objectGroup._objects_0;
                var array_1_7 = tmp0_fastForEach_0_6._array_4;
                var n_2_8 = 0;
                while (n_2_8 < array_1_7.length) {
                  var tmp0_4_11 = n_2_8;
                  n_2_8 = tmp0_4_11 + 1 | 0;
                  var tmp0_unsafeCast_0_3_10 = array_1_7[tmp0_4_11];
                  var tmp1__anonymous__5_9 = tmp0_unsafeCast_0_3_10;
                  var tmp_14 = Companion_getInstance_208();
                  var tmp_15 = tmp1__anonymous__5_9._type_23;
                  vectorPaths_5.add_2bq_k$(new TileShapeInfoImpl(tmp_14.fromString$default_8mwcsm_k$(tmp_15, null, 2, null), tmp1__anonymous__5_9.toShape2dNoTransformed_0_k$(), tmp1__anonymous__5_9.getTransform_0_k$()));
                  Unit_getInstance();
                }
              }collisionsMap.set_bq5tp3_k$(tmp2__anonymous__3._id_31, new _no_name_provided__521(vectorPaths_5, collisionType_4, tmp2__anonymous__3));
              Unit_getInstance();
            }

            var tmp_16;
            if (!(this._atlas0 == null)) {
              var tmp_17 = Companion_getInstance_223();
              var tmp_18 = bmp;
              var tileSet = tmp_17.invoke_6ggabi_k$(slice$default(tmp_18, null, null, 3, null), this._tileset1._tileWidth, this._tileset1._tileHeight, this._tileset1._columns, this._tileset1._tileCount, collisionsMap);
              var map_0 = IntMap_init_$Create$(0, 0.0, 3, null);
              var tmp3_fastForEachWithIndex_0 = tileSet._get_infos__0_k$();
              var n_1_0 = 0;
              while (n_1_0 < tmp3_fastForEachWithIndex_0.length) {
                var tmp4__anonymous__3 = n_1_0;
                var tmp5__anonymous__3 = tmp3_fastForEachWithIndex_0[n_1_0];
                if (!(tmp5__anonymous__3 == null)) {
                  var tile_4 = this._tileset1._tilesById.get_ha5a7z_k$(tmp5__anonymous__3._id_34);
                  var tmp_19 = this._atlas0.add$default_em5mj4_k$(tmp5__anonymous__3._slice_1, Unit_getInstance(), null, 4, null)._slice;
                  var tmp0_safe_receiver_7 = tile_4;
                  var tmp1_elvis_lhs_6 = tmp0_safe_receiver_7 == null ? null : tmp0_safe_receiver_7._frames_1;
                  var tmp0_map_0_5 = tmp1_elvis_lhs_6 == null ? emptyList() : tmp1_elvis_lhs_6;
                  var tmp0_mapTo_0_1_8 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_5, 10));
                  var tmp0_iterator_1_2_9 = tmp0_map_0_5.iterator_0_k$();
                  while (tmp0_iterator_1_2_9.hasNext_0_k$()) {
                    var item_2_3_10 = tmp0_iterator_1_2_9.next_0_k$();
                    var tmp0__get_milliseconds__0_5_11 = item_2_3_10._duration_1;
                    tmp0_mapTo_0_1_8.add_2bq_k$(new TileSetAnimationFrame(item_2_3_10._tileId_2, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp0__get_milliseconds__0_5_11)));
                    Unit_getInstance();
                  }
                  map_0.set_bq5tp3_k$(tmp4__anonymous__3, tmp5__anonymous__3.copy$default_ohfk3m_k$(0, tmp_19, tmp0_mapTo_0_1_8, 1, null));
                  Unit_getInstance();
                }var tmp0_2_0 = n_1_0;
                n_1_0 = tmp0_2_0 + 1 | 0;
                Unit_getInstance();
              }
              tmp_16 = new TileSet(map_0, this._tileset1._tileWidth, this._tileset1._tileHeight, collisionsMap);
            } else {
              var tmp_20 = Companion_getInstance_223();
              var tmp_21 = bmp;
              tmp_16 = tmp_20.invoke_6ggabi_k$(slice$default(tmp_21, null, null, 3, null), this._tileset1._tileWidth, this._tileset1._tileHeight, this._tileset1._columns, this._tileset1._tileCount, collisionsMap);
            }

            var ptileset = tmp_16;
            var tiledTileset = new TiledTileset(ptileset, this._tileset1, this._tileset1._firstgid_0);
            return tiledTileset;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $toTiledSetCOROUTINE$27.$metadata$ = {
    simpleName: '$toTiledSetCOROUTINE$27',
    kind: 'class',
    interfaces: []
  };
  function TiledMapView_init_$Init$(tiledMap, showShapes, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      showShapes = true;
    if (!(($mask0 & 4) === 0))
      smoothing = true;
    TiledMapView.call($this, tiledMap, showShapes, smoothing);
    return $this;
  }
  function TiledMapView_init_$Create$(tiledMap, showShapes, smoothing, $mask0, $marker) {
    return TiledMapView_init_$Init$(tiledMap, showShapes, smoothing, $mask0, $marker, Object.create(TiledMapView.prototype));
  }
  function TiledMapView(tiledMap, showShapes, smoothing) {
    Container.call(this);
    this._tiledMap = tiledMap;
    this._tileset_0 = toTileSet(this._tiledMap._tilesets);
    var tmp0_fastForEachWithIndex_0 = this._tiledMap._get_allLayers__0_k$();
    var n_1 = 0;
    while (n_1 < tmp0_fastForEachWithIndex_0._get_size__0_k$()) {
      var tmp1__anonymous__3 = n_1;
      var tmp2__anonymous__3 = tmp0_fastForEachWithIndex_0.get_ha5a7z_k$(n_1);
      var tmp0_subject_5 = tmp2__anonymous__3;
      var tmp;
      if (tmp0_subject_5 instanceof Tiles) {
        var tmp2_tileMap_0_6 = tmp2__anonymous__3._map_7;
        var tmp3_tileMap_0_7 = this._tileset_0;
        var tmp4_tileMap_0_8 = this._tiledMap._data_56._orientation_0;
        var tmp5_tileMap_0_9 = this._tiledMap._data_56._staggerAxis;
        var tmp6_tileMap_0_10 = this._tiledMap._data_56._staggerIndex;
        var tmp7_tileMap_0_11 = Companion_getInstance_38().invoke_9i800l_k$(this._tiledMap._get_tilewidth__0_k$(), this._tiledMap._get_tileheight__0_k$());
        var tmp8_tileMap_0_12 = Repeat_NONE_getInstance();
        var tmp1_addTo_0_13 = repeat_0(new TileMap(toIntArray2(tmp2_tileMap_0_6), tmp3_tileMap_0_7, smoothing, tmp4_tileMap_0_8, tmp5_tileMap_0_9, tmp6_tileMap_0_10, tmp7_tileMap_0_11), tmp8_tileMap_0_12, tmp8_tileMap_0_12);
        var tmp0_apply_0_14 = addTo(tmp1_addTo_0_13, this);
        Unit_getInstance();
        tmp = tmp0_apply_0_14;
      } else {
        if (tmp0_subject_5 instanceof Objects) {
          var tmp10_addTo_0_15 = new Container();
          var tmp9_apply_0_16 = addTo(tmp10_addTo_0_15, this);
          var tmp0_iterator_3_17 = tmp2__anonymous__3._objects_0.iterator_0_k$();
          while (tmp0_iterator_3_17.hasNext_0_k$()) {
            var obj_4_18 = tmp0_iterator_3_17.next_0_k$();
            var bounds_5_19 = obj_4_18._bounds_13;
            var gid_6_20 = obj_4_18._gid;
            var shouldShow_7_21 = showShapes;
            var type_9_23 = obj_4_18._objectShape;
            var tmp_0;
            if (type_9_23 instanceof PPoint) {
              var tmp2_solidRect_0_10_24 = Colors_getInstance()._WHITE_0;
              var tmp1_addTo_0_11_25 = new SolidRect(1.0, 1.0, tmp2_solidRect_0_10_24);
              var tmp0_apply_0_12_26 = addTo(tmp1_addTo_0_11_25, tmp9_apply_0_16);
              Unit_getInstance();
              tmp_0 = tmp0_apply_0_12_26;
            } else {
              if (type_9_23 instanceof Ellipse_0) {
                var tmp5_ellipse_0_13_27 = bounds_5_19._width_0 / 2;
                var tmp6_ellipse_0_14_28 = bounds_5_19._height_0 / 2;
                var tmp7_ellipse_0_15_29 = Colors_getInstance()._WHITE_0;
                var tmp8_ellipse_0_16_30 = Colors_getInstance()._WHITE_0;
                var tmp4_addTo_0_17_31 = new Ellipse_1(tmp5_ellipse_0_13_27, tmp6_ellipse_0_14_28, new RGBA(tmp7_ellipse_0_15_29), new RGBA(tmp8_ellipse_0_16_30), 0.0, true);
                var tmp3_apply_0_18_32 = addTo(tmp4_addTo_0_17_31, tmp9_apply_0_16);
                Unit_getInstance();
                tmp_0 = tmp3_apply_0_18_32;
              } else {
                if (type_9_23 instanceof Rectangle_1) {
                  var tmp_1;
                  if (!(gid_6_20 == null)) {
                    var tmp1_elvis_lhs_20_34 = this._tileset_0.get_ha5a7z_k$(gid_6_20);
                    var tmp_2;
                    if (tmp1_elvis_lhs_20_34 == null) {
                      var tmp9__get_transparent__0_21_35 = Bitmaps_getInstance();
                      tmp_2 = Bitmaps_transparent;
                    } else {
                      tmp_2 = tmp1_elvis_lhs_20_34;
                    }
                    var tileTex_19_33 = tmp_2;
                    shouldShow_7_21 = true;
                    var tmp11_addTo_0_22_36 = Image_init_$Create$_0(tileTex_19_33, 0.0, 0.0, null, false, 24, null);
                    var tmp10_apply_0_23_37 = addTo(tmp11_addTo_0_22_36, tmp9_apply_0_16);
                    Unit_getInstance();
                    tmp_1 = tmp10_apply_0_23_37;
                  } else {
                    var tmp14_solidRect_0_24_38 = bounds_5_19._width_0;
                    var tmp15_solidRect_0_25_39 = bounds_5_19._height_0;
                    var tmp16_solidRect_0_26_40 = Colors_getInstance()._WHITE_0;
                    var tmp13_addTo_0_27_41 = new SolidRect(tmp14_solidRect_0_24_38, tmp15_solidRect_0_25_39, tmp16_solidRect_0_26_40);
                    var tmp12_apply_0_28_42 = addTo(tmp13_addTo_0_27_41, tmp9_apply_0_16);
                    Unit_getInstance();
                    tmp_1 = tmp12_apply_0_28_42;
                  }
                  tmp_0 = tmp_1;
                } else {
                  if (type_9_23 instanceof Polygon_0) {
                    var tmp18_addTo_0_30_44 = new Graphics(false);
                    var tmp17_apply_0_31_45 = addTo(tmp18_addTo_0_30_44, tmp9_apply_0_16);
                    var tmp1_fill_0_4_32_46 = Colors_getInstance()._WHITE_0;
                    var tmp0_fill_0_5_33_47 = tmp17_apply_0_31_45.toColorFill_rs7hy8_k$(tmp1_fill_0_4_32_46, 1.0);
                    tmp17_apply_0_31_45.beginFill_v3uoh1_k$(new RGBA(tmp0_fill_0_5_33_47));
                    Unit_getInstance();
                    try {
                      var first_2_6_34_48 = true;
                      var firstPoint_3_7_35_49 = null;
                      var tmp0_iterator_4_8_36_50 = type_9_23._points_6.iterator_0_k$();
                      while (tmp0_iterator_4_8_36_50.hasNext_0_k$()) {
                        var point_5_9_37_51 = tmp0_iterator_4_8_36_50.next_0_k$();
                        if (first_2_6_34_48) {
                          first_2_6_34_48 = false;
                          firstPoint_3_7_35_49 = point_5_9_37_51;
                          tmp17_apply_0_31_45.moveTo_ul66c3_k$(point_5_9_37_51._x_1, point_5_9_37_51._y_1);
                        } else {
                          tmp17_apply_0_31_45.lineTo_ul66c3_k$(point_5_9_37_51._x_1, point_5_9_37_51._y_1);
                        }
                      }
                      var tmp1_safe_receiver_6_10_38_52 = firstPoint_3_7_35_49;
                      if (tmp1_safe_receiver_6_10_38_52 == null)
                        null;
                      else {
                        tmp17_apply_0_31_45.lineTo_ul66c3_k$(tmp1_safe_receiver_6_10_38_52._x_1, tmp1_safe_receiver_6_10_38_52._y_1);
                        Unit_getInstance();
                      }
                      Unit_getInstance();
                      tmp17_apply_0_31_45.close_sv8swh_k$();
                    }finally {
                      tmp17_apply_0_31_45.endFill_0_k$();
                      Unit_getInstance();
                    }
                    var tmp19_apply_0_29_43 = tmp17_apply_0_31_45;
                    tmp19_apply_0_29_43.redrawIfRequired_sv8swh_k$();
                    tmp_0 = tmp19_apply_0_29_43;
                  } else {
                    if (type_9_23 instanceof Polyline_0) {
                      var tmp21_addTo_0_40_54 = new Graphics(false);
                      var tmp20_apply_0_41_55 = addTo(tmp21_addTo_0_40_54, tmp9_apply_0_16);
                      var tmp1_fill_0_4_42_56 = Colors_getInstance()._WHITE_0;
                      var tmp0_fill_0_5_43_57 = tmp20_apply_0_41_55.toColorFill_rs7hy8_k$(tmp1_fill_0_4_42_56, 1.0);
                      tmp20_apply_0_41_55.beginFill_v3uoh1_k$(new RGBA(tmp0_fill_0_5_43_57));
                      Unit_getInstance();
                      try {
                        var first_2_6_44_58 = true;
                        var tmp0_iterator_3_7_45_59 = type_9_23._points_7.iterator_0_k$();
                        while (tmp0_iterator_3_7_45_59.hasNext_0_k$()) {
                          var point_4_8_46_60 = tmp0_iterator_3_7_45_59.next_0_k$();
                          if (first_2_6_44_58) {
                            first_2_6_44_58 = false;
                            tmp20_apply_0_41_55.moveTo_ul66c3_k$(point_4_8_46_60._x_1, point_4_8_46_60._y_1);
                          } else {
                            tmp20_apply_0_41_55.lineTo_ul66c3_k$(point_4_8_46_60._x_1, point_4_8_46_60._y_1);
                          }
                        }
                        tmp20_apply_0_41_55.close_sv8swh_k$();
                      }finally {
                        tmp20_apply_0_41_55.endFill_0_k$();
                        Unit_getInstance();
                      }
                      var tmp22_apply_0_39_53 = tmp20_apply_0_41_55;
                      tmp22_apply_0_39_53.redrawIfRequired_sv8swh_k$();
                      tmp_0 = tmp22_apply_0_39_53;
                    } else {
                      if (type_9_23 instanceof Text_2) {
                        var tmp23_TODO_0_47_61 = '' + 'Unsupported tiled object ' + obj_4_18;
                        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp23_TODO_0_47_61);
                      } else {
                        {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
            var view_8_22 = tmp_0;
            var tmp24_visible_0_51_65 = shouldShow_7_21;
            view_8_22._set_visible__rpwsgn_k$(tmp24_visible_0_51_65);
            var tmp26_name_0_50_64 = view_8_22;
            var tmp25_takeIf_0_53_67 = obj_4_18._name_36;
            var tmp_3;
            if (charSequenceLength(tmp25_takeIf_0_53_67) > 0) {
              tmp_3 = tmp25_takeIf_0_53_67;
            } else {
              {
                tmp_3 = null;
              }
            }
            var tmp27_name_0_52_66 = tmp_3;
            tmp26_name_0_50_64._name_43 = tmp27_name_0_52_66;
            var tmp28_also_0_49_63 = rotation(xy(tmp26_name_0_50_64, bounds_5_19._x_2, bounds_5_19._y_2), _get_degrees__1(obj_4_18._rotation_1));
            tmp28_also_0_49_63.addProp_jbb6jz_k$('type', obj_4_18._type_23);
            var tmp29_also_0_48_62 = tmp28_also_0_49_63;
            tmp29_also_0_48_62.addProps_lvinfi_k$(obj_4_18._properties);
            Unit_getInstance();
          }
          tmp = tmp9_apply_0_16;
        } else {
          {
            tmp = dummyView(this);
          }
        }
      }
      var view_4 = tmp;
      var tmp11_visible_0_70 = tmp2__anonymous__3._visible_1;
      view_4._set_visible__rpwsgn_k$(tmp11_visible_0_70);
      var tmp13_name_0_69 = view_4;
      var tmp12_takeIf_0_72 = tmp2__anonymous__3._name_37;
      var tmp_4;
      if (charSequenceLength(tmp12_takeIf_0_72) > 0) {
        tmp_4 = tmp12_takeIf_0_72;
      } else {
        {
          tmp_4 = null;
        }
      }
      var tmp14_name_0_71 = tmp_4;
      tmp13_name_0_69._name_43 = tmp14_name_0_71;
      var tmp15_also_0_68 = alpha(xy(tmp13_name_0_69, tmp2__anonymous__3._offsetx, tmp2__anonymous__3._offsety), tmp2__anonymous__3._opacity);
      tmp15_also_0_68.addProps_lvinfi_k$(tmp2__anonymous__3._properties_0);
      Unit_getInstance();
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      Unit_getInstance();
    }
  }
  TiledMapView.prototype.hitTest_j5t4vg_k$ = function (x, y, direction) {
    return this.globalPixelHitTest_j5t4vg_k$(x, y, direction);
  };
  TiledMapView.prototype.globalPixelHitTest_j5t4vg_k$ = function (globalX, globalY, direction) {
    return this.pixelHitTest_ksczqu_k$(numberToInt(round(this.globalToLocalX_ngl742_k$(globalX, globalY) / this._get_scaleX__0_k$())), numberToInt(round(this.globalToLocalY_ngl742_k$(globalX, globalY) / this._get_scaleY__0_k$())), direction);
  };
  TiledMapView.prototype.pixelHitTest_ksczqu_k$ = function (x, y, direction) {
    var tmp0_fastForEach_0 = this.___children;
    var array_1 = tmp0_fastForEach_0._array_4;
    var n_2 = 0;
    while (n_2 < array_1.length) {
      var tmp0_4 = n_2;
      n_2 = tmp0_4 + 1 | 0;
      var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
      var tmp1__anonymous__1_5 = tmp0_unsafeCast_0_3;
      var tmp0_subject_3 = tmp1__anonymous__1_5;
      if (tmp0_subject_3 instanceof TileMap) {
        if (tmp1__anonymous__1_5.pixelHitTest_ksczqu_k$(x, y, direction))
          return tmp1__anonymous__1_5;
      } else {
      }
    }
    return null;
  };
  TiledMapView.$metadata$ = {
    simpleName: 'TiledMapView',
    kind: 'class',
    interfaces: []
  };
  function createView(_this_) {
    return TiledMapView_init_$Create$(_this_, false, false, 6, null);
  }
  function $forceLoadSourceFileCOROUTINE$28(_this_, views_0, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__194 = _this_;
    this._views_11 = views_0;
    this._currentVfs_1 = currentVfs;
    this._sourceFile_1 = sourceFile;
  }
  $forceLoadSourceFileCOROUTINE$28.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__194.baseForceLoadSourceFile_z71c2l_k$(this.__this__194, this._views_11, this._currentVfs_1, this._sourceFile_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this.__this__194.removeChildren_sv8swh_k$();
            this._state_1 = 2;
            var tmp_0 = this._currentVfs_1.get_6wfw3l_k$('' + this._sourceFile_1);
            suspendResult = readTiledMap$default(tmp_0, false, null, 0, null, 15, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = createView(ARGUMENT);
            this.__this__194.addChild_4l6ao4_k$(ARGUMENT_0);
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadSourceFileCOROUTINE$28.$metadata$ = {
    simpleName: '$forceLoadSourceFileCOROUTINE$28',
    kind: 'class',
    interfaces: []
  };
  function TiledMapViewRef() {
    Container.call(this);
    this._$$delegate_0_43 = new Mixin_3();
  }
  TiledMapViewRef.prototype.lazyLoadRenderInternal_hk6fpn_k$ = function (ctx, view) {
    this._$$delegate_0_43.lazyLoadRenderInternal_hk6fpn_k$(ctx, view);
  };
  TiledMapViewRef.prototype._set_sourceFile__qlpr75_k$ = function (_set___) {
    this._$$delegate_0_43._set_sourceFile__qlpr75_k$(_set___);
  };
  TiledMapViewRef.prototype._set_sourceTreeLoaded__rpwsgn_k$ = function (_set___) {
    this._$$delegate_0_43._sourceTreeLoaded = _set___;
  };
  TiledMapViewRef.prototype.baseForceLoadSourceFile_z71c2l_k$ = function (_this__0, views_0, currentVfs, sourceFile, $cont) {
    return this._$$delegate_0_43.baseForceLoadSourceFile_z71c2l_k$(_this__0, views_0, currentVfs, sourceFile, $cont);
  };
  TiledMapViewRef.prototype.forceLoadSourceFile_mwdcj_k$ = function (views_0, currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadSourceFileCOROUTINE$28(this, views_0, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  TiledMapViewRef.prototype.renderInternal_uxru53_k$ = function (ctx) {
    this.lazyLoadRenderInternal_hk6fpn_k$(ctx, this);
    Container.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  TiledMapViewRef.$metadata$ = {
    simpleName: 'TiledMapViewRef',
    kind: 'class',
    interfaces: [ViewLeaf, ViewFileRef]
  };
  var DEFAULT_EASING;
  var DEFAULT_TIME;
  function tween(_this_, vs, time, easing, waitTime, timeout, callback, $cont) {
    var tmp = new $tweenCOROUTINE$30(_this_, vs, time, easing, waitTime, timeout, callback, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function tween$default(_this_, vs, time, easing, waitTime, timeout, callback, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      time = DEFAULT_TIME;
    if (!(($mask0 & 4) === 0))
      easing = DEFAULT_EASING;
    if (!(($mask0 & 8) === 0))
      waitTime = Companion_getInstance_92()._NIL;
    if (!(($mask0 & 16) === 0))
      timeout = false;
    if (!(($mask0 & 32) === 0)) {
      callback = _no_name_provided_$factory_457();
    }return tween(_this_, vs, time, easing, waitTime, timeout, callback, $cont);
  }
  function _no_name_provided__522(this$0) {
    this._this$0_142 = this$0;
  }
  _no_name_provided__522.prototype.invoke_houul8_k$ = function (it) {
    this._this$0_142._cancelled = true;
  };
  _no_name_provided__522.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_houul8_k$((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__522.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TweenComponent(view, vs, time, easing, callback, c, waitTime) {
    this._view_9 = view;
    this._vs_0 = vs;
    this._time_10 = time;
    this._easing_2 = easing;
    this._callback_5 = callback;
    this._c_3 = c;
    this._waitTime = waitTime;
    var tmp = this;
    tmp._elapsed = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    var tmp_0 = this;
    var tmp_1;
    if (!equals_1(new TimeSpan(this._time_10), new TimeSpan(Companion_getInstance_92()._NIL))) {
      tmp_1 = this._time_10;
    } else {
      var tmp0_map_0 = this._vs_0;
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var tmp0_iterator_1_2 = tmp0_map_0.iterator_0_k$();
      while (tmp0_iterator_1_2.hasNext_0_k$()) {
        var item_2_3 = tmp0_iterator_1_2.next_0_k$();
        tmp0_mapTo_0_1.add_2bq_k$(_TimeSpan___get_nanoseconds__impl_(item_2_3._endTime));
        Unit_getInstance();
      }
      var tmp0_elvis_lhs = maxOrNull_0(tmp0_mapTo_0_1);
      var tmp1__get_nanoseconds__0 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      tmp_1 = Companion_getInstance_92().fromNanoseconds_ttklb2_k$(tmp1__get_nanoseconds__0);
    }
    tmp_0._hrtime = tmp_1;
    this._cancelled = false;
    this._done = false;
    this._resumed = false;
    var tmp0_safe_receiver = this._c_3;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.invokeOnCancellation_aip8gd_k$(_no_name_provided_$factory_458(this));
      Unit_getInstance();
    }
    Unit_getInstance();
    this.update_zah5t7_k$(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0));
  }
  TweenComponent.prototype._get_view__0_k$ = function () {
    return this._view_9;
  };
  TweenComponent.prototype.resumeOnce_sv8swh_k$ = function () {
    if (this._resumed)
      return Unit_getInstance();
    this._resumed = true;
    var tmp0_safe_receiver = this._c_3;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp0_success_0_1 = Companion_getInstance_3();
      tmp0_safe_receiver.resumeWith_bnunh2_k$(_Result___init__impl_(Unit_getInstance()));
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  TweenComponent.prototype.completeOnce_sv8swh_k$ = function () {
    if (this._done)
      return Unit_getInstance();
    this._done = true;
    detach(this);
    Unit_getInstance();
    this.resumeOnce_sv8swh_k$();
  };
  TweenComponent.prototype.update_zah5t7_k$ = function (dt) {
    if (this._cancelled) {
      return this.completeOnce_sv8swh_k$();
    }var tmp0_this = this;
    tmp0_this._elapsed = TimeSpan__plus_impl(tmp0_this._elapsed, dt);
    var ratio = clamp_3(TimeSpan__div_impl_0(this._elapsed, this._hrtime), 0.0, 1.0);
    this.setTo_zah5t7_k$(this._elapsed);
    this._callback_5(this._easing_2.invoke_e2tf9d_k$(ratio));
    if (!equals_1(new TimeSpan(this._waitTime), new TimeSpan(Companion_getInstance_92()._NIL)) ? TimeSpan__compareTo_impl(this._elapsed, this._waitTime) >= 0 : false) {
      this.resumeOnce_sv8swh_k$();
    }if (ratio >= 1.0) {
      return this.completeOnce_sv8swh_k$();
    }};
  TweenComponent.prototype.setTo_zah5t7_k$ = function (elapsed) {
    var tmp = new TimeSpan(elapsed);
    if (equals_1(tmp, new TimeSpan(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0)))) {
      var tmp0_fastForEach_0 = this._vs_0;
      var n_1 = 0;
      while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
        tmp1__anonymous__3.init_sv8swh_k$();
      }
    } else {
    }
    var tmp2_fastForEach_0 = this._vs_0;
    var n_1_0 = 0;
    while (n_1_0 < tmp2_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_0 = n_1_0;
      n_1_0 = tmp0_2_0 + 1 | 0;
      var tmp3__anonymous__3 = tmp2_fastForEach_0.get_ha5a7z_k$(tmp0_2_0);
      var tmp0_coalesce_0_5 = tmp3__anonymous__3._duration_2;
      var tmp_0;
      if (!equals_1(new TimeSpan(tmp0_coalesce_0_5), new TimeSpan(Companion_getInstance_92()._NIL))) {
        tmp_0 = tmp0_coalesce_0_5;
      } else {
        tmp_0 = TimeSpan__minus_impl(this._hrtime, tmp3__anonymous__3._startTime_3);
      }
      var durationInTween_4 = tmp_0;
      var tmp_1 = TimeSpan__minus_impl(elapsed, tmp3__anonymous__3._startTime_3);
      var elapsedInTween_6 = clamp_0(tmp_1, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0), durationInTween_4);
      var tmp_2;
      var tmp_3;
      if (TimeSpan__compareTo_impl(durationInTween_4, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0)) <= 0) {
        tmp_3 = true;
      } else {
        {
          tmp_3 = TimeSpan__compareTo_impl(elapsedInTween_6, durationInTween_4) >= 0;
        }
      }
      if (tmp_3) {
        tmp_2 = 1.0;
      } else {
        {
          tmp_2 = TimeSpan__div_impl_0(elapsedInTween_6, durationInTween_4);
        }
      }
      var ratioInTween_7 = tmp_2;
      var easedRatioInTween_8 = this._easing_2.invoke_e2tf9d_k$(ratioInTween_7);
      tmp3__anonymous__3.set_okcceq_k$(easedRatioInTween_8);
    }
  };
  TweenComponent.prototype.toString = function () {
    return '' + 'TweenComponent(' + this._view_9 + ')';
  };
  TweenComponent.$metadata$ = {
    simpleName: 'TweenComponent',
    kind: 'class',
    interfaces: [UpdateComponent]
  };
  function _no_name_provided__523() {
  }
  _no_name_provided__523.prototype.invoke_okcceq_k$ = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__523.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__523.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__524($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, resultContinuation) {
    this._$this_tween = $this_tween;
    this._$tc = $tc;
    this._$vs = $vs;
    this._$time = $time;
    this._$easing_1 = $easing;
    this._$callback_5 = $callback;
    this._$waitTime = $waitTime;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__524.prototype.invoke_2i3g7c_k$ = function ($this$withTimeout, $cont) {
    var tmp = this.create_y6imfn_k$($this$withTimeout, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__524.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_2i3g7c_k$((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__524.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this;
            tmp_0._tmp0__anonymous__1_10_0 = this;
            this._cancellable_2_21 = new CancellableContinuationImpl(intercepted(this._tmp0__anonymous__1_10_0), 1);
            this._cancellable_2_21.initCancellability_sv8swh_k$();
            this._view_42 = this._$this_tween;
            var tmp_1 = this;
            tmp_1._tmp0_also_0_53 = new TweenComponent(this._view_42, toList(this._$vs), this._$time, this._$easing_1, this._$callback_5, this._cancellable_2_21, this._$waitTime);
            attach_0(this._tmp0_also_0_53);
            Unit_getInstance();
            this._$tc._v = this._tmp0_also_0_53;
            suspendResult = this._cancellable_2_21.getResult_0_k$();
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__524.prototype.create_y6imfn_k$ = function ($this$withTimeout, completion) {
    var i = new _no_name_provided__524(this._$this_tween, this._$tc, this._$vs, this._$time, this._$easing_1, this._$callback_5, this._$waitTime, completion);
    i._$this$withTimeout = $this$withTimeout;
    return i;
  };
  _no_name_provided__524.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $tweenCOROUTINE$30(_this_, vs, time, easing, waitTime, timeout, callback, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__195 = _this_;
    this._vs_1 = vs;
    this._time_11 = time;
    this._easing_3 = easing;
    this._waitTime_0 = waitTime;
    this._timeout = timeout;
    this._callback_6 = callback;
  }
  $tweenCOROUTINE$30.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            if (!(this.__this__195 == null)) {
              this._tc0 = {_v: null};
              this._exceptionState = 2;
              this._state_1 = 1;
              var tmp_0;
              if (this._timeout) {
                var tmp_1 = TimeSpan__times_impl(this._time_11, 2);
                tmp_0 = TimeSpan__plus_impl(tmp_1, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(300.0));
              } else {
                tmp_0 = Companion_getInstance_92()._NIL;
              }
              var tmp_2 = tmp_0;
              suspendResult = withTimeout_0(tmp_2, _no_name_provided_$factory_459(this.__this__195, this._tc0, this._vs_1, this._time_11, this._easing_3, this._callback_6, this._waitTime_0, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 1:
            this._exceptionState = 5;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._exceptionState = 5;
            var tmp_3 = this._exception_0;
            if (tmp_3 instanceof TimeoutCancellationException) {
              var e = this._exception_0;
              var tmp0_safe_receiver = this._tc0._v;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.setTo_zah5t7_k$(this._time_11);
                Unit_getInstance();
              }
              Unit_getInstance();
              this._state_1 = 3;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            this._exceptionState = 5;
            this._state_1 = 4;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tweenCOROUTINE$30.$metadata$ = {
    simpleName: '$tweenCOROUTINE$30',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_457() {
    var i = new _no_name_provided__523();
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_458(this$0) {
    var i = new _no_name_provided__522(this$0);
    return function (p1) {
      i.invoke_houul8_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_459($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, resultContinuation) {
    var i = new _no_name_provided__524($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_2i3g7c_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function DEFAULT_TIME$init$() {
    return Companion_getInstance_92().fromSeconds_ttklb2_k$(1.0);
  }
  function V2_init_$Init$(key, initial, end, interpolator, includeStart, startTime, duration, $mask0, $marker, $this) {
    if (!(($mask0 & 32) === 0)) {
      startTime = Companion_getInstance_92().fromNanoseconds_ttklb2_k$(0.0);
    }if (!(($mask0 & 64) === 0))
      duration = Companion_getInstance_92()._NIL;
    V2.call($this, key, initial, end, interpolator, includeStart, startTime, duration);
    return $this;
  }
  function V2_init_$Create$(key, initial, end, interpolator, includeStart, startTime, duration, $mask0, $marker) {
    return V2_init_$Init$(key, initial, end, interpolator, includeStart, startTime, duration, $mask0, $marker, Object.create(V2.prototype));
  }
  function V2(key, initial, end, interpolator, includeStart, startTime, duration) {
    this._key_5 = key;
    this._initial = initial;
    this._end_4 = end;
    this._interpolator = interpolator;
    this._includeStart = includeStart;
    this._startTime_3 = startTime;
    this._duration_2 = duration;
    var tmp = this;
    var tmp0_coalesce_0 = this._duration_2;
    var tmp_0;
    if (!equals_1(new TimeSpan(tmp0_coalesce_0), new TimeSpan(Companion_getInstance_92()._NIL))) {
      tmp_0 = tmp0_coalesce_0;
    } else {
      tmp_0 = Companion_getInstance_92().fromNanoseconds_ttklb2_k$(0.0);
    }
    tmp._endTime = TimeSpan__plus_impl(this._startTime_3, tmp_0);
  }
  V2.prototype.init_sv8swh_k$ = function () {
    if (!this._includeStart) {
      this._initial = this._key_5.get();
    }};
  V2.prototype.set_okcceq_k$ = function (ratio) {
    return this._key_5.set(this._interpolator(ratio, this._initial, this._end_4));
  };
  V2.prototype.toString = function () {
    return '' + 'V2(key=' + this._key_5.callableName + ', range=[' + this._initial + '-' + this._end_4 + '], startTime=' + new TimeSpan(this._startTime_3) + ', duration=' + new TimeSpan(this._duration_2) + ')';
  };
  V2.prototype.hashCode = function () {
    var result = hashCode(this._key_5);
    result = imul(result, 31) + (this._initial == null ? 0 : hashCode(this._initial)) | 0;
    result = imul(result, 31) + (this._end_4 == null ? 0 : hashCode(this._end_4)) | 0;
    result = imul(result, 31) + hashCode(this._interpolator) | 0;
    result = imul(result, 31) + (this._includeStart | 0) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._startTime_3) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._duration_2) | 0;
    return result;
  };
  V2.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals_1(this._key_5, tmp0_other_with_cast._key_5))
      return false;
    if (!equals_1(this._initial, tmp0_other_with_cast._initial))
      return false;
    if (!equals_1(this._end_4, tmp0_other_with_cast._end_4))
      return false;
    if (!equals_1(this._interpolator, tmp0_other_with_cast._interpolator))
      return false;
    if (!(this._includeStart === tmp0_other_with_cast._includeStart))
      return false;
    if (!equals_1(new TimeSpan(this._startTime_3), new TimeSpan(tmp0_other_with_cast._startTime_3)))
      return false;
    if (!equals_1(new TimeSpan(this._duration_2), new TimeSpan(tmp0_other_with_cast._duration_2)))
      return false;
    return true;
  };
  V2.$metadata$ = {
    simpleName: 'V2',
    kind: 'class',
    interfaces: []
  };
  function _interpolate(ratio, l, r) {
    return ratio < 0.0 ? l : ratio >= 1.0 ? r : interpolate(ratio, l, r);
  }
  function _interpolateTimeSpan(ratio, l, r) {
    var tmp0__get_milliseconds__0 = _interpolate(ratio, _TimeSpan___get_milliseconds__impl_(l), _TimeSpan___get_milliseconds__impl_(r));
    return Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp0__get_milliseconds__0);
  }
  function _no_name_provided__525() {
  }
  _no_name_provided__525.prototype.invoke_0_k$ = function () {
    var tmp0_also_0 = UIButton_init_$Create$(0.0, 0.0, null, null, 15, null);
    tmp0_also_0._text_4 = 'Button';
    return tmp0_also_0;
  };
  _no_name_provided__525.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__526() {
  }
  _no_name_provided__526.prototype.invoke_nw728s_k$ = function ($this$null) {
    var tmp = text$factory_0();
    $this$null.add$default_aqar58_k$(tmp, null, 2, null);
    Unit_getInstance();
    var tmp_0 = textSize$factory();
    $this$null.add$default_8vq79r_k$(tmp_0, 0.0, 2, null);
    Unit_getInstance();
    var tmp_1 = width$factory();
    $this$null.add$default_8vq79r_k$(tmp_1, 0.0, 2, null);
    Unit_getInstance();
    var tmp_2 = height$factory();
    $this$null.add$default_8vq79r_k$(tmp_2, 0.0, 2, null);
    Unit_getInstance();
  };
  _no_name_provided__526.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nw728s_k$(p1 instanceof KTreeSerializerExt ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__526.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__527(this$0) {
    this._this$0_143 = this$0;
  }
  _no_name_provided__527.prototype.invoke_3xauee_k$ = function (it) {
    this._this$0_143.simulateDown_sv8swh_k$();
  };
  _no_name_provided__527.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_3xauee_k$(p1 instanceof Info_1 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__527.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__528(this$0) {
    this._this$0_144 = this$0;
  }
  _no_name_provided__528.prototype.invoke_3xauee_k$ = function (it) {
    this._this$0_144.simulateUp_sv8swh_k$();
  };
  _no_name_provided__528.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_3xauee_k$(p1 instanceof Info_1 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__528.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__529(this$0) {
    this._this$0_145 = this$0;
  }
  _no_name_provided__529.prototype.invoke_3xauee_k$ = function (it) {
    this._this$0_145._onPress.invoke_iav7o_k$(it);
  };
  _no_name_provided__529.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_3xauee_k$(p1 instanceof Info_1 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__529.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__530($tmp0_onOver_0_3, $it, resultContinuation) {
    this._$tmp0_onOver_0_3 = $tmp0_onOver_0_3;
    this._$it = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__530.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__530.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__530.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp0_onOver_0_3(this._$it, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__530.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__530(this._$tmp0_onOver_0_3, this._$it, completion);
    return i;
  };
  _no_name_provided__530.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__531($tmp1_onOut_0_8, $it, resultContinuation) {
    this._$tmp1_onOut_0_8 = $tmp1_onOut_0_8;
    this._$it_0 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__531.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__531.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__531.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp1_onOut_0_8(this._$it_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__531.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__531(this._$tmp1_onOut_0_8, this._$it_0, completion);
    return i;
  };
  _no_name_provided__531.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function UIButton_init_$Init$(width, height, text, icon, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 128.0;
    if (!(($mask0 & 2) === 0))
      height = 32.0;
    if (!(($mask0 & 4) === 0))
      text = '';
    if (!(($mask0 & 8) === 0))
      icon = null;
    UIButton.call($this, width, height, text, icon);
    return $this;
  }
  function UIButton_init_$Create$(width, height, text, icon, $mask0, $marker) {
    return UIButton_init_$Init$(width, height, text, icon, $mask0, $marker, Object.create(UIButton.prototype));
  }
  function Serializer() {
    Serializer_instance = this;
    var tmp = getKClass_0(UIButton);
    var tmp_0 = _no_name_provided_$factory_465();
    KTreeSerializerExt.call(this, 'UIButton', tmp, tmp_0, _no_name_provided_$factory_466());
  }
  Serializer.$metadata$ = {
    simpleName: 'Serializer',
    kind: 'object',
    interfaces: []
  };
  var Serializer_instance;
  function Serializer_getInstance() {
    if (Serializer_instance == null)
      new Serializer();
    return Serializer_instance;
  }
  function _no_name_provided__532(this$0) {
    this._this$0_146 = this$0;
  }
  _no_name_provided__532.prototype.invoke_qglxds_k$ = function ($this$singleTouch, it) {
    $this$singleTouch._start_4.invoke_o72mru_k$(_no_name_provided_$factory_467(this._this$0_146));
    Unit_getInstance();
    $this$singleTouch._endAnywhere.invoke_o72mru_k$(_no_name_provided_$factory_468(this._this$0_146));
    Unit_getInstance();
    $this$singleTouch._tap.invoke_o72mru_k$(_no_name_provided_$factory_469(this._this$0_146));
    Unit_getInstance();
  };
  _no_name_provided__532.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof SingleTouchHandler ? p1 : THROW_CCE();
    this.invoke_qglxds_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__532.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__533(this$0, resultContinuation) {
    this._this$0_147 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__533.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__533.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__533.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_147.simulateOver_sv8swh_k$();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__533.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__533(this._this$0_147, completion);
    i._it_0 = it;
    return i;
  };
  _no_name_provided__533.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__534($tmp0_run_0_1, $tmp0_onOver_0_3) {
    this._$tmp0_run_0_1 = $tmp0_run_0_1;
    this._$tmp0_onOver_0_3_0 = $tmp0_onOver_0_3;
  }
  _no_name_provided__534.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp0_run_0_1._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_470(this._$tmp0_onOver_0_3_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__534.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__534.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__535(this$0, resultContinuation) {
    this._this$0_148 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__535.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__535.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__535.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_148.simulateOut_sv8swh_k$();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__535.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__535(this._this$0_148, completion);
    i._it_1 = it;
    return i;
  };
  _no_name_provided__535.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__536($tmp0_run_0_1, $tmp1_onOut_0_8) {
    this._$tmp0_run_0_1_0 = $tmp0_run_0_1;
    this._$tmp1_onOut_0_8_0 = $tmp1_onOut_0_8;
  }
  _no_name_provided__536.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp0_run_0_1_0._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_471(this._$tmp1_onOut_0_8_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__536.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__536.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIButton(width, height, text, icon) {
    UIView.call(this, width, height);
    this._text_4 = text;
    this._icon_3 = icon;
    this._forcePressed = false;
    var tmp = this;
    var tmp1_addTo_0 = new NinePatchEx(null, width, height);
    var tmp0_apply_0 = addTo(tmp1_addTo_0, this);
    Unit_getInstance();
    tmp._rect_3 = tmp0_apply_0;
    var tmp_0 = this;
    var tmp2_text_0 = Colors_getInstance()._WHITE_0;
    var tmp3_text_0 = _get_DefaultTtfFont_();
    var tmp4_text_0 = Companion_getInstance_153()._TOP_LEFT_0;
    var tmp5_text_0 = DefaultStringTextRenderer;
    var tmp6_text_0 = Companion_getInstance_212()._DEFAULT_AUTO_SCALING;
    var tmp1_addTo_0_0 = new Text_3('', 16.0, tmp2_text_0, tmp3_text_0, tmp4_text_0, tmp5_text_0, tmp6_text_0);
    var tmp0_apply_0_0 = addTo(tmp1_addTo_0_0, this);
    Unit_getInstance();
    tmp_0._textShadowView = tmp0_apply_0_0;
    var tmp_1 = this;
    var tmp2_text_0_0 = Colors_getInstance()._WHITE_0;
    var tmp3_text_0_0 = _get_DefaultTtfFont_();
    var tmp4_text_0_0 = Companion_getInstance_153()._TOP_LEFT_0;
    var tmp5_text_0_0 = DefaultStringTextRenderer;
    var tmp6_text_0_0 = Companion_getInstance_212()._DEFAULT_AUTO_SCALING;
    var tmp1_addTo_0_1 = new Text_3('', 16.0, tmp2_text_0_0, tmp3_text_0_0, tmp4_text_0_0, tmp5_text_0_0, tmp6_text_0_0);
    var tmp0_apply_0_1 = addTo(tmp1_addTo_0_1, this);
    Unit_getInstance();
    tmp_1._textView = tmp0_apply_0_1;
    var tmp_2 = this;
    var tmp0__get_transparent__0 = Bitmaps_getInstance();
    var tmp3_image_0 = Bitmaps_transparent;
    var tmp2_addTo_0 = Image_init_$Create$_0(tmp3_image_0, 0.0, 0.0, null, false, 24, null);
    var tmp1_apply_0 = addTo(tmp2_addTo_0, this);
    Unit_getInstance();
    tmp_2._iconView = tmp1_apply_0;
    this._textAndShadow = fastArrayListOf([this._textView, this._textShadowView]);
    this._bover = false;
    this._bpressing = false;
    var tmp_3 = this;
    tmp_3._onPress = Signal_init_$Create$(null, 1, null);
    singleTouch$default(this, false, false, _no_name_provided_$factory_460(this), 3, null);
    var tmp0_run_0_1 = _get_mouse_(this);
    var tmp0_onOver_0_3 = _no_name_provided_$factory_461(this, null);
    var tmp0__mouseEvent_0_1_5 = over$factory();
    var tmp_4 = tmp0__mouseEvent_0_1_5.get(tmp0_run_0_1);
    tmp_4.add_o72mru_k$(_no_name_provided_$factory_462(tmp0_run_0_1, tmp0_onOver_0_3));
    Unit_getInstance();
    Unit_getInstance();
    var tmp1_onOut_0_8 = _no_name_provided_$factory_463(this, null);
    var tmp0__mouseEvent_0_1_10 = out$factory();
    var tmp_5 = tmp0__mouseEvent_0_1_10.get(tmp0_run_0_1);
    tmp_5.add_o72mru_k$(_no_name_provided_$factory_464(tmp0_run_0_1, tmp1_onOut_0_8));
    Unit_getInstance();
    Unit_getInstance();
  }
  UIButton.prototype.renderInternal_uxru53_k$ = function (ctx) {
    var skin = _get_realUiSkin_(this);
    this._rect_3._ninePatch_1 = !this._get_enabled__0_k$() ? _get_buttonDisabled_(skin) : (this._bpressing ? true : this._forcePressed) ? _get_buttonDown_(skin) : this._bover ? _get_buttonOver_(skin) : _get_buttonNormal_(skin);
    this._rect_3._width_27 = this._get_width__0_k$();
    this._rect_3._height_28 = this._get_height__0_k$();
    var tmp = Companion_getInstance_205();
    var tmp0_elvis_lhs = this._icon_3;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp0__get_transparent__0 = Bitmaps_getInstance();
      tmp_0 = Bitmaps_transparent;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp.fitIconInRect_s39vyx_k$(this._iconView, tmp_0, this._rect_3._width_27, this._rect_3._height_28, Companion_getInstance_25()._MIDDLE_CENTER);
    this._iconView._set_alpha__okcceq_k$(!this._get_enabled__0_k$() ? 0.5 : this._bover ? 1.0 : 1.0);
    var tmp1_isNotEmpty_0 = this._text_4;
    if (charSequenceLength(tmp1_isNotEmpty_0) > 0) {
      var alignment = _get_buttonTextAlignment_(skin);
      var font = _get_textFont_(skin);
      var text = this._text_4;
      var textSize = _get_textSize_(skin);
      var tmp2_fastForEach_0 = this._textAndShadow;
      var array_1 = tmp2_fastForEach_0._array_4;
      var n_2 = 0;
      while (n_2 < array_1.length) {
        var tmp0_4 = n_2;
        n_2 = tmp0_4 + 1 | 0;
        var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
        var tmp3__anonymous__5 = tmp0_unsafeCast_0_3;
        tmp3__anonymous__5.setTextBounds_wf26y9_k$(new Rectangle(0.0, 0.0, this._get_width__0_k$(), this._get_height__0_k$()));
        tmp3__anonymous__5._set_visible__rpwsgn_k$(true);
        tmp3__anonymous__5._set_text__a4enbm_k$(text);
        tmp3__anonymous__5._set_alignment__1x48jb_k$(alignment);
        tmp3__anonymous__5._set_font__aavk6z_k$(font);
        tmp3__anonymous__5._set_textSize__okcceq_k$(textSize);
      }
      this._textView._set_color__f52nlt_k$(_get_textColor_(skin));
      this._textShadowView._set_color__f52nlt_k$(_get_shadowColor_(skin));
      var tmp4_position_0 = this._textShadowView;
      var tmp5_position_0 = _get_shadowPosition_(skin);
      position(tmp4_position_0, tmp5_position_0._get_x__0_k$(), tmp5_position_0._get_y__0_k$());
      Unit_getInstance();
    } else {
      {
        this._textView._set_visible__rpwsgn_k$(false);
        this._textShadowView._set_visible__rpwsgn_k$(false);
      }
    }
    UIView.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  UIButton.prototype.simulateOver_sv8swh_k$ = function () {
    this._bover = true;
  };
  UIButton.prototype.simulateOut_sv8swh_k$ = function () {
    this._bover = false;
  };
  UIButton.prototype.simulateDown_sv8swh_k$ = function () {
    this._bpressing = true;
  };
  UIButton.prototype.simulateUp_sv8swh_k$ = function () {
    this._bpressing = false;
  };
  UIButton.$metadata$ = {
    simpleName: 'UIButton',
    kind: 'class',
    interfaces: []
  };
  function over$factory() {
    return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
      return receiver._over;
    }, null);
  }
  function out$factory() {
    return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
      return receiver._out_11;
    }, null);
  }
  function text$factory_0() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._text_4;
    }, function (receiver_0, value) {
      receiver_0._text_4 = value;
      return Unit_getInstance();
    });
  }
  function textSize$factory() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return _get_textSize_(receiver);
    }, function (receiver_0, value) {
      return _set_textSize_(receiver_0, value);
    });
  }
  function width$factory() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_width__okcceq_k$(value);
    });
  }
  function height$factory() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_height__okcceq_k$(value);
    });
  }
  function _no_name_provided_$factory_460(this$0) {
    var i = new _no_name_provided__532(this$0);
    return function (p1, p2) {
      i.invoke_qglxds_k$(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_461(this$0, resultContinuation) {
    var i = new _no_name_provided__533(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_462($tmp0_run_0_1, $tmp0_onOver_0_3) {
    var i = new _no_name_provided__534($tmp0_run_0_1, $tmp0_onOver_0_3);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_463(this$0, resultContinuation) {
    var i = new _no_name_provided__535(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_464($tmp0_run_0_1, $tmp1_onOut_0_8) {
    var i = new _no_name_provided__536($tmp0_run_0_1, $tmp1_onOut_0_8);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_465() {
    var i = new _no_name_provided__525();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_466() {
    var i = new _no_name_provided__526();
    return function (p1) {
      i.invoke_nw728s_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_467(this$0) {
    var i = new _no_name_provided__527(this$0);
    return function (p1) {
      i.invoke_3xauee_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_468(this$0) {
    var i = new _no_name_provided__528(this$0);
    return function (p1) {
      i.invoke_3xauee_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_469(this$0) {
    var i = new _no_name_provided__529(this$0);
    return function (p1) {
      i.invoke_3xauee_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_470($tmp0_onOver_0_3, $it, resultContinuation) {
    var i = new _no_name_provided__530($tmp0_onOver_0_3, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_471($tmp1_onOut_0_8, $it, resultContinuation) {
    var i = new _no_name_provided__531($tmp1_onOut_0_8, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided__537() {
  }
  _no_name_provided__537.prototype.invoke_0_k$ = function () {
    return UICheckBox_init_$Create$(0.0, 0.0, false, null, 15, null);
  };
  _no_name_provided__537.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__538() {
  }
  _no_name_provided__538.prototype.invoke_patkcz_k$ = function ($this$null) {
    var tmp = text$factory_1();
    $this$null.add$default_aqar58_k$(tmp, null, 2, null);
    Unit_getInstance();
    var tmp_0 = checked$factory();
    $this$null.add$default_5jqalj_k$(tmp_0, false, 2, null);
    Unit_getInstance();
    var tmp_1 = width$factory_0();
    $this$null.add$default_8vq79r_k$(tmp_1, 0.0, 2, null);
    Unit_getInstance();
    var tmp_2 = height$factory_0();
    $this$null.add$default_8vq79r_k$(tmp_2, 0.0, 2, null);
    Unit_getInstance();
  };
  _no_name_provided__538.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_patkcz_k$(p1 instanceof KTreeSerializerExt ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__538.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UICheckBox_init_$Init$(width, height, checked, text, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 100.0;
    if (!(($mask0 & 2) === 0))
      height = 32.0;
    if (!(($mask0 & 4) === 0))
      checked = false;
    if (!(($mask0 & 8) === 0))
      text = 'CheckBox';
    UICheckBox.call($this, width, height, checked, text);
    return $this;
  }
  function UICheckBox_init_$Create$(width, height, checked, text, $mask0, $marker) {
    return UICheckBox_init_$Init$(width, height, checked, text, $mask0, $marker, Object.create(UICheckBox.prototype));
  }
  function Serializer_0() {
    Serializer_instance_0 = this;
    var tmp = getKClass_0(UICheckBox);
    var tmp_0 = _no_name_provided_$factory_472();
    KTreeSerializerExt.call(this, 'UICheckBox', tmp, tmp_0, _no_name_provided_$factory_473());
  }
  Serializer_0.$metadata$ = {
    simpleName: 'Serializer',
    kind: 'object',
    interfaces: []
  };
  var Serializer_instance_0;
  function Serializer_getInstance_0() {
    if (Serializer_instance_0 == null)
      new Serializer_0();
    return Serializer_instance_0;
  }
  function UICheckBox(width, height, checked, text) {
    UIBaseCheckBox.call(this, width, height, checked, text);
  }
  UICheckBox.$metadata$ = {
    simpleName: 'UICheckBox',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__539($tmp0_onOver_0_3, $it, resultContinuation) {
    this._$tmp0_onOver_0_3_1 = $tmp0_onOver_0_3;
    this._$it_1 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__539.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__539.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__539.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp0_onOver_0_3_1(this._$it_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__539.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__539(this._$tmp0_onOver_0_3_1, this._$it_1, completion);
    return i;
  };
  _no_name_provided__539.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__540($tmp1_onOut_0_8, $it, resultContinuation) {
    this._$tmp1_onOut_0_8_1 = $tmp1_onOut_0_8;
    this._$it_2 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__540.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__540.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__540.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp1_onOut_0_8_1(this._$it_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__540.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__540(this._$tmp1_onOut_0_8_1, this._$it_2, completion);
    return i;
  };
  _no_name_provided__540.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__541($tmp2_onDown_0_13, $it, resultContinuation) {
    this._$tmp2_onDown_0_13 = $tmp2_onDown_0_13;
    this._$it_3 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__541.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__541.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__541.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp2_onDown_0_13(this._$it_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__541.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__541(this._$tmp2_onDown_0_13, this._$it_3, completion);
    return i;
  };
  _no_name_provided__541.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__542($tmp3_onUpAnywhere_0_18, $it, resultContinuation) {
    this._$tmp3_onUpAnywhere_0_18 = $tmp3_onUpAnywhere_0_18;
    this._$it_4 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__542.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__542.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__542.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp3_onUpAnywhere_0_18(this._$it_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__542.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__542(this._$tmp3_onUpAnywhere_0_18, this._$it_4, completion);
    return i;
  };
  _no_name_provided__542.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__543($tmp4_onClick_0_23, $it, resultContinuation) {
    this._$tmp4_onClick_0_23 = $tmp4_onClick_0_23;
    this._$it_5 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__543.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__543.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__543.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp4_onClick_0_23(this._$it_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__543.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__543(this._$tmp4_onClick_0_23, this._$it_5, completion);
    return i;
  };
  _no_name_provided__543.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _set_over_($this, _set___) {
    return $this._over$delegate.setValue_8gqndb_k$($this, over$factory_1(), _set___);
  }
  function _get_over_($this) {
    return $this._over$delegate.getValue_1rt9ub_k$($this, over$factory_2());
  }
  function _set_pressing_($this, _set___) {
    return $this._pressing$delegate.setValue_8gqndb_k$($this, pressing$factory(), _set___);
  }
  function _get_pressing_($this) {
    return $this._pressing$delegate.getValue_1rt9ub_k$($this, pressing$factory_0());
  }
  function _no_name_provided__544(this$0) {
    this._this$0_149 = this$0;
  }
  _no_name_provided__544.prototype.invoke_rpwsgn_k$ = function (it) {
    this._this$0_149.updateState_sv8swh_k$();
  };
  _no_name_provided__544.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_rpwsgn_k$((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__544.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__545(this$0) {
    this._this$0_150 = this$0;
  }
  _no_name_provided__545.prototype.invoke_rpwsgn_k$ = function (it) {
    this._this$0_150.updateState_sv8swh_k$();
  };
  _no_name_provided__545.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_rpwsgn_k$((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__545.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__546(this$0, resultContinuation) {
    this._this$0_151 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__546.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__546.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__546.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          _set_over_(this._this$0_151, true);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__546.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__546(this._this$0_151, completion);
    i._it_2 = it;
    return i;
  };
  _no_name_provided__546.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__547($tmp0_run_0_1, $tmp0_onOver_0_3) {
    this._$tmp0_run_0_1_1 = $tmp0_run_0_1;
    this._$tmp0_onOver_0_3_2 = $tmp0_onOver_0_3;
  }
  _no_name_provided__547.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp0_run_0_1_1._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_486(this._$tmp0_onOver_0_3_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__547.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__547.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__548(this$0, resultContinuation) {
    this._this$0_152 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__548.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__548.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__548.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          _set_over_(this._this$0_152, false);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__548.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__548(this._this$0_152, completion);
    i._it_3 = it;
    return i;
  };
  _no_name_provided__548.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__549($tmp0_run_0_1, $tmp1_onOut_0_8) {
    this._$tmp0_run_0_1_2 = $tmp0_run_0_1;
    this._$tmp1_onOut_0_8_2 = $tmp1_onOut_0_8;
  }
  _no_name_provided__549.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp0_run_0_1_2._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_487(this._$tmp1_onOut_0_8_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__549.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__549.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__550(this$0, resultContinuation) {
    this._this$0_153 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__550.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__550.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__550.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          _set_pressing_(this._this$0_153, true);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__550.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__550(this._this$0_153, completion);
    i._it_4 = it;
    return i;
  };
  _no_name_provided__550.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__551($tmp0_run_0_1, $tmp2_onDown_0_13) {
    this._$tmp0_run_0_1_3 = $tmp0_run_0_1;
    this._$tmp2_onDown_0_13_0 = $tmp2_onDown_0_13;
  }
  _no_name_provided__551.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp0_run_0_1_3._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_488(this._$tmp2_onDown_0_13_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__551.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__551.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__552(this$0, resultContinuation) {
    this._this$0_154 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__552.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__552.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__552.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          _set_pressing_(this._this$0_154, false);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__552.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__552(this._this$0_154, completion);
    i._it_5 = it;
    return i;
  };
  _no_name_provided__552.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__553($tmp0_run_0_1, $tmp3_onUpAnywhere_0_18) {
    this._$tmp0_run_0_1_4 = $tmp0_run_0_1;
    this._$tmp3_onUpAnywhere_0_18_0 = $tmp3_onUpAnywhere_0_18;
  }
  _no_name_provided__553.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp0_run_0_1_4._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_489(this._$tmp3_onUpAnywhere_0_18_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__553.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__553.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__554(this$0, resultContinuation) {
    this._this$0_155 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__554.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__554.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__554.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          if (!this._it_6._get_views__0_k$()._editingMode)
            this._this$0_155.onComponentClick_sv8swh_k$();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__554.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__554(this._this$0_155, completion);
    i._it_6 = it;
    return i;
  };
  _no_name_provided__554.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__555($tmp0_run_0_1, $tmp4_onClick_0_23) {
    this._$tmp0_run_0_1_5 = $tmp0_run_0_1;
    this._$tmp4_onClick_0_23_0 = $tmp4_onClick_0_23;
  }
  _no_name_provided__555.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp0_run_0_1_5._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_490(this._$tmp4_onClick_0_23_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__555.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__555.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIBaseCheckBox(width, height, checked, text) {
    UIView.call(this, width, height);
    this._text_5 = text;
    var tmp = this;
    tmp._onChange = Signal_init_$Create$(null, 1, null);
    this._checked = checked;
    var tmp_0 = this;
    var tmp2_solidRect_0 = Colors_getInstance()._TRANSPARENT_BLACK;
    var tmp1_addTo_0 = new SolidRect(width, height, tmp2_solidRect_0);
    var tmp0_apply_0 = addTo(tmp1_addTo_0, this);
    Unit_getInstance();
    tmp_0._background = tmp0_apply_0;
    var tmp_1 = this;
    var tmp2_ninePatch_0 = _get_buttonNormal_(this);
    var tmp1_addTo_0_0 = new NinePatchEx(tmp2_ninePatch_0, height, height);
    var tmp0_apply_0_0 = addTo(tmp1_addTo_0_0, this);
    Unit_getInstance();
    tmp_1._box = tmp0_apply_0_0;
    var tmp_2 = this;
    var tmp2_image_0 = _get_checkBoxIcon_(this);
    var tmp1_addTo_0_1 = Image_init_$Create$_0(tmp2_image_0, 0.0, 0.0, null, false, 24, null);
    var tmp0_apply_0_1 = addTo(tmp1_addTo_0_1, this);
    Unit_getInstance();
    tmp_2._icon_4 = tmp0_apply_0_1;
    var tmp_3 = this;
    var tmp2_text_0 = this._text_5;
    var tmp3_text_0 = Companion_getInstance_212()._DEFAULT_TEXT_SIZE;
    var tmp4_text_0 = Colors_getInstance()._WHITE_0;
    var tmp5_text_0 = _get_DefaultTtfFont_();
    var tmp6_text_0 = Companion_getInstance_153()._TOP_LEFT_0;
    var tmp7_text_0 = DefaultStringTextRenderer;
    var tmp8_text_0 = Companion_getInstance_212()._DEFAULT_AUTO_SCALING;
    var tmp1_addTo_0_2 = new Text_3(tmp2_text_0, tmp3_text_0, tmp4_text_0, tmp5_text_0, tmp6_text_0, tmp7_text_0, tmp8_text_0);
    var tmp0_apply_0_2 = addTo(tmp1_addTo_0_2, this);
    Unit_getInstance();
    tmp_3._textView_0 = tmp0_apply_0_2;
    var tmp_4 = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_474(this);
    tmp_4._over$delegate = new UIObservable(false, tmp0_uiObservable_0);
    var tmp_5 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_475(this);
    tmp_5._pressing$delegate = new UIObservable(false, tmp0_uiObservable_0_0);
    this._textBounds = Companion_getInstance_35().invoke_0_k$();
    var tmp0_run_0_1 = _get_mouse_(this);
    var tmp0_onOver_0_3 = _no_name_provided_$factory_476(this, null);
    var tmp0__mouseEvent_0_1_5 = over$factory_0();
    var tmp_6 = tmp0__mouseEvent_0_1_5.get(tmp0_run_0_1);
    tmp_6.add_o72mru_k$(_no_name_provided_$factory_477(tmp0_run_0_1, tmp0_onOver_0_3));
    Unit_getInstance();
    Unit_getInstance();
    var tmp1_onOut_0_8 = _no_name_provided_$factory_478(this, null);
    var tmp0__mouseEvent_0_1_10 = out$factory_0();
    var tmp_7 = tmp0__mouseEvent_0_1_10.get(tmp0_run_0_1);
    tmp_7.add_o72mru_k$(_no_name_provided_$factory_479(tmp0_run_0_1, tmp1_onOut_0_8));
    Unit_getInstance();
    Unit_getInstance();
    var tmp2_onDown_0_13 = _no_name_provided_$factory_480(this, null);
    var tmp0__mouseEvent_0_1_15 = down$factory();
    var tmp_8 = tmp0__mouseEvent_0_1_15.get(tmp0_run_0_1);
    tmp_8.add_o72mru_k$(_no_name_provided_$factory_481(tmp0_run_0_1, tmp2_onDown_0_13));
    Unit_getInstance();
    Unit_getInstance();
    var tmp3_onUpAnywhere_0_18 = _no_name_provided_$factory_482(this, null);
    var tmp0__mouseEvent_0_1_20 = upAnywhere$factory();
    var tmp_9 = tmp0__mouseEvent_0_1_20.get(tmp0_run_0_1);
    tmp_9.add_o72mru_k$(_no_name_provided_$factory_483(tmp0_run_0_1, tmp3_onUpAnywhere_0_18));
    Unit_getInstance();
    Unit_getInstance();
    var tmp4_onClick_0_23 = _no_name_provided_$factory_484(this, null);
    var tmp0__mouseEvent_0_1_25 = click$factory();
    var tmp_10 = tmp0__mouseEvent_0_1_25.get(tmp0_run_0_1);
    tmp_10.add_o72mru_k$(_no_name_provided_$factory_485(tmp0_run_0_1, tmp4_onClick_0_23));
    Unit_getInstance();
    Unit_getInstance();
  }
  UIBaseCheckBox.prototype._set_text__a4enbm_k$ = function (_set___) {
    this._text_5 = _set___;
  };
  UIBaseCheckBox.prototype._get_text__0_k$ = function () {
    return this._text_5;
  };
  UIBaseCheckBox.prototype._get_thisAsT__0_k$ = function () {
    return this;
  };
  UIBaseCheckBox.prototype._set_checked__rpwsgn_k$ = function (value) {
    this._checked = value;
    this._onChange.invoke_iav7o_k$(this._get_thisAsT__0_k$());
  };
  UIBaseCheckBox.prototype._get_checked__0_k$ = function () {
    return this._checked;
  };
  UIBaseCheckBox.prototype.renderInternal_uxru53_k$ = function (ctx) {
    this._textView_0.setFormat_4idiqv_k$(_get_textFont_(this), numberToInt(_get_textSize_(this)), _get_textColor_(this), Companion_getInstance_153()._MIDDLE_LEFT_0);
    this._textView_0._set_text__a4enbm_k$(this._text_5);
    position(this._textView_0, this._get_height__0_k$() + 8.0, 0.0);
    Unit_getInstance();
    this._textView_0.setTextBounds_wf26y9_k$(this._textBounds);
    size_0(this._background, this._get_width__0_k$(), this._get_height__0_k$());
    Unit_getInstance();
    this._box._ninePatch_1 = this.getNinePatch_vcj5fe_k$(_get_over_(this));
    size_0(this._box, this._get_height__0_k$(), this._get_height__0_k$());
    Unit_getInstance();
    this._textBounds.setTo_i6u10_k$(0.0, 0.0, this._get_width__0_k$() - this._get_height__0_k$() - 8.0, this._get_height__0_k$());
    Unit_getInstance();
    Companion_getInstance_205().fitIconInRect_s39vyx_k$(this._icon_4, _get_checkBoxIcon_(this), this._box._width_27, this._box._height_28, Companion_getInstance_25()._MIDDLE_CENTER);
    this._icon_4._set_visible__rpwsgn_k$(this._get_checked__0_k$());
    UIView.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  UIBaseCheckBox.prototype.getNinePatch_vcj5fe_k$ = function (over) {
    return over ? _get_buttonOver_(this) : _get_buttonNormal_(this);
  };
  UIBaseCheckBox.prototype.onComponentClick_sv8swh_k$ = function () {
    this._set_checked__rpwsgn_k$(!this._get_checked__0_k$());
  };
  UIBaseCheckBox.$metadata$ = {
    simpleName: 'UIBaseCheckBox',
    kind: 'class',
    interfaces: [ViewLeaf]
  };
  function text$factory_1() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._get_text__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_text__a4enbm_k$(value);
    });
  }
  function checked$factory() {
    return getPropertyCallableRef('checked', 1, KMutableProperty1, function (receiver) {
      return receiver._get_checked__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_checked__rpwsgn_k$(value);
    });
  }
  function width$factory_0() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_width__okcceq_k$(value);
    });
  }
  function height$factory_0() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_height__okcceq_k$(value);
    });
  }
  function over$factory_0() {
    return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
      return receiver._over;
    }, null);
  }
  function out$factory_0() {
    return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
      return receiver._out_11;
    }, null);
  }
  function down$factory() {
    return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
      return receiver._down;
    }, null);
  }
  function upAnywhere$factory() {
    return getPropertyCallableRef('upAnywhere', 1, KProperty1, function (receiver) {
      return receiver._upAnywhere;
    }, null);
  }
  function click$factory() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function over$factory_1() {
    return getPropertyCallableRef('over', 1, KMutableProperty1, function (receiver) {
      return _get_over_(receiver);
    }, function (receiver_0, value) {
      return _set_over_(receiver_0, value);
    });
  }
  function over$factory_2() {
    return getPropertyCallableRef('over', 1, KMutableProperty1, function (receiver) {
      return _get_over_(receiver);
    }, function (receiver_0, value) {
      return _set_over_(receiver_0, value);
    });
  }
  function pressing$factory() {
    return getPropertyCallableRef('pressing', 1, KMutableProperty1, function (receiver) {
      return _get_pressing_(receiver);
    }, function (receiver_0, value) {
      return _set_pressing_(receiver_0, value);
    });
  }
  function pressing$factory_0() {
    return getPropertyCallableRef('pressing', 1, KMutableProperty1, function (receiver) {
      return _get_pressing_(receiver);
    }, function (receiver_0, value) {
      return _set_pressing_(receiver_0, value);
    });
  }
  function _no_name_provided_$factory_472() {
    var i = new _no_name_provided__537();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_473() {
    var i = new _no_name_provided__538();
    return function (p1) {
      i.invoke_patkcz_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_474(this$0) {
    var i = new _no_name_provided__544(this$0);
    return function (p1) {
      i.invoke_rpwsgn_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_475(this$0) {
    var i = new _no_name_provided__545(this$0);
    return function (p1) {
      i.invoke_rpwsgn_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_476(this$0, resultContinuation) {
    var i = new _no_name_provided__546(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_477($tmp0_run_0_1, $tmp0_onOver_0_3) {
    var i = new _no_name_provided__547($tmp0_run_0_1, $tmp0_onOver_0_3);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_478(this$0, resultContinuation) {
    var i = new _no_name_provided__548(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_479($tmp0_run_0_1, $tmp1_onOut_0_8) {
    var i = new _no_name_provided__549($tmp0_run_0_1, $tmp1_onOut_0_8);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_480(this$0, resultContinuation) {
    var i = new _no_name_provided__550(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_481($tmp0_run_0_1, $tmp2_onDown_0_13) {
    var i = new _no_name_provided__551($tmp0_run_0_1, $tmp2_onDown_0_13);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_482(this$0, resultContinuation) {
    var i = new _no_name_provided__552(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_483($tmp0_run_0_1, $tmp3_onUpAnywhere_0_18) {
    var i = new _no_name_provided__553($tmp0_run_0_1, $tmp3_onUpAnywhere_0_18);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_484(this$0, resultContinuation) {
    var i = new _no_name_provided__554(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_485($tmp0_run_0_1, $tmp4_onClick_0_23) {
    var i = new _no_name_provided__555($tmp0_run_0_1, $tmp4_onClick_0_23);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_486($tmp0_onOver_0_3, $it, resultContinuation) {
    var i = new _no_name_provided__539($tmp0_onOver_0_3, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_487($tmp1_onOut_0_8, $it, resultContinuation) {
    var i = new _no_name_provided__540($tmp1_onOut_0_8, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_488($tmp2_onDown_0_13, $it, resultContinuation) {
    var i = new _no_name_provided__541($tmp2_onDown_0_13, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_489($tmp3_onUpAnywhere_0_18, $it, resultContinuation) {
    var i = new _no_name_provided__542($tmp3_onUpAnywhere_0_18, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_490($tmp4_onClick_0_23, $it, resultContinuation) {
    var i = new _no_name_provided__543($tmp4_onClick_0_23, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function UIObservable(initial, observe) {
    this._initial_0 = initial;
    this._observe = observe;
    this._currentValue = this._initial_0;
  }
  UIObservable.prototype.getValue_1rt9ub_k$ = function (obj, prop) {
    return this._currentValue;
  };
  UIObservable.prototype.setValue_8gqndb_k$ = function (obj, prop, value) {
    if (!equals_1(this._currentValue, value)) {
      this._currentValue = value;
      this._observe(value);
    }};
  UIObservable.$metadata$ = {
    simpleName: 'UIObservable',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__556() {
  }
  _no_name_provided__556.prototype.invoke_0_k$ = function () {
    return UIProgressBar_init_$Create$(0.0, 0.0, 0.0, 0.0, 15, null);
  };
  _no_name_provided__556.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__557() {
  }
  _no_name_provided__557.prototype.invoke_wowuri_k$ = function ($this$null) {
    var tmp = current$factory_1();
    $this$null.add$default_8vq79r_k$(tmp, 0.0, 2, null);
    Unit_getInstance();
    var tmp_0 = maximum$factory_1();
    $this$null.add$default_8vq79r_k$(tmp_0, 0.0, 2, null);
    Unit_getInstance();
    var tmp_1 = width$factory_1();
    $this$null.add$default_8vq79r_k$(tmp_1, 0.0, 2, null);
    Unit_getInstance();
    var tmp_2 = height$factory_1();
    $this$null.add$default_8vq79r_k$(tmp_2, 0.0, 2, null);
    Unit_getInstance();
  };
  _no_name_provided__557.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_wowuri_k$(p1 instanceof KTreeSerializerExt ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__557.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIProgressBar_init_$Init$(width, height, current, maximum, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 256.0;
    if (!(($mask0 & 2) === 0))
      height = 24.0;
    if (!(($mask0 & 4) === 0))
      current = 0.0;
    if (!(($mask0 & 8) === 0))
      maximum = 100.0;
    UIProgressBar.call($this, width, height, current, maximum);
    return $this;
  }
  function UIProgressBar_init_$Create$(width, height, current, maximum, $mask0, $marker) {
    return UIProgressBar_init_$Init$(width, height, current, maximum, $mask0, $marker, Object.create(UIProgressBar.prototype));
  }
  function Serializer_1() {
    Serializer_instance_1 = this;
    var tmp = getKClass_0(UIProgressBar);
    var tmp_0 = _no_name_provided_$factory_493();
    KTreeSerializerExt.call(this, 'UIProgressBar', tmp, tmp_0, _no_name_provided_$factory_494());
  }
  Serializer_1.$metadata$ = {
    simpleName: 'Serializer',
    kind: 'object',
    interfaces: []
  };
  var Serializer_instance_1;
  function Serializer_getInstance_1() {
    if (Serializer_instance_1 == null)
      new Serializer_1();
    return Serializer_instance_1;
  }
  function _no_name_provided__558(this$0) {
    this._this$0_156 = this$0;
  }
  _no_name_provided__558.prototype.invoke_okcceq_k$ = function (it) {
    this._this$0_156.updateState_sv8swh_k$();
  };
  _no_name_provided__558.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__558.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__559(this$0) {
    this._this$0_157 = this$0;
  }
  _no_name_provided__559.prototype.invoke_okcceq_k$ = function (it) {
    this._this$0_157.updateState_sv8swh_k$();
  };
  _no_name_provided__559.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__559.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIProgressBar(width, height, current, maximum) {
    UIView.call(this, width, height);
    var tmp = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_491(this);
    tmp._current$delegate = new UIObservable(current, tmp0_uiObservable_0);
    var tmp_0 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_492(this);
    tmp_0._maximum$delegate = new UIObservable(maximum, tmp0_uiObservable_0_0);
    var tmp_1 = this;
    var tmp2_solidRect_0 = _get_buttonBackColor_(this);
    var tmp1_addTo_0 = new SolidRect(width, height, tmp2_solidRect_0);
    var tmp0_apply_0 = addTo(tmp1_addTo_0, this);
    Unit_getInstance();
    tmp_1._background_0 = tmp0_apply_0;
    var tmp_2 = this;
    var tmp2_ninePatch_0 = _get_buttonNormal_(this);
    var tmp3_ninePatch_0 = width * clamp01(current / maximum);
    var tmp1_addTo_0_0 = new NinePatchEx(tmp2_ninePatch_0, tmp3_ninePatch_0, height);
    var tmp0_apply_0_0 = addTo(tmp1_addTo_0_0, this);
    Unit_getInstance();
    tmp_2._progressView = tmp0_apply_0_0;
  }
  UIProgressBar.prototype._set_current__okcceq_k$ = function (_set___) {
    return this._current$delegate.setValue_8gqndb_k$(this, current$factory(), _set___);
  };
  UIProgressBar.prototype._get_current__0_k$ = function () {
    return this._current$delegate.getValue_1rt9ub_k$(this, current$factory_0());
  };
  UIProgressBar.prototype._set_maximum__okcceq_k$ = function (_set___) {
    return this._maximum$delegate.setValue_8gqndb_k$(this, maximum$factory(), _set___);
  };
  UIProgressBar.prototype._get_maximum__0_k$ = function () {
    return this._maximum$delegate.getValue_1rt9ub_k$(this, maximum$factory_0());
  };
  UIProgressBar.prototype._set_ratio__okcceq_k$ = function (value) {
    this._set_current__okcceq_k$(value * this._get_maximum__0_k$());
  };
  UIProgressBar.prototype._get_ratio__0_k$ = function () {
    return clamp01(this._get_current__0_k$() / this._get_maximum__0_k$());
  };
  UIProgressBar.prototype._get_progressView__0_k$ = function () {
    return this._progressView;
  };
  UIProgressBar.prototype.renderInternal_uxru53_k$ = function (ctx) {
    size_0(this._background_0, this._get_width__0_k$(), this._get_height__0_k$());
    Unit_getInstance();
    size_0(this._get_progressView__0_k$(), this._get_width__0_k$() * this._get_ratio__0_k$(), this._get_height__0_k$());
    Unit_getInstance();
    this._get_progressView__0_k$()._ninePatch_1 = _get_buttonNormal_(this);
    this._background_0._set_color__f52nlt_k$(_get_buttonBackColor_(this));
    UIView.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  UIProgressBar.$metadata$ = {
    simpleName: 'UIProgressBar',
    kind: 'class',
    interfaces: [ViewLeaf]
  };
  function current$factory() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return receiver._get_current__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_current__okcceq_k$(value);
    });
  }
  function current$factory_0() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return receiver._get_current__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_current__okcceq_k$(value);
    });
  }
  function maximum$factory() {
    return getPropertyCallableRef('maximum', 1, KMutableProperty1, function (receiver) {
      return receiver._get_maximum__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_maximum__okcceq_k$(value);
    });
  }
  function maximum$factory_0() {
    return getPropertyCallableRef('maximum', 1, KMutableProperty1, function (receiver) {
      return receiver._get_maximum__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_maximum__okcceq_k$(value);
    });
  }
  function current$factory_1() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return receiver._get_current__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_current__okcceq_k$(value);
    });
  }
  function maximum$factory_1() {
    return getPropertyCallableRef('maximum', 1, KMutableProperty1, function (receiver) {
      return receiver._get_maximum__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_maximum__okcceq_k$(value);
    });
  }
  function width$factory_1() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_width__okcceq_k$(value);
    });
  }
  function height$factory_1() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_height__okcceq_k$(value);
    });
  }
  function _no_name_provided_$factory_491(this$0) {
    var i = new _no_name_provided__558(this$0);
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_492(this$0) {
    var i = new _no_name_provided__559(this$0);
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_493() {
    var i = new _no_name_provided__556();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_494() {
    var i = new _no_name_provided__557();
    return function (p1) {
      i.invoke_wowuri_k$(p1);
      return Unit_getInstance();
    };
  }
  function _set_uiSkinBitmap_(_this_, _set___) {
    return uiSkinBitmap$delegate.setValue_d34mgx_k$(_this_, uiSkinBitmap$factory(), _set___);
  }
  function _get_uiSkinBitmap_(_this_) {
    return uiSkinBitmap$delegate.getValue_igxjej_k$(_this_, uiSkinBitmap$factory_0());
  }
  var uiSkinBitmap$delegate;
  function _set_textFont_(_this_, _set___) {
    return textFont$delegate.setValue_d34mgx_k$(_this_, textFont$factory(), _set___);
  }
  function _get_textFont_(_this_) {
    return textFont$delegate.getValue_igxjej_k$(_this_, textFont$factory_0());
  }
  var textFont$delegate;
  function _set_textSize_(_this_, _set___) {
    return textSize$delegate.setValue_d34mgx_k$(_this_, textSize$factory_0(), _set___);
  }
  function _get_textSize_(_this_) {
    return textSize$delegate.getValue_igxjej_k$(_this_, textSize$factory_1());
  }
  var textSize$delegate;
  function _set_textColor_(_this_, _set___) {
    return textColor$delegate.setValue_d34mgx_k$(_this_, textColor$factory(), new RGBA(_set___));
  }
  function _get_textColor_(_this_) {
    return textColor$delegate.getValue_igxjej_k$(_this_, textColor$factory_0())._value_19;
  }
  var textColor$delegate;
  var textAlignment$delegate;
  function _set_shadowColor_(_this_, _set___) {
    return shadowColor$delegate.setValue_d34mgx_k$(_this_, shadowColor$factory(), new RGBA(_set___));
  }
  function _get_shadowColor_(_this_) {
    return shadowColor$delegate.getValue_igxjej_k$(_this_, shadowColor$factory_0())._value_19;
  }
  var shadowColor$delegate;
  function _set_shadowPosition_(_this_, _set___) {
    return shadowPosition$delegate.setValue_d34mgx_k$(_this_, shadowPosition$factory(), _set___);
  }
  function _get_shadowPosition_(_this_) {
    return shadowPosition$delegate.getValue_igxjej_k$(_this_, shadowPosition$factory_0());
  }
  var shadowPosition$delegate;
  function _set_buttonNormal_(_this_, _set___) {
    return buttonNormal$delegate.setValue_d34mgx_k$(_this_, buttonNormal$factory(), _set___);
  }
  function _get_buttonNormal_(_this_) {
    return buttonNormal$delegate.getValue_igxjej_k$(_this_, buttonNormal$factory_0());
  }
  var buttonNormal$delegate;
  function _set_buttonOver_(_this_, _set___) {
    return buttonOver$delegate.setValue_d34mgx_k$(_this_, buttonOver$factory(), _set___);
  }
  function _get_buttonOver_(_this_) {
    return buttonOver$delegate.getValue_igxjej_k$(_this_, buttonOver$factory_0());
  }
  var buttonOver$delegate;
  function _set_buttonDown_(_this_, _set___) {
    return buttonDown$delegate.setValue_d34mgx_k$(_this_, buttonDown$factory(), _set___);
  }
  function _get_buttonDown_(_this_) {
    return buttonDown$delegate.getValue_igxjej_k$(_this_, buttonDown$factory_0());
  }
  var buttonDown$delegate;
  function _set_buttonDisabled_(_this_, _set___) {
    return buttonDisabled$delegate.setValue_d34mgx_k$(_this_, buttonDisabled$factory(), _set___);
  }
  function _get_buttonDisabled_(_this_) {
    return buttonDisabled$delegate.getValue_igxjej_k$(_this_, buttonDisabled$factory_0());
  }
  var buttonDisabled$delegate;
  var radioNormal$delegate;
  var radioOver$delegate;
  var radioDown$delegate;
  var radioDisabled$delegate;
  function _set_buttonBackColor_(_this_, _set___) {
    return buttonBackColor$delegate.setValue_d34mgx_k$(_this_, buttonBackColor$factory(), new RGBA(_set___));
  }
  function _get_buttonBackColor_(_this_) {
    return buttonBackColor$delegate.getValue_igxjej_k$(_this_, buttonBackColor$factory_0())._value_19;
  }
  var buttonBackColor$delegate;
  function _set_buttonTextAlignment_(_this_, _set___) {
    return buttonTextAlignment$delegate.setValue_d34mgx_k$(_this_, buttonTextAlignment$factory(), _set___);
  }
  function _get_buttonTextAlignment_(_this_) {
    return buttonTextAlignment$delegate.getValue_igxjej_k$(_this_, buttonTextAlignment$factory_0());
  }
  var buttonTextAlignment$delegate;
  function _set_iconCheck_(_this_, _set___) {
    return iconCheck$delegate.setValue_d34mgx_k$(_this_, iconCheck$factory(), _set___);
  }
  function _get_iconCheck_(_this_) {
    return iconCheck$delegate.getValue_igxjej_k$(_this_, iconCheck$factory_0());
  }
  var iconCheck$delegate;
  function _set_iconUp_(_this_, _set___) {
    return iconUp$delegate.setValue_d34mgx_k$(_this_, iconUp$factory(), _set___);
  }
  function _get_iconUp_(_this_) {
    return iconUp$delegate.getValue_igxjej_k$(_this_, iconUp$factory_0());
  }
  var iconUp$delegate;
  function _set_iconRight_(_this_, _set___) {
    return iconRight$delegate.setValue_d34mgx_k$(_this_, iconRight$factory(), _set___);
  }
  function _get_iconRight_(_this_) {
    return iconRight$delegate.getValue_igxjej_k$(_this_, iconRight$factory_0());
  }
  var iconRight$delegate;
  function _set_iconDown_(_this_, _set___) {
    return iconDown$delegate.setValue_d34mgx_k$(_this_, iconDown$factory(), _set___);
  }
  function _get_iconDown_(_this_) {
    return iconDown$delegate.getValue_igxjej_k$(_this_, iconDown$factory_0());
  }
  var iconDown$delegate;
  function _set_iconLeft_(_this_, _set___) {
    return iconLeft$delegate.setValue_d34mgx_k$(_this_, iconLeft$factory(), _set___);
  }
  function _get_iconLeft_(_this_) {
    return iconLeft$delegate.getValue_igxjej_k$(_this_, iconLeft$factory_0());
  }
  var iconLeft$delegate;
  var comboBoxShrinkIcon$delegate;
  var comboBoxExpandIcon$delegate;
  function _set_checkBoxIcon_(_this_, _set___) {
    return checkBoxIcon$delegate.setValue_d34mgx_k$(_this_, checkBoxIcon$factory(), _set___);
  }
  function _get_checkBoxIcon_(_this_) {
    return checkBoxIcon$delegate.getValue_igxjej_k$(_this_, checkBoxIcon$factory_0());
  }
  var checkBoxIcon$delegate;
  var scrollbarIconLeft$delegate;
  var scrollbarIconRight$delegate;
  var scrollbarIconUp$delegate;
  var scrollbarIconDown$delegate;
  function _get_DEFAULT_UI_SKIN_IMG_() {
    var tmp0_getValue_0 = DEFAULT_UI_SKIN_IMG$factory();
    return DEFAULT_UI_SKIN_IMG$delegate._get_value__0_k$();
  }
  var DEFAULT_UI_SKIN_IMG$delegate;
  function UISkinable() {
  }
  UISkinable.$metadata$ = {
    simpleName: 'UISkinable',
    kind: 'interface',
    interfaces: []
  };
  function UISkinableProperty(default_0) {
    this._default_3 = default_0;
  }
  UISkinableProperty.prototype.setValue_d34mgx_k$ = function (skin, property, value) {
    return skin.setSkinProperty_v61kqf_k$(property, value);
  };
  UISkinableProperty.prototype.getValue_igxjej_k$ = function (skin, property) {
    return getSkinProperty(skin, property, this._default_3);
  };
  UISkinableProperty.$metadata$ = {
    simpleName: 'UISkinableProperty',
    kind: 'class',
    interfaces: []
  };
  function _get_DefaultUIFont_() {
    return _get_DefaultUIVectorFont_();
  }
  function getUiIconFromSkinBitmap(_this_, index_0, kind) {
    var tmp = _get_uiSkinBitmap_(_this_);
    var tmp_0 = imul(64, kind);
    var tmp_1 = imul(64, index_0 + 1 | 0);
    return sliceWithSize$default_0(tmp, tmp_0, tmp_1, 64, 64, null, 16, null);
  }
  function getUiIconFromSkinBitmap$default(_this_, index_0, kind, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      kind = 0;
    return getUiIconFromSkinBitmap(_this_, index_0, kind);
  }
  var UiSkinKind_BUTTON_instance;
  var UiSkinKind_RADIO_instance;
  var UiSkinKind_entriesInitialized;
  function UiSkinKind_initEntries() {
    if (UiSkinKind_entriesInitialized)
      return Unit_getInstance();
    UiSkinKind_entriesInitialized = true;
    UiSkinKind_BUTTON_instance = new UiSkinKind('BUTTON', 0, 0);
    UiSkinKind_RADIO_instance = new UiSkinKind('RADIO', 1, 1);
  }
  function UiSkinKind(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this._id_32 = id;
  }
  UiSkinKind.$metadata$ = {
    simpleName: 'UiSkinKind',
    kind: 'class',
    interfaces: []
  };
  function buildDefaultButton(index_0, kind) {
    var tmp0_context2d_0 = NativeImage$default(64, 64, null, 4, null);
    tmp0_context2d_0.lock_sv8swh_k$();
    try {
      var ctx_2_1 = tmp0_context2d_0.getContext2d_vcj5fe_k$(true);
      try {
        var tmp0_subject_4 = index_0;
        var tmp;
        if (equals_1(new UiSkinType(tmp0_subject_4), new UiSkinType(Companion_getInstance_204()._NORMAL_0))) {
          tmp = new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Companion_getInstance_136().invoke_abrt0h_k$(Colors_getInstance()._DIMGREY)));
        } else if (equals_1(new UiSkinType(tmp0_subject_4), new UiSkinType(Companion_getInstance_204()._OVER))) {
          tmp = new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Companion_getInstance_136().invoke_abrt0h_k$(Colors_getInstance().get_xr0bn6_k$('#6b6b6b'))));
        } else if (equals_1(new UiSkinType(tmp0_subject_4), new UiSkinType(Companion_getInstance_204()._DOWN))) {
          tmp = new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Companion_getInstance_136().invoke_abrt0h_k$(Colors_getInstance().get_xr0bn6_k$('#4f4f4f'))));
        } else if (equals_1(new UiSkinType(tmp0_subject_4), new UiSkinType(Companion_getInstance_204()._DISABLED))) {
          tmp = new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Companion_getInstance_136().invoke_abrt0h_k$(Colors_getInstance().get_xr0bn6_k$('#494949'))));
        } else {
          throw NotImplementedError_init_$Create$(null, 1, null);
        }
        var gradient_3 = tmp;
        var tmp1_subject_6 = index_0;
        var border_5 = equals_1(new UiSkinType(tmp1_subject_6), new UiSkinType(Companion_getInstance_204()._NORMAL_0)) ? gradient_3 : equals_1(new UiSkinType(tmp1_subject_6), new UiSkinType(Companion_getInstance_204()._OVER)) ? new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Colors_getInstance().get_xr0bn6_k$('#b4b4b4'))) : equals_1(new UiSkinType(tmp1_subject_6), new UiSkinType(Companion_getInstance_204()._DOWN)) ? new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Colors_getInstance().get_xr0bn6_k$('#c8c8c8'))) : equals_1(new UiSkinType(tmp1_subject_6), new UiSkinType(Companion_getInstance_204()._DISABLED)) ? gradient_3 : new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Colors_getInstance().get_xr0bn6_k$('#3c3e3e')));
        ctx_2_1.beginPath_sv8swh_k$();
        var tmp0_stroke_0_2_7 = ctx_2_1._get_lineCap__0_k$();
        var tmp1_stroke_0_3_8 = ctx_2_1._get_lineJoin__0_k$();
        ctx_2_1.beginPath_sv8swh_k$();
        var tmp0_subject_2_4_9 = kind;
        if (tmp0_subject_2_4_9.equals(UiSkinKind_RADIO_getInstance()))
          circle(ctx_2_1, 32.0, 32.0, 28.0);
        else if (tmp0_subject_2_4_9.equals(UiSkinKind_BUTTON_getInstance()))
          roundRect_0(ctx_2_1, 4, 4, 56, 56, 6, 6);
        ctx_2_1._set_lineWidth__okcceq_k$(8.0);
        ctx_2_1._set_lineCap__li1cb3_k$(tmp0_stroke_0_2_7);
        ctx_2_1._set_lineJoin__n3bztj_k$(tmp1_stroke_0_3_8);
        ctx_2_1.stroke_y73s1i_k$(border_5);
        ctx_2_1.fill_y73s1i_k$(gradient_3);
      }finally {
        ctx_2_1.dispose_sv8swh_k$();
      }
    }finally {
      tmp0_context2d_0.unlock_ixubtt_k$(null);
      Unit_getInstance();
    }
    return tmp0_context2d_0;
  }
  function _UiSkinType___init__impl_(index_0) {
    return index_0;
  }
  function Companion_205() {
    Companion_instance_204 = this;
    this._NORMAL_0 = _UiSkinType___init__impl_(0);
    this._OVER = _UiSkinType___init__impl_(1);
    this._DOWN = _UiSkinType___init__impl_(2);
    this._DISABLED = _UiSkinType___init__impl_(3);
  }
  Companion_205.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_204;
  function Companion_getInstance_204() {
    if (Companion_instance_204 == null)
      new Companion_205();
    return Companion_instance_204;
  }
  function UiSkinType__toString_impl(this_0) {
    return '' + 'UiSkinType(index=' + this_0 + ')';
  }
  function UiSkinType__hashCode_impl(this_0) {
    return this_0;
  }
  function UiSkinType__equals_impl(this_0, other) {
    if (!(other instanceof UiSkinType))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UiSkinType ? other._index_34 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UiSkinType(index_0) {
    Companion_getInstance_204();
    this._index_34 = index_0;
  }
  UiSkinType.prototype.toString = function () {
    return UiSkinType__toString_impl(this._index_34);
  };
  UiSkinType.prototype.hashCode = function () {
    return UiSkinType__hashCode_impl(this._index_34);
  };
  UiSkinType.prototype.equals = function (other) {
    return UiSkinType__equals_impl(this._index_34, other);
  };
  UiSkinType.$metadata$ = {
    simpleName: 'UiSkinType',
    kind: 'class',
    interfaces: []
  };
  function buildDefaultShape(index_0, enabled) {
    var color_0 = Companion_getInstance_136().invoke_abrt0h_k$(enabled ? Colors_getInstance().get_xr0bn6_k$('#484848') : Colors_getInstance().get_xr0bn6_k$('#737373'));
    var lineWidth = 8.0;
    var tmp0_context2d_0 = NativeImage$default(64, 64, null, 4, null);
    tmp0_context2d_0.lock_sv8swh_k$();
    try {
      var ctx_2_1 = tmp0_context2d_0.getContext2d_vcj5fe_k$(true);
      try {
        var tmp0_subject_3 = index_0;
        if (tmp0_subject_3 === 0) {
          ctx_2_1.translate_ngl742_k$(27.0, 41.0);
          Unit_getInstance();
          ctx_2_1.rotate_ubek5g_k$(_get_degrees__0(45));
          Unit_getInstance();
          var tmp0_stroke_0_4 = LineCap_BUTT_getInstance();
          var tmp1_stroke_0_5 = ctx_2_1._get_lineJoin__0_k$();
          ctx_2_1.beginPath_sv8swh_k$();
          moveTo(ctx_2_1, -16, 0);
          lineTo(ctx_2_1, 0, 0);
          lineTo(ctx_2_1, 0, -32);
          ctx_2_1._set_lineWidth__okcceq_k$(lineWidth);
          ctx_2_1._set_lineCap__li1cb3_k$(tmp0_stroke_0_4);
          ctx_2_1._set_lineJoin__n3bztj_k$(tmp1_stroke_0_5);
          ctx_2_1.stroke_y73s1i_k$(new RGBA(color_0));
        } else {
          ctx_2_1.translate_ngl742_k$(32.0, 32.0);
          Unit_getInstance();
          ctx_2_1.rotate_ubek5g_k$(_get_degrees__0(45 + imul(90, index_0 - 1 | 0) | 0));
          Unit_getInstance();
          var offsetX_6 = -8;
          var offsetY_7 = -8;
          var lineLength_8 = 20;
          var tmp2_stroke_0_9 = LineCap_SQUARE_getInstance();
          var tmp3_stroke_0_10 = ctx_2_1._get_lineJoin__0_k$();
          ctx_2_1.beginPath_sv8swh_k$();
          line(ctx_2_1, offsetX_6 + 0 | 0, offsetY_7 + 0 | 0, offsetX_6 + 0 | 0, offsetY_7 + lineLength_8 | 0);
          line(ctx_2_1, offsetX_6 + 0 | 0, offsetY_7 + 0 | 0, offsetX_6 + lineLength_8 | 0, offsetY_7 + 0 | 0);
          ctx_2_1._set_lineWidth__okcceq_k$(lineWidth);
          ctx_2_1._set_lineCap__li1cb3_k$(tmp2_stroke_0_9);
          ctx_2_1._set_lineJoin__n3bztj_k$(tmp3_stroke_0_10);
          ctx_2_1.stroke_y73s1i_k$(new RGBA(color_0));
        }
      }finally {
        ctx_2_1.dispose_sv8swh_k$();
      }
    }finally {
      tmp0_context2d_0.unlock_ixubtt_k$(null);
      Unit_getInstance();
    }
    return tmp0_context2d_0;
  }
  function getSkinProperty(_this_, property, default_0) {
    var res = _this_.getSkinPropertyOrNull_yocrkd_k$(property);
    if (res == null) {
      var value = default_0(_this_);
      _this_.setSkinProperty_v61kqf_k$(property, value);
      return value;
    }return res;
  }
  function _get_DefaultUIVectorFont_() {
    return _get_DefaultTtfFont_();
  }
  function UISkin_init_$Init$(name, skins, parent, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      name = null;
    if (!(($mask0 & 2) === 0)) {
      skins = emptyList();
    }if (!(($mask0 & 4) === 0))
      parent = null;
    UISkin.call($this, name, skins, parent);
    return $this;
  }
  function UISkin_init_$Create$(name, skins, parent, $mask0, $marker) {
    return UISkin_init_$Init$(name, skins, parent, $mask0, $marker, Object.create(UISkin.prototype));
  }
  function UISkin(name, skins, parent) {
    this._name_42 = name;
    this._skins = skins;
    this._parent_7 = parent;
    this._skinProps = FastStringMap();
  }
  UISkin.prototype.setSkinProperty_v61kqf_k$ = function (property, value) {
    var tmp0_set_0 = this._skinProps;
    var tmp1_set_0 = property.callableName;
    tmp0_set_0.set(tmp1_set_0, value);
  };
  UISkin.prototype.getSkinPropertyOrNull_yocrkd_k$ = function (property) {
    var tmp0_get_0 = this._skinProps;
    var tmp1_get_0 = property.callableName;
    var tmp0_safe_receiver = tmp0_get_0.get(tmp1_get_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      return tmp0_safe_receiver;
    }
    Unit_getInstance();
    var tmp2_fastForEach_0 = this._skins;
    var n_1 = 0;
    while (n_1 < tmp2_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp3__anonymous__3 = tmp2_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      var tmp0_safe_receiver_4 = tmp3__anonymous__3.getSkinPropertyOrNull_yocrkd_k$(property);
      if (tmp0_safe_receiver_4 == null)
        null;
      else {
        return tmp0_safe_receiver_4;
      }
      Unit_getInstance();
    }
    var tmp1_safe_receiver = this._parent_7;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.getSkinPropertyOrNull_yocrkd_k$(property);
  };
  UISkin.prototype.toString = function () {
    return '' + 'UISkin(' + this._name_42 + ')';
  };
  UISkin.$metadata$ = {
    simpleName: 'UISkin',
    kind: 'class',
    interfaces: [UISkinable]
  };
  function _no_name_provided__560() {
  }
  _no_name_provided__560.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return _get_DEFAULT_UI_SKIN_IMG_();
  };
  _no_name_provided__560.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__560.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__561() {
  }
  _no_name_provided__561.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return _get_DefaultUIFont_();
  };
  _no_name_provided__561.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__561.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__562() {
  }
  _no_name_provided__562.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return 16.0;
  };
  _no_name_provided__562.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__562.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__563() {
  }
  _no_name_provided__563.prototype.invoke_p46fa3_k$ = function ($this$$receiver) {
    return Colors_getInstance()._WHITE_0;
  };
  _no_name_provided__563.prototype.invoke_20e8_k$ = function (p1) {
    return new RGBA(this.invoke_p46fa3_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE()));
  };
  _no_name_provided__563.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__564() {
  }
  _no_name_provided__564.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return Companion_getInstance_153()._LEFT_0;
  };
  _no_name_provided__564.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__564.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__565() {
  }
  _no_name_provided__565.prototype.invoke_p46fa3_k$ = function ($this$$receiver) {
    return RGBA__withAd_impl(Colors_getInstance()._BLACK_0, 0.3);
  };
  _no_name_provided__565.prototype.invoke_20e8_k$ = function (p1) {
    return new RGBA(this.invoke_p46fa3_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE()));
  };
  _no_name_provided__565.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__566() {
  }
  _no_name_provided__566.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return Point_init_$Create$_0(1, 1);
  };
  _no_name_provided__566.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__566.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__567() {
  }
  _no_name_provided__567.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    var tmp = _get_uiSkinBitmap_($this$$receiver);
    return asNinePatchSimple(sliceWithSize$default_0(tmp, 0, 0, 64, 64, null, 16, null), 16, 16, 48, 48);
  };
  _no_name_provided__567.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__567.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__568() {
  }
  _no_name_provided__568.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    var tmp = _get_uiSkinBitmap_($this$$receiver);
    return asNinePatchSimple(sliceWithSize$default_0(tmp, 64, 0, 64, 64, null, 16, null), 16, 16, 48, 48);
  };
  _no_name_provided__568.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__568.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__569() {
  }
  _no_name_provided__569.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    var tmp = _get_uiSkinBitmap_($this$$receiver);
    return asNinePatchSimple(sliceWithSize$default_0(tmp, 128, 0, 64, 64, null, 16, null), 16, 16, 48, 48);
  };
  _no_name_provided__569.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__569.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__570() {
  }
  _no_name_provided__570.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    var tmp = _get_uiSkinBitmap_($this$$receiver);
    return asNinePatchSimple(sliceWithSize$default_0(tmp, 192, 0, 64, 64, null, 16, null), 16, 16, 48, 48);
  };
  _no_name_provided__570.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__570.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__571() {
  }
  _no_name_provided__571.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    var tmp = _get_uiSkinBitmap_($this$$receiver);
    return asNinePatchSimple(sliceWithSize$default_0(tmp, 256, 0, 64, 64, null, 16, null), 0, 0, 64, 64);
  };
  _no_name_provided__571.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__571.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__572() {
  }
  _no_name_provided__572.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    var tmp = _get_uiSkinBitmap_($this$$receiver);
    return asNinePatchSimple(sliceWithSize$default_0(tmp, 320, 0, 64, 64, null, 16, null), 0, 0, 64, 64);
  };
  _no_name_provided__572.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__572.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__573() {
  }
  _no_name_provided__573.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    var tmp = _get_uiSkinBitmap_($this$$receiver);
    return asNinePatchSimple(sliceWithSize$default_0(tmp, 384, 0, 64, 64, null, 16, null), 0, 0, 64, 64);
  };
  _no_name_provided__573.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__573.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__574() {
  }
  _no_name_provided__574.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    var tmp = _get_uiSkinBitmap_($this$$receiver);
    return asNinePatchSimple(sliceWithSize$default_0(tmp, 448, 0, 64, 64, null, 16, null), 0, 0, 64, 64);
  };
  _no_name_provided__574.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__574.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__575() {
  }
  _no_name_provided__575.prototype.invoke_p46fa3_k$ = function ($this$$receiver) {
    return Colors_getInstance()._DARKGREY;
  };
  _no_name_provided__575.prototype.invoke_20e8_k$ = function (p1) {
    return new RGBA(this.invoke_p46fa3_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE()));
  };
  _no_name_provided__575.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__576() {
  }
  _no_name_provided__576.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return Companion_getInstance_153()._MIDDLE_CENTER_0;
  };
  _no_name_provided__576.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__576.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__577() {
  }
  _no_name_provided__577.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return getUiIconFromSkinBitmap$default($this$$receiver, 0, 0, 2, null);
  };
  _no_name_provided__577.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__577.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__578() {
  }
  _no_name_provided__578.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return getUiIconFromSkinBitmap$default($this$$receiver, 1, 0, 2, null);
  };
  _no_name_provided__578.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__578.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__579() {
  }
  _no_name_provided__579.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return getUiIconFromSkinBitmap$default($this$$receiver, 2, 0, 2, null);
  };
  _no_name_provided__579.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__579.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__580() {
  }
  _no_name_provided__580.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return getUiIconFromSkinBitmap$default($this$$receiver, 3, 0, 2, null);
  };
  _no_name_provided__580.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__580.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__581() {
  }
  _no_name_provided__581.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return getUiIconFromSkinBitmap$default($this$$receiver, 4, 0, 2, null);
  };
  _no_name_provided__581.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__581.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__582() {
  }
  _no_name_provided__582.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return _get_iconUp_($this$$receiver);
  };
  _no_name_provided__582.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__582.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__583() {
  }
  _no_name_provided__583.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return _get_iconDown_($this$$receiver);
  };
  _no_name_provided__583.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__583.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__584() {
  }
  _no_name_provided__584.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return _get_iconCheck_($this$$receiver);
  };
  _no_name_provided__584.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__584.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__585() {
  }
  _no_name_provided__585.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return _get_iconLeft_($this$$receiver);
  };
  _no_name_provided__585.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__585.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__586() {
  }
  _no_name_provided__586.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return _get_iconRight_($this$$receiver);
  };
  _no_name_provided__586.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__586.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__587() {
  }
  _no_name_provided__587.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return _get_iconUp_($this$$receiver);
  };
  _no_name_provided__587.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__587.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__588() {
  }
  _no_name_provided__588.prototype.invoke_33f72k_k$ = function ($this$$receiver) {
    return _get_iconDown_($this$$receiver);
  };
  _no_name_provided__588.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_33f72k_k$((!(p1 == null) ? isInterface(p1, UISkinable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__588.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__589() {
  }
  _no_name_provided__589.prototype.invoke_0_k$ = function () {
    var tmp0_context2d_0 = NativeImage$default(512, 512, null, 4, null);
    tmp0_context2d_0.lock_sv8swh_k$();
    try {
      var ctx_2_1 = tmp0_context2d_0.getContext2d_vcj5fe_k$(true);
      try {
        var tmp0_iterator_3 = listOf([UiSkinKind_BUTTON_getInstance(), UiSkinKind_RADIO_getInstance()]).iterator_0_k$();
        while (tmp0_iterator_3.hasNext_0_k$()) {
          var kind_4 = tmp0_iterator_3.next_0_k$();
          var inductionVariable = 0;
          if (inductionVariable < 4)
            do {
              var n_6 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0_drawImage_0_7 = buildDefaultButton(_UiSkinType___init__impl_(n_6), kind_4);
              var tmp1_drawImage_0_8 = imul(kind_4._id_32, 256) + imul(n_6, 64) | 0;
              var tmp2_drawImage_0_9 = tmp0_drawImage_0_7._width_2;
              var tmp3_drawImage_0_10 = tmp0_drawImage_0_7._height_3;
              ctx_2_1.drawImage_c2z1l2_k$(tmp0_drawImage_0_7, numberToDouble(tmp1_drawImage_0_8), 0.0, numberToDouble(tmp2_drawImage_0_9), numberToDouble(tmp3_drawImage_0_10));
            }
             while (inductionVariable < 4);
        }
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 5)
          do {
            var n_12 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp3_iterator_13 = listOf([false, true]).iterator_0_k$();
            while (tmp3_iterator_13.hasNext_0_k$()) {
              var enabled_14 = tmp3_iterator_13.next_0_k$();
              var tmp = buildDefaultShape(n_12, enabled_14);
              var tmp_0 = 64.0 * (enabled_14 ? 0 : 1);
              var tmp_1 = 64 + 64.0 * n_12;
              ctx_2_1.drawImage$default_aaejay_k$(tmp, tmp_0, tmp_1, 0.0, 0.0, 24, null);
            }
          }
           while (inductionVariable_0 < 5);
      }finally {
        ctx_2_1.dispose_sv8swh_k$();
      }
    }finally {
      tmp0_context2d_0.unlock_ixubtt_k$(null);
      Unit_getInstance();
    }
    var tmp1_also_0 = mipmaps(tmp0_context2d_0, true).toBMP32IfRequired_0_k$();
    Unit_getInstance();
    return tmp1_also_0;
  };
  _no_name_provided__589.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UiSkinKind_BUTTON_getInstance() {
    UiSkinKind_initEntries();
    return UiSkinKind_BUTTON_instance;
  }
  function UiSkinKind_RADIO_getInstance() {
    UiSkinKind_initEntries();
    return UiSkinKind_RADIO_instance;
  }
  function uiSkinBitmap$factory() {
    return getPropertyCallableRef('uiSkinBitmap', 1, KMutableProperty1, function (receiver) {
      return _get_uiSkinBitmap_(receiver);
    }, function (receiver_0, value) {
      return _set_uiSkinBitmap_(receiver_0, value);
    });
  }
  function uiSkinBitmap$factory_0() {
    return getPropertyCallableRef('uiSkinBitmap', 1, KMutableProperty1, function (receiver) {
      return _get_uiSkinBitmap_(receiver);
    }, function (receiver_0, value) {
      return _set_uiSkinBitmap_(receiver_0, value);
    });
  }
  function textFont$factory() {
    return getPropertyCallableRef('textFont', 1, KMutableProperty1, function (receiver) {
      return _get_textFont_(receiver);
    }, function (receiver_0, value) {
      return _set_textFont_(receiver_0, value);
    });
  }
  function textFont$factory_0() {
    return getPropertyCallableRef('textFont', 1, KMutableProperty1, function (receiver) {
      return _get_textFont_(receiver);
    }, function (receiver_0, value) {
      return _set_textFont_(receiver_0, value);
    });
  }
  function textSize$factory_0() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return _get_textSize_(receiver);
    }, function (receiver_0, value) {
      return _set_textSize_(receiver_0, value);
    });
  }
  function textSize$factory_1() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return _get_textSize_(receiver);
    }, function (receiver_0, value) {
      return _set_textSize_(receiver_0, value);
    });
  }
  function textColor$factory() {
    return getPropertyCallableRef('textColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(_get_textColor_(receiver));
    }, function (receiver_0, value) {
      return _set_textColor_(receiver_0, value._value_19);
    });
  }
  function textColor$factory_0() {
    return getPropertyCallableRef('textColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(_get_textColor_(receiver));
    }, function (receiver_0, value) {
      return _set_textColor_(receiver_0, value._value_19);
    });
  }
  function shadowColor$factory() {
    return getPropertyCallableRef('shadowColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(_get_shadowColor_(receiver));
    }, function (receiver_0, value) {
      return _set_shadowColor_(receiver_0, value._value_19);
    });
  }
  function shadowColor$factory_0() {
    return getPropertyCallableRef('shadowColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(_get_shadowColor_(receiver));
    }, function (receiver_0, value) {
      return _set_shadowColor_(receiver_0, value._value_19);
    });
  }
  function shadowPosition$factory() {
    return getPropertyCallableRef('shadowPosition', 1, KMutableProperty1, function (receiver) {
      return _get_shadowPosition_(receiver);
    }, function (receiver_0, value) {
      return _set_shadowPosition_(receiver_0, value);
    });
  }
  function shadowPosition$factory_0() {
    return getPropertyCallableRef('shadowPosition', 1, KMutableProperty1, function (receiver) {
      return _get_shadowPosition_(receiver);
    }, function (receiver_0, value) {
      return _set_shadowPosition_(receiver_0, value);
    });
  }
  function buttonNormal$factory() {
    return getPropertyCallableRef('buttonNormal', 1, KMutableProperty1, function (receiver) {
      return _get_buttonNormal_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonNormal_(receiver_0, value);
    });
  }
  function buttonNormal$factory_0() {
    return getPropertyCallableRef('buttonNormal', 1, KMutableProperty1, function (receiver) {
      return _get_buttonNormal_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonNormal_(receiver_0, value);
    });
  }
  function buttonOver$factory() {
    return getPropertyCallableRef('buttonOver', 1, KMutableProperty1, function (receiver) {
      return _get_buttonOver_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonOver_(receiver_0, value);
    });
  }
  function buttonOver$factory_0() {
    return getPropertyCallableRef('buttonOver', 1, KMutableProperty1, function (receiver) {
      return _get_buttonOver_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonOver_(receiver_0, value);
    });
  }
  function buttonDown$factory() {
    return getPropertyCallableRef('buttonDown', 1, KMutableProperty1, function (receiver) {
      return _get_buttonDown_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonDown_(receiver_0, value);
    });
  }
  function buttonDown$factory_0() {
    return getPropertyCallableRef('buttonDown', 1, KMutableProperty1, function (receiver) {
      return _get_buttonDown_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonDown_(receiver_0, value);
    });
  }
  function buttonDisabled$factory() {
    return getPropertyCallableRef('buttonDisabled', 1, KMutableProperty1, function (receiver) {
      return _get_buttonDisabled_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonDisabled_(receiver_0, value);
    });
  }
  function buttonDisabled$factory_0() {
    return getPropertyCallableRef('buttonDisabled', 1, KMutableProperty1, function (receiver) {
      return _get_buttonDisabled_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonDisabled_(receiver_0, value);
    });
  }
  function buttonBackColor$factory() {
    return getPropertyCallableRef('buttonBackColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(_get_buttonBackColor_(receiver));
    }, function (receiver_0, value) {
      return _set_buttonBackColor_(receiver_0, value._value_19);
    });
  }
  function buttonBackColor$factory_0() {
    return getPropertyCallableRef('buttonBackColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(_get_buttonBackColor_(receiver));
    }, function (receiver_0, value) {
      return _set_buttonBackColor_(receiver_0, value._value_19);
    });
  }
  function buttonTextAlignment$factory() {
    return getPropertyCallableRef('buttonTextAlignment', 1, KMutableProperty1, function (receiver) {
      return _get_buttonTextAlignment_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonTextAlignment_(receiver_0, value);
    });
  }
  function buttonTextAlignment$factory_0() {
    return getPropertyCallableRef('buttonTextAlignment', 1, KMutableProperty1, function (receiver) {
      return _get_buttonTextAlignment_(receiver);
    }, function (receiver_0, value) {
      return _set_buttonTextAlignment_(receiver_0, value);
    });
  }
  function iconCheck$factory() {
    return getPropertyCallableRef('iconCheck', 1, KMutableProperty1, function (receiver) {
      return _get_iconCheck_(receiver);
    }, function (receiver_0, value) {
      return _set_iconCheck_(receiver_0, value);
    });
  }
  function iconCheck$factory_0() {
    return getPropertyCallableRef('iconCheck', 1, KMutableProperty1, function (receiver) {
      return _get_iconCheck_(receiver);
    }, function (receiver_0, value) {
      return _set_iconCheck_(receiver_0, value);
    });
  }
  function iconUp$factory() {
    return getPropertyCallableRef('iconUp', 1, KMutableProperty1, function (receiver) {
      return _get_iconUp_(receiver);
    }, function (receiver_0, value) {
      return _set_iconUp_(receiver_0, value);
    });
  }
  function iconUp$factory_0() {
    return getPropertyCallableRef('iconUp', 1, KMutableProperty1, function (receiver) {
      return _get_iconUp_(receiver);
    }, function (receiver_0, value) {
      return _set_iconUp_(receiver_0, value);
    });
  }
  function iconRight$factory() {
    return getPropertyCallableRef('iconRight', 1, KMutableProperty1, function (receiver) {
      return _get_iconRight_(receiver);
    }, function (receiver_0, value) {
      return _set_iconRight_(receiver_0, value);
    });
  }
  function iconRight$factory_0() {
    return getPropertyCallableRef('iconRight', 1, KMutableProperty1, function (receiver) {
      return _get_iconRight_(receiver);
    }, function (receiver_0, value) {
      return _set_iconRight_(receiver_0, value);
    });
  }
  function iconDown$factory() {
    return getPropertyCallableRef('iconDown', 1, KMutableProperty1, function (receiver) {
      return _get_iconDown_(receiver);
    }, function (receiver_0, value) {
      return _set_iconDown_(receiver_0, value);
    });
  }
  function iconDown$factory_0() {
    return getPropertyCallableRef('iconDown', 1, KMutableProperty1, function (receiver) {
      return _get_iconDown_(receiver);
    }, function (receiver_0, value) {
      return _set_iconDown_(receiver_0, value);
    });
  }
  function iconLeft$factory() {
    return getPropertyCallableRef('iconLeft', 1, KMutableProperty1, function (receiver) {
      return _get_iconLeft_(receiver);
    }, function (receiver_0, value) {
      return _set_iconLeft_(receiver_0, value);
    });
  }
  function iconLeft$factory_0() {
    return getPropertyCallableRef('iconLeft', 1, KMutableProperty1, function (receiver) {
      return _get_iconLeft_(receiver);
    }, function (receiver_0, value) {
      return _set_iconLeft_(receiver_0, value);
    });
  }
  function checkBoxIcon$factory() {
    return getPropertyCallableRef('checkBoxIcon', 1, KMutableProperty1, function (receiver) {
      return _get_checkBoxIcon_(receiver);
    }, function (receiver_0, value) {
      return _set_checkBoxIcon_(receiver_0, value);
    });
  }
  function checkBoxIcon$factory_0() {
    return getPropertyCallableRef('checkBoxIcon', 1, KMutableProperty1, function (receiver) {
      return _get_checkBoxIcon_(receiver);
    }, function (receiver_0, value) {
      return _set_checkBoxIcon_(receiver_0, value);
    });
  }
  function DEFAULT_UI_SKIN_IMG$factory() {
    return getPropertyCallableRef('DEFAULT_UI_SKIN_IMG', 0, KProperty0, function () {
      return _get_DEFAULT_UI_SKIN_IMG_();
    }, null);
  }
  function _no_name_provided_$factory_495() {
    var i = new _no_name_provided__560();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_496() {
    var i = new _no_name_provided__561();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_497() {
    var i = new _no_name_provided__562();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_498() {
    var i = new _no_name_provided__563();
    return function (p1) {
      return new RGBA(i.invoke_p46fa3_k$(p1));
    };
  }
  function _no_name_provided_$factory_499() {
    var i = new _no_name_provided__564();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_500() {
    var i = new _no_name_provided__565();
    return function (p1) {
      return new RGBA(i.invoke_p46fa3_k$(p1));
    };
  }
  function _no_name_provided_$factory_501() {
    var i = new _no_name_provided__566();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_502() {
    var i = new _no_name_provided__567();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_503() {
    var i = new _no_name_provided__568();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_504() {
    var i = new _no_name_provided__569();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_505() {
    var i = new _no_name_provided__570();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_506() {
    var i = new _no_name_provided__571();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_507() {
    var i = new _no_name_provided__572();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_508() {
    var i = new _no_name_provided__573();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_509() {
    var i = new _no_name_provided__574();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_510() {
    var i = new _no_name_provided__575();
    return function (p1) {
      return new RGBA(i.invoke_p46fa3_k$(p1));
    };
  }
  function _no_name_provided_$factory_511() {
    var i = new _no_name_provided__576();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_512() {
    var i = new _no_name_provided__577();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_513() {
    var i = new _no_name_provided__578();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_514() {
    var i = new _no_name_provided__579();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_515() {
    var i = new _no_name_provided__580();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_516() {
    var i = new _no_name_provided__581();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_517() {
    var i = new _no_name_provided__582();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_518() {
    var i = new _no_name_provided__583();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_519() {
    var i = new _no_name_provided__584();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_520() {
    var i = new _no_name_provided__585();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_521() {
    var i = new _no_name_provided__586();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_522() {
    var i = new _no_name_provided__587();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_523() {
    var i = new _no_name_provided__588();
    return function (p1) {
      return i.invoke_33f72k_k$(p1);
    };
  }
  function _no_name_provided_$factory_524() {
    var i = new _no_name_provided__589();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _get__defaultUiSkin_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = _defaultUiSkin$factory();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = _defaultUiSkin$delegate._name_0;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = _defaultUiSkin$delegate._defaultGen();
        var tmp0_elvis_lhs_1_7 = _defaultUiSkin$delegate._name_0;
        var tmp_0 = tmp0_elvis_lhs_1_7 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_1_7;
        setExtra(_this_, tmp_0, r_6);
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var _defaultUiSkin$delegate;
  function _set_uiSkin_(_this_, _set___) {
    var tmp0_setValue_0 = uiSkin$factory();
    var tmp0_elvis_lhs_1 = uiSkin$delegate._name_0;
    var tmp = tmp0_elvis_lhs_1 == null ? tmp0_setValue_0.callableName : tmp0_elvis_lhs_1;
    return setExtra(_this_, tmp, _set___);
  }
  function _get_uiSkin_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = uiSkin$factory_0();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = uiSkin$delegate._name_0;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = uiSkin$delegate._defaultGen();
        var tmp0_elvis_lhs_1_7 = uiSkin$delegate._name_0;
        var tmp_0 = tmp0_elvis_lhs_1_7 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_1_7;
        setExtra(_this_, tmp_0, r_6);
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var uiSkin$delegate;
  function registerUISupportOnce($this) {
    if ($this._registered)
      return Unit_getInstance();
    var tmp0_elvis_lhs = $this._get_stage__0_k$();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stage = tmp;
    $this._registered = true;
    if (equals_1(getExtra(stage, 'uiSupport'), true))
      return Unit_getInstance();
    setExtra(stage, 'uiSupport', true);
    var tmp0_run_0_1 = _get_keys_(stage);
    Unit_getInstance();
    var tmp3_getOrCreateComponent_0_1 = stage._get_componentsSure__0_k$();
    var tmp4_getOrCreateComponent_0_2 = getKClass_0(DummyUpdateComponentWithViews);
    var tmp1_getOrCreateComponent_0_4 = tmp3_getOrCreateComponent_0_1._get_eupdateWV__0_k$();
    var component_1_5 = tmp3_getOrCreateComponent_0_1.findFirstComponentOfType_3uvto2_k$(tmp1_getOrCreateComponent_0_4, tmp4_getOrCreateComponent_0_2);
    if (component_1_5 == null) {
      component_1_5 = new DummyUpdateComponentWithViews(stage);
      var tmp0_plusAssign_0_6 = component_1_5;
      tmp1_getOrCreateComponent_0_4.add_2bq_k$(tmp0_plusAssign_0_6);
      Unit_getInstance();
    }var tmp2_fastCastTo_0_3 = component_1_5;
    Unit_getInstance();
  }
  function Companion_206() {
    Companion_instance_205 = this;
  }
  Companion_206.prototype.fitIconInRect_s39vyx_k$ = function (iconView, bmp, width, height, anchor_2) {
    var iconScaleX = width / bmp._get_width__0_k$();
    var iconScaleY = height / bmp._get_height__0_k$();
    var iconScale = Math.min(iconScaleX, iconScaleY);
    iconView._set_bitmap__5a5lwo_k$(bmp);
    anchor_0(iconView, anchor_2);
    Unit_getInstance();
    position(iconView, width * anchor_2._sx, height * anchor_2._sy);
    Unit_getInstance();
    scale_0(iconView, iconScale, iconScale);
    Unit_getInstance();
  };
  Companion_206.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_205;
  function Companion_getInstance_205() {
    if (Companion_instance_205 == null)
      new Companion_206();
    return Companion_instance_205;
  }
  function _no_name_provided__590(this$0) {
    this._this$0_158 = this$0;
  }
  _no_name_provided__590.prototype.invoke_okcceq_k$ = function (it) {
    this._this$0_158.onSizeChanged_sv8swh_k$();
  };
  _no_name_provided__590.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__590.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__591(this$0) {
    this._this$0_159 = this$0;
  }
  _no_name_provided__591.prototype.invoke_okcceq_k$ = function (it) {
    this._this$0_159.onSizeChanged_sv8swh_k$();
  };
  _no_name_provided__591.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__591.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIView(width, height) {
    Companion_getInstance_205();
    FixedSizeContainer_init_$Init$(width, height, false, 4, null, this);
    this._skinProps_0 = FastStringMap();
    var tmp = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_527(this);
    tmp._width$delegate = new UIObservable(width, tmp0_uiObservable_0);
    var tmp_0 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_528(this);
    tmp_0._height$delegate = new UIObservable(height, tmp0_uiObservable_0_0);
    this._registered = false;
  }
  UIView.prototype.setSkinProperty_v61kqf_k$ = function (property, value) {
    var tmp0_set_0 = this._skinProps_0;
    var tmp1_set_0 = property.callableName;
    tmp0_set_0.set(tmp1_set_0, value);
  };
  UIView.prototype.getSkinPropertyOrNull_yocrkd_k$ = function (property) {
    var tmp0_get_0 = this._skinProps_0;
    var tmp1_get_0 = property.callableName;
    var tmp = tmp0_get_0.get(tmp1_get_0);
    var tmp0_elvis_lhs = (tmp == null ? true : isObject(tmp)) ? tmp : null;
    return tmp0_elvis_lhs == null ? _get_realUiSkin_(this).getSkinPropertyOrNull_yocrkd_k$(property) : tmp0_elvis_lhs;
  };
  UIView.prototype._set_width__okcceq_k$ = function (_set___) {
    return this._width$delegate.setValue_8gqndb_k$(this, width$factory_2(), _set___);
  };
  UIView.prototype._get_width__0_k$ = function () {
    return this._width$delegate.getValue_1rt9ub_k$(this, width$factory_3());
  };
  UIView.prototype._set_height__okcceq_k$ = function (_set___) {
    return this._height$delegate.setValue_8gqndb_k$(this, height$factory_2(), _set___);
  };
  UIView.prototype._get_height__0_k$ = function () {
    return this._height$delegate.getValue_1rt9ub_k$(this, height$factory_3());
  };
  UIView.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    out.setTo_i6u10_k$(0.0, 0.0, this._get_width__0_k$(), this._get_height__0_k$());
    Unit_getInstance();
  };
  UIView.prototype._set_enabled__rpwsgn_k$ = function (value) {
    this._set_mouseEnabled__rpwsgn_k$(value);
    this.updateState_sv8swh_k$();
  };
  UIView.prototype._get_enabled__0_k$ = function () {
    return this._get_mouseEnabled__0_k$();
  };
  UIView.prototype.onSizeChanged_sv8swh_k$ = function () {
  };
  UIView.prototype.updateState_sv8swh_k$ = function () {
  };
  UIView.prototype.renderInternal_uxru53_k$ = function (ctx) {
    registerUISupportOnce(this);
    FixedSizeContainer.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  UIView.$metadata$ = {
    simpleName: 'UIView',
    kind: 'class',
    interfaces: [UISkinable]
  };
  function _get_realUiSkin_(_this_) {
    var tmp1_elvis_lhs = _get_uiSkin_(_this_);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = _this_._get_parent__0_k$();
      tmp = tmp0_safe_receiver == null ? null : _get_realUiSkin_(tmp0_safe_receiver);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? _get__defaultUiSkin_(_this_._get_root__0_k$()) : tmp2_elvis_lhs;
  }
  function DummyUpdateComponentWithViews(view) {
    this._view_10 = view;
  }
  DummyUpdateComponentWithViews.prototype._get_view__0_k$ = function () {
    return this._view_10;
  };
  DummyUpdateComponentWithViews.prototype.update_2el4wj_k$ = function (views_0, dt) {
  };
  DummyUpdateComponentWithViews.$metadata$ = {
    simpleName: 'DummyUpdateComponentWithViews',
    kind: 'class',
    interfaces: [UpdateComponentWithViews]
  };
  function _no_name_provided__592() {
  }
  _no_name_provided__592.prototype.invoke_0_k$ = function () {
    var tmp0_apply_0_1 = UISkin_init_$Create$('defaultUiSkin', null, null, 6, null);
    Unit_getInstance();
    return tmp0_apply_0_1;
  };
  _no_name_provided__592.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__593() {
  }
  _no_name_provided__593.prototype.invoke_0_k$ = function () {
    return null;
  };
  _no_name_provided__593.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _defaultUiSkin$factory() {
    return getPropertyCallableRef('_defaultUiSkin', 1, KProperty1, function (receiver) {
      return _get__defaultUiSkin_(receiver);
    }, null);
  }
  function uiSkin$factory() {
    return getPropertyCallableRef('uiSkin', 1, KMutableProperty1, function (receiver) {
      return _get_uiSkin_(receiver);
    }, function (receiver_0, value) {
      return _set_uiSkin_(receiver_0, value);
    });
  }
  function uiSkin$factory_0() {
    return getPropertyCallableRef('uiSkin', 1, KMutableProperty1, function (receiver) {
      return _get_uiSkin_(receiver);
    }, function (receiver_0, value) {
      return _set_uiSkin_(receiver_0, value);
    });
  }
  function width$factory_2() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_width__okcceq_k$(value);
    });
  }
  function width$factory_3() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_width__okcceq_k$(value);
    });
  }
  function height$factory_2() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_height__okcceq_k$(value);
    });
  }
  function height$factory_3() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_height__okcceq_k$(value);
    });
  }
  function _no_name_provided_$factory_525() {
    var i = new _no_name_provided__592();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_526() {
    var i = new _no_name_provided__593();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_527(this$0) {
    var i = new _no_name_provided__590(this$0);
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_528(this$0) {
    var i = new _no_name_provided__591(this$0);
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _defaultUiSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_525();
    return new Property(null, tmp0_extraProperty_0);
  }
  function uiSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_526();
    return new Property(null, tmp0_extraProperty_0);
  }
  var koruiComponent$delegate;
  function _no_name_provided__594() {
  }
  _no_name_provided__594.prototype.invoke_upazaj_k$ = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__594.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_upazaj_k$(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__594.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_529() {
    var i = new _no_name_provided__594();
    return function (p1) {
      return i.invoke_upazaj_k$(p1);
    };
  }
  function CancellableGroup() {
    var tmp = this;
    tmp._cancellables_0 = ArrayList_init_$Create$();
  }
  CancellableGroup.prototype.cancel_1ti8hr_k$ = function (e) {
    cancel_1(this._cancellables_0, e);
  };
  CancellableGroup.$metadata$ = {
    simpleName: 'CancellableGroup',
    kind: 'class',
    interfaces: [Cancellable]
  };
  function anchor(_this_, ax, ay) {
    return anchor_1(_this_, ax, ay);
  }
  function Anchorable() {
  }
  Anchorable.$metadata$ = {
    simpleName: 'Anchorable',
    kind: 'interface',
    interfaces: []
  };
  function anchor_0(_this_, anchor_2) {
    return anchor_1(_this_, anchor_2._sx, anchor_2._sy);
  }
  function anchor_1(_this_, ax, ay) {
    _this_._set_anchorX__okcceq_k$(ax);
    _this_._set_anchorY__okcceq_k$(ay);
    return _this_;
  }
  function $forceLoadSourceFileCOROUTINE$31(_this_, views_0, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__196 = _this_;
    this._views_12 = views_0;
    this._currentVfs_2 = currentVfs;
    this._sourceFile_2 = sourceFile;
  }
  $forceLoadSourceFileCOROUTINE$31.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__196.baseForceLoadSourceFile_z71c2l_k$(this.__this__196, this._views_12, this._currentVfs_2, this._sourceFile_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this.__this__196.removeChildren_sv8swh_k$();
            this._state_1 = 2;
            suspendResult = readAnimation(this._currentVfs_2.get_6wfw3l_k$('' + this._sourceFile_2), this._views_12, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT.createMainTimeLine_0_k$();
            this.__this__196.addChild_4l6ao4_k$(ARGUMENT_0);
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadSourceFileCOROUTINE$31.$metadata$ = {
    simpleName: '$forceLoadSourceFileCOROUTINE$31',
    kind: 'class',
    interfaces: []
  };
  function AnimationViewRef() {
    Container.call(this);
    this._$$delegate_0_44 = new Mixin_3();
  }
  AnimationViewRef.prototype.lazyLoadRenderInternal_hk6fpn_k$ = function (ctx, view) {
    this._$$delegate_0_44.lazyLoadRenderInternal_hk6fpn_k$(ctx, view);
  };
  AnimationViewRef.prototype._set_sourceFile__qlpr75_k$ = function (_set___) {
    this._$$delegate_0_44._set_sourceFile__qlpr75_k$(_set___);
  };
  AnimationViewRef.prototype._set_sourceTreeLoaded__rpwsgn_k$ = function (_set___) {
    this._$$delegate_0_44._sourceTreeLoaded = _set___;
  };
  AnimationViewRef.prototype.baseForceLoadSourceFile_z71c2l_k$ = function (_this__0, views_0, currentVfs, sourceFile, $cont) {
    return this._$$delegate_0_44.baseForceLoadSourceFile_z71c2l_k$(_this__0, views_0, currentVfs, sourceFile, $cont);
  };
  AnimationViewRef.prototype.forceLoadSourceFile_mwdcj_k$ = function (views_0, currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadSourceFileCOROUTINE$31(this, views_0, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  AnimationViewRef.prototype.renderInternal_uxru53_k$ = function (ctx) {
    this.lazyLoadRenderInternal_hk6fpn_k$(ctx, this);
    Container.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  AnimationViewRef.$metadata$ = {
    simpleName: 'AnimationViewRef',
    kind: 'class',
    interfaces: [ViewLeaf, ViewFileRef]
  };
  function BView() {
  }
  BView.$metadata$ = {
    simpleName: 'BView',
    kind: 'interface',
    interfaces: []
  };
  function createImage($this, width, height) {
    var tmp;
    if ($this._useNativeRendering) {
      tmp = NativeImage$default(width, height, null, 4, null);
    } else {
      tmp = Bitmap32_init_$Create$(width, height, null, true, 4, null);
    }
    return tmp;
  }
  function BaseGraphics(autoScaling) {
    var tmp0__get_transparent__0 = Bitmaps_getInstance();
    BaseImage_init_$Init$(Bitmaps_transparent, 0.0, 0.0, null, false, 30, null, this);
    this._autoScaling = autoScaling;
    this._useNativeRendering = true;
    var tmp = this;
    tmp._bitmapsToRemove = ArrayList_init_$Create$();
    this._autoscaling = new InternalViewAutoscaling();
    this._dirty_3 = true;
    this._bb_0 = new BoundsBuilder();
    this._bounds_14 = Companion_getInstance_35().invoke_0_k$();
  }
  BaseGraphics.prototype._get_bwidth__0_k$ = function () {
    return this._get_bitmap__0_k$()._get_width__0_k$() / this._autoscaling._renderedAtScaleX;
  };
  BaseGraphics.prototype._get_bheight__0_k$ = function () {
    return this._get_bitmap__0_k$()._get_height__0_k$() / this._autoscaling._renderedAtScaleY;
  };
  BaseGraphics.prototype._set_dirty__rpwsgn_k$ = function (_set___) {
    this._dirty_3 = _set___;
  };
  BaseGraphics.prototype.renderInternal_uxru53_k$ = function (ctx) {
    var tmp0_fastForEach_0 = this._bitmapsToRemove;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      ctx._agBitmapTextureManager.removeBitmap_dwbv7a_k$(tmp1__anonymous__3);
    }
    this._bitmapsToRemove.clear_sv8swh_k$();
    this.redrawIfRequired_sv8swh_k$();
    BaseImage.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  BaseGraphics.prototype.redrawIfRequired_sv8swh_k$ = function () {
    if (this._autoscaling.onRender_2oo7xy_k$(this._autoScaling, this._get_globalMatrix__0_k$())) {
      this._dirty_3 = true;
    }if (this._dirty_3) {
      this._dirty_3 = false;
      this.getLocalBoundsInternalNoAnchor_wf26y9_k$(this._bounds_14);
      this._bitmapsToRemove.add_2bq_k$(this._get_bitmap__0_k$()._bmpBase);
      Unit_getInstance();
      var image_2 = createImage(this, coerceAtLeast(toIntCeil(this._bounds_14._width_0 * this._autoscaling._renderedAtScaleX), 1) + 1 | 0, coerceAtLeast(toIntCeil(this._bounds_14._height_0 * this._autoscaling._renderedAtScaleY), 1) + 1 | 0);
      image_2.lock_sv8swh_k$();
      try {
        var ctx_2_1_3 = image_2.getContext2d_vcj5fe_k$(true);
        try {
          ctx_2_1_3.scale_ngl742_k$(this._autoscaling._renderedAtScaleX, this._autoscaling._renderedAtScaleY);
          Unit_getInstance();
          ctx_2_1_3.translate_ngl742_k$(-this._bounds_14._x_2, -this._bounds_14._y_2);
          Unit_getInstance();
          this.drawShape_h81jc_k$(ctx_2_1_3);
        }finally {
          ctx_2_1_3.dispose_sv8swh_k$();
        }
      }finally {
        image_2.unlock_ixubtt_k$(null);
        Unit_getInstance();
      }
      Unit_getInstance();
      this._set_bitmap__5a5lwo_k$(slice$default(image_2, null, null, 3, null));
    }};
  BaseGraphics.prototype._get_sLeft__0_k$ = function () {
    var out = this._bounds_14._x_2 - this._get_anchorDispX__0_k$();
    if (this._get_bwidth__0_k$() < 0.0)
      out = out - this._get_bwidth__0_k$();
    return out;
  };
  BaseGraphics.prototype._get_sTop__0_k$ = function () {
    var out = this._bounds_14._y_2 - this._get_anchorDispY__0_k$();
    if (this._get_bheight__0_k$() < 0.0)
      out = out - this._get_bheight__0_k$();
    return out;
  };
  BaseGraphics.prototype.getLocalBoundsInternalNoAnchor_wf26y9_k$ = function (out) {
    this._bb_0.reset_sv8swh_k$();
    this.getShapeBounds_j4ilx6_k$(this._bb_0);
    this._bb_0.getBounds_uebyw0_k$(out);
    Unit_getInstance();
  };
  BaseGraphics.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    this.getLocalBoundsInternalNoAnchor_wf26y9_k$(out);
    out.displace_ngl742_k$(-this._get_anchorDispX__0_k$(), -this._get_anchorDispY__0_k$());
    Unit_getInstance();
  };
  BaseGraphics.$metadata$ = {
    simpleName: 'BaseGraphics',
    kind: 'class',
    interfaces: []
  };
  var BlendMode_INHERIT_instance;
  var BlendMode_NONE_instance;
  var BlendMode_NORMAL_instance_0;
  var BlendMode_ADD_instance;
  var BlendMode_MULTIPLY_instance_0;
  var BlendMode_SCREEN_instance_0;
  var BlendMode_ERASE_instance;
  var BlendMode_MASK_instance;
  var BlendMode_BELOW_instance;
  var BlendMode_SUBTRACT_instance_0;
  var BlendMode_INVERT_instance;
  var BlendMode_LIGHTEN_instance_0;
  var BlendMode_DARKEN_instance_0;
  var BlendMode_DIFFERENCE_instance_0;
  var BlendMode_ALPHA_instance;
  var BlendMode_HARDLIGHT_instance;
  function Companion_207() {
    Companion_instance_206 = this;
    this._OVERLAY = BlendMode_NORMAL_getInstance_0();
    var tmp = this;
    var tmp0_associateBy_0 = values_20();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_1q9pf_k$(element_2_4._get_ordinal__0_k$(), element_2_4);
      Unit_getInstance();
    }
    tmp._BY_ORDINAL = tmp0_associateByTo_0_2;
    var tmp_0 = this;
    var tmp0_associateBy_0_0 = values_20();
    var capacity_1_0 = coerceAtLeast(mapCapacity(tmp0_associateBy_0_0.length), 16);
    var tmp0_associateByTo_0_2_0 = LinkedHashMap_init_$Create$_1(capacity_1_0);
    var indexedObject_0 = tmp0_associateBy_0_0;
    var inductionVariable_0 = 0;
    var last_2 = indexedObject_0.length;
    while (inductionVariable_0 < last_2) {
      var element_2_4_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      tmp0_associateByTo_0_2_0.put_1q9pf_k$(element_2_4_0._get_name__0_k$(), element_2_4_0);
      Unit_getInstance();
    }
    tmp_0._BY_NAME_0 = tmp0_associateByTo_0_2_0;
  }
  Companion_207.prototype.get_6wfw3l_k$ = function (name) {
    var tmp0_elvis_lhs = this._BY_NAME_0.get_2bw_k$(name.toUpperCase());
    return tmp0_elvis_lhs == null ? BlendMode_INHERIT_getInstance() : tmp0_elvis_lhs;
  };
  Companion_207.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_206;
  function Companion_getInstance_206() {
    if (Companion_instance_206 == null)
      new Companion_207();
    return Companion_instance_206;
  }
  function values_20() {
    return [BlendMode_INHERIT_getInstance(), BlendMode_NONE_getInstance(), BlendMode_NORMAL_getInstance_0(), BlendMode_ADD_getInstance(), BlendMode_MULTIPLY_getInstance_0(), BlendMode_SCREEN_getInstance_0(), BlendMode_ERASE_getInstance(), BlendMode_MASK_getInstance(), BlendMode_BELOW_getInstance(), BlendMode_SUBTRACT_getInstance(), BlendMode_INVERT_getInstance(), BlendMode_LIGHTEN_getInstance_0(), BlendMode_DARKEN_getInstance_0(), BlendMode_DIFFERENCE_getInstance_0(), BlendMode_ALPHA_getInstance(), BlendMode_HARDLIGHT_getInstance()];
  }
  var BlendMode_entriesInitialized_0;
  function BlendMode_initEntries_0() {
    if (BlendMode_entriesInitialized_0)
      return Unit_getInstance();
    BlendMode_entriesInitialized_0 = true;
    BlendMode_INHERIT_instance = new BlendMode_0('INHERIT', 0, Companion_getInstance_163()._NORMAL);
    var tmp = BlendFactor_ONE_getInstance();
    var tmp_0 = BlendFactor_ZERO_getInstance();
    BlendMode_NONE_instance = new BlendMode_0('NONE', 1, Blending_init_$Create$_0(tmp, tmp_0, null, 4, null));
    BlendMode_NORMAL_instance_0 = new BlendMode_0('NORMAL', 2, Companion_getInstance_163()._NORMAL);
    BlendMode_ADD_instance = new BlendMode_0('ADD', 3, Companion_getInstance_163()._ADD);
    var tmp_1 = BlendFactor_DESTINATION_COLOR_getInstance();
    var tmp_2 = BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance();
    BlendMode_MULTIPLY_instance_0 = new BlendMode_0('MULTIPLY', 4, Blending_init_$Create$_0(tmp_1, tmp_2, null, 4, null));
    var tmp_3 = BlendFactor_ONE_getInstance();
    var tmp_4 = BlendFactor_ONE_MINUS_SOURCE_COLOR_getInstance();
    BlendMode_SCREEN_instance_0 = new BlendMode_0('SCREEN', 5, Blending_init_$Create$_0(tmp_3, tmp_4, null, 4, null));
    var tmp_5 = BlendFactor_ZERO_getInstance();
    var tmp_6 = BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance();
    BlendMode_ERASE_instance = new BlendMode_0('ERASE', 6, Blending_init_$Create$_0(tmp_5, tmp_6, null, 4, null));
    var tmp_7 = BlendFactor_ZERO_getInstance();
    var tmp_8 = BlendFactor_SOURCE_ALPHA_getInstance();
    BlendMode_MASK_instance = new BlendMode_0('MASK', 7, Blending_init_$Create$_0(tmp_7, tmp_8, null, 4, null));
    var tmp_9 = BlendFactor_ONE_MINUS_DESTINATION_ALPHA_getInstance();
    var tmp_10 = BlendFactor_DESTINATION_ALPHA_getInstance();
    BlendMode_BELOW_instance = new BlendMode_0('BELOW', 8, Blending_init_$Create$_0(tmp_9, tmp_10, null, 4, null));
    var tmp_11 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_12 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_13 = BlendFactor_ONE_getInstance();
    var tmp_14 = BlendFactor_ONE_getInstance();
    var tmp_15 = BlendEquation_REVERSE_SUBTRACT_getInstance();
    BlendMode_SUBTRACT_instance_0 = new BlendMode_0('SUBTRACT', 9, Blending_init_$Create$(tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, null, 32, null));
    var tmp_16 = BlendFactor_ONE_MINUS_DESTINATION_COLOR_getInstance();
    var tmp_17 = BlendFactor_ZERO_getInstance();
    BlendMode_INVERT_instance = new BlendMode_0('INVERT', 10, Blending_init_$Create$_0(tmp_16, tmp_17, null, 4, null));
    var tmp_18 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_19 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_20 = BlendFactor_ONE_getInstance();
    var tmp_21 = BlendFactor_ONE_getInstance();
    BlendMode_LIGHTEN_instance_0 = new BlendMode_0('LIGHTEN', 11, Blending_init_$Create$(tmp_18, tmp_19, tmp_20, tmp_21, null, null, 48, null));
    var tmp_22 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_23 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_24 = BlendFactor_ONE_getInstance();
    var tmp_25 = BlendFactor_ONE_getInstance();
    BlendMode_DARKEN_instance_0 = new BlendMode_0('DARKEN', 12, Blending_init_$Create$(tmp_22, tmp_23, tmp_24, tmp_25, null, null, 48, null));
    var tmp_26 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_27 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_28 = BlendFactor_ONE_getInstance();
    var tmp_29 = BlendFactor_ONE_getInstance();
    BlendMode_DIFFERENCE_instance_0 = new BlendMode_0('DIFFERENCE', 13, Blending_init_$Create$(tmp_26, tmp_27, tmp_28, tmp_29, null, null, 48, null));
    var tmp_30 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_31 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_32 = BlendFactor_ONE_getInstance();
    var tmp_33 = BlendFactor_ONE_getInstance();
    BlendMode_ALPHA_instance = new BlendMode_0('ALPHA', 14, Blending_init_$Create$(tmp_30, tmp_31, tmp_32, tmp_33, null, null, 48, null));
    var tmp_34 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_35 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_36 = BlendFactor_ONE_getInstance();
    var tmp_37 = BlendFactor_ONE_getInstance();
    BlendMode_HARDLIGHT_instance = new BlendMode_0('HARDLIGHT', 15, Blending_init_$Create$(tmp_34, tmp_35, tmp_36, tmp_37, null, null, 48, null));
    Companion_getInstance_206();
  }
  function BlendMode_0(name, ordinal, factors) {
    Enum.call(this, name, ordinal);
    this._factors = factors;
  }
  BlendMode_0.$metadata$ = {
    simpleName: 'BlendMode',
    kind: 'class',
    interfaces: []
  };
  function BlendMode_INHERIT_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_INHERIT_instance;
  }
  function BlendMode_NONE_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_NONE_instance;
  }
  function BlendMode_NORMAL_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_NORMAL_instance_0;
  }
  function BlendMode_ADD_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_ADD_instance;
  }
  function BlendMode_MULTIPLY_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_MULTIPLY_instance_0;
  }
  function BlendMode_SCREEN_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_SCREEN_instance_0;
  }
  function BlendMode_ERASE_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_ERASE_instance;
  }
  function BlendMode_MASK_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_MASK_instance;
  }
  function BlendMode_BELOW_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_BELOW_instance;
  }
  function BlendMode_SUBTRACT_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_SUBTRACT_instance_0;
  }
  function BlendMode_INVERT_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_INVERT_instance;
  }
  function BlendMode_LIGHTEN_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_LIGHTEN_instance_0;
  }
  function BlendMode_DARKEN_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_DARKEN_instance_0;
  }
  function BlendMode_DIFFERENCE_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_DIFFERENCE_instance_0;
  }
  function BlendMode_ALPHA_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_ALPHA_instance;
  }
  function BlendMode_HARDLIGHT_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_HARDLIGHT_instance;
  }
  function Container() {
    View.call(this, true);
    this.___children = FastArrayList_init_$Create$();
    var tmp = this;
    tmp._tempMatrix_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._bb_1 = new BoundsBuilder();
    this._tempRect_5 = Companion_getInstance_35().invoke_0_k$();
  }
  Container.prototype._get__children__0_k$ = function () {
    return this.___children;
  };
  Container.prototype._get_childrenInternal__0_k$ = function () {
    return ensureNotNull(this.___children);
  };
  Container.prototype._get_children__0_k$ = function () {
    return this.___children;
  };
  Container.prototype.invalidate_sv8swh_k$ = function () {
    View.prototype.invalidate_sv8swh_k$.call(this);
    var tmp0_fastForEach_0_1 = this.___children;
    var array_1_2 = tmp0_fastForEach_0_1._array_4;
    var n_2_3 = 0;
    while (n_2_3 < array_1_2.length) {
      var tmp0_4_6 = n_2_3;
      n_2_3 = tmp0_4_6 + 1 | 0;
      var tmp0_unsafeCast_0_3_5 = array_1_2[tmp0_4_6];
      var tmp1__anonymous__5_4 = tmp0_unsafeCast_0_3_5;
      if (tmp1__anonymous__5_4.__requireInvalidate) {
        tmp1__anonymous__5_4.invalidate_sv8swh_k$();
      }}
  };
  Container.prototype.invalidateColorTransform_sv8swh_k$ = function () {
    View.prototype.invalidateColorTransform_sv8swh_k$.call(this);
    var tmp0_fastForEach_0_1 = this.___children;
    var array_1_2 = tmp0_fastForEach_0_1._array_4;
    var n_2_3 = 0;
    while (n_2_3 < array_1_2.length) {
      var tmp0_4_6 = n_2_3;
      n_2_3 = tmp0_4_6 + 1 | 0;
      var tmp0_unsafeCast_0_3_5 = array_1_2[tmp0_4_6];
      var tmp1__anonymous__5_4 = tmp0_unsafeCast_0_3_5;
      if (tmp1__anonymous__5_4.__requireInvalidateColor) {
        tmp1__anonymous__5_4.invalidateColorTransform_sv8swh_k$();
      }}
  };
  Container.prototype._get_numChildren__0_k$ = function () {
    var children_0 = this._get__children__0_k$();
    if (children_0 == null)
      return 0;
    return children_0._get_size__0_k$();
  };
  Container.prototype.addChildAt_c0r4ud_k$ = function (view, index_0) {
    view.removeFromParent_sv8swh_k$();
    var aindex = clamp_2(index_0, 0, this._get_numChildren__0_k$());
    view._set_index__majfzk_k$(aindex);
    var children_0 = this._get_childrenInternal__0_k$();
    children_0.add_vz2mgm_k$(aindex, view);
    var inductionVariable = aindex + 1 | 0;
    var last_1 = children_0._get_size__0_k$();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children_0.get_ha5a7z_k$(n)._set_index__majfzk_k$(n);
      }
       while (inductionVariable < last_1);
    view._set_parent__f4egqr_k$(this);
    view.invalidate_sv8swh_k$();
    this.onChildAdded_4l6ao4_k$(view);
  };
  Container.prototype.onChildAdded_4l6ao4_k$ = function (view) {
  };
  Container.prototype.getChildAt_ha5a7z_k$ = function (index_0) {
    return this._get_childrenInternal__0_k$().get_ha5a7z_k$(index_0);
  };
  Container.prototype.getChildByName_6wfw3l_k$ = function (name) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this.___children;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (element_2._name_43 === name) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  };
  Container.prototype.removeChild_38n6pl_k$ = function (view) {
    var tmp0_safe_receiver = view;
    if (equals_1(tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_parent__0_k$(), this)) {
      var tmp1_safe_receiver = view;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.removeFromParent_sv8swh_k$();
        Unit_getInstance();
      }
      Unit_getInstance();
    } else {
    }
  };
  Container.prototype.removeChildren_sv8swh_k$ = function () {
    var tmp0_fastForEach_0_1 = this.___children;
    var array_1_2 = tmp0_fastForEach_0_1._array_4;
    var n_2_3 = 0;
    while (n_2_3 < array_1_2.length) {
      var tmp0_4_6 = n_2_3;
      n_2_3 = tmp0_4_6 + 1 | 0;
      var tmp0_unsafeCast_0_3_5 = array_1_2[tmp0_4_6];
      var tmp1__anonymous__5_4 = tmp0_unsafeCast_0_3_5;
      tmp1__anonymous__5_4._set_parent__f4egqr_k$(null);
      tmp1__anonymous__5_4._set_index__majfzk_k$(-1);
    }
    this.___children.clear_sv8swh_k$();
  };
  Container.prototype.addChild_4l6ao4_k$ = function (view) {
    return this.addChildAt_c0r4ud_k$(view, this._get_numChildren__0_k$());
  };
  Container.prototype.addChildren_j595c9_k$ = function (views_0) {
    var tmp0_safe_receiver = views_0;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toList_3(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      var n_1 = 0;
      while (n_1 < tmp1_safe_receiver._get_size__0_k$()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp0__anonymous__3 = tmp1_safe_receiver.get_ha5a7z_k$(tmp0_2);
        var tmp0_safe_receiver_4 = tmp0__anonymous__3;
        if (tmp0_safe_receiver_4 == null)
          null;
        else {
          this.addChild_4l6ao4_k$(tmp0_safe_receiver_4);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
      tmp = Unit_getInstance();
    }
    return tmp;
  };
  Container.prototype.plusAssign_4l6ao4_k$ = function (view) {
    this.addChildAt_c0r4ud_k$(view, this._get_numChildren__0_k$());
  };
  Container.prototype.get_ha5a7z_k$ = function (index_0) {
    return this.getChildAt_ha5a7z_k$(index_0);
  };
  Container.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (!this._get_visible__0_k$())
      return Unit_getInstance();
    this.renderChildrenInternal_uxru53_k$(ctx);
  };
  Container.prototype.renderChildrenInternal_uxru53_k$ = function (ctx) {
    var tmp0_fastForEach_0_1 = this.___children;
    var array_1_2 = tmp0_fastForEach_0_1._array_4;
    var n_2_3 = 0;
    while (n_2_3 < array_1_2.length) {
      var tmp0_4_6 = n_2_3;
      n_2_3 = tmp0_4_6 + 1 | 0;
      var tmp0_unsafeCast_0_3_5 = array_1_2[tmp0_4_6];
      var tmp1__anonymous__5_4 = tmp0_unsafeCast_0_3_5;
      tmp1__anonymous__5_4.render_uxru53_k$(ctx);
    }
  };
  Container.prototype.renderDebug_uxru53_k$ = function (ctx) {
    var tmp0_fastForEach_0_1 = this.___children;
    var array_1_2 = tmp0_fastForEach_0_1._array_4;
    var n_2_3 = 0;
    while (n_2_3 < array_1_2.length) {
      var tmp0_4_6 = n_2_3;
      n_2_3 = tmp0_4_6 + 1 | 0;
      var tmp0_unsafeCast_0_3_5 = array_1_2[tmp0_4_6];
      var tmp1__anonymous__5_4 = tmp0_unsafeCast_0_3_5;
      tmp1__anonymous__5_4.renderDebug_uxru53_k$(ctx);
    }
    View.prototype.renderDebug_uxru53_k$.call(this, ctx);
  };
  Container.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    this._bb_1.reset_sv8swh_k$();
    var tmp0_fastForEach_0_1 = this.___children;
    var array_1_2 = tmp0_fastForEach_0_1._array_4;
    var n_2_3 = 0;
    while (n_2_3 < array_1_2.length) {
      var tmp0_4_6 = n_2_3;
      n_2_3 = tmp0_4_6 + 1 | 0;
      var tmp0_unsafeCast_0_3_5 = array_1_2[tmp0_4_6];
      var tmp1__anonymous__5_4 = tmp0_unsafeCast_0_3_5;
      tmp1__anonymous__5_4.getBounds$default_kmxszx_k$(this, this._tempRect_5, false, false, 12, null);
      Unit_getInstance();
      this._bb_1.add_uebyw0_k$(this._tempRect_5);
      Unit_getInstance();
    }
    this._bb_1.getBounds_uebyw0_k$(out);
    Unit_getInstance();
  };
  Container.$metadata$ = {
    simpleName: 'Container',
    kind: 'class',
    interfaces: []
  };
  function addTo(_this_, parent) {
    parent.plusAssign_4l6ao4_k$(_this_);
    return _this_;
  }
  function DummyView() {
    View_init_$Init$(this);
  }
  DummyView.prototype.renderInternal_uxru53_k$ = function (ctx) {
    return Unit_getInstance();
  };
  DummyView.$metadata$ = {
    simpleName: 'DummyView',
    kind: 'class',
    interfaces: []
  };
  function dummyView(_this_) {
    var tmp0_also_0 = new DummyView();
    _this_.addChild_4l6ao4_k$(tmp0_also_0);
    return tmp0_also_0;
  }
  function Ellipse_init_$Init$(radiusX, radiusY, fill_4, stroke, strokeThickness, autoScaling, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      radiusX = 16.0;
    if (!(($mask0 & 2) === 0))
      radiusY = 16.0;
    if (!(($mask0 & 4) === 0))
      fill_4 = new RGBA(Colors_getInstance()._WHITE_0);
    if (!(($mask0 & 8) === 0))
      stroke = new RGBA(Colors_getInstance()._WHITE_0);
    if (!(($mask0 & 16) === 0))
      strokeThickness = 0.0;
    if (!(($mask0 & 32) === 0))
      autoScaling = true;
    Ellipse_1.call($this, radiusX, radiusY, fill_4, stroke, strokeThickness, autoScaling);
    return $this;
  }
  function Ellipse_init_$Create$(radiusX, radiusY, fill_4, stroke, strokeThickness, autoScaling, $mask0, $marker) {
    return Ellipse_init_$Init$(radiusX, radiusY, fill_4, stroke, strokeThickness, autoScaling, $mask0, $marker, Object.create(Ellipse_1.prototype));
  }
  function updateGraphics($this) {
    var tmp0__anonymous__1 = $this._internalShape;
    tmp0__anonymous__1.clear_sv8swh_k$();
    ellipse(tmp0__anonymous__1, 0.0, 0.0, $this._get_width__0_k$(), $this._get_height__0_k$());
    $this._set_shape__mda8oa_k$($this._internalShape);
  }
  function _no_name_provided__595(this$0) {
    this._this$0_160 = this$0;
  }
  _no_name_provided__595.prototype.invoke_okcceq_k$ = function (it) {
    updateGraphics(this._this$0_160);
  };
  _no_name_provided__595.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__595.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__596(this$0) {
    this._this$0_161 = this$0;
  }
  _no_name_provided__596.prototype.invoke_okcceq_k$ = function (it) {
    updateGraphics(this._this$0_161);
  };
  _no_name_provided__596.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_okcceq_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__596.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Ellipse_1(radiusX, radiusY, fill_4, stroke, strokeThickness, autoScaling) {
    ShapeView.call(this, VectorPath_init_$Create$(null, null, null, 7, null), fill_4, stroke, strokeThickness, autoScaling);
    var tmp = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_530(this);
    tmp._radiusX$delegate = new UIObservable(radiusX, tmp0_uiObservable_0);
    var tmp_0 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_531(this);
    tmp_0._radiusY$delegate = new UIObservable(radiusY, tmp0_uiObservable_0_0);
    updateGraphics(this);
  }
  Ellipse_1.prototype._set_radiusX__okcceq_k$ = function (_set___) {
    return this._radiusX$delegate.setValue_8gqndb_k$(this, radiusX$factory(), _set___);
  };
  Ellipse_1.prototype._get_radiusX__0_k$ = function () {
    return this._radiusX$delegate.getValue_1rt9ub_k$(this, radiusX$factory_0());
  };
  Ellipse_1.prototype._set_radiusY__okcceq_k$ = function (_set___) {
    return this._radiusY$delegate.setValue_8gqndb_k$(this, radiusY$factory(), _set___);
  };
  Ellipse_1.prototype._get_radiusY__0_k$ = function () {
    return this._radiusY$delegate.getValue_1rt9ub_k$(this, radiusY$factory_0());
  };
  Ellipse_1.prototype._set_width__okcceq_k$ = function (value) {
    this._set_radiusX__okcceq_k$(value / 2);
  };
  Ellipse_1.prototype._get_width__0_k$ = function () {
    return this._get_radiusX__0_k$() * 2;
  };
  Ellipse_1.prototype._set_height__okcceq_k$ = function (value) {
    this._set_radiusY__okcceq_k$(value / 2);
  };
  Ellipse_1.prototype._get_height__0_k$ = function () {
    return this._get_radiusY__0_k$() * 2;
  };
  Ellipse_1.prototype._get_bwidth__0_k$ = function () {
    return this._get_width__0_k$();
  };
  Ellipse_1.prototype._get_bheight__0_k$ = function () {
    return this._get_height__0_k$();
  };
  Ellipse_1.$metadata$ = {
    simpleName: 'Ellipse',
    kind: 'class',
    interfaces: []
  };
  function radiusX$factory() {
    return getPropertyCallableRef('radiusX', 1, KMutableProperty1, function (receiver) {
      return receiver._get_radiusX__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_radiusX__okcceq_k$(value);
    });
  }
  function radiusX$factory_0() {
    return getPropertyCallableRef('radiusX', 1, KMutableProperty1, function (receiver) {
      return receiver._get_radiusX__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_radiusX__okcceq_k$(value);
    });
  }
  function radiusY$factory() {
    return getPropertyCallableRef('radiusY', 1, KMutableProperty1, function (receiver) {
      return receiver._get_radiusY__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_radiusY__okcceq_k$(value);
    });
  }
  function radiusY$factory_0() {
    return getPropertyCallableRef('radiusY', 1, KMutableProperty1, function (receiver) {
      return receiver._get_radiusY__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_radiusY__okcceq_k$(value);
    });
  }
  function _no_name_provided_$factory_530(this$0) {
    var i = new _no_name_provided__595(this$0);
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_531(this$0) {
    var i = new _no_name_provided__596(this$0);
    return function (p1) {
      i.invoke_okcceq_k$(p1);
      return Unit_getInstance();
    };
  }
  function FixedSizeContainer_init_$Init$(width, height, clip, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 100.0;
    if (!(($mask0 & 2) === 0))
      height = 100.0;
    if (!(($mask0 & 4) === 0))
      clip = false;
    FixedSizeContainer.call($this, width, height, clip);
    return $this;
  }
  function FixedSizeContainer(width, height, clip) {
    Container.call(this);
    this._width_26 = width;
    this._height_27 = height;
    this._clip_4 = clip;
    this._tempBounds = Companion_getInstance_35().invoke_0_k$();
  }
  FixedSizeContainer.prototype._set_width__okcceq_k$ = function (_set___) {
    this._width_26 = _set___;
  };
  FixedSizeContainer.prototype._get_width__0_k$ = function () {
    return this._width_26;
  };
  FixedSizeContainer.prototype._set_height__okcceq_k$ = function (_set___) {
    this._height_27 = _set___;
  };
  FixedSizeContainer.prototype._get_height__0_k$ = function () {
    return this._height_27;
  };
  FixedSizeContainer.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    var tmp0_setTo_0 = this._get_width__0_k$();
    var tmp1_setTo_0 = this._get_height__0_k$();
    out.setTo_i6u10_k$(0.0, 0.0, numberToDouble(tmp0_setTo_0), numberToDouble(tmp1_setTo_0));
    Unit_getInstance();
  };
  FixedSizeContainer.prototype.toString = function () {
    var out = Container.prototype.toString.call(this);
    out = out + ('' + ':size=(' + _get_niceStr__3(this._get_width__0_k$()) + 'x' + _get_niceStr__3(this._get_height__0_k$()) + ')');
    return out;
  };
  FixedSizeContainer.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (this._clip_4) {
      var tmp0_useBatcher_0_1 = ctx._batch_0;
      if (!(ctx._currentBatcher === tmp0_useBatcher_0_1)) {
        ctx.flush_sv8swh_k$();
        ctx._currentBatcher = tmp0_useBatcher_0_1;
      }var tmp0__anonymous__2 = ctx._ctx2d;
      var bounds_3 = this.getWindowBounds_uebyw0_k$(this._tempBounds);
      applyTransform(bounds_3, ctx._batch_0._viewMat2D);
      Unit_getInstance();
      var tmp0_safe_receiver_5 = tmp0__anonymous__2._batch_1._scissor_1;
      var rect_4 = tmp0_safe_receiver_5 == null ? null : tmp0_safe_receiver_5._get_rect__0_k$();
      var intersects_6 = true;
      if (!(rect_4 == null)) {
        intersects_6 = !(bounds_3.setToIntersection_x1ktds_k$(bounds_3, rect_4) == null);
      }if (intersects_6) {
        var tmp0_safe_receiver_2_8 = bounds_3;
        var tmp;
        if (tmp0_safe_receiver_2_8 == null) {
          tmp = null;
        } else {
          tmp = tmp0__anonymous__2._tempScissor.setTo_uebyw0_k$(tmp0_safe_receiver_2_8);
        }
        var tmp0_scissor_0_1_7 = tmp;
        var oldScissor_1_3_9 = tmp0__anonymous__2._batch_1._scissor_1;
        var returnScissor_2_4_10 = tmp0__anonymous__2.scissorStart_lefq8c_k$(tmp0_scissor_0_1_7);
        try {
          Container.prototype.renderInternal_uxru53_k$.call(this, ctx);
        }finally {
          tmp0__anonymous__2.scissorEnd_h27edz_k$(oldScissor_1_3_9, returnScissor_2_4_10);
        }
      } else {
        Container.prototype.renderInternal_uxru53_k$.call(this, ctx);
      }
    } else {
      Container.prototype.renderInternal_uxru53_k$.call(this, ctx);
    }
  };
  FixedSizeContainer.$metadata$ = {
    simpleName: 'FixedSizeContainer',
    kind: 'class',
    interfaces: [Reference]
  };
  function installFpsDebugOverlay(_this_) {
    var longWindow = new TimeSlidingWindow(240);
    var mediumWindow = new TimeSlidingWindow(60);
    var shortWindow = new TimeSlidingWindow(10);
    var previousTime = {_v: new TimeSpan(PerformanceCounter_getInstance()._get_reference__nsqrdp_k$())};
    var frames = {_v: 0};
    var batchCount = {_v: 0};
    var vertexCount = {_v: 0};
    var instanceCount = {_v: 0};
    var tmp = _this_._get_views__0_k$()._onBeforeRender;
    tmp.invoke_o72mru_k$(_no_name_provided_$factory_532(batchCount, vertexCount, instanceCount));
    Unit_getInstance();
    var tmp_0 = _get_debugLineRenderContext_(_this_._get_views__0_k$()._renderContext)._beforeFlush_0;
    tmp_0.invoke_o72mru_k$(_no_name_provided_$factory_533(batchCount, vertexCount));
    Unit_getInstance();
    var tmp_1 = _this_._get_views__0_k$()._renderContext._batch_0._beforeFlush;
    tmp_1.invoke_o72mru_k$(_no_name_provided_$factory_534(batchCount, vertexCount));
    Unit_getInstance();
    var tmp_2 = _this_._get_views__0_k$()._renderContext._batch_0._onInstanceCount;
    tmp_2.invoke_o72mru_k$(_no_name_provided_$factory_535(instanceCount));
    Unit_getInstance();
    var tmp_3 = _this_._get_views__0_k$();
    tmp_3.addDebugRenderer_qyxj66_k$(_no_name_provided_$factory_536(previousTime, frames, longWindow, mediumWindow, shortWindow, batchCount, vertexCount, instanceCount));
  }
  function TimeSlidingWindow(capacity) {
    this._capacity_2 = capacity;
    this._deque = new IntDeque(this._capacity_2);
    this._totalMicroseconds = 0;
  }
  TimeSlidingWindow.prototype._get_size__0_k$ = function () {
    return this._deque._get_size__0_k$();
  };
  TimeSlidingWindow.prototype._get_avg__nsqrdp_k$ = function () {
    var tmp0__get_microseconds__0 = this._totalMicroseconds / this._deque._get_size__0_k$();
    return Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0);
  };
  TimeSlidingWindow.prototype._get_avgFps__0_k$ = function () {
    return TimeSpan__div_impl_0(Companion_getInstance_92().fromSeconds_ttklb2_k$(1.0), this._get_avg__nsqrdp_k$());
  };
  TimeSlidingWindow.prototype.get_wnb0f0_k$ = function (index_0) {
    var tmp0__get_microseconds__0 = this._deque.get_ha5a7z_k$(index_0);
    return Companion_getInstance_92().fromMicroseconds_ttklb2_k$(tmp0__get_microseconds__0);
  };
  TimeSlidingWindow.prototype.add_zah5t7_k$ = function (value) {
    var intValue = _TimeSpan___get_microsecondsInt__impl_(value);
    this._deque.add_ha5a7z_k$(intValue);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._totalMicroseconds = tmp0_this._totalMicroseconds + intValue | 0;
    if (this._deque._get_size__0_k$() > this._capacity_2) {
      var tmp1_this = this;
      tmp1_this._totalMicroseconds = tmp1_this._totalMicroseconds - this._deque.removeFirst_0_k$() | 0;
    }};
  TimeSlidingWindow.$metadata$ = {
    simpleName: 'TimeSlidingWindow',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__597($batchCount, $vertexCount, $instanceCount) {
    this._$batchCount = $batchCount;
    this._$vertexCount = $vertexCount;
    this._$instanceCount = $instanceCount;
  }
  _no_name_provided__597.prototype.invoke_uxru53_k$ = function (it) {
    this._$batchCount._v = 0;
    this._$vertexCount._v = 0;
    this._$instanceCount._v = 0;
  };
  _no_name_provided__597.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_uxru53_k$(p1 instanceof RenderContext ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__597.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__598($batchCount, $vertexCount) {
    this._$batchCount_0 = $batchCount;
    this._$vertexCount_0 = $vertexCount;
  }
  _no_name_provided__598.prototype.invoke_b04tal_k$ = function (it) {
    var tmp0 = this._$batchCount_0._v;
    this._$batchCount_0._v = tmp0 + 1 | 0;
    Unit_getInstance();
    this._$vertexCount_0._v = this._$vertexCount_0._v + it._vertexCount_1 | 0;
  };
  _no_name_provided__598.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_b04tal_k$(p1 instanceof LineRenderBatcher ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__598.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__599($batchCount, $vertexCount) {
    this._$batchCount_1 = $batchCount;
    this._$vertexCount_1 = $vertexCount;
  }
  _no_name_provided__599.prototype.invoke_gase1t_k$ = function (it) {
    var tmp0 = this._$batchCount_1._v;
    this._$batchCount_1._v = tmp0 + 1 | 0;
    Unit_getInstance();
    this._$vertexCount_1._v = this._$vertexCount_1._v + it._get_vertexCount__0_k$() | 0;
  };
  _no_name_provided__599.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_gase1t_k$(p1 instanceof BatchBuilder2D ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__599.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__600($instanceCount) {
    this._$instanceCount_0 = $instanceCount;
  }
  _no_name_provided__600.prototype.invoke_majfzk_k$ = function (it) {
    this._$instanceCount_0._v = this._$instanceCount_0._v + it | 0;
  };
  _no_name_provided__600.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_majfzk_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__600.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function invoke$drawTextWithShadow($ctx, fontSize, text, x, y) {
    var tmp = _get_debugBmpFont_();
    var tmp_0 = x + 1 | 0;
    var tmp_1 = y + 1 | 0;
    var tmp_2 = Colors_getInstance()._BLACK_0;
    drawText$default_0($ctx, tmp, fontSize, text, tmp_0, tmp_1, null, tmp_2, null, null, false, 928, null);
    var tmp_3 = _get_debugBmpFont_();
    var tmp_4 = Colors_getInstance()._WHITE_0;
    drawText$default_0($ctx, tmp_3, fontSize, text, x, y, null, tmp_4, null, null, false, 928, null);
  }
  function _no_name_provided__601($previousTime, $frames, $longWindow, $mediumWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
    this._$previousTime = $previousTime;
    this._$frames = $frames;
    this._$longWindow = $longWindow;
    this._$mediumWindow = $mediumWindow;
    this._$shortWindow = $shortWindow;
    this._$batchCount_2 = $batchCount;
    this._$vertexCount_2 = $vertexCount;
    this._$instanceCount_1 = $instanceCount;
  }
  _no_name_provided__601.prototype.invoke_8ltlll_k$ = function ($this$addDebugRenderer, ctx) {
    var scale_1 = ctx._ag_5._get_devicePixelRatio__0_k$();
    var fontSize = 8.0 * scale_1;
    var currentTime = PerformanceCounter_getInstance()._get_reference__nsqrdp_k$();
    var elapsedTime = TimeSpan__minus_impl(currentTime, this._$previousTime._v._milliseconds);
    if (this._$frames._v > 3) {
      if (TimeSpan__compareTo_impl(elapsedTime, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(4.0)) > 0) {
        this._$longWindow.add_zah5t7_k$(elapsedTime);
        this._$mediumWindow.add_zah5t7_k$(elapsedTime);
        this._$shortWindow.add_zah5t7_k$(elapsedTime);
      } else {
      }
    }var tmp0 = this._$frames._v;
    this._$frames._v = tmp0 + 1 | 0;
    Unit_getInstance();
    this._$previousTime._v = new TimeSpan(currentTime);
    invoke$drawTextWithShadow(ctx, fontSize, 'FPS: ' + ('' + roundDecimalPlaces(this._$shortWindow._get_avgFps__0_k$(), 1)) + ('' + ', batchCount=' + this._$batchCount_2._v + ', vertexCount=' + this._$vertexCount_2._v + ', instanceCount=' + this._$instanceCount_1._v), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale_1;
    var overlayHeight = 30 * scale_1;
    var overlayHeightGap = 5.0;
    var tmp0_useLineBatcher_0 = $this$addDebugRenderer._renderContext;
    var tmp0_use_0_1 = _get_debugLineRenderContext_(tmp0_useLineBatcher_0);
    var tmp0_useBatcher_0_1_2 = tmp0_use_0_1._ctx_7;
    if (!(tmp0_useBatcher_0_1_2._currentBatcher === tmp0_use_0_1)) {
      tmp0_useBatcher_0_1_2.flush_sv8swh_k$();
      tmp0_useBatcher_0_1_2._currentBatcher = tmp0_use_0_1;
    }var tmp0_color_0_4 = Colors_getInstance()._YELLOW;
    var oldColor_1_5 = tmp0_use_0_1._color_6;
    tmp0_use_0_1._color_6 = tmp0_color_0_4;
    try {
      var tmp = graphTop + overlayHeight;
      tmp0_use_0_1.line$default_to8tb2_k$(graphLeft, graphTop, graphLeft, tmp, null, null, null, 112, null);
      var tmp_0 = graphTop + overlayHeight;
      var tmp_1 = graphLeft + overlayWidth;
      var tmp_2 = graphTop + overlayHeight;
      tmp0_use_0_1.line$default_to8tb2_k$(graphLeft, tmp_0, tmp_1, tmp_2, null, null, null, 112, null);
    }finally {
      tmp0_use_0_1._color_6 = oldColor_1_5;
    }
    var tmp1_color_0_6 = Colors_getInstance()._WHITE_0;
    var oldColor_1_7 = tmp0_use_0_1._color_6;
    tmp0_use_0_1._color_6 = tmp1_color_0_6;
    try {
      var ratio_3_8 = this._$longWindow._get_size__0_k$() / this._$longWindow._capacity_2;
      var totalOverlayLines_4_9 = coerceAtLeast(numberToInt(overlayLines * ratio_3_8), 1);
      if (this._$longWindow._get_size__0_k$() > 0) {
        var previousX_5_10 = 0.0;
        var previousY_6_11 = 0.0;
        var minFps_7_12 = 0.0;
        var maxFps_8_13 = 150.0;
        var inductionVariable = 0;
        if (inductionVariable < totalOverlayLines_4_9)
          do {
            var n_10_15 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var p0_2_12_17 = convertRange(n_10_15, 0, totalOverlayLines_4_9, 0, coerceAtLeast(this._$longWindow._get_size__0_k$(), 1));
            var p1_3_13_18 = convertRange(n_10_15 + 1 | 0, 0, totalOverlayLines_4_9, 0, coerceAtLeast(this._$longWindow._get_size__0_k$(), 1));
            var plen_4_14_19 = 0;
            var timeSum_5_15_20 = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
            var inductionVariable_0 = p0_2_12_17;
            var last_1 = coerceAtMost(p1_3_13_18, this._$longWindow._get_size__0_k$());
            if (inductionVariable_0 < last_1)
              do {
                var m_7_17_22 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                timeSum_5_15_20 = TimeSpan__plus_impl(timeSum_5_15_20, this._$longWindow.get_wnb0f0_k$(m_7_17_22));
                var tmp1_8_18_23 = plen_4_14_19;
                plen_4_14_19 = tmp1_8_18_23 + 1 | 0;
                Unit_getInstance();
              }
               while (inductionVariable_0 < last_1);
            if (plen_4_14_19 === 0) {
              timeSum_5_15_20 = TimeSpan__plus_impl(timeSum_5_15_20, this._$longWindow.get_wnb0f0_k$(p0_2_12_17));
              var tmp2_9_19_24 = plen_4_14_19;
              plen_4_14_19 = tmp2_9_19_24 + 1 | 0;
              Unit_getInstance();
            }var time_10_20_25 = TimeSpan__div_impl(timeSum_5_15_20, plen_4_14_19);
            var fps_11_21_26 = _Frequency___get_hertz__impl_(toFrequency(time_10_20_25));
            var fps_11_16 = fps_11_21_26;
            var scaledFreq_22_27 = convertRange_0(fps_11_16, minFps_7_12, maxFps_8_13, overlayHeightGap, overlayHeight);
            var y_23_28 = graphTop + overlayHeight - scaledFreq_22_27;
            var x_24_29 = graphLeft + n_10_15 * overlayWidth / overlayLines;
            if (n_10_15 > 0) {
              var tmp_3 = previousX_5_10;
              var tmp_4 = previousY_6_11;
              tmp0_use_0_1.line$default_to8tb2_k$(tmp_3, tmp_4, x_24_29, y_23_28, null, null, null, 112, null);
            }previousY_6_11 = y_23_28;
            previousX_5_10 = x_24_29;
          }
           while (inductionVariable < totalOverlayLines_4_9);
      }}finally {
      tmp0_use_0_1._color_6 = oldColor_1_7;
    }
  };
  _no_name_provided__601.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Views ? p1 : THROW_CCE();
    this.invoke_8ltlll_k$(tmp, p2 instanceof RenderContext ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__601.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_532($batchCount, $vertexCount, $instanceCount) {
    var i = new _no_name_provided__597($batchCount, $vertexCount, $instanceCount);
    return function (p1) {
      i.invoke_uxru53_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_533($batchCount, $vertexCount) {
    var i = new _no_name_provided__598($batchCount, $vertexCount);
    return function (p1) {
      i.invoke_b04tal_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_534($batchCount, $vertexCount) {
    var i = new _no_name_provided__599($batchCount, $vertexCount);
    return function (p1) {
      i.invoke_gase1t_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_535($instanceCount) {
    var i = new _no_name_provided__600($instanceCount);
    return function (p1) {
      i.invoke_majfzk_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_536($previousTime, $frames, $longWindow, $mediumWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
    var i = new _no_name_provided__601($previousTime, $frames, $longWindow, $mediumWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount);
    return function (p1, p2) {
      i.invoke_8ltlll_k$(p1, p2);
      return Unit_getInstance();
    };
  }
  function setStrokeInfo($this, info) {
    $this._thickness_1 = info._thickness_0;
    $this._pixelHinting_1 = info._pixelHinting_0;
    $this._scaleMode_3 = info._scaleMode_0;
    $this._startCap_1 = info._startCap_0;
    $this._endCap_1 = info._endCap_0;
    $this._lineJoin_2 = info._lineJoin_1;
    $this._miterLimit_3 = info._miterLimit_2;
  }
  function _no_name_provided__602() {
  }
  _no_name_provided__602.prototype.invoke_f4hqzb_k$ = function (it) {
    it.clear_sv8swh_k$();
  };
  _no_name_provided__602.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_f4hqzb_k$(p1 instanceof GraphicsPath ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__602.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__603() {
  }
  _no_name_provided__603.prototype.invoke_ha5a7z_k$ = function (it) {
    return GraphicsPath_init_$Create$(null, null, null, 7, null);
  };
  _no_name_provided__603.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__603.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Graphics(autoScaling) {
    BaseGraphics.call(this, autoScaling);
    var tmp = this;
    var tmp_0 = _no_name_provided_$factory_537();
    tmp._graphicsPathPool = Pool_init_$Create$(tmp_0, 0, _no_name_provided_$factory_538(), 2, null);
    this._shapeVersion = 0;
    var tmp_1 = this;
    tmp_1._shapes_0 = ArrayList_init_$Create$();
    this._compoundShape = new CompoundShape(this._shapes_0);
    this._fill_1 = null;
    this._stroke_0 = null;
    this._currentPath = this._graphicsPathPool.alloc_0_k$();
    this._hitShapeVersion = -1;
    this._hitShape2dVersion = -1;
    this._hitShapeAnchorVersion = -1;
    var tmp_2 = this;
    tmp_2._tempVectorPaths = ArrayList_init_$Create$();
    var tmp_3 = this;
    tmp_3._tempMatrix_1 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._customHitShape2d = null;
    this._customHitShapes = null;
    this._thickness_1 = 1.0;
    this._pixelHinting_1 = false;
    this._scaleMode_3 = LineScaleMode_NORMAL_getInstance();
    this._startCap_1 = LineCap_BUTT_getInstance();
    this._endCap_1 = LineCap_BUTT_getInstance();
    this._lineJoin_2 = LineJoin_MITER_getInstance();
    this._miterLimit_3 = 4.0;
    this._set_hitTestUsingShapes__3vfqq4_k$(true);
  }
  Graphics.prototype._set_hitShape__mda8oa_k$ = function (value) {
    var tmp = this;
    var tmp0_safe_receiver_2 = value;
    var tmp_0;
    if (tmp0_safe_receiver_2 == null) {
      tmp_0 = null;
    } else {
      tmp_0 = listOf_0(tmp0_safe_receiver_2);
    }
    tmp._customHitShapes = tmp_0;
    return Unit_getInstance();
  };
  Graphics.prototype._get_hitShape__0_k$ = function () {
    var tmp0_safe_receiver = this._get_hitShapes__0_k$();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  };
  Graphics.prototype._get_hitShapes__0_k$ = function () {
    if (!(this._customHitShapes == null))
      return this._customHitShapes;
    if (!(this._hitShapeVersion === this._shapeVersion)) {
      this._hitShapeVersion = this._shapeVersion;
      this._tempVectorPaths.clear_sv8swh_k$();
      var tmp0_iterator = this._shapes_0.iterator_0_k$();
      while (tmp0_iterator.hasNext_0_k$()) {
        var shape = tmp0_iterator.next_0_k$();
        var tmp = this._tempVectorPaths;
        tmp.add_2bq_k$(shape.getPath$default_w786tn_k$(null, 1, null));
        Unit_getInstance();
      }
    }return this._tempVectorPaths;
  };
  Graphics.prototype._get_hitShape2d__0_k$ = function () {
    if (!(this._customHitShape2d == null))
      return ensureNotNull(this._customHitShape2d);
    if (!(this._hitShape2dVersion === this._shapeVersion)) {
      this._hitShape2dVersion = this._shapeVersion;
      var tmp = this;
      var tmp_0 = ensureNotNull(this._get_hitShapes__0_k$());
      tmp._customHitShape2d = toShape2d$default(tmp_0, false, 1, null);
    }return ensureNotNull(this._customHitShape2d);
  };
  Graphics.prototype.clear_sv8swh_k$ = function () {
    var tmp0_forEach_0 = this._shapes_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_0_k$();
    while (tmp0_iterator_1.hasNext_0_k$()) {
      var element_2 = tmp0_iterator_1.next_0_k$();
      var tmp0_safe_receiver_5 = isInterface(element_2, StyledShape) ? element_2 : null;
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_5 == null ? null : tmp0_safe_receiver_5._get_path__0_k$();
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        this._graphicsPathPool.free_iav7o_k$(tmp1_safe_receiver_4);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    this._shapes_0.clear_sv8swh_k$();
    this._currentPath.clear_sv8swh_k$();
  };
  Graphics.prototype._get_lastX__0_k$ = function () {
    return this._currentPath._get_lastX__0_k$();
  };
  Graphics.prototype._get_lastY__0_k$ = function () {
    return this._currentPath._get_lastY__0_k$();
  };
  Graphics.prototype._get_totalPoints__0_k$ = function () {
    return this._currentPath._get_totalPoints__0_k$();
  };
  Graphics.prototype.close_sv8swh_k$ = function () {
    return this._currentPath.close_sv8swh_k$();
  };
  Graphics.prototype.cubicTo_iylh49_k$ = function (cx1, cy1, cx2, cy2, ax, ay) {
    this._currentPath.cubicTo_iylh49_k$(cx1, cy1, cx2, cy2, ax, ay);
  };
  Graphics.prototype.lineTo_ul66c3_k$ = function (x, y) {
    this._currentPath.lineTo_ul66c3_k$(x, y);
  };
  Graphics.prototype.moveTo_ul66c3_k$ = function (x, y) {
    this._currentPath.moveTo_ul66c3_k$(x, y);
  };
  Graphics.prototype.quadTo_lf7oid_k$ = function (cx, cy, ax, ay) {
    this._currentPath.quadTo_lf7oid_k$(cx, cy, ax, ay);
  };
  Graphics.prototype.beginFill_v3uoh1_k$ = function (paint) {
    this._set_dirty__rpwsgn_k$(true);
    this._fill_1 = paint;
    this._currentPath.clear_sv8swh_k$();
    return this;
  };
  Graphics.prototype.beginStroke_g13ioz_k$ = function (paint, info) {
    this._set_dirty__rpwsgn_k$(true);
    setStrokeInfo(this, info);
    this._stroke_0 = paint;
    this._currentPath.clear_sv8swh_k$();
    return this;
  };
  Graphics.prototype.toColorFill_rs7hy8_k$ = function (color_0, alpha_0) {
    return Companion_getInstance_136().invoke_abrt0h_k$(Companion_getInstance_136().invoke_fnl2i9_k$(_RGBA___get_r__impl_(color_0), _RGBA___get_g__impl_(color_0), _RGBA___get_b__impl_(color_0), clamp_2(numberToInt(_RGBA___get_a__impl_(color_0) * alpha_0), 0, 255)));
  };
  Graphics.prototype.endFill_0_k$ = function () {
    this._set_dirty__rpwsgn_k$(true);
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._shapes_0;
    var tmp = this._currentPath;
    var tmp1_elvis_lhs_5 = this._fill_1;
    var tmp_0 = tmp1_elvis_lhs_5 == null ? new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Colors_getInstance()._RED_0)) : tmp1_elvis_lhs_5;
    var tmp1_plusAssign_0_4 = new FillShape(tmp, null, tmp_0, Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null));
    tmp0_plusAssign_0_3.add_2bq_k$(tmp1_plusAssign_0_4);
    Unit_getInstance();
    this._currentPath = this._graphicsPathPool.alloc_0_k$();
    var tmp2_this_6 = this;
    var tmp3_7 = tmp2_this_6._shapeVersion;
    tmp2_this_6._shapeVersion = tmp3_7 + 1 | 0;
    Unit_getInstance();
    return this;
  };
  Graphics.prototype.endStroke_0_k$ = function () {
    this._set_dirty__rpwsgn_k$(true);
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._shapes_0;
    var tmp = this._currentPath;
    var tmp1_elvis_lhs_5 = this._stroke_0;
    var tmp_0 = tmp1_elvis_lhs_5 == null ? new RGBA(Companion_getInstance_136().invoke_abrt0h_k$(Colors_getInstance()._RED_0)) : tmp1_elvis_lhs_5;
    var tmp1_plusAssign_0_4 = new PolylineShape(tmp, null, tmp_0, Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null), this._thickness_1, this._pixelHinting_1, this._scaleMode_3, this._startCap_1, this._endCap_1, this._lineJoin_2, this._miterLimit_3);
    tmp0_plusAssign_0_3.add_2bq_k$(tmp1_plusAssign_0_4);
    Unit_getInstance();
    this._currentPath = this._graphicsPathPool.alloc_0_k$();
    var tmp2_this_6 = this;
    var tmp3_7 = tmp2_this_6._shapeVersion;
    tmp2_this_6._shapeVersion = tmp3_7 + 1 | 0;
    Unit_getInstance();
    return this;
  };
  Graphics.prototype.drawShape_h81jc_k$ = function (ctx) {
    this._compoundShape.draw_h81jc_k$(ctx);
  };
  Graphics.prototype.getShapeBounds_j4ilx6_k$ = function (bb) {
    var tmp0_fastForEach_0 = this._shapes_0;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      tmp1__anonymous__3.addBounds_j4ilx6_k$(bb);
    }
  };
  Graphics.$metadata$ = {
    simpleName: 'Graphics',
    kind: 'class',
    interfaces: [VectorBuilder]
  };
  function _no_name_provided_$factory_537() {
    var i = new _no_name_provided__602();
    return function (p1) {
      i.invoke_f4hqzb_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_538() {
    var i = new _no_name_provided__603();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  var MOVE_ANGLES;
  var MOVE_SCALES;
  function HitTestable() {
  }
  HitTestable.$metadata$ = {
    simpleName: 'HitTestable',
    kind: 'interface',
    interfaces: []
  };
  var HitTestDirection_ANY_instance;
  var HitTestDirection_UP_instance;
  var HitTestDirection_RIGHT_instance;
  var HitTestDirection_DOWN_instance;
  var HitTestDirection_LEFT_instance;
  function Companion_208() {
    Companion_instance_207 = this;
  }
  Companion_208.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_207;
  function Companion_getInstance_207() {
    if (Companion_instance_207 == null)
      new Companion_208();
    return Companion_instance_207;
  }
  var HitTestDirection_entriesInitialized;
  function HitTestDirection_initEntries() {
    if (HitTestDirection_entriesInitialized)
      return Unit_getInstance();
    HitTestDirection_entriesInitialized = true;
    HitTestDirection_ANY_instance = new HitTestDirection('ANY', 0);
    HitTestDirection_UP_instance = new HitTestDirection('UP', 1);
    HitTestDirection_RIGHT_instance = new HitTestDirection('RIGHT', 2);
    HitTestDirection_DOWN_instance = new HitTestDirection('DOWN', 3);
    HitTestDirection_LEFT_instance = new HitTestDirection('LEFT', 4);
    Companion_getInstance_207();
  }
  function HitTestDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  HitTestDirection.$metadata$ = {
    simpleName: 'HitTestDirection',
    kind: 'class',
    interfaces: []
  };
  function _HitTestDirectionFlags___init__impl_(value) {
    return value;
  }
  function _HitTestDirectionFlags___get_value__impl_(this_0) {
    return this_0;
  }
  function _HitTestDirectionFlags___init__impl__0(up, right, down, left) {
    var tmp = _HitTestDirectionFlags___init__impl_(insert_0(insert_0(insert_0(insert_0(0, up, 0), right, 1), down, 2), left, 3));
    return tmp;
  }
  function Companion_209() {
    Companion_instance_208 = this;
    this._ALL_0 = _HitTestDirectionFlags___init__impl__0(true, true, true, true);
    this._NONE_1 = _HitTestDirectionFlags___init__impl__0(false, false, false, false);
  }
  Companion_209.prototype.fromString_n6wkrt_k$ = function (kind, default_0) {
    if (kind == null ? true : kind === '')
      return default_0;
    if (!startsWith$default_1(kind, 'collision', false, 2, null))
      return this._NONE_1;
    else {
    }
    if (kind === 'collision')
      return this._ALL_0;
    var tmp = contains$default_0(kind, '_up', false, 2, null);
    var tmp_0 = contains$default_0(kind, '_right', false, 2, null);
    var tmp_1 = contains$default_0(kind, '_down', false, 2, null);
    return _HitTestDirectionFlags___init__impl__0(tmp, tmp_0, tmp_1, contains$default_0(kind, '_left', false, 2, null));
  };
  Companion_209.prototype.fromString$default_8mwcsm_k$ = function (kind, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      default_0 = this._ALL_0;
    return this.fromString_n6wkrt_k$(kind, default_0);
  };
  Companion_209.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_208;
  function Companion_getInstance_208() {
    if (Companion_instance_208 == null)
      new Companion_209();
    return Companion_instance_208;
  }
  function _HitTestDirectionFlags___get_any__impl_(this_0) {
    return !(_HitTestDirectionFlags___get_value__impl_(this_0) === 0);
  }
  function _HitTestDirectionFlags___get_up__impl_(this_0) {
    return extract_0(_HitTestDirectionFlags___get_value__impl_(this_0), 0);
  }
  function _HitTestDirectionFlags___get_right__impl_(this_0) {
    return extract_0(_HitTestDirectionFlags___get_value__impl_(this_0), 1);
  }
  function _HitTestDirectionFlags___get_down__impl_(this_0) {
    return extract_0(_HitTestDirectionFlags___get_value__impl_(this_0), 2);
  }
  function _HitTestDirectionFlags___get_left__impl_(this_0) {
    return extract_0(_HitTestDirectionFlags___get_value__impl_(this_0), 3);
  }
  function HitTestDirectionFlags__matches_impl(this_0, direction) {
    var tmp0_subject = direction;
    var tmp;
    if (tmp0_subject.equals(HitTestDirection_ANY_getInstance())) {
      tmp = _HitTestDirectionFlags___get_any__impl_(this_0);
    } else if (tmp0_subject.equals(HitTestDirection_UP_getInstance())) {
      tmp = _HitTestDirectionFlags___get_up__impl_(this_0);
    } else if (tmp0_subject.equals(HitTestDirection_RIGHT_getInstance())) {
      tmp = _HitTestDirectionFlags___get_right__impl_(this_0);
    } else if (tmp0_subject.equals(HitTestDirection_DOWN_getInstance())) {
      tmp = _HitTestDirectionFlags___get_down__impl_(this_0);
    } else if (tmp0_subject.equals(HitTestDirection_LEFT_getInstance())) {
      tmp = _HitTestDirectionFlags___get_left__impl_(this_0);
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function HitTestDirectionFlags__toString_impl(this_0) {
    return '' + 'HitTestDirectionFlags(up=' + _HitTestDirectionFlags___get_up__impl_(this_0) + ', right=' + _HitTestDirectionFlags___get_right__impl_(this_0) + ', down=' + _HitTestDirectionFlags___get_down__impl_(this_0) + ', left=' + _HitTestDirectionFlags___get_left__impl_(this_0) + ')';
  }
  function HitTestDirectionFlags__hashCode_impl(this_0) {
    return this_0;
  }
  function HitTestDirectionFlags__equals_impl(this_0, other) {
    if (!(other instanceof HitTestDirectionFlags))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HitTestDirectionFlags ? other._value_45 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function HitTestDirectionFlags(value) {
    Companion_getInstance_208();
    this._value_45 = value;
  }
  HitTestDirectionFlags.prototype.toString = function () {
    return HitTestDirectionFlags__toString_impl(this._value_45);
  };
  HitTestDirectionFlags.prototype.hashCode = function () {
    return HitTestDirectionFlags__hashCode_impl(this._value_45);
  };
  HitTestDirectionFlags.prototype.equals = function (other) {
    return HitTestDirectionFlags__equals_impl(this._value_45, other);
  };
  HitTestDirectionFlags.$metadata$ = {
    simpleName: 'HitTestDirectionFlags',
    kind: 'class',
    interfaces: []
  };
  function HitTestDirection_ANY_getInstance() {
    HitTestDirection_initEntries();
    return HitTestDirection_ANY_instance;
  }
  function HitTestDirection_UP_getInstance() {
    HitTestDirection_initEntries();
    return HitTestDirection_UP_instance;
  }
  function HitTestDirection_RIGHT_getInstance() {
    HitTestDirection_initEntries();
    return HitTestDirection_RIGHT_instance;
  }
  function HitTestDirection_DOWN_getInstance() {
    HitTestDirection_initEntries();
    return HitTestDirection_DOWN_instance;
  }
  function HitTestDirection_LEFT_getInstance() {
    HitTestDirection_initEntries();
    return HitTestDirection_LEFT_instance;
  }
  function MOVE_ANGLES$init$() {
    var tmp0_arrayOf_0 = [new Angle(_get_degrees__0(0)), new Angle(_get_degrees__0(5)), new Angle(_get_degrees__0(10)), new Angle(_get_degrees__0(15)), new Angle(_get_degrees__0(20)), new Angle(_get_degrees__0(30)), new Angle(_get_degrees__0(45)), new Angle(_get_degrees__0(60)), new Angle(_get_degrees__0(80)), new Angle(_get_degrees__0(85))];
    return tmp0_arrayOf_0;
  }
  function MOVE_SCALES$init$() {
    return [1.0, -1.0];
  }
  function Image_init_$Init$_0(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 4) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 8) === 0))
      hitShape = null;
    if (!(($mask0 & 16) === 0))
      smoothing = true;
    Image_1.call($this, bitmap, anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function Image_init_$Create$_0(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker) {
    return Image_init_$Init$_0(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, Object.create(Image_1.prototype));
  }
  function Image_init_$Init$_1(bitmap, anchorX, anchorY, hitShape, smoothing, $this) {
    Image_1.call($this, slice$default(bitmap, null, null, 3, null), anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function Image_init_$Init$_2(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 4) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 8) === 0))
      hitShape = null;
    if (!(($mask0 & 16) === 0))
      smoothing = true;
    Image_init_$Init$_1(bitmap, anchorX, anchorY, hitShape, smoothing, $this);
    return $this;
  }
  function Image_init_$Create$_1(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker) {
    return Image_init_$Init$_2(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, Object.create(Image_1.prototype));
  }
  function $forceLoadSourceFileCOROUTINE$32(_this_, views_0, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__197 = _this_;
    this._views_13 = views_0;
    this._currentVfs_3 = currentVfs;
    this._sourceFile_3 = sourceFile;
  }
  $forceLoadSourceFileCOROUTINE$32.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = this.__this__197.baseForceLoadSourceFile_z71c2l_k$(this.__this__197, this._views_13, this._currentVfs_3, this._sourceFile_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._exceptionState = 3;
            this._state_1 = 2;
            var tmp_0 = this._currentVfs_3.get_6wfw3l_k$('' + this._sourceFile_3);
            suspendResult = readBitmapSlice$default(tmp_0, false, null, null, 7, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.__this__197._set_bitmap__5a5lwo_k$(ARGUMENT);
            this.__this__197._set_scale__okcceq_k$(1.0);
            this._exceptionState = 5;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._exceptionState = 5;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              var tmp0__get_white__0 = Bitmaps_getInstance();
              this.__this__197._set_bitmap__5a5lwo_k$(Bitmaps_white);
              this.__this__197._set_scale__okcceq_k$(100.0);
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 5;
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadSourceFileCOROUTINE$32.$metadata$ = {
    simpleName: '$forceLoadSourceFileCOROUTINE$32',
    kind: 'class',
    interfaces: []
  };
  function Image_1(bitmap, anchorX, anchorY, hitShape, smoothing) {
    BaseImage.call(this, bitmap, anchorX, anchorY, hitShape, smoothing);
    this._$$delegate_0_45 = new Mixin_3();
  }
  Image_1.prototype.lazyLoadRenderInternal_hk6fpn_k$ = function (ctx, view) {
    this._$$delegate_0_45.lazyLoadRenderInternal_hk6fpn_k$(ctx, view);
  };
  Image_1.prototype._set_sourceFile__qlpr75_k$ = function (_set___) {
    this._$$delegate_0_45._set_sourceFile__qlpr75_k$(_set___);
  };
  Image_1.prototype._get_sourceFile__0_k$ = function () {
    return this._$$delegate_0_45._sourceFile_8;
  };
  Image_1.prototype._set_sourceTreeLoaded__rpwsgn_k$ = function (_set___) {
    this._$$delegate_0_45._sourceTreeLoaded = _set___;
  };
  Image_1.prototype.baseForceLoadSourceFile_z71c2l_k$ = function (_this__0, views_0, currentVfs, sourceFile, $cont) {
    return this._$$delegate_0_45.baseForceLoadSourceFile_z71c2l_k$(_this__0, views_0, currentVfs, sourceFile, $cont);
  };
  Image_1.prototype.renderInternal_uxru53_k$ = function (ctx) {
    this.lazyLoadRenderInternal_hk6fpn_k$(ctx, this);
    BaseImage.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  Image_1.prototype.forceLoadSourceFile_mwdcj_k$ = function (views_0, currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadSourceFileCOROUTINE$32(this, views_0, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Image_1.$metadata$ = {
    simpleName: 'Image',
    kind: 'class',
    interfaces: [ViewFileRef]
  };
  function BaseImage_init_$Init$(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 4) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 8) === 0))
      hitShape = null;
    if (!(($mask0 & 16) === 0))
      smoothing = true;
    BaseImage.call($this, bitmap, anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function trySetSourceActually($this) {
    var source = $this._bitmapSrc.getOrNull_0_k$();
    if (!(source == null)) {
      $this._setBitmapSource = true;
      $this._set_baseBitmap__5a5lwo_k$(source);
    }}
  function BaseImage(bitmap, anchorX, anchorY, hitShape, smoothing) {
    RectBase.call(this, anchorX, anchorY, hitShape, smoothing);
    this._setBitmapSource = false;
    this._bitmapSrc = bitmap;
    this.trySetSource_sv8swh_k$();
  }
  BaseImage.prototype._set_bitmap__5a5lwo_k$ = function (value) {
    this._setBitmapSource = true;
    this._set_baseBitmap__5a5lwo_k$(value);
  };
  BaseImage.prototype._get_bitmap__0_k$ = function () {
    return this._get_baseBitmap__0_k$();
  };
  BaseImage.prototype.trySetSource_sv8swh_k$ = function () {
    if (this._setBitmapSource)
      return Unit_getInstance();
    trySetSourceActually(this);
  };
  BaseImage.prototype.renderInternal_uxru53_k$ = function (ctx) {
    this.trySetSource_sv8swh_k$();
    RectBase.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  BaseImage.prototype._get_bwidth__0_k$ = function () {
    return this._get_baseBitmap__0_k$()._get_width__0_k$();
  };
  BaseImage.prototype._get_bheight__0_k$ = function () {
    return this._get_baseBitmap__0_k$()._get_height__0_k$();
  };
  BaseImage.prototype._get_anchorDispX__0_k$ = function () {
    return this._get_anchorX__0_k$() * this._get_baseBitmap__0_k$()._frameWidth - this._get_baseBitmap__0_k$()._frameOffsetX;
  };
  BaseImage.prototype._get_anchorDispY__0_k$ = function () {
    return this._get_anchorY__0_k$() * this._get_baseBitmap__0_k$()._frameHeight - this._get_baseBitmap__0_k$()._frameOffsetY;
  };
  BaseImage.prototype.toString = function () {
    return RectBase.prototype.toString.call(this) + ('' + ':bitmap=' + this._get_bitmap__0_k$());
  };
  BaseImage.$metadata$ = {
    simpleName: 'BaseImage',
    kind: 'class',
    interfaces: []
  };
  function NinePatchEx_init_$Init$(ninePatch, width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      var tmp0_safe_receiver = ninePatch;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_width__0_k$();
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
      width = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
    }if (!(($mask0 & 4) === 0)) {
      var tmp3_safe_receiver = ninePatch;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver._get_height__0_k$();
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver;
      height = tmp5_elvis_lhs == null ? 16.0 : tmp5_elvis_lhs;
    }NinePatchEx.call($this, ninePatch, width, height);
    return $this;
  }
  function NinePatchEx_init_$Create$(ninePatch, width, height, $mask0, $marker) {
    return NinePatchEx_init_$Init$(ninePatch, width, height, $mask0, $marker, Object.create(NinePatchEx.prototype));
  }
  function recomputeVerticesIfRequired($this) {
    var viewBounds = $this._bounds_15;
    if (_RectangleInt___get_rect__impl_($this._cachedBounds).equals(_RectangleInt___get_rect__impl_(viewBounds)) ? equals_1($this._cachedNinePatch, $this._ninePatch_1) : false)
      return Unit_getInstance();
    _RectangleInt___get_rect__impl_($this._cachedBounds).copyFrom_uebyw0_k$(_RectangleInt___get_rect__impl_(viewBounds));
    Unit_getInstance();
    $this._cachedNinePatch = $this._ninePatch_1;
    var ninePatch = $this._ninePatch_1;
    if (ninePatch == null) {
      $this._tva = null;
      $this._tvaCached = null;
      return Unit_getInstance();
    }var numQuads = ninePatch._info_0._get_totalSegments__0_k$();
    var tmp0_quadIndices_0 = Companion_getInstance_202();
    var indices = TEXTURED_ARRAY_quadIndices(numQuads);
    var tmp = imul(numQuads, 4);
    var tva = TexturedVertexArray_init_$Create$(tmp, indices, 0, 4, null);
    var index_0 = {_v: 0};
    var matrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    ninePatch._info_0.computeScale$default_acnxy2_k$(viewBounds, false, _no_name_provided_$factory_539(ninePatch, tva, index_0, matrix, $this), 2, null);
    $this._tva = tva;
    var tmp_0 = $this;
    var tmp_1 = imul(numQuads, 4);
    tmp_0._tvaCached = TexturedVertexArray_init_$Create$(tmp_1, indices, 0, 4, null);
    $this._cachedMatrix.setToNan_0_k$();
    Unit_getInstance();
  }
  function _no_name_provided__604($ninePatch, $tva, $index, $matrix, this$0) {
    this._$ninePatch = $ninePatch;
    this._$tva = $tva;
    this._$index_0 = $index;
    this._$matrix = $matrix;
    this._this$0_162 = this$0;
  }
  _no_name_provided__604.prototype.invoke_1u43sm_k$ = function (segment, x, y, width, height) {
    var bmpSlice = this._$ninePatch.getSegmentBmpSlice_ngrvll_k$(segment);
    var tmp0 = this._$index_0._v;
    this._$index_0._v = tmp0 + 1 | 0;
    this._$tva.quad_drsndp_k$(imul(tmp0, 4), x, y, width, height, this._$matrix, bmpSlice, this._this$0_162._get_renderColorMul__12t64v_k$(), this._this$0_162._get_renderColorAdd__7hz20p_k$());
  };
  _no_name_provided__604.prototype.invoke_owvcxu_k$ = function (p1, p2, p3, p4, p5) {
    var tmp = p1 instanceof Segment ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_1u43sm_k$(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__604.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $forceLoadSourceFileCOROUTINE$33(_this_, views_0, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__198 = _this_;
    this._views_14 = views_0;
    this._currentVfs_4 = currentVfs;
    this._sourceFile_4 = sourceFile;
  }
  $forceLoadSourceFileCOROUTINE$33.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = this.__this__198.baseForceLoadSourceFile_z71c2l_k$(this.__this__198, this._views_14, this._currentVfs_4, this._sourceFile_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._exceptionState = 3;
            this._state_1 = 2;
            var tmp_0 = this._currentVfs_4.get_6wfw3l_k$('' + this._sourceFile_4);
            suspendResult = readNinePatch$default(tmp_0, null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._TRY_RESULT0_6 = suspendResult;
            this._exceptionState = 5;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._exceptionState = 5;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              var tmp_2 = this;
              var tmp_3 = Companion_getInstance_131();
              tmp_2._TRY_RESULT0_6 = tmp_3.invoke_nc8knv_k$(Bitmap32_init_$Create$(62, 62, null, false, 12, null));
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 5;
            var ARGUMENT = this._TRY_RESULT0_6;
            this.__this__198._ninePatch_1 = ARGUMENT;
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadSourceFileCOROUTINE$33.$metadata$ = {
    simpleName: '$forceLoadSourceFileCOROUTINE$33',
    kind: 'class',
    interfaces: []
  };
  function NinePatchEx(ninePatch, width, height) {
    View_init_$Init$(this);
    this._width_27 = width;
    this._height_28 = height;
    this._$$delegate_0_46 = new Mixin_3();
    this._ninePatch_1 = ninePatch;
    this._smoothing_2 = true;
    this._bounds_15 = Companion_getInstance_36().invoke_t4v1qq_k$();
    this._tva = null;
    this._tvaCached = null;
    var tmp = this;
    tmp._cachedMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._cachedNinePatch = null;
    this._cachedBounds = Companion_getInstance_36().invoke_t4v1qq_k$();
  }
  NinePatchEx.prototype._set_width__okcceq_k$ = function (_set___) {
    this._width_27 = _set___;
  };
  NinePatchEx.prototype._get_width__0_k$ = function () {
    return this._width_27;
  };
  NinePatchEx.prototype._set_height__okcceq_k$ = function (_set___) {
    this._height_28 = _set___;
  };
  NinePatchEx.prototype._get_height__0_k$ = function () {
    return this._height_28;
  };
  NinePatchEx.prototype.lazyLoadRenderInternal_hk6fpn_k$ = function (ctx, view) {
    this._$$delegate_0_46.lazyLoadRenderInternal_hk6fpn_k$(ctx, view);
  };
  NinePatchEx.prototype._set_sourceFile__qlpr75_k$ = function (_set___) {
    this._$$delegate_0_46._set_sourceFile__qlpr75_k$(_set___);
  };
  NinePatchEx.prototype._set_sourceTreeLoaded__rpwsgn_k$ = function (_set___) {
    this._$$delegate_0_46._sourceTreeLoaded = _set___;
  };
  NinePatchEx.prototype.baseForceLoadSourceFile_z71c2l_k$ = function (_this__0, views_0, currentVfs, sourceFile, $cont) {
    return this._$$delegate_0_46.baseForceLoadSourceFile_z71c2l_k$(_this__0, views_0, currentVfs, sourceFile, $cont);
  };
  NinePatchEx.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (!this._get_visible__0_k$())
      return Unit_getInstance();
    this.lazyLoadRenderInternal_hk6fpn_k$(ctx, this);
    var m = this._get_globalMatrix__0_k$();
    var xscale = m._a;
    var yscale = m._d;
    setTo(this._bounds_15, 0, 0, numberToInt(this._width_27 * xscale), numberToInt(this._height_28 * yscale));
    Unit_getInstance();
    var tmp$ret$2;
    l$ret$3: do {
      var a_1 = m._a;
      var b_2 = m._b;
      var c_3 = m._c;
      var d_4 = m._d;
      var tx_5 = m._tx;
      var ty_6 = m._ty;
      try {
        m.prescale_ngl742_k$(1.0 / xscale, 1.0 / yscale);
        Unit_getInstance();
        var ninePatch_8 = this._ninePatch_1;
        var tmp;
        if (!(ninePatch_8 == null)) {
          recomputeVerticesIfRequired(this);
          var tvaCached_9 = this._tvaCached;
          var tmp_0;
          if (!(tvaCached_9 == null)) {
            if (!this._cachedMatrix.equals(m)) {
              this._cachedMatrix.copyFrom_v5f3e9_k$(m);
              Unit_getInstance();
              tvaCached_9.copyFrom_e7bxyc_k$(ensureNotNull(this._tva));
              tvaCached_9.applyMatrix_skjkkf_k$(m);
            }var tmp0_use_0_1_10 = ctx._batch_0;
            var tmp0_useBatcher_0_1_2_11 = tmp0_use_0_1_10._ctx_6;
            if (!(tmp0_useBatcher_0_1_2_11._currentBatcher === tmp0_use_0_1_10)) {
              tmp0_useBatcher_0_1_2_11.flush_sv8swh_k$();
              tmp0_useBatcher_0_1_2_11._currentBatcher = tmp0_use_0_1_10;
            }var tmp0_drawVertices_0_4_12 = ctx.getTex_nc8knv_k$(ninePatch_8._content_5._get_bmp__0_k$());
            var tmp1_drawVertices_0_5_13 = this._smoothing_2;
            var tmp2_drawVertices_0_6_14 = this._get_blendMode__0_k$()._factors;
            var tmp3_drawVertices_0_7_15 = tvaCached_9._vcount;
            var tmp4_drawVertices_0_8_16 = tvaCached_9._isize;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp0_setStateFast_0_1_9_17 = tmp0_drawVertices_0_4_12._base_5;
              var isCurrentStateFast_1_2_10_18 = tmp0_use_0_1_10.isCurrentStateFast_ww8sek_k$(tmp0_setStateFast_0_1_9_17, tmp1_drawVertices_0_5_13, tmp2_drawVertices_0_6_14, null);
              if (isCurrentStateFast_1_2_10_18) {
                tmp$ret$0 = Unit_getInstance();
                break l$ret$1;
              }tmp0_use_0_1_10.flush$default_9k51td_k$(false, false, 3, null);
              tmp0_use_0_1_10._currentTexIndex = 0;
              tmp0_use_0_1_10._currentTexN[0] = tmp0_setStateFast_0_1_9_17;
              tmp0_use_0_1_10._currentSmoothing = tmp1_drawVertices_0_5_13;
              tmp0_use_0_1_10._currentBlendFactors = (!(tmp0_setStateFast_0_1_9_17 == null) ? tmp0_setStateFast_0_1_9_17._isFbo : false) ? toRenderFboIntoBack(tmp2_drawVertices_0_6_14) : tmp2_drawVertices_0_6_14;
              tmp0_use_0_1_10._currentProgram = null;
            }
             while (false);
            tmp_0 = tmp0_use_0_1_10.drawVertices$default_69bxws_k$(tvaCached_9, null, tmp3_drawVertices_0_7_15, tmp4_drawVertices_0_8_16, 0, 16, null);
          }tmp = tmp_0;
        }tmp$ret$2 = tmp;
        break l$ret$3;
      }finally {
        m._a = a_1;
        m._b = b_2;
        m._c = c_3;
        m._d = d_4;
        m._tx = tx_5;
        m._ty = ty_6;
      }
    }
     while (false);
  };
  NinePatchEx.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    out.setTo_i6u10_k$(0.0, 0.0, this._width_27, this._height_28);
    Unit_getInstance();
  };
  NinePatchEx.prototype.forceLoadSourceFile_mwdcj_k$ = function (views_0, currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadSourceFileCOROUTINE$33(this, views_0, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  NinePatchEx.$metadata$ = {
    simpleName: 'NinePatchEx',
    kind: 'class',
    interfaces: [ViewFileRef]
  };
  function _no_name_provided_$factory_539($ninePatch, $tva, $index, $matrix, this$0) {
    var i = new _no_name_provided__604($ninePatch, $tva, $index, $matrix, this$0);
    return function (p1, p2, p3, p4, p5) {
      i.invoke_1u43sm_k$(p1, p2, p3, p4, p5);
      return Unit_getInstance();
    };
  }
  function RectBase_init_$Init$(anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 2) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 4) === 0))
      hitShape = null;
    if (!(($mask0 & 8) === 0))
      smoothing = true;
    RectBase.call($this, anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function RectBase(anchorX, anchorY, hitShape, smoothing) {
    View_init_$Init$(this);
    this._smoothing_3 = smoothing;
    this._set_hitShape__mda8oa_k$(hitShape);
    this._anchorVersion = 0;
    var tmp = this;
    var tmp0__get_white__0 = Bitmaps_getInstance();
    tmp._baseBitmap = Bitmaps_white;
    this._anchorX = anchorX;
    this._anchorY = anchorY;
    var tmp_0 = this;
    var tmp0__get_QUAD_INDICES__0 = Companion_getInstance_202();
    tmp_0._vertices_6 = TexturedVertexArray_init_$Create$(4, TEXTURED_ARRAY_QUAD_INDICES, 0, 4, null);
  }
  RectBase.prototype._set_smoothing__rpwsgn_k$ = function (_set___) {
    this._smoothing_3 = _set___;
  };
  RectBase.prototype._set_baseBitmap__5a5lwo_k$ = function (v) {
    if (!(this._baseBitmap === v)) {
      this._baseBitmap = v;
      this._set_dirtyVertices__rpwsgn_k$(true);
    }};
  RectBase.prototype._get_baseBitmap__0_k$ = function () {
    return this._baseBitmap;
  };
  RectBase.prototype._set_anchorX__okcceq_k$ = function (v) {
    if (!(this._anchorX === v)) {
      this._anchorX = v;
      this._set_dirtyVertices__rpwsgn_k$(true);
      var tmp0_this = this;
      var tmp1 = tmp0_this._anchorVersion;
      tmp0_this._anchorVersion = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  RectBase.prototype._get_anchorX__0_k$ = function () {
    return this._anchorX;
  };
  RectBase.prototype._set_anchorY__okcceq_k$ = function (v) {
    if (!(this._anchorY === v)) {
      this._anchorY = v;
      this._set_dirtyVertices__rpwsgn_k$(true);
      var tmp0_this = this;
      var tmp1 = tmp0_this._anchorVersion;
      tmp0_this._anchorVersion = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  RectBase.prototype._get_anchorY__0_k$ = function () {
    return this._anchorY;
  };
  RectBase.prototype._get_bwidth__0_k$ = function () {
    return 0.0;
  };
  RectBase.prototype._get_bheight__0_k$ = function () {
    return 0.0;
  };
  RectBase.prototype._get_anchorDispX__0_k$ = function () {
    return this._get_anchorX__0_k$() * this._get_bwidth__0_k$();
  };
  RectBase.prototype._get_anchorDispY__0_k$ = function () {
    return this._get_anchorY__0_k$() * this._get_bheight__0_k$();
  };
  RectBase.prototype._get_sLeft__0_k$ = function () {
    return -this._get_anchorDispX__0_k$();
  };
  RectBase.prototype._get_sTop__0_k$ = function () {
    return -this._get_anchorDispY__0_k$();
  };
  RectBase.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (!this._get_visible__0_k$())
      return Unit_getInstance();
    var tmp = this._baseBitmap;
    var tmp0__get_transparent__0 = Bitmaps_getInstance();
    if (tmp === Bitmaps_transparent)
      return Unit_getInstance();
    else {
    }
    if (this._get_dirtyVertices__0_k$()) {
      this._set_dirtyVertices__rpwsgn_k$(false);
      this._vertices_6.quad_vcy9g9_k$(0, this._get_sLeft__0_k$(), this._get_sTop__0_k$(), this._get_bwidth__0_k$(), this._get_bheight__0_k$(), this._get_globalMatrix__0_k$(), this._baseBitmap, this._get_renderColorMul__12t64v_k$(), this._get_renderColorAdd__7hz20p_k$());
    }var tmp0_use_0_1 = ctx._batch_0;
    var tmp0_useBatcher_0_1_2 = tmp0_use_0_1._ctx_6;
    if (!(tmp0_useBatcher_0_1_2._currentBatcher === tmp0_use_0_1)) {
      tmp0_useBatcher_0_1_2.flush_sv8swh_k$();
      tmp0_useBatcher_0_1_2._currentBatcher = tmp0_use_0_1;
    }var tmp0_drawVertices_0_4 = this._vertices_6;
    var tmp1_drawVertices_0_5 = ctx.getTex_uoiv7r_k$(this._baseBitmap)._base_6;
    var tmp2_drawVertices_0_6 = this._smoothing_3;
    var tmp3_drawVertices_0_7 = this._get_renderBlendMode__0_k$()._factors;
    var tmp4_drawVertices_0_8 = tmp0_drawVertices_0_4._vcount;
    var tmp5_drawVertices_0_9 = tmp0_drawVertices_0_4._isize;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_setStateFast_0_1_10 = tmp1_drawVertices_0_5._base_5;
      var isCurrentStateFast_1_2_11 = tmp0_use_0_1.isCurrentStateFast_ww8sek_k$(tmp0_setStateFast_0_1_10, tmp2_drawVertices_0_6, tmp3_drawVertices_0_7, null);
      if (isCurrentStateFast_1_2_11) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }tmp0_use_0_1.flush$default_9k51td_k$(false, false, 3, null);
      tmp0_use_0_1._currentTexIndex = 0;
      tmp0_use_0_1._currentTexN[0] = tmp0_setStateFast_0_1_10;
      tmp0_use_0_1._currentSmoothing = tmp2_drawVertices_0_6;
      tmp0_use_0_1._currentBlendFactors = (!(tmp0_setStateFast_0_1_10 == null) ? tmp0_setStateFast_0_1_10._isFbo : false) ? toRenderFboIntoBack(tmp3_drawVertices_0_7) : tmp3_drawVertices_0_7;
      tmp0_use_0_1._currentProgram = null;
    }
     while (false);
    tmp0_use_0_1.drawVertices$default_69bxws_k$(tmp0_drawVertices_0_4, null, tmp4_drawVertices_0_8, tmp5_drawVertices_0_9, 0, 16, null);
  };
  RectBase.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    out.setTo_i6u10_k$(this._get_sLeft__0_k$(), this._get_sTop__0_k$(), this._get_bwidth__0_k$(), this._get_bheight__0_k$());
    Unit_getInstance();
  };
  RectBase.prototype.toString = function () {
    var out = View.prototype.toString.call(this);
    if (!(this._get_anchorX__0_k$() === 0.0) ? true : !(this._get_anchorY__0_k$() === 0.0))
      out = out + ('' + ':anchor=(' + this._get_str__xaho5p_k$(this._get_anchorX__0_k$()) + ', ' + this._get_str__xaho5p_k$(this._get_anchorY__0_k$()) + ')');
    return out;
  };
  RectBase.$metadata$ = {
    simpleName: 'RectBase',
    kind: 'class',
    interfaces: [Anchorable]
  };
  function Renderable() {
  }
  Renderable.$metadata$ = {
    simpleName: 'Renderable',
    kind: 'interface',
    interfaces: []
  };
  function updateGraphics_0($this) {
    var shape = $this._shape_0;
    $this.clear_sv8swh_k$();
    if (!(shape == null) ? isNotEmpty(shape) : false) {
      var tmp0_fill_0 = $this._fill_2;
      $this.beginFill_v3uoh1_k$(tmp0_fill_0);
      Unit_getInstance();
      try {
        path($this, shape);
      }finally {
        $this.endFill_0_k$();
        Unit_getInstance();
      }
      if (!($this._strokeThickness === 0.0)) {
        var tmp1_stroke_0 = $this._stroke_1;
        var tmp = $this._strokeThickness;
        var tmp2_stroke_0 = StrokeInfo_init_$Create$(tmp, false, null, null, null, null, 0.0, 126, null);
        $this.beginStroke_g13ioz_k$(tmp1_stroke_0, tmp2_stroke_0);
        Unit_getInstance();
        try {
          path($this, shape);
        }finally {
          $this.endStroke_0_k$();
          Unit_getInstance();
        }
      }}}
  function ShapeView(shape, fill_4, stroke, strokeThickness, autoScaling) {
    Graphics.call(this, autoScaling);
    this._shape_0 = shape;
    this._fill_2 = fill_4;
    this._stroke_1 = stroke;
    this._strokeThickness = strokeThickness;
    updateGraphics_0(this);
    var tmp = this;
    tmp._internalShape = VectorPath_init_$Create$(null, null, null, 7, null);
  }
  ShapeView.prototype._set_shape__mda8oa_k$ = function (value) {
    this._shape_0 = value;
    updateGraphics_0(this);
  };
  ShapeView.$metadata$ = {
    simpleName: 'ShapeView',
    kind: 'class',
    interfaces: []
  };
  function Companion_210() {
    Companion_instance_209 = this;
  }
  Companion_210.prototype.invoke_xxd7wu_k$ = function (width, height, color_0) {
    return new SolidRect(width, height, color_0);
  };
  Companion_210.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_209;
  function Companion_getInstance_209() {
    if (Companion_instance_209 == null)
      new Companion_210();
    return Companion_instance_209;
  }
  function SolidRect(width, height, color_0) {
    Companion_getInstance_209();
    RectBase_init_$Init$(0.0, 0.0, null, false, 15, null, this);
    this._width_28 = width;
    this._height_29 = height;
    this._set_colorMul__f52nlt_k$(color_0);
  }
  SolidRect.prototype._set_width__okcceq_k$ = function (v) {
    this._width_28 = v;
    this._set_dirtyVertices__rpwsgn_k$(true);
  };
  SolidRect.prototype._get_width__0_k$ = function () {
    return this._width_28;
  };
  SolidRect.prototype._set_height__okcceq_k$ = function (v) {
    this._height_29 = v;
    this._set_dirtyVertices__rpwsgn_k$(true);
  };
  SolidRect.prototype._get_height__0_k$ = function () {
    return this._height_29;
  };
  SolidRect.prototype._get_bwidth__0_k$ = function () {
    return this._width_28;
  };
  SolidRect.prototype._get_bheight__0_k$ = function () {
    return this._height_29;
  };
  SolidRect.prototype._set_color__f52nlt_k$ = function (value) {
    this._set_colorMul__f52nlt_k$(value);
  };
  SolidRect.$metadata$ = {
    simpleName: 'SolidRect',
    kind: 'class',
    interfaces: []
  };
  function Sprite_init_$Init$(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      var tmp0__get_white__0 = Bitmaps_getInstance();
      bitmap = Bitmaps_white;
    }if (!(($mask0 & 2) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 4) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 8) === 0))
      hitShape = null;
    if (!(($mask0 & 16) === 0))
      smoothing = true;
    Sprite.call($this, bitmap, anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function Sprite_init_$Create$(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker) {
    return Sprite_init_$Init$(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, Object.create(Sprite.prototype));
  }
  function Sprite_init_$Init$_0(bitmap, anchorX, anchorY, hitShape, smoothing, $this) {
    Sprite.call($this, slice$default(bitmap, null, null, 3, null), anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function Sprite_init_$Init$_1(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 4) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 8) === 0))
      hitShape = null;
    if (!(($mask0 & 16) === 0))
      smoothing = true;
    Sprite_init_$Init$_0(bitmap, anchorX, anchorY, hitShape, smoothing, $this);
    return $this;
  }
  function _set_animationNumberOfFramesRequested_($this, value) {
    if (value === 0) {
      $this.stopAnimation_sv8swh_k$();
      var tmp0_subject = $this._animationType;
      var tmp = new AnimationType(tmp0_subject);
      var tmp0__get_STANDARD__0 = Companion_getInstance_210();
      if (equals_1(tmp, new AnimationType(_AnimationType___init__impl_(0))))
        triggerEvent($this, $this._get_onAnimationCompleted__0_k$());
      else {
        triggerEvent($this, $this._get_onAnimationStopped__0_k$());
      }
    }$this._animationNumberOfFramesRequested = value;
  }
  function _set_animationRemainingDuration_($this, value) {
    var tmp;
    if (TimeSpan__compareTo_impl(value, Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0)) <= 0) {
      var tmp_0 = new AnimationType($this._animationType);
      var tmp0__get_DURATION__0 = Companion_getInstance_210();
      tmp = equals_1(tmp_0, new AnimationType(_AnimationType___init__impl_(2)));
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      $this.stopAnimation_sv8swh_k$();
      triggerEvent($this, $this.__onAnimationCompleted);
    } else {
    }
    $this._animationRemainingDuration = value;
  }
  function _set_currentSpriteIndex_($this, value) {
    $this._currentSpriteIndex = umod_2(value, $this._get_totalFrames__0_k$());
    var tmp0_safe_receiver = $this._currentAnimation;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getSprite_ha5a7z_k$(value);
    $this._set_bitmap__5a5lwo_k$(tmp1_elvis_lhs == null ? $this._get_bitmap__0_k$() : tmp1_elvis_lhs);
  }
  function getDefaultTime($this, spriteAnimation) {
    return (!(spriteAnimation == null) ? !equals_1(new TimeSpan(spriteAnimation._defaultTimePerFrame), new TimeSpan(Companion_getInstance_92()._NIL)) : false) ? spriteAnimation._defaultTimePerFrame : $this._spriteDisplayTime;
  }
  function nextSprite($this, frameTime) {
    var tmp0_this = $this;
    tmp0_this._lastAnimationFrameTime = TimeSpan__plus_impl(tmp0_this._lastAnimationFrameTime, frameTime);
    if (TimeSpan__compareTo_impl(TimeSpan__plus_impl($this._lastAnimationFrameTime, frameTime), $this._spriteDisplayTime) >= 0) {
      var tmp1_subject = $this._animationType;
      var tmp = new AnimationType(tmp1_subject);
      var tmp0__get_STANDARD__0 = Companion_getInstance_210();
      if (equals_1(tmp, new AnimationType(_AnimationType___init__impl_(0)))) {
        if ($this._animationNumberOfFramesRequested > 0) {
          var tmp2_this = $this;
          var tmp3 = tmp2_this._animationNumberOfFramesRequested;
          _set_animationNumberOfFramesRequested_(tmp2_this, tmp3 - 1 | 0);
          Unit_getInstance();
        }} else {
        var tmp_0 = new AnimationType(tmp1_subject);
        var tmp1__get_DURATION__0 = Companion_getInstance_210();
        if (equals_1(tmp_0, new AnimationType(_AnimationType___init__impl_(2)))) {
          var tmp4_this = $this;
          _set_animationRemainingDuration_(tmp4_this, TimeSpan__minus_impl(tmp4_this._animationRemainingDuration, $this._lastAnimationFrameTime));
        } else {
          var tmp_1 = new AnimationType(tmp1_subject);
          var tmp2__get_LOOPED__0 = Companion_getInstance_210();
          if (equals_1(tmp_1, new AnimationType(_AnimationType___init__impl_(1)))) {
          } else {
          }
        }
      }
      if ($this._reversed) {
        var tmp5_this = $this;
        _set_currentSpriteIndex_(tmp5_this, tmp5_this._currentSpriteIndex - 1 | 0);
        Unit_getInstance();
      } else {
        var tmp6_this = $this;
        _set_currentSpriteIndex_(tmp6_this, tmp6_this._currentSpriteIndex + 1 | 0);
        Unit_getInstance();
      }
      var tmp7_this = $this;
      var tmp8 = tmp7_this._totalFramesPlayed;
      tmp7_this._totalFramesPlayed = tmp8 + 1 | 0;
      Unit_getInstance();
      triggerEvent($this, $this.__onFrameChanged);
      var tmp_2 = $this;
      tmp_2._lastAnimationFrameTime = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    }}
  function updateCurrentAnimation($this, spriteAnimation, spriteDisplayTime, animationCyclesRequested, duration, startFrame, endFrame, looped, reversed_2, type) {
    triggerEvent($this, $this.__onAnimationStarted);
    $this._spriteDisplayTime = spriteDisplayTime;
    $this._currentAnimation = spriteAnimation;
    $this._animationLooped = looped;
    _set_animationRemainingDuration_($this, duration);
    _set_currentSpriteIndex_($this, startFrame);
    $this._reversed = reversed_2;
    $this._animationType = type;
    $this._animationRequested = true;
    var endFrame_0 = umod_2(endFrame, $this._get_totalFrames__0_k$());
    var tmp0_safe_receiver = $this._currentAnimation;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var count_2 = startFrame > endFrame_0 ? reversed_2 ? startFrame - endFrame_0 | 0 : tmp0_safe_receiver._get_spriteStackSize__0_k$() - (startFrame - endFrame_0 | 0) | 0 : endFrame_0 > startFrame ? reversed_2 ? umod_2(startFrame - endFrame_0 | 0, tmp0_safe_receiver._get_spriteStackSize__0_k$()) : endFrame_0 - startFrame | 0 : 0;
      var requestedFrames_3 = count_2 + imul(animationCyclesRequested, tmp0_safe_receiver._get_spriteStackSize__0_k$()) | 0;
      _set_animationNumberOfFramesRequested_($this, requestedFrames_3);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function updateCurrentAnimation$default($this, spriteAnimation, spriteDisplayTime, animationCyclesRequested, duration, startFrame, endFrame, looped, reversed_2, type, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      spriteDisplayTime = getDefaultTime($this, spriteAnimation);
    if (!(($mask0 & 8) === 0))
      animationCyclesRequested = 1;
    if (!(($mask0 & 16) === 0)) {
      duration = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    }if (!(($mask0 & 32) === 0))
      startFrame = 0;
    if (!(($mask0 & 64) === 0))
      endFrame = 0;
    if (!(($mask0 & 128) === 0))
      looped = false;
    if (!(($mask0 & 256) === 0))
      reversed_2 = false;
    if (!(($mask0 & 512) === 0)) {
      var tmp0__get_STANDARD__0 = Companion_getInstance_210();
      type = _AnimationType___init__impl_(0);
    }return updateCurrentAnimation($this, spriteAnimation, spriteDisplayTime, animationCyclesRequested, duration, startFrame, endFrame, looped, reversed_2, type);
  }
  function triggerEvent($this, signal) {
    if (!(signal == null)) {
      var tmp0_safe_receiver = $this._currentAnimation;
      if (tmp0_safe_receiver == null)
        null;
      else {
        signal.invoke_iav7o_k$(tmp0_safe_receiver);
        Unit_getInstance();
      }
      Unit_getInstance();
    }}
  function _no_name_provided__605() {
  }
  _no_name_provided__605.prototype.invoke_o0m8s6_k$ = function ($this$addUpdater, frameTime) {
    if ($this$addUpdater._animationRequested) {
      nextSprite($this$addUpdater, frameTime);
    }};
  _no_name_provided__605.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Sprite ? p1 : THROW_CCE();
    this.invoke_o0m8s6_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__605.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Sprite(bitmap, anchorX, anchorY, hitShape, smoothing) {
    BaseImage.call(this, bitmap, anchorX, anchorY, hitShape, smoothing);
    this._animationRequested = false;
    this._totalFramesPlayed = 0;
    this._animationNumberOfFramesRequested = 0;
    var tmp = this;
    var tmp0__get_STANDARD__0 = Companion_getInstance_210();
    tmp._animationType = _AnimationType___init__impl_(0);
    this.__onAnimationCompleted = null;
    this.__onAnimationStopped = null;
    this.__onAnimationStarted = null;
    this.__onFrameChanged = null;
    var tmp_0 = this;
    tmp_0._spriteDisplayTime = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(50.0);
    this._animationLooped = false;
    var tmp_1 = this;
    tmp_1._lastAnimationFrameTime = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    var tmp_2 = this;
    tmp_2._animationRemainingDuration = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0);
    this._currentAnimation = null;
    this._currentSpriteIndex = 0;
    this._reversed = false;
    addUpdater(this, _no_name_provided_$factory_540());
    Unit_getInstance();
  }
  Sprite.prototype._get_onAnimationCompleted__0_k$ = function () {
    if (this.__onAnimationCompleted == null) {
      var tmp = this;
      tmp.__onAnimationCompleted = Signal_init_$Create$(null, 1, null);
    }return ensureNotNull(this.__onAnimationCompleted);
  };
  Sprite.prototype._get_onAnimationStopped__0_k$ = function () {
    if (this.__onAnimationStopped == null) {
      var tmp = this;
      tmp.__onAnimationStopped = Signal_init_$Create$(null, 1, null);
    }return ensureNotNull(this.__onAnimationStopped);
  };
  Sprite.prototype.playAnimationLooped_g824fy_k$ = function (spriteAnimation, spriteDisplayTime, startFrame, reversed_2) {
    var tmp = startFrame >= 0 ? startFrame : this._currentSpriteIndex;
    var tmp0__get_LOOPED__0 = Companion_getInstance_210();
    return updateCurrentAnimation$default(this, spriteAnimation, spriteDisplayTime, 0, null, tmp, 0, true, reversed_2, _AnimationType___init__impl_(1), 88, null);
  };
  Sprite.prototype.playAnimationLooped$default_2b9tm9_k$ = function (spriteAnimation, spriteDisplayTime, startFrame, reversed_2, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      spriteAnimation = this._currentAnimation;
    if (!(($mask0 & 2) === 0))
      spriteDisplayTime = getDefaultTime(this, spriteAnimation);
    if (!(($mask0 & 4) === 0))
      startFrame = -1;
    if (!(($mask0 & 8) === 0))
      reversed_2 = false;
    return this.playAnimationLooped_g824fy_k$(spriteAnimation, spriteDisplayTime, startFrame, reversed_2);
  };
  Sprite.prototype.stopAnimation_sv8swh_k$ = function () {
    this._animationRequested = false;
    triggerEvent(this, this.__onAnimationStopped);
  };
  Sprite.prototype._get_totalFrames__0_k$ = function () {
    var tmp0_elvis_lhs = this._currentAnimation;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ca = tmp;
    return ca._get_size__0_k$();
  };
  Sprite.$metadata$ = {
    simpleName: 'Sprite',
    kind: 'class',
    interfaces: []
  };
  function _AnimationType___init__impl_(id) {
    return id;
  }
  function Companion_211() {
    Companion_instance_210 = this;
  }
  Companion_211.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_210;
  function Companion_getInstance_210() {
    if (Companion_instance_210 == null)
      new Companion_211();
    return Companion_instance_210;
  }
  function AnimationType__toString_impl(this_0) {
    return '' + 'AnimationType(id=' + this_0 + ')';
  }
  function AnimationType__hashCode_impl(this_0) {
    return this_0;
  }
  function AnimationType__equals_impl(this_0, other) {
    if (!(other instanceof AnimationType))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AnimationType ? other._id_33 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function AnimationType(id) {
    Companion_getInstance_210();
    this._id_33 = id;
  }
  AnimationType.prototype.toString = function () {
    return AnimationType__toString_impl(this._id_33);
  };
  AnimationType.prototype.hashCode = function () {
    return AnimationType__hashCode_impl(this._id_33);
  };
  AnimationType.prototype.equals = function (other) {
    return AnimationType__equals_impl(this._id_33, other);
  };
  AnimationType.$metadata$ = {
    simpleName: 'AnimationType',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_540() {
    var i = new _no_name_provided__605();
    return function (p1, p2) {
      i.invoke_o0m8s6_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function SpriteAnimation_init_$Init$(sprites, defaultTimePerFrame, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      defaultTimePerFrame = Companion_getInstance_92()._NIL;
    SpriteAnimation.call($this, sprites, defaultTimePerFrame);
    return $this;
  }
  function SpriteAnimation_init_$Create$(sprites, defaultTimePerFrame, $mask0, $marker) {
    return SpriteAnimation_init_$Init$(sprites, defaultTimePerFrame, $mask0, $marker, Object.create(SpriteAnimation.prototype));
  }
  function Companion_212() {
    Companion_instance_211 = this;
  }
  Companion_212.prototype.invoke_p6y3a3_k$ = function (spriteMap, spriteWidth, spriteHeight, marginTop, marginLeft, columns, rows, offsetBetweenColumns, offsetBetweenRows) {
    var tmp0_apply_0 = FastArrayList_init_$Create$();
    var inductionVariable = 0;
    if (inductionVariable < rows)
      do {
        var row_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < columns)
          do {
            var col_5 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            tmp0_apply_0.add_2bq_k$(sliceWithSize_1(spriteMap, marginLeft + imul(spriteWidth + offsetBetweenColumns | 0, col_5) | 0, marginTop + imul(spriteHeight + offsetBetweenRows | 0, row_3) | 0, spriteWidth, spriteHeight, '' + 'slice' + tmp0_apply_0._get_size__0_k$()));
            Unit_getInstance();
          }
           while (inductionVariable_0 < columns);
      }
       while (inductionVariable < rows);
    return SpriteAnimation_init_$Create$(tmp0_apply_0, null, 2, null);
  };
  Companion_212.prototype.invoke$default_7wokc9_k$ = function (spriteMap, spriteWidth, spriteHeight, marginTop, marginLeft, columns, rows, offsetBetweenColumns, offsetBetweenRows, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      spriteWidth = 16;
    if (!(($mask0 & 4) === 0))
      spriteHeight = 16;
    if (!(($mask0 & 8) === 0))
      marginTop = 0;
    if (!(($mask0 & 16) === 0))
      marginLeft = 0;
    if (!(($mask0 & 32) === 0))
      columns = 1;
    if (!(($mask0 & 64) === 0))
      rows = 1;
    if (!(($mask0 & 128) === 0))
      offsetBetweenColumns = 0;
    if (!(($mask0 & 256) === 0))
      offsetBetweenRows = 0;
    return this.invoke_p6y3a3_k$(spriteMap, spriteWidth, spriteHeight, marginTop, marginLeft, columns, rows, offsetBetweenColumns, offsetBetweenRows);
  };
  Companion_212.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_211;
  function Companion_getInstance_211() {
    if (Companion_instance_211 == null)
      new Companion_212();
    return Companion_instance_211;
  }
  function SpriteAnimation(sprites, defaultTimePerFrame) {
    Companion_getInstance_211();
    this._sprites = sprites;
    this._defaultTimePerFrame = defaultTimePerFrame;
  }
  SpriteAnimation.prototype._get_spriteStackSize__0_k$ = function () {
    return this._sprites._get_size__0_k$();
  };
  SpriteAnimation.prototype._get_size__0_k$ = function () {
    return this._sprites._get_size__0_k$();
  };
  SpriteAnimation.prototype.getSprite_ha5a7z_k$ = function (index_0) {
    return this._sprites.get_ha5a7z_k$(umod_2(index_0, this._sprites._get_size__0_k$()));
  };
  SpriteAnimation.$metadata$ = {
    simpleName: 'SpriteAnimation',
    kind: 'class',
    interfaces: []
  };
  function Stage(views_0) {
    Container.call(this);
    this._views_15 = views_0;
    this._$$delegate_1 = new Mixin_2();
    this._stage = this;
    this._mouseXY = new Point(0.0, 0.0);
  }
  Stage.prototype._get_views__0_k$ = function () {
    return this._views_15;
  };
  Stage.prototype._get_coroutineContext__0_k$ = function () {
    return this._views_15._coroutineContext_6;
  };
  Stage.prototype.addEventListener_lfkrxw_k$ = function (clazz, handler) {
    return this._$$delegate_1.addEventListener_lfkrxw_k$(clazz, handler);
  };
  Stage.prototype.dispatch_62irmi_k$ = function (clazz, event) {
    this._$$delegate_1.dispatch_62irmi_k$(clazz, event);
  };
  Stage.prototype._get_input__0_k$ = function () {
    return this._views_15._input_3;
  };
  Stage.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    var tmp0_setTo_0 = this._views_15._virtualWidth_0;
    var tmp1_setTo_0 = this._views_15._virtualHeight_0;
    out.setTo_i6u10_k$(0.0, 0.0, numberToDouble(tmp0_setTo_0), numberToDouble(tmp1_setTo_0));
    Unit_getInstance();
  };
  Stage.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (this._views_15._clipBorders_1) {
      var tmp0_useBatcher_0_1 = ctx._batch_0;
      if (!(ctx._currentBatcher === tmp0_useBatcher_0_1)) {
        ctx.flush_sv8swh_k$();
        ctx._currentBatcher = tmp0_useBatcher_0_1;
      }var tmp0__anonymous__2 = ctx._ctx2d;
      var tmp0_scissor_0_3 = this._get_x__0_k$();
      var tmp1_scissor_0_4 = this._get_y__0_k$();
      var tmp2_scissor_0_5 = this._views_15._virtualWidth_0 * this._get_scaleX__0_k$();
      var tmp3_scissor_0_6 = this._views_15._virtualHeight_0 * this._get_scaleY__0_k$();
      var tmp0_scissor_0_1_7 = numberToInt(tmp0_scissor_0_3);
      var tmp1_scissor_0_2_8 = numberToInt(tmp1_scissor_0_4);
      var tmp2_scissor_0_3_9 = numberToInt(tmp2_scissor_0_5);
      var tmp3_scissor_0_4_10 = numberToInt(tmp3_scissor_0_6);
      var tmp0_scissor_0_1_5_11 = tmp0__anonymous__2._tempScissor.setTo_w0xdj4_k$(tmp0_scissor_0_1_7, tmp1_scissor_0_2_8, tmp2_scissor_0_3_9, tmp3_scissor_0_4_10);
      var oldScissor_1_2_6_12 = tmp0__anonymous__2._batch_1._scissor_1;
      var returnScissor_2_3_7_13 = tmp0__anonymous__2.scissorStart_lefq8c_k$(tmp0_scissor_0_1_5_11);
      try {
        Container.prototype.renderInternal_uxru53_k$.call(this, ctx);
      }finally {
        tmp0__anonymous__2.scissorEnd_h27edz_k$(oldScissor_1_2_6_12, returnScissor_2_3_7_13);
      }
    } else {
      Container.prototype.renderInternal_uxru53_k$.call(this, ctx);
    }
  };
  Stage.$metadata$ = {
    simpleName: 'Stage',
    kind: 'class',
    interfaces: [Reference, CoroutineScope, EventDispatcher, ViewsContainer, ResourcesContainer]
  };
  function _no_name_provided__606() {
  }
  _no_name_provided__606.prototype.invoke_dd2oxv_k$ = function (it) {
    return Companion_getInstance_151().invoke_dd2oxv_k$(it);
  };
  _no_name_provided__606.prototype.invoke_20e8_k$ = function (p1) {
    return new VerticalAlign(this.invoke_dd2oxv_k$((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE()));
  };
  _no_name_provided__606.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__607() {
  }
  _no_name_provided__607.prototype.invoke_gepp4v_k$ = function (it) {
    return VerticalAlign__toString_impl(it);
  };
  _no_name_provided__607.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_gepp4v_k$(p1 instanceof VerticalAlign ? p1._ratio : THROW_CCE());
  };
  _no_name_provided__607.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__608() {
  }
  _no_name_provided__608.prototype.invoke_zfvmlt_k$ = function (it) {
    return Companion_getInstance_152().invoke_zfvmlt_k$(it);
  };
  _no_name_provided__608.prototype.invoke_20e8_k$ = function (p1) {
    return new HorizontalAlign(this.invoke_zfvmlt_k$((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE()));
  };
  _no_name_provided__608.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__609() {
  }
  _no_name_provided__609.prototype.invoke_l3qhhv_k$ = function (it) {
    return HorizontalAlign__toString_impl(it);
  };
  _no_name_provided__609.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_l3qhhv_k$(p1 instanceof HorizontalAlign ? p1._ratio_0 : THROW_CCE());
  };
  _no_name_provided__609.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__610() {
  }
  _no_name_provided__610.prototype.invoke_0_k$ = function () {
    return Text_init_$Create$('Text', 0.0, null, null, null, null, false, 126, null);
  };
  _no_name_provided__610.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__611() {
  }
  _no_name_provided__611.prototype.invoke_y981ny_k$ = function ($this$null) {
    $this$null.add_whpltd_k$(text$factory_2(), 'Text');
    Unit_getInstance();
    $this$null.add_m0hu7f_k$(fontSource$factory());
    Unit_getInstance();
    $this$null.add_iop6bz_k$(textSize$factory_2(), Companion_getInstance_212()._DEFAULT_TEXT_SIZE);
    Unit_getInstance();
    $this$null.add_no4f49_k$(autoScaling$factory(), Companion_getInstance_212()._DEFAULT_AUTO_SCALING);
    Unit_getInstance();
    var tmp = verticalAlign$factory();
    var tmp_0 = _no_name_provided_$factory_543();
    $this$null.add_utj6n9_k$(tmp, tmp_0, _no_name_provided_$factory_544());
    var tmp_1 = horizontalAlign$factory();
    var tmp_2 = _no_name_provided_$factory_545();
    $this$null.add_utj6n9_k$(tmp_1, tmp_2, _no_name_provided_$factory_546());
  };
  _no_name_provided__611.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_y981ny_k$(p1 instanceof KTreeSerializerExt ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__611.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $ktreeToViewTreeCOROUTINE$34(_this_, xml, currentVfs, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__199 = _this_;
    this._xml_0 = xml;
    this._currentVfs_5 = currentVfs;
  }
  $ktreeToViewTreeCOROUTINE$34.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._state_1 = 1;
            suspendResult = KTreeSerializerExt.prototype.ktreeToViewTree_nuc85r_k$.call(this.__this__199, this._xml_0, this._currentVfs_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_also_00_2 = suspendResult;
            var tmp_0 = this;
            var tmp0_elvis_lhs_3 = this._tmp0_also_00_2._fontSource;
            tmp_0._tmp0_isNotBlank_0_21 = tmp0_elvis_lhs_3 == null ? '' : tmp0_elvis_lhs_3;
            if (!isBlank(this._tmp0_isNotBlank_0_21)) {
              this._exceptionState = 3;
              this._state_1 = 2;
              suspendResult = this._tmp0_also_00_2.forceLoadFontSource_kixtld_k$(this._currentVfs_5, this._tmp0_also_00_2._fontSource, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 5;
                continue $sm;
              }
            }

            break;
          case 2:
            this._exceptionState = 6;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._exceptionState = 6;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e_4 = this._exception_0;
              printStackTrace(e_4);
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 6;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._tmp0_also_00_2;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $ktreeToViewTreeCOROUTINE$34.$metadata$ = {
    simpleName: '$ktreeToViewTreeCOROUTINE$34',
    kind: 'class',
    interfaces: []
  };
  function Text_init_$Init$(text, textSize, color_0, font, alignment, renderer, autoScaling, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      textSize = Companion_getInstance_212()._DEFAULT_TEXT_SIZE;
    if (!(($mask0 & 4) === 0))
      color_0 = Colors_getInstance()._WHITE_0;
    if (!(($mask0 & 8) === 0))
      font = _get_DefaultTtfFont_();
    if (!(($mask0 & 16) === 0))
      alignment = Companion_getInstance_153()._TOP_LEFT_0;
    if (!(($mask0 & 32) === 0))
      renderer = DefaultStringTextRenderer;
    if (!(($mask0 & 64) === 0))
      autoScaling = Companion_getInstance_212()._DEFAULT_AUTO_SCALING;
    Text_3.call($this, text, textSize, color_0, font, alignment, renderer, autoScaling);
    return $this;
  }
  function Text_init_$Create$(text, textSize, color_0, font, alignment, renderer, autoScaling, $mask0, $marker) {
    return Text_init_$Init$(text, textSize, color_0, font, alignment, renderer, autoScaling, $mask0, $marker, Object.create(Text_3.prototype));
  }
  function Companion_213() {
    Companion_instance_212 = this;
    this._DEFAULT_TEXT_SIZE = 16.0;
    this._DEFAULT_AUTO_SCALING = true;
  }
  Companion_213.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_212;
  function Companion_getInstance_212() {
    if (Companion_instance_212 == null)
      new Companion_213();
    return Companion_instance_212;
  }
  function Serializer_2() {
    Serializer_instance_2 = this;
    var tmp = getKClass_0(Text_3);
    var tmp_0 = _no_name_provided_$factory_541();
    KTreeSerializerExt.call(this, 'Text', tmp, tmp_0, _no_name_provided_$factory_542());
  }
  Serializer_2.prototype.ktreeToViewTree_nuc85r_k$ = function (xml, currentVfs, $cont) {
    var tmp = new $ktreeToViewTreeCOROUTINE$34(this, xml, currentVfs, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Serializer_2.$metadata$ = {
    simpleName: 'Serializer',
    kind: 'object',
    interfaces: []
  };
  var Serializer_instance_2;
  function Serializer_getInstance_2() {
    if (Serializer_instance_2 == null)
      new Serializer_2();
    return Serializer_instance_2;
  }
  function updateLineCount($this) {
    var tmp = $this;
    var tmp0_count_0 = $this._get_text__0_k$();
    var count_1 = 0;
    var indexedObject = tmp0_count_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_3 = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (element_3.equals(new Char(10))) {
        count_1 = count_1 + 1 | 0;
        Unit_getInstance();
      } else {
      }
    }
    tmp._lineCount = count_1 + 1 | 0;
  }
  function _get_textToBitmapResult_($this) {
    var tmp = $this._textToBitmapResult;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('textToBitmapResult');
    }
  }
  function setContainerPosition($this, x, y, baseline) {
    if ($this._autoSize) {
      setRealContainerPosition($this, x, y);
    } else {
      setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl($this._alignment._horizontal, $this.__textBounds._width_0), y - VerticalAlign__getOffsetY_impl($this._alignment._vertical, $this.__textBounds._height_0, baseline));
    }
  }
  function setRealContainerPosition($this, x, y) {
    position($this._container_0, x, y);
    Unit_getInstance();
  }
  function _no_name_provided__612(this$0, $ctx, $fontSource, resultContinuation) {
    this._this$0_163 = this$0;
    this._$ctx_2 = $ctx;
    this._$fontSource = $fontSource;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__612.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__612.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__612.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_163.forceLoadFontSource_kixtld_k$(ensureNotNull(this._$ctx_2._views_8)._currentVfs_9, this._$fontSource, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__612.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__612(this._this$0_163, this._$ctx_2, this._$fontSource, completion);
    return i;
  };
  _no_name_provided__612.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $forceLoadFontSourceCOROUTINE$35(_this_, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__200 = _this_;
    this._currentVfs_6 = currentVfs;
    this._sourceFile_5 = sourceFile;
  }
  $forceLoadFontSourceCOROUTINE$35.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this.__this__200._set_fontSource__qlpr75_k$(this._sourceFile_5);
            this.__this__200._fontLoaded = true;
            if (!(this._sourceFile_5 == null)) {
              this._state_1 = 1;
              var tmp_0 = this._currentVfs_6.get_6wfw3l_k$('' + this._sourceFile_5);
              suspendResult = readFont$default(tmp_0, false, null, false, 7, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            this.__this__200._set_font__aavk6z_k$(ARGUMENT);
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadFontSourceCOROUTINE$35.$metadata$ = {
    simpleName: '$forceLoadFontSourceCOROUTINE$35',
    kind: 'class',
    interfaces: []
  };
  function Text_3(text, textSize, color_0, font, alignment, renderer, autoScaling) {
    Companion_getInstance_212();
    Container.call(this);
    this._smoothing_4 = true;
    this._cachedVersion_3 = -1;
    this._cachedVersionRenderer = -1;
    this._version_4 = 0;
    this._lineCount = 0;
    this._text_6 = text;
    updateLineCount(this);
    this._color_10 = color_0;
    this._font_2 = font;
    this._textSize = textSize;
    this._renderer_0 = renderer;
    this._alignment = alignment;
    var tmp = this;
    var tmp1_addTo_0_2 = new Container();
    var tmp0_apply_0_3 = addTo(tmp1_addTo_0_2, this);
    Unit_getInstance();
    tmp._container_0 = tmp0_apply_0_3;
    this._bitmapFontActions = new Text2TextRendererActions();
    this._fontLoaded = false;
    this._autoScaling_0 = autoScaling;
    this._fontSource = null;
    this.__textBounds = Companion_getInstance_35().invoke_w0xdj4_k$(0, 0, 2048, 2048);
    this._autoSize = true;
    this._boundsVersion = -1;
    var tmp_0 = this;
    tmp_0._tempMatrix_2 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._newTvaRenderer = false;
    this._cachedVersionGlyphMetrics = -1;
    this.__textMetricsResult = null;
    var tmp_1 = this;
    tmp_1._tempBmpEntry = Entry_init_$Create$(null, 0.0, 0.0, 0.0, 0.0, null, 63, null);
    var tmp_2 = this;
    tmp_2._fontMetrics_1 = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    var tmp_3 = this;
    tmp_3._textMetrics = TextMetrics_init_$Create$(null, null, null, 0, 15, null);
    this._lastAutoScaling = null;
    this._lastSmoothing = null;
    this._lastNativeRendering = null;
    this._tva_0 = null;
    var tmp_4 = this;
    tmp_4._identityMat = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._useNativeRendering_0 = true;
    this._autoscaling_0 = new InternalViewAutoscaling();
    var tmp_5 = this;
    tmp_5._imagesToRemove = ArrayList_init_$Create$();
    this.__staticImage = null;
  }
  Text_3.prototype._set_text__a4enbm_k$ = function (value) {
    if (!(this._text_6 === value)) {
      this._text_6 = value;
      updateLineCount(this);
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_3.prototype._get_text__0_k$ = function () {
    return this._text_6;
  };
  Text_3.prototype._set_color__f52nlt_k$ = function (value) {
    if (!equals_1(new RGBA(this._color_10), new RGBA(value))) {
      this._color_10 = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_3.prototype._set_font__aavk6z_k$ = function (value) {
    if (!equals_1(this._font_2, value)) {
      this._font_2 = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_3.prototype._set_textSize__okcceq_k$ = function (value) {
    if (!(this._textSize === value)) {
      this._textSize = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_3.prototype._get_fontSize__0_k$ = function () {
    return this._textSize;
  };
  Text_3.prototype._set_alignment__1x48jb_k$ = function (value) {
    if (!this._alignment.equals(value)) {
      this._alignment = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_3.prototype._set_horizontalAlign__4fnuf6_k$ = function (value) {
    return this._set_alignment__1x48jb_k$(this._alignment.withHorizontal_l3qhhv_k$(value));
  };
  Text_3.prototype._get_horizontalAlign__mfkab4_k$ = function () {
    return this._alignment._horizontal;
  };
  Text_3.prototype._set_verticalAlign__4c4bf4_k$ = function (value) {
    return this._set_alignment__1x48jb_k$(this._alignment.withVertical_gepp4v_k$(value));
  };
  Text_3.prototype._get_verticalAlign__8gdh1a_k$ = function () {
    return this._alignment._vertical;
  };
  Text_3.prototype._set_fontSource__qlpr75_k$ = function (value) {
    this._fontSource = value;
    this._fontLoaded = false;
  };
  Text_3.prototype.forceLoadFontSource_kixtld_k$ = function (currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadFontSourceCOROUTINE$35(this, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Text_3.prototype.setFormat_4idiqv_k$ = function (face, size_2, color_0, align) {
    var tmp0_elvis_lhs = face;
    this._set_font__aavk6z_k$(tmp0_elvis_lhs == null ? _get_DefaultTtfFont_() : tmp0_elvis_lhs);
    this._set_textSize__okcceq_k$(size_2);
    this._set_color__f52nlt_k$(color_0);
    this._set_alignment__1x48jb_k$(align);
  };
  Text_3.prototype.setTextBounds_wf26y9_k$ = function (rect_3) {
    if (this.__textBounds.equals(rect_3) ? !this._autoSize : false)
      return Unit_getInstance();
    this.__textBounds.copyFrom_uebyw0_k$(rect_3);
    Unit_getInstance();
    this._autoSize = false;
    var tmp0_this = this;
    var tmp1 = tmp0_this._boundsVersion;
    tmp0_this._boundsVersion = tmp1 + 1 | 0;
    Unit_getInstance();
    var tmp2_this = this;
    var tmp3 = tmp2_this._version_4;
    tmp2_this._version_4 = tmp3 + 1 | 0;
    Unit_getInstance();
  };
  Text_3.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    this._renderInternal_wm24ss_k$(null);
    out.copyFrom_uebyw0_k$(this.__textBounds);
    Unit_getInstance();
  };
  Text_3.prototype.renderInternal_uxru53_k$ = function (ctx) {
    this._renderInternal_wm24ss_k$(ctx);
    $l$break: while (true) {
      var tmp0_isNotEmpty_0 = this._imagesToRemove;
      if (!!tmp0_isNotEmpty_0.isEmpty_0_k$()) {
        break $l$break;
      }ctx._agBitmapTextureManager.removeBitmap_dwbv7a_k$(removeLast(this._imagesToRemove));
    }
    if (!(this._tva_0 == null)) {
      this._tempMatrix_2.copyFrom_v5f3e9_k$(this._get_globalMatrix__0_k$());
      Unit_getInstance();
      this._tempMatrix_2.pretranslate_ngl742_k$(this._container_0._get_x__0_k$(), this._container_0._get_y__0_k$());
      Unit_getInstance();
      var tmp0_use_0_1 = ctx._batch_0;
      var tmp0_useBatcher_0_1_2 = tmp0_use_0_1._ctx_6;
      if (!(tmp0_useBatcher_0_1_2._currentBatcher === tmp0_use_0_1)) {
        tmp0_useBatcher_0_1_2.flush_sv8swh_k$();
        tmp0_useBatcher_0_1_2._currentBatcher = tmp0_use_0_1;
      }var tmp = this._font_2;
      tmp0_use_0_1.setStateFast_79xbb3_k$((tmp instanceof BitmapFont ? tmp : THROW_CCE())._get_baseBmp__0_k$(), this._smoothing_4, this._get_renderBlendMode__0_k$()._factors, null);
      var tmp_0 = ensureNotNull(this._tva_0);
      tmp0_use_0_1.drawVertices$default_69bxws_k$(tmp_0, this._tempMatrix_2, 0, 0, 0, 28, null);
    } else {
      Container.prototype.renderInternal_uxru53_k$.call(this, ctx);
    }
  };
  Text_3.prototype._renderInternal_wm24ss_k$ = function (ctx) {
    if (!(ctx == null)) {
      var fontSource = this._fontSource;
      if (!this._fontLoaded ? !(fontSource == null) : false) {
        this._fontLoaded = true;
        launchImmediately(ctx._coroutineContext_5, _no_name_provided_$factory_547(this, ctx, fontSource, null));
        Unit_getInstance();
      }}this._container_0._set_colorMul__f52nlt_k$(this._color_10);
    var font = this._font_2.getOrNull_0_k$();
    var tmp;
    var tmp_0;
    if (this._autoSize) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this._boundsVersion === this._version_4);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      this._boundsVersion = this._version_4;
      var metrics = getTextBounds(font, this._textSize, this._get_text__0_k$(), this._textMetrics, this._renderer_0);
      this.__textBounds.copyFrom_uebyw0_k$(metrics._bounds_2);
      Unit_getInstance();
      this.__textBounds._height_0 = font.getFontMetrics_sqtkiv_k$(this._textSize, this._fontMetrics_1)._get_lineHeight__0_k$() * this._lineCount;
      this.__textBounds._x_2 = -HorizontalAlign__getOffsetX_impl(this._alignment._horizontal, this.__textBounds._width_0) + metrics._get_left__0_k$();
      this.__textBounds._y_2 = VerticalAlign__getOffsetY_impl(this._alignment._vertical, this.__textBounds._height_0, -metrics._get_ascent__0_k$());
    } else {
    }
    var tmp0_subject = font;
    if (tmp0_subject == null)
      Unit_getInstance();
    else {
      if (tmp0_subject instanceof BitmapFont) {
        var rversion = this._renderer_0._get_version__0_k$();
        if ((!(this._lastSmoothing === this._smoothing_4) ? true : !(this._cachedVersion_3 === this._version_4)) ? true : !(this._cachedVersionRenderer === rversion)) {
          this._lastSmoothing = this._smoothing_4;
          this._cachedVersionRenderer = rversion;
          this._cachedVersion_3 = this._version_4;
          this.__staticImage = null;
          this._bitmapFontActions._set_x__okcceq_k$(0.0);
          this._bitmapFontActions._set_y__okcceq_k$(0.0);
          this._bitmapFontActions.mreset_sv8swh_k$();
          this._bitmapFontActions._verticalAlign = this._get_verticalAlign__8gdh1a_k$();
          this._bitmapFontActions._horizontalAlign = this._get_horizontalAlign__mfkab4_k$();
          this._renderer_0.invoke_q7g7zr_k$(this._bitmapFontActions, this._get_text__0_k$(), this._textSize, font);
          while (this._container_0._get_numChildren__0_k$() < this._bitmapFontActions._get_size__0_k$()) {
            var tmp1_image_0 = this._container_0;
            var tmp0__get_transparent__0 = Bitmaps_getInstance();
            var tmp2_image_0 = Bitmaps_transparent;
            var tmp0_addTo_0_2 = Image_init_$Create$_0(tmp2_image_0, 0.0, 0.0, null, false, 24, null);
            var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp1_image_0);
            Unit_getInstance();
            Unit_getInstance();
          }
          while (this._container_0._get_numChildren__0_k$() > this._bitmapFontActions._get_size__0_k$()) {
            this._container_0.get_ha5a7z_k$(this._container_0._get_numChildren__0_k$() - 1 | 0).removeFromParent_sv8swh_k$();
          }
          var textWidth = this._bitmapFontActions._get_x__0_k$();
          var dx = -textWidth * _HorizontalAlign___get_ratio__impl_(this._get_horizontalAlign__mfkab4_k$());
          if (this._newTvaRenderer) {
            this._tva_0 = Companion_getInstance_202().forQuads_ha5a7z_k$(this._bitmapFontActions._get_size__0_k$());
          }var inductionVariable = 0;
          var last_1 = this._bitmapFontActions._get_size__0_k$();
          if (inductionVariable < last_1)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this._bitmapFontActions.read_g732d_k$(n, this._tempBmpEntry);
              if (this._newTvaRenderer) {
                var tmp2_safe_receiver = this._tva_0;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  tmp2_safe_receiver.quad_vcy9g9_k$(imul(n, 4), entry._x_15 + dx, entry._y_14, entry._tex._get_width__0_k$() * entry._sx_0, entry._tex._get_height__0_k$() * entry._sy_0, this._identityMat, entry._tex, this._get_renderColorMul__12t64v_k$(), this._get_renderColorAdd__7hz20p_k$());
                  Unit_getInstance();
                }
                Unit_getInstance();
              } else {
                var tmp_1 = this._container_0.get_ha5a7z_k$(n);
                var it = tmp_1 instanceof Image_1 ? tmp_1 : THROW_CCE();
                anchor(it, 0, 0);
                Unit_getInstance();
                it._set_smoothing__rpwsgn_k$(this._smoothing_4);
                it._set_bitmap__5a5lwo_k$(entry._tex);
                it._set_x__okcceq_k$(entry._x_15 + dx);
                it._set_y__okcceq_k$(entry._y_14);
                it._set_scaleX__okcceq_k$(entry._sx_0);
                it._set_scaleY__okcceq_k$(entry._sy_0);
                it._set_rotation__p0vwlp_k$(entry._rot);
              }
            }
             while (inductionVariable < last_1);
          setContainerPosition(this, 0.0, 0.0, font._base_4);
        }} else {
        {
          var onRenderResult = this._autoscaling_0.onRender_2oo7xy_k$(this._autoScaling_0, this._get_globalMatrix__0_k$());
          var lastAutoScalingResult = !(this._lastAutoScaling === this._autoScaling_0);
          if (((onRenderResult ? true : lastAutoScalingResult) ? true : !(this._lastSmoothing === this._smoothing_4)) ? true : !(this._lastNativeRendering === this._useNativeRendering_0)) {
            var tmp3_this = this;
            var tmp4 = tmp3_this._version_4;
            tmp3_this._version_4 = tmp4 + 1 | 0;
            Unit_getInstance();
            this._lastNativeRendering = this._useNativeRendering_0;
            this._lastAutoScaling = this._autoScaling_0;
            this._lastSmoothing = this._smoothing_4;
          }if (!(this._cachedVersion_3 === this._version_4)) {
            this._cachedVersion_3 = this._version_4;
            var realTextSize = this._textSize * this._autoscaling_0._renderedAtScaleXY;
            var tmp_2 = this;
            var tmp_3;
            var tmp3_isNotEmpty_0 = this._get_text__0_k$();
            if (charSequenceLength(tmp3_isNotEmpty_0) > 0) {
              var tmp_4 = this._get_text__0_k$();
              var tmp_5 = new RGBA(Colors_getInstance()._WHITE_0);
              var tmp_6 = this._renderer_0;
              tmp_3 = renderTextToBitmap$default(font, realTextSize, tmp_4, tmp_5, null, true, 0, tmp_6, false, this._useNativeRendering_0, true, 168, null);
            } else {
              {
                var tmp4__get_transparent__0 = Bitmaps_getInstance();
                var tmp_7 = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
                tmp_3 = new TextToBitmapResult(Bitmaps_transparent._bmp, tmp_7, TextMetrics_init_$Create$(null, null, null, 0, 15, null), emptyList());
              }
            }
            tmp_2._textToBitmapResult = tmp_3;
            var met = _get_textToBitmapResult_(this)._metrics;
            var x = -HorizontalAlign__getOffsetX_impl(this._get_horizontalAlign__mfkab4_k$(), met._get_width__0_k$()) + met._get_left__0_k$();
            var y = VerticalAlign__getOffsetY_impl(this._get_verticalAlign__8gdh1a_k$(), met._get_lineHeight__0_k$(), -met._get_ascent__0_k$());
            if (this.__staticImage == null) {
              this._container_0.removeChildren_sv8swh_k$();
              var tmp_8 = this;
              var tmp5_image_0 = this._container_0;
              var tmp6_image_0 = _get_textToBitmapResult_(this)._bmp_1;
              var tmp0_addTo_0_2_0 = Image_init_$Create$_1(tmp6_image_0, 0.0, 0.0, null, false, 24, null);
              var tmp0_apply_0_2_3_0 = addTo(tmp0_addTo_0_2_0, tmp5_image_0);
              Unit_getInstance();
              tmp_8.__staticImage = tmp0_apply_0_2_3_0;
            } else {
              this._imagesToRemove.add_2bq_k$(ensureNotNull(this.__staticImage)._get_bitmap__0_k$()._bmpBase);
              Unit_getInstance();
              var tmp_9 = ensureNotNull(this.__staticImage);
              var tmp_10 = _get_textToBitmapResult_(this)._bmp_1;
              tmp_9._set_bitmap__5a5lwo_k$(slice$default(tmp_10, null, null, 3, null));
            }
            var mscale = 1.0 / this._autoscaling_0._renderedAtScaleXY;
            scale_0(ensureNotNull(this.__staticImage), mscale, mscale);
            Unit_getInstance();
            setContainerPosition(this, x * mscale, y * mscale, font.getFontMetrics_sqtkiv_k$(this._get_fontSize__0_k$(), this._fontMetrics_1)._baseline);
          }var tmp5_safe_receiver = this.__staticImage;
          if (tmp5_safe_receiver == null) {
            Unit_getInstance();
          } else
            tmp5_safe_receiver._set_smoothing__rpwsgn_k$(this._smoothing_4);
        }
      }
    }
  };
  Text_3.$metadata$ = {
    simpleName: 'Text',
    kind: 'class',
    interfaces: [ViewLeaf, IText]
  };
  function text$factory_2() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._get_text__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_text__a4enbm_k$(value);
    });
  }
  function fontSource$factory() {
    return getPropertyCallableRef('fontSource', 1, KMutableProperty1, function (receiver) {
      return receiver._fontSource;
    }, function (receiver_0, value) {
      return receiver_0._set_fontSource__qlpr75_k$(value);
    });
  }
  function textSize$factory_2() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return receiver._textSize;
    }, function (receiver_0, value) {
      return receiver_0._set_textSize__okcceq_k$(value);
    });
  }
  function autoScaling$factory() {
    return getPropertyCallableRef('autoScaling', 1, KMutableProperty1, function (receiver) {
      return receiver._autoScaling_0;
    }, function (receiver_0, value) {
      receiver_0._autoScaling_0 = value;
      return Unit_getInstance();
    });
  }
  function verticalAlign$factory() {
    return getPropertyCallableRef('verticalAlign', 1, KMutableProperty1, function (receiver) {
      return new VerticalAlign(receiver._get_verticalAlign__8gdh1a_k$());
    }, function (receiver_0, value) {
      return receiver_0._set_verticalAlign__4c4bf4_k$(value._ratio);
    });
  }
  function horizontalAlign$factory() {
    return getPropertyCallableRef('horizontalAlign', 1, KMutableProperty1, function (receiver) {
      return new HorizontalAlign(receiver._get_horizontalAlign__mfkab4_k$());
    }, function (receiver_0, value) {
      return receiver_0._set_horizontalAlign__4fnuf6_k$(value._ratio_0);
    });
  }
  function _no_name_provided_$factory_541() {
    var i = new _no_name_provided__610();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_542() {
    var i = new _no_name_provided__611();
    return function (p1) {
      i.invoke_y981ny_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_543() {
    var i = new _no_name_provided__606();
    return function (p1) {
      return new VerticalAlign(i.invoke_dd2oxv_k$(p1));
    };
  }
  function _no_name_provided_$factory_544() {
    var i = new _no_name_provided__607();
    return function (p1) {
      return i.invoke_gepp4v_k$(p1._ratio);
    };
  }
  function _no_name_provided_$factory_545() {
    var i = new _no_name_provided__608();
    return function (p1) {
      return new HorizontalAlign(i.invoke_zfvmlt_k$(p1));
    };
  }
  function _no_name_provided_$factory_546() {
    var i = new _no_name_provided__609();
    return function (p1) {
      return i.invoke_l3qhhv_k$(p1._ratio_0);
    };
  }
  function _no_name_provided_$factory_547(this$0, $ctx, $fontSource, resultContinuation) {
    var i = new _no_name_provided__612(this$0, $ctx, $fontSource, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function IText() {
  }
  IText.$metadata$ = {
    simpleName: 'IText',
    kind: 'interface',
    interfaces: []
  };
  function IHtml() {
  }
  IHtml.$metadata$ = {
    simpleName: 'IHtml',
    kind: 'interface',
    interfaces: []
  };
  function Companion_214() {
    Companion_instance_213 = this;
  }
  Companion_214.prototype.invoke_ciaw91_k$ = function (text, textSize, color_0, font, fontsCatalog) {
    var tmp0_apply_0 = new TextOld();
    var tmp = numberToInt(textSize);
    tmp0_apply_0._set_format__931uz4_k$(Format_init_$Create$(null, color_0, font, tmp, null, null, null, 113, null));
    if (!(text === ''))
      tmp0_apply_0._set_text__a4enbm_k$(text);
    tmp0_apply_0._fontsCatalog_1 = fontsCatalog;
    return tmp0_apply_0;
  };
  Companion_214.prototype.invoke$default_xzsnuq_k$ = function (text, textSize, color_0, font, fontsCatalog, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      textSize = 16.0;
    if (!(($mask0 & 4) === 0))
      color_0 = Colors_getInstance()._WHITE_0;
    if (!(($mask0 & 8) === 0))
      font = _get_debugBmpFont_();
    if (!(($mask0 & 16) === 0))
      fontsCatalog = Html_getInstance()._DefaultFontsCatalog;
    return this.invoke_ciaw91_k$(text, textSize, color_0, font, fontsCatalog);
  };
  Companion_214.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_213;
  function Companion_getInstance_213() {
    if (Companion_instance_213 == null)
      new Companion_214();
    return Companion_instance_213;
  }
  function recalculateBounds($this) {
    $this._fontsCatalog_1.getBounds_ldpub3_k$($this._get_text__0_k$(), $this._get_format__0_k$(), $this._textBounds_0);
  }
  function recalculateBoundsWhenRequired($this) {
    if ($this._autoSize_0)
      recalculateBounds($this);
  }
  function TextOld() {
    Companion_getInstance_213();
    View_init_$Init$(this);
    this._fontsCatalog_1 = Html_getInstance()._DefaultFontsCatalog;
    this._textBounds_0 = Companion_getInstance_35().invoke_w0xdj4_k$(0, 0, 1024, 1024);
    this._tempRect_6 = Companion_getInstance_35().invoke_0_k$();
    this.__text = '';
    this.__html = '';
    this._document_0 = null;
    var tmp = this;
    tmp.__format = Format_init_$Create$(null, null, null, null, null, null, null, 127, null);
    this._filtering_0 = true;
    this._autoSize_0 = true;
    this._bgcolor_4 = Colors_getInstance()._TRANSPARENT_BLACK;
  }
  TextOld.prototype._set_format__931uz4_k$ = function (value) {
    this.__format = value;
    var tmp0_safe_receiver = this._document_0;
    if (!value.equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver._defaultFormat)) {
      var tmp1_safe_receiver = this._document_0;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._defaultFormat;
      if (tmp2_safe_receiver == null) {
        Unit_getInstance();
      } else
        tmp2_safe_receiver._parent_6 = value;
    } else {
    }
    recalculateBoundsWhenRequired(this);
  };
  TextOld.prototype._get_format__0_k$ = function () {
    return this.__format;
  };
  TextOld.prototype._set_text__a4enbm_k$ = function (value) {
    this.__text = value;
    this.__html = '';
    this._document_0 = null;
    recalculateBoundsWhenRequired(this);
  };
  TextOld.prototype._get_text__0_k$ = function () {
    var tmp;
    if (!(this._document_0 == null)) {
      var tmp0_safe_receiver = this._document_0;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._xml;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_text__0_k$();
      tmp = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    } else {
      tmp = this.__text;
    }
    return tmp;
  };
  TextOld.prototype._set_html__a4enbm_k$ = function (value) {
    this._document_0 = Html_getInstance().parse_yph680_k$(value, this._fontsCatalog_1);
    this.relayout_sv8swh_k$();
    ensureNotNull(this._document_0)._defaultFormat._parent_6 = this._get_format__0_k$();
    this.__text = '';
    this.__html = value;
    this.__format = ensureNotNull(this._document_0)._get_firstFormat__0_k$().consolidate_0_k$();
  };
  TextOld.prototype._get_html__0_k$ = function () {
    return !(this._document_0 == null) ? this.__html : this.__text;
  };
  TextOld.prototype.relayout_sv8swh_k$ = function () {
    var tmp0_safe_receiver = this._document_0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.doPositioning_jkszk7_k$(this._fontsCatalog_1, this._textBounds_0);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  TextOld.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (!this._get_visible__0_k$())
      return Unit_getInstance();
    var colorMul = this._get_renderColorMul__12t64v_k$();
    var colorAdd = this._get_renderColorAdd__7hz20p_k$();
    var m = this._get_globalMatrix__0_k$();
    if (!(this._document_0 == null)) {
      var tmp0_fastForEach_0 = ensureNotNull(this._document_0)._get_allSpans__0_k$();
      var n_1 = 0;
      while (n_1 < tmp0_fastForEach_0._get_size__0_k$()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp1__anonymous__3 = tmp0_fastForEach_0.get_ha5a7z_k$(tmp0_2);
        var font_4 = this._fontsCatalog_1.getBitmapFont_khfkyj_k$(tmp1__anonymous__3._format_2._get_computedFace__0_k$());
        var format_5 = tmp1__anonymous__3._format_2;
        drawText_1(font_4, ctx, format_5._get_computedSize__0_k$(), this._get_text__0_k$(), numberToInt(tmp1__anonymous__3._bounds_7._x_2), numberToInt(tmp1__anonymous__3._bounds_7._y_2), m, Companion_getInstance_136().multiply_5llkhf_k$(colorMul, format_5._get_computedColor__12t64v_k$()), colorAdd, this._get_renderBlendMode__0_k$(), this._filtering_0);
      }
    } else {
      var font = this._get_format__0_k$()._get_computedFace__0_k$();
      var anchor_2 = this._get_format__0_k$()._get_computedAlign__0_k$()._anchor;
      this._fontsCatalog_1.getBounds_ldpub3_k$(this._get_text__0_k$(), this._get_format__0_k$(), this._tempRect_6);
      var px = this._textBounds_0._x_2 + (this._textBounds_0._width_0 - this._tempRect_6._width_0) * anchor_2._sx;
      var py = this._textBounds_0._y_2 + (this._textBounds_0._height_0 - this._tempRect_6._height_0) * anchor_2._sy;
      if (!(_RGBA___get_a__impl_(this._bgcolor_4) === 0)) {
        var tmp0_use_0_1 = ctx._batch_0;
        var tmp0_useBatcher_0_1_2 = tmp0_use_0_1._ctx_6;
        if (!(tmp0_useBatcher_0_1_2._currentBatcher === tmp0_use_0_1)) {
          tmp0_useBatcher_0_1_2.flush_sv8swh_k$();
          tmp0_useBatcher_0_1_2._currentBatcher = tmp0_use_0_1;
        }var tmp0__get_white__0_4 = Bitmaps_getInstance();
        var tmp = ctx.getTex_uoiv7r_k$(Bitmaps_white);
        var tmp_0 = this._textBounds_0._x_2;
        var tmp_1 = this._textBounds_0._y_2;
        var tmp_2 = this._textBounds_0._width_0;
        var tmp_3 = this._textBounds_0._height_0;
        var tmp_4 = Companion_getInstance_136().multiply_5llkhf_k$(this._bgcolor_4, this._get_renderColorMul__12t64v_k$());
        var tmp_5 = this._get_renderBlendMode__0_k$()._factors;
        tmp0_use_0_1.drawQuad$default_r2v3rq_k$(tmp, tmp_0, tmp_1, tmp_2, tmp_3, m, false, tmp_4, colorAdd, tmp_5, null, 1024, null);
      }drawText_1(this._fontsCatalog_1.getBitmapFont_khfkyj_k$(font), ctx, this._get_format__0_k$()._get_computedSize__0_k$(), this._get_text__0_k$(), numberToInt(px), numberToInt(py), m, Companion_getInstance_136().multiply_5llkhf_k$(colorMul, this._get_format__0_k$()._get_computedColor__12t64v_k$()), colorAdd, this._get_renderBlendMode__0_k$(), this._filtering_0);
    }
  };
  TextOld.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    if (!(this._document_0 == null)) {
      out.copyFrom_uebyw0_k$(ensureNotNull(this._document_0)._bounds_10);
      Unit_getInstance();
    } else {
      if (this._autoSize_0) {
        this._fontsCatalog_1.getBounds_ldpub3_k$(this._get_text__0_k$(), this._get_format__0_k$(), out);
        out.setToAnchoredRectangle_s80lk4_k$(out, this._get_format__0_k$()._get_computedAlign__0_k$()._anchor, this._textBounds_0);
        Unit_getInstance();
      } else {
        out.copyFrom_uebyw0_k$(this._textBounds_0);
        Unit_getInstance();
      }
    }
  };
  TextOld.$metadata$ = {
    simpleName: 'TextOld',
    kind: 'class',
    interfaces: [IText, IHtml]
  };
  function $forceLoadSourceFileCOROUTINE$36(_this_, views_0, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__201 = _this_;
    this._views_16 = views_0;
    this._currentVfs_7 = currentVfs;
    this._sourceFile_6 = sourceFile;
  }
  $forceLoadSourceFileCOROUTINE$36.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__201.baseForceLoadSourceFile_z71c2l_k$(this.__this__201, this._views_16, this._currentVfs_7, this._sourceFile_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this.__this__201.removeChildren_sv8swh_k$();
            this._state_1 = 2;
            var tmp_0 = this._currentVfs_7.get_6wfw3l_k$('' + this._sourceFile_6);
            suspendResult = readKTree$default(tmp_0, this._views_16, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult instanceof Container ? suspendResult : THROW_CCE();
            var ARGUMENT_0 = ARGUMENT._get_children__0_k$();
            var ARGUMENT_1 = toList_3(ARGUMENT_0);
            this.__this__201.addChildren_j595c9_k$(ARGUMENT_1);
            Unit_getInstance();
            this.__this__201._set_scale__okcceq_k$(1.0);
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadSourceFileCOROUTINE$36.$metadata$ = {
    simpleName: '$forceLoadSourceFileCOROUTINE$36',
    kind: 'class',
    interfaces: []
  };
  function TreeViewRef() {
    Container.call(this);
    this._$$delegate_0_47 = new Mixin_3();
  }
  TreeViewRef.prototype.lazyLoadRenderInternal_hk6fpn_k$ = function (ctx, view) {
    this._$$delegate_0_47.lazyLoadRenderInternal_hk6fpn_k$(ctx, view);
  };
  TreeViewRef.prototype._set_sourceFile__qlpr75_k$ = function (_set___) {
    this._$$delegate_0_47._set_sourceFile__qlpr75_k$(_set___);
  };
  TreeViewRef.prototype._set_sourceTreeLoaded__rpwsgn_k$ = function (_set___) {
    this._$$delegate_0_47._sourceTreeLoaded = _set___;
  };
  TreeViewRef.prototype.baseForceLoadSourceFile_z71c2l_k$ = function (_this__0, views_0, currentVfs, sourceFile, $cont) {
    return this._$$delegate_0_47.baseForceLoadSourceFile_z71c2l_k$(_this__0, views_0, currentVfs, sourceFile, $cont);
  };
  TreeViewRef.prototype.forceLoadSourceFile_mwdcj_k$ = function (views_0, currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadSourceFileCOROUTINE$36(this, views_0, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  TreeViewRef.prototype.renderInternal_uxru53_k$ = function (ctx) {
    this.lazyLoadRenderInternal_hk6fpn_k$(ctx, this);
    Container.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  TreeViewRef.$metadata$ = {
    simpleName: 'TreeViewRef',
    kind: 'class',
    interfaces: [ViewLeaf, ViewFileRef]
  };
  function VectorImage_init_$Init$(shape, autoScaling, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      autoScaling = true;
    VectorImage.call($this, shape, autoScaling);
    return $this;
  }
  function VectorImage_init_$Create$(shape, autoScaling, $mask0, $marker) {
    return VectorImage_init_$Init$(shape, autoScaling, $mask0, $marker, Object.create(VectorImage.prototype));
  }
  function Companion_215() {
    Companion_instance_214 = this;
  }
  Companion_215.prototype.createDefault_0_k$ = function () {
    var tmp0_apply_0_1 = new ShapeBuilder(null, null);
    var tmp0_fill_0_3 = Colors_getInstance()._WHITE_0;
    tmp0_apply_0_1.beginPath_sv8swh_k$();
    rect_1(tmp0_apply_0_1, 0, 0, 100, 100);
    tmp0_apply_0_1.fill_y73s1i_k$(new RGBA(tmp0_fill_0_3));
    var tmp = tmp0_apply_0_1.buildShape_0_k$();
    return VectorImage_init_$Create$(tmp, false, 2, null);
  };
  Companion_215.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_214;
  function Companion_getInstance_214() {
    if (Companion_instance_214 == null)
      new Companion_215();
    return Companion_instance_214;
  }
  function $forceLoadSourceFileCOROUTINE$37(_this_, views_0, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__202 = _this_;
    this._views_17 = views_0;
    this._currentVfs_8 = currentVfs;
    this._sourceFile_7 = sourceFile;
  }
  $forceLoadSourceFileCOROUTINE$37.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__202.baseForceLoadSourceFile_z71c2l_k$(this.__this__202, this._views_17, this._currentVfs_8, this._sourceFile_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = readVectorImage(this._currentVfs_8.get_6wfw3l_k$('' + this._sourceFile_7), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var vector = suspendResult;
            println('' + 'VECTOR: ' + vector);
            this.__this__202._set_shape__wyljoo_k$(vector);
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadSourceFileCOROUTINE$37.$metadata$ = {
    simpleName: '$forceLoadSourceFileCOROUTINE$37',
    kind: 'class',
    interfaces: []
  };
  function VectorImage(shape, autoScaling) {
    Companion_getInstance_214();
    BaseGraphics.call(this, autoScaling);
    this._$$delegate_0_48 = new Mixin_3();
    this._shape_1 = shape;
  }
  VectorImage.prototype.lazyLoadRenderInternal_hk6fpn_k$ = function (ctx, view) {
    this._$$delegate_0_48.lazyLoadRenderInternal_hk6fpn_k$(ctx, view);
  };
  VectorImage.prototype._set_sourceFile__qlpr75_k$ = function (_set___) {
    this._$$delegate_0_48._set_sourceFile__qlpr75_k$(_set___);
  };
  VectorImage.prototype._set_sourceTreeLoaded__rpwsgn_k$ = function (_set___) {
    this._$$delegate_0_48._sourceTreeLoaded = _set___;
  };
  VectorImage.prototype.baseForceLoadSourceFile_z71c2l_k$ = function (_this__0, views_0, currentVfs, sourceFile, $cont) {
    return this._$$delegate_0_48.baseForceLoadSourceFile_z71c2l_k$(_this__0, views_0, currentVfs, sourceFile, $cont);
  };
  VectorImage.prototype._set_shape__wyljoo_k$ = function (value) {
    if (!(this._shape_1 === value)) {
      this._shape_1 = value;
      this._set_dirty__rpwsgn_k$(true);
      this.redrawIfRequired_sv8swh_k$();
      this._set_scale__okcceq_k$(1.0);
    }};
  VectorImage.prototype.drawShape_h81jc_k$ = function (ctx) {
    ctx.draw_ndfaxx_k$(this._shape_1);
  };
  VectorImage.prototype.getShapeBounds_j4ilx6_k$ = function (bb) {
    bb.add_ngl742_k$(0.0, 0.0);
    Unit_getInstance();
    bb.add_27zxwg_k$(this._shape_1._get_width__0_k$(), this._shape_1._get_height__0_k$());
    Unit_getInstance();
  };
  VectorImage.prototype.renderInternal_uxru53_k$ = function (ctx) {
    this.lazyLoadRenderInternal_hk6fpn_k$(ctx, this);
    BaseGraphics.prototype.renderInternal_uxru53_k$.call(this, ctx);
  };
  VectorImage.prototype.forceLoadSourceFile_mwdcj_k$ = function (views_0, currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadSourceFileCOROUTINE$37(this, views_0, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  VectorImage.$metadata$ = {
    simpleName: 'VectorImage',
    kind: 'class',
    interfaces: [ViewFileRef]
  };
  function View_init_$Init$($this) {
    View.call($this, false);
    return $this;
  }
  function Reference() {
  }
  Reference.$metadata$ = {
    simpleName: 'Reference',
    kind: 'interface',
    interfaces: []
  };
  function ColorReference() {
  }
  ColorReference.$metadata$ = {
    simpleName: 'ColorReference',
    kind: 'interface',
    interfaces: []
  };
  function Companion_216() {
    Companion_instance_215 = this;
  }
  Companion_216.prototype.commonAncestor_xozmjw_k$ = function (left, right) {
    var l = left;
    var r = right;
    var lCount = _get_ancestorCount_(l);
    var rCount = _get_ancestorCount_(r);
    while (lCount >= 0 ? true : rCount >= 0) {
      if (equals_1(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        var tmp0 = lCount;
        lCount = tmp0 - 1 | 0;
        Unit_getInstance();
        var tmp1_safe_receiver = l;
        l = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_parent__0_k$();
      }if (rdec) {
        var tmp2 = rCount;
        rCount = tmp2 - 1 | 0;
        Unit_getInstance();
        var tmp3_safe_receiver = r;
        r = tmp3_safe_receiver == null ? null : tmp3_safe_receiver._get_parent__0_k$();
      }}
    return null;
  };
  Companion_216.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_215;
  function Companion_getInstance_215() {
    if (Companion_instance_215 == null)
      new Companion_216();
    return Companion_instance_215;
  }
  function ensureTransform($this) {
    if ($this._validLocalProps)
      return Unit_getInstance();
    $this._validLocalProps = true;
    var t = $this._tempTransform_0;
    t.setMatrixNoReturn_skjkkf_k$($this.__localMatrix);
    $this.__x = t._x_0;
    $this.__y = t._y_0;
    $this.__scaleX = t._scaleX;
    $this.__scaleY = t._scaleY;
    $this.__skewX = t._skewX;
    $this.__skewY = t._skewY;
    $this.__rotation = t._rotation;
  }
  function updateRenderColorTransform($this) {
    $this.__renderColorTransformVersion = $this.__versionColor;
    $this.__requireInvalidateColor = true;
    var parent = $this._get_parent__0_k$();
    var tmp0_safe_receiver = parent;
    if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_filter__0_k$()) == null)) {
      $this.__renderColorTransform.copyFrom_33nyfb_k$($this.__colorTransform);
      Unit_getInstance();
    } else {
      var tmp;
      if (!(parent == null)) {
        tmp = !isInterface($this, ColorReference);
      } else {
        tmp = false;
      }
      if (tmp) {
        $this.__renderColorTransform.setToConcat_qc4ape_k$($this.__colorTransform, parent._get_renderColorTransform__0_k$());
        Unit_getInstance();
      } else {
        {
          $this.__renderColorTransform.copyFrom_33nyfb_k$($this.__colorTransform);
          Unit_getInstance();
        }
      }
    }
  }
  function updateRenderColorTransformIfRequired($this) {
    if ($this.__renderColorTransformVersion === $this.__versionColor)
      return Unit_getInstance();
    updateRenderColorTransform($this);
  }
  function updateRenderBlendMode($this) {
    $this.__renderBlendModeVersion = $this.__version;
    $this.__requireInvalidate = true;
    var tmp = $this;
    var tmp0_subject = $this._blendMode_0;
    var tmp_0;
    if (tmp0_subject.equals(BlendMode_INHERIT_getInstance())) {
      var tmp1_safe_receiver = $this._get_parent__0_k$();
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_renderBlendMode__0_k$();
      tmp_0 = tmp2_elvis_lhs == null ? BlendMode_NORMAL_getInstance_0() : tmp2_elvis_lhs;
    } else {
      tmp_0 = $this._blendMode_0;
    }
    tmp.__renderBlendMode = tmp_0;
  }
  function updateRenderBlendModeIfRequired($this) {
    if ($this.__renderBlendModeVersion === $this.__version)
      return Unit_getInstance();
    updateRenderBlendMode($this);
  }
  function renderFiltered($this, ctx) {
    $this.renderFiltered_o3hpcp_k$(ctx, ensureNotNull($this._filter_0));
  }
  function _no_name_provided__613(this$0) {
    this._this$0_164 = this$0;
  }
  _no_name_provided__613.prototype.invoke_0_k$ = function () {
    return listOf_0(this._this$0_164);
  };
  _no_name_provided__613.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function View(isContainer) {
    Companion_getInstance_215();
    BaseView.call(this);
    this._isContainer = isContainer;
    this._extra_4 = null;
    var tmp = this;
    tmp._bviewAll$delegate = lazy(_no_name_provided_$factory_548(this));
    this._propagateEvents = true;
    this.__hitShape2d = null;
    this._hitShape_0 = null;
    this._hitShapes = null;
    this._ratio_4 = 0.0;
    this.__index = 0;
    this.__parent = null;
    this._speed_2 = 1.0;
    this._name_43 = null;
    this._blendMode_0 = BlendMode_INHERIT_getInstance();
    this.__x = 0.0;
    this.__y = 0.0;
    this.__scaleX = 1.0;
    this.__scaleY = 1.0;
    this.__skewX = _get_radians_(0.0);
    this.__skewY = _get_radians_(0.0);
    this.__rotation = _get_radians_(0.0);
    this.__pos = Companion_getInstance_32().invoke_0_k$();
    var tmp_0 = this;
    tmp_0._tempTransform_0 = Transform_init_$Create$(0.0, 0.0, 0.0, 0.0, null, null, null, 127, null);
    this._mouseEnabled = false;
    this._mouseChildren = true;
    this._visible_2 = true;
    this._validLocalProps = true;
    this._validLocalMatrix = true;
    var tmp_1 = this;
    tmp_1.__localMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_2 = this;
    tmp_2.__globalMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this.__globalMatrixVersion = -1;
    var tmp_3 = this;
    tmp_3.__globalMatrixInv = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this.__globalMatrixInvVersion = -1;
    var tmp_4 = this;
    tmp_4.__colorTransform = new ColorTransform(1.0, 1.0, 1.0, 1.0, 0, 0, 0, 0);
    this.__renderColorTransform = new ColorTransform(1.0, 1.0, 1.0, 1.0, 0, 0, 0, 0);
    this.__renderColorTransformVersion = -1;
    this.__renderBlendMode = BlendMode_INHERIT_getInstance();
    this.__renderBlendModeVersion = -1;
    this._dirtyVertices = true;
    this.__version = 0;
    this.__versionColor = 0;
    this.__requireInvalidate = false;
    this.__requireInvalidateColor = false;
    this.__isFilterSet = false;
    this._filter_0 = null;
    this._debugAnnotate = false;
    this._hitTestEnabled = true;
    var tmp_5 = this;
    tmp_5._tempMatrix1 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_6 = this;
    tmp_6._tempMatrix2 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_7 = this;
    tmp_7._tempMatrix_3 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this.__localBounds2 = Companion_getInstance_35().invoke_0_k$();
    this._hitTestUsingShapes = null;
    var tmp_8 = this;
    tmp_8._boundsTemp = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._bb_2 = new BoundsBuilder();
    this.__localBounds = Companion_getInstance_35().invoke_0_k$();
    this._extraBuildDebugComponent = null;
  }
  View.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._extra_4 = _set___;
  };
  View.prototype._get_extra__0_k$ = function () {
    return this._extra_4;
  };
  View.prototype._get_anchorDispX__0_k$ = function () {
    return 0.0;
  };
  View.prototype._get_anchorDispY__0_k$ = function () {
    return 0.0;
  };
  View.prototype._get__children__0_k$ = function () {
    return null;
  };
  View.prototype._set_hitShape__mda8oa_k$ = function (_set___) {
    this._hitShape_0 = _set___;
  };
  View.prototype._get_hitShape__0_k$ = function () {
    return this._hitShape_0;
  };
  View.prototype._get_hitShapes__0_k$ = function () {
    return this._hitShapes;
  };
  View.prototype._set_hitShape2d__irscnu_k$ = function (value) {
    this.__hitShape2d = value;
  };
  View.prototype._get_hitShape2d__0_k$ = function () {
    if (this.__hitShape2d == null) {
      if (this.__hitShape2d == null ? !(this._get_hitShapes__0_k$() == null) : false) {
        var tmp = this;
        var tmp_0 = ensureNotNull(this._get_hitShapes__0_k$());
        tmp.__hitShape2d = toShape2d$default(tmp_0, false, 1, null);
      }if (this.__hitShape2d == null ? !(this._get_hitShape__0_k$() == null) : false) {
        var tmp_1 = this;
        var tmp_2 = ensureNotNull(this._get_hitShape__0_k$());
        tmp_1.__hitShape2d = toShape2d$default_0(tmp_2, false, 1, null);
      }}var tmp0_elvis_lhs = this.__hitShape2d;
    return tmp0_elvis_lhs == null ? Empty_getInstance() : tmp0_elvis_lhs;
  };
  View.prototype._set_ratio__okcceq_k$ = function (_set___) {
    this._ratio_4 = _set___;
  };
  View.prototype._get_ratio__0_k$ = function () {
    return this._ratio_4;
  };
  View.prototype._set_index__majfzk_k$ = function (value) {
    this.__index = value;
  };
  View.prototype._get_index__0_k$ = function () {
    return this.__index;
  };
  View.prototype._set_parent__f4egqr_k$ = function (value) {
    this.__parent = value;
  };
  View.prototype._get_parent__0_k$ = function () {
    return this.__parent;
  };
  View.prototype._set_name__qlpr75_k$ = function (_set___) {
    this._name_43 = _set___;
  };
  View.prototype._get_name__0_k$ = function () {
    return this._name_43;
  };
  View.prototype._set_blendMode__9dm7zh_k$ = function (value) {
    if (!this._blendMode_0.equals(value)) {
      this._blendMode_0 = value;
      this.invalidate_sv8swh_k$();
    }};
  View.prototype._get_blendMode__0_k$ = function () {
    return this._blendMode_0;
  };
  View.prototype._get_globalSpeed__0_k$ = function () {
    return !(this._get_parent__0_k$() == null) ? ensureNotNull(this._get_parent__0_k$())._get_globalSpeed__0_k$() * this._speed_2 : this._speed_2;
  };
  View.prototype._set_pos__bbtl9s_k$ = function (value) {
    ensureTransform(this);
    if (!(this.__x === value._x_1) ? true : !(this.__y === value._y_1)) {
      this.__x = value._x_1;
      this.__y = value._y_1;
      this.invalidateMatrix_sv8swh_k$();
    }};
  View.prototype._get_pos__0_k$ = function () {
    this.__pos.setTo_ngl742_k$(this._get_x__0_k$(), this._get_y__0_k$());
    Unit_getInstance();
    return this.__pos;
  };
  View.prototype._set_x__okcceq_k$ = function (v) {
    ensureTransform(this);
    if (!(this.__x === v)) {
      this.__x = v;
      this.invalidateMatrix_sv8swh_k$();
    }};
  View.prototype._get_x__0_k$ = function () {
    ensureTransform(this);
    return this.__x;
  };
  View.prototype._set_y__okcceq_k$ = function (v) {
    ensureTransform(this);
    if (!(this.__y === v)) {
      this.__y = v;
      this.invalidateMatrix_sv8swh_k$();
    }};
  View.prototype._get_y__0_k$ = function () {
    ensureTransform(this);
    return this.__y;
  };
  View.prototype._set_scaleX__okcceq_k$ = function (v) {
    ensureTransform(this);
    if (!(this.__scaleX === v)) {
      this.__scaleX = v;
      this.invalidateMatrix_sv8swh_k$();
    }};
  View.prototype._get_scaleX__0_k$ = function () {
    ensureTransform(this);
    return this.__scaleX;
  };
  View.prototype._set_scaleY__okcceq_k$ = function (v) {
    ensureTransform(this);
    if (!(this.__scaleY === v)) {
      this.__scaleY = v;
      this.invalidateMatrix_sv8swh_k$();
    }};
  View.prototype._get_scaleY__0_k$ = function () {
    ensureTransform(this);
    return this.__scaleY;
  };
  View.prototype._set_scale__okcceq_k$ = function (v) {
    this._set_scaleX__okcceq_k$(v);
    this._set_scaleY__okcceq_k$(v);
  };
  View.prototype._get_scale__0_k$ = function () {
    return (this._get_scaleX__0_k$() + this._get_scaleY__0_k$()) / 2.0;
  };
  View.prototype._set_skewX__p0vwlp_k$ = function (v) {
    ensureTransform(this);
    if (!equals_1(new Angle(this.__skewX), new Angle(v))) {
      this.__skewX = v;
      this.invalidateMatrix_sv8swh_k$();
    }};
  View.prototype._get_skewX__gxicn3_k$ = function () {
    ensureTransform(this);
    return this.__skewX;
  };
  View.prototype._set_skewY__p0vwlp_k$ = function (v) {
    ensureTransform(this);
    if (!equals_1(new Angle(this.__skewY), new Angle(v))) {
      this.__skewY = v;
      this.invalidateMatrix_sv8swh_k$();
    }};
  View.prototype._get_skewY__gxicn3_k$ = function () {
    ensureTransform(this);
    return this.__skewY;
  };
  View.prototype._set_rotation__p0vwlp_k$ = function (v) {
    ensureTransform(this);
    if (!equals_1(new Angle(this.__rotation), new Angle(v))) {
      this.__rotation = v;
      this.invalidateMatrix_sv8swh_k$();
    }};
  View.prototype._get_rotation__gxicn3_k$ = function () {
    ensureTransform(this);
    return this.__rotation;
  };
  View.prototype._get_globalX__0_k$ = function () {
    var tmp0_safe_receiver = this._get_parent__0_k$();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.localToGlobalX_ngl742_k$(this._get_x__0_k$(), this._get_y__0_k$());
    return tmp1_elvis_lhs == null ? this._get_x__0_k$() : tmp1_elvis_lhs;
  };
  View.prototype._get_globalY__0_k$ = function () {
    var tmp0_safe_receiver = this._get_parent__0_k$();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.localToGlobalY_ngl742_k$(this._get_x__0_k$(), this._get_y__0_k$());
    return tmp1_elvis_lhs == null ? this._get_y__0_k$() : tmp1_elvis_lhs;
  };
  View.prototype.setSize_ul66c3_k$ = function (width, height) {
    this._set_width__okcceq_k$(width);
    this._set_height__okcceq_k$(height);
  };
  View.prototype._set_width__okcceq_k$ = function (value) {
    this._set_scaleX__okcceq_k$((this._get_scaleX__0_k$() === 0.0 ? 1.0 : this._get_scaleX__0_k$()) * (value / this._get_width__0_k$()));
  };
  View.prototype._get_width__0_k$ = function () {
    return this.getLocalBoundsOptimizedAnchored_0_k$()._width_0;
  };
  View.prototype._set_height__okcceq_k$ = function (value) {
    this._set_scaleY__okcceq_k$((this._get_scaleY__0_k$() === 0.0 ? 1.0 : this._get_scaleY__0_k$()) * (value / this.getLocalBoundsOptimizedAnchored_0_k$()._height_0));
  };
  View.prototype._get_height__0_k$ = function () {
    return this.getLocalBoundsOptimizedAnchored_0_k$()._height_0;
  };
  View.prototype._get_unscaledWidth__0_k$ = function () {
    return this._get_width__0_k$();
  };
  View.prototype._get_unscaledHeight__0_k$ = function () {
    return this._get_height__0_k$();
  };
  View.prototype._set_scaledWidth__okcceq_k$ = function (value) {
    this._set_width__okcceq_k$(this._get_scaleX__0_k$() === 0.0 ? value : value / this._get_scaleX__0_k$());
  };
  View.prototype._get_scaledWidth__0_k$ = function () {
    return this._get_unscaledWidth__0_k$() * this._get_scaleX__0_k$();
  };
  View.prototype._set_scaledHeight__okcceq_k$ = function (value) {
    this._set_height__okcceq_k$(this._get_scaleY__0_k$() === 0.0 ? value : value / this._get_scaleY__0_k$());
  };
  View.prototype._get_scaledHeight__0_k$ = function () {
    return this._get_unscaledHeight__0_k$() * this._get_scaleY__0_k$();
  };
  View.prototype._set_colorMul__f52nlt_k$ = function (v) {
    if (!equals_1(new RGBA(v), new RGBA(this.__colorTransform._get_colorMul__12t64v_k$()))) {
      this.__colorTransform._set_colorMul__f52nlt_k$(v);
      this.invalidateColorTransform_sv8swh_k$();
    }};
  View.prototype._get_colorMul__12t64v_k$ = function () {
    return this.__colorTransform._get_colorMul__12t64v_k$();
  };
  View.prototype._set_colorAdd__fii3aj_k$ = function (v) {
    if (!equals_1(new ColorAdd(v), new ColorAdd(this.__colorTransform._get_colorAdd__7hz20p_k$()))) {
      this.__colorTransform._set_colorAdd__fii3aj_k$(v);
      this.invalidateColorTransform_sv8swh_k$();
    }};
  View.prototype._get_colorAdd__7hz20p_k$ = function () {
    return this.__colorTransform._get_colorAdd__7hz20p_k$();
  };
  View.prototype._set_alpha__okcceq_k$ = function (v) {
    if (!(v === this.__colorTransform._get_mA__0_k$())) {
      this.__colorTransform._set_mA__okcceq_k$(v);
      this.invalidateColorTransform_sv8swh_k$();
    }};
  View.prototype._get_alpha__0_k$ = function () {
    return this.__colorTransform._get_mA__0_k$();
  };
  View.prototype._get_root__0_k$ = function () {
    var tmp0_safe_receiver = this._get_parent__0_k$();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_root__0_k$();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  };
  View.prototype._get_stage__0_k$ = function () {
    var tmp = this._get_root__0_k$();
    return tmp instanceof Stage ? tmp : null;
  };
  View.prototype._set_mouseEnabled__rpwsgn_k$ = function (_set___) {
    this._mouseEnabled = _set___;
  };
  View.prototype._get_mouseEnabled__0_k$ = function () {
    return this._mouseEnabled;
  };
  View.prototype._get_mouseChildren__0_k$ = function () {
    return this._mouseChildren;
  };
  View.prototype._set_visible__rpwsgn_k$ = function (_set___) {
    this._visible_2 = _set___;
  };
  View.prototype._get_visible__0_k$ = function () {
    return this._visible_2;
  };
  View.prototype.setMatrix_skjkkf_k$ = function (matrix) {
    this.__localMatrix.copyFrom_v5f3e9_k$(matrix);
    Unit_getInstance();
    this._validLocalProps = false;
    this.invalidate_sv8swh_k$();
  };
  View.prototype.setMatrixInterpolated_zhpt3m_k$ = function (ratio, l, r) {
    this.__localMatrix.setToInterpolated_1dhpa9_k$(ratio, l, r);
    Unit_getInstance();
    this._validLocalProps = false;
    this.invalidate_sv8swh_k$();
  };
  View.prototype._get_localMatrix__0_k$ = function () {
    if (!this._validLocalMatrix) {
      this._validLocalMatrix = true;
      this.__requireInvalidate = true;
      this.__localMatrix.setTransform_hbf2g_k$(this._get_x__0_k$(), this._get_y__0_k$(), this._get_scaleX__0_k$(), this._get_scaleY__0_k$(), this._get_rotation__gxicn3_k$(), this._get_skewX__gxicn3_k$(), this._get_skewY__gxicn3_k$());
      Unit_getInstance();
    }return this.__localMatrix;
  };
  View.prototype._get_globalMatrix__0_k$ = function () {
    if (!(this.__globalMatrixVersion === this.__version)) {
      this.__globalMatrixVersion = this.__version;
      this.__requireInvalidate = true;
      if (!(this._get_parent__0_k$() == null)) {
        this.__globalMatrix.multiply_yv84xs_k$(this._get_localMatrix__0_k$(), ensureNotNull(this._get_parent__0_k$())._get_globalMatrix__0_k$());
        Unit_getInstance();
      } else {
        this.__globalMatrix.copyFrom_v5f3e9_k$(this._get_localMatrix__0_k$());
        Unit_getInstance();
      }
    }return this.__globalMatrix;
  };
  View.prototype._get_globalMatrixInv__0_k$ = function () {
    if (!(this.__globalMatrixInvVersion === this.__version)) {
      this.__globalMatrixInvVersion = this.__version;
      this.__requireInvalidate = true;
      this.__globalMatrixInv.invert_lwp7hs_k$(this._get_globalMatrix__0_k$());
      Unit_getInstance();
    }return this.__globalMatrixInv;
  };
  View.prototype._set_colorTransform__yu9zyi_k$ = function (v) {
    if (!v.equals(this.__colorTransform)) {
      this.__colorTransform.copyFrom_33nyfb_k$(v);
      Unit_getInstance();
      this.invalidate_sv8swh_k$();
    }};
  View.prototype._get_colorTransform__0_k$ = function () {
    return this.__colorTransform;
  };
  View.prototype._get_renderColorTransform__0_k$ = function () {
    updateRenderColorTransformIfRequired(this);
    return this.__renderColorTransform;
  };
  View.prototype._get_renderBlendMode__0_k$ = function () {
    updateRenderBlendModeIfRequired(this);
    return this.__renderBlendMode;
  };
  View.prototype._get_renderColorMul__12t64v_k$ = function () {
    updateRenderColorTransformIfRequired(this);
    return this.__renderColorTransform._get_colorMul__12t64v_k$();
  };
  View.prototype._get_renderColorAdd__7hz20p_k$ = function () {
    updateRenderColorTransformIfRequired(this);
    return this.__renderColorTransform._get_colorAdd__7hz20p_k$();
  };
  View.prototype.invalidateMatrix_sv8swh_k$ = function () {
    this._validLocalMatrix = false;
    this.invalidate_sv8swh_k$();
  };
  View.prototype._set_dirtyVertices__rpwsgn_k$ = function (_set___) {
    this._dirtyVertices = _set___;
  };
  View.prototype._get_dirtyVertices__0_k$ = function () {
    return this._dirtyVertices;
  };
  View.prototype.invalidate_sv8swh_k$ = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.__version;
    tmp0_this.__version = tmp1 + 1 | 0;
    Unit_getInstance();
    this.__requireInvalidate = false;
    this._dirtyVertices = true;
  };
  View.prototype.invalidateColorTransform_sv8swh_k$ = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.__versionColor;
    tmp0_this.__versionColor = tmp1 + 1 | 0;
    Unit_getInstance();
    this.__requireInvalidateColor = false;
    this._dirtyVertices = true;
  };
  View.prototype._set_filter__gcenm8_k$ = function (value) {
    this._filter_0 = value;
    this.__isFilterSet = !(value == null);
  };
  View.prototype._get_filter__0_k$ = function () {
    return this._filter_0;
  };
  View.prototype.render_uxru53_k$ = function (ctx) {
    if (!this._get_visible__0_k$())
      return Unit_getInstance();
    if (this.__isFilterSet) {
      renderFiltered(this, ctx);
    } else {
      this.renderInternal_uxru53_k$(ctx);
    }
  };
  View.prototype.renderDebug_uxru53_k$ = function (ctx) {
    if (this._debugAnnotate ? true : this === ctx._debugAnnotateView) {
      this.renderDebugAnnotationsInternal_uxru53_k$(ctx);
    }};
  View.prototype.renderDebugAnnotationsInternal_uxru53_k$ = function (ctx) {
    var local = this.getLocalBoundsOptimizedAnchored_0_k$();
    var tmp0_use_0_1 = _get_debugLineRenderContext_(ctx);
    var tmp0_useBatcher_0_1_2 = tmp0_use_0_1._ctx_7;
    if (!(tmp0_useBatcher_0_1_2._currentBatcher === tmp0_use_0_1)) {
      tmp0_useBatcher_0_1_2.flush_sv8swh_k$();
      tmp0_useBatcher_0_1_2._currentBatcher = tmp0_use_0_1;
    }var tmp0_drawVector_0_4 = Colors_getInstance()._RED_0;
    var tmp1_drawVector_0_5 = tmp0_use_0_1._currentMatrix;
    var oldColor_1_1_6 = tmp0_use_0_1._color_6;
    tmp0_use_0_1._color_6 = tmp0_drawVector_0_4;
    try {
      var tmp0_apply_0_1_3_2_7 = VectorPath_init_$Create$(null, null, null, 7, null);
      rect_0(tmp0_apply_0_1_3_2_7, this._get_windowBounds__0_k$());
      tmp0_use_0_1.drawVector_lypuw5_k$(tmp0_apply_0_1_3_2_7, tmp1_drawVector_0_5);
    }finally {
      tmp0_use_0_1._color_6 = oldColor_1_1_6;
    }
    var tmp2_drawVector_0_8 = Colors_getInstance()._WHITE_0;
    var tmp3_drawVector_0_9 = tmp0_use_0_1._currentMatrix;
    var oldColor_1_1_10 = tmp0_use_0_1._color_6;
    tmp0_use_0_1._color_6 = tmp2_drawVector_0_8;
    try {
      var tmp0_apply_0_1_3_2_11 = VectorPath_init_$Create$(null, null, null, 7, null);
      var tmp = new Point(local._get_left__0_k$(), local._get_top__0_k$());
      moveTo_0(tmp0_apply_0_1_3_2_11, this.localToGlobal$default_2xtrnq_k$(tmp, null, 2, null));
      var tmp_0 = new Point(local._get_right__0_k$(), local._get_top__0_k$());
      lineTo_0(tmp0_apply_0_1_3_2_11, this.localToGlobal$default_2xtrnq_k$(tmp_0, null, 2, null));
      var tmp_1 = new Point(local._get_right__0_k$(), local._get_bottom__0_k$());
      lineTo_0(tmp0_apply_0_1_3_2_11, this.localToGlobal$default_2xtrnq_k$(tmp_1, null, 2, null));
      var tmp_2 = new Point(local._get_left__0_k$(), local._get_bottom__0_k$());
      lineTo_0(tmp0_apply_0_1_3_2_11, this.localToGlobal$default_2xtrnq_k$(tmp_2, null, 2, null));
      tmp0_apply_0_1_3_2_11.close_sv8swh_k$();
      tmp0_use_0_1.drawVector_lypuw5_k$(tmp0_apply_0_1_3_2_11, tmp3_drawVector_0_9);
    }finally {
      tmp0_use_0_1._color_6 = oldColor_1_1_10;
    }
    var tmp4_drawVector_0_12 = Colors_getInstance()._YELLOW;
    var tmp5_drawVector_0_13 = tmp0_use_0_1._currentMatrix;
    var oldColor_1_1_14 = tmp0_use_0_1._color_6;
    tmp0_use_0_1._color_6 = tmp4_drawVector_0_12;
    try {
      var tmp0_apply_0_1_3_2_15 = VectorPath_init_$Create$(null, null, null, 7, null);
      var anchorSize_4_16 = 5.0;
      var tmp_3 = _get_topLeft_(local);
      circle_0(tmp0_apply_0_1_3_2_15, this.localToGlobal$default_2xtrnq_k$(tmp_3, null, 2, null), anchorSize_4_16);
      var tmp_4 = _get_topRight_(local);
      circle_0(tmp0_apply_0_1_3_2_15, this.localToGlobal$default_2xtrnq_k$(tmp_4, null, 2, null), anchorSize_4_16);
      var tmp_5 = _get_bottomRight_(local);
      circle_0(tmp0_apply_0_1_3_2_15, this.localToGlobal$default_2xtrnq_k$(tmp_5, null, 2, null), anchorSize_4_16);
      var tmp_6 = _get_bottomLeft_(local);
      circle_0(tmp0_apply_0_1_3_2_15, this.localToGlobal$default_2xtrnq_k$(tmp_6, null, 2, null), anchorSize_4_16);
      var tmp_7 = _get_topLeft_(local).interpolateWith_10r4jk_k$(0.5, _get_topRight_(local));
      circle_0(tmp0_apply_0_1_3_2_15, this.localToGlobal$default_2xtrnq_k$(tmp_7, null, 2, null), anchorSize_4_16);
      var tmp_8 = _get_topRight_(local).interpolateWith_10r4jk_k$(0.5, _get_bottomRight_(local));
      circle_0(tmp0_apply_0_1_3_2_15, this.localToGlobal$default_2xtrnq_k$(tmp_8, null, 2, null), anchorSize_4_16);
      var tmp_9 = _get_bottomRight_(local).interpolateWith_10r4jk_k$(0.5, _get_bottomLeft_(local));
      circle_0(tmp0_apply_0_1_3_2_15, this.localToGlobal$default_2xtrnq_k$(tmp_9, null, 2, null), anchorSize_4_16);
      var tmp_10 = _get_bottomLeft_(local).interpolateWith_10r4jk_k$(0.5, _get_topLeft_(local));
      circle_0(tmp0_apply_0_1_3_2_15, this.localToGlobal$default_2xtrnq_k$(tmp_10, null, 2, null), anchorSize_4_16);
      tmp0_use_0_1.drawVector_lypuw5_k$(tmp0_apply_0_1_3_2_15, tmp5_drawVector_0_13);
    }finally {
      tmp0_use_0_1._color_6 = oldColor_1_1_14;
    }
    var tmp6_drawVector_0_17 = Colors_getInstance()._BLUE_0;
    var tmp7_drawVector_0_18 = tmp0_use_0_1._currentMatrix;
    var oldColor_1_1_19 = tmp0_use_0_1._color_6;
    tmp0_use_0_1._color_6 = tmp6_drawVector_0_17;
    try {
      var tmp0_apply_0_1_3_2_20 = VectorPath_init_$Create$(null, null, null, 7, null);
      var centerX_4_21 = this._get_globalX__0_k$();
      var centerY_5_22 = this._get_globalY__0_k$();
      line_0(tmp0_apply_0_1_3_2_20, centerX_4_21, centerY_5_22 - 5, centerX_4_21, centerY_5_22 + 5);
      line_0(tmp0_apply_0_1_3_2_20, centerX_4_21 - 5, centerY_5_22, centerX_4_21 + 5, centerY_5_22);
      tmp0_use_0_1.drawVector_lypuw5_k$(tmp0_apply_0_1_3_2_20, tmp7_drawVector_0_18);
    }finally {
      tmp0_use_0_1._color_6 = oldColor_1_1_19;
    }
  };
  View.prototype.renderFiltered_o3hpcp_k$ = function (ctx, filter) {
    var bounds_0 = this.getLocalBoundsOptimizedAnchored_0_k$();
    var borderEffect = filter._get_border__0_k$();
    var tmp$ret$4;
    l$ret$5: do {
      var tmp0_alloc_0 = ctx._matrixPool;
      var temp_1 = tmp0_alloc_0.alloc_0_k$();
      try {
        var texWidth_3 = numberToInt(bounds_0._width_0) + imul(borderEffect, 2) | 0;
        var texHeight_4 = numberToInt(bounds_0._height_0) + imul(borderEffect, 2) | 0;
        var addx_5 = -bounds_0._x_2 + borderEffect;
        var addy_6 = -bounds_0._y_2 + borderEffect;
        ctx.flush_sv8swh_k$();
        var tmp0_renderToTexture_0_1_7 = ctx._ag_5;
        var rb_1_2_8 = tmp0_renderToTexture_0_1_7._renderBuffers.alloc_0_k$();
        var tmp0_this_2_3_9 = tmp0_renderToTexture_0_1_7;
        var tmp0_plusAssign_0_3_4_10 = tmp0_this_2_3_9._frameRenderBuffers;
        tmp0_plusAssign_0_3_4_10.add_2bq_k$(rb_1_2_8);
        Unit_getInstance();
        var tmp;
        try {
          rb_1_2_8.setSize_6try9d_k$(0, 0, texWidth_3, texHeight_4, texWidth_3, texHeight_4);
          var old_1_4_5_11 = tmp0_renderToTexture_0_1_7.setRenderBuffer_rpvbnr_k$(rb_1_2_8);
          try {
            var tmp_0 = Colors_getInstance()._TRANSPARENT_BLACK;
            tmp0_renderToTexture_0_1_7.clear$default_qpozyh_k$(tmp_0, 0.0, 0, false, false, false, 62, null);
            var oldScissors_8_6_12 = ctx._batch_0._scissor_1;
            ctx._batch_0._scissor_1 = null;
            try {
              temp_1.copyFrom_v5f3e9_k$(this._get_globalMatrixInv__0_k$());
              Unit_getInstance();
              temp_1.translate_ngl742_k$(addx_5, addy_6);
              Unit_getInstance();
              var tmp0_setViewMatrixTemp_0_11_13 = ctx._batch_0;
              var tmp$ret$2;
              l$ret$3: do {
                var tmp0_alloc_0_1_12_14 = tmp0_setViewMatrixTemp_0_11_13._ctx_6._matrix3DPool;
                var temp_1_2_13_15 = tmp0_alloc_0_1_12_14.alloc_0_k$();
                try {
                  var tmp$ret$0;
                  l$ret$1: do {
                    var tmp0_alloc_0_3_3_14_16 = tmp0_setViewMatrixTemp_0_11_13._ctx_6._matrixPool;
                    var temp_1_4_4_15_17 = tmp0_alloc_0_3_3_14_16.alloc_0_k$();
                    try {
                      tmp0_setViewMatrixTemp_0_11_13.flush$default_9k51td_k$(false, false, 3, null);
                      temp_1_2_13_15.copyFrom_srku5d_k$(tmp0_setViewMatrixTemp_0_11_13._viewMat);
                      Unit_getInstance();
                      temp_1_4_4_15_17.copyFrom_v5f3e9_k$(tmp0_setViewMatrixTemp_0_11_13._viewMat2D);
                      Unit_getInstance();
                      tmp0_setViewMatrixTemp_0_11_13._viewMat2D.copyFrom_v5f3e9_k$(temp_1);
                      Unit_getInstance();
                      copyFrom(tmp0_setViewMatrixTemp_0_11_13._viewMat, temp_1);
                      Unit_getInstance();
                      var tmp_1;
                      try {
                        tmp_1 = this.renderInternal_uxru53_k$(ctx);
                      }finally {
                        tmp0_setViewMatrixTemp_0_11_13.flush$default_9k51td_k$(false, false, 3, null);
                        tmp0_setViewMatrixTemp_0_11_13._viewMat.copyFrom_srku5d_k$(temp_1_2_13_15);
                        Unit_getInstance();
                        tmp0_setViewMatrixTemp_0_11_13._viewMat2D.copyFrom_v5f3e9_k$(temp_1_4_4_15_17);
                        Unit_getInstance();
                      }
                      tmp$ret$0 = tmp_1;
                      break l$ret$1;
                    }finally {
                      tmp0_alloc_0_3_3_14_16.free_iav7o_k$(temp_1_4_4_15_17);
                    }
                  }
                   while (false);
                  tmp$ret$2 = tmp$ret$0;
                  break l$ret$3;
                }finally {
                  tmp0_alloc_0_1_12_14.free_iav7o_k$(temp_1_2_13_15);
                }
              }
               while (false);
              ctx.flush_sv8swh_k$();
            }finally {
              ctx._batch_0._scissor_1 = oldScissors_8_6_12;
            }
          }finally {
            tmp0_renderToTexture_0_1_7.setRenderBuffer_rpvbnr_k$(old_1_4_5_11);
            Unit_getInstance();
          }
          var tmp1__anonymous__9_7_18 = rb_1_2_8._get_tex__0_k$();
          var tmp0__anonymous__16_19 = Companion_getInstance_201().invoke_yvav1y_k$(tmp1__anonymous__9_7_18, texWidth_3, texHeight_4);
          temp_1.copyFrom_v5f3e9_k$(this._get_globalMatrix__0_k$());
          Unit_getInstance();
          temp_1.pretranslate_ngl742_k$(-addx_5, -addy_6);
          Unit_getInstance();
          filter.render_a436xf_k$(ctx, temp_1, tmp0__anonymous__16_19, texWidth_3, texHeight_4, this._get_renderColorAdd__7hz20p_k$(), this._get_renderColorMul__12t64v_k$(), this._blendMode_0);
          tmp = ctx.flush_sv8swh_k$();
        }finally {
          var tmp1_this_5_8_20 = tmp0_renderToTexture_0_1_7;
          var tmp1_minusAssign_0_6_9_21 = tmp1_this_5_8_20._frameRenderBuffers;
          tmp1_minusAssign_0_6_9_21.remove_2bq_k$(rb_1_2_8);
          Unit_getInstance();
          tmp0_renderToTexture_0_1_7._renderBuffers.free_iav7o_k$(rb_1_2_8);
        }
        tmp$ret$4 = tmp;
        break l$ret$5;
      }finally {
        tmp0_alloc_0.free_iav7o_k$(temp_1);
      }
    }
     while (false);
  };
  View.prototype.toString = function () {
    var out = _get_portableSimpleName_(getKClassFromExpression_0(this));
    if (!(this._get_x__0_k$() === 0.0) ? true : !(this._get_y__0_k$() === 0.0))
      out = out + ('' + ':pos=(' + this._get_str__xaho5p_k$(this._get_x__0_k$()) + ',' + this._get_str__xaho5p_k$(this._get_y__0_k$()) + ')');
    if (!(this._get_scaleX__0_k$() === 1.0) ? true : !(this._get_scaleY__0_k$() === 1.0))
      out = out + ('' + ':scale=(' + this._get_str__xaho5p_k$(this._get_scaleX__0_k$()) + ',' + this._get_str__xaho5p_k$(this._get_scaleY__0_k$()) + ')');
    if (!(_Angle___get_radians__impl_(this._get_skewX__gxicn3_k$()) === 0.0) ? true : !(_Angle___get_radians__impl_(this._get_skewY__gxicn3_k$()) === 0.0))
      out = out + ('' + ':skew=(' + this._get_str__xaho5p_k$(_get_degrees_(this._get_skewX__gxicn3_k$())) + ',' + this._get_str__xaho5p_k$(_get_degrees_(this._get_skewY__gxicn3_k$())) + ')');
    if (!equals_1(new Angle(_get_absoluteValue_(this._get_rotation__gxicn3_k$())), new Angle(_get_radians__0(0))))
      out = out + ('' + ':rotation=(' + this._get_str__xaho5p_k$(_get_degrees_(this._get_rotation__gxicn3_k$())) + '\xBA)');
    if (!(this._name_43 == null))
      out = out + ('' + ':name=(' + this._name_43 + ')');
    if (!this._blendMode_0.equals(BlendMode_INHERIT_getInstance()))
      out = out + ('' + ':blendMode=(' + this._blendMode_0 + ')');
    if (!this._get_visible__0_k$())
      out = out + ('' + ':visible=' + this._get_visible__0_k$());
    if (!(this._get_alpha__0_k$() === 1.0))
      out = out + ('' + ':alpha=' + this._get_alpha__0_k$());
    if (!(_RGBA___get_rgb__impl_(this._get_colorMul__12t64v_k$()) === _RGBA___get_rgb__impl_(Colors_getInstance()._WHITE_0)))
      out = out + ('' + ':colorMul=' + _RGBA___get_hexString__impl_(this._get_colorMul__12t64v_k$()));
    var tmp = new ColorAdd(this._get_colorAdd__7hz20p_k$());
    var tmp0__get_NEUTRAL__0 = Companion_getInstance_132();
    if (!equals_1(tmp, new ColorAdd(ColorAdd_NEUTRAL)))
      out = out + ('' + ':colorAdd=' + _ColorAdd___get_shex__impl_(this._get_colorAdd__7hz20p_k$()));
    else {
    }
    return out;
  };
  View.prototype._get_str__xaho5p_k$ = function (_this__0) {
    return toStringDecimal(_this__0, 2, true);
  };
  View.prototype.globalToLocal_p5v4q1_k$ = function (p, out) {
    return this.globalToLocalXY_hj1jb5_k$(p._get_x__0_k$(), p._get_y__0_k$(), out);
  };
  View.prototype.globalToLocalXY_hj1jb5_k$ = function (x, y, out) {
    return this._get_globalMatrixInv__0_k$().transform_hj1jb5_k$(x, y, out);
  };
  View.prototype.globalToLocalX_ngl742_k$ = function (x, y) {
    return this._get_globalMatrixInv__0_k$().transformX_ngl742_k$(x, y);
  };
  View.prototype.globalToLocalY_ngl742_k$ = function (x, y) {
    return this._get_globalMatrixInv__0_k$().transformY_ngl742_k$(x, y);
  };
  View.prototype.localToGlobal_p5v4q1_k$ = function (p, out) {
    return this.localToGlobalXY_hj1jb5_k$(p._get_x__0_k$(), p._get_y__0_k$(), out);
  };
  View.prototype.localToGlobal$default_2xtrnq_k$ = function (p, out, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      out = Companion_getInstance_32().invoke_0_k$();
    return this.localToGlobal_p5v4q1_k$(p, out);
  };
  View.prototype.localToGlobalXY_hj1jb5_k$ = function (x, y, out) {
    return this._get_globalMatrix__0_k$().transform_hj1jb5_k$(x, y, out);
  };
  View.prototype.localToGlobalX_ngl742_k$ = function (x, y) {
    return this._get_globalMatrix__0_k$().transformX_ngl742_k$(x, y);
  };
  View.prototype.localToGlobalY_ngl742_k$ = function (x, y) {
    return this._get_globalMatrix__0_k$().transformY_ngl742_k$(x, y);
  };
  View.prototype.hitTest_j5t4vg_k$ = function (x, y, direction) {
    if (!this._hitTestEnabled)
      return null;
    if (!this._get_visible__0_k$())
      return null;
    var tmp0_safe_receiver = this._get__children__0_k$();
    if (tmp0_safe_receiver == null)
      null;
    else {
      var array_1 = tmp0_safe_receiver._array_4;
      var n_2 = 0;
      while (n_2 < array_1.length) {
        var tmp0_unsafeCast_0_3 = array_1[(tmp0_safe_receiver._get_size__0_k$() - n_2 | 0) - 1 | 0];
        var tmp0__anonymous__5 = tmp0_unsafeCast_0_3;
        var tmp0_safe_receiver_6 = tmp0__anonymous__5.hitTest_j5t4vg_k$(x, y, direction);
        if (tmp0_safe_receiver_6 == null)
          null;
        else {
          return tmp0_safe_receiver_6;
        }
        Unit_getInstance();
        var tmp0_4 = n_2;
        n_2 = tmp0_4 + 1 | 0;
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    var res = this.hitTestInternal$default_j9mo27_k$(x, y, null, 4, null);
    if (!(res == null))
      return res;
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  };
  View.prototype.hitTest$default_j9mo27_k$ = function (x, y, direction, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      direction = HitTestDirection_ANY_getInstance();
    return $handler == null ? this.hitTest_j5t4vg_k$(x, y, direction) : $handler(x, y, direction);
  };
  View.prototype.mouseHitTest_ngl742_k$ = function (x, y) {
    if (!this._hitTestEnabled)
      return null;
    if (!this._get_visible__0_k$())
      return null;
    if (this._get_mouseChildren__0_k$()) {
      var tmp0_safe_receiver = this._get__children__0_k$();
      if (tmp0_safe_receiver == null)
        null;
      else {
        var array_1 = tmp0_safe_receiver._array_4;
        var n_2 = 0;
        while (n_2 < array_1.length) {
          var tmp0_unsafeCast_0_3 = array_1[(tmp0_safe_receiver._get_size__0_k$() - n_2 | 0) - 1 | 0];
          var tmp0__anonymous__5 = tmp0_unsafeCast_0_3;
          var tmp0_safe_receiver_6 = tmp0__anonymous__5.mouseHitTest_ngl742_k$(x, y);
          if (tmp0_safe_receiver_6 == null)
            null;
          else {
            return tmp0_safe_receiver_6;
          }
          Unit_getInstance();
          var tmp0_4 = n_2;
          n_2 = tmp0_4 + 1 | 0;
          Unit_getInstance();
        }
        Unit_getInstance();
      }
      Unit_getInstance();
    }if (!this._get_mouseEnabled__0_k$())
      return null;
    var tmp1_safe_receiver = this.hitTestInternal$default_j9mo27_k$(x, y, null, 4, null);
    if (tmp1_safe_receiver == null)
      null;
    else {
      var area_2 = this.getClippingAreaInternal_0_k$();
      if (!(area_2 == null) ? !contains_9(area_2, x, y) : false)
        return null;
      return tmp1_safe_receiver;
    }
    Unit_getInstance();
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  };
  View.prototype.getClippingAreaInternal_0_k$ = function () {
    DoubleCompanionObject_getInstance();
    DoubleCompanionObject_getInstance();
    DoubleCompanionObject_getInstance();
    DoubleCompanionObject_getInstance();
    this.__localBounds2.setTo_i6u10_k$(-Infinity, -Infinity, Infinity, Infinity);
    Unit_getInstance();
    var count_0 = 0;
    var view_1 = this;
    if (false) {
      var tmp0_safe_receiver_2 = view_1;
      view_1 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2._get_parent__0_k$();
    }while (!(view_1 == null)) {
      var tmp0__anonymous__3 = view_1;
      var tmp;
      var tmp_0;
      if (!(tmp0__anonymous__3 instanceof Stage)) {
        tmp_0 = tmp0__anonymous__3 instanceof FixedSizeContainer;
      } else {
        {
          tmp_0 = false;
        }
      }
      if (tmp_0) {
        tmp = tmp0__anonymous__3._clip_4;
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp0__anonymous__3.getWindowBounds_uebyw0_k$(this.__localBounds);
        Unit_getInstance();
        if (count_0 === 0) {
          this.__localBounds2.copyFrom_uebyw0_k$(this.__localBounds);
          Unit_getInstance();
        } else {
          this.__localBounds2.setToIntersection_x1ktds_k$(this.__localBounds2, this.__localBounds);
          Unit_getInstance();
        }
        var tmp0_4 = count_0;
        count_0 = tmp0_4 + 1 | 0;
        Unit_getInstance();
      } else {
      }
      view_1 = view_1._get_parent__0_k$();
    }
    return count_0 === 0 ? null : this.__localBounds2;
  };
  View.prototype._set_hitTestUsingShapes__3vfqq4_k$ = function (_set___) {
    this._hitTestUsingShapes = _set___;
  };
  View.prototype.hitTestInternal_j5t4vg_k$ = function (x, y, direction) {
    if (!this._hitTestEnabled)
      return null;
    var llx = this.globalToLocalX_ngl742_k$(x, y);
    var lly = this.globalToLocalY_ngl742_k$(x, y);
    var bounds_0 = this.getLocalBoundsOptimizedAnchored_0_k$();
    if (!contains_9(bounds_0, llx, lly))
      return null;
    var anchorDispX = this._get_anchorDispX__0_k$();
    var anchorDispY = this._get_anchorDispY__0_k$();
    var lx = llx + anchorDispX;
    var ly = lly + anchorDispY;
    var hitShape = this._get_hitShape__0_k$();
    var hitShapes = this._get_hitShapes__0_k$();
    if (this._hitTestUsingShapes === true ? true : this._hitTestUsingShapes == null ? !(hitShape == null) ? true : !(hitShapes == null) : false) {
      var tmp0_safe_receiver = hitShapes;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var n_1 = 0;
        while (n_1 < tmp0_safe_receiver._get_size__0_k$()) {
          var tmp0_2 = n_1;
          n_1 = tmp0_2 + 1 | 0;
          var tmp0__anonymous__3 = tmp0_safe_receiver.get_ha5a7z_k$(tmp0_2);
          if (tmp0__anonymous__3.containsPoint_ngl742_k$(lx, ly))
            return this;
        }
        Unit_getInstance();
      }
      Unit_getInstance();
      if (!(hitShape == null) ? hitShape.containsPoint_ngl742_k$(lx, ly) : false)
        return this;
      return null;
    } else {
      return this;
    }
  };
  View.prototype.hitTestInternal$default_j9mo27_k$ = function (x, y, direction, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      direction = HitTestDirection_ANY_getInstance();
    return $handler == null ? this.hitTestInternal_j5t4vg_k$(x, y, direction) : $handler(x, y, direction);
  };
  View.prototype.removeFromParent_sv8swh_k$ = function () {
    if (this._get_parent__0_k$() == null)
      return Unit_getInstance();
    var p = ensureNotNull(this._get_parent__0_k$());
    var inductionVariable = this._get_index__0_k$() + 1 | 0;
    var last_1 = p._get_numChildren__0_k$();
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_this = p.get_ha5a7z_k$(i);
        var tmp2 = tmp1_this._get_index__0_k$();
        tmp1_this._set_index__majfzk_k$(tmp2 - 1 | 0);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    var tmp3_safe_receiver = p._get__children__0_k$();
    if (tmp3_safe_receiver == null)
      null;
    else
      tmp3_safe_receiver.removeAt_ha5a7z_k$(this._get_index__0_k$());
    Unit_getInstance();
    this._set_parent__f4egqr_k$(null);
    this._set_index__majfzk_k$(-1);
  };
  View.prototype.getConcatMatrix_iekifz_k$ = function (target, out, inclusive) {
    if (target === this._get_parent__0_k$()) {
      out.copyFrom_v5f3e9_k$(this._get_localMatrix__0_k$());
      Unit_getInstance();
    } else if (target === this) {
      out.identity_0_k$();
      Unit_getInstance();
    } else {
      var commonAncestor = Companion_getInstance_215().commonAncestor_xozmjw_k$(this, target);
      if (!(commonAncestor === null)) {
        if (target._get_parent__0_k$() == null ? inclusive : false) {
          return out.copyFrom_v5f3e9_k$(this._get_globalMatrix__0_k$());
        }out.multiply_yv84xs_k$(this._get_globalMatrix__0_k$(), target._get_globalMatrixInv__0_k$());
        Unit_getInstance();
      } else {
        out.identity_0_k$();
        Unit_getInstance();
      }
    }
    if (inclusive) {
      out.multiply_yv84xs_k$(out, target._get_localMatrix__0_k$());
      Unit_getInstance();
    }return out;
  };
  View.prototype._get_windowBounds__0_k$ = function () {
    return this.getWindowBounds$default_3nifib_k$(null, 1, null);
  };
  View.prototype.getWindowBounds_uebyw0_k$ = function (out) {
    var tmp = this._get_root__0_k$();
    return this.getBounds$default_kmxszx_k$(tmp, out, false, true, 4, null);
  };
  View.prototype.getWindowBounds$default_3nifib_k$ = function (out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      out = Companion_getInstance_35().invoke_0_k$();
    return this.getWindowBounds_uebyw0_k$(out);
  };
  View.prototype.getGlobalBounds_uebyw0_k$ = function (out) {
    var tmp = this._get_root__0_k$();
    return this.getBounds$default_kmxszx_k$(tmp, out, false, false, 4, null);
  };
  View.prototype._getBounds_yi423v_k$ = function (concat, out, doAnchoring) {
    this.getLocalBounds_q1s19i_k$(out, doAnchoring);
    Unit_getInstance();
    if (!(concat == null) ? !concat.isIdentity_0_k$() : false) {
      var p1x = out._get_left__0_k$();
      var p1y = out._get_top__0_k$();
      var p2x = out._get_right__0_k$();
      var p2y = out._get_top__0_k$();
      var p3x = out._get_right__0_k$();
      var p3y = out._get_bottom__0_k$();
      var p4x = out._get_left__0_k$();
      var p4y = out._get_bottom__0_k$();
      this._bb_2.reset_sv8swh_k$();
      this._bb_2.add_ngl742_k$(concat.transformX_ngl742_k$(p1x, p1y), concat.transformY_ngl742_k$(p1x, p1y));
      Unit_getInstance();
      this._bb_2.add_ngl742_k$(concat.transformX_ngl742_k$(p2x, p2y), concat.transformY_ngl742_k$(p2x, p2y));
      Unit_getInstance();
      this._bb_2.add_ngl742_k$(concat.transformX_ngl742_k$(p3x, p3y), concat.transformY_ngl742_k$(p3x, p3y));
      Unit_getInstance();
      this._bb_2.add_ngl742_k$(concat.transformX_ngl742_k$(p4x, p4y), concat.transformY_ngl742_k$(p4x, p4y));
      Unit_getInstance();
      this._bb_2.getBounds_uebyw0_k$(out);
      Unit_getInstance();
    }return out;
  };
  View.prototype.getBounds_ee6oru_k$ = function (target, out, doAnchoring, inclusive) {
    var tmp0_elvis_lhs = target;
    return this._getBounds_yi423v_k$(this.getConcatMatrix_iekifz_k$(tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs, this._boundsTemp, inclusive), out, doAnchoring);
  };
  View.prototype.getBounds$default_kmxszx_k$ = function (target, out, doAnchoring, inclusive, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      target = this;
    if (!(($mask0 & 2) === 0))
      out = Companion_getInstance_35().invoke_0_k$();
    if (!(($mask0 & 4) === 0))
      doAnchoring = true;
    if (!(($mask0 & 8) === 0))
      inclusive = false;
    return this.getBounds_ee6oru_k$(target, out, doAnchoring, inclusive);
  };
  View.prototype.getLocalBoundsOptimizedAnchored_0_k$ = function () {
    return this.getLocalBounds_q1s19i_k$(this.__localBounds, true);
  };
  View.prototype.getLocalBounds_q1s19i_k$ = function (out, doAnchoring) {
    this.getLocalBoundsInternal_wf26y9_k$(out);
    var it = out;
    if (!doAnchoring) {
      var tmp0_this = it;
      tmp0_this._x_2 = tmp0_this._x_2 + this._get_anchorDispX__0_k$();
      var tmp1_this = it;
      tmp1_this._y_2 = tmp1_this._y_2 + this._get_anchorDispY__0_k$();
    }return it;
  };
  View.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    out.clear_0_k$();
    Unit_getInstance();
  };
  View.prototype.getGlobalMatrixWithAnchor_lwp7hs_k$ = function (out) {
    var view = this;
    out.copyFrom_v5f3e9_k$(view._get_localMatrix__0_k$());
    Unit_getInstance();
    out.pretranslate_ngl742_k$(-view._get_anchorDispX__0_k$(), -view._get_anchorDispY__0_k$());
    Unit_getInstance();
    var tmp0_safe_receiver = view._get_parent__0_k$();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_globalMatrix__0_k$();
    if (tmp1_safe_receiver == null)
      null;
    else {
      out.multiply_yv84xs_k$(out, tmp1_safe_receiver);
    }
    Unit_getInstance();
    return out;
  };
  View.$metadata$ = {
    simpleName: 'View',
    kind: 'class',
    interfaces: [Renderable, Extra, KorgeDebugNode, BView, XY, HitTestable, WithHitShape2d]
  };
  function hasAncestor(_this_, ancestor) {
    var tmp;
    if (equals_1(_this_, ancestor)) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = _this_._get_parent__0_k$();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
      tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    }
    return tmp;
  }
  function _get_ancestorCount_(_this_) {
    var count_0 = 0;
    var tmp0_safe_receiver = _this_;
    var parent = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_parent__0_k$();
    while (!(parent == null)) {
      var tmp1 = count_0;
      count_0 = tmp1 + 1 | 0;
      Unit_getInstance();
      parent = parent._get_parent__0_k$();
    }
    return count_0;
  }
  function addUpdater(_this_, updatable) {
    var component = attach_0(new _no_name_provided__614(_this_, updatable));
    component.update_zah5t7_k$(Companion_getInstance_92()._ZERO);
    var tmp = _no_name_provided_$factory_549(component);
    return new sam$com_soywiz_korio_lang_Cancellable$0_0(tmp);
  }
  function addFixedUpdater(_this_, time, initial, limitCallsPerFrame, updatable) {
    var accum = {_v: new TimeSpan(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0))};
    var component = attach_0(new _no_name_provided__616(_this_, accum, time, updatable, limitCallsPerFrame));
    if (initial) {
      updatable(_this_);
    }var tmp = _no_name_provided_$factory_550(component);
    return new sam$com_soywiz_korio_lang_Cancellable$0_0(tmp);
  }
  function replaceWith(_this_, view) {
    if (equals_1(_this_, view))
      return false;
    if (_this_._get_parent__0_k$() == null)
      return false;
    var tmp0_safe_receiver = view._get_parent__0_k$();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get__children__0_k$();
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.remove_2bq_k$(view);
    Unit_getInstance();
    ensureNotNull(_this_._get_parent__0_k$())._get_childrenInternal__0_k$().set_ddb1qf_k$(_this_._get_index__0_k$(), view);
    Unit_getInstance();
    view._set_index__majfzk_k$(_this_._get_index__0_k$());
    view._set_parent__f4egqr_k$(_this_._get_parent__0_k$());
    _this_._set_parent__f4egqr_k$(null);
    view.invalidate_sv8swh_k$();
    _this_._set_index__majfzk_k$(-1);
    return true;
  }
  function ViewLeaf() {
  }
  ViewLeaf.$metadata$ = {
    simpleName: 'ViewLeaf',
    kind: 'interface',
    interfaces: []
  };
  function scale_0(_this_, sx, sy) {
    _this_._set_scaleX__okcceq_k$(sx);
    _this_._set_scaleY__okcceq_k$(sy);
    return _this_;
  }
  function position(_this_, x, y) {
    return xy(_this_, x, y);
  }
  function size_0(_this_, width, height) {
    _this_.setSize_ul66c3_k$(width, height);
    return _this_;
  }
  function xy(_this_, x, y) {
    _this_._set_x__okcceq_k$(x);
    _this_._set_y__okcceq_k$(y);
    return _this_;
  }
  function hitTest(_this_, pos) {
    var tmp = pos._get_x__0_k$();
    var tmp_0 = pos._get_y__0_k$();
    return _this_.hitTest$default_j9mo27_k$(tmp, tmp_0, null, 4, null);
  }
  function rotation(_this_, rot) {
    _this_._set_rotation__p0vwlp_k$(rot);
    return _this_;
  }
  function alpha(_this_, alpha_0) {
    _this_._set_alpha__okcceq_k$(alpha_0);
    return _this_;
  }
  function xy_0(_this_, p) {
    return xy(_this_, p._get_x__0_k$(), p._get_y__0_k$());
  }
  function addFixedUpdater_0(_this_, timesPerSecond, initial, limitCallsPerFrame, updatable) {
    return addFixedUpdater(_this_, _Frequency___get_timeSpan__impl_(timesPerSecond), initial, limitCallsPerFrame, updatable);
  }
  function addFixedUpdater$default(_this_, timesPerSecond, initial, limitCallsPerFrame, updatable, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      initial = true;
    if (!(($mask0 & 4) === 0))
      limitCallsPerFrame = 16;
    return addFixedUpdater_0(_this_, timesPerSecond, initial, limitCallsPerFrame, updatable);
  }
  function xy_1(_this_, x, y) {
    return xy(_this_, x, y);
  }
  function size_1(_this_, width, height) {
    return size_0(_this_, width, height);
  }
  function foreachDescendant(_this_, handler) {
    if (!(_this_ == null)) {
      handler(_this_);
      if (_this_._isContainer) {
        var tmp0_safe_receiver_1 = _this_._get__children__0_k$();
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          var array_1_2 = tmp0_safe_receiver_1._array_4;
          var n_2_3 = 0;
          while (n_2_3 < array_1_2.length) {
            var tmp0_4_5 = n_2_3;
            n_2_3 = tmp0_4_5 + 1 | 0;
            var tmp0_unsafeCast_0_3_4 = array_1_2[tmp0_4_5];
            var tmp0__anonymous__6 = tmp0_unsafeCast_0_3_4;
            foreachDescendant(tmp0__anonymous__6, handler);
          }
          Unit_getInstance();
        }
        Unit_getInstance();
      }}}
  function sam$com_soywiz_korio_lang_Cancellable$0_0(function_0) {
    this._function_6 = function_0;
  }
  sam$com_soywiz_korio_lang_Cancellable$0_0.prototype.cancel_1ti8hr_k$ = function (e) {
    return this._function_6(e);
  };
  sam$com_soywiz_korio_lang_Cancellable$0_0.$metadata$ = {
    simpleName: 'sam$com_soywiz_korio_lang_Cancellable$0',
    kind: 'class',
    interfaces: [Cancellable]
  };
  function _no_name_provided__614($this_addUpdater, $updatable) {
    this._$this_addUpdater = $this_addUpdater;
    this._$updatable = $updatable;
  }
  _no_name_provided__614.prototype._get_view__0_k$ = function () {
    return this._$this_addUpdater;
  };
  _no_name_provided__614.prototype.update_zah5t7_k$ = function (dt) {
    this._$updatable(this._$this_addUpdater, new TimeSpan(dt));
  };
  _no_name_provided__614.$metadata$ = {
    kind: 'class',
    interfaces: [UpdateComponent]
  };
  function _no_name_provided__615($component) {
    this._$component = $component;
  }
  _no_name_provided__615.prototype.invoke_1ti8hr_k$ = function (it) {
    detach(this._$component);
    Unit_getInstance();
  };
  _no_name_provided__615.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_1ti8hr_k$(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__615.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__616($this_addFixedUpdater, $accum, $time, $updatable, $limitCallsPerFrame) {
    this._$this_addFixedUpdater = $this_addFixedUpdater;
    this._$accum = $accum;
    this._$time_0 = $time;
    this._$updatable_0 = $updatable;
    this._$limitCallsPerFrame = $limitCallsPerFrame;
  }
  _no_name_provided__616.prototype._get_view__0_k$ = function () {
    return this._$this_addFixedUpdater;
  };
  _no_name_provided__616.prototype.update_zah5t7_k$ = function (dt) {
    this._$accum._v = new TimeSpan(TimeSpan__plus_impl(this._$accum._v._milliseconds, dt));
    var calls = 0;
    $l$break: while (TimeSpan__compareTo_impl(this._$accum._v._milliseconds, TimeSpan__times_impl_0(this._$time_0, 0.75)) >= 0) {
      this._$accum._v = new TimeSpan(TimeSpan__minus_impl(this._$accum._v._milliseconds, this._$time_0));
      this._$updatable_0(this._$this_addFixedUpdater);
      var tmp0 = calls;
      calls = tmp0 + 1 | 0;
      Unit_getInstance();
      if (calls >= this._$limitCallsPerFrame) {
        this._$accum._v = new TimeSpan(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0));
        break $l$break;
      }}
    if (calls > 0) {
      if (TimeSpan__compareTo_impl(this._$accum._v._milliseconds, TimeSpan__times_impl_0(this._$time_0, 0.25)) < 0) {
        this._$accum._v = new TimeSpan(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(0.0));
      }}};
  _no_name_provided__616.$metadata$ = {
    kind: 'class',
    interfaces: [UpdateComponent]
  };
  function _no_name_provided__617($component) {
    this._$component_0 = $component;
  }
  _no_name_provided__617.prototype.invoke_1ti8hr_k$ = function (it) {
    detach(this._$component_0);
    Unit_getInstance();
  };
  _no_name_provided__617.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_1ti8hr_k$(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__617.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_548(this$0) {
    var i = new _no_name_provided__613(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_549($component) {
    var i = new _no_name_provided__615($component);
    return function (p1) {
      i.invoke_1ti8hr_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_550($component) {
    var i = new _no_name_provided__617($component);
    return function (p1) {
      i.invoke_1ti8hr_k$(p1);
      return Unit_getInstance();
    };
  }
  function _get_collisionContext_() {
    var tmp0_getValue_0 = collisionContext$factory();
    return collisionContext$delegate._local.get_0_k$();
  }
  var collisionContext$delegate;
  function ViewCollisionContext() {
    var tmp = this;
    tmp._tempMat = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._tempRect1 = Companion_getInstance_35().invoke_0_k$();
    this._tempRect2 = Companion_getInstance_35().invoke_0_k$();
    var tmp_0 = this;
    tmp_0._tempVectorPath1 = listOf_0(VectorPath_init_$Create$(null, null, null, 7, null));
    var tmp_1 = this;
    tmp_1._tempVectorPath2 = listOf_0(VectorPath_init_$Create$(null, null, null, 7, null));
    var tmp_2 = this;
    tmp_2._ident = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_3 = this;
    tmp_3._lmat = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_4 = this;
    tmp_4._rmat = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  }
  ViewCollisionContext.prototype.collidesWith_f1ahee_k$ = function (left, right, kind) {
    left.getGlobalBounds_uebyw0_k$(this._tempRect1);
    Unit_getInstance();
    right.getGlobalBounds_uebyw0_k$(this._tempRect2);
    Unit_getInstance();
    if (!this._tempRect1.intersects_uebyw0_k$(this._tempRect2))
      return false;
    if (kind.equals(CollisionKind_SHAPE_getInstance())) {
      var leftShape = left._get_hitShape2d__0_k$();
      var rightShape = right._get_hitShape2d__0_k$();
      var ml = left.getGlobalMatrixWithAnchor_lwp7hs_k$(this._lmat);
      var mr = right.getGlobalMatrixWithAnchor_lwp7hs_k$(this._rmat);
      return Companion_getInstance_51().intersects_r62lph_k$(leftShape, ml, rightShape, mr, this._tempMat);
    }return true;
  };
  ViewCollisionContext.$metadata$ = {
    simpleName: 'ViewCollisionContext',
    kind: 'class',
    interfaces: []
  };
  var CollisionKind_GLOBAL_RECT_instance;
  var CollisionKind_SHAPE_instance;
  var CollisionKind_entriesInitialized;
  function CollisionKind_initEntries() {
    if (CollisionKind_entriesInitialized)
      return Unit_getInstance();
    CollisionKind_entriesInitialized = true;
    CollisionKind_GLOBAL_RECT_instance = new CollisionKind('GLOBAL_RECT', 0);
    CollisionKind_SHAPE_instance = new CollisionKind('SHAPE', 1);
  }
  function CollisionKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CollisionKind.$metadata$ = {
    simpleName: 'CollisionKind',
    kind: 'class',
    interfaces: []
  };
  function collidesWith(_this_, other, kind) {
    return _get_collisionContext_().collidesWith_f1ahee_k$(_this_, other, kind);
  }
  function onCollision(_this_, filter, root, kind, callback) {
    return addUpdater(_this_, _no_name_provided_$factory_553(root, filter, kind, callback));
  }
  function onCollision$default(_this_, filter, root, kind, callback, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      filter = _no_name_provided_$factory_552();
    }if (!(($mask0 & 2) === 0))
      root = null;
    if (!(($mask0 & 4) === 0))
      kind = CollisionKind_GLOBAL_RECT_getInstance();
    return onCollision(_this_, filter, root, kind, callback);
  }
  function _no_name_provided__618() {
  }
  _no_name_provided__618.prototype.invoke_0_k$ = function () {
    return new ViewCollisionContext();
  };
  _no_name_provided__618.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__619() {
  }
  _no_name_provided__619.prototype.invoke_upazaj_k$ = function (it) {
    return true;
  };
  _no_name_provided__619.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_upazaj_k$(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__619.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__620($this_addUpdater, $filter, $kind, $callback) {
    this._$this_addUpdater_0 = $this_addUpdater;
    this._$filter_2 = $filter;
    this._$kind = $kind;
    this._$callback_6 = $callback;
  }
  _no_name_provided__620.prototype.invoke_4l6ao4_k$ = function (it) {
    if ((!equals_1(this._$this_addUpdater_0, it) ? this._$filter_2(it) : false) ? collidesWith(this._$this_addUpdater_0, it, this._$kind) : false) {
      this._$callback_6(this._$this_addUpdater_0, it);
    }};
  _no_name_provided__620.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_4l6ao4_k$(p1 instanceof View ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__620.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__621($root, $filter, $kind, $callback) {
    this._$root = $root;
    this._$filter_3 = $filter;
    this._$kind_0 = $kind;
    this._$callback_7 = $callback;
  }
  _no_name_provided__621.prototype.invoke_gd6pyi_k$ = function ($this$addUpdater, it) {
    var tmp0_elvis_lhs = this._$root;
    var tmp = tmp0_elvis_lhs == null ? $this$addUpdater._get_root__0_k$() : tmp0_elvis_lhs;
    foreachDescendant(tmp, _no_name_provided_$factory_554($this$addUpdater, this._$filter_3, this._$kind_0, this._$callback_7));
  };
  _no_name_provided__621.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof View ? p1 : THROW_CCE();
    this.invoke_gd6pyi_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__621.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CollisionKind_GLOBAL_RECT_getInstance() {
    CollisionKind_initEntries();
    return CollisionKind_GLOBAL_RECT_instance;
  }
  function CollisionKind_SHAPE_getInstance() {
    CollisionKind_initEntries();
    return CollisionKind_SHAPE_instance;
  }
  function collisionContext$factory() {
    return getPropertyCallableRef('collisionContext', 0, KProperty0, function () {
      return _get_collisionContext_();
    }, null);
  }
  function _no_name_provided_$factory_551() {
    var i = new _no_name_provided__618();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_552() {
    var i = new _no_name_provided__619();
    return function (p1) {
      return i.invoke_upazaj_k$(p1);
    };
  }
  function _no_name_provided_$factory_553($root, $filter, $kind, $callback) {
    var i = new _no_name_provided__621($root, $filter, $kind, $callback);
    return function (p1, p2) {
      i.invoke_gd6pyi_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_554($this_addUpdater, $filter, $kind, $callback) {
    var i = new _no_name_provided__620($this_addUpdater, $filter, $kind, $callback);
    return function (p1) {
      i.invoke_4l6ao4_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__622($view, $ctx, this$0, resultContinuation) {
    this._$view = $view;
    this._$ctx_3 = $ctx;
    this._this$0_165 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__622.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__622.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__622.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = ensureNotNull(this._$ctx_3._views_8);
            suspendResult = this._$view.forceLoadSourceFile$default_nkqr3g_k$(tmp_0, null, this._this$0_165._sourceFile_8, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__622.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__622(this._$view, this._$ctx_3, this._this$0_165, completion);
    return i;
  };
  _no_name_provided__622.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function Mixin_3() {
    this._sourceTreeLoaded = true;
    this._sourceFile_8 = null;
  }
  Mixin_3.prototype._set_sourceTreeLoaded__rpwsgn_k$ = function (_set___) {
    this._sourceTreeLoaded = _set___;
  };
  Mixin_3.prototype._set_sourceFile__qlpr75_k$ = function (value) {
    this._sourceTreeLoaded = false;
    this._sourceFile_8 = value;
  };
  Mixin_3.prototype.baseForceLoadSourceFile_z71c2l_k$ = function (_this__0, views_0, currentVfs, sourceFile, $cont) {
    _this__0._set_sourceFile__qlpr75_k$(sourceFile);
    _this__0._set_sourceTreeLoaded__rpwsgn_k$(true);
  };
  Mixin_3.prototype.forceLoadSourceFile_mwdcj_k$ = function (views_0, currentVfs, sourceFile, $cont) {
    throw new NotImplementedError('An operation is not implemented: Must override this');
  };
  Mixin_3.prototype.lazyLoadRenderInternal_hk6fpn_k$ = function (ctx, view) {
    if (this._sourceTreeLoaded)
      return Unit_getInstance();
    this.lazyLoadRenderInternalActually_hk6fpn_k$(ctx, view);
  };
  Mixin_3.prototype.lazyLoadRenderInternalActually_hk6fpn_k$ = function (ctx, view) {
    if (!this._sourceTreeLoaded ? !(this._sourceFile_8 == null) : false) {
      this._sourceTreeLoaded = true;
      launchImmediately(ctx._coroutineContext_5, _no_name_provided_$factory_555(view, ctx, this, null));
      Unit_getInstance();
    }};
  Mixin_3.$metadata$ = {
    simpleName: 'Mixin',
    kind: 'class',
    interfaces: [ViewFileRef]
  };
  function ViewFileRef() {
  }
  ViewFileRef.prototype.forceLoadSourceFile$default_nkqr3g_k$ = function (views_0, currentVfs, sourceFile, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      currentVfs = views_0._currentVfs_9;
    if (!(($mask0 & 4) === 0))
      sourceFile = null;
    return $handler == null ? this.forceLoadSourceFile_mwdcj_k$(views_0, currentVfs, sourceFile, $cont) : $handler(views_0, currentVfs, sourceFile);
  };
  ViewFileRef.$metadata$ = {
    simpleName: 'ViewFileRef',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_555($view, $ctx, this$0, resultContinuation) {
    var i = new _no_name_provided__622($view, $ctx, this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  var views$delegate;
  function KorgeFileLoaderTester(name, tester) {
    this._name_44 = name;
    this._tester = tester;
  }
  KorgeFileLoaderTester.prototype.invoke_glb5i0_k$ = function (s, injector_0, $cont) {
    return this._tester(s, injector_0, $cont);
  };
  KorgeFileLoaderTester.prototype.toString = function () {
    return '' + 'KorgeFileTester("' + this._name_44 + '")';
  };
  KorgeFileLoaderTester.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_44);
    result = imul(result, 31) + hashCode(this._tester) | 0;
    return result;
  };
  KorgeFileLoaderTester.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeFileLoaderTester))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof KorgeFileLoaderTester ? other : THROW_CCE();
    if (!(this._name_44 === tmp0_other_with_cast._name_44))
      return false;
    if (!equals_1(this._tester, tmp0_other_with_cast._tester))
      return false;
    return true;
  };
  KorgeFileLoaderTester.$metadata$ = {
    simpleName: 'KorgeFileLoaderTester',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__623(this$0) {
    this._this$0_166 = this$0;
  }
  _no_name_provided__623.prototype.invoke_0_k$ = function () {
    return !(this._this$0_166._settingsFolder_1 == null) ? ensureNotNull(this._this$0_166._settingsFolder_1) : OS_getInstance()._get_isMac__0_k$() ? '' + '/Users/' + Companion_getInstance_112().get_6wfw3l_k$('USER') + '/Library/Preferences/' + this._this$0_166._get_gameIdFolder__0_k$() : OS_getInstance()._get_isWindows__0_k$() ? '' + Companion_getInstance_112().get_6wfw3l_k$('APPDATA') + '/' + this._this$0_166._get_gameIdFolder__0_k$() : '' + Companion_getInstance_112().get_6wfw3l_k$('HOME') + '/.config/' + this._this$0_166._get_gameIdFolder__0_k$();
  };
  _no_name_provided__623.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__624($callback) {
    this._$callback_8 = $callback;
  }
  _no_name_provided__624.prototype.close_sv8swh_k$ = function ($cont) {
    return this._$callback_8($cont);
  };
  _no_name_provided__624.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncCloseable]
  };
  function _no_name_provided__625(this$0, resultContinuation) {
    this._this$0_167 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__625.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__625.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__625.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_167.closeSuspend_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__625.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__625(this._this$0_167, completion);
    return i;
  };
  _no_name_provided__625.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__626(this$0) {
    this._this$0_168 = this$0;
  }
  _no_name_provided__626.prototype.invoke_uxru53_k$ = function (it) {
    this._this$0_168._renderContext.flush_sv8swh_k$();
    this._this$0_168._renderContext.finish_sv8swh_k$();
    this._this$0_168._agBitmapTextureManager_1.afterRender_sv8swh_k$();
  };
  _no_name_provided__626.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_uxru53_k$(p1 instanceof RenderContext ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__626.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $closeSuspendCOROUTINE$38(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__203 = _this_;
  }
  $closeSuspendCOROUTINE$38.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            tmp_0._tmp0_fastForEach_00_0 = this.__this__203._closeables;
            this._n_11_0 = 0;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this._n_11_0 < this._tmp0_fastForEach_00_0._get_size__0_k$())) {
              this._state_1 = 3;
              continue $sm;
            }
            var tmp_1 = this;
            var tmp0_2 = this._n_11_0;
            this._n_11_0 = tmp0_2 + 1 | 0;
            tmp_1._tmp1__anonymous__32_0 = this._tmp0_fastForEach_00_0.get_ha5a7z_k$(tmp0_2);
            this._state_1 = 2;
            suspendResult = this._tmp1__anonymous__32_0.close_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._state_1 = 1;
            continue $sm;
          case 3:
            this.__this__203._closeables.clear_sv8swh_k$();
            cancel$default(this.__this__203._coroutineContext_6, null, 1, null);
            this.__this__203._gameWindow_1.close_sv8swh_k$();
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $closeSuspendCOROUTINE$38.$metadata$ = {
    simpleName: '$closeSuspendCOROUTINE$38',
    kind: 'class',
    interfaces: []
  };
  function Views(coroutineContext, ag, injector_0, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads) {
    this._coroutineContext_6 = coroutineContext;
    this._ag_6 = ag;
    this._injector_7 = injector_0;
    this._input_3 = input;
    this._timeProvider_3 = timeProvider;
    this._stats_2 = stats;
    this._gameWindow_1 = gameWindow;
    this._gameId_1 = gameId;
    this._settingsFolder_1 = settingsFolder;
    this._batchMaxQuads_2 = batchMaxQuads;
    var tmp = this;
    tmp._$$delegate_0_49 = Mixin_init_$Create$(null, 1, null);
    this._$$delegate_1_0 = new Mixin_2();
    this._views_18 = this;
    this._serializer = new KTreeSerializer(this);
    var tmp_0 = this;
    tmp_0._realSettingsFolder$delegate = lazy(_no_name_provided_$factory_557(this));
    this._name_45 = null;
    this._currentVfs_9 = _get_resourcesVfs_();
    this._imageFormats_3 = RegisteredImageFormats_getInstance();
    this._renderContext = new RenderContext(this._ag_6, this, this._stats_2, this._coroutineContext_6, this._batchMaxQuads_2);
    this._agBitmapTextureManager_1 = this._renderContext._agBitmapTextureManager;
    this._clearEachFrame_1 = true;
    this._clearColor = Colors_getInstance()._BLACK_0;
    var tmp_1 = this;
    tmp_1._propsTriggers = HashMap_init_$Create$();
    var tmp_2 = this;
    tmp_2._clampElapsedTimeTo = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(100.0);
    var tmp_3 = this;
    var tmp_4 = this._currentVfs_9;
    tmp_3._resources = Resources_init_$Create$(this._coroutineContext_6, tmp_4, null, 4, null);
    this._editingMode = false;
    var tmp_5 = this;
    DefaultViewport_getInstance();
    tmp_5._virtualWidth_0 = 1280;
    var tmp_6 = this;
    DefaultViewport_getInstance();
    tmp_6._virtualHeight_0 = 720;
    this._actualVirtualLeft = 0;
    this._actualVirtualTop = 0;
    var tmp_7 = this;
    DefaultViewport_getInstance();
    tmp_7._actualVirtualWidth = 1280;
    var tmp_8 = this;
    DefaultViewport_getInstance();
    tmp_8._actualVirtualHeight = 720;
    var tmp_9 = this;
    tmp_9._closeables = ArrayList_init_$Create$();
    this._scaleMode_4 = Companion_getInstance_37()._SHOW_ALL;
    this._scaleAnchor_1 = Companion_getInstance_25()._MIDDLE_CENTER;
    this._clipBorders_1 = true;
    var tmp_10 = this;
    tmp_10._resizedEvent = ReshapeEvent_init_$Create$(0, 0, 0, 0, 12, null);
    this._stage_0 = new Stage(this);
    this._root_5 = this._stage_0;
    this._supportTogglingDebug = true;
    this._debugViews = false;
    this._debugHandlers = FastArrayList_init_$Create$();
    this._lastTime_0 = this._timeProvider_3.now_utobi1_k$();
    this._tempViews = FastArrayList_init_$Create$();
    this._virtualSize = Companion_getInstance_39().invoke_qgazdw_k$();
    this._actualSize = Companion_getInstance_39().invoke_qgazdw_k$();
    this._targetSize = Companion_getInstance_39().invoke_qgazdw_k$();
    var tmp_11 = this;
    tmp_11._onBeforeRender = Signal_init_$Create$(null, 1, null);
    var tmp_12 = this;
    tmp_12._onAfterRender = Signal_init_$Create$(null, 1, null);
    this._targetFps_1 = -1.0;
    this._injector_7.mapInstance_770c45_k$(getKClass_0(CoroutineContext), this._coroutineContext_6);
    Unit_getInstance();
    this._injector_7.mapInstance_770c45_k$(getKClass_0(AG), this._ag_6);
    Unit_getInstance();
    this._injector_7.mapInstance_770c45_k$(getKClass_0(Views), this);
    Unit_getInstance();
    this._onAfterRender.invoke_o72mru_k$(_no_name_provided_$factory_558(this));
    Unit_getInstance();
    installFpsDebugOverlay(this);
    var tmp_13 = this;
    tmp_13._debugHighlighters = Signal_init_$Create$(null, 1, null);
    var tmp_14 = this;
    tmp_14._debugSavedHandlers = Signal_init_$Create$(null, 1, null);
    var tmp_15 = this;
    tmp_15._completedEditing = Signal_init_$Create$(null, 1, null);
    var tmp_16 = this;
    tmp_16._viewExtraBuildDebugComponent = ArrayList_init_$Create$();
  }
  Views.prototype._get_coroutineContext__0_k$ = function () {
    return this._coroutineContext_6;
  };
  Views.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_49._set_extra__n1onou_k$(_set___);
  };
  Views.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_49._get_extra__0_k$();
  };
  Views.prototype.addEventListener_lfkrxw_k$ = function (clazz, handler) {
    return this._$$delegate_1_0.addEventListener_lfkrxw_k$(clazz, handler);
  };
  Views.prototype._get_views__0_k$ = function () {
    return this._views_18;
  };
  Views.prototype._get_serializer__0_k$ = function () {
    return this._serializer;
  };
  Views.prototype._get_gameIdFolder__0_k$ = function () {
    var tmp = replace$default_0(this._gameId_1, '\\', '', false, 4, null);
    var tmp_0 = replace$default_0(tmp, '/', '', false, 4, null);
    return replace$default_0(tmp_0, '..', '', false, 4, null);
  };
  Views.prototype._get_globalResources__0_k$ = function () {
    return this._resources;
  };
  Views.prototype._get_nativeWidth__0_k$ = function () {
    return this._ag_6._get_mainRenderBuffer__0_k$()._get_width__0_k$();
  };
  Views.prototype._get_nativeHeight__0_k$ = function () {
    return this._ag_6._get_mainRenderBuffer__0_k$()._get_height__0_k$();
  };
  Views.prototype._get_virtualLeft__0_k$ = function () {
    return (-this._actualVirtualLeft | 0) * this._views_18._stage_0._get_scaleX__0_k$();
  };
  Views.prototype._get_virtualTop__0_k$ = function () {
    return (-this._actualVirtualTop | 0) * this._views_18._stage_0._get_scaleY__0_k$();
  };
  Views.prototype._get_virtualRight__0_k$ = function () {
    return this._get_virtualLeft__0_k$() + this._virtualWidth_0 * this._views_18._stage_0._get_scaleX__0_k$();
  };
  Views.prototype._get_virtualBottom__0_k$ = function () {
    return this._get_virtualTop__0_k$() + this._virtualHeight_0 * this._views_18._stage_0._get_scaleY__0_k$();
  };
  Views.prototype.onClose_4udvt5_k$ = function (callback) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._closeables;
    var tmp1_plusAssign_0 = new _no_name_provided__624(callback);
    tmp0_plusAssign_0.add_2bq_k$(tmp1_plusAssign_0);
    Unit_getInstance();
  };
  Views.prototype.close_sv8swh_k$ = function () {
    launchImmediately_0(this, _no_name_provided_$factory_559(this, null));
    Unit_getInstance();
  };
  Views.prototype.closeSuspend_sv8swh_k$ = function ($cont) {
    var tmp = new $closeSuspendCOROUTINE$38(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Views.prototype._get_nativeMouseX__0_k$ = function () {
    return this._input_3._mouse_0._x_1;
  };
  Views.prototype._get_nativeMouseY__0_k$ = function () {
    return this._input_3._mouse_0._y_1;
  };
  Views.prototype.addDebugRenderer_qyxj66_k$ = function (block) {
    this._debugHandlers.add_2bq_k$(block);
    Unit_getInstance();
  };
  Views.prototype.dispatch_62irmi_k$ = function (clazz, event) {
    var e = event;
    try {
      this._stage_0.dispatch_62irmi_k$(clazz, event);
      var stagedViews = getAllDescendantViews(this._stage_0, this._tempViews, true);
      var tmp0_subject = e;
      if (tmp0_subject instanceof MouseEvent_0) {
        var tmp$ret$0;
        l$ret$1: do {
          e.__stopPropagation = false;
          var array_1_1 = stagedViews._array_4;
          var n_2_2 = 0;
          while (n_2_2 < array_1_1.length) {
            var tmp0_4_5 = n_2_2;
            n_2_2 = tmp0_4_5 + 1 | 0;
            var tmp0_unsafeCast_0_3_4 = array_1_1[tmp0_4_5];
            var tmp0__anonymous__5_3 = tmp0_unsafeCast_0_3_4;
            var comps_6_6 = tmp0__anonymous__5_3.__components;
            var tmp0_safe_receiver_7_7 = comps_6_6;
            if (tmp0_safe_receiver_7_7 == null)
              null;
            else {
              var tmp0_safe_receiver_2_8_8 = comps_6_6._mouse;
              if (tmp0_safe_receiver_2_8_8 == null)
                null;
              else {
                var array_1_3_9_9 = tmp0_safe_receiver_2_8_8._array_4;
                var n_2_4_10_10 = 0;
                while (n_2_4_10_10 < array_1_3_9_9.length) {
                  var tmp0_4_7_13_13 = n_2_4_10_10;
                  n_2_4_10_10 = tmp0_4_7_13_13 + 1 | 0;
                  var tmp0_unsafeCast_0_3_6_12_12 = array_1_3_9_9[tmp0_4_7_13_13];
                  var tmp0__anonymous__5_5_11_11 = tmp0_unsafeCast_0_3_6_12_12;
                  tmp0__anonymous__5_5_11_11.onMouseEvent_ja6erc_k$(this._views_18, e);
                  if (e.__stopPropagation) {
                    tmp$ret$0 = Unit_getInstance();
                    break l$ret$1;
                  }}
                Unit_getInstance();
              }
              Unit_getInstance();
            }
            Unit_getInstance();
          }
        }
         while (false);
      } else {
        if (tmp0_subject instanceof TouchEvent_0) {
          var tmp$ret$2;
          l$ret$3: do {
            e.__stopPropagation = false;
            var array_1_1_0 = stagedViews._array_4;
            var n_2_2_0 = 0;
            while (n_2_2_0 < array_1_1_0.length) {
              var tmp0_4_5_0 = n_2_2_0;
              n_2_2_0 = tmp0_4_5_0 + 1 | 0;
              var tmp0_unsafeCast_0_3_4_0 = array_1_1_0[tmp0_4_5_0];
              var tmp0__anonymous__5_3_0 = tmp0_unsafeCast_0_3_4_0;
              var comps_6_6_0 = tmp0__anonymous__5_3_0.__components;
              var tmp0_safe_receiver_7_7_0 = comps_6_6_0;
              if (tmp0_safe_receiver_7_7_0 == null)
                null;
              else {
                var tmp0_safe_receiver_2_8_8_0 = comps_6_6_0._touch;
                if (tmp0_safe_receiver_2_8_8_0 == null)
                  null;
                else {
                  var array_1_3_9_9_0 = tmp0_safe_receiver_2_8_8_0._array_4;
                  var n_2_4_10_10_0 = 0;
                  while (n_2_4_10_10_0 < array_1_3_9_9_0.length) {
                    var tmp0_4_7_13_13_0 = n_2_4_10_10_0;
                    n_2_4_10_10_0 = tmp0_4_7_13_13_0 + 1 | 0;
                    var tmp0_unsafeCast_0_3_6_12_12_0 = array_1_3_9_9_0[tmp0_4_7_13_13_0];
                    var tmp0__anonymous__5_5_11_11_0 = tmp0_unsafeCast_0_3_6_12_12_0;
                    tmp0__anonymous__5_5_11_11_0.onTouchEvent_k01v9u_k$(this._views_18, e);
                    if (e.__stopPropagation) {
                      tmp$ret$2 = Unit_getInstance();
                      break l$ret$3;
                    }}
                  Unit_getInstance();
                }
                Unit_getInstance();
              }
              Unit_getInstance();
            }
          }
           while (false);
        } else {
          if (tmp0_subject instanceof ReshapeEvent) {
            var tmp$ret$4;
            l$ret$5: do {
              e.__stopPropagation = false;
              var array_1_1_1 = stagedViews._array_4;
              var n_2_2_1 = 0;
              while (n_2_2_1 < array_1_1_1.length) {
                var tmp0_4_5_1 = n_2_2_1;
                n_2_2_1 = tmp0_4_5_1 + 1 | 0;
                var tmp0_unsafeCast_0_3_4_1 = array_1_1_1[tmp0_4_5_1];
                var tmp0__anonymous__5_3_1 = tmp0_unsafeCast_0_3_4_1;
                var comps_6_6_1 = tmp0__anonymous__5_3_1.__components;
                var tmp0_safe_receiver_7_7_1 = comps_6_6_1;
                if (tmp0_safe_receiver_7_7_1 == null)
                  null;
                else {
                  var tmp0_safe_receiver_2_8_8_1 = comps_6_6_1._resize;
                  if (tmp0_safe_receiver_2_8_8_1 == null)
                    null;
                  else {
                    var array_1_3_9_9_1 = tmp0_safe_receiver_2_8_8_1._array_4;
                    var n_2_4_10_10_1 = 0;
                    while (n_2_4_10_10_1 < array_1_3_9_9_1.length) {
                      var tmp0_4_7_13_13_1 = n_2_4_10_10_1;
                      n_2_4_10_10_1 = tmp0_4_7_13_13_1 + 1 | 0;
                      var tmp0_unsafeCast_0_3_6_12_12_1 = array_1_3_9_9_1[tmp0_4_7_13_13_1];
                      var tmp0__anonymous__5_5_11_11_1 = tmp0_unsafeCast_0_3_6_12_12_1;
                      tmp0__anonymous__5_5_11_11_1.resized_tdt231_k$(this._views_18, e._width_15, e._height_16);
                      if (e.__stopPropagation) {
                        tmp$ret$4 = Unit_getInstance();
                        break l$ret$5;
                      }}
                    Unit_getInstance();
                  }
                  Unit_getInstance();
                }
                Unit_getInstance();
              }
            }
             while (false);
          } else {
            if (tmp0_subject instanceof KeyEvent) {
              this._input_3.triggerOldKeyEvent_hkhmy8_k$(e);
              this._input_3._keys_0.triggerKeyEvent_hkhmy8_k$(e);
              if ((e._type_16.equals(Type_UP_getInstance_0()) ? this._supportTogglingDebug : false) ? e._key_3.equals(Key_F12_getInstance()) ? true : e._key_3.equals(Key_F7_getInstance()) : false) {
                this._debugViews = !this._debugViews;
                this._gameWindow_1._set_debug__rpwsgn_k$(this._debugViews);
              }var tmp$ret$6;
              l$ret$7: do {
                e.__stopPropagation = false;
                var array_1_1_2 = stagedViews._array_4;
                var n_2_2_2 = 0;
                while (n_2_2_2 < array_1_1_2.length) {
                  var tmp0_4_5_2 = n_2_2_2;
                  n_2_2_2 = tmp0_4_5_2 + 1 | 0;
                  var tmp0_unsafeCast_0_3_4_2 = array_1_1_2[tmp0_4_5_2];
                  var tmp0__anonymous__5_3_2 = tmp0_unsafeCast_0_3_4_2;
                  var comps_6_6_2 = tmp0__anonymous__5_3_2.__components;
                  var tmp0_safe_receiver_7_7_2 = comps_6_6_2;
                  if (tmp0_safe_receiver_7_7_2 == null)
                    null;
                  else {
                    var tmp0_safe_receiver_2_8_8_2 = comps_6_6_2._key_4;
                    if (tmp0_safe_receiver_2_8_8_2 == null)
                      null;
                    else {
                      var array_1_3_9_9_2 = tmp0_safe_receiver_2_8_8_2._array_4;
                      var n_2_4_10_10_2 = 0;
                      while (n_2_4_10_10_2 < array_1_3_9_9_2.length) {
                        var tmp0_4_7_13_13_2 = n_2_4_10_10_2;
                        n_2_4_10_10_2 = tmp0_4_7_13_13_2 + 1 | 0;
                        var tmp0_unsafeCast_0_3_6_12_12_2 = array_1_3_9_9_2[tmp0_4_7_13_13_2];
                        var tmp0__anonymous__5_5_11_11_2 = tmp0_unsafeCast_0_3_6_12_12_2;
                        tmp0__anonymous__5_5_11_11_2.onKeyEvent_m6zpgk_k$(this._views_18, e);
                        Unit_getInstance();
                        if (e.__stopPropagation) {
                          tmp$ret$6 = Unit_getInstance();
                          break l$ret$7;
                        }}
                      Unit_getInstance();
                    }
                    Unit_getInstance();
                  }
                  Unit_getInstance();
                }
              }
               while (false);
            } else {
              if (tmp0_subject instanceof GamePadConnectionEvent) {
                var tmp$ret$8;
                l$ret$9: do {
                  e.__stopPropagation = false;
                  var array_1_1_3 = stagedViews._array_4;
                  var n_2_2_3 = 0;
                  while (n_2_2_3 < array_1_1_3.length) {
                    var tmp0_4_5_3 = n_2_2_3;
                    n_2_2_3 = tmp0_4_5_3 + 1 | 0;
                    var tmp0_unsafeCast_0_3_4_3 = array_1_1_3[tmp0_4_5_3];
                    var tmp0__anonymous__5_3_3 = tmp0_unsafeCast_0_3_4_3;
                    var comps_6_6_3 = tmp0__anonymous__5_3_3.__components;
                    var tmp0_safe_receiver_7_7_3 = comps_6_6_3;
                    if (tmp0_safe_receiver_7_7_3 == null)
                      null;
                    else {
                      var tmp0_safe_receiver_2_8_8_3 = comps_6_6_3._gamepad_2;
                      if (tmp0_safe_receiver_2_8_8_3 == null)
                        null;
                      else {
                        var array_1_3_9_9_3 = tmp0_safe_receiver_2_8_8_3._array_4;
                        var n_2_4_10_10_3 = 0;
                        while (n_2_4_10_10_3 < array_1_3_9_9_3.length) {
                          var tmp0_4_7_13_13_3 = n_2_4_10_10_3;
                          n_2_4_10_10_3 = tmp0_4_7_13_13_3 + 1 | 0;
                          var tmp0_unsafeCast_0_3_6_12_12_3 = array_1_3_9_9_3[tmp0_4_7_13_13_3];
                          var tmp0__anonymous__5_5_11_11_3 = tmp0_unsafeCast_0_3_6_12_12_3;
                          tmp0__anonymous__5_5_11_11_3.onGamepadEvent_j2wo1a_k$(this._views_18, e);
                          Unit_getInstance();
                          if (e.__stopPropagation) {
                            tmp$ret$8 = Unit_getInstance();
                            break l$ret$9;
                          }}
                        Unit_getInstance();
                      }
                      Unit_getInstance();
                    }
                    Unit_getInstance();
                  }
                }
                 while (false);
              } else {
                if (tmp0_subject instanceof GamePadUpdateEvent) {
                  var tmp$ret$10;
                  l$ret$11: do {
                    e.__stopPropagation = false;
                    var array_1_1_4 = stagedViews._array_4;
                    var n_2_2_4 = 0;
                    while (n_2_2_4 < array_1_1_4.length) {
                      var tmp0_4_5_4 = n_2_2_4;
                      n_2_2_4 = tmp0_4_5_4 + 1 | 0;
                      var tmp0_unsafeCast_0_3_4_4 = array_1_1_4[tmp0_4_5_4];
                      var tmp0__anonymous__5_3_4 = tmp0_unsafeCast_0_3_4_4;
                      var comps_6_6_4 = tmp0__anonymous__5_3_4.__components;
                      var tmp0_safe_receiver_7_7_4 = comps_6_6_4;
                      if (tmp0_safe_receiver_7_7_4 == null)
                        null;
                      else {
                        var tmp0_safe_receiver_2_8_8_4 = comps_6_6_4._gamepad_2;
                        if (tmp0_safe_receiver_2_8_8_4 == null)
                          null;
                        else {
                          var array_1_3_9_9_4 = tmp0_safe_receiver_2_8_8_4._array_4;
                          var n_2_4_10_10_4 = 0;
                          while (n_2_4_10_10_4 < array_1_3_9_9_4.length) {
                            var tmp0_4_7_13_13_4 = n_2_4_10_10_4;
                            n_2_4_10_10_4 = tmp0_4_7_13_13_4 + 1 | 0;
                            var tmp0_unsafeCast_0_3_6_12_12_4 = array_1_3_9_9_4[tmp0_4_7_13_13_4];
                            var tmp0__anonymous__5_5_11_11_4 = tmp0_unsafeCast_0_3_6_12_12_4;
                            tmp0__anonymous__5_5_11_11_4.onGamepadEvent_etpyjn_k$(this._views_18, e);
                            Unit_getInstance();
                            if (e.__stopPropagation) {
                              tmp$ret$10 = Unit_getInstance();
                              break l$ret$11;
                            }}
                          Unit_getInstance();
                        }
                        Unit_getInstance();
                      }
                      Unit_getInstance();
                    }
                  }
                   while (false);
                } else {
                  {
                    var tmp$ret$12;
                    l$ret$13: do {
                      e.__stopPropagation = false;
                      var array_1_1_5 = stagedViews._array_4;
                      var n_2_2_5 = 0;
                      while (n_2_2_5 < array_1_1_5.length) {
                        var tmp0_4_5_5 = n_2_2_5;
                        n_2_2_5 = tmp0_4_5_5 + 1 | 0;
                        var tmp0_unsafeCast_0_3_4_5 = array_1_1_5[tmp0_4_5_5];
                        var tmp0__anonymous__5_3_5 = tmp0_unsafeCast_0_3_4_5;
                        var comps_6_6_5 = tmp0__anonymous__5_3_5.__components;
                        var tmp0_safe_receiver_7_7_5 = comps_6_6_5;
                        if (tmp0_safe_receiver_7_7_5 == null)
                          null;
                        else {
                          var tmp0_safe_receiver_2_8_8_5 = comps_6_6_5._event_0;
                          if (tmp0_safe_receiver_2_8_8_5 == null)
                            null;
                          else {
                            var array_1_3_9_9_5 = tmp0_safe_receiver_2_8_8_5._array_4;
                            var n_2_4_10_10_5 = 0;
                            while (n_2_4_10_10_5 < array_1_3_9_9_5.length) {
                              var tmp0_4_7_13_13_5 = n_2_4_10_10_5;
                              n_2_4_10_10_5 = tmp0_4_7_13_13_5 + 1 | 0;
                              var tmp0_unsafeCast_0_3_6_12_12_5 = array_1_3_9_9_5[tmp0_4_7_13_13_5];
                              var tmp0__anonymous__5_5_11_11_5 = tmp0_unsafeCast_0_3_6_12_12_5;
                              tmp0__anonymous__5_5_11_11_5.onEvent_suvueb_k$(e);
                              Unit_getInstance();
                              if (e.__stopPropagation) {
                                tmp$ret$12 = Unit_getInstance();
                                break l$ret$13;
                              }}
                            Unit_getInstance();
                          }
                          Unit_getInstance();
                        }
                        Unit_getInstance();
                      }
                    }
                     while (false);
                  }
                }
              }
            }
          }
        }
      }
    } catch ($p) {
      if ($p instanceof PreventDefaultException) {
      } else {
        {
          throw $p;
        }
      }
    }
  };
  Views.prototype.render_sv8swh_k$ = function () {
    this._ag_6.startFrame_sv8swh_k$();
    if (this._clearEachFrame_1) {
      var tmp0_color = this._clearColor;
      this._ag_6.clear_jnj4is_k$(tmp0_color, 1.0, 0, true, true, true);
    }this._onBeforeRender.invoke_iav7o_k$(this._renderContext);
    this._stage_0.render_uxru53_k$(this._renderContext);
    this._renderContext.flush_sv8swh_k$();
    this._stage_0.renderDebug_uxru53_k$(this._renderContext);
    if (this._debugViews) {
      var tmp0_fastForEach_0 = this._debugHandlers;
      var array_1 = tmp0_fastForEach_0._array_4;
      var n_2 = 0;
      while (n_2 < array_1.length) {
        var tmp0_4 = n_2;
        n_2 = tmp0_4 + 1 | 0;
        var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
        var tmp1__anonymous__5 = tmp0_unsafeCast_0_3;
        tmp1__anonymous__5(this, this._renderContext);
      }
    }this._onAfterRender.invoke_iav7o_k$(this._renderContext);
    this._renderContext.flush_sv8swh_k$();
  };
  Views.prototype.frameUpdateAndRender_zah5t7_k$ = function (fixedSizeStep) {
    var currentTime = this._timeProvider_3.now_utobi1_k$();
    this._views_18._stats_2.startFrame_sv8swh_k$();
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_5xis2i_k$(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog_sbdqh6_k$(tmp0_log_0_1, 'ag.onRender');
    }var delta_0 = DateTime__minus_impl_0(currentTime, this._lastTime_0);
    var adelta = TimeSpan__compareTo_impl(delta_0, this._views_18._clampElapsedTimeTo) > 0 ? this._views_18._clampElapsedTimeTo : delta_0;
    this._lastTime_0 = currentTime;
    if (!equals_1(new TimeSpan(fixedSizeStep), new TimeSpan(Companion_getInstance_92()._NIL))) {
      this.update_zah5t7_k$(fixedSizeStep);
    } else {
      this.update_zah5t7_k$(adelta);
    }
    this.render_sv8swh_k$();
  };
  Views.prototype.update_zah5t7_k$ = function (elapsed) {
    this._input_3.startFrame_zah5t7_k$(elapsed);
    updateSingleViewWithViewsAll(this._stage_0, this, elapsed, this._tempViews);
    this._input_3.endFrame_zah5t7_k$(elapsed);
  };
  Views.prototype.mouseUpdated_sv8swh_k$ = function () {
  };
  Views.prototype.resized_rvwcgf_k$ = function (width, height) {
    var actualWidth = width;
    var actualHeight = height;
    setTo_0(this._actualSize, actualWidth, actualHeight);
    Unit_getInstance();
    this.resized_sv8swh_k$();
  };
  Views.prototype.resized_sv8swh_k$ = function () {
    var virtualWidth = this._virtualWidth_0;
    var virtualHeight = this._virtualHeight_0;
    var anchor_2 = this._scaleAnchor_1;
    setTo_0(this._virtualSize, virtualWidth, virtualHeight);
    Unit_getInstance();
    this._scaleMode_4.invoke_2hy4zr_k$(this._virtualSize, this._actualSize, this._targetSize);
    Unit_getInstance();
    var ratioX = _SizeInt___get_width__impl_(this._targetSize) / virtualWidth;
    var ratioY = _SizeInt___get_height__impl_(this._targetSize) / virtualHeight;
    this._actualVirtualWidth = toIntRound(_SizeInt___get_width__impl_(this._actualSize) / ratioX);
    this._actualVirtualHeight = toIntRound(_SizeInt___get_height__impl_(this._actualSize) / ratioY);
    this._stage_0._set_scaleX__okcceq_k$(ratioX);
    this._stage_0._set_scaleY__okcceq_k$(ratioY);
    this._stage_0._set_x__okcceq_k$(toIntRound((this._actualVirtualWidth - virtualWidth | 0) * anchor_2._sx * ratioX));
    this._stage_0._set_y__okcceq_k$(toIntRound((this._actualVirtualHeight - virtualHeight | 0) * anchor_2._sy * ratioY));
    this._actualVirtualLeft = -toIntRound(this._stage_0._get_x__0_k$() / ratioX) | 0;
    this._actualVirtualTop = -toIntRound(this._stage_0._get_y__0_k$() / ratioY) | 0;
    var tmp0_apply_0 = this._resizedEvent;
    tmp0_apply_0._width_15 = _SizeInt___get_width__impl_(this._actualSize);
    tmp0_apply_0._height_16 = _SizeInt___get_height__impl_(this._actualSize);
    Unit_getInstance();
    var tmp1_dispatch_0 = this._stage_0;
    var tmp2_dispatch_0 = this._resizedEvent;
    tmp1_dispatch_0.dispatch_62irmi_k$(getKClass_0(ReshapeEvent), tmp2_dispatch_0);
    var tmp3_dispatch_0 = this._resizedEvent;
    this.dispatch_62irmi_k$(getKClass_0(ReshapeEvent), tmp3_dispatch_0);
    this._stage_0.invalidate_sv8swh_k$();
  };
  Views.$metadata$ = {
    simpleName: 'Views',
    kind: 'class',
    interfaces: [Extra, EventDispatcher, CoroutineScope, ViewsContainer, BoundsProvider, DialogInterface, Closeable, KTreeSerializerHolder, ResourcesContainer]
  };
  function KorgeFileLoader(name, loader) {
    this._name_46 = name;
    this._loader = loader;
  }
  KorgeFileLoader.prototype.toString = function () {
    return '' + 'KorgeFileLoader("' + this._name_46 + '")';
  };
  KorgeFileLoader.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_46);
    result = imul(result, 31) + hashCode(this._loader) | 0;
    return result;
  };
  KorgeFileLoader.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeFileLoader))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof KorgeFileLoader ? other : THROW_CCE();
    if (!(this._name_46 === tmp0_other_with_cast._name_46))
      return false;
    if (!equals_1(this._loader, tmp0_other_with_cast._loader))
      return false;
    return true;
  };
  KorgeFileLoader.$metadata$ = {
    simpleName: 'KorgeFileLoader',
    kind: 'class',
    interfaces: []
  };
  function BoundsProvider() {
  }
  BoundsProvider.$metadata$ = {
    simpleName: 'BoundsProvider',
    kind: 'interface',
    interfaces: []
  };
  function ViewsContainer() {
  }
  ViewsContainer.$metadata$ = {
    simpleName: 'ViewsContainer',
    kind: 'interface',
    interfaces: []
  };
  function getAllDescendantViews(view, out, reversed_2) {
    out.clear_sv8swh_k$();
    var pos = getAllDescendantViewsBase(view, out, reversed_2, 0);
    while (out._get_size__0_k$() > pos) {
      out.removeAt_ha5a7z_k$(out._get_size__0_k$() - 1 | 0);
      Unit_getInstance();
    }
    return out;
  }
  function getAllDescendantViews$default(view, out, reversed_2, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      out = FastArrayList_init_$Create$();
    if (!(($mask0 & 4) === 0))
      reversed_2 = true;
    return getAllDescendantViews(view, out, reversed_2);
  }
  function updateSingleViewWithViewsAll(_this_, views_0, delta_0, tempViews) {
    var tmp0_fastForEach_0 = getAllDescendantViews$default(_this_, tempViews, false, 4, null);
    var array_1 = tmp0_fastForEach_0._array_4;
    var n_2 = 0;
    while (n_2 < array_1.length) {
      var tmp0_4 = n_2;
      n_2 = tmp0_4 + 1 | 0;
      var tmp0_unsafeCast_0_3 = array_1[tmp0_4];
      var tmp1__anonymous__5 = tmp0_unsafeCast_0_3;
      var tmp0_safe_receiver_7 = tmp1__anonymous__5._get__components__0_k$();
      var tmp1_safe_receiver_6 = tmp0_safe_receiver_7 == null ? null : tmp0_safe_receiver_7._updateWV;
      if (tmp1_safe_receiver_6 == null)
        null;
      else {
        var array_1_8 = tmp1_safe_receiver_6._array_4;
        var n_2_9 = 0;
        while (n_2_9 < array_1_8.length) {
          var tmp0_4_12 = n_2_9;
          n_2_9 = tmp0_4_12 + 1 | 0;
          var tmp0_unsafeCast_0_3_11 = array_1_8[tmp0_4_12];
          var tmp0__anonymous__5_10 = tmp0_unsafeCast_0_3_11;
          tmp0__anonymous__5_10.update_2el4wj_k$(views_0, TimeSpan__times_impl_0(delta_0, tmp1__anonymous__5._get_globalSpeed__0_k$()));
        }
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp2_safe_receiver_14 = tmp1__anonymous__5._get__components__0_k$();
      var tmp3_safe_receiver_13 = tmp2_safe_receiver_14 == null ? null : tmp2_safe_receiver_14._update_0;
      if (tmp3_safe_receiver_13 == null)
        null;
      else {
        var array_1_15 = tmp3_safe_receiver_13._array_4;
        var n_2_16 = 0;
        while (n_2_16 < array_1_15.length) {
          var tmp0_4_19 = n_2_16;
          n_2_16 = tmp0_4_19 + 1 | 0;
          var tmp0_unsafeCast_0_3_18 = array_1_15[tmp0_4_19];
          var tmp1__anonymous__5_17 = tmp0_unsafeCast_0_3_18;
          tmp1__anonymous__5_17.update_zah5t7_k$(TimeSpan__times_impl_0(delta_0, tmp1__anonymous__5._get_globalSpeed__0_k$()));
        }
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  }
  function getAllDescendantViewsBase(view, out, reversed_2, cursor) {
    var pos = cursor;
    if (reversed_2) {
      var tmp0_safe_receiver_1 = view._get__children__0_k$();
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        var array_1_2 = tmp0_safe_receiver_1._array_4;
        var n_2_3 = 0;
        while (n_2_3 < array_1_2.length) {
          var tmp0_unsafeCast_0_3_4 = array_1_2[(tmp0_safe_receiver_1._get_size__0_k$() - n_2_3 | 0) - 1 | 0];
          var tmp0__anonymous__6 = tmp0_unsafeCast_0_3_4;
          pos = getAllDescendantViewsBase(tmp0__anonymous__6, out, reversed_2, pos);
          var tmp0_4_5 = n_2_3;
          n_2_3 = tmp0_4_5 + 1 | 0;
          Unit_getInstance();
        }
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp0 = pos;
      pos = tmp0 + 1 | 0;
      replaceOrAdd(out, tmp0, view);
    } else {
      var tmp1 = pos;
      pos = tmp1 + 1 | 0;
      replaceOrAdd(out, tmp1, view);
      var tmp0_safe_receiver_1_0 = view._get__children__0_k$();
      if (tmp0_safe_receiver_1_0 == null)
        null;
      else {
        var array_1_2_0 = tmp0_safe_receiver_1_0._array_4;
        var n_2_3_0 = 0;
        while (n_2_3_0 < array_1_2_0.length) {
          var tmp0_4_5_0 = n_2_3_0;
          n_2_3_0 = tmp0_4_5_0 + 1 | 0;
          var tmp0_unsafeCast_0_3_4_0 = array_1_2_0[tmp0_4_5_0];
          var tmp1__anonymous__6 = tmp0_unsafeCast_0_3_4_0;
          pos = getAllDescendantViewsBase(tmp1__anonymous__6, out, reversed_2, pos);
        }
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    return pos;
  }
  function replaceOrAdd(_this_, pos, value) {
    if (pos >= _this_._get_size__0_k$()) {
      _this_.add_2bq_k$(value);
      Unit_getInstance();
    } else {
      _this_.set_ddb1qf_k$(pos, value);
      Unit_getInstance();
    }
  }
  function views($cont) {
    var tmp = new $viewsCOROUTINE$39($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function _no_name_provided__627() {
  }
  _no_name_provided__627.prototype.invoke_4bsyzd_k$ = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__627.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_4bsyzd_k$(p1 instanceof UiApplication ? p1 : THROW_CCE());
  };
  _no_name_provided__627.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $viewsCOROUTINE$39(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  $viewsCOROUTINE$39.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = injector(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_get_00 = suspendResult;
            this._state_1 = 2;
            var tmp_0 = getKClass_0(Views);
            suspendResult = this._tmp0_get_00.get$default_b3eqw1_k$(tmp_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $viewsCOROUTINE$39.$metadata$ = {
    simpleName: '$viewsCOROUTINE$39',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_556() {
    var i = new _no_name_provided__627();
    return function (p1) {
      return i.invoke_4bsyzd_k$(p1);
    };
  }
  function _no_name_provided_$factory_557(this$0) {
    var i = new _no_name_provided__623(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_558(this$0) {
    var i = new _no_name_provided__626(this$0);
    return function (p1) {
      i.invoke_uxru53_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_559(this$0, resultContinuation) {
    var i = new _no_name_provided__625(this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function Companion_217() {
    Companion_instance_216 = this;
    var tmp = this;
    var tmp_0 = VarType_Float2_getInstance();
    tmp._u_TextureSize = Uniform_init_$Create$('effectTextureSize', tmp_0, null, 4, null);
    var tmp_1 = this;
    var tmp_2 = Companion_getInstance_200();
    tmp_1._DEFAULT_FRAGMENT = tmp_2.buildTextureLookupFragment$default_etv6iq_k$(false, false, 2, null);
  }
  Companion_217.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_216;
  function Companion_getInstance_216() {
    if (Companion_instance_216 == null)
      new Companion_217();
    return Companion_instance_216;
  }
  function Filter_0() {
  }
  Filter_0.prototype._get_border__0_k$ = function () {
    return 0;
  };
  Filter_0.$metadata$ = {
    simpleName: 'Filter',
    kind: 'interface',
    interfaces: [KorgeDebugNode]
  };
  var registerFilterSerialization$delegate;
  function _no_name_provided__628() {
  }
  _no_name_provided__628.prototype.invoke_0_k$ = function () {
    return false;
  };
  _no_name_provided__628.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_560() {
    var i = new _no_name_provided__628();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided__629($premultiplied) {
    this._$premultiplied_0 = $premultiplied;
  }
  _no_name_provided__629.prototype.invoke_dzcoxa_k$ = function ($this$appending) {
    if (this._$premultiplied_0) {
      $this$appending.setTo_ag43kx_k$($this$appending.get_v2sg9q_k$($this$appending._out_8, 'rgb'), $this$appending.div_l29sts_k$($this$appending.get_v2sg9q_k$($this$appending._out_8, 'rgb'), $this$appending.get_v2sg9q_k$($this$appending._out_8, 'a')));
    }$this$appending.setTo_ag43kx_k$($this$appending._out_8, $this$appending.plus_l29sts_k$($this$appending.times_l29sts_k$($this$appending._out_8, Companion_getInstance_200()._v_ColMul), $this$appending.times_l29sts_k$($this$appending.minus_l29sts_k$(Companion_getInstance_200()._v_ColAdd, $this$appending.vec4_ldyooh_k$([$this$appending._get_lit__a9njmo_k$(0.5), $this$appending._get_lit__a9njmo_k$(0.5), $this$appending._get_lit__a9njmo_k$(0.5), $this$appending._get_lit__a9njmo_k$(0.5)])), $this$appending._get_lit__a9njmo_k$(2.0))));
    if (this._$premultiplied_0) {
      var tmp0_IF_0 = $this$appending.le_l29sts_k$($this$appending.get_v2sg9q_k$($this$appending._out_8, 'a'), $this$appending._get_lit__a9njmo_k$(0.0));
      var body_1 = new Builder($this$appending._type_12);
      body_1.DISCARD_sv8swh_k$();
      var tmp = new Stms(body_1._outputStms);
      var stmIf_2 = If_init_$Create$(tmp0_IF_0, tmp, null, 4, null);
      var tmp0_this_3 = $this$appending;
      var tmp0_plusAssign_0_4 = tmp0_this_3._outputStms;
      tmp0_plusAssign_0_4.add_2bq_k$(stmIf_2);
      Unit_getInstance();
      Unit_getInstance();
    }};
  _no_name_provided__629.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__629.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_218() {
    Companion_instance_217 = this;
    var tmp = this;
    var tmp_0 = VarType_Float2_getInstance();
    tmp._u_TextureSize_0 = Uniform_init_$Create$('effectTextureSize', tmp_0, null, 4, null);
    var tmp_1 = this;
    var tmp_2 = Companion_getInstance_200();
    tmp_1._DEFAULT_FRAGMENT_0 = tmp_2.buildTextureLookupFragment$default_etv6iq_k$(false, false, 2, null);
  }
  Companion_218.prototype._get_fragmentCoords01__20938x_k$ = function (_this__0) {
    return _this__0.get_v2sg9q_k$(DefaultShaders_getInstance()._v_Tex, 'xy');
  };
  Companion_218.prototype._get_fragmentCoords__20938x_k$ = function (_this__0) {
    return _this__0.times_l29sts_k$(this._get_fragmentCoords01__20938x_k$(_this__0), this._u_TextureSize_0);
  };
  Companion_218.prototype.tex_yq73su_k$ = function (_this__0, coords) {
    return _this__0.texture2D_s4jwrm_k$(DefaultShaders_getInstance()._u_Tex, _this__0.div_l29sts_k$(coords, this._u_TextureSize_0));
  };
  Companion_218.prototype.createProgram_27j5m6_k$ = function (vertex, fragment, premultiplied) {
    var tmp = appending(fragment, _no_name_provided_$factory_563(premultiplied));
    return Program_init_$Create$(vertex, tmp, null, 4, null);
  };
  Companion_218.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_217;
  function Companion_getInstance_217() {
    if (Companion_instance_217 == null)
      new Companion_218();
    return Companion_instance_217;
  }
  function _get_programPremult_($this) {
    var tmp0_getValue_0 = programPremult$factory();
    return $this._programPremult$delegate._get_value__0_k$();
  }
  function _get_programNormal_($this) {
    var tmp0_getValue_0 = programNormal$factory();
    return $this._programNormal$delegate._get_value__0_k$();
  }
  function _no_name_provided__630(this$0) {
    this._this$0_169 = this$0;
  }
  _no_name_provided__630.prototype.invoke_0_k$ = function () {
    return Companion_getInstance_217().createProgram_27j5m6_k$(this._this$0_169._get_vertex__0_k$(), this._this$0_169._get_fragment__0_k$(), true);
  };
  _no_name_provided__630.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__631(this$0) {
    this._this$0_170 = this$0;
  }
  _no_name_provided__631.prototype.invoke_0_k$ = function () {
    return Companion_getInstance_217().createProgram_27j5m6_k$(this._this$0_170._get_vertex__0_k$(), this._this$0_170._get_fragment__0_k$(), false);
  };
  _no_name_provided__631.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ShaderFilter() {
    Companion_getInstance_217();
    this._filtering_1 = true;
    this._textureSizeHolder = new Float32Array(2);
    this._uniforms_8 = UniformValues_init_$Create$([to(Companion_getInstance_216()._u_TextureSize, this._textureSizeHolder)]);
    this._border_0 = 0;
    this._vertex_0 = Companion_getInstance_200()._VERTEX;
    this._fragment_1 = Companion_getInstance_216()._DEFAULT_FRAGMENT;
    var tmp = this;
    tmp._programPremult$delegate = lazy(_no_name_provided_$factory_561(this));
    var tmp_0 = this;
    tmp_0._programNormal$delegate = lazy(_no_name_provided_$factory_562(this));
  }
  ShaderFilter.prototype._set_filtering__rpwsgn_k$ = function (_set___) {
    this._filtering_1 = _set___;
  };
  ShaderFilter.prototype._get_uniforms__0_k$ = function () {
    return this._uniforms_8;
  };
  ShaderFilter.prototype._get_border__0_k$ = function () {
    return this._border_0;
  };
  ShaderFilter.prototype._get_vertex__0_k$ = function () {
    return this._vertex_0;
  };
  ShaderFilter.prototype._get_fragment__0_k$ = function () {
    return this._fragment_1;
  };
  ShaderFilter.prototype.updateUniforms_uxru53_k$ = function (ctx) {
  };
  ShaderFilter.prototype.render_a436xf_k$ = function (ctx, matrix, texture, texWidth, texHeight, renderColorAdd, renderColorMul, blendMode) {
    this._textureSizeHolder[0] = texture._base_6._width_20;
    this._textureSizeHolder[1] = texture._base_6._height_21;
    this.updateUniforms_uxru53_k$(ctx);
    var tmp0_use_0_1 = ctx._batch_0;
    var tmp0_useBatcher_0_1_2 = tmp0_use_0_1._ctx_6;
    if (!(tmp0_useBatcher_0_1_2._currentBatcher === tmp0_use_0_1)) {
      tmp0_useBatcher_0_1_2.flush_sv8swh_k$();
      tmp0_useBatcher_0_1_2._currentBatcher = tmp0_use_0_1;
    }var tmp0_setTemporalUniforms_0_4 = this._uniforms_8;
    tmp0_use_0_1.flush$default_9k51td_k$(false, false, 3, null);
    tmp0_use_0_1._tempOldUniforms.setTo_53oll8_k$(tmp0_use_0_1._get_uniforms__0_k$());
    tmp0_use_0_1._get_uniforms__0_k$().put_ehqtxh_k$(tmp0_setTemporalUniforms_0_4);
    Unit_getInstance();
    try {
      var tmp0_filtering_2_5 = this._filtering_1;
      var tmp1_blendFactors_3_6 = blendMode._factors;
      var tmp2_program_4_7 = texture._get_premultiplied__0_k$() ? _get_programPremult_(this) : _get_programNormal_(this);
      tmp0_use_0_1.drawQuad$default_r2v3rq_k$(texture, 0.0, 0.0, 0.0, 0.0, matrix, tmp0_filtering_2_5, renderColorMul, renderColorAdd, tmp1_blendFactors_3_6, tmp2_program_4_7, 30, null);
    }finally {
      tmp0_use_0_1.flush$default_9k51td_k$(false, false, 3, null);
      tmp0_use_0_1._get_uniforms__0_k$().setTo_53oll8_k$(tmp0_use_0_1._tempOldUniforms);
    }
  };
  ShaderFilter.$metadata$ = {
    simpleName: 'ShaderFilter',
    kind: 'class',
    interfaces: [Filter_0]
  };
  function programPremult$factory() {
    return getPropertyCallableRef('programPremult', 1, KProperty1, function (receiver) {
      return _get_programPremult_(receiver);
    }, null);
  }
  function programNormal$factory() {
    return getPropertyCallableRef('programNormal', 1, KProperty1, function (receiver) {
      return _get_programNormal_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_561(this$0) {
    var i = new _no_name_provided__630(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_562(this$0) {
    var i = new _no_name_provided__631(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_563($premultiplied) {
    var i = new _no_name_provided__629($premultiplied);
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function createTransitionBox($this, paint) {
    var tmp0_context2d_0 = Bitmap32_init_$Create$($this._BMP_SIZE, $this._BMP_SIZE, null, false, 12, null);
    tmp0_context2d_0.lock_sv8swh_k$();
    try {
      var ctx_2_1 = tmp0_context2d_0.getContext2d_vcj5fe_k$(true);
      try {
        var tmp0_fill_0_3 = paint.add_grassx_k$(0.0, Colors_getInstance()._WHITE_0).add_grassx_k$(1.0, Colors_getInstance()._BLACK_0);
        ctx_2_1.beginPath_sv8swh_k$();
        rect_1(ctx_2_1, 0, 0, Companion_getInstance_218()._BMP_SIZE, Companion_getInstance_218()._BMP_SIZE);
        ctx_2_1.fill_y73s1i_k$(tmp0_fill_0_3);
      }finally {
        ctx_2_1.dispose_sv8swh_k$();
      }
    }finally {
      tmp0_context2d_0.unlock_ixubtt_k$(null);
      Unit_getInstance();
    }
    return new Transition_1(tmp0_context2d_0);
  }
  function createLinearTransitionBox($this, x0, y0, x1, y1) {
    var tmp0_LinearGradientPaint_0 = CycleMethod_NO_CYCLE_getInstance();
    var tmp1_LinearGradientPaint_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp = GradientKind_LINEAR_getInstance();
    var tmp_0 = numberToDouble(x0);
    var tmp_1 = numberToDouble(y0);
    var tmp_2 = numberToDouble(x1);
    var tmp_3 = numberToDouble(y1);
    return createTransitionBox($this, GradientPaint_init_$Create$(tmp, tmp_0, tmp_1, 0.0, tmp_2, tmp_3, 0.0, null, null, tmp0_LinearGradientPaint_0, tmp1_LinearGradientPaint_0, null, null, 6528, null));
  }
  function _no_name_provided__632() {
  }
  _no_name_provided__632.prototype.invoke_0_k$ = function () {
    return createLinearTransitionBox(Companion_getInstance_218(), 0, 0, 0, Companion_getInstance_218()._BMP_SIZE);
  };
  _no_name_provided__632.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__633() {
  }
  _no_name_provided__633.prototype.invoke_0_k$ = function () {
    return createLinearTransitionBox(Companion_getInstance_218(), 0, 0, Companion_getInstance_218()._BMP_SIZE, 0);
  };
  _no_name_provided__633.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__634() {
  }
  _no_name_provided__634.prototype.invoke_0_k$ = function () {
    return createLinearTransitionBox(Companion_getInstance_218(), 0, 0, Companion_getInstance_218()._BMP_SIZE, Companion_getInstance_218()._BMP_SIZE);
  };
  _no_name_provided__634.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__635() {
  }
  _no_name_provided__635.prototype.invoke_0_k$ = function () {
    return createLinearTransitionBox(Companion_getInstance_218(), Companion_getInstance_218()._BMP_SIZE, 0, 0, Companion_getInstance_218()._BMP_SIZE);
  };
  _no_name_provided__635.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__636() {
  }
  _no_name_provided__636.prototype.invoke_0_k$ = function () {
    var tmp = Companion_getInstance_218();
    var tmp0_RadialGradientPaint_0 = Companion_getInstance_218()._BMP_SIZE / 2 | 0;
    var tmp1_RadialGradientPaint_0 = Companion_getInstance_218()._BMP_SIZE / 2 | 0;
    var tmp2_RadialGradientPaint_0 = Companion_getInstance_218()._BMP_SIZE / 2 | 0;
    var tmp3_RadialGradientPaint_0 = Companion_getInstance_218()._BMP_SIZE / 2 | 0;
    var tmp4_RadialGradientPaint_0 = Companion_getInstance_218()._BMP_SIZE / 2 | 0;
    var tmp5_RadialGradientPaint_0 = CycleMethod_NO_CYCLE_getInstance();
    var tmp6_RadialGradientPaint_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_0 = GradientKind_RADIAL_getInstance();
    var tmp_1 = numberToDouble(tmp0_RadialGradientPaint_0);
    var tmp_2 = numberToDouble(tmp1_RadialGradientPaint_0);
    var tmp_3 = numberToDouble(tmp2_RadialGradientPaint_0);
    var tmp_4 = numberToDouble(tmp3_RadialGradientPaint_0);
    var tmp_5 = numberToDouble(tmp4_RadialGradientPaint_0);
    return createTransitionBox(tmp, GradientPaint_init_$Create$(tmp_0, tmp_1, tmp_2, 0.0, tmp_3, tmp_4, tmp_5, null, null, tmp5_RadialGradientPaint_0, tmp6_RadialGradientPaint_0, null, null, 6528, null));
  };
  _no_name_provided__636.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__637() {
  }
  _no_name_provided__637.prototype.invoke_0_k$ = function () {
    var tmp = Companion_getInstance_218();
    var tmp0_SweepGradientPaint_0 = Companion_getInstance_218()._BMP_SIZE / 2 | 0;
    var tmp1_SweepGradientPaint_0 = Companion_getInstance_218()._BMP_SIZE / 2 | 0;
    var tmp2_SweepGradientPaint_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_0 = GradientKind_SWEEP_getInstance();
    var tmp_1 = numberToDouble(tmp0_SweepGradientPaint_0);
    var tmp_2 = numberToDouble(tmp1_SweepGradientPaint_0);
    return createTransitionBox(tmp, GradientPaint_init_$Create$(tmp_0, tmp_1, tmp_2, 0.0, 0.0, 0.0, 0.0, null, null, null, tmp2_SweepGradientPaint_0, null, null, 7040, null));
  };
  _no_name_provided__637.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_219() {
    Companion_instance_218 = this;
    this._BMP_SIZE = 64;
    var tmp = this;
    tmp._VERTICAL$delegate = lazy(_no_name_provided_$factory_564());
    var tmp_0 = this;
    tmp_0._HORIZONTAL$delegate = lazy(_no_name_provided_$factory_565());
    var tmp_1 = this;
    tmp_1._DIAGONAL1$delegate = lazy(_no_name_provided_$factory_566());
    var tmp_2 = this;
    tmp_2._DIAGONAL2$delegate = lazy(_no_name_provided_$factory_567());
    var tmp_3 = this;
    tmp_3._CIRCULAR$delegate = lazy(_no_name_provided_$factory_568());
    var tmp_4 = this;
    tmp_4._SWEEP$delegate = lazy(_no_name_provided_$factory_569());
  }
  Companion_219.prototype._get_HORIZONTAL__0_k$ = function () {
    var tmp0_getValue_0 = HORIZONTAL$factory();
    return this._HORIZONTAL$delegate._get_value__0_k$();
  };
  Companion_219.prototype._get_DIAGONAL1__0_k$ = function () {
    var tmp0_getValue_0 = DIAGONAL1$factory();
    return this._DIAGONAL1$delegate._get_value__0_k$();
  };
  Companion_219.prototype._get_CIRCULAR__0_k$ = function () {
    var tmp0_getValue_0 = CIRCULAR$factory();
    return this._CIRCULAR$delegate._get_value__0_k$();
  };
  Companion_219.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_218;
  function Companion_getInstance_218() {
    if (Companion_instance_218 == null)
      new Companion_219();
    return Companion_instance_218;
  }
  function _no_name_provided__638() {
  }
  _no_name_provided__638.prototype.invoke_dzcoxa_k$ = function ($this$null) {
    $this$null.setTo_ag43kx_k$($this$null._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp1), $this$null._get_lit__a9njmo_k$(0.0));
  };
  _no_name_provided__638.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__638.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__639() {
  }
  _no_name_provided__639.prototype.invoke_dzcoxa_k$ = function ($this$appending) {
    $this$appending.setTo_ag43kx_k$($this$appending._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp1), $this$appending._get_r__mp8w81_k$($this$appending.texture2D_s4jwrm_k$(Companion_getInstance_219()._u_Mask, $this$appending.get_v2sg9q_k$(DefaultShaders_getInstance()._v_Tex, 'xy'))));
    var tmp0_IF_0 = $this$appending.eq_l29sts_k$(Companion_getInstance_219()._u_Reversed, $this$appending._get_lit__a9njmo_k$(1.0));
    var body_1 = new Builder($this$appending._type_12);
    body_1.setTo_ag43kx_k$(body_1._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp1), body_1.minus_l29sts_k$(body_1._get_lit__a9njmo_k$(1.0), body_1._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp1)));
    var tmp = new Stms(body_1._outputStms);
    var stmIf_2 = If_init_$Create$(tmp0_IF_0, tmp, null, 4, null);
    var tmp0_this_3 = $this$appending;
    var tmp0_plusAssign_0_4 = tmp0_this_3._outputStms;
    tmp0_plusAssign_0_4.add_2bq_k$(stmIf_2);
    Unit_getInstance();
    Unit_getInstance();
    $this$appending.setTo_ag43kx_k$($this$appending._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp1), $this$appending.clamp_h5nd2r_k$($this$appending.plus_l29sts_k$($this$appending._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp1), $this$appending.minus_l29sts_k$($this$appending.times_l29sts_k$(Companion_getInstance_219()._u_Ratio, $this$appending._get_lit__a9njmo_k$(2.0)), $this$appending._get_lit__a9njmo_k$(1.0))), $this$appending._get_lit__a9njmo_k$(0.0), $this$appending._get_lit__a9njmo_k$(1.0)));
    var tmp1_IF_0 = $this$appending.ne_l29sts_k$(Companion_getInstance_219()._u_Smooth, $this$appending._get_lit__a9njmo_k$(1.0));
    var body_1_0 = new Builder($this$appending._type_12);
    var tmp0_IF_0_6 = body_1_0.ge_l29sts_k$(body_1_0._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp1), body_1_0._get_lit__a9njmo_k$(1.0));
    var body_1_7 = new Builder(body_1_0._type_12);
    body_1_7.setTo_ag43kx_k$(body_1_7._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp1), body_1_7._get_lit__a9njmo_k$(1.0));
    var tmp_0 = new Stms(body_1_7._outputStms);
    var stmIf_2_8 = If_init_$Create$(tmp0_IF_0_6, tmp_0, null, 4, null);
    var tmp0_this_3_9 = body_1_0;
    var tmp0_plusAssign_0_4_10 = tmp0_this_3_9._outputStms;
    tmp0_plusAssign_0_4_10.add_2bq_k$(stmIf_2_8);
    Unit_getInstance();
    body_1_0.ELSE_p4ir4u_k$(stmIf_2_8, _no_name_provided_$factory_571());
    var tmp_1 = new Stms(body_1_0._outputStms);
    var stmIf_2_0 = If_init_$Create$(tmp1_IF_0, tmp_1, null, 4, null);
    var tmp0_this_3_0 = $this$appending;
    var tmp0_plusAssign_0_4_0 = tmp0_this_3_0._outputStms;
    tmp0_plusAssign_0_4_0.add_2bq_k$(stmIf_2_0);
    Unit_getInstance();
    Unit_getInstance();
    $this$appending.setTo_ag43kx_k$($this$appending._out_8, $this$appending.times_l29sts_k$($this$appending._out_8, $this$appending._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp1)));
  };
  _no_name_provided__639.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__639.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TransitionFilter_init_$Init$(transition, reversed_2, smooth, ratio, filtering, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      transition = Companion_getInstance_218()._get_CIRCULAR__0_k$();
    if (!(($mask0 & 2) === 0))
      reversed_2 = false;
    if (!(($mask0 & 4) === 0))
      smooth = true;
    if (!(($mask0 & 8) === 0))
      ratio = 1.0;
    if (!(($mask0 & 16) === 0))
      filtering = false;
    TransitionFilter.call($this, transition, reversed_2, smooth, ratio, filtering);
    return $this;
  }
  function TransitionFilter_init_$Create$(transition, reversed_2, smooth, ratio, filtering, $mask0, $marker) {
    return TransitionFilter_init_$Init$(transition, reversed_2, smooth, ratio, filtering, $mask0, $marker, Object.create(TransitionFilter.prototype));
  }
  function Transition_1(bmp) {
    Companion_getInstance_218();
    this._bmp_4 = bmp;
  }
  Transition_1.$metadata$ = {
    simpleName: 'Transition',
    kind: 'class',
    interfaces: []
  };
  function Companion_220() {
    Companion_instance_219 = this;
    var tmp = this;
    var tmp_0 = VarType_Float1_getInstance();
    tmp._u_Reversed = Uniform_init_$Create$('u_Reversed', tmp_0, null, 4, null);
    var tmp_1 = this;
    var tmp_2 = VarType_Float1_getInstance();
    tmp_1._u_Smooth = Uniform_init_$Create$('u_Smooth', tmp_2, null, 4, null);
    var tmp_3 = this;
    var tmp_4 = VarType_Float1_getInstance();
    tmp_3._u_Ratio = Uniform_init_$Create$('u_Ratio', tmp_4, null, 4, null);
    var tmp_5 = this;
    var tmp_6 = VarType_TextureUnit_getInstance();
    tmp_5._u_Mask = Uniform_init_$Create$('u_Mask', tmp_6, null, 4, null);
    var tmp_7 = this;
    var tmp_8 = Companion_getInstance_216()._DEFAULT_FRAGMENT;
    tmp_7._FRAGMENT_SHADER_0 = appending(tmp_8, _no_name_provided_$factory_570());
  }
  Companion_220.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_219;
  function Companion_getInstance_219() {
    if (Companion_instance_219 == null)
      new Companion_220();
    return Companion_instance_219;
  }
  function TransitionFilter(transition, reversed_2, smooth, ratio, filtering) {
    Companion_getInstance_219();
    ShaderFilter.call(this);
    this._transition_1 = transition;
    this._set_filtering__rpwsgn_k$(filtering);
    this._fragment_2 = Companion_getInstance_219()._FRAGMENT_SHADER_0;
    var tmp = this;
    tmp._textureUnit_0 = TextureUnit_init_$Create$(null, false, 3, null);
    var tmp_0 = this;
    var tmp_1 = this._get_uniforms__0_k$();
    var tmp_2 = Companion_getInstance_219()._u_Ratio;
    tmp_0._s_ratio = storageFor$default(tmp_1, tmp_2, null, 2, null);
    this._s_tex = storageForTextureUnit(this._get_uniforms__0_k$(), Companion_getInstance_219()._u_Mask, this._textureUnit_0);
    var tmp_3 = this;
    var tmp_4 = this._get_uniforms__0_k$();
    var tmp_5 = Companion_getInstance_219()._u_Reversed;
    var tmp_6 = storageFor$default(tmp_4, tmp_5, null, 2, null);
    tmp_3._reversed$delegate = tmp_6.boolDelegateX$default_notclq_k$(reversed_2, null, 2, null);
    var tmp_7 = this;
    var tmp_8 = this._get_uniforms__0_k$();
    var tmp_9 = Companion_getInstance_219()._u_Smooth;
    var tmp_10 = storageFor$default(tmp_8, tmp_9, null, 2, null);
    tmp_7._smooth$delegate = tmp_10.boolDelegateX$default_notclq_k$(smooth, null, 2, null);
    var tmp_11 = this;
    tmp_11._ratio$delegate = this._s_ratio.doubleDelegateX$default_vmusvy_k$(ratio, null, 2, null);
  }
  TransitionFilter.prototype._get_fragment__0_k$ = function () {
    return this._fragment_2;
  };
  TransitionFilter.prototype._set_ratio__okcceq_k$ = function (_set___) {
    return this._ratio$delegate.setValue_bg21lx_k$(this, ratio$factory_0(), _set___);
  };
  TransitionFilter.prototype._get_ratio__0_k$ = function () {
    return this._ratio$delegate.getValue_1rt9ub_k$(this, ratio$factory_1());
  };
  TransitionFilter.prototype.updateUniforms_uxru53_k$ = function (ctx) {
    this._textureUnit_0._texture_2 = ctx.getTex_nc8knv_k$(this._transition_1._bmp_4)._base_5;
  };
  TransitionFilter.$metadata$ = {
    simpleName: 'TransitionFilter',
    kind: 'class',
    interfaces: []
  };
  function HORIZONTAL$factory() {
    return getPropertyCallableRef('HORIZONTAL', 1, KProperty1, function (receiver) {
      return receiver._get_HORIZONTAL__0_k$();
    }, null);
  }
  function DIAGONAL1$factory() {
    return getPropertyCallableRef('DIAGONAL1', 1, KProperty1, function (receiver) {
      return receiver._get_DIAGONAL1__0_k$();
    }, null);
  }
  function CIRCULAR$factory() {
    return getPropertyCallableRef('CIRCULAR', 1, KProperty1, function (receiver) {
      return receiver._get_CIRCULAR__0_k$();
    }, null);
  }
  function ratio$factory_0() {
    return getPropertyCallableRef('ratio', 1, KMutableProperty1, function (receiver) {
      return receiver._get_ratio__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_ratio__okcceq_k$(value);
    });
  }
  function ratio$factory_1() {
    return getPropertyCallableRef('ratio', 1, KMutableProperty1, function (receiver) {
      return receiver._get_ratio__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_ratio__okcceq_k$(value);
    });
  }
  function _no_name_provided_$factory_564() {
    var i = new _no_name_provided__632();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_565() {
    var i = new _no_name_provided__633();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_566() {
    var i = new _no_name_provided__634();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_567() {
    var i = new _no_name_provided__635();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_568() {
    var i = new _no_name_provided__636();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_569() {
    var i = new _no_name_provided__637();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_570() {
    var i = new _no_name_provided__639();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_571() {
    var i = new _no_name_provided__638();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__640() {
  }
  _no_name_provided__640.prototype.invoke_dzcoxa_k$ = function ($this$FragmentShader) {
    var tmpx_2 = $this$FragmentShader._get_x__mp8w81_k$(DefaultShaders_getInstance()._t_Temp0);
    var tmpy_3 = $this$FragmentShader._get_y__mp8w81_k$(DefaultShaders_getInstance()._t_Temp0);
    $this$FragmentShader.setTo_ag43kx_k$(tmpx_2, $this$FragmentShader.sin_ojgi1d_k$($this$FragmentShader.times_l29sts_k$($this$FragmentShader._get_lit__xaho5p_k$(3.141592653589793), $this$FragmentShader.plus_l29sts_k$($this$FragmentShader.times_l29sts_k$($this$FragmentShader._get_x__mp8w81_k$(Companion_getInstance_217()._get_fragmentCoords01__20938x_k$($this$FragmentShader)), $this$FragmentShader._get_x__mp8w81_k$(Companion_getInstance_220()._u_crestCount)), $this$FragmentShader.times_l29sts_k$(Companion_getInstance_220()._u_Time, $this$FragmentShader._get_x__mp8w81_k$(Companion_getInstance_220()._u_cyclesPerSecond))))));
    $this$FragmentShader.setTo_ag43kx_k$(tmpy_3, $this$FragmentShader.sin_ojgi1d_k$($this$FragmentShader.times_l29sts_k$($this$FragmentShader._get_lit__xaho5p_k$(3.141592653589793), $this$FragmentShader.plus_l29sts_k$($this$FragmentShader.times_l29sts_k$($this$FragmentShader._get_y__mp8w81_k$(Companion_getInstance_217()._get_fragmentCoords01__20938x_k$($this$FragmentShader)), $this$FragmentShader._get_y__mp8w81_k$(Companion_getInstance_220()._u_crestCount)), $this$FragmentShader.times_l29sts_k$(Companion_getInstance_220()._u_Time, $this$FragmentShader._get_y__mp8w81_k$(Companion_getInstance_220()._u_cyclesPerSecond))))));
    $this$FragmentShader.setTo_ag43kx_k$($this$FragmentShader._out_8, Companion_getInstance_217().tex_yq73su_k$($this$FragmentShader, $this$FragmentShader.minus_l29sts_k$(Companion_getInstance_217()._get_fragmentCoords__20938x_k$($this$FragmentShader), $this$FragmentShader.vec2_ldyooh_k$([$this$FragmentShader.times_l29sts_k$(tmpy_3, $this$FragmentShader._get_x__mp8w81_k$(Companion_getInstance_220()._u_Amplitude)), $this$FragmentShader.times_l29sts_k$(tmpx_2, $this$FragmentShader._get_y__mp8w81_k$(Companion_getInstance_220()._u_Amplitude))]))));
    Unit_getInstance();
  };
  _no_name_provided__640.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_dzcoxa_k$(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__640.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function WaveFilter_init_$Init$(amplitudeX, amplitudeY, crestCountX, crestCountY, cyclesPerSecondX, cyclesPerSecondY, time, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      amplitudeX = 10;
    if (!(($mask0 & 2) === 0))
      amplitudeY = 10;
    if (!(($mask0 & 4) === 0))
      crestCountX = 2.0;
    if (!(($mask0 & 8) === 0))
      crestCountY = 2.0;
    if (!(($mask0 & 16) === 0))
      cyclesPerSecondX = 1.0;
    if (!(($mask0 & 32) === 0))
      cyclesPerSecondY = 1.0;
    if (!(($mask0 & 64) === 0)) {
      time = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    }WaveFilter.call($this, amplitudeX, amplitudeY, crestCountX, crestCountY, cyclesPerSecondX, cyclesPerSecondY, time);
    return $this;
  }
  function WaveFilter_init_$Create$(amplitudeX, amplitudeY, crestCountX, crestCountY, cyclesPerSecondX, cyclesPerSecondY, time, $mask0, $marker) {
    return WaveFilter_init_$Init$(amplitudeX, amplitudeY, crestCountX, crestCountY, cyclesPerSecondX, cyclesPerSecondY, time, $mask0, $marker, Object.create(WaveFilter.prototype));
  }
  function Companion_221() {
    Companion_instance_220 = this;
    var tmp = this;
    var tmp_0 = VarType_Float1_getInstance();
    tmp._u_Time = Uniform_init_$Create$('time', tmp_0, null, 4, null);
    var tmp_1 = this;
    var tmp_2 = VarType_Float2_getInstance();
    tmp_1._u_Amplitude = Uniform_init_$Create$('amplitude', tmp_2, null, 4, null);
    var tmp_3 = this;
    var tmp_4 = VarType_Float2_getInstance();
    tmp_3._u_crestCount = Uniform_init_$Create$('crestCount', tmp_4, null, 4, null);
    var tmp_5 = this;
    var tmp_6 = VarType_Float2_getInstance();
    tmp_5._u_cyclesPerSecond = Uniform_init_$Create$('cyclesPerSecond', tmp_6, null, 4, null);
    var tmp_7 = this;
    tmp_7._FRAGMENT_SHADER_1 = FragmentShader_0(_no_name_provided_$factory_572());
  }
  Companion_221.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_220;
  function Companion_getInstance_220() {
    if (Companion_instance_220 == null)
      new Companion_221();
    return Companion_instance_220;
  }
  function WaveFilter(amplitudeX, amplitudeY, crestCountX, crestCountY, cyclesPerSecondX, cyclesPerSecondY, time) {
    Companion_getInstance_220();
    ShaderFilter.call(this);
    var tmp = this;
    var tmp_0 = this._get_uniforms__0_k$();
    var tmp_1 = Companion_getInstance_220()._u_Amplitude;
    tmp._amplitude = storageFor$default(tmp_0, tmp_1, null, 2, null);
    var tmp_2 = this;
    var tmp_3 = this._get_uniforms__0_k$();
    var tmp_4 = Companion_getInstance_220()._u_crestCount;
    tmp_2._crestCount = storageFor$default(tmp_3, tmp_4, null, 2, null);
    var tmp_5 = this;
    var tmp_6 = this._get_uniforms__0_k$();
    var tmp_7 = Companion_getInstance_220()._u_cyclesPerSecond;
    tmp_5._cyclesPerSecond = storageFor$default(tmp_6, tmp_7, null, 2, null);
    var tmp_8 = this;
    tmp_8._amplitudeX$delegate = this._amplitude.intDelegateX$default_y6olaq_k$(amplitudeX, null, 2, null);
    var tmp_9 = this;
    tmp_9._amplitudeY$delegate = this._amplitude.intDelegateY$default_y6olaq_k$(amplitudeY, null, 2, null);
    var tmp_10 = this;
    tmp_10._crestCountX$delegate = this._crestCount.doubleDelegateX$default_vmusvy_k$(crestCountX, null, 2, null);
    var tmp_11 = this;
    tmp_11._crestCountY$delegate = this._crestCount.doubleDelegateY$default_vmusvy_k$(crestCountY, null, 2, null);
    var tmp_12 = this;
    tmp_12._cyclesPerSecondX$delegate = this._cyclesPerSecond.doubleDelegateX$default_vmusvy_k$(cyclesPerSecondX, null, 2, null);
    var tmp_13 = this;
    tmp_13._cyclesPerSecondY$delegate = this._cyclesPerSecond.doubleDelegateY$default_vmusvy_k$(cyclesPerSecondY, null, 2, null);
    var tmp_14 = this;
    var tmp_15 = this._get_uniforms__0_k$();
    var tmp_16 = Companion_getInstance_220()._u_Time;
    var tmp_17 = storageFor$default(tmp_15, tmp_16, null, 2, null);
    var tmp_18 = _TimeSpan___get_seconds__impl_(time);
    tmp_14._timeSeconds$delegate = tmp_17.doubleDelegateX$default_vmusvy_k$(tmp_18, null, 2, null);
    this._fragment_3 = Companion_getInstance_220()._FRAGMENT_SHADER_1;
  }
  WaveFilter.prototype._set_amplitudeX__majfzk_k$ = function (_set___) {
    return this._amplitudeX$delegate.setValue_10wnmr_k$(this, amplitudeX$factory(), _set___);
  };
  WaveFilter.prototype._get_amplitudeX__0_k$ = function () {
    return this._amplitudeX$delegate.getValue_1rt9ub_k$(this, amplitudeX$factory_0());
  };
  WaveFilter.prototype._set_amplitudeY__majfzk_k$ = function (_set___) {
    return this._amplitudeY$delegate.setValue_10wnmr_k$(this, amplitudeY$factory(), _set___);
  };
  WaveFilter.prototype._get_amplitudeY__0_k$ = function () {
    return this._amplitudeY$delegate.getValue_1rt9ub_k$(this, amplitudeY$factory_0());
  };
  WaveFilter.prototype._set_timeSeconds__okcceq_k$ = function (_set___) {
    return this._timeSeconds$delegate.setValue_bg21lx_k$(this, timeSeconds$factory(), _set___);
  };
  WaveFilter.prototype._get_timeSeconds__0_k$ = function () {
    return this._timeSeconds$delegate.getValue_1rt9ub_k$(this, timeSeconds$factory_0());
  };
  WaveFilter.prototype._set_time__zah5t7_k$ = function (value) {
    this._set_timeSeconds__okcceq_k$(_TimeSpan___get_seconds__impl_(value));
  };
  WaveFilter.prototype._get_time__nsqrdp_k$ = function () {
    var tmp0__get_seconds__0 = this._get_timeSeconds__0_k$();
    return Companion_getInstance_92().fromSeconds_ttklb2_k$(tmp0__get_seconds__0);
  };
  WaveFilter.prototype._get_border__0_k$ = function () {
    var tmp0__get_absoluteValue__0 = this._get_amplitudeX__0_k$();
    var tmp2_max_0 = abs(tmp0__get_absoluteValue__0);
    var tmp1__get_absoluteValue__0 = this._get_amplitudeY__0_k$();
    var tmp3_max_0 = abs(tmp1__get_absoluteValue__0);
    return Math.max(tmp2_max_0, tmp3_max_0);
  };
  WaveFilter.prototype._get_fragment__0_k$ = function () {
    return this._fragment_3;
  };
  WaveFilter.$metadata$ = {
    simpleName: 'WaveFilter',
    kind: 'class',
    interfaces: []
  };
  function amplitudeX$factory() {
    return getPropertyCallableRef('amplitudeX', 1, KMutableProperty1, function (receiver) {
      return receiver._get_amplitudeX__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_amplitudeX__majfzk_k$(value);
    });
  }
  function amplitudeX$factory_0() {
    return getPropertyCallableRef('amplitudeX', 1, KMutableProperty1, function (receiver) {
      return receiver._get_amplitudeX__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_amplitudeX__majfzk_k$(value);
    });
  }
  function amplitudeY$factory() {
    return getPropertyCallableRef('amplitudeY', 1, KMutableProperty1, function (receiver) {
      return receiver._get_amplitudeY__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_amplitudeY__majfzk_k$(value);
    });
  }
  function amplitudeY$factory_0() {
    return getPropertyCallableRef('amplitudeY', 1, KMutableProperty1, function (receiver) {
      return receiver._get_amplitudeY__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_amplitudeY__majfzk_k$(value);
    });
  }
  function timeSeconds$factory() {
    return getPropertyCallableRef('timeSeconds', 1, KMutableProperty1, function (receiver) {
      return receiver._get_timeSeconds__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_timeSeconds__okcceq_k$(value);
    });
  }
  function timeSeconds$factory_0() {
    return getPropertyCallableRef('timeSeconds', 1, KMutableProperty1, function (receiver) {
      return receiver._get_timeSeconds__0_k$();
    }, function (receiver_0, value) {
      return receiver_0._set_timeSeconds__okcceq_k$(value);
    });
  }
  function _no_name_provided_$factory_572() {
    var i = new _no_name_provided__640();
    return function (p1) {
      i.invoke_dzcoxa_k$(p1);
      return Unit_getInstance();
    };
  }
  function OrthographicGrid(width, height) {
    this._width_29 = width;
    this._height_30 = height;
  }
  OrthographicGrid.prototype.draw_ktvpd3_k$ = function (ctx, width, height, m) {
    var gridWidth = this._width_29;
    var gridHeight = this._height_30;
    var width_0 = numberToInt(width);
    var height_0 = numberToInt(height);
    var matrix = m;
    var transform = matrix.toTransform$default_888p34_k$(null, 1, null);
    var tmp0_use_0_1 = _get_debugLineRenderContext_(ctx);
    var tmp0_useBatcher_0_1_2 = tmp0_use_0_1._ctx_7;
    if (!(tmp0_useBatcher_0_1_2._currentBatcher === tmp0_use_0_1)) {
      tmp0_useBatcher_0_1_2.flush_sv8swh_k$();
      tmp0_useBatcher_0_1_2._currentBatcher = tmp0_use_0_1;
    }var tmp$ret$0;
    l$ret$1: do {
      tmp0_use_0_1._ctx_7.flush_sv8swh_k$();
      var temp_1_4 = tmp0_use_0_1._tempViewMat.alloc_0_k$();
      temp_1_4.copyFrom_srku5d_k$(tmp0_use_0_1._viewMat_0);
      Unit_getInstance();
      toMatrix3D(matrix, tmp0_use_0_1._viewMat_0);
      Unit_getInstance();
      try {
        var rect_3_5 = Companion_getInstance_36().invoke_ihmn6a_k$(0, 0, width_0, height_0);
        var dx_4_6 = transform._scaleX * gridWidth;
        var dy_5_7 = transform._scaleY * gridHeight;
        var smallX_6_8 = dx_4_6 < 3.0;
        var smallY_7_9 = dy_5_7 < 3.0;
        if (!smallX_6_8 ? !smallY_7_9 : false) {
          var tmp0_drawVector_0_8_10 = Colors_getInstance().get_xr0bn6_k$('#d3d3d367');
          var tmp1_drawVector_0_9_11 = tmp0_use_0_1._currentMatrix;
          var oldColor_1_1_10_12 = tmp0_use_0_1._color_6;
          tmp0_use_0_1._color_6 = tmp0_drawVector_0_8_10;
          try {
            var tmp0_apply_0_1_3_2_11_13 = VectorPath_init_$Create$(null, null, null, 7, null);
            var progression = step(until(_RectangleInt___get_left__impl_(rect_3_5), _RectangleInt___get_right__impl_(rect_3_5)), gridWidth);
            var inductionVariable = progression._first_0;
            var last_1 = progression._last;
            var step_0 = progression._step_2;
            if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
              do {
                var x_5_13_15 = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                var tmp = _RectangleInt___get_top__impl_(rect_3_5);
                var tmp_0 = _RectangleInt___get_bottom__impl_(rect_3_5);
                tmp0_use_0_1.line$default_okckny_k$(x_5_13_15, tmp, x_5_13_15, tmp_0, null, null, null, 112, null);
              }
               while (!(x_5_13_15 === last_1));
            var progression_0 = step(until(_RectangleInt___get_top__impl_(rect_3_5), _RectangleInt___get_bottom__impl_(rect_3_5)), gridHeight);
            var inductionVariable_0 = progression_0._first_0;
            var last_2 = progression_0._last;
            var step_1 = progression_0._step_2;
            if ((step_1 > 0 ? inductionVariable_0 <= last_2 : false) ? true : step_1 < 0 ? last_2 <= inductionVariable_0 : false)
              do {
                var y_7_15_17 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + step_1 | 0;
                var tmp_1 = _RectangleInt___get_left__impl_(rect_3_5);
                var tmp_2 = _RectangleInt___get_right__impl_(rect_3_5);
                tmp0_use_0_1.line$default_okckny_k$(tmp_1, y_7_15_17, tmp_2, y_7_15_17, null, null, null, 112, null);
              }
               while (!(y_7_15_17 === last_2));
            tmp0_use_0_1.drawVector_lypuw5_k$(tmp0_apply_0_1_3_2_11_13, tmp1_drawVector_0_9_11);
          }finally {
            tmp0_use_0_1._color_6 = oldColor_1_1_10_12;
          }
        }var tmp2_drawVector_0_16_18 = Colors_getInstance()._BLACK_0;
        var tmp3_drawVector_0_17_19 = tmp0_use_0_1._currentMatrix;
        var oldColor_1_1_18_20 = tmp0_use_0_1._color_6;
        tmp0_use_0_1._color_6 = tmp2_drawVector_0_16_18;
        try {
          var tmp0_apply_0_1_3_2_19_21 = VectorPath_init_$Create$(null, null, null, 7, null);
          rect_2(tmp0_apply_0_1_3_2_19_21, new RectangleInt(rect_3_5));
          tmp0_use_0_1.drawVector_lypuw5_k$(tmp0_apply_0_1_3_2_19_21, tmp3_drawVector_0_17_19);
        }finally {
          tmp0_use_0_1._color_6 = oldColor_1_1_18_20;
        }
        var tmp4_drawVector_0_20_22 = Colors_getInstance()._WHITE_0;
        var tmp5_drawVector_0_21_23 = tmp0_use_0_1._currentMatrix;
        var oldColor_1_1_22_24 = tmp0_use_0_1._color_6;
        tmp0_use_0_1._color_6 = tmp4_drawVector_0_20_22;
        var tmp_3;
        try {
          var tmp0_apply_0_1_3_2_23_25 = VectorPath_init_$Create$(null, null, null, 7, null);
          rect_1(tmp0_apply_0_1_3_2_23_25, _RectangleInt___get_left__impl_(rect_3_5) - 1 | 0, _RectangleInt___get_top__impl_(rect_3_5) - 1 | 0, _RectangleInt___get_width__impl_(rect_3_5) + 2 | 0, _RectangleInt___get_height__impl_(rect_3_5) + 2 | 0);
          tmp_3 = tmp0_use_0_1.drawVector_lypuw5_k$(tmp0_apply_0_1_3_2_23_25, tmp5_drawVector_0_21_23);
        }finally {
          tmp0_use_0_1._color_6 = oldColor_1_1_22_24;
        }
        tmp$ret$0 = tmp_3;
        break l$ret$1;
      }finally {
        tmp0_use_0_1.flush_sv8swh_k$();
        tmp0_use_0_1._viewMat_0.copyFrom_srku5d_k$(temp_1_4);
        Unit_getInstance();
      }
    }
     while (false);
  };
  OrthographicGrid.$metadata$ = {
    simpleName: 'OrthographicGrid',
    kind: 'class',
    interfaces: [Grid_0]
  };
  function Grid_0() {
  }
  Grid_0.$metadata$ = {
    simpleName: 'Grid',
    kind: 'interface',
    interfaces: []
  };
  function InternalViewAutoscaling() {
    this._renderedAtScaleX = 1.0;
    this._renderedAtScaleY = 1.0;
    this._renderedAtScaleXY = 1.0;
    var tmp = this;
    tmp._matrixTransform = Transform_init_$Create$(0.0, 0.0, 0.0, 0.0, null, null, null, 127, null);
  }
  InternalViewAutoscaling.prototype.onRender_2oo7xy_k$ = function (autoScaling, globalMatrix) {
    if (autoScaling) {
      this._matrixTransform.setMatrixNoReturn_skjkkf_k$(globalMatrix);
      var tmp0_abs_0 = this._matrixTransform._scaleX;
      var sx = Math.abs(tmp0_abs_0);
      var tmp1_abs_0 = this._matrixTransform._scaleY;
      var sy = Math.abs(tmp1_abs_0);
      var sxy = Math.max(sx, sy);
      var tmp2_abs_0 = sx / this._renderedAtScaleX - 1.0;
      var diffX = Math.abs(tmp2_abs_0);
      var tmp3_abs_0 = sy / this._renderedAtScaleY - 1.0;
      var diffY = Math.abs(tmp3_abs_0);
      if (diffX >= 0.1 ? true : diffY >= 0.1) {
        this._renderedAtScaleX = sx;
        this._renderedAtScaleY = sy;
        this._renderedAtScaleXY = sxy;
        return true;
      }} else {
      this._renderedAtScaleX = 1.0;
      this._renderedAtScaleY = 1.0;
      this._renderedAtScaleXY = 1.0;
    }
    return false;
  };
  InternalViewAutoscaling.$metadata$ = {
    simpleName: 'InternalViewAutoscaling',
    kind: 'class',
    interfaces: []
  };
  function KTreeSerializerHolder() {
  }
  KTreeSerializerHolder.$metadata$ = {
    simpleName: 'KTreeSerializerHolder',
    kind: 'interface',
    interfaces: []
  };
  function Companion_222() {
    Companion_instance_221 = this;
    this.___ex_ = '__ex_';
  }
  Companion_222.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_221;
  function Companion_getInstance_221() {
    if (Companion_instance_221 == null)
      new Companion_222();
    return Companion_instance_221;
  }
  function ktreeToViewTreeInternal$double($xml, prop, defaultValue) {
    prop.set($xml.double_qmgruq_k$(prop.callableName, defaultValue));
  }
  function ktreeToViewTreeInternal$angleDegrees($xml, prop, defaultValue) {
    prop.set(new Angle(_get_degrees__1($xml.double_qmgruq_k$(prop.callableName, _get_degrees_(defaultValue)))));
  }
  function ktreeToViewTreeInternal$color($xml, prop, defaultValue) {
    var tmp = Colors_getInstance();
    var tmp0_elvis_lhs = $xml.strNull_6wfw3l_k$(prop.callableName);
    prop.set(new RGBA(tmp.get_xr0bn6_k$(tmp0_elvis_lhs == null ? _RGBA___get_hexString__impl_(defaultValue) : tmp0_elvis_lhs)));
  }
  function ktreeToViewTreeInternal$string($xml, prop, defaultValue) {
    prop.set($xml.str_jg38oy_k$(prop.callableName, defaultValue));
  }
  function ktreeToViewTreeInternal$stringNull($xml, prop) {
    prop.set($xml.strNull_6wfw3l_k$(prop.callableName));
  }
  function ktreeToViewTreeInternal$boolean($xml, prop, defaultValue) {
    prop.set($xml.boolean_2f0f39_k$(prop.callableName, defaultValue));
  }
  function $ktreeToViewTreeCOROUTINE$40(_this_, xml, currentVfs, parent, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__204 = _this_;
    this._xml_1 = xml;
    this._currentVfs_10 = currentVfs;
    this._parent_8 = parent;
  }
  $ktreeToViewTreeCOROUTINE$40.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__204.ktreeToViewTreeInternal_j7zuzj_k$(this._xml_1, this._currentVfs_10, this._parent_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_also_0 = suspendResult;
            var tmp0_iterator_2 = this.__this__204._extensions_1.iterator_0_k$();
            while (tmp0_iterator_2.hasNext_0_k$()) {
              var extension_3 = tmp0_iterator_2.next_0_k$();
              extension_3.complete_y55136_k$(this.__this__204, tmp0_also_0);
            }

            return tmp0_also_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $ktreeToViewTreeCOROUTINE$40.$metadata$ = {
    simpleName: '$ktreeToViewTreeCOROUTINE$40',
    kind: 'class',
    interfaces: []
  };
  function $ktreeToViewTreeInternalCOROUTINE$41(_this_, xml, currentVfs, parent, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__205 = _this_;
    this._xml_2 = xml;
    this._currentVfs_11 = currentVfs;
    this._parent_9 = parent;
  }
  $ktreeToViewTreeInternalCOROUTINE$41.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 18;
            this._view0 = null;
            this._tmp0_subject1_0 = this._xml_2._nameLC_0;
            if (this._tmp0_subject1_0 === 'solidrect') {
              this._view0 = Companion_getInstance_209().invoke_xxd7wu_k$(100, 100, Colors_getInstance()._RED_0);
              this._state_1 = 7;
              continue $sm;
            } else {
              if (this._tmp0_subject1_0 === 'ellipse') {
                var tmp_0 = this;
                var tmp_1 = new RGBA(Colors_getInstance()._RED_0);
                tmp_0._view0 = Ellipse_init_$Create$(50.0, 50.0, tmp_1, null, 0.0, false, 56, null);
                this._state_1 = 7;
                continue $sm;
              } else {
                if (this._tmp0_subject1_0 === 'container') {
                  this._view0 = new Container();
                  this._state_1 = 7;
                  continue $sm;
                } else {
                  if (this._tmp0_subject1_0 === 'image') {
                    var tmp_2 = this;
                    var tmp_3 = this;
                    tmp_3._tmp0__get_transparent__02 = Bitmaps_getInstance();
                    tmp_2._view0 = Image_init_$Create$_0(Bitmaps_transparent, 0.0, 0.0, null, false, 30, null);
                    this._state_1 = 7;
                    continue $sm;
                  } else {
                    if (this._tmp0_subject1_0 === 'vectorimage') {
                      this._view0 = Companion_getInstance_214().createDefault_0_k$();
                      this._state_1 = 7;
                      continue $sm;
                    } else {
                      if (this._tmp0_subject1_0 === 'treeviewref') {
                        this._view0 = new TreeViewRef();
                        this._state_1 = 7;
                        continue $sm;
                      } else {
                        if (this._tmp0_subject1_0 === 'particle') {
                          var tmp_4 = this;
                          var tmp_5 = new ParticleEmitter();
                          tmp_4._view0 = ParticleEmitterView_init_$Create$(tmp_5, null, 2, null);
                          this._state_1 = 7;
                          continue $sm;
                        } else {
                          if (this._tmp0_subject1_0 === 'animation') {
                            this._view0 = new AnimationViewRef();
                            this._state_1 = 7;
                            continue $sm;
                          } else {
                            if (this._tmp0_subject1_0 === 'tiledmapref') {
                              this._view0 = new TiledMapViewRef();
                              this._state_1 = 7;
                              continue $sm;
                            } else {
                              if (this._tmp0_subject1_0 === 'ninepatch') {
                                var tmp_6 = this;
                                var tmp_7 = Companion_getInstance_131();
                                var tmp_8 = tmp_7.invoke_nc8knv_k$(Bitmap32_init_$Create$(62, 62, null, false, 12, null));
                                tmp_6._view0 = NinePatchEx_init_$Create$(tmp_8, 0.0, 0.0, 6, null);
                                this._state_1 = 7;
                                continue $sm;
                              } else {
                                if (this._tmp0_subject1_0 === 'ktree') {
                                  this._view0 = new KTreeRoot(100.0, 100.0);
                                  this._state_1 = 7;
                                  continue $sm;
                                } else {
                                  this._registration3 = this.__this__205._registrationsByNameLC.get_2bw_k$(this._xml_2._nameLC_0);
                                  if (!(this._registration3 == null)) {
                                    this._state_1 = 5;
                                    suspendResult = this._registration3.ktreeToViewTree_nuc85r_k$(this._xml_2, this._currentVfs_11, this);
                                    if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                                      return suspendResult;
                                    }continue $sm;
                                  } else {
                                    this._tmp1_iterator4 = this.__this__205._registrations.iterator_0_k$();
                                    this._state_1 = 1;
                                    continue $sm;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            if (!this._tmp1_iterator4.hasNext_0_k$()) {
              this._state_1 = 4;
              continue $sm;
            }
            this._registration5 = this._tmp1_iterator4.next_0_k$();
            this._state_1 = 2;
            suspendResult = this._registration5.deserializer__error(this._xml_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._view0 = suspendResult;
            if (!(this._view0 == null)) {
              this._state_1 = 4;
              continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._state_1 = 1;
            continue $sm;
          case 4:
            this._state_1 = 6;
            continue $sm;
          case 5:
            this._view0 = suspendResult;
            this._state_1 = 6;
            continue $sm;
          case 6:
            this._state_1 = 7;
            continue $sm;
          case 7:
            if (this._view0 == null) {
              var tmp1_TODO_0 = '' + "Unsupported node '" + this._xml_2._name_11 + "'";
              throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp1_TODO_0);
            }
            var tmp_9 = this._view0;
            if (!(tmp_9 == null) ? isInterface(tmp_9, ViewFileRef) : false) {
              var tmp_10 = this;
              tmp_10._sourceFile6 = this._xml_2.str$default_877n1b_k$('sourceFile', null, 2, null);
              if (!isBlank(this._sourceFile6)) {
                this._exceptionState = 9;
                this._state_1 = 8;
                suspendResult = this._view0.forceLoadSourceFile_mwdcj_k$(this.__this__205._views_19, this._currentVfs_11, this._sourceFile6, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                {
                  this._state_1 = 11;
                  continue $sm;
                }
              }
            } else {
              {
                this._state_1 = 12;
                continue $sm;
              }
            }

            break;
          case 8:
            this._exceptionState = 18;
            this._state_1 = 10;
            continue $sm;
          case 9:
            this._exceptionState = 18;
            var tmp_11 = this._exception_0;
            if (tmp_11 instanceof Error) {
              this._e7_1 = this._exception_0;
              printStackTrace(this._e7_1);
              this._state_1 = 10;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 10:
            this._exceptionState = 18;
            this._state_1 = 11;
            continue $sm;
          case 11:
            this._state_1 = 12;
            continue $sm;
          case 12:
            ktreeToViewTreeInternal$stringNull(this._xml_2, name$factory(this._view0));
            ktreeToViewTreeInternal$color(this._xml_2, colorMul$factory(this._view0), Colors_getInstance()._WHITE_0);
            ktreeToViewTreeInternal$double(this._xml_2, alpha$factory(this._view0), 1.0);
            ktreeToViewTreeInternal$double(this._xml_2, speed$factory(this._view0), 1.0);
            ktreeToViewTreeInternal$double(this._xml_2, ratio$factory_2(this._view0), 0.0);
            ktreeToViewTreeInternal$double(this._xml_2, x$factory_0(this._view0), 0.0);
            ktreeToViewTreeInternal$double(this._xml_2, y$factory_0(this._view0), 0.0);
            ktreeToViewTreeInternal$angleDegrees(this._xml_2, rotation$factory(this._view0), _get_degrees__0(0));
            ktreeToViewTreeInternal$double(this._xml_2, scaleX$factory_0(this._view0), 1.0);
            ktreeToViewTreeInternal$double(this._xml_2, scaleY$factory_0(this._view0), 1.0);
            ktreeToViewTreeInternal$angleDegrees(this._xml_2, skewX$factory(this._view0), _get_degrees__0(0));
            ktreeToViewTreeInternal$angleDegrees(this._xml_2, skewY$factory(this._view0), _get_degrees__0(0));
            var tmp_12 = this._view0;
            if (tmp_12 instanceof RectBase) {
              ktreeToViewTreeInternal$double(this._xml_2, anchorX$factory(this._view0), 0.0);
              ktreeToViewTreeInternal$double(this._xml_2, anchorY$factory(this._view0), 0.0);
              ktreeToViewTreeInternal$double(this._xml_2, width$factory_4(this._view0), 100.0);
              ktreeToViewTreeInternal$double(this._xml_2, height$factory_4(this._view0), 100.0);
            } else {
            }

            var tmp_13 = this._view0;
            if (tmp_13 instanceof NinePatchEx) {
              ktreeToViewTreeInternal$double(this._xml_2, width$factory_5(this._view0), 100.0);
              ktreeToViewTreeInternal$double(this._xml_2, height$factory_5(this._view0), 100.0);
            } else {
            }

            var tmp_14 = this._view0;
            if (tmp_14 instanceof Text_3) {
              ktreeToViewTreeInternal$string(this._xml_2, text$factory_3(this._view0), 'Text');
              ktreeToViewTreeInternal$double(this._xml_2, textSize$factory_3(this._view0), Companion_getInstance_212()._DEFAULT_TEXT_SIZE);
              ktreeToViewTreeInternal$boolean(this._xml_2, autoScaling$factory_0(this._view0), Companion_getInstance_212()._DEFAULT_AUTO_SCALING);
              var tmp_15 = this._view0;
              var tmp_16 = Companion_getInstance_151();
              tmp_15._set_verticalAlign__4c4bf4_k$(tmp_16.invoke_dd2oxv_k$(this._xml_2.str$default_877n1b_k$('verticalAlign', null, 2, null)));
              var tmp_17 = this._view0;
              var tmp_18 = Companion_getInstance_152();
              tmp_17._set_horizontalAlign__4fnuf6_k$(tmp_18.invoke_zfvmlt_k$(this._xml_2.str$default_877n1b_k$('horizontalAlign', null, 2, null)));
            } else {
            }

            var tmp_19 = this._view0;
            if (tmp_19 instanceof KTreeRoot) {
              this._view0._set_width__okcceq_k$(this._xml_2.double_qmgruq_k$('width', 512.0));
              this._view0._set_height__okcceq_k$(this._xml_2.double_qmgruq_k$('height', 512.0));
              this._view0._grid_0._width_29 = this._xml_2.int_8i7b4u_k$('gridWidth', 20);
              this._view0._grid_0._height_30 = this._xml_2.int_8i7b4u_k$('gridHeight', 20);
            } else {
            }

            this._view0._set_blendMode__9dm7zh_k$(Companion_getInstance_206().get_6wfw3l_k$(this._xml_2.str_jg38oy_k$('blendMode', 'INHERIT')));
            var tmp2_safe_receiver = this._parent_9;
            if (tmp2_safe_receiver == null)
              null;
            else {
              tmp2_safe_receiver.addChild_4l6ao4_k$(this._view0);
              Unit_getInstance();
            }

            Unit_getInstance();
            var tmp_20 = this._view0;
            if (tmp_20 instanceof Container) {
              this._tmp3_iterator8 = this._xml_2._get_allNodeChildren__0_k$().iterator_0_k$();
              this._state_1 = 13;
              continue $sm;
            } else {
              {
                this._state_1 = 17;
                continue $sm;
              }
            }

            break;
          case 13:
            if (!this._tmp3_iterator8.hasNext_0_k$()) {
              this._state_1 = 16;
              continue $sm;
            }
            this._node9 = this._tmp3_iterator8.next_0_k$();
            var tmp_21 = Companion_getInstance_221().___ex_;
            if (startsWith$default_1(this._node9._nameLC_0, tmp_21, false, 2, null)) {
              this._state_1 = 13;
              continue $sm;
            } else {
              {
                this._state_1 = 14;
                continue $sm;
              }
            }

            break;
          case 14:
            this._state_1 = 15;
            suspendResult = this.__this__205.ktreeToViewTreeInternal_j7zuzj_k$(this._node9, this._currentVfs_11, this._view0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 15:
            Unit_getInstance();
            this._state_1 = 13;
            continue $sm;
          case 16:
            this._state_1 = 17;
            continue $sm;
          case 17:
            var tmp4_iterator = this._xml_2._get_allNodeChildren__0_k$().iterator_0_k$();
            while (tmp4_iterator.hasNext_0_k$()) {
              var node = tmp4_iterator.next_0_k$();
              var tmp_22 = Companion_getInstance_221().___ex_;
              if (!startsWith$default_1(node._nameLC_0, tmp_22, false, 2, null))
                continue;
              else {
              }
              var extensionName = removePrefix(node._nameLC_0, Companion_getInstance_221().___ex_);
              var extension = this.__this__205._extensionsByName.get_2bw_k$(extensionName);
              if (extension == null) {
                println('' + "Can't find extension " + Companion_getInstance_221().___ex_ + ' : extensionName=' + extensionName);
              }var tmp5_safe_receiver = extension;
              if (tmp5_safe_receiver == null)
                null;
              else {
                tmp5_safe_receiver.setProps_exmqkx_k$(this.__this__205, this._view0, node);
                Unit_getInstance();
              }
              Unit_getInstance();
            }

            return this._view0;
          case 18:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 18) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $ktreeToViewTreeInternalCOROUTINE$41.$metadata$ = {
    simpleName: '$ktreeToViewTreeInternalCOROUTINE$41',
    kind: 'class',
    interfaces: []
  };
  function KTreeSerializer(views_0) {
    Companion_getInstance_221();
    this._views_19 = views_0;
    var tmp = this;
    tmp._$$delegate_0_50 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._registrationsExt = LinkedHashSet_init_$Create$();
    this._registrationsByClass = LinkedHashMap_init_$Create$();
    this._registrationsByNameLC = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    tmp_1._registrations = LinkedHashSet_init_$Create$();
    var tmp_2 = this;
    tmp_2._extensions_1 = LinkedHashSet_init_$Create$();
    this._extensionsByName = LinkedHashMap_init_$Create$();
    this.register_8g84o4_k$(Serializer_getInstance());
    this.register_8g84o4_k$(Serializer_getInstance_2());
    this.register_8g84o4_k$(Serializer_getInstance_1());
    this.register_8g84o4_k$(Serializer_getInstance_0());
  }
  KTreeSerializer.prototype._set_extra__n1onou_k$ = function (_set___) {
    this._$$delegate_0_50._set_extra__n1onou_k$(_set___);
  };
  KTreeSerializer.prototype._get_extra__0_k$ = function () {
    return this._$$delegate_0_50._get_extra__0_k$();
  };
  KTreeSerializer.prototype._get_serializer__0_k$ = function () {
    return this;
  };
  KTreeSerializer.prototype.register_8g84o4_k$ = function (registration) {
    this._registrationsExt.add_2bq_k$(registration);
    Unit_getInstance();
    var tmp0_set_0 = this._registrationsByClass;
    var tmp1_set_0 = registration._clazz_5;
    tmp0_set_0.put_1q9pf_k$(tmp1_set_0, registration);
    Unit_getInstance();
    var tmp2_set_0 = this._registrationsByNameLC;
    var tmp3_set_0 = registration._nameLC_1;
    tmp2_set_0.put_1q9pf_k$(tmp3_set_0, registration);
    Unit_getInstance();
  };
  KTreeSerializer.prototype.ktreeToViewTree_j7zuzj_k$ = function (xml, currentVfs, parent, $cont) {
    var tmp = new $ktreeToViewTreeCOROUTINE$40(this, xml, currentVfs, parent, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  KTreeSerializer.prototype.ktreeToViewTreeInternal_j7zuzj_k$ = function (xml, currentVfs, parent, $cont) {
    var tmp = new $ktreeToViewTreeInternalCOROUTINE$41(this, xml, currentVfs, parent, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  KTreeSerializer.$metadata$ = {
    simpleName: 'KTreeSerializer',
    kind: 'class',
    interfaces: [KTreeSerializerHolder, Extra]
  };
  function Prop(prop, default_0) {
    this._prop_1 = prop;
    this._default_4 = default_0;
  }
  Prop.prototype.toString = function () {
    return '' + 'Prop(prop=' + this._prop_1 + ', default=' + this._default_4 + ')';
  };
  Prop.prototype.hashCode = function () {
    var result = hashCode(this._prop_1);
    result = imul(result, 31) + (this._default_4 == null ? 0 : hashCode(this._default_4)) | 0;
    return result;
  };
  Prop.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Prop))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Prop ? other : THROW_CCE();
    if (!equals_1(this._prop_1, tmp0_other_with_cast._prop_1))
      return false;
    if (!equals_1(this._default_4, tmp0_other_with_cast._default_4))
      return false;
    return true;
  };
  Prop.$metadata$ = {
    simpleName: 'Prop',
    kind: 'class',
    interfaces: []
  };
  function CustomProp(prop, serialize, deserialize) {
    this._prop_2 = prop;
    this._serialize = serialize;
    this._deserialize = deserialize;
  }
  CustomProp.prototype.toString = function () {
    return '' + 'CustomProp(prop=' + this._prop_2 + ', serialize=' + this._serialize + ', deserialize=' + this._deserialize + ')';
  };
  CustomProp.prototype.hashCode = function () {
    var result = hashCode(this._prop_2);
    result = imul(result, 31) + hashCode(this._serialize) | 0;
    result = imul(result, 31) + hashCode(this._deserialize) | 0;
    return result;
  };
  CustomProp.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CustomProp))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CustomProp ? other : THROW_CCE();
    if (!equals_1(this._prop_2, tmp0_other_with_cast._prop_2))
      return false;
    if (!equals_1(this._serialize, tmp0_other_with_cast._serialize))
      return false;
    if (!equals_1(this._deserialize, tmp0_other_with_cast._deserialize))
      return false;
    return true;
  };
  CustomProp.$metadata$ = {
    simpleName: 'CustomProp',
    kind: 'class',
    interfaces: []
  };
  function KTreeSerializerExt(name, clazz, factory, block) {
    this._name_47 = name;
    this._clazz_5 = clazz;
    this._factory = factory;
    this._block_4 = block;
    var tmp = this;
    var tmp0_toLowerCase_0 = this._name_47;
    tmp._nameLC_1 = tmp0_toLowerCase_0.toLowerCase();
    var tmp_0 = this;
    tmp_0._propsBoolean = ArrayList_init_$Create$();
    var tmp_1 = this;
    tmp_1._propsString = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2._propsStringNull = ArrayList_init_$Create$();
    var tmp_3 = this;
    tmp_3._propsDouble = ArrayList_init_$Create$();
    var tmp_4 = this;
    tmp_4._propsInt = ArrayList_init_$Create$();
    var tmp_5 = this;
    tmp_5._propsRGBA = ArrayList_init_$Create$();
    var tmp_6 = this;
    tmp_6._propsCustom = ArrayList_init_$Create$();
    this._allPropsList = listOf([this._propsBoolean, this._propsString, this._propsStringNull, this._propsDouble, this._propsInt, this._propsRGBA]);
    this._block_4(this);
  }
  KTreeSerializerExt.prototype.add_utj6n9_k$ = function (prop, serialize, deserialize) {
    this._propsCustom.add_2bq_k$(new CustomProp(prop, serialize, deserialize));
    Unit_getInstance();
  };
  KTreeSerializerExt.prototype.add_no4f49_k$ = function (prop, default_0) {
    return this._propsBoolean.add_2bq_k$(new Prop(prop, default_0));
  };
  KTreeSerializerExt.prototype.add$default_5jqalj_k$ = function (prop, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      default_0 = false;
    return this.add_no4f49_k$(prop, default_0);
  };
  KTreeSerializerExt.prototype.add_whpltd_k$ = function (prop, default_0) {
    return this._propsString.add_2bq_k$(new Prop(prop, default_0));
  };
  KTreeSerializerExt.prototype.add$default_aqar58_k$ = function (prop, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      default_0 = '';
    return this.add_whpltd_k$(prop, default_0);
  };
  KTreeSerializerExt.prototype.add_m0hu7f_k$ = function (prop) {
    return this._propsStringNull.add_2bq_k$(new Prop(prop, null));
  };
  KTreeSerializerExt.prototype.add_iop6bz_k$ = function (prop, default_0) {
    return this._propsDouble.add_2bq_k$(new Prop(prop, default_0));
  };
  KTreeSerializerExt.prototype.add$default_8vq79r_k$ = function (prop, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      default_0 = 0.0;
    return this.add_iop6bz_k$(prop, default_0);
  };
  KTreeSerializerExt.prototype.ktreeToViewTree_nuc85r_k$ = function (xml, currentVfs, $cont) {
    if (!(xml._nameLC_0 === this._nameLC_1)) {
      var tmp0_error_0 = '' + "Not a '" + this._nameLC_1 + "' (" + this._clazz_5 + ') : ' + xml._nameLC_0;
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }var instance = this._factory();
    var tmp1_fastForEach_0 = this._propsBoolean;
    var n_1 = 0;
    while (n_1 < tmp1_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp2__anonymous__3 = tmp1_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      tmp2__anonymous__3._prop_1.set(instance, xml.str_jg38oy_k$(tmp2__anonymous__3._prop_1.callableName, '' + tmp2__anonymous__3._default_4) === 'true');
    }
    var tmp3_fastForEach_0 = this._propsString;
    var n_1_0 = 0;
    while (n_1_0 < tmp3_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_0 = n_1_0;
      n_1_0 = tmp0_2_0 + 1 | 0;
      var tmp4__anonymous__3 = tmp3_fastForEach_0.get_ha5a7z_k$(tmp0_2_0);
      tmp4__anonymous__3._prop_1.set(instance, xml.str_jg38oy_k$(tmp4__anonymous__3._prop_1.callableName, tmp4__anonymous__3._default_4));
    }
    var tmp5_fastForEach_0 = this._propsStringNull;
    var n_1_1 = 0;
    while (n_1_1 < tmp5_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_1 = n_1_1;
      n_1_1 = tmp0_2_1 + 1 | 0;
      var tmp6__anonymous__3 = tmp5_fastForEach_0.get_ha5a7z_k$(tmp0_2_1);
      tmp6__anonymous__3._prop_1.set(instance, xml.strNull_6wfw3l_k$(tmp6__anonymous__3._prop_1.callableName));
    }
    var tmp7_fastForEach_0 = this._propsRGBA;
    var n_1_2 = 0;
    while (n_1_2 < tmp7_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_2 = n_1_2;
      n_1_2 = tmp0_2_2 + 1 | 0;
      var tmp8__anonymous__3 = tmp7_fastForEach_0.get_ha5a7z_k$(tmp0_2_2);
      var tmp = Colors_getInstance();
      var tmp0_elvis_lhs_4 = xml.strNull_6wfw3l_k$(tmp8__anonymous__3._prop_1.callableName);
      tmp8__anonymous__3._prop_1.set(instance, new RGBA(tmp.get_xr0bn6_k$(tmp0_elvis_lhs_4 == null ? _RGBA___get_hexString__impl_(tmp8__anonymous__3._default_4._value_19) : tmp0_elvis_lhs_4)));
    }
    var tmp9_fastForEach_0 = this._propsDouble;
    var n_1_3 = 0;
    while (n_1_3 < tmp9_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_3 = n_1_3;
      n_1_3 = tmp0_2_3 + 1 | 0;
      var tmp10__anonymous__3 = tmp9_fastForEach_0.get_ha5a7z_k$(tmp0_2_3);
      tmp10__anonymous__3._prop_1.set(instance, xml.double_qmgruq_k$(tmp10__anonymous__3._prop_1.callableName, tmp10__anonymous__3._default_4));
    }
    var tmp11_fastForEach_0 = this._propsInt;
    var n_1_4 = 0;
    while (n_1_4 < tmp11_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_4 = n_1_4;
      n_1_4 = tmp0_2_4 + 1 | 0;
      var tmp12__anonymous__3 = tmp11_fastForEach_0.get_ha5a7z_k$(tmp0_2_4);
      tmp12__anonymous__3._prop_1.set(instance, xml.int_8i7b4u_k$(tmp12__anonymous__3._prop_1.callableName, tmp12__anonymous__3._default_4));
    }
    var tmp13_fastForEach_0 = this._propsCustom;
    var n_1_5 = 0;
    while (n_1_5 < tmp13_fastForEach_0._get_size__0_k$()) {
      var tmp0_2_5 = n_1_5;
      n_1_5 = tmp0_2_5 + 1 | 0;
      var tmp14__anonymous__3 = tmp13_fastForEach_0.get_ha5a7z_k$(tmp0_2_5);
      if (tmp14__anonymous__3 instanceof CustomProp)
        tmp14__anonymous__3;
      else
        THROW_CCE();
      Unit_getInstance();
      var tmp_0 = tmp14__anonymous__3._prop_2.callableName;
      tmp14__anonymous__3._prop_2.set(instance, tmp14__anonymous__3._serialize(xml.str$default_877n1b_k$(tmp_0, null, 2, null)));
    }
    return instance;
  };
  KTreeSerializerExt.$metadata$ = {
    simpleName: 'KTreeSerializerExt',
    kind: 'class',
    interfaces: []
  };
  function KTreeRoot(width, height) {
    FixedSizeContainer_init_$Init$(width, height, false, 4, null, this);
    this._grid_0 = new OrthographicGrid(20, 20);
    this._showGrid = false;
  }
  KTreeRoot.prototype.renderInternal_uxru53_k$ = function (ctx) {
    FixedSizeContainer.prototype.renderInternal_uxru53_k$.call(this, ctx);
    if (this._showGrid) {
      this._grid_0.draw_ktvpd3_k$(ctx, this._get_width__0_k$(), this._get_height__0_k$(), this._get_globalMatrix__0_k$());
    }};
  KTreeRoot.$metadata$ = {
    simpleName: 'KTreeRoot',
    kind: 'class',
    interfaces: []
  };
  function readKTree(_this_, serializer, parent, $cont) {
    var tmp = new $readKTreeCOROUTINE$42(_this_, serializer, parent, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function readKTree$default(_this_, serializer, parent, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      parent = null;
    return readKTree(_this_, serializer, parent, $cont);
  }
  function ktreeToViewTree(_this_, serializer, currentVfs, parent, $cont) {
    return serializer._get_serializer__0_k$().ktreeToViewTree_j7zuzj_k$(_this_, currentVfs, parent, $cont);
  }
  function readKTree_0(_this_, parent, $cont) {
    var tmp = new $readKTreeCOROUTINE$43(_this_, parent, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  }
  function $readKTreeCOROUTINE$42(_this_, serializer, parent, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__206 = _this_;
    this._serializer_0 = serializer;
    this._parent_10 = parent;
  }
  $readKTreeCOROUTINE$42.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = readXml(this.__this__206, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_32 = suspendResult;
            this._state_1 = 2;
            suspendResult = ktreeToViewTree(this._ARGUMENT0_32, this._serializer_0, this.__this__206._get_parent__0_k$(), this._parent_10, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readKTreeCOROUTINE$42.$metadata$ = {
    simpleName: '$readKTreeCOROUTINE$42',
    kind: 'class',
    interfaces: []
  };
  function $readKTreeCOROUTINE$43(_this_, parent, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__207 = _this_;
    this._parent_11 = parent;
  }
  $readKTreeCOROUTINE$43.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = views(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_33 = suspendResult;
            this._state_1 = 2;
            suspendResult = readKTree(this.__this__207, this._ARGUMENT0_33, this._parent_11, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readKTreeCOROUTINE$43.$metadata$ = {
    simpleName: '$readKTreeCOROUTINE$43',
    kind: 'class',
    interfaces: []
  };
  function name$factory($b0) {
    return getPropertyCallableRef('name', 0, KMutableProperty0, function () {
      return $b0._name_43;
    }, function (value) {
      $b0._name_43 = value;
      return Unit_getInstance();
    });
  }
  function colorMul$factory($b0) {
    return getPropertyCallableRef('colorMul', 0, KMutableProperty0, function () {
      return new RGBA($b0._get_colorMul__12t64v_k$());
    }, function (value) {
      return $b0._set_colorMul__f52nlt_k$(value._value_19);
    });
  }
  function alpha$factory($b0) {
    return getPropertyCallableRef('alpha', 0, KMutableProperty0, function () {
      return $b0._get_alpha__0_k$();
    }, function (value) {
      return $b0._set_alpha__okcceq_k$(value);
    });
  }
  function speed$factory($b0) {
    return getPropertyCallableRef('speed', 0, KMutableProperty0, function () {
      return $b0._speed_2;
    }, function (value) {
      $b0._speed_2 = value;
      return Unit_getInstance();
    });
  }
  function ratio$factory_2($b0) {
    return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
      return $b0._get_ratio__0_k$();
    }, function (value) {
      return $b0._set_ratio__okcceq_k$(value);
    });
  }
  function x$factory_0($b0) {
    return getPropertyCallableRef('x', 0, KMutableProperty0, function () {
      return $b0._get_x__0_k$();
    }, function (value) {
      return $b0._set_x__okcceq_k$(value);
    });
  }
  function y$factory_0($b0) {
    return getPropertyCallableRef('y', 0, KMutableProperty0, function () {
      return $b0._get_y__0_k$();
    }, function (value) {
      return $b0._set_y__okcceq_k$(value);
    });
  }
  function rotation$factory($b0) {
    return getPropertyCallableRef('rotation', 0, KMutableProperty0, function () {
      return new Angle($b0._get_rotation__gxicn3_k$());
    }, function (value) {
      return $b0._set_rotation__p0vwlp_k$(value._radians);
    });
  }
  function scaleX$factory_0($b0) {
    return getPropertyCallableRef('scaleX', 0, KMutableProperty0, function () {
      return $b0._get_scaleX__0_k$();
    }, function (value) {
      return $b0._set_scaleX__okcceq_k$(value);
    });
  }
  function scaleY$factory_0($b0) {
    return getPropertyCallableRef('scaleY', 0, KMutableProperty0, function () {
      return $b0._get_scaleY__0_k$();
    }, function (value) {
      return $b0._set_scaleY__okcceq_k$(value);
    });
  }
  function skewX$factory($b0) {
    return getPropertyCallableRef('skewX', 0, KMutableProperty0, function () {
      return new Angle($b0._get_skewX__gxicn3_k$());
    }, function (value) {
      return $b0._set_skewX__p0vwlp_k$(value._radians);
    });
  }
  function skewY$factory($b0) {
    return getPropertyCallableRef('skewY', 0, KMutableProperty0, function () {
      return new Angle($b0._get_skewY__gxicn3_k$());
    }, function (value) {
      return $b0._set_skewY__p0vwlp_k$(value._radians);
    });
  }
  function anchorX$factory($b0) {
    return getPropertyCallableRef('anchorX', 0, KMutableProperty0, function () {
      return $b0._get_anchorX__0_k$();
    }, function (value) {
      return $b0._set_anchorX__okcceq_k$(value);
    });
  }
  function anchorY$factory($b0) {
    return getPropertyCallableRef('anchorY', 0, KMutableProperty0, function () {
      return $b0._get_anchorY__0_k$();
    }, function (value) {
      return $b0._set_anchorY__okcceq_k$(value);
    });
  }
  function width$factory_4($b0) {
    return getPropertyCallableRef('width', 0, KMutableProperty0, function () {
      return $b0._get_width__0_k$();
    }, function (value) {
      return $b0._set_width__okcceq_k$(value);
    });
  }
  function height$factory_4($b0) {
    return getPropertyCallableRef('height', 0, KMutableProperty0, function () {
      return $b0._get_height__0_k$();
    }, function (value) {
      return $b0._set_height__okcceq_k$(value);
    });
  }
  function width$factory_5($b0) {
    return getPropertyCallableRef('width', 0, KMutableProperty0, function () {
      return $b0._get_width__0_k$();
    }, function (value) {
      return $b0._set_width__okcceq_k$(value);
    });
  }
  function height$factory_5($b0) {
    return getPropertyCallableRef('height', 0, KMutableProperty0, function () {
      return $b0._get_height__0_k$();
    }, function (value) {
      return $b0._set_height__okcceq_k$(value);
    });
  }
  function text$factory_3($b0) {
    return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
      return $b0._get_text__0_k$();
    }, function (value) {
      return $b0._set_text__a4enbm_k$(value);
    });
  }
  function textSize$factory_3($b0) {
    return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
      return $b0._textSize;
    }, function (value) {
      return $b0._set_textSize__okcceq_k$(value);
    });
  }
  function autoScaling$factory_0($b0) {
    return getPropertyCallableRef('autoScaling', 0, KMutableProperty0, function () {
      return $b0._autoScaling_0;
    }, function (value) {
      $b0._autoScaling_0 = value;
      return Unit_getInstance();
    });
  }
  var Repeat_NONE_instance;
  var Repeat_REPEAT_instance;
  var Repeat_MIRROR_instance;
  function _no_name_provided__641() {
  }
  _no_name_provided__641.prototype.invoke_27zxwg_k$ = function (v, max) {
    return v;
  };
  _no_name_provided__641.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_27zxwg_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__641.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__642() {
  }
  _no_name_provided__642.prototype.invoke_27zxwg_k$ = function (v, max) {
    return umod_2(v, max);
  };
  _no_name_provided__642.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_27zxwg_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__642.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__643() {
  }
  _no_name_provided__643.prototype.invoke_27zxwg_k$ = function (v, max) {
    var r = umod_2(v, max);
    return (v / max | 0) % 2 === 0 ? r : (max - 1 | 0) - r | 0;
  };
  _no_name_provided__643.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_27zxwg_k$(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__643.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var Repeat_entriesInitialized;
  function Repeat_initEntries() {
    if (Repeat_entriesInitialized)
      return Unit_getInstance();
    Repeat_entriesInitialized = true;
    Repeat_NONE_instance = new Repeat('NONE', 0, _no_name_provided_$factory_575());
    Repeat_REPEAT_instance = new Repeat('REPEAT', 1, _no_name_provided_$factory_576());
    Repeat_MIRROR_instance = new Repeat('MIRROR', 2, _no_name_provided_$factory_577());
  }
  function swap_1(_this_, $this, a, b) {
    var t_2 = _this_[a];
    _this_[a] = _this_[b];
    _this_[b] = t_2;
    return _this_;
  }
  function Repeat(name, ordinal, get_2) {
    Enum.call(this, name, ordinal);
    this._get = get_2;
  }
  Repeat.$metadata$ = {
    simpleName: 'Repeat',
    kind: 'class',
    interfaces: []
  };
  function computeVertexIfRequired($this, ctx) {
    if (!$this._get_dirtyVertices__0_k$() ? $this._cachedContentVersion === $this._contentVersion_0 : false)
      return Unit_getInstance();
    $this._cachedContentVersion = $this._contentVersion_0;
    $this._set_dirtyVertices__rpwsgn_k$(false);
    var m = $this._get_globalMatrix__0_k$();
    var renderTilesCounter = ctx._stats_1.counter_6wfw3l_k$('renderedTiles');
    var posX = m.transformX_ngl742_k$(0.0, 0.0);
    var posY = m.transformY_ngl742_k$(0.0, 0.0);
    var dUX = m.transformX_ngl742_k$($this._tileWidth_0, 0.0) - posX;
    var dUY = m.transformY_ngl742_k$($this._tileWidth_0, 0.0) - posY;
    var dVX = m.transformX_ngl742_k$(0.0, $this._tileHeight_0) - posX;
    var dVY = m.transformY_ngl742_k$(0.0, $this._tileHeight_0) - posY;
    var tmp;
    if (!($this._staggerAxis_0 == null)) {
      var it = _Size___get_height__impl_($this._tileSize) - $this._tileHeight_0;
      var tmp0_min_0 = m.transformX_ngl742_k$(it, 0.0) - posX;
      var tmp1_min_0 = m.transformY_ngl742_k$(0.0, it);
      tmp = Math.min(tmp0_min_0, tmp1_min_0);
    } else {
      tmp = 0.0;
    }
    var initY = tmp;
    var tmp2_let_0 = _Size___get_width__impl_($this._tileSize) / (equals_1($this._staggerAxis_0, StaggerAxis_X_getInstance()) ? 2.0 : 1.0);
    var tmp0_min_0_2 = m.transformX_ngl742_k$(tmp2_let_0, 0.0) - posX;
    var tmp1_min_0_3 = m.transformY_ngl742_k$(0.0, tmp2_let_0) - posY;
    var nextTileX = Math.min(tmp0_min_0_2, tmp1_min_0_3);
    var tmp3_let_0 = _Size___get_height__impl_($this._tileSize) / (equals_1($this._staggerAxis_0, StaggerAxis_Y_getInstance()) ? 2.0 : 1.0);
    var tmp0_min_0_2_0 = m.transformX_ngl742_k$(tmp3_let_0, 0.0) - posX;
    var tmp1_min_0_3_0 = m.transformY_ngl742_k$(0.0, tmp3_let_0) - posY;
    var nextTileY = Math.min(tmp0_min_0_2_0, tmp1_min_0_3_0);
    var tmp4_let_0 = $this._tileWidth_0 / 2.0;
    var tmp0_min_0_2_1 = m.transformX_ngl742_k$(tmp4_let_0, 0.0) - posX;
    var tmp1_min_0_3_1 = m.transformY_ngl742_k$(0.0, tmp4_let_0) - posY;
    var staggerX = Math.min(tmp0_min_0_2_1, tmp1_min_0_3_1);
    var tmp5_let_0 = _Size___get_height__impl_($this._tileSize) / 2.0;
    var tmp0_min_0_2_2 = m.transformX_ngl742_k$(tmp5_let_0, 0.0) - posX;
    var tmp1_min_0_3_2 = m.transformY_ngl742_k$(0.0, tmp5_let_0) - posY;
    var staggerY = Math.min(tmp0_min_0_2_2, tmp1_min_0_3_2);
    var colMul = $this._get_renderColorMul__12t64v_k$();
    var colAdd = $this._get_renderColorAdd__7hz20p_k$();
    var pp0 = $this.globalToLocal_p5v4q1_k$($this._t0_0.setTo_ngl742_k$($this._currentVirtualRect._get_left__0_k$(), $this._currentVirtualRect._get_top__0_k$()), $this._tt0);
    var pp1 = $this.globalToLocal_p5v4q1_k$($this._t0_0.setTo_ngl742_k$($this._currentVirtualRect._get_right__0_k$(), $this._currentVirtualRect._get_bottom__0_k$()), $this._tt1);
    var pp2 = $this.globalToLocal_p5v4q1_k$($this._t0_0.setTo_ngl742_k$($this._currentVirtualRect._get_right__0_k$(), $this._currentVirtualRect._get_top__0_k$()), $this._tt2);
    var pp3 = $this.globalToLocal_p5v4q1_k$($this._t0_0.setTo_ngl742_k$($this._currentVirtualRect._get_left__0_k$(), $this._currentVirtualRect._get_bottom__0_k$()), $this._tt3);
    var mapTileWidth = _Size___get_width__impl_($this._tileSize);
    var mapTileHeight = _Size___get_height__impl_($this._tileSize) / (equals_1($this._staggerAxis_0, StaggerAxis_Y_getInstance()) ? 2.0 : 1.0);
    var mx0 = numberToInt(pp0._x_1 / mapTileWidth - 1);
    var mx1 = numberToInt(pp1._x_1 / mapTileWidth + 1);
    var mx2 = numberToInt(pp2._x_1 / mapTileWidth + 1);
    var mx3 = numberToInt(pp3._x_1 / mapTileWidth + 1);
    var my0 = numberToInt(pp0._y_1 / mapTileHeight - 1);
    var my1 = numberToInt(pp1._y_1 / mapTileHeight + 1);
    var my2 = numberToInt(pp2._y_1 / mapTileHeight + 1);
    var my3 = numberToInt(pp3._y_1 / mapTileHeight + 1);
    var tmp6_min_0 = Math.min(my0, my1);
    var tmp7_min_0 = Math.min(tmp6_min_0, my2);
    var ymin = Math.min(tmp7_min_0, my3);
    var tmp8_max_0 = Math.max(my0, my1);
    var tmp9_max_0 = Math.max(tmp8_max_0, my2);
    var ymax = Math.max(tmp9_max_0, my3);
    var tmp10_min_0 = Math.min(mx0, mx1);
    var tmp11_min_0 = Math.min(tmp10_min_0, mx2);
    var xmin = Math.min(tmp11_min_0, mx3);
    var tmp12_max_0 = Math.max(mx0, mx1);
    var tmp13_max_0 = Math.max(tmp12_max_0, mx2);
    var xmax = Math.max(tmp13_max_0, mx3);
    var yheight = ymax - ymin | 0;
    var xwidth = xmax - xmin | 0;
    var ntiles = imul(xwidth, yheight);
    var allocTiles = _get_nextPowerOfTwo_(ntiles);
    var tmp14_fastForEach_0 = $this._infos_0;
    var n_1 = 0;
    while (n_1 < tmp14_fastForEach_0._get_size__0_k$()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp15__anonymous__3 = tmp14_fastForEach_0.get_ha5a7z_k$(tmp0_2);
      $this._infosPool.free_iav7o_k$(tmp15__anonymous__3);
    }
    clear($this._verticesPerTex);
    $this._infos_0.clear_sv8swh_k$();
    var count_0 = 0;
    var passes = equals_1($this._staggerAxis_0, StaggerAxis_X_getInstance()) ? 2 : 1;
    var inductionVariable = ymin;
    if (inductionVariable < ymax)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < passes)
          do {
            var pass = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var inductionVariable_1 = xmin;
            if (inductionVariable_1 < xmax)
              do {
                var x = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var rx = $this._repeatX._get(x, $this._intMap._width);
                var ry = $this._repeatY._get(y, $this._intMap._height);
                if (rx < 0 ? true : rx >= $this._intMap._width)
                  continue;
                if (ry < 0 ? true : ry >= $this._intMap._height)
                  continue;
                if (equals_1($this._staggerAxis_0, StaggerAxis_X_getInstance())) {
                  var firstPass = (equals_1($this._staggerIndex_0, StaggerIndex_ODD_getInstance()) ? _get_isEven_(rx) : false) ? true : equals_1($this._staggerIndex_0, StaggerIndex_EVEN_getInstance()) ? _get_isOdd_(rx) : false;
                  var secondPass = (equals_1($this._staggerIndex_0, StaggerIndex_ODD_getInstance()) ? _get_isOdd_(rx) : false) ? true : equals_1($this._staggerIndex_0, StaggerIndex_EVEN_getInstance()) ? _get_isEven_(rx) : false;
                  if (pass === 0 ? !firstPass : false)
                    continue;
                  if (pass === 1 ? !secondPass : false)
                    continue;
                }var cell = $this._intMap.get_27zxwg_k$(rx, ry);
                var odd = equals_1($this._staggerAxis_0, StaggerAxis_Y_getInstance()) ? _get_isOdd_(ry) : _get_isOdd_(rx);
                var staggered = odd ? equals_1($this._staggerIndex_0, StaggerIndex_ODD_getInstance()) : equals_1($this._staggerIndex_0, StaggerIndex_EVEN_getInstance());
                var cellData = extract(cell, 0, 28);
                var flipX = extract_0(cell, 31);
                var flipY = extract_0(cell, 30);
                var rotate = extract_0(cell, 29);
                var tmp16_takeIf_0 = $this._staggerAxis_0;
                var tmp_0;
                if (staggered) {
                  tmp_0 = tmp16_takeIf_0;
                } else {
                  {
                    tmp_0 = null;
                  }
                }
                var tmp3_subject = tmp_0;
                var staggerOffsetX = equals_1(tmp3_subject, StaggerAxis_Y_getInstance()) ? staggerX : equals_1(tmp3_subject, StaggerAxis_X_getInstance()) ? 0.0 : 0.0;
                var tmp17_takeIf_0 = $this._staggerAxis_0;
                var tmp_1;
                if (staggered) {
                  tmp_1 = tmp17_takeIf_0;
                } else {
                  {
                    tmp_1 = null;
                  }
                }
                var tmp4_subject = tmp_1;
                var staggerOffsetY = equals_1(tmp4_subject, StaggerAxis_Y_getInstance()) ? 0.0 : equals_1(tmp4_subject, StaggerAxis_X_getInstance()) ? staggerY : 0.0;
                var tmp5 = count_0;
                count_0 = tmp5 + 1 | 0;
                Unit_getInstance();
                var tmp6_elvis_lhs = $this._tilesetTextures[cellData];
                var tmp_2;
                if (tmp6_elvis_lhs == null) {
                  continue;
                } else {
                  tmp_2 = tmp6_elvis_lhs;
                }
                var tex = tmp_2;
                var tmp$ret$0;
                l$ret$1: do {
                  var tmp18_getOrPut_0 = $this._verticesPerTex;
                  var tmp19_getOrPut_0 = tex._bmpBase;
                  var res_1 = get(tmp18_getOrPut_0, tmp19_getOrPut_0);
                  if (!(res_1 == null)) {
                    tmp$ret$0 = res_1;
                    break l$ret$1;
                  }var tmp0_also_0_4 = $this._infosPool.alloc_0_k$();
                  tmp0_also_0_4._tex_2 = tex._bmpBase;
                  if (tmp0_also_0_4._vertices_7._initialVcount < imul(allocTiles, 4)) {
                    var tmp_3 = tmp0_also_0_4;
                    var tmp_4 = imul(allocTiles, 4);
                    var tmp0_quadIndices_0_2_5 = Companion_getInstance_202();
                    var tmp_5 = TEXTURED_ARRAY_quadIndices(allocTiles);
                    tmp_3._vertices_7 = TexturedVertexArray_init_$Create$(tmp_4, tmp_5, 0, 4, null);
                  }tmp0_also_0_4._vcount_0 = 0;
                  tmp0_also_0_4._icount = 0;
                  var tmp0_this_3_6 = $this;
                  var tmp1_plusAssign_0_4_7 = tmp0_this_3_6._infos_0;
                  tmp1_plusAssign_0_4_7.add_2bq_k$(tmp0_also_0_4);
                  Unit_getInstance();
                  var out_2 = tmp0_also_0_4;
                  set(tmp18_getOrPut_0, tmp19_getOrPut_0, out_2);
                  tmp$ret$0 = out_2;
                }
                 while (false);
                var info = tmp$ret$0;
                var p0X_2 = posX + nextTileX * x + dVX * y + staggerOffsetX;
                var p0Y_3 = posY + dUY * x + nextTileY * y + staggerOffsetY + initY;
                var p1X_4 = p0X_2 + dUX;
                var p1Y_5 = p0Y_3 + dUY;
                var p2X_6 = p0X_2 + dUX + dVX;
                var p2Y_7 = p0Y_3 + dUY + dVY;
                var p3X_8 = p0X_2 + dVX;
                var p3Y_9 = p0Y_3 + dVY;
                $this._tempX[0] = tex._get_tl_x__0_k$();
                $this._tempX[1] = tex._get_tr_x__0_k$();
                $this._tempX[2] = tex._get_br_x__0_k$();
                $this._tempX[3] = tex._get_bl_x__0_k$();
                $this._tempY[0] = tex._get_tl_y__0_k$();
                $this._tempY[1] = tex._get_tr_y__0_k$();
                $this._tempY[2] = tex._get_br_y__0_k$();
                $this._tempY[3] = tex._get_bl_y__0_k$();
                Companion_getInstance_222().computeIndices_rhc3ou_k$(flipX, flipY, rotate, $this._indices_2);
                Unit_getInstance();
                var tmp_6 = info._vertices_7;
                var tmp0_this_10 = info;
                var tmp1_11 = tmp0_this_10._vcount_0;
                tmp0_this_10._vcount_0 = tmp1_11 + 1 | 0;
                tmp_6.quadV_hx94cc_k$(tmp1_11, p0X_2, p0Y_3, $this._tempX[$this._indices_2[0]], $this._tempY[$this._indices_2[0]], colMul, colAdd);
                var tmp_7 = info._vertices_7;
                var tmp2_this_12 = info;
                var tmp3_13 = tmp2_this_12._vcount_0;
                tmp2_this_12._vcount_0 = tmp3_13 + 1 | 0;
                tmp_7.quadV_hx94cc_k$(tmp3_13, p1X_4, p1Y_5, $this._tempX[$this._indices_2[1]], $this._tempY[$this._indices_2[1]], colMul, colAdd);
                var tmp_8 = info._vertices_7;
                var tmp4_this_14 = info;
                var tmp5_15 = tmp4_this_14._vcount_0;
                tmp4_this_14._vcount_0 = tmp5_15 + 1 | 0;
                tmp_8.quadV_hx94cc_k$(tmp5_15, p2X_6, p2Y_7, $this._tempX[$this._indices_2[2]], $this._tempY[$this._indices_2[2]], colMul, colAdd);
                var tmp_9 = info._vertices_7;
                var tmp6_this_16 = info;
                var tmp7_17 = tmp6_this_16._vcount_0;
                tmp6_this_16._vcount_0 = tmp7_17 + 1 | 0;
                tmp_9.quadV_hx94cc_k$(tmp7_17, p3X_8, p3Y_9, $this._tempX[$this._indices_2[3]], $this._tempY[$this._indices_2[3]], colMul, colAdd);
                var tmp7_this = info;
                tmp7_this._icount = tmp7_this._icount + 6 | 0;
              }
               while (inductionVariable_1 < xmax);
          }
           while (inductionVariable_0 < passes);
      }
       while (inductionVariable < ymax);
    renderTilesCounter.increment_majfzk_k$(count_0);
  }
  function Info_2(tex, vertices) {
    this._tex_2 = tex;
    this._vertices_7 = vertices;
    this._vcount_0 = 0;
    this._icount = 0;
  }
  Info_2.$metadata$ = {
    simpleName: 'Info',
    kind: 'class',
    interfaces: []
  };
  function Companion_223() {
    Companion_instance_222 = this;
    this._dummyTexturedVertexArray = Companion_getInstance_202()._EMPTY_6;
  }
  Companion_223.prototype.computeIndices_rhc3ou_k$ = function (flipX, flipY, rotate, indices) {
    indices[0] = 0;
    indices[1] = 1;
    indices[2] = 2;
    indices[3] = 3;
    if (rotate) {
      swap_1(indices, this, 1, 3);
      Unit_getInstance();
    }if (flipY) {
      swap_1(indices, this, 0, 3);
      Unit_getInstance();
      swap_1(indices, this, 1, 2);
      Unit_getInstance();
    }if (flipX) {
      swap_1(indices, this, 0, 1);
      Unit_getInstance();
      swap_1(indices, this, 3, 2);
      Unit_getInstance();
    }return indices;
  };
  Companion_223.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_222;
  function Companion_getInstance_222() {
    if (Companion_instance_222 == null)
      new Companion_223();
    return Companion_instance_222;
  }
  function _no_name_provided__644() {
  }
  _no_name_provided__644.prototype.invoke_ha5a7z_k$ = function (it) {
    var tmp0__get_transparent__0 = Bitmaps_getInstance();
    return new Info_2(Bitmaps_transparent._get_bmpBase__0_k$(), Companion_getInstance_222()._dummyTexturedVertexArray);
  };
  _no_name_provided__644.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_ha5a7z_k$((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__644.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__645() {
  }
  _no_name_provided__645.prototype.invoke_nn9sui_k$ = function ($this$addUpdater, dt) {
    var tmp0_fastForEachWithIndex_0 = $this$addUpdater._tileset_1._get_infos__0_k$();
    var n_1 = 0;
    while (n_1 < tmp0_fastForEachWithIndex_0.length) {
      var tmp1__anonymous__3 = n_1;
      var tmp2__anonymous__3 = tmp0_fastForEachWithIndex_0[n_1];
      var tmp;
      if (!(tmp2__anonymous__3 == null)) {
        var tmp0_isNotEmpty_0_4 = tmp2__anonymous__3._frames_2;
        tmp = !tmp0_isNotEmpty_0_4.isEmpty_0_k$();
      } else {
        tmp = false;
      }
      if (tmp) {
        var aindex_5 = $this$addUpdater._animationIndex[tmp1__anonymous__3];
        var currentFrame_6 = tmp2__anonymous__3._frames_2.get_ha5a7z_k$(aindex_5);
        var tmp0_array_7 = $this$addUpdater._animationElapsed;
        var tmp1_index0_8 = tmp1__anonymous__3;
        tmp0_array_7[tmp1_index0_8] = tmp0_array_7[tmp1_index0_8] + _TimeSpan___get_milliseconds__impl_(dt);
        var tmp1__get_milliseconds__0_9 = $this$addUpdater._animationElapsed[tmp1__anonymous__3];
        if (TimeSpan__compareTo_impl(Companion_getInstance_92().fromMilliseconds_ttklb2_k$(tmp1__get_milliseconds__0_9), currentFrame_6._duration_3) >= 0) {
          var nextIndex_10 = (aindex_5 + 1 | 0) % tmp2__anonymous__3._frames_2._get_size__0_k$();
          var tmp2_array_11 = $this$addUpdater._animationElapsed;
          var tmp3_index0_12 = tmp1__anonymous__3;
          tmp2_array_11[tmp3_index0_12] = tmp2_array_11[tmp3_index0_12] - _TimeSpan___get_milliseconds__impl_(currentFrame_6._duration_3);
          $this$addUpdater._animationIndex[tmp1__anonymous__3] = nextIndex_10;
          $this$addUpdater._tilesetTextures[tmp1__anonymous__3] = $this$addUpdater._tileset_1._get_textures__0_k$()[tmp2__anonymous__3._frames_2.get_ha5a7z_k$(nextIndex_10)._tileId_3];
          var tmp4_this_13 = $this$addUpdater;
          var tmp5_14 = tmp4_this_13._contentVersion_0;
          tmp4_this_13._contentVersion_0 = tmp5_14 + 1 | 0;
          Unit_getInstance();
        } else {
        }
      } else {
      }
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      Unit_getInstance();
    }
  };
  _no_name_provided__645.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TileMap ? p1 : THROW_CCE();
    this.invoke_nn9sui_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__645.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Repeat_NONE_getInstance() {
    Repeat_initEntries();
    return Repeat_NONE_instance;
  }
  function TileMap(intMap, tileset, smoothing, orientation, staggerAxis, staggerIndex, tileSize) {
    Companion_getInstance_222();
    View_init_$Init$(this);
    this._intMap = intMap;
    this._tileset_1 = tileset;
    this._smoothing_5 = smoothing;
    this._orientation_1 = orientation;
    this._staggerAxis_0 = staggerAxis;
    this._staggerIndex_0 = staggerIndex;
    this._tileSize = tileSize;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this._tileset_1._get_textures__0_k$().length;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = this._tileset_1._get_textures__0_k$()[tmp_3];
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._tilesetTextures = tmp_2;
    var tmp_4 = this;
    var tmp_5 = 0;
    var tmp_6 = this._tileset_1._get_textures__0_k$().length;
    var tmp_7 = fillArrayVal(Array(tmp_6), null);
    while (tmp_5 < tmp_6) {
      var tmp_8 = tmp_5;
      tmp_7[tmp_8] = 0;
      tmp_5 = tmp_5 + 1 | 0;
    }
    tmp_4._animationIndex = tmp_7;
    var tmp_9 = this;
    var tmp_10 = 0;
    var tmp_11 = this._tileset_1._get_textures__0_k$().length;
    var tmp_12 = fillArrayVal(Array(tmp_11), null);
    while (tmp_10 < tmp_11) {
      var tmp_13 = tmp_10;
      tmp_12[tmp_13] = 0.0;
      tmp_10 = tmp_10 + 1 | 0;
    }
    tmp_9._animationElapsed = tmp_12;
    this._contentVersion_0 = 0;
    this._tileWidth_0 = this._tileset_1._width_30;
    this._tileHeight_0 = this._tileset_1._height_31;
    this._repeatX = Repeat_NONE_getInstance();
    this._repeatY = Repeat_NONE_getInstance();
    this._t0_0 = Point_init_$Create$_0(0, 0);
    this._tt0 = Point_init_$Create$_0(0, 0);
    this._tt1 = Point_init_$Create$_0(0, 0);
    this._tt2 = Point_init_$Create$_0(0, 0);
    this._tt3 = Point_init_$Create$_0(0, 0);
    this._cachedContentVersion = 0;
    this._indices_2 = new Int32Array(4);
    this._tempX = new Float32Array(4);
    this._tempY = new Float32Array(4);
    this._verticesPerTex = FastIdentityMap();
    var tmp_14 = this;
    tmp_14._infos_0 = ArrayList_init_$Create$();
    var tmp_15 = this;
    tmp_15._infosPool = Pool_init_$Create$_1(0, _no_name_provided_$factory_573(), 1, null);
    this._lastVirtualRect = Companion_getInstance_35().invoke_w0xdj4_k$(-1, -1, -1, -1);
    this._currentVirtualRect = Companion_getInstance_35().invoke_w0xdj4_k$(-1, -1, -1, -1);
    addUpdater(this, _no_name_provided_$factory_574());
    Unit_getInstance();
  }
  TileMap.prototype.pixelHitTest_ksczqu_k$ = function (x, y, direction) {
    if (x < 0 ? true : y < 0)
      return true;
    var tw = this._tileset_1._width_30;
    var th = this._tileset_1._height_31;
    return this.pixelHitTest_29pb2u_k$(x / tw | 0, y / th | 0, x % tw, y % th, direction);
  };
  TileMap.prototype.pixelHitTest_29pb2u_k$ = function (tileX, tileY, x, y, direction) {
    if (!this._intMap.inside_27zxwg_k$(tileX, tileY))
      return true;
    var tile = this._intMap.get_27zxwg_k$(tileX, tileY);
    var tmp0_elvis_lhs = this._tileset_1._get_collisions__0_k$()[tile];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var collision = tmp;
    return collision.hitTestAny_j5t4vg_k$(x, y, direction);
  };
  TileMap.prototype.renderInternal_uxru53_k$ = function (ctx) {
    if (!this._get_visible__0_k$())
      return Unit_getInstance();
    this._currentVirtualRect.setBounds_i6u10_k$(ctx._get_virtualLeft__0_k$(), ctx._get_virtualTop__0_k$(), ctx._get_virtualRight__0_k$(), ctx._get_virtualBottom__0_k$());
    Unit_getInstance();
    if (!this._currentVirtualRect.equals(this._lastVirtualRect)) {
      this._set_dirtyVertices__rpwsgn_k$(true);
      this._lastVirtualRect.copyFrom_uebyw0_k$(this._currentVirtualRect);
      Unit_getInstance();
    }computeVertexIfRequired(this, ctx);
    var tmp0_use_0_1 = ctx._batch_0;
    var tmp0_useBatcher_0_1_2 = tmp0_use_0_1._ctx_6;
    if (!(tmp0_useBatcher_0_1_2._currentBatcher === tmp0_use_0_1)) {
      tmp0_useBatcher_0_1_2.flush_sv8swh_k$();
      tmp0_useBatcher_0_1_2._currentBatcher = tmp0_use_0_1;
    }var tmp0_fastForEach_0_4 = this._infos_0;
    var n_1_5 = 0;
    while (n_1_5 < tmp0_fastForEach_0_4._get_size__0_k$()) {
      var tmp0_2_7 = n_1_5;
      n_1_5 = tmp0_2_7 + 1 | 0;
      var tmp1__anonymous__3_6 = tmp0_fastForEach_0_4.get_ha5a7z_k$(tmp0_2_7);
      var tmp0_drawVertices_0_4_8 = tmp1__anonymous__3_6._vertices_7;
      var tmp1_drawVertices_0_5_9 = ctx.getTex_nc8knv_k$(tmp1__anonymous__3_6._tex_2);
      var tmp2_drawVertices_0_6_10 = this._smoothing_5;
      var tmp3_drawVertices_0_7_11 = this._get_renderBlendMode__0_k$()._factors;
      var tmp4_drawVertices_0_8_12 = tmp1__anonymous__3_6._vcount_0;
      var tmp5_drawVertices_0_9_13 = tmp1__anonymous__3_6._icount;
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_setStateFast_0_1_10_14 = tmp1_drawVertices_0_5_9._base_5;
        var isCurrentStateFast_1_2_11_15 = tmp0_use_0_1.isCurrentStateFast_ww8sek_k$(tmp0_setStateFast_0_1_10_14, tmp2_drawVertices_0_6_10, tmp3_drawVertices_0_7_11, null);
        if (isCurrentStateFast_1_2_11_15) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }tmp0_use_0_1.flush$default_9k51td_k$(false, false, 3, null);
        tmp0_use_0_1._currentTexIndex = 0;
        tmp0_use_0_1._currentTexN[0] = tmp0_setStateFast_0_1_10_14;
        tmp0_use_0_1._currentSmoothing = tmp2_drawVertices_0_6_10;
        tmp0_use_0_1._currentBlendFactors = (!(tmp0_setStateFast_0_1_10_14 == null) ? tmp0_setStateFast_0_1_10_14._isFbo : false) ? toRenderFboIntoBack(tmp3_drawVertices_0_7_11) : tmp3_drawVertices_0_7_11;
        tmp0_use_0_1._currentProgram = null;
      }
       while (false);
      tmp0_use_0_1.drawVertices$default_69bxws_k$(tmp0_drawVertices_0_4_8, null, tmp4_drawVertices_0_8_12, tmp5_drawVertices_0_9_13, 0, 16, null);
    }
  };
  TileMap.prototype.getLocalBoundsInternal_wf26y9_k$ = function (out) {
    var tmp0_setTo_0 = this._tileWidth_0 * this._intMap._width;
    var tmp1_setTo_0 = this._tileHeight_0 * this._intMap._height;
    out.setTo_i6u10_k$(0.0, 0.0, numberToDouble(tmp0_setTo_0), numberToDouble(tmp1_setTo_0));
    Unit_getInstance();
  };
  TileMap.$metadata$ = {
    simpleName: 'TileMap',
    kind: 'class',
    interfaces: []
  };
  function toIntArray2(_this_) {
    return new IntArray2(_this_._get_width__0_k$(), _this_._get_height__0_k$(), _RgbaArray___get_ints__impl_(_this_._data_25));
  }
  function repeat_0(_this_, repeatX, repeatY) {
    _this_._repeatX = repeatX;
    _this_._repeatY = repeatY;
    return _this_;
  }
  function _no_name_provided_$factory_573() {
    var i = new _no_name_provided__644();
    return function (p1) {
      return i.invoke_ha5a7z_k$(p1);
    };
  }
  function _no_name_provided_$factory_574() {
    var i = new _no_name_provided__645();
    return function (p1, p2) {
      i.invoke_nn9sui_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_575() {
    var i = new _no_name_provided__641();
    return function (p1, p2) {
      return i.invoke_27zxwg_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_576() {
    var i = new _no_name_provided__642();
    return function (p1, p2) {
      return i.invoke_27zxwg_k$(p1, p2);
    };
  }
  function _no_name_provided_$factory_577() {
    var i = new _no_name_provided__643();
    return function (p1, p2) {
      return i.invoke_27zxwg_k$(p1, p2);
    };
  }
  function TileSet_init_$Init$(texturesMap, width, height, collisionsMap, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      width = texturesMap.firstValue_0_k$()._slice_1._get_width__0_k$();
    if (!(($mask0 & 4) === 0))
      height = texturesMap.firstValue_0_k$()._slice_1._get_height__0_k$();
    if (!(($mask0 & 8) === 0)) {
      collisionsMap = IntMap_init_$Create$(0, 0.0, 3, null);
    }TileSet.call($this, texturesMap, width, height, collisionsMap);
    return $this;
  }
  function TileSet_init_$Create$(texturesMap, width, height, collisionsMap, $mask0, $marker) {
    return TileSet_init_$Init$(texturesMap, width, height, collisionsMap, $mask0, $marker, Object.create(TileSet.prototype));
  }
  function Companion_224() {
    Companion_instance_223 = this;
  }
  Companion_224.prototype.invoke_6ggabi_k$ = function (base, tileWidth, tileHeight, columns, totalTiles, collisionsMap) {
    var out = IntMap_init_$Create$(0, 0.0, 3, null);
    var rows = base._get_height__0_k$() / tileHeight | 0;
    var actualColumns = columns < 0 ? base._get_width__0_k$() / tileWidth | 0 : columns;
    var actualTotalTiles = totalTiles < 0 ? imul(rows, actualColumns) : totalTiles;
    var n = 0;
    var inductionVariable = 0;
    if (inductionVariable < rows)
      complete: do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < actualColumns)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = n;
            var tmp_0 = n + 1 | 0;
            var tmp_1 = imul(x, tileWidth);
            var tmp_2 = imul(y, tileHeight);
            var tmp_3 = base.sliceWithSize$default_cox0wy_k$(tmp_1, tmp_2, tileWidth, tileHeight, null, 16, null);
            out.set_bq5tp3_k$(tmp, TileSetTileInfo_init_$Create$(tmp_0, tmp_3, null, 4, null));
            Unit_getInstance();
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            Unit_getInstance();
            if (out._size_1 >= actualTotalTiles)
              break complete;
          }
           while (inductionVariable_0 < actualColumns);
      }
       while (inductionVariable < rows);
    return new TileSet(out, tileWidth, tileHeight, collisionsMap);
  };
  Companion_224.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_223;
  function Companion_getInstance_223() {
    if (Companion_instance_223 == null)
      new Companion_224();
    return Companion_instance_223;
  }
  function _no_name_provided__646(this$0) {
    this._this$0_171 = this$0;
  }
  _no_name_provided__646.prototype.invoke_0_k$ = function () {
    var tmp;
    if (this._this$0_171._texturesMap._size_1 === 0) {
      var tmp0__get_transparent__0 = Bitmaps_getInstance();
      tmp = Bitmaps_transparent._get_bmpBase__0_k$();
    } else {
      tmp = this._this$0_171._texturesMap.firstValue_0_k$()._slice_1._bmpBase;
    }
    return tmp;
  };
  _no_name_provided__646.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__647(this$0) {
    this._this$0_172 = this$0;
  }
  _no_name_provided__647.prototype.invoke_0_k$ = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._this$0_172._texturesMap._get_values__0_k$();
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_0_k$();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_0_k$();
      while (tmp0_iterator_1.hasNext_0_k$()) {
        var element_2 = tmp0_iterator_1.next_0_k$();
        if (!(element_2 === null) ? !(element_2._slice_1._bmpBase === this._this$0_172._get_base__0_k$()) : false) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  _no_name_provided__647.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__648(this$0) {
    this._this$0_173 = this$0;
  }
  _no_name_provided__648.prototype.invoke_0_k$ = function () {
    var tmp = 0;
    var tmp0_safe_receiver = maxOrNull(this._this$0_173._texturesMap._get_keys__0_k$());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver + 1 | 0;
    var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this._this$0_173._texturesMap.get_ha5a7z_k$(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
  _no_name_provided__648.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__649(this$0) {
    this._this$0_174 = this$0;
  }
  _no_name_provided__649.prototype.invoke_0_k$ = function () {
    var tmp = 0;
    var tmp0_safe_receiver = maxOrNull(this._this$0_174._texturesMap._get_keys__0_k$());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver + 1 | 0;
    var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp0_safe_receiver_0 = this._this$0_174._texturesMap.get_ha5a7z_k$(tmp_2);
      tmp_1[tmp_2] = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0._slice_1;
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
  _no_name_provided__649.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__650(this$0) {
    this._this$0_175 = this$0;
  }
  _no_name_provided__650.prototype.invoke_0_k$ = function () {
    var tmp = 0;
    var tmp0_safe_receiver = maxOrNull(this._this$0_175._texturesMap._get_keys__0_k$());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver + 1 | 0;
    var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this._this$0_175._collisionsMap.get_ha5a7z_k$(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
  _no_name_provided__650.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TileSet(texturesMap, width, height, collisionsMap) {
    Companion_getInstance_223();
    this._texturesMap = texturesMap;
    this._width_30 = width;
    this._height_31 = height;
    this._collisionsMap = collisionsMap;
    var tmp = this;
    tmp._base$delegate = lazy(_no_name_provided_$factory_578(this));
    var tmp_0 = this;
    tmp_0._hasMultipleBaseBitmaps$delegate = lazy(_no_name_provided_$factory_579(this));
    var tmp_1 = this;
    tmp_1._infos$delegate = lazy(_no_name_provided_$factory_580(this));
    var tmp_2 = this;
    tmp_2._textures$delegate = lazy(_no_name_provided_$factory_581(this));
    var tmp_3 = this;
    tmp_3._collisions$delegate = lazy(_no_name_provided_$factory_582(this));
  }
  TileSet.prototype._get_base__0_k$ = function () {
    var tmp0_getValue_0 = base$factory();
    return this._base$delegate._get_value__0_k$();
  };
  TileSet.prototype._get_infos__0_k$ = function () {
    var tmp0_getValue_0 = infos$factory();
    return this._infos$delegate._get_value__0_k$();
  };
  TileSet.prototype._get_textures__0_k$ = function () {
    var tmp0_getValue_0 = textures$factory();
    return this._textures$delegate._get_value__0_k$();
  };
  TileSet.prototype._get_collisions__0_k$ = function () {
    var tmp0_getValue_0 = collisions$factory();
    return this._collisions$delegate._get_value__0_k$();
  };
  TileSet.prototype.getInfo_ha5a7z_k$ = function (index_0) {
    return getOrNull_0(this._get_infos__0_k$(), index_0);
  };
  TileSet.prototype.getSlice_ha5a7z_k$ = function (index_0) {
    var tmp0_safe_receiver = this.getInfo_ha5a7z_k$(index_0);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._slice_1;
  };
  TileSet.prototype.get_ha5a7z_k$ = function (index_0) {
    return this.getSlice_ha5a7z_k$(index_0);
  };
  TileSet.$metadata$ = {
    simpleName: 'TileSet',
    kind: 'class',
    interfaces: []
  };
  function TileSetTileInfo_init_$Init$(id, slice_1, frames, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      frames = emptyList();
    TileSetTileInfo.call($this, id, slice_1, frames);
    return $this;
  }
  function TileSetTileInfo_init_$Create$(id, slice_1, frames, $mask0, $marker) {
    return TileSetTileInfo_init_$Init$(id, slice_1, frames, $mask0, $marker, Object.create(TileSetTileInfo.prototype));
  }
  function TileSetTileInfo(id, slice_1, frames) {
    this._id_34 = id;
    this._slice_1 = slice_1;
    this._frames_2 = frames;
  }
  TileSetTileInfo.prototype.copy_eh3x3a_k$ = function (id, slice_1, frames) {
    return new TileSetTileInfo(id, slice_1, frames);
  };
  TileSetTileInfo.prototype.copy$default_ohfk3m_k$ = function (id, slice_1, frames, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this._id_34;
    if (!(($mask0 & 2) === 0))
      slice_1 = this._slice_1;
    if (!(($mask0 & 4) === 0))
      frames = this._frames_2;
    return this.copy_eh3x3a_k$(id, slice_1, frames);
  };
  TileSetTileInfo.prototype.toString = function () {
    return '' + 'TileSetTileInfo(id=' + this._id_34 + ', slice=' + this._slice_1 + ', frames=' + this._frames_2 + ')';
  };
  TileSetTileInfo.prototype.hashCode = function () {
    var result = this._id_34;
    result = imul(result, 31) + hashCode(this._slice_1) | 0;
    result = imul(result, 31) + hashCode(this._frames_2) | 0;
    return result;
  };
  TileSetTileInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TileSetTileInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TileSetTileInfo ? other : THROW_CCE();
    if (!(this._id_34 === tmp0_other_with_cast._id_34))
      return false;
    if (!equals_1(this._slice_1, tmp0_other_with_cast._slice_1))
      return false;
    if (!equals_1(this._frames_2, tmp0_other_with_cast._frames_2))
      return false;
    return true;
  };
  TileSetTileInfo.$metadata$ = {
    simpleName: 'TileSetTileInfo',
    kind: 'class',
    interfaces: []
  };
  function TileSetAnimationFrame(tileId, duration) {
    this._tileId_3 = tileId;
    this._duration_3 = duration;
  }
  TileSetAnimationFrame.prototype.toString = function () {
    return '' + 'TileSetAnimationFrame(tileId=' + this._tileId_3 + ', duration=' + new TimeSpan(this._duration_3) + ')';
  };
  TileSetAnimationFrame.prototype.hashCode = function () {
    var result = this._tileId_3;
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._duration_3) | 0;
    return result;
  };
  TileSetAnimationFrame.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TileSetAnimationFrame))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TileSetAnimationFrame ? other : THROW_CCE();
    if (!(this._tileId_3 === tmp0_other_with_cast._tileId_3))
      return false;
    if (!equals_1(new TimeSpan(this._duration_3), new TimeSpan(tmp0_other_with_cast._duration_3)))
      return false;
    return true;
  };
  TileSetAnimationFrame.$metadata$ = {
    simpleName: 'TileSetAnimationFrame',
    kind: 'class',
    interfaces: []
  };
  function base$factory() {
    return getPropertyCallableRef('base', 1, KProperty1, function (receiver) {
      return receiver._get_base__0_k$();
    }, null);
  }
  function infos$factory() {
    return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
      return receiver._get_infos__0_k$();
    }, null);
  }
  function textures$factory() {
    return getPropertyCallableRef('textures', 1, KProperty1, function (receiver) {
      return receiver._get_textures__0_k$();
    }, null);
  }
  function collisions$factory() {
    return getPropertyCallableRef('collisions', 1, KProperty1, function (receiver) {
      return receiver._get_collisions__0_k$();
    }, null);
  }
  function _no_name_provided_$factory_578(this$0) {
    var i = new _no_name_provided__646(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_579(this$0) {
    var i = new _no_name_provided__647(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_580(this$0) {
    var i = new _no_name_provided__648(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_581(this$0) {
    var i = new _no_name_provided__649(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_582(this$0) {
    var i = new _no_name_provided__650(this$0);
    return function () {
      return i.invoke_0_k$();
    };
  }
  function TileShapeInfo() {
  }
  TileShapeInfo.$metadata$ = {
    simpleName: 'TileShapeInfo',
    kind: 'interface',
    interfaces: [HitTestable]
  };
  function TileShapeInfoImpl(type, shape, transform) {
    this._type_25 = type;
    this._shape_2 = shape;
    this._transform_11 = transform;
    var tmp = this;
    tmp._transformInv = this._transform_11.inverted$default_3vhimr_k$(null, 1, null);
  }
  TileShapeInfoImpl.prototype.hitTestAny_j5t4vg_k$ = function (x, y, direction) {
    return this._shape_2.containsPoint_n7xxde_k$(x, y, this._transformInv) ? HitTestDirectionFlags__matches_impl(this._type_25, direction) : false;
  };
  TileShapeInfoImpl.prototype.toString = function () {
    return '' + 'TileShapeInfoImpl(type=' + new HitTestDirectionFlags(this._type_25) + ', shape=' + this._shape_2 + ', transform=' + this._transform_11 + ')';
  };
  TileShapeInfoImpl.prototype.hashCode = function () {
    var result = HitTestDirectionFlags__hashCode_impl(this._type_25);
    result = imul(result, 31) + hashCode(this._shape_2) | 0;
    result = imul(result, 31) + this._transform_11.hashCode() | 0;
    return result;
  };
  TileShapeInfoImpl.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TileShapeInfoImpl))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TileShapeInfoImpl ? other : THROW_CCE();
    if (!equals_1(new HitTestDirectionFlags(this._type_25), new HitTestDirectionFlags(tmp0_other_with_cast._type_25)))
      return false;
    if (!equals_1(this._shape_2, tmp0_other_with_cast._shape_2))
      return false;
    if (!this._transform_11.equals(tmp0_other_with_cast._transform_11))
      return false;
    return true;
  };
  TileShapeInfoImpl.$metadata$ = {
    simpleName: 'TileShapeInfoImpl',
    kind: 'class',
    interfaces: [TileShapeInfo]
  };
  var vector3DTemps;
  function Vector3DTemps() {
    this._pos_2 = 0;
    this._items_6 = arrayListOf([new Vector3D(), new Vector3D(), new Vector3D()]);
  }
  Vector3DTemps.$metadata$ = {
    simpleName: 'Vector3DTemps',
    kind: 'class',
    interfaces: []
  };
  function completeViews(views_0) {
  }
  function NativeStorage(views_0) {
    this._views_20 = views_0;
  }
  NativeStorage.prototype.toString = function () {
    return '' + 'NativeStorage(' + toMap_3(this) + ')';
  };
  NativeStorage.prototype.keys_0_k$ = function () {
    var keys = Object.keys();
    var tmp0_map_0 = until(0, keys.length);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var inductionVariable = tmp0_map_0._get_first__0_k$();
    var last_1 = tmp0_map_0._get_last__0_k$();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_mapTo_0_1.add_2bq_k$(keys.get(item_2_3));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    return tmp0_mapTo_0_1;
  };
  NativeStorage.prototype.getOrNull_6wfw3l_k$ = function (key) {
    return localStorage.getItem(key);
  };
  NativeStorage.$metadata$ = {
    simpleName: 'NativeStorage',
    kind: 'class',
    interfaces: [IStorage]
  };
  var DEFAULT_SCALE;
  var DEFAULT_GRAVITY_Y;
  var registeredBox2dSupport$delegate;
  var box2dWorld$delegate;
  function _set_box2dWorldComponent_(_this_, _set___) {
    var tmp0_setValue_0 = box2dWorldComponent$factory();
    if (_this_._get_extra__0_k$() == null)
      _this_._set_extra__n1onou_k$(ExtraTypeCreate());
    var tmp1_safe_receiver_1 = _this_._get_extra__0_k$();
    if (tmp1_safe_receiver_1 == null)
      null;
    else {
      var tmp0_elvis_lhs_3 = box2dWorldComponent$delegate._name_1;
      var tmp0_set_0_2 = tmp0_elvis_lhs_3 == null ? tmp0_setValue_0.callableName : tmp0_elvis_lhs_3;
      var tmp1_set_0_4 = _set___;
      tmp1_safe_receiver_1.set(tmp0_set_0_2, tmp1_set_0_4);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function _get_box2dWorldComponent_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = box2dWorldComponent$factory_0();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = box2dWorldComponent$delegate._name_1;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = box2dWorldComponent$delegate._defaultGen_0(_this_);
        if (_this_._get_extra__0_k$() == null)
          _this_._set_extra__n1onou_k$(ExtraTypeCreate());
        var tmp1_safe_receiver_1_7 = _this_._get_extra__0_k$();
        if (tmp1_safe_receiver_1_7 == null)
          null;
        else {
          var tmp0_elvis_lhs_2_9 = box2dWorldComponent$delegate._name_1;
          var tmp2_set_0_8 = tmp0_elvis_lhs_2_9 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_2_9;
          var tmp3_set_0_10 = r_6;
          tmp1_safe_receiver_1_7.set(tmp2_set_0_8, tmp3_set_0_10);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var box2dWorldComponent$delegate;
  function _set_body_(_this_, _set___) {
    var tmp0_setValue_0 = body$factory();
    if (_this_._get_extra__0_k$() == null)
      _this_._set_extra__n1onou_k$(ExtraTypeCreate());
    var tmp1_safe_receiver_1 = _this_._get_extra__0_k$();
    if (tmp1_safe_receiver_1 == null)
      null;
    else {
      var tmp0_elvis_lhs_3 = body$delegate._name_1;
      var tmp0_set_0_2 = tmp0_elvis_lhs_3 == null ? tmp0_setValue_0.callableName : tmp0_elvis_lhs_3;
      var tmp1_set_0_4 = _set___;
      tmp1_safe_receiver_1.set(tmp0_set_0_2, tmp1_set_0_4);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function _get_body_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = body$factory_0();
      var tmp1_safe_receiver_3 = _this_._get_extra__0_k$();
      var tmp;
      if (tmp1_safe_receiver_3 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_5 = body$delegate._name_1;
        var tmp0_get_0_4 = tmp0_elvis_lhs_5 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_5;
        tmp = tmp1_safe_receiver_3.get(tmp0_get_0_4);
      }
      var tmp1_fastCastTo_0_2 = tmp;
      var res_1 = tmp1_fastCastTo_0_2;
      if (res_1 == null) {
        var r_6 = body$delegate._defaultGen_0(_this_);
        if (_this_._get_extra__0_k$() == null)
          _this_._set_extra__n1onou_k$(ExtraTypeCreate());
        var tmp1_safe_receiver_1_7 = _this_._get_extra__0_k$();
        if (tmp1_safe_receiver_1_7 == null)
          null;
        else {
          var tmp0_elvis_lhs_2_9 = body$delegate._name_1;
          var tmp2_set_0_8 = tmp0_elvis_lhs_2_9 == null ? tmp0_getValue_0.callableName : tmp0_elvis_lhs_2_9;
          var tmp3_set_0_10 = r_6;
          tmp1_safe_receiver_1_7.set(tmp2_set_0_8, tmp3_set_0_10);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_6;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var body$delegate;
  var ViewKey;
  function Box2dWorldComponent_init_$Init$(worldView, world, velocityIterations, positionIterations, autoDestroyBodies, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      velocityIterations = 6;
    if (!(($mask0 & 8) === 0))
      positionIterations = 2;
    if (!(($mask0 & 16) === 0))
      autoDestroyBodies = true;
    Box2dWorldComponent.call($this, worldView, world, velocityIterations, positionIterations, autoDestroyBodies);
    return $this;
  }
  function Box2dWorldComponent_init_$Create$(worldView, world, velocityIterations, positionIterations, autoDestroyBodies, $mask0, $marker) {
    return Box2dWorldComponent_init_$Init$(worldView, world, velocityIterations, positionIterations, autoDestroyBodies, $mask0, $marker, Object.create(Box2dWorldComponent.prototype));
  }
  function Key_7() {
    Key_instance_4 = this;
    Key_1.call(this);
  }
  Key_7.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: []
  };
  var Key_instance_4;
  function Key_getInstance_4() {
    if (Key_instance_4 == null)
      new Key_7();
    return Key_instance_4;
  }
  function Box2dWorldComponent(worldView, world, velocityIterations, positionIterations, autoDestroyBodies) {
    var tmp = Companion_getInstance_92().fromMilliseconds_ttklb2_k$(16.0);
    FixedUpdateComponent_init_$Init$(worldView, tmp, 0, 4, null, this);
    this._worldView = worldView;
    this._world_1 = world;
    this._velocityIterations_0 = velocityIterations;
    this._positionIterations_0 = positionIterations;
    this._autoDestroyBodies = autoDestroyBodies;
    _set_component_(this._world_1, this);
    var tmp_0 = this;
    tmp_0._tempVec_2 = Vec2_init_$Create$(0.0, 0.0, 3, null);
    this._tempPos = Companion_getInstance_32().invoke_0_k$();
  }
  Box2dWorldComponent.prototype._get_world__0_k$ = function () {
    return this._world_1;
  };
  Box2dWorldComponent.prototype.update_sv8swh_k$ = function () {
    this._world_1.step_tte0sd_k$(_TimeSpan___get_seconds__impl_(this._get_step__nsqrdp_k$()), this._velocityIterations_0, this._positionIterations_0);
    var tmp0_forEachBody_0 = this._world_1;
    var node_1 = tmp0_forEachBody_0._get_world__0_k$()._bodyList;
    while (!(node_1 == null)) {
      var tmp1__anonymous__2 = node_1;
      var view_3 = _get_view_(tmp1__anonymous__2);
      if (!(view_3 == null)) {
        var worldScale_4 = this._world_1._customScale;
        var worldScaleInv_5 = 1.0 / worldScale_4;
        var viewPos_6 = this._tempPos.setTo_ngl742_k$(view_3._get_x__0_k$(), view_3._get_y__0_k$());
        if ((!(viewPos_6._x_1 === tmp1__anonymous__2._viewInfo._x_9) ? true : !(viewPos_6._y_1 === tmp1__anonymous__2._viewInfo._y_8)) ? true : !equals_1(new Angle(view_3._get_rotation__gxicn3_k$()), new Angle(tmp1__anonymous__2._viewInfo._rotation_0))) {
          var tmp0_set_0_7 = this._tempVec_2;
          var tmp1_set_0_8 = viewPos_6._x_1 * worldScaleInv_5;
          var tmp2_set_0_9 = viewPos_6._y_1 * worldScaleInv_5;
          tmp1__anonymous__2.setTransform_fe2466_k$(tmp0_set_0_7.set_rybm4g_k$(numberToDouble(tmp1_set_0_8), numberToDouble(tmp2_set_0_9)), view_3._get_rotation__gxicn3_k$());
          tmp1__anonymous__2._set_linearVelocity__ftoxb6_k$(this._tempVec_2.set_rybm4g_k$(0.0, 0.0));
          tmp1__anonymous__2._set_angularVelocity__cpozfn_k$(0.0);
          tmp1__anonymous__2._set_isActive__rpwsgn_k$(true);
          tmp1__anonymous__2._set_isAwake__rpwsgn_k$(true);
        }var newX_10 = tmp1__anonymous__2._get_position__0_k$()._x_7 * worldScale_4;
        var newY_11 = tmp1__anonymous__2._get_position__0_k$()._y_6 * worldScale_4;
        position(view_3, newX_10, newY_11);
        Unit_getInstance();
        view_3._set_rotation__p0vwlp_k$(tmp1__anonymous__2._get_angle__gxicn3_k$());
        var viewRoot_12 = view_3._get_root__0_k$();
        var viewRootStage_13 = viewRoot_12 instanceof Stage;
        tmp1__anonymous__2._viewInfo._x_9 = view_3._get_x__0_k$();
        tmp1__anonymous__2._viewInfo._y_8 = view_3._get_y__0_k$();
        tmp1__anonymous__2._viewInfo._rotation_0 = view_3._get_rotation__gxicn3_k$();
        if ((this._autoDestroyBodies ? tmp1__anonymous__2._viewInfo._onStage : false) ? !viewRootStage_13 : false) {
          this._world_1.destroyBody_h0xjxj_k$(tmp1__anonymous__2);
          var tmp0_safe_receiver_14 = _get_view_(tmp1__anonymous__2);
          if (tmp0_safe_receiver_14 == null) {
            Unit_getInstance();
          } else
            _set_body_(tmp0_safe_receiver_14, null);
          _set_view_(tmp1__anonymous__2, null);
        }tmp1__anonymous__2._viewInfo._onStage = viewRootStage_13;
      }node_1 = node_1._m_next;
    }
  };
  Box2dWorldComponent.$metadata$ = {
    simpleName: 'Box2dWorldComponent',
    kind: 'class',
    interfaces: [WorldRef]
  };
  function _set_component_(_this_, value) {
    _this_.set_fm38x_k$(Key_getInstance_4(), value);
  }
  function _set_view_(_this_, value) {
    _this_.set_fm38x_k$(ViewKey, value);
  }
  function _get_view_(_this_) {
    return _this_.get_3xhjti_k$(ViewKey);
  }
  function _get_nearestBox2dWorld_(_this_) {
    return _get_nearestBox2dWorldComponent_(_this_)._world_1;
  }
  function _get_nearestBox2dWorldComponent_(_this_) {
    var nearestReference = null;
    var view = _this_;
    while (!(view == null)) {
      var component = _get_box2dWorldComponent_(view);
      if (!(component == null)) {
        return component;
      }if (!(view == null) ? isInterface(view, Reference) : false) {
        if (nearestReference == null) {
          nearestReference = view;
        }} else {
      }
      if (view._get_parent__0_k$() == null) {
        var tmp0_elvis_lhs = nearestReference;
        return getOrCreateBox2dWorld(tmp0_elvis_lhs == null ? view : tmp0_elvis_lhs);
      }view = view._get_parent__0_k$();
    }
    _get_invalidOp_();
  }
  function getOrCreateBox2dWorld(_this_) {
    if (_get_box2dWorldComponent_(_this_) == null) {
      var tmp0_also_0 = World_init_$Create$(0.0, DEFAULT_GRAVITY_Y, null, null, 12, null);
      tmp0_also_0._customScale = DEFAULT_SCALE;
      var component = Box2dWorldComponent_init_$Create$(_this_, tmp0_also_0, 6, 2, false, 16, null);
      _set_box2dWorldComponent_(_this_, component);
      _this_.addComponent_91onm2_k$(component);
      Unit_getInstance();
    }return ensureNotNull(_get_box2dWorldComponent_(_this_));
  }
  function _no_name_provided__651() {
  }
  _no_name_provided__651.prototype.invoke_0_k$ = function () {
    return false;
  };
  _no_name_provided__651.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__652() {
  }
  _no_name_provided__652.prototype.invoke_mqfreu_k$ = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__652.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_mqfreu_k$(p1 instanceof KTreeSerializer ? p1 : THROW_CCE());
  };
  _no_name_provided__652.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__653() {
  }
  _no_name_provided__653.prototype.invoke_upazaj_k$ = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__653.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_upazaj_k$(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__653.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__654() {
  }
  _no_name_provided__654.prototype.invoke_upazaj_k$ = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__654.prototype.invoke_20e8_k$ = function (p1) {
    return this.invoke_upazaj_k$(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__654.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function box2dWorldComponent$factory() {
    return getPropertyCallableRef('box2dWorldComponent', 1, KMutableProperty1, function (receiver) {
      return _get_box2dWorldComponent_(receiver);
    }, function (receiver_0, value) {
      return _set_box2dWorldComponent_(receiver_0, value);
    });
  }
  function box2dWorldComponent$factory_0() {
    return getPropertyCallableRef('box2dWorldComponent', 1, KMutableProperty1, function (receiver) {
      return _get_box2dWorldComponent_(receiver);
    }, function (receiver_0, value) {
      return _set_box2dWorldComponent_(receiver_0, value);
    });
  }
  function body$factory() {
    return getPropertyCallableRef('body', 1, KMutableProperty1, function (receiver) {
      return _get_body_(receiver);
    }, function (receiver_0, value) {
      return _set_body_(receiver_0, value);
    });
  }
  function body$factory_0() {
    return getPropertyCallableRef('body', 1, KMutableProperty1, function (receiver) {
      return _get_body_(receiver);
    }, function (receiver_0, value) {
      return _set_body_(receiver_0, value);
    });
  }
  function _no_name_provided_$factory_583() {
    var i = new _no_name_provided__651();
    return function () {
      return i.invoke_0_k$();
    };
  }
  function _no_name_provided_$factory_584() {
    var i = new _no_name_provided__652();
    return function (p1) {
      return i.invoke_mqfreu_k$(p1);
    };
  }
  function _no_name_provided_$factory_585() {
    var i = new _no_name_provided__653();
    return function (p1) {
      return i.invoke_upazaj_k$(p1);
    };
  }
  function _no_name_provided_$factory_586() {
    var i = new _no_name_provided__654();
    return function (p1) {
      return i.invoke_upazaj_k$(p1);
    };
  }
  function $loadCOROUTINE$0(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__208 = _this_;
  }
  $loadCOROUTINE$0.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 17;
            this._ARGUMENT0_34 = Companion_getInstance_211();
            this._state_1 = 1;
            var tmp_0 = _get_resourcesVfs_().get_6wfw3l_k$('coin-100.png');
            suspendResult = readBitmap$default(tmp_0, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1_14 = suspendResult;
            var tmp_1 = this;
            tmp_1._ARGUMENT2_6 = this._ARGUMENT0_34.invoke$default_7wokc9_k$(this._ARGUMENT1_14, 100, 100, 0, 0, 6, 0, 0, 0, 472, null);
            this.__this__208._coin = this._ARGUMENT2_6;
            this._state_1 = 2;
            var tmp_2 = _get_resourcesVfs_().get_6wfw3l_k$('beachball.png');
            suspendResult = readBitmap$default(tmp_2, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT3_6 = suspendResult;
            this.__this__208._beachball = this._ARGUMENT3_6;
            this._state_1 = 3;
            var tmp_3 = _get_resourcesVfs_().get_6wfw3l_k$('left-flipper-200.png');
            suspendResult = readBitmap$default(tmp_3, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._ARGUMENT4_4 = suspendResult;
            this.__this__208._leftFlipper = this._ARGUMENT4_4;
            this._state_1 = 4;
            var tmp_4 = _get_resourcesVfs_().get_6wfw3l_k$('right-flipper-200.png');
            suspendResult = readBitmap$default(tmp_4, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._ARGUMENT5_0 = suspendResult;
            this.__this__208._rightFlipper = this._ARGUMENT5_0;
            this._state_1 = 5;
            var tmp_5 = _get_resourcesVfs_().get_6wfw3l_k$('bounce-1.mp3');
            suspendResult = readSound$default(tmp_5, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._ARGUMENT6_4 = suspendResult;
            this.__this__208._bounceSound1 = this._ARGUMENT6_4;
            this._state_1 = 6;
            var tmp_6 = _get_resourcesVfs_().get_6wfw3l_k$('bounce-2.mp3');
            suspendResult = readSound$default(tmp_6, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._ARGUMENT7_2 = suspendResult;
            this.__this__208._bounceSound2 = this._ARGUMENT7_2;
            this._state_1 = 7;
            var tmp_7 = _get_resourcesVfs_().get_6wfw3l_k$('bounce-3.mp3');
            suspendResult = readSound$default(tmp_7, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._ARGUMENT8_2 = suspendResult;
            this.__this__208._bounceSound3 = this._ARGUMENT8_2;
            this._state_1 = 8;
            var tmp_8 = _get_resourcesVfs_().get_6wfw3l_k$('bounce-1.mp3');
            suspendResult = readSound$default(tmp_8, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._ARGUMENT9_2 = suspendResult;
            this.__this__208._bumberSound1 = this._ARGUMENT9_2;
            this._state_1 = 9;
            var tmp_9 = _get_resourcesVfs_().get_6wfw3l_k$('bounce-2.mp3');
            suspendResult = readSound$default(tmp_9, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._ARGUMENT10_2 = suspendResult;
            this.__this__208._bumberSound2 = this._ARGUMENT10_2;
            this._state_1 = 10;
            var tmp_10 = _get_resourcesVfs_().get_6wfw3l_k$('bounce-3.mp3');
            suspendResult = readSound$default(tmp_10, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            this._ARGUMENT11_0 = suspendResult;
            this.__this__208._bumberSound3 = this._ARGUMENT11_0;
            this._state_1 = 11;
            var tmp_11 = _get_resourcesVfs_().get_6wfw3l_k$('mouse.mp3');
            suspendResult = readSound$default(tmp_11, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._ARGUMENT12_1 = suspendResult;
            this.__this__208._mouseSound = this._ARGUMENT12_1;
            this._state_1 = 12;
            var tmp_12 = _get_resourcesVfs_().get_6wfw3l_k$('coin.mp3');
            suspendResult = readSound$default(tmp_12, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._ARGUMENT13_1 = suspendResult;
            this.__this__208._coinSound = this._ARGUMENT13_1;
            this._state_1 = 13;
            var tmp_13 = _get_resourcesVfs_().get_6wfw3l_k$('bubbles.mp3');
            suspendResult = readSound$default(tmp_13, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 13:
            this._ARGUMENT14 = suspendResult;
            this.__this__208._fishSound = this._ARGUMENT14;
            this._state_1 = 14;
            var tmp_14 = _get_resourcesVfs_().get_6wfw3l_k$('car-horn.mp3');
            suspendResult = readSound$default(tmp_14, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 14:
            this._ARGUMENT15 = suspendResult;
            this.__this__208._hornSound = this._ARGUMENT15;
            this._state_1 = 15;
            var tmp_15 = _get_resourcesVfs_().get_6wfw3l_k$('spring.mp3');
            suspendResult = readSound$default(tmp_15, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 15:
            this._ARGUMENT16 = suspendResult;
            this.__this__208._springSound = this._ARGUMENT16;
            this._state_1 = 16;
            var tmp_16 = _get_resourcesVfs_().get_6wfw3l_k$('debris.mp3');
            suspendResult = readSound$default(tmp_16, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 16:
            var ARGUMENT = suspendResult;
            this.__this__208._debrisSound = ARGUMENT;
            return Unit_getInstance();
          case 17:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 17) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loadCOROUTINE$0.$metadata$ = {
    simpleName: '$loadCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function Resources_0() {
  }
  Resources_0.prototype._get_coin__0_k$ = function () {
    var tmp = this._coin;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('coin');
    }
  };
  Resources_0.prototype._get_beachball__0_k$ = function () {
    var tmp = this._beachball;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('beachball');
    }
  };
  Resources_0.prototype._get_leftFlipper__0_k$ = function () {
    var tmp = this._leftFlipper;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('leftFlipper');
    }
  };
  Resources_0.prototype._get_rightFlipper__0_k$ = function () {
    var tmp = this._rightFlipper;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('rightFlipper');
    }
  };
  Resources_0.prototype._get_bounceSound1__0_k$ = function () {
    var tmp = this._bounceSound1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('bounceSound1');
    }
  };
  Resources_0.prototype._get_bounceSound2__0_k$ = function () {
    var tmp = this._bounceSound2;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('bounceSound2');
    }
  };
  Resources_0.prototype._get_bounceSound3__0_k$ = function () {
    var tmp = this._bounceSound3;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('bounceSound3');
    }
  };
  Resources_0.prototype._get_mouseSound__0_k$ = function () {
    var tmp = this._mouseSound;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('mouseSound');
    }
  };
  Resources_0.prototype._get_coinSound__0_k$ = function () {
    var tmp = this._coinSound;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('coinSound');
    }
  };
  Resources_0.prototype._get_fishSound__0_k$ = function () {
    var tmp = this._fishSound;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fishSound');
    }
  };
  Resources_0.prototype._get_hornSound__0_k$ = function () {
    var tmp = this._hornSound;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('hornSound');
    }
  };
  Resources_0.prototype._get_springSound__0_k$ = function () {
    var tmp = this._springSound;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('springSound');
    }
  };
  Resources_0.prototype._get_debrisSound__0_k$ = function () {
    var tmp = this._debrisSound;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debrisSound');
    }
  };
  Resources_0.prototype.load_sv8swh_k$ = function ($cont) {
    var tmp = new $loadCOROUTINE$0(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  Resources_0.$metadata$ = {
    simpleName: 'Resources',
    kind: 'class',
    interfaces: []
  };
  function Level_1(name, intro, ktree, background, start) {
    this._name_48 = name;
    this._intro = intro;
    this._ktree = ktree;
    this._background_1 = background;
    this._start_5 = start;
  }
  Level_1.$metadata$ = {
    simpleName: 'Level',
    kind: 'class',
    interfaces: []
  };
  function Game() {
    this._stageWidth = 1280;
    this._stageHeight = 768;
    this._currentLevelIndex = 0;
    this._maxCoins = 0;
    this._coins = 0;
    this._touchedExit = false;
    this._levels = listOf([new Level_1('Sewers', 'sewer-intro.ktree', 'sewers.ktree', 'sewers-background.png', new Point(220.0, 0.0)), new Level_1('City', 'city-intro.ktree', 'city.ktree', 'city-background.png', new Point(0.0, 0.0)), new Level_1('Beach', 'beach-intro.ktree', 'beach.ktree', 'beach-background.png', Point_init_$Create$_0(1470, -2400))]);
    this._resources_0 = new Resources_0();
  }
  Game.prototype._get_views__0_k$ = function () {
    var tmp = this._views_21;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  Game.prototype._get_allCoinsCollected__0_k$ = function () {
    return this._coins === this._maxCoins;
  };
  Game.prototype._get_currentLevel__0_k$ = function () {
    return this._levels.get_ha5a7z_k$(this._currentLevelIndex);
  };
  Game.prototype.reset_sv8swh_k$ = function () {
    this._maxCoins = 0;
    this._coins = 0;
    this._touchedExit = false;
  };
  Game.$metadata$ = {
    simpleName: 'Game',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__655(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__655.prototype.invoke_merzw6_k$ = function ($this$mapPrototype, $cont) {
    var tmp = this.create_qg21b2_k$($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__655.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_merzw6_k$(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__655.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = getKClass_0(Game);
            suspendResult = this._$this$mapPrototype_0.get$default_b3eqw1_k$(tmp_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new LoadScene(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__655.prototype.create_qg21b2_k$ = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__655(completion);
    i._$this$mapPrototype_0 = $this$mapPrototype;
    return i;
  };
  _no_name_provided__655.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__656(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__656.prototype.invoke_merzw6_k$ = function ($this$mapPrototype, $cont) {
    var tmp = this.create_qg21b2_k$($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__656.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_merzw6_k$(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__656.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = getKClass_0(Game);
            suspendResult = this._$this$mapPrototype_1.get$default_b3eqw1_k$(tmp_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new PlayScene(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__656.prototype.create_qg21b2_k$ = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__656(completion);
    i._$this$mapPrototype_1 = $this$mapPrototype;
    return i;
  };
  _no_name_provided__656.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__657(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__657.prototype.invoke_merzw6_k$ = function ($this$mapPrototype, $cont) {
    var tmp = this.create_qg21b2_k$($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__657.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_merzw6_k$(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__657.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = getKClass_0(Game);
            suspendResult = this._$this$mapPrototype_2.get$default_b3eqw1_k$(tmp_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new IntroScene(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__657.prototype.create_qg21b2_k$ = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__657(completion);
    i._$this$mapPrototype_2 = $this$mapPrototype;
    return i;
  };
  _no_name_provided__657.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__658(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__658.prototype.invoke_merzw6_k$ = function ($this$mapPrototype, $cont) {
    var tmp = this.create_qg21b2_k$($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__658.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_merzw6_k$(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__658.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = getKClass_0(Game);
            suspendResult = this._$this$mapPrototype_3.get$default_b3eqw1_k$(tmp_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new TitleScene(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__658.prototype.create_qg21b2_k$ = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__658(completion);
    i._$this$mapPrototype_3 = $this$mapPrototype;
    return i;
  };
  _no_name_provided__658.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__659(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__659.prototype.invoke_merzw6_k$ = function ($this$mapPrototype, $cont) {
    var tmp = this.create_qg21b2_k$($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__659.prototype.invoke_20e8_k$ = function (p1, $cont) {
    return this.invoke_merzw6_k$(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__659.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = getKClass_0(Game);
            suspendResult = this._$this$mapPrototype_4.get$default_b3eqw1_k$(tmp_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new EndScene(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__659.prototype.create_qg21b2_k$ = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__659(completion);
    i._$this$mapPrototype_4 = $this$mapPrototype;
    return i;
  };
  _no_name_provided__659.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $configureCOROUTINE$1(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__209 = _this_;
    this.__this__210 = _this__0;
  }
  $configureCOROUTINE$1.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._ARGUMENT0_35 = this.__this__209._game;
            this._state_1 = 1;
            suspendResult = views(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this._ARGUMENT0_35._views_21 = ARGUMENT;
            var tmp0_mapInstance_0 = this.__this__209._game;
            this.__this__210.mapInstance_770c45_k$(getKClass_0(Game), tmp0_mapInstance_0);
            Unit_getInstance();
            var tmp1_mapPrototype_0 = _no_name_provided_$factory_587(null);
            this.__this__210.mapPrototype_tk1g05_k$(getKClass_0(LoadScene), tmp1_mapPrototype_0);
            Unit_getInstance();
            var tmp2_mapPrototype_0 = _no_name_provided_$factory_588(null);
            this.__this__210.mapPrototype_tk1g05_k$(getKClass_0(PlayScene), tmp2_mapPrototype_0);
            Unit_getInstance();
            var tmp3_mapPrototype_0 = _no_name_provided_$factory_589(null);
            this.__this__210.mapPrototype_tk1g05_k$(getKClass_0(IntroScene), tmp3_mapPrototype_0);
            Unit_getInstance();
            var tmp4_mapPrototype_0 = _no_name_provided_$factory_590(null);
            this.__this__210.mapPrototype_tk1g05_k$(getKClass_0(TitleScene), tmp4_mapPrototype_0);
            Unit_getInstance();
            var tmp5_mapPrototype_0 = _no_name_provided_$factory_591(null);
            this.__this__210.mapPrototype_tk1g05_k$(getKClass_0(EndScene), tmp5_mapPrototype_0);
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $configureCOROUTINE$1.$metadata$ = {
    simpleName: '$configureCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function GameModule() {
    Module.call(this);
    this._game = new Game();
    this._mainScene_0 = getKClass_0(LoadScene);
    this._title_2 = 'Beachball';
    this._size_19 = Companion_getInstance_39().invoke_aaxa64_k$(this._game._stageWidth, this._game._stageHeight);
  }
  GameModule.prototype._get_mainScene__0_k$ = function () {
    return this._mainScene_0;
  };
  GameModule.prototype._get_title__0_k$ = function () {
    return this._title_2;
  };
  GameModule.prototype._get_size__qgazdw_k$ = function () {
    return this._size_19;
  };
  GameModule.prototype.configure_k6yfpx_k$ = function (_this__0, $cont) {
    var tmp = new $configureCOROUTINE$1(this, _this__0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  GameModule.$metadata$ = {
    simpleName: 'GameModule',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_587(resultContinuation) {
    var i = new _no_name_provided__655(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_merzw6_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_588(resultContinuation) {
    var i = new _no_name_provided__656(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_merzw6_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_589(resultContinuation) {
    var i = new _no_name_provided__657(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_merzw6_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_590(resultContinuation) {
    var i = new _no_name_provided__658(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_merzw6_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_591(resultContinuation) {
    var i = new _no_name_provided__659(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_merzw6_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function BaseEntity(playField, image) {
    var tmp = image._get_bitmap__0_k$();
    Sprite_init_$Init$(tmp, 0.0, 0.0, null, false, 30, null, this);
    this._playField = playField;
    this._set_scaleX__okcceq_k$(image._get_scaleX__0_k$());
    this._set_scaleY__okcceq_k$(image._get_scaleY__0_k$());
    xy_0(this, image);
    Unit_getInstance();
    this._set_name__qlpr75_k$(image._get_name__0_k$());
  }
  BaseEntity.prototype.createBoxBody_3h59xg_k$ = function (bodyType) {
    var tmp0_createBody_0 = this._playField;
    var tmp0_elvis_lhs_1 = null;
    var tmp = tmp0_elvis_lhs_1 == null ? _get_nearestBox2dWorld_(tmp0_createBody_0) : tmp0_elvis_lhs_1;
    var tmp0_apply_0_2 = BodyDef_init_$Create$(null, null, null, 0.0, null, 0.0, 0.0, 0.0, false, false, false, false, false, 0.0, 16383, null);
    tmp0_apply_0_2._type_7 = bodyType;
    var tmp1_fixture_0 = tmp.createBody_kicyo5_k$(tmp0_apply_0_2);
    var tmp0_apply_0_2_1 = FixtureDef_init_$Create$(null, null, 0.0, 0.0, 0.0, false, null, 127, null);
    var tmp_0 = tmp0_apply_0_2_1;
    var tmp0_BoxShape_0_3 = this._get_scaledWidth__0_k$() / 20;
    var tmp1_BoxShape_0_4 = this._get_scaledHeight__0_k$() / 20;
    var tmp0_apply_0_1_5 = new PolygonShape();
    tmp0_apply_0_1_5._count_4 = 4;
    var tmp0_set_0_2_2_6 = tmp0_apply_0_1_5._vertices_2[0];
    tmp0_set_0_2_2_6.set_rybm4g_k$(numberToDouble(0), numberToDouble(0));
    Unit_getInstance();
    var tmp1_set_0_3_3_7 = tmp0_apply_0_1_5._vertices_2[1];
    tmp1_set_0_3_3_7.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(0));
    Unit_getInstance();
    var tmp2_set_0_4_4_8 = tmp0_apply_0_1_5._vertices_2[2];
    tmp2_set_0_4_4_8.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(tmp1_BoxShape_0_4));
    Unit_getInstance();
    var tmp3_set_0_5_5_9 = tmp0_apply_0_1_5._vertices_2[3];
    tmp3_set_0_5_5_9.set_rybm4g_k$(numberToDouble(0), numberToDouble(tmp1_BoxShape_0_4));
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[0].set_rybm4g_k$(0.0, -1.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[1].set_rybm4g_k$(1.0, 0.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[2].set_rybm4g_k$(0.0, 1.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[3].set_rybm4g_k$(-1.0, 0.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._centroid.setZero_sv8swh_k$();
    tmp_0._shape = tmp0_apply_0_1_5;
    tmp0_apply_0_2_1._density = 1.0;
    tmp0_apply_0_2_1._friction = 0.5;
    tmp0_apply_0_2_1._restitution = 0.5;
    tmp1_fixture_0.createFixture_n3zf3w_k$(tmp0_apply_0_2_1);
    Unit_getInstance();
    var body = tmp1_fixture_0;
    _set_view_(body, this);
    return body;
  };
  BaseEntity.prototype.createCircleBody_3h59xg_k$ = function (bodyType) {
    anchor_1(this, 0.5, 0.5);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._set_x__okcceq_k$(tmp0_this._get_x__0_k$() + this._get_width__0_k$() / 2.0);
    var tmp1_this = this;
    tmp1_this._set_y__okcceq_k$(tmp1_this._get_y__0_k$() + this._get_height__0_k$() / 2.0);
    var tmp0_createBody_0 = this._playField;
    var tmp0_elvis_lhs_1 = null;
    var tmp = tmp0_elvis_lhs_1 == null ? _get_nearestBox2dWorld_(tmp0_createBody_0) : tmp0_elvis_lhs_1;
    var tmp0_apply_0_2 = BodyDef_init_$Create$(null, null, null, 0.0, null, 0.0, 0.0, 0.0, false, false, false, false, false, 0.0, 16383, null);
    tmp0_apply_0_2._type_7 = bodyType;
    var tmp1_fixture_0 = tmp.createBody_kicyo5_k$(tmp0_apply_0_2);
    var tmp0_apply_0_2_1 = FixtureDef_init_$Create$(null, null, 0.0, 0.0, 0.0, false, null, 127, null);
    tmp0_apply_0_2_1._shape = CircleShape_init_$Create$(this._get_scaledHeight__0_k$() / 2.2 / 20.0);
    tmp0_apply_0_2_1._density = 1.0;
    tmp0_apply_0_2_1._friction = 0.5;
    tmp0_apply_0_2_1._restitution = 0.5;
    tmp1_fixture_0.createFixture_n3zf3w_k$(tmp0_apply_0_2_1);
    Unit_getInstance();
    var body = tmp1_fixture_0;
    _set_view_(body, this);
    return body;
  };
  BaseEntity.prototype.createBoxHitShape_sv8swh_k$ = function () {
    var tmp0_invoke_0 = Companion_getInstance_46();
    var tmp1_invoke_0 = this._get_scaledWidth__0_k$() + 2;
    var tmp2_invoke_0 = this._get_scaledHeight__0_k$() + 2;
    this._set_hitShape2d__irscnu_k$(new Rectangle_0(new Rectangle(-1.0, -1.0, tmp1_invoke_0, tmp2_invoke_0)));
  };
  BaseEntity.prototype.createCircleHitShape_sv8swh_k$ = function () {
    var tmp = this._get_scaledWidth__0_k$() / 2.0 - this._get_anchorX__0_k$();
    var tmp_0 = this._get_scaledHeight__0_k$() / 2.0 - this._get_anchorY__0_k$();
    var tmp_1 = this._get_scaledWidth__0_k$() / 2.0;
    this._set_hitShape2d__irscnu_k$(Circle_init_$Create$(tmp, tmp_0, tmp_1, 0, 8, null));
  };
  BaseEntity.prototype._get_touchingBeachBall__0_k$ = function () {
    return collidesWith(this, this._playField._beachBall, CollisionKind_SHAPE_getInstance());
  };
  BaseEntity.$metadata$ = {
    simpleName: 'BaseEntity',
    kind: 'class',
    interfaces: []
  };
  function BeachBall(playField, game) {
    var tmp = game._resources_0._get_beachball__0_k$();
    Sprite_init_$Init$_1(tmp, 0.0, 0.0, null, false, 30, null, this);
    this._contact_0 = false;
    this._set_name__qlpr75_k$('beachball');
    anchor_1(this, 0.5, 0.5);
    Unit_getInstance();
    var tmp0_buildPath_0_2 = VectorPath_init_$Create$(null, null, null, 7, null);
    circle(tmp0_buildPath_0_2, this._get_width__0_k$() / 2.0, this._get_height__0_k$() / 2.0, this._get_width__0_k$() / 2.0);
    var tmp1_also_0_1 = tmp0_buildPath_0_2;
    this._set_hitShape__mda8oa_k$(tmp1_also_0_1);
    Unit_getInstance();
    Unit_getInstance();
    var tmp0_elvis_lhs_1 = null;
    var tmp_0 = tmp0_elvis_lhs_1 == null ? _get_nearestBox2dWorld_(playField) : tmp0_elvis_lhs_1;
    var tmp0_apply_0_2 = BodyDef_init_$Create$(null, null, null, 0.0, null, 0.0, 0.0, 0.0, false, false, false, false, false, 0.0, 16383, null);
    tmp0_apply_0_2._type_7 = BodyType_DYNAMIC_getInstance();
    var tmp0_fixture_0 = tmp_0.createBody_kicyo5_k$(tmp0_apply_0_2);
    var tmp0_apply_0_2_1 = FixtureDef_init_$Create$(null, null, 0.0, 0.0, 0.0, false, null, 127, null);
    tmp0_apply_0_2_1._shape = CircleShape_init_$Create$(this._get_width__0_k$() / 2 / 20);
    tmp0_apply_0_2_1._density = 1.0;
    tmp0_apply_0_2_1._restitution = 0.5;
    tmp0_apply_0_2_1._friction = 0.1;
    tmp0_fixture_0.createFixture_n3zf3w_k$(tmp0_apply_0_2_1);
    Unit_getInstance();
    var body = tmp0_fixture_0;
    _set_view_(body, this);
    _set_body_(this, body);
  }
  BeachBall.$metadata$ = {
    simpleName: 'BeachBall',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__660() {
  }
  _no_name_provided__660.prototype.invoke_9twhu_k$ = function ($this$addUpdater, it) {
    var tmp0_this = $this$addUpdater;
    tmp0_this._set_alpha__okcceq_k$(tmp0_this._get_alpha__0_k$() - 0.01);
    if ($this$addUpdater._get_alpha__0_k$() <= 0.0) {
      $this$addUpdater.removeFromParent_sv8swh_k$();
    }};
  _no_name_provided__660.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Debris ? p1 : THROW_CCE();
    this.invoke_9twhu_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__660.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Debris(playField, image) {
    BaseEntity.call(this, playField, image);
    this.createBoxBody_3h59xg_k$(BodyType_DYNAMIC_getInstance());
    Unit_getInstance();
    this._set_alpha__okcceq_k$(8.0);
    addUpdater(this, _no_name_provided_$factory_592());
    Unit_getInstance();
  }
  Debris.$metadata$ = {
    simpleName: 'Debris',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__661($playField, $image) {
    this._$playField = $playField;
    this._$image = $image;
  }
  _no_name_provided__661.prototype.invoke_541z4_k$ = function ($this$addUpdater, it) {
    if ($this$addUpdater._get_touchingBeachBall__0_k$()) {
      var tmp = this._$playField._game_5._resources_0._get_debrisSound__0_k$();
      var tmp_0 = this._$playField._game_5._get_views__0_k$()._coroutineContext_6;
      tmp.play$default_5gxx2y_k$(tmp_0, null, 2, null);
      Unit_getInstance();
      var inductionVariable = 0;
      if (inductionVariable <= 9)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var debris = new Debris(this._$playField, this._$image);
          var tmp1_this = debris;
          tmp1_this._set_x__okcceq_k$(tmp1_this._get_x__0_k$() + Default_getInstance().nextDouble_e2tf9d_k$($this$addUpdater._get_scaledWidth__0_k$()));
          var tmp2_this = debris;
          tmp2_this._set_y__okcceq_k$(tmp2_this._get_y__0_k$() + Default_getInstance().nextDouble_e2tf9d_k$($this$addUpdater._get_scaledHeight__0_k$()));
          var tmp3_safe_receiver = $this$addUpdater._get_parent__0_k$();
          if (tmp3_safe_receiver == null)
            null;
          else {
            tmp3_safe_receiver.addChild_4l6ao4_k$(debris);
            Unit_getInstance();
          }
          Unit_getInstance();
        }
         while (inductionVariable <= 9);
      $this$addUpdater.removeFromParent_sv8swh_k$();
    }};
  _no_name_provided__661.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Breakable ? p1 : THROW_CCE();
    this.invoke_541z4_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__661.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Breakable(playField, image) {
    BaseEntity.call(this, playField, image);
    this.createBoxHitShape_sv8swh_k$();
    image._set_scale__okcceq_k$(0.25);
    addUpdater(this, _no_name_provided_$factory_593(playField, image));
    Unit_getInstance();
  }
  Breakable.$metadata$ = {
    simpleName: 'Breakable',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_592() {
    var i = new _no_name_provided__660();
    return function (p1, p2) {
      i.invoke_9twhu_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_593($playField, $image) {
    var i = new _no_name_provided__661($playField, $image);
    return function (p1, p2) {
      i.invoke_541z4_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function Brick(playField, image) {
    BaseEntity.call(this, playField, image);
    this.createBoxBody_3h59xg_k$(BodyType_DYNAMIC_getInstance());
    Unit_getInstance();
    this.createBoxHitShape_sv8swh_k$();
  }
  Brick.$metadata$ = {
    simpleName: 'Brick',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__662($playField) {
    this._$playField_0 = $playField;
  }
  _no_name_provided__662.prototype.invoke_kt60nu_k$ = function ($this$addUpdater, it) {
    $this$addUpdater._set_colorAdd__fii3aj_k$(toColorAdd(Colors_getInstance()._TRANSPARENT_BLACK));
    if ($this$addUpdater._get_touchingBeachBall__0_k$()) {
      var angle = $this$addUpdater._get_pos__0_k$().angleTo_sw9sci_k$(this._$playField_0._beachBall._get_pos__0_k$());
      var velX = _get_cosine_(angle) * 75.0;
      var velY = _get_sine_(angle) * 75.0;
      var tmp0_safe_receiver = _get_body_(this._$playField_0._beachBall);
      if (tmp0_safe_receiver == null) {
        Unit_getInstance();
      } else
        tmp0_safe_receiver._set_linearVelocityX__cpozfn_k$(velX);
      var tmp1_safe_receiver = _get_body_(this._$playField_0._beachBall);
      if (tmp1_safe_receiver == null) {
        Unit_getInstance();
      } else
        tmp1_safe_receiver._set_linearVelocityY__cpozfn_k$(velY);
      var tmp0_invoke_0 = Companion_getInstance_132();
      $this$addUpdater._set_colorAdd__fii3aj_k$(_ColorAdd___init__impl_(ColorAdd_pack(255, 255, 0, 0)));
      var tmp2_subject = Default_getInstance().nextInt_27zxwg_k$(1, 3);
      {
        var sound;
        switch (tmp2_subject) {
          case 1:
            sound = this._$playField_0._game_5._resources_0._get_bounceSound1__0_k$();
            break;
          case 2:
            sound = this._$playField_0._game_5._resources_0._get_bounceSound2__0_k$();
            break;
          case 3:
            sound = this._$playField_0._game_5._resources_0._get_bounceSound3__0_k$();
            break;
          default:sound = null;
            break;
        }
      }
      var tmp3_safe_receiver = sound;
      if (tmp3_safe_receiver == null)
        null;
      else {
        var tmp = this._$playField_0._game_5._get_views__0_k$()._coroutineContext_6;
        tmp3_safe_receiver.play$default_5gxx2y_k$(tmp, null, 2, null);
      }
      Unit_getInstance();
    }};
  _no_name_provided__662.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Bumper ? p1 : THROW_CCE();
    this.invoke_kt60nu_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__662.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Bumper(playField, image) {
    BaseEntity.call(this, playField, image);
    anchor_1(this, 0.5, 0.5);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._set_x__okcceq_k$(tmp0_this._get_x__0_k$() + this._get_width__0_k$() / 2);
    var tmp1_this = this;
    tmp1_this._set_y__okcceq_k$(tmp1_this._get_y__0_k$() + this._get_height__0_k$() / 2);
    this.createCircleHitShape_sv8swh_k$();
    addUpdater(this, _no_name_provided_$factory_594(playField));
    Unit_getInstance();
  }
  Bumper.$metadata$ = {
    simpleName: 'Bumper',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_594($playField) {
    var i = new _no_name_provided__662($playField);
    return function (p1, p2) {
      i.invoke_kt60nu_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__663($game) {
    this._$game = $game;
  }
  _no_name_provided__663.prototype.invoke_4vbg6k_k$ = function ($this$addUpdater, it) {
    if ($this$addUpdater._get_touchingBeachBall__0_k$()) {
      var tmp0_this = this._$game;
      var tmp1 = tmp0_this._coins;
      tmp0_this._coins = tmp1 + 1 | 0;
      Unit_getInstance();
      $this$addUpdater.removeFromParent_sv8swh_k$();
      var tmp = this._$game._resources_0._get_coinSound__0_k$();
      var tmp_0 = this._$game._get_views__0_k$()._coroutineContext_6;
      tmp.play$default_5gxx2y_k$(tmp_0, null, 2, null);
      Unit_getInstance();
    }};
  _no_name_provided__663.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Coin ? p1 : THROW_CCE();
    this.invoke_4vbg6k_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__663.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Coin(game, playField, image) {
    BaseEntity.call(this, playField, image);
    this._playField_0 = playField;
    if (image._get_sourceFile__0_k$() === 'coin-placeholder.png') {
      var tmp = game._resources_0._get_coin__0_k$();
      this.playAnimationLooped$default_2b9tm9_k$(tmp, null, 0, false, 14, null);
    }this.createCircleHitShape_sv8swh_k$();
    addUpdater(this, _no_name_provided_$factory_595(game));
    Unit_getInstance();
  }
  Coin.$metadata$ = {
    simpleName: 'Coin',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_595($game) {
    var i = new _no_name_provided__663($game);
    return function (p1, p2) {
      i.invoke_4vbg6k_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__664($playField) {
    this._$playField_1 = $playField;
  }
  _no_name_provided__664.prototype.invoke_qabjbl_k$ = function ($this$addUpdater, it) {
    if (this._$playField_1._game_5._get_allCoinsCollected__0_k$()) {
      $this$addUpdater._set_alpha__okcceq_k$(0.0);
      if ($this$addUpdater._get_touchingBeachBall__0_k$()) {
        this._$playField_1._beachBall.removeFromParent_sv8swh_k$();
        this._$playField_1._game_5._touchedExit = true;
      }}};
  _no_name_provided__664.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof BlockedExit ? p1 : THROW_CCE();
    this.invoke_qabjbl_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__664.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BlockedExit(playField, image) {
    BaseEntity.call(this, playField, image);
    var body = this.createCircleBody_3h59xg_k$(BodyType_STATIC_getInstance());
    this.createCircleHitShape_sv8swh_k$();
    addUpdater(this, _no_name_provided_$factory_596(playField));
    Unit_getInstance();
  }
  BlockedExit.$metadata$ = {
    simpleName: 'BlockedExit',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_596($playField) {
    var i = new _no_name_provided__664($playField);
    return function (p1, p2) {
      i.invoke_qabjbl_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__665($body) {
    this._$body = $body;
  }
  _no_name_provided__665.prototype.invoke_gyklze_k$ = function ($this$addFixedUpdater) {
    var tmp0_safe_receiver = $this$addFixedUpdater._get_stage__0_k$();
    var input = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_input__0_k$();
    var tmp1_safe_receiver = input;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._keys_0;
    if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.pressing_dbfq2v_k$(Key_A_getInstance())) === true) {
      if (Angle__compareTo_impl($this$addFixedUpdater._get_rotation__gxicn3_k$(), unaryMinus(_get_degrees__1(30.0))) > 0) {
        this._$body._set_angularVelocity__cpozfn_k$(-10.0);
      } else {
        $this$addFixedUpdater._set_rotation__p0vwlp_k$(unaryMinus(_get_degrees__1(30.0)));
      }
    } else {
      {
        if (Angle__compareTo_impl($this$addFixedUpdater._get_rotation__gxicn3_k$(), _get_degrees__1(30.0)) < 0) {
          this._$body._set_angularVelocity__cpozfn_k$(10.0);
        } else {
          $this$addFixedUpdater._set_rotation__p0vwlp_k$(_get_degrees__1(30.0));
        }
      }
    }
  };
  _no_name_provided__665.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_gyklze_k$(p1 instanceof LeftFlipper ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__665.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function LeftFlipper(container, game) {
    var tmp = game._resources_0._get_leftFlipper__0_k$();
    Sprite_init_$Init$_1(tmp, 0.0, 0.0, null, false, 30, null, this);
    this._set_anchorY__okcceq_k$(0.5);
    this._set_rotation__p0vwlp_k$(_get_degrees__1(30.0));
    var tmp0_elvis_lhs_1 = null;
    var tmp_0 = tmp0_elvis_lhs_1 == null ? _get_nearestBox2dWorld_(container) : tmp0_elvis_lhs_1;
    var tmp0_apply_0_2 = BodyDef_init_$Create$(null, null, null, 0.0, null, 0.0, 0.0, 0.0, false, false, false, false, false, 0.0, 16383, null);
    tmp0_apply_0_2._type_7 = BodyType_KINEMATIC_getInstance();
    var tmp0_fixture_0 = tmp_0.createBody_kicyo5_k$(tmp0_apply_0_2);
    var tmp0_apply_0_2_1 = FixtureDef_init_$Create$(null, null, 0.0, 0.0, 0.0, false, null, 127, null);
    var tmp_1 = tmp0_apply_0_2_1;
    var tmp0_BoxShape_0_3 = this._get_bitmap__0_k$()._get_width__0_k$() / 20 | 0;
    var tmp1_BoxShape_0_4 = this._get_bitmap__0_k$()._get_height__0_k$() / 20 | 0;
    var tmp0_apply_0_1_5 = new PolygonShape();
    tmp0_apply_0_1_5._count_4 = 4;
    var tmp0_set_0_2_2_6 = tmp0_apply_0_1_5._vertices_2[0];
    tmp0_set_0_2_2_6.set_rybm4g_k$(numberToDouble(0), numberToDouble(0));
    Unit_getInstance();
    var tmp1_set_0_3_3_7 = tmp0_apply_0_1_5._vertices_2[1];
    tmp1_set_0_3_3_7.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(0));
    Unit_getInstance();
    var tmp2_set_0_4_4_8 = tmp0_apply_0_1_5._vertices_2[2];
    tmp2_set_0_4_4_8.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(tmp1_BoxShape_0_4));
    Unit_getInstance();
    var tmp3_set_0_5_5_9 = tmp0_apply_0_1_5._vertices_2[3];
    tmp3_set_0_5_5_9.set_rybm4g_k$(numberToDouble(0), numberToDouble(tmp1_BoxShape_0_4));
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[0].set_rybm4g_k$(0.0, -1.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[1].set_rybm4g_k$(1.0, 0.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[2].set_rybm4g_k$(0.0, 1.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[3].set_rybm4g_k$(-1.0, 0.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._centroid.setZero_sv8swh_k$();
    tmp_1._shape = tmp0_apply_0_1_5;
    tmp0_apply_0_2_1._density = 1.0;
    tmp0_apply_0_2_1._restitution = 1.0;
    tmp0_fixture_0.createFixture_n3zf3w_k$(tmp0_apply_0_2_1);
    Unit_getInstance();
    var body = tmp0_fixture_0;
    _set_view_(body, this);
    var tmp_2 = _get_timesPerSecond_(60);
    addFixedUpdater$default(this, tmp_2, false, 0, _no_name_provided_$factory_597(body), 6, null);
    Unit_getInstance();
  }
  LeftFlipper.$metadata$ = {
    simpleName: 'LeftFlipper',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__666($body) {
    this._$body_0 = $body;
  }
  _no_name_provided__666.prototype.invoke_fr4981_k$ = function ($this$addFixedUpdater) {
    var tmp0_safe_receiver = $this$addFixedUpdater._get_stage__0_k$();
    var input = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_input__0_k$();
    var tmp1_safe_receiver = input;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._keys_0;
    if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.pressing_dbfq2v_k$(Key_D_getInstance())) === true) {
      if (Angle__compareTo_impl($this$addFixedUpdater._get_rotation__gxicn3_k$(), _get_degrees__1(210.0)) < 0) {
        this._$body_0._set_angularVelocity__cpozfn_k$(10.0);
      } else {
        $this$addFixedUpdater._set_rotation__p0vwlp_k$(_get_degrees__1(211.0));
      }
    } else {
      {
        if (Angle__compareTo_impl($this$addFixedUpdater._get_rotation__gxicn3_k$(), _get_degrees__1(150.0)) > 0) {
          this._$body_0._set_angularVelocity__cpozfn_k$(-10.0);
        } else {
          $this$addFixedUpdater._set_rotation__p0vwlp_k$(_get_degrees__1(150.0));
        }
      }
    }
  };
  _no_name_provided__666.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_fr4981_k$(p1 instanceof RightFlipper ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__666.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RightFlipper(container, game) {
    var tmp = game._resources_0._get_rightFlipper__0_k$();
    Sprite_init_$Init$_1(tmp, 0.0, 0.0, null, false, 30, null, this);
    this._set_anchorY__okcceq_k$(0.5);
    this._set_rotation__p0vwlp_k$(_get_degrees__1(140.0));
    var tmp0_elvis_lhs_1 = null;
    var tmp_0 = tmp0_elvis_lhs_1 == null ? _get_nearestBox2dWorld_(container) : tmp0_elvis_lhs_1;
    var tmp0_apply_0_2 = BodyDef_init_$Create$(null, null, null, 0.0, null, 0.0, 0.0, 0.0, false, false, false, false, false, 0.0, 16383, null);
    tmp0_apply_0_2._type_7 = BodyType_KINEMATIC_getInstance();
    var tmp0_fixture_0 = tmp_0.createBody_kicyo5_k$(tmp0_apply_0_2);
    var tmp0_apply_0_2_1 = FixtureDef_init_$Create$(null, null, 0.0, 0.0, 0.0, false, null, 127, null);
    var tmp_1 = tmp0_apply_0_2_1;
    var tmp0_BoxShape_0_3 = this._get_bitmap__0_k$()._get_width__0_k$() / 20 | 0;
    var tmp1_BoxShape_0_4 = this._get_bitmap__0_k$()._get_height__0_k$() / 20 | 0;
    var tmp0_apply_0_1_5 = new PolygonShape();
    tmp0_apply_0_1_5._count_4 = 4;
    var tmp0_set_0_2_2_6 = tmp0_apply_0_1_5._vertices_2[0];
    tmp0_set_0_2_2_6.set_rybm4g_k$(numberToDouble(0), numberToDouble(0));
    Unit_getInstance();
    var tmp1_set_0_3_3_7 = tmp0_apply_0_1_5._vertices_2[1];
    tmp1_set_0_3_3_7.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(0));
    Unit_getInstance();
    var tmp2_set_0_4_4_8 = tmp0_apply_0_1_5._vertices_2[2];
    tmp2_set_0_4_4_8.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(tmp1_BoxShape_0_4));
    Unit_getInstance();
    var tmp3_set_0_5_5_9 = tmp0_apply_0_1_5._vertices_2[3];
    tmp3_set_0_5_5_9.set_rybm4g_k$(numberToDouble(0), numberToDouble(tmp1_BoxShape_0_4));
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[0].set_rybm4g_k$(0.0, -1.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[1].set_rybm4g_k$(1.0, 0.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[2].set_rybm4g_k$(0.0, 1.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[3].set_rybm4g_k$(-1.0, 0.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._centroid.setZero_sv8swh_k$();
    tmp_1._shape = tmp0_apply_0_1_5;
    tmp0_apply_0_2_1._density = 1.0;
    tmp0_apply_0_2_1._restitution = 1.0;
    tmp0_fixture_0.createFixture_n3zf3w_k$(tmp0_apply_0_2_1);
    Unit_getInstance();
    var body = tmp0_fixture_0;
    _set_view_(body, this);
    var tmp_2 = _get_timesPerSecond_(60);
    addFixedUpdater$default(this, tmp_2, false, 0, _no_name_provided_$factory_598(body), 6, null);
    Unit_getInstance();
  }
  RightFlipper.$metadata$ = {
    simpleName: 'RightFlipper',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_597($body) {
    var i = new _no_name_provided__665($body);
    return function (p1) {
      i.invoke_gyklze_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_598($body) {
    var i = new _no_name_provided__666($body);
    return function (p1) {
      i.invoke_fr4981_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__667($playField) {
    this._$playField_2 = $playField;
  }
  _no_name_provided__667.prototype.invoke_p3wcz4_k$ = function ($this$addUpdater, it) {
    if ($this$addUpdater._get_touchingBeachBall__0_k$()) {
      var tmp = this._$playField_2._game_5._resources_0._get_springSound__0_k$();
      var tmp_0 = this._$playField_2._game_5._get_views__0_k$()._coroutineContext_6;
      tmp.play$default_5gxx2y_k$(tmp_0, null, 2, null);
      Unit_getInstance();
      var tmp0_safe_receiver = _get_body_(this._$playField_2._beachBall);
      if (tmp0_safe_receiver == null) {
        Unit_getInstance();
      } else
        tmp0_safe_receiver._set_linearVelocityX__cpozfn_k$(0.0);
      var tmp1_safe_receiver = _get_body_(this._$playField_2._beachBall);
      if (tmp1_safe_receiver == null) {
        Unit_getInstance();
      } else
        tmp1_safe_receiver._set_linearVelocityY__cpozfn_k$(-100.0);
    }};
  _no_name_provided__667.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Spring ? p1 : THROW_CCE();
    this.invoke_p3wcz4_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__667.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Spring(playField, image) {
    BaseEntity.call(this, playField, image);
    this.createBoxHitShape_sv8swh_k$();
    addUpdater(this, _no_name_provided_$factory_599(playField));
    Unit_getInstance();
  }
  Spring.$metadata$ = {
    simpleName: 'Spring',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_599($playField) {
    var i = new _no_name_provided__667($playField);
    return function (p1, p2) {
      i.invoke_p3wcz4_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__668($playField) {
    this._$playField_3 = $playField;
  }
  _no_name_provided__668.prototype.invoke_gvr72_k$ = function ($this$addUpdater, it) {
    if ($this$addUpdater._get_touchingBeachBall__0_k$()) {
      var destinationName = '' + $this$addUpdater._get_name__0_k$() + '-destination';
      var destination = ensureNotNull(this._$playField_3.getChildByName_6wfw3l_k$(destinationName));
      this._$playField_3._beachBall._set_x__okcceq_k$(destination._get_x__0_k$() + this._$playField_3._beachBall._get_width__0_k$() / 2);
      this._$playField_3._beachBall._set_y__okcceq_k$(destination._get_y__0_k$() + this._$playField_3._beachBall._get_height__0_k$() / 2);
    }};
  _no_name_provided__668.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Teleport ? p1 : THROW_CCE();
    this.invoke_gvr72_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__668.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Teleport(playField, image) {
    BaseEntity.call(this, playField, image);
    var tmp0__get_transparent__0 = Bitmaps_getInstance();
    this._set_bitmap__5a5lwo_k$(Bitmaps_transparent);
    this._set_scaledWidth__okcceq_k$(image._get_width__0_k$());
    this._set_scaledHeight__okcceq_k$(image._get_height__0_k$());
    this.createBoxHitShape_sv8swh_k$();
    addUpdater(this, _no_name_provided_$factory_600(playField));
    Unit_getInstance();
  }
  Teleport.$metadata$ = {
    simpleName: 'Teleport',
    kind: 'class',
    interfaces: []
  };
  function TeleportDestination(playField, image) {
    BaseEntity.call(this, playField, image);
    var tmp0__get_transparent__0 = Bitmaps_getInstance();
    this._set_bitmap__5a5lwo_k$(Bitmaps_transparent);
  }
  TeleportDestination.$metadata$ = {
    simpleName: 'TeleportDestination',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_600($playField) {
    var i = new _no_name_provided__668($playField);
    return function (p1, p2) {
      i.invoke_gvr72_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function createBoxHitShape($this) {
    var tmp0_invoke_0 = Companion_getInstance_46();
    var tmp1_invoke_0 = $this._get_width__0_k$();
    var tmp2_invoke_0 = $this._get_height__0_k$();
    $this._set_hitShape2d__irscnu_k$(new Rectangle_0(new Rectangle(0.0, 0.0, tmp1_invoke_0, tmp2_invoke_0)));
  }
  function _no_name_provided__669() {
  }
  _no_name_provided__669.prototype.invoke_4n6ubx_k$ = function ($this$addUpdater, it) {
    if ($this$addUpdater._get_touchingBeachBall__0_k$()) {
      $this$addUpdater._set_alpha__okcceq_k$(3.0);
    } else if ($this$addUpdater._get_alpha__0_k$() > 0.0) {
      var tmp0_this = $this$addUpdater;
      tmp0_this._set_alpha__okcceq_k$(tmp0_this._get_alpha__0_k$() - 0.01);
    } else {
      $this$addUpdater._set_alpha__okcceq_k$(0.0);
    }
  };
  _no_name_provided__669.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof TextEntity ? p1 : THROW_CCE();
    this.invoke_4n6ubx_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__669.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TextEntity(playField, child) {
    var tmp = child._get_text__0_k$();
    var tmp_0 = child._textSize;
    Text_init_$Init$(tmp, tmp_0, null, null, null, null, false, 124, null, this);
    this._playField_1 = playField;
    xy_0(this, child);
    Unit_getInstance();
    createBoxHitShape(this);
    this._set_alpha__okcceq_k$(0.0);
    addUpdater(this, _no_name_provided_$factory_601());
    Unit_getInstance();
  }
  TextEntity.prototype._get_touchingBeachBall__0_k$ = function () {
    return collidesWith(this, this._playField_1._beachBall, CollisionKind_SHAPE_getInstance());
  };
  TextEntity.$metadata$ = {
    simpleName: 'TextEntity',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_601() {
    var i = new _no_name_provided__669();
    return function (p1, p2) {
      i.invoke_4n6ubx_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__670($container) {
    this._$container = $container;
  }
  _no_name_provided__670.prototype.invoke_rqulwx_k$ = function ($this$onCollision, it) {
    if (it instanceof Vehicle) {
      var entranceName = '' + $this$onCollision._name_43 + '-entrance';
      var entrance = ensureNotNull(this._$container.getChildByName_6wfw3l_k$(entranceName));
      it._set_x__okcceq_k$(entrance._get_x__0_k$());
    } else {
    }
  };
  _no_name_provided__670.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof View ? p1 : THROW_CCE();
    this.invoke_rqulwx_k$(tmp, p2 instanceof View ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__670.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Tunnel(container, oldImage) {
    var tmp = oldImage._get_bitmap__0_k$();
    Sprite_init_$Init$(tmp, 0.0, 0.0, null, false, 30, null, this);
    xy_0(this, oldImage);
    Unit_getInstance();
    this._set_name__qlpr75_k$(oldImage._get_name__0_k$());
    var tmp0_elvis_lhs_1 = null;
    var tmp_0 = tmp0_elvis_lhs_1 == null ? _get_nearestBox2dWorld_(container) : tmp0_elvis_lhs_1;
    var tmp0_apply_0_2 = BodyDef_init_$Create$(null, null, null, 0.0, null, 0.0, 0.0, 0.0, false, false, false, false, false, 0.0, 16383, null);
    tmp0_apply_0_2._type_7 = BodyType_STATIC_getInstance();
    var tmp0_fixture_0 = tmp_0.createBody_kicyo5_k$(tmp0_apply_0_2);
    var tmp0_apply_0_2_1 = FixtureDef_init_$Create$(null, null, 0.0, 0.0, 0.0, false, null, 127, null);
    tmp0_apply_0_2_1._isSensor = true;
    var tmp_1 = tmp0_apply_0_2_1;
    var tmp0_BoxShape_0_3 = this._get_bitmap__0_k$()._get_width__0_k$() / 20 | 0;
    var tmp1_BoxShape_0_4 = this._get_bitmap__0_k$()._get_height__0_k$() / 20 | 0;
    var tmp0_apply_0_1_5 = new PolygonShape();
    tmp0_apply_0_1_5._count_4 = 4;
    var tmp0_set_0_2_2_6 = tmp0_apply_0_1_5._vertices_2[0];
    tmp0_set_0_2_2_6.set_rybm4g_k$(numberToDouble(0), numberToDouble(0));
    Unit_getInstance();
    var tmp1_set_0_3_3_7 = tmp0_apply_0_1_5._vertices_2[1];
    tmp1_set_0_3_3_7.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(0));
    Unit_getInstance();
    var tmp2_set_0_4_4_8 = tmp0_apply_0_1_5._vertices_2[2];
    tmp2_set_0_4_4_8.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(tmp1_BoxShape_0_4));
    Unit_getInstance();
    var tmp3_set_0_5_5_9 = tmp0_apply_0_1_5._vertices_2[3];
    tmp3_set_0_5_5_9.set_rybm4g_k$(numberToDouble(0), numberToDouble(tmp1_BoxShape_0_4));
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[0].set_rybm4g_k$(0.0, -1.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[1].set_rybm4g_k$(1.0, 0.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[2].set_rybm4g_k$(0.0, 1.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._normals_0[3].set_rybm4g_k$(-1.0, 0.0);
    Unit_getInstance();
    tmp0_apply_0_1_5._centroid.setZero_sv8swh_k$();
    tmp_1._shape = tmp0_apply_0_1_5;
    tmp0_fixture_0.createFixture_n3zf3w_k$(tmp0_apply_0_2_1);
    Unit_getInstance();
    var body = tmp0_fixture_0;
    _set_view_(body, this);
    onCollision$default(this, null, null, null, _no_name_provided_$factory_602(container), 7, null);
    Unit_getInstance();
  }
  Tunnel.$metadata$ = {
    simpleName: 'Tunnel',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__671($body, $playField) {
    this._$body_1 = $body;
    this._$playField_4 = $playField;
  }
  _no_name_provided__671.prototype.invoke_y619n7_k$ = function ($this$addUpdater, it) {
    this._$body_1._set_linearVelocityX__cpozfn_k$(-15.0);
    if ($this$addUpdater._get_touchingBeachBall__0_k$()) {
      var tmp = this._$playField_4._game_5._get_views__0_k$()._coroutineContext_6;
      $this$addUpdater._sound_0.play$default_5gxx2y_k$(tmp, null, 2, null);
      Unit_getInstance();
    }};
  _no_name_provided__671.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Vehicle ? p1 : THROW_CCE();
    this.invoke_y619n7_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__671.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Vehicle(playField, image, sound) {
    BaseEntity.call(this, playField, image);
    this._sound_0 = sound;
    var body = this.createBoxBody_3h59xg_k$(BodyType_KINEMATIC_getInstance());
    this.createBoxHitShape_sv8swh_k$();
    addUpdater(this, _no_name_provided_$factory_603(body, playField));
    Unit_getInstance();
  }
  Vehicle.$metadata$ = {
    simpleName: 'Vehicle',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_602($container) {
    var i = new _no_name_provided__670($container);
    return function (p1, p2) {
      i.invoke_rqulwx_k$(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_603($body, $playField) {
    var i = new _no_name_provided__671($body, $playField);
    return function (p1, p2) {
      i.invoke_y619n7_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__672() {
  }
  _no_name_provided__672.prototype.invoke_t39kku_k$ = function (p0, p1, p2) {
    return _interpolateTimeSpan(p0, p1, p2);
  };
  _no_name_provided__672.prototype.invoke_ifn5k1_k$ = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE();
    return new TimeSpan(this.invoke_t39kku_k$(tmp, tmp_0, p3 instanceof TimeSpan ? p3._milliseconds : THROW_CCE()));
  };
  _no_name_provided__672.prototype._get_name__0_k$ = function () {
    return '_interpolateTimeSpan';
  };
  _no_name_provided__672.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__673() {
  }
  _no_name_provided__673.prototype.invoke_t39kku_k$ = function (p0, p1, p2) {
    return _interpolateTimeSpan(p0, p1, p2);
  };
  _no_name_provided__673.prototype.invoke_ifn5k1_k$ = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE();
    return new TimeSpan(this.invoke_t39kku_k$(tmp, tmp_0, p3 instanceof TimeSpan ? p3._milliseconds : THROW_CCE()));
  };
  _no_name_provided__673.prototype._get_name__0_k$ = function () {
    return '_interpolateTimeSpan';
  };
  _no_name_provided__673.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__674($wave) {
    this._$wave = $wave;
  }
  _no_name_provided__674.prototype.invoke_njrw7w_k$ = function ($this$animateParallel) {
    var tmp0_sequence_0 = $this$animateParallel._time_6;
    var tmp1_sequence_0 = $this$animateParallel._speed;
    var tmp2_sequence_0 = $this$animateParallel._easing_0;
    var tmp3_sequence_0 = $this$animateParallel._completeOnCancel;
    var tmp = NodeKind_Sequence_getInstance();
    var tmp0_apply_0_2 = Animator_init_$Create$($this$animateParallel._root_3, tmp0_sequence_0, tmp1_sequence_0, tmp2_sequence_0, tmp3_sequence_0, tmp, true, null, 128, null);
    var tmp0_get_0_4 = time$factory(this._$wave);
    var tmp1_get_0_5 = Companion_getInstance_92().fromSeconds_ttklb2_k$(1.0);
    var tmp_0 = tmp0_get_0_4.get();
    var tmp_1 = new TimeSpan(tmp1_get_0_5);
    var tmp_2 = _no_name_provided_$factory_605();
    var tmp_3 = [V2_init_$Create$(tmp0_get_0_4, tmp_0, tmp_1, tmp_2, false, null, null, 96, null)];
    tmp0_apply_0_2.tween_lgqmq9_k$(tmp_3, Companion_getInstance_92().fromSeconds_ttklb2_k$(1.0), Companion_getInstance_57()._get_LINEAR__0_k$());
    var tmp2_get_0_6 = time$factory_0(this._$wave);
    var tmp3_get_0_7 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
    var tmp_4 = tmp2_get_0_6.get();
    var tmp_5 = new TimeSpan(tmp3_get_0_7);
    var tmp_6 = _no_name_provided_$factory_606();
    var tmp_7 = [V2_init_$Create$(tmp2_get_0_6, tmp_4, tmp_5, tmp_6, false, null, null, 96, null)];
    tmp0_apply_0_2.tween_lgqmq9_k$(tmp_7, Companion_getInstance_92().fromSeconds_ttklb2_k$(1.0), Companion_getInstance_57()._get_LINEAR__0_k$());
    var tmp1_also_0_1 = tmp0_apply_0_2;
    $this$animateParallel._nodes.add_1hrmez_k$(tmp1_also_0_1);
    Unit_getInstance();
    Unit_getInstance();
  };
  _no_name_provided__674.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_njrw7w_k$(p1 instanceof Animator ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__674.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__675(this$0, $wave, resultContinuation) {
    this._this$0_176 = this$0;
    this._$wave_0 = $wave;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__675.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__675.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__675.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = animateParallel$default(this._this$0_176, null, 0.0, null, false, false, _no_name_provided_$factory_607(this._$wave_0), 31, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__675.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__675(this._this$0_176, this._$wave_0, completion);
    return i;
  };
  _no_name_provided__675.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function Water(playField, image) {
    BaseEntity.call(this, playField, image);
    this.createBoxBody_3h59xg_k$(BodyType_STATIC_getInstance());
    Unit_getInstance();
    var wave = WaveFilter_init_$Create$(40, 40, 0.0, 0.0, 0.0, 0.0, null, 124, null);
    this._set_filter__gcenm8_k$(wave);
    var tmp = playField._game_5._get_views__0_k$()._coroutineContext_6;
    launch_0(tmp, _no_name_provided_$factory_604(this, wave, null));
    Unit_getInstance();
  }
  Water.$metadata$ = {
    simpleName: 'Water',
    kind: 'class',
    interfaces: []
  };
  function time$factory($b0) {
    return getPropertyCallableRef('time', 0, KMutableProperty0, function () {
      return new TimeSpan($b0._get_time__nsqrdp_k$());
    }, function (value) {
      return $b0._set_time__zah5t7_k$(value._milliseconds);
    });
  }
  function time$factory_0($b0) {
    return getPropertyCallableRef('time', 0, KMutableProperty0, function () {
      return new TimeSpan($b0._get_time__nsqrdp_k$());
    }, function (value) {
      return $b0._set_time__zah5t7_k$(value._milliseconds);
    });
  }
  function _no_name_provided_$factory_604(this$0, $wave, resultContinuation) {
    var i = new _no_name_provided__675(this$0, $wave, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_605() {
    var i = new _no_name_provided__672();
    var l = function (p1, p2, p3) {
      return new TimeSpan(i.invoke_t39kku_k$(p1, p2._milliseconds, p3._milliseconds));
    };
    l.callableName = i._get_name__0_k$();
    return l;
  }
  function _no_name_provided_$factory_606() {
    var i = new _no_name_provided__673();
    var l = function (p1, p2, p3) {
      return new TimeSpan(i.invoke_t39kku_k$(p1, p2._milliseconds, p3._milliseconds));
    };
    l.callableName = i._get_name__0_k$();
    return l;
  }
  function _no_name_provided_$factory_607($wave) {
    var i = new _no_name_provided__674($wave);
    return function (p1) {
      i.invoke_njrw7w_k$(p1);
      return Unit_getInstance();
    };
  }
  function main($cont) {
    var tmp = Korge_getInstance();
    var tmp_0 = new GameModule();
    return tmp.invoke_te0jre_k$(Config_init_$Create$(tmp_0, null, null, null, null, null, null, null, false, false, null, null, false, null, null, 0, null, 131070, null), $cont);
  }
  function _no_name_provided__676($tmp0_onClick_0_4, $it, resultContinuation) {
    this._$tmp0_onClick_0_4 = $tmp0_onClick_0_4;
    this._$it_6 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__676.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__676.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__676.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp0_onClick_0_4(this._$it_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__676.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__676(this._$tmp0_onClick_0_4, this._$it_6, completion);
    return i;
  };
  _no_name_provided__676.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__677($tmp0_apply_0_2, this$0, resultContinuation) {
    this._$tmp0_apply_0_2 = $tmp0_apply_0_2;
    this._this$0_177 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__677.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__677.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__677.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._$tmp0_apply_0_2._set_enabled__rpwsgn_k$(false);
            this._$tmp0_apply_0_2._text_4 = 'LOADING...';
            this._this$0_177._game_0.reset_sv8swh_k$();
            this._this$0_177._game_0._currentLevelIndex = 0;
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_0_60 = this._this$0_177._get_sceneContainer__0_k$();
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_0_71 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
            var tmp_2 = this;
            tmp_2._tmp2_changeTo_0_82 = this._tmp0_changeTo_0_60._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._tmp0_changeTo_0_60.changeTo_71zaf0_k$(getKClass_0(PlayScene), [].slice(), this._tmp1_changeTo_0_71, this._tmp2_changeTo_0_82, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__677.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__677(this._$tmp0_apply_0_2, this._this$0_177, completion);
    i._it_7 = it;
    return i;
  };
  _no_name_provided__677.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__678($tmp1_safe_receiver_1_2_10, $tmp0_onClick_0_4) {
    this._$tmp1_safe_receiver_1_2_10 = $tmp1_safe_receiver_1_2_10;
    this._$tmp0_onClick_0_4_0 = $tmp0_onClick_0_4;
  }
  _no_name_provided__678.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_10._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_608(this._$tmp0_onClick_0_4_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__678.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__678.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $sceneInitCOROUTINE$2(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__211 = _this_;
    this.__this__212 = _this__0;
  }
  $sceneInitCOROUTINE$2.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readKTree_0(_get_resourcesVfs_().get_6wfw3l_k$('end.ktree'), this.__this__212, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            var tmp0_uiButton_0 = 100.0;
            var tmp1_uiButton_0 = 32.0;
            var tmp0_apply_0_2 = addTo(new UIButton(tmp0_uiButton_0, tmp1_uiButton_0, '', null), this.__this__212);
            tmp0_apply_0_2._text_4 = 'REPLAY';
            xy_1(tmp0_apply_0_2, 900, 680);
            Unit_getInstance();
            size_1(tmp0_apply_0_2, 300, 64);
            Unit_getInstance();
            _set_buttonBackColor_(tmp0_apply_0_2, Colors_getInstance()._YELLOW);
            var tmp0_onClick_0_4 = _no_name_provided_$factory_609(tmp0_apply_0_2, this.__this__211, null);
            var tmp0_doMouseEvent_0_1_9 = click$factory_0();
            var tmp0_safe_receiver_2_3_11 = tmp0_apply_0_2;
            var tmp1_safe_receiver_1_2_10 = tmp0_safe_receiver_2_3_11 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3_11);
            if (tmp1_safe_receiver_1_2_10 == null)
              null;
            else {
              var tmp_0 = tmp0_doMouseEvent_0_1_9.get(tmp1_safe_receiver_1_2_10);
              tmp_0.add_o72mru_k$(_no_name_provided_$factory_610(tmp1_safe_receiver_1_2_10, tmp0_onClick_0_4));
            }

            Unit_getInstance();
            Unit_getInstance();
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneInitCOROUTINE$2.$metadata$ = {
    simpleName: '$sceneInitCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function EndScene(game) {
    Scene.call(this);
    this._game_0 = game;
  }
  EndScene.prototype.sceneInit_zg0dwy_k$ = function (_this__0, $cont) {
    var tmp = new $sceneInitCOROUTINE$2(this, _this__0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  EndScene.$metadata$ = {
    simpleName: 'EndScene',
    kind: 'class',
    interfaces: []
  };
  function click$factory_0() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function _no_name_provided_$factory_608($tmp0_onClick_0_4, $it, resultContinuation) {
    var i = new _no_name_provided__676($tmp0_onClick_0_4, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_609($tmp0_apply_0_2, this$0, resultContinuation) {
    var i = new _no_name_provided__677($tmp0_apply_0_2, this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_610($tmp1_safe_receiver_1_2_10, $tmp0_onClick_0_4) {
    var i = new _no_name_provided__678($tmp1_safe_receiver_1_2_10, $tmp0_onClick_0_4);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__679($tmp0_onClick_0_4, $it, resultContinuation) {
    this._$tmp0_onClick_0_4_1 = $tmp0_onClick_0_4;
    this._$it_7 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__679.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__679.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__679.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp0_onClick_0_4_1(this._$it_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__679.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__679(this._$tmp0_onClick_0_4_1, this._$it_7, completion);
    return i;
  };
  _no_name_provided__679.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__680($tmp0_apply_0_2, this$0, resultContinuation) {
    this._$tmp0_apply_0_2_0 = $tmp0_apply_0_2;
    this._this$0_178 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__680.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__680.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__680.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._$tmp0_apply_0_2_0._set_enabled__rpwsgn_k$(false);
            this._$tmp0_apply_0_2_0._text_4 = 'LOADING...';
            this._this$0_178._game_1.reset_sv8swh_k$();
            var tmp_0 = this;
            var tmp_1 = Companion_getInstance_218()._get_DIAGONAL1__0_k$();
            tmp_0._tmp0_transition_60 = MaskTransition$default(tmp_1, false, false, false, 14, null);
            var tmp_2 = this;
            tmp_2._tmp1_time_71 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.5);
            var tmp_3 = this;
            tmp_3._tmp0_changeTo_0_82 = this._this$0_178._get_sceneContainer__0_k$();
            this._state_1 = 1;
            suspendResult = this._tmp0_changeTo_0_82.changeTo_71zaf0_k$(getKClass_0(PlayScene), [].slice(), this._tmp1_time_71, this._tmp0_transition_60, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__680.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__680(this._$tmp0_apply_0_2_0, this._this$0_178, completion);
    i._it_8 = it;
    return i;
  };
  _no_name_provided__680.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__681($tmp1_safe_receiver_1_2_10, $tmp0_onClick_0_4) {
    this._$tmp1_safe_receiver_1_2_10_0 = $tmp1_safe_receiver_1_2_10;
    this._$tmp0_onClick_0_4_2 = $tmp0_onClick_0_4;
  }
  _no_name_provided__681.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_10_0._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_611(this._$tmp0_onClick_0_4_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__681.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__681.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $sceneInitCOROUTINE$3(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__213 = _this_;
    this.__this__214 = _this__0;
  }
  $sceneInitCOROUTINE$3.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readKTree_0(_get_resourcesVfs_().get_6wfw3l_k$(this.__this__213._game_1._get_currentLevel__0_k$()._intro), this.__this__214, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            var tmp0_uiButton_0 = 100.0;
            var tmp1_uiButton_0 = 32.0;
            var tmp0_apply_0_2 = addTo(new UIButton(tmp0_uiButton_0, tmp1_uiButton_0, '', null), this.__this__214);
            tmp0_apply_0_2._text_4 = 'START';
            xy_1(tmp0_apply_0_2, 900, 680);
            Unit_getInstance();
            size_1(tmp0_apply_0_2, 300, 64);
            Unit_getInstance();
            _set_buttonBackColor_(tmp0_apply_0_2, Colors_getInstance()._YELLOW);
            var tmp0_onClick_0_4 = _no_name_provided_$factory_612(tmp0_apply_0_2, this.__this__213, null);
            var tmp0_doMouseEvent_0_1_9 = click$factory_1();
            var tmp0_safe_receiver_2_3_11 = tmp0_apply_0_2;
            var tmp1_safe_receiver_1_2_10 = tmp0_safe_receiver_2_3_11 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3_11);
            if (tmp1_safe_receiver_1_2_10 == null)
              null;
            else {
              var tmp_0 = tmp0_doMouseEvent_0_1_9.get(tmp1_safe_receiver_1_2_10);
              tmp_0.add_o72mru_k$(_no_name_provided_$factory_613(tmp1_safe_receiver_1_2_10, tmp0_onClick_0_4));
            }

            Unit_getInstance();
            Unit_getInstance();
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneInitCOROUTINE$3.$metadata$ = {
    simpleName: '$sceneInitCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function IntroScene(game) {
    Scene.call(this);
    this._game_1 = game;
  }
  IntroScene.prototype.sceneInit_zg0dwy_k$ = function (_this__0, $cont) {
    var tmp = new $sceneInitCOROUTINE$3(this, _this__0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  IntroScene.$metadata$ = {
    simpleName: 'IntroScene',
    kind: 'class',
    interfaces: []
  };
  function click$factory_1() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function _no_name_provided_$factory_611($tmp0_onClick_0_4, $it, resultContinuation) {
    var i = new _no_name_provided__679($tmp0_onClick_0_4, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_612($tmp0_apply_0_2, this$0, resultContinuation) {
    var i = new _no_name_provided__680($tmp0_apply_0_2, this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_613($tmp1_safe_receiver_1_2_10, $tmp0_onClick_0_4) {
    var i = new _no_name_provided__681($tmp1_safe_receiver_1_2_10, $tmp0_onClick_0_4);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function $sceneInitCOROUTINE$4(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__215 = _this_;
    this.__this__216 = _this__0;
  }
  $sceneInitCOROUTINE$4.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__215._game_2._resources_0.load_sv8swh_k$(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_00_0 = this.__this__215._get_sceneContainer__0_k$();
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_01_0 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
            var tmp_2 = this;
            tmp_2._tmp2_changeTo_02 = this._tmp0_changeTo_00_0._defaultTransition;
            this._state_1 = 2;
            suspendResult = this._tmp0_changeTo_00_0.changeTo_71zaf0_k$(getKClass_0(TitleScene), [].slice(), this._tmp1_changeTo_01_0, this._tmp2_changeTo_02, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneInitCOROUTINE$4.$metadata$ = {
    simpleName: '$sceneInitCOROUTINE$4',
    kind: 'class',
    interfaces: []
  };
  function LoadScene(game) {
    Scene.call(this);
    this._game_2 = game;
  }
  LoadScene.prototype.sceneInit_zg0dwy_k$ = function (_this__0, $cont) {
    var tmp = new $sceneInitCOROUTINE$4(this, _this__0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  LoadScene.$metadata$ = {
    simpleName: 'LoadScene',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__682(this$0, $channel, resultContinuation) {
    this._this$0_179 = this$0;
    this._$channel_1 = $channel;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__682.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__682.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__682.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp0_this = this._this$0_179._game_3;
            var tmp1 = tmp0_this._currentLevelIndex;
            tmp0_this._currentLevelIndex = tmp1 + 1 | 0;
            Unit_getInstance();
            this._this$0_179._exited = true;
            this._$channel_1.stop_sv8swh_k$();
            if (this._this$0_179._game_3._currentLevelIndex < this._this$0_179._game_3._levels._get_size__0_k$()) {
              var tmp_0 = this;
              var tmp_1 = Companion_getInstance_218()._get_DIAGONAL1__0_k$();
              tmp_0._tmp2_transition0 = MaskTransition$default(tmp_1, false, false, false, 14, null);
              var tmp_2 = this;
              tmp_2._tmp3_time1 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.5);
              var tmp_3 = this;
              tmp_3._tmp0_changeTo_02 = this._this$0_179._get_sceneContainer__0_k$();
              this._state_1 = 2;
              suspendResult = this._tmp0_changeTo_02.changeTo_71zaf0_k$(getKClass_0(IntroScene), [].slice(), this._tmp3_time1, this._tmp2_transition0, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              var tmp_4 = this;
              var tmp_5 = Companion_getInstance_218()._get_HORIZONTAL__0_k$();
              tmp_4._tmp4_transition3 = MaskTransition$default(tmp_5, false, false, false, 14, null);
              var tmp_6 = this;
              tmp_6._tmp5_time4 = Companion_getInstance_92().fromSeconds_ttklb2_k$(2.0);
              var tmp_7 = this;
              tmp_7._tmp1_changeTo_05 = this._this$0_179._get_sceneContainer__0_k$();
              this._state_1 = 1;
              suspendResult = this._tmp1_changeTo_05.changeTo_71zaf0_k$(getKClass_0(EndScene), [].slice(), this._tmp5_time4, this._tmp4_transition3, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            Unit_getInstance();
            this._state_1 = 3;
            continue $sm;
          case 2:
            Unit_getInstance();
            this._state_1 = 3;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__682.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__682(this._this$0_179, this._$channel_1, completion);
    return i;
  };
  _no_name_provided__682.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__683(this$0, $channel) {
    this._this$0_180 = this$0;
    this._$channel_2 = $channel;
  }
  _no_name_provided__683.prototype.invoke_e9wmmy_k$ = function ($this$addUpdater, it) {
    if (this._this$0_180._game_3._touchedExit ? !this._this$0_180._exited : false) {
      var tmp = this._this$0_180._game_3._get_views__0_k$()._coroutineContext_6;
      launch_0(tmp, _no_name_provided_$factory_614(this._this$0_180, this._$channel_2, null));
      Unit_getInstance();
    }};
  _no_name_provided__683.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Container ? p1 : THROW_CCE();
    this.invoke_e9wmmy_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__683.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $sceneInitCOROUTINE$5(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__217 = _this_;
    this.__this__218 = _this__0;
  }
  $sceneInitCOROUTINE$5.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._ARGUMENT0_36 = this.__this__217._background_2;
            this._state_1 = 1;
            var tmp_0 = _get_resourcesVfs_().get_6wfw3l_k$(this.__this__217._game_3._get_currentLevel__0_k$()._background_1);
            suspendResult = readBitmap$default(tmp_0, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1_15 = suspendResult;
            var tmp_1 = this;
            tmp_1._ARGUMENT2_7 = slice$default(this._ARGUMENT1_15, null, null, 3, null);
            this._ARGUMENT0_36._set_bitmap__5a5lwo_k$(this._ARGUMENT2_7);
            this._state_1 = 2;
            suspendResult = readKTree_0(_get_resourcesVfs_().get_6wfw3l_k$(this.__this__217._game_3._get_currentLevel__0_k$()._ktree), this.__this__217._playField_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp_2 = this;
            tmp_2._scene3 = suspendResult instanceof KTreeRoot ? suspendResult : THROW_CCE();
            this.__this__217._playField_2.setLevel_r6yi63_k$(this._scene3);
            this.__this__218.addChild_4l6ao4_k$(this.__this__217._background_2);
            this.__this__218.addChild_4l6ao4_k$(this.__this__217._playField_2);
            this.__this__218.addChild_4l6ao4_k$(new Hud(this.__this__217));
            this._state_1 = 3;
            var tmp_3 = _get_resourcesVfs_().get_6wfw3l_k$('Cephelopod.mp3');
            suspendResult = readSound$default(tmp_3, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var music = suspendResult;
            var tmp_4 = this.__this__217._game_3._get_views__0_k$()._coroutineContext_6;
            var channel = music.playForever$default_7k2zgb_k$(tmp_4, null, 2, null);
            addUpdater(this.__this__218, _no_name_provided_$factory_615(this.__this__217, channel));
            Unit_getInstance();
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneInitCOROUTINE$5.$metadata$ = {
    simpleName: '$sceneInitCOROUTINE$5',
    kind: 'class',
    interfaces: []
  };
  function PlayScene(game) {
    Scene.call(this);
    this._game_3 = game;
    this._playField_2 = new PlayField(this._game_3);
    var tmp = this;
    tmp._background_2 = Sprite_init_$Create$(null, 0.0, 0.0, null, false, 31, null);
    this._exited = false;
  }
  PlayScene.prototype.sceneInit_zg0dwy_k$ = function (_this__0, $cont) {
    var tmp = new $sceneInitCOROUTINE$5(this, _this__0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  PlayScene.$metadata$ = {
    simpleName: 'PlayScene',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_614(this$0, $channel, resultContinuation) {
    var i = new _no_name_provided__682(this$0, $channel, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_615(this$0, $channel) {
    var i = new _no_name_provided__683(this$0, $channel);
    return function (p1, p2) {
      i.invoke_e9wmmy_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__684($tmp0_onClick_0_4, $it, resultContinuation) {
    this._$tmp0_onClick_0_4_3 = $tmp0_onClick_0_4;
    this._$it_8 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__684.prototype.invoke_sv8swh_k$ = function ($cont) {
    var tmp = this.create_s8oglw_k$($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__684.prototype.invoke_0_k$ = function ($cont) {
    this.invoke_sv8swh_k$($cont);
    return Unit_getInstance();
  };
  _no_name_provided__684.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp0_onClick_0_4_3(this._$it_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__684.prototype.create_s8oglw_k$ = function (completion) {
    var i = new _no_name_provided__684(this._$tmp0_onClick_0_4_3, this._$it_8, completion);
    return i;
  };
  _no_name_provided__684.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__685(this$0, resultContinuation) {
    this._this$0_181 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__685.prototype.invoke_nn0jqo_k$ = function (it, $cont) {
    var tmp = this.create_ow3isr_k$(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  _no_name_provided__685.prototype.invoke_20e8_k$ = function (p1, $cont) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__685.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_0_60_0 = this._this$0_181._get_sceneContainer__0_k$();
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_0_71_0 = Companion_getInstance_92().fromSeconds_ttklb2_k$(0.0);
            var tmp_2 = this;
            tmp_2._tmp2_changeTo_0_82_0 = this._tmp0_changeTo_0_60_0._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._tmp0_changeTo_0_60_0.changeTo_71zaf0_k$(getKClass_0(IntroScene), [].slice(), this._tmp1_changeTo_0_71_0, this._tmp2_changeTo_0_82_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__685.prototype.create_ow3isr_k$ = function (it, completion) {
    var i = new _no_name_provided__685(this._this$0_181, completion);
    i._it_9 = it;
    return i;
  };
  _no_name_provided__685.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__686($tmp1_safe_receiver_1_2_10, $tmp0_onClick_0_4) {
    this._$tmp1_safe_receiver_1_2_10_1 = $tmp1_safe_receiver_1_2_10;
    this._$tmp0_onClick_0_4_4 = $tmp0_onClick_0_4;
  }
  _no_name_provided__686.prototype.invoke_nn0jqo_k$ = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_10_1._get_coroutineContext__0_k$();
    launchImmediately(tmp, _no_name_provided_$factory_616(this._$tmp0_onClick_0_4_4, it, null));
    Unit_getInstance();
  };
  _no_name_provided__686.prototype.invoke_20e8_k$ = function (p1) {
    this.invoke_nn0jqo_k$(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__686.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $sceneInitCOROUTINE$6(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__219 = _this_;
    this.__this__220 = _this__0;
  }
  $sceneInitCOROUTINE$6.prototype.doResume_0_k$ = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readKTree_0(_get_resourcesVfs_().get_6wfw3l_k$('title.ktree'), this.__this__220, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            Unit_getInstance();
            var tmp0_uiButton_0 = 100.0;
            var tmp1_uiButton_0 = 32.0;
            var tmp0_apply_0_2 = addTo(new UIButton(tmp0_uiButton_0, tmp1_uiButton_0, '', null), this.__this__220);
            tmp0_apply_0_2._text_4 = 'PLAY';
            _set_textSize_(tmp0_apply_0_2, 64.0);
            tmp0_apply_0_2.setSize_ul66c3_k$(300.0, 64.0);
            xy(tmp0_apply_0_2, this.__this__219._game_4._stageWidth / 2.0 - 150, this.__this__219._game_4._stageHeight / 2.0 - 32);
            Unit_getInstance();
            var tmp0_onClick_0_4 = _no_name_provided_$factory_617(this.__this__219, null);
            var tmp0_doMouseEvent_0_1_9 = click$factory_2();
            var tmp0_safe_receiver_2_3_11 = tmp0_apply_0_2;
            var tmp1_safe_receiver_1_2_10 = tmp0_safe_receiver_2_3_11 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3_11);
            if (tmp1_safe_receiver_1_2_10 == null)
              null;
            else {
              var tmp_0 = tmp0_doMouseEvent_0_1_9.get(tmp1_safe_receiver_1_2_10);
              tmp_0.add_o72mru_k$(_no_name_provided_$factory_618(tmp1_safe_receiver_1_2_10, tmp0_onClick_0_4));
            }

            Unit_getInstance();
            Unit_getInstance();
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneInitCOROUTINE$6.$metadata$ = {
    simpleName: '$sceneInitCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function TitleScene(game) {
    Scene.call(this);
    this._game_4 = game;
  }
  TitleScene.prototype.sceneInit_zg0dwy_k$ = function (_this__0, $cont) {
    var tmp = new $sceneInitCOROUTINE$6(this, _this__0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_0_k$();
  };
  TitleScene.$metadata$ = {
    simpleName: 'TitleScene',
    kind: 'class',
    interfaces: []
  };
  function click$factory_2() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function _no_name_provided_$factory_616($tmp0_onClick_0_4, $it, resultContinuation) {
    var i = new _no_name_provided__684($tmp0_onClick_0_4, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_sv8swh_k$($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_617(this$0, resultContinuation) {
    var i = new _no_name_provided__685(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_nn0jqo_k$(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_618($tmp1_safe_receiver_1_2_10, $tmp0_onClick_0_4) {
    var i = new _no_name_provided__686($tmp1_safe_receiver_1_2_10, $tmp0_onClick_0_4);
    return function (p1) {
      i.invoke_nn0jqo_k$(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__687($coinCount, $coinCountShadow) {
    this._$coinCount = $coinCount;
    this._$coinCountShadow = $coinCountShadow;
  }
  _no_name_provided__687.prototype.invoke_mvka8j_k$ = function ($this$addUpdater, it) {
    var text = '' + 'Coins: ' + $this$addUpdater._playScene._game_3._coins + ' / ' + $this$addUpdater._playScene._game_3._maxCoins;
    this._$coinCount._set_text__a4enbm_k$(text);
    this._$coinCountShadow._set_text__a4enbm_k$(text);
  };
  _no_name_provided__687.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof Hud ? p1 : THROW_CCE();
    this.invoke_mvka8j_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__687.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Hud(playScene) {
    Container.call(this);
    this._playScene = playScene;
    var coinCount = xy(Text_init_$Create$('', 64.0, null, null, null, null, false, 124, null), 10.0, 0.0);
    var tmp = Colors_getInstance()._BLACK_0;
    var coinCountShadow = xy(Text_init_$Create$('', 64.0, tmp, null, null, null, false, 120, null), 12.0, 2.0);
    this.addChild_4l6ao4_k$(coinCountShadow);
    this.addChild_4l6ao4_k$(coinCount);
    addUpdater(this, _no_name_provided_$factory_619(coinCount, coinCountShadow));
    Unit_getInstance();
  }
  Hud.$metadata$ = {
    simpleName: 'Hud',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_619($coinCount, $coinCountShadow) {
    var i = new _no_name_provided__687($coinCount, $coinCountShadow);
    return function (p1, p2) {
      i.invoke_mvka8j_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__688() {
  }
  _no_name_provided__688.prototype.invoke_5c5yjo_k$ = function ($this$addUpdater, it) {
    $this$addUpdater._set_x__okcceq_k$(-$this$addUpdater._beachBall._get_x__0_k$() + ($this$addUpdater._game_5._stageWidth / 2 | 0));
    $this$addUpdater._set_y__okcceq_k$(-$this$addUpdater._beachBall._get_y__0_k$() + ($this$addUpdater._game_5._stageHeight / 2 | 0));
    if ($this$addUpdater._game_5._get_views__0_k$()._input_3._keys_0.pressing_dbfq2v_k$(Key_R_getInstance())) {
      $this$addUpdater._beachBall._set_pos__bbtl9s_k$($this$addUpdater._game_5._get_currentLevel__0_k$()._start_5);
    }if ($this$addUpdater._game_5._get_views__0_k$()._input_3._keys_0.pressing_dbfq2v_k$(Key_C_getInstance())) {
      var tmp0_safe_receiver_1 = $this$addUpdater._get__children__0_k$();
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        var array_1_2 = tmp0_safe_receiver_1._array_4;
        var n_2_3 = 0;
        while (n_2_3 < array_1_2.length) {
          var tmp0_4_5 = n_2_3;
          n_2_3 = tmp0_4_5 + 1 | 0;
          var tmp0_unsafeCast_0_3_4 = array_1_2[tmp0_4_5];
          var tmp0__anonymous__6 = tmp0_unsafeCast_0_3_4;
          if (tmp0__anonymous__6 instanceof Coin) {
            $this$addUpdater._beachBall._set_pos__bbtl9s_k$(tmp0__anonymous__6._get_pos__0_k$());
          } else {
          }
        }
        Unit_getInstance();
      }
      Unit_getInstance();
    }};
  _no_name_provided__688.prototype.invoke_osx4an_k$ = function (p1, p2) {
    var tmp = p1 instanceof PlayField ? p1 : THROW_CCE();
    this.invoke_5c5yjo_k$(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__688.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PlayField(game) {
    Container.call(this);
    this._game_5 = game;
    this._beachBall = new BeachBall(this, this._game_5);
  }
  PlayField.prototype.setLevel_r6yi63_k$ = function (level) {
    var removeMe = ArrayList_init_$Create$();
    var tmp0_iterator = level._get_children__0_k$().iterator_0_k$();
    while (tmp0_iterator.hasNext_0_k$()) {
      var child = tmp0_iterator.next_0_k$();
      var createBody = false;
      var tmp1_subject = child;
      if (tmp1_subject instanceof Image_1) {
        var tmp2_subject = child._get_sourceFile__0_k$();
        switch (tmp2_subject) {
          case 'left-flipper-200.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var leftFlipper = new LeftFlipper(level, this._game_5);
            xy(leftFlipper, child._get_x__0_k$(), child._get_y__0_k$());
            Unit_getInstance();
            this.addChild_4l6ao4_k$(leftFlipper);
            break;
          case 'right-flipper-200.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var rightFlipper = new RightFlipper(level, this._game_5);
            xy(rightFlipper, child._get_x__0_k$() + rightFlipper._get_width__0_k$(), child._get_y__0_k$());
            Unit_getInstance();
            this.addChild_4l6ao4_k$(rightFlipper);
            break;
          case 'fish.png':
          case 'mouse-200.png':
          case 'car-1-320.png':
          case 'car-2-320.png':
          case 'car-3-320.png':
            var tmp3_subject = child._get_sourceFile__0_k$();
            {
              var sound;
              switch (tmp3_subject) {
                case 'fish.png':
                  sound = this._game_5._resources_0._get_fishSound__0_k$();
                  break;
                case 'mouse-200.png':
                  sound = this._game_5._resources_0._get_mouseSound__0_k$();
                  break;
                default:sound = this._game_5._resources_0._get_hornSound__0_k$();
                  break;
              }
            }

            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var mouse = new Vehicle(this, child, sound);
            this.addChild_4l6ao4_k$(mouse);
            break;
          case 'car-exit.png':
          case 'mouse-hole-exit-200.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var tunnel = new Tunnel(level, child);
            this.addChild_4l6ao4_k$(tunnel);
            break;
          case 'coin-placeholder.png':
          case 'coin-placeholder-static.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var coin = new Coin(this._game_5, this, child);
            this.addChild_4l6ao4_k$(coin);
            var tmp4_this = this._game_5;
            var tmp5 = tmp4_this._maxCoins;
            tmp4_this._maxCoins = tmp5 + 1 | 0;
            Unit_getInstance();
            break;
          case 'teleport.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var teleport = new Teleport(this, child);
            this.addChild_4l6ao4_k$(teleport);
            break;
          case 'teleport-destination.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var teleportDestination = new TeleportDestination(this, child);
            this.addChild_4l6ao4_k$(teleportDestination);
            break;
          case 'mushroom-200.png':
          case 'mushroom-house-300.png':
          case 'seashell-bumper-2.png':
          case 'seashell-bumper.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var bumper = new Bumper(this, child);
            this.addChild_4l6ao4_k$(bumper);
            break;
          case 'shark.png':
          case 'no-entry-300.png':
          case 'manhole-300.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var exit = new BlockedExit(this, child);
            this.addChild_4l6ao4_k$(exit);
            break;
          case 'shell-1.png':
          case 'shell-2.png':
          case 'shell-3.png':
          case 'old-house.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var house = new Breakable(this, child);
            this.addChild_4l6ao4_k$(house);
            break;
          case 'brick-80.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var brick = new Brick(this, child);
            this.addChild_4l6ao4_k$(brick);
            break;
          case 'spring.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var spring = new Spring(this, child);
            this.addChild_4l6ao4_k$(spring);
            break;
          case 'water.png':
            removeMe.add_2bq_k$(child);
            Unit_getInstance();
            var water = new Water(this, child);
            this.addChild_4l6ao4_k$(water);
            break;
          default:var tmp6_safe_receiver = child._get_sourceFile__0_k$();
            var tmp;
            if (tmp6_safe_receiver == null) {
              tmp = null;
            } else {
              tmp = startsWith$default_1(tmp6_safe_receiver, 'bg_', false, 2, null);
            }

            createBody = tmp === false;
            break;
        }
      } else {
        if (tmp1_subject instanceof Text_3) {
          removeMe.add_2bq_k$(child);
          Unit_getInstance();
          var textEntity = new TextEntity(this, child);
          this.addChild_4l6ao4_k$(textEntity);
        } else {
        }
      }
      if (createBody) {
        var tmp0_elvis_lhs_1 = null;
        var tmp_0 = tmp0_elvis_lhs_1 == null ? _get_nearestBox2dWorld_(this) : tmp0_elvis_lhs_1;
        var tmp0_apply_0_2 = BodyDef_init_$Create$(null, null, null, 0.0, null, 0.0, 0.0, 0.0, false, false, false, false, false, 0.0, 16383, null);
        tmp0_apply_0_2._type_7 = BodyType_STATIC_getInstance();
        var tmp0_fixture_0 = tmp_0.createBody_kicyo5_k$(tmp0_apply_0_2);
        var tmp0_apply_0_2_1 = FixtureDef_init_$Create$(null, null, 0.0, 0.0, 0.0, false, null, 127, null);
        var tmp_1 = tmp0_apply_0_2_1;
        var tmp0_BoxShape_0_3 = child._get_scaledWidth__0_k$() / 20;
        var tmp1_BoxShape_0_4 = child._get_scaledHeight__0_k$() / 20;
        var tmp0_apply_0_1_5 = new PolygonShape();
        tmp0_apply_0_1_5._count_4 = 4;
        var tmp0_set_0_2_2_6 = tmp0_apply_0_1_5._vertices_2[0];
        tmp0_set_0_2_2_6.set_rybm4g_k$(numberToDouble(0), numberToDouble(0));
        Unit_getInstance();
        var tmp1_set_0_3_3_7 = tmp0_apply_0_1_5._vertices_2[1];
        tmp1_set_0_3_3_7.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(0));
        Unit_getInstance();
        var tmp2_set_0_4_4_8 = tmp0_apply_0_1_5._vertices_2[2];
        tmp2_set_0_4_4_8.set_rybm4g_k$(numberToDouble(tmp0_BoxShape_0_3), numberToDouble(tmp1_BoxShape_0_4));
        Unit_getInstance();
        var tmp3_set_0_5_5_9 = tmp0_apply_0_1_5._vertices_2[3];
        tmp3_set_0_5_5_9.set_rybm4g_k$(numberToDouble(0), numberToDouble(tmp1_BoxShape_0_4));
        Unit_getInstance();
        tmp0_apply_0_1_5._normals_0[0].set_rybm4g_k$(0.0, -1.0);
        Unit_getInstance();
        tmp0_apply_0_1_5._normals_0[1].set_rybm4g_k$(1.0, 0.0);
        Unit_getInstance();
        tmp0_apply_0_1_5._normals_0[2].set_rybm4g_k$(0.0, 1.0);
        Unit_getInstance();
        tmp0_apply_0_1_5._normals_0[3].set_rybm4g_k$(-1.0, 0.0);
        Unit_getInstance();
        tmp0_apply_0_1_5._centroid.setZero_sv8swh_k$();
        tmp_1._shape = tmp0_apply_0_1_5;
        tmp0_fixture_0.createFixture_n3zf3w_k$(tmp0_apply_0_2_1);
        Unit_getInstance();
        var body = tmp0_fixture_0;
        _set_view_(body, child);
      }}
    var tmp0_iterator_1 = removeMe.iterator_0_k$();
    while (tmp0_iterator_1.hasNext_0_k$()) {
      var element_2 = tmp0_iterator_1.next_0_k$();
      level.removeChild_38n6pl_k$(element_2);
    }
    xy(this._beachBall, this._game_5._get_currentLevel__0_k$()._start_5._x_1, this._game_5._get_currentLevel__0_k$()._start_5._y_1);
    Unit_getInstance();
    this.addChild_4l6ao4_k$(this._beachBall);
    addUpdater(this, _no_name_provided_$factory_620());
    Unit_getInstance();
  };
  PlayField.$metadata$ = {
    simpleName: 'PlayField',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_620() {
    var i = new _no_name_provided__688();
    return function (p1, p2) {
      i.invoke_5c5yjo_k$(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  AbstractMap.prototype._get_entries__0_k$ = Map_0.prototype._get_entries__0_k$;
  CombinedContext.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  AbstractCoroutineContextElement.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  AbstractCoroutineContextElement.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  AbstractCoroutineContextElement.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  AbstractCoroutineContextElement.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  UByteIterator.prototype.hasNext_0_k$ = Iterator_3.prototype.hasNext_0_k$;
  UIntIterator.prototype.hasNext_0_k$ = Iterator_3.prototype.hasNext_0_k$;
  ULongIterator.prototype.hasNext_0_k$ = Iterator_3.prototype.hasNext_0_k$;
  UShortIterator.prototype.hasNext_0_k$ = Iterator_3.prototype.hasNext_0_k$;
  IntIterator.prototype.hasNext_0_k$ = Iterator_3.prototype.hasNext_0_k$;
  LongIterator.prototype.hasNext_0_k$ = Iterator_3.prototype.hasNext_0_k$;
  CharIterator.prototype.hasNext_0_k$ = Iterator_3.prototype.hasNext_0_k$;
  AbstractMutableList.prototype.get_ha5a7z_k$ = List.prototype.get_ha5a7z_k$;
  AbstractMutableMap.prototype._get_entries__0_k$ = MutableMap.prototype._get_entries__0_k$;
  InternalHashCodeMap.prototype.createJsMap_0_k$ = InternalMap.prototype.createJsMap_0_k$;
  KClassImpl.prototype._get_simpleName__0_k$ = KClass.prototype._get_simpleName__0_k$;
  Easings.prototype.invoke_e2tf9d_k$ = Easing.prototype.invoke_e2tf9d_k$;
  BaseConsole.prototype.appendAnsiScape_jbsthk_k$ = AnsiEscape.prototype.appendAnsiScape_jbsthk_k$;
  BaseConsole.prototype.appendAnsiScape$default_ojj93a_k$ = AnsiEscape.prototype.appendAnsiScape$default_ojj93a_k$;
  BaseConsole.prototype.appendReset_85vhob_k$ = AnsiEscape.prototype.appendReset_85vhob_k$;
  BaseConsole.prototype.appendFgColor_2ur4wq_k$ = AnsiEscape.prototype.appendFgColor_2ur4wq_k$;
  BaseConsole.prototype.appendFgColor$default_dyn3vg_k$ = AnsiEscape.prototype.appendFgColor$default_dyn3vg_k$;
  Console_0.prototype.appendAnsiScape_jbsthk_k$ = AnsiEscape.prototype.appendAnsiScape_jbsthk_k$;
  Console_0.prototype.appendAnsiScape$default_ojj93a_k$ = AnsiEscape.prototype.appendAnsiScape$default_ojj93a_k$;
  Console_0.prototype.appendReset_85vhob_k$ = AnsiEscape.prototype.appendReset_85vhob_k$;
  Console_0.prototype.appendFgColor_2ur4wq_k$ = AnsiEscape.prototype.appendFgColor_2ur4wq_k$;
  Console_0.prototype.appendFgColor$default_dyn3vg_k$ = AnsiEscape.prototype.appendFgColor$default_dyn3vg_k$;
  JobSupport.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  JobSupport.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  JobSupport.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  JobSupport.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  JobSupport.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  JobSupport.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  AbstractCoroutine.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  AbstractCoroutine.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  AbstractCoroutine.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  AbstractCoroutine.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  AbstractCoroutine.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  AbstractCoroutine.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  StandaloneCoroutine.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  StandaloneCoroutine.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  StandaloneCoroutine.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  StandaloneCoroutine.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  StandaloneCoroutine.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  StandaloneCoroutine.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  LazyStandaloneCoroutine.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  LazyStandaloneCoroutine.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  LazyStandaloneCoroutine.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  LazyStandaloneCoroutine.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  LazyStandaloneCoroutine.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  LazyStandaloneCoroutine.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  DeferredCoroutine.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  DeferredCoroutine.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  DeferredCoroutine.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  DeferredCoroutine.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  DeferredCoroutine.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  DeferredCoroutine.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  LazyDeferredCoroutine.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  LazyDeferredCoroutine.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  LazyDeferredCoroutine.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  LazyDeferredCoroutine.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  LazyDeferredCoroutine.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  LazyDeferredCoroutine.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  SchedulerTask.prototype.run_sv8swh_k$ = Runnable.prototype.run_sv8swh_k$;
  CompletableDeferredImpl.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  CompletableDeferredImpl.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  CompletableDeferredImpl.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  CompletableDeferredImpl.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  CompletableDeferredImpl.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  CompletableDeferredImpl.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  CoroutineDispatcher.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  CoroutineDispatcher.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  CoroutineDispatcher.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  CoroutineDispatcher.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  EventLoop.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  EventLoop.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  EventLoop.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  EventLoop.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  JobImpl.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  JobImpl.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  JobImpl.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  JobImpl.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  JobImpl.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  JobImpl.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  MainCoroutineDispatcher.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  MainCoroutineDispatcher.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  MainCoroutineDispatcher.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  MainCoroutineDispatcher.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  SupervisorJobImpl.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  SupervisorJobImpl.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  SupervisorJobImpl.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  SupervisorJobImpl.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  SupervisorJobImpl.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  SupervisorJobImpl.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  ScopeCoroutine.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  ScopeCoroutine.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  ScopeCoroutine.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  ScopeCoroutine.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  ScopeCoroutine.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  ScopeCoroutine.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  TimeoutCoroutine.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  TimeoutCoroutine.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  TimeoutCoroutine.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  TimeoutCoroutine.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  TimeoutCoroutine.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  TimeoutCoroutine.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  Unconfined.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  Unconfined.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  Unconfined.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  Unconfined.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  Receive.prototype.tryResumeReceive_c24eu3_k$ = ReceiveOrClosed.prototype.tryResumeReceive_c24eu3_k$;
  Receive.prototype.completeResumeReceive_jxzaet_k$ = ReceiveOrClosed.prototype.completeResumeReceive_jxzaet_k$;
  AbstractSendChannel.prototype.close$default_xa3v0r_k$ = SendChannel.prototype.close$default_xa3v0r_k$;
  AbstractChannel.prototype.close$default_xa3v0r_k$ = SendChannel.prototype.close$default_xa3v0r_k$;
  ArrayChannel.prototype.close$default_xa3v0r_k$ = SendChannel.prototype.close$default_xa3v0r_k$;
  ChannelCoroutine.prototype.close$default_xa3v0r_k$ = SendChannel.prototype.close$default_xa3v0r_k$;
  ChannelCoroutine.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  ChannelCoroutine.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  ChannelCoroutine.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  ChannelCoroutine.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  ChannelCoroutine.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  ChannelCoroutine.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  ConflatedChannel.prototype.close$default_xa3v0r_k$ = SendChannel.prototype.close$default_xa3v0r_k$;
  LinkedListChannel.prototype.close$default_xa3v0r_k$ = SendChannel.prototype.close$default_xa3v0r_k$;
  ProducerCoroutine.prototype.close$default_xa3v0r_k$ = SendChannel.prototype.close$default_xa3v0r_k$;
  ProducerCoroutine.prototype.cancel$default_44too_k$ = Job.prototype.cancel$default_44too_k$;
  ProducerCoroutine.prototype.invokeOnCompletion$default_n4h7x8_k$ = Job.prototype.invokeOnCompletion$default_n4h7x8_k$;
  ProducerCoroutine.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  ProducerCoroutine.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  ProducerCoroutine.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  ProducerCoroutine.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  RendezvousChannel.prototype.close$default_xa3v0r_k$ = SendChannel.prototype.close$default_xa3v0r_k$;
  JsMainDispatcher.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  JsMainDispatcher.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  JsMainDispatcher.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  JsMainDispatcher.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  UnconfinedEventLoop.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  UnconfinedEventLoop.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  UnconfinedEventLoop.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  UnconfinedEventLoop.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  SetTimeoutBasedDispatcher.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  SetTimeoutBasedDispatcher.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  SetTimeoutBasedDispatcher.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  SetTimeoutBasedDispatcher.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  NodeDispatcher.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  NodeDispatcher.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  NodeDispatcher.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  NodeDispatcher.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  SetTimeoutDispatcher.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  SetTimeoutDispatcher.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  SetTimeoutDispatcher.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  SetTimeoutDispatcher.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  WindowDispatcher.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  WindowDispatcher.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  WindowDispatcher.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  WindowDispatcher.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  AsyncByteArrayDeque.prototype.write$default_ffc7am_k$ = AsyncOutputStream.prototype.write$default_ffc7am_k$;
  AsyncByteArrayDeque.prototype.write_majfzk_k$ = AsyncOutputStream.prototype.write_majfzk_k$;
  AsyncByteArrayDeque.prototype.read_0_k$ = AsyncInputStream.prototype.read_0_k$;
  _no_name_provided__133.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  _no_name_provided__133.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  _no_name_provided__133.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  _no_name_provided__133.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  _no_name_provided__133.prototype.releaseInterceptedContinuation_h7c6yl_k$ = ContinuationInterceptor.prototype.releaseInterceptedContinuation_h7c6yl_k$;
  _no_name_provided__133.prototype.invokeOnTimeout_x8mf2g_k$ = Delay.prototype.invokeOnTimeout_x8mf2g_k$;
  _no_name_provided__140.prototype.write$default_ffc7am_k$ = AsyncOutputStream.prototype.write$default_ffc7am_k$;
  _no_name_provided__143.prototype.write$default_ffc7am_k$ = AsyncOutputStream.prototype.write$default_ffc7am_k$;
  _no_name_provided__143.prototype.write_majfzk_k$ = AsyncOutputStream.prototype.write_majfzk_k$;
  BitReader.prototype.read_0_k$ = AsyncInputStream.prototype.read_0_k$;
  BitReader.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  AsyncStreamBase.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  _no_name_provided__163.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  _no_name_provided__167.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  AsyncStream.prototype.write$default_ffc7am_k$ = AsyncOutputStream.prototype.write$default_ffc7am_k$;
  AsyncStream.prototype.read_0_k$ = AsyncInputStream.prototype.read_0_k$;
  AsyncStream.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  AsyncStream.prototype.write_majfzk_k$ = AsyncOutputStream.prototype.write_majfzk_k$;
  BufferedStreamBase.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  MemoryAsyncStreamBase.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  SyncAsyncStreamBase.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  SliceAsyncStreamBase.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  _no_name_provided__194.prototype.write$default_ffc7am_k$ = AsyncOutputStream.prototype.write$default_ffc7am_k$;
  _no_name_provided__198.prototype.read_0_k$ = AsyncInputStream.prototype.read_0_k$;
  _no_name_provided__198.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  _no_name_provided__199.prototype.write$default_ffc7am_k$ = AsyncOutputStream.prototype.write$default_ffc7am_k$;
  _no_name_provided__199.prototype.write_majfzk_k$ = AsyncOutputStream.prototype.write_majfzk_k$;
  _no_name_provided__200.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  _no_name_provided__201.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  SyncStream.prototype.read$default_82dsjl_k$ = SyncInputStream.prototype.read$default_82dsjl_k$;
  Adler32.prototype.update$default_esd280_k$ = SimpleChecksum.prototype.update$default_esd280_k$;
  CRC32.prototype.update$default_esd280_k$ = SimpleChecksum.prototype.update$default_esd280_k$;
  BlobAsyncBaseStream.prototype.hasLength_0_k$ = AsyncGetLengthStream.prototype.hasLength_0_k$;
  BmpSlice.prototype._set_extra__n1onou_k$ = Extra.prototype._set_extra__n1onou_k$;
  BmpSlice.prototype._get_extra__0_k$ = Extra.prototype._get_extra__0_k$;
  ColorFormat32.prototype.getR_ha5a7z_k$ = ColorFormat.prototype.getR_ha5a7z_k$;
  ColorFormat32.prototype.getG_ha5a7z_k$ = ColorFormat.prototype.getG_ha5a7z_k$;
  ColorFormat32.prototype.getB_ha5a7z_k$ = ColorFormat.prototype.getB_ha5a7z_k$;
  ColorFormat32.prototype.getA_ha5a7z_k$ = ColorFormat.prototype.getA_ha5a7z_k$;
  ColorFormat32.prototype.pack_w0xdj4_k$ = ColorFormat.prototype.pack_w0xdj4_k$;
  ColorFormat24.prototype.getR_ha5a7z_k$ = ColorFormat.prototype.getR_ha5a7z_k$;
  ColorFormat24.prototype.getG_ha5a7z_k$ = ColorFormat.prototype.getG_ha5a7z_k$;
  ColorFormat24.prototype.getB_ha5a7z_k$ = ColorFormat.prototype.getB_ha5a7z_k$;
  ColorFormat24.prototype.getA_ha5a7z_k$ = ColorFormat.prototype.getA_ha5a7z_k$;
  ColorFormat24.prototype.pack_w0xdj4_k$ = ColorFormat.prototype.pack_w0xdj4_k$;
  BitmapFont.prototype.getFontMetrics$default_2k781i_k$ = Font.prototype.getFontMetrics$default_2k781i_k$;
  BitmapFont.prototype.getGlyphMetrics$default_vit8xo_k$ = Font.prototype.getGlyphMetrics$default_vit8xo_k$;
  SystemFont.prototype.getFontMetrics$default_2k781i_k$ = Font.prototype.getFontMetrics$default_2k781i_k$;
  SystemFont.prototype.getGlyphMetrics$default_vit8xo_k$ = Font.prototype.getGlyphMetrics$default_vit8xo_k$;
  SystemFont.prototype.getGlyphPath$default_pwme3u_k$ = VectorFont.prototype.getGlyphPath$default_pwme3u_k$;
  SystemFont.prototype.renderGlyph_its5jl_k$ = VectorFont.prototype.renderGlyph_its5jl_k$;
  SystemFont.prototype.getOrNull_0_k$ = Font.prototype.getOrNull_0_k$;
  TtfFont.prototype.getFontMetrics$default_2k781i_k$ = Font.prototype.getFontMetrics$default_2k781i_k$;
  TtfFont.prototype.getGlyphMetrics$default_vit8xo_k$ = Font.prototype.getGlyphMetrics$default_vit8xo_k$;
  TtfFont.prototype.getGlyphPath$default_pwme3u_k$ = VectorFont.prototype.getGlyphPath$default_pwme3u_k$;
  TtfFont.prototype.renderGlyph_its5jl_k$ = VectorFont.prototype.renderGlyph_its5jl_k$;
  TtfFont.prototype.getOrNull_0_k$ = Font.prototype.getOrNull_0_k$;
  _no_name_provided__275.prototype.invoke_q7g7zr_k$ = TextRenderer.prototype.invoke_q7g7zr_k$;
  FillShape.prototype.addBounds_j4ilx6_k$ = StyledShape.prototype.addBounds_j4ilx6_k$;
  FillShape.prototype.getPath_gwjbs_k$ = StyledShape.prototype.getPath_gwjbs_k$;
  FillShape.prototype.getPath$default_w786tn_k$ = Shape_0.prototype.getPath$default_w786tn_k$;
  FillShape.prototype.draw_h81jc_k$ = StyledShape.prototype.draw_h81jc_k$;
  FillShape.prototype._get_bounds__0_k$ = Shape_0.prototype._get_bounds__0_k$;
  FillShape.prototype._get_width__0_k$ = BoundsDrawable.prototype._get_width__0_k$;
  FillShape.prototype._get_height__0_k$ = BoundsDrawable.prototype._get_height__0_k$;
  CompoundShape.prototype.getPath$default_w786tn_k$ = Shape_0.prototype.getPath$default_w786tn_k$;
  CompoundShape.prototype._get_bounds__0_k$ = Shape_0.prototype._get_bounds__0_k$;
  CompoundShape.prototype._get_width__0_k$ = BoundsDrawable.prototype._get_width__0_k$;
  CompoundShape.prototype._get_height__0_k$ = BoundsDrawable.prototype._get_height__0_k$;
  PolylineShape.prototype.getPath_gwjbs_k$ = StyledShape.prototype.getPath_gwjbs_k$;
  PolylineShape.prototype.getPath$default_w786tn_k$ = Shape_0.prototype.getPath$default_w786tn_k$;
  PolylineShape.prototype.draw_h81jc_k$ = StyledShape.prototype.draw_h81jc_k$;
  PolylineShape.prototype._get_bounds__0_k$ = Shape_0.prototype._get_bounds__0_k$;
  PolylineShape.prototype._get_width__0_k$ = BoundsDrawable.prototype._get_width__0_k$;
  PolylineShape.prototype._get_height__0_k$ = BoundsDrawable.prototype._get_height__0_k$;
  TextShape.prototype._get_path__0_k$ = StyledShape.prototype._get_path__0_k$;
  TextShape.prototype.getPath_gwjbs_k$ = StyledShape.prototype.getPath_gwjbs_k$;
  TextShape.prototype.getPath$default_w786tn_k$ = Shape_0.prototype.getPath$default_w786tn_k$;
  TextShape.prototype.draw_h81jc_k$ = StyledShape.prototype.draw_h81jc_k$;
  TextShape.prototype._get_bounds__0_k$ = Shape_0.prototype._get_bounds__0_k$;
  TextShape.prototype._get_width__0_k$ = BoundsDrawable.prototype._get_width__0_k$;
  TextShape.prototype._get_height__0_k$ = BoundsDrawable.prototype._get_height__0_k$;
  KmlGl.prototype.activeTexture_majfzk_k$ = IKmlGl.prototype.activeTexture_majfzk_k$;
  KmlGl.prototype.attachShader_rvwcgf_k$ = IKmlGl.prototype.attachShader_rvwcgf_k$;
  KmlGl.prototype.bindBuffer_rvwcgf_k$ = IKmlGl.prototype.bindBuffer_rvwcgf_k$;
  KmlGl.prototype.bindFramebuffer_rvwcgf_k$ = IKmlGl.prototype.bindFramebuffer_rvwcgf_k$;
  KmlGl.prototype.bindRenderbuffer_rvwcgf_k$ = IKmlGl.prototype.bindRenderbuffer_rvwcgf_k$;
  KmlGl.prototype.bindTexture_rvwcgf_k$ = IKmlGl.prototype.bindTexture_rvwcgf_k$;
  KmlGl.prototype.blendEquationSeparate_rvwcgf_k$ = IKmlGl.prototype.blendEquationSeparate_rvwcgf_k$;
  KmlGl.prototype.blendFuncSeparate_jthg1_k$ = IKmlGl.prototype.blendFuncSeparate_jthg1_k$;
  KmlGl.prototype.bufferData_tov2rt_k$ = IKmlGl.prototype.bufferData_tov2rt_k$;
  KmlGl.prototype.clear_majfzk_k$ = IKmlGl.prototype.clear_majfzk_k$;
  KmlGl.prototype.clearColor_f95lpr_k$ = IKmlGl.prototype.clearColor_f95lpr_k$;
  KmlGl.prototype.clearDepthf_cpozfn_k$ = IKmlGl.prototype.clearDepthf_cpozfn_k$;
  KmlGl.prototype.clearStencil_majfzk_k$ = IKmlGl.prototype.clearStencil_majfzk_k$;
  KmlGl.prototype.colorMask_7d158x_k$ = IKmlGl.prototype.colorMask_7d158x_k$;
  KmlGl.prototype.compileShader_majfzk_k$ = IKmlGl.prototype.compileShader_majfzk_k$;
  KmlGl.prototype.createProgram_0_k$ = IKmlGl.prototype.createProgram_0_k$;
  KmlGl.prototype.createShader_ha5a7z_k$ = IKmlGl.prototype.createShader_ha5a7z_k$;
  KmlGl.prototype.deleteBuffers_9vfq5l_k$ = IKmlGl.prototype.deleteBuffers_9vfq5l_k$;
  KmlGl.prototype.deleteFramebuffers_9vfq5l_k$ = IKmlGl.prototype.deleteFramebuffers_9vfq5l_k$;
  KmlGl.prototype.deleteProgram_majfzk_k$ = IKmlGl.prototype.deleteProgram_majfzk_k$;
  KmlGl.prototype.deleteRenderbuffers_9vfq5l_k$ = IKmlGl.prototype.deleteRenderbuffers_9vfq5l_k$;
  KmlGl.prototype.deleteShader_majfzk_k$ = IKmlGl.prototype.deleteShader_majfzk_k$;
  KmlGl.prototype.deleteTextures_9vfq5l_k$ = IKmlGl.prototype.deleteTextures_9vfq5l_k$;
  KmlGl.prototype.depthFunc_majfzk_k$ = IKmlGl.prototype.depthFunc_majfzk_k$;
  KmlGl.prototype.depthMask_rpwsgn_k$ = IKmlGl.prototype.depthMask_rpwsgn_k$;
  KmlGl.prototype.depthRangef_c7v4pd_k$ = IKmlGl.prototype.depthRangef_c7v4pd_k$;
  KmlGl.prototype.disable_majfzk_k$ = IKmlGl.prototype.disable_majfzk_k$;
  KmlGl.prototype.disableVertexAttribArray_majfzk_k$ = IKmlGl.prototype.disableVertexAttribArray_majfzk_k$;
  KmlGl.prototype.drawArrays_zd700_k$ = IKmlGl.prototype.drawArrays_zd700_k$;
  KmlGl.prototype.drawElements_jthg1_k$ = IKmlGl.prototype.drawElements_jthg1_k$;
  KmlGl.prototype.enable_majfzk_k$ = IKmlGl.prototype.enable_majfzk_k$;
  KmlGl.prototype.enableVertexAttribArray_majfzk_k$ = IKmlGl.prototype.enableVertexAttribArray_majfzk_k$;
  KmlGl.prototype.framebufferRenderbuffer_jthg1_k$ = IKmlGl.prototype.framebufferRenderbuffer_jthg1_k$;
  KmlGl.prototype.framebufferTexture2D_s9wiz4_k$ = IKmlGl.prototype.framebufferTexture2D_s9wiz4_k$;
  KmlGl.prototype.frontFace_majfzk_k$ = IKmlGl.prototype.frontFace_majfzk_k$;
  KmlGl.prototype.genBuffers_9vfq5l_k$ = IKmlGl.prototype.genBuffers_9vfq5l_k$;
  KmlGl.prototype.generateMipmap_majfzk_k$ = IKmlGl.prototype.generateMipmap_majfzk_k$;
  KmlGl.prototype.genFramebuffers_9vfq5l_k$ = IKmlGl.prototype.genFramebuffers_9vfq5l_k$;
  KmlGl.prototype.genRenderbuffers_9vfq5l_k$ = IKmlGl.prototype.genRenderbuffers_9vfq5l_k$;
  KmlGl.prototype.genTextures_9vfq5l_k$ = IKmlGl.prototype.genTextures_9vfq5l_k$;
  KmlGl.prototype.getAttribLocation_4wk0sg_k$ = IKmlGl.prototype.getAttribLocation_4wk0sg_k$;
  KmlGl.prototype.getUniformLocation_4wk0sg_k$ = IKmlGl.prototype.getUniformLocation_4wk0sg_k$;
  KmlGl.prototype.getError_0_k$ = IKmlGl.prototype.getError_0_k$;
  KmlGl.prototype.getIntegerv_9vfq5l_k$ = IKmlGl.prototype.getIntegerv_9vfq5l_k$;
  KmlGl.prototype.getProgramiv_1a3fjs_k$ = IKmlGl.prototype.getProgramiv_1a3fjs_k$;
  KmlGl.prototype.getShaderiv_1a3fjs_k$ = IKmlGl.prototype.getShaderiv_1a3fjs_k$;
  KmlGl.prototype.getShaderInfoLog_su8xz3_k$ = IKmlGl.prototype.getShaderInfoLog_su8xz3_k$;
  KmlGl.prototype.getString_ha5a7z_k$ = IKmlGl.prototype.getString_ha5a7z_k$;
  KmlGl.prototype.lineWidth_cpozfn_k$ = IKmlGl.prototype.lineWidth_cpozfn_k$;
  KmlGl.prototype.linkProgram_majfzk_k$ = IKmlGl.prototype.linkProgram_majfzk_k$;
  KmlGl.prototype.pixelStorei_rvwcgf_k$ = IKmlGl.prototype.pixelStorei_rvwcgf_k$;
  KmlGl.prototype.renderbufferStorage_jthg1_k$ = IKmlGl.prototype.renderbufferStorage_jthg1_k$;
  KmlGl.prototype.scissor_jthg1_k$ = IKmlGl.prototype.scissor_jthg1_k$;
  KmlGl.prototype.shaderSource_iyywcx_k$ = IKmlGl.prototype.shaderSource_iyywcx_k$;
  KmlGl.prototype.stencilFunc_zd700_k$ = IKmlGl.prototype.stencilFunc_zd700_k$;
  KmlGl.prototype.stencilMask_majfzk_k$ = IKmlGl.prototype.stencilMask_majfzk_k$;
  KmlGl.prototype.stencilOp_zd700_k$ = IKmlGl.prototype.stencilOp_zd700_k$;
  KmlGl.prototype.texImage2D_p2mxp1_k$ = IKmlGl.prototype.texImage2D_p2mxp1_k$;
  KmlGl.prototype.texImage2D_4xnpxk_k$ = IKmlGl.prototype.texImage2D_4xnpxk_k$;
  KmlGl.prototype.texParameteri_zd700_k$ = IKmlGl.prototype.texParameteri_zd700_k$;
  KmlGl.prototype.uniform1f_z49mik_k$ = IKmlGl.prototype.uniform1f_z49mik_k$;
  KmlGl.prototype.uniform1fv_1a3fjs_k$ = IKmlGl.prototype.uniform1fv_1a3fjs_k$;
  KmlGl.prototype.uniform1i_rvwcgf_k$ = IKmlGl.prototype.uniform1i_rvwcgf_k$;
  KmlGl.prototype.uniform2f_gk2bzk_k$ = IKmlGl.prototype.uniform2f_gk2bzk_k$;
  KmlGl.prototype.uniform2fv_1a3fjs_k$ = IKmlGl.prototype.uniform2fv_1a3fjs_k$;
  KmlGl.prototype.uniform3f_tarz9g_k$ = IKmlGl.prototype.uniform3f_tarz9g_k$;
  KmlGl.prototype.uniform3fv_1a3fjs_k$ = IKmlGl.prototype.uniform3fv_1a3fjs_k$;
  KmlGl.prototype.uniform4f_g45f0w_k$ = IKmlGl.prototype.uniform4f_g45f0w_k$;
  KmlGl.prototype.uniform4fv_1a3fjs_k$ = IKmlGl.prototype.uniform4fv_1a3fjs_k$;
  KmlGl.prototype.uniformMatrix2fv_a0t79e_k$ = IKmlGl.prototype.uniformMatrix2fv_a0t79e_k$;
  KmlGl.prototype.uniformMatrix3fv_a0t79e_k$ = IKmlGl.prototype.uniformMatrix3fv_a0t79e_k$;
  KmlGl.prototype.uniformMatrix4fv_a0t79e_k$ = IKmlGl.prototype.uniformMatrix4fv_a0t79e_k$;
  KmlGl.prototype.useProgram_majfzk_k$ = IKmlGl.prototype.useProgram_majfzk_k$;
  KmlGl.prototype.vertexAttribPointer_5h0f29_k$ = IKmlGl.prototype.vertexAttribPointer_5h0f29_k$;
  KmlGl.prototype.viewport_jthg1_k$ = IKmlGl.prototype.viewport_jthg1_k$;
  KmlGl.prototype.enableDisable_hwwcoo_k$ = IKmlGl.prototype.enableDisable_hwwcoo_k$;
  KmlGl.prototype.drawArraysInstanced_jthg1_k$ = IKmlGl.prototype.drawArraysInstanced_jthg1_k$;
  KmlGl.prototype.drawElementsInstanced_s9wiz4_k$ = IKmlGl.prototype.drawElementsInstanced_s9wiz4_k$;
  KmlGl.prototype.vertexAttribDivisor_rvwcgf_k$ = IKmlGl.prototype.vertexAttribDivisor_rvwcgf_k$;
  KmlGlWithExtensions.prototype.activeTexture_majfzk_k$ = IKmlGl.prototype.activeTexture_majfzk_k$;
  KmlGlWithExtensions.prototype.attachShader_rvwcgf_k$ = IKmlGl.prototype.attachShader_rvwcgf_k$;
  KmlGlWithExtensions.prototype.bindBuffer_rvwcgf_k$ = IKmlGl.prototype.bindBuffer_rvwcgf_k$;
  KmlGlWithExtensions.prototype.bindFramebuffer_rvwcgf_k$ = IKmlGl.prototype.bindFramebuffer_rvwcgf_k$;
  KmlGlWithExtensions.prototype.bindRenderbuffer_rvwcgf_k$ = IKmlGl.prototype.bindRenderbuffer_rvwcgf_k$;
  KmlGlWithExtensions.prototype.bindTexture_rvwcgf_k$ = IKmlGl.prototype.bindTexture_rvwcgf_k$;
  KmlGlWithExtensions.prototype.blendEquationSeparate_rvwcgf_k$ = IKmlGl.prototype.blendEquationSeparate_rvwcgf_k$;
  KmlGlWithExtensions.prototype.blendFuncSeparate_jthg1_k$ = IKmlGl.prototype.blendFuncSeparate_jthg1_k$;
  KmlGlWithExtensions.prototype.bufferData_tov2rt_k$ = IKmlGl.prototype.bufferData_tov2rt_k$;
  KmlGlWithExtensions.prototype.clear_majfzk_k$ = IKmlGl.prototype.clear_majfzk_k$;
  KmlGlWithExtensions.prototype.clearColor_f95lpr_k$ = IKmlGl.prototype.clearColor_f95lpr_k$;
  KmlGlWithExtensions.prototype.clearDepthf_cpozfn_k$ = IKmlGl.prototype.clearDepthf_cpozfn_k$;
  KmlGlWithExtensions.prototype.clearStencil_majfzk_k$ = IKmlGl.prototype.clearStencil_majfzk_k$;
  KmlGlWithExtensions.prototype.colorMask_7d158x_k$ = IKmlGl.prototype.colorMask_7d158x_k$;
  KmlGlWithExtensions.prototype.compileShader_majfzk_k$ = IKmlGl.prototype.compileShader_majfzk_k$;
  KmlGlWithExtensions.prototype.createProgram_0_k$ = IKmlGl.prototype.createProgram_0_k$;
  KmlGlWithExtensions.prototype.createShader_ha5a7z_k$ = IKmlGl.prototype.createShader_ha5a7z_k$;
  KmlGlWithExtensions.prototype.deleteBuffers_9vfq5l_k$ = IKmlGl.prototype.deleteBuffers_9vfq5l_k$;
  KmlGlWithExtensions.prototype.deleteFramebuffers_9vfq5l_k$ = IKmlGl.prototype.deleteFramebuffers_9vfq5l_k$;
  KmlGlWithExtensions.prototype.deleteProgram_majfzk_k$ = IKmlGl.prototype.deleteProgram_majfzk_k$;
  KmlGlWithExtensions.prototype.deleteRenderbuffers_9vfq5l_k$ = IKmlGl.prototype.deleteRenderbuffers_9vfq5l_k$;
  KmlGlWithExtensions.prototype.deleteShader_majfzk_k$ = IKmlGl.prototype.deleteShader_majfzk_k$;
  KmlGlWithExtensions.prototype.deleteTextures_9vfq5l_k$ = IKmlGl.prototype.deleteTextures_9vfq5l_k$;
  KmlGlWithExtensions.prototype.depthFunc_majfzk_k$ = IKmlGl.prototype.depthFunc_majfzk_k$;
  KmlGlWithExtensions.prototype.depthMask_rpwsgn_k$ = IKmlGl.prototype.depthMask_rpwsgn_k$;
  KmlGlWithExtensions.prototype.depthRangef_c7v4pd_k$ = IKmlGl.prototype.depthRangef_c7v4pd_k$;
  KmlGlWithExtensions.prototype.disable_majfzk_k$ = IKmlGl.prototype.disable_majfzk_k$;
  KmlGlWithExtensions.prototype.disableVertexAttribArray_majfzk_k$ = IKmlGl.prototype.disableVertexAttribArray_majfzk_k$;
  KmlGlWithExtensions.prototype.drawArrays_zd700_k$ = IKmlGl.prototype.drawArrays_zd700_k$;
  KmlGlWithExtensions.prototype.drawElements_jthg1_k$ = IKmlGl.prototype.drawElements_jthg1_k$;
  KmlGlWithExtensions.prototype.enable_majfzk_k$ = IKmlGl.prototype.enable_majfzk_k$;
  KmlGlWithExtensions.prototype.enableVertexAttribArray_majfzk_k$ = IKmlGl.prototype.enableVertexAttribArray_majfzk_k$;
  KmlGlWithExtensions.prototype.framebufferRenderbuffer_jthg1_k$ = IKmlGl.prototype.framebufferRenderbuffer_jthg1_k$;
  KmlGlWithExtensions.prototype.framebufferTexture2D_s9wiz4_k$ = IKmlGl.prototype.framebufferTexture2D_s9wiz4_k$;
  KmlGlWithExtensions.prototype.frontFace_majfzk_k$ = IKmlGl.prototype.frontFace_majfzk_k$;
  KmlGlWithExtensions.prototype.genBuffers_9vfq5l_k$ = IKmlGl.prototype.genBuffers_9vfq5l_k$;
  KmlGlWithExtensions.prototype.generateMipmap_majfzk_k$ = IKmlGl.prototype.generateMipmap_majfzk_k$;
  KmlGlWithExtensions.prototype.genFramebuffers_9vfq5l_k$ = IKmlGl.prototype.genFramebuffers_9vfq5l_k$;
  KmlGlWithExtensions.prototype.genRenderbuffers_9vfq5l_k$ = IKmlGl.prototype.genRenderbuffers_9vfq5l_k$;
  KmlGlWithExtensions.prototype.genTextures_9vfq5l_k$ = IKmlGl.prototype.genTextures_9vfq5l_k$;
  KmlGlWithExtensions.prototype.getAttribLocation_4wk0sg_k$ = IKmlGl.prototype.getAttribLocation_4wk0sg_k$;
  KmlGlWithExtensions.prototype.getUniformLocation_4wk0sg_k$ = IKmlGl.prototype.getUniformLocation_4wk0sg_k$;
  KmlGlWithExtensions.prototype.getError_0_k$ = IKmlGl.prototype.getError_0_k$;
  KmlGlWithExtensions.prototype.getIntegerv_9vfq5l_k$ = IKmlGl.prototype.getIntegerv_9vfq5l_k$;
  KmlGlWithExtensions.prototype.getProgramiv_1a3fjs_k$ = IKmlGl.prototype.getProgramiv_1a3fjs_k$;
  KmlGlWithExtensions.prototype.getShaderiv_1a3fjs_k$ = IKmlGl.prototype.getShaderiv_1a3fjs_k$;
  KmlGlWithExtensions.prototype.getShaderInfoLog_su8xz3_k$ = IKmlGl.prototype.getShaderInfoLog_su8xz3_k$;
  KmlGlWithExtensions.prototype.getString_ha5a7z_k$ = IKmlGl.prototype.getString_ha5a7z_k$;
  KmlGlWithExtensions.prototype.lineWidth_cpozfn_k$ = IKmlGl.prototype.lineWidth_cpozfn_k$;
  KmlGlWithExtensions.prototype.linkProgram_majfzk_k$ = IKmlGl.prototype.linkProgram_majfzk_k$;
  KmlGlWithExtensions.prototype.pixelStorei_rvwcgf_k$ = IKmlGl.prototype.pixelStorei_rvwcgf_k$;
  KmlGlWithExtensions.prototype.renderbufferStorage_jthg1_k$ = IKmlGl.prototype.renderbufferStorage_jthg1_k$;
  KmlGlWithExtensions.prototype.scissor_jthg1_k$ = IKmlGl.prototype.scissor_jthg1_k$;
  KmlGlWithExtensions.prototype.shaderSource_iyywcx_k$ = IKmlGl.prototype.shaderSource_iyywcx_k$;
  KmlGlWithExtensions.prototype.stencilFunc_zd700_k$ = IKmlGl.prototype.stencilFunc_zd700_k$;
  KmlGlWithExtensions.prototype.stencilMask_majfzk_k$ = IKmlGl.prototype.stencilMask_majfzk_k$;
  KmlGlWithExtensions.prototype.stencilOp_zd700_k$ = IKmlGl.prototype.stencilOp_zd700_k$;
  KmlGlWithExtensions.prototype.texImage2D_p2mxp1_k$ = IKmlGl.prototype.texImage2D_p2mxp1_k$;
  KmlGlWithExtensions.prototype.texImage2D_4xnpxk_k$ = IKmlGl.prototype.texImage2D_4xnpxk_k$;
  KmlGlWithExtensions.prototype.texParameteri_zd700_k$ = IKmlGl.prototype.texParameteri_zd700_k$;
  KmlGlWithExtensions.prototype.uniform1f_z49mik_k$ = IKmlGl.prototype.uniform1f_z49mik_k$;
  KmlGlWithExtensions.prototype.uniform1fv_1a3fjs_k$ = IKmlGl.prototype.uniform1fv_1a3fjs_k$;
  KmlGlWithExtensions.prototype.uniform1i_rvwcgf_k$ = IKmlGl.prototype.uniform1i_rvwcgf_k$;
  KmlGlWithExtensions.prototype.uniform2f_gk2bzk_k$ = IKmlGl.prototype.uniform2f_gk2bzk_k$;
  KmlGlWithExtensions.prototype.uniform2fv_1a3fjs_k$ = IKmlGl.prototype.uniform2fv_1a3fjs_k$;
  KmlGlWithExtensions.prototype.uniform3f_tarz9g_k$ = IKmlGl.prototype.uniform3f_tarz9g_k$;
  KmlGlWithExtensions.prototype.uniform3fv_1a3fjs_k$ = IKmlGl.prototype.uniform3fv_1a3fjs_k$;
  KmlGlWithExtensions.prototype.uniform4f_g45f0w_k$ = IKmlGl.prototype.uniform4f_g45f0w_k$;
  KmlGlWithExtensions.prototype.uniform4fv_1a3fjs_k$ = IKmlGl.prototype.uniform4fv_1a3fjs_k$;
  KmlGlWithExtensions.prototype.uniformMatrix2fv_a0t79e_k$ = IKmlGl.prototype.uniformMatrix2fv_a0t79e_k$;
  KmlGlWithExtensions.prototype.uniformMatrix3fv_a0t79e_k$ = IKmlGl.prototype.uniformMatrix3fv_a0t79e_k$;
  KmlGlWithExtensions.prototype.uniformMatrix4fv_a0t79e_k$ = IKmlGl.prototype.uniformMatrix4fv_a0t79e_k$;
  KmlGlWithExtensions.prototype.useProgram_majfzk_k$ = IKmlGl.prototype.useProgram_majfzk_k$;
  KmlGlWithExtensions.prototype.vertexAttribPointer_5h0f29_k$ = IKmlGl.prototype.vertexAttribPointer_5h0f29_k$;
  KmlGlWithExtensions.prototype.viewport_jthg1_k$ = IKmlGl.prototype.viewport_jthg1_k$;
  KmlGlWithExtensions.prototype.enableDisable_hwwcoo_k$ = IKmlGl.prototype.enableDisable_hwwcoo_k$;
  KmlGlWithExtensions.prototype.drawArraysInstanced_jthg1_k$ = IKmlGl.prototype.drawArraysInstanced_jthg1_k$;
  KmlGlWithExtensions.prototype.drawElementsInstanced_s9wiz4_k$ = IKmlGl.prototype.drawElementsInstanced_s9wiz4_k$;
  KmlGlWithExtensions.prototype.vertexAttribDivisor_rvwcgf_k$ = IKmlGl.prototype.vertexAttribDivisor_rvwcgf_k$;
  BaseRenderBufferImpl.prototype.setSize$default_e5nmz5_k$ = BaseRenderBuffer.prototype.setSize$default_e5nmz5_k$;
  BaseRenderBufferImpl.prototype.init_sv8swh_k$ = BaseRenderBuffer.prototype.init_sv8swh_k$;
  BaseRenderBufferImpl.prototype.set_sv8swh_k$ = BaseRenderBuffer.prototype.set_sv8swh_k$;
  BaseRenderBufferImpl.prototype.unset_sv8swh_k$ = BaseRenderBuffer.prototype.unset_sv8swh_k$;
  RenderBuffer.prototype.setSize$default_e5nmz5_k$ = BaseRenderBuffer.prototype.setSize$default_e5nmz5_k$;
  RenderBuffer.prototype.init_sv8swh_k$ = BaseRenderBuffer.prototype.init_sv8swh_k$;
  RenderBuffer.prototype.unset_sv8swh_k$ = BaseRenderBuffer.prototype.unset_sv8swh_k$;
  GlRenderBuffer.prototype.setSize$default_e5nmz5_k$ = BaseRenderBuffer.prototype.setSize$default_e5nmz5_k$;
  GlRenderBuffer.prototype.init_sv8swh_k$ = BaseRenderBuffer.prototype.init_sv8swh_k$;
  GlRenderBuffer.prototype.unset_sv8swh_k$ = BaseRenderBuffer.prototype.unset_sv8swh_k$;
  _no_name_provided__313.prototype.setSize$default_e5nmz5_k$ = BaseRenderBuffer.prototype.setSize$default_e5nmz5_k$;
  LogRenderBuffer.prototype.setSize$default_e5nmz5_k$ = BaseRenderBuffer.prototype.setSize$default_e5nmz5_k$;
  LogRenderBuffer.prototype.init_sv8swh_k$ = BaseRenderBuffer.prototype.init_sv8swh_k$;
  LogRenderBuffer.prototype.unset_sv8swh_k$ = BaseRenderBuffer.prototype.unset_sv8swh_k$;
  GameWindow.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  GameWindow.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  GameWindow.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  GameWindow.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  GameWindowCoroutineDispatcher.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  GameWindowCoroutineDispatcher.prototype.get_9uvjra_k$ = ContinuationInterceptor.prototype.get_9uvjra_k$;
  GameWindowCoroutineDispatcher.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  GameWindowCoroutineDispatcher.prototype.minusKey_djuxjq_k$ = ContinuationInterceptor.prototype.minusKey_djuxjq_k$;
  KmlGlJsCanvas.prototype.enableDisable_hwwcoo_k$ = IKmlGl.prototype.enableDisable_hwwcoo_k$;
  NodeJsGameWindow.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  NodeJsGameWindow.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  NodeJsGameWindow.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  NodeJsGameWindow.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  BrowserGameWindow.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  BrowserGameWindow.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  BrowserGameWindow.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  BrowserGameWindow.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  AsyncInjectorContext.prototype.get_9uvjra_k$ = Element_0.prototype.get_9uvjra_k$;
  AsyncInjectorContext.prototype.fold_cq605b_k$ = Element_0.prototype.fold_cq605b_k$;
  AsyncInjectorContext.prototype.minusKey_djuxjq_k$ = Element_0.prototype.minusKey_djuxjq_k$;
  AsyncInjectorContext.prototype.plus_d7pszg_k$ = CoroutineContext.prototype.plus_d7pszg_k$;
  ParticleEmitterView.prototype.forceLoadSourceFile$default_nkqr3g_k$ = ViewFileRef.prototype.forceLoadSourceFile$default_nkqr3g_k$;
  _no_name_provided__507.prototype.start_rqulwx_k$ = TransitionProcess.prototype.start_rqulwx_k$;
  _no_name_provided__507.prototype.end_rqulwx_k$ = TransitionProcess.prototype.end_rqulwx_k$;
  _no_name_provided__513.prototype.start_rqulwx_k$ = TransitionProcess.prototype.start_rqulwx_k$;
  _no_name_provided__513.prototype.end_rqulwx_k$ = TransitionProcess.prototype.end_rqulwx_k$;
  TiledMapViewRef.prototype.forceLoadSourceFile$default_nkqr3g_k$ = ViewFileRef.prototype.forceLoadSourceFile$default_nkqr3g_k$;
  AnimationViewRef.prototype.forceLoadSourceFile$default_nkqr3g_k$ = ViewFileRef.prototype.forceLoadSourceFile$default_nkqr3g_k$;
  Image_1.prototype.forceLoadSourceFile$default_nkqr3g_k$ = ViewFileRef.prototype.forceLoadSourceFile$default_nkqr3g_k$;
  NinePatchEx.prototype.forceLoadSourceFile$default_nkqr3g_k$ = ViewFileRef.prototype.forceLoadSourceFile$default_nkqr3g_k$;
  TreeViewRef.prototype.forceLoadSourceFile$default_nkqr3g_k$ = ViewFileRef.prototype.forceLoadSourceFile$default_nkqr3g_k$;
  VectorImage.prototype.forceLoadSourceFile$default_nkqr3g_k$ = ViewFileRef.prototype.forceLoadSourceFile$default_nkqr3g_k$;
  Mixin_3.prototype.forceLoadSourceFile$default_nkqr3g_k$ = ViewFileRef.prototype.forceLoadSourceFile$default_nkqr3g_k$;
  _stableSortingIsSupported = null;
  output = output$init$();
  EmptyContinuation = EmptyContinuation$init$();
  INV_2_26 = INV_2_26$init$();
  INV_2_53 = INV_2_53$init$();
  functionClasses = functionClasses$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufFloat32 = bufFloat32$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  propertyRefClassMetadataCache = propertyRefClassMetadataCache$init$();
  CONCURRENCY_COUNT = 1;
  tempMat3D = new Matrix3D();
  tempVec1 = new Vector3D();
  tempVec2 = new Vector3D();
  tempVec3 = new Vector3D();
  tempMat1 = new Matrix3D();
  tempMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  identityMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  _FAST_ABS = true;
  _FAST_FLOOR = true;
  _FAST_CEIL = true;
  _FAST_ROUND = false;
  _FAST_ATAN2 = true;
  _FAST_POW = true;
  _CONTACT_STACK_INIT_SIZE = 10;
  _SINCOS_LUT_ENABLED = true;
  _SINCOS_LUT_LERP = false;
  _maxManifoldPoints = 2;
  _maxPolygonVertices = 8;
  _aabbExtension = 0.1;
  _aabbMultiplier = 2.0;
  _linearSlop = 0.005;
  _angularSlop = 2.0 / 180.0 * Settings_getInstance()._PI_0;
  _polygonRadius = 2.0 * _linearSlop;
  _maxSubSteps = 8;
  _maxTOIContacts = 32;
  _velocityThreshold = 1.0;
  _maxLinearCorrection = 0.2;
  _maxAngularCorrection = 8.0 / 180.0 * Settings_getInstance()._PI_0;
  _maxTranslation = 2.0;
  _maxTranslationSquared = _maxTranslation * _maxTranslation;
  _maxRotation = 0.5 * Settings_getInstance()._PI_0;
  _maxRotationSquared = _maxRotation * _maxRotation;
  _baumgarte = 0.2;
  _toiBaugarte = 0.75;
  _timeToSleep = 0.5;
  _linearSleepTolerance = 0.01;
  _angularSleepTolerance = 2.0 / 180.0 * Settings_getInstance()._PI_0;
  __dummy = Vec2_init_$Create$(0.0, 0.0, 3, null);
  KlockLocale_default = Companion_getInstance_85();
  ExtendedTimezoneNames = ExtendedTimezoneNames$init$();
  klockIsKotlinNative = false;
  isNode = typeof window === 'undefined';
  initialHrTime$delegate = klockAtomicLazy(_no_name_provided_$factory_88());
  KmemGC = KmemGC$init$();
  EmptyByteArray = new Int8Array(1);
  EmptyShortArray = new Int16Array(1);
  EmptyIntArray = new Int32Array(1);
  EmptyFloatArray = new Float32Array(1);
  randomUnittesting = false;
  isNodeJs$delegate = lazy(_no_name_provided_$factory_89());
  _global = typeof global !== 'undefined' ? global : self;
  isNative = false;
  RESUME_TOKEN = new Symbol('RESUME_TOKEN');
  COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
  COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
  COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
  TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
  SEALED = new Symbol('SEALED');
  EMPTY_NEW = new Empty_0(false);
  EMPTY_ACTIVE = new Empty_0(true);
  EMPTY = new Symbol('EMPTY');
  OFFER_SUCCESS = new Symbol('OFFER_SUCCESS');
  OFFER_FAILED = new Symbol('OFFER_FAILED');
  POLL_FAILED = new Symbol('POLL_FAILED');
  ENQUEUE_FAILED = new Symbol('ENQUEUE_FAILED');
  HANDLER_INVOKED = new Symbol('ON_CLOSE_HANDLER_INVOKED');
  UNDEFINED = new Symbol('UNDEFINED');
  REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
  counter = 0;
  DEBUG = false;
  DEFAULT_SUSPEND_TEST_TIMEOUT = DEFAULT_SUSPEND_TEST_TIMEOUT$init$();
  Deflate$delegate = lazy(_no_name_provided_$factory_111());
  defaultDynApi = DynamicInternal_getInstance();
  dynApi = DynamicInternal_getInstance();
  Mapper = new ObjectMapper();
  resourcesVfsDebug = false;
  defaultUniSchema = defaultUniSchema$init$();
  bytesTempPool$delegate = new threadLocal(_no_name_provided_$factory_139());
  smallBytesPool$delegate = new threadLocal(_no_name_provided_$factory_140());
  LATIN1 = ISO_8859_1_getInstance();
  UTF16_LE = new UTF16Charset(true);
  UTF16_BE = new UTF16Charset(false);
  customEnvironments = null;
  formatRegex = Regex_init_$Create$('%([-]?\\d+)?(\\w)');
  replaceNonPrintableCharactersRegex$delegate = lazy(_no_name_provided_$factory_143());
  MimeType_byExtensions$delegate = lazy(_no_name_provided_$factory_144());
  _defaultHttpFactory$delegate = lazy(_no_name_provided_$factory_149());
  EMPTY_BYTE_ARRAY = new Int8Array(0);
  traceTimes$delegate = lazy(_no_name_provided_$factory_159());
  LONG_ZERO_TO_MAX_RANGE = LONG_ZERO_TO_MAX_RANGE$init$();
  Language_CURRENT$delegate = lazy(_no_name_provided_$factory_170());
  jsLocalStorageVfs$delegate = lazy(_no_name_provided_$factory_173());
  jsbaseUrl$delegate = lazy(_no_name_provided_$factory_174());
  globalDynamic = typeof global !== 'undefined' ? global : self;
  global = globalDynamic;
  isWeb$delegate = lazy(_no_name_provided_$factory_175());
  isWorker$delegate = lazy(_no_name_provided_$factory_176());
  isNodeJs$delegate_0 = lazy(_no_name_provided_$factory_177());
  File_separatorChar = new Char(47);
  tmpdir$delegate = lazy(_no_name_provided_$factory_180());
  absoluteCwd$delegate = lazy(_no_name_provided_$factory_181());
  resourcesVfs$delegate = lazy(_no_name_provided_$factory_182());
  rootLocalVfs$delegate = lazy(_no_name_provided_$factory_183());
  applicationVfs$delegate = lazy(_no_name_provided_$factory_184());
  applicationDataVfs$delegate = lazy(_no_name_provided_$factory_185());
  cacheVfs$delegate = lazy(_no_name_provided_$factory_186());
  externalStorageVfs$delegate = lazy(_no_name_provided_$factory_187());
  userHomeVfs$delegate = lazy(_no_name_provided_$factory_188());
  tempVfs$delegate = lazy(_no_name_provided_$factory_189());
  UTF8 = UTF8$init$();
  asyncSocketFactory$delegate = lazy(_no_name_provided_$factory_190());
  httpFactory$delegate = lazy(_no_name_provided_$factory_191());
  rawOsName$delegate = lazy(_no_name_provided_$factory_195());
  rawPlatformName = rawPlatformName$init$();
  systemLanguageStrings$delegate = lazy(_no_name_provided_$factory_196());
  Bitmaps_transparent = Bitmaps_transparent$init$();
  Bitmaps_white = Bitmaps_white$init$();
  ColorAdd_NEUTRAL = _ColorAdd___init__impl_(2139062143);
  DefaultTtfFontBytes = DefaultTtfFontBytes$init$();
  DefaultTtfFont$delegate = lazy(_no_name_provided_$factory_211());
  linuxFolders = listOf(['/usr/share/fonts', '/usr/local/share/fonts', '~/.fonts']);
  windowsFolders = listOf(['%WINDIR%\\Fonts', '%LOCALAPPDATA%\\Microsoft\\Windows\\Fonts']);
  macosFolders = listOf(['/System/Library/Fonts/', '/Library/Fonts/', '~/Library/Fonts/', '/Network/Library/Fonts/']);
  iosFolders = listOf(['/System/Library/Fonts/Cache', '/System/Library/Fonts']);
  androidFolders = listOf(['/system/Fonts', '/system/font', '/data/fonts']);
  emojiFontNames = listOf(['Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji']);
  fourcc$delegate = Property_init_$Create$(null, _no_name_provided_$factory_215(), 1, null);
  kritaLoadLayers$delegate = kritaLoadLayers$delegate$init$();
  kritaPartialImageLayers$delegate = kritaPartialImageLayers$delegate$init$();
  nativeImageLoadingEnabled = true;
  RegisteredImageFormats_formats = ImageFormats_init_$Create$([BMP_getInstance(), TGA_getInstance()]);
  DefaultStringTextRenderer = CreateStringTextRenderer$default(null, _no_name_provided_$factory_224(), 1, null);
  nativeSystemFontProvider = new FallbackNativeSystemFontProvider(_get_DefaultTtfFont_());
  nativeImageFormatProvider = nativeImageFormatProvider$init$();
  tempB = new ArrayBuffer(4);
  tempI = new Int32Array(tempB);
  temp8 = new Uint8Array(tempB);
  isLittleEndian$delegate = lazy(_no_name_provided_$factory_234());
  versionString$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_262(), 1, null);
  versionInt$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_263(), 1, null);
  GLOBAL_CHECK_GL = false;
  korgwJvmEngine = null;
  uiComponent$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_283(), 1, null);
  layoutChildrenPadding$delegate = Property_init_$Create$(null, _no_name_provided_$factory_284(), 1, null);
  DEFAULT_WIDTH = new PT(128.0);
  DEFAULT_HEIGHT = new PT(32.0);
  preferredSize$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_285(), 1, null);
  minimumSize$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_286(), 1, null);
  maximumSize$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_287(), 1, null);
  reactUid$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_288(), 1, null);
  korgwCanvasQuery$delegate = lazy(_no_name_provided_$factory_291());
  knownControllers = knownControllers$init$();
  DEFAULT_UI_FACTORY = DummyUiFactory_getInstance();
  defaultAudioFormats$delegate = lazy(_no_name_provided_$factory_324());
  temp = new Float32Array(1);
  nativeSoundProvider$delegate = lazy(_no_name_provided_$factory_346());
  debugPrintln$delegate = debugPrintln$delegate$init$();
  formatRegex_0 = Regex_init_$Create$('%([-]?\\d+)?(\\w)');
  charToEntity = linkedMapOf([to(new Char(34), '&quot;'), to(new Char(39), '&apos;'), to(new Char(60), '&lt;'), to(new Char(62), '&gt;'), to(new Char(38), '&amp;')]);
  Mapper2 = new JsObjectMapper2();
  animateLibraryLoaders$delegate = Property_init_$Create$(null, _no_name_provided_$factory_375(), 1, null);
  lengths$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_387(), 1, null);
  width$delegate = width$delegate$init$();
  height$delegate = height$delegate$init$();
  x$delegate = x$delegate$init$();
  y$delegate = y$delegate$init$();
  scale$delegate = scale$delegate$init$();
  scaleX$delegate = scaleX$delegate$init$();
  scaleY$delegate = scaleY$delegate$init$();
  extraLanguage$delegate = Property_init_$Create$(null, _no_name_provided_$factory_394(), 1, null);
  gamepad$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_395(), 1, null);
  keys$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_397(), 1, null);
  mouse$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_401(), 1, null);
  cursor$delegate = cursor$delegate$init$();
  logger = Companion_getInstance_98().invoke_6wfw3l_k$('BatchBuilder2D');
  debugLineRenderContext$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_422(), 1, null);
  logger_0 = Companion_getInstance_98().invoke_6wfw3l_k$('RenderContext2D');
  TEXTURED_ARRAY_QUAD_INDICES = TEXTURED_ARRAY_QUAD_INDICES$init$();
  TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
  TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
  debugBmpFont$delegate = lazy(_no_name_provided_$factory_437());
  AlphaTransition = Transition_0(_no_name_provided_$factory_447());
  storage$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_450(), 1, null);
  fadeThread$delegate = fadeThread$delegate$init$();
  changing$delegate = changing$delegate$init$();
  tilemapLog = Companion_getInstance_98().invoke_6wfw3l_k$('tilemap');
  spaces = Regex_init_$Create$('\\s+');
  DEFAULT_EASING = Companion_getInstance_57()._get_EASE_IN_OUT_QUAD__0_k$();
  DEFAULT_TIME = DEFAULT_TIME$init$();
  uiSkinBitmap$delegate = new UISkinableProperty(_no_name_provided_$factory_495());
  textFont$delegate = new UISkinableProperty(_no_name_provided_$factory_496());
  textSize$delegate = new UISkinableProperty(_no_name_provided_$factory_497());
  textColor$delegate = new UISkinableProperty(_no_name_provided_$factory_498());
  textAlignment$delegate = new UISkinableProperty(_no_name_provided_$factory_499());
  shadowColor$delegate = new UISkinableProperty(_no_name_provided_$factory_500());
  shadowPosition$delegate = new UISkinableProperty(_no_name_provided_$factory_501());
  buttonNormal$delegate = new UISkinableProperty(_no_name_provided_$factory_502());
  buttonOver$delegate = new UISkinableProperty(_no_name_provided_$factory_503());
  buttonDown$delegate = new UISkinableProperty(_no_name_provided_$factory_504());
  buttonDisabled$delegate = new UISkinableProperty(_no_name_provided_$factory_505());
  radioNormal$delegate = new UISkinableProperty(_no_name_provided_$factory_506());
  radioOver$delegate = new UISkinableProperty(_no_name_provided_$factory_507());
  radioDown$delegate = new UISkinableProperty(_no_name_provided_$factory_508());
  radioDisabled$delegate = new UISkinableProperty(_no_name_provided_$factory_509());
  buttonBackColor$delegate = new UISkinableProperty(_no_name_provided_$factory_510());
  buttonTextAlignment$delegate = new UISkinableProperty(_no_name_provided_$factory_511());
  iconCheck$delegate = new UISkinableProperty(_no_name_provided_$factory_512());
  iconUp$delegate = new UISkinableProperty(_no_name_provided_$factory_513());
  iconRight$delegate = new UISkinableProperty(_no_name_provided_$factory_514());
  iconDown$delegate = new UISkinableProperty(_no_name_provided_$factory_515());
  iconLeft$delegate = new UISkinableProperty(_no_name_provided_$factory_516());
  comboBoxShrinkIcon$delegate = new UISkinableProperty(_no_name_provided_$factory_517());
  comboBoxExpandIcon$delegate = new UISkinableProperty(_no_name_provided_$factory_518());
  checkBoxIcon$delegate = new UISkinableProperty(_no_name_provided_$factory_519());
  scrollbarIconLeft$delegate = new UISkinableProperty(_no_name_provided_$factory_520());
  scrollbarIconRight$delegate = new UISkinableProperty(_no_name_provided_$factory_521());
  scrollbarIconUp$delegate = new UISkinableProperty(_no_name_provided_$factory_522());
  scrollbarIconDown$delegate = new UISkinableProperty(_no_name_provided_$factory_523());
  DEFAULT_UI_SKIN_IMG$delegate = lazy(_no_name_provided_$factory_524());
  _defaultUiSkin$delegate = _defaultUiSkin$delegate$init$();
  uiSkin$delegate = uiSkin$delegate$init$();
  koruiComponent$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_529(), 1, null);
  MOVE_ANGLES = MOVE_ANGLES$init$();
  MOVE_SCALES = MOVE_SCALES$init$();
  collisionContext$delegate = new threadLocal(_no_name_provided_$factory_551());
  views$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_556(), 1, null);
  registerFilterSerialization$delegate = Property_init_$Create$(null, _no_name_provided_$factory_560(), 1, null);
  vector3DTemps = new Vector3DTemps();
  DEFAULT_SCALE = 20.0;
  DEFAULT_GRAVITY_Y = 9.8;
  registeredBox2dSupport$delegate = Property_init_$Create$(null, _no_name_provided_$factory_583(), 1, null);
  box2dWorld$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_584(), 1, null);
  box2dWorldComponent$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_585(), 1, null);
  body$delegate = new PropertyThis('box2dBody', _no_name_provided_$factory_586());
  ViewKey = new Key_1();
  var $kotlinx = _.kotlinx || (_.kotlinx = {});
  var $kotlinx$atomicfu = $kotlinx.atomicfu || ($kotlinx.atomicfu = {});
  $kotlinx$atomicfu.atomic$ref$ = atomic_2;
  $kotlinx$atomicfu.atomic$boolean$ = atomic_4;
  $kotlinx$atomicfu.atomic$int$ = atomic_6;
  $kotlinx$atomicfu.atomic$long$ = atomic_8;
  main(_get_EmptyContinuation_());
  return _;
}));
